/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 515);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(522);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var core = __webpack_require__(50);
var hide = __webpack_require__(40);
var redefine = __webpack_require__(41);
var ctx = __webpack_require__(51);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CorePage__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_UrlManager__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_HawkEye__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_AttributeManager__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_icons_heypractest_icon_png__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_icons_heypractest_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_icons_heypractest_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_BrowserUtil__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_GradeRestrictionManager__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_HmAjax__ = __webpack_require__(5);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PreLoginPage=function(_CorePage){_inherits(PreLoginPage,_CorePage);function PreLoginPage(props){_classCallCheck(this,PreLoginPage);var _this=_possibleConstructorReturn(this,(PreLoginPage.__proto__||Object.getPrototypeOf(PreLoginPage)).call(this,props));_this.state={loggedIn:false};_this.UserStore=new __WEBPACK_IMPORTED_MODULE_2__util_UserStore__["a" /* default */]();_this.userObj={};_this.plpTrackKey="PLP_TRACK";_this.userObj=_this.UserStore.get();_this.plpTrackKey="PLP_TRACK";_this.attributeManager=null;_this.setAttributeManager();_this.GradeRestrictionManager=new __WEBPACK_IMPORTED_MODULE_10__util_GradeRestrictionManager__["a" /* default */]();return _this;}/**
	* IMPORTANT: Applicable only to PreloginPage. This function needs to be called in places where reloading a page is NOT applicable and attribute has to be updated on the callback of post-login
	*/_createClass(PreLoginPage,[{key:'setAttributeManager',value:function setAttributeManager(userObj){if(this.userObj){this.attributeManager=new __WEBPACK_IMPORTED_MODULE_6__util_AttributeManager__["a" /* default */](this.UserStore);__WEBPACK_IMPORTED_MODULE_4__model_HmEventRegistry__["a" /* default */].fireEvent("SET_TRACK_STORE",this.UserStore);}else if(userObj){this.userObj=userObj;this.attributeManager=new __WEBPACK_IMPORTED_MODULE_6__util_AttributeManager__["a" /* default */](this.UserStore);__WEBPACK_IMPORTED_MODULE_4__model_HmEventRegistry__["a" /* default */].fireEvent("SET_TRACK_STORE",this.UserStore);}else if(this.getUser().getUserId()){this.userObj=this.getUser();this.attributeManager=new __WEBPACK_IMPORTED_MODULE_6__util_AttributeManager__["a" /* default */](this.UserStore);__WEBPACK_IMPORTED_MODULE_4__model_HmEventRegistry__["a" /* default */].fireEvent("SET_TRACK_STORE",this.UserStore);}}},{key:'getGeo',value:function getGeo(){return this.getUser().getLoginId()?this.getUser().getGeo():_get(PreLoginPage.prototype.__proto__||Object.getPrototypeOf(PreLoginPage.prototype),'getGeo',this).call(this);}},{key:'getAttributeManager',value:function getAttributeManager(){if(!this.attributeManager){this.setAttributeManager();}return this.attributeManager;}},{key:'componentDidMount',value:function componentDidMount(){this.initiateFreshChat();}},{key:'getCmpHelper',value:function getCmpHelper(){return _get(PreLoginPage.prototype.__proto__||Object.getPrototypeOf(PreLoginPage.prototype),'getCmpHelper',this).call(this,this.UserStore);}},{key:'getComponent',value:function getComponent(cmpName){return this.getCmpHelper().getCmp(cmpName);}},{key:'updateUserType',value:function updateUserType(successCallback,failureCallBack){var me=this;var success=function success(userObj){if((typeof userObj==='undefined'?'undefined':_typeof(userObj))==="object"&&userObj.userId){me.getUser().set(userObj);me.userObj=userObj;me.setAttributeManager(userObj);}if(typeof successCallback==="function"){successCallback.apply(this,[userObj]);}};var failure=function failure(error){if(typeof failureCallBack==="function"){failureCallBack.apply(this,[error]);}};new __WEBPACK_IMPORTED_MODULE_12__util_HmAjax__["a" /* default */](this.getUrlFor("GET_USER_TYPE")).get(success,failure);}},{key:'fireMobileToast',value:function fireMobileToast(){if(this.isMobile()||this.isTab()){var mode=0;try{if(this.UserStore&&this.UserStore.getAuthProviderId()){if(mode===4){mode=this.getUser().getAuthProviderId();}}}catch(e){}if(this.getUser().getUserId()){console.log("user available ",this.getUser().getUserId());this.fireEvent("DESKTOP_EXP_TOAST",{msg:"warn_desktop_experience_"+mode,level:"warn"});}else{this.fireEvent("DESKTOP_EXP_TOAST",{msg:"warn_desktop_preexperience_"+mode,level:"warn"});}}}},{key:'initiateFreshChat',value:function initiateFreshChat(){var disabledSites=window.noFreshChatSchoolIds||[];if(disabledSites.length>0){var schoolId=this.getUser().getSchoolId();if(schoolId>0&&disabledSites.indexOf(schoolId)>-1){return;}}__WEBPACK_IMPORTED_MODULE_4__model_HmEventRegistry__["a" /* default */].fireEvent("INIT_FRESHCHAT");}},{key:'doLumosLogout',value:function doLumosLogout(){var _success=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var failure=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var me=this;console.log("logout url="+me.getUrlFor("LUMOS_LOGOUT"));__WEBPACK_IMPORTED_MODULE_11_jquery___default.a.ajax({url:me.getUrlFor("LUMOS_LOGOUT"),type:'GET',xhrFields:{withCredentials:true},crossDomain:true,success:function success(response){if(typeof _success==="function"){_success.apply(this,[response]);}},error:function error(response){console.log("Error in LUMOS_LOGOUT",response);if(typeof failure==="function"){failure.apply(this,[response]);}}});}},{key:'doPLPLogout',value:function doPLPLogout(){var success=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var failure=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var me=this;var callBackSuccess=function callBackSuccess(resp){if(typeof success==="function"){success.apply(this,[resp]);}};var callBackFailure=function callBackFailure(resp){console.error("Logout failed.");if(typeof failure==="function"){failure.apply(this,[resp]);}};new __WEBPACK_IMPORTED_MODULE_12__util_HmAjax__["a" /* default */](me.getUrlFor("LOGOUT")).get(callBackSuccess,callBackFailure);}},{key:'sessionCheck',value:function sessionCheck(){var successCallback=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var failureCallback=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var forceTrigger=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var me=this;var success=function success(userObj){if((typeof userObj==='undefined'?'undefined':_typeof(userObj))==="object"&&userObj.authToken){//Update the userStore Object
me.UserStore.set(userObj);//Updating the locale for the user
me.setLocale(me.UserStore.getLocale());me.setState({loggedIn:true});me.userObj=userObj;me.trackPending();//Appending user params to FreshChat
__WEBPACK_IMPORTED_MODULE_4__model_HmEventRegistry__["a" /* default */].fireEvent("ADD_USER_FRESHCHAT",me.UserStore);if(typeof successCallback==="function"){successCallback.apply(this,[userObj]);}//HmEventRegistry.fireEvent("GO_HOME",userObj);  
}else{//Clear userStore
me.UserStore.clearOldUser();me.trackPending();//Clear FreshChat user
__WEBPACK_IMPORTED_MODULE_4__model_HmEventRegistry__["a" /* default */].fireEvent("CLEAR_USER_FRESHCHAT");if(typeof failureCallback==="function"){failureCallback.apply(this,[userObj]);}//me.initiateFreshChat();
}};var failure=function failure(error){//empty function for now
//me.initiateFreshChat();
//Clear FreshChat user
__WEBPACK_IMPORTED_MODULE_4__model_HmEventRegistry__["a" /* default */].fireEvent("CLEAR_USER_FRESHCHAT");};_get(PreLoginPage.prototype.__proto__||Object.getPrototypeOf(PreLoginPage.prototype),'sessionCheck',this).call(this,success,failure,forceTrigger);}},{key:'trackPending',value:function trackPending(){try{var plpTrackEvents=JSON.parse(__WEBPACK_IMPORTED_MODULE_8__util_BrowserStorageUtil__["a" /* default */].getStoredSessionItem(this.plpTrackKey));//console.log("loginInfo:::",loginInfo);
var length=plpTrackEvents.length;if(plpTrackEvents){for(var i=0;i<length;i++){var trackEvent=plpTrackEvents.pop();this.initiateTrack(trackEvent.name,trackEvent.data);__WEBPACK_IMPORTED_MODULE_8__util_BrowserStorageUtil__["a" /* default */].storeSessionItem(this.plpTrackKey,JSON.stringify(plpTrackEvents));}}}catch(e){}}},{key:'storeTrackEvent',value:function storeTrackEvent(name,data){var events=JSON.parse(__WEBPACK_IMPORTED_MODULE_8__util_BrowserStorageUtil__["a" /* default */].getStoredSessionItem(this.plpTrackKey));events.push({name:name,data:data});__WEBPACK_IMPORTED_MODULE_8__util_BrowserStorageUtil__["a" /* default */].storeSessionItem(this.plpTrackKey,JSON.stringify(events));}},{key:'initiateTrack',value:function initiateTrack(trackKey,addnldata){try{var trackObj=this.getTracker().getEventObject(this.getTracker().eventCodes[trackKey]);trackObj.event_details.user_id=this.UserStore.getUserId()||"";trackObj.event_details.session_id=this.UserStore.getAuthToken()||"";trackObj.event_details.timestamp=new Date().getTime()||"";if(addnldata!==undefined&&(typeof addnldata==='undefined'?'undefined':_typeof(addnldata))==="object"){for(var key in addnldata){trackObj.event_data[key]=addnldata[key];}}var output={"event":trackObj};new __WEBPACK_IMPORTED_MODULE_5__util_HawkEye__["a" /* default */](output).post();}catch(e){console.error(e);}}},{key:'getUser',value:function getUser(){return this.UserStore;}},{key:'setAttribute',value:function setAttribute(attrKey,attrValue,callBack){//if(this.attributeManager){
if(this.getAttributeManager()){var oldAttrVal=this.getAttribute(attrKey);if(oldAttrVal===attrValue){if(callBack&&typeof callBack==="function"){callBack.apply(this);}}else{//console.log("lala::: set attribute::",attrKey,typeof attrValue);
this.attributeManager.update(attrKey,attrValue,callBack);}}}},{key:'removeAttribute',value:function removeAttribute(attrKey,callBack){this.attributeManager.remove(attrKey,callBack);}},{key:'getAttribute',value:function getAttribute(attrKey){//console.log("lala::: ", this.UserStore);
return this.UserStore.getAttribute(attrKey);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' ',this.showLoader(),' ');}}]);return PreLoginPage;}(__WEBPACK_IMPORTED_MODULE_1__CorePage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (PreLoginPage);__WEBPACK_IMPORTED_MODULE_4__model_HmEventRegistry__["a" /* default */].registerEvent("GO_HOME",function(obj){window.location.href=__WEBPACK_IMPORTED_MODULE_3__model_UrlManager__["a" /* default */].getUrlForAction("LOGIN_HOME");});

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.4.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2019-05-01T21:04Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.4.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code, options ) {
		DOMEval( code, { nonce: options && options.nonce } );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.4
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2019-04-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) &&

				// Support: IE 8 only
				// Exclude object elements
				(nodeType !== 1 || context.nodeName.toLowerCase() !== "object") ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 && rdescend.test( selector ) ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem.namespaceURI,
		docElem = (elem.ownerDocument || elem).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( typeof elem.contentDocument !== "undefined" ) {
			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();
						return result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								} );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	// Support: IE 9-11 only
	// Also use offsetWidth/offsetHeight for when box sizing is unreliable
	// We use getClientRects() to check for hidden/disconnected.
	// In those cases, the computed value can be trusted to be border-box
	if ( ( !support.boxSizingReliable() && isBorderBox ||
		val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url, options ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(533)();
}


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CoreAjax__ = __webpack_require__(75);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/*
 * Common Ajax for the application.
 * Depends on React fetch
 *
 */var HmAjax=function HmAjax(url,data,headers){var availableMethods=['GET','POST','PUT','DELETE'];var dataStr="";if((typeof data==='undefined'?'undefined':_typeof(data))==='object'){try{dataStr=JSON.stringify(data);}catch(e){console.error("Error occurred while processing the data:",e);}}else{console.warn("Data is not in the form of an object");}this.get=function(success,failure){this.connect('GET',success,failure);};this.post=function(success,failure){this.connect('POST',success,failure);};this.put=function(success,failure){this.connect('PUT',success,failure);};this.delete=function(success,failure){this.connect('DELETE',success,failure);};this.connect=function(method,success,failure){var successCallback=function successCallback(result,opts){if(!sessionValid(result)){__WEBPACK_IMPORTED_MODULE_0__model_HmEventRegistry__["a" /* default */].fireEvent("LOG_OUT_PROMPT");return;}if(!systemErrCheck(result)){__WEBPACK_IMPORTED_MODULE_0__model_HmEventRegistry__["a" /* default */].fireEvent("ERROR_PROMPT",buildErrorObj(result,url));return;}if(opts&&opts.timeTakenInSecs>=2){//Trigger NET_CHECK to check internet
__WEBPACK_IMPORTED_MODULE_0__model_HmEventRegistry__["a" /* default */].fireEvent("NET_CHECK");}try{if(typeof success==="function"){success.apply(this,[result,opts]);}}catch(e){console.error("Error occurred while calling the success handler:",e);}};var failureCallback=function failureCallback(error,opts){if(!sessionValid(error)){__WEBPACK_IMPORTED_MODULE_0__model_HmEventRegistry__["a" /* default */].fireEvent("LOG_OUT_PROMPT");return;}//Trigger NET_CHECK to check internet
__WEBPACK_IMPORTED_MODULE_0__model_HmEventRegistry__["a" /* default */].fireEvent("NET_CHECK");try{if(typeof failure==="function"){failure.apply(this,[error,opts]);}else{//Trigger default failurePrompt	
__WEBPACK_IMPORTED_MODULE_0__model_HmEventRegistry__["a" /* default */].fireEvent("ERROR_PROMPT",buildErrorObj(503,url));}}catch(e){console.error("Error occurred while calling the failure handler:",e);}};if(availableMethods.indexOf(method)===-1){//if method not defined, default is applied
method=availableMethods[0];}new __WEBPACK_IMPORTED_MODULE_1__CoreAjax__["a" /* default */](url,data,headers).connect(method,successCallback,failureCallback);};var sessionValid=function sessionValid(response){try{if((typeof response==='undefined'?'undefined':_typeof(response))==="object"&&Object.keys(response).length>0){if(typeof response.sessionValid!=="undefined"&&response.sessionValid==="false"){return false;}}}catch(e){console.error(e);}return true;};var systemErrCheck=function systemErrCheck(response){try{if((typeof response==='undefined'?'undefined':_typeof(response))==="object"&&Object.keys(response).length>0){if(typeof response.error!=="undefined"&&(response.error===true||response.error==="true")){return false;}}}catch(e){}return true;};var buildErrorObj=function buildErrorObj(response,url){var errObj={};if((typeof response==='undefined'?'undefined':_typeof(response))==="object"){try{if((typeof response==='undefined'?'undefined':_typeof(response))==="object"&&Object.keys(response).length>0){if(typeof response.error!=="undefined"&&(response.error===true||response.error==="true")){errObj["title"]="500.title";errObj["msg"]="500.msg";errObj["status_code"]=500;errObj["reference_id"]=response.reference_id;if(url){errObj["url"]=url;}}}}catch(e){}}else if(response){//Error for 503 - Service Unavailable
if(response===503){errObj["title"]="503.title";errObj["msg"]="503.msg";errObj["status_code"]=503;if(url){errObj["url"]=url;}}}return errObj;};};/* harmony default export */ __webpack_exports__["a"] = (HmAjax);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PreLoginSessionCheck=function(_PreLoginPage){_inherits(PreLoginSessionCheck,_PreLoginPage);function PreLoginSessionCheck(props){_classCallCheck(this,PreLoginSessionCheck);return _possibleConstructorReturn(this,(PreLoginSessionCheck.__proto__||Object.getPrototypeOf(PreLoginSessionCheck)).call(this,props));}_createClass(PreLoginSessionCheck,[{key:'sessionCheck',value:function sessionCheck(){var me=this;var success=function success(userObj){//me.setState({loggedIn:true});
};var failure=function failure(error){//empty function for now
};_get(PreLoginSessionCheck.prototype.__proto__||Object.getPrototypeOf(PreLoginSessionCheck.prototype),'sessionCheck',this).call(this,success,failure);}},{key:'render',value:function render(){return this.showLoader();}}]);return PreLoginSessionCheck;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (PreLoginSessionCheck);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
* Scope: Singleton
* Event Registry wil store the events as callback for certain actions / events.
* This saves the browser from throwing undefined in case of missing functions as the events are used instead.
* However, it is up to the developer to not miss any function while registering the appropriate functions.
*/var HmEventRegistry=function(){var eventRegistry={};return{/**
		 * Registering Event
		 */registerEvent:function registerEvent(eventName,eventHandler){if(eventName!==null&&eventHandler!==null){eventRegistry[eventName]=eventHandler;return true;}else{return false;}},/**
		* function to check if the event exists
		*/exists:function exists(eventName){return eventName&&eventRegistry[eventName];},/**
		 * Firing the registered Event
		 */fireEvent:function fireEvent(eventName){var eventParams=[];if(arguments&&arguments.length>1){for(var i=1;i<arguments.length;i++){eventParams.push(arguments[i]);}}if(eventName!==null){if(eventRegistry[eventName]){if(typeof eventRegistry[eventName]==="function"){return eventRegistry[eventName].apply(this,eventParams);}else{return eventRegistry[eventName];}}else{return{};}}}};}();/* harmony default export */ __webpack_exports__["a"] = (HmEventRegistry);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(523);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This function is for accessing Browser's storage utility
 */var browserStorageUtil=function(){var isStorageSupported=function(){if(typeof Storage!=="undefined"){return true;}else{//No Support for storage in the browser
return false;}}();return{storeItem:function storeItem(itemKey,itemValue){try{if(isStorageSupported){localStorage.setItem(itemKey,itemValue);}}catch(e){if(console)console.log(e);//while facing exception in storing remove all
//	browserStorageUtil.clearStorage();
}},getStoredItem:function getStoredItem(itemKey){try{if(isStorageSupported){return localStorage.getItem(itemKey);}else{return null;}}catch(e){if(console)console.log(e);return null;}},removeItem:function removeItem(itemKey){try{if(isStorageSupported){localStorage.removeItem(itemKey);}}catch(e){if(console)console.log(e);}},clearStorage:function clearStorage(){try{if(isStorageSupported){localStorage.clear();}}catch(e){if(console)console.log(e);}},//session storage
storeSessionItem:function storeSessionItem(itemKey,itemValue){try{if(isStorageSupported){sessionStorage.setItem(itemKey,itemValue);}}catch(e){if(console)console.log(e);//while facing exception in storing remove all
//browserStorageUtil.clearStorage();
}},getStoredSessionItem:function getStoredSessionItem(itemKey){try{if(isStorageSupported){return sessionStorage.getItem(itemKey);}else{return null;}}catch(e){if(console)console.log(e);return null;}},removeSessionItem:function removeSessionItem(itemKey){try{if(isStorageSupported){sessionStorage.removeItem(itemKey);}}catch(e){if(console)console.log(e);}},clearSessionStorage:function clearSessionStorage(){try{if(isStorageSupported){sessionStorage.clear();}}catch(e){if(console)console.log(e);}}};}();/* harmony default export */ __webpack_exports__["a"] = (browserStorageUtil);

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserUtil__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserStorageUtil__ = __webpack_require__(33);
/*import HmEventRegistry from './../model/HmEventRegistry';*/var UserStore=function UserStore(){var me=this;var authToken=__WEBPACK_IMPORTED_MODULE_0__BrowserUtil__["a" /* default */].getAuthToken();if(authToken===null||authToken.length===0){//console.log("Clear storage triggered");
__WEBPACK_IMPORTED_MODULE_1__UserStorageUtil__["a" /* default */].clearSessionStorage();}var isUserAvailable=function isUserAvailable(){try{if(!me.user){me.user=me.get();}if(me.user&&me.user.userId&&me.user.userId.length>0){return true;}else{me.clearOldUser();return false;}}catch(e){me.clearOldUser();//HmEventRegistry.fireEvent("LOG_OUT_PROMPT");
return false;}};this.clearOldUser=function(){__WEBPACK_IMPORTED_MODULE_1__UserStorageUtil__["a" /* default */].clearSessionStorage();};this.store=function(user){this.user=user;__WEBPACK_IMPORTED_MODULE_1__UserStorageUtil__["a" /* default */].storeSessionItem("USER_DETAILS",user);__WEBPACK_IMPORTED_MODULE_0__BrowserUtil__["a" /* default */].setUserDetails(user);};this.set=this.store;this.get=function(){__WEBPACK_IMPORTED_MODULE_0__BrowserUtil__["a" /* default */].setUserDetails(__WEBPACK_IMPORTED_MODULE_1__UserStorageUtil__["a" /* default */].getStoredSessionItem("USER_DETAILS"));this.user=__WEBPACK_IMPORTED_MODULE_0__BrowserUtil__["a" /* default */].getUserDetails();return __WEBPACK_IMPORTED_MODULE_0__BrowserUtil__["a" /* default */].getUserDetails();};this.getUserId=function(){if(isUserAvailable()){return this.user.userId;}else{return"";}};this.getUserName=function(){if(isUserAvailable()){return this.user.userName;}else{return"";}};this.getLoginId=function(){if(isUserAvailable()){return this.user.loginId;}else{return"";}};this.getRole=function(){if(isUserAvailable()){return this.user.userRole.role;}else{return"";}};this.getDob=function(){if(isUserAvailable()){return this.user.dob;}else{return"";}};this.getGender=function(){if(isUserAvailable()){return this.user.gender;}else{return"";}};this.getEmail=function(){if(isUserAvailable()){return this.user.email;}else{return"";}};this.getMobile=function(){if(isUserAvailable()){return this.user.phone;}else{return"";}};this.getModeID=function(){if(isUserAvailable()){return this.user.modeId;}else{return"";}};this.getLanguage=function(){if(isUserAvailable()){return this.user.language;}else{return"";}};this.getLocale=this.getLanguage;this.isSimulation=function(){if(isUserAvailable()){return this.user.simulation;}else{return"";}};this.getAuthToken=function(){if(isUserAvailable()){return this.user.authToken;}else{return"";}};this.getUserAgent=function(){if(isUserAvailable()){return this.user.userAgent;}else{return"";}};this.getDevice=function(){if(isUserAvailable()){return this.user.device;}else{return"";}};this.getIpAddress=function(){if(isUserAvailable()){return this.user.ipAddress;}else{return"";}};this.getPermissions=function(){if(isUserAvailable()){return this.user.permission;}else{return{};}};this.getAccessMap=function(){if(isUserAvailable()){return this.user.access;}else{return{};}};this.getReverseAccessMap=function(){if(isUserAvailable()){var reverseMap={};try{if(this.user.access){for(var i in this.user.access){reverseMap[this.user.access[i]]=i;}}}catch(e){}return reverseMap;}else{return{};}};this.getEntlHistory=function(){if(isUserAvailable()){return this.user.entlHistory;}else{return{};}};this.getAuthProviderId=function(){if(isUserAvailable()){return this.user.authProviderId;}else{return 0;}};this.isAllowed=function(key){if(isUserAvailable()){try{if(key!==undefined&&key!==null&&key.length>0){var perm=this.getPermissions();if(perm[key]!==undefined&&perm[key]!==null&&perm[key].length>0){return true;}}}catch(e){}return false;}else{return false;}};this.allowedLevels=function(key){if(isUserAvailable()){if(key!==undefined&&key!==null&&key.length>0){try{var perm=this.getPermissions();if(perm[key]!==undefined&&perm[key]!==null&&perm[key].length>0){return perm[key].split(",");}}catch(e){}}else{console.error("key is required for allowedLevels.");}}return[];};this.getAttribute=function(attrKey){if(isUserAvailable()){if(attrKey&&this.user.userAttributes){return this.user.userAttributes[attrKey]||null;}}return null;};this.getSchoolInfo=function(){if(isUserAvailable()){return this.user.school;}return null;};this.getSchoolId=function(){if(isUserAvailable()){if(this.user.school&&!isNaN(this.user.school.schoolId)){return Number(this.user.school.schoolId);}}return 0;};this.getSchoolName=function(){if(isUserAvailable()){if(this.user.school&&this.user.school.schoolName){return this.user.school.schoolName;}}return null;};this.getSchoolBoard=function(){if(isUserAvailable()){if(this.user.school&&this.user.school.board){return this.user.school.board;}}return null;};this.getSchoolPrefix=function(){if(isUserAvailable()){if(this.user.school&&this.user.school.prefix){return this.user.school.prefix;}}return null;};this.isHmUser=function(){if(isUserAvailable()){if(this.user.heymathUser){return this.user.heymathUser;}}return false;};this.getUserOrigin=function(){if(isUserAvailable()){if(this.user.origin){return this.user.origin;}}return"default";};this.isPilotUser=function(){if(isUserAvailable()){if(this.user.pilotUser){return this.user.pilotUser;}}return false;};this.getGeo=function(){if(isUserAvailable()){if(this.user.countryCode){return this.user.countryCode;}}return"";};this.user=!this.user?this.get():this.user;};/* harmony default export */ __webpack_exports__["a"] = (UserStore);

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.htmlparser2 = exports.convertNodeToElement = exports.processNodes = undefined;

var _processNodes = __webpack_require__(199);

Object.defineProperty(exports, 'processNodes', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_processNodes).default;
  }
});

var _convertNodeToElement = __webpack_require__(325);

Object.defineProperty(exports, 'convertNodeToElement', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_convertNodeToElement).default;
  }
});

var _htmlparser = __webpack_require__(102);

Object.defineProperty(exports, 'htmlparser2', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_htmlparser).default;
  }
});

var _HtmlParser = __webpack_require__(587);

var _HtmlParser2 = _interopRequireDefault(_HtmlParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _HtmlParser2.default;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(1064));
__export(__webpack_require__(1065));
__export(__webpack_require__(1066));
var fieldWithoutFeedback_1 = __webpack_require__(443);
exports.fieldWithoutFeedback = fieldWithoutFeedback_1.default;
__export(__webpack_require__(293));
__export(__webpack_require__(292));
__export(__webpack_require__(291));
//# sourceMappingURL=index.js.map

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CorePage__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_HawkEye__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_AttributeManager__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_BrowserUtil__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_common_SubscribeButton__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_NativeAjax__ = __webpack_require__(29);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoggedInPage=function(_CorePage){_inherits(LoggedInPage,_CorePage);function LoggedInPage(props){_classCallCheck(this,LoggedInPage);var _this=_possibleConstructorReturn(this,(LoggedInPage.__proto__||Object.getPrototypeOf(LoggedInPage)).call(this,props));_this.state={loggedIn:false,LumosloggedIn:false};_this.UserStore=new __WEBPACK_IMPORTED_MODULE_2__util_UserStore__["a" /* default */]();var UserObj=_this.UserStore.get();_this.plpTrackKey="PLP_TRACK";if(!UserObj){//try to reload the page then prompt if the user is not logged in
_this.sessionCheck(function(){window.location.reload();},function(){__WEBPACK_IMPORTED_MODULE_3__model_HmEventRegistry__["a" /* default */].fireEvent("LOG_OUT_PROMPT");});}else{_this.attributeManager=new __WEBPACK_IMPORTED_MODULE_5__util_AttributeManager__["a" /* default */](_this.UserStore);__WEBPACK_IMPORTED_MODULE_3__model_HmEventRegistry__["a" /* default */].fireEvent("SET_TRACK_STORE",_this.UserStore);}return _this;}_createClass(LoggedInPage,[{key:'componentDidMount',value:function componentDidMount(){//Freshchat is not required in LoggedInPages
//this.initiateFreshChat();
}},{key:'getCmpHelper',value:function getCmpHelper(){return _get(LoggedInPage.prototype.__proto__||Object.getPrototypeOf(LoggedInPage.prototype),'getCmpHelper',this).call(this,this.UserStore);}},{key:'getComponent',value:function getComponent(cmpName){return this.getCmpHelper().getCmp(cmpName);}},{key:'getGeo',value:function getGeo(){return this.getUser().getLoginId()?this.getUser().getGeo():_get(LoggedInPage.prototype.__proto__||Object.getPrototypeOf(LoggedInPage.prototype),'getGeo',this).call(this);}},{key:'subscribeFn',value:function subscribeFn(dataga){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__views_common_SubscribeButton__["a" /* default */],{ga:dataga});}},{key:'fireMobileToast',value:function fireMobileToast(){if(this.isMobile()||this.isTab()){var mode=0;try{if(this.UserStore&&this.UserStore.getAuthProviderId()){if(mode===4){mode=this.getUser().getAuthProviderId();}}}catch(e){}this.fireEvent("DESKTOP_EXP_TOAST",{msg:"warn_desktop_experience_"+mode,level:"warn"});}}},{key:'setAttribute',value:function setAttribute(attrKey,attrValue,callBack){var oldAttrVal=this.getAttribute(attrKey);if(oldAttrVal===attrValue){if(callBack&&typeof callBack==="function"){callBack.apply(this);}}else{//console.log("lala::: set attribute::",attrKey,typeof attrValue);
this.attributeManager.update(attrKey,attrValue,callBack);}}},{key:'removeAttribute',value:function removeAttribute(attrKey,callBack){this.attributeManager.remove(attrKey,callBack);}},{key:'getAttribute',value:function getAttribute(attrKey){//console.log("lala::: get attribute "," : ",this.UserStore.getAttribute(attrKey));
return this.UserStore.getAttribute(attrKey);}},{key:'LumosSessionCheck',value:function LumosSessionCheck(){var me=this;var user_Success=function user_Success(userObj){if((typeof userObj==='undefined'?'undefined':_typeof(userObj))==="object"&&userObj.sessionValid){me.setState({LumosloggedIn:true});var lumosRedirect=true;if(window.lumos_allowed_routes&&window.lumos_allowed_routes.length>0){for(var i=0;i<window.lumos_allowed_routes.length;i++){if(window.location.href&&window.location.href.match(window.lumos_allowed_routes[i])){lumosRedirect=false;break;}}}/*if(window.lumos_restricted_routes && window.lumos_restricted_routes.length > 0){
					for(var i=0;i<window.lumos_restricted_routes.length;i++){
						if(window.location.href && window.location.href.match(window.lumos_restricted_routes[i])){
							lumosRedirect = true;
							break;
						}
					}
				}*/if(lumosRedirect){//For a Lumos User, always redirect him to Lumos Page
window.location.href=me.getUrlFor("LUMOS_REDIRECT_URL");}}else{me.setState({LumosloggedIn:false});}};var user_Failure=function user_Failure(error){me.setState({LumosloggedIn:false});};new __WEBPACK_IMPORTED_MODULE_9__util_NativeAjax__["a" /* default */](this.getUrlFor("LUMOS_SESSION_CHECK")).enableCORS().get(user_Success,user_Failure);}},{key:'sessionCheck',value:function sessionCheck(sessionValid,sessionInvalid){var forceTrigger=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var me=this;var success=function success(userObj){if((typeof userObj==='undefined'?'undefined':_typeof(userObj))==="object"&&userObj.authToken){//Update the userStore Object
me.UserStore.set(userObj);//Updating the locale for the user
me.setLocale(me.UserStore.getLocale());me.setState({loggedIn:true});me.attributeManager=new __WEBPACK_IMPORTED_MODULE_5__util_AttributeManager__["a" /* default */](me.UserStore);me.trackPending();//Lumos User Session Check
__WEBPACK_IMPORTED_MODULE_3__model_HmEventRegistry__["a" /* default */].fireEvent("SCHEDULE_LUMOS_HEARTBEAT");//Appending user params to FreshChat
__WEBPACK_IMPORTED_MODULE_3__model_HmEventRegistry__["a" /* default */].fireEvent("ADD_USER_FRESHCHAT",me.UserStore);//Check if callbackUser session is valid 
if(typeof sessionValid==="function"){sessionValid.apply(this,[userObj]);}}else{//Clear userStore
me.UserStore.clearOldUser();me.trackPending();//Clear FreshChat user
__WEBPACK_IMPORTED_MODULE_3__model_HmEventRegistry__["a" /* default */].fireEvent("CLEAR_USER_FRESHCHAT");//User session is no longer valid
if(typeof sessionInvalid==="function"){sessionInvalid.apply(this,[userObj]);}else{//Handle auto-redirection to prelogin page
if((typeof userObj==='undefined'?'undefined':_typeof(userObj))==="object"&&Object.keys(userObj).length>0){if(typeof userObj.sessionValid!=="undefined"&&userObj.sessionValid==="false"){__WEBPACK_IMPORTED_MODULE_3__model_HmEventRegistry__["a" /* default */].fireEvent("LOG_OUT_PROMPT");}}}}};var failure=function failure(error){//Clear FreshChat user
__WEBPACK_IMPORTED_MODULE_3__model_HmEventRegistry__["a" /* default */].fireEvent("CLEAR_USER_FRESHCHAT");//User session is no longer valid
if(typeof sessionInvalid==="function"){sessionInvalid.apply(this,[error]);}else{//Handle auto-redirection to prelogin page
if((typeof error==='undefined'?'undefined':_typeof(error))==="object"&&Object.keys(error).length>0){if(typeof error.sessionValid!=="undefined"&&error.sessionValid==="false"){__WEBPACK_IMPORTED_MODULE_3__model_HmEventRegistry__["a" /* default */].fireEvent("LOG_OUT_PROMPT");}}}};_get(LoggedInPage.prototype.__proto__||Object.getPrototypeOf(LoggedInPage.prototype),'sessionCheck',this).call(this,success,failure,forceTrigger);}},{key:'trackPending',value:function trackPending(){try{var plpTrackEvents=JSON.parse(__WEBPACK_IMPORTED_MODULE_6__util_BrowserStorageUtil__["a" /* default */].getStoredSessionItem(this.plpTrackKey));//console.log("loginInfo:::",loginInfo);
var length=plpTrackEvents.length;if(plpTrackEvents){for(var i=0;i<length;i++){var trackEvent=plpTrackEvents.pop();this.initiateTrack(trackEvent.name,trackEvent.data);__WEBPACK_IMPORTED_MODULE_6__util_BrowserStorageUtil__["a" /* default */].storeSessionItem(this.plpTrackKey,JSON.stringify(plpTrackEvents));}}}catch(e){}}},{key:'storeTrackEvent',value:function storeTrackEvent(name,data){var events=JSON.parse(__WEBPACK_IMPORTED_MODULE_6__util_BrowserStorageUtil__["a" /* default */].getStoredSessionItem(this.plpTrackKey));events.push({name:name,data:data});__WEBPACK_IMPORTED_MODULE_6__util_BrowserStorageUtil__["a" /* default */].storeSessionItem(this.plpTrackKey,JSON.stringify(events));}},{key:'initiateTrack',value:function initiateTrack(trackKey,addnldata){try{var eventObj=this.getTracker();var trackObj=eventObj.getEventObject(eventObj.eventCodes[trackKey]);trackObj.event_details.user_id=this.getUser().getUserId()||"";trackObj.event_details.session_id=this.getUser().getAuthToken()||"";trackObj.event_details.timestamp=new Date().getTime()||"";console.log("addnldata:::",addnldata);console.log(trackObj.event_data);if(addnldata!==undefined&&(typeof addnldata==='undefined'?'undefined':_typeof(addnldata))==="object"){for(var key in addnldata){trackObj.event_data[key]=addnldata[key];}}var output={"event":trackObj};var me=this;new __WEBPACK_IMPORTED_MODULE_4__util_HawkEye__["a" /* default */](output).post();}catch(e){console.log("Error in Tracking :::",e);}}},{key:'getUser',value:function getUser(){return this.UserStore;}},{key:'initiateFreshChat',value:function initiateFreshChat(){var disabledSites=window.noFreshChatSchoolIds||[];if(disabledSites.length>0){var schoolId=this.getUser().getSchoolId();if(schoolId>0&&disabledSites.indexOf(schoolId)>-1){return;}}__WEBPACK_IMPORTED_MODULE_3__model_HmEventRegistry__["a" /* default */].fireEvent("INIT_FRESHCHAT");}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' ',this.showLoader(),' ');}}]);return LoggedInPage;}(__WEBPACK_IMPORTED_MODULE_1__CorePage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (LoggedInPage);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(131)('wks');
var uid = __webpack_require__(83);
var Symbol = __webpack_require__(9).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(1067));
//# sourceMappingURL=index.js.map

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(53);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(13)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UAParser = __webpack_require__(6);

var UA = exports.UA = new UAParser();

var browser = exports.browser = UA.getBrowser();
var cpu = exports.cpu = UA.getCPU();
var device = exports.device = UA.getDevice();
var engine = exports.engine = UA.getEngine();
var os = exports.os = UA.getOS();
var ua = exports.ua = UA.getUA();
var setUA = exports.setUA = function setUA(uaStr) {
  return UA.setUA(uaStr);
};

var mockUserAgent = exports.mockUserAgent = function mockUserAgent(userAgent) {
  window.navigator.__defineGetter__("userAgent", function () {
    return userAgent;
  });
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isYandex = exports.isEdge = exports.getUA = exports.engineVersion = exports.engineName = exports.mobileModel = exports.mobileVendor = exports.browserName = exports.browserVersion = exports.fullBrowserVersion = exports.osName = exports.osVersion = exports.isIE = exports.isOpera = exports.isSafari = exports.isFirefox = exports.isChrome = exports.isIOS = exports.isWinPhone = exports.isAndroid = exports.isBrowser = exports.isTablet = exports.isMobileOnly = exports.isMobile = exports.isChromium = exports.isMobileSafari = exports.isWearable = exports.isConsole = exports.isSmartTV = undefined;

var _getUaData = __webpack_require__(0);

var _types = __webpack_require__(2);

var CHROME = _types.BROWSER_TYPES.CHROME,
    CHROMIUM = _types.BROWSER_TYPES.CHROMIUM,
    IE = _types.BROWSER_TYPES.IE,
    INTERNET_EXPLORER = _types.BROWSER_TYPES.INTERNET_EXPLORER,
    OPERA = _types.BROWSER_TYPES.OPERA,
    FIREFOX = _types.BROWSER_TYPES.FIREFOX,
    SAFARI = _types.BROWSER_TYPES.SAFARI,
    MOBILE_SAFARI = _types.BROWSER_TYPES.MOBILE_SAFARI,
    EDGE = _types.BROWSER_TYPES.EDGE,
    YANDEX = _types.BROWSER_TYPES.YANDEX;
var MOBILE = _types.DEVICE_TYPES.MOBILE,
    TABLET = _types.DEVICE_TYPES.TABLET,
    SMART_TV = _types.DEVICE_TYPES.SMART_TV,
    BROWSER = _types.DEVICE_TYPES.BROWSER,
    WEARABLE = _types.DEVICE_TYPES.WEARABLE,
    CONSOLE = _types.DEVICE_TYPES.CONSOLE;
var ANDROID = _types.OS_TYPES.ANDROID,
    WINDOWS_PHONE = _types.OS_TYPES.WINDOWS_PHONE,
    IOS = _types.OS_TYPES.IOS;


var isMobileType = function isMobileType() {
  return _getUaData.device.type === MOBILE;
};
var isTabletType = function isTabletType() {
  return _getUaData.device.type === TABLET;
};

var isMobileAndTabletType = function isMobileAndTabletType() {
  switch (_getUaData.device.type) {
    case MOBILE:
    case TABLET:
      return true;
    default:
      return false;
  }
};

var isSmartTVType = function isSmartTVType() {
  return _getUaData.device.type === SMART_TV;
};
var isBrowserType = function isBrowserType() {
  return _getUaData.device.type === BROWSER;
};
var isWearableType = function isWearableType() {
  return _getUaData.device.type === WEARABLE;
};
var isConsoleType = function isConsoleType() {
  return _getUaData.device.type === CONSOLE;
};
var isAndroidType = function isAndroidType() {
  return _getUaData.os.name === ANDROID;
};
var isWinPhoneType = function isWinPhoneType() {
  return _getUaData.os.name === WINDOWS_PHONE;
};
var isIOSType = function isIOSType() {
  return _getUaData.os.name === IOS;
};
var isChromeType = function isChromeType() {
  return _getUaData.browser.name === CHROME;
};
var isFirefoxType = function isFirefoxType() {
  return _getUaData.browser.name === FIREFOX;
};
var isChromiumType = function isChromiumType() {
  return _getUaData.browser.name === CHROMIUM;
};
var isEdgeType = function isEdgeType() {
  return _getUaData.browser.name === EDGE;
};
var isYandexType = function isYandexType() {
  return _getUaData.browser.name === YANDEX;
};
var isSafariType = function isSafariType() {
  return _getUaData.browser.name === SAFARI || _getUaData.browser.name === MOBILE_SAFARI;
};
var isMobileSafariType = function isMobileSafariType() {
  return _getUaData.browser.name === MOBILE_SAFARI;
};
var isOperaType = function isOperaType() {
  return _getUaData.browser.name === OPERA;
};
var isIEType = function isIEType() {
  return _getUaData.browser.name === INTERNET_EXPLORER || _getUaData.browser.name === IE;
};

var getBrowserFullVersion = function getBrowserFullVersion() {
  return _getUaData.browser.major;
};
var getBrowserVersion = function getBrowserVersion() {
  return _getUaData.browser.version;
};
var getOsVersion = function getOsVersion() {
  return _getUaData.os.version ? _getUaData.os.version : "none";
};
var getOsName = function getOsName() {
  return _getUaData.os.name ? _getUaData.os.name : "none";
};
var getBrowserName = function getBrowserName() {
  return _getUaData.browser.name;
};
var getMobileVendor = function getMobileVendor() {
  return _getUaData.device.vendor ? _getUaData.device.vendor : "none";
};
var getMobileModel = function getMobileModel() {
  return _getUaData.device.model ? _getUaData.device.model : "none";
};
var getEngineName = function getEngineName() {
  return _getUaData.engine.name;
};
var getEngineVersion = function getEngineVersion() {
  return _getUaData.engine.version;
};
var getUseragent = function getUseragent() {
  return _getUaData.ua;
};

var isSmartTV = exports.isSmartTV = isSmartTVType();
var isConsole = exports.isConsole = isConsoleType();
var isWearable = exports.isWearable = isWearableType();
var isMobileSafari = exports.isMobileSafari = isMobileSafariType();
var isChromium = exports.isChromium = isChromiumType();
var isMobile = exports.isMobile = isMobileAndTabletType();
var isMobileOnly = exports.isMobileOnly = isMobileType();
var isTablet = exports.isTablet = isTabletType();
var isBrowser = exports.isBrowser = isBrowserType();
var isAndroid = exports.isAndroid = isAndroidType();
var isWinPhone = exports.isWinPhone = isWinPhoneType();
var isIOS = exports.isIOS = isIOSType();
var isChrome = exports.isChrome = isChromeType();
var isFirefox = exports.isFirefox = isFirefoxType();
var isSafari = exports.isSafari = isSafariType();
var isOpera = exports.isOpera = isOperaType();
var isIE = exports.isIE = isIEType();
var osVersion = exports.osVersion = getOsVersion();
var osName = exports.osName = getOsName();
var fullBrowserVersion = exports.fullBrowserVersion = getBrowserFullVersion();
var browserVersion = exports.browserVersion = getBrowserVersion();
var browserName = exports.browserName = getBrowserName();
var mobileVendor = exports.mobileVendor = getMobileVendor();
var mobileModel = exports.mobileModel = getMobileModel();
var engineName = exports.engineName = getEngineName();
var engineVersion = exports.engineVersion = getEngineVersion();
var getUA = exports.getUA = getUseragent();
var isEdge = exports.isEdge = isEdgeType();
var isYandex = exports.isYandex = isYandexType();

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wearPayload = exports.consolePayload = exports.stvPayload = exports.mobilePayload = exports.broPayload = exports.getCurrentBrowser = exports.checkType = exports.OS_TYPES = exports.BROWSER_TYPES = exports.DEVICE_TYPES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _getUaData = __webpack_require__(0);

var DEVICE_TYPES = exports.DEVICE_TYPES = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  SMART_TV: 'smarttv',
  CONSOLE: 'console',
  WEARABLE: 'wearable',
  BROWSER: undefined
};

var BROWSER_TYPES = exports.BROWSER_TYPES = {
  CHROME: 'Chrome',
  FIREFOX: "Firefox",
  OPERA: "Opera",
  YANDEX: "Yandex",
  SAFARI: "Safari",
  INTERNET_EXPLORER: "Internet Explorer",
  EDGE: "Edge",
  CHROMIUM: "Chromium",
  IE: 'IE',
  MOBILE_SAFARI: "Mobile Safari"
};

var OS_TYPES = exports.OS_TYPES = {
  IOS: 'iOS',
  ANDROID: "Android",
  WINDOWS_PHONE: "Windows Phone"
};

var initialData = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};

var checkType = exports.checkType = function checkType(type) {
  switch (type) {
    case DEVICE_TYPES.MOBILE:
      return { isMobile: true };
    case DEVICE_TYPES.TABLET:
      return { isTablet: true };
    case DEVICE_TYPES.SMART_TV:
      return { isSmartTV: true };
    case DEVICE_TYPES.CONSOLE:
      return { isConsole: true };
    case DEVICE_TYPES.WEARABLE:
      return { isWearable: true };
    case DEVICE_TYPES.BROWSER:
      return { isBrowser: true };
    default:
      return initialData;
  }
};

var getCurrentBrowser = exports.getCurrentBrowser = function getCurrentBrowser(name) {
  switch (name) {
    case BROWSER_TYPES.CHROME:
    case BROWSER_TYPES.FIREFOX:
    case BROWSER_TYPES.OPERA:
    case BROWSER_TYPES.YANDEX:
    case BROWSER_TYPES.SAFARI:
    case BROWSER_TYPES.IE:
    case BROWSER_TYPES.EDGE:
    case BROWSER_TYPES.CHROMIUM:
      return true;
    default:
      return false;
  }
};

var broPayload = exports.broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: browser.major,
    browserFullVersion: browser.version,
    browserName: browser.name,
    engineName: engine.name || false,
    engineVersion: engine.version,
    osName: os.name,
    osVersion: os.version,
    userAgent: ua
  };
};

var mobilePayload = exports.mobilePayload = function mobilePayload(type, device, os, ua) {
  return _extends({}, type, {
    vendor: device.vendor || "none",
    model: device.model || "none",
    os: os.name || "none",
    osVersion: os.version || "none",
    ua: ua || "none"
  });
};

var stvPayload = exports.stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: engine.name || false,
    engineVersion: engine.version,
    osName: os.name,
    osVersion: os.version,
    userAgent: ua
  };
};

var consolePayload = exports.consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: engine.name || false,
    engineVersion: engine.version,
    osName: os.name,
    osVersion: os.version,
    userAgent: ua
  };
};

var wearPayload = exports.wearPayload = function wearPayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: engine.name || false,
    engineVersion: engine.version,
    osName: os.name,
    osVersion: os.version,
    userAgent: ua
  };
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deviceDetect = undefined;

var _views = __webpack_require__(4);

Object.keys(_views).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _views[key];
    }
  });
});

var _selectors = __webpack_require__(1);

Object.keys(_selectors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _selectors[key];
    }
  });
});

var _detect = __webpack_require__(8);

var _detect2 = _interopRequireDefault(_detect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.deviceDetect = _detect2.default;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomView = exports.WearableView = exports.ConsoleView = exports.SmartTVView = exports.MobileOnlyView = exports.WinPhoneView = exports.TabletView = exports.MobileView = exports.IOSView = exports.IEView = exports.BrowserView = exports.AndroidView = undefined;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _selectors = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AndroidView = exports.AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      viewClassName = _ref.viewClassName,
      style = _ref.style;

  return _selectors.isAndroid ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var BrowserView = exports.BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      viewClassName = _ref2.viewClassName,
      style = _ref2.style;

  return _selectors.isBrowser ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var IEView = exports.IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      viewClassName = _ref3.viewClassName,
      style = _ref3.style;

  return _selectors.isIE ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var IOSView = exports.IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      viewClassName = _ref4.viewClassName,
      style = _ref4.style;

  return _selectors.isIOS ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var MobileView = exports.MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      viewClassName = _ref5.viewClassName,
      style = _ref5.style;

  return _selectors.isMobile ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var TabletView = exports.TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      viewClassName = _ref6.viewClassName,
      style = _ref6.style;

  return _selectors.isTablet ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var WinPhoneView = exports.WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      viewClassName = _ref7.viewClassName,
      style = _ref7.style;

  return _selectors.isWinPhone ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var MobileOnlyView = exports.MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children,
      viewClassName = _ref8.viewClassName,
      style = _ref8.style;

  return _selectors.isMobileOnly ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var SmartTVView = exports.SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      viewClassName = _ref9.viewClassName,
      style = _ref9.style;

  return _selectors.isSmartTV ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var ConsoleView = exports.ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      viewClassName = _ref10.viewClassName,
      style = _ref10.style;

  return _selectors.isConsole ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var WearableView = exports.WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      viewClassName = _ref11.viewClassName,
      style = _ref11.style;

  return _selectors.isWearable ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var CustomView = exports.CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children,
      viewClassName = _ref12.viewClassName,
      style = _ref12.style,
      condition = _ref12.condition;

  return condition ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * UAParser.js v0.7.18
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
 * Dual licensed under GPLv2 or MIT
 */
(function(window,undefined){"use strict";var LIBVERSION="0.7.18",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded";var util={extend:function(regexes,extensions){var margedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){margedRegexes[i]=extensions[i].concat(regexes[i])}else{margedRegexes[i]=regexes[i]}}return margedRegexes},has:function(str1,str2){if(typeof str1==="string"){return str2.toLowerCase().indexOf(str1.toLowerCase())!==-1}else{return false}},lowerize:function(str){return str.toLowerCase()},major:function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,"").split(".")[0]:undefined},trim:function(str){return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")}};var mapper={rgx:function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length==2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length==3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length==4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},str:function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(util.has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(util.has(map[i],str)){return i===UNKNOWN?undefined:i}}return str}};var maps={browser:{oldsafari:{version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}}},device:{amazon:{model:{"Fire Phone":["SD","KF"]}},sprint:{model:{"Evo Shift 4G":"7373KT"},vendor:{HTC:"APA",Sprint:"Sprint"}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2000:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"}}}};var regexes={browser:[[/(opera\smini)\/([\w\.-]+)/i,/(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,/(opera).+version\/([\w\.]+)/i,/(opera)[\/\s]+([\w\.]+)/i],[NAME,VERSION],[/(opios)[\/\s]+([\w\.]+)/i],[[NAME,"Opera Mini"],VERSION],[/\s(opr)\/([\w\.]+)/i],[[NAME,"Opera"],VERSION],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,/(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,/(?:ms|\()(ie)\s([\w\.]+)/i,/(rekonq)\/([\w\.]*)/i,/(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark)\/([\w\.-]+)/i],[NAME,VERSION],[/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i],[[NAME,"IE"],VERSION],[/(edge|edgios|edgea)\/((\d+)?[\w\.]+)/i],[[NAME,"Edge"],VERSION],[/(yabrowser)\/([\w\.]+)/i],[[NAME,"Yandex"],VERSION],[/(puffin)\/([\w\.]+)/i],[[NAME,"Puffin"],VERSION],[/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i],[[NAME,"UCBrowser"],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(micromessenger)\/([\w\.]+)/i],[[NAME,"WeChat"],VERSION],[/(qqbrowserlite)\/([\w\.]+)/i],[NAME,VERSION],[/(QQ)\/([\d\.]+)/i],[NAME,VERSION],[/m?(qqbrowser)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(BIDUBrowser)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(2345Explorer)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(MetaSr)[\/\s]?([\w\.]+)/i],[NAME],[/(LBBROWSER)/i],[NAME],[/xiaomi\/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI Browser"]],[/;fbav\/([\w\.]+);/i],[VERSION,[NAME,"Facebook"]],[/headlesschrome(?:\/([\w\.]+)|\s)/i],[VERSION,[NAME,"Chrome Headless"]],[/\swv\).+(chrome)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 WebView"],VERSION],[/((?:oculus|samsung)browser)\/([\w\.]+)/i],[[NAME,/(.+(?:g|us))(.+)/,"$1 $2"],VERSION],[/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i],[VERSION,[NAME,"Android Browser"]],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/(dolfin)\/([\w\.]+)/i],[[NAME,"Dolphin"],VERSION],[/((?:android.+)crmo|crios)\/([\w\.]+)/i],[[NAME,"Chrome"],VERSION],[/(coast)\/([\w\.]+)/i],[[NAME,"Opera Coast"],VERSION],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,"Firefox"]],[/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w\.]+).+?(mobile\s?safari|safari)/i],[VERSION,NAME],[/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[[NAME,"GSA"],VERSION],[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,mapper.str,maps.browser.oldsafari.version]],[/(konqueror)\/([\w\.]+)/i,/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape)\/([\w\.-]+)/i],[[NAME,"Netscape"],VERSION],[/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,/(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,/(links)\s\(([\w\.]+)/i,/(gobrowser)\/?([\w\.]*)/i,/(ice\s?browser)\/v?([\w\._]+)/i,/(mosaic)[\/\s]([\w\.]+)/i],[NAME,VERSION]],cpu:[[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,util.lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/windows\s(ce|mobile);\sppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],[[ARCHITECTURE,/ower/,"",util.lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i],[[ARCHITECTURE,util.lowerize]]],device:[[/\((ipad|playbook);[\w\s\);-]+(rim|apple)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/applecoremedia\/[\w\.]+ \((ipad)/],[MODEL,[VENDOR,"Apple"],[TYPE,TABLET]],[/(apple\s{0,1}tv)/i],[[MODEL,"Apple TV"],[VENDOR,"Apple"]],[/(archos)\s(gamepad2?)/i,/(hp).+(touchpad)/i,/(hp).+(tablet)/i,/(kindle)\/([\w\.]+)/i,/\s(nook)[\w\s]+build\/(\w+)/i,/(dell)\s(strea[kpr\s\d]*[\dko])/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(kf[A-z]+)\sbuild\/.+silk\//i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i],[[MODEL,mapper.str,maps.device.amazon.model],[VENDOR,"Amazon"],[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);.+(apple)/i],[MODEL,VENDOR,[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);/i],[MODEL,[VENDOR,"Apple"],[TYPE,MOBILE]],[/(blackberry)[\s-]?(\w+)/i,/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,/(hp)\s([\w\s]+\w)/i,/(asus)-?(\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/\(bb10;\s(\w+)/i],[MODEL,[VENDOR,"BlackBerry"],[TYPE,MOBILE]],[/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i],[MODEL,[VENDOR,"Asus"],[TYPE,TABLET]],[/(sony)\s(tablet\s[ps])\sbuild\//i,/(sony)?(?:sgp.+)\sbuild\//i],[[VENDOR,"Sony"],[MODEL,"Xperia Tablet"],[TYPE,TABLET]],[/android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i],[MODEL,[VENDOR,"Sony"],[TYPE,MOBILE]],[/\s(ouya)\s/i,/(nintendo)\s([wids3u]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/android.+;\s(shield)\sbuild/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation\s[34portablevi]+)/i],[MODEL,[VENDOR,"Sony"],[TYPE,CONSOLE]],[/(sprint\s(\w+))/i],[[VENDOR,mapper.str,maps.device.sprint.vendor],[MODEL,mapper.str,maps.device.sprint.model],[TYPE,MOBILE]],[/(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,/(zte)-(\w*)/i,/(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/(nexus\s9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/d\/huawei([\w\s-]+)[;\)]/i,/(nexus\s6p)/i],[MODEL,[VENDOR,"Huawei"],[TYPE,MOBILE]],[/(microsoft);\s(lumia[\s\w]+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/[\s\(;](xbox(?:\sone)?)[\s\);]/i],[MODEL,[VENDOR,"Microsoft"],[TYPE,CONSOLE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,"Microsoft"],[TYPE,MOBILE]],[/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,/mot[\s-]?(\w*)/i,/(XT\d{3,4}) build\//i,/(nexus\s6)/i],[MODEL,[VENDOR,"Motorola"],[TYPE,MOBILE]],[/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],[MODEL,[VENDOR,"Motorola"],[TYPE,TABLET]],[/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],[[VENDOR,util.trim],[MODEL,util.trim],[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,"Samsung"],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,SMARTTV]],[/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,/((SM-T\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,TABLET]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV],MODEL],[/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,/(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,/sec-((sgh\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,MOBILE]],[/sie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/(maemo|nokia).*(n900|lumia\s\d+)/i,/(nokia)[\s_-]?([\w-]*)/i],[[VENDOR,"Nokia"],MODEL,[TYPE,MOBILE]],[/android\s3\.[\s\w;-]{10}(a\d{3})/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/android.+([vl]k\-?\d{3})\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,TABLET]],[/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i],[[VENDOR,"LG"],MODEL,[TYPE,TABLET]],[/(lg) netcast\.tv/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/(nexus\s[45])/i,/lg[e;\s\/-]+(\w*)/i,/android.+lg(\-?[\d\w]+)\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,MOBILE]],[/android.+(ideatab[a-z0-9\-\s]+)/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/linux;.+((jolla));/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/((pebble))app\/[\d\.]+\s/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/crkey/i],[[MODEL,"Chromecast"],[VENDOR,"Google"]],[/android.+;\s(glass)\s\d/i],[MODEL,[VENDOR,"Google"],[TYPE,WEARABLE]],[/android.+;\s(pixel c)\s/i],[MODEL,[VENDOR,"Google"],[TYPE,TABLET]],[/android.+;\s(pixel xl|pixel)\s/i],[MODEL,[VENDOR,"Google"],[TYPE,MOBILE]],[/android.+;\s(\w+)\s+build\/hm\1/i,/android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,/android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,/android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,MOBILE]],[/android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,TABLET]],[/android.+;\s(m[1-5]\snote)\sbuild/i],[MODEL,[VENDOR,"Meizu"],[TYPE,TABLET]],[/android.+a000(1)\s+build/i,/android.+oneplus\s(a\d{4})\s+build/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i],[[VENDOR,"Barnes & Noble"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/android.+;\s(k88)\sbuild/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/android.+[;\/]\s*(zur\d{3})\s+build/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/(android).+[;\/]\s+([YR]\d{2})\s+build/i,/android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*TU_(1491)\s+build/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/android.+(KS(.+))\s+build/i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/\s(tablet|tab)[;\/]/i,/\s(mobile)(?:[;\/]|\ssafari)/i],[[TYPE,util.lowerize],VENDOR,MODEL],[/(android[\w\.\s\-]{0,9});.+build/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+\sedge\/([\w\.]+)/i],[VERSION,[NAME,"EdgeHTML"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9}).+(gecko)/i],[VERSION,NAME]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[NAME,VERSION],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,/(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i],[NAME,[VERSION,mapper.str,maps.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,mapper.str,maps.os.windows.version]],[/\((bb)(10);/i],[[NAME,"BlackBerry"],VERSION],[/(blackberry)\w*\/?([\w\.]*)/i,/(tizen)[\/\s]([\w\.]+)/i,/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]*)/i,/linux;.+(sailfish);/i],[NAME,VERSION],[/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i],[[NAME,"Symbian"],VERSION],[/\((series40);/i],[NAME],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[NAME,"Firefox OS"],VERSION],[/(nintendo|playstation)\s([wids34portablevu]+)/i,/(mint)[\/\s\(]?(\w*)/i,/(mageia|vectorlinux)[;\s]/i,/(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,/(hurd|linux)\s?([\w\.]*)/i,/(gnu)\s?([\w\.]*)/i],[NAME,VERSION],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[NAME,"Chromium OS"],VERSION],[/(sunos)\s?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i],[NAME,VERSION],[/(haiku)\s(\w+)/i],[NAME,VERSION],[/cfnetwork\/.+darwin/i,/ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac\sos\sx)\s?([\w\s\.]*)/i,/(macintosh|mac(?=_powerpc)\s)/i],[[NAME,"Mac OS"],[VERSION,/_/g,"."]],[/((?:open)?solaris)[\/\s-]?([\w\.]*)/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,/(unix)\s?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(uastring,extensions){if(typeof uastring==="object"){extensions=uastring;uastring=undefined}if(!(this instanceof UAParser)){return new UAParser(uastring,extensions).getResult()}var ua=uastring||(window&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:EMPTY);var rgxmap=extensions?util.extend(regexes,extensions):regexes;this.getBrowser=function(){var browser={name:undefined,version:undefined};mapper.rgx.call(browser,ua,rgxmap.browser);browser.major=util.major(browser.version);return browser};this.getCPU=function(){var cpu={architecture:undefined};mapper.rgx.call(cpu,ua,rgxmap.cpu);return cpu};this.getDevice=function(){var device={vendor:undefined,model:undefined,type:undefined};mapper.rgx.call(device,ua,rgxmap.device);return device};this.getEngine=function(){var engine={name:undefined,version:undefined};mapper.rgx.call(engine,ua,rgxmap.engine);return engine};this.getOS=function(){var os={name:undefined,version:undefined};mapper.rgx.call(os,ua,rgxmap.os);return os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return ua};this.setUA=function(uastring){ua=uastring;return this};return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER={NAME:NAME,MAJOR:MAJOR,VERSION:VERSION};UAParser.CPU={ARCHITECTURE:ARCHITECTURE};UAParser.DEVICE={MODEL:MODEL,VENDOR:VENDOR,TYPE:TYPE,CONSOLE:CONSOLE,MOBILE:MOBILE,SMARTTV:SMARTTV,TABLET:TABLET,WEARABLE:WEARABLE,EMBEDDED:EMBEDDED};UAParser.ENGINE={NAME:NAME,VERSION:VERSION};UAParser.OS={NAME:NAME,VERSION:VERSION};if(typeof exports!==UNDEF_TYPE){if(typeof module!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if("function"===FUNC_TYPE&&__webpack_require__(7)){!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return UAParser}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(window){window.UAParser=UAParser}}var $=window&&(window.jQuery||window.Zepto);if(typeof $!==UNDEF_TYPE){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(uastring){parser.setUA(uastring);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),
/* 7 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getUaData = __webpack_require__(0);

var _types = __webpack_require__(2);

var create = _interopRequireWildcard(_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var type = create.checkType(_getUaData.device.type);

exports.default = function () {
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable;

  if (isBrowser) {
    return create.broPayload(isBrowser, _getUaData.browser, _getUaData.engine, _getUaData.os, _getUaData.ua);
  }

  if (isSmartTV) {
    return create.stvPayload(isSmartTV, _getUaData.engine, _getUaData.os, _getUaData.ua);
  }

  if (isConsole) {
    return create.consolePayload(isConsole, _getUaData.engine, _getUaData.os, _getUaData.ua);
  }

  if (isMobile) {
    return create.mobilePayload(type, _getUaData.device, _getUaData.os, _getUaData.ua);
  }

  if (isTablet) {
    return create.mobilePayload(type, _getUaData.device, _getUaData.os, _getUaData.ua);
  }

  if (isWearable) {
    return create.wearPayload(isWearable, _getUaData.engine, _getUaData.os, _getUaData.ua);
  }
};

/***/ })
/******/ ]);

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var IE8_DOM_DEFINE = __webpack_require__(344);
var toPrimitive = __webpack_require__(63);
var dP = Object.defineProperty;

exports.f = __webpack_require__(22) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(623).default;

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_bootstrapModal_css__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_bootstrapModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__css_bootstrapModal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var modalsShowing=0;var currentScrollTop=0;function modalWillShow(){if(modalsShowing===0){document.body.classList.add('modal-open');}modalsShowing+=1;currentScrollTop=__WEBPACK_IMPORTED_MODULE_4_jquery___default()(window).scrollTop();}function modalWillHide(){modalsShowing-=1;if(modalsShowing===0){document.body.classList.remove('modal-open');window.scrollTo(0,currentScrollTop);}}var TestTakingModalComponent=function(_React$Component){_inherits(TestTakingModalComponent,_React$Component);function TestTakingModalComponent(props){_classCallCheck(this,TestTakingModalComponent);var _this=_possibleConstructorReturn(this,(TestTakingModalComponent.__proto__||Object.getPrototypeOf(TestTakingModalComponent)).call(this,props));_this.componentWillMount=function(){if(_this.props.visible){modalWillShow();}};_this.componentDidUpdate=function(prevProps){if(_this.props.visible!==prevProps.visible){if(_this.props.visible){modalWillShow();}else{modalWillHide();}_this.setState({transitioning:true},function(){window.requestAnimationFrame(function(){_this.setState({visible:_this.props.visible},function(){window.setTimeout(function(){_this.setState({transitioning:false});},150);});});});}};_this.componentWillUnmount=function(){if(_this.props.visible){modalWillHide();}};_this.stopPropagation=function(event){event.stopPropagation();};_this.renderBackdrop=function(){if(_this.state.visible||_this.state.transitioning){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-backdrop','fade',{show:_this.state.visible}),onClick:_this.props.onClickBackdrop,role:'presentation'});}return null;};_this.render=function(){var _this$props=_this.props,wrapperProps=_this$props.wrapperProps,className=_this$props.className,dialogClassName=_this$props.dialogClassName,visible=_this$props.visible,onClickBackdrop=_this$props.onClickBackdrop,children=_this$props.children,other=_objectWithoutProperties(_this$props,['wrapperProps','className','dialogClassName','visible','onClickBackdrop','children']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',wrapperProps,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal','fade',{show:_this.state.visible},className),style:{display:_this.state.visible||_this.state.transitioning?'block':'none'},role:'dialog','aria-hidden':!_this.state.visible,tabIndex:'-1',onClick:onClickBackdrop},other),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-dialog',dialogClassName),role:'document',onClick:_this.stopPropagation},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content'},children))),_this.renderBackdrop());};_this.state={visible:_this.props.visible};return _this;}// Shenanigans to allow the CSS fade to happen before we stop rendering the dialog or divs
return TestTakingModalComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);TestTakingModalComponent.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,onClickBackdrop:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,visible:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,wrapperProps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,// eslint-disable-line react/forbid-prop-types
className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,dialogClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};TestTakingModalComponent.defaultProps={onClickBackdrop:null,wrapperProps:null,className:null,dialogClassName:null};/* harmony default export */ __webpack_exports__["a"] = (TestTakingModalComponent);

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(64);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/**
* Native Ajax enables CORS requests.
*/var NativeAjax=function NativeAjax(url,data){var availableMethods=['GET','POST','PUT'];var paramStr="";var withCredentials=false;var defaultHeaders={"Content-type":"application/json;charset=UTF-8",'Accept':'*'};var reqBodyTypePreference="string";var processHeaders=function processHeaders(request){if(defaultHeaders&&(typeof defaultHeaders==='undefined'?'undefined':_typeof(defaultHeaders))==="object"){for(var i in defaultHeaders){request.setRequestHeader(i,defaultHeaders[i]);}}request.withCredentials=withCredentials;return request;};//To enable CORS request
this.enableCORS=function(){withCredentials=true;return this;};this.setFormData=function(formObj){reqBodyTypePreference="object";var formData=new FormData();if(formObj){for(var i in formObj){formData.append(i,formObj[i]);}}defaultHeaders={};data=formData;return this;};this.setHeaders=function(headers){if(headers&&(typeof headers==='undefined'?'undefined':_typeof(headers))==="object"){for(var i in headers){defaultHeaders[i]=headers[i];}}return this;};this.preferObject=function(type){if(type)reqBodyTypePreference=type;return this;};if(data!=null){paramStr="?";var tempIndex=0;for(var i in data){if(tempIndex>0){paramStr+="&";}paramStr+=i+"="+data[i];tempIndex++;}}this.get=function(success,failure){this.connect('GET',success,failure);};this.post=function(success,failure){this.connect('POST',success,failure);};this.put=function(success,failure){this.connect('PUT',success,failure);};this.connect=function(method,success,failure){if(availableMethods.indexOf(method)===-1){//if method not defined, default is applied
method=availableMethods[0];}// Feature detection
if(!window.XMLHttpRequest)return;// Create new request
var request=new XMLHttpRequest();//enable CORS
request.withCredentials=withCredentials;request.onreadystatechange=function(){// If the request is complete
if(request.readyState===4){// If the request failed
if(request.status!==200){if(failure&&typeof failure==='function'){var response={};try{response=JSON.parse(request.responseText);}catch(e){response=request.responseText;}failure(response,request);}return;}// If the request succeeded
if(success&&typeof success==='function'){var response={};try{response=JSON.parse(request.responseText);}catch(e){response=request.responseText;//console.error(e);
}success(response,request);}return;}};if(paramStr!=null){if(method==='GET'){url+=paramStr;request.open(method,url,true);request.send();}else{request.open(method,url,true);request=processHeaders(request);if(reqBodyTypePreference==="object"){request.send(data);}else{request.send(JSON.stringify(data));}}}else{console.error("No Params to request to Host machine.");}};};/* harmony default export */ __webpack_exports__["a"] = (NativeAjax);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.9' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _CSSTransition = __webpack_require__(1124);

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalVideo = function (_React$Component) {
  _inherits(ModalVideo, _React$Component);

  function ModalVideo(props) {
    _classCallCheck(this, ModalVideo);

    var _this = _possibleConstructorReturn(this, (ModalVideo.__proto__ || Object.getPrototypeOf(ModalVideo)).call(this, props));

    _this.state = {
      isOpen: false
    };
    _this.closeModal = _this.closeModal.bind(_this);
    _this.updateFocus = _this.updateFocus.bind(_this);
    return _this;
  }

  _createClass(ModalVideo, [{
    key: 'openModal',
    value: function openModal() {
      this.setState({ isOpen: true });
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.setState({ isOpen: false });
      if (typeof this.props.onClose === 'function') {
        this.props.onClose();
      }
    }
  }, {
    key: 'keydownHandler',
    value: function keydownHandler(e) {
      if (e.keyCode === 27) {
        this.closeModal();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('keydown', this.keydownHandler.bind(this));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.keydownHandler.bind(this));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({ isOpen: nextProps.isOpen });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.state.isOpen && this.modal) {
        this.modal.focus();
      }
    }
  }, {
    key: 'updateFocus',
    value: function updateFocus(e) {
      if (e.keyCode === 9) {
        e.preventDefault();
        e.stopPropagation();
        if (this.modal === document.activeElement) {
          this.modalbtn.focus();
        } else {
          this.modal.focus();
        }
      }
    }
  }, {
    key: 'getQueryString',
    value: function getQueryString(obj) {
      var url = '';
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (obj[key] !== null) {
            url += key + '=' + obj[key] + '&';
          }
        }
      }
      return url.substr(0, url.length - 1);
    }
  }, {
    key: 'getYoutubeUrl',
    value: function getYoutubeUrl(youtube, videoId) {
      var query = this.getQueryString(youtube);
      return '//www.youtube.com/embed/' + videoId + '?' + query;
    }
  }, {
    key: 'getVimeoUrl',
    value: function getVimeoUrl(vimeo, videoId) {
      var query = this.getQueryString(vimeo);
      return '//player.vimeo.com/video/' + videoId + '?' + query;
    }
  }, {
    key: 'getYoukuUrl',
    value: function getYoukuUrl(youku, videoId) {
      var query = this.getQueryString(youku);
      return '//player.youku.com/embed/' + videoId + '?' + query;
    }
  }, {
    key: 'getVideoUrl',
    value: function getVideoUrl(opt, videoId) {
      if (opt.channel === 'youtube') {
        return this.getYoutubeUrl(opt.youtube, videoId);
      } else if (opt.channel === 'vimeo') {
        return this.getVimeoUrl(opt.vimeo, videoId);
      } else if (opt.channel === 'youku') {
        return this.getYoukuUrl(opt.youku, videoId);
      }
    }
  }, {
    key: 'getPadding',
    value: function getPadding(ratio) {
      var arr = ratio.split(':');
      var width = Number(arr[0]);
      var height = Number(arr[1]);
      var padding = height * 100 / width;
      return padding + '%';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var style = {
        paddingBottom: this.getPadding(this.props.ratio)
      };

      return _react2.default.createElement(
        _CSSTransition2.default,
        {
          classNames: this.props.classNames.modalVideoEffect,
          timeout: this.props.animationSpeed
        },
        function () {
          if (!_this2.state.isOpen) {
            return null;
          }

          return _react2.default.createElement(
            'div',
            { className: _this2.props.classNames.modalVideo, tabIndex: '-1', role: 'dialog',
              'aria-label': _this2.props.aria.openMessage, onClick: _this2.closeModal, ref: function ref(node) {
                _this2.modal = node;
              }, onKeyDown: _this2.updateFocus },
            _react2.default.createElement(
              'div',
              { className: _this2.props.classNames.modalVideoBody },
              _react2.default.createElement(
                'div',
                { className: _this2.props.classNames.modalVideoInner },
                _react2.default.createElement(
                  'div',
                  { className: _this2.props.classNames.modalVideoIframeWrap, style: style },
                  _react2.default.createElement('button', { className: _this2.props.classNames.modalVideoCloseBtn, 'aria-label': _this2.props.aria.dismissBtnMessage, ref: function ref(node) {
                      _this2.modalbtn = node;
                    }, onKeyDown: _this2.updateFocus }),
                  _react2.default.createElement('iframe', { width: '460', height: '230', src: _this2.getVideoUrl(_this2.props, _this2.props.videoId), frameBorder: '0', allowFullScreen: _this2.props.allowFullScreen, tabIndex: '-1' })
                )
              )
            )
          );
        }
      );
    }
  }]);

  return ModalVideo;
}(_react2.default.Component);

exports.default = ModalVideo;


ModalVideo.defaultProps = {
  channel: 'youtube',
  isOpen: false,
  youtube: {
    autoplay: 1,
    cc_load_policy: 1,
    color: null,
    controls: 1,
    disablekb: 0,
    enablejsapi: 0,
    end: null,
    fs: 1,
    h1: null,
    iv_load_policy: 1,
    list: null,
    listType: null,
    loop: 0,
    modestbranding: null,
    origin: null,
    playlist: null,
    playsinline: null,
    rel: 0,
    showinfo: 1,
    start: 0,
    wmode: 'transparent',
    theme: 'dark'
  },
  ratio: '16:9',
  vimeo: {
    api: false,
    autopause: true,
    autoplay: true,
    byline: true,
    callback: null,
    color: null,
    height: null,
    loop: false,
    maxheight: null,
    maxwidth: null,
    player_id: null,
    portrait: true,
    title: true,
    width: null,
    xhtml: false
  },
  youku: {
    autoplay: 1,
    show_related: 0
  },
  allowFullScreen: true,
  animationSpeed: 300,
  classNames: {
    modalVideoEffect: 'modal-video-effect',
    modalVideo: 'modal-video',
    modalVideoClose: 'modal-video-close',
    modalVideoBody: 'modal-video-body',
    modalVideoInner: 'modal-video-inner',
    modalVideoIframeWrap: 'modal-video-movie-wrap',
    modalVideoCloseBtn: 'modal-video-close-btn'
  },
  aria: {
    openMessage: 'You just openned the modal video',
    dismissBtnMessage: 'Close the modal by clicking here'
  }
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/**
 * This function is to access browser utilities
 */var browserUtil=function(){var userDetails={};return{setUserDetails:function setUserDetails(userObj){try{if(typeof userObj==="string"){userDetails=JSON.parse(userObj);}else if((typeof userObj==="undefined"?"undefined":_typeof(userObj))==="object"){userDetails=userObj;}}catch(e){console.error(e);}},getUserDetails:function getUserDetails(){return userDetails;},getCookie:function getCookie(cname){try{var name=cname+"=";var ca=document.cookie.split(';');for(var i=0;i<ca.length;i++){var c=ca[i];while(c.charAt(0)===' '){c=c.substring(1);}if(c.indexOf(name)===0){return c.substring(name.length,c.length);}}return"";}catch(e){if(console)console.log(e);return"";}},clearCookie:function clearCookie(cname){try{document.cookie=cname+" =; expires = Thu, 01 Jan 1970 00:00:00 UTC";}catch(e){if(console)console.log(e);}},getUserName:function getUserName(){return userDetails.userName;},getUserId:function getUserId(){return userDetails.userId;},getLoginId:function getLoginId(){return userDetails.loginId;},getCountry:function getCountry(){return userDetails.country;},getLanguage:function getLanguage(){return userDetails.language;},getUserRole:function getUserRole(){return userDetails.userRole.role;},getAuthToken:function getAuthToken(){var authToken=browserUtil.getCookie("_rToken")?browserUtil.getCookie("_rToken"):"";return authToken;},getLumosToken:function getLumosToken(){var authToken=browserUtil.getCookie("authToken")?browserUtil.getCookie("authToken"):"";return authToken;}};}();/* harmony default export */ __webpack_exports__["a"] = (browserUtil);

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserUtil__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BrowserStorageUtil__ = __webpack_require__(11);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var UserStorageUtil=function(){var userDataKey="USER_SESSION";var getAuthToken=function getAuthToken(){return __WEBPACK_IMPORTED_MODULE_0__BrowserUtil__["a" /* default */].getAuthToken();};setTimeout(function(){try{var allData={};try{allData=JSON.parse(__WEBPACK_IMPORTED_MODULE_1__BrowserStorageUtil__["a" /* default */].getStoredItem(userDataKey));}catch(e){}if(allData!==null&&(typeof allData==='undefined'?'undefined':_typeof(allData))==="object"){for(var i in allData){if(i!==getAuthToken()){delete allData[i];}}__WEBPACK_IMPORTED_MODULE_1__BrowserStorageUtil__["a" /* default */].storeItem(userDataKey,JSON.stringify(allData));}}catch(e){}},5000);return{storeSessionItem:function storeSessionItem(itemKey,itemValue){try{var allUserData={};try{allUserData=JSON.parse(__WEBPACK_IMPORTED_MODULE_1__BrowserStorageUtil__["a" /* default */].getStoredItem(userDataKey));}catch(e){}if(allUserData==null){allUserData={};}var myStoreObj=allUserData[getAuthToken()]||{};myStoreObj[itemKey]=itemValue;allUserData[getAuthToken()]=myStoreObj;__WEBPACK_IMPORTED_MODULE_1__BrowserStorageUtil__["a" /* default */].storeItem(userDataKey,JSON.stringify(allUserData));}catch(e){if(console)console.error(e);}},getStoredSessionItem:function getStoredSessionItem(itemKey){try{var allUserData={};try{allUserData=JSON.parse(__WEBPACK_IMPORTED_MODULE_1__BrowserStorageUtil__["a" /* default */].getStoredItem(userDataKey));}catch(e){}if(allUserData===null){allUserData={};}var myStoreObj=allUserData[getAuthToken()]||{};if(myStoreObj[itemKey]!==undefined&&myStoreObj[itemKey]!==null){return myStoreObj[itemKey];}else{return null;}}catch(e){if(console)console.error(e);}},deleteSessionItem:function deleteSessionItem(itemKey){try{var allUserData={};try{allUserData=JSON.parse(__WEBPACK_IMPORTED_MODULE_1__BrowserStorageUtil__["a" /* default */].getStoredItem(userDataKey));}catch(e){}if(allUserData==null){allUserData={};}var myStoreObj=allUserData[getAuthToken()]||{};delete myStoreObj[itemKey];allUserData[getAuthToken()]=myStoreObj;__WEBPACK_IMPORTED_MODULE_1__BrowserStorageUtil__["a" /* default */].storeItem(userDataKey,JSON.stringify(allUserData));}catch(e){if(console)console.error(e);}},clearSessionStorage:function clearSessionStorage(){try{__WEBPACK_IMPORTED_MODULE_1__BrowserStorageUtil__["a" /* default */].removeItem(userDataKey);}catch(e){if(console)console.error(e);}}};}();/* harmony default export */ __webpack_exports__["a"] = (UserStorageUtil);

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_html_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_UrlManager__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_CoreAjax__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_LoaderMask__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert_src_react_confirm_alert_css__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_confirm_alert_src_react_confirm_alert_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_confirm_alert_src_react_confirm_alert_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_RbUtil__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_RbMeta__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_RbTitle__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_RbHeading__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__model_event_structures__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__model_event_structures___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__model_event_structures__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_TimeUtil__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_device_detect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_UserStorageUtil__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_BrowserUtil__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__util_AdsTracker__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__model_ComponentRegistry_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__util_ComponentHelper__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_FileAppender__ = __webpack_require__(620);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CorePage=function(_React$Component){_inherits(CorePage,_React$Component);function CorePage(props){_classCallCheck(this,CorePage);return _possibleConstructorReturn(this,(CorePage.__proto__||Object.getPrototypeOf(CorePage)).call(this,props));}_createClass(CorePage,[{key:'getQueryParams',value:function getQueryParams(){try{if(!window.location.href.includes("?")){return{};}var pairs=window.location.href.split("?")[1].split('&');var result={};pairs.forEach(function(pair){pair=pair.split('=');result[pair[0]]=decodeURIComponent(pair[1]||'');});return JSON.parse(JSON.stringify(result));}catch(e){}return{};}},{key:'getQueryParam',value:function getQueryParam(){var key=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;if(key){var qryParams=this.getQueryParams();return qryParams&&qryParams[key]?qryParams[key]:null;}return null;}},{key:'appendJS',value:function appendJS(url){new __WEBPACK_IMPORTED_MODULE_22__util_FileAppender__["a" /* default */](url).addVersion().js();}},{key:'appendCSS',value:function appendCSS(url){new __WEBPACK_IMPORTED_MODULE_22__util_FileAppender__["a" /* default */](url).addVersion().css();}},{key:'getCmpHelper',value:function getCmpHelper(userStore){return Object(__WEBPACK_IMPORTED_MODULE_21__util_ComponentHelper__["a" /* default */])(userStore);}},{key:'getTimeUtil',value:function getTimeUtil(){return new __WEBPACK_IMPORTED_MODULE_12__util_TimeUtil__["a" /* default */]();}},{key:'getTracker',value:function getTracker(){return __WEBPACK_IMPORTED_MODULE_11__model_event_structures___default.a;}},{key:'isMobile',value:function isMobile(){return __WEBPACK_IMPORTED_MODULE_14_react_device_detect__["isMobile"];}},{key:'isTab',value:function isTab(){return __WEBPACK_IMPORTED_MODULE_14_react_device_detect__["isTablet"];}},{key:'isBrowser',value:function isBrowser(){return __WEBPACK_IMPORTED_MODULE_14_react_device_detect__["isBrowser"];}},{key:'getSessionStore',value:function getSessionStore(){return __WEBPACK_IMPORTED_MODULE_15__util_UserStorageUtil__["a" /* default */];}},{key:'saveInSession',value:function saveInSession(key,value){__WEBPACK_IMPORTED_MODULE_15__util_UserStorageUtil__["a" /* default */].storeSessionItem(key,value);}},{key:'getFromSession',value:function getFromSession(key){return __WEBPACK_IMPORTED_MODULE_15__util_UserStorageUtil__["a" /* default */].getStoredSessionItem(key);}},{key:'getAdsTracker',value:function getAdsTracker(){return __WEBPACK_IMPORTED_MODULE_19__util_AdsTracker__["a" /* default */];}},{key:'getTermsUrl',value:function getTermsUrl(_geo){var geo=_geo||"ROW";var termsObj=window.termsandCondition;var termsURL=termsObj[geo]?termsObj[geo]:termsObj["ALL"];return termsURL;}},{key:'getGeo',value:function getGeo(){if(sessionStorage.getItem("geo")&&sessionStorage.getItem("geo").length>0){return sessionStorage.getItem("geo");}return __WEBPACK_IMPORTED_MODULE_18__util_BrowserUtil__["a" /* default */].getCookie("geo");}},{key:'prodForCountry',value:function prodForCountry(){var producttoShow=window.producttoShow?window.producttoShow:null;var geoLocation=this.getGeo();var prodShow='';if(producttoShow){prodShow=producttoShow[geoLocation]||producttoShow['OTHERS'];}else{prodShow='SG';}return prodShow;}},{key:'sessionCheck',value:function sessionCheck(successCallback,failureCallBack,forceTrigger){var me=this;var success=function success(userObj,opts){if(typeof successCallback==="function"){successCallback.apply(this,[userObj]);}};var failure=function failure(error,opts){if(typeof failureCallBack==="function"){failureCallBack.apply(this,[error]);}};if(forceTrigger||this.isSessionCheckEligible()){new __WEBPACK_IMPORTED_MODULE_3__util_CoreAjax__["a" /* default */](me.getUrlFor("SESSION_CHECK")).get(success,failure);if(forceTrigger){__WEBPACK_IMPORTED_MODULE_17__util_BrowserStorageUtil__["a" /* default */].storeItem("LAST_SESSION_CHECK",new Date().getTime()/1000);}}else{var storedUserObj=this.getStoredUser();if(storedUserObj){if(typeof successCallback==="function"){successCallback.apply(this,[storedUserObj]);}}else{if(typeof failureCallBack==="function"){failureCallBack.apply(this,[{sessionChecked:false}]);}}}}},{key:'isSessionCheckEligible',value:function isSessionCheckEligible(){var storedUser=this.getStoredUser();var storedUserId=storedUser&&storedUser.userId?storedUser.userId:null;if(!(storedUserId&&storedUserId.length>0)){return true;}var DEFAULT_INTERVAL_IN_SECS=!isNaN(window.sessionCheckInterval)&&window.sessionCheckInterval>0?window.sessionCheckInterval:15;try{var dt=new Date().getTime()/1000;var oldDt=__WEBPACK_IMPORTED_MODULE_17__util_BrowserStorageUtil__["a" /* default */].getStoredItem("LAST_SESSION_CHECK");if(!isNaN(oldDt)&&dt-oldDt<=DEFAULT_INTERVAL_IN_SECS){return false;}else{__WEBPACK_IMPORTED_MODULE_17__util_BrowserStorageUtil__["a" /* default */].storeItem("LAST_SESSION_CHECK",dt);}}catch(e){}return true;}},{key:'getStoredUser',value:function getStoredUser(){return this.getFromSession("USER_DETAILS");}},{key:'setLocale',value:function setLocale(locale){__WEBPACK_IMPORTED_MODULE_7__util_RbUtil__["a" /* default */].setLocale(locale);__WEBPACK_IMPORTED_MODULE_8__util_RbMeta__["a" /* default */].setLocale(locale);__WEBPACK_IMPORTED_MODULE_9__util_RbTitle__["a" /* default */].setLocale(locale);__WEBPACK_IMPORTED_MODULE_10__util_RbHeading__["a" /* default */].setLocale(locale);}},{key:'rb',value:function rb(rawTxt){var replaceStringArray=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];return __WEBPACK_IMPORTED_MODULE_7__util_RbUtil__["a" /* default */].getText(rawTxt,replaceStringArray);}},{key:'getLocales',value:function getLocales(){return __WEBPACK_IMPORTED_MODULE_7__util_RbUtil__["a" /* default */].getLocales();}},{key:'getTitle',value:function getTitle(rawTxt){var replaceStringArray=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];return __WEBPACK_IMPORTED_MODULE_9__util_RbTitle__["a" /* default */].getText(rawTxt,replaceStringArray);}},{key:'setTitle',value:function setTitle(rawTxt){var replaceStringArray=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];document.title=this.getTitle(rawTxt,replaceStringArray);}},{key:'getMeta',value:function getMeta(rawTxt){var replaceStringArray=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];return __WEBPACK_IMPORTED_MODULE_8__util_RbMeta__["a" /* default */].getText(rawTxt,replaceStringArray);}},{key:'setMeta',value:function setMeta(rawTxt){var replaceStringArray=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var me=this;//document.body.onload = ()=> {
var metas=document.getElementsByTagName("meta");if(metas&&metas.length>0){for(var i=0;i<metas.length;i++){if(metas[i].name==="description"){var descMeta=metas[i];descMeta.content=me.getMeta(rawTxt,replaceStringArray);}}}//}
}},{key:'getHeading',value:function getHeading(rawTxt){var replaceStringArray=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];return __WEBPACK_IMPORTED_MODULE_10__util_RbHeading__["a" /* default */].getText(rawTxt,replaceStringArray);}},{key:'setHeading',value:function setHeading(rawTxt){var replaceStringArray=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var heading=document.getElementById("hidden-h1");heading.textContent=this.getHeading(rawTxt,replaceStringArray);}},{key:'fireEvent',value:function fireEvent(event,obj){if(event){__WEBPACK_IMPORTED_MODULE_13__model_HmEventRegistry__["a" /* default */].fireEvent(event,obj);}}},{key:'getUrlFor',value:function getUrlFor(action){return __WEBPACK_IMPORTED_MODULE_2__model_UrlManager__["a" /* default */].getUrlForAction(action);}},{key:'showLoader',value:function showLoader(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_common_LoaderMask__["a" /* default */],null));}},{key:'showAlert',value:function showAlert(title,message,btnHandlers){var btnshw=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;var closeOnClickOutside=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;var me=this;var buttons=[];try{if(btnHandlers!==undefined&&btnHandlers!==null&&btnHandlers.length>0){for(var i=0;i<btnHandlers.length;i++){buttons.push({label:btnHandlers[i].label||me.rb("btn.ok"),onClick:typeof btnHandlers[i].handler==="function"?btnHandlers[i].handler:function(){}});}}}catch(e){}if(buttons.length==0&&btnshw==null){buttons.push({label:'Ok',onClick:function onClick(){}});}return Object(__WEBPACK_IMPORTED_MODULE_5_react_confirm_alert__["confirmAlert"])({title:title||'Alert',message:message?__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(message):'Hello..',buttons:buttons,closeOnClickOutside:closeOnClickOutside||false});}},{key:'removeWhiteSpace',value:function removeWhiteSpace(str){return str.replace(/ +/g,"");}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_common_LoaderMask__["a" /* default */],null));}}]);return CorePage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CorePage);

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
* Scope: Singleton
* ComponentRegistry will register and get components based on parameters.
* Component - In general, any function. But since functions are already available with HmEventRegistry,
* this will be used whenever there is a need for a component (Class) to be fetched using just the name
* component (class).
*/var ComponentRegistry=function(){var cmpRegistry={};return{/**
		 * Registering Component
		 */register:function register(cmpName,comp){if(cmpName!==null&&comp!==null){cmpRegistry[cmpName.toLowerCase()]=comp;return true;}else{return false;}},/**
		* function to check if the component exists
		*/exists:function exists(cmpName){return cmpName&&cmpRegistry[cmpName.toLowerCase()];},/**
		 * Get the component by cmpName
		 */get:function get(cmpName){if(cmpName&&cmpRegistry[cmpName.toLowerCase()]){return cmpRegistry[cmpName.toLowerCase()];}return null;}};}();/* harmony default export */ __webpack_exports__["a"] = (ComponentRegistry);

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Alert */
/* unused harmony export Container */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return Row; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Col; });
/* unused harmony export Navbar */
/* unused harmony export NavbarBrand */
/* unused harmony export NavbarToggler */
/* unused harmony export Nav */
/* unused harmony export NavItem */
/* unused harmony export NavDropdown */
/* unused harmony export NavLink */
/* unused harmony export Breadcrumb */
/* unused harmony export BreadcrumbItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* unused harmony export ButtonDropdown */
/* unused harmony export ButtonGroup */
/* unused harmony export ButtonToolbar */
/* unused harmony export Dropdown */
/* unused harmony export DropdownItem */
/* unused harmony export DropdownMenu */
/* unused harmony export DropdownToggle */
/* unused harmony export Fade */
/* unused harmony export Badge */
/* unused harmony export Card */
/* unused harmony export CardLink */
/* unused harmony export CardGroup */
/* unused harmony export CardDeck */
/* unused harmony export CardColumns */
/* unused harmony export CardBody */
/* unused harmony export CardBlock */
/* unused harmony export CardFooter */
/* unused harmony export CardHeader */
/* unused harmony export CardImg */
/* unused harmony export CardImgOverlay */
/* unused harmony export Carousel */
/* unused harmony export UncontrolledCarousel */
/* unused harmony export CarouselControl */
/* unused harmony export CarouselItem */
/* unused harmony export CarouselIndicators */
/* unused harmony export CarouselCaption */
/* unused harmony export CardSubtitle */
/* unused harmony export CardText */
/* unused harmony export CardTitle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Popover; });
/* unused harmony export PopoverContent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PopoverBody; });
/* unused harmony export PopoverTitle */
/* unused harmony export PopoverHeader */
/* unused harmony export Progress */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Modal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ModalHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ModalBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ModalFooter; });
/* unused harmony export PopperContent */
/* unused harmony export PopperTargetHelper */
/* unused harmony export Tooltip */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return Table; });
/* unused harmony export ListGroup */
/* unused harmony export Form */
/* unused harmony export FormFeedback */
/* unused harmony export FormGroup */
/* unused harmony export FormText */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Input; });
/* unused harmony export InputGroup */
/* unused harmony export InputGroupAddon */
/* unused harmony export InputGroupButton */
/* unused harmony export InputGroupButtonDropdown */
/* unused harmony export InputGroupText */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Label; });
/* unused harmony export Media */
/* unused harmony export Pagination */
/* unused harmony export PaginationItem */
/* unused harmony export PaginationLink */
/* unused harmony export TabContent */
/* unused harmony export TabPane */
/* unused harmony export Jumbotron */
/* unused harmony export Collapse */
/* unused harmony export ListGroupItem */
/* unused harmony export ListGroupItemText */
/* unused harmony export ListGroupItemHeading */
/* unused harmony export UncontrolledAlert */
/* unused harmony export UncontrolledButtonDropdown */
/* unused harmony export UncontrolledDropdown */
/* unused harmony export UncontrolledNavDropdown */
/* unused harmony export UncontrolledTooltip */
/* unused harmony export Util */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isfunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isobject__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isobject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isobject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_popper__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_popper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_popper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_tonumber__);









// https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/js/src/modal.js#L436-L443
function getScrollbarWidth() {
  var scrollDiv = document.createElement('div');
  // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.width = '50px';
  scrollDiv.style.height = '50px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}

function setScrollbarWidth(padding) {
  document.body.style.paddingRight = padding > 0 ? padding + 'px' : null;
}

function isBodyOverflowing() {
  return document.body.clientWidth < window.innerWidth;
}

function getOriginalBodyPadding() {
  var style = window.getComputedStyle(document.body, null);

  return parseInt(style && style.getPropertyValue('padding-right') || 0, 10);
}

function conditionallyUpdateScrollbar() {
  var scrollbarWidth = getScrollbarWidth();
  // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.6/js/src/modal.js#L433
  var fixedContent = document.querySelectorAll('.fixed-top, .fixed-bottom, .is-fixed, .sticky-top')[0];
  var bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;

  if (isBodyOverflowing()) {
    setScrollbarWidth(bodyPadding + scrollbarWidth);
  }
}

var globalCssModule = void 0;

function setGlobalCssModule(cssModule) {
  globalCssModule = cssModule;
}

function mapToCssModules() {
  var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var cssModule = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalCssModule;

  if (!cssModule) return className;
  return className.split(' ').map(function (c) {
    return cssModule[c] || c;
  }).join(' ');
}

/**
 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
 */
function omit(obj, omitKeys) {
  var result = {};
  Object.keys(obj).forEach(function (key) {
    if (omitKeys.indexOf(key) === -1) {
      result[key] = obj[key];
    }
  });
  return result;
}

/**
 * Returns a filtered copy of an object with only the specified keys.
 */
function pick(obj, keys) {
  var pickKeys = Array.isArray(keys) ? keys : [keys];
  var length = pickKeys.length;
  var key = void 0;
  var result = {};

  while (length > 0) {
    length -= 1;
    key = pickKeys[length];
    result[key] = obj[key];
  }
  return result;
}

var warned = {};

function warnOnce(message) {
  if (!warned[message]) {
    /* istanbul ignore else */
    if (typeof console !== 'undefined') {
      console.error(message); // eslint-disable-line no-console
    }
    warned[message] = true;
  }
}

function deprecated(propType, explanation) {
  return function validate(props, propName, componentName) {
    if (props[propName] !== null && typeof props[propName] !== 'undefined') {
      warnOnce('"' + propName + '" property of "' + componentName + '" has been deprecated.\n' + explanation);
    }

    for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType.apply(undefined, [props, propName, componentName].concat(rest));
  };
}

function DOMElement(props, propName, componentName) {
  if (!(props[propName] instanceof Element)) {
    return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. Expected prop to be an instance of Element. Validation failed.');
  }
}

function getTarget(target) {
  if (__WEBPACK_IMPORTED_MODULE_3_lodash_isfunction___default()(target)) {
    return target();
  }

  if (typeof target === 'string' && document) {
    var selection = document.querySelector(target);
    if (selection === null) {
      selection = document.querySelector('#' + target);
    }
    if (selection === null) {
      throw new Error('The target \'' + target + '\' could not be identified in the dom, tip: check spelling');
    }
    return selection;
  }

  return target;
}

/* eslint key-spacing: ["error", { afterColon: true, align: "value" }] */
// These are all setup to match what is in the bootstrap _variables.scss
// https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss
var TransitionTimeouts = {
  Fade: 150, // $transition-fade
  Collapse: 350, // $transition-collapse
  Modal: 300, // $modal-transition
  Carousel: 600 // $carousel-transition
};

// Duplicated Transition.propType keys to ensure that Reactstrap builds
// for distribution properly exclude these keys for nested child HTML attributes
// since `react-transition-group` removes propTypes in production builds.
var TransitionPropTypeKeys = ['in', 'mountOnEnter', 'unmountOnExit', 'appear', 'enter', 'exit', 'timeout', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'];

var TransitionStatuses = {
  ENTERING: 'entering',
  ENTERED: 'entered',
  EXITING: 'exiting',
  EXITED: 'exited'
};

var keyCodes = {
  esc: 27,
  space: 32,
  tab: 9,
  up: 38,
  down: 40
};

var PopperPlacements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var utils = Object.freeze({
	getScrollbarWidth: getScrollbarWidth,
	setScrollbarWidth: setScrollbarWidth,
	isBodyOverflowing: isBodyOverflowing,
	getOriginalBodyPadding: getOriginalBodyPadding,
	conditionallyUpdateScrollbar: conditionallyUpdateScrollbar,
	setGlobalCssModule: setGlobalCssModule,
	mapToCssModules: mapToCssModules,
	omit: omit,
	pick: pick,
	warnOnce: warnOnce,
	deprecated: deprecated,
	DOMElement: DOMElement,
	getTarget: getTarget,
	TransitionTimeouts: TransitionTimeouts,
	TransitionPropTypeKeys: TransitionPropTypeKeys,
	TransitionStatuses: TransitionStatuses,
	keyCodes: keyCodes,
	PopperPlacements: PopperPlacements,
	canUseDOM: canUseDOM
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var propTypes = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  fluid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps = {
  tag: 'div'
};

var Container = function Container(props) {
  var className = props.className,
      cssModule = props.cssModule,
      fluid = props.fluid,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'fluid', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, fluid ? 'container-fluid' : 'container'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Container.propTypes = propTypes;
Container.defaultProps = defaultProps;

var propTypes$1 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  noGutters: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$1 = {
  tag: 'div'
};

var Row = function Row(props) {
  var className = props.className,
      cssModule = props.cssModule,
      noGutters = props.noGutters,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'noGutters', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, noGutters ? 'no-gutters' : null, 'row'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Row.propTypes = propTypes$1;
Row.defaultProps = defaultProps$1;

var colWidths = ['xs', 'sm', 'md', 'lg', 'xl'];
var stringOrNumberProp = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]);

var columnProps = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  push: deprecated(stringOrNumberProp, 'Please use the prop "order"'),
  pull: deprecated(stringOrNumberProp, 'Please use the prop "order"'),
  order: stringOrNumberProp,
  offset: stringOrNumberProp
})]);

var propTypes$2 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  xs: columnProps,
  sm: columnProps,
  md: columnProps,
  lg: columnProps,
  xl: columnProps,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  widths: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

var defaultProps$2 = {
  tag: 'div',
  widths: colWidths
};

var getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : 'col-' + colWidth;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : 'col-' + colWidth + '-auto';
  }

  return isXs ? 'col-' + colSize : 'col-' + colWidth + '-' + colSize;
};

var Col = function Col(props) {
  var className = props.className,
      cssModule = props.cssModule,
      widths = props.widths,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'widths', 'tag']);

  var colClasses = [];

  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];

    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    var isXs = !i;

    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isobject___default()(columnProp)) {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : '-' + colWidth + '-';
      var colClass = getColumnSizeClass(isXs, colWidth, columnProp.size);

      colClasses.push(mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, defineProperty(_classNames, colClass, columnProp.size || columnProp.size === ''), defineProperty(_classNames, 'order' + colSizeInterfix + columnProp.order, columnProp.order || columnProp.order === 0), defineProperty(_classNames, 'offset' + colSizeInterfix + columnProp.offset, columnProp.offset || columnProp.offset === 0), _classNames)), cssModule));
    } else {
      var _colClass = getColumnSizeClass(isXs, colWidth, columnProp);
      colClasses.push(_colClass);
    }
  });

  if (!colClasses.length) {
    colClasses.push('col');
  }

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, colClasses), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Col.propTypes = propTypes$2;
Col.defaultProps = defaultProps$2;

var propTypes$3 = {
  light: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dark: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inverse: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "dark"'),
  full: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  fixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  sticky: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggleable: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]), 'Please use the prop "expand"'),
  expand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$3 = {
  tag: 'nav',
  expand: false
};

var getExpandClass = function getExpandClass(expand) {
  if (expand === false) {
    return false;
  } else if (expand === true || expand === 'xs') {
    return 'navbar-expand';
  }

  return 'navbar-expand-' + expand;
};

// To better maintain backwards compatibility while toggleable is deprecated.
// We must map breakpoints to the next breakpoint so that toggleable and expand do the same things at the same breakpoint.
var toggleableToExpand = {
  xs: 'sm',
  sm: 'md',
  md: 'lg',
  lg: 'xl'
};

var getToggleableClass = function getToggleableClass(toggleable) {
  if (toggleable === undefined || toggleable === 'xl') {
    return false;
  } else if (toggleable === false) {
    return 'navbar-expand';
  }

  return 'navbar-expand-' + (toggleable === true ? 'sm' : toggleableToExpand[toggleable] || toggleable);
};

var Navbar = function Navbar(props) {
  var _classNames;

  var toggleable = props.toggleable,
      expand = props.expand,
      className = props.className,
      cssModule = props.cssModule,
      light = props.light,
      dark = props.dark,
      inverse = props.inverse,
      fixed = props.fixed,
      sticky = props.sticky,
      color = props.color,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['toggleable', 'expand', 'className', 'cssModule', 'light', 'dark', 'inverse', 'fixed', 'sticky', 'color', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar', getExpandClass(expand) || getToggleableClass(toggleable), (_classNames = {
    'navbar-light': light,
    'navbar-dark': inverse || dark
  }, defineProperty(_classNames, 'bg-' + color, color), defineProperty(_classNames, 'fixed-' + fixed, fixed), defineProperty(_classNames, 'sticky-' + sticky, sticky), _classNames)), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Navbar.propTypes = propTypes$3;
Navbar.defaultProps = defaultProps$3;

var propTypes$4 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$4 = {
  tag: 'a'
};

var NavbarBrand = function NavbarBrand(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar-brand'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

NavbarBrand.propTypes = propTypes$4;
NavbarBrand.defaultProps = defaultProps$4;

var propTypes$5 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var defaultProps$5 = {
  tag: 'button',
  type: 'button'
};

var NavbarToggler = function NavbarToggler(props) {
  var className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'children', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'navbar-toggler'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    _extends({}, attributes, { className: classes }),
    children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: mapToCssModules('navbar-toggler-icon', cssModule) })
  );
};

NavbarToggler.propTypes = propTypes$5;
NavbarToggler.defaultProps = defaultProps$5;

var propTypes$6 = {
  tabs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  pills: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  horizontal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  justified: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  fill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  navbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  card: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$6 = {
  tag: 'ul',
  vertical: false
};

var getVerticalClass = function getVerticalClass(vertical) {
  if (vertical === false) {
    return false;
  } else if (vertical === true || vertical === 'xs') {
    return 'flex-column';
  }

  return 'flex-' + vertical + '-column';
};

var Nav = function Nav(props) {
  var className = props.className,
      cssModule = props.cssModule,
      tabs = props.tabs,
      pills = props.pills,
      vertical = props.vertical,
      horizontal = props.horizontal,
      justified = props.justified,
      fill = props.fill,
      navbar = props.navbar,
      card = props.card,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tabs', 'pills', 'vertical', 'horizontal', 'justified', 'fill', 'navbar', 'card', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, navbar ? 'navbar-nav' : 'nav', horizontal ? 'justify-content-' + horizontal : false, getVerticalClass(vertical), {
    'nav-tabs': tabs,
    'card-header-tabs': card && tabs,
    'nav-pills': pills,
    'card-header-pills': card && pills,
    'nav-justified': justified,
    'nav-fill': fill
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Nav.propTypes = propTypes$6;
Nav.defaultProps = defaultProps$6;

var propTypes$7 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$7 = {
  tag: 'li'
};

var NavItem = function NavItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      active = props.active,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'active', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'nav-item', active ? 'active' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

NavItem.propTypes = propTypes$7;
NavItem.defaultProps = defaultProps$7;

/* eslint react/no-find-dom-node: 0 */
// https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-find-dom-node.md

var propTypes$8 = {
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dropup: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "direction" with the value "up".'),
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['up', 'down', 'left', 'right']),
  group: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  nav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append'])]),
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  inNavbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$8 = {
  isOpen: false,
  direction: 'down',
  nav: false,
  active: false,
  addonType: false,
  inNavbar: false
};

var childContextTypes = {
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['up', 'down', 'left', 'right']).isRequired,
  inNavbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var Dropdown = function (_React$Component) {
  inherits(Dropdown, _React$Component);

  function Dropdown(props) {
    classCallCheck(this, Dropdown);

    var _this = possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));

    _this.addEvents = _this.addEvents.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.removeEvents = _this.removeEvents.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(Dropdown, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        toggle: this.props.toggle,
        isOpen: this.props.isOpen,
        direction: this.props.direction === 'down' && this.props.dropup ? 'up' : this.props.direction,
        inNavbar: this.props.inNavbar
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpen !== prevProps.isOpen) {
        this.handleProps();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeEvents();
    }
  }, {
    key: 'getContainer',
    value: function getContainer() {
      return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
    }
  }, {
    key: 'addEvents',
    value: function addEvents() {
      var _this2 = this;

      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.addEventListener(event, _this2.handleDocumentClick, true);
      });
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      var _this3 = this;

      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      if (e && (e.which === 3 || e.type === 'keyup' && e.which !== keyCodes.tab)) return;
      var container = this.getContainer();

      if (container.contains(e.target) && container !== e.target && (e.type !== 'keyup' || e.which === keyCodes.tab)) {
        return;
      }

      this.toggle(e);
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(e) {
      if ([keyCodes.esc, keyCodes.up, keyCodes.down, keyCodes.space].indexOf(e.which) === -1 || /button/i.test(e.target.tagName) && e.which === keyCodes.space || /input|textarea/i.test(e.target.tagName)) {
        return;
      }

      e.preventDefault();
      if (this.props.disabled) return;

      var container = this.getContainer();

      if (e.which === keyCodes.space && this.props.isOpen && container !== e.target) {
        e.target.click();
      }

      if (e.which === keyCodes.esc || !this.props.isOpen) {
        this.toggle(e);
        container.querySelector('[aria-expanded]').focus();
        return;
      }

      var menuClass = mapToCssModules('dropdown-menu', this.props.cssModule);
      var itemClass = mapToCssModules('dropdown-item', this.props.cssModule);
      var disabledClass = mapToCssModules('disabled', this.props.cssModule);

      var items = container.querySelectorAll('.' + menuClass + ' .' + itemClass + ':not(.' + disabledClass + ')');

      if (!items.length) return;

      var index = -1;
      for (var i = 0; i < items.length; i += 1) {
        if (items[i] === e.target) {
          index = i;
          break;
        }
      }

      if (e.which === keyCodes.up && index > 0) {
        index -= 1;
      }

      if (e.which === keyCodes.down && index < items.length - 1) {
        index += 1;
      }

      if (index < 0) {
        index = 0;
      }

      items[index].focus();
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.isOpen) {
        this.addEvents();
      } else {
        this.removeEvents();
      }
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _omit = omit(this.props, ['toggle', 'disabled', 'inNavbar', 'direction']),
          className = _omit.className,
          cssModule = _omit.cssModule,
          dropup = _omit.dropup,
          isOpen = _omit.isOpen,
          group = _omit.group,
          size = _omit.size,
          nav = _omit.nav,
          active = _omit.active,
          addonType = _omit.addonType,
          attrs = objectWithoutProperties(_omit, ['className', 'cssModule', 'dropup', 'isOpen', 'group', 'size', 'nav', 'active', 'addonType']);

      var direction = this.props.direction === 'down' && dropup ? 'up' : this.props.direction;

      attrs.tag = attrs.tag || (nav ? 'li' : 'div');

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, direction !== 'down' && 'drop' + direction, nav && active ? 'active' : false, (_classNames = {}, defineProperty(_classNames, 'input-group-' + addonType, addonType), defineProperty(_classNames, 'btn-group', group), defineProperty(_classNames, 'btn-group-' + size, !!size), defineProperty(_classNames, 'dropdown', !group && !addonType), defineProperty(_classNames, 'show', isOpen), defineProperty(_classNames, 'nav-item', nav), _classNames)), cssModule);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_popper__["Manager"], _extends({}, attrs, { className: classes, onKeyDown: this.handleKeyDown }));
    }
  }]);
  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Dropdown.propTypes = propTypes$8;
Dropdown.defaultProps = defaultProps$8;
Dropdown.childContextTypes = childContextTypes;

function NavDropdown(props) {
  warnOnce('The "NavDropdown" component has been deprecated.\nPlease use component "Dropdown" with nav prop.');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, _extends({ nav: true }, props));
}

var propTypes$9 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$9 = {
  tag: 'a'
};

var NavLink = function (_React$Component) {
  inherits(NavLink, _React$Component);

  function NavLink(props) {
    classCallCheck(this, NavLink);

    var _this = possibleConstructorReturn(this, (NavLink.__proto__ || Object.getPrototypeOf(NavLink)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(NavLink, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.href === '#') {
        e.preventDefault();
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          active = _props.active,
          Tag = _props.tag,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['className', 'cssModule', 'active', 'tag', 'innerRef']);


      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'nav-link', {
        disabled: attributes.disabled,
        active: active
      }), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, onClick: this.onClick, className: classes }));
    }
  }]);
  return NavLink;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

NavLink.propTypes = propTypes$9;
NavLink.defaultProps = defaultProps$9;

var propTypes$10 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$10 = {
  tag: 'ol'
};

var Breadcrumb = function Breadcrumb(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'breadcrumb'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Breadcrumb.propTypes = propTypes$10;
Breadcrumb.defaultProps = defaultProps$10;

var propTypes$11 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$11 = {
  tag: 'li'
};

var BreadcrumbItem = function BreadcrumbItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      active = props.active,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'active', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, active ? 'active' : false, 'breadcrumb-item'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

BreadcrumbItem.propTypes = propTypes$11;
BreadcrumbItem.defaultProps = defaultProps$11;

var propTypes$12 = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  outline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$12 = {
  color: 'secondary',
  tag: 'button'
};

var Button = function (_React$Component) {
  inherits(Button, _React$Component);

  function Button(props) {
    classCallCheck(this, Button);

    var _this = possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(Button, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          block = _props.block,
          className = _props.className,
          cssModule = _props.cssModule,
          color = _props.color,
          outline = _props.outline,
          size = _props.size,
          Tag = _props.tag,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['active', 'block', 'className', 'cssModule', 'color', 'outline', 'size', 'tag', 'innerRef']);


      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'btn', 'btn' + (outline ? '-outline' : '') + '-' + color, size ? 'btn-' + size : false, block ? 'btn-block' : false, { active: active, disabled: this.props.disabled }), cssModule);

      if (attributes.href && Tag === 'button') {
        Tag = 'a';
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
        type: Tag === 'button' && attributes.onClick ? 'button' : undefined
      }, attributes, {
        className: classes,
        ref: innerRef,
        onClick: this.onClick
      }));
    }
  }]);
  return Button;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Button.propTypes = propTypes$12;
Button.defaultProps = defaultProps$12;

var propTypes$13 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var ButtonDropdown = function ButtonDropdown(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, _extends({ group: true }, props));
};

ButtonDropdown.propTypes = propTypes$13;

var propTypes$14 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$13 = {
  tag: 'div',
  role: 'group'
};

var ButtonGroup = function ButtonGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      vertical = props.vertical,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'size', 'vertical', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, size ? 'btn-group-' + size : false, vertical ? 'btn-group-vertical' : 'btn-group'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ButtonGroup.propTypes = propTypes$14;
ButtonGroup.defaultProps = defaultProps$13;

var propTypes$15 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps$14 = {
  tag: 'div',
  role: 'toolbar'
};

var ButtonToolbar = function ButtonToolbar(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'btn-toolbar'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ButtonToolbar.propTypes = propTypes$15;
ButtonToolbar.defaultProps = defaultProps$14;

var propTypes$16 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  divider: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var contextTypes = {
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var defaultProps$15 = {
  tag: 'button',
  toggle: true
};

var DropdownItem = function (_React$Component) {
  inherits(DropdownItem, _React$Component);

  function DropdownItem(props) {
    classCallCheck(this, DropdownItem);

    var _this = possibleConstructorReturn(this, (DropdownItem.__proto__ || Object.getPrototypeOf(DropdownItem)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    _this.getTabIndex = _this.getTabIndex.bind(_this);
    return _this;
  }

  createClass(DropdownItem, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled || this.props.header || this.props.divider) {
        e.preventDefault();
        return;
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }

      if (this.props.toggle) {
        this.context.toggle(e);
      }
    }
  }, {
    key: 'getTabIndex',
    value: function getTabIndex() {
      if (this.props.disabled || this.props.header || this.props.divider) {
        return '-1';
      }

      return '0';
    }
  }, {
    key: 'render',
    value: function render() {
      var tabIndex = this.getTabIndex();

      var _omit = omit(this.props, ['toggle']),
          className = _omit.className,
          cssModule = _omit.cssModule,
          divider = _omit.divider,
          Tag = _omit.tag,
          header = _omit.header,
          active = _omit.active,
          props = objectWithoutProperties(_omit, ['className', 'cssModule', 'divider', 'tag', 'header', 'active']);

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
        disabled: props.disabled,
        'dropdown-item': !divider && !header,
        active: active,
        'dropdown-header': header,
        'dropdown-divider': divider
      }), cssModule);

      if (Tag === 'button') {
        if (header) {
          Tag = 'h6';
        } else if (divider) {
          Tag = 'div';
        } else if (props.href) {
          Tag = 'a';
        }
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
        type: Tag === 'button' && (props.onClick || this.props.toggle) ? 'button' : undefined
      }, props, {
        tabIndex: tabIndex,
        className: classes,
        onClick: this.onClick
      }));
    }
  }]);
  return DropdownItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DropdownItem.propTypes = propTypes$16;
DropdownItem.defaultProps = defaultProps$15;
DropdownItem.contextTypes = contextTypes;

var propTypes$17 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  flip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$16 = {
  tag: 'div',
  flip: true
};

var contextTypes$1 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['up', 'down', 'left', 'right']).isRequired,
  inNavbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var noFlipModifier = { flip: { enabled: false } };

var directionPositionMap = {
  up: 'top',
  left: 'left',
  right: 'right',
  down: 'bottom'
};

var DropdownMenu = function DropdownMenu(props, context) {
  var className = props.className,
      cssModule = props.cssModule,
      right = props.right,
      tag = props.tag,
      flip = props.flip,
      attrs = objectWithoutProperties(props, ['className', 'cssModule', 'right', 'tag', 'flip']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'dropdown-menu', {
    'dropdown-menu-right': right,
    show: context.isOpen
  }), cssModule);

  var Tag = tag;

  if (context.isOpen && !context.inNavbar) {
    Tag = __WEBPACK_IMPORTED_MODULE_6_react_popper__["Popper"];

    var position1 = directionPositionMap[context.direction] || 'bottom';
    var position2 = right ? 'end' : 'start';
    attrs.placement = position1 + '-' + position2;
    attrs.component = tag;
    attrs.modifiers = !flip ? noFlipModifier : undefined;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
    tabIndex: '-1',
    role: 'menu'
  }, attrs, {
    'aria-hidden': !context.isOpen,
    className: classes
  }));
};

DropdownMenu.propTypes = propTypes$17;
DropdownMenu.defaultProps = defaultProps$16;
DropdownMenu.contextTypes = contextTypes$1;

var propTypes$18 = {
  caret: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  'aria-haspopup': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  split: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  nav: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$17 = {
  'aria-haspopup': true,
  color: 'secondary'
};

var contextTypes$2 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  inNavbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};

var DropdownToggle = function (_React$Component) {
  inherits(DropdownToggle, _React$Component);

  function DropdownToggle(props) {
    classCallCheck(this, DropdownToggle);

    var _this = possibleConstructorReturn(this, (DropdownToggle.__proto__ || Object.getPrototypeOf(DropdownToggle)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  createClass(DropdownToggle, [{
    key: 'onClick',
    value: function onClick(e) {
      if (this.props.disabled) {
        e.preventDefault();
        return;
      }

      if (this.props.nav && !this.props.tag) {
        e.preventDefault();
      }

      if (this.props.onClick) {
        this.props.onClick(e);
      }

      this.context.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          color = _props.color,
          cssModule = _props.cssModule,
          caret = _props.caret,
          split = _props.split,
          nav = _props.nav,
          tag = _props.tag,
          props = objectWithoutProperties(_props, ['className', 'color', 'cssModule', 'caret', 'split', 'nav', 'tag']);

      var ariaLabel = props['aria-label'] || 'Toggle Dropdown';
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
        'dropdown-toggle': caret || split,
        'dropdown-toggle-split': split,
        'nav-link': nav
      }), cssModule);
      var children = props.children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        ariaLabel
      );

      var Tag = void 0;

      if (nav && !tag) {
        Tag = 'a';
        props.href = '#';
      } else if (!tag) {
        Tag = Button;
        props.color = color;
        props.cssModule = cssModule;
      } else {
        Tag = tag;
      }

      if (this.context.inNavbar) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, props, {
          className: classes,
          onClick: this.onClick,
          'aria-expanded': this.context.isOpen,
          children: children
        }));
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_popper__["Target"], _extends({}, props, {
        className: classes,
        component: Tag,
        onClick: this.onClick,
        'aria-expanded': this.context.isOpen,
        children: children
      }));
    }
  }]);
  return DropdownToggle;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

DropdownToggle.propTypes = propTypes$18;
DropdownToggle.defaultProps = defaultProps$17;
DropdownToggle.contextTypes = contextTypes$2;

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var PropTypes$1 = createCommonjsModule(function (module, exports) {
  'use strict';

  exports.__esModule = true;
  exports.classNamesShape = exports.timeoutsShape = undefined;
  exports.transitionTimeout = transitionTimeout;

  var _propTypes2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function transitionTimeout(transitionType) {
    var timeoutPropName = 'transition' + transitionType + 'Timeout';
    var enabledPropName = 'transition' + transitionType;

    return function (props) {
      // If the transition is enabled
      if (props[enabledPropName]) {
        // If no timeout duration is provided
        if (props[timeoutPropName] == null) {
          return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

          // If the duration isn't a number
        } else if (typeof props[timeoutPropName] !== 'number') {
          return new Error(timeoutPropName + ' must be a number (in milliseconds)');
        }
      }

      return null;
    };
  }

  var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
    enter: _propTypes2.default.number,
    exit: _propTypes2.default.number
  }).isRequired]);

  var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    enter: _propTypes2.default.string,
    exit: _propTypes2.default.string,
    active: _propTypes2.default.string
  }), _propTypes2.default.shape({
    enter: _propTypes2.default.string,
    enterActive: _propTypes2.default.string,
    exit: _propTypes2.default.string,
    exitActive: _propTypes2.default.string
  })]);
});

unwrapExports(PropTypes$1);

var Transition_1 = createCommonjsModule(function (module, exports) {
  'use strict';

  exports.__esModule = true;
  exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

  var PropTypes$$1 = _interopRequireWildcard(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a);

  var _react2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_0_react___default.a);

  var _reactDom2 = _interopRequireDefault(__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }newObj.default = obj;return newObj;
    }
  }

  function _objectWithoutProperties(obj, keys) {
    var target = {};for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
    }return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
  var EXITED = exports.EXITED = 'exited';
  var ENTERING = exports.ENTERING = 'entering';
  var ENTERED = exports.ENTERED = 'entered';
  var EXITING = exports.EXITING = 'exiting';

  /**
   * The Transition component lets you describe a transition from one component
   * state to another _over time_ with a simple declarative API. Most commonly
   * it's used to animate the mounting and unmounting of a component, but can also
   * be used to describe in-place transition states as well.
   *
   * By default the `Transition` component does not alter the behavior of the
   * component it renders, it only tracks "enter" and "exit" states for the components.
   * It's up to you to give meaning and effect to those states. For example we can
   * add styles to a component when it enters or exits:
   *
   * ```jsx
   * import Transition from 'react-transition-group/Transition';
   *
   * const duration = 300;
   *
   * const defaultStyle = {
   *   transition: `opacity ${duration}ms ease-in-out`,
   *   opacity: 0,
   * }
   *
   * const transitionStyles = {
   *   entering: { opacity: 0 },
   *   entered:  { opacity: 1 },
   * };
   *
   * const Fade = ({ in: inProp }) => (
   *   <Transition in={inProp} timeout={duration}>
   *     {(state) => (
   *       <div style={{
   *         ...defaultStyle,
   *         ...transitionStyles[state]
   *       }}>
   *         I'm A fade Transition!
   *       </div>
   *     )}
   *   </Transition>
   * );
   * ```
   *
   * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
   * What it does do is track transition states over time so you can update the
   * component (such as by adding styles or classes) when it changes states.
   *
   * There are 4 main states a Transition can be in:
   *  - `ENTERING`
   *  - `ENTERED`
   *  - `EXITING`
   *  - `EXITED`
   *
   * Transition state is toggled via the `in` prop. When `true` the component begins the
   * "Enter" stage. During this stage, the component will shift from its current transition state,
   * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
   * it's complete. Let's take the following example:
   *
   * ```jsx
   * state= { in: false };
   *
   * toggleEnterState = () => {
   *   this.setState({ in: true });
   * }
   *
   * render() {
   *   return (
   *     <div>
   *       <Transition in={this.state.in} timeout={500} />
   *       <button onClick={this.toggleEnterState}>Click to Enter</button>
   *     </div>
   *   );
   * }
   * ```
   *
   * When the button is clicked the component will shift to the `'entering'` state and
   * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
   *
   * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
   */

  var Transition = function (_React$Component) {
    _inherits(Transition, _React$Component);

    function Transition(props, context) {
      _classCallCheck(this, Transition);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

      var parentGroup = context.transitionGroup;
      // In the context of a TransitionGroup all enters are really appears
      var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

      var initialStatus = void 0;
      _this.nextStatus = null;

      if (props.in) {
        if (appear) {
          initialStatus = EXITED;
          _this.nextStatus = ENTERING;
        } else {
          initialStatus = ENTERED;
        }
      } else {
        if (props.unmountOnExit || props.mountOnEnter) {
          initialStatus = UNMOUNTED;
        } else {
          initialStatus = EXITED;
        }
      }

      _this.state = { status: initialStatus };

      _this.nextCallback = null;
      return _this;
    }

    Transition.prototype.getChildContext = function getChildContext() {
      return { transitionGroup: null }; // allows for nested Transitions
    };

    Transition.prototype.componentDidMount = function componentDidMount() {
      this.updateStatus(true);
    };

    Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _ref = this.pendingState || this.state,
          status = _ref.status;

      if (nextProps.in) {
        if (status === UNMOUNTED) {
          this.setState({ status: EXITED });
        }
        if (status !== ENTERING && status !== ENTERED) {
          this.nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          this.nextStatus = EXITING;
        }
      }
    };

    Transition.prototype.componentDidUpdate = function componentDidUpdate() {
      this.updateStatus();
    };

    Transition.prototype.componentWillUnmount = function componentWillUnmount() {
      this.cancelNextCallback();
    };

    Transition.prototype.getTimeouts = function getTimeouts() {
      var timeout = this.props.timeout;

      var exit = void 0,
          enter = void 0,
          appear = void 0;

      exit = enter = appear = timeout;

      if (timeout != null && typeof timeout !== 'number') {
        exit = timeout.exit;
        enter = timeout.enter;
        appear = timeout.appear;
      }
      return { exit: exit, enter: enter, appear: appear };
    };

    Transition.prototype.updateStatus = function updateStatus() {
      var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var nextStatus = this.nextStatus;

      if (nextStatus !== null) {
        this.nextStatus = null;
        // nextStatus will always be ENTERING or EXITING.
        this.cancelNextCallback();
        var node = _reactDom2.default.findDOMNode(this);

        if (nextStatus === ENTERING) {
          this.performEnter(node, mounting);
        } else {
          this.performExit(node);
        }
      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
        this.setState({ status: UNMOUNTED });
      }
    };

    Transition.prototype.performEnter = function performEnter(node, mounting) {
      var _this2 = this;

      var enter = this.props.enter;

      var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

      var timeouts = this.getTimeouts();

      // no enter animation skip right to ENTERED
      // if we are mounting and running this it means appear _must_ be set
      if (!mounting && !enter) {
        this.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node);
        });
        return;
      }

      this.props.onEnter(node, appearing);

      this.safeSetState({ status: ENTERING }, function () {
        _this2.props.onEntering(node, appearing);

        // FIXME: appear timeout?
        _this2.onTransitionEnd(node, timeouts.enter, function () {
          _this2.safeSetState({ status: ENTERED }, function () {
            _this2.props.onEntered(node, appearing);
          });
        });
      });
    };

    Transition.prototype.performExit = function performExit(node) {
      var _this3 = this;

      var exit = this.props.exit;

      var timeouts = this.getTimeouts();

      // no exit animation skip right to EXITED
      if (!exit) {
        this.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
        return;
      }
      this.props.onExit(node);

      this.safeSetState({ status: EXITING }, function () {
        _this3.props.onExiting(node);

        _this3.onTransitionEnd(node, timeouts.exit, function () {
          _this3.safeSetState({ status: EXITED }, function () {
            _this3.props.onExited(node);
          });
        });
      });
    };

    Transition.prototype.cancelNextCallback = function cancelNextCallback() {
      if (this.nextCallback !== null) {
        this.nextCallback.cancel();
        this.nextCallback = null;
      }
    };

    Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
      var _this4 = this;

      // We need to track pending updates for instances where a cWRP fires quickly
      // after cDM and before the state flushes, which would double trigger a
      // transition
      this.pendingState = nextState;

      // This shouldn't be necessary, but there are weird race conditions with
      // setState callbacks and unmounting in testing, so always make sure that
      // we can cancel any pending setState callbacks after we unmount.
      callback = this.setNextCallback(callback);
      this.setState(nextState, function () {
        _this4.pendingState = null;
        callback();
      });
    };

    Transition.prototype.setNextCallback = function setNextCallback(callback) {
      var _this5 = this;

      var active = true;

      this.nextCallback = function (event) {
        if (active) {
          active = false;
          _this5.nextCallback = null;

          callback(event);
        }
      };

      this.nextCallback.cancel = function () {
        active = false;
      };

      return this.nextCallback;
    };

    Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
      this.setNextCallback(handler);

      if (node) {
        if (this.props.addEndListener) {
          this.props.addEndListener(node, this.nextCallback);
        }
        if (timeout != null) {
          setTimeout(this.nextCallback, timeout);
        }
      } else {
        setTimeout(this.nextCallback, 0);
      }
    };

    Transition.prototype.render = function render() {
      var status = this.state.status;
      if (status === UNMOUNTED) {
        return null;
      }

      var _props = this.props,
          children = _props.children,
          childProps = _objectWithoutProperties(_props, ['children']);
      // filter props for Transtition


      delete childProps.in;
      delete childProps.mountOnEnter;
      delete childProps.unmountOnExit;
      delete childProps.appear;
      delete childProps.enter;
      delete childProps.exit;
      delete childProps.timeout;
      delete childProps.addEndListener;
      delete childProps.onEnter;
      delete childProps.onEntering;
      delete childProps.onEntered;
      delete childProps.onExit;
      delete childProps.onExiting;
      delete childProps.onExited;

      if (typeof children === 'function') {
        return children(status, childProps);
      }

      var child = _react2.default.Children.only(children);
      return _react2.default.cloneElement(child, childProps);
    };

    return Transition;
  }(_react2.default.Component);

  Transition.contextTypes = {
    transitionGroup: PropTypes$$1.object
  };
  Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
  };

  Transition.propTypes =  false ? {
    /**
     * A `function` child can be used instead of a React element.
     * This function is called with the current transition status
     * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
     * to apply context specific props to a component.
     *
     * ```jsx
     * <Transition timeout={150}>
     *   {(status) => (
     *     <MyComponent className={`fade fade-${status}`} />
     *   )}
     * </Transition>
     * ```
     */
    children: PropTypes$$1.oneOfType([PropTypes$$1.func.isRequired, PropTypes$$1.element.isRequired]).isRequired,

    /**
     * Show the component; triggers the enter or exit states
     */
    in: PropTypes$$1.bool,

    /**
     * By default the child component is mounted immediately along with
     * the parent `Transition` component. If you want to "lazy mount" the component on the
     * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
     * mounted, even on "exited", unless you also specify `unmountOnExit`.
     */
    mountOnEnter: PropTypes$$1.bool,

    /**
     * By default the child component stays mounted after it reaches the `'exited'` state.
     * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
     */
    unmountOnExit: PropTypes$$1.bool,

    /**
     * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
     * If you want to transition on the first mount set `appear` to `true`, and the
     * component will transition in as soon as the `<Transition>` mounts.
     *
     * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
     */
    appear: PropTypes$$1.bool,

    /**
     * Enable or disable enter transitions.
     */
    enter: PropTypes$$1.bool,

    /**
     * Enable or disable exit transitions.
     */
    exit: PropTypes$$1.bool,

    /**
     * The duration of the transition, in milliseconds.
     * Required unless `addEventListener` is provided
     *
     * You may specify a single timeout for all transitions like: `timeout={500}`,
     * or individually like:
     *
     * ```jsx
     * timeout={{
     *  enter: 300,
     *  exit: 500,
     * }}
     * ```
     *
     * @type {number | { enter?: number, exit?: number }}
     */
    timeout: function timeout(props) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var pt = PropTypes$1.timeoutsShape;
      if (!props.addEndListener) pt = pt.isRequired;
      return pt.apply(undefined, [props].concat(args));
    },

    /**
     * Add a custom transition end trigger. Called with the transitioning
     * DOM node and a `done` callback. Allows for more fine grained transition end
     * logic. **Note:** Timeouts are still used as a fallback if provided.
     *
     * ```jsx
     * addEndListener={(node, done) => {
     *   // use the css transitionend event to mark the finish of a transition
     *   node.addEventListener('transitionend', done, false);
     * }}
     * ```
     */
    addEndListener: PropTypes$$1.func,

    /**
     * Callback fired before the "entering" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool) -> void
     */
    onEnter: PropTypes$$1.func,

    /**
     * Callback fired after the "entering" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool)
     */
    onEntering: PropTypes$$1.func,

    /**
     * Callback fired after the "entered" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool) -> void
     */
    onEntered: PropTypes$$1.func,

    /**
     * Callback fired before the "exiting" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExit: PropTypes$$1.func,

    /**
     * Callback fired after the "exiting" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExiting: PropTypes$$1.func,

    /**
     * Callback fired after the "exited" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExited: PropTypes$$1.func
  } : {};

  // Name the function so it is clearer in the documentation
  function noop() {}

  Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,

    onEnter: noop,
    onEntering: noop,
    onEntered: noop,

    onExit: noop,
    onExiting: noop,
    onExited: noop
  };

  Transition.UNMOUNTED = 0;
  Transition.EXITED = 1;
  Transition.ENTERING = 2;
  Transition.ENTERED = 3;
  Transition.EXITING = 4;

  exports.default = Transition;
});

var Transition = unwrapExports(Transition_1);

var propTypes$19 = _extends({}, Transition.propTypes, {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  baseClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  baseClassActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
});

var defaultProps$18 = _extends({}, Transition.defaultProps, {
  tag: 'div',
  baseClass: 'fade',
  baseClassActive: 'show',
  timeout: TransitionTimeouts.Fade,
  appear: true,
  enter: true,
  exit: true,
  in: true
});

function Fade(props) {
  var Tag = props.tag,
      baseClass = props.baseClass,
      baseClassActive = props.baseClassActive,
      className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      otherProps = objectWithoutProperties(props, ['tag', 'baseClass', 'baseClassActive', 'className', 'cssModule', 'children']);

  // In NODE_ENV=production the Transition.propTypes are wrapped which results in an
  // empty object "{}". This is the result of the `react-transition-group` babel
  // configuration settings. Therefore, to ensure that production builds work without
  // error, we can either explicitly define keys or use the Transition.defaultProps.
  // Using the Transition.defaultProps excludes any required props. Thus, the best
  // solution is to explicitly define required props in our utilities and reference these.
  // This also gives us more flexibility in the future to remove the prop-types
  // dependency in distribution builds (Similar to how `react-transition-group` does).
  // Note: Without omitting the `react-transition-group` props, the resulting child
  // Tag component would inherit the Transition properties as attributes for the HTML
  // element which results in errors/warnings for non-valid attributes.

  var transitionProps = pick(otherProps, TransitionPropTypeKeys);
  var childProps = omit(otherProps, TransitionPropTypeKeys);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Transition,
    transitionProps,
    function (status) {
      var isActive = status === 'entered';
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, baseClass, isActive && baseClassActive), cssModule);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Tag,
        _extends({ className: classes }, childProps),
        children
      );
    }
  );
}

Fade.propTypes = propTypes$19;
Fade.defaultProps = defaultProps$18;

var propTypes$20 = {
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  pill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$19 = {
  color: 'secondary',
  pill: false,
  tag: 'span'
};

var Badge = function Badge(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      pill = props.pill,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'color', 'pill', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'badge', 'badge-' + color, pill ? 'badge-pill' : false), cssModule);

  if (attributes.href && Tag === 'span') {
    Tag = 'a';
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Badge.propTypes = propTypes$20;
Badge.defaultProps = defaultProps$19;

var propTypes$21 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  inverse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  block: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the props "body"'),
  body: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  outline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$20 = {
  tag: 'div'
};

var Card = function Card(props) {
  var className = props.className,
      cssModule = props.cssModule,
      color = props.color,
      block = props.block,
      body = props.body,
      inverse = props.inverse,
      outline = props.outline,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'color', 'block', 'body', 'inverse', 'outline', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card', inverse ? 'text-white' : false, block || body ? 'card-body' : false, color ? (outline ? 'border' : 'bg') + '-' + color : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Card.propTypes = propTypes$21;
Card.defaultProps = defaultProps$20;

var propTypes$22 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$21 = {
  tag: 'div'
};

var CardGroup = function CardGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-group'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardGroup.propTypes = propTypes$22;
CardGroup.defaultProps = defaultProps$21;

var propTypes$23 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$22 = {
  tag: 'div'
};

var CardDeck = function CardDeck(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-deck'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardDeck.propTypes = propTypes$23;
CardDeck.defaultProps = defaultProps$22;

var propTypes$24 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$23 = {
  tag: 'div'
};

var CardColumns = function CardColumns(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-columns'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardColumns.propTypes = propTypes$24;
CardColumns.defaultProps = defaultProps$23;

var propTypes$25 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$24 = {
  tag: 'div'
};

var CardBody = function CardBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-body'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardBody.propTypes = propTypes$25;
CardBody.defaultProps = defaultProps$24;

function CardBlock(props) {
  warnOnce('The "CardBlock" component has been deprecated.\nPlease use component "CardBody".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CardBody, props);
}

var propTypes$26 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$25 = {
  tag: 'a'
};

var CardLink = function CardLink(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      innerRef = props.innerRef,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'innerRef']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-link'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, className: classes }));
};

CardLink.propTypes = propTypes$26;
CardLink.defaultProps = defaultProps$25;

var propTypes$27 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$26 = {
  tag: 'div'
};

var CardFooter = function CardFooter(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-footer'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardFooter.propTypes = propTypes$27;
CardFooter.defaultProps = defaultProps$26;

var propTypes$28 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$27 = {
  tag: 'div'
};

var CardHeader = function CardHeader(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-header'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardHeader.propTypes = propTypes$28;
CardHeader.defaultProps = defaultProps$27;

var propTypes$29 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$28 = {
  tag: 'img'
};

var CardImg = function CardImg(props) {
  var className = props.className,
      cssModule = props.cssModule,
      top = props.top,
      bottom = props.bottom,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'top', 'bottom', 'tag']);


  var cardImgClassName = 'card-img';
  if (top) {
    cardImgClassName = 'card-img-top';
  }
  if (bottom) {
    cardImgClassName = 'card-img-bottom';
  }

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, cardImgClassName), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardImg.propTypes = propTypes$29;
CardImg.defaultProps = defaultProps$28;

var propTypes$30 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$29 = {
  tag: 'div'
};

var CardImgOverlay = function CardImgOverlay(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-img-overlay'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardImgOverlay.propTypes = propTypes$30;
CardImgOverlay.defaultProps = defaultProps$29;

var CarouselItem = function (_React$Component) {
  inherits(CarouselItem, _React$Component);

  function CarouselItem(props) {
    classCallCheck(this, CarouselItem);

    var _this = possibleConstructorReturn(this, (CarouselItem.__proto__ || Object.getPrototypeOf(CarouselItem)).call(this, props));

    _this.state = {
      startAnimation: false
    };

    _this.onEnter = _this.onEnter.bind(_this);
    _this.onEntering = _this.onEntering.bind(_this);
    _this.onExit = _this.onExit.bind(_this);
    _this.onExiting = _this.onExiting.bind(_this);
    _this.onExited = _this.onExited.bind(_this);
    return _this;
  }

  createClass(CarouselItem, [{
    key: 'onEnter',
    value: function onEnter(node, isAppearing) {
      this.setState({ startAnimation: false });
      this.props.onEnter(node, isAppearing);
    }
  }, {
    key: 'onEntering',
    value: function onEntering(node, isAppearing) {
      // getting this variable triggers a reflow
      var offsetHeight = node.offsetHeight;
      this.setState({ startAnimation: true });
      this.props.onEntering(node, isAppearing);
      return offsetHeight;
    }
  }, {
    key: 'onExit',
    value: function onExit(node) {
      this.setState({ startAnimation: false });
      this.props.onExit(node);
    }
  }, {
    key: 'onExiting',
    value: function onExiting(node) {
      this.setState({ startAnimation: true });
      node.dispatchEvent(new CustomEvent('slide.bs.carousel'));
      this.props.onExiting(node);
    }
  }, {
    key: 'onExited',
    value: function onExited(node) {
      node.dispatchEvent(new CustomEvent('slid.bs.carousel'));
      this.props.onExited(node);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          isIn = _props.in,
          children = _props.children,
          cssModule = _props.cssModule,
          slide = _props.slide,
          Tag = _props.tag,
          className = _props.className,
          transitionProps = objectWithoutProperties(_props, ['in', 'children', 'cssModule', 'slide', 'tag', 'className']);


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Transition,
        _extends({}, transitionProps, {
          enter: slide,
          exit: slide,
          'in': isIn,
          onEnter: this.onEnter,
          onEntering: this.onEntering,
          onExit: this.onExit,
          onExiting: this.onExiting,
          onExited: this.onExited
        }),
        function (status) {
          var direction = _this2.context.direction;

          var isActive = status === TransitionStatuses.ENTERED || status === TransitionStatuses.EXITING;
          var directionClassName = (status === TransitionStatuses.ENTERING || status === TransitionStatuses.EXITING) && _this2.state.startAnimation && (direction === 'right' ? 'carousel-item-left' : 'carousel-item-right');
          var orderClassName = status === TransitionStatuses.ENTERING && (direction === 'right' ? 'carousel-item-next' : 'carousel-item-prev');
          var itemClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-item', isActive && 'active', directionClassName, orderClassName), cssModule);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            Tag,
            { className: itemClasses },
            children
          );
        }
      );
    }
  }]);
  return CarouselItem;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

CarouselItem.propTypes = _extends({}, Transition.propTypes, {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  in: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  slide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
});

CarouselItem.defaultProps = _extends({}, Transition.defaultProps, {
  tag: 'div',
  timeout: TransitionTimeouts.Carousel,
  slide: true
});

CarouselItem.contextTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var Carousel = function (_React$Component) {
  inherits(Carousel, _React$Component);

  function Carousel(props) {
    classCallCheck(this, Carousel);

    var _this = possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
    _this.renderItems = _this.renderItems.bind(_this);
    _this.hoverStart = _this.hoverStart.bind(_this);
    _this.hoverEnd = _this.hoverEnd.bind(_this);
    _this.state = {
      direction: 'right',
      indicatorClicked: false
    };
    return _this;
  }

  createClass(Carousel, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { direction: this.state.direction };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Set up the cycle
      if (this.props.ride === 'carousel') {
        this.setInterval();
      }

      // TODO: move this to the specific carousel like bootstrap. Currently it will trigger ALL carousels on the page.
      document.addEventListener('keyup', this.handleKeyPress);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setInterval(nextProps);
      // Calculate the direction to turn
      if (this.props.activeIndex + 1 === nextProps.activeIndex) {
        this.setState({ direction: 'right' });
      } else if (this.props.activeIndex - 1 === nextProps.activeIndex) {
        this.setState({ direction: 'left' });
      } else if (this.props.activeIndex > nextProps.activeIndex) {
        this.setState({ direction: this.state.indicatorClicked ? 'left' : 'right' });
      } else if (this.props.activeIndex !== nextProps.activeIndex) {
        this.setState({ direction: this.state.indicatorClicked ? 'right' : 'left' });
      }
      this.setState({ indicatorClicked: false });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearInterval();
      document.removeEventListener('keyup', this.handleKeyPress);
    }
  }, {
    key: 'setInterval',
    value: function (_setInterval) {
      function setInterval() {
        return _setInterval.apply(this, arguments);
      }

      setInterval.toString = function () {
        return _setInterval.toString();
      };

      return setInterval;
    }(function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      // make sure not to have multiple intervals going...
      this.clearInterval();
      if (props.interval) {
        this.cycleInterval = setInterval(function () {
          props.next();
        }, parseInt(props.interval, 10));
      }
    })
  }, {
    key: 'clearInterval',
    value: function (_clearInterval) {
      function clearInterval() {
        return _clearInterval.apply(this, arguments);
      }

      clearInterval.toString = function () {
        return _clearInterval.toString();
      };

      return clearInterval;
    }(function () {
      clearInterval(this.cycleInterval);
    })
  }, {
    key: 'hoverStart',
    value: function hoverStart() {
      if (this.props.pause === 'hover') {
        this.clearInterval();
      }
      if (this.props.mouseEnter) {
        var _props;

        (_props = this.props).mouseEnter.apply(_props, arguments);
      }
    }
  }, {
    key: 'hoverEnd',
    value: function hoverEnd() {
      if (this.props.pause === 'hover') {
        this.setInterval();
      }
      if (this.props.mouseLeave) {
        var _props2;

        (_props2 = this.props).mouseLeave.apply(_props2, arguments);
      }
    }
  }, {
    key: 'handleKeyPress',
    value: function handleKeyPress(evt) {
      if (this.props.keyboard) {
        if (evt.keyCode === 37) {
          this.props.previous();
        } else if (evt.keyCode === 39) {
          this.props.next();
        }
      }
    }
  }, {
    key: 'renderItems',
    value: function renderItems(carouselItems, className) {
      var _this2 = this;

      var slide = this.props.slide;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { role: 'listbox', className: className },
        carouselItems.map(function (item, index) {
          var isIn = index === _this2.props.activeIndex;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(item, {
            in: isIn,
            slide: slide
          });
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          children = _props3.children,
          cssModule = _props3.cssModule,
          slide = _props3.slide,
          className = _props3.className;

      var outerClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel', slide && 'slide'), cssModule);

      var innerClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('carousel-inner'), cssModule);

      var slidesOnly = children.every(function (child) {
        return child.type === CarouselItem;
      });

      // Rendering only slides
      if (slidesOnly) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: outerClasses, onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd },
          this.renderItems(children, innerClasses)
        );
      }

      // Rendering slides and controls
      if (children[0] instanceof Array) {
        var _carouselItems = children[0];
        var _controlLeft = children[1];
        var _controlRight = children[2];

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: outerClasses, onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd },
          this.renderItems(_carouselItems, innerClasses),
          _controlLeft,
          _controlRight
        );
      }

      // Rendering indicators, slides and controls
      var indicators = children[0];
      var wrappedOnClick = function wrappedOnClick(e) {
        if (typeof indicators.props.onClickHandler === 'function') {
          _this3.setState({ indicatorClicked: true }, function () {
            return indicators.props.onClickHandler(e);
          });
        }
      };
      var wrappedIndicators = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(indicators, { onClickHandler: wrappedOnClick });
      var carouselItems = children[1];
      var controlLeft = children[2];
      var controlRight = children[3];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: outerClasses, onMouseEnter: this.hoverStart, onMouseLeave: this.hoverEnd },
        wrappedIndicators,
        this.renderItems(carouselItems, innerClasses),
        controlLeft,
        controlRight
      );
    }
  }]);
  return Carousel;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Carousel.propTypes = {
  // the current active slide of the carousel
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // a function which should advance the carousel to the next slide (via activeIndex)
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // a function which should advance the carousel to the previous slide (via activeIndex)
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // controls if the left and right arrow keys should control the carousel
  keyboard: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  /* If set to "hover", pauses the cycling of the carousel on mouseenter and resumes the cycling of the carousel on
   * mouseleave. If set to false, hovering over the carousel won't pause it. (default: "hover")
   */
  pause: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['hover', false]),
  // Autoplays the carousel after the user manually cycles the first item. If "carousel", autoplays the carousel on load.
  // This is how bootstrap defines it... I would prefer a bool named autoplay or something...
  ride: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['carousel']),
  // the interval at which the carousel automatically cycles (default: 5000)
  // eslint-disable-next-line react/no-unused-prop-types
  interval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  // called when the mouse enters the Carousel
  mouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // called when the mouse exits the Carousel
  mouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // controls whether the slide animation on the Carousel works or not
  slide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

Carousel.defaultProps = {
  interval: 5000,
  pause: 'hover',
  keyboard: true,
  slide: true
};

Carousel.childContextTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var CarouselControl = function CarouselControl(props) {
  var direction = props.direction,
      onClickHandler = props.onClickHandler,
      cssModule = props.cssModule,
      directionText = props.directionText,
      className = props.className;


  var anchorClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-control-' + direction), cssModule);

  var iconClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('carousel-control-' + direction + '-icon'), cssModule);

  var screenReaderClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('sr-only'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    {
      className: anchorClasses,
      role: 'button',
      tabIndex: '0',
      onClick: function onClick(e) {
        e.preventDefault();
        onClickHandler();
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: iconClasses, 'aria-hidden': 'true' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: screenReaderClasses },
      directionText || direction
    )
  );
};

CarouselControl.propTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prev', 'next']).isRequired,
  onClickHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  directionText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var CarouselIndicators = function CarouselIndicators(props) {
  var items = props.items,
      activeIndex = props.activeIndex,
      cssModule = props.cssModule,
      onClickHandler = props.onClickHandler,
      className = props.className;


  var listClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-indicators'), cssModule);
  var indicators = items.map(function (item, idx) {
    var indicatorClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()({ active: activeIndex === idx }), cssModule);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', {
      key: '' + (item.key || item.src) + item.caption + item.altText,
      onClick: function onClick(e) {
        e.preventDefault();
        onClickHandler(idx);
      },
      className: indicatorClasses
    });
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'ol',
    { className: listClasses },
    indicators
  );
};

CarouselIndicators.propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onClickHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var CarouselCaption = function CarouselCaption(props) {
  var captionHeader = props.captionHeader,
      captionText = props.captionText,
      cssModule = props.cssModule,
      className = props.className;

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'carousel-caption', 'd-none', 'd-md-block'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: classes },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      captionHeader
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      captionText
    )
  );
};

CarouselCaption.propTypes = {
  captionHeader: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  captionText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var propTypes$31 = {
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  indicators: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  controls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoPlay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  activeIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  goToIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

var UncontrolledCarousel = function (_Component) {
  inherits(UncontrolledCarousel, _Component);

  function UncontrolledCarousel(props) {
    classCallCheck(this, UncontrolledCarousel);

    var _this = possibleConstructorReturn(this, (UncontrolledCarousel.__proto__ || Object.getPrototypeOf(UncontrolledCarousel)).call(this, props));

    _this.animating = false;
    _this.state = { activeIndex: 0 };
    _this.next = _this.next.bind(_this);
    _this.previous = _this.previous.bind(_this);
    _this.goToIndex = _this.goToIndex.bind(_this);
    _this.onExiting = _this.onExiting.bind(_this);
    _this.onExited = _this.onExited.bind(_this);
    return _this;
  }

  createClass(UncontrolledCarousel, [{
    key: 'onExiting',
    value: function onExiting() {
      this.animating = true;
    }
  }, {
    key: 'onExited',
    value: function onExited() {
      this.animating = false;
    }
  }, {
    key: 'next',
    value: function next() {
      if (this.animating) return;
      var nextIndex = this.state.activeIndex === this.props.items.length - 1 ? 0 : this.state.activeIndex + 1;
      this.setState({ activeIndex: nextIndex });
    }
  }, {
    key: 'previous',
    value: function previous() {
      if (this.animating) return;
      var nextIndex = this.state.activeIndex === 0 ? this.props.items.length - 1 : this.state.activeIndex - 1;
      this.setState({ activeIndex: nextIndex });
    }
  }, {
    key: 'goToIndex',
    value: function goToIndex(newIndex) {
      if (this.animating) return;
      this.setState({ activeIndex: newIndex });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          autoPlay = _props.autoPlay,
          indicators = _props.indicators,
          controls = _props.controls,
          items = _props.items,
          goToIndex = _props.goToIndex,
          props = objectWithoutProperties(_props, ['autoPlay', 'indicators', 'controls', 'items', 'goToIndex']);
      var activeIndex = this.state.activeIndex;


      var slides = items.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          CarouselItem,
          {
            onExiting: _this2.onExiting,
            onExited: _this2.onExited,
            key: item.src
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: item.src, alt: item.altText }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselCaption, { captionText: item.caption, captionHeader: item.caption })
        );
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Carousel,
        _extends({
          activeIndex: activeIndex,
          next: this.next,
          previous: this.previous,
          ride: autoPlay ? 'carousel' : undefined
        }, props),
        indicators && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselIndicators, {
          items: items,
          activeIndex: props.activeIndex || activeIndex,
          onClickHandler: goToIndex || this.goToIndex
        }),
        slides,
        controls && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselControl, {
          direction: 'prev',
          directionText: 'Previous',
          onClickHandler: props.previous || this.previous
        }),
        controls && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CarouselControl, {
          direction: 'next',
          directionText: 'Next',
          onClickHandler: props.next || this.next
        })
      );
    }
  }]);
  return UncontrolledCarousel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

UncontrolledCarousel.propTypes = propTypes$31;
UncontrolledCarousel.defaultProps = {
  controls: true,
  indicators: true,
  autoPlay: true
};

var propTypes$32 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$30 = {
  tag: 'h6'
};

var CardSubtitle = function CardSubtitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-subtitle'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardSubtitle.propTypes = propTypes$32;
CardSubtitle.defaultProps = defaultProps$30;

var propTypes$33 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$31 = {
  tag: 'p'
};

var CardText = function CardText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-text'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardText.propTypes = propTypes$33;
CardText.defaultProps = defaultProps$31;

var propTypes$34 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$32 = {
  tag: 'h5'
};

var CardTitle = function CardTitle(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'card-title'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

CardTitle.propTypes = propTypes$34;
CardTitle.defaultProps = defaultProps$32;

var propTypes$35 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hideArrow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  fallbackPlacement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),
  flip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired,
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$33 = {
  placement: 'auto',
  hideArrow: false,
  isOpen: false,
  offset: 0,
  fallbackPlacement: 'flip',
  flip: true,
  container: 'body',
  modifiers: {}
};

var childContextTypes$1 = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

var PopperContent = function (_React$Component) {
  inherits(PopperContent, _React$Component);

  function PopperContent(props) {
    classCallCheck(this, PopperContent);

    var _this = possibleConstructorReturn(this, (PopperContent.__proto__ || Object.getPrototypeOf(PopperContent)).call(this, props));

    _this.handlePlacementChange = _this.handlePlacementChange.bind(_this);
    _this.setTargetNode = _this.setTargetNode.bind(_this);
    _this.getTargetNode = _this.getTargetNode.bind(_this);
    _this.state = {};
    return _this;
  }

  createClass(PopperContent, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this.setTargetNode,
          getTargetNode: this.getTargetNode
        }
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isOpen !== prevProps.isOpen) {
        this.handleProps();
      } else if (this._element) {
        // rerender
        this.renderIntoSubtree();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.hide();
    }
  }, {
    key: 'setTargetNode',
    value: function setTargetNode(node) {
      this.targetNode = node;
    }
  }, {
    key: 'getTargetNode',
    value: function getTargetNode() {
      return this.targetNode;
    }
  }, {
    key: 'getContainerNode',
    value: function getContainerNode() {
      return getTarget(this.props.container);
    }
  }, {
    key: 'handlePlacementChange',
    value: function handlePlacementChange(data) {
      if (this.state.placement !== data.placement) {
        this.setState({ placement: data.placement });
      }
      return data;
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.container !== 'inline') {
        if (this.props.isOpen) {
          this.show();
        } else {
          this.hide();
        }
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (this._element) {
        this.getContainerNode().removeChild(this._element);
        __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unmountComponentAtNode(this._element);
        this._element = null;
      }
    }
  }, {
    key: 'show',
    value: function show() {
      this._element = document.createElement('div');
      this.getContainerNode().appendChild(this._element);
      this.renderIntoSubtree();
      if (this._element.childNodes && this._element.childNodes[0] && this._element.childNodes[0].focus) {
        this._element.childNodes[0].focus();
      }
    }
  }, {
    key: 'renderIntoSubtree',
    value: function renderIntoSubtree() {
      __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this.renderChildren(), this._element);
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var _props = this.props,
          cssModule = _props.cssModule,
          children = _props.children,
          isOpen = _props.isOpen,
          flip = _props.flip,
          target = _props.target,
          offset = _props.offset,
          fallbackPlacement = _props.fallbackPlacement,
          placementPrefix = _props.placementPrefix,
          hideArrow = _props.hideArrow,
          className = _props.className,
          tag = _props.tag,
          container = _props.container,
          modifiers = _props.modifiers,
          attrs = objectWithoutProperties(_props, ['cssModule', 'children', 'isOpen', 'flip', 'target', 'offset', 'fallbackPlacement', 'placementPrefix', 'hideArrow', 'className', 'tag', 'container', 'modifiers']);

      var arrowClassName = mapToCssModules('arrow', cssModule);
      var placement = (this.state.placement || attrs.placement).split('-')[0];
      var popperClassName = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, placementPrefix ? placementPrefix + '-' + placement : placement), this.props.cssModule);

      var extendedModifiers = _extends({
        offset: { offset: offset },
        flip: { enabled: flip, behavior: fallbackPlacement },
        update: {
          enabled: true,
          order: 950,
          fn: this.handlePlacementChange
        }
      }, modifiers);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_popper__["Popper"],
        _extends({ modifiers: extendedModifiers }, attrs, { component: tag, className: popperClassName }),
        children,
        !hideArrow && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_popper__["Arrow"], { className: arrowClassName })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      this.setTargetNode(getTarget(this.props.target));

      if (this.props.container === 'inline') {
        return this.props.isOpen ? this.renderChildren() : null;
      }

      return null;
    }
  }]);
  return PopperContent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PopperContent.propTypes = propTypes$35;
PopperContent.defaultProps = defaultProps$33;
PopperContent.childContextTypes = childContextTypes$1;

var PopperTargetHelper = function PopperTargetHelper(props, context) {
  context.popperManager.setTargetNode(getTarget(props.target));
  return null;
};

PopperTargetHelper.contextTypes = {
  popperManager: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

PopperTargetHelper.propTypes = {
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired
};

var propTypes$36 = {
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(PopperPlacements),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]),
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hideArrow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  innerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  delay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number }), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var DEFAULT_DELAYS = {
  show: 0,
  hide: 0
};

var defaultProps$34 = {
  isOpen: false,
  hideArrow: false,
  placement: 'right',
  placementPrefix: 'bs-popover',
  delay: DEFAULT_DELAYS,
  toggle: function toggle() {}
};

var Popover = function (_React$Component) {
  inherits(Popover, _React$Component);

  function Popover(props) {
    classCallCheck(this, Popover);

    var _this = possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).call(this, props));

    _this.addTargetEvents = _this.addTargetEvents.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.removeTargetEvents = _this.removeTargetEvents.bind(_this);
    _this.getRef = _this.getRef.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    _this.show = _this.show.bind(_this);
    _this.hide = _this.hide.bind(_this);
    return _this;
  }

  createClass(Popover, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._target = getTarget(this.props.target);
      this.handleProps();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.handleProps();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearShowTimeout();
      this.clearHideTimeout();
      this.removeTargetEvents();
    }
  }, {
    key: 'getRef',
    value: function getRef(ref) {
      this._popover = ref;
    }
  }, {
    key: 'getDelay',
    value: function getDelay(key) {
      var delay = this.props.delay;

      if ((typeof delay === 'undefined' ? 'undefined' : _typeof(delay)) === 'object') {
        return isNaN(delay[key]) ? DEFAULT_DELAYS[key] : delay[key];
      }
      return delay;
    }
  }, {
    key: 'handleProps',
    value: function handleProps() {
      if (this.props.isOpen) {
        this.show();
      } else {
        this.hide();
      }
    }
  }, {
    key: 'show',
    value: function show() {
      this.clearHideTimeout();
      this.addTargetEvents();
      if (!this.props.isOpen) {
        this.clearShowTimeout();
        this._showTimeout = setTimeout(this.toggle, this.getDelay('show'));
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.clearShowTimeout();
      this.removeTargetEvents();
      if (this.props.isOpen) {
        this.clearHideTimeout();
        this._hideTimeout = setTimeout(this.toggle, this.getDelay('hide'));
      }
    }
  }, {
    key: 'clearShowTimeout',
    value: function clearShowTimeout() {
      clearTimeout(this._showTimeout);
      this._showTimeout = undefined;
    }
  }, {
    key: 'clearHideTimeout',
    value: function clearHideTimeout() {
      clearTimeout(this._hideTimeout);
      this._hideTimeout = undefined;
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      if (e.target !== this._target && !this._target.contains(e.target) && e.target !== this._popover && !(this._popover && this._popover.contains(e.target))) {
        if (this._hideTimeout) {
          this.clearHideTimeout();
        }

        if (this.props.isOpen) {
          this.toggle(e);
        }
      }
    }
  }, {
    key: 'addTargetEvents',
    value: function addTargetEvents() {
      var _this2 = this;

      ['click', 'touchstart'].forEach(function (event) {
        return document.addEventListener(event, _this2.handleDocumentClick, true);
      });
    }
  }, {
    key: 'removeTargetEvents',
    value: function removeTargetEvents() {
      var _this3 = this;

      ['click', 'touchstart'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.isOpen) {
        return null;
      }

      var attributes = omit(this.props, Object.keys(propTypes$36));
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('popover-inner', this.props.innerClassName), this.props.cssModule);

      var popperClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('popover', 'show', this.props.className), this.props.cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        PopperContent,
        {
          className: popperClasses,
          target: this.props.target,
          isOpen: this.props.isOpen,
          hideArrow: this.props.hideArrow,
          placement: this.props.placement,
          placementPrefix: this.props.placementPrefix,
          container: this.props.container,
          modifiers: this.props.modifiers
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', _extends({}, attributes, { className: classes, ref: this.getRef }))
      );
    }
  }]);
  return Popover;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Popover.propTypes = propTypes$36;
Popover.defaultProps = defaultProps$34;

var propTypes$37 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$35 = {
  tag: 'h3'
};

var PopoverHeader = function PopoverHeader(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'popover-header'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PopoverHeader.propTypes = propTypes$37;
PopoverHeader.defaultProps = defaultProps$35;

function PopoverTitle(props) {
  warnOnce('The "PopoverTitle" component has been deprecated.\nPlease use component "PopoverHeader".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopoverHeader, props);
}

var propTypes$38 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$36 = {
  tag: 'div'
};

var PopoverBody = function PopoverBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'popover-body'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PopoverBody.propTypes = propTypes$38;
PopoverBody.defaultProps = defaultProps$36;

function PopoverContent(props) {
  warnOnce('The "PopoverContent" component has been deprecated.\nPlease use component "PopoverBody".');
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopoverBody, props);
}

var propTypes$39 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  bar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  multi: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  max: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  animated: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  barClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$37 = {
  tag: 'div',
  value: 0,
  max: 100
};

var Progress = function Progress(props) {
  var children = props.children,
      className = props.className,
      barClassName = props.barClassName,
      cssModule = props.cssModule,
      value = props.value,
      max = props.max,
      animated = props.animated,
      striped = props.striped,
      color = props.color,
      bar = props.bar,
      multi = props.multi,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['children', 'className', 'barClassName', 'cssModule', 'value', 'max', 'animated', 'striped', 'color', 'bar', 'multi', 'tag']);


  var percent = __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default()(value) / __WEBPACK_IMPORTED_MODULE_7_lodash_tonumber___default()(max) * 100;

  var progressClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'progress'), cssModule);

  var progressBarClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('progress-bar', bar ? className || barClassName : barClassName, animated ? 'progress-bar-animated' : null, color ? 'bg-' + color : null, striped || animated ? 'progress-bar-striped' : null), cssModule);

  var ProgressBar = multi ? children : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
    className: progressBarClasses,
    style: { width: percent + '%' },
    role: 'progressbar',
    'aria-valuenow': value,
    'aria-valuemin': '0',
    'aria-valuemax': max,
    children: children
  });

  if (bar) {
    return ProgressBar;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: progressClasses, children: ProgressBar }));
};

Progress.propTypes = propTypes$39;
Progress.defaultProps = defaultProps$37;

var propTypes$41 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var Portal = function (_React$Component) {
  inherits(Portal, _React$Component);

  function Portal() {
    classCallCheck(this, Portal);
    return possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  createClass(Portal, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!canUseDOM) {
        return null;
      }

      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }

      return __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.createPortal(this.props.children, this.props.node || this.defaultNode);
    }
  }]);
  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Portal.propTypes = propTypes$41;

function noop() {}

var FadePropTypes = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(Fade.propTypes);

var propTypes$40 = {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  centered: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  keyboard: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  labelledBy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backdrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['static'])]),
  onEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onExit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onOpened: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClosed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  wrapClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  modalClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  backdropClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  contentClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  external: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  fade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  zIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  backdropTransition: FadePropTypes,
  modalTransition: FadePropTypes
};

var propsToOmit = Object.keys(propTypes$40);

var defaultProps$38 = {
  isOpen: false,
  autoFocus: true,
  centered: false,
  role: 'dialog',
  backdrop: true,
  keyboard: true,
  zIndex: 1050,
  fade: true,
  onOpened: noop,
  onClosed: noop,
  modalTransition: {
    timeout: TransitionTimeouts.Modal
  },
  backdropTransition: {
    mountOnEnter: true,
    timeout: TransitionTimeouts.Fade // uses standard fade transition
  }
};

var Modal = function (_React$Component) {
  inherits(Modal, _React$Component);

  function Modal(props) {
    classCallCheck(this, Modal);

    var _this = possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this._element = null;
    _this._originalBodyPadding = null;
    _this.handleBackdropClick = _this.handleBackdropClick.bind(_this);
    _this.handleEscape = _this.handleEscape.bind(_this);
    _this.onOpened = _this.onOpened.bind(_this);
    _this.onClosed = _this.onClosed.bind(_this);

    _this.state = {
      isOpen: props.isOpen
    };

    if (props.isOpen) {
      _this.init();
    }
    return _this;
  }

  createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.onEnter) {
        this.props.onEnter();
      }

      if (this.state.isOpen && this.props.autoFocus) {
        this.setFocus();
      }

      this._isMounted = true;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isOpen && !this.props.isOpen) {
        this.setState({ isOpen: nextProps.isOpen });
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      if (nextState.isOpen && !this.state.isOpen) {
        this.init();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.autoFocus && this.state.isOpen && !prevState.isOpen) {
        this.setFocus();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.onExit) {
        this.props.onExit();
      }

      if (this.state.isOpen) {
        this.destroy();
      }

      this._isMounted = false;
    }
  }, {
    key: 'onOpened',
    value: function onOpened(node, isAppearing) {
      this.props.onOpened();
      (this.props.modalTransition.onEntered || noop)(node, isAppearing);
    }
  }, {
    key: 'onClosed',
    value: function onClosed(node) {
      // so all methods get called before it is unmounted
      this.props.onClosed();
      (this.props.modalTransition.onExited || noop)(node);
      this.destroy();

      if (this._isMounted) {
        this.setState({ isOpen: false });
      }
    }
  }, {
    key: 'setFocus',
    value: function setFocus() {
      if (this._dialog && this._dialog.parentNode && typeof this._dialog.parentNode.focus === 'function') {
        this._dialog.parentNode.focus();
      }
    }
  }, {
    key: 'handleBackdropClick',
    value: function handleBackdropClick(e) {
      e.stopPropagation();
      if (!this.props.isOpen || this.props.backdrop !== true) return;

      var container = this._dialog;

      if (e.target && !container.contains(e.target) && this.props.toggle) {
        this.props.toggle(e);
      }
    }
  }, {
    key: 'handleEscape',
    value: function handleEscape(e) {
      if (this.props.isOpen && this.props.keyboard && e.keyCode === 27 && this.props.toggle) {
        this.props.toggle(e);
      }
    }
  }, {
    key: 'init',
    value: function init() {
      this._element = document.createElement('div');
      this._element.setAttribute('tabindex', '-1');
      this._element.style.position = 'relative';
      this._element.style.zIndex = this.props.zIndex;
      this._originalBodyPadding = getOriginalBodyPadding();

      conditionallyUpdateScrollbar();

      document.body.appendChild(this._element);

      if (!this.bodyClassAdded) {
        document.body.className = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(document.body.className, mapToCssModules('modal-open', this.props.cssModule));
        this.bodyClassAdded = true;
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      if (this._element) {
        document.body.removeChild(this._element);
        this._element = null;
      }

      if (this.bodyClassAdded) {
        var modalOpenClassName = mapToCssModules('modal-open', this.props.cssModule);
        // Use regex to prevent matching `modal-open` as part of a different class, e.g. `my-modal-opened`
        var modalOpenClassNameRegex = new RegExp('(^| )' + modalOpenClassName + '( |$)');
        document.body.className = document.body.className.replace(modalOpenClassNameRegex, ' ').trim();
        this.bodyClassAdded = false;
      }

      setScrollbarWidth(this._originalBodyPadding);
    }
  }, {
    key: 'renderModalDialog',
    value: function renderModalDialog() {
      var _classNames,
          _this2 = this;

      var attributes = omit(this.props, propsToOmit);
      var dialogBaseClass = 'modal-dialog';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({}, attributes, {
          className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(dialogBaseClass, this.props.className, (_classNames = {}, defineProperty(_classNames, 'modal-' + this.props.size, this.props.size), defineProperty(_classNames, dialogBaseClass + '-centered', this.props.centered), _classNames)), this.props.cssModule),
          role: 'document',
          ref: function ref(c) {
            _this2._dialog = c;
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-content', this.props.contentClassName), this.props.cssModule)
          },
          this.props.children
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.isOpen) {
        var _props = this.props,
            wrapClassName = _props.wrapClassName,
            modalClassName = _props.modalClassName,
            backdropClassName = _props.backdropClassName,
            cssModule = _props.cssModule,
            isOpen = _props.isOpen,
            backdrop = _props.backdrop,
            role = _props.role,
            labelledBy = _props.labelledBy,
            external = _props.external;


        var modalAttributes = {
          onClick: this.handleBackdropClick,
          onKeyUp: this.handleEscape,
          style: { display: 'block' },
          'aria-labelledby': labelledBy,
          role: role,
          tabIndex: '-1'
        };

        var hasTransition = this.props.fade;
        var modalTransition = _extends({}, Fade.defaultProps, this.props.modalTransition, {
          baseClass: hasTransition ? this.props.modalTransition.baseClass : '',
          timeout: hasTransition ? this.props.modalTransition.timeout : 0
        });
        var backdropTransition = _extends({}, Fade.defaultProps, this.props.backdropTransition, {
          baseClass: hasTransition ? this.props.backdropTransition.baseClass : '',
          timeout: hasTransition ? this.props.backdropTransition.timeout : 0
        });

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Portal,
          { node: this._element },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: mapToCssModules(wrapClassName) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              Fade,
              _extends({}, modalAttributes, modalTransition, {
                'in': isOpen,
                onEntered: this.onOpened,
                onExited: this.onClosed,
                cssModule: cssModule,
                className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal', modalClassName), cssModule)
              }),
              external,
              this.renderModalDialog()
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Fade, _extends({}, backdropTransition, {
              'in': isOpen && !!backdrop,
              cssModule: cssModule,
              className: mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('modal-backdrop', backdropClassName), cssModule)
            }))
          )
        );
      }

      return null;
    }
  }]);
  return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Modal.propTypes = propTypes$40;
Modal.defaultProps = defaultProps$38;

var propTypes$42 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  wrapTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  closeAriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

var defaultProps$39 = {
  tag: 'h5',
  wrapTag: 'div',
  closeAriaLabel: 'Close'
};

var ModalHeader = function ModalHeader(props) {
  var closeButton = void 0;
  var className = props.className,
      cssModule = props.cssModule,
      children = props.children,
      toggle = props.toggle,
      Tag = props.tag,
      WrapTag = props.wrapTag,
      closeAriaLabel = props.closeAriaLabel,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'children', 'toggle', 'tag', 'wrapTag', 'closeAriaLabel']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-header'), cssModule);

  if (toggle) {
    closeButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      { type: 'button', onClick: toggle, className: mapToCssModules('close', cssModule), 'aria-label': closeAriaLabel },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { 'aria-hidden': 'true' },
        String.fromCharCode(215)
      )
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    WrapTag,
    _extends({}, attributes, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      { className: mapToCssModules('modal-title', cssModule) },
      children
    ),
    closeButton
  );
};

ModalHeader.propTypes = propTypes$42;
ModalHeader.defaultProps = defaultProps$39;

var propTypes$43 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$40 = {
  tag: 'div'
};

var ModalBody = function ModalBody(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-body'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ModalBody.propTypes = propTypes$43;
ModalBody.defaultProps = defaultProps$40;

var propTypes$44 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$41 = {
  tag: 'div'
};

var ModalFooter = function ModalFooter(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'modal-footer'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ModalFooter.propTypes = propTypes$44;
ModalFooter.defaultProps = defaultProps$41;

var propTypes$45 = {
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(PopperPlacements),
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]).isRequired,
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, DOMElement]),
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hideArrow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  innerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  autohide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  placementPrefix: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  delay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({ show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number }), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  modifiers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var DEFAULT_DELAYS$1 = {
  show: 0,
  hide: 250
};

var defaultProps$42 = {
  isOpen: false,
  hideArrow: false,
  placement: 'top',
  placementPrefix: 'bs-tooltip',
  delay: DEFAULT_DELAYS$1,
  autohide: true,
  toggle: function toggle() {}
};

var Tooltip = function (_React$Component) {
  inherits(Tooltip, _React$Component);

  function Tooltip(props) {
    classCallCheck(this, Tooltip);

    var _this = possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

    _this.addTargetEvents = _this.addTargetEvents.bind(_this);
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.removeTargetEvents = _this.removeTargetEvents.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    _this.onMouseOverTooltip = _this.onMouseOverTooltip.bind(_this);
    _this.onMouseLeaveTooltip = _this.onMouseLeaveTooltip.bind(_this);
    _this.onMouseOverTooltipContent = _this.onMouseOverTooltipContent.bind(_this);
    _this.onMouseLeaveTooltipContent = _this.onMouseLeaveTooltipContent.bind(_this);
    _this.show = _this.show.bind(_this);
    _this.hide = _this.hide.bind(_this);
    return _this;
  }

  createClass(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._target = getTarget(this.props.target);
      this.addTargetEvents();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeTargetEvents();
    }
  }, {
    key: 'onMouseOverTooltip',
    value: function onMouseOverTooltip() {
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }
      this._showTimeout = setTimeout(this.show, this.getDelay('show'));
    }
  }, {
    key: 'onMouseLeaveTooltip',
    value: function onMouseLeaveTooltip() {
      if (this._showTimeout) {
        this.clearShowTimeout();
      }
      this._hideTimeout = setTimeout(this.hide, this.getDelay('hide'));
    }
  }, {
    key: 'onMouseOverTooltipContent',
    value: function onMouseOverTooltipContent() {
      if (this.props.autohide) {
        return;
      }
      if (this._hideTimeout) {
        this.clearHideTimeout();
      }
    }
  }, {
    key: 'onMouseLeaveTooltipContent',
    value: function onMouseLeaveTooltipContent() {
      if (this.props.autohide) {
        return;
      }
      if (this._showTimeout) {
        this.clearShowTimeout();
      }
      this._hideTimeout = setTimeout(this.hide, this.getDelay('hide'));
    }
  }, {
    key: 'getDelay',
    value: function getDelay(key) {
      var delay = this.props.delay;

      if ((typeof delay === 'undefined' ? 'undefined' : _typeof(delay)) === 'object') {
        return isNaN(delay[key]) ? DEFAULT_DELAYS$1[key] : delay[key];
      }
      return delay;
    }
  }, {
    key: 'show',
    value: function show() {
      if (!this.props.isOpen) {
        this.clearShowTimeout();
        this.toggle();
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (this.props.isOpen) {
        this.clearHideTimeout();
        this.toggle();
      }
    }
  }, {
    key: 'clearShowTimeout',
    value: function clearShowTimeout() {
      clearTimeout(this._showTimeout);
      this._showTimeout = undefined;
    }
  }, {
    key: 'clearHideTimeout',
    value: function clearHideTimeout() {
      clearTimeout(this._hideTimeout);
      this._hideTimeout = undefined;
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(e) {
      if (e.target === this._target || this._target.contains(e.target)) {
        if (this._hideTimeout) {
          this.clearHideTimeout();
        }

        if (!this.props.isOpen) {
          this.toggle();
        }
      }
    }
  }, {
    key: 'addTargetEvents',
    value: function addTargetEvents() {
      var _this2 = this;

      this._target.addEventListener('mouseover', this.onMouseOverTooltip, true);
      this._target.addEventListener('mouseout', this.onMouseLeaveTooltip, true);
      ['click', 'touchstart'].forEach(function (event) {
        return document.addEventListener(event, _this2.handleDocumentClick, true);
      });
    }
  }, {
    key: 'removeTargetEvents',
    value: function removeTargetEvents() {
      var _this3 = this;

      this._target.removeEventListener('mouseover', this.onMouseOverTooltip, true);
      this._target.removeEventListener('mouseout', this.onMouseLeaveTooltip, true);
      ['click', 'touchstart'].forEach(function (event) {
        return document.removeEventListener(event, _this3.handleDocumentClick, true);
      });
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      if (this.props.disabled) {
        return e && e.preventDefault();
      }

      return this.props.toggle();
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.isOpen) {
        return null;
      }

      var attributes = omit(this.props, Object.keys(propTypes$45));
      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tooltip-inner', this.props.innerClassName), this.props.cssModule);

      var popperClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tooltip', 'show', this.props.className), this.props.cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        PopperContent,
        {
          className: popperClasses,
          target: this.props.target,
          isOpen: this.props.isOpen,
          hideArrow: this.props.hideArrow,
          placement: this.props.placement,
          placementPrefix: this.props.placementPrefix,
          container: this.props.container,
          modifiers: this.props.modifiers
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', _extends({}, attributes, {
          className: classes,
          onMouseOver: this.onMouseOverTooltipContent,
          onMouseLeave: this.onMouseLeaveTooltipContent
        }))
      );
    }
  }]);
  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Tooltip.propTypes = propTypes$45;
Tooltip.defaultProps = defaultProps$42;

var propTypes$46 = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bordered: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inverse: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "dark"'),
  dark: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hover: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  responsive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  responsiveTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$43 = {
  tag: 'table',
  responsiveTag: 'div'
};

var Table = function Table(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      bordered = props.bordered,
      striped = props.striped,
      inverse = props.inverse,
      dark = props.dark,
      hover = props.hover,
      responsive = props.responsive,
      Tag = props.tag,
      ResponsiveTag = props.responsiveTag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'size', 'bordered', 'striped', 'inverse', 'dark', 'hover', 'responsive', 'tag', 'responsiveTag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'table', size ? 'table-' + size : false, bordered ? 'table-bordered' : false, striped ? 'table-striped' : false, dark || inverse ? 'table-dark' : false, hover ? 'table-hover' : false), cssModule);

  var table = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));

  if (responsive) {
    var responsiveClassName = responsive === true ? 'table-responsive' : 'table-responsive-' + responsive;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ResponsiveTag,
      { className: responsiveClassName },
      table
    );
  }

  return table;
};

Table.propTypes = propTypes$46;
Table.defaultProps = defaultProps$43;

var propTypes$47 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  flush: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$44 = {
  tag: 'ul'
};

var ListGroup = function ListGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      flush = props.flush,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'flush']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group', flush ? 'list-group-flush' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroup.propTypes = propTypes$47;
ListGroup.defaultProps = defaultProps$44;

var propTypes$48 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$45 = {
  tag: 'form'
};

var Form = function Form(props) {
  var className = props.className,
      cssModule = props.cssModule,
      inline = props.inline,
      Tag = props.tag,
      innerRef = props.innerRef,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'inline', 'tag', 'innerRef']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, inline ? 'form-inline' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, className: classes }));
};

Form.propTypes = propTypes$48;
Form.defaultProps = defaultProps$45;

var propTypes$49 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  valid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var defaultProps$46 = {
  tag: 'div',
  valid: undefined
};

var FormFeedback = function FormFeedback(props) {
  var className = props.className,
      cssModule = props.cssModule,
      valid = props.valid,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'valid', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, valid ? 'valid-feedback' : 'invalid-feedback'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormFeedback.propTypes = propTypes$49;
FormFeedback.defaultProps = defaultProps$46;

var propTypes$50 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  row: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  check: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$47 = {
  tag: 'div'
};

var FormGroup = function FormGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      row = props.row,
      disabled = props.disabled,
      check = props.check,
      inline = props.inline,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'row', 'disabled', 'check', 'inline', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, row ? 'row' : false, check ? 'form-check' : 'form-group', check && inline ? 'form-check-inline' : false, check && disabled ? 'disabled' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormGroup.propTypes = propTypes$50;
FormGroup.defaultProps = defaultProps$47;

var propTypes$51 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  inline: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$48 = {
  tag: 'small',
  color: 'muted'
};

var FormText = function FormText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      inline = props.inline,
      color = props.color,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'inline', 'color', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, !inline ? 'form-text' : false, color ? 'text-' + color : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

FormText.propTypes = propTypes$51;
FormText.defaultProps = defaultProps$48;

/* eslint react/prefer-stateless-function: 0 */

var propTypes$52 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  state: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, 'Please use the props "valid" and "invalid" to indicate the state.'),
  valid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  invalid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  static: deprecated(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, 'Please use the prop "plaintext"'),
  plaintext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  addon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$49 = {
  type: 'text'
};

var Input = function (_React$Component) {
  inherits(Input, _React$Component);

  function Input() {
    classCallCheck(this, Input);
    return possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
  }

  createClass(Input, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          type = _props.type,
          bsSize = _props.bsSize,
          state = _props.state,
          valid = _props.valid,
          invalid = _props.invalid,
          tag = _props.tag,
          addon = _props.addon,
          staticInput = _props.static,
          plaintext = _props.plaintext,
          innerRef = _props.innerRef,
          attributes = objectWithoutProperties(_props, ['className', 'cssModule', 'type', 'bsSize', 'state', 'valid', 'invalid', 'tag', 'addon', 'static', 'plaintext', 'innerRef']);


      var checkInput = ['radio', 'checkbox'].indexOf(type) > -1;
      var isNotaNumber = new RegExp('\\D', 'g');

      var fileInput = type === 'file';
      var textareaInput = type === 'textarea';
      var selectInput = type === 'select';
      var Tag = tag || (selectInput || textareaInput ? type : 'input');

      var formControlClass = 'form-control';

      if (plaintext || staticInput) {
        formControlClass = formControlClass + '-plaintext';
        Tag = tag || 'p';
      } else if (fileInput) {
        formControlClass = formControlClass + '-file';
      } else if (checkInput) {
        if (addon) {
          formControlClass = null;
        } else {
          formControlClass = 'form-check-input';
        }
      }

      if (state && typeof valid === 'undefined' && typeof invalid === 'undefined') {
        if (state === 'danger') {
          invalid = true;
        } else if (state === 'success') {
          valid = true;
        }
      }

      if (attributes.size && isNotaNumber.test(attributes.size)) {
        warnOnce('Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.');
        bsSize = attributes.size;
        delete attributes.size;
      }

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, invalid && 'is-invalid', valid && 'is-valid', bsSize ? 'form-control-' + bsSize : false, formControlClass), cssModule);

      if (Tag === 'input' || typeof tag !== 'string') {
        attributes.type = type;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { ref: innerRef, className: classes }));
    }
  }]);
  return Input;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Input.propTypes = propTypes$52;
Input.defaultProps = defaultProps$49;

var propTypes$53 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$50 = {
  tag: 'div'
};

var InputGroup = function InputGroup(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      size = props.size,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'size']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group', size ? 'input-group-' + size : null), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

InputGroup.propTypes = propTypes$53;
InputGroup.defaultProps = defaultProps$50;

var propTypes$55 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$52 = {
  tag: 'span'
};

var InputGroupText = function InputGroupText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group-text'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

InputGroupText.propTypes = propTypes$55;
InputGroupText.defaultProps = defaultProps$52;

var propTypes$54 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$51 = {
  tag: 'div'
};

var InputGroupAddon = function InputGroupAddon(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      addonType = props.addonType,
      children = props.children,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'addonType', 'children']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'input-group-' + addonType), cssModule);

  // Convenience to assist with transition
  if (typeof children === 'string') {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Tag,
      _extends({}, attributes, { className: classes }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputGroupText, { children: children })
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes, children: children }));
};

InputGroupAddon.propTypes = propTypes$54;
InputGroupAddon.defaultProps = defaultProps$51;

var propTypes$56 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  groupClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  groupAttributes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var InputGroupButton = function InputGroupButton(props) {
  warnOnce('The "InputGroupButton" component has been deprecated.\nPlease use component "InputGroupAddon".');

  var children = props.children,
      groupClassName = props.groupClassName,
      groupAttributes = props.groupAttributes,
      propsWithoutGroup = objectWithoutProperties(props, ['children', 'groupClassName', 'groupAttributes']);


  if (typeof children === 'string') {
    var cssModule = propsWithoutGroup.cssModule,
        tag = propsWithoutGroup.tag,
        addonType = propsWithoutGroup.addonType,
        attributes = objectWithoutProperties(propsWithoutGroup, ['cssModule', 'tag', 'addonType']);


    var allGroupAttributes = _extends({}, groupAttributes, {
      cssModule: cssModule,
      tag: tag,
      addonType: addonType
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      InputGroupAddon,
      _extends({}, allGroupAttributes, { className: groupClassName }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button, _extends({}, attributes, { children: children }))
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputGroupAddon, _extends({}, props, { children: children }));
};

InputGroupButton.propTypes = propTypes$56;

var propTypes$57 = {
  addonType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['prepend', 'append']).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

var InputGroupButtonDropdown = function InputGroupButtonDropdown(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, props);
};

InputGroupButtonDropdown.propTypes = propTypes$57;

var colWidths$1 = ['xs', 'sm', 'md', 'lg', 'xl'];

var stringOrNumberProp$1 = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]);

var columnProps$1 = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  size: stringOrNumberProp$1,
  push: deprecated(stringOrNumberProp$1, 'Please use the prop "order"'),
  pull: deprecated(stringOrNumberProp$1, 'Please use the prop "order"'),
  order: stringOrNumberProp$1,
  offset: stringOrNumberProp$1
})]);

var propTypes$58 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  hidden: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  check: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  for: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  xs: columnProps$1,
  sm: columnProps$1,
  md: columnProps$1,
  lg: columnProps$1,
  xl: columnProps$1,
  widths: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
};

var defaultProps$53 = {
  tag: 'label',
  widths: colWidths$1
};

var getColumnSizeClass$1 = function getColumnSizeClass(isXs, colWidth, colSize) {
  if (colSize === true || colSize === '') {
    return isXs ? 'col' : 'col-' + colWidth;
  } else if (colSize === 'auto') {
    return isXs ? 'col-auto' : 'col-' + colWidth + '-auto';
  }

  return isXs ? 'col-' + colSize : 'col-' + colWidth + '-' + colSize;
};

var Label = function Label(props) {
  var className = props.className,
      cssModule = props.cssModule,
      hidden = props.hidden,
      widths = props.widths,
      Tag = props.tag,
      check = props.check,
      size = props.size,
      htmlFor = props.for,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'hidden', 'widths', 'tag', 'check', 'size', 'for']);


  var colClasses = [];

  widths.forEach(function (colWidth, i) {
    var columnProp = props[colWidth];

    delete attributes[colWidth];

    if (!columnProp && columnProp !== '') {
      return;
    }

    var isXs = !i;
    var colClass = void 0;

    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isobject___default()(columnProp)) {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : '-' + colWidth + '-';
      colClass = getColumnSizeClass$1(isXs, colWidth, columnProp.size);

      colClasses.push(mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, defineProperty(_classNames, colClass, columnProp.size || columnProp.size === ''), defineProperty(_classNames, 'order' + colSizeInterfix + columnProp.order, columnProp.order || columnProp.order === 0), defineProperty(_classNames, 'offset' + colSizeInterfix + columnProp.offset, columnProp.offset || columnProp.offset === 0), _classNames))), cssModule);
    } else {
      colClass = getColumnSizeClass$1(isXs, colWidth, columnProp);
      colClasses.push(colClass);
    }
  });

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, hidden ? 'sr-only' : false, check ? 'form-check-label' : false, size ? 'col-form-label-' + size : false, colClasses, colClasses.length ? 'col-form-label' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({ htmlFor: htmlFor }, attributes, { className: classes }));
};

Label.propTypes = propTypes$58;
Label.defaultProps = defaultProps$53;

var propTypes$59 = {
  body: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  heading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  list: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  middle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  object: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

var Media = function Media(props) {
  var body = props.body,
      bottom = props.bottom,
      className = props.className,
      cssModule = props.cssModule,
      heading = props.heading,
      left = props.left,
      list = props.list,
      middle = props.middle,
      object = props.object,
      right = props.right,
      tag = props.tag,
      top = props.top,
      attributes = objectWithoutProperties(props, ['body', 'bottom', 'className', 'cssModule', 'heading', 'left', 'list', 'middle', 'object', 'right', 'tag', 'top']);


  var defaultTag = void 0;
  if (heading) {
    defaultTag = 'h4';
  } else if (left || right) {
    defaultTag = 'a';
  } else if (object) {
    defaultTag = 'img';
  } else if (list) {
    defaultTag = 'ul';
  } else {
    defaultTag = 'div';
  }
  var Tag = tag || defaultTag;

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, {
    'media-body': body,
    'media-heading': heading,
    'media-left': left,
    'media-right': right,
    'media-top': top,
    'media-bottom': bottom,
    'media-middle': middle,
    'media-object': object,
    'media-list': list,
    media: !body && !heading && !left && !right && !top && !bottom && !middle && !object && !list
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Media.propTypes = propTypes$59;

var propTypes$60 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$54 = {
  tag: 'ul'
};

var Pagination = function Pagination(props) {
  var className = props.className,
      cssModule = props.cssModule,
      size = props.size,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'size', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'pagination', defineProperty({}, 'pagination-' + size, !!size)), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Pagination.propTypes = propTypes$60;
Pagination.defaultProps = defaultProps$54;

var propTypes$61 = {
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$55 = {
  tag: 'li'
};

var PaginationItem = function PaginationItem(props) {
  var active = props.active,
      className = props.className,
      cssModule = props.cssModule,
      disabled = props.disabled,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['active', 'className', 'cssModule', 'disabled', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'page-item', {
    active: active,
    disabled: disabled
  }), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

PaginationItem.propTypes = propTypes$61;
PaginationItem.defaultProps = defaultProps$55;

var propTypes$62 = {
  'aria-label': __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  previous: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

var defaultProps$56 = {
  tag: 'a'
};

var PaginationLink = function PaginationLink(props) {
  var className = props.className,
      cssModule = props.cssModule,
      next = props.next,
      previous = props.previous,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'next', 'previous', 'tag']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'page-link'), cssModule);

  var defaultAriaLabel = void 0;
  if (previous) {
    defaultAriaLabel = 'Previous';
  } else if (next) {
    defaultAriaLabel = 'Next';
  }
  var ariaLabel = props['aria-label'] || defaultAriaLabel;

  var defaultCaret = void 0;
  if (previous) {
    defaultCaret = '\xAB';
  } else if (next) {
    defaultCaret = '\xBB';
  }

  var children = props.children;
  if (children && Array.isArray(children) && children.length === 0) {
    children = null;
  }

  if (previous || next) {
    children = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      {
        'aria-hidden': 'true',
        key: 'caret'
      },
      children || defaultCaret
    ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      {
        className: 'sr-only',
        key: 'sr'
      },
      ariaLabel
    )];
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Tag,
    _extends({}, attributes, {
      className: classes,
      'aria-label': ariaLabel
    }),
    children
  );
};

PaginationLink.propTypes = propTypes$62;
PaginationLink.defaultProps = defaultProps$56;

var propTypes$63 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  activeTab: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$57 = {
  tag: 'div'
};

var childContextTypes$2 = {
  activeTabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var TabContent = function (_Component) {
  inherits(TabContent, _Component);

  function TabContent(props) {
    classCallCheck(this, TabContent);

    var _this = possibleConstructorReturn(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).call(this, props));

    _this.state = {
      activeTab: _this.props.activeTab
    };
    return _this;
  }

  createClass(TabContent, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        activeTabId: this.state.activeTab
      };
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.activeTab !== nextProps.activeTab) {
        this.setState({
          activeTab: nextProps.activeTab
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          cssModule = _props.cssModule,
          Tag = _props.tag;


      var attributes = omit(this.props, Object.keys(propTypes$63));

      var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tab-content', className), cssModule);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
    }
  }]);
  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

TabContent.propTypes = propTypes$63;
TabContent.defaultProps = defaultProps$57;
TabContent.childContextTypes = childContextTypes$2;

var propTypes$64 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  tabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

var defaultProps$58 = {
  tag: 'div'
};

var contextTypes$3 = {
  activeTabId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

function TabPane(props, context) {
  var className = props.className,
      cssModule = props.cssModule,
      tabId = props.tabId,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tabId', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('tab-pane', className, { active: tabId === context.activeTabId }), cssModule);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
}
TabPane.propTypes = propTypes$64;
TabPane.defaultProps = defaultProps$58;
TabPane.contextTypes = contextTypes$3;

var propTypes$65 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  fluid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$59 = {
  tag: 'div'
};

var Jumbotron = function Jumbotron(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      fluid = props.fluid,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'fluid']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'jumbotron', fluid ? 'jumbotron-fluid' : false), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

Jumbotron.propTypes = propTypes$65;
Jumbotron.defaultProps = defaultProps$59;

var propTypes$66 = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  closeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  closeAriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  toggle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  transition: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(Fade.propTypes)
};

var defaultProps$60 = {
  color: 'success',
  isOpen: true,
  tag: 'div',
  closeAriaLabel: 'Close',
  transition: _extends({}, Fade.defaultProps, {
    unmountOnExit: true
  })
};

function Alert(props) {
  var className = props.className,
      closeClassName = props.closeClassName,
      closeAriaLabel = props.closeAriaLabel,
      cssModule = props.cssModule,
      Tag = props.tag,
      color = props.color,
      isOpen = props.isOpen,
      toggle = props.toggle,
      children = props.children,
      transition = props.transition,
      attributes = objectWithoutProperties(props, ['className', 'closeClassName', 'closeAriaLabel', 'cssModule', 'tag', 'color', 'isOpen', 'toggle', 'children', 'transition']);


  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'alert', 'alert-' + color, { 'alert-dismissible': toggle }), cssModule);

  var closeClasses = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()('close', closeClassName), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Fade,
    _extends({}, attributes, transition, { tag: Tag, className: classes, 'in': isOpen, role: 'alert' }),
    toggle ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      { type: 'button', className: closeClasses, 'aria-label': closeAriaLabel, onClick: toggle },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { 'aria-hidden': 'true' },
        '\xD7'
      )
    ) : null,
    children
  );
}

Alert.propTypes = propTypes$66;
Alert.defaultProps = defaultProps$60;

var _transitionStatusToCl;

var propTypes$67 = _extends({}, Transition.propTypes, {
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  navbar: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
});

var defaultProps$61 = _extends({}, Transition.defaultProps, {
  isOpen: false,
  appear: false,
  enter: true,
  exit: true,
  tag: 'div',
  timeout: TransitionTimeouts.Collapse
});

var transitionStatusToClassHash = (_transitionStatusToCl = {}, defineProperty(_transitionStatusToCl, TransitionStatuses.ENTERING, 'collapsing'), defineProperty(_transitionStatusToCl, TransitionStatuses.ENTERED, 'collapse show'), defineProperty(_transitionStatusToCl, TransitionStatuses.EXITING, 'collapsing'), defineProperty(_transitionStatusToCl, TransitionStatuses.EXITED, 'collapse'), _transitionStatusToCl);

function getTransitionClass(status) {
  return transitionStatusToClassHash[status] || 'collapse';
}

function getHeight(node) {
  return node.scrollHeight;
}

var Collapse = function (_Component) {
  inherits(Collapse, _Component);

  function Collapse(props) {
    classCallCheck(this, Collapse);

    var _this = possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));

    _this.state = {
      height: null
    };

    ['onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'].forEach(function (name) {
      _this[name] = _this[name].bind(_this);
    });
    return _this;
  }

  createClass(Collapse, [{
    key: 'onEntering',
    value: function onEntering(node, isAppearing) {
      this.setState({ height: getHeight(node) });
      this.props.onEntering(node, isAppearing);
    }
  }, {
    key: 'onEntered',
    value: function onEntered(node, isAppearing) {
      this.setState({ height: null });
      this.props.onEntered(node, isAppearing);
    }
  }, {
    key: 'onExit',
    value: function onExit(node) {
      this.setState({ height: getHeight(node) });
      this.props.onExit(node);
    }
  }, {
    key: 'onExiting',
    value: function onExiting(node) {
      // getting this variable triggers a reflow
      var _unused = node.offsetHeight; // eslint-disable-line no-unused-vars
      this.setState({ height: 0 });
      this.props.onExiting(node);
    }
  }, {
    key: 'onExited',
    value: function onExited(node) {
      this.setState({ height: null });
      this.props.onExited(node);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          Tag = _props.tag,
          isOpen = _props.isOpen,
          className = _props.className,
          navbar = _props.navbar,
          cssModule = _props.cssModule,
          children = _props.children,
          otherProps = objectWithoutProperties(_props, ['tag', 'isOpen', 'className', 'navbar', 'cssModule', 'children']);
      var height = this.state.height;

      // In NODE_ENV=production the Transition.propTypes are wrapped which results in an
      // empty object "{}". This is the result of the `react-transition-group` babel
      // configuration settings. Therefore, to ensure that production builds work without
      // error, we can either explicitly define keys or use the Transition.defaultProps.
      // Using the Transition.defaultProps excludes any required props. Thus, the best
      // solution is to explicitly define required props in our utilities and reference these.
      // This also gives us more flexibility in the future to remove the prop-types
      // dependency in distribution builds (Similar to how `react-transition-group` does).
      // Note: Without omitting the `react-transition-group` props, the resulting child
      // Tag component would inherit the Transition properties as attributes for the HTML
      // element which results in errors/warnings for non-valid attributes.

      var transitionProps = pick(otherProps, TransitionPropTypeKeys);
      var childProps = omit(otherProps, TransitionPropTypeKeys);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Transition,
        _extends({}, transitionProps, {
          'in': isOpen,
          onEntering: this.onEntering,
          onEntered: this.onEntered,
          onExit: this.onExit,
          onExiting: this.onExiting,
          onExited: this.onExited
        }),
        function (status) {
          var collapseClass = getTransitionClass(status);
          var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, collapseClass, navbar && 'navbar-collapse'), cssModule);
          var style = height === null ? null : { height: height };
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            Tag,
            _extends({}, childProps, {
              style: _extends({}, childProps.style, style),
              className: classes
            }),
            children
          );
        }
      );
    }
  }]);
  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Collapse.propTypes = propTypes$67;
Collapse.defaultProps = defaultProps$61;

var propTypes$68 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  active: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  action: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$62 = {
  tag: 'li'
};

var handleDisabledOnClick = function handleDisabledOnClick(e) {
  e.preventDefault();
};

var ListGroupItem = function ListGroupItem(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      active = props.active,
      disabled = props.disabled,
      action = props.action,
      color = props.color,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag', 'active', 'disabled', 'action', 'color']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, active ? 'active' : false, disabled ? 'disabled' : false, action ? 'list-group-item-action' : false, color ? 'list-group-item-' + color : false, 'list-group-item'), cssModule);

  // Prevent click event when disabled.
  if (disabled) {
    attributes.onClick = handleDisabledOnClick;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItem.propTypes = propTypes$68;
ListGroupItem.defaultProps = defaultProps$62;

var propTypes$69 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$63 = {
  tag: 'h5'
};

var ListGroupItemHeading = function ListGroupItemHeading(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group-item-heading'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItemHeading.propTypes = propTypes$69;
ListGroupItemHeading.defaultProps = defaultProps$63;

var propTypes$70 = {
  tag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  cssModule: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

var defaultProps$64 = {
  tag: 'p'
};

var ListGroupItemText = function ListGroupItemText(props) {
  var className = props.className,
      cssModule = props.cssModule,
      Tag = props.tag,
      attributes = objectWithoutProperties(props, ['className', 'cssModule', 'tag']);

  var classes = mapToCssModules(__WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, 'list-group-item-text'), cssModule);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({}, attributes, { className: classes }));
};

ListGroupItemText.propTypes = propTypes$70;
ListGroupItemText.defaultProps = defaultProps$64;

var UncontrolledAlert = function (_Component) {
  inherits(UncontrolledAlert, _Component);

  function UncontrolledAlert(props) {
    classCallCheck(this, UncontrolledAlert);

    var _this = possibleConstructorReturn(this, (UncontrolledAlert.__proto__ || Object.getPrototypeOf(UncontrolledAlert)).call(this, props));

    _this.state = { isOpen: true };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(UncontrolledAlert, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Alert, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
    }
  }]);
  return UncontrolledAlert;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var UncontrolledButtonDropdown = function (_Component) {
  inherits(UncontrolledButtonDropdown, _Component);

  function UncontrolledButtonDropdown(props) {
    classCallCheck(this, UncontrolledButtonDropdown);

    var _this = possibleConstructorReturn(this, (UncontrolledButtonDropdown.__proto__ || Object.getPrototypeOf(UncontrolledButtonDropdown)).call(this, props));

    _this.state = { isOpen: false };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(UncontrolledButtonDropdown, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonDropdown, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
    }
  }]);
  return UncontrolledButtonDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var UncontrolledDropdown = function (_Component) {
  inherits(UncontrolledDropdown, _Component);

  function UncontrolledDropdown(props) {
    classCallCheck(this, UncontrolledDropdown);

    var _this = possibleConstructorReturn(this, (UncontrolledDropdown.__proto__ || Object.getPrototypeOf(UncontrolledDropdown)).call(this, props));

    _this.state = { isOpen: false };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(UncontrolledDropdown, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dropdown, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
    }
  }]);
  return UncontrolledDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var UncontrolledNavDropdown = function UncontrolledNavDropdown(props) {
  warnOnce('The "UncontrolledNavDropdown" component has been deprecated.\nPlease use component "UncontrolledDropdown" with nav prop.');

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UncontrolledDropdown, _extends({ nav: true }, props));
};

var UncontrolledTooltip = function (_Component) {
  inherits(UncontrolledTooltip, _Component);

  function UncontrolledTooltip(props) {
    classCallCheck(this, UncontrolledTooltip);

    var _this = possibleConstructorReturn(this, (UncontrolledTooltip.__proto__ || Object.getPrototypeOf(UncontrolledTooltip)).call(this, props));

    _this.state = { isOpen: false };
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(UncontrolledTooltip, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tooltip, _extends({ isOpen: this.state.isOpen, toggle: this.toggle }, this.props));
    }
  }]);
  return UncontrolledTooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);


//# sourceMappingURL=reactstrap.es.js.map


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(24);
var createDesc = __webpack_require__(82);
module.exports = __webpack_require__(22) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var hide = __webpack_require__(40);
var has = __webpack_require__(44);
var SRC = __webpack_require__(83)('src');
var $toString = __webpack_require__(671);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(50).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var fails = __webpack_require__(13);
var defined = __webpack_require__(64);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(251)('wks');
var uid = __webpack_require__(173);
var Symbol = __webpack_require__(35).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 44 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(132);
var defined = __webpack_require__(64);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(133);
var createDesc = __webpack_require__(82);
var toIObject = __webpack_require__(45);
var toPrimitive = __webpack_require__(63);
var has = __webpack_require__(44);
var IE8_DOM_DEFINE = __webpack_require__(344);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(22) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(44);
var toObject = __webpack_require__(27);
var IE_PROTO = __webpack_require__(218)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 50 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.9' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(34);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(13);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(35);
var core = __webpack_require__(30);
var ctx = __webpack_require__(113);
var hide = __webpack_require__(94);
var has = __webpack_require__(95);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(387);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(388);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(905);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(909);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(388);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(532);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(538);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(320);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(539);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(541);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(543);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(545);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(321);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(196);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(547);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(549);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(551);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(552);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(553);
/* unused harmony reexport withRouter */





























/***/ }),
/* 60 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(589);

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(14);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(1);
var core = __webpack_require__(50);
var fails = __webpack_require__(13);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(51);
var IObject = __webpack_require__(132);
var toObject = __webpack_require__(27);
var toLength = __webpack_require__(21);
var asc = __webpack_require__(234);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(884), __esModule: true };

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x3, _x4, _x5) { var _again = true; _function: while (_again) { var object = _x3, property = _x4, receiver = _x5; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x3 = parent; _x4 = property; _x5 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(10);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _baseStyles = __webpack_require__(1074);

var _baseStyles2 = _interopRequireDefault(_baseStyles);

var _BurgerIcon = __webpack_require__(1075);

var _BurgerIcon2 = _interopRequireDefault(_BurgerIcon);

var _CrossIcon = __webpack_require__(1076);

var _CrossIcon2 = _interopRequireDefault(_CrossIcon);

exports['default'] = function (styles) {
  var Menu = (function (_Component) {
    _inherits(Menu, _Component);

    function Menu(props) {
      _classCallCheck(this, Menu);

      _get(Object.getPrototypeOf(Menu.prototype), 'constructor', this).call(this, props);
      this.state = {
        isOpen: false
      };

      if (!styles) {
        throw new Error('No styles supplied');
      }
    }

    _createClass(Menu, [{
      key: 'toggleMenu',
      value: function toggleMenu() {
        var _this = this;

        var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
        var isOpen = options.isOpen;
        var noStateChange = options.noStateChange;

        var newState = {
          isOpen: typeof isOpen !== 'undefined' ? isOpen : !this.state.isOpen
        };

        this.applyWrapperStyles();

        this.setState(newState, function () {
          !noStateChange && _this.props.onStateChange(newState);

          if (!_this.props.disableAutoFocus) {
            // For accessibility reasons, ensures that when we toggle open,
            // we focus the first menu item if one exists.
            if (newState.isOpen) {
              var firstItem = document.querySelector('.bm-item');
              if (firstItem) {
                firstItem.focus();
              }
            } else {
              if (document.activeElement) {
                document.activeElement.blur();
              } else {
                document.body.blur(); // Needed for IE
              }
            }
          }

          // Timeout ensures wrappers are cleared after animation finishes.
          _this.timeoutId && clearTimeout(_this.timeoutId);
          _this.timeoutId = setTimeout(function () {
            _this.timeoutId = null;
            if (!newState.isOpen) {
              _this.applyWrapperStyles(false);
            }
          }, 500);
        });
      }

      // Applies component-specific styles to external wrapper elements.
    }, {
      key: 'applyWrapperStyles',
      value: function applyWrapperStyles() {
        var set = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

        var applyClass = function applyClass(el, className) {
          return el.classList[set ? 'add' : 'remove'](className);
        };

        if (this.props.htmlClassName) {
          applyClass(document.querySelector('html'), this.props.htmlClassName);
        }
        if (this.props.bodyClassName) {
          applyClass(document.querySelector('body'), this.props.bodyClassName);
        }

        if (styles.pageWrap && this.props.pageWrapId) {
          this.handleExternalWrapper(this.props.pageWrapId, styles.pageWrap, set);
        }

        if (styles.outerContainer && this.props.outerContainerId) {
          this.handleExternalWrapper(this.props.outerContainerId, styles.outerContainer, set);
        }
      }

      // Sets or unsets styles on DOM elements outside the menu component.
      // This is necessary for correct page interaction with some of the menus.
      // Throws and returns if the required external elements don't exist,
      // which means any external page animations won't be applied.
    }, {
      key: 'handleExternalWrapper',
      value: function handleExternalWrapper(id, wrapperStyles, set) {
        var wrapper = document.getElementById(id);

        if (!wrapper) {
          console.error("Element with ID '" + id + "' not found");
          return;
        }

        var builtStyles = this.getStyle(wrapperStyles);

        for (var prop in builtStyles) {
          if (builtStyles.hasOwnProperty(prop)) {
            wrapper.style[prop] = set ? builtStyles[prop] : '';
          }
        }

        // Prevent any horizontal scroll.
        // Only set overflow-x as an inline style if htmlClassName or
        // bodyClassName is not passed in. Otherwise, it is up to the caller to
        // decide if they want to set the overflow style in CSS using the custom
        // class names.
        var applyOverflow = function applyOverflow(el) {
          return el.style['overflow-x'] = set ? 'hidden' : '';
        };
        if (!this.props.htmlClassName) {
          applyOverflow(document.querySelector('html'));
        }
        if (!this.props.bodyClassName) {
          applyOverflow(document.querySelector('body'));
        }
      }

      // Builds styles incrementally for a given element.
    }, {
      key: 'getStyles',
      value: function getStyles(el, index, inline) {
        var propName = 'bm' + el.replace(el.charAt(0), el.charAt(0).toUpperCase());

        // Set base styles.
        var output = _baseStyles2['default'][el] ? this.getStyle(_baseStyles2['default'][el]) : {};

        // Add animation-specific styles.
        if (styles[el]) {
          output = _extends({}, output, this.getStyle(styles[el], index + 1));
        }

        // Add custom styles.
        if (this.props.styles[propName]) {
          output = _extends({}, output, this.props.styles[propName]);
        }

        // Add element inline styles.
        if (inline) {
          output = _extends({}, output, inline);
        }

        return output;
      }
    }, {
      key: 'getStyle',
      value: function getStyle(style, index) {
        var width = this.props.width;

        var formattedWidth = typeof width !== 'string' ? width + 'px' : width;
        return style(this.state.isOpen, formattedWidth, this.props.right, index);
      }
    }, {
      key: 'listenForClose',
      value: function listenForClose(e) {
        e = e || window.event;

        // Close on ESC, unless disabled
        if (!this.props.disableCloseOnEsc && this.state.isOpen && (e.key === 'Escape' || e.keyCode === 27)) {
          this.toggleMenu();
        }
      }
    }, {
      key: 'shouldDisableOverlayClick',
      value: function shouldDisableOverlayClick() {
        if (typeof this.props.disableOverlayClick === 'function') {
          return this.props.disableOverlayClick();
        } else {
          return this.props.disableOverlayClick;
        }
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        // Bind ESC key handler (unless custom function supplied).
        if (this.props.customOnKeyDown) {
          window.onkeydown = this.props.customOnKeyDown;
        } else {
          window.onkeydown = this.listenForClose.bind(this);
        }

        // Allow initial open state to be set by props.
        if (this.props.isOpen) {
          this.toggleMenu({ isOpen: true, noStateChange: true });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.onkeydown = null;

        this.applyWrapperStyles(false);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        var _this2 = this;

        var wasToggled = typeof this.props.isOpen !== 'undefined' && this.props.isOpen !== this.state.isOpen && this.props.isOpen !== prevProps.isOpen;
        if (wasToggled) {
          this.toggleMenu();
          // Toggling changes SVG animation requirements, so we defer these until the next componentDidUpdate
          return;
        }

        if (styles.svg) {
          (function () {
            var morphShape = _reactDom2['default'].findDOMNode(_this2, 'bm-morph-shape');
            var path = styles.svg.lib(morphShape).select('path');

            if (_this2.state.isOpen) {
              // Animate SVG path.
              styles.svg.animate(path);
            } else {
              // Reset path (timeout ensures animation happens off screen).
              setTimeout(function () {
                path.attr('d', styles.svg.pathInitial);
              }, 300);
            }
          })();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this3 = this;

        return _react2['default'].createElement(
          'div',
          null,
          !this.props.noOverlay && _react2['default'].createElement('div', {
            className: ('bm-overlay ' + this.props.overlayClassName).trim(),
            onClick: function () {
              return !_this3.shouldDisableOverlayClick() && _this3.toggleMenu();
            },
            style: this.getStyles('overlay')
          }),
          _react2['default'].createElement(
            'div',
            {
              id: this.props.id,
              className: ('bm-menu-wrap ' + this.props.className).trim(),
              style: this.getStyles('menuWrap')
            },
            styles.svg && _react2['default'].createElement(
              'div',
              {
                className: ('bm-morph-shape ' + this.props.morphShapeClassName).trim(),
                style: this.getStyles('morphShape')
              },
              _react2['default'].createElement(
                'svg',
                {
                  width: '100%',
                  height: '100%',
                  viewBox: '0 0 100 800',
                  preserveAspectRatio: 'none'
                },
                _react2['default'].createElement('path', { d: styles.svg.pathInitial })
              )
            ),
            _react2['default'].createElement(
              'div',
              {
                className: ('bm-menu ' + this.props.menuClassName).trim(),
                style: this.getStyles('menu')
              },
              _react2['default'].createElement(
                'nav',
                {
                  className: ('bm-item-list ' + this.props.itemListClassName).trim(),
                  style: this.getStyles('itemList')
                },
                _react2['default'].Children.map(this.props.children, function (item, index) {
                  if (item) {
                    var classList = ['bm-item', _this3.props.itemClassName, item.props.className].filter(function (className) {
                      return !!className;
                    }).join(' ');
                    var extraProps = {
                      key: index,
                      className: classList,
                      style: _this3.getStyles('item', index, item.props.style),
                      tabIndex: _this3.state.isOpen ? 0 : -1
                    };
                    return _react2['default'].cloneElement(item, extraProps);
                  }
                })
              )
            ),
            this.props.customCrossIcon !== false && _react2['default'].createElement(
              'div',
              { style: this.getStyles('closeButton') },
              _react2['default'].createElement(_CrossIcon2['default'], {
                onClick: function () {
                  return _this3.toggleMenu();
                },
                styles: this.props.styles,
                customIcon: this.props.customCrossIcon,
                className: this.props.crossButtonClassName,
                crossClassName: this.props.crossClassName,
                tabIndex: this.state.isOpen ? 0 : -1
              })
            )
          ),
          this.props.customBurgerIcon !== false && _react2['default'].createElement(
            'div',
            { style: this.getStyles('burgerIcon') },
            _react2['default'].createElement(_BurgerIcon2['default'], {
              onClick: function () {
                return _this3.toggleMenu();
              },
              styles: this.props.styles,
              customIcon: this.props.customBurgerIcon,
              className: this.props.burgerButtonClassName,
              barClassName: this.props.burgerBarClassName
            })
          )
        );
      }
    }]);

    return Menu;
  })(_react.Component);

  Menu.propTypes = {
    bodyClassName: _propTypes2['default'].string,
    burgerBarClassName: _propTypes2['default'].string,
    burgerButtonClassName: _propTypes2['default'].string,
    className: _propTypes2['default'].string,
    crossButtonClassName: _propTypes2['default'].string,
    crossClassName: _propTypes2['default'].string,
    customBurgerIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].oneOf([false])]),
    customCrossIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].oneOf([false])]),
    customOnKeyDown: _propTypes2['default'].func,
    disableAutoFocus: _propTypes2['default'].bool,
    disableCloseOnEsc: _propTypes2['default'].bool,
    disableOverlayClick: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].func]),
    htmlClassName: _propTypes2['default'].string,
    id: _propTypes2['default'].string,
    isOpen: _propTypes2['default'].bool,
    itemClassName: _propTypes2['default'].string,
    itemListClassName: _propTypes2['default'].string,
    menuClassName: _propTypes2['default'].string,
    morphShapeClassName: _propTypes2['default'].string,
    noOverlay: _propTypes2['default'].bool,
    onStateChange: _propTypes2['default'].func,
    outerContainerId: styles && styles.outerContainer ? _propTypes2['default'].string.isRequired : _propTypes2['default'].string,
    overlayClassName: _propTypes2['default'].string,
    pageWrapId: styles && styles.pageWrap ? _propTypes2['default'].string.isRequired : _propTypes2['default'].string,
    right: _propTypes2['default'].bool,
    styles: _propTypes2['default'].object,
    width: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
  };

  Menu.defaultProps = {
    bodyClassName: '',
    burgerBarClassName: '',
    burgerButtonClassName: '',
    className: '',
    crossButtonClassName: '',
    crossClassName: '',
    disableAutoFocus: false,
    disableCloseOnEsc: false,
    htmlClassName: '',
    id: '',
    itemClassName: '',
    itemListClassName: '',
    menuClassName: '',
    morphShapeClassName: '',
    noOverlay: false,
    onStateChange: function onStateChange() {},
    outerContainerId: '',
    overlayClassName: '',
    pageWrapId: '',
    styles: {},
    width: 300
  };

  return Menu;
};

module.exports = exports['default'];

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(22)) {
  var LIBRARY = __webpack_require__(77);
  var global = __webpack_require__(9);
  var fails = __webpack_require__(13);
  var $export = __webpack_require__(1);
  var $typed = __webpack_require__(167);
  var $buffer = __webpack_require__(242);
  var ctx = __webpack_require__(51);
  var anInstance = __webpack_require__(89);
  var propertyDesc = __webpack_require__(82);
  var hide = __webpack_require__(40);
  var redefineAll = __webpack_require__(91);
  var toInteger = __webpack_require__(53);
  var toLength = __webpack_require__(21);
  var toIndex = __webpack_require__(372);
  var toAbsoluteIndex = __webpack_require__(85);
  var toPrimitive = __webpack_require__(63);
  var has = __webpack_require__(44);
  var classof = __webpack_require__(110);
  var isObject = __webpack_require__(14);
  var toObject = __webpack_require__(27);
  var isArrayIter = __webpack_require__(231);
  var create = __webpack_require__(86);
  var getPrototypeOf = __webpack_require__(47);
  var gOPN = __webpack_require__(87).f;
  var getIterFn = __webpack_require__(233);
  var uid = __webpack_require__(83);
  var wks = __webpack_require__(19);
  var createArrayMethod = __webpack_require__(66);
  var createArrayIncludes = __webpack_require__(157);
  var speciesConstructor = __webpack_require__(135);
  var ArrayIterators = __webpack_require__(236);
  var Iterators = __webpack_require__(112);
  var $iterDetect = __webpack_require__(162);
  var setSpecies = __webpack_require__(88);
  var arrayFill = __webpack_require__(235);
  var arrayCopyWithin = __webpack_require__(361);
  var $DP = __webpack_require__(24);
  var $GOPD = __webpack_require__(46);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(367);
var $export = __webpack_require__(1);
var shared = __webpack_require__(131)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(370))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(72);
var IE8_DOM_DEFINE = __webpack_require__(382);
var toPrimitive = __webpack_require__(246);
var dP = Object.defineProperty;

exports.f = __webpack_require__(73) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(80);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(114)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/*
* CoreAjax is used by HmAjax.
* only difference latter handles the session validity.
*
*/var CoreAjax=function CoreAjax(url,data,headers){var startTime=0;var timeTakenInSecs=0;var opts={};var availableMethods=['GET','POST','PUT','DELETE'];var dataStr="";if((typeof headers==='undefined'?'undefined':_typeof(headers))==='object'){dataStr=data;}else{if((typeof data==='undefined'?'undefined':_typeof(data))==='object'){try{dataStr=JSON.stringify(data);}catch(e){}}else{dataStr=data;}}var calcResponseTime=function calcResponseTime(){try{timeTakenInSecs=Math.round((new Date().getTime()-startTime)/1000*100)/100;opts.timeTakenInSecs=timeTakenInSecs;}catch(e){}};this.get=function(success,failure){this.connect('GET',success,failure);};this.post=function(success,failure){this.connect('POST',success,failure);};this.put=function(success,failure){this.connect('PUT',success,failure);};this.delete=function(success,failure){this.connect('DELETE',success,failure);};this.connect=function(method,success,failure){var _this=this;if(availableMethods.indexOf(method)===-1){//if method not defined, default is applied
method=availableMethods[0];}var defaultParams={method:method,mode:'cors',redirect:'follow',credentials:'include',headers:{'Accept':'*'}};if(method==='GET'){try{if((typeof data==='undefined'?'undefined':_typeof(data))==="object"&&Object.keys(data).length>0){url+="?";for(var i in data){url+=i+"="+data[i]+"&";}url=url.substring(0,url.length-1);}}catch(e){console.error(e);}}else{defaultParams.headers["Content-Type"]="application/json";defaultParams.body=dataStr;}try{if((typeof headers==='undefined'?'undefined':_typeof(headers))==="object"&&Object.keys(headers).length>0){for(var key in headers){defaultParams.headers[key]=headers[key];}}}catch(e){console.error(e);}startTime=new Date().getTime();fetch(url,defaultParams).then(function(response){return response.json();}).then(function(result){calcResponseTime();try{if(typeof success==="function"){success.apply(_this,[result,opts]);}}catch(e){console.error("Error occurred while calling the success handler:",e);}},function(error){calcResponseTime();try{if(typeof failure==="function"){failure.apply(_this,[error,opts]);}}catch(e){console.error("Error occurred while calling the failure handler:",e);}});};};/* harmony default export */ __webpack_exports__["a"] = (CoreAjax);

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _slider = __webpack_require__(629);

var _slider2 = _interopRequireDefault(_slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _slider2.default;

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(83)('meta');
var isObject = __webpack_require__(14);
var has = __webpack_require__(44);
var setDesc = __webpack_require__(24).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(13)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(19)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(40)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 83 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(346);
var enumBugKeys = __webpack_require__(219);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(53);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(8);
var dPs = __webpack_require__(347);
var enumBugKeys = __webpack_require__(219);
var IE_PROTO = __webpack_require__(218)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(216)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(220).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(346);
var hiddenKeys = __webpack_require__(219).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9);
var dP = __webpack_require__(24);
var DESCRIPTORS = __webpack_require__(22);
var SPECIES = __webpack_require__(19)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(51);
var call = __webpack_require__(359);
var isArrayIter = __webpack_require__(231);
var anObject = __webpack_require__(8);
var toLength = __webpack_require__(21);
var getIterFn = __webpack_require__(233);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(41);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(878);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(71);
var createDesc = __webpack_require__(136);
module.exports = __webpack_require__(73) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 95 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(152);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(182);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __webpack_require__(142);
util.inherits = __webpack_require__(60);
/*</replacement>*/

var Readable = __webpack_require__(419);
var Writable = __webpack_require__(283);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NonceProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_memoize_one__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__emotion_core__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__babel_runtime_helpers_esm_typeof__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_raf__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__chunk_e8ae4b0f_browser_esm_js__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__chunk_5d200a41_browser_esm_js__ = __webpack_require__(452);
/* unused harmony reexport components */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__base_dist_react_select_a34e9d12_browser_esm_js__ = __webpack_require__(455);
/* unused harmony reexport createFilter */
/* unused harmony reexport defaultTheme */
/* unused harmony reexport mergeStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__emotion_css__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__babel_runtime_helpers_esm_taggedTemplateLiteral__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_input_autosize__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__chunk_b36baf1a_browser_esm_js__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__emotion_cache__ = __webpack_require__(448);




























var NonceProvider =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(NonceProvider, _Component);

  function NonceProvider(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, NonceProvider);

    _this = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(NonceProvider).call(this, props));

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "createEmotionCache", function (nonce) {
      return Object(__WEBPACK_IMPORTED_MODULE_25__emotion_cache__["a" /* default */])({
        nonce: nonce
      });
    });

    _this.createEmotionCache = Object(__WEBPACK_IMPORTED_MODULE_12_memoize_one__["a" /* default */])(_this.createEmotionCache);
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(NonceProvider, [{
    key: "render",
    value: function render() {
      var emotionCache = this.createEmotionCache(this.props.nonce);
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["a" /* CacheProvider */], {
        value: emotionCache
      }, this.props.children);
    }
  }]);

  return NonceProvider;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

var index = Object(__WEBPACK_IMPORTED_MODULE_24__chunk_b36baf1a_browser_esm_js__["a" /* m */])(__WEBPACK_IMPORTED_MODULE_20__base_dist_react_select_a34e9d12_browser_esm_js__["a" /* S */]);

/* harmony default export */ __webpack_exports__["a"] = (index);



/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = {"PLP":{"productKey":"PLP","url":"/personalised-learning/","ganame":"Personalised Learning"},"SPL":{"productKey":"SPL","url":"/self-learning/","ganame":"Self-Paced Lessons"},"EXAM_PREP_CBSE":{"productKey":"EXAM_PREP_CBSE","url":"/cbse-exam/","ganame":"CBSE Exam Prep"},"TCHR_SPL":{"productKey":"TCHR_SPL","url":"/self-learning/","ganame":"Self-Paced Lessons for Teachers"}}

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(537);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');
  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    return '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var Parser = __webpack_require__(326);
var DomHandler = __webpack_require__(330);

function defineProp(name, value) {
    delete module.exports[name];
    module.exports[name] = value;
    return value;
}

module.exports = {
    Parser: Parser,
    Tokenizer: __webpack_require__(327),
    ElementType: __webpack_require__(103),
    DomHandler: DomHandler,
    get FeedHandler() {
        return defineProp("FeedHandler", __webpack_require__(561));
    },
    get Stream() {
        return defineProp("Stream", __webpack_require__(572));
    },
    get WritableStream() {
        return defineProp("WritableStream", __webpack_require__(333));
    },
    get ProxyHandler() {
        return defineProp("ProxyHandler", __webpack_require__(576));
    },
    get DomUtils() {
        return defineProp("DomUtils", __webpack_require__(332));
    },
    get CollectingHandler() {
        return defineProp(
            "CollectingHandler",
            __webpack_require__(577)
        );
    },
    // For legacy support
    DefaultHandler: DomHandler,
    get RssHandler() {
        return defineProp("RssHandler", this.FeedHandler);
    },
    //helper methods
    parseDOM: function(data, options) {
        var handler = new DomHandler(options);
        new Parser(handler, options).end(data);
        return handler.dom;
    },
    parseFeed: function(feed, options) {
        var handler = new module.exports.FeedHandler(options);
        new Parser(handler, options).end(feed);
        return handler.dom;
    },
    createDomStream: function(cb, options, elementCb) {
        var handler = new DomHandler(cb, options, elementCb);
        return new Parser(handler, options);
    },
    // List of all events that the parser emits
    EVENTS: {
        /* Format: eventname: number of arguments */
        attribute: 2,
        cdatastart: 0,
        cdataend: 0,
        text: 1,
        processinginstruction: 2,
        comment: 1,
        commentend: 0,
        closetag: 1,
        opentag: 2,
        opentagname: 1,
        error: 1,
        end: 0
    }
};


/***/ }),
/* 103 */
/***/ (function(module, exports) {

//Types of elements found in the DOM
module.exports = {
	Text: "text", //Text
	Directive: "directive", //<? ... ?>
	Comment: "comment", //<!-- ... -->
	Script: "script", //<script> tags
	Style: "style", //<style> tags
	Tag: "tag", //Any tag
	CDATA: "cdata", //<![CDATA[ ... ]]>
	Doctype: "doctype",

	isTag: function(elem){
		return elem.type === "tag" || elem.type === "script" || elem.type === "style";
	}
};


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_urls_json__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_urls_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_urls_json__);
//This contains the URL base path
//This file contains URI or relative path concatenated with above
//import urlConfig from './../config/uris.json';
//Cancelling out the above import as it is being moved to public folder
var urlConfig={};Object.assign(urlConfig,window.app_uris);//delete window reference of URIs after loading to const urlConfig
window.app_uris=null;/*
* COmmon file to manage URLs
*/var UrlManager=function(){var me=this;var actionUrlMap=urlConfig;var PROTOCOL=window.location.protocol+"//";PROTOCOL="https://";/*for(var i in actionUrlMap){
  if(actionUrlMap[i] && !actionUrlMap[i].match("http[s]?://+")){
    actionUrlMap[i] = PROTOCOL + actionUrlMap[i]; 
  }
 }*///console.log("actionUrlMap ::" , actionUrlMap);
var localUrlMap={"PRELOGIN_PAGE":"/","LOGIN_HOME":"/landing","404":"/404"//set url configuartion item to actionUrlMap
};for(var item in localUrlMap){if(!actionUrlMap[item]){actionUrlMap[item]=localUrlMap[item];}}var sortedBaseDomain={};/*
* VERY IMPORTANT: Sorting based on key length is very important
*/if(__WEBPACK_IMPORTED_MODULE_0__config_urls_json___default.a){var sortedArr=Object.keys(__WEBPACK_IMPORTED_MODULE_0__config_urls_json___default.a).sort(function(a,b){return b.length-a.length;});if(sortedArr&&sortedArr.length>0){for(var i=0;i<sortedArr.length;i++){sortedBaseDomain[sortedArr[i]]=__WEBPACK_IMPORTED_MODULE_0__config_urls_json___default.a[sortedArr[i]];}}}/*
* Function to replace URL with Base Domain
*/var replaceBaseUrl=function replaceBaseUrl(url){if(sortedBaseDomain){for(var _i in sortedBaseDomain){if(url&&~url.indexOf(_i)){url=url.replace(_i,sortedBaseDomain[_i]);if(url&&!url.match("http[s]?://+")){url=PROTOCOL+url;}return url;}}}return url;};return{getUrlForAction:function getUrlForAction(action){if(typeof actionUrlMap[action]==="string"){return replaceBaseUrl(actionUrlMap[action]);}else{return"#";}},getUriForAction:function getUriForAction(action){if(typeof actionUrlMap[action]==="string"){return actionUrlMap[action];}else{return"#";}},getDomainForAction:function getDomainForAction(action){if(action){var url=this.getUrlForAction(action);if(url&&url.length>0){try{return url.replace(/http[s]?:\/\//gi,"").split("/")[0];}catch(e){}}}return"";}};}();/* harmony default export */ __webpack_exports__["a"] = (UrlManager);

/***/ }),
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_LoggedInPage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_common_Header__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_BrowserUtil__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mdl_materialUsage_css__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mdl_materialUsage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__mdl_materialUsage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__home_style_violet_css__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__home_style_violet_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__home_style_violet_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__home_custom_css__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__home_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__home_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_landing_css__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_landing_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__css_landing_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__css_myHome_css__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__css_myHome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__css_myHome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_common_Sidebar__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vendors_mindstretcher_ms_sidebar__ = __webpack_require__(652);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import Ms_sidebar from '../../vendors/mindstretcher/ms_sidebar';
//import Sidebar from '../../views/common/Sidebar';
/*
* IMPORTANT: Reason for commenting the variable-based importing is to avoid accidental usage which 
* could break the dependency injection (Component Registry) flow
*
*/var Landing=function(_LoggedInPage){_inherits(Landing,_LoggedInPage);function Landing(props){_classCallCheck(this,Landing);var _this=_possibleConstructorReturn(this,(Landing.__proto__||Object.getPrototypeOf(Landing)).call(this,props));_this.state={visible:false,topicListPlaceHolder:"",upgradenow:false};_this.childComponent=null;_this.childComponentName=null;_this.userNameUpdateEvent=_this.userNameUpdateEvent.bind(_this);_this.updateImage=_this.updateImage.bind(_this);_this.sideBarDropdownChange=_this.sideBarDropdownChange.bind(_this);_this.routingMenus=_this.routingMenus.bind(_this);_this.loginStoreKey="PLP_LOGIN_INFO";_this.homeDropDownKey="homeDropdown";_this.gradeStore=null;_this.renderSidebar=_this.renderSidebar.bind(_this);return _this;}_createClass(Landing,[{key:'setChild',value:function setChild(childComp,childName){this.childComponent=childComp;this.childComponentName=childName;}},{key:'componentDidMount',value:function componentDidMount(){this.sessionCheck();this.loginTracking();}},{key:'getAccessIdsforProducts',value:function getAccessIdsforProducts(){var accessIds=[];var prodAccess=["PLP|REVISION|TAKE","PLP|LESSON|VIEW"];var user=this.getUser();if(user.getAccessMap()){for(var i in user.getAccessMap()){if(prodAccess.indexOf(user.getAccessMap()[i])>=0){accessIds.push(i);}}}return accessIds;}},{key:'getClassIdforAccessCount',value:function getClassIdforAccessCount(classId){var accessIds=this.getAccessIdsforProducts();var user=this.getUser();var counter=0;if(user.getPermissions()&&accessIds){//var classId = 4;
for(var i in user.getPermissions()){try{if(accessIds.indexOf(i)&&user.getPermissions()[i].indexOf(classId)){counter++;}}catch(e){}}}return counter;}},{key:'routingMenus',value:function routingMenus(value){try{// this.gradeStore = {
// 	"grd":this.selectedGradeOption.value,
// 	"prod":this.selectedProductOption.value
// }
//this.setAttribute(this.homeDropDownKey,JSON.stringify(this.gradeStore));
}catch(e){}this.props.history.push(value);}},{key:'loginTracking',value:function loginTracking(){try{var loginInfo=__WEBPACK_IMPORTED_MODULE_3__util_BrowserStorageUtil__["a" /* default */].getStoredSessionItem(this.loginStoreKey);//console.log("loginInfo:::",loginInfo);
if(loginInfo){this.initiateTrack("login",JSON.parse(loginInfo));__WEBPACK_IMPORTED_MODULE_3__util_BrowserStorageUtil__["a" /* default */].removeSessionItem(this.loginStoreKey);}}catch(e){}}},{key:'userNameUpdateEvent',value:function userNameUpdateEvent(username){this.sidebarComponent.updateUserName(username);}},{key:'updateImage',value:function updateImage(imageUrl){if(imageUrl){this.sidebarComponent.setCurrentImage(imageUrl);}else{this.sidebarComponent.deleteCurrentImage();}}},{key:'sideBarDropdownChange',value:function sideBarDropdownChange(selectedGradeOption,selectedProductOption,comboNamesLoaded,state,isProductClicked){console.log("selected product:::",selectedGradeOption," :::: ",selectedProductOption);if(this.childComponent&&this.childComponent.assignStateFromParent){this.childComponent.selectedProductOption=selectedProductOption;this.childComponent.selectedGradeOption=selectedGradeOption;this.childComponent.comboNamesLoaded=comboNamesLoaded;this.childComponent.assignStateFromParent(state);if(state.noProducts==false){this.childComponent.getTopicList();}}else{if(this.childComponentName=="DASHBOARD"&&!isProductClicked){this.childComponent.gradeDropdownChange(selectedGradeOption);}}// this.setState({upgradenow:false});
}},{key:'renderSidebar',value:function renderSidebar(){var mindstretcher=true;var me=this;var SideBarComp=me.getComponent("Sidebar");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SideBarComp,{onRef:function onRef(ref){return me.sidebarComponent=ref;},myProps:me.props,sideBarDropdownChange:me.sideBarDropdownChange,childComponentName:me.childComponentName,routingMenus:me.routingMenus});}},{key:'render',value:function render(subComponent){if(!this.state.loggedIn){return _get(Landing.prototype.__proto__||Object.getPrototypeOf(Landing.prototype),'render',this).call(this);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-content d-flex align-items-stretch'},this.renderSidebar(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid norightpadding'},subComponent))));}}}]);return Landing;}(__WEBPACK_IMPORTED_MODULE_1__views_core_LoggedInPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Landing);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var sidebar_props={menus:[{'id':1001,'label':'menu.dashboard','value':'/dashboard','materialkey':'dashboard'}],ms_menus:[{'id':1001,'label':'menu.report','value':'/report','materialkey':'assessment'}],collapsed:false};/* harmony default export */ __webpack_exports__["a"] = (sidebar_props);

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(24).f;
var has = __webpack_require__(44);
var TAG = __webpack_require__(19)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(52);
var TAG = __webpack_require__(19)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var defined = __webpack_require__(64);
var fails = __webpack_require__(13);
var spaces = __webpack_require__(222);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(172);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(384);
var defined = __webpack_require__(247);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(247);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPrefixedValue;
function getPrefixedValue(prefixedValue, value, keepUnprefixed) {
  if (keepUnprefixed) {
    return [prefixedValue, value];
  }
  return prefixedValue;
}
module.exports = exports["default"];

/***/ }),
/* 119 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(36);

var ReactCurrentOwner = __webpack_require__(439);

var warning = __webpack_require__(96);
var canDefineProperty = __webpack_require__(438);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(440);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_device_detect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_BrowserStorageUtil__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserLoginType=function(_PreLoginPage){_inherits(UserLoginType,_PreLoginPage);function UserLoginType(props){_classCallCheck(this,UserLoginType);var _this=_possibleConstructorReturn(this,(UserLoginType.__proto__||Object.getPrototypeOf(UserLoginType)).call(this,props));_this.hmNav=function(userobj){//this.props.history.push('/landing');
//console.log(this.props.myProps)
//this.props.myProps.history.push(this.props.navigateURL);
if(userobj&&userobj.userRole.role=="PRNT"){if(this.props.navigateURL=="/landing"){window.top.location.href="/myproducts";}else{window.top.location.href=this.props.navigateURL;}}else{window.top.location.href=this.props.navigateURL;}};_this.submitForm=function(){if(this.state.plp_userinput.length<=0){return;}var formData={"verificationId":this.state.plp_userinput};var me=this;var callBackSuccess=function callBackSuccess(response){if(response!==null){console.log("response : ",response,"me.props.from:::",me.props.from);if(response.user_exists){//me.hmNav(response.user);
me.props.showNewLoginForm(me.state.loginType,me.state.plp_userinput,me.props.from);}else{if(response.message=="provider_forbidden"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("google.errmsg.login")});}else{me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);}}}};var callBackFailure=function callBackFailure(response){console.log("response : ",response);me.trackMe(false);};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("GET_USER_STATUS")+this.state.loginType,formData).post(callBackSuccess,callBackFailure);new __WEBPACK_IMPORTED_MODULE_7__util_UserStore__["a" /* default */]().clearOldUser();};_this.state={plp_userinput:'',submitButtonDisabled:false,loginType:"userid",loginMaxLength:254};_this.handleChange=_this.handleChange.bind(_this);_this.userIdChange=_this.userIdChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.showCreateAccount=_this.showCreateAccount.bind(_this);_this.myTrackerInstance=_this.getTracker();_this.navigationKey="PLP_Navigation";_this.loginStoreKey="PLP_LOGIN_INFO";return _this;}_createClass(UserLoginType,[{key:'componentDidMount',value:function componentDidMount(){this.sessionCheck();}},{key:'handleChange',value:function handleChange(e){var _setState;var target=e.currentTarget;this.form.validateFields(target);this.setState((_setState={},_defineProperty(_setState,target.name,target.value),_defineProperty(_setState,'submitButtonDisabled',!this.form.isValid()),_setState));}},{key:'userIdChange',value:function userIdChange(e){var target=e.currentTarget;var phoneRegx=/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;if(phoneRegx.test(target.value)){this.setState({loginType:"mobile",loginMaxLength:10});}else{this.setState({loginType:"email",loginMaxLength:254});}this.handleChange(e);this.setState({submitButtonDisabled:false});__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".userlogintypeformgroup .form-control-feedback").hide();}},{key:'handleSubmit',value:function handleSubmit(e){e.preventDefault();__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".userlogintypeformgroup .form-control-feedback").show();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){this.submitForm();}}},{key:'trackMe',value:function trackMe(result){var userObj=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var trackObj={"user_id":userObj==null?"":userObj.userId,"login_id":this.state.plp_userinput,"user_agent":navigator.userAgent,"platform":navigator.platform,"device":__WEBPACK_IMPORTED_MODULE_8_react_device_detect__["isMobile"]?"mobile":__WEBPACK_IMPORTED_MODULE_8_react_device_detect__["isTablet"]?"tablet":"PC","ip_address":"ip_address","result":result===true,"session_id":userObj==null?"":userObj.authToken};this.initiateTrack("login",trackObj);}},{key:'showCreateAccount',value:function showCreateAccount(){this.props.callbackCreateAccount();}},{key:'getUserInputPattern',value:function getUserInputPattern(){if(this.state.loginType=="mobile"){return".{10,}";}else{return"^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$";}}},{key:'render',value:function render(){var _this2=this;var styles=this.props.styles||{};if(this.state.loggedIn){return _get(UserLoginType.prototype.__proto__||Object.getPrototypeOf(UserLoginType.prototype),'render',this).call(this);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'loginRoot',className:'plpLogin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nopadding userlogintypeContainer',style:styles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this2.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-12 userlogintyperoot'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'plp_userinput',className:'userlogintypeformgroup'},function(){if(_this2.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'countrycode'},'+91');}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'plp_userinput',className:"plp_userinput userlogintype "+this.state.loginType,name:'plp_userinput',placeholder:this.rb("login.userplaceholder"),value:this.state.plp_userinput,onChange:this.userIdChange,pattern:this.getUserInputPattern(),required:true,minLength:1,maxLength:this.state.loginMaxLength,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'1'}),function(){if(_this2.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'plp_userinput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons errinfoicon'},'info'),' ',_this2.rb("login.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons errinfoicon'},'info'),' ',_this2.rb("register.mobilenolength")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length>0&&!/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g.test(value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons errinfoicon'},'info'),' ',_this2.rb("register.numbersonly")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'plp_userinput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons errinfoicon'},'info'),' ',_this2.rb("login.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons errinfoicon'},'info'),' ',_this2.rb("fpwd.validemail")));}}()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages'},this.state.serverMessage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 text-left joincontainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-ga':"Home - "+this.props.from+" Home- Join",disabled:this.state.submitButtonDisabled,className:'joinButton'},this.rb("join")))))))));}}}]);return UserLoginType;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (UserLoginType);

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prelogin_public_img_phone_png__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prelogin_public_img_phone_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__prelogin_public_img_phone_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prelogin_public_img_whatsapp_png__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prelogin_public_img_whatsapp_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__prelogin_public_img_whatsapp_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Whatsapp=function(_PreLoginPage){_inherits(Whatsapp,_PreLoginPage);function Whatsapp(){_classCallCheck(this,Whatsapp);return _possibleConstructorReturn(this,(Whatsapp.__proto__||Object.getPrototypeOf(Whatsapp)).apply(this,arguments));}_createClass(Whatsapp,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'whatsapp',style:{marginTop:'25px',textAlign:this.props.align,maxWidth:this.props.maxWidth}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__prelogin_public_img_phone_png___default.a,alt:'Call icon',style:{margin:'5px',padding:"5px",border:"2px solid white",borderRadius:'30px 30px 30px 30px',background:this.props.background||"transparent"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__prelogin_public_img_whatsapp_png___default.a,alt:'Whatsapp icon',style:{margin:'5px',padding:"5px",border:"2px solid white",borderRadius:'30px 30px 30px 30px',background:this.props.background||"transparent"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:_defineProperty({marginLeft:'5px',color:'#fff',marginTop:'5px'},'color',this.props.background||"#fff")},'+91 9884400755')));}}]);return Whatsapp;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Whatsapp);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GA_tracking_constants_json__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GA_tracking_constants_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__GA_tracking_constants_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_GA_Tracking_IDS_json__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_GA_Tracking_IDS_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_GA_Tracking_IDS_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_ga__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_debounce__);
var GoogleAnalytics=function(){var debounce_google_analytics_event_trigger=__WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default()(google_analytics_event_trigger,10);function getInitializeId(pathname){if(__WEBPACK_IMPORTED_MODULE_1__config_GA_Tracking_IDS_json___default.a[pathname]!=undefined&&__WEBPACK_IMPORTED_MODULE_1__config_GA_Tracking_IDS_json___default.a[pathname]!=null){return __WEBPACK_IMPORTED_MODULE_1__config_GA_Tracking_IDS_json___default.a[pathname];}return __WEBPACK_IMPORTED_MODULE_1__config_GA_Tracking_IDS_json___default.a.defaultId;}function google_analytics_event_trigger(event_action,event_category,event_label){var pathname=getpathname();var initializerId=getInitializeId(pathname);var defaultId=__WEBPACK_IMPORTED_MODULE_1__config_GA_Tracking_IDS_json___default.a["defaultId"];if(event_action!=null&&event_action!=undefined){var event_ga={"eventAction":event_action};var event_ga_default={"action":event_action};if(event_category!=NaN&&event_category!=undefined&&event_category!=null&&event_category!=''){event_ga['eventCategory']=event_category;event_ga_default['category']=event_ga['eventCategory'];}if(event_label!=NaN&&event_label!=undefined&&event_label!=null&&event_label!=''){event_ga['eventLabel']=event_label;event_ga_default['label']=event_label;}if(initializerId!=defaultId){__WEBPACK_IMPORTED_MODULE_2_react_ga__["a" /* default */].ga(pathname+".send","event",event_ga);}__WEBPACK_IMPORTED_MODULE_2_react_ga__["a" /* default */].ga("send","event",event_ga);}return;}function data_ga(value){if(value==null||value==undefined){return;}var escaped_value=value.replace(/\s+/g,'');escaped_value=escaped_value.toLowerCase();try{if(__WEBPACK_IMPORTED_MODULE_0__GA_tracking_constants_json___default.a.hasOwnProperty(escaped_value)){var value_ga=__WEBPACK_IMPORTED_MODULE_0__GA_tracking_constants_json___default.a[escaped_value];debounce_google_analytics_event_trigger(value,value_ga['event_category'],value_ga['event_label']);}else{debounce_google_analytics_event_trigger(value);}}catch(e){console.log(e);debounce_google_analytics_event_trigger(value);}}function getpathname(){var pathname=window.location.pathname;var pathname_arr=pathname.split("/");if(pathname_arr.length>1){pathname=pathname_arr[1].replace(/[^\w]/gi,'');}else{pathname="default";}return pathname;}return{GA:__WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default()(function(){try{var pathname=getpathname();var initializerId=getInitializeId(pathname);var defaultId=__WEBPACK_IMPORTED_MODULE_1__config_GA_Tracking_IDS_json___default.a["defaultId"];console.log(initializerId+"------"+defaultId+"---"+pathname);/*if(initializerId!=defaultId){*///ReactGA.initialize([{trackingId:initializerId}, {trackingId:defaultId, gaOptions:{name:"default"}}]);
//ReactGA.initialize([initializerId, defaultId]);
//ReactGA.initialize(defaultId);
//ReactGA.initialize(initializerId);
/*}else{
				ReactGA.initialize(defaultId);
			}*/if(initializerId!=defaultId){__WEBPACK_IMPORTED_MODULE_2_react_ga__["a" /* default */].initialize([{trackingId:initializerId,gaOptions:{name:pathname}},{trackingId:defaultId}]);//ReactGA.ga('create', initializerId,'auto' , pathname);
__WEBPACK_IMPORTED_MODULE_2_react_ga__["a" /* default */].ga(pathname+'.send',{'page':window.location.pathname+window.location.search,"hitType":"pageview"});}else{__WEBPACK_IMPORTED_MODULE_2_react_ga__["a" /* default */].initialize([{trackingId:defaultId}]);}__WEBPACK_IMPORTED_MODULE_2_react_ga__["a" /* default */].pageview(window.location.pathname+window.location.search);//ReactGA.pageview("default.send", window.location.pathname + window.location.search);
}catch(e){return;}},150),GAEvent:__WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default()(function(){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('[data-ga]').unbind("click");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('[data-ga]').click(function(){var value=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(this).attr('data-ga');data_ga(value);});__WEBPACK_IMPORTED_MODULE_3_jquery___default()('[data-hover-ga]').unbind("hover");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('[data-hover-ga]').hover(function(){var value=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(this).attr('data-hover-ga');data_ga(value);});__WEBPACK_IMPORTED_MODULE_3_jquery___default()('[data-p-ga]').unbind("click");__WEBPACK_IMPORTED_MODULE_3_jquery___default()('[data-p-ga]').click(function(event){var element=event.target;while(__WEBPACK_IMPORTED_MODULE_3_jquery___default()(element)!=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(this)){if(__WEBPACK_IMPORTED_MODULE_3_jquery___default()(element).attr('data-ga')!=undefined&&__WEBPACK_IMPORTED_MODULE_3_jquery___default()(element).attr('data-ga')!=NaN&&__WEBPACK_IMPORTED_MODULE_3_jquery___default()(element).attr('data-ga')!=null){var value=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(element).attr('data-ga');var escaped_value=value.replace(/\s+/g,'');escaped_value=escaped_value.toLowerCase();try{if(__WEBPACK_IMPORTED_MODULE_0__GA_tracking_constants_json___default.a.hasOwnProperty(escaped_value)){var value_ga=__WEBPACK_IMPORTED_MODULE_0__GA_tracking_constants_json___default.a[escaped_value];debounce_google_analytics_event_trigger(value,value_ga['event_category'],value_ga['event_label']);}else{debounce_google_analytics_event_trigger(value);}}catch(e){debounce_google_analytics_event_trigger(value);return;}return;}else if(element!=null){element=element.parentNode;}else{return;}}});},100)};}();/* unused harmony default export */ var _unused_webpack_default_export = (GoogleAnalytics);__WEBPACK_IMPORTED_MODULE_4__model_HmEventRegistry__["a" /* default */].registerEvent("INITIATE_GA",function(store){//GoogleAnalytics.GA();
});__WEBPACK_IMPORTED_MODULE_4__model_HmEventRegistry__["a" /* default */].registerEvent("INITIATE_GA_EVENT",function(store){//GoogleAnalytics.GAEvent();
});

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(36);

var ReactCurrentOwner = __webpack_require__(479);

var warning = __webpack_require__(96);
var canDefineProperty = __webpack_require__(478);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(480);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loader_spinner__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loader_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_loader_spinner__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoaderMask=function(_Loader){_inherits(LoaderMask,_Loader);function LoaderMask(){_classCallCheck(this,LoaderMask);return _possibleConstructorReturn(this,(LoaderMask.__proto__||Object.getPrototypeOf(LoaderMask)).apply(this,arguments));}_createClass(LoaderMask,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center loadingAnim'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_loader_spinner___default.a,{type:'Oval',color:'#00BFFF',height:'100',width:'100'}));}}]);return LoaderMask;}(__WEBPACK_IMPORTED_MODULE_1_react_loader_spinner___default.a);/* harmony default export */ __webpack_exports__["a"] = (LoaderMask);

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

exports.confirmAlert = confirmAlert;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactConfirmAlert = (_temp2 = _class = function (_Component) {
  _inherits(ReactConfirmAlert, _Component);

  function ReactConfirmAlert() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReactConfirmAlert);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactConfirmAlert.__proto__ || Object.getPrototypeOf(ReactConfirmAlert)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickButton = function (button) {
      if (button.onClick) button.onClick();
      _this.close();
    }, _this.handleClickOverlay = function (e) {
      var _this$props = _this.props,
          closeOnClickOutside = _this$props.closeOnClickOutside,
          onClickOutside = _this$props.onClickOutside;

      var isClickOutside = e.target === _this.overlay;

      if (closeOnClickOutside && isClickOutside) {
        onClickOutside();
        _this.close();
      }
    }, _this.close = function () {
      removeBodyClass();
      removeElementReconfirm();
      removeSVGBlurReconfirm();
    }, _this.keyboardClose = function (event) {
      var _this$props2 = _this.props,
          closeOnEscape = _this$props2.closeOnEscape,
          onKeypressEscape = _this$props2.onKeypressEscape;

      var isKeyCodeEscape = event.keyCode === 27;

      if (closeOnEscape && isKeyCodeEscape) {
        onKeypressEscape(event);
        _this.close();
      }
    }, _this.componentDidMount = function () {
      document.addEventListener('keydown', _this.keyboardClose, false);
    }, _this.componentWillUnmount = function () {
      document.removeEventListener('keydown', _this.keyboardClose, false);
      _this.props.willUnmount();
    }, _this.renderCustomUI = function () {
      var _this$props3 = _this.props,
          title = _this$props3.title,
          message = _this$props3.message,
          customUI = _this$props3.customUI;

      var dataCustomUI = {
        title: title,
        message: message,
        onClose: _this.close
      };

      return customUI(dataCustomUI);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReactConfirmAlert, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          title = _props.title,
          message = _props.message,
          buttons = _props.buttons,
          childrenElement = _props.childrenElement,
          customUI = _props.customUI;


      return _react2.default.createElement(
        'div',
        {
          className: 'react-confirm-alert-overlay',
          ref: function ref(dom) {
            return _this2.overlay = dom;
          },
          onClick: this.handleClickOverlay
        },
        _react2.default.createElement(
          'div',
          { className: 'react-confirm-alert' },
          customUI ? this.renderCustomUI() : _react2.default.createElement(
            'div',
            { className: 'react-confirm-alert-body' },
            title && _react2.default.createElement(
              'h1',
              null,
              title
            ),
            message,
            childrenElement(),
            _react2.default.createElement(
              'div',
              { className: 'react-confirm-alert-button-group' },
              buttons.map(function (button, i) {
                return _react2.default.createElement(
                  'button',
                  { key: i, onClick: function onClick() {
                      return _this2.handleClickButton(button);
                    } },
                  button.label
                );
              })
            )
          )
        )
      );
    }
  }]);

  return ReactConfirmAlert;
}(_react.Component), _class.propTypes = {
  title: _propTypes2.default.string,
  message: _propTypes2.default.string,
  buttons: _propTypes2.default.array.isRequired,
  childrenElement: _propTypes2.default.func,
  customUI: _propTypes2.default.func,
  closeOnClickOutside: _propTypes2.default.bool,
  closeOnEscape: _propTypes2.default.bool,
  willUnmount: _propTypes2.default.func,
  onClickOutside: _propTypes2.default.func,
  onKeypressEscape: _propTypes2.default.func
}, _class.defaultProps = {
  buttons: [{
    label: 'Cancel',
    onClick: function onClick() {
      return null;
    }
  }, {
    label: 'Confirm',
    onClick: function onClick() {
      return null;
    }
  }],
  childrenElement: function childrenElement() {
    return null;
  },
  closeOnClickOutside: true,
  closeOnEscape: true,
  willUnmount: function willUnmount() {
    return null;
  },
  onClickOutside: function onClickOutside() {
    return null;
  },
  onKeypressEscape: function onKeypressEscape() {
    return null;
  }
}, _temp2);
exports.default = ReactConfirmAlert;


function createSVGBlurReconfirm() {
  // If has svg ignore to create the svg
  var svg = document.getElementById('react-confirm-alert-firm-svg');
  if (svg) return;
  var svgNS = 'http://www.w3.org/2000/svg';
  var feGaussianBlur = document.createElementNS(svgNS, 'feGaussianBlur');
  feGaussianBlur.setAttribute('stdDeviation', '0.3');

  var filter = document.createElementNS(svgNS, 'filter');
  filter.setAttribute('id', 'gaussian-blur');
  filter.appendChild(feGaussianBlur);

  var svgElem = document.createElementNS(svgNS, 'svg');
  svgElem.setAttribute('id', 'react-confirm-alert-firm-svg');
  svgElem.setAttribute('class', 'react-confirm-alert-svg');
  svgElem.appendChild(filter);

  document.body.appendChild(svgElem);
}

function removeSVGBlurReconfirm() {
  var svg = document.getElementById('react-confirm-alert-firm-svg');
  svg.parentNode.removeChild(svg);
  document.body.children[0].classList.remove('react-confirm-alert-blur');
}

function createElementReconfirm(properties) {
  var divTarget = document.getElementById('react-confirm-alert');
  if (divTarget) {
    // Rerender - the mounted ReactConfirmAlert
    (0, _reactDom.render)(_react2.default.createElement(ReactConfirmAlert, properties), divTarget);
  } else {
    // Mount the ReactConfirmAlert component
    document.body.children[0].classList.add('react-confirm-alert-blur');
    divTarget = document.createElement('div');
    divTarget.id = 'react-confirm-alert';
    document.body.appendChild(divTarget);
    (0, _reactDom.render)(_react2.default.createElement(ReactConfirmAlert, properties), divTarget);
  }
}

function removeElementReconfirm() {
  var target = document.getElementById('react-confirm-alert');
  (0, _reactDom.unmountComponentAtNode)(target);
  target.parentNode.removeChild(target);
}

function addBodyClass() {
  document.body.classList.add('react-confirm-alert-body-element');
}

function removeBodyClass() {
  document.body.classList.remove('react-confirm-alert-body-element');
}

function confirmAlert(properties) {
  addBodyClass();
  createSVGBlurReconfirm();
  createElementReconfirm(properties);
}

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CoreAjax__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_UrlManager__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NativeAjax__ = __webpack_require__(29);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/*
 * Common Ajax for the application.
 * Depends on React fetch
 *
 */var HawkEye=function HawkEye(data){var url=__WEBPACK_IMPORTED_MODULE_2__model_UrlManager__["a" /* default */].getUrlForAction("TRACKING_URL");var availableMethods=['GET','POST','PUT'];var dataStr="";if((typeof data==='undefined'?'undefined':_typeof(data))==='object'){try{dataStr=JSON.stringify(data);}catch(e){console.error("Error occurred while processing the data:",e);}}else{console.warn("Data is not in the form of an object");}this.get=function(success,failure){this.connect('GET',success,failure);};this.post=function(success,failure){this.connect('POST',success,failure);};this.put=function(success,failure){this.connect('PUT',success,failure);};this.connect=function(method,success,failure){var successCallback=function successCallback(result){try{if(typeof success==="function"){success.apply(this,[result]);}}catch(e){console.error("Error occurred while calling the success handler:",e);}};var failureCallback=function failureCallback(error){try{if(typeof failure==="function"){failure.apply(this,[error]);}}catch(e){console.error("Error occurred while calling the failure handler:",e);}};if(availableMethods.indexOf(method)===-1){//if method not defined, default is applied
method=availableMethods[0];}//new CoreAjax(url,data).connect(method,successCallback,failureCallback);
//new NativeAjax(url,data).enableCORS().post(successCallback,failureCallback);
};};/* harmony default export */ __webpack_exports__["a"] = (HawkEye);

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(10);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(49);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_PLACEHOLDER_STRING = 'Select...';

var Dropdown = function (_Component) {
  _inherits(Dropdown, _Component);

  function Dropdown(props) {
    _classCallCheck(this, Dropdown);

    var _this = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));

    _this.state = {
      selected: _this.parseValue(props.value, props.options) || {
        label: typeof props.placeholder === 'undefined' ? DEFAULT_PLACEHOLDER_STRING : props.placeholder,
        value: ''
      },
      isOpen: false
    };
    _this.mounted = true;
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    _this.fireChangeEvent = _this.fireChangeEvent.bind(_this);
    return _this;
  }

  _createClass(Dropdown, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.value) {
        var selected = this.parseValue(newProps.value, newProps.options);
        if (selected !== this.state.selected) {
          this.setState({ selected: selected });
        }
      } else {
        this.setState({ selected: {
            label: typeof newProps.placeholder === 'undefined' ? DEFAULT_PLACEHOLDER_STRING : newProps.placeholder,
            value: ''
          } });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('click', this.handleDocumentClick, false);
      document.addEventListener('touchend', this.handleDocumentClick, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
      document.removeEventListener('click', this.handleDocumentClick, false);
      document.removeEventListener('touchend', this.handleDocumentClick, false);
    }
  }, {
    key: 'handleMouseDown',
    value: function handleMouseDown(event) {
      if (this.props.onFocus && typeof this.props.onFocus === 'function') {
        this.props.onFocus(this.state.isOpen);
      }
      if (event.type === 'mousedown' && event.button !== 0) return;
      event.stopPropagation();
      event.preventDefault();

      if (!this.props.disabled) {
        this.setState({
          isOpen: !this.state.isOpen
        });
      }
    }
  }, {
    key: 'parseValue',
    value: function parseValue(value, options) {
      var option = void 0;

      if (typeof value === 'string') {
        for (var i = 0, num = options.length; i < num; i++) {
          if (options[i].type === 'group') {
            var match = options[i].items.filter(function (item) {
              return item.value === value;
            });
            if (match.length) {
              option = match[0];
            }
          } else if (typeof options[i].value !== 'undefined' && options[i].value === value) {
            option = options[i];
          }
        }
      }

      return option || value;
    }
  }, {
    key: 'setValue',
    value: function setValue(value, label) {
      var newState = {
        selected: {
          value: value,
          label: label },
        isOpen: false
      };
      this.fireChangeEvent(newState);
      this.setState(newState);
    }
  }, {
    key: 'fireChangeEvent',
    value: function fireChangeEvent(newState) {
      if (newState.selected !== this.state.selected && this.props.onChange) {
        this.props.onChange(newState.selected);
      }
    }
  }, {
    key: 'renderOption',
    value: function renderOption(option) {
      var _classes;

      var value = option.value;
      if (typeof value === 'undefined') {
        value = option.label || option;
      }
      var label = option.label || option.value || option;
      var isSelected = value === this.state.selected.value || value === this.state.selected;

      var classes = (_classes = {}, _defineProperty(_classes, this.props.baseClassName + '-option', true), _defineProperty(_classes, option.className, !!option.className), _defineProperty(_classes, 'is-selected', isSelected), _classes);

      var optionClass = (0, _classnames2.default)(classes);

      return _react2.default.createElement(
        'div',
        {
          key: value,
          className: optionClass,
          onMouseDown: this.setValue.bind(this, value, label),
          onClick: this.setValue.bind(this, value, label),
          role: 'option',
          'aria-selected': isSelected ? 'true' : 'false' },
        label
      );
    }
  }, {
    key: 'buildMenu',
    value: function buildMenu() {
      var _this2 = this;

      var _props = this.props,
          options = _props.options,
          baseClassName = _props.baseClassName;

      var ops = options.map(function (option) {
        if (option.type === 'group') {
          var groupTitle = _react2.default.createElement(
            'div',
            { className: baseClassName + '-title' },
            option.name
          );
          var _options = option.items.map(function (item) {
            return _this2.renderOption(item);
          });

          return _react2.default.createElement(
            'div',
            { className: baseClassName + '-group', key: option.name, role: 'listbox', tabIndex: '-1' },
            groupTitle,
            _options
          );
        } else {
          return _this2.renderOption(option);
        }
      });

      return ops.length ? ops : _react2.default.createElement(
        'div',
        { className: baseClassName + '-noresults' },
        'No options found'
      );
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(event) {
      if (this.mounted) {
        if (!_reactDom2.default.findDOMNode(this).contains(event.target)) {
          if (this.state.isOpen) {
            this.setState({ isOpen: false });
          }
        }
      }
    }
  }, {
    key: 'isValueSelected',
    value: function isValueSelected() {
      return typeof this.state.selected === 'string' || this.state.selected.value !== '';
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames, _classNames2, _classNames3, _classNames4, _classNames5;

      var _props2 = this.props,
          baseClassName = _props2.baseClassName,
          controlClassName = _props2.controlClassName,
          placeholderClassName = _props2.placeholderClassName,
          menuClassName = _props2.menuClassName,
          arrowClassName = _props2.arrowClassName,
          arrowClosed = _props2.arrowClosed,
          arrowOpen = _props2.arrowOpen,
          className = _props2.className;


      var disabledClass = this.props.disabled ? 'Dropdown-disabled' : '';
      var placeHolderValue = typeof this.state.selected === 'string' ? this.state.selected : this.state.selected.label;

      var dropdownClass = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, baseClassName + '-root', true), _defineProperty(_classNames, className, !!className), _defineProperty(_classNames, 'is-open', this.state.isOpen), _classNames));
      var controlClass = (0, _classnames2.default)((_classNames2 = {}, _defineProperty(_classNames2, baseClassName + '-control', true), _defineProperty(_classNames2, controlClassName, !!controlClassName), _defineProperty(_classNames2, disabledClass, !!disabledClass), _classNames2));
      var placeholderClass = (0, _classnames2.default)((_classNames3 = {}, _defineProperty(_classNames3, baseClassName + '-placeholder', true), _defineProperty(_classNames3, placeholderClassName, !!placeholderClassName), _defineProperty(_classNames3, 'is-selected', this.isValueSelected()), _classNames3));
      var menuClass = (0, _classnames2.default)((_classNames4 = {}, _defineProperty(_classNames4, baseClassName + '-menu', true), _defineProperty(_classNames4, menuClassName, !!menuClassName), _classNames4));
      var arrowClass = (0, _classnames2.default)((_classNames5 = {}, _defineProperty(_classNames5, baseClassName + '-arrow', true), _defineProperty(_classNames5, arrowClassName, !!arrowClassName), _classNames5));

      var value = _react2.default.createElement(
        'div',
        { className: placeholderClass },
        placeHolderValue
      );
      var menu = this.state.isOpen ? _react2.default.createElement(
        'div',
        { className: menuClass, 'aria-expanded': 'true' },
        this.buildMenu()
      ) : null;

      return _react2.default.createElement(
        'div',
        { className: dropdownClass },
        _react2.default.createElement(
          'div',
          { className: controlClass, onMouseDown: this.handleMouseDown.bind(this), onTouchEnd: this.handleMouseDown.bind(this), 'aria-haspopup': 'listbox' },
          value,
          _react2.default.createElement(
            'div',
            { className: baseClassName + '-arrow-wrapper' },
            arrowOpen && arrowClosed ? this.state.isOpen ? arrowOpen : arrowClosed : _react2.default.createElement('span', { className: arrowClass })
          )
        ),
        menu
      );
    }
  }]);

  return Dropdown;
}(_react.Component);

Dropdown.defaultProps = { baseClassName: 'Dropdown' };
exports.default = Dropdown;


/***/ }),
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(50);
var global = __webpack_require__(9);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(77) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(52);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 133 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(8);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(8);
var aFunction = __webpack_require__(34);
var SPECIES = __webpack_require__(19)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(383);
var enumBugKeys = __webpack_require__(252);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 138 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  easeOutFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
  easeInOutFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',

  easeOut: function easeOut(duration, property, delay, easeFunction) {
    easeFunction = easeFunction || this.easeOutFunction;

    if (property && Object.prototype.toString.call(property) === '[object Array]') {
      var transitions = '';
      for (var i = 0; i < property.length; i++) {
        if (transitions) transitions += ',';
        transitions += this.create(duration, property[i], delay, easeFunction);
      }

      return transitions;
    } else {
      return this.create(duration, property, delay, easeFunction);
    }
  },
  create: function create(duration, property, delay, easeFunction) {
    duration = duration || '450ms';
    property = property || 'all';
    delay = delay || '0ms';
    easeFunction = easeFunction || 'linear';

    return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
  }
};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(203).Buffer))

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_serialize__ = __webpack_require__(450);


function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__emotion_serialize__["a" /* serializeStyles */])(args);
}

/* harmony default export */ __webpack_exports__["a"] = (css);


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/forgotpwdicon.3e65c7e9.png";

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/loginicon.53220c51.png";

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ACTION = exports.TYPE = exports.POSITION = void 0;
var POSITION = {
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  TOP_CENTER: 'top-center',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  BOTTOM_CENTER: 'bottom-center'
};
exports.POSITION = POSITION;
var TYPE = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  DEFAULT: 'default'
};
exports.TYPE = TYPE;
var ACTION = {
  SHOW: 0,
  CLEAR: 1,
  DID_MOUNT: 2,
  WILL_UNMOUNT: 3,
  ON_CHANGE: 4
};
exports.ACTION = ACTION;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = $getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  var args = [];
  for (var i = 0; i < arguments.length; i++) args.push(arguments[i]);
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    ReflectApply(this.listener, this.target, args);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(203)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_id_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_css__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_slick_carousel_slick_slick_theme_css__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_slick_carousel_slick_slick_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_slick_carousel_slick_slick_theme_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_slick__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_common_Landing__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_reactstrap__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__css_scorecard_css__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__css_scorecard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__css_scorecard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_circular_progressbar_dist_styles_css__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_circular_progressbar_dist_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_circular_progressbar_dist_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_hey_icon_png__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_hey_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_icons_hey_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_icons_scardp_icon_png__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_icons_scardp_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_icons_scardp_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_icons_scardg_icon_png__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_icons_scardg_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_icons_scardg_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_icons_recom_lesson_png__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_icons_recom_lesson_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_icons_recom_lesson_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_icons_recom_practice_png__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_icons_recom_practice_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__images_icons_recom_practice_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_icons_recom_related_lesson_png__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_icons_recom_related_lesson_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__images_icons_recom_related_lesson_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__LessonComponent__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ViewSolution__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_loader_spinner__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_loader_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_loader_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_plp_TestTakingModalComponent__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_plp_TestInfo__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__vendors_mindstretcher_ms_TestInfo__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_plp_GetTest__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Piechart__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Imageslider__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_common_Navtop__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__images_icons_emojis_rating_default_png__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__images_icons_emojis_rating_default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__images_icons_emojis_rating_default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__images_icons_emojis_bad_gif__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__images_icons_emojis_bad_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__images_icons_emojis_bad_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__images_icons_emojis_good_gif__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__images_icons_emojis_good_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__images_icons_emojis_good_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__images_icons_emojis_loveit_gif__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__images_icons_emojis_loveit_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__images_icons_emojis_loveit_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__images_icons_emojis_normal_gif__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__images_icons_emojis_normal_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__images_icons_emojis_normal_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__images_icons_emojis_verybad_gif__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__images_icons_emojis_verybad_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__images_icons_emojis_verybad_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__images_icons_emojis_bad_small_png__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__images_icons_emojis_bad_small_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__images_icons_emojis_bad_small_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__images_icons_emojis_good_small_png__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__images_icons_emojis_good_small_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__images_icons_emojis_good_small_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__images_icons_emojis_loveit_small_png__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__images_icons_emojis_loveit_small_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__images_icons_emojis_loveit_small_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__images_icons_emojis_normal_small_png__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__images_icons_emojis_normal_small_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__images_icons_emojis_normal_small_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__images_icons_emojis_verybad_small_png__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__images_icons_emojis_verybad_small_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__images_icons_emojis_verybad_small_png__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import CircularProgressbar from 'react-circular-progressbar';
//Import React Table
//import image1 from '../../images/recommand/image1.jpg'; 
var settings={dots:false,infinite:false,speed:300,slidesToShow:5,slidesToScroll:5,responsive:[{breakpoint:1370,settings:{slidesToShow:4,slidesToScroll:4,infinite:false,dots:false}},{breakpoint:1100,settings:{slidesToShow:3,slidesToScroll:3,infinite:false,dots:false}},{breakpoint:767,settings:{slidesToShow:2,slidesToScroll:2}},{breakpoint:550,settings:{slidesToShow:1,slidesToScroll:1}// You can unslick at a given breakpoint now by adding:
// settings: "unslick"
// instead of a settings object
}]};var scorecardLoadedTime=null;var Scorecard=function(_Landing){_inherits(Scorecard,_Landing);function Scorecard(props){_classCallCheck(this,Scorecard);var _this=_possibleConstructorReturn(this,(Scorecard.__proto__||Object.getPrototypeOf(Scorecard)).call(this,props));_this.scoreCalculated=false;_this.testId=0;_this.state={dataLoaded:false,data:{},testModalView:"",testModalShow:false,testModalContent:"loading",modalTitle:"",piechartdata:false,existingRatingObj:{},popoverOpen:false,selectedEmoji:null,hideRatingModal:false,classDefnMap:null,recomLocked:{similarProblemLocked:false,recommendedLessonLocked:false,practiceLocked:false}};_this.questionTypeCount=0;_this.questionCount=0;_this.attemptCount=0;_this.unAttemptedCount=0;_this.partialCorrect=0;_this.questionsCorrect=0;_this.questionsIncorrect=0;_this.totalScore=0;_this.userScore=0;_this.testMode=0;_this.questions=[];_this.recommdata={};_this.userGrade=0;_this.totalPoints=0;_this.userPoints="";_this.showRecommendationScreen=_this.showRecommendationScreen.bind(_this);_this.showTestModal=_this.showTestModal.bind(_this);_this.hideTestModal=_this.hideTestModal.bind(_this);_this.hideRatingModal=_this.hideRatingModal.bind(_this);_this.startTest=_this.startTest.bind(_this);_this.setModalBackdropClose=_this.setModalBackdropClose.bind(_this);_this.feedbackText="";_this.feedbackText2="";_this.noLessonMode=false;_this.currentScrollIndex=1;_this.selectedRate=null;_this.toggle=_this.toggle.bind(_this);_this.selectRating=_this.selectRating.bind(_this);_this.handleMouseOver=_this.handleMouseOver.bind(_this);_this.handleMouseOut=_this.handleMouseOut.bind(_this);_this.isFreeTrail=_this.isFreeTrail.bind(_this);_this.isFreeTrailSub=_this.isFreeTrailSub.bind(_this);_this.isPurchased=_this.isPurchased.bind(_this);_this.ga={"subscribe-btn":""};return _this;}_createClass(Scorecard,[{key:'addGa',value:function addGa(){this.ga['subscribe-btn']=this.ViewsolutionGA();return this.ga;}},{key:'lscrFn',value:function lscrFn(e){console.log("left");var scrdiv=document.querySelector('.imgGal');}},{key:'rscrFn',value:function rscrFn(e){console.log("right");var scrdiv=document.querySelector('.imgGal');}},{key:'handleMouseOver',value:function handleMouseOver(event){__WEBPACK_IMPORTED_MODULE_2_jquery___default()(event.currentTarget).find(".hovertxt").show();}},{key:'handleMouseOut',value:function handleMouseOut(event){__WEBPACK_IMPORTED_MODULE_2_jquery___default()(".hovertxt").hide();}},{key:'getAllSolutionsTrackingDetails',value:function getAllSolutionsTrackingDetails(){var trackingParams=[];if(this.questions.length>0){for(var i=0;i<this.questions.length;i++){var quesObj={};quesObj["questionId"]=this.questions[i].testQuestionId;quesObj["snippetId"]=this.questions[i].snippetId;quesObj["currQuestAtt"]=this.questions[i].attemptNo;trackingParams.push(quesObj);}}//console.log("trackingParams",trackingParams);
var me=this;var callBackSuccess=function callBackSuccess(response){me.setState({existingRatingObj:response});//console.log("GET_TRACKING_DETAILS response",response);
};var callBackFailure=function callBackFailure(error){console.log("Error in Scorecard GET_TRACKING_DETAILS");};new __WEBPACK_IMPORTED_MODULE_8__util_HmAjax__["a" /* default */](this.getUrlFor("GET_TRACKING_DETAILS")+this.testId,trackingParams).post(callBackSuccess,callBackFailure);}},{key:'showViewSolutionScreen',value:function showViewSolutionScreen(){this.currentScrollIndex=1;this.setState({testModalShow:true,testModalContent:this.renderViewSolution(),modalTitle:this.setQModalTitle(this.state.data),testModalView:"staticContent",modalLabel:"View Solutions"});}},{key:'showRecommendationScreen',value:function showRecommendationScreen(){this.setState({testModalShow:true,testModalContent:this.renderRecomendationContent(),modalTitle:this.state.data.testDetails.topics,testModalView:"staticContent",modalLabel:"View Recommendations"});}},{key:'renderViewSolution',value:function renderViewSolution(){this.trackRecommendationSolutionLoaded("solutions");//console.log("this.testId="+this.testId+", subtopicid="+this.state.data.testDetails.topicSubTopicMapId);
var me=this;//Decide whether to show the View Solution button or not
var isSolutionAvailable=this.state.data.isSolutionAvailable;var solutionDate=this.state.data.solutionDate;if(isSolutionAvailable){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__ViewSolution__["a" /* default */],{questionTypeCount:this.questionTypeCount,ga:me.addGa(),questions:this.questions,testId:me.testId,topicSubTopicMapId:me.state.data.testDetails.topicSubTopicMapId,existingRatingObj:me.state.existingRatingObj,accessId:me.state.data.testDetails.accessId,classId:me.state.data.testDetails.classId,recomLocked:me.state.recomLocked});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,function(){if(solutionDate){return me.rb("scorecard.label.solutionAvailableOn",[solutionDate]);}else{return me.rb("scorecard.label.solutionNotAvailable");}}());}}},{key:'showRatingPopup',value:function showRatingPopup(){if(this.state.dataLoaded){//console.log("rating popup:::",this.state.data.testDetails);
var completedOn=this.state.data.completedOnInSeconds;var currentTime=this.getUnixTime();//console.log("completedOn:::",completedOn);
//console.log("currentTime:::",currentTime);
var diffInSeconds=currentTime-completedOn;//console.log("diffInSeconds="+diffInSeconds);
// if(this.state.data.testDetails.mode != 1 && diffInSeconds <= 30){
var showRatingDelayTime=window.showRatingDelayTime||5;if(diffInSeconds<=showRatingDelayTime){this.setState({ratingModalShow:true});}}}},{key:'getUnixTime',value:function getUnixTime(){return new Date(new Date().toUTCString()).getTime()/1000;}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(this.props.match.params.reset){__WEBPACK_IMPORTED_MODULE_2_jquery___default()(".content-inner").css("width","100%");}}},{key:'componentDidMount',value:function componentDidMount(){console.log("reset:::"+this.props.match.params.reset);this.setState({loggedIn:true,piechartdata:true});this.getScorecardData();this.getClassNames();__WEBPACK_IMPORTED_MODULE_7__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");this.fireMobileToast();}},{key:'getClassNames',value:function getClassNames(callBack){var me=this;var callBackSuccess=function callBackSuccess(response){me.setState({classDefnMap:response.classDefn});};var callBackFailure=function callBackFailure(error){};new __WEBPACK_IMPORTED_MODULE_8__util_HmAjax__["a" /* default */](this.getUrlFor("DASH_COMBO_DATA")).get(callBackSuccess,callBackFailure);}},{key:'getScorecardData',value:function getScorecardData(){try{var me=this;var successHandler=function successHandler(data){if(data===null||data!==null&&data.error){var buttons=[{label:me.rb("go_home"),handler:function handler(){window.location.href=me.getUrlFor("LOGIN_HOME");}}];me.showAlert(me.rb(data.testStatus),me.rb(data.reference_id)||me.rb(data.testStatus),buttons);return;}try{var accessMap=me.getUser().getAccessMap();me.noLessonMode=accessMap[data.testDetails.accessId]==="PLP|TEST|TAKE";}catch(e){}// me.setState({recomLocked:{
// 	similarProblemLocked:data.similarProblemLocked,
// 	recommendedLessonLocked:data.recommendedLessonLocked,
// 	practiceLocked:data.practiceLocked
// }});
me.calculatePointsAndGrade(data);var rating=data.rating?parseInt(data.rating):0;me.setState({dataLoaded:true,"data":data,selectedEmoji:rating,recomLocked:{similarProblemLocked:data.similarProblemLocked,recommendedLessonLocked:data.recommendedLessonLocked,practiceLocked:data.practiceLocked}});console.log("isFreeTrail1",me.state.recomLocked.recommendedLessonLocked);me.selectedRate=rating;me.trackScorecardLoaded();me.getAllSolutionsTrackingDetails();me.showRatingPopup();me.render();};var failureHandler=function failureHandler(err){var buttons=[{label:me.rb("go_home"),handler:function handler(){window.location.href=me.getUrlFor("LOGIN_HOME");}}];me.showAlert(me.rb("error"),me.rb("generic_connect_error"),buttons);return;};this.testId=this.props.match.params.id;var versionSuffix=this.props.match.params.reset&&!isNaN(this.props.match.params.reset)?"/"+this.props.match.params.reset:"";//new HmAjax(this.getUrlFor("SCORECARD_DATA")).get(successHandler, failureHandler);
new __WEBPACK_IMPORTED_MODULE_8__util_HmAjax__["a" /* default */](this.getUrlFor("SCORECARD_DATA")+this.testId+versionSuffix).get(successHandler,failureHandler);}catch(e){var buttons=[{label:me.rb("go_home"),handler:function handler(){window.location.href=me.getUrlFor("LOGIN_HOME");}}];me.showAlert(me.rb("error"),me.rb("system_error"),buttons);}if(scorecardLoadedTime==null){scorecardLoadedTime=new Date().getTime();}}},{key:'getFeedBackText',value:function getFeedBackText(){return this.feedbackText;}},{key:'getFeedBackText2',value:function getFeedBackText2(){return this.feedbackText2;}},{key:'getOriginalFeedBackText',value:function getOriginalFeedBackText(gradeDtls){if(gradeDtls.oldPercent===100){return this.rb("scorecard.test.grade-full-A+");}else{return this.noLessonMode?this.rb("scorecard.test.nolesson-grade-"+(gradeDtls.oldGrade&&gradeDtls.oldGrade.length>0?gradeDtls.oldGrade:"C")):this.rb("scorecard.test.grade-"+(gradeDtls.oldGrade&&gradeDtls.oldGrade.length>0?gradeDtls.oldGrade:"C"));}}},{key:'getUpdatedFeedBackText',value:function getUpdatedFeedBackText(gradeDtls){if(gradeDtls.newPercent===100){return this.rb("scorecard.practice.grade-full");}else if(gradeDtls.gradeChanged){return this.rb("scorecard.practice.grade-change").replace("{1}",gradeDtls.oldGrade).replace("{2}",gradeDtls.newGrade);}else if(gradeDtls.percentChanged){return this.rb("scorecard.practice.grade-nochange").replace("{1}",gradeDtls.oldPoints).replace("{2}",gradeDtls.newPoints);}else{return this.rb("scorecard.practice.point-nochange");}}},{key:'getRecommendedViewFeedBackForPractice',value:function getRecommendedViewFeedBackForPractice(gradeDtls){if(gradeDtls.newPercent===100){return this.rb("scorecard.practice.grade-full");}else if(gradeDtls.gradeChanged){return this.rb("scorecard.practice.grade-change").replace("{1}",gradeDtls.oldGrade).replace("{2}",gradeDtls.newGrade);}else if(gradeDtls.percentChanged){return this.rb("scorecard.practice.grade-nochange").replace("{1}",gradeDtls.oldPoints).replace("{2}",gradeDtls.newPoints);}else if(gradeDtls.newPercent===0){return this.rb("scorecard.recommended.rawtext1");}else{return this.rb("scorecard.practice.point-nochange");}}},{key:'processFeedBackText',value:function processFeedBackText(){if(this.state.data&&this.state.data.topicGradeDtls){try{var gradeDtls=Object.values(Object.values(this.state.data.topicGradeDtls)[0])[0];if(gradeDtls){//this one is for Test - to show the original comment
if(this.state.data.isActualTest){this.feedbackText=this.getOriginalFeedBackText(gradeDtls);this.feedbackText2=this.getRecommendedViewFeedBackForPractice(gradeDtls);}else{// This one is for practice - to show the new comment
this.feedbackText=this.getUpdatedFeedBackText(gradeDtls);}}}catch(e){console.error(e);}}}},{key:'calculateQuestionCount',value:function calculateQuestionCount(){if(!this.scoreCalculated){this.testMode=this.state.data.testDetails.mode;if(this.testMode===1){this.calculateScoreForTest();}else if(this.testMode===2){this.calculateScoreForStandard();}else if(this.testMode===3){this.calculateScoreForAdaptive();}this.scoreCalculated=true;}}},{key:'calculateScoreForTest',value:function calculateScoreForTest(){var me=this;try{this.state.data.transcripts.map(function(transcript,index){try{me.questionTypeCount++;if(transcript.attempts===null||transcript.attempts.length<=0){me.unAttemptedCount++;me.questionCount++;}else{transcript.attempts.map(function(attempt,index){//Push additional details to attempt object 
attempt.questionNo=transcript.questionNo;attempt.testMode="TEST";//This method pushes the question to renderer array
me.populateQuestions(attempt);me.totalScore+=attempt.marks;me.questionCount++;if(attempt.attempted){me.attemptCount++;if(attempt.attemptCorrect){me.questionsCorrect++;}else if(attempt.partialCorrect){me.partialCorrect++;}else{me.questionsIncorrect++;}}else{me.unAttemptedCount++;}me.userScore+=attempt.userMarks;});}// For Test, take the user marks
//me.userScore = me.state.data.testDetails.marks;
}catch(e){console.log("Error occurred for the question of index:"+index,e);}});}catch(e){console.error("Error occurred while calculating questions count in Scorecard:",e);}}},{key:'calculateScoreForAdaptive',value:function calculateScoreForAdaptive(){var me=this;try{this.state.data.transcripts.map(function(transcript,index){try{me.questionTypeCount++;me.questionCount++;if(transcript.attempts===null||transcript.attempts.length<=0){me.unAttemptedCount++;}else{me.totalScore++;if(transcript.answerCorrect){me.userScore++;me.questionsCorrect++;}else{me.questionsIncorrect++;}transcript.attempts.map(function(attempt,index){//Push additional details to attempt object 
attempt.questionNo=transcript.questionNo;attempt.testMode="PRACTICE";//This method pushes the question to renderer array
me.populateQuestions(attempt);});}}catch(e){console.log("Error occurred for the question of index:"+index,e);}});}catch(e){console.error("Error occurred while calculating questions count in Scorecard:",e);}}},{key:'calculateScoreForStandard',value:function calculateScoreForStandard(){var me=this;try{this.state.data.transcripts.map(function(transcript,index){try{me.questionTypeCount++;if(transcript.attempts===null||transcript.attempts.length<=0){me.unAttemptedCount++;}else{transcript.attempts.map(function(attempt,index){//Push additional details to attempt object 
attempt.questionNo=transcript.questionNo;attempt.testMode="TEST";//This method pushes the question to renderer array
me.populateQuestions(attempt);me.totalScore++;if(attempt.attemptCorrect){me.userScore++;}me.questionCount++;if(attempt.attempted){me.attemptCount++;if(attempt.attemptCorrect){me.questionsCorrect++;}else if(attempt.partialCorrect){me.partialCorrect++;}else{me.questionsIncorrect++;}}else{me.unAttemptedCount++;}});}}catch(e){console.log("Error occurred for the question of index:"+index,e);}});}catch(e){console.error("Error occurred while calculating questions count in Scorecard:",e);}}},{key:'populateQuestions',value:function populateQuestions(questionAttempt){try{this.questions.push(questionAttempt);}catch(e){console.log("Error Occurred while populating questions.",e);}}},{key:'calculatePointsAndGrade',value:function calculatePointsAndGrade(data){try{this.userPoints=data.userPoints||0;this.totalPoints=data.testPoints||0;this.userGrade=data.grade;}catch(e){}}},{key:'getUserPoints',value:function getUserPoints(){return this.userPoints;}},{key:'getTotalPoints',value:function getTotalPoints(){return this.totalPoints;}},{key:'getUserGrade',value:function getUserGrade(){return this.userGrade;}},{key:'getTotalScore',value:function getTotalScore(){return this.totalScore;}},{key:'getQuestionCount',value:function getQuestionCount(){return this.questionCount;}},{key:'getAttemptedCount',value:function getAttemptedCount(){return this.attemptCount;}},{key:'getUnAttemptedCount',value:function getUnAttemptedCount(){return this.unAttemptedCount;}},{key:'getCorrectCount',value:function getCorrectCount(){return this.questionsCorrect;}},{key:'getIncorrectCount',value:function getIncorrectCount(){return this.questionsIncorrect;}},{key:'unanswerdata',value:function unanswerdata(topicInfoObj){if(topicInfoObj.testDetails.mode==1||topicInfoObj.testDetails.mode=="1"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'nosidepaddingmust'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons resultalg noans'},'fiber_manual_record')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'boxtxt'},this.rb("scorecard.unanswered"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'nosidepaddingmust'},this.getUnAttemptedCount()));}}},{key:'getPartialCorrectCount',value:function getPartialCorrectCount(){return this.partialCorrect;}},{key:'getSummaryPointColumn',value:function getSummaryPointColumn(transcript){var attPoints=0;try{if(this.testMode===1){transcript.attempts.map(function(attempt,index){attPoints+=attempt.attemptPoints;});}else if(this.testMode===2){transcript.attempts.map(function(attempt,index){if(attempt.attemptCorrect){attPoints+=attempt.attemptPoints;//attPoints++;
}});}else if(this.testMode===3){transcript.attempts.map(function(attempt,index){if(attempt.attemptCorrect){attPoints+=attempt.attemptPoints;//attPoints++;
}});}}catch(e){}return attPoints;}},{key:'getSummaryMarkColumn',value:function getSummaryMarkColumn(transcript){var attMark=0;try{if(this.testMode===1){transcript.attempts.map(function(attempt,index){attMark+=attempt.userMarks;});}else if(this.testMode===2){transcript.attempts.map(function(attempt,index){if(attempt.attemptCorrect){attMark++;}});}else if(this.testMode===3){transcript.attempts.map(function(attempt,index){if(attempt.attemptCorrect){attMark++;}});}}catch(e){}return attMark;}},{key:'getSummaryOutcomesColumn',value:function getSummaryOutcomesColumn(transcript){try{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resultspan'},transcript.attempts.map(function(attempt,index){if(attempt.attemptCorrect){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons resultalg rightans'},'done'));}else if(attempt.attempted){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons resultalg wrongans'},'close'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons resultalg noans'},'fiber_manual_record'));}})));}catch(e){}}},{key:'getSummaryView',value:function getSummaryView(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["l" /* Table */],{className:'result1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'resulthead'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,this.rb("scorecard.question_col")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,this.rb("scorecard.result_col")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,this.rb("scorecard.points_col")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.state.data.transcripts.map(function(transcript,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'qorder'},transcript.questionNo),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,_this2.getSummaryOutcomesColumn(transcript)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,_this2.getSummaryPointColumn(transcript)));}))));}},{key:'ViewsolutionGA',value:function ViewsolutionGA(){return"Post login - "+this.state.classDefnMap[this.state.data.testDetails.classId].className+" - Tests - "+this.state.data.breadcrumb.topicname+" - "+this.state.data.breadcrumb.subtopicname+" - "+(this.state.data.testDetails.mode==1?"PT":"CP")+" - "+"Scorecard - View Solutions";}},{key:'ViewRecommendationGA',value:function ViewRecommendationGA(){return"Post login - "+this.state.classDefnMap[this.state.data.testDetails.classId].className+" - Tests - "+this.state.data.breadcrumb.topicname+" - "+this.state.data.breadcrumb.subtopicname+" - "+(this.state.data.testDetails.mode==1?"PT":"CP")+" - "+"Scorecard - View Recommendations";}},{key:'getRecommendViewOnTop',value:function getRecommendViewOnTop(){var _this3=this;var recomStr=this.state.data.recommendResponseStr;var me=this;var recommendations={};var isSolutionAvailable=this.state.data.isSolutionAvailable;var recommendedBtnStyleClass="col-sm-12 col-md-6 col-12 text-center";if(!isSolutionAvailable){recommendedBtnStyleClass="col-12 text-center";}try{if(recomStr!==undefined&&recomStr!==null&&recomStr!=="null"){recommendations=JSON.parse(recomStr).recommendResponse;this.recommdata=recommendations;this.processRelatedLessons();if((typeof recommendations==='undefined'?'undefined':_typeof(recommendations))==="object"&&Object.keys(recommendations).length>0){if(me.props.match.params.reset){if(me.recommdata.testDetails){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix col-12 row topbtnscontainer'},function(){if(isSolutionAvailable){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-12 col-md-6 col-12 text-center borderight'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:_this3.showViewSolutionScreen.bind(_this3),className:'btn btn-primary largeBtn soln widthmax no-float','data-ga':_this3.ViewsolutionGA()},_this3.rb("scorecard.review_solution")));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:recommendedBtnStyleClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:me.openPracticeModal.bind(me),className:'btn btn-primary largeBtn soln no-float'},me.rb("scorecard.viewpracticereport"))));}else{if(isSolutionAvailable){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix col-12 row topbtnscontainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.showViewSolutionScreen.bind(this),className:'btn btn-primary largeBtn soln widthmax no-float','data-ga':this.ViewsolutionGA()},this.rb("scorecard.review_solution"))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix col-12 row topbtnscontainer'},function(){if(isSolutionAvailable){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-12 col-md-6 col-12 text-center borderight'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:_this3.showViewSolutionScreen.bind(_this3),className:'btn btn-primary largeBtn soln widthmax no-float','data-ga':_this3.ViewsolutionGA()},_this3.rb("scorecard.review_solution")));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:recommendedBtnStyleClass},function(){var practiceBtnTxt=me.rb("scorecard.recommendationsnpractice");if(me.recommdata.testDetails&&me.recommdata.lessonInfos&&me.recommdata.lessonInfos.length>0){practiceBtnTxt=me.rb("scorecard.recommendationslessonpractice");}else if(me.recommdata.testDetails){practiceBtnTxt=me.rb("scorecard.recommendationsnpractice");}else if(me.recommdata.minRelatedLessons&&me.recommdata.minRelatedLessons.length>0){practiceBtnTxt=me.rb("scorecard.recommendationslesson");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:me.showRecommendationScreen,className:'btn btn-primary largeBtn soln widthmax no-float','data-ga':"Post login - "+me.state.classDefnMap[me.state.data.testDetails.classId].className+" - Tests - "+me.state.data.breadcrumb.topicname+" - "+me.state.data.breadcrumb.subtopicname+" - "+(me.state.data.testDetails.mode==1?"PT":"CP")+" - "+"Scorecard - View Recommendations"},practiceBtnTxt);}()));}}else{if(isSolutionAvailable){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix col-12 row topbtnscontainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.showViewSolutionScreen.bind(this),className:'btn btn-primary largeBtn soln widthmax no-float','data-ga':this.ViewsolutionGA()},this.rb("scorecard.review_solution"))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}}else{if(isSolutionAvailable){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix col-12 row topbtnscontainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.showViewSolutionScreen.bind(this),className:'btn btn-primary largeBtn soln widthmax no-float','data-ga':this.ViewsolutionGA()},this.rb("scorecard.review_solution"))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}}catch(e){//console.error("Error occurred while parsing recommendations:", e);
if(isSolutionAvailable){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix col-12 row topbtnscontainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.showViewSolutionScreen.bind(this),className:'btn btn-primary largeBtn soln widthmax no-float','data-ga':this.ViewsolutionGA()},this.rb("scorecard.review_solution"))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}}},{key:'getRecommendView',value:function getRecommendView(){var _this4=this;var recomStr=this.state.data.recommendResponseStr;var me=this;var recommendations={};try{if(recomStr!==undefined&&recomStr!==null&&recomStr!=="null"){recommendations=JSON.parse(recomStr).recommendResponse;this.recommdata=recommendations;//console.log(this.recommdata);
//process related lessons
this.processRelatedLessons();if((typeof recommendations==='undefined'?'undefined':_typeof(recommendations))==="object"&&Object.keys(recommendations).length>0){//console.log(this.recommdata.testDetails, Object.keys(this.recommdata.testDetails).length );
//console.log(this.recommdata.minRelatedLessons, this.recommdata.minRelatedLessons.length );
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["b" /* Col */],{className:'col-sm-12 col-12 col-md-12 col-lg-4 viewrecobtn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.showRecommendationScreen,className:'btn btn-primary largeBtn soln','data-ga':this.ViewRecommendationGA()},function(){if(_this4.recommdata.testDetails&&_this4.recommdata.lessonInfos){return me.rb("scorecard.viewrecommendations");}else if(_this4.recommdata.testDetails){return me.rb("scorecard.viewrecommendations");}else if(_this4.recommdata.minRelatedLessons&&_this4.recommdata.minRelatedLessons.length>0){return me.rb("scorecard.viewrerelatedlessons");}}()));}}}catch(e){console.error("Error occurred while parsing recommendations:",e);}}},{key:'getFeedBackArea',value:function getFeedBackArea(){var _this5=this;try{if(!this.props.match.params.reset){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["k" /* Row */],{className:'recommandrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["b" /* Col */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["k" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["b" /* Col */],{className:'col-sm-12 col-12 col-md-12 col-lg-2 recommandcol'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'recommand'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_12__images_icons_hey_icon_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["b" /* Col */],{className:'col-sm-12 col-12 col-md-12 col-lg-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reco_title'},this.rb("scorecard.recommendation_title")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'reco_desc'},function(){return _this5.getFeedBackText();}())),this.getRecommendView())));}}catch(e){console.error(e);}}},{key:'processRelatedLessons',value:function processRelatedLessons(){var minRelatedLessons=[];var tempRelationMap={};try{var allRelatedLessons=this.recommdata.relatedLessons;var recommLessons=this.recommdata.lessonInfos;if(allRelatedLessons&&(typeof allRelatedLessons==='undefined'?'undefined':_typeof(allRelatedLessons))==="object"&&allRelatedLessons.length>0){for(var l=0;l<allRelatedLessons.length;l++){tempRelationMap[allRelatedLessons[l].lessonUrl]=allRelatedLessons[l];}}if(recommLessons&&(typeof recommLessons==='undefined'?'undefined':_typeof(recommLessons))==="object"&&recommLessons.length>0){for(var r=0;r<recommLessons.length;r++){if(tempRelationMap[recommLessons[r].lessonUrl]!==undefined||tempRelationMap[recommLessons[r].lessonUrl]!==null){delete tempRelationMap[recommLessons[r].lessonUrl];}}}minRelatedLessons=Object.values(tempRelationMap);}catch(e){console.error(e);}this.recommdata.minRelatedLessons=minRelatedLessons;}},{key:'imageSliderFn',value:function imageSliderFn(){}},{key:'openPracticeModal',value:function openPracticeModal(){var me=this;if(this.recommdata&&this.recommdata.testDetails){if(this.recommdata.testDetails.studentStatus&&this.recommdata.testDetails.studentStatus=="COMPLETED"){var versionSuffix=this.props.match.params.reset&&!isNaN(this.props.match.params.reset)?"/"+this.props.match.params.reset:"";window.location.href="/scorecard/"+me.recommdata.testDetails.id+versionSuffix;}else{setTimeout(function(){//	console.log("Custamized Test")
me.showTestModal(me.recommdata.testDetails.id,me.state.data.testDetails.topicSubTopicMapId,me.state.data.testDetails.revisionTestId);me.fireMobileToast();},500);}}}},{key:'showTestModal',value:function showTestModal(testId){var topicsubtopicId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var revisiontestid=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;this.setState({testModalShow:true,testModalContent:this.setTestInfoScreen(testId,topicsubtopicId,revisiontestid),modalTitle:"",testModalView:"testInfo",modalLabel:""});}},{key:'setTestInfoScreen',value:function setTestInfoScreen(testId,topicsubtopicId,revisiontestid){var _this6=this;var TestInfoComp=this.getComponent("TestInfo");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TestInfoComp,{callbackParent:this.startTest,testId:testId,topicsubtopicId:topicsubtopicId,revisiontestid:revisiontestid,onRef:function onRef(ref){return _this6.getTestInfoComponent=ref;},gradeName:this.state.classDefnMap[this.state.data.testDetails.classId].className});}},{key:'loadTestScreen',value:function loadTestScreen(topicInfoObj,topicsubtopicId,revisiontestid){var _this7=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__views_plp_GetTest__["a" /* default */],{topicInfoObj:topicInfoObj,topicsubtopicId:topicsubtopicId,revisiontestid:revisiontestid,onRef:function onRef(ref){return _this7.getTestComponent=ref;},gradeName:this.state.classDefnMap[this.state.data.testDetails.classId].className,studentStatus:this.recommdata.testDetails.studentStatus});}},{key:'onCloseHandler',value:function onCloseHandler(){try{if(this.getTestComponent&&typeof this.getTestComponent.onCloseHandler==="function"){this.getTestComponent.onCloseHandler();}else{console.warn("Not submitting this test: function 'onCloseHandler' not available");}}catch(e){console.error(e);}}},{key:'hideTestModal',value:function hideTestModal(){try{if(this.getTestComponent){this.getTestComponent.modalCloseEvent();}else if(this.getTestInfoComponent){this.getTestInfoComponent.trackTestClose();}}catch(e){}this.onCloseHandler();this.setState({testModalShow:false,testModalContent:"loading",modalTitle:"",testModalView:"loading",modalLabel:""});//this.getTopicList(subTopicView);		
if(this.state.testModalView!=="staticContent"){this.setState({dataLoaded:false});this.getScorecardData();}this.getAllSolutionsTrackingDetails();}},{key:'hideRatingModal',value:function hideRatingModal(){this.setState({ratingModalShow:false});}},{key:'setModalClass',value:function setModalClass(){if(this.state.testModalView=="testView"){return" modal-lg custom-modal";}else if(this.state.testModalView=="testInfo"){return" modal-lg info-modal";}else if(this.state.testModalView=="staticContent"){return" modal-lg solution-modal";}return" modal-lg";}},{key:'setModalBackdropClose',value:function setModalBackdropClose(){if(this.state.testModalView=="testView"){return"";}else if(this.state.testModalView=="testInfo"){return"";}else if(this.state.testModalView=="staticContent"){return this.hideTestModal;}return this.hideTestModal;}},{key:'setModalTitle',value:function setModalTitle(topicInfoObj){var testType="";if(topicInfoObj.testDetails.mode==1||topicInfoObj.testDetails.mode=="1"){testType=this.rb("home.proficiencytest");}else{testType=this.rb("home.customizepractice");}var topicname=topicInfoObj.testDetails.topics;topicname=topicname.split("- Customized Practice").join("");return topicname+" - "+testType;}},{key:'setQModalTitle',value:function setQModalTitle(topicInfoObj){var testType="";if(topicInfoObj.testDetails.mode==1||topicInfoObj.testDetails.mode=="1"){testType=this.rb("scorecard.view_solution_proficiency");}else{testType=this.rb("scorecard.view_solution_customized");}var topicname=topicInfoObj.testDetails.topics;topicname=topicname.split("- Customized Practice").join("");return topicname+" - "+testType;}},{key:'getReportName',value:function getReportName(topicInfoObj){var testType="";if(topicInfoObj.testDetails.mode==1||topicInfoObj.testDetails.mode=="1"){testType=this.rb("scorecard.revision_test_report");}else{testType=this.rb("scorecard.revision_custom_report");}return testType;}},{key:'getScorecardtitleName',value:function getScorecardtitleName(topicInfoObj){var testType="";if(topicInfoObj.testDetails.mode==1||topicInfoObj.testDetails.mode=="1"){testType=this.rb("scorecard.revision_test_report");}else{testType=this.rb("scorecard.revision_custom_report");}var topicname=topicInfoObj.testDetails.topics;topicname=topicname.split("- Customized Practice").join("");return testType+" - "+topicname;}},{key:'loadModalContent',value:function loadModalContent(){if(this.state.testModalContent==="loading"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center loadingAnim'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_loader_spinner___default.a,{type:'Oval',color:'#00BFFF',height:'100',width:'100'}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.testModalContent);}}},{key:'startTest',value:function startTest(topicInfoObj,topicsubtopicId,revisiontestid){this.setState({testModalContent:this.loadTestScreen(topicInfoObj,topicsubtopicId,revisiontestid),modalTitle:this.setModalTitle(topicInfoObj),testModalView:"testView"});var source_test_id="";var resumed=null;if(topicInfoObj.testDetails.mode==1||topicInfoObj.testDetails.mode=="1"){source_test_id="";}else{source_test_id=this.state.data.testDetails.id;}if(this.recommdata.testDetails.studentStatus=="NEW"||!this.recommdata.testDetails.studentStatus){resumed=false;}else if(this.recommdata.testDetails.studentStatus=="IN_PROGRESS"){resumed=true;}var trackObj={"subtopic_id":topicsubtopicId,"test_id":topicInfoObj.testDetails.id,"source_test_id":source_test_id,"resumed":resumed};this.initiateTrack("test_started",trackObj);}},{key:'getrecopracticelabel',value:function getrecopracticelabel(){try{if(this.recommdata.testDetails.studentStatus==="COMPLETED"){return this.rb("home.btn.view");}else if(this.recommdata.testDetails.studentStatus==="IN_PROGRESS"){return this.rb("home.continue")+" Practice";}else{return this.rb("home.start")+" Practice";}}catch(e){return this.rb("home.start")+" Practice";}}},{key:'lockcontent',value:function lockcontent(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'upgrdlock1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'lock'));}},{key:'isPurchased',value:function isPurchased(){return!this.state.recomLocked.practiceLocked;}},{key:'isFreeTrail',value:function isFreeTrail(){var _this8=this;if(this.state.recomLocked.practiceLocked){return this.subscribeFn(this.ViewRecommendationGA()+" - Recommended Practice - Subscribe");}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary largeBtn',onClick:this.openPracticeModal.bind(this),'data-ga':this.ViewRecommendationGA()+" - "+this.getrecopracticelabel()},function(){if(_this8.recommdata&&_this8.recommdata.testDetails&&_this8.recommdata.testDetails.studentStatus){if(_this8.recommdata.testDetails.studentStatus==="COMPLETED"){return _this8.rb("home.btn.view");}else if(_this8.recommdata.testDetails.studentStatus==="IN_PROGRESS"){return _this8.rb("home.continue");}else{return _this8.rb("home.start");}}else{return _this8.rb("home.start");}}());}}},{key:'isFreeTrailSub',value:function isFreeTrailSub(){if(this.state.recomLocked.practiceLocked){return this.subscribeFn(this.ViewRecommendationGA()+" - Recommended Lessons - Subscribe");}}},{key:'renderRecomendationContent',value:function renderRecomendationContent(){var _this9=this;var me=this;this.trackRecommendationSolutionLoaded("recommendations");//console.log("recomlocked  :::",this.state.recomLocked,typeof this.state.recomLocked);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recompage'},function(){var classdisabled="";if(_this9.state.recomLocked.practiceLocked){classdisabled="disabled lockdisabledrecom";}if(_this9.recommdata.testDetails){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recomdiv'},_this9.rb("scorecard.recommended_practice")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["k" /* Row */],{className:'allMiddle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["b" /* Col */],{className:'col-sm-12 col-12 col-md-3 col-lg-3 recommandcol'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_16__images_icons_recom_practice_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["b" /* Col */],{className:'col-sm-12 col-12 col-md-6 col-lg-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pr-15'},_this9.getFeedBackText2())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["b" /* Col */],{className:'col-sm-12 col-12 col-md-3 col-lg-3 text-center'},_this9.isFreeTrail())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null));}}(),function(){if(_this9.recommdata.lessonInfos&&_this9.recommdata.lessonInfos.length>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recomdiv'},_this9.rb("scorecard.recommended_lessons")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["k" /* Row */],{className:'allMiddle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["b" /* Col */],{className:'col-sm-12 col-12 col-md-3 col-lg-3 recommandcol'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_15__images_icons_recom_lesson_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["b" /* Col */],{className:'col-sm-12 col-12 col-md-9 col-lg-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this9.rb("scorecard.recommended.rawtext2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["k" /* Row */],{className:'allMiddle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["b" /* Col */],{className:'col-sm-8 col-8 col-md-10 col-lg-10 imgGal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'co-12 text-center scorecardLessons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_slick___default.a,settings,_this9.recommdata.lessonInfos.map(function(lesson,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},_this9.props,{key:index,'data-index':index,'data-ga':_this9.ViewRecommendationGA()+" - Lessons"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__LessonComponent__["a" /* default */],{isFrom:"ViewSoln",isFreeTrail:_this9.state.data.recommendedLessonLocked,lesson:lesson,testId:_this9.testId,topicSubTopicMapId:_this9.state.data.testDetails.topicSubTopicMapId,accessId:_this9.state.data.testDetails.accessId,classId:_this9.state.data.testDetails.classId,tracksource:'recommended_lessons'}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-center allMiddle'},_this9.isFreeTrailSub())))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null));}}(),function(){if(_this9.recommdata.minRelatedLessons!==undefined&&_this9.recommdata.minRelatedLessons!==null&&_this9.recommdata.minRelatedLessons.length>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recomdiv'},_this9.rb("scorecard.related_lessons")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["k" /* Row */],{className:'allMiddle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["b" /* Col */],{className:'col-sm-12 col-12 col-md-3 col-lg-3 recommandcol'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_17__images_icons_recom_related_lesson_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["b" /* Col */],{className:'col-sm-12 col-12 col-md-9 col-lg-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this9.rb("scorecard.recommended.rawtext3")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["k" /* Row */],{className:'allMiddle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["b" /* Col */],{className:'col-sm-8 col-8 col-md-10 col-lg-10 imgGal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'co-12 text-center scorecardLessons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_slick___default.a,settings,_this9.recommdata.minRelatedLessons.map(function(lesson,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},_this9.props,{key:index,'data-index':index}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__LessonComponent__["a" /* default */],{isFrom:"Scorecard",lesson:lesson,testId:_this9.testId,topicSubTopicMapId:_this9.state.data.testDetails.topicSubTopicMapId,isFreeTrail:_this9.state.data.recommendedLessonLocked,accessId:_this9.state.data.testDetails.accessId,classId:_this9.state.data.testDetails.classId,tracksource:'related_lessons',key:index}));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-center allMiddle'},_this9.isFreeTrailSub()))));}}());}},{key:'piechartFn',value:function piechartFn(){var piedata=[this.getCorrectCount(),this.getIncorrectCount(),this.getUnAttemptedCount()];//how many partitions you want
var piecolors=["#2daa13","#ff6d00","#d1d3d4"];//partiation color
var pieindata=[this.getCorrectCount(),"/",this.getQuestionCount()];//inside data of svg
//console.log(piedata + " " + piecolors+" "+pieindata);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'piechart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__Piechart__["a" /* default */],{data:piedata,colors:piecolors,txtval:pieindata}));}},{key:'trackScorecardLoaded',value:function trackScorecardLoaded(){var endTime=new Date().getTime();var loadedTime=-1;if(scorecardLoadedTime!=null){loadedTime=endTime-scorecardLoadedTime;}var trackObj={"source_id":this.testId,"load_duration":loadedTime,"page_type":this.getTracker().enums.loadedPageType.scorecard};this.initiateTrack("page_loaded",trackObj);scorecardLoadedTime=null;}},{key:'trackRecommendationSolutionLoaded',value:function trackRecommendationSolutionLoaded(recommendations){var trackObj={"source_id":this.testId,"load_duration":0,"page_type":this.getTracker().enums.loadedPageType[recommendations]};this.initiateTrack("page_loaded",trackObj);}},{key:'getRecommendPracticeTitle',value:function getRecommendPracticeTitle(){if(this.recommdata.testDetails){return this.recommdata.testDetails.topics;}}},{key:'getSelectedEmojiIcon',value:function getSelectedEmojiIcon(){console.log("render...:",this.state.selectedEmoji);switch(this.state.selectedEmoji){case 5:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'shakeme',src:__WEBPACK_IMPORTED_MODULE_36__images_icons_emojis_loveit_small_png___default.a});break;case 4:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'shakeme',src:__WEBPACK_IMPORTED_MODULE_35__images_icons_emojis_good_small_png___default.a});break;case 3:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'shakeme',src:__WEBPACK_IMPORTED_MODULE_37__images_icons_emojis_normal_small_png___default.a});break;case 2:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'shakeme',src:__WEBPACK_IMPORTED_MODULE_34__images_icons_emojis_bad_small_png___default.a});break;case 1:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'shakeme',src:__WEBPACK_IMPORTED_MODULE_38__images_icons_emojis_verybad_small_png___default.a});break;default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_28__images_icons_emojis_rating_default_png___default.a});}}},{key:'saveRating',value:function saveRating(){var me=this;var ratingData={"topicId":this.state.data.breadcrumb.topicid,"subTopicId":this.state.data.breadcrumb.subtopicid,"classId":parseInt(this.state.data.testDetails.classId),"accessId":parseInt(this.state.data.testDetails.accessId),"rating":parseInt(this.selectedRate)};var callBackSuccess=function callBackSuccess(response){console.log("response:::",response);};var callBackFailure=function callBackFailure(error){console.log("Error in Ssubtopic RATING_EMOJI_SAVE");};new __WEBPACK_IMPORTED_MODULE_8__util_HmAjax__["a" /* default */](this.getUrlFor("RATING_EMOJI_SAVE"),ratingData).post(callBackSuccess,callBackFailure);//----------------
//console.log("scorecardrating id:::",this.state.data.breadcrumb);
try{var trackObj={"subtopic_id":this.state.data.breadcrumb.topicsubtopicmapid,"rating":parseInt(this.selectedRate),"grade_id":parseInt(this.state.data.testDetails.classId),"product_type":parseInt(this.state.data.testDetails.accessId),"source":this.getTracker().enums.itemRatedSource.scorecard};this.initiateTrack("item_rated",trackObj);}catch(e){}}},{key:'selectRating',value:function selectRating(event){var target=event.currentTarget;__WEBPACK_IMPORTED_MODULE_2_jquery___default()(".emojiicons").removeClass("selected");__WEBPACK_IMPORTED_MODULE_2_jquery___default()(target).addClass("selected");this.selectedRate=__WEBPACK_IMPORTED_MODULE_2_jquery___default()(target).attr("data-rateindex");this.setState({selectedEmoji:parseInt(__WEBPACK_IMPORTED_MODULE_2_jquery___default()(target).attr("data-rateindex"))});this.saveRating();if(this.state.ratingModalShow){this.hideRatingModal();}else{this.toggle();}}/*toggle() {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    });
}*/},{key:'toggle',value:function toggle(){var me=this;if(this.state.popoverOpen==false){me.setState({popoverOpen:!me.state.popoverOpen});}else{me.setState({popoverOpen:!me.state.popoverOpen});}}},{key:'getcloselabel',value:function getcloselabel(){return this.state.modalLabel+" - Close";}},{key:'renderPracticeReportButton',value:function renderPracticeReportButton(){if(this.props.match.params.reset){var recommendations={};var recomStr=this.state.data.recommendResponseStr;if(recomStr!==undefined&&recomStr!==null&&recomStr!=="null"){var recommendations=JSON.parse(recomStr).recommendResponse;this.recommdata=recommendations;if(this.recommdata.testDetails&&this.recommdata.testDetails.studentStatus=="COMPLETED"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this.openPracticeModal.bind(this),className:'btn btn-primary largeBtn soln'},this.rb("scorecard.viewpracticereport"));}}}}},{key:'renderScoreData',value:function renderScoreData(){if(this.state.dataLoaded&&this.state.classDefnMap){this.processFeedBackText();this.calculateQuestionCount();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'scrbread'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'breadcrumb-holder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'breadcrumb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'breadcrumb-item active'},this.state.data.breadcrumb.topicname),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'breadcrumb-item active'},this.state.data.breadcrumb.subtopicname),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'breadcrumb-item active'},this.getReportName(this.state.data)))),this.getRecommendViewOnTop(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scoretitle clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pull-left'},this.getScorecardtitleName(this.state.data),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pull-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pr-15'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratingemoji',onClick:this.toggle,id:'Popover-'+this.state.data.testDetails.topicSubTopicMapId},this.getSelectedEmojiIcon()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["i" /* Popover */],{className:'emojiPopover scorecard',placement:'right-start',isOpen:this.state.popoverOpen,target:'Popover-'+this.state.data.testDetails.topicSubTopicMapId,toggle:this.toggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["j" /* PopoverBody */],{className:'pos_relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emojianim',onMouseOver:this.handleMouseOver,onMouseOut:this.handleMouseOut},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'emojiicons','data-rateindex':5,src:__WEBPACK_IMPORTED_MODULE_31__images_icons_emojis_loveit_gif___default.a,onClick:this.selectRating}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center hovertxt'},'Loved it')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emojianim',onMouseOver:this.handleMouseOver,onMouseOut:this.handleMouseOut},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'emojiicons','data-rateindex':4,src:__WEBPACK_IMPORTED_MODULE_30__images_icons_emojis_good_gif___default.a,onClick:this.selectRating}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center hovertxt'},'Good')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emojianim',onMouseOver:this.handleMouseOver,onMouseOut:this.handleMouseOut},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'emojiicons','data-rateindex':3,src:__WEBPACK_IMPORTED_MODULE_32__images_icons_emojis_normal_gif___default.a,onClick:this.selectRating}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center hovertxt'},'Normal')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emojianim',onMouseOver:this.handleMouseOver,onMouseOut:this.handleMouseOut},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'emojiicons','data-rateindex':2,src:__WEBPACK_IMPORTED_MODULE_29__images_icons_emojis_bad_gif___default.a,onClick:this.selectRating}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center hovertxt'},'Hard')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emojianim',onMouseOver:this.handleMouseOver,onMouseOut:this.handleMouseOut},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'emojiicons','data-rateindex':1,src:__WEBPACK_IMPORTED_MODULE_33__images_icons_emojis_verybad_gif___default.a,onClick:this.selectRating}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center hovertxt'},'Very hard'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["k" /* Row */],{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["b" /* Col */],{sm:12,xs:12,md:6,lg:3,className:'noleftpadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'score-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["k" /* Row */],{className:'box1Row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["b" /* Col */],{sm:6,xs:6,md:6,lg:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'scard'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_14__images_icons_scardg_icon_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["b" /* Col */],{sm:6,xs:6,md:6,lg:6,className:'nopadding text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boxtxt'},' ',this.rb("scorecard.grade"),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reward'},this.getUserGrade()))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["b" /* Col */],{sm:12,xs:12,md:6,lg:4,className:'noleftpadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'score-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["k" /* Row */],{className:'box2Row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["b" /* Col */],{sm:6,xs:6,md:6,lg:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'scard'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_13__images_icons_scardp_icon_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["b" /* Col */],{sm:6,xs:6,md:6,lg:6,className:'nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'boxtxt'},' ',this.rb("scorecard.points"),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'score'},this.getUserPoints()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scoreoutof'},this.rb("scorecard.out_of"),' ',this.getTotalPoints()))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["b" /* Col */],{sm:12,xs:12,md:12,lg:5,className:'noleftpadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'score-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'box3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["k" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["b" /* Col */],{sm:5,xs:5,md:5,lg:5},this.piechartFn()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["b" /* Col */],{sm:7,xs:7,md:7,lg:7,className:'pt-20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_reactstrap__["l" /* Table */],{className:'result'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'nosidepaddingmust'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons resultalg rightans'},'done')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'boxtxt'},this.rb("scorecard.correct"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'nosidepaddingmust'},this.getCorrectCount())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'nosidepaddingmust'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons resultalg wrongans'},'close')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'boxtxt'},this.rb("scorecard.incorrect"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'nosidepaddingmust'},this.getIncorrectCount())),this.unanswerdata(this.state.data)))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.getSummaryView(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__views_plp_TestTakingModalComponent__["a" /* default */],{visible:this.state.testModalShow,dialogClassName:this.setModalClass(),onClickBackdrop:this.setModalBackdropClose()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-header bg-purple'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-title'},this.state.modalTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close',onClick:this.hideTestModal,'aria-label':'Close','data-ga':"Post login - "+this.state.classDefnMap[this.state.data.testDetails.classId].className+" - Tests - "+this.state.data.breadcrumb.topicname+" - "+this.state.data.breadcrumb.subtopicname+" - "+(this.state.data.testDetails.mode==1?"PT":"CP")+" - "+"Scorecard - "+this.getcloselabel()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'close')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-body testModalBody'},this.loadModalContent()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__views_plp_TestTakingModalComponent__["a" /* default */],{visible:this.state.ratingModalShow,dialogClassName:"ratingModal",onClickBackdrop:this.hideRatingModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-header rating-mdl-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-title'},this.rb("scorecard.rating.headermsg")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'skipmodal',onClick:this.hideRatingModal,'aria-label':'Close'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},'Skip'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pos_relative text-center ratingbody'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emojianim',onMouseOver:this.handleMouseOver,onMouseOut:this.handleMouseOut},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'emojiicons','data-rateindex':5,src:__WEBPACK_IMPORTED_MODULE_31__images_icons_emojis_loveit_gif___default.a,onClick:this.selectRating}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center hovertxt'},'Loved it')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emojianim',onMouseOver:this.handleMouseOver,onMouseOut:this.handleMouseOut},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'emojiicons','data-rateindex':4,src:__WEBPACK_IMPORTED_MODULE_30__images_icons_emojis_good_gif___default.a,onClick:this.selectRating}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center hovertxt'},'Good')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emojianim',onMouseOver:this.handleMouseOver,onMouseOut:this.handleMouseOut},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'emojiicons','data-rateindex':3,src:__WEBPACK_IMPORTED_MODULE_32__images_icons_emojis_normal_gif___default.a,onClick:this.selectRating}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center hovertxt'},'Normal')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emojianim',onMouseOver:this.handleMouseOver,onMouseOut:this.handleMouseOut},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'emojiicons','data-rateindex':2,src:__WEBPACK_IMPORTED_MODULE_29__images_icons_emojis_bad_gif___default.a,onClick:this.selectRating}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center hovertxt'},'Hard')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emojianim',onMouseOver:this.handleMouseOver,onMouseOut:this.handleMouseOut},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'emojiicons','data-rateindex':1,src:__WEBPACK_IMPORTED_MODULE_33__images_icons_emojis_verybad_gif___default.a,onClick:this.selectRating}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center hovertxt'},'Very hard')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__views_common_Navtop__["a" /* default */],null));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' ',this.showLoader());}}},{key:'render',value:function render(){return _get(Scorecard.prototype.__proto__||Object.getPrototypeOf(Scorecard.prototype),'render',this).call(this,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scorecardComponent','data-p-ga':''},this.renderScoreData()),false);}}]);return Scorecard;}(__WEBPACK_IMPORTED_MODULE_6__views_common_Landing__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Scorecard);

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(10);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }
  return onDemandSlides;
};

// return list of slides that need to be present
var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }
  return requiredSlides;
};

// startIndex that needs to be present
var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};
var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};
var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};

// get width of an element
var getWidth = exports.getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};
var getHeight = exports.getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};
var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);
  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }
  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }
  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }
  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
};

// whether or not we can go next
var canGoNext = exports.canGoNext = function canGoNext(spec) {
  var canGo = true;
  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }
  return canGo;
};

// given an object and a list of keys, return new object with given keys
var extractObject = exports.extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
};

// get initialized state
var initializedState = exports.initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react2.default.Children.count(spec.children);
  var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
  var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
  var slideWidth = void 0;
  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }
    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }
  var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }
  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides({ currentSlide: currentSlide, lazyLoadedList: lazyLoadedList }, spec);
  lazyLoadedList.concat(slidesToLoad);

  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

var slideHandler = exports.slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;

  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide = void 0,
      animationLeft = void 0,
      finalLeft = void 0;
  var state = {},
      nextState = {};
  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};
    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }
    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }
    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList
    };
    nextState = { animating: false };
  } else {
    finalSlide = animationSlide;
    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }
    animationLeft = getTrackLeft(_extends({}, spec, { slideIndex: animationSlide }));
    finalLeft = getTrackLeft(_extends({}, spec, { slideIndex: finalSlide }));
    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }
    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, { currentSlide: animationSlide })));
    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        lazyLoadedList: lazyLoadedList
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_extends({}, spec, { left: animationLeft })),
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        swipeLeft: null
      };
    }
  }
  return { state: state, nextState: nextState };
};

var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;

  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;
    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;
    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    if (targetSlide === options.currentSlide) {
      return null;
    }
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;
    if (targetSlide === options.currentSlide) {
      return null;
    }
    if (infinite) {
      var direction = siblingDirection(_extends({}, spec, { targetSlide: targetSlide }));
      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
    if (targetSlide === options.currentSlide) {
      return null;
    }
  }
  return targetSlide;
};
var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && e.preventDefault();
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};
var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;

  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft = void 0,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return { scrolling: true };
  }
  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;

  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;
  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;
      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }
  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }
  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }
  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }
  state = _extends({}, state, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_extends({}, spec, { left: swipeLeft }))
  });
  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }
  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    e.preventDefault();
  }
  return state;
};
var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      currentSlide = spec.currentSlide,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }
  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
  // reset the state of touch related state variables.
  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };
  if (scrolling) {
    return state;
  }
  if (!touchObject.swipeLength) {
    return state;
  }
  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();
    if (onSwipe) {
      onSwipe(swipeDirection);
    }
    var slideCount = void 0,
        newSlide = void 0;
    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = currentSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;
      case "right":
      case "down":
        newSlide = currentSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;
      default:
        slideCount = currentSlide;
    }
    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, { left: currentLeft }));
  }
  return state;
};
var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];
  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }
  return indexes;
};
var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;
  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }
      prevNavigable = navigables[n];
    }
  }
  return index;
};
var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
  if (spec.swipeToSlide) {
    var swipedSlide = void 0;
    var slickList = _reactDom2.default.findDOMNode(spec.listRef);
    var slides = slickList.querySelectorAll(".slick-slide");
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }
    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth = void 0,
      trackHeight = void 0;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }
  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _extends({}, style, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }
  if (spec.fade) style = { opacity: 1 };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight;

  // Fallback for IE8
  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};
var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }
  return style;
};
var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);

  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;


  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;
  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    }
    // shift current slide to center of the frame
    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }
    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }
  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = _reactDom2.default.findDOMNode(trackRef);
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;
      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }
      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

var getPreClones = exports.getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  if (spec.variableWidth) {
    return spec.slideCount;
  }
  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

var getPostClones = exports.getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  return spec.slideCount;
};

var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};
var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }
    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }
    return "left";
  }
};

var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }
  if (rtl) {
    return 0;
  }
  return slidesToShow - 1;
};

var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }
  if (rtl) {
    return slidesToShow - 1;
  }
  return 0;
};

var canUseDOM = exports.canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

/***/ }),
/* 154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_LoggedInPage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_UserStorageUtil__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_lessons_png__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_lessons_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_lessons_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var imagePath="/lesson/get_lesson_thumbnails?image=";var LessonComponent=function(_PreLoginPage){_inherits(LessonComponent,_PreLoginPage);function LessonComponent(props){_classCallCheck(this,LessonComponent);var _this=_possibleConstructorReturn(this,(LessonComponent.__proto__||Object.getPrototypeOf(LessonComponent)).call(this,props));_this.loadLessonThumbnail=_this.loadLessonThumbnail.bind(_this);_this.lockcontent=_this.lockcontent.bind(_this);// this.isFreeTrail = this.props.isFreeTrail || true;
return _this;}_createClass(LessonComponent,[{key:'componentDidMount',value:function componentDidMount(){}// this.isFreeTrail = this.props.isFreeTrail || true;
//console.log("isFreeTrail2",this.props.isFreeTrail,': ',this.props.isFrom);
//----------------- get lesson thumbnail-----------------
},{key:'loadLessonThumbnail',value:function loadLessonThumbnail(lessonPath){var backgroundImg="";var _url=lessonPath.toLowerCase();var lessonMapClass="";var lid=_url;var thumb="";var lessonURL="";/*if(lid.trim().length>0) {		
  		backgroundImg = (this.getUrlFor("CS_BASE_URL")+imagePath+lid+"&type=lessons");
  		//console.log(imagePath+lid+"&type=lessons");
  	}
  	else{		*/backgroundImg=__WEBPACK_IMPORTED_MODULE_4__images_lessons_png___default.a;//}
return backgroundImg;}},{key:'getListBGImage',value:function getListBGImage(_img){return"url('"+_img+"')";}//--------------------------------
},{key:'openLessonFromScorecard',value:function openLessonFromScorecard(){//console.log("this.props.PLPloggedIn=="+this.props.PLPloggedIn);
if(this.props.isFreeTrail){return;}if(this.props.PLPloggedIn==false||this.props.PLPloggedIn=="false"){this.props.showNewLoginForm();return;}//console.log(this.props.lesson);
var lessonidTracking=this.props.lesson.lessonid||this.props.lesson.lessonId;var lessonid=this.props.lesson.lessonUrl||this.props.lesson.lessonurl;var lessonname=this.props.lesson.lessonName||this.props.lesson.lessonname;var lurl=this.props.lesson.lessonUrl||this.props.lesson.lessonurl;var dd=!isNaN(this.props.lesson.preferredDdId)?this.props.lesson.preferredDdId:!isNaN(this.props.lesson.lessondd)?this.props.lesson.lessondd:0;var lessonPref=this.props.lesson.lessontype;var testid=this.props.testId;var topicSubTopicMapId=this.props.topicSubTopicMapId;var accessId=this.props.accessId;var classId=this.props.classId;var snippetId=this.props.snippetId||"";var source=this.props.source||0;//var _url = lesson_Url+"/lessonViewDD.action?lessonid="+lessonid+"&lessonname="+lessonname+"&url="+lurl+"&src=Revision&&dd="+dd;
//var _url = "https://testrevision.heymath.com/lessonView.action?lessonid="+lessonid+"&lessonname="+lessonname+"&url="+lurl+"&lessonPref="+lessonPref+"&testid="+testid+"&revisiontopicid="+topicSubTopicMapId+"&src=plp&dd="+dd;
var _url="";if(lessonPref==="mozart"){_url="/mozartview/"+lessonid+"?url="+lurl+"&lessonPref="+lessonPref+"&testid="+testid+"&revisiontopicid="+topicSubTopicMapId+"&accessId="+accessId+"&classId="+classId+"&src=plp"+"&lessonidTracking="+lessonidTracking+"&tracksource="+this.props.tracksource+"&snid="+snippetId+"&qsrc="+source;}else{_url="/lessonview/"+lessonid+"?url="+lurl+"&lessonPref="+lessonPref+"&testid="+testid+"&revisiontopicid="+topicSubTopicMapId+"&accessId="+accessId+"&classId="+classId+"&src=plp"+"&lessonidTracking="+lessonidTracking+"&tracksource="+this.props.tracksource+"&snid="+snippetId+"&qsrc="+source;}if(dd>0){_url+="&dd="+dd;}__WEBPACK_IMPORTED_MODULE_3__util_UserStorageUtil__["a" /* default */].storeSessionItem(lurl,lessonname);//console.log(_url);
window.open(_url,lessonid,'fullscreen=yes,menubar=no,width='+window.innerWidth+',height='+window.innerHeight).focus();}},{key:'lockcontent',value:function lockcontent(){if(this.props.isFreeTrail){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons md-40 playicon upgrdlock1'},'lock');}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons md-40 playicon'},'play_circle_filled');}}},{key:'render',value:function render(){var classdisabled="";if(this.props.isFreeTrail){classdisabled="disabled lockdisabledcont";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"card clearfix"+classdisabled,onClick:this.openLessonFromScorecard.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-img-top subtopic text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{height:'90',width:'120',src:this.loadLessonThumbnail(this.props.lesson.lessonUrl||this.props.lesson.lessonurl)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'playContainer'},this.lockcontent())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-title'},this.props.lesson.lessonName||this.props.lesson.lessonname)));}}]);return LessonComponent;}(__WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (LessonComponent);

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(45);
var toLength = __webpack_require__(21);
var toAbsoluteIndex = __webpack_require__(85);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 158 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(52);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(53);
var defined = __webpack_require__(64);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(14);
var cof = __webpack_require__(52);
var MATCH = __webpack_require__(19)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(19)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(110);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(363);
var redefine = __webpack_require__(41);
var hide = __webpack_require__(40);
var fails = __webpack_require__(13);
var defined = __webpack_require__(64);
var wks = __webpack_require__(19);
var regexpExec = __webpack_require__(237);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(41);
var redefineAll = __webpack_require__(91);
var meta = __webpack_require__(78);
var forOf = __webpack_require__(90);
var anInstance = __webpack_require__(89);
var isObject = __webpack_require__(14);
var fails = __webpack_require__(13);
var $iterDetect = __webpack_require__(162);
var setToStringTag = __webpack_require__(109);
var inheritIfRequired = __webpack_require__(223);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var hide = __webpack_require__(40);
var uid = __webpack_require__(83);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(77) || !__webpack_require__(13)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(9)[K];
});


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(1);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(1);
var aFunction = __webpack_require__(34);
var ctx = __webpack_require__(51);
var forOf = __webpack_require__(90);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {(function (global, factory) {
   true ? factory(exports, __webpack_require__(0)) :
  typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) :
  (factory((global.reactAccessibleAccordion = {}),global.React));
}(this, (function (exports,React) { 'use strict';

  var React__default = 'default' in React ? React['default'] : React;

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

      return arr2;
    }
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  // Arbitrary, but ought to be unique to avoid context namespace clashes.
  var CONTEXT_KEY = 'react-accessible-accordion@AccordionContainer';
  var Provider =
  /*#__PURE__*/
  function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Provider)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
        items: _this.props.items || []
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "addItem", function (newItem) {
        // Need to use callback style otherwise race-conditions are created by concurrent registrations.
        _this.setState(function (state) {
          var items;

          if (state.items.some(function (item) {
            return item.uuid === newItem.uuid;
          })) {
            // eslint-disable-next-line no-console
            console.error("AccordionItem error: One item already has the uuid \"".concat(newItem.uuid, "\". Uuid property must be unique. See: https://github.com/springload/react-accessible-accordion#accordionitem"));
          }

          if (_this.props.accordion && newItem.expanded) {
            // If this is a true accordion and the new item is expanded, then the others must be closed.
            items = _toConsumableArray(state.items.map(function (item) {
              return _objectSpread({}, item, {
                expanded: false
              });
            })).concat([newItem]);
          } else {
            items = _toConsumableArray(state.items).concat([newItem]);
          }

          return {
            items: items
          };
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "removeItem", function (key) {
        return _this.setState(function (state) {
          return {
            items: state.items.filter(function (item) {
              return item.uuid !== key;
            })
          };
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setExpanded", function (key, expanded) {
        return _this.setState(function (state) {
          return {
            items: state.items.map(function (item) {
              if (item.uuid === key) {
                return _objectSpread({}, item, {
                  expanded: expanded
                });
              }

              if (_this.props.accordion && expanded) {
                // If this is an accordion, we might need to collapse the other expanded item.
                return _objectSpread({}, item, {
                  expanded: false
                });
              }

              return item;
            })
          };
        }, function () {
          if (_this.props.onChange) {
            _this.props.onChange(_this.props.accordion ? key : _this.state.items.filter(function (item) {
              return item.expanded;
            }).map(function (item) {
              return item.uuid;
            }));
          }
        });
      });

      return _this;
    }

    _createClass(Provider, [{
      key: "getChildContext",
      value: function getChildContext() {
        var context = {
          items: this.state.items,
          accordion: !!this.props.accordion,
          addItem: this.addItem,
          removeItem: this.removeItem,
          setExpanded: this.setExpanded
        };
        return _defineProperty({}, CONTEXT_KEY, context);
      }
    }, {
      key: "render",
      value: function render() {
        return this.props.children || null;
      }
    }]);

    return Provider;
  }(React.Component); // eslint-disable-next-line react/no-multi-comp

  _defineProperty(Provider, "childContextTypes", _defineProperty({}, CONTEXT_KEY, function () {
    return null;
  }));

  var Consumer =
  /*#__PURE__*/
  function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      _classCallCheck(this, Consumer);

      return _possibleConstructorReturn(this, _getPrototypeOf(Consumer).apply(this, arguments));
    }

    _createClass(Consumer, [{
      key: "render",
      value: function render() {
        return this.props.children(this.context[CONTEXT_KEY]);
      }
    }]);

    return Consumer;
  }(React.Component);

  _defineProperty(Consumer, "contextTypes", _defineProperty({}, CONTEXT_KEY, function () {
    return null;
  }));

  var accordionDefaultProps = {
    accordion: true
  };

  var Accordion = function Accordion(_ref) {
    var accordion = _ref.accordion,
        rest = _objectWithoutProperties(_ref, ["accordion"]);

    return React__default.createElement("div", _extends({
      role: accordion ? 'tablist' : null
    }, rest));
  };

  Accordion.defaultProps = accordionDefaultProps;

  var defaultProps = {
    accordion: true,
    onChange: function onChange() {},
    className: 'accordion',
    children: null
  };

  var AccordionWrapper =
  /*#__PURE__*/
  function (_Component) {
    _inherits(AccordionWrapper, _Component);

    function AccordionWrapper() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, AccordionWrapper);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AccordionWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderAccordion", function (accordionStore) {
        var _this$props = _this.props,
            accordion = _this$props.accordion,
            onChange = _this$props.onChange,
            rest = _objectWithoutProperties(_this$props, ["accordion", "onChange"]);

        return React__default.createElement(Accordion, _extends({
          accordion: accordionStore.accordion
        }, rest));
      });

      return _this;
    }

    _createClass(AccordionWrapper, [{
      key: "render",
      value: function render() {
        return React__default.createElement(Provider, {
          accordion: this.props.accordion,
          onChange: this.props.onChange
        }, React__default.createElement(Consumer, null, this.renderAccordion));
      }
    }]);

    return AccordionWrapper;
  }(React.Component);

  _defineProperty(AccordionWrapper, "defaultProps", defaultProps);

  function _extends$1() {
    _extends$1 = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$1.apply(this, arguments);
  }

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * @typechecks
   * 
   */

  function _inheritsLoose$1(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  function unwrapExports (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var lib = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
    var currentListeners = [];
    var nextListeners = currentListeners;

    function ensureCanMutateNextListeners() {
      if (nextListeners === currentListeners) {
        nextListeners = currentListeners.slice();
      }
    }

    function listen(listener) {
      if (typeof listener !== 'function') {
        throw new Error('Expected listener to be a function.');
      }

      var isSubscribed = true;
      ensureCanMutateNextListeners();
      nextListeners.push(listener);
      return function () {
        if (!isSubscribed) {
          return;
        }

        isSubscribed = false;
        ensureCanMutateNextListeners();
        var index = nextListeners.indexOf(listener);
        nextListeners.splice(index, 1);
      };
    }

    function emit() {
      currentListeners = nextListeners;
      var listeners = currentListeners;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i].apply(listeners, arguments);
      }
    }

    return {
      listen: listen,
      emit: emit
    };
  };
  });

  unwrapExports(lib);
  var lib_1 = lib.createChangeEmitter;

  function symbolObservablePonyfill(root) {
    var result;
    var Symbol = root.Symbol;

    if (typeof Symbol === 'function') {
      if (Symbol.observable) {
        result = Symbol.observable;
      } else {
        result = Symbol('observable');
        Symbol.observable = result;
      }
    } else {
      result = '@@observable';
    }

    return result;
  }

  /* global window */
  var root;

  if (typeof self !== 'undefined') {
    root = self;
  } else if (typeof window !== 'undefined') {
    root = window;
  } else if (typeof global !== 'undefined') {
    root = global;
  } else if (true) {
    root = module;
  } else {
    root = Function('return this')();
  }

  var result = symbolObservablePonyfill(root);

  var Nothing =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose$1(Nothing, _Component);

    function Nothing() {
      return _Component.apply(this, arguments) || this;
    }

    var _proto = Nothing.prototype;

    _proto.render = function render() {
      return null;
    };

    return Nothing;
  }(React.Component);

  var fromRenderProps = function fromRenderProps(RenderPropsComponent, propsMapper, renderPropName) {
    if (renderPropName === void 0) {
      renderPropName = 'children';
    }

    return function (BaseComponent) {
      var baseFactory = React__default.createFactory(BaseComponent);
      var renderPropsFactory = React__default.createFactory(RenderPropsComponent);

      var FromRenderProps = function FromRenderProps(ownerProps) {
        var _renderPropsFactory;

        return renderPropsFactory((_renderPropsFactory = {}, _renderPropsFactory[renderPropName] = function () {
          return baseFactory(_extends({}, ownerProps, propsMapper.apply(void 0, arguments)));
        }, _renderPropsFactory));
      };

      return FromRenderProps;
    };
  };

  var compose = function compose() {
    for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
      funcs[_key] = arguments[_key];
    }

    return funcs.reduce(function (a, b) {
      return function () {
        return a(b.apply(void 0, arguments));
      };
    }, function (arg) {
      return arg;
    });
  };

  /*!
   * consecutive
   * Get consecutive numbers
   * Copyright(c) 2017 ivanoff .$ curl -A cv ivanoff.org.ua
   * MIT Licensed
   */

  var consecutive = function (begin, base, inc) {
    var number = begin || 0;
    if (typeof base !== 'number') base = 10;
    if (typeof inc !== 'number') inc = 1;
    return function () {
      var res;

      if (typeof base === 'undefined' || base === 10) {
        res = number;
        number += inc;
      } else {
        res = number.toString();
        number = (parseInt(number, base) + inc).toString(base);
      }

      return res;
    };
  };

  // Arbitrary, but ought to be unique to avoid context namespace clashes.
  var CONTEXT_KEY$1 = 'react-accessible-accordion@ItemContainer';
  var Provider$1 =
  /*#__PURE__*/
  function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      _classCallCheck(this, Provider);

      return _possibleConstructorReturn(this, _getPrototypeOf(Provider).apply(this, arguments));
    }

    _createClass(Provider, [{
      key: "getChildContext",
      value: function getChildContext() {
        var uuid = this.props.uuid;
        var context = {
          uuid: uuid
        };
        return _defineProperty({}, CONTEXT_KEY$1, context);
      }
    }, {
      key: "render",
      value: function render() {
        return this.props.children || null;
      }
    }]);

    return Provider;
  }(React.Component);

  _defineProperty(Provider$1, "childContextTypes", _defineProperty({}, CONTEXT_KEY$1, function () {
    return null;
  }));

  // eslint-disable-next-line react/no-multi-comp
  var Consumer$1 =
  /*#__PURE__*/
  function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      _classCallCheck(this, Consumer);

      return _possibleConstructorReturn(this, _getPrototypeOf(Consumer).apply(this, arguments));
    }

    _createClass(Consumer, [{
      key: "render",
      value: function render() {
        return this.props.children(this.context[CONTEXT_KEY$1]);
      }
    }]);

    return Consumer;
  }(React.Component);

  _defineProperty(Consumer$1, "contextTypes", _defineProperty({}, CONTEXT_KEY$1, function () {
    return null;
  }));

  var classnames = createCommonjsModule(function (module) {
  /*!
    Copyright (c) 2016 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */

  /* global define */
  (function () {

    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          classes.push(classNames.apply(null, arg));
        } else if (argType === 'object') {
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      module.exports = classNames;
    } else if (false) {
      // register as 'classnames', consistent with npm package name
      undefined('classnames', [], function () {
        return classNames;
      });
    } else {
      window.classNames = classNames;
    }
  })();
  });

  var AccordionItem =
  /*#__PURE__*/
  function (_Component) {
    _inherits(AccordionItem, _Component);

    function AccordionItem() {
      _classCallCheck(this, AccordionItem);

      return _possibleConstructorReturn(this, _getPrototypeOf(AccordionItem).apply(this, arguments));
    }

    _createClass(AccordionItem, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this$props = this.props,
            uuid = _this$props.uuid,
            accordionStore = _this$props.accordionStore,
            disabled = _this$props.disabled;
        accordionStore.addItem({
          uuid: uuid,
          expanded: this.props.expanded || false,
          disabled: disabled
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.props.accordionStore.removeItem(this.props.uuid);
      } // This is here so that the user can dynamically set the 'expanded' state using the 'expanded' prop.

    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this$props2 = this.props,
            uuid = _this$props2.uuid,
            expanded = _this$props2.expanded,
            accordionStore = _this$props2.accordionStore;

        if (expanded !== prevProps.expanded) {
          accordionStore.setExpanded(uuid, expanded);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props3 = this.props,
            uuid = _this$props3.uuid,
            className = _this$props3.className,
            hideBodyClassName = _this$props3.hideBodyClassName,
            accordionStore = _this$props3.accordionStore,
            disabled = _this$props3.disabled,
            expanded = _this$props3.expanded,
            rest = _objectWithoutProperties(_this$props3, ["uuid", "className", "hideBodyClassName", "accordionStore", "disabled", "expanded"]); // Deliberately not using 'find' because IE compat.


        var currentItem = accordionStore.items.filter(function (item) {
          return item.uuid === uuid;
        })[0];

        if (!currentItem) {
          return null;
        }

        return React__default.createElement("div", _extends({
          className: classnames(className, _defineProperty({}, hideBodyClassName, !currentItem.expanded && hideBodyClassName))
        }, rest));
      }
    }]);

    return AccordionItem;
  }(React.Component);

  var nextUuid = consecutive();
  function resetNextUuid() {
    nextUuid = consecutive();
  }

  var AccordionItemWrapper =
  /*#__PURE__*/
  function (_Component) {
    _inherits(AccordionItemWrapper, _Component);

    function AccordionItemWrapper() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, AccordionItemWrapper);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AccordionItemWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "id", nextUuid());

      return _this;
    }

    _createClass(AccordionItemWrapper, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            accordionStore = _this$props.accordionStore,
            uuid = _this$props.uuid,
            rest = _objectWithoutProperties(_this$props, ["accordionStore", "uuid"]);

        var itemUuid = uuid !== undefined ? uuid : this.id;
        return React__default.createElement(Provider$1, {
          uuid: itemUuid
        }, React__default.createElement(AccordionItem, _extends({}, rest, {
          uuid: itemUuid,
          accordionStore: accordionStore
        })));
      }
    }]);

    return AccordionItemWrapper;
  }(React.Component);

  _defineProperty(AccordionItemWrapper, "defaultProps", {
    className: 'accordion__item',
    hideBodyClassName: '',
    disabled: false,
    expanded: false,
    uuid: undefined
  });

  var AccordionItem_wrapper = compose(fromRenderProps(Consumer, function (accordionStore) {
    return {
      accordionStore: accordionStore
    };
  }))(AccordionItemWrapper);

  var AccordionItemTitle =
  /*#__PURE__*/
  function (_Component) {
    _inherits(AccordionItemTitle, _Component);

    function AccordionItemTitle() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, AccordionItemTitle);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AccordionItemTitle)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function () {
        var _this$props = _this.props,
            uuid = _this$props.uuid,
            expanded = _this$props.expanded,
            setExpanded = _this$props.setExpanded;
        setExpanded(uuid, !expanded);
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeyPress", function (evt) {
        if (evt.charCode === 13 || evt.charCode === 32) {
          evt.preventDefault();

          _this.handleClick();
        }
      });

      return _this;
    }

    _createClass(AccordionItemTitle, [{
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            className = _this$props2.className,
            hideBodyClassName = _this$props2.hideBodyClassName,
            item = _this$props2.item,
            accordion = _this$props2.accordion,
            setExpanded = _this$props2.setExpanded,
            expanded = _this$props2.expanded,
            uuid = _this$props2.uuid,
            disabled = _this$props2.disabled,
            rest = _objectWithoutProperties(_this$props2, ["className", "hideBodyClassName", "item", "accordion", "setExpanded", "expanded", "uuid", "disabled"]);

        var id = "accordion__title-".concat(uuid);
        var ariaControls = "accordion__body-".concat(uuid);
        var role = accordion ? 'tab' : 'button';
        var titleClassName = classnames(className, _defineProperty({}, hideBodyClassName, hideBodyClassName && !expanded));

        if (role === 'tab') {
          return React__default.createElement("div", _extends({
            id: id,
            "aria-selected": expanded,
            "aria-controls": ariaControls,
            className: titleClassName,
            onClick: disabled ? undefined : this.handleClick,
            role: role,
            tabIndex: "0" // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
            ,
            onKeyPress: this.handleKeyPress,
            disabled: disabled
          }, rest));
        }

        return React__default.createElement("div", _extends({
          id: id,
          "aria-expanded": expanded,
          "aria-controls": ariaControls,
          className: titleClassName,
          onClick: disabled ? undefined : this.handleClick,
          role: role,
          tabIndex: "0" // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
          ,
          onKeyPress: this.handleKeyPress,
          disabled: disabled
        }, rest));
      }
    }]);

    return AccordionItemTitle;
  }(React.Component);

  _defineProperty(AccordionItemTitle, "accordionElementName", 'AccordionItemTitle');

  // eslint-disable-next-line react/prefer-stateless-function
  var AccordionItemTitleWrapper =
  /*#__PURE__*/
  function (_Component) {
    _inherits(AccordionItemTitleWrapper, _Component);

    function AccordionItemTitleWrapper() {
      _classCallCheck(this, AccordionItemTitleWrapper);

      return _possibleConstructorReturn(this, _getPrototypeOf(AccordionItemTitleWrapper).apply(this, arguments));
    }

    _createClass(AccordionItemTitleWrapper, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            itemStore = _this$props.itemStore,
            accordionStore = _this$props.accordionStore,
            rest = _objectWithoutProperties(_this$props, ["itemStore", "accordionStore"]);

        var uuid = itemStore.uuid;
        var items = accordionStore.items,
            accordion = accordionStore.accordion;
        var item = items.filter(function (stateItem) {
          return stateItem.uuid === uuid;
        })[0];
        return React__default.createElement(AccordionItemTitle, _extends({}, rest, item, {
          setExpanded: accordionStore.setExpanded,
          accordion: accordion
        }));
      }
    }]);

    return AccordionItemTitleWrapper;
  }(React.Component);

  _defineProperty(AccordionItemTitleWrapper, "defaultProps", {
    className: 'accordion__title',
    hideBodyClassName: ''
  });

  var AccordionItemTitle_wrapper = compose(fromRenderProps(Consumer, function (accordionStore) {
    return {
      accordionStore: accordionStore
    };
  }), fromRenderProps(Consumer$1, function (itemStore) {
    return {
      itemStore: itemStore
    };
  }))(AccordionItemTitleWrapper);

  var AccordionItemBody = function AccordionItemBody(props) {
    var className = props.className,
        hideBodyClassName = props.hideBodyClassName,
        uuid = props.uuid,
        expanded = props.expanded,
        disabled = props.disabled,
        accordion = props.accordion,
        rest = _objectWithoutProperties(props, ["className", "hideBodyClassName", "uuid", "expanded", "disabled", "accordion"]);

    return React__default.createElement("div", _extends({
      id: "accordion__body-".concat(uuid),
      className: classnames(className, _defineProperty({}, hideBodyClassName, !expanded)),
      "aria-hidden": !expanded,
      "aria-labelledby": "accordion__title-".concat(uuid),
      role: accordion ? 'tabpanel' : null
    }, rest));
  };

  // eslint-disable-next-line react/prefer-stateless-function
  var AccordionItemBodyWrapper =
  /*#__PURE__*/
  function (_Component) {
    _inherits(AccordionItemBodyWrapper, _Component);

    function AccordionItemBodyWrapper() {
      _classCallCheck(this, AccordionItemBodyWrapper);

      return _possibleConstructorReturn(this, _getPrototypeOf(AccordionItemBodyWrapper).apply(this, arguments));
    }

    _createClass(AccordionItemBodyWrapper, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            itemStore = _this$props.itemStore,
            accordionStore = _this$props.accordionStore,
            rest = _objectWithoutProperties(_this$props, ["itemStore", "accordionStore"]);

        var uuid = itemStore.uuid;
        var items = accordionStore.items,
            accordion = accordionStore.accordion;
        var item = items.filter(function (stateItem) {
          return stateItem.uuid === uuid;
        })[0];
        return item ? React__default.createElement(AccordionItemBody, _extends({}, rest, item, {
          accordion: accordion
        })) : null;
      }
    }]);

    return AccordionItemBodyWrapper;
  }(React.Component);

  _defineProperty(AccordionItemBodyWrapper, "defaultProps", {
    className: 'accordion__body',
    hideBodyClassName: 'accordion__body--hidden'
  });

  var AccordionItemBody_wrapper = compose(fromRenderProps(Consumer, function (accordionStore) {
    return {
      accordionStore: accordionStore
    };
  }), fromRenderProps(Consumer$1, function (itemStore) {
    return {
      itemStore: itemStore
    };
  }))(AccordionItemBodyWrapper);

  // eslint-disable-next-line

  exports.Accordion = AccordionWrapper;
  exports.AccordionItem = AccordionItem_wrapper;
  exports.AccordionItemTitle = AccordionItemTitle_wrapper;
  exports.AccordionItemBody = AccordionItemBody_wrapper;
  exports.resetNextUuid = resetNextUuid;

  Object.defineProperty(exports, '__esModule', { value: true });

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28), __webpack_require__(243)(module)))

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 173 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 174 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(71).f;
var has = __webpack_require__(95);
var TAG = __webpack_require__(43)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shouldUpdate = __webpack_require__(930);

var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);

var _shallowEqual = __webpack_require__(259);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _setDisplayName = __webpack_require__(404);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(405);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pure = function pure(BaseComponent) {
  var hoc = (0, _shouldUpdate2.default)(function (props, nextProps) {
    return !(0, _shallowEqual2.default)(props, nextProps);
  });

  if (false) {
    return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

exports.default = pure;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _SvgIcon = __webpack_require__(933);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SvgIcon2.default;

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_common_Landing__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mdl_materialUsage_css__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mdl_materialUsage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__mdl_materialUsage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home_style_violet_css__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home_style_violet_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__home_style_violet_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__home_custom_css__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__home_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__home_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__css_myHome_css__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__css_myHome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__css_myHome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TopicComponent__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SubTopicComponent__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TestTakingModalComponent__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SubscribeModal__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_loader_spinner__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_loader_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_loader_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TestInfo__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__GetTest__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_html_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_super_responsive_table_dist_SuperResponsiveTableStyle_css__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_super_responsive_table_dist_SuperResponsiveTableStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_super_responsive_table_dist_SuperResponsiveTableStyle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_dropdown__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_dropdown_style_css__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_dropdown_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_dropdown_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_slick_carousel_slick_slick_css__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_slick_carousel_slick_slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_slick_carousel_slick_slick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_slick_carousel_slick_slick_theme_css__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_slick_carousel_slick_slick_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_slick_carousel_slick_slick_theme_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_slick__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_scorecard_LessonComponent__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__images_icons_recom_lesson_png__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__images_icons_recom_lesson_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__images_icons_recom_lesson_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__warning_DesktopOnly__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__SearchboxComp__ = __webpack_require__(1000);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import { Table } from 'reactstrap';
/*import Swiper from 'react-id-swiper';*/var substImgPath=function substImgPath(url,substPath){try{if(url&&url.length>0){return url.replace("https://","").replace("http://","").replace(window.s3_base_path,substPath);}}catch(e){console.error("error occurred while substituting S3 img path ::",e);}return url;};var topicListPlaceHolder="{\"4\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":4,\"topicId\":2,\"subTopicId\":4,\"topicName\":\"Decimals\",\"subTopicName\":\"Introduction to Decimals\",\"subtopicStatus\":{\"topicsubtopicId\":4,\"testId\":1,\"revisiontestid\":4,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"COMPLETED\",\"referenceId\":\"4\",\"recommendtestid\":\"2\",\"testScore\":\"1\",\"testTotalScore\":\"10\",\"recommendTestScore\":\"3\",\"recommendTestTotalScore\":\"9\",\"cumulativeScore\":\"4\",\"cumulativeTotalScore\":\"10\"},\"displayorder\":1,\"styleid\":1,\"animationGif\":\"05-fivedecimal\"},\"5\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":5,\"topicId\":2,\"subTopicId\":5,\"topicName\":\"Decimals\",\"subTopicName\":\"Addition and Subtraction of Decimals\",\"subtopicStatus\":{\"topicsubtopicId\":5,\"testId\":9,\"revisiontestid\":5,\"testStatus\":\"IN_PROGRESS\",\"reqTestStatus\":null,\"referenceId\":\"5\",\"recommendtestid\":\"0\",\"testScore\":\"0\",\"testTotalScore\":\"5\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"0\",\"cumulativeScore\":\"0\",\"cumulativeTotalScore\":\"5\"},\"displayorder\":2,\"styleid\":1,\"animationGif\":\"05-fivedecimal\"},\"6\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":6,\"topicId\":2,\"subTopicId\":6,\"topicName\":\"Decimals\",\"subTopicName\":\"Multiplication and Division of Decimals\",\"subtopicStatus\":{\"topicsubtopicId\":6,\"testId\":39,\"revisiontestid\":6,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"NEW\",\"referenceId\":\"6\",\"recommendtestid\":\"40\",\"testScore\":\"1\",\"testTotalScore\":\"7\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"6\",\"cumulativeScore\":\"1\",\"cumulativeTotalScore\":\"7\"},\"displayorder\":3,\"styleid\":1,\"animationGif\":\"05-fivedecimal\"},\"7\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":7,\"topicId\":2,\"subTopicId\":7,\"topicName\":\"Decimals\",\"subTopicName\":\"Application Problems\",\"subtopicStatus\":{\"topicsubtopicId\":7,\"testId\":52,\"revisiontestid\":7,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"NEW\",\"referenceId\":\"7\",\"recommendtestid\":\"53\",\"testScore\":\"0\",\"testTotalScore\":\"5\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"5\",\"cumulativeScore\":\"0\",\"cumulativeTotalScore\":\"5\"},\"displayorder\":4,\"styleid\":1,\"animationGif\":\"05-fivedecimal\"},\"12\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":12,\"topicId\":5,\"subTopicId\":12,\"topicName\":\"Factors and Multiples\",\"subTopicName\":\"Prime Factors and Tests of Divisibility\",\"subtopicStatus\":{\"topicsubtopicId\":12,\"testId\":13,\"revisiontestid\":12,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"COMPLETED\",\"referenceId\":\"12\",\"recommendtestid\":\"14\",\"testScore\":\"0\",\"testTotalScore\":\"3\",\"recommendTestScore\":\"2\",\"recommendTestTotalScore\":\"3\",\"cumulativeScore\":\"2\",\"cumulativeTotalScore\":\"3\"},\"displayorder\":5,\"styleid\":2,\"animationGif\":\"05-fivefactmult\"},\"13\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":13,\"topicId\":5,\"subTopicId\":13,\"topicName\":\"Factors and Multiples\",\"subTopicName\":\"HCF and LCM\",\"subtopicStatus\":{\"topicsubtopicId\":13,\"testId\":19,\"revisiontestid\":13,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"COMPLETED\",\"referenceId\":\"13\",\"recommendtestid\":\"20\",\"testScore\":\"0\",\"testTotalScore\":\"4\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"4\",\"cumulativeScore\":\"0\",\"cumulativeTotalScore\":\"4\"},\"displayorder\":6,\"styleid\":2,\"animationGif\":\"05-fivefactmult\"},\"14\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":14,\"topicId\":5,\"subTopicId\":7,\"topicName\":\"Factors and Multiples\",\"subTopicName\":\"Application Problems\",\"subtopicStatus\":{\"topicsubtopicId\":14,\"testId\":22,\"revisiontestid\":14,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"COMPLETED\",\"referenceId\":\"14\",\"recommendtestid\":\"23\",\"testScore\":\"0\",\"testTotalScore\":\"5\",\"recommendTestScore\":\"1\",\"recommendTestTotalScore\":\"5\",\"cumulativeScore\":\"1\",\"cumulativeTotalScore\":\"5\"},\"displayorder\":7,\"styleid\":2,\"animationGif\":\"05-fivefactmult\"},\"15\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":15,\"topicId\":6,\"subTopicId\":14,\"topicName\":\"Fractions\",\"subTopicName\":\"Introduction to Fractions\",\"subtopicStatus\":{\"topicsubtopicId\":15,\"testId\":0,\"revisiontestid\":15,\"testStatus\":null,\"reqTestStatus\":null,\"referenceId\":\"0\",\"recommendtestid\":\"0\",\"testScore\":\"0\",\"testTotalScore\":\"0\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"0\",\"cumulativeScore\":\"0\",\"cumulativeTotalScore\":\"0\"},\"displayorder\":8,\"styleid\":3,\"animationGif\":\"05-fivefraction\"},\"16\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":16,\"topicId\":6,\"subTopicId\":15,\"topicName\":\"Fractions\",\"subTopicName\":\"Addition and Subtraction of fractions\",\"subtopicStatus\":{\"topicsubtopicId\":16,\"testId\":44,\"revisiontestid\":16,\"testStatus\":\"NEW\",\"reqTestStatus\":null,\"referenceId\":\"16\",\"recommendtestid\":\"0\",\"testScore\":\"0\",\"testTotalScore\":\"7\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"0\",\"cumulativeScore\":\"0\",\"cumulativeTotalScore\":\"7\"},\"displayorder\":9,\"styleid\":3,\"animationGif\":\"05-fivefraction\"},\"17\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":17,\"topicId\":6,\"subTopicId\":16,\"topicName\":\"Fractions\",\"subTopicName\":\"Multiplication and Division of fractions\",\"subtopicStatus\":{\"topicsubtopicId\":17,\"testId\":54,\"revisiontestid\":17,\"testStatus\":\"IN_PROGRESS\",\"reqTestStatus\":null,\"referenceId\":\"17\",\"recommendtestid\":\"0\",\"testScore\":\"0\",\"testTotalScore\":\"6\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"0\",\"cumulativeScore\":\"0\",\"cumulativeTotalScore\":\"6\"},\"displayorder\":10,\"styleid\":3,\"animationGif\":\"05-fivefraction\"},\"18\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":18,\"topicId\":6,\"subTopicId\":7,\"topicName\":\"Fractions\",\"subTopicName\":\"Application Problems\",\"subtopicStatus\":{\"topicsubtopicId\":18,\"testId\":41,\"revisiontestid\":18,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"IN_PROGRESS\",\"referenceId\":\"18\",\"recommendtestid\":\"42\",\"testScore\":\"0\",\"testTotalScore\":\"4\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"4\",\"cumulativeScore\":\"0\",\"cumulativeTotalScore\":\"4\"},\"displayorder\":11,\"styleid\":3,\"animationGif\":\"05-fivefraction\"},\"19\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":19,\"topicId\":7,\"subTopicId\":17,\"topicName\":\"Percentages\",\"subTopicName\":\"Percentages\",\"subtopicStatus\":{\"topicsubtopicId\":19,\"testId\":34,\"revisiontestid\":19,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"IN_PROGRESS\",\"referenceId\":\"19\",\"recommendtestid\":\"51\",\"testScore\":\"0\",\"testTotalScore\":\"8\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"8\",\"cumulativeScore\":\"0\",\"cumulativeTotalScore\":\"8\"},\"displayorder\":12,\"styleid\":4,\"animationGif\":\"05-fivepercentage\"},\"20\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":20,\"topicId\":7,\"subTopicId\":18,\"topicName\":\"Percentages\",\"subTopicName\":\"More on Percentages\",\"subtopicStatus\":{\"topicsubtopicId\":20,\"testId\":50,\"revisiontestid\":20,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"IN_PROGRESS\",\"referenceId\":\"20\",\"recommendtestid\":\"56\",\"testScore\":\"2\",\"testTotalScore\":\"8\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"6\",\"cumulativeScore\":\"2\",\"cumulativeTotalScore\":\"8\"},\"displayorder\":13,\"styleid\":4,\"animationGif\":\"05-fivepercentage\"}}";//var selectedProductOption = "";
//var selectedGradeOption = "";
var settings={dots:false,infinite:false,speed:300,slidesToShow:5,slidesToScroll:5,responsive:[{breakpoint:1370,settings:{slidesToShow:4,slidesToScroll:4,infinite:false,dots:false}},{breakpoint:1100,settings:{slidesToShow:3,slidesToScroll:3,infinite:false,dots:false}},{breakpoint:767,settings:{slidesToShow:2,slidesToScroll:2}},{breakpoint:550,settings:{slidesToShow:1,slidesToScroll:1}// You can unslick at a given breakpoint now by adding:
// settings: "unslick"
// instead of a settings object
}]};function groupTopicsBy(list,lessonOnlyMode){var s3BasePath=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"";var topicList=[];var tempTopicMap={};for(var i in list){if(list[i].subtopicStatus){var topicId=list[i].topicId;var topicOb=tempTopicMap[topicId];if(topicOb==null){topicOb={};//Topic Atttributes here
topicOb.topicId=topicId;topicOb.classId=list[i].classId;topicOb.className=list[i].className;topicOb.topicName=list[i].topicName;topicOb.topicDescription=list[i].topicDescription;topicOb.topicSubTopicMapId=list[i].topicSubTopicMapId;/*topicOb.staticImgPath = list[i].staticImgPath; 
			topicOb.animatedImgPath = list[i].animatedImgPath;*//*topicOb.staticImgPath = substImgPath(list[i].staticImgPath,s3BasePath); 
			topicOb.animatedImgPath = substImgPath(list[i].animatedImgPath,s3BasePath);*/topicOb.colourCode=list[i].colourCode;topicOb.styleid=list[i].styleid;topicOb.statusArr=[];topicOb.scoreNumeratorArr=[];topicOb.scoreDenominatorArr=[];topicOb.topicPoints=0;topicOb.userTopicPoints=0;//Check if topic is locked
topicOb.topicLocked=list[i].topicLocked&&list[i].topicLocked===true?list[i].topicLocked:false;//topicOb.practiceLocked = list[i].practiceLocked;	
}if(topicOb["subTopicMap"]!=undefined&&topicOb["subTopicMap"]!=null){topicOb["subTopicMap"];}else{topicOb["subTopicMap"]={};topicOb["sortedSubTopicArr"]=[];}if(!topicOb["subTopicMap"][list[i].subTopicId]){var subTopicObj={};//Subtopic Atttributes here
subTopicObj.subTopicId=list[i].subTopicId;subTopicObj.subTopicName=list[i].subTopicName;subTopicObj.reqTestStatus=list[i].subtopicStatus.reqTestStatus?list[i].subtopicStatus.reqTestStatus:null;subTopicObj.revisiontestid=list[i].subtopicStatus.revisiontestid;subTopicObj.testId=list[i].subtopicStatus.testId;subTopicObj.testStatus=list[i].subtopicStatus.testStatus?list[i].subtopicStatus.testStatus:null;subTopicObj.topicsubtopicId=list[i].subtopicStatus.topicsubtopicId;subTopicObj.recommendtestid=list[i].subtopicStatus.recommendtestid;subTopicObj.displayorder=list[i].displayorder;topicOb.topicPoints+=subTopicObj.subTopicPoints=list[i].subtopicStatus.subTopicPoints?list[i].subtopicStatus.subTopicPoints:0;topicOb.userTopicPoints+=subTopicObj.userPoints=list[i].subtopicStatus.userPoints?list[i].subtopicStatus.userPoints:0;subTopicObj.grade=list[i].subtopicStatus.grade?list[i].subtopicStatus.grade:"";subTopicObj.cumulativeScore=parseInt(list[i].subtopicStatus.cumulativeScore);subTopicObj.cumulativeTotalScore=parseInt(list[i].subtopicStatus.cumulativeTotalScore);subTopicObj.recommendTestScore=parseInt(list[i].subtopicStatus.recommendTestScore);subTopicObj.recommendTestTotalScore=parseInt(list[i].subtopicStatus.recommendTestTotalScore);subTopicObj.testScore=parseInt(list[i].subtopicStatus.testScore);subTopicObj.testTotalScore=parseInt(list[i].subtopicStatus.testTotalScore);subTopicObj.percentScore=Math.round(subTopicObj.cumulativeScore/subTopicObj.cumulativeTotalScore*100);subTopicObj.topicNumerator=subTopicObj.cumulativeScore;subTopicObj.topicDenominator=subTopicObj.cumulativeTotalScore;subTopicObj.rating=parseInt(list[i].subtopicStatus.rating);subTopicObj.parentTopicId=topicId;subTopicObj.practiceLocked=list[i].practiceLocked;subTopicObj.purchased=list[i].purchased;subTopicObj.classId=topicOb.classId;subTopicObj.noOfRetakesAvailable=parseInt(list[i].subtopicStatus.noOfRetakesAvailable);if(lessonOnlyMode){subTopicObj.lessonsSubTopicArr=list[i].subtopicStatus.lessonDefnList;/**
				* IMPORTANT: Sort the lessons based on displayOrder
				*/if(subTopicObj.lessonsSubTopicArr&&subTopicObj.lessonsSubTopicArr.length>0){subTopicObj.lessonsSubTopicArr.sort(function(a,b){if(a&&b&&a.displayOrder&&b.displayOrder){return a.displayOrder-b.displayOrder;}return 0;});}}if(list[i].subtopicStatus!=null){if(list[i].subtopicStatus.reqTestStatus==null&&list[i].subtopicStatus.testStatus==null){subTopicObj.status="NEW";}else if(list[i].subtopicStatus.reqTestStatus=="NEW"&&list[i].subtopicStatus.testStatus==null||list[i].subtopicStatus.reqTestStatus==null&&list[i].subtopicStatus.testStatus=="NEW"){subTopicObj.status="NEW";}else if(list[i].subtopicStatus.reqTestStatus=="COMPLETED"&&list[i].subtopicStatus.testStatus=="COMPLETED"){subTopicObj.status="COMPLETED";}else if(list[i].subtopicStatus.recommendtestid==0&&list[i].subtopicStatus.testStatus=="COMPLETED"){subTopicObj.status="COMPLETED";}else{subTopicObj.status="IN_PROGRESS";}}else{subTopicObj.status="NEW";}if(lessonOnlyMode){subTopicObj.status=list[i].subtopicStatus.lessonStatus;}topicOb.scoreNumeratorArr.push(subTopicObj.topicNumerator);topicOb.scoreDenominatorArr.push(subTopicObj.topicDenominator);topicOb.statusArr.push(subTopicObj.status);topicOb["subTopicMap"][subTopicObj.subTopicId]=subTopicObj;topicOb["sortedSubTopicArr"].push(subTopicObj);}tempTopicMap[topicId]=topicOb;}//console.log("Temp topic ",topicOb)
}for(var j in tempTopicMap){topicList.push(topicStatusCheck(tempTopicMap[j]));}//Sorting of Topics goes here
topicList=sortTopics(topicList);//console.log("topicList ::", topicList);
return topicList;}function topicStatusCheck(topicOb){try{if(topicOb.statusArr!=null){if(topicOb.statusArr.indexOf("IN_PROGRESS")>=0){topicOb.status="IN_PROGRESS";}else{if(topicOb.statusArr.indexOf("NEW")<0&&topicOb.statusArr.indexOf("UN_ATTEMPTED")<0){topicOb.status="COMPLETED";}else{if(topicOb.statusArr.indexOf("COMPLETED")<0){topicOb.status="NEW";}else{topicOb.status="IN_PROGRESS";}}}}if(topicOb.scoreNumeratorArr!=null&&topicOb.scoreDenominatorArr!=null){var _numerator=0;var _denominator=0;for(var i=0;i<topicOb.scoreNumeratorArr.length;i++){_numerator+=topicOb.scoreNumeratorArr[i];_denominator+=topicOb.scoreDenominatorArr[i];}var percentScore=Math.round(_numerator/_denominator*100);topicOb.percentScore=percentScore;}}catch(e){}return topicOb;}/**
 * Topics Sorting is not present. Future Implementation if required
 */function sortTopics(topicObj){try{for(var t in topicObj){topicObj[t]["sortedSubTopicArr"]=sortSubTopics(topicObj[t]["sortedSubTopicArr"]);}}catch(e){}return topicObj;}/**
 * Sub-Topics Sorting
 */function sortSubTopics(subTopicArr){try{var sortedSubTopicArr=subTopicArr.sort(function(a,b){return a.displayorder-b.displayorder;});return sortedSubTopicArr;}catch(e){}return subTopicArr;}var loadingView="loadingView";var topicView="topicView";var subTopicView="subTopicView";var messageView="messageView";var productExpiredView="productExpiredView";var allTopicsView="allTopicsView";var pointsSystemView="pointsSystemView";var noProductView="noProductView";var desktopOnlyView="desktopOnlyView";var gradePointsMap={"grades":[{"id":1,"name":"defaultGradeCalculator","grade":"C","minPercent":0,"maxPercent":39},{"id":1,"name":"defaultGradeCalculator","grade":"B","minPercent":40,"maxPercent":64},{"id":1,"name":"defaultGradeCalculator","grade":"B+","minPercent":65,"maxPercent":74},{"id":1,"name":"defaultGradeCalculator","grade":"A","minPercent":75,"maxPercent":84},{"id":1,"name":"defaultGradeCalculator","grade":"A+","minPercent":85,"maxPercent":100}],"points":{"hard":{"1":30,"2":20,"3":15},"medium":{"1":20,"2":13,"3":10},"easy":{"1":10,"2":7,"3":5}}};var Home=function(_Landing){_inherits(Home,_Landing);function Home(props){_classCallCheck(this,Home);var _this=_possibleConstructorReturn(this,(Home.__proto__||Object.getPrototypeOf(Home)).call(this,props));_this.state={topics:[],lessonArr:[],subtopics:[],selectedTopic:[],selectedSubTopic:[],selectedTopicIndex:null,view:loadingView,message:"",modalShow:false,modalContent:"loading",modalTitle:"",modalView:"loading",productArr:[],gradeArr:[],lessonOnlyMode:false,subTopicBoxColor:"#77b900",productExpired:false,noProducts:false,topicSubView:allTopicsView,purchased:true,SubscribeModal:false};_this.searchBarComp=null;_this.onTopicChangedEvent=_this.onTopicChangedEvent.bind(_this);_this.onSubTopicChangedEvent=_this.onSubTopicChangedEvent.bind(_this);_this.getTopicList=_this.getTopicList.bind(_this);_this.showAllTopics=_this.showAllTopics.bind(_this);_this.showModal=_this.showModal.bind(_this);_this.hideModal=_this.hideModal.bind(_this);_this.startTest=_this.startTest.bind(_this);_this.topicPointClick=_this.topicPointClick.bind(_this);_this.setModalBackdropClose=_this.setModalBackdropClose.bind(_this);_this.accessId=0;_this.gradeProductMap={};_this.selectedGradeOption=null;_this.selectedProductOption=null;_this.comboNamesLoaded=false;_this.gradeStore=null;_this.homeDropDownKey="homeDropdown";_this.preferredGrade=null;_this.preferredProduct=null;_this.TestTypeLbl="";_this.showSubscribemodal=_this.showSubscribemodal.bind(_this);_this.hideSubscribeModal=_this.hideSubscribeModal.bind(_this);_this.assignStateFromParent=_this.assignStateFromParent.bind(_this);_this.showFormobile=_this.showFormobile.bind(_this);_this.goToLanding=_this.goToLanding.bind(_this);_this.setChild(_this,"HOME");return _this;}_createClass(Home,[{key:'assignStateFromParent',value:function assignStateFromParent(obj){if(obj){this.setState(obj);}}},{key:'componentDidMount',value:function componentDidMount(){_get(Home.prototype.__proto__||Object.getPrototypeOf(Home.prototype),'componentDidMount',this).call(this);if(this.productsAvailableToAccess()){//this.getGradeList();
this.getPointDetails();}this.fireMobileToast();}},{key:'productsAvailableToAccess',value:function productsAvailableToAccess(){var user=this.getUser();if(user!=null){var permissions=user.getPermissions();if(permissions!=null&&Object.keys(permissions).length>0){for(var i in permissions){if(permissions[i]!=null){var totalLevel=permissions[i].split(",").reduce(function(a,b){try{return parseInt(a)+parseInt(b);}catch(e){return 0;}});if(totalLevel>0){return true;}}}}}return false;}},{key:'isLessonTabAvailable',value:function isLessonTabAvailable(){//This is restricted to only Mobile check for now
return this.showFormobile();}},{key:'showFormobile',value:function showFormobile(){var isMobileOrTab=this.isTab()||this.isMobile();var lessonLockForGrades=window.lessonLockForGrades||[];var gradeVal=!isNaN(this.selectedGradeOption.value)?Number(this.selectedGradeOption.value):0;return!(lessonLockForGrades.indexOf(gradeVal)>-1&&isMobileOrTab);}},{key:'getPointDetails',value:function getPointDetails(){var me=this;var callBackSuccess=function callBackSuccess(response){//console.log("point response::",response);	
if(response){gradePointsMap=response;}};var callBackFailure=function callBackFailure(response){console.log("Failure::: in GET_POINTS_DETAILS");};new __WEBPACK_IMPORTED_MODULE_8__util_HmAjax__["a" /* default */](this.getUrlFor("GET_POINTS_DETAILS")).get(callBackSuccess,callBackFailure);}},{key:'isLessonOnlyProduct',value:function isLessonOnlyProduct(accessId){var lessonOnlyProds=window.lessonOnlyEntl||["PLP|LESSON|VIEW","TCHR|LESSON|VIEW"];if(lessonOnlyProds&&lessonOnlyProds.length>0){return lessonOnlyProds.indexOf(this.getUser().getAccessMap()[accessId])>-1;}else{return false;}}/**
	* This method will extract lesson from topicListObj
	**/},{key:'getLessonArr',value:function getLessonArr(topicList){var accessVal=!isNaN(this.selectedGradeOption.value)?Number(this.selectedGradeOption.value):0;var gradeVal=!isNaN(this.selectedProductOption.value)?Number(this.selectedProductOption.value):0;var lessonIdSet=new Set();var lessonArr=[];var codeStartTime=Math.round(performance.now());if(topicList&&Object.values(topicList).length>0){Object.values(topicList).map(function(topic,ind){if(topic.subtopicStatus&&topic.subtopicStatus.lessonDefnList&&topic.subtopicStatus.lessonDefnList.length>0){topic.subtopicStatus.lessonDefnList.map(function(lesson,ind){if(lesson&&lesson.lessonurl){if(!lessonIdSet.has(lesson.lessonurl)){lessonIdSet.add(lesson.lessonurl);lesson["classId"]=gradeVal;lesson["accessId"]=accessVal;lesson["subTopicId"]=topic.subTopicId;lesson["topicId"]=topic.topicId;lesson["topicSubTopicMapId"]=topic.topicSubTopicMapId;lessonArr.push(lesson);}}});}});}console.warn("Time Taken to process Lessons from Topic : ",Math.round(performance.now())-codeStartTime+" ms");return lessonArr;}},{key:'getTopicList',value:function getTopicList(){var myView=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var me=this;me.setState({productExpired:false,topicSubView:allTopicsView});var permissions=this.getUser().getPermissions();var entlhistory=this.getUser().getEntlHistory();//console.log(permissions);
//console.log(entlhistory);
/*if((permissions && Object.keys(permissions).length <= 0) && (entlhistory && Object.keys(entlhistory).length <= 0)){
			alert("no products for you..");	
			return;
		}else if((permissions && Object.keys(permissions).length <= 0)){
			alert("products expired...");	
			return;
		}*/var serviceType=null;var accessId=0;if(me.selectedProductOption.value!==undefined&&me.selectedProductOption.value!==null&&me.selectedProductOption.value.length>0){if(me.selectedProductOption.value.toLowerCase().indexOf("revision")>0){serviceType="revision";}else if(me.selectedProductOption.value.toLowerCase().indexOf("test")>0){serviceType="test";}}accessId=!isNaN(me.selectedProductOption.value)?me.selectedProductOption.value:accessId;this.accessId=accessId;if(this.isLessonOnlyProduct(this.accessId)){me.setState({lessonOnlyMode:true});}else{me.setState({lessonOnlyMode:false});}try{if(permissions[accessId]){var levels=permissions[accessId].split(",");//console.log("me.selectedProductOption.value=="+me.selectedProductOption.value);
//console.log(products,me.selectedProductOption.value,$.inArray(me.selectedProductOption.value, products));
if(__WEBPACK_IMPORTED_MODULE_7_jquery___default.a.inArray(me.selectedGradeOption.value,levels)<0){me.setState({productExpired:true,view:productExpiredView});try{this.gradeStore={"grd":me.selectedGradeOption.value,"prod":accessId};this.setAttribute(this.homeDropDownKey,JSON.stringify(this.gradeStore));}catch(e){}try{var trackObj={"grade_id":me.selectedGradeOption.value,"product_type":accessId,"source":this.getTracker().enums.selectedProductSource.home};this.initiateTrack("product_selected",trackObj);}catch(e){}return;}}else{me.setState({productExpired:true,view:productExpiredView});try{this.gradeStore={"grd":me.selectedGradeOption.value,"prod":accessId};this.setAttribute(this.homeDropDownKey,JSON.stringify(this.gradeStore));}catch(e){}try{var trackObj={"grade_id":me.selectedGradeOption.value,"product_type":accessId,"source":this.getTracker().enums.selectedProductSource.home};this.initiateTrack("product_selected",trackObj);}catch(e){}return;}}catch(e){}if(myView===null){myView=topicView;}this.setState({modalShow:false,modalContent:"loading",view:loadingView,modalTitle:"",modalView:"loading"});var callBackSuccess=function callBackSuccess(response){if(response.code===200){var topicListObj=JSON.parse(response.data);var topicListObjFinal=groupTopicsBy(topicListObj,me.state.lessonOnlyMode,me.getUrlFor("GET_S3_IMG"));/***
				* IMPORTANT: This is for Search box.
				* executing this will unlock search box
				*/var tempLessonArr=me.state.lessonOnlyMode?me.getLessonArr(topicListObj):[];me.state.lessonArr=tempLessonArr;if(me.searchBarComp&&typeof me.searchBarComp.refresh==="function"){me.searchBarComp.refresh(tempLessonArr);}if(topicListObjFinal&&topicListObjFinal.length>0){if(myView===subTopicView){var subTopicMap=topicListObjFinal[me.state.selectedTopicIndex].sortedSubTopicArr;if(subTopicMap.length>0){me.setState({topics:topicListObjFinal,subtopics:subTopicMap,view:subTopicView});}}else{me.setState({topics:topicListObjFinal,view:myView});}if(topicListObjFinal&&topicListObjFinal[0].subTopicMap&&topicListObjFinal[0].subTopicMap){var purchased=false;try{purchased=Object.values(topicListObjFinal[0].subTopicMap)[0].purchased;}catch(e){}me.setState({purchased:purchased});}//console.log("lalala ::" , topicListObjFinal);
}else{me.setState({message:me.rb("home.notopics"),view:messageView});}}else if(response.code===400){me.setState({message:me.rb("home.notopics"),view:messageView});}else{me.setState({message:me.rb("error.oops"),view:messageView});}};var callBackFailure=function callBackFailure(response){me.setState({message:me.rb("error.oops"),view:messageView});me.showAlert(me.rb("503.title"),me.rb("503.msg"));};//IMPORTANT: THERE IS A REASON FOR THIS
var classIdToLoadTopic=me.selectedGradeOption&&me.selectedGradeOption.gradeId?me.selectedGradeOption.gradeId:me.selectedGradeOption.value;new __WEBPACK_IMPORTED_MODULE_8__util_HmAjax__["a" /* default */](this.getUrlFor("GET_PLP_TOPICS")+"?access="+accessId+"&level="+classIdToLoadTopic).get(callBackSuccess,callBackFailure);try{this.gradeStore={"grd":me.selectedGradeOption.value,"prod":accessId};this.setAttribute(this.homeDropDownKey,JSON.stringify(this.gradeStore));}catch(e){}try{var trackObj={"grade_id":me.selectedGradeOption.value,"product_type":accessId,"source":this.getTracker().enums.selectedProductSource.home};this.initiateTrack("product_selected",trackObj);}catch(e){}__WEBPACK_IMPORTED_MODULE_7_jquery___default()(".hometopmenu").removeClass("selected");__WEBPACK_IMPORTED_MODULE_7_jquery___default()(".allTopics").addClass("selected");}},{key:'onTopicChangedEvent',value:function onTopicChangedEvent(topicMap,selectedTopicIndex,boxColor){var me=this;var subTopicMap=topicMap.sortedSubTopicArr;if(subTopicMap.length>0){this.setState({subtopics:subTopicMap,view:subTopicView,selectedTopic:topicMap,selectedTopicIndex:selectedTopicIndex,subTopicBoxColor:boxColor});}else{me.setState({message:me.rb("home.nosubtopics"),view:messageView});}var trackObj={"item_id":topicMap.topicId,"item_type":this.getTracker().enums.selectedItemType.topic,"source":this.getTracker().enums.selectedItemSource.home};this.initiateTrack("item_selected",trackObj);}},{key:'onSubTopicChangedEvent',value:function onSubTopicChangedEvent(subtopicMap){var typelbl=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";var testId=subtopicMap.testId;var testStatus=subtopicMap.testStatus||subtopicMap.status;var recommendtestid=subtopicMap.recommendtestid;var reqTestStatus=subtopicMap.reqTestStatus;var selectedtopicsubtopicId=subtopicMap.topicsubtopicId;var selectedrevisiontestid=subtopicMap.revisiontestid;this.TestTypeLbl=typelbl;this.setState({selectedSubTopic:subtopicMap});//console.log(subtopicMap)
if(this.state.lessonOnlyMode){var lessonList=subtopicMap.lessonsSubTopicArr;this.showLessonOnlyModal(lessonList,testId,selectedtopicsubtopicId,selectedrevisiontestid,subtopicMap);}else{if(testStatus.toUpperCase()=="COMPLETED"){if(recommendtestid==0||recommendtestid==null){alert("show revision scorecared for testId="+testId);}else if(reqTestStatus=="COMPLETED"){alert("show recommendation scorecared for testId="+recommendtestid);}else{//alert("start Practice for recommendtestid="+recommendtestid);
this.showModal(recommendtestid,selectedtopicsubtopicId,selectedrevisiontestid);this.fireMobileToast();}}else{this.showModal(testId,selectedtopicsubtopicId,selectedrevisiontestid);this.fireMobileToast();}}var trackObj={"item_id":subtopicMap.topicsubtopicId,"item_type":this.getTracker().enums.selectedItemType.subtopic,"source":this.getTracker().enums.selectedItemSource.home};this.initiateTrack("item_selected",trackObj);}},{key:'showAllTopics',value:function showAllTopics(){this.setState({view:topicView,selectedTopicIndex:null});}},{key:'showLessonOnlyModal',value:function showLessonOnlyModal(lessonList,testId,selectedtopicsubtopicId,selectedrevisiontestid,subtopicObj){this.setState({modalShow:true,modalContent:this.getLessonModalContent(lessonList,testId,selectedtopicsubtopicId,selectedrevisiontestid,subtopicObj),modalTitle:subtopicObj.subTopicName,modalView:"lessonInfo"});//alert(lessonId+", "+lessonName+", "+lessonUrl+", "+lessonDd);
//this.setSlick();
}},{key:'showModal',value:function showModal(testId){var topicsubtopicId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var revisiontestid=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;this.setState({modalShow:true,modalContent:this.setTestInfoScreen(testId,topicsubtopicId,revisiontestid),modalTitle:"",modalView:"testInfo"});}},{key:'setTestInfoScreen',value:function setTestInfoScreen(testId,topicsubtopicId,revisiontestid,classId){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__TestInfo__["a" /* default */],{callbackParent:this.startTest,accessId:this.accessId,testId:testId,topicsubtopicId:topicsubtopicId,revisiontestid:revisiontestid,classId:this.selectedGradeOption.value,onRef:function onRef(ref){return _this2.getTestInfoComponent=ref;},gradeName:this.selectedGradeOption.label});}},{key:'loadTestScreen',value:function loadTestScreen(topicInfoObj,topicsubtopicId,revisiontestid){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__GetTest__["a" /* default */],{topicInfoObj:topicInfoObj,topicsubtopicId:topicsubtopicId,revisiontestid:revisiontestid,onRef:function onRef(ref){return _this3.getTestComponent=ref;},gradeName:this.selectedGradeOption.label,subtopic:this.state.selectedSubTopic});}},{key:'hideSubscribeModal',value:function hideSubscribeModal(){this.setState({SubscribeModal:false});}},{key:'showSubscribemodal',value:function showSubscribemodal(){this.setState({SubscribeModal:true});}},{key:'rendershowSubscribe',value:function rendershowSubscribe(dataga,subtopictitle){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'ss-modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__TestTakingModalComponent__["a" /* default */],{visible:this.state.SubscribeModal,dialogClassName:"fullwidthdiag grademodal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-header bg-purple'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-title'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close helpClose',onClick:this.hideSubscribeModal,'aria-label':'Close'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'close')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',_defineProperty({className:'modal-body'},'className','col-12 text-center subscrcont'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__SubscribeModal__["a" /* default */],{ga:dataga}))));}},{key:'setSlick',value:function setSlick(){__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.responsive').slick({dots:true,infinite:false,speed:300,slidesToShow:4,slidesToScroll:4,responsive:[{breakpoint:1024,settings:{slidesToShow:3,slidesToScroll:3,infinite:true,dots:true}},{breakpoint:600,settings:{slidesToShow:2,slidesToScroll:2}},{breakpoint:480,settings:{slidesToShow:1,slidesToScroll:1}// You can unslick at a given breakpoint now by adding:
// settings: "unslick"
// instead of a settings object
}]});}},{key:'subscribeFn',value:function subscribeFn(props,dataga){if(props){return _get(Home.prototype.__proto__||Object.getPrototypeOf(Home.prototype),'subscribeFn',this).call(this,dataga);}}},{key:'getLessonModalComponent',value:function getLessonModalComponent(lessonList,testId,selectedtopicsubtopicId,selectedrevisiontestid,subtopicObj,lessonType){var accessId=0;var accessId=!isNaN(this.selectedProductOption.value)?this.selectedProductOption.value:accessId;var classId=subtopicObj&&!isNaN(subtopicObj.classId)?subtopicObj.classId:this.selectedGradeOption.value;var isFreeTrial=subtopicObj.practiceLocked;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:lessonType},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,this.rb("title."+lessonType))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row allMiddle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-12 col-12 col-md-2 col-lg-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_25__images_icons_recom_lesson_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-12 col-12 col-md-10 col-lg-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.rb("lessontype.detailtxt."+lessonType)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row allMiddle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-8 col-8 col-md-10 col-lg-10 imgGal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-center scorecardLessons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_slick___default.a,settings,lessonList.map(function(lesson,index){//if(lesson.lessontype === lessonType){
if(lesson.lessonGroup===lessonType){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__views_scorecard_LessonComponent__["a" /* default */],{isFrom:"Home",isFreeTrail:isFreeTrial,lesson:lesson,testId:testId,topicSubTopicMapId:selectedtopicsubtopicId,accessId:accessId,classId:classId,key:index,tracksource:'subtopic'});}}))))));}},{key:'getLessonModalContent',value:function getLessonModalContent(lessonList,testId,selectedtopicsubtopicId,selectedrevisiontestid,subtopicObj){var _this4=this;var me=this;var classId=subtopicObj&&!isNaN(subtopicObj.classId)?subtopicObj.classId:this.selectedGradeOption.value;var isFreeTrial=subtopicObj.practiceLocked;var availableLessonTypes=new Set();var lessonGroups=window.lessonGroup;for(var i=0;i<lessonList.length;i++){var lessonGroup=lessonList[i].lessontype||"no_type";if(lessonList[i].lessontype){lessonGroup=lessonGroups&&lessonGroups[lessonList[i].lessontype]?lessonGroups[lessonList[i].lessontype]:lessonGroup;}lessonList[i].lessonGroup=lessonGroup;availableLessonTypes.add(lessonGroup);}//Sort based on window.lessonModalGroupOrder
if(window.lessonModalOrder){var sortingOrder=window.lessonModalOrder;availableLessonTypes=Array.from(availableLessonTypes).sort(function(x,y){if(sortingOrder[x]<sortingOrder[y]){return-1;}if(sortingOrder[x]>sortingOrder[y]){return 1;}return 0;});}else{availableLessonTypes=Array.from(availableLessonTypes);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,availableLessonTypes.map(function(lType,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,me.getLessonModalComponent(lessonList,testId,selectedtopicsubtopicId,selectedrevisiontestid,subtopicObj,lType),function(){if(index<availableLessonTypes.length-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null));}}());}),function(){if(isFreeTrial){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-center allMiddle'},_this4.subscribeFn(isFreeTrial,"Post login - Class "+classId+" - Lessons - "+_this4.state.selectedTopic.topicName+" - "+subtopicObj.subTopicName+" - Lessons - Subscribe")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));}}());}},{key:'onCloseHandler',value:function onCloseHandler(){try{if(this.getTestComponent&&typeof this.getTestComponent.onCloseHandler==="function"){this.getTestComponent.onCloseHandler();}else{console.warn("Not submitting this test: function 'onCloseHandler' not available");}}catch(e){console.error(e);}}},{key:'hideModal',value:function hideModal(){try{if(this.getTestComponent){this.getTestComponent.modalCloseEvent();}else if(this.getTestInfoComponent){this.getTestInfoComponent.trackTestClose();}}catch(e){}this.onCloseHandler();this.getTestComponent=null;this.getTestInfoComponent=null;this.setState({modalShow:false,modalContent:"loading",view:loadingView,modalTitle:"",modalView:"loading"});this.getTopicList(subTopicView);}},{key:'setModalClass',value:function setModalClass(){if(this.state.modalView=="testView"){return" modal-lg custom-modal";}return" modal-lg";}},{key:'setModalBackdropClose',value:function setModalBackdropClose(){if(this.state.modalView=="lessonInfo"){return this.hideModal;}return"";}},{key:'setModalTitle',value:function setModalTitle(topicInfoObj){var testType="";if(topicInfoObj.testDetails.mode==1||topicInfoObj.testDetails.mode=="1"){testType=" - "+this.rb("home.proficiencytest");}else{//testType = this.rb("home.practicetest");
}var topics=topicInfoObj.testDetails.topics.split("- Customized Practice").join("- Customised Practice");return topics+testType;}},{key:'loadModalContent',value:function loadModalContent(){if(this.state.modalContent==="loading"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center loadingAnim'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_loader_spinner___default.a,{type:'Oval',color:'#00BFFF',height:'100',width:'100'}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.modalContent);}}},{key:'startTest',value:function startTest(topicInfoObj,topicsubtopicId,revisiontestid){this.setState({modalContent:this.loadTestScreen(topicInfoObj,topicsubtopicId,revisiontestid),modalTitle:this.setModalTitle(topicInfoObj),modalView:"testView"});var source_test_id=0;var resumed=null;if(topicInfoObj.testDetails.mode==1||topicInfoObj.testDetails.mode=="1"){source_test_id=null;if(this.state.selectedSubTopic.status=="NEW"){resumed=false;}else if(this.state.selectedSubTopic.status=="IN_PROGRESS"){resumed=true;}}else{source_test_id=this.state.selectedSubTopic.testId;if(this.state.selectedSubTopic.reqTestStatus=="NEW"){resumed=false;}else if(this.state.selectedSubTopic.reqTestStatus=="IN_PROGRESS"){resumed=true;}}var trackObj={"subtopic_id":topicsubtopicId,"test_id":topicInfoObj.testDetails.id,"source_test_id":source_test_id,"resumed":resumed};this.initiateTrack("test_started",trackObj);}},{key:'topicPointClick',value:function topicPointClick(event){var target=event.currentTarget;__WEBPACK_IMPORTED_MODULE_7_jquery___default()(".hometopmenu").removeClass("selected");__WEBPACK_IMPORTED_MODULE_7_jquery___default()(target).addClass("selected");if(__WEBPACK_IMPORTED_MODULE_7_jquery___default()(target).hasClass("allTopics")){this.setState({topicSubView:allTopicsView});}else if(__WEBPACK_IMPORTED_MODULE_7_jquery___default()(target).hasClass("pointssystem")){gradePointsMap.grades=gradePointsMap.grades.reverse();//console.log(gradePointsMap.grades);		
this.setState({topicSubView:pointsSystemView});}}},{key:'custsubscribeFn',value:function custsubscribeFn(dataga){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pointssystem hometopmenu float-right sub-mb-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'SubscribeButton',className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'btn btn-primary largeBtn subscribe_style subhome','data-ga':dataga||"Post login - Subscribe",onClick:function onClick(){window.location.href="/myproducts";}},'Subscribe')));}},{key:'renderTopics',value:function renderTopics(){var _this5=this;var me=this;if(this.state.view===topicView&&this.state.lessonOnlyMode&&!this.isLessonTabAvailable()){this.setState({view:desktopOnlyView});}//console.log("view:::",this.state.view);
if(this.state.view===desktopOnlyView){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__warning_DesktopOnly__["a" /* default */],null);}else if(this.state.view===loadingView){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center loadingAnim'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_loader_spinner___default.a,{type:'Oval',color:'#00BFFF',height:'100',width:'100'}));}else if(this.state.view===messageView){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'messageView text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.state.message));}else if(this.state.view===topicView){var topics=this.state.topics;var topicLength=topics.length;/**
								* IMPORTANT: TODO: Shyam
								*/var classId=this.selectedGradeOption.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'topicspointsheader'},function(){if(!me.state.purchased){return _this5.custsubscribeFn(me.state.lessonOnlyMode?"Post login - Class "+classId+" - Lessons - Subscribe":"Post login - Class "+classId+" - Tests - Subscribe");}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'allTopics hometopmenu selected',onClick:this.topicPointClick},this.rb("landing.alltopics"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-corner'},topicLength)),function(){if(_this5.state.lessonOnlyMode==false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pointssystem hometopmenu',onClick:_this5.topicPointClick},_this5.rb("points.pointssystem"));}}()),function(){console.log("this.state.topicSubView=="+_this5.state.topicSubView);if(_this5.state.topicSubView==pointsSystemView){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'pointsContainer',className:'homeTopicContainer mainScrollContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pointsheadertxt'},_this5.rb("points.ptest")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this5.rb("points.testmsg")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pointsTable testtable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Table"],{className:'table noleftpadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Tbody"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'dark'},_this5.rb("points.hardquestions")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'medium'},gradePointsMap.points.hard[1])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'dark'},_this5.rb("points.mediumquestions")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'medium'},gradePointsMap.points.medium[1])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'dark'},_this5.rb("points.easyquestions")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'medium'},gradePointsMap.points.easy[1])))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pointsheadertxt'},_this5.rb("points.cpractice")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pointsTable practicetable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Table"],{className:'table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Thead"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'dark'},_this5.rb("points.answeredrightly")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'dark'},_this5.rb("points.hardquestion")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'dark'},_this5.rb("points.mediumquestion")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'dark'},_this5.rb("points.easyquestion")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Tbody"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'dark'},_this5.rb("points.1attempt")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'medium'},gradePointsMap.points.hard[1]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'medium'},gradePointsMap.points.medium[1]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'medium'},gradePointsMap.points.easy[1])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'dark'},_this5.rb("points.2attempt")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'medium'},gradePointsMap.points.hard[2]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'medium'},gradePointsMap.points.medium[2]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'medium'},gradePointsMap.points.easy[2])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'dark'},_this5.rb("points.3attempt")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'medium'},gradePointsMap.points.hard[3]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'medium'},gradePointsMap.points.medium[3]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'medium'},gradePointsMap.points.easy[3])))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pointsheader2txt'},_this5.rb("points.gradingsystem")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pointsheadertxt'},_this5.rb("points.forasubtopic")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Percentage = (Points scored/ Total no.of points in that sub-topic)*100'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pointsheadertxt mt-10'},_this5.rb("points.foratopic")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Percentage = (Total points scored in all subtopics (in that topic)/ Total no.of points of all sub-topics (in that topic))*100'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pointsTable gradetable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Table"],{className:'table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Thead"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Th"],{className:'dark'},_this5.rb("points.percentagerange")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Th"],{className:'dark'},_this5.rb("points.grade")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Tbody"],null,gradePointsMap.grades.map(function(grades,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Tr"],{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:"green "+grades.grade.toLowerCase().split("+").join("plus")},grades.minPercent,'% - ',grades.maxPercent,'%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:"green "+grades.grade.toLowerCase().split("+").join("plus")},grades.grade));}))))));}else{var selectedGradeLabel="";try{selectedGradeLabel=_this5.selectedGradeOption.label.split(" ").join("").toLowerCase();}catch(e){}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'topicContainer',className:'homeTopicContainer mainScrollContent'},topics.map(function(topic,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TopicComponent__["a" /* default */],{topic:topic,callbackParent:_this5.onTopicChangedEvent,key:index,dataIndex:index,lessonOnlyMode:_this5.state.lessonOnlyMode,selectedGradeLabel:selectedGradeLabel,gradeName:_this5.selectedGradeOption.label});}));}}());}else if(this.state.view===subTopicView){var subtopics=this.state.subtopics;var subLength=subtopics.length;var accessId=!isNaN(this.selectedProductOption.value)?this.selectedProductOption.value:0;/**
									* IMPORTANT: TODO: Shyam
									*/var classId=this.selectedGradeOption.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-right'},function(){if(!me.state.purchased){return _this5.custsubscribeFn(_this5.state.lessonOnlyMode?"Post login - Class "+classId+" - Lessons - "+_this5.state.selectedTopic.topicName+" - Subscribe":"Post login - Class "+classId+" - Tests - "+_this5.state.selectedTopic.topicName+" - Subscribe");}}()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'breadcrumb-holder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'breadcrumb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'breadcrumb-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:this.showAllTopics},this.rb("landing.alltopics_small"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'breadcrumb-item active'},this.state.selectedTopic.topicName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subTopicName'},this.state.selectedTopic.topicName,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-corner'},subLength))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'topicContainer',className:'homeTopicContainer mainScrollContent'},subtopics.map(function(subtopic,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SubTopicComponent__["a" /* default */],{key:index,subtopic:subtopic,accessId:accessId,classId:classId,showSubscribe:_this5.showSubscribemodal,callbackParent:_this5.onSubTopicChangedEvent,lessonOnlyMode:_this5.state.lessonOnlyMode,subTopicBoxColor:_this5.state.subTopicBoxColor,gradeName:_this5.selectedGradeOption.label,topicName:_this5.state.selectedTopic.topicName});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__TestTakingModalComponent__["a" /* default */],{visible:this.state.modalShow,dialogClassName:this.setModalClass(),onClickBackdrop:this.setModalBackdropClose()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-header bg-purple'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-title'},this.state.modalTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close',onClick:this.hideModal,'aria-label':'Close','data-ga':"Post login - "+this.selectedGradeOption.label+" - "+this.getProductIndication()+" - "+this.state.selectedTopic.topicName+" - "+this.state.selectedSubTopic.subTopicName+" - "+this.getTestTypeLbl()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'close')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-body testModalBody'},this.loadModalContent()))),this.rendershowSubscribe("Post login - "+this.selectedGradeOption.label+" - "+this.getProductIndication()+" - "+this.state.selectedTopic.topicName+" - Subscribe"));}else if(this.state.productExpired==true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'messageView expiredView text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'expiredlock'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'lock')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.rb("access.expiredmsg1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Go to ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'r-btn myheymathbtn goprod-btn',onClick:this.goToLanding},'Products'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'to subscribe')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_16_react_html_parser___default()(this.rb("access.expiredmsg3"))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Nothing'));}}},{key:'showProductpage',value:function showProductpage(){window.location.href='/products';}},{key:'goToLanding',value:function goToLanding(){window.location.href='/mysubscriptions';}},{key:'getTestTypeLbl',value:function getTestTypeLbl(){if(this.TestTypeLbl==""){return"Close";}else{return this.TestTypeLbl+" - Close";}}},{key:'getProductIndication',value:function getProductIndication(){if(this.state.modalView=="lessonInfo"){return"Lessons";}else{return"Tests";}}},{key:'render',value:function render(){var me=this;if(this.comboNamesLoaded){return _get(Home.prototype.__proto__||Object.getPrototypeOf(Home.prototype),'render',this).call(this,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'HomeComponent mt-40'},function(){var geo=me.getGeo()||"";if(window.lesson_searchbox_for_geos&&(window.lesson_searchbox_for_geos.includes("ALL")||window.lesson_searchbox_for_geos.includes(geo))){if(me.state.lessonArr&&me.state.lessonArr.length>0&&!me.state.productExpired){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__SearchboxComp__["a" /* default */],{onRef:function onRef(ref){return me.searchBarComp=ref;},lessons:me.state.lessonArr});}}}(),this.renderTopics()));}else if(this.state.noProducts){return _get(Home.prototype.__proto__||Object.getPrototypeOf(Home.prototype),'render',this).call(this,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'messageView expiredView text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'expiredlock'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'lock')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.rb("register.noproducts.msg")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.rb("register.noproducts.msg2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_16_react_html_parser___default()(this.rb("register.noproducts.msg3")))));}else{return _get(Home.prototype.__proto__||Object.getPrototypeOf(Home.prototype),'render',this).call(this);}}}]);return Home;}(__WEBPACK_IMPORTED_MODULE_1__views_common_Landing__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAAEEfUpiAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAy5JREFUeNpi/P//PwMyYAERBvv3w0QfMiHLpsv+kUcRmPmY5SFAADGim8EEMwNmDlzLBUdHBhQBoAowDRBAcDOAAguAVDxU/iJQhwGKDpBkk6YmAwir8vDoAzU8QDfhP7p9IHkMZ6IDgAAiqAAWNgJA6gYQi0PFFwKtSUB25H0kSQYk30BMAAGQ62Gg7vp1BgwFMEFOxg9AXwQyZJ2Z+2uaSTIbEzaHJZ2awSDIxs2KYgIMfP8vwHDuqwDDBTNHRqK8CRBADCAFuLD+vn0LgNgBnxoUG4Dh9R5ICeC3kuEhMAwVUBIQJYAFmyBymMOCWJDpAYMq1z+G65+eyjEwOOI3ADmiQECc6QIDw//vDIaCpgzf/34HhS7I34xEe+HlPwOGv4xi4EB78u39f53tJYJYUyMwEOuAVCEB8xSBgfiB6ORMCAAEEMUG4A0DoJc+kOQCaMmAkp+QwEIgPgb0/yx8BhD0D9AARqK9QHEYkJWUgYUeQ6ysLMHUSbQLQBpBWJTxFIMZzz0G30NdM0gORF3O6wyLLbLA7Oyz8xgefX3ju9mubAvRYQDSnAPUCMwDDFONkxj+/v83haRAzDozj0GbX5bhimcPmM/OzDIFb3ZGB8c+KwLLgaPg3Hjg1dUt621KeqiWkNBd8AWI/+DR/5W+uZEYABBgeOsFQhhYZyhQoh+jXiFQtkwAUVAuqO7RR5I+iMReAIyoBRSXiEALnwApaQoD+BcQtwId1EROHHIzUA7YQI0JkitWdGDEz89QrqZGtK3bXrxgWPj4Mfk1Ozq4/fUrQ/ft20QZePPLF4bPf/5Q1rRAByADz3z4QGLu+g5tqHJS7gBeFhYGdWBFgQvAHCfGdIPBVFCQoULTn4GXFWLx59/f5asvrfh/49Ozo2ttimxoFgJSLPcYitVsGZzFdeBi0+/sZph6eyewTaXA0KoXYR18pO8IuiNYGKgI+IC+hlkKAiCLYVUIMAQYfvz7xUVKOUBMYxcFiDJdYYiTN2CIVbBFrRAfHGZYcP/Azb2OtRo0dQAiBf4GJsJP0ETI9/iCk5scOYmQ/OhhZAVaLAzjfaRp43TAG3ZD3gEAckzZ+dW2eYoAAAAASUVORK5CYII="

/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAAEEfUpiAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA6lJREFUeNpi/P//PwMyYAERBvv3w0QfMiHLnlPjlEcROLuz+gdAADGim8EEMwNmDhOSfgYUgV8bwsE0QADBzQBqWQCk4qHyFy84OhqAWSAFIKy/b9//G58/g3Hi2bP/gfwHIHEWZBeEnz4NpoG6Gf69uSaPYgIy/j5FbgIQHwCxAQIIwx/oABY2AkDqBhCLQ8UXAq1JQPbWfSRJBiTfIBy50tQUw7HwcABa8R7IBlnDcJr1EMPfi/MYGIVUr7BH7tFlQnfU6RcPGTiyHzL8f3fbFyVoYSBLOJbhx1R5kKIHKEGNCwAEENaAQgr+BUBsgE8Nig3InsEDHgLDUAElAVECWLAJmgigOuLP66sMc+XYGZgU3Rl+7CmUY2BwxG/AmQ8fUPhnoZp/ztFl4Mx+yPhzif0D9piDCkR7wfi5CFgzI68Mw+l5zj9gmrEZ0A/EH3BghtWs6j81f9w/i6yBcDwTAAABRLEBeMMAmC4+kOQCaMmAkp+QwEIgPgZMRLPwGUDQP0ADGIn2AsVhQFZSNuLnZyhXU8NQiFyM4A0DXhYWBnUeHpRkffhhJQNvwgmG/5+fMPxaG7SZPeGUH9GBaP/5HMMEx3CGv9dXMzBJWzIw8smAkjQj0WGgz/gJnAf+nJ7A8PfGajCb5Gg8w32BgcWsEMz+Od/kB3viGU682RmjfPhqwHBygTmwUvrEwJ52nZNggYK17Pz6gqho/AIqgLApfMkqxCf++x0TSaUylmrNAW+pTA4ACDCSXICl3lCgRD9JPgAmEVB9DCtLQQ0Ifyj7IxBPQFJ6AJjjD1BcIgItfAKkpCnM67+AuBXooCZyShNuBsoBGxAnkVyxEltC4QLbXrxgWPj4Mfk1Ozo49/EjzuKQJk0LcoHk7zcMJd8OMSj/eATmf2PmZpjDY8uJ3BQhywGqwPI9VlYWp3zd9esMO5+2MIh6TGZgEgll+P/zE8PvvcUMbF6zGfoYGMR+bUn89f/TwyD2qH1bSMkFxDT1IA74vIPBX8cJXF/8OdIILPbXQJMgLwOrbT0Ds0YoA7A99RC5SUS1OhUEZnOYMHw/P4eBkZ0P6AgLBmb9JAb2uKPA0NAGWw6uh9h4LpNaDhAdAjAw7e1iBhOGdwzMOtFA3/Mx/Ht2guHX3R3/WbnF7NlCNh6muQNA4MS1BBT+ZU6VH6ZJeznJKYiokkOYGf79JSsbAotPXnIs/HGNARSkjsBu0gFgd+mB1vd7D2hWGxJZhxdQpTakFQAAiVSkN291h+0AAAAASUVORK5CYII="

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(119)))

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_html_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_common_Landing__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_plp_TestTakingModalComponent__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_moment__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_timezone__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_icons_topiccompleted_icon_png__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_icons_topiccompleted_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_icons_topiccompleted_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_icons_recenttopic_icon_png__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_icons_recenttopic_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_icons_recenttopic_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_icons_gradeEarned_icon_png__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_icons_gradeEarned_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_icons_gradeEarned_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_icons_pointsEarnedBig_icon_png__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_icons_pointsEarnedBig_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_icons_pointsEarnedBig_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_scardp_icon_png__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_scardp_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_icons_scardp_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_icons_topic_lesson_icon_png__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_icons_topic_lesson_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_icons_topic_lesson_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_icons_hey_icon_png__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_icons_hey_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_icons_hey_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_icons_report_proficiency_png__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_icons_report_proficiency_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_icons_report_proficiency_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_icons_report_practice_png__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_icons_report_practice_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__images_icons_report_practice_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__css_dashboard_css__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__css_dashboard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__css_dashboard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_circular_progressbar__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_circular_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_circular_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_circular_progressbar_dist_styles_css__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_circular_progressbar_dist_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react_circular_progressbar_dist_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_scorecard_Piechart__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_dropdown__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_dropdown_style_css__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_dropdown_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react_dropdown_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_jquery__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var gradeArr=["a","b","c"];var topicList=[];var defaultOption=topicList[0];var Dashboard=function(_Landing){_inherits(Dashboard,_Landing);function Dashboard(){_classCallCheck(this,Dashboard);var _this=_possibleConstructorReturn(this,(Dashboard.__proto__||Object.getPrototypeOf(Dashboard)).call(this));_this.state={topicsCompleted:0,topicsTotal:0,recentTestData:{},selectedTopic:null,selectedSubTopic:null,gradeArr:[],productArr:[],comboNamesLoaded:false,overallPerformanceLoaded:false,recentTopicLoaded:false,pointsEarned:0,grade:_this.rb("dash.not_available"),feedbackText:"",selectedProduct:"",noProducts:false,ModalShow:false};_this.topicListRequestAllowed=true;_this.selectedGradeOption=null;_this.selectedProductOption=null;_this.gradeProductMap={};_this.classDefnMap={};_this.topicDropdownChange=_this.topicDropdownChange.bind(_this);_this.topicDescMap={};_this.topicTestMap={};_this.completedTopicCount=0;_this.gradeDefns=[];_this.topicGradeDtls={};//this.plpDashboard = 1; Unused 
//this.testDashboard = 2; Unused
//this.lessonDashboard = 3; NOT USED ANYMORE - PATHETIC Way of hardcoding
_this.totalTopicTimeSpent=0;_this.noLessonMode=false;_this.gradeStore=null;_this.dashboardDropDownKey="homeDropdown";//"dashDropdown";
_this.preferredGrade=null;_this.preferredProduct=null;//this.pointsEarned = 0;
_this.subTopicClick=_this.subTopicClick.bind(_this);_this.TopicClick=_this.TopicClick.bind(_this);_this.productsAvailableToAccess=_this.productsAvailableToAccess.bind(_this);_this.setChild(_this,"DASHBOARD");_this.hideLoginModal=_this.hideLoginModal.bind(_this);_this.showPreviousAttempts=_this.showPreviousAttempts.bind(_this);_this.showMoreAttempt=_this.showMoreAttempt.bind(_this);_this.showLessAttempt=_this.showLessAttempt.bind(_this);//this.triggerPreviousAttempts = this.triggerPreviousAttempts.bind(this);
_this.attemptsArr=[1,2,3,4,5,6];_this.attemptBoundry=3;return _this;}_createClass(Dashboard,[{key:'isLessonOnlyProduct',value:function isLessonOnlyProduct(accessId){var lessonOnlyProds=window.lessonOnlyEntl||["PLP|LESSON|VIEW","TCHR|LESSON|VIEW"];if(lessonOnlyProds&&lessonOnlyProds.length>0){return lessonOnlyProds.indexOf(this.getUser().getAccessMap()[accessId])>-1;}else{return false;}}},{key:'componentDidMount',value:function componentDidMount(){_get(Dashboard.prototype.__proto__||Object.getPrototypeOf(Dashboard.prototype),'componentDidMount',this).call(this);if(this.productsAvailableToAccess()){this.setPreferredDd();this.getGradeList();}else{setTimeout(function(){__WEBPACK_IMPORTED_MODULE_23_jquery___default()(".page-content nav.side-navbar ul li").addClass("noclicks");},1000);this.setState({noProducts:true});}this.fireMobileToast();//this.populateSubTopics(defaultOption);
}},{key:'productsAvailableToAccess',value:function productsAvailableToAccess(){var user=this.getUser();if(user!=null){var permissions=user.getEntlHistory();if(permissions!=null&&Object.keys(permissions).length>0){for(var i in permissions){if(permissions[i]!=null){var totalLevel=permissions[i].split(",").reduce(function(a,b){try{return parseInt(a)+parseInt(b);}catch(e){return 0;}});if(totalLevel>0){return true;}}}}}return false;}},{key:'setPreferredDd',value:function setPreferredDd(){try{var gradeStore=null;var prefStr=this.getAttribute(this.dashboardDropDownKey);if(prefStr)gradeStore=JSON.parse(prefStr);console.log("dashboard gradeStore::",gradeStore);if((typeof gradeStore==='undefined'?'undefined':_typeof(gradeStore))==="object"){this.preferredGrade=gradeStore["grd"];this.preferredProduct=gradeStore["prod"];;}}catch(e){}}//For feedback text
},{key:'getFeedbackText',value:function getFeedbackText(){return this.state.feedbackText;}},{key:'calculateGradeForTopics',value:function calculateGradeForTopics(topicTestMap){for(var i in topicTestMap){if(topicTestMap[i].status==="COMPLETED"){var userPoints=topicTestMap[i].userPoints||0;var topicPoints=topicTestMap[i].topicPoints||0;if(topicPoints>0){var percentage=Math.round(userPoints*100/topicPoints);topicTestMap[i].grade=this.calculateGrade(percentage);topicTestMap[i].feedback=this.processFeedbackTextByGrade(topicTestMap[i].grade,percentage);}}else if(topicTestMap[i].status==="IN_PROGRESS"){topicTestMap[i].feedback=this.rb("dash.label.topic.feedback-inprogress");}else{topicTestMap[i].feedback=this.rb("dash.label.topic.feedback-unattempted");}}}},{key:'calculateGrade',value:function calculateGrade(percentage){if(!isNaN(percentage)&&this.gradeDefns&&this.gradeDefns.length>0){for(var i=0;i<this.gradeDefns.length;i++){if(percentage>=this.gradeDefns[i].minPercent&&percentage<=this.gradeDefns[i].maxPercent){return this.gradeDefns[i].grade;}}}return this.rb("dash.not_available");}},{key:'processFeedbackTextByGrade',value:function processFeedbackTextByGrade(grade,percentage){if(percentage===100){return this.rb("dash.label.topic.grade-full-A+");}else if(grade&&grade.length>0){return this.noLessonMode?this.rb("dash.label.topic.nolesson-grade-"+grade):this.rb("dash.label.topic.grade-"+grade);}}},{key:'getOriginalFeedBackText',value:function getOriginalFeedBackText(gradeDtls){if(gradeDtls.oldPercent===100){return this.rb("scorecard.test.grade-full-A+");}else{return this.noLessonMode?this.rb("scorecard.test.nolesson-grade-"+(gradeDtls.oldGrade&&gradeDtls.oldGrade.length>0?gradeDtls.oldGrade:"")):this.rb("scorecard.test.grade-"+(gradeDtls.oldGrade&&gradeDtls.oldGrade.length>0?gradeDtls.oldGrade:""));}}},{key:'getUpdatedFeedBackText',value:function getUpdatedFeedBackText(gradeDtls){if(gradeDtls.newPercent===100){return this.rb("scorecard.practice.grade-full");}else if(gradeDtls.gradeChanged){return this.rb("scorecard.practice.grade-change").replace("{1}",gradeDtls.oldGrade).replace("{2}",gradeDtls.newGrade);}else if(gradeDtls.percentChanged){return this.rb("scorecard.practice.grade-nochange").replace("{1}",gradeDtls.oldPoints).replace("{2}",gradeDtls.newPoints);}else{return this.rb("scorecard.practice.point-nochange");}}},{key:'processFeedbackTextForSubTopic',value:function processFeedbackTextForSubTopic(subTopic){if(subTopic){if(this.topicGradeDtls&&subTopic.status){try{var gradeDtls=this.topicGradeDtls[subTopic.topicId]&&this.topicGradeDtls[subTopic.topicId][subTopic.subTopicId]?this.topicGradeDtls[subTopic.topicId][subTopic.subTopicId]:null;var subTopicPercent=0;var subTopicGrade="";// Both revision and practice, if available - completed
if(subTopic.status==="COMPLETED"&&gradeDtls!==null){if(subTopic.practiceStatus==="COMPLETED"){subTopic.feedback=this.getUpdatedFeedBackText(gradeDtls);}else{subTopic.feedback=this.getOriginalFeedBackText(gradeDtls);}}else if(subTopic.status==="IN_PROGRESS"){//Revision only completed, if completed
if(subTopic.testStatus==="COMPLETED"&&gradeDtls!==null){subTopic.feedback=this.getOriginalFeedBackText(gradeDtls);}else{subTopic.feedback=this.rb("dash.label.subtopic.feedback-inprogress");}}else if(subTopic.status==="NEW"){//Just started
subTopic.feedback=this.rb("dash.label.subtopic.feedback-inprogress");}else{subTopic.feedback=this.rb("dash.label.subtopic.feedback-unattempted");}}catch(e){console.error(e);}}else{subTopic.feedback=this.rb("dash.label.subtopic.feedback-unattempted");}}return subTopic;}},{key:'processSubTopic',value:function processSubTopic(subTopic){var returnObj={};var testScore=0;var userScore=0;var testStatus="";var practiceStatus="";var status="";var grade="";var subTopicPoints=0;var userPoints=0;var totalTimeSpent=0;try{if(subTopic){if(subTopic.diagnosticTests){for(var i in subTopic.diagnosticTests){userScore+=!isNaN(subTopic.diagnosticTests[i].userScore)?subTopic.diagnosticTests[i].userScore:0;testScore+=!isNaN(subTopic.diagnosticTests[i].score)?subTopic.diagnosticTests[i].score:0;testStatus=subTopic.diagnosticTests[i].status;}}if(subTopic.customTests){for(var i in subTopic.customTests){userScore+=!isNaN(subTopic.customTests[i].userScore)?subTopic.customTests[i].userScore:0;testScore+=!isNaN(subTopic.customTests[i].score)?subTopic.customTests[i].score:0;practiceStatus=subTopic.customTests[i].status;}}subTopicPoints=!isNaN(subTopic.subTopicPoints)?subTopic.subTopicPoints:0;userPoints=!isNaN(subTopic.userPoints)?subTopic.userPoints:0;grade=subTopic.grade;status=subTopic.status;returnObj["topicId"]=subTopic.topicId||0;returnObj["subTopicId"]=subTopic.subTopicId||0;if(subTopic.lessons){for(var obj in subTopic.lessons){totalTimeSpent+=subTopic.lessons[obj].timeSpent;}}}}catch(e){}returnObj["testScore"]=testScore;returnObj["userScore"]=userScore;returnObj["status"]=status;returnObj["practiceStatus"]=practiceStatus;returnObj["testStatus"]=testStatus;returnObj["grade"]=grade;returnObj["subTopicPoints"]=subTopicPoints;returnObj["userPoints"]=userPoints;returnObj["totalTimeSpent"]=totalTimeSpent;//process feedback text for SubTopic
this.processFeedbackTextForSubTopic(returnObj);return returnObj;}},{key:'TopicClick',value:function TopicClick(event){//console.log(event.currentTarget);
__WEBPACK_IMPORTED_MODULE_23_jquery___default()(".DashboardComponent .subtopicCard").removeClass("selected");__WEBPACK_IMPORTED_MODULE_23_jquery___default()(event.currentTarget).addClass("selected");var grade=event.currentTarget.dataset.grade;var subTopicId=event.currentTarget.dataset.subtopicid;if(!grade){grade=this.rb("dash.not_available");}this.setState({pointsEarned:event.currentTarget.dataset.userpoints,grade:grade,feedbackText:event.currentTarget.dataset.feedback,selectedSubTopic:null});var trackObj={"item_id":subTopicId,"item_type":this.getTracker().enums.selectedItemType.topic,"source":this.getTracker().enums.selectedItemSource.dashboard};this.initiateTrack("item_selected",trackObj);}},{key:'subTopicClick',value:function subTopicClick(event){//console.log(event.currentTarget);
__WEBPACK_IMPORTED_MODULE_23_jquery___default()(".DashboardComponent .subtopicCard").removeClass("selected");__WEBPACK_IMPORTED_MODULE_23_jquery___default()(event.currentTarget).addClass("selected");var grade=event.currentTarget.dataset.grade;var subTopicId=event.currentTarget.dataset.subtopicid;if(!grade){grade=this.rb("dash.not_available");}this.setState({pointsEarned:event.currentTarget.dataset.userpoints,grade:grade,feedbackText:event.currentTarget.dataset.feedback,selectedSubTopic:this.state.selectedTopic.subTopics[subTopicId]});var trackObj={"item_id":subTopicId,"item_type":this.getTracker().enums.selectedItemType.subtopic,"source":this.getTracker().enums.selectedItemSource.dashboard};this.initiateTrack("item_selected",trackObj);}},{key:'populateSubTopics',value:function populateSubTopics(){var _this2=this;//console.log("populateSubTopics");
if(this.state.selectedTopic&&this.state.selectedTopic.subTopics){var me=this;var timeSpent=0;//console.log(this.state.selectedTopic)
var subTopicsArr=Object.values(this.state.selectedTopic.subTopics);this.totalTopicTimeSpent=0;//this.setState({feedbackText: this.topicTestMap[this.defaultOption.value].feedback || "", grade: this.topicTestMap[this.defaultOption.value].grade || this.rb("dash.not_available"),selectedTopic:this.topicTestMap[selectedOption.value],selectedSubTopic:null, pointsEarned:(this.topicTestMap && this.topicTestMap[selectedOption.value] && this.topicTestMap[selectedOption.value].userPoints && !isNaN(this.topicTestMap[selectedOption.value].userPoints)) ? this.topicTestMap[selectedOption.value].userPoints : 0});
var topicstatus=this.topicTestMap[this.defaultOption.value].status;var statusclass="un_attempted";if(topicstatus.toLowerCase()=="completed"){statusclass="completed";}else if(topicstatus.toLowerCase()=="in_progress"){statusclass="in_progress";}//console.log("subtopic satus=="+subtopic.status);
var mygrade=this.topicTestMap[this.defaultOption.value].grade||this.rb("dash.not_available");var cssgrade=mygrade.toLowerCase().split("+").join("plus");if(this.isLessonOnlyProduct(this.state.selectedProduct)){cssgrade=statusclass;}var userPoints=this.topicTestMap[this.defaultOption.value].userPoints;var feedback=this.topicTestMap[this.defaultOption.value].feedback;var topicId=this.topicTestMap[this.defaultOption.value].topicId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subtopicContainer clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"card subtopicCard selected float-left grade_"+cssgrade+" "+statusclass,'data-userpoints':userPoints,'data-grade':mygrade,'data-feedback':feedback,'data-subtopicid':topicId,onClick:this.TopicClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'card-text subcardText'},this.rb("dash.overall.topic")))),subTopicsArr.map(function(subtopic,index){subtopic["topicId"]=_this2.state.selectedTopic.topicId;var processedSubTopic=me.processSubTopic(subtopic);var userEarnedPoints=!isNaN(processedSubTopic.userPoints)?processedSubTopic.userPoints:0;var mygrade=processedSubTopic.grade||"";var subTopicMarks=processedSubTopic.userScore+" / "+processedSubTopic.testScore;var statusclass="un_attempted";if(subtopic.status.toLowerCase()=="completed"){statusclass="completed";}else if(subtopic.status.toLowerCase()=="in_progress"){statusclass="in_progress";}//console.log("subtopic satus=="+subtopic.status);
_this2.totalTopicTimeSpent+=processedSubTopic.totalTimeSpent;var cssgrade=mygrade.toLowerCase().split("+").join("plus");if(me.isLessonOnlyProduct(me.state.selectedProduct)){cssgrade=statusclass;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"card subtopicCard float-left grade_"+cssgrade+" "+statusclass,key:index,'data-userpoints':processedSubTopic.userPoints,'data-grade':processedSubTopic.grade,'data-feedback':processedSubTopic.feedback,'data-subtopicid':processedSubTopic.subTopicId,onClick:_this2.subTopicClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'card-text subcardText'},subtopic.subTopicName),function(){if(!me.isLessonOnlyProduct(me.state.selectedProduct)){if(subtopic.status.toLowerCase()==="un_attempted"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center gradeinfo notattempted'},_this2.rb("dash.notattempted"));}/*else if(subtopic.status.toLowerCase() === "in_progress") {
										return <div className="text-center gradeinfo notattempted">{this.rb("dash.inprogress")}</div>;
									}*/else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center gradeinfo'},mygrade.toUpperCase());}}else{if(subtopic.status.toLowerCase()==="un_attempted"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center gradeinfo notattempted'},_this2.rb("dash.notattempted"));}/*else if(subtopic.status.toLowerCase() === "in_progress") {
										return <div className="text-center gradeinfo notattempted">{this.rb("dash.inprogress")}</div>;
									}*/}}()));}));}}},{key:'getTopicCompletedPercentage',value:function getTopicCompletedPercentage(){//console.log(this.completedTopicCount,topicList.length);
var percentComplete=0;percentComplete=Math.round(this.completedTopicCount/topicList.length*100);return percentComplete;}},{key:'getGradeDisplay',value:function getGradeDisplay(){if(this.state.grade==this.rb("dash.not_available")){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'greyColor fsp8rem'},this.state.grade);}else{var cssgrade=this.state.grade.toLowerCase().split("+").join("plus");if(this.isLessonOnlyProduct(this.state.selectedProduct)){cssgrade="";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"reward "+cssgrade},this.state.grade);}}},{key:'getTopicsCompletedContent',value:function getTopicsCompletedContent(){if(this.state.overallPerformanceLoaded){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row flexcenter justifycenter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-4 flexcenter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'widgetIcon',src:__WEBPACK_IMPORTED_MODULE_8__images_icons_topiccompleted_icon_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-4 text-right piechartparent'},this.piechartFn(this.completedTopicCount,topicList.length)));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.showLoader());}}},{key:'getTopicsCompletedTitle',value:function getTopicsCompletedTitle(){if(this.isLessonOnlyProduct(this.state.selectedProduct)){return this.rb("dash.topics_watched");}else{return this.rb("dash.topics_completed");}}},{key:'getRecentAttemptTitle',value:function getRecentAttemptTitle(){if(this.isLessonOnlyProduct(this.state.selectedProduct)){return this.rb("dash.recently.watched");}else{return this.rb("dash.recently.attempted.topic");}}},{key:'getOverallTitle',value:function getOverallTitle(){if(this.isLessonOnlyProduct(this.state.selectedProduct)){return this.rb("dash.overall.summary");}else{return this.rb("dash.overall.performance");}}},{key:'getRecentAttemptedTopicContent',value:function getRecentAttemptedTopicContent(){var me=this;if(this.state.recentTopicLoaded){if(Object.keys(this.state.recentTestData).length>0){var firstAccessDate=!isNaN(this.state.recentTestData.startTime)?this.state.recentTestData.startTime:null;var testSubmitDate=!isNaN(this.state.recentTestData.endTime)?this.state.recentTestData.endTime:null;var Accessedon=!isNaN(this.state.recentTestData.inTime)?this.state.recentTestData.inTime:" ";var testRecentAccessDate=!isNaN(this.state.recentTestData.trackOpenTime)?this.state.recentTestData.trackOpenTime:null;var recentTopicTitle=this.state.recentTestData.title;var recentTopicSubmittedon=testSubmitDate||testRecentAccessDate||firstAccessDate;var recentTopicStatus=this.state.recentTestData.status==="NEW"?me.rb("IN_PROGRESS"):me.rb(this.state.recentTestData.status);var recentTopicPoints=this.state.recentTestData.totalPoints;var recentTopicUserPoints=this.state.recentTestData.userPoints;var recentTopicName=this.state.recentTestData.topicName||"";var recentSubTopicName=this.state.recentTestData.subTopicName||"";var activityMode=this.state.recentTestData.isActualTest==="true"?"scorecard.revision_test":"scorecard.custom_practice";var recentSubmittedName=this.rb("dash.submitted_on");if(this.state.recentTestData.status=="IN_PROGRESS"){recentSubmittedName=this.rb("dash.accessed_on");}else if(this.state.recentTestData.status=="NEW"){recentSubmittedName=this.rb("dash.accessed_on");}//console.log("dash Recent data : ", this.state.recentTestData);
if(this.isLessonOnlyProduct(this.state.selectedProduct)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-3 recentIconContainer lessonRecentBox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'widgetIcon',src:__WEBPACK_IMPORTED_MODULE_13__images_icons_topic_lesson_icon_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-9 norightpadding headerTxt clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row lessonRecentBox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recentTopicName col-12 col-sm-8 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'greyColor'},recentTopicName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt-10'},recentSubTopicName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'infoTxt col-12 col-sm-4 nopadding lessonAccessedTxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'borderBottom clearfix'},this.rb("dash.watched_on")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'greyColor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_moment___default.a,{unix:true,format:'DD/MM/YYYY'},this.getTimeUtil().setServerTime(Accessedon).getServerTime())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'greyColor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_moment___default.a,{unix:true,format:'hh:mm:ss A'},this.getTimeUtil().setServerTime(Accessedon).getServerTime()))))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-3 recentIconContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'widgetIcon',src:__WEBPACK_IMPORTED_MODULE_9__images_icons_recenttopic_icon_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-9 norightpadding headerTxt clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recentTopicName'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'greyColor'},recentTopicName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt-10'},recentSubTopicName,' - ',this.rb(activityMode))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'infoTxt row col-12 recentAttemptInfo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-4 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'borderBottom clearfix'},recentSubmittedName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'greyColor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_moment___default.a,{unix:true,format:'DD/MM/YYYY'},this.getTimeUtil().setServerTime(recentTopicSubmittedon).getServerTime())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'greyColor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_moment___default.a,{unix:true,format:'hh:mm:ss A'},this.getTimeUtil().setServerTime(recentTopicSubmittedon).getServerTime()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-4 nopadding plp4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'borderBottom'},this.rb("dash.status")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'greyColor'},recentTopicStatus)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-4 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'borderBottom'},this.rb("dash.points_earned")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'points'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'flash_on'),' ',recentTopicUserPoints))))));}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row pt-45'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-3 pb-20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'widgetIcon',src:__WEBPACK_IMPORTED_MODULE_9__images_icons_recenttopic_icon_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-9 nodatamsg'},'You have not started any topic'));}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.showLoader());}}},{key:'hhmmss',value:function hhmmss(secs){var minutes=Math.floor(secs/60);secs=secs%60;var hours=Math.floor(minutes/60);minutes=minutes%60;return this.pad(hours)+":"+this.pad(minutes)+":"+this.pad(secs);}},{key:'pad',value:function pad(num){return("0"+num).slice(-2);}},{key:'getLessonTable',value:function getLessonTable(){//console.log("lessontable...");
/*return(
							{this.state.selectedSubTopic.lessons.map((lesson, index) => {
								return (<tr key={index}>
								<td>{lesson.lessonName}</td>
								<td>{lesson.timeSpent}</td>
								</tr>)
							})}
							);*/return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'"lessonName"'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'"timeSpent"'));}},{key:'renderOverallSubtopicInfo',value:function renderOverallSubtopicInfo(){var _this3=this;if(this.isLessonOnlyProduct(this.state.selectedProduct)){try{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-12 col-lg-6 clearfix nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 nopadding bottomPadding'},function(){var totaltimespent=_this3.hhmmss(_this3.totalTopicTimeSpent);if(_this3.state.selectedSubTopic==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottomBorder'},_this3.rb("dash.totaltimespenttopic")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'topicTimeSpent text-center'},totaltimespent));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottomBorder'},'Subtopic - ',_this3.state.selectedSubTopic.subTopicName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lessonTable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["l" /* Table */],{className:'result1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'resulthead'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,_this3.rb("dash.lessonname")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,_this3.rb("dash.timespent")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,Object.keys(_this3.state.selectedSubTopic.lessons).map(function(lesson,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,_this3.state.selectedSubTopic.lessons[lesson].lessonName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,_this3.hhmmss(_this3.state.selectedSubTopic.lessons[lesson].timeSpent)));})))));}}()));}catch(e){}}else{var me=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-12 col-lg-6 clearfix nopadding'},function(){if(me.state.selectedSubTopic&&me.state.selectedSubTopic!=null){if(me.state.selectedSubTopic.archivedTestDetails&&me.state.selectedSubTopic.archivedTestDetails!=null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row bottomBorder mb20 overallRHS'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-8'},_this3.rb("dash.subtopic"),' - ',_this3.state.selectedSubTopic.subTopicName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-4 text-right norightpadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn btn-primary btnAttempts',onClick:_this3.triggerPreviousAttempts.bind(_this3,Object.values(me.state.selectedSubTopic.archivedTestDetails))},_this3.rb("dash.previousattempts"))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row bottomBorder mb20 overallRHS'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-8'},_this3.rb("dash.subtopic"),' - ',_this3.state.selectedSubTopic.subTopicName));}}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-12 nopadding bottomBorder bottomPadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row clearfix nopadding rightBorder flexcenter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left rightPadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'gradeEarnedIcon',src:__WEBPACK_IMPORTED_MODULE_10__images_icons_gradeEarned_icon_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headerTxt clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.rb("dash.grade_earned")),this.getGradeDisplay()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row clearfix nopadding flexcenter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left rightPadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'pointsEarnedBig',src:__WEBPACK_IMPORTED_MODULE_11__images_icons_pointsEarnedBig_icon_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headerTxt clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.rb("dash.points_earned")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'yellowColor bigPoints'},this.state.pointsEarned))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-12 statusMsgrow plpmsggrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-3 pb-20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_14__images_icons_hey_icon_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-9 text-center feedbackTxtDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.getFeedbackText()))));}}},{key:'getOverallPerformanceContent',value:function getOverallPerformanceContent(){if(this.state.overallPerformanceLoaded){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-12 col-lg-6 topicDropdown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_react_dropdown___default.a,{options:topicList,onChange:this.topicDropdownChange,value:this.defaultOption,placeholder:'Select an option'}),this.populateSubTopics()),this.renderOverallSubtopicInfo());}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.showLoader());}}},{key:'topicDropdownChange',value:function topicDropdownChange(selectedOption){this.defaultOption=selectedOption;this.totalTopicTimeSpent=0;this.setState({feedbackText:this.topicTestMap[this.defaultOption.value].feedback||"",grade:this.topicTestMap[this.defaultOption.value].grade||this.rb("dash.not_available"),selectedTopic:this.topicTestMap[selectedOption.value],selectedSubTopic:null,pointsEarned:this.topicTestMap&&this.topicTestMap[selectedOption.value]&&this.topicTestMap[selectedOption.value].userPoints&&!isNaN(this.topicTestMap[selectedOption.value].userPoints)?this.topicTestMap[selectedOption.value].userPoints:0});//this.setState({selectedTopic:this.topicTestMap[selectedOption.value]}); // using same state above
try{var trackObj={"item_id":this.defaultOption.value,"item_type":this.getTracker().enums.selectedItemType.topic,"source":this.getTracker().enums.selectedItemSource.dashboard};this.initiateTrack("item_selected",trackObj);}catch(e){}}},{key:'getProductList',value:function getProductList(){var preselectIndex=0;var gradeProductMap=this.gradeProductMap;var permissions=gradeProductMap[this.selectedGradeOption.value];var accessMap=this.getUser().getAccessMap();if(permissions.length>0){var productArr=[];for(var i=0;i<permissions.length;i++){var classCode=this.classDefnMap[this.selectedGradeOption.value].classCode;var board=this.classDefnMap[this.selectedGradeOption.value].board;var label=this.rb(accessMap[permissions[i]]+"-"+classCode+"-"+board)||this.rb("label-"+permissions[i]+"-"+classCode+"-"+board);if(label===accessMap[permissions[i]]+"-"+classCode+"-"+board||label==="label-"+permissions[i]+"-"+classCode+"-"+board){label=this.rb(accessMap[permissions[i]]+"-menu")||this.rb("label-"+permissions[i]);}productArr.push({"label":label,"value":permissions[i]});console.log("product::",permissions[i],this.preferredProduct);if(permissions[i]==parseInt(this.preferredProduct)){console.log("selectedindex::"+i);preselectIndex=i;}}this.selectedProductOption=productArr[preselectIndex];this.setState({productArr:productArr});this.getTopics();}else{//this.showAlert("",this.rb("home.not_entitled"));
}}},{key:'getGradeList',value:function getGradeList(){var me=this;var callBack=function callBack(response){console.log("response:::",response);var grades=response.classId;var products=response.accessId;var classDefnMap=response.classDefn;me.gradeProductMap=response.gradeProdMap;me.classDefnMap=classDefnMap;var gradeArr=[];var preselectIndex=0;console.log("grades::",grades);if(grades!==null&&grades.length>0){for(var i=0;i<grades.length;i++){if(grades[i]>0){try{var dropDownLabel=me.rb(classDefnMap[grades[i]].className);if(classDefnMap[grades[i]]&&classDefnMap[grades[i]].gradeId){/**
												* IMPORTANT: Replace classId with gradeId when available.
												* This is for grouped classes
												*///if(groupedGradesList.indexOf(classDefnMap[grades[i]].gradeId) === -1){
var gradeDisplayName=me.rb(classDefnMap[grades[i]].gradeDisplayName);//gradeArr.push({"label":gradeDisplayName,"value":classDefnMap[grades[i]].gradeId});	
classDefnMap[grades[i]]["label"]=gradeDisplayName;classDefnMap[grades[i]]["value"]=grades[i];gradeArr.push(classDefnMap[grades[i]]);//gradeArr.push({"label":gradeDisplayName,"value":grades[i],"gradeId":classDefnMap[grades[i]].gradeId,"classId":grades[i]});	
//	groupedGradesList.push(classDefnMap[grades[i]].gradeId);
//}
}else{classDefnMap[grades[i]]["label"]=dropDownLabel;classDefnMap[grades[i]]["value"]=grades[i];gradeArr.push(classDefnMap[grades[i]]);//gradeArr.push({"label":dropDownLabel,"value":grades[i],"gradeId":classDefnMap[grades[i]].gradeId,"classId":grades[i]});	
}//gradeArr.push({"label":dropDownLabel,"value":grades[i]});	
}catch(e){}}}}if(gradeArr&&gradeArr.length>0){for(var i=0;i<gradeArr.length;i++){if(gradeArr[i].value==me.preferredGrade){console.log("selectedindex::"+i);preselectIndex=i;}}}me.selectedGradeOption=gradeArr[preselectIndex];me.setState({gradeArr:gradeArr});me.getProductList();};this.getClassNames(callBack);}},{key:'getClassNames',value:function getClassNames(callBack){var me=this;var callBackSuccess=function callBackSuccess(response){me.setState({comboNamesLoaded:true});callBack.apply(this,[response]);};var callBackFailure=function callBackFailure(error){me.showAlert(me.rb("503.title"),me.rb("503.msg"));};new __WEBPACK_IMPORTED_MODULE_4__util_HmAjax__["a" /* default */](this.getUrlFor("DASH_COMBO_DATA")).get(callBackSuccess,callBackFailure);}},{key:'gradeDropdownChange',value:function gradeDropdownChange(selectedOption){this.selectedGradeOption=selectedOption;this.getProductList();}},{key:'productDropdownChange',value:function productDropdownChange(selectedOption){this.selectedProductOption=selectedOption;this.getTopics();}},{key:'getTopics',value:function getTopics(){this.setState({overallPerformanceLoaded:false,recentTopicLoaded:false,grade:this.rb("dash.not_available"),pointsEarned:0,selectedProduct:this.selectedProductOption.value});var classIdToLoadTopic=this.selectedGradeOption&&this.selectedGradeOption.gradeId?this.selectedGradeOption.gradeId:this.selectedGradeOption.value;this.loadOverallPerformance(this.selectedProductOption.value,classIdToLoadTopic);this.loadRecentTopic(this.selectedProductOption.value,classIdToLoadTopic);try{var accessMap=this.getUser().getAccessMap();this.noLessonMode=accessMap[this.selectedProductOption.value]==="PLP|TEST|TAKE";}catch(e){}try{this.gradeStore={"grd":this.selectedGradeOption.value,"prod":this.selectedProductOption.value};this.setAttribute(this.dashboardDropDownKey,JSON.stringify(this.gradeStore));}catch(e){}try{var trackObj={"grade_id":this.selectedGradeOption.value,"product_type":this.selectedProductOption.value,"source":this.getTracker().enums.selectedProductSource.dashboard};this.initiateTrack("product_selected",trackObj);}catch(e){}}},{key:'loadRecentTopic',value:function loadRecentTopic(accessId,level){var me=this;var callBackSuccess=function callBackSuccess(response){if(_typeof(response.data)==="object"&&Object.keys(response.data).length>0){var recentTestData=response.data;me.setState({recentTopicLoaded:true,recentTestData:recentTestData});}else{me.setState({recentTopicLoaded:true,recentTestData:{}});}};var callBackFailure=function callBackFailure(error){me.showAlert(me.rb("503.title"),me.rb("503.msg"));};if(accessId!==undefined&&level!==undefined&&accessId!==null&&level!==null){new __WEBPACK_IMPORTED_MODULE_4__util_HmAjax__["a" /* default */](this.getUrlFor("DASH_RECENT_TEST")+"?access="+accessId+"&level="+level).get(callBackSuccess,callBackFailure);}}},{key:'calculateTopicCompletedCount',value:function calculateTopicCompletedCount(){this.completedTopicCount++;}},{key:'resetCount',value:function resetCount(){this.completedTopicCount=0;}},{key:'loadOverallPerformance',value:function loadOverallPerformance(accessId,level){var me=this;if(!this.topicListRequestAllowed){return;}this.completedTopicCount=0;topicList=new Array();var callBackSuccess=function callBackSuccess(response){me.topicListRequestAllowed=true;topicList=new Array();if(_typeof(response.data)==="object"&&Object.keys(response.data).length>0){me.setState({overallPerformanceLoaded:true});me.topicDescMap=response.data.topicDescMap;me.topicTestMap=response.data.topicTestMap||response.data.topicLessonMap;me.gradeDefns=response.data.gradeDefns;me.topicGradeDtls=response.data.topicGradeDtls;try{me.calculateGradeForTopics(me.topicTestMap);}catch(e){console.error(e);}me.resetCount();if(me.isLessonOnlyProduct(me.state.selectedProduct)){for(var i in me.topicTestMap){if(me.topicTestMap[i].status&&me.topicTestMap[i].status.toLowerCase()==="completed"){me.calculateTopicCompletedCount();}topicList.push({"label":me.topicTestMap[i].topicName,"value":me.topicTestMap[i].topicId});}}else{for(var i in me.topicDescMap){if(me.topicTestMap[i].status&&me.topicTestMap[i].status.toLowerCase()==="completed"){me.calculateTopicCompletedCount();}//console.log(me.topicDescMap[i]);
topicList.push({"label":me.topicTestMap[i].topicName,"value":me.topicTestMap[i].topicId});}}console.log("topicList::::",topicList);me.defaultOption=topicList[0];me.setState({feedbackText:me.topicTestMap[me.defaultOption.value].feedback||"",grade:me.topicTestMap[me.defaultOption.value].grade||me.rb("dash.not_available"),selectedTopic:me.topicTestMap[me.defaultOption.value],selectedSubTopic:null,pointsEarned:me.topicTestMap&&me.topicTestMap[me.defaultOption.value]&&me.topicTestMap[me.defaultOption.value].userPoints&&!isNaN(me.topicTestMap[me.defaultOption.value].userPoints)?me.topicTestMap[me.defaultOption.value].userPoints:0});//me.setState({selectedTopic:me.topicTestMap[defaultOption.value]}); // using same setState
//me.populateSubTopics();		
}else{}};var callBackFailure=function callBackFailure(error){me.topicListRequestAllowed=true;me.showAlert(me.rb("503.title"),me.rb("503.msg"));};if(this.topicListRequestAllowed&&accessId!==undefined&&level!==undefined&&accessId!==null&&level!==null){new __WEBPACK_IMPORTED_MODULE_4__util_HmAjax__["a" /* default */](this.getUrlFor("DASH_OVERALL_PERFORMANCE")+"?access="+accessId+"&level="+level).get(callBackSuccess,callBackFailure);me.topicListRequestAllowed=false;}}},{key:'piechartFn',value:function piechartFn(value,total){if(total>0){var piedata=[value,total-value];//how many partitions you want
var piecolors=["#FFAA00","#d1d3d4"];//partiation color
var pieindata=[value,"/",total];//inside data of svg
//console.log(piedata + " " + piecolors+" "+pieindata);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'piechart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__views_scorecard_Piechart__["a" /* default */],{data:piedata,colors:piecolors,txtval:pieindata}));}}},{key:'hideLoginModal',value:function hideLoginModal(){this.setState({"ModalShow":false});}},{key:'triggerPreviousAttempts',value:function triggerPreviousAttempts(previousAttemptsArray){console.log("lala :: ",previousAttemptsArray);this.attemptBoundry=3;__WEBPACK_IMPORTED_MODULE_23_jquery___default()(".attemptsBodyContent").css("padding-right","1rem");this.showPreviousAttempts(previousAttemptsArray);}},{key:'showPreviousAttempts',value:function showPreviousAttempts(previousAttemptsArray){this.setState({"ModalShow":true,"ModalContent":this.getPreviousAttempts(previousAttemptsArray)});}},{key:'showMoreAttempt',value:function showMoreAttempt(){this.attemptBoundry=this.attemptsArr.length;this.showPreviousAttempts(this.attemptsArr);__WEBPACK_IMPORTED_MODULE_23_jquery___default()(".attemptsBodyContent").css("padding-right","0rem");}},{key:'showLessAttempt',value:function showLessAttempt(){this.attemptBoundry=3;this.showPreviousAttempts(this.attemptsArr);__WEBPACK_IMPORTED_MODULE_23_jquery___default()(".attemptsBodyContent").css("padding-right","1rem");}},{key:'getPreviousAttempts',value:function getPreviousAttempts(previousAttemptsArray){var _this4=this;this.attemptsArr=previousAttemptsArray;var customAttemptsArr=[];if(this.attemptsArr.length>this.attemptBoundry){for(var i=0;i<this.attemptBoundry;i++){customAttemptsArr.push(this.attemptsArr[i]);}}else{customAttemptsArr=this.attemptsArr;}var me=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'attemptsBodyContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'attemptsContainer'},customAttemptsArr.map(function(attempts,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'attemptInfoContainer',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix attemptInfoTitle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left'},_this4.rb("dash.attempt"),' #',customAttemptsArr[index].diagnostic.version),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-right'},_this4.rb("dash.archive.submitted_on"),': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_moment___default.a,{unix:true,format:'DD MMM YYYY  hh:mm:ss A'},me.getTimeUtil().setServerTime((customAttemptsArr[index].customized?customAttemptsArr[index].customized.endDate:customAttemptsArr[index].diagnostic.endDate)+"").getServerTime()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-12 nopadding attemptInfoBody'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 row clearfix nopadding rightBorder flexcenter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left rightPadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'attemptsGradeEarnedIcon',src:__WEBPACK_IMPORTED_MODULE_10__images_icons_gradeEarned_icon_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headerTxt clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Grade Earned'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center reward rewardsmall c'},customAttemptsArr[index].customized?customAttemptsArr[index].customized.grade:customAttemptsArr[index].diagnostic.grade)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 row clearfix nopadding rightBorder flexcenter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left rightPadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'attemptsPointsEarnedSmall',src:__WEBPACK_IMPORTED_MODULE_12__images_icons_scardp_icon_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headerTxt clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Points Earned'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center yellowColor smallPoints'},customAttemptsArr[index].customized?customAttemptsArr[index].customized.userPoints:customAttemptsArr[index].diagnostic.userPoints)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 row clearfix nopadding flexcenter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left rightPadding previousreporticon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"/scorecard/"+customAttemptsArr[index].diagnostic.testId+"/"+customAttemptsArr[index].diagnostic.version},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'reportProficienyIcon rightPadding',src:__WEBPACK_IMPORTED_MODULE_15__images_icons_report_proficiency_png___default.a}))),function(){if(customAttemptsArr[index].customized){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"/scorecard/"+customAttemptsArr[index].customized.testId+"/"+customAttemptsArr[index].customized.version},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'reportPracticeIcon',src:__WEBPACK_IMPORTED_MODULE_16__images_icons_report_practice_png___default.a})));}}())));})),function(){if(_this4.attemptsArr.length>3&&_this4.attemptBoundry==3){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right showmore',onClick:_this4.showMoreAttempt.bind(_this4,_this4.attemptsArr)},_this4.rb("dash.showmore"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'keyboard_arrow_down'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right showmore showless',onClick:_this4.showLessAttempt},_this4.rb("dash.showless"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'keyboard_arrow_up'));}}());}},{key:'render',value:function render(){if(this.state.comboNamesLoaded){return _get(Dashboard.prototype.__proto__||Object.getPrototypeOf(Dashboard.prototype),'render',this).call(this,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DashboardComponent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dropdownContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_react_dropdown___default.a,{className:'dropdowns hidden',options:this.state.gradeArr,onChange:this.gradeDropdownChange.bind(this),value:this.selectedGradeOption,placeholder:'Select an option'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_react_dropdown___default.a,{className:'dropdowns',options:this.state.productArr,onChange:this.productDropdownChange.bind(this),value:this.selectedProductOption,placeholder:'Select an option'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no-margin-bottom dashboardtitle'},this.rb("title.dashboard"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row dashboardContentContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-6 widgets noleftpadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-header d-flex align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.getTopicsCompletedTitle())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body'},this.getTopicsCompletedContent()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-6 widgets noleftpadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-header d-flex align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.getRecentAttemptTitle())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body recentAttemptBody'},this.getRecentAttemptedTopicContent()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-12 widgets noleftpadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-header d-flex align-items-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.getOverallTitle())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body'},this.getOverallPerformanceContent())))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__views_plp_TestTakingModalComponent__["a" /* default */],{visible:this.state.ModalShow,dialogClassName:'attemptsModalDialog'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'attemptsHeader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center attemptsheadertext'},this.rb("dash.previousattempts")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close attemptsClose',onClick:this.hideLoginModal,'aria-label':'Close'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'close')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-body attemptsModalBody'},this.state.ModalContent)))));}else if(this.state.noProducts){return _get(Dashboard.prototype.__proto__||Object.getPrototypeOf(Dashboard.prototype),'render',this).call(this,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'messageView expiredView text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'expiredlock'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'lock')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.rb("register.noproducts.msg")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.rb("register.noproducts.msg2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_2_react_html_parser___default()(this.rb("register.noproducts.msg3")))));}else{return _get(Dashboard.prototype.__proto__||Object.getPrototypeOf(Dashboard.prototype),'render',this).call(this);}}}]);return Dashboard;}(__WEBPACK_IMPORTED_MODULE_3__views_common_Landing__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Dashboard);

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose__ = __webpack_require__(1092);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose__["a" /* default */])(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_esm_typeof__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized__ = __webpack_require__(144);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__helpers_esm_typeof__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized__["a" /* default */])(self);
}

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf__ = __webpack_require__(1096);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_HmEventRegistry__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OrderReview=function(_PreLoginPage){_inherits(OrderReview,_PreLoginPage);function OrderReview(props){_classCallCheck(this,OrderReview);var _this=_possibleConstructorReturn(this,(OrderReview.__proto__||Object.getPrototypeOf(OrderReview)).call(this,props));_this.getUserId=_this.getUserId.bind(_this);return _this;}_createClass(OrderReview,[{key:'componentDidMount',value:function componentDidMount(){//console.warn("order ",this.props.reviewData)
}},{key:'componentWillMount',value:function componentWillMount(){__WEBPACK_IMPORTED_MODULE_3__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");}},{key:'getUserId',value:function getUserId(){if(this.props.reviewData.userId!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'review-billing-userid'},this.props.reviewData.userId),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));}}},{key:'getAddrss2',value:function getAddrss2(){var address2=this.props.reviewData.city+" , "+this.props.reviewData.state+" , "+this.props.reviewData.zip;return address2;}},{key:'render',value:function render(){var me=this;if(this.props.reviewData){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'confirm-dialog',className:'mdl-dialog'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{align:'center',cellPadding:'0',cellSpacing:'0',className:'container-for-gmail-android',width:'100%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center',valign:'top',width:'100%',className:'content-padding billingReviewTop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellSpacing:'0',cellPadding:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'free-text'},'Please review the billing details below before proceeding to pay.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mini-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'header-sm'},'Billing Address'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'review-billing-name'},this.props.reviewData.fullName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'review-address-1'},this.props.reviewData.address),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'review-address-2'},this.getAddrss2()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'review-address-3'},this.props.reviewData.country))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mini-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'header-sm'},'Email address'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'review-email'},this.props.reviewData.email))))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center',valign:'top',width:'100%',className:'splitblock'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'item-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellSpacing:'0',cellPadding:'0',width:'100%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',{id:'confirm-cart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'title-dark',width:'200'},'Item'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'title-dark table-pull-right',width:'100'},'Validity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'title-dark table-pull-right',width:'100'},'Quantity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'title-dark table-pull-right',width:'70'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'title-dark table-pull-right',width:'100'},'Total')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'item-template'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'item-col item bold4dcolor'},this.props.reviewData.productName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'item-col validity table-pull-right'},this.props.reviewData.validity),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'item-col quantity table-pull-right'},'1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'item-col table-pull-right pt4'},this.props.reviewData.currency),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'item-col price table-pull-right'},this.props.reviewData.price)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'item-col'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'item-col'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'item-col quantity subtotal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'total-space'},'Subtotal'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'total-space'},'GST'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'total-space bold4dcolor'},'Total')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'item-col table-pull-right topbdr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'total-space currency'},this.props.reviewData.currency),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'total-space currency'},this.props.reviewData.currency),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'total-space currency bold4dcolor'},this.props.reviewData.currency),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'item-col price table-pull-right topbdr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'total-space transx4'},this.props.reviewData.basePrice.toFixed(2)),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'total-space'},this.props.reviewData.taxAmount.toFixed(2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'total-space bold4dcolor'},this.props.reviewData.totalAmount.toFixed(2)))))))))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mdl-dialog__actions clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-ga':this.props.reviewData.selectedProductCategoryTypeGA+" - "+this.props.reviewData.selectedProductClassName+" - "+"Proceed to pay",type:'button',className:'submitButton pay float-right',onClick:this.props.proceedPay},'Proceed to Pay'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-ga':this.props.reviewData.selectedProductCategoryTypeGA+" - "+this.props.reviewData.selectedProductClassName+" - "+"Edit Details",type:'button',className:'submitButton go-back float-right',onClick:this.props.hideReviewModal},'Edit Details')));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}}]);return OrderReview;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (OrderReview);

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__products_details_json__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__products_details_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__products_details_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_if_elseif_else_render__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_if_elseif_else_render___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_if_elseif_else_render__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_html_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_plp_TestTakingModalComponent__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_purchase_BillingForm__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_NativeAjax__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var BuyOption=function(_PreLoginPage){_inherits(BuyOption,_PreLoginPage);function BuyOption(props){_classCallCheck(this,BuyOption);var _this=_possibleConstructorReturn(this,(BuyOption.__proto__||Object.getPrototypeOf(BuyOption)).call(this,props));_this.epochTimeFn=function(str){var repTxt=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var replaceTxt=repTxt;var timeVal=replaceTxt;if(str>0){var d=str;//new Date(Number(str) * 1000);
var months=["January","February","March","April","May","June","July","August","September","October","November","December"];var n=d.toDateString();timeVal=d.getDate()+" "+months[d.getMonth()]+"  "+d.getFullYear();//n.substring(4,n.length);
}return timeVal;};_this.state={products_details:{},OPSAvailable:false,ModalShow:false,review_order:false,BillingFormShow:false};_this.productDetails=localStorage.getItem('proDetail');_this.gradeID=localStorage.getItem('grade');_this.proID=localStorage.getItem('product');_this.url=_this.gradeID+'.json';_this.freetrailtextFn=_this.freetrailtextFn.bind(_this);_this.role=props.role||'';_this.showBillingForm=_this.showBillingForm.bind(_this);_this.renderbillingForm=_this.renderbillingForm.bind(_this);_this.showOrderReview=_this.showOrderReview.bind(_this);_this.hideBillingModal=_this.hideBillingModal.bind(_this);_this.hideReviewModal=_this.hideReviewModal.bind(_this);_this.productsJson={};_this.purchaseObj={};//init default to 30
_this.freeTrialDays=!isNaN(window.free_trial_extension.days)&&window.free_trial_extension.days>0?window.free_trial_extension.days:30;//Decide the date until the product can be tried
_this.freeTrialDate=!isNaN(window.free_trial_extension.date)&&window.free_trial_extension.date>0?new Date(window.free_trial_extension.date*1000):new Date();//Default the toggle to days
_this.freeTrialToggle=window.free_trial_extension&&window.free_trial_extension.toggle?window.free_trial_extension.toggle:"days";return _this;}_createClass(BuyOption,[{key:'componentWillMount',value:function componentWillMount(){var me=this;var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status==='active'){me.setState({OPSAvailable:true});}}//console.log("OPS_DETECT response : ", response);
};var callBackFailure=function callBackFailure(response){console.log("Error in OPS_DETECT");};new __WEBPACK_IMPORTED_MODULE_5__util_HmAjax__["a" /* default */](this.getUrlFor("OPS_DETECT")).get(callBackSuccess,callBackFailure);}},{key:'componentDidMount',value:function componentDidMount(){var me=this;this.proID=localStorage.getItem('product');if(this.role=="TCHR"){try{me.tchrgetProductDetails();}catch(e){}}}},{key:'tchrgetProductDetails',value:function tchrgetProductDetails(){var me=this;var callBackSuccess=function callBackSuccess(response){if(response!==null){me.productsJson=response;var sortedProducts=me.sortTeacherProducts(response);me.purchaseObj=sortedProducts[0];//console.log("tchr products ",me.purchaseObj);
}};var callBackFailure=function callBackFailure(response){console.log("Error in PRODUCT_DETAILS");};new __WEBPACK_IMPORTED_MODULE_9__util_NativeAjax__["a" /* default */](this.getUrlFor("PC1_PRODUCTS")).enableCORS().get(callBackSuccess,callBackFailure);}},{key:'sortTeacherProducts',value:function sortTeacherProducts(data){var products=data&&data.productList&&data.productList.length>0?data.productList:[];var tchrProducts=[];var filterProductCategories=window.teacherProducts||[];var appName=data.appName;var appId=data._appId;if(products.length>0){for(var i=0;i<products.length;i++){if(filterProductCategories&&filterProductCategories.length>0&&filterProductCategories.indexOf(products[i].productCategory)>-1){products[i]["appName"]=appName;products[i]["appId"]=appId;tchrProducts.push(products[i]);}else if((!filterProductCategories||filterProductCategories.length==0)&&!isNaN(products[i].productCategory)){products[i]["appName"]=appName;products[i]["appId"]=appId;tchrProducts.push(products[i]);}}}return tchrProducts;}},{key:'getProductDetails',value:function getProductDetails(){//console.log(JSON.parse(this.productDetails));
if(this.productDetails!={}&&this.productDetails!=undefined){return JSON.parse(this.productDetails);}}},{key:'freetrailtextFn',value:function freetrailtextFn(){if(this.props.triedFree){return this.rb("product.freetrial.accessed");}var classname=this.getProductDetails()[this.proID].ClassName;if(classname=="Class 1"||classname=="Class 2"||classname=="Class 3"||classname=="Class 4"){if(this.freeTrialToggle==="date"){return this.rb('product.buyoption.freetrail.until').replace("{0}",this.epochTimeFn(this.freeTrialDate));}return this.rb('product.buyoption.freetrail').replace("{0}",this.freeTrialDays);}else{if(this.freeTrialToggle==="date"){return this.rb('product.buyoption.freetrail.until').replace("{0}",this.epochTimeFn(this.freeTrialDate));}return this.rb('product.buyoption.freetrail').replace("{0}",this.freeTrialDays);}}},{key:'getFreeBtnDisabledClass',value:function getFreeBtnDisabledClass(styles){return this.props.triedFree||this.props.purchased?styles+" opsdisabled":styles;}},{key:'renderFreeTrailProductElement',value:function renderFreeTrailProductElement(data,tarrifid,index){var freeTrailBuyMsg="Take away the hassle of going for TUITIONS";var tboxcontentclass="tboxcontent";var classname=this.getProductDetails()[this.proID].ClassName;try{if(classname=="Class 1"||classname=="Class 2"||classname=="Class 3"||classname=="Class 4"){tboxcontentclass="tboxcontentlarge";freeTrailBuyMsg="Success in Maths is all about developing good work habits, persevering and taking responsibility for your learning";}else if(classname=="Class 9"||classname=="Class 10"){freeTrailBuyMsg="Take diagnostic tests and bridge your learning gaps";}else{freeTrailBuyMsg="Take diagnostic tests and bridge your learning gaps";}}catch(e){}var category=this.getProductDetails()[this.proID].productCategory;var category_ga=this.getProductDetails()[this.proID].productCategory;if(category_ga=="EXAM_PREP_CBSE"){category_ga="CBSE Exam Prep";}if(data.is_trial===true){if(this.props.simpleform=="true"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 mb-10',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':category_ga+" - "+classname+" - Top - Free Trial",href:'#',className:this.getFreeBtnDisabledClass("r-btn col-12 btn_freetrail"),'data-freetrail':'true','data-tarrifid':tarrifid,'data-productid':this.proID,'data-gradeid':this.gradeID,'data-category':category,onClick:this.props.showSubScripeLoginForm},this.freetrailtextFn()));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'t-box left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:tboxcontentclass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'width100p'},freeTrailBuyMsg)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':category_ga+" - "+classname+" - Bottom - Free Trial",href:'#',className:this.getFreeBtnDisabledClass("r-btn notexttransform btn_freetrail"),'data-freetrail':'true','data-tarrifid':tarrifid,'data-productid':this.proID,'data-gradeid':this.gradeID,'data-category':category,onClick:this.props.showSubScripeLoginForm},this.freetrailtextFn())));}}}},{key:'renderPaidProductElement',value:function renderPaidProductElement(data,tarrifid,index){var _this2=this;if(data.is_trial===true){}else{var classname=this.getProductDetails()[this.proID].ClassName;var category=this.getProductDetails()[this.proID].productCategory;var category_ga=this.getProductDetails()[this.proID].productCategory;if(category_ga=="EXAM_PREP_CBSE"){category_ga="CBSE Exam Prep";}var price=0;var monthprice=0;var tboxcontentclass="tboxcontent";try{price=parseInt(Math.round(data.productPrice));monthprice=Math.round(price/12);}catch(e){}var paidBuyMsg="No more hassle of going for tuitions";try{if(classname=="Class 1"||classname=="Class 2"||classname=="Class 3"||classname=="Class 4"){tboxcontentclass="tboxcontentlarge";paidBuyMsg="Mom, you can be the best coach for your child. <br /><span class='buysmallinfo'>Create bonding moments over Math</span>";}}catch(e){}//console.log("category:::",category);
if(this.props.simpleform=="true"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6',key:index},function(){if(_this2.state.OPSAvailable){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':category_ga+" - "+classname+" - Top - Subscribe now",href:'#',className:'r-btn opsenabled col-12 btn_subscribe','data-freetrail':'false','data-tarrifid':tarrifid,'data-productid':_this2.proID,'data-gradeid':_this2.gradeID,'data-category':category,onClick:_this2.props.showSubScripeLoginForm},'SUBSCRIBE NOW');}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':category_ga+" - "+classname+" - Top - Subscribe now",href:'#',className:'r-btn opsdisabled col-12 btn_subscribe','data-freetrail':'false','data-tarrifid':tarrifid,'data-productid':_this2.proID,'data-gradeid':_this2.gradeID,'data-category':category,onClick:_this2.props.showSubScripeLoginForm},'SUBSCRIBE NOW');}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'pt-10 pricetxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa'},'\uF156'),' ',monthprice,' / month ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'smalltxt'},'Billed annually'))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'t-box right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:tboxcontentclass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,__WEBPACK_IMPORTED_MODULE_6_react_html_parser___default()(paidBuyMsg)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'pt-30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa'},'\uF156'),' ',monthprice,' / month ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'font1rem'},'Billed annually'))),function(){if(_this2.state.OPSAvailable){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':category_ga+" - "+classname+" - Bottom - Subscribe now",href:'#',className:'r-btn opsenabled btn_subscribe','data-freetrail':'false','data-tarrifid':tarrifid,'data-productid':_this2.proID,'data-gradeid':_this2.gradeID,'data-category':category,onClick:_this2.props.showSubScripeLoginForm},'JOIN THE HEYMATH! CLUB');}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':category_ga+" - "+classname+" - Bottom - Subscribe now",href:'#',className:'r-btn opsdisabled btn_subscribe','data-freetrail':'false','data-tarrifid':tarrifid,'data-productid':_this2.proID,'data-gradeid':_this2.gradeID,'data-category':category,onClick:_this2.props.showSubScripeLoginForm},'JOIN THE HEYMATH! CLUB');}}()));}}}},{key:'showBillingForm',value:function showBillingForm(){this.setState({BillingFormShow:true,ModalShow:true});}},{key:'hideBillingModal',value:function hideBillingModal(){this.setState({ModalShow:false});}},{key:'showOrderReview',value:function showOrderReview(){this.setState({review_order:true});}},{key:'hideReviewModal',value:function hideReviewModal(){this.setState({review_order:false});}},{key:'renderbillingForm',value:function renderbillingForm(){//console.log("renderbilling Form ",this.state.ModalShow);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__views_plp_TestTakingModalComponent__["a" /* default */],{visible:this.state.ModalShow,dialogClassName:'modal-md'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loginHeader text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center modallogo loginHeaderTxt'},this.rb("billing.information")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close loginClose',onClick:this.hideBillingModal,'aria-label':'Close'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'close')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__views_purchase_BillingForm__["a" /* default */],{purchaseObj:this.purchaseObj,productsJson:this.productsJson,myProps:this.props,ModalShow:this.state.ModalShow,showBillingForm:this.showBillingForm,hideBillingModal:this.hideBillingModal,review_order:this.state.review_order,showOrderReview:this.showOrderReview,hideReviewModal:this.hideReviewModal,purchaseKey:this.state.purchaseKey}))));}},{key:'render',value:function render(){var _this3=this;var monthprice=416;if(this.role==="TCHR"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-10 mx-auto simplebuycontainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 mb-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',className:this.getFreeBtnDisabledClass("r-btn col-12 btn_freetrail"),onClick:this.props.showContactus},this.rb("Teachers.freetrail"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},function(){if(_this3.state.OPSAvailable){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',className:'r-btn opsenabled col-12 btn_subscribe',onClick:_this3.showBillingForm},_this3.rb("Teachers.subscribe"));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',className:'r-btn opsdisabled col-12 btn_subscribe',onClick:_this3.showBillingForm},_this3.rb("Teachers.subscribe"));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'pt-10 pricetxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa'},'\uF156'),' ',monthprice,' / month ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'smalltxt'},'Billed annually'))))),function(){if(_this3.state.BillingFormShow&&_this3.purchaseObj!==undefined){return _this3.renderbillingForm();}}()));}else{this.proID=localStorage.getItem('product');var buy=this.getProductDetails()[this.proID].pricing_details;var myObj;//console.log(buy);
var newArr=Object.keys(buy);//console.log(newArr);
/*var mappedArr = newArr.map(function(i) {
	  console.log(buy[i].productPrice);
	});*/if(this.props.simpleform=="true"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-10 mx-auto simplebuycontainer'},Object.keys(buy).map(function(v,i){return _this3.renderFreeTrailProductElement(buy[v],v,i);}),function(){if(!window.suppress_all_paid_products){return Object.keys(buy).map(function(v,i){return _this3.renderPaidProductElement(buy[v],v,i);});}}()));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},Object.keys(buy).map(function(v,i){return _this3.renderFreeTrailProductElement(buy[v],v,i);}),function(){if(!window.suppress_all_paid_products){return Object.keys(buy).map(function(v,i){return _this3.renderPaidProductElement(buy[v],v,i);});}}())));}}}}]);return BuyOption;}(__WEBPACK_IMPORTED_MODULE_4__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (BuyOption);

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(197);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = processNodes;

var _isEmptyTextNode = __webpack_require__(557);

var _isEmptyTextNode2 = _interopRequireDefault(_isEmptyTextNode);

var _convertNodeToElement = __webpack_require__(325);

var _convertNodeToElement2 = _interopRequireDefault(_convertNodeToElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Processes the nodes generated by htmlparser2 and convert them all into React elements
 *
 * @param {Object[]} nodes List of nodes to process
 * @param {Function} transform Transform function to optionally apply to nodes
 * @returns {React.Element[]} The list of processed React elements
 */
function processNodes(nodes, transform) {

  return nodes.filter(function (node) {
    return !(0, _isEmptyTextNode2.default)(node);
  }).map(function (node, index) {

    // return the result of the transform function if applicable
    var transformed = void 0;
    if (typeof transform === 'function') {
      transformed = transform(node, index);
      if (transformed === null || !!transformed) {
        return transformed;
      }
    }

    // otherwise convert the node as standard
    return (0, _convertNodeToElement2.default)(node, index, transform);
  });
}

/***/ }),
/* 200 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(150).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(574)
var ieee754 = __webpack_require__(575)
var isArray = __webpack_require__(334)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserUtil__ = __webpack_require__(32);
var localeKeysToDelete=[];var loadLocales=function loadLocales(key){if(key&&window[key.toLowerCase()]){localeKeysToDelete.push(key.toLowerCase());return window[key.toLowerCase()];}return window.en_us;};var en_US=loadLocales("en_US");var ta_IN=loadLocales("ta_IN");var hi_IN=loadLocales("hi_IN");var ml_IN=loadLocales("ml_IN");var ms_mly=loadLocales("ms_mly");var te_IN=loadLocales("te_IN");var zh_CN=loadLocales("zh_CN");var zh_TW=loadLocales("zh_TW");var id_indo=loadLocales("id_indo");var en_ZA=loadLocales("en_ZA");//console.log("lalala to deelete ::", localeKeysToDelete);
if(localeKeysToDelete&&localeKeysToDelete.length>0){localeKeysToDelete.map(function(elem,index){window[elem]=null;});}var RbUtil=function(){var ALL_LOCALES=["en_us","hi_in","ml_in","ms_mly","ta_in","te_in","zh_cn","zh_tw","id_indo","en_za"];//Setting defaultLocale to en_US
var defaultLocale="en_US";//Setting userLocale to en_US unless otherwise changed by the user
var userLocale="en_US";var getGeo=function getGeo(){if(sessionStorage.getItem("geo")&&sessionStorage.getItem("geo").length>0){return sessionStorage.getItem("geo");}return __WEBPACK_IMPORTED_MODULE_0__BrowserUtil__["a" /* default */].getCookie("geo");};var getBundle=function getBundle(locale){locale=getGeo()?locale+"_"+getGeo().toLowerCase():locale;locale=typeof locale==="string"?locale.toLowerCase():locale;switch(locale){case"en_us":return en_US;case"hi_in":return hi_IN;case"ml_in":return ml_IN;case"ms_mly":return ms_mly;case"ta_in":return ta_IN;case"te_in":return te_IN;case"zh_cn":return zh_CN;case"zh_tw":return zh_TW;case"id_indo":return id_indo;case"en_za":return en_ZA;default:return en_US;}};var replaceDynamicText=function replaceDynamicText(originalString,replaceStringArray){for(var i=0;i<replaceStringArray.length;i++){var val="{"+i+"}";originalString=originalString.split(val).join(replaceStringArray[i]);}return originalString;};return{getText:function getText(rawTxt){var replaceStringArray=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];try{var rb=getBundle(userLocale);if(rb[rawTxt]){return replaceStringArray.length>0?replaceDynamicText(rb[rawTxt],replaceStringArray):rb[rawTxt];}else if(getBundle(defaultLocale)[rawTxt]){return replaceStringArray.length>0?replaceDynamicText(getBundle(defaultLocale)[rawTxt],replaceStringArray):getBundle(defaultLocale)[rawTxt];}}catch(e){console.error(e);}return replaceStringArray.length>0?replaceDynamicText(rawTxt,replaceStringArray):rawTxt;},setLocale:function setLocale(locale){userLocale=locale;},getLocale:function getLocale(){return userLocale;},getLocales:function getLocales(){return ALL_LOCALES;}};}();/* harmony default export */ __webpack_exports__["a"] = (RbUtil);

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CorePage__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_bg_404_png__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_bg_404_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_bg_404_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_errorPage_css__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_errorPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__css_errorPage_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ErrorPage=function(_CorePage){_inherits(ErrorPage,_CorePage);function ErrorPage(){_classCallCheck(this,ErrorPage);return _possibleConstructorReturn(this,(ErrorPage.__proto__||Object.getPrototypeOf(ErrorPage)).apply(this,arguments));}_createClass(ErrorPage,[{key:'componentDidMount',value:function componentDidMount(){try{var errPath=document.location.pathname;if(errPath!==null&&errPath.length>1){errPath=errPath.replace("/","");document.title+=" "+errPath+" ";}else{document.title+=" 404 ";}}catch(e){document.title+=" 404 ";}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'errorContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'errorback text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fff'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'f100 robotto fwb'},'404')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'f40 fwb'},'Oops.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'f30'},'You seem to be lost.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'f30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Let\'s get you back ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/',className:'r-btn errHome'},'Home'),' '))))));}}]);return ErrorPage;}(__WEBPACK_IMPORTED_MODULE_1__CorePage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ErrorPage);

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAQCAYAAAAS7Y8mAAAAAXNSR0IArs4c6QAAAL5JREFUOBG1k8ENwjAMRVPEBNzhzChcOkrFLkzDIAjUY4ErE7RgnqMgVRVWDW0s/bpx7KfIToKIlOiM5rIToLLg04QQNmhOuypYlFhgU8mglPFCspgKs+pHwZziiLYWwIxTFM1KSNst/oBWVp7G2Y+txT91Ec0q+Own/8BXaPktn/jf4MSXCz+7IbwPHu3xsNi5llyt6LzgX4fnAruvW6/Hba6X1+UaXtD7eENrvUfOiXvS7nriCtWebGeOsvZviDVaQmmX5pwAAAAASUVORK5CYII="

/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 214 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 215 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
var document = __webpack_require__(9).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var core = __webpack_require__(50);
var LIBRARY = __webpack_require__(77);
var wksExt = __webpack_require__(345);
var defineProperty = __webpack_require__(24).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(131)('keys');
var uid = __webpack_require__(83);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 219 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(9).document;
module.exports = document && document.documentElement;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(14);
var anObject = __webpack_require__(8);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(51)(Function.call, __webpack_require__(46).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
var setPrototypeOf = __webpack_require__(221).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(53);
var defined = __webpack_require__(64);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 225 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 226 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(77);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(41);
var hide = __webpack_require__(40);
var Iterators = __webpack_require__(112);
var $iterCreate = __webpack_require__(228);
var setToStringTag = __webpack_require__(109);
var getPrototypeOf = __webpack_require__(47);
var ITERATOR = __webpack_require__(19)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(86);
var descriptor = __webpack_require__(82);
var setToStringTag = __webpack_require__(109);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(40)(IteratorPrototype, __webpack_require__(19)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(161);
var defined = __webpack_require__(64);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(19)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(112);
var ITERATOR = __webpack_require__(19)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(24);
var createDesc = __webpack_require__(82);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(110);
var ITERATOR = __webpack_require__(19)('iterator');
var Iterators = __webpack_require__(112);
module.exports = __webpack_require__(50).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(760);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(27);
var toAbsoluteIndex = __webpack_require__(85);
var toLength = __webpack_require__(21);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(79);
var step = __webpack_require__(362);
var Iterators = __webpack_require__(112);
var toIObject = __webpack_require__(45);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(227)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(134);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(160)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(51);
var invoke = __webpack_require__(352);
var html = __webpack_require__(220);
var cel = __webpack_require__(216);
var global = __webpack_require__(9);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(52)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var macrotask = __webpack_require__(239).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(52)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(34);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9);
var DESCRIPTORS = __webpack_require__(22);
var LIBRARY = __webpack_require__(77);
var $typed = __webpack_require__(167);
var hide = __webpack_require__(40);
var redefineAll = __webpack_require__(91);
var fails = __webpack_require__(13);
var anInstance = __webpack_require__(89);
var toInteger = __webpack_require__(53);
var toLength = __webpack_require__(21);
var toIndex = __webpack_require__(372);
var gOPN = __webpack_require__(87).f;
var dP = __webpack_require__(24).f;
var arrayFill = __webpack_require__(235);
var setToStringTag = __webpack_require__(109);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _itemTypeToComponent;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactUltimatePagination = __webpack_require__(872);

var _FlatButton = __webpack_require__(876);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

var _firstPage = __webpack_require__(929);

var _firstPage2 = _interopRequireDefault(_firstPage);

var _lastPage = __webpack_require__(934);

var _lastPage2 = _interopRequireDefault(_lastPage);

var _chevronLeft = __webpack_require__(935);

var _chevronLeft2 = _interopRequireDefault(_chevronLeft);

var _chevronRight = __webpack_require__(936);

var _chevronRight2 = _interopRequireDefault(_chevronRight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var flatButtonStyle = {
  minWidth: 36
};

var Page = function Page(_ref) {
  var value = _ref.value,
      isActive = _ref.isActive,
      onClick = _ref.onClick,
      isDisabled = _ref.isDisabled;
  return _react2.default.createElement(_FlatButton2.default, {
    style: flatButtonStyle,
    label: value.toString(),
    primary: isActive,
    onClick: onClick,
    disabled: isDisabled
  });
};

var Ellipsis = function Ellipsis(_ref2) {
  var onClick = _ref2.onClick,
      isDisabled = _ref2.isDisabled;
  return _react2.default.createElement(_FlatButton2.default, {
    style: flatButtonStyle,
    label: '...',
    onClick: onClick,
    disabled: isDisabled
  });
};

var FirstPageLink = function FirstPageLink(_ref3) {
  var isActive = _ref3.isActive,
      onClick = _ref3.onClick,
      isDisabled = _ref3.isDisabled;
  return _react2.default.createElement(_FlatButton2.default, {
    style: flatButtonStyle,
    icon: _react2.default.createElement(_firstPage2.default, null),
    onClick: onClick,
    disabled: isDisabled
  });
};

var PreviousPageLink = function PreviousPageLink(_ref4) {
  var isActive = _ref4.isActive,
      onClick = _ref4.onClick,
      isDisabled = _ref4.isDisabled;
  return _react2.default.createElement(_FlatButton2.default, {
    style: flatButtonStyle,
    icon: _react2.default.createElement(_chevronLeft2.default, null),
    onClick: onClick,
    disabled: isDisabled
  });
};

var NextPageLink = function NextPageLink(_ref5) {
  var isActive = _ref5.isActive,
      onClick = _ref5.onClick,
      isDisabled = _ref5.isDisabled;
  return _react2.default.createElement(_FlatButton2.default, {
    style: flatButtonStyle,
    icon: _react2.default.createElement(_chevronRight2.default, null),
    onClick: onClick,
    disabled: isDisabled
  });
};

var LastPageLink = function LastPageLink(_ref6) {
  var isActive = _ref6.isActive,
      onClick = _ref6.onClick,
      isDisabled = _ref6.isDisabled;
  return _react2.default.createElement(_FlatButton2.default, {
    style: flatButtonStyle,
    icon: _react2.default.createElement(_lastPage2.default, null),
    onClick: onClick,
    disabled: isDisabled
  });
};

var itemTypeToComponent = (_itemTypeToComponent = {}, _defineProperty(_itemTypeToComponent, _reactUltimatePagination.ITEM_TYPES.PAGE, Page), _defineProperty(_itemTypeToComponent, _reactUltimatePagination.ITEM_TYPES.ELLIPSIS, Ellipsis), _defineProperty(_itemTypeToComponent, _reactUltimatePagination.ITEM_TYPES.FIRST_PAGE_LINK, FirstPageLink), _defineProperty(_itemTypeToComponent, _reactUltimatePagination.ITEM_TYPES.PREVIOUS_PAGE_LINK, PreviousPageLink), _defineProperty(_itemTypeToComponent, _reactUltimatePagination.ITEM_TYPES.NEXT_PAGE_LINK, NextPageLink), _defineProperty(_itemTypeToComponent, _reactUltimatePagination.ITEM_TYPES.LAST_PAGE_LINK, LastPageLink), _itemTypeToComponent);

var UltimatePaginationMaterialUi = (0, _reactUltimatePagination.createUltimatePagination)({ itemTypeToComponent: itemTypeToComponent });

exports.default = UltimatePaginationMaterialUi;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(80);
var document = __webpack_require__(35).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(80);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 247 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(249);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 249 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(251)('keys');
var uid = __webpack_require__(173);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(30);
var global = __webpack_require__(35);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(139) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 252 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 253 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(890)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(389)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(72);
var dPs = __webpack_require__(892);
var enumBugKeys = __webpack_require__(252);
var IE_PROTO = __webpack_require__(250)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(245)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(391).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(43);


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(35);
var core = __webpack_require__(30);
var LIBRARY = __webpack_require__(139);
var wksExt = __webpack_require__(256);
var defineProperty = __webpack_require__(71).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertColorToString = convertColorToString;
exports.convertHexToRGB = convertHexToRGB;
exports.decomposeColor = decomposeColor;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.emphasize = emphasize;
exports.fade = fade;
exports.darken = darken;
exports.lighten = lighten;

var _warning = __webpack_require__(176);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value, min, max) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of, 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
function convertColorToString(color) {
  var type = color.type,
      values = color.values;


  if (type.indexOf('rgb') > -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    for (var i = 0; i < 3; i++) {
      values[i] = parseInt(values[i]);
    }
  }

  var colorString = void 0;

  if (type.indexOf('hsl') > -1) {
    colorString = color.type + '(' + values[0] + ', ' + values[1] + '%, ' + values[2] + '%';
  } else {
    colorString = color.type + '(' + values[0] + ', ' + values[1] + ', ' + values[2];
  }

  if (values.length === 4) {
    colorString += ', ' + color.values[3] + ')';
  } else {
    colorString += ')';
  }

  return colorString;
}

/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 *  @returns {string} A CSS rgb color string
 */
function convertHexToRGB(color) {
  if (color.length === 4) {
    var extendedColor = '#';
    for (var i = 1; i < color.length; i++) {
      extendedColor += color.charAt(i) + color.charAt(i);
    }
    color = extendedColor;
  }

  var values = {
    r: parseInt(color.substr(1, 2), 16),
    g: parseInt(color.substr(3, 2), 16),
    b: parseInt(color.substr(5, 2), 16)
  };

  return 'rgb(' + values.r + ', ' + values.g + ', ' + values.b + ')';
}

/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values and color names.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {{type: string, values: number[]}} A MUI color object
 */
function decomposeColor(color) {
  if (color.charAt(0) === '#') {
    return decomposeColor(convertHexToRGB(color));
  }

  var marker = color.indexOf('(');

   false ? (0, _warning2.default)(marker !== -1, 'Material-UI: The ' + color + ' color was not parsed correctly,\n  because it has an unsupported format (color name or RGB %). This may cause issues in component rendering.') : void 0;

  var type = color.substring(0, marker);
  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });

  return { type: type, values: values };
}

/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21 with 2 digit precision.
 */
function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  var contrastRatio = (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);

  return Number(contrastRatio.toFixed(2)); // Truncate at two digits
}

/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/WAI/GL/wiki/Relative_luminance
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */
function getLuminance(color) {
  color = decomposeColor(color);

  if (color.type.indexOf('rgb') > -1) {
    var rgb = color.values.map(function (val) {
      val /= 255; // normalized
      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    });
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3)); // Truncate at 3 digits
  } else if (color.type.indexOf('hsl') > -1) {
    return color.values[2] / 100;
  }
}

/**
 * Darken or lighten a colour, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;

  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}

/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function fade(color, value) {
  color = decomposeColor(color);
  value = clamp(value, 0, 1);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }
  color.values[3] = value;

  return convertColorToString(color);
}

/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient, 0, 1);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i++) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return convertColorToString(color);
}

/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient, 0, 1);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i++) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return convertColorToString(color);
}

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shallowEqual = __webpack_require__(916);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shallowEqual2.default;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  set: function set(style, key, value) {
    style[key] = value;
  }
};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(67);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(48);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(56);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(57);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(58);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getMuiTheme = __webpack_require__(937);

var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MuiThemeProvider = function (_Component) {
  (0, _inherits3.default)(MuiThemeProvider, _Component);

  function MuiThemeProvider() {
    (0, _classCallCheck3.default)(this, MuiThemeProvider);
    return (0, _possibleConstructorReturn3.default)(this, (MuiThemeProvider.__proto__ || (0, _getPrototypeOf2.default)(MuiThemeProvider)).apply(this, arguments));
  }

  (0, _createClass3.default)(MuiThemeProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        muiTheme: this.props.muiTheme || (0, _getMuiTheme2.default)()
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return MuiThemeProvider;
}(_react.Component);

MuiThemeProvider.childContextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
MuiThemeProvider.propTypes =  false ? {
  children: _propTypes2.default.element,
  muiTheme: _propTypes2.default.object
} : {};
exports.default = MuiThemeProvider;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var red50 = exports.red50 = '#ffebee';
var red100 = exports.red100 = '#ffcdd2';
var red200 = exports.red200 = '#ef9a9a';
var red300 = exports.red300 = '#e57373';
var red400 = exports.red400 = '#ef5350';
var red500 = exports.red500 = '#f44336';
var red600 = exports.red600 = '#e53935';
var red700 = exports.red700 = '#d32f2f';
var red800 = exports.red800 = '#c62828';
var red900 = exports.red900 = '#b71c1c';
var redA100 = exports.redA100 = '#ff8a80';
var redA200 = exports.redA200 = '#ff5252';
var redA400 = exports.redA400 = '#ff1744';
var redA700 = exports.redA700 = '#d50000';

var pink50 = exports.pink50 = '#fce4ec';
var pink100 = exports.pink100 = '#f8bbd0';
var pink200 = exports.pink200 = '#f48fb1';
var pink300 = exports.pink300 = '#f06292';
var pink400 = exports.pink400 = '#ec407a';
var pink500 = exports.pink500 = '#e91e63';
var pink600 = exports.pink600 = '#d81b60';
var pink700 = exports.pink700 = '#c2185b';
var pink800 = exports.pink800 = '#ad1457';
var pink900 = exports.pink900 = '#880e4f';
var pinkA100 = exports.pinkA100 = '#ff80ab';
var pinkA200 = exports.pinkA200 = '#ff4081';
var pinkA400 = exports.pinkA400 = '#f50057';
var pinkA700 = exports.pinkA700 = '#c51162';

var purple50 = exports.purple50 = '#f3e5f5';
var purple100 = exports.purple100 = '#e1bee7';
var purple200 = exports.purple200 = '#ce93d8';
var purple300 = exports.purple300 = '#ba68c8';
var purple400 = exports.purple400 = '#ab47bc';
var purple500 = exports.purple500 = '#9c27b0';
var purple600 = exports.purple600 = '#8e24aa';
var purple700 = exports.purple700 = '#7b1fa2';
var purple800 = exports.purple800 = '#6a1b9a';
var purple900 = exports.purple900 = '#4a148c';
var purpleA100 = exports.purpleA100 = '#ea80fc';
var purpleA200 = exports.purpleA200 = '#e040fb';
var purpleA400 = exports.purpleA400 = '#d500f9';
var purpleA700 = exports.purpleA700 = '#aa00ff';

var deepPurple50 = exports.deepPurple50 = '#ede7f6';
var deepPurple100 = exports.deepPurple100 = '#d1c4e9';
var deepPurple200 = exports.deepPurple200 = '#b39ddb';
var deepPurple300 = exports.deepPurple300 = '#9575cd';
var deepPurple400 = exports.deepPurple400 = '#7e57c2';
var deepPurple500 = exports.deepPurple500 = '#673ab7';
var deepPurple600 = exports.deepPurple600 = '#5e35b1';
var deepPurple700 = exports.deepPurple700 = '#512da8';
var deepPurple800 = exports.deepPurple800 = '#4527a0';
var deepPurple900 = exports.deepPurple900 = '#311b92';
var deepPurpleA100 = exports.deepPurpleA100 = '#b388ff';
var deepPurpleA200 = exports.deepPurpleA200 = '#7c4dff';
var deepPurpleA400 = exports.deepPurpleA400 = '#651fff';
var deepPurpleA700 = exports.deepPurpleA700 = '#6200ea';

var indigo50 = exports.indigo50 = '#e8eaf6';
var indigo100 = exports.indigo100 = '#c5cae9';
var indigo200 = exports.indigo200 = '#9fa8da';
var indigo300 = exports.indigo300 = '#7986cb';
var indigo400 = exports.indigo400 = '#5c6bc0';
var indigo500 = exports.indigo500 = '#3f51b5';
var indigo600 = exports.indigo600 = '#3949ab';
var indigo700 = exports.indigo700 = '#303f9f';
var indigo800 = exports.indigo800 = '#283593';
var indigo900 = exports.indigo900 = '#1a237e';
var indigoA100 = exports.indigoA100 = '#8c9eff';
var indigoA200 = exports.indigoA200 = '#536dfe';
var indigoA400 = exports.indigoA400 = '#3d5afe';
var indigoA700 = exports.indigoA700 = '#304ffe';

var blue50 = exports.blue50 = '#e3f2fd';
var blue100 = exports.blue100 = '#bbdefb';
var blue200 = exports.blue200 = '#90caf9';
var blue300 = exports.blue300 = '#64b5f6';
var blue400 = exports.blue400 = '#42a5f5';
var blue500 = exports.blue500 = '#2196f3';
var blue600 = exports.blue600 = '#1e88e5';
var blue700 = exports.blue700 = '#1976d2';
var blue800 = exports.blue800 = '#1565c0';
var blue900 = exports.blue900 = '#0d47a1';
var blueA100 = exports.blueA100 = '#82b1ff';
var blueA200 = exports.blueA200 = '#448aff';
var blueA400 = exports.blueA400 = '#2979ff';
var blueA700 = exports.blueA700 = '#2962ff';

var lightBlue50 = exports.lightBlue50 = '#e1f5fe';
var lightBlue100 = exports.lightBlue100 = '#b3e5fc';
var lightBlue200 = exports.lightBlue200 = '#81d4fa';
var lightBlue300 = exports.lightBlue300 = '#4fc3f7';
var lightBlue400 = exports.lightBlue400 = '#29b6f6';
var lightBlue500 = exports.lightBlue500 = '#03a9f4';
var lightBlue600 = exports.lightBlue600 = '#039be5';
var lightBlue700 = exports.lightBlue700 = '#0288d1';
var lightBlue800 = exports.lightBlue800 = '#0277bd';
var lightBlue900 = exports.lightBlue900 = '#01579b';
var lightBlueA100 = exports.lightBlueA100 = '#80d8ff';
var lightBlueA200 = exports.lightBlueA200 = '#40c4ff';
var lightBlueA400 = exports.lightBlueA400 = '#00b0ff';
var lightBlueA700 = exports.lightBlueA700 = '#0091ea';

var cyan50 = exports.cyan50 = '#e0f7fa';
var cyan100 = exports.cyan100 = '#b2ebf2';
var cyan200 = exports.cyan200 = '#80deea';
var cyan300 = exports.cyan300 = '#4dd0e1';
var cyan400 = exports.cyan400 = '#26c6da';
var cyan500 = exports.cyan500 = '#00bcd4';
var cyan600 = exports.cyan600 = '#00acc1';
var cyan700 = exports.cyan700 = '#0097a7';
var cyan800 = exports.cyan800 = '#00838f';
var cyan900 = exports.cyan900 = '#006064';
var cyanA100 = exports.cyanA100 = '#84ffff';
var cyanA200 = exports.cyanA200 = '#18ffff';
var cyanA400 = exports.cyanA400 = '#00e5ff';
var cyanA700 = exports.cyanA700 = '#00b8d4';

var teal50 = exports.teal50 = '#e0f2f1';
var teal100 = exports.teal100 = '#b2dfdb';
var teal200 = exports.teal200 = '#80cbc4';
var teal300 = exports.teal300 = '#4db6ac';
var teal400 = exports.teal400 = '#26a69a';
var teal500 = exports.teal500 = '#009688';
var teal600 = exports.teal600 = '#00897b';
var teal700 = exports.teal700 = '#00796b';
var teal800 = exports.teal800 = '#00695c';
var teal900 = exports.teal900 = '#004d40';
var tealA100 = exports.tealA100 = '#a7ffeb';
var tealA200 = exports.tealA200 = '#64ffda';
var tealA400 = exports.tealA400 = '#1de9b6';
var tealA700 = exports.tealA700 = '#00bfa5';

var green50 = exports.green50 = '#e8f5e9';
var green100 = exports.green100 = '#c8e6c9';
var green200 = exports.green200 = '#a5d6a7';
var green300 = exports.green300 = '#81c784';
var green400 = exports.green400 = '#66bb6a';
var green500 = exports.green500 = '#4caf50';
var green600 = exports.green600 = '#43a047';
var green700 = exports.green700 = '#388e3c';
var green800 = exports.green800 = '#2e7d32';
var green900 = exports.green900 = '#1b5e20';
var greenA100 = exports.greenA100 = '#b9f6ca';
var greenA200 = exports.greenA200 = '#69f0ae';
var greenA400 = exports.greenA400 = '#00e676';
var greenA700 = exports.greenA700 = '#00c853';

var lightGreen50 = exports.lightGreen50 = '#f1f8e9';
var lightGreen100 = exports.lightGreen100 = '#dcedc8';
var lightGreen200 = exports.lightGreen200 = '#c5e1a5';
var lightGreen300 = exports.lightGreen300 = '#aed581';
var lightGreen400 = exports.lightGreen400 = '#9ccc65';
var lightGreen500 = exports.lightGreen500 = '#8bc34a';
var lightGreen600 = exports.lightGreen600 = '#7cb342';
var lightGreen700 = exports.lightGreen700 = '#689f38';
var lightGreen800 = exports.lightGreen800 = '#558b2f';
var lightGreen900 = exports.lightGreen900 = '#33691e';
var lightGreenA100 = exports.lightGreenA100 = '#ccff90';
var lightGreenA200 = exports.lightGreenA200 = '#b2ff59';
var lightGreenA400 = exports.lightGreenA400 = '#76ff03';
var lightGreenA700 = exports.lightGreenA700 = '#64dd17';

var lime50 = exports.lime50 = '#f9fbe7';
var lime100 = exports.lime100 = '#f0f4c3';
var lime200 = exports.lime200 = '#e6ee9c';
var lime300 = exports.lime300 = '#dce775';
var lime400 = exports.lime400 = '#d4e157';
var lime500 = exports.lime500 = '#cddc39';
var lime600 = exports.lime600 = '#c0ca33';
var lime700 = exports.lime700 = '#afb42b';
var lime800 = exports.lime800 = '#9e9d24';
var lime900 = exports.lime900 = '#827717';
var limeA100 = exports.limeA100 = '#f4ff81';
var limeA200 = exports.limeA200 = '#eeff41';
var limeA400 = exports.limeA400 = '#c6ff00';
var limeA700 = exports.limeA700 = '#aeea00';

var yellow50 = exports.yellow50 = '#fffde7';
var yellow100 = exports.yellow100 = '#fff9c4';
var yellow200 = exports.yellow200 = '#fff59d';
var yellow300 = exports.yellow300 = '#fff176';
var yellow400 = exports.yellow400 = '#ffee58';
var yellow500 = exports.yellow500 = '#ffeb3b';
var yellow600 = exports.yellow600 = '#fdd835';
var yellow700 = exports.yellow700 = '#fbc02d';
var yellow800 = exports.yellow800 = '#f9a825';
var yellow900 = exports.yellow900 = '#f57f17';
var yellowA100 = exports.yellowA100 = '#ffff8d';
var yellowA200 = exports.yellowA200 = '#ffff00';
var yellowA400 = exports.yellowA400 = '#ffea00';
var yellowA700 = exports.yellowA700 = '#ffd600';

var amber50 = exports.amber50 = '#fff8e1';
var amber100 = exports.amber100 = '#ffecb3';
var amber200 = exports.amber200 = '#ffe082';
var amber300 = exports.amber300 = '#ffd54f';
var amber400 = exports.amber400 = '#ffca28';
var amber500 = exports.amber500 = '#ffc107';
var amber600 = exports.amber600 = '#ffb300';
var amber700 = exports.amber700 = '#ffa000';
var amber800 = exports.amber800 = '#ff8f00';
var amber900 = exports.amber900 = '#ff6f00';
var amberA100 = exports.amberA100 = '#ffe57f';
var amberA200 = exports.amberA200 = '#ffd740';
var amberA400 = exports.amberA400 = '#ffc400';
var amberA700 = exports.amberA700 = '#ffab00';

var orange50 = exports.orange50 = '#fff3e0';
var orange100 = exports.orange100 = '#ffe0b2';
var orange200 = exports.orange200 = '#ffcc80';
var orange300 = exports.orange300 = '#ffb74d';
var orange400 = exports.orange400 = '#ffa726';
var orange500 = exports.orange500 = '#ff9800';
var orange600 = exports.orange600 = '#fb8c00';
var orange700 = exports.orange700 = '#f57c00';
var orange800 = exports.orange800 = '#ef6c00';
var orange900 = exports.orange900 = '#e65100';
var orangeA100 = exports.orangeA100 = '#ffd180';
var orangeA200 = exports.orangeA200 = '#ffab40';
var orangeA400 = exports.orangeA400 = '#ff9100';
var orangeA700 = exports.orangeA700 = '#ff6d00';

var deepOrange50 = exports.deepOrange50 = '#fbe9e7';
var deepOrange100 = exports.deepOrange100 = '#ffccbc';
var deepOrange200 = exports.deepOrange200 = '#ffab91';
var deepOrange300 = exports.deepOrange300 = '#ff8a65';
var deepOrange400 = exports.deepOrange400 = '#ff7043';
var deepOrange500 = exports.deepOrange500 = '#ff5722';
var deepOrange600 = exports.deepOrange600 = '#f4511e';
var deepOrange700 = exports.deepOrange700 = '#e64a19';
var deepOrange800 = exports.deepOrange800 = '#d84315';
var deepOrange900 = exports.deepOrange900 = '#bf360c';
var deepOrangeA100 = exports.deepOrangeA100 = '#ff9e80';
var deepOrangeA200 = exports.deepOrangeA200 = '#ff6e40';
var deepOrangeA400 = exports.deepOrangeA400 = '#ff3d00';
var deepOrangeA700 = exports.deepOrangeA700 = '#dd2c00';

var brown50 = exports.brown50 = '#efebe9';
var brown100 = exports.brown100 = '#d7ccc8';
var brown200 = exports.brown200 = '#bcaaa4';
var brown300 = exports.brown300 = '#a1887f';
var brown400 = exports.brown400 = '#8d6e63';
var brown500 = exports.brown500 = '#795548';
var brown600 = exports.brown600 = '#6d4c41';
var brown700 = exports.brown700 = '#5d4037';
var brown800 = exports.brown800 = '#4e342e';
var brown900 = exports.brown900 = '#3e2723';

var blueGrey50 = exports.blueGrey50 = '#eceff1';
var blueGrey100 = exports.blueGrey100 = '#cfd8dc';
var blueGrey200 = exports.blueGrey200 = '#b0bec5';
var blueGrey300 = exports.blueGrey300 = '#90a4ae';
var blueGrey400 = exports.blueGrey400 = '#78909c';
var blueGrey500 = exports.blueGrey500 = '#607d8b';
var blueGrey600 = exports.blueGrey600 = '#546e7a';
var blueGrey700 = exports.blueGrey700 = '#455a64';
var blueGrey800 = exports.blueGrey800 = '#37474f';
var blueGrey900 = exports.blueGrey900 = '#263238';

var grey50 = exports.grey50 = '#fafafa';
var grey100 = exports.grey100 = '#f5f5f5';
var grey200 = exports.grey200 = '#eeeeee';
var grey300 = exports.grey300 = '#e0e0e0';
var grey400 = exports.grey400 = '#bdbdbd';
var grey500 = exports.grey500 = '#9e9e9e';
var grey600 = exports.grey600 = '#757575';
var grey700 = exports.grey700 = '#616161';
var grey800 = exports.grey800 = '#424242';
var grey900 = exports.grey900 = '#212121';

var black = exports.black = '#000000';
var white = exports.white = '#ffffff';

var transparent = exports.transparent = 'rgba(0, 0, 0, 0)';
var fullBlack = exports.fullBlack = 'rgba(0, 0, 0, 1)';
var darkBlack = exports.darkBlack = 'rgba(0, 0, 0, 0.87)';
var lightBlack = exports.lightBlack = 'rgba(0, 0, 0, 0.54)';
var minBlack = exports.minBlack = 'rgba(0, 0, 0, 0.26)';
var faintBlack = exports.faintBlack = 'rgba(0, 0, 0, 0.12)';
var fullWhite = exports.fullWhite = 'rgba(255, 255, 255, 1)';
var darkWhite = exports.darkWhite = 'rgba(255, 255, 255, 0.87)';
var lightWhite = exports.lightWhite = 'rgba(255, 255, 255, 0.54)';

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalizeString;
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
module.exports = exports["default"];

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrefixedValue;
var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_core_LoggedInPage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_iframe__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_iframe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_iframe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_GetTest_css__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_GetTest_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__css_GetTest_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_ultimate_pagination_material_ui__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_ultimate_pagination_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_ultimate_pagination_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_styles_MuiThemeProvider__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_styles_MuiThemeProvider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_styles_MuiThemeProvider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_confirm_alert__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_confirm_alert_src_react_confirm_alert_css__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_confirm_alert_src_react_confirm_alert_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_confirm_alert_src_react_confirm_alert_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_circular_progressbar__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_circular_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_circular_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_circular_progressbar_dist_styles_css__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_circular_progressbar_dist_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_circular_progressbar_dist_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__model_HmEventRegistry__ = __webpack_require__(7);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Import
// Import css
var GetTest=function(_LoggedInPage){_inherits(GetTest,_LoggedInPage);function GetTest(props){_classCallCheck(this,GetTest);var _this=_possibleConstructorReturn(this,(GetTest.__proto__||Object.getPrototypeOf(GetTest)).call(this,props));_this.render=function(){var me=_this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row modalBase testTakingScreen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 quesDispContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quesNumDisp float-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' Q',_this.state.currentQuesNo)),_this.updatePercentageDisplay(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_circular_progressbar___default.a,{percentage:_this.state.percentageComplete,styles:{path:{stroke:'rgba(62, 152, 199, ${this.state.percentageComplete / 100})'}}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_iframe___default.a,{url:_this.getUrlFor("IFRAME_DOMAIN")+"/prassoapp/20171102/",ref:function ref(e){me.container=e;},position:'relative',id:'quesIframe',width:'100%',className:'quesIframe',height:'100%',styles:{height:"63vh"},allowFullScreen:true})),_this.renderRatingContainer(),_this.renderBottomSection());};_this.displayTextObj={};_this.displayTextObj.solutionTitle=_this.rb("editor.solutionTitle");_this.displayTextObj.answerTitleSingle="";_this.displayTextObj.answerTitlePlural="";_this.displayTextObj.showEditorTooltip=_this.rb("editor.showEditorTooltip");_this.displayTextObj.hideEditorTooltip=_this.rb("editor.hideEditorTooltip");_this.displayTextObj.enterAnswerMessage=_this.rb("editor.enterAnswerMessage");//var iframeContentUrl = this.getUrlFor("IFRAME_DOMAIN") + "/prassoapp/20171102/";
//console.log(this.props.topicInfoObj);
//console.log("currentQNo="+this.props.topicInfoObj.userTest.currentQNo);
_this.testCompleted=false;_this.showSolution=false;_this.state={pageCurrent:_this.props.topicInfoObj.testDetails.mode==1?1:_this.props.topicInfoObj.userTest.currentAttempt,currentAttempt:_this.props.topicInfoObj.testDetails.mode==1?1:_this.props.topicInfoObj.userTest.currentAttempt,currentQuesNo:_this.props.topicInfoObj.testDetails.mode==1?1:_this.props.topicInfoObj.userTest.currentQNo,pageTotal:_this.props.topicInfoObj.testDetails.questionCount,totalQuestions:_this.props.topicInfoObj.testDetails.questionCount,paginationDisabled:false,percentageComplete:0,testMode:_this.props.topicInfoObj.testDetails.mode,questionObj:[],questionRendered:false,attemptedQuestions:_this.props.topicInfoObj.attempts||new Object(),questionEvaluated:false,showSolution:_this.showSolution,testCompleted:_this.testCompleted};_this.onPageChange=_this.onPageChange.bind(_this);_this.handleMessage=_this.handleMessage.bind(_this);_this.iframeLoaded=_this.iframeLoaded.bind(_this);_this.getQuestion=_this.getQuestion.bind(_this);_this.modalCloseEvent=_this.modalCloseEvent.bind(_this);_this.submitClick=_this.submitClick.bind(_this);_this.EvaluateClick=_this.EvaluateClick.bind(_this);_this.NextClick=_this.NextClick.bind(_this);_this.viewHideSolutionClick=_this.viewHideSolutionClick.bind(_this);_this.submitPractice=_this.submitPractice.bind(_this);_this.enableQuestionTrackTimer=false;_this.intervalId=null;_this.checkImageLoaded=_this.checkImageLoaded.bind(_this);_this.trackTestClose=_this.trackTestClose.bind(_this);_this.forceSubmit=false;_this.attemptBeforeEvaluate=null;_this.prassoView=null;_this.isPrassoViewLoaded=false;_this.evalAndNavigate=false;_this.evalAndSubmit=false;_this.isSubmitTriggered=false;_this.submittedQnMap=new Object();_this.correctAns=false;_this.solutionResults=[];_this.attemptsLeft;_this.allowedAttempts;_this.currentAttempt;_this.currentQuestionNo=0;_this.totalCorrectAns;_this.totalNoQuestions=0;_this.isEvaluationGoing=false;_this.currTestQuestionId=null;_this.currentSnippetId=null;_this.questionAnswerStartTime=null;_this.questionAnswerElapsedTime=null;_this.timeSpentAction="";_this.currentRating=null;_this.iframeContentDomain=null;//"http://local.retailmath.com:3000/";
//const UltimatePagination = reactUltimatePaginationBasic.default;  	
_this.trackingQuestionObj={};_this.questionLoadTime=null;return _this;}/*
  * IMPORTANT: This is for the very last question attempted by the user.
  * Auto-submission will still work from TimerComp irrespective of the configuration window.auto_submit_types - FOR NOW
  */_createClass(GetTest,[{key:'isAutoSubmitAllowed',value:function isAutoSubmitAllowed(){try{var testType=this.props.topicInfoObj.testDetails.type;if(window.auto_submit_types&&window.auto_submit_types.length>0){return~window.auto_submit_types.indexOf(testType)?true:false;}}catch(e){console.error(e);}return false;}},{key:'getCurrentQuestionNo',value:function getCurrentQuestionNo(){return this.currentQuestionNo;}},{key:'getTotalQuestions',value:function getTotalQuestions(){return this.totalNoQuestions;}},{key:'forceSubmitMode',value:function forceSubmitMode(testMode){if(!isNaN(testMode)&&window.force_submit_test_mode){return~window.force_submit_test_mode.indexOf(testMode)?true:false;}return false;}},{key:'onCloseHandler',value:function onCloseHandler(){if(!this.isAjaxSubmitTriggered&&(this.forceSubmitMode(this.state.testMode)||this.isAutoSubmitAllowed())&&this.getCurrentQuestionNo()>this.getTotalQuestions()){this.completeTest();}else{//this.triggerGetUserAnswer();
console.warn("This test is not eligible for submit on close.");}}},{key:'onPageChange',value:function onPageChange(page){this.setState({pageCurrent:page,paginationDisabled:true});//this.getQuestion();
this.timeSpentAction="Pagination";this.evalAndNavigate=true;this.evalAndSubmit=false;this.evalAns();}},{key:'evalAns',value:function evalAns(){this.showSolution=false;this.correctAns=false;this.solutionResults=undefined;this.setState({showSolution:false});this.prassoView.postMessage({name:"getUserAnswer"},this.iframeContentDomain);}},{key:'iframeLoaded',value:function iframeLoaded(){if(!this.container){this.container=document.getElementById("quesIframe");}var iframeDOMNode=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.container);this.prassoView=iframeDOMNode.contentWindow;this.isPrassoViewLoaded=true;if(this.prassoView){this.isAjaxSubmitTriggered=false;this.prassoView.postMessage({name:"setDisplayText",params:[this.displayTextObj]},this.iframeContentDomain);if(this.state.testMode==1){//this.prassoView.enableTestMode();
this.prassoView.postMessage({name:"enableTestMode"},this.iframeContentDomain);}}if(this.state.testMode==1){this.getQuestion();}else{//console.log(this.currentQuestionNo,this.totalNoQuestions);
if(this.currentQuestionNo>this.totalNoQuestions){this.setState({testCompleted:true});this.completeTest(true);}else{this.getQuestion();}}}},{key:'componentDidMount',value:function componentDidMount(){this.questionAnswerStartTime=null;this.questionAnswerElapsedTime=null;this.enableQuestionTrackTimer=false;clearInterval(this.intervalId);this.initiateQuestionPulseTimer();this.currentRating=null;this.props.onRef(this);//console.log(this.props.topicInfoObj);
this.currentAttempt=this.props.topicInfoObj.testDetails.mode==1?1:this.props.topicInfoObj.userTest.currentAttempt;this.currentQuestionNo=this.props.topicInfoObj.testDetails.mode==1?1:this.props.topicInfoObj.userTest.currentQNo;this.totalCorrectAns=this.props.topicInfoObj.userTest.totalCorrectAns||0;this.totalNoQuestions=this.props.topicInfoObj.userTest.ques.length||0;this.attemptsLeft=-1;if(this.state.attemptedQuestions){this.submittedQnMap=this.state.attemptedQuestions;}this.iframeContentDomain=this.getUrlFor("IFRAME_DOMAIN");window.addEventListener('message',this.handleMessage,false);if(!this.container){this.container=document.getElementById("quesIframe");}var iframeDOMNode=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.container);iframeDOMNode.addEventListener('load',this.iframeLoaded);__WEBPACK_IMPORTED_MODULE_13__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");}},{key:'compoenentWillMount',value:function compoenentWillMount(){this.props.onRef(undefined);window.removeEventListener('message',this.handleMessage,false);}},{key:'initiateQuestionPulseTimer',value:function initiateQuestionPulseTimer(){var me=this;this.intervalId=setInterval(function(){if(me.enableQuestionTrackTimer){me.trackQuestionPulsed();}},30000);}},{key:'trackQuestionPulsed',value:function trackQuestionPulsed(){try{var trackObj={"test_id":this.props.topicInfoObj.testDetails.id,"snippet_id":this.currentSnippetId,"question_source":this.state.questionObj.questionSource,"attempt_no":this.attemptBeforeEvaluate};this.initiateTrack("question_pulsed",trackObj);}catch(e){}}},{key:'handleMessage',value:function handleMessage(event){console.log(event.origin+", "+this.iframeContentDomain);/*if (event.origin !== this.iframeContentDomain) {
	    console.warn('Invalid origin:', event.origin);
	    return;
	}*/switch(event.data.name){case'renderingCompleted':this.setState({questionRendered:true,paginationDisabled:false});var endTime=new Date().getTime();var questionloadedTime=-1;if(this.questionLoadTime!=null){questionloadedTime=endTime-this.questionLoadTime;}var trackingdummyObj={};if(this.trackingQuestionObj!==undefined&&_typeof(this.trackingQuestionObj)==="object"){for(var key in this.trackingQuestionObj){trackingdummyObj[key]=this.trackingQuestionObj[key];}}trackingdummyObj["load_duration"]=questionloadedTime;this.initiateTrack("question_loaded",trackingdummyObj);this.questionLoadTime=null;questionloadedTime=null;if(this.questionAnswerStartTime==null){this.questionAnswerStartTime=new Date().getTime();}this.enableQuestionTrackTimer=true;if(typeof this.props.resumeTimer==="function"){this.props.resumeTimer();}break;case'userAnswer':this.handleUserAnswer(JSON.parse(event.data.params));break;case'pushedUserAnswer':// enterkey event    	
if(this.state.testMode==1){//if($("#evaluateBtn").hasClass("disabled")===false){	    			
this.evalAndNavigate=false;this.evalAndSubmit=false;this.timeSpentAction="Check";this.handleUserAnswer(JSON.parse(event.data.params));//}
}else{if(this.state.questionEvaluated==false&&this.isEvaluationGoing==false){this.evalAndNavigate=false;this.evalAndSubmit=false;this.timeSpentAction="Check";this.isEvaluationGoing=true;this.handleUserAnswer(JSON.parse(event.data.params));}}break;}}},{key:'handleUserAnswer',value:function handleUserAnswer(userAnswer){var me=this;var userAnswered=userAnswer.userAnswered;var userResponse=userAnswer.userResponse;var topicInfoObj=this.props.topicInfoObj.userTest.ques[this.state.currentQuesNo-1];var testid=this.props.topicInfoObj.testDetails.id;var quesType=this.state.questionObj.questionType;var currrentAttempt=this.state.currentAttempt;var mcqRes=null;var fibRes=null;if(quesType==="mcq"){mcqRes=userResponse;}else{fibRes=userResponse;}me.setState({paginationDisabled:false});if(userAnswered===false){if(me.state.testMode==1){if(this.evalAndSubmit){this.isEvaluationGoing=false;me.trackTimeSpentInQuestion();me.completeTest();return;}if(userAnswer.partialAnswer){this.isSubmitTriggered=false;this.evalAndNavigate=false;this.evalAndSubmit=false;this.isEvaluationGoing=false;return;}}else if(me.state.testMode==2&&this.evalAndSubmit){me.trackTimeSpentInQuestion();this.isEvaluationGoing=false;me.completeTest();return;}}if(userAnswered===false&&me.state.testMode!=1){me.prassoView.focus();this.isEvaluationGoing=false;return;}else{if(me.state.testMode!=1){if(me.state.questionObj.questionType=="mcq"){if(!userResponse.isUserOptionCorrect){me.chooseShowSolution(false,false,this.solutionResults);me.ShowHideSolution();}else{me.chooseShowSolution(false,false,this.solutionResults);me.ShowHideSolution();}}}}//console.log(userAnswered,userResponse);
var callBackSuccess=function callBackSuccess(response){var data=response;var finalResult=true;this.isEvaluationGoing=false;var solutionResults=new Object();for(var res in data){finalResult=finalResult&data[res];solutionResults[res]=data[res];}if(me.state.questionObj.questionType=="fib"){this.showSolution=false;this.correctAns=false;me.setState({showSolution:false});me.chooseShowSolution(this.correctAns,this.showSolution,solutionResults);if(this.showSolution){if(me.state.testMode!=1){me.setScrollElement("answers-display");}}}try{var trackingdummyObj={};if(this.trackingQuestionObj!==undefined&&_typeof(this.trackingQuestionObj)==="object"){for(var key in this.trackingQuestionObj){trackingdummyObj[key]=this.trackingQuestionObj[key];}}trackingdummyObj["result"]=finalResult;trackingdummyObj["answered"]=userAnswered===undefined?true:userAnswered;me.initiateTrack("question_evaluated",trackingdummyObj);}catch(e){}me.postEvaluation(finalResult,userAnswered);};var callBackFailure=function callBackFailure(response){this.isEvaluationGoing=false;console.log("QUESTION_EVALUATE Error : ",response);//me.setState({  modalContent:me.setTestScreen() });
};this.trackTimeSpentInQuestion();var postParams={"snippetId":this.state.questionObj.snippetId,"testId":testid,"questionId":topicInfoObj.id,"questionType":quesType,"fibResponse":fibRes,"mcqResponse":mcqRes,"attemptNumber":currrentAttempt,"questionNumber":topicInfoObj.qOrder,"questionSource":topicInfoObj.source,"mode":me.state.testMode};if(typeof me.props.callbackParent==="function"){postParams["time"]=window.btoa(me.props.callbackParent());console.log("QUESTION_EVALUATE ",me.props.callbackParent());}new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("QUESTION_EVALUATE"),postParams).put(callBackSuccess,callBackFailure);if(typeof this.props.pauseTimer==="function"){this.props.pauseTimer();}}},{key:'postEvaluation',value:function postEvaluation(finalResult,userAnswered){var me=this;var topicInfoObj=this.props.topicInfoObj.userTest.ques[this.state.currentQuesNo-1];var currrentAttempt=this.state.currentAttempt;me.setState({questionEvaluated:true});if(me.state.testMode==1){this.currentQuestionNo=me.state.pageCurrent;me.setState({currentQuesNo:me.state.pageCurrent});if(userAnswered==false||userAnswered==""){delete this.submittedQnMap[topicInfoObj.id+"-"+currrentAttempt];me.setState({attemptedQuestions:this.submittedQnMap});}else{this.submittedQnMap[topicInfoObj.id+"-"+currrentAttempt]=true;me.setState({attemptedQuestions:this.submittedQnMap});}if(me.forceSubmit){this.evalAndSubmit=true;me.completeTest();}else if(this.isSubmitTriggered){me.showSubmitConfirm();this.isSubmitTriggered=false;}else{if(this.evalAndNavigate){me.getQuestion();}else if(this.evalAndSubmit){me.completeTest();}}}else{if(finalResult==true){this.attemptsLeft=-1;this.currentAttempt=1;this.currentQuestionNo++;this.totalCorrectAns++;}else{if(this.allowedAttempts<1){this.currentAttempt++;}else{this.attemptsLeft--;this.currentAttempt++;if(this.attemptsLeft>0){//$("#attemptsLeft").html(attemptsLeft.toString());
}else if(this.attemptsLeft<0){this.attemptsLeft=-1;this.currentAttempt=1;this.currentQuestionNo++;}else{//$("#attemptsLeft").html("-");
this.attemptsLeft=-1;this.currentAttempt=1;this.currentQuestionNo++;}}}me.setState({currentAttempt:this.currentAttempt});console.log(this.currentQuestionNo,this.attemptsLeft,this.currentAttempt);if(this.currentQuestionNo>this.totalNoQuestions){me.setState({testCompleted:true});me.updateProgress();if(this.isAutoSubmitAllowed()){me.completeTest();}return;}}me.updateProgress();}},{key:'chooseShowSolution',value:function chooseShowSolution(correctAns,showsolution,resultsObj){var me=this;if(me.state.testMode!=1){if(me.state.questionObj.questionType=="fib"){//this.prassoView.showSolution(false,showsolution,resultsObj);
me.prassoView.postMessage({name:"showSolution",params:[false,showsolution,resultsObj]},this.iframeContentDomain);}else{//this.prassoView.showSolution(false,showsolution);
me.prassoView.postMessage({name:"showSolution",params:[false,showsolution]},this.iframeContentDomain);}me.ShowHideSolution();}}},{key:'ShowHideSolution',value:function ShowHideSolution(){if(this.showSolution){//$("#displaySolnStudent").html(btn_hidesolution);
}else{//$("#displaySolnStudent").html(btn_viewsolution);
}}},{key:'setScrollElement',value:function setScrollElement(target){var me=this;setTimeout(function(){//this.prassoView.scrollToId(target);
me.prassoView.postMessage({name:"scrollToId",params:[target]},this.iframeContentDomain);},500);}},{key:'modalCloseEvent',value:function modalCloseEvent(){try{window.removeEventListener('message',this.handleMessage,false);}catch(e){}try{this.enableQuestionTrackTimer=false;clearInterval(this.intervalId);}catch(e){}try{this.timeSpentAction="Close";if(this.isVisible(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(".quesDispContainer"))==true){this.trackTimeSpentInQuestion();}}catch(e){}this.trackTestClose();try{var trackObj={"test_id":this.props.topicInfoObj.testDetails.id,"submitted":false};if(this.state.testMode!=1){if(this.state.testCompleted){trackObj.submitted=true;}else{trackObj.submitted=false;}}this.initiateTrack("test_closed",trackObj);}catch(e){}}},{key:'trackTestClose',value:function trackTestClose(){var me=this;try{var postParams={"trackingDefId":4,"testId":this.props.topicInfoObj.testDetails.id,"endTime":new Date().getTime()};var callBackSuccess=function callBackSuccess(response){};var callBackFailure=function callBackFailure(error){console.log("Error in TRACK_TEST_CLOSED");};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("TRACK_TEST_CLOSED"),postParams).post(callBackSuccess,callBackFailure);}catch(e){}}},{key:'isVisible',value:function isVisible(element){var element=__WEBPACK_IMPORTED_MODULE_4_jquery___default()(element);if(element.length>0&&element.css('visibility')!=='hidden'&&element.css('display')!=='none'){return true;}else{return false;}}},{key:'trackTimeSpentInQuestion',value:function trackTimeSpentInQuestion(){if(this.questionAnswerStartTime==null){return;}try{var endTime=new Date().getTime();this.questionAnswerElapsedTime=endTime-this.questionAnswerStartTime;var postParams={"trackingDefId":3,"testId":this.props.topicInfoObj.testDetails.id,"questionId":this.currTestQuestionId,"snippetId":this.currentSnippetId,"currQuestAtt":this.state.currentAttempt,"sourceId":this.state.questionObj.questionSource,"timeSpent":this.questionAnswerElapsedTime,"startTime":this.questionAnswerStartTime,"endTime":endTime,"action":this.timeSpentAction};var me=this;var callBackSuccess=function callBackSuccess(response){};var callBackFailure=function callBackFailure(error){console.log("Error in TRACK_QUESTION_TIMESPENT");};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("TRACK_QUESTION_TIMESPENT"),postParams).post(callBackSuccess,callBackFailure);this.questionAnswerStartTime=new Date().getTime();this.enableQuestionTrackTimer=false;}catch(e){}}},{key:'getQuestion',value:function getQuestion(){this.isEvaluationGoing=false;// this.setState({paginationDisabled:true,questionRendered:false});
this.setState({paginationDisabled:true,questionRendered:false,questionEvaluated:false,currentAttempt:this.currentAttempt,currentQuesNo:this.currentQuestionNo,showSolution:false});var me=this;this.questionAnswerStartTime=null;this.enableQuestionTrackTimer=false;this.currentRating=null;var topicQuesObj=this.props.topicInfoObj.userTest.ques[this.currentQuestionNo-1];var testid=this.props.topicInfoObj.testDetails.id;var getQuestionURL="";this.allowedAttempts=topicQuesObj.attempts;this.currTestQuestionId=topicQuesObj.id;this.currentSnippetId=topicQuesObj.qId;//console.log("topicQuesObj::",topicQuesObj);
if(this.allowedAttempts>0){//$("#totalAttempts").html(this.allowedAttempts.toString());
if(this.attemptsLeft==-1){this.attemptsLeft=this.allowedAttempts-(this.currentAttempt-1);//$("#attemptsLeft").html(this.attemptsLeft.toString());
}}else{//$("#totalAttempts").html("&infin;");
//$("#attemptsLeft").html("&infin;");
}this.attemptBeforeEvaluate=this.state.currentAttempt;var callBackSuccess=function callBackSuccess(response){var dataJsonList=response;var dataQuestion=dataJsonList;if(me.state.testMode==1){dataQuestion=response.questionContainer;}me.setState({questionObj:dataQuestion});//console.log(dataJsonList.answer);
me.prassoView.postMessage({name:"loadQuestion",params:[dataQuestion.question,dataJsonList.answer]},me.iframeContentDomain);me.container.scrollTop=0;me.updateProgress();me.checkImageLoaded();};var callBackFailure=function callBackFailure(response){this.questionLoadTime=null;me.setState({paginationDisabled:false});console.log("GET_QUESTION Error : ",response);//me.setState({  modalContent:me.setTestScreen() });
};if(this.state.testMode==1){getQuestionURL=this.getUrlFor("GET_QUESTION_TEST");}else{getQuestionURL=this.getUrlFor("GET_QUESTION");}new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](getQuestionURL+"?snippetId="+topicQuesObj.qId+"&questionId="+topicQuesObj.id+"&attempt="+this.state.currentAttempt+"&source="+topicQuesObj.source+"&testId="+testid).get(callBackSuccess,callBackFailure);if(this.questionLoadTime==null){this.questionLoadTime=new Date().getTime();}this.trackingQuestionObj={"test_id":testid,"snippet_id":this.currentSnippetId,"question_source":topicQuesObj.source,"attempt_no":this.state.currentAttempt};}},{key:'submitClick',value:function submitClick(forceSubmit){this.forceSubmit=forceSubmit===true?true:false;var me=this;this.isSubmitTriggered=true;this.timeSpentAction="Submit";var unattemptedQuestionCount=this.state.totalQuestions-Object.keys(this.submittedQnMap).length;console.log("unattemptedQuestionCount="+unattemptedQuestionCount);/*if(unattemptedQuestionCount > 0){
			this.triggerGetUserAnswer(); 	
		}else{
			this.showSubmitConfirm();
		}	*/this.triggerGetUserAnswer();}},{key:'submitPractice',value:function submitPractice(){this.isSubmitTriggered=false;this.evalAndNavigate=false;this.evalAndSubmit=true;this.completeTest();return;/**
		*IMPORTANT: Following block may have been written for a purpose which is unknown for the present devs.
		* Hence, commenting the code below. Should there be any unwanted scenarios, please check before uncommenting the following code.
		*//**	var testId = this.props.topicInfoObj.testDetails.id;
		let testType = this.props.topicInfoObj.testDetails.type;

		var trackObj = {
			"test_id": testId,
			"submitted": true
		}		
		this.storeTrackEvent("test_closed", trackObj);

		this.timeSpentAction = "Submit";
		this.trackTimeSpentInQuestion();
		this.trackTestClose();

		let redirectUrl = "/scorecard/"+testId;
		if(testType === 5 || testType === 6){
			//window.location.href="/800";
			redirectUrl = "/report";
		}

		setTimeout(function(){
			window.location.href = redirectUrl;
		},500)
*/}},{key:'triggerGetUserAnswer',value:function triggerGetUserAnswer(){this.evalAndNavigate=false;this.evalAndSubmit=false;this.evalAns();}},{key:'showSubmitConfirm',value:function showSubmitConfirm(){var _this2=this;var me=this;var unattemptedQuestionCount=this.state.totalQuestions-Object.keys(this.submittedQnMap).length;var msg="";if(typeof me.props.resumeTimer==="function"){me.props.resumeTimer();}if(unattemptedQuestionCount>0){//msg = 'You have not attempted '+unattemptedQuestionCount+' question(s).';
msg=this.rb("test.confirm.unattempted",[unattemptedQuestionCount]);}else{msg=this.rb("test.confirm.allanswered");}Object(__WEBPACK_IMPORTED_MODULE_9_react_confirm_alert__["confirmAlert"])({title:this.rb("test.confirm.wanttosubmit"),message:msg,buttons:[{label:this.rb("alert.ok"),onClick:function onClick(){_this2.isSubmitTriggered=false;_this2.evalAndNavigate=false;_this2.evalAndSubmit=true;//me.evalAns();
me.completeTest();}},{label:this.rb("alert.cancel"),onClick:function onClick(){_this2.isSubmitTriggered=false;}}]});}},{key:'showAutoSubmitConfirm',value:function showAutoSubmitConfirm(callback,response){var _this3=this;var me=this;var unattemptedQuestionCount=this.state.totalQuestions-Object.keys(this.submittedQnMap).length;var msg="";if(unattemptedQuestionCount>0){//msg = 'You have not attempted '+unattemptedQuestionCount+' question(s).';
msg=this.rb("test.confirm.unattempted",[unattemptedQuestionCount]);}else{msg=this.rb("test.confirm.allanswered");}Object(__WEBPACK_IMPORTED_MODULE_9_react_confirm_alert__["confirmAlert"])({title:this.rb("test.confirm.autosubmit"),message:msg,buttons:[{label:this.rb("alert.autosubmit.ok"),onClick:function onClick(){if(typeof callback==="function"){callback.apply(_this3,[response]);}/* 	this.isSubmitTriggered = false;
				this.evalAndNavigate = false;
				this.evalAndSubmit = true;
				//me.evalAns();
				me.completeTest(); */}}],closeOnClickOutside:false});}},{key:'completeTest',value:function completeTest(){var isScoreCard=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var me=this;var testId=me.props.topicInfoObj.testDetails.id;var testType=me.props.topicInfoObj.testDetails.type;var finalCallBack=function finalCallBack(response){me.prassoView.postMessage({name:"disableInput"},me.iframeContentDomain);var redirectUrlByType=window.test_type_submit_route?window.test_type_submit_route[testType]:null;if(redirectUrlByType){window.location.href=redirectUrlByType;}else if(me.state.testMode==1||isScoreCard||!redirectUrlByType){console.log("testId22="+testId);var trackObj={"test_id":testId,"submitted":true};me.storeTrackEvent("test_closed",trackObj);me.trackTestClose();window.location.href="/scorecard/"+testId;}if(typeof me.props.closeTimer==="function"){me.props.closeTimer();}};var callBackSuccess=function callBackSuccess(response){if(me.forceSubmit){me.showAutoSubmitConfirm(finalCallBack,response);}else{finalCallBack(response);}};var callBackFailure=function callBackFailure(response){me.isAjaxSubmitTriggered=false;console.log("SUBMIT_TEST Error : ",response);//me.setState({  modalContent:me.setTestScreen() });
};var postParams={"testId":testId,"revisionTestId":this.props.revisiontestid,"topicSubtopicMapId":this.props.topicsubtopicId};if(typeof me.props.callbackParent==="function"){postParams["time"]=window.btoa(me.props.callbackParent());//console.log("submit test ",this.props.callbackParent());
}if(!this.isAjaxSubmitTriggered){this.isAjaxSubmitTriggered=true;new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("SUBMIT_TEST"),postParams).put(callBackSuccess,callBackFailure);}}},{key:'updateProgress',value:function updateProgress(){var percentComplete=0;if(this.state.testMode==1){percentComplete=Math.round(Object.keys(this.submittedQnMap).length/this.state.totalQuestions*100);}else{percentComplete=Math.round((this.currentQuestionNo-1)/this.totalNoQuestions*100);}this.setState({percentageComplete:percentComplete});}},{key:'EvaluateClick',value:function EvaluateClick(){if(this.isEvaluationGoing==false){this.evalAndNavigate=false;this.evalAndSubmit=false;this.isEvaluationGoing=true;this.timeSpentAction="Check";this.evalAns();}}},{key:'NextClick',value:function NextClick(){this.getQuestion();this.timeSpentAction="Next";this.trackTimeSpentInQuestion();}},{key:'viewHideSolutionClick',value:function viewHideSolutionClick(){this.showSolution=!this.showSolution;this.chooseShowSolution(this.correctAns,this.showSolution,this.solutionResults);this.setState({showSolution:this.showSolution});if(this.showSolution){this.setScrollElement("solution-display");}else{this.setScrollElement("question-display");}this.trackShowHideSolution(this.showSolution);this.checkImageLoaded();}},{key:'trackShowHideSolution',value:function trackShowHideSolution(showSol){var myaction="";if(showSol==true){myaction="Open";}else{myaction="Close";}var postParams={trackingDefId:1,testId:this.props.topicInfoObj.testDetails.id,questionId:this.currTestQuestionId,snippetId:this.currentSnippetId,currQuestAtt:this.state.currentAttempt,sourceId:this.state.questionObj.questionSource,action:myaction};var me=this;var callBackSuccess=function callBackSuccess(response){};var callBackFailure=function callBackFailure(error){console.log("Error in TRACK_SOLUTION");};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("TRACK_SOLUTION"),postParams).post(callBackSuccess,callBackFailure);try{var trackObj={"test_id":this.props.topicInfoObj.testDetails.id,"snippet_id":this.currentSnippetId,"question_source":this.state.questionObj.questionSource,"item_type":this.getTracker().enums.viewedItemType.solution,"hidden":!showSol};this.initiateTrack("item_viewed",trackObj);}catch(e){}}},{key:'getStatusText',value:function getStatusText(){if(this.props.topicInfoObj.userTest.status=="IN_PROGRESS"){return this.rb("home.continue");}else{return"Start Practice";}}},{key:'getStatusActionText',value:function getStatusActionText(){if(this.props.subtopic){if(this.props.subtopic.status=="IN_PROGRESS"){if(this.props.subtopic.testStatus=="COMPLETED"&&this.props.subtopic.reqTestStatus!="COMPLETED"){if(this.props.subtopic.reqTestStatus=="IN_PROGRESS"){return this.rb("home.resume");}else{return this.rb("home.start");}}return this.rb("home.resume");}else if(this.props.subtopic.status=="COMPLETED"){return"";}else{return this.rb("home.start");}}else if(this.props.studentStatus){if(this.props.studentStatus==="IN_PROGRESS"){return this.rb("home.resume");}else{return this.rb("home.start");}}}},{key:'getviewhideText',value:function getviewhideText(){if(this.state.showSolution){return this.rb("test.hidesolution");}else{return this.rb("test.viewsolution");}}},{key:'renderBottomSection',value:function renderBottomSection(){var _this4=this;console.log("this.props.topicInfoObj:::",this.props.topicInfoObj);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_styles_MuiThemeProvider___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row nopadding'},function(){if(_this4.state.testMode==1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-12 col-md-9 text-center nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_ultimate_pagination_material_ui___default.a,{currentPage:_this4.state.currentQuesNo,totalPages:_this4.state.pageTotal,boundaryPagesRange:1,siblingPagesRange:1,hidePreviousAndNextPageLinks:false,hideFirstAndLastPageLinks:false,hideEllipsis:false,onChange:_this4.onPageChange,disabled:_this4.state.paginationDisabled})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-12 col-md-3 submittestbtndiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-primary mediumBtn float-right',disabled:!_this4.state.questionRendered,onClick:_this4.submitClick,'data-ga':"Post login - "+_this4.props.gradeName+" - Tests - "+_this4.props.topicInfoObj.testDetails.title+" - "+_this4.props.topicInfoObj.testDetails.topics.split("- Customized Practice").join("")+" - "+(_this4.props.topicInfoObj.testDetails.mode==1?"PT":"CP")+" - "+"Submit Test"},_this4.rb("test.submittest"))));}else{if(_this4.state.questionEvaluated==false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-primary mediumBtn float-right',disabled:!_this4.state.questionRendered&&!_this4.isEvaluationGoing,onClick:_this4.EvaluateClick,'data-ga':"Post login - "+_this4.props.gradeName+" - Tests - "+_this4.props.topicInfoObj.testDetails.title+" - "+_this4.props.topicInfoObj.testDetails.topics.split("- Customized Practice").join("")+" - "+"CP"+" - "+_this4.getStatusActionText()+" - "+_this4.getStatusText()+" - "+"Check"},_this4.rb("test.check"))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-12 nopadding'},function(){if(_this4.state.testCompleted){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-primary mediumBtn float-right mb-20 ml-10',disabled:!_this4.state.questionRendered,onClick:_this4.submitPractice,'data-ga':"Post login - "+_this4.props.gradeName+" - Tests - "+_this4.props.topicInfoObj.testDetails.title+" - "+_this4.props.topicInfoObj.testDetails.topics.split("- Customized Practice").join("")+" - "+"CP"+" - "+_this4.getStatusActionText()+" - "+_this4.getStatusText()+" - "+"Submit"},_this4.rb("test.submit"));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-primary mediumBtn float-right mb-20 ml-10',disabled:!_this4.state.questionRendered,onClick:_this4.NextClick,'data-ga':"Post login - "+_this4.props.gradeName+" - Tests - "+_this4.props.topicInfoObj.testDetails.title+" - "+_this4.props.topicInfoObj.testDetails.topics.split("- Customized Practice").join("")+" - "+"CP"+" - "+_this4.getStatusActionText()+" - "+_this4.getStatusText()+" - "+"Next"},_this4.rb("test.next"));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-primary mediumBtn float-right',disabled:!_this4.state.questionRendered,onClick:_this4.viewHideSolutionClick,'data-ga':"Post login - "+_this4.props.gradeName+" - Tests - "+_this4.props.topicInfoObj.testDetails.title+" - "+_this4.props.topicInfoObj.testDetails.topics.split("- Customized Practice").join("")+" - "+"CP"+" - "+_this4.getStatusActionText()+" - "+_this4.getStatusText()+" - "+_this4.getviewhideText()},function(){if(_this4.state.showSolution){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this4.rb("test.hidesolution"));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this4.rb("test.viewsolution"));}}())));}}}()));}},{key:'updatePercentageDisplay',value:function updatePercentageDisplay(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'percentageDisp float-right'},function(){if(_this5.state.testMode==1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,_this5.state.percentageComplete,'% ',_this5.rb("test.complete"),' ');}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,_this5.state.percentageComplete,'% ',_this5.rb("test.complete"),' \xA0 | \xA0',_this5.rb("test.attemptsleft"),': ',_this5.attemptsLeft<0?0:_this5.attemptsLeft,' ');}}());}},{key:'likeFn',value:function likeFn(event){if(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(event.currentTarget).hasClass("selected")){return false;}var ratingIcons=document.querySelectorAll('.ratingIcon');ratingIcons.forEach(function(rating){rating.classList.remove('selected');});event.currentTarget.classList.add("selected");var postParams={trackingDefId:2,testId:this.props.topicInfoObj.testDetails.id,questionId:this.currTestQuestionId,snippetId:this.currentSnippetId,rating:parseInt(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(event.currentTarget).attr("data-id")),currQuestAtt:this.state.currentAttempt,sourceId:this.state.questionObj.questionSource,action:"submit"};this.currentRating=parseInt(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(event.currentTarget).attr("data-id"));var me=this;var callBackSuccess=function callBackSuccess(response){__WEBPACK_IMPORTED_MODULE_4_jquery___default()(".likebox").attr("data-myrating",this.currentRating);};var callBackFailure=function callBackFailure(error){console.log("Error in TRACK_SOLUTION");};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("TRACK_SOLUTION"),postParams).post(callBackSuccess,callBackFailure);try{var trackObj={"test_id":this.props.topicInfoObj.testDetails.id,"snippet_id":this.currentSnippetId,"question_source":this.state.questionObj.questionSource,"attempt_no":this.attemptBeforeEvaluate,"helpful":parseInt(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(event.currentTarget).attr("data-id"))===2,"source":this.getTracker().enums.itemRatedSource.test};this.initiateTrack("solution_rated",trackObj);}catch(e){}}},{key:'setRatingSelected',value:function setRatingSelected(id){if(this.currentRating!=null){if(this.currentRating==id){return"selected";}}}},{key:'renderRatingContainer',value:function renderRatingContainer(){if(this.state.showSolution){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'likebox','data-myrating':'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.rb("rating.title")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btngp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:"ratingIcon "+this.setRatingSelected(2),'data-id':'2',onClick:this.likeFn.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'thumb_up')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:"ratingIcon "+this.setRatingSelected(1),'data-id':'1',onClick:this.likeFn.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'thumb_down'))));}}},{key:'checkImageLoaded',value:function checkImageLoaded(){try{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('img').unbind("error");__WEBPACK_IMPORTED_MODULE_4_jquery___default()('img').error(function(){var me=this;var timeDelay=5000;if(!__WEBPACK_IMPORTED_MODULE_4_jquery___default()(me).attr('imageReloadCount')){__WEBPACK_IMPORTED_MODULE_4_jquery___default()(me).attr('imageReloadCount',1);}timeDelay=timeDelay*parseInt(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(me).attr('imageReloadCount'));setTimeout(function(){if(!__WEBPACK_IMPORTED_MODULE_4_jquery___default()(me).attr('imageReloadCount')){__WEBPACK_IMPORTED_MODULE_4_jquery___default()(me).attr('imageReloadCount',1);}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()(me).attr('imageReloadCount',parseInt(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(me).attr('imageReloadCount'))+1);}if(__WEBPACK_IMPORTED_MODULE_4_jquery___default()(me).attr('imageReloadCount')<=4){//console.log("timeDelay::",timeDelay);
__WEBPACK_IMPORTED_MODULE_4_jquery___default()(me).attr('src',__WEBPACK_IMPORTED_MODULE_4_jquery___default()(me).attr('src'));}if(console){console.log("image not loaded :"+__WEBPACK_IMPORTED_MODULE_4_jquery___default()(me).attr('src'));}},timeDelay);}).load(function(){//console.log("loaded successfully...");
});}catch(e){}}}]);return GetTest;}(__WEBPACK_IMPORTED_MODULE_2__views_core_LoggedInPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (GetTest);

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(0)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.CircularProgressbar=t(require("react")):e.CircularProgressbar=t(e.React)}(this,function(e){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var r={};return t.m=e,t.c=r,t.i=function(e){return e},t.d=function(e,r,n){t.o(e,r)||Object.defineProperty(e,r,{configurable:!1,enumerable:!0,get:n})},t.n=function(e){var r=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(r,"a",r),r},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=7)}([function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),u=r(6),c=n(u),l=r(4),p=n(l),f=function(e){function t(e){o(this,t);var r=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return r.state={percentage:e.initialAnimation?0:e.percentage},r}return i(t,e),s(t,[{key:"componentDidMount",value:function(){var e=this;this.props.initialAnimation&&(this.initialTimeout=setTimeout(function(){e.requestAnimationFrame=window.requestAnimationFrame(function(){e.setState({percentage:e.props.percentage})})},0))}},{key:"componentWillReceiveProps",value:function(e){this.setState({percentage:e.percentage})}},{key:"componentWillUnmount",value:function(){clearTimeout(this.initialTimeout),window.cancelAnimationFrame(this.requestAnimationFrame)}},{key:"getBackgroundPadding",value:function(){return this.props.background?null==this.props.backgroundPadding?this.props.strokeWidth:this.props.backgroundPadding:0}},{key:"getPathDescription",value:function(){var e=this.getPathRadius(),t=this.props.counterClockwise?1:0;return"\n      M 50,50\n      m 0,-"+e+"\n      a "+e+","+e+" "+t+" 1 1 0,"+2*e+"\n      a "+e+","+e+" "+t+" 1 1 0,-"+2*e+"\n    "}},{key:"getPathStyles",value:function(){var e=2*Math.PI*this.getPathRadius(),t=Math.min(Math.max(this.state.percentage,0),100),r=(100-t)/100*e;return{strokeDasharray:e+"px "+e+"px",strokeDashoffset:(this.props.counterClockwise?-r:r)+"px"}}},{key:"getPathRadius",value:function(){return 50-this.props.strokeWidth/2-this.getBackgroundPadding()}},{key:"render",value:function(){var e=this.props,t=e.percentage,r=e.textForPercentage,n=e.className,o=e.classes,a=e.styles,i=e.strokeWidth,s=this.props.classForPercentage?this.props.classForPercentage(t):"",u=this.getPathDescription(),l=r?r(t):null;return c.default.createElement("svg",{className:o.root+" "+n+" "+s,style:a.root,viewBox:"0 0 100 100"},this.props.background?c.default.createElement("circle",{className:o.background,style:a.background,cx:50,cy:50,r:50}):null,c.default.createElement("path",{className:o.trail,style:a.trail,d:u,strokeWidth:i,fillOpacity:0}),c.default.createElement("path",{className:o.path,d:u,strokeWidth:i,fillOpacity:0,style:Object.assign({},a.path,this.getPathStyles())}),l?c.default.createElement("text",{className:o.text,style:a.text,x:50,y:50},l):null)}}]),t}(c.default.Component);f.propTypes={percentage:p.default.number.isRequired,className:p.default.string,classes:p.default.objectOf(p.default.string),styles:p.default.objectOf(p.default.object),strokeWidth:p.default.number,background:p.default.bool,backgroundPadding:p.default.number,initialAnimation:p.default.bool,counterClockwise:p.default.bool,classForPercentage:p.default.func,textForPercentage:p.default.func},f.defaultProps={strokeWidth:8,className:"",classes:{root:"CircularProgressbar",trail:"CircularProgressbar-trail",path:"CircularProgressbar-path",text:"CircularProgressbar-text",background:"CircularProgressbar-background"},styles:{root:{},trail:{},path:{},text:{},background:{}},background:!1,backgroundPadding:null,initialAnimation:!1,counterClockwise:!1,classForPercentage:null,textForPercentage:function(e){return e+"%"}},t.default=f},function(e,t,r){"use strict";function n(e){return function(){return e}}var o=function(){};o.thatReturns=n,o.thatReturnsFalse=n(!1),o.thatReturnsTrue=n(!0),o.thatReturnsNull=n(null),o.thatReturnsThis=function(){return this},o.thatReturnsArgument=function(e){return e},e.exports=o},function(e,t,r){"use strict";function n(e,t,r,n,a,i,s,u){if(o(t),!e){var c;if(void 0===t)c=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[r,n,a,i,s,u],p=0;c=new Error(t.replace(/%s/g,function(){return l[p++]})),c.name="Invariant Violation"}throw c.framesToPop=1,c}}var o=function(e){};e.exports=n},function(e,t,r){"use strict";var n=r(1),o=r(2),a=r(5);e.exports=function(){function e(e,t,r,n,i,s){s!==a&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return r.checkPropTypes=n,r.PropTypes=r,r}},function(e,t,r){e.exports=r(3)()},function(e,t,r){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(t,r){t.exports=e},function(e,t,r){e.exports=r(0)}])});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Pie */
/* unused harmony export Slice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Piechart_css__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Piechart_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Piechart_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//customize piechart author abdul
var Piechart=function(_React$Component){_inherits(Piechart,_React$Component);function Piechart(props){_classCallCheck(this,Piechart);var _this=_possibleConstructorReturn(this,(Piechart.__proto__||Object.getPrototypeOf(Piechart)).call(this,props));_this.state={"piedataLoaded":false,data:[],path:'',x:0,y:0};return _this;}_createClass(Piechart,[{key:'componentDidMount',value:function componentDidMount(){console.log("piechart loaded");// setInterval(function () {
var dataSize=3,data=[];for(;dataSize--;){data.push(this.getRandomInt(1,20));}this.setState({data:[]});// }.bind(this), 2000);
}},{key:'getAnglePoint',value:function getAnglePoint(startAngle,endAngle,radius,x,y){var x1,y1,x2,y2;x1=x+radius*Math.cos(Math.PI*startAngle/180);y1=y+radius*Math.sin(Math.PI*startAngle/180);x2=x+radius*Math.cos(Math.PI*endAngle/180);y2=y+radius*Math.sin(Math.PI*endAngle/180);return{x1:x1,y1:y1,x2:x2,y2:y2};}},{key:'getRandomInt',value:function getRandomInt(min,max){return Math.floor(Math.random()*(max-min))+min;}},{key:'getInitialState',value:function getInitialState(){return{data:[5,12,8]};}},{key:'render',value:function render(){var colors=this.props.colors;var data=this.props.data;var txtval=this.props.txtval;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Pie,{data:data,radius:60,hole:55,colors:colors,txtval:txtval}));}}]);return Piechart;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);// labels={true}
// percent={true}
// strokeWidth={1}
// stroke={'#fff'}
var Pie=function(_Piechart){_inherits(Pie,_Piechart);function Pie(props){_classCallCheck(this,Pie);return _possibleConstructorReturn(this,(Pie.__proto__||Object.getPrototypeOf(Pie)).call(this,props));}_createClass(Pie,[{key:'render',value:function render(){var colors=this.props.colors,colorsLength=colors.length,labels=this.props.labels,hole=this.props.hole,radius=this.props.radius,diameter=radius*2,self=this,sum,startAngle,d=null;sum=this.props.data.reduce(function(carry,current){return carry+current;},0);//console.log(sum);
startAngle=-90;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{id:"Piechart",width:diameter,height:diameter,viewBox:'0 0 '+diameter+' '+diameter,xmlns:'http://www.w3.org/2000/svg',version:'1.1'},this.props.data.map(function(slice,sliceIndex){var angle,nextAngle,percent;nextAngle=startAngle;angle=slice/sum*360;percent=slice/sum*100;startAngle+=angle;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Slice,{key:sliceIndex,value:slice,percent:self.props.percent,percentValue:Math.floor(percent),startAngle:nextAngle,angle:angle,radius:radius,hole:radius-hole,trueHole:hole,showLabel:labels,fill:colors[sliceIndex%colorsLength],stroke:self.props.stroke,strokeWidth:self.props.strokeWidth});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:radius,y:radius+10,className:'tval'},this.props.txtval.map(function(slicetxt,slicetxtIndex){var boxClass=["tvl"];boxClass.push(slicetxtIndex);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tspan',{className:boxClass.join(''),key:slicetxtIndex},slicetxt);}))));}}]);return Pie;}(Piechart);var Slice=function(_Piechart2){_inherits(Slice,_Piechart2);function Slice(props){_classCallCheck(this,Slice);var _this3=_possibleConstructorReturn(this,(Slice.__proto__||Object.getPrototypeOf(Slice)).call(this,props));_this3.state={path:'',x:0,y:0};_this3.animate=_this3.animate.bind(_this3);_this3.draw=_this3.draw.bind(_this3);return _this3;}_createClass(Slice,[{key:'getInitialState',value:function getInitialState(){return{path:'',x:0,y:0};}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(){console.log("slice again");// this.setState({ path: ''});
//this.animate();
}},{key:'componentDidMount',value:function componentDidMount(){console.log("slice loaded");this.animate();}},{key:'componentWillUnmount',value:function componentWillUnmount(){// console.log("removed")
// this.ifMounted.unmount();
}},{key:'animate',value:function animate(){this.draw(0);}},{key:'draw',value:function draw(s){// if (!this.isMounted()) {
//     return;
// }
var p=this.props,path=[],a,b,c,self=this,step;step=p.angle/(37.5/2);if(s+step>p.angle){s=p.angle-0.01;}//console.log("draw  "+s +" "+ step+" "+p.angle)
// Get angle points
a=this.getAnglePoint(p.startAngle,p.startAngle+s,p.radius,p.radius,p.radius);b=this.getAnglePoint(p.startAngle,p.startAngle+s,p.radius-p.hole,p.radius,p.radius);path.push('M'+a.x1+','+a.y1);path.push('A'+p.radius+','+p.radius+' 0 '+(s>180?1:0)+',1 '+a.x2+','+a.y2);path.push('L'+b.x2+','+b.y2);path.push('A'+(p.radius-p.hole)+','+(p.radius-p.hole)+' 0 '+(s>180?1:0)+',0 '+b.x1+','+b.y1);// Close
path.push('Z');this.setState({path:path.join(' ')});if(s<p.angle){setTimeout(function(){self.draw(s+step);},16);}else if(p.showLabel){c=this.getAnglePoint(p.startAngle,p.startAngle+p.angle/2,p.radius/2+p.trueHole/2,p.radius,p.radius);console.log(c);this.setState({x:c.x2,y:c.y2});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{overflow:'hidden'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:this.state.path,fill:this.props.fill,stroke:this.props.stroke,strokeWidth:this.props.strokeWidth?this.props.strokeWidth:3}),this.props.showLabel&&this.props.percentValue>5?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{x:this.state.x,y:this.state.y,fill:'#fff',textAnchor:'middle'},this.props.percent?this.props.percentValue+'%':this.props.value):null);}}]);return Slice;}(Piechart);/* harmony default export */ __webpack_exports__["a"] = (Piechart);

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAABICAYAAACjpDbfAAALkElEQVRoge1aX08bxxb/zezujP8mdkzagKri/hGoaqKL6j7cRKrip6gPSOUbXK4I9D7mI+Qj5D5CWqn9AJGo1Jf2iVCp6YvzX2qpaEXaFNTgBOPdtXdmd2fug72+GLCxwaSpxE9CeHfm7J7fnplzzswc4AR/b5DjfPjc3NxprfVEp3ZKaWV+fv7BceowUIIzMzOjlNIpQkgRwASAfC9yWuv7AO4TQpYWFha+HKROAyE4Ozt7GcD1JjGkUink83lwzjE8PNxRzrZtOI6DcrmMjY0NSCmhta4AWFRKXf/888+fHFW3IxFsErtBCJnI5XLI5/MYGxtDOp0GAJimCUppR/kwDBGGYet6fX0dP//8M9bX1+E4DgAshmF47ShED0WwObduEEKmc7kczp8/j/HxcRiGgXg8DsYYOOet/kKIfQlF8H2/1Sfq//jxYzx69AhCiAqA6zdv3vzvYXTtm+Cnn376D6XUEuc8c+HCBRQKBXDOkUwmW6Q8z4PnefB9H0EQHEYvAA2iS0tLePLkCbTW9wkhxYWFhe1+ntEXwbm5uX8B+CKXy2FychLJZBKnTp0C5xxKKbiui3q9vq+VjoJyuYyvv/4aQogKpbTYj+ftmeDVq1c/oZQujo2N4eLFi8jlcq255roubNuG1voQ6vcG27bx7bffolwuV5RSE73Oy54IRsMyn89nPv74Y+RyOViWBd/3sbW1NXCLdYIQArdu3YJt2z0P184uromI3NDQUKZYLCKbzcKyLAghUC6XXxo5AOCc48qVK+CcT2itl3qRMbo1zs3NnQawNDQ0dG5ychKvvfYa4vE4PM/D1tbWIHTuG4lEAm+88QZ++umnc4VCIVMqlb7p1r+rBbXWi4yx/JUrV5DL5ZBIJOD7PiqVymC17hNDQ0P46KOPAODa1atXP+nWtyPBubm5fxFCisViseVQgiDA8+fPj9WZ9Irx8XGcPXsWhJAvmiNtX+xLMArko6OjeOutt3D69GkopbC1tfVKkAMASimKxSIYYxmt9Y2O/Trcv0YIyVy6dAnJZBKmacK27b6Ctm3bWFlZactQBo10Oo13330XhJDpmZmZ0f36mLtvNK13bXx8HKdOnUIymYTneajVal1ftr6+jo2NjbbEOVJiZGRkXxkhBL78srF4yOVyYIxhZGQEqVQK6XQauVyuLeXbo7xpYmxsDKurq9BaXwfw7wMJaq2nCSGZQqGAZDIJAKhWqx1f8v333+Px48eta8YYhoeHMTQ0hOHh4Y7kgIbbv3z5cmtFIaVEqVRqe9b09HRHeaDhVd98802srq5Ozc3NXdsdG/cQBDA9PDyMdDqNeDx+YOoVLYtSqRRGRkZa2U2vGB8f33PPtm3Ytg3G2IHypmlidHQUv/zyS0YpVQTwVVv7zouZmZlRQshEPp9vLXVs2+76gpGRka5WOgzS6XTPH8o0TWQyGSQSCbiuO4VdBNucjGEYRaBhFcYYXNd9ZbxmJxhGI1cZGhoCgKnd7bu96ARjDOl0GrFYDK7rHr+GR0S0oM5kMiCEZHZ70zaCWuuJXC4HoLGme9WttxOnTzdiPaU0v/P+bifTIniYJHplZQV37tyBlBKMMUxOTkZDp2/Zixcv7uuAOiGbzUY/JwDcji7aLEgIyURx5zABOlIQAKSUuHPnzkuRBRrOBmhw2Hn/wOXSX4WI7EFQSnVtHyjBsbGxtut8Pn9o2fPnz/ckd9BU2i/QHxqXLl1COp2GlBKpVKqvObRTljG2h3An9E3wqMnxhQsXXqrsQQuA3WFi6fnz532/5K+E7/sAgM3NTQANDjvbd3vRykGp2auEnRvJEVFKadt2w24nc99xnGNdww0SESkA2N5uLCJ275nutuAiAGxsbBy/dgNAvV5v/d7c3NwzPIFdBOfn5x9orStra2vHrtxRIYRoDU8pJcrlMgAs7u63X5hYXFtbm+7nRbdu3YpOgwaKQqGAQqGwb9vOhUA04pRSBxOklN6QUk6vrKz0FMc4533Fu34Q5cW7Ua/X2zKY5pbF0n7b+XsIzs/PP5idnV0qlUrFXhXv9JWPA0EQtO0PbW5uYnt7G4SQL/br3ylVu+44Dh4+fHgMKh4eSqk9hzw//vgjAKx1Ovrel+DNmzdvA1gslUqv1KLXdd221Gx1dRXlchlKqWudZLol29NSysrt27fb4s1fgchyO+Oz67qR9RY/++yzrzrJdiTY3H6bevr0KZaXl+F53iB17hlKKWxvb7eRk1Lihx9+gO/7awCmu8l3PV26e/fuk0KhgK2traJhGDhz5kxrYfkyEAQBqtXqnhXDvXv38OzZMzTPCLsehHYlCAClUun2Bx98kN/Y2JhQSiGVSoFzDkKOtYYInuehWq22ORQpJe7du4fffvsNAKYXFha6Hp0BPRAEgLt373714YcfZp49e/bParWKXC4HQggsyzo0gU4IgmDPkAQa5L777jv8+eefFULIf3otGOqJIACUSqVvCoXCWrVanXIcB2fPnm3Ny0EQ9X0fjuOgVqvt2c0LwxDLy8uoVCoVSmmxF8tF6JkgAJRKpQcRyXK5jHPnzkEphVqthjAMobUGIaRr8U8EpRSklPA8D47jwPO8ffdXHMfB8vIyqtVq3xUWwCELgZoVTouc88x7772Hd955p62dUtrace6Eg0JPGIZ49OgRfv31V2it7yulpg5T8XRoTzEzMzNqGMYNAFPZbBbvv/8+Xn/99SNvFiul8PTpUzx8+BBCiAoh5AaAG/0WAEU4siucnZ293MwD81ER3ttvvw3OeU+bx5Gz+uOPP7C+vo7ff/89KspbUkpNH7Ugb2C+fr+Kw2w2u3PHeQ+EEKhWq63lzqArDYFjKIhtnhBPo7GFPkEI6VgQ2yR0nxCypJS63y3lOsEJTnCCE5zgBCfYg4FkMlprAoABYLZtM0qpKYSwKKWmlNIghFBCCPV9v/U+y7KUbiBkjIWc8yAMQz+VSvkAfACSENLbOXYXHIqg1joGIFGv1+O2bce01nEhBPd9PxYEAQvDkAdBYAVBYIVhaGqtDaUUJYTQ/z9Ca9M0Q0JISAgJDMPwOecSgDRNU1iWJTjnXjwer1uW5SUSiTqAWr+keyaoteYAki9evEgKIZJSyoQQIun7fkIIkQiCIC6ESDRJxqSUMaUU832faa3NMAxNpRQFAEKIppQqSmlgGEZAKZWmaQrGmGeapmdZlheLxWqmadY55zXGmBuLxWqMMTeZTLqJRMIF4BJCDqzvPHCLrDn8UrVaLeW6bqpWq6WEECkhREpKmRJCpDzPS0opo/9JKWWySTYupYz7vh9TSllhGJoNfkQZhhEYhiEty/IYY3XTNOuxWMxljLX+OOduLBZzOOeO7/uOZVmOECLuOE4skUhwrbVDCOla59nLHiCzbZuFYciVUtz3/VgYhrFI+ciSnuelpJSper2ebpJO73ctpYztUNzmnDvxeNzmnDvRR9Ba0+aHBSFEEUJCSmlICAmaVvellD4AX2stu1myF4J+Op32a7WaDILAZ4xJADIMQxGGoRUppZQyIsWiIWgYhm9Zluf7vh0EwXOllKWUIoQQZZqmbxiGYIx5lmXVGGM1znmNc+5YllXjnNcZY/XmsBWMMWFZlmSMSdM0fc555Ii6DtMDCRJCFICq1jpQSvmmaQrP8zzDMOqmabpBEDixWCzh+37C87x4EARxKWWsORd5GIYsCAILgNGcgwSAjqyyg6hoOpe6ZVn1JsEa59xtEnYty3I55+6ZM2dcAE4vDqdvL6q1pgC4bduJMAxT9Xq9Nc+ahHgYhqz5Z4Vh2HIwhBCilCKUUk0IUZRSBSBozkffMAzJOZeGYXiWZQnLsjzOeV0ptW1ZlpfNZgUhpK8zhEHFQYrGaDBevHhhMcZinucZlFJDCEEppQYACCEIIYRorTXnvBkGtWKMhbFYLJRS1rPZbABAoRELQ0LI36fk8QTHgP8BqD1k7QB7CboAAAAASUVORK5CYII="

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bad.6fad1cd9.gif";

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/good.1a919990.gif";

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/loveit.69b311c8.gif";

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/normal.4edfd750.gif";

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/verybad.15a34c24.gif";

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAAA+CAYAAAEUptYOAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABNJJREFUeNpi/P//P8PXCTP+MxAATEBFDgxEABYQwV2QwYhPEcgwJiyC/7E5hYmBSMCCLoDLGUxo1jbg9DWaaTgVAgQQ45f+6YTDkBhPMIJihGSTgJ7owAg7kEkwDHRfOZT+jyxOmnX4UgpRJgEEECicQMloPwN5YCMQ+wOxIRCfJyqpEQOA3lrIQoQiYyB1BsoVAlr8HofSBUwEDAIF1BmQy6GufweKP7KSDcz7yJkHKFZBdB4hNs8Q7TKoSwRIjQRQ0lAA0vcZqAAAAoio/Egk+MhEpkZDKJ2IJMZPrmHnofR8kgtbInPAfyYGKgJistN/YtMcE7EGESqjiC2F70FdJESVIh3oIiVQJqc0zISghtwlJsxYCGRyUNlFWUYnFxBd8ZPrso9US7TAcBKgyDByvYUGHgIEEKX1Js0AEz0tg6b5h1BuIBAL4ipDBm2IsZBT09ISQFv2+5kYBilgodB35UCqA1+5iqcpR5vED3TUTCRH3UNqCp5FUvYO2uaka650wZHzTIBUJ5JQKF2jEugAZaTCVAnIfoec/aHgPb62L83SGFIjHNQ9QI6y1UC5sAFL/GjRR/9cCQwRUJt+ARAfwNd/ppvDgA4COSYeScgeKFZPo6qKpCZZApBKGNBKnNhBHjqACSACIIBAlfgFIK0/2Jo8g8pB9G6HHUTr0xoisScCceNAOGoBMAMtQMpMF5A6AgugmOpDA0OzGU1qQaoIDM4Hg6SlChmlGCwOGtTRN6jTFCVpAL2NBQKd5Db8KA4paKsUWzu9HOpY+joKzdJ0ULMYTYkxtFdE15AyRiqdZwExaDgLvWncMeAJHeiw1dDG26zBmPtCBzT3EciJ7+ntKFCHtBxPsQACJnSNPmg5dBY90SOBCqCae3RPU9A+IHqOew8dAOkcsDQFynEMJAxGj1bIA9GNB7WfQV35AGB0fRhwR6F1499TO/2QM67wnxgxCsFC6DAB0WMKjEBHGDAgpg8/UjKlQbXog/bPGEd87mOCJWZyZsxp0L0yGLQ9ZIAA7Vw7TgMxFHQk+mi5ACQnQOICUFCTBo4ALWU64AiUUEG9DT0UHIBIcAAKTrDiBnjEiBhjb/aT7D57/SQ3sV1k5Peed2Z2xeo5qdMksETGoaEqPVhzE2Pu3ZrLjLnPIaUhzGUogDs15kAxvugBTMYbfdwSFscN5sZl+2ywwDJf6fHWxYVTavBasMcTdulMQylGAmHA/eKTumHqhj0+PHd03EEMwruxr5asU8EBJjNvyjpFARYJb4zMsyTjAAcNMz1+A4131NQeFBxYtBs9lYBUFtgLy9JiE3YTUTVL/0mk2qsDKNPLBYUjXwVaG40olAJ/u2oBUgxOKQO8uXLrCY21q1DAmtbdAPaeetq5p65FW7Oelcex6EnbMzYBH8iLmMGC9vPhOxEanIzgVEmvnLJNnGCx5W87ZMVpTVp/3kZcC+oGz7ZfpeuZURCkUddA9X4p5Sk7tVLwxKhPBa8UuRIQovgsgnenhEZ6kE5gCU5DOvMhw9q8NQSBg1hY160WAN2rv28KuAJO8IJsgeT45xxYK1jm2wsajEflJ/pv9NqLVLOWwM3Uj4UeEtMXB/S6SSxArfXqQOvIbDDdUIIzRGDs+k5WCMW4txjxez9VOtvQ4/obLJXe2xVMaQwAAAAASUVORK5CYII="

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Td = exports.Tbody = exports.Th = exports.Tr = exports.Thead = exports.Table = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _tableContext = __webpack_require__(996);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var omit = function omit(obj, omitProps) {
  return Object.keys(obj).filter(function (key) {
    return omitProps.indexOf(key) === -1;
  }).reduce(function (returnObj, key) {
    return _objectSpread({}, returnObj, _defineProperty({}, key, obj[key]));
  }, {});
};

var allowed = function allowed(props) {
  return omit(props, ['inHeader', 'columnKey', 'headers']);
};

var Table =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Table, _React$Component);

  function Table(props) {
    var _this;

    _classCallCheck(this, Table);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Table).call(this, props));
    _this.state = {
      headers: {}
    };
    return _this;
  }

  _createClass(Table, [{
    key: "render",
    value: function render() {
      var headers = this.state.headers;
      var classes = (this.props.className || '') + ' responsiveTable';
      return _react["default"].createElement(_tableContext.Provider, {
        value: headers
      }, _react["default"].createElement("table", _extends({}, allowed(this.props), {
        className: classes
      })));
    }
  }]);

  return Table;
}(_react["default"].Component);

exports.Table = Table;

var Thead = function Thead(props) {
  return _react["default"].createElement("thead", allowed(props), _react["default"].cloneElement(props.children, {
    inHeader: true
  }));
};

exports.Thead = Thead;

var TrInner =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(TrInner, _React$Component2);

  function TrInner(props) {
    var _this2;

    _classCallCheck(this, TrInner);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(TrInner).call(this, props));
    var headers = props.headers;

    if (headers && props.inHeader) {
      _react["default"].Children.map(props.children, function (child, i) {
        if (child) {
          headers[i] = child.props.children;
        }
      });
    }

    return _this2;
  }

  _createClass(TrInner, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return _react["default"].createElement("tr", allowed(this.props), children && _react["default"].Children.map(children, function (child, i) {
        return child && _react["default"].cloneElement(child, {
          key: i,
          columnKey: i
        });
      }));
    }
  }]);

  return TrInner;
}(_react["default"].Component);

var Tr = function Tr(props) {
  return _react["default"].createElement(_tableContext.Consumer, null, function (headers) {
    return _react["default"].createElement(TrInner, _extends({}, props, {
      headers: headers
    }));
  });
};

exports.Tr = Tr;

var Th = function Th(props) {
  return _react["default"].createElement("th", allowed(props));
};

exports.Th = Th;

var Tbody = function Tbody(props) {
  return _react["default"].createElement("tbody", allowed(props));
};

exports.Tbody = Tbody;

var TdInner =
/*#__PURE__*/
function (_React$Component3) {
  _inherits(TdInner, _React$Component3);

  function TdInner() {
    _classCallCheck(this, TdInner);

    return _possibleConstructorReturn(this, _getPrototypeOf(TdInner).apply(this, arguments));
  }

  _createClass(TdInner, [{
    key: "render",
    value: function render() {
      if (this.props.colSpan) {
        return _react["default"].createElement("td", allowed(this.props));
      }

      var _this$props = this.props,
          headers = _this$props.headers,
          children = _this$props.children,
          columnKey = _this$props.columnKey;
      var classes = (this.props.className || '') + ' pivoted';
      return _react["default"].createElement("td", {
        className: classes
      }, _react["default"].createElement("div", {
        className: "tdBefore"
      }, headers[columnKey]), children !== undefined ? children : _react["default"].createElement("div", null, "\xA0"));
    }
  }]);

  return TdInner;
}(_react["default"].Component);

var Td = function Td(props) {
  return _react["default"].createElement(_tableContext.Consumer, null, function (headers) {
    return _react["default"].createElement(TdInner, _extends({}, props, {
      headers: headers
    }));
  });
};

exports.Td = Td;

/***/ }),
/* 281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(419);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(283);
exports.Duplex = __webpack_require__(97);
exports.Transform = __webpack_require__(422);
exports.PassThrough = __webpack_require__(1010);


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(182);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(142);
util.inherits = __webpack_require__(60);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(1009)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(420);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(150).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(421);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(97);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(97);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(119), __webpack_require__(1007).setImmediate, __webpack_require__(28)))

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(285),__webpack_require__(0)):"function"==typeof define&&define.amd?define(["moment","react"],t):"object"==typeof exports?exports["react-moment"]=t(require("moment"),require("react")):e["react-moment"]=t(e.moment,e.react)}(this,function(e,t){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return e[r].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function a(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(13),f=r(c),s=n(11),p=r(s),d=n(12),m=r(d),y=n(6),v=[p.default.string,p.default.number,p.default.array,p.default.object],b=[p.default.string,p.default.array],h=[p.default.object,p.default.bool],g=function(e){function t(e){o(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.setTimer=function(){n.clearTimer();var e=n.props.interval;t.pooledTimer||0===e||(n.timer=setInterval(function(){n.update(n.props)},e))},n.clearTimer=function(){!t.pooledTimer&&n.timer&&(clearInterval(n.timer),n.timer=null),t.pooledTimer&&!n.timer&&t.removePooledElement(n)},t.globalMoment||(t.globalMoment=m.default),n.state={content:""},n.timer=null,n}return a(t,e),l(t,null,[{key:"startPooledTimer",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:6e4;t.clearPooledTimer(),t.pooledTimer=setInterval(function(){t.pooledElements.forEach(function(e){0!==e.props.interval&&e.update()})},e)}},{key:"clearPooledTimer",value:function(){t.pooledTimer&&(clearInterval(t.pooledTimer),t.pooledTimer=null,t.pooledElements=[])}},{key:"pushPooledElement",value:function(e){return e instanceof t?void(t.pooledElements.indexOf(e)===-1&&t.pooledElements.push(e)):void console.error("Element not an instance of Moment.")}},{key:"removePooledElement",value:function(e){var n=t.pooledElements.indexOf(e);n!==-1&&t.pooledElements.splice(n,1)}},{key:"getDatetime",value:function(e){var n=e.utc,r=e.unix,o=e.date,i=e.locale,a=e.parse,u=e.tz;o=o||e.children,a=a||t.globalParse,u=u||t.globalTimezone,i=t.globalLocale?t.globalLocale:i||t.globalMoment.locale();var l=null;return l=n?t.globalMoment.utc(o,a,i):r?t.globalMoment(1e3*o,a,i):t.globalMoment(o,a,i),u&&(l=l.tz(u)),l}}]),l(t,[{key:"componentWillMount",value:function(){this.update(this.props)}},{key:"componentDidMount",value:function(){this.setTimer(),t.pooledTimer&&t.pushPooledElement(this)}},{key:"componentWillReceiveProps",value:function(e){this.update(e)}},{key:"componentDidUpdate",value:function(e){e.interval!==this.props.interval&&this.setTimer()}},{key:"componentWillUnmount",value:function(){this.clearTimer()}},{key:"update",value:function(e){var n=this;e=e||this.props;var r=e,o=r.fromNow,i=r.fromNowDuring,a=r.from,u=r.add,l=r.subtract,c=r.toNow,f=r.to,s=r.ago,p=r.calendar,d=r.diff,y=r.unit,v=r.decimal,b=e,h=b.format;h=h||t.globalFormat;var g=t.getDatetime(e);u&&g.add(u),l&&g.subtract(l);var O=Boolean(i)&&-g.diff((0,m.default)())<i,T="";T=h&&!O?g.format(h):a?g.from(a,s):o||O?g.fromNow(s):f?g.to(f,s):c?g.toNow(s):p?g.calendar(null,p):d?g.diff(d,y,v):g.toString();var w=t.globalFilter||this.props.filter;T=w(T),this.setState({content:T},function(){n.props.onChange(T)})}},{key:"render",value:function(){var e=(0,y.objectKeyFilter)(this.props,t.propTypes);return f.default.createElement(t.globalElement||this.props.element,u({dateTime:t.getDatetime(this.props)},e),this.state.content)}}]),t}(f.default.Component);g.propTypes={element:p.default.any,date:p.default.oneOfType(v),parse:p.default.oneOfType(b),format:p.default.string,add:p.default.object,subtract:p.default.object,ago:p.default.bool,fromNow:p.default.bool,fromNowDuring:p.default.number,from:p.default.oneOfType(v),toNow:p.default.bool,to:p.default.oneOfType(v),calendar:p.default.oneOfType(h),unix:p.default.bool,utc:p.default.bool,tz:p.default.string,locale:p.default.string,interval:p.default.number,diff:p.default.oneOfType(v),unit:p.default.string,decimal:p.default.bool,filter:p.default.func,onChange:p.default.func},g.defaultProps={element:"time",fromNow:!1,toNow:!1,calendar:!1,ago:!1,unix:!1,utc:!1,unit:null,decimal:!1,interval:6e4,filter:function(e){return e},onChange:function(){}},g.globalMoment=null,g.globalLocale=null,g.globalFormat=null,g.globalParse=null,g.globalFilter=null,g.globalElement=null,g.globalTimezone=null,g.pooledElements=[],g.pooledTimer=null,t.default=g},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(f===setTimeout)return setTimeout(e,0);if((f===n||!f)&&setTimeout)return f=setTimeout,setTimeout(e,0);try{return f(e,0)}catch(t){try{return f.call(null,e,0)}catch(t){return f.call(this,e,0)}}}function i(e){if(s===clearTimeout)return clearTimeout(e);if((s===r||!s)&&clearTimeout)return s=clearTimeout,clearTimeout(e);try{return s(e)}catch(t){try{return s.call(null,e)}catch(t){return s.call(this,e)}}}function a(){y&&d&&(y=!1,d.length?m=d.concat(m):v=-1,m.length&&u())}function u(){if(!y){var e=o(a);y=!0;for(var t=m.length;t;){for(d=m,m=[];++v<t;)d&&d[v].run();v=-1,t=m.length}d=null,y=!1,i(e)}}function l(e,t){this.fun=e,this.array=t}function c(){}var f,s,p=e.exports={};!function(){try{f="function"==typeof setTimeout?setTimeout:n}catch(e){f=n}try{s="function"==typeof clearTimeout?clearTimeout:r}catch(e){s=r}}();var d,m=[],y=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];m.push(new l(e,t)),1!==m.length||y||o(u)},l.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=c,p.addListener=c,p.once=c,p.off=c,p.removeListener=c,p.removeAllListeners=c,p.emit=c,p.prependListener=c,p.prependOnceListener=c,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){"use strict";function n(e){return function(){return e}}var r=function(){};r.thatReturns=n,r.thatReturnsFalse=n(!1),r.thatReturnsTrue=n(!0),r.thatReturnsNull=n(null),r.thatReturnsThis=function(){return this},r.thatReturnsArgument=function(e){return e},e.exports=r},function(e,t,n){(function(t){"use strict";function n(e,t,n,o,i,a,u,l){if(r(t),!e){var c;if(void 0===t)c=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var f=[n,o,i,a,u,l],s=0;c=new Error(t.replace(/%s/g,function(){return f[s++]})),c.name="Invariant Violation"}throw c.framesToPop=1,c}}var r=function(e){};"production"!==t.env.NODE_ENV&&(r=function(e){if(void 0===e)throw new Error("invariant requires an error message argument")}),e.exports=n}).call(t,n(1))},function(e,t){"use strict";var n="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=n},function(e,t,n){(function(t){"use strict";var r=n(2),o=r;if("production"!==t.env.NODE_ENV){var i=function(e){for(var t=arguments.length,n=Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=0,i="Warning: "+e.replace(/%s/g,function(){return n[o++]});"undefined"!=typeof console&&console.error(i);try{throw new Error(i)}catch(e){}};o=function(e,t){if(void 0===t)throw new Error("`warning(condition, format, ...args)` requires a warning message argument");if(0!==t.indexOf("Failed Composite propType: ")&&!e){for(var n=arguments.length,r=Array(n>2?n-2:0),o=2;o<n;o++)r[o-2]=arguments[o];i.apply(void 0,[t].concat(r))}}}e.exports=o}).call(t,n(1))},function(e,t){"use strict";function n(e,t){var n=Object.keys(t),r=Object.assign({},e);return Object.keys(r).filter(function(e){return n.indexOf(e)!==-1}).forEach(function(e){return delete r[e]}),r}Object.defineProperty(t,"__esModule",{value:!0}),t.objectKeyFilter=n},function(e,t){/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
"use strict";function n(e){if(null===e||void 0===e)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e)}function r(){try{if(!Object.assign)return!1;var e=new String("abc");if(e[5]="de","5"===Object.getOwnPropertyNames(e)[0])return!1;for(var t={},n=0;n<10;n++)t["_"+String.fromCharCode(n)]=n;var r=Object.getOwnPropertyNames(t).map(function(e){return t[e]});if("0123456789"!==r.join(""))return!1;var o={};return"abcdefghijklmnopqrst".split("").forEach(function(e){o[e]=e}),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},o)).join("")}catch(e){return!1}}var o=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable;e.exports=r()?Object.assign:function(e,t){for(var r,u,l=n(e),c=1;c<arguments.length;c++){r=Object(arguments[c]);for(var f in r)i.call(r,f)&&(l[f]=r[f]);if(o){u=o(r);for(var s=0;s<u.length;s++)a.call(r,u[s])&&(l[u[s]]=r[u[s]])}}return l}},function(e,t,n){(function(t){"use strict";function r(e,n,r,l,c){if("production"!==t.env.NODE_ENV)for(var f in e)if(e.hasOwnProperty(f)){var s;try{o("function"==typeof e[f],"%s: %s type `%s` is invalid; it must be a function, usually from the `prop-types` package, but received `%s`.",l||"React class",r,f,typeof e[f]),s=e[f](n,f,l,r,null,a)}catch(e){s=e}if(i(!s||s instanceof Error,"%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).",l||"React class",r,f,typeof s),s instanceof Error&&!(s.message in u)){u[s.message]=!0;var p=c?c():"";i(!1,"Failed %s type: %s%s",r,s.message,null!=p?p:"")}}}if("production"!==t.env.NODE_ENV)var o=n(3),i=n(5),a=n(4),u={};e.exports=r}).call(t,n(1))},function(e,t,n){"use strict";var r=n(2),o=n(3),i=n(4);e.exports=function(){function e(e,t,n,r,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return n.checkPropTypes=r,n.PropTypes=n,n}},function(e,t,n){(function(t){"use strict";var r=n(2),o=n(3),i=n(5),a=n(7),u=n(4),l=n(8);e.exports=function(e,n){function c(e){var t=e&&(R&&e[R]||e[I]);if("function"==typeof t)return t}function f(e,t){return e===t?0!==e||1/e===1/t:e!==e&&t!==t}function s(e){this.message=e,this.stack=""}function p(e){function r(r,c,f,p,d,m,y){if(p=p||S,m=m||f,y!==u)if(n)o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");else if("production"!==t.env.NODE_ENV&&"undefined"!=typeof console){var v=p+":"+f;!a[v]&&l<3&&(i(!1,"You are manually calling a React.PropTypes validation function for the `%s` prop on `%s`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.",m,p),a[v]=!0,l++)}return null==c[f]?r?new s(null===c[f]?"The "+d+" `"+m+"` is marked as required "+("in `"+p+"`, but its value is `null`."):"The "+d+" `"+m+"` is marked as required in "+("`"+p+"`, but its value is `undefined`.")):null:e(c,f,p,d,m)}if("production"!==t.env.NODE_ENV)var a={},l=0;var c=r.bind(null,!1);return c.isRequired=r.bind(null,!0),c}function d(e){function t(t,n,r,o,i,a){var u=t[n],l=P(u);if(l!==e){var c=N(u);return new s("Invalid "+o+" `"+i+"` of type "+("`"+c+"` supplied to `"+r+"`, expected ")+("`"+e+"`."))}return null}return p(t)}function m(){return p(r.thatReturnsNull)}function y(e){function t(t,n,r,o,i){if("function"!=typeof e)return new s("Property `"+i+"` of component `"+r+"` has invalid PropType notation inside arrayOf.");var a=t[n];if(!Array.isArray(a)){var l=P(a);return new s("Invalid "+o+" `"+i+"` of type "+("`"+l+"` supplied to `"+r+"`, expected an array."))}for(var c=0;c<a.length;c++){var f=e(a,c,r,o,i+"["+c+"]",u);if(f instanceof Error)return f}return null}return p(t)}function v(){function t(t,n,r,o,i){var a=t[n];if(!e(a)){var u=P(a);return new s("Invalid "+o+" `"+i+"` of type "+("`"+u+"` supplied to `"+r+"`, expected a single ReactElement."))}return null}return p(t)}function b(e){function t(t,n,r,o,i){if(!(t[n]instanceof e)){var a=e.name||S,u=_(t[n]);return new s("Invalid "+o+" `"+i+"` of type "+("`"+u+"` supplied to `"+r+"`, expected ")+("instance of `"+a+"`."))}return null}return p(t)}function h(e){function n(t,n,r,o,i){for(var a=t[n],u=0;u<e.length;u++)if(f(a,e[u]))return null;var l=JSON.stringify(e);return new s("Invalid "+o+" `"+i+"` of value `"+a+"` "+("supplied to `"+r+"`, expected one of "+l+"."))}return Array.isArray(e)?p(n):("production"!==t.env.NODE_ENV?i(!1,"Invalid argument supplied to oneOf, expected an instance of array."):void 0,r.thatReturnsNull)}function g(e){function t(t,n,r,o,i){if("function"!=typeof e)return new s("Property `"+i+"` of component `"+r+"` has invalid PropType notation inside objectOf.");var a=t[n],l=P(a);if("object"!==l)return new s("Invalid "+o+" `"+i+"` of type "+("`"+l+"` supplied to `"+r+"`, expected an object."));for(var c in a)if(a.hasOwnProperty(c)){var f=e(a,c,r,o,i+"."+c,u);if(f instanceof Error)return f}return null}return p(t)}function O(e){function n(t,n,r,o,i){for(var a=0;a<e.length;a++){var l=e[a];if(null==l(t,n,r,o,i,u))return null}return new s("Invalid "+o+" `"+i+"` supplied to "+("`"+r+"`."))}if(!Array.isArray(e))return"production"!==t.env.NODE_ENV?i(!1,"Invalid argument supplied to oneOfType, expected an instance of array."):void 0,r.thatReturnsNull;for(var o=0;o<e.length;o++){var a=e[o];if("function"!=typeof a)return i(!1,"Invalid argument supplied to oneOfType. Expected an array of check functions, but received %s at index %s.",k(a),o),r.thatReturnsNull}return p(n)}function T(){function e(e,t,n,r,o){return j(e[t])?null:new s("Invalid "+r+" `"+o+"` supplied to "+("`"+n+"`, expected a ReactNode."))}return p(e)}function w(e){function t(t,n,r,o,i){var a=t[n],l=P(a);if("object"!==l)return new s("Invalid "+o+" `"+i+"` of type `"+l+"` "+("supplied to `"+r+"`, expected `object`."));for(var c in e){var f=e[c];if(f){var p=f(a,c,r,o,i+"."+c,u);if(p)return p}}return null}return p(t)}function E(e){function t(t,n,r,o,i){var l=t[n],c=P(l);if("object"!==c)return new s("Invalid "+o+" `"+i+"` of type `"+c+"` "+("supplied to `"+r+"`, expected `object`."));var f=a({},t[n],e);for(var p in f){var d=e[p];if(!d)return new s("Invalid "+o+" `"+i+"` key `"+p+"` supplied to `"+r+"`.\nBad object: "+JSON.stringify(t[n],null,"  ")+"\nValid keys: "+JSON.stringify(Object.keys(e),null,"  "));var m=d(l,p,r,o,i+"."+p,u);if(m)return m}return null}return p(t)}function j(t){switch(typeof t){case"number":case"string":case"undefined":return!0;case"boolean":return!t;case"object":if(Array.isArray(t))return t.every(j);if(null===t||e(t))return!0;var n=c(t);if(!n)return!1;var r,o=n.call(t);if(n!==t.entries){for(;!(r=o.next()).done;)if(!j(r.value))return!1}else for(;!(r=o.next()).done;){var i=r.value;if(i&&!j(i[1]))return!1}return!0;default:return!1}}function x(e,t){return"symbol"===e||("Symbol"===t["@@toStringTag"]||"function"==typeof Symbol&&t instanceof Symbol)}function P(e){var t=typeof e;return Array.isArray(e)?"array":e instanceof RegExp?"object":x(t,e)?"symbol":t}function N(e){if("undefined"==typeof e||null===e)return""+e;var t=P(e);if("object"===t){if(e instanceof Date)return"date";if(e instanceof RegExp)return"regexp"}return t}function k(e){var t=N(e);switch(t){case"array":case"object":return"an "+t;case"boolean":case"date":case"regexp":return"a "+t;default:return t}}function _(e){return e.constructor&&e.constructor.name?e.constructor.name:S}var R="function"==typeof Symbol&&Symbol.iterator,I="@@iterator",S="<<anonymous>>",D={array:d("array"),bool:d("boolean"),func:d("function"),number:d("number"),object:d("object"),string:d("string"),symbol:d("symbol"),any:m(),arrayOf:y,element:v(),instanceOf:b,node:T(),objectOf:g,oneOf:h,oneOfType:O,shape:w,exact:E};return s.prototype=Error.prototype,D.checkPropTypes=l,D.PropTypes=D,D}}).call(t,n(1))},function(e,t,n){(function(t){if("production"!==t.env.NODE_ENV){var r="function"==typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103,o=function(e){return"object"==typeof e&&null!==e&&e.$$typeof===r},i=!0;e.exports=n(10)(o,i)}else e.exports=n(9)()}).call(t,n(1))},function(t,n){t.exports=e},function(e,n){e.exports=t}])});

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(243)(module)))

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var moment = module.exports = __webpack_require__(1015);
moment.tz.load(__webpack_require__(1016));


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(172);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(36);

var emptyObject = __webpack_require__(288);
var _invariant = __webpack_require__(62);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_CorePage__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_icons_desktoporlaptop_png__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_icons_desktoporlaptop_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_icons_desktoporlaptop_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_html_parser__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Errmsg=function(_CorePage){_inherits(Errmsg,_CorePage);function Errmsg(props){_classCallCheck(this,Errmsg);return _possibleConstructorReturn(this,(Errmsg.__proto__||Object.getPrototypeOf(Errmsg)).call(this,props));}_createClass(Errmsg,[{key:'getImageURL',value:function getImageURL(){if(this.props.errormsg.srcval=='desktoporlaptop'){return __WEBPACK_IMPORTED_MODULE_2__images_icons_desktoporlaptop_png___default.a;}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.props.errormsg.heading)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingBottom:'30px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.getImageURL()})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_3_react_html_parser___default()(this.props.errormsg.description)));}}]);return Errmsg;}(__WEBPACK_IMPORTED_MODULE_1__views_core_CorePage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Errmsg);

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var EventEmitter_1 = __webpack_require__(292);
exports.ValidateEvent = 'VALIDATE_EVENT';
function withValidateEventEmitter(Base) {
    return (function (_super) {
        __extends(ValidateEventEmitter, _super);
        function ValidateEventEmitter() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.validateEventEmitter = new EventEmitter_1.EventEmitter();
            return _this;
        }
        ValidateEventEmitter.prototype.emitValidateEvent = function (input) {
            this.validateEventEmitter.emit(exports.ValidateEvent, input);
        };
        ValidateEventEmitter.prototype.addValidateEventListener = function (listener) {
            this.validateEventEmitter.addListener(exports.ValidateEvent, listener);
        };
        ValidateEventEmitter.prototype.removeValidateEventListener = function (listener) {
            this.validateEventEmitter.removeListener(exports.ValidateEvent, listener);
        };
        return ValidateEventEmitter;
    }(Base));
}
exports.withValidateEventEmitter = withValidateEventEmitter;
//# sourceMappingURL=withValidateEventEmitter.js.map

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var EventEmitter = (function () {
    function EventEmitter() {
        this.listeners = new Map();
    }
    EventEmitter.prototype.emit = function (eventName) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var listeners = this.listeners.get(eventName);
        if (listeners !== undefined) {
            console.assert(listeners.length > 0, "No listener for event '" + eventName + "'");
            listeners.forEach(function (listener) { return listener.apply(void 0, __spread(args)); });
        }
    };
    EventEmitter.prototype.addListener = function (eventName, listener) {
        if (!this.listeners.has(eventName))
            this.listeners.set(eventName, []);
        var listeners = this.listeners.get(eventName);
        console.assert(listeners.indexOf(listener) === -1, "Listener already added for event '" + eventName + "'");
        listeners.push(listener);
    };
    EventEmitter.prototype.removeListener = function (eventName, listener) {
        var listeners = this.listeners.get(eventName);
        console.assert(listeners !== undefined, "Unknown event '" + eventName + "'");
        var index = listeners.lastIndexOf(listener);
        console.assert(index > -1, "Listener not found for event '" + eventName + "'");
        listeners.splice(index, 1);
        if (listeners.length === 0)
            this.listeners.delete(eventName);
    };
    return EventEmitter;
}());
exports.EventEmitter = EventEmitter;
//# sourceMappingURL=EventEmitter.js.map

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var EventEmitter_1 = __webpack_require__(292);
var fieldWithoutFeedback_1 = __webpack_require__(443);
var FieldEvent;
(function (FieldEvent) {
    FieldEvent["Added"] = "FIELD_ADDED";
    FieldEvent["Removed"] = "FIELD_REMOVED";
    FieldEvent["Updated"] = "FIELD_UPDATED";
})(FieldEvent = exports.FieldEvent || (exports.FieldEvent = {}));
var FieldsStore = (function (_super) {
    __extends(FieldsStore, _super);
    function FieldsStore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fields = Object.create(null);
        return _this;
    }
    FieldsStore.prototype.addField = function (fieldName) {
        if (this.fields[fieldName] === undefined) {
            var newField = fieldWithoutFeedback_1.default;
            this.fields[fieldName] = newField;
            this.emit(FieldEvent.Added, fieldName, newField);
        }
    };
    FieldsStore.prototype.removeField = function (fieldName) {
        console.assert(this.fields[fieldName] !== undefined, "Unknown field '" + fieldName + "'");
        delete this.fields[fieldName];
        this.emit(FieldEvent.Removed, fieldName);
    };
    FieldsStore.prototype.cloneField = function (fieldName) {
        var field = this.fields[fieldName];
        console.assert(field !== undefined, "Unknown field '" + fieldName + "'");
        var newField = {
            dirty: field.dirty,
            errors: new Set(field.errors),
            warnings: new Set(field.warnings),
            infos: new Set(field.infos),
            validationMessage: field.validationMessage
        };
        return newField;
    };
    FieldsStore.prototype.updateField = function (fieldName, field) {
        console.assert(this.fields[fieldName] !== undefined, "Unknown field '" + fieldName + "'");
        this.fields[fieldName] = field;
        this.emit(FieldEvent.Updated, fieldName);
    };
    FieldsStore.prototype.removeFieldFor = function (fieldName, fieldFeedbacksKey) {
        var field = this.fields[fieldName];
        console.assert(field !== undefined, "Unknown field '" + fieldName + "'");
        var reject = function (fieldFeedbackKey) { return fieldFeedbacksKey !== Math.floor(fieldFeedbackKey); };
        field.errors = new Set(Array.from(field.errors).filter(reject));
        field.warnings = new Set(Array.from(field.warnings).filter(reject));
        field.infos = new Set(Array.from(field.infos).filter(reject));
        this.emit(FieldEvent.Updated, fieldName);
    };
    FieldsStore.prototype.getFieldFor = function (fieldName, fieldFeedbacksKey) {
        var field = this.fields[fieldName];
        console.assert(field !== undefined, "Unknown field '" + fieldName + "'");
        var filter = function (fieldFeedbackKey) { return fieldFeedbacksKey === Math.floor(fieldFeedbackKey); };
        var fieldFor = {
            dirty: field.dirty,
            errors: new Set(Array.from(field.errors).filter(filter)),
            warnings: new Set(Array.from(field.warnings).filter(filter)),
            infos: new Set(Array.from(field.infos).filter(filter)),
            validationMessage: field.validationMessage
        };
        return fieldFor;
    };
    FieldsStore.prototype.containErrors = function () {
        var _this = this;
        var fieldNames = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            fieldNames[_i] = arguments[_i];
        }
        return fieldNames.some(function (fieldName) {
            var field = _this.fields[fieldName];
            return field !== undefined && field.errors.size > 0;
        });
    };
    FieldsStore.prototype.containWarnings = function () {
        var _this = this;
        var fieldNames = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            fieldNames[_i] = arguments[_i];
        }
        return fieldNames.some(function (fieldName) {
            var field = _this.fields[fieldName];
            return field !== undefined && field.warnings.size > 0;
        });
    };
    FieldsStore.prototype.containInfos = function () {
        var _this = this;
        var fieldNames = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            fieldNames[_i] = arguments[_i];
        }
        return fieldNames.some(function (fieldName) {
            var field = _this.fields[fieldName];
            return field !== undefined && field.infos.size > 0;
        });
    };
    FieldsStore.prototype.areValidDirtyWithoutWarnings = function () {
        var _this = this;
        var fieldNames = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            fieldNames[_i] = arguments[_i];
        }
        return fieldNames.some(function (fieldName) {
            var field = _this.fields[fieldName];
            return field !== undefined && field.dirty === true && field.errors.size === 0 && field.warnings.size === 0;
        });
    };
    return FieldsStore;
}(EventEmitter_1.EventEmitter));
exports.FieldsStore = FieldsStore;
//# sourceMappingURL=FieldsStore.js.map

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_burger_menu__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_burger_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_burger_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_html_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_icons_plp_signin_icon_png__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_icons_plp_signin_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_icons_plp_signin_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_icons_school_signin_icon_png__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_icons_school_signin_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_icons_school_signin_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_pwdhelpscrn_png__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_pwdhelpscrn_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_pwdhelpscrn_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_NativeAjax__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_core_ErrorPage__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_dashboard_Dashboard__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_login_Contactus__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_login_TchrContactus__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_login_CreateNewAccountForm__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_login_ForgotPasswordForm__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_login_ForgotPwd__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_login_UnifiedForgotPwd__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_login_LoginForm__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_login_LumosLoginForm__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_login_UnifiedLogin__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_login_SignupForm__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_plp_Home__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_plp_TestTakingModalComponent__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_purchase_BillingDetails__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_purchase_MyProducts__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_scorecard_Scorecard__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_settings_Settings__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__public_css_all_css_css__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__public_css_all_css_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__public_css_all_css_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__public_css_main_css__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__public_css_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__public_css_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__public_css_wrapper_css__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__public_css_wrapper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__public_css_wrapper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__public_css_seo_optimize_css__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__public_css_seo_optimize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__public_css_seo_optimize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__App_css__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Use_js__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Banner2_js__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_SignupSection2_js__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_WhoBanner2_js__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_LessonFeatures2_js__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_StaticFeed__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_RecognisedStatic__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_EndorsedStatic__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_ProgramHighlights__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_NrichCollaboration__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_TeacherResources__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_Blog_js__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_Spotlight__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_OverallFeatures__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_DownloadButton__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_BuyOption_js__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_Culture_js__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_DayInLife_js__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_Experience_js__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_Featured_js__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_FlipSection_js__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_Footer_js__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_Founders_js__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_FounderVideos_js__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_Grades_js__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_HowWorks_js__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_Lessons_js__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_OtherLearnings_js__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_OurTeachers_js__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_OurParents_js__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_ContactHeader_js__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_OurTeam_js__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_PageBanner_js__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_PageBannerBuy_js__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_ProductBanner_js__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_Recognised_js__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_ScrollToTopOnMount_js__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_Testimonial_js__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_TeacherBannerBuy_js__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_TeacherBuy_js__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_OurTestimonial_js__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_TeacherTestimonial_js__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_Topics_js__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_Trusted_js__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_Why_js__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_ProductMenu__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_FAQ__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__util_BrowserUtil__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_TeacherProdComp__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__model_ComponentRegistry__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__vendors_mindstretcher_Report__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__views_others_SGProductCatalogue__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__views_others_NewINProductCatalogue__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__views_others_TopBanner__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__views_others_InTopBanner__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_SGTeacherBuy__ = __webpack_require__(1263);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*import Banner from './components/Banner.js';*//*import SignupSection from './components/SignupSection.js';*//*import WhoBanner from './components/WhoBanner.js';*//*import LessonFeatures from './components/LessonFeatures';*//*
* IMPORTANT: To revert back to the older way of showing products on home,
* uncomment the above lines and comment the below ones.
*//*import Use from './components/Use2.js';*/var maintenanceMessage=window.maintenanceMessage?window.maintenanceMessage:{};var PreloginHome=function(_PreLoginPage){_inherits(PreloginHome,_PreLoginPage);function PreloginHome(props){_classCallCheck(this,PreloginHome);var _this=_possibleConstructorReturn(this,(PreloginHome.__proto__||Object.getPrototypeOf(PreloginHome)).call(this,props));_this.redirecttoSomewhere=function(){_this.hideInfoModal();window.location.href='/products';};_this.GetProductDetails=function(_ref){var match=_ref.match;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'heyPrelolgin'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__views_purchase_BillingDetails__["a" /* default */],{myProps:_this.props,purchaseKey:_this.state.purchaseKey}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_57__components_Footer_js__["a" /* default */],{showContactus:_this.showContactus,products_category_order:_this.getProductsTypeOrder(),products_category:_this.getProductsType(),classes:_this.getClasses(),grades:_this.getGrades(),products_class:_this.getProductsClass()}));};_this.GetMyProducts=function(_ref2){var match=_ref2.match;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'heyPrelolgin'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__views_purchase_MyProducts__["a" /* default */],{myProps:_this.props,PLPloggedIn:_this.state.PLPloggedIn,purchaseKey:_this.state.purchaseKey,showSubScripeLoginForm:_this.showSubScripeLoginForm}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_57__components_Footer_js__["a" /* default */],{showContactus:_this.showContactus,products_category_order:_this.getProductsTypeOrder(),products_category:_this.getProductsType(),classes:_this.getClasses(),grades:_this.getGrades(),products_class:_this.getProductsClass()}));};_this.GetMyProfile=function(_ref3){var match=_ref3.match;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_72__components_ScrollToTopOnMount_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_68__components_PageBanner_js__["a" /* default */],{name:'My Profile',classes:'bg-grn settingsbggren mt-0'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__views_settings_Settings__["a" /* default */],{callbackHomeUpdateImage:_this.UpdateProfileImage,userNameUpdateEvent:_this.userNameUpdateEvent}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)));};_this.geoBasedProductHeader=function(){var me=_this;if(_this.prodForCountry()==='IN'){return me.productTab();}else if(_this.prodForCountry()==='SG'){return me.sgProductTab();}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,me.productTab(),me.sgProductTab());}};_this.geoBasedProdMobNav=function(){if(_this.prodForCountry()==='IN'){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{'data-ga':'Products - Main tab',className:'animated'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuproducts','data-classname':'menuproducts',to:'/products',onClick:function onClick(){return _this.menuSelected();}},_this.rb("in.products.students.title"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{'data-ga':'SG Prducts - Main Tab',className:'animated'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menusgproducts','data-classname':'menusgproducts',to:'/sg/products',onClick:function onClick(){return _this.menuSelected();}},_this.rb("sg.products.title"))));}else if(_this.prodForCountry()==='SG'){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{'data-ga':'SG Prducts - Main Tab',className:'animated'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menusgproducts','data-classname':'menusgproducts',to:'/sg/products',onClick:function onClick(){return _this.menuSelected();}},_this.rb("sg.products.title")));}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{'data-ga':'Products - Main tab',className:'animated'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuproducts','data-classname':'menuproducts',to:'/products',onClick:function onClick(){return _this.menuSelected();}},_this.rb("in.products.students.title"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{'data-ga':'SG Prducts - Main Tab',className:'animated'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menusgproducts','data-classname':'menusgproducts',to:'/sg/products',onClick:function onClick(){return _this.menuSelected();}},_this.rb("sg.products.title"))));}};var urlSplitArray=document.location.pathname.split("/");_this.state={grades:[],classes:{},products_details:{},products_class:{},products_classification:{},products_category:{},products_category_order:[],menuOpen:false,isOpen:false,HelpModalShow:false,HelpModalContent:"","ModalShow":false,"ModalContent":"","ModalHeader":"",PLPloggedIn:false,LumosloggedIn:false,loggedIn:false,productsJson:null,selectedGrade:null,selectedTarriffID:null,purchaseKey:"PLP_USER_PURCHASE",customClass:"",userRole:"",navigationKey:"PLP_Navigation",productsInfoAvailable:localStorage.getItem('product')===urlSplitArray[urlSplitArray.length-1]?true:false,productsLoadErr:false,loginStoreKey:"PLP_LOGIN_INFO",userName:"",preloginClassName:"PreLogin",imagePreviewUrl:"",imageLoaded:false,userProdReqComplete:false,triedFree:false,purchased:false,loginRequestComplete:false,InfoModalHeader:'',InfoModalShow:false,InfoModalContent:"",catalogProdType:"SPL"};_this.showLoginForm=_this.showLoginForm.bind(_this);_this.hideLoginModal=_this.hideLoginModal.bind(_this);_this.hideHelpLoginModal=_this.hideHelpLoginModal.bind(_this);_this.hideInfoModal=_this.hideInfoModal.bind(_this);//this.loginIframeLoaded = this.loginIframeLoaded.bind(this);
//this.pwdIframeLoaded = this.pwdIframeLoaded.bind(this);
_this.loginIframeView=null;_this.pwdIframeView=null;_this.selectedMenu=null;_this.suppressedHeaders=[];_this.showSubscriptionForm=_this.showSubscriptionForm.bind(_this);_this.showForgotPasswordForm=_this.showForgotPasswordForm.bind(_this);_this.showSuccessForgotPwdMessage=_this.showSuccessForgotPwdMessage.bind(_this);_this.showSuccessContactMessage=_this.showSuccessContactMessage.bind(_this);_this.showsuccessRegisterMsg=_this.showsuccessRegisterMsg.bind(_this);_this.getLoginForm=_this.getLoginForm.bind(_this);_this.getLiveFeedLoginForm=_this.getLiveFeedLoginForm.bind(_this);_this.showLiveFeedLogin=_this.showLiveFeedLogin.bind(_this);_this.showCreateAccount=_this.showCreateAccount.bind(_this);_this.startFreeTrial=_this.startFreeTrial.bind(_this);_this.showForgotHelpScreen=_this.showForgotHelpScreen.bind(_this);_this.showContactus=_this.showContactus.bind(_this);_this.showContactusForTeacher=_this.showContactusForTeacher.bind(_this);_this.showSignUp=_this.showSignUp.bind(_this);_this.showSubScripeLoginForm=_this.showSubScripeLoginForm.bind(_this);_this.getSubScripeLoginForm=_this.getSubScripeLoginForm.bind(_this);_this.getSingleLoginForm=_this.getSingleLoginForm.bind(_this);_this.onLogout=_this.onLogout.bind(_this);_this.doLogout=_this.doLogout.bind(_this);_this.menuSelected=_this.menuSelected.bind(_this);_this.Home=_this.Home.bind(_this);_this.Products=_this.Products.bind(_this);_this.SelfPaced=_this.SelfPaced.bind(_this);_this.Plp=_this.Plp.bind(_this);_this.cbse=_this.cbse.bind(_this);_this.Learnings=_this.Learnings.bind(_this);_this.WhoWeAre=_this.WhoWeAre.bind(_this);_this.Blog=_this.Blog.bind(_this);_this.Spotlight=_this.Spotlight.bind(_this);_this.Faq=_this.Faq.bind(_this);_this.Teachers=_this.Teachers.bind(_this);_this.getBannerContent=_this.getBannerContent.bind(_this);_this.closeBanner=_this.closeBanner.bind(_this);_this.showNewLoginForm=_this.showNewLoginForm.bind(_this);_this.UpdateProfileImage=_this.UpdateProfileImage.bind(_this);_this.userNameUpdateEvent=_this.userNameUpdateEvent.bind(_this);_this.doPLPLogout=_this.doPLPLogout.bind(_this);_this.doLumosLogout=_this.doLumosLogout.bind(_this);_this.doCommonLogout=_this.doCommonLogout.bind(_this);_this.gaFrom="";_this.isProdcutLoadCalled=false;_this.modalcloseDataGA="";//this.renderClassView = this.renderClassView.bind(this);
_this.productTab=_this.productTab.bind(_this);_this.aboutUsTab=_this.aboutUsTab.bind(_this);_this.postLoginTchr=_this.postLoginTchr.bind(_this);_this.postLoginTchrTab=_this.postLoginTchrTab.bind(_this);_this.showlog_Form_route=_this.showlog_Form_route.bind(_this);_this.setPreloginClass=_this.setPreloginClass.bind(_this);_this.postLoginCallBack=_this.postLoginCallBack.bind(_this);_this.sgProductTab=_this.sgProductTab.bind(_this);_this.SGCatalogue=_this.SGCatalogue.bind(_this);_this.newINCatalogue=_this.newINCatalogue.bind(_this);_this.switchProdType=_this.switchProdType.bind(_this);_this.getHeaderLogo=_this.getHeaderLogo.bind(_this);return _this;}_createClass(PreloginHome,[{key:'postLoginCallBack',value:function postLoginCallBack(){this.setState({PLPloggedIn:true,loggedIn:true});}},{key:'getSchoolId',value:function getSchoolId(){return this.getUser().getSchoolId();}},{key:'handleStateChange',value:function handleStateChange(state){this.setState({menuOpen:state.isOpen});}},{key:'closeMenu',value:function closeMenu(){this.setState({menuOpen:false});}},{key:'getBannerContent',value:function getBannerContent(){//console.log(maintenanceMessage);
if(maintenanceMessage.showBanner){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'maintenance-banner-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'maintenance-banner flex-row justify-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'banner-icon flex-col justify-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-exclamation-circle','aria-hidden':'true'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'maintenance-banner-content flex flex-col justify-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:'title'},maintenanceMessage.bannerMessage.title),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'message'},maintenanceMessage.bannerMessage.content),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'banner-close',onClick:this.closeBanner},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-times','aria-hidden':'true'})))));}}},{key:'closeBanner',value:function closeBanner(){var bannerContainer=document.getElementsByClassName("maintenance-banner-container");bannerContainer[0].style.display="none";}},{key:'menuSelected',value:function menuSelected(event){var target=event.currentTarget;__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".heyMenu").removeClass("selected");var selectedclass=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(target).attr("data-classname");//console.log(selectedclass, target);
__WEBPACK_IMPORTED_MODULE_0_jquery___default()("."+selectedclass).addClass("selected");this.closeMenu();this.setState({preloginClassName:"PreLogin"});}},{key:'showSettings',value:function showSettings(event){event.preventDefault();}},{key:'componentWillMount',value:function componentWillMount(){this.PLPSessionCheck();this.LumosSessionCheck();console.log(this.props.location.pathname);if(this.props.location.pathname=="/landing"||this.props.location.pathname=="/dashboard"||this.props.location.pathname=="/settings"||this.props.location.pathname=="/report"||this.props.location.pathname.indexOf("/scorecard")>-1){this.setState({preloginClassName:"PreLoginLanding"});}else{this.setState({preloginClassName:"PreLogin"});}}},{key:'setPreloginClass',value:function setPreloginClass(){//To force select home icon on menu img
this.menuSelected();this.setState({preloginClassName:"PreLogin"});}},{key:'userNameUpdateEvent',value:function userNameUpdateEvent(username){this.setState({userName:username});}},{key:'UpdateProfileImage',value:function UpdateProfileImage(imageUrl){//console.log("updateimage in home::"+imageUrl);
if(imageUrl){this.setState({imagePreviewUrl:imageUrl,imageLoaded:true});}else{this.setState({imageLoaded:false});}}},{key:'loadCurrentImage',value:function loadCurrentImage(){//alert("loadCurrentImage....");
var me=this;var success=function success(response){if(response&&response.imgUrl){me.setState({imagePreviewUrl:response.imgUrl,imageLoaded:true});}};var failure=function failure(err){};new __WEBPACK_IMPORTED_MODULE_10__util_HmAjax__["a" /* default */](this.getUrlFor("PROFILE_PIC")).get(success,failure);}},{key:'PLPSessionCheck',value:function PLPSessionCheck(){var me=this;var user_Success=function user_Success(userObj){console.log("session check succes....");if((typeof userObj==='undefined'?'undefined':_typeof(userObj))==="object"&&userObj.authToken){me.getUser().store(userObj);me.setState({PLPloggedIn:true,loginRequestComplete:true,userRole:userObj.userRole.role,userName:userObj.userName});if(me.headerComponent){me.setLoginState(true);}me.loadCurrentImage();me.showlog_Form_route();/*if(userObj.userRole.role == "STU"){
					me.props.history.push('/landing');
				}*/}else{me.setState({PLPloggedIn:false,loginRequestComplete:true});me.setLoginState(false);me.showlog_Form_route();}me.detectGmailGExists();};var user_Failure=function user_Failure(error){me.setState({PLPloggedIn:false,loginRequestComplete:true});me.showlog_Form_route();me.setLoginState(false);try{__WEBPACK_IMPORTED_MODULE_9__util_BrowserStorageUtil__["a" /* default */].removeItem(me.state.purchaseKey);}catch(e){if(console)console.error(e);}me.detectGmailGExists();};me.sessionCheck(user_Success,user_Failure);}},{key:'LumosSessionCheck',value:function LumosSessionCheck(){var me=this;var user_Success=function user_Success(userObj){if((typeof userObj==='undefined'?'undefined':_typeof(userObj))==="object"&&userObj.sessionValid){me.setState({LumosloggedIn:true,loginRequestComplete:true});me.showlog_Form_route();console.log("LumosloggedIn ",me.state.LumosloggedIn);var lumosRedirect=true;if(window.lumos_allowed_routes&&window.lumos_allowed_routes.length>0){for(var i=0;i<window.lumos_allowed_routes.length;i++){if(window.location.href&&window.location.href.match(window.lumos_allowed_routes[i])){lumosRedirect=false;break;}}}/*if(window.lumos_restricted_routes && window.lumos_restricted_routes.length > 0){
					for(var i=0;i<window.lumos_restricted_routes.length;i++){
						if(window.location.href && window.location.href.match(window.lumos_restricted_routes[i])){
							lumosRedirect = true;
							break;
						}
					}
				}*/if(lumosRedirect){//For a Lumos User, always redirect him to Lumos Page
window.location.href=me.getUrlFor("LUMOS_REDIRECT_URL");}}else{me.setState({LumosloggedIn:false,loginRequestComplete:true});me.showlog_Form_route();}};var user_Failure=function user_Failure(error){me.setState({LumosloggedIn:false,loginRequestComplete:true});me.showlog_Form_route();};new __WEBPACK_IMPORTED_MODULE_11__util_NativeAjax__["a" /* default */](this.getUrlFor("LUMOS_SESSION_CHECK")).enableCORS().get(user_Success,user_Failure);}},{key:'setLoginState',value:function setLoginState(isLoggedIn){this.setState({loggedIn:isLoggedIn});}},{key:'hideHelpLoginModal',value:function hideHelpLoginModal(){this.setState({"HelpModalShow":false});}},{key:'hideLoginModal',value:function hideLoginModal(){this.setState({"ModalShow":false,customClass:""});}},{key:'showForgotHelpScreen',value:function showForgotHelpScreen(){this.setState({"HelpModalShow":true,"HelpModalContent":this.getPwdHelpContent(),customClass:"resetpasword"});}},{key:'showSignupForm',value:function showSignupForm(loginType,userInput,gaFrom){this.gaFrom=gaFrom;this.setState({"ModalShow":true,"ModalContent":this.getVerifyAccount(loginType,userInput),"ModalHeader":this.rb("login.createnewaccount"),customClass:"newloginDialog"});}},{key:'showNewLoginForm',value:function showNewLoginForm(loginType,userInput,gaFrom){this.gaFrom=gaFrom;//this.setState({"ModalShow":true,"ModalContent":this.getPLPLoginForm(loginType,userInput),"ModalHeader":"logo", customClass:"newloginDialog"});
this.setState({"ModalShow":true,"ModalContent":this.getUnifiedLoginForm(loginType,userInput),"ModalHeader":"logo",customClass:"newloginDialog"});}},{key:'showCreateAccount',value:function showCreateAccount(){var navigateurl=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var freetrail=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var gaFrom=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"";this.gaFrom=gaFrom;this.modalcloseDataGA="Home - Users who have independently registered - Sign Up - New User - Start Learning - Close";this.setState({"ModalShow":true,"ModalContent":this.getVerifyAccount(null,null,navigateurl,freetrail),"ModalHeader":this.rb("login.createnewaccount"),customClass:"newloginDialog teacherJoinForm"});}},{key:'showForgotPasswordForm',value:function showForgotPasswordForm(source){var mycustomclass="";this.modalcloseDataGA="Home - Sign in - Users enrolled through school - Forgot Password";if(source=="plp"){this.modalcloseDataGA="Home - Sign in - Users who have independently registered - Forgot Password";mycustomclass="resetpasword newloginDialog";}else{mycustomclass="resetpasword newloginDialog";}this.setState({"ModalShow":true,"ModalContent":this.getForgotPassword(source),"ModalHeader":this.rb("rpwd.title"),customClass:mycustomclass});}},{key:'getPwdHelpContent',value:function getPwdHelpContent(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'loginRoot'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 josefin'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'loginHeaderTxt'},'For Parent Account:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Please use the email address you used to register with HeyMath!'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'loginHeaderTxt'},'For Student Account:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'mt-10'},'If you have not updated your email address in your Settings, please use the parent email address that was used to register with HeyMath!'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'mt-10'},'If you have updated your email address in your account settings (as shown below), please use that email ID to reset your password.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__images_pwdhelpscrn_png___default.a})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null))));}},{key:'showSubscriptionForm',value:function showSubscriptionForm(callBack){var me=this;var success=function success(resp){me.setState({"ModalShow":false});if(typeof callBack==="function"){callBack();}};this.setState({"ModalShow":true,"ModalContent":this.getUnifiedLoginFormWithoutNav(null,null,null,null,success),"ModalHeader":"logo",customClass:"newloginDialog"});}},{key:'showSubscriptionForm_deprecated',value:function showSubscriptionForm_deprecated(productObj){var purchaseObj={tariffId:productObj.tariffId,productId:productObj.productId};__WEBPACK_IMPORTED_MODULE_9__util_BrowserStorageUtil__["a" /* default */].storeItem(this.state.purchaseKey,JSON.stringify(purchaseObj));var gradeid="";var category="";var freetrail="";try{gradeid=productObj.gradeid;category=productObj.productCategory;freetrail=false;//productObj.freetrail;
var tarrrifid=productObj.tariffId;var productid=productObj.productId;var buyagain=productObj.buyagain;var trackObj={"grade_id":gradeid.length>0?parseInt(gradeid):null,"product_type":category,"tariff_id":tarrrifid};this.storeTrackEvent("purchase_viewed",trackObj);}catch(e){}try{if(!gradeid&&localStorage.getItem("product")&&localStorage.getItem("product").length>0){var _prodId=localStorage.getItem("product");if(_prodId){var _tempProdDetails=JSON.parse(localStorage.getItem("proDetail"));gradeid=_tempProdDetails[_prodId].productOrigin||"";if(gradeid&&gradeid.length>0){localStorage.setItem("grade",gradeid);}}}else{gradeid="";}}catch(e){gradeid="";}if(this.state.PLPloggedIn==true){if(freetrail==="true"){//this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"free-"+category+"-class-"+gradeid+"-btn-click"});
this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":category+"-class-"+gradeid+"-logged-freetrial-btn"});}else{//this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"paid-"+category+"-class-"+gradeid+"-subscribe-btn-click"});
this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":category+"-class-"+gradeid+"-logged-subscribe-btn"});}this.setState({selectedTarriffID:productObj.tarrifid});// if(buyagain && buyagain == "true"){
// 	window.location.href = '/product-details/';
// }else{
// 	this.props.history.push('/product-details/');
// }
}else{if(freetrail==="true"){//this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"free-"+category+"-class-"+gradeid+"-loginform"});
this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":category+"-class-"+gradeid+"-loginform-freetrial-btn"});}else{//this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"paid-"+category+"-class-"+gradeid+"-subscribe-loginform"});
this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":category+"-class-"+gradeid+"-loginform-subscribe-btn"});}this.modalcloseDataGA="Home - Sign in - Subscription - close";this.setState({"ModalShow":true,"ModalContent":this.getSubScripeLoginForm(freetrail),"ModalHeader":"logo",selectedTarriffID:productObj.tarrifid,customClass:"newloginDialog"});}}},{key:'showSubScripeLoginForm',value:function showSubScripeLoginForm(event){var purchaseObj={tarrrifid:event.currentTarget.dataset.tarrifid,productid:event.currentTarget.dataset.productid};__WEBPACK_IMPORTED_MODULE_9__util_BrowserStorageUtil__["a" /* default */].storeItem(this.state.purchaseKey,JSON.stringify(purchaseObj));var gradeid="";var category="";var freetrail="";try{gradeid=event.currentTarget.dataset.gradeid;category=event.currentTarget.dataset.category;freetrail=event.currentTarget.dataset.freetrail;var tarrrifid=event.currentTarget.dataset.tarrifid;var productid=event.currentTarget.dataset.productid;var buyagain=event.currentTarget.dataset.buyagain;var trackObj={"grade_id":gradeid.length>0?parseInt(gradeid):null,"product_type":category,"tariff_id":tarrrifid};this.storeTrackEvent("purchase_viewed",trackObj);}catch(e){}try{if(!gradeid&&localStorage.getItem("product")&&localStorage.getItem("product").length>0){var _prodId=localStorage.getItem("product");if(_prodId){var _tempProdDetails=JSON.parse(localStorage.getItem("proDetail"));gradeid=_tempProdDetails[_prodId].productOrigin||"";if(gradeid&&gradeid.length>0){localStorage.setItem("grade",gradeid);}}}else{gradeid="";}}catch(e){gradeid="";}if(this.state.PLPloggedIn==true){if(freetrail==="true"){//this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"free-"+category+"-class-"+gradeid+"-btn-click"});
this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":category+"-class-"+gradeid+"-logged-freetrial-btn"});}else{//this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"paid-"+category+"-class-"+gradeid+"-subscribe-btn-click"});
this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":category+"-class-"+gradeid+"-logged-subscribe-btn"});}this.setState({selectedTarriffID:event.currentTarget.dataset.tarrifid});if(buyagain&&buyagain=="true"){window.location.href='/product-details/';}else{this.props.history.push('/product-details/');}}else{if(freetrail==="true"){//this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"free-"+category+"-class-"+gradeid+"-loginform"});
this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":category+"-class-"+gradeid+"-loginform-freetrial-btn"});}else{//this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"paid-"+category+"-class-"+gradeid+"-subscribe-loginform"});
this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":category+"-class-"+gradeid+"-loginform-subscribe-btn"});}this.modalcloseDataGA="Home - Sign in - Subscription - close";this.setState({"ModalShow":true,"ModalContent":this.getSubScripeLoginForm(freetrail),"ModalHeader":"logo",selectedTarriffID:event.currentTarget.dataset.tarrifid,customClass:"newloginDialog"});}}},{key:'showLoginForm',value:function showLoginForm(e){//alert("showLoginForm"+this.state.LumosloggedIn+" : "+this.state.PLPloggedIn);
if(this.state.LumosloggedIn==true||__WEBPACK_IMPORTED_MODULE_83__util_BrowserUtil__["a" /* default */].getLumosToken()&&__WEBPACK_IMPORTED_MODULE_83__util_BrowserUtil__["a" /* default */].getLumosToken().length>=5){window.top.location.href=this.getUrlFor("LUMOS_REDIRECT_URL");}else if(this.state.PLPloggedIn==true||__WEBPACK_IMPORTED_MODULE_83__util_BrowserUtil__["a" /* default */].getAuthToken()&&__WEBPACK_IMPORTED_MODULE_83__util_BrowserUtil__["a" /* default */].getAuthToken().length>=5){/*if(this.state.userRole == "PRNT"){
						window.top.location.href = '/myproducts';
			   }else{
						window.top.location.href = '/landing';
					}*/if(this.allProductsExpired()){window.top.location.href='/landing';}else if(!this.productsAvailableToAccess()){window.top.location.href='/landing';}else{window.top.location.href='/landing';}}else{//alert("showlogin else");
//this.modalcloseDataGA = "Home - Sign in - close";
//this.setState({"ModalShow":true,"ModalContent":this.getLoginForm(),"ModalHeader":this.rb("signin.heading"),customClass:""});
this.getSingleLoginForm(e);}}},{key:'allProductsExpired',value:function allProductsExpired(){var productsInHistory=false;var user=this.getUser();if(user!=null){var productsAvailable=this.productsAvailableToAccess();var entlHistory=user.getEntlHistory();if(entlHistory!=null&&Object.keys(entlHistory).length>0){for(var i in entlHistory){if(entlHistory[i]!=null){var totalLevel=entlHistory[i].split(",").reduce(function(a,b){try{return parseInt(a)+parseInt(b);}catch(e){return 0;}});if(totalLevel>0){productsInHistory=true;break;}}}}}return productsInHistory&&!productsAvailable;}},{key:'productsAvailableToAccess',value:function productsAvailableToAccess(){var user=this.getUser();if(user!=null){var permissions=user.getPermissions();if(permissions!=null&&Object.keys(permissions).length>0){for(var i in permissions){if(permissions[i]!=null){var totalLevel=permissions[i].split(",").reduce(function(a,b){try{return parseInt(a)+parseInt(b);}catch(e){return 0;}});if(totalLevel>0){return true;}}}}}return false;}},{key:'showSignUp',value:function showSignUp(loginType,userInput,gaFrom){console.log("loginType::",loginType," userInput::",userInput);this.gaFrom=gaFrom;this.showSignupForm(loginType,userInput,gaFrom);}},{key:'startFreeTrial',value:function startFreeTrial(){if(this.state.PLPloggedIn==true){if(this.getUserRole()=="TCHR"){window.top.location.href='/teachers';}else{window.top.location.href='/products';}}else{this.modalcloseDataGA="Home - Sign in - Free Trail - close";this.setState({"ModalShow":true,"ModalContent":this.getFreeTrialPLPLoginForm(),"ModalHeader":"logo",customClass:""});}}},{key:'getUserRole',value:function getUserRole(){var role='';if(this.UserStore){if(this.getUser()&&this.getUser().get()){role=this.getUser().get().userRole.role;}}return role;}},{key:'showLiveFeedLogin',value:function showLiveFeedLogin(){this.setState({"ModalShow":true,"ModalContent":this.getLiveFeedLoginForm(),"ModalHeader":"logo",customClass:"newloginDialog"});}},{key:'showContactusForTeacher',value:function showContactusForTeacher(){this.modalcloseDataGA="Footer - Contact Us - Close";this.setState({"ModalShow":true,"ModalContent":this.getTchrContactusForm(),"ModalHeader":this.rb("contactus.title"),customClass:"contactus"});}},{key:'showContactus',value:function showContactus(){this.modalcloseDataGA="Footer - Contact Us - Close";this.setState({"ModalShow":true,"ModalContent":this.getContactusForm(),"ModalHeader":this.rb("contactus.title"),customClass:"contactus"});}},{key:'showSuccessContactMessage',value:function showSuccessContactMessage(msg){this.setState({"ModalShow":true,"ModalContent":this.getSuccessPwdMsg(msg),"ModalHeader":this.rb("contactus.title"),customClass:"contactus"});}},{key:'showSuccessForgotPwdMessage',value:function showSuccessForgotPwdMessage(msg){this.setState({"ModalShow":true,"ModalContent":this.getSuccessPwdMsg(msg),"ModalHeader":this.rb("rpwd.title")});}},{key:'showsuccessRegisterMsg',value:function showsuccessRegisterMsg(msg){this.setState({"ModalShow":true,"ModalContent":this.getSuccessPwdMsg(msg),"ModalHeader":this.rb("login.createnewaccount")});}},{key:'getSuccessPwdMsg',value:function getSuccessPwdMsg(msg){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'successPwdMsg text-center'},__WEBPACK_IMPORTED_MODULE_3_react_html_parser___default()(msg));}},{key:'renderModalHeader',value:function renderModalHeader(){if(this.state.ModalHeader!="logo"){if(this.state.customClass=="resetpasword"){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'text-center loginHeaderTxt josefinsansFont'},this.state.ModalHeader,' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons',onClick:this.showForgotHelpScreen},'info')));}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'text-center loginHeaderTxt josefinsansFont'},this.state.ModalHeader));}}else{//return (<img src={heymathlogo} className="heymathlogo" width="120"/>);
}}},{key:'getCreateAccount',value:function getCreateAccount(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__views_login_CreateNewAccountForm__["a" /* default */],{myProps:this.props,successRegisterMsg:this.showsuccessRegisterMsg,navigateURL:'/product-details'});}},{key:'getVerifyAccount',value:function getVerifyAccount(){var loginType=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var userInput=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var navigateurl=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var freetrail=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;if(navigateurl==null){navigateurl='/products';}console.log("calling signup this.gaFrom:::",this.gaFrom);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__views_login_SignupForm__["a" /* default */],{signupUser:'student',myProps:this.props,loginType:loginType,'data-ga':this.modalcloseDataGA,userInput:userInput,successRegisterMsg:this.showsuccessRegisterMsg,navigateURL:navigateurl,freetrail:freetrail,gaFrom:this.gaFrom});}},{key:'getContactusForm',value:function getContactusForm(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 nopadding'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__views_login_Contactus__["a" /* default */],{myProps:this.props,successContactus:this.showSuccessContactMessage}))));}},{key:'getTchrContactusForm',value:function getTchrContactusForm(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 nopadding'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__views_login_TchrContactus__["a" /* default */],{myProps:this.props,successContactus:this.showSuccessContactMessage}))));}},{key:'getSubScripeLoginForm',value:function getSubScripeLoginForm(freetrail){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 nopadding'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__views_login_UnifiedLogin__["a" /* default */],{myProps:this.props,callbackForgotPwd:this.showForgotPasswordForm,callbackCreateAccount:this.showCreateAccount,showSignUp:this.showSignUp,navigateURL:'/product-details',freetrail:freetrail}))));}},{key:'getSingleLoginForm',value:function getSingleLoginForm(event){var loginSource=event.currentTarget.dataset.source||'';if(loginSource==""||loginSource=="lumos"||loginSource=="plp"){this.modalcloseDataGA="Home - Users who have independently registered - Close";this.setState({"ModalShow":true,"ModalContent":this.getUnifiedLoginForm(),"ModalHeader":"logo",customClass:"newloginDialog"});}else if(loginSource=="register"){this.modalcloseDataGA="Home - Sign in - Users who want to register - Close";this.setState({"ModalShow":true,"ModalContent":this.getVerifyAccount(),"ModalHeader":this.rb("login.createnewaccount"),customClass:"newloginDialog"});}//console.log("loginFrom="+loginSource);
// if(loginSource == "lumos"){
// 	this.modalcloseDataGA = "Home - Sign in - Users enrolled through school - Close";
// 	this.setState({"ModalShow":true,"ModalContent":this.getLumosLoginForm(),"ModalHeader":"logo", customClass:"loginlumos"});
// }else if(loginSource == "plp"){
// 	this.modalcloseDataGA = "Home - Users who have independently registered - Close";
// 	this.setState({"ModalShow":true,"ModalContent":this.getPLPLoginForm(),"ModalHeader":"logo", customClass:"newloginDialog"});
// }else if(loginSource == "register"){
// 	this.modalcloseDataGA = "Home - Sign in - Users who want to register - Close";
// 	this.setState({"ModalShow":true,"ModalContent":this.getVerifyAccount(),"ModalHeader":this.rb("login.createnewaccount"),customClass:"newloginDialog"});
// }
}},{key:'loginFormOnLoad',value:function loginFormOnLoad(source){if(this.state.loggedIn||this.state.LumosloggedIn||__WEBPACK_IMPORTED_MODULE_83__util_BrowserUtil__["a" /* default */].getAuthToken()&&__WEBPACK_IMPORTED_MODULE_83__util_BrowserUtil__["a" /* default */].getAuthToken().length>=5||__WEBPACK_IMPORTED_MODULE_83__util_BrowserUtil__["a" /* default */].getLumosToken()&&__WEBPACK_IMPORTED_MODULE_83__util_BrowserUtil__["a" /* default */].getLumosToken().length>=5){return;}if(source=="plp"||source=="lumos"){this.modalcloseDataGA="Home - Sign in - Users enrolled through school - Close";this.setState({"ModalShow":true,"ModalContent":this.getUnifiedLoginForm(),"ModalHeader":"logo",customClass:"loginlumos"});}else if(source=="register"){this.modalcloseDataGA="Home - Sign in - Users who want to register - Close";this.setState({"ModalShow":true,"ModalContent":this.getVerifyAccount(),"ModalHeader":this.rb("login.createnewaccount"),customClass:"newloginDialog"});}// else if(source == "lumos"){
// 	this.modalcloseDataGA = "Home - Sign in - Users enrolled through school - Close";
// 	this.setState({"ModalShow":true,"ModalContent":this.getLumosLoginForm(),"ModalHeader":"logo", customClass:"loginlumos"});
// }else if(source == "plp"){
// 	this.modalcloseDataGA = "Home - Users who have independently registered - Close";
// 	this.setState({"ModalShow":true,"ModalContent":this.getPLPLoginForm(),"ModalHeader":"logo", customClass:"newloginDialog"});
// }
}},{key:'getLoginForm',value:function getLoginForm(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'signinContainer josefinsansFont'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 clearfix text-center mt-15'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{'data-ga':'Home - Sign in - Users enrolled through school',className:'card school','data-source':'lumos',onClick:this.getSingleLoginForm},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'card-top'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'top-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__images_icons_school_signin_icon_png___default.a})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'top-heading'},__WEBPACK_IMPORTED_MODULE_3_react_html_parser___default()(this.rb("signin.school.cardheading"))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'card-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'card-text'},this.rb("signin.school.content")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'text-right arrow'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons'},'chevron_right')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{'data-ga':'Home - Sign in - Users who have independently registered',className:'card individual','data-source':'plp',onClick:this.getSingleLoginForm},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'card-top'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'top-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__images_icons_plp_signin_icon_png___default.a})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'top-heading'},__WEBPACK_IMPORTED_MODULE_3_react_html_parser___default()(this.rb("signin.individual.cardheading"))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'card-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'card-text'},this.rb("signin.individual.content")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'text-right arrow'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons'},'chevron_right')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null));}},{key:'getLumosLoginForm',value:function getLumosLoginForm(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 nopadding'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__views_login_LumosLoginForm__["a" /* default */],{myProps:this.props,loginIframeView:this.loginIframeView,callbackForgotPwd:this.showForgotPasswordForm}))));}},{key:'getUnifiedLoginForm',value:function getUnifiedLoginForm(){var loginType=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var userid=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var errMsg=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 nopadding'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__views_login_UnifiedLogin__["a" /* default */],{myProps:this.props,loginType:loginType,userid:userid,callbackForgotPwd:this.showForgotPasswordForm,callbackCreateAccount:this.showCreateAccount,showSignUp:this.showSignUp,navigateURL:'/products',errMsg:errMsg})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)));}},{key:'getUnifiedLoginFormWithoutNav',value:function getUnifiedLoginFormWithoutNav(){var loginType=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var userid=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var errMsg=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var navUrl=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;var callBack=arguments.length>4&&arguments[4]!==undefined?arguments[4]:null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 nopadding'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__views_login_UnifiedLogin__["a" /* default */],{myProps:this.props,loginType:loginType,userid:userid,callBack:callBack,callbackForgotPwd:this.showForgotPasswordForm,callbackCreateAccount:this.showCreateAccount,showSignUp:this.showSignUp,navigateURL:navUrl,errMsg:errMsg})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)));}},{key:'getPLPLoginForm',value:function getPLPLoginForm(){var loginType=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var userid=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var errMsg=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 nopadding'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__views_login_LoginForm__["a" /* default */],{myProps:this.props,loginType:loginType,userid:userid,callbackForgotPwd:this.showForgotPasswordForm,callbackCreateAccount:this.showCreateAccount,showSignUp:this.showSignUp,navigateURL:'/products',errMsg:errMsg})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)));}},{key:'getFreeTrialPLPLoginForm',value:function getFreeTrialPLPLoginForm(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 nopadding'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__views_login_UnifiedLogin__["a" /* default */],{myProps:this.props,callbackForgotPwd:this.showForgotPasswordForm,callbackCreateAccount:this.showCreateAccount,showSignUp:this.showSignUp,navigateURL:'/products'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)));}},{key:'getLiveFeedLoginForm',value:function getLiveFeedLoginForm(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 nopadding'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__views_login_LoginForm__["a" /* default */],{myProps:this.props,callbackForgotPwd:this.showForgotPasswordForm,callbackCreateAccount:this.showCreateAccount,showSignUp:this.showSignUp,navigateURL:'/',liveFeed:'true'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)));}},{key:'getForgotPassword',value:function getForgotPassword(source){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 nopadding'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__views_login_UnifiedForgotPwd__["a" /* default */],{myProps:this.props,pwdIframeView:this.pwdIframeView,source:source,successForgotPwd:this.showSuccessForgotPwdMessage,showNewLoginForm:this.showNewLoginForm}))));/*if(source == "plp"){			
			return ( 
				<div>					
				<div className="row">
				<div className="col-12 nopadding">
				<ForgotPwd myProps={this.props} pwdIframeView={this.pwdIframeView} source={source} successForgotPwd={this.showSuccessForgotPwdMessage} showNewLoginForm={this.showNewLoginForm}/>
				</div>		
				</div>
				</div>
				);
			}else{
				return ( 
				<div>					
				<div className="row">
				<div className="col-12 nopadding">
				<ForgotPasswordForm myProps={this.props} pwdIframeView={this.pwdIframeView} source={source} successForgotPwd={this.showSuccessForgotPwdMessage}/>
				</div>		
				</div>
				</div>
				);
			}*/}},{key:'getButtonName',value:function getButtonName(){//console.log("lumos login::::",this.state.LumosloggedIn);
if(this.state.loggedIn||this.state.LumosloggedIn||__WEBPACK_IMPORTED_MODULE_83__util_BrowserUtil__["a" /* default */].getAuthToken()&&__WEBPACK_IMPORTED_MODULE_83__util_BrowserUtil__["a" /* default */].getAuthToken().length>=5||__WEBPACK_IMPORTED_MODULE_83__util_BrowserUtil__["a" /* default */].getLumosToken()&&__WEBPACK_IMPORTED_MODULE_83__util_BrowserUtil__["a" /* default */].getLumosToken().length>=5){return this.rb("btn.label.myheymath");}return this.rb("btn.label.signin");}},{key:'getMargin',value:function getMargin(){if(this.state.loggedIn==false){if(this.state.LumosloggedIn){return"";}return"mt-7";}else{return"";}}},{key:'getErrorPage',value:function getErrorPage(){window.top.location.href="/404";}},{key:'onLogout',value:function onLogout(){var me=this;var msg=me.rb("logout.msg");var buttons=[{label:me.rb("alert.ok"),handler:function handler(){me.doLogout();}},{label:me.rb("alert.cancel"),handler:function handler(){}}];me.showAlert(" ",msg,buttons);}},{key:'doLumosLogout',value:function doLumosLogout(){var me=this;//console.log("logout url="+me.getUrlFor("LUMOS_LOGOUT"));
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({url:me.getUrlFor("LUMOS_LOGOUT"),type:'GET',xhrFields:{withCredentials:true},crossDomain:true,success:function success(response){me.setState({LumosloggedIn:false});},error:function error(response){console.log("Error in LUMOS_LOGOUT",response);me.setState({LumosloggedIn:false});}});}},{key:'doCommonLogout',value:function doCommonLogout(){var redirectUrl=null;/*if(BrowserUtil.getCookie("loginSrc") && BrowserUtil.getCookie("loginSrc").length > 10){
			redirectUrl = (BrowserUtil.getCookie("loginSrc")).replace(/"/g,"");
		}else{
			redirectUrl = (this.getUrlFor("PRELOGIN_PAGE")).replace(/"/g,"");
		}*/if(this.getUrlFor("PRELOGIN_PAGE")&&this.getUrlFor("PRELOGIN_PAGE").length>0){redirectUrl=this.getUrlFor("PRELOGIN_PAGE").replace(/"/g,"");}else if(this.getUrlFor("HEYMATH_HOME")&&this.getUrlFor("HEYMATH_HOME").length>0){redirectUrl=this.getUrlFor("HEYMATH_HOME").replace(/"/g,"");}var me=this;var callBackSuccess=function callBackSuccess(){me.initiateTrack("logout",{});setTimeout(function(){me.UserStore.clearOldUser();window.location.href=redirectUrl;//me.getUrlFor("PRELOGIN_PAGE");
},500);};var PLPcallBackFailure=function PLPcallBackFailure(){window.location.href=redirectUrl;//me.getUrlFor("PRELOGIN_PAGE");
console.error("Logout failed.");};var callBackFailure=function callBackFailure(response,request){//window.location.href = me.getUrlFor("PRELOGIN_PAGE");
if(request.status!=403){console.error("Logout failed.");new __WEBPACK_IMPORTED_MODULE_11__util_NativeAjax__["a" /* default */](me.getUrlFor("PLP_COMMON_LOGOUT")).enableCORS().get(callBackSuccess,PLPcallBackFailure);}else{window.location.href=redirectUrl;// me.getUrlFor("PRELOGIN_PAGE");
}};new __WEBPACK_IMPORTED_MODULE_11__util_NativeAjax__["a" /* default */](this.getUrlFor("LUMOS_COMMON_LOGOUT")).enableCORS().get(callBackSuccess,callBackFailure);}},{key:'doPLPLogout',value:function doPLPLogout(){var me=this;var callBackSuccess=function callBackSuccess(){me.initiateTrack("logout",{});setTimeout(function(){me.UserStore.clearOldUser();window.location.href=me.getUrlFor("PRELOGIN_PAGE");},500);};var callBackFailure=function callBackFailure(){console.error("Logout failed.");};new __WEBPACK_IMPORTED_MODULE_10__util_HmAjax__["a" /* default */](me.getUrlFor("LOGOUT")).get(callBackSuccess,callBackFailure);}},{key:'doLogout',value:function doLogout(){var me=this;//console.log("logout ",me.UserStore.getAuthProviderId())
// if(me.UserStore.getAuthProviderId() === 5){
// 	me.doLumosLogout();
// }
try{__WEBPACK_IMPORTED_MODULE_9__util_BrowserStorageUtil__["a" /* default */].removeSessionItem(me.state.navigationKey);}catch(e){if(console)console.error(e);}//me.doPLPLogout();
me.doCommonLogout();}},{key:'renderLoginView',value:function renderLoginView(){var _this2=this;if(this.state.loggedIn==true){// return(<a className="pl-20 logoutIcon" href="#" onClick={() => {this.onLogout()}}><i className="material-icons">power_settings_new</i></a>);
var lumosHidden="";if(this.state.LumosloggedIn){lumosHidden="hidden";}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'inlineblock'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'inlineblock navbar-nav'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:'nav-item dropdown'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'nav-link dropdown-toggle',href:'#',id:'navbardrop','data-toggle':'dropdown'},this.state.imageLoaded?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'material-icons md-60  usericon imgprv',src:this.state.imagePreviewUrl}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons md-40 useraccountelement'},'account_circle')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dropdown-menu'},function(){if(_this2.isHeaderMenuAllowed("my_products")){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:"dropdown-item "+lumosHidden,href:'/myproducts','data-ga':'Home - My Subscriptions'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons pr-16'},'credit_card'),' My Subscriptions');}}(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:"dropdown-item "+lumosHidden,href:'/settings'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons pr-16'},'account_circle'),' My Profile'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'dropdown-item',href:'#',onClick:function onClick(){_this2.onLogout();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons pr-16'},'power_settings_new'),' Sign out')))));}}},{key:'renderClassView',value:function renderClassView(){var me=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'productdd',className:'inlineblock'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'inlineblock navbar-nav'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:'nav-item dropdown'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'nav-link dropdown-toggle cont',href:'#',id:'navbardrop','data-toggle':'dropdown'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'procont'},this.rb("in.products.students.title"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_81__components_ProductMenu__["a" /* default */],{products_category_order:me.getProductsTypeOrder(),products_category:me.getProductsType(),classes:me.getClasses(),grades:me.getGrades(),products_class:me.getProductsClass()}))));}},{key:'renderAboutUsMenu',value:function renderAboutUsMenu(){var me=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'aboutContent',className:'inlineblock'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'inlineblock navbar-nav'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{className:'nav-item dropdown'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'nav-link dropdown-toggle cont',href:'#',id:'navbardrop','data-toggle':'dropdown'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'aboutcont'},this.rb("header.label.about.tab"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'about-menu',className:'dropdown-menu'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dropdown-item'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'splwell'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'about-menu'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{'data-ga':'Who we are - Main Tab'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuwhoweare','data-classname':'menuwhoweare',to:'/who-we-are',onClick:this.menuSelected},'Who We Are'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'about-menu'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{'data-ga':'Our Learning - Main Tab'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuourlearnings','data-classname':'menuourlearnings',to:'/our-learnings',onClick:this.menuSelected},'Our Learnings'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'about-menu'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{'data-ga':'Spotlight - Main Tab'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuspotlight','data-classname':'menuspotlight',to:'/spotlight',onClick:me.menuSelected},'Spotlight')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row atagalign'})))))));}},{key:'componentDidMount',value:function componentDidMount(){//console.warn("PreloginHome IN");
var me=this;me.showlog_Form_route();__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA");__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");var callBackSuccess=function callBackSuccess(result){if(result!==null){try{me.setState({isLoaded:true,grades:result.products_classification.IN.Board.CBSE.grade_order,classes:result.products_classification.IN.Board.CBSE.grades,products_class:result.products_classification.IN.Board.CBSE.grades,products_category:result.products_classification.IN.Board.CBSE.products_category,products_category_order:result.products_classification.IN.Board.CBSE.products_category_order,products_classification:result});}catch(e){console.error(e);}}//console.log("response : ", response);
};var callBackFailure=function callBackFailure(response){me.setState({isLoaded:true,error:"Error in PRODUCT_CLASSIFICATION"});console.log("Error in PRODUCT_CLASSIFICATION");};new __WEBPACK_IMPORTED_MODULE_10__util_HmAjax__["a" /* default */](this.getUrlFor("PRODUCT_CLASSIFICATION")).post(callBackSuccess,callBackFailure);try{if(this.selectedMenu!=null){__WEBPACK_IMPORTED_MODULE_0_jquery___default()("."+this.selectedMenu).addClass("selected");}}catch(e){}if(!__WEBPACK_IMPORTED_MODULE_9__util_BrowserStorageUtil__["a" /* default */].getStoredSessionItem(this.plpTrackKey)){__WEBPACK_IMPORTED_MODULE_9__util_BrowserStorageUtil__["a" /* default */].storeSessionItem(this.plpTrackKey,"[]");}var pathName=window.location.pathname;var windowAlert=window.infoMaintenance&&window.infoMaintenance.showBanner&&window.infoMaintenance.bannerMessage[pathName]||false;var hideCountryList=window.infoMaintenance&&window.infoMaintenance.hidecountryList?window.infoMaintenance.hidecountryList:[];var alreadyShown=localStorage.getItem("banner-"+pathName)==="true";var currentGeo=this.getGeo();var hideBasedCountry=hideCountryList.length>0&&hideCountryList.indexOf(currentGeo)>-1?true:false;//console.warn("alreadyShown ",alreadyShown, " : ",hideCountryList, " : ",hideBasedCountry," : ",hideCountryList.indexOf(currentGeo));
if(alreadyShown||hideBasedCountry){return;}var title=window.infoMaintenance.bannerMessage&&window.infoMaintenance.bannerMessage[pathName]&&window.infoMaintenance.bannerMessage[pathName].title?window.infoMaintenance.bannerMessage[pathName].title:'';var bannerContent=window.infoMaintenance.bannerMessage&&window.infoMaintenance.bannerMessage[pathName]&&window.infoMaintenance.bannerMessage[pathName].content?window.infoMaintenance.bannerMessage[pathName].content:'';if((title||bannerContent)&&windowAlert&&!alreadyShown){this.setState({InfoModalShow:true,InfoModalContent:this.showInfoBannerUI(bannerContent),InfoModalHeader:title,customClass:"newloginDialog"});}}},{key:'getGeo',value:function getGeo(){var geo=_get(PreloginHome.prototype.__proto__||Object.getPrototypeOf(PreloginHome.prototype),'getGeo',this).call(this);return geo||"SG";}},{key:'showInfoBannerUI',value:function showInfoBannerUI(bannerContent){var message=bannerContent?bannerContent:'';return message;}},{key:'hideInfoModal',value:function hideInfoModal(){var pathName=window.location.pathname;localStorage.setItem("banner-"+pathName,"true");this.setState({InfoModalShow:false});}},{key:'showlog_Form_route',value:function showlog_Form_route(){var me=this;//console.log("loginRequestComplete ",me.state.loginRequestComplete," : ",me.state.PLPloggedIn," : ",me.state.LumosloggedIn);
if(me.state.loginRequestComplete&&!me.state.PLPloggedIn&&!me.state.LumosloggedIn){var qryParam=me.QueryStringToJSON();if(qryParam["loginForm"]&&qryParam["loginForm"].length>0){setTimeout(function(){me.loginFormOnLoad(qryParam["loginForm"]);},1000);}}}},{key:'detectGmailGExists',value:function detectGmailGExists(){try{var params=this.QueryStringToJSON();if(Object.keys(params).length>0){if(params.g_exists=="true"||params.g_exists==true){//console.log("g_exists::this.state.PLPloggedIn=="+this.state.PLPloggedIn);
if(this.state.PLPloggedIn==false||this.state.PLPloggedIn=="false"){var googleErrmsg=this.rb("google.forbiden.msg");//this.setState({"ModalShow":true,"ModalContent":this.getPLPLoginForm(null,null,googleErrmsg),"ModalHeader":"logo", customClass:"newloginDialog"});
this.setState({"ModalShow":true,"ModalContent":this.getUnifiedLoginForm(null,null,googleErrmsg),"ModalHeader":"logo",customClass:"newloginDialog"});}}}}catch(e){}}},{key:'QueryStringToJSON',value:function QueryStringToJSON(){try{var pairs=this.props.location.search.slice(1).split('&');var result={};pairs.forEach(function(pair){pair=pair.split('=');result[pair[0]]=decodeURIComponent(pair[1]||'');});return JSON.parse(JSON.stringify(result));}catch(e){}return{};}},{key:'getGrades',value:function getGrades(){if(this.state.grades!==[]&&this.state.grades!==undefined){return this.state.grades;}}},{key:'getClasses',value:function getClasses(){if(this.state.classes!==[]&&this.state.classes!==undefined){return this.state.classes;}}},{key:'getProductsClass',value:function getProductsClass(){if(this.state.products_class!=={}&&this.state.products_class!==undefined){return this.state.products_class;}}},{key:'getProductsClassification',value:function getProductsClassification(){if(this.state.products_classification!=={}&&this.state.products_classification!==undefined){return this.state.products_classification;}}},{key:'getProductsType',value:function getProductsType(){if(this.state.products_category!=={}&&this.state.products_category!==undefined){return this.state.products_category;}}},{key:'getProductsTypeOrder',value:function getProductsTypeOrder(){if(this.state.products_category_order!==[]&&this.state.products_category_order!==undefined){return this.state.products_category_order;}}},{key:'freeTrialUser',value:function freeTrialUser(isTriedFree,isPurchased){this.setState({productsInfoAvailable:true,userProdReqComplete:true,triedFree:isTriedFree,purchased:isPurchased});}},{key:'checkUserFreeTrial',value:function checkUserFreeTrial(prodInfo){var me=this;if(prodInfo&&prodInfo.productId&&prodInfo.tariffId){var successFn=function successFn(resp){try{if(resp&&resp.response){console.log(resp.response);me.freeTrialUser(resp.response.free_accessed,resp.response.paid_accessed);/*if(resp.response === "error"){
							me.freeTrialUser(true);
						}else{
							me.freeTrialUser(false);
						}*/}}catch(e){}};var failureFn=function failureFn(err){console.warn("Error while checking for the product free usage :",err);//IMPORTANT: Not Required in Ideal scenario. But all scenarios are not idle everytime
me.freeTrialUser(false,false);};var products=[];products.push(prodInfo);var paramObj={"products":products};new __WEBPACK_IMPORTED_MODULE_11__util_NativeAjax__["a" /* default */](this.getUrlFor("FREE_PRODUCT_CHECK"),paramObj).enableCORS().post(successFn,failureFn);}else{console.warn("productId or TariffId not available in prodInfo :",prodInfo);}}},{key:'loadProductDetails',value:function loadProductDetails(productid){var me=this;var paramObj={"productId":productid};var callBackSuccess=function callBackSuccess(response){console.log("response:::",response);if((typeof response==='undefined'?'undefined':_typeof(response))==="object"&&response){localStorage.setItem('product',response.product_order[0]);//localStorage.setItem('grade',this.gradeNo);
localStorage.setItem('proDetail',JSON.stringify(response.product_details));//me.setState({productsInfoAvailable:true});
try{var tariffs=response.product_details[productid]["pricing_details"];if(tariffs){for(var i in tariffs){if(tariffs[i]["is_trial"]||tariffs[i]["is_free_product"]){me.checkUserFreeTrial({"productId":productid,"tariffId":i});break;}}}}catch(e){console.error(e);}}else{me.setState({productsLoadErr:true});}};var callBackFailure=function callBackFailure(response){me.isProdcutLoadCalled=false;console.log("Error in PRODUCT_DETAILS");};new __WEBPACK_IMPORTED_MODULE_11__util_NativeAjax__["a" /* default */](this.getUrlFor("PRODUCT_DETAILS"),paramObj).enableCORS().post(callBackSuccess,callBackFailure);}},{key:'Home',value:function Home(){if(!this.tracked){this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"home-PageView"});this.tracked=true;}try{if(this.state.LumosloggedIn){window.location.href=this.getUrlFor("LUMOS_REDIRECT_URL");}else if(this.state.PLPloggedIn&&!window.location.href.match("/home")){window.location.href="/landing";}}catch(e){}this.selectedMenu="menuhome";var me=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,me.setTitle("HOME_title"),me.setMeta("HOME_meta"),me.setHeading("HOME_heading"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'bannerElement'},this.getBannerContent()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_72__components_ScrollToTopOnMount_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__components_Banner2_js__["a" /* default */],{products_category_order:this.getProductsTypeOrder(),products_category:this.getProductsType(),classes:this.getClasses(),grades:this.getGrades(),products_class:this.getProductsClass(),PLPloggedIn:this.state.PLPloggedIn,startFreeTrial:this.startFreeTrial,showSignUp:this.showSignUp,showNewLoginForm:this.showNewLoginForm}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42__components_RecognisedStatic__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__components_LessonFeatures2_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_80__components_Why_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_64__components_OurTeachers_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_76__components_OurTestimonial_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41__components_StaticFeed__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__components_SignupSection2_js__["a" /* default */],{PLPloggedIn:this.state.PLPloggedIn,startFreeTrial:this.startFreeTrial,showSignUp:this.showSignUp,showNewLoginForm:this.showNewLoginForm}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_57__components_Footer_js__["a" /* default */],{showContactus:this.showContactus,products_category_order:this.getProductsTypeOrder(),products_category:this.getProductsType(),classes:this.getClasses(),grades:this.getGrades(),products_class:this.getProductsClass()}),this.fireMobileToast());}},{key:'Products',value:function Products(_ref4){var match=_ref4.match;if(!this.tracked){this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"product-PageView"});this.tracked=true;}__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA");__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");this.selectedMenu="menuproducts";var me=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,me.setTitle("PRODUCTS_title"),me.setMeta("PRODUCTS_meta"),me.setHeading("PRODUCTS_heading"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_72__components_ScrollToTopOnMount_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_68__components_PageBanner_js__["a" /* default */],{name:this.rb("header.label.products.tab"),classes:'bg-grn'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_79__components_Trusted_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_60__components_Grades_js__["a" /* default */],{url:''+match.url,products_category:this.getProductsType(),grades:this.getGrades(),classes:this.getClasses(),products_class:this.getProductsClass()}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_57__components_Footer_js__["a" /* default */],{showContactus:this.showContactus,products_category_order:this.getProductsTypeOrder(),products_category:this.getProductsType(),classes:this.getClasses(),grades:this.getGrades(),products_class:this.getProductsClass()}),this.fireMobileToast());}},{key:'Learnings',value:function Learnings(){this.setTitle("LEARNINGS_title");__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA");__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");this.selectedMenu="menuourlearnings";return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_72__components_ScrollToTopOnMount_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_68__components_PageBanner_js__["a" /* default */],{classes:'bg-grn bg-blue banner-text',text:this.rb("our_learnings_heading")}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_56__components_FlipSection_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_63__components_OtherLearnings_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_57__components_Footer_js__["a" /* default */],{showContactus:this.showContactus,products_category_order:this.getProductsTypeOrder(),products_category:this.getProductsType(),classes:this.getClasses(),grades:this.getGrades(),products_class:this.getProductsClass()}));}},{key:'SelfPaced',value:function SelfPaced(_ref5){var _this3=this;var match=_ref5.match;if(!this.tracked){this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"spl-PageView"});this.tracked=true;}__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA");__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");if(this.state.productsInfoAvailable&&this.state.userProdReqComplete){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_72__components_ScrollToTopOnMount_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_69__components_PageBannerBuy_js__["a" /* default */],{name:'Self-Paced Lessons',triedFree:this.state.triedFree,purchased:this.state.purchased,classes:'bg-grn bg-blue-large banner-text',text:'To build a strong conceptual foundation',id:''+match.params.id,showSubScripeLoginForm:this.showSubScripeLoginForm,productBase:'plp',simpleform:'true'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_49__components_OverallFeatures__["a" /* default */],{name:'SPL'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__components_Lessons_js__["a" /* default */],{id:''+match.params.id,PLPloggedIn:this.state.PLPloggedIn}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_78__components_Topics_js__["a" /* default */],{id:''+match.params.id,productBase:'selfpaced'}),function(){if(!window.suppress_all_paid_products){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_51__components_BuyOption_js__["a" /* default */],{id:''+match.params.id,triedFree:_this3.state.triedFree,purchased:_this3.state.purchased,showSubScripeLoginForm:_this3.showSubScripeLoginForm,productBase:'selfpaced',simpleform:'false'});}}(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__components_Use_js__["a" /* default */],{imgName:'../img/sgp.jpg',owner:'spl'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_57__components_Footer_js__["a" /* default */],{showContactus:this.showContactus,products_category_order:this.getProductsTypeOrder(),products_category:this.getProductsType(),classes:this.getClasses(),grades:this.getGrades(),products_class:this.getProductsClass()}));}else{if(this.isProdcutLoadCalled==false){this.isProdcutLoadCalled=true;this.loadProductDetails(''+match.params.id);}if(this.state.productsLoadErr){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_72__components_ScrollToTopOnMount_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_70__components_ProductBanner_js__["a" /* default */],{name:'Self-Paced Lessons',classes:'bg-grn bg-blue banner-text',text:'To build a strong conceptual foundation',bannerPoint1:'Learn the Why',bannerPoint2:'Know the How',bannerPoint3:'Check your understanding'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'text-center josefin mt-30'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,' ',this.rb("profile.oops"),' ')));}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_72__components_ScrollToTopOnMount_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_70__components_ProductBanner_js__["a" /* default */],{name:'Self-Paced Lessons',classes:'bg-grn bg-blue banner-text',text:'To build a strong conceptual foundation',bannerPoint1:'Learn the Why',bannerPoint2:'Know the How',bannerPoint3:'Check your understanding'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'productLoading'},' ',this.showLoader(),' '));}}}},{key:'Plp',value:function Plp(_ref6){var _this4=this;var match=_ref6.match;if(!this.tracked){this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"plp-PageView"});this.tracked=true;}__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA");__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");if(this.state.productsInfoAvailable&&this.state.userProdReqComplete){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_72__components_ScrollToTopOnMount_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_69__components_PageBannerBuy_js__["a" /* default */],{name:'Personalised Learning',triedFree:this.state.triedFree,purchased:this.state.purchased,classes:'bg-grn bg-grn-large banner-text',text:this.rb("PLP.build"),id:''+match.params.id,showSubScripeLoginForm:this.showSubScripeLoginForm,productBase:'plp',simpleform:'true'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_50__components_DownloadButton__["a" /* default */],{id:''+match.params.id}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_49__components_OverallFeatures__["a" /* default */],{name:'PLP'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__components_Lessons_js__["a" /* default */],{id:''+match.params.id,PLPloggedIn:this.state.PLPloggedIn}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_78__components_Topics_js__["a" /* default */],{id:''+match.params.id,productBase:'plp'}),function(){if(!window.suppress_all_paid_products){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_51__components_BuyOption_js__["a" /* default */],{id:''+match.params.id,triedFree:_this4.state.triedFree,purchased:_this4.state.purchased,showSubScripeLoginForm:_this4.showSubScripeLoginForm,productBase:'plp',simpleform:'false'});}}(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__components_Use_js__["a" /* default */],{imgName:'../img/pdbg.png',owner:'plp'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_57__components_Footer_js__["a" /* default */],{showContactus:this.showContactus,products_category_order:this.getProductsTypeOrder(),products_category:this.getProductsType(),classes:this.getClasses(),grades:this.getGrades(),products_class:this.getProductsClass()}));}else{if(this.isProdcutLoadCalled==false){this.isProdcutLoadCalled=true;this.loadProductDetails(''+match.params.id);}if(this.state.productsLoadErr){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_72__components_ScrollToTopOnMount_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_68__components_PageBanner_js__["a" /* default */],{name:'Personalised Learning',classes:'bg-grn banner-text',text:this.rb("PLP.build")}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'text-center josefin mt-30'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,' ',this.rb("profile.oops"),' ')));}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_72__components_ScrollToTopOnMount_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_68__components_PageBanner_js__["a" /* default */],{name:'Personalised Learning',classes:'bg-grn banner-text',text:this.rb("PLP.build")}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'productLoading'},' ',this.showLoader(),' '));}}}},{key:'cbse',value:function cbse(_ref7){var _this5=this;var match=_ref7.match;if(!this.tracked){this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"cbse-PageView"});this.tracked=true;}__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA");__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");if(this.state.productsInfoAvailable&&this.state.userProdReqComplete){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_72__components_ScrollToTopOnMount_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_69__components_PageBannerBuy_js__["a" /* default */],{name:'CBSE Exam Prep',triedFree:this.state.triedFree,purchased:this.state.purchased,classes:'bg-grn bg-yellowbg banner-text',text:'To achieve your best in the board exams',id:''+match.params.id,showSubScripeLoginForm:this.showSubScripeLoginForm,productBase:'cbse',simpleform:'true'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_61__components_HowWorks_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__components_Lessons_js__["a" /* default */],{id:''+match.params.id,PLPloggedIn:this.state.PLPloggedIn}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_78__components_Topics_js__["a" /* default */],{id:''+match.params.id,productBase:'cbse',imgName:'../img/pdbg.png',owner:'cbse'}),function(){if(!window.suppress_all_paid_products){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_51__components_BuyOption_js__["a" /* default */],{id:''+match.params.id,triedFree:_this5.state.triedFree,purchased:_this5.state.purchased,showSubScripeLoginForm:_this5.showSubScripeLoginForm,productBase:'cbse',simpleform:'false'});}}(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__components_Use_js__["a" /* default */],{imgName:'../img/pdbg.png',owner:'cbse'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_57__components_Footer_js__["a" /* default */],{showContactus:this.showContactus,products_category_order:this.getProductsTypeOrder(),products_category:this.getProductsType(),classes:this.getClasses(),grades:this.getGrades(),products_class:this.getProductsClass()}));}else{if(this.isProdcutLoadCalled==false){this.isProdcutLoadCalled=true;this.loadProductDetails(''+match.params.id);}if(this.state.productsLoadErr){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_72__components_ScrollToTopOnMount_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_68__components_PageBanner_js__["a" /* default */],{name:'CBSE Exam Prep',classes:'bg-grn bg-yellowbg banner-text',text:'To achieve your best in the board exams'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'text-center josefin mt-30'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,' ',this.rb("profile.oops"),' ')));}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_72__components_ScrollToTopOnMount_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_68__components_PageBanner_js__["a" /* default */],{name:'CBSE Exam Prep',classes:'bg-grn bg-yellowbg banner-text',text:'To achieve your best in the board exams'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'productLoading'},' ',this.showLoader(),' '));}}}},{key:'WhoWeAre',value:function WhoWeAre(){__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA");__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");this.selectedMenu="menuwhoweare";var me=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,me.setTitle("WHO_WE_ARE_title"),me.setMeta("WHO_WE_ARE_meta"),me.setHeading("WHO_WE_ARE_heading"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_72__components_ScrollToTopOnMount_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__components_WhoBanner2_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_53__components_DayInLife_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52__components_Culture_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_58__components_Founders_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_67__components_OurTeam_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_59__components_FounderVideos_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_71__components_Recognised_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_57__components_Footer_js__["a" /* default */],{showContactus:this.showContactus,products_category_order:this.getProductsTypeOrder(),products_category:this.getProductsType(),classes:this.getClasses(),grades:this.getGrades(),products_class:this.getProductsClass()}));}},{key:'Spotlight',value:function Spotlight(){__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA");__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");this.selectedMenu="menuspotlight";return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48__components_Spotlight__["a" /* default */],{showContactus:this.showContactus,products_category_order:this.getProductsTypeOrder(),products_category:this.getProductsType(),classes:this.getClasses(),grades:this.getGrades(),products_class:this.getProductsClass()}));}},{key:'Teachers',value:function Teachers(_ref8){var match=_ref8.match;__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA");__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");this.selectedMenu="menuteachers";if(!this.tracked){this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"teacherpage"});this.tracked=true;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_72__components_ScrollToTopOnMount_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_74__components_TeacherBannerBuy_js__["a" /* default */],{name:'CBSE Exam Prep',showContactus:this.showContactusForTeacher,triedFree:this.state.triedFree,purchased:this.state.purchased,classes:'bg-grn bg-yellowbg banner-text',text:'To achieve your best in the board exams',id:''+match.params.id,showSubScripeLoginForm:this.showSubScripeLoginForm,productBase:'cbse',simpleform:'true'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_44__components_ProgramHighlights__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_84__components_TeacherProdComp__["a" /* default */],{showSubscriptionForm:this.showSubscriptionForm,postLoginCallBack:this.postLoginCallBack}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__components_EndorsedStatic__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_45__components_NrichCollaboration__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_77__components_TeacherTestimonial_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_46__components_TeacherResources__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_75__components_TeacherBuy_js__["a" /* default */],{showContactus:this.showContactusForTeacher}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_57__components_Footer_js__["a" /* default */],{showContactus:this.showContactus,products_category_order:this.getProductsTypeOrder(),products_category:this.getProductsType(),classes:this.getClasses(),grades:this.getGrades(),products_class:this.getProductsClass()}));}},{key:'SGCatalogue',value:function SGCatalogue(_ref9){var match=_ref9.match;__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA");__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");this.selectedMenu="sgproducts";if(!this.tracked){this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"teacherpage"});this.tracked=true;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_72__components_ScrollToTopOnMount_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_89__views_others_TopBanner__["a" /* default */],{name:'CBSE Exam Prep',showContactus:this.showContactusForTeacher,triedFree:this.state.triedFree,purchased:this.state.purchased,classes:'bg-grn bg-yellowbg banner-text',text:'To achieve your best in the board exams',id:''+match.params.id,showSubScripeLoginForm:this.showSubScripeLoginForm,productBase:'cbse',simpleform:'true'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_49__components_OverallFeatures__["a" /* default */],{name:'PLP'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_87__views_others_SGProductCatalogue__["a" /* default */],{showSubscriptionForm:this.showSubscriptionForm,postLoginCallBack:this.postLoginCallBack}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__components_EndorsedStatic__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_45__components_NrichCollaboration__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_57__components_Footer_js__["a" /* default */],{showContactus:this.showContactus,products_category_order:this.getProductsTypeOrder(),products_category:this.getProductsType(),classes:this.getClasses(),grades:this.getGrades(),products_class:this.getProductsClass()}));}},{key:'switchProdType',value:function switchProdType(prodType){if(prodType){this.setState({catalogProdType:prodType});}}},{key:'newINCatalogue',value:function newINCatalogue(_ref10){var match=_ref10.match;__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA");__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");this.selectedMenu="menuproducts";if(!this.tracked){this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"teacherpage"});this.tracked=true;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_72__components_ScrollToTopOnMount_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_90__views_others_InTopBanner__["a" /* default */],{key:this.state.catalogProdType,prodType:this.state.catalogProdType,name:'CBSE Exam Prep',showContactus:this.showContactusForTeacher,triedFree:this.state.triedFree,purchased:this.state.purchased,classes:'bg-grn bg-yellowbg banner-text',text:'To achieve your best in the board exams',id:''+match.params.id,showSubScripeLoginForm:this.showSubScripeLoginForm,productBase:'cbse',simpleform:'true'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_49__components_OverallFeatures__["a" /* default */],{name:this.state.catalogProdType}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_88__views_others_NewINProductCatalogue__["a" /* default */],{switchProdType:this.switchProdType,showSubscriptionForm:this.showSubscriptionForm,postLoginCallBack:this.postLoginCallBack}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__components_EndorsedStatic__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_45__components_NrichCollaboration__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_57__components_Footer_js__["a" /* default */],{showContactus:this.showContactus,products_category_order:this.getProductsTypeOrder(),products_category:this.getProductsType(),classes:this.getClasses(),grades:this.getGrades(),products_class:this.getProductsClass()}));}},{key:'Faq',value:function Faq(){__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA");__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");//this.selectedMenu = "menufaq";
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_82__components_FAQ__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_57__components_Footer_js__["a" /* default */],{showContactus:this.showContactus,products_category_order:this.getProductsTypeOrder(),products_category:this.getProductsType(),classes:this.getClasses(),grades:this.getGrades(),products_class:this.getProductsClass()}));}},{key:'Blog',value:function Blog(){__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA");__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");this.selectedMenu="menublog";return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_47__components_Blog_js__["a" /* default */],null));}},{key:'productTab',value:function productTab(){var me=this;if(this.isMobile()||this.isTab()){if(this.isHeaderMenuAllowed("my_products")){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{'data-ga':'Products - Main tab'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuproducts','data-classname':'menuproducts',to:'/in/products',onClick:this.menuSelected},this.rb("in.products.students.title")));}}else{//return (this.renderClassView());
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{'data-ga':'Products - Main tab'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuproducts','data-classname':'menuproducts',to:'/in/products',onClick:this.menuSelected},this.rb("in.products.students.title")));}}},{key:'sgProductTab',value:function sgProductTab(){var me=this;if(this.isMobile()||this.isTab()){//if(this.isHeaderMenuAllowed("sg_products")){
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{'data-ga':'Products - Main tab'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu sgproducts','data-classname':'sgproducts',to:'/sg/products',onClick:this.menuSelected},this.rb("sg.products.title")));//}
}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{'data-ga':'Products - Main tab'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu sgproducts','data-classname':'sgproducts',to:'/sg/products',onClick:this.menuSelected},this.rb("sg.products.title")));}}},{key:'aboutUsTab',value:function aboutUsTab(){if(!window.teachers_tab_suppressed&&(this.isMobile()||this.isTab())){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{'data-ga':'Teachers - Main Tab'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuteachers','data-classname':'menuteachers',to:'/teachers',onClick:this.menuSelected},'Teachers'));}else{return this.renderAboutUsMenu();}}},{key:'postLoginTchr',value:function postLoginTchr(userObj){var me=this;if(!userObj){userObj=this.getUser().get();}var geoLocation=this.getGeo().toUpperCase()||'';if(userObj&&userObj.userRole&&userObj.userRole.role&&userObj.userRole.role.toUpperCase()==="TCHR"&&geoLocation==="IN"){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'textAlignLeft'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{'data-ga':'Teachers - Main Tab'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuteachers','data-classname':'menuteachers',to:'/teachers',onClick:this.menuSelected},'Teachers')));}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'textAlignLeft'},this.productTab(),this.sgProductTab());}}},{key:'postLoginTchrTab',value:function postLoginTchrTab(userObj){var me=this;if(!userObj){userObj=this.getUser().get();}var geoLocation=this.getGeo().toUpperCase()||'';if(userObj&&userObj.userRole&&userObj.userRole.role&&userObj.userRole.role.toUpperCase()==="TCHR"&&geoLocation==="IN"){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'textAlignLeft'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{'data-ga':'Teachers - Main Tab'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuteachers','data-classname':'menuteachers',to:'/teachers',onClick:this.menuSelected},'Teachers')));}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'textAlignLeft'},me.productTab(),this.sgProductTab());}}},{key:'getSwitcher',value:function getSwitcher(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Redirect */],{from:'/',exact:true,to:'/in'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{exact:true,path:'/in',component:this.Home,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{exact:true,path:'/home',component:this.Home,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/landing',exact:true,component:__WEBPACK_IMPORTED_MODULE_25__views_plp_Home__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/dashboard',exact:true,component:__WEBPACK_IMPORTED_MODULE_14__views_dashboard_Dashboard__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/settings',exact:true,component:this.GetMyProfile}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/report',exact:true,component:__WEBPACK_IMPORTED_MODULE_86__vendors_mindstretcher_Report__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/scorecard/:id/:reset?',exact:true,component:__WEBPACK_IMPORTED_MODULE_29__views_scorecard_Scorecard__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Redirect */],{from:'/classes',exact:true,to:"in/products"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Redirect */],{from:'/products',exact:true,to:this.getGeo()+"/products"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/in/products',component:this.newINCatalogue,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{exact:true,path:'/sg/products',component:this.SGCatalogue,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{exact:true,path:'/in/oldproducts',component:this.Products,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/our-learnings',component:this.Learnings,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/who-we-are',component:this.WhoWeAre,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/blog',component:this.Blog,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/spotlight',component:this.Spotlight,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/faq',component:this.Faq,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/self-learning/:id',component:this.SelfPaced,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/personalised-learning/:id',component:this.Plp,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/cbse-exam/:id',component:this.cbse,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{exact:true,path:'/product-details',component:this.GetProductDetails,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{exact:true,path:'/teachers',component:this.Teachers,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Redirect */],{from:'/myproducts',to:'/mysubscriptions'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/mysubscriptions',exact:true,component:this.GetMyProducts,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{exact:true,path:'/404',component:this.Home}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{component:this.Home}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Redirect */],{from:'*',to:'/'}));}},{key:'isHeaderMenuAllowed',value:function isHeaderMenuAllowed(headerMenu){if(headerMenu&&window.header_suppression_for_school&&window.header_suppression_for_school[this.getSchoolId()]&&window.header_suppression_for_school[this.getSchoolId()].length>0){this.suppressedHeaders=window.header_suppression_for_school[this.getSchoolId()]||[];return this.suppressedHeaders.indexOf(headerMenu)===-1;}return true;}},{key:'getHeaderLogo',value:function getHeaderLogo(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'/img/h-logo.png',alt:'Heymath! logo'});}},{key:'getRouter',value:function getRouter(){var _this6=this;var me=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('header',{className:'clearfix'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('nav',{className:'nav-desktop'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container-fluid norightpadding'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuhome','data-classname':'menuhome',to:'/home',onClick:me.setPreloginClass},this.getHeaderLogo())),function(){if(me.state.LumosloggedIn){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'textAlignLeft'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null));}else if(me.state.loggedIn||me.state.PLPloggedIn){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,function(){if(me.isHeaderMenuAllowed("products")){return me.postLoginTchr();}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'textAlignLeft'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null));}}());}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{'data-ga':'Home Tab'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuhome','data-classname':'menuhome',to:'/',onClick:me.menuSelected},'Home')),me.productTab(),me.sgProductTab(),function(){if(!window.teachers_tab_suppressed){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{'data-ga':'Teachers - Main Tab'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuteachers','data-classname':'menuteachers',to:'/teachers',onClick:_this6.menuSelected},'Teachers'));}}(),me.aboutUsTab());}}(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'r-sec'},function(){if(me.isHeaderMenuAllowed("my_heymath")){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-ga':'My HeyMath Tab',className:"r-btn myheymathbtn mr-30 "+me.getMargin(),onClick:me.showLoginForm},me.getButtonName());}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',{className:'textAlignLeft'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null));}}(),me.renderLoginView()))),function(){if(_this6.isHeaderMenuAllowed("hamburger")){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_burger_menu__["slide"],{right:true,onStateChange:function onStateChange(state){return me.handleStateChange(state);},isOpen:me.state.menuOpen},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'menu-icon-wrapper',className:'menu-icon-wrapper'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('nav',{className:'nav-mobile'},function(){if(me.state.loggedIn&&_this6.isHeaderMenuAllowed("hamburger")){return me.postLoginTchrTab();}else if(_this6.isHeaderMenuAllowed("hamburger")){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{'data-ga':'Home Tab',className:'animated'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuhome','data-classname':'menuhome',to:'/',onClick:function onClick(){return _this6.menuSelected();}},'Home')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{'data-ga':'Products - Main tab',className:'animated'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuproducts','data-classname':'menuproducts',to:'/products',onClick:function onClick(){return _this6.menuSelected();}},_this6.rb("in.products.students.title"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{'data-ga':'SG Prducts - Main Tab',className:'animated'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menusgproducts','data-classname':'menusgproducts',to:'/sg/products',onClick:function onClick(){return _this6.menuSelected();}},_this6.rb("sg.products.title"))),function(){if(!window.teachers_tab_suppressed){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{'data-ga':'Teachers - Main Tab',className:'animated'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuteachers','data-classname':'menuteachers',to:'/teachers',onClick:function onClick(){return _this6.menuSelected();}},'Teachers'));}}(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{'data-ga':'Our Learning - Main Tab',className:'animated'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuourlearnings','data-classname':'menuourlearnings',to:'/our-learnings',onClick:function onClick(){return _this6.menuSelected();}},'Our Learnings')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{'data-ga':'Who we are - Main Tab',className:'animated'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuwhoweare','data-classname':'menuwhoweare',to:'/who-we-are',onClick:function onClick(){return _this6.menuSelected();}},'Who We Are')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{'data-ga':'Spotlight - Main Tab',className:'animated'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuspotlight','data-classname':'menuspotlight',to:'/spotlight',onClick:function onClick(){return _this6.menuSelected();}},'Spotlight')));}}()));}else{return null;}}()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clearfix'}),me.getSwitcher()));}},{key:'render',value:function render(){__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA");__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");var isMenuOpen=function isMenuOpen(state){return state.isOpen;};var _state=this.state,grades=_state.grades,products_details=_state.products_details,products_class=_state.products_class,products_classification=_state.products_classification,products_category=_state.products_category;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"App "+this.state.preloginClassName},this.getRouter(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__views_plp_TestTakingModalComponent__["a" /* default */],{visible:this.state.ModalShow,dialogClassName:"loginModal modal-lg "+this.state.customClass},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{'data-p-ga':'',className:'modal-body'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'close loginClose','data-ga':this.modalcloseDataGA,onClick:this.hideLoginModal,'aria-label':'Close'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{'aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons'},'close'))),this.state.ModalContent))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__views_plp_TestTakingModalComponent__["a" /* default */],{visible:this.state.HelpModalShow,dialogClassName:"loginModal modal-lg "+this.state.customClass},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'loginHeader text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'text-center modallogo'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'text-center loginHeaderTxt josefinsansFont'},this.rb("resetpwd.instruction")))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'close helpClose',onClick:this.hideHelpLoginModal,'aria-label':'Close'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{'aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons'},'close')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-body'},this.state.HelpModalContent))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__views_plp_TestTakingModalComponent__["a" /* default */],{visible:this.state.InfoModalShow,dialogClassName:"infoBanner loginModal modal-lg"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'infoHeader text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'text-center modallogo'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'close helpClose',onClick:this.hideInfoModal,'aria-label':'Close'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{'aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons'},'close')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-body',onClick:this.redirecttoSomewhere},__WEBPACK_IMPORTED_MODULE_3_react_html_parser___default()(this.state.InfoModalContent)))));}}]);return PreloginHome;}(__WEBPACK_IMPORTED_MODULE_13__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (PreloginHome);__WEBPACK_IMPORTED_MODULE_85__model_ComponentRegistry__["a" /* default */].register("in_PreloginHome",PreloginHome);/**
* IMPORTANT: CommonPreLoginHome moved to sg_PreloginHome
*/////ComponentRegistry.register("PreloginHome",PreloginHome);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty__ = __webpack_require__(143);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty__["a" /* default */])(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CacheProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ClassNames; });
/* unused harmony export Global */
/* unused harmony export ThemeContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return jsx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return keyframes; });
/* unused harmony export withEmotionCache */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_cache__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_utils__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emotion_serialize__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emotion_sheet__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__emotion_css__ = __webpack_require__(145);
/* unused harmony reexport css */









var EmotionCacheContext = Object(__WEBPACK_IMPORTED_MODULE_1_react__["createContext"])( Object(__WEBPACK_IMPORTED_MODULE_2__emotion_cache__["a" /* default */])() );
var ThemeContext = Object(__WEBPACK_IMPORTED_MODULE_1_react__["createContext"])({});
var CacheProvider = EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  var render = function render(props, ref) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(EmotionCacheContext.Consumer, null, function ( // $FlowFixMe we know it won't be null
    cache) {
      return func(props, cache, ref);
    });
  }; // $FlowFixMe


  return Object(__WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"])(render);
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var hasOwnProperty = Object.prototype.hasOwnProperty;

var render = function render(cache, props, theme, ref) {
  var type = props[typePropName];
  var registeredStyles = [];
  var className = '';
  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  registeredStyles.push(cssProp);

  if (props.className !== undefined) {
    className = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_utils__["a" /* getRegisteredStyles */])(cache.registered, registeredStyles, props.className);
  }

  var serialized = Object(__WEBPACK_IMPORTED_MODULE_4__emotion_serialize__["a" /* serializeStyles */])(registeredStyles);

  if (false) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  var rules = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_utils__["b" /* insertStyles */])(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ("production" === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(type, newProps);

  return ele;
};

var Emotion = withEmotionCache(function (props, cache, ref) {
  // use Context.read for the theme when it's stable
  if (typeof props.css === 'function') {
    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(ThemeContext.Consumer, null, function (theme) {
      return render(cache, props, theme, ref);
    });
  }

  return render(cache, props, null, ref);
});

if (false) {
  Emotion.displayName = 'EmotionCssPropInternal';
} // $FlowFixMe


var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || props.css == null) {
    // $FlowFixMe
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"].apply(undefined, args);
  }

  if (false) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type;

  if (false) {
    var error = new Error();

    if (error.stack) {
      // chrome
      var match = error.stack.match(/at jsx.*\n\s+at ([A-Z][A-Za-z]+) /);

      if (!match) {
        // safari and firefox
        match = error.stack.match(/^.*\n([A-Z][A-Za-z]+)@/);
      }

      if (match) {
        newProps[labelPropName] = match[1];
      }
    }
  }

  createElementArgArray[1] = newProps;

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"].apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false;
var Global =
/* #__PURE__ */
withEmotionCache(function (props, cache) {
  if (false) {
    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
    warnedAboutCssPropForGlobal = true;
  }

  var styles = props.styles;

  if (typeof styles === 'function') {
    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(ThemeContext.Consumer, null, function (theme) {
      var serialized = Object(__WEBPACK_IMPORTED_MODULE_4__emotion_serialize__["a" /* serializeStyles */])([styles(theme)]);
      return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(InnerGlobal, {
        serialized: serialized,
        cache: cache
      });
    });
  }

  var serialized = Object(__WEBPACK_IMPORTED_MODULE_4__emotion_serialize__["a" /* serializeStyles */])([styles]);
  return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(InnerGlobal, {
    serialized: serialized,
    cache: cache
  });
});

// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var InnerGlobal =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose___default()(InnerGlobal, _React$Component);

  function InnerGlobal(props, context, updater) {
    return _React$Component.call(this, props, context, updater) || this;
  }

  var _proto = InnerGlobal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.sheet = new __WEBPACK_IMPORTED_MODULE_5__emotion_sheet__["a" /* StyleSheet */]({
      key: this.props.cache.key + "-global",
      nonce: this.props.cache.sheet.nonce,
      container: this.props.cache.sheet.container
    }); // $FlowFixMe

    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");

    if (node !== null) {
      this.sheet.tags.push(node);
    }

    if (this.props.cache.sheet.tags.length) {
      this.sheet.before = this.props.cache.sheet.tags[0];
    }

    this.insertStyles();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.serialized.name !== this.props.serialized.name) {
      this.insertStyles();
    }
  };

  _proto.insertStyles = function insertStyles$1() {
    if (this.props.serialized.next !== undefined) {
      // insert keyframes
      Object(__WEBPACK_IMPORTED_MODULE_3__emotion_utils__["b" /* insertStyles */])(this.props.cache, this.props.serialized.next, true);
    }

    if (this.sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
      this.sheet.before = element;
      this.sheet.flush();
    }

    this.props.cache.insert("", this.props.serialized, this.sheet, false);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.sheet.flush();
  };

  _proto.render = function render() {

    return null;
  };

  return InnerGlobal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var keyframes = function keyframes() {
  var insertable = __WEBPACK_IMPORTED_MODULE_6__emotion_css__["a" /* default */].apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_utils__["a" /* getRegisteredStyles */])(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var ClassNames = withEmotionCache(function (props, context) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(ThemeContext.Consumer, null, function (theme) {
    var hasRendered = false;

    var css = function css() {
      if (hasRendered && "production" !== 'production') {
        throw new Error('css can only be used during render');
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = Object(__WEBPACK_IMPORTED_MODULE_4__emotion_serialize__["a" /* serializeStyles */])(args, context.registered);

      {
        Object(__WEBPACK_IMPORTED_MODULE_3__emotion_utils__["b" /* insertStyles */])(context, serialized, false);
      }

      return context.key + "-" + serialized.name;
    };

    var cx = function cx() {
      if (hasRendered && "production" !== 'production') {
        throw new Error('cx can only be used during render');
      }

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return merge(context.registered, css, classnames(args));
    };

    var content = {
      css: css,
      cx: cx,
      theme: theme
    };
    var ele = props.children(content);
    hasRendered = true;

    return ele;
  });
});




/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getScrollParent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getScrollTop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return animatedScrollTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isMobileDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isDocumentElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return cleanValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getBoundingClientObj; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return scrollIntoView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isTouchCapable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return classNames; });
/* unused harmony export k */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return scrollTo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raf__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_raf__);



// ==============================
// NO OP
// ==============================
var noop = function noop() {};
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/

function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}

function classNames(prefix, state, className) {
  var arr = [className];

  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }

  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
} // ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(value) === 'object' && value !== null) return [value];
  return [];
}; // ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var newValue = onInputChange(inputValue, actionMeta);
    if (typeof newValue === 'string') return newValue;
  }

  return inputValue;
} // ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }

  return el.scrollTop;
}
function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }

  el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  var docEl = document.documentElement; // suck it, flow...

  if (style.position === 'fixed') return docEl;

  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);

    if (excludeStaticParent && style.position === 'static') {
      continue;
    }

    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return docEl;
} // Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/

function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}

function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;

  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);

    if (currentTime < duration) {
      __WEBPACK_IMPORTED_MODULE_1_raf___default()(animateScroll);
    } else {
      callback(element);
    }
  }

  animateScroll();
} // Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect

function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
} // ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
}




/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/signupicon.86731fc1.png";

/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var options=[{label:'Class 1',value:1},{label:'Class 2',value:2},{label:'Class 3',value:3},{label:'Class 4',value:4},{label:'Class 5',value:5},{label:'Class 6',value:6},{label:'Class 7',value:7},{label:'Class 8',value:8},{label:'Class 9',value:9},{label:'Class 10',value:10},{label:'Class 11',value:11},{label:'Class 12',value:12}];var SelectDropdown=function(_PreLoginPage){_inherits(SelectDropdown,_PreLoginPage);function SelectDropdown(props){_classCallCheck(this,SelectDropdown);var _this=_possibleConstructorReturn(this,(SelectDropdown.__proto__||Object.getPrototypeOf(SelectDropdown)).call(this,props));_this.state={};_this.handleChange=_this.handleChange.bind(_this);return _this;}_createClass(SelectDropdown,[{key:'handleChange',value:function handleChange(e){if(typeof this.props.callBack==="function"){this.props.callBack(e);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */],{closeMenuOnSelect:false,isMulti:true,onChange:this.handleChange,options:options});}}]);return SelectDropdown;}(__WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (SelectDropdown);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RadioButtons=function(_PreLoginPage){_inherits(RadioButtons,_PreLoginPage);function RadioButtons(){_classCallCheck(this,RadioButtons);var _this=_possibleConstructorReturn(this,(RadioButtons.__proto__||Object.getPrototypeOf(RadioButtons)).call(this));_this.state={selectedOption:''};//this.radioChange = this.radioChange.bind(this);
return _this;}_createClass(RadioButtons,[{key:'radioChange',value:function radioChange(e){if(typeof this.props.callBack==="function"){this.props.callBack(e);}console.log("radioChange");console.log(e.target.value," ",e.value);this.setState({selectedOption:e.target.value});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 radio-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'radio-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',value:'Yes',checked:this.state.selectedOption==="Yes",onChange:this.radioChange.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'radio-label'},' Yes'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-2 radio-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'radio-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',value:'No',checked:this.state.selectedOption==="No",onChange:this.radioChange.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'radio-label'},' No'))));}}]);return RadioButtons;}(__WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (RadioButtons);

/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports = {"countryList":[{"countryID":"AF","countryName":"Afghanistan"},{"countryID":"AX","countryName":"Aland Islands"},{"countryID":"AL","countryName":"Albania"},{"countryID":"DZ","countryName":"Algeria"},{"countryID":"AS","countryName":"American Samoa"},{"countryID":"AD","countryName":"Andorra"},{"countryID":"AO","countryName":"Angola"},{"countryID":"AI","countryName":"Anguilla"},{"countryID":"AQ","countryName":"Antarctica"},{"countryID":"AG","countryName":"Antigua and Barbuda"},{"countryID":"AR","countryName":"Argentina"},{"countryID":"AM","countryName":"Armenia"},{"countryID":"AW","countryName":"Aruba"},{"countryID":"AU","countryName":"Australia"},{"countryID":"AT","countryName":"Austria"},{"countryID":"AZ","countryName":"Azerbaijan"},{"countryID":"BS","countryName":"Bahamas"},{"countryID":"BH","countryName":"Bahrain"},{"countryID":"BD","countryName":"Bangladesh"},{"countryID":"BB","countryName":"Barbados"},{"countryID":"BY","countryName":"Belarus"},{"countryID":"BE","countryName":"Belgium"},{"countryID":"BZ","countryName":"Belize"},{"countryID":"BJ","countryName":"Benin"},{"countryID":"BM","countryName":"Bermuda"},{"countryID":"BT","countryName":"Bhutan"},{"countryID":"BO","countryName":"Bolivia"},{"countryID":"BQ","countryName":"Bonaire"},{"countryID":"BA","countryName":"Bosnia and Herzegovina"},{"countryID":"BW","countryName":"Botswana"},{"countryID":"BV","countryName":"Bouvet Island"},{"countryID":"BR","countryName":"Brazil"},{"countryID":"IO","countryName":"British Indian Ocean Territory"},{"countryID":"VG","countryName":"British Virgin Islands"},{"countryID":"BN","countryName":"Brunei Darussalam"},{"countryID":"BG","countryName":"Bulgaria"},{"countryID":"BF","countryName":"Burkina Faso"},{"countryID":"BI","countryName":"Burundi"},{"countryID":"KH","countryName":"Cambodia"},{"countryID":"CM","countryName":"Cameroon"},{"countryID":"CA","countryName":"Canada"},{"countryID":"CV","countryName":"Cape Verde"},{"countryID":"KY","countryName":"Cayman Islands"},{"countryID":"CF","countryName":"Central African Republic"},{"countryID":"TD","countryName":"Chad"},{"countryID":"CL","countryName":"Chile"},{"countryID":"CN","countryName":"China"},{"countryID":"CX","countryName":"Christmas Island"},{"countryID":"CC","countryName":"Cocos Islands"},{"countryID":"CO","countryName":"Colombia"},{"countryID":"KM","countryName":"Comoros"},{"countryID":"CG","countryName":"Congo"},{"countryID":"CK","countryName":"Cook Islands"},{"countryID":"CR","countryName":"Costa Rica"},{"countryID":"CI","countryName":"Cote dIvoire"},{"countryID":"HR","countryName":"Croatia"},{"countryID":"CU","countryName":"Cuba"},{"countryID":"CW","countryName":"Curacao"},{"countryID":"CY","countryName":"Cyprus"},{"countryID":"CZ","countryName":"Czech Republic"},{"countryID":"CD","countryName":"Democratic Republic of the Congo"},{"countryID":"DK","countryName":"Denmark"},{"countryID":"DJ","countryName":"Djibouti"},{"countryID":"DM","countryName":"Dominica"},{"countryID":"DO","countryName":"Dominican Republic"},{"countryID":"TL","countryName":"East Timor"},{"countryID":"EC","countryName":"Ecuador"},{"countryID":"EG","countryName":"Egypt"},{"countryID":"SV","countryName":"El Salvador"},{"countryID":"GQ","countryName":"Equatorial Guinea"},{"countryID":"ER","countryName":"Eritrea"},{"countryID":"EE","countryName":"Estonia"},{"countryID":"ET","countryName":"Ethiopia"},{"countryID":"FK","countryName":"Falkland Islands"},{"countryID":"FO","countryName":"Faroe Islands"},{"countryID":"FM","countryName":"Federated States of Micronesia"},{"countryID":"FJ","countryName":"Fiji"},{"countryID":"FI","countryName":"Finland"},{"countryID":"FR","countryName":"France"},{"countryID":"GF","countryName":"French Guiana"},{"countryID":"PF","countryName":"French Polynesia"},{"countryID":"TF","countryName":"French Southern Territories"},{"countryID":"GA","countryName":"Gabon"},{"countryID":"GM","countryName":"Gambia"},{"countryID":"GE","countryName":"Georgia"},{"countryID":"DE","countryName":"Germany"},{"countryID":"GH","countryName":"Ghana"},{"countryID":"GI","countryName":"Gibraltar"},{"countryID":"GR","countryName":"Greece"},{"countryID":"GL","countryName":"Greenland"},{"countryID":"GD","countryName":"Grenada"},{"countryID":"GP","countryName":"Guadeloupe"},{"countryID":"GU","countryName":"Guam"},{"countryID":"GT","countryName":"Guatemala"},{"countryID":"GG","countryName":"Guernsey"},{"countryID":"GN","countryName":"Guinea"},{"countryID":"GW","countryName":"Guinea Bissau"},{"countryID":"GY","countryName":"Guyana"},{"countryID":"HT","countryName":"Haiti"},{"countryID":"HM","countryName":"Heard Island and McDonald Islands"},{"countryID":"HN","countryName":"Honduras"},{"countryID":"HK","countryName":"Hong Kong"},{"countryID":"HU","countryName":"Hungary"},{"countryID":"IS","countryName":"Iceland"},{"countryID":"IN","countryName":"India"},{"countryID":"ID","countryName":"Indonesia"},{"countryID":"IR","countryName":"Iran"},{"countryID":"IQ","countryName":"Iraq"},{"countryID":"IE","countryName":"Ireland"},{"countryID":"IM","countryName":"Isle of Man"},{"countryID":"IL","countryName":"Israel"},{"countryID":"IT","countryName":"Italy"},{"countryID":"JM","countryName":"Jamaica"},{"countryID":"JP","countryName":"Japan"},{"countryID":"JE","countryName":"Jersey"},{"countryID":"JO","countryName":"Jordan"},{"countryID":"KZ","countryName":"Kazakhstan"},{"countryID":"KE","countryName":"Kenya"},{"countryID":"KI","countryName":"Kiribati"},{"countryID":"KW","countryName":"Kuwait"},{"countryID":"KG","countryName":"Kyrgyzstan"},{"countryID":"LA","countryName":"Laos"},{"countryID":"LV","countryName":"Latvia"},{"countryID":"LB","countryName":"Lebanon"},{"countryID":"LS","countryName":"Lesotho"},{"countryID":"LR","countryName":"Liberia"},{"countryID":"LY","countryName":"Libya"},{"countryID":"LI","countryName":"Liechtenstein"},{"countryID":"LT","countryName":"Lithuania"},{"countryID":"LU","countryName":"Luxembourg"},{"countryID":"MO","countryName":"Macao"},{"countryID":"MG","countryName":"Madagascar"},{"countryID":"MW","countryName":"Malawi"},{"countryID":"MY","countryName":"Malaysia"},{"countryID":"MV","countryName":"Maldives"},{"countryID":"ML","countryName":"Mali"},{"countryID":"MT","countryName":"Malta"},{"countryID":"MH","countryName":"Marshall Islands"},{"countryID":"MQ","countryName":"Martinique"},{"countryID":"MR","countryName":"Mauritania"},{"countryID":"MU","countryName":"Mauritius"},{"countryID":"YT","countryName":"Mayotte"},{"countryID":"MX","countryName":"Mexico"},{"countryID":"MD","countryName":"Moldova"},{"countryID":"MC","countryName":"Monaco"},{"countryID":"MN","countryName":"Mongolia"},{"countryID":"ME","countryName":"Montenegro"},{"countryID":"MS","countryName":"Montserrat"},{"countryID":"MA","countryName":"Morocco"},{"countryID":"MZ","countryName":"Mozambique"},{"countryID":"MM","countryName":"Myanmar"},{"countryID":"NA","countryName":"Namibia"},{"countryID":"NR","countryName":"Nauru"},{"countryID":"NP","countryName":"Nepal"},{"countryID":"NL","countryName":"Netherlands"},{"countryID":"NC","countryName":"New Caledonia"},{"countryID":"NZ","countryName":"New Zealand"},{"countryID":"NI","countryName":"Nicaragua"},{"countryID":"NE","countryName":"Niger"},{"countryID":"NG","countryName":"Nigeria"},{"countryID":"NU","countryName":"Niue"},{"countryID":"NF","countryName":"Norfolk Island"},{"countryID":"KP","countryName":"North Korea"},{"countryID":"MP","countryName":"Northern Mariana Islands"},{"countryID":"NO","countryName":"Norway"},{"countryID":"OM","countryName":"Oman"},{"countryID":"PK","countryName":"Pakistan"},{"countryID":"PW","countryName":"Palau"},{"countryID":"PS","countryName":"Palestine"},{"countryID":"PA","countryName":"Panama"},{"countryID":"PG","countryName":"Papua New Guinea"},{"countryID":"PY","countryName":"Paraguay"},{"countryID":"PE","countryName":"Peru"},{"countryID":"PH","countryName":"Philippines"},{"countryID":"PN","countryName":"Pitcairn"},{"countryID":"PL","countryName":"Poland"},{"countryID":"PT","countryName":"Portugal"},{"countryID":"PR","countryName":"Puerto Rico"},{"countryID":"QA","countryName":"Qatar"},{"countryID":"MK","countryName":"Republic of Macedonia"},{"countryID":"RE","countryName":"Reunion"},{"countryID":"RO","countryName":"Romania"},{"countryID":"RU","countryName":"Russian Federation"},{"countryID":"RW","countryName":"Rwanda"},{"countryID":"BL","countryName":"Saint Barthelemy"},{"countryID":"SH","countryName":"Saint Helena"},{"countryID":"KN","countryName":"Saint Kitts and Nevis"},{"countryID":"LC","countryName":"Saint Lucia"},{"countryID":"MF","countryName":"Saint Martin"},{"countryID":"PM","countryName":"Saint Pierre and Miquelon"},{"countryID":"VC","countryName":"Saint Vincent and the Grenadines"},{"countryID":"WS","countryName":"Samoa"},{"countryID":"SM","countryName":"San Marino"},{"countryID":"ST","countryName":"Sao Tome and Principe"},{"countryID":"SA","countryName":"Saudi Arabia"},{"countryID":"SN","countryName":"Senegal"},{"countryID":"CS","countryName":"Serbia"},{"countryID":"SC","countryName":"Seychelles"},{"countryID":"SL","countryName":"Sierra Leone"},{"countryID":"SG","countryName":"Singapore"},{"countryID":"SX","countryName":"Sint Maarten Dutch part"},{"countryID":"SK","countryName":"Slovakia"},{"countryID":"SI","countryName":"Slovenia"},{"countryID":"SB","countryName":"Solomon Islands"},{"countryID":"SO","countryName":"Somalia"},{"countryID":"ZA","countryName":"South Africa"},{"countryID":"GS","countryName":"South Georgia and the South Sandwich Islands"},{"countryID":"KR","countryName":"South Korea"},{"countryID":"SS","countryName":"South Sudan"},{"countryID":"ES","countryName":"Spain"},{"countryID":"LK","countryName":"Sri Lanka"},{"countryID":"SD","countryName":"Sudan"},{"countryID":"SR","countryName":"Suriname"},{"countryID":"SJ","countryName":"Svalbard and Jan Mayen"},{"countryID":"SZ","countryName":"Swaziland"},{"countryID":"SE","countryName":"Sweden"},{"countryID":"CH","countryName":"Switzerland"},{"countryID":"SY","countryName":"Syrian Arab Republic"},{"countryID":"TW","countryName":"Taiwan"},{"countryID":"TJ","countryName":"Tajikistan"},{"countryID":"TZ","countryName":"Tanzania"},{"countryID":"TH","countryName":"Thailand"},{"countryID":"TG","countryName":"Togo"},{"countryID":"TK","countryName":"Tokelau"},{"countryID":"TO","countryName":"Tonga"},{"countryID":"TT","countryName":"Trinidad and Tobago"},{"countryID":"TN","countryName":"Tunisia"},{"countryID":"TR","countryName":"Turkey"},{"countryID":"TM","countryName":"Turkmenistan"},{"countryID":"TC","countryName":"Turks and Caicos Islands"},{"countryID":"TV","countryName":"Tuvalu"},{"countryID":"UG","countryName":"Uganda"},{"countryID":"UA","countryName":"Ukraine"},{"countryID":"AE","countryName":"United Arab Emirates"},{"countryID":"GB","countryName":"United Kingdom"},{"countryID":"US","countryName":"United States"},{"countryID":"UM","countryName":"United States Minor Outlying Islands"},{"countryID":"VI","countryName":"United States Virgin Islands"},{"countryID":"UY","countryName":"Uruguay"},{"countryID":"UZ","countryName":"Uzbekistan"},{"countryID":"VU","countryName":"Vanuatu"},{"countryID":"VA","countryName":"Vatican City"},{"countryID":"VE","countryName":"Venezuela"},{"countryID":"VN","countryName":"VietNam"},{"countryID":"WF","countryName":"Wallis and Futuna"},{"countryID":"EH","countryName":"Western Sahara"},{"countryID":"YE","countryName":"Yemen"},{"countryID":"ZM","countryName":"Zambia"},{"countryID":"ZW","countryName":"Zimbabwe"}]}

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_id_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal_video__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal_video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_modal_video__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_login_UserLoginType__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_login_Whatsapp_js__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_ProductConfig_json__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_ProductConfig_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__config_ProductConfig_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Productbox__ = __webpack_require__(1132);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var Banner=function(_PreLoginPage){_inherits(Banner,_PreLoginPage);function Banner(props){_classCallCheck(this,Banner);var _this=_possibleConstructorReturn(this,(Banner.__proto__||Object.getPrototypeOf(Banner)).call(this,props));_this.state={isOpen:false};_this.openModal=_this.openModal.bind(_this);_this.isFreeTrialAllowed=_this.isFreeTrialAllowed.bind(_this);return _this;}_createClass(Banner,[{key:'openModal',value:function openModal(){this.setState({isOpen:true});}},{key:'homeforweb',value:function homeforweb(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slider-inner b-web-comp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 b-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Productbox__["a" /* default */],{device:"web",products_category_order:this.props.products_category_order,products_category:this.props.products_category,classes:this.props.classes,grades:this.props.grades,products_class:this.props.products_class}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 b-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'heading-one'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt first-line'},this.rb("banner.heading")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hmorg'},'Hey'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hmblue'},'Math! '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt furtxt'},this.rb("banner.subheading"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'heading-two'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'wrdcls'},this.rb("banner.subheading1"))),function(){if(_this2.props.PLPloggedIn){if(_this2.isFreeTrialAllowed()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'paddtri'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#','data-ga':'Home - Best Math Teacher - Free Trial',className:'r-btn',onClick:_this2.props.startFreeTrial},'Start your Free Trial'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__views_login_Whatsapp_js__["a" /* default */],{align:'left',maxWidth:'285px'},'/'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null);}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 nopadding mx-auto joingrp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__views_login_UserLoginType__["a" /* default */],{showSignUp:_this2.props.showSignUp,showNewLoginForm:_this2.props.showNewLoginForm,from:"Top"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__views_login_Whatsapp_js__["a" /* default */],{align:'left',maxWidth:'100%'},'/'));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nottxt'}))));}},{key:'isFreeTrialAllowed',value:function isFreeTrialAllowed(){var userRole=this.getUser().getRole();if(userRole&&userRole.length>1&&window.noFreeTrialRoles&&window.noFreeTrialRoles.length>0){return!~window.noFreeTrialRoles.indexOf(userRole);}//user not logged in or role not defined latter is unlikely or no suppression in window.noFreeTrialRoles
return true;}},{key:'homeformobile',value:function homeformobile(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comp-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-center b-comp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt'},this.rb("banner.heading"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hmorg'},'Hey'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hmblue'},'Math! '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt furtxt'},this.rb("banner.subheading")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wrdcls'},this.rb("banner.subheading1")),function(){if(_this3.props.PLPloggedIn){if(_this3.isFreeTrialAllowed()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'paddtri'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#','data-ga':'Home - Best Math Teacher - Free Trial',className:'r-btn',onClick:_this3.props.startFreeTrial},'Start your Free Trial'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__views_login_Whatsapp_js__["a" /* default */],{align:'center',background:"#30BDBD",maxWidth:'100%'},'/'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null);}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 nopadding mx-auto joingrp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__views_login_UserLoginType__["a" /* default */],{showSignUp:_this3.props.showSignUp,showNewLoginForm:_this3.props.showNewLoginForm,from:"Top"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__views_login_Whatsapp_js__["a" /* default */],{align:'center',background:"#30BDBD",maxWidth:'100%'},'/'));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nottxt'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Productbox__["a" /* default */],{device:"mobile",products_category_order:this.props.products_category_order,products_category:this.props.products_category,classes:this.props.classes,grades:this.props.grades,products_class:this.props.products_class}))));}},{key:'homecomponent',value:function homecomponent(){var _this4=this;if(this.isMobile()||this.isTab()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'h-mob-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-container home-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},this.homeformobile())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-pagination'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_modal_video___default.a,{channel:'youtube',isOpen:this.state.isOpen,videoId:'b-X5TsIQG24',onClose:function onClose(){return _this4.setState({isOpen:false});}}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'h-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-container home-bannerweb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},this.homeforweb())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-pagination'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_modal_video___default.a,{channel:'youtube',isOpen:this.state.isOpen,videoId:'b-X5TsIQG24',onClose:function onClose(){return _this4.setState({isOpen:false});}}));}}},{key:'render',value:function render(){console.log("plplogin:::"+this.props.PLPloggedIn);var params={pagination:{el:'.swiper-pagination',clickable:true}};return this.homecomponent();}}]);return Banner;}(__WEBPACK_IMPORTED_MODULE_9__views_core_PreLoginPage__["a" /* default */]);/*ReactDOM.render(<Banner />, document.getElementById('root'));*//* harmony default export */ __webpack_exports__["a"] = (Banner);

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_login_UserLoginType__ = __webpack_require__(121);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var SignupSection=function(_PreLoginSessionCheck){_inherits(SignupSection,_PreLoginSessionCheck);function SignupSection(){_classCallCheck(this,SignupSection);return _possibleConstructorReturn(this,(SignupSection.__proto__||Object.getPrototypeOf(SignupSection)).apply(this,arguments));}_createClass(SignupSection,[{key:'isFreeTrialAllowed',value:function isFreeTrialAllowed(){var userRole=this.getUser().getRole();if(userRole&&userRole.length>1&&window.noFreeTrialRoles&&window.noFreeTrialRoles.length>0){return!~window.noFreeTrialRoles.indexOf(userRole);}//user not logged in or role not defined latter is unlikely or no suppression in window.noFreeTrialRoles
return true;}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{'data-p-ga':'',className:'mtb child'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Give your child '),'timely support in Maths'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hmorg'},'Hey'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hmblue'},'Math!'),' is like having the best tutor at home!'),function(){if(_this2.props.PLPloggedIn){if(_this2.isFreeTrialAllowed()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Home - Give your child an Edge - Free Trial',href:'#',className:'r-btn big-btn',onClick:_this2.props.startFreeTrial},'Start your Free Trial');}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null);}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-5 mx-auto text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__views_login_UserLoginType__["a" /* default */],{showSignUp:_this2.props.showSignUp,showNewLoginForm:_this2.props.showNewLoginForm,from:"Bottom"}));}}()));}}]);return SignupSection;}(__WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (SignupSection);

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warn;
function warn(s) {
  console.warn('[react-ga]', s);
}

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_if_elseif_else_render__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_if_elseif_else_render___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_if_elseif_else_render__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_ProductConfig_json__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_ProductConfig_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__config_ProductConfig_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var proClass='';// ES6 class-style
var Footer=function(_PreLoginPage){_inherits(Footer,_PreLoginPage);function Footer(props){_classCallCheck(this,Footer);var _this=_possibleConstructorReturn(this,(Footer.__proto__||Object.getPrototypeOf(Footer)).call(this,props));_this.geoBasedProductHeader=function(){var me=_this;if(_this.prodForCountry()==='IN'){return me.renderProductTab();}else if(_this.prodForCountry()==='SG'){return me.SgCatalogue();}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,me.renderProductTab(),me.SgCatalogue());}};_this.getFooterProduct=function(product){var me=_this;if(_this.prodForCountry()!=='SG'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,me.rb(product)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'Lessons-links'},me.grades.map(function(grade){return me.renderFooterProduct(product,grade);})));}};_this.state={error:null,isLoaded:false,items:[],ProductList:[],pro_detail:[],products:[],self:[],plp:[],products_details:{},products_category_order:[]};_this.grades=_this.props.grades;_this.productClass=_this.props.products_class;_this.productDetails=_this.props.products_details;_this.products_category=_this.props.products_category;_this.productClasses=_this.props.classes;_this.state.products=Object.keys(_this.products_category);_this.renderFooterProduct=_this.renderFooterProduct.bind(_this);_this.restricted=false;_this.userObj=null;_this.restrictedCategories=window.footerRestrictedProdCategories||[];return _this;}_createClass(Footer,[{key:'componentDidMount',value:function componentDidMount(){//console.warn("IN Footer");
var _state=this.state,products=_state.products,self=_state.self,plp=_state.plp;this.grades=this.props.grades;this.productClass=this.props.products_class;this.productDetails=this.props.products_details;this.products_category=this.props.products_category;this.productClasses=this.props.classes;this.state.products=Object.keys(this.products_category);//HmEventRegistry.fireEvent("INITIATE_GA");
}},{key:'componentDidUpdate',value:function componentDidUpdate(){__WEBPACK_IMPORTED_MODULE_6__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");}},{key:'getProdDetails',value:function getProdDetails(){//console.log(this.state.products_details);
if(this.state.products_details!=={}&&this.state.products_details!==undefined){return this.state.products_details;}}},{key:'saveID',value:function saveID(grade,proID,link){var products_details=this.state.products_details;var me=this;var callBackSuccess=function callBackSuccess(result){if(result!==null){me.setState({products_details:result}),//console.log("Footer:::",me.getProdDetails());
localStorage.setItem('grade',grade);localStorage.setItem('product',proID);localStorage.setItem('proDetail',JSON.stringify(me.getProdDetails()));window.top.location.href=link;}//console.log("response : ", response);
};var callBackFailure=function callBackFailure(response){me.setState({isLoaded:true,error:"Error in Footer PRODUCT_JSON"});console.log("Error in Footer PRODUCT_JSON in Grade");};var formData={"levelId":grade};new __WEBPACK_IMPORTED_MODULE_5__util_HmAjax__["a" /* default */](this.getUrlFor("PRODUCT_JSON"),formData).post(callBackSuccess,callBackFailure);//console.log(grade);
//console.log(proID);
}},{key:'renderFooterProduct',value:function renderFooterProduct(product,grade){var _this2=this;//console.log(product,", ",grade,", ",this.productClasses);
if(product&&grade&&this.products_category&&this.products_category[product]&&this.products_category[product].hasOwnProperty(grade)){var restricted="";if(this.GradeRestrictionManager.isGradeRestricted(grade)){restricted="restricted";this.restricted=true;}if(__WEBPACK_IMPORTED_MODULE_7__config_ProductConfig_json___default.a[product]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:restricted,key:grade,'data-ga':'Footer - '+__WEBPACK_IMPORTED_MODULE_7__config_ProductConfig_json___default.a[product].ganame+' - '+this.productClasses[grade].ClassName,onClick:function onClick(){return _this2.saveID(''+grade,''+_this2.products_category[product][grade],__WEBPACK_IMPORTED_MODULE_7__config_ProductConfig_json___default.a[product].url+_this2.products_category[product][grade]);}},this.productClasses[grade].ClassName,function(){if(restricted=="restricted"){return"*";}}());}}}},{key:'checkRestrictedGrade',value:function checkRestrictedGrade(product,grades){//console.log("grades:::",grades, ", ",product);
//console.log(this.products_category, ", ",product,", ",this.products_category[product],", ",this.products_category[product].hasOwnProperty("11"));
var restrictedAvailable=false;var restrictedGrades=[];if(grades&&grades.length>0){for(var i=0;i<grades.length;i++){if(this.products_category&&this.products_category[product]&&this.products_category[product].hasOwnProperty(grades[i])){if(this.GradeRestrictionManager.isGradeRestricted(grades[i])){restrictedGrades.push(grades[i]);}}}try{restrictedAvailable=restrictedGrades.length===Object.keys(this.products_category[product]).length;}catch(e){}}else{restrictedAvailable=true;}return restrictedAvailable;}},{key:'getUserRole',value:function getUserRole(){var role='';if(this.UserStore){if(this.getUser()&&this.getUser().get()){role=this.getUser().get().userRole.role;}}//console.log("role ",role);
return role;}},{key:'renderProductTab',value:function renderProductTab(){var geoLocation=this.getGeo().toUpperCase()||'';if(this.getUserRole()=="TCHR"&&geoLocation==='IN'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'Footer - Products'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{to:'/in/products'},this.rb("in.products.students.title"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'Footer - Products'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{to:'/sg/products'},this.rb("sg.products.title"))));}}},{key:'renderTeacherTab',value:function renderTeacherTab(){if(this.getUserRole()=="TCHR"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'Footer - Teachers'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{to:'/teachers'},'Teachers'));}// if(window.teachers_tab_suppressed){
// 	return(<li></li>);
// }	
}},{key:'SgCatalogue',value:function SgCatalogue(){if(this.getUserRole()=="TCHR"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'Footer - SgCatalogue'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{to:'/sg'},this.rb("sg.products.title")));}}},{key:'renderLessonsTab',value:function renderLessonsTab(){var _this3=this;var me=this;if(me.getUserRole()!="TCHR"){return me.state.products_category_order.map(function(product){//if(this.checkRestrictedGrade(product,this.grades) == false){
if(!me.restrictedCategories||me.restrictedCategories.length===0||me.restrictedCategories.length>0&&me.restrictedCategories.indexOf(product)<0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-3 no-padding',key:product},_this3.getFooterProduct(product));}});//}
}}},{key:'render',value:function render(){var telPhoneNo=window.telPhoneNo[this.getGeo()]||window.telPhoneNo['OTHERS']||'+91 44 3500 2073';var _state2=this.state,products=_state2.products,self=_state2.self,plp=_state2.plp;this.grades=this.props.grades;this.grades_order=this.props.grades_order;this.productClass=this.props.products_class;this.productDetails=this.props.products_details;this.products_category=this.props.products_category;this.productClasses=this.props.classes;this.state.products=Object.keys(this.products_category);this.state.products_category_order=this.props.products_category_order;var tifOptions=[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row grade-links'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'f-links atag'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'Footer - Home'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{to:'/'},'Home')),this.renderProductTab(),this.renderTeacherTab(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'Footer - Who we are'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{to:'/who-we-are'},'Who We Are')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'Footer - Our Learnings'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{to:'/our-learnings'},'Our Learnings')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'Footer - Spotlight'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{to:'/spotlight'},'Spotlight')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'Footer - FAQ'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{to:'/faq'},this.rb("FAQ"))))),this.renderLessonsTab()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row follow-us'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-4 col-md-5 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'follow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Follow us on'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Footer - Follow Us - Facebook',href:'https://www.facebook.com/heymath',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fab fa-facebook-f'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Footer - Follow Us - Twitter',href:'http://twitter.com/heymath',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fab fa-twitter'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Footer - Follow Us - Linkedin',href:'http://linkedin.com/company/heymath',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fab fa-linkedin-in'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Footer - Follow Us - Youtube',href:'http://bit.ly/HeyMathYouTube',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fab fa-youtube'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Footer - Follow Us - Instagram',href:'https://www.instagram.com/heymath_india/',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fab fa-instagram'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-4 col-md norightpadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-link text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Footer - Phone number',href:"tel:"+telPhoneNo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/tel.png',alt:''}),' ',telPhoneNo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-link text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Footer - Email ID',href:'mailto:support@heymath.com'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/mail.png',alt:''}),' support@heymath.com'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-4 col-md nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-link text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'data-ga':'Footer - Contact Us',className:'r-btn contactbtn',onClick:this.props.showContactus},'Contact us')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 text-link '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-left'},'All rights reserved \xA9 ',this.rb("footer.copyright.year"),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'HeyMath!'),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 text-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Footer - Terms',href:this.getTermsUrl("IN"),target:'_blank'},' Terms of Use'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'|'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Footer - Privacy Policy',href:this.getUrlFor("LUMOS_PRIVACY"),target:'_blank'},' Privacy Policy')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 text-link'}))));}}]);return Footer;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1181);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Else = exports.ElseIf = exports.Then = exports.If = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var If = exports.If = function (_Component) {
  _inherits(If, _Component);

  function If() {
    _classCallCheck(this, If);

    return _possibleConstructorReturn(this, (If.__proto__ || Object.getPrototypeOf(If)).apply(this, arguments));
  }

  _createClass(If, [{
    key: 'render',
    value: function render() {
      var children = [];
      if (this.props.children != null) {
        if (this.props.children.constructor === Array) {
          children = this.props.children;
        } else {
          children.push(this.props.children);
        }
      }

      if (this.props.condition) {
        return children.find(function (item) {
          return item.type.name == Then.name;
        });
      }

      var elseIf = children.find(function (item) {
        return item.type.name == ElseIf.name && item.props.condition;
      });
      if (elseIf != null) {
        return elseIf;
      }

      return children.filter(function (item) {
        return item.type.name == Else.name;
      });
    }
  }]);

  return If;
}(_react.Component);

var SubRenderComponent = function (_Component2) {
  _inherits(SubRenderComponent, _Component2);

  function SubRenderComponent() {
    _classCallCheck(this, SubRenderComponent);

    return _possibleConstructorReturn(this, (SubRenderComponent.__proto__ || Object.getPrototypeOf(SubRenderComponent)).apply(this, arguments));
  }

  _createClass(SubRenderComponent, [{
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return SubRenderComponent;
}(_react.Component);

var Then = exports.Then = function (_SubRenderComponent) {
  _inherits(Then, _SubRenderComponent);

  function Then() {
    _classCallCheck(this, Then);

    return _possibleConstructorReturn(this, (Then.__proto__ || Object.getPrototypeOf(Then)).apply(this, arguments));
  }

  return Then;
}(SubRenderComponent);

var ElseIf = exports.ElseIf = function (_SubRenderComponent2) {
  _inherits(ElseIf, _SubRenderComponent2);

  function ElseIf() {
    _classCallCheck(this, ElseIf);

    return _possibleConstructorReturn(this, (ElseIf.__proto__ || Object.getPrototypeOf(ElseIf)).apply(this, arguments));
  }

  return ElseIf;
}(SubRenderComponent);

var Else = exports.Else = function (_SubRenderComponent3) {
  _inherits(Else, _SubRenderComponent3);

  function Else() {
    _classCallCheck(this, Else);

    return _possibleConstructorReturn(this, (Else.__proto__ || Object.getPrototypeOf(Else)).apply(this, arguments));
  }

  return Else;
}(SubRenderComponent);

/***/ })
/******/ ]);

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;

var _exenv = __webpack_require__(1212);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var PageBanner=function(_PreLoginSessionCheck){_inherits(PageBanner,_PreLoginSessionCheck);function PageBanner(){_classCallCheck(this,PageBanner);return _possibleConstructorReturn(this,(PageBanner.__proto__||Object.getPrototypeOf(PageBanner)).apply(this,arguments));}_createClass(PageBanner,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:this.props.classes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,this.props.name,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.text))));}}]);return PageBanner;}(__WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (PageBanner);

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAVCAYAAABc6S4mAAAAAXNSR0IArs4c6QAAA4RJREFUOBGNVM1vTFEUP+e+N+1MX5nRtCUiEQkRGysbseoGISE0GhLGRypELKwkdv4BEjZUVMViUBESQkT/APGxYiE+NiKSaqVm5s2b1sx71+/c926NeoOTvHfvPfd3vs+5TCm09MYNLwyCdaFSfU4UTU0fP/4yBfYba8nISF5FztqIdS+5/GlmePiNALgVtezatb7ZRuM8aR7URDnGrcZGcWb9zLHDr1uxdl+4enUlNfUFzXob4BnBs+KwM9u5fLJY/OpaYH50dLDeDC8TO73EQIEifGIEXvUZxoJf/sroUdJ0Tiu9SHydxxM5zTDsATw2sOT69U1hMxwn5Sj4DD4WQxonJnZVOWHML4Wxsd1RqK8IAk4l/BgPEc1RtiJMd8X4eK7i18Y0q0QrXGaawr/EzG8jrT5XDh18Na8Zm+WlUm919scl4EDmh0j5EysaRxjv4eCH6SP7vsitWw5mT5BSa+SgkUDF6kXUld1eHRqaEl4a+Y3wDID9Jt/IIdYnnT2FPdM7d1YX4l1UZIcJU26QRk2Z/f5flAtMM0EGAcfOVz3lFSdTlAtWhYpXR/BCPnLUu+rBve/koh2d1VqFrFYJXivIKfVisrj7azs8IuA8wjX3EdNMO6DlX3z8uBt4VBUGhPkPGc6VbvpAeUYBs1bE+yH+1Cr08vlgcsuWmj33PHq0uP698qurmOvosz3KoecWUyDyPw8N1eXM2Vu3fQCMAfFIYjGeya0QjMLXZx0dmQPlXbs+GgMV3xhIxcdSGAmecHIdRYXeN/k3NUCn2hWdhWLCHPovIt4412iWYlkZvKRmafhYTsGrzdFc8zJ33rmLFFFqBDaauEJEXYXFBW40dK1WT41gIR4dWnPRBUm3xf61psfu7ToXBF42k/E1ZCzZOznbvV3B8ly05vyNDBoyYgbOKPjDpRzYTTR3bODfeCZXvNEYLyF5LSIx0qoALSyKDCX6TZ3+Ay/OulLk+N20rycKGKsz0cQvpK1CcpE4YO/a4YXvSqfYnIoaI5Tosbm0a8KW6TXb/8GjnbhscgohYyhZTeoS44kT2stkKqv6++vkOA3TxmKoHR6ycKSMOVD3jLIWcLpBnpgaGPBfbdjQwBv0sNWZdDy601H33ai35zR9m5FeHUQt8xK7TYkUCUMWwPZEl86dlIER0ou6h6kaBBimreiA7t/xZjYreB0eRF721E9U/Xq0xQL5dwAAAABJRU5ErkJggg=="

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ScrollToTopOnMount=function(_Component){_inherits(ScrollToTopOnMount,_Component);function ScrollToTopOnMount(){_classCallCheck(this,ScrollToTopOnMount);return _possibleConstructorReturn(this,(ScrollToTopOnMount.__proto__||Object.getPrototypeOf(ScrollToTopOnMount)).apply(this,arguments));}_createClass(ScrollToTopOnMount,[{key:'componentDidMount',value:function componentDidMount(){window.scrollTo(0,0);}},{key:'render',value:function render(){return null;}}]);return ScrollToTopOnMount;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ScrollToTopOnMount);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BuyOption_js__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VideoComponent_js__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_centalogo_png__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_centalogo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_icons_centalogo_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var TeacherBannerBuy=function(_PreLoginSessionCheck){_inherits(TeacherBannerBuy,_PreLoginSessionCheck);function TeacherBannerBuy(props){_classCallCheck(this,TeacherBannerBuy);var _this=_possibleConstructorReturn(this,(TeacherBannerBuy.__proto__||Object.getPrototypeOf(TeacherBannerBuy)).call(this,props));_this.productDetails=localStorage.getItem('proDetail');_this.getBuyOptions=_this.getBuyOptions.bind(_this);return _this;}_createClass(TeacherBannerBuy,[{key:'getProductDetails',value:function getProductDetails(){//console.log(JSON.parse(this.productDetails));
if(this.productDetails!={}&&this.productDetails!=undefined){return JSON.parse(this.productDetails);}else{return{};}}},{key:'componentDidMount',value:function componentDidMount(){/* var clsName=this.removeWhiteSpace(this.getProductDetails()[this.props.id].ClassName)
		this.setTitle(clsName+"_title");
		this.setMeta(clsName+"_meta");
		this.setHeading(clsName+"_heading"); */}},{key:'getBuyOptions',value:function getBuyOptions(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BuyOption_js__["a" /* default */],{showContactus:this.props.showContactus,id:this.props.id,triedFree:this.props.triedFree,purchased:this.props.purchased,showSubScripeLoginForm:this.props.showSubScripeLoginForm,productBase:this.props.productBase,simpleform:this.props.simpleform,role:"TCHR"});}},{key:'render',value:function render(){//var classname = this.getProductDetails()[this.props.id].ClassName;
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:this.props.classes+" tchrhead"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,this.rb("Teachers.heading")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,this.rb("Teachers.centaheading"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__images_icons_centalogo_png___default.a,alt:'Centa Logo'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tchrdiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.rb("Tchrcomp.subheading"),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.rb("Tchrcomp.subheading1")))));}}]);return TeacherBannerBuy;}(__WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (TeacherBannerBuy);

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_NativeAjax__ = __webpack_require__(29);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var currency_map={"INR":"₹ ","SGD":"SG $"};var redirection_url_key="login-redirect-purchase";var FlipBox=function(_PreLoginPage){_inherits(FlipBox,_PreLoginPage);function FlipBox(props){_classCallCheck(this,FlipBox);var _this=_possibleConstructorReturn(this,(FlipBox.__proto__||Object.getPrototypeOf(FlipBox)).call(this,props));_this.checkFreeTrailFn=function(){//console.warn("checkFreeTrailFn ");
if(_this.props.gradeBox){_this.isUserLoggedIn=_this.getUser().getUserId()&&_this.getUser().getUserId().length>0?true:false;_this.isFreeProduct=!isNaN(_this.props.gradeBox.productPrice)&&parseInt(_this.props.gradeBox.productPrice)===0||!isNaN(_this.props.gradeBox.nonDiscountedPrice)&&parseInt(_this.props.gradeBox.nonDiscountedPrice)===0;if(_this.isFreeProduct&&_this.isUserLoggedIn){_this.checkUserFreeTrial();}}};_this.getProductPrice=function(){var me=_this;if(_this.props.gradeBox.productPrice>0){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,_this.getCurrency(me.props.gradeBox.currency),' ',Math.round(_this.props.gradeBox.productPrice)||'');}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,Math.round(_this.props.gradeBox.productPrice)||_this.rb("flipbox.price.free"));}};_this.getImageUI=function(){var me=_this;var category=me.props.category||'TCHR_SPL';var prodImgNotAvail=window.prodImgNotAvail||[];var imageAvailable=category.length>1&&prodImgNotAvail.indexOf(category)>-1?true:false;//console.warn("prodImgNotAvail ",prodImgNotAvail , " : ",category," : ",imageAvailable);
if(!imageAvailable){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row toprow'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 col-lg-5'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:"/"+me.productDetails.thumbnails,alt:me.props.gradeBox.productName||''})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 col-lg-7 topicinfo'},me.getLessonsList()));}};_this.state={isLoaded:false,forceUpdater:1};_this.OPSAvailable=false;_this.productDetails=props.productDetails||{};_this.teacherLessonsList={};if(_typeof(props.teacherLessonsList)==="object"){for(var i in props.teacherLessonsList){_this.teacherLessonsList[i]=props.teacherLessonsList[i];}}_this.isFreeProduct=false;_this.isFreeTrialAvailable=true;_this.isUserLoggedIn=false;try{_this.isFreeProduct=!isNaN(props.gradeBox.productPrice)&&parseInt(props.gradeBox.productPrice)===0||!isNaN(props.gradeBox.nonDiscountedPrice)&&parseInt(props.gradeBox.nonDiscountedPrice)===0;}catch(e){}_this.className=props.gradeName;_this.billingForm=_this.billingForm.bind(_this);_this.getCurrency=_this.getCurrency.bind(_this);_this.tryForFree=_this.tryForFree.bind(_this);return _this;}_createClass(FlipBox,[{key:'componentDidMount',value:function componentDidMount(){_get(FlipBox.prototype.__proto__||Object.getPrototypeOf(FlipBox.prototype),'componentDidMount',this).call(this);this.checkFreeTrailFn();}},{key:'showSubscriptionForm',value:function showSubscriptionForm(callback){sessionStorage.setItem(redirection_url_key,window.location.href);if(typeof this.props.showSubscriptionForm==="function"){this.props.showSubscriptionForm(callback);}}},{key:'checkUserFreeTrial',value:function checkUserFreeTrial(){var _this2=this;var me=this;var success=function success(resp){if(resp&&resp.response&&resp.response.paid_accessed===false&&resp.response.free_accessed===false){me.isFreeTrialAvailable=true;me.setState({forceUpdater:me.state.forceUpdater+1});}else{me.markUsed();}};var failure=function failure(err){console.warn("lalala :: failure");};var productPurchaseParams={};productPurchaseParams["products"]=[];var prodObj={"productId":this.props.gradeBox.productId,"tariffId":this.props.gradeBox.tariffId};productPurchaseParams["products"].push(prodObj);var sendToServer=function sendToServer(){new __WEBPACK_IMPORTED_MODULE_3__util_NativeAjax__["a" /* default */](_this2.getUrlFor("FREE_PRODUCT_CHECK"),productPurchaseParams).enableCORS().post(success,failure);};if(this.isUserLoggedIn){sendToServer();}else{this.showSubscriptionForm(sendToServer);}}},{key:'tryForFree',value:function tryForFree(){var _this3=this;var me=this;var success=function success(resp){if(resp&&resp.response==="success"){window.top.location.href="/myproducts";return;}else{me.markUsed();}window.location.reload();};var failure=function failure(err){window.location.reload();};var productPurchaseParams={};productPurchaseParams["products"]=[];var prodObj={"productId":this.props.gradeBox.productId,"tariffId":this.props.gradeBox.tariffId};productPurchaseParams["products"].push(prodObj);var sendToServer=function sendToServer(){new __WEBPACK_IMPORTED_MODULE_3__util_NativeAjax__["a" /* default */](_this3.getUrlFor("FREE_PRODUCT_SAVE"),productPurchaseParams).enableCORS().post(success,failure);};if(this.isUserLoggedIn){sendToServer();}else{this.showSubscriptionForm(sendToServer);}}},{key:'markUsed',value:function markUsed(){this.isFreeTrialAvailable=false;this.setState({forceUpdater:this.state.forceUpdater+1});}},{key:'billingForm',value:function billingForm(evt){var productList={"productId":this.props.gradeBox.productId,"productCategory":this.props.gradeBox.productCategory,"currency":this.props.gradeBox.currency,"productName":this.props.gradeBox.productName,"productPrice":this.props.gradeBox.productPrice,"productTariffID":this.props.gradeBox.tariffId,"validity":this.props.gradeBox.validity,"tariffId":this.props.gradeBox.tariffId,"count":1,"basePrice":this.props.gradeBox.productPrice,"appName":this.props.appDetails.appName,"appId":this.props.appDetails.appId,"gradeName":this.props.gradeName};this.props.showBillingForm(productList);}},{key:'getLessonsList',value:function getLessonsList(){var _this4=this;var tempObj=this.props.teacherLessonsList||{};if(tempObj&&Object.keys(tempObj).length>0){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',null,Object.keys(tempObj).map(function(data,idx){if(data&&!isNaN(tempObj[data])&&tempObj[data]>0){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{key:idx},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'topcnt'},tempObj[data]||0),' ',_this4.rb("label."+data));}}));}}},{key:'getCurrency',value:function getCurrency(){var currency=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";if(currency&&currency.length>0){return currency_map[currency.toUpperCase()]?currency_map[currency.toUpperCase()]:currency.toUpperCase();}return currency;}},{key:'getDiscountPercent',value:function getDiscountPercent(originalPrice,discountedPrice){if(!isNaN(originalPrice)&&!isNaN(discountedPrice)){try{return Math.round((originalPrice-discountedPrice)/originalPrice*100);}catch(e){console.error("Error calculating discount :: ",e);}}return 0;}},{key:'renderPrice',value:function renderPrice(){var me=this;if(me.props.gradeBox.nonDiscountedPrice){var productPrice=this.getCurrency(me.props.gradeBox.currency)+Math.round(me.props.gradeBox.productPrice);var nonDiscountedPrice=this.getCurrency(me.props.gradeBox.currency)+Math.round(me.props.gradeBox.nonDiscountedPrice);var disPercentage=me.getDiscountPercent(me.props.gradeBox.nonDiscountedPrice,me.props.gradeBox.productPrice)+"% off";return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'couponprice'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'orgprice'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'striketxt'},nonDiscountedPrice||'')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'discntprice'},productPrice||''),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'discntper'},disPercentage));}else if(this.isFreeProduct){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,this.rb("product.buyoption.freetrail").replace("{0}",me.props.gradeBox.validity));}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,this.getCurrency(me.props.gradeBox.currency),' ',Math.round(this.props.gradeBox.productPrice)||'');}},{key:'renderProductview',value:function renderProductview(){var me=this;if(me.props.gradeBox.nonDiscountedPrice){var productPrice=this.getCurrency(me.props.gradeBox.currency)+Math.round(me.props.gradeBox.productPrice);var nonDiscountedPrice=this.getCurrency(me.props.gradeBox.currency)+Math.round(me.props.gradeBox.nonDiscountedPrice);var disPercentage=me.getDiscountPercent(me.props.gradeBox.nonDiscountedPrice,me.props.gradeBox.productPrice)+"% off";var txtalign={textAlign:"left"};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-7 greyborderright',style:txtalign},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'couponprice'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'orgprice'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'striketxt'},nonDiscountedPrice||'')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'discntprice'},productPrice||''),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'discntper'},disPercentage))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-5 valyear'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Validity:\xA0'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),this.props.gradeBox.validity+' days'||''));}else{var _txtalign={textAlign:"center"};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-5 greyborderright',style:_txtalign},this.getProductPrice()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-7 valyear'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Validity:\xA0'),this.props.gradeBox.validity+' days'||''));}}},{key:'render',value:function render(){var _this5=this;var me=this;this.OPSAvailable=this.props.OPSAvailable||false;var opsClass=this.OPSAvailable==true?'opsenabled':'opsdisabled';this.productDetails=this.props.productDetails||{};me.isFreeProduct=!isNaN(me.props.gradeBox.productPrice)&&parseInt(me.props.gradeBox.productPrice)===0||!isNaN(me.props.gradeBox.nonDiscountedPrice)&&parseInt(me.props.gradeBox.nonDiscountedPrice)===0;this.className=this.props.gradeName||'';var addClass=me.isFreeProduct?' freetrail':'';return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flipbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'card-header'},this.props.gradeBox.productName||''),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'card-body'},this.getImageUI(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'card-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'text-heading'},'Concepts covered:\xA0'),this.productDetails.topics||'')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'card-footer row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-8 col-lg-8 bottrow'},this.renderProductview()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-4 col-lg-4'},function(){if(me.isFreeProduct&&_this5.state.forceUpdater){if(me.isFreeTrialAvailable){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'r-btn freetrail'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{'data-ga':'Home - Sign In - Users who have independently registered  - Sign In',className:"submitButton "+opsClass,'data-tarrifid':_this5.props.gradeBox.tariffId,'data-productid':_this5.props.gradeBox.productId,'data-gradeid':_this5.props.gradeName,'data-category':_this5.props.gradeBox.productCategory,onClick:_this5.tryForFree},_this5.rb("flipbox.trynow")));}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'r-btn opsdisabled freetrail'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{'data-ga':'Home - Sign In - Users who have independently registered  - Sign In',className:"submitButton "+opsClass,'data-tarrifid':_this5.props.gradeBox.tariffId,'data-productid':_this5.props.gradeBox.productId,'data-gradeid':_this5.props.gradeName,'data-category':_this5.props.gradeBox.productCategory},_this5.rb("flipbox.subscribed")));}}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'r-btn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{'data-ga':'Home - Sign In - Users who have independently registered  - Sign In',className:"submitButton "+opsClass,'data-tarrifid':_this5.props.gradeBox.tariffId,'data-productid':_this5.props.gradeBox.productId,'data-gradeid':_this5.props.gradeName,'data-category':_this5.props.gradeBox.productCategory,onClick:_this5.billingForm},_this5.rb("flipbox.subscribe")));}}()))));}}]);return FlipBox;}(__WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (FlipBox);

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isValidDelay = isValidDelay;
exports.objectValues = objectValues;
exports.falseOrElement = exports.falseOrDelay = void 0;

var _react = __webpack_require__(0);

function isValidDelay(val) {
  return typeof val === 'number' && !isNaN(val) && val > 0;
}

function objectValues(obj) {
  return Object.keys(obj).map(function (key) {
    return obj[key];
  });
}

function withRequired(fn) {
  fn.isRequired = function (props, propName, componentName) {
    var prop = props[propName];

    if (typeof prop === 'undefined') {
      return new Error("The prop " + propName + " is marked as required in \n      " + componentName + ", but its value is undefined.");
    }

    fn(props, propName, componentName);
  };

  return fn;
}

var falseOrDelay = withRequired(function (props, propName, componentName) {
  var prop = props[propName];

  if (prop !== false && !isValidDelay(prop)) {
    return new Error(componentName + " expect " + propName + " \n      to be a valid Number > 0 or equal to false. " + prop + " given.");
  }

  return null;
});
exports.falseOrDelay = falseOrDelay;
var falseOrElement = withRequired(function (props, propName, componentName) {
  var prop = props[propName];

  if (prop !== false && !(0, _react.isValidElement)(prop)) {
    return new Error(componentName + " expect " + propName + " \n      to be a valid react element or equal to false. " + prop + " given.");
  }

  return null;
});
exports.falseOrElement = falseOrElement;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(518);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.15.0
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(28)))

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(100);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(322);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(198);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(542)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = convertNodeToElement;

var _elementTypes = __webpack_require__(558);

var _elementTypes2 = _interopRequireDefault(_elementTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Converts a htmlparser2 node to a React element
 *
 * @param {Object} node The htmlparser2 node to convert
 * @param {Number} index The index of the current node
 * @param {Function} transform Transform function to apply to children of the node
 * @returns {React.Element}
 */
function convertNodeToElement(node, index, transform) {
  return _elementTypes2.default[node.type](node, index, transform);
}

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var Tokenizer = __webpack_require__(327);

/*
	Options:

	xmlMode: Disables the special behavior for script/style tags (false by default)
	lowerCaseAttributeNames: call .toLowerCase for each attribute name (true if xmlMode is `false`)
	lowerCaseTags: call .toLowerCase for each tag name (true if xmlMode is `false`)
*/

/*
	Callbacks:

	oncdataend,
	oncdatastart,
	onclosetag,
	oncomment,
	oncommentend,
	onerror,
	onopentag,
	onprocessinginstruction,
	onreset,
	ontext
*/

var formTags = {
    input: true,
    option: true,
    optgroup: true,
    select: true,
    button: true,
    datalist: true,
    textarea: true
};

var openImpliesClose = {
    tr: { tr: true, th: true, td: true },
    th: { th: true },
    td: { thead: true, th: true, td: true },
    body: { head: true, link: true, script: true },
    li: { li: true },
    p: { p: true },
    h1: { p: true },
    h2: { p: true },
    h3: { p: true },
    h4: { p: true },
    h5: { p: true },
    h6: { p: true },
    select: formTags,
    input: formTags,
    output: formTags,
    button: formTags,
    datalist: formTags,
    textarea: formTags,
    option: { option: true },
    optgroup: { optgroup: true }
};

var voidElements = {
    __proto__: null,
    area: true,
    base: true,
    basefont: true,
    br: true,
    col: true,
    command: true,
    embed: true,
    frame: true,
    hr: true,
    img: true,
    input: true,
    isindex: true,
    keygen: true,
    link: true,
    meta: true,
    param: true,
    source: true,
    track: true,
    wbr: true
};

var foreignContextElements = {
    __proto__: null,
    math: true,
    svg: true
};
var htmlIntegrationElements = {
    __proto__: null,
    mi: true,
    mo: true,
    mn: true,
    ms: true,
    mtext: true,
    "annotation-xml": true,
    foreignObject: true,
    desc: true,
    title: true
};

var re_nameEnd = /\s|\//;

function Parser(cbs, options) {
    this._options = options || {};
    this._cbs = cbs || {};

    this._tagname = "";
    this._attribname = "";
    this._attribvalue = "";
    this._attribs = null;
    this._stack = [];
    this._foreignContext = [];

    this.startIndex = 0;
    this.endIndex = null;

    this._lowerCaseTagNames =
        "lowerCaseTags" in this._options
            ? !!this._options.lowerCaseTags
            : !this._options.xmlMode;
    this._lowerCaseAttributeNames =
        "lowerCaseAttributeNames" in this._options
            ? !!this._options.lowerCaseAttributeNames
            : !this._options.xmlMode;

    if (this._options.Tokenizer) {
        Tokenizer = this._options.Tokenizer;
    }
    this._tokenizer = new Tokenizer(this._options, this);

    if (this._cbs.onparserinit) this._cbs.onparserinit(this);
}

__webpack_require__(60)(Parser, __webpack_require__(149).EventEmitter);

Parser.prototype._updatePosition = function(initialOffset) {
    if (this.endIndex === null) {
        if (this._tokenizer._sectionStart <= initialOffset) {
            this.startIndex = 0;
        } else {
            this.startIndex = this._tokenizer._sectionStart - initialOffset;
        }
    } else this.startIndex = this.endIndex + 1;
    this.endIndex = this._tokenizer.getAbsoluteIndex();
};

//Tokenizer event handlers
Parser.prototype.ontext = function(data) {
    this._updatePosition(1);
    this.endIndex--;

    if (this._cbs.ontext) this._cbs.ontext(data);
};

Parser.prototype.onopentagname = function(name) {
    if (this._lowerCaseTagNames) {
        name = name.toLowerCase();
    }

    this._tagname = name;

    if (!this._options.xmlMode && name in openImpliesClose) {
        for (
            var el;
            (el = this._stack[this._stack.length - 1]) in
            openImpliesClose[name];
            this.onclosetag(el)
        );
    }

    if (this._options.xmlMode || !(name in voidElements)) {
        this._stack.push(name);
        if (name in foreignContextElements) this._foreignContext.push(true);
        else if (name in htmlIntegrationElements)
            this._foreignContext.push(false);
    }

    if (this._cbs.onopentagname) this._cbs.onopentagname(name);
    if (this._cbs.onopentag) this._attribs = {};
};

Parser.prototype.onopentagend = function() {
    this._updatePosition(1);

    if (this._attribs) {
        if (this._cbs.onopentag)
            this._cbs.onopentag(this._tagname, this._attribs);
        this._attribs = null;
    }

    if (
        !this._options.xmlMode &&
        this._cbs.onclosetag &&
        this._tagname in voidElements
    ) {
        this._cbs.onclosetag(this._tagname);
    }

    this._tagname = "";
};

Parser.prototype.onclosetag = function(name) {
    this._updatePosition(1);

    if (this._lowerCaseTagNames) {
        name = name.toLowerCase();
    }
    
    if (name in foreignContextElements || name in htmlIntegrationElements) {
        this._foreignContext.pop();
    }

    if (
        this._stack.length &&
        (!(name in voidElements) || this._options.xmlMode)
    ) {
        var pos = this._stack.lastIndexOf(name);
        if (pos !== -1) {
            if (this._cbs.onclosetag) {
                pos = this._stack.length - pos;
                while (pos--) this._cbs.onclosetag(this._stack.pop());
            } else this._stack.length = pos;
        } else if (name === "p" && !this._options.xmlMode) {
            this.onopentagname(name);
            this._closeCurrentTag();
        }
    } else if (!this._options.xmlMode && (name === "br" || name === "p")) {
        this.onopentagname(name);
        this._closeCurrentTag();
    }
};

Parser.prototype.onselfclosingtag = function() {
    if (
        this._options.xmlMode ||
        this._options.recognizeSelfClosing ||
        this._foreignContext[this._foreignContext.length - 1]
    ) {
        this._closeCurrentTag();
    } else {
        this.onopentagend();
    }
};

Parser.prototype._closeCurrentTag = function() {
    var name = this._tagname;

    this.onopentagend();

    //self-closing tags will be on the top of the stack
    //(cheaper check than in onclosetag)
    if (this._stack[this._stack.length - 1] === name) {
        if (this._cbs.onclosetag) {
            this._cbs.onclosetag(name);
        }
        this._stack.pop();
        
    }
};

Parser.prototype.onattribname = function(name) {
    if (this._lowerCaseAttributeNames) {
        name = name.toLowerCase();
    }
    this._attribname = name;
};

Parser.prototype.onattribdata = function(value) {
    this._attribvalue += value;
};

Parser.prototype.onattribend = function() {
    if (this._cbs.onattribute)
        this._cbs.onattribute(this._attribname, this._attribvalue);
    if (
        this._attribs &&
        !Object.prototype.hasOwnProperty.call(this._attribs, this._attribname)
    ) {
        this._attribs[this._attribname] = this._attribvalue;
    }
    this._attribname = "";
    this._attribvalue = "";
};

Parser.prototype._getInstructionName = function(value) {
    var idx = value.search(re_nameEnd),
        name = idx < 0 ? value : value.substr(0, idx);

    if (this._lowerCaseTagNames) {
        name = name.toLowerCase();
    }

    return name;
};

Parser.prototype.ondeclaration = function(value) {
    if (this._cbs.onprocessinginstruction) {
        var name = this._getInstructionName(value);
        this._cbs.onprocessinginstruction("!" + name, "!" + value);
    }
};

Parser.prototype.onprocessinginstruction = function(value) {
    if (this._cbs.onprocessinginstruction) {
        var name = this._getInstructionName(value);
        this._cbs.onprocessinginstruction("?" + name, "?" + value);
    }
};

Parser.prototype.oncomment = function(value) {
    this._updatePosition(4);

    if (this._cbs.oncomment) this._cbs.oncomment(value);
    if (this._cbs.oncommentend) this._cbs.oncommentend();
};

Parser.prototype.oncdata = function(value) {
    this._updatePosition(1);

    if (this._options.xmlMode || this._options.recognizeCDATA) {
        if (this._cbs.oncdatastart) this._cbs.oncdatastart();
        if (this._cbs.ontext) this._cbs.ontext(value);
        if (this._cbs.oncdataend) this._cbs.oncdataend();
    } else {
        this.oncomment("[CDATA[" + value + "]]");
    }
};

Parser.prototype.onerror = function(err) {
    if (this._cbs.onerror) this._cbs.onerror(err);
};

Parser.prototype.onend = function() {
    if (this._cbs.onclosetag) {
        for (
            var i = this._stack.length;
            i > 0;
            this._cbs.onclosetag(this._stack[--i])
        );
    }
    if (this._cbs.onend) this._cbs.onend();
};

//Resets the parser to a blank state, ready to parse a new HTML document
Parser.prototype.reset = function() {
    if (this._cbs.onreset) this._cbs.onreset();
    this._tokenizer.reset();

    this._tagname = "";
    this._attribname = "";
    this._attribs = null;
    this._stack = [];

    if (this._cbs.onparserinit) this._cbs.onparserinit(this);
};

//Parses a complete HTML document and pushes it to the handler
Parser.prototype.parseComplete = function(data) {
    this.reset();
    this.end(data);
};

Parser.prototype.write = function(chunk) {
    this._tokenizer.write(chunk);
};

Parser.prototype.end = function(chunk) {
    this._tokenizer.end(chunk);
};

Parser.prototype.pause = function() {
    this._tokenizer.pause();
};

Parser.prototype.resume = function() {
    this._tokenizer.resume();
};

//alias for backwards compat
Parser.prototype.parseChunk = Parser.prototype.write;
Parser.prototype.done = Parser.prototype.end;

module.exports = Parser;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Tokenizer;

var decodeCodePoint = __webpack_require__(328);
var entityMap = __webpack_require__(200);
var legacyMap = __webpack_require__(329);
var xmlMap = __webpack_require__(201);

var i = 0;

var TEXT = i++;
var BEFORE_TAG_NAME = i++; //after <
var IN_TAG_NAME = i++;
var IN_SELF_CLOSING_TAG = i++;
var BEFORE_CLOSING_TAG_NAME = i++;
var IN_CLOSING_TAG_NAME = i++;
var AFTER_CLOSING_TAG_NAME = i++;

//attributes
var BEFORE_ATTRIBUTE_NAME = i++;
var IN_ATTRIBUTE_NAME = i++;
var AFTER_ATTRIBUTE_NAME = i++;
var BEFORE_ATTRIBUTE_VALUE = i++;
var IN_ATTRIBUTE_VALUE_DQ = i++; // "
var IN_ATTRIBUTE_VALUE_SQ = i++; // '
var IN_ATTRIBUTE_VALUE_NQ = i++;

//declarations
var BEFORE_DECLARATION = i++; // !
var IN_DECLARATION = i++;

//processing instructions
var IN_PROCESSING_INSTRUCTION = i++; // ?

//comments
var BEFORE_COMMENT = i++;
var IN_COMMENT = i++;
var AFTER_COMMENT_1 = i++;
var AFTER_COMMENT_2 = i++;

//cdata
var BEFORE_CDATA_1 = i++; // [
var BEFORE_CDATA_2 = i++; // C
var BEFORE_CDATA_3 = i++; // D
var BEFORE_CDATA_4 = i++; // A
var BEFORE_CDATA_5 = i++; // T
var BEFORE_CDATA_6 = i++; // A
var IN_CDATA = i++; // [
var AFTER_CDATA_1 = i++; // ]
var AFTER_CDATA_2 = i++; // ]

//special tags
var BEFORE_SPECIAL = i++; //S
var BEFORE_SPECIAL_END = i++; //S

var BEFORE_SCRIPT_1 = i++; //C
var BEFORE_SCRIPT_2 = i++; //R
var BEFORE_SCRIPT_3 = i++; //I
var BEFORE_SCRIPT_4 = i++; //P
var BEFORE_SCRIPT_5 = i++; //T
var AFTER_SCRIPT_1 = i++; //C
var AFTER_SCRIPT_2 = i++; //R
var AFTER_SCRIPT_3 = i++; //I
var AFTER_SCRIPT_4 = i++; //P
var AFTER_SCRIPT_5 = i++; //T

var BEFORE_STYLE_1 = i++; //T
var BEFORE_STYLE_2 = i++; //Y
var BEFORE_STYLE_3 = i++; //L
var BEFORE_STYLE_4 = i++; //E
var AFTER_STYLE_1 = i++; //T
var AFTER_STYLE_2 = i++; //Y
var AFTER_STYLE_3 = i++; //L
var AFTER_STYLE_4 = i++; //E

var BEFORE_ENTITY = i++; //&
var BEFORE_NUMERIC_ENTITY = i++; //#
var IN_NAMED_ENTITY = i++;
var IN_NUMERIC_ENTITY = i++;
var IN_HEX_ENTITY = i++; //X

var j = 0;

var SPECIAL_NONE = j++;
var SPECIAL_SCRIPT = j++;
var SPECIAL_STYLE = j++;

function whitespace(c) {
    return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
}

function ifElseState(upper, SUCCESS, FAILURE) {
    var lower = upper.toLowerCase();

    if (upper === lower) {
        return function(c) {
            if (c === lower) {
                this._state = SUCCESS;
            } else {
                this._state = FAILURE;
                this._index--;
            }
        };
    } else {
        return function(c) {
            if (c === lower || c === upper) {
                this._state = SUCCESS;
            } else {
                this._state = FAILURE;
                this._index--;
            }
        };
    }
}

function consumeSpecialNameChar(upper, NEXT_STATE) {
    var lower = upper.toLowerCase();

    return function(c) {
        if (c === lower || c === upper) {
            this._state = NEXT_STATE;
        } else {
            this._state = IN_TAG_NAME;
            this._index--; //consume the token again
        }
    };
}

function Tokenizer(options, cbs) {
    this._state = TEXT;
    this._buffer = "";
    this._sectionStart = 0;
    this._index = 0;
    this._bufferOffset = 0; //chars removed from _buffer
    this._baseState = TEXT;
    this._special = SPECIAL_NONE;
    this._cbs = cbs;
    this._running = true;
    this._ended = false;
    this._xmlMode = !!(options && options.xmlMode);
    this._decodeEntities = !!(options && options.decodeEntities);
}

Tokenizer.prototype._stateText = function(c) {
    if (c === "<") {
        if (this._index > this._sectionStart) {
            this._cbs.ontext(this._getSection());
        }
        this._state = BEFORE_TAG_NAME;
        this._sectionStart = this._index;
    } else if (
        this._decodeEntities &&
        this._special === SPECIAL_NONE &&
        c === "&"
    ) {
        if (this._index > this._sectionStart) {
            this._cbs.ontext(this._getSection());
        }
        this._baseState = TEXT;
        this._state = BEFORE_ENTITY;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateBeforeTagName = function(c) {
    if (c === "/") {
        this._state = BEFORE_CLOSING_TAG_NAME;
    } else if (c === "<") {
        this._cbs.ontext(this._getSection());
        this._sectionStart = this._index;
    } else if (c === ">" || this._special !== SPECIAL_NONE || whitespace(c)) {
        this._state = TEXT;
    } else if (c === "!") {
        this._state = BEFORE_DECLARATION;
        this._sectionStart = this._index + 1;
    } else if (c === "?") {
        this._state = IN_PROCESSING_INSTRUCTION;
        this._sectionStart = this._index + 1;
    } else {
        this._state =
            !this._xmlMode && (c === "s" || c === "S")
                ? BEFORE_SPECIAL
                : IN_TAG_NAME;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateInTagName = function(c) {
    if (c === "/" || c === ">" || whitespace(c)) {
        this._emitToken("onopentagname");
        this._state = BEFORE_ATTRIBUTE_NAME;
        this._index--;
    }
};

Tokenizer.prototype._stateBeforeCloseingTagName = function(c) {
    if (whitespace(c));
    else if (c === ">") {
        this._state = TEXT;
    } else if (this._special !== SPECIAL_NONE) {
        if (c === "s" || c === "S") {
            this._state = BEFORE_SPECIAL_END;
        } else {
            this._state = TEXT;
            this._index--;
        }
    } else {
        this._state = IN_CLOSING_TAG_NAME;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateInCloseingTagName = function(c) {
    if (c === ">" || whitespace(c)) {
        this._emitToken("onclosetag");
        this._state = AFTER_CLOSING_TAG_NAME;
        this._index--;
    }
};

Tokenizer.prototype._stateAfterCloseingTagName = function(c) {
    //skip everything until ">"
    if (c === ">") {
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    }
};

Tokenizer.prototype._stateBeforeAttributeName = function(c) {
    if (c === ">") {
        this._cbs.onopentagend();
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    } else if (c === "/") {
        this._state = IN_SELF_CLOSING_TAG;
    } else if (!whitespace(c)) {
        this._state = IN_ATTRIBUTE_NAME;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateInSelfClosingTag = function(c) {
    if (c === ">") {
        this._cbs.onselfclosingtag();
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    } else if (!whitespace(c)) {
        this._state = BEFORE_ATTRIBUTE_NAME;
        this._index--;
    }
};

Tokenizer.prototype._stateInAttributeName = function(c) {
    if (c === "=" || c === "/" || c === ">" || whitespace(c)) {
        this._cbs.onattribname(this._getSection());
        this._sectionStart = -1;
        this._state = AFTER_ATTRIBUTE_NAME;
        this._index--;
    }
};

Tokenizer.prototype._stateAfterAttributeName = function(c) {
    if (c === "=") {
        this._state = BEFORE_ATTRIBUTE_VALUE;
    } else if (c === "/" || c === ">") {
        this._cbs.onattribend();
        this._state = BEFORE_ATTRIBUTE_NAME;
        this._index--;
    } else if (!whitespace(c)) {
        this._cbs.onattribend();
        this._state = IN_ATTRIBUTE_NAME;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateBeforeAttributeValue = function(c) {
    if (c === '"') {
        this._state = IN_ATTRIBUTE_VALUE_DQ;
        this._sectionStart = this._index + 1;
    } else if (c === "'") {
        this._state = IN_ATTRIBUTE_VALUE_SQ;
        this._sectionStart = this._index + 1;
    } else if (!whitespace(c)) {
        this._state = IN_ATTRIBUTE_VALUE_NQ;
        this._sectionStart = this._index;
        this._index--; //reconsume token
    }
};

Tokenizer.prototype._stateInAttributeValueDoubleQuotes = function(c) {
    if (c === '"') {
        this._emitToken("onattribdata");
        this._cbs.onattribend();
        this._state = BEFORE_ATTRIBUTE_NAME;
    } else if (this._decodeEntities && c === "&") {
        this._emitToken("onattribdata");
        this._baseState = this._state;
        this._state = BEFORE_ENTITY;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateInAttributeValueSingleQuotes = function(c) {
    if (c === "'") {
        this._emitToken("onattribdata");
        this._cbs.onattribend();
        this._state = BEFORE_ATTRIBUTE_NAME;
    } else if (this._decodeEntities && c === "&") {
        this._emitToken("onattribdata");
        this._baseState = this._state;
        this._state = BEFORE_ENTITY;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateInAttributeValueNoQuotes = function(c) {
    if (whitespace(c) || c === ">") {
        this._emitToken("onattribdata");
        this._cbs.onattribend();
        this._state = BEFORE_ATTRIBUTE_NAME;
        this._index--;
    } else if (this._decodeEntities && c === "&") {
        this._emitToken("onattribdata");
        this._baseState = this._state;
        this._state = BEFORE_ENTITY;
        this._sectionStart = this._index;
    }
};

Tokenizer.prototype._stateBeforeDeclaration = function(c) {
    this._state =
        c === "["
            ? BEFORE_CDATA_1
            : c === "-"
                ? BEFORE_COMMENT
                : IN_DECLARATION;
};

Tokenizer.prototype._stateInDeclaration = function(c) {
    if (c === ">") {
        this._cbs.ondeclaration(this._getSection());
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    }
};

Tokenizer.prototype._stateInProcessingInstruction = function(c) {
    if (c === ">") {
        this._cbs.onprocessinginstruction(this._getSection());
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    }
};

Tokenizer.prototype._stateBeforeComment = function(c) {
    if (c === "-") {
        this._state = IN_COMMENT;
        this._sectionStart = this._index + 1;
    } else {
        this._state = IN_DECLARATION;
    }
};

Tokenizer.prototype._stateInComment = function(c) {
    if (c === "-") this._state = AFTER_COMMENT_1;
};

Tokenizer.prototype._stateAfterComment1 = function(c) {
    if (c === "-") {
        this._state = AFTER_COMMENT_2;
    } else {
        this._state = IN_COMMENT;
    }
};

Tokenizer.prototype._stateAfterComment2 = function(c) {
    if (c === ">") {
        //remove 2 trailing chars
        this._cbs.oncomment(
            this._buffer.substring(this._sectionStart, this._index - 2)
        );
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    } else if (c !== "-") {
        this._state = IN_COMMENT;
    }
    // else: stay in AFTER_COMMENT_2 (`--->`)
};

Tokenizer.prototype._stateBeforeCdata1 = ifElseState(
    "C",
    BEFORE_CDATA_2,
    IN_DECLARATION
);
Tokenizer.prototype._stateBeforeCdata2 = ifElseState(
    "D",
    BEFORE_CDATA_3,
    IN_DECLARATION
);
Tokenizer.prototype._stateBeforeCdata3 = ifElseState(
    "A",
    BEFORE_CDATA_4,
    IN_DECLARATION
);
Tokenizer.prototype._stateBeforeCdata4 = ifElseState(
    "T",
    BEFORE_CDATA_5,
    IN_DECLARATION
);
Tokenizer.prototype._stateBeforeCdata5 = ifElseState(
    "A",
    BEFORE_CDATA_6,
    IN_DECLARATION
);

Tokenizer.prototype._stateBeforeCdata6 = function(c) {
    if (c === "[") {
        this._state = IN_CDATA;
        this._sectionStart = this._index + 1;
    } else {
        this._state = IN_DECLARATION;
        this._index--;
    }
};

Tokenizer.prototype._stateInCdata = function(c) {
    if (c === "]") this._state = AFTER_CDATA_1;
};

Tokenizer.prototype._stateAfterCdata1 = function(c) {
    if (c === "]") this._state = AFTER_CDATA_2;
    else this._state = IN_CDATA;
};

Tokenizer.prototype._stateAfterCdata2 = function(c) {
    if (c === ">") {
        //remove 2 trailing chars
        this._cbs.oncdata(
            this._buffer.substring(this._sectionStart, this._index - 2)
        );
        this._state = TEXT;
        this._sectionStart = this._index + 1;
    } else if (c !== "]") {
        this._state = IN_CDATA;
    }
    //else: stay in AFTER_CDATA_2 (`]]]>`)
};

Tokenizer.prototype._stateBeforeSpecial = function(c) {
    if (c === "c" || c === "C") {
        this._state = BEFORE_SCRIPT_1;
    } else if (c === "t" || c === "T") {
        this._state = BEFORE_STYLE_1;
    } else {
        this._state = IN_TAG_NAME;
        this._index--; //consume the token again
    }
};

Tokenizer.prototype._stateBeforeSpecialEnd = function(c) {
    if (this._special === SPECIAL_SCRIPT && (c === "c" || c === "C")) {
        this._state = AFTER_SCRIPT_1;
    } else if (this._special === SPECIAL_STYLE && (c === "t" || c === "T")) {
        this._state = AFTER_STYLE_1;
    } else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeScript1 = consumeSpecialNameChar(
    "R",
    BEFORE_SCRIPT_2
);
Tokenizer.prototype._stateBeforeScript2 = consumeSpecialNameChar(
    "I",
    BEFORE_SCRIPT_3
);
Tokenizer.prototype._stateBeforeScript3 = consumeSpecialNameChar(
    "P",
    BEFORE_SCRIPT_4
);
Tokenizer.prototype._stateBeforeScript4 = consumeSpecialNameChar(
    "T",
    BEFORE_SCRIPT_5
);

Tokenizer.prototype._stateBeforeScript5 = function(c) {
    if (c === "/" || c === ">" || whitespace(c)) {
        this._special = SPECIAL_SCRIPT;
    }
    this._state = IN_TAG_NAME;
    this._index--; //consume the token again
};

Tokenizer.prototype._stateAfterScript1 = ifElseState("R", AFTER_SCRIPT_2, TEXT);
Tokenizer.prototype._stateAfterScript2 = ifElseState("I", AFTER_SCRIPT_3, TEXT);
Tokenizer.prototype._stateAfterScript3 = ifElseState("P", AFTER_SCRIPT_4, TEXT);
Tokenizer.prototype._stateAfterScript4 = ifElseState("T", AFTER_SCRIPT_5, TEXT);

Tokenizer.prototype._stateAfterScript5 = function(c) {
    if (c === ">" || whitespace(c)) {
        this._special = SPECIAL_NONE;
        this._state = IN_CLOSING_TAG_NAME;
        this._sectionStart = this._index - 6;
        this._index--; //reconsume the token
    } else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeStyle1 = consumeSpecialNameChar(
    "Y",
    BEFORE_STYLE_2
);
Tokenizer.prototype._stateBeforeStyle2 = consumeSpecialNameChar(
    "L",
    BEFORE_STYLE_3
);
Tokenizer.prototype._stateBeforeStyle3 = consumeSpecialNameChar(
    "E",
    BEFORE_STYLE_4
);

Tokenizer.prototype._stateBeforeStyle4 = function(c) {
    if (c === "/" || c === ">" || whitespace(c)) {
        this._special = SPECIAL_STYLE;
    }
    this._state = IN_TAG_NAME;
    this._index--; //consume the token again
};

Tokenizer.prototype._stateAfterStyle1 = ifElseState("Y", AFTER_STYLE_2, TEXT);
Tokenizer.prototype._stateAfterStyle2 = ifElseState("L", AFTER_STYLE_3, TEXT);
Tokenizer.prototype._stateAfterStyle3 = ifElseState("E", AFTER_STYLE_4, TEXT);

Tokenizer.prototype._stateAfterStyle4 = function(c) {
    if (c === ">" || whitespace(c)) {
        this._special = SPECIAL_NONE;
        this._state = IN_CLOSING_TAG_NAME;
        this._sectionStart = this._index - 5;
        this._index--; //reconsume the token
    } else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeEntity = ifElseState(
    "#",
    BEFORE_NUMERIC_ENTITY,
    IN_NAMED_ENTITY
);
Tokenizer.prototype._stateBeforeNumericEntity = ifElseState(
    "X",
    IN_HEX_ENTITY,
    IN_NUMERIC_ENTITY
);

//for entities terminated with a semicolon
Tokenizer.prototype._parseNamedEntityStrict = function() {
    //offset = 1
    if (this._sectionStart + 1 < this._index) {
        var entity = this._buffer.substring(
                this._sectionStart + 1,
                this._index
            ),
            map = this._xmlMode ? xmlMap : entityMap;

        if (map.hasOwnProperty(entity)) {
            this._emitPartial(map[entity]);
            this._sectionStart = this._index + 1;
        }
    }
};

//parses legacy entities (without trailing semicolon)
Tokenizer.prototype._parseLegacyEntity = function() {
    var start = this._sectionStart + 1,
        limit = this._index - start;

    if (limit > 6) limit = 6; //the max length of legacy entities is 6

    while (limit >= 2) {
        //the min length of legacy entities is 2
        var entity = this._buffer.substr(start, limit);

        if (legacyMap.hasOwnProperty(entity)) {
            this._emitPartial(legacyMap[entity]);
            this._sectionStart += limit + 1;
            return;
        } else {
            limit--;
        }
    }
};

Tokenizer.prototype._stateInNamedEntity = function(c) {
    if (c === ";") {
        this._parseNamedEntityStrict();
        if (this._sectionStart + 1 < this._index && !this._xmlMode) {
            this._parseLegacyEntity();
        }
        this._state = this._baseState;
    } else if (
        (c < "a" || c > "z") &&
        (c < "A" || c > "Z") &&
        (c < "0" || c > "9")
    ) {
        if (this._xmlMode);
        else if (this._sectionStart + 1 === this._index);
        else if (this._baseState !== TEXT) {
            if (c !== "=") {
                this._parseNamedEntityStrict();
            }
        } else {
            this._parseLegacyEntity();
        }

        this._state = this._baseState;
        this._index--;
    }
};

Tokenizer.prototype._decodeNumericEntity = function(offset, base) {
    var sectionStart = this._sectionStart + offset;

    if (sectionStart !== this._index) {
        //parse entity
        var entity = this._buffer.substring(sectionStart, this._index);
        var parsed = parseInt(entity, base);

        this._emitPartial(decodeCodePoint(parsed));
        this._sectionStart = this._index;
    } else {
        this._sectionStart--;
    }

    this._state = this._baseState;
};

Tokenizer.prototype._stateInNumericEntity = function(c) {
    if (c === ";") {
        this._decodeNumericEntity(2, 10);
        this._sectionStart++;
    } else if (c < "0" || c > "9") {
        if (!this._xmlMode) {
            this._decodeNumericEntity(2, 10);
        } else {
            this._state = this._baseState;
        }
        this._index--;
    }
};

Tokenizer.prototype._stateInHexEntity = function(c) {
    if (c === ";") {
        this._decodeNumericEntity(3, 16);
        this._sectionStart++;
    } else if (
        (c < "a" || c > "f") &&
        (c < "A" || c > "F") &&
        (c < "0" || c > "9")
    ) {
        if (!this._xmlMode) {
            this._decodeNumericEntity(3, 16);
        } else {
            this._state = this._baseState;
        }
        this._index--;
    }
};

Tokenizer.prototype._cleanup = function() {
    if (this._sectionStart < 0) {
        this._buffer = "";
        this._bufferOffset += this._index;
        this._index = 0;
    } else if (this._running) {
        if (this._state === TEXT) {
            if (this._sectionStart !== this._index) {
                this._cbs.ontext(this._buffer.substr(this._sectionStart));
            }
            this._buffer = "";
            this._bufferOffset += this._index;
            this._index = 0;
        } else if (this._sectionStart === this._index) {
            //the section just started
            this._buffer = "";
            this._bufferOffset += this._index;
            this._index = 0;
        } else {
            //remove everything unnecessary
            this._buffer = this._buffer.substr(this._sectionStart);
            this._index -= this._sectionStart;
            this._bufferOffset += this._sectionStart;
        }

        this._sectionStart = 0;
    }
};

//TODO make events conditional
Tokenizer.prototype.write = function(chunk) {
    if (this._ended) this._cbs.onerror(Error(".write() after done!"));

    this._buffer += chunk;
    this._parse();
};

Tokenizer.prototype._parse = function() {
    while (this._index < this._buffer.length && this._running) {
        var c = this._buffer.charAt(this._index);
        if (this._state === TEXT) {
            this._stateText(c);
        } else if (this._state === BEFORE_TAG_NAME) {
            this._stateBeforeTagName(c);
        } else if (this._state === IN_TAG_NAME) {
            this._stateInTagName(c);
        } else if (this._state === BEFORE_CLOSING_TAG_NAME) {
            this._stateBeforeCloseingTagName(c);
        } else if (this._state === IN_CLOSING_TAG_NAME) {
            this._stateInCloseingTagName(c);
        } else if (this._state === AFTER_CLOSING_TAG_NAME) {
            this._stateAfterCloseingTagName(c);
        } else if (this._state === IN_SELF_CLOSING_TAG) {
            this._stateInSelfClosingTag(c);
        } else if (this._state === BEFORE_ATTRIBUTE_NAME) {

        /*
		*	attributes
		*/
            this._stateBeforeAttributeName(c);
        } else if (this._state === IN_ATTRIBUTE_NAME) {
            this._stateInAttributeName(c);
        } else if (this._state === AFTER_ATTRIBUTE_NAME) {
            this._stateAfterAttributeName(c);
        } else if (this._state === BEFORE_ATTRIBUTE_VALUE) {
            this._stateBeforeAttributeValue(c);
        } else if (this._state === IN_ATTRIBUTE_VALUE_DQ) {
            this._stateInAttributeValueDoubleQuotes(c);
        } else if (this._state === IN_ATTRIBUTE_VALUE_SQ) {
            this._stateInAttributeValueSingleQuotes(c);
        } else if (this._state === IN_ATTRIBUTE_VALUE_NQ) {
            this._stateInAttributeValueNoQuotes(c);
        } else if (this._state === BEFORE_DECLARATION) {

        /*
		*	declarations
		*/
            this._stateBeforeDeclaration(c);
        } else if (this._state === IN_DECLARATION) {
            this._stateInDeclaration(c);
        } else if (this._state === IN_PROCESSING_INSTRUCTION) {

        /*
		*	processing instructions
		*/
            this._stateInProcessingInstruction(c);
        } else if (this._state === BEFORE_COMMENT) {

        /*
		*	comments
		*/
            this._stateBeforeComment(c);
        } else if (this._state === IN_COMMENT) {
            this._stateInComment(c);
        } else if (this._state === AFTER_COMMENT_1) {
            this._stateAfterComment1(c);
        } else if (this._state === AFTER_COMMENT_2) {
            this._stateAfterComment2(c);
        } else if (this._state === BEFORE_CDATA_1) {

        /*
		*	cdata
		*/
            this._stateBeforeCdata1(c);
        } else if (this._state === BEFORE_CDATA_2) {
            this._stateBeforeCdata2(c);
        } else if (this._state === BEFORE_CDATA_3) {
            this._stateBeforeCdata3(c);
        } else if (this._state === BEFORE_CDATA_4) {
            this._stateBeforeCdata4(c);
        } else if (this._state === BEFORE_CDATA_5) {
            this._stateBeforeCdata5(c);
        } else if (this._state === BEFORE_CDATA_6) {
            this._stateBeforeCdata6(c);
        } else if (this._state === IN_CDATA) {
            this._stateInCdata(c);
        } else if (this._state === AFTER_CDATA_1) {
            this._stateAfterCdata1(c);
        } else if (this._state === AFTER_CDATA_2) {
            this._stateAfterCdata2(c);
        } else if (this._state === BEFORE_SPECIAL) {

        /*
		* special tags
		*/
            this._stateBeforeSpecial(c);
        } else if (this._state === BEFORE_SPECIAL_END) {
            this._stateBeforeSpecialEnd(c);
        } else if (this._state === BEFORE_SCRIPT_1) {

        /*
		* script
		*/
            this._stateBeforeScript1(c);
        } else if (this._state === BEFORE_SCRIPT_2) {
            this._stateBeforeScript2(c);
        } else if (this._state === BEFORE_SCRIPT_3) {
            this._stateBeforeScript3(c);
        } else if (this._state === BEFORE_SCRIPT_4) {
            this._stateBeforeScript4(c);
        } else if (this._state === BEFORE_SCRIPT_5) {
            this._stateBeforeScript5(c);
        } else if (this._state === AFTER_SCRIPT_1) {
            this._stateAfterScript1(c);
        } else if (this._state === AFTER_SCRIPT_2) {
            this._stateAfterScript2(c);
        } else if (this._state === AFTER_SCRIPT_3) {
            this._stateAfterScript3(c);
        } else if (this._state === AFTER_SCRIPT_4) {
            this._stateAfterScript4(c);
        } else if (this._state === AFTER_SCRIPT_5) {
            this._stateAfterScript5(c);
        } else if (this._state === BEFORE_STYLE_1) {

        /*
		* style
		*/
            this._stateBeforeStyle1(c);
        } else if (this._state === BEFORE_STYLE_2) {
            this._stateBeforeStyle2(c);
        } else if (this._state === BEFORE_STYLE_3) {
            this._stateBeforeStyle3(c);
        } else if (this._state === BEFORE_STYLE_4) {
            this._stateBeforeStyle4(c);
        } else if (this._state === AFTER_STYLE_1) {
            this._stateAfterStyle1(c);
        } else if (this._state === AFTER_STYLE_2) {
            this._stateAfterStyle2(c);
        } else if (this._state === AFTER_STYLE_3) {
            this._stateAfterStyle3(c);
        } else if (this._state === AFTER_STYLE_4) {
            this._stateAfterStyle4(c);
        } else if (this._state === BEFORE_ENTITY) {

        /*
		* entities
		*/
            this._stateBeforeEntity(c);
        } else if (this._state === BEFORE_NUMERIC_ENTITY) {
            this._stateBeforeNumericEntity(c);
        } else if (this._state === IN_NAMED_ENTITY) {
            this._stateInNamedEntity(c);
        } else if (this._state === IN_NUMERIC_ENTITY) {
            this._stateInNumericEntity(c);
        } else if (this._state === IN_HEX_ENTITY) {
            this._stateInHexEntity(c);
        } else {
            this._cbs.onerror(Error("unknown _state"), this._state);
        }

        this._index++;
    }

    this._cleanup();
};

Tokenizer.prototype.pause = function() {
    this._running = false;
};
Tokenizer.prototype.resume = function() {
    this._running = true;

    if (this._index < this._buffer.length) {
        this._parse();
    }
    if (this._ended) {
        this._finish();
    }
};

Tokenizer.prototype.end = function(chunk) {
    if (this._ended) this._cbs.onerror(Error(".end() after done!"));
    if (chunk) this.write(chunk);

    this._ended = true;

    if (this._running) this._finish();
};

Tokenizer.prototype._finish = function() {
    //if there is remaining data, emit it in a reasonable way
    if (this._sectionStart < this._index) {
        this._handleTrailingData();
    }

    this._cbs.onend();
};

Tokenizer.prototype._handleTrailingData = function() {
    var data = this._buffer.substr(this._sectionStart);

    if (
        this._state === IN_CDATA ||
        this._state === AFTER_CDATA_1 ||
        this._state === AFTER_CDATA_2
    ) {
        this._cbs.oncdata(data);
    } else if (
        this._state === IN_COMMENT ||
        this._state === AFTER_COMMENT_1 ||
        this._state === AFTER_COMMENT_2
    ) {
        this._cbs.oncomment(data);
    } else if (this._state === IN_NAMED_ENTITY && !this._xmlMode) {
        this._parseLegacyEntity();
        if (this._sectionStart < this._index) {
            this._state = this._baseState;
            this._handleTrailingData();
        }
    } else if (this._state === IN_NUMERIC_ENTITY && !this._xmlMode) {
        this._decodeNumericEntity(2, 10);
        if (this._sectionStart < this._index) {
            this._state = this._baseState;
            this._handleTrailingData();
        }
    } else if (this._state === IN_HEX_ENTITY && !this._xmlMode) {
        this._decodeNumericEntity(3, 16);
        if (this._sectionStart < this._index) {
            this._state = this._baseState;
            this._handleTrailingData();
        }
    } else if (
        this._state !== IN_TAG_NAME &&
        this._state !== BEFORE_ATTRIBUTE_NAME &&
        this._state !== BEFORE_ATTRIBUTE_VALUE &&
        this._state !== AFTER_ATTRIBUTE_NAME &&
        this._state !== IN_ATTRIBUTE_NAME &&
        this._state !== IN_ATTRIBUTE_VALUE_SQ &&
        this._state !== IN_ATTRIBUTE_VALUE_DQ &&
        this._state !== IN_ATTRIBUTE_VALUE_NQ &&
        this._state !== IN_CLOSING_TAG_NAME
    ) {
        this._cbs.ontext(data);
    }
    //else, ignore remaining data
    //TODO add a way to remove current tag
};

Tokenizer.prototype.reset = function() {
    Tokenizer.call(
        this,
        { xmlMode: this._xmlMode, decodeEntities: this._decodeEntities },
        this._cbs
    );
};

Tokenizer.prototype.getAbsoluteIndex = function() {
    return this._bufferOffset + this._index;
};

Tokenizer.prototype._getSection = function() {
    return this._buffer.substring(this._sectionStart, this._index);
};

Tokenizer.prototype._emitToken = function(name) {
    this._cbs[name](this._getSection());
    this._sectionStart = -1;
};

Tokenizer.prototype._emitPartial = function(value) {
    if (this._baseState !== TEXT) {
        this._cbs.onattribdata(value); //TODO implement the new event
    } else {
        this._cbs.ontext(value);
    }
};


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var decodeMap = __webpack_require__(559);

module.exports = decodeCodePoint;

// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
function decodeCodePoint(codePoint) {
    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
        return "\uFFFD";
    }

    if (codePoint in decodeMap) {
        codePoint = decodeMap[codePoint];
    }

    var output = "";

    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
        codePoint = 0xdc00 | (codePoint & 0x3ff);
    }

    output += String.fromCharCode(codePoint);
    return output;
}


/***/ }),
/* 329 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","QUOT":"\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var ElementType = __webpack_require__(103);

var re_whitespace = /\s+/g;
var NodePrototype = __webpack_require__(331);
var ElementPrototype = __webpack_require__(560);

function DomHandler(callback, options, elementCB){
	if(typeof callback === "object"){
		elementCB = options;
		options = callback;
		callback = null;
	} else if(typeof options === "function"){
		elementCB = options;
		options = defaultOpts;
	}
	this._callback = callback;
	this._options = options || defaultOpts;
	this._elementCB = elementCB;
	this.dom = [];
	this._done = false;
	this._tagStack = [];
	this._parser = this._parser || null;
}

//default options
var defaultOpts = {
	normalizeWhitespace: false, //Replace all whitespace with single spaces
	withStartIndices: false, //Add startIndex properties to nodes
	withEndIndices: false, //Add endIndex properties to nodes
};

DomHandler.prototype.onparserinit = function(parser){
	this._parser = parser;
};

//Resets the handler back to starting state
DomHandler.prototype.onreset = function(){
	DomHandler.call(this, this._callback, this._options, this._elementCB);
};

//Signals the handler that parsing is done
DomHandler.prototype.onend = function(){
	if(this._done) return;
	this._done = true;
	this._parser = null;
	this._handleCallback(null);
};

DomHandler.prototype._handleCallback =
DomHandler.prototype.onerror = function(error){
	if(typeof this._callback === "function"){
		this._callback(error, this.dom);
	} else {
		if(error) throw error;
	}
};

DomHandler.prototype.onclosetag = function(){
	//if(this._tagStack.pop().name !== name) this._handleCallback(Error("Tagname didn't match!"));
	
	var elem = this._tagStack.pop();

	if(this._options.withEndIndices && elem){
		elem.endIndex = this._parser.endIndex;
	}

	if(this._elementCB) this._elementCB(elem);
};

DomHandler.prototype._createDomElement = function(properties){
	if (!this._options.withDomLvl1) return properties;

	var element;
	if (properties.type === "tag") {
		element = Object.create(ElementPrototype);
	} else {
		element = Object.create(NodePrototype);
	}

	for (var key in properties) {
		if (properties.hasOwnProperty(key)) {
			element[key] = properties[key];
		}
	}

	return element;
};

DomHandler.prototype._addDomElement = function(element){
	var parent = this._tagStack[this._tagStack.length - 1];
	var siblings = parent ? parent.children : this.dom;
	var previousSibling = siblings[siblings.length - 1];

	element.next = null;

	if(this._options.withStartIndices){
		element.startIndex = this._parser.startIndex;
	}
	if(this._options.withEndIndices){
		element.endIndex = this._parser.endIndex;
	}

	if(previousSibling){
		element.prev = previousSibling;
		previousSibling.next = element;
	} else {
		element.prev = null;
	}

	siblings.push(element);
	element.parent = parent || null;
};

DomHandler.prototype.onopentag = function(name, attribs){
	var properties = {
		type: name === "script" ? ElementType.Script : name === "style" ? ElementType.Style : ElementType.Tag,
		name: name,
		attribs: attribs,
		children: []
	};

	var element = this._createDomElement(properties);

	this._addDomElement(element);

	this._tagStack.push(element);
};

DomHandler.prototype.ontext = function(data){
	//the ignoreWhitespace is officially dropped, but for now,
	//it's an alias for normalizeWhitespace
	var normalize = this._options.normalizeWhitespace || this._options.ignoreWhitespace;

	var lastTag;

	if(!this._tagStack.length && this.dom.length && (lastTag = this.dom[this.dom.length-1]).type === ElementType.Text){
		if(normalize){
			lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
		} else {
			lastTag.data += data;
		}
	} else {
		if(
			this._tagStack.length &&
			(lastTag = this._tagStack[this._tagStack.length - 1]) &&
			(lastTag = lastTag.children[lastTag.children.length - 1]) &&
			lastTag.type === ElementType.Text
		){
			if(normalize){
				lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
			} else {
				lastTag.data += data;
			}
		} else {
			if(normalize){
				data = data.replace(re_whitespace, " ");
			}

			var element = this._createDomElement({
				data: data,
				type: ElementType.Text
			});

			this._addDomElement(element);
		}
	}
};

DomHandler.prototype.oncomment = function(data){
	var lastTag = this._tagStack[this._tagStack.length - 1];

	if(lastTag && lastTag.type === ElementType.Comment){
		lastTag.data += data;
		return;
	}

	var properties = {
		data: data,
		type: ElementType.Comment
	};

	var element = this._createDomElement(properties);

	this._addDomElement(element);
	this._tagStack.push(element);
};

DomHandler.prototype.oncdatastart = function(){
	var properties = {
		children: [{
			data: "",
			type: ElementType.Text
		}],
		type: ElementType.CDATA
	};

	var element = this._createDomElement(properties);

	this._addDomElement(element);
	this._tagStack.push(element);
};

DomHandler.prototype.oncommentend = DomHandler.prototype.oncdataend = function(){
	this._tagStack.pop();
};

DomHandler.prototype.onprocessinginstruction = function(name, data){
	var element = this._createDomElement({
		name: name,
		data: data,
		type: ElementType.Directive
	});

	this._addDomElement(element);
};

module.exports = DomHandler;


/***/ }),
/* 331 */
/***/ (function(module, exports) {

// This object will be used as the prototype for Nodes when creating a
// DOM-Level-1-compliant structure.
var NodePrototype = module.exports = {
	get firstChild() {
		var children = this.children;
		return children && children[0] || null;
	},
	get lastChild() {
		var children = this.children;
		return children && children[children.length - 1] || null;
	},
	get nodeType() {
		return nodeTypes[this.type] || nodeTypes.element;
	}
};

var domLvl1 = {
	tagName: "name",
	childNodes: "children",
	parentNode: "parent",
	previousSibling: "prev",
	nextSibling: "next",
	nodeValue: "data"
};

var nodeTypes = {
	element: 1,
	text: 3,
	cdata: 4,
	comment: 8
};

Object.keys(domLvl1).forEach(function(key) {
	var shorthand = domLvl1[key];
	Object.defineProperty(NodePrototype, key, {
		get: function() {
			return this[shorthand] || null;
		},
		set: function(val) {
			this[shorthand] = val;
			return val;
		}
	});
});


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var DomUtils = module.exports;

[
	__webpack_require__(562),
	__webpack_require__(567),
	__webpack_require__(568),
	__webpack_require__(569),
	__webpack_require__(570),
	__webpack_require__(571)
].forEach(function(ext){
	Object.keys(ext).forEach(function(key){
		DomUtils[key] = ext[key].bind(DomUtils);
	});
});


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Stream;

var Parser = __webpack_require__(326);
var WritableStream = __webpack_require__(573).Writable;
var StringDecoder = __webpack_require__(202).StringDecoder;
var Buffer = __webpack_require__(203).Buffer;

function Stream(cbs, options) {
    var parser = (this._parser = new Parser(cbs, options));
    var decoder = (this._decoder = new StringDecoder());

    WritableStream.call(this, { decodeStrings: false });

    this.once("finish", function() {
        parser.end(decoder.end());
    });
}

__webpack_require__(60)(Stream, WritableStream);

Stream.prototype._write = function(chunk, encoding, cb) {
    if (chunk instanceof Buffer) chunk = this._decoder.write(chunk);
    this._parser.write(chunk);
    cb();
};


/***/ }),
/* 334 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = generatePropsFromAttributes;

var _htmlAttributesToReact = __webpack_require__(580);

var _htmlAttributesToReact2 = _interopRequireDefault(_htmlAttributesToReact);

var _inlineStyleToObject = __webpack_require__(583);

var _inlineStyleToObject2 = _interopRequireDefault(_inlineStyleToObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Generates props for a React element from an object of HTML attributes
 *
 * @param {Object} attributes The HTML attributes
 * @param {String} key The key to give the react element
 */
function generatePropsFromAttributes(attributes, key) {

  // generate props
  var props = _extends({}, (0, _htmlAttributesToReact2.default)(attributes), { key: key });

  // if there is an inline/string style prop then convert it to a React style object
  // otherwise, it is invalid and omitted
  if (typeof props.style === 'string' || props.style instanceof String) {
    props.style = (0, _inlineStyleToObject2.default)(props.style);
  } else {
    delete props.style;
  }

  return props;
}

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isValidTagOrAttributeName;
var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/;

var nameCache = {};

function isValidTagOrAttributeName(tagName) {
  if (!nameCache.hasOwnProperty(tagName)) {
    nameCache[tagName] = VALID_TAG_REGEX.test(tagName);
  }
  return nameCache[tagName];
}

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_ComponentRegistry_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_NoComponent__ = __webpack_require__(619);
var ComponentHelper=function ComponentHelper(userStore){var prefix=null;if(userStore&&userStore.getSchoolPrefix){prefix=userStore.getSchoolPrefix()&&userStore.getSchoolPrefix().length>0?userStore.getSchoolPrefix():"";}else{prefix="";}return{getCmp:function getCmp(cmpName){if(cmpName){if(prefix&&__WEBPACK_IMPORTED_MODULE_0__model_ComponentRegistry_js__["a" /* default */].exists(prefix+cmpName.toLowerCase())){console.log("Component found with the prefix :  ",prefix+cmpName.toLowerCase());return __WEBPACK_IMPORTED_MODULE_0__model_ComponentRegistry_js__["a" /* default */].get(prefix+cmpName.toLowerCase());}else if(__WEBPACK_IMPORTED_MODULE_0__model_ComponentRegistry_js__["a" /* default */].exists(cmpName)){console.log("Default Component found : ",cmpName);return __WEBPACK_IMPORTED_MODULE_0__model_ComponentRegistry_js__["a" /* default */].get(cmpName);}}console.warn("The component does not exist or may not have been registered: ",cmpName);return __WEBPACK_IMPORTED_MODULE_1__components_common_NoComponent__["a" /* default */];},getCmpByName:function getCmpByName(cmpName){var altCmpName=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;/**
			* IMPORTANT: The following is purely based on assumption that
			* _ is used just for prefix and not while registering any component.
			*/if(!altCmpName&&cmpName){try{altCmpName=cmpName.includes("_")?cmpName.split("_")[1]:cmpName;}catch(e){altCmpName=cmpName;console.error(e);}}if(cmpName&&__WEBPACK_IMPORTED_MODULE_0__model_ComponentRegistry_js__["a" /* default */].exists(cmpName.toLowerCase())){console.log("Component found :  ",cmpName.toLowerCase());return __WEBPACK_IMPORTED_MODULE_0__model_ComponentRegistry_js__["a" /* default */].get(cmpName.toLowerCase());}else if(altCmpName&&__WEBPACK_IMPORTED_MODULE_0__model_ComponentRegistry_js__["a" /* default */].exists(altCmpName.toLowerCase())){console.log("Default Component found : ",altCmpName);return __WEBPACK_IMPORTED_MODULE_0__model_ComponentRegistry_js__["a" /* default */].get(altCmpName);}console.warn("The component does not exist or may not have been registered: ",cmpName);return __WEBPACK_IMPORTED_MODULE_1__components_common_NoComponent__["a" /* default */];}};};/* harmony default export */ __webpack_exports__["a"] = (ComponentHelper);

/***/ }),
/* 338 */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_UrlManager__ = __webpack_require__(104);
/**
* This function needs UserStore to be passed as part of the constructor to work. from LoggedInPage
*/var AttributeManager=function AttributeManager(userStore){var updateToServer=function updateToServer(attr_key,attr_value,callback){var me=this;var success=function success(userObj){if(userObj){userStore.store(userObj);}if(callback&&typeof callback==="function"){callback.apply(this);}};var failure=function failure(error){if(callback&&typeof callback==="function"){callback.apply(this);}};var attrData={"attr_key":attr_key,"attr_value":attr_value};new __WEBPACK_IMPORTED_MODULE_0__HmAjax__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__model_UrlManager__["a" /* default */].getUrlForAction("UPDATE_ATTRIBUTE"),attrData).post(success,failure);};var removeFromServer=function removeFromServer(attr_key,callback){var me=this;var success=function success(userObj){if(userObj){userStore.store(userObj);}if(callback&&typeof callback==="function"){callback.apply(this);}};var failure=function failure(error){if(callback&&typeof callback==="function"){callback.apply(this);}};var attrData={"attr_key":attr_key};new __WEBPACK_IMPORTED_MODULE_0__HmAjax__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__model_UrlManager__["a" /* default */].getUrlForAction("REMOVE_ATTRIBUTE"),attrData).delete(success,failure);};return{update:function update(attr_key,attr_value,callback){updateToServer(attr_key,attr_value,callback);},remove:function remove(attr_key,callback){removeFromServer(attr_key,callback);}};};/* harmony default export */ __webpack_exports__["a"] = (AttributeManager);

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_LoggedInPage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_patterns_profilebg_png__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_patterns_profilebg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_patterns_profilebg_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_icons_lessonmenuicon_png__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_icons_lessonmenuicon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_icons_lessonmenuicon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_lessonmenuiconwhite_png__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_lessonmenuiconwhite_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_icons_lessonmenuiconwhite_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_AppConstants_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_plp_TestTakingModalComponent__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_UserStorageUtil__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChooseGrade__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__css_Sidebar_css__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__css_Sidebar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__css_Sidebar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dropdown__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dropdown_style_css__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dropdown_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_dropdown_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__model_ComponentRegistry__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__config_sidebarMenus_json__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__config_sidebarMenus_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__config_sidebarMenus_json__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var menus=__WEBPACK_IMPORTED_MODULE_5__model_AppConstants_js__["a" /* default */].menus;var loadingView="loadingView";var topicView="topicView";var subTopicView="subTopicView";var messageView="messageView";var productExpiredView="productExpiredView";var allTopicsView="allTopicsView";var pointsSystemView="pointsSystemView";var noProductView="noProductView";var homeView="homeView";var Sidebar=function(_LoggedInPage){_inherits(Sidebar,_LoggedInPage);function Sidebar(props){_classCallCheck(this,Sidebar);var _this=_possibleConstructorReturn(this,(Sidebar.__proto__||Object.getPrototypeOf(Sidebar)).call(this,props));_this.state={selectedID:0,userName:_this.getUser().getUserName(),imagePreviewUrl:"",imageLoaded:false,productArr:[],gradeArr:[],productExpired:false,noProducts:false,view:homeView,lessonIconDisplay:__WEBPACK_IMPORTED_MODULE_3__images_icons_lessonmenuicon_png___default.a,grademodalShow:false,grademodalTitle:"Test",grademodalContent:""};_this.openProfile=_this.openProfile.bind(_this);_this.sideBarDropdownChange=_this.sideBarDropdownChange.bind(_this);_this.handleMouseOver=_this.handleMouseOver.bind(_this);_this.handleMouseOut=_this.handleMouseOut.bind(_this);_this.gradeChangefromChooseGrade=_this.gradeChangefromChooseGrade.bind(_this);_this.showHideLeftMenu=_this.showHideLeftMenu.bind(_this);_this.accessId=0;_this.gradeProductMap={};_this.classDefnMap={};_this.selectedGradeOption=null;_this.selectedProductOption=null;_this.comboNamesLoaded=false;_this.gradeStore=null;_this.homeDropDownKey="homeDropdown";_this.preferredGrade=null;_this.preferredProduct=null;_this.gradeStore=null;_this.entlKey=null;_this.getProductCount=_this.getProductCount.bind(_this);_this.showFormobile=_this.showFormobile.bind(_this);_this.getMenusFromJson=_this.getMenusFromJson.bind(_this);_this.goTo=_this.goTo.bind(_this);return _this;}_createClass(Sidebar,[{key:'updateUserName',value:function updateUserName(username){this.setState({userName:username});}},{key:'componentDidMount',value:function componentDidMount(){var me=this;this.props.onRef(this);this.loadCurrentImage();this.setState({selectedID:0});if(this.productsAvailableToAccess()){this.setPreferredDd();if(this.props.childComponentName=="DASHBOARD"){this.getGradeListDashboard();}else{this.getGradeListTopic();}}else{this.setState({noProducts:true,view:noProductView});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_13_jquery___default()(".page-content nav.side-navbar ul li").addClass("noclicks");me.sideBarDropdownChange();},300);}try{var isCollapsed=this.getAttribute("sidebar_collapsed")==="true";__WEBPACK_IMPORTED_MODULE_5__model_AppConstants_js__["a" /* default */].collapsed=isCollapsed||__WEBPACK_IMPORTED_MODULE_5__model_AppConstants_js__["a" /* default */].collapsed;if(__WEBPACK_IMPORTED_MODULE_5__model_AppConstants_js__["a" /* default */].collapsed===true){__WEBPACK_IMPORTED_MODULE_13_jquery___default()(".page-content .content-inner").toggleClass("fullwidth");__WEBPACK_IMPORTED_MODULE_13_jquery___default()(".page-content nav.side-navbar").toggle();__WEBPACK_IMPORTED_MODULE_13_jquery___default()(".page-content nav.side-navbar").toggleClass('collapsed');}}catch(e){console.error(e);}}},{key:'gradeSorter',value:function gradeSorter(response){var allCountryMap={};Object.values(response).map(function(grade,index){if(grade&&grade.countryCode){var tempArr=allCountryMap[grade.countryCode];if(!tempArr){tempArr=[];allCountryMap[grade.countryCode]=tempArr;}tempArr.push(grade);}});var _loop=function _loop(each){var sorter=window.choose_grade_sorter[each]||window.choose_grade_sorter["ALL"];var sortedArr=allCountryMap[each];var sortingField=sorter.field;if(sortingField&&sortedArr&&sortedArr.length>0&&sortedArr[0][sortingField]){var sortingType=sorter.type||(!isNaN(sortedArr[0][sortingField])?"number":"string");sortedArr.sort(function(a,b){if(sortingType==="number"){return a[sortingField]-b[sortingField];}else if(sortingType==="string"){if(a[sortingField]&&b[sortingField]){if(a[sortingField].toLowerCase()<b[sortingField].toLowerCase()){return-1;}else if(a[sortingField].toLowerCase()>b[sortingField].toLowerCase()){return 1;}}}return 0;});}sortedArr=sorter.order==="desc"?sortedArr.reverse():sortedArr;};for(var each in allCountryMap){_loop(each);}var sortedGrades={};var leastGradePerCountry={};Object.values(allCountryMap).map(function(gradeArr,ind){if(gradeArr&&gradeArr.length>0){gradeArr.map(function(grade,gInd){sortedGrades[String(grade.classId)]=grade;if(!leastGradePerCountry[grade.countryCode]){leastGradePerCountry[grade.countryCode]=grade;}});}});//console.warn("lalala unsorted :: ", response);
//console.warn("lalala sorted :: ", sortedGrades);
//console.warn("lalala leastGradePerCountry :: ", leastGradePerCountry);
return sortedGrades;}},{key:'compoenentWillMount',value:function compoenentWillMount(){this.props.onRef(undefined);}},{key:'gradeDropdownChange',value:function gradeDropdownChange(gradeOption,prodOption){this.selectedGradeOption=gradeOption;this.selectedProductOption=prodOption;this.getProductList();}},{key:'gradeChange',value:function gradeChange(event){var me=this;var selectedIndex=parseInt(event.currentTarget.dataset.index);this.selectedGradeOption=this.state.gradeArr[selectedIndex];this.getProductList();}},{key:'gradeChangefromChooseGrade',value:function gradeChangefromChooseGrade(gradeIndex,prodIndex,entlKey){this.setPreferredDd();this.selectedGradeOption=this.state.gradeArr[gradeIndex];this.selectedProductOption=this.state.productArr[prodIndex];this.entlKey=entlKey;this.getProductList();this.hidegradeModal();}},{key:'productChange',value:function productChange(event){var me=this;var selectedIndex=parseInt(event.currentTarget.dataset.index);this.selectedProductOption=this.state.productArr&&this.state.productArr.find(function(elem){return elem.id==selectedIndex;})?this.state.productArr.find(function(elem){return elem.id==selectedIndex;}):null;if(!this.selectedProductOption){return;}else{this.setPreferredDd();}this.setState({selectedID:parseInt(event.currentTarget.dataset.id)});if(event.currentTarget.dataset.label.toLowerCase()=="lessons"){this.setState({selectedID:parseInt(event.currentTarget.dataset.id),lessonIconDisplay:__WEBPACK_IMPORTED_MODULE_4__images_icons_lessonmenuiconwhite_png___default.a});}else{this.setState({selectedID:parseInt(event.currentTarget.dataset.id),lessonIconDisplay:__WEBPACK_IMPORTED_MODULE_3__images_icons_lessonmenuicon_png___default.a});}this.sideBarDropdownChange(true);try{this.gradeStore={"grd":this.selectedGradeOption.value,"prod":this.selectedProductOption.value};this.setAttribute(this.homeDropDownKey,JSON.stringify(this.gradeStore),function(){me.props.routingMenus("/landing");});}catch(e){me.props.routingMenus("/landing");}}},{key:'productsAvailableToAccess',value:function productsAvailableToAccess(){var user=this.getUser();if(user!=null){var permissions=user.getEntlHistory();if(permissions!=null&&Object.keys(permissions).length>0){for(var i in permissions){if(permissions[i]!=null){var totalLevel=permissions[i].split(",").reduce(function(a,b){try{return parseInt(a)+parseInt(b);}catch(e){return 0;}});if(totalLevel>0){return true;}}}}}return false;}},{key:'setPreferredDd',value:function setPreferredDd(){try{var gradeStore=null;var prefStr=this.getAttribute(this.homeDropDownKey);if(prefStr)gradeStore=JSON.parse(prefStr);if((typeof gradeStore==='undefined'?'undefined':_typeof(gradeStore))==="object"){this.preferredGrade=gradeStore["grd"];this.preferredProduct=gradeStore["prod"];;}}catch(e){}}},{key:'getGradeListDashboard',value:function getGradeListDashboard(){var me=this;var callBack=function callBack(response){var grades=response.classId;var products=response.accessId;var classDefnMap=response.classDefn;me.gradeProductMap=response.gradeProdMap;me.classDefnMap=classDefnMap;var gradeArr=[];var preselectIndex=0;var groupedGradesList=[];if(grades!==null&&grades.length>0){for(var i=0;i<grades.length;i++){if(grades[i]>0){try{var dropDownLabel=me.rb(classDefnMap[grades[i]].className);if(classDefnMap[grades[i]]&&classDefnMap[grades[i]].gradeId){/**
							* IMPORTANT: Replace classId with gradeId when available.
							* This is for grouped classes
							*/var gradeDisplayName=me.rb(classDefnMap[grades[i]].gradeDisplayName);classDefnMap[grades[i]]["label"]=gradeDisplayName;classDefnMap[grades[i]]["value"]=grades[i];gradeArr.push(classDefnMap[grades[i]]);}else{classDefnMap[grades[i]]["label"]=dropDownLabel;classDefnMap[grades[i]]["value"]=grades[i];gradeArr.push(classDefnMap[grades[i]]);}}catch(e){}}}}if(gradeArr&&gradeArr.length>0){for(var i=0;i<gradeArr.length;i++){if(gradeArr[i].value==me.preferredGrade){preselectIndex=i;}}}me.selectedGradeOption=gradeArr[preselectIndex];me.setState({gradeArr:gradeArr});me.getProductList();};this.getClassNamesDashboard(callBack);}},{key:'getClassNamesDashboard',value:function getClassNamesDashboard(callBack){var me=this;var callBackSuccess=function callBackSuccess(response){me.comboNamesLoaded=true;callBack.apply(this,[response]);};var callBackFailure=function callBackFailure(error){me.showAlert(me.rb("503.title"),me.rb("503.msg"));};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("DASH_COMBO_DATA")).get(callBackSuccess,callBackFailure);}},{key:'getGradeListTopic',value:function getGradeListTopic(){var me=this;var gradeProductMap=this.gradeProductMap;var entlhistory=this.getUser().getEntlHistory();for(var i in entlhistory){try{if(entlhistory[i]!==undefined&&entlhistory[i]!==null&&entlhistory[i].length>0){var tempKeysArr=entlhistory[i].split(",");if(tempKeysArr.length>0){for(var j=0;j<tempKeysArr.length;j++){var existingArr=gradeProductMap[tempKeysArr[j]];if(existingArr===undefined||existingArr===null){existingArr=[];}existingArr.push(i);gradeProductMap[tempKeysArr[j]]=existingArr;}}}}catch(e){console.error(e);}}this.gradeProductMap=gradeProductMap;var groupedGradesList=[];var grades=Object.keys(gradeProductMap);var callBack=function callBack(classDefnMap){var gradeArr=[];var preselectIndex=0;me.classDefnMap=classDefnMap;if(grades!==null&&grades.length>0){for(var i=0;i<grades.length;i++){if(grades[i]>0){try{var dropDownLabel=me.rb(classDefnMap[grades[i]].className);if(classDefnMap[grades[i]]&&classDefnMap[grades[i]].gradeId){/**
							* IMPORTANT: Replace classId with gradeId when available.
							* This is for grouped classes
							*/var gradeDisplayName=me.rb(classDefnMap[grades[i]].gradeDisplayName);classDefnMap[grades[i]]["label"]=gradeDisplayName;classDefnMap[grades[i]]["value"]=grades[i];gradeArr.push(classDefnMap[grades[i]]);}else{classDefnMap[grades[i]]["label"]=dropDownLabel;classDefnMap[grades[i]]["value"]=grades[i];gradeArr.push(classDefnMap[grades[i]]);}}catch(e){}}}}if(gradeArr&&gradeArr.length>0){for(var i=0;i<gradeArr.length;i++){if(gradeArr[i].value==me.preferredGrade){preselectIndex=i;}}}me.selectedGradeOption=gradeArr[preselectIndex];me.setState({gradeArr:gradeArr});me.getProductList();};this.getClassNamesTopic(grades,callBack);}},{key:'getClassNamesTopic',value:function getClassNamesTopic(classIds,callBack){var me=this;var callBackSuccess=function callBackSuccess(response){me.comboNamesLoaded=true;var sortedArr=me.gradeSorter(response);callBack.apply(this,[response]);};var callBackFailure=function callBackFailure(error){me.showAlert(me.rb("503.title"),me.rb("503.msg"));};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("CLASS_DEFN"),classIds).post(callBackSuccess,callBackFailure);}},{key:'getProductList',value:function getProductList(){var preselectIndex=0;var gradeProductMap=this.gradeProductMap;var permissionMap=this.getUser().getPermissions();var permissions=gradeProductMap[this.selectedGradeOption.value];var accessMap=this.getUser().getAccessMap();var reverseAccessMap=this.getUser().getReverseAccessMap();var lessonIconDisplay=__WEBPACK_IMPORTED_MODULE_3__images_icons_lessonmenuicon_png___default.a;if(permissions.length>0){var productArr=[];for(var i=0;i<permissions.length;i++){var classCode=this.classDefnMap[this.selectedGradeOption.value].classCode;var board=this.classDefnMap[this.selectedGradeOption.value].board;var label=this.rb(accessMap[permissions[i]]+"-"+classCode+"-"+board)||this.rb("label-"+permissions[i]+"-"+classCode+"-"+board);if(label===accessMap[permissions[i]]+"-"+classCode+"-"+board||label==="label-"+permissions[i]+"-"+classCode+"-"+board){label=this.rb(accessMap[permissions[i]]+"-menu")||this.rb("label-"+permissions[i]);}var materilkey='assignment';if(permissions[i]==3){materilkey='ondemand_video';}if(reverseAccessMap){permissions[i]=reverseAccessMap[accessMap[permissions[i]]];}productArr.push({entlKey:accessMap[permissions[i]],"label":label,"value":permissions[i],'id':permissions[i],'materialkey':materilkey});if(permissions[i]==parseInt(this.preferredProduct)){preselectIndex=i;if(parseInt(this.preferredProduct)==3){lessonIconDisplay=__WEBPACK_IMPORTED_MODULE_4__images_icons_lessonmenuiconwhite_png___default.a;}}}this.selectedProductOption=productArr[preselectIndex];var selectedProductId=this.selectedProductOption.id;var prodClicked=false;if(this.props.childComponentName=="DASHBOARD"){selectedProductId=1001;lessonIconDisplay=__WEBPACK_IMPORTED_MODULE_3__images_icons_lessonmenuicon_png___default.a;}else{prodClicked=true;}this.setState({productArr:productArr,selectedID:selectedProductId,lessonIconDisplay:lessonIconDisplay});this.sideBarDropdownChange(prodClicked);}else{this.setState({message:this.rb("home.not_entitled"),view:messageView});this.sideBarDropdownChange();this.showAlert("",this.rb("home.not_entitled"));}}},{key:'openProfile',value:function openProfile(){try{this.props.myProps.history.push("/settings");}catch(e){}}},{key:'profilePicToggle',value:function profilePicToggle(enable){var elems=document.getElementsByClassName("avatar");if(enable){if(elems&&elems.length>0){elems[0].classList.add("active");elems[0].classList.remove("inactive");}}else{if(elems&&elems.length>0){elems[0].classList.add("inactive");elems[0].classList.remove("active");}}}},{key:'sideBarDropdownChange',value:function sideBarDropdownChange(){var isProductClicked=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;this.props.sideBarDropdownChange(this.selectedGradeOption,this.selectedProductOption,this.comboNamesLoaded,this.state,isProductClicked);}},{key:'leftmenuclick',value:function leftmenuclick(event){this.setState({selectedID:event.currentTarget.dataset.id,lessonIconDisplay:__WEBPACK_IMPORTED_MODULE_3__images_icons_lessonmenuicon_png___default.a});this.props.routingMenus(event.currentTarget.dataset.value);}},{key:'deleteCurrentImage',value:function deleteCurrentImage(){this.setState({imageLoaded:false});}},{key:'loadCurrentImage',value:function loadCurrentImage(){var me=this;var success=function success(response){if(response&&response.imgUrl){me.setState({imagePreviewUrl:response.imgUrl,imageLoaded:true});}};var failure=function failure(err){};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("PROFILE_PIC")).get(success,failure);}},{key:'setCurrentImage',value:function setCurrentImage(imageUrl){this.setState({imagePreviewUrl:imageUrl,imageLoaded:true});}/*
	* IMPORTANT: This is the place to modify the menus to be rendered dynamically - Shyam
	*/},{key:'getSideBarMenus',value:function getSideBarMenus(){var _this2=this;var me=this;var elements=menus.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index,className:me.rb(element.label)+" leftmenu "+(parseInt(_this2.state.selectedID)===parseInt(element.id)?"active":""),onClick:_this2.leftmenuclick.bind(_this2),'data-id':element.id,'data-value':element.value},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},element.materialkey),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'leftmenutxt'},me.rb(element.label)),' '));});return elements;}},{key:'showGradeSelection',value:function showGradeSelection(){if(this.getProductCount()<2){return;}this.setState({grademodalShow:true,grademodalContent:this.getGradeMoalContent(),grademodalTitle:""});}},{key:'getProductCount',value:function getProductCount(){var orphanClassIds=new Set();var groupedGradeIds=new Set();var tempGradeArr=this.state.gradeArr;if(tempGradeArr&&tempGradeArr.length>0){for(var i=0;i<tempGradeArr.length;i++){if(tempGradeArr[i]&&tempGradeArr[i].classId){if(!isNaN(tempGradeArr[i].gradeId)&&tempGradeArr[i].gradeId>0){groupedGradeIds.add(tempGradeArr[i].gradeId);}else if(!isNaN(tempGradeArr[i].classId)&&tempGradeArr[i].classId>0){orphanClassIds.add(tempGradeArr[i].classId);}}}return orphanClassIds.size+groupedGradeIds.size;}else{return 0;}//return (this.state.gradeArr) ? this.state.gradeArr.length : 0;
}},{key:'getGradeMoalContent',value:function getGradeMoalContent(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ChooseGrade__["a" /* default */],{gradeArr:this.state.gradeArr,gradeProductMap:this.gradeProductMap,selectedGradeOption:this.selectedGradeOption,selectedProductOption:this.selectedProductOption,gradeChangefromChooseGrade:this.gradeChangefromChooseGrade});}},{key:'hidegradeModal',value:function hidegradeModal(){this.setState({grademodalShow:false,grademodalContent:"",grademodalTitle:""});}},{key:'loadgradeModalContent',value:function loadgradeModalContent(){if(this.state.grademodalContent!=""){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.grademodalContent);}}},{key:'getLabelByBoard',value:function getLabelByBoard(element){var board=element&&element.board?element.board:null;var labelFieldsForBoard=board&&window.choose_grade_label_fields_for_boards&&window.choose_grade_label_fields_for_boards[board]?window.choose_grade_label_fields_for_boards[board]:null;if(labelFieldsForBoard!=null){if(labelFieldsForBoard.length>1){return this.rb(element[labelFieldsForBoard[1]]);}return this.rb(element[labelFieldsForBoard[0]]);}else if(board&&board.toUpperCase()==="RSA"){if(element&&element.classDescription&&element.classDescription.length>0){return this.rb(element.classDescription);}else if(element&&element.className&&element.className.length>0){return this.rb(element.className);}}return null;}},{key:'getGradeMenus',value:function getGradeMenus(){var me=this;var gradeMenuTxt=this.getLabelByBoard(this.selectedGradeOption);if(gradeMenuTxt&&gradeMenuTxt.length>0){//Do nothing
}else if(this.selectedGradeOption&&this.selectedGradeOption.gradeDisplayName&&this.selectedGradeOption.gradeDisplayName.length>0&&this.selectedGradeOption.gradeDisplayName!=="null"){gradeMenuTxt=this.rb(this.selectedGradeOption.gradeDisplayName);}else if(this.selectedGradeOption&&this.selectedGradeOption.classDescription&&this.selectedGradeOption.classDescription.length>0&&this.selectedGradeOption.classDescription!=="null"){return this.rb(this.selectedGradeOption.classDescription);}else{//Older approach
gradeMenuTxt=this.rb(this.selectedGradeOption.label);}var singleGradeMenuStyle={pointerEvents:"none",opacity:0.7};if(this.getProductCount()<2){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'',style:singleGradeMenuStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'',href:'#',id:'navbardrop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'school'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'leftmenutxt'},gradeMenuTxt)));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'',onClick:this.showGradeSelection.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'',href:'#',id:'navbardrop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'school'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'leftmenutxt'},gradeMenuTxt),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons absolute'},'arrow_right')));}}},{key:'handleMouseOver',value:function handleMouseOver(event){this.setState({lessonIconDisplay:__WEBPACK_IMPORTED_MODULE_4__images_icons_lessonmenuiconwhite_png___default.a});}},{key:'handleMouseOut',value:function handleMouseOut(event){if(!__WEBPACK_IMPORTED_MODULE_13_jquery___default()(event.currentTarget).hasClass("active")){this.setState({lessonIconDisplay:__WEBPACK_IMPORTED_MODULE_3__images_icons_lessonmenuicon_png___default.a});}}},{key:'isLessonTabAvailable',value:function isLessonTabAvailable(){//This is restricted to only Mobile check for now
return this.showFormobile();}},{key:'showFormobile',value:function showFormobile(){var isMobileOrTab=this.isTab()||this.isMobile();var lessonLockForGrades=window.lessonLockForGrades||[];var gradeVal=!isNaN(this.selectedGradeOption.value)?Number(this.selectedGradeOption.value):0;return!(lessonLockForGrades.indexOf(gradeVal)>-1&&isMobileOrTab);}},{key:'getProductMenus',value:function getProductMenus(){var _this3=this;var me=this;var elements=this.state.productArr.map(function(element,index){if(element.label.toLowerCase()=="lessons"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index,'data-ga':"Post login - "+_this3.selectedGradeOption.label+" - "+element.label,className:element.label+" leftmenu "+(parseInt(_this3.state.selectedID)===parseInt(element.id)?"active":""),'data-index':index,'data-id':element.id,'data-value':element.value,'data-label':element.label,onClick:_this3.productChange.bind(_this3),onMouseOver:_this3.handleMouseOver,onMouseOut:_this3.handleMouseOut},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'va-inherit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'material-icons',src:_this3.state.lessonIconDisplay})),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'leftmenutxt'},element.label),' '));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index,'data-ga':"Post login - "+_this3.selectedGradeOption.label+" - "+element.label,className:element.label+" leftmenu "+(parseInt(_this3.state.selectedID)===parseInt(element.id)?"active":""),'data-index':index,'data-id':element.id,'data-value':element.value,'data-label':element.label,onClick:_this3.productChange.bind(_this3)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},element.materialkey),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'leftmenutxt'},element.label),' '));}});return elements;}},{key:'showHideLeftMenu',value:function showHideLeftMenu(){__WEBPACK_IMPORTED_MODULE_13_jquery___default()(".page-content .content-inner").toggleClass("fullwidth");__WEBPACK_IMPORTED_MODULE_13_jquery___default()(".page-content nav.side-navbar").toggle();__WEBPACK_IMPORTED_MODULE_13_jquery___default()(".page-content nav.side-navbar").toggleClass('collapsed');var isCollapsed=__WEBPACK_IMPORTED_MODULE_13_jquery___default()('nav.side-navbar').hasClass('collapsed');if(typeof isCollapsed==="boolean"){this.setAttribute("sidebar_collapsed",isCollapsed.toString());}__WEBPACK_IMPORTED_MODULE_5__model_AppConstants_js__["a" /* default */].collapsed=__WEBPACK_IMPORTED_MODULE_13_jquery___default()('nav.side-navbar').hasClass('collapsed');__WEBPACK_IMPORTED_MODULE_8__util_UserStorageUtil__["a" /* default */].storeSessionItem("sidebar_collapsed",__WEBPACK_IMPORTED_MODULE_5__model_AppConstants_js__["a" /* default */].collapsed);}},{key:'getMenusFromJson',value:function getMenusFromJson(){var me=this;var accessMap=me.getUser().getAccessMap();var reverseAccessMap=me.getUser().getReverseAccessMap();if(__WEBPACK_IMPORTED_MODULE_16__config_sidebarMenus_json___default.a&&Object.keys(__WEBPACK_IMPORTED_MODULE_16__config_sidebarMenus_json___default.a).length>0){return Object.values(__WEBPACK_IMPORTED_MODULE_16__config_sidebarMenus_json___default.a).map(function(element,index){var menuAvailable=false;if(element&&element.allowedEntlKeys&&element.allowedEntlKeys.length>0&&me.state.productArr&&me.state.productArr.length>0){me.state.productArr.map(function(prod,idx){//console.warn("lalala menus loop::" ,me.state.productArr," : ",index);
if(prod&&prod.entlKey&&element.allowedEntlKeys&&element.allowedEntlKeys.length>0&&~element.allowedEntlKeys.indexOf(prod.entlKey)){menuAvailable=true;return;}});}else{menuAvailable=true;}if(element&&menuAvailable){if(reverseAccessMap&&element.entlKey&&element.entlKey.length>0&&!isNaN(reverseAccessMap[element.entlKey])){element.id=reverseAccessMap[element.entlKey];element.value=reverseAccessMap[element.entlKey];element.index=reverseAccessMap[element.entlKey];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index,onClick:me.goTo,'data-ga':"Post login - "+me.selectedGradeOption.label+" - "+element.label,className:element.label+" leftmenu "+(me.state.selectedID==element.id?"active":""),'data-route':element.route,'data-index':element.index,'data-id':element.id,'data-value':element.value,'data-label':element.label},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},element.materialkey),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'leftmenutxt'},element.label),' '));}});}}},{key:'goTo',value:function goTo(element){var route=element.currentTarget.dataset.route||'';if(route!=''){this.productChange(element);}else{this.leftmenuclick(element);}}/*
	* IMPORTANT: This is the place to modify the menus to be rendered dynamically - Shyam
	*/},{key:'renderSidebarTab',value:function renderSidebarTab(){var me=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list-unstyled'},function(){if(me.comboNamesLoaded){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,me.getGradeMenus(),me.getMenusFromJson());}}());}},{key:'renderHumburger',value:function renderHumburger(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'showhidemenu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'toggle-btn',href:'#',className:'menu-btn active',onClick:this.showHideLeftMenu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'menu')));}},{key:'render',value:function render(){var headerImgStyle={backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_2__images_patterns_profilebg_png___default.a+')',backgroundSize:"cover"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pos_relative'},this.renderHumburger(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'side-navbar'},this.renderSidebarTab()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__views_plp_TestTakingModalComponent__["a" /* default */],{visible:this.state.grademodalShow,dialogClassName:'fullwidthdiag grademodal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-header bg-purple'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-title'},this.state.grademodalTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close',onClick:this.hidegradeModal.bind(this),'data-ga':"Post login - Choose your Class - Close",'aria-label':'Close'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'close')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-body testModalBody'},this.loadgradeModalContent()))));}}]);return Sidebar;}(__WEBPACK_IMPORTED_MODULE_1__views_core_LoggedInPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Sidebar);__WEBPACK_IMPORTED_MODULE_14__model_ComponentRegistry__["a" /* default */].register("Sidebar",Sidebar);

/***/ }),
/* 341 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WebQuestionView__ = __webpack_require__(668);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WebQuestionPanel=function(_React$Component){_inherits(WebQuestionPanel,_React$Component);function WebQuestionPanel(props){_classCallCheck(this,WebQuestionPanel);var _this=_possibleConstructorReturn(this,(WebQuestionPanel.__proto__||Object.getPrototypeOf(WebQuestionPanel)).call(this,props));_this.markedquesFn=_this.markedquesFn.bind(_this);_this.state={isStarView:false};return _this;}_createClass(WebQuestionPanel,[{key:'markedquesFn',value:function markedquesFn(event){//event.currentTarget.classList.toggle("selected")
this.setState({isStarView:!this.state.isStarView});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'qcont'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__WebQuestionView__["a" /* default */],{qno:this.props.qno,qdata:this.props.qdata,ga:this.props.ga,callbackParent:this.markedquesFn,existingRatingObj:this.props.existingRatingObj,accessId:this.props.accessId,classId:this.props.classId,recomLocked:this.props.recomLocked}));}}]);return WebQuestionPanel;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (WebQuestionPanel);

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(669);

__webpack_require__(866);

__webpack_require__(867);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(22) && !__webpack_require__(13)(function () {
  return Object.defineProperty(__webpack_require__(216)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(19);


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(44);
var toIObject = __webpack_require__(45);
var arrayIndexOf = __webpack_require__(157)(false);
var IE_PROTO = __webpack_require__(218)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(24);
var anObject = __webpack_require__(8);
var getKeys = __webpack_require__(84);

module.exports = __webpack_require__(22) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(45);
var gOPN = __webpack_require__(87).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(22);
var getKeys = __webpack_require__(84);
var gOPS = __webpack_require__(158);
var pIE = __webpack_require__(133);
var toObject = __webpack_require__(27);
var IObject = __webpack_require__(132);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(13)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 350 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(34);
var isObject = __webpack_require__(14);
var invoke = __webpack_require__(352);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 352 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(9).parseInt;
var $trim = __webpack_require__(111).trim;
var ws = __webpack_require__(222);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(9).parseFloat;
var $trim = __webpack_require__(111).trim;

module.exports = 1 / $parseFloat(__webpack_require__(222) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(52);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(14);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 357 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(225);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(8);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(34);
var toObject = __webpack_require__(27);
var IObject = __webpack_require__(132);
var toLength = __webpack_require__(21);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(27);
var toAbsoluteIndex = __webpack_require__(85);
var toLength = __webpack_require__(21);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(237);
__webpack_require__(1)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(22) && /./g.flags != 'g') __webpack_require__(24).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(134)
});


/***/ }),
/* 365 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var isObject = __webpack_require__(14);
var newPromiseCapability = __webpack_require__(241);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(368);
var validate = __webpack_require__(92);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(166)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(24).f;
var create = __webpack_require__(86);
var redefineAll = __webpack_require__(91);
var ctx = __webpack_require__(51);
var anInstance = __webpack_require__(89);
var forOf = __webpack_require__(90);
var $iterDefine = __webpack_require__(227);
var step = __webpack_require__(362);
var setSpecies = __webpack_require__(88);
var DESCRIPTORS = __webpack_require__(22);
var fastKey = __webpack_require__(78).fastKey;
var validate = __webpack_require__(92);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(368);
var validate = __webpack_require__(92);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(166)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9);
var each = __webpack_require__(66)(0);
var redefine = __webpack_require__(41);
var meta = __webpack_require__(78);
var assign = __webpack_require__(349);
var weak = __webpack_require__(371);
var isObject = __webpack_require__(14);
var validate = __webpack_require__(92);
var NATIVE_WEAK_MAP = __webpack_require__(92);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(166)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(91);
var getWeak = __webpack_require__(78).getWeak;
var anObject = __webpack_require__(8);
var isObject = __webpack_require__(14);
var anInstance = __webpack_require__(89);
var forOf = __webpack_require__(90);
var createArrayMethod = __webpack_require__(66);
var $has = __webpack_require__(44);
var validate = __webpack_require__(92);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(53);
var toLength = __webpack_require__(21);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(87);
var gOPS = __webpack_require__(158);
var anObject = __webpack_require__(8);
var Reflect = __webpack_require__(9).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(159);
var isObject = __webpack_require__(14);
var toLength = __webpack_require__(21);
var ctx = __webpack_require__(51);
var IS_CONCAT_SPREADABLE = __webpack_require__(19)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(21);
var repeat = __webpack_require__(224);
var defined = __webpack_require__(64);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(22);
var getKeys = __webpack_require__(84);
var toIObject = __webpack_require__(45);
var isEnum = __webpack_require__(133).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(110);
var from = __webpack_require__(378);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(90);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 379 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.ITEM_TYPES = {
    PAGE: 'PAGE',
    ELLIPSIS: 'ELLIPSIS',
    FIRST_PAGE_LINK: 'FIRST_PAGE_LINK',
    PREVIOUS_PAGE_LINK: 'PREVIOUS_PAGE_LINK',
    NEXT_PAGE_LINK: 'NEXT_PAGE_LINK',
    LAST_PAGE_LINK: 'LAST_PAGE_LINK'
};
exports.ITEM_KEYS = {
    FIRST_ELLIPSIS: -1,
    SECOND_ELLIPSIS: -2,
    FIRST_PAGE_LINK: -3,
    PREVIOUS_PAGE_LINK: -4,
    NEXT_PAGE_LINK: -5,
    LAST_PAGE_LINK: -6
};
//# sourceMappingURL=ultimate-pagination-constants.js.map

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(73) && !__webpack_require__(114)(function () {
  return Object.defineProperty(__webpack_require__(245)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(95);
var toIObject = __webpack_require__(115);
var arrayIndexOf = __webpack_require__(882)(false);
var IE_PROTO = __webpack_require__(250)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(138);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(95);
var toObject = __webpack_require__(116);
var IE_PROTO = __webpack_require__(250)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(55);
var core = __webpack_require__(30);
var fails = __webpack_require__(114);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(886), __esModule: true };

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(888);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(896);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(139);
var $export = __webpack_require__(55);
var redefine = __webpack_require__(390);
var hide = __webpack_require__(94);
var Iterators = __webpack_require__(140);
var $iterCreate = __webpack_require__(891);
var setToStringTag = __webpack_require__(175);
var getPrototypeOf = __webpack_require__(385);
var ITERATOR = __webpack_require__(43)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(94);


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(35).document;
module.exports = document && document.documentElement;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(893);
var global = __webpack_require__(35);
var hide = __webpack_require__(94);
var Iterators = __webpack_require__(140);
var TO_STRING_TAG = __webpack_require__(43)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(383);
var hiddenKeys = __webpack_require__(252).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(174);
var createDesc = __webpack_require__(136);
var toIObject = __webpack_require__(115);
var toPrimitive = __webpack_require__(246);
var has = __webpack_require__(95);
var IE8_DOM_DEFINE = __webpack_require__(382);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(73) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 395 */
/***/ (function(module, exports) {



/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(918);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(176);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(919);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(398);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(922), __esModule: true };

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(72);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(140);
var ITERATOR = __webpack_require__(43)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(402);
var ITERATOR = __webpack_require__(43)('iterator');
var Iterators = __webpack_require__(140);
module.exports = __webpack_require__(30).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(138);
var TAG = __webpack_require__(43)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(43)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setStatic = __webpack_require__(931);

var _setStatic2 = _interopRequireDefault(_setStatic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic2.default)('displayName', displayName);
};

exports.default = setDisplayName;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getDisplayName = __webpack_require__(932);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
};

exports.default = wrapDisplayName;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixValue;
function prefixValue(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData);

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    if (processedValue) {
      return processedValue;
    }
  }
}
module.exports = exports["default"];

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addNewValuesOnly;
function addIfNew(list, value) {
  if (list.indexOf(value) === -1) {
    list.push(value);
  }
}

function addNewValuesOnly(list, values) {
  if (Array.isArray(values)) {
    for (var i = 0, len = values.length; i < len; ++i) {
      addIfNew(list, values[i]);
    }
  } else {
    addIfNew(list, values);
  }
}
module.exports = exports["default"];

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObject;
function isObject(value) {
  return value instanceof Object && !Array.isArray(value);
}
module.exports = exports["default"];

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateProperty;

var _hyphenateStyleName = __webpack_require__(958);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2.default)(property);
}
module.exports = exports['default'];

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_LoggedInPage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_icons_topicinfo_png__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_icons_topicinfo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_icons_topicinfo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_icons_heypractest_icon_png__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_icons_heypractest_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_icons_heypractest_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_loader_spinner__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_loader_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_loader_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_ComponentRegistry__ = __webpack_require__(38);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TestInfo=function(_LoggedInPage){_inherits(TestInfo,_LoggedInPage);function TestInfo(props){_classCallCheck(this,TestInfo);var _this=_possibleConstructorReturn(this,(TestInfo.__proto__||Object.getPrototypeOf(TestInfo)).call(this,props));_this.componentDidMount=function(){_this.props.onRef(_this);_this.testId=_this.props.testId;_this.classId=_this.props.classId;if(_this.props.testId==0||_this.props.testId=="0"){var me=_this;var callBackSuccess=function callBackSuccess(response){if(response.code===200){me.loadTestInfo(response.data);}else{alert("GET_TEST_ID Error:: "+me.rb("error.oops"));}};var callBackFailure=function callBackFailure(response){alert("GET_TEST_ID Error : ",response);};if(_this.props.accessId!==undefined&&_this.props.accessId!==null&&_this.props.accessId>0){new __WEBPACK_IMPORTED_MODULE_4__util_HmAjax__["a" /* default */](_this.getUrlFor("GET_TEST_ID")+"?access="+_this.props.accessId+"&revisionTestId="+_this.props.revisiontestid+"&topicsubtopicId="+_this.props.topicsubtopicId+"&classId="+_this.classId).get(callBackSuccess,callBackFailure);}}else{_this.loadTestInfo(_this.props.testId);}__WEBPACK_IMPORTED_MODULE_6__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");};_this.render=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.renderTestInfo());};_this.state={testInfoLoaded:false,topicInfoObj:[]};_this.startTest=_this.startTest.bind(_this);_this.trackTestStart=_this.trackTestStart.bind(_this);_this.trackTestClose=_this.trackTestClose.bind(_this);_this.testId=_this.props.testId;_this.classId=_this.props.classId;return _this;}_createClass(TestInfo,[{key:'startTest',value:function startTest(){this.props.callbackParent(this.state.topicInfoObj,this.props.topicsubtopicId,this.props.revisiontestid);}},{key:'componentWillMount',value:function componentWillMount(){this.props.onRef(undefined);}},{key:'loadTestInfo',value:function loadTestInfo(testId){this.testId=testId;var me=this;var callBackSuccess=function callBackSuccess(response){console.log(JSON.parse(response.data));if(response.code===200){me.setState({testInfoLoaded:true,topicInfoObj:JSON.parse(response.data)});me.trackTestStart();}else{alert("GET_TEST_INFO Error:: "+me.rb("error.oops"));}};var callBackFailure=function callBackFailure(response){alert("GET_TEST_INFO Error : ",response);};new __WEBPACK_IMPORTED_MODULE_4__util_HmAjax__["a" /* default */](this.getUrlFor("GET_TEST_INFO")+testId).put(callBackSuccess,callBackFailure);}},{key:'trackTestStart',value:function trackTestStart(){var postParams={trackingDefId:4,testId:this.testId,startTime:new Date().getTime(),action:this.state.topicInfoObj.userTest.status};var me=this;var callBackSuccess=function callBackSuccess(response){};var callBackFailure=function callBackFailure(error){console.log("Error in TRACK_SOLUTION");};new __WEBPACK_IMPORTED_MODULE_4__util_HmAjax__["a" /* default */](this.getUrlFor("TRACK_SOLUTION"),postParams).post(callBackSuccess,callBackFailure);}},{key:'trackTestClose',value:function trackTestClose(){try{var postParams={"trackingDefId":4,"testId":this.testId,"endTime":new Date().getTime()};var me=this;var callBackSuccess=function callBackSuccess(response){};var callBackFailure=function callBackFailure(error){console.log("Error in TRACK_TEST_CLOSED");};new __WEBPACK_IMPORTED_MODULE_4__util_HmAjax__["a" /* default */](this.getUrlFor("TRACK_TEST_CLOSED"),postParams).post(callBackSuccess,callBackFailure);}catch(e){}}},{key:'getStatusText',value:function getStatusText(){if(this.state.testInfoLoaded){if(this.state.topicInfoObj.userTest.status=="IN_PROGRESS"){return this.rb("home.continue");}else{return this.rb("home.start");}}else{return this.rb("home.start");}}},{key:'getTopicName',value:function getTopicName(){var topicname=this.state.topicInfoObj.testDetails.topics;topicname=topicname.split("- Customized Practice").join("");return topicname;}},{key:'renderTestInfo',value:function renderTestInfo(){var _this2=this;if(this.state.testInfoLoaded===false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center loadingAnim'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_loader_spinner___default.a,{type:'Oval',color:'#00BFFF',height:'100',width:'100'}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row modalBase'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 text-center leftPanel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},function(){if(_this2.state.topicInfoObj.testDetails.mode==1||_this2.state.topicInfoObj.testDetails.mode=="1"){return _this2.rb("home.proficiencytest");}else{return _this2.rb("home.customizepractice");}}()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'topicDetails'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.topicInfoObj.testDetails.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'topicName'},this.getTopicName())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'iconDiv'},function(){if(_this2.state.topicInfoObj.testDetails.mode==1||_this2.state.topicInfoObj.testDetails.mode=="1"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__images_icons_topicinfo_png___default.a});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__images_icons_heypractest_icon_png___default.a});}}())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-8 rightPanel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'testInfo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-9 col-9 caption'},this.rb("testinfo.totalquestions")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3 col-3 nopadding bigNumbers text-right'},this.state.topicInfoObj.testDetails.questionTypeCount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row totalPointsSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-9 col-9 caption'},this.rb("testinfo.totalpoints")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3 col-3 nopadding bigNumbers text-right'},this.state.topicInfoObj.testDetails.points)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-right bottomBtns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-primary largeBtn',onClick:this.startTest,'data-ga':"Post login - "+this.props.gradeName+" - Tests - "+this.state.topicInfoObj.testDetails.title+" - "+this.getTopicName()+" - PT - "+this.getStatusText()},this.getStatusText())))));}}}]);return TestInfo;}(__WEBPACK_IMPORTED_MODULE_1__views_core_LoggedInPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (TestInfo);__WEBPACK_IMPORTED_MODULE_7__model_ComponentRegistry__["a" /* default */].register("TestInfo",TestInfo);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_LoggedInPage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_testinfo_png__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_testinfo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_testinfo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_alert_png__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_alert_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_alert_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_heypractest_icon_png__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_heypractest_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_icons_heypractest_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_loader_spinner__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_loader_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_loader_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model_ComponentRegistry__ = __webpack_require__(38);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ms_TestInfo=function(_LoggedInPage){_inherits(ms_TestInfo,_LoggedInPage);function ms_TestInfo(props){_classCallCheck(this,ms_TestInfo);var _this=_possibleConstructorReturn(this,(ms_TestInfo.__proto__||Object.getPrototypeOf(ms_TestInfo)).call(this,props));_this.componentDidMount=function(){_this.props.onRef(_this);_this.testId=_this.props.testId;_this.classId=_this.props.classId;if(_this.props.testId==0||_this.props.testId=="0"){var me=_this;var callBackSuccess=function callBackSuccess(response){if(response.code===200){me.loadTestInfo(response.data);}else if(response.code===403&&response.message=="TEST_LOCKED"){me.showAlert(' ',me.rb("test.locked"));}else{alert("GET_TEST_ID Error:: "+me.rb("error.oops"));}};var callBackFailure=function callBackFailure(response){alert("GET_TEST_ID Error : ",response);};if(_this.props.accessId!==undefined&&_this.props.accessId!==null&&_this.props.accessId>0){new __WEBPACK_IMPORTED_MODULE_5__util_HmAjax__["a" /* default */](_this.getUrlFor("GET_TEST_ID")+"?access="+_this.props.accessId+"&revisionTestId="+_this.props.revisiontestid+"&topicsubtopicId="+_this.props.topicsubtopicId+"&classId="+_this.classId).get(callBackSuccess,callBackFailure);}}else{_this.loadTestInfo(_this.props.testId);}__WEBPACK_IMPORTED_MODULE_7__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");};_this.render=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.renderTestInfo());};_this.state={testInfoLoaded:false,topicInfoObj:[]};_this.startTest=_this.startTest.bind(_this);_this.trackTestStart=_this.trackTestStart.bind(_this);_this.trackTestClose=_this.trackTestClose.bind(_this);_this.testId=_this.props.testId;_this.classId=_this.props.classId;_this.timedTest=false;return _this;}_createClass(ms_TestInfo,[{key:'startTest',value:function startTest(){this.props.callbackParent(this.state.topicInfoObj,this.props.topicsubtopicId,this.props.revisiontestid);}},{key:'componentWillMount',value:function componentWillMount(){this.props.onRef(undefined);}},{key:'loadTestInfo',value:function loadTestInfo(testId){this.testId=testId;var me=this;var callBackSuccess=function callBackSuccess(response){console.log(JSON.parse(response.data));if(response.code===200){me.setState({testInfoLoaded:true,topicInfoObj:JSON.parse(response.data)});me.trackTestStart();}else if(response.code===403&&response.message=="TEST_LOCKED"){me.showAlert(' ',me.rb("test.locked"));}else{alert("GET_TEST_INFO Error:: "+me.rb("error.oops"));}};var callBackFailure=function callBackFailure(response){alert("GET_TEST_INFO Error : ",response);};new __WEBPACK_IMPORTED_MODULE_5__util_HmAjax__["a" /* default */](this.getUrlFor("GET_TEST_INFO")+testId).put(callBackSuccess,callBackFailure);}},{key:'trackTestStart',value:function trackTestStart(){var postParams={trackingDefId:4,testId:this.testId,startTime:new Date().getTime(),action:this.state.topicInfoObj.userTest.status};var me=this;var callBackSuccess=function callBackSuccess(response){};var callBackFailure=function callBackFailure(error){console.log("Error in TRACK_SOLUTION");};new __WEBPACK_IMPORTED_MODULE_5__util_HmAjax__["a" /* default */](this.getUrlFor("TRACK_SOLUTION"),postParams).post(callBackSuccess,callBackFailure);}},{key:'trackTestClose',value:function trackTestClose(){try{var postParams={"trackingDefId":4,"testId":this.testId,"endTime":new Date().getTime()};var me=this;var callBackSuccess=function callBackSuccess(response){};var callBackFailure=function callBackFailure(error){console.log("Error in TRACK_TEST_CLOSED");};new __WEBPACK_IMPORTED_MODULE_5__util_HmAjax__["a" /* default */](this.getUrlFor("TRACK_TEST_CLOSED"),postParams).post(callBackSuccess,callBackFailure);}catch(e){}}},{key:'getStatusText',value:function getStatusText(){if(this.state.testInfoLoaded){if(this.state.topicInfoObj.userTest.status=="IN_PROGRESS"){return this.rb("home.continue");}else{return this.rb("home.start");}}else{return this.rb("home.start");}}},{key:'getTopicName',value:function getTopicName(){var topicname=this.state.topicInfoObj.testDetails.topics;topicname=topicname.split("- Customized Practice").join("");return topicname;}},{key:'getMinutesStr',value:function getMinutesStr(){var secsTime=this.state.topicInfoObj.testDetails.durationInSeconds;if(secsTime>0){this.timedTest=true;var minutes=Math.floor(secsTime/60);minutes=minutes+" Minutes";return minutes;}else{this.timedTest=false;}return 0;}},{key:'renderTestInfo',value:function renderTestInfo(){var _this2=this;if(this.state.testInfoLoaded===false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center loadingAnim'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_loader_spinner___default.a,{type:'Oval',color:'#00BFFF',height:'100',width:'100'}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row modalBase'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 text-center leftPanel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'topicDetails'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},this.state.topicInfoObj.testDetails.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'topicName'},this.getTopicName())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'iconDiv'},function(){if(_this2.state.topicInfoObj.testDetails.mode==1||_this2.state.topicInfoObj.testDetails.mode=="1"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__images_testinfo_png___default.a});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__images_icons_heypractest_icon_png___default.a});}}())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-8 rightPanel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'testInfo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-9 col-9 caption'},this.rb("testinfo.totalquestions")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-3 col-3 nopadding bigNumbers text-right'},this.state.topicInfoObj.testDetails.questionTypeCount)),function(){if(_this2.getMinutesStr()&&_this2.getMinutesStr().length>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row totalDuration'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 col-6 caption'},_this2.rb("testinfo.duration")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 col-6 nopadding bigNumbers text-right'},_this2.getMinutesStr()));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-right bottomBtns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-primary largeBtn',onClick:this.startTest,'data-ga':"Post login - "+this.props.gradeName+" - Tests - "+this.state.topicInfoObj.testDetails.title+" - "+this.getTopicName()+" - PT - "+this.getStatusText()},this.getStatusText())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instruct'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__images_alert_png___default.a})),function(){var dynInstruct=_this2.state.topicInfoObj.testDetails.instructions||_this2.rb("testinfo.instruction");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,dynInstruct);}()))));}}}]);return ms_TestInfo;}(__WEBPACK_IMPORTED_MODULE_1__views_core_LoggedInPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ms_TestInfo);__WEBPACK_IMPORTED_MODULE_8__model_ComponentRegistry__["a" /* default */].register("ms_TestInfo",ms_TestInfo);/*
* Also registering for the users with hm_ prefix
*/__WEBPACK_IMPORTED_MODULE_8__model_ComponentRegistry__["a" /* default */].register("hm_TestInfo",ms_TestInfo);

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_LoggedInPage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_icons_tick_icon_white_png__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_icons_tick_icon_white_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_icons_tick_icon_white_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_icons_points_icon_png__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_icons_points_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_icons_points_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_HmEventRegistry__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TopicComponent=function(_LoggedInPage){_inherits(TopicComponent,_LoggedInPage);function TopicComponent(props){_classCallCheck(this,TopicComponent);var _this=_possibleConstructorReturn(this,(TopicComponent.__proto__||Object.getPrototypeOf(TopicComponent)).call(this,props));_this.onTopicStart=_this.onTopicStart.bind(_this);_this.handleMouseOver=_this.handleMouseOver.bind(_this);_this.handleMouseOut=_this.handleMouseOut.bind(_this);_this.state={gifAnimSrc:'',gifSrc:'',imgSrc:'',boxColor:''};return _this;}_createClass(TopicComponent,[{key:'componentDidMount',value:function componentDidMount(){//console.log("selectedGrade::"+this.props.selectedGradeLabel);
var boxDefaultColor="#8D6E63";var boxDefaultImg="box_default.png";var boxcolor=boxDefaultColor;var boxImgSrc=__webpack_require__(415)("./"+boxDefaultImg);var boxgifsrc=__webpack_require__(415)("./"+boxDefaultImg);//console.log("lalala: topic::",this.props.topic);
if(this.props.topic.staticImgPath&&this.props.topic.staticImgPath!=""){boxImgSrc=this.props.topic.staticImgPath;}if(this.props.topic.animatedImgPath&&this.props.topic.animatedImgPath!=""){boxgifsrc=this.props.topic.animatedImgPath;}if(this.props.topic.colourCode&&this.props.topic.colourCode!=""){boxcolor=this.props.topic.colourCode;}/*console.log(this.props.topic.staticImgPath);
			console.log(this.props.topic.animatedImgPath);
			console.log(this.props.topic.colourCode);*//*if (boxColorObj.hasOwnProperty(folder)) {
			     if(boxColorObj[folder].hasOwnProperty(filename)) {
			    	 boxcolor = boxColorObj[folder][filename];
			    	 boxImgSrc = require("../../images/animations/"+folder+"/"+filename+".gif");			    	 
			    	 if(this.props.topic.status === "COMPLETED"){
			    		 boxgifsrc = require("../../images/animations/"+folder+"/"+filename+".gif");
			    	 }else{
			    		 boxgifsrc = require("../../images/animations/"+folder+"/"+filename+"_anim.gif");
			    	 }
			    }
			}*/this.setState({imgSrc:boxImgSrc,gifAnimSrc:boxgifsrc,gifSrc:boxImgSrc,boxColor:boxcolor});__WEBPACK_IMPORTED_MODULE_4__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");}},{key:'onTopicStart',value:function onTopicStart(){// console.log(this.props.topic.subTopicMap);	
this.props.callbackParent(this.props.topic,this.props.dataIndex,this.state.boxColor);}},{key:'handleMouseOver',value:function handleMouseOver(){this.setState({imgSrc:this.state.gifAnimSrc});}},{key:'handleMouseOut',value:function handleMouseOut(){this.setState({imgSrc:this.state.gifSrc});}},{key:'getUserTopicPoints',value:function getUserTopicPoints(){if(this.props.topic&&this.props.topic.userTopicPoints){return!isNaN(this.props.topic.userTopicPoints)?this.props.topic.userTopicPoints:0;}return 0;}},{key:'getTopicPoints',value:function getTopicPoints(){if(this.props.topic&&this.props.topic.topicPoints){return!isNaN(this.props.topic.topicPoints)?this.props.topic.topicPoints:0;}return 0;}},{key:'getLesssonsActionLabel',value:function getLesssonsActionLabel(){switch(this.props.topic.status){case"COMPLETED":return this.rb("lesson.watched");case"IN_PROGRESS":return this.rb("home.resume");default:return this.rb("home.start");}}},{key:'getTestsActionLabel',value:function getTestsActionLabel(){switch(this.props.topic.status){case"COMPLETED":return this.rb("home.revise");case"IN_PROGRESS":return this.rb("home.resume");default:return this.rb("home.start");}}},{key:'getTopicBottomSection',value:function getTopicBottomSection(){var _this2=this;var me=this;if(this.props.lessonOnlyMode==true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body card-bottom text-center lessononlytopic'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-link tileLink showcursor',onClick:this.onTopicStart,'data-ga':"Post login - "+this.props.gradeName+" - Lessons - "+this.props.topic.topicName+" - "+this.getLesssonsActionLabel()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,function(){if(me.props.topic.topicLocked===true){return _this2.rb("topic.locked");}switch(me.props.topic.status){case"COMPLETED":return _this2.rb("lesson.watched");case"IN_PROGRESS":return _this2.rb("home.resume");default:return _this2.rb("home.start");}}())));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body card-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'card-link user-points'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'bottomPointsIcon',src:__WEBPACK_IMPORTED_MODULE_3__images_icons_points_icon_png___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'user-points'},this.getUserTopicPoints()),'/',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'points'},this.getTopicPoints())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-link float-right tileLink showcursor',onClick:this.onTopicStart,'data-ga':"Post login - "+this.props.gradeName+" - Tests - "+this.props.topic.topicName+" - "+this.getTestsActionLabel()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,function(){if(me.props.topic.topicLocked===true){return _this2.rb("topic.locked");}switch(me.props.topic.status){case"COMPLETED":return _this2.rb("home.revise");case"IN_PROGRESS":return _this2.rb("home.resume");default:return _this2.rb("home.start");}}())));}}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"card "+this.props.selectedGradeLabel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-img-top topic text-center',style:{backgroundColor:this.state.boxColor},onMouseOver:this.handleMouseOver,onMouseOut:this.handleMouseOut},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:"bgimg animgif "+(this.props.topic.status==="COMPLETED"&&this.props.lessonOnlyMode==false?'opacityInGif':''),src:this.state.imgSrc}),function(){if(_this3.props.topic.status==="COMPLETED"){if(_this3.props.lessonOnlyMode==false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'topiccompletedIcon',src:__WEBPACK_IMPORTED_MODULE_2__images_icons_tick_icon_white_png___default.a});}}}()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-img-overlay'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-title'},this.props.topic.topicName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body descBody'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'card-text'},this.props.topic.topicDescription)),this.getTopicBottomSection());}}]);return TopicComponent;}(__WEBPACK_IMPORTED_MODULE_1__views_core_LoggedInPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (TopicComponent);

/***/ }),
/* 413 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAESUlEQVR4nO2cPXITMRiGX6VIxYwpaKhIl5IwHMBLD0NuEFOlhBvYNyAtlc0JEsC9zQnsdJAmpqEBBjOmCc1LoZWz3uyPpF2vvs3kmcmMxyNpN4/1s9J+EnDHHVVQTV+QZBfAAYD7ACKLLIv4bw5grpT6tq17y2Lrgkg+AtCDlhHVUOQCwBTAVCn1vobymodkh2Sf5CW3z2lcK+VD8hHJtw1IyeKS5MvQDjLhdY2RwIySahTJLsnfYZ1kMiTZCSmmw3DNyZYZKzY7r1GM+peZQg/XbaDnO+I5CyL5GFrOfZ8LBmSklHrlmslJUIvlGJwlWQtqYbPKw6m5WQm6RXIM1pJsBU1QzzRBEpFS6nNZop2yBCTf4vbJAYAz6nliIYU1KH6GOKvtluQxV0o9KUqQW4PifmdU9x0J44BkvyhBURM7QQuH809fR65ZBjZNbQPq+VXr6E+O+PQd2J8cuWad5LnIq0EDJ6MCGEx7GF/okXt88R6Dac8le8ScFYAbguKEkfsthiMpx+AhaZD1ZVYNOnEpNTRZcgyOkiJmzPw3BPF6Qb0VFMkxOEp6k/4iXYMObUsKjY0cw9OHkW2xEVOLbGlBPduSQuIip98d4sV+z6X4jcRrQXHzEv/cs2U5QKoVJWtQ5FpS0zQgB0h5aI2ghuQAWLcmAC0R1KScmMh82AHWr4dFEkAOAOyZDzvpLyQRSA7QBkEB5QDSBQWWA2QIqszqaonV1bJyOQLkbFCLoNXVEsfjCMfjqJIkaXKAGgQZORe/znHx69xbkkQ5QEVBSTkGH0lS5QAVBGXJMbhIkiwHuBY0d8lUJMdgI0mwnLUPI8ip0/i+WuD7alGarkiSYDlAwocRtHDJvf/gAO+eT3FvtzyAK0uScDlAwscOAPjEHvtKaoEcICFo/eqZngEKX3/OcTyO8Pffn9K093Y7VumAoHKARGBDchRz6qgNLjWpJXKAjE4a0PE/XrhIKkOCHKXU+pdcC1JKfahSah2SBMgBUtEs6QfFSqEuVSQJkQOUCBpVLd1HkiA5c6XUxtPvhqC4mS2qXsVFkiA5QMZr96y52KiOK9lIEiZniYwuJi94ofrKF4olCZMDACfJ0ctwQ1CcqLYIjyxJAuUs4fo/s+bNcF9+zNgddvjxy7DOYuviKM9DbpQrb3+Eq6Ew0jV3wSwe0VoVTOXBEiUhP2UrigN4ztFawpuylYxCQXGH3UNNo5owRjb7NWz3anRRYTIrkKlS6plNQqtF+3htpFfljgQxh0OoofVbjbg6HqLdze0MejHMbmEKd1syS/Hd1Ns2SV5yAM8Xh/GSQAT5D5JL6KHcS04tUM6JC2lm1DU9PNS7gyZBdVzzm/pHC3fqQh4kX7OZE1/yOKXgeMs1AUQNKaU5uUDd9E65ncNPZmygKTV2RBf1dOUQejeROaLLhTn0evkZ9FShkaO6Gj/DzEDdV+zZpLXZ335HIP4DoU8XKc2kD8YAAAAASUVORK5CYII="

/***/ }),
/* 414 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAV9JREFUeNpi/P//PwMMMDEgARQOQAAxwpQxYUgDBBADSAqE9fft+w9jg2UN9u+HaFrNCKYBAogR2S4Mc+Cq8aoEq1rNGADEDii2/1/FsADGBgggDO1AXQlASuCCo+MEZHEWBkwwH0pjVwg0CSSRD+VeBLrjA5gV+l8Ap8uRAkEQqPADfoVoACCAiFbIhC4AdGsDQRORgx0YPIz4TJwIpReS7UYWrNa+cRIEUu+BWBEYPA+QI9sBzfr3UFoAI/mh4FUMDUB8AVmMCYeTFIBWGpDlGYAAI1ohsYAFnyRaygPHAzDCEkhKEmggH40fT7GXoTlNAYgfAF23gCwDgYaAYqQAxARifSSpRGBi+QAVB6cdYOxtwBmG0AS0H4fljkDDQJb4A/FHIHYAGnaB1DAEgYcp35YoAA3bADUMBPiB+AAw1xuQn2xWM4KS+QOwQQwMCbCig6Rkg2ZYAKygomvCBgAlssW3uI+9SgAAAABJRU5ErkJggg=="

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./box_default.png": 990
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 415;

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_core_LoggedInPage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_icons_practice_icon_png__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_icons_practice_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_icons_practice_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_icons_recomnd_icon_png__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_icons_recomnd_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_icons_recomnd_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_icons_report_icon_png__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_icons_report_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_icons_report_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_icons_points_icon_png__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_icons_points_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_icons_points_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_icons_report_proficiency_png__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_icons_report_proficiency_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_icons_report_proficiency_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_icons_report_practice_png__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_icons_report_practice_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_icons_report_practice_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_icons_tick_icon_grey_png__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_icons_tick_icon_grey_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_icons_tick_icon_grey_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_topic_lesson_icon_png__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_topic_lesson_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_icons_topic_lesson_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_icons_lesson_icon_png__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_icons_lesson_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_icons_lesson_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_icons_emojis_rating_default_png__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_icons_emojis_rating_default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_icons_emojis_rating_default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_icons_emojis_bad_gif__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_icons_emojis_bad_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_icons_emojis_bad_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_icons_emojis_good_gif__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_icons_emojis_good_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__images_icons_emojis_good_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_icons_emojis_loveit_gif__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_icons_emojis_loveit_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__images_icons_emojis_loveit_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_icons_emojis_normal_gif__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_icons_emojis_normal_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__images_icons_emojis_normal_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_icons_emojis_verybad_gif__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_icons_emojis_verybad_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__images_icons_emojis_verybad_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_icons_emojis_bad_small_png__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_icons_emojis_bad_small_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__images_icons_emojis_bad_small_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__images_icons_emojis_good_small_png__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__images_icons_emojis_good_small_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__images_icons_emojis_good_small_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__images_icons_emojis_loveit_small_png__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__images_icons_emojis_loveit_small_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__images_icons_emojis_loveit_small_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__images_icons_emojis_normal_small_png__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__images_icons_emojis_normal_small_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__images_icons_emojis_normal_small_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__images_icons_emojis_verybad_small_png__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__images_icons_emojis_verybad_small_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__images_icons_emojis_verybad_small_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react_confirm_alert__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_confirm_alert_src_react_confirm_alert_css__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react_confirm_alert_src_react_confirm_alert_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_react_confirm_alert_src_react_confirm_alert_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_react_html_parser__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var imagePath="/lesson/get_lesson_thumbnails?image=";var SubTopicComponent=function(_LoggedInPage){_inherits(SubTopicComponent,_LoggedInPage);function SubTopicComponent(props){_classCallCheck(this,SubTopicComponent);var _this=_possibleConstructorReturn(this,(SubTopicComponent.__proto__||Object.getPrototypeOf(SubTopicComponent)).call(this,props));_this.state={popoverOpen:false,selectedEmoji:parseInt(_this.props.subtopic.rating),noOfRetakesAvailable:_this.props.subtopic.noOfRetakesAvailable};_this.selectedRate=parseInt(_this.props.subtopic.rating);_this.onSubTopicStart=_this.onSubTopicStart.bind(_this);_this.onSubTopicStartLessons=_this.onSubTopicStartLessons.bind(_this);_this.onSubTopicStartCP=_this.onSubTopicStartCP.bind(_this);_this.onSubTopicStartPT=_this.onSubTopicStartPT.bind(_this);_this.getDropDownItems=_this.getDropDownItems.bind(_this);_this.toggle=_this.toggle.bind(_this);_this.selectRating=_this.selectRating.bind(_this);_this.handleMouseOver=_this.handleMouseOver.bind(_this);_this.handleMouseOut=_this.handleMouseOut.bind(_this);_this.onSubScribeModal=_this.onSubScribeModal.bind(_this);_this.showResetAlert=_this.showResetAlert.bind(_this);_this.subtopic=_this.props.subtopic;//this.subtopic.reqTestStatus=this.props.subtopic.reqTestStatus;
//this.subtopic.testStatus=this.props.subtopic.testStatus;
return _this;}_createClass(SubTopicComponent,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_25__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");}},{key:'handleMouseOver',value:function handleMouseOver(event){__WEBPACK_IMPORTED_MODULE_2_jquery___default()(event.currentTarget).find(".hovertxt").show();}},{key:'handleMouseOut',value:function handleMouseOut(event){__WEBPACK_IMPORTED_MODULE_2_jquery___default()(".hovertxt").hide();}},{key:'onSubTopicStart',value:function onSubTopicStart(){this.props.callbackParent(this.props.subtopic);}},{key:'onSubTopicStartLessons',value:function onSubTopicStartLessons(){this.props.callbackParent(this.props.subtopic,"");}},{key:'onSubScribeModal',value:function onSubScribeModal(){this.props.showSubscribe();}},{key:'onSubTopicStartCP',value:function onSubTopicStartCP(){this.props.callbackParent(this.props.subtopic,"CP");}},{key:'onSubTopicStartPT',value:function onSubTopicStartPT(){this.props.callbackParent(this.subtopic,"PT");}},{key:'getUserSubTopicPoints',value:function getUserSubTopicPoints(){if(this.subtopic&&this.subtopic.userPoints){return!isNaN(this.subtopic.userPoints)?this.subtopic.userPoints:0;}return 0;}},{key:'getSubTopicPoints',value:function getSubTopicPoints(){if(this.props.subtopic&&this.props.subtopic.subTopicPoints){return!isNaN(this.props.subtopic.subTopicPoints)?this.props.subtopic.subTopicPoints:0;}return 0;}},{key:'getSubTopicUserGrade',value:function getSubTopicUserGrade(){if(this.props.subtopic&&this.props.subtopic.grade){return this.props.subtopic.grade;}return"";//return this.rb("no_grade_available");
}},{key:'doReset',value:function doReset(){var me=this;var testids=new Array();if(this.props.subtopic.testId){testids.push(this.props.subtopic.testId);}if(this.props.subtopic.recommendtestid){testids.push(this.props.subtopic.recommendtestid);}var topicsubtopicId=this.props.subtopic.topicsubtopicId;var params={"testId":testids};var callBackSuccess=function callBackSuccess(response){//console.log("RESET_SUBTOPIC::",response);	
if(response){if(response.response==="SUCCESS"){me.subtopic.status="NEW";me.subtopic.reqTestStatus="NEW";me.subtopic.testStatus="NEW";me.subtopic.userPoints=0;me.setState({noOfRetakesAvailable:me.state.noOfRetakesAvailable-1});}}};var callBackFailure=function callBackFailure(response){//console.log("Failure::: in RESET_SUBTOPIC");
};var accessId=!isNaN(this.props.accessId)?this.props.accessId:Number.parseInt(this.props.accessId);var classId=!isNaN(this.props.classId)?this.props.classId:Number.parseInt(this.props.classId);var url=this.getUrlFor("RESET_SUBTOPIC")+"/"+topicsubtopicId+"/"+classId+"/"+accessId;new __WEBPACK_IMPORTED_MODULE_3__util_HmAjax__["a" /* default */](url).get(callBackSuccess,callBackFailure);}},{key:'showResetAlert',value:function showResetAlert(){var _this2=this;if(this.state.noOfRetakesAvailable<=0){this.showAlert(" ",this.rb("reset.noretakesmsg"));return;}var msg=this.rb("reset.msg");Object(__WEBPACK_IMPORTED_MODULE_26_react_confirm_alert__["confirmAlert"])({customUI:function customUI(_ref){var onClose=_ref.onClose;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-ui-alert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg'},msg?__WEBPACK_IMPORTED_MODULE_28_react_html_parser___default()(msg):'Hello..'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg greymsg'},_this2.rb("reset.retakesleft"),': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'msgcount'},_this2.state.noOfRetakesAvailable)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'note text-left'},_this2.rb("reset.note")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 btn alertbtn okbtn border-bottom-left-radius',onClick:function onClick(){_this2.doReset();onClose();}},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'done'),' ',_this2.rb("alert.ok")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 btn alertbtn cancelbtn border-bottom-right-radius',onClick:onClose},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'close'),' ',_this2.rb("alert.no"))));}});}},{key:'getBGImg',value:function getBGImg(){if(this.props.lessonOnlyMode==true){/*if(this.props.subtopic.status == "COMPLETED"){
				return <img src={completedTickImg} />
			}else{
				return <img src={LessonIconImg} />
			}*///console.warn("this.props.subtopic ",this.props.subtopic);
var lid=this.props.subtopic&&this.props.subtopic.lessonsSubTopicArr?this.props.subtopic.lessonsSubTopicArr[0].lessonurl:'';var wanttoShow=window.showSubTopicImageAsLessonImage||false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_13__images_icons_lesson_icon_png___default.a});}else{if(this.subtopic.status=="IN_PROGRESS"){if(this.subtopic.reqTestStatus!="COMPLETED"&&this.subtopic.testStatus=="COMPLETED"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__images_icons_recomnd_icon_png___default.a});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__images_icons_practice_icon_png___default.a});}}else if(this.subtopic.status=="COMPLETED"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11__images_icons_tick_icon_grey_png___default.a});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__images_icons_practice_icon_png___default.a});}}}},{key:'getStatusActionText',value:function getStatusActionText(){if(this.subtopic.status=="IN_PROGRESS"){if(this.subtopic.testStatus=="COMPLETED"&&this.subtopic.reqTestStatus!="COMPLETED"){if(this.subtopic.reqTestStatus=="IN_PROGRESS"){return this.rb("home.resume");}else{return this.rb("home.start");}}return this.rb("home.resume");}else if(this.subtopic.status=="COMPLETED"){return"";}else{return this.rb("home.start");}}},{key:'getDropDownItems',value:function getDropDownItems(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dropdown-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'dropdown-item',href:'#'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'star'),' ',this.rb("home.markedquestions")));}},{key:'getLesssonsActionLabel',value:function getLesssonsActionLabel(){if(this.subtopic.status=="COMPLETED"){return this.rb("lesson.watched");}else if(this.subtopic.status=="IN_PROGRESS"){return this.rb("home.resume");}else{return this.rb("home.start");}}},{key:'lockcontent',value:function lockcontent(props){var classdisabled="";//console.log("abdul ",this.props.subtopic.practiceLocked)
if(this.props.subtopic.practiceLocked){classdisabled="disabled lockdisabledrecom1";}//console.log("lock Content ",props)
if(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:"col-6 card-bottom text-center nosidepadding notoppadding showcursor "+classdisabled,onClick:this.onSubScribeModal,'data-ga':"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - CP - "+this.getStatusActionText()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-link tileLink'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'upgrdlock2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'lock'))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'col-6 card-bottom text-center nosidepadding notoppadding showcursor',onClick:this.onSubTopicStartCP,'data-ga':"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - CP - "+this.getStatusActionText()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-link tileLink'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,this.getStatusActionText())));}}},{key:'getBottomItems',value:function getBottomItems(){var _this3=this;if(this.props.lessonOnlyMode==true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row clearfix bottomSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 card-bottom text-center nosidepadding showcursor',onClick:this.onSubTopicStartLessons,'data-ga':"Post login - "+this.props.gradeName+" - Lessons - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - "+this.getLesssonsActionLabel()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'card-link tileLink'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,function(){if(_this3.subtopic.status=="COMPLETED"){return _this3.rb("lesson.watched");}else if(_this3.subtopic.status=="IN_PROGRESS"){return _this3.rb("home.resume");}else{return _this3.rb("home.start");}}()))));}else{if(this.subtopic.status=="IN_PROGRESS"){if(this.subtopic.reqTestStatus!="COMPLETED"&&this.subtopic.testStatus=="COMPLETED"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row clearfix bottomSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'col-6 card-bottom text-center borderRight nosidepadding notoppadding showcursor',href:"/scorecard/"+this.props.subtopic.testId,'data-ga':"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - PT - Report"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-link tileLink'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'bottomReportsIcon',src:__WEBPACK_IMPORTED_MODULE_9__images_icons_report_proficiency_png___default.a}))),this.lockcontent(this.props.subtopic.practiceLocked));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row clearfix bottomSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 card-bottom text-center nosidepadding showcursor',onClick:this.onSubTopicStartPT,'data-ga':"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - PT - "+this.getStatusActionText()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-link tileLink'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,this.getStatusActionText()))));}}else if(this.subtopic.status=="COMPLETED"){if(this.props.subtopic.recommendtestid!=0&&this.props.subtopic.recommendtestid!="0"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row clearfix bottomSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'col-6 card-bottom text-center borderRight nosidepadding notoppadding showcursor',href:"/scorecard/"+this.props.subtopic.testId,'data-ga':"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - PT - Report"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-link tileLink'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'bottomReportsIcon',src:__WEBPACK_IMPORTED_MODULE_9__images_icons_report_proficiency_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'col-6 card-bottom text-center nosidepadding notoppadding showcursor',href:"/scorecard/"+this.props.subtopic.recommendtestid,'data-ga':"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - CP - Report"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-link tileLink'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'bottomReportsIcon',src:__WEBPACK_IMPORTED_MODULE_10__images_icons_report_practice_png___default.a}))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row clearfix bottomSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'col-12 card-bottom text-center borderRight nosidepadding notoppadding showcursor',href:"/scorecard/"+this.props.subtopic.testId,'data-ga':"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - PT - Report"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-link tileLink'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'bottomReportsIcon',src:__WEBPACK_IMPORTED_MODULE_9__images_icons_report_proficiency_png___default.a}))));}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row clearfix bottomSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 card-bottom text-center nosidepadding showcursor',onClick:this.onSubTopicStartPT,'data-ga':"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - PT - "+this.getStatusActionText()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'card-link tileLink'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,this.getStatusActionText()))));}}}},{key:'getTestStatusName',value:function getTestStatusName(){if(this.subtopic.status=="IN_PROGRESS"){if(this.subtopic.reqTestStatus!="COMPLETED"&&this.subtopic.testStatus=="COMPLETED"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.rb("home.practicetest"));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.rb("home.proficiencytest"));}}else if(this.subtopic.status=="COMPLETED"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.rb("home.reportcard"));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.rb("home.proficiencytest"));}}},{key:'getSelectedEmojiIcon',value:function getSelectedEmojiIcon(){switch(this.state.selectedEmoji){case 5:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'shakeme',src:__WEBPACK_IMPORTED_MODULE_22__images_icons_emojis_loveit_small_png___default.a});break;case 4:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'shakeme',src:__WEBPACK_IMPORTED_MODULE_21__images_icons_emojis_good_small_png___default.a});break;case 3:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'shakeme',src:__WEBPACK_IMPORTED_MODULE_23__images_icons_emojis_normal_small_png___default.a});break;case 2:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'shakeme',src:__WEBPACK_IMPORTED_MODULE_20__images_icons_emojis_bad_small_png___default.a});break;case 1:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'shakeme',src:__WEBPACK_IMPORTED_MODULE_24__images_icons_emojis_verybad_small_png___default.a});break;default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_14__images_icons_emojis_rating_default_png___default.a});}}},{key:'saveRating',value:function saveRating(){//console.log("subtopic:::",this.props.subtopic);
var me=this;var ratingData={"topicId":this.props.subtopic.parentTopicId,"subTopicId":this.props.subtopic.subTopicId,"classId":parseInt(this.props.classId),"accessId":parseInt(this.props.accessId),"rating":parseInt(this.selectedRate)};var callBackSuccess=function callBackSuccess(response){//console.log("response:::",response);
me.props.subtopic.rating=parseInt(me.selectedRate);};var callBackFailure=function callBackFailure(error){//	console.log("Error in Ssubtopic RATING_EMOJI_SAVE");
};new __WEBPACK_IMPORTED_MODULE_3__util_HmAjax__["a" /* default */](this.getUrlFor("RATING_EMOJI_SAVE"),ratingData).post(callBackSuccess,callBackFailure);//----------------
try{var trackObj={"subtopic_id":this.props.subtopic.topicsubtopicId,"rating":parseInt(this.selectedRate),"grade_id":parseInt(this.props.classId),"product_type":parseInt(this.props.accessId),"source":this.getTracker().enums.itemRatedSource.home};this.initiateTrack("item_rated",trackObj);}catch(e){}}},{key:'getSubTopicBodyContent',value:function getSubTopicBodyContent(){var _this4=this;if(this.props.lessonOnlyMode==false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body info subtopicbody'},function(){if(_this4.subtopic.status=="COMPLETED"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'resetContainer',style:{backgroundColor:_this4.props.subTopicBoxColor},onClick:_this4.showResetAlert},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'replay'));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'card-title'},this.getTestStatusName()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'card-link user-points'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'bottomPointsIcon',src:__WEBPACK_IMPORTED_MODULE_8__images_icons_points_icon_png___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'user-points'},this.getUserSubTopicPoints()),'/',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'points'},this.getSubTopicPoints())),function(){if(_this4.subtopic.status==="COMPLETED"||_this4.subtopic.reqTestStatus==="COMPLETED"||_this4.subtopic.testStatus==="COMPLETED"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ratingemoji',onClick:_this4.toggle,id:'Popover-'+_this4.props.subtopic.testId},_this4.getSelectedEmojiIcon()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["i" /* Popover */],{className:'emojiPopover subtopic',placement:'top',isOpen:_this4.state.popoverOpen,target:'Popover-'+_this4.props.subtopic.testId,toggle:_this4.toggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["j" /* PopoverBody */],{className:'pos_relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emojianim',onMouseOver:_this4.handleMouseOver,onMouseOut:_this4.handleMouseOut},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'emojiicons','data-rateindex':5,src:__WEBPACK_IMPORTED_MODULE_17__images_icons_emojis_loveit_gif___default.a,onClick:_this4.selectRating}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center hovertxt'},'Loved it')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emojianim',onMouseOver:_this4.handleMouseOver,onMouseOut:_this4.handleMouseOut},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'emojiicons','data-rateindex':4,src:__WEBPACK_IMPORTED_MODULE_16__images_icons_emojis_good_gif___default.a,onClick:_this4.selectRating}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center hovertxt'},'Good')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emojianim',onMouseOver:_this4.handleMouseOver,onMouseOut:_this4.handleMouseOut},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'emojiicons','data-rateindex':3,src:__WEBPACK_IMPORTED_MODULE_18__images_icons_emojis_normal_gif___default.a,onClick:_this4.selectRating}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center hovertxt'},'Normal')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emojianim',onMouseOver:_this4.handleMouseOver,onMouseOut:_this4.handleMouseOut},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'emojiicons','data-rateindex':2,src:__WEBPACK_IMPORTED_MODULE_15__images_icons_emojis_bad_gif___default.a,onClick:_this4.selectRating}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center hovertxt'},'Hard')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'emojianim',onMouseOver:_this4.handleMouseOver,onMouseOut:_this4.handleMouseOut},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'emojiicons','data-rateindex':1,src:__WEBPACK_IMPORTED_MODULE_19__images_icons_emojis_verybad_gif___default.a,onClick:_this4.selectRating}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center hovertxt'},'Very hard')))));}}());}}},{key:'selectRating',value:function selectRating(event){var target=event.currentTarget;__WEBPACK_IMPORTED_MODULE_2_jquery___default()(".emojiicons").removeClass("selected");__WEBPACK_IMPORTED_MODULE_2_jquery___default()(target).addClass("selected");this.selectedRate=__WEBPACK_IMPORTED_MODULE_2_jquery___default()(target).attr("data-rateindex");this.setState({selectedEmoji:parseInt(__WEBPACK_IMPORTED_MODULE_2_jquery___default()(target).attr("data-rateindex"))});this.saveRating();this.toggle();}},{key:'toggle',value:function toggle(){var me=this;if(this.state.popoverOpen==false){me.setState({popoverOpen:!me.state.popoverOpen});}else{me.setState({popoverOpen:!me.state.popoverOpen});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card subTopic clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-img-top subtopic text-center',style:{backgroundColor:this.props.subTopicBoxColor}},this.getBGImg()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-img-overlay'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-title'},this.props.subtopic.subTopicName)),this.getSubTopicBodyContent(),this.getBottomItems());}}]);return SubTopicComponent;}(__WEBPACK_IMPORTED_MODULE_4__views_core_LoggedInPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (SubTopicComponent);

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_LoggedInPage__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SubscribeModal=function(_LoggedInPage){_inherits(SubscribeModal,_LoggedInPage);function SubscribeModal(props){_classCallCheck(this,SubscribeModal);return _possibleConstructorReturn(this,(SubscribeModal.__proto__||Object.getPrototypeOf(SubscribeModal)).call(this,props));}_createClass(SubscribeModal,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'ss-modal-bdy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons md-50 playicon upgrdlock1'},'lock')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,this.rb("upgrade.heading")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.rb("upgrade.description"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subscrbtn'},this.subscribeFn(this.props.ga)));}}]);return SubscribeModal;}(__WEBPACK_IMPORTED_MODULE_1__views_core_LoggedInPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (SubscribeModal);

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_CorePage__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DesktopOnly=function(_CorePage){_inherits(DesktopOnly,_CorePage);function DesktopOnly(props){_classCallCheck(this,DesktopOnly);return _possibleConstructorReturn(this,(DesktopOnly.__proto__||Object.getPrototypeOf(DesktopOnly)).call(this,props));}_createClass(DesktopOnly,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desktoponly'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'desktop_mac')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.rb("desktop_only"))));}}]);return DesktopOnly;}(__WEBPACK_IMPORTED_MODULE_1__core_CorePage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (DesktopOnly);

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(182);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(334);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(149).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(420);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(150).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(142);
util.inherits = __webpack_require__(60);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(1004);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(1005);
var destroyImpl = __webpack_require__(421);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(97);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(202).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(97);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(202).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28), __webpack_require__(119)))

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(149).EventEmitter;


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(182);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(97);

/*<replacement>*/
var util = __webpack_require__(142);
util.inherits = __webpack_require__(60);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 424 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABSCAYAAAGEUnIRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABNlJREFUeNpi/P//PwMxgAlK/8eGv06YATeFCchpIMZEFkIKgAYJAKkFLEgCKAq4CzJgTAMgFmDBIoHXM0T7egAUMoJiBjlg0QHQk4wgGiCAGImJQiaoSbgwyKYNTITCDRTQxHhgAchN//FEGdzh+FzOSHR40VERKBxZ0H2FxYeNAAHEAPIcCH/pn/6fFABVz4CMwZkKX2IgBsD0sxCTRQgBWOpjYaAQAF3lAKT2A/FBJgYqAJwuwxdrhIKEhRTFVCsDhqZhsAoAIIAYia1biHIVKPUSKMTw1kvwUpAzOoQ6Lvq+dA2l4aRAcV4EGpIApOZTI+bmUzM9HaSWQfYsVMjEB4G4gWXQZWAWmpRPg8JrowbRxyB7UOXJQgWDHgLxAZBBH4EJkZ8MAwShNKjwVwAIIIzCn9LWC5GgEZj4cXc/kNtkIPz31ev/pLbPSG3LYWvPAcUEYGwWaH1ZD6qYmERFGAYQvMdodiM7iNI2IwV13ASCbU1CpScRzUZiHXMBSAUC8XogLmChhqFUAPpAuzYAHXcR1KBmYhhgAG3VN0LT9gYgdhgU0QdyCFCtA9SBDYMl+mjXph/WjsIbfX+fPKPIcGYZKeo7ilxDR9PUqKNGHUVp7qMTeABqSyMNhIPHsEHNBoYfazYNlKMUQM0VIAa1pUDj5Q4AAUS1ARqaRR9sdIPWlsLGDAk6Ct1BtGgh/Hv9hqixJSZkBzGys9E2qxPZMWFCdhBXZtJAt0DhITUYHCQA7R0j0tT/n78obvpSCAqggwgIR7FamDCwAfEAO2rQVTP8RFUzoFYnJaU8GaG/EZiECoBF0QQWfK1OevRmoLnuIbSaAePBEH2gImkCMAAOgHrKgyVNxQOxAPJ0+WBwVCM6ezC0p+rR+A2DIvfBWg2woc2h1RymV5Ew2psZddSAJvQBqJAJO4pJVJiBI8SP/Cjg46V+SDGys4+OT406atRRo44addSoo0ZUK4GeAH0txGBwVONgjL56dDY4pH6fOMPwj8K5PWLAv0+fcUmBRvI+IEefIRCf/0sHR0HBQTQ+aPENbNAM5BYGgADtnMFRwzAQRX3wPe4gR2Y40UEogQ6gA1yCOyB0kJRABeALV8LQSHIMHEDfXjMrRQSCsGWU/2ec2PJMJnlZrVe7a3+b3B8qt96zbs0atgz5gC9BJQJIa2NgFX/mOl1AyLAjod0pVnYhwC13u5OQz8n3AcKiD8WUyFn/ocFiii6MQawtUKr5fwfQkaqUq0vlWtS5HsA0C+0//8fWdGHepgKrGn3MGdmaGn8mrsjvzEdQ8ItpTWiGmKkhgFoExeahKcdQ9fSHXqm1AvZngGec+opTz9a1vM+VJZVBFhWzWtNjSADdSViAGxyxyLuUavaaFmVbzlyNLfW5/NgJSRw5lcN7T3DdhAo5jalJW9R7zq9oUa0KCQueM7sfCeHCDcMDj2VJg427mOZV7xDxqkdQBEVQY9avnDn62l/rx3hf+vSk2UYPCsm9AUtJu9MgQgsQwwP6KIIiKIIiKIKiCIqgCIqgCIrZg5RV6PvUs7a4QFBKulxVOecwznJVZ0mZ3cXyg6m33SZF4P2w31PjOWDdgduJCFCot6PwN3l7esmwJaqlbxC1PDxOLmvbfHwt0g94+WyfludbnKXog7oepxB9AATulcKuYFNUAAAAAElFTkSuQmCC"

/***/ }),
/* 425 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_common_Landing__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_core_LoggedInPage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_Settings_css__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_Settings_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__css_Settings_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_images_uploader__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_images_uploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_images_uploader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_images_uploader_src_styles_styles_css__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_images_uploader_src_styles_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_images_uploader_src_styles_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_images_uploader_src_styles_font_css__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_images_uploader_src_styles_font_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_images_uploader_src_styles_font_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_reactstrap__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_confirm_alert__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__css_components_ImageLoader_css__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__css_components_ImageLoader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__css_components_ImageLoader_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_components_imageLoader_ImageUpload__ = __webpack_require__(1060);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Settings=function(_LoggedInPage){_inherits(Settings,_LoggedInPage);function Settings(props){_classCallCheck(this,Settings);var _this=_possibleConstructorReturn(this,(Settings.__proto__||Object.getPrototypeOf(Settings)).call(this,props));_this.state={userid:_this.getUser().getLoginId(),name:_this.getUser().getUserName(),useremail:_this.getUser().getEmail(),mobile:_this.getUser().getMobile(),modeId:_this.getUser().getModeID(),locale:_this.getUser().getLocale(),authProviderId:_this.getUser().getAuthProviderId(),oldPassword:"",password:"",passwordConfirm:"",userimage:"",msg:"",modal:false};_this.dataUpdate=true;//Setting default state to clear
_this.defaultState=_this.state;_this.handleChange=_this.handleChange.bind(_this);_this.handlePasswrdChange=_this.handlePasswrdChange.bind(_this);_this.handleImgChange=_this.handleImgChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.handleClear=_this.handleClear.bind(_this);_this.toggle=_this.toggle.bind(_this);_this.LangSelect=_this.LangSelect.bind(_this);return _this;}_createClass(Settings,[{key:'componentDidMount',value:function componentDidMount(){this.sessionCheck();//console.log("authProviderId:::",this.state.authProviderId);
}},{key:'isPilotUser',value:function isPilotUser(){return this.getUser().isPilotUser();}},{key:'toggle',value:function toggle(e){this.setState({modal:!this.state.modal});}},{key:'handleChange',value:function handleChange(e){e.target.classList.add('active');this.setState(_defineProperty({},e.target.name,e.target.value));this.dataUpdate=false;if(e.target.name!=="fileInput"){this.showInputError(e.target.name);}else{// this.showImageError(e.target.name);
}}},{key:'LangSelect',value:function LangSelect(e){var x=e.target.value;///console.warn("Language "+x);
this.setLocale(x);this.dataUpdate=false;this.setState({locale:x});}},{key:'getLangField',value:function getLangField(){var me=this;var locales=this.getLocales();var isMuliLangAvailable=locales&&locales.length>1?true:false;if(this.isPilotUser()&&isMuliLangAvailable){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-inline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("profile.change.lang")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:this.LangSelect,id:'userlang',className:'form-control',type:'text',name:'userlang',ref:'userlang',value:this.state.locale,placeholder:'Email'},locales.map(function(key,idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:key},me.rb(key));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error',id:'useremailError'}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}},{key:'handlePasswrdChange',value:function handlePasswrdChange(e){e.target.classList.add('active');this.setState(_defineProperty({},e.target.name,e.target.value));this.dataUpdate=false;if(e.target.name!=="fileInput"){this.showPasswrdError(e.target.name);}else{// this.showImageError(e.target.name);
}}},{key:'handleImgChange',value:function handleImgChange(imageUrl){//image changes
// this.updateImage(imageUrl);
this.props.callbackHomeUpdateImage(imageUrl);}},{key:'submitdata',value:function submitdata(fData,myData){for(var i in fData){console.log(fData[i]+" == "+myData[i]);if(fData[i]!==myData[i]&&myData[i]!==undefined){return false;}}return true;}},{key:'handleSubmit',value:function handleSubmit(e){e.preventDefault();var newData={};var oldData={};var eq=true;var status="";if(!this.showFormInputErrors()||!this.showFormPassErrors()){status="error";}else{newData=this.state;oldData=this.defaultState;eq=this.submitdata(newData,oldData);if(!eq){status="success";this.storevalues(e);/*if(this.showFormPassErrors()){
                    this.passReset()
                }*/this.dataUpdate=true;}else{status="no changes";}}// console.log("old state")
// console.log(oldData)
// console.log("-------------------")
// console.log("current state")
// console.log(newData)
// console.log("*******")
// console.log(status)
}},{key:'trackProfileChanges',value:function trackProfileChanges(status){var isPwdChanged=false;if(status){isPwdChanged=this.state.password.length>0;}else{isPwdChanged=false;}//try{
var trackObj={"name":this.state.name,"password_changed":isPwdChanged,"result":status};this.initiateTrack("profile_change_evaluated",trackObj);//}catch(e){}
}},{key:'storevalues',value:function storevalues(e){var formData={"loginId":this.state.userid,"userName":this.state.name,"emailId":this.state.useremail,"currentPassword":this.state.password,"oldPassword":this.state.oldPassword,"locale":this.state.locale};for(var i in formData){if(formData[i]===null||formData[i].length<1){delete formData[i];}}var me=this;var callBackSuccess=function callBackSuccess(response){if(response!==null){//Update userStore
if(response.user&&response.user.userId){me.getUser().store(response.user);}//Changing default state tp new state
var msg="";if(response.status==="SUCCESS"){msg=me.rb("profile.saved_msg");me.defaultState=me.state;me.sessionCheck();me.props.userNameUpdateEvent(me.state.name);me.trackProfileChanges(true);}else{var replaceVal=response.status.split("||").length>1?response.status.split("||")[1]:"";msg=me.rb(response.status.split("||").length>0?response.status.split("||")[0]:response.status).replace("#1",replaceVal);me.trackProfileChanges(false);}me.state.msg=msg;var buttons=[{label:me.rb("btn.ok"),handler:function handler(){}}];me.passReset();me.showAlert(" ",msg,buttons);//me.toggle()
}//console.log("response : ", response);
};var callBackFailure=function callBackFailure(response){console.log("response : ",response);var msg=me.rb("profile.oops");me.state.msg=msg;var buttons=[{label:me.rb("alert.ok"),handler:function handler(){}}];me.trackProfileChanges(false);me.passReset();me.showAlert(" ",msg,buttons);};new __WEBPACK_IMPORTED_MODULE_9__util_HmAjax__["a" /* default */](this.getUrlFor("PROFILE_UPDATE"),formData).post(callBackSuccess,callBackFailure);}},{key:'handleClear',value:function handleClear(e){e.preventDefault();this.formReset();this.setState(this.defaultState);this.afterReset();console.log("clear");}},{key:'afterReset',value:function afterReset(){try{var oldLocale=this.defaultState.locale;//Reset to older language
this.setLocale(oldLocale);}catch(e){console.error(e);}}},{key:'showFormInputErrors',value:function showFormInputErrors(){var _this2=this;var inputs=document.querySelectorAll('.inputopt');var isFormValid=true;inputs.forEach(function(input){//console.log("input.name "+input.name)
if(input.name.length>0&&input.name!=='filesInput'){input.classList.add('active');var isInputValid=_this2.showInputError(input.name);if(!isInputValid){isFormValid=false;}}});return isFormValid;}},{key:'showFormPassErrors',value:function showFormPassErrors(){var _this3=this;var inputs=document.querySelectorAll('.inputpass');var isFormValid=true;inputs.forEach(function(input){//console.log("showFormPassErrors "+input.value)
var oPass=_this3.state.oldPassword.length;var nPass=_this3.state.password.length;var cPass=_this3.state.passwordConfirm.length;var tPass=oPass+nPass+cPass;if(input.name.length>0&&input.name!=='filesInput'&&tPass>0){input.classList.add('active');var isInputValid=_this3.showPasswrdError(input.name);if(!isInputValid){isFormValid=false;}}else{input.classList.remove('active');var error=document.getElementById(input.name+'Error');error.textContent='';}});return isFormValid;}},{key:'formReset',value:function formReset(){var inputs=document.querySelectorAll('input');if(inputs&&inputs.length>0){inputs.forEach(function(input){if(input&&input.name.length>0&&input.name!=='filesInput'){//console.log("remove" + input.name + " " + input.classList)
input.classList.remove('active');var error=document.getElementById(input.name+'Error');if(error){error.textContent='';}}else if(input&&input.name==='filesInput'){//Image validation
}});}}},{key:'passReset',value:function passReset(){var _this4=this;var inputs=document.querySelectorAll('.inputpass');inputs.forEach(function(input){console.log("passReset "+input.value);_this4.setState({oldPassword:"",password:"",passwordConfirm:""});input.classList.remove('active');var error=document.getElementById(input.name+'Error');error.textContent='';});}},{key:'showImageError',value:function showImageError(refName){var validity=document.getElementById(''+refName).files;var label="Image";//document.getElementById(`${refName}`).placeholder;
var error=document.getElementById(refName+'Error');if(validity.length<1){error.textContent=label+' is a required field';return false;}error.textContent='';return true;}},{key:'showInputError',value:function showInputError(refName){var validity=this.refs[refName].validity;var label=document.getElementById(refName+'Label').placeholder;var error=document.getElementById(refName+'Error');if(!validity.valid){if(validity.valueMissing){error.textContent=label+' is a required field';}else if(validity.typeMismatch){error.textContent=label+' should be a valid email address';}return false;}error.textContent='';return true;}},{key:'specialchar',value:function specialchar(string){var format=/^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;if(string.match(format)){return true;}else{return false;}}},{key:'showPasswrdError',value:function showPasswrdError(refName){var validity=this.refs[refName].validity;var labspl=document.getElementById(refName+'Label').placeholder.split("*");console.log("labspl "+labspl[0]);var label=labspl[0];var error=document.getElementById(refName+'Error');// console.log("refName " + refName)
var isPassword=refName.indexOf('password')!==-1;var isPasswordConfirm=refName==='passwordConfirm';var oPassword=this.refs.oldPassword.value.length;var nPassword=this.refs.password.value.length;var cPassword=this.refs.passwordConfirm.value.length;//console.log("refName " + refName)
if(isPasswordConfirm){if(this.refs.password.value!==this.refs.passwordConfirm.value){this.refs.passwordConfirm.setCustomValidity(this.rb("rpwd.doesnotmatch"));}else{this.refs.passwordConfirm.setCustomValidity('');}}if(!validity.valid){if(validity.valueMissing){error.textContent=label+' is a required field';}else if(isPassword&&validity.patternMismatch){error.textContent=label+' should be longer than 5 chars';}else if(isPasswordConfirm&&validity.customError){error.textContent=this.rb("rpwd.doesnotmatch");}return false;}error.textContent='';return true;}},{key:'render',value:function render(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'Settings'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["k" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["b" /* Col */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label-title'},this.rb("profile.aboutme")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["k" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["b" /* Col */],{xs:'12',lg:'3',md:'4',sm:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group',align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__src_components_imageLoader_ImageUpload__["a" /* default */],{checktype:'image',callback:this.handleImgChange,required:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error',id:'filesInputError'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["b" /* Col */],{xs:'12',lg:'auto',md:'auto',sm:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-inline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("profile.user_id"),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'useridLabel',className:'form-control',type:'text',name:'userid',ref:'userid',maxLength:'50',placeholder:'UserID',size:'40',value:this.state.userid,onChange:this.handleChange,required:true,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error',id:'useridError'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-inline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("profile.user_name"),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'nameLabel',className:'form-control inputopt',type:'text',name:'name',ref:'name',maxLength:'50',placeholder:'Username',size:'40',value:this.state.name,onChange:this.handleChange,required:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error',id:'nameError'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-inline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,function(){if(_this5.state.modeId=="2"||_this5.state.modeId==2){return _this5.rb("register.phone");}else{return _this5.rb("profile.email_id");}}(),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'useremailLabel',className:'form-control',type:'text',name:'useremail',ref:'useremail',maxLength:'50',placeholder:'Email',size:'40',value:this.state.modeId=="2"||this.state.modeId==2?this.state.mobile:this.state.useremail,required:true,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error',id:'useremailError'})),this.getLangField())),function(){if(parseInt(_this5.state.authProviderId)<=1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["k" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["b" /* Col */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label-middle'},_this5.rb("profile.change_password")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["k" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["b" /* Col */],{xs:'12',lg:'3',md:'4',sm:'12'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["b" /* Col */],{xs:'12',lg:'auto',md:'auto',sm:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'oldPasswordLabel',className:'form-control inputpass',type:'password',name:'oldPassword',ref:'oldPassword',maxLength:'50',placeholder:_this5.rb("profile.old_password")+_this5.rb("profile.pwdcasesensitive"),value:_this5.state.oldPassword,onChange:_this5.handlePasswrdChange,size:'40',required:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hint',hidden:true,id:'oldPasswordHint'},_this5.rb("profile.pwdcasesensitive")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error',id:'oldPasswordError'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'passwordLabel',className:'form-control inputpass',type:'password',name:'password',ref:'password',maxLength:'50',placeholder:_this5.rb("profile.new_password"),value:_this5.state.password,onChange:_this5.handlePasswrdChange,size:'40',pattern:'.{6,}',required:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hint',hidden:true,id:'passwordHint'},_this5.rb("profile.pwdcasesensitive")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error',id:'passwordError'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'passwordConfirmLabel',className:'form-control inputpass',type:'password',name:'passwordConfirm',ref:'passwordConfirm',maxLength:'50',placeholder:_this5.rb("profile.confirm_password"),value:_this5.state.passwordConfirm,size:'40',onChange:_this5.handlePasswrdChange,required:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hint',hidden:true,id:'passwordConfirmHint'},_this5.rb("profile.pwdcasesensitive")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error',id:'passwordConfirmError'})))));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["k" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["b" /* Col */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'label-title'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["k" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["b" /* Col */],{xs:'12',lg:'3',md:'4',sm:'12'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["b" /* Col */],{xs:'12',lg:'auto',md:'auto',sm:'12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btnalign'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["a" /* Button */],{className:'btncard alertyes',id:'save',size:'lg',disabled:this.dataUpdate,onClick:this.handleSubmit},this.rb("profile.save")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["a" /* Button */],{className:'btncard alertcancel',id:'cancel',size:'lg',disabled:this.dataUpdate,onClick:this.handleClear},this.rb("profile.cancel"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["e" /* Modal */],{isOpen:this.state.modal,className:'settingsModalDialog',centered:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["h" /* ModalHeader */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["f" /* ModalBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alertmsg'},this.state.msg)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["g" /* ModalFooter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_reactstrap__["a" /* Button */],{color:'Primary',className:'alertok',onClick:this.toggle},this.rb("alert.ok"))))));}}]);return Settings;}(__WEBPACK_IMPORTED_MODULE_3__views_core_LoggedInPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Settings);

/***/ }),
/* 429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1019);


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(72);
var aFunction = __webpack_require__(172);
var SPECIES = __webpack_require__(43)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(113);
var invoke = __webpack_require__(1027);
var html = __webpack_require__(391);
var cel = __webpack_require__(245);
var global = __webpack_require__(35);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(138)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 433 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(72);
var isObject = __webpack_require__(80);
var newPromiseCapability = __webpack_require__(287);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1034);


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(184),
    _assign = __webpack_require__(36);

var ReactNoopUpdateQueue = __webpack_require__(437);

var canDefineProperty = __webpack_require__(438);
var emptyObject = __webpack_require__(288);
var invariant = __webpack_require__(62);
var lowPriorityWarning = __webpack_require__(1035);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(96);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(1043);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var fieldWithoutFeedback = {
    dirty: false,
    errors: new Set(),
    warnings: new Set(),
    infos: new Set(),
    validationMessage: ''
};
exports.default = fieldWithoutFeedback;
//# sourceMappingURL=fieldWithoutFeedback.js.map

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = {
  slide: __webpack_require__(1073),
  stack: __webpack_require__(1077),
  elastic: __webpack_require__(1078),
  bubble: __webpack_require__(1081),
  push: __webpack_require__(1082),
  pushRotate: __webpack_require__(1083),
  scaleDown: __webpack_require__(1084),
  scaleRotate: __webpack_require__(1085),
  fallDown: __webpack_require__(1086),
  reveal: __webpack_require__(1087)
};
module.exports = exports['default'];

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

exports['default'] = function () {
  var Snap = undefined;
  try {
    Snap = __webpack_require__(1079);
  } finally {
    return Snap;
  }
};

module.exports = exports['default'];

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nonIterableSpread__ = __webpack_require__(1095);



function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__nonIterableSpread__["a" /* default */])();
}

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (var i = 0; i < newInputs.length; i++) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }

  return true;
}

function index (resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = areInputsEqual;
  }

  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;

  var result = function result() {
    for (var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      newArgs[_key] = arguments[_key];
    }

    if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
      return lastResult;
    }

    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  };

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_stylis__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_weak_memoize__ = __webpack_require__(1099);




// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new __WEBPACK_IMPORTED_MODULE_1__emotion_stylis__["a" /* default */](stylisOptions);

  if (false) {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;

  {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (false) {
        var map = serialized.map;
        Sheet.current = {
          insert: function insert(rule) {
            sheet.insert(rule + map);
          }
        };
      }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  }

  if (false) {
    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
    var commentStart = /\/\*/g;
    var commentEnd = /\*\//g;
    stylis.use(function (context, content) {
      switch (context) {
        case -1:
          {
            while (commentStart.test(content)) {
              commentEnd.lastIndex = commentStart.lastIndex;

              if (commentEnd.test(content)) {
                commentStart.lastIndex = commentEnd.lastIndex;
                continue;
              }

              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            }

            commentStart.lastIndex = 0;
            break;
          }
      }
    });
    stylis.use(function (context, content, selectors) {
      switch (context) {
        case -1:
          {
            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);

            if (unsafePseudoClasses) {
              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
                var ignore = ignoreRegExp.test(content);

                if (unsafePseudoClass && !ignore) {
                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
                }
              });
            }

            break;
          }
      }
    });
  }

  var cache = {
    key: key,
    sheet: new __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__["a" /* StyleSheet */]({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

/* harmony default export */ __webpack_exports__["a"] = (createCache);


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyleSheet; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (false) {
          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();




/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serializeStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_hash__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_memoize__ = __webpack_require__(1103);




var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var processStyleName = Object(__WEBPACK_IMPORTED_MODULE_2__emotion_memoize__["a" /* default */])(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  if (value == null || typeof value === 'boolean') {
    return '';
  }

  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          value = value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, char) {
        return char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {
      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles;

          if (false) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (false) {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }
      }
    // eslint-disable-next-line no-fallthrough

    default:
      {
        if (registered == null) {
          return interpolation;
        }

        var cached = registered[interpolation];

        if (false) {
          console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
          shouldWarnAboutInterpolatingClassNameFromCss = false;
        }

        return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
      }
  }
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
          }
        } else {
          string += _key + "{" + handleInterpolation(mergedProps, registered, value, false) + "}";
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (false) {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_hash__["a" /* default */])(styles) + identifierName;

  if (false) {
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1104)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuPlacer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return containerCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return clearIndicatorCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return dropdownIndicatorCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return groupHeadingCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return indicatorSeparatorCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return groupCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return inputCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return indicatorsContainerCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return loadingMessageCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return menuListCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return loadingIndicatorCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return menuCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return menuPortalCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return multiValueCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return multiValueLabelCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return multiValueRemoveCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return noOptionsMessageCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return optionCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return placeholderCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return css$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return valueContainerCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return defaultComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return exportedEqual; });
/* unused harmony export y */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__emotion_core__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__babel_runtime_helpers_esm_typeof__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__chunk_e8ae4b0f_browser_esm_js__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__emotion_css__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__babel_runtime_helpers_esm_taggedTemplateLiteral__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_input_autosize__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_input_autosize__);




















function getMenuPlacement(_ref) {
  var maxHeight = _ref.maxHeight,
      menuEl = _ref.menuEl,
      minHeight = _ref.minHeight,
      placement = _ref.placement,
      shouldScroll = _ref.shouldScroll,
      isFixedPosition = _ref.isFixedPosition,
      theme = _ref.theme;
  var spacing = theme.spacing;
  var scrollParent = Object(__WEBPACK_IMPORTED_MODULE_15__chunk_e8ae4b0f_browser_esm_js__["a"])(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: maxHeight
  }; // something went wrong, return default state

  if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;

  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;

  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;

  var viewHeight = window.innerHeight;
  var scrollTop = Object(__WEBPACK_IMPORTED_MODULE_15__chunk_e8ae4b0f_browser_esm_js__["b"])(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;

  switch (placement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          Object(__WEBPACK_IMPORTED_MODULE_15__chunk_e8ae4b0f_browser_esm_js__["c"])(scrollParent, scrollDown, scrollDuration);
        }

        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          Object(__WEBPACK_IMPORTED_MODULE_15__chunk_e8ae4b0f_browser_esm_js__["c"])(scrollParent, scrollDown, scrollDuration);
        } // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.


        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      } // 4. Forked beviour when there isn't enough space below
      // AUTO: flip the menu, render above


      if (placement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = maxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;

        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      } // BOTTOM: allow browser to increase scrollable area and immediately set scroll


      if (placement === 'bottom') {
        Object(__WEBPACK_IMPORTED_MODULE_15__chunk_e8ae4b0f_browser_esm_js__["l" /* s */])(scrollParent, scrollDown);
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      }

      break;

    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          Object(__WEBPACK_IMPORTED_MODULE_15__chunk_e8ae4b0f_browser_esm_js__["c"])(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }

        if (shouldScroll) {
          Object(__WEBPACK_IMPORTED_MODULE_15__chunk_e8ae4b0f_browser_esm_js__["c"])(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      } // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below


      return {
        placement: 'bottom',
        maxHeight: maxHeight
      };

    default:
      throw new Error("Invalid placement provided \"".concat(placement, "\"."));
  } // fulfil contract with flow: implicit return value of undefined


  return defaultState;
} // Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}

var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};

var menuCSS = function menuCSS(_ref2) {
  var _ref3;

  var placement = _ref2.placement,
      _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      spacing = _ref2$theme.spacing,
      colors = _ref2$theme.colors;
  return _ref3 = {
    label: 'menu'
  }, Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, alignToControl(placement), '100%'), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "backgroundColor", colors.neutral0), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "borderRadius", borderRadius), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "marginBottom", spacing.menuGutter), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "marginTop", spacing.menuGutter), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "position", 'absolute'), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "width", '100%'), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "zIndex", 1), _ref3;
}; // NOTE: internal only

var MenuPlacer =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(MenuPlacer, _Component);

  function MenuPlacer() {
    var _getPrototypeOf2;

    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, MenuPlacer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, (_getPrototypeOf2 = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(MenuPlacer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "state", {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    });

    Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getPlacement", function (ref) {
      var _this$props = _this.props,
          minMenuHeight = _this$props.minMenuHeight,
          maxMenuHeight = _this$props.maxMenuHeight,
          menuPlacement = _this$props.menuPlacement,
          menuPosition = _this$props.menuPosition,
          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
          theme = _this$props.theme;
      var getPortalPlacement = _this.context.getPortalPlacement;
      if (!ref) return; // DO NOT scroll if position is fixed

      var isFixedPosition = menuPosition === 'fixed';
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll: shouldScroll,
        isFixedPosition: isFixedPosition,
        theme: theme
      });
      if (getPortalPlacement) getPortalPlacement(state);

      _this.setState(state);
    });

    Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getUpdatedProps", function () {
      var menuPlacement = _this.props.menuPlacement;
      var placement = _this.state.placement || coercePlacement(menuPlacement);
      return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, _this.props, {
        placement: placement,
        maxHeight: _this.state.maxHeight
      });
    });

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(MenuPlacer, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]);

  return MenuPlacer;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(MenuPlacer, "contextTypes", {
  getPortalPlacement: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.func
});

var Menu = function Menu(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('menu', props),
    className: cx({
      menu: true
    }, className)
  }, innerProps, {
    ref: innerRef
  }), children);
};
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref4) {
  var maxHeight = _ref4.maxHeight,
      baseUnit = _ref4.theme.spacing.baseUnit;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: baseUnit,
    paddingTop: baseUnit,
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};
var MenuList = function MenuList(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isMulti = props.isMulti,
      innerRef = props.innerRef;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", {
    css: getStyles('menuList', props),
    className: cx({
      'menu-list': true,
      'menu-list--is-multi': isMulti
    }, className),
    ref: innerRef
  }, children);
}; // ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref5) {
  var _ref5$theme = _ref5.theme,
      baseUnit = _ref5$theme.spacing.baseUnit,
      colors = _ref5$theme.colors;
  return {
    color: colors.neutral40,
    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
    textAlign: 'center'
  };
};

var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('noOptionsMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--no-options': true
    }, className)
  }, innerProps), children);
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};
var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('loadingMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--loading': true
    }, className)
  }, innerProps), children);
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
}; // ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref6) {
  var rect = _ref6.rect,
      offset = _ref6.offset,
      position = _ref6.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal =
/*#__PURE__*/
function (_Component2) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(MenuPortal, _Component2);

  function MenuPortal() {
    var _getPrototypeOf3;

    var _this2;

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, MenuPortal);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, (_getPrototypeOf3 = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(MenuPortal)).call.apply(_getPrototypeOf3, [this].concat(args)));

    Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this2)), "state", {
      placement: null
    });

    Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this2)), "getPortalPlacement", function (_ref7) {
      var placement = _ref7.placement;
      var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed

      if (placement !== initialPlacement) {
        _this2.setState({
          placement: placement
        });
      }
    });

    return _this2;
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(MenuPortal, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        getPortalPlacement: this.getPortalPlacement
      };
    } // callback for occassions where the menu must "flip"

  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          appendTo = _this$props2.appendTo,
          children = _this$props2.children,
          controlElement = _this$props2.controlElement,
          menuPlacement = _this$props2.menuPlacement,
          position = _this$props2.menuPosition,
          getStyles = _this$props2.getStyles;
      var isFixed = position === 'fixed'; // bail early if required elements aren't present

      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }

      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = Object(__WEBPACK_IMPORTED_MODULE_15__chunk_e8ae4b0f_browser_esm_js__["g"])(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = {
        offset: offset,
        position: position,
        rect: rect
      }; // same wrapper element whether fixed or portalled

      var menuWrapper = Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", {
        css: getStyles('menuPortal', state)
      }, children);
      return appendTo ? Object(__WEBPACK_IMPORTED_MODULE_12_react_dom__["createPortal"])(menuWrapper, appendTo) : menuWrapper;
    }
  }]);

  return MenuPortal;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(MenuPortal, "childContextTypes", {
  getPortalPlacement: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.func
});

var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && Object(__WEBPACK_IMPORTED_MODULE_14__babel_runtime_helpers_esm_typeof__["a" /* default */])(a) == 'object' && Object(__WEBPACK_IMPORTED_MODULE_14__babel_runtime_helpers_esm_typeof__["a" /* default */])(b) == 'object') {
    var arrA = isArray(a),
        arrB = isArray(b),
        i,
        length,
        key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }

      return true;
    }

    if (arrA != arrB) return false;
    var dateA = a instanceof Date,
        dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();
    var regexpA = a instanceof RegExp,
        regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();
    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length) {
      return false;
    }

    for (i = length; i-- !== 0;) {
      if (!hasProp.call(b, keys[i])) return false;
    } // end fast-deep-equal
    // Custom handling for React


    for (i = length; i-- !== 0;) {
      key = keys[i];

      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    } // fast-deep-equal index.js 2.0.1


    return true;
  }

  return a !== a && b !== b;
} // end fast-deep-equal


function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (error.message && error.message.match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    } // some other error. we should definitely know about these


    throw error;
  }
}

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isRtl = _ref.isRtl;
  return {
    label: 'container',
    direction: isRtl ? 'rtl' : null,
    pointerEvents: isDisabled ? 'none' : null,
    // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('container', props),
    className: cx({
      '--is-disabled': isDisabled,
      '--is-rtl': isRtl
    }, className)
  }, innerProps), children);
}; // ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  };
};
var ValueContainer =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(ValueContainer, _Component);

  function ValueContainer() {
    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ValueContainer);

    return Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ValueContainer).apply(this, arguments));
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(ValueContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          cx = _this$props.cx,
          isMulti = _this$props.isMulti,
          getStyles = _this$props.getStyles,
          hasValue = _this$props.hasValue;
      return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", {
        css: getStyles('valueContainer', this.props),
        className: cx({
          'value-container': true,
          'value-container--is-multi': isMulti,
          'value-container--has-value': hasValue
        }, className)
      }, children);
    }
  }]);

  return ValueContainer;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]); // ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", {
    css: getStyles('indicatorsContainer', props),
    className: cx({
      indicators: true
    }, className)
  }, children);
};

function _templateObject() {
  var data = Object(__WEBPACK_IMPORTED_MODULE_17__babel_runtime_helpers_esm_taggedTemplateLiteral__["a" /* default */])(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _ref2 =  true ? {
  name: "19bqh2r",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;"
} : {
  name: "19bqh2r",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"
};

// ==============================
// Dropdown & Clear Icons
// ==============================
var Svg = function Svg(_ref) {
  var size = _ref.size,
      props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, ["size"]);

  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("svg", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2
  }, props));
};

var CrossIcon = function CrossIcon(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(Svg, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    size: 20
  }, props), Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(Svg, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    size: 20
  }, props), Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref3) {
  var isFocused = _ref3.isFocused,
      _ref3$theme = _ref3.theme,
      baseUnit = _ref3$theme.spacing.baseUnit,
      colors = _ref3$theme.colors;
  return {
    label: 'indicatorContainer',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  };
};

var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, innerProps, {
    css: getStyles('dropdownIndicator', props),
    className: cx({
      indicator: true,
      'dropdown-indicator': true
    }, className)
  }), children || Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, innerProps, {
    css: getStyles('clearIndicator', props),
    className: cx({
      indicator: true,
      'clear-indicator': true
    }, className)
  }), children || Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(CrossIcon, null));
}; // ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4) {
  var isDisabled = _ref4.isDisabled,
      _ref4$theme = _ref4.theme,
      baseUnit = _ref4$theme.spacing.baseUnit,
      colors = _ref4$theme.colors;
  return {
    label: 'indicatorSeparator',
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2,
    width: 1
  };
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("span", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, innerProps, {
    css: getStyles('indicatorSeparator', props),
    className: cx({
      'indicator-separator': true
    }, className)
  }));
}; // ==============================
// Loading
// ==============================

var loadingDotAnimations = Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["d" /* keyframes */])(_templateObject());
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5) {
  var isFocused = _ref5.isFocused,
      size = _ref5.size,
      _ref5$theme = _ref5.theme,
      colors = _ref5$theme.colors,
      baseUnit = _ref5$theme.spacing.baseUnit;
  return {
    label: 'loadingIndicator',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};

var LoadingDot = function LoadingDot(_ref6) {
  var color = _ref6.color,
      delay = _ref6.delay,
      offset = _ref6.offset;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("span", {
    css:
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_16__emotion_css__["a" /* default */])({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: color,
      borderRadius: '1em;',
      display: 'inline-block;',
      marginLeft: offset ? '1em;' : null,
      height: '1em;',
      verticalAlign: 'top;',
      width: '1em;'
    },  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
};

var LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isFocused = props.isFocused,
      isRtl = props.isRtl,
      colors = props.theme.colors;
  var color = isFocused ? colors.neutral80 : colors.neutral20;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, innerProps, {
    css: getStyles('loadingIndicator', props),
    className: cx({
      indicator: true,
      'loading-indicator': true
    }, className)
  }), Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(LoadingDot, {
    color: color,
    delay: 0,
    offset: isRtl
  }), Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(LoadingDot, {
    color: color,
    delay: 160,
    offset: true
  }), Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(LoadingDot, {
    color: color,
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};

var css = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      borderRadius = _ref$theme.borderRadius,
      spacing = _ref$theme.spacing;
  return {
    label: 'control',
    alignItems: 'center',
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  };
};

var Control = function Control(props) {
  var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerRef = props.innerRef,
      innerProps = props.innerProps,
      menuIsOpen = props.menuIsOpen;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: innerRef,
    css: getStyles('control', props),
    className: cx({
      control: true,
      'control--is-disabled': isDisabled,
      'control--is-focused': isFocused,
      'control--menu-is-open': menuIsOpen
    }, className)
  }, innerProps), children);
};

var groupCSS = function groupCSS(_ref) {
  var spacing = _ref.theme.spacing;
  return {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};

var Group = function Group(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      Heading = props.Heading,
      headingProps = props.headingProps,
      label = props.label,
      theme = props.theme,
      selectProps = props.selectProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", {
    css: getStyles('group', props),
    className: cx({
      group: true
    }, className)
  }, Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(Heading, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    cx: cx
  }), label), Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", null, children));
};

var groupHeadingCSS = function groupHeadingCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    label: 'group',
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: '500',
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};
var GroupHeading = function GroupHeading(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      theme = props.theme,
      selectProps = props.selectProps,
      cleanProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["className", "cx", "getStyles", "theme", "selectProps"]);

  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('groupHeading', Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
      theme: theme
    }, cleanProps)),
    className: cx({
      'group-heading': true
    }, className)
  }, cleanProps));
};

var inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: colors.neutral80
  };
};

var inputStyle = function inputStyle(isHidden) {
  return {
    label: 'input',
    background: 0,
    border: 0,
    fontSize: 'inherit',
    opacity: isHidden ? 0 : 1,
    outline: 0,
    padding: 0,
    color: 'inherit'
  };
};

var Input = function Input(_ref2) {
  var className = _ref2.className,
      cx = _ref2.cx,
      getStyles = _ref2.getStyles,
      innerRef = _ref2.innerRef,
      isHidden = _ref2.isHidden,
      isDisabled = _ref2.isDisabled,
      theme = _ref2.theme,
      selectProps = _ref2.selectProps,
      props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref2, ["className", "cx", "getStyles", "innerRef", "isHidden", "isDisabled", "theme", "selectProps"]);

  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", {
    css: getStyles('input', Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
      theme: theme
    }, props))
  }, Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(__WEBPACK_IMPORTED_MODULE_18_react_input_autosize___default.a, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: cx({
      input: true
    }, className),
    inputRef: innerRef,
    inputStyle: inputStyle(isHidden),
    disabled: isDisabled
  }, props)));
};

var multiValueCSS = function multiValueCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      borderRadius = _ref$theme.borderRadius,
      colors = _ref$theme.colors;
  return {
    label: 'multiValue',
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    display: 'flex',
    margin: spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug

  };
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
  var _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      colors = _ref2$theme.colors,
      cropWithEllipsis = _ref2.cropWithEllipsis;
  return {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
    whiteSpace: 'nowrap'
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
  var _ref3$theme = _ref3.theme,
      spacing = _ref3$theme.spacing,
      borderRadius = _ref3$theme.borderRadius,
      colors = _ref3$theme.colors,
      isFocused = _ref3.isFocused;
  return {
    alignItems: 'center',
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused && colors.dangerLight,
    display: 'flex',
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  };
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
      innerProps = _ref4.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
var MultiValueRemove =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(MultiValueRemove, _Component);

  function MultiValueRemove() {
    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, MultiValueRemove);

    return Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(MultiValueRemove).apply(this, arguments));
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(MultiValueRemove, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          innerProps = _this$props.innerProps;
      return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", innerProps, children || Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(CrossIcon, {
        size: 14
      }));
    }
  }]);

  return MultiValueRemove;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

var MultiValue =
/*#__PURE__*/
function (_Component2) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(MultiValue, _Component2);

  function MultiValue() {
    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, MultiValue);

    return Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(MultiValue).apply(this, arguments));
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(MultiValue, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          components = _this$props2.components,
          cx = _this$props2.cx,
          data = _this$props2.data,
          getStyles = _this$props2.getStyles,
          innerProps = _this$props2.innerProps,
          isDisabled = _this$props2.isDisabled,
          removeProps = _this$props2.removeProps,
          selectProps = _this$props2.selectProps;
      var Container = components.Container,
          Label = components.Label,
          Remove = components.Remove;
      return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["b" /* ClassNames */], null, function (_ref5) {
        var css = _ref5.css,
            emotionCx = _ref5.cx;
        return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(Container, {
          data: data,
          innerProps: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, innerProps, {
            className: emotionCx(css(getStyles('multiValue', _this.props)), cx({
              'multi-value': true,
              'multi-value--is-disabled': isDisabled
            }, className))
          }),
          selectProps: selectProps
        }, Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(Label, {
          data: data,
          innerProps: {
            className: emotionCx(css(getStyles('multiValueLabel', _this.props)), cx({
              'multi-value__label': true
            }, className))
          },
          selectProps: selectProps
        }, children), Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])(Remove, {
          data: data,
          innerProps: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
            className: emotionCx(css(getStyles('multiValueRemove', _this.props)), cx({
              'multi-value__remove': true
            }, className))
          }, removeProps),
          selectProps: selectProps
        }));
      });
    }
  }]);

  return MultiValue;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(MultiValue, "defaultProps", {
  cropWithEllipsis: true
});

var optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'option',
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
    }
  };
};

var Option = function Option(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('option', props),
    className: cx({
      option: true,
      'option--is-disabled': isDisabled,
      'option--is-focused': isFocused,
      'option--is-selected': isSelected
    }, className),
    ref: innerRef
  }, innerProps), children);
};

var placeholderCSS = function placeholderCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'placeholder',
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var Placeholder = function Placeholder(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('placeholder', props),
    className: cx({
      placeholder: true
    }, className)
  }, innerProps), children);
};

var css$1 = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'singleValue',
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
    overflow: 'hidden',
    position: 'absolute',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var SingleValue = function SingleValue(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["c" /* jsx */])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('singleValue', props),
    className: cx({
      'single-value': true,
      'single-value--is-disabled': isDisabled
    }, className)
  }, innerProps), children);
};

var components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, components, props.components);
};




/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _taggedTemplateLiteral;
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Select; });
/* unused harmony export a */
/* unused harmony export c */
/* unused harmony export d */
/* unused harmony export m */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_memoize_one__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__emotion_core__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__chunk_e8ae4b0f_browser_esm_js__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__emotion_css__ = __webpack_require__(145);



















var diacritics = [{
  base: 'A',
  letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
}, {
  base: 'AA',
  letters: /[\uA732]/g
}, {
  base: 'AE',
  letters: /[\u00C6\u01FC\u01E2]/g
}, {
  base: 'AO',
  letters: /[\uA734]/g
}, {
  base: 'AU',
  letters: /[\uA736]/g
}, {
  base: 'AV',
  letters: /[\uA738\uA73A]/g
}, {
  base: 'AY',
  letters: /[\uA73C]/g
}, {
  base: 'B',
  letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
}, {
  base: 'C',
  letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
}, {
  base: 'D',
  letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
}, {
  base: 'DZ',
  letters: /[\u01F1\u01C4]/g
}, {
  base: 'Dz',
  letters: /[\u01F2\u01C5]/g
}, {
  base: 'E',
  letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
}, {
  base: 'F',
  letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
}, {
  base: 'G',
  letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
}, {
  base: 'H',
  letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
}, {
  base: 'I',
  letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
}, {
  base: 'J',
  letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g
}, {
  base: 'K',
  letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
}, {
  base: 'L',
  letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
}, {
  base: 'LJ',
  letters: /[\u01C7]/g
}, {
  base: 'Lj',
  letters: /[\u01C8]/g
}, {
  base: 'M',
  letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
}, {
  base: 'N',
  letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
}, {
  base: 'NJ',
  letters: /[\u01CA]/g
}, {
  base: 'Nj',
  letters: /[\u01CB]/g
}, {
  base: 'O',
  letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
}, {
  base: 'OI',
  letters: /[\u01A2]/g
}, {
  base: 'OO',
  letters: /[\uA74E]/g
}, {
  base: 'OU',
  letters: /[\u0222]/g
}, {
  base: 'P',
  letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
}, {
  base: 'Q',
  letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
}, {
  base: 'R',
  letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
}, {
  base: 'S',
  letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
}, {
  base: 'T',
  letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
}, {
  base: 'TZ',
  letters: /[\uA728]/g
}, {
  base: 'U',
  letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
}, {
  base: 'V',
  letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
}, {
  base: 'VY',
  letters: /[\uA760]/g
}, {
  base: 'W',
  letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
}, {
  base: 'X',
  letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
}, {
  base: 'Y',
  letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
}, {
  base: 'Z',
  letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
}, {
  base: 'a',
  letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
}, {
  base: 'aa',
  letters: /[\uA733]/g
}, {
  base: 'ae',
  letters: /[\u00E6\u01FD\u01E3]/g
}, {
  base: 'ao',
  letters: /[\uA735]/g
}, {
  base: 'au',
  letters: /[\uA737]/g
}, {
  base: 'av',
  letters: /[\uA739\uA73B]/g
}, {
  base: 'ay',
  letters: /[\uA73D]/g
}, {
  base: 'b',
  letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
}, {
  base: 'c',
  letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
}, {
  base: 'd',
  letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
}, {
  base: 'dz',
  letters: /[\u01F3\u01C6]/g
}, {
  base: 'e',
  letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
}, {
  base: 'f',
  letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
}, {
  base: 'g',
  letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
}, {
  base: 'h',
  letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
}, {
  base: 'hv',
  letters: /[\u0195]/g
}, {
  base: 'i',
  letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
}, {
  base: 'j',
  letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
}, {
  base: 'k',
  letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
}, {
  base: 'l',
  letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
}, {
  base: 'lj',
  letters: /[\u01C9]/g
}, {
  base: 'm',
  letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
}, {
  base: 'n',
  letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
}, {
  base: 'nj',
  letters: /[\u01CC]/g
}, {
  base: 'o',
  letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
}, {
  base: 'oi',
  letters: /[\u01A3]/g
}, {
  base: 'ou',
  letters: /[\u0223]/g
}, {
  base: 'oo',
  letters: /[\uA74F]/g
}, {
  base: 'p',
  letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
}, {
  base: 'q',
  letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
}, {
  base: 'r',
  letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
}, {
  base: 's',
  letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
}, {
  base: 't',
  letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
}, {
  base: 'tz',
  letters: /[\uA729]/g
}, {
  base: 'u',
  letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
}, {
  base: 'v',
  letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
}, {
  base: 'vy',
  letters: /[\uA761]/g
}, {
  base: 'w',
  letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
}, {
  base: 'x',
  letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
}, {
  base: 'y',
  letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
}, {
  base: 'z',
  letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
}];
var stripDiacritics = function stripDiacritics(str) {
  for (var i = 0; i < diacritics.length; i++) {
    str = str.replace(diacritics[i].letters, diacritics[i].base);
  }

  return str;
};

var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var defaultStringify = function defaultStringify(option) {
  return "".concat(option.label, " ").concat(option.value);
};

var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    var _ignoreCase$ignoreAcc = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: 'any'
    }, config),
        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
        stringify = _ignoreCase$ignoreAcc.stringify,
        trim = _ignoreCase$ignoreAcc.trim,
        matchFrom = _ignoreCase$ignoreAcc.matchFrom;

    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);

    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }

    if (ignoreAccents) {
      input = stripDiacritics(input);
      candidate = stripDiacritics(candidate);
    }

    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

var _ref =  true ? {
  name: "1laao21-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;"
} : {
  name: "1laao21-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFNIiwiZmlsZSI6IkExMXlUZXh0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgdHlwZSBFbGVtZW50Q29uZmlnIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vY29yZSc7XG5cbi8vIEFzc2lzdGl2ZSB0ZXh0IHRvIGRlc2NyaWJlIHZpc3VhbCBlbGVtZW50cy4gSGlkZGVuIGZvciBzaWdodGVkIHVzZXJzLlxuY29uc3QgQTExeVRleHQgPSAocHJvcHM6IEVsZW1lbnRDb25maWc8J3NwYW4nPikgPT4gKFxuICAgIDxzcGFuXG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdhMTF5VGV4dCcsXG4gICAgICAgIHpJbmRleDogOTk5OSxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICBjbGlwOiAncmVjdCgxcHgsIDFweCwgMXB4LCAxcHgpJyxcbiAgICAgICAgaGVpZ2h0OiAxLFxuICAgICAgICB3aWR0aDogMSxcbiAgICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICAgIG92ZXJmbG93OiAnaGlkZGVuJyxcbiAgICAgICAgcGFkZGluZzogMCxcbiAgICAgICAgd2hpdGVTcGFjZTogJ25vd3JhcCcsXG4gICAgICB9fVxuICAgICAgey4uLnByb3BzfVxuICAgIC8+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBBMTF5VGV4dDtcbiJdfQ== */"
};

var A11yText = function A11yText(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["c" /* jsx */])("span", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: _ref
  }, props));
};

var DummyInput =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(DummyInput, _Component);

  function DummyInput() {
    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, DummyInput);

    return Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(DummyInput).apply(this, arguments));
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(DummyInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          inProp = _this$props.in,
          out = _this$props.out,
          onExited = _this$props.onExited,
          appear = _this$props.appear,
          enter = _this$props.enter,
          exit = _this$props.exit,
          innerRef = _this$props.innerRef,
          emotion = _this$props.emotion,
          props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_this$props, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);

      return Object(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["c" /* jsx */])("input", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        ref: innerRef
      }, props, {
        css:
        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_17__emotion_css__["a" /* default */])({
          label: 'dummyInput',
          // get rid of any default styles
          background: 0,
          border: 0,
          fontSize: 'inherit',
          outline: 0,
          padding: 0,
          // important! without `width` browsers won't allow focus
          width: 1,
          // remove cursor on desktop
          color: 'transparent',
          // remove cursor on mobile whilst maintaining "scroll into view" behaviour
          left: -100,
          opacity: 0,
          position: 'relative',
          transform: 'scale(0)'
        },  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBWVEiLCJmaWxlIjoiRHVtbXlJbnB1dC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG4vKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IENvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL2NvcmUnO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBEdW1teUlucHV0IGV4dGVuZHMgQ29tcG9uZW50PGFueT4ge1xuICByZW5kZXIgKCkge1xuICAgIGNvbnN0IHsgaW46IGluUHJvcCwgb3V0LCBvbkV4aXRlZCwgYXBwZWFyLCBlbnRlciwgZXhpdCwgaW5uZXJSZWYsIGVtb3Rpb24sIC4uLnByb3BzIH0gPSB0aGlzLnByb3BzO1xuICAgIHJldHVybihcbiAgICAgIDxpbnB1dFxuICAgICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgICB7Li4ucHJvcHN9XG4gICAgICAgIGNzcz17e1xuICAgICAgICAgIGxhYmVsOiAnZHVtbXlJbnB1dCcsXG4gICAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgICBiYWNrZ3JvdW5kOiAwLFxuICAgICAgICAgIGJvcmRlcjogMCxcbiAgICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICAgIG91dGxpbmU6IDAsXG4gICAgICAgICAgcGFkZGluZzogMCxcbiAgICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICAgIHdpZHRoOiAxLFxuXG4gICAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBkZXNrdG9wXG4gICAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIG1vYmlsZSB3aGlsc3QgbWFpbnRhaW5pbmcgXCJzY3JvbGwgaW50byB2aWV3XCIgYmVoYXZpb3VyXG4gICAgICAgICAgbGVmdDogLTEwMCxcbiAgICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuICAgICAgICAgIHRyYW5zZm9ybTogJ3NjYWxlKDApJyxcbiAgICAgICAgfX1cbiAgICAgIC8+XG4gICAgKTtcbiAgfVxufVxuIl19 */")
      }));
    }
  }]);

  return DummyInput;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

var NodeResolver =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(NodeResolver, _Component);

  function NodeResolver() {
    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, NodeResolver);

    return Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(NodeResolver).apply(this, arguments));
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(NodeResolver, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.innerRef(Object(__WEBPACK_IMPORTED_MODULE_14_react_dom__["findDOMNode"])(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.innerRef(null);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return NodeResolver;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
var LOCK_STYLES = {
  boxSizing: 'border-box',
  // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};

function preventTouchMove(e) {
  e.preventDefault();
}
function allowTouchMove(e) {
  e.stopPropagation();
}
function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
} // `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

var canUseDOM = !!(window.document && window.document.createElement);
var activeScrollLocks = 0;

var ScrollLock =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(ScrollLock, _Component);

  function ScrollLock() {
    var _getPrototypeOf2;

    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ScrollLock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, (_getPrototypeOf2 = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ScrollLock)).call.apply(_getPrototypeOf2, [this].concat(args)));

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "originalStyles", {});

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "listenerOptions", {
      capture: false,
      passive: false
    });

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(ScrollLock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!canUseDOM) return;
      var _this$props = this.props,
          accountForScrollbars = _this$props.accountForScrollbars,
          touchScrollTarget = _this$props.touchScrollTarget;
      var target = document.body;
      var targetStyle = target && target.style;

      if (accountForScrollbars) {
        // store any styles already applied to the body
        STYLE_KEYS.forEach(function (key) {
          var val = targetStyle && targetStyle[key];
          _this2.originalStyles[key] = val;
        });
      } // apply the lock styles and padding if this is the first scroll lock


      if (accountForScrollbars && activeScrollLocks < 1) {
        var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
        var clientWidth = document.body ? document.body.clientWidth : 0;
        var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
        Object.keys(LOCK_STYLES).forEach(function (key) {
          var val = LOCK_STYLES[key];

          if (targetStyle) {
            targetStyle[key] = val;
          }
        });

        if (targetStyle) {
          targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
      } // account for touch devices


      if (target && isTouchDevice()) {
        // Mobile Safari ignores { overflow: hidden } declaration on the body.
        target.addEventListener('touchmove', preventTouchMove, this.listenerOptions); // Allow scroll on provided target

        if (touchScrollTarget) {
          touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.addEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      } // increment active scroll locks


      activeScrollLocks += 1;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      if (!canUseDOM) return;
      var _this$props2 = this.props,
          accountForScrollbars = _this$props2.accountForScrollbars,
          touchScrollTarget = _this$props2.touchScrollTarget;
      var target = document.body;
      var targetStyle = target && target.style; // safely decrement active scroll locks

      activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any

      if (accountForScrollbars && activeScrollLocks < 1) {
        STYLE_KEYS.forEach(function (key) {
          var val = _this3.originalStyles[key];

          if (targetStyle) {
            targetStyle[key] = val;
          }
        });
      } // remove touch listeners


      if (target && isTouchDevice()) {
        target.removeEventListener('touchmove', preventTouchMove, this.listenerOptions);

        if (touchScrollTarget) {
          touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.removeEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return ScrollLock;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(ScrollLock, "defaultProps", {
  accountForScrollbars: true
});

var _ref$1 =  true ? {
  name: "1dsbpcp",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;"
} : {
  name: "1dsbpcp",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"
};

// NOTE:
// We shouldn't need this after updating to React v16.3.0, which introduces:
// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref
var ScrollBlock =
/*#__PURE__*/
function (_PureComponent) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(ScrollBlock, _PureComponent);

  function ScrollBlock() {
    var _getPrototypeOf2;

    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ScrollBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, (_getPrototypeOf2 = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ScrollBlock)).call.apply(_getPrototypeOf2, [this].concat(args)));

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "state", {
      touchScrollTarget: null
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getScrollTarget", function (ref) {
      if (ref === _this.state.touchScrollTarget) return;

      _this.setState({
        touchScrollTarget: ref
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "blurSelectInput", function () {
      if (document.activeElement) {
        document.activeElement.blur();
      }
    });

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(ScrollBlock, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          isEnabled = _this$props.isEnabled;
      var touchScrollTarget = this.state.touchScrollTarget; // bail early if not enabled

      if (!isEnabled) return children;
      /*
       * Div
       * ------------------------------
       * blocks scrolling on non-body elements behind the menu
        * NodeResolver
       * ------------------------------
       * we need a reference to the scrollable element to "unlock" scroll on
       * mobile devices
        * ScrollLock
       * ------------------------------
       * actually does the scroll locking
       */

      return Object(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["c" /* jsx */])("div", null, Object(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["c" /* jsx */])("div", {
        onClick: this.blurSelectInput,
        css: _ref$1
      }), Object(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["c" /* jsx */])(NodeResolver, {
        innerRef: this.getScrollTarget
      }, children), touchScrollTarget ? Object(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["c" /* jsx */])(ScrollLock, {
        touchScrollTarget: touchScrollTarget
      }) : null);
    }
  }]);

  return ScrollBlock;
}(__WEBPACK_IMPORTED_MODULE_11_react__["PureComponent"]);

var ScrollCaptor =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(ScrollCaptor, _Component);

  function ScrollCaptor() {
    var _getPrototypeOf2;

    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ScrollCaptor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, (_getPrototypeOf2 = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ScrollCaptor)).call.apply(_getPrototypeOf2, [this].concat(args)));

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "isBottom", false);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "isTop", false);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "scrollTarget", void 0);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "touchStart", void 0);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "cancelScroll", function (event) {
      event.preventDefault();
      event.stopPropagation();
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "handleEventDelta", function (event, delta) {
      var _this$props = _this.props,
          onBottomArrive = _this$props.onBottomArrive,
          onBottomLeave = _this$props.onBottomLeave,
          onTopArrive = _this$props.onTopArrive,
          onTopLeave = _this$props.onTopLeave;
      var _this$scrollTarget = _this.scrollTarget,
          scrollTop = _this$scrollTarget.scrollTop,
          scrollHeight = _this$scrollTarget.scrollHeight,
          clientHeight = _this$scrollTarget.clientHeight;
      var target = _this.scrollTarget;
      var isDeltaPositive = delta > 0;
      var availableScroll = scrollHeight - clientHeight - scrollTop;
      var shouldCancelScroll = false; // reset bottom/top flags

      if (availableScroll > delta && _this.isBottom) {
        if (onBottomLeave) onBottomLeave(event);
        _this.isBottom = false;
      }

      if (isDeltaPositive && _this.isTop) {
        if (onTopLeave) onTopLeave(event);
        _this.isTop = false;
      } // bottom limit


      if (isDeltaPositive && delta > availableScroll) {
        if (onBottomArrive && !_this.isBottom) {
          onBottomArrive(event);
        }

        target.scrollTop = scrollHeight;
        shouldCancelScroll = true;
        _this.isBottom = true; // top limit
      } else if (!isDeltaPositive && -delta > scrollTop) {
        if (onTopArrive && !_this.isTop) {
          onTopArrive(event);
        }

        target.scrollTop = 0;
        shouldCancelScroll = true;
        _this.isTop = true;
      } // cancel scroll


      if (shouldCancelScroll) {
        _this.cancelScroll(event);
      }
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onWheel", function (event) {
      _this.handleEventDelta(event, event.deltaY);
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onTouchStart", function (event) {
      // set touch start so we can calculate touchmove delta
      _this.touchStart = event.changedTouches[0].clientY;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onTouchMove", function (event) {
      var deltaY = _this.touchStart - event.changedTouches[0].clientY;

      _this.handleEventDelta(event, deltaY);
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getScrollTarget", function (ref) {
      _this.scrollTarget = ref;
    });

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(ScrollCaptor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListening(this.scrollTarget);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListening(this.scrollTarget);
    }
  }, {
    key: "startListening",
    value: function startListening(el) {
      // bail early if no scroll available
      if (!el) return;
      if (el.scrollHeight <= el.clientHeight) return; // all the if statements are to appease Flow 😢

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('wheel', this.onWheel, false);
      }

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchstart', this.onTouchStart, false);
      }

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: "stopListening",
    value: function stopListening(el) {
      // bail early if no scroll available
      if (el.scrollHeight <= el.clientHeight) return; // all the if statements are to appease Flow 😢

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('wheel', this.onWheel, false);
      }

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchstart', this.onTouchStart, false);
      }

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(NodeResolver, {
        innerRef: this.getScrollTarget
      }, this.props.children);
    }
  }]);

  return ScrollCaptor;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

var ScrollCaptorSwitch =
/*#__PURE__*/
function (_Component2) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(ScrollCaptorSwitch, _Component2);

  function ScrollCaptorSwitch() {
    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ScrollCaptorSwitch);

    return Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ScrollCaptorSwitch).apply(this, arguments));
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(ScrollCaptorSwitch, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          isEnabled = _this$props2.isEnabled,
          props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_this$props2, ["isEnabled"]);

      return isEnabled ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ScrollCaptor, props) : this.props.children;
    }
  }]);

  return ScrollCaptorSwitch;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(ScrollCaptorSwitch, "defaultProps", {
  isEnabled: true
});

var instructionsAriaMessage = function instructionsAriaMessage(event) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isSearchable = context.isSearchable,
      isMulti = context.isMulti,
      label = context.label,
      isDisabled = context.isDisabled;

  switch (event) {
    case 'menu':
      return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu, press Tab to select the option and exit the menu.");

    case 'input':
      return "".concat(label ? label : 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');

    case 'value':
      return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
  }
};
var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
  var value = context.value,
      isDisabled = context.isDisabled;
  if (!value) return;

  switch (event) {
    case 'deselect-option':
    case 'pop-value':
    case 'remove-value':
      return "option ".concat(value, ", deselected.");

    case 'select-option':
      return isDisabled ? "option ".concat(value, " is disabled. Select another option.") : "option ".concat(value, ", selected.");
  }
};
var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
  var focusedValue = _ref.focusedValue,
      getOptionLabel = _ref.getOptionLabel,
      selectValue = _ref.selectValue;
  return "value ".concat(getOptionLabel(focusedValue), " focused, ").concat(selectValue.indexOf(focusedValue) + 1, " of ").concat(selectValue.length, ".");
};
var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
  var focusedOption = _ref2.focusedOption,
      getOptionLabel = _ref2.getOptionLabel,
      options = _ref2.options;
  return "option ".concat(getOptionLabel(focusedOption), " focused").concat(focusedOption.isDisabled ? ' disabled' : '', ", ").concat(options.indexOf(focusedOption) + 1, " of ").concat(options.length, ".");
};
var resultsAriaMessage = function resultsAriaMessage(_ref3) {
  var inputValue = _ref3.inputValue,
      screenReaderMessage = _ref3.screenReaderMessage;
  return "".concat(screenReaderMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
};

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};
var getOptionLabel = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

var defaultStyles = {
  clearIndicator: __WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__["d" /* c */],
  container: __WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__["b" /* a */],
  control: __WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__["c" /* b */],
  dropdownIndicator: __WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__["e" /* d */],
  group: __WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__["h" /* g */],
  groupHeading: __WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__["f" /* e */],
  indicatorsContainer: __WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__["j" /* i */],
  indicatorSeparator: __WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__["g" /* f */],
  input: __WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__["i" /* h */],
  loadingIndicator: __WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__["m" /* l */],
  loadingMessage: __WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__["k" /* j */],
  menu: __WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__["n" /* m */],
  menuList: __WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__["l" /* k */],
  menuPortal: __WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__["o" /* n */],
  multiValue: __WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__["p" /* o */],
  multiValueLabel: __WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__["q" /* p */],
  multiValueRemove: __WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__["r" /* q */],
  noOptionsMessage: __WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__["s" /* r */],
  option: __WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__["t" /* s */],
  placeholder: __WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__["u" /* t */],
  singleValue: __WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__["v" /* u */],
  valueContainer: __WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__["w" /* v */]
}; // Merge Utility
// Allows consumers to extend a base Select with additional styles

function mergeStyles(source) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // initialize with source styles
  var styles = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, source); // massage in target styles


  Object.keys(target).forEach(function (key) {
    if (source[key]) {
      styles[key] = function (rsCss, props) {
        return target[key](source[key](rsCss, props), props);
      };
    } else {
      styles[key] = target[key];
    }
  });
  return styles;
}

var colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',
  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4; // Used to calculate consistent margin/padding on elements

var baseUnit = 4; // The minimum height of the control

var controlHeight = 38; // The amount of space between the control and menu */

var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};
var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};

var defaultProps = {
  backspaceRemovesValue: true,
  blurInputOnSelect: Object(__WEBPACK_IMPORTED_MODULE_15__chunk_e8ae4b0f_browser_esm_js__["i"])(),
  captureMenuScroll: !Object(__WEBPACK_IMPORTED_MODULE_15__chunk_e8ae4b0f_browser_esm_js__["i"])(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !Object(__WEBPACK_IMPORTED_MODULE_15__chunk_e8ae4b0f_browser_esm_js__["d"])(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
  },
  styles: {},
  tabIndex: '0',
  tabSelectsValue: true
};
var instanceId = 1;

var Select =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(Select, _Component);

  // Misc. Instance Properties
  // ------------------------------
  // TODO
  // Refs
  // ------------------------------
  // Lifecycle
  // ------------------------------
  function Select(_props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Select);

    _this = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Select).call(this, _props));

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "state", {
      ariaLiveSelection: '',
      ariaLiveContext: '',
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      menuOptions: {
        render: [],
        focusable: []
      },
      selectValue: []
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "blockOptionHover", false);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "isComposing", false);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "clearFocusValueOnUpdate", false);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "commonProps", void 0);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "components", void 0);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "hasGroups", false);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "initialTouchX", 0);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "initialTouchY", 0);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "inputIsHiddenAfterUpdate", void 0);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "instancePrefix", '');

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "openAfterFocus", false);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "scrollToFocusedOptionOnUpdate", false);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "userIsDragging", void 0);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "controlRef", null);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getControlRef", function (ref) {
      _this.controlRef = ref;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "focusedOptionRef", null);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getFocusedOptionRef", function (ref) {
      _this.focusedOptionRef = ref;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "menuListRef", null);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getMenuListRef", function (ref) {
      _this.menuListRef = ref;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "inputRef", null);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getInputRef", function (ref) {
      _this.inputRef = ref;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "cacheComponents", function (components) {
      _this.components = Object(__WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__["x" /* w */])({
        components: components
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "focus", _this.focusInput);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "blur", _this.blurInput);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onChange", function (newValue, actionMeta) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          name = _this$props.name;
      onChange(newValue, Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, actionMeta, {
        name: name
      }));
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "setValue", function (newValue) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
      var option = arguments.length > 2 ? arguments[2] : undefined;
      var _this$props2 = _this.props,
          closeMenuOnSelect = _this$props2.closeMenuOnSelect,
          isMulti = _this$props2.isMulti;

      _this.onInputChange('', {
        action: 'set-value'
      });

      if (closeMenuOnSelect) {
        _this.inputIsHiddenAfterUpdate = !isMulti;

        _this.onMenuClose();
      } // when the select value should change, we should reset focusedValue


      _this.clearFocusValueOnUpdate = true;

      _this.onChange(newValue, {
        action: action,
        option: option
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "selectOption", function (newValue) {
      var _this$props3 = _this.props,
          blurInputOnSelect = _this$props3.blurInputOnSelect,
          isMulti = _this$props3.isMulti;
      var selectValue = _this.state.selectValue;

      if (isMulti) {
        if (_this.isOptionSelected(newValue, selectValue)) {
          var candidate = _this.getOptionValue(newValue);

          _this.setValue(selectValue.filter(function (i) {
            return _this.getOptionValue(i) !== candidate;
          }), 'deselect-option', newValue);

          _this.announceAriaLiveSelection({
            event: 'deselect-option',
            context: {
              value: _this.getOptionLabel(newValue)
            }
          });
        } else {
          if (!_this.isOptionDisabled(newValue, selectValue)) {
            _this.setValue([].concat(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(selectValue), [newValue]), 'select-option', newValue);

            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue)
              }
            });
          } else {
            // announce that option is disabled
            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue),
                isDisabled: true
              }
            });
          }
        }
      } else {
        if (!_this.isOptionDisabled(newValue, selectValue)) {
          _this.setValue(newValue, 'select-option');

          _this.announceAriaLiveSelection({
            event: 'select-option',
            context: {
              value: _this.getOptionLabel(newValue)
            }
          });
        } else {
          // announce that option is disabled
          _this.announceAriaLiveSelection({
            event: 'select-option',
            context: {
              value: _this.getOptionLabel(newValue),
              isDisabled: true
            }
          });
        }
      }

      if (blurInputOnSelect) {
        _this.blurInput();
      }
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "removeValue", function (removedValue) {
      var selectValue = _this.state.selectValue;

      var candidate = _this.getOptionValue(removedValue);

      var newValue = selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      });

      _this.onChange(newValue.length ? newValue : null, {
        action: 'remove-value',
        removedValue: removedValue
      });

      _this.announceAriaLiveSelection({
        event: 'remove-value',
        context: {
          value: removedValue ? _this.getOptionLabel(removedValue) : ''
        }
      });

      _this.focusInput();
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "clearValue", function () {
      var isMulti = _this.props.isMulti;

      _this.onChange(isMulti ? [] : null, {
        action: 'clear'
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "popValue", function () {
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValue = selectValue.slice(0, selectValue.length - 1);

      _this.announceAriaLiveSelection({
        event: 'pop-value',
        context: {
          value: lastSelectedValue ? _this.getOptionLabel(lastSelectedValue) : ''
        }
      });

      _this.onChange(newValue.length ? newValue : null, {
        action: 'pop-value',
        removedValue: lastSelectedValue
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getOptionLabel", function (data) {
      return _this.props.getOptionLabel(data);
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getOptionValue", function (data) {
      return _this.props.getOptionValue(data);
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getStyles", function (key, props) {
      var base = defaultStyles[key](props);
      base.boxSizing = 'border-box';
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getElementId", function (element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getActiveDescendentId", function () {
      var menuIsOpen = _this.props.menuIsOpen;
      var _this$state = _this.state,
          menuOptions = _this$state.menuOptions,
          focusedOption = _this$state.focusedOption;
      if (!focusedOption || !menuIsOpen) return undefined;
      var index = menuOptions.focusable.indexOf(focusedOption);
      var option = menuOptions.render[index];
      return option && option.key;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "announceAriaLiveSelection", function (_ref2) {
      var event = _ref2.event,
          context = _ref2.context;

      _this.setState({
        ariaLiveSelection: valueEventAriaMessage(event, context)
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "announceAriaLiveContext", function (_ref3) {
      var event = _ref3.event,
          context = _ref3.context;

      _this.setState({
        ariaLiveContext: instructionsAriaMessage(event, Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, context, {
          label: _this.props['aria-label']
        }))
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onMenuMouseDown", function (event) {
      if (event.button !== 0) {
        return;
      }

      event.stopPropagation();
      event.preventDefault();

      _this.focusInput();
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onMenuMouseMove", function (event) {
      _this.blockOptionHover = false;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onControlMouseDown", function (event) {
      var openMenuOnClick = _this.props.openMenuOnClick;

      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }

        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu('first');
        }
      } else {
        //$FlowFixMe
        if (event.target.tagName !== 'INPUT') {
          _this.onMenuClose();
        }
      } //$FlowFixMe


      if (event.target.tagName !== 'INPUT') {
        event.preventDefault();
      }
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onDropdownIndicatorMouseDown", function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
          isMulti = _this$props4.isMulti,
          menuIsOpen = _this$props4.menuIsOpen;

      _this.focusInput();

      if (menuIsOpen) {
        _this.inputIsHiddenAfterUpdate = !isMulti;

        _this.onMenuClose();
      } else {
        _this.openMenu('first');
      }

      event.preventDefault();
      event.stopPropagation();
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onClearIndicatorMouseDown", function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      _this.clearValue();

      event.stopPropagation();
      _this.openAfterFocus = false;

      if (event.type === 'touchend') {
        _this.focusInput();
      } else {
        setTimeout(function () {
          return _this.focusInput();
        });
      }
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onScroll", function (event) {
      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
        if (event.target instanceof HTMLElement && Object(__WEBPACK_IMPORTED_MODULE_15__chunk_e8ae4b0f_browser_esm_js__["e"])(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onCompositionStart", function () {
      _this.isComposing = true;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onCompositionEnd", function () {
      _this.isComposing = false;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onTouchStart", function (_ref4) {
      var touches = _ref4.touches;
      var touch = touches.item(0);

      if (!touch) {
        return;
      }

      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onTouchMove", function (_ref5) {
      var touches = _ref5.touches;
      var touch = touches.item(0);

      if (!touch) {
        return;
      }

      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onTouchEnd", function (event) {
      if (_this.userIsDragging) return; // close the menu if the user taps outside
      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
      // on events on child elements, not the document (which we've attached this handler to).

      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      } // reset move vars


      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onControlTouchEnd", function (event) {
      if (_this.userIsDragging) return;

      _this.onControlMouseDown(event);
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onClearIndicatorTouchEnd", function (event) {
      if (_this.userIsDragging) return;

      _this.onClearIndicatorMouseDown(event);
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onDropdownIndicatorTouchEnd", function (event) {
      if (_this.userIsDragging) return;

      _this.onDropdownIndicatorMouseDown(event);
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "handleInputChange", function (event) {
      var inputValue = event.currentTarget.value;
      _this.inputIsHiddenAfterUpdate = false;

      _this.onInputChange(inputValue, {
        action: 'input-change'
      });

      _this.onMenuOpen();
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onInputFocus", function (event) {
      var _this$props5 = _this.props,
          isSearchable = _this$props5.isSearchable,
          isMulti = _this$props5.isMulti;

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      _this.inputIsHiddenAfterUpdate = false;

      _this.announceAriaLiveContext({
        event: 'input',
        context: {
          isSearchable: isSearchable,
          isMulti: isMulti
        }
      });

      _this.setState({
        isFocused: true
      });

      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu('first');
      }

      _this.openAfterFocus = false;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onInputBlur", function (event) {
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();

        return;
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      _this.onInputChange('', {
        action: 'input-blur'
      });

      _this.onMenuClose();

      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onOptionHover", function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }

      _this.setState({
        focusedOption: focusedOption
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "shouldHideSelectedOptions", function () {
      var _this$props6 = _this.props,
          hideSelectedOptions = _this$props6.hideSelectedOptions,
          isMulti = _this$props6.isMulti;
      if (hideSelectedOptions === undefined) return isMulti;
      return hideSelectedOptions;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onKeyDown", function (event) {
      var _this$props7 = _this.props,
          isMulti = _this$props7.isMulti,
          backspaceRemovesValue = _this$props7.backspaceRemovesValue,
          escapeClearsValue = _this$props7.escapeClearsValue,
          inputValue = _this$props7.inputValue,
          isClearable = _this$props7.isClearable,
          isDisabled = _this$props7.isDisabled,
          menuIsOpen = _this$props7.menuIsOpen,
          onKeyDown = _this$props7.onKeyDown,
          tabSelectsValue = _this$props7.tabSelectsValue,
          openMenuOnFocus = _this$props7.openMenuOnFocus;
      var _this$state2 = _this.state,
          focusedOption = _this$state2.focusedOption,
          focusedValue = _this$state2.focusedValue,
          selectValue = _this$state2.selectValue;
      if (isDisabled) return;

      if (typeof onKeyDown === 'function') {
        onKeyDown(event);

        if (event.defaultPrevented) {
          return;
        }
      } // Block option hover events when the user has just pressed a key


      _this.blockOptionHover = true;

      switch (event.key) {
        case 'ArrowLeft':
          if (!isMulti || inputValue) return;

          _this.focusValue('previous');

          break;

        case 'ArrowRight':
          if (!isMulti || inputValue) return;

          _this.focusValue('next');

          break;

        case 'Delete':
        case 'Backspace':
          if (inputValue) return;

          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;

            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }

          break;

        case 'Tab':
          if (_this.isComposing) return;

          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }

          _this.selectOption(focusedOption);

          break;

        case 'Enter':
          if (event.keyCode === 229) {
            // ignore the keydown event from an Input Method Editor(IME)
            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
            break;
          }

          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;

            _this.selectOption(focusedOption);

            break;
          }

          return;

        case 'Escape':
          if (menuIsOpen) {
            _this.inputIsHiddenAfterUpdate = false;

            _this.onInputChange('', {
              action: 'menu-close'
            });

            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }

          break;

        case ' ':
          // space
          if (inputValue) {
            return;
          }

          if (!menuIsOpen) {
            _this.openMenu('first');

            break;
          }

          if (!focusedOption) return;

          _this.selectOption(focusedOption);

          break;

        case 'ArrowUp':
          if (menuIsOpen) {
            _this.focusOption('up');
          } else {
            _this.openMenu('last');
          }

          break;

        case 'ArrowDown':
          if (menuIsOpen) {
            _this.focusOption('down');
          } else {
            _this.openMenu('first');
          }

          break;

        case 'PageUp':
          if (!menuIsOpen) return;

          _this.focusOption('pageup');

          break;

        case 'PageDown':
          if (!menuIsOpen) return;

          _this.focusOption('pagedown');

          break;

        case 'Home':
          if (!menuIsOpen) return;

          _this.focusOption('first');

          break;

        case 'End':
          if (!menuIsOpen) return;

          _this.focusOption('last');

          break;

        default:
          return;
      }

      event.preventDefault();
    });

    var value = _props.value;
    _this.cacheComponents = Object(__WEBPACK_IMPORTED_MODULE_12_memoize_one__["a" /* default */])(_this.cacheComponents, __WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__["y" /* x */]).bind(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));

    _this.cacheComponents(_props.components);

    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);

    var _selectValue = Object(__WEBPACK_IMPORTED_MODULE_15__chunk_e8ae4b0f_browser_esm_js__["f"])(value);

    var _menuOptions = _props.menuIsOpen ? _this.buildMenuOptions(_props, _selectValue) : {
      render: [],
      focusable: []
    };

    _this.state.menuOptions = _menuOptions;
    _this.state.selectValue = _selectValue;
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();

      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }

      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$props8 = this.props,
          options = _this$props8.options,
          value = _this$props8.value,
          menuIsOpen = _this$props8.menuIsOpen,
          inputValue = _this$props8.inputValue; // re-cache custom components

      this.cacheComponents(nextProps.components); // rebuild the menu options

      if (nextProps.value !== value || nextProps.options !== options || nextProps.menuIsOpen !== menuIsOpen || nextProps.inputValue !== inputValue) {
        var selectValue = Object(__WEBPACK_IMPORTED_MODULE_15__chunk_e8ae4b0f_browser_esm_js__["f"])(nextProps.value);
        var menuOptions = nextProps.menuIsOpen ? this.buildMenuOptions(nextProps, selectValue) : {
          render: [],
          focusable: []
        };
        var focusedValue = this.getNextFocusedValue(selectValue);
        var focusedOption = this.getNextFocusedOption(menuOptions.focusable);
        this.setState({
          menuOptions: menuOptions,
          selectValue: selectValue,
          focusedOption: focusedOption,
          focusedValue: focusedValue
        });
      } // some updates should toggle the state of the input visibility


      if (this.inputIsHiddenAfterUpdate != null) {
        this.setState({
          inputIsHidden: this.inputIsHiddenAfterUpdate
        });
        delete this.inputIsHiddenAfterUpdate;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props9 = this.props,
          isDisabled = _this$props9.isDisabled,
          menuIsOpen = _this$props9.menuIsOpen;
      var isFocused = this.state.isFocused;

      if ( // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      } // scroll the focused option into view if necessary


      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        Object(__WEBPACK_IMPORTED_MODULE_15__chunk_e8ae4b0f_browser_esm_js__["h"])(this.menuListRef, this.focusedOptionRef);
      }

      this.scrollToFocusedOptionOnUpdate = false;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: "onMenuOpen",
    // ==============================
    // Consumer Handlers
    // ==============================
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      var _this$props10 = this.props,
          isSearchable = _this$props10.isSearchable,
          isMulti = _this$props10.isMulti;
      this.announceAriaLiveContext({
        event: 'input',
        context: {
          isSearchable: isSearchable,
          isMulti: isMulti
        }
      });
      this.onInputChange('', {
        action: 'menu-close'
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    } // ==============================
    // Methods
    // ==============================

  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    } // aliased for consumers

  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this$state3 = this.state,
          menuOptions = _this$state3.menuOptions,
          selectValue = _this$state3.selectValue,
          isFocused = _this$state3.isFocused;
      var isMulti = this.props.isMulti;
      var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;

      if (!isMulti) {
        var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);

        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      } // only scroll if the menu isn't already open


      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.inputIsHiddenAfterUpdate = false;
      this.onMenuOpen();
      this.setState({
        focusedValue: null,
        focusedOption: menuOptions.focusable[openAtIndex]
      });
      this.announceAriaLiveContext({
        event: 'menu'
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$props11 = this.props,
          isMulti = _this$props11.isMulti,
          isSearchable = _this$props11.isSearchable;
      var _this$state4 = this.state,
          selectValue = _this$state4.selectValue,
          focusedValue = _this$state4.focusedValue; // Only multiselects support value focusing

      if (!isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);

      if (!focusedValue) {
        focusedIndex = -1;
        this.announceAriaLiveContext({
          event: 'value'
        });
      }

      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;

      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }

          break;

        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }

          break;
      }

      if (nextFocus === -1) {
        this.announceAriaLiveContext({
          event: 'input',
          context: {
            isSearchable: isSearchable,
            isMulti: isMulti
          }
        });
      }

      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var _this$state5 = this.state,
          focusedOption = _this$state5.focusedOption,
          menuOptions = _this$state5.menuOptions;
      var options = menuOptions.focusable;
      if (!options.length) return;
      var nextFocus = 0; // handles 'first'

      var focusedIndex = options.indexOf(focusedOption);

      if (!focusedOption) {
        focusedIndex = -1;
        this.announceAriaLiveContext({
          event: 'menu'
        });
      }

      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }

      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
      this.announceAriaLiveContext({
        event: 'menu',
        context: {
          isDisabled: isOptionDisabled(options[nextFocus])
        }
      });
    }
  }, {
    key: "getTheme",
    // ==============================
    // Getters
    // ==============================
    value: function getTheme() {
      // Use the default theme if there are no customizations.
      if (!this.props.theme) {
        return defaultTheme;
      } // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.


      if (typeof this.props.theme === 'function') {
        return this.props.theme(defaultTheme);
      } // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.


      return Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, defaultTheme, this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue,
          getStyles = this.getStyles,
          setValue = this.setValue,
          selectOption = this.selectOption,
          props = this.props;
      var classNamePrefix = props.classNamePrefix,
          isMulti = props.isMulti,
          isRtl = props.isRtl,
          options = props.options;
      var selectValue = this.state.selectValue;
      var hasValue = this.hasValue();

      var getValue = function getValue() {
        return selectValue;
      };

      var cx = __WEBPACK_IMPORTED_MODULE_15__chunk_e8ae4b0f_browser_esm_js__["j"].bind(null, classNamePrefix);
      return {
        cx: cx,
        clearValue: clearValue,
        getStyles: getStyles,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        setValue: setValue,
        selectProps: props,
        theme: this.getTheme()
      };
    }
  }, {
    key: "getNextFocusedValue",
    value: function getNextFocusedValue(nextSelectValue) {
      if (this.clearFocusValueOnUpdate) {
        this.clearFocusValueOnUpdate = false;
        return null;
      }

      var _this$state6 = this.state,
          focusedValue = _this$state6.focusedValue,
          lastSelectValue = _this$state6.selectValue;
      var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);

      if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);

        if (nextFocusedIndex > -1) {
          // the focused value is still in the selectValue, return it
          return focusedValue;
        } else if (lastFocusedIndex < nextSelectValue.length) {
          // the focusedValue is not present in the next selectValue array by
          // reference, so return the new value at the same index
          return nextSelectValue[lastFocusedIndex];
        }
      }

      return null;
    }
  }, {
    key: "getNextFocusedOption",
    value: function getNextFocusedOption(options) {
      var lastFocusedOption = this.state.focusedOption;
      return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.state.menuOptions.render.length;
    }
  }, {
    key: "countOptions",
    value: function countOptions() {
      return this.state.menuOptions.focusable.length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props12 = this.props,
          isClearable = _this$props12.isClearable,
          isMulti = _this$props12.isMulti; // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable

      if (isClearable === undefined) return isMulti;
      return isClearable;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled(option, selectValue) {
      return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      var _this2 = this;

      if (selectValue.indexOf(option) > -1) return true;

      if (typeof this.props.isOptionSelected === 'function') {
        return this.props.isOptionSelected(option, selectValue);
      }

      var candidate = this.getOptionValue(option);
      return selectValue.some(function (i) {
        return _this2.getOptionValue(i) === candidate;
      });
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var inputValue = this.props.inputValue;
        var selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: inputValue,
          selectValue: selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel(data) {
      return this.props.formatGroupLabel(data);
    } // ==============================
    // Mouse Handlers
    // ==============================

  }, {
    key: "startListeningComposition",
    // ==============================
    // Composition Handlers
    // ==============================
    value: function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    // ==============================
    // Touch Handlers
    // ==============================
    value: function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "buildMenuOptions",
    // ==============================
    // Menu Options
    // ==============================
    value: function buildMenuOptions(props, selectValue) {
      var _this3 = this;

      var _props$inputValue = props.inputValue,
          inputValue = _props$inputValue === void 0 ? '' : _props$inputValue,
          options = props.options;

      var toOption = function toOption(option, id) {
        var isDisabled = _this3.isOptionDisabled(option, selectValue);

        var isSelected = _this3.isOptionSelected(option, selectValue);

        var label = _this3.getOptionLabel(option);

        var value = _this3.getOptionValue(option);

        if (_this3.shouldHideSelectedOptions() && isSelected || !_this3.filterOption({
          label: label,
          value: value,
          data: option
        }, inputValue)) {
          return;
        }

        var onHover = isDisabled ? undefined : function () {
          return _this3.onOptionHover(option);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this3.selectOption(option);
        };
        var optionId = "".concat(_this3.getElementId('option'), "-").concat(id);
        return {
          innerProps: {
            id: optionId,
            onClick: onSelect,
            onMouseMove: onHover,
            onMouseOver: onHover,
            tabIndex: -1
          },
          data: option,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: 'option',
          value: value
        };
      };

      return options.reduce(function (acc, item, itemIndex) {
        if (item.options) {
          // TODO needs a tidier implementation
          if (!_this3.hasGroups) _this3.hasGroups = true;
          var items = item.options;
          var children = items.map(function (child, i) {
            var option = toOption(child, "".concat(itemIndex, "-").concat(i));
            if (option) acc.focusable.push(child);
            return option;
          }).filter(Boolean);

          if (children.length) {
            var groupId = "".concat(_this3.getElementId('group'), "-").concat(itemIndex);
            acc.render.push({
              type: 'group',
              key: groupId,
              data: item,
              options: children
            });
          }
        } else {
          var option = toOption(item, "".concat(itemIndex));

          if (option) {
            acc.render.push(option);
            acc.focusable.push(item);
          }
        }

        return acc;
      }, {
        render: [],
        focusable: []
      });
    } // ==============================
    // Renderers
    // ==============================

  }, {
    key: "constructAriaLiveMessage",
    value: function constructAriaLiveMessage() {
      var _this$state7 = this.state,
          ariaLiveContext = _this$state7.ariaLiveContext,
          selectValue = _this$state7.selectValue,
          focusedValue = _this$state7.focusedValue,
          focusedOption = _this$state7.focusedOption;
      var _this$props13 = this.props,
          options = _this$props13.options,
          menuIsOpen = _this$props13.menuIsOpen,
          inputValue = _this$props13.inputValue,
          screenReaderStatus = _this$props13.screenReaderStatus; // An aria live message representing the currently focused value in the select.

      var focusedValueMsg = focusedValue ? valueFocusAriaMessage({
        focusedValue: focusedValue,
        getOptionLabel: this.getOptionLabel,
        selectValue: selectValue
      }) : ''; // An aria live message representing the currently focused option in the select.

      var focusedOptionMsg = focusedOption && menuIsOpen ? optionFocusAriaMessage({
        focusedOption: focusedOption,
        getOptionLabel: this.getOptionLabel,
        options: options
      }) : ''; // An aria live message representing the set of focusable results and current searchterm/inputvalue.

      var resultsMsg = resultsAriaMessage({
        inputValue: inputValue,
        screenReaderMessage: screenReaderStatus({
          count: this.countOptions()
        })
      });
      return "".concat(focusedValueMsg, " ").concat(focusedOptionMsg, " ").concat(resultsMsg, " ").concat(ariaLiveContext);
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this$props14 = this.props,
          isDisabled = _this$props14.isDisabled,
          isSearchable = _this$props14.isSearchable,
          inputId = _this$props14.inputId,
          inputValue = _this$props14.inputValue,
          tabIndex = _this$props14.tabIndex;
      var Input = this.components.Input;
      var inputIsHidden = this.state.inputIsHidden;
      var id = inputId || this.getElementId('input');

      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(DummyInput, {
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: __WEBPACK_IMPORTED_MODULE_15__chunk_e8ae4b0f_browser_esm_js__["k" /* n */],
          onFocus: this.onInputFocus,
          readOnly: true,
          disabled: isDisabled,
          tabIndex: tabIndex,
          value: ""
        });
      } // aria attributes makes the JSX "noisy", separated for clarity


      var ariaAttributes = {
        'aria-autocomplete': 'list',
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby']
      };
      var _this$commonProps = this.commonProps,
          cx = _this$commonProps.cx,
          theme = _this$commonProps.theme,
          selectProps = _this$commonProps.selectProps;
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Input, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        cx: cx,
        getStyles: this.getStyles,
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        selectProps: selectProps,
        spellCheck: "false",
        tabIndex: tabIndex,
        theme: theme,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this4 = this;

      var _this$components = this.components,
          MultiValue = _this$components.MultiValue,
          MultiValueContainer = _this$components.MultiValueContainer,
          MultiValueLabel = _this$components.MultiValueLabel,
          MultiValueRemove = _this$components.MultiValueRemove,
          SingleValue = _this$components.SingleValue,
          Placeholder = _this$components.Placeholder;
      var commonProps = this.commonProps;
      var _this$props15 = this.props,
          controlShouldRenderValue = _this$props15.controlShouldRenderValue,
          isDisabled = _this$props15.isDisabled,
          isMulti = _this$props15.isMulti,
          inputValue = _this$props15.inputValue,
          placeholder = _this$props15.placeholder;
      var _this$state8 = this.state,
          selectValue = _this$state8.selectValue,
          focusedValue = _this$state8.focusedValue,
          isFocused = _this$state8.isFocused;

      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Placeholder, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
          key: "placeholder",
          isDisabled: isDisabled,
          isFocused: isFocused
        }), placeholder);
      }

      if (isMulti) {
        var selectValues = selectValue.map(function (opt) {
          var isOptionFocused = opt === focusedValue;
          return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(MultiValue, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
            components: {
              Container: MultiValueContainer,
              Label: MultiValueLabel,
              Remove: MultiValueRemove
            },
            isFocused: isOptionFocused,
            isDisabled: isDisabled,
            key: _this4.getOptionValue(opt),
            removeProps: {
              onClick: function onClick() {
                return _this4.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this4.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
                e.stopPropagation();
              }
            },
            data: opt
          }), _this4.formatOptionLabel(opt, 'value'));
        });
        return selectValues;
      }

      if (inputValue) {
        return null;
      }

      var singleValue = selectValue[0];
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(SingleValue, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        data: singleValue,
        isDisabled: isDisabled
      }), this.formatOptionLabel(singleValue, 'value'));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var ClearIndicator = this.components.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props16 = this.props,
          isDisabled = _this$props16.isDisabled,
          isLoading = _this$props16.isLoading;
      var isFocused = this.state.isFocused;

      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }

      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ClearIndicator, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var LoadingIndicator = this.components.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props17 = this.props,
          isDisabled = _this$props17.isDisabled,
          isLoading = _this$props17.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator || !isLoading) return null;
      var innerProps = {
        'aria-hidden': 'true'
      };
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(LoadingIndicator, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$components2 = this.components,
          DropdownIndicator = _this$components2.DropdownIndicator,
          IndicatorSeparator = _this$components2.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator

      if (!DropdownIndicator || !IndicatorSeparator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(IndicatorSeparator, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var DropdownIndicator = this.components.DropdownIndicator;
      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(DropdownIndicator, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this5 = this;

      var _this$components3 = this.components,
          Group = _this$components3.Group,
          GroupHeading = _this$components3.GroupHeading,
          Menu = _this$components3.Menu,
          MenuList = _this$components3.MenuList,
          MenuPortal = _this$components3.MenuPortal,
          LoadingMessage = _this$components3.LoadingMessage,
          NoOptionsMessage = _this$components3.NoOptionsMessage,
          Option = _this$components3.Option;
      var commonProps = this.commonProps;
      var _this$state9 = this.state,
          focusedOption = _this$state9.focusedOption,
          menuOptions = _this$state9.menuOptions;
      var _this$props18 = this.props,
          captureMenuScroll = _this$props18.captureMenuScroll,
          inputValue = _this$props18.inputValue,
          isLoading = _this$props18.isLoading,
          loadingMessage = _this$props18.loadingMessage,
          minMenuHeight = _this$props18.minMenuHeight,
          maxMenuHeight = _this$props18.maxMenuHeight,
          menuIsOpen = _this$props18.menuIsOpen,
          menuPlacement = _this$props18.menuPlacement,
          menuPosition = _this$props18.menuPosition,
          menuPortalTarget = _this$props18.menuPortalTarget,
          menuShouldBlockScroll = _this$props18.menuShouldBlockScroll,
          menuShouldScrollIntoView = _this$props18.menuShouldScrollIntoView,
          noOptionsMessage = _this$props18.noOptionsMessage,
          onMenuScrollToTop = _this$props18.onMenuScrollToTop,
          onMenuScrollToBottom = _this$props18.onMenuScrollToBottom;
      if (!menuIsOpen) return null; // TODO: Internal Option Type here

      var render = function render(props) {
        // for performance, the menu options in state aren't changed when the
        // focused option changes so we calculate additional props based on that
        var isFocused = focusedOption === props.data;
        props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;
        return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Option, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, props, {
          isFocused: isFocused
        }), _this5.formatOptionLabel(props.data, 'menu'));
      };

      var menuUI;

      if (this.hasOptions()) {
        menuUI = menuOptions.render.map(function (item) {
          if (item.type === 'group') {
            var type = item.type,
                group = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(item, ["type"]);

            var headingId = "".concat(item.key, "-heading");
            return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Group, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, group, {
              Heading: GroupHeading,
              headingProps: {
                id: headingId
              },
              label: _this5.formatGroupLabel(item.data)
            }), item.options.map(function (option) {
              return render(option);
            }));
          } else if (item.type === 'option') {
            return render(item);
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({
          inputValue: inputValue
        });
        if (message === null) return null;
        menuUI = __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(LoadingMessage, commonProps, message);
      } else {
        var _message = noOptionsMessage({
          inputValue: inputValue
        });

        if (_message === null) return null;
        menuUI = __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(NoOptionsMessage, commonProps, _message);
      }

      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };
      var menuElement = __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__chunk_5d200a41_browser_esm_js__["a" /* M */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, menuPlacementProps), function (_ref6) {
        var ref = _ref6.ref,
            _ref6$placerProps = _ref6.placerProps,
            placement = _ref6$placerProps.placement,
            maxHeight = _ref6$placerProps.maxHeight;
        return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Menu, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this5.onMenuMouseDown,
            onMouseMove: _this5.onMenuMouseMove
          },
          isLoading: isLoading,
          placement: placement
        }), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ScrollCaptorSwitch, {
          isEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom
        }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ScrollBlock, {
          isEnabled: menuShouldBlockScroll
        }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(MenuList, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
          innerRef: _this5.getMenuListRef,
          isLoading: isLoading,
          maxHeight: maxHeight
        }), menuUI))));
      }); // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`

      return menuPortalTarget || menuPosition === 'fixed' ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(MenuPortal, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this6 = this;

      var _this$props19 = this.props,
          delimiter = _this$props19.delimiter,
          isDisabled = _this$props19.isDisabled,
          isMulti = _this$props19.isMulti,
          name = _this$props19.name;
      var selectValue = this.state.selectValue;
      if (!name || isDisabled) return;

      if (isMulti) {
        if (delimiter) {
          var value = selectValue.map(function (opt) {
            return _this6.getOptionValue(opt);
          }).join(delimiter);
          return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("input", {
            name: name,
            type: "hidden",
            value: value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("input", {
              key: "i-".concat(i),
              name: name,
              type: "hidden",
              value: _this6.getOptionValue(opt)
            });
          }) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("input", {
            name: name,
            type: "hidden"
          });
          return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div", null, input);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';

        return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("input", {
          name: name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      if (!this.state.isFocused) return null;
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(A11yText, {
        "aria-live": "polite"
      }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("p", {
        id: "aria-selection-event"
      }, "\xA0", this.state.ariaLiveSelection), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("p", {
        id: "aria-context"
      }, "\xA0", this.constructAriaLiveMessage()));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$components4 = this.components,
          Control = _this$components4.Control,
          IndicatorsContainer = _this$components4.IndicatorsContainer,
          SelectContainer = _this$components4.SelectContainer,
          ValueContainer = _this$components4.ValueContainer;
      var _this$props20 = this.props,
          className = _this$props20.className,
          id = _this$props20.id,
          isDisabled = _this$props20.isDisabled,
          menuIsOpen = _this$props20.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(SelectContainer, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        className: className,
        innerProps: {
          id: id,
          onKeyDown: this.onKeyDown
        },
        isDisabled: isDisabled,
        isFocused: isFocused
      }), this.renderLiveRegion(), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Control, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: isDisabled,
        isFocused: isFocused,
        menuIsOpen: menuIsOpen
      }), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ValueContainer, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(IndicatorsContainer, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }]);

  return Select;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Select, "defaultProps", defaultProps);




/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_NativeAjax__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_device_detect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_purchase_countries_json__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_purchase_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_purchase_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_select__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_html_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_plp_TestTakingModalComponent__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_purchase_OrderReview__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__model_HmEventRegistry__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var paymentErrorMap={"TXN_ERR_001":"Transaction not saved","TXN_ERR_002":"Transaction failed","TXN_ERR_003":"Field does not meet the minimum length","TXN_ERR_004":"Field exceeds the maximum length","TXN_ERR_005":"Space not allowed in the field","TXN_ERR_006":"Should be Alphanumeric Only","TXN_ERR_007":"Should contain Alphanumeric and permitted characters only","TXN_ERR_008":"Should contain Alphabets Only","TXN_ERR_009":"Should contain Numbers Only","TXN_ERR_010":"Should contain Numbers and dot (.)","TXN_ERR_011":"Contains Invalid Characters","TXN_ERR_012":"Should contain Alpabets and characters only","TXN_ERR_013":"Invalid parameter","TXN_ERR_014":"Invalid Transaction amount","TXN_ERR_015":"System Error"};var MOBILE_VALID_LENGTH={"SGD":8,"INR":10};var MOBILE_VALID_LENGTH_BY_GEO={"IN":10,"SG":8,"ALL":8};var BillingDetails=function(_PreLoginPage){_inherits(BillingDetails,_PreLoginPage);function BillingDetails(props){_classCallCheck(this,BillingDetails);var _this=_possibleConstructorReturn(this,(BillingDetails.__proto__||Object.getPrototypeOf(BillingDetails)).call(this,props));_this.submitForm=function(){//[{"productId":"GDf9vCuSgsU=","productCategory":"service","price":"800.00","currency":"INR","validity":"1 year","tariffId":"73","count":1}]
var me=this;//console.log("submitform sessionId="+this.state.sessionId)
var formData={userId:me.userId,/*customerId: me.userId,*/appName:me.appName,_appId:me._appId,sessionId:this.state.sessionId,fullName:this.state.billing_name,address:this.state.billing_address,zip:this.state.billing_zipcode,city:this.state.billing_city,state:this.state.billing_state,countryCode:this.state.selectedCountryOption.value||"",country:this.state.selectedCountryOption.label||"",email:this.state.billing_email,phone:this.state.billing_phone,billingAddressLine1:this.state.billing_address,billingAddressLine2:this.state.billing_address,language:"EN",currency:this.productsJson[this.purchaseObj.productid].pricing_details[this.purchaseObj.tarrrifid].currency};var productList=[{"productId":me.purchaseObj.productid,"productCategory":me.productsJson[me.purchaseObj.productid].productCategory,"price":me.productsJson[me.purchaseObj.productid].pricing_details[me.purchaseObj.tarrrifid].productPrice,"currency":me.productsJson[me.purchaseObj.productid].pricing_details[me.purchaseObj.tarrrifid].currency,"validity":"1 year","tariffId":me.purchaseObj.tarrrifid,"count":1}];var opsCart=Object.assign({},formData,{productList:JSON.stringify(productList)});var submitFormFields=opsCart;var paymentSubmitElem=__WEBPACK_IMPORTED_MODULE_9_jquery___default()('#doPayForm');me.fillForm(paymentSubmitElem,submitFormFields);/*var callBackSuccess = function(response){
			//console.log(response);
			if(response !== null){
				if(response.formValid){
					me.setState({serverMessage:''});
					//me.doPay();
					me.showOrderReview();
				}				
				else if(response.errorMsgs != null){
			          var errmsg = "";								
			          if(response.fieldErrMap != null){
			            for(var key in response.fieldErrMap){
			              var msg = paymentErrorMap[response.fieldErrMap[key].split(":")[0]];		              
			              errmsg += key +" : " + msg;
			            }
			          }
			          me.setState({serverMessage:errmsg});
						
				  }else{
					  me.setState({serverMessage:'Sorry, we\'re unable to process your registration. Please try again later.'});
				  }
			}
	
		}
	
		var callBackFailure = function(response){		
			console.log("Error in OPS_FORM_VALIDATION");
		}
	
		var formdataHeaders = {
			"Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
			'Accept':  '*'  
		};
		new NativeAjax(this.getUrlFor("OPS_FORM_VALIDATION"),$(paymentSubmitElem).serializeArray()).enableCORS().setHeaders(formdataHeaders).preferObject("object").post(callBackSuccess,callBackFailure);
		*/__WEBPACK_IMPORTED_MODULE_9_jquery___default.a.ajax({url:this.getUrlFor("OPS_FORM_VALIDATION"),data:__WEBPACK_IMPORTED_MODULE_9_jquery___default()(paymentSubmitElem).serializeArray(),type:'POST',xhrFields:{withCredentials:true},crossDomain:true,success:function success(response){if(response!==null){if(response.formValid){me.setState({serverMessage:''});//me.doPay();
me.showOrderReview();}else if(response.errorMsgs!=null){var errmsg="";if(response.fieldErrMap!=null){for(var key in response.fieldErrMap){var msg=paymentErrorMap[response.fieldErrMap[key].split(":")[0]];errmsg+=key+" : "+msg;}}me.setState({serverMessage:errmsg});}else{me.setState({serverMessage:'Sorry, we\'re unable to process your registration. Please try again later.'});}}//console.log("response : ", response);
},error:function error(response){console.log("Error in OPS_FORM_VALIDATION");}});};_this.state={ModalShow:false,ModalContent:"",prod_price:"",taxAmount:"",basePrice:"",otherCharges:"",prod_name:"",errorMsg:"",selectedProductClassName:"",selectedProductCategoryType:""};_this.userId=null;_this.userCountryCode=null;_this.purchaseObj={};_this.userObj={};_this.productsJson={};_this.renderProductDetails=_this.renderProductDetails.bind(_this);_this.handleChange=_this.handleChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.submitForm=_this.submitForm.bind(_this);_this.countryDropdownChange=_this.countryDropdownChange.bind(_this);_this.updatePrice=_this.updatePrice.bind(_this);_this.hideReviewModal=_this.hideReviewModal.bind(_this);_this.proceedPay=_this.proceedPay.bind(_this);_this.validateMobilePattern=_this.validateMobilePattern.bind(_this);_this.countryDpList=[];_this.taxRules={};_this.productCategoryInfo={"PLP":"PLP","EXAM_PREP_CBSE":"EXAM_PREP_CBSE","SPL":"SPL","PLP-GA":"PLP","EXAM_PREP_CBSE-GA":"CBSE Exam Prep","SPL-GA":"SPL"};_this.userDataKey="USER_SESSION";_this.appName=null;_this._appId=null;//this.selectedCountryOption = this.countryDpList[0];
return _this;}_createClass(BillingDetails,[{key:'handleChange',value:function handleChange(e){var _setState;var target=e.currentTarget;this.form.validateFields(target);this.setState((_setState={},_defineProperty(_setState,target.name,target.value),_defineProperty(_setState,'submitButtonDisabled',!this.form.isValid()),_setState));}},{key:'handleSubmit',value:function handleSubmit(e){e.preventDefault();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){this.submitForm();}}},{key:'proceedPay',value:function proceedPay(){this.doPay();}},{key:'doPay',value:function doPay(){var me=this;this.trackMe();var formData={userId:me.userId,/*customerId: me.userId,*/appName:me.appName,_appId:me._appId,sessionId:this.state.sessionId,fullName:this.state.billing_name,address:this.state.billing_address,zip:this.state.billing_zipcode,city:this.state.billing_city,state:this.state.billing_state,countryCode:this.state.selectedCountryOption.value||"",country:this.state.selectedCountryOption.label||"",email:this.state.billing_email,phone:this.state.billing_phone,billingAddressLine1:this.state.billing_address,billingAddressLine2:this.state.billing_address,language:"EN",currency:this.productsJson[this.purchaseObj.productid].pricing_details[this.purchaseObj.tarrrifid].currency};var productList=[{"productId":me.purchaseObj.productid,"productCategory":me.productsJson[me.purchaseObj.productid].productCategory,"price":me.productsJson[me.purchaseObj.productid].pricing_details[me.purchaseObj.tarrrifid].productPrice,"currency":me.productsJson[me.purchaseObj.productid].pricing_details[me.purchaseObj.tarrrifid].currency,"validity":"1 year","tariffId":me.purchaseObj.tarrrifid,"count":1}];var opsCart=Object.assign({},formData,{productList:JSON.stringify(productList)});var submitFormFields=opsCart;var paymentSubmitElem=__WEBPACK_IMPORTED_MODULE_9_jquery___default()('#doPayForm');me.fillForm(paymentSubmitElem,submitFormFields);__WEBPACK_IMPORTED_MODULE_9_jquery___default()("#paySubmit").trigger("click");try{var trackGradeId=localStorage.getItem("grade")||"";this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"pay-gateway-class-"+trackGradeId});}catch(e){console.error(e);}return;//new HmAjax(this.getUrlFor("OPS_DO_PAY"),fd,headers).post(callBackSuccess,callBackFailure);
}},{key:'trackMe',value:function trackMe(){try{var trackObj={"grade_id":localStorage.getItem("grade"),"product_type":this.productsJson[this.purchaseObj.productid].productCategory,"tariff_id":this.purchaseObj.tarrrifid,"email":this.state.billing_email};this.initiateTrack("purchase_initiated",trackObj);}catch(e){}}},{key:'componentWillUnmount',value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_9_jquery___default()("#custom_fc_button").css("display","block");//console.log("componentWillUnmount")
//$("body").css({overflowY:"auto"});
}},{key:'componentWillMount',value:function componentWillMount(){try{this.userObj=JSON.parse(__WEBPACK_IMPORTED_MODULE_13__util_BrowserStorageUtil__["a" /* default */].getStoredItem(this.userDataKey));//console.log("userobj::",this.userObj);
for(var key in this.userObj){this.userId=this.userObj[key].USER_DETAILS.userId;this.userCountryCode=this.userObj[key].USER_DETAILS.countryCode;}}catch(e){}try{this.purchaseObj=JSON.parse(__WEBPACK_IMPORTED_MODULE_13__util_BrowserStorageUtil__["a" /* default */].getStoredItem(this.props.purchaseKey));if(this.purchaseObj.productid){this.setState({isProductSelected:true});this.getProductDetails();}else{this.setState({isProductSelected:false});}}catch(e){}if(this.purchaseObj===null){this.purchaseObj={};this.setState({isProductSelected:false});}//console.log("purchaseObj",purchaseObj);
}},{key:'getProductDetails',value:function getProductDetails(){var me=this;var paramObj={"productId":this.purchaseObj.productid,"tariffId":this.purchaseObj.tarrrifid};var callBackSuccess=function callBackSuccess(response){//console.log(response);
if(response!==null){me.productsJson=response;me.setState({selectedProductClassName:me.productsJson[me.purchaseObj.productid].ClassName,selectedProductCategoryType:me.productsJson[me.purchaseObj.productid].productCategory});try{me.appName=me.productsJson[me.purchaseObj.productid].appName;me._appId=me.productsJson[me.purchaseObj.productid]._appId;}catch(e){}if(me.productsJson[me.purchaseObj.productid].pricing_details[me.purchaseObj.tarrrifid].is_trial==true){//me.props.myProps.history.push("/myProducts");
me.saveAndRedirectFreeProduct();}else{me.getOPSHome();}}};var callBackFailure=function callBackFailure(response){console.log("Error in PRODUCT_DETAILS");};new __WEBPACK_IMPORTED_MODULE_6__util_NativeAjax__["a" /* default */](this.getUrlFor("PRODUCT_DETAILS"),paramObj).enableCORS().post(callBackSuccess,callBackFailure);//new HmAjax(this.getUrlFor("PRODUCT_DETAILS"),paramObj).post(callBackSuccess,callBackFailure);
}},{key:'saveAndRedirectFreeProduct',value:function saveAndRedirectFreeProduct(){var me=this;var productList=[{"productId":me.purchaseObj.productid,"tariffId":me.purchaseObj.tarrrifid}];var productPurchaseParams={};productPurchaseParams['products']=productList;var callBackSuccess=function callBackSuccess(response){//console.log("FREE_PRODUCT_SAVE success::",response);
if(response!==null&&response){//console.log("response.response::",response.response);
if(response.response.toLowerCase()!="success"){//console.log(response.response.message);
if(response.message){me.setState({opsReady:false,opsCheckDone:true,errorMsg:response.message});}else{me.setState({opsReady:false,opsCheckDone:true,errorMsg:'Sorry, we\'re unable to process your registration. Please try again later.'});}}else{try{var trackGradeId=localStorage.getItem("grade")||"";this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"freetrial-class-"+trackGradeId});}catch(e){console.error(e);}me.setState({opsReady:false,opsCheckDone:true,errorMsg:''});//me.props.myProps.history.push("/myproducts");
window.top.location.href="/myproducts";}}else{console.log("FREE_PRODUCT_SAVE failure::",response);me.setState({opsReady:false,opsCheckDone:true,errorMsg:''});//me.props.myProps.history.push("/products");
window.top.location.href="/myproducts";}};var callBackFailure=function callBackFailure(response){console.log("Error in FREE_PRODUCT_SAVE",response);me.props.myProps.history.push('/products');};//new HmAjax(this.getUrlFor("FREE_PRODUCT_SAVE"),productList).post(callBackSuccess,callBackFailure);
new __WEBPACK_IMPORTED_MODULE_6__util_NativeAjax__["a" /* default */](this.getUrlFor("FREE_PRODUCT_SAVE"),productPurchaseParams).enableCORS().post(callBackSuccess,callBackFailure);}},{key:'getOPSHome',value:function getOPSHome(){var me=this;//console.log(me.productsJson,me.purchaseObj.tarrrifid,me.purchaseObj.productid);
//console.log(me.productsJson[me.purchaseObj.productid]);
var formData={userId:me.userId,/*customerId: me.userId,*/appName:me.appName,_appId:me._appId,sFrame:me.getUrlFor("PAYMENT_SUCCESS_URL"),fFrame:me.getUrlFor("PAYMENT_FAILURE_URL"),pcsUrl:me.getUrlFor("PAYMENT_PCS_URL"),pcfUrl:me.getUrlFor("PAYMENT_PCF_URL"),currency:me.productsJson[me.purchaseObj.productid].pricing_details[me.purchaseObj.tarrrifid].currency};var productList=[{"productId":me.purchaseObj.productid,"productCategory":me.productsJson[me.purchaseObj.productid].productCategory,"price":me.productsJson[me.purchaseObj.productid].pricing_details[me.purchaseObj.tarrrifid].productPrice,"currency":me.productsJson[me.purchaseObj.productid].pricing_details[me.purchaseObj.tarrrifid].currency,"validity":"1 year","tariffId":me.purchaseObj.tarrrifid,"count":1}];var opsCart=Object.assign({},formData,{productList:JSON.stringify(productList)});var me=this;var paramObj={"productId":this.purchaseObj.productid,"tariffId":this.purchaseObj.tarrrifid/*var callBackSuccess = function(response){
			//console.log(response);
			if(response !== null){
				me.setState({sessionId:response.sessionId});
	    				
		          if (response.currency) {    		           
		            
		        	  if(response.allTaxRules && response.allTaxRules.length > 0){
    		            	for(var i=0; i<response.allTaxRules.length; i++){
    		            		var tempObj = {};
    		            		if(me.taxRules[response.allTaxRules[i].geo]){
    		            			tempObj = me.taxRules[response.allTaxRules[i].geo];
    		            		}
    		            		tempObj[response.allTaxRules[i].currency] = response.allTaxRules[i];
    		            		
    		            		me.taxRules[response.allTaxRules[i].geo] = tempObj;
    		            	}
    		            }
    		        	 
		        	  
		        	  
		        	  me.setState({sessionId:response.sessionId,opsReady:true,opsCheckDone:true});
		            
		        	  me.updatePrice();
		          } else {
		        	me.setState({opsReady:false,opsCheckDone:true,errorMsg:'Sorry, we\'re unable to process your registration. Please try again later.'});    		           
		           
		          }
			}
	
		}
	
		var callBackFailure = function(response){		
			console.log("Error in OPS_PROCESSPAY");
	    	me.setState({opsReady:false,opsCheckDone:true,errorMsg:'Sorry, we\'re unable to process your registration. Please try again later.'});
		}
	
		var formdataHeaders = {
			"Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
			'Accept':  '*'  
		};
		
		new NativeAjax(this.getUrlFor("OPS_PROCESSPAY"),opsCart).enableCORS().setHeaders(formdataHeaders).preferObject("object").post(callBackSuccess,callBackFailure);
		*/};__WEBPACK_IMPORTED_MODULE_9_jquery___default.a.ajax({url:this.getUrlFor("OPS_PROCESSPAY"),data:opsCart,type:'POST',xhrFields:{withCredentials:true},crossDomain:true,success:function success(response){if(response!=null){//alert("sessionid="+response.sessionId)
me.setState({sessionId:response.sessionId});if(response.currency){if(response.allTaxRules&&response.allTaxRules.length>0){for(var i=0;i<response.allTaxRules.length;i++){var tempObj={};if(me.taxRules[response.allTaxRules[i].geo]){tempObj=me.taxRules[response.allTaxRules[i].geo];}tempObj[response.allTaxRules[i].currency]=response.allTaxRules[i];me.taxRules[response.allTaxRules[i].geo]=tempObj;}}me.setState({sessionId:response.sessionId,opsReady:true,opsCheckDone:true});me.updatePrice();}else{me.setState({opsReady:false,opsCheckDone:true,errorMsg:'Sorry, we\'re unable to process your registration. Please try again later.'});}}//console.log("response : ", response);
},error:function error(response){console.log("Error in OPS_PROCESSPAY");me.setState({opsReady:false,opsCheckDone:true,errorMsg:'Sorry, we\'re unable to process your registration. Please try again later.'});}});//new HmAjax(this.getUrlFor("OPS_PROCESSPAY"),opsCart,headers).post(callBackSuccess,callBackFailure);
}},{key:'componentDidMount',value:function componentDidMount(){this.sessionCheck();this.populateCountryDropdown();__WEBPACK_IMPORTED_MODULE_16__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");__WEBPACK_IMPORTED_MODULE_9_jquery___default()("#custom_fc_button").css("display","none");}},{key:'getTaxedAmount',value:function getTaxedAmount(amount,country,currency){//console.log(amount, country, currency);
var me=this;amount=parseInt(amount);var taxAmount=0;var basePrice=0;var otherCharges=0;var amountDetails={taxAmount:0,basePrice:0,otherCharges:0,amount:amount};try{if(!isNaN(amount)&&amount>0&&currency&&(me.taxRules[country]&&me.taxRules[country][currency]||me.taxRules["ALL"]&&me.taxRules["ALL"][currency])){var tRule=(me.taxRules&&me.taxRules[country]&&me.taxRules[country][currency]?me.taxRules[country][currency]:null)||(me.taxRules&&me.taxRules["ALL"]&&me.taxRules["ALL"][currency]?me.taxRules["ALL"][currency]:null);otherCharges=tRule.flat;if(!tRule){return amount;}if(tRule.inclusive){if(tRule.type===2){basePrice=Math.round((amount-otherCharges)*100/(100+tRule.percentage)*100)/100;taxAmount=Math.round((amount-basePrice)*100)/100;}else{basePrice=Math.round(amount*100/(100+tRule.percentage)*100)/100-otherCharges;taxAmount=Math.round((amount-basePrice)*100)/100;}}else{//Exclusive tax - amount without tax is the basePrice
basePrice=amount;if(tRule.type===1){taxAmount=Math.round(amount*tRule.percentage/100)+otherCharges;amount=amount+taxAmount;}else if(tRule.type===2){taxAmount=Math.round((amount+otherCharges)*tRule.percentage/100);amount=amount+taxAmount;}else{taxAmount=Math.round(amount*tRule.percentage/100);amount=amount+taxAmount;}}amountDetails["taxAmount"]=taxAmount;amountDetails["basePrice"]=basePrice;amountDetails["otherCharges"]=otherCharges;amountDetails["amount"]=amount;me.setTaxMessage('Price inclusive of Taxes','Price updated to include Taxes',amount);}else{me.setTaxMessage('Price includes 0% Taxes',null,amount);}}catch(e){}return amountDetails;}},{key:'setTaxMessage',value:function setTaxMessage(msg1,msg2,amount){var taxMessage1Elem=__WEBPACK_IMPORTED_MODULE_9_jquery___default()('#tax-message-1');var taxMessage2Elem=__WEBPACK_IMPORTED_MODULE_9_jquery___default()('#tax-message-2');this.setState({taxMsg1:""});this.setState({taxMsg2:""});if(typeof msg1==='string'&&msg1.length>0){this.setState({taxMsg1:msg1});}if(typeof msg2==='string'&&msg2.length>0){this.setState({taxMsg2:msg2});}}},{key:'fillForm',value:function fillForm(formElem,formData,reset){var i;for(i in formData){__WEBPACK_IMPORTED_MODULE_9_jquery___default()(formElem).find('[name="'+i+'"]').val(reset?'':formData[i]);}}},{key:'populateCountryDropdown',value:function populateCountryDropdown(){var defaultIndex=0;for(var i=0;i<__WEBPACK_IMPORTED_MODULE_10__views_purchase_countries_json___default.a.countryList.length;i++){this.countryDpList.push({"label":__WEBPACK_IMPORTED_MODULE_10__views_purchase_countries_json___default.a.countryList[i].countryName,"value":__WEBPACK_IMPORTED_MODULE_10__views_purchase_countries_json___default.a.countryList[i].countryID});if(this.userCountryCode){if(__WEBPACK_IMPORTED_MODULE_10__views_purchase_countries_json___default.a.countryList[i].countryID==this.userCountryCode){defaultIndex=i;}}else if(__WEBPACK_IMPORTED_MODULE_10__views_purchase_countries_json___default.a.countryList[i].countryName.toLowerCase()=="india"){defaultIndex=i;}}//this.selectedCountryOption = this.countryDpList[0];
this.setState({selectedCountryOption:this.countryDpList[defaultIndex]});// console.log("country::",this.state.selectedCountryOption);
}},{key:'countryDropdownChange',value:function countryDropdownChange(selectedOption){//this.selectedCountryOption = selectedOption;
var me=this;this.setState({selectedCountryOption:selectedOption});setTimeout(function(){me.updatePrice();},200);}},{key:'updatePrice',value:function updatePrice(){__WEBPACK_IMPORTED_MODULE_16__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");if(this.state.selectedCountryOption===null){return false;}//console.log("updateprice::",this.state.selectedCountryOption);
var validity=this.productsJson[this.purchaseObj.productid].pricing_details[this.purchaseObj.tarrrifid].validity=="365"?"1 Year":this.productsJson[this.purchaseObj.productid].pricing_details[this.purchaseObj.tarrrifid].validity;var price=this.productsJson[this.purchaseObj.productid].pricing_details[this.purchaseObj.tarrrifid].productPrice;var currency=this.productsJson[this.purchaseObj.productid].pricing_details[this.purchaseObj.tarrrifid].currency;var amountDetails=this.getTaxedAmount(price,this.state.selectedCountryOption.value,currency);var taxAmount=amountDetails.taxAmount;var totalAmount=amountDetails.amount;var otherCharges=amountDetails.otherCharges;var basePrice=amountDetails.basePrice;var productName=this.productsJson[this.purchaseObj.productid].productName;//console.log("amountDetails:::",amountDetails);
this.setState({prod_validity:validity,prod_price:totalAmount,taxAmount:taxAmount,prod_name:productName,basePrice:basePrice,otherCharges:otherCharges});}},{key:'hideReviewModal',value:function hideReviewModal(){this.setState({"ModalShow":false});}},{key:'validateMobilePattern',value:function validateMobilePattern(){var selectedCurr=this.purchaseObj&&this.purchaseObj.currency?this.purchaseObj.currency:"INR";var mobileLen=10;var geo=this.getGeo();if(geo&&(!isNaN(MOBILE_VALID_LENGTH_BY_GEO[geo.toUpperCase()])||!isNaN(MOBILE_VALID_LENGTH_BY_GEO["ALL"]))){mobileLen=MOBILE_VALID_LENGTH_BY_GEO[geo.toUpperCase()]||MOBILE_VALID_LENGTH_BY_GEO["ALL"];}else if(selectedCurr&&!isNaN(MOBILE_VALID_LENGTH[selectedCurr])){mobileLen=MOBILE_VALID_LENGTH[selectedCurr];}return".{"+mobileLen+",}";}},{key:'renderBillingInformation',value:function renderBillingInformation(){var _this2=this;__WEBPACK_IMPORTED_MODULE_16__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");if(this.state.isProductSelected){if(this.state.opsCheckDone==false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' ',this.showLoader());}if(this.state.opsReady==false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center mg-5p'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.state.errorMsg)));}console.log("product:::",this.productsJson);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container row Billing josefin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 order-2 col-sm-12 order-sm-2 col-md-12 order-md-2 col-lg-6 order-lg-1 nopadding pr-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-center  mt-20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'heading'},this.rb("billing.information"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this2.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'billing_name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'text',className:'billing_name',name:'billing_name',placeholder:this.rb("billing.fullname"),value:this.state.billing_name,onChange:this.handleChange,required:true,minLength:1,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'billing_name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.namerequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'billing_email'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'text',className:'billing_email',name:'billing_email',placeholder:this.rb("profile.email_id"),value:this.state.billing_email,onChange:this.handleChange,required:true,pattern:'^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$',minLength:1,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'billing_email'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("fpwd.emailrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},this.rb("fpwd.validemail")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'billing_phone'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'billing_phone',className:'billing_phone',name:'billing_phone',placeholder:this.rb("register.phone"),innerRef:function innerRef(phone){return _this2.phone=phone;},value:this.state.billing_phone,onChange:this.handleChange,pattern:this.validateMobilePattern(),autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'billing_phone'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("register.mobilerequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},this.rb("register.mobilenolength")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length>0&&!/\d/.test(value);}},this.rb("register.numbersonly")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'billing_address'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'text',className:'billing_address',name:'billing_address',placeholder:this.rb("billing.address"),value:this.state.billing_address,onChange:this.handleChange,required:true,minLength:1,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'billing_address'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.addressrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'billing_zipcode'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'text',className:'billing_zipcode',name:'billing_zipcode',placeholder:this.rb("billing.zipcode"),value:this.state.billing_zipcode,onChange:this.handleChange,required:true,minLength:1,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'billing_zipcode'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.zipcoderequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'billing_city'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'text',className:'billing_city',name:'billing_city',placeholder:this.rb("billing.city"),value:this.state.billing_city,onChange:this.handleChange,required:true,minLength:1,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'billing_city'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.cityrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'billing_state'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'text',className:'billing_state',name:'billing_state',placeholder:this.rb("billing.state"),value:this.state.billing_state,onChange:this.handleChange,required:true,minLength:1,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'6'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'billing_state'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.staterequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{value:this.state.selectedCountryOption,onChange:this.countryDropdownChange,options:this.countryDpList,onBlurResetsInput:false,onSelectResetsInput:false,autoFocus:true,clearable:false,rtl:false,searchable:false,required:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{id:'tax-message-2'},this.state.taxMsg2),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages'},this.state.serverMessage),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:this.state.submitButtonDisabled,className:'submitButton','data-ga':this.productCategoryInfo[this.state.selectedProductCategoryType+"-GA"]+" - "+this.state.selectedProductClassName+" - "+"Purchase"},this.rb("billing.purchase"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 order-1 col-sm-12 order-sm-1 col-md-12 order-md-1 col-lg-6 order-lg-2 mb-50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-center  mt-20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'heading'},this.rb("product.ordersummary"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productBoxContainer'},this.renderProductDetails())));}}},{key:'renderProductDetails',value:function renderProductDetails(){var _this3=this;//console.log("this.productsJson::",this.productsJson);
if(this.productsJson&&Object.keys(this.productsJson).length>0){return Object.keys(this.productsJson).map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productbox clearfix',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left productimg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'g-img'},function(){if(window.prodImgNotAvail&&_this3.productsJson[item]&&_this3.productsJson[item].productCategory&&window.prodImgNotAvail.includes(_this3.productsJson[item].productCategory)){// Don't show image
}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/"+JSON.parse(_this3.productsJson[item].productDetails)[0].thumbnail,alt:''});}}())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left productcontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'g-text mb-0'},_this3.productsJson[item].ClassName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'g-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,_this3.rb(_this3.productsJson[item].productCategory))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greycolor'},_this3.rb("product.validity"),' : \xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this3.state.prod_validity))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this3.rb("product.price"),' : \xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'priceAmt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,_this3.state.prod_price))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'tax-message-1'},_this3.state.taxMsg1)));});}}},{key:'isProductSelected',value:function isProductSelected(){if(this.state.isProductSelected==false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lineheight-40 josefin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_12_react_html_parser___default()(this.rb("register.noproducts.msg"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center josefin'},__WEBPACK_IMPORTED_MODULE_12_react_html_parser___default()(this.rb("register.noproducts.msg2"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center josefin'},__WEBPACK_IMPORTED_MODULE_12_react_html_parser___default()(this.rb("register.noproducts.msg3"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center josefin'},'OR'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'r-btn lineheight-20',href:'/products'},this.rb("product.browseproducts"))));}}},{key:'showOrderReview',value:function showOrderReview(){this.setState({ModalShow:true,"ModalContent":this.getOrderReview()});}},{key:'getOrderReview',value:function getOrderReview(){var reviewData={fullName:this.state.billing_name,address:this.state.billing_address,zip:this.state.billing_zipcode,city:this.state.billing_city,state:this.state.billing_state,country:this.state.selectedCountryOption.label||"",phone:this.state.billing_phone,email:this.state.billing_email,billingAddressLine1:this.state.billing_address,billingAddressLine2:this.state.billing_address,currency:this.productsJson[this.purchaseObj.productid].pricing_details[this.purchaseObj.tarrrifid].currency,validity:this.productsJson[this.purchaseObj.productid].pricing_details[this.purchaseObj.tarrrifid].validity=="365"?"1 Year":this.productsJson[this.purchaseObj.productid].pricing_details[this.purchaseObj.tarrrifid].validity,productName:this.productsJson[this.purchaseObj.productid].productName,price:this.productsJson[this.purchaseObj.productid].pricing_details[this.purchaseObj.tarrrifid].productPrice,taxAmount:this.state.taxAmount,totalAmount:this.state.prod_price,basePrice:this.state.basePrice,otherCharges:this.state.otherCharges,selectedProductCategoryType:this.productCategoryInfo[this.state.selectedProductCategoryType],selectedProductCategoryTypeGA:this.productCategoryInfo[this.state.selectedProductCategoryType+"-GA"],selectedProductClassName:this.state.selectedProductClassName};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__views_purchase_OrderReview__["a" /* default */],{hideReviewModal:this.hideReviewModal,reviewData:reviewData,proceedPay:this.proceedPay});}},{key:'render',value:function render(){__WEBPACK_IMPORTED_MODULE_16__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'bg-grn productsbggrn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.rb("product.yoursubsciptions")))),this.isProductSelected(),this.renderBillingInformation(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'doPayForm',className:'hidden',method:'post',target:'_top',action:this.getUrlFor("OPS_DO_PAY")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'userId',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'appName',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'_appId',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'sessionId',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'fullName',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'address',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'zip',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'city',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'state',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'countryCode',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'country',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'email',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'phone',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'language',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'productList',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'currency',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',value:'submit',id:'paySubmit'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__views_plp_TestTakingModalComponent__["a" /* default */],{visible:this.state.ModalShow,dialogClassName:'modal-lg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loginHeader text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center modallogo loginHeaderTxt'},'Review order details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':this.productCategoryInfo[this.state.selectedProductCategoryType+"-GA"]+" - "+this.state.selectedProductClassName+" - "+"Review order details - close",className:'close loginClose',onClick:this.hideReviewModal,'aria-label':'Close'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'close')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-body'},this.state.ModalContent))));}}]);return BillingDetails;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (BillingDetails);

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_purchase_countries_json__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_purchase_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_purchase_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_select__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__prelogin_public_css_react_select_css__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__prelogin_public_css_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__prelogin_public_css_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_html_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_plp_TestTakingModalComponent__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_purchase_OrderReview__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_moment__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment_timezone__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_icons_free_png__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_icons_free_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__images_icons_free_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_icons_free_disabled_png__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_icons_free_disabled_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__images_icons_free_disabled_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__StudentDropdown__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__core_LoggedInPage__ = __webpack_require__(18);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var paymentErrorMap={"TXN_ERR_001":"Transaction not saved","TXN_ERR_002":"Transaction failed","TXN_ERR_003":"Field does not meet the minimum length","TXN_ERR_004":"Field exceeds the maximum length","TXN_ERR_005":"Space not allowed in the field","TXN_ERR_006":"Should be Alphanumeric Only","TXN_ERR_007":"Should contain Alphanumeric and permitted characters only","TXN_ERR_008":"Should contain Alphabets Only","TXN_ERR_009":"Should contain Numbers Only","TXN_ERR_010":"Should contain Numbers and dot (.)","TXN_ERR_011":"Contains Invalid Characters","TXN_ERR_012":"Should contain Alpabets and characters only","TXN_ERR_013":"Invalid parameter","TXN_ERR_014":"Invalid Transaction amount","TXN_ERR_015":"System Error"};/***
* Substitute locales instead of directly getting from RBUtil
**/var PROD_LOCALE_GRP={"IN_PLP":{"class1":"SPL","class2":"SPL","class3":"SPL","class4":"SPL"}};var branchLocale=function branchLocale(categoryTxt,className){try{if(categoryTxt&&className&&PROD_LOCALE_GRP[categoryTxt]){return PROD_LOCALE_GRP[categoryTxt][className.replace(/ /g,"").toLowerCase()]?PROD_LOCALE_GRP[categoryTxt][className.replace(/ /g,"").toLowerCase()]:categoryTxt;}}catch(e){console.error(e);}return categoryTxt;};var MyProducts=function(_LoggedInPage){_inherits(MyProducts,_LoggedInPage);function MyProducts(props){_classCallCheck(this,MyProducts);var _this=_possibleConstructorReturn(this,(MyProducts.__proto__||Object.getPrototypeOf(MyProducts)).call(this,props));_this.state={PLPloggedIn:false,prodLoaded:false,myProducts:{},firstchild:false,newStudentForm:false,newStudentSuccess:false,selectedStudentOption:{},selectedGradeOption:{},selectedProduct:null,selectedProductIndex:null,student_name:"",student_grade:"",student_board:null,student_username:"",student_password:"",student_confirmpassword:"",serverMessage:"",studentDpList:[],ModalShow:false,ModalContent:"",userRole:""};_this.userId=null;_this.purchaseObj={};_this.userObj={};_this.productsJson={};_this.userDataKey="USER_SESSION";_this.getProducts=_this.getProducts.bind(_this);//this.studentDropdownChange = this.studentDropdownChange.bind(this);
//this.gradeDropdownChange = this.gradeDropdownChange.bind(this);
//this.getNewStudentForm = this.getNewStudentForm.bind(this);
//this.handleNewStudentSubmit = this.handleNewStudentSubmit.bind(this);
//this.handleChange = this.handleChange.bind(this);
//this.submitCreateStudent = this.submitCreateStudent.bind(this);
//this.boardChange = this.boardChange.bind(this);
//this.checkStudentAssigned = this.checkStudentAssigned.bind(this);
//this.productClick = this.productClick.bind(this);
//this.assignProduct = this.assignProduct.bind(this);
//this.getGradeList = this.getGradeList.bind(this);
//this.populateGradeDropdown = this.populateGradeDropdown.bind(this);		
//this.removePasswords = this.removePasswords.bind(this);
//this.hideStudentSuccessmsg = this.hideStudentSuccessmsg.bind(this);
_this.hideReviewModal=_this.hideReviewModal.bind(_this);_this.getproductBox=_this.getproductBox.bind(_this);_this.goToLanding=_this.goToLanding.bind(_this);_this.isFreeProduct=_this.isFreeProduct.bind(_this);//this.studentDpList = [];
_this.gradeDpList=[];_this.loginStoreKey="PLP_LOGIN_INFO";_this.homeDropDownKey="homeDropdown";_this.gradeStore=null;return _this;}_createClass(MyProducts,[{key:'componentWillMount',value:function componentWillMount(){var me=this;var user_Success=function user_Success(userObj){if((typeof userObj==='undefined'?'undefined':_typeof(userObj))==="object"&&userObj.authToken){console.log("user::",userObj.userRole.role);me.setState({PLPloggedIn:true,userRole:userObj.userRole.role});me.userObj=userObj;me.getProducts();}else{me.setState({PLPloggedIn:false});__WEBPACK_IMPORTED_MODULE_15__model_HmEventRegistry__["a" /* default */].fireEvent("LOG_OUT_PROMPT");}};var user_Failure=function user_Failure(error){console.log("session failure...",error);me.setState({PLPloggedIn:false});if((typeof error==='undefined'?'undefined':_typeof(error))==="object"&&Object.keys(error).length>0){if(typeof error.sessionValid!=="undefined"&&error.sessionValid==="false"){__WEBPACK_IMPORTED_MODULE_15__model_HmEventRegistry__["a" /* default */].fireEvent("LOG_OUT_PROMPT");}}};this.sessionCheck(user_Success,user_Failure,true);try{__WEBPACK_IMPORTED_MODULE_12__util_BrowserStorageUtil__["a" /* default */].removeItem(me.props.purchaseKey);}catch(e){if(console)console.error(e);}}},{key:'componentDidMount',value:function componentDidMount(){}//this.getGradeList();	
//this.loginTracking();		
/*loginTracking(){
		try{
			var loginInfo = BrowserStorageUtil.getStoredSessionItem(this.loginStoreKey);
			//console.log("loginInfo:::",loginInfo);
			if(loginInfo){
				this.initiateTrack("login",JSON.parse(loginInfo));
				BrowserStorageUtil.removeSessionItem(this.loginStoreKey);
			}
		}catch(e){}
	}*//*getGradeList(){
		var me = this;
		var callBackSuccess = function(response){
			if(response !== null){
				me.populateGradeDropdown(response);
			}

			console.log(" GET_GRADE_LIST response : ", response);
		}

		var callBackFailure = function(response){
			console.log("Error in GET_GRADE_LIST");			
		}

		new HmAjax(this.getUrlFor("GET_GRADE_LIST")).get(callBackSuccess,callBackFailure);
	}*//*populateGradeDropdown(data) {     	
		if(Object.keys(data).length>0){
			var classArr = data["IN"]
			for (var i = 0; i <= classArr.length; i++) {          
	          this.gradeDpList.push({"label":classArr[i],"value":classArr[i]});         
	        }
		}
       
        this.setState({selectedGradeOption:this.gradeDpList[0]});
    }*//*gradeDropdownChange(selectedOption){
		var me = this;
    	this.setState({selectedGradeOption:selectedOption});    	 
	}*/},{key:'populateStudentDropdown',value:function populateStudentDropdown(myProducts){//console.log("data=",this.state.myProducts);
this.state.studentDpList=[];if(myProducts.related_children&&Object.keys(myProducts.related_children).length>0){this.state.studentDpList.push({"label":this.rb("product.selectedstudent"),"value":"select-student"});for(var key in myProducts.related_children){var username=myProducts.related_children[key].userName||myProducts.related_children[key].loginId;this.state.studentDpList.push({"label":username,"value":key});}this.state.studentDpList.push({"label":this.rb("product.createstudent"),"value":"new-student"});}this.setState({selectedStudentOption:this.state.studentDpList[0]});}/*studentDropdownChange(selectedOption,index){
		var me = this;
		
		if(selectedOption.value == "select-student"){
			this.setState({selectedStudentOption:selectedOption});    	 
			return;
		}
		if(selectedOption.value == "new-student"){
			this.setState({student_name:"",student_grade:"",student_username:"",student_password:"",student_confirmpassword:"",serverMessage:""});
				
			this.setState({"ModalShow":true});
			setTimeout(function(){
				var board_cbse = document.getElementById('board_cbse');
				board_cbse.click();
			},200);
			return;
		}
    	this.setState({selectedStudentOption:selectedOption});    	 
    	
    	var msg = ("<div class='josefin'>Subscription to "+this.state.myProducts.product_details[this.state.selectedProduct.productId].ClassName+" "+this.state.myProducts.product_details[this.state.selectedProduct.productId].productDescription+" is for <span class='bluecolor'>"+selectedOption.label+"</span>. <br/ >The above subscription is only for the named student and cannot be changed later.</div>");
    	
    	 var buttons = [{
                label: me.rb("alert.ok"),
                handler: () => { me.assignProduct() }
            },
            {
                label: me.rb("alert.cancel"),
                handler: () => { }
            }]

        me.showAlert(" ", msg, buttons);
    	
	}*/},{key:'getProducts',value:function getProducts(){//try {
var me=this;var successHandler=function successHandler(data){console.log("data :: ",data);//me.productData = data;
//me.processData();
me.populateStudentDropdown(data);me.setState({myProducts:data,prodLoaded:true});if(Object.keys(data).length>0){if(Object.keys(data.related_children).length==1){var keys=Object.keys(data.related_children);if(data.related_children[keys[0]].password&&data.related_children[keys[0]].password!=null&&data.related_children[keys[0]].password!=""){me.setState({firstchild:true});}}//me.removePasswords();
}};var failureHandler=function failureHandler(err){var buttons=[{label:me.rb("go_home"),handler:function handler(){window.location.href=me.getUrlFor("LOGIN_HOME");}}];me.showAlert(me.rb("error"),me.rb("generic_connect_error"),buttons);return;};var userId=me.userObj.userId;new __WEBPACK_IMPORTED_MODULE_5__util_HmAjax__["a" /* default */](this.getUrlFor("GET_PURCHASED_PRODUCTS")).get(successHandler,failureHandler);/*} catch (e) {
				var buttons = [{
					label: me.rb("go_home"),
					handler: () => {window.location.href = me.getUrlFor("LOGIN_HOME");}
				}]
				me.showAlert(me.rb("error"), me.rb("system_error"), buttons);
			}*/}/*removePasswords(){
		   $.ajax({
            url: this.getUrlFor("REMOVE_PWD"),
            type: 'GET',
            xhrFields: {
		       withCredentials: true
		    },
		    crossDomain: true,
            success: function(response){
    			if(response !== null){
    				
    			}

    			console.log("response : ", response);
    		},
            error: function(response){
    			console.log("Error in REMOVE_PWD");
    		}
          });	   
	  }
	   *//*getNewStudentForm(){
		this.setState({newStudentForm:true,newStudentSuccess:false});
		
		setTimeout(function(){
			var board_cbse = document.getElementById('board_cbse');
			board_cbse.click();
		},200);
		
	}*//*productClick(event){		
		this.setState({selectedProduct:this.state.myProducts.purchased_products_details[event.currentTarget.dataset.productindex], selectedProductIndex:event.currentTarget.dataset.productindex});
	}*//*assignProduct(){
		if(this.state.selectedProduct == null){
				this.showAlert("","Please select a product.");
		}else{
			var me =this;			
			
			var formData = {
				  "productId":this.state.selectedProduct.productId,
				  "childId":this.state.selectedStudentOption.value,
				  "subscription_date":this.state.selectedProduct.subscriptionDate
			}
	
			
			var callBackSuccess = function(response){
				if(response !== null){
					console.log(response);
					console.log(response.response);
					console.log(response.response.toLowerCase());
					if(response.response.toLowerCase() == "success"){
						//me.state.myProducts.child_product_assign_details[me.state.selectedProduct.productId] = me.state.selectedStudentOption.value;
						me.state.myProducts.purchased_products_details[me.state.selectedProductIndex].childId = me.state.selectedStudentOption.value;
						me.setState(me.state);
						setTimeout(function(){
							me.setState({selectedProduct:null});
						},200);
						//me.showAlert("","Product Assigned Successfully.");
					}
				}
	
				console.log(" ASSIGN_PRODUCT response : ", response);
			}
	
			var callBackFailure = function(response){
				console.log("Error in ASSIGN_PRODUCT");			
			}
	
			new HmAjax(this.getUrlFor("ASSIGN_PRODUCT"),formData).post(callBackSuccess,callBackFailure);
		}
	}*//*checkStudentAssigned(item){
		if(this.state.myProducts.purchased_products_details[item].childId){	
			return "assigned";
		}
		return "";
	}*/},{key:'checkExpired',value:function checkExpired(item){if(this.state.myProducts.purchased_products_details[item].expired){return"expired";}return"";}},{key:'isFreeProduct',value:function isFreeProduct(prodid,tarrifid){try{return this.state.myProducts.product_details[prodid].pricing_details[tarrifid].is_trial||this.state.myProducts.product_details[prodid].pricing_details[tarrifid].is_free_product;}catch(e){}return false;}},{key:'isPaidAvailable',value:function isPaidAvailable(prodid,paidTariffId){try{return this.state.myProducts.product_details[prodid].IS_PROD_AVAILABLE;}catch(e){}return false;}/*hideStudentSuccessmsg(){
		this.setState({newStudentForm:false,newStudentSuccess:false});
	}*/},{key:'renderTitleMsg',value:function renderTitleMsg(){try{if(this.state.userRole=="PRNT"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productAssignMsg col-8 offset-2 josefin row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 alertleftdiv nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons alerticon'},'report_problem')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'The products you have purchased/done a free trial are now viewable in the respective student accounts.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'You can now view all your new purchases here in this account.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));}if(this.state.prodLoaded==true&&this.state.firstchild==false){if(Object.keys(this.state.myProducts).length>0){if(this.state.myProducts.product_details&&Object.keys(this.state.myProducts.product_details).length>0){var userName="";for(var i=0;i<this.state.myProducts.purchased_products_details.length;i++){if(this.state.myProducts.related_children[this.state.myProducts.child_product_assign_details[this.state.myProducts.purchased_products_details[i].productId]]){userName=this.state.myProducts.related_children[this.state.myProducts.child_product_assign_details[this.state.myProducts.purchased_products_details[i].productId]].userName;break;}}//var userName =  this.state.myProducts.related_children[this.state.myProducts.child_product_assign_details[this.state.myProducts.product_order[0]]].userName;
/*return(
							<div className="productAssignMsg col-8 offset-2 josefin">
								Please assign newly purchased products to <b>{userName}</b> to use it. <br/>Click <span className="redfont">Assign To</span> and select <b>{userName}</b> to start using it.
							</div>
							);*/}}}}catch(e){console.error(e);}}},{key:'goToLanding',value:function goToLanding(event){try{this.gradeStore={"grd":event.currentTarget.dataset.classid,"prod":event.currentTarget.dataset.accessid};var goLanding=function goLanding(){//alert("goLanding");
window.top.location.href="/landing";};//console.log("classId ::  abdul",this.gradeStore)
this.setAttribute(this.homeDropDownKey,JSON.stringify(this.gradeStore),goLanding);}catch(e){}}},{key:'pricetagFn',value:function pricetagFn(props){// var productType=props || "PLP";
// return this.rb("banner."+productType);
}},{key:'classforcont',value:function classforcont(){if(this.isMobile()&&!this.isTab()){return'pInfo productcontent prodcontmob text-left';}else{return'pInfo float-left productcontent text-left';}}},{key:'getproductBox',value:function getproductBox(item,index){var _this2=this;var prodid=this.state.myProducts.purchased_products_details[item].productId;var tarrifid=this.state.myProducts.purchased_products_details[item].tariffId;//IMPORTANT: This is a very bad fix. Have to change it later
var upgradeBtnAdded=false;if(this.state.myProducts.product_details[prodid].pricing_details[tarrifid].is_trial){for(var tarrif in this.state.myProducts.product_details[prodid].pricing_details){}}//console.log("tarrifid=="+tarrifid);
if(this.state.myProducts.product_details[this.state.myProducts.purchased_products_details[item].productId]){var prodCategory=this.state.myProducts.product_details[this.state.myProducts.purchased_products_details[item].productId].productCategory||"";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"productboxBig productbox clearfix "+this.checkExpired(item),id:"product-"+item,key:index,'data-productindex':index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prodCont'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productimg'},function(){if(prodCategory&&window.prodImgNotAvail&&window.prodImgNotAvail.includes(prodCategory)){//NOT Doing anything now
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'noprodimgavail'},' Product image not available');}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'g-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:JSON.parse(_this2.state.myProducts.product_details[_this2.state.myProducts.purchased_products_details[item].productId].productDetails)[0].thumbnail,alt:''}));}}()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.classforcont()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'g-text mb-0'},this.state.myProducts.product_details[this.state.myProducts.purchased_products_details[item].productId].ClassName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'g-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.rb(branchLocale(this.state.myProducts.product_details[this.state.myProducts.purchased_products_details[item].productId].productCategory,this.state.myProducts.product_details[this.state.myProducts.purchased_products_details[item].productId].ClassName)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'infoTxt row col-12 nopadding datecontainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 clearfix greyborderright'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' smallgrey'},this.rb("product.purchasedon"),': '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'greyColor  datefield'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_moment___default.a,{unix:true,format:'DD/MM/YYYY'},this.state.myProducts.purchased_products_details[item].subscriptionDate))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 clearfix paddLeft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' smallgrey'},this.state.myProducts.purchased_products_details[item].expired?this.rb("product.expiredon"):this.rb("product.expired"),': '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'greyColor  datefield'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_moment___default.a,{unix:true,format:'DD/MM/YYYY'},this.state.myProducts.purchased_products_details[item].expiryDate)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'}))),function(){try{var prodid=_this2.state.myProducts.purchased_products_details[item].productId;var tarrifid=_this2.state.myProducts.purchased_products_details[item].tariffId;if(_this2.state.myProducts.product_details[prodid].pricing_details[tarrifid].is_trial){if(_this2.state.myProducts.purchased_products_details[item].expired===false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'freeIcon',src:__WEBPACK_IMPORTED_MODULE_18__images_icons_free_png___default.a,alt:''});}else if(_this2.state.myProducts.purchased_products_details[item].expired===true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'freeIcon',src:__WEBPACK_IMPORTED_MODULE_19__images_icons_free_disabled_png___default.a,alt:''});}}}catch(e){}}(),function(){try{var prodid=_this2.state.myProducts.purchased_products_details[item].productId;var paidTariffId=_this2.state.myProducts.product_details[prodid].paidTariffId;var category=_this2.state.myProducts.product_details[prodid].productCategory;//navigation to landing for loading current clicked lesson.
var classId=_this2.state.myProducts.purchased_products_details[item].classId;var accessId=_this2.state.myProducts.purchased_products_details[item].accessId;//console.log("abdul "+classId+" "+accessId)
if(_this2.state.myProducts.purchased_products_details[item].expired){if(_this2.state.myProducts.product_details[prodid].IS_PROD_AVAILABLE&&paidTariffId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pInfo productcontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'expiredmsg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'mood_bad'),' ',_this2.rb("product.expiredmsg")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:"r-btn productBuynow isExprdSub-Class"+classId,'data-ga':"My Subscriptions - Class "+classId+" - Subscribe",'data-tarrifid':paidTariffId,'data-productid':prodid,'data-gradeid':'','data-category':category,'data-buyagain':'true',onClick:_this2.props.showSubScripeLoginForm},_this2.rb("product.buynow")));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pInfo productcontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'expiredmsg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'mood_bad'),' ',_this2.rb("product.expiredmsg")));}}else if(_this2.isFreeProduct(prodid,tarrifid)&&_this2.isPaidAvailable(prodid,paidTariffId)){upgradeBtnAdded=true;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pInfo productcontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:"r-btn productBuynow upgrapnkbtn isFreeSub-Class"+classId,'data-tarrifid':paidTariffId,'data-productid':prodid,'data-ga':"My Subscriptions - Class "+classId+" - Subscribe",'data-gradeid':'','data-category':category,'data-buyagain':'true',onClick:_this2.props.showSubScripeLoginForm},_this2.rb("product.buynow")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'data-classid':classId,'data-accessid':accessId,className:"r-btn productBuynow isFreeStart-Class"+classId,'data-ga':"My Subscriptions - Class "+classId+" - Start",onClick:_this2.goToLanding},_this2.rb("home.start")));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pInfo productcontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'data-classid':classId,'data-accessid':accessId,className:"r-btn productBuynow isPurchStart-Class"+classId,'data-ga':"My Subscriptions - Class "+classId+" - Start",onClick:_this2.goToLanding},_this2.rb("home.start")));}}catch(e){}}(),function(){if(_this2.state.myProducts.purchased_products_details[item].expired==false){var classId=_this2.state.myProducts.purchased_products_details[item].classId;var secdiff=_this2.state.myProducts.purchased_products_details[item].expiryDate-_this2.state.myProducts.currentDateTime;var mindiff=Math.floor(secdiff/60);secdiff=secdiff%60;var hourdiff=Math.floor(mindiff/60);mindiff=mindiff%60;var daydiff=Math.floor(hourdiff/24);hourdiff=hourdiff%24;var daysLimit=7;var prodid=_this2.state.myProducts.purchased_products_details[item].productId;var tarrifid=_this2.state.myProducts.purchased_products_details[item].tariffId;var paidTariffId=_this2.state.myProducts.product_details[prodid].paidTariffId;var category=_this2.state.myProducts.product_details[prodid].productCategory;if(_this2.state.myProducts.product_details[prodid].pricing_details[tarrifid].is_trial){daysLimit=3;}if(daydiff<daysLimit){if(daydiff==0){if(_this2.state.myProducts.product_details[prodid].IS_PROD_AVAILABLE&&_this2.state.myProducts.product_details[prodid].paidTariffId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pInfo productcontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'expiredmsg aboutexpire'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'alarm'),'\xA0',_this2.rb("product.expireson"),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_moment___default.a,{unix:true,format:'DD/MM/YYYY'},_this2.state.myProducts.purchased_products_details[item].expiryDate)),function(){if(!upgradeBtnAdded){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:"r-btn productBuynow isFreeSub-Class"+classId,'data-ga':"My Subscriptions - Class "+classId+" - Subscribe",'data-tarrifid':paidTariffId,'data-productid':prodid,'data-gradeid':'','data-category':category,'data-buyagain':'true',onClick:_this2.props.showSubScripeLoginForm},_this2.rb("product.buynow"));}});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'expiredmsg aboutexpire'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'alarm'),'\xA0',_this2.rb("product.expireson"),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_moment___default.a,{unix:true,format:'DD/MM/YYYY'},_this2.state.myProducts.purchased_products_details[item].expiryDate));}}else if(daydiff<2){if(_this2.state.myProducts.product_details[prodid].IS_PROD_AVAILABLE&&_this2.state.myProducts.product_details[prodid].paidTariffId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pInfo productcontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'expiredmsg aboutexpire'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'alarm'),'\xA0',_this2.rb("product.expiresinday",[daydiff])),function(){if(!upgradeBtnAdded){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:"r-btn productBuynow isFreeSub-Class"+classId,'data-ga':"My Subscriptions - Class "+classId+" - Subscribe",'data-tarrifid':paidTariffId,'data-productid':prodid,'data-gradeid':'','data-category':category,'data-buyagain':'true',onClick:_this2.props.showSubScripeLoginForm},_this2.rb("product.buynow"));}});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pInfo productcontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'expiredmsg aboutexpire'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'alarm'),'\xA0',_this2.rb("product.expiresinday",[daydiff])));}}else{if(_this2.state.myProducts.product_details[prodid].IS_PROD_AVAILABLE&&_this2.state.myProducts.product_details[prodid].paidTariffId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pInfo productcontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'expiredmsg aboutexpire'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'alarm'),'\xA0',_this2.rb("product.expiresindays",[daydiff])),function(){if(!upgradeBtnAdded){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:"r-btn productBuynow isFreeSub-Class"+classId,'data-ga':"My Subscriptions - Class "+classId+" - Subscribe",'data-tarrifid':paidTariffId,'data-productid':prodid,'data-gradeid':'','data-category':category,'data-buyagain':'true',onClick:_this2.props.showSubScripeLoginForm},_this2.rb("product.buynow"));}});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'expiredmsg aboutexpire'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'alarm'),'\xA0',_this2.rb("product.expiresindays",[daydiff]));}}}}}()));}}},{key:'renderProducts',value:function renderProducts(){try{var me=this;if(this.state.PLPloggedIn==false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' ',this.showLoader());}else if(this.state.prodLoaded==false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' ',this.showLoader());}else if(this.state.prodLoaded==true){if(Object.keys(this.state.myProducts).length>0){if(this.state.myProducts.product_details&&Object.keys(this.state.myProducts.product_details).length>0){return Object.keys(this.state.myProducts.purchased_products_details).map(function(item,index){return me.getproductBox(item,index);});}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lineheight-40 josefin noproductsContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_11_react_html_parser___default()(this.rb("register.noproducts.msg"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center josefin'},__WEBPACK_IMPORTED_MODULE_11_react_html_parser___default()(this.rb("register.noproducts.msg2"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center josefin'},__WEBPACK_IMPORTED_MODULE_11_react_html_parser___default()(this.rb("register.noproducts.msg3"))));}}}catch(e){console.error(e);}}/*handleChange(e) {
		const target = e.currentTarget;	
		this.form.validateFields(target);

		this.setState({
			[target.name]: target.value,
			submitButtonDisabled: !this.form.isValid()
		});
	}*//*handleNewStudentSubmit(e) {
		e.preventDefault();

		this.form.validateFields();

		this.setState({ submitButtonDisabled: !this.form.isValid() });

		if (this.form.isValid()) { 
			this.submitCreateStudent();
		}
	}*//*boardChange(event){		
		this.setState({student_board:event.currentTarget.value,serverMessage:""});
	}*//*submitCreateStudent(){
		
		if(this.state.student_board == null){
			this.setState({serverMessage:"Board is required."});
			return;
		}
		var formData = {
				"userName" : this.state.student_name,
				"loginId" : this.state.student_username,
				"grade" : this.state.selectedGradeOption.value,
				"board" : this.state.student_board,
				"countryCode":"IN",
				"userRole" : {
					"role" : "STU",
					"level": "1"
				},				
				"password" : this.state.student_password,
				"regnProvider" : "heymath"
		}

		var me =this;
		var callBackSuccess = function(response){
			if(response !== null){
				if(response.status.toLowerCase() == "success"){		
					me.state.myProducts.related_children[response.createdUser.userId] = {loginId: response.createdUser.loginId, userName: response.createdUser.userName};		
					me.populateStudentDropdown(me.state.myProducts);
					var createdStudent = {"label":response.createdUser.userName, "value":response.createdUser.userId};
					me.state.selectedStudentOption = createdStudent
					me.setState({selectedStudentOption:createdStudent});
					me.assignProduct();
					//me.state.studentDpList.push({"label":response.createdUser.userName,"value":response.createdUser.userId});
					me.setState({ModalShow:false});
				}else{
					if(response.status == "user_exists"){
						me.setState({serverMessage:"User already exists."});
					}else if(response.status == "no_such_token"){
						me.setState({serverMessage:"No such token."});
					}else if(response.status == "error"){
						me.setState({serverMessage:"Internal error occured."});
					}else if(response.status == "empty_inputs"){
						me.setState({serverMessage:"OTP is required."});
					}else if(response.status == "token_not_verified"){
						me.setState({serverMessage:"OTP Verification is required."});
					}else if(response.status == "role_forbidden"){
						me.setState({serverMessage:"Parent user only can create student."});
					}					
					else{
						me.setState({serverMessage:response.status});
					}
				}
			}

			console.log("response : ", response);
		}

		var callBackFailure = function(response){
			console.log("Error in CREATE_STUDENT");
			me.showAlert("","Error in CREATE_STUDENT");
		}

		new HmAjax(this.getUrlFor("CREATE_STUDENT"),formData).post(callBackSuccess,callBackFailure);
	}*/},{key:'renderErrorMsg',value:function renderErrorMsg(){return this.state.serverMessage;}},{key:'hideReviewModal',value:function hideReviewModal(){this.setState({"ModalShow":false});}/*getStudentForm(thisRef){
		var me = this;
		return(
					<div  className="col-12 col-md-8 mx-auto text-center  mt-20 josefin">
						
						<FormWithConstraints ref={formWithConstraints => me.form = formWithConstraints}
						onSubmit={me.handleNewStudentSubmit} noValidate>
							<FormGroup for="student_name">		
								<FormControlInput type="text" className="student_name" name="student_name" placeholder={me.rb("billing.fullname")}
									onChange={me.handleChange}
								required minLength={1} maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="1"/>
									<FieldFeedbacks for="student_name">
										<FieldFeedback when="valueMissing">{me.rb("billing.namerequired")}</FieldFeedback>
										<FieldFeedback when="*" />
									</FieldFeedbacks>
							</FormGroup>
							
							
							<Select		
						        onChange={me.gradeDropdownChange}
						        options={me.gradeDpList}
							 	onBlurResetsInput={false}
								onSelectResetsInput={false}		
							 	clearable={false}
							 	rtl={false}
							 	searchable={false}	
						      />
							
							
							<form className="form-inline mt-30">
								 <label className="form-check-label" for="board_icse">Board:</label>
								<div className="form-check">
							        <input className="form-check-input" name="radio_board" type="radio" id="board_cbse" value="CBSE" onChange={me.boardChange}/>
							        <label className="form-check-label" for="board_cbse">CBSE</label>
							    </div>
							
							    <div className="form-check">
							        <input className="form-check-input" name="radio_board" type="radio" id="board_icse" value="ICSE" onChange={me.boardChange}/>
							        <label className="form-check-label" for="board_icse">ICSE</label>
							    </div>
							    
							    <div className="form-check">
							        <input className="form-check-input" name="radio_board" type="radio" id="board_others" value="others" onChange={me.boardChange}/>
							        <label className="form-check-label" for="board_others">Others</label>
							    </div>
							 </form> 
							 
							<FormGroup for="student_username">		
								<FormControlInput type="text" className="student_username" name="student_username" placeholder={me.rb("login.userid")}
									onChange={me.handleChange}
								required minLength={6} maxLength={254} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="2"/>
									<FieldFeedbacks for="student_username">
										<FieldFeedback when="valueMissing">{me.rb("login.useridrequired")}</FieldFeedback>
										<FieldFeedback when={value => (value.length<6)}>{this.rb("validate.userid.minimum",[6])}</FieldFeedback>
										<FieldFeedback when="*" />
									</FieldFeedbacks>
							</FormGroup>
							
							<FormGroup for="student_password">
								<FormControlInput type="password" className="student_password" name="student_password" placeholder={me.rb("rpwd.newpwd")}
									innerRef={password => me.password = password}
								onChange={me.handleChange}				
								required minLength={6} maxLength={50} tabIndex="3"/>
								
								<FieldFeedbacks for="student_password">
									<FieldFeedback when="valueMissing">{me.rb("login.pwdrequired")}</FieldFeedback>		
									<FieldFeedback when={value => (value.length<6)}>{this.rb("validate.pwd.minimum",[6])}</FieldFeedback>
								</FieldFeedbacks>					
							</FormGroup>
							
							<FormGroup for="student_confirmpassword">
								<FormControlInput type="password" className="student_confirmpassword" name="student_confirmpassword" placeholder={me.rb("rpwd.confirmpwd")}
									innerRef={confirmpassword => me.confirmpassword = confirmpassword}
								onChange={me.handleChange}				
								required minLength={6} maxLength={50} tabIndex="4"/>
								
								<FieldFeedbacks for="student_confirmpassword">
									<FieldFeedback when="valueMissing">{me.rb("rpwd.confirmpwdrequired")}</FieldFeedback>
									<FieldFeedback when={value => (value.length<6)}>{this.rb("validate.pwd.minimum",[6])}</FieldFeedback>
									<FieldFeedback when={value => value !== me.password.value}>{me.rb("rpwd.doesnotmatch")}</FieldFeedback>
								</FieldFeedbacks>					
							</FormGroup>						
							
							 
							
							<div className="server-messages">{me.renderErrorMsg()}</div>
						
							<div className="text-center"><button disabled={me.state.submitButtonDisabled} className="submitButton">{me.rb("button.assign")}</button></div>
							<br />
							<br />
						</FormWithConstraints>	
					</div>
				);
	}*//*renderStudentInfo(){
		
		if(this.state.prodLoaded == true && Object.keys(this.state.myProducts).length>0){
			if(this.state.firstchild == true){
				var keys = Object.keys(this.state.myProducts.related_children);				
				var username = this.state.myProducts.related_children[keys[0]].loginId;
				var password = this.state.myProducts.related_children[keys[0]].password;
				
				var prodid = this.state.myProducts.purchased_products_details[0].productId;
				var tarrifid = this.state.myProducts.purchased_products_details[0].tariffId;
				
				var purchasesuccessmsg = "";
				if(this.state.myProducts.product_details[prodid].pricing_details[tarrifid].is_trial == false){
					purchasesuccessmsg = ReactHtmlParser("<div>"+this.rb('student.purchasesuccess')+"</div><br />");
				}
					
				return(					
					<div className="col-12 text-center mt-20">
						{purchasesuccessmsg}
						<div>{ReactHtmlParser(this.rb("student.studentcredential"))}</div>
						<br />
						<div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{this.rb("login.userid")}: {username}</div>						
						<div>{this.rb("login.password")}: {password}</div>
						<br />						
					</div>
					
				);
			}
		}
	}*//*renderProductsHeaderMsg(){
		if(this.state.prodLoaded == true){			
			if(Object.keys(this.state.myProducts).length>0){
				return (<span className="myproductsheadermsg josefin">To accecategoryr subscriptions, log out from the parent account and sign in with the student User ID and​ ​Password that was sent to your registered Email</span>);
			}
		}
	}*/},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'bg-grn productsbggrn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.rb("product.mysubscriptions")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-center'},this.renderTitleMsg(),this.renderProducts()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__views_plp_TestTakingModalComponent__["a" /* default */],{visible:this.state.ModalShow,dialogClassName:'modal-lg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loginHeader text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center modallogo loginHeaderTxt josefin'},this.rb("student.info")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close loginClose',onClick:this.hideReviewModal,'aria-label':'Close'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'close')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-8 mx-auto text-center  mt-20 josefin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this3.form=formWithConstraints;},onSubmit:this.handleNewStudentSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'student_name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'text',className:'student_name',name:'student_name',placeholder:this.rb("billing.fullname"),value:this.state.student_name,onChange:this.handleChange,required:true,minLength:1,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'student_name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.namerequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{value:this.state.selectedGradeOption,onChange:this.gradeDropdownChange,options:this.gradeDpList,onBlurResetsInput:false,onSelectResetsInput:false,clearable:false,rtl:false,searchable:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'form-inline mt-30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-check-label','for':'board_icse'},'Board:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-check'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-check-input',name:'radio_board',type:'radio',id:'board_cbse',value:'CBSE',onChange:this.boardChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-check-label','for':'board_cbse'},'CBSE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-check'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-check-input',name:'radio_board',type:'radio',id:'board_icse',value:'ICSE',onChange:this.boardChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-check-label','for':'board_icse'},'ICSE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-check'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-check-input',name:'radio_board',type:'radio',id:'board_others',value:'others',onChange:this.boardChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-check-label','for':'board_others'},'Others'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'student_username'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'text',className:'student_username',name:'student_username',placeholder:this.rb("login.userid"),value:this.state.student_username,onChange:this.handleChange,required:true,minLength:6,maxLength:254,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'student_username'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("login.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("validate.userid.minimum",[6])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'student_password'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'student_password',name:'student_password',placeholder:this.rb("rpwd.newpwd"),innerRef:function innerRef(password){return _this3.password=password;},value:this.state.student_password,onChange:this.handleChange,required:true,minLength:6,maxLength:50,tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'student_password'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("login.pwdrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("validate.pwd.minimum",[6])))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'student_confirmpassword'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'student_confirmpassword',name:'student_confirmpassword',placeholder:this.rb("rpwd.confirmpwd"),innerRef:function innerRef(confirmpassword){return _this3.confirmpassword=confirmpassword;},value:this.state.student_confirmpassword,onChange:this.handleChange,required:true,minLength:6,maxLength:50,tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'student_confirmpassword'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("rpwd.confirmpwdrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("validate.pwd.minimum",[6])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value!==_this3.password.value;}},this.rb("rpwd.doesnotmatch")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages'},this.renderErrorMsg()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:this.state.submitButtonDisabled,className:'submitButton'},this.rb("button.assign"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)))))));}}]);return MyProducts;}(__WEBPACK_IMPORTED_MODULE_21__core_LoggedInPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (MyProducts);

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(10));

var _reactLifecyclesCompat = __webpack_require__(303);

var _PropTypes = __webpack_require__(459);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(4));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAAZiS0dEAAAAAAAA+UO7fwAAAAlwSFlzAAAASAAAAEgARslrPgAAAVpJREFUSMftlKtOA1EURfeQKh51JYQaAgkGBZoUBBgesgbJJ9RUAQpB+IMaggZDAMtDkEBCKElFTb8AEsQMogTIwpwmw2Ue7TQo2G7fu+ese+5jpH/1IuCG72oDq07mFWgCNWC5V8AbP7XnZFxdA9NxNQccH0RkCo4fljQnaUvSs6SSpFtgoZsO7iNW+JCQzwPHlntJ6qTzwWEE4AMYcs7gElg374UgV2mAzQhAHcjFnMFuqJMnG1tKAowB76ECDaDgZMaBauhCrNn4tvlaWhenFmy5xZ1c1XIX5mfNN9MAJQv6QDGlWwDf/Ij5QGkCzi18lBrOImAKCAxS+S3IhgE+gXJMJgcM9gPZCUEqzlwBeLS5OnAA7Lv/rm4gneuHPaiiFW8QrXbW7fJDt6tFgrJu1yRwRhfKfCYGmgdOnBcfC/D6AI1KWpG0KGlG0oSkvKQ7z/NKfXXxt/QFEnt0OlnOVmcAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMTEtMjFUMTI6NTM6MDQrMDA6MDCYl6ToAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE4LTExLTIxVDEyOjUzOjA0KzAwOjAw6cocVAAAACh0RVh0c3ZnOmJhc2UtdXJpAGZpbGU6Ly8vdG1wL21hZ2ljay1uc2RjNlBUSGNv514AAAAASUVORK5CYII="

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WhoBanner__ = __webpack_require__(1134);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var WhoBanner2=function(_WhoBanner){_inherits(WhoBanner2,_WhoBanner);function WhoBanner2(){_classCallCheck(this,WhoBanner2);return _possibleConstructorReturn(this,(WhoBanner2.__proto__||Object.getPrototypeOf(WhoBanner2)).apply(this,arguments));}_createClass(WhoBanner2,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'bg-grn why-us'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,this.rb("whobanner2.txt.1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.rb("whobanner.txt.2"))));}}]);return WhoBanner2;}(__WEBPACK_IMPORTED_MODULE_1__WhoBanner__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (WhoBanner2);

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = trim;
// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().
function trim(s) {
  return s.replace(/^\s+|\s+$/g, '');
}

/***/ }),
/* 463 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(1149);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(464);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAYAAAA8AXHiAAAAAXNSR0IArs4c6QAAEqpJREFUeAHtXAmUHEUZrurZI8nOgqABCSEcETQghEO5eQSCRBBBBANBFOSQrMkuZJOIUSCBxxXIJribVYIiqCC8CAKKgg8lPCMPSFAOOSWRKwTCnexOzt0uv2+Z2tfTO7M7Oz3d00f9+77truquqr++/ruq/qqaFsKIYcAwYBgwDBgGDAOGAcOAYcAwYBgwDBgGDAOGAcOAYcAwYBgwDBgGDAOGAcOAYcAwkEQGZBIrXUydP77mZ9tUVXcfKCy5jxJyNyHVCJC1VU5aJTqVEKulkK9KKf9jp7qW1Tc1vZdzT0IDxrAcD35dy8I9UpY8TSl1opDyS45LRZ/C0J4VtrhPVFmL6y9seK7ohDG70RgWHmimpXU/20rNkkqdAoOyyvaMlfpTStjXD21uWlq2PCOSUaINa31r68jubjlPCmsinpd/XCj1l2pbTa+d0fhSROzCs5r+kelZNX8zyMxvP9cWYoGUot7fknTuahO6yNl1He9fL+fMQdHxlsQZlpo/f2inqPklBttnDPRoMV56BQQ9qmz1lGVZK4XqXoPx1xamk5aVUlINV7Y1GgP7fRB1CAbxPA4g6qG6ajFJTp36wQA3Rvpyogxr3bxFn7GsLQ/0OzBX4m0l1C+qlbh9yPSp/x3M02XXandZk5QUF8DIRhdKi/xXVqfsCUOamlYWuifq8YkxLIXpg85a+1G0VGPyPTSlxPvCtq9I16ibZFPTpnz3FBunFi9OZd5cMwkGfCWwc4F0b6e67MOGzmx8tcD1SEcnwrDU3JvrMzUbHkIHdlDep6XEbXWi9kLZfN6Hea+XGMlut0PUXmUJdWE+bxPd6gqrWh1Z19i4usQiQpss9obV03q89e6fYVQT+jwFJTYKJRrS06fc2udaGSMy89qOs1PW7SB7G3e2MK6n07XyCDllSqf7WpTD5ZuzCSkLHavWXJ/PqND1rcWgfILfRkVa6mY0PiCUOkIItcpNE7rmfTs32b92x0c9HOsWK9Oy8HhlyfvxkHLqSaNKie5jhzU3LQvyAW5sbR3d1W09AnVGustVym6ob2680R0f1XAO4VGtRD69VWvrVplu60U8xBE515XarLrVhPqZjY/kxAcU6FjQPgbd72OYP9s6p0ilMilb7DV0xtTXc+IjGohtV5jZYs3uY1R4SGitmitlVLSR+mlTXrSUOpOqMNwrUtZ1WXJ+bzjiJ7Fssda3tO9kS7UCnlhNzvPB2l26eeqJOXEVCnS0LGyVlmx0F29JdfCwi6Y+4Y6PWjiWLVa3VDPcRoWWqsMSqYawPKC0vWEWms833fp0K/Fjd1wUw7EzLLVo0TB0gd9zPwxLipZhzQ1vueMrFZYzZ2ZQ9qXu8qUSJ2yYt7DQpKr79tCGY2dYmfVdJ7kXltlaDdtUdUPYnkLdyO1uQ6uVO/OObTvdUgy4jhm2urj1iZ1hYUR8sruSQth3yh9dsLZvfGVj5MSJsCHxyz5aWDJPHfrcFeqIWBkWZrElWoDxfRiX4nd94kISYcktfXVT6gBujQ6JiiWpESvD6mxpG4OZ7G2dTHAyNL3j9qHdwTl02rTX8EI879SZ64rVNfYhOXERC1RFTN9edTvnt38VU0Gno406HAPenfEw8tYFXc1ydjm9CcN4gglTrA3s5VQNKwZ/7lzQzok3G9dW4QV5HOd3pTs+uDsKGwXzPgxnBcN23tnSOha77G4C2QfC+8MfpOdfAU2lerbAFUbvCXwbgCcp/gfcC/SZAkBcKbIfEsH4xXbAGuAXQP7NfRZ1LFCJT/bgj4JDMgovz8TOrYe/3LGgbXL9tMqsHKAORUmkusKO+QsnwqiWgWAYVbEi3y5w5/mI/zfAeaOLgFaAHtodwA5AqbIPEv4DYN5XA8z7GoC/2Mmrt2XLojf8wfw+jz36D6PFnob8QiuRMazOeQu/AlJ/C6PKnU0fgFppi7V5bhmLuJ8Dta5rKYRPB5YDh7quFRNk6/cYgJ0MfeSziLkHqHNfwe+CPnLHDRBmU93S2dJ+9gD3VexyJAwr09Y2QlnizsEaFVnF0k4+w2rGJRoRf9RwDMB+aF/gZoCyI/AIcCXAbnIgGYEbbgduA3j/ZoBpOdHJvGcDFN5H48sR27bX50QUF0DDpW7sGRoUd3+gd0XCsNQWa67b2yuWJVQw3zZjjn0oDwJ/7zkT4hkczwPOBjYC1cBPAHZTPO4EuIUt30LgFeCM7MXVOB4DXAq8kY27FscPs+cnZI9lOMhaZVksP3QSesPKzG3DW67YPZUkcOXdP+/aHhltl81sSZ5Mf424AwB2aRR2YWx9aCQvA38EHgC4PPQ0MAXQrdrvcM6WbyngFLZguizmnSMplXLrmHO9vwD6xMPXz2/NO3brL53f10JvWHaNPAldYFXJREiLhuQUGoqWV/WJ6/gCwocCEwEOwrXsgZOvA2zxYPA9ovAfW5977mc3915PbN9/L2WjdLreO7qk7dax91oxJ7ZKnVLMfUHeU/oDC0hLDFA8vY146rv1o2pXP9d46fdZsBViF3YQwN2f3QCnJ/4J3AuwNRtIthS6Ad18fzoWStYbryzliaPejMp4EnrDEgrbeDn8LVkUx0FehV0e4Y8ogbk5D1mrHmP3kEH5k4a+K8SvjD0ZP8YgB/BnWA7qnFMM+Qb2jlvLeuosqyYnZyvv9ETOLf0F0OJ54qi/vEu9FnrDwreptDdVWh2lGLJe1Yx3JHYa2QZHvN+nzrJ6dei4/qdfxIzEKE+FK+WNI0+F508cesPCdgV6Yp7EtiT3mIdSZFXKu25Seuao3OSE3rAwhfl3r5XGd69OzixYsIPXfMqdXs25ZQici3O85otFeM8cedXBnT70hoXP/iyB0q+5FR9UGMtAtqq6eFBpArg5U5+ZjDHgcC9F4QMjncOquum9hkpCb1ifbBFRl3llDQ+wIUx7yVV7exrLVJd4rRfGZ9fhIybrvOdT3hxCb1isbnra1N/izeSMd8mCfVvLhozabhUyCINXWNvzrQYlHiq5Qkyo1JPptcPnesrDp8SRMCzWPb156JnY7OZeKimKFizrvCS6UqdkN/z1emRI7PTUisrLw03Osnp0SIvN5+CF0UtHg8oadXpBVquT5JyJXC4KnUTGsOTF53akxaYJSth3DIpFpR7EAzysfmbDu4NKF8DNsrl5Q1ptHm/jM0qDKQ4v2N+UXR3qzx95me8dDBdlvXddS9uJlrTmYLZ6v0IZw9t6Wdr2lenpje6HxqWZP2XTnYbj4kJ5lDn+auQ3K5vnTjiyW+6Vng+YSHE51kW/1BvpOoFBrcBO0qvS06bc6roUumAkDUuziB2le8G4xqESuyEO3zeD4y3E61KqpXXTpjoXj3USHtPAG8A2AOd/9gYKruPhWjmEC88si2UvBwqu7fV8NESocagJvm3as2cMYyn5hhT20rrmxieR1kiIGZgO3WiEhGePs4h6cueoLs+5ClBEUnNLlBjgJj7uQefDZmt1KOCXXICMtVEF1e36VReTbxEM7I97NgF86O8AuwLllqORoS5jNc4/Xe4CTH7hZGAy1NKtyUqc71JGNY9EXh0A86dxHQEYSRAD3I+ujettnBccWA+CkzNwL+etmG83MAkwkkAGOHutjWsjzmcApXjM9PoWOfJiS0UjM5JgBhpQ982ANjBOCxxWJB80QhrQm4BO/wHOjwKMGAZ69rS/DB60cdg4/wtQyEC4E5T7qfjTMZ2Gx4cBToIaMQz0MjAEZ60ApyGcxkKDmwOMAzgQbwO4TOS852OEvw8kXkoZR8SBtFpUgksnewJjgN2BnYEdgG0BC/Ai7FJpdHQGOMu/AngR4A8y2LoZiREDI1GXKQC333CPuLOlCfKc81l3AN8FaMSxlLi3WMPw1DioPgvgQDxffflBDrYoHHhzopRGxy6tC6CsAzjW6k/YfRIUbonhOiSNZkeALeFogK2kW9jdPgTcDNDgdZk4NRJGBj4Dpa4G8rVMryL+RuBkwPmraAR9kyrkzO52MnA3QMN1t5I0bE5z8GUwEjIG6KX9EGAr43xwKxG+HNgLCIOkoMR4YBHgNrI1iDsHyNe6ItpI0AwcjQJfAZwG9TeEvwaE+SHVQT96kvy2g1P35QjvBxipEANspW4AOA7SD4b7lg4DoiT0RDmg51dsdD3oXc4CwvxiQL34yQhUaRmgH8RanHMcE+UHwRZsLsCBva4XJ2npEBgJgIF9UAbniTT5/8T5zgGUG1QRnGdzdu3sKkcFVXhSy+EOBOegtxVhel5xE7Ze9wL65aHn+Pm4VTIs9XEaFed9msKimE96sFu/DnAa12ifykpstp9Dzd/LkszBOic/kyIXo6LauFbg3OxGLdOT514nrrdpcqeUKd8oZXOZo/5Lcc69+0Y8MrAY6bVRcVY9qfIrVFzzwGkWIx4YOA9pNZn3ecgnDknZSrG1Ih8cDhwPGCmBgV2QRv8oYRXOzXzOJ4vb3KFK4yInnwKMDJKB+3G/fjuPGmTaON9+apYXcvPzOFfUj7od5yDvJj8KiHied2X56cZx/4jXJVD1F2SJY7O/baAlR6MwLml1Amy1ZodJ5VSYlMmjy38Qtx6ggT2X53rSozj2fCELrj5sTDohpv6GAcOAYcAwYBgwDBgG4sxAWDbE7QKSt44z0RWqG73F1wFugEyMcGmCi6qrARJg4A8HXPZ5FBgHJEK45meMKTgOuHft2KAsq1Jd4XhUkL+gobwFtAH8NgINzUj5GOCPaCcAZwN81pwL3BuIrcxBzXRrtXtsaxmeiv3MwXcgC9b8yVElRA/U2f/zBwNG/GXgeUf2mntHVPlPK2VYG7JVYflblb9aJkcXA8511k2ua74EK2VYznW/Q3ypmcnUyQB/gELhtyze6TmL6T9+jINbPTjOMnuJ/H3IHMDrjZJ/8LeocOS+BGrQsLglhpU34g8D30G22lFKxK+aWEld4cn+cGpyBQOPZ3lOzAtchQq/ka2002tBlJEyMfBl5KNf3mvKlGcksrnEUfFDI6FxtJS8Kcsvx7OjoqW6N213RHIuNfCtusVbVia1iwH+wHcdQG4fdF1LRPCP2cpncAxk8i4RrApxfpZXGtY3E1LnnGqe4CDgBzlXTMALA8uyvPJTTxzPJk44ScuFaL5ZTyWu9v5UeGyWT3J6rT9FRCPXKxxE0JMx4o2BdiSnUXEtdrS3rKKdmh6LnomnJ2OkdAb4nfmPARqW3ppUem4xSEnPhWTQk6FHExbhtyK41nZkFgfjuD0QVjkLipFH4vSwKhmkXvRcNCH0aCopw1H4pcDzgNbJfVyJa/ycEqdMwiSPQhnqyg/U1YRJsUrpQs+FHgxJoUdTKfk6CuYuALchFQpzgXdSpZR1lbunQ+95rmuJDtKD0Q+Qnk3QcjIK1BO2Wo9ij2GYKlkA/bW+XwiavDCXRw+GngzJoWcTpKRQmJ720A9nMMf1SL9tkAq7yqpFmAvN1PkfrmsmCAboyZCcjwB6OEGJsxsZjEE57z0+KGXzlMPuWOtyZp7riY9yEnRWgGzsgrL0gyn1OC5Afd1FLcnqH/QL6dYjtGF6MvqT2/RwgpQnUVipRsUtQNVBKusoaw+c6yFEqyPenLoYoEejH/AY1zU/gxzwvusoW+sw0JETkpXc9jPXofMXcW6kAAM0Jv0w6ekEKVwFuAvQ5Q90fAD37h6kgq6y2EquAajnE65rJpiHAXo2JIueDj2eoGUsCmTLuRzIANrANuH8GWAhwFn4Ssu3oIDW7ZxKKxOF8unZaMLCMgEZRt7+muVpLY7Dwqhg2HQaCoXo4dC4loRNuZDosyv00Iv3i0KiUyTUoIdDw6LHQ8/HSC4DVyGoW/X9cy+ZUH8M0MPRxM3t78YEXnOuFDyZwPp7rjI9HRrXGqBS80SeK+FDBichT/3SNfiQf+yzpKejCTw19rUtvoL3Z3npxLG++GTmTs0APZ11AI2LHpARIUaChC6AnNxsCCmdAXo8JJEeED2hpMtsEEA+iEOSToaX+tPj0URe6SWjGKTlJx+5Lkk+no1BfSpehX9lyXwLR3pESZXjUHH9kjUmlYRy1puejyaUHlFS5R5UnDzwq4j8oYcRjwzQ86EHRFLpESVRPotKbwHIwW+SSIBfdaYHRFLpEdEzSprMQoVZf+KIpFXez/rSA9LEzvazoBDmzUH7ymz9XwqhfpFXiZ4QjYueEclOihyDiuqXqjnsla70V0jqQNDnBknSw7h/b2AngLPySVkn0x4gjYv7wcYCxQoH+v8t9uY43HckKqHfQnP0j4ungjYWK+gCTXnJYKDSXeFzoPkbyaC6orXk7lIjhgHDgGHAMGAYMAwYBgwDhgHDgGHAMGAYMAwYBgwDhgHDgGHAMGAYMAwYBgwDhgHDgGHAMGAYMAwYBgwDvQz8Hz24NQhnxg2TAAAAAElFTkSuQmCC"

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_icons_studentinfo_png__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_icons_studentinfo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_icons_studentinfo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_icons_pencil_png__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_icons_pencil_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_icons_pencil_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_diploma_png__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_diploma_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_icons_diploma_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_icons_education_png__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_icons_education_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_icons_education_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StaticFeed=function(_PreLoginPage){_inherits(StaticFeed,_PreLoginPage);function StaticFeed(props){_classCallCheck(this,StaticFeed);return _possibleConstructorReturn(this,(StaticFeed.__proto__||Object.getPrototypeOf(StaticFeed)).call(this,props));}_createClass(StaticFeed,[{key:'componentDidMount',value:function componentDidMount(){// this.getLiveFeedData();
}},{key:'componentWillMount',value:function componentWillMount(){//this.getLiveFeedData();
}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container staticfeed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row scorecardLessons text-center padd'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'performicon',height:'35px',src:__WEBPACK_IMPORTED_MODULE_5__images_icons_education_png___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5000')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body card-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.rb("staticfeed.teacher")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'performicon',height:'35px',src:__WEBPACK_IMPORTED_MODULE_3__images_icons_pencil_png___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'10,00,000')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body card-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.rb("staticfeed.student")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'performicon',height:'35px',src:__WEBPACK_IMPORTED_MODULE_4__images_icons_diploma_png___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'30%')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body card-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.rb("staticfeed.improveInfo")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'performicon',height:'35px',src:__WEBPACK_IMPORTED_MODULE_2__images_icons_studentinfo_png___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{}},'92%')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body card-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.rb("staticfeed.studentsInfo")))))));}}]);return StaticFeed;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (StaticFeed);

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_icons_cambridge_home_png__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_icons_cambridge_home_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_icons_cambridge_home_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_raffles_home_png__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_raffles_home_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_icons_raffles_home_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_icons_bbcnews_png__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_icons_bbcnews_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_icons_bbcnews_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_icons_nytimes_png__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_icons_nytimes_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_icons_nytimes_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_icons_worldisflat_png__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_icons_worldisflat_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_icons_worldisflat_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_icons_nasscom_png__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_icons_nasscom_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_icons_nasscom_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var RecognisedStatic=function(_PreLoginPage){_inherits(RecognisedStatic,_PreLoginPage);function RecognisedStatic(){_classCallCheck(this,RecognisedStatic);return _possibleConstructorReturn(this,(RecognisedStatic.__proto__||Object.getPrototypeOf(RecognisedStatic)).apply(this,arguments));}_createClass(RecognisedStatic,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-p-ga':'',id:'recognisedStatic'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'books'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 collaboration'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Academic collaborations'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__images_icons_cambridge_home_png___default.a,alt:'University of Cambridge logo'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__images_icons_raffles_home_png___default.a,alt:' Raffles Institution, Singapore'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 recognised'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Featured in'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Home - Featured In - BBC News',href:'http://news.bbc.co.uk/2/hi/south_asia/5203440.stm',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__images_icons_bbcnews_png___default.a,alt:'BBC News logo'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Home - Featured In - NewYork Times',href:'https://www.nytimes.com/2005/09/16/opinion/still-eating-our-lunch.html?_r=1',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__images_icons_nytimes_png___default.a,alt:'The New York Times logo'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 recognised'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Recognised by'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Home - Featured In - World is Flat',href:this.getUrlFor("IFRAME_DOMAIN")+"/staticfiles/Thomas-FriedMan.pdf",target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__images_icons_worldisflat_png___default.a,alt:'The World Is Flat'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Home - Featured In - NASSCOM',href:this.getUrlFor("IFRAME_DOMAIN")+"/staticfiles/NASSCOM-Award.png",target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__images_icons_nasscom_png___default.a,alt:'Nasscom Emerge 50 2011'}))))))));}}]);return RecognisedStatic;}(__WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (RecognisedStatic);

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/worldisflat.e1459074.png";

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_icons_cambridge_png__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_icons_cambridge_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_icons_cambridge_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_raffles_png__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_raffles_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_icons_raffles_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_icons_academyofsingapore_png__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_icons_academyofsingapore_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_icons_academyofsingapore_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_icons_teacherscount_png__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_icons_teacherscount_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_icons_teacherscount_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_icons_worldisflat_png__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_icons_worldisflat_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_icons_worldisflat_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var EndorsedStatic=function(_PreLoginPage){_inherits(EndorsedStatic,_PreLoginPage);function EndorsedStatic(){_classCallCheck(this,EndorsedStatic);return _possibleConstructorReturn(this,(EndorsedStatic.__proto__||Object.getPrototypeOf(EndorsedStatic)).apply(this,arguments));}_createClass(EndorsedStatic,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-p-ga':'',id:'endorsedStatic'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'books'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 collaboration'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Academic collaborations'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__images_icons_raffles_png___default.a,alt:' Raffles Institution, Singapore'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__images_icons_cambridge_png___default.a,alt:'University of Cambridge logo'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 endorsed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Endorsed by'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Teacher - Endorsed by'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__images_icons_teacherscount_png___default.a,alt:'5000 teachers globally'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 recognised'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Recognised by'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Teacher - Featured In - Academy of singapore',href:this.getUrlFor("IFRAME_DOMAIN")+"/staticfiles/Partner_AoT_Award.pdf",target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__images_icons_academyofsingapore_png___default.a,alt:'Academy of Singapore'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Teacher - Featured In - World is Flat',href:this.getUrlFor("IFRAME_DOMAIN")+"/staticfiles/Thomas-FriedMan.pdf",target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__images_icons_worldisflat_png___default.a,alt:'The World Is Flat'}))))))));}}]);return EndorsedStatic;}(__WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (EndorsedStatic);

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_id_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal_video__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal_video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal_video__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var NrichCollaboration=function(_PreLoginSessionCheck){_inherits(NrichCollaboration,_PreLoginSessionCheck);function NrichCollaboration(props){_classCallCheck(this,NrichCollaboration);var _this=_possibleConstructorReturn(this,(NrichCollaboration.__proto__||Object.getPrototypeOf(NrichCollaboration)).call(this,props));_this.state={isOpen:false};_this.openModal=_this.openModal.bind(_this);_this.goNext=_this.goNext.bind(_this);_this.goPrev=_this.goPrev.bind(_this);_this.swiper=null;return _this;}_createClass(NrichCollaboration,[{key:'goNext',value:function goNext(){if(this.swiper)this.swiper.slideNext();}},{key:'goPrev',value:function goPrev(){if(this.swiper)this.swiper.slidePrev();}},{key:'openModal',value:function openModal(someValue){this.setState({isOpen:true});this.videoId=someValue;console.log(this.videoId);}},{key:'render',value:function render(){var _this2=this;var videoId='';var params={slidesPerView:1,spaceBetween:30,loop:false,navigation:{nextEl:'.swiper-button-next',prevEl:'.swiper-button-prev',nextButtonCustomizedClass:'.swp-next',prevButtonCustomizedClass:'.swp-prev'},breakpoints:{480:{slidesPerView:1,spaceBetween:20},640:{slidesPerView:1,spaceBetween:30},768:{slidesPerView:1,spaceBetween:30}}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'mtb collab-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Our Academic Collaboration'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collab-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container collab-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collab-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/nrich.png',alt:'How HeyMath! really empowers Tutors and Teachers'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'HeyMath! and MMP/NRICH'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'HeyMath! was founded in the year 2000 in collaboration with the Millennium Mathematics Project (MMP) and NRICH(which is an integral part of MMP) at the University of Cambridge'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Experts from NRICH have been involved right from the inception of HeyMath! and have played an instrumental role in shaping the innovative pedagogies and high quality that underlies HeyMath\u2019s digital program.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Home - How HeyMath! really empowers Tutors and Teachers',className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box popup-youtube single-video',onClick:this.openModal.bind(null,'2wmnGsAmwMw')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/nrich_video_img.jpg',alt:'How HeyMath! really empowers Tutors and Teachers'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'What makes an effective Mathematics teacher?')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_modal_video___default.a,{channel:'youtube',isOpen:this.state.isOpen,videoId:this.videoId,onClose:function onClose(){return _this2.setState({isOpen:false});}}));}}]);return NrichCollaboration;}(__WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (NrichCollaboration);

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Ga_js__ = __webpack_require__(123);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var SpotlightBanner=function(_PreLoginSessionCheck){_inherits(SpotlightBanner,_PreLoginSessionCheck);function SpotlightBanner(props){_classCallCheck(this,SpotlightBanner);return _possibleConstructorReturn(this,(SpotlightBanner.__proto__||Object.getPrototypeOf(SpotlightBanner)).call(this,props));}_createClass(SpotlightBanner,[{key:'rendermsg',value:function rendermsg(){if(this.props.msg||""){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'msg'},this.props.msg);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'bg-yel-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container mask'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,this.props.title)),this.rendermsg());}}]);return SpotlightBanner;}(__WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (SpotlightBanner);

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(194),
    _assign = __webpack_require__(36);

var ReactNoopUpdateQueue = __webpack_require__(477);

var canDefineProperty = __webpack_require__(478);
var emptyObject = __webpack_require__(288);
var invariant = __webpack_require__(62);
var lowPriorityWarning = __webpack_require__(1183);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(96);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_icons_SPL_spl1_png__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_icons_SPL_spl1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_icons_SPL_spl1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_SPL_spl2_png__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_SPL_spl2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_icons_SPL_spl2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_icons_SPL_spl3_png__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_icons_SPL_spl3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_icons_SPL_spl3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_icons_SPL_spl4_png__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_icons_SPL_spl4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_icons_SPL_spl4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_icons_PLP_plp1_png__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_icons_PLP_plp1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_icons_PLP_plp1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_icons_PLP_plp2_png__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_icons_PLP_plp2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_icons_PLP_plp2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_icons_PLP_plp3_png__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_icons_PLP_plp3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_icons_PLP_plp3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_icons_PLP_plp4_png__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_icons_PLP_plp4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_icons_PLP_plp4_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var OverallFeatures=function(_PreLoginPage){_inherits(OverallFeatures,_PreLoginPage);function OverallFeatures(props){_classCallCheck(this,OverallFeatures);var _this=_possibleConstructorReturn(this,(OverallFeatures.__proto__||Object.getPrototypeOf(OverallFeatures)).call(this,props));_this.loadFeature=_this.loadFeature.bind(_this);return _this;}_createClass(OverallFeatures,[{key:'componentDidMount',value:function componentDidMount(){//console.log("Overall Features ",this.props)
}},{key:'SPL',value:function SPL(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'OverallFeatures',className:'spl-features'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-6 col-lg-3 featureSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__images_icons_SPL_spl1_png___default.a,alt:'Book of stories'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'heading-three'},'Stories'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Our rich animated stories explain the \u2018why\u2019 and \u2018how\u2019 of every Maths concept and really engage students.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-6 col-lg-3 featureSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__images_icons_SPL_spl2_png___default.a,alt:'Student learning vocabulary'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'heading-three'},'Vocabulary'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Language and voice in our lessons build comprehension skills; which is important for solving word problems')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-6 col-lg-3 featureSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__images_icons_SPL_spl3_png___default.a,alt:'List of interactive tasks'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'heading-three'},'Activities'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Interactive tasks with immediate feedback helps students check their understanding and develop confidence.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-6 col-lg-3 featureSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__images_icons_SPL_spl4_png___default.a,alt:'Singapore Flag'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'heading-three'},'Enrichment'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Proven teaching approaches from Singapore\u2019s world class education system deepen mathematical thinking.')))));}},{key:'PLP',value:function PLP(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'OverallFeatures'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-6 col-lg-3 featureSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__images_icons_PLP_plp1_png___default.a,alt:'Diagnostic test report'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'heading-three'},'Take mini tests'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Choose a topic and take a series of diagnostic tests to assess your proficiency.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-6 col-lg-3 featureSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__images_icons_PLP_plp2_png___default.a,alt:'Video lesson'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'heading-three'},'Watch videos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'We will recommend lessons that will help you bridge learning gaps.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-6 col-lg-3 featureSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__images_icons_PLP_plp3_png___default.a,alt:'Man holding bow and arrow'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'heading-three'},'Complete practice'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'We will also recommend targeted practice to help improve your scores')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-6 col-lg-3 featureSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10__images_icons_PLP_plp4_png___default.a,alt:'Granular report card'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'heading-three'},'Performance summary'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'To identify specific topics and problems to focus on to achieve mastery')))));}},{key:'loadFeature',value:function loadFeature(){if(this.props.name=="SPL"){return this.SPL();}else{return this.PLP();}}},{key:'render',value:function render(){return this.loadFeature();}}]);return OverallFeatures;}(__WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (OverallFeatures);

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports = {"u9IQMvVIawI=":{"GEO":"IN","access":"Personalised Learning Program","productId":"u9IQMvVIawI=","productOrigin":"null","pricing_details":{"11":{"discountFlat":"0","discountPercent":"0.00","is_free_product":false,"courseDuration":"null","currency":"INR","validity":"365","is_trial":false,"productPrice":"5000.00"},"110":{"discountFlat":"0","discountPercent":"0.00","is_free_product":true,"courseDuration":"null","currency":"INR","validity":"30","is_trial":true,"productPrice":"0.00"}},"productDetails":"[{\"thumbnail\":\"images/products/prime/5.png\",\"displayName\":\"Grade 5<br>Numbers and Operations -5\",\"group\":\"Grades 5\",\"samples\":[{\"Description\":\"The Lesson features about the Quacky and her Six naughty duckinlgs playing a game of hide and seek, The ducklings love to hide but Quacky doesn't want to lose them.\",\"image\":\"images/products/retail/5.png\",\"name\":\"Simplifying fractions\",\"url\":\"lessons/vl585p_simplifyingfractions_files/teacherstemplate.html\"}],\"image\":\"images/products/retail/5.png\",\"topics\":[\"Arithmetic operations- 5\",\"Factors & Multiples 5\",\"Fractions 5\",\"Decimals 5\",\"Topic 5\",\"Topics 5\",\"Topica 5\",\"Topicb 5\"]}]","productName":"Grade 5 - Revision","productDescription":"A lesson service","productType":"1","productCategory":"service"},"9uez3z/vNBs=":{"GEO":"IN","access":"Test Prep","productId":"9uez3z/vNBs=","productOrigin":"null","pricing_details":{"15":{"discountFlat":"0","discountPercent":"0.00","is_free_product":false,"courseDuration":"null","currency":"INR","validity":"365","is_trial":false,"productPrice":"250.00"},"114":{"discountFlat":"0","discountPercent":"0.00","is_free_product":true,"courseDuration":"null","currency":"INR","validity":"30","is_trial":true,"productPrice":"0.00"}},"productDetails":"[{\"thumbnail\":\"images/products/prime/5.png\",\"displayName\":\"Grade 5<br>Numbers and Operations -5\",\"group\":\"Grades 5\",\"samples\":[{\"Description\":\"The Lesson features about the Quacky and her Six naughty duckinlgs playing a game of hide and seek, The ducklings love to hide but Quacky doesn't want to lose them.\",\"image\":\"images/products/retail/5.png\",\"name\":\"Simplifying fractions\",\"url\":\"lessons/vl585p_simplifyingfractions_files/teacherstemplate.html\"}],\"image\":\"images/products/retail/5.png\",\"topics\":[\"Arithmetic operations- 5\",\"Factors & Multiples 5\",\"Fractions 5\",\"Decimals 5\",\"Topic 5\",\"Topics 5\",\"Topica 5\",\"Topicb 5\"]}]","productName":"Grade 5 - Test","productDescription":"A lesson service","productType":"1","productCategory":"service"},"bFBXgrAoBtc=":{"GEO":"IN","access":"Self-Paced lessons","productId":"bFBXgrAoBtc=","productOrigin":"null","pricing_details":{"5":{"discountFlat":"0","discountPercent":"0.00","is_free_product":false,"courseDuration":"null","currency":"INR","validity":"365","is_trial":false,"productPrice":"2000.00"},"104":{"discountFlat":"0","discountPercent":"0.00","is_free_product":true,"courseDuration":"null","currency":"INR","validity":"30","is_trial":true,"productPrice":"0.00"}},"productDetails":"[{\"thumbnail\":\"images/products/prime/5.png\",\"displayName\":\"Grade 5<br>Numbers and Operations -5\",\"group\":\"Grades 5\",\"samples\":[{\"Description\":\"The Lesson features about the Quacky and her Six naughty duckinlgs playing a game of hide and seek, The ducklings love to hide but Quacky doesn't want to lose them.\",\"image\":\"images/products/retail/5.png\",\"name\":\"Simplifying fractions\",\"url\":\"lessons/vl585p_simplifyingfractions_files/teacherstemplate.html\"}],\"image\":\"images/products/retail/5.png\",\"topics\":[\"Arithmetic operations- 5\",\"Factors & Multiples 5\",\"Fractions 5\",\"Decimals 5\",\"Topic 5\",\"Topics 5\",\"Topica 5\",\"Topicb 5\"]}]","productName":"Grade 5","productDescription":"A lesson service","productType":"1","productCategory":"service"}}

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_NativeAjax__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_device_detect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_purchase_countries_json__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_purchase_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_purchase_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_select__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_html_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_plp_TestTakingModalComponent__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_purchase_OrderReview__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_reactstrap__ = __webpack_require__(39);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var paymentErrorMap={"TXN_ERR_001":"Transaction not saved","TXN_ERR_002":"Transaction failed","TXN_ERR_003":"Field does not meet the minimum length","TXN_ERR_004":"Field exceeds the maximum length","TXN_ERR_005":"Space not allowed in the field","TXN_ERR_006":"Should be Alphanumeric Only","TXN_ERR_007":"Should contain Alphanumeric and permitted characters only","TXN_ERR_008":"Should contain Alphabets Only","TXN_ERR_009":"Should contain Numbers Only","TXN_ERR_010":"Should contain Numbers and dot (.)","TXN_ERR_011":"Contains Invalid Characters","TXN_ERR_012":"Should contain Alpabets and characters only","TXN_ERR_013":"Invalid parameter","TXN_ERR_014":"Invalid Transaction amount","TXN_ERR_015":"System Error"};var MOBILE_VALID_LENGTH={"SGD":8,"INR":10};var MOBILE_VALID_LENGTH_BY_GEO={"IN":10,"SG":8,"ALL":8};var BillingForm=function(_PreLoginPage){_inherits(BillingForm,_PreLoginPage);function BillingForm(props){_classCallCheck(this,BillingForm);//ModalContent has 2 options - billing / review
var _this=_possibleConstructorReturn(this,(BillingForm.__proto__||Object.getPrototypeOf(BillingForm)).call(this,props));_this.toggleChange=function(){_this.setState({existing_userid:__WEBPACK_IMPORTED_MODULE_9_jquery___default()('#existing_userid').prop('checked'),eligible:false,isverified:false});};_this.submitForm=function(){var me=this;var userExists=String(me.state.existing_userid);//console.log("userExists ==> ",userExists, "type : ",typeof userExists);
//Setting payLoad
me.payload={"schoolId":me.purchaseObj.productCategory,"validTo":me.purchaseObj.validTo,"userName":me.state.billing_name,"userExists":userExists,"role":"TCHR","grade":"TCHR"};var payloadStr=JSON.stringify(me.payload);//abdul
var formData={userName:this.state.billing_name,userId:this.state.billing_userid.toLowerCase(),appName:this.purchaseObj.appName,_appId:this.purchaseObj.appId,sessionId:this.state.sessionId,fullName:this.state.billing_name,address:this.state.billing_address,zip:this.state.billing_zipcode,city:this.state.billing_city,state:this.state.billing_state,countryCode:this.state.selectedCountryOption.value||"",country:this.state.selectedCountryOption.label||"",email:this.state.billing_email,phone:this.state.billing_phone,language:'EN',productList:[{"productId":me.purchaseObj._productID,"productCategory":me.purchaseObj.productCategory,"price":me.purchaseObj.productPrice,"currency":me.purchaseObj.currency,"validity":me.purchaseObj.validity,"tariffId":me.purchaseObj.productTariffID,"count":1}],currency:this.purchaseObj.currency,payload:payloadStr};var productList=[{"productId":me.purchaseObj._productID,"productCategory":me.purchaseObj.productCategory,"price":me.purchaseObj.productPrice,"currency":me.purchaseObj.currency,"validity":me.purchaseObj.validity,"tariffId":me.purchaseObj.productTariffID,"count":1}];// var productList=[{
// 	"productId":me.purchaseObj.productid,
// 	"productCategory":me.productsJson[me.purchaseObj.productid].productCategory,
// 	"price":me.productsJson[me.purchaseObj.productid].pricing_details[me.purchaseObj.tarrrifid].productPrice,
// 	"currency":me.productsJson[me.purchaseObj.productid].pricing_details[me.purchaseObj.tarrrifid].currency,
// 	"validity":"1 year",
// 	"tariffId":me.purchaseObj.tarrrifid,
// 	"count":1
// }];
var opsCart=Object.assign({},formData,{productList:JSON.stringify(productList)});var submitFormFields=opsCart;var paymentSubmitElem=__WEBPACK_IMPORTED_MODULE_9_jquery___default()('#doPayForm');me.fillForm(paymentSubmitElem,submitFormFields);__WEBPACK_IMPORTED_MODULE_9_jquery___default.a.ajax({url:this.getUrlFor("OPS_FORM_VALIDATION"),data:__WEBPACK_IMPORTED_MODULE_9_jquery___default()(paymentSubmitElem).serializeArray(),type:'POST',xhrFields:{withCredentials:true},crossDomain:true,success:function success(response){if(response!==null){if(response.formValid){me.setState({serverMessage:''});//me.doPay();
me.showOrderReview();}else if(response.errorMsgs!=null){var errmsg="";if(response.fieldErrMap!=null){for(var key in response.fieldErrMap){var msg=paymentErrorMap[response.fieldErrMap[key].split(":")[0]];errmsg+=key+" : "+msg;}}me.setState({serverMessage:errmsg});}else{me.setState({serverMessage:'Sorry, we\'re unable to process your registration. Please try again later.'});}}//console.log("response : ", response);
},error:function error(response){console.log("Error in OPS_FORM_VALIDATION");}});};_this.state={ModalShow:false,ModalContent:"billing",prod_price:"",taxAmount:"",basePrice:"",otherCharges:"",prod_name:"",errorMsg:"",selectedProductClassName:"",selectedProductCategoryType:"",sessionId:"",eligible:false,isverified:false,billing_userid:"",existing_userid:false,billing_name:"",billing_address:"",billing_zipcode:"",billing_city:"",billing_state:"",billing_email:"",billing_phone:""};_this.oldState=_this.state;_this.userId=null;_this.userCountryCode=null;_this.purchaseObj=props.purchaseObj||{};_this.userObj={};_this.productsJson=props.productsJson||{};_this.renderProductDetails=_this.renderProductDetails.bind(_this);_this.handleChange=_this.handleChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.submitForm=_this.submitForm.bind(_this);_this.countryDropdownChange=_this.countryDropdownChange.bind(_this);_this.updatePrice=_this.updatePrice.bind(_this);_this.hideReviewModal=_this.hideReviewModal.bind(_this);_this.validateMobilePattern=_this.validateMobilePattern.bind(_this);_this.payload={};_this.proceedPay=_this.proceedPay.bind(_this);_this.countryDpList=[];_this.taxRules={};_this.productCategoryInfo={"PLP":"PLP","EXAM_PREP_CBSE":"EXAM_PREP_CBSE","SPL":"SPL","PLP-GA":"PLP","EXAM_PREP_CBSE-GA":"CBSE Exam Prep","SPL-GA":"SPL"};_this.userDataKey="USER_SESSION";_this.appName=null;_this._appId=null;//this.selectedCountryOption = this.countryDpList[0];
_this.renderForm=_this.renderForm.bind(_this);_this.renderHiddenForm=_this.renderHiddenForm.bind(_this);_this.getUserStatus=_this.getUserStatus.bind(_this);return _this;}_createClass(BillingForm,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.resetValues();}},{key:'resetValues',value:function resetValues(){this.setState(this.oldState);}},{key:'validateMobilePattern',value:function validateMobilePattern(){var selectedCurr=this.purchaseObj&&this.purchaseObj.currency?this.purchaseObj.currency:"INR";var mobileLen=10;var geo=this.getGeo();if(geo&&(!isNaN(MOBILE_VALID_LENGTH_BY_GEO[geo.toUpperCase()])||!isNaN(MOBILE_VALID_LENGTH_BY_GEO["ALL"]))){mobileLen=MOBILE_VALID_LENGTH_BY_GEO[geo.toUpperCase()]||MOBILE_VALID_LENGTH_BY_GEO["ALL"];}else if(selectedCurr&&!isNaN(MOBILE_VALID_LENGTH[selectedCurr])){mobileLen=MOBILE_VALID_LENGTH[selectedCurr];}return".{"+mobileLen+",}";}},{key:'handleChange',value:function handleChange(e){var _setState;var me=this;var target=e.currentTarget;this.form.validateFields(target);if(target.name=="billing_userid"&&this.state.isverified){me.setState({eligible:false,isverified:false});}this.setState((_setState={},_defineProperty(_setState,target.name,target.value),_defineProperty(_setState,'submitButtonDisabled',!this.form.isValid()),_setState));}},{key:'handleSubmit',value:function handleSubmit(e){e.preventDefault();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()&&this.state.eligible){this.submitForm();}else if(!this.state.eligible){this.setState({serverMessage:this.rb("tchr.userid.verify")});}//this.showOrderReview();
}},{key:'proceedPay',value:function proceedPay(){this.doPay();}},{key:'doPay',value:function doPay(){var me=this;var payloadStr=JSON.stringify(me.payload);this.trackMe();var formData={userId:this.state.billing_userid.toLowerCase(),/*customerId: me.userId,*/appName:me.purchaseObj.appName,_appId:me.purchaseObj.appId,sessionId:this.state.sessionId,fullName:this.state.billing_name,address:this.state.billing_address,zip:this.state.billing_zipcode,city:this.state.billing_city,state:this.state.billing_state,countryCode:this.state.selectedCountryOption.value||"",country:this.state.selectedCountryOption.label||"",email:this.state.billing_email,phone:this.state.billing_phone,billingAddressLine1:this.state.billing_address,billingAddressLine2:this.state.billing_address,language:"EN",currency:me.purchaseObj.currency,payload:payloadStr};var productList=[{"productId":me.purchaseObj._productID,"productCategory":me.purchaseObj.productCategory,"price":me.purchaseObj.productPrice,"currency":me.purchaseObj.currency,"validity":me.purchaseObj.validity,"tariffId":me.purchaseObj.productTariffID,"count":1}];var opsCart=Object.assign({},formData,{productList:JSON.stringify(productList)});var submitFormFields=opsCart;var paymentSubmitElem=__WEBPACK_IMPORTED_MODULE_9_jquery___default()('#doPayForm');me.fillForm(paymentSubmitElem,submitFormFields);__WEBPACK_IMPORTED_MODULE_9_jquery___default()("#paySubmit").trigger("click");try{var trackGradeId=localStorage.getItem("grade")||"";this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"pay-gateway-class-"+trackGradeId});}catch(e){console.error(e);}return;//new HmAjax(this.getUrlFor("OPS_DO_PAY"),fd,headers).post(callBackSuccess,callBackFailure);
}},{key:'trackMe',value:function trackMe(){try{var trackObj={"grade_id":localStorage.getItem("grade"),"product_type":this.productsJson[this.purchaseObj.productid].productCategory,"tariff_id":this.purchaseObj.productTariffID,"email":this.state.billing_email};this.initiateTrack("purchase_initiated",trackObj);}catch(e){}}},{key:'componentWillUnmount',value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_9_jquery___default()("#custom_fc_button").css("display","block");//console.log("componentWillUnmount")
//$("body").css({overflowY:"auto"});
}},{key:'getOPSHome',value:function getOPSHome(){var me=this;//console.log(me.productsJson,me.purchaseObj.tarrrifid,me.purchaseObj.productid);
//console.log(me.productsJson[me.purchaseObj.productid]);
if(me.purchaseObj){//IMPORTANT: This component needs to be extended to make the following parameters dynamic
var formData={/*customerId: me.userId,*/appName:me.purchaseObj.appName,_appId:me.purchaseObj.appId,/*sFrame: me.getUrlFor("PAYMENT_SUCCESS_URL"),*/sFrame:me.getUrlFor("TCHR_PURCHASE_SUCCESS"),fFrame:me.getUrlFor("PAYMENT_FAILURE_URL"),//pcsUrl: me.getUrlFor("PAYMENT_PCS_URL"), 
pcsUrl:me.getUrlFor("TEACHER_PCS_URL"),//pcfUrl: me.getUrlFor("PAYMENT_PCF_URL"),
pcfUrl:me.getUrlFor("TEACHER_PCF_URL"),currency:me.purchaseObj.currency};var productList=[{"productId":me.purchaseObj._productID,"productCategory":me.purchaseObj.productCategory,"price":me.purchaseObj.productPrice,"currency":me.purchaseObj.currency,"validity":me.purchaseObj.validity,"tariffId":me.purchaseObj.productTariffID,"count":1}];var opsCart=Object.assign({},formData,{productList:JSON.stringify(productList)});var me=this;__WEBPACK_IMPORTED_MODULE_9_jquery___default.a.ajax({url:this.getUrlFor("OPS_PROCESSPAY"),data:opsCart,type:'POST',xhrFields:{withCredentials:true},crossDomain:true,success:function success(response){if(response!=null){//alert("sessionid="+response.sessionId)
me.setState({sessionId:response.sessionId});if(response.currency){if(response.allTaxRules&&response.allTaxRules.length>0){for(var i=0;i<response.allTaxRules.length;i++){var tempObj={};if(me.taxRules[response.allTaxRules[i].geo]){tempObj=me.taxRules[response.allTaxRules[i].geo];}tempObj[response.allTaxRules[i].currency]=response.allTaxRules[i];me.taxRules[response.allTaxRules[i].geo]=tempObj;}}me.setState({sessionId:response.sessionId,opsReady:true,opsCheckDone:true});me.updatePrice();}else{me.setState({opsReady:false,opsCheckDone:true,errorMsg:'Sorry, we\'re unable to process your registration. Please try again later.'});}}//console.log("response : ", response);
},error:function error(response){console.log("Error in OPS_PROCESSPAY");me.setState({opsReady:false,opsCheckDone:true,errorMsg:'Sorry, we\'re unable to process your registration. Please try again later.'});}});}//new HmAjax(this.getUrlFor("OPS_PROCESSPAY"),opsCart,headers).post(callBackSuccess,callBackFailure);
}},{key:'componentDidMount',value:function componentDidMount(){if(this.purchaseObj){console.log("tchr products ",this.purchaseObj);this.getOPSHome();}this.sessionCheck();this.populateCountryDropdown();__WEBPACK_IMPORTED_MODULE_16__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");__WEBPACK_IMPORTED_MODULE_9_jquery___default()("#custom_fc_button").css("display","none");}},{key:'getTaxedAmount',value:function getTaxedAmount(amount,country,currency){//console.log(amount, country, currency);
var me=this;amount=parseInt(amount);var taxAmount=0;var basePrice=0;var otherCharges=0;var amountDetails={taxAmount:0,basePrice:0,otherCharges:0,amount:amount};try{if(!isNaN(amount)&&amount>0&&currency&&(me.taxRules[country]&&me.taxRules[country][currency]||me.taxRules["ALL"]&&me.taxRules["ALL"][currency])){var tRule=(me.taxRules&&me.taxRules[country]&&me.taxRules[country][currency]?me.taxRules[country][currency]:null)||(me.taxRules&&me.taxRules["ALL"]&&me.taxRules["ALL"][currency]?me.taxRules["ALL"][currency]:null);otherCharges=tRule.flat;if(!tRule){return amount;}if(tRule.inclusive){if(tRule.type===2){basePrice=Math.round((amount-otherCharges)*100/(100+tRule.percentage)*100)/100;taxAmount=Math.round((amount-basePrice)*100)/100;}else{basePrice=Math.round(amount*100/(100+tRule.percentage)*100)/100-otherCharges;taxAmount=Math.round((amount-basePrice)*100)/100;}}else{//Exclusive tax - amount without tax is the basePrice
basePrice=amount;if(tRule.type===1){taxAmount=Math.round(amount*tRule.percentage/100)+otherCharges;amount=amount+taxAmount;}else if(tRule.type===2){taxAmount=Math.round((amount+otherCharges)*tRule.percentage/100);amount=amount+taxAmount;}else{taxAmount=Math.round(amount*tRule.percentage/100);amount=amount+taxAmount;}}amountDetails["taxAmount"]=taxAmount;amountDetails["basePrice"]=basePrice;amountDetails["otherCharges"]=otherCharges;amountDetails["amount"]=amount;me.setTaxMessage('Price inclusive of Taxes','Price updated to include Taxes',amount);}else{me.setTaxMessage('Price includes 0% Taxes',null,amount);}}catch(e){}return amountDetails;}},{key:'setTaxMessage',value:function setTaxMessage(msg1,msg2,amount){var taxMessage1Elem=__WEBPACK_IMPORTED_MODULE_9_jquery___default()('#tax-message-1');var taxMessage2Elem=__WEBPACK_IMPORTED_MODULE_9_jquery___default()('#tax-message-2');this.setState({taxMsg1:""});this.setState({taxMsg2:""});if(typeof msg1==='string'&&msg1.length>0){this.setState({taxMsg1:msg1});}if(typeof msg2==='string'&&msg2.length>0){this.setState({taxMsg2:msg2});}}},{key:'fillForm',value:function fillForm(formElem,formData,reset){var i;for(i in formData){__WEBPACK_IMPORTED_MODULE_9_jquery___default()(formElem).find('[name="'+i+'"]').val(reset?'':formData[i]);}}},{key:'populateCountryDropdown',value:function populateCountryDropdown(){var defaultIndex=0;for(var i=0;i<__WEBPACK_IMPORTED_MODULE_10__views_purchase_countries_json___default.a.countryList.length;i++){this.countryDpList.push({"label":__WEBPACK_IMPORTED_MODULE_10__views_purchase_countries_json___default.a.countryList[i].countryName,"value":__WEBPACK_IMPORTED_MODULE_10__views_purchase_countries_json___default.a.countryList[i].countryID});if(this.userCountryCode){if(__WEBPACK_IMPORTED_MODULE_10__views_purchase_countries_json___default.a.countryList[i].countryID==this.userCountryCode){defaultIndex=i;}}else if(__WEBPACK_IMPORTED_MODULE_10__views_purchase_countries_json___default.a.countryList[i].countryName.toLowerCase()=="india"){defaultIndex=i;}}//this.selectedCountryOption = this.countryDpList[0];
this.setState({selectedCountryOption:this.countryDpList[defaultIndex]});// console.log("country::",this.state.selectedCountryOption);
}},{key:'countryDropdownChange',value:function countryDropdownChange(selectedOption){//this.selectedCountryOption = selectedOption;
var me=this;this.setState({selectedCountryOption:selectedOption});setTimeout(function(){me.updatePrice();},200);}},{key:'updatePrice',value:function updatePrice(){__WEBPACK_IMPORTED_MODULE_16__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");if(this.state.selectedCountryOption===null){return false;}//console.log("updateprice::",this.state.selectedCountryOption);
var validity=this.purchaseObj.validity=="365"?"1 Year":this.purchaseObj.validity;var price=this.purchaseObj.productPrice;var currency=this.purchaseObj.currency;var amountDetails=this.getTaxedAmount(price,this.state.selectedCountryOption.value,currency);var taxAmount=amountDetails.taxAmount;var totalAmount=amountDetails.amount;var otherCharges=amountDetails.otherCharges;var basePrice=amountDetails.basePrice;var productName=this.purchaseObj.productName;//console.log("amountDetails:::",amountDetails);
this.setState({prod_validity:validity,prod_price:totalAmount,taxAmount:taxAmount,prod_name:productName,basePrice:basePrice,otherCharges:otherCharges});}},{key:'hideReviewModal',value:function hideReviewModal(){this.setState({"ModalContent":"billing"});//this.setState({"ModalShow":false});
}},{key:'getUserStatus',value:function getUserStatus(){if(this.state.billing_userid.length<=0){return;}var pattern=new RegExp("^[a-z0-9\s]+$");if(!pattern.test(this.state.billing_userid)){return;}var formData={"userId":this.state.billing_userid.toLowerCase()};var me=this;//	me.setState({submitButtonDisabled: true});
var callBackSuccess=function callBackSuccess(response,request){if(response!==null){if(!me.state.existing_userid){if(!response.userExists){me.setState({serverMessage:'',eligible:true,isverified:true});}else if(response.userExists){me.setState({submitButtonDisabled:false,eligible:false,isverified:true});}}else if(me.state.existing_userid){if(response.userExists){me.setState({serverMessage:'',eligible:true,isverified:true});}else if(!response.userExists){me.setState({submitButtonDisabled:false,eligible:false,isverified:true});}}// if(response.userExists && response.source!=='null' && response.message !== "provider_forbidden"){	
// 	if(response.source=="lumos"){
// 		me.setState({userLoginAllowed:true,user_exists:response.userExists,source:response.source,username:me.state.billing_userid});
// 	}else if(response.source=="plp"){
// 		me.setState({userLoginAllowed:true,user_exists:response.userExists,source:response.source,userInput:me.state.billing_userid});
// 	}
// }else{	
// 	if(response.message == "provider_forbidden"){						
// 		if(response.authProviderId==2){
// 			me.setState({submitButtonDisabled: false, serverMessage: me.rb("google.errmsg.pwd")});
// 		}else if(response.authProviderId==4){
// 			me.setState({submitButtonDisabled: false, serverMessage: me.rb("uolo.errmsg.pwd")});
// 		}
// 	}else{					
// 		me.setState({submitButtonDisabled: false, serverMessage: me.rb("unifiedlogin.invalidinput.msg")});
// 	}					
// }
}};var PLPcallBackFailure=function PLPcallBackFailure(response,request){me.setState({submitButtonDisabled:false});};var callBackFailure=function callBackFailure(response,request){//me.setState({submitButtonDisabled: false});
new __WEBPACK_IMPORTED_MODULE_6__util_NativeAjax__["a" /* default */](me.getUrlFor("PLP_GET_USER_STATUS_UNIF"),formData).enableCORS().post(callBackSuccess,PLPcallBackFailure);};//new HmAjax(this.getUrlFor("GET_USER_STATUS"),formData).post(callBackSuccess,callBackFailure);
new __WEBPACK_IMPORTED_MODULE_6__util_NativeAjax__["a" /* default */](this.getUrlFor("GET_USER_STATUS_UNIF"),formData).enableCORS().post(callBackSuccess,callBackFailure);}},{key:'checkValidUserInput',value:function checkValidUserInput(){var me=this;var userinput=this.state.billing_userid;var phoneRegx=/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;if(phoneRegx.test(userinput)){if(userinput.length==10){me.setState({userLoginAllowed:false});me.props.showSignUp(me.state.loginType,me.state.billing_userid,me.props.from);}else{me.setState({submitButtonDisabled:false,serverMessage:me.rb("login.invalidinput.msg")});}}else{if(userinput.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){me.setState({userLoginAllowed:false});me.props.showSignUp(me.state.loginType,me.state.billing_userid,me.props.from);}else{me.setState({submitButtonDisabled:false,serverMessage:me.rb("login.invalidinput.msg")});}}}},{key:'existingUserId',value:function existingUserId(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'existing_userid',className:'existuser'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_reactstrap__["d" /* Label */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("existing.user")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_reactstrap__["c" /* Input */],{type:'checkbox',id:'existing_userid',name:'existing_userid',checked:this.state.existing_userid,value:this.state.existing_userid,onChange:this.toggleChange,tabIndex:'1'})));}},{key:'newUserId',value:function newUserId(){var _this2=this;var me=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'billing_userid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'text',className:'billing_userid',name:'billing_userid',placeholder:this.rb("billing.userid"),value:this.state.billing_userid,onChange:this.handleChange,required:true,pattern:'^[a-z0-9]*$',minLength:6,maxLength:25,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'2'}),function(){if(!me.state.eligible&&!me.state.isverified&&me.state.billing_userid.length>5){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'userstatus',onClick:me.getUserStatus},_this2.rb("verify"));}}(),function(){//	console.log("existing_userid ",me.state.existing_userid);
if(me.state.isverified&&me.state.eligible&&me.state.existing_userid){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error userstatusfbc'},_this2.rb("tchr.existuserid.valid"));}else if(!me.state.eligible&&me.state.isverified&&me.state.existing_userid){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error userstatusfbw'},_this2.rb("tchr.existuserid.invalid"));}else if(me.state.isverified&&me.state.eligible&&!me.state.existing_userid){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error userstatusfbc'},_this2.rb("tchr.userid.valid"));}else if(!me.state.eligible&&me.state.isverified&&!me.state.existing_userid){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error userstatusfbw'},_this2.rb("tchr.userid.invalid"));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'billing_userid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("tchrvalidate.userid.minimum",[6])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},this.rb("tchr.userid.pattern")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'*'})));}},{key:'renderBillingInformation',value:function renderBillingInformation(){var _this3=this;var me=this;__WEBPACK_IMPORTED_MODULE_16__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");//	console.log("product:::",this.productsJson);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container row Billing josefin billing_form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 order-2 col-sm-12 order-sm-2 col-md-12 order-md-2 col-lg-9 order-lg-1 nopadding pr-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this3.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},this.existingUserId(),this.newUserId(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'billing_name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'text',className:'billing_name',name:'billing_name',placeholder:this.rb("billing.fullname"),value:this.state.billing_name,onChange:this.handleChange,required:true,minLength:1,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'billing_name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.namerequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'billing_email'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'text',className:'billing_email',name:'billing_email',placeholder:this.rb("profile.email_id"),value:this.state.billing_email,onChange:this.handleChange,required:true,pattern:'^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$',minLength:1,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'billing_email'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("fpwd.emailrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},this.rb("fpwd.validemail")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'billing_phone'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'billing_phone',className:'billing_phone',name:'billing_phone',placeholder:this.rb("register.phone"),innerRef:function innerRef(phone){return _this3.phone=phone;},value:this.state.billing_phone,onChange:this.handleChange,pattern:this.validateMobilePattern(),autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'billing_phone'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("register.mobilerequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},this.rb("register.mobilenolength")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length>0&&!/\d/.test(value);}},this.rb("register.numbersonly")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'billing_address'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'text',className:'billing_address',name:'billing_address',placeholder:this.rb("billing.address"),value:this.state.billing_address,onChange:this.handleChange,required:true,minLength:1,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'6'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'billing_address'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.addressrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'billing_zipcode'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'text',className:'billing_zipcode',name:'billing_zipcode',placeholder:this.rb("billing.zipcode"),value:this.state.billing_zipcode,onChange:this.handleChange,required:true,minLength:1,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'7'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'billing_zipcode'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.zipcoderequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'billing_city'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'text',className:'billing_city',name:'billing_city',placeholder:this.rb("billing.city"),value:this.state.billing_city,onChange:this.handleChange,required:true,minLength:1,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'8'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'billing_city'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.cityrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'billing_state'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'text',className:'billing_state',name:'billing_state',placeholder:this.rb("billing.state"),value:this.state.billing_state,onChange:this.handleChange,required:true,minLength:1,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'9'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'billing_state'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.staterequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{value:this.state.selectedCountryOption,onChange:this.countryDropdownChange,options:this.countryDpList,onBlurResetsInput:false,onSelectResetsInput:false,autoFocus:true,clearable:false,rtl:false,searchable:false,required:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{id:'tax-message-2'},this.state.taxMsg2),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages'},this.state.serverMessage),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:this.state.submitButtonDisabled,className:'submitButton','data-ga':this.productCategoryInfo[this.state.selectedProductCategoryType+"-GA"]+" - "+this.state.selectedProductClassName+" - "+"Purchase"},this.rb("billing.purchase"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))));}},{key:'renderProductDetails',value:function renderProductDetails(){var _this4=this;//console.log("this.productsJson::",this.productsJson);
if(this.productsJson&&Object.keys(this.productsJson).length>0){return Object.keys(this.productsJson).map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productbox clearfix',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left productimg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'g-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/"+JSON.parse(_this4.productsJson[item].productDetails)[0].thumbnail,alt:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left productcontent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'g-text mb-0'},_this4.productsJson[item].ClassName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'g-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,_this4.rb(_this4.productsJson[item].productCategory))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'greycolor'},_this4.rb("product.validity"),' : \xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this4.state.prod_validity))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this4.rb("product.price"),' : \xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'priceAmt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,_this4.state.prod_price))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'tax-message-1'},_this4.state.taxMsg1)));});}}},{key:'isProductSelected',value:function isProductSelected(){if(this.state.isProductSelected==false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lineheight-40 josefin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_12_react_html_parser___default()(this.rb("register.noproducts.msg"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center josefin'},__WEBPACK_IMPORTED_MODULE_12_react_html_parser___default()(this.rb("register.noproducts.msg2"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center josefin'},__WEBPACK_IMPORTED_MODULE_12_react_html_parser___default()(this.rb("register.noproducts.msg3"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center josefin'},'OR'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'r-btn lineheight-20',href:'/products'},this.rb("product.browseproducts"))));}}},{key:'showOrderReview',value:function showOrderReview(){this.setState({"ModalContent":"review"});/*this.setState({"ModalContent":this.getOrderReview()});*/this.props.showOrderReview();}},{key:'getOrderReview',value:function getOrderReview(){//console.warn("tchr products review",this.purchaseObj);
var reviewData={userId:this.state.billing_userid.toLowerCase(),fullName:this.state.billing_name,address:this.state.billing_address,zip:this.state.billing_zipcode,city:this.state.billing_city,state:this.state.billing_state,country:this.state.selectedCountryOption.label||"",phone:this.state.billing_phone,email:this.state.billing_email,billingAddressLine1:this.state.billing_address,billingAddressLine2:this.state.billing_address,currency:this.purchaseObj.currency,validity:this.purchaseObj.validity=="365"?"1 Year":this.purchaseObj.validity,productName:this.purchaseObj.productName,price:this.purchaseObj.productPrice,taxAmount:this.state.taxAmount,totalAmount:this.state.prod_price,basePrice:this.state.basePrice,otherCharges:this.state.otherCharges,selectedProductCategoryType:this.productCategoryInfo[this.state.selectedProductCategoryType],selectedProductCategoryTypeGA:this.productCategoryInfo[this.state.selectedProductCategoryType+"-GA"],selectedProductClassName:this.state.selectedProductClassName};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__views_purchase_OrderReview__["a" /* default */],{hideReviewModal:this.hideReviewModal,reviewData:reviewData,proceedPay:this.proceedPay});}},{key:'renderHiddenForm',value:function renderHiddenForm(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{id:'doPayForm',className:'hidden',method:'post',target:'_top',action:this.getUrlFor("OPS_DO_PAY")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'userId',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'appName',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'_appId',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'sessionId',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'fullName',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'address',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'zip',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'city',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'state',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'countryCode',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'country',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'email',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'phone',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'language',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'productList',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'currency',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'payload',value:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',value:'submit',id:'paySubmit'}));}},{key:'renderForm',value:function renderForm(){var sessionId=this.state.sessionId&&this.state.sessionId.length>0?true:false;if(this.props.ModalShow&&this.state.ModalContent==="billing"&&sessionId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.renderBillingInformation());}else if(this.props.ModalShow&&this.state.ModalContent==="review"&&sessionId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.getOrderReview());}else{return null;}}},{key:'render',value:function render(){__WEBPACK_IMPORTED_MODULE_16__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'tchbillingform'},this.renderHiddenForm(),this.renderForm());}}]);return BillingForm;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (BillingForm);

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_id_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_HmEventRegistry__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 classNameNameName-style
var Culture=function(_PreLoginSessionCheck){_inherits(Culture,_PreLoginSessionCheck);function Culture(){_classCallCheck(this,Culture);return _possibleConstructorReturn(this,(Culture.__proto__||Object.getPrototypeOf(Culture)).apply(this,arguments));}_createClass(Culture,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_3__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA");}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'product-main h4 dna-chart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,' Our DNA and Culture'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-circle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/chart-circle-1.png',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-hover-ga':'Who we are - Our DNA and Culture - Intensely collaborative - flip',className:'flip-container',id:'card01'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flip-cards'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'front-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/d1.png',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reverse-card',id:'card1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Magic happens when different disciplines come together'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Intensely collaborative')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-hover-ga':'Who we are - Our DNA and Culture - Colorfully diverse - flip',className:'flip-container',id:'card02'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flip-cards'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'front-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/d2.png',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reverse-card',id:'card2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Because different viewpoints lead to the best ideas'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Colorfully diverse'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'line'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-hover-ga':'Who we are - Our DNA and Culture - Atmosphere of a campus - flip',className:'flip-container',id:'card03'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flip-cards'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'front-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/d3.png',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reverse-card',id:'card3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'17 years on we still feel like a startup'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' Atmosphere of a campus')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-hover-ga':'Who we are - Our DNA and Culture - We\'ve never stopped learning - flip',className:'flip-container',id:'card04'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flip-cards'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'front-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/d4.png',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reverse-card',id:'card4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Keeps us on top of the latest trends in education'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'cng-width'},' We\'ve never stopped learning ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-hover-ga':'Who we are - Our DNA and Culture - Value our Globality - flip',className:'flip-container',id:'card05'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flip-cards'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'front-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/d5.png',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reverse-card',id:'card5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Sharing of best practices and richer ideation'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' Value our Globality'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'what-we-do'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/what-we-do.png',alt:''}))));}}]);return Culture;}(__WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Culture);

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Ga_js__ = __webpack_require__(123);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 className-style
var DayInLife=function(_PreLoginSessionCheck){_inherits(DayInLife,_PreLoginSessionCheck);function DayInLife(){_classCallCheck(this,DayInLife);return _possibleConstructorReturn(this,(DayInLife.__proto__||Object.getPrototypeOf(DayInLife)).apply(this,arguments));}_createClass(DayInLife,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'product-main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'A Day in Our Life'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'our-life'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'our-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/day1.jpg',alt:'Germination of an idea'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Germination of an idea'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'our-life'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'our-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/day2.jpg',alt:'Discussing the visuals and animations'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Discussing the visuals and animations'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'our-life'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'our-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/day3.jpg',alt:'Designing interactive activities'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Designing interactive activities'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'our-life'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'our-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/day4.jpg',alt:'Showcasing to users for critical feedback'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Showcasing to users for critical feedback ')))))));}}]);return DayInLife;}(__WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (DayInLife);

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_HmEventRegistry__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 className-style
var FlipSection=function(_PreLoginSessionCheck){_inherits(FlipSection,_PreLoginSessionCheck);function FlipSection(){_classCallCheck(this,FlipSection);return _possibleConstructorReturn(this,(FlipSection.__proto__||Object.getPrototypeOf(FlipSection)).apply(this,arguments));}_createClass(FlipSection,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_2__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA");}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'product-main our-lrn  mtb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row flip-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-hover-ga':'Our Learnings - Mathethatics is not a spectator sport - flip',className:'col-md-4 col-sm-6 flip-main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'side'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/flp1.jpg',alt:'flip img missing'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottom-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Mathematics is not a spectator sport'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'side back'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Mathematics is not a spectator sport'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'w-hr'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Just as in sport, even in Math - with more practice - you get better - and then start enjoying it')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-hover-ga':'Our Learnings - Literacy and Numeracy go together - flip',className:'col-md-8 col-sm-6 flip-main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-container verticle-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'side'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'side-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/flp2.jpg',className:'flp2',alt:'flip img missing'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/flp2-new.jpg',className:'flp2-new',alt:'flip img missing'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottom-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Literacy and Numeracy go together'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'side back'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Literacy and Numeracy go together'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'w-hr'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Building a good vocabulary and comprehension skills are important stepping stones for Math')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-hover-ga':'Our Learnings - Algebra requires a strong Arithmetic foundation - flip',className:'col-md-4 col-sm-6 flip-main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'side'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/flp3.jpg',alt:'flip img missing'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottom-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Algebra requires a strong Arithmetic foundation'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'side back'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Algebra requires a strong Arithmetic foundation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'w-hr'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Mastering Fractions, Decimals, LCM, HCF, BODMAS really help when you begin Algebra')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-hover-ga':'Our Learnings - Math is a powerful tool in interdisciplinary contexts - flip',className:'col-md-4 col-sm-6 flip-main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'side'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/flp4.jpg',alt:'flip img missing'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottom-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Math is a powerful tool in interdisciplinary contexts'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'side back'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Math is a powerful tool in interdisciplinary contexts'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'w-hr'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Math in virtually everywhere around us. From the Sciences to Humanities, Math can help solve real problems')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-hover-ga':'Our Learnings - Mathematical Thinking is all about processes - flip',className:'col-md-4 col-sm-6 flip-main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'side'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/flp5.jpg',alt:'flip img missing'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottom-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Mathematical Thinking is all about processes'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'side back'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Mathematical Thinking is all about processes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'w-hr'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'How to start off on a problem, what questions to ask, what strategies to consider and reflecting on your learning')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-hover-ga':'Our Learnings - Multiple representations of concepts drives the learning deeper - flip',className:'col-md-8 col-sm-6 flip-main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-container verticle-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'side'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'side-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/flp6.jpg',className:'flp6',alt:'flip img missing'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/flp6-new.jpg',className:'flp6-new',alt:'flip img missing'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottom-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Multiple representations of concepts drive the learning deeper'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'side back'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Multiple representations of concepts drive the learning deeper'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'w-hr'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Making connections between arithmetic, algebra and geometry develops critical thinking')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-hover-ga':'Our Learnings - Attitude and Dispositions matter when it comes to Math - flip',className:'col-md-4 col-sm-6 flip-main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'side'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/flp7.jpg',alt:'flip img missing'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottom-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Attitudes and Dispositions matter when it comes to Math'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'side back'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Attitudes and Dispositions matter when it comes to Math'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'w-hr'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'It is about developing good work habits, be willing to persevere and take responsibility for your learning')))))))));}}]);return FlipSection;}(__WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (FlipSection);

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_id_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 classNameNameNameName-style
var Founders=function(_PreLoginSessionCheck){_inherits(Founders,_PreLoginSessionCheck);function Founders(){_classCallCheck(this,Founders);return _possibleConstructorReturn(this,(Founders.__proto__||Object.getPrototypeOf(Founders)).apply(this,arguments));}_createClass(Founders,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'mtb product-main founder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Founders'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'founder-box b-grn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'found-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/found-1.jpg',alt:'Nirmala Sankaran, Co-Founder of Heymath'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'found-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Nirmala Sankaran'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Co-founder'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Nimmi is the Chief Evangelist and leads product design, innovation and talent at HeyMath! She graduated from SRCC, completed an MBA from IIM Bangalore and has worked for over 12 years with Citibank.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'founder-box b-ylw'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'found-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/found-2.jpg',alt:'Harsh Rajan, Co-Founder of Heymath'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'found-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Harsh Rajan'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Co-founder'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Harsh worked for over 12 years in the Emerging Markets Fixed Income Derivatives businesses at Citigroup and Credit Suisse, and is a Fellow of The Institute of Chartered Accountants of India.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}))))));}}]);return Founders;}(__WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Founders);

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_id_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal_video__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal_video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal_video__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Ga_js__ = __webpack_require__(123);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 classNameName-style
var FounderVideos=function(_PreLoginSessionCheck){_inherits(FounderVideos,_PreLoginSessionCheck);function FounderVideos(){_classCallCheck(this,FounderVideos);var _this=_possibleConstructorReturn(this,(FounderVideos.__proto__||Object.getPrototypeOf(FounderVideos)).call(this));_this.state={isOpen:false};_this.openModal=_this.openModal.bind(_this);_this.goNext=_this.goNext.bind(_this);_this.goPrev=_this.goPrev.bind(_this);return _this;}_createClass(FounderVideos,[{key:'openModal',value:function openModal(someValue){this.setState({isOpen:true});this.videoId=someValue;}},{key:'goNext',value:function goNext(){if(this.swiper)this.swiper.slideNext();}},{key:'goPrev',value:function goPrev(){if(this.swiper)this.swiper.slidePrev();}},{key:'render',value:function render(){var _this2=this;var videoId='';var params={slidesPerView:3,spaceBetween:30,loop:true,navigation:{nextEl:'.swiper-button-next',prevEl:'.swiper-button-prev',nextButtonCustomizedClass:'.swp-next',prevButtonCustomizedClass:'.swp-prev'},containerClass:'student-slider swiper-container',breakpoints:{480:{slidesPerView:1,spaceBetween:20},640:{slidesPerView:2,spaceBetween:30},768:{slidesPerView:2,spaceBetween:30}}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'our-student outer-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Working at HeyMath!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_id_swiper___default.a,{className:'student-slider',breakpoints:params.breakpoints,loop:params.loop,slidesPerView:params.slidesPerView,spaceBetween:params.spaceBetween,containerClass:params.containerClass,ref:function ref(node){if(node)_this2.swiper=node.swiper;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Who we are - Our DNA and Culture- Matthew Smith 1',onClick:this.openModal.bind(null,'RuUp6uVwY8w'),className:'img-box popup-youtube'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/culture1.jpg',alt:'Work culture at Heymath by Matthew Smith, Cambridge Education Consultant'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Who we are - Our DNA and Culture- Kyle Lomer ',onClick:this.openModal.bind(null,'aP7yJHCFaWw'),className:'img-box popup-youtube'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/culture2.jpg',alt:'Cambridge Education Consultant Kyle Lomer shares his experience on Heymath'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Who we are - Our DNA and Culture- Krishna Balakrishnan',onClick:this.openModal.bind(null,'j5TyBFhXzS0'),className:'img-box popup-youtube'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/day-4.jpg',alt:'NID Bengaluru Design Intern Student shares her Heymath Journey'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Who we are - Our DNA and Culture- Matthew Smith 2',onClick:this.openModal.bind(null,'NN39lhbbu1U'),className:'img-box popup-youtube'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/culture1.jpg',alt:'Work culture at Heymath by Matthew Smith, Cambridge Education Consultant'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Who we are - Our DNA and Culture- Samuel Hewitt',onClick:this.openModal.bind(null,'nmvQOGbNEtQ'),className:'img-box popup-youtube'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/day-3.jpg',alt:'Cambridge Education Consultant Samuel Hewitt shares his journey on Heymath'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Who we are - Our DNA and Culture- Matthew Smith 3',onClick:this.openModal.bind(null,'8vZ4t0nmNyc'),className:'img-box popup-youtube'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/day-2.jpg',alt:'Work culture at Heymath by Matthew Smith, Cambridge Education Consultant'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Who we are - Our DNA and Culture- Kyle Lomer 2',onClick:this.openModal.bind(null,'MqP7N8T650U'),className:'img-box popup-youtube'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/day-1.jpg',alt:'Cambridge Education Consultant Kyle Lomer shares his experience on Heymath'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Home - Star Students - Shreyas Kumar',onClick:this.openModal.bind(null,'bRE5tit8zqU'),className:'img-box popup-youtube'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/student4.png',alt:'Shreyas Kumar, Heymath Intern from Harvey Mudd shares his journey experience'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Home - Star Students - Uday Saharia',onClick:this.openModal.bind(null,'KT-uJDOLOvA'),className:'img-box popup-youtube'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/student5.png',alt:'Uday Saharia, Heymath Intern from University of Chicago presents his experience'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Home - Star Students - Varun Ranganathan',onClick:this.openModal.bind(null,'MLyYoLco1eY'),className:'img-box popup-youtube'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/student6.png',alt:'Varun Ranganathan, Heymath User and Intern from SSN College shares his experience'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slider-btns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-button-prev swp-prev',onClick:this.goPrev}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-button-next swp-next',onClick:this.goNext})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_modal_video___default.a,{channel:'youtube',isOpen:this.state.isOpen,videoId:this.videoId,onClose:function onClose(){return _this2.setState({isOpen:false});}}));}}]);return FounderVideos;}(__WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (FounderVideos);

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;

var _warning = __webpack_require__(1211);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(309);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  if (!appElement && !globalElement) {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return false;
  }

  return true;
}

function hide(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).setAttribute("aria-hidden", "true");
  }
}

function show(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).removeAttribute("aria-hidden");
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_id_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal_video__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal_video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal_video__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 className-style
var OtherLearning=function(_PreLoginSessionCheck){_inherits(OtherLearning,_PreLoginSessionCheck);function OtherLearning(){_classCallCheck(this,OtherLearning);var _this=_possibleConstructorReturn(this,(OtherLearning.__proto__||Object.getPrototypeOf(OtherLearning)).call(this));_this.state={isOpen:false};_this.openModal=_this.openModal.bind(_this);_this.goNext=_this.goNext.bind(_this);_this.goPrev=_this.goPrev.bind(_this);return _this;}_createClass(OtherLearning,[{key:'goNext',value:function goNext(){if(this.swiper)this.swiper.slideNext();}},{key:'goPrev',value:function goPrev(){if(this.swiper)this.swiper.slidePrev();}},{key:'openModal',value:function openModal(someValue){this.setState({isOpen:true});this.videoId=someValue;}},{key:'render',value:function render(){var _this2=this;var videoId='';var params={slidesPerView:3,spaceBetween:30,navigation:{nextEl:'.swiper-button-next',prevEl:'.swiper-button-prev',nextButtonCustomizedClass:'.swp-next',prevButtonCustomizedClass:'.swp-prev'},containerClass:'our-learning learning-slider swiper-container swiper-container-horizontal',breakpoints:{480:{slidesPerView:1,spaceBetween:20},640:{slidesPerView:2,spaceBetween:30},768:{slidesPerView:2,spaceBetween:30}}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'mtb whyhm pro-detail student'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'We collaborate closely with teachers'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_id_swiper___default.a,{className:'our-learning learning-slider',breakpoints:params.breakpoints,slidesPerView:params.slidesPerView,spaceBetween:params.spaceBetween,containerClass:params.containerClass,ref:function ref(node){if(node)_this2.swiper=node.swiper;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Our Learnings - We collaborate closely with teachers - Karen Dickey',onClick:this.openModal.bind(null,'MMbIMB1eQ9U'),className:'learn-box popup-youtube collaborate-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/learn1.jpg',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Our Learnings - We collaborate closely with teachers - Maheshwari Natarajan',onClick:this.openModal.bind(null,'RGZ8kSxUi8Y'),className:'learn-box popup-youtube collaborate-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/learn2.jpg',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Our Learnings - We collaborate closely with teachers - Swathi Ashar',onClick:this.openModal.bind(null,'5QyaHbY6EX0'),className:'learn-box popup-youtube collaborate-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/learn3.jpg',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Our Learnings - We collaborate closely with teachers - Ms Jemila',onClick:this.openModal.bind(null,'Yqqb_xHarMQ'),className:'learn-box popup-youtube collaborate-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/learn4.jpg',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Our Learnings - We collaborate closely with teachers - Meena Meyyappan',onClick:this.openModal.bind(null,'c3Z2ty6gwv4'),className:'learn-box popup-youtube collaborate-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/learn5.jpg',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Our Learnings - We collaborate closely with teachers - N Rama Devi',onClick:this.openModal.bind(null,'jKx6LKHFIqs'),className:'learn-box popup-youtube collaborate-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/learn6.jpg',alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slider-btns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-button-prev swp-prev',onClick:this.goPrev}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-button-next swp-next',onClick:this.goNext}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_modal_video___default.a,{channel:'youtube',isOpen:this.state.isOpen,videoId:this.videoId,onClose:function onClose(){return _this2.setState({isOpen:false});}}));}}]);return OtherLearning;}(__WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (OtherLearning);

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_id_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal_video__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal_video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal_video__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var OurTeachers=function(_PreLoginSessionCheck){_inherits(OurTeachers,_PreLoginSessionCheck);function OurTeachers(props){_classCallCheck(this,OurTeachers);var _this=_possibleConstructorReturn(this,(OurTeachers.__proto__||Object.getPrototypeOf(OurTeachers)).call(this,props));_this.state={isOpen:false};_this.openModal=_this.openModal.bind(_this);_this.goNext=_this.goNext.bind(_this);_this.goPrev=_this.goPrev.bind(_this);_this.swiper=null;return _this;}_createClass(OurTeachers,[{key:'goNext',value:function goNext(){if(this.swiper)this.swiper.slideNext();}},{key:'goPrev',value:function goPrev(){if(this.swiper)this.swiper.slidePrev();}},{key:'openModal',value:function openModal(someValue){this.setState({isOpen:true});this.videoId=someValue;console.log(this.videoId);}},{key:'render',value:function render(){var _this2=this;var videoId='';var params={slidesPerView:3,spaceBetween:30,loop:true,navigation:{nextEl:'.swiper-button-next',prevEl:'.swiper-button-prev',nextButtonCustomizedClass:'.swp-next',prevButtonCustomizedClass:'.swp-prev'},breakpoints:{480:{slidesPerView:1,spaceBetween:20},640:{slidesPerView:2,spaceBetween:30},768:{slidesPerView:2,spaceBetween:30}}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'mtb our-student'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,this.rb("ourteachers.heading")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_id_swiper___default.a,{className:'student-slider',slidesPerView:params.slidesPerView,breakpoints:params.breakpoints,loop:params.loop,spaceBetween:params.spaceBetween,ref:function ref(node){if(node)_this2.swiper=node.swiper;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Our Learnings - We collaborate closely with teachers - Karen Dickey',className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box popup-youtube','data-ga':'Home - We collaborate closely with teachers - Karen Dickey',onClick:this.openModal.bind(null,'MMbIMB1eQ9U')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/learn1.jpg',alt:'Karen Dickey, middle school math coordinator for Westport School discusses the partnership between Westport and HeyMath'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Our Learnings - We collaborate closely with teachers - Maheshwari Natarajan',className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box popup-youtube','data-ga':'Home - We collaborate closely with teachers - Maheshwari Natarajan',onClick:this.openModal.bind(null,'RGZ8kSxUi8Y')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/learn2.jpg',alt:'Ms.Maheshwari Nataraja, Vidya Mandir Estancia  principal shares her feedback about HeyMath!'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Our Learnings - We collaborate closely with teachers - Swathi Ashar',className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box popup-youtube','data-ga':'Home - We collaborate closely with teachers - Swathi Ashar',onClick:this.openModal.bind(null,'5QyaHbY6EX0')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/learn3.jpg',alt:'Ms.Swathi Ashar, Bombay International School math co-ordinator shares her feedback'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Our Learnings - We collaborate closely with teachers - Ms Jemila',className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box popup-youtube','data-ga':'Home - We collaborate closely with teachers - Ms Jemila',onClick:this.openModal.bind(null,'Yqqb_xHarMQ')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/learn4.jpg',alt:'Ms.Jemila, GIIS math teacher shares her experience using HeyMath!'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Our Learnings - We collaborate closely with teachers - Meena Meyyappan',className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box popup-youtube','data-ga':'Home - We collaborate closely with teachers - Meena Meyyappan',onClick:this.openModal.bind(null,'c3Z2ty6gwv4')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/learn5.jpg',alt:'Ms.Meena Meyyappan, Honey bunch school, Pollachi shares her comments on HeyMath!'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Our Learnings - We collaborate closely with teachers - N Rama Devi',className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box popup-youtube','data-ga':'Home - We collaborate closely with teachers - N Rama Devi',onClick:this.openModal.bind(null,'jKx6LKHFIqs')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/learn6.jpg',alt:'Ms.N.Rama Devi, Vidya Niketan Public School math teacher shares her feedback about HeyMath!'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slider-btns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-button-prev swp-prev',onClick:this.goPrev}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-button-next swp-next',onClick:this.goNext})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_modal_video___default.a,{channel:'youtube',isOpen:this.state.isOpen,videoId:this.videoId,onClose:function onClose(){return _this2.setState({isOpen:false});}}));}}]);return OurTeachers;}(__WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (OurTeachers);

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/anuradha.4fce8338.png";

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bindu.d0ab4186.png";

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mekhala_balaji.bfcb23ee.png";

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__H_Teams__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__H_Teams___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__H_Teams__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 classNameNameNameName-style
var Founders=function(_PreLoginSessionCheck){_inherits(Founders,_PreLoginSessionCheck);function Founders(props){_classCallCheck(this,Founders);var _this=_possibleConstructorReturn(this,(Founders.__proto__||Object.getPrototypeOf(Founders)).call(this,props));_this.handleMouseOver=_this.handleMouseOver.bind(_this);_this.handleMouseOut=_this.handleMouseOut.bind(_this);return _this;}_createClass(Founders,[{key:'handleMouseOver',value:function handleMouseOver(event){var index=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(event.currentTarget).attr("data-index");__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".caption-"+index).show();}},{key:'handleMouseOut',value:function handleMouseOut(event){var index=__WEBPACK_IMPORTED_MODULE_3_jquery___default()(event.currentTarget).attr("data-index");__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".caption-"+index).hide();}},{key:'alttxtFn',value:function alttxtFn(a,b){return a+", "+b;}},{key:'render',value:function render(){var _this2=this;//console.log("ourTeams:::",ourTeams);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'mtb product-main founder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Our Team'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 row d-flex flex-center'},__WEBPACK_IMPORTED_MODULE_2__H_Teams___default.a.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'profile',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figure',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'profile-pic','data-index':index,style:{color:"#ccc",background:'url("../../images/teamHM/'+element.picture+'")'},role:'img','aria-label':_this2.alttxtFn(element.name,element.desgn),onMouseOver:_this2.handleMouseOver,onMouseOut:_this2.handleMouseOut}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figcaption',{className:"caption-"+index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,element.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,element.desgn))));})))));}}]);return Founders;}(__WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Founders);

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_id_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Ga_js__ = __webpack_require__(123);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 classNameNameNameNameNameName-style
var Recognised=function(_PreLoginSessionCheck){_inherits(Recognised,_PreLoginSessionCheck);function Recognised(){_classCallCheck(this,Recognised);var _this=_possibleConstructorReturn(this,(Recognised.__proto__||Object.getPrototypeOf(Recognised)).call(this));_this.goNext=_this.goNext.bind(_this);_this.goPrev=_this.goPrev.bind(_this);return _this;}_createClass(Recognised,[{key:'goNext',value:function goNext(){if(this.swiper)this.swiper.slideNext();}},{key:'goPrev',value:function goPrev(){if(this.swiper)this.swiper.slidePrev();}},{key:'render',value:function render(){var _this2=this;var params={slidesPerView:3,spaceBetween:30,loop:true,navigation:{nextEl:'.swiper-button-next',prevEl:'.swiper-button-prev',nextButtonCustomizedClass:'.swp-next',prevButtonCustomizedClass:'.swp-prev'},breakpoints:{480:{slidesPerView:1,spaceBetween:20},640:{slidesPerView:2,spaceBetween:30},768:{slidesPerView:2,spaceBetween:30}}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'mtb whyhm prod-detl who-we-btm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'mb-30 rec-heading'},'Our work has been recognised by'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_id_swiper___default.a,{className:'our-learning recogzize-slider outer-padding',breakpoints:params.breakpoints,loop:params.loop,slidesPerView:params.slidesPerView,spaceBetween:params.spaceBetween,ref:function ref(node){if(node)_this2.swiper=node.swiper;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Who we are - Our work has been recognised by - Still eating our lunch',href:'https://www.nytimes.com/2005/09/16/opinion/still-eating-our-lunch.html',target:'_blank',className:'learn-box recognise-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'our-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/recg2.jpg',alt:'Still eating our lunch article published by The New York Times'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'our-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Published by: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'The New York Times')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Still Eating Our Lunch')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Who we are - Our work has been recognised by - How maths can be great fun',href:'http://news.bbc.co.uk/2/hi/south_asia/5203440.stm',target:'_blank',className:'learn-box recognise-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'our-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/recg5.jpg',alt:'How maths can be great fun article published by BBC News'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'our-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Published by: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'BBC News')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'How maths can be great fun')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Who we are - Our work has been recognised by - Lets talk about figures',href:'https://www.economist.com/node/10880471',target:'_blank',className:'learn-box recognise-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'our-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/recg1.jpg',alt:'Lets talk about figures article published by The Economist'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'our-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Published by: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'The Economist')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Let\'s talk about figures')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Who we are - Our work has been recognised by - De-mystifying maths',href:'https://heymath.com/common/spotlight/2008/timesofindia_may08.pdf',target:'_blank',className:'learn-box recognise-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'our-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/recg3.jpg',alt:'De-Mystifying Math article published by Education Times'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'our-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Published by: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Education Times')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'De-mystifying Math')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Who we are - Our work has been recognised by - Hey, math can be great fun',href:'https://heymath.com/common/spotlight/2007/outlook.jpg',target:'_blank',className:'learn-box recognise-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'our-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/recg4.jpg',alt:'Hey, Math can be great fun published by Outlook Business'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'our-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Published by: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Outlook Business')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Hey, Math can be great fun'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slider-btns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-button-prev swp-prev btn-p-blk',onClick:this.goPrev}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-button-next swp-next btn-n-blk',onClick:this.goNext}))))));}}]);return Recognised;}(__WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Recognised);

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_id_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal_video__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal_video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal_video__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var VideoComponent=function(_PreLoginSessionCheck){_inherits(VideoComponent,_PreLoginSessionCheck);function VideoComponent(props){_classCallCheck(this,VideoComponent);var _this=_possibleConstructorReturn(this,(VideoComponent.__proto__||Object.getPrototypeOf(VideoComponent)).call(this,props));_this.state={isOpen:false};_this.openModal=_this.openModal.bind(_this);_this.goNext=_this.goNext.bind(_this);_this.goPrev=_this.goPrev.bind(_this);_this.swiper=null;return _this;}_createClass(VideoComponent,[{key:'goNext',value:function goNext(){if(this.swiper)this.swiper.slideNext();}},{key:'goPrev',value:function goPrev(){if(this.swiper)this.swiper.slidePrev();}},{key:'openModal',value:function openModal(someValue){this.setState({isOpen:true});this.videoId=someValue;console.log(this.videoId);}},{key:'render',value:function render(){var _this2=this;var videoId='';var params={slidesPerView:1,spaceBetween:30,loop:false,navigation:{nextEl:'.swiper-button-next',prevEl:'.swiper-button-prev',nextButtonCustomizedClass:'.swp-next',prevButtonCustomizedClass:'.swp-prev'},breakpoints:{480:{slidesPerView:1,spaceBetween:20},640:{slidesPerView:1,spaceBetween:30},768:{slidesPerView:1,spaceBetween:30}}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'mtb video-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Home - How HeyMath! really empowers Tutors and Teachers',className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box popup-youtube single-video',onClick:this.openModal.bind(null,'IA_Pal7iRmE')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/teacherBanner.jpg',alt:'How HeyMath! really empowers Tutors and Teachers'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_modal_video___default.a,{channel:'youtube',isOpen:this.state.isOpen,videoId:this.videoId,onClose:function onClose(){return _this2.setState({isOpen:false});}}));}}]);return VideoComponent;}(__WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__["a" /* default */]);/* unused harmony default export */ var _unused_webpack_default_export = (VideoComponent);

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BuyOption_js__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VideoComponent_js__ = __webpack_require__(498);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var TeacherBuy=function(_PreLoginSessionCheck){_inherits(TeacherBuy,_PreLoginSessionCheck);function TeacherBuy(props){_classCallCheck(this,TeacherBuy);var _this=_possibleConstructorReturn(this,(TeacherBuy.__proto__||Object.getPrototypeOf(TeacherBuy)).call(this,props));_this.productDetails=localStorage.getItem('proDetail');_this.getBuyOptions=_this.getBuyOptions.bind(_this);return _this;}_createClass(TeacherBuy,[{key:'getProductDetails',value:function getProductDetails(){//console.log(JSON.parse(this.productDetails));
if(this.productDetails!={}&&this.productDetails!=undefined){return JSON.parse(this.productDetails);}else{return{};}}},{key:'componentDidMount',value:function componentDidMount(){/* var clsName=this.removeWhiteSpace(this.getProductDetails()[this.props.id].ClassName)
		this.setTitle(clsName+"_title");
		this.setMeta(clsName+"_meta");
		this.setHeading(clsName+"_heading"); */}},{key:'getBuyOptions',value:function getBuyOptions(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BuyOption_js__["a" /* default */],{showContactus:this.props.showContactus,id:this.props.id,triedFree:this.props.triedFree,purchased:this.props.purchased,showSubScripeLoginForm:this.props.showSubScripeLoginForm,productBase:this.props.productBase,simpleform:this.props.simpleform,role:"TCHR"});}},{key:'render',value:function render(){//var classname = this.getProductDetails()[this.props.id].ClassName;
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'mtb yellow-child'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container tchrbuy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.rb("Tchrcomp.subheading"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.rb("Tchrcomp.subheading1"))));}}]);return TeacherBuy;}(__WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (TeacherBuy);

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SpotlightBanner__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion_dist_fancy_example_css__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion_dist_fancy_example_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion_dist_fancy_example_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// 'Fancy' theme - boilerplate styles for all components, as seen on our demo:
// ES6 class-style
var FAQ=function(_PreLoginPage){_inherits(FAQ,_PreLoginPage);function FAQ(props){_classCallCheck(this,FAQ);var _this=_possibleConstructorReturn(this,(FAQ.__proto__||Object.getPrototypeOf(FAQ)).call(this,props));_this.product=_this.product.bind(_this);_this.regandlogin=_this.regandlogin.bind(_this);_this.pricing=_this.pricing.bind(_this);//this.handleChange=this.handleChange.bind(this);
return _this;}_createClass(FAQ,[{key:'componentDidMount',value:function componentDidMount(){this.setTitle("FAQ_title");this.setMeta("FAQ_meta");this.setHeading("FAQ_heading");}},{key:'handleChange',value:function handleChange(id){//console.log("Accordian changed ",id);
if(__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#matericon'+id).hasClass("minus")){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#matericon'+id).removeClass("minus");__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#matericon'+id).addClass("plus");__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#matericon'+id).html('<i class="material-icons">add</i>');}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#matericon'+id).removeClass("plus");__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#matericon'+id).addClass("minus");__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#matericon'+id).html('<i class="material-icons">remove</i>');}}},{key:'product',value:function product(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItem"],{expanded:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItemTitle"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'1. Product ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'matericon1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'add'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItemBody"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faqcnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'blustr'},'1.1) How does HeyMath! Work?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'HeyMath! assures continuous progress from wherever your child is in his or her Math learning journey. We cover everything from counting to calculus.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtindent'},'Our program helps')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'1. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Develop an interest in Maths')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'2. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Build a positive attitude toward learning')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'3. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Become a self-directed independent learner')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faqcnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'blustr'},'1.2) How can HeyMath! help me as a parent?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Through HeyMath!, you are armed with a granular report card and in-depth insights of your child\u2019s Math performance that help you truly guide your child.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faqcnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'blustr'},'1.3) How is HeyMath! different from tuitions?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'1. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'You will be able to move at your own pace every day at your home')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'2. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'You can align your practice and revision schedule to the school\u2019s academic calendar')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faqcnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'blustr'},'1.4) How many hours should my child spend every day on HeyMath!?'),'We believe Math is not a spectator sport. We recommended you spend 20 minutes a day going through our lessons and practice.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faqcnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'blustr'},'1.5) I am unaware where my child stands when it comes to Math. Can HeyMath! help?'),'Absolutely. Encourage your child to take free diagnostic tests available for grades 5 to 10. You will get a detailed report card on your child\u2019s strengths and weaknesses.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faqcnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'blustr'},'1.6) What are Self-Paced Lessons?'),'In the Self-Paced Lessons modules for grades 1 to 4, you will get video lessons aligned to CBSE curriculum. You will also get access to many solved examples, interactive activities and quizzes to check your understanding. Our lessons build vocabulary, comprehension skills and inculcate Mathematical thinking. Also, we have infused proven pedagogies from Singapore\u2019s world-class education system and adapted them for CBSE, ICSE and local boards.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faqcnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'blustr'},'1.7) Why and what is Personalised Learning?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtindent'},'Personalised Learning is a real alternative to tuitions',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'1. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Teachers do not have the luxury of time to \u2018bridge learning gaps\u2019 from previous years nor do they find it feasible to provide individual attention to each student')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'2. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Over time, some students start developing anxieties due to poor performance in tests.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'3. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'You end up resorting to tuitions; which also doesn\u2019t necessarily resolve the problem'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Personalised Learning is customised for each student, diagnoses de\uFB01ciencies at a granular level and bridges learning gaps through recommended lessons and targeted practice. With regular usage of PLP, students are sure to do better in school tests'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faqcnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'blustr'},'1.8) I want to know more about HeyMath! Can I speak with someone from HeyMath?'),'You can call/Whatsapp us at ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'whatsapp'},'+91 9884400755'),' or email us at ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'support@heymath.com'},'support@heymath.com')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faqcnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'blustr'},'1.9) I am the Principal/Founder/Trustee etc of a school and I want HeyMath! Implementation in my school. Who should I contact?'),'Please write a mail to ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'support@heymath.com'},'support@heymath.com'),' and we will contact you for the implementation.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faqcnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'blustr'},'1.10) What are the supported devices for HeyMath?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtindent'},'For users enrolled through school (including teachers/tutors who have independently registered), we recommend accessing HeyMath! on desktop/laptop ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'For users who have independently registered,'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'1. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Classes 1-4: we recommend using on desktop/laptop')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'2. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Classes 5-10: available for use on all devices'))))));}},{key:'regandlogin',value:function regandlogin(){var telPhoneNo=window.telPhoneNo[this.getGeo()]||window.telPhoneNo['OTHERS']||'+91 44 3500 2073';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItemTitle"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'2. Registration & Login ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'matericon2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'add'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItemBody"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faqcnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'blustr'},'2.1) How do I Sign-up?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'1. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Click on Sign In button at the top right corner.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'2. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Click on \'Users who have independently registered\'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'3. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Choose either \'Sign In with Google\' or \'Create an Account\'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'4. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Only for users who choose to \'Create an Account\':',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'a.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Fill in the details and verify your email ID by clicking on \u201CVerify Passcode\u201D')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'b.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Enter the 6-digit Passcode that has been sent to your Email ID')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'c.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Click Sign In')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'5. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Choose the grade in the \u2018Classes page\u2019 or directly choose your grade from the drop-down on the Classes tab')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'6. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Choose \u2018Subscribe\u2019 or \u2018Start a Free trial\u2019')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faqcnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'blustr'},'2.2) How do I start a free trial HeyMath after signing up?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'1. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Login with your User ID and password chosen while signing up. In case you signed-up with your Google account, your email ID is the User ID')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'2. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Choose the grade in the \u2018Classes page\u2019 or directly choose your grade from the drop-down on the Classes tab')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'3. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'In the respective grade page, choose \'Free Trial\'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'4. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Click on \'My HeyMath\' to access HeyMath! content after starting a free trial')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faqcnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'blustr'},'2.3) I have a HeyMath! user ID and password from my school. How do I sign in?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'1. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Click on the Sign-In button on the top right corner of the screen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'2. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Click on \u201CUsers enrolled through school\u201D (the green card)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'3. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Enter the school provided user ID and password')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faqcnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'blustr'},'2.4) What can I do if I have forgotten my password?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'1. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Click on \'Sign-In\' at the top right corner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'2. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Choose the right option to proceed: \'Users enrolled through HeyMath!\' or \'Users who have independently registered\'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'3. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Click on \'Forgot Password\' above \'Sign-In\' button')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'4. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'For users who got received their ID from school',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'a.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Enter your registered email ID, the User ID given by the school and click on \'Send\u2019')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'b.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'We will share a new password on email'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtindent'},'Note: If your email ID is not registered, please write an email to ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'support@heymath.com'},'support@heymath.com')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'5. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'For users who subscribed to HeyMath! on their own',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'a.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Enter your email ID/mobile number and click on \'Send OTP\'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'b.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Enter the OTP in \'Enter OTP\' field and click on \'Verify\'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'c.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Now reset your password and start accessing HeyMath!')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faqcnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'blustr'},'2.5) How do I subscribe to HeyMath! for two children?'),'We advise subscribing to a distinct account for each child to ensure simultaneous access to HeyMath! To do this, you can subscribe using your mobile number for one account and email ID for the other account. Alternatively, you could use 2 mobile numbers and/or 2 email ids.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faqcnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'blustr'},'2.6) How do I reset my password?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtindent'},'For users who independently registered:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'1. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'After logging-in, click on \u2018My Account\u2019 icon at the top right corner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'2. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'In the drop-down, choose \u2018My Profile\u2019')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'3. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Fill-in your old password and the new password you want')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'4. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Click on \u2018Save\u2019'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtindent'},'For users who enrolled through school'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'1. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'After logging-in, click on \u2018My Account\u2019 icon at the top right corner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'2. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'In the drop-down, choose \u2018Profile\u2019')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'3. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Fill in the new password that you want')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'4. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Click on \u2018Save\u2019')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faqcnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'blustr'},'2.7) What is the helpline number for HeyMath?'),'The helpline is ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'whatsapp'},telPhoneNo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faqcnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'blustr'},'2.8) What is the helpline email ID for HeyMath?'),'The helpline email ID is ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'support@heymath.com'},'support@heymath.com'))));}},{key:'pricing',value:function pricing(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItem"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItemTitle"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'3. Pricing ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'matericon3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'add'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["AccordionItemBody"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faqcnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'blustr'},'3.1) Can I use HeyMath! for free?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Joining HeyMath! is absolutely free. Students in grades 5 to 10 can take FREE mini diagnostic tests across all curriculum topics and view a detailed report card of their performance. To receive personalised study plans, you will need to upgrade to a paid subscription of Rs. 2999 per year. Students in grades 1 to 4 can try our self paced lessons FREE for 30 days to experience our engaging teaching methodology. To access the full curriculum with quizzes, you will need to upgrade to a paid subscription of Rs. 1499 per year.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faqcnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'blustr'},'3.2) My child is going to the next class in a few months. Can I purchase a monthly subscription instead of an annual one?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'We currently do not have a monthly subscription. You can email us once your child has gone to the next class. We will, then, shift your child\u2019s subscription to the next class.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Note: Only for students in classes 1 to 3 and in classes 5 to 9')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faqcnt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'blustr'},'3.3) What are the payment options?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'There are multiple payment options. You can pay using Credit/debit cards/netbanking/wallets/paytm etc.'))));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'FAQ'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SpotlightBanner__["a" /* default */],{title:this.rb("FAQ.title")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faqaccord'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["Accordion"],{onChange:this.handleChange.bind(this,1)},this.product()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["Accordion"],{onChange:this.handleChange.bind(this,2)},this.regandlogin()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_accessible_accordion__["Accordion"],{onChange:this.handleChange.bind(this,3)},this.pricing())))));}}]);return FAQ;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (FAQ);

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FlipBox__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_UserStorageUtil__ = __webpack_require__(33);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SampleLessonLayout=function(_PreLoginPage){_inherits(SampleLessonLayout,_PreLoginPage);function SampleLessonLayout(props){_classCallCheck(this,SampleLessonLayout);var _this=_possibleConstructorReturn(this,(SampleLessonLayout.__proto__||Object.getPrototypeOf(SampleLessonLayout)).call(this,props));_this.state={};_this.openLesson=_this.openLesson.bind(_this);return _this;}_createClass(SampleLessonLayout,[{key:'openLesson',value:function openLesson(event){var lesIndex=event.currentTarget.dataset.index;var samplesLessons=Object.values(this.props.sampleLessons);//console.log("tchr sample ",samplesLessons[lesIndex]);
var lessonidTracking=samplesLessons[lesIndex].lessonUrl;var lessonid=samplesLessons[lesIndex].lessonUrl;var lessonname=samplesLessons[lesIndex].lessonName;var lurl=samplesLessons[lesIndex].lessonUrl;var dd=0;var lessonPref=null;var testid=null;var topicSubTopicMapId=null;var accessId=null;var classId=null;var snippetId="";var source=0;var lessonviewRoute="/openlessonview";if(this.props.PLPloggedIn||this.props.PLPloggedIn=="true"){lessonviewRoute="/lessonview";}var _url=lessonviewRoute+"/"+lessonid+"?url="+lurl+"&lessonPref="+lessonPref+"&testid="+testid+"&revisiontopicid="+topicSubTopicMapId+"&accessId="+accessId+"&classId="+classId+"&src=plp"+"&lessonidTracking="+lessonidTracking+"&tracksource="+this.props.tracksource+"&snid="+snippetId+"&qsrc="+source;if(dd>0){_url+="&dd="+dd;}__WEBPACK_IMPORTED_MODULE_4__util_UserStorageUtil__["a" /* default */].storeSessionItem(lurl,lessonname);//console.warn("tchr sampleUrl ",_url);
window.open(_url,lessonid,'fullscreen=yes,menubar=no,width='+window.innerWidth+',height='+window.innerHeight).focus();}//sampleLesson.url,sampleLesson.lessonUrl,sampleLesson.lessonName
},{key:'getSampleLessonComp',value:function getSampleLessonComp(sampleLesson,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-md-12',key:i},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'sample-les samplelessonbox','data-index':i,onClick:this.openLesson},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'sampl-img lessonthumb'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:"/"+sampleLesson.image,alt:"/"+sampleLesson.lessonName+" - HeyMath! lesson"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'play-btn'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'sampl-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,sampleLesson.lessonName),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,sampleLesson.description)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clear'}))));}},{key:'render',value:function render(){var me=this;var samplesLessons=this.props.sampleLessons||{};try{if(samplesLessons.length!=0){this.stitle=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',{className:'tchr-lessons'},'Sample Lessons');}}catch(e){}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'SampleLessonLayout'},this.stitle,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},Object.keys(samplesLessons).map(function(v,i){return me.getSampleLessonComp(samplesLessons[i],i);})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'productFlipbox'},' '));}}]);return SampleLessonLayout;}(__WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (SampleLessonLayout);

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BillingForm__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_purchase_TchrOrderReview__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_HmEventRegistry__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var paymentErrorMap={"TXN_ERR_001":"Transaction not saved","TXN_ERR_002":"Transaction failed","TXN_ERR_003":"Field does not meet the minimum length","TXN_ERR_004":"Field exceeds the maximum length","TXN_ERR_005":"Space not allowed in the field","TXN_ERR_006":"Should be Alphanumeric Only","TXN_ERR_007":"Should contain Alphanumeric and permitted characters only","TXN_ERR_008":"Should contain Alphabets Only","TXN_ERR_009":"Should contain Numbers Only","TXN_ERR_010":"Should contain Numbers and dot (.)","TXN_ERR_011":"Contains Invalid Characters","TXN_ERR_012":"Should contain Alpabets and characters only","TXN_ERR_013":"Invalid parameter","TXN_ERR_014":"Invalid Transaction amount","TXN_ERR_015":"System Error"};var TchrBillingForm=function(_BillingForm){_inherits(TchrBillingForm,_BillingForm);function TchrBillingForm(props){_classCallCheck(this,TchrBillingForm);var _this=_possibleConstructorReturn(this,(TchrBillingForm.__proto__||Object.getPrototypeOf(TchrBillingForm)).call(this,props));_this.submitForm=function(){this.userId=this.getUserId();var me=this;var userExists=String(me.state.existing_userid);//console.log("userExists ==> ",userExists, "type : ",typeof userExists);
//Setting payLoad
//me.payload={"schoolId":me.purchaseObj.productCategory,"validTo":me.purchaseObj.validTo,"userName":me.state.billing_name,"userExists":userExists,"role":"TCHR","grade":"TCHR"};
me.payload={"trackId":me.props.trackId};var payloadStr=JSON.stringify(me.payload);//abdul
var formData={userId:me.getUserId(),appName:this.purchaseObj.appName,_appId:this.purchaseObj.appId,sessionId:this.state.sessionId,fullName:this.state.billing_name,address:this.state.billing_address,zip:this.state.billing_zipcode,city:this.state.billing_city,state:this.state.billing_state,countryCode:this.state.selectedCountryOption.value||"",country:this.state.selectedCountryOption.label||"",email:this.state.billing_email,phone:this.state.billing_phone,language:'EN',productList:[{"productId":me.purchaseObj.productId,"productCategory":me.purchaseObj.productCategory,"price":me.purchaseObj.productPrice,"currency":me.purchaseObj.currency,"validity":me.purchaseObj.validity,"tariffId":me.purchaseObj.productTariffID,"count":1}],currency:this.purchaseObj.currency,payload:payloadStr};var productList=[{"productId":me.purchaseObj.productId,"productCategory":me.purchaseObj.productCategory,"price":me.purchaseObj.productPrice,"currency":me.purchaseObj.currency,"validity":me.purchaseObj.validity,"tariffId":me.purchaseObj.productTariffID,"count":1}];var opsCart=Object.assign({},formData,{productList:JSON.stringify(productList)});var submitFormFields=opsCart;var paymentSubmitElem=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#doPayForm');me.fillForm(paymentSubmitElem,submitFormFields);__WEBPACK_IMPORTED_MODULE_3_jquery___default.a.ajax({url:this.getUrlFor("OPS_FORM_VALIDATION"),data:__WEBPACK_IMPORTED_MODULE_3_jquery___default()(paymentSubmitElem).serializeArray(),type:'POST',xhrFields:{withCredentials:true},crossDomain:true,success:function success(response){if(response!==null){if(response.formValid){me.setState({serverMessage:''});//me.doPay();
me.showOrderReview();}else if(response.errorMsgs!=null){var errmsg="";if(response.fieldErrMap!=null){for(var key in response.fieldErrMap){var msg=paymentErrorMap[response.fieldErrMap[key].split(":")[0]];errmsg+=key+" : "+msg;}}me.setState({serverMessage:errmsg});}else{me.setState({serverMessage:'Sorry, we\'re unable to process your registration. Please try again later.'});}}//console.log("response : ", response);
},error:function error(response){console.log("Error in OPS_FORM_VALIDATION");}});};_this.sessionId=null;return _this;}_createClass(TchrBillingForm,[{key:'componentDidMount',value:function componentDidMount(){_get(TchrBillingForm.prototype.__proto__||Object.getPrototypeOf(TchrBillingForm.prototype),'componentDidMount',this).call(this);}},{key:'existingUserId',value:function existingUserId(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}},{key:'newUserId',value:function newUserId(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}},{key:'setSessionId',value:function setSessionId(sessionId){this.sessionId=sessionId;}},{key:'doPay',value:function doPay(){var me=this;me.userId=me.getUser().getUserId();var payloadStr=JSON.stringify(me.payload);this.trackMe();var formData={userId:me.getUserId(),appName:me.purchaseObj.appName,_appId:me.purchaseObj.appId,sessionId:this.state.sessionId,fullName:this.state.billing_name,address:this.state.billing_address,zip:this.state.billing_zipcode,city:this.state.billing_city,state:this.state.billing_state,countryCode:this.state.selectedCountryOption.value||"",country:this.state.selectedCountryOption.label||"",email:this.state.billing_email,phone:this.state.billing_phone,billingAddressLine1:this.state.billing_address,billingAddressLine2:this.state.billing_address,language:"EN",currency:me.purchaseObj.currency,payload:payloadStr};var productList=[{"productId":me.purchaseObj.productId,"productCategory":me.purchaseObj.productCategory,"price":me.purchaseObj.productPrice,"currency":me.purchaseObj.currency,"validity":me.purchaseObj.validity,"tariffId":me.purchaseObj.productTariffID,"count":1}];var opsCart=Object.assign({},formData,{productList:JSON.stringify(productList)});var submitFormFields=opsCart;var paymentSubmitElem=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#doPayForm');me.fillForm(paymentSubmitElem,submitFormFields);__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#paySubmit").trigger("click");try{var gradeName=me.purchaseObj.gradeName.toLowerCase().replace(/\s/g,'')||'';var productName=me.purchaseObj.productName.toLowerCase().replace(/\s/g,'')||'';this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":gradeName+"-"+productName+"-purchased"});}catch(e){console.error(e);}return;//new HmAjax(this.getUrlFor("OPS_DO_PAY"),fd,headers).post(callBackSuccess,callBackFailure);
}},{key:'getUserId',value:function getUserId(){return this.getUser().getUserId();}},{key:'getOPSHome',value:function getOPSHome(){var me=this;//console.log(me.productsJson,me.purchaseObj.tarrrifid,me.purchaseObj.productid);
//console.log(me.productsJson[me.purchaseObj.productid]);
if(me.purchaseObj){//IMPORTANT: This component needs to be extended to make the following parameters dynamic
var formData={appName:me.purchaseObj.appName,_appId:me.purchaseObj.appId,sFrame:me.getUrlFor("PAYMENT_SUCCESS_URL"),fFrame:me.getUrlFor("PAYMENT_FAILURE_URL"),pcsUrl:me.getUrlFor("PAYMENT_PCS_URL"),pcfUrl:me.getUrlFor("PAYMENT_PCF_URL"),currency:me.purchaseObj.currency};var productList=[{"productId":me.purchaseObj.productId,"productCategory":me.purchaseObj.productCategory,"price":me.purchaseObj.productPrice,"currency":me.purchaseObj.currency,"validity":me.purchaseObj.validity,"tariffId":me.purchaseObj.productTariffID,"count":1}];var opsCart=Object.assign({},formData,{productList:JSON.stringify(productList)});var me=this;__WEBPACK_IMPORTED_MODULE_3_jquery___default.a.ajax({url:this.getUrlFor("OPS_PROCESSPAY"),data:opsCart,type:'POST',xhrFields:{withCredentials:true},crossDomain:true,success:function success(response){if(response!=null){//alert("sessionid="+response.sessionId)
me.setSessionId(response.sessionId);if(response.currency){if(response.allTaxRules&&response.allTaxRules.length>0){for(var i=0;i<response.allTaxRules.length;i++){var tempObj={};if(me.taxRules[response.allTaxRules[i].geo]){tempObj=me.taxRules[response.allTaxRules[i].geo];}tempObj[response.allTaxRules[i].currency]=response.allTaxRules[i];me.taxRules[response.allTaxRules[i].geo]=tempObj;}}me.setState({sessionId:response.sessionId,opsReady:true,opsCheckDone:true});me.updatePrice();}else{me.setState({opsReady:false,opsCheckDone:true,errorMsg:'Sorry, we\'re unable to process your registration. Please try again later.'});}}//console.log("response : ", response);
},error:function error(response){console.log("Error in OPS_PROCESSPAY");me.setState({opsReady:false,opsCheckDone:true,errorMsg:'Sorry, we\'re unable to process your registration. Please try again later.'});}});}//new HmAjax(this.getUrlFor("OPS_PROCESSPAY"),opsCart,headers).post(callBackSuccess,callBackFailure);
}},{key:'getOrderReview',value:function getOrderReview(){var me=this;//console.warn("tchr products review",this.purchaseObj.basePrice);
var reviewData={userId:me.getUserId(),fullName:me.state.billing_name,address:me.state.billing_address,zip:me.state.billing_zipcode,city:me.state.billing_city,state:me.state.billing_state,country:me.state.selectedCountryOption.label||"",phone:me.state.billing_phone,email:me.state.billing_email,billingAddressLine1:me.state.billing_address,billingAddressLine2:me.state.billing_address,currency:me.purchaseObj.currency,validity:me.purchaseObj.validity=="365"?"1 Year":me.purchaseObj.validity,productName:me.purchaseObj.productName,price:me.purchaseObj.productPrice,taxAmount:me.state.taxAmount,totalAmount:me.state.prod_price,basePrice:me.state.basePrice||me.purchaseObj.basePrice,otherCharges:me.state.otherCharges,selectedProductCategoryType:me.purchaseObj.productCategory,selectedProductCategoryTypeGA:me.purchaseObj.productCategory+"-GA",selectedProductClassName:me.purchaseObj.gradeName};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__views_purchase_TchrOrderReview__["a" /* default */],{hideReviewModal:this.hideReviewModal,reviewData:reviewData,proceedPay:this.proceedPay});}},{key:'handleSubmit',value:function handleSubmit(e){e.preventDefault();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){this.submitForm();}//this.showOrderReview();
}},{key:'render',value:function render(){return _get(TchrBillingForm.prototype.__proto__||Object.getPrototypeOf(TchrBillingForm.prototype),'render',this).call(this);}}]);return TchrBillingForm;}(__WEBPACK_IMPORTED_MODULE_1__BillingForm__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (TchrBillingForm);

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__images_coupon_gift_box_lg_png__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__images_coupon_gift_box_lg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__images_coupon_gift_box_lg_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_CouponCode_css__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_CouponCode_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_CouponCode_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_plp_TestTakingModalComponent__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_coupon_teachersday_png__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_coupon_teachersday_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_coupon_teachersday_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CouponCodeModel=function(_PreLoginPage){_inherits(CouponCodeModel,_PreLoginPage);function CouponCodeModel(props){_classCallCheck(this,CouponCodeModel);var _this=_possibleConstructorReturn(this,(CouponCodeModel.__proto__||Object.getPrototypeOf(CouponCodeModel)).call(this,props));_this.submitForm=function(){if(this.state.plp_userinput.length<=0){return;}var formData={"couponCode":this.state.plp_userinput,"category":this.getUser().getUserOrigin()};this.setState({submitButtonDisabled:true});var me=this;var callBackSuccess=function callBackSuccess(response){if(response!==null){console.log("response : ",response);if(response.status=="valid"){if(response.body){var callBackParent=function callBackParent(){me.hideSubscribeModal();me.props.callBackParent(response.body);__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".userlogintypeformgroup .plp_userinput.form-control").attr({'style':'border:2px solid #28a745 !important'});me.setState({submitButtonDisabled:true,serverMessage:me.rb("couponcode.success"),SubscribeModal:false,valid:true});__WEBPACK_IMPORTED_MODULE_3_jquery___default()('html, body').animate({scrollTop:__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".CouponCodeBoxLayout").offset().top},200);};me.setAttribute(me.getAttributePrefix()+"couponcode",formData.couponCode,callBackParent);//me.removeAttribute("couponcode");
}}else if(response.status=="forbidden"||response.status=="failure"){if(response.message=="invalid_coupon"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("couponcode.validpromo")});}else if(response.message=="coupon_expired"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("couponcode.coupon_expired")});}else if(response.message=="error_communicating_centa"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("couponcode.comm_error")});}else if(response.message=="internal_error_occurred"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("couponcode.coupon_expired")});}else{if(response.message.match("max_usage_limit_reached")>-1){me.setState({submitButtonDisabled:false,serverMessage:me.rb(response.message)});}else{me.setState({submitButtonDisabled:false,serverMessage:me.rb(response.message)});}}__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".userlogintypeformgroup .plp_userinput.form-control").attr({'style':'border:2px solid #dc3545 !important'});}if(!me.props.couponCodeTracked){me.couponTrackInit(response);}}};var callBackFailure=function callBackFailure(response){//console.log("response : ", response);
me.setState({submitButtonDisabled:false});};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("GET_COUPON_STATUS"),formData).post(callBackSuccess,callBackFailure);};_this.state={SubscribeModal:false,loginMaxLength:30,submitButtonDisabled:false,serverMessage:'',plp_userinput:props.couponCode||'',valid:false};_this.handleSubmit=_this.handleSubmit.bind(_this);_this.autohandleSubmit=_this.autohandleSubmit.bind(_this);_this.hideSubscribeModal=_this.hideSubscribeModal.bind(_this);_this.showSubscribemodal=_this.showSubscribemodal.bind(_this);_this.handleChange=_this.handleChange.bind(_this);_this.userIdChange=_this.userIdChange.bind(_this);_this.submitForm=_this.submitForm.bind(_this);_this.autoSubmitFn=_this.autoSubmitFn.bind(_this);_this.couponTrackInit=_this.couponTrackInit.bind(_this);return _this;}_createClass(CouponCodeModel,[{key:'componentDidMount',value:function componentDidMount(){this.setState({plp_userinput:this.props.couponCode,SubscribeModal:this.props.SubscribeModal});}/**
    * IMPORTANT:This method gets the attribute prefix based on the product catalogue.
    * If it weren't for this method, all Product Catalogue will share the same CouponCode
    */},{key:'getAttributePrefix',value:function getAttributePrefix(){return this.props.couponPrefix?this.props.couponPrefix+"-":"-";}},{key:'couponTrackInit',value:function couponTrackInit(response){var me=this;var trackObj={"couponCode":me.state.plp_userinput||null,"valid":response&&response.status==="valid"||false};var success=function success(resp){var trackId=resp&&resp.trackId?resp.trackId:0;if(trackId>0&&typeof me.props.setTrackId==="function"){me.props.setTrackId(trackId,trackObj.valid);}};var failure=function failure(err){console.warn("Coupon Init track failed :",err);};if(!trackObj.valid){__WEBPACK_IMPORTED_MODULE_9__model_HmEventRegistry__["a" /* default */].fireEvent("COUPON_TRACK_CREATE",trackObj,success,failure);}}},{key:'handleChange',value:function handleChange(e){var _setState;var target=e.currentTarget;this.form.validateFields(target);this.setState((_setState={},_defineProperty(_setState,target.name,target.value),_defineProperty(_setState,'submitButtonDisabled',!this.form.isValid()),_setState));}},{key:'userIdChange',value:function userIdChange(e){var target=e.currentTarget;this.handleChange(e);this.setState({submitButtonDisabled:false,serverMessage:''});__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".userlogintypeformgroup .plp_userinput.form-control").attr({'style':'border:2px solid #66666645 !important'});__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".userlogintypeformgroup .form-control-feedback").hide();}},{key:'handleSubmit',value:function handleSubmit(e){var me=this;e.preventDefault();__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".userlogintypeformgroup .form-control-feedback").show();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){me.autoSubmitFn();}}},{key:'autohandleSubmit',value:function autohandleSubmit(){var me=this;__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".userlogintypeformgroup .form-control-feedback").show();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){me.autoSubmitFn();}}},{key:'autoSubmitFn',value:function autoSubmitFn(){var me=this;var userLoggedIn=me.getUser().getUserId()&&me.getUser().getUserId().length>0?true:false;var tempFunc=function tempFunc(){if(typeof me.props.postLoginCallBack==="function"){me.props.postLoginCallBack();}userLoggedIn=me.getUser().getUserId()&&me.getUser().getUserId().length>0?true:false;me.submitForm();};if(!userLoggedIn){//me.setState({SubscribeModal:false});
if(typeof this.props.showSubscriptionForm==="function"){//var gradeName = (productObj.gradeName).toLowerCase().replace(/\s/g,'') || '';
//var productName = (productObj.productName).toLowerCase().replace(/\s/g,'') || '';
this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"couponcode-applybtn"});this.props.showSubscriptionForm(tempFunc);}}else{tempFunc();}}},{key:'hideSubscribeModal',value:function hideSubscribeModal(){this.setState({SubscribeModal:false});this.props.hideSubscribeModal();}},{key:'showSubscribemodal',value:function showSubscribemodal(){this.setState({SubscribeModal:true});}},{key:'renderCouponBody',value:function renderCouponBody(){var me=this;var centaRef=false;var userLoggedIn=false;var userOrigin='';var AllowUserOrigin=false;var couponcode=this.getAttribute(this.getAttributePrefix()+"couponcode")||'';try{var refUrl=document.referrer;centaRef=me.callByReferer(refUrl);userLoggedIn=this.getUser().getUserId()&&this.getUser().getUserId().length>0?true:false;userOrigin=this.getUser().getUserOrigin();AllowUserOrigin=me.callByOrigin(userOrigin);}catch(e){console.error("Error occurred while couponcode",e);}if(centaRef&&!userLoggedIn||AllowUserOrigin&&userLoggedIn&&couponcode===""){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,this.rb("centa.heading")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__images_coupon_gift_box_lg_png___default.a,alt:"tchr_prod"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,this.rb("centa.info"),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',this.rb("centa.info1"),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'discounttxt'},' ',this.rb("centa.info2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.rb("centa.info3")));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10__images_coupon_teachersday_png___default.a,className:'fordefault',alt:"tchr_prod"}));}}},{key:'callByReferer',value:function callByReferer(url){var couponTrackers=window.couponTrackers||{};if(url&&couponTrackers){for(var i in couponTrackers){if(url.match(i)){return true;}}}return false;}},{key:'callByOrigin',value:function callByOrigin(origin){var originCenta=window.originCenta||[];if(origin&&origin.length>1&&originCenta&&originCenta.length>0){return~originCenta.indexOf(origin)?true:false;}return false;}},{key:'renderCouponForm',value:function renderCouponForm(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'couponcodeId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nopadding coupontypeContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this2.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-12 userlogintyperoot'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'plp_userinput',className:'userlogintypeformgroup'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'plp_userinput',className:"plp_userinput userlogintype ",name:'plp_userinput',placeholder:this.rb("centa.coupon.code_paceholder"),pattern:'^[A-Za-z0-9_]*$',value:this.state.plp_userinput,onChange:this.userIdChange,required:true,minLength:1,maxLength:this.state.loginMaxLength,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'plp_userinput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons errinfoicon'},'info'),' ',this.rb("couponcode.promorequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons errinfoicon'},'info'),' ',this.rb("couponcode.patternmismatch")),function(){if(!_this2.state.valid){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages'},_this2.state.serverMessage);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages success'},_this2.state.serverMessage);}}()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-ga':"Home - "+this.props.from+" Home- Join",disabled:this.state.submitButtonDisabled,className:'joinButton'},this.rb("couponcode.apply"))))))));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'couponCode'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__views_plp_TestTakingModalComponent__["a" /* default */],{visible:this.state.SubscribeModal,dialogClassName:"fullwidthdiag grademodal modal-sm"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-title'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close helpClose',onClick:this.hideSubscribeModal,'aria-label':'Close'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'close')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',_defineProperty({className:'modal-body'},'className','col-12 text-center'),this.renderCouponBody()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',_defineProperty({className:'modal-body'},'className','col-12 text-center bg-purple couponForm'),this.renderCouponForm())));}}]);return CouponCodeModel;}(__WEBPACK_IMPORTED_MODULE_8__core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (CouponCodeModel);

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_coupon_gift_box_sm_png__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_coupon_gift_box_sm_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_coupon_gift_box_sm_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CouponCodeLayout=function(_PreLoginPage){_inherits(CouponCodeLayout,_PreLoginPage);function CouponCodeLayout(props){_classCallCheck(this,CouponCodeLayout);var _this=_possibleConstructorReturn(this,(CouponCodeLayout.__proto__||Object.getPrototypeOf(CouponCodeLayout)).call(this,props));_this.submitForm=function(){if(this.state.plp_userinput.length<=0){return;}this.setState({submitButtonDisabled:true});var formData={"couponCode":this.state.plp_userinput,"category":this.getUser().getUserOrigin()};var me=this;var callBackSuccess=function callBackSuccess(response){if(response!==null){console.log("response : ",response);if(response.status=="valid"){if(response.body){var callBackParent=function callBackParent(){me.props.callBackParent(response.body);__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".userlogintypeformgroup .plp_userinput.form-control").attr({'style':'border:2px solid #28a745 !important'});me.setState({submitButtonDisabled:true,serverMessage:me.rb("couponcode.success"),valid:true});__WEBPACK_IMPORTED_MODULE_3_jquery___default()('html, body').animate({scrollTop:__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".productFlipbox").offset().top},500);};me.setAttribute(me.getAttributePrefix()+"couponcode",formData.couponCode,callBackParent);//me.removeAttribute("couponcode");
}}else if(response.status=="forbidden"||response.status=="failure"){if(response.message=="invalid_coupon"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("couponcode.validpromo")});}else if(response.message=="coupon_expired"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("couponcode.coupon_expired")});}else if(response.message=="error_communicating_centa"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("couponcode.comm_error")});}else if(response.message=="internal_error_occurred"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("couponcode.coupon_expired")});}else{if(response.message.match("max_usage_limit_reached")>-1){me.setState({submitButtonDisabled:false,serverMessage:me.rb(response.message)});}else{me.setState({submitButtonDisabled:false,serverMessage:me.rb(response.message)});}}__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".userlogintypeformgroup .plp_userinput.form-control").attr({'style':'border:2px solid #dc3545 !important'});}if(!me.props.couponCodeTracked){me.couponTrackInit(response);}}};var callBackFailure=function callBackFailure(response){console.log("response : ",response);// me.trackMe(false);
me.setState({submitButtonDisabled:false,serverMessage:me.rb(response.message)});__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".userlogintypeformgroup .plp_userinput.form-control").attr({'style':'border:2px solid #dc3545 !important'});};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("GET_COUPON_STATUS"),formData).post(callBackSuccess,callBackFailure);//new UserStore().clearOldUser();
};_this.state={loginMaxLength:30,submitButtonDisabled:false,serverMessage:"",plp_userinput:'',valid:false,userAttrUpdate:false};_this.handleChange=_this.handleChange.bind(_this);_this.userIdChange=_this.userIdChange.bind(_this);_this.submitForm=_this.submitForm.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.autohandleSubmit=_this.autohandleSubmit.bind(_this);_this.couponTrackInit=_this.couponTrackInit.bind(_this);_this.autoSubmitFn=_this.autoSubmitFn.bind(_this);_this.getUpdateAttribute=_this.getUpdateAttribute.bind(_this);return _this;}_createClass(CouponCodeLayout,[{key:"componentDidMount",value:function componentDidMount(){this.getUpdateAttribute();}/**
    * IMPORTANT:This method gets the attribute prefix based on the product catalogue.
    * If it weren't for this method, all Product Catalogue will share the same CouponCode
    */},{key:"getAttributePrefix",value:function getAttributePrefix(){return this.props.couponPrefix?this.props.couponPrefix+"-":"-";}},{key:"getUpdateAttribute",value:function getUpdateAttribute(){var me=this;var couponcode=this.getAttribute(this.getAttributePrefix()+"couponcode")||'';this.setState({userAttrUpdate:true,plp_userinput:couponcode});setTimeout(function(){if(me.state.plp_userinput.length>0){me.autohandleSubmit();}},300);}},{key:"autoSubmitFn",value:function autoSubmitFn(){var me=this;var userLoggedIn=me.getUser().getUserId()&&me.getUser().getUserId().length>0?true:false;var tempFunc=function tempFunc(){if(typeof me.props.postLoginCallBack==="function"){me.props.postLoginCallBack();}userLoggedIn=me.getUser().getUserId()&&me.getUser().getUserId().length>0?true:false;me.submitForm();};if(!userLoggedIn){if(typeof this.props.showSubscriptionForm==="function"){this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"couponcode-applybtn"});this.props.showSubscriptionForm(tempFunc);}}else{tempFunc();}}},{key:"couponTrackInit",value:function couponTrackInit(response){var me=this;var trackObj={"couponCode":me.state.plp_userinput||null,"valid":response&&response.status==="valid"||false};var success=function success(resp){var trackId=resp&&resp.trackId?resp.trackId:0;if(trackId>0&&typeof me.props.setTrackId==="function"){me.props.setTrackId(trackId,trackObj.valid);}};var failure=function failure(err){console.warn("Coupon Init track failed :",err);};__WEBPACK_IMPORTED_MODULE_8__model_HmEventRegistry__["a" /* default */].fireEvent("COUPON_TRACK_CREATE",trackObj,success,failure);}},{key:"userIdChange",value:function userIdChange(e){var target=e.currentTarget;this.handleChange(e);this.setState({submitButtonDisabled:false});__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".userlogintypeformgroup .plp_userinput.form-control").attr({'style':'border:2px solid #66666645 !important'});__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".userlogintypeformgroup .form-control-feedback").hide();}},{key:"handleChange",value:function handleChange(e){var _setState;var target=e.currentTarget;this.form.validateFields(target);this.setState((_setState={},_defineProperty(_setState,target.name,target.value),_defineProperty(_setState,"serverMessage",""),_defineProperty(_setState,"submitButtonDisabled",!this.form.isValid()),_setState));}},{key:"autohandleSubmit",value:function autohandleSubmit(){__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".userlogintypeformgroup .form-control-feedback").show();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){this.submitForm();}}},{key:"handleSubmit",value:function handleSubmit(e){e.preventDefault();__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".userlogintypeformgroup .plp_userinput").blur();__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".userlogintypeformgroup .form-control-feedback").show();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){this.autoSubmitFn();// this.submitForm();
}}},{key:"render",value:function render(){var _this2=this,_React$createElement;var inputDisabled=this.props.couponApplied||false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"CouponCodeLayout"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"nopadding coupontypeContainer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-center clearfix"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this2.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row userlogintyperoot justify-content-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-xs-12 col-sm-12 col-md-9 col-lg-9 couponBox"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_2__images_coupon_gift_box_sm_png___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"coupIntro"},"\xA0",this.rb("centa.boxtitle"),"\xA0\xA0")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{"for":"plp_userinput",className:"userlogintypeformgroup"},function(){if(_this2.state.userAttrUpdate){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:"plp_userinput",className:"plp_userinput userlogintype ",name:"plp_userinput",placeholder:_this2.rb("centa.coupon.code_paceholder"),pattern:"^[A-Za-z0-9_]*$",value:_this2.state.plp_userinput,onChange:_this2.userIdChange,required:true,minLength:1,maxLength:_this2.state.loginMaxLength,autoCapitalize:"none",autoComplete:"off",autoCorrect:"off",spellCheck:"false",tabIndex:"1",disabled:inputDisabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{"for":"plp_userinput"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:"valueMissing"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons errinfoicon"},"info")," ",_this2.rb("couponcode.promorequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:"patternMismatch"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"material-icons errinfoicon"},"info")," ",_this2.rb("couponcode.patternmismatch"))));}}(),function(){if(!_this2.state.valid){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"server-messages"},_this2.state.serverMessage);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"server-messages success"},_this2.state.serverMessage);}}()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",(_React$createElement={disabled:inputDisabled,"data-ga":"Home - "+this.props.from+" Home- Join"},_defineProperty(_React$createElement,"disabled",this.state.submitButtonDisabled),_defineProperty(_React$createElement,"className","joinButton"),_React$createElement),this.rb("couponcode.apply")))))))));}}]);return CouponCodeLayout;}(__WEBPACK_IMPORTED_MODULE_1__core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (CouponCodeLayout);

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_html_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_common_Landing__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_plp_TestTakingModalComponent__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_moment__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_timezone__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_icons_topiccompleted_icon_png__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_icons_topiccompleted_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_icons_topiccompleted_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_icons_recenttopic_icon_png__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_icons_recenttopic_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_icons_recenttopic_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_icons_gradeEarned_icon_png__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_icons_gradeEarned_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_icons_gradeEarned_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_icons_pointsEarnedBig_icon_png__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_icons_pointsEarnedBig_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_icons_pointsEarnedBig_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_scardp_icon_png__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_scardp_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_icons_scardp_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_icons_topic_lesson_icon_png__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_icons_topic_lesson_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_icons_topic_lesson_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_icons_hey_icon_png__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_icons_hey_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_icons_hey_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_icons_report_proficiency_png__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_icons_report_proficiency_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_icons_report_proficiency_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_icons_report_practice_png__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_icons_report_practice_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__images_icons_report_practice_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__css_dashboard_css__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__css_dashboard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__css_dashboard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_circular_progressbar__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_circular_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_circular_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_circular_progressbar_dist_styles_css__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_circular_progressbar_dist_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react_circular_progressbar_dist_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_scorecard_Piechart__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_dropdown__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_dropdown_style_css__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_dropdown_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react_dropdown_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_super_responsive_table__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_super_responsive_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_react_super_responsive_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_super_responsive_table_dist_SuperResponsiveTableStyle_css__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_super_responsive_table_dist_SuperResponsiveTableStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_react_super_responsive_table_dist_SuperResponsiveTableStyle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Diagnostic__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Barchart_Topicwise__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Barchart_Overall__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__DownloadContent__ = __webpack_require__(1260);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var gradeArr=["a","b","c"];var topicList=[];var defaultOption=topicList[0];var benchMarkingView="benchMarkingView";var diagnosticView="diagnosticView";var gradePointsMap={"grades":[{"id":1,"name":"defaultGradeCalculator","grade":"C","minPercent":0,"maxPercent":39},{"id":1,"name":"defaultGradeCalculator","grade":"B","minPercent":40,"maxPercent":64},{"id":1,"name":"defaultGradeCalculator","grade":"B+","minPercent":65,"maxPercent":74},{"id":1,"name":"defaultGradeCalculator","grade":"A","minPercent":75,"maxPercent":84},{"id":1,"name":"defaultGradeCalculator","grade":"A+","minPercent":85,"maxPercent":100}],"points":{"hard":{"1":30,"2":20,"3":15},"medium":{"1":20,"2":13,"3":10},"easy":{"1":10,"2":7,"3":5}}};var Report=function(_Landing){_inherits(Report,_Landing);function Report(){_classCallCheck(this,Report);var _this=_possibleConstructorReturn(this,(Report.__proto__||Object.getPrototypeOf(Report)).call(this));_this.state={topicsCompleted:0,topicsTotal:0,recentTestData:{},selectedTopic:null,selectedSubTopic:null,gradeArr:[],productArr:[],comboNamesLoaded:false,overallPerformanceLoaded:false,recentTopicLoaded:false,pointsEarned:0,grade:_this.rb("dash.not_available"),feedbackText:"",selectedProduct:"",noProducts:false,topicSubView:benchMarkingView,benchMarkingDataLoaded:true,diagnosticDataLoaded:true,reportData:null,ModalShow:false,benchmark_available:false};_this.exportId=0;_this.reportEnabled=false;_this.topicListRequestAllowed=true;_this.selectedGradeOption=null;_this.selectedProductOption=null;_this.gradeProductMap={};_this.classDefnMap={};_this.topicDropdownChange=_this.topicDropdownChange.bind(_this);_this.topicDescMap={};_this.topicTestMap={};_this.completedTopicCount=0;_this.gradeDefns=[];_this.topicGradeDtls={};_this.plpDashboard=1;_this.testDashboard=2;_this.lessonDashboard=3;_this.totalTopicTimeSpent=0;_this.noLessonMode=false;_this.gradeStore=null;_this.dashboardDropDownKey="homeDropdown";//"dashDropdown";
_this.preferredGrade=null;_this.preferredProduct=null;//this.pointsEarned = 0;
_this.subTopicClick=_this.subTopicClick.bind(_this);_this.TopicClick=_this.TopicClick.bind(_this);_this.productsAvailableToAccess=_this.productsAvailableToAccess.bind(_this);_this.setChild(_this,"DASHBOARD");_this.hideLoginModal=_this.hideLoginModal.bind(_this);_this.showPreviousAttempts=_this.showPreviousAttempts.bind(_this);_this.showMoreAttempt=_this.showMoreAttempt.bind(_this);_this.showLessAttempt=_this.showLessAttempt.bind(_this);//this.triggerPreviousAttempts = this.triggerPreviousAttempts.bind(this);
_this.attemptsArr=[1,2,3,4,5,6];_this.attemptBoundry=3;_this.topicPointClick=_this.topicPointClick.bind(_this);_this.classId=null;_this.accessId=null;_this.getReportTab=_this.getReportTab.bind(_this);return _this;}_createClass(Report,[{key:'componentDidMount',value:function componentDidMount(){var me=this;_get(Report.prototype.__proto__||Object.getPrototypeOf(Report.prototype),'componentDidMount',this).call(this);if(this.productsAvailableToAccess()){this.setPreferredDd();this.getGradeList();}else{setTimeout(function(){__WEBPACK_IMPORTED_MODULE_23_jquery___default()(".page-content nav.side-navbar ul li").addClass("noclicks");},1000);this.setState({noProducts:true});}this.fireMobileToast();//this.populateSubTopics(defaultOption);
}},{key:'getReportTab',value:function getReportTab(){var classId=this.preferredGrade;var accessId=this.preferredProduct;var benchMarkType=window.benchMarkType||5;var diagnosticType=window.diagnosticType||6;var me=this;var callBackSuccess=function callBackSuccess(response){if((typeof response==='undefined'?'undefined':_typeof(response))==="object"){response["accessId"]=accessId;response["classId"]=classId;response["diagnosticType"]=diagnosticType;response["benchMarkType"]=benchMarkType;me.accessId=accessId;me.classId=classId;me.exportId=response["pdf_info"]&&!isNaN(response["pdf_info"]["export_id"])?response["pdf_info"]["export_id"]:0;me.reportEnabled=response["pdf_info"]&&response["pdf_info"]["generate_available"]?response["pdf_info"]["generate_available"]:false;}var benchmark_available=false;if(response&&response.benchMarkData){benchmark_available=response.benchMarkData.benchmark_available;}me.setState({reportData:response,benchmark_available:benchmark_available});// callBack.apply(this,[response]);
};var callBackFailure=function callBackFailure(error){// me.showAlert(me.rb("503.title"),me.rb("503.msg"));
};new __WEBPACK_IMPORTED_MODULE_4__util_HmAjax__["a" /* default */](this.getUrlFor("GET_REPORT_MS")+classId+"/"+accessId).get(callBackSuccess,callBackFailure);}},{key:'productsAvailableToAccess',value:function productsAvailableToAccess(){var user=this.getUser();if(user!=null){var permissions=user.getEntlHistory();if(permissions!=null&&Object.keys(permissions).length>0){for(var i in permissions){if(permissions[i]!=null){var totalLevel=permissions[i].split(",").reduce(function(a,b){try{return parseInt(a)+parseInt(b);}catch(e){return 0;}});if(totalLevel>0){return true;}}}}}return false;}},{key:'setPreferredDd',value:function setPreferredDd(){try{var gradeStore=null;var prefStr=this.getAttribute(this.dashboardDropDownKey);if(prefStr)gradeStore=JSON.parse(prefStr);console.log("dashboard gradeStore::",gradeStore);if((typeof gradeStore==='undefined'?'undefined':_typeof(gradeStore))==="object"){this.preferredGrade=gradeStore["grd"];this.preferredProduct=gradeStore["prod"];}}catch(e){}}//For feedback text
},{key:'getFeedbackText',value:function getFeedbackText(){return this.state.feedbackText;}},{key:'calculateGradeForTopics',value:function calculateGradeForTopics(topicTestMap){for(var i in topicTestMap){if(topicTestMap[i].status==="COMPLETED"){var userPoints=topicTestMap[i].userPoints||0;var topicPoints=topicTestMap[i].topicPoints||0;if(topicPoints>0){var percentage=Math.round(userPoints*100/topicPoints);topicTestMap[i].grade=this.calculateGrade(percentage);topicTestMap[i].feedback=this.processFeedbackTextByGrade(topicTestMap[i].grade,percentage);}}else if(topicTestMap[i].status==="IN_PROGRESS"){topicTestMap[i].feedback=this.rb("dash.label.topic.feedback-inprogress");}else{topicTestMap[i].feedback=this.rb("dash.label.topic.feedback-unattempted");}}}},{key:'calculateGrade',value:function calculateGrade(percentage){if(!isNaN(percentage)&&this.gradeDefns&&this.gradeDefns.length>0){for(var i=0;i<this.gradeDefns.length;i++){if(percentage>=this.gradeDefns[i].minPercent&&percentage<=this.gradeDefns[i].maxPercent){return this.gradeDefns[i].grade;}}}return this.rb("dash.not_available");}},{key:'processFeedbackTextByGrade',value:function processFeedbackTextByGrade(grade,percentage){if(percentage===100){return this.rb("dash.label.topic.grade-full-A+");}else if(grade&&grade.length>0){return this.noLessonMode?this.rb("dash.label.topic.nolesson-grade-"+grade):this.rb("dash.label.topic.grade-"+grade);}}},{key:'getOriginalFeedBackText',value:function getOriginalFeedBackText(gradeDtls){if(gradeDtls.oldPercent===100){return this.rb("scorecard.test.grade-full-A+");}else{return this.noLessonMode?this.rb("scorecard.test.nolesson-grade-"+(gradeDtls.oldGrade&&gradeDtls.oldGrade.length>0?gradeDtls.oldGrade:"")):this.rb("scorecard.test.grade-"+(gradeDtls.oldGrade&&gradeDtls.oldGrade.length>0?gradeDtls.oldGrade:""));}}},{key:'getUpdatedFeedBackText',value:function getUpdatedFeedBackText(gradeDtls){if(gradeDtls.newPercent===100){return this.rb("scorecard.practice.grade-full");}else if(gradeDtls.gradeChanged){return this.rb("scorecard.practice.grade-change").replace("{1}",gradeDtls.oldGrade).replace("{2}",gradeDtls.newGrade);}else if(gradeDtls.percentChanged){return this.rb("scorecard.practice.grade-nochange").replace("{1}",gradeDtls.oldPoints).replace("{2}",gradeDtls.newPoints);}else{return this.rb("scorecard.practice.point-nochange");}}},{key:'processFeedbackTextForSubTopic',value:function processFeedbackTextForSubTopic(subTopic){if(subTopic){if(this.topicGradeDtls&&subTopic.status){try{var gradeDtls=this.topicGradeDtls[subTopic.topicId]&&this.topicGradeDtls[subTopic.topicId][subTopic.subTopicId]?this.topicGradeDtls[subTopic.topicId][subTopic.subTopicId]:null;var subTopicPercent=0;var subTopicGrade="";// Both revision and practice, if available - completed
if(subTopic.status==="COMPLETED"&&gradeDtls!==null){if(subTopic.practiceStatus==="COMPLETED"){subTopic.feedback=this.getUpdatedFeedBackText(gradeDtls);}else{subTopic.feedback=this.getOriginalFeedBackText(gradeDtls);}}else if(subTopic.status==="IN_PROGRESS"){//Revision only completed, if completed
if(subTopic.testStatus==="COMPLETED"&&gradeDtls!==null){subTopic.feedback=this.getOriginalFeedBackText(gradeDtls);}else{subTopic.feedback=this.rb("dash.label.subtopic.feedback-inprogress");}}else if(subTopic.status==="NEW"){//Just started
subTopic.feedback=this.rb("dash.label.subtopic.feedback-inprogress");}else{subTopic.feedback=this.rb("dash.label.subtopic.feedback-unattempted");}}catch(e){console.error(e);}}else{subTopic.feedback=this.rb("dash.label.subtopic.feedback-unattempted");}}return subTopic;}},{key:'processSubTopic',value:function processSubTopic(subTopic){var returnObj={};var testScore=0;var userScore=0;var testStatus="";var practiceStatus="";var status="";var grade="";var subTopicPoints=0;var userPoints=0;var totalTimeSpent=0;try{if(subTopic){if(subTopic.diagnosticTests){for(var i in subTopic.diagnosticTests){userScore+=!isNaN(subTopic.diagnosticTests[i].userScore)?subTopic.diagnosticTests[i].userScore:0;testScore+=!isNaN(subTopic.diagnosticTests[i].score)?subTopic.diagnosticTests[i].score:0;testStatus=subTopic.diagnosticTests[i].status;}}if(subTopic.customTests){for(var i in subTopic.customTests){userScore+=!isNaN(subTopic.customTests[i].userScore)?subTopic.customTests[i].userScore:0;testScore+=!isNaN(subTopic.customTests[i].score)?subTopic.customTests[i].score:0;practiceStatus=subTopic.customTests[i].status;}}subTopicPoints=!isNaN(subTopic.subTopicPoints)?subTopic.subTopicPoints:0;userPoints=!isNaN(subTopic.userPoints)?subTopic.userPoints:0;grade=subTopic.grade;status=subTopic.status;returnObj["topicId"]=subTopic.topicId||0;returnObj["subTopicId"]=subTopic.subTopicId||0;if(subTopic.lessons){for(var obj in subTopic.lessons){totalTimeSpent+=subTopic.lessons[obj].timeSpent;}}}}catch(e){}returnObj["testScore"]=testScore;returnObj["userScore"]=userScore;returnObj["status"]=status;returnObj["practiceStatus"]=practiceStatus;returnObj["testStatus"]=testStatus;returnObj["grade"]=grade;returnObj["subTopicPoints"]=subTopicPoints;returnObj["userPoints"]=userPoints;returnObj["totalTimeSpent"]=totalTimeSpent;//process feedback text for SubTopic
this.processFeedbackTextForSubTopic(returnObj);return returnObj;}},{key:'TopicClick',value:function TopicClick(event){//console.log(event.currentTarget);
__WEBPACK_IMPORTED_MODULE_23_jquery___default()(".DashboardComponent .subtopicCard").removeClass("selected");__WEBPACK_IMPORTED_MODULE_23_jquery___default()(event.currentTarget).addClass("selected");var grade=event.currentTarget.dataset.grade;var subTopicId=event.currentTarget.dataset.subtopicid;if(!grade){grade=this.rb("dash.not_available");}this.setState({pointsEarned:event.currentTarget.dataset.userpoints,grade:grade,feedbackText:event.currentTarget.dataset.feedback,selectedSubTopic:null});var trackObj={"item_id":subTopicId,"item_type":this.getTracker().enums.selectedItemType.topic,"source":this.getTracker().enums.selectedItemSource.dashboard};this.initiateTrack("item_selected",trackObj);}},{key:'subTopicClick',value:function subTopicClick(event){//console.log(event.currentTarget);
__WEBPACK_IMPORTED_MODULE_23_jquery___default()(".DashboardComponent .subtopicCard").removeClass("selected");__WEBPACK_IMPORTED_MODULE_23_jquery___default()(event.currentTarget).addClass("selected");var grade=event.currentTarget.dataset.grade;var subTopicId=event.currentTarget.dataset.subtopicid;if(!grade){grade=this.rb("dash.not_available");}this.setState({pointsEarned:event.currentTarget.dataset.userpoints,grade:grade,feedbackText:event.currentTarget.dataset.feedback,selectedSubTopic:this.state.selectedTopic.subTopics[subTopicId]});var trackObj={"item_id":subTopicId,"item_type":this.getTracker().enums.selectedItemType.subtopic,"source":this.getTracker().enums.selectedItemSource.dashboard};this.initiateTrack("item_selected",trackObj);}},{key:'populateSubTopics',value:function populateSubTopics(){var _this2=this;//console.log("populateSubTopics");
if(this.state.selectedTopic&&this.state.selectedTopic.subTopics){var me=this;var timeSpent=0;//console.log(this.state.selectedTopic)
var subTopicsArr=Object.values(this.state.selectedTopic.subTopics);this.totalTopicTimeSpent=0;//this.setState({feedbackText: this.topicTestMap[this.defaultOption.value].feedback || "", grade: this.topicTestMap[this.defaultOption.value].grade || this.rb("dash.not_available"),selectedTopic:this.topicTestMap[selectedOption.value],selectedSubTopic:null, pointsEarned:(this.topicTestMap && this.topicTestMap[selectedOption.value] && this.topicTestMap[selectedOption.value].userPoints && !isNaN(this.topicTestMap[selectedOption.value].userPoints)) ? this.topicTestMap[selectedOption.value].userPoints : 0});
var topicstatus=this.topicTestMap[this.defaultOption.value].status;var statusclass="un_attempted";if(topicstatus.toLowerCase()=="completed"){statusclass="completed";}else if(topicstatus.toLowerCase()=="in_progress"){statusclass="in_progress";}//console.log("subtopic satus=="+subtopic.status);
var mygrade=this.topicTestMap[this.defaultOption.value].grade||this.rb("dash.not_available");var cssgrade=mygrade.toLowerCase().split("+").join("plus");if(me.state.selectedProduct==me.lessonDashboard){cssgrade=statusclass;}var userPoints=this.topicTestMap[this.defaultOption.value].userPoints;var feedback=this.topicTestMap[this.defaultOption.value].feedback;var topicId=this.topicTestMap[this.defaultOption.value].topicId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subtopicContainer clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"card subtopicCard selected float-left grade_"+cssgrade+" "+statusclass,'data-userpoints':userPoints,'data-grade':mygrade,'data-feedback':feedback,'data-subtopicid':topicId,onClick:this.TopicClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'card-text subcardText'},this.rb("dash.overall.topic")))),subTopicsArr.map(function(subtopic,index){subtopic["topicId"]=_this2.state.selectedTopic.topicId;var processedSubTopic=me.processSubTopic(subtopic);var userEarnedPoints=!isNaN(processedSubTopic.userPoints)?processedSubTopic.userPoints:0;var mygrade=processedSubTopic.grade||"";var subTopicMarks=processedSubTopic.userScore+" / "+processedSubTopic.testScore;var statusclass="un_attempted";if(subtopic.status.toLowerCase()=="completed"){statusclass="completed";}else if(subtopic.status.toLowerCase()=="in_progress"){statusclass="in_progress";}//console.log("subtopic satus=="+subtopic.status);
_this2.totalTopicTimeSpent+=processedSubTopic.totalTimeSpent;var cssgrade=mygrade.toLowerCase().split("+").join("plus");if(me.state.selectedProduct==me.lessonDashboard){cssgrade=statusclass;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"card subtopicCard float-left grade_"+cssgrade+" "+statusclass,key:index,'data-userpoints':processedSubTopic.userPoints,'data-grade':processedSubTopic.grade,'data-feedback':processedSubTopic.feedback,'data-subtopicid':processedSubTopic.subTopicId,onClick:_this2.subTopicClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'card-text subcardText'},subtopic.subTopicName),function(){if(me.state.selectedProduct!=me.lessonDashboard){if(subtopic.status.toLowerCase()==="un_attempted"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center gradeinfo notattempted'},_this2.rb("dash.notattempted"));}/*else if(subtopic.status.toLowerCase() === "in_progress") {
									return <div className="text-center gradeinfo notattempted">{this.rb("dash.inprogress")}</div>;
								}*/else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center gradeinfo'},mygrade.toUpperCase());}}else{if(subtopic.status.toLowerCase()==="un_attempted"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center gradeinfo notattempted'},_this2.rb("dash.notattempted"));}/*else if(subtopic.status.toLowerCase() === "in_progress") {
									return <div className="text-center gradeinfo notattempted">{this.rb("dash.inprogress")}</div>;
								}*/}}()));}));}}},{key:'getTopicCompletedPercentage',value:function getTopicCompletedPercentage(){//console.log(this.completedTopicCount,topicList.length);
var percentComplete=0;percentComplete=Math.round(this.completedTopicCount/topicList.length*100);return percentComplete;}},{key:'getGradeDisplay',value:function getGradeDisplay(){if(this.state.grade==this.rb("dash.not_available")){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'greyColor fsp8rem'},this.state.grade);}else{var cssgrade=this.state.grade.toLowerCase().split("+").join("plus");if(this.state.selectedProduct==this.lessonDashboard){cssgrade="";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"reward "+cssgrade},this.state.grade);}}},{key:'getTopicsCompletedContent',value:function getTopicsCompletedContent(){if(this.state.overallPerformanceLoaded){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row flexcenter justifycenter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-4 flexcenter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'widgetIcon',src:__WEBPACK_IMPORTED_MODULE_8__images_icons_topiccompleted_icon_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-4 text-right piechartparent'},this.piechartFn(this.completedTopicCount,topicList.length)));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.showLoader());}}},{key:'getTopicsCompletedTitle',value:function getTopicsCompletedTitle(){if(this.state.selectedProduct==this.lessonDashboard){return this.rb("dash.topics_watched");}else{return this.rb("dash.topics_completed");}}},{key:'getRecentAttemptTitle',value:function getRecentAttemptTitle(){if(this.state.selectedProduct==this.lessonDashboard){return this.rb("dash.recently.watched");}else{return this.rb("dash.recently.attempted.topic");}}},{key:'getOverallTitle',value:function getOverallTitle(){if(this.state.selectedProduct==this.lessonDashboard){return this.rb("dash.overall.summary");}else{return this.rb("dash.overall.performance");}}},{key:'getRecentAttemptedTopicContent',value:function getRecentAttemptedTopicContent(){var me=this;if(this.state.recentTopicLoaded){if(Object.keys(this.state.recentTestData).length>0){var firstAccessDate=!isNaN(this.state.recentTestData.startTime)?this.state.recentTestData.startTime:null;var testSubmitDate=!isNaN(this.state.recentTestData.endTime)?this.state.recentTestData.endTime:null;var Accessedon=!isNaN(this.state.recentTestData.inTime)?this.state.recentTestData.inTime:" ";var testRecentAccessDate=!isNaN(this.state.recentTestData.trackOpenTime)?this.state.recentTestData.trackOpenTime:null;var recentTopicTitle=this.state.recentTestData.title;var recentTopicSubmittedon=testSubmitDate||testRecentAccessDate||firstAccessDate;var recentTopicStatus=this.state.recentTestData.status==="NEW"?me.rb("IN_PROGRESS"):me.rb(this.state.recentTestData.status);var recentTopicPoints=this.state.recentTestData.totalPoints;var recentTopicUserPoints=this.state.recentTestData.userPoints;var recentTopicName=this.state.recentTestData.topicName||"";var recentSubTopicName=this.state.recentTestData.subTopicName||"";var activityMode=this.state.recentTestData.isActualTest==="true"?"scorecard.revision_test":"scorecard.custom_practice";var recentSubmittedName=this.rb("dash.submitted_on");if(this.state.recentTestData.status=="IN_PROGRESS"){recentSubmittedName=this.rb("dash.accessed_on");}else if(this.state.recentTestData.status=="NEW"){recentSubmittedName=this.rb("dash.accessed_on");}//console.log("dash Recent data : ", this.state.recentTestData);
if(this.state.selectedProduct==this.lessonDashboard){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-3 recentIconContainer lessonRecentBox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'widgetIcon',src:__WEBPACK_IMPORTED_MODULE_13__images_icons_topic_lesson_icon_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-9 norightpadding headerTxt clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row lessonRecentBox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recentTopicName col-12 col-sm-8 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'greyColor'},recentTopicName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt-10'},recentSubTopicName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'infoTxt col-12 col-sm-4 nopadding lessonAccessedTxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'borderBottom clearfix'},this.rb("dash.watched_on")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'greyColor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_moment___default.a,{unix:true,format:'DD/MM/YYYY'},this.getTimeUtil().setServerTime(Accessedon).getServerTime())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'greyColor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_moment___default.a,{unix:true,format:'hh:mm:ss A'},this.getTimeUtil().setServerTime(Accessedon).getServerTime()))))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-3 recentIconContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'widgetIcon',src:__WEBPACK_IMPORTED_MODULE_9__images_icons_recenttopic_icon_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-9 norightpadding headerTxt clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'recentTopicName'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'greyColor'},recentTopicName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pt-10'},recentSubTopicName,' - ',this.rb(activityMode))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'infoTxt row col-12 recentAttemptInfo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-4 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'borderBottom clearfix'},recentSubmittedName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'greyColor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_moment___default.a,{unix:true,format:'DD/MM/YYYY'},this.getTimeUtil().setServerTime(recentTopicSubmittedon).getServerTime())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'greyColor'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_moment___default.a,{unix:true,format:'hh:mm:ss A'},this.getTimeUtil().setServerTime(recentTopicSubmittedon).getServerTime()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-4 nopadding plp4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'borderBottom'},this.rb("dash.status")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'greyColor'},recentTopicStatus)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-4 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'borderBottom'},this.rb("dash.points_earned")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'points'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'flash_on'),' ',recentTopicUserPoints))))));}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row pt-45'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-3 pb-20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'widgetIcon',src:__WEBPACK_IMPORTED_MODULE_9__images_icons_recenttopic_icon_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-9 nodatamsg'},'You have not started any topic'));}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.showLoader());}}},{key:'hhmmss',value:function hhmmss(secs){var minutes=Math.floor(secs/60);secs=secs%60;var hours=Math.floor(minutes/60);minutes=minutes%60;return this.pad(hours)+":"+this.pad(minutes)+":"+this.pad(secs);}},{key:'pad',value:function pad(num){return("0"+num).slice(-2);}},{key:'getLessonTable',value:function getLessonTable(){//console.log("lessontable...");
/*return(
							{this.state.selectedSubTopic.lessons.map((lesson, index) => {
								return (<tr key={index}>
								<td>{lesson.lessonName}</td>
								<td>{lesson.timeSpent}</td>
								</tr>)
							})}
							);*/return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'"lessonName"'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'"timeSpent"'));}},{key:'renderOverallSubtopicInfo',value:function renderOverallSubtopicInfo(){var _this3=this;if(this.state.selectedProduct==this.lessonDashboard){try{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-12 col-lg-6 clearfix nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 nopadding bottomPadding'},function(){var totaltimespent=_this3.hhmmss(_this3.totalTopicTimeSpent);if(_this3.state.selectedSubTopic==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottomBorder'},_this3.rb("dash.totaltimespenttopic")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'topicTimeSpent text-center'},totaltimespent));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottomBorder'},'Subtopic - ',_this3.state.selectedSubTopic.subTopicName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lessonTable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_react_super_responsive_table__["Table"],{className:'result1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'resulthead'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,_this3.rb("dash.lessonname")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,_this3.rb("dash.timespent")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,Object.keys(_this3.state.selectedSubTopic.lessons).map(function(lesson,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,_this3.state.selectedSubTopic.lessons[lesson].lessonName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,_this3.hhmmss(_this3.state.selectedSubTopic.lessons[lesson].timeSpent)));})))));}}()));}catch(e){}}else{var me=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-12 col-lg-6 clearfix nopadding'},function(){if(me.state.selectedSubTopic&&me.state.selectedSubTopic!=null){if(me.state.selectedSubTopic.archivedTestDetails&&me.state.selectedSubTopic.archivedTestDetails!=null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row bottomBorder mb20 overallRHS'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-8'},_this3.rb("dash.subtopic"),' - ',_this3.state.selectedSubTopic.subTopicName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-4 text-right norightpadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn btn-primary btnAttempts',onClick:_this3.triggerPreviousAttempts.bind(_this3,Object.values(me.state.selectedSubTopic.archivedTestDetails))},_this3.rb("dash.previousattempts"))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row bottomBorder mb20 overallRHS'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-8'},_this3.rb("dash.subtopic"),' - ',_this3.state.selectedSubTopic.subTopicName));}}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-12 nopadding bottomBorder bottomPadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row clearfix nopadding rightBorder flexcenter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left rightPadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'gradeEarnedIcon',src:__WEBPACK_IMPORTED_MODULE_10__images_icons_gradeEarned_icon_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headerTxt clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.rb("dash.grade_earned")),this.getGradeDisplay()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 row clearfix nopadding flexcenter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left rightPadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'pointsEarnedBig',src:__WEBPACK_IMPORTED_MODULE_11__images_icons_pointsEarnedBig_icon_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headerTxt clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.rb("dash.points_earned")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'yellowColor bigPoints'},this.state.pointsEarned))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-12 statusMsgrow plpmsggrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-3 pb-20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_14__images_icons_hey_icon_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-9 text-center feedbackTxtDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.getFeedbackText()))));}}},{key:'getOverallPerformanceContent',value:function getOverallPerformanceContent(){if(this.state.overallPerformanceLoaded){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-sm-12 col-lg-6 topicDropdown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_react_dropdown___default.a,{options:topicList,onChange:this.topicDropdownChange,value:this.defaultOption,placeholder:'Select an option'}),this.populateSubTopics()),this.renderOverallSubtopicInfo());}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.showLoader());}}},{key:'topicDropdownChange',value:function topicDropdownChange(selectedOption){this.defaultOption=selectedOption;this.totalTopicTimeSpent=0;this.setState({feedbackText:this.topicTestMap[this.defaultOption.value].feedback||"",grade:this.topicTestMap[this.defaultOption.value].grade||this.rb("dash.not_available"),selectedTopic:this.topicTestMap[selectedOption.value],selectedSubTopic:null,pointsEarned:this.topicTestMap&&this.topicTestMap[selectedOption.value]&&this.topicTestMap[selectedOption.value].userPoints&&!isNaN(this.topicTestMap[selectedOption.value].userPoints)?this.topicTestMap[selectedOption.value].userPoints:0});//this.setState({selectedTopic:this.topicTestMap[selectedOption.value]}); // using same state above
try{var trackObj={"item_id":this.defaultOption.value,"item_type":this.getTracker().enums.selectedItemType.topic,"source":this.getTracker().enums.selectedItemSource.dashboard};this.initiateTrack("item_selected",trackObj);}catch(e){}}},{key:'getProductList',value:function getProductList(){var preselectIndex=0;var gradeProductMap=this.gradeProductMap;var permissions=gradeProductMap[this.selectedGradeOption.value];var accessMap=this.getUser().getAccessMap();if(permissions.length>0){var productArr=[];for(var i=0;i<permissions.length;i++){var classCode=this.classDefnMap[this.selectedGradeOption.value].classCode;var board=this.classDefnMap[this.selectedGradeOption.value].board;var label=this.rb(accessMap[permissions[i]]+"-"+classCode+"-"+board)||this.rb("label-"+permissions[i]+"-"+classCode+"-"+board);if(label===accessMap[permissions[i]]+"-"+classCode+"-"+board||label==="label-"+permissions[i]+"-"+classCode+"-"+board){label=this.rb(accessMap[permissions[i]]+"-menu")||this.rb("label-"+permissions[i]);}productArr.push({"label":label,"value":permissions[i]});console.log("product::",permissions[i],this.preferredProduct);if(permissions[i]==parseInt(this.preferredProduct)){console.log("selectedindex::"+i);preselectIndex=i;}}this.selectedProductOption=productArr[preselectIndex];this.setState({productArr:productArr});this.getTopics();}else{//this.showAlert("",this.rb("home.not_entitled"));
}}},{key:'getGradeList',value:function getGradeList(){var me=this;var callBack=function callBack(response){console.log("response:::",response);var grades=response.classId;var products=response.accessId;var classDefnMap=response.classDefn;me.gradeProductMap=response.gradeProdMap;me.classDefnMap=classDefnMap;var gradeArr=[];var preselectIndex=0;console.log("grades::",grades);if(grades!==null&&grades.length>0){for(var i=0;i<grades.length;i++){if(grades[i]>0){try{var dropDownLabel=me.rb(classDefnMap[grades[i]].className);gradeArr.push({"label":dropDownLabel,"value":grades[i]});}catch(e){}}}}if(gradeArr&&gradeArr.length>0){for(var i=0;i<gradeArr.length;i++){if(gradeArr[i].value==me.preferredGrade){console.log("selectedindex::"+i);preselectIndex=i;}}}me.selectedGradeOption=gradeArr[preselectIndex];me.setState({gradeArr:gradeArr});me.getProductList();me.getReportTab();};this.getClassNames(callBack);}},{key:'getClassNames',value:function getClassNames(callBack){var me=this;var callBackSuccess=function callBackSuccess(response){me.setState({comboNamesLoaded:true});callBack.apply(this,[response]);};var callBackFailure=function callBackFailure(error){me.showAlert(me.rb("503.title"),me.rb("503.msg"));};new __WEBPACK_IMPORTED_MODULE_4__util_HmAjax__["a" /* default */](this.getUrlFor("DASH_COMBO_DATA")).get(callBackSuccess,callBackFailure);}},{key:'gradeDropdownChange',value:function gradeDropdownChange(selectedOption){this.selectedGradeOption=selectedOption;this.getProductList();}},{key:'productDropdownChange',value:function productDropdownChange(selectedOption){this.selectedProductOption=selectedOption;this.getTopics();}},{key:'getTopics',value:function getTopics(){this.setState({overallPerformanceLoaded:false,recentTopicLoaded:false,grade:this.rb("dash.not_available"),pointsEarned:0,selectedProduct:this.selectedProductOption.value});this.loadOverallPerformance(this.selectedProductOption.value,this.selectedGradeOption.value);this.loadRecentTopic(this.selectedProductOption.value,this.selectedGradeOption.value);try{var accessMap=this.getUser().getAccessMap();this.noLessonMode=accessMap[this.selectedProductOption.value]==="PLP|TEST|TAKE";}catch(e){}try{this.gradeStore={"grd":this.selectedGradeOption.value,"prod":this.selectedProductOption.value};this.setAttribute(this.dashboardDropDownKey,JSON.stringify(this.gradeStore));}catch(e){}try{var trackObj={"grade_id":this.selectedGradeOption.value,"product_type":this.selectedProductOption.value,"source":this.getTracker().enums.selectedProductSource.dashboard};this.initiateTrack("product_selected",trackObj);}catch(e){}}},{key:'loadRecentTopic',value:function loadRecentTopic(accessId,level){var me=this;var callBackSuccess=function callBackSuccess(response){if(_typeof(response.data)==="object"&&Object.keys(response.data).length>0){var recentTestData=response.data;me.setState({recentTopicLoaded:true,recentTestData:recentTestData});}else{me.setState({recentTopicLoaded:true,recentTestData:{}});}};var callBackFailure=function callBackFailure(error){me.showAlert(me.rb("503.title"),me.rb("503.msg"));};if(accessId!==undefined&&level!==undefined&&accessId!==null&&level!==null){new __WEBPACK_IMPORTED_MODULE_4__util_HmAjax__["a" /* default */](this.getUrlFor("DASH_RECENT_TEST")+"?access="+accessId+"&level="+level).get(callBackSuccess,callBackFailure);}}},{key:'calculateTopicCompletedCount',value:function calculateTopicCompletedCount(){this.completedTopicCount++;}},{key:'resetCount',value:function resetCount(){this.completedTopicCount=0;}},{key:'loadOverallPerformance',value:function loadOverallPerformance(accessId,level){var me=this;if(!this.topicListRequestAllowed){return;}this.completedTopicCount=0;topicList=new Array();var callBackSuccess=function callBackSuccess(response){me.topicListRequestAllowed=true;topicList=new Array();if(_typeof(response.data)==="object"&&Object.keys(response.data).length>0){me.setState({overallPerformanceLoaded:true});me.topicDescMap=response.data.topicDescMap;me.topicTestMap=response.data.topicTestMap||response.data.topicLessonMap;me.gradeDefns=response.data.gradeDefns;me.topicGradeDtls=response.data.topicGradeDtls;//Shyam
try{me.calculateGradeForTopics(me.topicTestMap);}catch(e){console.error(e);}me.resetCount();if(me.state.selectedProduct==me.lessonDashboard){for(var i in me.topicTestMap){if(me.topicTestMap[i].status&&me.topicTestMap[i].status.toLowerCase()==="completed"){me.calculateTopicCompletedCount();}topicList.push({"label":me.topicTestMap[i].topicName,"value":me.topicTestMap[i].topicId});}}else{for(var i in me.topicDescMap){if(me.topicTestMap[i].status&&me.topicTestMap[i].status.toLowerCase()==="completed"){me.calculateTopicCompletedCount();}//console.log(me.topicDescMap[i]);
topicList.push({"label":me.topicTestMap[i].topicName,"value":me.topicTestMap[i].topicId});}}console.log("topicList::::",topicList);me.defaultOption=topicList[0];me.setState({feedbackText:me.topicTestMap[me.defaultOption.value].feedback||"",grade:me.topicTestMap[me.defaultOption.value].grade||me.rb("dash.not_available"),selectedTopic:me.topicTestMap[me.defaultOption.value],selectedSubTopic:null,pointsEarned:me.topicTestMap&&me.topicTestMap[me.defaultOption.value]&&me.topicTestMap[me.defaultOption.value].userPoints&&!isNaN(me.topicTestMap[me.defaultOption.value].userPoints)?me.topicTestMap[me.defaultOption.value].userPoints:0});//me.setState({selectedTopic:me.topicTestMap[defaultOption.value]}); // using same setState
//me.populateSubTopics();		
}else{}};var callBackFailure=function callBackFailure(error){me.topicListRequestAllowed=true;me.showAlert(me.rb("503.title"),me.rb("503.msg"));};if(this.topicListRequestAllowed&&accessId!==undefined&&level!==undefined&&accessId!==null&&level!==null){new __WEBPACK_IMPORTED_MODULE_4__util_HmAjax__["a" /* default */](this.getUrlFor("DASH_OVERALL_PERFORMANCE")+"?access="+accessId+"&level="+level).get(callBackSuccess,callBackFailure);me.topicListRequestAllowed=false;}}},{key:'piechartFn',value:function piechartFn(value,total){if(total>0){var piedata=[value,total-value];//how many partitions you want
var piecolors=["#FFAA00","#d1d3d4"];//partiation color
var pieindata=[value,"/",total];//inside data of svg
//console.log(piedata + " " + piecolors+" "+pieindata);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'piechart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__views_scorecard_Piechart__["a" /* default */],{data:piedata,colors:piecolors,txtval:pieindata}));}}},{key:'hideLoginModal',value:function hideLoginModal(){this.setState({"ModalShow":false});}},{key:'triggerPreviousAttempts',value:function triggerPreviousAttempts(previousAttemptsArray){console.log("lala :: ",previousAttemptsArray);this.attemptBoundry=3;__WEBPACK_IMPORTED_MODULE_23_jquery___default()(".attemptsBodyContent").css("padding-right","1rem");this.showPreviousAttempts(previousAttemptsArray);}},{key:'showPreviousAttempts',value:function showPreviousAttempts(previousAttemptsArray){this.setState({"ModalShow":true,"ModalContent":this.getPreviousAttempts(previousAttemptsArray)});}},{key:'showMoreAttempt',value:function showMoreAttempt(){this.attemptBoundry=this.attemptsArr.length;this.showPreviousAttempts(this.attemptsArr);__WEBPACK_IMPORTED_MODULE_23_jquery___default()(".attemptsBodyContent").css("padding-right","0rem");}},{key:'showLessAttempt',value:function showLessAttempt(){this.attemptBoundry=3;this.showPreviousAttempts(this.attemptsArr);__WEBPACK_IMPORTED_MODULE_23_jquery___default()(".attemptsBodyContent").css("padding-right","1rem");}},{key:'getPreviousAttempts',value:function getPreviousAttempts(previousAttemptsArray){var _this4=this;this.attemptsArr=previousAttemptsArray;var customAttemptsArr=[];if(this.attemptsArr.length>this.attemptBoundry){for(var i=0;i<this.attemptBoundry;i++){customAttemptsArr.push(this.attemptsArr[i]);}}else{customAttemptsArr=this.attemptsArr;}var me=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'attemptsBodyContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'attemptsContainer'},customAttemptsArr.map(function(attempts,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'attemptInfoContainer',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix attemptInfoTitle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left'},_this4.rb("dash.attempt"),' #',customAttemptsArr[index].diagnostic.version),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-right'},_this4.rb("dash.archive.submitted_on"),': ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_moment___default.a,{unix:true,format:'DD MMM YYYY  hh:mm:ss A'},me.getTimeUtil().setServerTime((customAttemptsArr[index].customized?customAttemptsArr[index].customized.endDate:customAttemptsArr[index].diagnostic.endDate)+"").getServerTime()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-12 nopadding attemptInfoBody'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 row clearfix nopadding rightBorder flexcenter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left rightPadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'attemptsGradeEarnedIcon',src:__WEBPACK_IMPORTED_MODULE_10__images_icons_gradeEarned_icon_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headerTxt clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Grade Earned'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center reward rewardsmall c'},customAttemptsArr[index].customized?customAttemptsArr[index].customized.grade:customAttemptsArr[index].diagnostic.grade)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 row clearfix nopadding rightBorder flexcenter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left rightPadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'attemptsPointsEarnedSmall',src:__WEBPACK_IMPORTED_MODULE_12__images_icons_scardp_icon_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headerTxt clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Points Earned'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center yellowColor smallPoints'},customAttemptsArr[index].customized?customAttemptsArr[index].customized.userPoints:customAttemptsArr[index].diagnostic.userPoints)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 row clearfix nopadding flexcenter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left rightPadding previousreporticon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"/scorecard/"+customAttemptsArr[index].diagnostic.testId+"/"+customAttemptsArr[index].diagnostic.version},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'reportProficienyIcon rightPadding',src:__WEBPACK_IMPORTED_MODULE_15__images_icons_report_proficiency_png___default.a}))),function(){if(customAttemptsArr[index].customized){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:"/scorecard/"+customAttemptsArr[index].customized.testId+"/"+customAttemptsArr[index].customized.version},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'reportPracticeIcon',src:__WEBPACK_IMPORTED_MODULE_16__images_icons_report_practice_png___default.a})));}}())));})),function(){if(_this4.attemptsArr.length>3&&_this4.attemptBoundry==3){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right showmore',onClick:_this4.showMoreAttempt.bind(_this4,_this4.attemptsArr)},_this4.rb("dash.showmore"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'keyboard_arrow_down'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right showmore showless',onClick:_this4.showLessAttempt},_this4.rb("dash.showless"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'keyboard_arrow_up'));}}());}},{key:'topicPointClick',value:function topicPointClick(event){var target=event.currentTarget;__WEBPACK_IMPORTED_MODULE_23_jquery___default()(".hometopmenu").removeClass("selected");__WEBPACK_IMPORTED_MODULE_23_jquery___default()(target).addClass("selected");if(__WEBPACK_IMPORTED_MODULE_23_jquery___default()(target).hasClass("allTopics")){this.setState({topicSubView:benchMarkingView});}else if(__WEBPACK_IMPORTED_MODULE_23_jquery___default()(target).hasClass("pointssystem")){//gradePointsMap.grades = gradePointsMap.grades.reverse();
//console.log(gradePointsMap.grades);		
this.setState({topicSubView:diagnosticView});}}},{key:'renderdiagnosticData',value:function renderdiagnosticData(){var me=this;if(me.state.reportData!==null){if(me.state.reportData.benchMarkData&&me.state.reportData.benchMarkData!=null){if(me.state.reportData.benchMarkData.diagnostic_status==="success"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__Diagnostic__["a" /* default */],{reportData:me.state.reportData});}else if(me.state.reportData.benchMarkData.diagnostic_status==='failure'||me.state.reportData.benchMarkData.diagnostic_status==='forbidden'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.rb(this.state.reportData.benchMarkData.diagnostic_message));}}}}},{key:'legendData',value:function legendData(frm){var _this5=this;var metricType=window.report_legends&&window.report_legends.hasOwnProperty(this.getUser().getSchoolPrefix())?window.report_legends[this.getUser().getSchoolPrefix()]:window.report_legends["default"];var legend_red_lbl="testinfo.legend.red";var legend_yellow_lbl="testinfo.legend.yellow";var legend_green_lbl="testinfo.legend.green";var legend_grey_lbl="testinfo.legend.grey";if(metricType&&metricType==="text"){legend_red_lbl="testinfo.legend.red.txt";legend_yellow_lbl="testinfo.legend.yellow.txt";legend_green_lbl="testinfo.legend.green.txt";}else if(metricType&&metricType==="points"){/**
						  * Points are defaulted at instantiation. Should this be changed this block will be filled
						  */}var me=this;if(me.state.reportData!==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'legend-cont'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'red'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'stop'),this.rb(legend_red_lbl)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'yellow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'stop'),this.rb(legend_yellow_lbl)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'green'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'stop'),this.rb(legend_green_lbl)),function(){if(frm=='diagnostic'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'grey'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'stop'),_this5.rb(legend_grey_lbl));}}()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}},{key:'epochTimeFn',value:function epochTimeFn(str){var d=new Date(Number(str)*1000);var n=d.toString();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("report_date_in_future"),n);}},{key:'renderBarOverAlldata',value:function renderBarOverAlldata(){var _this6=this;if(this.state.reportData.benchMarkData!==null){if(this.state.reportData.benchMarkData.status==='success'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,function(){if(_this6.state.reportData.benchMarkData.percentile){{console.log("Barchart_Overall");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'report_title'},'Benchmarking Report - Overall'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row justify-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-12 col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__Barchart_Overall__["a" /* default */],{benchMarkData:_this6.state.reportData.benchMarkData}))));}}());}else if(this.state.reportData.benchMarkData.status==='report_date_in_future'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.epochTimeFn(this.state.reportData.benchMarkData.message));}else if(this.state.reportData.benchMarkData.status==='failure'||this.state.reportData.benchMarkData.status==='forbidden'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.rb(this.state.reportData.benchMarkData.message));}}}},{key:'renderBarTopicwisedata',value:function renderBarTopicwisedata(){var _this7=this;if(this.state.reportData.benchMarkData!==null){if(this.state.reportData.benchMarkData.status==='success'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,function(){if(_this7.state.reportData.benchMarkData.topic_wise&&_this7.state.reportData.benchMarkData.topic_wise.length>0){{console.log("Barchart_Topicwise");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'resout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'report_title'},'Benchmarking Assesment - Topic-wise'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row justify-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-12 col-lg-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__Barchart_Topicwise__["a" /* default */],{benchMarkData:_this7.state.reportData.benchMarkData}))));}}());}}}},{key:'benchMarkTab',value:function benchMarkTab(){if(this.state.benchMarkingDataLoaded==true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'allTopics hometopmenu selected',onClick:this.topicPointClick},this.rb("menu.report.benchmarkingReport"));}}},{key:'diagnosticTab',value:function diagnosticTab(){if(this.state.diagnosticDataLoaded==true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pointssystem hometopmenu',onClick:this.topicPointClick},this.rb("menu.report.diagnosticReport"));}}},{key:'render',value:function render(){var _this8=this;var me=this;if(this.state.comboNamesLoaded){return _get(Report.prototype.__proto__||Object.getPrototypeOf(Report.prototype),'render',this).call(this,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'reportTab',className:'DashboardComponent'},function(){if(_this8.reportEnabled&&(_this8.state.benchMarkingDataLoaded==true||_this8.state.diagnosticDataLoaded==true)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__DownloadContent__["a" /* default */],{exportId:me.exportId,classId:me.classId,accessId:me.accessId})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'},' '));}}(),function(){if(_this8.state.benchmark_available){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'topicspointsheader'},_this8.benchMarkTab(),_this8.diagnosticTab());}}(),function(){//console.log("this.state.topicSubView=="+this.state.topicSubView);
if(_this8.state.topicSubView===benchMarkingView&&_this8.state.benchmark_available){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'pointsContainer',className:'homeTopicContainer'},function(){if(_this8.state.reportData!==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'reportChart'},_this8.legendData('benchmark'),_this8.renderBarOverAlldata(),_this8.renderBarTopicwisedata());}else{{return _this8.showLoader();}}}());}else{var me=_this8;//this.setState({topicSubView:diagnosticView});
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'topicContainer',className:'homeTopicContainer'},me.legendData('diagnostic'),me.renderdiagnosticData());}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__views_plp_TestTakingModalComponent__["a" /* default */],{visible:this.state.ModalShow,dialogClassName:'attemptsModalDialog'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'attemptsHeader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center attemptsheadertext'},this.rb("dash.previousattempts")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close attemptsClose',onClick:this.hideLoginModal,'aria-label':'Close'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'close')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-body attemptsModalBody'},this.state.ModalContent)))));}else if(this.state.noProducts){return _get(Report.prototype.__proto__||Object.getPrototypeOf(Report.prototype),'render',this).call(this,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'messageView expiredView text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'expiredlock'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'lock')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.rb("register.noproducts.msg")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.rb("register.noproducts.msg2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_2_react_html_parser___default()(this.rb("register.noproducts.msg3")))));}else{return _get(Report.prototype.__proto__||Object.getPrototypeOf(Report.prototype),'render',this).call(this);}}}]);return Report;}(__WEBPACK_IMPORTED_MODULE_3__views_common_Landing__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Report);

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_google_charts__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_LoaderMask__ = __webpack_require__(126);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BarChart=function(_React$Component){_inherits(BarChart,_React$Component);function BarChart(props){_classCallCheck(this,BarChart);return _possibleConstructorReturn(this,(BarChart.__proto__||Object.getPrototypeOf(BarChart)).call(this,props));}_createClass(BarChart,[{key:"componentDidMount",value:function componentDidMount(){// console.log("this.props.params ",this.props.params);
}},{key:"getChart",value:function getChart(){var params=this.props.params;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_google_charts__["a" /* default */],{chartType:params.chartType||"BarChart",width:params.width||'500px',height:params.height||'300px',loader:__WEBPACK_IMPORTED_MODULE_3__components_common_LoaderMask__["a" /* default */],data:params.data||[],options:{title:params.options.title||'',chartArea:params.options.chartArea||{width:'50%'},legend:params.options.legend||{position:'none'},isStacked:params.options.isStacked||true,bar:params.options.bar||{groupWidth:'90%'},hAxis:params.options.hAxis||{title:'Percentile Ranking',minValue:0},vAxis:params.options.vAxis||{title:''},tooltip:{trigger:'none'},crosshair:{trigger:'none'}}});}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"BarChart"},this.getChart());}}]);return BarChart;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (BarChart);

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommonProductCatalogue__ = __webpack_require__(508);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SGProductCatalogue=function(_CommonProductCatalog){_inherits(SGProductCatalogue,_CommonProductCatalog);function SGProductCatalogue(){_classCallCheck(this,SGProductCatalogue);return _possibleConstructorReturn(this,(SGProductCatalogue.__proto__||Object.getPrototypeOf(SGProductCatalogue)).apply(this,arguments));}_createClass(SGProductCatalogue,[{key:"componentDidMount",value:function componentDidMount(){_get(SGProductCatalogue.prototype.__proto__||Object.getPrototypeOf(SGProductCatalogue.prototype),"componentDidMount",this).call(this);this.isReloadRequired=!this.userLoggedIn;}},{key:"getSelectedIndex",value:function getSelectedIndex(indVal){var chosenGradeFromURL=this.getProdFromQryParam();if(window.catalog_qry_param_support[this.getCategory()]&&!isNaN(window.catalog_qry_param_support[this.getCategory()][chosenGradeFromURL])){return window.catalog_qry_param_support[this.getCategory()][chosenGradeFromURL];}return _get(SGProductCatalogue.prototype.__proto__||Object.getPrototypeOf(SGProductCatalogue.prototype),"getSelectedIndex",this).call(this,indVal);}},{key:"getCategory",value:function getCategory(){return"SG_PLP";}//setting coupon false
},{key:"isCouponAllowed",value:function isCouponAllowed(){return window.sg_plp_discount_available;}},{key:"couponAttrPrefix",value:function couponAttrPrefix(){return"sg1";}},{key:"onBillingFormClose",value:function onBillingFormClose(){if(this.isReloadRequired){window.location.reload();}}}]);return SGProductCatalogue;}(__WEBPACK_IMPORTED_MODULE_0__CommonProductCatalogue__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (SGProductCatalogue);

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__prelogin_src_components_FlipBox__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prelogin_src_components_SampleLessonLayout__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_id_swiper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_id_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_id_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_slick__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_plp_TestTakingModalComponent__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_purchase_TchrBillingForm__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_NativeAjax__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_purchase_CouponCodeModel__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_purchase_CouponCodeLayout__ = __webpack_require__(504);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var redirection_url_key="login-redirect-purchase";var CommonProductCatalogue=function(_PreLoginPage){_inherits(CommonProductCatalogue,_PreLoginPage);function CommonProductCatalogue(props){_classCallCheck(this,CommonProductCatalogue);var _this=_possibleConstructorReturn(this,(CommonProductCatalogue.__proto__||Object.getPrototypeOf(CommonProductCatalogue)).call(this,props));_this.getLengthtoSlideShow=function(val){var me=_this;var gradeLen=me.tchrgradeOrder.length;var lengGrade=gradeLen>val?val:gradeLen;return lengGrade;};_this.setFreeProductsFirst=function(gradeData){var FreeProdArr=[];var PaidProdArr=[];var allProdCount=Object.values(gradeData).length;Object.values(gradeData).map(function(grade,index){if(grade.productPrice>0){PaidProdArr.push(grade);}else{FreeProdArr.push(grade);}});var FinalProd=[];/**
        * IMPORTANT: Sort free-paid combo per row
        **/for(var i=0;i<allProdCount;i++){if(FreeProdArr[i]){FinalProd.push(FreeProdArr[i]);}if(PaidProdArr[i]){FinalProd.push(PaidProdArr[i]);}}//FinalProd = FreeProdArr.concat(PaidProdArr);
return FinalProd;};_this.state={tchrdata:{},chooseGrade:null,products_details:{},OPSAvailable:false,ModalShow:false,review_order:false,BillingFormShow:false,currentGradeIndex:_this.getSelectedIndex(0),dataLoaded:false,teacherLessonsList:null,selectedGrade:'',purchaseObj:null,noData:false,couponApplied:false,SubscribeModal:false,trackId:0,couponCodeTracked:false};_this.slider=null;_this.productCateBox=_this.productCateBox.bind(_this);_this.renderClassTab=_this.renderClassTab.bind(_this);_this.similarLessonList={};_this.productsJson={};//this.purchaseObj = null;
_this.appDetails={};_this.tchrgradeOrder=[];_this.productEvt=null;_this.teacherLumosProduct=null;_this.showBillingForm=_this.showBillingForm.bind(_this);_this.renderbillingForm=_this.renderbillingForm.bind(_this);_this.showOrderReview=_this.showOrderReview.bind(_this);_this.hideBillingModal=_this.hideBillingModal.bind(_this);_this.hideReviewModal=_this.hideReviewModal.bind(_this);_this.teachergradeSwiper=_this.teachergradeSwiper.bind(_this);_this.couponValidFn=_this.couponValidFn.bind(_this);_this.setTrackId=_this.setTrackId.bind(_this);_this.SuccesscallBackFn=_this.SuccesscallBackFn.bind(_this);_this.hideSubscribeModal=_this.hideSubscribeModal.bind(_this);_this.isCouponAllowed=_this.isCouponAllowed.bind(_this);return _this;}_createClass(CommonProductCatalogue,[{key:'getProdFromQryParam',value:function getProdFromQryParam(){try{var prodKeys=window.catalog_qry_param["product"];var prodKey=null;var qryParams=this.getQueryParams();if(prodKeys&&prodKeys.length>0){for(var i=0;i<prodKeys.length;i++){if(prodKey===null){prodKey=qryParams[prodKeys[i]];}else{break;}}}return prodKey;}catch(e){console.error(e);}return null;}/**
    * VERY IMPORTANT: Override to set based on the Category set in PC Database
    * Default to "TCHR_SPL". 
    */},{key:'getCategory',value:function getCategory(){return"TCHR_SPL";}/**
    * IMPORTANT: Coupon Code Attribute Prefix to store different user attribute 
    * for different product catalogue
    * Must be Overridden by childClasses
    */},{key:'couponAttrPrefix',value:function couponAttrPrefix(){return"common";}},{key:'onBillingFormClose',value:function onBillingFormClose(){}//dummy function for now - must be overridden
/**
    * Override this method to get Products specific to the Product Catalogue
    */},{key:'getProductDetails',value:function getProductDetails(){var me=this;var callBackSuccess=function callBackSuccess(response){me.SuccesscallBackFn(response);};var callBackFailure=function callBackFailure(response){me.setState({noData:true});console.log("Error in PRODUCT_DETAILS");};new __WEBPACK_IMPORTED_MODULE_11__util_NativeAjax__["a" /* default */](this.getUrlFor("TCHR_PRODUCTS")).enableCORS().post(callBackSuccess,callBackFailure);}/**
    * IMPORTANT: Override this function to enable disable
    */},{key:'isCouponAllowed',value:function isCouponAllowed(){return false;}},{key:'couponValidFn',value:function couponValidFn(response){if(response&&(typeof response==='undefined'?'undefined':_typeof(response))=="object"){this.SuccesscallBackFn(response);this.setState({couponApplied:true});}}},{key:'setTrackId',value:function setTrackId(trackId,couponCodeTracked){this.setState({trackId:trackId,couponCodeTracked:couponCodeTracked});}},{key:'componentWillMount',value:function componentWillMount(){var me=this;var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status==='active'){me.setState({OPSAvailable:true});}}//console.log("OPS_DETECT response : ", response);
};var callBackFailure=function callBackFailure(response){console.log("Error in OPS_DETECT");};new __WEBPACK_IMPORTED_MODULE_8__util_HmAjax__["a" /* default */](this.getUrlFor("OPS_DETECT")).get(callBackSuccess,callBackFailure);// try {
// 	this.userObj = JSON.parse(BrowserStorageUtil.getStoredItem(this.userDataKey));
// 	//console.log("userobj::",this.userObj);
// 	for(var key in this.userObj){
// 		this.userId = this.userObj[key].USER_DETAILS.userId;
// 		this.userCountryCode = this.userObj[key].USER_DETAILS.countryCode;
// 	}
// } catch (e) {}
}},{key:'componentDidMount',value:function componentDidMount(){var me=this;try{var refUrl=document.referrer;var centaRef=me.callByReferer(refUrl);var userLoggedIn=this.getUser().getUserId()&&this.getUser().getUserId().length>0?true:false;this.userLoggedIn=userLoggedIn;var userOrigin=this.getUser().getUserOrigin();var couponcode=this.getAttribute(me.couponAttrPrefix()+"couponcode")||'';var AllowUserOrigin=me.callByOrigin(userOrigin);if(centaRef&&!userLoggedIn||AllowUserOrigin&&userLoggedIn&&couponcode===""){me.setState({SubscribeModal:true});}else if(AllowUserOrigin&&couponcode===""){me.setState({SubscribeModal:true});}me.getProductDetails();}catch(e){console.error("Error occurred while couponcode",e);}}},{key:'SuccesscallBackFn',value:function SuccesscallBackFn(response){var me=this;var category=this.getCategory();if(response!==null&&category){me.productsJson=response;var sortedProducts=me.sortProducts(response);me.teacherLumosProduct=sortedProducts[0];if(response.categories&&response.categories[category]){var tchrdata=Object.values(response.categories[category].grade_wise);if(tchrdata&&tchrdata.length>0){tchrdata.sort(function(a,b){if(a&&b&&a.gradeOrder&&b.gradeOrder){return a.gradeOrder-b.gradeOrder;}return 0;});me.tchrgradeOrder=[];tchrdata.map(function(gradeList,index){me.tchrgradeOrder.push(gradeList.gradeDisplayName);});var teacherLessonsList=null;var gradeName=tchrdata[me.state.currentGradeIndex].gradeDisplayName.toLowerCase().replace(/\s/g,'')||'';var TeacherLessonMaps=window.TeacherLessonMaps||{};teacherLessonsList=TeacherLessonMaps[gradeName];var updVar={teacherLessonsList:teacherLessonsList,chooseGrade:tchrdata[me.state.currentGradeIndex].gradeDisplayName,tchrdata:tchrdata,dataLoaded:true,selectedGrade:gradeName};me.setState(updVar);//chooseGrade:tchrdata[0].gradeDisplayName,
setTimeout(function(){me.checkAndMoveSlider();},250);me.tabCustomCallBack(updVar);}else{me.setState({noData:true});}}else{me.setState({noData:true});}}}},{key:'sortProducts',value:function sortProducts(data){var products=data&&data.productList&&data.productList.length>0?data.productList:[];var tchrProducts=[];var filterProductCategories=window.teacherProdProducts||[];var appName=data.appName;var appId=data._appId;this.appDetails.appName=appName;this.appDetails.appId=appId;if(products.length>0){for(var i=0;i<products.length;i++){if(filterProductCategories&&filterProductCategories.length>0&&filterProductCategories.indexOf(products[i].productCategory)>-1){products[i]["appName"]=appName;products[i]["appId"]=appId;tchrProducts.push(products[i]);}else if((!filterProductCategories||filterProductCategories.length==0)&&!isNaN(products[i].productCategory)){products[i]["appName"]=appName;products[i]["appId"]=appId;tchrProducts.push(products[i]);}}}//console.warn("tchr prod",tchrProducts);
return tchrProducts;}},{key:'showBillingForm',value:function showBillingForm(productObj){var me=this;var userLoggedIn=this.getUser().getUserId()&&this.getUser().getUserId().length>0?true:false;//React.unmountComponentAtNode(document.getElementById('tchrbilling'));
if(productObj&&productObj.productId){if(this.state.purchaseObj&&this.state.purchaseObj.productId){//Product already exists
if(this.state.purchaseObj.productId!==productObj.productId){this.setState({purchaseObj:null,BillingFormShow:false,ModalShow:false});}}}else{return;}var tempFunc=function tempFunc(){if(typeof me.props.postLoginCallBack==="function"){me.props.postLoginCallBack();}userLoggedIn=me.getUser().getUserId()&&me.getUser().getUserId().length>0?true:false;if(productObj&&productObj.productId){me.purchaseObj=productObj;me.setState({purchaseObj:productObj,BillingFormShow:true,ModalShow:true});}};if(!userLoggedIn){if(typeof this.props.showSubscriptionForm==="function"){var gradeName=productObj.gradeName.toLowerCase().replace(/\s/g,'')||'';var productName=productObj.productName.toLowerCase().replace(/\s/g,'')||'';this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":gradeName+"-"+productName+"-subscribebtn"});this.props.showSubscriptionForm(tempFunc);}//This sets the current URL to redirect on login
sessionStorage.setItem(redirection_url_key,window.location.href);}else{tempFunc();}}/**
    * IMPORTANT: Do not override this function
    * This function will move the slider based on the highlighted tab.
    **/},{key:'checkAndMoveSlider',value:function checkAndMoveSlider(){var _this2=this;var me=this;var recurFn=function recurFn(allGradeTabs){var firstHiddenIdx=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;try{if(allGradeTabs[_this2.state.currentGradeIndex].ariaHidden==="true"||allGradeTabs[_this2.state.currentGradeIndex].getAttribute("aria-hidden")==="true"){for(var i=0;i<allGradeTabs.length;i++){if(allGradeTabs[i].ariaHidden==="true"||allGradeTabs[i].getAttribute("aria-hidden")==="true"){firstHiddenIdx=i;break;}}me.slider.slickGoTo(firstHiddenIdx);}}catch(e){console.error(e);}};if(this.slider&&typeof this.slider.slickGoTo==="function"){try{var allGradeTabs=__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".slick-track").children();if(allGradeTabs&&allGradeTabs.length>0){recurFn(allGradeTabs);}}catch(e){console.error("Error while trying to move the slider ::",e);}}}},{key:'hideBillingModal',value:function hideBillingModal(){// Shyam
/*
        * IMPORTANT: It is very IMPORTANT to unmount the Billing form.
        */this.setState({ModalShow:false});}},{key:'showOrderReview',value:function showOrderReview(){this.setState({review_order:true});}},{key:'hideReviewModal',value:function hideReviewModal(){this.setState({review_order:false});}},{key:'hideSubscribeModal',value:function hideSubscribeModal(){this.setState({SubscribeModal:false});}},{key:'renderCouponCodeModel',value:function renderCouponCodeModel(){if(!this.state.couponApplied){var couponCode=this.getAttribute(this.couponAttrPrefix()+"couponcode")||'';return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__views_purchase_CouponCodeModel__["a" /* default */],Object.assign({},this.props,{couponPrefix:this.couponAttrPrefix(),couponCode:couponCode,setTrackId:this.setTrackId,couponApplied:this.state.couponApplied,hideSubscribeModal:this.hideSubscribeModal,showSubscriptionForm:this.props.showSubscriptionForm,callBackParent:this.couponValidFn,SubscribeModal:this.state.SubscribeModal,couponCodeTracked:this.state.couponCodeTracked}));}}},{key:'callByReferer',value:function callByReferer(url){var couponTrackers=window.couponTrackers||{};if(url&&couponTrackers){for(var i in couponTrackers){if(url.match(i)){return true;}}}return false;}},{key:'callByOrigin',value:function callByOrigin(origin){var couponPopup=window.couponPopup||[];if(origin&&origin.length>1&&couponPopup&&couponPopup.length>0){return~couponPopup.indexOf(origin)?true:false;}return false;}},{key:'renderbillingForm',value:function renderbillingForm(){var _this3=this;//console.log("renderbilling Form ",this.state.ModalShow);
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__views_plp_TestTakingModalComponent__["a" /* default */],{visible:this.state.ModalShow,dialogClassName:'modal-md'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'loginHeader text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'text-center modallogo loginHeaderTxt'},this.rb("billing.information")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'close loginClose',onClick:this.hideBillingModal,'aria-label':'Close'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{'aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons'},'close')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-body'},function(){if(_this3.state.purchaseObj&&_this3.state.ModalShow){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__views_purchase_TchrBillingForm__["a" /* default */],{trackId:_this3.state.trackId,purchaseObj:_this3.state.purchaseObj,productsJson:_this3.productsJson,myProps:_this3.props,ModalShow:_this3.state.ModalShow,showBillingForm:_this3.showBillingForm,hideBillingModal:_this3.hideBillingModal,review_order:_this3.state.review_order,showOrderReview:_this3.showOrderReview,hideReviewModal:_this3.hideReviewModal,purchaseKey:_this3.state.purchaseKey});}else if(!_this3.state.ModalShow){_this3.onBillingFormClose();return null;}}())));}},{key:'getSelectedIndex',value:function getSelectedIndex(indVal){if(sessionStorage.getItem(this.getCategory()+"-catalogue")&&!isNaN(sessionStorage.getItem(this.getCategory()+"-catalogue"))){return Number(sessionStorage.getItem(this.getCategory()+"-catalogue"));}return indVal;}},{key:'setSelectedIndex',value:function setSelectedIndex(indVal){if(!isNaN(indVal)){sessionStorage.setItem(this.getCategory()+"-catalogue",indVal);}}},{key:'renderClassTab',value:function renderClassTab(list,indVal){if(this.state.chooseGrade==list||this.state.currentGradeIndex===indVal){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'swiper-slide',key:indVal},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'swiper-active','data-grade':list,'data-index':indVal,onClick:this.gradeTabClickFn.bind(this)},list)));}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'swiper-slide',key:indVal},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'grade','data-grade':list,'data-index':indVal,onClick:this.gradeTabClickFn.bind(this)},list)));}}},{key:'teachergradeSwiper',value:function teachergradeSwiper(){var _this4=this;var me=this;if(me.state.tchrdata&&me.state.tchrdata!=null&&me.tchrgradeOrder.length>0){var settings={dots:false,infinite:false,speed:300,slidesToShow:me.getLengthtoSlideShow(5),slidesToScroll:me.getLengthtoSlideShow(5),responsive:[{breakpoint:1370,settings:{slidesToShow:me.getLengthtoSlideShow(5),slidesToScroll:me.getLengthtoSlideShow(5),infinite:false,dots:false}},{breakpoint:1100,settings:{slidesToShow:me.getLengthtoSlideShow(4),slidesToScroll:me.getLengthtoSlideShow(4),infinite:false,dots:false}},{breakpoint:767,settings:{slidesToShow:me.getLengthtoSlideShow(3),slidesToScroll:me.getLengthtoSlideShow(3)}},{breakpoint:550,settings:{slidesToShow:me.getLengthtoSlideShow(1),slidesToScroll:me.getLengthtoSlideShow(1)}// You can unslick at a given breakpoint now by adding:
// settings: "unslick"
// instead of a settings object
}]};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row tchrswiper'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'swiper-container row allMiddle'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-12 col-xs-12 col-md-12 col-lg-12 imgGal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 text-center scorecardLessons'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_slick___default.a,Object.assign({ref:function ref(slider){return _this4.slider=slider;}},settings),me.tchrgradeOrder.map(function(list,index){return _this4.renderClassTab(list,index);}))))));}}},{key:'gradeTabClickFn',value:function gradeTabClickFn(e){//console.warn("grade ",e.target.dataset.index);
var allElements=Array.from(document.querySelectorAll('.swiper-active'));var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=allElements[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var element=_step.value;if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).hasClass('swiper-active')){element.classList.remove('swiper-active');element.classList.add('grade');}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).hasClass('grade')){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).removeClass('grade');__WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).addClass("swiper-active");}var teacherLessonsList=null;var gradeName=this.state.tchrdata[e.target.dataset.index].gradeName.toLowerCase().replace(/\s/g,'')||'';var TeacherLessonMaps=window.TeacherLessonMaps||{};teacherLessonsList=TeacherLessonMaps[gradeName];__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".tchrprodanim").animate({opacity:0},"fast",function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".tchrprodanim").animate({opacity:1});});this.setSelectedIndex(e.target.dataset.index);this.tabCustomCallBack({teacherLessonsList:teacherLessonsList,selectedGrade:gradeName,currentGradeIndex:e.target.dataset.index,chooseGrade:e.target.dataset.grade});this.setState({teacherLessonsList:teacherLessonsList,selectedGrade:gradeName,currentGradeIndex:e.target.dataset.index,chooseGrade:e.target.dataset.grade});}},{key:'tabCustomCallBack',//This function needs to be overridden
value:function tabCustomCallBack(tab){}},{key:'productCateBox',value:function productCateBox(){var _this5=this;var me=this;var gradeData=null;if(me.state.tchrdata&&me.state.tchrdata!=null&&me.tchrgradeOrder.length>0/*&& me.state.teacherLessonsList*/){gradeData=me.state.tchrdata[me.state.currentGradeIndex].tariffDetails;var gradeDataFinal=[];gradeDataFinal=me.setFreeProductsFirst(gradeData);//console.warn("lalala gradeData::", gradeDataFinal);
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-container'},function(){return gradeDataFinal.map(function(gradeBox,index){var tariffId=gradeBox.tariffId;var productDetails=gradeBox.productDetails;var category=me.getCategory();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__prelogin_src_components_FlipBox__["a" /* default */],{custom:_this5.onClickCustomCallBack,category:category,key:tariffId,OPSAvailable:me.state.OPSAvailable,teacherLessonsList:function teacherLessonsList(){return me.state.teacherLessonsList?me.state.teacherLessonsList[index]:null;},gradeBox:gradeBox,productDetails:productDetails,gradeName:me.state.selectedGrade,showBillingForm:me.showBillingForm,appDetails:_this5.appDetails,showSubscriptionForm:_this5.props.showSubscriptionForm});});}());}}},{key:'getSampleLessons',value:function getSampleLessons(){var me=this;if(me.state.tchrdata[me.state.currentGradeIndex].sampleLessons){var sampleLessons=me.state.tchrdata[me.state.currentGradeIndex].sampleLessons;if(sampleLessons&&sampleLessons.length>0){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__prelogin_src_components_SampleLessonLayout__["a" /* default */],{sampleLessons:sampleLessons});}else{return null;}}}},{key:'getBuyOptions',value:function getBuyOptions(){if(this.state.BillingFormShow&&this.state.purchaseObj){return this.renderbillingForm();}}},{key:'getProductBoxes',value:function getProductBoxes(){if(this.state.currentGradeIndex>=0&&this.state.tchrdata){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tchrprodanim'},this.getSampleLessons(),this.productCateBox(),this.getBuyOptions());}}},{key:'couponLayout',value:function couponLayout(){var userLoggedIn=this.getUser().getUserId()&&this.getUser().getUserId().length>0?true:false;var userOrigin=this.getUser().getUserOrigin();var boxlocked='';if(this.state.couponApplied){boxlocked="disabled";}var couponCode=this.getAttribute(this.couponAttrPrefix()+"couponcode")||'';return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"CouponCodeBoxLayout "+boxlocked},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__views_purchase_CouponCodeLayout__["a" /* default */],Object.assign({},this.props,{couponPrefix:this.couponAttrPrefix(),couponCode:couponCode,couponApplied:this.state.couponApplied,showSubscriptionForm:this.props.showSubscriptionForm,setTrackId:this.setTrackId,callBackParent:this.couponValidFn,couponCodeTracked:this.state.couponCodeTracked})));}},{key:'render',value:function render(){var _this6=this;var me=this;if(this.state.dataLoaded){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tchrprodcomp container'},function(){if(me.state.chooseGrade){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},function(){if(_this6.isCouponAllowed()&&!_this6.state.SubscribeModal){return me.couponLayout();}}(),me.teachergradeSwiper()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null),me.getProductBoxes(),function(){if(_this6.isCouponAllowed()&&_this6.state.SubscribeModal){return me.renderCouponCodeModel();}}());}}());}else if(this.state.noData){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null);}else{return _get(CommonProductCatalogue.prototype.__proto__||Object.getPrototypeOf(CommonProductCatalogue.prototype),'render',this).call(this);}}}]);return CommonProductCatalogue;}(__WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (CommonProductCatalogue);

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__prelogin_src_components_TeacherBannerBuy__ = __webpack_require__(313);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TopBanner=function(_TeacherBannerBuy){_inherits(TopBanner,_TeacherBannerBuy);function TopBanner(){_classCallCheck(this,TopBanner);return _possibleConstructorReturn(this,(TopBanner.__proto__||Object.getPrototypeOf(TopBanner)).apply(this,arguments));}_createClass(TopBanner,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:this.props.classes+" tchrhead"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,this.rb("sg.products.heading"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tchrdiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.rb("sg.products.subheading"),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.rb("sg.products.subheading1")))));}}]);return TopBanner;}(__WEBPACK_IMPORTED_MODULE_1__prelogin_src_components_TeacherBannerBuy__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (TopBanner);

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_device_detect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_BrowserStorageUtil__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var za_UserLoginType=function(_PreLoginPage){_inherits(za_UserLoginType,_PreLoginPage);function za_UserLoginType(props){_classCallCheck(this,za_UserLoginType);var _this=_possibleConstructorReturn(this,(za_UserLoginType.__proto__||Object.getPrototypeOf(za_UserLoginType)).call(this,props));_this.hmNav=function(userobj){//this.props.history.push('/landing');
//console.log(this.props.myProps)
//this.props.myProps.history.push(this.props.navigateURL);
if(userobj&&userobj.userRole.role=="PRNT"){if(this.props.navigateURL=="/landing"){window.top.location.href="/myproducts";}else{window.top.location.href=this.props.navigateURL;}}else{window.top.location.href=this.props.navigateURL;}};_this.submitForm=function(){if(this.state.plp_userinput.length<=0){return;}var formData={"verificationId":this.state.plp_userinput};var me=this;var callBackSuccess=function callBackSuccess(response){if(response!==null){console.log("response : ",response,"me.props.from:::",me.props.from);if(response.user_exists){//me.hmNav(response.user);
me.props.showNewLoginForm(me.state.loginType,me.state.plp_userinput,me.props.from);}else{if(response.message=="provider_forbidden"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("google.errmsg.login")});}else{me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);}}}};var callBackFailure=function callBackFailure(response){console.log("response : ",response);me.trackMe(false);};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("GET_USER_STATUS")+this.state.loginType,formData).post(callBackSuccess,callBackFailure);new __WEBPACK_IMPORTED_MODULE_7__util_UserStore__["a" /* default */]().clearOldUser();};_this.state={plp_userinput:'',submitButtonDisabled:false,loginType:"userid",loginMaxLength:254};_this.handleChange=_this.handleChange.bind(_this);_this.userIdChange=_this.userIdChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.showCreateAccount=_this.showCreateAccount.bind(_this);_this.myTrackerInstance=_this.getTracker();_this.navigationKey="PLP_Navigation";_this.loginStoreKey="PLP_LOGIN_INFO";return _this;}_createClass(za_UserLoginType,[{key:'componentDidMount',value:function componentDidMount(){this.sessionCheck();}},{key:'handleChange',value:function handleChange(e){var _setState;var target=e.currentTarget;this.form.validateFields(target);this.setState((_setState={},_defineProperty(_setState,target.name,target.value),_defineProperty(_setState,'submitButtonDisabled',!this.form.isValid()),_setState));}},{key:'userIdChange',value:function userIdChange(e){var target=e.currentTarget;// var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
// if(phoneRegx.test(target.value)){
// 	this.setState({loginType:"mobile",loginMaxLength:10});
// }else{
// 	this.setState({loginType:"email",loginMaxLength:254});
// }
this.setState({loginType:"email",loginMaxLength:254});this.handleChange(e);this.setState({submitButtonDisabled:false});__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".userlogintypeformgroup .form-control-feedback").hide();}},{key:'handleSubmit',value:function handleSubmit(e){e.preventDefault();__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".userlogintypeformgroup .form-control-feedback").show();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){this.submitForm();}}},{key:'trackMe',value:function trackMe(result){var userObj=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var trackObj={"user_id":userObj==null?"":userObj.userId,"login_id":this.state.plp_userinput,"user_agent":navigator.userAgent,"platform":navigator.platform,"device":__WEBPACK_IMPORTED_MODULE_8_react_device_detect__["isMobile"]?"mobile":__WEBPACK_IMPORTED_MODULE_8_react_device_detect__["isTablet"]?"tablet":"PC","ip_address":"ip_address","result":result===true,"session_id":userObj==null?"":userObj.authToken};this.initiateTrack("login",trackObj);}},{key:'showCreateAccount',value:function showCreateAccount(){this.props.callbackCreateAccount();}},{key:'getUserInputPattern',value:function getUserInputPattern(){return"^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$";// if(this.state.loginType == "mobile"){
// 	return ".{10,}";
// }else{
// 	return "^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$";
// }
}},{key:'render',value:function render(){var _this2=this;var styles=this.props.styles||{};if(this.state.loggedIn){return _get(za_UserLoginType.prototype.__proto__||Object.getPrototypeOf(za_UserLoginType.prototype),'render',this).call(this);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'loginRoot',className:'plpLogin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nopadding userlogintypeContainer',style:styles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this2.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-12 userlogintyperoot'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'plp_userinput',className:'userlogintypeformgroup'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'plp_userinput',className:"plp_userinput userlogintype "+this.state.loginType,name:'plp_userinput',placeholder:this.rb("login.userplaceholder.za"),value:this.state.plp_userinput,onChange:this.userIdChange,pattern:this.getUserInputPattern(),required:true,minLength:1,maxLength:this.state.loginMaxLength,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'1'}),function(){if(_this2.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'plp_userinput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons errinfoicon'},'info'),' ',_this2.rb("za_login.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons errinfoicon'},'info'),' ',_this2.rb("register.mobilenolength")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length>0&&!/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g.test(value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons errinfoicon'},'info'),' ',_this2.rb("register.numbersonly")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'plp_userinput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons errinfoicon'},'info'),' ',_this2.rb("za_login.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons errinfoicon'},'info'),' ',_this2.rb("fpwd.validemail")));}}()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages'},this.state.serverMessage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 text-left joincontainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-ga':"Home - "+this.props.from+" Home- Join",disabled:this.state.submitButtonDisabled,className:'joinButton'},this.rb("join")))))))));}}}]);return za_UserLoginType;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (za_UserLoginType);

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_device_detect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_BrowserStorageUtil__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var za_UserLoginType=function(_PreLoginPage){_inherits(za_UserLoginType,_PreLoginPage);function za_UserLoginType(props){_classCallCheck(this,za_UserLoginType);var _this=_possibleConstructorReturn(this,(za_UserLoginType.__proto__||Object.getPrototypeOf(za_UserLoginType)).call(this,props));_this.hmNav=function(userobj){//this.props.history.push('/landing');
//console.log(this.props.myProps)
//this.props.myProps.history.push(this.props.navigateURL);
if(userobj&&userobj.userRole.role=="PRNT"){if(this.props.navigateURL=="/landing"){window.top.location.href="/myproducts";}else{window.top.location.href=this.props.navigateURL;}}else{window.top.location.href=this.props.navigateURL;}};_this.submitForm=function(){if(this.state.plp_userinput.length<=0){return;}var formData={"verificationId":this.state.plp_userinput};var me=this;var callBackSuccess=function callBackSuccess(response){if(response!==null){console.log("response : ",response,"me.props.from:::",me.props.from);if(response.user_exists){//me.hmNav(response.user);
me.props.showNewLoginForm(me.state.loginType,me.state.plp_userinput,me.props.from);}else{if(response.message=="provider_forbidden"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("google.errmsg.login")});}else{me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);}}}};var callBackFailure=function callBackFailure(response){console.log("response : ",response);me.trackMe(false);};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("GET_USER_STATUS")+this.state.loginType,formData).post(callBackSuccess,callBackFailure);new __WEBPACK_IMPORTED_MODULE_7__util_UserStore__["a" /* default */]().clearOldUser();};_this.state={plp_userinput:'',submitButtonDisabled:false,loginType:"userid",loginMaxLength:254};_this.handleChange=_this.handleChange.bind(_this);_this.userIdChange=_this.userIdChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.showCreateAccount=_this.showCreateAccount.bind(_this);_this.myTrackerInstance=_this.getTracker();_this.navigationKey="PLP_Navigation";_this.loginStoreKey="PLP_LOGIN_INFO";return _this;}_createClass(za_UserLoginType,[{key:'componentDidMount',value:function componentDidMount(){this.sessionCheck();}},{key:'handleChange',value:function handleChange(e){var _setState;var target=e.currentTarget;this.form.validateFields(target);this.setState((_setState={},_defineProperty(_setState,target.name,target.value),_defineProperty(_setState,'submitButtonDisabled',!this.form.isValid()),_setState));}},{key:'userIdChange',value:function userIdChange(e){var target=e.currentTarget;// var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
// if(phoneRegx.test(target.value)){
// 	this.setState({loginType:"mobile",loginMaxLength:10});
// }else{
// 	this.setState({loginType:"email",loginMaxLength:254});
// }
this.setState({loginType:"email",loginMaxLength:254});this.handleChange(e);this.setState({submitButtonDisabled:false});__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".userlogintypeformgroup .form-control-feedback").hide();}},{key:'handleSubmit',value:function handleSubmit(e){e.preventDefault();__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".userlogintypeformgroup .form-control-feedback").show();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){this.submitForm();}}},{key:'trackMe',value:function trackMe(result){var userObj=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var trackObj={"user_id":userObj==null?"":userObj.userId,"login_id":this.state.plp_userinput,"user_agent":navigator.userAgent,"platform":navigator.platform,"device":__WEBPACK_IMPORTED_MODULE_8_react_device_detect__["isMobile"]?"mobile":__WEBPACK_IMPORTED_MODULE_8_react_device_detect__["isTablet"]?"tablet":"PC","ip_address":"ip_address","result":result===true,"session_id":userObj==null?"":userObj.authToken};this.initiateTrack("login",trackObj);}},{key:'showCreateAccount',value:function showCreateAccount(){this.props.callbackCreateAccount();}},{key:'getUserInputPattern',value:function getUserInputPattern(){return"^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$";// if(this.state.loginType == "mobile"){
// 	return ".{10,}";
// }else{
// 	return "^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$";
// }
}},{key:'render',value:function render(){var styles=this.props.styles||{};if(this.state.loggedIn){return _get(za_UserLoginType.prototype.__proto__||Object.getPrototypeOf(za_UserLoginType.prototype),'render',this).call(this);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'loginRoot',className:'plpLogin',style:{"borderRadius":"50px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null));}}}]);return za_UserLoginType;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (za_UserLoginType);

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Flip = exports.Zoom = exports.Slide = exports.Bounce = void 0;

var _cssTransition = _interopRequireDefault(__webpack_require__(513));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Bounce = (0, _cssTransition.default)({
  enter: 'Toastify__bounce-enter',
  exit: 'Toastify__bounce-exit',
  appendPosition: true
});
exports.Bounce = Bounce;
var Slide = (0, _cssTransition.default)({
  enter: 'Toastify__slide-enter',
  exit: 'Toastify__slide-exit',
  duration: [450, 750],
  appendPosition: true
});
exports.Slide = Slide;
var Zoom = (0, _cssTransition.default)({
  enter: 'Toastify__zoom-enter',
  exit: 'Toastify__zoom-exit'
});
exports.Zoom = Zoom;
var Flip = (0, _cssTransition.default)({
  enter: 'Toastify__flip-enter',
  exit: 'Toastify__flip-exit'
});
exports.Flip = Flip;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = _default;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Transition = _interopRequireDefault(__webpack_require__(458));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var noop = function noop() {};

function _default(_ref) {
  var enter = _ref.enter,
      exit = _ref.exit,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 750 : _ref$duration,
      _ref$appendPosition = _ref.appendPosition,
      appendPosition = _ref$appendPosition === void 0 ? false : _ref$appendPosition;
  return function Animation(_ref2) {
    var children = _ref2.children,
        position = _ref2.position,
        preventExitTransition = _ref2.preventExitTransition,
        props = _objectWithoutPropertiesLoose(_ref2, ["children", "position", "preventExitTransition"]);

    var enterClassName = appendPosition ? enter + "--" + position : enter;
    var exitClassName = appendPosition ? exit + "--" + position : exit;
    var enterDuration, exitDuration;

    if (Array.isArray(duration) && duration.length === 2) {
      enterDuration = duration[0];
      exitDuration = duration[1];
    } else {
      enterDuration = exitDuration = duration;
    }

    var onEnter = function onEnter(node) {
      node.classList.add(enterClassName);
      node.style.animationFillMode = 'forwards';
      node.style.animationDuration = enterDuration * 0.001 + "s";
    };

    var onEntered = function onEntered(node) {
      node.classList.remove(enterClassName);
      node.style.cssText = '';
    };

    var onExit = function onExit(node) {
      node.classList.add(exitClassName);
      node.style.animationFillMode = 'forwards';
      node.style.animationDuration = exitDuration * 0.001 + "s";
    };

    return _react.default.createElement(_Transition.default, _extends({}, props, {
      timeout: preventExitTransition ? 0 : {
        enter: enterDuration,
        exit: exitDuration
      },
      onEnter: onEnter,
      onEntered: onEntered,
      onExit: preventExitTransition ? noop : onExit
    }), children);
  };
}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;
var eventManager = {
  list: new Map(),
  on: function on(event, callback) {
    this.list.has(event) || this.list.set(event, []);
    this.list.get(event).push(callback);
    return this;
  },
  off: function off(event) {
    this.list.delete(event);
    return this;
  },
  emit: function emit(event) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (!this.list.has(event)) {
      return false;
    }

    this.list.get(event).forEach(function (callback) {
      return setTimeout(function () {
        return callback.call.apply(callback, [null].concat(args));
      }, 0);
    });
    return true;
  }
};
var _default = eventManager;
exports.default = _default;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(516);
module.exports = __webpack_require__(521);


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(517).enable();
  window.Promise = __webpack_require__(519);
}

// fetch() polyfill for making API calls.
__webpack_require__(520);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(36);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(316);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(316);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 520 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_index_css__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_js_bootstrap_js__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_js_bootstrap_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_js_bootstrap_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_min_css__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_typeface_roboto__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_typeface_roboto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_typeface_roboto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_core_ToastPage_js__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_core_LoggedOutPrompt_js__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_core_ErrorPrompt_js__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vendors_LumosHeartBeat_js__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__vendors_FreshChatWidget_js__ = __webpack_require__(1307);
//import './util/IcePieTracker.js';
//import './vendors/FbCampaignTrack.js';
try{window.showConsole=false;}catch(e){}if(console&&!window.showConsole){var CONSOLE_MODES_ALLOWED=["error","warn"];for(var i in console){if(CONSOLE_MODES_ALLOWED.indexOf(i)<0){console[i]=function(){};}}}__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__App__["a" /* default */],null),document.getElementById('root'));try{window.alert=console.warn||function(){};}catch(e){}/*if(window && window.isSWCacheEnabled){
	registerServiceWorker();
}*///To unregister serviceWorker
try{if(navigator.serviceWorker){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}catch(e){}

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(36),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.memo"):
60115,ba=n?Symbol.for("react.lazy"):60116,A="function"===typeof Symbol&&Symbol.iterator;function ca(a,b,d,c,e,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[d,c,e,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function B(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}var H=G.prototype=new F;
H.constructor=G;k(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,d){var c=void 0,e={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:e,_owner:J.current}}
function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){e=a[h];var f=b+T(e,h);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
0;!(e=a.next()).done;)e=e.value,f=b+T(e,h++),g+=S(e,f,d,c);else"object"===e&&(d=""+a,B("31","[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,""));return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=I.current;null===a?B("321"):void 0;return a}
var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){N(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:ba,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:aa,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,StrictMode:t,Suspense:z,createElement:M,cloneElement:function(a,b,d){null===a||void 0===a?B("267",a):void 0;var c=void 0,e=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=
b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.8.6",
unstable_ConcurrentMode:x,unstable_Profiler:u,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentOwner:J,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(36),r=__webpack_require__(524);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(525);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

/*!
  * Bootstrap v4.1.0 (https://getbootstrap.com/)
  * Copyright 2011-2018 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
  */
(function (global, factory) {
   true ? factory(exports, __webpack_require__(3), __webpack_require__(317)) :
  typeof define === 'function' && define.amd ? define(['exports', 'jquery', 'popper.js'], factory) :
  (factory((global.bootstrap = {}),global.jQuery,global.Popper));
}(this, (function (exports,$,Popper) { 'use strict';

  $ = $ && $.hasOwnProperty('default') ? $['default'] : $;
  Popper = Popper && Popper.hasOwnProperty('default') ? Popper['default'] : Popper;

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.1.0): util.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Util = function ($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Private TransitionEnd Helpers
     * ------------------------------------------------------------------------
     */
    var TRANSITION_END = 'transitionend';
    var MAX_UID = 1000000;
    var MILLISECONDS_MULTIPLIER = 1000; // Shoutout AngusCroll (https://goo.gl/pxwQGp)

    function toType(obj) {
      return {}.toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
    }

    function getSpecialTransitionEndEvent() {
      return {
        bindType: TRANSITION_END,
        delegateType: TRANSITION_END,
        handle: function handle(event) {
          if ($$$1(event.target).is(this)) {
            return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
          }

          return undefined; // eslint-disable-line no-undefined
        }
      };
    }

    function transitionEndEmulator(duration) {
      var _this = this;

      var called = false;
      $$$1(this).one(Util.TRANSITION_END, function () {
        called = true;
      });
      setTimeout(function () {
        if (!called) {
          Util.triggerTransitionEnd(_this);
        }
      }, duration);
      return this;
    }

    function setTransitionEndSupport() {
      $$$1.fn.emulateTransitionEnd = transitionEndEmulator;
      $$$1.event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
    }
    /**
     * --------------------------------------------------------------------------
     * Public Util Api
     * --------------------------------------------------------------------------
     */


    var Util = {
      TRANSITION_END: 'bsTransitionEnd',
      getUID: function getUID(prefix) {
        do {
          // eslint-disable-next-line no-bitwise
          prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
        } while (document.getElementById(prefix));

        return prefix;
      },
      getSelectorFromElement: function getSelectorFromElement(element) {
        var selector = element.getAttribute('data-target');

        if (!selector || selector === '#') {
          selector = element.getAttribute('href') || '';
        }

        try {
          var $selector = $$$1(document).find(selector);
          return $selector.length > 0 ? selector : null;
        } catch (err) {
          return null;
        }
      },
      getTransitionDurationFromElement: function getTransitionDurationFromElement(element) {
        if (!element) {
          return 0;
        } // Get transition-duration of the element


        var transitionDuration = $$$1(element).css('transition-duration');
        var floatTransitionDuration = parseFloat(transitionDuration); // Return 0 if element or transition duration is not found

        if (!floatTransitionDuration) {
          return 0;
        } // If multiple durations are defined, take the first


        transitionDuration = transitionDuration.split(',')[0];
        return parseFloat(transitionDuration) * MILLISECONDS_MULTIPLIER;
      },
      reflow: function reflow(element) {
        return element.offsetHeight;
      },
      triggerTransitionEnd: function triggerTransitionEnd(element) {
        $$$1(element).trigger(TRANSITION_END);
      },
      // TODO: Remove in v5
      supportsTransitionEnd: function supportsTransitionEnd() {
        return Boolean(TRANSITION_END);
      },
      isElement: function isElement(obj) {
        return (obj[0] || obj).nodeType;
      },
      typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
        for (var property in configTypes) {
          if (Object.prototype.hasOwnProperty.call(configTypes, property)) {
            var expectedTypes = configTypes[property];
            var value = config[property];
            var valueType = value && Util.isElement(value) ? 'element' : toType(value);

            if (!new RegExp(expectedTypes).test(valueType)) {
              throw new Error(componentName.toUpperCase() + ": " + ("Option \"" + property + "\" provided type \"" + valueType + "\" ") + ("but expected type \"" + expectedTypes + "\"."));
            }
          }
        }
      }
    };
    setTransitionEndSupport();
    return Util;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.1.0): alert.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Alert = function ($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME = 'alert';
    var VERSION = '4.1.0';
    var DATA_KEY = 'bs.alert';
    var EVENT_KEY = "." + DATA_KEY;
    var DATA_API_KEY = '.data-api';
    var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
    var Selector = {
      DISMISS: '[data-dismiss="alert"]'
    };
    var Event = {
      CLOSE: "close" + EVENT_KEY,
      CLOSED: "closed" + EVENT_KEY,
      CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
    };
    var ClassName = {
      ALERT: 'alert',
      FADE: 'fade',
      SHOW: 'show'
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Alert =
    /*#__PURE__*/
    function () {
      function Alert(element) {
        this._element = element;
      } // Getters


      var _proto = Alert.prototype;

      // Public
      _proto.close = function close(element) {
        element = element || this._element;

        var rootElement = this._getRootElement(element);

        var customEvent = this._triggerCloseEvent(rootElement);

        if (customEvent.isDefaultPrevented()) {
          return;
        }

        this._removeElement(rootElement);
      };

      _proto.dispose = function dispose() {
        $$$1.removeData(this._element, DATA_KEY);
        this._element = null;
      }; // Private


      _proto._getRootElement = function _getRootElement(element) {
        var selector = Util.getSelectorFromElement(element);
        var parent = false;

        if (selector) {
          parent = $$$1(selector)[0];
        }

        if (!parent) {
          parent = $$$1(element).closest("." + ClassName.ALERT)[0];
        }

        return parent;
      };

      _proto._triggerCloseEvent = function _triggerCloseEvent(element) {
        var closeEvent = $$$1.Event(Event.CLOSE);
        $$$1(element).trigger(closeEvent);
        return closeEvent;
      };

      _proto._removeElement = function _removeElement(element) {
        var _this = this;

        $$$1(element).removeClass(ClassName.SHOW);

        if (!$$$1(element).hasClass(ClassName.FADE)) {
          this._destroyElement(element);

          return;
        }

        var transitionDuration = Util.getTransitionDurationFromElement(element);
        $$$1(element).one(Util.TRANSITION_END, function (event) {
          return _this._destroyElement(element, event);
        }).emulateTransitionEnd(transitionDuration);
      };

      _proto._destroyElement = function _destroyElement(element) {
        $$$1(element).detach().trigger(Event.CLOSED).remove();
      }; // Static


      Alert._jQueryInterface = function _jQueryInterface(config) {
        return this.each(function () {
          var $element = $$$1(this);
          var data = $element.data(DATA_KEY);

          if (!data) {
            data = new Alert(this);
            $element.data(DATA_KEY, data);
          }

          if (config === 'close') {
            data[config](this);
          }
        });
      };

      Alert._handleDismiss = function _handleDismiss(alertInstance) {
        return function (event) {
          if (event) {
            event.preventDefault();
          }

          alertInstance.close(this);
        };
      };

      _createClass(Alert, null, [{
        key: "VERSION",
        get: function get() {
          return VERSION;
        }
      }]);

      return Alert;
    }();
    /**
     * ------------------------------------------------------------------------
     * Data Api implementation
     * ------------------------------------------------------------------------
     */


    $$$1(document).on(Event.CLICK_DATA_API, Selector.DISMISS, Alert._handleDismiss(new Alert()));
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */

    $$$1.fn[NAME] = Alert._jQueryInterface;
    $$$1.fn[NAME].Constructor = Alert;

    $$$1.fn[NAME].noConflict = function () {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Alert._jQueryInterface;
    };

    return Alert;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.1.0): button.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Button = function ($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME = 'button';
    var VERSION = '4.1.0';
    var DATA_KEY = 'bs.button';
    var EVENT_KEY = "." + DATA_KEY;
    var DATA_API_KEY = '.data-api';
    var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
    var ClassName = {
      ACTIVE: 'active',
      BUTTON: 'btn',
      FOCUS: 'focus'
    };
    var Selector = {
      DATA_TOGGLE_CARROT: '[data-toggle^="button"]',
      DATA_TOGGLE: '[data-toggle="buttons"]',
      INPUT: 'input',
      ACTIVE: '.active',
      BUTTON: '.btn'
    };
    var Event = {
      CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY,
      FOCUS_BLUR_DATA_API: "focus" + EVENT_KEY + DATA_API_KEY + " " + ("blur" + EVENT_KEY + DATA_API_KEY)
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Button =
    /*#__PURE__*/
    function () {
      function Button(element) {
        this._element = element;
      } // Getters


      var _proto = Button.prototype;

      // Public
      _proto.toggle = function toggle() {
        var triggerChangeEvent = true;
        var addAriaPressed = true;
        var rootElement = $$$1(this._element).closest(Selector.DATA_TOGGLE)[0];

        if (rootElement) {
          var input = $$$1(this._element).find(Selector.INPUT)[0];

          if (input) {
            if (input.type === 'radio') {
              if (input.checked && $$$1(this._element).hasClass(ClassName.ACTIVE)) {
                triggerChangeEvent = false;
              } else {
                var activeElement = $$$1(rootElement).find(Selector.ACTIVE)[0];

                if (activeElement) {
                  $$$1(activeElement).removeClass(ClassName.ACTIVE);
                }
              }
            }

            if (triggerChangeEvent) {
              if (input.hasAttribute('disabled') || rootElement.hasAttribute('disabled') || input.classList.contains('disabled') || rootElement.classList.contains('disabled')) {
                return;
              }

              input.checked = !$$$1(this._element).hasClass(ClassName.ACTIVE);
              $$$1(input).trigger('change');
            }

            input.focus();
            addAriaPressed = false;
          }
        }

        if (addAriaPressed) {
          this._element.setAttribute('aria-pressed', !$$$1(this._element).hasClass(ClassName.ACTIVE));
        }

        if (triggerChangeEvent) {
          $$$1(this._element).toggleClass(ClassName.ACTIVE);
        }
      };

      _proto.dispose = function dispose() {
        $$$1.removeData(this._element, DATA_KEY);
        this._element = null;
      }; // Static


      Button._jQueryInterface = function _jQueryInterface(config) {
        return this.each(function () {
          var data = $$$1(this).data(DATA_KEY);

          if (!data) {
            data = new Button(this);
            $$$1(this).data(DATA_KEY, data);
          }

          if (config === 'toggle') {
            data[config]();
          }
        });
      };

      _createClass(Button, null, [{
        key: "VERSION",
        get: function get() {
          return VERSION;
        }
      }]);

      return Button;
    }();
    /**
     * ------------------------------------------------------------------------
     * Data Api implementation
     * ------------------------------------------------------------------------
     */


    $$$1(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE_CARROT, function (event) {
      event.preventDefault();
      var button = event.target;

      if (!$$$1(button).hasClass(ClassName.BUTTON)) {
        button = $$$1(button).closest(Selector.BUTTON);
      }

      Button._jQueryInterface.call($$$1(button), 'toggle');
    }).on(Event.FOCUS_BLUR_DATA_API, Selector.DATA_TOGGLE_CARROT, function (event) {
      var button = $$$1(event.target).closest(Selector.BUTTON)[0];
      $$$1(button).toggleClass(ClassName.FOCUS, /^focus(in)?$/.test(event.type));
    });
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */

    $$$1.fn[NAME] = Button._jQueryInterface;
    $$$1.fn[NAME].Constructor = Button;

    $$$1.fn[NAME].noConflict = function () {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Button._jQueryInterface;
    };

    return Button;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.1.0): carousel.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Carousel = function ($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME = 'carousel';
    var VERSION = '4.1.0';
    var DATA_KEY = 'bs.carousel';
    var EVENT_KEY = "." + DATA_KEY;
    var DATA_API_KEY = '.data-api';
    var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
    var ARROW_LEFT_KEYCODE = 37; // KeyboardEvent.which value for left arrow key

    var ARROW_RIGHT_KEYCODE = 39; // KeyboardEvent.which value for right arrow key

    var TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch

    var Default = {
      interval: 5000,
      keyboard: true,
      slide: false,
      pause: 'hover',
      wrap: true
    };
    var DefaultType = {
      interval: '(number|boolean)',
      keyboard: 'boolean',
      slide: '(boolean|string)',
      pause: '(string|boolean)',
      wrap: 'boolean'
    };
    var Direction = {
      NEXT: 'next',
      PREV: 'prev',
      LEFT: 'left',
      RIGHT: 'right'
    };
    var Event = {
      SLIDE: "slide" + EVENT_KEY,
      SLID: "slid" + EVENT_KEY,
      KEYDOWN: "keydown" + EVENT_KEY,
      MOUSEENTER: "mouseenter" + EVENT_KEY,
      MOUSELEAVE: "mouseleave" + EVENT_KEY,
      TOUCHEND: "touchend" + EVENT_KEY,
      LOAD_DATA_API: "load" + EVENT_KEY + DATA_API_KEY,
      CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
    };
    var ClassName = {
      CAROUSEL: 'carousel',
      ACTIVE: 'active',
      SLIDE: 'slide',
      RIGHT: 'carousel-item-right',
      LEFT: 'carousel-item-left',
      NEXT: 'carousel-item-next',
      PREV: 'carousel-item-prev',
      ITEM: 'carousel-item'
    };
    var Selector = {
      ACTIVE: '.active',
      ACTIVE_ITEM: '.active.carousel-item',
      ITEM: '.carousel-item',
      NEXT_PREV: '.carousel-item-next, .carousel-item-prev',
      INDICATORS: '.carousel-indicators',
      DATA_SLIDE: '[data-slide], [data-slide-to]',
      DATA_RIDE: '[data-ride="carousel"]'
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Carousel =
    /*#__PURE__*/
    function () {
      function Carousel(element, config) {
        this._items = null;
        this._interval = null;
        this._activeElement = null;
        this._isPaused = false;
        this._isSliding = false;
        this.touchTimeout = null;
        this._config = this._getConfig(config);
        this._element = $$$1(element)[0];
        this._indicatorsElement = $$$1(this._element).find(Selector.INDICATORS)[0];

        this._addEventListeners();
      } // Getters


      var _proto = Carousel.prototype;

      // Public
      _proto.next = function next() {
        if (!this._isSliding) {
          this._slide(Direction.NEXT);
        }
      };

      _proto.nextWhenVisible = function nextWhenVisible() {
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $$$1(this._element).is(':visible') && $$$1(this._element).css('visibility') !== 'hidden') {
          this.next();
        }
      };

      _proto.prev = function prev() {
        if (!this._isSliding) {
          this._slide(Direction.PREV);
        }
      };

      _proto.pause = function pause(event) {
        if (!event) {
          this._isPaused = true;
        }

        if ($$$1(this._element).find(Selector.NEXT_PREV)[0]) {
          Util.triggerTransitionEnd(this._element);
          this.cycle(true);
        }

        clearInterval(this._interval);
        this._interval = null;
      };

      _proto.cycle = function cycle(event) {
        if (!event) {
          this._isPaused = false;
        }

        if (this._interval) {
          clearInterval(this._interval);
          this._interval = null;
        }

        if (this._config.interval && !this._isPaused) {
          this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
        }
      };

      _proto.to = function to(index) {
        var _this = this;

        this._activeElement = $$$1(this._element).find(Selector.ACTIVE_ITEM)[0];

        var activeIndex = this._getItemIndex(this._activeElement);

        if (index > this._items.length - 1 || index < 0) {
          return;
        }

        if (this._isSliding) {
          $$$1(this._element).one(Event.SLID, function () {
            return _this.to(index);
          });
          return;
        }

        if (activeIndex === index) {
          this.pause();
          this.cycle();
          return;
        }

        var direction = index > activeIndex ? Direction.NEXT : Direction.PREV;

        this._slide(direction, this._items[index]);
      };

      _proto.dispose = function dispose() {
        $$$1(this._element).off(EVENT_KEY);
        $$$1.removeData(this._element, DATA_KEY);
        this._items = null;
        this._config = null;
        this._element = null;
        this._interval = null;
        this._isPaused = null;
        this._isSliding = null;
        this._activeElement = null;
        this._indicatorsElement = null;
      }; // Private


      _proto._getConfig = function _getConfig(config) {
        config = _objectSpread({}, Default, config);
        Util.typeCheckConfig(NAME, config, DefaultType);
        return config;
      };

      _proto._addEventListeners = function _addEventListeners() {
        var _this2 = this;

        if (this._config.keyboard) {
          $$$1(this._element).on(Event.KEYDOWN, function (event) {
            return _this2._keydown(event);
          });
        }

        if (this._config.pause === 'hover') {
          $$$1(this._element).on(Event.MOUSEENTER, function (event) {
            return _this2.pause(event);
          }).on(Event.MOUSELEAVE, function (event) {
            return _this2.cycle(event);
          });

          if ('ontouchstart' in document.documentElement) {
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            $$$1(this._element).on(Event.TOUCHEND, function () {
              _this2.pause();

              if (_this2.touchTimeout) {
                clearTimeout(_this2.touchTimeout);
              }

              _this2.touchTimeout = setTimeout(function (event) {
                return _this2.cycle(event);
              }, TOUCHEVENT_COMPAT_WAIT + _this2._config.interval);
            });
          }
        }
      };

      _proto._keydown = function _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) {
          return;
        }

        switch (event.which) {
          case ARROW_LEFT_KEYCODE:
            event.preventDefault();
            this.prev();
            break;

          case ARROW_RIGHT_KEYCODE:
            event.preventDefault();
            this.next();
            break;

          default:
        }
      };

      _proto._getItemIndex = function _getItemIndex(element) {
        this._items = $$$1.makeArray($$$1(element).parent().find(Selector.ITEM));
        return this._items.indexOf(element);
      };

      _proto._getItemByDirection = function _getItemByDirection(direction, activeElement) {
        var isNextDirection = direction === Direction.NEXT;
        var isPrevDirection = direction === Direction.PREV;

        var activeIndex = this._getItemIndex(activeElement);

        var lastItemIndex = this._items.length - 1;
        var isGoingToWrap = isPrevDirection && activeIndex === 0 || isNextDirection && activeIndex === lastItemIndex;

        if (isGoingToWrap && !this._config.wrap) {
          return activeElement;
        }

        var delta = direction === Direction.PREV ? -1 : 1;
        var itemIndex = (activeIndex + delta) % this._items.length;
        return itemIndex === -1 ? this._items[this._items.length - 1] : this._items[itemIndex];
      };

      _proto._triggerSlideEvent = function _triggerSlideEvent(relatedTarget, eventDirectionName) {
        var targetIndex = this._getItemIndex(relatedTarget);

        var fromIndex = this._getItemIndex($$$1(this._element).find(Selector.ACTIVE_ITEM)[0]);

        var slideEvent = $$$1.Event(Event.SLIDE, {
          relatedTarget: relatedTarget,
          direction: eventDirectionName,
          from: fromIndex,
          to: targetIndex
        });
        $$$1(this._element).trigger(slideEvent);
        return slideEvent;
      };

      _proto._setActiveIndicatorElement = function _setActiveIndicatorElement(element) {
        if (this._indicatorsElement) {
          $$$1(this._indicatorsElement).find(Selector.ACTIVE).removeClass(ClassName.ACTIVE);

          var nextIndicator = this._indicatorsElement.children[this._getItemIndex(element)];

          if (nextIndicator) {
            $$$1(nextIndicator).addClass(ClassName.ACTIVE);
          }
        }
      };

      _proto._slide = function _slide(direction, element) {
        var _this3 = this;

        var activeElement = $$$1(this._element).find(Selector.ACTIVE_ITEM)[0];

        var activeElementIndex = this._getItemIndex(activeElement);

        var nextElement = element || activeElement && this._getItemByDirection(direction, activeElement);

        var nextElementIndex = this._getItemIndex(nextElement);

        var isCycling = Boolean(this._interval);
        var directionalClassName;
        var orderClassName;
        var eventDirectionName;

        if (direction === Direction.NEXT) {
          directionalClassName = ClassName.LEFT;
          orderClassName = ClassName.NEXT;
          eventDirectionName = Direction.LEFT;
        } else {
          directionalClassName = ClassName.RIGHT;
          orderClassName = ClassName.PREV;
          eventDirectionName = Direction.RIGHT;
        }

        if (nextElement && $$$1(nextElement).hasClass(ClassName.ACTIVE)) {
          this._isSliding = false;
          return;
        }

        var slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);

        if (slideEvent.isDefaultPrevented()) {
          return;
        }

        if (!activeElement || !nextElement) {
          // Some weirdness is happening, so we bail
          return;
        }

        this._isSliding = true;

        if (isCycling) {
          this.pause();
        }

        this._setActiveIndicatorElement(nextElement);

        var slidEvent = $$$1.Event(Event.SLID, {
          relatedTarget: nextElement,
          direction: eventDirectionName,
          from: activeElementIndex,
          to: nextElementIndex
        });

        if ($$$1(this._element).hasClass(ClassName.SLIDE)) {
          $$$1(nextElement).addClass(orderClassName);
          Util.reflow(nextElement);
          $$$1(activeElement).addClass(directionalClassName);
          $$$1(nextElement).addClass(directionalClassName);
          var transitionDuration = Util.getTransitionDurationFromElement(activeElement);
          $$$1(activeElement).one(Util.TRANSITION_END, function () {
            $$$1(nextElement).removeClass(directionalClassName + " " + orderClassName).addClass(ClassName.ACTIVE);
            $$$1(activeElement).removeClass(ClassName.ACTIVE + " " + orderClassName + " " + directionalClassName);
            _this3._isSliding = false;
            setTimeout(function () {
              return $$$1(_this3._element).trigger(slidEvent);
            }, 0);
          }).emulateTransitionEnd(transitionDuration);
        } else {
          $$$1(activeElement).removeClass(ClassName.ACTIVE);
          $$$1(nextElement).addClass(ClassName.ACTIVE);
          this._isSliding = false;
          $$$1(this._element).trigger(slidEvent);
        }

        if (isCycling) {
          this.cycle();
        }
      }; // Static


      Carousel._jQueryInterface = function _jQueryInterface(config) {
        return this.each(function () {
          var data = $$$1(this).data(DATA_KEY);

          var _config = _objectSpread({}, Default, $$$1(this).data());

          if (typeof config === 'object') {
            _config = _objectSpread({}, _config, config);
          }

          var action = typeof config === 'string' ? config : _config.slide;

          if (!data) {
            data = new Carousel(this, _config);
            $$$1(this).data(DATA_KEY, data);
          }

          if (typeof config === 'number') {
            data.to(config);
          } else if (typeof action === 'string') {
            if (typeof data[action] === 'undefined') {
              throw new TypeError("No method named \"" + action + "\"");
            }

            data[action]();
          } else if (_config.interval) {
            data.pause();
            data.cycle();
          }
        });
      };

      Carousel._dataApiClickHandler = function _dataApiClickHandler(event) {
        var selector = Util.getSelectorFromElement(this);

        if (!selector) {
          return;
        }

        var target = $$$1(selector)[0];

        if (!target || !$$$1(target).hasClass(ClassName.CAROUSEL)) {
          return;
        }

        var config = _objectSpread({}, $$$1(target).data(), $$$1(this).data());

        var slideIndex = this.getAttribute('data-slide-to');

        if (slideIndex) {
          config.interval = false;
        }

        Carousel._jQueryInterface.call($$$1(target), config);

        if (slideIndex) {
          $$$1(target).data(DATA_KEY).to(slideIndex);
        }

        event.preventDefault();
      };

      _createClass(Carousel, null, [{
        key: "VERSION",
        get: function get() {
          return VERSION;
        }
      }, {
        key: "Default",
        get: function get() {
          return Default;
        }
      }]);

      return Carousel;
    }();
    /**
     * ------------------------------------------------------------------------
     * Data Api implementation
     * ------------------------------------------------------------------------
     */


    $$$1(document).on(Event.CLICK_DATA_API, Selector.DATA_SLIDE, Carousel._dataApiClickHandler);
    $$$1(window).on(Event.LOAD_DATA_API, function () {
      $$$1(Selector.DATA_RIDE).each(function () {
        var $carousel = $$$1(this);

        Carousel._jQueryInterface.call($carousel, $carousel.data());
      });
    });
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */

    $$$1.fn[NAME] = Carousel._jQueryInterface;
    $$$1.fn[NAME].Constructor = Carousel;

    $$$1.fn[NAME].noConflict = function () {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Carousel._jQueryInterface;
    };

    return Carousel;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.1.0): collapse.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Collapse = function ($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME = 'collapse';
    var VERSION = '4.1.0';
    var DATA_KEY = 'bs.collapse';
    var EVENT_KEY = "." + DATA_KEY;
    var DATA_API_KEY = '.data-api';
    var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
    var Default = {
      toggle: true,
      parent: ''
    };
    var DefaultType = {
      toggle: 'boolean',
      parent: '(string|element)'
    };
    var Event = {
      SHOW: "show" + EVENT_KEY,
      SHOWN: "shown" + EVENT_KEY,
      HIDE: "hide" + EVENT_KEY,
      HIDDEN: "hidden" + EVENT_KEY,
      CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
    };
    var ClassName = {
      SHOW: 'show',
      COLLAPSE: 'collapse',
      COLLAPSING: 'collapsing',
      COLLAPSED: 'collapsed'
    };
    var Dimension = {
      WIDTH: 'width',
      HEIGHT: 'height'
    };
    var Selector = {
      ACTIVES: '.show, .collapsing',
      DATA_TOGGLE: '[data-toggle="collapse"]'
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Collapse =
    /*#__PURE__*/
    function () {
      function Collapse(element, config) {
        this._isTransitioning = false;
        this._element = element;
        this._config = this._getConfig(config);
        this._triggerArray = $$$1.makeArray($$$1("[data-toggle=\"collapse\"][href=\"#" + element.id + "\"]," + ("[data-toggle=\"collapse\"][data-target=\"#" + element.id + "\"]")));
        var tabToggles = $$$1(Selector.DATA_TOGGLE);

        for (var i = 0; i < tabToggles.length; i++) {
          var elem = tabToggles[i];
          var selector = Util.getSelectorFromElement(elem);

          if (selector !== null && $$$1(selector).filter(element).length > 0) {
            this._selector = selector;

            this._triggerArray.push(elem);
          }
        }

        this._parent = this._config.parent ? this._getParent() : null;

        if (!this._config.parent) {
          this._addAriaAndCollapsedClass(this._element, this._triggerArray);
        }

        if (this._config.toggle) {
          this.toggle();
        }
      } // Getters


      var _proto = Collapse.prototype;

      // Public
      _proto.toggle = function toggle() {
        if ($$$1(this._element).hasClass(ClassName.SHOW)) {
          this.hide();
        } else {
          this.show();
        }
      };

      _proto.show = function show() {
        var _this = this;

        if (this._isTransitioning || $$$1(this._element).hasClass(ClassName.SHOW)) {
          return;
        }

        var actives;
        var activesData;

        if (this._parent) {
          actives = $$$1.makeArray($$$1(this._parent).find(Selector.ACTIVES).filter("[data-parent=\"" + this._config.parent + "\"]"));

          if (actives.length === 0) {
            actives = null;
          }
        }

        if (actives) {
          activesData = $$$1(actives).not(this._selector).data(DATA_KEY);

          if (activesData && activesData._isTransitioning) {
            return;
          }
        }

        var startEvent = $$$1.Event(Event.SHOW);
        $$$1(this._element).trigger(startEvent);

        if (startEvent.isDefaultPrevented()) {
          return;
        }

        if (actives) {
          Collapse._jQueryInterface.call($$$1(actives).not(this._selector), 'hide');

          if (!activesData) {
            $$$1(actives).data(DATA_KEY, null);
          }
        }

        var dimension = this._getDimension();

        $$$1(this._element).removeClass(ClassName.COLLAPSE).addClass(ClassName.COLLAPSING);
        this._element.style[dimension] = 0;

        if (this._triggerArray.length > 0) {
          $$$1(this._triggerArray).removeClass(ClassName.COLLAPSED).attr('aria-expanded', true);
        }

        this.setTransitioning(true);

        var complete = function complete() {
          $$$1(_this._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).addClass(ClassName.SHOW);
          _this._element.style[dimension] = '';

          _this.setTransitioning(false);

          $$$1(_this._element).trigger(Event.SHOWN);
        };

        var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        var scrollSize = "scroll" + capitalizedDimension;
        var transitionDuration = Util.getTransitionDurationFromElement(this._element);
        $$$1(this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
        this._element.style[dimension] = this._element[scrollSize] + "px";
      };

      _proto.hide = function hide() {
        var _this2 = this;

        if (this._isTransitioning || !$$$1(this._element).hasClass(ClassName.SHOW)) {
          return;
        }

        var startEvent = $$$1.Event(Event.HIDE);
        $$$1(this._element).trigger(startEvent);

        if (startEvent.isDefaultPrevented()) {
          return;
        }

        var dimension = this._getDimension();

        this._element.style[dimension] = this._element.getBoundingClientRect()[dimension] + "px";
        Util.reflow(this._element);
        $$$1(this._element).addClass(ClassName.COLLAPSING).removeClass(ClassName.COLLAPSE).removeClass(ClassName.SHOW);

        if (this._triggerArray.length > 0) {
          for (var i = 0; i < this._triggerArray.length; i++) {
            var trigger = this._triggerArray[i];
            var selector = Util.getSelectorFromElement(trigger);

            if (selector !== null) {
              var $elem = $$$1(selector);

              if (!$elem.hasClass(ClassName.SHOW)) {
                $$$1(trigger).addClass(ClassName.COLLAPSED).attr('aria-expanded', false);
              }
            }
          }
        }

        this.setTransitioning(true);

        var complete = function complete() {
          _this2.setTransitioning(false);

          $$$1(_this2._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).trigger(Event.HIDDEN);
        };

        this._element.style[dimension] = '';
        var transitionDuration = Util.getTransitionDurationFromElement(this._element);
        $$$1(this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
      };

      _proto.setTransitioning = function setTransitioning(isTransitioning) {
        this._isTransitioning = isTransitioning;
      };

      _proto.dispose = function dispose() {
        $$$1.removeData(this._element, DATA_KEY);
        this._config = null;
        this._parent = null;
        this._element = null;
        this._triggerArray = null;
        this._isTransitioning = null;
      }; // Private


      _proto._getConfig = function _getConfig(config) {
        config = _objectSpread({}, Default, config);
        config.toggle = Boolean(config.toggle); // Coerce string values

        Util.typeCheckConfig(NAME, config, DefaultType);
        return config;
      };

      _proto._getDimension = function _getDimension() {
        var hasWidth = $$$1(this._element).hasClass(Dimension.WIDTH);
        return hasWidth ? Dimension.WIDTH : Dimension.HEIGHT;
      };

      _proto._getParent = function _getParent() {
        var _this3 = this;

        var parent = null;

        if (Util.isElement(this._config.parent)) {
          parent = this._config.parent; // It's a jQuery object

          if (typeof this._config.parent.jquery !== 'undefined') {
            parent = this._config.parent[0];
          }
        } else {
          parent = $$$1(this._config.parent)[0];
        }

        var selector = "[data-toggle=\"collapse\"][data-parent=\"" + this._config.parent + "\"]";
        $$$1(parent).find(selector).each(function (i, element) {
          _this3._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [element]);
        });
        return parent;
      };

      _proto._addAriaAndCollapsedClass = function _addAriaAndCollapsedClass(element, triggerArray) {
        if (element) {
          var isOpen = $$$1(element).hasClass(ClassName.SHOW);

          if (triggerArray.length > 0) {
            $$$1(triggerArray).toggleClass(ClassName.COLLAPSED, !isOpen).attr('aria-expanded', isOpen);
          }
        }
      }; // Static


      Collapse._getTargetFromElement = function _getTargetFromElement(element) {
        var selector = Util.getSelectorFromElement(element);
        return selector ? $$$1(selector)[0] : null;
      };

      Collapse._jQueryInterface = function _jQueryInterface(config) {
        return this.each(function () {
          var $this = $$$1(this);
          var data = $this.data(DATA_KEY);

          var _config = _objectSpread({}, Default, $this.data(), typeof config === 'object' && config);

          if (!data && _config.toggle && /show|hide/.test(config)) {
            _config.toggle = false;
          }

          if (!data) {
            data = new Collapse(this, _config);
            $this.data(DATA_KEY, data);
          }

          if (typeof config === 'string') {
            if (typeof data[config] === 'undefined') {
              throw new TypeError("No method named \"" + config + "\"");
            }

            data[config]();
          }
        });
      };

      _createClass(Collapse, null, [{
        key: "VERSION",
        get: function get() {
          return VERSION;
        }
      }, {
        key: "Default",
        get: function get() {
          return Default;
        }
      }]);

      return Collapse;
    }();
    /**
     * ------------------------------------------------------------------------
     * Data Api implementation
     * ------------------------------------------------------------------------
     */


    $$$1(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
      // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
      if (event.currentTarget.tagName === 'A') {
        event.preventDefault();
      }

      var $trigger = $$$1(this);
      var selector = Util.getSelectorFromElement(this);
      $$$1(selector).each(function () {
        var $target = $$$1(this);
        var data = $target.data(DATA_KEY);
        var config = data ? 'toggle' : $trigger.data();

        Collapse._jQueryInterface.call($target, config);
      });
    });
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */

    $$$1.fn[NAME] = Collapse._jQueryInterface;
    $$$1.fn[NAME].Constructor = Collapse;

    $$$1.fn[NAME].noConflict = function () {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Collapse._jQueryInterface;
    };

    return Collapse;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.1.0): dropdown.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Dropdown = function ($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME = 'dropdown';
    var VERSION = '4.1.0';
    var DATA_KEY = 'bs.dropdown';
    var EVENT_KEY = "." + DATA_KEY;
    var DATA_API_KEY = '.data-api';
    var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
    var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key

    var SPACE_KEYCODE = 32; // KeyboardEvent.which value for space key

    var TAB_KEYCODE = 9; // KeyboardEvent.which value for tab key

    var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key

    var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key

    var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)

    var REGEXP_KEYDOWN = new RegExp(ARROW_UP_KEYCODE + "|" + ARROW_DOWN_KEYCODE + "|" + ESCAPE_KEYCODE);
    var Event = {
      HIDE: "hide" + EVENT_KEY,
      HIDDEN: "hidden" + EVENT_KEY,
      SHOW: "show" + EVENT_KEY,
      SHOWN: "shown" + EVENT_KEY,
      CLICK: "click" + EVENT_KEY,
      CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY,
      KEYDOWN_DATA_API: "keydown" + EVENT_KEY + DATA_API_KEY,
      KEYUP_DATA_API: "keyup" + EVENT_KEY + DATA_API_KEY
    };
    var ClassName = {
      DISABLED: 'disabled',
      SHOW: 'show',
      DROPUP: 'dropup',
      DROPRIGHT: 'dropright',
      DROPLEFT: 'dropleft',
      MENURIGHT: 'dropdown-menu-right',
      MENULEFT: 'dropdown-menu-left',
      POSITION_STATIC: 'position-static'
    };
    var Selector = {
      DATA_TOGGLE: '[data-toggle="dropdown"]',
      FORM_CHILD: '.dropdown form',
      MENU: '.dropdown-menu',
      NAVBAR_NAV: '.navbar-nav',
      VISIBLE_ITEMS: '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)'
    };
    var AttachmentMap = {
      TOP: 'top-start',
      TOPEND: 'top-end',
      BOTTOM: 'bottom-start',
      BOTTOMEND: 'bottom-end',
      RIGHT: 'right-start',
      RIGHTEND: 'right-end',
      LEFT: 'left-start',
      LEFTEND: 'left-end'
    };
    var Default = {
      offset: 0,
      flip: true,
      boundary: 'scrollParent',
      reference: 'toggle',
      display: 'dynamic'
    };
    var DefaultType = {
      offset: '(number|string|function)',
      flip: 'boolean',
      boundary: '(string|element)',
      reference: '(string|element)',
      display: 'string'
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Dropdown =
    /*#__PURE__*/
    function () {
      function Dropdown(element, config) {
        this._element = element;
        this._popper = null;
        this._config = this._getConfig(config);
        this._menu = this._getMenuElement();
        this._inNavbar = this._detectNavbar();

        this._addEventListeners();
      } // Getters


      var _proto = Dropdown.prototype;

      // Public
      _proto.toggle = function toggle() {
        if (this._element.disabled || $$$1(this._element).hasClass(ClassName.DISABLED)) {
          return;
        }

        var parent = Dropdown._getParentFromElement(this._element);

        var isActive = $$$1(this._menu).hasClass(ClassName.SHOW);

        Dropdown._clearMenus();

        if (isActive) {
          return;
        }

        var relatedTarget = {
          relatedTarget: this._element
        };
        var showEvent = $$$1.Event(Event.SHOW, relatedTarget);
        $$$1(parent).trigger(showEvent);

        if (showEvent.isDefaultPrevented()) {
          return;
        } // Disable totally Popper.js for Dropdown in Navbar


        if (!this._inNavbar) {
          /**
           * Check for Popper dependency
           * Popper - https://popper.js.org
           */
          if (typeof Popper === 'undefined') {
            throw new TypeError('Bootstrap dropdown require Popper.js (https://popper.js.org)');
          }

          var referenceElement = this._element;

          if (this._config.reference === 'parent') {
            referenceElement = parent;
          } else if (Util.isElement(this._config.reference)) {
            referenceElement = this._config.reference; // Check if it's jQuery element

            if (typeof this._config.reference.jquery !== 'undefined') {
              referenceElement = this._config.reference[0];
            }
          } // If boundary is not `scrollParent`, then set position to `static`
          // to allow the menu to "escape" the scroll parent's boundaries
          // https://github.com/twbs/bootstrap/issues/24251


          if (this._config.boundary !== 'scrollParent') {
            $$$1(parent).addClass(ClassName.POSITION_STATIC);
          }

          this._popper = new Popper(referenceElement, this._menu, this._getPopperConfig());
        } // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html


        if ('ontouchstart' in document.documentElement && $$$1(parent).closest(Selector.NAVBAR_NAV).length === 0) {
          $$$1(document.body).children().on('mouseover', null, $$$1.noop);
        }

        this._element.focus();

        this._element.setAttribute('aria-expanded', true);

        $$$1(this._menu).toggleClass(ClassName.SHOW);
        $$$1(parent).toggleClass(ClassName.SHOW).trigger($$$1.Event(Event.SHOWN, relatedTarget));
      };

      _proto.dispose = function dispose() {
        $$$1.removeData(this._element, DATA_KEY);
        $$$1(this._element).off(EVENT_KEY);
        this._element = null;
        this._menu = null;

        if (this._popper !== null) {
          this._popper.destroy();

          this._popper = null;
        }
      };

      _proto.update = function update() {
        this._inNavbar = this._detectNavbar();

        if (this._popper !== null) {
          this._popper.scheduleUpdate();
        }
      }; // Private


      _proto._addEventListeners = function _addEventListeners() {
        var _this = this;

        $$$1(this._element).on(Event.CLICK, function (event) {
          event.preventDefault();
          event.stopPropagation();

          _this.toggle();
        });
      };

      _proto._getConfig = function _getConfig(config) {
        config = _objectSpread({}, this.constructor.Default, $$$1(this._element).data(), config);
        Util.typeCheckConfig(NAME, config, this.constructor.DefaultType);
        return config;
      };

      _proto._getMenuElement = function _getMenuElement() {
        if (!this._menu) {
          var parent = Dropdown._getParentFromElement(this._element);

          this._menu = $$$1(parent).find(Selector.MENU)[0];
        }

        return this._menu;
      };

      _proto._getPlacement = function _getPlacement() {
        var $parentDropdown = $$$1(this._element).parent();
        var placement = AttachmentMap.BOTTOM; // Handle dropup

        if ($parentDropdown.hasClass(ClassName.DROPUP)) {
          placement = AttachmentMap.TOP;

          if ($$$1(this._menu).hasClass(ClassName.MENURIGHT)) {
            placement = AttachmentMap.TOPEND;
          }
        } else if ($parentDropdown.hasClass(ClassName.DROPRIGHT)) {
          placement = AttachmentMap.RIGHT;
        } else if ($parentDropdown.hasClass(ClassName.DROPLEFT)) {
          placement = AttachmentMap.LEFT;
        } else if ($$$1(this._menu).hasClass(ClassName.MENURIGHT)) {
          placement = AttachmentMap.BOTTOMEND;
        }

        return placement;
      };

      _proto._detectNavbar = function _detectNavbar() {
        return $$$1(this._element).closest('.navbar').length > 0;
      };

      _proto._getPopperConfig = function _getPopperConfig() {
        var _this2 = this;

        var offsetConf = {};

        if (typeof this._config.offset === 'function') {
          offsetConf.fn = function (data) {
            data.offsets = _objectSpread({}, data.offsets, _this2._config.offset(data.offsets) || {});
            return data;
          };
        } else {
          offsetConf.offset = this._config.offset;
        }

        var popperConfig = {
          placement: this._getPlacement(),
          modifiers: {
            offset: offsetConf,
            flip: {
              enabled: this._config.flip
            },
            preventOverflow: {
              boundariesElement: this._config.boundary
            }
          } // Disable Popper.js if we have a static display

        };

        if (this._config.display === 'static') {
          popperConfig.modifiers.applyStyle = {
            enabled: false
          };
        }

        return popperConfig;
      }; // Static


      Dropdown._jQueryInterface = function _jQueryInterface(config) {
        return this.each(function () {
          var data = $$$1(this).data(DATA_KEY);

          var _config = typeof config === 'object' ? config : null;

          if (!data) {
            data = new Dropdown(this, _config);
            $$$1(this).data(DATA_KEY, data);
          }

          if (typeof config === 'string') {
            if (typeof data[config] === 'undefined') {
              throw new TypeError("No method named \"" + config + "\"");
            }

            data[config]();
          }
        });
      };

      Dropdown._clearMenus = function _clearMenus(event) {
        if (event && (event.which === RIGHT_MOUSE_BUTTON_WHICH || event.type === 'keyup' && event.which !== TAB_KEYCODE)) {
          return;
        }

        var toggles = $$$1.makeArray($$$1(Selector.DATA_TOGGLE));

        for (var i = 0; i < toggles.length; i++) {
          var parent = Dropdown._getParentFromElement(toggles[i]);

          var context = $$$1(toggles[i]).data(DATA_KEY);
          var relatedTarget = {
            relatedTarget: toggles[i]
          };

          if (!context) {
            continue;
          }

          var dropdownMenu = context._menu;

          if (!$$$1(parent).hasClass(ClassName.SHOW)) {
            continue;
          }

          if (event && (event.type === 'click' && /input|textarea/i.test(event.target.tagName) || event.type === 'keyup' && event.which === TAB_KEYCODE) && $$$1.contains(parent, event.target)) {
            continue;
          }

          var hideEvent = $$$1.Event(Event.HIDE, relatedTarget);
          $$$1(parent).trigger(hideEvent);

          if (hideEvent.isDefaultPrevented()) {
            continue;
          } // If this is a touch-enabled device we remove the extra
          // empty mouseover listeners we added for iOS support


          if ('ontouchstart' in document.documentElement) {
            $$$1(document.body).children().off('mouseover', null, $$$1.noop);
          }

          toggles[i].setAttribute('aria-expanded', 'false');
          $$$1(dropdownMenu).removeClass(ClassName.SHOW);
          $$$1(parent).removeClass(ClassName.SHOW).trigger($$$1.Event(Event.HIDDEN, relatedTarget));
        }
      };

      Dropdown._getParentFromElement = function _getParentFromElement(element) {
        var parent;
        var selector = Util.getSelectorFromElement(element);

        if (selector) {
          parent = $$$1(selector)[0];
        }

        return parent || element.parentNode;
      }; // eslint-disable-next-line complexity


      Dropdown._dataApiKeydownHandler = function _dataApiKeydownHandler(event) {
        // If not input/textarea:
        //  - And not a key in REGEXP_KEYDOWN => not a dropdown command
        // If input/textarea:
        //  - If space key => not a dropdown command
        //  - If key is other than escape
        //    - If key is not up or down => not a dropdown command
        //    - If trigger inside the menu => not a dropdown command
        if (/input|textarea/i.test(event.target.tagName) ? event.which === SPACE_KEYCODE || event.which !== ESCAPE_KEYCODE && (event.which !== ARROW_DOWN_KEYCODE && event.which !== ARROW_UP_KEYCODE || $$$1(event.target).closest(Selector.MENU).length) : !REGEXP_KEYDOWN.test(event.which)) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        if (this.disabled || $$$1(this).hasClass(ClassName.DISABLED)) {
          return;
        }

        var parent = Dropdown._getParentFromElement(this);

        var isActive = $$$1(parent).hasClass(ClassName.SHOW);

        if (!isActive && (event.which !== ESCAPE_KEYCODE || event.which !== SPACE_KEYCODE) || isActive && (event.which === ESCAPE_KEYCODE || event.which === SPACE_KEYCODE)) {
          if (event.which === ESCAPE_KEYCODE) {
            var toggle = $$$1(parent).find(Selector.DATA_TOGGLE)[0];
            $$$1(toggle).trigger('focus');
          }

          $$$1(this).trigger('click');
          return;
        }

        var items = $$$1(parent).find(Selector.VISIBLE_ITEMS).get();

        if (items.length === 0) {
          return;
        }

        var index = items.indexOf(event.target);

        if (event.which === ARROW_UP_KEYCODE && index > 0) {
          // Up
          index--;
        }

        if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) {
          // Down
          index++;
        }

        if (index < 0) {
          index = 0;
        }

        items[index].focus();
      };

      _createClass(Dropdown, null, [{
        key: "VERSION",
        get: function get() {
          return VERSION;
        }
      }, {
        key: "Default",
        get: function get() {
          return Default;
        }
      }, {
        key: "DefaultType",
        get: function get() {
          return DefaultType;
        }
      }]);

      return Dropdown;
    }();
    /**
     * ------------------------------------------------------------------------
     * Data Api implementation
     * ------------------------------------------------------------------------
     */


    $$$1(document).on(Event.KEYDOWN_DATA_API, Selector.DATA_TOGGLE, Dropdown._dataApiKeydownHandler).on(Event.KEYDOWN_DATA_API, Selector.MENU, Dropdown._dataApiKeydownHandler).on(Event.CLICK_DATA_API + " " + Event.KEYUP_DATA_API, Dropdown._clearMenus).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
      event.preventDefault();
      event.stopPropagation();

      Dropdown._jQueryInterface.call($$$1(this), 'toggle');
    }).on(Event.CLICK_DATA_API, Selector.FORM_CHILD, function (e) {
      e.stopPropagation();
    });
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */

    $$$1.fn[NAME] = Dropdown._jQueryInterface;
    $$$1.fn[NAME].Constructor = Dropdown;

    $$$1.fn[NAME].noConflict = function () {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Dropdown._jQueryInterface;
    };

    return Dropdown;
  }($, Popper);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.1.0): modal.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Modal = function ($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME = 'modal';
    var VERSION = '4.1.0';
    var DATA_KEY = 'bs.modal';
    var EVENT_KEY = "." + DATA_KEY;
    var DATA_API_KEY = '.data-api';
    var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
    var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key

    var Default = {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: true
    };
    var DefaultType = {
      backdrop: '(boolean|string)',
      keyboard: 'boolean',
      focus: 'boolean',
      show: 'boolean'
    };
    var Event = {
      HIDE: "hide" + EVENT_KEY,
      HIDDEN: "hidden" + EVENT_KEY,
      SHOW: "show" + EVENT_KEY,
      SHOWN: "shown" + EVENT_KEY,
      FOCUSIN: "focusin" + EVENT_KEY,
      RESIZE: "resize" + EVENT_KEY,
      CLICK_DISMISS: "click.dismiss" + EVENT_KEY,
      KEYDOWN_DISMISS: "keydown.dismiss" + EVENT_KEY,
      MOUSEUP_DISMISS: "mouseup.dismiss" + EVENT_KEY,
      MOUSEDOWN_DISMISS: "mousedown.dismiss" + EVENT_KEY,
      CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
    };
    var ClassName = {
      SCROLLBAR_MEASURER: 'modal-scrollbar-measure',
      BACKDROP: 'modal-backdrop',
      OPEN: 'modal-open',
      FADE: 'fade',
      SHOW: 'show'
    };
    var Selector = {
      DIALOG: '.modal-dialog',
      DATA_TOGGLE: '[data-toggle="modal"]',
      DATA_DISMISS: '[data-dismiss="modal"]',
      FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
      STICKY_CONTENT: '.sticky-top',
      NAVBAR_TOGGLER: '.navbar-toggler'
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Modal =
    /*#__PURE__*/
    function () {
      function Modal(element, config) {
        this._config = this._getConfig(config);
        this._element = element;
        this._dialog = $$$1(element).find(Selector.DIALOG)[0];
        this._backdrop = null;
        this._isShown = false;
        this._isBodyOverflowing = false;
        this._ignoreBackdropClick = false;
        this._scrollbarWidth = 0;
      } // Getters


      var _proto = Modal.prototype;

      // Public
      _proto.toggle = function toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
      };

      _proto.show = function show(relatedTarget) {
        var _this = this;

        if (this._isTransitioning || this._isShown) {
          return;
        }

        if ($$$1(this._element).hasClass(ClassName.FADE)) {
          this._isTransitioning = true;
        }

        var showEvent = $$$1.Event(Event.SHOW, {
          relatedTarget: relatedTarget
        });
        $$$1(this._element).trigger(showEvent);

        if (this._isShown || showEvent.isDefaultPrevented()) {
          return;
        }

        this._isShown = true;

        this._checkScrollbar();

        this._setScrollbar();

        this._adjustDialog();

        $$$1(document.body).addClass(ClassName.OPEN);

        this._setEscapeEvent();

        this._setResizeEvent();

        $$$1(this._element).on(Event.CLICK_DISMISS, Selector.DATA_DISMISS, function (event) {
          return _this.hide(event);
        });
        $$$1(this._dialog).on(Event.MOUSEDOWN_DISMISS, function () {
          $$$1(_this._element).one(Event.MOUSEUP_DISMISS, function (event) {
            if ($$$1(event.target).is(_this._element)) {
              _this._ignoreBackdropClick = true;
            }
          });
        });

        this._showBackdrop(function () {
          return _this._showElement(relatedTarget);
        });
      };

      _proto.hide = function hide(event) {
        var _this2 = this;

        if (event) {
          event.preventDefault();
        }

        if (this._isTransitioning || !this._isShown) {
          return;
        }

        var hideEvent = $$$1.Event(Event.HIDE);
        $$$1(this._element).trigger(hideEvent);

        if (!this._isShown || hideEvent.isDefaultPrevented()) {
          return;
        }

        this._isShown = false;
        var transition = $$$1(this._element).hasClass(ClassName.FADE);

        if (transition) {
          this._isTransitioning = true;
        }

        this._setEscapeEvent();

        this._setResizeEvent();

        $$$1(document).off(Event.FOCUSIN);
        $$$1(this._element).removeClass(ClassName.SHOW);
        $$$1(this._element).off(Event.CLICK_DISMISS);
        $$$1(this._dialog).off(Event.MOUSEDOWN_DISMISS);

        if (transition) {
          var transitionDuration = Util.getTransitionDurationFromElement(this._element);
          $$$1(this._element).one(Util.TRANSITION_END, function (event) {
            return _this2._hideModal(event);
          }).emulateTransitionEnd(transitionDuration);
        } else {
          this._hideModal();
        }
      };

      _proto.dispose = function dispose() {
        $$$1.removeData(this._element, DATA_KEY);
        $$$1(window, document, this._element, this._backdrop).off(EVENT_KEY);
        this._config = null;
        this._element = null;
        this._dialog = null;
        this._backdrop = null;
        this._isShown = null;
        this._isBodyOverflowing = null;
        this._ignoreBackdropClick = null;
        this._scrollbarWidth = null;
      };

      _proto.handleUpdate = function handleUpdate() {
        this._adjustDialog();
      }; // Private


      _proto._getConfig = function _getConfig(config) {
        config = _objectSpread({}, Default, config);
        Util.typeCheckConfig(NAME, config, DefaultType);
        return config;
      };

      _proto._showElement = function _showElement(relatedTarget) {
        var _this3 = this;

        var transition = $$$1(this._element).hasClass(ClassName.FADE);

        if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) {
          // Don't move modal's DOM position
          document.body.appendChild(this._element);
        }

        this._element.style.display = 'block';

        this._element.removeAttribute('aria-hidden');

        this._element.scrollTop = 0;

        if (transition) {
          Util.reflow(this._element);
        }

        $$$1(this._element).addClass(ClassName.SHOW);

        if (this._config.focus) {
          this._enforceFocus();
        }

        var shownEvent = $$$1.Event(Event.SHOWN, {
          relatedTarget: relatedTarget
        });

        var transitionComplete = function transitionComplete() {
          if (_this3._config.focus) {
            _this3._element.focus();
          }

          _this3._isTransitioning = false;
          $$$1(_this3._element).trigger(shownEvent);
        };

        if (transition) {
          var transitionDuration = Util.getTransitionDurationFromElement(this._element);
          $$$1(this._dialog).one(Util.TRANSITION_END, transitionComplete).emulateTransitionEnd(transitionDuration);
        } else {
          transitionComplete();
        }
      };

      _proto._enforceFocus = function _enforceFocus() {
        var _this4 = this;

        $$$1(document).off(Event.FOCUSIN) // Guard against infinite focus loop
        .on(Event.FOCUSIN, function (event) {
          if (document !== event.target && _this4._element !== event.target && $$$1(_this4._element).has(event.target).length === 0) {
            _this4._element.focus();
          }
        });
      };

      _proto._setEscapeEvent = function _setEscapeEvent() {
        var _this5 = this;

        if (this._isShown && this._config.keyboard) {
          $$$1(this._element).on(Event.KEYDOWN_DISMISS, function (event) {
            if (event.which === ESCAPE_KEYCODE) {
              event.preventDefault();

              _this5.hide();
            }
          });
        } else if (!this._isShown) {
          $$$1(this._element).off(Event.KEYDOWN_DISMISS);
        }
      };

      _proto._setResizeEvent = function _setResizeEvent() {
        var _this6 = this;

        if (this._isShown) {
          $$$1(window).on(Event.RESIZE, function (event) {
            return _this6.handleUpdate(event);
          });
        } else {
          $$$1(window).off(Event.RESIZE);
        }
      };

      _proto._hideModal = function _hideModal() {
        var _this7 = this;

        this._element.style.display = 'none';

        this._element.setAttribute('aria-hidden', true);

        this._isTransitioning = false;

        this._showBackdrop(function () {
          $$$1(document.body).removeClass(ClassName.OPEN);

          _this7._resetAdjustments();

          _this7._resetScrollbar();

          $$$1(_this7._element).trigger(Event.HIDDEN);
        });
      };

      _proto._removeBackdrop = function _removeBackdrop() {
        if (this._backdrop) {
          $$$1(this._backdrop).remove();
          this._backdrop = null;
        }
      };

      _proto._showBackdrop = function _showBackdrop(callback) {
        var _this8 = this;

        var animate = $$$1(this._element).hasClass(ClassName.FADE) ? ClassName.FADE : '';

        if (this._isShown && this._config.backdrop) {
          this._backdrop = document.createElement('div');
          this._backdrop.className = ClassName.BACKDROP;

          if (animate) {
            $$$1(this._backdrop).addClass(animate);
          }

          $$$1(this._backdrop).appendTo(document.body);
          $$$1(this._element).on(Event.CLICK_DISMISS, function (event) {
            if (_this8._ignoreBackdropClick) {
              _this8._ignoreBackdropClick = false;
              return;
            }

            if (event.target !== event.currentTarget) {
              return;
            }

            if (_this8._config.backdrop === 'static') {
              _this8._element.focus();
            } else {
              _this8.hide();
            }
          });

          if (animate) {
            Util.reflow(this._backdrop);
          }

          $$$1(this._backdrop).addClass(ClassName.SHOW);

          if (!callback) {
            return;
          }

          if (!animate) {
            callback();
            return;
          }

          var backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);
          $$$1(this._backdrop).one(Util.TRANSITION_END, callback).emulateTransitionEnd(backdropTransitionDuration);
        } else if (!this._isShown && this._backdrop) {
          $$$1(this._backdrop).removeClass(ClassName.SHOW);

          var callbackRemove = function callbackRemove() {
            _this8._removeBackdrop();

            if (callback) {
              callback();
            }
          };

          if ($$$1(this._element).hasClass(ClassName.FADE)) {
            var _backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);

            $$$1(this._backdrop).one(Util.TRANSITION_END, callbackRemove).emulateTransitionEnd(_backdropTransitionDuration);
          } else {
            callbackRemove();
          }
        } else if (callback) {
          callback();
        }
      }; // ----------------------------------------------------------------------
      // the following methods are used to handle overflowing modals
      // todo (fat): these should probably be refactored out of modal.js
      // ----------------------------------------------------------------------


      _proto._adjustDialog = function _adjustDialog() {
        var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;

        if (!this._isBodyOverflowing && isModalOverflowing) {
          this._element.style.paddingLeft = this._scrollbarWidth + "px";
        }

        if (this._isBodyOverflowing && !isModalOverflowing) {
          this._element.style.paddingRight = this._scrollbarWidth + "px";
        }
      };

      _proto._resetAdjustments = function _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
      };

      _proto._checkScrollbar = function _checkScrollbar() {
        var rect = document.body.getBoundingClientRect();
        this._isBodyOverflowing = rect.left + rect.right < window.innerWidth;
        this._scrollbarWidth = this._getScrollbarWidth();
      };

      _proto._setScrollbar = function _setScrollbar() {
        var _this9 = this;

        if (this._isBodyOverflowing) {
          // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
          //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
          // Adjust fixed content padding
          $$$1(Selector.FIXED_CONTENT).each(function (index, element) {
            var actualPadding = $$$1(element)[0].style.paddingRight;
            var calculatedPadding = $$$1(element).css('padding-right');
            $$$1(element).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + _this9._scrollbarWidth + "px");
          }); // Adjust sticky content margin

          $$$1(Selector.STICKY_CONTENT).each(function (index, element) {
            var actualMargin = $$$1(element)[0].style.marginRight;
            var calculatedMargin = $$$1(element).css('margin-right');
            $$$1(element).data('margin-right', actualMargin).css('margin-right', parseFloat(calculatedMargin) - _this9._scrollbarWidth + "px");
          }); // Adjust navbar-toggler margin

          $$$1(Selector.NAVBAR_TOGGLER).each(function (index, element) {
            var actualMargin = $$$1(element)[0].style.marginRight;
            var calculatedMargin = $$$1(element).css('margin-right');
            $$$1(element).data('margin-right', actualMargin).css('margin-right', parseFloat(calculatedMargin) + _this9._scrollbarWidth + "px");
          }); // Adjust body padding

          var actualPadding = document.body.style.paddingRight;
          var calculatedPadding = $$$1(document.body).css('padding-right');
          $$$1(document.body).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + this._scrollbarWidth + "px");
        }
      };

      _proto._resetScrollbar = function _resetScrollbar() {
        // Restore fixed content padding
        $$$1(Selector.FIXED_CONTENT).each(function (index, element) {
          var padding = $$$1(element).data('padding-right');

          if (typeof padding !== 'undefined') {
            $$$1(element).css('padding-right', padding).removeData('padding-right');
          }
        }); // Restore sticky content and navbar-toggler margin

        $$$1(Selector.STICKY_CONTENT + ", " + Selector.NAVBAR_TOGGLER).each(function (index, element) {
          var margin = $$$1(element).data('margin-right');

          if (typeof margin !== 'undefined') {
            $$$1(element).css('margin-right', margin).removeData('margin-right');
          }
        }); // Restore body padding

        var padding = $$$1(document.body).data('padding-right');

        if (typeof padding !== 'undefined') {
          $$$1(document.body).css('padding-right', padding).removeData('padding-right');
        }
      };

      _proto._getScrollbarWidth = function _getScrollbarWidth() {
        // thx d.walsh
        var scrollDiv = document.createElement('div');
        scrollDiv.className = ClassName.SCROLLBAR_MEASURER;
        document.body.appendChild(scrollDiv);
        var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
        return scrollbarWidth;
      }; // Static


      Modal._jQueryInterface = function _jQueryInterface(config, relatedTarget) {
        return this.each(function () {
          var data = $$$1(this).data(DATA_KEY);

          var _config = _objectSpread({}, Modal.Default, $$$1(this).data(), typeof config === 'object' && config);

          if (!data) {
            data = new Modal(this, _config);
            $$$1(this).data(DATA_KEY, data);
          }

          if (typeof config === 'string') {
            if (typeof data[config] === 'undefined') {
              throw new TypeError("No method named \"" + config + "\"");
            }

            data[config](relatedTarget);
          } else if (_config.show) {
            data.show(relatedTarget);
          }
        });
      };

      _createClass(Modal, null, [{
        key: "VERSION",
        get: function get() {
          return VERSION;
        }
      }, {
        key: "Default",
        get: function get() {
          return Default;
        }
      }]);

      return Modal;
    }();
    /**
     * ------------------------------------------------------------------------
     * Data Api implementation
     * ------------------------------------------------------------------------
     */


    $$$1(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
      var _this10 = this;

      var target;
      var selector = Util.getSelectorFromElement(this);

      if (selector) {
        target = $$$1(selector)[0];
      }

      var config = $$$1(target).data(DATA_KEY) ? 'toggle' : _objectSpread({}, $$$1(target).data(), $$$1(this).data());

      if (this.tagName === 'A' || this.tagName === 'AREA') {
        event.preventDefault();
      }

      var $target = $$$1(target).one(Event.SHOW, function (showEvent) {
        if (showEvent.isDefaultPrevented()) {
          // Only register focus restorer if modal will actually get shown
          return;
        }

        $target.one(Event.HIDDEN, function () {
          if ($$$1(_this10).is(':visible')) {
            _this10.focus();
          }
        });
      });

      Modal._jQueryInterface.call($$$1(target), config, this);
    });
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */

    $$$1.fn[NAME] = Modal._jQueryInterface;
    $$$1.fn[NAME].Constructor = Modal;

    $$$1.fn[NAME].noConflict = function () {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Modal._jQueryInterface;
    };

    return Modal;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.1.0): tooltip.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Tooltip = function ($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME = 'tooltip';
    var VERSION = '4.1.0';
    var DATA_KEY = 'bs.tooltip';
    var EVENT_KEY = "." + DATA_KEY;
    var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
    var CLASS_PREFIX = 'bs-tooltip';
    var BSCLS_PREFIX_REGEX = new RegExp("(^|\\s)" + CLASS_PREFIX + "\\S+", 'g');
    var DefaultType = {
      animation: 'boolean',
      template: 'string',
      title: '(string|element|function)',
      trigger: 'string',
      delay: '(number|object)',
      html: 'boolean',
      selector: '(string|boolean)',
      placement: '(string|function)',
      offset: '(number|string)',
      container: '(string|element|boolean)',
      fallbackPlacement: '(string|array)',
      boundary: '(string|element)'
    };
    var AttachmentMap = {
      AUTO: 'auto',
      TOP: 'top',
      RIGHT: 'right',
      BOTTOM: 'bottom',
      LEFT: 'left'
    };
    var Default = {
      animation: true,
      template: '<div class="tooltip" role="tooltip">' + '<div class="arrow"></div>' + '<div class="tooltip-inner"></div></div>',
      trigger: 'hover focus',
      title: '',
      delay: 0,
      html: false,
      selector: false,
      placement: 'top',
      offset: 0,
      container: false,
      fallbackPlacement: 'flip',
      boundary: 'scrollParent'
    };
    var HoverState = {
      SHOW: 'show',
      OUT: 'out'
    };
    var Event = {
      HIDE: "hide" + EVENT_KEY,
      HIDDEN: "hidden" + EVENT_KEY,
      SHOW: "show" + EVENT_KEY,
      SHOWN: "shown" + EVENT_KEY,
      INSERTED: "inserted" + EVENT_KEY,
      CLICK: "click" + EVENT_KEY,
      FOCUSIN: "focusin" + EVENT_KEY,
      FOCUSOUT: "focusout" + EVENT_KEY,
      MOUSEENTER: "mouseenter" + EVENT_KEY,
      MOUSELEAVE: "mouseleave" + EVENT_KEY
    };
    var ClassName = {
      FADE: 'fade',
      SHOW: 'show'
    };
    var Selector = {
      TOOLTIP: '.tooltip',
      TOOLTIP_INNER: '.tooltip-inner',
      ARROW: '.arrow'
    };
    var Trigger = {
      HOVER: 'hover',
      FOCUS: 'focus',
      CLICK: 'click',
      MANUAL: 'manual'
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Tooltip =
    /*#__PURE__*/
    function () {
      function Tooltip(element, config) {
        /**
         * Check for Popper dependency
         * Popper - https://popper.js.org
         */
        if (typeof Popper === 'undefined') {
          throw new TypeError('Bootstrap tooltips require Popper.js (https://popper.js.org)');
        } // private


        this._isEnabled = true;
        this._timeout = 0;
        this._hoverState = '';
        this._activeTrigger = {};
        this._popper = null; // Protected

        this.element = element;
        this.config = this._getConfig(config);
        this.tip = null;

        this._setListeners();
      } // Getters


      var _proto = Tooltip.prototype;

      // Public
      _proto.enable = function enable() {
        this._isEnabled = true;
      };

      _proto.disable = function disable() {
        this._isEnabled = false;
      };

      _proto.toggleEnabled = function toggleEnabled() {
        this._isEnabled = !this._isEnabled;
      };

      _proto.toggle = function toggle(event) {
        if (!this._isEnabled) {
          return;
        }

        if (event) {
          var dataKey = this.constructor.DATA_KEY;
          var context = $$$1(event.currentTarget).data(dataKey);

          if (!context) {
            context = new this.constructor(event.currentTarget, this._getDelegateConfig());
            $$$1(event.currentTarget).data(dataKey, context);
          }

          context._activeTrigger.click = !context._activeTrigger.click;

          if (context._isWithActiveTrigger()) {
            context._enter(null, context);
          } else {
            context._leave(null, context);
          }
        } else {
          if ($$$1(this.getTipElement()).hasClass(ClassName.SHOW)) {
            this._leave(null, this);

            return;
          }

          this._enter(null, this);
        }
      };

      _proto.dispose = function dispose() {
        clearTimeout(this._timeout);
        $$$1.removeData(this.element, this.constructor.DATA_KEY);
        $$$1(this.element).off(this.constructor.EVENT_KEY);
        $$$1(this.element).closest('.modal').off('hide.bs.modal');

        if (this.tip) {
          $$$1(this.tip).remove();
        }

        this._isEnabled = null;
        this._timeout = null;
        this._hoverState = null;
        this._activeTrigger = null;

        if (this._popper !== null) {
          this._popper.destroy();
        }

        this._popper = null;
        this.element = null;
        this.config = null;
        this.tip = null;
      };

      _proto.show = function show() {
        var _this = this;

        if ($$$1(this.element).css('display') === 'none') {
          throw new Error('Please use show on visible elements');
        }

        var showEvent = $$$1.Event(this.constructor.Event.SHOW);

        if (this.isWithContent() && this._isEnabled) {
          $$$1(this.element).trigger(showEvent);
          var isInTheDom = $$$1.contains(this.element.ownerDocument.documentElement, this.element);

          if (showEvent.isDefaultPrevented() || !isInTheDom) {
            return;
          }

          var tip = this.getTipElement();
          var tipId = Util.getUID(this.constructor.NAME);
          tip.setAttribute('id', tipId);
          this.element.setAttribute('aria-describedby', tipId);
          this.setContent();

          if (this.config.animation) {
            $$$1(tip).addClass(ClassName.FADE);
          }

          var placement = typeof this.config.placement === 'function' ? this.config.placement.call(this, tip, this.element) : this.config.placement;

          var attachment = this._getAttachment(placement);

          this.addAttachmentClass(attachment);
          var container = this.config.container === false ? document.body : $$$1(this.config.container);
          $$$1(tip).data(this.constructor.DATA_KEY, this);

          if (!$$$1.contains(this.element.ownerDocument.documentElement, this.tip)) {
            $$$1(tip).appendTo(container);
          }

          $$$1(this.element).trigger(this.constructor.Event.INSERTED);
          this._popper = new Popper(this.element, tip, {
            placement: attachment,
            modifiers: {
              offset: {
                offset: this.config.offset
              },
              flip: {
                behavior: this.config.fallbackPlacement
              },
              arrow: {
                element: Selector.ARROW
              },
              preventOverflow: {
                boundariesElement: this.config.boundary
              }
            },
            onCreate: function onCreate(data) {
              if (data.originalPlacement !== data.placement) {
                _this._handlePopperPlacementChange(data);
              }
            },
            onUpdate: function onUpdate(data) {
              _this._handlePopperPlacementChange(data);
            }
          });
          $$$1(tip).addClass(ClassName.SHOW); // If this is a touch-enabled device we add extra
          // empty mouseover listeners to the body's immediate children;
          // only needed because of broken event delegation on iOS
          // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html

          if ('ontouchstart' in document.documentElement) {
            $$$1(document.body).children().on('mouseover', null, $$$1.noop);
          }

          var complete = function complete() {
            if (_this.config.animation) {
              _this._fixTransition();
            }

            var prevHoverState = _this._hoverState;
            _this._hoverState = null;
            $$$1(_this.element).trigger(_this.constructor.Event.SHOWN);

            if (prevHoverState === HoverState.OUT) {
              _this._leave(null, _this);
            }
          };

          if ($$$1(this.tip).hasClass(ClassName.FADE)) {
            var transitionDuration = Util.getTransitionDurationFromElement(this.tip);
            $$$1(this.tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
          } else {
            complete();
          }
        }
      };

      _proto.hide = function hide(callback) {
        var _this2 = this;

        var tip = this.getTipElement();
        var hideEvent = $$$1.Event(this.constructor.Event.HIDE);

        var complete = function complete() {
          if (_this2._hoverState !== HoverState.SHOW && tip.parentNode) {
            tip.parentNode.removeChild(tip);
          }

          _this2._cleanTipClass();

          _this2.element.removeAttribute('aria-describedby');

          $$$1(_this2.element).trigger(_this2.constructor.Event.HIDDEN);

          if (_this2._popper !== null) {
            _this2._popper.destroy();
          }

          if (callback) {
            callback();
          }
        };

        $$$1(this.element).trigger(hideEvent);

        if (hideEvent.isDefaultPrevented()) {
          return;
        }

        $$$1(tip).removeClass(ClassName.SHOW); // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support

        if ('ontouchstart' in document.documentElement) {
          $$$1(document.body).children().off('mouseover', null, $$$1.noop);
        }

        this._activeTrigger[Trigger.CLICK] = false;
        this._activeTrigger[Trigger.FOCUS] = false;
        this._activeTrigger[Trigger.HOVER] = false;

        if ($$$1(this.tip).hasClass(ClassName.FADE)) {
          var transitionDuration = Util.getTransitionDurationFromElement(tip);
          $$$1(tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
        } else {
          complete();
        }

        this._hoverState = '';
      };

      _proto.update = function update() {
        if (this._popper !== null) {
          this._popper.scheduleUpdate();
        }
      }; // Protected


      _proto.isWithContent = function isWithContent() {
        return Boolean(this.getTitle());
      };

      _proto.addAttachmentClass = function addAttachmentClass(attachment) {
        $$$1(this.getTipElement()).addClass(CLASS_PREFIX + "-" + attachment);
      };

      _proto.getTipElement = function getTipElement() {
        this.tip = this.tip || $$$1(this.config.template)[0];
        return this.tip;
      };

      _proto.setContent = function setContent() {
        var $tip = $$$1(this.getTipElement());
        this.setElementContent($tip.find(Selector.TOOLTIP_INNER), this.getTitle());
        $tip.removeClass(ClassName.FADE + " " + ClassName.SHOW);
      };

      _proto.setElementContent = function setElementContent($element, content) {
        var html = this.config.html;

        if (typeof content === 'object' && (content.nodeType || content.jquery)) {
          // Content is a DOM node or a jQuery
          if (html) {
            if (!$$$1(content).parent().is($element)) {
              $element.empty().append(content);
            }
          } else {
            $element.text($$$1(content).text());
          }
        } else {
          $element[html ? 'html' : 'text'](content);
        }
      };

      _proto.getTitle = function getTitle() {
        var title = this.element.getAttribute('data-original-title');

        if (!title) {
          title = typeof this.config.title === 'function' ? this.config.title.call(this.element) : this.config.title;
        }

        return title;
      }; // Private


      _proto._getAttachment = function _getAttachment(placement) {
        return AttachmentMap[placement.toUpperCase()];
      };

      _proto._setListeners = function _setListeners() {
        var _this3 = this;

        var triggers = this.config.trigger.split(' ');
        triggers.forEach(function (trigger) {
          if (trigger === 'click') {
            $$$1(_this3.element).on(_this3.constructor.Event.CLICK, _this3.config.selector, function (event) {
              return _this3.toggle(event);
            });
          } else if (trigger !== Trigger.MANUAL) {
            var eventIn = trigger === Trigger.HOVER ? _this3.constructor.Event.MOUSEENTER : _this3.constructor.Event.FOCUSIN;
            var eventOut = trigger === Trigger.HOVER ? _this3.constructor.Event.MOUSELEAVE : _this3.constructor.Event.FOCUSOUT;
            $$$1(_this3.element).on(eventIn, _this3.config.selector, function (event) {
              return _this3._enter(event);
            }).on(eventOut, _this3.config.selector, function (event) {
              return _this3._leave(event);
            });
          }

          $$$1(_this3.element).closest('.modal').on('hide.bs.modal', function () {
            return _this3.hide();
          });
        });

        if (this.config.selector) {
          this.config = _objectSpread({}, this.config, {
            trigger: 'manual',
            selector: ''
          });
        } else {
          this._fixTitle();
        }
      };

      _proto._fixTitle = function _fixTitle() {
        var titleType = typeof this.element.getAttribute('data-original-title');

        if (this.element.getAttribute('title') || titleType !== 'string') {
          this.element.setAttribute('data-original-title', this.element.getAttribute('title') || '');
          this.element.setAttribute('title', '');
        }
      };

      _proto._enter = function _enter(event, context) {
        var dataKey = this.constructor.DATA_KEY;
        context = context || $$$1(event.currentTarget).data(dataKey);

        if (!context) {
          context = new this.constructor(event.currentTarget, this._getDelegateConfig());
          $$$1(event.currentTarget).data(dataKey, context);
        }

        if (event) {
          context._activeTrigger[event.type === 'focusin' ? Trigger.FOCUS : Trigger.HOVER] = true;
        }

        if ($$$1(context.getTipElement()).hasClass(ClassName.SHOW) || context._hoverState === HoverState.SHOW) {
          context._hoverState = HoverState.SHOW;
          return;
        }

        clearTimeout(context._timeout);
        context._hoverState = HoverState.SHOW;

        if (!context.config.delay || !context.config.delay.show) {
          context.show();
          return;
        }

        context._timeout = setTimeout(function () {
          if (context._hoverState === HoverState.SHOW) {
            context.show();
          }
        }, context.config.delay.show);
      };

      _proto._leave = function _leave(event, context) {
        var dataKey = this.constructor.DATA_KEY;
        context = context || $$$1(event.currentTarget).data(dataKey);

        if (!context) {
          context = new this.constructor(event.currentTarget, this._getDelegateConfig());
          $$$1(event.currentTarget).data(dataKey, context);
        }

        if (event) {
          context._activeTrigger[event.type === 'focusout' ? Trigger.FOCUS : Trigger.HOVER] = false;
        }

        if (context._isWithActiveTrigger()) {
          return;
        }

        clearTimeout(context._timeout);
        context._hoverState = HoverState.OUT;

        if (!context.config.delay || !context.config.delay.hide) {
          context.hide();
          return;
        }

        context._timeout = setTimeout(function () {
          if (context._hoverState === HoverState.OUT) {
            context.hide();
          }
        }, context.config.delay.hide);
      };

      _proto._isWithActiveTrigger = function _isWithActiveTrigger() {
        for (var trigger in this._activeTrigger) {
          if (this._activeTrigger[trigger]) {
            return true;
          }
        }

        return false;
      };

      _proto._getConfig = function _getConfig(config) {
        config = _objectSpread({}, this.constructor.Default, $$$1(this.element).data(), config);

        if (typeof config.delay === 'number') {
          config.delay = {
            show: config.delay,
            hide: config.delay
          };
        }

        if (typeof config.title === 'number') {
          config.title = config.title.toString();
        }

        if (typeof config.content === 'number') {
          config.content = config.content.toString();
        }

        Util.typeCheckConfig(NAME, config, this.constructor.DefaultType);
        return config;
      };

      _proto._getDelegateConfig = function _getDelegateConfig() {
        var config = {};

        if (this.config) {
          for (var key in this.config) {
            if (this.constructor.Default[key] !== this.config[key]) {
              config[key] = this.config[key];
            }
          }
        }

        return config;
      };

      _proto._cleanTipClass = function _cleanTipClass() {
        var $tip = $$$1(this.getTipElement());
        var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX);

        if (tabClass !== null && tabClass.length > 0) {
          $tip.removeClass(tabClass.join(''));
        }
      };

      _proto._handlePopperPlacementChange = function _handlePopperPlacementChange(data) {
        this._cleanTipClass();

        this.addAttachmentClass(this._getAttachment(data.placement));
      };

      _proto._fixTransition = function _fixTransition() {
        var tip = this.getTipElement();
        var initConfigAnimation = this.config.animation;

        if (tip.getAttribute('x-placement') !== null) {
          return;
        }

        $$$1(tip).removeClass(ClassName.FADE);
        this.config.animation = false;
        this.hide();
        this.show();
        this.config.animation = initConfigAnimation;
      }; // Static


      Tooltip._jQueryInterface = function _jQueryInterface(config) {
        return this.each(function () {
          var data = $$$1(this).data(DATA_KEY);

          var _config = typeof config === 'object' && config;

          if (!data && /dispose|hide/.test(config)) {
            return;
          }

          if (!data) {
            data = new Tooltip(this, _config);
            $$$1(this).data(DATA_KEY, data);
          }

          if (typeof config === 'string') {
            if (typeof data[config] === 'undefined') {
              throw new TypeError("No method named \"" + config + "\"");
            }

            data[config]();
          }
        });
      };

      _createClass(Tooltip, null, [{
        key: "VERSION",
        get: function get() {
          return VERSION;
        }
      }, {
        key: "Default",
        get: function get() {
          return Default;
        }
      }, {
        key: "NAME",
        get: function get() {
          return NAME;
        }
      }, {
        key: "DATA_KEY",
        get: function get() {
          return DATA_KEY;
        }
      }, {
        key: "Event",
        get: function get() {
          return Event;
        }
      }, {
        key: "EVENT_KEY",
        get: function get() {
          return EVENT_KEY;
        }
      }, {
        key: "DefaultType",
        get: function get() {
          return DefaultType;
        }
      }]);

      return Tooltip;
    }();
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */


    $$$1.fn[NAME] = Tooltip._jQueryInterface;
    $$$1.fn[NAME].Constructor = Tooltip;

    $$$1.fn[NAME].noConflict = function () {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Tooltip._jQueryInterface;
    };

    return Tooltip;
  }($, Popper);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.1.0): popover.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Popover = function ($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME = 'popover';
    var VERSION = '4.1.0';
    var DATA_KEY = 'bs.popover';
    var EVENT_KEY = "." + DATA_KEY;
    var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
    var CLASS_PREFIX = 'bs-popover';
    var BSCLS_PREFIX_REGEX = new RegExp("(^|\\s)" + CLASS_PREFIX + "\\S+", 'g');

    var Default = _objectSpread({}, Tooltip.Default, {
      placement: 'right',
      trigger: 'click',
      content: '',
      template: '<div class="popover" role="tooltip">' + '<div class="arrow"></div>' + '<h3 class="popover-header"></h3>' + '<div class="popover-body"></div></div>'
    });

    var DefaultType = _objectSpread({}, Tooltip.DefaultType, {
      content: '(string|element|function)'
    });

    var ClassName = {
      FADE: 'fade',
      SHOW: 'show'
    };
    var Selector = {
      TITLE: '.popover-header',
      CONTENT: '.popover-body'
    };
    var Event = {
      HIDE: "hide" + EVENT_KEY,
      HIDDEN: "hidden" + EVENT_KEY,
      SHOW: "show" + EVENT_KEY,
      SHOWN: "shown" + EVENT_KEY,
      INSERTED: "inserted" + EVENT_KEY,
      CLICK: "click" + EVENT_KEY,
      FOCUSIN: "focusin" + EVENT_KEY,
      FOCUSOUT: "focusout" + EVENT_KEY,
      MOUSEENTER: "mouseenter" + EVENT_KEY,
      MOUSELEAVE: "mouseleave" + EVENT_KEY
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Popover =
    /*#__PURE__*/
    function (_Tooltip) {
      _inheritsLoose(Popover, _Tooltip);

      function Popover() {
        return _Tooltip.apply(this, arguments) || this;
      }

      var _proto = Popover.prototype;

      // Overrides
      _proto.isWithContent = function isWithContent() {
        return this.getTitle() || this._getContent();
      };

      _proto.addAttachmentClass = function addAttachmentClass(attachment) {
        $$$1(this.getTipElement()).addClass(CLASS_PREFIX + "-" + attachment);
      };

      _proto.getTipElement = function getTipElement() {
        this.tip = this.tip || $$$1(this.config.template)[0];
        return this.tip;
      };

      _proto.setContent = function setContent() {
        var $tip = $$$1(this.getTipElement()); // We use append for html objects to maintain js events

        this.setElementContent($tip.find(Selector.TITLE), this.getTitle());

        var content = this._getContent();

        if (typeof content === 'function') {
          content = content.call(this.element);
        }

        this.setElementContent($tip.find(Selector.CONTENT), content);
        $tip.removeClass(ClassName.FADE + " " + ClassName.SHOW);
      }; // Private


      _proto._getContent = function _getContent() {
        return this.element.getAttribute('data-content') || this.config.content;
      };

      _proto._cleanTipClass = function _cleanTipClass() {
        var $tip = $$$1(this.getTipElement());
        var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX);

        if (tabClass !== null && tabClass.length > 0) {
          $tip.removeClass(tabClass.join(''));
        }
      }; // Static


      Popover._jQueryInterface = function _jQueryInterface(config) {
        return this.each(function () {
          var data = $$$1(this).data(DATA_KEY);

          var _config = typeof config === 'object' ? config : null;

          if (!data && /destroy|hide/.test(config)) {
            return;
          }

          if (!data) {
            data = new Popover(this, _config);
            $$$1(this).data(DATA_KEY, data);
          }

          if (typeof config === 'string') {
            if (typeof data[config] === 'undefined') {
              throw new TypeError("No method named \"" + config + "\"");
            }

            data[config]();
          }
        });
      };

      _createClass(Popover, null, [{
        key: "VERSION",
        // Getters
        get: function get() {
          return VERSION;
        }
      }, {
        key: "Default",
        get: function get() {
          return Default;
        }
      }, {
        key: "NAME",
        get: function get() {
          return NAME;
        }
      }, {
        key: "DATA_KEY",
        get: function get() {
          return DATA_KEY;
        }
      }, {
        key: "Event",
        get: function get() {
          return Event;
        }
      }, {
        key: "EVENT_KEY",
        get: function get() {
          return EVENT_KEY;
        }
      }, {
        key: "DefaultType",
        get: function get() {
          return DefaultType;
        }
      }]);

      return Popover;
    }(Tooltip);
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */


    $$$1.fn[NAME] = Popover._jQueryInterface;
    $$$1.fn[NAME].Constructor = Popover;

    $$$1.fn[NAME].noConflict = function () {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Popover._jQueryInterface;
    };

    return Popover;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.1.0): scrollspy.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var ScrollSpy = function ($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME = 'scrollspy';
    var VERSION = '4.1.0';
    var DATA_KEY = 'bs.scrollspy';
    var EVENT_KEY = "." + DATA_KEY;
    var DATA_API_KEY = '.data-api';
    var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
    var Default = {
      offset: 10,
      method: 'auto',
      target: ''
    };
    var DefaultType = {
      offset: 'number',
      method: 'string',
      target: '(string|element)'
    };
    var Event = {
      ACTIVATE: "activate" + EVENT_KEY,
      SCROLL: "scroll" + EVENT_KEY,
      LOAD_DATA_API: "load" + EVENT_KEY + DATA_API_KEY
    };
    var ClassName = {
      DROPDOWN_ITEM: 'dropdown-item',
      DROPDOWN_MENU: 'dropdown-menu',
      ACTIVE: 'active'
    };
    var Selector = {
      DATA_SPY: '[data-spy="scroll"]',
      ACTIVE: '.active',
      NAV_LIST_GROUP: '.nav, .list-group',
      NAV_LINKS: '.nav-link',
      NAV_ITEMS: '.nav-item',
      LIST_ITEMS: '.list-group-item',
      DROPDOWN: '.dropdown',
      DROPDOWN_ITEMS: '.dropdown-item',
      DROPDOWN_TOGGLE: '.dropdown-toggle'
    };
    var OffsetMethod = {
      OFFSET: 'offset',
      POSITION: 'position'
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var ScrollSpy =
    /*#__PURE__*/
    function () {
      function ScrollSpy(element, config) {
        var _this = this;

        this._element = element;
        this._scrollElement = element.tagName === 'BODY' ? window : element;
        this._config = this._getConfig(config);
        this._selector = this._config.target + " " + Selector.NAV_LINKS + "," + (this._config.target + " " + Selector.LIST_ITEMS + ",") + (this._config.target + " " + Selector.DROPDOWN_ITEMS);
        this._offsets = [];
        this._targets = [];
        this._activeTarget = null;
        this._scrollHeight = 0;
        $$$1(this._scrollElement).on(Event.SCROLL, function (event) {
          return _this._process(event);
        });
        this.refresh();

        this._process();
      } // Getters


      var _proto = ScrollSpy.prototype;

      // Public
      _proto.refresh = function refresh() {
        var _this2 = this;

        var autoMethod = this._scrollElement === this._scrollElement.window ? OffsetMethod.OFFSET : OffsetMethod.POSITION;
        var offsetMethod = this._config.method === 'auto' ? autoMethod : this._config.method;
        var offsetBase = offsetMethod === OffsetMethod.POSITION ? this._getScrollTop() : 0;
        this._offsets = [];
        this._targets = [];
        this._scrollHeight = this._getScrollHeight();
        var targets = $$$1.makeArray($$$1(this._selector));
        targets.map(function (element) {
          var target;
          var targetSelector = Util.getSelectorFromElement(element);

          if (targetSelector) {
            target = $$$1(targetSelector)[0];
          }

          if (target) {
            var targetBCR = target.getBoundingClientRect();

            if (targetBCR.width || targetBCR.height) {
              // TODO (fat): remove sketch reliance on jQuery position/offset
              return [$$$1(target)[offsetMethod]().top + offsetBase, targetSelector];
            }
          }

          return null;
        }).filter(function (item) {
          return item;
        }).sort(function (a, b) {
          return a[0] - b[0];
        }).forEach(function (item) {
          _this2._offsets.push(item[0]);

          _this2._targets.push(item[1]);
        });
      };

      _proto.dispose = function dispose() {
        $$$1.removeData(this._element, DATA_KEY);
        $$$1(this._scrollElement).off(EVENT_KEY);
        this._element = null;
        this._scrollElement = null;
        this._config = null;
        this._selector = null;
        this._offsets = null;
        this._targets = null;
        this._activeTarget = null;
        this._scrollHeight = null;
      }; // Private


      _proto._getConfig = function _getConfig(config) {
        config = _objectSpread({}, Default, config);

        if (typeof config.target !== 'string') {
          var id = $$$1(config.target).attr('id');

          if (!id) {
            id = Util.getUID(NAME);
            $$$1(config.target).attr('id', id);
          }

          config.target = "#" + id;
        }

        Util.typeCheckConfig(NAME, config, DefaultType);
        return config;
      };

      _proto._getScrollTop = function _getScrollTop() {
        return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
      };

      _proto._getScrollHeight = function _getScrollHeight() {
        return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
      };

      _proto._getOffsetHeight = function _getOffsetHeight() {
        return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
      };

      _proto._process = function _process() {
        var scrollTop = this._getScrollTop() + this._config.offset;

        var scrollHeight = this._getScrollHeight();

        var maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();

        if (this._scrollHeight !== scrollHeight) {
          this.refresh();
        }

        if (scrollTop >= maxScroll) {
          var target = this._targets[this._targets.length - 1];

          if (this._activeTarget !== target) {
            this._activate(target);
          }

          return;
        }

        if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
          this._activeTarget = null;

          this._clear();

          return;
        }

        for (var i = this._offsets.length; i--;) {
          var isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (typeof this._offsets[i + 1] === 'undefined' || scrollTop < this._offsets[i + 1]);

          if (isActiveTarget) {
            this._activate(this._targets[i]);
          }
        }
      };

      _proto._activate = function _activate(target) {
        this._activeTarget = target;

        this._clear();

        var queries = this._selector.split(','); // eslint-disable-next-line arrow-body-style


        queries = queries.map(function (selector) {
          return selector + "[data-target=\"" + target + "\"]," + (selector + "[href=\"" + target + "\"]");
        });
        var $link = $$$1(queries.join(','));

        if ($link.hasClass(ClassName.DROPDOWN_ITEM)) {
          $link.closest(Selector.DROPDOWN).find(Selector.DROPDOWN_TOGGLE).addClass(ClassName.ACTIVE);
          $link.addClass(ClassName.ACTIVE);
        } else {
          // Set triggered link as active
          $link.addClass(ClassName.ACTIVE); // Set triggered links parents as active
          // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor

          $link.parents(Selector.NAV_LIST_GROUP).prev(Selector.NAV_LINKS + ", " + Selector.LIST_ITEMS).addClass(ClassName.ACTIVE); // Handle special case when .nav-link is inside .nav-item

          $link.parents(Selector.NAV_LIST_GROUP).prev(Selector.NAV_ITEMS).children(Selector.NAV_LINKS).addClass(ClassName.ACTIVE);
        }

        $$$1(this._scrollElement).trigger(Event.ACTIVATE, {
          relatedTarget: target
        });
      };

      _proto._clear = function _clear() {
        $$$1(this._selector).filter(Selector.ACTIVE).removeClass(ClassName.ACTIVE);
      }; // Static


      ScrollSpy._jQueryInterface = function _jQueryInterface(config) {
        return this.each(function () {
          var data = $$$1(this).data(DATA_KEY);

          var _config = typeof config === 'object' && config;

          if (!data) {
            data = new ScrollSpy(this, _config);
            $$$1(this).data(DATA_KEY, data);
          }

          if (typeof config === 'string') {
            if (typeof data[config] === 'undefined') {
              throw new TypeError("No method named \"" + config + "\"");
            }

            data[config]();
          }
        });
      };

      _createClass(ScrollSpy, null, [{
        key: "VERSION",
        get: function get() {
          return VERSION;
        }
      }, {
        key: "Default",
        get: function get() {
          return Default;
        }
      }]);

      return ScrollSpy;
    }();
    /**
     * ------------------------------------------------------------------------
     * Data Api implementation
     * ------------------------------------------------------------------------
     */


    $$$1(window).on(Event.LOAD_DATA_API, function () {
      var scrollSpys = $$$1.makeArray($$$1(Selector.DATA_SPY));

      for (var i = scrollSpys.length; i--;) {
        var $spy = $$$1(scrollSpys[i]);

        ScrollSpy._jQueryInterface.call($spy, $spy.data());
      }
    });
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */

    $$$1.fn[NAME] = ScrollSpy._jQueryInterface;
    $$$1.fn[NAME].Constructor = ScrollSpy;

    $$$1.fn[NAME].noConflict = function () {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return ScrollSpy._jQueryInterface;
    };

    return ScrollSpy;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.1.0): tab.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Tab = function ($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME = 'tab';
    var VERSION = '4.1.0';
    var DATA_KEY = 'bs.tab';
    var EVENT_KEY = "." + DATA_KEY;
    var DATA_API_KEY = '.data-api';
    var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
    var Event = {
      HIDE: "hide" + EVENT_KEY,
      HIDDEN: "hidden" + EVENT_KEY,
      SHOW: "show" + EVENT_KEY,
      SHOWN: "shown" + EVENT_KEY,
      CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
    };
    var ClassName = {
      DROPDOWN_MENU: 'dropdown-menu',
      ACTIVE: 'active',
      DISABLED: 'disabled',
      FADE: 'fade',
      SHOW: 'show'
    };
    var Selector = {
      DROPDOWN: '.dropdown',
      NAV_LIST_GROUP: '.nav, .list-group',
      ACTIVE: '.active',
      ACTIVE_UL: '> li > .active',
      DATA_TOGGLE: '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]',
      DROPDOWN_TOGGLE: '.dropdown-toggle',
      DROPDOWN_ACTIVE_CHILD: '> .dropdown-menu .active'
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Tab =
    /*#__PURE__*/
    function () {
      function Tab(element) {
        this._element = element;
      } // Getters


      var _proto = Tab.prototype;

      // Public
      _proto.show = function show() {
        var _this = this;

        if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && $$$1(this._element).hasClass(ClassName.ACTIVE) || $$$1(this._element).hasClass(ClassName.DISABLED)) {
          return;
        }

        var target;
        var previous;
        var listElement = $$$1(this._element).closest(Selector.NAV_LIST_GROUP)[0];
        var selector = Util.getSelectorFromElement(this._element);

        if (listElement) {
          var itemSelector = listElement.nodeName === 'UL' ? Selector.ACTIVE_UL : Selector.ACTIVE;
          previous = $$$1.makeArray($$$1(listElement).find(itemSelector));
          previous = previous[previous.length - 1];
        }

        var hideEvent = $$$1.Event(Event.HIDE, {
          relatedTarget: this._element
        });
        var showEvent = $$$1.Event(Event.SHOW, {
          relatedTarget: previous
        });

        if (previous) {
          $$$1(previous).trigger(hideEvent);
        }

        $$$1(this._element).trigger(showEvent);

        if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) {
          return;
        }

        if (selector) {
          target = $$$1(selector)[0];
        }

        this._activate(this._element, listElement);

        var complete = function complete() {
          var hiddenEvent = $$$1.Event(Event.HIDDEN, {
            relatedTarget: _this._element
          });
          var shownEvent = $$$1.Event(Event.SHOWN, {
            relatedTarget: previous
          });
          $$$1(previous).trigger(hiddenEvent);
          $$$1(_this._element).trigger(shownEvent);
        };

        if (target) {
          this._activate(target, target.parentNode, complete);
        } else {
          complete();
        }
      };

      _proto.dispose = function dispose() {
        $$$1.removeData(this._element, DATA_KEY);
        this._element = null;
      }; // Private


      _proto._activate = function _activate(element, container, callback) {
        var _this2 = this;

        var activeElements;

        if (container.nodeName === 'UL') {
          activeElements = $$$1(container).find(Selector.ACTIVE_UL);
        } else {
          activeElements = $$$1(container).children(Selector.ACTIVE);
        }

        var active = activeElements[0];
        var isTransitioning = callback && active && $$$1(active).hasClass(ClassName.FADE);

        var complete = function complete() {
          return _this2._transitionComplete(element, active, callback);
        };

        if (active && isTransitioning) {
          var transitionDuration = Util.getTransitionDurationFromElement(active);
          $$$1(active).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
        } else {
          complete();
        }
      };

      _proto._transitionComplete = function _transitionComplete(element, active, callback) {
        if (active) {
          $$$1(active).removeClass(ClassName.SHOW + " " + ClassName.ACTIVE);
          var dropdownChild = $$$1(active.parentNode).find(Selector.DROPDOWN_ACTIVE_CHILD)[0];

          if (dropdownChild) {
            $$$1(dropdownChild).removeClass(ClassName.ACTIVE);
          }

          if (active.getAttribute('role') === 'tab') {
            active.setAttribute('aria-selected', false);
          }
        }

        $$$1(element).addClass(ClassName.ACTIVE);

        if (element.getAttribute('role') === 'tab') {
          element.setAttribute('aria-selected', true);
        }

        Util.reflow(element);
        $$$1(element).addClass(ClassName.SHOW);

        if (element.parentNode && $$$1(element.parentNode).hasClass(ClassName.DROPDOWN_MENU)) {
          var dropdownElement = $$$1(element).closest(Selector.DROPDOWN)[0];

          if (dropdownElement) {
            $$$1(dropdownElement).find(Selector.DROPDOWN_TOGGLE).addClass(ClassName.ACTIVE);
          }

          element.setAttribute('aria-expanded', true);
        }

        if (callback) {
          callback();
        }
      }; // Static


      Tab._jQueryInterface = function _jQueryInterface(config) {
        return this.each(function () {
          var $this = $$$1(this);
          var data = $this.data(DATA_KEY);

          if (!data) {
            data = new Tab(this);
            $this.data(DATA_KEY, data);
          }

          if (typeof config === 'string') {
            if (typeof data[config] === 'undefined') {
              throw new TypeError("No method named \"" + config + "\"");
            }

            data[config]();
          }
        });
      };

      _createClass(Tab, null, [{
        key: "VERSION",
        get: function get() {
          return VERSION;
        }
      }]);

      return Tab;
    }();
    /**
     * ------------------------------------------------------------------------
     * Data Api implementation
     * ------------------------------------------------------------------------
     */


    $$$1(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
      event.preventDefault();

      Tab._jQueryInterface.call($$$1(this), 'show');
    });
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */

    $$$1.fn[NAME] = Tab._jQueryInterface;
    $$$1.fn[NAME].Constructor = Tab;

    $$$1.fn[NAME].noConflict = function () {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Tab._jQueryInterface;
    };

    return Tab;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.0.0): index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  (function ($$$1) {
    if (typeof $$$1 === 'undefined') {
      throw new TypeError('Bootstrap\'s JavaScript requires jQuery. jQuery must be included before Bootstrap\'s JavaScript.');
    }

    var version = $$$1.fn.jquery.split(' ')[0].split('.');
    var minMajor = 1;
    var ltMajor = 2;
    var minMinor = 9;
    var minPatch = 1;
    var maxMajor = 4;

    if (version[0] < ltMajor && version[1] < minMinor || version[0] === minMajor && version[1] === minMinor && version[2] < minPatch || version[0] >= maxMajor) {
      throw new Error('Bootstrap\'s JavaScript requires at least jQuery v1.9.1 but less than v4.0.0');
    }
  })($);

  exports.Util = Util;
  exports.Alert = Alert;
  exports.Button = Button;
  exports.Carousel = Carousel;
  exports.Collapse = Collapse;
  exports.Dropdown = Dropdown;
  exports.Modal = Modal;
  exports.Popover = Popover;
  exports.Scrollspy = ScrollSpy;
  exports.Tab = Tab;
  exports.Tooltip = Tooltip;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=bootstrap.js.map


/***/ }),
/* 529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_App_css__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_core_CorePage__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_core_ErrorPage__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_scorecard_Scorecard__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_plp_Home__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_dashboard_Dashboard__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_settings_Settings__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_lesson_LessonView__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_login_ResetPasswordForm__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_extlogin_ExternalLogin__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_extlogin_LumosLogin__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_extlogin_VendorLogin__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_lesson_OpenLessonView__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__vendors_mindstretcher_ms_PreloginHome__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_sg_sg_PreloginHome__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__model_ComponentRegistry__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_UserStorageUtil__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_lesson_MozartView__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_temp_TestComplete__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__track_CouponTracker__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_za_za_PreloginHome__ = __webpack_require__(1282);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import PreloginHome from './prelogin/src/PreloginHome';
var App=function(_CorePage){_inherits(App,_CorePage);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.userStore=new __WEBPACK_IMPORTED_MODULE_19__util_UserStore__["a" /* default */]();return _this;}_createClass(App,[{key:'getCmpHelper',value:function getCmpHelper(){return _get(App.prototype.__proto__||Object.getPrototypeOf(App.prototype),'getCmpHelper',this).call(this,this.userStore);}},{key:'getComponent',value:function getComponent(cmpName){return this.getCmpHelper().getCmp(cmpName);}},{key:'getComponentByName',value:function getComponentByName(cmpName,altCmpName){return this.getCmpHelper().getCmpByName(cmpName,altCmpName);}},{key:'getLandingByGeo',value:function getLandingByGeo(cmpName){var geoCookie=this.getGeo();if(cmpName&&geoCookie){return this.getComponentByName(geoCookie.toLowerCase()+"_"+cmpName,cmpName);}return this.getComponent(cmpName);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/',exact:true,component:this.getComponentByName("za_PreloginHome","PreloginHome")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/home',exact:true,component:this.getComponentByName("za_PreloginHome","PreloginHome")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/login',exact:true,component:this.getComponentByName("za_PreloginHome","PreloginHome")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/lessonview/:id',exact:true,component:__WEBPACK_IMPORTED_MODULE_9__views_lesson_LessonView__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/mozartview/:lid',exact:true,component:__WEBPACK_IMPORTED_MODULE_20__views_lesson_MozartView__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/openlessonview/:id',exact:true,component:__WEBPACK_IMPORTED_MODULE_14__views_lesson_OpenLessonView__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/forgotPassword/:id',exact:true,component:__WEBPACK_IMPORTED_MODULE_10__views_login_ResetPasswordForm__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/extlogin',component:__WEBPACK_IMPORTED_MODULE_11__views_extlogin_ExternalLogin__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/lumos',component:__WEBPACK_IMPORTED_MODULE_12__views_extlogin_LumosLogin__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/vendorlogin',component:__WEBPACK_IMPORTED_MODULE_13__views_extlogin_VendorLogin__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/800',exact:true,component:__WEBPACK_IMPORTED_MODULE_21__views_temp_TestComplete__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{component:this.getLandingByGeo("PreloginHome")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Redirect */],{from:'*',to:'/'})));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_3__views_core_CorePage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(196);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(319);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(196);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(540);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(197);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(320);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(544);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(546);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(324);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(548);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(197);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(550);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(198);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(324);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(198);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(554);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(322);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 556 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmptyTextNode;
/**
 * Tests a htmlparser2 node and returns whether is it a text node at the start and end of the line containing only
 * white space. This allows these node types to be excluded from the rendering because they are unnecessary.
 *
 * @param {Object} node The element object as created by htmlparser2
 * @returns {boolean} Whether the node is an empty text node
 */
function isEmptyTextNode(node) {
  return node.type === 'text' && /\r?\n/.test(node.data) && node.data.trim() === '';
}

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ElementType$Text$Ele;

var _htmlparser = __webpack_require__(102);

var _TextElementType = __webpack_require__(578);

var _TextElementType2 = _interopRequireDefault(_TextElementType);

var _TagElementType = __webpack_require__(579);

var _TagElementType2 = _interopRequireDefault(_TagElementType);

var _StyleElementType = __webpack_require__(585);

var _StyleElementType2 = _interopRequireDefault(_StyleElementType);

var _UnsupportedElementType = __webpack_require__(586);

var _UnsupportedElementType2 = _interopRequireDefault(_UnsupportedElementType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
                                                                                                                                                                                                                   * Map each htmlparser2 element type to a function which will convert that element type to a React element
                                                                                                                                                                                                                   * Not all of the element types are supported so the UnsupportedElementType is used for them which will not return any
                                                                                                                                                                                                                   * value
                                                                                                                                                                                                                   */

exports.default = (_ElementType$Text$Ele = {}, _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Text, _TextElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Tag, _TagElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Style, _StyleElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Directive, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Comment, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Script, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.CDATA, _UnsupportedElementType2.default), _defineProperty(_ElementType$Text$Ele, _htmlparser.ElementType.Doctype, _UnsupportedElementType2.default), _ElementType$Text$Ele);

/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports = {"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

// DOM-Level-1-compliant structure
var NodePrototype = __webpack_require__(331);
var ElementPrototype = module.exports = Object.create(NodePrototype);

var domLvl1 = {
	tagName: "name"
};

Object.keys(domLvl1).forEach(function(key) {
	var shorthand = domLvl1[key];
	Object.defineProperty(ElementPrototype, key, {
		get: function() {
			return this[shorthand] || null;
		},
		set: function(val) {
			this[shorthand] = val;
			return val;
		}
	});
});


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var DomHandler = __webpack_require__(330);
var DomUtils = __webpack_require__(332);

//TODO: make this a streamable handler
function FeedHandler(callback, options) {
    this.init(callback, options);
}

__webpack_require__(60)(FeedHandler, DomHandler);

FeedHandler.prototype.init = DomHandler;

function getElements(what, where) {
    return DomUtils.getElementsByTagName(what, where, true);
}
function getOneElement(what, where) {
    return DomUtils.getElementsByTagName(what, where, true, 1)[0];
}
function fetch(what, where, recurse) {
    return DomUtils.getText(
        DomUtils.getElementsByTagName(what, where, recurse, 1)
    ).trim();
}

function addConditionally(obj, prop, what, where, recurse) {
    var tmp = fetch(what, where, recurse);
    if (tmp) obj[prop] = tmp;
}

var isValidFeed = function(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
};

FeedHandler.prototype.onend = function() {
    var feed = {},
        feedRoot = getOneElement(isValidFeed, this.dom),
        tmp,
        childs;

    if (feedRoot) {
        if (feedRoot.name === "feed") {
            childs = feedRoot.children;

            feed.type = "atom";
            addConditionally(feed, "id", "id", childs);
            addConditionally(feed, "title", "title", childs);
            if (
                (tmp = getOneElement("link", childs)) &&
                (tmp = tmp.attribs) &&
                (tmp = tmp.href)
            )
                feed.link = tmp;
            addConditionally(feed, "description", "subtitle", childs);
            if ((tmp = fetch("updated", childs))) feed.updated = new Date(tmp);
            addConditionally(feed, "author", "email", childs, true);

            feed.items = getElements("entry", childs).map(function(item) {
                var entry = {},
                    tmp;

                item = item.children;

                addConditionally(entry, "id", "id", item);
                addConditionally(entry, "title", "title", item);
                if (
                    (tmp = getOneElement("link", item)) &&
                    (tmp = tmp.attribs) &&
                    (tmp = tmp.href)
                )
                    entry.link = tmp;
                if ((tmp = fetch("summary", item) || fetch("content", item)))
                    entry.description = tmp;
                if ((tmp = fetch("updated", item)))
                    entry.pubDate = new Date(tmp);
                return entry;
            });
        } else {
            childs = getOneElement("channel", feedRoot.children).children;

            feed.type = feedRoot.name.substr(0, 3);
            feed.id = "";
            addConditionally(feed, "title", "title", childs);
            addConditionally(feed, "link", "link", childs);
            addConditionally(feed, "description", "description", childs);
            if ((tmp = fetch("lastBuildDate", childs)))
                feed.updated = new Date(tmp);
            addConditionally(feed, "author", "managingEditor", childs, true);

            feed.items = getElements("item", feedRoot.children).map(function(
                item
            ) {
                var entry = {},
                    tmp;

                item = item.children;

                addConditionally(entry, "id", "guid", item);
                addConditionally(entry, "title", "title", item);
                addConditionally(entry, "link", "link", item);
                addConditionally(entry, "description", "description", item);
                if ((tmp = fetch("pubDate", item)))
                    entry.pubDate = new Date(tmp);
                return entry;
            });
        }
    }
    this.dom = feed;
    DomHandler.prototype._handleCallback.call(
        this,
        feedRoot ? null : Error("couldn't find root of feed")
    );
};

module.exports = FeedHandler;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var ElementType = __webpack_require__(103),
    getOuterHTML = __webpack_require__(563),
    isTag = ElementType.isTag;

module.exports = {
	getInnerHTML: getInnerHTML,
	getOuterHTML: getOuterHTML,
	getText: getText
};

function getInnerHTML(elem, opts){
	return elem.children ? elem.children.map(function(elem){
		return getOuterHTML(elem, opts);
	}).join("") : "";
}

function getText(elem){
	if(Array.isArray(elem)) return elem.map(getText).join("");
	if(isTag(elem)) return elem.name === "br" ? "\n" : getText(elem.children);
	if(elem.type === ElementType.CDATA) return getText(elem.children);
	if(elem.type === ElementType.Text) return elem.data;
	return "";
}


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

/*
  Module dependencies
*/
var ElementType = __webpack_require__(103);
var entities = __webpack_require__(564);

var unencodedElements = {
  __proto__: null,
  style: true,
  script: true,
  xmp: true,
  iframe: true,
  noembed: true,
  noframes: true,
  plaintext: true,
  noscript: true
};

/*
  Format attributes
*/
function formatAttrs(attributes, opts) {
  if (!attributes) return;

  var output = '',
      value;

  // Loop through the attributes
  for (var key in attributes) {
    value = attributes[key];
    if (output) {
      output += ' ';
    }

    output += key;
    if ((value !== null && value !== '') || opts.xmlMode) {
        output += '="' + (opts.decodeEntities ? entities.encodeXML(value) : value) + '"';
    }
  }

  return output;
}

/*
  Self-enclosing tags (stolen from node-htmlparser)
*/
var singleTag = {
  __proto__: null,
  area: true,
  base: true,
  basefont: true,
  br: true,
  col: true,
  command: true,
  embed: true,
  frame: true,
  hr: true,
  img: true,
  input: true,
  isindex: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true,
};


var render = module.exports = function(dom, opts) {
  if (!Array.isArray(dom) && !dom.cheerio) dom = [dom];
  opts = opts || {};

  var output = '';

  for(var i = 0; i < dom.length; i++){
    var elem = dom[i];

    if (elem.type === 'root')
      output += render(elem.children, opts);
    else if (ElementType.isTag(elem))
      output += renderTag(elem, opts);
    else if (elem.type === ElementType.Directive)
      output += renderDirective(elem);
    else if (elem.type === ElementType.Comment)
      output += renderComment(elem);
    else if (elem.type === ElementType.CDATA)
      output += renderCdata(elem);
    else
      output += renderText(elem, opts);
  }

  return output;
};

function renderTag(elem, opts) {
  // Handle SVG
  if (elem.name === "svg") opts = {decodeEntities: opts.decodeEntities, xmlMode: true};

  var tag = '<' + elem.name,
      attribs = formatAttrs(elem.attribs, opts);

  if (attribs) {
    tag += ' ' + attribs;
  }

  if (
    opts.xmlMode
    && (!elem.children || elem.children.length === 0)
  ) {
    tag += '/>';
  } else {
    tag += '>';
    if (elem.children) {
      tag += render(elem.children, opts);
    }

    if (!singleTag[elem.name] || opts.xmlMode) {
      tag += '</' + elem.name + '>';
    }
  }

  return tag;
}

function renderDirective(elem) {
  return '<' + elem.data + '>';
}

function renderText(elem, opts) {
  var data = elem.data || '';

  // if entities weren't decoded, no need to encode them back
  if (opts.decodeEntities && !(elem.parent && elem.parent.name in unencodedElements)) {
    data = entities.encodeXML(data);
  }

  return data;
}

function renderCdata(elem) {
  return '<![CDATA[' + elem.children[0].data + ']]>';
}

function renderComment(elem) {
  return '<!--' + elem.data + '-->';
}


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var encode = __webpack_require__(565),
    decode = __webpack_require__(566);

exports.decode = function(data, level) {
    return (!level || level <= 0 ? decode.XML : decode.HTML)(data);
};

exports.decodeStrict = function(data, level) {
    return (!level || level <= 0 ? decode.XML : decode.HTMLStrict)(data);
};

exports.encode = function(data, level) {
    return (!level || level <= 0 ? encode.XML : encode.HTML)(data);
};

exports.encodeXML = encode.XML;

exports.encodeHTML4 = exports.encodeHTML5 = exports.encodeHTML = encode.HTML;

exports.decodeXML = exports.decodeXMLStrict = decode.XML;

exports.decodeHTML4 = exports.decodeHTML5 = exports.decodeHTML = decode.HTML;

exports.decodeHTML4Strict = exports.decodeHTML5Strict = exports.decodeHTMLStrict = decode.HTMLStrict;

exports.escape = encode.escape;


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var inverseXML = getInverseObj(__webpack_require__(201)),
    xmlReplacer = getInverseReplacer(inverseXML);

exports.XML = getInverse(inverseXML, xmlReplacer);

var inverseHTML = getInverseObj(__webpack_require__(200)),
    htmlReplacer = getInverseReplacer(inverseHTML);

exports.HTML = getInverse(inverseHTML, htmlReplacer);

function getInverseObj(obj) {
    return Object.keys(obj)
        .sort()
        .reduce(function(inverse, name) {
            inverse[obj[name]] = "&" + name + ";";
            return inverse;
        }, {});
}

function getInverseReplacer(inverse) {
    var single = [],
        multiple = [];

    Object.keys(inverse).forEach(function(k) {
        if (k.length === 1) {
            single.push("\\" + k);
        } else {
            multiple.push(k);
        }
    });

    //TODO add ranges
    multiple.unshift("[" + single.join("") + "]");

    return new RegExp(multiple.join("|"), "g");
}

var re_nonASCII = /[^\0-\x7F]/g,
    re_astralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;

function singleCharReplacer(c) {
    return (
        "&#x" +
        c
            .charCodeAt(0)
            .toString(16)
            .toUpperCase() +
        ";"
    );
}

function astralReplacer(c) {
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    var high = c.charCodeAt(0);
    var low = c.charCodeAt(1);
    var codePoint = (high - 0xd800) * 0x400 + low - 0xdc00 + 0x10000;
    return "&#x" + codePoint.toString(16).toUpperCase() + ";";
}

function getInverse(inverse, re) {
    function func(name) {
        return inverse[name];
    }

    return function(data) {
        return data
            .replace(re, func)
            .replace(re_astralSymbols, astralReplacer)
            .replace(re_nonASCII, singleCharReplacer);
    };
}

var re_xmlChars = getInverseReplacer(inverseXML);

function escapeXML(data) {
    return data
        .replace(re_xmlChars, singleCharReplacer)
        .replace(re_astralSymbols, astralReplacer)
        .replace(re_nonASCII, singleCharReplacer);
}

exports.escape = escapeXML;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var entityMap = __webpack_require__(200),
    legacyMap = __webpack_require__(329),
    xmlMap = __webpack_require__(201),
    decodeCodePoint = __webpack_require__(328);

var decodeXMLStrict = getStrictDecoder(xmlMap),
    decodeHTMLStrict = getStrictDecoder(entityMap);

function getStrictDecoder(map) {
    var keys = Object.keys(map).join("|"),
        replace = getReplacer(map);

    keys += "|#[xX][\\da-fA-F]+|#\\d+";

    var re = new RegExp("&(?:" + keys + ");", "g");

    return function(str) {
        return String(str).replace(re, replace);
    };
}

var decodeHTML = (function() {
    var legacy = Object.keys(legacyMap).sort(sorter);

    var keys = Object.keys(entityMap).sort(sorter);

    for (var i = 0, j = 0; i < keys.length; i++) {
        if (legacy[j] === keys[i]) {
            keys[i] += ";?";
            j++;
        } else {
            keys[i] += ";";
        }
    }

    var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"),
        replace = getReplacer(entityMap);

    function replacer(str) {
        if (str.substr(-1) !== ";") str += ";";
        return replace(str);
    }

    //TODO consider creating a merged map
    return function(str) {
        return String(str).replace(re, replacer);
    };
})();

function sorter(a, b) {
    return a < b ? 1 : -1;
}

function getReplacer(map) {
    return function replace(str) {
        if (str.charAt(1) === "#") {
            if (str.charAt(2) === "X" || str.charAt(2) === "x") {
                return decodeCodePoint(parseInt(str.substr(3), 16));
            }
            return decodeCodePoint(parseInt(str.substr(2), 10));
        }
        return map[str.slice(1, -1)];
    };
}

module.exports = {
    XML: decodeXMLStrict,
    HTML: decodeHTML,
    HTMLStrict: decodeHTMLStrict
};


/***/ }),
/* 567 */
/***/ (function(module, exports) {

var getChildren = exports.getChildren = function(elem){
	return elem.children;
};

var getParent = exports.getParent = function(elem){
	return elem.parent;
};

exports.getSiblings = function(elem){
	var parent = getParent(elem);
	return parent ? getChildren(parent) : [elem];
};

exports.getAttributeValue = function(elem, name){
	return elem.attribs && elem.attribs[name];
};

exports.hasAttrib = function(elem, name){
	return !!elem.attribs && hasOwnProperty.call(elem.attribs, name);
};

exports.getName = function(elem){
	return elem.name;
};


/***/ }),
/* 568 */
/***/ (function(module, exports) {

exports.removeElement = function(elem){
	if(elem.prev) elem.prev.next = elem.next;
	if(elem.next) elem.next.prev = elem.prev;

	if(elem.parent){
		var childs = elem.parent.children;
		childs.splice(childs.lastIndexOf(elem), 1);
	}
};

exports.replaceElement = function(elem, replacement){
	var prev = replacement.prev = elem.prev;
	if(prev){
		prev.next = replacement;
	}

	var next = replacement.next = elem.next;
	if(next){
		next.prev = replacement;
	}

	var parent = replacement.parent = elem.parent;
	if(parent){
		var childs = parent.children;
		childs[childs.lastIndexOf(elem)] = replacement;
	}
};

exports.appendChild = function(elem, child){
	child.parent = elem;

	if(elem.children.push(child) !== 1){
		var sibling = elem.children[elem.children.length - 2];
		sibling.next = child;
		child.prev = sibling;
		child.next = null;
	}
};

exports.append = function(elem, next){
	var parent = elem.parent,
		currNext = elem.next;

	next.next = currNext;
	next.prev = elem;
	elem.next = next;
	next.parent = parent;

	if(currNext){
		currNext.prev = next;
		if(parent){
			var childs = parent.children;
			childs.splice(childs.lastIndexOf(currNext), 0, next);
		}
	} else if(parent){
		parent.children.push(next);
	}
};

exports.prepend = function(elem, prev){
	var parent = elem.parent;
	if(parent){
		var childs = parent.children;
		childs.splice(childs.lastIndexOf(elem), 0, prev);
	}

	if(elem.prev){
		elem.prev.next = prev;
	}
	
	prev.parent = parent;
	prev.prev = elem.prev;
	prev.next = elem;
	elem.prev = prev;
};




/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var isTag = __webpack_require__(103).isTag;

module.exports = {
	filter: filter,
	find: find,
	findOneChild: findOneChild,
	findOne: findOne,
	existsOne: existsOne,
	findAll: findAll
};

function filter(test, element, recurse, limit){
	if(!Array.isArray(element)) element = [element];

	if(typeof limit !== "number" || !isFinite(limit)){
		limit = Infinity;
	}
	return find(test, element, recurse !== false, limit);
}

function find(test, elems, recurse, limit){
	var result = [], childs;

	for(var i = 0, j = elems.length; i < j; i++){
		if(test(elems[i])){
			result.push(elems[i]);
			if(--limit <= 0) break;
		}

		childs = elems[i].children;
		if(recurse && childs && childs.length > 0){
			childs = find(test, childs, recurse, limit);
			result = result.concat(childs);
			limit -= childs.length;
			if(limit <= 0) break;
		}
	}

	return result;
}

function findOneChild(test, elems){
	for(var i = 0, l = elems.length; i < l; i++){
		if(test(elems[i])) return elems[i];
	}

	return null;
}

function findOne(test, elems){
	var elem = null;

	for(var i = 0, l = elems.length; i < l && !elem; i++){
		if(!isTag(elems[i])){
			continue;
		} else if(test(elems[i])){
			elem = elems[i];
		} else if(elems[i].children.length > 0){
			elem = findOne(test, elems[i].children);
		}
	}

	return elem;
}

function existsOne(test, elems){
	for(var i = 0, l = elems.length; i < l; i++){
		if(
			isTag(elems[i]) && (
				test(elems[i]) || (
					elems[i].children.length > 0 &&
					existsOne(test, elems[i].children)
				)
			)
		){
			return true;
		}
	}

	return false;
}

function findAll(test, rootElems){
	var result = [];
	var stack = rootElems.slice();
	while(stack.length){
		var elem = stack.shift();
		if(!isTag(elem)) continue;
		if (elem.children && elem.children.length > 0) {
			stack.unshift.apply(stack, elem.children);
		}
		if(test(elem)) result.push(elem);
	}
	return result;
}


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var ElementType = __webpack_require__(103);
var isTag = exports.isTag = ElementType.isTag;

exports.testElement = function(options, element){
	for(var key in options){
		if(!options.hasOwnProperty(key));
		else if(key === "tag_name"){
			if(!isTag(element) || !options.tag_name(element.name)){
				return false;
			}
		} else if(key === "tag_type"){
			if(!options.tag_type(element.type)) return false;
		} else if(key === "tag_contains"){
			if(isTag(element) || !options.tag_contains(element.data)){
				return false;
			}
		} else if(!element.attribs || !options[key](element.attribs[key])){
			return false;
		}
	}
	return true;
};

var Checks = {
	tag_name: function(name){
		if(typeof name === "function"){
			return function(elem){ return isTag(elem) && name(elem.name); };
		} else if(name === "*"){
			return isTag;
		} else {
			return function(elem){ return isTag(elem) && elem.name === name; };
		}
	},
	tag_type: function(type){
		if(typeof type === "function"){
			return function(elem){ return type(elem.type); };
		} else {
			return function(elem){ return elem.type === type; };
		}
	},
	tag_contains: function(data){
		if(typeof data === "function"){
			return function(elem){ return !isTag(elem) && data(elem.data); };
		} else {
			return function(elem){ return !isTag(elem) && elem.data === data; };
		}
	}
};

function getAttribCheck(attrib, value){
	if(typeof value === "function"){
		return function(elem){ return elem.attribs && value(elem.attribs[attrib]); };
	} else {
		return function(elem){ return elem.attribs && elem.attribs[attrib] === value; };
	}
}

function combineFuncs(a, b){
	return function(elem){
		return a(elem) || b(elem);
	};
}

exports.getElements = function(options, element, recurse, limit){
	var funcs = Object.keys(options).map(function(key){
		var value = options[key];
		return key in Checks ? Checks[key](value) : getAttribCheck(key, value);
	});

	return funcs.length === 0 ? [] : this.filter(
		funcs.reduce(combineFuncs),
		element, recurse, limit
	);
};

exports.getElementById = function(id, element, recurse){
	if(!Array.isArray(element)) element = [element];
	return this.findOne(getAttribCheck("id", id), element, recurse !== false);
};

exports.getElementsByTagName = function(name, element, recurse, limit){
	return this.filter(Checks.tag_name(name), element, recurse, limit);
};

exports.getElementsByTagType = function(type, element, recurse, limit){
	return this.filter(Checks.tag_type(type), element, recurse, limit);
};


/***/ }),
/* 571 */
/***/ (function(module, exports) {

// removeSubsets
// Given an array of nodes, remove any member that is contained by another.
exports.removeSubsets = function(nodes) {
	var idx = nodes.length, node, ancestor, replace;

	// Check if each node (or one of its ancestors) is already contained in the
	// array.
	while (--idx > -1) {
		node = ancestor = nodes[idx];

		// Temporarily remove the node under consideration
		nodes[idx] = null;
		replace = true;

		while (ancestor) {
			if (nodes.indexOf(ancestor) > -1) {
				replace = false;
				nodes.splice(idx, 1);
				break;
			}
			ancestor = ancestor.parent;
		}

		// If the node has been found to be unique, re-insert it.
		if (replace) {
			nodes[idx] = node;
		}
	}

	return nodes;
};

// Source: http://dom.spec.whatwg.org/#dom-node-comparedocumentposition
var POSITION = {
	DISCONNECTED: 1,
	PRECEDING: 2,
	FOLLOWING: 4,
	CONTAINS: 8,
	CONTAINED_BY: 16
};

// Compare the position of one node against another node in any other document.
// The return value is a bitmask with the following values:
//
// document order:
// > There is an ordering, document order, defined on all the nodes in the
// > document corresponding to the order in which the first character of the
// > XML representation of each node occurs in the XML representation of the
// > document after expansion of general entities. Thus, the document element
// > node will be the first node. Element nodes occur before their children.
// > Thus, document order orders element nodes in order of the occurrence of
// > their start-tag in the XML (after expansion of entities). The attribute
// > nodes of an element occur after the element and before its children. The
// > relative order of attribute nodes is implementation-dependent./
// Source:
// http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
//
// @argument {Node} nodaA The first node to use in the comparison
// @argument {Node} nodeB The second node to use in the comparison
//
// @return {Number} A bitmask describing the input nodes' relative position.
//         See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
//         a description of these values.
var comparePos = exports.compareDocumentPosition = function(nodeA, nodeB) {
	var aParents = [];
	var bParents = [];
	var current, sharedParent, siblings, aSibling, bSibling, idx;

	if (nodeA === nodeB) {
		return 0;
	}

	current = nodeA;
	while (current) {
		aParents.unshift(current);
		current = current.parent;
	}
	current = nodeB;
	while (current) {
		bParents.unshift(current);
		current = current.parent;
	}

	idx = 0;
	while (aParents[idx] === bParents[idx]) {
		idx++;
	}

	if (idx === 0) {
		return POSITION.DISCONNECTED;
	}

	sharedParent = aParents[idx - 1];
	siblings = sharedParent.children;
	aSibling = aParents[idx];
	bSibling = bParents[idx];

	if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
		if (sharedParent === nodeB) {
			return POSITION.FOLLOWING | POSITION.CONTAINED_BY;
		}
		return POSITION.FOLLOWING;
	} else {
		if (sharedParent === nodeA) {
			return POSITION.PRECEDING | POSITION.CONTAINS;
		}
		return POSITION.PRECEDING;
	}
};

// Sort an array of nodes based on their relative position in the document and
// remove any duplicate nodes. If the array contains nodes that do not belong
// to the same document, sort order is unspecified.
//
// @argument {Array} nodes Array of DOM nodes
//
// @returns {Array} collection of unique nodes, sorted in document order
exports.uniqueSort = function(nodes) {
	var idx = nodes.length, node, position;

	nodes = nodes.slice();

	while (--idx > -1) {
		node = nodes[idx];
		position = nodes.indexOf(node);
		if (position > -1 && position < idx) {
			nodes.splice(idx, 1);
		}
	}
	nodes.sort(function(a, b) {
		var relative = comparePos(a, b);
		if (relative & POSITION.PRECEDING) {
			return -1;
		} else if (relative & POSITION.FOLLOWING) {
			return 1;
		}
		return 0;
	});

	return nodes;
};


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = Stream;

var Parser = __webpack_require__(333);

function Stream(options) {
    Parser.call(this, new Cbs(this), options);
}

__webpack_require__(60)(Stream, Parser);

Stream.prototype.readable = true;

function Cbs(scope) {
    this.scope = scope;
}

var EVENTS = __webpack_require__(102).EVENTS;

Object.keys(EVENTS).forEach(function(name) {
    if (EVENTS[name] === 0) {
        Cbs.prototype["on" + name] = function() {
            this.scope.emit(name);
        };
    } else if (EVENTS[name] === 1) {
        Cbs.prototype["on" + name] = function(a) {
            this.scope.emit(name, a);
        };
    } else if (EVENTS[name] === 2) {
        Cbs.prototype["on" + name] = function(a, b) {
            this.scope.emit(name, a, b);
        };
    } else {
        throw Error("wrong number of arguments!");
    }
});


/***/ }),
/* 573 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 575 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = ProxyHandler;

function ProxyHandler(cbs) {
    this._cbs = cbs || {};
}

var EVENTS = __webpack_require__(102).EVENTS;
Object.keys(EVENTS).forEach(function(name) {
    if (EVENTS[name] === 0) {
        name = "on" + name;
        ProxyHandler.prototype[name] = function() {
            if (this._cbs[name]) this._cbs[name]();
        };
    } else if (EVENTS[name] === 1) {
        name = "on" + name;
        ProxyHandler.prototype[name] = function(a) {
            if (this._cbs[name]) this._cbs[name](a);
        };
    } else if (EVENTS[name] === 2) {
        name = "on" + name;
        ProxyHandler.prototype[name] = function(a, b) {
            if (this._cbs[name]) this._cbs[name](a, b);
        };
    } else {
        throw Error("wrong number of arguments");
    }
});


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = CollectingHandler;

function CollectingHandler(cbs) {
    this._cbs = cbs || {};
    this.events = [];
}

var EVENTS = __webpack_require__(102).EVENTS;
Object.keys(EVENTS).forEach(function(name) {
    if (EVENTS[name] === 0) {
        name = "on" + name;
        CollectingHandler.prototype[name] = function() {
            this.events.push([name]);
            if (this._cbs[name]) this._cbs[name]();
        };
    } else if (EVENTS[name] === 1) {
        name = "on" + name;
        CollectingHandler.prototype[name] = function(a) {
            this.events.push([name, a]);
            if (this._cbs[name]) this._cbs[name](a);
        };
    } else if (EVENTS[name] === 2) {
        name = "on" + name;
        CollectingHandler.prototype[name] = function(a, b) {
            this.events.push([name, a, b]);
            if (this._cbs[name]) this._cbs[name](a, b);
        };
    } else {
        throw Error("wrong number of arguments");
    }
});

CollectingHandler.prototype.onreset = function() {
    this.events = [];
    if (this._cbs.onreset) this._cbs.onreset();
};

CollectingHandler.prototype.restart = function() {
    if (this._cbs.onreset) this._cbs.onreset();

    for (var i = 0, len = this.events.length; i < len; i++) {
        if (this._cbs[this.events[i][0]]) {
            var num = this.events[i].length;

            if (num === 1) {
                this._cbs[this.events[i][0]]();
            } else if (num === 2) {
                this._cbs[this.events[i][0]](this.events[i][1]);
            } else {
                this._cbs[this.events[i][0]](
                    this.events[i][1],
                    this.events[i][2]
                );
            }
        }
    }
};


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TextElementType;
/**
 * Converts a text node to a React text element
 *
 * @param {Object} node The text node
 * @returns {String} The text
 */
function TextElementType(node) {

  // React will accept plain text for rendering so just return the node data
  return node.data;
}

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TagElementType;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _processNodes = __webpack_require__(199);

var _processNodes2 = _interopRequireDefault(_processNodes);

var _generatePropsFromAttributes = __webpack_require__(335);

var _generatePropsFromAttributes2 = _interopRequireDefault(_generatePropsFromAttributes);

var _VoidElements = __webpack_require__(584);

var _VoidElements2 = _interopRequireDefault(_VoidElements);

var _isValidTagOrAttributeName = __webpack_require__(336);

var _isValidTagOrAttributeName2 = _interopRequireDefault(_isValidTagOrAttributeName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Converts any element (excluding style - see StyleElementType - and script) to a react element.
 *
 * @param {Object} node The tag node
 * @param {String} index The index of the React element relative to it's parent
 * @param {Function} transform The transform function to apply to all children
 * @returns {React.Element} The React tag element
 */
function TagElementType(node, index, transform) {

  var tagName = node.name;

  // validate tag name
  if (!(0, _isValidTagOrAttributeName2.default)(tagName)) {
    return null;
  }

  // generate props
  var props = (0, _generatePropsFromAttributes2.default)(node.attribs, index);

  // If the node is not a void element and has children then process them
  var children = null;
  if (_VoidElements2.default.indexOf(tagName) === -1) {
    children = (0, _processNodes2.default)(node.children, transform);
  }

  // create and return the element
  return _react2.default.createElement(tagName, props, children);
}

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = htmlAttributesToReact;

var _BooleanAttributes = __webpack_require__(581);

var _BooleanAttributes2 = _interopRequireDefault(_BooleanAttributes);

var _ReactAttributes = __webpack_require__(582);

var _ReactAttributes2 = _interopRequireDefault(_ReactAttributes);

var _isValidTagOrAttributeName = __webpack_require__(336);

var _isValidTagOrAttributeName2 = _interopRequireDefault(_isValidTagOrAttributeName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns the parsed attribute value taking into account things like boolean attributes
 *
 * @param {String} attribute The name of the attribute
 * @param {*} value The value of the attribute from the HTML
 * @returns {*} The parsed attribute value
 */
var getParsedAttributeValue = function getParsedAttributeValue(attribute, value) {

  // if the attribute if a boolean then it's value should be the same as it's name
  // e.g. disabled="disabled"
  var lowerBooleanAttributes = _BooleanAttributes2.default.map(function (attr) {
    return attr.toLowerCase();
  });
  if (lowerBooleanAttributes.indexOf(attribute.toLowerCase()) >= 0) {
    value = attribute;
  }

  return value;
};

/**
 * Takes an object of standard HTML property names and converts them to their React counterpart. If the react
 * version does not exist for an attribute then just use it as it is
 *
 * @param {Object} attributes The HTML attributes to convert
 * @returns {Object} The React attributes
 */
function htmlAttributesToReact(attributes) {

  return Object.keys(attributes).filter(function (attr) {
    return (0, _isValidTagOrAttributeName2.default)(attr);
  }).reduce(function (mappedAttributes, attribute) {

    // lowercase the attribute name and find it in the react attribute map
    var lowerCaseAttribute = attribute.toLowerCase();

    // format the attribute name
    var name = _ReactAttributes2.default[lowerCaseAttribute] || lowerCaseAttribute;

    // add the parsed attribute value to the mapped attributes
    mappedAttributes[name] = getParsedAttributeValue(name, attributes[attribute]);

    return mappedAttributes;
  }, {});
}

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * List of boolean attributes
 * These attributes should have their React attribute value set to be the same as their name
 * E.g. <input disabled> = <input disabled>
 *      <input disabled=""> = <input disabled>
 *      <input disabled="disabled"> = <input disabled>
 * @type {Array}
 */
exports.default = ['allowfullScreen', 'async', 'autoplay', 'capture', 'checked', 'controls', 'default', 'defer', 'disabled', 'formnovalidate', 'hidden', 'loop', 'multiple', 'muted', 'novalidate', 'open', 'playsinline', 'readonly', 'required', 'reversed', 'scoped', 'seamless', 'selected', 'itemscope'];

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Mapping of standard HTML attributes to their React counterparts
 * List taken and reversed from react/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
 * https://github.com/facebook/react/blob/c9c3c339b757682f1154f1c915eb55e6a8766933/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
 * @type {Object}
 */
exports.default = {
  /**
   * Standard Properties
   */
  accept: 'accept',
  'accept-charset': 'acceptCharset',
  accesskey: 'accessKey',
  action: 'action',
  allowfullscreen: 'allowFullScreen',
  allowtransparency: 'allowTransparency',
  alt: 'alt',
  as: 'as',
  async: 'async',
  autocomplete: 'autoComplete',
  autoplay: 'autoPlay',
  capture: 'capture',
  cellpadding: 'cellPadding',
  cellspacing: 'cellSpacing',
  charset: 'charSet',
  challenge: 'challenge',
  checked: 'checked',
  cite: 'cite',
  classid: 'classID',
  class: 'className',
  cols: 'cols',
  colspan: 'colSpan',
  content: 'content',
  contenteditable: 'contentEditable',
  contextmenu: 'contextMenu',
  controls: 'controls',
  controlsList: 'controlsList',
  coords: 'coords',
  crossorigin: 'crossOrigin',
  data: 'data',
  datetime: 'dateTime',
  default: 'default',
  defer: 'defer',
  dir: 'dir',
  disabled: 'disabled',
  download: 'download',
  draggable: 'draggable',
  enctype: 'encType',
  form: 'form',
  formaction: 'formAction',
  formenctype: 'formEncType',
  formmethod: 'formMethod',
  formnovalidate: 'formNoValidate',
  formtarget: 'formTarget',
  frameborder: 'frameBorder',
  headers: 'headers',
  height: 'height',
  hidden: 'hidden',
  high: 'high',
  href: 'href',
  hreflang: 'hrefLang',
  for: 'htmlFor',
  'http-equiv': 'httpEquiv',
  icon: 'icon',
  id: 'id',
  inputmode: 'inputMode',
  integrity: 'integrity',
  is: 'is',
  keyparams: 'keyParams',
  keytype: 'keyType',
  kind: 'kind',
  label: 'label',
  lang: 'lang',
  list: 'list',
  loop: 'loop',
  low: 'low',
  manifest: 'manifest',
  marginheight: 'marginHeight',
  marginwidth: 'marginWidth',
  max: 'max',
  maxlength: 'maxLength',
  media: 'media',
  mediagroup: 'mediaGroup',
  method: 'method',
  min: 'min',
  minlength: 'minLength',
  multiple: 'multiple',
  muted: 'muted',
  name: 'name',
  nonce: 'nonce',
  novalidate: 'noValidate',
  open: 'open',
  optimum: 'optimum',
  pattern: 'pattern',
  placeholder: 'placeholder',
  playsinline: 'playsInline',
  poster: 'poster',
  preload: 'preload',
  profile: 'profile',
  radiogroup: 'radioGroup',
  readonly: 'readOnly',
  referrerpolicy: 'referrerPolicy',
  rel: 'rel',
  required: 'required',
  reversed: 'reversed',
  role: 'role',
  rows: 'rows',
  rowspan: 'rowSpan',
  sandbox: 'sandbox',
  scope: 'scope',
  scoped: 'scoped',
  scrolling: 'scrolling',
  seamless: 'seamless',
  selected: 'selected',
  shape: 'shape',
  size: 'size',
  sizes: 'sizes',
  slot: 'slot',
  span: 'span',
  spellcheck: 'spellCheck',
  src: 'src',
  srcdoc: 'srcDoc',
  srclang: 'srcLang',
  srcset: 'srcSet',
  start: 'start',
  step: 'step',
  style: 'style',
  summary: 'summary',
  tabindex: 'tabIndex',
  target: 'target',
  title: 'title',
  type: 'type',
  usemap: 'useMap',
  value: 'value',
  width: 'width',
  wmode: 'wmode',
  wrap: 'wrap',
  /**
   * RDFa Properties
   */
  about: 'about',
  datatype: 'datatype',
  inlist: 'inlist',
  prefix: 'prefix',
  property: 'property',
  resource: 'resource',
  typeof: 'typeof',
  vocab: 'vocab',
  /**
   * Non-standard Properties
   */
  autocapitalize: 'autoCapitalize',
  autocorrect: 'autoCorrect',
  autosave: 'autoSave',
  color: 'color',
  itemprop: 'itemProp',
  itemscope: 'itemScope',
  itemtype: 'itemType',
  itemid: 'itemID',
  itemref: 'itemRef',
  results: 'results',
  security: 'security',
  unselectable: 'unselectable'
};

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = InlineStyleToObject;
/**
 * Converts an inline style string into an object of React style properties
 *
 * @param {String} inlineStyle='' The inline style to convert
 * @returns {Object} The converted style
 */
function InlineStyleToObject() {
  var inlineStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';


  // just return empty object if the inlineStyle is empty
  if (inlineStyle === '') {
    return {};
  }

  return inlineStyle.split(';').reduce(function (styleObject, stylePropertyValue) {

    // extract the style property name and value
    var _stylePropertyValue$s = stylePropertyValue.split(/^([^:]+):/).filter(function (val, i) {
      return i > 0;
    }).map(function (item) {
      return item.trim().toLowerCase();
    }),
        _stylePropertyValue$s2 = _slicedToArray(_stylePropertyValue$s, 2),
        property = _stylePropertyValue$s2[0],
        value = _stylePropertyValue$s2[1];

    // if there is no value (i.e. no : in the style) then ignore it


    if (value === undefined) {
      return styleObject;
    }

    // convert the property name into the correct React format
    // remove all hyphens and convert the letter immediately after each hyphen to upper case
    // additionally don't uppercase any -ms- prefix
    // e.g. -ms-style-property = msStyleProperty
    //      -webkit-style-property = WebkitStyleProperty
    property = property.replace(/^-ms-/, 'ms-').replace(/-(.)/g, function (_, character) {
      return character.toUpperCase();
    });

    // add the new style property and value to the style object
    styleObject[property] = value;

    return styleObject;
  }, {});
}

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * List of void elements
 * These elements are not allowed to have children
 * @type {Array}
 */
exports.default = ['area', 'base', 'br', 'col', 'command', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'meta', 'param', 'source', 'track', 'wbr'];

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StyleElementType;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _generatePropsFromAttributes = __webpack_require__(335);

var _generatePropsFromAttributes2 = _interopRequireDefault(_generatePropsFromAttributes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Converts a <style> element to a React element
 *
 * @param {Object} node The style node
 * @param {String} index The index of the React element relative to it's parent
 * @returns {React.Element} The React style element
 */
function StyleElementType(node, index) {

  // The style element only ever has a single child which is the styles so try and find this to add as
  // a child to the style element that will be created
  var styles = void 0;
  if (node.children.length > 0) {
    styles = node.children[0].data;
  }

  // generate props
  var props = (0, _generatePropsFromAttributes2.default)(node.attribs, index);

  // create and return the element
  return _react2.default.createElement('style', props, styles);
}

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UnsupportedElementType;
/**
 * Handles an unsupported element type by returning null so nothing is rendered
 * @returns {null}
 */
function UnsupportedElementType() {

  // do nothing because the element type is unsupported
  // comment, directive, script, cdata, doctype are all currently unsupported
  return null;
}

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HtmlParser;

var _htmlparser = __webpack_require__(102);

var _htmlparser2 = _interopRequireDefault(_htmlparser);

var _processNodes = __webpack_require__(199);

var _processNodes2 = _interopRequireDefault(_processNodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Parses a HTML string and returns a list of React components generated from it
 *
 * @param {String} html The HTML to convert into React component
 * @param {Object} options Options to pass
 * @returns {Array} List of top level React elements
 */
function HtmlParser(html) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$decodeEntities = _ref.decodeEntities,
      decodeEntities = _ref$decodeEntities === undefined ? true : _ref$decodeEntities,
      transform = _ref.transform,
      _ref$preprocessNodes = _ref.preprocessNodes,
      preprocessNodes = _ref$preprocessNodes === undefined ? function (nodes) {
    return nodes;
  } : _ref$preprocessNodes;

  var nodes = preprocessNodes(_htmlparser2.default.parseDOM(html, { decodeEntities: decodeEntities }));
  return (0, _processNodes2.default)(nodes, transform);
}

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports = {"UM_DOMAIN":"heymath.co.za/um","REV_DOMAIN":"heymath.co.za/rev","PC_DOMAIN":"heymath.co.za/pc","WEB_DOMAIN":"heymath.co.za","OPS_DOMAIN":"ops.heymath.com","LUMOS_PC_DOMAIN":"pc.heymath.com","LUMOS_UM_DOMAIN":"heymath.co.za/lum","WIRIS_DOMAIN":"me.heymath.com","CS_DOMAIN":"cs.heymath.co.za","ORIG_CS_DOMAIN":"cs.heymath.com","CP_DOMAIN":"contests.heymath.com","CONTEST_UM_DOMAIN":"contests.heymath.com/um","CP_DOMAIN_API":"contests.heymath.com/api"}

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(4), __webpack_require__(590), __webpack_require__(591), __webpack_require__(592), __webpack_require__(593), __webpack_require__(594), __webpack_require__(595), __webpack_require__(596), __webpack_require__(609), __webpack_require__(597), __webpack_require__(598), __webpack_require__(599), __webpack_require__(600), __webpack_require__(601), __webpack_require__(602), __webpack_require__(604), __webpack_require__(606), __webpack_require__(608)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"), require("./loader/Audio"), require("./loader/BallTriangle"), require("./loader/Bars"), require("./loader/Circles"), require("./loader/Grid"), require("./loader/Hearts"), require("./loader/Oval"), require("./loader/Puff"), require("./loader/Rings"), require("./loader/TailSpin"), require("./loader/ThreeDots"), require("./loader/Watch"), require("./loader/RevolvingDot"), require("./loader/CradleLoader"), require("./loader/Triangle"), require("./loader/Plane"), require("./loader/MutatingDot"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.Audio, global.BallTriangle, global.Bars, global.Circles, global.Grid, global.Hearts, global.Oval, global.Puff, global.Rings, global.TailSpin, global.ThreeDots, global.Watch, global.RevolvingDot, global.CradleLoader, global.Triangle, global.Plane, global.MutatingDot);
    global.index = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _Audio, _BallTriangle, _Bars, _Circles, _Grid, _Hearts, _Oval, _Puff, _Rings, _TailSpin, _ThreeDots, _Watch, _RevolvingDot, _CradleLoader, _Triangle, _Plane, _MutatingDot) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Loader = function (_React$Component) {
    _inherits(Loader, _React$Component);

    function Loader() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Loader);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Loader.__proto__ || Object.getPrototypeOf(Loader)).call.apply(_ref, [this].concat(args))), _this), _this.svgRenderer = function (type) {
        switch (type) {
          case "Audio":
            return _react2.default.createElement(_Audio.Audio, _this.props);
          case "Ball-Triangle":
            return _react2.default.createElement(_BallTriangle.BallTriangle, _this.props);
          case "Bars":
            return _react2.default.createElement(_Bars.Bars, _this.props);
          case "Circles":
            return _react2.default.createElement(_Circles.Circles, _this.props);
          case "Grid":
            return _react2.default.createElement(_Grid.Grid, _this.props);
          case "Hearts":
            return _react2.default.createElement(_Hearts.Hearts, _this.props);
          case "Oval":
            return _react2.default.createElement(_Oval.Oval, _this.props);
          case "Puff":
            return _react2.default.createElement(_Puff.Puff, _this.props);
          case "Rings":
            return _react2.default.createElement(_Rings.Rings, _this.props);
          case "TailSpin":
            return _react2.default.createElement(_TailSpin.TailSpin, _this.props);
          case "ThreeDots":
            return _react2.default.createElement(_ThreeDots.ThreeDots, _this.props);
          case "Watch":
            return _react2.default.createElement(_Watch.Watch, _this.props);
          case "RevolvingDot":
            return _react2.default.createElement(_RevolvingDot.RevolvingDot, _this.props);
          case "CradleLoader":
            return _react2.default.createElement(_CradleLoader.CradleLoader, _this.props);
          case "Triangle":
            return _react2.default.createElement(_Triangle.Triangle, _this.props);
          case "Plane":
            return _react2.default.createElement(_Plane.Plane, _this.props);
          case "MutatingDot":
            return _react2.default.createElement(_MutatingDot.MutatingDot, _this.props);
          default:
            return _react2.default.createElement(
              "div",
              null,
              _react2.default.createElement(
                "span",
                { style: { color: "Green" } },
                "LOADING"
              ),
              _react2.default.createElement(
                "small",
                null,
                _react2.default.createElement(
                  "i",
                  null,
                  _react2.default.createElement("br", null),
                  "Note:No specific svg type exist"
                )
              )
            );
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Loader, [{
      key: "render",
      value: function render() {
        var type = this.props.type;

        return _react2.default.createElement(
          "div",
          { className: this.props.style },
          this.svgRenderer(type)
        );
      }
    }]);

    return Loader;
  }(_react2.default.Component);

  Loader.propTypes = {
    color: _propTypes2.default.string,
    type: _propTypes2.default.string,
    height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    style: _propTypes2.default.shape({})
  };
  Loader.defaultProps = {
    color: "#71238",
    type: "Audio",
    height: 80,
    width: 80
  };
  exports.default = Loader;
});

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Audio = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Audio = undefined;

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Audio = exports.Audio = function Audio(svg) {
    return _react2.default.createElement(
      "svg",
      {
        height: svg.height,
        width: svg.width,
        fill: svg.color,
        viewBox: "0 0 55 80",
        xmlns: "http://www.w3.org/2000/svg"
      },
      _react2.default.createElement(
        "g",
        { transform: "matrix(1 0 0 -1 0 80)" },
        _react2.default.createElement(
          "rect",
          { width: "10", height: "20", rx: "3" },
          _react2.default.createElement("animate", {
            attributeName: "height",
            begin: "0s",
            dur: "4.3s",
            values: "20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20",
            calcMode: "linear",
            repeatCount: "indefinite"
          })
        ),
        _react2.default.createElement(
          "rect",
          { x: "15", width: "10", height: "80", rx: "3" },
          _react2.default.createElement("animate", {
            attributeName: "height",
            begin: "0s",
            dur: "2s",
            values: "80;55;33;5;75;23;73;33;12;14;60;80",
            calcMode: "linear",
            repeatCount: "indefinite"
          })
        ),
        _react2.default.createElement(
          "rect",
          { x: "30", width: "10", height: "50", rx: "3" },
          _react2.default.createElement("animate", {
            attributeName: "height",
            begin: "0s",
            dur: "1.4s",
            values: "50;34;78;23;56;23;34;76;80;54;21;50",
            calcMode: "linear",
            repeatCount: "indefinite"
          })
        ),
        _react2.default.createElement(
          "rect",
          { x: "45", width: "10", height: "30", rx: "3" },
          _react2.default.createElement("animate", {
            attributeName: "height",
            begin: "0s",
            dur: "2s",
            values: "30;45;13;80;56;72;45;76;34;23;67;30",
            calcMode: "linear",
            repeatCount: "indefinite"
          })
        )
      )
    );
  };
});

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.BallTriangle = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.BallTriangle = undefined;

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var BallTriangle = exports.BallTriangle = function BallTriangle(svg) {
    return _react2.default.createElement(
      "svg",
      {
        height: svg.height,
        width: svg.width,
        stroke: svg.color,
        viewBox: "0 0 57 57",
        xmlns: "http://www.w3.org/2000/svg"
      },
      _react2.default.createElement(
        "g",
        { fill: "none", fillRule: "evenodd" },
        _react2.default.createElement(
          "g",
          { transform: "translate(1 1)", strokeWidth: "2" },
          _react2.default.createElement(
            "circle",
            { cx: "5", cy: "50", r: "5" },
            _react2.default.createElement("animate", {
              attributeName: "cy",
              begin: "0s",
              dur: "2.2s",
              values: "50;5;50;50",
              calcMode: "linear",
              repeatCount: "indefinite"
            }),
            _react2.default.createElement("animate", {
              attributeName: "cx",
              begin: "0s",
              dur: "2.2s",
              values: "5;27;49;5",
              calcMode: "linear",
              repeatCount: "indefinite"
            })
          ),
          _react2.default.createElement(
            "circle",
            { cx: "27", cy: "5", r: "5" },
            _react2.default.createElement("animate", {
              attributeName: "cy",
              begin: "0s",
              dur: "2.2s",
              from: "5",
              to: "5",
              values: "5;50;50;5",
              calcMode: "linear",
              repeatCount: "indefinite"
            }),
            _react2.default.createElement("animate", {
              attributeName: "cx",
              begin: "0s",
              dur: "2.2s",
              from: "27",
              to: "27",
              values: "27;49;5;27",
              calcMode: "linear",
              repeatCount: "indefinite"
            })
          ),
          _react2.default.createElement(
            "circle",
            { cx: "49", cy: "50", r: "5" },
            _react2.default.createElement("animate", {
              attributeName: "cy",
              begin: "0s",
              dur: "2.2s",
              values: "50;50;5;50",
              calcMode: "linear",
              repeatCount: "indefinite"
            }),
            _react2.default.createElement("animate", {
              attributeName: "cx",
              from: "49",
              to: "49",
              begin: "0s",
              dur: "2.2s",
              values: "49;5;27;49",
              calcMode: "linear",
              repeatCount: "indefinite"
            })
          )
        )
      )
    );
  };
});

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Bars = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Bars = undefined;

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Bars = exports.Bars = function Bars(svg) {
    return _react2.default.createElement(
      "svg",
      {
        width: svg.height,
        height: svg.width,
        fill: svg.color,
        viewBox: "0 0 135 140",
        xmlns: "http://www.w3.org/2000/svg"
      },
      _react2.default.createElement(
        "rect",
        { y: "10", width: "15", height: "120", rx: "6" },
        _react2.default.createElement("animate", {
          attributeName: "height",
          begin: "0.5s",
          dur: "1s",
          values: "120;110;100;90;80;70;60;50;40;140;120",
          calcMode: "linear",
          repeatCount: "indefinite"
        }),
        _react2.default.createElement("animate", {
          attributeName: "y",
          begin: "0.5s",
          dur: "1s",
          values: "10;15;20;25;30;35;40;45;50;0;10",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      ),
      _react2.default.createElement(
        "rect",
        { x: "30", y: "10", width: "15", height: "120", rx: "6" },
        _react2.default.createElement("animate", {
          attributeName: "height",
          begin: "0.25s",
          dur: "1s",
          values: "120;110;100;90;80;70;60;50;40;140;120",
          calcMode: "linear",
          repeatCount: "indefinite"
        }),
        _react2.default.createElement("animate", {
          attributeName: "y",
          begin: "0.25s",
          dur: "1s",
          values: "10;15;20;25;30;35;40;45;50;0;10",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      ),
      _react2.default.createElement(
        "rect",
        { x: "60", width: "15", height: "140", rx: "6" },
        _react2.default.createElement("animate", {
          attributeName: "height",
          begin: "0s",
          dur: "1s",
          values: "120;110;100;90;80;70;60;50;40;140;120",
          calcMode: "linear",
          repeatCount: "indefinite"
        }),
        _react2.default.createElement("animate", {
          attributeName: "y",
          begin: "0s",
          dur: "1s",
          values: "10;15;20;25;30;35;40;45;50;0;10",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      ),
      _react2.default.createElement(
        "rect",
        { x: "90", y: "10", width: "15", height: "120", rx: "6" },
        _react2.default.createElement("animate", {
          attributeName: "height",
          begin: "0.25s",
          dur: "1s",
          values: "120;110;100;90;80;70;60;50;40;140;120",
          calcMode: "linear",
          repeatCount: "indefinite"
        }),
        _react2.default.createElement("animate", {
          attributeName: "y",
          begin: "0.25s",
          dur: "1s",
          values: "10;15;20;25;30;35;40;45;50;0;10",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      ),
      _react2.default.createElement(
        "rect",
        { x: "120", y: "10", width: "15", height: "120", rx: "6" },
        _react2.default.createElement("animate", {
          attributeName: "height",
          begin: "0.5s",
          dur: "1s",
          values: "120;110;100;90;80;70;60;50;40;140;120",
          calcMode: "linear",
          repeatCount: "indefinite"
        }),
        _react2.default.createElement("animate", {
          attributeName: "y",
          begin: "0.5s",
          dur: "1s",
          values: "10;15;20;25;30;35;40;45;50;0;10",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      )
    );
  };
});

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Circles = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Circles = undefined;

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Circles = exports.Circles = function Circles(svg) {
    return _react2.default.createElement(
      "svg",
      {
        width: svg.width,
        height: svg.height,
        viewBox: "0 0 135 135",
        xmlns: "http://www.w3.org/2000/svg",
        fill: svg.color
      },
      _react2.default.createElement(
        "path",
        { d: "M67.447 58c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm9.448 9.447c0 5.523 4.477 10 10 10 5.522 0 10-4.477 10-10s-4.478-10-10-10c-5.523 0-10 4.477-10 10zm-9.448 9.448c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zM58 67.447c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10z" },
        _react2.default.createElement("animateTransform", {
          attributeName: "transform",
          type: "rotate",
          from: "0 67 67",
          to: "-360 67 67",
          dur: "2.5s",
          repeatCount: "indefinite"
        })
      ),
      _react2.default.createElement(
        "path",
        { d: "M28.19 40.31c6.627 0 12-5.374 12-12 0-6.628-5.373-12-12-12-6.628 0-12 5.372-12 12 0 6.626 5.372 12 12 12zm30.72-19.825c4.686 4.687 12.284 4.687 16.97 0 4.686-4.686 4.686-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97zm35.74 7.705c0 6.627 5.37 12 12 12 6.626 0 12-5.373 12-12 0-6.628-5.374-12-12-12-6.63 0-12 5.372-12 12zm19.822 30.72c-4.686 4.686-4.686 12.284 0 16.97 4.687 4.686 12.285 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.97-4.685-4.687-12.283-4.687-16.97 0zm-7.704 35.74c-6.627 0-12 5.37-12 12 0 6.626 5.373 12 12 12s12-5.374 12-12c0-6.63-5.373-12-12-12zm-30.72 19.822c-4.686-4.686-12.284-4.686-16.97 0-4.686 4.687-4.686 12.285 0 16.97 4.686 4.687 12.284 4.687 16.97 0 4.687-4.685 4.687-12.283 0-16.97zm-35.74-7.704c0-6.627-5.372-12-12-12-6.626 0-12 5.373-12 12s5.374 12 12 12c6.628 0 12-5.373 12-12zm-19.823-30.72c4.687-4.686 4.687-12.284 0-16.97-4.686-4.686-12.284-4.686-16.97 0-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0z" },
        _react2.default.createElement("animateTransform", {
          attributeName: "transform",
          type: "rotate",
          from: "0 67 67",
          to: "360 67 67",
          dur: "8s",
          repeatCount: "indefinite"
        })
      )
    );
  };
});

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Grid = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Grid = undefined;

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Grid = exports.Grid = function Grid(svg) {
    return _react2.default.createElement(
      "svg",
      { width: svg.width, height: svg.height, viewBox: "0 0 105 105", fill: svg.color },
      _react2.default.createElement(
        "circle",
        { cx: "12.5", cy: "12.5", r: "12.5" },
        _react2.default.createElement("animate", {
          attributeName: "fill-opacity",
          begin: "0s",
          dur: "1s",
          values: "1;.2;1",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      ),
      _react2.default.createElement(
        "circle",
        { cx: "12.5", cy: "52.5", r: "12.5" },
        _react2.default.createElement("animate", {
          attributeName: "fill-opacity",
          begin: "100ms",
          dur: "1s",
          values: "1;.2;1",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      ),
      _react2.default.createElement(
        "circle",
        { cx: "52.5", cy: "12.5", r: "12.5" },
        _react2.default.createElement("animate", {
          attributeName: "fill-opacity",
          begin: "300ms",
          dur: "1s",
          values: "1;.2;1",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      ),
      _react2.default.createElement(
        "circle",
        { cx: "52.5", cy: "52.5", r: "12.5" },
        _react2.default.createElement("animate", {
          attributeName: "fill-opacity",
          begin: "600ms",
          dur: "1s",
          values: "1;.2;1",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      ),
      _react2.default.createElement(
        "circle",
        { cx: "92.5", cy: "12.5", r: "12.5" },
        _react2.default.createElement("animate", {
          attributeName: "fill-opacity",
          begin: "800ms",
          dur: "1s",
          values: "1;.2;1",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      ),
      _react2.default.createElement(
        "circle",
        { cx: "92.5", cy: "52.5", r: "12.5" },
        _react2.default.createElement("animate", {
          attributeName: "fill-opacity",
          begin: "400ms",
          dur: "1s",
          values: "1;.2;1",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      ),
      _react2.default.createElement(
        "circle",
        { cx: "12.5", cy: "92.5", r: "12.5" },
        _react2.default.createElement("animate", {
          attributeName: "fill-opacity",
          begin: "700ms",
          dur: "1s",
          values: "1;.2;1",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      ),
      _react2.default.createElement(
        "circle",
        { cx: "52.5", cy: "92.5", r: "12.5" },
        _react2.default.createElement("animate", {
          attributeName: "fill-opacity",
          begin: "500ms",
          dur: "1s",
          values: "1;.2;1",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      ),
      _react2.default.createElement(
        "circle",
        { cx: "92.5", cy: "92.5", r: "12.5" },
        _react2.default.createElement("animate", {
          attributeName: "fill-opacity",
          begin: "200ms",
          dur: "1s",
          values: "1;.2;1",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      )
    );
  };
});

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Hearts = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Hearts = undefined;

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Hearts = exports.Hearts = function Hearts(svg) {
    return _react2.default.createElement(
      "svg",
      {
        width: svg.width,
        height: svg.height,
        viewBox: "0 0 140 64",
        xmlns: "http://www.w3.org/2000/svg",
        fill: svg.color
      },
      _react2.default.createElement(
        "path",
        {
          d: "M30.262 57.02L7.195 40.723c-5.84-3.976-7.56-12.06-3.842-18.063 3.715-6 11.467-7.65 17.306-3.68l4.52 3.76 2.6-5.274c3.717-6.002 11.47-7.65 17.305-3.68 5.84 3.97 7.56 12.054 3.842 18.062L34.49 56.118c-.897 1.512-2.793 1.915-4.228.9z",
          attributeName: "fill-opacity",
          from: "0",
          to: ".5"
        },
        _react2.default.createElement("animate", {
          attributeName: "fill-opacity",
          begin: "0s",
          dur: "1.4s",
          values: "0.5;1;0.5",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      ),
      _react2.default.createElement(
        "path",
        {
          d: "M105.512 56.12l-14.44-24.272c-3.716-6.008-1.996-14.093 3.843-18.062 5.835-3.97 13.588-2.322 17.306 3.68l2.6 5.274 4.52-3.76c5.84-3.97 13.592-2.32 17.307 3.68 3.718 6.003 1.998 14.088-3.842 18.064L109.74 57.02c-1.434 1.014-3.33.61-4.228-.9z",
          attributeName: "fill-opacity",
          from: "0",
          to: ".5"
        },
        _react2.default.createElement("animate", {
          attributeName: "fill-opacity",
          begin: "0.7s",
          dur: "1.4s",
          values: "0.5;1;0.5",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      ),
      _react2.default.createElement("path", { d: "M67.408 57.834l-23.01-24.98c-5.864-6.15-5.864-16.108 0-22.248 5.86-6.14 15.37-6.14 21.234 0L70 16.168l4.368-5.562c5.863-6.14 15.375-6.14 21.235 0 5.863 6.14 5.863 16.098 0 22.247l-23.007 24.98c-1.43 1.556-3.757 1.556-5.188 0z" })
    );
  };
});

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Oval = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Oval = undefined;

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Oval = exports.Oval = function Oval(svg) {
    return _react2.default.createElement(
      "svg",
      {
        width: svg.width,
        height: svg.height,
        viewBox: "0 0 38 38",
        xmlns: "http://www.w3.org/2000/svg",
        stroke: svg.color
      },
      _react2.default.createElement(
        "g",
        { fill: "none", fillRule: "evenodd" },
        _react2.default.createElement(
          "g",
          { transform: "translate(1 1)", strokeWidth: "2" },
          _react2.default.createElement("circle", { strokeOpacity: ".5", cx: "18", cy: "18", r: "18" }),
          _react2.default.createElement(
            "path",
            { d: "M36 18c0-9.94-8.06-18-18-18" },
            _react2.default.createElement("animateTransform", {
              attributeName: "transform",
              type: "rotate",
              from: "0 18 18",
              to: "360 18 18",
              dur: "1s",
              repeatCount: "indefinite"
            })
          )
        )
      )
    );
  };
});

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Rings = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Rings = undefined;

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Rings = exports.Rings = function Rings(svg) {
    return _react2.default.createElement(
      "svg",
      {
        width: svg.width,
        height: svg.height,
        viewBox: "0 0 45 45",
        xmlns: "http://www.w3.org/2000/svg",
        stroke: svg.color
      },
      _react2.default.createElement(
        "g",
        { fill: "none", fillRule: "evenodd", transform: "translate(1 1)", strokeWidth: "2" },
        _react2.default.createElement(
          "circle",
          { cx: "22", cy: "22", r: "6", strokeOpacity: "0" },
          _react2.default.createElement("animate", {
            attributeName: "r",
            begin: "1.5s",
            dur: "3s",
            values: "6;22",
            calcMode: "linear",
            repeatCount: "indefinite"
          }),
          _react2.default.createElement("animate", {
            attributeName: "stroke-opacity",
            begin: "1.5s",
            dur: "3s",
            values: "1;0",
            calcMode: "linear",
            repeatCount: "indefinite"
          }),
          _react2.default.createElement("animate", {
            attributeName: "stroke-width",
            begin: "1.5s",
            dur: "3s",
            values: "2;0",
            calcMode: "linear",
            repeatCount: "indefinite"
          })
        ),
        _react2.default.createElement(
          "circle",
          { cx: "22", cy: "22", r: "6", strokeOpacity: "0" },
          _react2.default.createElement("animate", {
            attributeName: "r",
            begin: "3s",
            dur: "3s",
            values: "6;22",
            calcMode: "linear",
            repeatCount: "indefinite"
          }),
          _react2.default.createElement("animate", {
            attributeName: "strokeOpacity",
            begin: "3s",
            dur: "3s",
            values: "1;0",
            calcMode: "linear",
            repeatCount: "indefinite"
          }),
          _react2.default.createElement("animate", {
            attributeName: "strokeWidth",
            begin: "3s",
            dur: "3s",
            values: "2;0",
            calcMode: "linear",
            repeatCount: "indefinite"
          })
        ),
        _react2.default.createElement(
          "circle",
          { cx: "22", cy: "22", r: "8" },
          _react2.default.createElement("animate", {
            attributeName: "r",
            begin: "0s",
            dur: "1.5s",
            values: "6;1;2;3;4;5;6",
            calcMode: "linear",
            repeatCount: "indefinite"
          })
        )
      )
    );
  };
});

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.TailSpin = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.TailSpin = undefined;

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var TailSpin = exports.TailSpin = function TailSpin(svg) {
    return _react2.default.createElement(
      "svg",
      { width: svg.width, height: svg.height, viewBox: "0 0 38 38", xmlns: "http://www.w3.org/2000/svg" },
      _react2.default.createElement(
        "defs",
        null,
        _react2.default.createElement(
          "linearGradient",
          { x1: "8.042%", y1: "0%", x2: "65.682%", y2: "23.865%", id: "a" },
          _react2.default.createElement("stop", { stopColor: svg.color, stopOpacity: "0", offset: "0%" }),
          _react2.default.createElement("stop", { stopColor: svg.color, stopOpacity: ".631", offset: "63.146%" }),
          _react2.default.createElement("stop", { stopColor: svg.color, offset: "100%" })
        )
      ),
      _react2.default.createElement(
        "g",
        { fill: "none", fillRule: "evenodd" },
        _react2.default.createElement(
          "g",
          { transform: "translate(1 1)" },
          _react2.default.createElement(
            "path",
            { d: "M36 18c0-9.94-8.06-18-18-18", id: "Oval-2", stroke: svg.color, strokeWidth: "2" },
            _react2.default.createElement("animateTransform", {
              attributeName: "transform",
              type: "rotate",
              from: "0 18 18",
              to: "360 18 18",
              dur: "0.9s",
              repeatCount: "indefinite"
            })
          ),
          _react2.default.createElement(
            "circle",
            { fill: "#fff", cx: "36", cy: "18", r: "1" },
            _react2.default.createElement("animateTransform", {
              attributeName: "transform",
              type: "rotate",
              from: "0 18 18",
              to: "360 18 18",
              dur: "0.9s",
              repeatCount: "indefinite"
            })
          )
        )
      )
    );
  };
});

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.ThreeDots = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ThreeDots = undefined;

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var ThreeDots = exports.ThreeDots = function ThreeDots(svg) {
    return _react2.default.createElement(
      "svg",
      {
        width: svg.width,
        height: svg.height,
        viewBox: "0 0 120 30",
        xmlns: "http://www.w3.org/2000/svg",
        fill: svg.color
      },
      _react2.default.createElement(
        "circle",
        { cx: "15", cy: "15", r: "15" },
        _react2.default.createElement("animate", {
          attributeName: "r",
          from: "15",
          to: "15",
          begin: "0s",
          dur: "0.8s",
          values: "15;9;15",
          calcMode: "linear",
          repeatCount: "indefinite"
        }),
        _react2.default.createElement("animate", {
          attributeName: "fillOpacity",
          from: "1",
          to: "1",
          begin: "0s",
          dur: "0.8s",
          values: "1;.5;1",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      ),
      _react2.default.createElement(
        "circle",
        { cx: "60", cy: "15", r: "9", attributeName: "fillOpacity", from: "1", to: "0.3" },
        _react2.default.createElement("animate", {
          attributeName: "r",
          from: "9",
          to: "9",
          begin: "0s",
          dur: "0.8s",
          values: "9;15;9",
          calcMode: "linear",
          repeatCount: "indefinite"
        }),
        _react2.default.createElement("animate", {
          attributeName: "fillOpacity",
          from: "0.5",
          to: "0.5",
          begin: "0s",
          dur: "0.8s",
          values: ".5;1;.5",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      ),
      _react2.default.createElement(
        "circle",
        { cx: "105", cy: "15", r: "15" },
        _react2.default.createElement("animate", {
          attributeName: "r",
          from: "15",
          to: "15",
          begin: "0s",
          dur: "0.8s",
          values: "15;9;15",
          calcMode: "linear",
          repeatCount: "indefinite"
        }),
        _react2.default.createElement("animate", {
          attributeName: "fillOpacity",
          from: "1",
          to: "1",
          begin: "0s",
          dur: "0.8s",
          values: "1;.5;1",
          calcMode: "linear",
          repeatCount: "indefinite"
        })
      )
    );
  };
});

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Watch = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Watch = undefined;

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Watch = exports.Watch = function Watch(svg) {
    return _react2.default.createElement(
      "svg",
      {
        width: svg.width,
        height: svg.height,
        version: "1.1",
        id: "L2",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 100 100",
        enableBackground: "new 0 0 100 100",
        xmlSpace: "preserve"
      },
      _react2.default.createElement("circle", {
        fill: "none",
        stroke: svg.color,
        strokeWidth: "4",
        strokeMiterlimit: "10",
        cx: "50",
        cy: "50",
        r: "48"
      }),
      _react2.default.createElement(
        "line",
        {
          fill: "none",
          strokeLinecap: "round",
          stroke: svg.color,
          strokeWidth: "4",
          strokeMiterlimit: "10",
          x1: "50",
          y1: "50",
          x2: "85",
          y2: "50.5"
        },
        _react2.default.createElement("animateTransform", {
          attributeName: "transform",
          dur: "2s",
          type: "rotate",
          from: "0 50 50",
          to: "360 50 50",
          repeatCount: "indefinite"
        })
      ),
      _react2.default.createElement(
        "line",
        {
          fill: "none",
          strokeLinecap: "round",
          stroke: svg.color,
          strokeWidth: "4",
          strokeMiterlimit: "10",
          x1: "50",
          y1: "50",
          x2: "49.5",
          y2: "74"
        },
        _react2.default.createElement("animateTransform", {
          attributeName: "transform",
          dur: "15s",
          type: "rotate",
          from: "0 50 50",
          to: "360 50 50",
          repeatCount: "indefinite"
        })
      )
    );
  };
});

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.RevolvingDot = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.RevolvingDot = undefined;

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var RevolvingDot = exports.RevolvingDot = function RevolvingDot(svg) {
    return _react2.default.createElement(
      "svg",
      {
        version: "1.1",
        width: svg.width,
        height: svg.height,
        id: "L3",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 100 100",
        enableBackground: "new 0 0 0 0",
        xmlSpace: "preserve"
      },
      _react2.default.createElement("circle", {
        fill: "none",
        stroke: svg.color,
        strokeWidth: "4",
        cx: "50",
        cy: "50",
        r: "44",
        style: { opacity: 0.5 }
      }),
      _react2.default.createElement(
        "circle",
        { fill: svg.color, stroke: svg.color, strokeWidth: "3", cx: "8", cy: "54", r: "6" },
        _react2.default.createElement("animateTransform", {
          attributeName: "transform",
          dur: "2s",
          type: "rotate",
          from: "0 50 48",
          to: "360 50 52",
          repeatCount: "indefinite"
        })
      )
    );
  };
});

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(603)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("./css/CradleLoader.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.CradleLoader);
    global.CradleLoader = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CradleLoader = undefined;

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var CradleLoader = exports.CradleLoader = function CradleLoader() {
    return _react2.default.createElement(
      "div",
      { "aria-busy": "true", "aria-label": "Loading", role: "progressbar", className: "container" },
      _react2.default.createElement(
        "div",
        { className: "react-spinner-loader-swing" },
        _react2.default.createElement("div", { className: "react-spinner-loader-swing-l" }),
        _react2.default.createElement("div", null),
        _react2.default.createElement("div", null),
        _react2.default.createElement("div", null),
        _react2.default.createElement("div", null),
        _react2.default.createElement("div", null),
        _react2.default.createElement("div", { className: "react-spinner-loader-swing-r" })
      ),
      _react2.default.createElement(
        "div",
        { className: "react-spinner-loader-shadow" },
        _react2.default.createElement("div", { className: "react-spinner-loader-shadow-l" }),
        _react2.default.createElement("div", null),
        _react2.default.createElement("div", null),
        _react2.default.createElement("div", null),
        _react2.default.createElement("div", null),
        _react2.default.createElement("div", null),
        _react2.default.createElement("div", { className: "react-spinner-loader-shadow-r" })
      )
    );
  };
});

/***/ }),
/* 603 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(605)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("./css/Triangle.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.Triangle);
    global.Triangle = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Triangle = undefined;

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Triangle = exports.Triangle = function Triangle(svg) {
    return _react2.default.createElement(
      "div",
      { className: "react-spinner-loader-svg" },
      _react2.default.createElement(
        "svg",
        { id: "triangle", width: svg.height, height: svg.height, viewBox: "-3 -4 39 39" },
        _react2.default.createElement("polygon", { fill: "transparent", stroke: svg.color, strokeWidth: "1", points: "16,0 32,32 0,32" })
      )
    );
  };
});

/***/ }),
/* 605 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(4), __webpack_require__(607)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"), require("./css/Plane.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.Plane);
    global.Plane = mod.exports;
  }
})(this, function (exports, _react, _propTypes) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Plane = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Plane = exports.Plane = function Plane(props) {
    return _react2.default.createElement(
      "svg",
      { className: "react-spinner-loader-svg-calLoader", xmlns: "http://www.w3.org/2000/svg", width: "230", height: "230" },
      _react2.default.createElement("path", {
        className: "react-spinner-loader-cal-loader__path",
        style: { stroke: props.secondaryColor },
        d: "M86.429 40c63.616-20.04 101.511 25.08 107.265 61.93 6.487 41.54-18.593 76.99-50.6 87.643-59.46 19.791-101.262-23.577-107.142-62.616C29.398 83.441 59.945 48.343 86.43 40z",
        fill: "none",
        stroke: "#0099cc",
        strokeWidth: "4",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeDasharray: "10 10 10 10 10 10 10 432",
        strokeDashoffset: "77"
      }),
      _react2.default.createElement("path", {
        className: "cal-loader__plane",
        style: { fill: props.color },
        d: "M141.493 37.93c-1.087-.927-2.942-2.002-4.32-2.501-2.259-.824-3.252-.955-9.293-1.172-4.017-.146-5.197-.23-5.47-.37-.766-.407-1.526-1.448-7.114-9.773-4.8-7.145-5.344-7.914-6.327-8.976-1.214-1.306-1.396-1.378-3.79-1.473-1.036-.04-2-.043-2.153-.002-.353.1-.87.586-1 .952-.139.399-.076.71.431 2.22.241.72 1.029 3.386 1.742 5.918 1.644 5.844 2.378 8.343 2.863 9.705.206.601.33 1.1.275 1.125-.24.097-10.56 1.066-11.014 1.032a3.532 3.532 0 0 1-1.002-.276l-.487-.246-2.044-2.613c-2.234-2.87-2.228-2.864-3.35-3.309-.717-.287-2.82-.386-3.276-.163-.457.237-.727.644-.737 1.152-.018.39.167.805 1.916 4.373 1.06 2.166 1.964 4.083 1.998 4.27.04.179.004.521-.076.75-.093.228-1.109 2.064-2.269 4.088-1.921 3.34-2.11 3.711-2.123 4.107-.008.25.061.557.168.725.328.512.72.644 1.966.676 1.32.029 2.352-.236 3.05-.762.222-.171 1.275-1.313 2.412-2.611 1.918-2.185 2.048-2.32 2.45-2.505.241-.111.601-.232.82-.271.267-.058 2.213.201 5.912.8 3.036.48 5.525.894 5.518.914 0 .026-.121.306-.27.638-.54 1.198-1.515 3.842-3.35 9.021-1.029 2.913-2.107 5.897-2.4 6.62-.703 1.748-.725 1.833-.594 2.286.137.46.45.833.872 1.012.41.177 3.823.24 4.37.085.852-.25 1.44-.688 2.312-1.724 1.166-1.39 3.169-3.948 6.771-8.661 5.8-7.583 6.561-8.49 7.387-8.702.233-.065 2.828-.056 5.784.011 5.827.138 6.64.09 8.62-.5 2.24-.67 4.035-1.65 5.517-3.016 1.136-1.054 1.135-1.014.207-1.962-.357-.38-.767-.777-.902-.893z",
        fill: "#000033"
      })
    );
  };

  Plane.propTypes = {
    secondaryColor: _propTypes2.default.string,
    color: _propTypes2.default.string
  };

  Plane.defaultProps = {
    secondaryColor: "grey",
    color: "#FFA500"
  };
});

/***/ }),
/* 607 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.MutatingDot = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.MutatingDot = undefined;

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var MutatingDot = exports.MutatingDot = function MutatingDot(svg) {
    return _react2.default.createElement(
      "svg",
      { id: "goo-loader", width: svg.width, height: svg.height },
      _react2.default.createElement(
        "filter",
        { id: "fancy-goo" },
        _react2.default.createElement("feGaussianBlur", { "in": "SourceGraphic", stdDeviation: "6", result: "blur" }),
        _react2.default.createElement("feColorMatrix", {
          "in": "blur",
          mode: "matrix",
          values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9",
          result: "goo"
        }),
        _react2.default.createElement("feComposite", { "in": "SourceGraphic", in2: "goo", operator: "atop" })
      ),
      _react2.default.createElement(
        "g",
        { filter: "url(#fancy-goo)" },
        _react2.default.createElement("animateTransform", {
          id: "mainAnim",
          attributeName: "transform",
          attributeType: "XML",
          type: "rotate",
          from: "0 50 50",
          to: "359 50 50",
          dur: "1.2s",
          repeatCount: "indefinite"
        }),
        _react2.default.createElement(
          "circle",
          { cx: "50%", cy: "40", r: "11" },
          _react2.default.createElement("animate", {
            id: "cAnim1",
            attributeType: "XML",
            attributeName: "cy",
            dur: "0.6s",
            begin: "0;cAnim1.end+0.2s",
            calcMode: "spline",
            values: "40;20;40",
            keyTimes: "0;0.3;1",
            keySplines: "0.175, 0.885, 0.320, 1.5; 0.175, 0.885, 0.320, 1.5"
          })
        ),
        _react2.default.createElement(
          "circle",
          { cx: "50%", cy: "60", r: "11" },
          _react2.default.createElement("animate", {
            id: "cAnim2",
            attributeType: "XML",
            attributeName: "cy",
            dur: "0.6s",
            begin: "0.4s;cAnim2.end+0.2s",
            calcMode: "spline",
            values: "60;80;60",
            keyTimes: "0;0.3;1",
            keySplines: "0.175, 0.885, 0.320, 1.5;0.175, 0.885, 0.320, 1.5"
          })
        )
      )
    );
  };
});

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Puff = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Puff = undefined;

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Puff = exports.Puff = function Puff(svg) {
    return _react2.default.createElement(
      "svg",
      {
        width: svg.width,
        height: svg.height,
        viewBox: "0 0 44 44",
        xmlns: "http://www.w3.org/2000/svg",
        stroke: svg.color
      },
      _react2.default.createElement(
        "g",
        { fill: "none", fillRule: "evenodd", strokeWidth: "2" },
        _react2.default.createElement(
          "circle",
          { cx: "22", cy: "22", r: "1" },
          _react2.default.createElement("animate", {
            attributeName: "r",
            begin: "0s",
            dur: "1.8s",
            values: "1; 20",
            calcMode: "spline",
            keyTimes: "0; 1",
            keySplines: "0.165, 0.84, 0.44, 1",
            repeatCount: "indefinite"
          }),
          _react2.default.createElement("animate", {
            attributeName: "strokeOpacity",
            begin: "0s",
            dur: "1.8s",
            values: "1; 0",
            calcMode: "spline",
            keyTimes: "0; 1",
            keySplines: "0.3, 0.61, 0.355, 1",
            repeatCount: "indefinite"
          })
        ),
        _react2.default.createElement(
          "circle",
          { cx: "22", cy: "22", r: "1" },
          _react2.default.createElement("animate", {
            attributeName: "r",
            begin: "-0.9s",
            dur: "1.8s",
            values: "1; 20",
            calcMode: "spline",
            keyTimes: "0; 1",
            keySplines: "0.165, 0.84, 0.44, 1",
            repeatCount: "indefinite"
          }),
          _react2.default.createElement("animate", {
            attributeName: "strokeOpacity",
            begin: "-0.9s",
            dur: "1.8s",
            values: "1; 0",
            calcMode: "spline",
            keyTimes: "0; 1",
            keySplines: "0.3, 0.61, 0.355, 1",
            repeatCount: "indefinite"
          })
        )
      )
    );
  };
});

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_meta_US_json__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_meta_US_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_meta_US_json__);
var RbMeta=function(){//Setting defaultLocale to en_US
var defaultLocale="meta_US";//Setting userLocale to en_US unless otherwise changed by the user
var userLocale="meta_US";var getBundle=function getBundle(locale){switch(locale){case"meta_US":return __WEBPACK_IMPORTED_MODULE_0__config_meta_US_json___default.a;default:return __WEBPACK_IMPORTED_MODULE_0__config_meta_US_json___default.a;}};var replaceDynamicText=function replaceDynamicText(originalString,replaceStringArray){for(var i=0;i<replaceStringArray.length;i++){var val="{"+i+"}";originalString=originalString.split(val).join(replaceStringArray[i]);}return originalString;};return{getText:function getText(rawTxt){var replaceStringArray=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];try{var rb=getBundle(userLocale);if(rb[rawTxt]){return replaceStringArray.length>0?replaceDynamicText(rb[rawTxt],replaceStringArray):rb[rawTxt];}else if(getBundle(defaultLocale)[rawTxt]){return replaceStringArray.length>0?replaceDynamicText(getBundle(defaultLocale)[rawTxt],replaceStringArray):getBundle(defaultLocale)[rawTxt];}}catch(e){console.error(e);}return replaceStringArray.length>0?replaceDynamicText(rawTxt,replaceStringArray):rawTxt;},setLocale:function setLocale(locale){userLocale=locale;},getLocale:function getLocale(){return userLocale;}};}();/* harmony default export */ __webpack_exports__["a"] = (RbMeta);

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports = {"HOME_meta":"Learn from India's BEST online math expert that has impacted over a million students and used by 5000 teachers. HeyMath! provides animated videos, games, practice, diagnostic tests and personalised learning for Grade 1 to 10. Start your free trial today!","PRODUCTS_meta":"We provide fun and engaging courses covering Grade from 1 to 10. Developed in academic collaboration with University of Cambridge and Raffles Institution, Singapore and trusted by over 5000 teacher experts. Successfully Implemented since 2001 in CBSE, ICSE, IGCSE and MOE schools.","Class1_meta":"Self-Paced Maths videos for class 1 - Syllabus, Animated stories, Interactive activities, Vocabulary, Enrichment. Proven teaching approaches from Singapore’s world class education system. Start your free trial today!","Class2_meta":"Self-Paced Maths videos for class 2 - Syllabus, Animated stories, Interactive activities, Vocabulary, Enrichment. Proven teaching approaches from Singapore’s world class education system. Start your free trial today!","Class3_meta":"Self-Paced Math videos for class 3 - Syllabus, Animated stories, Interactive activities, Vocabulary, Enrichment. Proven teaching approaches from Singapore’s world class education system. Start your free trial today!","Class4_meta":"Self-Paced Maths videos for class 4 - Syllabus, Animated stories, Interactive activities, Vocabulary, Enrichment. Proven teaching approaches from Singapore’s world class education system. Start your free trial today!","Class5_meta":"HeyMath! helps you bridge your learning gaps through targeted practice. Personalised Learning for Class 5 - Syllabus, Topic-wise diagnostic tests, Personalised Study Plan & Granular report card. Start your free trial today!","Class6_meta":"HeyMath! helps you bridge your learning gaps through targeted practice. Personalised Learning for Class 6 - Syllabus, Topic-wise diagnostic tests, Personalised Study Plan & Granular report card. Start your free trial today!","Class7_meta":"HeyMath! helps you bridge your learning gaps through targeted practice. Personalised Learning for Class 7 - Syllabus, Topic-wise diagnostic tests, Personalised Study Plan & Granular report card. Start your free trial today!","Class8_meta":"HeyMath! helps you bridge your learning gaps through targeted practice. Personalised Learning for Class 8 - Syllabus, Topic-wise diagnostic tests, Personalised Study Plan & Granular report card. Start your free trial today!","Class9_meta":"HeyMath! helps you bridge your learning gaps through targeted practice. Personalised Learning for Class 9 - Syllabus, Topic-wise diagnostic tests, Personalised Study Plan & Granular report card. Start your free trial today!","Class10_meta":"HeyMath! helps you bridge your learning gaps through targeted practice. Personalised Learning for Class 10 - Syllabus, Topic-wise diagnostic tests, Personalised Study Plan & Granular report card. Start your free trial today!","WHO_WE_ARE_meta":"We are a bunch of folks who are zealously driven to make the learning of Math creative and enjoyable for students. Nothing excites us more than a student saying ‘Aah, I get it now’!","SPOTLIGHT_meta":"HeyMath, Ed-Tech company - Know our awards, expansion and latest news in the media | Wherever you are in your learning, HeyMath! will take you further","FAQ_meta":"Find answers to your questions on products, registration, login, pricing and using HeyMath!"}

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_title_US_json__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_title_US_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_title_US_json__);
var RbTitle=function(){//Setting defaultLocale to en_US
var defaultLocale="title_US";//Setting userLocale to en_US unless otherwise changed by the user
var userLocale="title_US";var getBundle=function getBundle(locale){switch(locale){case"title_US":return __WEBPACK_IMPORTED_MODULE_0__config_title_US_json___default.a;default:return __WEBPACK_IMPORTED_MODULE_0__config_title_US_json___default.a;}};var replaceDynamicText=function replaceDynamicText(originalString,replaceStringArray){for(var i=0;i<replaceStringArray.length;i++){var val="{"+i+"}";originalString=originalString.split(val).join(replaceStringArray[i]);}return originalString;};return{getText:function getText(rawTxt){var replaceStringArray=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];try{var rb=getBundle(userLocale);if(rb[rawTxt]){return replaceStringArray.length>0?replaceDynamicText(rb[rawTxt],replaceStringArray):rb[rawTxt];}else if(getBundle(defaultLocale)[rawTxt]){return replaceStringArray.length>0?replaceDynamicText(getBundle(defaultLocale)[rawTxt],replaceStringArray):getBundle(defaultLocale)[rawTxt];}}catch(e){console.error(e);}return replaceStringArray.length>0?replaceDynamicText(rawTxt,replaceStringArray):rawTxt;},setLocale:function setLocale(locale){userLocale=locale;},getLocale:function getLocale(){return userLocale;}};}();/* harmony default export */ __webpack_exports__["a"] = (RbTitle);

/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports = {"HOME_title":"Home - Online Math Videos & Practice for Classes 1 to 10 | HeyMath!","PRODUCTS_title":"Products - Videos & Personalised Learning | HeyMath!","Class1_title":"Class 1 Online Maths - Stories, vocabulary & games | HeyMath!","Class2_title":"Class 2 Online Maths - Stories, vocabulary & games | HeyMath!","Class3_title":"Class 3 Online Maths - Stories, vocabulary & games | HeyMath!","Class4_title":"Class 4 Online Maths - Stories, vocabulary & games | HeyMath!","Class5_title":"Class 5 Online Maths - Videos & Targeted Practice | HeyMath!","Class6_title":"Class 6 Online Maths - Videos & Targeted Practice | HeyMath!","Class7_title":"Class 7 Online Maths - Videos & Targeted Practice | HeyMath!","Class8_title":"Class 8 Online Maths - Videos & Targeted Practice | HeyMath!","Class9_title":"Class 9 Online Maths - Videos & Targeted Practice | HeyMath!","Class10_title":"Class 10 Online Maths - Videos & Targeted Practice | HeyMath!","WHO_WE_ARE_title":"Who we are | HeyMath!","SPOTLIGHT_title":"Spotlight - Awards, Media Coverage and Expansion | HeyMath!","FAQ_title":"Frequently Asked Questions | HeyMath!","LEARNINGS_title":"Our Learnings | HeyMath!"}

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_heading_US_json__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_heading_US_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_heading_US_json__);
var RbHeading=function(){//Setting defaultLocale to en_US
var defaultLocale="heading_US";//Setting userLocale to en_US unless otherwise changed by the user
var userLocale="heading_US";var getBundle=function getBundle(locale){switch(locale){case"heading_US":return __WEBPACK_IMPORTED_MODULE_0__config_heading_US_json___default.a;default:return __WEBPACK_IMPORTED_MODULE_0__config_heading_US_json___default.a;}};var replaceDynamicText=function replaceDynamicText(originalString,replaceStringArray){for(var i=0;i<replaceStringArray.length;i++){var val="{"+i+"}";originalString=originalString.split(val).join(replaceStringArray[i]);}return originalString;};return{getText:function getText(rawTxt){var replaceStringArray=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];try{var rb=getBundle(userLocale);if(rb[rawTxt]){return replaceStringArray.length>0?replaceDynamicText(rb[rawTxt],replaceStringArray):rb[rawTxt];}else if(getBundle(defaultLocale)[rawTxt]){return replaceStringArray.length>0?replaceDynamicText(getBundle(defaultLocale)[rawTxt],replaceStringArray):getBundle(defaultLocale)[rawTxt];}}catch(e){console.error(e);}return replaceStringArray.length>0?replaceDynamicText(rawTxt,replaceStringArray):rawTxt;},setLocale:function setLocale(locale){userLocale=locale;},getLocale:function getLocale(){return userLocale;}};}();/* harmony default export */ __webpack_exports__["a"] = (RbHeading);

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports = {"HOME_heading":"Wherever you are in your learning, HeyMath! will take you further","PRODUCTS_heading":"Classes","Class1_heading":"Self-Paced Lessons for Class 1","Class2_heading":"Self-Paced Lessons for Class 2","Class3_heading":"Self-Paced Lessons for Class 3","Class4_heading":"Self-Paced Lessons for Class 4","Class5_heading":"Personalised Learning for Class 5","Class6_heading":"Personalised Learning for Class 6","Class7_heading":"Personalised Learning for Class 7","Class8_heading":"Personalised Learning for Class 8","Class9_heading":"Personalised Learning for Class 9","Class10_heading":"Personalised Learning for Class 10","WHO_WE_ARE_heading":"We are a bunch of folks who are zealously driven to make the learning of Math creative and enjoyable for students","SPOTLIGHT_heading":"Spotlight","FAQ_heading":"Product, Registration and Login, Pricing"}

/***/ }),
/* 616 */
/***/ (function(module, exports) {

//call getEventObject with an eventCode to get the corresponding object
var eventCodes=Object.freeze({"login":10001,"logout":10002,"signup":10003,"forgot_password":10004,"contact_support":10005,"product_selected":11001,"topic_shared":11002,"item_rated":11003,"lesson_opened":12001,"lesson_closed":12002,"lesson_element_started":12003,"lesson_element_ended":12004,"lesson_element_paused":12005,"lesson_element_pulsed":12006,"test_started":13001,"test_closed":13002,"question_loaded":13003,"question_evaluated":13004,"solution_rated":13005,"question_marked":13006,"answer_captured":14001,"question_pulsed":14002,"item_viewed":15001,"item_selected":15002,"page_loaded":15003,"purchase_viewed":16001,"purchase_initiated":16002,"purchase_processed":16003,"profile_change_evaluated":17001,"error_encountered":18001});var enumSignupEventSource=Object.freeze({"set_password":0,"send_otp":1,"verify_otp":2});var enumSelectedProductSource=Object.freeze({"home":0,"dashboard":1});var enumLessonSource=Object.freeze({"subtopic":0,"recommended_lessons":1,"related_lessons":2,"solution_question":3});var enumLessonElementType=Object.freeze({"video":0,"act":1,"interactivity":2});var enumItemRatedSource=Object.freeze({"test":0,"scorecard":1,"home":2});var enumViewedItemType=Object.freeze({"similar_problem":0,"recommended_lessons":1,"solution":2});var enumSelectedItemType=Object.freeze({"topic":0,"subtopic":1});var enumSelectedItemSource=Object.freeze({"home":0,"dashboard":1});var enumLoadedPageType=Object.freeze({"marked_questions":0,"solutions":1,"recommendations":2,"scorecard":3});var enumEncounteredErrorSource=Object.freeze({"um":0,"plp":1});var objectEventDetails=Object.seal({"user_id":"","session_id":"","event_code":-1,"timestamp":-1});var eventLogin=Object.seal({"user_id":"","login_id":"","user_agent":"","platform":"","device":"","ip_address":"","result":null,"session_id":""});var eventSignup=Object.seal({"name":"","email":"","phone":"","event_source":-1,"result":null});var eventForgotPassword=Object.seal({"login_id":"","email":"","event_source":-1,"result":null});var eventProductSelected=Object.seal({"grade_id":-1,"product_type":-1,"source":-1});var eventTopicShared=Object.seal({"topic_id":-1});var eventItemRated=Object.seal({"subtopic_id":-1,"rating":-1,"grade_id":-1,"product_type":-1,"source":-1});var eventLessonOpened=Object.seal({"lesson_id":-1,"lesson_dd":-1,"source":-1,"source_id":-1,"snippet_id":-1,"question_source":-1});var eventLessonClosed=Object.seal({"lesson_id":-1});var eventLessonElementStarted=Object.seal({"lesson_id":-1,"lesson_dd":-1,"type":-1,"interactivity_id":-1,"resumed":null,"dd_url":""});var eventLessonElementEnded=Object.seal({"lesson_id":-1,"lesson_dd":-1,"type":-1,"interactivity_id":-1});var eventLessonElementPaused=Object.seal({"lesson_id":-1,"lesson_dd":-1,"type":-1,"interactivity_id":-1});var eventLessonElementPulsed=Object.seal({"lesson_id":-1,"lesson_dd":-1,"type":-1,"interactivity_id":-1});var eventTestStarted=Object.seal({"subtopic_id":-1,"test_id":-1,"source_test_id":-1,"resumed":null});var eventTestClosed=Object.seal({"test_id":-1,"submitted":null});var eventQuestionLoaded=Object.seal({"test_id":-1,"snippet_id":-1,"question_source":-1,"attempt_no":-1,"load_duration":-1});var eventQuestionEvaluated=Object.seal({"test_id":-1,"snippet_id":-1,"question_source":-1,"attempt_no":-1,"answered":null,"result":null});var eventSolutionRated=Object.seal({"test_id":-1,"snippet_id":-1,"question_source":-1,"attempt_no":-1,"source":-1,"helpful":null});var eventQuestionMarked=Object.seal({"test_id":-1,"snippet_id":-1,"question_source":-1,"marked":null});var eventAnswerCaptured=Object.seal({"test_id":-1,"snippet_id":-1,"question_source":-1,"attempt_no":-1,"answer":""});var eventQuestionPulsed=Object.seal({"test_id":-1,"snippet_id":-1,"question_source":-1,"attempt_no":-1});var eventItemViewed=Object.seal({"test_id":-1,"snippet_id":-1,"question_source":-1,"item_type":-1,"hidden":null});var eventItemSelected=Object.seal({"item_id":-1,"item_type":-1,"source":-1});var eventPageLoaded=Object.seal({"source_id":-1,"load_duration":-1,"page_type":-1});var eventPurchaseViewed=Object.seal({"grade_id":-1,"product_type":"","tariff_id":-1});var eventPurchaseInitiated=Object.seal({"grade_id":-1,"product_type":"","tariff_id":-1,"email":""});var eventPurchaseProcessed=Object.seal({"grade_id":-1,"product_type":"","tariff_id":-1,"result":null,"details":""});var eventProfileChangeEvaluated=Object.seal({"name":"","password_changed":null,"result":null});var eventErrorEncountered=Object.seal({"error_id":"","status_code":-1,"source":-1});var events=Object.freeze({"10001":eventLogin,"10002":null,"10003":eventSignup,"10004":eventForgotPassword,"10005":null,"11001":eventProductSelected,"11002":eventTopicShared,"11003":eventItemRated,"12001":eventLessonOpened,"12002":eventLessonClosed,"12003":eventLessonElementStarted,"12004":eventLessonElementEnded,"12005":eventLessonElementPaused,"12006":eventLessonElementPulsed,"13001":eventTestStarted,"13002":eventTestClosed,"13003":eventQuestionLoaded,"13004":eventQuestionEvaluated,"13005":eventSolutionRated,"13006":eventQuestionMarked,"14001":eventAnswerCaptured,"14002":eventQuestionPulsed,"15001":eventItemViewed,"15002":eventItemSelected,"15003":eventPageLoaded,"16001":eventPurchaseViewed,"16002":eventPurchaseInitiated,"16003":eventPurchaseProcessed,"17001":eventProfileChangeEvaluated,"18001":eventErrorEncountered});var getEventObject=function getEventObject(eventCode){var objectEvent={};var eventData=events[eventCode.toString()];objectEvent["event_details"]=Object.assign(objectEventDetails);objectEvent["event_data"]=eventData?Object.assign(eventData):eventData;objectEvent.event_details.event_code=eventCode;return Object.freeze(objectEvent);};var allEventObj={"eventCodes":eventCodes,"getEventObject":getEventObject,"enums":{"signupEventSource":enumSignupEventSource,"selectedProductSource":enumSelectedProductSource,"itemRatedSource":enumItemRatedSource,"selectedItemType":enumSelectedItemType,"selectedItemSource":enumSelectedItemSource,"lessonSource":enumLessonSource,"loadedPageType":enumLoadedPageType,"viewedItemType":enumViewedItemType,"encounteredErrorSource":enumEncounteredErrorSource,"lessonElementType":enumLessonElementType}};//export default allEventObj;//<--Uncomment for actual usage
module.exports=allEventObj;//<--Comment for actual usage

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TimeUtil=function TimeUtil(){var epoch=0;var serverTime=0;var date=null;var fallBackScenario=function fallBackScenario(){date=new Date();epoch=date.getTime();serverTime=Math.round(epoch/1000);};this.setDate=function(inDate){try{if(inDate){date=inDate;epoch=date.getTime();serverTime=Math.round(epoch/1000);}}catch(e){}return this;};this.setEpoch=function(inEpoch){try{if(typeof inEpoch==="string"&&!isNaN(inEpoch)){epoch=inEpoch.length<=10?Number(inEpoch)*1000:Number(inEpoch);}else if(typeof inEpoch==="number"){epoch=inEpoch.toString().length<=10?inEpoch*1000:inEpoch;}serverTime=Math.round(epoch/1000);date=new Date(epoch);}catch(e){}return this;};this.setServerTime=function(inServerTime){try{if(typeof inServerTime==="string"&&!isNaN(inServerTime)){serverTime=inServerTime.length>10?Math.round(Number.parseInt(inServerTime)/1000):Number.parseInt(inServerTime);}else if(typeof inEpoch==="number"){serverTime=inServerTime.toString().length>10?Math.round(inServerTime/1000):inServerTime;}epoch=serverTime*1000;date=new Date(epoch);}catch(e){}return this;};this.getDate=function(){if(!date){fallBackScenario();}return date;};this.getEpoch=function(){if(epoch<=0){fallBackScenario();}return epoch;};this.getServerTime=function(){if(serverTime<=0){fallBackScenario();}return serverTime;};};/* harmony default export */ __webpack_exports__["a"] = (TimeUtil);

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BrowserStorageUtil__ = __webpack_require__(11);
/**
* This function is responsible for tracking where the user came from.
*/var AdsTracker=function(){var TRACKER_PREFIX="TRACKER_";var trackers=window.webAdsTrackers;return{getName:function getName(url){if(url&&trackers){for(var i in trackers){if(url.match(i)){return trackers[i];}}}return null;},callByUrl:function callByUrl(url){try{var args=null;if(arguments&&arguments.length>1){args=[];for(var i=1;i<arguments.length;i++){args.push(arguments[i]);}}var name=this.getName(url);if(name===null){/*if name is null, get the tracker name from session*/name=__WEBPACK_IMPORTED_MODULE_1__BrowserStorageUtil__["a" /* default */].getStoredSessionItem("TRACKER_NAME");console.log("important 2: getting the name : ",name);}else{/*set the tracker name to session*/__WEBPACK_IMPORTED_MODULE_1__BrowserStorageUtil__["a" /* default */].storeSessionItem("TRACKER_NAME",name);console.log("important 1: setting the name : ",name);}if(name){var trackName=TRACKER_PREFIX+name.toUpperCase();if(__WEBPACK_IMPORTED_MODULE_0__model_HmEventRegistry__["a" /* default */].exists(trackName)){__WEBPACK_IMPORTED_MODULE_0__model_HmEventRegistry__["a" /* default */].fireEvent(trackName,args);}else{/*Warn that the tracker is not available or not registered.*/console.warn(trackName+" is either not available or registered.");}}}catch(e){console.error(e);}},callByReferer:function callByReferer(trackObj){try{var refUrl=document.referrer;//if(refUrl && refUrl.length > 0){
this.callByUrl(refUrl,trackObj);//}
}catch(e){console.error("Error occurred while tracking",e);}}};}();/* harmony default export */ __webpack_exports__["a"] = (AdsTracker);

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NoComponent=function(_React$Component){_inherits(NoComponent,_React$Component);function NoComponent(){_classCallCheck(this,NoComponent);return _possibleConstructorReturn(this,(NoComponent.__proto__||Object.getPrototypeOf(NoComponent)).apply(this,arguments));}_createClass(NoComponent,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-center loadingAnim"},"\xA0");}}]);return NoComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (NoComponent);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var FileAppender=function FileAppender(url){var _this=this;var asyncEnabled=false;var fileVersion=1;var forceUpdate=false;var appendFunc=function appendFunc(type,callBack){var file=null;if(forceUpdate===true){if(typeof url==="string"&&url.indexOf("?")>0){url+="&ver="+fileVersion;}else if(typeof url==="string"){url+="?ver="+fileVersion;}}if(type==="css"){file=document.createElement('link');file.type='text/css';file.href=url;file.rel='stylesheet';}else if(type==="js"){file=document.createElement('script');file.type='text/javascript';file.src=url;}if(file!==null){file.onload=function(req,resp){//console.warn("lalalal : ", req, resp);
if(typeof callBack==="function"){callBack.apply(_this,[resp]);}};file.onerror=function(req,resp){alert("error");};document.getElementsByTagName('head')[0].appendChild(file);}};this.css=function(callBack){appendFunc("css",callBack);};this.js=function(callBack){appendFunc("js",callBack);};this.async=function(){asyncEnabled=true;return this;};this.addVersion=function(version){forceUpdate=true;if(!isNaN(version)){fileVersion=version;}else if(!isNaN(window.fileVersion)){fileVersion=window.fileVersion;}return this;};};/* harmony default export */ __webpack_exports__["a"] = (FileAppender);

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bg-404.0eb9e5a6.png";

/***/ }),
/* 622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(10);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _swiper = __webpack_require__(624);

var _swiper2 = _interopRequireDefault(_swiper);

var _objectAssign = __webpack_require__(36);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _propTypes = __webpack_require__(625);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(628);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactIdSwiper = function (_Component) {
  _inherits(ReactIdSwiper, _Component);

  // Default props
  function ReactIdSwiper(props) {
    _classCallCheck(this, ReactIdSwiper);

    var _this = _possibleConstructorReturn(this, (ReactIdSwiper.__proto__ || Object.getPrototypeOf(ReactIdSwiper)).call(this, props));

    _this.renderContent = _this.renderContent.bind(_this);
    return _this;
  }

  // Proptypes


  _createClass(ReactIdSwiper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.swiper = new _swiper2.default(_reactDom2.default.findDOMNode(this), (0, _objectAssign2.default)({}, this.props));
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (typeof this.swiper === 'undefined') return;
      var _props = this.props,
          rebuildOnUpdate = _props.rebuildOnUpdate,
          shouldSwiperUpdate = _props.shouldSwiperUpdate,
          activeSlideKey = _props.activeSlideKey;


      if (rebuildOnUpdate) {
        this.rebuildSwiper();
      } else if (shouldSwiperUpdate) {
        this.swiper.update();

        var numSlides = this.swiper.slides.length;
        if (numSlides <= this.swiper.activeIndex) {
          var index = Math.max(numSlides - 1, 0);
          this.swiper.slideTo(index);
        }
      }

      if (activeSlideKey) {
        var activeSlideId = null;
        var id = 0;

        _react2.default.Children.forEach(this.props.children, function (child) {
          if (child) {
            if (child.key === activeSlideKey) {
              activeSlideId = id;
            }
            id += 1;
          }
        });

        if (activeSlideId !== null) {
          this.swiper.slideTo(activeSlideId);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (typeof this.swiper !== 'undefined') this.swiper.destroy(true, true);
      delete this.swiper;
    }
  }, {
    key: 'rebuildSwiper',
    value: function rebuildSwiper() {
      this.swiper.destroy(true, true);
      this.swiper = new _swiper2.default(_reactDom2.default.findDOMNode(this), (0, _objectAssign2.default)({}, this.props));
    }
  }, {
    key: 'renderContent',
    value: function renderContent(e) {
      if (!e) return false;

      var _props2 = this.props,
          slideClass = _props2.slideClass,
          noSwiping = _props2.noSwiping;

      var slideClassNames = [slideClass, e.props.className];
      if (noSwiping) slideClassNames.push('swiper-no-swiping');

      return _react2.default.cloneElement(e, _extends({}, e.props, {
        className: slideClassNames.join(' ').trim()
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          ContainerEl = _props3.ContainerEl,
          WrapperEl = _props3.WrapperEl,
          containerClass = _props3.containerClass,
          wrapperClass = _props3.wrapperClass,
          children = _props3.children,
          rtl = _props3.rtl,
          scrollbar = _props3.scrollbar,
          renderScrollbar = _props3.renderScrollbar,
          pagination = _props3.pagination,
          renderPagination = _props3.renderPagination,
          navigation = _props3.navigation,
          renderPrevButton = _props3.renderPrevButton,
          renderNextButton = _props3.renderNextButton,
          parallax = _props3.parallax,
          parallaxEl = _props3.parallaxEl,
          renderParallax = _props3.renderParallax;


      return _react2.default.createElement(
        ContainerEl,
        { className: containerClass, dir: rtl && 'rtl' },
        parallax && parallaxEl && renderParallax(this.props),
        _react2.default.createElement(
          WrapperEl,
          { className: wrapperClass },
          _react2.default.Children.map(children, this.renderContent)
        ),
        pagination && pagination.el && renderPagination(this.props),
        scrollbar && scrollbar.el && renderScrollbar(this.props),
        navigation && navigation.nextEl && renderNextButton(this.props),
        navigation && navigation.prevEl && renderPrevButton(this.props)
      );
    }
  }]);

  return ReactIdSwiper;
}(_react.Component);

ReactIdSwiper.defaultProps = {
  containerClass: 'swiper-container',
  wrapperClass: 'swiper-wrapper',
  slideClass: 'swiper-slide',
  ContainerEl: 'div',
  WrapperEl: 'div',
  renderScrollbar: function renderScrollbar(_ref) {
    var scrollbar = _ref.scrollbar;
    return _react2.default.createElement('div', { className: (0, _utils.cn)(scrollbar.el) });
  },
  renderPagination: function renderPagination(_ref2) {
    var pagination = _ref2.pagination;
    return _react2.default.createElement('div', { className: (0, _utils.cn)(pagination.el) });
  },
  renderPrevButton: function renderPrevButton(_ref3) {
    var navigation = _ref3.navigation;
    return _react2.default.createElement('div', { className: (0, _utils.cn)(navigation.prevEl) });
  },
  renderNextButton: function renderNextButton(_ref4) {
    var navigation = _ref4.navigation;
    return _react2.default.createElement('div', { className: (0, _utils.cn)(navigation.nextEl) });
  },
  renderParallax: function renderParallax(_ref5) {
    var parallaxEl = _ref5.parallaxEl;
    return _react2.default.createElement('div', { className: (0, _utils.cn)(parallaxEl.el), 'data-swiper-parallax': parallaxEl.value });
  }
};
ReactIdSwiper.propTypes = {
  // react-id-swiper original parameters
  ContainerEl: _propTypes2.default.string,
  WrapperEl: _propTypes2.default.string,
  containerClass: _propTypes2.default.string,
  wrapperClass: _propTypes2.default.string,
  children: _propTypes2.default.any,
  rebuildOnUpdate: _propTypes2.default.bool,
  shouldSwiperUpdate: _propTypes2.default.bool,
  activeSlideKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  renderScrollbar: _propTypes2.default.func,
  renderPagination: _propTypes2.default.func,
  renderPrevButton: _propTypes2.default.func,
  renderNextButton: _propTypes2.default.func,
  renderParallax: _propTypes2.default.func,

  // parallax
  parallax: _propTypes2.default.bool,
  parallaxEl: _propTypes2.default.shape({
    el: _propTypes2.default.string,
    value: _propTypes2.default.string
  }),

  // swiper parameter
  init: _propTypes2.default.bool,
  initialSlide: _propTypes2.default.number,
  direction: _propTypes2.default.string,
  rtl: _propTypes2.default.bool,
  speed: _propTypes2.default.number,
  setWrapperSize: _propTypes2.default.bool,
  virtualTranslate: _propTypes2.default.bool,
  width: _propTypes2.default.number,
  height: _propTypes2.default.number,
  autoHeight: _propTypes2.default.bool,
  roundLengths: _propTypes2.default.bool,
  nested: _propTypes2.default.bool,
  uniqueNavElements: _propTypes2.default.bool,
  effect: _propTypes2.default.string,
  runCallbacksOnInit: _propTypes2.default.bool,

  // slides grid
  spaceBetween: _propTypes2.default.number,
  slidesPerView: _propTypes2.default.any,
  slidesPerColumn: _propTypes2.default.number,
  slidesPerColumnFill: _propTypes2.default.string,
  slidesPerGroup: _propTypes2.default.number,
  centeredSlides: _propTypes2.default.bool,
  slidesOffsetBefore: _propTypes2.default.number,
  slidesOffsetAfter: _propTypes2.default.number,
  normalizeSlideIndex: _propTypes2.default.bool,

  // grab cursor
  grabCursor: _propTypes2.default.bool,

  // touches
  touchEventsTarget: _propTypes2.default.string,
  touchRatio: _propTypes2.default.number,
  touchAngle: _propTypes2.default.number,
  simulateTouch: _propTypes2.default.bool,
  shortSwipes: _propTypes2.default.bool,
  longSwipes: _propTypes2.default.bool,
  longSwipesRatio: _propTypes2.default.number,
  longSwipesMs: _propTypes2.default.number,
  followFinger: _propTypes2.default.bool,
  allowTouchMove: _propTypes2.default.bool,
  threshold: _propTypes2.default.number,
  touchMoveStopPropagation: _propTypes2.default.bool,
  iOSEdgeSwipeDetection: _propTypes2.default.bool,
  iOSEdgeSwipeThreshold: _propTypes2.default.number,
  touchReleaseOnEdges: _propTypes2.default.bool,
  passiveListeners: _propTypes2.default.bool,

  // touch resistance
  resistance: _propTypes2.default.bool,
  resistanceRatio: _propTypes2.default.number,

  // swiping / no swiping
  allowSlidePrev: _propTypes2.default.bool,
  allowSlideNext: _propTypes2.default.bool,
  noSwiping: _propTypes2.default.bool,
  noSwipingClass: _propTypes2.default.string,
  swipeHandler: _propTypes2.default.any,

  // clicks
  preventClicks: _propTypes2.default.bool,
  preventClicksPropagation: _propTypes2.default.bool,
  slideToClickedSlide: _propTypes2.default.bool,

  // freemode
  freeMode: _propTypes2.default.bool,
  freeModeMomentum: _propTypes2.default.bool,
  freeModeMomentumRatio: _propTypes2.default.number,
  freeModeMomentumVelocityRatio: _propTypes2.default.number,
  freeModeMomentumBounce: _propTypes2.default.bool,
  freeModeMomentumBounceRatio: _propTypes2.default.number,
  freeModeMinimumVelocity: _propTypes2.default.number,
  freeModeSticky: _propTypes2.default.bool,

  // progress
  watchSlidesProgress: _propTypes2.default.bool,
  watchSlidesVisibility: _propTypes2.default.bool,

  // images
  preloadImages: _propTypes2.default.bool,
  updateOnImagesReady: _propTypes2.default.bool,

  // loop
  loop: _propTypes2.default.bool,
  loopAdditionalSlides: _propTypes2.default.number,
  loopedSlides: _propTypes2.default.number,
  loopFillGroupWithBlank: _propTypes2.default.bool,

  // breakpoints
  breakpoints: _propTypes2.default.object,

  // observer
  observer: _propTypes2.default.bool,
  observeParents: _propTypes2.default.bool,

  // namespace
  containerModifierClass: _propTypes2.default.string,
  slideClass: _propTypes2.default.string,
  slideActiveClass: _propTypes2.default.string,
  slideDuplicatedActiveClass: _propTypes2.default.string,
  slideVisibleClass: _propTypes2.default.string,
  slideDuplicateClass: _propTypes2.default.string,
  slideNextClass: _propTypes2.default.string,
  slideDuplicatedNextClass: _propTypes2.default.string,
  slidePrevClass: _propTypes2.default.string,
  slideDuplicatedPrevClass: _propTypes2.default.string,

  // autoplay
  autoplay: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    delay: _propTypes2.default.number,
    stopOnLast: _propTypes2.default.bool,
    disableOnInteraction: _propTypes2.default.bool
  })]),

  // pagination
  pagination: _propTypes2.default.shape({
    el: _propTypes2.default.string,
    type: _propTypes2.default.string,
    bulletElement: _propTypes2.default.string,
    dynamicBullets: _propTypes2.default.bool,
    hideOnClick: _propTypes2.default.bool,
    clickable: _propTypes2.default.bool,
    renderBullet: _propTypes2.default.func,
    renderFraction: _propTypes2.default.func,
    renderProgressbar: _propTypes2.default.func,
    renderCustom: _propTypes2.default.func,
    bulletClass: _propTypes2.default.string,
    bulletActiveClass: _propTypes2.default.string,
    modifierClass: _propTypes2.default.string,
    currentClass: _propTypes2.default.string,
    totalClass: _propTypes2.default.string,
    hiddenClass: _propTypes2.default.string,
    progressbarFillClass: _propTypes2.default.string,
    clickableClass: _propTypes2.default.string
  }),

  // scrollbar
  scrollbar: _propTypes2.default.shape({
    el: _propTypes2.default.any,
    hide: _propTypes2.default.bool,
    draggable: _propTypes2.default.bool,
    snapOnRelease: _propTypes2.default.bool,
    dragSize: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
  }),

  // navigation
  navigation: _propTypes2.default.shape({
    nextEl: _propTypes2.default.string,
    prevEl: _propTypes2.default.string,
    hideOnClick: _propTypes2.default.bool,
    disabledClass: _propTypes2.default.string,
    hiddenClass: _propTypes2.default.string
  }),

  // a11y
  a11y: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    prevSlideMessage: _propTypes2.default.string,
    nextSlideMessage: _propTypes2.default.string,
    firstSlideMessage: _propTypes2.default.string,
    lastSlideMessage: _propTypes2.default.string,
    paginationBulletMessage: _propTypes2.default.string,
    notificationClass: _propTypes2.default.string
  })]),

  // zoom
  zoom: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    maxRatio: _propTypes2.default.number,
    minRatio: _propTypes2.default.number,
    toggle: _propTypes2.default.bool,
    containerClass: _propTypes2.default.string,
    zoomedSlideClass: _propTypes2.default.string
  })]),

  // keyboard
  keyboard: _propTypes2.default.bool,

  // mousewheel
  mousewheel: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    forceToAxis: _propTypes2.default.bool,
    releaseOnEdges: _propTypes2.default.bool,
    invert: _propTypes2.default.bool,
    sensitivity: _propTypes2.default.number,
    eventsTarged: _propTypes2.default.string
  })]),

  // hashNavigation
  hashNavigation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    watchState: _propTypes2.default.bool,
    replaceState: _propTypes2.default.bool
  })]),

  // history
  history: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    key: _propTypes2.default.string,
    replaceState: _propTypes2.default.bool
  })]),

  // lazy
  lazy: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    loadPrevNext: _propTypes2.default.bool,
    loadPrevNextAmount: _propTypes2.default.number,
    loadOnTransitionStart: _propTypes2.default.bool,
    elementClass: _propTypes2.default.string,
    loadingClass: _propTypes2.default.string,
    loadedClass: _propTypes2.default.string,
    preloaderClass: _propTypes2.default.string
  })]),

  // fadeEffect
  fadeEffect: _propTypes2.default.shape({
    crossFade: _propTypes2.default.bool
  }),

  // coverflowEffect
  coverflowEffect: _propTypes2.default.shape({
    slideShadows: _propTypes2.default.bool,
    rotate: _propTypes2.default.number,
    stretch: _propTypes2.default.number,
    depth: _propTypes2.default.number,
    modifier: _propTypes2.default.number
  }),

  // flipEffect
  flipEffect: _propTypes2.default.shape({
    slideShadows: _propTypes2.default.bool,
    limitRotation: _propTypes2.default.bool
  }),

  // cubeEffect
  cubeEffect: _propTypes2.default.shape({
    slideShadows: _propTypes2.default.bool,
    shadow: _propTypes2.default.bool,
    shadowOffset: _propTypes2.default.number,
    shadowScale: _propTypes2.default.number
  }),

  // controller
  controller: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    control: _propTypes2.default.any,
    inverse: _propTypes2.default.bool,
    by: _propTypes2.default.string
  })]),

  // events
  on: _propTypes2.default.shape({
    init: _propTypes2.default.func,
    beforeDestroy: _propTypes2.default.func,
    slideChange: _propTypes2.default.func,
    slideChangeTransitionStart: _propTypes2.default.func,
    slideChangeTransitionEnd: _propTypes2.default.func,
    slideNextTransitionStart: _propTypes2.default.func,
    slideNextTransitionEnd: _propTypes2.default.func,
    slidePrevTransitionStart: _propTypes2.default.func,
    slidePrevTransitionEnd: _propTypes2.default.func,
    transitionStart: _propTypes2.default.func,
    onTransitionEnd: _propTypes2.default.func,
    touchStart: _propTypes2.default.func,
    touchMove: _propTypes2.default.func,
    touchMoveOpposite: _propTypes2.default.func,
    sliderMove: _propTypes2.default.func,
    touchEnd: _propTypes2.default.func,
    click: _propTypes2.default.func,
    tap: _propTypes2.default.func,
    doubleTap: _propTypes2.default.func,
    imagesReady: _propTypes2.default.func,
    progress: _propTypes2.default.func,
    reachBeginning: _propTypes2.default.func,
    reachEnd: _propTypes2.default.func,
    fromEdge: _propTypes2.default.func,
    setTranslate: _propTypes2.default.func,
    setTransition: _propTypes2.default.func,
    resize: _propTypes2.default.func
  })
};
exports.default = ReactIdSwiper;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Swiper 4.5.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://www.idangero.us/swiper/
 *
 * Copyright 2014-2019 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: September 13, 2019
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.Swiper = factory());
}(this, function () { 'use strict';

  /**
   * SSR Window 1.0.1
   * Better handling for window object in SSR environment
   * https://github.com/nolimits4web/ssr-window
   *
   * Copyright 2018, Vladimir Kharlampidi
   *
   * Licensed under MIT
   *
   * Released on: July 18, 2018
   */
  var doc = (typeof document === 'undefined') ? {
    body: {},
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
      blur: function blur() {},
      nodeName: '',
    },
    querySelector: function querySelector() {
      return null;
    },
    querySelectorAll: function querySelectorAll() {
      return [];
    },
    getElementById: function getElementById() {
      return null;
    },
    createEvent: function createEvent() {
      return {
        initEvent: function initEvent() {},
      };
    },
    createElement: function createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute: function setAttribute() {},
        getElementsByTagName: function getElementsByTagName() {
          return [];
        },
      };
    },
    location: { hash: '' },
  } : document; // eslint-disable-line

  var win = (typeof window === 'undefined') ? {
    document: doc,
    navigator: {
      userAgent: '',
    },
    location: {},
    history: {},
    CustomEvent: function CustomEvent() {
      return this;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    getComputedStyle: function getComputedStyle() {
      return {
        getPropertyValue: function getPropertyValue() {
          return '';
        },
      };
    },
    Image: function Image() {},
    Date: function Date() {},
    screen: {},
    setTimeout: function setTimeout() {},
    clearTimeout: function clearTimeout() {},
  } : window; // eslint-disable-line

  /**
   * Dom7 2.1.3
   * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
   * http://framework7.io/docs/dom.html
   *
   * Copyright 2019, Vladimir Kharlampidi
   * The iDangero.us
   * http://www.idangero.us/
   *
   * Licensed under MIT
   *
   * Released on: February 11, 2019
   */

  var Dom7 = function Dom7(arr) {
    var self = this;
    // Create array-like object
    for (var i = 0; i < arr.length; i += 1) {
      self[i] = arr[i];
    }
    self.length = arr.length;
    // Return collection with methods
    return this;
  };

  function $(selector, context) {
    var arr = [];
    var i = 0;
    if (selector && !context) {
      if (selector instanceof Dom7) {
        return selector;
      }
    }
    if (selector) {
        // String
      if (typeof selector === 'string') {
        var els;
        var tempParent;
        var html = selector.trim();
        if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
          var toCreate = 'div';
          if (html.indexOf('<li') === 0) { toCreate = 'ul'; }
          if (html.indexOf('<tr') === 0) { toCreate = 'tbody'; }
          if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) { toCreate = 'tr'; }
          if (html.indexOf('<tbody') === 0) { toCreate = 'table'; }
          if (html.indexOf('<option') === 0) { toCreate = 'select'; }
          tempParent = doc.createElement(toCreate);
          tempParent.innerHTML = html;
          for (i = 0; i < tempParent.childNodes.length; i += 1) {
            arr.push(tempParent.childNodes[i]);
          }
        } else {
          if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
            // Pure ID selector
            els = [doc.getElementById(selector.trim().split('#')[1])];
          } else {
            // Other selectors
            els = (context || doc).querySelectorAll(selector.trim());
          }
          for (i = 0; i < els.length; i += 1) {
            if (els[i]) { arr.push(els[i]); }
          }
        }
      } else if (selector.nodeType || selector === win || selector === doc) {
        // Node/element
        arr.push(selector);
      } else if (selector.length > 0 && selector[0].nodeType) {
        // Array of elements or instance of Dom
        for (i = 0; i < selector.length; i += 1) {
          arr.push(selector[i]);
        }
      }
    }
    return new Dom7(arr);
  }

  $.fn = Dom7.prototype;
  $.Class = Dom7;
  $.Dom7 = Dom7;

  function unique(arr) {
    var uniqueArray = [];
    for (var i = 0; i < arr.length; i += 1) {
      if (uniqueArray.indexOf(arr[i]) === -1) { uniqueArray.push(arr[i]); }
    }
    return uniqueArray;
  }

  // Classes and attributes
  function addClass(className) {
    if (typeof className === 'undefined') {
      return this;
    }
    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.add(classes[i]); }
      }
    }
    return this;
  }
  function removeClass(className) {
    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.remove(classes[i]); }
      }
    }
    return this;
  }
  function hasClass(className) {
    if (!this[0]) { return false; }
    return this[0].classList.contains(className);
  }
  function toggleClass(className) {
    var classes = className.split(' ');
    for (var i = 0; i < classes.length; i += 1) {
      for (var j = 0; j < this.length; j += 1) {
        if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') { this[j].classList.toggle(classes[i]); }
      }
    }
    return this;
  }
  function attr(attrs, value) {
    var arguments$1 = arguments;

    if (arguments.length === 1 && typeof attrs === 'string') {
      // Get attr
      if (this[0]) { return this[0].getAttribute(attrs); }
      return undefined;
    }

    // Set attrs
    for (var i = 0; i < this.length; i += 1) {
      if (arguments$1.length === 2) {
        // String
        this[i].setAttribute(attrs, value);
      } else {
        // Object
        // eslint-disable-next-line
        for (var attrName in attrs) {
          this[i][attrName] = attrs[attrName];
          this[i].setAttribute(attrName, attrs[attrName]);
        }
      }
    }
    return this;
  }
  // eslint-disable-next-line
  function removeAttr(attr) {
    for (var i = 0; i < this.length; i += 1) {
      this[i].removeAttribute(attr);
    }
    return this;
  }
  function data(key, value) {
    var el;
    if (typeof value === 'undefined') {
      el = this[0];
      // Get value
      if (el) {
        if (el.dom7ElementDataStorage && (key in el.dom7ElementDataStorage)) {
          return el.dom7ElementDataStorage[key];
        }

        var dataKey = el.getAttribute(("data-" + key));
        if (dataKey) {
          return dataKey;
        }
        return undefined;
      }
      return undefined;
    }

    // Set value
    for (var i = 0; i < this.length; i += 1) {
      el = this[i];
      if (!el.dom7ElementDataStorage) { el.dom7ElementDataStorage = {}; }
      el.dom7ElementDataStorage[key] = value;
    }
    return this;
  }
  // Transforms
  // eslint-disable-next-line
  function transform(transform) {
    for (var i = 0; i < this.length; i += 1) {
      var elStyle = this[i].style;
      elStyle.webkitTransform = transform;
      elStyle.transform = transform;
    }
    return this;
  }
  function transition(duration) {
    if (typeof duration !== 'string') {
      duration = duration + "ms"; // eslint-disable-line
    }
    for (var i = 0; i < this.length; i += 1) {
      var elStyle = this[i].style;
      elStyle.webkitTransitionDuration = duration;
      elStyle.transitionDuration = duration;
    }
    return this;
  }
  // Events
  function on() {
    var assign;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
    var eventType = args[0];
    var targetSelector = args[1];
    var listener = args[2];
    var capture = args[3];
    if (typeof args[1] === 'function') {
      (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
      targetSelector = undefined;
    }
    if (!capture) { capture = false; }

    function handleLiveEvent(e) {
      var target = e.target;
      if (!target) { return; }
      var eventData = e.target.dom7EventData || [];
      if (eventData.indexOf(e) < 0) {
        eventData.unshift(e);
      }
      if ($(target).is(targetSelector)) { listener.apply(target, eventData); }
      else {
        var parents = $(target).parents(); // eslint-disable-line
        for (var k = 0; k < parents.length; k += 1) {
          if ($(parents[k]).is(targetSelector)) { listener.apply(parents[k], eventData); }
        }
      }
    }
    function handleEvent(e) {
      var eventData = e && e.target ? e.target.dom7EventData || [] : [];
      if (eventData.indexOf(e) < 0) {
        eventData.unshift(e);
      }
      listener.apply(this, eventData);
    }
    var events = eventType.split(' ');
    var j;
    for (var i = 0; i < this.length; i += 1) {
      var el = this[i];
      if (!targetSelector) {
        for (j = 0; j < events.length; j += 1) {
          var event = events[j];
          if (!el.dom7Listeners) { el.dom7Listeners = {}; }
          if (!el.dom7Listeners[event]) { el.dom7Listeners[event] = []; }
          el.dom7Listeners[event].push({
            listener: listener,
            proxyListener: handleEvent,
          });
          el.addEventListener(event, handleEvent, capture);
        }
      } else {
        // Live events
        for (j = 0; j < events.length; j += 1) {
          var event$1 = events[j];
          if (!el.dom7LiveListeners) { el.dom7LiveListeners = {}; }
          if (!el.dom7LiveListeners[event$1]) { el.dom7LiveListeners[event$1] = []; }
          el.dom7LiveListeners[event$1].push({
            listener: listener,
            proxyListener: handleLiveEvent,
          });
          el.addEventListener(event$1, handleLiveEvent, capture);
        }
      }
    }
    return this;
  }
  function off() {
    var assign;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
    var eventType = args[0];
    var targetSelector = args[1];
    var listener = args[2];
    var capture = args[3];
    if (typeof args[1] === 'function') {
      (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
      targetSelector = undefined;
    }
    if (!capture) { capture = false; }

    var events = eventType.split(' ');
    for (var i = 0; i < events.length; i += 1) {
      var event = events[i];
      for (var j = 0; j < this.length; j += 1) {
        var el = this[j];
        var handlers = (void 0);
        if (!targetSelector && el.dom7Listeners) {
          handlers = el.dom7Listeners[event];
        } else if (targetSelector && el.dom7LiveListeners) {
          handlers = el.dom7LiveListeners[event];
        }
        if (handlers && handlers.length) {
          for (var k = handlers.length - 1; k >= 0; k -= 1) {
            var handler = handlers[k];
            if (listener && handler.listener === listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            } else if (!listener) {
              el.removeEventListener(event, handler.proxyListener, capture);
              handlers.splice(k, 1);
            }
          }
        }
      }
    }
    return this;
  }
  function trigger() {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var events = args[0].split(' ');
    var eventData = args[1];
    for (var i = 0; i < events.length; i += 1) {
      var event = events[i];
      for (var j = 0; j < this.length; j += 1) {
        var el = this[j];
        var evt = (void 0);
        try {
          evt = new win.CustomEvent(event, {
            detail: eventData,
            bubbles: true,
            cancelable: true,
          });
        } catch (e) {
          evt = doc.createEvent('Event');
          evt.initEvent(event, true, true);
          evt.detail = eventData;
        }
        // eslint-disable-next-line
        el.dom7EventData = args.filter(function (data, dataIndex) { return dataIndex > 0; });
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
    return this;
  }
  function transitionEnd(callback) {
    var events = ['webkitTransitionEnd', 'transitionend'];
    var dom = this;
    var i;
    function fireCallBack(e) {
      /* jshint validthis:true */
      if (e.target !== this) { return; }
      callback.call(this, e);
      for (i = 0; i < events.length; i += 1) {
        dom.off(events[i], fireCallBack);
      }
    }
    if (callback) {
      for (i = 0; i < events.length; i += 1) {
        dom.on(events[i], fireCallBack);
      }
    }
    return this;
  }
  function outerWidth(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        // eslint-disable-next-line
        var styles = this.styles();
        return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
      }
      return this[0].offsetWidth;
    }
    return null;
  }
  function outerHeight(includeMargins) {
    if (this.length > 0) {
      if (includeMargins) {
        // eslint-disable-next-line
        var styles = this.styles();
        return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
      }
      return this[0].offsetHeight;
    }
    return null;
  }
  function offset() {
    if (this.length > 0) {
      var el = this[0];
      var box = el.getBoundingClientRect();
      var body = doc.body;
      var clientTop = el.clientTop || body.clientTop || 0;
      var clientLeft = el.clientLeft || body.clientLeft || 0;
      var scrollTop = el === win ? win.scrollY : el.scrollTop;
      var scrollLeft = el === win ? win.scrollX : el.scrollLeft;
      return {
        top: (box.top + scrollTop) - clientTop,
        left: (box.left + scrollLeft) - clientLeft,
      };
    }

    return null;
  }
  function styles() {
    if (this[0]) { return win.getComputedStyle(this[0], null); }
    return {};
  }
  function css(props, value) {
    var i;
    if (arguments.length === 1) {
      if (typeof props === 'string') {
        if (this[0]) { return win.getComputedStyle(this[0], null).getPropertyValue(props); }
      } else {
        for (i = 0; i < this.length; i += 1) {
          // eslint-disable-next-line
          for (var prop in props) {
            this[i].style[prop] = props[prop];
          }
        }
        return this;
      }
    }
    if (arguments.length === 2 && typeof props === 'string') {
      for (i = 0; i < this.length; i += 1) {
        this[i].style[props] = value;
      }
      return this;
    }
    return this;
  }
  // Iterate over the collection passing elements to `callback`
  function each(callback) {
    // Don't bother continuing without a callback
    if (!callback) { return this; }
    // Iterate over the current collection
    for (var i = 0; i < this.length; i += 1) {
      // If the callback returns false
      if (callback.call(this[i], i, this[i]) === false) {
        // End the loop early
        return this;
      }
    }
    // Return `this` to allow chained DOM operations
    return this;
  }
  // eslint-disable-next-line
  function html(html) {
    if (typeof html === 'undefined') {
      return this[0] ? this[0].innerHTML : undefined;
    }

    for (var i = 0; i < this.length; i += 1) {
      this[i].innerHTML = html;
    }
    return this;
  }
  // eslint-disable-next-line
  function text(text) {
    if (typeof text === 'undefined') {
      if (this[0]) {
        return this[0].textContent.trim();
      }
      return null;
    }

    for (var i = 0; i < this.length; i += 1) {
      this[i].textContent = text;
    }
    return this;
  }
  function is(selector) {
    var el = this[0];
    var compareWith;
    var i;
    if (!el || typeof selector === 'undefined') { return false; }
    if (typeof selector === 'string') {
      if (el.matches) { return el.matches(selector); }
      else if (el.webkitMatchesSelector) { return el.webkitMatchesSelector(selector); }
      else if (el.msMatchesSelector) { return el.msMatchesSelector(selector); }

      compareWith = $(selector);
      for (i = 0; i < compareWith.length; i += 1) {
        if (compareWith[i] === el) { return true; }
      }
      return false;
    } else if (selector === doc) { return el === doc; }
    else if (selector === win) { return el === win; }

    if (selector.nodeType || selector instanceof Dom7) {
      compareWith = selector.nodeType ? [selector] : selector;
      for (i = 0; i < compareWith.length; i += 1) {
        if (compareWith[i] === el) { return true; }
      }
      return false;
    }
    return false;
  }
  function index() {
    var child = this[0];
    var i;
    if (child) {
      i = 0;
      // eslint-disable-next-line
      while ((child = child.previousSibling) !== null) {
        if (child.nodeType === 1) { i += 1; }
      }
      return i;
    }
    return undefined;
  }
  // eslint-disable-next-line
  function eq(index) {
    if (typeof index === 'undefined') { return this; }
    var length = this.length;
    var returnIndex;
    if (index > length - 1) {
      return new Dom7([]);
    }
    if (index < 0) {
      returnIndex = length + index;
      if (returnIndex < 0) { return new Dom7([]); }
      return new Dom7([this[returnIndex]]);
    }
    return new Dom7([this[index]]);
  }
  function append() {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var newChild;

    for (var k = 0; k < args.length; k += 1) {
      newChild = args[k];
      for (var i = 0; i < this.length; i += 1) {
        if (typeof newChild === 'string') {
          var tempDiv = doc.createElement('div');
          tempDiv.innerHTML = newChild;
          while (tempDiv.firstChild) {
            this[i].appendChild(tempDiv.firstChild);
          }
        } else if (newChild instanceof Dom7) {
          for (var j = 0; j < newChild.length; j += 1) {
            this[i].appendChild(newChild[j]);
          }
        } else {
          this[i].appendChild(newChild);
        }
      }
    }

    return this;
  }
  function prepend(newChild) {
    var i;
    var j;
    for (i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = doc.createElement('div');
        tempDiv.innerHTML = newChild;
        for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
          this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        }
      } else if (newChild instanceof Dom7) {
        for (j = 0; j < newChild.length; j += 1) {
          this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        }
      } else {
        this[i].insertBefore(newChild, this[i].childNodes[0]);
      }
    }
    return this;
  }
  function next(selector) {
    if (this.length > 0) {
      if (selector) {
        if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
          return new Dom7([this[0].nextElementSibling]);
        }
        return new Dom7([]);
      }

      if (this[0].nextElementSibling) { return new Dom7([this[0].nextElementSibling]); }
      return new Dom7([]);
    }
    return new Dom7([]);
  }
  function nextAll(selector) {
    var nextEls = [];
    var el = this[0];
    if (!el) { return new Dom7([]); }
    while (el.nextElementSibling) {
      var next = el.nextElementSibling; // eslint-disable-line
      if (selector) {
        if ($(next).is(selector)) { nextEls.push(next); }
      } else { nextEls.push(next); }
      el = next;
    }
    return new Dom7(nextEls);
  }
  function prev(selector) {
    if (this.length > 0) {
      var el = this[0];
      if (selector) {
        if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
          return new Dom7([el.previousElementSibling]);
        }
        return new Dom7([]);
      }

      if (el.previousElementSibling) { return new Dom7([el.previousElementSibling]); }
      return new Dom7([]);
    }
    return new Dom7([]);
  }
  function prevAll(selector) {
    var prevEls = [];
    var el = this[0];
    if (!el) { return new Dom7([]); }
    while (el.previousElementSibling) {
      var prev = el.previousElementSibling; // eslint-disable-line
      if (selector) {
        if ($(prev).is(selector)) { prevEls.push(prev); }
      } else { prevEls.push(prev); }
      el = prev;
    }
    return new Dom7(prevEls);
  }
  function parent(selector) {
    var parents = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      if (this[i].parentNode !== null) {
        if (selector) {
          if ($(this[i].parentNode).is(selector)) { parents.push(this[i].parentNode); }
        } else {
          parents.push(this[i].parentNode);
        }
      }
    }
    return $(unique(parents));
  }
  function parents(selector) {
    var parents = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      var parent = this[i].parentNode; // eslint-disable-line
      while (parent) {
        if (selector) {
          if ($(parent).is(selector)) { parents.push(parent); }
        } else {
          parents.push(parent);
        }
        parent = parent.parentNode;
      }
    }
    return $(unique(parents));
  }
  function closest(selector) {
    var closest = this; // eslint-disable-line
    if (typeof selector === 'undefined') {
      return new Dom7([]);
    }
    if (!closest.is(selector)) {
      closest = closest.parents(selector).eq(0);
    }
    return closest;
  }
  function find(selector) {
    var foundElements = [];
    for (var i = 0; i < this.length; i += 1) {
      var found = this[i].querySelectorAll(selector);
      for (var j = 0; j < found.length; j += 1) {
        foundElements.push(found[j]);
      }
    }
    return new Dom7(foundElements);
  }
  function children(selector) {
    var children = []; // eslint-disable-line
    for (var i = 0; i < this.length; i += 1) {
      var childNodes = this[i].childNodes;

      for (var j = 0; j < childNodes.length; j += 1) {
        if (!selector) {
          if (childNodes[j].nodeType === 1) { children.push(childNodes[j]); }
        } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
          children.push(childNodes[j]);
        }
      }
    }
    return new Dom7(unique(children));
  }
  function remove() {
    for (var i = 0; i < this.length; i += 1) {
      if (this[i].parentNode) { this[i].parentNode.removeChild(this[i]); }
    }
    return this;
  }
  function add() {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var dom = this;
    var i;
    var j;
    for (i = 0; i < args.length; i += 1) {
      var toAdd = $(args[i]);
      for (j = 0; j < toAdd.length; j += 1) {
        dom[dom.length] = toAdd[j];
        dom.length += 1;
      }
    }
    return dom;
  }

  var Methods = {
    addClass: addClass,
    removeClass: removeClass,
    hasClass: hasClass,
    toggleClass: toggleClass,
    attr: attr,
    removeAttr: removeAttr,
    data: data,
    transform: transform,
    transition: transition,
    on: on,
    off: off,
    trigger: trigger,
    transitionEnd: transitionEnd,
    outerWidth: outerWidth,
    outerHeight: outerHeight,
    offset: offset,
    css: css,
    each: each,
    html: html,
    text: text,
    is: is,
    index: index,
    eq: eq,
    append: append,
    prepend: prepend,
    next: next,
    nextAll: nextAll,
    prev: prev,
    prevAll: prevAll,
    parent: parent,
    parents: parents,
    closest: closest,
    find: find,
    children: children,
    remove: remove,
    add: add,
    styles: styles,
  };

  Object.keys(Methods).forEach(function (methodName) {
    $.fn[methodName] = $.fn[methodName] || Methods[methodName];
  });

  var Utils = {
    deleteProps: function deleteProps(obj) {
      var object = obj;
      Object.keys(object).forEach(function (key) {
        try {
          object[key] = null;
        } catch (e) {
          // no getter for object
        }
        try {
          delete object[key];
        } catch (e) {
          // something got wrong
        }
      });
    },
    nextTick: function nextTick(callback, delay) {
      if ( delay === void 0 ) delay = 0;

      return setTimeout(callback, delay);
    },
    now: function now() {
      return Date.now();
    },
    getTranslate: function getTranslate(el, axis) {
      if ( axis === void 0 ) axis = 'x';

      var matrix;
      var curTransform;
      var transformMatrix;

      var curStyle = win.getComputedStyle(el, null);

      if (win.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) {
          curTransform = curTransform.split(', ').map(function (a) { return a.replace(',', '.'); }).join(', ');
        }
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new win.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
      } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
      }

      if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m41; }
        // Crazy IE10 Matrix
        else if (matrix.length === 16) { curTransform = parseFloat(matrix[12]); }
        // Normal Browsers
        else { curTransform = parseFloat(matrix[4]); }
      }
      if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m42; }
        // Crazy IE10 Matrix
        else if (matrix.length === 16) { curTransform = parseFloat(matrix[13]); }
        // Normal Browsers
        else { curTransform = parseFloat(matrix[5]); }
      }
      return curTransform || 0;
    },
    parseUrlQuery: function parseUrlQuery(url) {
      var query = {};
      var urlToParse = url || win.location.href;
      var i;
      var params;
      var param;
      var length;
      if (typeof urlToParse === 'string' && urlToParse.length) {
        urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
        params = urlToParse.split('&').filter(function (paramsPart) { return paramsPart !== ''; });
        length = params.length;

        for (i = 0; i < length; i += 1) {
          param = params[i].replace(/#\S+/g, '').split('=');
          query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
        }
      }
      return query;
    },
    isObject: function isObject(o) {
      return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
    },
    extend: function extend() {
      var args = [], len$1 = arguments.length;
      while ( len$1-- ) args[ len$1 ] = arguments[ len$1 ];

      var to = Object(args[0]);
      for (var i = 1; i < args.length; i += 1) {
        var nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null) {
          var keysArray = Object.keys(Object(nextSource));
          for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) {
              if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                Utils.extend(to[nextKey], nextSource[nextKey]);
              } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                to[nextKey] = {};
                Utils.extend(to[nextKey], nextSource[nextKey]);
              } else {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
      }
      return to;
    },
  };

  var Support = (function Support() {
    var testDiv = doc.createElement('div');
    return {
      touch: (win.Modernizr && win.Modernizr.touch === true) || (function checkTouch() {
        return !!((win.navigator.maxTouchPoints > 0) || ('ontouchstart' in win) || (win.DocumentTouch && doc instanceof win.DocumentTouch));
      }()),

      pointerEvents: !!(win.navigator.pointerEnabled || win.PointerEvent || ('maxTouchPoints' in win.navigator && win.navigator.maxTouchPoints > 0)),
      prefixedPointerEvents: !!win.navigator.msPointerEnabled,

      transition: (function checkTransition() {
        var style = testDiv.style;
        return ('transition' in style || 'webkitTransition' in style || 'MozTransition' in style);
      }()),
      transforms3d: (win.Modernizr && win.Modernizr.csstransforms3d === true) || (function checkTransforms3d() {
        var style = testDiv.style;
        return ('webkitPerspective' in style || 'MozPerspective' in style || 'OPerspective' in style || 'MsPerspective' in style || 'perspective' in style);
      }()),

      flexbox: (function checkFlexbox() {
        var style = testDiv.style;
        var styles = ('alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient').split(' ');
        for (var i = 0; i < styles.length; i += 1) {
          if (styles[i] in style) { return true; }
        }
        return false;
      }()),

      observer: (function checkObserver() {
        return ('MutationObserver' in win || 'WebkitMutationObserver' in win);
      }()),

      passiveListener: (function checkPassiveListener() {
        var supportsPassive = false;
        try {
          var opts = Object.defineProperty({}, 'passive', {
            // eslint-disable-next-line
            get: function get() {
              supportsPassive = true;
            },
          });
          win.addEventListener('testPassiveListener', null, opts);
        } catch (e) {
          // No support
        }
        return supportsPassive;
      }()),

      gestures: (function checkGestures() {
        return 'ongesturestart' in win;
      }()),
    };
  }());

  var Browser = (function Browser() {
    function isSafari() {
      var ua = win.navigator.userAgent.toLowerCase();
      return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
    }
    return {
      isIE: !!win.navigator.userAgent.match(/Trident/g) || !!win.navigator.userAgent.match(/MSIE/g),
      isEdge: !!win.navigator.userAgent.match(/Edge/g),
      isSafari: isSafari(),
      isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(win.navigator.userAgent),
    };
  }());

  var SwiperClass = function SwiperClass(params) {
    if ( params === void 0 ) params = {};

    var self = this;
    self.params = params;

    // Events
    self.eventsListeners = {};

    if (self.params && self.params.on) {
      Object.keys(self.params.on).forEach(function (eventName) {
        self.on(eventName, self.params.on[eventName]);
      });
    }
  };

  var staticAccessors = { components: { configurable: true } };

  SwiperClass.prototype.on = function on (events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') { return self; }
    var method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(function (event) {
      if (!self.eventsListeners[event]) { self.eventsListeners[event] = []; }
      self.eventsListeners[event][method](handler);
    });
    return self;
  };

  SwiperClass.prototype.once = function once (events, handler, priority) {
    var self = this;
    if (typeof handler !== 'function') { return self; }
    function onceHandler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];

      handler.apply(self, args);
      self.off(events, onceHandler);
      if (onceHandler.f7proxy) {
        delete onceHandler.f7proxy;
      }
    }
    onceHandler.f7proxy = handler;
    return self.on(events, onceHandler, priority);
  };

  SwiperClass.prototype.off = function off (events, handler) {
    var self = this;
    if (!self.eventsListeners) { return self; }
    events.split(' ').forEach(function (event) {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event] && self.eventsListeners[event].length) {
        self.eventsListeners[event].forEach(function (eventHandler, index) {
          if (eventHandler === handler || (eventHandler.f7proxy && eventHandler.f7proxy === handler)) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  };

  SwiperClass.prototype.emit = function emit () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

    var self = this;
    if (!self.eventsListeners) { return self; }
    var events;
    var data;
    var context;
    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }
    var eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(function (event) {
      if (self.eventsListeners && self.eventsListeners[event]) {
        var handlers = [];
        self.eventsListeners[event].forEach(function (eventHandler) {
          handlers.push(eventHandler);
        });
        handlers.forEach(function (eventHandler) {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  };

  SwiperClass.prototype.useModulesParams = function useModulesParams (instanceParams) {
    var instance = this;
    if (!instance.modules) { return; }
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      // Extend params
      if (module.params) {
        Utils.extend(instanceParams, module.params);
      }
    });
  };

  SwiperClass.prototype.useModules = function useModules (modulesParams) {
      if ( modulesParams === void 0 ) modulesParams = {};

    var instance = this;
    if (!instance.modules) { return; }
    Object.keys(instance.modules).forEach(function (moduleName) {
      var module = instance.modules[moduleName];
      var moduleParams = modulesParams[moduleName] || {};
      // Extend instance methods and props
      if (module.instance) {
        Object.keys(module.instance).forEach(function (modulePropName) {
          var moduleProp = module.instance[modulePropName];
          if (typeof moduleProp === 'function') {
            instance[modulePropName] = moduleProp.bind(instance);
          } else {
            instance[modulePropName] = moduleProp;
          }
        });
      }
      // Add event listeners
      if (module.on && instance.on) {
        Object.keys(module.on).forEach(function (moduleEventName) {
          instance.on(moduleEventName, module.on[moduleEventName]);
        });
      }

      // Module create callback
      if (module.create) {
        module.create.bind(instance)(moduleParams);
      }
    });
  };

  staticAccessors.components.set = function (components) {
    var Class = this;
    if (!Class.use) { return; }
    Class.use(components);
  };

  SwiperClass.installModule = function installModule (module) {
      var params = [], len = arguments.length - 1;
      while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];

    var Class = this;
    if (!Class.prototype.modules) { Class.prototype.modules = {}; }
    var name = module.name || (((Object.keys(Class.prototype.modules).length) + "_" + (Utils.now())));
    Class.prototype.modules[name] = module;
    // Prototype
    if (module.proto) {
      Object.keys(module.proto).forEach(function (key) {
        Class.prototype[key] = module.proto[key];
      });
    }
    // Class
    if (module.static) {
      Object.keys(module.static).forEach(function (key) {
        Class[key] = module.static[key];
      });
    }
    // Callback
    if (module.install) {
      module.install.apply(Class, params);
    }
    return Class;
  };

  SwiperClass.use = function use (module) {
      var params = [], len = arguments.length - 1;
      while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];

    var Class = this;
    if (Array.isArray(module)) {
      module.forEach(function (m) { return Class.installModule(m); });
      return Class;
    }
    return Class.installModule.apply(Class, [ module ].concat( params ));
  };

  Object.defineProperties( SwiperClass, staticAccessors );

  function updateSize () {
    var swiper = this;
    var width;
    var height;
    var $el = swiper.$el;
    if (typeof swiper.params.width !== 'undefined') {
      width = swiper.params.width;
    } else {
      width = $el[0].clientWidth;
    }
    if (typeof swiper.params.height !== 'undefined') {
      height = swiper.params.height;
    } else {
      height = $el[0].clientHeight;
    }
    if ((width === 0 && swiper.isHorizontal()) || (height === 0 && swiper.isVertical())) {
      return;
    }

    // Subtract paddings
    width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
    height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);

    Utils.extend(swiper, {
      width: width,
      height: height,
      size: swiper.isHorizontal() ? width : height,
    });
  }

  function updateSlides () {
    var swiper = this;
    var params = swiper.params;

    var $wrapperEl = swiper.$wrapperEl;
    var swiperSize = swiper.size;
    var rtl = swiper.rtlTranslate;
    var wrongRTL = swiper.wrongRTL;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = $wrapperEl.children(("." + (swiper.params.slideClass)));
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];

    var offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') {
      offsetBefore = params.slidesOffsetBefore.call(swiper);
    }

    var offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') {
      offsetAfter = params.slidesOffsetAfter.call(swiper);
    }

    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.snapGrid.length;

    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var index = 0;
    if (typeof swiperSize === 'undefined') {
      return;
    }
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
      spaceBetween = (parseFloat(spaceBetween.replace('%', '')) / 100) * swiperSize;
    }

    swiper.virtualSize = -spaceBetween;

    // reset margins
    if (rtl) { slides.css({ marginLeft: '', marginTop: '' }); }
    else { slides.css({ marginRight: '', marginBottom: '' }); }

    var slidesNumberEvenToRows;
    if (params.slidesPerColumn > 1) {
      if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
        slidesNumberEvenToRows = slidesLength;
      } else {
        slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
      }
      if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
        slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
      }
    }

    // Calc slides
    var slideSize;
    var slidesPerColumn = params.slidesPerColumn;
    var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
    var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
    for (var i = 0; i < slidesLength; i += 1) {
      slideSize = 0;
      var slide = slides.eq(i);
      if (params.slidesPerColumn > 1) {
        // Set slides order
        var newSlideOrderIndex = (void 0);
        var column = (void 0);
        var row = (void 0);
        if (
          (params.slidesPerColumnFill === 'column')
          || (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1)
        ) {
          if (params.slidesPerColumnFill === 'column') {
            column = Math.floor(i / slidesPerColumn);
            row = i - (column * slidesPerColumn);
            if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn - 1)) {
              row += 1;
              if (row >= slidesPerColumn) {
                row = 0;
                column += 1;
              }
            }
          } else {
            var groupIndex = Math.floor(i / params.slidesPerGroup);
            row = Math.floor(i / params.slidesPerView) - groupIndex * params.slidesPerColumn;
            column = i - row * params.slidesPerView - groupIndex * params.slidesPerView;
          }
          newSlideOrderIndex = column + ((row * slidesNumberEvenToRows) / slidesPerColumn);
          slide
            .css({
              '-webkit-box-ordinal-group': newSlideOrderIndex,
              '-moz-box-ordinal-group': newSlideOrderIndex,
              '-ms-flex-order': newSlideOrderIndex,
              '-webkit-order': newSlideOrderIndex,
              order: newSlideOrderIndex,
            });
        } else {
          row = Math.floor(i / slidesPerRow);
          column = i - (row * slidesPerRow);
        }
        slide
          .css(
            ("margin-" + (swiper.isHorizontal() ? 'top' : 'left')),
            (row !== 0 && params.spaceBetween) && (((params.spaceBetween) + "px"))
          )
          .attr('data-swiper-column', column)
          .attr('data-swiper-row', row);
      }
      if (slide.css('display') === 'none') { continue; } // eslint-disable-line

      if (params.slidesPerView === 'auto') {
        var slideStyles = win.getComputedStyle(slide[0], null);
        var currentTransform = slide[0].style.transform;
        var currentWebKitTransform = slide[0].style.webkitTransform;
        if (currentTransform) {
          slide[0].style.transform = 'none';
        }
        if (currentWebKitTransform) {
          slide[0].style.webkitTransform = 'none';
        }
        if (params.roundLengths) {
          slideSize = swiper.isHorizontal()
            ? slide.outerWidth(true)
            : slide.outerHeight(true);
        } else {
          // eslint-disable-next-line
          if (swiper.isHorizontal()) {
            var width = parseFloat(slideStyles.getPropertyValue('width'));
            var paddingLeft = parseFloat(slideStyles.getPropertyValue('padding-left'));
            var paddingRight = parseFloat(slideStyles.getPropertyValue('padding-right'));
            var marginLeft = parseFloat(slideStyles.getPropertyValue('margin-left'));
            var marginRight = parseFloat(slideStyles.getPropertyValue('margin-right'));
            var boxSizing = slideStyles.getPropertyValue('box-sizing');
            if (boxSizing && boxSizing === 'border-box' && !Browser.isIE) {
              slideSize = width + marginLeft + marginRight;
            } else {
              slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight;
            }
          } else {
            var height = parseFloat(slideStyles.getPropertyValue('height'));
            var paddingTop = parseFloat(slideStyles.getPropertyValue('padding-top'));
            var paddingBottom = parseFloat(slideStyles.getPropertyValue('padding-bottom'));
            var marginTop = parseFloat(slideStyles.getPropertyValue('margin-top'));
            var marginBottom = parseFloat(slideStyles.getPropertyValue('margin-bottom'));
            var boxSizing$1 = slideStyles.getPropertyValue('box-sizing');
            if (boxSizing$1 && boxSizing$1 === 'border-box' && !Browser.isIE) {
              slideSize = height + marginTop + marginBottom;
            } else {
              slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom;
            }
          }
        }
        if (currentTransform) {
          slide[0].style.transform = currentTransform;
        }
        if (currentWebKitTransform) {
          slide[0].style.webkitTransform = currentWebKitTransform;
        }
        if (params.roundLengths) { slideSize = Math.floor(slideSize); }
      } else {
        slideSize = (swiperSize - ((params.slidesPerView - 1) * spaceBetween)) / params.slidesPerView;
        if (params.roundLengths) { slideSize = Math.floor(slideSize); }

        if (slides[i]) {
          if (swiper.isHorizontal()) {
            slides[i].style.width = slideSize + "px";
          } else {
            slides[i].style.height = slideSize + "px";
          }
        }
      }
      if (slides[i]) {
        slides[i].swiperSlideSize = slideSize;
      }
      slidesSizesGrid.push(slideSize);


      if (params.centeredSlides) {
        slidePosition = slidePosition + (slideSize / 2) + (prevSlideSize / 2) + spaceBetween;
        if (prevSlideSize === 0 && i !== 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
        if (i === 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
        if (Math.abs(slidePosition) < 1 / 1000) { slidePosition = 0; }
        if (params.roundLengths) { slidePosition = Math.floor(slidePosition); }
        if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
        slidesGrid.push(slidePosition);
      } else {
        if (params.roundLengths) { slidePosition = Math.floor(slidePosition); }
        if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
        slidesGrid.push(slidePosition);
        slidePosition = slidePosition + slideSize + spaceBetween;
      }

      swiper.virtualSize += slideSize + spaceBetween;

      prevSlideSize = slideSize;

      index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    var newSlidesGrid;

    if (
      rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
      $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") });
    }
    if (!Support.flexbox || params.setWrapperSize) {
      if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
      else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
    }

    if (params.slidesPerColumn > 1) {
      swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
      swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
      if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
      else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
      if (params.centeredSlides) {
        newSlidesGrid = [];
        for (var i$1 = 0; i$1 < snapGrid.length; i$1 += 1) {
          var slidesGridItem = snapGrid[i$1];
          if (params.roundLengths) { slidesGridItem = Math.floor(slidesGridItem); }
          if (snapGrid[i$1] < swiper.virtualSize + snapGrid[0]) { newSlidesGrid.push(slidesGridItem); }
        }
        snapGrid = newSlidesGrid;
      }
    }

    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
      newSlidesGrid = [];
      for (var i$2 = 0; i$2 < snapGrid.length; i$2 += 1) {
        var slidesGridItem$1 = snapGrid[i$2];
        if (params.roundLengths) { slidesGridItem$1 = Math.floor(slidesGridItem$1); }
        if (snapGrid[i$2] <= swiper.virtualSize - swiperSize) {
          newSlidesGrid.push(slidesGridItem$1);
        }
      }
      snapGrid = newSlidesGrid;
      if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
        snapGrid.push(swiper.virtualSize - swiperSize);
      }
    }
    if (snapGrid.length === 0) { snapGrid = [0]; }

    if (params.spaceBetween !== 0) {
      if (swiper.isHorizontal()) {
        if (rtl) { slides.css({ marginLeft: (spaceBetween + "px") }); }
        else { slides.css({ marginRight: (spaceBetween + "px") }); }
      } else { slides.css({ marginBottom: (spaceBetween + "px") }); }
    }

    if (params.centerInsufficientSlides) {
      var allSlidesSize = 0;
      slidesSizesGrid.forEach(function (slideSizeValue) {
        allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
      });
      allSlidesSize -= params.spaceBetween;
      if (allSlidesSize < swiperSize) {
        var allSlidesOffset = (swiperSize - allSlidesSize) / 2;
        snapGrid.forEach(function (snap, snapIndex) {
          snapGrid[snapIndex] = snap - allSlidesOffset;
        });
        slidesGrid.forEach(function (snap, snapIndex) {
          slidesGrid[snapIndex] = snap + allSlidesOffset;
        });
      }
    }

    Utils.extend(swiper, {
      slides: slides,
      snapGrid: snapGrid,
      slidesGrid: slidesGrid,
      slidesSizesGrid: slidesSizesGrid,
    });

    if (slidesLength !== previousSlidesLength) {
      swiper.emit('slidesLengthChange');
    }
    if (snapGrid.length !== previousSnapGridLength) {
      if (swiper.params.watchOverflow) { swiper.checkOverflow(); }
      swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) {
      swiper.emit('slidesGridLengthChange');
    }

    if (params.watchSlidesProgress || params.watchSlidesVisibility) {
      swiper.updateSlidesOffset();
    }
  }

  function updateAutoHeight (speed) {
    var swiper = this;
    var activeSlides = [];
    var newHeight = 0;
    var i;
    if (typeof speed === 'number') {
      swiper.setTransition(speed);
    } else if (speed === true) {
      swiper.setTransition(swiper.params.speed);
    }
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        var index = swiper.activeIndex + i;
        if (index > swiper.slides.length) { break; }
        activeSlides.push(swiper.slides.eq(index)[0]);
      }
    } else {
      activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
    }

    // Find new height from highest slide in view
    for (i = 0; i < activeSlides.length; i += 1) {
      if (typeof activeSlides[i] !== 'undefined') {
        var height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
      }
    }

    // Update Height
    if (newHeight) { swiper.$wrapperEl.css('height', (newHeight + "px")); }
  }

  function updateSlidesOffset () {
    var swiper = this;
    var slides = swiper.slides;
    for (var i = 0; i < slides.length; i += 1) {
      slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
    }
  }

  function updateSlidesProgress (translate) {
    if ( translate === void 0 ) translate = (this && this.translate) || 0;

    var swiper = this;
    var params = swiper.params;

    var slides = swiper.slides;
    var rtl = swiper.rtlTranslate;

    if (slides.length === 0) { return; }
    if (typeof slides[0].swiperSlideOffset === 'undefined') { swiper.updateSlidesOffset(); }

    var offsetCenter = -translate;
    if (rtl) { offsetCenter = translate; }

    // Visible Slides
    slides.removeClass(params.slideVisibleClass);

    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];

    for (var i = 0; i < slides.length; i += 1) {
      var slide = slides[i];
      var slideProgress = (
        (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0)) - slide.swiperSlideOffset
      ) / (slide.swiperSlideSize + params.spaceBetween);
      if (params.watchSlidesVisibility) {
        var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
        var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        var isVisible = (slideBefore >= 0 && slideBefore < swiper.size - 1)
                  || (slideAfter > 1 && slideAfter <= swiper.size)
                  || (slideBefore <= 0 && slideAfter >= swiper.size);
        if (isVisible) {
          swiper.visibleSlides.push(slide);
          swiper.visibleSlidesIndexes.push(i);
          slides.eq(i).addClass(params.slideVisibleClass);
        }
      }
      slide.progress = rtl ? -slideProgress : slideProgress;
    }
    swiper.visibleSlides = $(swiper.visibleSlides);
  }

  function updateProgress (translate) {
    if ( translate === void 0 ) translate = (this && this.translate) || 0;

    var swiper = this;
    var params = swiper.params;

    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress;
    var isBeginning = swiper.isBeginning;
    var isEnd = swiper.isEnd;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;
    if (translatesDiff === 0) {
      progress = 0;
      isBeginning = true;
      isEnd = true;
    } else {
      progress = (translate - swiper.minTranslate()) / (translatesDiff);
      isBeginning = progress <= 0;
      isEnd = progress >= 1;
    }
    Utils.extend(swiper, {
      progress: progress,
      isBeginning: isBeginning,
      isEnd: isEnd,
    });

    if (params.watchSlidesProgress || params.watchSlidesVisibility) { swiper.updateSlidesProgress(translate); }

    if (isBeginning && !wasBeginning) {
      swiper.emit('reachBeginning toEdge');
    }
    if (isEnd && !wasEnd) {
      swiper.emit('reachEnd toEdge');
    }
    if ((wasBeginning && !isBeginning) || (wasEnd && !isEnd)) {
      swiper.emit('fromEdge');
    }

    swiper.emit('progress', progress);
  }

  function updateSlidesClasses () {
    var swiper = this;

    var slides = swiper.slides;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;
    var realIndex = swiper.realIndex;
    var isVirtual = swiper.virtual && params.virtual.enabled;

    slides.removeClass(((params.slideActiveClass) + " " + (params.slideNextClass) + " " + (params.slidePrevClass) + " " + (params.slideDuplicateActiveClass) + " " + (params.slideDuplicateNextClass) + " " + (params.slideDuplicatePrevClass)));

    var activeSlide;
    if (isVirtual) {
      activeSlide = swiper.$wrapperEl.find(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + activeIndex + "\"]"));
    } else {
      activeSlide = slides.eq(activeIndex);
    }

    // Active classes
    activeSlide.addClass(params.slideActiveClass);

    if (params.loop) {
      // Duplicate to all looped slides
      if (activeSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl
          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + realIndex + "\"]"))
          .addClass(params.slideDuplicateActiveClass);
      } else {
        $wrapperEl
          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]"))
          .addClass(params.slideDuplicateActiveClass);
      }
    }
    // Next Slide
    var nextSlide = activeSlide.nextAll(("." + (params.slideClass))).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
      nextSlide = slides.eq(0);
      nextSlide.addClass(params.slideNextClass);
    }
    // Prev Slide
    var prevSlide = activeSlide.prevAll(("." + (params.slideClass))).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
      prevSlide = slides.eq(-1);
      prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
      // Duplicate to all looped slides
      if (nextSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl
          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicateNextClass);
      } else {
        $wrapperEl
          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicateNextClass);
      }
      if (prevSlide.hasClass(params.slideDuplicateClass)) {
        $wrapperEl
          .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicatePrevClass);
      } else {
        $wrapperEl
          .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
          .addClass(params.slideDuplicatePrevClass);
      }
    }
  }

  function updateActiveIndex (newActiveIndex) {
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var slidesGrid = swiper.slidesGrid;
    var snapGrid = swiper.snapGrid;
    var params = swiper.params;
    var previousIndex = swiper.activeIndex;
    var previousRealIndex = swiper.realIndex;
    var previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;
    if (typeof activeIndex === 'undefined') {
      for (var i = 0; i < slidesGrid.length; i += 1) {
        if (typeof slidesGrid[i + 1] !== 'undefined') {
          if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - ((slidesGrid[i + 1] - slidesGrid[i]) / 2)) {
            activeIndex = i;
          } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
            activeIndex = i + 1;
          }
        } else if (translate >= slidesGrid[i]) {
          activeIndex = i;
        }
      }
      // Normalize slideIndex
      if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') { activeIndex = 0; }
      }
    }
    if (snapGrid.indexOf(translate) >= 0) {
      snapIndex = snapGrid.indexOf(translate);
    } else {
      snapIndex = Math.floor(activeIndex / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }
    if (activeIndex === previousIndex) {
      if (snapIndex !== previousSnapIndex) {
        swiper.snapIndex = snapIndex;
        swiper.emit('snapIndexChange');
      }
      return;
    }

    // Get real index
    var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);

    Utils.extend(swiper, {
      snapIndex: snapIndex,
      realIndex: realIndex,
      previousIndex: previousIndex,
      activeIndex: activeIndex,
    });
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (previousRealIndex !== realIndex) {
      swiper.emit('realIndexChange');
    }
    if (swiper.initialized || swiper.runCallbacksOnInit) {
      swiper.emit('slideChange');
    }
  }

  function updateClickedSlide (e) {
    var swiper = this;
    var params = swiper.params;
    var slide = $(e.target).closest(("." + (params.slideClass)))[0];
    var slideFound = false;
    if (slide) {
      for (var i = 0; i < swiper.slides.length; i += 1) {
        if (swiper.slides[i] === slide) { slideFound = true; }
      }
    }

    if (slide && slideFound) {
      swiper.clickedSlide = slide;
      if (swiper.virtual && swiper.params.virtual.enabled) {
        swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
      } else {
        swiper.clickedIndex = $(slide).index();
      }
    } else {
      swiper.clickedSlide = undefined;
      swiper.clickedIndex = undefined;
      return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
      swiper.slideToClickedSlide();
    }
  }

  var update = {
    updateSize: updateSize,
    updateSlides: updateSlides,
    updateAutoHeight: updateAutoHeight,
    updateSlidesOffset: updateSlidesOffset,
    updateSlidesProgress: updateSlidesProgress,
    updateProgress: updateProgress,
    updateSlidesClasses: updateSlidesClasses,
    updateActiveIndex: updateActiveIndex,
    updateClickedSlide: updateClickedSlide,
  };

  function getTranslate (axis) {
    if ( axis === void 0 ) axis = this.isHorizontal() ? 'x' : 'y';

    var swiper = this;

    var params = swiper.params;
    var rtl = swiper.rtlTranslate;
    var translate = swiper.translate;
    var $wrapperEl = swiper.$wrapperEl;

    if (params.virtualTranslate) {
      return rtl ? -translate : translate;
    }

    var currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
    if (rtl) { currentTranslate = -currentTranslate; }

    return currentTranslate || 0;
  }

  function setTranslate (translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;

    if (swiper.isHorizontal()) {
      x = rtl ? -translate : translate;
    } else {
      y = translate;
    }

    if (params.roundLengths) {
      x = Math.floor(x);
      y = Math.floor(y);
    }

    if (!params.virtualTranslate) {
      if (Support.transforms3d) { $wrapperEl.transform(("translate3d(" + x + "px, " + y + "px, " + z + "px)")); }
      else { $wrapperEl.transform(("translate(" + x + "px, " + y + "px)")); }
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;

    // Check if we need to update progress
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) {
      newProgress = 0;
    } else {
      newProgress = (translate - swiper.minTranslate()) / (translatesDiff);
    }
    if (newProgress !== progress) {
      swiper.updateProgress(translate);
    }

    swiper.emit('setTranslate', swiper.translate, byController);
  }

  function minTranslate () {
    return (-this.snapGrid[0]);
  }

  function maxTranslate () {
    return (-this.snapGrid[this.snapGrid.length - 1]);
  }

  var translate = {
    getTranslate: getTranslate,
    setTranslate: setTranslate,
    minTranslate: minTranslate,
    maxTranslate: maxTranslate,
  };

  function setTransition (duration, byController) {
    var swiper = this;

    swiper.$wrapperEl.transition(duration);

    swiper.emit('setTransition', duration, byController);
  }

  function transitionStart (runCallbacks, direction) {
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var params = swiper.params;
    var previousIndex = swiper.previousIndex;
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    var dir = direction;
    if (!dir) {
      if (activeIndex > previousIndex) { dir = 'next'; }
      else if (activeIndex < previousIndex) { dir = 'prev'; }
      else { dir = 'reset'; }
    }

    swiper.emit('transitionStart');

    if (runCallbacks && activeIndex !== previousIndex) {
      if (dir === 'reset') {
        swiper.emit('slideResetTransitionStart');
        return;
      }
      swiper.emit('slideChangeTransitionStart');
      if (dir === 'next') {
        swiper.emit('slideNextTransitionStart');
      } else {
        swiper.emit('slidePrevTransitionStart');
      }
    }
  }

  function transitionEnd$1 (runCallbacks, direction) {
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var previousIndex = swiper.previousIndex;
    swiper.animating = false;
    swiper.setTransition(0);

    var dir = direction;
    if (!dir) {
      if (activeIndex > previousIndex) { dir = 'next'; }
      else if (activeIndex < previousIndex) { dir = 'prev'; }
      else { dir = 'reset'; }
    }

    swiper.emit('transitionEnd');

    if (runCallbacks && activeIndex !== previousIndex) {
      if (dir === 'reset') {
        swiper.emit('slideResetTransitionEnd');
        return;
      }
      swiper.emit('slideChangeTransitionEnd');
      if (dir === 'next') {
        swiper.emit('slideNextTransitionEnd');
      } else {
        swiper.emit('slidePrevTransitionEnd');
      }
    }
  }

  var transition$1 = {
    setTransition: setTransition,
    transitionStart: transitionStart,
    transitionEnd: transitionEnd$1,
  };

  function slideTo (index, speed, runCallbacks, internal) {
    if ( index === void 0 ) index = 0;
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var slideIndex = index;
    if (slideIndex < 0) { slideIndex = 0; }

    var params = swiper.params;
    var snapGrid = swiper.snapGrid;
    var slidesGrid = swiper.slidesGrid;
    var previousIndex = swiper.previousIndex;
    var activeIndex = swiper.activeIndex;
    var rtl = swiper.rtlTranslate;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return false;
    }

    var snapIndex = Math.floor(slideIndex / params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }

    if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
      swiper.emit('beforeSlideChangeStart');
    }

    var translate = -snapGrid[snapIndex];

    // Update progress
    swiper.updateProgress(translate);

    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
      for (var i = 0; i < slidesGrid.length; i += 1) {
        if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
          slideIndex = i;
        }
      }
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
      if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
        return false;
      }
      if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
        if ((activeIndex || 0) !== slideIndex) { return false; }
      }
    }

    var direction;
    if (slideIndex > activeIndex) { direction = 'next'; }
    else if (slideIndex < activeIndex) { direction = 'prev'; }
    else { direction = 'reset'; }


    // Update Index
    if ((rtl && -translate === swiper.translate) || (!rtl && translate === swiper.translate)) {
      swiper.updateActiveIndex(slideIndex);
      // Update Height
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
      swiper.updateSlidesClasses();
      if (params.effect !== 'slide') {
        swiper.setTranslate(translate);
      }
      if (direction !== 'reset') {
        swiper.transitionStart(runCallbacks, direction);
        swiper.transitionEnd(runCallbacks, direction);
      }
      return false;
    }

    if (speed === 0 || !Support.transition) {
      swiper.setTransition(0);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    } else {
      swiper.setTransition(speed);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) {
          swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) { return; }
            if (e.target !== this) { return; }
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
          };
        }
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
      }
    }

    return true;
  }

  function slideToLoop (index, speed, runCallbacks, internal) {
    if ( index === void 0 ) index = 0;
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var newIndex = index;
    if (swiper.params.loop) {
      newIndex += swiper.loopedSlides;
    }

    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideNext (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var params = swiper.params;
    var animating = swiper.animating;
    if (params.loop) {
      if (animating) { return false; }
      swiper.loopFix();
      // eslint-disable-next-line
      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
      return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
    }
    return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slidePrev (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var params = swiper.params;
    var animating = swiper.animating;
    var snapGrid = swiper.snapGrid;
    var slidesGrid = swiper.slidesGrid;
    var rtlTranslate = swiper.rtlTranslate;

    if (params.loop) {
      if (animating) { return false; }
      swiper.loopFix();
      // eslint-disable-next-line
      swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
      if (val < 0) { return -Math.floor(Math.abs(val)); }
      return Math.floor(val);
    }
    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function (val) { return normalize(val); });
    var normalizedSlidesGrid = slidesGrid.map(function (val) { return normalize(val); });

    var currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    var prevIndex;
    if (typeof prevSnap !== 'undefined') {
      prevIndex = slidesGrid.indexOf(prevSnap);
      if (prevIndex < 0) { prevIndex = swiper.activeIndex - 1; }
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideReset (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
  }

  /* eslint no-unused-vars: "off" */
  function slideToClosest (speed, runCallbacks, internal) {
    if ( speed === void 0 ) speed = this.params.speed;
    if ( runCallbacks === void 0 ) runCallbacks = true;

    var swiper = this;
    var index = swiper.activeIndex;
    var snapIndex = Math.floor(index / swiper.params.slidesPerGroup);

    if (snapIndex < swiper.snapGrid.length - 1) {
      var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

      var currentSnap = swiper.snapGrid[snapIndex];
      var nextSnap = swiper.snapGrid[snapIndex + 1];

      if ((translate - currentSnap) > (nextSnap - currentSnap) / 2) {
        index = swiper.params.slidesPerGroup;
      }
    }

    return swiper.slideTo(index, speed, runCallbacks, internal);
  }

  function slideToClickedSlide () {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;

    var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.clickedIndex;
    var realIndex;
    if (params.loop) {
      if (swiper.animating) { return; }
      realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
      if (params.centeredSlides) {
        if (
          (slideToIndex < swiper.loopedSlides - (slidesPerView / 2))
          || (slideToIndex > (swiper.slides.length - swiper.loopedSlides) + (slidesPerView / 2))
        ) {
          swiper.loopFix();
          slideToIndex = $wrapperEl
            .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
            .eq(0)
            .index();

          Utils.nextTick(function () {
            swiper.slideTo(slideToIndex);
          });
        } else {
          swiper.slideTo(slideToIndex);
        }
      } else if (slideToIndex > swiper.slides.length - slidesPerView) {
        swiper.loopFix();
        slideToIndex = $wrapperEl
          .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
          .eq(0)
          .index();

        Utils.nextTick(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else {
      swiper.slideTo(slideToIndex);
    }
  }

  var slide = {
    slideTo: slideTo,
    slideToLoop: slideToLoop,
    slideNext: slideNext,
    slidePrev: slidePrev,
    slideReset: slideReset,
    slideToClosest: slideToClosest,
    slideToClickedSlide: slideToClickedSlide,
  };

  function loopCreate () {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    // Remove duplicated slides
    $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass))).remove();

    var slides = $wrapperEl.children(("." + (params.slideClass)));

    if (params.loopFillGroupWithBlank) {
      var blankSlidesNum = params.slidesPerGroup - (slides.length % params.slidesPerGroup);
      if (blankSlidesNum !== params.slidesPerGroup) {
        for (var i = 0; i < blankSlidesNum; i += 1) {
          var blankNode = $(doc.createElement('div')).addClass(((params.slideClass) + " " + (params.slideBlankClass)));
          $wrapperEl.append(blankNode);
        }
        slides = $wrapperEl.children(("." + (params.slideClass)));
      }
    }

    if (params.slidesPerView === 'auto' && !params.loopedSlides) { params.loopedSlides = slides.length; }

    swiper.loopedSlides = parseInt(params.loopedSlides || params.slidesPerView, 10);
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length) {
      swiper.loopedSlides = slides.length;
    }

    var prependSlides = [];
    var appendSlides = [];
    slides.each(function (index, el) {
      var slide = $(el);
      if (index < swiper.loopedSlides) { appendSlides.push(el); }
      if (index < slides.length && index >= slides.length - swiper.loopedSlides) { prependSlides.push(el); }
      slide.attr('data-swiper-slide-index', index);
    });
    for (var i$1 = 0; i$1 < appendSlides.length; i$1 += 1) {
      $wrapperEl.append($(appendSlides[i$1].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
    for (var i$2 = prependSlides.length - 1; i$2 >= 0; i$2 -= 1) {
      $wrapperEl.prepend($(prependSlides[i$2].cloneNode(true)).addClass(params.slideDuplicateClass));
    }
  }

  function loopFix () {
    var swiper = this;
    var params = swiper.params;
    var activeIndex = swiper.activeIndex;
    var slides = swiper.slides;
    var loopedSlides = swiper.loopedSlides;
    var allowSlidePrev = swiper.allowSlidePrev;
    var allowSlideNext = swiper.allowSlideNext;
    var snapGrid = swiper.snapGrid;
    var rtl = swiper.rtlTranslate;
    var newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;

    var snapTranslate = -snapGrid[activeIndex];
    var diff = snapTranslate - swiper.getTranslate();


    // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
      newIndex = (slides.length - (loopedSlides * 3)) + activeIndex;
      newIndex += loopedSlides;
      var slideChanged = swiper.slideTo(newIndex, 0, false, true);
      if (slideChanged && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    } else if ((params.slidesPerView === 'auto' && activeIndex >= loopedSlides * 2) || (activeIndex >= slides.length - loopedSlides)) {
      // Fix For Positive Oversliding
      newIndex = -slides.length + activeIndex + loopedSlides;
      newIndex += loopedSlides;
      var slideChanged$1 = swiper.slideTo(newIndex, 0, false, true);
      if (slideChanged$1 && diff !== 0) {
        swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
  }

  function loopDestroy () {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    var slides = swiper.slides;
    $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + ",." + (params.slideClass) + "." + (params.slideBlankClass))).remove();
    slides.removeAttr('data-swiper-slide-index');
  }

  var loop = {
    loopCreate: loopCreate,
    loopFix: loopFix,
    loopDestroy: loopDestroy,
  };

  function setGrabCursor (moving) {
    var swiper = this;
    if (Support.touch || !swiper.params.simulateTouch || (swiper.params.watchOverflow && swiper.isLocked)) { return; }
    var el = swiper.el;
    el.style.cursor = 'move';
    el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
    el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
    el.style.cursor = moving ? 'grabbing' : 'grab';
  }

  function unsetGrabCursor () {
    var swiper = this;
    if (Support.touch || (swiper.params.watchOverflow && swiper.isLocked)) { return; }
    swiper.el.style.cursor = '';
  }

  var grabCursor = {
    setGrabCursor: setGrabCursor,
    unsetGrabCursor: unsetGrabCursor,
  };

  function appendSlide (slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    if (params.loop) {
      swiper.loopDestroy();
    }
    if (typeof slides === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) { $wrapperEl.append(slides[i]); }
      }
    } else {
      $wrapperEl.append(slides);
    }
    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
  }

  function prependSlide (slides) {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;

    if (params.loop) {
      swiper.loopDestroy();
    }
    var newActiveIndex = activeIndex + 1;
    if (typeof slides === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) { $wrapperEl.prepend(slides[i]); }
      }
      newActiveIndex = activeIndex + slides.length;
    } else {
      $wrapperEl.prepend(slides);
    }
    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    swiper.slideTo(newActiveIndex, 0, false);
  }

  function addSlide (index, slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var params = swiper.params;
    var activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
      activeIndexBuffer -= swiper.loopedSlides;
      swiper.loopDestroy();
      swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
    }
    var baseLength = swiper.slides.length;
    if (index <= 0) {
      swiper.prependSlide(slides);
      return;
    }
    if (index >= baseLength) {
      swiper.appendSlide(slides);
      return;
    }
    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;

    var slidesBuffer = [];
    for (var i = baseLength - 1; i >= index; i -= 1) {
      var currentSlide = swiper.slides.eq(i);
      currentSlide.remove();
      slidesBuffer.unshift(currentSlide);
    }

    if (typeof slides === 'object' && 'length' in slides) {
      for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
        if (slides[i$1]) { $wrapperEl.append(slides[i$1]); }
      }
      newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else {
      $wrapperEl.append(slides);
    }

    for (var i$2 = 0; i$2 < slidesBuffer.length; i$2 += 1) {
      $wrapperEl.append(slidesBuffer[i$2]);
    }

    if (params.loop) {
      swiper.loopCreate();
    }
    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    if (params.loop) {
      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
      swiper.slideTo(newActiveIndex, 0, false);
    }
  }

  function removeSlide (slidesIndexes) {
    var swiper = this;
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl;
    var activeIndex = swiper.activeIndex;

    var activeIndexBuffer = activeIndex;
    if (params.loop) {
      activeIndexBuffer -= swiper.loopedSlides;
      swiper.loopDestroy();
      swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
    }
    var newActiveIndex = activeIndexBuffer;
    var indexToRemove;

    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
      for (var i = 0; i < slidesIndexes.length; i += 1) {
        indexToRemove = slidesIndexes[i];
        if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
        if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
      }
      newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
      indexToRemove = slidesIndexes;
      if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
      if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
      newActiveIndex = Math.max(newActiveIndex, 0);
    }

    if (params.loop) {
      swiper.loopCreate();
    }

    if (!(params.observer && Support.observer)) {
      swiper.update();
    }
    if (params.loop) {
      swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    } else {
      swiper.slideTo(newActiveIndex, 0, false);
    }
  }

  function removeAllSlides () {
    var swiper = this;

    var slidesIndexes = [];
    for (var i = 0; i < swiper.slides.length; i += 1) {
      slidesIndexes.push(i);
    }
    swiper.removeSlide(slidesIndexes);
  }

  var manipulation = {
    appendSlide: appendSlide,
    prependSlide: prependSlide,
    addSlide: addSlide,
    removeSlide: removeSlide,
    removeAllSlides: removeAllSlides,
  };

  var Device = (function Device() {
    var ua = win.navigator.userAgent;

    var device = {
      ios: false,
      android: false,
      androidChrome: false,
      desktop: false,
      windows: false,
      iphone: false,
      ipod: false,
      ipad: false,
      cordova: win.cordova || win.phonegap,
      phonegap: win.cordova || win.phonegap,
    };

    var windows = ua.match(/(Windows Phone);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);


    // Windows
    if (windows) {
      device.os = 'windows';
      device.osVersion = windows[2];
      device.windows = true;
    }
    // Android
    if (android && !windows) {
      device.os = 'android';
      device.osVersion = android[2];
      device.android = true;
      device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
    }
    if (ipad || iphone || ipod) {
      device.os = 'ios';
      device.ios = true;
    }
    // iOS
    if (iphone && !ipod) {
      device.osVersion = iphone[2].replace(/_/g, '.');
      device.iphone = true;
    }
    if (ipad) {
      device.osVersion = ipad[2].replace(/_/g, '.');
      device.ipad = true;
    }
    if (ipod) {
      device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
      device.iphone = true;
    }
    // iOS 8+ changed UA
    if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
      if (device.osVersion.split('.')[0] === '10') {
        device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
      }
    }

    // Desktop
    device.desktop = !(device.os || device.android || device.webView);

    // Webview
    device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);

    // Minimal UI
    if (device.os && device.os === 'ios') {
      var osVersionArr = device.osVersion.split('.');
      var metaViewport = doc.querySelector('meta[name="viewport"]');
      device.minimalUi = !device.webView
        && (ipod || iphone)
        && (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7)
        && metaViewport && metaViewport.getAttribute('content').indexOf('minimal-ui') >= 0;
    }

    // Pixel Ratio
    device.pixelRatio = win.devicePixelRatio || 1;

    // Export object
    return device;
  }());

  function onTouchStart (event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params;
    var touches = swiper.touches;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return;
    }
    var e = event;
    if (e.originalEvent) { e = e.originalEvent; }
    data.isTouchEvent = e.type === 'touchstart';
    if (!data.isTouchEvent && 'which' in e && e.which === 3) { return; }
    if (!data.isTouchEvent && 'button' in e && e.button > 0) { return; }
    if (data.isTouched && data.isMoved) { return; }
    if (params.noSwiping && $(e.target).closest(params.noSwipingSelector ? params.noSwipingSelector : ("." + (params.noSwipingClass)))[0]) {
      swiper.allowClick = true;
      return;
    }
    if (params.swipeHandler) {
      if (!$(e).closest(params.swipeHandler)[0]) { return; }
    }

    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY;

    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore

    var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (
      edgeSwipeDetection
      && ((startX <= edgeSwipeThreshold)
      || (startX >= win.screen.width - edgeSwipeThreshold))
    ) {
      return;
    }

    Utils.extend(data, {
      isTouched: true,
      isMoved: false,
      allowTouchCallbacks: true,
      isScrolling: undefined,
      startMoving: undefined,
    });

    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = Utils.now();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) { data.allowThresholdMove = false; }
    if (e.type !== 'touchstart') {
      var preventDefault = true;
      if ($(e.target).is(data.formElements)) { preventDefault = false; }
      if (
        doc.activeElement
        && $(doc.activeElement).is(data.formElements)
        && doc.activeElement !== e.target
      ) {
        doc.activeElement.blur();
      }

      var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
      if (params.touchStartForcePreventDefault || shouldPreventDefault) {
        e.preventDefault();
      }
    }
    swiper.emit('touchStart', e);
  }

  function onTouchMove (event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params;
    var touches = swiper.touches;
    var rtl = swiper.rtlTranslate;
    var e = event;
    if (e.originalEvent) { e = e.originalEvent; }
    if (!data.isTouched) {
      if (data.startMoving && data.isScrolling) {
        swiper.emit('touchMoveOpposite', e);
      }
      return;
    }
    if (data.isTouchEvent && e.type === 'mousemove') { return; }
    var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
    var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
      touches.startX = pageX;
      touches.startY = pageY;
      return;
    }
    if (!swiper.allowTouchMove) {
      // isMoved = true;
      swiper.allowClick = false;
      if (data.isTouched) {
        Utils.extend(touches, {
          startX: pageX,
          startY: pageY,
          currentX: pageX,
          currentY: pageY,
        });
        data.touchStartTime = Utils.now();
      }
      return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
      if (swiper.isVertical()) {
        // Vertical
        if (
          (pageY < touches.startY && swiper.translate <= swiper.maxTranslate())
          || (pageY > touches.startY && swiper.translate >= swiper.minTranslate())
        ) {
          data.isTouched = false;
          data.isMoved = false;
          return;
        }
      } else if (
        (pageX < touches.startX && swiper.translate <= swiper.maxTranslate())
        || (pageX > touches.startX && swiper.translate >= swiper.minTranslate())
      ) {
        return;
      }
    }
    if (data.isTouchEvent && doc.activeElement) {
      if (e.target === doc.activeElement && $(e.target).is(data.formElements)) {
        data.isMoved = true;
        swiper.allowClick = false;
        return;
      }
    }
    if (data.allowTouchCallbacks) {
      swiper.emit('touchMove', e);
    }
    if (e.targetTouches && e.targetTouches.length > 1) { return; }

    touches.currentX = pageX;
    touches.currentY = pageY;

    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt((Math.pow( diffX, 2 )) + (Math.pow( diffY, 2 ))) < swiper.params.threshold) { return; }

    if (typeof data.isScrolling === 'undefined') {
      var touchAngle;
      if ((swiper.isHorizontal() && touches.currentY === touches.startY) || (swiper.isVertical() && touches.currentX === touches.startX)) {
        data.isScrolling = false;
      } else {
        // eslint-disable-next-line
        if ((diffX * diffX) + (diffY * diffY) >= 25) {
          touchAngle = (Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180) / Math.PI;
          data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : (90 - touchAngle > params.touchAngle);
        }
      }
    }
    if (data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }
    if (typeof data.startMoving === 'undefined') {
      if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
        data.startMoving = true;
      }
    }
    if (data.isScrolling) {
      data.isTouched = false;
      return;
    }
    if (!data.startMoving) {
      return;
    }
    swiper.allowClick = false;
    e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) {
      e.stopPropagation();
    }

    if (!data.isMoved) {
      if (params.loop) {
        swiper.loopFix();
      }
      data.startTranslate = swiper.getTranslate();
      swiper.setTransition(0);
      if (swiper.animating) {
        swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
      }
      data.allowMomentumBounce = false;
      // Grab Cursor
      if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
        swiper.setGrabCursor(true);
      }
      swiper.emit('sliderFirstMove', e);
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;

    var diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;

    diff *= params.touchRatio;
    if (rtl) { diff = -diff; }

    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    data.currentTranslate = diff + data.startTranslate;

    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) {
      resistanceRatio = 0;
    }
    if ((diff > 0 && data.currentTranslate > swiper.minTranslate())) {
      disableParentSwiper = false;
      if (params.resistance) { data.currentTranslate = (swiper.minTranslate() - 1) + (Math.pow( (-swiper.minTranslate() + data.startTranslate + diff), resistanceRatio )); }
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) { data.currentTranslate = (swiper.maxTranslate() + 1) - (Math.pow( (swiper.maxTranslate() - data.startTranslate - diff), resistanceRatio )); }
    }

    if (disableParentSwiper) {
      e.preventedByNestedSwiper = true;
    }

    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }


    // Threshold
    if (params.threshold > 0) {
      if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
        if (!data.allowThresholdMove) {
          data.allowThresholdMove = true;
          touches.startX = touches.currentX;
          touches.startY = touches.currentY;
          data.currentTranslate = data.startTranslate;
          touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
          return;
        }
      } else {
        data.currentTranslate = data.startTranslate;
        return;
      }
    }

    if (!params.followFinger) { return; }

    // Update active index in free mode
    if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    if (params.freeMode) {
      // Velocity
      if (data.velocities.length === 0) {
        data.velocities.push({
          position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
          time: data.touchStartTime,
        });
      }
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
        time: Utils.now(),
      });
    }
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
  }

  function onTouchEnd (event) {
    var swiper = this;
    var data = swiper.touchEventsData;

    var params = swiper.params;
    var touches = swiper.touches;
    var rtl = swiper.rtlTranslate;
    var $wrapperEl = swiper.$wrapperEl;
    var slidesGrid = swiper.slidesGrid;
    var snapGrid = swiper.snapGrid;
    var e = event;
    if (e.originalEvent) { e = e.originalEvent; }
    if (data.allowTouchCallbacks) {
      swiper.emit('touchEnd', e);
    }
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
      if (data.isMoved && params.grabCursor) {
        swiper.setGrabCursor(false);
      }
      data.isMoved = false;
      data.startMoving = false;
      return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(false);
    }

    // Time diff
    var touchEndTime = Utils.now();
    var timeDiff = touchEndTime - data.touchStartTime;

    // Tap, doubleTap, Click
    if (swiper.allowClick) {
      swiper.updateClickedSlide(e);
      swiper.emit('tap', e);
      if (timeDiff < 300 && (touchEndTime - data.lastClickTime) > 300) {
        if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
        data.clickTimeout = Utils.nextTick(function () {
          if (!swiper || swiper.destroyed) { return; }
          swiper.emit('click', e);
        }, 300);
      }
      if (timeDiff < 300 && (touchEndTime - data.lastClickTime) < 300) {
        if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
        swiper.emit('doubleTap', e);
      }
    }

    data.lastClickTime = Utils.now();
    Utils.nextTick(function () {
      if (!swiper.destroyed) { swiper.allowClick = true; }
    });

    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
      data.isTouched = false;
      data.isMoved = false;
      data.startMoving = false;
      return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;

    var currentPos;
    if (params.followFinger) {
      currentPos = rtl ? swiper.translate : -swiper.translate;
    } else {
      currentPos = -data.currentTranslate;
    }

    if (params.freeMode) {
      if (currentPos < -swiper.minTranslate()) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (currentPos > -swiper.maxTranslate()) {
        if (swiper.slides.length < snapGrid.length) {
          swiper.slideTo(snapGrid.length - 1);
        } else {
          swiper.slideTo(swiper.slides.length - 1);
        }
        return;
      }

      if (params.freeModeMomentum) {
        if (data.velocities.length > 1) {
          var lastMoveEvent = data.velocities.pop();
          var velocityEvent = data.velocities.pop();

          var distance = lastMoveEvent.position - velocityEvent.position;
          var time = lastMoveEvent.time - velocityEvent.time;
          swiper.velocity = distance / time;
          swiper.velocity /= 2;
          if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
            swiper.velocity = 0;
          }
          // this implies that the user stopped moving a finger then released.
          // There would be no events with distance zero, so the last event is stale.
          if (time > 150 || (Utils.now() - lastMoveEvent.time) > 300) {
            swiper.velocity = 0;
          }
        } else {
          swiper.velocity = 0;
        }
        swiper.velocity *= params.freeModeMomentumVelocityRatio;

        data.velocities.length = 0;
        var momentumDuration = 1000 * params.freeModeMomentumRatio;
        var momentumDistance = swiper.velocity * momentumDuration;

        var newPosition = swiper.translate + momentumDistance;
        if (rtl) { newPosition = -newPosition; }

        var doBounce = false;
        var afterBouncePosition;
        var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
        var needsLoopFix;
        if (newPosition < swiper.maxTranslate()) {
          if (params.freeModeMomentumBounce) {
            if (newPosition + swiper.maxTranslate() < -bounceAmount) {
              newPosition = swiper.maxTranslate() - bounceAmount;
            }
            afterBouncePosition = swiper.maxTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.maxTranslate();
          }
          if (params.loop && params.centeredSlides) { needsLoopFix = true; }
        } else if (newPosition > swiper.minTranslate()) {
          if (params.freeModeMomentumBounce) {
            if (newPosition - swiper.minTranslate() > bounceAmount) {
              newPosition = swiper.minTranslate() + bounceAmount;
            }
            afterBouncePosition = swiper.minTranslate();
            doBounce = true;
            data.allowMomentumBounce = true;
          } else {
            newPosition = swiper.minTranslate();
          }
          if (params.loop && params.centeredSlides) { needsLoopFix = true; }
        } else if (params.freeModeSticky) {
          var nextSlide;
          for (var j = 0; j < snapGrid.length; j += 1) {
            if (snapGrid[j] > -newPosition) {
              nextSlide = j;
              break;
            }
          }

          if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
            newPosition = snapGrid[nextSlide];
          } else {
            newPosition = snapGrid[nextSlide - 1];
          }
          newPosition = -newPosition;
        }
        if (needsLoopFix) {
          swiper.once('transitionEnd', function () {
            swiper.loopFix();
          });
        }
        // Fix duration
        if (swiper.velocity !== 0) {
          if (rtl) {
            momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
          } else {
            momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
          }
        } else if (params.freeModeSticky) {
          swiper.slideToClosest();
          return;
        }

        if (params.freeModeMomentumBounce && doBounce) {
          swiper.updateProgress(afterBouncePosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);
          swiper.animating = true;
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed || !data.allowMomentumBounce) { return; }
            swiper.emit('momentumBounce');

            swiper.setTransition(params.speed);
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) { return; }
              swiper.transitionEnd();
            });
          });
        } else if (swiper.velocity) {
          swiper.updateProgress(newPosition);
          swiper.setTransition(momentumDuration);
          swiper.setTranslate(newPosition);
          swiper.transitionStart(true, swiper.swipeDirection);
          if (!swiper.animating) {
            swiper.animating = true;
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed) { return; }
              swiper.transitionEnd();
            });
          }
        } else {
          swiper.updateProgress(newPosition);
        }

        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      }

      if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      return;
    }

    // Find current slide
    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];
    for (var i = 0; i < slidesGrid.length; i += params.slidesPerGroup) {
      if (typeof slidesGrid[i + params.slidesPerGroup] !== 'undefined') {
        if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + params.slidesPerGroup]) {
          stopIndex = i;
          groupSize = slidesGrid[i + params.slidesPerGroup] - slidesGrid[i];
        }
      } else if (currentPos >= slidesGrid[i]) {
        stopIndex = i;
        groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
      }
    }

    // Find current slide size
    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;

    if (timeDiff > params.longSwipesMs) {
      // Long touches
      if (!params.longSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (swiper.swipeDirection === 'next') {
        if (ratio >= params.longSwipesRatio) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
        else { swiper.slideTo(stopIndex); }
      }
      if (swiper.swipeDirection === 'prev') {
        if (ratio > (1 - params.longSwipesRatio)) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
        else { swiper.slideTo(stopIndex); }
      }
    } else {
      // Short swipes
      if (!params.shortSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(stopIndex + params.slidesPerGroup);
      }
      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(stopIndex);
      }
    }
  }

  function onResize () {
    var swiper = this;

    var params = swiper.params;
    var el = swiper.el;

    if (el && el.offsetWidth === 0) { return; }

    // Breakpoints
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }

    // Save locks
    var allowSlideNext = swiper.allowSlideNext;
    var allowSlidePrev = swiper.allowSlidePrev;
    var snapGrid = swiper.snapGrid;

    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;

    swiper.updateSize();
    swiper.updateSlides();

    if (params.freeMode) {
      var newTranslate = Math.min(Math.max(swiper.translate, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();

      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      swiper.updateSlidesClasses();
      if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
    }
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
      swiper.autoplay.run();
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;

    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
  }

  function onClick (e) {
    var swiper = this;
    if (!swiper.allowClick) {
      if (swiper.params.preventClicks) { e.preventDefault(); }
      if (swiper.params.preventClicksPropagation && swiper.animating) {
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }
  }

  function attachEvents() {
    var swiper = this;
    var params = swiper.params;
    var touchEvents = swiper.touchEvents;
    var el = swiper.el;
    var wrapperEl = swiper.wrapperEl;

    {
      swiper.onTouchStart = onTouchStart.bind(swiper);
      swiper.onTouchMove = onTouchMove.bind(swiper);
      swiper.onTouchEnd = onTouchEnd.bind(swiper);
    }

    swiper.onClick = onClick.bind(swiper);

    var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
    var capture = !!params.nested;

    // Touch Events
    {
      if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        target.addEventListener(touchEvents.start, swiper.onTouchStart, false);
        doc.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
        doc.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
      } else {
        if (Support.touch) {
          var passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
          target.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
          target.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? { passive: false, capture: capture } : capture);
          target.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
        }
        if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
          target.addEventListener('mousedown', swiper.onTouchStart, false);
          doc.addEventListener('mousemove', swiper.onTouchMove, capture);
          doc.addEventListener('mouseup', swiper.onTouchEnd, false);
        }
      }
      // Prevent Links Clicks
      if (params.preventClicks || params.preventClicksPropagation) {
        target.addEventListener('click', swiper.onClick, true);
      }
    }

    // Resize handler
    swiper.on((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize, true);
  }

  function detachEvents() {
    var swiper = this;

    var params = swiper.params;
    var touchEvents = swiper.touchEvents;
    var el = swiper.el;
    var wrapperEl = swiper.wrapperEl;

    var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
    var capture = !!params.nested;

    // Touch Events
    {
      if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        target.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
        doc.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
        doc.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
      } else {
        if (Support.touch) {
          var passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
          target.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
          target.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
          target.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
        }
        if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
          target.removeEventListener('mousedown', swiper.onTouchStart, false);
          doc.removeEventListener('mousemove', swiper.onTouchMove, capture);
          doc.removeEventListener('mouseup', swiper.onTouchEnd, false);
        }
      }
      // Prevent Links Clicks
      if (params.preventClicks || params.preventClicksPropagation) {
        target.removeEventListener('click', swiper.onClick, true);
      }
    }

    // Resize handler
    swiper.off((Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate'), onResize);
  }

  var events = {
    attachEvents: attachEvents,
    detachEvents: detachEvents,
  };

  function setBreakpoint () {
    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var initialized = swiper.initialized;
    var loopedSlides = swiper.loopedSlides; if ( loopedSlides === void 0 ) loopedSlides = 0;
    var params = swiper.params;
    var breakpoints = params.breakpoints;
    if (!breakpoints || (breakpoints && Object.keys(breakpoints).length === 0)) { return; }

    // Set breakpoint for window width and update parameters
    var breakpoint = swiper.getBreakpoint(breakpoints);

    if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
      var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
      if (breakpointOnlyParams) {
        ['slidesPerView', 'spaceBetween', 'slidesPerGroup'].forEach(function (param) {
          var paramValue = breakpointOnlyParams[param];
          if (typeof paramValue === 'undefined') { return; }
          if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
            breakpointOnlyParams[param] = 'auto';
          } else if (param === 'slidesPerView') {
            breakpointOnlyParams[param] = parseFloat(paramValue);
          } else {
            breakpointOnlyParams[param] = parseInt(paramValue, 10);
          }
        });
      }

      var breakpointParams = breakpointOnlyParams || swiper.originalParams;
      var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
      var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

      if (directionChanged && initialized) {
        swiper.changeDirection();
      }

      Utils.extend(swiper.params, breakpointParams);

      Utils.extend(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,
      });

      swiper.currentBreakpoint = breakpoint;

      if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo((activeIndex - loopedSlides) + swiper.loopedSlides, 0, false);
      }

      swiper.emit('breakpoint', breakpointParams);
    }
  }

  function getBreakpoint (breakpoints) {
    var swiper = this;
    // Get breakpoint for window width
    if (!breakpoints) { return undefined; }
    var breakpoint = false;
    var points = [];
    Object.keys(breakpoints).forEach(function (point) {
      points.push(point);
    });
    points.sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });
    for (var i = 0; i < points.length; i += 1) {
      var point = points[i];
      if (swiper.params.breakpointsInverse) {
        if (point <= win.innerWidth) {
          breakpoint = point;
        }
      } else if (point >= win.innerWidth && !breakpoint) {
        breakpoint = point;
      }
    }
    return breakpoint || 'max';
  }

  var breakpoints = { setBreakpoint: setBreakpoint, getBreakpoint: getBreakpoint };

  function addClasses () {
    var swiper = this;
    var classNames = swiper.classNames;
    var params = swiper.params;
    var rtl = swiper.rtl;
    var $el = swiper.$el;
    var suffixes = [];

    suffixes.push('initialized');
    suffixes.push(params.direction);

    if (params.freeMode) {
      suffixes.push('free-mode');
    }
    if (!Support.flexbox) {
      suffixes.push('no-flexbox');
    }
    if (params.autoHeight) {
      suffixes.push('autoheight');
    }
    if (rtl) {
      suffixes.push('rtl');
    }
    if (params.slidesPerColumn > 1) {
      suffixes.push('multirow');
    }
    if (Device.android) {
      suffixes.push('android');
    }
    if (Device.ios) {
      suffixes.push('ios');
    }
    // WP8 Touch Events Fix
    if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
      suffixes.push(("wp8-" + (params.direction)));
    }

    suffixes.forEach(function (suffix) {
      classNames.push(params.containerModifierClass + suffix);
    });

    $el.addClass(classNames.join(' '));
  }

  function removeClasses () {
    var swiper = this;
    var $el = swiper.$el;
    var classNames = swiper.classNames;

    $el.removeClass(classNames.join(' '));
  }

  var classes = { addClasses: addClasses, removeClasses: removeClasses };

  function loadImage (imageEl, src, srcset, sizes, checkForComplete, callback) {
    var image;
    function onReady() {
      if (callback) { callback(); }
    }
    if (!imageEl.complete || !checkForComplete) {
      if (src) {
        image = new win.Image();
        image.onload = onReady;
        image.onerror = onReady;
        if (sizes) {
          image.sizes = sizes;
        }
        if (srcset) {
          image.srcset = srcset;
        }
        if (src) {
          image.src = src;
        }
      } else {
        onReady();
      }
    } else {
      // image already loaded...
      onReady();
    }
  }

  function preloadImages () {
    var swiper = this;
    swiper.imagesToLoad = swiper.$el.find('img');
    function onReady() {
      if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) { return; }
      if (swiper.imagesLoaded !== undefined) { swiper.imagesLoaded += 1; }
      if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
        if (swiper.params.updateOnImagesReady) { swiper.update(); }
        swiper.emit('imagesReady');
      }
    }
    for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
      var imageEl = swiper.imagesToLoad[i];
      swiper.loadImage(
        imageEl,
        imageEl.currentSrc || imageEl.getAttribute('src'),
        imageEl.srcset || imageEl.getAttribute('srcset'),
        imageEl.sizes || imageEl.getAttribute('sizes'),
        true,
        onReady
      );
    }
  }

  var images = {
    loadImage: loadImage,
    preloadImages: preloadImages,
  };

  function checkOverflow() {
    var swiper = this;
    var wasLocked = swiper.isLocked;

    swiper.isLocked = swiper.snapGrid.length === 1;
    swiper.allowSlideNext = !swiper.isLocked;
    swiper.allowSlidePrev = !swiper.isLocked;

    // events
    if (wasLocked !== swiper.isLocked) { swiper.emit(swiper.isLocked ? 'lock' : 'unlock'); }

    if (wasLocked && wasLocked !== swiper.isLocked) {
      swiper.isEnd = false;
      swiper.navigation.update();
    }
  }

  var checkOverflow$1 = { checkOverflow: checkOverflow };

  var defaults = {
    init: true,
    direction: 'horizontal',
    touchEventsTarget: 'container',
    initialSlide: 0,
    speed: 300,
    //
    preventInteractionOnTransition: false,

    // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,

    // Free mode
    freeMode: false,
    freeModeMomentum: true,
    freeModeMomentumRatio: 1,
    freeModeMomentumBounce: true,
    freeModeMomentumBounceRatio: 1,
    freeModeMomentumVelocityRatio: 1,
    freeModeSticky: false,
    freeModeMinimumVelocity: 0.02,

    // Autoheight
    autoHeight: false,

    // Set wrapper width
    setWrapperSize: false,

    // Virtual Translate
    virtualTranslate: false,

    // Effects
    effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

    // Breakpoints
    breakpoints: undefined,
    breakpointsInverse: false,

    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerColumn: 1,
    slidesPerColumnFill: 'column',
    slidesPerGroup: 1,
    centeredSlides: false,
    slidesOffsetBefore: 0, // in px
    slidesOffsetAfter: 0, // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,

    // Disable swiper and hide navigation when container not overflow
    watchOverflow: false,

    // Round length
    roundLengths: false,

    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: true,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,

    // Unique Navigation Elements
    uniqueNavElements: true,

    // Resistance
    resistance: true,
    resistanceRatio: 0.85,

    // Progress
    watchSlidesProgress: false,
    watchSlidesVisibility: false,

    // Cursor
    grabCursor: false,

    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,

    // Images
    preloadImages: true,
    updateOnImagesReady: true,

    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: false,

    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null, // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,

    // Passive Listeners
    passiveListeners: true,

    // NS
    containerModifierClass: 'swiper-container-', // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-invisible-blank',
    slideActiveClass: 'swiper-slide-active',
    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideDuplicateClass: 'swiper-slide-duplicate',
    slideNextClass: 'swiper-slide-next',
    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
    slidePrevClass: 'swiper-slide-prev',
    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
    wrapperClass: 'swiper-wrapper',

    // Callbacks
    runCallbacksOnInit: true,
  };

  /* eslint no-param-reassign: "off" */

  var prototypes = {
    update: update,
    translate: translate,
    transition: transition$1,
    slide: slide,
    loop: loop,
    grabCursor: grabCursor,
    manipulation: manipulation,
    events: events,
    breakpoints: breakpoints,
    checkOverflow: checkOverflow$1,
    classes: classes,
    images: images,
  };

  var extendedDefaults = {};

  var Swiper = /*@__PURE__*/(function (SwiperClass) {
    function Swiper() {
      var assign;

      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];
      var el;
      var params;
      if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
        params = args[0];
      } else {
        (assign = args, el = assign[0], params = assign[1]);
      }
      if (!params) { params = {}; }

      params = Utils.extend({}, params);
      if (el && !params.el) { params.el = el; }

      SwiperClass.call(this, params);

      Object.keys(prototypes).forEach(function (prototypeGroup) {
        Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
          if (!Swiper.prototype[protoMethod]) {
            Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
          }
        });
      });

      // Swiper Instance
      var swiper = this;
      if (typeof swiper.modules === 'undefined') {
        swiper.modules = {};
      }
      Object.keys(swiper.modules).forEach(function (moduleName) {
        var module = swiper.modules[moduleName];
        if (module.params) {
          var moduleParamName = Object.keys(module.params)[0];
          var moduleParams = module.params[moduleParamName];
          if (typeof moduleParams !== 'object' || moduleParams === null) { return; }
          if (!(moduleParamName in params && 'enabled' in moduleParams)) { return; }
          if (params[moduleParamName] === true) {
            params[moduleParamName] = { enabled: true };
          }
          if (
            typeof params[moduleParamName] === 'object'
            && !('enabled' in params[moduleParamName])
          ) {
            params[moduleParamName].enabled = true;
          }
          if (!params[moduleParamName]) { params[moduleParamName] = { enabled: false }; }
        }
      });

      // Extend defaults with modules params
      var swiperParams = Utils.extend({}, defaults);
      swiper.useModulesParams(swiperParams);

      // Extend defaults with passed params
      swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
      swiper.originalParams = Utils.extend({}, swiper.params);
      swiper.passedParams = Utils.extend({}, params);

      // Save Dom lib
      swiper.$ = $;

      // Find el
      var $el = $(swiper.params.el);
      el = $el[0];

      if (!el) {
        return undefined;
      }

      if ($el.length > 1) {
        var swipers = [];
        $el.each(function (index, containerEl) {
          var newParams = Utils.extend({}, params, { el: containerEl });
          swipers.push(new Swiper(newParams));
        });
        return swipers;
      }

      el.swiper = swiper;
      $el.data('swiper', swiper);

      // Find Wrapper
      var $wrapperEl = $el.children(("." + (swiper.params.wrapperClass)));

      // Extend Swiper
      Utils.extend(swiper, {
        $el: $el,
        el: el,
        $wrapperEl: $wrapperEl,
        wrapperEl: $wrapperEl[0],

        // Classes
        classNames: [],

        // Slides
        slides: $(),
        slidesGrid: [],
        snapGrid: [],
        slidesSizesGrid: [],

        // isDirection
        isHorizontal: function isHorizontal() {
          return swiper.params.direction === 'horizontal';
        },
        isVertical: function isVertical() {
          return swiper.params.direction === 'vertical';
        },
        // RTL
        rtl: (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
        rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
        wrongRTL: $wrapperEl.css('display') === '-webkit-box',

        // Indexes
        activeIndex: 0,
        realIndex: 0,

        //
        isBeginning: true,
        isEnd: false,

        // Props
        translate: 0,
        previousTranslate: 0,
        progress: 0,
        velocity: 0,
        animating: false,

        // Locks
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,

        // Touch Events
        touchEvents: (function touchEvents() {
          var touch = ['touchstart', 'touchmove', 'touchend'];
          var desktop = ['mousedown', 'mousemove', 'mouseup'];
          if (Support.pointerEvents) {
            desktop = ['pointerdown', 'pointermove', 'pointerup'];
          } else if (Support.prefixedPointerEvents) {
            desktop = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp'];
          }
          swiper.touchEventsTouch = {
            start: touch[0],
            move: touch[1],
            end: touch[2],
          };
          swiper.touchEventsDesktop = {
            start: desktop[0],
            move: desktop[1],
            end: desktop[2],
          };
          return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
        }()),
        touchEventsData: {
          isTouched: undefined,
          isMoved: undefined,
          allowTouchCallbacks: undefined,
          touchStartTime: undefined,
          isScrolling: undefined,
          currentTranslate: undefined,
          startTranslate: undefined,
          allowThresholdMove: undefined,
          // Form elements to match
          formElements: 'input, select, option, textarea, button, video',
          // Last click time
          lastClickTime: Utils.now(),
          clickTimeout: undefined,
          // Velocities
          velocities: [],
          allowMomentumBounce: undefined,
          isTouchEvent: undefined,
          startMoving: undefined,
        },

        // Clicks
        allowClick: true,

        // Touches
        allowTouchMove: swiper.params.allowTouchMove,

        touches: {
          startX: 0,
          startY: 0,
          currentX: 0,
          currentY: 0,
          diff: 0,
        },

        // Images
        imagesToLoad: [],
        imagesLoaded: 0,

      });

      // Install Modules
      swiper.useModules();

      // Init
      if (swiper.params.init) {
        swiper.init();
      }

      // Return app instance
      return swiper;
    }

    if ( SwiperClass ) Swiper.__proto__ = SwiperClass;
    Swiper.prototype = Object.create( SwiperClass && SwiperClass.prototype );
    Swiper.prototype.constructor = Swiper;

    var staticAccessors = { extendedDefaults: { configurable: true },defaults: { configurable: true },Class: { configurable: true },$: { configurable: true } };

    Swiper.prototype.slidesPerViewDynamic = function slidesPerViewDynamic () {
      var swiper = this;
      var params = swiper.params;
      var slides = swiper.slides;
      var slidesGrid = swiper.slidesGrid;
      var swiperSize = swiper.size;
      var activeIndex = swiper.activeIndex;
      var spv = 1;
      if (params.centeredSlides) {
        var slideSize = slides[activeIndex].swiperSlideSize;
        var breakLoop;
        for (var i = activeIndex + 1; i < slides.length; i += 1) {
          if (slides[i] && !breakLoop) {
            slideSize += slides[i].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) { breakLoop = true; }
          }
        }
        for (var i$1 = activeIndex - 1; i$1 >= 0; i$1 -= 1) {
          if (slides[i$1] && !breakLoop) {
            slideSize += slides[i$1].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) { breakLoop = true; }
          }
        }
      } else {
        for (var i$2 = activeIndex + 1; i$2 < slides.length; i$2 += 1) {
          if (slidesGrid[i$2] - slidesGrid[activeIndex] < swiperSize) {
            spv += 1;
          }
        }
      }
      return spv;
    };

    Swiper.prototype.update = function update () {
      var swiper = this;
      if (!swiper || swiper.destroyed) { return; }
      var snapGrid = swiper.snapGrid;
      var params = swiper.params;
      // Breakpoints
      if (params.breakpoints) {
        swiper.setBreakpoint();
      }
      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      function setTranslate() {
        var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
        var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      var translated;
      if (swiper.params.freeMode) {
        setTranslate();
        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      } else {
        if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
          translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
        } else {
          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
        }
        if (!translated) {
          setTranslate();
        }
      }
      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
      swiper.emit('update');
    };

    Swiper.prototype.changeDirection = function changeDirection (newDirection, needUpdate) {
      if ( needUpdate === void 0 ) needUpdate = true;

      var swiper = this;
      var currentDirection = swiper.params.direction;
      if (!newDirection) {
        // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
      }
      if ((newDirection === currentDirection) || (newDirection !== 'horizontal' && newDirection !== 'vertical')) {
        return swiper;
      }

      swiper.$el
        .removeClass(("" + (swiper.params.containerModifierClass) + currentDirection + " wp8-" + currentDirection))
        .addClass(("" + (swiper.params.containerModifierClass) + newDirection));

      if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        swiper.$el.addClass(((swiper.params.containerModifierClass) + "wp8-" + newDirection));
      }

      swiper.params.direction = newDirection;

      swiper.slides.each(function (slideIndex, slideEl) {
        if (newDirection === 'vertical') {
          slideEl.style.width = '';
        } else {
          slideEl.style.height = '';
        }
      });

      swiper.emit('changeDirection');
      if (needUpdate) { swiper.update(); }

      return swiper;
    };

    Swiper.prototype.init = function init () {
      var swiper = this;
      if (swiper.initialized) { return; }

      swiper.emit('beforeInit');

      // Set breakpoint
      if (swiper.params.breakpoints) {
        swiper.setBreakpoint();
      }

      // Add Classes
      swiper.addClasses();

      // Create loop
      if (swiper.params.loop) {
        swiper.loopCreate();
      }

      // Update size
      swiper.updateSize();

      // Update slides
      swiper.updateSlides();

      if (swiper.params.watchOverflow) {
        swiper.checkOverflow();
      }

      // Set Grab Cursor
      if (swiper.params.grabCursor) {
        swiper.setGrabCursor();
      }

      if (swiper.params.preloadImages) {
        swiper.preloadImages();
      }

      // Slide To Initial Slide
      if (swiper.params.loop) {
        swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
      } else {
        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
      }

      // Attach events
      swiper.attachEvents();

      // Init Flag
      swiper.initialized = true;

      // Emit
      swiper.emit('init');
    };

    Swiper.prototype.destroy = function destroy (deleteInstance, cleanStyles) {
      if ( deleteInstance === void 0 ) deleteInstance = true;
      if ( cleanStyles === void 0 ) cleanStyles = true;

      var swiper = this;
      var params = swiper.params;
      var $el = swiper.$el;
      var $wrapperEl = swiper.$wrapperEl;
      var slides = swiper.slides;

      if (typeof swiper.params === 'undefined' || swiper.destroyed) {
        return null;
      }

      swiper.emit('beforeDestroy');

      // Init Flag
      swiper.initialized = false;

      // Detach events
      swiper.detachEvents();

      // Destroy loop
      if (params.loop) {
        swiper.loopDestroy();
      }

      // Cleanup styles
      if (cleanStyles) {
        swiper.removeClasses();
        $el.removeAttr('style');
        $wrapperEl.removeAttr('style');
        if (slides && slides.length) {
          slides
            .removeClass([
              params.slideVisibleClass,
              params.slideActiveClass,
              params.slideNextClass,
              params.slidePrevClass ].join(' '))
            .removeAttr('style')
            .removeAttr('data-swiper-slide-index')
            .removeAttr('data-swiper-column')
            .removeAttr('data-swiper-row');
        }
      }

      swiper.emit('destroy');

      // Detach emitter events
      Object.keys(swiper.eventsListeners).forEach(function (eventName) {
        swiper.off(eventName);
      });

      if (deleteInstance !== false) {
        swiper.$el[0].swiper = null;
        swiper.$el.data('swiper', null);
        Utils.deleteProps(swiper);
      }
      swiper.destroyed = true;

      return null;
    };

    Swiper.extendDefaults = function extendDefaults (newDefaults) {
      Utils.extend(extendedDefaults, newDefaults);
    };

    staticAccessors.extendedDefaults.get = function () {
      return extendedDefaults;
    };

    staticAccessors.defaults.get = function () {
      return defaults;
    };

    staticAccessors.Class.get = function () {
      return SwiperClass;
    };

    staticAccessors.$.get = function () {
      return $;
    };

    Object.defineProperties( Swiper, staticAccessors );

    return Swiper;
  }(SwiperClass));

  var Device$1 = {
    name: 'device',
    proto: {
      device: Device,
    },
    static: {
      device: Device,
    },
  };

  var Support$1 = {
    name: 'support',
    proto: {
      support: Support,
    },
    static: {
      support: Support,
    },
  };

  var Browser$1 = {
    name: 'browser',
    proto: {
      browser: Browser,
    },
    static: {
      browser: Browser,
    },
  };

  var Resize = {
    name: 'resize',
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        resize: {
          resizeHandler: function resizeHandler() {
            if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
            swiper.emit('beforeResize');
            swiper.emit('resize');
          },
          orientationChangeHandler: function orientationChangeHandler() {
            if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
            swiper.emit('orientationchange');
          },
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        // Emit resize
        win.addEventListener('resize', swiper.resize.resizeHandler);

        // Emit orientationchange
        win.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
      },
      destroy: function destroy() {
        var swiper = this;
        win.removeEventListener('resize', swiper.resize.resizeHandler);
        win.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
      },
    },
  };

  var Observer = {
    func: win.MutationObserver || win.WebkitMutationObserver,
    attach: function attach(target, options) {
      if ( options === void 0 ) options = {};

      var swiper = this;

      var ObserverFunc = Observer.func;
      var observer = new ObserverFunc(function (mutations) {
        // The observerUpdate event should only be triggered
        // once despite the number of mutations.  Additional
        // triggers are redundant and are very costly
        if (mutations.length === 1) {
          swiper.emit('observerUpdate', mutations[0]);
          return;
        }
        var observerUpdate = function observerUpdate() {
          swiper.emit('observerUpdate', mutations[0]);
        };

        if (win.requestAnimationFrame) {
          win.requestAnimationFrame(observerUpdate);
        } else {
          win.setTimeout(observerUpdate, 0);
        }
      });

      observer.observe(target, {
        attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
        childList: typeof options.childList === 'undefined' ? true : options.childList,
        characterData: typeof options.characterData === 'undefined' ? true : options.characterData,
      });

      swiper.observer.observers.push(observer);
    },
    init: function init() {
      var swiper = this;
      if (!Support.observer || !swiper.params.observer) { return; }
      if (swiper.params.observeParents) {
        var containerParents = swiper.$el.parents();
        for (var i = 0; i < containerParents.length; i += 1) {
          swiper.observer.attach(containerParents[i]);
        }
      }
      // Observe container
      swiper.observer.attach(swiper.$el[0], { childList: swiper.params.observeSlideChildren });

      // Observe wrapper
      swiper.observer.attach(swiper.$wrapperEl[0], { attributes: false });
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.observer.observers.forEach(function (observer) {
        observer.disconnect();
      });
      swiper.observer.observers = [];
    },
  };

  var Observer$1 = {
    name: 'observer',
    params: {
      observer: false,
      observeParents: false,
      observeSlideChildren: false,
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        observer: {
          init: Observer.init.bind(swiper),
          attach: Observer.attach.bind(swiper),
          destroy: Observer.destroy.bind(swiper),
          observers: [],
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.observer.init();
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.observer.destroy();
      },
    },
  };

  var Virtual = {
    update: function update(force) {
      var swiper = this;
      var ref = swiper.params;
      var slidesPerView = ref.slidesPerView;
      var slidesPerGroup = ref.slidesPerGroup;
      var centeredSlides = ref.centeredSlides;
      var ref$1 = swiper.params.virtual;
      var addSlidesBefore = ref$1.addSlidesBefore;
      var addSlidesAfter = ref$1.addSlidesAfter;
      var ref$2 = swiper.virtual;
      var previousFrom = ref$2.from;
      var previousTo = ref$2.to;
      var slides = ref$2.slides;
      var previousSlidesGrid = ref$2.slidesGrid;
      var renderSlide = ref$2.renderSlide;
      var previousOffset = ref$2.offset;
      swiper.updateActiveIndex();
      var activeIndex = swiper.activeIndex || 0;

      var offsetProp;
      if (swiper.rtlTranslate) { offsetProp = 'right'; }
      else { offsetProp = swiper.isHorizontal() ? 'left' : 'top'; }

      var slidesAfter;
      var slidesBefore;
      if (centeredSlides) {
        slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
      } else {
        slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesBefore;
        slidesBefore = slidesPerGroup + addSlidesAfter;
      }
      var from = Math.max((activeIndex || 0) - slidesBefore, 0);
      var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
      var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);

      Utils.extend(swiper.virtual, {
        from: from,
        to: to,
        offset: offset,
        slidesGrid: swiper.slidesGrid,
      });

      function onRendered() {
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        if (swiper.lazy && swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      }

      if (previousFrom === from && previousTo === to && !force) {
        if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
          swiper.slides.css(offsetProp, (offset + "px"));
        }
        swiper.updateProgress();
        return;
      }
      if (swiper.params.virtual.renderExternal) {
        swiper.params.virtual.renderExternal.call(swiper, {
          offset: offset,
          from: from,
          to: to,
          slides: (function getSlides() {
            var slidesToRender = [];
            for (var i = from; i <= to; i += 1) {
              slidesToRender.push(slides[i]);
            }
            return slidesToRender;
          }()),
        });
        onRendered();
        return;
      }
      var prependIndexes = [];
      var appendIndexes = [];
      if (force) {
        swiper.$wrapperEl.find(("." + (swiper.params.slideClass))).remove();
      } else {
        for (var i = previousFrom; i <= previousTo; i += 1) {
          if (i < from || i > to) {
            swiper.$wrapperEl.find(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + i + "\"]")).remove();
          }
        }
      }
      for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
        if (i$1 >= from && i$1 <= to) {
          if (typeof previousTo === 'undefined' || force) {
            appendIndexes.push(i$1);
          } else {
            if (i$1 > previousTo) { appendIndexes.push(i$1); }
            if (i$1 < previousFrom) { prependIndexes.push(i$1); }
          }
        }
      }
      appendIndexes.forEach(function (index) {
        swiper.$wrapperEl.append(renderSlide(slides[index], index));
      });
      prependIndexes.sort(function (a, b) { return b - a; }).forEach(function (index) {
        swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
      });
      swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, (offset + "px"));
      onRendered();
    },
    renderSlide: function renderSlide(slide, index) {
      var swiper = this;
      var params = swiper.params.virtual;
      if (params.cache && swiper.virtual.cache[index]) {
        return swiper.virtual.cache[index];
      }
      var $slideEl = params.renderSlide
        ? $(params.renderSlide.call(swiper, slide, index))
        : $(("<div class=\"" + (swiper.params.slideClass) + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>"));
      if (!$slideEl.attr('data-swiper-slide-index')) { $slideEl.attr('data-swiper-slide-index', index); }
      if (params.cache) { swiper.virtual.cache[index] = $slideEl; }
      return $slideEl;
    },
    appendSlide: function appendSlide(slides) {
      var swiper = this;
      if (typeof slides === 'object' && 'length' in slides) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) { swiper.virtual.slides.push(slides[i]); }
        }
      } else {
        swiper.virtual.slides.push(slides);
      }
      swiper.virtual.update(true);
    },
    prependSlide: function prependSlide(slides) {
      var swiper = this;
      var activeIndex = swiper.activeIndex;
      var newActiveIndex = activeIndex + 1;
      var numberOfNewSlides = 1;

      if (Array.isArray(slides)) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) { swiper.virtual.slides.unshift(slides[i]); }
        }
        newActiveIndex = activeIndex + slides.length;
        numberOfNewSlides = slides.length;
      } else {
        swiper.virtual.slides.unshift(slides);
      }
      if (swiper.params.virtual.cache) {
        var cache = swiper.virtual.cache;
        var newCache = {};
        Object.keys(cache).forEach(function (cachedIndex) {
          newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cache[cachedIndex];
        });
        swiper.virtual.cache = newCache;
      }
      swiper.virtual.update(true);
      swiper.slideTo(newActiveIndex, 0);
    },
    removeSlide: function removeSlide(slidesIndexes) {
      var swiper = this;
      if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) { return; }
      var activeIndex = swiper.activeIndex;
      if (Array.isArray(slidesIndexes)) {
        for (var i = slidesIndexes.length - 1; i >= 0; i -= 1) {
          swiper.virtual.slides.splice(slidesIndexes[i], 1);
          if (swiper.params.virtual.cache) {
            delete swiper.virtual.cache[slidesIndexes[i]];
          }
          if (slidesIndexes[i] < activeIndex) { activeIndex -= 1; }
          activeIndex = Math.max(activeIndex, 0);
        }
      } else {
        swiper.virtual.slides.splice(slidesIndexes, 1);
        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes];
        }
        if (slidesIndexes < activeIndex) { activeIndex -= 1; }
        activeIndex = Math.max(activeIndex, 0);
      }
      swiper.virtual.update(true);
      swiper.slideTo(activeIndex, 0);
    },
    removeAllSlides: function removeAllSlides() {
      var swiper = this;
      swiper.virtual.slides = [];
      if (swiper.params.virtual.cache) {
        swiper.virtual.cache = {};
      }
      swiper.virtual.update(true);
      swiper.slideTo(0, 0);
    },
  };

  var Virtual$1 = {
    name: 'virtual',
    params: {
      virtual: {
        enabled: false,
        slides: [],
        cache: true,
        renderSlide: null,
        renderExternal: null,
        addSlidesBefore: 0,
        addSlidesAfter: 0,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        virtual: {
          update: Virtual.update.bind(swiper),
          appendSlide: Virtual.appendSlide.bind(swiper),
          prependSlide: Virtual.prependSlide.bind(swiper),
          removeSlide: Virtual.removeSlide.bind(swiper),
          removeAllSlides: Virtual.removeAllSlides.bind(swiper),
          renderSlide: Virtual.renderSlide.bind(swiper),
          slides: swiper.params.virtual.slides,
          cache: {},
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (!swiper.params.virtual.enabled) { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "virtual"));
        var overwriteParams = {
          watchSlidesProgress: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);

        if (!swiper.params.initialSlide) {
          swiper.virtual.update();
        }
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (!swiper.params.virtual.enabled) { return; }
        swiper.virtual.update();
      },
    },
  };

  var Keyboard = {
    handle: function handle(event) {
      var swiper = this;
      var rtl = swiper.rtlTranslate;
      var e = event;
      if (e.originalEvent) { e = e.originalEvent; } // jquery fix
      var kc = e.keyCode || e.charCode;
      // Directions locks
      if (!swiper.allowSlideNext && ((swiper.isHorizontal() && kc === 39) || (swiper.isVertical() && kc === 40) || kc === 34)) {
        return false;
      }
      if (!swiper.allowSlidePrev && ((swiper.isHorizontal() && kc === 37) || (swiper.isVertical() && kc === 38) || kc === 33)) {
        return false;
      }
      if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
        return undefined;
      }
      if (doc.activeElement && doc.activeElement.nodeName && (doc.activeElement.nodeName.toLowerCase() === 'input' || doc.activeElement.nodeName.toLowerCase() === 'textarea')) {
        return undefined;
      }
      if (swiper.params.keyboard.onlyInViewport && (kc === 33 || kc === 34 || kc === 37 || kc === 39 || kc === 38 || kc === 40)) {
        var inView = false;
        // Check that swiper should be inside of visible area of window
        if (swiper.$el.parents(("." + (swiper.params.slideClass))).length > 0 && swiper.$el.parents(("." + (swiper.params.slideActiveClass))).length === 0) {
          return undefined;
        }
        var windowWidth = win.innerWidth;
        var windowHeight = win.innerHeight;
        var swiperOffset = swiper.$el.offset();
        if (rtl) { swiperOffset.left -= swiper.$el[0].scrollLeft; }
        var swiperCoord = [
          [swiperOffset.left, swiperOffset.top],
          [swiperOffset.left + swiper.width, swiperOffset.top],
          [swiperOffset.left, swiperOffset.top + swiper.height],
          [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height] ];
        for (var i = 0; i < swiperCoord.length; i += 1) {
          var point = swiperCoord[i];
          if (
            point[0] >= 0 && point[0] <= windowWidth
            && point[1] >= 0 && point[1] <= windowHeight
          ) {
            inView = true;
          }
        }
        if (!inView) { return undefined; }
      }
      if (swiper.isHorizontal()) {
        if (kc === 33 || kc === 34 || kc === 37 || kc === 39) {
          if (e.preventDefault) { e.preventDefault(); }
          else { e.returnValue = false; }
        }
        if (((kc === 34 || kc === 39) && !rtl) || ((kc === 33 || kc === 37) && rtl)) { swiper.slideNext(); }
        if (((kc === 33 || kc === 37) && !rtl) || ((kc === 34 || kc === 39) && rtl)) { swiper.slidePrev(); }
      } else {
        if (kc === 33 || kc === 34 || kc === 38 || kc === 40) {
          if (e.preventDefault) { e.preventDefault(); }
          else { e.returnValue = false; }
        }
        if (kc === 34 || kc === 40) { swiper.slideNext(); }
        if (kc === 33 || kc === 38) { swiper.slidePrev(); }
      }
      swiper.emit('keyPress', kc);
      return undefined;
    },
    enable: function enable() {
      var swiper = this;
      if (swiper.keyboard.enabled) { return; }
      $(doc).on('keydown', swiper.keyboard.handle);
      swiper.keyboard.enabled = true;
    },
    disable: function disable() {
      var swiper = this;
      if (!swiper.keyboard.enabled) { return; }
      $(doc).off('keydown', swiper.keyboard.handle);
      swiper.keyboard.enabled = false;
    },
  };

  var Keyboard$1 = {
    name: 'keyboard',
    params: {
      keyboard: {
        enabled: false,
        onlyInViewport: true,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        keyboard: {
          enabled: false,
          enable: Keyboard.enable.bind(swiper),
          disable: Keyboard.disable.bind(swiper),
          handle: Keyboard.handle.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.keyboard.enabled) {
          swiper.keyboard.enable();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.keyboard.enabled) {
          swiper.keyboard.disable();
        }
      },
    },
  };

  function isEventSupported() {
    var eventName = 'onwheel';
    var isSupported = eventName in doc;

    if (!isSupported) {
      var element = doc.createElement('div');
      element.setAttribute(eventName, 'return;');
      isSupported = typeof element[eventName] === 'function';
    }

    if (!isSupported
      && doc.implementation
      && doc.implementation.hasFeature
      // always returns true in newer browsers as per the standard.
      // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
      && doc.implementation.hasFeature('', '') !== true
    ) {
      // This is the only way to test support for the `wheel` event in IE9+.
      isSupported = doc.implementation.hasFeature('Events.wheel', '3.0');
    }

    return isSupported;
  }
  var Mousewheel = {
    lastScrollTime: Utils.now(),
    event: (function getEvent() {
      if (win.navigator.userAgent.indexOf('firefox') > -1) { return 'DOMMouseScroll'; }
      return isEventSupported() ? 'wheel' : 'mousewheel';
    }()),
    normalize: function normalize(e) {
      // Reasonable defaults
      var PIXEL_STEP = 10;
      var LINE_HEIGHT = 40;
      var PAGE_HEIGHT = 800;

      var sX = 0;
      var sY = 0; // spinX, spinY
      var pX = 0;
      var pY = 0; // pixelX, pixelY

      // Legacy
      if ('detail' in e) {
        sY = e.detail;
      }
      if ('wheelDelta' in e) {
        sY = -e.wheelDelta / 120;
      }
      if ('wheelDeltaY' in e) {
        sY = -e.wheelDeltaY / 120;
      }
      if ('wheelDeltaX' in e) {
        sX = -e.wheelDeltaX / 120;
      }

      // side scrolling on FF with DOMMouseScroll
      if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
        sX = sY;
        sY = 0;
      }

      pX = sX * PIXEL_STEP;
      pY = sY * PIXEL_STEP;

      if ('deltaY' in e) {
        pY = e.deltaY;
      }
      if ('deltaX' in e) {
        pX = e.deltaX;
      }

      if ((pX || pY) && e.deltaMode) {
        if (e.deltaMode === 1) { // delta in LINE units
          pX *= LINE_HEIGHT;
          pY *= LINE_HEIGHT;
        } else { // delta in PAGE units
          pX *= PAGE_HEIGHT;
          pY *= PAGE_HEIGHT;
        }
      }

      // Fall-back if spin cannot be determined
      if (pX && !sX) {
        sX = (pX < 1) ? -1 : 1;
      }
      if (pY && !sY) {
        sY = (pY < 1) ? -1 : 1;
      }

      return {
        spinX: sX,
        spinY: sY,
        pixelX: pX,
        pixelY: pY,
      };
    },
    handleMouseEnter: function handleMouseEnter() {
      var swiper = this;
      swiper.mouseEntered = true;
    },
    handleMouseLeave: function handleMouseLeave() {
      var swiper = this;
      swiper.mouseEntered = false;
    },
    handle: function handle(event) {
      var e = event;
      var swiper = this;
      var params = swiper.params.mousewheel;

      if (!swiper.mouseEntered && !params.releaseOnEdges) { return true; }

      if (e.originalEvent) { e = e.originalEvent; } // jquery fix
      var delta = 0;
      var rtlFactor = swiper.rtlTranslate ? -1 : 1;

      var data = Mousewheel.normalize(e);

      if (params.forceToAxis) {
        if (swiper.isHorizontal()) {
          if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) { delta = data.pixelX * rtlFactor; }
          else { return true; }
        } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) { delta = data.pixelY; }
        else { return true; }
      } else {
        delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
      }

      if (delta === 0) { return true; }

      if (params.invert) { delta = -delta; }

      if (!swiper.params.freeMode) {
        if (Utils.now() - swiper.mousewheel.lastScrollTime > 60) {
          if (delta < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
              swiper.slideNext();
              swiper.emit('scroll', e);
            } else if (params.releaseOnEdges) { return true; }
          } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            swiper.emit('scroll', e);
          } else if (params.releaseOnEdges) { return true; }
        }
        swiper.mousewheel.lastScrollTime = (new win.Date()).getTime();
      } else {
        // Freemode or scrollContainer:
        if (swiper.params.loop) {
          swiper.loopFix();
        }
        var position = swiper.getTranslate() + (delta * params.sensitivity);
        var wasBeginning = swiper.isBeginning;
        var wasEnd = swiper.isEnd;

        if (position >= swiper.minTranslate()) { position = swiper.minTranslate(); }
        if (position <= swiper.maxTranslate()) { position = swiper.maxTranslate(); }

        swiper.setTransition(0);
        swiper.setTranslate(position);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();

        if ((!wasBeginning && swiper.isBeginning) || (!wasEnd && swiper.isEnd)) {
          swiper.updateSlidesClasses();
        }

        if (swiper.params.freeModeSticky) {
          clearTimeout(swiper.mousewheel.timeout);
          swiper.mousewheel.timeout = Utils.nextTick(function () {
            swiper.slideToClosest();
          }, 300);
        }
        // Emit event
        swiper.emit('scroll', e);

        // Stop autoplay
        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) { swiper.autoplay.stop(); }
        // Return page scroll on edge positions
        if (position === swiper.minTranslate() || position === swiper.maxTranslate()) { return true; }
      }

      if (e.preventDefault) { e.preventDefault(); }
      else { e.returnValue = false; }
      return false;
    },
    enable: function enable() {
      var swiper = this;
      if (!Mousewheel.event) { return false; }
      if (swiper.mousewheel.enabled) { return false; }
      var target = swiper.$el;
      if (swiper.params.mousewheel.eventsTarged !== 'container') {
        target = $(swiper.params.mousewheel.eventsTarged);
      }
      target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
      target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
      target.on(Mousewheel.event, swiper.mousewheel.handle);
      swiper.mousewheel.enabled = true;
      return true;
    },
    disable: function disable() {
      var swiper = this;
      if (!Mousewheel.event) { return false; }
      if (!swiper.mousewheel.enabled) { return false; }
      var target = swiper.$el;
      if (swiper.params.mousewheel.eventsTarged !== 'container') {
        target = $(swiper.params.mousewheel.eventsTarged);
      }
      target.off(Mousewheel.event, swiper.mousewheel.handle);
      swiper.mousewheel.enabled = false;
      return true;
    },
  };

  var Mousewheel$1 = {
    name: 'mousewheel',
    params: {
      mousewheel: {
        enabled: false,
        releaseOnEdges: false,
        invert: false,
        forceToAxis: false,
        sensitivity: 1,
        eventsTarged: 'container',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        mousewheel: {
          enabled: false,
          enable: Mousewheel.enable.bind(swiper),
          disable: Mousewheel.disable.bind(swiper),
          handle: Mousewheel.handle.bind(swiper),
          handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
          handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
          lastScrollTime: Utils.now(),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.mousewheel.enabled) { swiper.mousewheel.enable(); }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.mousewheel.enabled) { swiper.mousewheel.disable(); }
      },
    },
  };

  var Navigation = {
    update: function update() {
      // Update Navigation Buttons
      var swiper = this;
      var params = swiper.params.navigation;

      if (swiper.params.loop) { return; }
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;

      if ($prevEl && $prevEl.length > 0) {
        if (swiper.isBeginning) {
          $prevEl.addClass(params.disabledClass);
        } else {
          $prevEl.removeClass(params.disabledClass);
        }
        $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
      if ($nextEl && $nextEl.length > 0) {
        if (swiper.isEnd) {
          $nextEl.addClass(params.disabledClass);
        } else {
          $nextEl.removeClass(params.disabledClass);
        }
        $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    },
    onPrevClick: function onPrevClick(e) {
      var swiper = this;
      e.preventDefault();
      if (swiper.isBeginning && !swiper.params.loop) { return; }
      swiper.slidePrev();
    },
    onNextClick: function onNextClick(e) {
      var swiper = this;
      e.preventDefault();
      if (swiper.isEnd && !swiper.params.loop) { return; }
      swiper.slideNext();
    },
    init: function init() {
      var swiper = this;
      var params = swiper.params.navigation;
      if (!(params.nextEl || params.prevEl)) { return; }

      var $nextEl;
      var $prevEl;
      if (params.nextEl) {
        $nextEl = $(params.nextEl);
        if (
          swiper.params.uniqueNavElements
          && typeof params.nextEl === 'string'
          && $nextEl.length > 1
          && swiper.$el.find(params.nextEl).length === 1
        ) {
          $nextEl = swiper.$el.find(params.nextEl);
        }
      }
      if (params.prevEl) {
        $prevEl = $(params.prevEl);
        if (
          swiper.params.uniqueNavElements
          && typeof params.prevEl === 'string'
          && $prevEl.length > 1
          && swiper.$el.find(params.prevEl).length === 1
        ) {
          $prevEl = swiper.$el.find(params.prevEl);
        }
      }

      if ($nextEl && $nextEl.length > 0) {
        $nextEl.on('click', swiper.navigation.onNextClick);
      }
      if ($prevEl && $prevEl.length > 0) {
        $prevEl.on('click', swiper.navigation.onPrevClick);
      }

      Utils.extend(swiper.navigation, {
        $nextEl: $nextEl,
        nextEl: $nextEl && $nextEl[0],
        $prevEl: $prevEl,
        prevEl: $prevEl && $prevEl[0],
      });
    },
    destroy: function destroy() {
      var swiper = this;
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;
      if ($nextEl && $nextEl.length) {
        $nextEl.off('click', swiper.navigation.onNextClick);
        $nextEl.removeClass(swiper.params.navigation.disabledClass);
      }
      if ($prevEl && $prevEl.length) {
        $prevEl.off('click', swiper.navigation.onPrevClick);
        $prevEl.removeClass(swiper.params.navigation.disabledClass);
      }
    },
  };

  var Navigation$1 = {
    name: 'navigation',
    params: {
      navigation: {
        nextEl: null,
        prevEl: null,

        hideOnClick: false,
        disabledClass: 'swiper-button-disabled',
        hiddenClass: 'swiper-button-hidden',
        lockClass: 'swiper-button-lock',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        navigation: {
          init: Navigation.init.bind(swiper),
          update: Navigation.update.bind(swiper),
          destroy: Navigation.destroy.bind(swiper),
          onNextClick: Navigation.onNextClick.bind(swiper),
          onPrevClick: Navigation.onPrevClick.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.navigation.init();
        swiper.navigation.update();
      },
      toEdge: function toEdge() {
        var swiper = this;
        swiper.navigation.update();
      },
      fromEdge: function fromEdge() {
        var swiper = this;
        swiper.navigation.update();
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.navigation.destroy();
      },
      click: function click(e) {
        var swiper = this;
        var ref = swiper.navigation;
        var $nextEl = ref.$nextEl;
        var $prevEl = ref.$prevEl;
        if (
          swiper.params.navigation.hideOnClick
          && !$(e.target).is($prevEl)
          && !$(e.target).is($nextEl)
        ) {
          var isHidden;
          if ($nextEl) {
            isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
          } else if ($prevEl) {
            isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
          }
          if (isHidden === true) {
            swiper.emit('navigationShow', swiper);
          } else {
            swiper.emit('navigationHide', swiper);
          }
          if ($nextEl) {
            $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
          }
          if ($prevEl) {
            $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
          }
        }
      },
    },
  };

  var Pagination = {
    update: function update() {
      // Render || Update Pagination bullets/items
      var swiper = this;
      var rtl = swiper.rtl;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
      var $el = swiper.pagination.$el;
      // Current/Total
      var current;
      var total = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      if (swiper.params.loop) {
        current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
        if (current > slidesLength - 1 - (swiper.loopedSlides * 2)) {
          current -= (slidesLength - (swiper.loopedSlides * 2));
        }
        if (current > total - 1) { current -= total; }
        if (current < 0 && swiper.params.paginationType !== 'bullets') { current = total + current; }
      } else if (typeof swiper.snapIndex !== 'undefined') {
        current = swiper.snapIndex;
      } else {
        current = swiper.activeIndex || 0;
      }
      // Types
      if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
        var bullets = swiper.pagination.bullets;
        var firstIndex;
        var lastIndex;
        var midIndex;
        if (params.dynamicBullets) {
          swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
          $el.css(swiper.isHorizontal() ? 'width' : 'height', ((swiper.pagination.bulletSize * (params.dynamicMainBullets + 4)) + "px"));
          if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
            swiper.pagination.dynamicBulletIndex += (current - swiper.previousIndex);
            if (swiper.pagination.dynamicBulletIndex > (params.dynamicMainBullets - 1)) {
              swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
            } else if (swiper.pagination.dynamicBulletIndex < 0) {
              swiper.pagination.dynamicBulletIndex = 0;
            }
          }
          firstIndex = current - swiper.pagination.dynamicBulletIndex;
          lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
          midIndex = (lastIndex + firstIndex) / 2;
        }
        bullets.removeClass(((params.bulletActiveClass) + " " + (params.bulletActiveClass) + "-next " + (params.bulletActiveClass) + "-next-next " + (params.bulletActiveClass) + "-prev " + (params.bulletActiveClass) + "-prev-prev " + (params.bulletActiveClass) + "-main"));
        if ($el.length > 1) {
          bullets.each(function (index, bullet) {
            var $bullet = $(bullet);
            var bulletIndex = $bullet.index();
            if (bulletIndex === current) {
              $bullet.addClass(params.bulletActiveClass);
            }
            if (params.dynamicBullets) {
              if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                $bullet.addClass(((params.bulletActiveClass) + "-main"));
              }
              if (bulletIndex === firstIndex) {
                $bullet
                  .prev()
                  .addClass(((params.bulletActiveClass) + "-prev"))
                  .prev()
                  .addClass(((params.bulletActiveClass) + "-prev-prev"));
              }
              if (bulletIndex === lastIndex) {
                $bullet
                  .next()
                  .addClass(((params.bulletActiveClass) + "-next"))
                  .next()
                  .addClass(((params.bulletActiveClass) + "-next-next"));
              }
            }
          });
        } else {
          var $bullet = bullets.eq(current);
          $bullet.addClass(params.bulletActiveClass);
          if (params.dynamicBullets) {
            var $firstDisplayedBullet = bullets.eq(firstIndex);
            var $lastDisplayedBullet = bullets.eq(lastIndex);
            for (var i = firstIndex; i <= lastIndex; i += 1) {
              bullets.eq(i).addClass(((params.bulletActiveClass) + "-main"));
            }
            $firstDisplayedBullet
              .prev()
              .addClass(((params.bulletActiveClass) + "-prev"))
              .prev()
              .addClass(((params.bulletActiveClass) + "-prev-prev"));
            $lastDisplayedBullet
              .next()
              .addClass(((params.bulletActiveClass) + "-next"))
              .next()
              .addClass(((params.bulletActiveClass) + "-next-next"));
          }
        }
        if (params.dynamicBullets) {
          var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
          var bulletsOffset = (((swiper.pagination.bulletSize * dynamicBulletsLength) - (swiper.pagination.bulletSize)) / 2) - (midIndex * swiper.pagination.bulletSize);
          var offsetProp = rtl ? 'right' : 'left';
          bullets.css(swiper.isHorizontal() ? offsetProp : 'top', (bulletsOffset + "px"));
        }
      }
      if (params.type === 'fraction') {
        $el.find(("." + (params.currentClass))).text(params.formatFractionCurrent(current + 1));
        $el.find(("." + (params.totalClass))).text(params.formatFractionTotal(total));
      }
      if (params.type === 'progressbar') {
        var progressbarDirection;
        if (params.progressbarOpposite) {
          progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
        } else {
          progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
        }
        var scale = (current + 1) / total;
        var scaleX = 1;
        var scaleY = 1;
        if (progressbarDirection === 'horizontal') {
          scaleX = scale;
        } else {
          scaleY = scale;
        }
        $el.find(("." + (params.progressbarFillClass))).transform(("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")")).transition(swiper.params.speed);
      }
      if (params.type === 'custom' && params.renderCustom) {
        $el.html(params.renderCustom(swiper, current + 1, total));
        swiper.emit('paginationRender', swiper, $el[0]);
      } else {
        swiper.emit('paginationUpdate', swiper, $el[0]);
      }
      $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    },
    render: function render() {
      // Render Container
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
      var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;

      var $el = swiper.pagination.$el;
      var paginationHTML = '';
      if (params.type === 'bullets') {
        var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        for (var i = 0; i < numberOfBullets; i += 1) {
          if (params.renderBullet) {
            paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
          } else {
            paginationHTML += "<" + (params.bulletElement) + " class=\"" + (params.bulletClass) + "\"></" + (params.bulletElement) + ">";
          }
        }
        $el.html(paginationHTML);
        swiper.pagination.bullets = $el.find(("." + (params.bulletClass)));
      }
      if (params.type === 'fraction') {
        if (params.renderFraction) {
          paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
        } else {
          paginationHTML = "<span class=\"" + (params.currentClass) + "\"></span>"
          + ' / '
          + "<span class=\"" + (params.totalClass) + "\"></span>";
        }
        $el.html(paginationHTML);
      }
      if (params.type === 'progressbar') {
        if (params.renderProgressbar) {
          paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
        } else {
          paginationHTML = "<span class=\"" + (params.progressbarFillClass) + "\"></span>";
        }
        $el.html(paginationHTML);
      }
      if (params.type !== 'custom') {
        swiper.emit('paginationRender', swiper.pagination.$el[0]);
      }
    },
    init: function init() {
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el) { return; }

      var $el = $(params.el);
      if ($el.length === 0) { return; }

      if (
        swiper.params.uniqueNavElements
        && typeof params.el === 'string'
        && $el.length > 1
        && swiper.$el.find(params.el).length === 1
      ) {
        $el = swiper.$el.find(params.el);
      }

      if (params.type === 'bullets' && params.clickable) {
        $el.addClass(params.clickableClass);
      }

      $el.addClass(params.modifierClass + params.type);

      if (params.type === 'bullets' && params.dynamicBullets) {
        $el.addClass(("" + (params.modifierClass) + (params.type) + "-dynamic"));
        swiper.pagination.dynamicBulletIndex = 0;
        if (params.dynamicMainBullets < 1) {
          params.dynamicMainBullets = 1;
        }
      }
      if (params.type === 'progressbar' && params.progressbarOpposite) {
        $el.addClass(params.progressbarOppositeClass);
      }

      if (params.clickable) {
        $el.on('click', ("." + (params.bulletClass)), function onClick(e) {
          e.preventDefault();
          var index = $(this).index() * swiper.params.slidesPerGroup;
          if (swiper.params.loop) { index += swiper.loopedSlides; }
          swiper.slideTo(index);
        });
      }

      Utils.extend(swiper.pagination, {
        $el: $el,
        el: $el[0],
      });
    },
    destroy: function destroy() {
      var swiper = this;
      var params = swiper.params.pagination;
      if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
      var $el = swiper.pagination.$el;

      $el.removeClass(params.hiddenClass);
      $el.removeClass(params.modifierClass + params.type);
      if (swiper.pagination.bullets) { swiper.pagination.bullets.removeClass(params.bulletActiveClass); }
      if (params.clickable) {
        $el.off('click', ("." + (params.bulletClass)));
      }
    },
  };

  var Pagination$1 = {
    name: 'pagination',
    params: {
      pagination: {
        el: null,
        bulletElement: 'span',
        clickable: false,
        hideOnClick: false,
        renderBullet: null,
        renderProgressbar: null,
        renderFraction: null,
        renderCustom: null,
        progressbarOpposite: false,
        type: 'bullets', // 'bullets' or 'progressbar' or 'fraction' or 'custom'
        dynamicBullets: false,
        dynamicMainBullets: 1,
        formatFractionCurrent: function (number) { return number; },
        formatFractionTotal: function (number) { return number; },
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
        modifierClass: 'swiper-pagination-', // NEW
        currentClass: 'swiper-pagination-current',
        totalClass: 'swiper-pagination-total',
        hiddenClass: 'swiper-pagination-hidden',
        progressbarFillClass: 'swiper-pagination-progressbar-fill',
        progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
        clickableClass: 'swiper-pagination-clickable', // NEW
        lockClass: 'swiper-pagination-lock',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        pagination: {
          init: Pagination.init.bind(swiper),
          render: Pagination.render.bind(swiper),
          update: Pagination.update.bind(swiper),
          destroy: Pagination.destroy.bind(swiper),
          dynamicBulletIndex: 0,
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.pagination.init();
        swiper.pagination.render();
        swiper.pagination.update();
      },
      activeIndexChange: function activeIndexChange() {
        var swiper = this;
        if (swiper.params.loop) {
          swiper.pagination.update();
        } else if (typeof swiper.snapIndex === 'undefined') {
          swiper.pagination.update();
        }
      },
      snapIndexChange: function snapIndexChange() {
        var swiper = this;
        if (!swiper.params.loop) {
          swiper.pagination.update();
        }
      },
      slidesLengthChange: function slidesLengthChange() {
        var swiper = this;
        if (swiper.params.loop) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      },
      snapGridLengthChange: function snapGridLengthChange() {
        var swiper = this;
        if (!swiper.params.loop) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.pagination.destroy();
      },
      click: function click(e) {
        var swiper = this;
        if (
          swiper.params.pagination.el
          && swiper.params.pagination.hideOnClick
          && swiper.pagination.$el.length > 0
          && !$(e.target).hasClass(swiper.params.pagination.bulletClass)
        ) {
          var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
          if (isHidden === true) {
            swiper.emit('paginationShow', swiper);
          } else {
            swiper.emit('paginationHide', swiper);
          }
          swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
        }
      },
    },
  };

  var Scrollbar = {
    setTranslate: function setTranslate() {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var rtl = swiper.rtlTranslate;
      var progress = swiper.progress;
      var dragSize = scrollbar.dragSize;
      var trackSize = scrollbar.trackSize;
      var $dragEl = scrollbar.$dragEl;
      var $el = scrollbar.$el;
      var params = swiper.params.scrollbar;

      var newSize = dragSize;
      var newPos = (trackSize - dragSize) * progress;
      if (rtl) {
        newPos = -newPos;
        if (newPos > 0) {
          newSize = dragSize - newPos;
          newPos = 0;
        } else if (-newPos + dragSize > trackSize) {
          newSize = trackSize + newPos;
        }
      } else if (newPos < 0) {
        newSize = dragSize + newPos;
        newPos = 0;
      } else if (newPos + dragSize > trackSize) {
        newSize = trackSize - newPos;
      }
      if (swiper.isHorizontal()) {
        if (Support.transforms3d) {
          $dragEl.transform(("translate3d(" + newPos + "px, 0, 0)"));
        } else {
          $dragEl.transform(("translateX(" + newPos + "px)"));
        }
        $dragEl[0].style.width = newSize + "px";
      } else {
        if (Support.transforms3d) {
          $dragEl.transform(("translate3d(0px, " + newPos + "px, 0)"));
        } else {
          $dragEl.transform(("translateY(" + newPos + "px)"));
        }
        $dragEl[0].style.height = newSize + "px";
      }
      if (params.hide) {
        clearTimeout(swiper.scrollbar.timeout);
        $el[0].style.opacity = 1;
        swiper.scrollbar.timeout = setTimeout(function () {
          $el[0].style.opacity = 0;
          $el.transition(400);
        }, 1000);
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
      swiper.scrollbar.$dragEl.transition(duration);
    },
    updateSize: function updateSize() {
      var swiper = this;
      if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }

      var scrollbar = swiper.scrollbar;
      var $dragEl = scrollbar.$dragEl;
      var $el = scrollbar.$el;

      $dragEl[0].style.width = '';
      $dragEl[0].style.height = '';
      var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;

      var divider = swiper.size / swiper.virtualSize;
      var moveDivider = divider * (trackSize / swiper.size);
      var dragSize;
      if (swiper.params.scrollbar.dragSize === 'auto') {
        dragSize = trackSize * divider;
      } else {
        dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
      }

      if (swiper.isHorizontal()) {
        $dragEl[0].style.width = dragSize + "px";
      } else {
        $dragEl[0].style.height = dragSize + "px";
      }

      if (divider >= 1) {
        $el[0].style.display = 'none';
      } else {
        $el[0].style.display = '';
      }
      if (swiper.params.scrollbar.hide) {
        $el[0].style.opacity = 0;
      }
      Utils.extend(scrollbar, {
        trackSize: trackSize,
        divider: divider,
        moveDivider: moveDivider,
        dragSize: dragSize,
      });
      scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    },
    getPointerPosition: function getPointerPosition(e) {
      var swiper = this;
      if (swiper.isHorizontal()) {
        return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageX : e.pageX || e.clientX);
      }
      return ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageY : e.pageY || e.clientY);
    },
    setDragPosition: function setDragPosition(e) {
      var swiper = this;
      var scrollbar = swiper.scrollbar;
      var rtl = swiper.rtlTranslate;
      var $el = scrollbar.$el;
      var dragSize = scrollbar.dragSize;
      var trackSize = scrollbar.trackSize;
      var dragStartPos = scrollbar.dragStartPos;

      var positionRatio;
      positionRatio = ((scrollbar.getPointerPosition(e)) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top']
        - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
      positionRatio = Math.max(Math.min(positionRatio, 1), 0);
      if (rtl) {
        positionRatio = 1 - positionRatio;
      }

      var position = swiper.minTranslate() + ((swiper.maxTranslate() - swiper.minTranslate()) * positionRatio);

      swiper.updateProgress(position);
      swiper.setTranslate(position);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    },
    onDragStart: function onDragStart(e) {
      var swiper = this;
      var params = swiper.params.scrollbar;
      var scrollbar = swiper.scrollbar;
      var $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el;
      var $dragEl = scrollbar.$dragEl;
      swiper.scrollbar.isTouched = true;
      swiper.scrollbar.dragStartPos = (e.target === $dragEl[0] || e.target === $dragEl)
        ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
      e.preventDefault();
      e.stopPropagation();

      $wrapperEl.transition(100);
      $dragEl.transition(100);
      scrollbar.setDragPosition(e);

      clearTimeout(swiper.scrollbar.dragTimeout);

      $el.transition(0);
      if (params.hide) {
        $el.css('opacity', 1);
      }
      swiper.emit('scrollbarDragStart', e);
    },
    onDragMove: function onDragMove(e) {
      var swiper = this;
      var scrollbar = swiper.scrollbar;
      var $wrapperEl = swiper.$wrapperEl;
      var $el = scrollbar.$el;
      var $dragEl = scrollbar.$dragEl;

      if (!swiper.scrollbar.isTouched) { return; }
      if (e.preventDefault) { e.preventDefault(); }
      else { e.returnValue = false; }
      scrollbar.setDragPosition(e);
      $wrapperEl.transition(0);
      $el.transition(0);
      $dragEl.transition(0);
      swiper.emit('scrollbarDragMove', e);
    },
    onDragEnd: function onDragEnd(e) {
      var swiper = this;

      var params = swiper.params.scrollbar;
      var scrollbar = swiper.scrollbar;
      var $el = scrollbar.$el;

      if (!swiper.scrollbar.isTouched) { return; }
      swiper.scrollbar.isTouched = false;
      if (params.hide) {
        clearTimeout(swiper.scrollbar.dragTimeout);
        swiper.scrollbar.dragTimeout = Utils.nextTick(function () {
          $el.css('opacity', 0);
          $el.transition(400);
        }, 1000);
      }
      swiper.emit('scrollbarDragEnd', e);
      if (params.snapOnRelease) {
        swiper.slideToClosest();
      }
    },
    enableDraggable: function enableDraggable() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var touchEventsTouch = swiper.touchEventsTouch;
      var touchEventsDesktop = swiper.touchEventsDesktop;
      var params = swiper.params;
      var $el = scrollbar.$el;
      var target = $el[0];
      var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
      var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
      if (!Support.touch) {
        target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
        doc.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
        doc.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
      } else {
        target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
        target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
        target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
      }
    },
    disableDraggable: function disableDraggable() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var touchEventsTouch = swiper.touchEventsTouch;
      var touchEventsDesktop = swiper.touchEventsDesktop;
      var params = swiper.params;
      var $el = scrollbar.$el;
      var target = $el[0];
      var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
      var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
      if (!Support.touch) {
        target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
        doc.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
        doc.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
      } else {
        target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
        target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
        target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
      }
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.scrollbar.el) { return; }
      var scrollbar = swiper.scrollbar;
      var $swiperEl = swiper.$el;
      var params = swiper.params.scrollbar;

      var $el = $(params.el);
      if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
        $el = $swiperEl.find(params.el);
      }

      var $dragEl = $el.find(("." + (swiper.params.scrollbar.dragClass)));
      if ($dragEl.length === 0) {
        $dragEl = $(("<div class=\"" + (swiper.params.scrollbar.dragClass) + "\"></div>"));
        $el.append($dragEl);
      }

      Utils.extend(scrollbar, {
        $el: $el,
        el: $el[0],
        $dragEl: $dragEl,
        dragEl: $dragEl[0],
      });

      if (params.draggable) {
        scrollbar.enableDraggable();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.scrollbar.disableDraggable();
    },
  };

  var Scrollbar$1 = {
    name: 'scrollbar',
    params: {
      scrollbar: {
        el: null,
        dragSize: 'auto',
        hide: false,
        draggable: false,
        snapOnRelease: true,
        lockClass: 'swiper-scrollbar-lock',
        dragClass: 'swiper-scrollbar-drag',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        scrollbar: {
          init: Scrollbar.init.bind(swiper),
          destroy: Scrollbar.destroy.bind(swiper),
          updateSize: Scrollbar.updateSize.bind(swiper),
          setTranslate: Scrollbar.setTranslate.bind(swiper),
          setTransition: Scrollbar.setTransition.bind(swiper),
          enableDraggable: Scrollbar.enableDraggable.bind(swiper),
          disableDraggable: Scrollbar.disableDraggable.bind(swiper),
          setDragPosition: Scrollbar.setDragPosition.bind(swiper),
          getPointerPosition: Scrollbar.getPointerPosition.bind(swiper),
          onDragStart: Scrollbar.onDragStart.bind(swiper),
          onDragMove: Scrollbar.onDragMove.bind(swiper),
          onDragEnd: Scrollbar.onDragEnd.bind(swiper),
          isTouched: false,
          timeout: null,
          dragTimeout: null,
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        swiper.scrollbar.init();
        swiper.scrollbar.updateSize();
        swiper.scrollbar.setTranslate();
      },
      update: function update() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      resize: function resize() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        swiper.scrollbar.updateSize();
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        swiper.scrollbar.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        swiper.scrollbar.setTransition(duration);
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.scrollbar.destroy();
      },
    },
  };

  var Parallax = {
    setTransform: function setTransform(el, progress) {
      var swiper = this;
      var rtl = swiper.rtl;

      var $el = $(el);
      var rtlFactor = rtl ? -1 : 1;

      var p = $el.attr('data-swiper-parallax') || '0';
      var x = $el.attr('data-swiper-parallax-x');
      var y = $el.attr('data-swiper-parallax-y');
      var scale = $el.attr('data-swiper-parallax-scale');
      var opacity = $el.attr('data-swiper-parallax-opacity');

      if (x || y) {
        x = x || '0';
        y = y || '0';
      } else if (swiper.isHorizontal()) {
        x = p;
        y = '0';
      } else {
        y = p;
        x = '0';
      }

      if ((x).indexOf('%') >= 0) {
        x = (parseInt(x, 10) * progress * rtlFactor) + "%";
      } else {
        x = (x * progress * rtlFactor) + "px";
      }
      if ((y).indexOf('%') >= 0) {
        y = (parseInt(y, 10) * progress) + "%";
      } else {
        y = (y * progress) + "px";
      }

      if (typeof opacity !== 'undefined' && opacity !== null) {
        var currentOpacity = opacity - ((opacity - 1) * (1 - Math.abs(progress)));
        $el[0].style.opacity = currentOpacity;
      }
      if (typeof scale === 'undefined' || scale === null) {
        $el.transform(("translate3d(" + x + ", " + y + ", 0px)"));
      } else {
        var currentScale = scale - ((scale - 1) * (1 - Math.abs(progress)));
        $el.transform(("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")"));
      }
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      var $el = swiper.$el;
      var slides = swiper.slides;
      var progress = swiper.progress;
      var snapGrid = swiper.snapGrid;
      $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
        .each(function (index, el) {
          swiper.parallax.setTransform(el, progress);
        });
      slides.each(function (slideIndex, slideEl) {
        var slideProgress = slideEl.progress;
        if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
          slideProgress += Math.ceil(slideIndex / 2) - (progress * (snapGrid.length - 1));
        }
        slideProgress = Math.min(Math.max(slideProgress, -1), 1);
        $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
          .each(function (index, el) {
            swiper.parallax.setTransform(el, slideProgress);
          });
      });
    },
    setTransition: function setTransition(duration) {
      if ( duration === void 0 ) duration = this.params.speed;

      var swiper = this;
      var $el = swiper.$el;
      $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]')
        .each(function (index, parallaxEl) {
          var $parallaxEl = $(parallaxEl);
          var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
          if (duration === 0) { parallaxDuration = 0; }
          $parallaxEl.transition(parallaxDuration);
        });
    },
  };

  var Parallax$1 = {
    name: 'parallax',
    params: {
      parallax: {
        enabled: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        parallax: {
          setTransform: Parallax.setTransform.bind(swiper),
          setTranslate: Parallax.setTranslate.bind(swiper),
          setTransition: Parallax.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
      },
      init: function init() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.parallax.setTranslate();
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.parallax.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (!swiper.params.parallax.enabled) { return; }
        swiper.parallax.setTransition(duration);
      },
    },
  };

  var Zoom = {
    // Calc Scale From Multi-touches
    getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
      if (e.targetTouches.length < 2) { return 1; }
      var x1 = e.targetTouches[0].pageX;
      var y1 = e.targetTouches[0].pageY;
      var x2 = e.targetTouches[1].pageX;
      var y2 = e.targetTouches[1].pageY;
      var distance = Math.sqrt((Math.pow( (x2 - x1), 2 )) + (Math.pow( (y2 - y1), 2 )));
      return distance;
    },
    // Events
    onGestureStart: function onGestureStart(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      zoom.fakeGestureTouched = false;
      zoom.fakeGestureMoved = false;
      if (!Support.gestures) {
        if (e.type !== 'touchstart' || (e.type === 'touchstart' && e.targetTouches.length < 2)) {
          return;
        }
        zoom.fakeGestureTouched = true;
        gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
      }
      if (!gesture.$slideEl || !gesture.$slideEl.length) {
        gesture.$slideEl = $(e.target).closest('.swiper-slide');
        if (gesture.$slideEl.length === 0) { gesture.$slideEl = swiper.slides.eq(swiper.activeIndex); }
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
        gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        if (gesture.$imageWrapEl.length === 0) {
          gesture.$imageEl = undefined;
          return;
        }
      }
      gesture.$imageEl.transition(0);
      swiper.zoom.isScaling = true;
    },
    onGestureChange: function onGestureChange(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (!Support.gestures) {
        if (e.type !== 'touchmove' || (e.type === 'touchmove' && e.targetTouches.length < 2)) {
          return;
        }
        zoom.fakeGestureMoved = true;
        gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      if (Support.gestures) {
        zoom.scale = e.scale * zoom.currentScale;
      } else {
        zoom.scale = (gesture.scaleMove / gesture.scaleStart) * zoom.currentScale;
      }
      if (zoom.scale > gesture.maxRatio) {
        zoom.scale = (gesture.maxRatio - 1) + (Math.pow( ((zoom.scale - gesture.maxRatio) + 1), 0.5 ));
      }
      if (zoom.scale < params.minRatio) {
        zoom.scale = (params.minRatio + 1) - (Math.pow( ((params.minRatio - zoom.scale) + 1), 0.5 ));
      }
      gesture.$imageEl.transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
    },
    onGestureEnd: function onGestureEnd(e) {
      var swiper = this;
      var params = swiper.params.zoom;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (!Support.gestures) {
        if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
          return;
        }
        if (e.type !== 'touchend' || (e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android)) {
          return;
        }
        zoom.fakeGestureTouched = false;
        zoom.fakeGestureMoved = false;
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
      gesture.$imageEl.transition(swiper.params.speed).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
      zoom.currentScale = zoom.scale;
      zoom.isScaling = false;
      if (zoom.scale === 1) { gesture.$slideEl = undefined; }
    },
    onTouchStart: function onTouchStart(e) {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      if (image.isTouched) { return; }
      if (Device.android) { e.preventDefault(); }
      image.isTouched = true;
      image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
      image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    },
    onTouchMove: function onTouchMove(e) {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      var velocity = zoom.velocity;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      swiper.allowClick = false;
      if (!image.isTouched || !gesture.$slideEl) { return; }

      if (!image.isMoved) {
        image.width = gesture.$imageEl[0].offsetWidth;
        image.height = gesture.$imageEl[0].offsetHeight;
        image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
        image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
        gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
        gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
        gesture.$imageWrapEl.transition(0);
        if (swiper.rtl) {
          image.startX = -image.startX;
          image.startY = -image.startY;
        }
      }
      // Define if we need image drag
      var scaledWidth = image.width * zoom.scale;
      var scaledHeight = image.height * zoom.scale;

      if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) { return; }

      image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
      image.maxX = -image.minX;
      image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
      image.maxY = -image.minY;

      image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
      image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

      if (!image.isMoved && !zoom.isScaling) {
        if (
          swiper.isHorizontal()
          && (
            (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x)
            || (Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)
          )
        ) {
          image.isTouched = false;
          return;
        } if (
          !swiper.isHorizontal()
          && (
            (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y)
            || (Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)
          )
        ) {
          image.isTouched = false;
          return;
        }
      }
      e.preventDefault();
      e.stopPropagation();

      image.isMoved = true;
      image.currentX = (image.touchesCurrent.x - image.touchesStart.x) + image.startX;
      image.currentY = (image.touchesCurrent.y - image.touchesStart.y) + image.startY;

      if (image.currentX < image.minX) {
        image.currentX = (image.minX + 1) - (Math.pow( ((image.minX - image.currentX) + 1), 0.8 ));
      }
      if (image.currentX > image.maxX) {
        image.currentX = (image.maxX - 1) + (Math.pow( ((image.currentX - image.maxX) + 1), 0.8 ));
      }

      if (image.currentY < image.minY) {
        image.currentY = (image.minY + 1) - (Math.pow( ((image.minY - image.currentY) + 1), 0.8 ));
      }
      if (image.currentY > image.maxY) {
        image.currentY = (image.maxY - 1) + (Math.pow( ((image.currentY - image.maxY) + 1), 0.8 ));
      }

      // Velocity
      if (!velocity.prevPositionX) { velocity.prevPositionX = image.touchesCurrent.x; }
      if (!velocity.prevPositionY) { velocity.prevPositionY = image.touchesCurrent.y; }
      if (!velocity.prevTime) { velocity.prevTime = Date.now(); }
      velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
      velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
      if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) { velocity.x = 0; }
      if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) { velocity.y = 0; }
      velocity.prevPositionX = image.touchesCurrent.x;
      velocity.prevPositionY = image.touchesCurrent.y;
      velocity.prevTime = Date.now();

      gesture.$imageWrapEl.transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
    },
    onTouchEnd: function onTouchEnd() {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;
      var velocity = zoom.velocity;
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
      if (!image.isTouched || !image.isMoved) {
        image.isTouched = false;
        image.isMoved = false;
        return;
      }
      image.isTouched = false;
      image.isMoved = false;
      var momentumDurationX = 300;
      var momentumDurationY = 300;
      var momentumDistanceX = velocity.x * momentumDurationX;
      var newPositionX = image.currentX + momentumDistanceX;
      var momentumDistanceY = velocity.y * momentumDurationY;
      var newPositionY = image.currentY + momentumDistanceY;

      // Fix duration
      if (velocity.x !== 0) { momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x); }
      if (velocity.y !== 0) { momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y); }
      var momentumDuration = Math.max(momentumDurationX, momentumDurationY);

      image.currentX = newPositionX;
      image.currentY = newPositionY;

      // Define if we need image drag
      var scaledWidth = image.width * zoom.scale;
      var scaledHeight = image.height * zoom.scale;
      image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
      image.maxX = -image.minX;
      image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
      image.maxY = -image.minY;
      image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
      image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);

      gesture.$imageWrapEl.transition(momentumDuration).transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
    },
    onTransitionEnd: function onTransitionEnd() {
      var swiper = this;
      var zoom = swiper.zoom;
      var gesture = zoom.gesture;
      if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
        gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
        gesture.$imageWrapEl.transform('translate3d(0,0,0)');

        zoom.scale = 1;
        zoom.currentScale = 1;

        gesture.$slideEl = undefined;
        gesture.$imageEl = undefined;
        gesture.$imageWrapEl = undefined;
      }
    },
    // Toggle Zoom
    toggle: function toggle(e) {
      var swiper = this;
      var zoom = swiper.zoom;

      if (zoom.scale && zoom.scale !== 1) {
        // Zoom Out
        zoom.out();
      } else {
        // Zoom In
        zoom.in(e);
      }
    },
    in: function in$1(e) {
      var swiper = this;

      var zoom = swiper.zoom;
      var params = swiper.params.zoom;
      var gesture = zoom.gesture;
      var image = zoom.image;

      if (!gesture.$slideEl) {
        gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }

      gesture.$slideEl.addClass(("" + (params.zoomedSlideClass)));

      var touchX;
      var touchY;
      var offsetX;
      var offsetY;
      var diffX;
      var diffY;
      var translateX;
      var translateY;
      var imageWidth;
      var imageHeight;
      var scaledWidth;
      var scaledHeight;
      var translateMinX;
      var translateMinY;
      var translateMaxX;
      var translateMaxY;
      var slideWidth;
      var slideHeight;

      if (typeof image.touchesStart.x === 'undefined' && e) {
        touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
        touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
      } else {
        touchX = image.touchesStart.x;
        touchY = image.touchesStart.y;
      }

      zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      if (e) {
        slideWidth = gesture.$slideEl[0].offsetWidth;
        slideHeight = gesture.$slideEl[0].offsetHeight;
        offsetX = gesture.$slideEl.offset().left;
        offsetY = gesture.$slideEl.offset().top;
        diffX = (offsetX + (slideWidth / 2)) - touchX;
        diffY = (offsetY + (slideHeight / 2)) - touchY;

        imageWidth = gesture.$imageEl[0].offsetWidth;
        imageHeight = gesture.$imageEl[0].offsetHeight;
        scaledWidth = imageWidth * zoom.scale;
        scaledHeight = imageHeight * zoom.scale;

        translateMinX = Math.min(((slideWidth / 2) - (scaledWidth / 2)), 0);
        translateMinY = Math.min(((slideHeight / 2) - (scaledHeight / 2)), 0);
        translateMaxX = -translateMinX;
        translateMaxY = -translateMinY;

        translateX = diffX * zoom.scale;
        translateY = diffY * zoom.scale;

        if (translateX < translateMinX) {
          translateX = translateMinX;
        }
        if (translateX > translateMaxX) {
          translateX = translateMaxX;
        }

        if (translateY < translateMinY) {
          translateY = translateMinY;
        }
        if (translateY > translateMaxY) {
          translateY = translateMaxY;
        }
      } else {
        translateX = 0;
        translateY = 0;
      }
      gesture.$imageWrapEl.transition(300).transform(("translate3d(" + translateX + "px, " + translateY + "px,0)"));
      gesture.$imageEl.transition(300).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
    },
    out: function out() {
      var swiper = this;

      var zoom = swiper.zoom;
      var params = swiper.params.zoom;
      var gesture = zoom.gesture;

      if (!gesture.$slideEl) {
        gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
        gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
        gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
      }
      if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }

      zoom.scale = 1;
      zoom.currentScale = 1;
      gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
      gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
      gesture.$slideEl.removeClass(("" + (params.zoomedSlideClass)));
      gesture.$slideEl = undefined;
    },
    // Attach/Detach Events
    enable: function enable() {
      var swiper = this;
      var zoom = swiper.zoom;
      if (zoom.enabled) { return; }
      zoom.enabled = true;

      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

      // Scale image
      if (Support.gestures) {
        swiper.$wrapperEl.on('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.on('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.on('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
      } else if (swiper.touchEvents.start === 'touchstart') {
        swiper.$wrapperEl.on(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.on(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.on(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
      }

      // Move image
      swiper.$wrapperEl.on(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove);
    },
    disable: function disable() {
      var swiper = this;
      var zoom = swiper.zoom;
      if (!zoom.enabled) { return; }

      swiper.zoom.enabled = false;

      var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

      // Scale image
      if (Support.gestures) {
        swiper.$wrapperEl.off('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.off('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.off('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
      } else if (swiper.touchEvents.start === 'touchstart') {
        swiper.$wrapperEl.off(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
        swiper.$wrapperEl.off(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
        swiper.$wrapperEl.off(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
      }

      // Move image
      swiper.$wrapperEl.off(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove);
    },
  };

  var Zoom$1 = {
    name: 'zoom',
    params: {
      zoom: {
        enabled: false,
        maxRatio: 3,
        minRatio: 1,
        toggle: true,
        containerClass: 'swiper-zoom-container',
        zoomedSlideClass: 'swiper-slide-zoomed',
      },
    },
    create: function create() {
      var swiper = this;
      var zoom = {
        enabled: false,
        scale: 1,
        currentScale: 1,
        isScaling: false,
        gesture: {
          $slideEl: undefined,
          slideWidth: undefined,
          slideHeight: undefined,
          $imageEl: undefined,
          $imageWrapEl: undefined,
          maxRatio: 3,
        },
        image: {
          isTouched: undefined,
          isMoved: undefined,
          currentX: undefined,
          currentY: undefined,
          minX: undefined,
          minY: undefined,
          maxX: undefined,
          maxY: undefined,
          width: undefined,
          height: undefined,
          startX: undefined,
          startY: undefined,
          touchesStart: {},
          touchesCurrent: {},
        },
        velocity: {
          x: undefined,
          y: undefined,
          prevPositionX: undefined,
          prevPositionY: undefined,
          prevTime: undefined,
        },
      };

      ('onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out').split(' ').forEach(function (methodName) {
        zoom[methodName] = Zoom[methodName].bind(swiper);
      });
      Utils.extend(swiper, {
        zoom: zoom,
      });

      var scale = 1;
      Object.defineProperty(swiper.zoom, 'scale', {
        get: function get() {
          return scale;
        },
        set: function set(value) {
          if (scale !== value) {
            var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
            var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
            swiper.emit('zoomChange', value, imageEl, slideEl);
          }
          scale = value;
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.zoom.enabled) {
          swiper.zoom.enable();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.zoom.disable();
      },
      touchStart: function touchStart(e) {
        var swiper = this;
        if (!swiper.zoom.enabled) { return; }
        swiper.zoom.onTouchStart(e);
      },
      touchEnd: function touchEnd(e) {
        var swiper = this;
        if (!swiper.zoom.enabled) { return; }
        swiper.zoom.onTouchEnd(e);
      },
      doubleTap: function doubleTap(e) {
        var swiper = this;
        if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
          swiper.zoom.toggle(e);
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
          swiper.zoom.onTransitionEnd();
        }
      },
    },
  };

  var Lazy = {
    loadInSlide: function loadInSlide(index, loadInDuplicate) {
      if ( loadInDuplicate === void 0 ) loadInDuplicate = true;

      var swiper = this;
      var params = swiper.params.lazy;
      if (typeof index === 'undefined') { return; }
      if (swiper.slides.length === 0) { return; }
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;

      var $slideEl = isVirtual
        ? swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]"))
        : swiper.slides.eq(index);

      var $images = $slideEl.find(("." + (params.elementClass) + ":not(." + (params.loadedClass) + "):not(." + (params.loadingClass) + ")"));
      if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
        $images = $images.add($slideEl[0]);
      }
      if ($images.length === 0) { return; }

      $images.each(function (imageIndex, imageEl) {
        var $imageEl = $(imageEl);
        $imageEl.addClass(params.loadingClass);

        var background = $imageEl.attr('data-background');
        var src = $imageEl.attr('data-src');
        var srcset = $imageEl.attr('data-srcset');
        var sizes = $imageEl.attr('data-sizes');

        swiper.loadImage($imageEl[0], (src || background), srcset, sizes, false, function () {
          if (typeof swiper === 'undefined' || swiper === null || !swiper || (swiper && !swiper.params) || swiper.destroyed) { return; }
          if (background) {
            $imageEl.css('background-image', ("url(\"" + background + "\")"));
            $imageEl.removeAttr('data-background');
          } else {
            if (srcset) {
              $imageEl.attr('srcset', srcset);
              $imageEl.removeAttr('data-srcset');
            }
            if (sizes) {
              $imageEl.attr('sizes', sizes);
              $imageEl.removeAttr('data-sizes');
            }
            if (src) {
              $imageEl.attr('src', src);
              $imageEl.removeAttr('data-src');
            }
          }

          $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
          $slideEl.find(("." + (params.preloaderClass))).remove();
          if (swiper.params.loop && loadInDuplicate) {
            var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
            if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
              var originalSlide = swiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]:not(." + (swiper.params.slideDuplicateClass) + ")"));
              swiper.lazy.loadInSlide(originalSlide.index(), false);
            } else {
              var duplicatedSlide = swiper.$wrapperEl.children(("." + (swiper.params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]"));
              swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
            }
          }
          swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
        });

        swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
      });
    },
    load: function load() {
      var swiper = this;
      var $wrapperEl = swiper.$wrapperEl;
      var swiperParams = swiper.params;
      var slides = swiper.slides;
      var activeIndex = swiper.activeIndex;
      var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
      var params = swiperParams.lazy;

      var slidesPerView = swiperParams.slidesPerView;
      if (slidesPerView === 'auto') {
        slidesPerView = 0;
      }

      function slideExist(index) {
        if (isVirtual) {
          if ($wrapperEl.children(("." + (swiperParams.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]")).length) {
            return true;
          }
        } else if (slides[index]) { return true; }
        return false;
      }
      function slideIndex(slideEl) {
        if (isVirtual) {
          return $(slideEl).attr('data-swiper-slide-index');
        }
        return $(slideEl).index();
      }

      if (!swiper.lazy.initialImageLoaded) { swiper.lazy.initialImageLoaded = true; }
      if (swiper.params.watchSlidesVisibility) {
        $wrapperEl.children(("." + (swiperParams.slideVisibleClass))).each(function (elIndex, slideEl) {
          var index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
          swiper.lazy.loadInSlide(index);
        });
      } else if (slidesPerView > 1) {
        for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
          if (slideExist(i)) { swiper.lazy.loadInSlide(i); }
        }
      } else {
        swiper.lazy.loadInSlide(activeIndex);
      }
      if (params.loadPrevNext) {
        if (slidesPerView > 1 || (params.loadPrevNextAmount && params.loadPrevNextAmount > 1)) {
          var amount = params.loadPrevNextAmount;
          var spv = slidesPerView;
          var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
          var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
          // Next Slides
          for (var i$1 = activeIndex + slidesPerView; i$1 < maxIndex; i$1 += 1) {
            if (slideExist(i$1)) { swiper.lazy.loadInSlide(i$1); }
          }
          // Prev Slides
          for (var i$2 = minIndex; i$2 < activeIndex; i$2 += 1) {
            if (slideExist(i$2)) { swiper.lazy.loadInSlide(i$2); }
          }
        } else {
          var nextSlide = $wrapperEl.children(("." + (swiperParams.slideNextClass)));
          if (nextSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(nextSlide)); }

          var prevSlide = $wrapperEl.children(("." + (swiperParams.slidePrevClass)));
          if (prevSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(prevSlide)); }
        }
      }
    },
  };

  var Lazy$1 = {
    name: 'lazy',
    params: {
      lazy: {
        enabled: false,
        loadPrevNext: false,
        loadPrevNextAmount: 1,
        loadOnTransitionStart: false,

        elementClass: 'swiper-lazy',
        loadingClass: 'swiper-lazy-loading',
        loadedClass: 'swiper-lazy-loaded',
        preloaderClass: 'swiper-lazy-preloader',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        lazy: {
          initialImageLoaded: false,
          load: Lazy.load.bind(swiper),
          loadInSlide: Lazy.loadInSlide.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
          swiper.params.preloadImages = false;
        }
      },
      init: function init() {
        var swiper = this;
        if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
          swiper.lazy.load();
        }
      },
      scroll: function scroll() {
        var swiper = this;
        if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
          swiper.lazy.load();
        }
      },
      resize: function resize() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      },
      scrollbarDragMove: function scrollbarDragMove() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          swiper.lazy.load();
        }
      },
      transitionStart: function transitionStart() {
        var swiper = this;
        if (swiper.params.lazy.enabled) {
          if (swiper.params.lazy.loadOnTransitionStart || (!swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded)) {
            swiper.lazy.load();
          }
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
          swiper.lazy.load();
        }
      },
    },
  };

  /* eslint no-bitwise: ["error", { "allow": [">>"] }] */

  var Controller = {
    LinearSpline: function LinearSpline(x, y) {
      var binarySearch = (function search() {
        var maxIndex;
        var minIndex;
        var guess;
        return function (array, val) {
          minIndex = -1;
          maxIndex = array.length;
          while (maxIndex - minIndex > 1) {
            guess = maxIndex + minIndex >> 1;
            if (array[guess] <= val) {
              minIndex = guess;
            } else {
              maxIndex = guess;
            }
          }
          return maxIndex;
        };
      }());
      this.x = x;
      this.y = y;
      this.lastIndex = x.length - 1;
      // Given an x value (x2), return the expected y2 value:
      // (x1,y1) is the known point before given value,
      // (x3,y3) is the known point after given value.
      var i1;
      var i3;

      this.interpolate = function interpolate(x2) {
        if (!x2) { return 0; }

        // Get the indexes of x1 and x3 (the array indexes before and after given x2):
        i3 = binarySearch(this.x, x2);
        i1 = i3 - 1;

        // We have our indexes i1 & i3, so we can calculate already:
        // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
        return (((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1])) + this.y[i1];
      };
      return this;
    },
    // xxx: for now i will just save one spline function to to
    getInterpolateFunction: function getInterpolateFunction(c) {
      var swiper = this;
      if (!swiper.controller.spline) {
        swiper.controller.spline = swiper.params.loop
          ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid)
          : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
      }
    },
    setTranslate: function setTranslate(setTranslate$1, byController) {
      var swiper = this;
      var controlled = swiper.controller.control;
      var multiplier;
      var controlledTranslate;
      function setControlledTranslate(c) {
        // this will create an Interpolate function based on the snapGrids
        // x is the Grid of the scrolled scroller and y will be the controlled scroller
        // it makes sense to create this only once and recall it for the interpolation
        // the function does a lot of value caching for performance
        var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
        if (swiper.params.controller.by === 'slide') {
          swiper.controller.getInterpolateFunction(c);
          // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
          // but it did not work out
          controlledTranslate = -swiper.controller.spline.interpolate(-translate);
        }

        if (!controlledTranslate || swiper.params.controller.by === 'container') {
          multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
          controlledTranslate = ((translate - swiper.minTranslate()) * multiplier) + c.minTranslate();
        }

        if (swiper.params.controller.inverse) {
          controlledTranslate = c.maxTranslate() - controlledTranslate;
        }
        c.updateProgress(controlledTranslate);
        c.setTranslate(controlledTranslate, swiper);
        c.updateActiveIndex();
        c.updateSlidesClasses();
      }
      if (Array.isArray(controlled)) {
        for (var i = 0; i < controlled.length; i += 1) {
          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
            setControlledTranslate(controlled[i]);
          }
        }
      } else if (controlled instanceof Swiper && byController !== controlled) {
        setControlledTranslate(controlled);
      }
    },
    setTransition: function setTransition(duration, byController) {
      var swiper = this;
      var controlled = swiper.controller.control;
      var i;
      function setControlledTransition(c) {
        c.setTransition(duration, swiper);
        if (duration !== 0) {
          c.transitionStart();
          if (c.params.autoHeight) {
            Utils.nextTick(function () {
              c.updateAutoHeight();
            });
          }
          c.$wrapperEl.transitionEnd(function () {
            if (!controlled) { return; }
            if (c.params.loop && swiper.params.controller.by === 'slide') {
              c.loopFix();
            }
            c.transitionEnd();
          });
        }
      }
      if (Array.isArray(controlled)) {
        for (i = 0; i < controlled.length; i += 1) {
          if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
            setControlledTransition(controlled[i]);
          }
        }
      } else if (controlled instanceof Swiper && byController !== controlled) {
        setControlledTransition(controlled);
      }
    },
  };
  var Controller$1 = {
    name: 'controller',
    params: {
      controller: {
        control: undefined,
        inverse: false,
        by: 'slide', // or 'container'
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        controller: {
          control: swiper.params.controller.control,
          getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
          setTranslate: Controller.setTranslate.bind(swiper),
          setTransition: Controller.setTransition.bind(swiper),
        },
      });
    },
    on: {
      update: function update() {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      resize: function resize() {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      },
      setTranslate: function setTranslate(translate, byController) {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        swiper.controller.setTranslate(translate, byController);
      },
      setTransition: function setTransition(duration, byController) {
        var swiper = this;
        if (!swiper.controller.control) { return; }
        swiper.controller.setTransition(duration, byController);
      },
    },
  };

  var a11y = {
    makeElFocusable: function makeElFocusable($el) {
      $el.attr('tabIndex', '0');
      return $el;
    },
    addElRole: function addElRole($el, role) {
      $el.attr('role', role);
      return $el;
    },
    addElLabel: function addElLabel($el, label) {
      $el.attr('aria-label', label);
      return $el;
    },
    disableEl: function disableEl($el) {
      $el.attr('aria-disabled', true);
      return $el;
    },
    enableEl: function enableEl($el) {
      $el.attr('aria-disabled', false);
      return $el;
    },
    onEnterKey: function onEnterKey(e) {
      var swiper = this;
      var params = swiper.params.a11y;
      if (e.keyCode !== 13) { return; }
      var $targetEl = $(e.target);
      if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
        if (!(swiper.isEnd && !swiper.params.loop)) {
          swiper.slideNext();
        }
        if (swiper.isEnd) {
          swiper.a11y.notify(params.lastSlideMessage);
        } else {
          swiper.a11y.notify(params.nextSlideMessage);
        }
      }
      if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
        if (!(swiper.isBeginning && !swiper.params.loop)) {
          swiper.slidePrev();
        }
        if (swiper.isBeginning) {
          swiper.a11y.notify(params.firstSlideMessage);
        } else {
          swiper.a11y.notify(params.prevSlideMessage);
        }
      }
      if (swiper.pagination && $targetEl.is(("." + (swiper.params.pagination.bulletClass)))) {
        $targetEl[0].click();
      }
    },
    notify: function notify(message) {
      var swiper = this;
      var notification = swiper.a11y.liveRegion;
      if (notification.length === 0) { return; }
      notification.html('');
      notification.html(message);
    },
    updateNavigation: function updateNavigation() {
      var swiper = this;

      if (swiper.params.loop) { return; }
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;

      if ($prevEl && $prevEl.length > 0) {
        if (swiper.isBeginning) {
          swiper.a11y.disableEl($prevEl);
        } else {
          swiper.a11y.enableEl($prevEl);
        }
      }
      if ($nextEl && $nextEl.length > 0) {
        if (swiper.isEnd) {
          swiper.a11y.disableEl($nextEl);
        } else {
          swiper.a11y.enableEl($nextEl);
        }
      }
    },
    updatePagination: function updatePagination() {
      var swiper = this;
      var params = swiper.params.a11y;
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.bullets.each(function (bulletIndex, bulletEl) {
          var $bulletEl = $(bulletEl);
          swiper.a11y.makeElFocusable($bulletEl);
          swiper.a11y.addElRole($bulletEl, 'button');
          swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/{{index}}/, $bulletEl.index() + 1));
        });
      }
    },
    init: function init() {
      var swiper = this;

      swiper.$el.append(swiper.a11y.liveRegion);

      // Navigation
      var params = swiper.params.a11y;
      var $nextEl;
      var $prevEl;
      if (swiper.navigation && swiper.navigation.$nextEl) {
        $nextEl = swiper.navigation.$nextEl;
      }
      if (swiper.navigation && swiper.navigation.$prevEl) {
        $prevEl = swiper.navigation.$prevEl;
      }
      if ($nextEl) {
        swiper.a11y.makeElFocusable($nextEl);
        swiper.a11y.addElRole($nextEl, 'button');
        swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
        $nextEl.on('keydown', swiper.a11y.onEnterKey);
      }
      if ($prevEl) {
        swiper.a11y.makeElFocusable($prevEl);
        swiper.a11y.addElRole($prevEl, 'button');
        swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
        $prevEl.on('keydown', swiper.a11y.onEnterKey);
      }

      // Pagination
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.$el.on('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) { swiper.a11y.liveRegion.remove(); }

      var $nextEl;
      var $prevEl;
      if (swiper.navigation && swiper.navigation.$nextEl) {
        $nextEl = swiper.navigation.$nextEl;
      }
      if (swiper.navigation && swiper.navigation.$prevEl) {
        $prevEl = swiper.navigation.$prevEl;
      }
      if ($nextEl) {
        $nextEl.off('keydown', swiper.a11y.onEnterKey);
      }
      if ($prevEl) {
        $prevEl.off('keydown', swiper.a11y.onEnterKey);
      }

      // Pagination
      if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
        swiper.pagination.$el.off('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
      }
    },
  };
  var A11y = {
    name: 'a11y',
    params: {
      a11y: {
        enabled: true,
        notificationClass: 'swiper-notification',
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
        paginationBulletMessage: 'Go to slide {{index}}',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        a11y: {
          liveRegion: $(("<span class=\"" + (swiper.params.a11y.notificationClass) + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")),
        },
      });
      Object.keys(a11y).forEach(function (methodName) {
        swiper.a11y[methodName] = a11y[methodName].bind(swiper);
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.init();
        swiper.a11y.updateNavigation();
      },
      toEdge: function toEdge() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.updateNavigation();
      },
      fromEdge: function fromEdge() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.updateNavigation();
      },
      paginationUpdate: function paginationUpdate() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.updatePagination();
      },
      destroy: function destroy() {
        var swiper = this;
        if (!swiper.params.a11y.enabled) { return; }
        swiper.a11y.destroy();
      },
    },
  };

  var History = {
    init: function init() {
      var swiper = this;
      if (!swiper.params.history) { return; }
      if (!win.history || !win.history.pushState) {
        swiper.params.history.enabled = false;
        swiper.params.hashNavigation.enabled = true;
        return;
      }
      var history = swiper.history;
      history.initialized = true;
      history.paths = History.getPathValues();
      if (!history.paths.key && !history.paths.value) { return; }
      history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
      if (!swiper.params.history.replaceState) {
        win.addEventListener('popstate', swiper.history.setHistoryPopState);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (!swiper.params.history.replaceState) {
        win.removeEventListener('popstate', swiper.history.setHistoryPopState);
      }
    },
    setHistoryPopState: function setHistoryPopState() {
      var swiper = this;
      swiper.history.paths = History.getPathValues();
      swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
    },
    getPathValues: function getPathValues() {
      var pathArray = win.location.pathname.slice(1).split('/').filter(function (part) { return part !== ''; });
      var total = pathArray.length;
      var key = pathArray[total - 2];
      var value = pathArray[total - 1];
      return { key: key, value: value };
    },
    setHistory: function setHistory(key, index) {
      var swiper = this;
      if (!swiper.history.initialized || !swiper.params.history.enabled) { return; }
      var slide = swiper.slides.eq(index);
      var value = History.slugify(slide.attr('data-history'));
      if (!win.location.pathname.includes(key)) {
        value = key + "/" + value;
      }
      var currentState = win.history.state;
      if (currentState && currentState.value === value) {
        return;
      }
      if (swiper.params.history.replaceState) {
        win.history.replaceState({ value: value }, null, value);
      } else {
        win.history.pushState({ value: value }, null, value);
      }
    },
    slugify: function slugify(text) {
      return text.toString()
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
    },
    scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
      var swiper = this;
      if (value) {
        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
          var slide = swiper.slides.eq(i);
          var slideHistory = History.slugify(slide.attr('data-history'));
          if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
            var index = slide.index();
            swiper.slideTo(index, speed, runCallbacks);
          }
        }
      } else {
        swiper.slideTo(0, speed, runCallbacks);
      }
    },
  };

  var History$1 = {
    name: 'history',
    params: {
      history: {
        enabled: false,
        replaceState: false,
        key: 'slides',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        history: {
          init: History.init.bind(swiper),
          setHistory: History.setHistory.bind(swiper),
          setHistoryPopState: History.setHistoryPopState.bind(swiper),
          scrollToSlide: History.scrollToSlide.bind(swiper),
          destroy: History.destroy.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.history.enabled) {
          swiper.history.init();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.params.history.enabled) {
          swiper.history.destroy();
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.history.initialized) {
          swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
        }
      },
    },
  };

  var HashNavigation = {
    onHashCange: function onHashCange() {
      var swiper = this;
      var newHash = doc.location.hash.replace('#', '');
      var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
      if (newHash !== activeSlideHash) {
        var newIndex = swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-hash=\"" + newHash + "\"]")).index();
        if (typeof newIndex === 'undefined') { return; }
        swiper.slideTo(newIndex);
      }
    },
    setHash: function setHash() {
      var swiper = this;
      if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) { return; }
      if (swiper.params.hashNavigation.replaceState && win.history && win.history.replaceState) {
        win.history.replaceState(null, null, (("#" + (swiper.slides.eq(swiper.activeIndex).attr('data-hash'))) || ''));
      } else {
        var slide = swiper.slides.eq(swiper.activeIndex);
        var hash = slide.attr('data-hash') || slide.attr('data-history');
        doc.location.hash = hash || '';
      }
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.hashNavigation.enabled || (swiper.params.history && swiper.params.history.enabled)) { return; }
      swiper.hashNavigation.initialized = true;
      var hash = doc.location.hash.replace('#', '');
      if (hash) {
        var speed = 0;
        for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
          var slide = swiper.slides.eq(i);
          var slideHash = slide.attr('data-hash') || slide.attr('data-history');
          if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
            var index = slide.index();
            swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
          }
        }
      }
      if (swiper.params.hashNavigation.watchState) {
        $(win).on('hashchange', swiper.hashNavigation.onHashCange);
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.params.hashNavigation.watchState) {
        $(win).off('hashchange', swiper.hashNavigation.onHashCange);
      }
    },
  };
  var HashNavigation$1 = {
    name: 'hash-navigation',
    params: {
      hashNavigation: {
        enabled: false,
        replaceState: false,
        watchState: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        hashNavigation: {
          initialized: false,
          init: HashNavigation.init.bind(swiper),
          destroy: HashNavigation.destroy.bind(swiper),
          setHash: HashNavigation.setHash.bind(swiper),
          onHashCange: HashNavigation.onHashCange.bind(swiper),
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.hashNavigation.enabled) {
          swiper.hashNavigation.init();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.params.hashNavigation.enabled) {
          swiper.hashNavigation.destroy();
        }
      },
      transitionEnd: function transitionEnd() {
        var swiper = this;
        if (swiper.hashNavigation.initialized) {
          swiper.hashNavigation.setHash();
        }
      },
    },
  };

  /* eslint no-underscore-dangle: "off" */

  var Autoplay = {
    run: function run() {
      var swiper = this;
      var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
      var delay = swiper.params.autoplay.delay;
      if ($activeSlideEl.attr('data-swiper-autoplay')) {
        delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
      }
      clearTimeout(swiper.autoplay.timeout);
      swiper.autoplay.timeout = Utils.nextTick(function () {
        if (swiper.params.autoplay.reverseDirection) {
          if (swiper.params.loop) {
            swiper.loopFix();
            swiper.slidePrev(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.isBeginning) {
            swiper.slidePrev(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.params.autoplay.stopOnLastSlide) {
            swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else {
            swiper.autoplay.stop();
          }
        } else if (swiper.params.loop) {
          swiper.loopFix();
          swiper.slideNext(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.isEnd) {
          swiper.slideNext(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(0, swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else {
          swiper.autoplay.stop();
        }
      }, delay);
    },
    start: function start() {
      var swiper = this;
      if (typeof swiper.autoplay.timeout !== 'undefined') { return false; }
      if (swiper.autoplay.running) { return false; }
      swiper.autoplay.running = true;
      swiper.emit('autoplayStart');
      swiper.autoplay.run();
      return true;
    },
    stop: function stop() {
      var swiper = this;
      if (!swiper.autoplay.running) { return false; }
      if (typeof swiper.autoplay.timeout === 'undefined') { return false; }

      if (swiper.autoplay.timeout) {
        clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.timeout = undefined;
      }
      swiper.autoplay.running = false;
      swiper.emit('autoplayStop');
      return true;
    },
    pause: function pause(speed) {
      var swiper = this;
      if (!swiper.autoplay.running) { return; }
      if (swiper.autoplay.paused) { return; }
      if (swiper.autoplay.timeout) { clearTimeout(swiper.autoplay.timeout); }
      swiper.autoplay.paused = true;
      if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
        swiper.autoplay.paused = false;
        swiper.autoplay.run();
      } else {
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
      }
    },
  };

  var Autoplay$1 = {
    name: 'autoplay',
    params: {
      autoplay: {
        enabled: false,
        delay: 3000,
        waitForTransition: true,
        disableOnInteraction: true,
        stopOnLastSlide: false,
        reverseDirection: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        autoplay: {
          running: false,
          paused: false,
          run: Autoplay.run.bind(swiper),
          start: Autoplay.start.bind(swiper),
          stop: Autoplay.stop.bind(swiper),
          pause: Autoplay.pause.bind(swiper),
          onTransitionEnd: function onTransitionEnd(e) {
            if (!swiper || swiper.destroyed || !swiper.$wrapperEl) { return; }
            if (e.target !== this) { return; }
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
            swiper.autoplay.paused = false;
            if (!swiper.autoplay.running) {
              swiper.autoplay.stop();
            } else {
              swiper.autoplay.run();
            }
          },
        },
      });
    },
    on: {
      init: function init() {
        var swiper = this;
        if (swiper.params.autoplay.enabled) {
          swiper.autoplay.start();
        }
      },
      beforeTransitionStart: function beforeTransitionStart(speed, internal) {
        var swiper = this;
        if (swiper.autoplay.running) {
          if (internal || !swiper.params.autoplay.disableOnInteraction) {
            swiper.autoplay.pause(speed);
          } else {
            swiper.autoplay.stop();
          }
        }
      },
      sliderFirstMove: function sliderFirstMove() {
        var swiper = this;
        if (swiper.autoplay.running) {
          if (swiper.params.autoplay.disableOnInteraction) {
            swiper.autoplay.stop();
          } else {
            swiper.autoplay.pause();
          }
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.autoplay.running) {
          swiper.autoplay.stop();
        }
      },
    },
  };

  var Fade = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var slides = swiper.slides;
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = swiper.slides.eq(i);
        var offset = $slideEl[0].swiperSlideOffset;
        var tx = -offset;
        if (!swiper.params.virtualTranslate) { tx -= swiper.translate; }
        var ty = 0;
        if (!swiper.isHorizontal()) {
          ty = tx;
          tx = 0;
        }
        var slideOpacity = swiper.params.fadeEffect.crossFade
          ? Math.max(1 - Math.abs($slideEl[0].progress), 0)
          : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
        $slideEl
          .css({
            opacity: slideOpacity,
          })
          .transform(("translate3d(" + tx + "px, " + ty + "px, 0px)"));
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var slides = swiper.slides;
      var $wrapperEl = swiper.$wrapperEl;
      slides.transition(duration);
      if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        slides.transitionEnd(function () {
          if (eventTriggered) { return; }
          if (!swiper || swiper.destroyed) { return; }
          eventTriggered = true;
          swiper.animating = false;
          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
          for (var i = 0; i < triggerEvents.length; i += 1) {
            $wrapperEl.trigger(triggerEvents[i]);
          }
        });
      }
    },
  };

  var EffectFade = {
    name: 'effect-fade',
    params: {
      fadeEffect: {
        crossFade: false,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        fadeEffect: {
          setTranslate: Fade.setTranslate.bind(swiper),
          setTransition: Fade.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'fade') { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "fade"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'fade') { return; }
        swiper.fadeEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'fade') { return; }
        swiper.fadeEffect.setTransition(duration);
      },
    },
  };

  var Cube = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var $el = swiper.$el;
      var $wrapperEl = swiper.$wrapperEl;
      var slides = swiper.slides;
      var swiperWidth = swiper.width;
      var swiperHeight = swiper.height;
      var rtl = swiper.rtlTranslate;
      var swiperSize = swiper.size;
      var params = swiper.params.cubeEffect;
      var isHorizontal = swiper.isHorizontal();
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      var wrapperRotate = 0;
      var $cubeShadowEl;
      if (params.shadow) {
        if (isHorizontal) {
          $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
          if ($cubeShadowEl.length === 0) {
            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
            $wrapperEl.append($cubeShadowEl);
          }
          $cubeShadowEl.css({ height: (swiperWidth + "px") });
        } else {
          $cubeShadowEl = $el.find('.swiper-cube-shadow');
          if ($cubeShadowEl.length === 0) {
            $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
            $el.append($cubeShadowEl);
          }
        }
      }
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = slides.eq(i);
        var slideIndex = i;
        if (isVirtual) {
          slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
        }
        var slideAngle = slideIndex * 90;
        var round = Math.floor(slideAngle / 360);
        if (rtl) {
          slideAngle = -slideAngle;
          round = Math.floor(-slideAngle / 360);
        }
        var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
        var tx = 0;
        var ty = 0;
        var tz = 0;
        if (slideIndex % 4 === 0) {
          tx = -round * 4 * swiperSize;
          tz = 0;
        } else if ((slideIndex - 1) % 4 === 0) {
          tx = 0;
          tz = -round * 4 * swiperSize;
        } else if ((slideIndex - 2) % 4 === 0) {
          tx = swiperSize + (round * 4 * swiperSize);
          tz = swiperSize;
        } else if ((slideIndex - 3) % 4 === 0) {
          tx = -swiperSize;
          tz = (3 * swiperSize) + (swiperSize * 4 * round);
        }
        if (rtl) {
          tx = -tx;
        }

        if (!isHorizontal) {
          ty = tx;
          tx = 0;
        }

        var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";
        if (progress <= 1 && progress > -1) {
          wrapperRotate = (slideIndex * 90) + (progress * 90);
          if (rtl) { wrapperRotate = (-slideIndex * 90) - (progress * 90); }
        }
        $slideEl.transform(transform);
        if (params.slideShadows) {
          // Set shadows
          var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if (shadowBefore.length === 0) {
            shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
            $slideEl.append(shadowBefore);
          }
          if (shadowAfter.length === 0) {
            shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
            $slideEl.append(shadowAfter);
          }
          if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
          if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
        }
      }
      $wrapperEl.css({
        '-webkit-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
        '-moz-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
        '-ms-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
        'transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
      });

      if (params.shadow) {
        if (isHorizontal) {
          $cubeShadowEl.transform(("translate3d(0px, " + ((swiperWidth / 2) + params.shadowOffset) + "px, " + (-swiperWidth / 2) + "px) rotateX(90deg) rotateZ(0deg) scale(" + (params.shadowScale) + ")"));
        } else {
          var shadowAngle = Math.abs(wrapperRotate) - (Math.floor(Math.abs(wrapperRotate) / 90) * 90);
          var multiplier = 1.5 - (
            (Math.sin((shadowAngle * 2 * Math.PI) / 360) / 2)
            + (Math.cos((shadowAngle * 2 * Math.PI) / 360) / 2)
          );
          var scale1 = params.shadowScale;
          var scale2 = params.shadowScale / multiplier;
          var offset = params.shadowOffset;
          $cubeShadowEl.transform(("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + ((swiperHeight / 2) + offset) + "px, " + (-swiperHeight / 2 / scale2) + "px) rotateX(-90deg)"));
        }
      }
      var zFactor = (Browser.isSafari || Browser.isUiWebView) ? (-swiperSize / 2) : 0;
      $wrapperEl
        .transform(("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)"));
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var $el = swiper.$el;
      var slides = swiper.slides;
      slides
        .transition(duration)
        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
        .transition(duration);
      if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
        $el.find('.swiper-cube-shadow').transition(duration);
      }
    },
  };

  var EffectCube = {
    name: 'effect-cube',
    params: {
      cubeEffect: {
        slideShadows: true,
        shadow: true,
        shadowOffset: 20,
        shadowScale: 0.94,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        cubeEffect: {
          setTranslate: Cube.setTranslate.bind(swiper),
          setTransition: Cube.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'cube') { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "cube"));
        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          resistanceRatio: 0,
          spaceBetween: 0,
          centeredSlides: false,
          virtualTranslate: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'cube') { return; }
        swiper.cubeEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'cube') { return; }
        swiper.cubeEffect.setTransition(duration);
      },
    },
  };

  var Flip = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var slides = swiper.slides;
      var rtl = swiper.rtlTranslate;
      for (var i = 0; i < slides.length; i += 1) {
        var $slideEl = slides.eq(i);
        var progress = $slideEl[0].progress;
        if (swiper.params.flipEffect.limitRotation) {
          progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
        }
        var offset = $slideEl[0].swiperSlideOffset;
        var rotate = -180 * progress;
        var rotateY = rotate;
        var rotateX = 0;
        var tx = -offset;
        var ty = 0;
        if (!swiper.isHorizontal()) {
          ty = tx;
          tx = 0;
          rotateX = -rotateY;
          rotateY = 0;
        } else if (rtl) {
          rotateY = -rotateY;
        }

        $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

        if (swiper.params.flipEffect.slideShadows) {
          // Set shadows
          var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if (shadowBefore.length === 0) {
            shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'left' : 'top') + "\"></div>"));
            $slideEl.append(shadowBefore);
          }
          if (shadowAfter.length === 0) {
            shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'right' : 'bottom') + "\"></div>"));
            $slideEl.append(shadowAfter);
          }
          if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
          if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
        }
        $slideEl
          .transform(("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)"));
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var slides = swiper.slides;
      var activeIndex = swiper.activeIndex;
      var $wrapperEl = swiper.$wrapperEl;
      slides
        .transition(duration)
        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
        .transition(duration);
      if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        // eslint-disable-next-line
        slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
          if (eventTriggered) { return; }
          if (!swiper || swiper.destroyed) { return; }
          // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
          eventTriggered = true;
          swiper.animating = false;
          var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
          for (var i = 0; i < triggerEvents.length; i += 1) {
            $wrapperEl.trigger(triggerEvents[i]);
          }
        });
      }
    },
  };

  var EffectFlip = {
    name: 'effect-flip',
    params: {
      flipEffect: {
        slideShadows: true,
        limitRotation: true,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        flipEffect: {
          setTranslate: Flip.setTranslate.bind(swiper),
          setTransition: Flip.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'flip') { return; }
        swiper.classNames.push(((swiper.params.containerModifierClass) + "flip"));
        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
        var overwriteParams = {
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: true,
        };
        Utils.extend(swiper.params, overwriteParams);
        Utils.extend(swiper.originalParams, overwriteParams);
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'flip') { return; }
        swiper.flipEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'flip') { return; }
        swiper.flipEffect.setTransition(duration);
      },
    },
  };

  var Coverflow = {
    setTranslate: function setTranslate() {
      var swiper = this;
      var swiperWidth = swiper.width;
      var swiperHeight = swiper.height;
      var slides = swiper.slides;
      var $wrapperEl = swiper.$wrapperEl;
      var slidesSizesGrid = swiper.slidesSizesGrid;
      var params = swiper.params.coverflowEffect;
      var isHorizontal = swiper.isHorizontal();
      var transform = swiper.translate;
      var center = isHorizontal ? -transform + (swiperWidth / 2) : -transform + (swiperHeight / 2);
      var rotate = isHorizontal ? params.rotate : -params.rotate;
      var translate = params.depth;
      // Each slide offset from center
      for (var i = 0, length = slides.length; i < length; i += 1) {
        var $slideEl = slides.eq(i);
        var slideSize = slidesSizesGrid[i];
        var slideOffset = $slideEl[0].swiperSlideOffset;
        var offsetMultiplier = ((center - slideOffset - (slideSize / 2)) / slideSize) * params.modifier;

        var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
        var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
        // var rotateZ = 0
        var translateZ = -translate * Math.abs(offsetMultiplier);

        var translateY = isHorizontal ? 0 : params.stretch * (offsetMultiplier);
        var translateX = isHorizontal ? params.stretch * (offsetMultiplier) : 0;

        // Fix for ultra small values
        if (Math.abs(translateX) < 0.001) { translateX = 0; }
        if (Math.abs(translateY) < 0.001) { translateY = 0; }
        if (Math.abs(translateZ) < 0.001) { translateZ = 0; }
        if (Math.abs(rotateY) < 0.001) { rotateY = 0; }
        if (Math.abs(rotateX) < 0.001) { rotateX = 0; }

        var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)";

        $slideEl.transform(slideTransform);
        $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
        if (params.slideShadows) {
          // Set shadows
          var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
          var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
          if ($shadowBeforeEl.length === 0) {
            $shadowBeforeEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
            $slideEl.append($shadowBeforeEl);
          }
          if ($shadowAfterEl.length === 0) {
            $shadowAfterEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
            $slideEl.append($shadowAfterEl);
          }
          if ($shadowBeforeEl.length) { $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0; }
          if ($shadowAfterEl.length) { $shadowAfterEl[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0; }
        }
      }

      // Set correct perspective for IE10
      if (Support.pointerEvents || Support.prefixedPointerEvents) {
        var ws = $wrapperEl[0].style;
        ws.perspectiveOrigin = center + "px 50%";
      }
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      swiper.slides
        .transition(duration)
        .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
        .transition(duration);
    },
  };

  var EffectCoverflow = {
    name: 'effect-coverflow',
    params: {
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true,
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        coverflowEffect: {
          setTranslate: Coverflow.setTranslate.bind(swiper),
          setTransition: Coverflow.setTransition.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') { return; }

        swiper.classNames.push(((swiper.params.containerModifierClass) + "coverflow"));
        swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));

        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') { return; }
        swiper.coverflowEffect.setTranslate();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (swiper.params.effect !== 'coverflow') { return; }
        swiper.coverflowEffect.setTransition(duration);
      },
    },
  };

  var Thumbs = {
    init: function init() {
      var swiper = this;
      var ref = swiper.params;
      var thumbsParams = ref.thumbs;
      var SwiperClass = swiper.constructor;
      if (thumbsParams.swiper instanceof SwiperClass) {
        swiper.thumbs.swiper = thumbsParams.swiper;
        Utils.extend(swiper.thumbs.swiper.originalParams, {
          watchSlidesProgress: true,
          slideToClickedSlide: false,
        });
        Utils.extend(swiper.thumbs.swiper.params, {
          watchSlidesProgress: true,
          slideToClickedSlide: false,
        });
      } else if (Utils.isObject(thumbsParams.swiper)) {
        swiper.thumbs.swiper = new SwiperClass(Utils.extend({}, thumbsParams.swiper, {
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          slideToClickedSlide: false,
        }));
        swiper.thumbs.swiperCreated = true;
      }
      swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
      swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
    },
    onThumbClick: function onThumbClick() {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) { return; }
      var clickedIndex = thumbsSwiper.clickedIndex;
      var clickedSlide = thumbsSwiper.clickedSlide;
      if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) { return; }
      if (typeof clickedIndex === 'undefined' || clickedIndex === null) { return; }
      var slideToIndex;
      if (thumbsSwiper.params.loop) {
        slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
      } else {
        slideToIndex = clickedIndex;
      }
      if (swiper.params.loop) {
        var currentIndex = swiper.activeIndex;
        if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
          swiper.loopFix();
          // eslint-disable-next-line
          swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
          currentIndex = swiper.activeIndex;
        }
        var prevIndex = swiper.slides.eq(currentIndex).prevAll(("[data-swiper-slide-index=\"" + slideToIndex + "\"]")).eq(0).index();
        var nextIndex = swiper.slides.eq(currentIndex).nextAll(("[data-swiper-slide-index=\"" + slideToIndex + "\"]")).eq(0).index();
        if (typeof prevIndex === 'undefined') { slideToIndex = nextIndex; }
        else if (typeof nextIndex === 'undefined') { slideToIndex = prevIndex; }
        else if (nextIndex - currentIndex < currentIndex - prevIndex) { slideToIndex = nextIndex; }
        else { slideToIndex = prevIndex; }
      }
      swiper.slideTo(slideToIndex);
    },
    update: function update(initial) {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) { return; }

      var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto'
        ? thumbsSwiper.slidesPerViewDynamic()
        : thumbsSwiper.params.slidesPerView;

      if (swiper.realIndex !== thumbsSwiper.realIndex) {
        var currentThumbsIndex = thumbsSwiper.activeIndex;
        var newThumbsIndex;
        if (thumbsSwiper.params.loop) {
          if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
            thumbsSwiper.loopFix();
            // eslint-disable-next-line
            thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
            currentThumbsIndex = thumbsSwiper.activeIndex;
          }
          // Find actual thumbs index to slide to
          var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(("[data-swiper-slide-index=\"" + (swiper.realIndex) + "\"]")).eq(0).index();
          var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(("[data-swiper-slide-index=\"" + (swiper.realIndex) + "\"]")).eq(0).index();
          if (typeof prevThumbsIndex === 'undefined') { newThumbsIndex = nextThumbsIndex; }
          else if (typeof nextThumbsIndex === 'undefined') { newThumbsIndex = prevThumbsIndex; }
          else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) { newThumbsIndex = currentThumbsIndex; }
          else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) { newThumbsIndex = nextThumbsIndex; }
          else { newThumbsIndex = prevThumbsIndex; }
        } else {
          newThumbsIndex = swiper.realIndex;
        }
        if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
          if (thumbsSwiper.params.centeredSlides) {
            if (newThumbsIndex > currentThumbsIndex) {
              newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
            } else {
              newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
            }
          } else if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - slidesPerView + 1;
          }
          thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
        }
      }

      // Activate thumbs
      var thumbsToActivate = 1;
      var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

      if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
        thumbsToActivate = swiper.params.slidesPerView;
      }

      thumbsSwiper.slides.removeClass(thumbActiveClass);
      if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual) {
        for (var i = 0; i < thumbsToActivate; i += 1) {
          thumbsSwiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + (swiper.realIndex + i) + "\"]")).addClass(thumbActiveClass);
        }
      } else {
        for (var i$1 = 0; i$1 < thumbsToActivate; i$1 += 1) {
          thumbsSwiper.slides.eq(swiper.realIndex + i$1).addClass(thumbActiveClass);
        }
      }
    },
  };
  var Thumbs$1 = {
    name: 'thumbs',
    params: {
      thumbs: {
        swiper: null,
        slideThumbActiveClass: 'swiper-slide-thumb-active',
        thumbsContainerClass: 'swiper-container-thumbs',
      },
    },
    create: function create() {
      var swiper = this;
      Utils.extend(swiper, {
        thumbs: {
          swiper: null,
          init: Thumbs.init.bind(swiper),
          update: Thumbs.update.bind(swiper),
          onThumbClick: Thumbs.onThumbClick.bind(swiper),
        },
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var swiper = this;
        var ref = swiper.params;
        var thumbs = ref.thumbs;
        if (!thumbs || !thumbs.swiper) { return; }
        swiper.thumbs.init();
        swiper.thumbs.update(true);
      },
      slideChange: function slideChange() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      update: function update() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      resize: function resize() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      observerUpdate: function observerUpdate() {
        var swiper = this;
        if (!swiper.thumbs.swiper) { return; }
        swiper.thumbs.update();
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) { return; }
        thumbsSwiper.setTransition(duration);
      },
      beforeDestroy: function beforeDestroy() {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) { return; }
        if (swiper.thumbs.swiperCreated && thumbsSwiper) {
          thumbsSwiper.destroy();
        }
      },
    },
  };

  // Swiper Class

  var components = [
    Device$1,
    Support$1,
    Browser$1,
    Resize,
    Observer$1,
    Virtual$1,
    Keyboard$1,
    Mousewheel$1,
    Navigation$1,
    Pagination$1,
    Scrollbar$1,
    Parallax$1,
    Zoom$1,
    Lazy$1,
    Controller$1,
    A11y,
    History$1,
    HashNavigation$1,
    Autoplay$1,
    EffectFade,
    EffectCube,
    EffectFlip,
    EffectCoverflow,
    Thumbs$1
  ];

  if (typeof Swiper.use === 'undefined') {
    Swiper.use = Swiper.Class.use;
    Swiper.installModule = Swiper.Class.installModule;
  }

  Swiper.use(components);

  return Swiper;

}));


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(626)();
}


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(152);
var invariant = __webpack_require__(62);
var ReactPropTypesSecret = __webpack_require__(627);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var cn = exports.cn = function cn(className) {
    return typeof className === 'string' ? className.split('.').join(' ').trim() : '';
};

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _innerSlider = __webpack_require__(630);

var _json2mq = __webpack_require__(637);

var _json2mq2 = _interopRequireDefault(_json2mq);

var _defaultProps = __webpack_require__(639);

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _innerSliderUtils = __webpack_require__(153);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(640);

var Slider = function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.innerSliderRefHandler = function (ref) {
      return _this.innerSlider = ref;
    };

    _this.slickPrev = function () {
      return _this.innerSlider.slickPrev();
    };

    _this.slickNext = function () {
      return _this.innerSlider.slickNext();
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    };

    _this.slickPause = function () {
      return _this.innerSlider.pause("paused");
    };

    _this.slickPlay = function () {
      return _this.innerSlider.autoPlay("play");
    };

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  Slider.prototype.media = function media(query, handler) {
    // javascript handler for  css media query
    enquire.register(query, handler);
    this._responsiveMediaHandlers.push({ query: query, handler: handler });
  };

  // handles responsive breakpoints


  Slider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // performance monitoring
    //if (process.env.NODE_ENV !== 'production') {
    //const { whyDidYouUpdate } = require('why-did-you-update')
    //whyDidYouUpdate(React)
    //}
    if (this.props.responsive) {
      var breakpoints = this.props.responsive.map(function (breakpt) {
        return breakpt.breakpoint;
      });
      // sort them in increasing order of their numerical value
      breakpoints.sort(function (x, y) {
        return x - y;
      });

      breakpoints.forEach(function (breakpoint, index) {
        // media query for each breakpoint
        var bQuery = void 0;
        if (index === 0) {
          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
        } else {
          bQuery = (0, _json2mq2.default)({
            minWidth: breakpoints[index - 1] + 1,
            maxWidth: breakpoint
          });
        }
        // when not using server side rendering
        (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
          _this2.setState({ breakpoint: breakpoint });
        });
      });

      // Register media query for full screen. Need to support resize from small to large
      // convert javascript object to media query string
      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });

      (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
        _this2.setState({ breakpoint: null });
      });
    }
  };

  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
    this._responsiveMediaHandlers.forEach(function (obj) {
      enquire.unregister(obj.query, obj.handler);
    });
  };

  Slider.prototype.render = function render() {
    var _this3 = this;

    var settings;
    var newProps;
    if (this.state.breakpoint) {
      newProps = this.props.responsive.filter(function (resp) {
        return resp.breakpoint === _this3.state.breakpoint;
      });
      settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
    } else {
      settings = _extends({}, _defaultProps2.default, this.props);
    }

    // force scrolling by one if centerMode is on
    if (settings.centerMode) {
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
      }
      settings.slidesToScroll = 1;
    }
    // force showing one slide and scrolling by one if the fade mode is on
    if (settings.fade) {
      if (settings.slidesToShow > 1 && "production" !== "production") {
        console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
      }
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
      }
      settings.slidesToShow = 1;
      settings.slidesToScroll = 1;
    }

    // makes sure that children is an array, even when there is only 1 child
    var children = _react2.default.Children.toArray(this.props.children);

    // Children may contain false or null, so we should filter them
    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
    children = children.filter(function (child) {
      if (typeof child === "string") {
        return !!child.trim();
      }
      return !!child;
    });

    // rows and slidesPerRow logic is handled here
    if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
      console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
      settings.variableWidth = false;
    }
    var newChildren = [];
    var currentWidth = null;
    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
      var newSlide = [];
      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
        var row = [];
        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
          if (settings.variableWidth && children[k].props.style) {
            currentWidth = children[k].props.style.width;
          }
          if (k >= children.length) break;
          row.push(_react2.default.cloneElement(children[k], {
            key: 100 * i + 10 * j + k,
            tabIndex: -1,
            style: {
              width: 100 / settings.slidesPerRow + "%",
              display: "inline-block"
            }
          }));
        }
        newSlide.push(_react2.default.createElement(
          "div",
          { key: 10 * i + j },
          row
        ));
      }
      if (settings.variableWidth) {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i, style: { width: currentWidth } },
          newSlide
        ));
      } else {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i },
          newSlide
        ));
      }
    }

    if (settings === "unslick") {
      var className = "regular slider " + (this.props.className || "");
      return _react2.default.createElement(
        "div",
        { className: className },
        newChildren
      );
    } else if (newChildren.length <= settings.slidesToShow) {
      settings.unslick = true;
    }
    return _react2.default.createElement(
      _innerSlider.InnerSlider,
      _extends({ ref: this.innerSliderRefHandler }, settings),
      newChildren
    );
  };

  return Slider;
}(_react2.default.Component);

exports.default = Slider;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.InnerSlider = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(10);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _initialState = __webpack_require__(631);

var _initialState2 = _interopRequireDefault(_initialState);

var _lodash = __webpack_require__(632);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(49);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(153);

var _track = __webpack_require__(633);

var _dots = __webpack_require__(634);

var _arrows = __webpack_require__(635);

var _resizeObserverPolyfill = __webpack_require__(636);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InnerSlider = exports.InnerSlider = function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  function InnerSlider(props) {
    _classCallCheck(this, InnerSlider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.listRefHandler = function (ref) {
      return _this.list = ref;
    };

    _this.trackRefHandler = function (ref) {
      return _this.track = ref;
    };

    _this.adaptHeight = function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");
        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    };

    _this.componentWillMount = function () {
      _this.ssrInit();
      _this.props.onInit && _this.props.onInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
    };

    _this.componentDidMount = function () {
      var spec = _extends({ listRef: _this.list, trackRef: _this.track }, _this.props);
      _this.updateState(spec, true, function () {
        _this.adaptHeight();
        _this.props.autoplay && _this.autoPlay("update");
      });
      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }
      _this.ro = new _resizeObserverPolyfill2.default(function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });
      _this.ro.observe(_this.list);
      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });
      // To support server-side rendering
      if (!window) {
        return;
      }
      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    };

    _this.componentWillUnmount = function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }
      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }
      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });
        _this.callbackTimers = [];
      }
      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
    };

    _this.componentWillReceiveProps = function (nextProps) {
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, nextProps, _this.state);
      var setTrackStyle = false;
      for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var key = _ref;

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }
        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
          continue;
        }
        if (nextProps[key] !== _this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
          _this.changeSlide({
            message: "index",
            index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }
        if (nextProps.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    };

    _this.componentDidUpdate = function () {
      _this.checkImagesLoad();
      _this.props.onReInit && _this.props.onReInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }
      _this.adaptHeight();
    };

    _this.onWindowResized = function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash2.default)(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);
      _this.debouncedResize();
    };

    _this.resizeWindow = function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!_reactDom2.default.findDOMNode(_this.track)) return;
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props, _this.state);
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      });
      // animating state should be cleared while resizing, otherwise autoplay stops working
      _this.setState({
        animating: false
      });
      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    };

    _this.updateState = function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _extends({}, spec, updatedState, { slideIndex: updatedState.currentSlide });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _extends({}, spec, { left: targetLeft });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
      if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }
      _this.setState(updatedState, callback);
    };

    _this.ssrInit = function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });
        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }
        for (var _i2 = 0; _i2 < postClones; _i2++) {
          _trackWidth += childrenWidths[_i2];
        }
        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
          _trackLeft += childrenWidths[_i3];
        }
        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };
        if (_this.props.centerMode) {
          var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
          _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
        }
        _this.setState({
          trackStyle: _trackStyle
        });
        return;
      }
      var childrenCount = _react2.default.Children.count(_this.props.children);
      var spec = _extends({}, _this.props, _this.state, { slideCount: childrenCount });
      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }
      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      _this.setState({
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      });
    };

    _this.checkImagesLoad = function () {
      var images = document.querySelectorAll(".slick-slide img");
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };
        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;
          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }
        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();
              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;
            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    };

    _this.progressiveLazyLoad = function () {
      var slidesToLoad = [];
      var spec = _extends({}, _this.props, _this.state);
      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }
      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }
      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });
        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    };

    _this.slideHandler = function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange;
      // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
        index: index
      }, _this.props, _this.state, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
      _this.setState(state, function () {
        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({ animating: animating });
            }, 10));
            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    };

    _this.changeSlide = function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _extends({}, _this.props, _this.state);
      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;
      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
    };

    _this.clickHandler = function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }
      _this.clickable = true;
    };

    _this.keyHandler = function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({ message: dir });
    };

    _this.selectHandler = function (options) {
      _this.changeSlide(options);
    };

    _this.disableBodyScroll = function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };
      window.ontouchmove = preventDefault;
    };

    _this.enableBodyScroll = function () {
      window.ontouchmove = null;
    };

    _this.swipeStart = function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }
      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    };

    _this.swipeMove = function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      if (state["swiping"]) {
        _this.clickable = false;
      }
      _this.setState(state);
    };

    _this.swipeEnd = function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];
      _this.setState(state);
      if (triggerSlideHandler === undefined) return;
      _this.slideHandler(triggerSlideHandler);
      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    };

    _this.slickPrev = function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "previous" });
      }, 0));
    };

    _this.slickNext = function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "next" });
      }, 0));
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      slide = Number(slide);
      if (isNaN(slide)) return "";
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    };

    _this.play = function () {
      var nextIndex;
      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    };

    _this.autoPlay = function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
      var autoplaying = _this.state.autoplaying;
      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }
      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
      _this.setState({ autoplaying: "playing" });
    };

    _this.pause = function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }
      var autoplaying = _this.state.autoplaying;
      if (pauseType === "paused") {
        _this.setState({ autoplaying: "paused" });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({ autoplaying: "focused" });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({ autoplaying: "hovered" });
        }
      }
    };

    _this.onDotsOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onDotsLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onTrackOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onTrackLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onSlideFocus = function () {
      return _this.props.autoplay && _this.pause("focused");
    };

    _this.onSlideBlur = function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    };

    _this.render = function () {
      var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });
      var spec = _extends({}, _this.props, _this.state);
      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
      var pauseOnHover = _this.props.pauseOnHover;

      trackProps = _extends({}, trackProps, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
      });

      var dots;
      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;

        dotProps = _extends({}, dotProps, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = _react2.default.createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);
      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.swipeEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };

      var innerSliderProps = {
        className: className,
        dir: "ltr"
      };

      if (_this.props.unslick) {
        listProps = { className: "slick-list" };
        innerSliderProps = { className: className };
      }
      return _react2.default.createElement(
        "div",
        innerSliderProps,
        !_this.props.unslick ? prevArrow : "",
        _react2.default.createElement(
          "div",
          _extends({ ref: _this.listRefHandler }, listProps),
          _react2.default.createElement(
            _track.Track,
            _extends({ ref: _this.trackRefHandler }, trackProps),
            _this.props.children
          )
        ),
        !_this.props.unslick ? nextArrow : "",
        !_this.props.unslick ? dots : ""
      );
    };

    _this.list = null;
    _this.track = null;
    _this.state = _extends({}, _initialState2.default, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react2.default.Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    return _this;
  }

  return InnerSlider;
}(_react2.default.Component);

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false, // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
  trackStyle: {},
  trackWidth: 0
};

exports.default = initialState;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Track = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(49);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(153);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }
  slickCloned = index < 0 || index >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }
  var slickCurrent = index === spec.currentSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL
  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";
    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }
    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];
  var childrenCount = _react2.default.Children.count(spec.children);
  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react2.default.Children.forEach(spec.children, function (elem, index) {
    var child = void 0;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    };

    // in case of lazyLoad, whether or not we want to fetch the slide
    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = _react2.default.createElement("div", null);
    }
    var childStyle = getSlideStyle(_extends({}, spec, { index: index }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_extends({}, spec, { index: index }));
    // push a cloned element of the desired slide
    slides.push(_react2.default.cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames2.default)(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _extends({ outline: "none" }, child.props.style || {}, childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);
        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    }));

    // if slide needs to be precloned or postcloned
    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;
      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;
        if (key >= startIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        preCloneSlides.push(_react2.default.cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;
        if (key < endIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        postCloneSlides.push(_react2.default.cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = exports.Track = function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Track.prototype.render = function render() {
    var slides = renderSlides(this.props);
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    return _react2.default.createElement(
      "div",
      _extends({
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents),
      slides
    );
  };

  return Track;
}(_react2.default.PureComponent);

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Dots = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(49);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = exports.Dots = function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Dots.prototype.clickHandler = function clickHandler(options, e) {
    // In Autoplay the focus stays on clicked button even after transition
    // to next slide. That only goes away by click somewhere outside
    e.preventDefault();
    this.props.clickHandler(options);
  };

  Dots.prototype.render = function render() {
    var _this2 = this;

    var dotCount = getDotCount({
      slideCount: this.props.slideCount,
      slidesToScroll: this.props.slidesToScroll,
      slidesToShow: this.props.slidesToShow,
      infinite: this.props.infinite
    });

    // Apply join & split to Array to pre-fill it for IE8
    //
    // Credit: http://stackoverflow.com/a/13735425/1849458
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
      var leftBound = i * _this2.props.slidesToScroll;
      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
      var className = (0, _classnames2.default)({
        "slick-active": _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
      });

      var dotOptions = {
        message: "dots",
        index: i,
        slidesToScroll: _this2.props.slidesToScroll,
        currentSlide: _this2.props.currentSlide
      };

      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
      return _react2.default.createElement(
        "li",
        { key: i, className: className },
        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
      );
    });

    return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
      className: this.props.dotsClass
    }, mouseEvents));
  };

  return Dots;
}(_react2.default.PureComponent);

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.NextArrow = exports.PrevArrow = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(49);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(153);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  PrevArrow.prototype.render = function render() {
    var prevClasses = { "slick-arrow": true, "slick-prev": true };
    var prevHandler = this.clickHandler.bind(this, { message: "previous" });

    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
      prevClasses["slick-disabled"] = true;
      prevHandler = null;
    }

    var prevArrowProps = {
      key: "0",
      "data-role": "none",
      className: (0, _classnames2.default)(prevClasses),
      style: { display: "block" },
      onClick: prevHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var prevArrow = void 0;

    if (this.props.prevArrow) {
      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
    } else {
      prevArrow = _react2.default.createElement(
        "button",
        _extends({ key: "0", type: "button" }, prevArrowProps),
        " ",
        "Previous"
      );
    }

    return prevArrow;
  };

  return PrevArrow;
}(_react2.default.PureComponent);

var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
  }

  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  NextArrow.prototype.render = function render() {
    var nextClasses = { "slick-arrow": true, "slick-next": true };
    var nextHandler = this.clickHandler.bind(this, { message: "next" });

    if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
      nextClasses["slick-disabled"] = true;
      nextHandler = null;
    }

    var nextArrowProps = {
      key: "1",
      "data-role": "none",
      className: (0, _classnames2.default)(nextClasses),
      style: { display: "block" },
      onClick: nextHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var nextArrow = void 0;

    if (this.props.nextArrow) {
      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
    } else {
      nextArrow = _react2.default.createElement(
        "button",
        _extends({ key: "1", type: "button" }, nextArrowProps),
        " ",
        "Next"
      );
    }

    return nextArrow;
  };

  return NextArrow;
}(_react2.default.PureComponent);

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(28)))

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(638);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),
/* 638 */
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return _react2.default.createElement(
      "ul",
      { style: { display: "block" } },
      dots
    );
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return _react2.default.createElement(
      "button",
      null,
      i + 1
    );
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};

exports.default = defaultProps;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(641);
module.exports = new MediaQueryDispatch();


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(642);
var Util = __webpack_require__(338);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(643);
var each = __webpack_require__(338).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),
/* 643 */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_CorePage__ = __webpack_require__(37);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var SubscribeButton=function(_CorePage){_inherits(SubscribeButton,_CorePage);function SubscribeButton(props){_classCallCheck(this,SubscribeButton);return _possibleConstructorReturn(this,(SubscribeButton.__proto__||Object.getPrototypeOf(SubscribeButton)).call(this,props));}_createClass(SubscribeButton,[{key:'getGa',value:function getGa(){if(this.props.ga&&typeof this.props.ga==="string"){return this.props.ga;}else if(this.props.ga&&_typeof(this.props.ga)==="object"&&this.props.ga["subscribe-btn"]){return this.props.ga["subscribe-btn"];}else{return"Post login - Subscribe";}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'SubscribeButton',className:'float-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'btn btn-primary largeBtn subscribe_style','data-ga':this.getGa(),onClick:function onClick(){window.location.href="/myproducts";}},this.rb("product.buynow")));}}]);return SubscribeButton;}(__WEBPACK_IMPORTED_MODULE_1__views_core_CorePage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (SubscribeButton);

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_core_LoggedInPage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_AppConstants_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_UserStorageUtil__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_heymathlogo_png__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_heymathlogo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_heymathlogo_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Header=function(_LoggedInPage){_inherits(Header,_LoggedInPage);function Header(props){_classCallCheck(this,Header);return _possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).call(this,props));}_createClass(Header,[{key:'componentDidMount',value:function componentDidMount(){try{var isCollapsed=this.getAttribute("sidebar_collapsed")==="true";//UserStorageUtil.getStoredSessionItem("sidebar_collapsed") ||
__WEBPACK_IMPORTED_MODULE_4__model_AppConstants_js__["a" /* default */].collapsed=isCollapsed||__WEBPACK_IMPORTED_MODULE_4__model_AppConstants_js__["a" /* default */].collapsed;if(__WEBPACK_IMPORTED_MODULE_4__model_AppConstants_js__["a" /* default */].collapsed===true){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.side-navbar').addClass('shrinked');__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.content-inner').addClass('active');__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').removeClass('active');__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').removeClass("goRight");__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-small').show();__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-big').hide();}}catch(e){console.error(e);}if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).outerWidth()>1183){if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').hasClass('active')){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').addClass("goRight");}else{__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').removeClass("goRight");}}if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).outerWidth()<1183){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').removeClass("goRight");}}},{key:'toggleSideBar',value:function toggleSideBar(){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').toggleClass('active');__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.side-navbar').toggleClass('shrinked');__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.content-inner').toggleClass('active');if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).outerWidth()>1183){if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').hasClass('active')){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-small').hide();__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-big').show();__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').addClass("goRight");}else{__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-small').show();__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-big').hide();__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').removeClass("goRight");}}if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).outerWidth()<1183){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-small').show();__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').removeClass("goRight");}try{var isCollapsed=__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.side-navbar').hasClass('shrinked');if(typeof isCollapsed==="boolean"){this.setAttribute("sidebar_collapsed",isCollapsed.toString());}__WEBPACK_IMPORTED_MODULE_4__model_AppConstants_js__["a" /* default */].collapsed=__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.side-navbar').hasClass('shrinked');__WEBPACK_IMPORTED_MODULE_5__util_UserStorageUtil__["a" /* default */].storeSessionItem("sidebar_collapsed",__WEBPACK_IMPORTED_MODULE_4__model_AppConstants_js__["a" /* default */].collapsed);}catch(e){console.log(e);}}},{key:'onLogout',value:function onLogout(){var me=this;var msg=me.rb("logout.msg");var buttons=[{label:me.rb("alert.ok"),handler:function handler(){me.doLogout();}},{label:me.rb("alert.cancel"),handler:function handler(){}}];me.showAlert(" ",msg,buttons);}},{key:'doLogout',value:function doLogout(){var me=this;var callBackSuccess=function callBackSuccess(){me.initiateTrack("logout",{});setTimeout(function(){me.getUser().clearOldUser();window.location.href=me.getUrlFor("PRELOGIN_PAGE");},500);};var callBackFailure=function callBackFailure(){console.error("Logout failed.");};new __WEBPACK_IMPORTED_MODULE_3__util_HmAjax__["a" /* default */](me.getUrlFor("LOGOUT")).get(callBackSuccess,callBackFailure);}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'navbar bg-purple'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'navbar-holder d-flex align-items-center justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'navbar-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("PRELOGIN_PAGE"),className:'navbar-brand'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'brand-text brand-big'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__images_heymathlogo_png___default.a,className:'heymathlogo',width:'100'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'brand-text brand-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'H!'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'toggle-btn',href:'#',className:'menu-btn active',onClick:function onClick(){_this2.toggleSideBar();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nav-menu list-unstyled d-flex flex-md-row align-items-md-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'nav-item dropdown'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'notifications',rel:'nofollow','data-target':'#',href:'#','data-toggle':'dropdown','aria-haspopup':'true','aria-expanded':'false',className:'nav-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons md-40'},'account_circle')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{'aria-labelledby':'notifications',className:'dropdown-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{rel:'nofollow',href:'/myproducts',className:'dropdown-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification-content'},this.rb("product.mypurchases"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{rel:'nofollow',href:'/settings',className:'dropdown-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification-content'},'My Profile')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{rel:'nofollow',href:'#',className:'dropdown-item',onClick:function onClick(){_this2.onLogout();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification-content'},'Signout')))))))))));}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_2__views_core_LoggedInPage__["a" /* default */]);/* unused harmony default export */ var _unused_webpack_default_export = (Header);

/***/ }),
/* 646 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAQCAYAAAAS7Y8mAAAABHNCSVQICAgIfAhkiAAAAOhJREFUOI2107FOwzAYBOA7K0Pm7mWGbPb/ELDwKBGsbF1Zu/RV4CGcDFUjqk4F5s4ZKh9TpQ5Qp5K52ffJ/n+Z3vtHAK/OuTsUiKSNpBea2R7ATQn0LJ/VCY0xsgBIM0sppbkrgP2aLBxCeDOz2+IwyXtJ6xDCsmma2URXk0ZBsiLZ1nW98963AKpc56oZk5w555ZmtvbePxSDr7iAsk86j6SDpEXf9ysAx0tnJ8GSjgBW4zguhmE4TOlkYUnvJJ9jjB9TwFMtC3ddd3FJf+Xffl4l6Yvk3MxUCpX07VJKraRtQXQL4OkHGbhY4qtNa+sAAAAASUVORK5CYII="

/***/ }),
/* 648 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_LoggedInPage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_html_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_lessonmenuiconwhite_png__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_lessonmenuiconwhite_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_icons_lessonmenuiconwhite_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_UserStorageUtil__ = __webpack_require__(33);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChooseGrade=function(_LoggedInPage){_inherits(ChooseGrade,_LoggedInPage);function ChooseGrade(props){_classCallCheck(this,ChooseGrade);var _this=_possibleConstructorReturn(this,(ChooseGrade.__proto__||Object.getPrototypeOf(ChooseGrade)).call(this,props));_this.gradeSelected=function(){if(typeof _this.props.gradeChangefromChooseGrade==='function'){_this.props.gradeChangefromChooseGrade(_this.state.selectedIndex,_this.accessId,_this.entlKey);}};_this.getArrayListSet=function(){var subjectSet=new Set();var sorter=window.choose_grade_sorter[_this.getGeo()]||window.choose_grade_sorter["ALL"];var sortedArr=_this.props.gradeArr;sortedArr=sorter.order==="desc"?sortedArr.reverse():sortedArr;for(var i=0;i<sortedArr.length;i++){subjectSet.add(sortedArr[i].subject);}//console.warn("subjectSet ",subjectSet);
return subjectSet;};_this.getSubjectArrayList=function(){var me=_this;var tempGradeArr=[];var sortedArr=_this.props.gradeArr;var sorter=window.choose_grade_sorter[_this.getGeo()]||window.choose_grade_sorter["ALL"];if(sorter&&sorter.enabled){var sortingField=sorter.field;if(sortingField&&sortedArr&&sortedArr.length>0&&sortedArr[0][sortingField]){var sortingType=sorter.type||(!isNaN(sortedArr[0][sortingField])?"number":_typeof(me.props.gradeArr[0][sortingField]));sortedArr.sort(function(a,b){if(sortingType==="number"){return a[sortingField]-b[sortingField];}else if(sortingType==="string"){if(a[sortingField]&&b[sortingField]){if(a[sortingField].toLowerCase()<b[sortingField].toLowerCase()){return-1;}else if(a[sortingField].toLowerCase()>b[sortingField].toLowerCase()){return 1;}}}return 0;});}sortedArr=sorter.order==="desc"?sortedArr.reverse():sortedArr;}var subjectSet=_this.getArrayListSet();var gradeMapList=_this.makeSubjectBasedTree(subjectSet,sortedArr);var topicTitle=Array.from(subjectSet);var wholeSubject=Object.values(gradeMapList);var selectedIndex=_this.state.selectedIndex;/* which is hot coded for now */var subjectBasedUI=window.chooseGradeBasedonSubject||[];var willShowSubject=subjectBasedUI.indexOf(_this.countryCode)>-1?true:false;if(willShowSubject&&topicTitle.length>0&&wholeSubject.length>0){_this.getArrayListSet();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center mt-30'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,_this.rb("select.your.class")),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center col-12 col-sm-12 col-md-10 col-lg-10 mx-auto mt-30 grade-only'},wholeSubject.map(function(sortedSub,valIndex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:valIndex},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'subtitle fancy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,topicTitle[valIndex])),sortedSub.map(function(element,index){var addClass=element.index==selectedIndex?" selected":'';//console.warn("sortedSub ",element.index," : ",selectedIndex);
if(element&&element.gradeId){if(!~tempGradeArr.indexOf(element.gradeId)){tempGradeArr.push(element.gradeId);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:"gradeBox "+element.label.split(" ").join("").toLowerCase()+addClass,'data-ga':"Post login - Choose your class - "+element.label,'data-value':element.value,'data-label':element.label,'data-index':element.index,'data-gradeid':element.gradeId,'data-classid':element.classId,onClick:_this.gradeDirectClick.bind(_this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_2_react_html_parser___default()(_this.getGradeLabel(element))));}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:"gradeBox "+element.label.split(" ").join("").toLowerCase()+addClass,'data-ga':"Post login - Choose your class - "+element.label,'data-value':element.value,'data-label':element.label,'data-index':element.index,'data-gradeid':element.gradeId,'data-classid':element.classId,onClick:_this.gradeDirectClick.bind(_this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_2_react_html_parser___default()(_this.getGradeLabel(element))));}}));})));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center mt-30'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,_this.rb("select.your.class")),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center col-12 col-sm-12 col-md-10 col-lg-10 mx-auto mt-30'},sortedArr.map(function(element,index){if(element&&element.gradeId){if(!~tempGradeArr.indexOf(element.gradeId)){tempGradeArr.push(element.gradeId);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:"gradeBox "+element.label.split(" ").join("").toLowerCase(),'data-ga':"Post login - Choose your class - "+element.label,'data-value':element.value,'data-label':element.label,'data-index':index,'data-gradeid':element.gradeId,'data-classid':element.classId,onClick:_this.gradeClick.bind(_this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_2_react_html_parser___default()(_this.getGradeLabel(element))));}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:"gradeBox "+element.label.split(" ").join("").toLowerCase(),'data-ga':"Post login - Choose your class - "+element.label,'data-value':element.value,'data-label':element.label,'data-index':index,'data-gradeid':element.gradeId,'data-classid':element.classId,onClick:_this.gradeClick.bind(_this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_2_react_html_parser___default()(_this.getGradeLabel(element))));}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center mt-30'},_this.getGradeContent()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center mt-30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'submitButton signup signupButton',onClick:_this.gradeSelected.bind(_this),'data-ga':"Post login - Choose your class - "+_this.state.selectedGradeName+" - Start Learning"},_this.rb("register.startlearning"))));}};_this.accessId=props.selectedProductOption&&!isNaN(props.selectedProductOption.value)?Number(props.selectedProductOption.value):1;_this.entlKey=_this.getUser().getAccessMap()[_this.accessId]||"PLP|REVISION|TAKE";_this.prodLabel=_this.rb(_this.entlKey);_this.state={selectedGradeName:_this.props.selectedGradeOption.label,selectedIndex:0,entlKey:_this.entlKey,selectedClassId:0,selectedGradeId:0};_this.LessonTestMaps=window.LessonTestMaps||{};_this.countryCode='';return _this;}_createClass(ChooseGrade,[{key:'getEntlKey',value:function getEntlKey(accessId){return this.getUser().getAccessMap()[accessId]||"PLP|REVISION|TAKE";}},{key:'componentDidMount',value:function componentDidMount(){this.countryCode=this.getGeo()||'IN';//console.warn("this.countryCode ",this.countryCode);
var selectedlabel=this.props.selectedGradeOption.label.split(" ").join("").toLowerCase();__WEBPACK_IMPORTED_MODULE_3_jquery___default()("."+selectedlabel).trigger("click");}},{key:'getGradeLabel',value:function getGradeLabel(element){var label=element.label;var gradeTxt=this.getLabelByBoard(element);if(gradeTxt&&gradeTxt.length>0){return gradeTxt;}else if(element&&element.gradeDisplayName&&element.gradeDisplayName.length>0&&element.gradeDisplayName!=="null"){return this.rb(element.gradeDisplayName);}else if(element&&element.classDescription&&element.classDescription.length>0&&element.classDescription!=="null"){return this.rb(element.classDescription);}else{gradeTxt=label.split(" ")[1];var preText=this.rb("class.prefix.choosegrade");var superTxt="";if(parseInt(gradeTxt)==1){superTxt="st";}else if(parseInt(gradeTxt)==2){superTxt="nd";}else if(parseInt(gradeTxt)==3){superTxt="rd";}else if(!isNaN(parseInt(gradeTxt))){superTxt="th";}else{if(!(gradeTxt&&gradeTxt.length>0)){if(element.gradeId&&element.gradeDisplayName&&element.gradeDisplayName.length>0){gradeTxt=element.gradeDisplayName;}else{gradeTxt=element.label;}return gradeTxt;}return preText+gradeTxt;}}return gradeTxt+"<sup>"+superTxt+"</sup>";}},{key:'getLabelByBoard',value:function getLabelByBoard(element){var board=element&&element.board?element.board:null;var labelFieldsForBoard=board&&window.choose_grade_label_fields_for_boards&&window.choose_grade_label_fields_for_boards[board]?window.choose_grade_label_fields_for_boards[board]:null;if(labelFieldsForBoard!=null){return this.rb(element[labelFieldsForBoard[0]]);}else if(board&&board.toUpperCase()==="RSA"){if(element&&element.classDescription&&element.classDescription.length>0){return this.rb(element.classDescription);}else if(element&&element.className&&element.className.length>0){return this.rb(element.className);}}return null;}},{key:'gradeClick',value:function gradeClick(event){__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".gradeBox").removeClass("selected");__WEBPACK_IMPORTED_MODULE_3_jquery___default()(event.currentTarget).addClass("selected");this.setState({selectedGradeName:__WEBPACK_IMPORTED_MODULE_3_jquery___default()(event.currentTarget).attr("data-label"),selectedIndex:__WEBPACK_IMPORTED_MODULE_3_jquery___default()(event.currentTarget).attr("data-index"),selectedClassId:__WEBPACK_IMPORTED_MODULE_3_jquery___default()(event.currentTarget).attr("data-classid"),selectedGradeId:__WEBPACK_IMPORTED_MODULE_3_jquery___default()(event.currentTarget).attr("data-gradeid")});}},{key:'gradeDirectClick',value:function gradeDirectClick(event){var _this2=this;__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".gradeBox").removeClass("selected");__WEBPACK_IMPORTED_MODULE_3_jquery___default()(event.currentTarget).addClass("selected");this.setState({selectedGradeName:__WEBPACK_IMPORTED_MODULE_3_jquery___default()(event.currentTarget).attr("data-label"),selectedIndex:__WEBPACK_IMPORTED_MODULE_3_jquery___default()(event.currentTarget).attr("data-index"),selectedClassId:__WEBPACK_IMPORTED_MODULE_3_jquery___default()(event.currentTarget).attr("data-classid"),selectedGradeId:__WEBPACK_IMPORTED_MODULE_3_jquery___default()(event.currentTarget).attr("data-gradeid")},function(){_this2.gradeSelected(event);});}},{key:'getIconForContent',value:function getIconForContent(contentKey){if(contentKey==="LessonsMapped"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'topicmapLessons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'material-icons mxwidthinherit',src:__WEBPACK_IMPORTED_MODULE_4__images_icons_lessonmenuiconwhite_png___default.a,alt:'Animated Lessons icon'}));}else if(contentKey==="SolvedExamplesGameQuiz"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'topicmaptests'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons',role:'img','aria-label':'Puzzles and activites icon'},'extension'));}else if(contentKey==="DiagnosticTests"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'topicmaptests'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons',role:'img','aria-label':'Puzzles and activites icon'},'assignment'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'topicmaptests'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons',role:'img','aria-label':'Puzzles and activites icon'},'assignment'));}}/**
		* IMPORTANT: Content details that need to be shown in grade box.
		* contentKeys - list of keys for the content. For example: DiagnosticTests, LessonsMapped, SolvedExamplesGameQuiz
		* FUnction will check either gdname or classId
		*/},{key:'getContentDetails',value:function getContentDetails(gdname,classId){var me=this;var authProviderId=this.getUser().getAuthProviderId();var entlKey=this.entlKey;var contentKeys=[];var classSelectkey=null;var content_keys_by_entlkey=entlKey&&window.chooseGradeContent_entl&&window.chooseGradeContent_entl[entlKey]?window.chooseGradeContent_entl[entlKey]:null;var content_keys_by_authProviderId=authProviderId&&window.chooseGradeContent_authprovider&&window.chooseGradeContent_authprovider[authProviderId]?window.chooseGradeContent_authprovider[authProviderId]:null;if(gdname&&this.LessonTestMaps[gdname]){contentKeys=Object.keys(this.LessonTestMaps[gdname]);classSelectkey=gdname;}else if(classId&&this.LessonTestMaps[classId]){contentKeys=Object.keys(this.LessonTestMaps[classId]);classSelectkey=classId;}if(classSelectkey&&this.LessonTestMaps[classSelectkey]&&entlKey&&contentKeys&&contentKeys.length>0){var validContentKeys=[];for(var i=0;i<contentKeys.length;i++){var menuAllowed=true;if(content_keys_by_authProviderId&&content_keys_by_authProviderId.length>0){//Check for Lumos suppression
menuAllowed=menuAllowed&&content_keys_by_authProviderId.indexOf(contentKeys[i])>-1;}if(content_keys_by_entlkey&&content_keys_by_entlkey.length>0){//Check for entlKey
menuAllowed=menuAllowed&&content_keys_by_entlkey.indexOf(contentKeys[i])>-1;}else if(!isNaN(me.LessonTestMaps[classSelectkey][contentKeys[i]])&&me.LessonTestMaps[classSelectkey][contentKeys[i]]>0){menuAllowed=true;}if(menuAllowed){validContentKeys.push(contentKeys[i]);}}if(validContentKeys&&validContentKeys.length>0){return validContentKeys.map(function(contentKey,idx){if(contentKey&&!isNaN(me.LessonTestMaps[classSelectkey][contentKey])){var dividerCls="";var columnWidth=Math.floor(12/validContentKeys.length)||6;if(idx<validContentKeys.length-1){dividerCls=" clearfix greyborderright";}else{dividerCls=" clearfix ";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"col-sm-"+columnWidth+" norightpadding "+dividerCls,key:contentKey},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 pt-10 text-right norightpadding'},me.getIconForContent(contentKey)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 pl-20 norightpadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,me.LessonTestMaps[classSelectkey][contentKey])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,me.rb(entlKey+"-"+contentKey)))));}});}}}},{key:'getGradeContent',value:function getGradeContent(){var _this3=this;var userObj=__WEBPACK_IMPORTED_MODULE_5__util_UserStorageUtil__["a" /* default */].getStoredSessionItem("USER_DETAILS");var authProviderId=userObj&&userObj.authProviderId?userObj.authProviderId:0;if(this.state.entlKey==""){return;}var classArr=this.props.gradeArr.filter(function(obj){return obj.label==_this3.state.selectedGradeName;});var classId=classArr&&classArr.length>0&&!isNaN(classArr[0].value)?Number(classArr[0].value):0;if(this.props.gradeProductMap[classId]&&this.props.gradeProductMap[classId].length>0){this.accessId=this.props.gradeProductMap[classId][0];this.entlKey=this.getEntlKey(this.props.gradeProductMap[classId][0]);}var productName=this.rb(this.entlKey);var producticon="";var productclass="";if(this.entlKey==="PLP|LESSON|VIEW"){producticon="../img/e1.png";productclass="lessons";}else if(this.entlKey==="PLP|TEST|TAKE"){producticon="../img/e2.png";productclass="cbse";}else if(this.entlKey==="TCHR|LESSON|VIEW"){producticon="../img/e1.png";productclass="lessons";}else{producticon="../img/e3.png";productclass="plp";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gradeContentBox col-lg-9 col-md-10 col-sm-12 col-12 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt-20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:"gradeiconbox "+productclass,src:producticon,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt-20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,productName,' for ',this.state.selectedGradeName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,function(){var gdname=_this3.state.selectedGradeName?_this3.state.selectedGradeName.split(" ").join("").toLowerCase():"";if(parseInt(_this3.state.selectedGradeId)===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-12 mx-auto text-left topicmapinforow'},_this3.getContentDetails(gdname,classId)));}}()));}},{key:'makeSubjectBasedTree',value:function makeSubjectBasedTree(subjSet,sortedArr){var subjectBasedArr={};var subj=0;var subjectSet=Array.from(subjSet);while(subj<subjectSet.length){for(var i=0;i<sortedArr.length;i++){if(i===0){subjectBasedArr[subjectSet[subj]]=[];}sortedArr[i].index=i;if(sortedArr[i].subject===subjectSet[subj]){subjectBasedArr[subjectSet[subj]].push(sortedArr[i]);}}//console.warn("subjectBasedArr ",subjectBasedArr," : ",sortedArr);
subj++;}return subjectBasedArr;}},{key:'render',value:function render(){var me=this;//console.warn("sorted lalala ::", sortedArr);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'choosegrade'},this.getSubjectArrayList());}}]);return ChooseGrade;}(__WEBPACK_IMPORTED_MODULE_1__views_core_LoggedInPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ChooseGrade);

/***/ }),
/* 650 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports = {"tests":{"id":"tests","label":"tests","value":"/landing","route":"/landing","materialkey":"assignment","entlKey":"PLP|REVISION|TAKE","allowedEntlKeys":["PLP|REVISION|TAKE","PLP|TEST|TAKE"]},"lessons":{"id":"lessons","label":"lessons","value":"/landing","route":"/landing","materialkey":"ondemand_video","entlKey":"PLP|LESSON|VIEW","allowedEntlKeys":["PLP|TEST|TAKE","PLP|LESSON|VIEW"]},"lessons_tchr":{"id":"lessons","label":"lessons","value":"/landing","route":"/landing","materialkey":"ondemand_video","entlKey":"TCHR|LESSON|VIEW","allowedEntlKeys":["TCHR|LESSON|VIEW"]},"dashboard":{"id":"1001","label":"dashboard","value":"/dashboard","route":"","materialkey":"dashboard","entlKey":"","allowedEntlKeys":["PLP|REVISION|TAKE","PLP|TEST|TAKE","PLP|LESSON|VIEW","TCHR|LESSON|VIEW"]},"assessments":{"id":"assessment","label":"assessment","value":"/landing","route":"/landing","materialkey":"assignment","entlKey":"TUITION|TEST|TAKE","allowedEntlKeys":["TUITION|TEST|TAKE"]},"reports":{"id":"1001","label":"report","route":"","value":"/report","materialkey":"assessment","entlKey":"","allowedEntlKeys":["TUITION|TEST|TAKE"]}}

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_common_Sidebar__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_patterns_profilebg_png__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_patterns_profilebg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_patterns_profilebg_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_plp_TestTakingModalComponent__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_AppConstants__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_ComponentRegistry__ = __webpack_require__(38);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ms_menus=__WEBPACK_IMPORTED_MODULE_4__model_AppConstants__["a" /* default */].ms_menus;var ms_sidebar=function(_Sidebar){_inherits(ms_sidebar,_Sidebar);function ms_sidebar(props){_classCallCheck(this,ms_sidebar);var _this=_possibleConstructorReturn(this,(ms_sidebar.__proto__||Object.getPrototypeOf(ms_sidebar)).call(this,props));_this.renderSidebarTab=_this.renderSidebarTab.bind(_this);return _this;}_createClass(ms_sidebar,[{key:'componentDidMount',value:function componentDidMount(){//console.log("ms_menus ",menus);
_get(ms_sidebar.prototype.__proto__||Object.getPrototypeOf(ms_sidebar.prototype),'componentDidMount',this).call(this);}},{key:'renderHumburger',value:function renderHumburger(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}},{key:'getSideBarMenus',value:function getSideBarMenus(){var _this2=this;var me=this;var elements=ms_menus.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index,className:me.rb(element.label)+" leftmenu "+(parseInt(_this2.state.selectedID)===parseInt(element.id)?"active":""),onClick:_this2.leftmenuclick.bind(_this2),'data-id':element.id,'data-value':element.value},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},element.materialkey),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'leftmenutxt'},me.rb(element.label)),' '));});return elements;}},{key:'renderSidebarTab',value:function renderSidebarTab(){var me=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list-unstyled'},function(){if(me.comboNamesLoaded){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,me.getMenusFromJson());}}());}},{key:'render',value:function render(){return _get(ms_sidebar.prototype.__proto__||Object.getPrototypeOf(ms_sidebar.prototype),'render',this).call(this);}}]);return ms_sidebar;}(__WEBPACK_IMPORTED_MODULE_1__views_common_Sidebar__["a" /* default */]);/* unused harmony default export */ var _unused_webpack_default_export = (ms_sidebar);__WEBPACK_IMPORTED_MODULE_5__model_ComponentRegistry__["a" /* default */].register("ms_sidebar",ms_sidebar);/*
* Also registering for the users with hm_ prefix
*/__WEBPACK_IMPORTED_MODULE_5__model_ComponentRegistry__["a" /* default */].register("hm_sidebar",ms_sidebar);

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    nullTag = '[object Null]',
    proxyTag = '[object Proxy]',
    undefinedTag = '[object Undefined]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isFunction;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 654 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Arrow = exports.Popper = exports.Target = exports.Manager = undefined;

var _Manager2 = __webpack_require__(656);

var _Manager3 = _interopRequireDefault(_Manager2);

var _Target2 = __webpack_require__(657);

var _Target3 = _interopRequireDefault(_Target2);

var _Popper2 = __webpack_require__(658);

var _Popper3 = _interopRequireDefault(_Popper2);

var _Arrow2 = __webpack_require__(659);

var _Arrow3 = _interopRequireDefault(_Arrow2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Manager = _Manager3.default;
exports.Target = _Target3.default;
exports.Popper = _Popper3.default;
exports.Arrow = _Arrow3.default;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Manager = function (_Component) {
  _inherits(Manager, _Component);

  function Manager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Manager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
      _this._targetNode = node;
    }, _this._getTargetNode = function () {
      return _this._targetNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Manager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this._setTargetNode,
          getTargetNode: this._getTargetNode
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tag = _props.tag,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['tag', 'children']);

      if (tag !== false) {
        return (0, _react.createElement)(tag, restProps, children);
      } else {
        return children;
      }
    }
  }]);

  return Manager;
}(_react.Component);

Manager.childContextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};
Manager.propTypes = {
  tag: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};
Manager.defaultProps = {
  tag: 'div'
};
exports.default = Manager;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Target = function Target(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'div' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popperManager = context.popperManager;

  var targetRef = function targetRef(node) {
    popperManager.setTargetNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };

  if (typeof children === 'function') {
    var targetProps = { ref: targetRef };
    return children({ targetProps: targetProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps);

  if (typeof component === 'string') {
    componentProps.ref = targetRef;
  } else {
    componentProps.innerRef = targetRef;
  }

  return (0, _react.createElement)(component, componentProps, children);
};

Target.contextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};

Target.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};

exports.default = Target;

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _popper = __webpack_require__(317);

var _popper2 = _interopRequireDefault(_popper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Popper = function (_Component) {
  _inherits(Popper, _Component);

  function Popper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
      _this._arrowNode = node;
    }, _this._getTargetNode = function () {
      return _this.context.popperManager.getTargetNode();
    }, _this._getOffsets = function (data) {
      return Object.keys(data.offsets).map(function (key) {
        return data.offsets[key];
      });
    }, _this._isDataDirty = function (data) {
      if (_this.state.data) {
        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
      } else {
        return true;
      }
    }, _this._updateStateModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        if (_this._isDataDirty(data)) {
          _this.setState({ data: data });
        }
        return data;
      }
    }, _this._getPopperStyle = function () {
      var data = _this.state.data;


      if (!_this._popper || !data) {
        return {
          position: 'absolute',
          pointerEvents: 'none',
          opacity: 0
        };
      }

      return _extends({
        position: data.offsets.popper.position
      }, data.styles);
    }, _this._getPopperPlacement = function () {
      return _this.state.data ? _this.state.data.placement : undefined;
    }, _this._getPopperHide = function () {
      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
    }, _this._getArrowStyle = function () {
      if (!_this.state.data || !_this.state.data.offsets.arrow) {
        return {};
      } else {
        var _this$state$data$offs = _this.state.data.offsets.arrow,
            top = _this$state$data$offs.top,
            left = _this$state$data$offs.left;

        return { top: top, left: left };
      }
    }, _this._handlePopperRef = function (node) {
      _this._popperNode = node;
      if (node) {
        _this._createPopper();
      } else {
        _this._destroyPopper();
      }
      if (_this.props.innerRef) {
        _this.props.innerRef(node);
      }
    }, _this._scheduleUpdate = function () {
      _this._popper && _this._popper.scheduleUpdate();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popper, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popper: {
          setArrowNode: this._setArrowNode,
          getArrowStyle: this._getArrowStyle
        }
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(lastProps) {
      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled) {
        this._destroyPopper();
        this._createPopper();
      }
      if (lastProps.children !== this.props.children) {
        this._scheduleUpdate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._destroyPopper();
    }
  }, {
    key: '_createPopper',
    value: function _createPopper() {
      var _this2 = this;

      var _props = this.props,
          placement = _props.placement,
          eventsEnabled = _props.eventsEnabled;

      var modifiers = _extends({}, this.props.modifiers, {
        applyStyle: { enabled: false },
        updateState: this._updateStateModifier
      });
      if (this._arrowNode) {
        modifiers.arrow = {
          element: this._arrowNode
        };
      }
      this._popper = new _popper2.default(this._getTargetNode(), this._popperNode, {
        placement: placement,
        eventsEnabled: eventsEnabled,
        modifiers: modifiers
      });

      // TODO: look into setTimeout scheduleUpdate call, without it, the popper will not position properly on creation
      setTimeout(function () {
        return _this2._scheduleUpdate();
      });
    }
  }, {
    key: '_destroyPopper',
    value: function _destroyPopper() {
      if (this._popper) {
        this._popper.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          component = _props2.component,
          innerRef = _props2.innerRef,
          placement = _props2.placement,
          eventsEnabled = _props2.eventsEnabled,
          modifiers = _props2.modifiers,
          children = _props2.children,
          restProps = _objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'modifiers', 'children']);

      var popperStyle = this._getPopperStyle();
      var popperPlacement = this._getPopperPlacement();
      var popperHide = this._getPopperHide();

      if (typeof children === 'function') {
        var popperProps = {
          ref: this._handlePopperRef,
          style: popperStyle,
          'data-placement': popperPlacement,
          'data-x-out-of-boundaries': popperHide
        };
        return children({
          popperProps: popperProps,
          restProps: restProps,
          scheduleUpdate: this._scheduleUpdate
        });
      }

      var componentProps = _extends({}, restProps, {
        style: _extends({}, restProps.style, popperStyle),
        'data-placement': popperPlacement,
        'data-x-out-of-boundaries': popperHide
      });

      if (typeof component === 'string') {
        componentProps.ref = this._handlePopperRef;
      } else {
        componentProps.innerRef = this._handlePopperRef;
      }

      return (0, _react.createElement)(component, componentProps, children);
    }
  }]);

  return Popper;
}(_react.Component);

Popper.contextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};
Popper.childContextTypes = {
  popper: _propTypes2.default.object.isRequired
};
Popper.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  placement: _propTypes2.default.oneOf(_popper2.default.placements),
  eventsEnabled: _propTypes2.default.bool,
  modifiers: _propTypes2.default.object,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};
Popper.defaultProps = {
  component: 'div',
  placement: 'bottom',
  eventsEnabled: true,
  modifiers: {}
};
exports.default = Popper;

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Arrow = function Arrow(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'span' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popper = context.popper;

  var arrowRef = function arrowRef(node) {
    popper.setArrowNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };
  var arrowStyle = popper.getArrowStyle();

  if (typeof children === 'function') {
    var arrowProps = {
      ref: arrowRef,
      style: arrowStyle
    };
    return children({ arrowProps: arrowProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps, {
    style: _extends({}, arrowStyle, restProps.style)
  });

  if (typeof component === 'string') {
    componentProps.ref = arrowRef;
  } else {
    componentProps.innerRef = arrowRef;
  }

  return (0, _react.createElement)(component, componentProps, children);
};

Arrow.contextTypes = {
  popper: _propTypes2.default.object.isRequired
};

Arrow.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};

exports.default = Arrow;

/***/ }),
/* 660 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 661 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAAF96VFh0UmF3IHByb2ZpbGUgdHlwZSBBUFAxAAAImeNKT81LLcpMVigoyk/LzEnlUgADYxMuE0sTS6NEAwMDCwMIMDQwMDYEkkZAtjlUKNEABZiYm6UBoblZspkpiM8FAE+6FWgbLdiMAAAD6klEQVR4nO3d0XnaOhjG8VcJXIcNygZlAzFCPEHYoNmgdILmTHDIBMrZwN6AbpBukF7bqc4F7mlCDyCDkW30/10RwH6+PH6RbFm2JQAAAAAAAAAAAAAAAAAAAAAAAADDY7bfKJ29lzTpoJbeuJKer7Nitetz7+zEZMVLxJLO5l0ASmeXMuZzV8X0ivdfxlmx/ONtZ6eVtJb0NM6KRfS6Wna19fe8iyJ6av5/b1bSg4y5kTF3dWs5aNsBwGGTHa8HiQAkjgAkjgAkjgAkjgC07NXZRenssus6QhGAFpXOzn8a87eM+Vw5+9B1PSEIQLvmv154adZhHcEIQOIIQOIIQOIIQOIIQOIIQOIIQOJGXRcg779JWo2k3GTF+t1Hzs6qzbH1vYz50El9F667AHj/XdJinBX5rq/UgVhLenh1dvFTWhKEdnXTBXj/OJJm+zb+tuusWI2kmbz/54yVJSd+C+D947Fz6eqJmLelsysZc9duYWmK2wJ4X+za+KWzc+9s0BSrkXRf7zvgRFEDMJIWez6eV1IeEgKTFS8H1oVA0QJgvP/LZMXz/i+Zjw1CsJb3j23Vl6poAbiWws6PNwjBKHSd2ClOALz/dvDX/1ZgCOpW4Pup5aUsSgCMlDdfKLglaL5u/CdKALx03HV0YSF4PmrdkDSEcwGbEAz+Eqy+6n8ANgNHy67LuFSxAjA9aqmwUcNBTL7sq1gBmDdeInzImACcIE4AjPngnQ3fUIEbv3R2ztnB00TbBwjekWt2sij0e9gh3k6gMXcHW4EGG7/+9XNG8ERRjwIqabXrmH4krUI3fr2OVYulJSvuYeCegZ3QoWLv7KSScvr+dsQfB/gdgmnTResbNOUy5uMZKktSNwNBmxCsQ2+y5J2dlM4uK2nNxm9Xd5NCjbmR9LV0dmk2/Xl+La1/dQXe2emrNPPSbSXd1t9Hy7qfFm7MjZc+SfpUSSqf5pKkqsuaEtL/cwE4KwKQOAKQOAKQOAKQOAKQOAKQOAKQOAKQOAKQOAKQOAKQOAKQOAKQOAKQuO0A5F0U0UdXiUw6fTchZJwVy9LZXIk/P3AkPW3fs/BS/TEjqL51Wx69EnSCfYDEEYDmBv+00LcIQAOls/eXNi1976zgN1fhXNQ/jd/2tgCvm5szs/Ev2N4AeOlJ3v+IVcygeP9jdAFjBXu7gHFW5N7ZWeX9NFI9g9HkTud9dvDKoPpSreezV4JOcBSQOALQrsHdsOqki0PrZ/pww+aNyRCPmI4OwJsxAi7bHrCju4BqgM1dTGbzsKveM6csXHcBt20Vc0FexllB1wgAAAAAAAAAAAAAAAAAAAAAAAAAAFr3L17PJGhNsVB0AAAAAElFTkSuQmCC"

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_device_detect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_device_detect__);
var GradeRestrictionManager=function GradeRestrictionManager(){var me=this;//console.log("window.restrictedGrades :::",window.restrictedGrades);
var restrictedGrades=window.restrictedGrades||[];//[1,2,3,4,9,10]; // grade ids
this.isGradeRestricted=function(grade){//console.log("isMobile:::",isMobile,", isTablet::",isTablet," isBrowser:::",isBrowser);
try{if(__WEBPACK_IMPORTED_MODULE_0_react_device_detect__["isMobile"]||__WEBPACK_IMPORTED_MODULE_0_react_device_detect__["isTablet"]){if(restrictedGrades.indexOf(parseInt(grade))>-1){return true;}}return false;}catch(e){return false;}};};/* harmony default export */ __webpack_exports__["a"] = (GradeRestrictionManager);

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_question_WebQuestionPanel__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_ultimate_pagination_material_ui__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_ultimate_pagination_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_ultimate_pagination_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles_MuiThemeProvider__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles_MuiThemeProvider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_styles_MuiThemeProvider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_core_LoggedInPage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.fn.inView=function(){var elementTop=__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).offset().top;var elementBottom=elementTop+__WEBPACK_IMPORTED_MODULE_5_jquery___default()(this).outerHeight();var viewportTop=__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#questionsParent").scrollTop();var viewportBottom=viewportTop+__WEBPACK_IMPORTED_MODULE_5_jquery___default()(window).height();return elementBottom>viewportTop&&elementTop<viewportBottom;};var ViewSolution=function(_LoggedInPage){_inherits(ViewSolution,_LoggedInPage);function ViewSolution(props){_classCallCheck(this,ViewSolution);var _this=_possibleConstructorReturn(this,(ViewSolution.__proto__||Object.getPrototypeOf(ViewSolution)).call(this,props));_this.state={currentScrollIndex:1};_this.onPageChange=_this.onPageChange.bind(_this);//this.scrollFinished = this.scrollFinished.bind(this);
_this.isScrollPreset=false;return _this;}_createClass(ViewSolution,[{key:'componentDidMount',value:function componentDidMount(){var me=this;var scrollTimer=-1;__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#questionsParent").scroll(function(event){if(me.isScrollPreset==false){var element=document.getElementById("qindex-"+me.state.currentScrollIndex);if(me.state.currentScrollIndex!=0&&__WEBPACK_IMPORTED_MODULE_5_jquery___default()(element).inView()==false){me.setState({currentScrollIndex:0});}}if(scrollTimer!=-1)clearTimeout(scrollTimer);scrollTimer=setTimeout(function(){me.isScrollPreset=false;},500);});}},{key:'onPageChange',value:function onPageChange(page){//console.log(page);
this.isScrollPreset=true;this.setState({currentScrollIndex:page});var element=document.getElementById("qindex-"+page);element.scrollIntoView({behavior:'smooth',block:"start"});}},{key:'render',value:function render(){var me=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_styles_MuiThemeProvider___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'questionsParent'},this.props.questions.map(function(eachques,index){eachques["testId"]=me.props.testId;eachques["topicSubTopicMapId"]=me.props.topicSubTopicMapId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,id:"qindex-"+eachques.questionNo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_question_WebQuestionPanel__["a" /* default */],{qno:eachques.questionNo,ga:me.props.ga,qdata:eachques,existingRatingObj:me.props.existingRatingObj,accessId:me.props.accessId,classId:me.props.classId,recomLocked:me.props.recomLocked}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-center paginationParent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_ultimate_pagination_material_ui___default.a,{currentPage:this.state.currentScrollIndex,totalPages:this.props.questionTypeCount,boundaryPagesRange:5,siblingPagesRange:5,hidePreviousAndNextPageLinks:true,hideFirstAndLastPageLinks:true,hideEllipsis:true,onChange:this.onPageChange})));}}]);return ViewSolution;}(__WEBPACK_IMPORTED_MODULE_4__views_core_LoggedInPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ViewSolution);

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_html_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_polyfill__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_accessible_accordion__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_accessible_accordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_accessible_accordion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion_dist_fancy_example_css__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion_dist_fancy_example_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_accessible_accordion_dist_fancy_example_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__similar_json__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__similar_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__similar_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_core_LoggedInPage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CustomAccordian__ = __webpack_require__(871);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultFontColor="&color=%23000000";var defaultFontName="&fontFamily=Muli-Light";var defaultFontSize="&fontSize=13";var WebQuestionView=function(_LoggedInPage){_inherits(WebQuestionView,_LoggedInPage);function WebQuestionView(props){_classCallCheck(this,WebQuestionView);//this.handleChange = this.handleChange.bind(this);
var _this=_possibleConstructorReturn(this,(WebQuestionView.__proto__||Object.getPrototypeOf(WebQuestionView)).call(this,props));_this.likeFn=_this.likeFn.bind(_this);_this.filterHTML=_this.filterHTML.bind(_this);_this.checkImageLoaded=_this.checkImageLoaded.bind(_this);try{_this.WIRIS_URL=_this.getUrlFor("WIRIS_URL");_this.imageServiceUrl=_this.WIRIS_URL+"/formula3/render?transparency=true";}catch(e){if(console)console.log("Error occurred in mathmlToimage | ",e);}return _this;}_createClass(WebQuestionView,[{key:'likeFn',value:function likeFn(event){if(__WEBPACK_IMPORTED_MODULE_9_jquery___default()(event.currentTarget).hasClass("selected")){return false;}var postParams={trackingDefId:2,testId:this.props.qdata.testId,questionId:this.props.qdata.testQuestionId,snippetId:this.props.qdata.snippetId,rating:parseInt(__WEBPACK_IMPORTED_MODULE_9_jquery___default()(event.currentTarget).attr("data-id")),currQuestAtt:this.props.qdata.attemptNo,sourceId:2,action:"submit"};var currentRating=parseInt(__WEBPACK_IMPORTED_MODULE_9_jquery___default()(event.currentTarget).attr("data-id"));var me=this;var currentTarget=__WEBPACK_IMPORTED_MODULE_9_jquery___default()(event.currentTarget);var callBackSuccess=function callBackSuccess(response){//$(".likebox").attr("data-myrating",currentRating);
__WEBPACK_IMPORTED_MODULE_9_jquery___default()("#"+me.props.qdata.testQuestionId+"-"+me.props.qdata.attemptNo).attr("data-myrating",currentRating);__WEBPACK_IMPORTED_MODULE_9_jquery___default()("#"+me.props.qdata.testQuestionId+"-"+me.props.qdata.attemptNo).find(".ratingIcon").removeClass("selected");__WEBPACK_IMPORTED_MODULE_9_jquery___default()(currentTarget).addClass("selected");};var callBackFailure=function callBackFailure(error){console.log("Error in Scorecard TRACK_SOLUTION");};new __WEBPACK_IMPORTED_MODULE_8__util_HmAjax__["a" /* default */](this.getUrlFor("TRACK_SOLUTION"),postParams).post(callBackSuccess,callBackFailure);try{var trackObj={"test_id":this.props.qdata.testId,"snippet_id":this.props.qdata.snippetId,"question_source":this.props.qdata.source,"attempt_no":this.props.qdata.attemptNo,"helpful":parseInt(__WEBPACK_IMPORTED_MODULE_9_jquery___default()(event.currentTarget).attr("data-id"))===2,"source":this.getTracker().enums.itemRatedSource.scorecard};this.initiateTrack("solution_rated",trackObj);}catch(e){}}},{key:'renderOptions',value:function renderOptions(){if(this.props.qdata.questionType==="mcq"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{name:'optionsVw'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'qoption'},this.props.qdata.optionText.map(function(option,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index},__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(option));})));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' ');}}},{key:'setRatingSelected',value:function setRatingSelected(id){/*if(currentRating != null){
		   if(currentRating == id){
			   return "selected";
		   }
	   }*/if(this.props.existingRatingObj.hasOwnProperty(this.props.qdata.testQuestionId+"-"+this.props.qdata.attemptNo)){//console.log(this.props.existingRatingObj[this.props.qdata.testQuestionId+"-"+this.props.qdata.attemptNo].rate, id);
if(this.props.existingRatingObj[this.props.qdata.testQuestionId+"-"+this.props.qdata.attemptNo].rate==parseInt(id)){return"selected";}}}},{key:'renderlikebtn',value:function renderlikebtn(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scorecardLikebox',id:this.props.qdata.testQuestionId+"-"+this.props.qdata.attemptNo,'data-myrating':'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inlineblock'},this.rb("rating.title")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btngp inlineblock'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:"ratingIcon "+this.setRatingSelected(2),'data-id':'2',onClick:this.likeFn.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'thumb_up')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:"ratingIcon "+this.setRatingSelected(1),'data-id':'1',onClick:this.likeFn.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'thumb_down'))));}},{key:'filterHTML',value:function filterHTML(html){if(html!==null){var sb="";var pos=0;var start;while((start=html.indexOf("<math",pos))!=-1){sb+=html.substring(pos,start);var autoclose=html.indexOf("/>",start);var greaterindex=html.indexOf(">",start);if(autoclose!=-1&&autoclose<greaterindex){//autoclosed math tag
pos=autoclose+"/>".length();}else{pos=html.indexOf("</math>",start)+"</math>".length;var formula=html.substring(start,pos);var url=this.getImageUrl(formula);var img="<img src=\""+url+"\" align='middle' class='formula' />";sb+=img;}}sb+=html.substring(pos);return sb.toString();}}},{key:'renderResultFn',value:function renderResultFn(){if(this.props.qdata&&(!this.props.qdata.attemptNo||this.props.qdata.attemptNo===0)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'unans'},this.rb("scorecard.notattempted"));}else if(this.props.qdata.optionResult&&this.props.qdata.optionResult.length>0){if(this.props.qdata.optionResult[0].optionCorrect===true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons corrans'},'done'));}else if(this.props.qdata.optionResult[0].optionCorrect===false&&this.props.qdata.optionResult[0].userAns!==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons wrgans'},'close'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'unans'},this.rb("scorecard.notattempted"));}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'unans'},this.rb("scorecard.notattempted"));}}},{key:'rendersubbtns',value:function rendersubbtns(){var _this2=this;var me=this;//console.log(this.props.qdata);
if(this.props.qdata.similarType&&this.props.qdata.similarType.length>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.qdata.similarType.map(function(similarType,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CustomAccordian__["a" /* default */],{similarType:similarType,key:index,ga:me.props.ga,snippetId:me.props.qdata.snippetId,source:me.props.qdata.source,testQuestionId:me.props.qdata.testQuestionId,testId:me.props.qdata.testId,topicSubTopicMapId:me.props.qdata.topicSubTopicMapId,callbackParent:_this2.props.callbackParent,accessId:_this2.props.accessId,classId:_this2.props.classId,recomLocked:_this2.props.recomLocked});}));}}},{key:'getQuestionNumber',value:function getQuestionNumber(){var qNo=0;if(this.props.qno){qNo=this.props.qno;}if(this.props.qdata.testMode==="TEST"){return this.rb("questionview.q-label").replace("{1}",this.props.qno);}return this.rb("questionview.q-label.withattempt").replace("{1}",this.props.qno).replace("{2}",this.props.qdata.attemptNo);}},{key:'getImageUrl',value:function getImageUrl(mathml,fontColor,fontSize,fontName){var fontOptions="";if(fontColor!=null&&fontColor!=undefined){fontOptions+="&color=%23"+fontColor;}else{fontOptions+=defaultFontColor;}if(fontSize!=null&&fontSize!=undefined){fontOptions+="&fontSize="+fontSize;}else{fontOptions+=defaultFontSize;}if(fontName!=null&&fontName!=undefined){fontOptions+="&fontFamily="+fontName;}else{fontOptions+=defaultFontName;}// replace hack to remove <br> tag from mathml input to wiris editor service since latest versions 
// throws error for invalid inputs, which was previously rendered by older editor versions.
mathml=mathml.trim().replace("</math><br>","</math>");var returnImage=this.imageServiceUrl+"&mml="+encodeURIComponent(this.escapeUTF8Chars(mathml))+fontOptions;return returnImage;}},{key:'escapeUTF8Chars',value:function escapeUTF8Chars(str){var out="";for(var i=0;i<str.length;i++){var c=str.charCodeAt(i);if(c<128){out+=str.charAt(i);}else{out+="&#"+c+";";}}return out.trim();}},{key:'checkImageLoaded',value:function checkImageLoaded(){try{__WEBPACK_IMPORTED_MODULE_9_jquery___default()('img').unbind("error");__WEBPACK_IMPORTED_MODULE_9_jquery___default()('img').error(function(){var me=this;var timeDelay=5000;if(!__WEBPACK_IMPORTED_MODULE_9_jquery___default()(me).attr('imageReloadCount')){__WEBPACK_IMPORTED_MODULE_9_jquery___default()(me).attr('imageReloadCount',1);}timeDelay=timeDelay*parseInt(__WEBPACK_IMPORTED_MODULE_9_jquery___default()(me).attr('imageReloadCount'));setTimeout(function(){if(!__WEBPACK_IMPORTED_MODULE_9_jquery___default()(me).attr('imageReloadCount')){__WEBPACK_IMPORTED_MODULE_9_jquery___default()(me).attr('imageReloadCount',1);}else{__WEBPACK_IMPORTED_MODULE_9_jquery___default()(me).attr('imageReloadCount',parseInt(__WEBPACK_IMPORTED_MODULE_9_jquery___default()(me).attr('imageReloadCount'))+1);}if(__WEBPACK_IMPORTED_MODULE_9_jquery___default()(me).attr('imageReloadCount')<=4){//console.log("timeDelay::",timeDelay);
__WEBPACK_IMPORTED_MODULE_9_jquery___default()(me).attr('src',__WEBPACK_IMPORTED_MODULE_9_jquery___default()(me).attr('src'));}if(console){console.log("image not loaded :"+__WEBPACK_IMPORTED_MODULE_9_jquery___default()(me).attr('src'));}},timeDelay);}).load(function(){//console.log("loaded successfully...");
});}catch(e){}}},{key:'componentDidMount',value:function componentDidMount(){this.checkImageLoaded();}},{key:'render',value:function render(){var me=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{name:'questionView',className:'qvroot'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'qView scrollEqn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'qvwList'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quesorder'},this.getQuestionNumber(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'qVw'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{name:'questionVw scro'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(this.props.qdata.questionText))),this.renderOptions(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{name:'userAnswerVw',className:'anspadd'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("scorecard.your_answer"),':'),this.renderResultFn(),this.props.qdata.optionResult.map(function(optionObj,index){if(me.props.qdata.attemptNo>0){if(optionObj.unitPosition==0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mathml',key:index},__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(optionObj.label),' ',__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(optionObj.unit),' ',__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(me.filterHTML(optionObj.userAns)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mathml',key:index},__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(optionObj.label),' ',__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(me.filterHTML(optionObj.userAns)),' ',__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(optionObj.unit));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mathml',key:index},__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(me.filterHTML(optionObj.userAns)));}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{name:'correctAnswerVw',className:'anspadd'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("scorecard.correct_answer"),':'),this.props.qdata.optionResult.map(function(optionObj,index){if(me.props.qdata.attemptNo>0){if(optionObj.unitPosition==0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mathml',key:index},__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(optionObj.label),' ',__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(optionObj.unit),' ',__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(me.filterHTML(optionObj.correctAns)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mathml',key:index},__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(optionObj.label),' ',__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(me.filterHTML(optionObj.correctAns)),' ',__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(optionObj.unit));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mathml',key:index},__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(me.filterHTML(optionObj.correctAns)));}})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{name:'solutionVw'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'qsoln scrollEqn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.rb("editor.solutionTitle"),':'),__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(this.props.qdata.solutionText),this.renderlikebtn())),this.rendersubbtns());}}]);return WebQuestionView;}(__WEBPACK_IMPORTED_MODULE_7__views_core_LoggedInPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (WebQuestionView);

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(670);
__webpack_require__(673);
__webpack_require__(674);
__webpack_require__(675);
__webpack_require__(676);
__webpack_require__(677);
__webpack_require__(678);
__webpack_require__(679);
__webpack_require__(680);
__webpack_require__(681);
__webpack_require__(682);
__webpack_require__(683);
__webpack_require__(684);
__webpack_require__(685);
__webpack_require__(686);
__webpack_require__(687);
__webpack_require__(688);
__webpack_require__(689);
__webpack_require__(690);
__webpack_require__(691);
__webpack_require__(692);
__webpack_require__(693);
__webpack_require__(694);
__webpack_require__(695);
__webpack_require__(696);
__webpack_require__(697);
__webpack_require__(698);
__webpack_require__(699);
__webpack_require__(700);
__webpack_require__(701);
__webpack_require__(702);
__webpack_require__(703);
__webpack_require__(704);
__webpack_require__(705);
__webpack_require__(706);
__webpack_require__(707);
__webpack_require__(708);
__webpack_require__(709);
__webpack_require__(710);
__webpack_require__(711);
__webpack_require__(712);
__webpack_require__(713);
__webpack_require__(714);
__webpack_require__(715);
__webpack_require__(716);
__webpack_require__(717);
__webpack_require__(718);
__webpack_require__(719);
__webpack_require__(720);
__webpack_require__(721);
__webpack_require__(722);
__webpack_require__(723);
__webpack_require__(724);
__webpack_require__(725);
__webpack_require__(726);
__webpack_require__(727);
__webpack_require__(728);
__webpack_require__(729);
__webpack_require__(730);
__webpack_require__(731);
__webpack_require__(732);
__webpack_require__(733);
__webpack_require__(734);
__webpack_require__(735);
__webpack_require__(736);
__webpack_require__(737);
__webpack_require__(738);
__webpack_require__(739);
__webpack_require__(740);
__webpack_require__(741);
__webpack_require__(742);
__webpack_require__(743);
__webpack_require__(744);
__webpack_require__(745);
__webpack_require__(746);
__webpack_require__(747);
__webpack_require__(748);
__webpack_require__(750);
__webpack_require__(751);
__webpack_require__(753);
__webpack_require__(754);
__webpack_require__(755);
__webpack_require__(756);
__webpack_require__(757);
__webpack_require__(758);
__webpack_require__(759);
__webpack_require__(761);
__webpack_require__(762);
__webpack_require__(763);
__webpack_require__(764);
__webpack_require__(765);
__webpack_require__(766);
__webpack_require__(767);
__webpack_require__(768);
__webpack_require__(769);
__webpack_require__(770);
__webpack_require__(771);
__webpack_require__(772);
__webpack_require__(773);
__webpack_require__(236);
__webpack_require__(774);
__webpack_require__(363);
__webpack_require__(775);
__webpack_require__(364);
__webpack_require__(776);
__webpack_require__(777);
__webpack_require__(778);
__webpack_require__(779);
__webpack_require__(780);
__webpack_require__(367);
__webpack_require__(369);
__webpack_require__(370);
__webpack_require__(781);
__webpack_require__(782);
__webpack_require__(783);
__webpack_require__(784);
__webpack_require__(785);
__webpack_require__(786);
__webpack_require__(787);
__webpack_require__(788);
__webpack_require__(789);
__webpack_require__(790);
__webpack_require__(791);
__webpack_require__(792);
__webpack_require__(793);
__webpack_require__(794);
__webpack_require__(795);
__webpack_require__(796);
__webpack_require__(797);
__webpack_require__(798);
__webpack_require__(799);
__webpack_require__(800);
__webpack_require__(801);
__webpack_require__(802);
__webpack_require__(803);
__webpack_require__(804);
__webpack_require__(805);
__webpack_require__(806);
__webpack_require__(807);
__webpack_require__(808);
__webpack_require__(809);
__webpack_require__(810);
__webpack_require__(811);
__webpack_require__(812);
__webpack_require__(813);
__webpack_require__(814);
__webpack_require__(815);
__webpack_require__(816);
__webpack_require__(817);
__webpack_require__(818);
__webpack_require__(819);
__webpack_require__(820);
__webpack_require__(821);
__webpack_require__(822);
__webpack_require__(823);
__webpack_require__(824);
__webpack_require__(825);
__webpack_require__(826);
__webpack_require__(827);
__webpack_require__(828);
__webpack_require__(829);
__webpack_require__(830);
__webpack_require__(831);
__webpack_require__(832);
__webpack_require__(833);
__webpack_require__(834);
__webpack_require__(835);
__webpack_require__(836);
__webpack_require__(837);
__webpack_require__(838);
__webpack_require__(839);
__webpack_require__(840);
__webpack_require__(841);
__webpack_require__(842);
__webpack_require__(843);
__webpack_require__(844);
__webpack_require__(845);
__webpack_require__(846);
__webpack_require__(847);
__webpack_require__(848);
__webpack_require__(849);
__webpack_require__(850);
__webpack_require__(851);
__webpack_require__(852);
__webpack_require__(853);
__webpack_require__(854);
__webpack_require__(855);
__webpack_require__(856);
__webpack_require__(857);
__webpack_require__(858);
__webpack_require__(859);
__webpack_require__(860);
__webpack_require__(861);
__webpack_require__(862);
__webpack_require__(863);
__webpack_require__(864);
__webpack_require__(865);
module.exports = __webpack_require__(50);


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(9);
var has = __webpack_require__(44);
var DESCRIPTORS = __webpack_require__(22);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(41);
var META = __webpack_require__(78).KEY;
var $fails = __webpack_require__(13);
var shared = __webpack_require__(131);
var setToStringTag = __webpack_require__(109);
var uid = __webpack_require__(83);
var wks = __webpack_require__(19);
var wksExt = __webpack_require__(345);
var wksDefine = __webpack_require__(217);
var enumKeys = __webpack_require__(672);
var isArray = __webpack_require__(159);
var anObject = __webpack_require__(8);
var isObject = __webpack_require__(14);
var toObject = __webpack_require__(27);
var toIObject = __webpack_require__(45);
var toPrimitive = __webpack_require__(63);
var createDesc = __webpack_require__(82);
var _create = __webpack_require__(86);
var gOPNExt = __webpack_require__(348);
var $GOPD = __webpack_require__(46);
var $GOPS = __webpack_require__(158);
var $DP = __webpack_require__(24);
var $keys = __webpack_require__(84);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(87).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(133).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(77)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(40)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(131)('native-function-to-string', Function.toString);


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(84);
var gOPS = __webpack_require__(158);
var pIE = __webpack_require__(133);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(86) });


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(22), 'Object', { defineProperty: __webpack_require__(24).f });


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(22), 'Object', { defineProperties: __webpack_require__(347) });


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(45);
var $getOwnPropertyDescriptor = __webpack_require__(46).f;

__webpack_require__(65)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(27);
var $getPrototypeOf = __webpack_require__(47);

__webpack_require__(65)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(27);
var $keys = __webpack_require__(84);

__webpack_require__(65)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(65)('getOwnPropertyNames', function () {
  return __webpack_require__(348).f;
});


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(14);
var meta = __webpack_require__(78).onFreeze;

__webpack_require__(65)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(14);
var meta = __webpack_require__(78).onFreeze;

__webpack_require__(65)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(14);
var meta = __webpack_require__(78).onFreeze;

__webpack_require__(65)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(14);

__webpack_require__(65)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(14);

__webpack_require__(65)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(14);

__webpack_require__(65)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(1);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(349) });


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { is: __webpack_require__(350) });


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(221).set });


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(110);
var test = {};
test[__webpack_require__(19)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(41)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(1);

$export($export.P, 'Function', { bind: __webpack_require__(351) });


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(24).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(22) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(14);
var getPrototypeOf = __webpack_require__(47);
var HAS_INSTANCE = __webpack_require__(19)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(24).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseInt = __webpack_require__(353);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseFloat = __webpack_require__(354);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9);
var has = __webpack_require__(44);
var cof = __webpack_require__(52);
var inheritIfRequired = __webpack_require__(223);
var toPrimitive = __webpack_require__(63);
var fails = __webpack_require__(13);
var gOPN = __webpack_require__(87).f;
var gOPD = __webpack_require__(46).f;
var dP = __webpack_require__(24).f;
var $trim = __webpack_require__(111).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(86)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(22) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(41)(global, NUMBER, $Number);
}


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toInteger = __webpack_require__(53);
var aNumberValue = __webpack_require__(355);
var repeat = __webpack_require__(224);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(13)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $fails = __webpack_require__(13);
var aNumberValue = __webpack_require__(355);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(1);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(1);
var _isFinite = __webpack_require__(9).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', { isInteger: __webpack_require__(356) });


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(1);
var isInteger = __webpack_require__(356);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseFloat = __webpack_require__(354);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseInt = __webpack_require__(353);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(1);
var log1p = __webpack_require__(357);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(1);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(1);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(1);
var sign = __webpack_require__(225);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(1);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(1);
var $expm1 = __webpack_require__(226);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { fround: __webpack_require__(358) });


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(1);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(1);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(13)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { log1p: __webpack_require__(357) });


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { sign: __webpack_require__(225) });


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(1);
var expm1 = __webpack_require__(226);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(13)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(1);
var expm1 = __webpack_require__(226);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toAbsoluteIndex = __webpack_require__(85);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toIObject = __webpack_require__(45);
var toLength = __webpack_require__(21);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(111)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(160)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(227)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $at = __webpack_require__(160)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(1);
var toLength = __webpack_require__(21);
var context = __webpack_require__(229);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(230)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(1);
var context = __webpack_require__(229);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(230)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(224)
});


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(1);
var toLength = __webpack_require__(21);
var context = __webpack_require__(229);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(230)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(42)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(42)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(42)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(42)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(42)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(42)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(42)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(42)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(42)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(42)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(42)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(42)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(42)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(1);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(27);
var toPrimitive = __webpack_require__(63);

$export($export.P + $export.F * __webpack_require__(13)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(1);
var toISOString = __webpack_require__(749);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(13);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(41)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(19)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(40)(proto, TO_PRIMITIVE, __webpack_require__(752));


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(8);
var toPrimitive = __webpack_require__(63);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(1);

$export($export.S, 'Array', { isArray: __webpack_require__(159) });


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(51);
var $export = __webpack_require__(1);
var toObject = __webpack_require__(27);
var call = __webpack_require__(359);
var isArrayIter = __webpack_require__(231);
var toLength = __webpack_require__(21);
var createProperty = __webpack_require__(232);
var getIterFn = __webpack_require__(233);

$export($export.S + $export.F * !__webpack_require__(162)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var createProperty = __webpack_require__(232);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(13)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(1);
var toIObject = __webpack_require__(45);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(132) != Object || !__webpack_require__(54)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var html = __webpack_require__(220);
var cof = __webpack_require__(52);
var toAbsoluteIndex = __webpack_require__(85);
var toLength = __webpack_require__(21);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(13)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var aFunction = __webpack_require__(34);
var toObject = __webpack_require__(27);
var fails = __webpack_require__(13);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(54)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $forEach = __webpack_require__(66)(0);
var STRICT = __webpack_require__(54)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
var isArray = __webpack_require__(159);
var SPECIES = __webpack_require__(19)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $map = __webpack_require__(66)(1);

$export($export.P + $export.F * !__webpack_require__(54)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $filter = __webpack_require__(66)(2);

$export($export.P + $export.F * !__webpack_require__(54)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $some = __webpack_require__(66)(3);

$export($export.P + $export.F * !__webpack_require__(54)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $every = __webpack_require__(66)(4);

$export($export.P + $export.F * !__webpack_require__(54)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $reduce = __webpack_require__(360);

$export($export.P + $export.F * !__webpack_require__(54)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $reduce = __webpack_require__(360);

$export($export.P + $export.F * !__webpack_require__(54)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $indexOf = __webpack_require__(157)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(54)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toIObject = __webpack_require__(45);
var toInteger = __webpack_require__(53);
var toLength = __webpack_require__(21);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(54)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', { copyWithin: __webpack_require__(361) });

__webpack_require__(79)('copyWithin');


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', { fill: __webpack_require__(235) });

__webpack_require__(79)('fill');


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(1);
var $find = __webpack_require__(66)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(79)(KEY);


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(1);
var $find = __webpack_require__(66)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(79)(KEY);


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(88)('Array');


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var inheritIfRequired = __webpack_require__(223);
var dP = __webpack_require__(24).f;
var gOPN = __webpack_require__(87).f;
var isRegExp = __webpack_require__(161);
var $flags = __webpack_require__(134);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(22) && (!CORRECT_NEW || __webpack_require__(13)(function () {
  re2[__webpack_require__(19)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(41)(global, 'RegExp', $RegExp);
}

__webpack_require__(88)('RegExp');


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(364);
var anObject = __webpack_require__(8);
var $flags = __webpack_require__(134);
var DESCRIPTORS = __webpack_require__(22);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(41)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(13)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(8);
var toLength = __webpack_require__(21);
var advanceStringIndex = __webpack_require__(238);
var regExpExec = __webpack_require__(163);

// @@match logic
__webpack_require__(164)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(8);
var toObject = __webpack_require__(27);
var toLength = __webpack_require__(21);
var toInteger = __webpack_require__(53);
var advanceStringIndex = __webpack_require__(238);
var regExpExec = __webpack_require__(163);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(164)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(8);
var sameValue = __webpack_require__(350);
var regExpExec = __webpack_require__(163);

// @@search logic
__webpack_require__(164)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(161);
var anObject = __webpack_require__(8);
var speciesConstructor = __webpack_require__(135);
var advanceStringIndex = __webpack_require__(238);
var toLength = __webpack_require__(21);
var callRegExpExec = __webpack_require__(163);
var regexpExec = __webpack_require__(237);
var fails = __webpack_require__(13);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(164)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(77);
var global = __webpack_require__(9);
var ctx = __webpack_require__(51);
var classof = __webpack_require__(110);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(14);
var aFunction = __webpack_require__(34);
var anInstance = __webpack_require__(89);
var forOf = __webpack_require__(90);
var speciesConstructor = __webpack_require__(135);
var task = __webpack_require__(239).set;
var microtask = __webpack_require__(240)();
var newPromiseCapabilityModule = __webpack_require__(241);
var perform = __webpack_require__(365);
var userAgent = __webpack_require__(165);
var promiseResolve = __webpack_require__(366);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(19)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(91)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(109)($Promise, PROMISE);
__webpack_require__(88)(PROMISE);
Wrapper = __webpack_require__(50)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(162)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(371);
var validate = __webpack_require__(92);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(166)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $typed = __webpack_require__(167);
var buffer = __webpack_require__(242);
var anObject = __webpack_require__(8);
var toAbsoluteIndex = __webpack_require__(85);
var toLength = __webpack_require__(21);
var isObject = __webpack_require__(14);
var ArrayBuffer = __webpack_require__(9).ArrayBuffer;
var speciesConstructor = __webpack_require__(135);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(13)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(88)(ARRAY_BUFFER);


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
$export($export.G + $export.W + $export.F * !__webpack_require__(167).ABV, {
  DataView: __webpack_require__(242).DataView
});


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(69)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(69)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(69)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(69)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(69)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(69)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(69)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(69)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(69)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(1);
var aFunction = __webpack_require__(34);
var anObject = __webpack_require__(8);
var rApply = (__webpack_require__(9).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(13)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(1);
var create = __webpack_require__(86);
var aFunction = __webpack_require__(34);
var anObject = __webpack_require__(8);
var isObject = __webpack_require__(14);
var fails = __webpack_require__(13);
var bind = __webpack_require__(351);
var rConstruct = (__webpack_require__(9).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(24);
var $export = __webpack_require__(1);
var anObject = __webpack_require__(8);
var toPrimitive = __webpack_require__(63);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(13)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(1);
var gOPD = __webpack_require__(46).f;
var anObject = __webpack_require__(8);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(8);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(228)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(46);
var getPrototypeOf = __webpack_require__(47);
var has = __webpack_require__(44);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(14);
var anObject = __webpack_require__(8);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(46);
var $export = __webpack_require__(1);
var anObject = __webpack_require__(8);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(1);
var getProto = __webpack_require__(47);
var anObject = __webpack_require__(8);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(8);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(373) });


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(8);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(24);
var gOPD = __webpack_require__(46);
var getPrototypeOf = __webpack_require__(47);
var has = __webpack_require__(44);
var $export = __webpack_require__(1);
var createDesc = __webpack_require__(82);
var anObject = __webpack_require__(8);
var isObject = __webpack_require__(14);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(1);
var setProto = __webpack_require__(221);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(1);
var $includes = __webpack_require__(157)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(79)('includes');


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(1);
var flattenIntoArray = __webpack_require__(374);
var toObject = __webpack_require__(27);
var toLength = __webpack_require__(21);
var aFunction = __webpack_require__(34);
var arraySpeciesCreate = __webpack_require__(234);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(79)('flatMap');


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(1);
var flattenIntoArray = __webpack_require__(374);
var toObject = __webpack_require__(27);
var toLength = __webpack_require__(21);
var toInteger = __webpack_require__(53);
var arraySpeciesCreate = __webpack_require__(234);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(79)('flatten');


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(1);
var $at = __webpack_require__(160)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(1);
var $pad = __webpack_require__(375);
var userAgent = __webpack_require__(165);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(1);
var $pad = __webpack_require__(375);
var userAgent = __webpack_require__(165);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(111)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(111)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(1);
var defined = __webpack_require__(64);
var toLength = __webpack_require__(21);
var isRegExp = __webpack_require__(161);
var getFlags = __webpack_require__(134);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(228)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(217)('asyncIterator');


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(217)('observable');


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(1);
var ownKeys = __webpack_require__(373);
var toIObject = __webpack_require__(45);
var gOPD = __webpack_require__(46);
var createProperty = __webpack_require__(232);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $values = __webpack_require__(376)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $entries = __webpack_require__(376)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(27);
var aFunction = __webpack_require__(34);
var $defineProperty = __webpack_require__(24);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(22) && $export($export.P + __webpack_require__(168), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(27);
var aFunction = __webpack_require__(34);
var $defineProperty = __webpack_require__(24);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(22) && $export($export.P + __webpack_require__(168), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(27);
var toPrimitive = __webpack_require__(63);
var getPrototypeOf = __webpack_require__(47);
var getOwnPropertyDescriptor = __webpack_require__(46).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(22) && $export($export.P + __webpack_require__(168), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(27);
var toPrimitive = __webpack_require__(63);
var getPrototypeOf = __webpack_require__(47);
var getOwnPropertyDescriptor = __webpack_require__(46).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(22) && $export($export.P + __webpack_require__(168), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(1);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(377)('Map') });


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(1);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(377)('Set') });


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(169)('Map');


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(169)('Set');


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(169)('WeakMap');


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(169)('WeakSet');


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(170)('Map');


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(170)('Set');


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(170)('WeakMap');


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(170)('WeakSet');


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(1);

$export($export.G, { global: __webpack_require__(9) });


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(1);

$export($export.S, 'System', { global: __webpack_require__(9) });


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(1);
var cof = __webpack_require__(52);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var scale = __webpack_require__(379);
var fround = __webpack_require__(358);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { scale: __webpack_require__(379) });


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(1);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(1);
var core = __webpack_require__(50);
var global = __webpack_require__(9);
var speciesConstructor = __webpack_require__(135);
var promiseResolve = __webpack_require__(366);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(1);
var newPromiseCapability = __webpack_require__(241);
var perform = __webpack_require__(365);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(70);
var anObject = __webpack_require__(8);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(70);
var anObject = __webpack_require__(8);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(70);
var anObject = __webpack_require__(8);
var getPrototypeOf = __webpack_require__(47);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(369);
var from = __webpack_require__(378);
var metadata = __webpack_require__(70);
var anObject = __webpack_require__(8);
var getPrototypeOf = __webpack_require__(47);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(70);
var anObject = __webpack_require__(8);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(70);
var anObject = __webpack_require__(8);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(70);
var anObject = __webpack_require__(8);
var getPrototypeOf = __webpack_require__(47);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(70);
var anObject = __webpack_require__(8);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(70);
var anObject = __webpack_require__(8);
var aFunction = __webpack_require__(34);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(1);
var microtask = __webpack_require__(240)();
var process = __webpack_require__(9).process;
var isNode = __webpack_require__(52)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(1);
var global = __webpack_require__(9);
var core = __webpack_require__(50);
var microtask = __webpack_require__(240)();
var OBSERVABLE = __webpack_require__(19)('observable');
var aFunction = __webpack_require__(34);
var anObject = __webpack_require__(8);
var anInstance = __webpack_require__(89);
var redefineAll = __webpack_require__(91);
var hide = __webpack_require__(40);
var forOf = __webpack_require__(90);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(88)('Observable');


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(9);
var $export = __webpack_require__(1);
var userAgent = __webpack_require__(165);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $task = __webpack_require__(239);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(236);
var getKeys = __webpack_require__(84);
var redefine = __webpack_require__(41);
var global = __webpack_require__(9);
var hide = __webpack_require__(40);
var Iterators = __webpack_require__(112);
var wks = __webpack_require__(19);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(868);
module.exports = __webpack_require__(50).RegExp.escape;


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(1);
var $re = __webpack_require__(869)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 869 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 870 */
/***/ (function(module, exports) {

module.exports = {"qsQuestionPojo":{"questionSource":1,"snippetId":18472,"topicId":0,"problemType":0,"difficulty":0,"year":0,"source":"HeyMath!","board":null,"name":"PQ00018472","questionType":"fib","optionType":"normal","questionText":"<img src=\"https://testme.heymath.com/formula3/render?version=2.0&transparency=true&mml=%3Cmath%3E%3Cmrow%3E%3Cmtext%3EExpand%20%20and%20%20simplify%3C%2Fmtext%3E%3C%2Fmrow%3E%3C%2Fmath%3E&color=%23000000&fontFamily=Muli&fontSize=13\" align=\"middle\" class=\"formula\" align=\"middle\"/> <img src=\"https://testme.heymath.com/formula3/render?version=2.0&transparency=true&mml=%3Cmath%3E%3Cmrow%3E%3Cmo%3E-%3C%2Fmo%3E%3Cmn%3E5%3C%2Fmn%3E%3Cmo%3E%26%238290%3B%3C%2Fmo%3E%3Cmi%3Em%3C%2Fmi%3E%3Cmfenced%3E%3Cmrow%3E%3Cmn%3E2%3C%2Fmn%3E%3Cmo%3E%26%238290%3B%3C%2Fmo%3E%3Cmi%3Em%3C%2Fmi%3E%3Cmo%3E-%3C%2Fmo%3E%3Cmn%3E9%3C%2Fmn%3E%3Cmo%3E%26%238290%3B%3C%2Fmo%3E%3Cmi%3En%3C%2Fmi%3E%3C%2Fmrow%3E%3C%2Fmfenced%3E%3C%2Fmrow%3E%3C%2Fmath%3E&color=%23000000&fontFamily=Muli&fontSize=13\" align=\"middle\" class=\"formula\" align=\"middle\"/>.","solutionText":"<table border=0 cellspacing=0><tr height='38px'><td style='border-style:solid; border-color:white; border-width:0px 2px; vertical-align:baseline; padding-top:0px' align=right width=0><img src=\"https://testme.heymath.com/formula3/render?version=2.0&transparency=true&mml=%3Cmath%3E%3Cmrow%3E%3Cmo%3E-%3C%2Fmo%3E%3Cmn%3E5%3C%2Fmn%3E%3Cmo%3E%26%238290%3B%3C%2Fmo%3E%3Cmi%3Em%3C%2Fmi%3E%3Cmfenced%3E%3Cmrow%3E%3Cmn%3E2%3C%2Fmn%3E%3Cmo%3E%26%238290%3B%3C%2Fmo%3E%3Cmi%3Em%3C%2Fmi%3E%3Cmo%3E-%3C%2Fmo%3E%3Cmn%3E9%3C%2Fmn%3E%3Cmo%3E%26%238290%3B%3C%2Fmo%3E%3Cmi%3En%3C%2Fmi%3E%3C%2Fmrow%3E%3C%2Fmfenced%3E%3C%2Fmrow%3E%3C%2Fmath%3E&color=%23000000&fontFamily=Muli&fontSize=13\" align=\"middle\" class=\"formula\" align=\"middle\"/></td><td style='border-style:solid; border-color:white; border-width:0px 2px; vertical-align:baseline; padding-top:0px' align=center width=0>=</td><td style='border-style:solid; border-color:white; border-width:0px 2px; vertical-align:baseline; padding-top:0px' align=left width=0><img src=\"https://testme.heymath.com/formula3/render?version=2.0&transparency=true&mml=%3Cmath%3E%3Cmrow%3E%3Cmo%3E-%3C%2Fmo%3E%3Cmn%3E5%3C%2Fmn%3E%3Cmo%3E%26%238290%3B%3C%2Fmo%3E%3Cmi%3Em%3C%2Fmi%3E%3Cmfenced%3E%3Cmrow%3E%3Cmn%3E2%3C%2Fmn%3E%3Cmo%3E%26%238290%3B%3C%2Fmo%3E%3Cmi%3Em%3C%2Fmi%3E%3C%2Fmrow%3E%3C%2Fmfenced%3E%3Cmo%3E-%3C%2Fmo%3E%3Cmfenced%3E%3Cmrow%3E%3Cmo%3E-%3C%2Fmo%3E%3Cmn%3E5%3C%2Fmn%3E%3Cmo%3E%26%238290%3B%3C%2Fmo%3E%3Cmi%3Em%3C%2Fmi%3E%3C%2Fmrow%3E%3C%2Fmfenced%3E%3Cmfenced%3E%3Cmrow%3E%3Cmn%3E9%3C%2Fmn%3E%3Cmo%3E%26%238290%3B%3C%2Fmo%3E%3Cmi%3En%3C%2Fmi%3E%3C%2Fmrow%3E%3C%2Fmfenced%3E%3C%2Fmrow%3E%3C%2Fmath%3E&color=%23000000&fontFamily=Muli&fontSize=13\" align=\"middle\" class=\"formula\" align=\"middle\"/><span class=\"Apple-tab-span\" style=\"white-space:pre\"></td></tr><tr height='38px'><td style='border-style:solid; border-color:white; border-width:0px 2px; vertical-align:baseline; padding-top:0px' align=right width=0></td><td style='border-style:solid; border-color:white; border-width:0px 2px; vertical-align:baseline; padding-top:0px' align=center width=0>=</td><td style='border-style:solid; border-color:white; border-width:0px 2px; vertical-align:baseline; padding-top:0px' align=left width=0><img src=\"https://testme.heymath.com/formula3/render?version=2.0&transparency=true&mml=%3Cmath%3E%3Cmrow%3E%3Cmo%3E-%3C%2Fmo%3E%3Cmn%3E10%3C%2Fmn%3E%3Cmo%3E%26%238290%3B%3C%2Fmo%3E%3Cmsup%3E%3Cmi%3Em%3C%2Fmi%3E%3Cmn%3E2%3C%2Fmn%3E%3C%2Fmsup%3E%3Cmo%3E%2B%3C%2Fmo%3E%3Cmn%3E45%3C%2Fmn%3E%3Cmo%3E%26%238290%3B%3C%2Fmo%3E%3Cmi%3Em%3C%2Fmi%3E%3Cmo%3E%26%238290%3B%3C%2Fmo%3E%3Cmi%3En%3C%2Fmi%3E%3C%2Fmrow%3E%3C%2Fmath%3E&color=%23000000&fontFamily=Muli&fontSize=13\" align=\"middle\" class=\"formula\" align=\"middle\"/></td></tr></table><table border=0 cellspacing=0><tr height='38px'><td style='border-style:solid; border-color:white; border-width:0px 2px; vertical-align:baseline; padding-top:0px' align=left width=0><span class=\"Apple-tab-span\" style=\"white-space:pre\"></td></tr></table>","variableMap":"{\"mathml\":{\"txtA\":\"<math><mrow><mtext>Expand and simplify</mtext></mrow></math>\",\"ans\":\"<math><mrow><mo>-</mo><mn>10</mn><mo>&#8290;</mo><msup><mi>m</mi><mn>2</mn></msup><mo>+</mo><mn>45</mn><mo>&#8290;</mo><mi>m</mi><mo>&#8290;</mo><mi>n</mi></mrow></math>\",\"exprB\":\"<math><mrow><mo>-</mo><mn>5</mn><mo>&#8290;</mo><mi>m</mi><mfenced><mrow><mn>2</mn><mo>&#8290;</mo><mi>m</mi></mrow></mfenced><mo>-</mo><mfenced><mrow><mo>-</mo><mn>5</mn><mo>&#8290;</mo><mi>m</mi></mrow></mfenced><mfenced><mrow><mn>9</mn><mo>&#8290;</mo><mi>n</mi></mrow></mfenced></mrow></math>\",\"exprA\":\"<math><mrow><mo>-</mo><mn>5</mn><mo>&#8290;</mo><mi>m</mi><mfenced><mrow><mn>2</mn><mo>&#8290;</mo><mi>m</mi><mo>-</mo><mn>9</mn><mo>&#8290;</mo><mi>n</mi></mrow></mfenced></mrow></math>\"}}","variableList":"[\"#txtA\",\"#ans\",\"#exprB\",\"#exprA\",\"#txtA\",\"#ans\",\"#exprB\",\"#exprA\"]","assertions":"<assertions>\n  <assertion name=\"syntax_expression\" correctAnswer=\"0\" answer=\"0\"/>\n  <assertion name=\"equivalent_symbolic\" correctAnswer=\"0\" answer=\"0\"/>\n  <assertion name=\"check_expanded\" correctAnswer=\"0\" answer=\"0\"/>\n</assertions>\n","options":[{"optionIndex":1,"optionImage":"<img src=\"https://testme.heymath.com/formula3/render?version=2.0&transparency=true&mml=%3Cmath%3E%3Cmrow%3E%3Cmo%3E-%3C%2Fmo%3E%3Cmn%3E10%3C%2Fmn%3E%3Cmo%3E%26%238290%3B%3C%2Fmo%3E%3Cmsup%3E%3Cmi%3Em%3C%2Fmi%3E%3Cmn%3E2%3C%2Fmn%3E%3C%2Fmsup%3E%3Cmo%3E%2B%3C%2Fmo%3E%3Cmn%3E45%3C%2Fmn%3E%3Cmo%3E%26%238290%3B%3C%2Fmo%3E%3Cmi%3Em%3C%2Fmi%3E%3Cmo%3E%26%238290%3B%3C%2Fmo%3E%3Cmi%3En%3C%2Fmi%3E%3C%2Fmrow%3E%3C%2Fmath%3E&color=%23000000&fontFamily=Muli&fontSize=13\" align=\"middle\" class=\"formula\" align=\"middle\"/>","optionMathml":"<math><mrow><mo>-</mo><mn>10</mn><mo>&#8290;</mo><msup><mi>m</mi><mn>2</mn></msup><mo>+</mo><mn>45</mn><mo>&#8290;</mo><mi>m</mi><mo>&#8290;</mo><mi>n</mi></mrow></math>","isCorrect":true,"attributes":{"unit":null,"label":null,"correctAnswerDisplayVariable":""}}],"csQid":0,"hasWorkedSolution":0,"questionAuthor":null,"questionAuthoredSchool":null,"completeOptionsDisplay":[null],"correctOptionsDisplay":[" <img src=\"https://testme.heymath.com/formula3/render?version=2.0&transparency=true&mml=%3Cmath%3E%3Cmrow%3E%3Cmo%3E-%3C%2Fmo%3E%3Cmn%3E10%3C%2Fmn%3E%3Cmo%3E%26%238290%3B%3C%2Fmo%3E%3Cmsup%3E%3Cmi%3Em%3C%2Fmi%3E%3Cmn%3E2%3C%2Fmn%3E%3C%2Fmsup%3E%3Cmo%3E%2B%3C%2Fmo%3E%3Cmn%3E45%3C%2Fmn%3E%3Cmo%3E%26%238290%3B%3C%2Fmo%3E%3Cmi%3Em%3C%2Fmi%3E%3Cmo%3E%26%238290%3B%3C%2Fmo%3E%3Cmi%3En%3C%2Fmi%3E%3C%2Fmrow%3E%3C%2Fmath%3E&color=%23000000&fontFamily=Muli&fontSize=13\" align=\"middle\" class=\"formula\" align=\"middle\"/>"]},"questionId":18472,"topicId":0,"questionNumber":0,"marks":0,"attempts":0,"csQid":0,"subMarks":null,"subMarksAllowed":false}

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_id_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_core_LoggedInPage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_scorecard_LessonComponent__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_loader_spinner__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_loader_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_loader_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_html_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_accessible_accordion__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_accessible_accordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_accessible_accordion__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var params={slidesPerView:'auto',paginationClickable:true,centeredSlides:true,spaceBetween:25,grabCursor:true,freeMode:true,scrollbar:'.swiper-scrollbar',scrollbarHide:true,effect:'fade'};var CustomAccordian=function(_LoggedInPage){_inherits(CustomAccordian,_LoggedInPage);function CustomAccordian(props){_classCallCheck(this,CustomAccordian);var _this=_possibleConstructorReturn(this,(CustomAccordian.__proto__||Object.getPrototypeOf(CustomAccordian)).call(this,props));_this.state={dataLoaded:false,data:{},isStarView:false,isAccoView:false};_this.markedquesFn=_this.markedquesFn.bind(_this);_this.likeFn=_this.likeFn.bind(_this);_this.ga=_this.props.ga||{"subscribe-btn":"scorecard-subscribe"};return _this;}_createClass(CustomAccordian,[{key:'likeFn',value:function likeFn(event){var ratingIcons=document.querySelectorAll('.ratingIcon');ratingIcons.forEach(function(rating){if(rating.classList.contains('selected')){rating.classList.remove('selected');}});event.currentTarget.classList.add("selected");}},{key:'markedquesFn',value:function markedquesFn(event){//event.currentTarget.classList.toggle("selected")
this.setState({isStarView:!this.state.isStarView});}},{key:'renderlikebtn',value:function renderlikebtn(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'likebox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.rb("rating.title")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btngp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ratingIcon','data-id':'0',onClick:this.likeFn.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'thumb_up')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ratingIcon','data-id':'0',onClick:this.likeFn.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'thumb_down'))));}},{key:'handleChange',value:function handleChange(e){this.setState({isAccoView:!this.state.isAccoView});//console.log("id "+e.target.getAttribute('id'));
//const acco_arrow=document.querySelector(".acc_arrow");
//console.log("on change"+acco_arrow.classList)
// acco_arrow.classList.toggle("selected");
var me=this;if(this.props.similarType.typeName=="question"){var callBackSuccess=function callBackSuccess(response){me.setState({dataLoaded:true,data:response});if(response.code===200){}else if(response.code===400){}else{}};var callBackFailure=function callBackFailure(response){console.log("GET_SIMILAR_QUESTION Failure...");};new __WEBPACK_IMPORTED_MODULE_4__util_HmAjax__["a" /* default */](this.getUrlFor("GET_SIMILAR_QUESTION")+this.props.similarType.similarSnippetId).get(callBackSuccess,callBackFailure);}else if(this.props.similarType.typeName=="lesson"){me.setState({dataLoaded:true});}var itemType=this.props.similarType.typeName=="question"?"similar_problem":"recommended_lessons";try{var trackObj={"test_id":me.props.testId,"snippet_id":me.props.snippetId,"question_source":me.props.source,"item_type":this.getTracker().enums.viewedItemType[itemType],"hidden":this.state.isAccoView};this.initiateTrack("item_viewed",trackObj);}catch(e){}}},{key:'getGA',value:function getGA(){return this.ga["subscribe-btn"];}},{key:'renderOptions',value:function renderOptions(){if(this.state.data.qsQuestionPojo.questionType==="mcq"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{name:'optionsVw'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'qoption'},this.state.data.qsQuestionPojo.options.map(function(option,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index},__WEBPACK_IMPORTED_MODULE_6_react_html_parser___default()(option.optionImage));})));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' ');}}},{key:'renderaccQuesFn',value:function renderaccQuesFn(propsval){var _this2=this;console.log("recomm pblm :: ",propsval);if(this.state.dataLoaded==false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_loader_spinner___default.a,{type:'Oval',color:'#00BFFF',height:'100',width:'50'}));}else{if(this.props.similarType.typeName=="lesson"){console.log("lesson source==",this.props.source);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row allMiddle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-center allMiddle scorecardLessons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_id_swiper___default.a,{className:'student-slider',slidesPerView:params.slidesPerView,spaceBetween:params.spaceBetween},this.props.similarType.similarLessonList.map(function(lesson,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__views_scorecard_LessonComponent__["a" /* default */],{isFrom:"Custom Accordian",isFreeTrail:_this2.props.recomLocked.recommendedLessonLocked,lesson:lesson,testId:_this2.props.testId,topicSubTopicMapId:_this2.props.topicSubTopicMapId,accessId:_this2.props.accessId,classId:_this2.props.classId,tracksource:'solution_question',snippetId:_this2.props.snippetId,source:_this2.props.source,key:index});}))),function(){if(propsval){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-center allMiddle'},_this2.subscribeFn(_this2.getGA()+" - Recommended Lesson - Subscribe"));}}());}else if(this.props.similarType.typeName=="question"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'qcontacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{name:'questionView',className:'qvroot'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'qView'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'qvwList'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quesorder'},"Q"+this.state.data.qsQuestionPojo.questionSource),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'qVw scrollEqn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{name:'questionVw scrollEqn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_6_react_html_parser___default()(this.state.data.qsQuestionPojo.questionText))),this.renderOptions(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scrollEqn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("scorecard.correct_answer"),':'),__WEBPACK_IMPORTED_MODULE_6_react_html_parser___default()(this.state.data.qsQuestionPojo.correctOptionsDisplay))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{name:'solutionVw'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'qsoln scrollEqn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.rb("editor.solutionTitle"),':'),__WEBPACK_IMPORTED_MODULE_6_react_html_parser___default()(this.state.data.qsQuestionPojo.solutionText)))));}}}},{key:'lockcontent',value:function lockcontent(props){if(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'upgrdlock1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'lock'));}}},{key:'renderRecommendedItem',value:function renderRecommendedItem(){var me=this;if(this.props.similarType.typeName=="question"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quesbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'spblmbtn'},me.rb("scorecard.similar_problem"),' ',this.state.isAccoView?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons acc_arrow selected'},'arrow_drop_up'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons acc_arrow'},'arrow_drop_up')),' ');}else if(this.props.similarType.typeName=="lesson"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quesbg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'spblmbtn'},this.rb("scorecard.recommended_lesson"),' ',this.state.isAccoView?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons acc_arrow selected'},'arrow_drop_up'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons acc_arrow'},'arrow_drop_up'),' '),' ',this.lockcontent(this.props.recomLocked.recommendedLessonLocked),' ');}}},{key:'render',value:function render(){var classdisabled="";if(this.props.recomLocked.similarProblemLocked){classdisabled="disabled lockdisabled";}var lessonLocked=this.props.recomLocked.recommendedLessonLocked||false;if(this.props.recomLocked.similarProblemLocked){if(this.props.similarType.typeName=="question"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:"spblmbtn"+classdisabled},this.rb("scorecard.similar_problem"),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons acc_arrow'},'arrow_drop_up'),' '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'upgrdlock'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'lock')),' ',this.subscribeFn(this.getGA()+" - Subscribe"),' ');}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_accessible_accordion__["Accordion"],{className:'accBox',onChange:this.handleChange.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_accessible_accordion__["AccordionItem"],{className:'accitem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_accessible_accordion__["AccordionItemTitle"],{className:'acctitle'},this.renderRecommendedItem()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_accessible_accordion__["AccordionItemBody"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.renderaccQuesFn(lessonLocked)))));}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_accessible_accordion__["Accordion"],{className:'accBox',onChange:this.handleChange.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_accessible_accordion__["AccordionItem"],{className:'accitem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_accessible_accordion__["AccordionItemTitle"],{className:'acctitle'},this.renderRecommendedItem()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_accessible_accordion__["AccordionItemBody"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.renderaccQuesFn(lessonLocked)))));}}}]);return CustomAccordian;}(__WEBPACK_IMPORTED_MODULE_2__views_core_LoggedInPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (CustomAccordian);

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ITEM_TYPES = exports.createUltimatePagination = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ultimatePagination = __webpack_require__(873);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var renderItemComponentFunctionFactory = function renderItemComponentFunctionFactory(itemTypeToComponent, currentPage, onChange) {
  var onItemClickFunctionFactory = function onItemClickFunctionFactory(_ref) {
    var value = _ref.value,
        isDisabled = _ref.isDisabled;

    return function () {
      if (!isDisabled && onChange && currentPage !== value) {
        onChange(value);
      }
    };
  };

  return function (props) {
    var ItemComponent = itemTypeToComponent[props.type];
    var onItemClick = onItemClickFunctionFactory(props);
    return _react2.default.createElement(ItemComponent, _extends({ onClick: onItemClick }, props));
  };
};

var createUltimatePagination = function createUltimatePagination(_ref2) {
  var itemTypeToComponent = _ref2.itemTypeToComponent,
      _ref2$WrapperComponen = _ref2.WrapperComponent,
      WrapperComponent = _ref2$WrapperComponen === undefined ? 'div' : _ref2$WrapperComponen;

  var UltimatePaginationComponent = function UltimatePaginationComponent(props) {
    var currentPage = props.currentPage,
        totalPages = props.totalPages,
        boundaryPagesRange = props.boundaryPagesRange,
        siblingPagesRange = props.siblingPagesRange,
        hideEllipsis = props.hideEllipsis,
        hidePreviousAndNextPageLinks = props.hidePreviousAndNextPageLinks,
        hideFirstAndLastPageLinks = props.hideFirstAndLastPageLinks,
        onChange = props.onChange,
        disabled = props.disabled,
        restProps = _objectWithoutProperties(props, ['currentPage', 'totalPages', 'boundaryPagesRange', 'siblingPagesRange', 'hideEllipsis', 'hidePreviousAndNextPageLinks', 'hideFirstAndLastPageLinks', 'onChange', 'disabled']);

    var paginationModel = (0, _ultimatePagination.getPaginationModel)({
      currentPage: currentPage,
      totalPages: totalPages,
      boundaryPagesRange: boundaryPagesRange,
      siblingPagesRange: siblingPagesRange,
      hideEllipsis: hideEllipsis,
      hidePreviousAndNextPageLinks: hidePreviousAndNextPageLinks,
      hideFirstAndLastPageLinks: hideFirstAndLastPageLinks
    });
    var renderItemComponent = renderItemComponentFunctionFactory(itemTypeToComponent, currentPage, onChange);
    return _react2.default.createElement(
      WrapperComponent,
      restProps,
      paginationModel.map(function (itemModel) {
        return renderItemComponent(_extends({}, itemModel, {
          isDisabled: !!disabled
        }));
      })
    );
  };

  UltimatePaginationComponent.propTypes = {
    currentPage: _propTypes2.default.number.isRequired,
    totalPages: _propTypes2.default.number.isRequired,
    boundaryPagesRange: _propTypes2.default.number,
    siblingPagesRange: _propTypes2.default.number,
    hideEllipsis: _propTypes2.default.bool,
    hidePreviousAndNextPageLinks: _propTypes2.default.bool,
    hideFirstAndLastPageLinks: _propTypes2.default.bool,
    onChange: _propTypes2.default.func,
    disabled: _propTypes2.default.bool
  };

  return UltimatePaginationComponent;
};

exports.createUltimatePagination = createUltimatePagination;
exports.ITEM_TYPES = _ultimatePagination.ITEM_TYPES;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ultimate_pagination_utils_1 = __webpack_require__(874);
var ultimate_pagination_item_factories_1 = __webpack_require__(875);
function getPaginationModel(options) {
    if (options == null) {
        throw new Error('getPaginationModel(): options object should be a passed');
    }
    var totalPages = Number(options.totalPages);
    if (isNaN(totalPages)) {
        throw new Error('getPaginationModel(): totalPages should be a number');
    }
    if (totalPages < 0) {
        throw new Error('getPaginationModel(): totalPages shouldn\'t be a negative number');
    }
    var currentPage = Number(options.currentPage);
    if (isNaN(currentPage)) {
        throw new Error('getPaginationModel(): currentPage should be a number');
    }
    if (currentPage < 0) {
        throw new Error('getPaginationModel(): currentPage shouldn\'t be a negative number');
    }
    if (currentPage > totalPages) {
        throw new Error('getPaginationModel(): currentPage shouldn\'t be greater than totalPages');
    }
    var boundaryPagesRange = (options.boundaryPagesRange == null ? 1 : Number(options.boundaryPagesRange));
    if (isNaN(boundaryPagesRange)) {
        throw new Error('getPaginationModel(): boundaryPagesRange should be a number');
    }
    if (boundaryPagesRange < 0) {
        throw new Error('getPaginationModel(): boundaryPagesRange shouldn\'t be a negative number');
    }
    var siblingPagesRange = (options.siblingPagesRange == null ? 1 : Number(options.siblingPagesRange));
    if (isNaN(siblingPagesRange)) {
        throw new Error('getPaginationModel(): siblingPagesRange should be a number');
    }
    if (siblingPagesRange < 0) {
        throw new Error('getPaginationModel(): siblingPagesRange shouldn\'t be a negative number');
    }
    var hidePreviousAndNextPageLinks = Boolean(options.hidePreviousAndNextPageLinks);
    var hideFirstAndLastPageLinks = Boolean(options.hideFirstAndLastPageLinks);
    var hideEllipsis = Boolean(options.hideEllipsis);
    var ellipsisSize = (hideEllipsis ? 0 : 1);
    var paginationModel = [];
    var createPage = ultimate_pagination_item_factories_1.createPageFunctionFactory(options);
    if (!hideFirstAndLastPageLinks) {
        paginationModel.push(ultimate_pagination_item_factories_1.createFirstPageLink(options));
    }
    if (!hidePreviousAndNextPageLinks) {
        paginationModel.push(ultimate_pagination_item_factories_1.createPreviousPageLink(options));
    }
    // Simplify generation of pages if number of available items is equal or greater than total pages to show
    if (1 + 2 * ellipsisSize + 2 * siblingPagesRange + 2 * boundaryPagesRange >= totalPages) {
        var allPages = ultimate_pagination_utils_1.createRange(1, totalPages).map(createPage);
        paginationModel.push.apply(paginationModel, allPages);
    }
    else {
        // Calculate group of first pages
        var firstPagesStart = 1;
        var firstPagesEnd = boundaryPagesRange;
        var firstPages = ultimate_pagination_utils_1.createRange(firstPagesStart, firstPagesEnd).map(createPage);
        // Calculate group of last pages
        var lastPagesStart = totalPages + 1 - boundaryPagesRange;
        var lastPagesEnd = totalPages;
        var lastPages = ultimate_pagination_utils_1.createRange(lastPagesStart, lastPagesEnd).map(createPage);
        // Calculate group of main pages
        var mainPagesStart = Math.min(Math.max(currentPage - siblingPagesRange, firstPagesEnd + ellipsisSize + 1), lastPagesStart - ellipsisSize - 2 * siblingPagesRange - 1);
        var mainPagesEnd = mainPagesStart + 2 * siblingPagesRange;
        var mainPages = ultimate_pagination_utils_1.createRange(mainPagesStart, mainPagesEnd).map(createPage);
        // Add group of first pages
        paginationModel.push.apply(paginationModel, firstPages);
        if (!hideEllipsis) {
            // Calculate and add ellipsis before group of main pages
            var firstEllipsisPageNumber = mainPagesStart - 1;
            var showPageInsteadOfFirstEllipsis = (firstEllipsisPageNumber === firstPagesEnd + 1);
            var createFirstEllipsisOrPage = showPageInsteadOfFirstEllipsis ? createPage : ultimate_pagination_item_factories_1.createFirstEllipsis;
            var firstEllipsis = createFirstEllipsisOrPage(firstEllipsisPageNumber);
            paginationModel.push(firstEllipsis);
        }
        // Add group of main pages
        paginationModel.push.apply(paginationModel, mainPages);
        if (!hideEllipsis) {
            // Calculate and add ellipsis after group of main pages
            var secondEllipsisPageNumber = mainPagesEnd + 1;
            var showPageInsteadOfSecondEllipsis = (secondEllipsisPageNumber === lastPagesStart - 1);
            var createSecondEllipsisOrPage = showPageInsteadOfSecondEllipsis ? createPage : ultimate_pagination_item_factories_1.createSecondEllipsis;
            var secondEllipsis = createSecondEllipsisOrPage(secondEllipsisPageNumber);
            paginationModel.push(secondEllipsis);
        }
        // Add group of last pages
        paginationModel.push.apply(paginationModel, lastPages);
    }
    if (!hidePreviousAndNextPageLinks) {
        paginationModel.push(ultimate_pagination_item_factories_1.createNextPageLink(options));
    }
    if (!hideFirstAndLastPageLinks) {
        paginationModel.push(ultimate_pagination_item_factories_1.createLastPageLink(options));
    }
    return paginationModel;
}
exports.getPaginationModel = getPaginationModel;
var ultimate_pagination_constants_1 = __webpack_require__(381);
exports.ITEM_TYPES = ultimate_pagination_constants_1.ITEM_TYPES;
exports.ITEM_KEYS = ultimate_pagination_constants_1.ITEM_KEYS;
//# sourceMappingURL=ultimate-pagination.js.map

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function createRange(start, end) {
    var range = [];
    for (var i = start; i <= end; i++) {
        range.push(i);
    }
    return range;
}
exports.createRange = createRange;
//# sourceMappingURL=ultimate-pagination-utils.js.map

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ultimate_pagination_constants_1 = __webpack_require__(381);
exports.createFirstEllipsis = function (pageNumber) {
    return {
        type: ultimate_pagination_constants_1.ITEM_TYPES.ELLIPSIS,
        key: ultimate_pagination_constants_1.ITEM_KEYS.FIRST_ELLIPSIS,
        value: pageNumber,
        isActive: false
    };
};
exports.createSecondEllipsis = function (pageNumber) {
    return {
        type: ultimate_pagination_constants_1.ITEM_TYPES.ELLIPSIS,
        key: ultimate_pagination_constants_1.ITEM_KEYS.SECOND_ELLIPSIS,
        value: pageNumber,
        isActive: false
    };
};
exports.createFirstPageLink = function (options) {
    var currentPage = options.currentPage;
    return {
        type: ultimate_pagination_constants_1.ITEM_TYPES.FIRST_PAGE_LINK,
        key: ultimate_pagination_constants_1.ITEM_KEYS.FIRST_PAGE_LINK,
        value: 1,
        isActive: currentPage === 1
    };
};
exports.createPreviousPageLink = function (options) {
    var currentPage = options.currentPage;
    return {
        type: ultimate_pagination_constants_1.ITEM_TYPES.PREVIOUS_PAGE_LINK,
        key: ultimate_pagination_constants_1.ITEM_KEYS.PREVIOUS_PAGE_LINK,
        value: Math.max(1, currentPage - 1),
        isActive: currentPage === 1
    };
};
exports.createNextPageLink = function (options) {
    var currentPage = options.currentPage, totalPages = options.totalPages;
    return {
        type: ultimate_pagination_constants_1.ITEM_TYPES.NEXT_PAGE_LINK,
        key: ultimate_pagination_constants_1.ITEM_KEYS.NEXT_PAGE_LINK,
        value: Math.min(totalPages, currentPage + 1),
        isActive: currentPage === totalPages
    };
};
exports.createLastPageLink = function (options) {
    var currentPage = options.currentPage, totalPages = options.totalPages;
    return {
        type: ultimate_pagination_constants_1.ITEM_TYPES.LAST_PAGE_LINK,
        key: ultimate_pagination_constants_1.ITEM_KEYS.LAST_PAGE_LINK,
        value: totalPages,
        isActive: currentPage === totalPages
    };
};
exports.createPageFunctionFactory = function (options) {
    var currentPage = options.currentPage;
    return function (pageNumber) {
        return {
            type: ultimate_pagination_constants_1.ITEM_TYPES.PAGE,
            key: pageNumber,
            value: pageNumber,
            isActive: pageNumber === currentPage
        };
    };
};
//# sourceMappingURL=ultimate-pagination-item-factories.js.map

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _FlatButton = __webpack_require__(877);

var _FlatButton2 = _interopRequireDefault(_FlatButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FlatButton2.default;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(93);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(117);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(67);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(48);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(56);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(57);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(58);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(74);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(141);

var _transitions2 = _interopRequireDefault(_transitions);

var _colorManipulator = __webpack_require__(258);

var _EnhancedButton = __webpack_require__(912);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

var _FlatButtonLabel = __webpack_require__(928);

var _FlatButtonLabel2 = _interopRequireDefault(_FlatButtonLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validateLabel(props, propName, componentName) {
  if (false) {
    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
    }
  }
}

var FlatButton = function (_Component) {
  (0, _inherits3.default)(FlatButton, _Component);

  function FlatButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FlatButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FlatButton.__proto__ || (0, _getPrototypeOf2.default)(FlatButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false,
      isKeyboardFocused: false,
      touch: false
    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
      _this.setState({ isKeyboardFocused: isKeyboardFocused });
      _this.props.onKeyboardFocus(event, isKeyboardFocused);
    }, _this.handleMouseEnter = function (event) {
      // Cancel hover styles for touch devices
      if (!_this.state.touch) _this.setState({ hovered: true });
      _this.props.onMouseEnter(event);
    }, _this.handleMouseLeave = function (event) {
      _this.setState({ hovered: false });
      _this.props.onMouseLeave(event);
    }, _this.handleTouchStart = function (event) {
      _this.setState({ touch: true });
      _this.props.onTouchStart(event);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FlatButton, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.disabled) {
        this.setState({
          hovered: false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          backgroundColor = _props.backgroundColor,
          children = _props.children,
          disabled = _props.disabled,
          fullWidth = _props.fullWidth,
          hoverColor = _props.hoverColor,
          icon = _props.icon,
          label = _props.label,
          labelStyle = _props.labelStyle,
          labelPosition = _props.labelPosition,
          primary = _props.primary,
          rippleColor = _props.rippleColor,
          secondary = _props.secondary,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'children', 'disabled', 'fullWidth', 'hoverColor', 'icon', 'label', 'labelStyle', 'labelPosition', 'primary', 'rippleColor', 'secondary', 'style']);
      var _context$muiTheme = this.context.muiTheme,
          borderRadius = _context$muiTheme.borderRadius,
          _context$muiTheme$but = _context$muiTheme.button,
          buttonHeight = _context$muiTheme$but.height,
          buttonMinWidth = _context$muiTheme$but.minWidth,
          buttonTextTransform = _context$muiTheme$but.textTransform,
          _context$muiTheme$fla = _context$muiTheme.flatButton,
          buttonFilterColor = _context$muiTheme$fla.buttonFilterColor,
          buttonColor = _context$muiTheme$fla.color,
          disabledTextColor = _context$muiTheme$fla.disabledTextColor,
          fontSize = _context$muiTheme$fla.fontSize,
          fontWeight = _context$muiTheme$fla.fontWeight,
          primaryTextColor = _context$muiTheme$fla.primaryTextColor,
          secondaryTextColor = _context$muiTheme$fla.secondaryTextColor,
          textColor = _context$muiTheme$fla.textColor,
          _context$muiTheme$fla2 = _context$muiTheme$fla.textTransform,
          textTransform = _context$muiTheme$fla2 === undefined ? buttonTextTransform || 'uppercase' : _context$muiTheme$fla2;

      var defaultTextColor = disabled ? disabledTextColor : primary ? primaryTextColor : secondary ? secondaryTextColor : textColor;

      var defaultHoverColor = (0, _colorManipulator.fade)(buttonFilterColor, 0.2);
      var defaultRippleColor = buttonFilterColor;
      var buttonHoverColor = hoverColor || defaultHoverColor;
      var buttonRippleColor = rippleColor || defaultRippleColor;
      var buttonBackgroundColor = backgroundColor || buttonColor;
      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;

      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
        height: buttonHeight,
        lineHeight: buttonHeight + 'px',
        minWidth: fullWidth ? '100%' : buttonMinWidth,
        color: defaultTextColor,
        transition: _transitions2.default.easeOut(),
        borderRadius: borderRadius,
        userSelect: 'none',
        overflow: 'hidden',
        backgroundColor: hovered ? buttonHoverColor : buttonBackgroundColor,
        padding: 0,
        margin: 0,
        textAlign: 'center'
      }, style);

      var iconCloned = void 0;
      var labelStyleIcon = {};

      if (icon) {
        var iconStyles = (0, _simpleAssign2.default)({
          verticalAlign: 'middle',
          marginLeft: label && labelPosition !== 'before' ? 12 : 0,
          marginRight: label && labelPosition === 'before' ? 12 : 0
        }, icon.props.style);
        iconCloned = _react2.default.cloneElement(icon, {
          color: icon.props.color || mergedRootStyles.color,
          style: iconStyles,
          key: 'iconCloned'
        });

        if (labelPosition === 'before') {
          labelStyleIcon.paddingRight = 8;
        } else {
          labelStyleIcon.paddingLeft = 8;
        }
      }

      var mergedLabelStyles = (0, _simpleAssign2.default)({
        letterSpacing: 0,
        textTransform: textTransform,
        fontWeight: fontWeight,
        fontSize: fontSize
      }, labelStyleIcon, labelStyle);

      var labelElement = label ? _react2.default.createElement(_FlatButtonLabel2.default, { key: 'labelElement', label: label, style: mergedLabelStyles }) : undefined;

      // Place label before or after children.
      var enhancedButtonChildren = labelPosition === 'before' ? [labelElement, iconCloned, children] : [children, iconCloned, labelElement];

      return _react2.default.createElement(
        _EnhancedButton2.default,
        (0, _extends3.default)({}, other, {
          disabled: disabled,
          focusRippleColor: buttonRippleColor,
          focusRippleOpacity: 0.3,
          onKeyboardFocus: this.handleKeyboardFocus,
          onMouseLeave: this.handleMouseLeave,
          onMouseEnter: this.handleMouseEnter,
          onTouchStart: this.handleTouchStart,
          style: mergedRootStyles,
          touchRippleColor: buttonRippleColor,
          touchRippleOpacity: 0.3
        }),
        enhancedButtonChildren
      );
    }
  }]);
  return FlatButton;
}(_react.Component);

FlatButton.muiName = 'FlatButton';
FlatButton.defaultProps = {
  disabled: false,
  fullWidth: false,
  labelStyle: {},
  labelPosition: 'after',
  onKeyboardFocus: function onKeyboardFocus() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  onTouchStart: function onTouchStart() {},
  primary: false,
  secondary: false
};
FlatButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
FlatButton.propTypes =  false ? {
  /**
   * Color of button when mouse is not hovering over it.
   */
  backgroundColor: _propTypes2.default.string,
  /**
   * This is what will be displayed inside the button.
   * If a label is specified, the text within the label prop will
   * be displayed. Otherwise, the component will expect children
   * which will then be displayed. (In our example,
   * we are nesting an `<input type="file" />` and a `span`
   * that acts as our label to be displayed.) This only
   * applies to flat and raised buttons.
   */
  children: _propTypes2.default.node,
  /**
   * The CSS class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * The element to use as the container for the FlatButton. Either a string to
   * use a DOM element or a ReactElement. This is useful for wrapping the
   * FlatButton in a custom Link component. If a ReactElement is given, ensure
   * that it passes all of its given props through to the underlying DOM
   * element and renders its children prop for proper integration.
   */
  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  /**
   * If true, the element's ripple effect will be disabled.
   */
  disableTouchRipple: _propTypes2.default.bool,
  /**
   * Disables the button if set to true.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If true, the button will take up the full width of its container.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * Color of button when mouse hovers over.
   */
  hoverColor: _propTypes2.default.string,
  /**
   * The URL to link to when the button is clicked.
   */
  href: _propTypes2.default.string,
  /**
   * Use this property to display an icon.
   */
  icon: _propTypes2.default.node,
  /**
   * Label for the button.
   */
  label: validateLabel,
  /**
   * Place label before or after the passed children.
   */
  labelPosition: _propTypes2.default.oneOf(['before', 'after']),
  /**
   * Override the inline-styles of the button's label element.
   */
  labelStyle: _propTypes2.default.object,
  /**
   * Callback function fired when the button is clicked.
   *
   * @param {object} event Click event targeting the button.
   */
  onClick: _propTypes2.default.func,
  /**
   * Callback function fired when the element is focused or blurred by the keyboard.
   *
   * @param {object} event `focus` or `blur` event targeting the element.
   * @param {boolean} isKeyboardFocused Indicates whether the element is focused.
   */
  onKeyboardFocus: _propTypes2.default.func,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /** @ignore */
  onTouchStart: _propTypes2.default.func,
  /**
   * If true, colors button according to
   * primaryTextColor from the Theme.
   */
  primary: _propTypes2.default.bool,
  /**
   * Color for the ripple after button is clicked.
   */
  rippleColor: _propTypes2.default.string,
  /**
   * If true, colors button according to secondaryTextColor from the theme.
   * The primary prop has precendent if set to true.
   */
  secondary: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = FlatButton;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(879), __esModule: true };

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(880);
module.exports = __webpack_require__(30).Object.assign;


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(55);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(881) });


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(73);
var getKeys = __webpack_require__(137);
var gOPS = __webpack_require__(253);
var pIE = __webpack_require__(174);
var toObject = __webpack_require__(116);
var IObject = __webpack_require__(384);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(114)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(115);
var toLength = __webpack_require__(248);
var toAbsoluteIndex = __webpack_require__(883);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(249);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(885);
module.exports = __webpack_require__(30).Object.getPrototypeOf;


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(116);
var $getPrototypeOf = __webpack_require__(385);

__webpack_require__(386)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(887);
var $Object = __webpack_require__(30).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(55);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(73), 'Object', { defineProperty: __webpack_require__(71).f });


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(889), __esModule: true };

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(254);
__webpack_require__(392);
module.exports = __webpack_require__(256).f('iterator');


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(249);
var defined = __webpack_require__(247);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(255);
var descriptor = __webpack_require__(136);
var setToStringTag = __webpack_require__(175);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(94)(IteratorPrototype, __webpack_require__(43)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(71);
var anObject = __webpack_require__(72);
var getKeys = __webpack_require__(137);

module.exports = __webpack_require__(73) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(894);
var step = __webpack_require__(895);
var Iterators = __webpack_require__(140);
var toIObject = __webpack_require__(115);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(389)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 895 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(897), __esModule: true };

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(898);
__webpack_require__(395);
__webpack_require__(903);
__webpack_require__(904);
module.exports = __webpack_require__(30).Symbol;


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(35);
var has = __webpack_require__(95);
var DESCRIPTORS = __webpack_require__(73);
var $export = __webpack_require__(55);
var redefine = __webpack_require__(390);
var META = __webpack_require__(899).KEY;
var $fails = __webpack_require__(114);
var shared = __webpack_require__(251);
var setToStringTag = __webpack_require__(175);
var uid = __webpack_require__(173);
var wks = __webpack_require__(43);
var wksExt = __webpack_require__(256);
var wksDefine = __webpack_require__(257);
var enumKeys = __webpack_require__(900);
var isArray = __webpack_require__(901);
var anObject = __webpack_require__(72);
var isObject = __webpack_require__(80);
var toObject = __webpack_require__(116);
var toIObject = __webpack_require__(115);
var toPrimitive = __webpack_require__(246);
var createDesc = __webpack_require__(136);
var _create = __webpack_require__(255);
var gOPNExt = __webpack_require__(902);
var $GOPD = __webpack_require__(394);
var $GOPS = __webpack_require__(253);
var $DP = __webpack_require__(71);
var $keys = __webpack_require__(137);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(393).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(174).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(139)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(94)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(173)('meta');
var isObject = __webpack_require__(80);
var has = __webpack_require__(95);
var setDesc = __webpack_require__(71).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(114)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(137);
var gOPS = __webpack_require__(253);
var pIE = __webpack_require__(174);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(138);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(115);
var gOPN = __webpack_require__(393).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(257)('asyncIterator');


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(257)('observable');


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(906), __esModule: true };

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(907);
module.exports = __webpack_require__(30).Object.setPrototypeOf;


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(55);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(908).set });


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(80);
var anObject = __webpack_require__(72);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(113)(Function.call, __webpack_require__(394).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(910), __esModule: true };

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(911);
var $Object = __webpack_require__(30).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(55);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(255) });


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(93);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(117);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(67);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(48);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(56);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(57);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(58);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(74);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _events = __webpack_require__(913);

var _events2 = _interopRequireDefault(_events);

var _keycode = __webpack_require__(914);

var _keycode2 = _interopRequireDefault(_keycode);

var _FocusRipple = __webpack_require__(915);

var _FocusRipple2 = _interopRequireDefault(_FocusRipple);

var _TouchRipple = __webpack_require__(921);

var _TouchRipple2 = _interopRequireDefault(_TouchRipple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styleInjected = false;
var listening = false;
var tabPressed = false;

function injectStyle() {
  if (!styleInjected) {
    // Remove inner padding and border in Firefox 4+.
    var style = document.createElement('style');
    style.innerHTML = '\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n      }\n    ';

    document.body.appendChild(style);
    styleInjected = true;
  }
}

function listenForTabPresses() {
  if (!listening) {
    _events2.default.on(window, 'keydown', function (event) {
      tabPressed = (0, _keycode2.default)(event) === 'tab';
    });
    listening = true;
  }
}

var EnhancedButton = function (_Component) {
  (0, _inherits3.default)(EnhancedButton, _Component);

  function EnhancedButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EnhancedButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedButton.__proto__ || (0, _getPrototypeOf2.default)(EnhancedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isKeyboardFocused: false
    }, _this.handleKeyDown = function (event) {
      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
        if ((0, _keycode2.default)(event) === 'esc' && _this.state.isKeyboardFocused) {
          _this.removeKeyboardFocus(event);
        }
      }
      _this.props.onKeyDown(event);
    }, _this.handleKeyUp = function (event) {
      _this.props.onKeyUp(event);
    }, _this.handleBlur = function (event) {
      _this.cancelFocusTimeout();
      _this.removeKeyboardFocus(event);
      _this.props.onBlur(event);
    }, _this.handleFocus = function (event) {
      if (event) event.persist();
      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
        // setTimeout is needed because the focus event fires first
        // Wait so that we can capture if this was a keyboard focus
        // or touch focus
        _this.focusTimeout = setTimeout(function () {
          if (tabPressed) {
            _this.setKeyboardFocus(event);
            tabPressed = false;
          }
        }, 150);

        _this.props.onFocus(event);
      }
    }, _this.handleClick = function (event) {
      _this.cancelFocusTimeout();
      if (!_this.props.disabled) {
        tabPressed = false;
        _this.removeKeyboardFocus(event);
        _this.props.onClick(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EnhancedButton, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          disabled = _props.disabled,
          disableKeyboardFocus = _props.disableKeyboardFocus,
          keyboardFocused = _props.keyboardFocused;

      if (!disabled && keyboardFocused && !disableKeyboardFocus) {
        this.setState({ isKeyboardFocused: true });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      injectStyle();
      listenForTabPresses();
      if (this.state.isKeyboardFocused) {
        this.button.focus();
        this.props.onKeyboardFocus(null, true);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ((nextProps.disabled || nextProps.disableKeyboardFocus) && this.state.isKeyboardFocused) {
        this.setState({ isKeyboardFocused: false });
        if (nextProps.onKeyboardFocus) {
          nextProps.onKeyboardFocus(null, false);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.focusTimeout) {
        clearTimeout(this.focusTimeout);
      }
    }
  }, {
    key: 'isKeyboardFocused',
    value: function isKeyboardFocused() {
      return this.state.isKeyboardFocused;
    }
  }, {
    key: 'removeKeyboardFocus',
    value: function removeKeyboardFocus(event) {
      if (this.state.isKeyboardFocused) {
        this.setState({ isKeyboardFocused: false });
        this.props.onKeyboardFocus(event, false);
      }
    }
  }, {
    key: 'setKeyboardFocus',
    value: function setKeyboardFocus(event) {
      if (!this.state.isKeyboardFocused) {
        this.setState({ isKeyboardFocused: true });
        this.props.onKeyboardFocus(event, true);
      }
    }
  }, {
    key: 'cancelFocusTimeout',
    value: function cancelFocusTimeout() {
      if (this.focusTimeout) {
        clearTimeout(this.focusTimeout);
        this.focusTimeout = null;
      }
    }
  }, {
    key: 'createButtonChildren',
    value: function createButtonChildren() {
      var _props2 = this.props,
          centerRipple = _props2.centerRipple,
          children = _props2.children,
          disabled = _props2.disabled,
          disableFocusRipple = _props2.disableFocusRipple,
          disableKeyboardFocus = _props2.disableKeyboardFocus,
          disableTouchRipple = _props2.disableTouchRipple,
          focusRippleColor = _props2.focusRippleColor,
          focusRippleOpacity = _props2.focusRippleOpacity,
          touchRippleColor = _props2.touchRippleColor,
          touchRippleOpacity = _props2.touchRippleOpacity;
      var isKeyboardFocused = this.state.isKeyboardFocused;

      // Focus Ripple

      var focusRipple = isKeyboardFocused && !disabled && !disableFocusRipple && !disableKeyboardFocus ? _react2.default.createElement(_FocusRipple2.default, {
        color: focusRippleColor,
        opacity: focusRippleOpacity,
        show: isKeyboardFocused,
        style: {
          overflow: 'hidden'
        },
        key: 'focusRipple'
      }) : undefined;

      // Touch Ripple
      var touchRipple = !disabled && !disableTouchRipple ? _react2.default.createElement(
        _TouchRipple2.default,
        {
          centerRipple: centerRipple,
          color: touchRippleColor,
          opacity: touchRippleOpacity,
          key: 'touchRipple'
        },
        children
      ) : undefined;

      return [focusRipple, touchRipple, touchRipple ? undefined : children];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          centerRipple = _props3.centerRipple,
          children = _props3.children,
          containerElement = _props3.containerElement,
          disabled = _props3.disabled,
          disableFocusRipple = _props3.disableFocusRipple,
          disableKeyboardFocus = _props3.disableKeyboardFocus,
          disableTouchRipple = _props3.disableTouchRipple,
          focusRippleColor = _props3.focusRippleColor,
          focusRippleOpacity = _props3.focusRippleOpacity,
          href = _props3.href,
          keyboardFocused = _props3.keyboardFocused,
          touchRippleColor = _props3.touchRippleColor,
          touchRippleOpacity = _props3.touchRippleOpacity,
          onBlur = _props3.onBlur,
          onClick = _props3.onClick,
          onFocus = _props3.onFocus,
          onKeyUp = _props3.onKeyUp,
          onKeyDown = _props3.onKeyDown,
          onKeyboardFocus = _props3.onKeyboardFocus,
          style = _props3.style,
          tabIndex = _props3.tabIndex,
          type = _props3.type,
          other = (0, _objectWithoutProperties3.default)(_props3, ['centerRipple', 'children', 'containerElement', 'disabled', 'disableFocusRipple', 'disableKeyboardFocus', 'disableTouchRipple', 'focusRippleColor', 'focusRippleOpacity', 'href', 'keyboardFocused', 'touchRippleColor', 'touchRippleOpacity', 'onBlur', 'onClick', 'onFocus', 'onKeyUp', 'onKeyDown', 'onKeyboardFocus', 'style', 'tabIndex', 'type']);
      var _context$muiTheme = this.context.muiTheme,
          prepareStyles = _context$muiTheme.prepareStyles,
          enhancedButton = _context$muiTheme.enhancedButton;


      var mergedStyles = (0, _simpleAssign2.default)({
        border: 10,
        boxSizing: 'border-box',
        display: 'inline-block',
        fontFamily: this.context.muiTheme.baseTheme.fontFamily,
        WebkitTapHighlightColor: enhancedButton.tapHighlightColor, // Remove mobile color flashing (deprecated)
        cursor: disabled ? 'default' : 'pointer',
        textDecoration: 'none',
        margin: 0,
        padding: 0,
        outline: 'none',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        position: 'relative', // This is needed so that ripples do not bleed past border radius.
        verticalAlign: href ? 'middle' : null
      }, style);

      // Passing both background:none & backgroundColor can break due to object iteration order
      if (!mergedStyles.backgroundColor && !mergedStyles.background) {
        mergedStyles.background = 'none';
      }

      if (disabled && href) {
        return _react2.default.createElement(
          'span',
          (0, _extends3.default)({}, other, {
            style: mergedStyles
          }),
          children
        );
      }

      var buttonProps = (0, _extends3.default)({}, other, {
        style: prepareStyles(mergedStyles),
        ref: function ref(node) {
          return _this2.button = node;
        },
        disabled: disabled,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onKeyUp: this.handleKeyUp,
        onKeyDown: this.handleKeyDown,
        onClick: this.handleClick,
        tabIndex: disabled || disableKeyboardFocus ? -1 : tabIndex
      });

      if (href) buttonProps.href = href;

      var buttonChildren = this.createButtonChildren();

      if (_react2.default.isValidElement(containerElement)) {
        return _react2.default.cloneElement(containerElement, buttonProps, buttonChildren);
      }

      if (!href && containerElement === 'button') {
        buttonProps.type = type;
      }

      return _react2.default.createElement(href ? 'a' : containerElement, buttonProps, buttonChildren);
    }
  }]);
  return EnhancedButton;
}(_react.Component);

EnhancedButton.defaultProps = {
  containerElement: 'button',
  onBlur: function onBlur() {},
  onClick: function onClick() {},
  onFocus: function onFocus() {},
  onKeyDown: function onKeyDown() {},
  onKeyUp: function onKeyUp() {},
  onKeyboardFocus: function onKeyboardFocus() {},
  tabIndex: 0,
  type: 'button'
};
EnhancedButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
EnhancedButton.propTypes =  false ? {
  centerRipple: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  disableFocusRipple: _propTypes2.default.bool,
  disableKeyboardFocus: _propTypes2.default.bool,
  disableTouchRipple: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  focusRippleColor: _propTypes2.default.string,
  focusRippleOpacity: _propTypes2.default.number,
  href: _propTypes2.default.string,
  keyboardFocused: _propTypes2.default.bool,
  onBlur: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onKeyUp: _propTypes2.default.func,
  onKeyboardFocus: _propTypes2.default.func,
  style: _propTypes2.default.object,
  tabIndex: _propTypes2.default.number,
  touchRippleColor: _propTypes2.default.string,
  touchRippleOpacity: _propTypes2.default.number,
  type: _propTypes2.default.string
} : {};
exports.default = EnhancedButton;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  once: function once(el, type, callback) {
    var typeArray = type ? type.split(' ') : [];
    var recursiveFunction = function recursiveFunction(event) {
      event.target.removeEventListener(event.type, recursiveFunction);
      return callback(event);
    };

    for (var i = typeArray.length - 1; i >= 0; i--) {
      this.on(el, typeArray[i], recursiveFunction);
    }
  },
  on: function on(el, type, callback) {
    if (el.addEventListener) {
      el.addEventListener(type, callback);
    } else {
      // IE8+ Support
      el.attachEvent('on' + type, function () {
        callback.call(el);
      });
    }
  },
  off: function off(el, type, callback) {
    if (el.removeEventListener) {
      el.removeEventListener(type, callback);
    } else {
      // IE8+ Support
      el.detachEvent('on' + type, callback);
    }
  },
  isKeyboard: function isKeyboard(event) {
    return ['keydown', 'keypress', 'keyup'].indexOf(event.type) !== -1;
  }
};

/***/ }),
/* 914 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

function keyCode(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */
keyCode.isEventKey = function isEventKey(event, nameOrCode) {
  if (event && 'object' === typeof event) {
    var keyCode = event.which || event.keyCode || event.charCode
    if (keyCode === null || keyCode === undefined) { return false; }
    if (typeof nameOrCode === 'string') {
      // check codes
      var foundNamedKey = codes[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    
      // check aliases
      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    } else if (typeof nameOrCode === 'number') {
      return nameOrCode === keyCode;
    }
    return false;
  }
}

exports = module.exports = keyCode;

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'spacebar': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}

/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(67);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(48);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(56);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(57);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(58);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(74);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(10);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(259);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _autoPrefix = __webpack_require__(260);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(141);

var _transitions2 = _interopRequireDefault(_transitions);

var _ScaleIn = __webpack_require__(917);

var _ScaleIn2 = _interopRequireDefault(_ScaleIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pulsateDuration = 750;

var FocusRipple = function (_Component) {
  (0, _inherits3.default)(FocusRipple, _Component);

  function FocusRipple() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FocusRipple);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FocusRipple.__proto__ || (0, _getPrototypeOf2.default)(FocusRipple)).call.apply(_ref, [this].concat(args))), _this), _this.pulsate = function () {
      var innerCircle = _reactDom2.default.findDOMNode(_this.refs.innerCircle);
      if (!innerCircle) return;

      var startScale = 'scale(1)';
      var endScale = 'scale(0.85)';
      var currentScale = innerCircle.style.transform || startScale;
      var nextScale = currentScale === startScale ? endScale : startScale;

      _autoPrefix2.default.set(innerCircle.style, 'transform', nextScale);
      _this.timeout = setTimeout(_this.pulsate, pulsateDuration);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FocusRipple, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.show) {
        this.setRippleSize();
        this.pulsate();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.show) {
        this.setRippleSize();
        this.pulsate();
      } else {
        if (this.timeout) clearTimeout(this.timeout);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'getRippleElement',
    value: function getRippleElement(props) {
      var color = props.color,
          innerStyle = props.innerStyle,
          opacity = props.opacity;
      var _context$muiTheme = this.context.muiTheme,
          prepareStyles = _context$muiTheme.prepareStyles,
          ripple = _context$muiTheme.ripple;


      var innerStyles = (0, _simpleAssign2.default)({
        position: 'absolute',
        height: '100%',
        width: '100%',
        borderRadius: '50%',
        opacity: opacity ? opacity : 0.16,
        backgroundColor: color || ripple.color,
        transition: _transitions2.default.easeOut(pulsateDuration + 'ms', 'transform', null, _transitions2.default.easeInOutFunction)
      }, innerStyle);

      return _react2.default.createElement('div', { ref: 'innerCircle', style: prepareStyles((0, _simpleAssign2.default)({}, innerStyles)) });
    }
  }, {
    key: 'setRippleSize',
    value: function setRippleSize() {
      var el = _reactDom2.default.findDOMNode(this.refs.innerCircle);
      var height = el.offsetHeight;
      var width = el.offsetWidth;
      var size = Math.max(height, width);

      var oldTop = 0;
      // For browsers that don't support endsWith()
      if (el.style.top.indexOf('px', el.style.top.length - 2) !== -1) {
        oldTop = parseInt(el.style.top);
      }
      el.style.height = size + 'px';
      el.style.top = height / 2 - size / 2 + oldTop + 'px';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          show = _props.show,
          style = _props.style;


      var mergedRootStyles = (0, _simpleAssign2.default)({
        height: '100%',
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0
      }, style);

      var ripple = show ? this.getRippleElement(this.props) : null;

      return _react2.default.createElement(
        _ScaleIn2.default,
        {
          maxScale: 0.85,
          style: mergedRootStyles
        },
        ripple
      );
    }
  }]);
  return FocusRipple;
}(_react.Component);

FocusRipple.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
FocusRipple.propTypes =  false ? {
  color: _propTypes2.default.string,
  innerStyle: _propTypes2.default.object,
  opacity: _propTypes2.default.number,
  show: _propTypes2.default.bool,
  style: _propTypes2.default.object
} : {};
exports.default = FocusRipple;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(93);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(117);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(67);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(48);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(56);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(57);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(58);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(74);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(396);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _ScaleInChild = __webpack_require__(920);

var _ScaleInChild2 = _interopRequireDefault(_ScaleInChild);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScaleIn = function (_Component) {
  (0, _inherits3.default)(ScaleIn, _Component);

  function ScaleIn() {
    (0, _classCallCheck3.default)(this, ScaleIn);
    return (0, _possibleConstructorReturn3.default)(this, (ScaleIn.__proto__ || (0, _getPrototypeOf2.default)(ScaleIn)).apply(this, arguments));
  }

  (0, _createClass3.default)(ScaleIn, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          childStyle = _props.childStyle,
          enterDelay = _props.enterDelay,
          maxScale = _props.maxScale,
          minScale = _props.minScale,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'childStyle', 'enterDelay', 'maxScale', 'minScale', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
        position: 'relative',
        height: '100%'
      }, style);

      var newChildren = _react2.default.Children.map(children, function (child) {
        return _react2.default.createElement(
          _ScaleInChild2.default,
          {
            key: child.key,
            enterDelay: enterDelay,
            maxScale: maxScale,
            minScale: minScale,
            style: childStyle
          },
          child
        );
      });

      return _react2.default.createElement(
        _TransitionGroup2.default,
        (0, _extends3.default)({}, other, {
          style: prepareStyles(mergedRootStyles),
          component: 'div'
        }),
        newChildren
      );
    }
  }]);
  return ScaleIn;
}(_react.Component);

ScaleIn.defaultProps = {
  enterDelay: 0
};
ScaleIn.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ScaleIn.propTypes =  false ? {
  childStyle: _propTypes2.default.object,
  children: _propTypes2.default.node,
  enterDelay: _propTypes2.default.number,
  maxScale: _propTypes2.default.number,
  minScale: _propTypes2.default.number,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = ScaleIn;

/***/ }),
/* 918 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(93);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(117);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(67);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(48);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(56);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(57);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(58);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(74);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(10);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _autoPrefix = __webpack_require__(260);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(141);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScaleInChild = function (_Component) {
  (0, _inherits3.default)(ScaleInChild, _Component);

  function ScaleInChild() {
    (0, _classCallCheck3.default)(this, ScaleInChild);
    return (0, _possibleConstructorReturn3.default)(this, (ScaleInChild.__proto__ || (0, _getPrototypeOf2.default)(ScaleInChild)).apply(this, arguments));
  }

  (0, _createClass3.default)(ScaleInChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.enterTimer);
      clearTimeout(this.leaveTimer);
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentDidAppear',
    value: function componentDidAppear() {
      this.animate();
    }
  }, {
    key: 'componentDidEnter',
    value: function componentDidEnter() {
      this.animate();
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;

      style.opacity = '0';
      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.minScale + ')');

      this.leaveTimer = setTimeout(callback, 450);
    }
  }, {
    key: 'animate',
    value: function animate() {
      var style = _reactDom2.default.findDOMNode(this).style;

      style.opacity = '1';
      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.maxScale + ')');
    }
  }, {
    key: 'initializeAnimation',
    value: function initializeAnimation(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;

      style.opacity = '0';
      _autoPrefix2.default.set(style, 'transform', 'scale(0)');

      this.enterTimer = setTimeout(callback, this.props.enterDelay);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          enterDelay = _props.enterDelay,
          maxScale = _props.maxScale,
          minScale = _props.minScale,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterDelay', 'maxScale', 'minScale', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
        position: 'absolute',
        height: '100%',
        width: '100%',
        top: 0,
        left: 0,
        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
      }, style);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
        children
      );
    }
  }]);
  return ScaleInChild;
}(_react.Component);

ScaleInChild.defaultProps = {
  enterDelay: 0,
  maxScale: 1,
  minScale: 0
};
ScaleInChild.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ScaleInChild.propTypes =  false ? {
  children: _propTypes2.default.node,
  enterDelay: _propTypes2.default.number,
  maxScale: _propTypes2.default.number,
  minScale: _propTypes2.default.number,
  style: _propTypes2.default.object
} : {};
exports.default = ScaleInChild;

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(397);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(67);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(48);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(56);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(57);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(58);

var _inherits3 = _interopRequireDefault(_inherits2);

var _toArray2 = __webpack_require__(925);

var _toArray3 = _interopRequireDefault(_toArray2);

var _simpleAssign = __webpack_require__(74);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(10);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _TransitionGroup = __webpack_require__(396);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _dom = __webpack_require__(926);

var _dom2 = _interopRequireDefault(_dom);

var _CircleRipple = __webpack_require__(927);

var _CircleRipple2 = _interopRequireDefault(_CircleRipple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Remove the first element of the array
var shift = function shift(_ref) {
  var _ref2 = (0, _toArray3.default)(_ref),
      newArray = _ref2.slice(1);

  return newArray;
};

var TouchRipple = function (_Component) {
  (0, _inherits3.default)(TouchRipple, _Component);

  function TouchRipple(props, context) {
    (0, _classCallCheck3.default)(this, TouchRipple);

    // Touch start produces a mouse down event for compat reasons. To avoid
    // showing ripples twice we skip showing a ripple for the first mouse down
    // after a touch start. Note we don't store ignoreNextMouseDown in this.state
    // to avoid re-rendering when we change it.
    var _this = (0, _possibleConstructorReturn3.default)(this, (TouchRipple.__proto__ || (0, _getPrototypeOf2.default)(TouchRipple)).call(this, props, context));

    _this.handleMouseDown = function (event) {
      // only listen to left clicks
      if (event.button === 0) {
        _this.start(event, false);
      }
    };

    _this.handleMouseUp = function () {
      _this.end();
    };

    _this.handleMouseLeave = function () {
      _this.end();
    };

    _this.handleTouchStart = function (event) {
      event.stopPropagation();
      // If the user is swiping (not just tapping), save the position so we can
      // abort ripples if the user appears to be scrolling.
      if (_this.props.abortOnScroll && event.touches) {
        _this.startListeningForScrollAbort(event);
        _this.startTime = Date.now();
      }
      _this.start(event, true);
    };

    _this.handleTouchEnd = function () {
      _this.end();
    };

    _this.handleTouchMove = function (event) {
      // Stop trying to abort if we're already 300ms into the animation
      var timeSinceStart = Math.abs(Date.now() - _this.startTime);
      if (timeSinceStart > 300) {
        _this.stopListeningForScrollAbort();
        return;
      }

      // If the user is scrolling...
      var deltaY = Math.abs(event.touches[0].clientY - _this.firstTouchY);
      var deltaX = Math.abs(event.touches[0].clientX - _this.firstTouchX);
      // Call it a scroll after an arbitrary 6px (feels reasonable in testing)
      if (deltaY > 6 || deltaX > 6) {
        var currentRipples = _this.state.ripples;
        var ripple = currentRipples[0];
        // This clone will replace the ripple in ReactTransitionGroup with a
        // version that will disappear immediately when removed from the DOM
        var abortedRipple = _react2.default.cloneElement(ripple, { aborted: true });
        // Remove the old ripple and replace it with the new updated one
        currentRipples = shift(currentRipples);
        currentRipples = [].concat((0, _toConsumableArray3.default)(currentRipples), [abortedRipple]);
        _this.setState({ ripples: currentRipples }, function () {
          // Call end after we've set the ripple to abort otherwise the setState
          // in end() merges with this and the ripple abort fails
          _this.end();
        });
      }
    };

    _this.ignoreNextMouseDown = false;

    _this.state = {
      // This prop allows us to only render the ReactTransitionGroup
      // on the first click of the component, making the inital render faster.
      hasRipples: false,
      nextKey: 0,
      ripples: []
    };
    return _this;
  }

  (0, _createClass3.default)(TouchRipple, [{
    key: 'start',
    value: function start(event, isRippleTouchGenerated) {
      var theme = this.context.muiTheme.ripple;

      if (this.ignoreNextMouseDown && !isRippleTouchGenerated) {
        this.ignoreNextMouseDown = false;
        return;
      }

      var ripples = this.state.ripples;

      // Add a ripple to the ripples array
      ripples = [].concat((0, _toConsumableArray3.default)(ripples), [_react2.default.createElement(_CircleRipple2.default, {
        key: this.state.nextKey,
        style: !this.props.centerRipple ? this.getRippleStyle(event) : {},
        color: this.props.color || theme.color,
        opacity: this.props.opacity,
        touchGenerated: isRippleTouchGenerated
      })]);

      this.ignoreNextMouseDown = isRippleTouchGenerated;
      this.setState({
        hasRipples: true,
        nextKey: this.state.nextKey + 1,
        ripples: ripples
      });
    }
  }, {
    key: 'end',
    value: function end() {
      var currentRipples = this.state.ripples;
      this.setState({
        ripples: shift(currentRipples)
      });
      if (this.props.abortOnScroll) {
        this.stopListeningForScrollAbort();
      }
    }

    // Check if the user seems to be scrolling and abort the animation if so

  }, {
    key: 'startListeningForScrollAbort',
    value: function startListeningForScrollAbort(event) {
      this.firstTouchY = event.touches[0].clientY;
      this.firstTouchX = event.touches[0].clientX;
      // Note that when scolling Chrome throttles this event to every 200ms
      // Also note we don't listen for scroll events directly as there's no general
      // way to cover cases like scrolling within containers on the page
      document.body.addEventListener('touchmove', this.handleTouchMove);
    }
  }, {
    key: 'stopListeningForScrollAbort',
    value: function stopListeningForScrollAbort() {
      document.body.removeEventListener('touchmove', this.handleTouchMove);
    }
  }, {
    key: 'getRippleStyle',
    value: function getRippleStyle(event) {
      var el = _reactDom2.default.findDOMNode(this);
      var elHeight = el.offsetHeight;
      var elWidth = el.offsetWidth;
      var offset = _dom2.default.offset(el);
      var isTouchEvent = event.touches && event.touches.length;
      var pageX = isTouchEvent ? event.touches[0].pageX : event.pageX;
      var pageY = isTouchEvent ? event.touches[0].pageY : event.pageY;
      var pointerX = pageX - offset.left;
      var pointerY = pageY - offset.top;
      var topLeftDiag = this.calcDiag(pointerX, pointerY);
      var topRightDiag = this.calcDiag(elWidth - pointerX, pointerY);
      var botRightDiag = this.calcDiag(elWidth - pointerX, elHeight - pointerY);
      var botLeftDiag = this.calcDiag(pointerX, elHeight - pointerY);
      var rippleRadius = Math.max(topLeftDiag, topRightDiag, botRightDiag, botLeftDiag);
      var rippleSize = rippleRadius * 2;
      var left = pointerX - rippleRadius;
      var top = pointerY - rippleRadius;

      return {
        directionInvariant: true,
        height: rippleSize,
        width: rippleSize,
        top: top,
        left: left
      };
    }
  }, {
    key: 'calcDiag',
    value: function calcDiag(a, b) {
      return Math.sqrt(a * a + b * b);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          style = _props.style;
      var _state = this.state,
          hasRipples = _state.hasRipples,
          ripples = _state.ripples;
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var rippleGroup = void 0;

      if (hasRipples) {
        var mergedStyles = (0, _simpleAssign2.default)({
          height: '100%',
          width: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          overflow: 'hidden',
          pointerEvents: 'none',
          zIndex: 1 // This is also needed so that ripples do not bleed past a parent border radius.
        }, style);

        rippleGroup = _react2.default.createElement(
          _TransitionGroup2.default,
          { style: prepareStyles(mergedStyles) },
          ripples
        );
      }

      return _react2.default.createElement(
        'div',
        {
          onMouseUp: this.handleMouseUp,
          onMouseDown: this.handleMouseDown,
          onMouseLeave: this.handleMouseLeave,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd
        },
        rippleGroup,
        children
      );
    }
  }]);
  return TouchRipple;
}(_react.Component);

TouchRipple.defaultProps = {
  abortOnScroll: true
};
TouchRipple.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TouchRipple.propTypes =  false ? {
  abortOnScroll: _propTypes2.default.bool,
  centerRipple: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  color: _propTypes2.default.string,
  opacity: _propTypes2.default.number,
  style: _propTypes2.default.object
} : {};
exports.default = TouchRipple;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(254);
__webpack_require__(923);
module.exports = __webpack_require__(30).Array.from;


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(113);
var $export = __webpack_require__(55);
var toObject = __webpack_require__(116);
var call = __webpack_require__(399);
var isArrayIter = __webpack_require__(400);
var toLength = __webpack_require__(248);
var createProperty = __webpack_require__(924);
var getIterFn = __webpack_require__(401);

$export($export.S + $export.F * !__webpack_require__(403)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(71);
var createDesc = __webpack_require__(136);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(398);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
};

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  isDescendant: function isDescendant(parent, child) {
    var node = child.parentNode;

    while (node !== null) {
      if (node === parent) return true;
      node = node.parentNode;
    }

    return false;
  },
  offset: function offset(el) {
    var rect = el.getBoundingClientRect();
    return {
      top: rect.top + document.body.scrollTop,
      left: rect.left + document.body.scrollLeft
    };
  }
};

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(93);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(117);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(67);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(48);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(56);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(57);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(58);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(74);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(10);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(259);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _autoPrefix = __webpack_require__(260);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(141);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CircleRipple = function (_Component) {
  (0, _inherits3.default)(CircleRipple, _Component);

  function CircleRipple() {
    (0, _classCallCheck3.default)(this, CircleRipple);
    return (0, _possibleConstructorReturn3.default)(this, (CircleRipple.__proto__ || (0, _getPrototypeOf2.default)(CircleRipple)).apply(this, arguments));
  }

  (0, _createClass3.default)(CircleRipple, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _shallowEqual2.default)(this.props, nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.enterTimer);
      clearTimeout(this.leaveTimer);
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentDidAppear',
    value: function componentDidAppear() {
      this.animate();
    }
  }, {
    key: 'componentDidEnter',
    value: function componentDidEnter() {
      this.animate();
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;
      style.opacity = 0;
      // If the animation is aborted, remove from the DOM immediately
      var removeAfter = this.props.aborted ? 0 : 2000;
      this.enterTimer = setTimeout(callback, removeAfter);
    }
  }, {
    key: 'animate',
    value: function animate() {
      var style = _reactDom2.default.findDOMNode(this).style;
      var transitionValue = _transitions2.default.easeOut('2s', 'opacity') + ', ' + _transitions2.default.easeOut('1s', 'transform');
      _autoPrefix2.default.set(style, 'transition', transitionValue);
      _autoPrefix2.default.set(style, 'transform', 'scale(1)');
    }
  }, {
    key: 'initializeAnimation',
    value: function initializeAnimation(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;
      style.opacity = this.props.opacity;
      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
      this.leaveTimer = setTimeout(callback, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          aborted = _props.aborted,
          color = _props.color,
          opacity = _props.opacity,
          style = _props.style,
          touchGenerated = _props.touchGenerated,
          other = (0, _objectWithoutProperties3.default)(_props, ['aborted', 'color', 'opacity', 'style', 'touchGenerated']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var mergedStyles = (0, _simpleAssign2.default)({
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        borderRadius: '50%',
        backgroundColor: color
      }, style);

      return _react2.default.createElement('div', (0, _extends3.default)({}, other, { style: prepareStyles(mergedStyles) }));
    }
  }]);
  return CircleRipple;
}(_react.Component);

CircleRipple.defaultProps = {
  opacity: 0.1,
  aborted: false
};
CircleRipple.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CircleRipple.propTypes =  false ? {
  aborted: _propTypes2.default.bool,
  color: _propTypes2.default.string,
  opacity: _propTypes2.default.number,
  style: _propTypes2.default.object,
  touchGenerated: _propTypes2.default.bool
} : {};
exports.default = CircleRipple;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(67);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(48);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(56);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(57);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(58);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(74);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var baseTheme = context.muiTheme.baseTheme;


  return {
    root: {
      position: 'relative',
      paddingLeft: baseTheme.spacing.desktopGutterLess,
      paddingRight: baseTheme.spacing.desktopGutterLess,
      verticalAlign: 'middle'
    }
  };
}

var FlatButtonLabel = function (_Component) {
  (0, _inherits3.default)(FlatButtonLabel, _Component);

  function FlatButtonLabel() {
    (0, _classCallCheck3.default)(this, FlatButtonLabel);
    return (0, _possibleConstructorReturn3.default)(this, (FlatButtonLabel.__proto__ || (0, _getPrototypeOf2.default)(FlatButtonLabel)).apply(this, arguments));
  }

  (0, _createClass3.default)(FlatButtonLabel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          style = _props.style;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'span',
        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
        label
      );
    }
  }]);
  return FlatButtonLabel;
}(_react.Component);

FlatButtonLabel.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
FlatButtonLabel.propTypes =  false ? {
  label: _propTypes2.default.node,
  style: _propTypes2.default.object
} : {};
exports.default = FlatButtonLabel;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(177);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(178);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationFirstPage = function NavigationFirstPage(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z' })
  );
};
NavigationFirstPage = (0, _pure2.default)(NavigationFirstPage);
NavigationFirstPage.displayName = 'NavigationFirstPage';
NavigationFirstPage.muiName = 'SvgIcon';

exports.default = NavigationFirstPage;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _setDisplayName = __webpack_require__(404);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(405);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var ShouldUpdate = function (_Component) {
      _inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        _classCallCheck(this, ShouldUpdate);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

exports.default = shouldUpdate;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

exports.default = setStatic;

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

exports.default = getDisplayName;

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(93);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(117);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(67);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(48);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(56);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(57);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(58);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(74);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(141);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIcon = function (_Component) {
  (0, _inherits3.default)(SvgIcon, _Component);

  function SvgIcon() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SvgIcon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SvgIcon.__proto__ || (0, _getPrototypeOf2.default)(SvgIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false
    }, _this.handleMouseLeave = function (event) {
      _this.setState({ hovered: false });
      _this.props.onMouseLeave(event);
    }, _this.handleMouseEnter = function (event) {
      _this.setState({ hovered: true });
      _this.props.onMouseEnter(event);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SvgIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          color = _props.color,
          hoverColor = _props.hoverColor,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          style = _props.style,
          viewBox = _props.viewBox,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'color', 'hoverColor', 'onMouseEnter', 'onMouseLeave', 'style', 'viewBox']);
      var _context$muiTheme = this.context.muiTheme,
          svgIcon = _context$muiTheme.svgIcon,
          prepareStyles = _context$muiTheme.prepareStyles;


      var offColor = color ? color : 'currentColor';
      var onColor = hoverColor ? hoverColor : offColor;

      var mergedStyles = (0, _simpleAssign2.default)({
        display: 'inline-block',
        color: svgIcon.color,
        fill: this.state.hovered ? onColor : offColor,
        height: 24,
        width: 24,
        userSelect: 'none',
        transition: _transitions2.default.easeOut()
      }, style);

      return _react2.default.createElement(
        'svg',
        (0, _extends3.default)({}, other, {
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          style: prepareStyles(mergedStyles),
          viewBox: viewBox
        }),
        children
      );
    }
  }]);
  return SvgIcon;
}(_react.Component);

SvgIcon.muiName = 'SvgIcon';
SvgIcon.defaultProps = {
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  viewBox: '0 0 24 24'
};
SvgIcon.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
SvgIcon.propTypes =  false ? {
  /**
   * Elements passed into the SVG Icon.
   */
  children: _propTypes2.default.node,
  /**
   * This is the fill color of the svg icon.
   * If not specified, this component will default
   * to muiTheme.palette.textColor.
   */
  color: _propTypes2.default.string,
  /**
   * This is the icon color when the mouse hovers over the icon.
   */
  hoverColor: _propTypes2.default.string,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Allows you to redefine what the coordinates
   * without units mean inside an svg element. For example,
   * if the SVG element is 500 (width) by 200 (height), and you
   * pass viewBox="0 0 50 20", this means that the coordinates inside
   * the svg will go from the top left corner (0,0) to bottom right (50,20)
   * and each unit will be worth 10px.
   */
  viewBox: _propTypes2.default.string
} : {};
exports.default = SvgIcon;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(177);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(178);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationLastPage = function NavigationLastPage(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z' })
  );
};
NavigationLastPage = (0, _pure2.default)(NavigationLastPage);
NavigationLastPage.displayName = 'NavigationLastPage';
NavigationLastPage.muiName = 'SvgIcon';

exports.default = NavigationLastPage;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(177);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(178);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationChevronLeft = function NavigationChevronLeft(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' })
  );
};
NavigationChevronLeft = (0, _pure2.default)(NavigationChevronLeft);
NavigationChevronLeft.displayName = 'NavigationChevronLeft';
NavigationChevronLeft.muiName = 'SvgIcon';

exports.default = NavigationChevronLeft;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(177);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(178);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationChevronRight = function NavigationChevronRight(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' })
  );
};
NavigationChevronRight = (0, _pure2.default)(NavigationChevronRight);
NavigationChevronRight.displayName = 'NavigationChevronRight';
NavigationChevronRight.muiName = 'SvgIcon';

exports.default = NavigationChevronRight;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(397);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = getMuiTheme;

var _lodash = __webpack_require__(938);

var _lodash2 = _interopRequireDefault(_lodash);

var _colorManipulator = __webpack_require__(258);

var _lightBaseTheme = __webpack_require__(939);

var _lightBaseTheme2 = _interopRequireDefault(_lightBaseTheme);

var _zIndex = __webpack_require__(941);

var _zIndex2 = _interopRequireDefault(_zIndex);

var _autoprefixer = __webpack_require__(942);

var _autoprefixer2 = _interopRequireDefault(_autoprefixer);

var _callOnce = __webpack_require__(967);

var _callOnce2 = _interopRequireDefault(_callOnce);

var _rtl = __webpack_require__(968);

var _rtl2 = _interopRequireDefault(_rtl);

var _compose = __webpack_require__(972);

var _compose2 = _interopRequireDefault(_compose);

var _typography = __webpack_require__(973);

var _typography2 = _interopRequireDefault(_typography);

var _colors = __webpack_require__(262);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get the MUI theme corresponding to a base theme.
 * It's possible to override the computed theme values
 * by providing a second argument. The calculated
 * theme will be deeply merged with the second argument.
 */
function getMuiTheme(muiTheme) {
  for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    more[_key - 1] = arguments[_key];
  }

  muiTheme = _lodash2.default.apply(undefined, [{
    zIndex: _zIndex2.default,
    isRtl: false,
    userAgent: undefined
  }, _lightBaseTheme2.default, muiTheme].concat(more));

  var _muiTheme = muiTheme,
      spacing = _muiTheme.spacing,
      fontFamily = _muiTheme.fontFamily,
      palette = _muiTheme.palette;

  var baseTheme = { spacing: spacing, fontFamily: fontFamily, palette: palette };

  muiTheme = (0, _lodash2.default)({
    appBar: {
      color: palette.primary1Color,
      textColor: palette.alternateTextColor,
      height: spacing.desktopKeylineIncrement,
      titleFontWeight: _typography2.default.fontWeightNormal,
      padding: spacing.desktopGutter
    },
    avatar: {
      color: palette.canvasColor,
      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.26)
    },
    badge: {
      color: palette.alternateTextColor,
      textColor: palette.textColor,
      primaryColor: palette.primary1Color,
      primaryTextColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryTextColor: palette.alternateTextColor,
      fontWeight: _typography2.default.fontWeightMedium
    },
    bottomNavigation: {
      backgroundColor: palette.canvasColor,
      unselectedColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      selectedColor: palette.primary1Color,
      height: 56,
      unselectedFontSize: 12,
      selectedFontSize: 14
    },
    button: {
      height: 36,
      minWidth: 88,
      iconButtonSize: spacing.iconSize * 2
    },
    card: {
      titleColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
      subtitleColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      fontWeight: _typography2.default.fontWeightMedium
    },
    cardMedia: {
      color: _colors.darkWhite,
      overlayContentBackground: _colors.lightBlack,
      titleColor: _colors.darkWhite,
      subtitleColor: _colors.lightWhite
    },
    cardText: {
      textColor: palette.textColor
    },
    checkbox: {
      boxColor: palette.textColor,
      checkedColor: palette.primary1Color,
      requiredColor: palette.primary1Color,
      disabledColor: palette.disabledColor,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor
    },
    chip: {
      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12),
      deleteIconColor: (0, _colorManipulator.fade)(palette.textColor, 0.26),
      textColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
      fontSize: 14,
      fontWeight: _typography2.default.fontWeightNormal,
      shadow: '0 1px 6px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12) + ',\n        0 1px 4px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12)
    },
    datePicker: {
      color: palette.primary1Color,
      textColor: palette.alternateTextColor,
      calendarTextColor: palette.textColor,
      selectColor: palette.primary2Color,
      selectTextColor: palette.alternateTextColor,
      calendarYearBackgroundColor: palette.canvasColor,
      headerColor: palette.pickerHeaderColor || palette.primary1Color
    },
    dialog: {
      titleFontSize: 22,
      bodyFontSize: 16,
      bodyColor: (0, _colorManipulator.fade)(palette.textColor, 0.6)
    },
    dropDownMenu: {
      accentColor: palette.borderColor
    },
    enhancedButton: {
      tapHighlightColor: _colors.transparent
    },
    flatButton: {
      color: _colors.transparent,
      buttonFilterColor: '#999999',
      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
      textColor: palette.textColor,
      primaryTextColor: palette.primary1Color,
      secondaryTextColor: palette.accent1Color,
      fontSize: _typography2.default.fontStyleButtonFontSize,
      fontWeight: _typography2.default.fontWeightMedium
    },
    floatingActionButton: {
      buttonSize: 56,
      miniSize: 40,
      color: palette.primary1Color,
      iconColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryIconColor: palette.alternateTextColor,
      disabledTextColor: palette.disabledColor,
      disabledColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12)
    },
    gridTile: {
      textColor: _colors.white
    },
    icon: {
      color: palette.canvasColor,
      backgroundColor: palette.primary1Color
    },
    inkBar: {
      backgroundColor: palette.accent1Color
    },
    drawer: {
      width: spacing.desktopKeylineIncrement * 4,
      color: palette.canvasColor
    },
    listItem: {
      nestedLevelDepth: 18,
      secondaryTextColor: palette.secondaryTextColor,
      leftIconColor: _colors.grey600,
      rightIconColor: _colors.grey600
    },
    menu: {
      backgroundColor: palette.canvasColor,
      containerBackgroundColor: palette.canvasColor
    },
    menuItem: {
      dataHeight: 32,
      height: 48,
      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1),
      padding: spacing.desktopGutter,
      selectedTextColor: palette.accent1Color,
      rightIconDesktopFill: _colors.grey600
    },
    menuSubheader: {
      padding: spacing.desktopGutter,
      borderColor: palette.borderColor,
      textColor: palette.primary1Color
    },
    overlay: {
      backgroundColor: _colors.lightBlack
    },
    paper: {
      color: palette.textColor,
      backgroundColor: palette.canvasColor,
      zDepthShadows: [[1, 6, 0.12, 1, 4, 0.12], [3, 10, 0.16, 3, 10, 0.23], [10, 30, 0.19, 6, 10, 0.23], [14, 45, 0.25, 10, 18, 0.22], [19, 60, 0.30, 15, 20, 0.22]].map(function (d) {
        return '0 ' + d[0] + 'px ' + d[1] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[2]) + ',\n         0 ' + d[3] + 'px ' + d[4] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[5]);
      })
    },
    radioButton: {
      borderColor: palette.textColor,
      backgroundColor: palette.alternateTextColor,
      checkedColor: palette.primary1Color,
      requiredColor: palette.primary1Color,
      disabledColor: palette.disabledColor,
      size: 24,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor
    },
    raisedButton: {
      color: palette.alternateTextColor,
      textColor: palette.textColor,
      primaryColor: palette.primary1Color,
      primaryTextColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryTextColor: palette.alternateTextColor,
      disabledColor: (0, _colorManipulator.darken)(palette.alternateTextColor, 0.1),
      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
      fontSize: _typography2.default.fontStyleButtonFontSize,
      fontWeight: _typography2.default.fontWeightMedium
    },
    refreshIndicator: {
      strokeColor: palette.borderColor,
      loadingStrokeColor: palette.primary1Color
    },
    ripple: {
      color: (0, _colorManipulator.fade)(palette.textColor, 0.87)
    },
    slider: {
      trackSize: 2,
      trackColor: palette.primary3Color,
      trackColorSelected: palette.accent3Color,
      handleSize: 12,
      handleSizeDisabled: 8,
      handleSizeActive: 18,
      handleColorZero: palette.primary3Color,
      handleFillColor: palette.alternateTextColor,
      selectionColor: palette.primary1Color,
      rippleColor: palette.primary1Color
    },
    snackbar: {
      textColor: palette.alternateTextColor,
      backgroundColor: palette.textColor,
      actionColor: palette.accent1Color
    },
    subheader: {
      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      fontWeight: _typography2.default.fontWeightMedium
    },
    stepper: {
      backgroundColor: 'transparent',
      hoverBackgroundColor: (0, _colorManipulator.fade)(_colors.black, 0.06),
      iconColor: palette.primary1Color,
      hoveredIconColor: _colors.grey700,
      inactiveIconColor: _colors.grey500,
      textColor: (0, _colorManipulator.fade)(_colors.black, 0.87),
      disabledTextColor: (0, _colorManipulator.fade)(_colors.black, 0.26),
      connectorLineColor: _colors.grey400
    },
    svgIcon: {
      color: palette.textColor
    },
    table: {
      backgroundColor: palette.canvasColor
    },
    tableFooter: {
      borderColor: palette.borderColor,
      textColor: palette.accent3Color
    },
    tableHeader: {
      borderColor: palette.borderColor
    },
    tableHeaderColumn: {
      textColor: palette.accent3Color,
      height: 56,
      spacing: 24
    },
    tableRow: {
      hoverColor: palette.accent2Color,
      stripeColor: (0, _colorManipulator.fade)((0, _colorManipulator.lighten)(palette.primary1Color, 0.5), 0.4),
      selectedColor: palette.borderColor,
      textColor: palette.textColor,
      borderColor: palette.borderColor,
      height: 48
    },
    tableRowColumn: {
      height: 48,
      spacing: 24
    },
    tabs: {
      backgroundColor: palette.primary1Color,
      textColor: (0, _colorManipulator.fade)(palette.alternateTextColor, 0.7),
      selectedTextColor: palette.alternateTextColor
    },
    textField: {
      textColor: palette.textColor,
      hintColor: palette.disabledColor,
      floatingLabelColor: palette.disabledColor,
      disabledTextColor: palette.disabledColor,
      errorColor: _colors.red500,
      focusColor: palette.primary1Color,
      backgroundColor: 'transparent',
      borderColor: palette.borderColor
    },
    timePicker: {
      color: palette.alternateTextColor,
      textColor: palette.alternateTextColor,
      accentColor: palette.primary1Color,
      clockColor: palette.textColor,
      clockCircleColor: palette.clockCircleColor,
      headerColor: palette.pickerHeaderColor || palette.primary1Color,
      selectColor: palette.primary2Color,
      selectTextColor: palette.alternateTextColor
    },
    toggle: {
      thumbOnColor: palette.primary1Color,
      thumbOffColor: palette.accent2Color,
      thumbDisabledColor: palette.borderColor,
      thumbRequiredColor: palette.primary1Color,
      trackOnColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5),
      trackOffColor: palette.primary3Color,
      trackDisabledColor: palette.primary3Color,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor,
      trackRequiredColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5)
    },
    toolbar: {
      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
      backgroundColor: (0, _colorManipulator.darken)(palette.accent2Color, 0.05),
      height: 56,
      titleFontSize: 20,
      iconColor: (0, _colorManipulator.fade)(palette.textColor, 0.4),
      separatorColor: (0, _colorManipulator.fade)(palette.textColor, 0.175),
      menuHoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1)
    },
    tooltip: {
      color: _colors.white,
      rippleBackgroundColor: _colors.grey700,
      opacity: 0.9
    }
  }, muiTheme, {
    baseTheme: baseTheme, // To provide backward compatibility.
    rawTheme: baseTheme // To provide backward compatibility.
  });

  var transformers = [_autoprefixer2.default, _rtl2.default, _callOnce2.default].map(function (t) {
    return t(muiTheme);
  }).filter(function (t) {
    return t;
  });

  muiTheme.prepareStyles = _compose2.default.apply(undefined, (0, _toConsumableArray3.default)(transformers));

  return muiTheme;
}

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  return key == '__proto__'
    ? undefined
    : object[key];
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeMax = Math.max,
    nativeNow = Date.now;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = merge;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28), __webpack_require__(243)(module)))

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = __webpack_require__(262);

var _colorManipulator = __webpack_require__(258);

var _spacing = __webpack_require__(940);

var _spacing2 = _interopRequireDefault(_spacing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Light Theme is the default theme used in material-ui. It is guaranteed to
 *  have all theme variables needed for every component. Variables not defined
 *  in a custom theme will default to these values.
 */
exports.default = {
  spacing: _spacing2.default,
  fontFamily: 'Roboto, sans-serif',
  borderRadius: 2,
  palette: {
    primary1Color: _colors.cyan500,
    primary2Color: _colors.cyan700,
    primary3Color: _colors.grey400,
    accent1Color: _colors.pinkA200,
    accent2Color: _colors.grey100,
    accent3Color: _colors.grey500,
    textColor: _colors.darkBlack,
    secondaryTextColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.54),
    alternateTextColor: _colors.white,
    canvasColor: _colors.white,
    borderColor: _colors.grey300,
    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
    pickerHeaderColor: _colors.cyan500,
    clockCircleColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.07),
    shadowColor: _colors.fullBlack
  }
}; /**
    * NB: If you update this file, please also update `docs/src/app/customization/Themes.js`
    */

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  iconSize: 24,

  desktopGutter: 24,
  desktopGutterMore: 32,
  desktopGutterLess: 16,
  desktopGutterMini: 8,
  desktopKeylineIncrement: 64,
  desktopDropDownMenuItemHeight: 32,
  desktopDropDownMenuFontSize: 15,
  desktopDrawerMenuItemHeight: 48,
  desktopSubheaderHeight: 48,
  desktopToolbarHeight: 56
};

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  menu: 1000,
  appBar: 1100,
  drawerOverlay: 1200,
  drawer: 1300,
  dialogOverlay: 1400,
  dialog: 1500,
  layer: 2000,
  popover: 2100,
  snackbar: 2900,
  tooltip: 3000
};

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (muiTheme) {
  var isClient = typeof navigator !== 'undefined';
  var userAgent = muiTheme.userAgent;

  if (userAgent === undefined && isClient) {
    userAgent = navigator.userAgent;
  }

  if (userAgent === undefined && !hasWarnedAboutUserAgent) {
     false ? (0, _warning2.default)(false, 'Material-UI: userAgent should be supplied in the muiTheme context\n      for server-side rendering.') : void 0;

    hasWarnedAboutUserAgent = true;
  }

  var prefixAll = (0, _createPrefixer2.default)(_autoprefixerStatic2.default);

  if (userAgent === false) {
    // Disabled autoprefixer
    return null;
  } else if (userAgent === 'all' || userAgent === undefined) {
    // Prefix for all user agent
    return function (style) {
      var isFlex = ['flex', 'inline-flex'].indexOf(style.display) !== -1;
      var stylePrefixed = prefixAll(style);

      if (isFlex) {
        var display = stylePrefixed.display;
        if (isClient) {
          // We can't apply this join with react-dom:
          // #https://github.com/facebook/react/issues/6467
          stylePrefixed.display = display[display.length - 1];
        } else {
          stylePrefixed.display = display.join('; display: ');
        }
      }

      return stylePrefixed;
    };
  } else {
    var Prefixer = (0, _createPrefixer4.default)(_autoprefixerDynamic2.default, prefixAll);
    var prefixer = new Prefixer({
      userAgent: userAgent
    });

    return function (style) {
      return prefixer.prefix(style);
    };
  }
};

var _createPrefixer = __webpack_require__(943);

var _createPrefixer2 = _interopRequireDefault(_createPrefixer);

var _createPrefixer3 = __webpack_require__(945);

var _createPrefixer4 = _interopRequireDefault(_createPrefixer3);

var _autoprefixerDynamic = __webpack_require__(950);

var _autoprefixerDynamic2 = _interopRequireDefault(_autoprefixerDynamic);

var _autoprefixerStatic = __webpack_require__(959);

var _autoprefixerStatic2 = _interopRequireDefault(_autoprefixerStatic);

var _warning = __webpack_require__(176);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasWarnedAboutUserAgent = false;

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPrefixer;

var _prefixProperty = __webpack_require__(944);

var _prefixProperty2 = _interopRequireDefault(_prefixProperty);

var _prefixValue = __webpack_require__(406);

var _prefixValue2 = _interopRequireDefault(_prefixValue);

var _addNewValuesOnly = __webpack_require__(407);

var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);

var _isObject = __webpack_require__(408);

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;

  function prefixAll(style) {
    for (var property in style) {
      var value = style[property];

      // handle nested objects
      if ((0, _isObject2.default)(value)) {
        style[property] = prefixAll(value);
        // handle array values
      } else if (Array.isArray(value)) {
        var combinedValue = [];

        for (var i = 0, len = value.length; i < len; ++i) {
          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
        }

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (combinedValue.length > 0) {
          style[property] = combinedValue;
        }
      } else {
        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (_processedValue) {
          style[property] = _processedValue;
        }

        (0, _prefixProperty2.default)(prefixMap, property, style);
      }
    }

    return style;
  }

  return prefixAll;
}
module.exports = exports['default'];

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixProperty;

var _capitalizeString = __webpack_require__(263);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prefixProperty(prefixProperties, property, style) {
  if (prefixProperties.hasOwnProperty(property)) {
    var requiredPrefixes = prefixProperties[property];
    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createPrefixer;

var _getBrowserInformation = __webpack_require__(946);

var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);

var _getPrefixedKeyframes = __webpack_require__(949);

var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);

var _capitalizeString = __webpack_require__(263);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

var _addNewValuesOnly = __webpack_require__(407);

var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);

var _isObject = __webpack_require__(408);

var _isObject2 = _interopRequireDefault(_isObject);

var _prefixValue = __webpack_require__(406);

var _prefixValue2 = _interopRequireDefault(_prefixValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (style) {
    return style;
  };

  return function () {
    /**
    * Instantiante a new prefixer
    * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
    * @param {string} keepUnprefixed - keeps unprefixed properties and values
    */
    function Prefixer() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, Prefixer);

      var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;

      this._userAgent = options.userAgent || defaultUserAgent;
      this._keepUnprefixed = options.keepUnprefixed || false;

      if (this._userAgent) {
        this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);
      }

      // Checks if the userAgent was resolved correctly
      if (this._browserInfo && this._browserInfo.cssPrefix) {
        this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo.browserName, this._browserInfo.browserVersion, this._browserInfo.cssPrefix);
      } else {
        this._useFallback = true;
        return false;
      }

      var prefixData = this._browserInfo.browserName && prefixMap[this._browserInfo.browserName];
      if (prefixData) {
        this._requiresPrefix = {};

        for (var property in prefixData) {
          if (prefixData[property] >= this._browserInfo.browserVersion) {
            this._requiresPrefix[property] = true;
          }
        }

        this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
      } else {
        this._useFallback = true;
      }

      this._metaData = {
        browserVersion: this._browserInfo.browserVersion,
        browserName: this._browserInfo.browserName,
        cssPrefix: this._browserInfo.cssPrefix,
        jsPrefix: this._browserInfo.jsPrefix,
        keepUnprefixed: this._keepUnprefixed,
        requiresPrefix: this._requiresPrefix
      };
    }

    _createClass(Prefixer, [{
      key: 'prefix',
      value: function prefix(style) {
        // use static prefixer as fallback if userAgent can not be resolved
        if (this._useFallback) {
          return fallback(style);
        }

        // only add prefixes if needed
        if (!this._hasPropsRequiringPrefix) {
          return style;
        }

        return this._prefixStyle(style);
      }
    }, {
      key: '_prefixStyle',
      value: function _prefixStyle(style) {
        for (var property in style) {
          var value = style[property];

          // handle nested objects
          if ((0, _isObject2.default)(value)) {
            style[property] = this.prefix(value);
            // handle array values
          } else if (Array.isArray(value)) {
            var combinedValue = [];

            for (var i = 0, len = value.length; i < len; ++i) {
              var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, this._metaData);
              (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
            }

            // only modify the value if it was touched
            // by any plugin to prevent unnecessary mutations
            if (combinedValue.length > 0) {
              style[property] = combinedValue;
            }
          } else {
            var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, this._metaData);

            // only modify the value if it was touched
            // by any plugin to prevent unnecessary mutations
            if (_processedValue) {
              style[property] = _processedValue;
            }

            // add prefixes to properties
            if (this._requiresPrefix.hasOwnProperty(property)) {
              style[this._browserInfo.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
              if (!this._keepUnprefixed) {
                delete style[property];
              }
            }
          }
        }

        return style;
      }

      /**
      * Returns a prefixed version of the style object using all vendor prefixes
      * @param {Object} styles - Style object that gets prefixed properties added
      * @returns {Object} - Style object with prefixed properties and values
      */

    }], [{
      key: 'prefixAll',
      value: function prefixAll(styles) {
        return fallback(styles);
      }
    }]);

    return Prefixer;
  }();
}
module.exports = exports['default'];

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getBrowserInformation;

var _bowser = __webpack_require__(947);

var _bowser2 = _interopRequireDefault(_bowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixByBrowser = {
  chrome: 'Webkit',
  safari: 'Webkit',
  ios: 'Webkit',
  android: 'Webkit',
  phantom: 'Webkit',
  opera: 'Webkit',
  webos: 'Webkit',
  blackberry: 'Webkit',
  bada: 'Webkit',
  tizen: 'Webkit',
  chromium: 'Webkit',
  vivaldi: 'Webkit',
  firefox: 'Moz',
  seamoney: 'Moz',
  sailfish: 'Moz',
  msie: 'ms',
  msedge: 'ms'
};


var browserByCanIuseAlias = {
  chrome: 'chrome',
  chromium: 'chrome',
  safari: 'safari',
  firfox: 'firefox',
  msedge: 'edge',
  opera: 'opera',
  vivaldi: 'opera',
  msie: 'ie'
};

function getBrowserName(browserInfo) {
  if (browserInfo.firefox) {
    return 'firefox';
  }

  if (browserInfo.mobile || browserInfo.tablet) {
    if (browserInfo.ios) {
      return 'ios_saf';
    } else if (browserInfo.android) {
      return 'android';
    } else if (browserInfo.opera) {
      return 'op_mini';
    }
  }

  for (var browser in browserByCanIuseAlias) {
    if (browserInfo.hasOwnProperty(browser)) {
      return browserByCanIuseAlias[browser];
    }
  }
}

/**
 * Uses bowser to get default browser browserInformation such as version and name
 * Evaluates bowser browserInfo and adds vendorPrefix browserInformation
 * @param {string} userAgent - userAgent that gets evaluated
 */
function getBrowserInformation(userAgent) {
  var browserInfo = _bowser2.default._detect(userAgent);

  if (browserInfo.yandexbrowser) {
    browserInfo = _bowser2.default._detect(userAgent.replace(/YaBrowser\/[0-9.]*/, ''));
  }

  for (var browser in prefixByBrowser) {
    if (browserInfo.hasOwnProperty(browser)) {
      var prefix = prefixByBrowser[browser];

      browserInfo.jsPrefix = prefix;
      browserInfo.cssPrefix = '-' + prefix.toLowerCase() + '-';
      break;
    }
  }

  browserInfo.browserName = getBrowserName(browserInfo);

  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
  if (browserInfo.version) {
    browserInfo.browserVersion = parseFloat(browserInfo.version);
  } else {
    browserInfo.browserVersion = parseInt(parseFloat(browserInfo.osversion), 10);
  }

  browserInfo.osVersion = parseFloat(browserInfo.osversion);

  // iOS forces all browsers to use Safari under the hood
  // as the Safari version seems to match the iOS version
  // we just explicitely use the osversion instead
  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
  if (browserInfo.browserName === 'ios_saf' && browserInfo.browserVersion > browserInfo.osVersion) {
    browserInfo.browserVersion = browserInfo.osVersion;
  }

  // seperate native android chrome
  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
  if (browserInfo.browserName === 'android' && browserInfo.chrome && browserInfo.browserVersion > 37) {
    browserInfo.browserName = 'and_chr';
  }

  // For android < 4.4 we want to check the osversion
  // not the chrome version, see issue #26
  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
  if (browserInfo.browserName === 'android' && browserInfo.osVersion < 5) {
    browserInfo.browserVersion = browserInfo.osVersion;
  }

  // Samsung browser are basically build on Chrome > 44
  // https://github.com/rofrischmann/inline-style-prefixer/issues/102
  if (browserInfo.browserName === 'android' && browserInfo.samsungBrowser) {
    browserInfo.browserName = 'and_chr';
    browserInfo.browserVersion = 44;
  }

  return browserInfo;
}
module.exports = exports['default'];

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */

!function (root, name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) __webpack_require__(948)(name, definition)
  else root[name] = definition()
}(this, 'bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[1]) || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[2]) || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
      , likeAndroid = /like android/i.test(ua)
      , android = !likeAndroid && /android/i.test(ua)
      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
      , chromeos = /CrOS/.test(ua)
      , silk = /silk/i.test(ua)
      , sailfish = /sailfish/i.test(ua)
      , tizen = /tizen/i.test(ua)
      , webos = /(web|hpw)(o|0)s/i.test(ua)
      , windowsphone = /windows phone/i.test(ua)
      , samsungBrowser = /SamsungBrowser/i.test(ua)
      , windows = !windowsphone && /windows/i.test(ua)
      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
      , mobile = !tablet && /[^-]mobi/i.test(ua)
      , xbox = /xbox/i.test(ua)
      , result

    if (/opera/i.test(ua)) {
      //  an old Opera
      result = {
        name: 'Opera'
      , opera: t
      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
      }
    } else if (/opr\/|opios/i.test(ua)) {
      // a new Opera
      result = {
        name: 'Opera'
        , opera: t
        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/SamsungBrowser/i.test(ua)) {
      result = {
        name: 'Samsung Internet for Android'
        , samsungBrowser: t
        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/Whale/i.test(ua)) {
      result = {
        name: 'NAVER Whale browser'
        , whale: t
        , version: getFirstMatch(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/MZBrowser/i.test(ua)) {
      result = {
        name: 'MZ Browser'
        , mzbrowser: t
        , version: getFirstMatch(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/coast/i.test(ua)) {
      result = {
        name: 'Opera Coast'
        , coast: t
        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/focus/i.test(ua)) {
      result = {
        name: 'Focus'
        , focus: t
        , version: getFirstMatch(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/yabrowser/i.test(ua)) {
      result = {
        name: 'Yandex Browser'
      , yandexbrowser: t
      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/ucbrowser/i.test(ua)) {
      result = {
          name: 'UC Browser'
        , ucbrowser: t
        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/mxios/i.test(ua)) {
      result = {
        name: 'Maxthon'
        , maxthon: t
        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/epiphany/i.test(ua)) {
      result = {
        name: 'Epiphany'
        , epiphany: t
        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/puffin/i.test(ua)) {
      result = {
        name: 'Puffin'
        , puffin: t
        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
      }
    }
    else if (/sleipnir/i.test(ua)) {
      result = {
        name: 'Sleipnir'
        , sleipnir: t
        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/k-meleon/i.test(ua)) {
      result = {
        name: 'K-Meleon'
        , kMeleon: t
        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (windowsphone) {
      result = {
        name: 'Windows Phone'
      , osname: 'Windows Phone'
      , windowsphone: t
      }
      if (edgeVersion) {
        result.msedge = t
        result.version = edgeVersion
      }
      else {
        result.msie = t
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer'
      , msie: t
      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      }
    } else if (chromeos) {
      result = {
        name: 'Chrome'
      , osname: 'Chrome OS'
      , chromeos: t
      , chromeBook: t
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    } else if (/edg([ea]|ios)/i.test(ua)) {
      result = {
        name: 'Microsoft Edge'
      , msedge: t
      , version: edgeVersion
      }
    }
    else if (/vivaldi/i.test(ua)) {
      result = {
        name: 'Vivaldi'
        , vivaldi: t
        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (sailfish) {
      result = {
        name: 'Sailfish'
      , osname: 'Sailfish OS'
      , sailfish: t
      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey'
      , seamonkey: t
      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/firefox|iceweasel|fxios/i.test(ua)) {
      result = {
        name: 'Firefox'
      , firefox: t
      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
      }
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t
        result.osname = 'Firefox OS'
      }
    }
    else if (silk) {
      result =  {
        name: 'Amazon Silk'
      , silk: t
      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS'
      , phantom: t
      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/slimerjs/i.test(ua)) {
      result = {
        name: 'SlimerJS'
        , slimer: t
        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry'
      , osname: 'BlackBerry OS'
      , blackberry: t
      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      }
    }
    else if (webos) {
      result = {
        name: 'WebOS'
      , osname: 'WebOS'
      , webos: t
      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t)
    }
    else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada'
      , osname: 'Bada'
      , bada: t
      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    }
    else if (tizen) {
      result = {
        name: 'Tizen'
      , osname: 'Tizen'
      , tizen: t
      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    }
    else if (/qupzilla/i.test(ua)) {
      result = {
        name: 'QupZilla'
        , qupzilla: t
        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
      }
    }
    else if (/chromium/i.test(ua)) {
      result = {
        name: 'Chromium'
        , chromium: t
        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome'
        , chrome: t
        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    }
    else if (android) {
      result = {
        name: 'Android'
        , version: versionIdentifier
      }
    }
    else if (/safari|applewebkit/i.test(ua)) {
      result = {
        name: 'Safari'
      , safari: t
      }
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if (iosdevice) {
      result = {
        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }
      // WTF: version is not part of user agent in web apps
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if(/googlebot/i.test(ua)) {
      result = {
        name: 'Googlebot'
      , googlebot: t
      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
      }
    }
    else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
     };
   }

    // set webkit or gecko flag for browsers based on these engines
    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      if (/(apple)?webkit\/537\.36/i.test(ua)) {
        result.name = result.name || "Blink"
        result.blink = t
      } else {
        result.name = result.name || "Webkit"
        result.webkit = t
      }
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko"
      result.gecko = t
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
    }

    // set OS flags for platforms that have multiple browsers
    if (!result.windowsphone && (android || result.silk)) {
      result.android = t
      result.osname = 'Android'
    } else if (!result.windowsphone && iosdevice) {
      result[iosdevice] = t
      result.ios = t
      result.osname = 'iOS'
    } else if (mac) {
      result.mac = t
      result.osname = 'macOS'
    } else if (xbox) {
      result.xbox = t
      result.osname = 'Xbox'
    } else if (windows) {
      result.windows = t
      result.osname = 'Windows'
    } else if (linux) {
      result.linux = t
      result.osname = 'Linux'
    }

    function getWindowsVersion (s) {
      switch (s) {
        case 'NT': return 'NT'
        case 'XP': return 'XP'
        case 'NT 5.0': return '2000'
        case 'NT 5.1': return 'XP'
        case 'NT 5.2': return '2003'
        case 'NT 6.0': return 'Vista'
        case 'NT 6.1': return '7'
        case 'NT 6.2': return '8'
        case 'NT 6.3': return '8.1'
        case 'NT 10.0': return '10'
        default: return undefined
      }
    }

    // OS version extraction
    var osVersion = '';
    if (result.windows) {
      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
    } else if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (result.mac) {
      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = !result.windows && osVersion.split('.')[0];
    if (
         tablet
      || nexusTablet
      || iosdevice == 'ipad'
      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
      || result.silk
    ) {
      result.tablet = t
    } else if (
         mobile
      || iosdevice == 'iphone'
      || iosdevice == 'ipod'
      || android
      || nexusMobile
      || result.blackberry
      || result.webos
      || result.bada
    ) {
      result.mobile = t
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if (result.msedge ||
        (result.msie && result.version >= 10) ||
        (result.yandexbrowser && result.version >= 15) ||
		    (result.vivaldi && result.version >= 1.0) ||
        (result.chrome && result.version >= 20) ||
        (result.samsungBrowser && result.version >= 4) ||
        (result.whale && compareVersions([result.version, '1.0']) === 1) ||
        (result.mzbrowser && compareVersions([result.version, '6.0']) === 1) ||
        (result.focus && compareVersions([result.version, '1.0']) === 1) ||
        (result.firefox && result.version >= 20.0) ||
        (result.safari && result.version >= 6) ||
        (result.opera && result.version >= 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
        (result.blackberry && result.version >= 10.1)
        || (result.chromium && result.version >= 20)
        ) {
      result.a = t;
    }
    else if ((result.msie && result.version < 10) ||
        (result.chrome && result.version < 20) ||
        (result.firefox && result.version < 20.0) ||
        (result.safari && result.version < 6) ||
        (result.opera && result.version < 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
        || (result.chromium && result.version < 20)
        ) {
      result.c = t
    } else result.x = t

    return result
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];
      if (typeof browserItem=== 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  function getVersionPrecision(version) {
    return version.split(".").length;
  }

  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  function map(arr, iterator) {
    var result = [], i;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i = 0; i < arr.length; i++) {
      result.push(iterator(arr[i]));
    }
    return result;
  }

  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
   *
   * @param  {Array<String>} versions versions to compare
   * @return {Number} comparison result
   */
  function compareVersions(versions) {
    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
    var chunks = map(versions, function (version) {
      var delta = precision - getVersionPrecision(version);

      // 2) "9" -> "9.0" (for precision = 2)
      version = version + new Array(delta + 1).join(".0");

      // 3) "9.0" -> ["000000000"", "000000009"]
      return map(version.split("."), function (chunk) {
        return new Array(20 - chunk.length).join("0") + chunk;
      }).reverse();
    });

    // iterate in reverse order by reversed chunks array
    while (--precision >= 0) {
      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }
      else if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === 0) {
          // all version chunks are same
          return 0;
        }
      }
      else {
        return -1;
      }
    }
  }

  /**
   * Check if browser is unsupported
   *
   * @example
   *   bowser.isUnsupportedBrowser({
   *     msie: "10",
   *     firefox: "23",
   *     chrome: "29",
   *     safari: "5.1",
   *     opera: "16",
   *     phantom: "534"
   *   });
   *
   * @param  {Object}  minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function isUnsupportedBrowser(minVersions, strictMode, ua) {
    var _bowser = bowser;

    // make strictMode param optional with ua param usage
    if (typeof strictMode === 'string') {
      ua = strictMode;
      strictMode = void(0);
    }

    if (strictMode === void(0)) {
      strictMode = false;
    }
    if (ua) {
      _bowser = detect(ua);
    }

    var version = "" + _bowser.version;
    for (var browser in minVersions) {
      if (minVersions.hasOwnProperty(browser)) {
        if (_bowser[browser]) {
          if (typeof minVersions[browser] !== 'string') {
            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
          }

          // browser version and min supported version.
          return compareVersions([version, minVersions[browser]]) < 0;
        }
      }
    }

    return strictMode; // not found
  }

  /**
   * Check if browser is supported
   *
   * @param  {Object} minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function check(minVersions, strictMode, ua) {
    return !isUnsupportedBrowser(minVersions, strictMode, ua);
  }

  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
  bowser.compareVersions = compareVersions;
  bowser.check = check;

  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  /*
   * Set our detect public method to the main bowser object
   * This is needed to implement bowser in server side
   */
  bowser.detect = detect;
  return bowser
});


/***/ }),
/* 948 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPrefixedKeyframes;
function getPrefixedKeyframes(browserName, browserVersion, cssPrefix) {
  var prefixedKeyframes = 'keyframes';

  if (browserName === 'chrome' && browserVersion < 43 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 || browserName === 'opera' && browserVersion < 30 || browserName === 'android' && browserVersion <= 4.4 || browserName === 'and_uc') {
    return cssPrefix + prefixedKeyframes;
  }
  return prefixedKeyframes;
}
module.exports = exports['default'];

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _calc = __webpack_require__(951);

var _calc2 = _interopRequireDefault(_calc);

var _flex = __webpack_require__(952);

var _flex2 = _interopRequireDefault(_flex);

var _flexboxIE = __webpack_require__(953);

var _flexboxIE2 = _interopRequireDefault(_flexboxIE);

var _flexboxOld = __webpack_require__(954);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

var _gradient = __webpack_require__(955);

var _gradient2 = _interopRequireDefault(_gradient);

var _sizing = __webpack_require__(956);

var _sizing2 = _interopRequireDefault(_sizing);

var _transition = __webpack_require__(957);

var _transition2 = _interopRequireDefault(_transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
  prefixMap: { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 60, "userSelect": 53, "fontKerning": 32, "textEmphasisPosition": 60, "textEmphasis": 60, "textEmphasisStyle": 60, "textEmphasisColor": 60, "boxDecorationBreak": 60, "clipPath": 54, "maskImage": 60, "maskMode": 60, "maskRepeat": 60, "maskPosition": 60, "maskClip": 60, "maskOrigin": 60, "maskSize": 60, "maskComposite": 60, "mask": 60, "maskBorderSource": 60, "maskBorderMode": 60, "maskBorderSlice": 60, "maskBorderWidth": 60, "maskBorderOutset": 60, "maskBorderRepeat": 60, "maskBorder": 60, "maskType": 60, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10.1, "userSelect": 10.1, "backdropFilter": 10.1, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10.1, "clipPath": 10.1, "maskImage": 10.1, "maskMode": 10.1, "maskRepeat": 10.1, "maskPosition": 10.1, "maskClip": 10.1, "maskOrigin": 10.1, "maskSize": 10.1, "maskComposite": 10.1, "mask": 10.1, "maskBorderSource": 10.1, "maskBorderMode": 10.1, "maskBorderSlice": 10.1, "maskBorderWidth": 10.1, "maskBorderOutset": 10.1, "maskBorderRepeat": 10.1, "maskBorder": 10.1, "maskType": 10.1, "textDecorationStyle": 10.1, "textDecorationSkip": 10.1, "textDecorationLine": 10.1, "textDecorationColor": 10.1, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10.1, "flowInto": 10.1, "flowFrom": 10.1, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10.1, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 55, "userSelect": 55, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 55, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 45, "userSelect": 40, "fontKerning": 19, "textEmphasisPosition": 45, "textEmphasis": 45, "textEmphasisStyle": 45, "textEmphasisColor": 45, "boxDecorationBreak": 45, "clipPath": 41, "maskImage": 45, "maskMode": 45, "maskRepeat": 45, "maskPosition": 45, "maskClip": 45, "maskOrigin": 45, "maskSize": 45, "maskComposite": 45, "mask": 45, "maskBorderSource": 45, "maskBorderMode": 45, "maskBorderSlice": 45, "maskBorderWidth": 45, "maskBorderOutset": 45, "maskBorderRepeat": 45, "maskBorder": 45, "maskType": 45, "textDecorationStyle": 43, "textDecorationSkip": 43, "textDecorationLine": 43, "textDecorationColor": 43, "filter": 39, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 15, "wrapFlow": 15, "wrapThrough": 15, "wrapMargin": 15, "scrollSnapType": 15, "scrollSnapPointsX": 15, "scrollSnapPointsY": 15, "scrollSnapDestination": 15, "scrollSnapCoordinate": 15, "hyphens": 15, "flowInto": 15, "flowFrom": 15, "breakBefore": 15, "breakAfter": 15, "breakInside": 15, "regionFragment": 15, "gridTemplateColumns": 15, "gridTemplateRows": 15, "gridTemplateAreas": 15, "gridTemplate": 15, "gridAutoColumns": 15, "gridAutoRows": 15, "gridAutoFlow": 15, "grid": 15, "gridRowStart": 15, "gridColumnStart": 15, "gridRowEnd": 15, "gridRow": 15, "gridColumn": 15, "gridColumnEnd": 15, "gridColumnGap": 15, "gridRowGap": 15, "gridArea": 15, "gridGap": 15 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 10, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textSizeAdjust": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 10, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "borderImage": 4.2, "borderImageOutset": 4.2, "borderImageRepeat": 4.2, "borderImageSlice": 4.2, "borderImageSource": 4.2, "borderImageWidth": 4.2, "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 53, "userSelect": 53, "fontKerning": 4.4, "textEmphasisPosition": 53, "textEmphasis": 53, "textEmphasisStyle": 53, "textEmphasisColor": 53, "boxDecorationBreak": 53, "clipPath": 53, "maskImage": 53, "maskMode": 53, "maskRepeat": 53, "maskPosition": 53, "maskClip": 53, "maskOrigin": 53, "maskSize": 53, "maskComposite": 53, "mask": 53, "maskBorderSource": 53, "maskBorderMode": 53, "maskBorderSlice": 53, "maskBorderWidth": 53, "maskBorderOutset": 53, "maskBorderRepeat": 53, "maskBorder": 53, "maskType": 53, "filter": 4.4, "fontFeatureSettings": 4.4, "breakAfter": 53, "breakBefore": 53, "breakInside": 53, "columnCount": 53, "columnFill": 53, "columnGap": 53, "columnRule": 53, "columnRuleColor": 53, "columnRuleStyle": 53, "columnRuleWidth": 53, "columns": 53, "columnSpan": 53, "columnWidth": 53 }, "and_chr": { "appearance": 56, "textEmphasisPosition": 56, "textEmphasis": 56, "textEmphasisStyle": 56, "textEmphasisColor": 56, "boxDecorationBreak": 56, "maskImage": 56, "maskMode": 56, "maskRepeat": 56, "maskPosition": 56, "maskClip": 56, "maskOrigin": 56, "maskSize": 56, "maskComposite": 56, "mask": 56, "maskBorderSource": 56, "maskBorderMode": 56, "maskBorderSlice": 56, "maskBorderWidth": 56, "maskBorderOutset": 56, "maskBorderRepeat": 56, "maskBorder": 56, "maskType": 56, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56 }, "and_uc": { "flex": 11, "flexBasis": 11, "flexDirection": 11, "flexGrow": 11, "flexFlow": 11, "flexShrink": 11, "flexWrap": 11, "alignContent": 11, "alignItems": 11, "alignSelf": 11, "justifyContent": 11, "order": 11, "transition": 11, "transitionDelay": 11, "transitionDuration": 11, "transitionProperty": 11, "transitionTimingFunction": 11, "transform": 11, "transformOrigin": 11, "transformOriginX": 11, "transformOriginY": 11, "backfaceVisibility": 11, "perspective": 11, "perspectiveOrigin": 11, "transformStyle": 11, "transformOriginZ": 11, "animation": 11, "animationDelay": 11, "animationDirection": 11, "animationFillMode": 11, "animationDuration": 11, "animationIterationCount": 11, "animationName": 11, "animationPlayState": 11, "animationTimingFunction": 11, "appearance": 11, "userSelect": 11, "fontKerning": 11, "textEmphasisPosition": 11, "textEmphasis": 11, "textEmphasisStyle": 11, "textEmphasisColor": 11, "maskImage": 11, "maskMode": 11, "maskRepeat": 11, "maskPosition": 11, "maskClip": 11, "maskOrigin": 11, "maskSize": 11, "maskComposite": 11, "mask": 11, "maskBorderSource": 11, "maskBorderMode": 11, "maskBorderSlice": 11, "maskBorderWidth": 11, "maskBorderOutset": 11, "maskBorderRepeat": 11, "maskBorder": 11, "maskType": 11, "textSizeAdjust": 11, "filter": 11, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "fontFeatureSettings": 11, "columnCount": 11, "columnFill": 11, "columnGap": 11, "columnRule": 11, "columnRuleColor": 11, "columnRuleStyle": 11, "columnRuleWidth": 11, "columns": 11, "columnSpan": 11, "columnWidth": 11 }, "op_mini": {} }
}; /* eslint-disable */

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;

var _getPrefixedValue = __webpack_require__(118);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function calc(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browserName === 'firefox' && browserVersion < 15 || browserName === 'chrome' && browserVersion < 25 || browserName === 'safari' && browserVersion < 6.1 || browserName === 'ios_saf' && browserVersion < 7)) {
    return (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, cssPrefix + 'calc('), value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;

var _getPrefixedValue = __webpack_require__(118);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = {
  flex: true,
  'inline-flex': true
};
function flex(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  if (property === 'display' && values[value] && (browserName === 'chrome' && browserVersion < 29 && browserVersion > 20 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 && browserVersion > 6 || browserName === 'opera' && (browserVersion === 15 || browserVersion === 16))) {
    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;

var _getPrefixedValue = __webpack_require__(118);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  flex: 'flexbox',
  'inline-flex': 'inline-flexbox'
};

var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msFlexPreferredSize'
};

function flexboxIE(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed,
      requiresPrefix = _ref.requiresPrefix;

  if ((alternativeProps.hasOwnProperty(property) || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'ie_mob' || browserName === 'ie') && browserVersion === 10) {
    delete requiresPrefix[property];

    if (!keepUnprefixed && !Array.isArray(style[property])) {
      delete style[property];
    }
    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
    }
    if (alternativeProps.hasOwnProperty(property)) {
      style[alternativeProps[property]] = alternativeValues[value] || value;
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;

var _getPrefixedValue = __webpack_require__(118);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple',
  flex: 'box',
  'inline-flex': 'inline-box'
};


var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
var properties = Object.keys(alternativeProps).concat(otherProps);

function flexboxOld(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed,
      requiresPrefix = _ref.requiresPrefix;

  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'firefox' && browserVersion < 22 || browserName === 'chrome' && browserVersion < 21 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion <= 6.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
    delete requiresPrefix[property];

    if (!keepUnprefixed && !Array.isArray(style[property])) {
      delete style[property];
    }
    if (property === 'flexDirection' && typeof value === 'string') {
      if (value.indexOf('column') > -1) {
        style.WebkitBoxOrient = 'vertical';
      } else {
        style.WebkitBoxOrient = 'horizontal';
      }
      if (value.indexOf('reverse') > -1) {
        style.WebkitBoxDirection = 'reverse';
      } else {
        style.WebkitBoxDirection = 'normal';
      }
    }
    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
    }
    if (alternativeProps.hasOwnProperty(property)) {
      style[alternativeProps[property]] = alternativeValues[value] || value;
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _getPrefixedValue = __webpack_require__(118);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
function gradient(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  if (typeof value === 'string' && values.test(value) && (browserName === 'firefox' && browserVersion < 16 || browserName === 'chrome' && browserVersion < 26 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 7 || (browserName === 'opera' || browserName === 'op_mini') && browserVersion < 12.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;

var _getPrefixedValue = __webpack_require__(118);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};

var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true

  // TODO: chrome & opera support it
};function sizing(property, value, style, _ref) {
  var cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  // This might change in the future
  // Keep an eye on it
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateProperty = __webpack_require__(409);

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var requiresPrefixDashCased = void 0;

function transition(property, value, style, _ref) {
  var cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed,
      requiresPrefix = _ref.requiresPrefix;

  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    // memoize the prefix array for later use
    if (!requiresPrefixDashCased) {
      requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
        return (0, _hyphenateProperty2.default)(prop);
      });
    }

    // only split multi values, not cubic beziers
    var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

    requiresPrefixDashCased.forEach(function (prop) {
      multipleValues.forEach(function (val, index) {
        if (val.indexOf(prop) > -1 && prop !== 'order') {
          multipleValues[index] = val.replace(prop, cssPrefix + prop) + (keepUnprefixed ? ',' + val : '');
        }
      });
    });

    return multipleValues.join(',');
  }
}
module.exports = exports['default'];

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ __webpack_exports__["default"] = (hyphenateStyleName);


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _calc = __webpack_require__(960);

var _calc2 = _interopRequireDefault(_calc);

var _flex = __webpack_require__(961);

var _flex2 = _interopRequireDefault(_flex);

var _flexboxIE = __webpack_require__(962);

var _flexboxIE2 = _interopRequireDefault(_flexboxIE);

var _flexboxOld = __webpack_require__(963);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

var _gradient = __webpack_require__(964);

var _gradient2 = _interopRequireDefault(_gradient);

var _sizing = __webpack_require__(965);

var _sizing2 = _interopRequireDefault(_sizing);

var _transition = __webpack_require__(966);

var _transition2 = _interopRequireDefault(_transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
  prefixMap: { "transform": ["Webkit", "ms"], "transformOrigin": ["Webkit", "ms"], "transformOriginX": ["Webkit", "ms"], "transformOriginY": ["Webkit", "ms"], "backfaceVisibility": ["Webkit"], "perspective": ["Webkit"], "perspectiveOrigin": ["Webkit"], "transformStyle": ["Webkit"], "transformOriginZ": ["Webkit"], "animation": ["Webkit"], "animationDelay": ["Webkit"], "animationDirection": ["Webkit"], "animationFillMode": ["Webkit"], "animationDuration": ["Webkit"], "animationIterationCount": ["Webkit"], "animationName": ["Webkit"], "animationPlayState": ["Webkit"], "animationTimingFunction": ["Webkit"], "appearance": ["Webkit", "Moz"], "userSelect": ["Webkit", "Moz", "ms"], "fontKerning": ["Webkit"], "textEmphasisPosition": ["Webkit"], "textEmphasis": ["Webkit"], "textEmphasisStyle": ["Webkit"], "textEmphasisColor": ["Webkit"], "boxDecorationBreak": ["Webkit"], "clipPath": ["Webkit"], "maskImage": ["Webkit"], "maskMode": ["Webkit"], "maskRepeat": ["Webkit"], "maskPosition": ["Webkit"], "maskClip": ["Webkit"], "maskOrigin": ["Webkit"], "maskSize": ["Webkit"], "maskComposite": ["Webkit"], "mask": ["Webkit"], "maskBorderSource": ["Webkit"], "maskBorderMode": ["Webkit"], "maskBorderSlice": ["Webkit"], "maskBorderWidth": ["Webkit"], "maskBorderOutset": ["Webkit"], "maskBorderRepeat": ["Webkit"], "maskBorder": ["Webkit"], "maskType": ["Webkit"], "textDecorationStyle": ["Webkit", "Moz"], "textDecorationSkip": ["Webkit", "Moz"], "textDecorationLine": ["Webkit", "Moz"], "textDecorationColor": ["Webkit", "Moz"], "filter": ["Webkit"], "fontFeatureSettings": ["Webkit", "Moz"], "breakAfter": ["Webkit", "Moz", "ms"], "breakBefore": ["Webkit", "Moz", "ms"], "breakInside": ["Webkit", "Moz", "ms"], "columnCount": ["Webkit", "Moz"], "columnFill": ["Webkit", "Moz"], "columnGap": ["Webkit", "Moz"], "columnRule": ["Webkit", "Moz"], "columnRuleColor": ["Webkit", "Moz"], "columnRuleStyle": ["Webkit", "Moz"], "columnRuleWidth": ["Webkit", "Moz"], "columns": ["Webkit", "Moz"], "columnSpan": ["Webkit", "Moz"], "columnWidth": ["Webkit", "Moz"], "flex": ["Webkit", "ms"], "flexBasis": ["Webkit"], "flexDirection": ["Webkit", "ms"], "flexGrow": ["Webkit"], "flexFlow": ["Webkit", "ms"], "flexShrink": ["Webkit"], "flexWrap": ["Webkit", "ms"], "alignContent": ["Webkit"], "alignItems": ["Webkit"], "alignSelf": ["Webkit"], "justifyContent": ["Webkit"], "order": ["Webkit"], "transitionDelay": ["Webkit"], "transitionDuration": ["Webkit"], "transitionProperty": ["Webkit"], "transitionTimingFunction": ["Webkit"], "backdropFilter": ["Webkit"], "scrollSnapType": ["Webkit", "ms"], "scrollSnapPointsX": ["Webkit", "ms"], "scrollSnapPointsY": ["Webkit", "ms"], "scrollSnapDestination": ["Webkit", "ms"], "scrollSnapCoordinate": ["Webkit", "ms"], "shapeImageThreshold": ["Webkit"], "shapeImageMargin": ["Webkit"], "shapeImageOutside": ["Webkit"], "hyphens": ["Webkit", "Moz", "ms"], "flowInto": ["Webkit", "ms"], "flowFrom": ["Webkit", "ms"], "regionFragment": ["Webkit", "ms"], "boxSizing": ["Moz"], "textAlignLast": ["Moz"], "tabSize": ["Moz"], "wrapFlow": ["ms"], "wrapThrough": ["ms"], "wrapMargin": ["ms"], "touchAction": ["ms"], "gridTemplateColumns": ["ms"], "gridTemplateRows": ["ms"], "gridTemplateAreas": ["ms"], "gridTemplate": ["ms"], "gridAutoColumns": ["ms"], "gridAutoRows": ["ms"], "gridAutoFlow": ["ms"], "grid": ["ms"], "gridRowStart": ["ms"], "gridColumnStart": ["ms"], "gridRowEnd": ["ms"], "gridRow": ["ms"], "gridColumn": ["ms"], "gridColumnEnd": ["ms"], "gridColumnGap": ["ms"], "gridRowGap": ["ms"], "gridArea": ["ms"], "gridGap": ["ms"], "textSizeAdjust": ["Webkit", "ms"], "borderImage": ["Webkit"], "borderImageOutset": ["Webkit"], "borderImageRepeat": ["Webkit"], "borderImageSlice": ["Webkit"], "borderImageSource": ["Webkit"], "borderImageWidth": ["Webkit"] }
}; /* eslint-disable */

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;

var _isPrefixedValue = __webpack_require__(264);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];
function calc(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/calc\(/g, prefix + 'calc(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = {
  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
};

function flex(property, value) {
  if (property === 'display' && values.hasOwnProperty(value)) {
    return values[value];
  }
}
module.exports = exports['default'];

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;
var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end'
};
var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msFlexPreferredSize'
};

function flexboxIE(property, value, style) {
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;
var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

function flexboxOld(property, value, style) {
  if (property === 'flexDirection' && typeof value === 'string') {
    if (value.indexOf('column') > -1) {
      style.WebkitBoxOrient = 'vertical';
    } else {
      style.WebkitBoxOrient = 'horizontal';
    }
    if (value.indexOf('reverse') > -1) {
      style.WebkitBoxDirection = 'reverse';
    } else {
      style.WebkitBoxDirection = 'normal';
    }
  }
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _isPrefixedValue = __webpack_require__(264);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;
var prefixes = ['-webkit-', '-moz-', ''];

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateProperty = __webpack_require__(409);

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

var _isPrefixedValue = __webpack_require__(264);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

var _capitalizeString = __webpack_require__(263);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var prefixMapping = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  ms: '-ms-'
};

function prefixValue(value, propertyPrefixMap) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(',');
  }

  return multipleValues.join(',');
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    var outputValue = prefixValue(value, propertyPrefixMap);
    // if the property is already prefixed
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Webkit') > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Moz') > -1) {
      return mozOutput;
    }

    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
    return outputValue;
  }
}
module.exports = exports['default'];

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = callOnce;

var _warning = __webpack_require__(176);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CALLED_ONCE = 'muiPrepared';

function callOnce() {
  if (false) {
    return function (style) {
      if (style[CALLED_ONCE]) {
        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI: You cannot call prepareStyles() on the same style object more than once.') : void 0;
      }
      style[CALLED_ONCE] = true;
      return style;
    };
  }
}

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(969);

var _keys2 = _interopRequireDefault(_keys);

exports.default = rtl;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reTranslate = /((^|\s)translate(3d|X)?\()(\-?[\d]+)/;
var reSkew = /((^|\s)skew(x|y)?\()\s*(\-?[\d]+)(deg|rad|grad)(,\s*(\-?[\d]+)(deg|rad|grad))?/;

/**
 * This function ensures that `style` supports both ltr and rtl directions by
 * checking `styleConstants` in `muiTheme` and replacing attribute keys if
 * necessary.
 */
function rtl(muiTheme) {
  if (muiTheme.isRtl) {
    return function (style) {
      if (style.directionInvariant === true) {
        return style;
      }

      var flippedAttributes = {
        // Keys and their replacements.
        right: 'left',
        left: 'right',
        marginRight: 'marginLeft',
        marginLeft: 'marginRight',
        paddingRight: 'paddingLeft',
        paddingLeft: 'paddingRight',
        borderRight: 'borderLeft',
        borderLeft: 'borderRight'
      };

      var newStyle = {};

      (0, _keys2.default)(style).forEach(function (attribute) {
        var value = style[attribute];
        var key = attribute;

        if (flippedAttributes.hasOwnProperty(attribute)) {
          key = flippedAttributes[attribute];
        }

        switch (attribute) {
          case 'float':
          case 'textAlign':
            if (value === 'right') {
              value = 'left';
            } else if (value === 'left') {
              value = 'right';
            }
            break;

          case 'direction':
            if (value === 'ltr') {
              value = 'rtl';
            } else if (value === 'rtl') {
              value = 'ltr';
            }
            break;

          case 'transform':
            if (!value) break;
            var matches = void 0;
            if (matches = value.match(reTranslate)) {
              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]));
            }
            if (matches = value.match(reSkew)) {
              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]) + matches[5] + matches[6] ? ', ' + (-parseFloat(matches[7]) + matches[8]) : '');
            }
            break;

          case 'transformOrigin':
            if (!value) break;
            if (value.indexOf('right') > -1) {
              value = value.replace('right', 'left');
            } else if (value.indexOf('left') > -1) {
              value = value.replace('left', 'right');
            }
            break;
        }

        newStyle[key] = value;
      });

      return newStyle;
    };
  }
}

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(970), __esModule: true };

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(971);
module.exports = __webpack_require__(30).Object.keys;


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(116);
var $keys = __webpack_require__(137);

__webpack_require__(386)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = compose;
function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(48);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _colors = __webpack_require__(262);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Typography = function Typography() {
  (0, _classCallCheck3.default)(this, Typography);

  // text colors
  this.textFullBlack = _colors.fullBlack;
  this.textDarkBlack = _colors.darkBlack;
  this.textLightBlack = _colors.lightBlack;
  this.textMinBlack = _colors.minBlack;
  this.textFullWhite = _colors.fullWhite;
  this.textDarkWhite = _colors.darkWhite;
  this.textLightWhite = _colors.lightWhite;

  // font weight
  this.fontWeightLight = 300;
  this.fontWeightNormal = 400;
  this.fontWeightMedium = 500;

  this.fontStyleButtonFontSize = 14;
};

exports.default = new Typography();

/***/ }),
/* 974 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 975 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 976 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAA15JREFUSA2tVktok0EQntmk1VYQUQoSxLYWreJB0B5EPIh6Uaw2qW3TIoiinmsvIgiKVFCkqDdF0YPQJJQmaUV7UhAfeBClBx/ggxStLYqPU7WP/x+/3f/PnzRJYyvdsP/OzuOb2dnd2TAVaRIMLqNSDhLpTjXEtIJEbGIeJqH3xJIkNR7n7rs/Z4LhQgIJN1SRqJMAOgR5SSEdjyc0Acc3aULOcTz+2eO7RJ4DaQnuI1ZRyBd6ykL3Ee1jMxdegnEV+mYAV3g6RH9I7DDHEn1ZPKhkNWkJtSPqS4YlMo7xNinu4kjv2yw1j5RwYx2RXEAKt2eY1M6x3ivpuecAke9B5HeMQGiUFO0E8Ku0YrFRmhtboX8VOouxR4KwGzga79c2xoGE9wZISrBpVIaIvhJZdRzt+1QMNFcmbaFKsvgFMJbCyRjZvjXc0zOsHEX/RQNuvEtzIXBpaiqTlsZ7Eg4NS319ea4D7o4PkbJDzgq4nHz2ea2jYFiNhbS5Btc5kniYa2zmylqHIHZBN0CLSmsL6Rhb5huu7IDGVvCqzzgyg9zZvlOuMH9gdlcLkWVl6DzNyTMeyzfVAEVBVGhMT5Czb57wPwmO9n9BsIPGXHg3HHCVmRA/c8Z5+T4yKMyVegVVZmLL6LxAaxCh9AkMKFwsfaH0dnt3wsxzP5YaAmsS1iM0xalc8bS5Qr1ym0K+nMiFK9PMQqPZH7E30NhULScS3wvpZHgqYGhg+7EHKUxq0LcYZpEP6sybIuJsEUqIbpzyYwUDSNMO9I04txUznSRz28l/zNhN0DVUzhFD53yAsZzE2go8ZFMGsAd20tNRVqdH5xElWDafNt1nOynI0wHDZ58FuLOfwFYcS34AO+LqHpXw/m0uPefB2IoccQylW2MbT84D43vt1CP6QWxt4mgyNRcPSM1KVIWXwECxo99kq9VesTNgLGEDqBXIN2hK8Cw9SGvjeoA/NeDGxm7W4Jp0cuUCoVp2gNPlTjHIA6ic4Gjv8wwvQwF4LaLtQD8Iu1IjETnOsfjltNY0B5qJhyeEWxfxDAyTdI3SpeQjns5fmkXCOCm0w9DO599PZlrZe/SJDuNE4K4UafrRJ7mFO945q0c/G8r8bVmgsCLBQ8LViBh/W/Aj0vl9N5u/LX8BTfE4yd3/55wAAAAASUVORK5CYII="

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function")}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}return call&&(typeof call==="object"||typeof call==="function")?call:self}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}var React=__webpack_require__(0);var PureComponent=React.PureComponent;var PropTypes=__webpack_require__(4);var objectAssign=__webpack_require__(36);function noop(){}var Iframe=function(_PureComponent){_inherits(Iframe,_PureComponent);function Iframe(){_classCallCheck(this,Iframe);return _possibleConstructorReturn(this,(Iframe.__proto__||Object.getPrototypeOf(Iframe)).apply(this,arguments))}_createClass(Iframe,[{key:"render",value:function render(){var props={ref:"iframe",frameBorder:"0",src:this.props.url,target:"_parent",allowFullScreen:this.props.allowFullScreen||false,style:objectAssign({},{position:this.props.position||"absolute",display:this.props.display||"block",height:this.props.height||"100%",width:this.props.width||"100%"},this.props.styles||{}),height:this.props.height||"100%",name:this.props.name||"",width:this.props.width||"100%",onLoad:this.props.onLoad||noop,onMouseOver:this.props.onMouseOver||noop,onMouseOut:this.props.onMouseOut||noop};return React.createElement("iframe",objectAssign(props,this.props.id?{id:this.props.id}:{},this.props.sandbox?{sandbox:this.props.sandbox}:{},this.props.allow?{allow:this.props.allow}:{},this.props.className?{className:this.props.className}:{},this.props.title?{title:this.props.title}:{},this.props.ariaHidden?{"aria-hidden":"true"}:{}))}}]);return Iframe}(PureComponent);Iframe.propTypes={url:PropTypes.string.isRequired,id:PropTypes.string,title:PropTypes.string,className:PropTypes.string,width:PropTypes.string,position:PropTypes.string,display:PropTypes.string,name:PropTypes.string,height:PropTypes.string,onLoad:PropTypes.func,sandbox:PropTypes.string,allow:PropTypes.string,onMouseOver:PropTypes.func,onMouseOut:PropTypes.func,styles:PropTypes.object,allowFullScreen:PropTypes.bool,ariaHidden:PropTypes.bool};exports.default=Iframe;


/***/ }),
/* 978 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 979 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_slideshow_image__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_slideshow_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_slideshow_image__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Imageslider=function(_React$Component){_inherits(Imageslider,_React$Component);function Imageslider(props){_classCallCheck(this,Imageslider);var _this=_possibleConstructorReturn(this,(Imageslider.__proto__||Object.getPrototypeOf(Imageslider)).call(this,props));_this.state={images:[]};return _this;}_createClass(Imageslider,[{key:'render',value:function render(){var images=this.props.images;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_slideshow_image__["Fade"],{images:images,duration:5000,transitionDuration:1000});}}]);return Imageslider;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* unused harmony default export */ var _unused_webpack_default_export = (Imageslider);

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slide = __webpack_require__(982);

Object.defineProperty(exports, 'Slide', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_slide).default;
  }
});

var _fade = __webpack_require__(984);

Object.defineProperty(exports, 'Fade', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_fade).default;
  }
});

var _zoom = __webpack_require__(986);

Object.defineProperty(exports, 'Zoom', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_zoom).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(983);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Slideshow = function (_Component) {
  _inherits(Slideshow, _Component);

  function Slideshow(props) {
    _classCallCheck(this, Slideshow);

    var _this = _possibleConstructorReturn(this, (Slideshow.__proto__ || Object.getPrototypeOf(Slideshow)).call(this, props));

    _this.state = {
      index: 0
    };
    _this.width = 0;
    _this.imageContainer = null;
    _this.timeout = null;
    return _this;
  }

  _createClass(Slideshow, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.allImages = document.querySelectorAll('.images-wrap div');
      this.width = document.querySelector('.react-slideshow-wrapper').clientWidth;
      this.setWidth();
      this.addResizeListener();
    }
  }, {
    key: 'setWidth',
    value: function setWidth() {
      var fullwidth = this.width * (this.props.images.length + 2);
      this.imageContainer.style.width = fullwidth + 'px';
      this.imageContainer.style.transform = 'translate(-' + this.width * (this.state.index + 1) + 'px)';
      this.applySlideStyle();
    }
  }, {
    key: 'addResizeListener',
    value: function addResizeListener() {
      var _this2 = this;

      window.addEventListener('resize', function () {
        _this2.width = document.querySelector('.react-slideshow-wrapper').clientWidth;
        _this2.setWidth();
      });
    }
  }, {
    key: 'applySlideStyle',
    value: function applySlideStyle() {
      var _this3 = this;

      this.allImages.forEach(function (eachImage, index) {
        eachImage.style.width = _this3.width + 'px';
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          images = _props.images,
          duration = _props.duration;
      var index = this.state.index;

      var style = {
        transform: 'translate(-' + (index + 1) * this.width + 'px)'
      };
      this.timeout = setTimeout(function () {
        return _this4.slideImages('next');
      }, duration);
      return _react2.default.createElement(
        'div',
        { className: 'react-slideshow-container' },
        _react2.default.createElement(
          'div',
          { className: 'nav', onClick: function onClick() {
              return _this4.slideImages('prev');
            } },
          ' ',
          '<',
          ' '
        ),
        _react2.default.createElement(
          'div',
          { className: 'react-slideshow-wrapper slide' },
          _react2.default.createElement(
            'div',
            {
              className: 'images-wrap',
              style: style,
              ref: function ref(wrap) {
                return _this4.imageContainer = wrap;
              }
            },
            _react2.default.createElement(
              'div',
              { 'data-index': '-1' },
              _react2.default.createElement('img', { alt: '', src: images[images.length - 1] })
            ),
            images.map(function (each, key) {
              return _react2.default.createElement(
                'div',
                {
                  'data-index': key,
                  key: key,
                  className: key === index ? 'active' : ''
                },
                _react2.default.createElement('img', { alt: '', src: each })
              );
            }),
            _react2.default.createElement(
              'div',
              { 'data-index': '-1' },
              _react2.default.createElement('img', { alt: '', src: images[0] })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'nav', onClick: function onClick() {
              return _this4.slideImages('next');
            } },
          ' ',
          '>',
          ' '
        )
      );
    }
  }, {
    key: 'slideImages',
    value: function slideImages(type) {
      var _this5 = this;

      var index = this.state.index;
      var images = this.props.images;

      clearTimeout(this.timeout);
      index = type === 'next' ? index + 1 : index - 1;
      this.imageContainer.style.transition = 'all ' + this.props.transitionDuration / 1000 + 's';
      this.imageContainer.style.transform = 'translate(-' + this.width * (index + 1) + 'px)';
      setTimeout(function () {
        _this5.imageContainer.style.transition = 'none';
        _this5.setState({
          index: index < 0 ? images.length - 1 : index >= images.length ? 0 : index
        });
      }, this.props.transitionDuration);
    }
  }]);

  return Slideshow;
}(_react.Component);

Slideshow.defaultProps = {
  duration: 5000,
  transitionDuration: 1000
};

Slideshow.propTypes = {
  images: _propTypes2.default.array.isRequired,
  duration: _propTypes2.default.number,
  transitionDuration: _propTypes2.default.number
};
exports.default = Slideshow;

/***/ }),
/* 983 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(985);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Fade = function (_Component) {
  _inherits(Fade, _Component);

  function Fade(props) {
    _classCallCheck(this, Fade);

    var _this = _possibleConstructorReturn(this, (Fade.__proto__ || Object.getPrototypeOf(Fade)).call(this, props));

    _this.state = {
      images: []
    };
    _this.imageRefs = [];
    _this.width = 0;
    _this.height = 0;
    _this.timeout = null;
    _this.imageContainer = null;
    _this.getImageDim = _this.getImageDim.bind(_this);
    return _this;
  }

  _createClass(Fade, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      this.timeout = setTimeout(function () {
        return _this2.fadeImages('next');
      }, this.props.duration);
      this.setState({
        images: this.props.images.reverse()
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.width = document.querySelector('.react-slideshow-fade-wrapper').clientWidth;
      this.applyStyle();
      this.addResizeListener();
    }
  }, {
    key: 'getImageDim',
    value: function getImageDim() {
      this.height = this.imageContainer.children[0].clientHeight;
      this.imageContainer.style.height = this.height + 'px';
    }
  }, {
    key: 'addResizeListener',
    value: function addResizeListener() {
      var _this3 = this;

      window.addEventListener('resize', function () {
        _this3.width = document.querySelector('.react-slideshow-fade-wrapper').clientWidth;
        _this3.applyStyle();
      });
    }
  }, {
    key: 'applyStyle',
    value: function applyStyle() {
      var _this4 = this;

      this.imageRefs.forEach(function (eachImage, index) {
        eachImage.style.width = _this4.width + 'px';
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var type = this.props.type;
      var images = this.state.images;

      return _react2.default.createElement(
        'div',
        { className: 'react-slideshow-container' },
        _react2.default.createElement(
          'div',
          { className: 'nav', onClick: function onClick() {
              return _this5.fadeImages('prev');
            } },
          ' ',
          '<',
          ' '
        ),
        _react2.default.createElement(
          'div',
          { className: 'react-slideshow-fade-wrapper ' + type },
          _react2.default.createElement(
            'div',
            {
              className: 'images-wrap',
              ref: function ref(wrap) {
                return _this5.imageContainer = wrap;
              }
            },
            images.map(function (each, key) {
              return _react2.default.createElement(
                'div',
                {
                  ref: function ref(el) {
                    _this5.imageRefs.push(el);
                  },
                  onLoad: key === 0 ? _this5.getImageDim : null,
                  'data-index': key,
                  key: key
                },
                _react2.default.createElement('img', { alt: '', src: each })
              );
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'nav', onClick: function onClick() {
              return _this5.fadeImages('next');
            } },
          ' ',
          '>',
          ' '
        )
      );
    }
  }, {
    key: 'fadeImages',
    value: function fadeImages(type) {
      var _this6 = this;

      var images = this.state.images;

      var newImageArr = [];
      clearTimeout(this.timeout);
      var lastImage = this.imageContainer.children[images.length - 1];
      if (type === 'prev') {
        newImageArr = images.slice(1);
        newImageArr.splice(newImageArr.length - 1, 0, images[0]);
        this.setState({ images: newImageArr });
        newImageArr = images.slice(1, images.length);
        newImageArr.splice(newImageArr.length, 0, images[0]);
      } else {
        newImageArr = [images[images.length - 1]].concat(images.slice(0, images.length - 1));
      }
      lastImage.style.transition = 'all ' + this.props.transitionDuration / 1000 + 's';
      lastImage.style.opacity = '0';
      setTimeout(function () {
        lastImage.style.opacity = '1';
        lastImage.style.transition = 'none';
        _this6.timeout = setTimeout(function () {
          return _this6.fadeImages('next');
        }, _this6.props.duration);
        _this6.setState({ images: newImageArr });
      }, this.props.transitionDuration);
    }
  }]);

  return Fade;
}(_react.Component);

Fade.defaultProps = {
  duration: 5000,
  transitionDuration: 1000
};

Fade.propTypes = {
  images: _propTypes2.default.array.isRequired,
  duration: _propTypes2.default.number,
  transitionDuration: _propTypes2.default.number
};
exports.default = Fade;

/***/ }),
/* 985 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(987);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Zoom = function (_Component) {
  _inherits(Zoom, _Component);

  function Zoom(props) {
    _classCallCheck(this, Zoom);

    var _this = _possibleConstructorReturn(this, (Zoom.__proto__ || Object.getPrototypeOf(Zoom)).call(this, props));

    _this.state = {
      images: []
    };
    _this.imageRefs = [];
    _this.width = 0;
    _this.height = 0;
    _this.timeout = null;
    _this.imageContainer = null;
    _this.getImageDim = _this.getImageDim.bind(_this);
    return _this;
  }

  _createClass(Zoom, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      this.timeout = setTimeout(function () {
        return _this2.fadeImages('next');
      }, this.props.duration);
      this.setState({
        images: this.props.images.reverse()
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.width = document.querySelector('.react-slideshow-zoom-wrapper').clientWidth;
      this.applyStyle();
      this.addResizeListener();
    }
  }, {
    key: 'getImageDim',
    value: function getImageDim() {
      this.height = this.imageContainer.children[0].clientHeight;
      this.imageContainer.style.height = this.height + 'px';
    }
  }, {
    key: 'addResizeListener',
    value: function addResizeListener() {
      var _this3 = this;

      window.addEventListener('resize', function () {
        _this3.width = document.querySelector('.react-slideshow-zoom-wrapper').clientWidth;
        _this3.applyStyle();
      });
    }
  }, {
    key: 'applyStyle',
    value: function applyStyle() {
      var _this4 = this;

      this.imageRefs.forEach(function (eachImage, index) {
        eachImage.style.width = _this4.width + 'px';
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var type = this.props.type;
      var images = this.state.images;

      return _react2.default.createElement(
        'div',
        { className: 'react-slideshow-container' },
        _react2.default.createElement(
          'div',
          { className: 'nav', onClick: function onClick() {
              return _this5.fadeImages('prev');
            } },
          ' ',
          '<',
          ' '
        ),
        _react2.default.createElement(
          'div',
          { className: 'react-slideshow-zoom-wrapper ' + type },
          _react2.default.createElement(
            'div',
            {
              className: 'images-wrap',
              ref: function ref(wrap) {
                return _this5.imageContainer = wrap;
              }
            },
            images.map(function (each, key) {
              return _react2.default.createElement(
                'div',
                {
                  ref: function ref(el) {
                    _this5.imageRefs.push(el);
                  },
                  onLoad: key === 0 ? _this5.getImageDim : null,
                  'data-index': key,
                  key: key
                },
                _react2.default.createElement('img', { alt: '', src: each })
              );
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'nav', onClick: function onClick() {
              return _this5.fadeImages('next');
            } },
          ' ',
          '>',
          ' '
        )
      );
    }
  }, {
    key: 'fadeImages',
    value: function fadeImages(type) {
      var _this6 = this;

      var images = this.state.images;

      var newImageArr = [];
      clearTimeout(this.timeout);
      var lastImage = this.imageContainer.children[images.length - 1];
      if (type === 'prev') {
        newImageArr = images.slice(1);
        newImageArr.splice(newImageArr.length - 1, 0, images[0]);
        this.setState({ images: newImageArr });
        newImageArr = images.slice(1, images.length);
        newImageArr.splice(newImageArr.length, 0, images[0]);
      } else {
        newImageArr = [images[images.length - 1]].concat(images.slice(0, images.length - 1));
      }
      lastImage.style.transition = 'all ' + this.props.transitionDuration / 1000 + 's';
      lastImage.style.opacity = '0';
      lastImage.style.transform = 'scale(' + this.props.scale + ')';
      setTimeout(function () {
        lastImage.style.opacity = '1';
        lastImage.style.transform = 'scale(1)';
        lastImage.style.transition = 'none';
        _this6.timeout = setTimeout(function () {
          return _this6.fadeImages('next');
        }, _this6.props.duration);
        _this6.setState({ images: newImageArr });
      }, this.props.transitionDuration);
    }
  }]);

  return Zoom;
}(_react.Component);

Zoom.defaultProps = {
  duration: 5000,
  transitionDuration: 1000
};

Zoom.propTypes = {
  images: _propTypes2.default.array.isRequired,
  duration: _propTypes2.default.number,
  transitionDuration: _propTypes2.default.number,
  scale: _propTypes2.default.string.isRequired
};
exports.default = Zoom;

/***/ }),
/* 987 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_navTop_css__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_navTop_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_navTop_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Navtop=function(_Component){_inherits(Navtop,_Component);function Navtop(){_classCallCheck(this,Navtop);return _possibleConstructorReturn(this,(Navtop.__proto__||Object.getPrototypeOf(Navtop)).apply(this,arguments));}_createClass(Navtop,[{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#navtopicn").fadeOut();this.checkScrollIconVisibility();}},{key:'componentDidUpdate',value:function componentDidUpdate(){var me=this;setTimeout(function(){me.windowscrollupdate();me.modalscrollupdate();},200);}},{key:'checkScrollIconVisibility',value:function checkScrollIconVisibility(){var me=this;__WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).scroll(function(){me.windowscrollupdate();});__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".modal").scroll(function(){me.modalscrollupdate();});}},{key:'windowscrollupdate',value:function windowscrollupdate(){var me=this;if(me.isVisible(".modal")==false){if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).scrollTop()>100){__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#navtopicn").fadeIn();}else{__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#navtopicn").fadeOut();}}}},{key:'modalscrollupdate',value:function modalscrollupdate(){var me=this;if(me.isVisible(".modal")==true){if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".modal").scrollTop()>100){__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#navtopicn").fadeIn();}else{__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#navtopicn").fadeOut();}}}},{key:'scrollToTop',value:function scrollToTop(){var intervalId=setInterval(this.scrollStep.bind(this),100);this.setState({intervalId:intervalId});}},{key:'isVisible',value:function isVisible(element){var element=__WEBPACK_IMPORTED_MODULE_1_jquery___default()(element);if(element.length>0&&element.css('visibility')!=='hidden'&&element.css('display')!=='none'){return true;}else{return false;}}},{key:'scrollStep',value:function scrollStep(){if(this.isVisible(".modal")){__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".modal").animate({scrollTop:0},'500');clearInterval(this.state.intervalId);}else{__WEBPACK_IMPORTED_MODULE_1_jquery___default()("HTML, BODY").animate({scrollTop:0},'500');clearInterval(this.state.intervalId);}console.log("scrollStep"+window.pageYOffset);}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'navtopicn',className:'hidden'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'fltarr',onClick:function onClick(){_this2.scrollToTop();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'cd-top js-cd-top',id:'fltoparrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'arrow_upward'))));}}]);return Navtop;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Navtop);

/***/ }),
/* 989 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 990 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAA5CAYAAAHoyPPnAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAklJREFUeNpi/P//PwMQODCgggMgghEomQCkFRgwwQYmBtwgAJ8kA40kGaFewQoAAogRlz9ZgEQDFg0HmEh2BBUlcPoFIIBgEg0MxAGwOpAfE6ACHUD8A59iKEhgQeIo4NGEDBSQNUUQ6UT8sTrgmhYABBAsyAWA2ICA4gOw4K4A4hVY0hs2DQ4gZ3EgxREh4MCCI9JwReYDYjTgjMgFOBShOJcFlwTV4mJUAymplVjAARBAyBpgqTaBgXIAS2YSQPyCCZp3QNnhBAP1gQfIJyxQSxQYaAMUCNZsVAIa9LCEgS6WsGARW0FkbcJAbJGCzZKIIRlco5YMTkt+UNlMdPN+AAQQcikMKjE1qGDBCWx5BGR4BpV88QLUtIC1SZiobDhG6csEDZYDsHYWtS1gIaK9NmiTqwK2gvADEE8g0aAAHM1cAfR2JEywgUo+EIBF8tAuMliw5MQVZDRnJIi1gJSew2gQDZEgGrVg1IJRC4aDBSw0NPsCtjqZGuADlAb32UkdUiC54gcIMGwWSECLbGoNR1AjqDfgkAOF0gUWLI7nYBhcwACWZrA0HjVgnhisjic4agLrNsHGgV7gaDYMdk/AOyMSDLQbzKIVkIC25Bno0pqncSzAY4IQ2IEjuVET4G3x4ijDH5BSCw3GvCGAnAWGanIiqT0A6gwtoENywtXPp4onQHVHxmCPiWGRnEZMntjAQP1hWEqLWJLzRMRochr1xKgnRj0x6olRT4x6YtQTo54YXp5YQYeeG7kA1HqewYA5+ncC6mawPAB86HLb2YAgYgAAAABJRU5ErkJggg=="

/***/ }),
/* 992 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAA9CAYAAAFpZVF/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAlhJREFUeNpi/P//PwMQODDgACxArIBPARMSuwGNfoCugKAJ5ClgBPoC5MgEsk0ACCCQCQ545A+w4AsDkFeZkP0MBQuQwoIe4cACpRWQxBJIMgEggAiGJAGwgImBQoBuwAPkMERKXwuQ2A+wBQIDFk1EAWIMaMBn8MAHIiM0WyuQqf8BQACBDNAAMiTI0PwBFIAR1Ir/gdMMitcDONLAAfR4HzhnY0uuB7A4nWjNDmhFXQOpGYWBCENJ8jNGaIOSZ8PQT2Ek52lQduQgQ+8PgACCac5goD8AF2ccDAMEmBgGEODLIQ+QKjEHPK2LBqRKPQFL/k7AVc4PqM8HbbCjR8GBgbL8A3rDhZ6WGxCR4PAW35TWB6SAC1AMAh64GiW0shw5mn7QqtlMcfE6MvM5EzR+BgL8AAggRkJdZxqBAxQ1foZkXI9aPPwtxld+NxDRG2kgkT0ax6MWD56W6IERZ7ECnjY5TS1OIKHZS1WLSQUNQz5Vk9yUJRRNtLL4waAN6tHG3qjFoxYPfYspnZEhu2QDCDCYxQEMkFGf4Q5eAPEMJmhIjwQPgwBoREyBiWEEglFPj3p6GANyGrygEdELOHpcpFY/2LqHAjgK1gc4GtIGUD009zQ2xzpQydMKeDyNS73AaPIe9fSop0c9PVplkQkOMNBghHI0pgdhTDswkD6T2jDUPU1rQE6gjibv0Tw9RACu2iGB1Db/aEwTCSQYsE/MCJBhFjZzcK0SNcARoxL08DQHA/WGbUkxR4DMgB1N3qOeHvX0qKdHPT1sPP0AiE+MEP+Chq4fAABx+IEv6gHt4QAAAABJRU5ErkJggg=="

/***/ }),
/* 993 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAA9CAYAAAFzWbHxAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABMZJREFUeNpi/P//PwMQKDBgggcsUIkEEAeIJYCYA4ifAPEaBqBOBZBuNOwAopmgRjQgGQdnsyAJroAaeQEmwIQkCbOPAZskA5KkChALMEK9gmwX3E6AAAJJYvPjfyao/zygftSA8hVhds2A0hZQ+gC6IzD8BRJwAKlEd7YAVFABXeIDVMcDKN8BOUAbkAMYIIBg/khgIAxA0XQHFLYsDMSDOzCHs2DzIhaAIkesJgZ8scoADQ0YzYFNEy4/wTT+QBJTgdLggHiAHDNoKf8AmmGvQHGDnK6IBgABxIgnX2EDD0AaiA2xA9hCDaT5BTQnNeByErE2NBCKzAho3i2AJmucEYmc0WFJHWvMY3NaAnoIsuBLfKSkLQdiNYAUngHiI7g0YUuIX/A5CV3DDSSTX2BLzehOeoGmGWfic0ALShBYgKaWGYj3smBJ/w448gSKDUQDgACCaWhgoB4AuXoPcrZgIpDhkNPeDxxsjIyJxhdgIpBtBKB0A7Tk6kBj/yA2uIgt5hlIKDUOEMobVAejlpCcpvEBEyDmwSL+B1pEUWyJANQCdAMNoHIKWPIEyZZ8QFKjA8RXoAYL4Mh06BU5DFxgIiLNg4AItEBTwFeo4Yv4B1SOZ/RiiqhWRgORYhQnYVgb4gI5XgMIIJhPJHA13cgEfEB8D1S5giyIgDbVqQVuA/FTWFwwUdlwBiTDCdYhNC+rGpBSTQcONtm5ewG0bQirBQOgCaEB2sXSgFpUQUwqIuSaF1DD0dlE5R9i4kACB5usIJqBpX2Hy5ULoEUOB76gQrcggwTHJZDjgwno7XdSehPEWFBAr+qUWJ80kGtBAT1y8tCwgIUIeRs0sRPENpSJ8YENFjELUionfBZYIDXAYC3sL2hyFFkAcyVyY+wMLSKZg1aR/AbaALOAuvwPUtDgi2QHYn1wBa2BbIGWkqgSRB+GRE6+QWUzkWu9LyzQcRwJHO0jDhzVJKHWNg8s37AgVeYvcLSaf5BhweArTSdAMdmta3y5+AeWPh3RyRcgQLtWj9owDIWF0eAhgykZUujg3iBDr9A75Dgde4wewWNHQxcPpZhOGQr1UKiGDB48hJJCLXgiqqpKlvoki9AHWmSw/fn9fe+TxQNyYHIlSdO4cMUV7tdxfUg5yovBgYMoQhAKRPsc14Ph+mMmTcSp2rutL/hmXAPsS03tLezfK/sd7FcpcKQ9ZHcNrLyBqYfBGFCR46GavH8H+4wc9Xw0c9UUb8hPqbyBL7+G0U4WDCroChvFKwLUlELyPK4n08QXQhjFttrWkeiE8MFwvdqP1fsWfykwNhAdYvwWEj3tyXc1Lnch2q4gMDUspiEzwbm3cHsXIe5zH5XExRMrhY73c790dHpp8HC0eV2XnMnRlIycgFHExFyCl6iUPztiOaqeGwQFqrEwhF4pCTBtKEC+IMpfeA+DpKVQfaj0nCu4vk0BxEIDoNWU3hdNJ16BN97mTmwV+GDoHTruRVPwxKDxjDg7Ve1C09Rcm+WZhbIzHxAHmCHkMFkSw+84yuSHDaL37RN74PguL1RjT3Qn1ewyJEIX0s5t4S1A3Eai3D7GhbPrcV1qCgw/ZBi8fniUbOqwL0SGfwIYE0T0sMTonq2h3BbQP9YhQXwBnaNWwcQgU5AAAAAASUVORK5CYII="

/***/ }),
/* 994 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAFUklEQVR4nO2cvW/bRhiHfy8/pgCxJVBabaBzUxfdChRmh87x2k3durgVUMBrNHQqYFToX6BMzajMHqrAqwsoaNamireIAiUVbgabwtvBR4WW+HUkJR4NP4ABmjq+JB7c8Y7Hlwc88EAeaNsndBznkJkPiGgXgJ1UnplHRDQioqGu68NarfZu81f5kY0Lmk6ne57ntXArw84bj5lHAAaapg0sy3qeN14SGxHkuu7OYrFoM3OLiPY3cY4AfQDdRqPxahPBCxUkaksbQLvIuGlg5pGmaW3Lsl4WGbcQQX6NAdApIl4emHlIRO2ialRuQY7jHOK2mu/mv5ziYOaeYRjter0+zxNHy3qg67o7juP8CmAAxeQAABG1PM8bTCaTp7niZDnIdd0dz/MGRHSQ5+TbgohaWXs8aUHT6fQzz/MGULDWxMHMvWaz+Z3scVKCqirHJ4uk1IKq1qyikG1uqQTdFzk+MpJS9WKLxaJ/X+QAt01NDE8SSRQkunI770UpSH86ne4lFYoVJMYQW39s2BK7Nzc3/aRCkYJc191h5l6hl6QYRHTgOM6zuDKRgjzP66KC3fnZu99lD+nENbVQQY7jHBJRS/ZMZXN6cYzTP3/A6cWx1HGe5/WifouqQR2pMyjA6cUxzi5fAADOLl/ISrKjerU1QaKgneEaSyMoxyeDpE7YzjVBzNyViVo2YXJ8JCXZYU/+dwSJe09lBoRxcnxkJDHz2pBmtQYdpb66kkkjx+dJ48u0YW3XdXeCO1YFtdJGKhMZOT998Ru+2fs2dWzxBmbJUpC4OSs/7tmkHAAgojutKFiDbKlIJbBpOQI7+E9lBG1JDoBlawJQEUHblCOw/Q0NuH3hlzfipihBDph539/WAMDzvP2owmVShhwACL4u11Z3qEJZcoCQGhTcoQJlygFCalARXF3PcXWd6y0vgPLlrFKIoKvrOU7Oj3ByfpRLkmpygAIE+XLezt/g7fxNZkkqygFyCgrK8ckiSVU5QA5BYXJ8ZCSpLAf42M0PZQ6Kk+OTRpKqcph56cPv5mcyAd5/uMT7D5eJ5eIkqSoHAIho6UMDAMMwRjIBPtn9FL981ccj83Fi2TBJKssBlpm0AISgLLnHWSWpLgcAiGi03PY3HMf5Axme6P+e/YWT8yP8d/NvYtlH5uNU5YDy5AhsPwk02ItJ3ah9ZGpSReRA1/W7N2kAIKJB1oAykpIoWw4zD4OZsUtBeROwi5BUthwAIKI7GR+rA8XEdJA48khSQQ4AGIYRLYiIenlPkEWSKnKYeVir1V4H990RZFnWy+AYICsyklSRAwCapq29dl97FiuiFgHpJKkkB8BM07S1W8yaIF3XuwCkHj2iiJOkmBwA6IZ917EmSBQqLMMjTJKCcmaiYqwRmSc9Ho//KXIy3x9xf//kZ9XkxOZNRwqaTCZPmTlXt18FmHnYbDY/j/o9csJMDBwrlUyVgZlpmrEpP7Ezirqud4KTR/cNImonzWTECqrX63PTNFsoqFdTCWbupfleI9XHLCLbYZD3ohRi0Gg0vk5TMNWkfaPReFXFvOkwmHmo63rqVMPUbzUsy3ousq+q3Nz6hmHYMh/6PnySmUCmj3qrJimrHCDji8NarfbaMAwbOeePtsCMmdtZ5QDFLCzwDAp+28HMQ9M0W6vzO7IUsjSFGAZ0oEae4wxAV9f10KdzWQpd3GQ8Hv8IoF1ixlrfMIzE0bEMG1keZ9uimLlnmmY3b3MKY6MLLImm18Zt0yu0xxOrvPSLakpRbG2JLiHrCMCB+JMSJoSMhJTBtpbq2voaZj5iMab9NGU3tbrUAwXwP3df2K9RjWFtAAAAAElFTkSuQmCC"

/***/ }),
/* 995 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAAA+CAYAAAEUptYOAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABF5JREFUeNpi/P//fyoDA4MvAwHARIwiEGCB0n4E1G1iwiYIxRhWM5BiNTLww+UZGKgm5GsYaMWnECCAGIHhuImYMCQIQCaR7NM+IJYAYh5kH6NbpwLEUWRZx4QWReQ7HCCAiAonPOA+ECsC8Tcg5iI2qREDNrEQoagPGooELSVk2CY0QzbhM5BQsvFDyzwLKXEZSeHJRMB7JAFKkwYKAAggahrmx0SmxldkFwJYgBhWUaA3nUH5jhqYqAxMadLAVtrHU2oYyJCpUHYwFFPksp3QXLCTkOtYiAwOWMnxhRLD7qBlrSiK6xFqxiZFhm0it9TA5bJ95JYaVPMmC7lewlYEAQQQVQtHKoIUJjpa1oZWN/khxXMKmtyrwRpifrBcHgnEXweJozYhZ6Wvgy3IWKjhOzxlatFAFIub0BIyCHeitdY3DYTDsIGjUAd+GcioXItUsyO3xJFB2kA4bCEUWwNxOZL4F6iDvgxk4keOPqoCYtPYCkL9G3oXF+i5KgWKqQlA1dIEUh1GtxDCFZWgKol7EBT4SlCaGyCABmMl/oqJYfABMXo66j6efu4VWlZD+EA+EG+GsqvRcnQVssMGZcNwMKYpBmqOr1EDgKLVfLCF1ITBGH1fB32aIheoQBt/6CCKknYWJSEVjMNBILCMATIkT3dHxaM1m7E5jK6OykZiv4A2l/2g3S/06KWbo9xxiBcxoI6tWdPTUS8IpLUBqWZ2YhGTgDalg9F6QnRz1Fo0x4AS9Sw0NQNSJCCnHR4C8nRz1BccOY7iviE1OqhFDFQGg7LuG7KOcoZm9RWDyVH5UJqLATIyPKBNlwIgdkIT02Gg3gQAziECFgJNUxBGXuDhN9AhBQOzoXjE5j4xZEfpDhJHRQ3aHjJAgPatUKeBIIhOkHCa1BdLwMEf8A1g+IAKEiQCQVKBIRgMqcGAOlWNJCmSFEmqL+ijmg59l1u2u9ymPe52t/OSMd279PIyMzv7ZtbXfo6PON4QDtzPyjGSNaSyq/SurQ2UNX1EpWixshI8/a9qzzfwRs2S8xYtjtkczmyE9cSwNkHy3pSctWJlo3rWFJXLmDxsRzeMXYTkgS0M+yBKMOdhDNL6pspPiDKT5vch1Vf4shuyQrk/sy6VEmoOY+2ORZ5snckqpkJtanwCO6VSPGel7JJqGHoJhSz2nCtarmXB7z7SivNUoRzt92je89GJypTK+gRhV0XaTeye1XN4hkPs2iFcd/B7GqtndZZ4J4W33VnyWrSe9YZQdMURvMdG8kfMZHF43VfsgJV3J4AXh9wWNFk5QkofMy16nq54aDJXtV1nncOLeuTeMs9BUNrSN7dalOq7XgLiOsp61nSohXDcIeVo4y3kIN2SZ7GMW0wQszz7JWQt4pdApoGbAKN1J8vU0TfhIgAOjLcR6iTrVvkDHhY5szz3BJMwBJ5hnK8KgZ/7ddHJ1HUm+AksWqilw7YUB8bNy+hZA+HmT/xcE3oVHirBHH1+A4BBJnm2S8IHAAAAAElFTkSuQmCC"

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Consumer = exports.Provider = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createReactContext = _interopRequireDefault(__webpack_require__(997));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// use the polyfill only if Context API not available (react<16)
var createContext = _react["default"].createContext || _createReactContext["default"];

var _createContext = createContext({}),
    Provider = _createContext.Provider,
    Consumer = _createContext.Consumer;

exports.Consumer = Consumer;
exports.Provider = Provider;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(998);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(999);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(96);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_LoggedInPage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_search_box__ = __webpack_require__(1001);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchboxComp=function(_LoggedInPage){_inherits(SearchboxComp,_LoggedInPage);function SearchboxComp(props){_classCallCheck(this,SearchboxComp);var _this=_possibleConstructorReturn(this,(SearchboxComp.__proto__||Object.getPrototypeOf(SearchboxComp)).call(this,props));_this.state={forceUpdater:1};_this.lessons=_this.processLessons(props.lessons)||[];_this.onSelect=_this.onSelect.bind(_this);_this.onFocus=_this.onFocus.bind(_this);_this.setWrapperRef=_this.setWrapperRef.bind(_this);_this.handleClickOutside=_this.handleClickOutside.bind(_this);return _this;}_createClass(SearchboxComp,[{key:'componentDidMount',value:function componentDidMount(){_get(SearchboxComp.prototype.__proto__||Object.getPrototypeOf(SearchboxComp.prototype),'componentDidMount',this).call(this);this.props.onRef(this);document.addEventListener('mousedown',this.handleClickOutside);}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.removeEventListener('mousedown',this.handleClickOutside);}},{key:'setWrapperRef',value:function setWrapperRef(node){this.wrapperRef=node;}},{key:'handleClickOutside',value:function handleClickOutside(event){try{if(this.wrapperRef&&!this.wrapperRef.contains(event.target)){this.setState({forceUpdater:this.state.forceUpdater+1});}}catch(e){console.error(e);}}},{key:'refresh',value:function refresh(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var lessonArr=[];if(data){lessonArr=this.processLessons(data);this.lessons=lessonArr;}this.setState({forceUpdater:this.state.forceUpdater+1});}},{key:'processLessons',value:function processLessons(lessons){if(lessons&&lessons.length>0){var me=this;var lessonData=[];lessons.map(function(lesson,ind){if(lesson){lesson["key"]=lesson.lessonname?lesson.lessonname.replace(/ /g,"").toLowerCase():lesson.lessonname;lesson["value"]=lesson.lessonname;lessonData.push(lesson);}});return lessonData;}return null;}},{key:'onFocus',value:function onFocus(lesson){}},{key:'getFuseConfigs',value:function getFuseConfigs(){return{threshold:0.15,minMatchCharLength:10,keys:['value'],location:15};}},{key:'onSelect',value:function onSelect(lesson){if(!lesson||!lesson.lessonurl){return;}var lessonidTracking=lesson.lessonid||lesson.lessonId;var lessonid=lesson.lessonUrl||lesson.lessonurl;var lessonname=lesson.lessonName||lesson.lessonname;var lurl=lesson.lessonUrl||lesson.lessonurl;var lessonPref=lesson.lessonType||lesson.lessontype||"";var dd=!isNaN(lesson.preferredDdId)?lesson.preferredDdId:!isNaN(lesson.lessondd)?lesson.lessondd:0;var accessId=!isNaN(lesson["classId"])?Number(lesson["classId"]):0;var classId=!isNaN(lesson["accessId"])?Number(lesson["accessId"]):0;var topicId=!isNaN(lesson["topicId"])?Number(lesson["topicId"]):0;var subTopicId=!isNaN(lesson["subTopicId"])?Number(lesson["subTopicId"]):0;var topicSubTopicMapId=!isNaN(lesson["topicSubTopicMapId"])?Number(lesson["topicSubTopicMapId"]):0;var lessonSrc=4;var _url="";if(lesson&&lesson.lessontype==="mozart"){_url="/mozartview/"+lessonid+"?url="+lurl+"&lessonPref="+lessonPref+"&accessId="+accessId+"&classId="+classId+"&lessonSrc="+lessonSrc+"&revisiontopicid="+topicSubTopicMapId;}else{_url="/lessonview/"+lessonid+"?url="+lurl+"&lessonPref="+lessonPref+"&accessId="+accessId+"&classId="+classId+"&lessonSrc="+lessonSrc+"&revisiontopicid="+topicSubTopicMapId;}if(dd>0){_url+="&dd="+dd;}window.open(_url,lessonid,'fullscreen=yes,menubar=no,width='+window.innerWidth+',height='+window.innerHeight).focus();this.setState({forceUpdater:this.state.forceUpdater+1});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'searchBox',ref:this.setWrapperRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_search_box__["a" /* default */],{key:this.state.forceUpdater,placeholder:'Search lessons here',value:'',inputBoxFontColor:'#000',inputBoxBorderColor:'#969696',data:this.lessons,onSelect:this.onSelect,onFocus:this.onFocus,callback:function callback(record){return console.log("searchBox::",record);},fuseConfigs:this.getFuseConfigs()})));}}]);return SearchboxComp;}(__WEBPACK_IMPORTED_MODULE_1__views_core_LoggedInPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (SearchboxComp);

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stream__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stream___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_stream__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);





function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x.default : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var fuse = createCommonjsModule(function (module, exports) {
/*!
 * Fuse.js v3.3.0 - Lightweight fuzzy-search (http://fusejs.io)
 * 
 * Copyright (c) 2012-2017 Kirollos Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 * 
 * http://www.apache.org/licenses/LICENSE-2.0
 */
(function webpackUniversalModuleDefinition(root, factory) {
	module.exports = factory();
})(commonjsGlobal, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = function (obj) {
  return !Array.isArray ? Object.prototype.toString.call(obj) === '[object Array]' : Array.isArray(obj);
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var bitapRegexSearch = __webpack_require__(5);
var bitapSearch = __webpack_require__(7);
var patternAlphabet = __webpack_require__(4);

var Bitap = function () {
  function Bitap(pattern, _ref) {
    var _ref$location = _ref.location,
        location = _ref$location === undefined ? 0 : _ref$location,
        _ref$distance = _ref.distance,
        distance = _ref$distance === undefined ? 100 : _ref$distance,
        _ref$threshold = _ref.threshold,
        threshold = _ref$threshold === undefined ? 0.6 : _ref$threshold,
        _ref$maxPatternLength = _ref.maxPatternLength,
        maxPatternLength = _ref$maxPatternLength === undefined ? 32 : _ref$maxPatternLength,
        _ref$isCaseSensitive = _ref.isCaseSensitive,
        isCaseSensitive = _ref$isCaseSensitive === undefined ? false : _ref$isCaseSensitive,
        _ref$tokenSeparator = _ref.tokenSeparator,
        tokenSeparator = _ref$tokenSeparator === undefined ? / +/g : _ref$tokenSeparator,
        _ref$findAllMatches = _ref.findAllMatches,
        findAllMatches = _ref$findAllMatches === undefined ? false : _ref$findAllMatches,
        _ref$minMatchCharLeng = _ref.minMatchCharLength,
        minMatchCharLength = _ref$minMatchCharLeng === undefined ? 1 : _ref$minMatchCharLeng;

    _classCallCheck(this, Bitap);

    this.options = {
      location: location,
      distance: distance,
      threshold: threshold,
      maxPatternLength: maxPatternLength,
      isCaseSensitive: isCaseSensitive,
      tokenSeparator: tokenSeparator,
      findAllMatches: findAllMatches,
      minMatchCharLength: minMatchCharLength
    };

    this.pattern = this.options.isCaseSensitive ? pattern : pattern.toLowerCase();

    if (this.pattern.length <= maxPatternLength) {
      this.patternAlphabet = patternAlphabet(this.pattern);
    }
  }

  _createClass(Bitap, [{
    key: 'search',
    value: function search(text) {
      if (!this.options.isCaseSensitive) {
        text = text.toLowerCase();
      }

      // Exact match
      if (this.pattern === text) {
        return {
          isMatch: true,
          score: 0,
          matchedIndices: [[0, text.length - 1]]
        };
      }

      // When pattern length is greater than the machine word length, just do a a regex comparison
      var _options = this.options,
          maxPatternLength = _options.maxPatternLength,
          tokenSeparator = _options.tokenSeparator;

      if (this.pattern.length > maxPatternLength) {
        return bitapRegexSearch(text, this.pattern, tokenSeparator);
      }

      // Otherwise, use Bitap algorithm
      var _options2 = this.options,
          location = _options2.location,
          distance = _options2.distance,
          threshold = _options2.threshold,
          findAllMatches = _options2.findAllMatches,
          minMatchCharLength = _options2.minMatchCharLength;

      return bitapSearch(text, this.pattern, this.patternAlphabet, {
        location: location,
        distance: distance,
        threshold: threshold,
        findAllMatches: findAllMatches,
        minMatchCharLength: minMatchCharLength
      });
    }
  }]);

  return Bitap;
}();

// let x = new Bitap("od mn war", {})
// let result = x.search("Old Man's War")
// console.log(result)

module.exports = Bitap;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {


var isArray = __webpack_require__(0);

var deepValue = function deepValue(obj, path, list) {
  if (!path) {
    // If there's no path left, we've gotten to the object we care about.
    list.push(obj);
  } else {
    var dotIndex = path.indexOf('.');
    var firstSegment = path;
    var remaining = null;

    if (dotIndex !== -1) {
      firstSegment = path.slice(0, dotIndex);
      remaining = path.slice(dotIndex + 1);
    }

    var value = obj[firstSegment];

    if (value !== null && value !== undefined) {
      if (!remaining && (typeof value === 'string' || typeof value === 'number')) {
        list.push(value.toString());
      } else if (isArray(value)) {
        // Search each item in the array.
        for (var i = 0, len = value.length; i < len; i += 1) {
          deepValue(value[i], remaining, list);
        }
      } else if (remaining) {
        // An object. Recurse further.
        deepValue(value, remaining, list);
      }
    }
  }

  return list;
};

module.exports = function (obj, path) {
  return deepValue(obj, path, []);
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = function () {
  var matchmask = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var minMatchCharLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var matchedIndices = [];
  var start = -1;
  var end = -1;
  var i = 0;

  for (var len = matchmask.length; i < len; i += 1) {
    var match = matchmask[i];
    if (match && start === -1) {
      start = i;
    } else if (!match && start !== -1) {
      end = i - 1;
      if (end - start + 1 >= minMatchCharLength) {
        matchedIndices.push([start, end]);
      }
      start = -1;
    }
  }

  // (i-1 - start) + 1 => i - start
  if (matchmask[i - 1] && i - start >= minMatchCharLength) {
    matchedIndices.push([start, i - 1]);
  }

  return matchedIndices;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = function (pattern) {
  var mask = {};
  var len = pattern.length;

  for (var i = 0; i < len; i += 1) {
    mask[pattern.charAt(i)] = 0;
  }

  for (var _i = 0; _i < len; _i += 1) {
    mask[pattern.charAt(_i)] |= 1 << len - _i - 1;
  }

  return mask;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {


var SPECIAL_CHARS_REGEX = /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g;

module.exports = function (text, pattern) {
  var tokenSeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : / +/g;

  var regex = new RegExp(pattern.replace(SPECIAL_CHARS_REGEX, '\\$&').replace(tokenSeparator, '|'));
  var matches = text.match(regex);
  var isMatch = !!matches;
  var matchedIndices = [];

  if (isMatch) {
    for (var i = 0, matchesLen = matches.length; i < matchesLen; i += 1) {
      var match = matches[i];
      matchedIndices.push([text.indexOf(match), match.length - 1]);
    }
  }

  return {
    // TODO: revisit this score
    score: isMatch ? 0.5 : 1,
    isMatch: isMatch,
    matchedIndices: matchedIndices
  };
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = function (pattern, _ref) {
  var _ref$errors = _ref.errors,
      errors = _ref$errors === undefined ? 0 : _ref$errors,
      _ref$currentLocation = _ref.currentLocation,
      currentLocation = _ref$currentLocation === undefined ? 0 : _ref$currentLocation,
      _ref$expectedLocation = _ref.expectedLocation,
      expectedLocation = _ref$expectedLocation === undefined ? 0 : _ref$expectedLocation,
      _ref$distance = _ref.distance,
      distance = _ref$distance === undefined ? 100 : _ref$distance;

  var accuracy = errors / pattern.length;
  var proximity = Math.abs(expectedLocation - currentLocation);

  if (!distance) {
    // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
  }

  return accuracy + proximity / distance;
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {


var bitapScore = __webpack_require__(6);
var matchedIndices = __webpack_require__(3);

module.exports = function (text, pattern, patternAlphabet, _ref) {
  var _ref$location = _ref.location,
      location = _ref$location === undefined ? 0 : _ref$location,
      _ref$distance = _ref.distance,
      distance = _ref$distance === undefined ? 100 : _ref$distance,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === undefined ? 0.6 : _ref$threshold,
      _ref$findAllMatches = _ref.findAllMatches,
      findAllMatches = _ref$findAllMatches === undefined ? false : _ref$findAllMatches,
      _ref$minMatchCharLeng = _ref.minMatchCharLength,
      minMatchCharLength = _ref$minMatchCharLeng === undefined ? 1 : _ref$minMatchCharLeng;

  var expectedLocation = location;
  // Set starting location at beginning text and initialize the alphabet.
  var textLen = text.length;
  // Highest score beyond which we give up.
  var currentThreshold = threshold;
  // Is there a nearby exact match? (speedup)
  var bestLocation = text.indexOf(pattern, expectedLocation);

  var patternLen = pattern.length;

  // a mask of the matches
  var matchMask = [];
  for (var i = 0; i < textLen; i += 1) {
    matchMask[i] = 0;
  }

  if (bestLocation !== -1) {
    var score = bitapScore(pattern, {
      errors: 0,
      currentLocation: bestLocation,
      expectedLocation: expectedLocation,
      distance: distance
    });
    currentThreshold = Math.min(score, currentThreshold);

    // What about in the other direction? (speed up)
    bestLocation = text.lastIndexOf(pattern, expectedLocation + patternLen);

    if (bestLocation !== -1) {
      var _score = bitapScore(pattern, {
        errors: 0,
        currentLocation: bestLocation,
        expectedLocation: expectedLocation,
        distance: distance
      });
      currentThreshold = Math.min(_score, currentThreshold);
    }
  }

  // Reset the best location
  bestLocation = -1;

  var lastBitArr = [];
  var finalScore = 1;
  var binMax = patternLen + textLen;

  var mask = 1 << patternLen - 1;

  for (var _i = 0; _i < patternLen; _i += 1) {
    // Scan for the best match; each iteration allows for one more error.
    // Run a binary search to determine how far from the match location we can stray
    // at this error level.
    var binMin = 0;
    var binMid = binMax;

    while (binMin < binMid) {
      var _score3 = bitapScore(pattern, {
        errors: _i,
        currentLocation: expectedLocation + binMid,
        expectedLocation: expectedLocation,
        distance: distance
      });

      if (_score3 <= currentThreshold) {
        binMin = binMid;
      } else {
        binMax = binMid;
      }

      binMid = Math.floor((binMax - binMin) / 2 + binMin);
    }

    // Use the result from this iteration as the maximum for the next.
    binMax = binMid;

    var start = Math.max(1, expectedLocation - binMid + 1);
    var finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;

    // Initialize the bit array
    var bitArr = Array(finish + 2);

    bitArr[finish + 1] = (1 << _i) - 1;

    for (var j = finish; j >= start; j -= 1) {
      var currentLocation = j - 1;
      var charMatch = patternAlphabet[text.charAt(currentLocation)];

      if (charMatch) {
        matchMask[currentLocation] = 1;
      }

      // First pass: exact match
      bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;

      // Subsequent passes: fuzzy match
      if (_i !== 0) {
        bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
      }

      if (bitArr[j] & mask) {
        finalScore = bitapScore(pattern, {
          errors: _i,
          currentLocation: currentLocation,
          expectedLocation: expectedLocation,
          distance: distance
        });

        // This match will almost certainly be better than any existing match.
        // But check anyway.
        if (finalScore <= currentThreshold) {
          // Indeed it is
          currentThreshold = finalScore;
          bestLocation = currentLocation;

          // Already passed `loc`, downhill from here on in.
          if (bestLocation <= expectedLocation) {
            break;
          }

          // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
          start = Math.max(1, 2 * expectedLocation - bestLocation);
        }
      }
    }

    // No hope for a (better) match at greater error levels.
    var _score2 = bitapScore(pattern, {
      errors: _i + 1,
      currentLocation: expectedLocation,
      expectedLocation: expectedLocation,
      distance: distance
    });

    // console.log('score', score, finalScore)

    if (_score2 > currentThreshold) {
      break;
    }

    lastBitArr = bitArr;
  }

  // console.log('FINAL SCORE', finalScore)

  // Count exact matches (those with a score of 0) to be "almost" exact
  return {
    isMatch: bestLocation >= 0,
    score: finalScore === 0 ? 0.001 : finalScore,
    matchedIndices: matchedIndices(matchMask, minMatchCharLength)
  };
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Bitap = __webpack_require__(1);
var deepValue = __webpack_require__(2);
var isArray = __webpack_require__(0);

var Fuse = function () {
  function Fuse(list, _ref) {
    var _ref$location = _ref.location,
        location = _ref$location === undefined ? 0 : _ref$location,
        _ref$distance = _ref.distance,
        distance = _ref$distance === undefined ? 100 : _ref$distance,
        _ref$threshold = _ref.threshold,
        threshold = _ref$threshold === undefined ? 0.6 : _ref$threshold,
        _ref$maxPatternLength = _ref.maxPatternLength,
        maxPatternLength = _ref$maxPatternLength === undefined ? 32 : _ref$maxPatternLength,
        _ref$caseSensitive = _ref.caseSensitive,
        caseSensitive = _ref$caseSensitive === undefined ? false : _ref$caseSensitive,
        _ref$tokenSeparator = _ref.tokenSeparator,
        tokenSeparator = _ref$tokenSeparator === undefined ? / +/g : _ref$tokenSeparator,
        _ref$findAllMatches = _ref.findAllMatches,
        findAllMatches = _ref$findAllMatches === undefined ? false : _ref$findAllMatches,
        _ref$minMatchCharLeng = _ref.minMatchCharLength,
        minMatchCharLength = _ref$minMatchCharLeng === undefined ? 1 : _ref$minMatchCharLeng,
        _ref$id = _ref.id,
        id = _ref$id === undefined ? null : _ref$id,
        _ref$keys = _ref.keys,
        keys = _ref$keys === undefined ? [] : _ref$keys,
        _ref$shouldSort = _ref.shouldSort,
        shouldSort = _ref$shouldSort === undefined ? true : _ref$shouldSort,
        _ref$getFn = _ref.getFn,
        getFn = _ref$getFn === undefined ? deepValue : _ref$getFn,
        _ref$sortFn = _ref.sortFn,
        sortFn = _ref$sortFn === undefined ? function (a, b) {
      return a.score - b.score;
    } : _ref$sortFn,
        _ref$tokenize = _ref.tokenize,
        tokenize = _ref$tokenize === undefined ? false : _ref$tokenize,
        _ref$matchAllTokens = _ref.matchAllTokens,
        matchAllTokens = _ref$matchAllTokens === undefined ? false : _ref$matchAllTokens,
        _ref$includeMatches = _ref.includeMatches,
        includeMatches = _ref$includeMatches === undefined ? false : _ref$includeMatches,
        _ref$includeScore = _ref.includeScore,
        includeScore = _ref$includeScore === undefined ? false : _ref$includeScore,
        _ref$verbose = _ref.verbose,
        verbose = _ref$verbose === undefined ? false : _ref$verbose;

    _classCallCheck(this, Fuse);

    this.options = {
      location: location,
      distance: distance,
      threshold: threshold,
      maxPatternLength: maxPatternLength,
      isCaseSensitive: caseSensitive,
      tokenSeparator: tokenSeparator,
      findAllMatches: findAllMatches,
      minMatchCharLength: minMatchCharLength,
      id: id,
      keys: keys,
      includeMatches: includeMatches,
      includeScore: includeScore,
      shouldSort: shouldSort,
      getFn: getFn,
      sortFn: sortFn,
      verbose: verbose,
      tokenize: tokenize,
      matchAllTokens: matchAllTokens
    };

    this.setCollection(list);
  }

  _createClass(Fuse, [{
    key: 'setCollection',
    value: function setCollection(list) {
      this.list = list;
      return list;
    }
  }, {
    key: 'search',
    value: function search(pattern) {
      this._log('---------\nSearch pattern: "' + pattern + '"');

      var _prepareSearchers2 = this._prepareSearchers(pattern),
          tokenSearchers = _prepareSearchers2.tokenSearchers,
          fullSearcher = _prepareSearchers2.fullSearcher;

      var _search2 = this._search(tokenSearchers, fullSearcher),
          weights = _search2.weights,
          results = _search2.results;

      this._computeScore(weights, results);

      if (this.options.shouldSort) {
        this._sort(results);
      }

      return this._format(results);
    }
  }, {
    key: '_prepareSearchers',
    value: function _prepareSearchers() {
      var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var tokenSearchers = [];

      if (this.options.tokenize) {
        // Tokenize on the separator
        var tokens = pattern.split(this.options.tokenSeparator);
        for (var i = 0, len = tokens.length; i < len; i += 1) {
          tokenSearchers.push(new Bitap(tokens[i], this.options));
        }
      }

      var fullSearcher = new Bitap(pattern, this.options);

      return { tokenSearchers: tokenSearchers, fullSearcher: fullSearcher };
    }
  }, {
    key: '_search',
    value: function _search() {
      var tokenSearchers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var fullSearcher = arguments[1];

      var list = this.list;
      var resultMap = {};
      var results = [];

      // Check the first item in the list, if it's a string, then we assume
      // that every item in the list is also a string, and thus it's a flattened array.
      if (typeof list[0] === 'string') {
        // Iterate over every item
        for (var i = 0, len = list.length; i < len; i += 1) {
          this._analyze({
            key: '',
            value: list[i],
            record: i,
            index: i
          }, {
            resultMap: resultMap,
            results: results,
            tokenSearchers: tokenSearchers,
            fullSearcher: fullSearcher
          });
        }

        return { weights: null, results: results };
      }

      // Otherwise, the first item is an Object (hopefully), and thus the searching
      // is done on the values of the keys of each item.
      var weights = {};
      for (var _i = 0, _len = list.length; _i < _len; _i += 1) {
        var item = list[_i];
        // Iterate over every key
        for (var j = 0, keysLen = this.options.keys.length; j < keysLen; j += 1) {
          var key = this.options.keys[j];
          if (typeof key !== 'string') {
            weights[key.name] = {
              weight: 1 - key.weight || 1
            };
            if (key.weight <= 0 || key.weight > 1) {
              throw new Error('Key weight has to be > 0 and <= 1');
            }
            key = key.name;
          } else {
            weights[key] = {
              weight: 1
            };
          }

          this._analyze({
            key: key,
            value: this.options.getFn(item, key),
            record: item,
            index: _i
          }, {
            resultMap: resultMap,
            results: results,
            tokenSearchers: tokenSearchers,
            fullSearcher: fullSearcher
          });
        }
      }

      return { weights: weights, results: results };
    }
  }, {
    key: '_analyze',
    value: function _analyze(_ref2, _ref3) {
      var key = _ref2.key,
          _ref2$arrayIndex = _ref2.arrayIndex,
          arrayIndex = _ref2$arrayIndex === undefined ? -1 : _ref2$arrayIndex,
          value = _ref2.value,
          record = _ref2.record,
          index = _ref2.index;
      var _ref3$tokenSearchers = _ref3.tokenSearchers,
          tokenSearchers = _ref3$tokenSearchers === undefined ? [] : _ref3$tokenSearchers,
          _ref3$fullSearcher = _ref3.fullSearcher,
          fullSearcher = _ref3$fullSearcher === undefined ? [] : _ref3$fullSearcher,
          _ref3$resultMap = _ref3.resultMap,
          resultMap = _ref3$resultMap === undefined ? {} : _ref3$resultMap,
          _ref3$results = _ref3.results,
          results = _ref3$results === undefined ? [] : _ref3$results;

      // Check if the texvaluet can be searched
      if (value === undefined || value === null) {
        return;
      }

      var exists = false;
      var averageScore = -1;
      var numTextMatches = 0;

      if (typeof value === 'string') {
        this._log('\nKey: ' + (key === '' ? '-' : key));

        var mainSearchResult = fullSearcher.search(value);
        this._log('Full text: "' + value + '", score: ' + mainSearchResult.score);

        if (this.options.tokenize) {
          var words = value.split(this.options.tokenSeparator);
          var scores = [];

          for (var i = 0; i < tokenSearchers.length; i += 1) {
            var tokenSearcher = tokenSearchers[i];

            this._log('\nPattern: "' + tokenSearcher.pattern + '"');

            // let tokenScores = []
            var hasMatchInText = false;

            for (var j = 0; j < words.length; j += 1) {
              var word = words[j];
              var tokenSearchResult = tokenSearcher.search(word);
              var obj = {};
              if (tokenSearchResult.isMatch) {
                obj[word] = tokenSearchResult.score;
                exists = true;
                hasMatchInText = true;
                scores.push(tokenSearchResult.score);
              } else {
                obj[word] = 1;
                if (!this.options.matchAllTokens) {
                  scores.push(1);
                }
              }
              this._log('Token: "' + word + '", score: ' + obj[word]);
              // tokenScores.push(obj)
            }

            if (hasMatchInText) {
              numTextMatches += 1;
            }
          }

          averageScore = scores[0];
          var scoresLen = scores.length;
          for (var _i2 = 1; _i2 < scoresLen; _i2 += 1) {
            averageScore += scores[_i2];
          }
          averageScore = averageScore / scoresLen;

          this._log('Token score average:', averageScore);
        }

        var finalScore = mainSearchResult.score;
        if (averageScore > -1) {
          finalScore = (finalScore + averageScore) / 2;
        }

        this._log('Score average:', finalScore);

        var checkTextMatches = this.options.tokenize && this.options.matchAllTokens ? numTextMatches >= tokenSearchers.length : true;

        this._log('\nCheck Matches: ' + checkTextMatches);

        // If a match is found, add the item to <rawResults>, including its score
        if ((exists || mainSearchResult.isMatch) && checkTextMatches) {
          // Check if the item already exists in our results
          var existingResult = resultMap[index];
          if (existingResult) {
            // Use the lowest score
            // existingResult.score, bitapResult.score
            existingResult.output.push({
              key: key,
              arrayIndex: arrayIndex,
              value: value,
              score: finalScore,
              matchedIndices: mainSearchResult.matchedIndices
            });
          } else {
            // Add it to the raw result list
            resultMap[index] = {
              item: record,
              output: [{
                key: key,
                arrayIndex: arrayIndex,
                value: value,
                score: finalScore,
                matchedIndices: mainSearchResult.matchedIndices
              }]
            };

            results.push(resultMap[index]);
          }
        }
      } else if (isArray(value)) {
        for (var _i3 = 0, len = value.length; _i3 < len; _i3 += 1) {
          this._analyze({
            key: key,
            arrayIndex: _i3,
            value: value[_i3],
            record: record,
            index: index
          }, {
            resultMap: resultMap,
            results: results,
            tokenSearchers: tokenSearchers,
            fullSearcher: fullSearcher
          });
        }
      }
    }
  }, {
    key: '_computeScore',
    value: function _computeScore(weights, results) {
      this._log('\n\nComputing score:\n');

      for (var i = 0, len = results.length; i < len; i += 1) {
        var output = results[i].output;
        var scoreLen = output.length;

        var currScore = 1;
        var bestScore = 1;

        for (var j = 0; j < scoreLen; j += 1) {
          var weight = weights ? weights[output[j].key].weight : 1;
          var score = weight === 1 ? output[j].score : output[j].score || 0.001;
          var nScore = score * weight;

          if (weight !== 1) {
            bestScore = Math.min(bestScore, nScore);
          } else {
            output[j].nScore = nScore;
            currScore *= nScore;
          }
        }

        results[i].score = bestScore === 1 ? currScore : bestScore;

        this._log(results[i]);
      }
    }
  }, {
    key: '_sort',
    value: function _sort(results) {
      this._log('\n\nSorting....');
      results.sort(this.options.sortFn);
    }
  }, {
    key: '_format',
    value: function _format(results) {
      var finalOutput = [];

      if (this.options.verbose) {
        this._log('\n\nOutput:\n\n', JSON.stringify(results));
      }

      var transformers = [];

      if (this.options.includeMatches) {
        transformers.push(function (result, data) {
          var output = result.output;
          data.matches = [];

          for (var i = 0, len = output.length; i < len; i += 1) {
            var item = output[i];

            if (item.matchedIndices.length === 0) {
              continue;
            }

            var obj = {
              indices: item.matchedIndices,
              value: item.value
            };
            if (item.key) {
              obj.key = item.key;
            }
            if (item.hasOwnProperty('arrayIndex') && item.arrayIndex > -1) {
              obj.arrayIndex = item.arrayIndex;
            }
            data.matches.push(obj);
          }
        });
      }

      if (this.options.includeScore) {
        transformers.push(function (result, data) {
          data.score = result.score;
        });
      }

      for (var i = 0, len = results.length; i < len; i += 1) {
        var result = results[i];

        if (this.options.id) {
          result.item = this.options.getFn(result.item, this.options.id)[0];
        }

        if (!transformers.length) {
          finalOutput.push(result.item);
          continue;
        }

        var data = {
          item: result.item
        };

        for (var j = 0, _len2 = transformers.length; j < _len2; j += 1) {
          transformers[j](result, data);
        }

        finalOutput.push(data);
      }

      return finalOutput;
    }
  }, {
    key: '_log',
    value: function _log() {
      if (this.options.verbose) {
        var _console;

        (_console = console).log.apply(_console, arguments);
      }
    }
  }]);

  return Fuse;
}();

module.exports = Fuse;

/***/ })
/******/ ]);
});

});

var Fuse = unwrapExports(fuse);

var stylis_min = createCommonjsModule(function (module, exports) {
!function(e){module.exports=e(null);}(function e(a){var r=/^\0+/g,c=/[\0\r\f]/g,s=/: */g,t=/zoo|gra/,i=/([,: ])(transform)/g,f=/,+\s*(?![^(]*[)])/g,n=/ +\s*(?![^(]*[)])/g,l=/ *[\0] */g,o=/,\r+?/g,h=/([\t\r\n ])*\f?&/g,u=/:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,d=/\W+/g,b=/@(k\w+)\s*(\S*)\s*/,p=/::(place)/g,k=/:(read-only)/g,g=/\s+(?=[{\];=:>])/g,A=/([[}=:>])\s+/g,C=/(\{[^{]+?);(?=\})/g,w=/\s{2,}/g,v=/([^\(])(:+) */g,m=/[svh]\w+-[tblr]{2}/,x=/\(\s*(.*)\s*\)/g,$=/([\s\S]*?);/g,y=/-self|flex-/g,O=/[^]*?(:[rp][el]a[\w-]+)[^]*/,j=/stretch|:\s*\w+\-(?:conte|avail)/,z=/([^-])(image-set\()/,N="-webkit-",S="-moz-",F="-ms-",W=59,q=125,B=123,D=40,E=41,G=91,H=93,I=10,J=13,K=9,L=64,M=32,P=38,Q=45,R=95,T=42,U=44,V=58,X=39,Y=34,Z=47,_=62,ee=43,ae=126,re=0,ce=12,se=11,te=107,ie=109,fe=115,ne=112,le=111,oe=105,he=99,ue=100,de=112,be=1,pe=1,ke=0,ge=1,Ae=1,Ce=1,we=0,ve=0,me=0,xe=[],$e=[],ye=0,Oe=null,je=-2,ze=-1,Ne=0,Se=1,Fe=2,We=3,qe=0,Be=1,De="",Ee="",Ge="";function He(e,a,s,t,i){for(var f,n,o=0,h=0,u=0,d=0,g=0,A=0,C=0,w=0,m=0,$=0,y=0,O=0,j=0,z=0,R=0,we=0,$e=0,Oe=0,je=0,ze=s.length,Je=ze-1,Re="",Te="",Ue="",Ve="",Xe="",Ye="";R<ze;){if(C=s.charCodeAt(R),R===Je)if(h+d+u+o!==0){if(0!==h)C=h===Z?I:Z;d=u=o=0,ze++,Je++;}if(h+d+u+o===0){if(R===Je){if(we>0)Te=Te.replace(c,"");if(Te.trim().length>0){switch(C){case M:case K:case W:case J:case I:break;default:Te+=s.charAt(R);}C=W;}}if(1===$e)switch(C){case B:case q:case W:case Y:case X:case D:case E:case U:$e=0;case K:case J:case I:case M:break;default:for($e=0,je=R,g=C,R--,C=W;je<ze;)switch(s.charCodeAt(je++)){case I:case J:case W:++R,C=g,je=ze;break;case V:if(we>0)++R,C=g;case B:je=ze;}}switch(C){case B:for(g=(Te=Te.trim()).charCodeAt(0),y=1,je=++R;R<ze;){switch(C=s.charCodeAt(R)){case B:y++;break;case q:y--;break;case Z:switch(A=s.charCodeAt(R+1)){case T:case Z:R=Qe(A,R,Je,s);}break;case G:C++;case D:C++;case Y:case X:for(;R++<Je&&s.charCodeAt(R)!==C;);}if(0===y)break;R++;}if(Ue=s.substring(je,R),g===re)g=(Te=Te.replace(r,"").trim()).charCodeAt(0);switch(g){case L:if(we>0)Te=Te.replace(c,"");switch(A=Te.charCodeAt(1)){case ue:case ie:case fe:case Q:f=a;break;default:f=xe;}if(je=(Ue=He(a,f,Ue,A,i+1)).length,me>0&&0===je)je=Te.length;if(ye>0)if(f=Ie(xe,Te,Oe),n=Pe(We,Ue,f,a,pe,be,je,A,i,t),Te=f.join(""),void 0!==n)if(0===(je=(Ue=n.trim()).length))A=0,Ue="";if(je>0)switch(A){case fe:Te=Te.replace(x,Me);case ue:case ie:case Q:Ue=Te+"{"+Ue+"}";break;case te:if(Ue=(Te=Te.replace(b,"$1 $2"+(Be>0?De:"")))+"{"+Ue+"}",1===Ae||2===Ae&&Le("@"+Ue,3))Ue="@"+N+Ue+"@"+Ue;else Ue="@"+Ue;break;default:if(Ue=Te+Ue,t===de)Ve+=Ue,Ue="";}else Ue="";break;default:Ue=He(a,Ie(a,Te,Oe),Ue,t,i+1);}Xe+=Ue,O=0,$e=0,z=0,we=0,Oe=0,j=0,Te="",Ue="",C=s.charCodeAt(++R);break;case q:case W:if((je=(Te=(we>0?Te.replace(c,""):Te).trim()).length)>1){if(0===z)if((g=Te.charCodeAt(0))===Q||g>96&&g<123)je=(Te=Te.replace(" ",":")).length;if(ye>0)if(void 0!==(n=Pe(Se,Te,a,e,pe,be,Ve.length,t,i,t)))if(0===(je=(Te=n.trim()).length))Te="\0\0";switch(g=Te.charCodeAt(0),A=Te.charCodeAt(1),g){case re:break;case L:if(A===oe||A===he){Ye+=Te+s.charAt(R);break}default:if(Te.charCodeAt(je-1)===V)break;Ve+=Ke(Te,g,A,Te.charCodeAt(2));}}O=0,$e=0,z=0,we=0,Oe=0,Te="",C=s.charCodeAt(++R);}}switch(C){case J:case I:if(h+d+u+o+ve===0)switch($){case E:case X:case Y:case L:case ae:case _:case T:case ee:case Z:case Q:case V:case U:case W:case B:case q:break;default:if(z>0)$e=1;}if(h===Z)h=0;else if(ge+O===0&&t!==te&&Te.length>0)we=1,Te+="\0";if(ye*qe>0)Pe(Ne,Te,a,e,pe,be,Ve.length,t,i,t);be=1,pe++;break;case W:case q:if(h+d+u+o===0){be++;break}default:switch(be++,Re=s.charAt(R),C){case K:case M:if(d+o+h===0)switch(w){case U:case V:case K:case M:Re="";break;default:if(C!==M)Re=" ";}break;case re:Re="\\0";break;case ce:Re="\\f";break;case se:Re="\\v";break;case P:if(d+h+o===0&&ge>0)Oe=1,we=1,Re="\f"+Re;break;case 108:if(d+h+o+ke===0&&z>0)switch(R-z){case 2:if(w===ne&&s.charCodeAt(R-3)===V)ke=w;case 8:if(m===le)ke=m;}break;case V:if(d+h+o===0)z=R;break;case U:if(h+u+d+o===0)we=1,Re+="\r";break;case Y:case X:if(0===h)d=d===C?0:0===d?C:d;break;case G:if(d+h+u===0)o++;break;case H:if(d+h+u===0)o--;break;case E:if(d+h+o===0)u--;break;case D:if(d+h+o===0){if(0===O)switch(2*w+3*m){case 533:break;default:y=0,O=1;}u++;}break;case L:if(h+u+d+o+z+j===0)j=1;break;case T:case Z:if(d+o+u>0)break;switch(h){case 0:switch(2*C+3*s.charCodeAt(R+1)){case 235:h=Z;break;case 220:je=R,h=T;}break;case T:if(C===Z&&w===T&&je+2!==R){if(33===s.charCodeAt(je+2))Ve+=s.substring(je,R+1);Re="",h=0;}}}if(0===h){if(ge+d+o+j===0&&t!==te&&C!==W)switch(C){case U:case ae:case _:case ee:case E:case D:if(0===O){switch(w){case K:case M:case I:case J:Re+="\0";break;default:Re="\0"+Re+(C===U?"":"\0");}we=1;}else switch(C){case D:if(z+7===R&&108===w)z=0;O=++y;break;case E:if(0==(O=--y))we=1,Re+="\0";}break;case K:case M:switch(w){case re:case B:case q:case W:case U:case ce:case K:case M:case I:case J:break;default:if(0===O)we=1,Re+="\0";}}if(Te+=Re,C!==M&&C!==K)$=C;}}m=w,w=C,R++;}if(je=Ve.length,me>0)if(0===je&&0===Xe.length&&0===a[0].length==false)if(t!==ie||1===a.length&&(ge>0?Ee:Ge)===a[0])je=a.join(",").length+2;if(je>0){if(f=0===ge&&t!==te?function(e){for(var a,r,s=0,t=e.length,i=Array(t);s<t;++s){for(var f=e[s].split(l),n="",o=0,h=0,u=0,d=0,b=f.length;o<b;++o){if(0===(h=(r=f[o]).length)&&b>1)continue;if(u=n.charCodeAt(n.length-1),d=r.charCodeAt(0),a="",0!==o)switch(u){case T:case ae:case _:case ee:case M:case D:break;default:a=" ";}switch(d){case P:r=a+Ee;case ae:case _:case ee:case M:case E:case D:break;case G:r=a+r+Ee;break;case V:switch(2*r.charCodeAt(1)+3*r.charCodeAt(2)){case 530:if(Ce>0){r=a+r.substring(8,h-1);break}default:if(o<1||f[o-1].length<1)r=a+Ee+r;}break;case U:a="";default:if(h>1&&r.indexOf(":")>0)r=a+r.replace(v,"$1"+Ee+"$2");else r=a+r+Ee;}n+=r;}i[s]=n.replace(c,"").trim();}return i}(a):a,ye>0)if(void 0!==(n=Pe(Fe,Ve,f,e,pe,be,je,t,i,t))&&0===(Ve=n).length)return Ye+Ve+Xe;if(Ve=f.join(",")+"{"+Ve+"}",Ae*ke!=0){if(2===Ae&&!Le(Ve,2))ke=0;switch(ke){case le:Ve=Ve.replace(k,":"+S+"$1")+Ve;break;case ne:Ve=Ve.replace(p,"::"+N+"input-$1")+Ve.replace(p,"::"+S+"$1")+Ve.replace(p,":"+F+"input-$1")+Ve;}ke=0;}}return Ye+Ve+Xe}function Ie(e,a,r){var c=a.trim().split(o),s=c,t=c.length,i=e.length;switch(i){case 0:case 1:for(var f=0,n=0===i?"":e[0]+" ";f<t;++f)s[f]=Je(n,s[f],r,i).trim();break;default:f=0;var l=0;for(s=[];f<t;++f)for(var h=0;h<i;++h)s[l++]=Je(e[h]+" ",c[f],r,i).trim();}return s}function Je(e,a,r,c){var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);switch(t){case P:switch(ge+c){case 0:case 1:if(0===e.trim().length)break;default:return s.replace(h,"$1"+e.trim())}break;case V:switch(s.charCodeAt(1)){case 103:if(Ce>0&&ge>0)return s.replace(u,"$1").replace(h,"$1"+Ge);break;default:return e.trim()+s.replace(h,"$1"+e.trim())}default:if(r*ge>0&&s.indexOf("\f")>0)return s.replace(h,(e.charCodeAt(0)===V?"":"$1")+e.trim())}return e+s}function Ke(e,a,r,c){var l,o=0,h=e+";",u=2*a+3*r+4*c;if(944===u)return function(e){var a=e.length,r=e.indexOf(":",9)+1,c=e.substring(0,r).trim(),s=e.substring(r,a-1).trim();switch(e.charCodeAt(9)*Be){case 0:break;case Q:if(110!==e.charCodeAt(10))break;default:for(var t=s.split((s="",f)),i=0,r=0,a=t.length;i<a;r=0,++i){for(var l=t[i],o=l.split(n);l=o[r];){var h=l.charCodeAt(0);if(1===Be&&(h>L&&h<90||h>96&&h<123||h===R||h===Q&&l.charCodeAt(1)!==Q))switch(isNaN(parseFloat(l))+(-1!==l.indexOf("("))){case 1:switch(l){case"infinite":case"alternate":case"backwards":case"running":case"normal":case"forwards":case"both":case"none":case"linear":case"ease":case"ease-in":case"ease-out":case"ease-in-out":case"paused":case"reverse":case"alternate-reverse":case"inherit":case"initial":case"unset":case"step-start":case"step-end":break;default:l+=De;}}o[r++]=l;}s+=(0===i?"":",")+o.join(" ");}}if(s=c+s+";",1===Ae||2===Ae&&Le(s,1))return N+s+s;return s}(h);else if(0===Ae||2===Ae&&!Le(h,1))return h;switch(u){case 1015:return 97===h.charCodeAt(10)?N+h+h:h;case 951:return 116===h.charCodeAt(3)?N+h+h:h;case 963:return 110===h.charCodeAt(5)?N+h+h:h;case 1009:if(100!==h.charCodeAt(4))break;case 969:case 942:return N+h+h;case 978:return N+h+S+h+h;case 1019:case 983:return N+h+S+h+F+h+h;case 883:if(h.charCodeAt(8)===Q)return N+h+h;if(h.indexOf("image-set(",11)>0)return h.replace(z,"$1"+N+"$2")+h;return h;case 932:if(h.charCodeAt(4)===Q)switch(h.charCodeAt(5)){case 103:return N+"box-"+h.replace("-grow","")+N+h+F+h.replace("grow","positive")+h;case 115:return N+h+F+h.replace("shrink","negative")+h;case 98:return N+h+F+h.replace("basis","preferred-size")+h}return N+h+F+h+h;case 964:return N+h+F+"flex-"+h+h;case 1023:if(99!==h.charCodeAt(8))break;return l=h.substring(h.indexOf(":",15)).replace("flex-","").replace("space-between","justify"),N+"box-pack"+l+N+h+F+"flex-pack"+l+h;case 1005:return t.test(h)?h.replace(s,":"+N)+h.replace(s,":"+S)+h:h;case 1e3:switch(o=(l=h.substring(13).trim()).indexOf("-")+1,l.charCodeAt(0)+l.charCodeAt(o)){case 226:l=h.replace(m,"tb");break;case 232:l=h.replace(m,"tb-rl");break;case 220:l=h.replace(m,"lr");break;default:return h}return N+h+F+l+h;case 1017:if(-1===h.indexOf("sticky",9))return h;case 975:switch(o=(h=e).length-10,u=(l=(33===h.charCodeAt(o)?h.substring(0,o):h).substring(e.indexOf(":",7)+1).trim()).charCodeAt(0)+(0|l.charCodeAt(7))){case 203:if(l.charCodeAt(8)<111)break;case 115:h=h.replace(l,N+l)+";"+h;break;case 207:case 102:h=h.replace(l,N+(u>102?"inline-":"")+"box")+";"+h.replace(l,N+l)+";"+h.replace(l,F+l+"box")+";"+h;}return h+";";case 938:if(h.charCodeAt(5)===Q)switch(h.charCodeAt(6)){case 105:return l=h.replace("-items",""),N+h+N+"box-"+l+F+"flex-"+l+h;case 115:return N+h+F+"flex-item-"+h.replace(y,"")+h;default:return N+h+F+"flex-line-pack"+h.replace("align-content","").replace(y,"")+h}break;case 973:case 989:if(h.charCodeAt(3)!==Q||122===h.charCodeAt(4))break;case 931:case 953:if(true===j.test(e))if(115===(l=e.substring(e.indexOf(":")+1)).charCodeAt(0))return Ke(e.replace("stretch","fill-available"),a,r,c).replace(":fill-available",":stretch");else return h.replace(l,N+l)+h.replace(l,S+l.replace("fill-",""))+h;break;case 962:if(h=N+h+(102===h.charCodeAt(5)?F+h:"")+h,r+c===211&&105===h.charCodeAt(13)&&h.indexOf("transform",10)>0)return h.substring(0,h.indexOf(";",27)+1).replace(i,"$1"+N+"$2")+h}return h}function Le(e,a){var r=e.indexOf(1===a?":":"{"),c=e.substring(0,3!==a?r:10),s=e.substring(r+1,e.length-1);return Oe(2!==a?c:c.replace(O,"$1"),s,a)}function Me(e,a){var r=Ke(a,a.charCodeAt(0),a.charCodeAt(1),a.charCodeAt(2));return r!==a+";"?r.replace($," or ($1)").substring(4):"("+a+")"}function Pe(e,a,r,c,s,t,i,f,n,l){for(var o,h=0,u=a;h<ye;++h)switch(o=$e[h].call(Te,e,u,r,c,s,t,i,f,n,l)){case void 0:case false:case true:case null:break;default:u=o;}if(u!==a)return u}function Qe(e,a,r,c){for(var s=a+1;s<r;++s)switch(c.charCodeAt(s)){case Z:if(e===T)if(c.charCodeAt(s-1)===T&&a+2!==s)return s+1;break;case I:if(e===Z)return s+1}return s}function Re(e){for(var a in e){var r=e[a];switch(a){case"keyframe":Be=0|r;break;case"global":Ce=0|r;break;case"cascade":ge=0|r;break;case"compress":we=0|r;break;case"semicolon":ve=0|r;break;case"preserve":me=0|r;break;case"prefix":if(Oe=null,!r)Ae=0;else if("function"!=typeof r)Ae=1;else Ae=2,Oe=r;}}return Re}function Te(a,r){if(void 0!==this&&this.constructor===Te)return e(a);var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);if(Be>0)De=s.replace(d,t===G?"":"-");if(t=1,1===ge)Ge=s;else Ee=s;var i,f=[Ge];if(ye>0)if(void 0!==(i=Pe(ze,r,f,f,pe,be,0,0,0,0))&&"string"==typeof i)r=i;var n=He(xe,f,r,0,0);if(ye>0)if(void 0!==(i=Pe(je,n,f,f,pe,be,n.length,0,0,0))&&"string"!=typeof(n=i))t=0;return De="",Ge="",Ee="",ke=0,pe=1,be=1,we*t==0?n:n.replace(c,"").replace(g,"").replace(A,"$1").replace(C,"$1").replace(w," ")}if(Te.use=function e(a){switch(a){case void 0:case null:ye=$e.length=0;break;default:if("function"==typeof a)$e[ye++]=a;else if("object"==typeof a)for(var r=0,c=a.length;r<c;++r)e(a[r]);else qe=0|!!a;}return e},Te.set=Re,void 0!==a)Re(a);return Te});

});

var stylisRuleSheet = createCommonjsModule(function (module, exports) {
(function (factory) {
	module['exports'] = factory();
}(function () {

	return function (insertRule) {
		var delimiter = '/*|*/';
		var needle = delimiter+'}';

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}');
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet);
			}
		}
	}
}));
});

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var reactIs_production_min = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};
});

unwrapExports(reactIs_production_min);
var reactIs_production_min_1 = reactIs_production_min.typeOf;
var reactIs_production_min_2 = reactIs_production_min.AsyncMode;
var reactIs_production_min_3 = reactIs_production_min.ConcurrentMode;
var reactIs_production_min_4 = reactIs_production_min.ContextConsumer;
var reactIs_production_min_5 = reactIs_production_min.ContextProvider;
var reactIs_production_min_6 = reactIs_production_min.Element;
var reactIs_production_min_7 = reactIs_production_min.ForwardRef;
var reactIs_production_min_8 = reactIs_production_min.Fragment;
var reactIs_production_min_9 = reactIs_production_min.Lazy;
var reactIs_production_min_10 = reactIs_production_min.Memo;
var reactIs_production_min_11 = reactIs_production_min.Portal;
var reactIs_production_min_12 = reactIs_production_min.Profiler;
var reactIs_production_min_13 = reactIs_production_min.StrictMode;
var reactIs_production_min_14 = reactIs_production_min.Suspense;
var reactIs_production_min_15 = reactIs_production_min.isValidElementType;
var reactIs_production_min_16 = reactIs_production_min.isAsyncMode;
var reactIs_production_min_17 = reactIs_production_min.isConcurrentMode;
var reactIs_production_min_18 = reactIs_production_min.isContextConsumer;
var reactIs_production_min_19 = reactIs_production_min.isContextProvider;
var reactIs_production_min_20 = reactIs_production_min.isElement;
var reactIs_production_min_21 = reactIs_production_min.isForwardRef;
var reactIs_production_min_22 = reactIs_production_min.isFragment;
var reactIs_production_min_23 = reactIs_production_min.isLazy;
var reactIs_production_min_24 = reactIs_production_min.isMemo;
var reactIs_production_min_25 = reactIs_production_min.isPortal;
var reactIs_production_min_26 = reactIs_production_min.isProfiler;
var reactIs_production_min_27 = reactIs_production_min.isStrictMode;
var reactIs_production_min_28 = reactIs_production_min.isSuspense;

var reactIs_development = createCommonjsModule(function (module, exports) {



if (false) {
  (function() {

Object.defineProperty(exports, '__esModule', { value: true });

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;

var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' ||
  // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE);
}

/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

{
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`lowPriorityWarning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

var lowPriorityWarning$1 = lowPriorityWarning;

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;
    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;
          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;
              default:
                return $$typeof;
            }
        }
      case REACT_LAZY_TYPE:
      case REACT_MEMO_TYPE:
      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}

// AsyncMode is deprecated along with isAsyncMode
var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;

var hasWarnedAboutDeprecatedIsAsyncMode = false;

// AsyncMode should be deprecated
function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true;
      lowPriorityWarning$1(false, 'The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }
  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.typeOf = typeOf;
exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isValidElementType = isValidElementType;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
  })();
}
});

unwrapExports(reactIs_development);
var reactIs_development_1 = reactIs_development.typeOf;
var reactIs_development_2 = reactIs_development.AsyncMode;
var reactIs_development_3 = reactIs_development.ConcurrentMode;
var reactIs_development_4 = reactIs_development.ContextConsumer;
var reactIs_development_5 = reactIs_development.ContextProvider;
var reactIs_development_6 = reactIs_development.Element;
var reactIs_development_7 = reactIs_development.ForwardRef;
var reactIs_development_8 = reactIs_development.Fragment;
var reactIs_development_9 = reactIs_development.Lazy;
var reactIs_development_10 = reactIs_development.Memo;
var reactIs_development_11 = reactIs_development.Portal;
var reactIs_development_12 = reactIs_development.Profiler;
var reactIs_development_13 = reactIs_development.StrictMode;
var reactIs_development_14 = reactIs_development.Suspense;
var reactIs_development_15 = reactIs_development.isValidElementType;
var reactIs_development_16 = reactIs_development.isAsyncMode;
var reactIs_development_17 = reactIs_development.isConcurrentMode;
var reactIs_development_18 = reactIs_development.isContextConsumer;
var reactIs_development_19 = reactIs_development.isContextProvider;
var reactIs_development_20 = reactIs_development.isElement;
var reactIs_development_21 = reactIs_development.isForwardRef;
var reactIs_development_22 = reactIs_development.isFragment;
var reactIs_development_23 = reactIs_development.isLazy;
var reactIs_development_24 = reactIs_development.isMemo;
var reactIs_development_25 = reactIs_development.isPortal;
var reactIs_development_26 = reactIs_development.isProfiler;
var reactIs_development_27 = reactIs_development.isStrictMode;
var reactIs_development_28 = reactIs_development.isSuspense;

var reactIs = createCommonjsModule(function (module) {

if (true) {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});
var reactIs_1 = reactIs.isElement;
var reactIs_2 = reactIs.isValidElementType;
var reactIs_3 = reactIs.ForwardRef;

var simpleIsEqual = function simpleIsEqual(a, b) {
  return a === b;
};

function index (resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = simpleIsEqual;
  }

  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;

  var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
    return isEqual(newArg, lastArgs[index], index);
  };

  var result = function result() {
    for (var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      newArgs[_key] = arguments[_key];
    }

    if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
      return lastResult;
    }

    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  };

  return result;
}

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index$1 = memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

var _typeof$1 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof$1(x)) === 'object' && x.constructor === Object;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 
function isFunction(test) {
  return typeof test === 'function';
}

// 

function getComponentName(target) {
  return ( false ? typeof target === 'string' && target : false) || target.displayName || target.name || 'Component';
}

// 
function isStyledComponent(target) {
  return target && typeof target.styledComponentId === 'string';
}

// 

var SC_ATTR = typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_FILE_VERSION":"10"}).SC_ATTR || 'data-styled';

var SC_VERSION_ATTR = 'data-styled-version';

var SC_STREAM_ATTR = 'data-styled-streamed';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = typeof SC_DISABLE_SPEEDY === 'boolean' && SC_DISABLE_SPEEDY || "production" !== 'production';

// Shared empty execution context when generating static styles
var STATIC_EXECUTION_CONTEXT = {};

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? {
  "1": "Cannot create styled-component for component: %s.\n\n",
  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
  "5": "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
  "9": "Missing document `<head>`\n\n",
  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  "11": "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
  "12": "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper (see https://www.styled-components.com/docs/api#css), which ensures the styles are injected correctly.\n\n",
  "13": "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n"
} : {};

/**
 * super basic version of sprintf
 */
function format() {
  var a = arguments.length <= 0 ? undefined : arguments[0];
  var b = [];

  for (var c = 1, len = arguments.length; c < len; c += 1) {
    b.push(arguments.length <= c ? undefined : arguments[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
    } else {
      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations)).trim()));
    }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new stylis_min({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new stylis_min({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];

// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = stylisRuleSheet(function (rule) {
  parsingRules.push(rule);
});

var _componentId = void 0;
var _selector = void 0;
var _selectorRegexp = void 0;

var selfReferenceReplacer = function selfReferenceReplacer(match, offset, string) {
  if (
  // the first self-ref is always untouched
  offset > 0 &&
  // there should be at least two self-refs to do a replacement (.b > .b)
  string.slice(0, offset).indexOf(_selector) !== -1 &&
  // no consecutive self refs (.b.b); that is a precedence boost and treated differently
  string.slice(offset - _selector.length, offset) !== _selector) {
    return '.' + _componentId;
  }

  return match;
};

/**
 * When writing a style like
 *
 * & + & {
 *   color: red;
 * }
 *
 * The second ampersand should be a reference to the static component class. stylis
 * has no knowledge of static class so we have to intelligently replace the base selector.
 */
var selfReferenceReplacementPlugin = function selfReferenceReplacementPlugin(context, _, selectors) {
  if (context === 2 && selectors.length && selectors[0].lastIndexOf(_selector) > 0) {
    // eslint-disable-next-line no-param-reassign
    selectors[0] = selectors[0].replace(_selectorRegexp, selfReferenceReplacer);
  }
};

stylis.use([selfReferenceReplacementPlugin, parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

function stringifyRules(rules, selector, prefix) {
  var componentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '&';

  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  // stylis has no concept of state to be passed to plugins
  // but since JS is single=threaded, we can rely on that to ensure
  // these properties stay in sync with the current stylis run
  _componentId = componentId;
  _selector = selector;
  _selectorRegexp = new RegExp('\\' + _selector + '\\b', 'g');

  return stylis(prefix || !selector ? '' : selector, cssStr);
}

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends$1({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = document.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = document.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index$$1) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index$$1 <= maxIndex ? index$$1 : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index$$1) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index$$1; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var el = document.createElement('style');
  el.setAttribute(SC_ATTR, '');
  el.setAttribute(SC_VERSION_ATTR, "4.1.3");

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(document.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', SC_VERSION_ATTR + '="' + "4.1.3" + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props[SC_VERSION_ATTR] = "4.1.3", _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('style', _extends$1({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whether getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker) - 1;
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(id) {
  return document.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whether getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTag = function makeServerTag(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTag(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

var rehydrate = function rehydrate(tag, els, extracted) {
  /* add all extracted components to the new tag */
  for (var i = 0, len = extracted.length; i < len; i += 1) {
    var _extracted$i = extracted[i],
        componentId = _extracted$i.componentId,
        cssFromDOM = _extracted$i.cssFromDOM;

    var cssRules = splitByRules(cssFromDOM);
    tag.insertRules(componentId, cssRules);
  }

  /* remove old HTMLStyleElements, since they have been rehydrated */
  for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
    var el = els[_i];
    if (el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {

  /* a map from ids to tags */

  /* deferred rules for a given id */

  /* this is used for not reinjecting rules via hasNameForId() */

  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */

  /* a list of tags belonging to this StyleSheet */

  /* a tag for import rules */

  /* current capacity until a new tag must be created */

  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate$$1() {
    if (!IS_BROWSER || this.forceServer) return this;

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + '][' + SC_VERSION_ATTR + '="' + "4.1.3" + '"]');

    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (!nodesSize) return this;

    for (var i = 0; i < nodesSize; i += 1) {
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0, name; j < elNamesSize; j += 1) {
        name = elNames[j];
        /* add rehydrated name to sheet to avoid re-adding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (!extractedSize) return this;

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);

    rehydrate(tag, els, extracted);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(tag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = tag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by createGlobalStyle, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends$1({}, this.rehydratedNames);
    sheet.deferred = _extends$1({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for createGlobalStyle to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;


    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);

    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;

    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

// 

var Keyframes = function () {
  function Keyframes(name, rules) {
    var _this = this;

    classCallCheck(this, Keyframes);

    this.inject = function (styleSheet) {
      if (!styleSheet.hasNameForId(_this.id, _this.name)) {
        styleSheet.inject(_this.id, _this.rules, _this.name);
      }
    };

    this.toString = function () {
      throw new StyledComponentsError(12, String(_this.name));
    };

    this.name = name;
    this.rules = rules;

    this.id = 'sc-keyframes-' + name;
  }

  Keyframes.prototype.getName = function getName() {
    return this.name;
  };

  return Keyframes;
}();

// 

/**
 * inlined version of
 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/hyphenateStyleName.js
 */

var uppercasePattern = /([A-Z])/g;
var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return string.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
}

// 

// Taken from https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/shared/dangerousStyleValue.js
function addUnitIfNeeded(name, value) {
  // https://github.com/amilajack/eslint-plugin-flowtype-errors/issues/133
  // $FlowFixMe
  if (value == null || typeof value === 'boolean' || value === '') {
    return '';
  }

  if (typeof value === 'number' && value !== 0 && !(name in unitlessKeys)) {
    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
  }

  return String(value).trim();
}

// 

/**
 * It's falsish not falsy because 0 is allowed.
 */
var isFalsish = function isFalsish(chunk) {
  return chunk === undefined || chunk === null || chunk === false || chunk === '';
};

var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    return !isFalsish(obj[key]);
  }).map(function (key) {
    if (isPlainObject(obj[key])) return objToCss(obj[key], key);
    return hyphenateStyleName(key) + ': ' + addUnitIfNeeded(key, obj[key]) + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

function flatten(chunk, executionContext, styleSheet) {
  if (Array.isArray(chunk)) {
    var ruleSet = [];

    for (var i = 0, len = chunk.length, result; i < len; i += 1) {
      result = flatten(chunk[i], executionContext, styleSheet);

      if (result === null) continue;else if (Array.isArray(result)) ruleSet.push.apply(ruleSet, result);else ruleSet.push(result);
    }

    return ruleSet;
  }

  if (isFalsish(chunk)) {
    return null;
  }

  /* Handle other components */
  if (isStyledComponent(chunk)) {
    return '.' + chunk.styledComponentId;
  }

  /* Either execute or defer the function */
  if (isFunction(chunk)) {
    if (executionContext) {
      var shouldThrow = false;

      try {
        // eslint-disable-next-line new-cap
        if (reactIs_1(new chunk(executionContext))) {
          shouldThrow = true;
        }
      } catch (e) {
        /* */
      }

      if (shouldThrow) {
        throw new StyledComponentsError(13, getComponentName(chunk));
      }

      return flatten(chunk(executionContext), executionContext, styleSheet);
    } else return chunk;
  }

  if (chunk instanceof Keyframes) {
    if (styleSheet) {
      chunk.inject(styleSheet);
      return chunk.getName();
    } else return chunk;
  }

  /* Handle objects */
  return isPlainObject(chunk) ? objToCss(chunk) : chunk.toString();
}

// 

function css(styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (isFunction(styles) || isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
}

// 

function constructWithOptions(componentConstructor, tag) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  if (!reactIs_2(tag)) {
    throw new StyledComponentsError(1, String(tag));
  }

  /* This is callable directly as a template function */
  // $FlowFixMe: Not typed to avoid destructuring arguments
  var templateFunction = function templateFunction() {
    return componentConstructor(tag, options, css.apply(undefined, arguments));
  };

  /* If config methods are called, wrap up a new template function and merge options */
  templateFunction.withConfig = function (config) {
    return constructWithOptions(componentConstructor, tag, _extends$1({}, options, config));
  };

  /* Modify/inject new props at runtime */
  templateFunction.attrs = function (attrs) {
    return constructWithOptions(componentConstructor, tag, _extends$1({}, options, {
      attrs: Array.prototype.concat(options.attrs, attrs).filter(Boolean)
    }));
  };

  return templateFunction;
}

// 
// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(c) {
  for (var e = c.length | 0, a = e | 0, d = 0, b; e >= 4;) {
    b = c.charCodeAt(d) & 255 | (c.charCodeAt(++d) & 255) << 8 | (c.charCodeAt(++d) & 255) << 16 | (c.charCodeAt(++d) & 255) << 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), b ^= b >>> 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16) ^ b, e -= 4, ++d;
  }
  switch (e) {
    case 3:
      a ^= (c.charCodeAt(d + 2) & 255) << 16;
    case 2:
      a ^= (c.charCodeAt(d + 1) & 255) << 8;
    case 1:
      a ^= c.charCodeAt(d) & 255, a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  }
  a ^= a >>> 13;
  a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  return (a ^ a >>> 15) >>> 0;
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
}

// 

function hasFunctionObjectKey(obj) {
  // eslint-disable-next-line guard-for-in, no-restricted-syntax
  for (var key in obj) {
    if (isFunction(obj[key])) {
      return true;
    }
  }

  return false;
}

function isStaticRules(rules, attrs) {
  for (var i = 0; i < rules.length; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule, attrs)) {
      return false;
    } else if (isFunction(rule) && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs.some(function (x) {
    return isFunction(x) || hasFunctionObjectKey(x);
  })) return false;

  return true;
}

// 

var isHMREnabled = "production" !== 'production' && typeof module !== 'undefined' && module.hot;

/* combines hashStr (murmurhash) and nameGenerator for convenience */
var hasher = function hasher(str) {
  return generateAlphabeticName(murmurhash(str));
};

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */

var ComponentStyle = function () {
  function ComponentStyle(rules, attrs, componentId) {
    classCallCheck(this, ComponentStyle);

    this.rules = rules;
    this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
    this.componentId = componentId;

    if (!StyleSheet.master.hasId(componentId)) {
      StyleSheet.master.deferredInject(componentId, []);
    }
  }

  /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


  ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
    var isStatic = this.isStatic,
        componentId = this.componentId,
        lastClassName = this.lastClassName;

    if (IS_BROWSER && isStatic && typeof lastClassName === 'string' && styleSheet.hasNameForId(componentId, lastClassName)) {
      return lastClassName;
    }

    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var name = hasher(this.componentId + flatCSS.join(''));
    if (!styleSheet.hasNameForId(componentId, name)) {
      styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name, undefined, componentId), name);
    }

    this.lastClassName = name;
    return name;
  };

  ComponentStyle.generateName = function generateName(str) {
    return hasher(str);
  };

  return ComponentStyle;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme) {
  var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types, flowtype-errors/show-errors */
  var isDefaultTheme = defaultProps ? props.theme === defaultProps.theme : false;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme || defaultProps.theme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function isTag(target) {
  return typeof target === 'string' && ( false ? target.charAt(0) === target.charAt(0).toLowerCase() : true);
}

// 

function generateDisplayName(target) {
  // $FlowFixMe
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

var _TYPE_STATICS;

var REACT_STATICS = {
  childContextTypes: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDerivedStateFromProps: true,
  propTypes: true,
  type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var TYPE_STATICS = (_TYPE_STATICS = {}, _TYPE_STATICS[reactIs_3] = {
  $$typeof: true,
  render: true
}, _TYPE_STATICS);

var defineProperty$1 = Object.defineProperty,
    getOwnPropertyNames = Object.getOwnPropertyNames,
    _Object$getOwnPropert = Object.getOwnPropertySymbols,
    getOwnPropertySymbols = _Object$getOwnPropert === undefined ? function () {
  return [];
} : _Object$getOwnPropert,
    getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor,
    getPrototypeOf = Object.getPrototypeOf,
    objectPrototype = Object.prototype;
var arrayPrototype = Array.prototype;


function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components

    var inheritedComponent = getPrototypeOf(sourceComponent);

    if (inheritedComponent && inheritedComponent !== objectPrototype) {
      hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
    }

    var keys = arrayPrototype.concat(getOwnPropertyNames(sourceComponent),
    // $FlowFixMe
    getOwnPropertySymbols(sourceComponent));

    var targetStatics = TYPE_STATICS[targetComponent.$$typeof] || REACT_STATICS;

    var sourceStatics = TYPE_STATICS[sourceComponent.$$typeof] || REACT_STATICS;

    var i = keys.length;
    var descriptor = void 0;
    var key = void 0;

    // eslint-disable-next-line no-plusplus
    while (i--) {
      key = keys[i];

      if (
      // $FlowFixMe
      !KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) &&
      // $FlowFixMe
      !(targetStatics && targetStatics[key])) {
        descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        if (descriptor) {
          try {
            // Avoid failures from read-only properties
            defineProperty$1(targetComponent, key, descriptor);
          } catch (e) {
            /* fail silently */
          }
        }
      }
    }

    return targetComponent;
  }

  return targetComponent;
}

// 
function isDerivedReactComponent(fn) {
  return !!(fn && fn.prototype && fn.prototype.isReactComponent);
}

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb.apply(undefined, arguments);
    }
  };
});

// 

var ThemeContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();

var ThemeConsumer = ThemeContext.Consumer;

/**
 * Provide a theme to an entire react component tree via context
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider(props) {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = index(_this.getContext.bind(_this));
    _this.renderInner = _this.renderInner.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) return null;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ThemeContext.Consumer,
      null,
      this.renderInner
    );
  };

  ThemeProvider.prototype.renderInner = function renderInner(outerTheme) {
    var context = this.getContext(this.props.theme, outerTheme);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ThemeContext.Provider,
      { value: context },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(this.props.children)
    );
  };

  /**
   * Get the theme from the props, supporting both (outerTheme) => {}
   * as well as object notation
   */


  ThemeProvider.prototype.getTheme = function getTheme(theme, outerTheme) {
    if (isFunction(theme)) {
      var mergedTheme = theme(outerTheme);

      if (false) {
        throw new StyledComponentsError(7);
      }

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof$1(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends$1({}, outerTheme, theme);
  };

  ThemeProvider.prototype.getContext = function getContext(theme, outerTheme) {
    return this.getTheme(theme, outerTheme);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

// 

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.sealed = false;
  }

  /**
   * Mark the ServerStyleSheet as being fully emitted and manually GC it from the
   * StyleSheet singleton.
   */


  ServerStyleSheet.prototype.seal = function seal() {
    if (!this.sealed) {
      /* Remove sealed StyleSheets from the master sheet */
      var index$$1 = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index$$1, 1);
      this.sealed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.sealed) {
      throw new StyledComponentsError(2);
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.seal();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.seal();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    if (IS_BROWSER) {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new __WEBPACK_IMPORTED_MODULE_2_stream___default.a.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        /* prepend style html to chunk */
        this.push(html + chunk);
        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.seal();
    });
    readableStream.on('error', function (err) {
      _this.seal();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var StyleSheetContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])();

var StyleSheetConsumer = StyleSheetContext.Consumer;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager(props) {
    classCallCheck(this, StyleSheetManager);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = index(_this.getContext);
    return _this;
  }

  StyleSheetManager.prototype.getContext = function getContext(sheet, target) {
    if (sheet) {
      return sheet;
    } else if (target) {
      return new StyleSheet(target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        sheet = _props.sheet,
        target = _props.target;


    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      StyleSheetContext.Provider,
      { value: this.getContext(sheet, target) },
       false ? React.Children.only(children) : children
    );
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),

  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 

var didWarnAboutClassNameUsage = new Set();

var classNameUsageCheckInjector = (function (target) {
  var elementClassName = '';

  var targetCDM = target.componentDidMount;

  // eslint-disable-next-line no-param-reassign
  target.componentDidMount = function componentDidMount() {
    if (typeof targetCDM === 'function') {
      targetCDM.call(this);
    }

    var forwardTarget = this.props.forwardedComponent.target;

    if (target.props && target.props.suppressClassNameWarning || target.attrs && target.attrs.suppressClassNameWarning || didWarnAboutClassNameUsage.has(forwardTarget)) {
      return;
    }

    didWarnAboutClassNameUsage.add(forwardTarget);

    var classNames = elementClassName.replace(/ +/g, ' ').trim().split(' ');
    // eslint-disable-next-line react/no-find-dom-node
    var node = __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(this);
    var selector = classNames.map(function (s) {
      return '.' + s;
    }).join('');

    if (node && node.nodeType === 1 && !classNames.every(function (className) {
      return node.classList && node.classList.contains(className);
    }) && !node.querySelector(selector)) {
      console.warn('It looks like you\'ve wrapped styled() around your React component (' + getComponentName(forwardTarget) + '), but the className prop is not being passed down to a child. No styles will be rendered unless className is composed within your React component.');
    }
  };

  var prevRenderInner = target.renderInner;

  // eslint-disable-next-line no-param-reassign
  target.renderInner = function renderInner() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var element = prevRenderInner.apply(this, args);

    elementClassName = element.props.className;

    return element;
  };
});

// 

var identifiers = {};

/* We depend on components having unique IDs */
function generateId(_ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + _ComponentStyle.generateName(displayName + nr);

  return parentComponentId ? parentComponentId + '-' + componentId : componentId;
}

// $FlowFixMe

var StyledComponent = function (_Component) {
  inherits(StyledComponent, _Component);

  function StyledComponent() {
    classCallCheck(this, StyledComponent);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.attrs = {};

    _this.renderOuter = _this.renderOuter.bind(_this);
    _this.renderInner = _this.renderInner.bind(_this);

    if (false) {
      _this.warnInnerRef = once(function (displayName) {
        return (
          // eslint-disable-next-line no-console
          console.warn('The "innerRef" API has been removed in styled-components v4 in favor of React 16 ref forwarding, use "ref" instead like a typical component. "innerRef" was detected on component "' + displayName + '".')
        );
      });

      _this.warnAttrsFnObjectKeyDeprecated = once(function (key, displayName) {
        return (
          // eslint-disable-next-line no-console
          console.warn('Functions as object-form attrs({}) keys are now deprecated and will be removed in a future version of styled-components. Switch to the new attrs(props => ({})) syntax instead for easier and more powerful composition. The attrs key in question is "' + key + '" on component "' + displayName + '".')
        );
      });

      _this.warnNonStyledComponentAttrsObjectKey = once(function (key, displayName) {
        return (
          // eslint-disable-next-line no-console
          console.warn('It looks like you\'ve used a non styled-component as the value for the "' + key + '" prop in an object-form attrs constructor of "' + displayName + '".\n' + 'You should use the new function-form attrs constructor which avoids this issue: attrs(props => ({ yourStuff }))\n' + "To continue using the deprecated object syntax, you'll need to wrap your component prop in a function to make it available inside the styled component (you'll still get the deprecation warning though.)\n" + ('For example, { ' + key + ': () => InnerComponent } instead of { ' + key + ': InnerComponent }'))
        );
      });
    }

    if (false) {
      classNameUsageCheckInjector(_this);
    }
    return _this;
  }

  StyledComponent.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      StyleSheetConsumer,
      null,
      this.renderOuter
    );
  };

  StyledComponent.prototype.renderOuter = function renderOuter() {
    var styleSheet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : StyleSheet.master;

    this.styleSheet = styleSheet;

    // No need to subscribe a static component to theme changes, it won't change anything
    if (this.props.forwardedComponent.componentStyle.isStatic) return this.renderInner();

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ThemeConsumer,
      null,
      this.renderInner
    );
  };

  StyledComponent.prototype.renderInner = function renderInner(theme) {
    var _props$forwardedCompo = this.props.forwardedComponent,
        componentStyle = _props$forwardedCompo.componentStyle,
        defaultProps = _props$forwardedCompo.defaultProps,
        displayName = _props$forwardedCompo.displayName,
        foldedComponentIds = _props$forwardedCompo.foldedComponentIds,
        styledComponentId = _props$forwardedCompo.styledComponentId,
        target = _props$forwardedCompo.target;


    var generatedClassName = void 0;
    if (componentStyle.isStatic) {
      generatedClassName = this.generateAndInjectStyles(EMPTY_OBJECT, this.props);
    } else if (theme !== undefined) {
      generatedClassName = this.generateAndInjectStyles(determineTheme(this.props, theme, defaultProps), this.props);
    } else {
      generatedClassName = this.generateAndInjectStyles(this.props.theme || EMPTY_OBJECT, this.props);
    }

    var elementToBeCreated = this.props.as || this.attrs.as || target;
    var isTargetTag = isTag(elementToBeCreated);

    var propsForElement = {};
    var computedProps = _extends$1({}, this.attrs, this.props);

    var key = void 0;
    // eslint-disable-next-line guard-for-in
    for (key in computedProps) {
      if (false) {
        this.warnInnerRef(displayName);
      }

      if (key === 'forwardedComponent' || key === 'as') continue;else if (key === 'forwardedRef') propsForElement.ref = computedProps[key];else if (!isTargetTag || index$1(key)) {
        // Don't pass through non HTML tags through to HTML elements
        propsForElement[key] = computedProps[key];
      }
    }

    if (this.props.style && this.attrs.style) {
      propsForElement.style = _extends$1({}, this.attrs.style, this.props.style);
    }

    propsForElement.className = Array.prototype.concat(foldedComponentIds, this.props.className, styledComponentId, this.attrs.className, generatedClassName).filter(Boolean).join(' ');

    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(elementToBeCreated, propsForElement);
  };

  StyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props, attrs) {
    var _this2 = this;

    var context = _extends$1({}, props, { theme: theme });

    if (!attrs.length) return context;

    this.attrs = {};

    attrs.forEach(function (attrDef) {
      var resolvedAttrDef = attrDef;
      var attrDefWasFn = false;
      var attr = void 0;
      var key = void 0;

      if (isFunction(resolvedAttrDef)) {
        // $FlowFixMe
        resolvedAttrDef = resolvedAttrDef(context);
        attrDefWasFn = true;
      }

      /* eslint-disable guard-for-in */
      // $FlowFixMe
      for (key in resolvedAttrDef) {
        attr = resolvedAttrDef[key];

        if (!attrDefWasFn) {
          if (isFunction(attr) && !isDerivedReactComponent(attr) && !isStyledComponent(attr)) {
            if (false) {
              _this2.warnAttrsFnObjectKeyDeprecated(key, props.forwardedComponent.displayName);
            }

            attr = attr(context);

            if (false) {
              _this2.warnNonStyledComponentAttrsObjectKey(key, props.forwardedComponent.displayName);
            }
          }
        }

        _this2.attrs[key] = attr;
        context[key] = attr;
      }
      /* eslint-enable */
    });

    return context;
  };

  StyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _props$forwardedCompo2 = props.forwardedComponent,
        attrs = _props$forwardedCompo2.attrs,
        componentStyle = _props$forwardedCompo2.componentStyle,
        warnTooManyClasses = _props$forwardedCompo2.warnTooManyClasses;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names

    if (componentStyle.isStatic && !attrs.length) {
      return componentStyle.generateAndInjectStyles(EMPTY_OBJECT, this.styleSheet);
    }

    var className = componentStyle.generateAndInjectStyles(this.buildExecutionContext(theme, props, attrs), this.styleSheet);

    if (false) warnTooManyClasses(className);

    return className;
  };

  return StyledComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function createStyledComponent(target, options, rules) {
  var isTargetStyledComp = isStyledComponent(target);
  var isClass = !isTag(target);

  var _options$displayName = options.displayName,
      displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
      _options$componentId = options.componentId,
      componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
      _options$ParentCompon = options.ParentComponent,
      ParentComponent = _options$ParentCompon === undefined ? StyledComponent : _options$ParentCompon,
      _options$attrs = options.attrs,
      attrs = _options$attrs === undefined ? EMPTY_ARRAY : _options$attrs;


  var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

  // fold the underlying StyledComponent attrs up (implicit extend)
  var finalAttrs =
  // $FlowFixMe
  isTargetStyledComp && target.attrs ? Array.prototype.concat(target.attrs, attrs).filter(Boolean) : attrs;

  var componentStyle = new ComponentStyle(isTargetStyledComp ? // fold the underlying StyledComponent rules up (implicit extend)
  // $FlowFixMe
  target.componentStyle.rules.concat(rules) : rules, finalAttrs, styledComponentId);

  /**
   * forwardRef creates a new interim component, which we'll take advantage of
   * instead of extending ParentComponent to create _another_ interim class
   */
  var WrappedStyledComponent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(function (props, ref) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ParentComponent, _extends$1({}, props, { forwardedComponent: WrappedStyledComponent, forwardedRef: ref }));
  });

  // $FlowFixMe
  WrappedStyledComponent.attrs = finalAttrs;
  // $FlowFixMe
  WrappedStyledComponent.componentStyle = componentStyle;
  WrappedStyledComponent.displayName = displayName;

  // $FlowFixMe
  WrappedStyledComponent.foldedComponentIds = isTargetStyledComp ? // $FlowFixMe
  Array.prototype.concat(target.foldedComponentIds, target.styledComponentId) : EMPTY_ARRAY;

  // $FlowFixMe
  WrappedStyledComponent.styledComponentId = styledComponentId;

  // fold the underlying StyledComponent target up since we folded the styles
  // $FlowFixMe
  WrappedStyledComponent.target = isTargetStyledComp ? target.target : target;

  // $FlowFixMe
  WrappedStyledComponent.withComponent = function withComponent(tag) {
    var previousComponentId = options.componentId,
        optionsToCopy = objectWithoutProperties(options, ['componentId']);


    var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

    var newOptions = _extends$1({}, optionsToCopy, {
      attrs: finalAttrs,
      componentId: newComponentId,
      ParentComponent: ParentComponent
    });

    return createStyledComponent(tag, newOptions, rules);
  };

  if (false) {
    // $FlowFixMe
    WrappedStyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
  }

  // $FlowFixMe
  WrappedStyledComponent.toString = function () {
    return '.' + WrappedStyledComponent.styledComponentId;
  };

  if (isClass) {
    hoistNonReactStatics(WrappedStyledComponent, target, {
      // all SC-specific things should not be hoisted
      attrs: true,
      componentStyle: true,
      displayName: true,
      foldedComponentIds: true,
      styledComponentId: true,
      target: true,
      withComponent: true
    });
  }

  return WrappedStyledComponent;
}

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var styled = function styled(tag) {
  return constructWithOptions(createStyledComponent, tag);
};

// Shorthands for all valid HTML Elements
domElements.forEach(function (domElement) {
  styled[domElement] = styled(domElement);
});

// 

var GlobalStyle = function () {
  function GlobalStyle(rules, componentId) {
    classCallCheck(this, GlobalStyle);

    this.rules = rules;
    this.componentId = componentId;
    this.isStatic = isStaticRules(rules, EMPTY_ARRAY);

    if (!StyleSheet.master.hasId(componentId)) {
      StyleSheet.master.deferredInject(componentId, []);
    }
  }

  GlobalStyle.prototype.createStyles = function createStyles(executionContext, styleSheet) {
    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var css = stringifyRules(flatCSS, '');

    styleSheet.inject(this.componentId, css);
  };

  GlobalStyle.prototype.removeStyles = function removeStyles(styleSheet) {
    var componentId = this.componentId;

    if (styleSheet.hasId(componentId)) {
      styleSheet.remove(componentId);
    }
  };

  // TODO: overwrite in-place instead of remove+create?


  GlobalStyle.prototype.renderStyles = function renderStyles(executionContext, styleSheet) {
    this.removeStyles(styleSheet);
    this.createStyles(executionContext, styleSheet);
  };

  return GlobalStyle;
}();

// 

// place our cache into shared context so it'll persist between HMRs
if (IS_BROWSER) {
  window.scCGSHMRCache = {};
}

function createGlobalStyle(strings) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var rules = css.apply(undefined, [strings].concat(interpolations));
  var id = 'sc-global-' + murmurhash(JSON.stringify(rules));
  var style = new GlobalStyle(rules, id);

  var GlobalStyleComponent = function (_React$Component) {
    inherits(GlobalStyleComponent, _React$Component);

    function GlobalStyleComponent() {
      classCallCheck(this, GlobalStyleComponent);

      var _this = possibleConstructorReturn(this, _React$Component.call(this));

      var _this$constructor = _this.constructor,
          globalStyle = _this$constructor.globalStyle,
          styledComponentId = _this$constructor.styledComponentId;


      if (IS_BROWSER) {
        window.scCGSHMRCache[styledComponentId] = (window.scCGSHMRCache[styledComponentId] || 0) + 1;
      }

      /**
       * This fixes HMR compatibility. Don't ask me why, but this combination of
       * caching the closure variables via statics and then persisting the statics in
       * state works across HMR where no other combination did. ¯\_(ツ)_/¯
       */
      _this.state = {
        globalStyle: globalStyle,
        styledComponentId: styledComponentId
      };
      return _this;
    }

    GlobalStyleComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      if (window.scCGSHMRCache[this.state.styledComponentId]) {
        window.scCGSHMRCache[this.state.styledComponentId] -= 1;
      }
      /**
       * Depending on the order "render" is called this can cause the styles to be lost
       * until the next render pass of the remaining instance, which may
       * not be immediate.
       */
      if (window.scCGSHMRCache[this.state.styledComponentId] === 0) {
        this.state.globalStyle.removeStyles(this.styleSheet);
      }
    };

    GlobalStyleComponent.prototype.render = function render() {
      var _this2 = this;

      if (false) {
        // eslint-disable-next-line no-console
        console.warn('The global style component ' + this.state.styledComponentId + ' was given child JSX. createGlobalStyle does not render children.');
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        StyleSheetConsumer,
        null,
        function (styleSheet) {
          _this2.styleSheet = styleSheet || StyleSheet.master;

          var globalStyle = _this2.state.globalStyle;


          if (globalStyle.isStatic) {
            globalStyle.renderStyles(STATIC_EXECUTION_CONTEXT, _this2.styleSheet);

            return null;
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              ThemeConsumer,
              null,
              function (theme) {
                // $FlowFixMe
                var defaultProps = _this2.constructor.defaultProps;


                var context = _extends$1({}, _this2.props);

                if (typeof theme !== 'undefined') {
                  context.theme = determineTheme(_this2.props, theme, defaultProps);
                }

                globalStyle.renderStyles(context, _this2.styleSheet);

                return null;
              }
            );
          }
        }
      );
    };

    return GlobalStyleComponent;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

  GlobalStyleComponent.globalStyle = style;
  GlobalStyleComponent.styledComponentId = id;


  return GlobalStyleComponent;
}

// 

/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

var StyledInput = styled.input.withConfig({
  displayName: "styled-component__StyledInput",
  componentId: "sc-1dsackt-0"
})(["font-size:", ";padding:10px 20px;height:", ";border:1px solid ", ";border-radius:5px;color:", ";&:focus{outline:none;}"], function (props) {
  return props.inputBoxFontSize;
}, function (props) {
  return props.inputBoxHeight;
}, function (props) {
  return props.inputBoxBorderColor;
}, function (props) {
  return props.inputBoxFontColor;
});

var InputBox =
/*#__PURE__*/
function (_Component) {
  _inherits(InputBox, _Component);

  function InputBox() {
    _classCallCheck(this, InputBox);

    return _possibleConstructorReturn(this, _getPrototypeOf(InputBox).apply(this, arguments));
  }

  _createClass(InputBox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var autoFocus = this.props.autoFocus;
      /**
       * Focusses on the input box if the autoFocus prop is true.
       */

      !!autoFocus && this.input.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          placeholder = _this$props.placeholder,
          value = _this$props.value,
          onChange = _this$props.onChange,
          onFocus = _this$props.onFocus,
          inputBoxFontColor = _this$props.inputBoxFontColor,
          inputBoxBorderColor = _this$props.inputBoxBorderColor,
          inputBoxFontSize = _this$props.inputBoxFontSize,
          inputBoxHeight = _this$props.inputBoxHeight;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledInput, {
        type: "text",
        placeholder: placeholder,
        value: value,
        onChange: onChange,
        onFocus: onFocus,
        ref: function ref(input) {
          _this.input = input;
        },
        inputBoxFontColor: inputBoxFontColor,
        inputBoxBorderColor: inputBoxBorderColor,
        inputBoxFontSize: inputBoxFontSize,
        inputBoxHeight: inputBoxHeight
      });
    }
  }]);

  return InputBox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(InputBox, "propTypes", {
  /**
   * placeholder: The placeholder text for the input box.
   * value: The value of the input box.
   * onChange: A function which acts as a callback when the input value is changed.
   * onFocus: A function which acts as a callback when the input is focussed.
   * inputBoxFontColor: Color of the text in the input box.
   * inputBoxBorderColor: Color of the border of the input box.
   * inputBoxFontSize: Size of the font of the input box.
   * inputBoxHeight: Height of the input box.
   */
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  inputBoxFontColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  inputBoxBorderColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  inputBoxFontSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  inputBoxHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
});

var StyledDropdown = styled.div.withConfig({
  displayName: "styled-component__StyledDropdown",
  componentId: "sc-160859k-0"
})(["margin:10px 0 0;background-color:#fff;box-shadow:rgba(0,0,0,0.1) 0 0 0 0,rgba(0,0,0,0.1) 0px 4px 11px;border-radius:5px;> ul{list-style-type:none;margin:0;padding:0;> li{padding:10px 20px;background-color:#fff;border:1px solid ", ";height:40px;display:flex;align-items:center;&:hover{background-color:", ";cursor:pointer;}&:first-child{border-top-left-radius:5px;border-top-right-radius:5px;}&:last-child{border-bottom-left-radius:5px;border-bottom-right-radius:5px;}&:not(:first-child){border-top:0;}}}"], function (props) {
  return props.dropDownBorderColor;
}, function (props) {
  return props.dropDownHoverColor;
});

var DropDown =
/*#__PURE__*/
function (_Component) {
  _inherits(DropDown, _Component);

  function DropDown() {
    _classCallCheck(this, DropDown);

    return _possibleConstructorReturn(this, _getPrototypeOf(DropDown).apply(this, arguments));
  }

  _createClass(DropDown, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          matchedRecords = _this$props.matchedRecords,
          _onClick = _this$props.onClick,
          dropDownHoverColor = _this$props.dropDownHoverColor,
          dropDownBorderColor = _this$props.dropDownBorderColor;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledDropdown, {
        className: "react-search-box-dropdown",
        dropDownHoverColor: dropDownHoverColor,
        dropDownBorderColor: dropDownBorderColor
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", null, matchedRecords.map(function (record) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
          key: record.key,
          className: "react-search-box-dropdown-list-item",
          onClick: function onClick() {
            return _onClick(record);
          }
        }, record.value);
      })));
    }
  }]);

  return DropDown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(DropDown, "propTypes", {
  /**
   * onClick: A function which acts as a callback when any record is selected. It
   * is triggered once a dropdown item is clicked.
   * matchedRecords: An array of matched records.
   * dropDownHoverColor: Background color on hover of the dropdown list items.
   * dropDownBorderColor: Border color of the dropdown.
   */
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  matchedRecords: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  dropDownHoverColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dropDownBorderColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
});

_defineProperty(DropDown, "defaultProps", {
  /**
   * Set matchedRecords prop as an empty array in case it's not passed.
   */
  matchedRecords: []
});

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  * {\n    box-sizing: border-box;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var GlobalStyle$1 = createGlobalStyle(_templateObject());
var StyledContainer = styled.div.withConfig({
  displayName: "src__StyledContainer",
  componentId: "hakmvc-0"
})(["display:flex;flex-direction:column;"]);

var ReactSearchBox =
/*#__PURE__*/
function (_Component) {
  _inherits(ReactSearchBox, _Component);

  function ReactSearchBox(props) {
    var _this;

    _classCallCheck(this, ReactSearchBox);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactSearchBox).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      /**
       * 'matchedRecords' stores the items when the input box's value
       * matches with any item from the 'data' prop.
       */
      value: '',
      matchedRecords: []
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (e) {
      var onChange = _this.props.onChange;
      /**
       * This function is responsible for checking if any items from the input
       * box's value matches with any item form the 'data' prop. If any item matches,
       * then that matched object is pushed into the 'matchedRecords' state. That
       * state is responsible for populating the dropdown.
       */

      var value = e.target.value;
      /**
       * Check all the values from 'data' array whose 'value' matches with
       * 'value' using Fuse plugin.
       */

      var matchedRecords = _this.fuse.search(value);
      /**
       * Update 'value' state with the value from the input box.
       * Update 'matchedRecords' state with the matched records from the data array.
       */


      _this.setState({
        value: value,
        matchedRecords: matchedRecords,

        /**
         * Show the dropdown onChange of the input.
         */
        showDropdown: true
      });
      /**
       * Trigger the 'onChange' prop once the input's value changes.
       */


      !!onChange && onChange(value);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputNode", function () {
      /**
       * This function is responsible for rendering the input box.
       * The input box acts as a source of entry for the data from the user.
       * Once the user enters the value, it's checked if that value matches
       * with any value which is present in the 'data' prop. If any value
       * matches with the input, then that matched item appears in the dropdown.
       */
      var _this$props = _this.props,
          placeholder = _this$props.placeholder,
          onFocus = _this$props.onFocus,
          autoFocus = _this$props.autoFocus,
          inputBoxFontColor = _this$props.inputBoxFontColor,
          inputBoxBorderColor = _this$props.inputBoxBorderColor,
          inputBoxFontSize = _this$props.inputBoxFontSize,
          inputBoxHeight = _this$props.inputBoxHeight;
      var value = _this.state.value;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputBox, {
        type: "text",
        placeholder: placeholder,
        value: value,
        onChange: _this.handleInputChange,
        autoFocus: autoFocus ? autoFocus : undefined,
        onFocus: onFocus ? onFocus : undefined,
        inputBoxFontColor: inputBoxFontColor,
        inputBoxBorderColor: inputBoxBorderColor,
        inputBoxFontSize: inputBoxFontSize,
        inputBoxHeight: inputBoxHeight
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleDropdownItemClick", function (record) {
      /**
       * This function is responsible for updating the value inside the
       * input box when any dropdown item is clicked.
       *
       * The 'value' state is updated with the clicked record's value.
       */
      var value = record.value;
      var _this$props2 = _this.props,
          onSelect = _this$props2.onSelect,
          onChange = _this$props2.onChange;

      _this.setState({
        value: value,

        /**
         * Hide the dropdown once any dropdown item is clicked.
         */
        showDropdown: false
      });
      /**
       * Trigger the 'onSelect' prop once everything is done if it's passed.
       */


      !!onSelect && onSelect(record);
      /**
       * Trigger the 'onChange' prop since the value of the input box also changes.
       */

      !!onChange && onChange(value);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "dropdownNode", function () {
      /**
       * This function is responsible for rendering the dropdown.
       * When any value from the input box matches with any value from the
       * 'data' prop, that matched object from the 'data' array shows up
       * in the dropdown's li. The matched values are stored in the
       * 'matchedRecords' state.
       */
      var _this$state = _this.state,
          matchedRecords = _this$state.matchedRecords,
          showDropdown = _this$state.showDropdown;
      var _this$props3 = _this.props,
          dropDownHoverColor = _this$props3.dropDownHoverColor,
          dropDownBorderColor = _this$props3.dropDownBorderColor;
      /**
       * If there is no value present in the input box, then the dropdown
       * shouldn't appear.
       */

      if (!showDropdown) return false;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DropDown, {
        matchedRecords: matchedRecords,
        onClick: _this.handleDropdownItemClick,
        dropDownHoverColor: dropDownHoverColor,
        dropDownBorderColor: dropDownBorderColor
      });
    });

    var data = props.data,
        fuseConfigs = props.fuseConfigs;
    /**
     * These configs are from Fuse plugin. Check out http://fusejs.io/
     * for more details.
     */

    var defaultFuseConfigs = {
      /**
       * At what point does the match algorithm give up. A threshold of 0.0
       * requires a perfect match (of both letters and location), a threshold
       * of 1.0 would match anything.
       */
      threshold: 0.05,

      /**
       * Determines approximately where in the text is the pattern expected to be found.
       */
      location: 0,

      /**
       * Determines how close the match must be to the fuzzy location
       * (specified by location). An exact letter match which is distance
       * characters away from the fuzzy location would score as a complete
       * mismatch. A distance of 0 requires the match be at the exact
       * location specified, a distance of 1000 would require a perfect
       * match to be within 800 characters of the location to be found
       * using a threshold of 0.8.
       */
      distance: 100,

      /**
       * When set to include matches, only the matches whose length exceeds this
       * value will be returned. (For instance, if you want to ignore single
       * character index returns, set to 2).
       */
      minMatchCharLength: 1,

      /**
       * List of properties that will be searched. This supports nested properties,
       * weighted search, searching in arrays of strings and objects.
       */
      keys: ['value']
      /**
       * Override defaultFuseConfigs with fuseConfigs prop
       */

    };
    var configs = Object.assign({}, defaultFuseConfigs, fuseConfigs);
    _this.fuse = new Fuse(data, configs);
    return _this;
  }

  _createClass(ReactSearchBox, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledContainer, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GlobalStyle$1, null), this.inputNode(), this.dropdownNode());
    }
  }]);

  return ReactSearchBox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(ReactSearchBox, "propTypes", {
  /**
   * placeholder: The placeholder text for the input box.
   * data: An array of objects which acts as teh source of data for the dropdown.
   * fuseConfigs: Configs to override default Fuse configs.
   * onSelect: A function which acts as a callback when any record is selected. It
   * is triggered once a dropdown item is clicked.
   * autoFocus: Focus on the input box once the component is mounted.
   * onFocus: A function which acts as a callback when the input is focussed.
   * onChange: A function which acts as a callback when the input value is changed.
   * inputBoxFontColor: Color of the text in the input box.
   * inputBoxBorderColor: Color of the border of the input box.
   * inputBoxFontSize: Size of the font of the input box.
   * inputBoxHeight: Height of the input box.
   * dropDownHoverColor: Background color on hover of the dropdown list items.
   * dropDownBorderColor: Border color of the dropdown.
   */
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  fuseConfigs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  inputBoxFontColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  inputBoxBorderColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  inputBoxFontSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  inputBoxHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dropDownHoverColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dropDownBorderColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
});

_defineProperty(ReactSearchBox, "defaultProps", {
  /**
   * Set data prop as an empty array in case it's not passed.
   */
  data: [],

  /**
   * Don't focus on the input box when the component is mounted by default
   */
  autoFocus: false,

  /**
   * Set the placeholder as empty text by default
   */
  placeholder: '',
  inputBoxFontColor: '#000',
  inputBoxBorderColor: '#cacaca96',
  inputBoxFontSize: '14px',
  inputBoxHeight: '40px',
  dropDownHoverColor: '#ccc',
  dropDownBorderColor: '#cacaca96'
});

/* harmony default export */ __webpack_exports__["a"] = (ReactSearchBox);
//# sourceMappingURL=index.es.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(28), __webpack_require__(119), __webpack_require__(1002)(module)))

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(149).EventEmitter;
var inherits = __webpack_require__(60);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(282);
Stream.Writable = __webpack_require__(1011);
Stream.Duplex = __webpack_require__(1012);
Stream.Transform = __webpack_require__(1013);
Stream.PassThrough = __webpack_require__(1014);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 1004 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(150).Buffer;
var util = __webpack_require__(1006);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(1008);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28), __webpack_require__(119)))

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(422);

/*<replacement>*/
var util = __webpack_require__(142);
util.inherits = __webpack_require__(60);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(283);


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(97);


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(282).Transform


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(282).PassThrough


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.27
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (typeof module === 'object' && module.exports) {
		module.exports = factory(__webpack_require__(285)); // Node
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(285)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.27",
		zones = {},
		links = {},
		names = {},
		guesses = {},
		cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2 (old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName  = abbrWrap(fn.zoneName);
	fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
	fn.utc       = resetZoneWrap(fn.utc);
	fn.local     = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


/***/ }),
/* 1016 */
/***/ (function(module, exports) {

module.exports = {"version":"2019c","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|010101010101010101010101010|-1c2w0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|0101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|012121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Etc/GMT-0|GMT|0|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Etc/GMT-11|+11|-b0|0|","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _defineProperty2 = __webpack_require__(1018);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = __webpack_require__(430);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(1021);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(93);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(48);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(56);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(57);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(58);

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class;

var _react = __webpack_require__(435);

var _react2 = _interopRequireDefault(_react);

var _isomorphicFetch = __webpack_require__(1050);

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _autobindDecorator = __webpack_require__(1052);

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _classnames2 = __webpack_require__(49);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactDropzone = __webpack_require__(1053);

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _reactProgressButton = __webpack_require__(1054);

var _reactProgressButton2 = _interopRequireDefault(_reactProgressButton);

__webpack_require__(1056);

__webpack_require__(343);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

var ImagesUploader = (_class = function (_Component) {
	(0, _inherits3.default)(ImagesUploader, _Component);

	/* eslint-disable react/sort-comp */
	function ImagesUploader(props) {
		(0, _classCallCheck3.default)(this, ImagesUploader);

		var _this = (0, _possibleConstructorReturn3.default)(this, (ImagesUploader.__proto__ || Object.getPrototypeOf(ImagesUploader)).call(this, props));

		var imagePreviewUrls = [];
		if (_this.props.images && _this.props.multiple !== false) {
			imagePreviewUrls = _this.props.images || [];
		}
		if (_this.props.image && _this.props.multiple === false) {
			imagePreviewUrls = [_this.props.image];
		}
		_this.state = {
			imagePreviewUrls: imagePreviewUrls,
			loadState: '',
			optimisticPreviews: [],
			displayNotification: false
		};
		_this.input = null;
		return _this;
	}
	/* eslint-enable react/sort-comp */

	(0, _createClass3.default)(ImagesUploader, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			document.addEventListener('dragover', function (event) {
				// prevent default to allow drop
				event.preventDefault();
			}, false);
			document.addEventListener('drop', function (event) {
				// prevent default to allow drop
				event.preventDefault();
			}, false);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (!this.props.images && nextProps.images && nextProps.multiple !== false) {
				this.setState({
					imagePreviewUrls: nextProps.images
				});
			}
			if (!this.props.image && nextProps.image && nextProps.multiple === false) {
				this.setState({
					imagePreviewUrls: [nextProps.image]
				});
			}
		}
	}, {
		key: 'clickImage',
		value: function clickImage(key, url) {
			var clickImageCallback = this.props.clickImage;
			if (clickImageCallback && typeof clickImageCallback === 'function') {
				clickImageCallback(key, url);
			}
		}
	}, {
		key: 'deleteImage',
		value: function deleteImage(key, url) {
			if (!this.props.disabled) {
				var _imagePreviewUrls = this.state.imagePreviewUrls;
				_imagePreviewUrls.splice(key, 1);
				this.setState({
					imagePreviewUrls: _imagePreviewUrls
				});
				if (this.props.deleteImage && typeof this.props.deleteImage === 'function') {
					this.props.deleteImage(key, url);
				}
			}
		}
	}, {
		key: 'buildPreviews',
		value: function buildPreviews(urls, optimisticUrls, inButton) {
			var _this2 = this;

			var _props = this.props,
			    classNamespace = _props.classNamespace,
			    disabled = _props.disabled,
			    classNames = _props.classNames,
			    styles = _props.styles,
			    color = _props.color,
			    disabledColor = _props.disabledColor,
			    borderColor = _props.borderColor,
			    disabledBorderColor = _props.disabledBorderColor,
			    notificationBgColor = _props.notificationBgColor,
			    notificationColor = _props.notificationColor,
			    deleteElement = _props.deleteElement,
			    plusElement = _props.plusElement;


			if ((!urls || urls.length < 1) && (!optimisticUrls || optimisticUrls.length < 1)) {
				return _react2.default.createElement('div', {
					className: classNames.emptyPreview || classNamespace + 'emptyPreview',
					style: styles.emptyPreview
				});
			}
			var previews = [];
			var multiple = this.props.multiple;
			if (urls && urls.length > 0 && !(multiple === false && optimisticUrls && optimisticUrls.length > 0)) {
				previews = urls.map(function (url, key) {
					if (url) {
						var imgPreviewStyle = {
							backgroundImage: 'url(' + url + ')',
							borderColor: disabled ? disabledBorderColor : borderColor
						};

						if (_this2.props.size) {
							imgPreviewStyle = (0, _extends3.default)({}, imgPreviewStyle, {
								width: _this2.props.size,
								height: _this2.props.size
							}, styles.imagePreview || {});
						}

						var deletePreviewStyle = (0, _extends3.default)({
							color: disabled ? disabledColor : color,
							borderColor: disabled ? disabledBorderColor : borderColor
						}, styles.deletePreview || {});

						return _react2.default.createElement(
							'div',
							{
								className: classNames.imgPreview || classNamespace + 'imgPreview',
								key: key,
								style: imgPreviewStyle,
								onClick: function onClick(e) {
									e.preventDefault();
									_this2.clickImage(key, url);
								} },
							!inButton ? _react2.default.createElement(
								'div',
								{
									className: classNames.deletePreview || classNamespace + 'deletePreview',
									style: deletePreviewStyle,
									onClick: function onClick(e) {
										e.preventDefault();
										e.stopPropagation();
										_this2.deleteImage(key, url);
									} },
								deleteElement || _react2.default.createElement(
									'svg',
									{ xmlns: 'http://www.w3.org/2000/svg', width: '7.969', height: '8', viewBox: '0 0 7.969 8' },
									_react2.default.createElement('path', {
										id: 'X_Icon',
										'data-name': 'X Icon',
										style: {
											fill: disabled ? disabledColor : color,
											fillRule: 'evenodd'
										}
										/* eslint-disable max-len */
										, d: 'M562.036,606l2.849-2.863a0.247,0.247,0,0,0,0-.352l-0.7-.706a0.246,0.246,0,0,0-.352,0l-2.849,2.862-2.849-2.862a0.247,0.247,0,0,0-.352,0l-0.7.706a0.249,0.249,0,0,0,0,.352L559.927,606l-2.849,2.862a0.25,0.25,0,0,0,0,.353l0.7,0.706a0.249,0.249,0,0,0,.352,0l2.849-2.862,2.849,2.862a0.249,0.249,0,0,0,.352,0l0.7-.706a0.25,0.25,0,0,0,0-.353Z'
										/* eslint-enable max-len */
										, transform: 'translate(-557 -602)'
									})
								)
							) : _react2.default.createElement(
								'div',
								{
									className: classNames.notification || classNamespace + 'notification',
									style: styles.notification ? (0, _extends3.default)({}, styles.notification, {
										display: _this2.state.displayNotification ? 'block' : 'none',
										backgroundColor: notificationBgColor,
										color: notificationColor
									}) : {
										display: _this2.state.displayNotification ? 'block' : 'none',
										backgroundColor: notificationBgColor,
										color: notificationColor
									} },
								_react2.default.createElement(
									'span',
									null,
									_this2.props.notification || _this2.buildPlus(disabled, notificationColor, disabledColor, plusElement)
								)
							)
						);
					}
					return null;
				});
			}
			if (optimisticUrls && optimisticUrls.length > 0) {
				var length = previews.length;
				previews = previews.concat(optimisticUrls.map(function (url, key) {
					if (url) {
						var imgPreviewStyle = {
							backgroundImage: 'url(' + url + ')',
							borderColor: disabled ? disabledBorderColor : borderColor
						};

						if (_this2.props.size) {
							imgPreviewStyle = (0, _extends3.default)({}, imgPreviewStyle, {
								width: _this2.props.size,
								height: _this2.props.size
							}, styles.imgPreview || {});
						}

						return _react2.default.createElement('div', {
							className: classNames.imgPreview || classNamespace + 'imgPreview',
							key: length + key,
							style: imgPreviewStyle
						});
					}
					return null;
				}));
			}
			return previews;
		}
	}, {
		key: 'loadImages',
		value: function () {
			var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(files, url, onLoadEnd) {
				var imageFormData, i, response, multiple, _imagePreviewUrls2, err, _err;

				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								if (!url) {
									_context.next = 24;
									break;
								}

								_context.prev = 1;
								imageFormData = new FormData();


								for (i = 0; i < files.length; i++) {
									imageFormData.append(this.props.dataName, files[i], files[i].name);
								}

								_context.next = 6;
								return (0, _isomorphicFetch2.default)(url, {
									method: 'POST',
									credentials: 'include',
									body: imageFormData,
									headers: this.props.headers
								});

							case 6:
								response = _context.sent;

								if (!(response && response.status && response.status === 200)) {
									_context.next = 15;
									break;
								}

								_context.next = 10;
								return response.json();

							case 10:
								response = _context.sent;
								multiple = this.props.multiple;

								if (response instanceof Array || typeof response === 'string') {
									_imagePreviewUrls2 = [];

									if (multiple === false) {
										_imagePreviewUrls2 = response instanceof Array ? response : [response];
									} else {
										_imagePreviewUrls2 = this.state.imagePreviewUrls.concat(response);
									}
									this.setState({
										imagePreviewUrls: _imagePreviewUrls2,
										optimisticPreviews: [],
										loadState: 'success'
									});
									if (onLoadEnd && typeof onLoadEnd === 'function') {
										onLoadEnd(false, response);
									}
								} else {
									err = {
										message: 'invalid response type',
										response: response,
										fileName: 'ImagesUploader'
									};

									this.setState({
										loadState: 'error',
										optimisticPreviews: []
									});
									if (onLoadEnd && typeof onLoadEnd === 'function') {
										onLoadEnd(err);
									}
								}
								_context.next = 18;
								break;

							case 15:
								_err = {
									message: 'server error',
									status: response ? response.status : false,
									fileName: 'ImagesUploader'
								};

								this.setState({
									loadState: 'error',
									optimisticPreviews: []
								});
								if (onLoadEnd && typeof onLoadEnd === 'function') {
									onLoadEnd(_err);
								}

							case 18:
								_context.next = 24;
								break;

							case 20:
								_context.prev = 20;
								_context.t0 = _context['catch'](1);

								if (onLoadEnd && typeof onLoadEnd === 'function') {
									onLoadEnd(_context.t0);
								}
								this.setState({
									loadState: 'error',
									optimisticPreviews: []
								});

							case 24:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, this, [[1, 20]]);
			}));

			function loadImages(_x, _x2, _x3) {
				return _ref.apply(this, arguments);
			}

			return loadImages;
		}()
	}, {
		key: 'handleImageChange',
		value: function handleImageChange(e) {
			var _this3 = this;

			e.preventDefault();

			var filesList = e.target.files;
			var _props2 = this.props,
			    onLoadStart = _props2.onLoadStart,
			    onLoadEnd = _props2.onLoadEnd,
			    url = _props2.url,
			    optimisticPreviews = _props2.optimisticPreviews,
			    multiple = _props2.multiple;


			if (onLoadStart && typeof onLoadStart === 'function') {
				onLoadStart();
			}

			this.setState({
				loadState: 'loading'
			});

			if (this.props.max && filesList.length + this.state.imagePreviewUrls.length > this.props.max) {
				var err = {
					message: 'exceeded the number'
				};
				this.setState({
					loadState: 'error',
					optimisticPreviews: []
				});
				if (onLoadEnd && typeof onLoadEnd === 'function') {
					onLoadEnd(err);
				}
				return;
			}

			for (var i = 0; i < filesList.length; i++) {
				var file = filesList[i];

				if (optimisticPreviews) {
					var reader = new FileReader();
					reader.onload = function (upload) {
						if (multiple === false) {
							_this3.setState({
								optimisticPreviews: [upload.target.result]
							});
						} else {
							var prevOptimisticPreviews = _this3.state.optimisticPreviews;
							_this3.setState({
								optimisticPreviews: prevOptimisticPreviews.concat(upload.target.result)
							});
						}
					};
					reader.readAsDataURL(file);
				}

				if (!file.type.match('image.*')) {
					var _err2 = {
						message: 'file type error',
						type: file.type,
						fileName: 'ImagesUploader'
					};
					if (onLoadEnd && typeof onLoadEnd === 'function') {
						onLoadEnd(_err2);
					}
					this.setState({
						loadState: 'error'
					});
					return;
				}
			}

			if (url) {
				this.loadImages(filesList, url, onLoadEnd);
			}
		}
	}, {
		key: 'handleFileDrop',
		value: function handleFileDrop(files) {
			if (!this.props.disabled) {
				this.handleImageChange({
					preventDefault: function preventDefault() {
						return true;
					},
					target: {
						files: files
					}
				});
			}
		}

		/* eslint-disable max-len, no-undef */

	}, {
		key: 'buildPlus',
		value: function buildPlus(disabled, color, disabledColor, plusElement) {
			return plusElement || _react2.default.createElement(
				'svg',
				{
					version: '1.1',
					xmlns: 'http://www.w3.org/2000/svg',
					style: {
						width: 35,
						fill: disabled ? disabledColor : color
					},
					xmlnsXlink: 'http://www.w3.org/1999/xlink',
					x: '0px',
					y: '0px',
					viewBox: '0 0 1000 1000',
					enableBackground: 'new 0 0 1000 1000',
					xmlSpace: 'preserve' },
				_react2.default.createElement(
					'g',
					null,
					_react2.default.createElement('path', {
						d: 'M500,10c13.5,0,25.1,4.8,34.7,14.4C544.2,33.9,549,45.5,549,59v392h392c13.5,0,25.1,4.8,34.7,14.4c9.6,9.6,14.4,21.1,14.4,34.7c0,13.5-4.8,25.1-14.4,34.6c-9.6,9.6-21.1,14.4-34.7,14.4H549v392c0,13.5-4.8,25.1-14.4,34.7c-9.6,9.6-21.1,14.4-34.7,14.4c-13.5,0-25.1-4.8-34.7-14.4c-9.6-9.6-14.4-21.1-14.4-34.7V549H59c-13.5,0-25.1-4.8-34.7-14.4C14.8,525.1,10,513.5,10,500c0-13.5,4.8-25.1,14.4-34.7C33.9,455.8,45.5,451,59,451h392V59c0-13.5,4.8-25.1,14.4-34.7C474.9,14.8,486.5,10,500,10L500,10z'
					})
				)
			);
		}
		/* eslint-enable max-len, no-undef */

	}, {
		key: 'buildButtonContent',
		value: function buildButtonContent() {
			var _props3 = this.props,
			    multiple = _props3.multiple,
			    classNamespace = _props3.classNamespace,
			    disabled = _props3.disabled,
			    classNames = _props3.classNames,
			    styles = _props3.styles,
			    color = _props3.color,
			    disabledColor = _props3.disabledColor,
			    plusElement = _props3.plusElement;


			var pseudobuttonContentStyle = (0, _extends3.default)({
				color: disabled ? disabledColor : color
			}, styles.pseudobuttonContent);

			if (multiple !== false) {
				return _react2.default.createElement(
					'span',
					{
						className: classNames.pseudobuttonContent || classNamespace + 'pseudobuttonContent',
						style: pseudobuttonContentStyle },
					this.buildPlus(disabled, color, disabledColor, plusElement)
				);
			}
			var _state = this.state,
			    imagePreviewUrls = _state.imagePreviewUrls,
			    optimisticPreviews = _state.optimisticPreviews;

			if ((!imagePreviewUrls || imagePreviewUrls.length < 1) && (!optimisticPreviews || optimisticPreviews.length < 1)) {
				return _react2.default.createElement(
					'span',
					{
						className: classNames.pseudobuttonContent || classNamespace + 'pseudobuttonContent',
						style: pseudobuttonContentStyle },
					this.buildPlus(disabled, color, disabledColor, plusElement)
				);
			}
			return this.buildPreviews(imagePreviewUrls, optimisticPreviews, true);
		}
	}, {
		key: 'buildClose',
		value: function buildClose() {
			var _this4 = this;

			var _props4 = this.props,
			    multiple = _props4.multiple,
			    classNamespace = _props4.classNamespace,
			    disabled = _props4.disabled,
			    classNames = _props4.classNames,
			    styles = _props4.styles,
			    color = _props4.color,
			    disabledColor = _props4.disabledColor,
			    borderColor = _props4.borderColor,
			    disabledBorderColor = _props4.disabledBorderColor,
			    deleteElement = _props4.deleteElement;


			if (multiple !== false) {
				return null;
			}
			var imagePreviewUrls = this.state.imagePreviewUrls;

			if (!imagePreviewUrls || imagePreviewUrls.length < 1) {
				return null;
			}

			var deletePreviewStyle = (0, _extends3.default)({
				color: disabled ? disabledColor : color,
				borderColor: disabled ? disabledBorderColor : borderColor
			}, styles.deletePreview || {});

			return _react2.default.createElement(
				'div',
				{
					className: classNames.deletePreview || classNamespace + 'deletePreview',
					style: deletePreviewStyle,
					onClick: function onClick(e) {
						e.preventDefault();
						_this4.deleteImage(0);
					} },
				deleteElement || _react2.default.createElement(
					'svg',
					{ xmlns: 'http://www.w3.org/2000/svg', width: '7.969', height: '8', viewBox: '0 0 7.969 8' },
					_react2.default.createElement('path', {
						id: 'X_Icon',
						'data-name': 'X Icon',
						style: {
							fill: disabled ? disabledColor : color,
							fillRrule: 'evenodd'
						}
						/* eslint-disable max-len */
						, d: 'M562.036,606l2.849-2.863a0.247,0.247,0,0,0,0-.352l-0.7-.706a0.246,0.246,0,0,0-.352,0l-2.849,2.862-2.849-2.862a0.247,0.247,0,0,0-.352,0l-0.7.706a0.249,0.249,0,0,0,0,.352L559.927,606l-2.849,2.862a0.25,0.25,0,0,0,0,.353l0.7,0.706a0.249,0.249,0,0,0,.352,0l2.849-2.862,2.849,2.862a0.249,0.249,0,0,0,.352,0l0.7-.706a0.25,0.25,0,0,0,0-.353Z'
						/* eslint-enable max-len */
						, transform: 'translate(-557 -602)'
					})
				)
			);
		}
	}, {
		key: 'showNotification',
		value: function showNotification() {
			var _props5 = this.props,
			    multiple = _props5.multiple,
			    disabled = _props5.disabled;
			var imagePreviewUrls = this.state.imagePreviewUrls;

			if (!disabled && multiple === false && imagePreviewUrls && imagePreviewUrls.length > 0) {
				this.setState({
					displayNotification: true
				});
			}
		}
	}, {
		key: 'hideNotification',
		value: function hideNotification() {
			var multiple = this.props.multiple;

			if (multiple === false) {
				this.setState({
					displayNotification: false
				});
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _classnames,
			    _this5 = this;

			var _state2 = this.state,
			    imagePreviewUrls = _state2.imagePreviewUrls,
			    loadState = _state2.loadState,
			    optimisticPreviews = _state2.optimisticPreviews;
			var _props6 = this.props,
			    inputId = _props6.inputId,
			    disabled = _props6.disabled,
			    multiple = _props6.multiple,
			    label = _props6.label,
			    size = _props6.size,
			    classNamespace = _props6.classNamespace,
			    classNames = _props6.classNames,
			    styles = _props6.styles,
			    color = _props6.color,
			    disabledColor = _props6.disabledColor,
			    borderColor = _props6.borderColor,
			    disabledBorderColor = _props6.disabledBorderColor;


			var containerClassNames = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, classNames.container || classNamespace + 'container', true), (0, _defineProperty3.default)(_classnames, 'disabled', disabled), _classnames));

			var loadContainerStyle = (0, _extends3.default)({}, size ? {
				width: size,
				height: size
			} : {}, {
				color: disabled ? disabledColor : color
			}, styles.loadContainer || {});

			var pseudobuttonStyle = (0, _extends3.default)({}, size ? {
				width: size,
				height: size
			} : {}, {
				color: disabled ? disabledColor : color
			}, styles.pseudobuttonStyle || {});

			var labelStyle = (0, _extends3.default)({
				color: disabled ? disabledColor : color
			}, styles.label || {});

			var dropzoneStyle = (0, _extends3.default)({
				borderColor: disabled ? disabledBorderColor : borderColor
			}, styles.dropzone || {});

			return _react2.default.createElement(
				'div',
				{ className: containerClassNames, style: styles.container || {} },
				_react2.default.createElement(
					'label',
					{
						className: classNames.label || classNamespace + 'label',
						style: labelStyle,
						htmlFor: inputId || 'filesInput' },
					label || null
				),
				_react2.default.createElement(
					'div',
					{
						className: classNames.filesInputContainer || classNamespace + 'filesInputContainer',
						style: styles.filesInputContainer },
					_react2.default.createElement(
						'div',
						{
							className: classNames.loadContainer || classNamespace + 'loadContainer',
							style: loadContainerStyle },
						this.buildClose(),
						_react2.default.createElement(
							_reactDropzone2.default,
							{
								onDrop: this.handleFileDrop,
								disableClick: true,
								accept: 'image/*',
								className: classNames.dropzone || classNamespace + 'dropzone',
								style: dropzoneStyle,
								multiple:
								/* eslint-disable no-unneeded-ternary */
								multiple === false ? false : true
								/* eslint-enable no-unneeded-ternary */
							},
							_react2.default.createElement(
								_reactProgressButton2.default,
								{
									state: loadState,
									type: 'button',
									classNamespace: classNamespace + 'button-',
									className: classNames.pseudobutton || classNamespace + 'pseudobutton',
									style: pseudobuttonStyle,
									onClick: function onClick(e) {
										e.preventDefault();
										if (_this5.input) {
											_this5.input.click();
										}
									},
									onMouseOver: this.showNotification,
									onMouseLeave: this.hideNotification,
									onDragOver: this.showNotification,
									onDragLeave: this.hideNotification },
								this.buildButtonContent()
							)
						)
					),
					_react2.default.createElement('input', {
						name: inputId || 'filesInput',
						id: inputId || 'filesInput',
						className: classNames.fileInput || classNamespace + 'fileInput',
						style: (0, _extends3.default)({
							display: 'none'
						}, styles.fileInput || {}),
						ref: function ref(_ref2) {
							_this5.input = _ref2;
						},
						type: 'file',
						accept: 'image/*',
						multiple: multiple === false ? false : 'multiple',
						disabled: disabled || loadState === 'loading',
						onChange: this.handleImageChange
					})
				),
				multiple !== false ? this.buildPreviews(imagePreviewUrls, this.props.optimisticPreviews && optimisticPreviews) : null
			);
		}
	}]);
	return ImagesUploader;
}(_react.Component), (_applyDecoratedDescriptor(_class.prototype, 'clickImage', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'clickImage'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deleteImage', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'deleteImage'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'buildPreviews', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'buildPreviews'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadImages', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'loadImages'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleImageChange', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleImageChange'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleFileDrop', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleFileDrop'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'buildButtonContent', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'buildButtonContent'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'buildClose', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'buildClose'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'showNotification', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'showNotification'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hideNotification', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'hideNotification'), _class.prototype)), _class);
ImagesUploader.propTypes = {
	url: _react.PropTypes.string.isRequired,
	dataName: _react.PropTypes.string,
	headers: _react.PropTypes.object,
	classNamespace: _react.PropTypes.string,
	inputId: _react.PropTypes.string,
	label: _react.PropTypes.string,
	images: _react.PropTypes.array,
	disabled: _react.PropTypes.bool,
	onLoadStart: _react.PropTypes.func,
	onLoadEnd: _react.PropTypes.func,
	deleteImage: _react.PropTypes.func,
	clickImage: _react.PropTypes.func,
	optimisticPreviews: _react.PropTypes.bool,
	multiple: _react.PropTypes.bool,
	image: _react.PropTypes.string,
	notification: _react.PropTypes.string,
	max: _react.PropTypes.number,
	color: _react.PropTypes.string,
	disabledColor: _react.PropTypes.string,
	borderColor: _react.PropTypes.string,
	disabledBorderColor: _react.PropTypes.string,
	notificationBgColor: _react.PropTypes.string,
	notificationColor: _react.PropTypes.string,
	deleteElement: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	plusElement: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	classNames: _react.PropTypes.shape({
		container: _react.PropTypes.string,
		label: _react.PropTypes.string,
		deletePreview: _react.PropTypes.string,
		loadContainer: _react.PropTypes.string,
		dropzone: _react.PropTypes.string,
		pseudobutton: _react.PropTypes.string,
		pseudobuttonContent: _react.PropTypes.string,
		imgPreview: _react.PropTypes.string,
		fileInput: _react.PropTypes.string,
		emptyPreview: _react.PropTypes.string,
		filesInputContainer: _react.PropTypes.string,
		notification: _react.PropTypes.string
	}),
	styles: _react.PropTypes.shape({
		container: _react.PropTypes.object,
		label: _react.PropTypes.object,
		deletePreview: _react.PropTypes.object,
		loadContainer: _react.PropTypes.object,
		dropzone: _react.PropTypes.object,
		pseudobutton: _react.PropTypes.object,
		pseudobuttonContent: _react.PropTypes.object,
		imgPreview: _react.PropTypes.object,
		fileInput: _react.PropTypes.object,
		emptyPreview: _react.PropTypes.object,
		filesInputContainer: _react.PropTypes.object,
		notification: _react.PropTypes.object
	})
};
ImagesUploader.defaultProps = {
	dataName: 'imageFiles',
	headers: {},
	classNames: {},
	styles: {},
	multiple: true,
	color: '#142434',
	disabledColor: '#bec3c7',
	borderColor: '#a9bac8',
	disabledBorderColor: '#bec3c7',
	notificationBgColor: 'rgba(0, 0, 0, 0.3)',
	notificationColor: '#fafafa',
	classNamespace: 'iu-'
};
exports.default = ImagesUploader;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(ImagesUploader, 'ImagesUploader', 'src/index.jsx');
}();

;

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(387);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(1020);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 1020 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(1022);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1023), __esModule: true };

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(395);
__webpack_require__(254);
__webpack_require__(392);
__webpack_require__(1024);
__webpack_require__(1032);
__webpack_require__(1033);
module.exports = __webpack_require__(30).Promise;


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(139);
var global = __webpack_require__(35);
var ctx = __webpack_require__(113);
var classof = __webpack_require__(402);
var $export = __webpack_require__(55);
var isObject = __webpack_require__(80);
var aFunction = __webpack_require__(172);
var anInstance = __webpack_require__(1025);
var forOf = __webpack_require__(1026);
var speciesConstructor = __webpack_require__(431);
var task = __webpack_require__(432).set;
var microtask = __webpack_require__(1028)();
var newPromiseCapabilityModule = __webpack_require__(287);
var perform = __webpack_require__(433);
var userAgent = __webpack_require__(1029);
var promiseResolve = __webpack_require__(434);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(43)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(1030)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(175)($Promise, PROMISE);
__webpack_require__(1031)(PROMISE);
Wrapper = __webpack_require__(30)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(403)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1025 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(113);
var call = __webpack_require__(399);
var isArrayIter = __webpack_require__(400);
var anObject = __webpack_require__(72);
var toLength = __webpack_require__(248);
var getIterFn = __webpack_require__(401);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 1027 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(35);
var macrotask = __webpack_require__(432).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(138)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(35);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(94);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(35);
var core = __webpack_require__(30);
var dP = __webpack_require__(71);
var DESCRIPTORS = __webpack_require__(73);
var SPECIES = __webpack_require__(43)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(55);
var core = __webpack_require__(30);
var global = __webpack_require__(35);
var speciesConstructor = __webpack_require__(431);
var promiseResolve = __webpack_require__(434);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(55);
var newPromiseCapability = __webpack_require__(287);
var perform = __webpack_require__(433);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(36);

var ReactBaseClasses = __webpack_require__(436);
var ReactChildren = __webpack_require__(1036);
var ReactDOMFactories = __webpack_require__(1041);
var ReactElement = __webpack_require__(120);
var ReactPropTypes = __webpack_require__(1042);
var ReactVersion = __webpack_require__(1047);

var createReactClass = __webpack_require__(1048);
var onlyChild = __webpack_require__(1049);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(1037);
var ReactElement = __webpack_require__(120);

var emptyFunction = __webpack_require__(152);
var traverseAllChildren = __webpack_require__(1038);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(184);

var invariant = __webpack_require__(62);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(184);

var ReactCurrentOwner = __webpack_require__(439);
var REACT_ELEMENT_TYPE = __webpack_require__(440);

var getIteratorFn = __webpack_require__(1039);
var invariant = __webpack_require__(62);
var KeyEscapeUtils = __webpack_require__(1040);
var warning = __webpack_require__(96);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(120);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(120),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(441);

module.exports = factory(isValidElement);

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(1044);
var assign = __webpack_require__(36);

var ReactPropTypesSecret = __webpack_require__(319);
var checkPropTypes = __webpack_require__(1046);

var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if (false) {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (false) {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1045);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (false) {
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (false) {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(436),
    Component = _require.Component;

var _require2 = __webpack_require__(120),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(437);
var factory = __webpack_require__(289);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(184);

var ReactElement = __webpack_require__(120);

var invariant = __webpack_require__(62);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(1051);
module.exports = self.fetch.bind(self);


/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["Headers"] = Headers;
/* harmony export (immutable) */ __webpack_exports__["Request"] = Request;
/* harmony export (immutable) */ __webpack_exports__["Response"] = Response;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOMException", function() { return DOMException; });
/* harmony export (immutable) */ __webpack_exports__["fetch"] = fetch;
var support = {
  searchParams: 'URLSearchParams' in self,
  iterable: 'Symbol' in self && 'iterator' in Symbol,
  blob:
    'FileReader' in self &&
    'Blob' in self &&
    (function() {
      try {
        new Blob()
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in self,
  arrayBuffer: 'ArrayBuffer' in self
}

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ]

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name)
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
    throw new TypeError('Invalid character in header field name')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value)
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift()
      return {done: value === undefined, value: value}
    }
  }

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    }
  }

  return iterator
}

function Headers(headers) {
  this.map = {}

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value)
    }, this)
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      this.append(header[0], header[1])
    }, this)
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name])
    }, this)
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name)
  value = normalizeValue(value)
  var oldValue = this.map[name]
  this.map[name] = oldValue ? oldValue + ', ' + value : value
}

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)]
}

Headers.prototype.get = function(name) {
  name = normalizeName(name)
  return this.has(name) ? this.map[name] : null
}

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
}

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value)
}

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this)
    }
  }
}

Headers.prototype.keys = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push(name)
  })
  return iteratorFor(items)
}

Headers.prototype.values = function() {
  var items = []
  this.forEach(function(value) {
    items.push(value)
  })
  return iteratorFor(items)
}

Headers.prototype.entries = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push([name, value])
  })
  return iteratorFor(items)
}

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries
}

function consumed(body) {
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result)
    }
    reader.onerror = function() {
      reject(reader.error)
    }
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsArrayBuffer(blob)
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsText(blob)
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf)
  var chars = new Array(view.length)

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i])
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength)
    view.set(new Uint8Array(buf))
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false

  this._initBody = function(body) {
    this._bodyInit = body
    if (!body) {
      this._bodyText = ''
    } else if (typeof body === 'string') {
      this._bodyText = body
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString()
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer)
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer])
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body)
    } else {
      this._bodyText = body = Object.prototype.toString.call(body)
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8')
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type)
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
      }
    }
  }

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    }

    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
      } else {
        return this.blob().then(readBlobAsArrayBuffer)
      }
    }
  }

  this.text = function() {
    var rejected = consumed(this)
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  }

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode)
    }
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  }

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

function normalizeMethod(method) {
  var upcased = method.toUpperCase()
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  options = options || {}
  var body = options.body

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url
    this.credentials = input.credentials
    if (!options.headers) {
      this.headers = new Headers(input.headers)
    }
    this.method = input.method
    this.mode = input.mode
    this.signal = input.signal
    if (!body && input._bodyInit != null) {
      body = input._bodyInit
      input.bodyUsed = true
    }
  } else {
    this.url = String(input)
  }

  this.credentials = options.credentials || this.credentials || 'same-origin'
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers)
  }
  this.method = normalizeMethod(options.method || this.method || 'GET')
  this.mode = options.mode || this.mode || null
  this.signal = options.signal || this.signal
  this.referrer = null

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body)
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
}

function decode(body) {
  var form = new FormData()
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers()
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
  preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
    var parts = line.split(':')
    var key = parts.shift().trim()
    if (key) {
      var value = parts.join(':').trim()
      headers.append(key, value)
    }
  })
  return headers
}

Body.call(Request.prototype)

function Response(bodyInit, options) {
  if (!options) {
    options = {}
  }

  this.type = 'default'
  this.status = options.status === undefined ? 200 : options.status
  this.ok = this.status >= 200 && this.status < 300
  this.statusText = 'statusText' in options ? options.statusText : 'OK'
  this.headers = new Headers(options.headers)
  this.url = options.url || ''
  this._initBody(bodyInit)
}

Body.call(Response.prototype)

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
}

Response.error = function() {
  var response = new Response(null, {status: 0, statusText: ''})
  response.type = 'error'
  return response
}

var redirectStatuses = [301, 302, 303, 307, 308]

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
}

var DOMException = self.DOMException
try {
  new DOMException()
} catch (err) {
  DOMException = function(message, name) {
    this.message = message
    this.name = name
    var error = Error(message)
    this.stack = error.stack
  }
  DOMException.prototype = Object.create(Error.prototype)
  DOMException.prototype.constructor = DOMException
}

function fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init)

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest()

    function abortXhr() {
      xhr.abort()
    }

    xhr.onload = function() {
      var options = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      }
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
      var body = 'response' in xhr ? xhr.response : xhr.responseText
      resolve(new Response(body, options))
    }

    xhr.onerror = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.ontimeout = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.onabort = function() {
      reject(new DOMException('Aborted', 'AbortError'))
    }

    xhr.open(request.method, request.url, true)

    if (request.credentials === 'include') {
      xhr.withCredentials = true
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false
    }

    if ('responseType' in xhr && support.blob) {
      xhr.responseType = 'blob'
    }

    request.headers.forEach(function(value, name) {
      xhr.setRequestHeader(name, value)
    })

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr)

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr)
        }
      }
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
  })
}

fetch.polyfill = true

if (!self.fetch) {
  self.fetch = fetch
  self.Headers = Headers
  self.Request = Request
  self.Response = Response
}


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @copyright 2015, Andrey Popp <8mayday@gmail.com>
 *
 * The decorator may be used on classes or methods
 * ```
 * @autobind
 * class FullBound {}
 *
 * class PartBound {
 *   @autobind
 *   method () {}
 * }
 * ```
 */


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = autobind;

function autobind() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (args.length === 1) {
    return boundClass.apply(undefined, args);
  } else {
    return boundMethod.apply(undefined, args);
  }
}

/**
 * Use boundMethod to bind all methods on the target.prototype
 */
function boundClass(target) {
  // (Using reflect to get all keys including symbols)
  var keys = undefined;
  // Use Reflect if exists
  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
    keys = Reflect.ownKeys(target.prototype);
  } else {
    keys = Object.getOwnPropertyNames(target.prototype);
    // use symbols if support is provided
    if (typeof Object.getOwnPropertySymbols === 'function') {
      keys = keys.concat(Object.getOwnPropertySymbols(target.prototype));
    }
  }

  keys.forEach(function (key) {
    // Ignore special case target method
    if (key === 'constructor') {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(target.prototype, key);

    // Only methods need binding
    if (typeof descriptor.value === 'function') {
      Object.defineProperty(target.prototype, key, boundMethod(target, key, descriptor));
    }
  });
  return target;
}

/**
 * Return a descriptor removing the value and returning a getter
 * The getter will return a .bind version of the function
 * and memoize the result against a symbol on the instance
 */
function boundMethod(target, key, descriptor) {
  var fn = descriptor.value;

  if (typeof fn !== 'function') {
    throw new Error('@autobind decorator can only be applied to methods not: ' + typeof fn);
  }

  // In IE11 calling Object.defineProperty has a side-effect of evaluating the
  // getter for the property which is being replaced. This causes infinite
  // recursion and an "Out of stack space" error.
  var definingProperty = false;

  return {
    configurable: true,
    get: function get() {
      if (definingProperty || this === target.prototype || this.hasOwnProperty(key)) {
        return fn;
      }

      var boundFn = fn.bind(this);
      definingProperty = true;
      Object.defineProperty(this, key, {
        value: boundFn,
        configurable: true,
        writable: true
      });
      definingProperty = false;
      return boundFn;
    }
  };
}
module.exports = exports['default'];


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(435), __webpack_require__(4));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types"], factory);
	else if(typeof exports === 'object')
		exports["Dropzone"] = factory(require("react"), require("prop-types"));
	else
		root["Dropzone"] = factory(root["react"], root["prop-types"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _attrAccept = __webpack_require__(4);
	
	var _attrAccept2 = _interopRequireDefault(_attrAccept);
	
	var _getDataTransferItems = __webpack_require__(5);
	
	var _getDataTransferItems2 = _interopRequireDefault(_getDataTransferItems);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint prefer-template: 0 */
	
	var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;
	
	function fileAccepted(file, accept) {
	  // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
	  // that MIME type will always be accepted
	  return file.type === 'application/x-moz-file' || (0, _attrAccept2.default)(file, accept);
	}
	
	var Dropzone = function (_React$Component) {
	  _inherits(Dropzone, _React$Component);
	
	  _createClass(Dropzone, null, [{
	    key: 'onDocumentDragOver',
	    value: function onDocumentDragOver(evt) {
	      // allow the entire document to be a drag target
	      evt.preventDefault();
	    }
	  }]);
	
	  function Dropzone(props, context) {
	    _classCallCheck(this, Dropzone);
	
	    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));
	
	    _this.renderChildren = function (children, isDragActive, isDragReject) {
	      if (typeof children === 'function') {
	        return children(_extends({}, _this.state, { isDragActive: isDragActive, isDragReject: isDragReject }));
	      }
	      return children;
	    };
	
	    _this.onClick = _this.onClick.bind(_this);
	    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
	    _this.onDragStart = _this.onDragStart.bind(_this);
	    _this.onDragEnter = _this.onDragEnter.bind(_this);
	    _this.onDragLeave = _this.onDragLeave.bind(_this);
	    _this.onDragOver = _this.onDragOver.bind(_this);
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
	    _this.setRef = _this.setRef.bind(_this);
	    _this.setRefs = _this.setRefs.bind(_this);
	    _this.onInputElementClick = _this.onInputElementClick.bind(_this);
	    _this.isFileDialogActive = false;
	    _this.state = {
	      draggedFiles: [],
	      acceptedFiles: [],
	      rejectedFiles: []
	    };
	    return _this;
	  }
	
	  _createClass(Dropzone, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var preventDropOnDocument = this.props.preventDropOnDocument;
	
	      this.dragTargets = [];
	
	      if (preventDropOnDocument) {
	        document.addEventListener('dragover', Dropzone.onDocumentDragOver, false);
	        document.addEventListener('drop', this.onDocumentDrop, false);
	      }
	      this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
	      // Tried implementing addEventListener, but didn't work out
	      document.body.onfocus = this.onFileDialogCancel;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var preventDropOnDocument = this.props.preventDropOnDocument;
	
	      if (preventDropOnDocument) {
	        document.removeEventListener('dragover', Dropzone.onDocumentDragOver);
	        document.removeEventListener('drop', this.onDocumentDrop);
	      }
	      this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
	      // Can be replaced with removeEventListener, if addEventListener works
	      document.body.onfocus = null;
	    }
	  }, {
	    key: 'onDocumentDrop',
	    value: function onDocumentDrop(evt) {
	      if (this.node.contains(evt.target)) {
	        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
	        return;
	      }
	      evt.preventDefault();
	      this.dragTargets = [];
	    }
	  }, {
	    key: 'onDragStart',
	    value: function onDragStart(evt) {
	      if (this.props.onDragStart) {
	        this.props.onDragStart.call(this, evt);
	      }
	    }
	  }, {
	    key: 'onDragEnter',
	    value: function onDragEnter(evt) {
	      evt.preventDefault();
	
	      // Count the dropzone and any children that are entered.
	      if (this.dragTargets.indexOf(evt.target) === -1) {
	        this.dragTargets.push(evt.target);
	      }
	
	      this.setState({ draggedFiles: (0, _getDataTransferItems2.default)(evt) });
	
	      if (this.props.onDragEnter) {
	        this.props.onDragEnter.call(this, evt);
	      }
	    }
	  }, {
	    key: 'onDragOver',
	    value: function onDragOver(evt) {
	      // eslint-disable-line class-methods-use-this
	      evt.preventDefault();
	      evt.stopPropagation();
	      try {
	        evt.dataTransfer.dropEffect = 'copy'; // eslint-disable-line no-param-reassign
	      } catch (err) {
	        // continue regardless of error
	      }
	
	      if (this.props.onDragOver) {
	        this.props.onDragOver.call(this, evt);
	      }
	      return false;
	    }
	  }, {
	    key: 'onDragLeave',
	    value: function onDragLeave(evt) {
	      var _this2 = this;
	
	      evt.preventDefault();
	
	      // Only deactivate once the dropzone and all children have been left.
	      this.dragTargets = this.dragTargets.filter(function (el) {
	        return el !== evt.target && _this2.node.contains(el);
	      });
	      if (this.dragTargets.length > 0) {
	        return;
	      }
	
	      // Clear dragging files state
	      this.setState({ draggedFiles: [] });
	
	      if (this.props.onDragLeave) {
	        this.props.onDragLeave.call(this, evt);
	      }
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop(evt) {
	      var _this3 = this;
	
	      var _props = this.props,
	          onDrop = _props.onDrop,
	          onDropAccepted = _props.onDropAccepted,
	          onDropRejected = _props.onDropRejected,
	          multiple = _props.multiple,
	          disablePreview = _props.disablePreview,
	          accept = _props.accept;
	
	      var fileList = (0, _getDataTransferItems2.default)(evt);
	      var acceptedFiles = [];
	      var rejectedFiles = [];
	
	      // Stop default browser behavior
	      evt.preventDefault();
	
	      // Reset the counter along with the drag on a drop.
	      this.dragTargets = [];
	      this.isFileDialogActive = false;
	
	      fileList.forEach(function (file) {
	        if (!disablePreview) {
	          try {
	            file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
	          } catch (err) {
	            if (process.env.NODE_ENV !== 'production') {
	              console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
	            }
	          }
	        }
	
	        if (fileAccepted(file, accept) && _this3.fileMatchSize(file)) {
	          acceptedFiles.push(file);
	        } else {
	          rejectedFiles.push(file);
	        }
	      });
	
	      if (!multiple) {
	        // if not in multi mode add any extra accepted files to rejected.
	        // This will allow end users to easily ignore a multi file drop in "single" mode.
	        rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
	      }
	
	      if (onDrop) {
	        onDrop.call(this, acceptedFiles, rejectedFiles, evt);
	      }
	
	      if (rejectedFiles.length > 0 && onDropRejected) {
	        onDropRejected.call(this, rejectedFiles, evt);
	      }
	
	      if (acceptedFiles.length > 0 && onDropAccepted) {
	        onDropAccepted.call(this, acceptedFiles, evt);
	      }
	
	      // Clear files value
	      this.draggedFiles = null;
	
	      // Reset drag state
	      this.setState({
	        draggedFiles: [],
	        acceptedFiles: acceptedFiles,
	        rejectedFiles: rejectedFiles
	      });
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(evt) {
	      var _props2 = this.props,
	          onClick = _props2.onClick,
	          disableClick = _props2.disableClick;
	
	      if (!disableClick) {
	        evt.stopPropagation();
	
	        if (onClick) {
	          onClick.call(this, evt);
	        }
	
	        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
	        // this is so react can handle state changes in the onClick prop above above
	        // see: https://github.com/okonet/react-dropzone/issues/450
	        setTimeout(this.open.bind(this), 0);
	      }
	    }
	  }, {
	    key: 'onInputElementClick',
	    value: function onInputElementClick(evt) {
	      evt.stopPropagation();
	      if (this.props.inputProps && this.props.inputProps.onClick) {
	        this.props.inputProps.onClick();
	      }
	    }
	  }, {
	    key: 'onFileDialogCancel',
	    value: function onFileDialogCancel() {
	      // timeout will not recognize context of this method
	      var onFileDialogCancel = this.props.onFileDialogCancel;
	      var fileInputEl = this.fileInputEl;
	      var isFileDialogActive = this.isFileDialogActive;
	      // execute the timeout only if the onFileDialogCancel is defined and FileDialog
	      // is opened in the browser
	
	      if (onFileDialogCancel && isFileDialogActive) {
	        setTimeout(function () {
	          // Returns an object as FileList
	          var FileList = fileInputEl.files;
	          if (!FileList.length) {
	            isFileDialogActive = false;
	            onFileDialogCancel();
	          }
	        }, 300);
	      }
	    }
	  }, {
	    key: 'setRef',
	    value: function setRef(ref) {
	      this.node = ref;
	    }
	  }, {
	    key: 'setRefs',
	    value: function setRefs(ref) {
	      this.fileInputEl = ref;
	    }
	  }, {
	    key: 'fileMatchSize',
	    value: function fileMatchSize(file) {
	      return file.size <= this.props.maxSize && file.size >= this.props.minSize;
	    }
	  }, {
	    key: 'allFilesAccepted',
	    value: function allFilesAccepted(files) {
	      var _this4 = this;
	
	      return files.every(function (file) {
	        return fileAccepted(file, _this4.props.accept);
	      });
	    }
	
	    /**
	     * Open system file upload dialog.
	     *
	     * @public
	     */
	
	  }, {
	    key: 'open',
	    value: function open() {
	      this.isFileDialogActive = true;
	      this.fileInputEl.value = null;
	      this.fileInputEl.click();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          accept = _props3.accept,
	          activeClassName = _props3.activeClassName,
	          inputProps = _props3.inputProps,
	          multiple = _props3.multiple,
	          name = _props3.name,
	          rejectClassName = _props3.rejectClassName,
	          children = _props3.children,
	          rest = _objectWithoutProperties(_props3, ['accept', 'activeClassName', 'inputProps', 'multiple', 'name', 'rejectClassName', 'children']);
	
	      var activeStyle = rest.activeStyle,
	          className = rest.className,
	          rejectStyle = rest.rejectStyle,
	          style = rest.style,
	          props = _objectWithoutProperties(rest, ['activeStyle', 'className', 'rejectStyle', 'style']);
	
	      var draggedFiles = this.state.draggedFiles;
	
	      var filesCount = draggedFiles.length;
	      var isMultipleAllowed = multiple || filesCount <= 1;
	      var isDragActive = filesCount > 0 && this.allFilesAccepted(draggedFiles);
	      var isDragReject = filesCount > 0 && (!isDragActive || !isMultipleAllowed);
	
	      className = className || '';
	
	      if (isDragActive && activeClassName) {
	        className += ' ' + activeClassName;
	      }
	      if (isDragReject && rejectClassName) {
	        className += ' ' + rejectClassName;
	      }
	
	      if (!className && !style && !activeStyle && !rejectStyle) {
	        style = {
	          width: 200,
	          height: 200,
	          borderWidth: 2,
	          borderColor: '#666',
	          borderStyle: 'dashed',
	          borderRadius: 5
	        };
	        activeStyle = {
	          borderStyle: 'solid',
	          borderColor: '#6c6',
	          backgroundColor: '#eee'
	        };
	        rejectStyle = {
	          borderStyle: 'solid',
	          borderColor: '#c66',
	          backgroundColor: '#eee'
	        };
	      }
	
	      var appliedStyle = void 0;
	      if (activeStyle && isDragActive) {
	        appliedStyle = _extends({}, style, activeStyle);
	      } else if (rejectStyle && isDragReject) {
	        appliedStyle = _extends({}, style, rejectStyle);
	      } else {
	        appliedStyle = _extends({}, style);
	      }
	
	      var inputAttributes = {
	        accept: accept,
	        type: 'file',
	        style: { display: 'none' },
	        multiple: supportMultiple && multiple,
	        ref: this.setRefs,
	        onChange: this.onDrop
	      };
	
	      if (name && name.length) {
	        inputAttributes.name = name;
	      }
	
	      // Remove custom properties before passing them to the wrapper div element
	      var customProps = ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize'];
	      var divProps = _extends({}, props);
	      customProps.forEach(function (prop) {
	        return delete divProps[prop];
	      });
	
	      return _react2.default.createElement(
	        'div',
	        _extends({
	          className: className,
	          style: appliedStyle
	        }, divProps /* expand user provided props first so event handlers are never overridden */, {
	          onClick: this.onClick,
	          onDragStart: this.onDragStart,
	          onDragEnter: this.onDragEnter,
	          onDragOver: this.onDragOver,
	          onDragLeave: this.onDragLeave,
	          onDrop: this.onDrop,
	          ref: this.setRef
	        }),
	        this.renderChildren(children, isDragActive, isDragReject),
	        _react2.default.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
	      );
	    }
	  }]);
	
	  return Dropzone;
	}(_react2.default.Component);
	
	Dropzone.propTypes = {
	  /**
	   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
	   * Keep in mind that mime type determination is not reliable accross platforms. CSV files,
	   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
	   * Windows. In some cases there might not be a mime type set at all.
	   * See: https://github.com/okonet/react-dropzone/issues/276
	   */
	  accept: _propTypes2.default.string,
	
	  /**
	   * Contents of the dropzone
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	
	  /**
	   * Disallow clicking on the dropzone container to open file dialog
	   */
	  disableClick: _propTypes2.default.bool,
	
	  /**
	   * Enable/disable preview generation
	   */
	  disablePreview: _propTypes2.default.bool,
	
	  /**
	   * If false, allow dropped items to take over the current browser window
	   */
	  preventDropOnDocument: _propTypes2.default.bool,
	
	  /**
	   * Pass additional attributes to the `<input type="file"/>` tag
	   */
	  inputProps: _propTypes2.default.object,
	
	  /**
	   * Allow dropping multiple files
	   */
	  multiple: _propTypes2.default.bool,
	
	  /**
	   * `name` attribute for the input tag
	   */
	  name: _propTypes2.default.string,
	
	  /**
	   * Maximum file size
	   */
	  maxSize: _propTypes2.default.number,
	
	  /**
	   * Minimum file size
	   */
	  minSize: _propTypes2.default.number,
	
	  /**
	   * className
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * className for accepted state
	   */
	  activeClassName: _propTypes2.default.string,
	
	  /**
	   * className for rejected state
	   */
	  rejectClassName: _propTypes2.default.string,
	
	  /**
	   * CSS styles to apply
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * CSS styles to apply when drop will be accepted
	   */
	  activeStyle: _propTypes2.default.object,
	
	  /**
	   * CSS styles to apply when drop will be rejected
	   */
	  rejectStyle: _propTypes2.default.object,
	
	  /**
	   * onClick callback
	   * @param {Event} event
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * onDrop callback
	   */
	  onDrop: _propTypes2.default.func,
	
	  /**
	   * onDropAccepted callback
	   */
	  onDropAccepted: _propTypes2.default.func,
	
	  /**
	   * onDropRejected callback
	   */
	  onDropRejected: _propTypes2.default.func,
	
	  /**
	   * onDragStart callback
	   */
	  onDragStart: _propTypes2.default.func,
	
	  /**
	   * onDragEnter callback
	   */
	  onDragEnter: _propTypes2.default.func,
	
	  /**
	   * onDragOver callback
	   */
	  onDragOver: _propTypes2.default.func,
	
	  /**
	   * onDragLeave callback
	   */
	  onDragLeave: _propTypes2.default.func,
	
	  /**
	   * Provide a callback on clicking the cancel button of the file dialog
	   */
	  onFileDialogCancel: _propTypes2.default.func
	};
	
	Dropzone.defaultProps = {
	  preventDropOnDocument: true,
	  disablePreview: false,
	  disableClick: false,
	  multiple: true,
	  maxSize: Infinity,
	  minSize: 0
	};
	
	exports.default = Dropzone;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={exports:{},id:e,loaded:!1};return t[e].call(o.exports,o,o.exports,n),o.loaded=!0,o.exports}var r={};return n.m=t,n.c=r,n.p="",n(0)}([function(t,n,r){"use strict";n.__esModule=!0,r(8),r(9),n["default"]=function(t,n){if(t&&n){var r=function(){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return{v:r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):/\/\*$/.test(n)?i===n.replace(/\/.*$/,""):o===n})}}();if("object"==typeof r)return r.v}return!0},t.exports=n["default"]},function(t,n){var r=t.exports={version:"1.2.2"};"number"==typeof __e&&(__e=r)},function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n,r){var e=r(2),o=r(1),i=r(4),u=r(19),c="prototype",f=function(t,n){return function(){return t.apply(n,arguments)}},s=function(t,n,r){var a,p,l,y,d=t&s.G,h=t&s.P,v=d?e:t&s.S?e[n]||(e[n]={}):(e[n]||{})[c],x=d?o:o[n]||(o[n]={});d&&(r=n);for(a in r)p=!(t&s.F)&&v&&a in v,l=(p?v:r)[a],y=t&s.B&&p?f(l,e):h&&"function"==typeof l?f(Function.call,l):l,v&&!p&&u(v,a,l),x[a]!=l&&i(x,a,y),h&&((x[c]||(x[c]={}))[a]=l)};e.core=o,s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,t.exports=s},function(t,n,r){var e=r(5),o=r(18);t.exports=r(22)?function(t,n,r){return e.setDesc(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=Object;t.exports={create:r.create,getProto:r.getPrototypeOf,isEnum:{}.propertyIsEnumerable,getDesc:r.getOwnPropertyDescriptor,setDesc:r.defineProperty,setDescs:r.defineProperties,getKeys:r.keys,getNames:r.getOwnPropertyNames,getSymbols:r.getOwnPropertySymbols,each:[].forEach}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(20)("wks"),o=r(2).Symbol;t.exports=function(t){return e[t]||(e[t]=o&&o[t]||(o||r(6))("Symbol."+t))}},function(t,n,r){r(26),t.exports=r(1).Array.some},function(t,n,r){r(25),t.exports=r(1).String.endsWith},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(10);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(e){try{return n[r(7)("match")]=!1,!"/./"[t](n)}catch(o){}}return!0}},function(t,n){t.exports=function(t){try{return!!t()}catch(n){return!0}}},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n,r){var e=r(16),o=r(11),i=r(7)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(2),o=r(4),i=r(6)("src"),u="toString",c=Function[u],f=(""+c).split(u);r(1).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,u){"function"==typeof r&&(o(r,i,t[n]?""+t[n]:f.join(String(n))),"name"in r||(r.name=n)),t===e?t[n]=r:(u||delete t[n],o(t,n,r))})(Function.prototype,u,function(){return"function"==typeof this&&this[i]||c.call(this)})},function(t,n,r){var e=r(2),o="__core-js_shared__",i=e[o]||(e[o]={});t.exports=function(t){return i[t]||(i[t]={})}},function(t,n,r){var e=r(17),o=r(13);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){t.exports=!r(15)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(23),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";var e=r(3),o=r(24),i=r(21),u="endsWith",c=""[u];e(e.P+e.F*r(14)(u),"String",{endsWith:function(t){var n=i(this,t,u),r=arguments,e=r.length>1?r[1]:void 0,f=o(n.length),s=void 0===e?f:Math.min(o(e),f),a=String(t);return c?c.call(n,a,s):n.slice(s-a.length,s)===a}})},function(t,n,r){var e=r(5),o=r(3),i=r(1).Array||Array,u={},c=function(t,n){e.each.call(t.split(","),function(t){void 0==n&&t in i?u[t]=i[t]:t in[]&&(u[t]=r(12)(Function.call,[][t],n))})};c("pop,reverse,shift,keys,values,entries",1),c("indexOf,every,some,forEach,map,filter,find,findIndex,includes",3),c("join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill"),o(o.S,"Array",u)}]);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDataTransferFiles;
	function getDataTransferFiles(event) {
	  var dataTransferItemsList = [];
	  if (event.dataTransfer) {
	    var dt = event.dataTransfer;
	    if (dt.files && dt.files.length) {
	      dataTransferItemsList = dt.files;
	    } else if (dt.items && dt.items.length) {
	      // During the drag even the dataTransfer.files is null
	      // but Chrome implements some drag store, which is accesible via dataTransfer.items
	      dataTransferItemsList = dt.items;
	    }
	  } else if (event.target && event.target.files) {
	    dataTransferItemsList = event.target.files;
	  }
	  // Convert from DataTransferItemsList to the native Array
	  return Array.prototype.slice.call(dataTransferItemsList);
	}
	module.exports = exports["default"];

/***/ })
/******/ ])
});
;
//# sourceMappingURL=index.js.map

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(1055);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var STATE = exports.STATE = {
  LOADING: 'loading',
  DISABLED: 'disabled',
  SUCCESS: 'success',
  ERROR: 'error',
  NOTHING: ''
};

var ProgressButton = (0, _createReactClass2.default)({
  displayName: 'ProgressButton',

  propTypes: {
    classNamespace: _propTypes2.default.string,
    controlled: _propTypes2.default.bool,
    durationError: _propTypes2.default.number,
    durationSuccess: _propTypes2.default.number,
    form: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    onError: _propTypes2.default.func,
    onSuccess: _propTypes2.default.func,
    state: _propTypes2.default.oneOf(Object.keys(STATE).map(function (k) {
      return STATE[k];
    })),
    type: _propTypes2.default.string,
    shouldAllowClickOnLoading: _propTypes2.default.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      classNamespace: 'pb-',
      controlled: false,
      durationError: 1200,
      durationSuccess: 500,
      onClick: function onClick() {},
      onError: function onError() {},
      onSuccess: function onSuccess() {},

      shouldAllowClickOnLoading: false
    };
  },
  getInitialState: function getInitialState() {
    return {
      currentState: this.props.state || STATE.NOTHING
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.state === this.props.state) {
      return;
    }
    switch (nextProps.state) {
      case STATE.SUCCESS:
        this.success();
        return;
      case STATE.ERROR:
        this.error();
        return;
      case STATE.LOADING:
        this.loading();
        return;
      case STATE.DISABLED:
        this.disable();
        return;
      case STATE.NOTHING:
        this.notLoading();
        return;
      default:
        return;
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    clearTimeout(this._timeout);
  },
  render: function render() {
    var _props = this.props,
        className = _props.className,
        classNamespace = _props.classNamespace,
        children = _props.children,
        type = _props.type,
        form = _props.form,
        durationError = _props.durationError,
        durationSuccess = _props.durationSuccess,
        onClick = _props.onClick,
        onError = _props.onError,
        onSuccess = _props.onSuccess,
        state = _props.state,
        shouldAllowClickOnLoading = _props.shouldAllowClickOnLoading,
        controlled = _props.controlled,
        containerProps = _objectWithoutProperties(_props, ['className', 'classNamespace', 'children', 'type', 'form', 'durationError', 'durationSuccess', 'onClick', 'onError', 'onSuccess', 'state', 'shouldAllowClickOnLoading', 'controlled']);

    containerProps.className = classNamespace + 'container ' + this.state.currentState + ' ' + className;
    containerProps.onClick = this.handleClick;
    return _react2.default.createElement(
      'div',
      containerProps,
      _react2.default.createElement(
        'button',
        { disabled: state === STATE.DISABLED, type: type, form: form, className: classNamespace + 'button' },
        _react2.default.createElement(
          'span',
          null,
          children
        ),
        _react2.default.createElement(
          'svg',
          { className: classNamespace + 'progress-circle', viewBox: '0 0 41 41' },
          _react2.default.createElement('path', { d: 'M38,20.5 C38,30.1685093 30.1685093,38 20.5,38' })
        ),
        _react2.default.createElement(
          'svg',
          { className: classNamespace + 'checkmark', viewBox: '0 0 70 70' },
          _react2.default.createElement('path', { d: 'm31.5,46.5l15.3,-23.2' }),
          _react2.default.createElement('path', { d: 'm31.5,46.5l-8.5,-7.1' })
        ),
        _react2.default.createElement(
          'svg',
          { className: classNamespace + 'cross', viewBox: '0 0 70 70' },
          _react2.default.createElement('path', { d: 'm35,35l-9.3,-9.3' }),
          _react2.default.createElement('path', { d: 'm35,35l9.3,9.3' }),
          _react2.default.createElement('path', { d: 'm35,35l-9.3,9.3' }),
          _react2.default.createElement('path', { d: 'm35,35l9.3,-9.3' })
        )
      )
    );
  },
  handleClick: function handleClick(e) {
    if (this.props.controlled) {
      this.props.onClick(e);
      return true;
    }

    if ((this.props.shouldAllowClickOnLoading || this.state.currentState !== STATE.LOADING) && this.state.currentState !== STATE.DISABLED) {
      this.loading();
      var ret = this.props.onClick(e);
      this.handlePromise(ret);
    } else {
      e.preventDefault();
    }
  },
  handlePromise: function handlePromise(promise) {
    var _this = this;

    if (promise && promise.then && promise.catch) {
      promise.then(function () {
        _this.success();
      }).catch(function (err) {
        _this.error(null, err);
      });
    }
  },
  loading: function loading() {
    this.setState({ currentState: STATE.LOADING });
  },
  notLoading: function notLoading() {
    this.setState({ currentState: STATE.NOTHING });
  },
  enable: function enable() {
    this.setState({ currentState: STATE.NOTHING });
  },
  disable: function disable() {
    this.setState({ currentState: STATE.DISABLED });
  },
  success: function success(callback, dontRemove) {
    var _this2 = this;

    this.setState({ currentState: STATE.SUCCESS });
    this._timeout = setTimeout(function () {
      if (!dontRemove) {
        _this2.setState({ currentState: STATE.NOTHING });
      }
      callback = callback || _this2.props.onSuccess;
      if (typeof callback === 'function') {
        callback();
      }
    }, this.props.durationSuccess);
  },
  error: function error(callback, err) {
    var _this3 = this;

    this.setState({ currentState: STATE.ERROR });
    this._timeout = setTimeout(function () {
      _this3.setState({ currentState: STATE.NOTHING });
      callback = callback || _this3.props.onError;
      if (typeof callback === 'function') {
        callback(err);
      }
    }, this.props.durationError);
  }
});

exports.default = ProgressButton;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(289);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint max-len: 0 */
// TODO: eventually deprecate this console.trace("use the `babel-register` package instead of `babel-core/register`");
module.exports = __webpack_require__(1057);


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function () {};

module.exports = exports["default"];

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_components_ImageLoader_css__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_components_ImageLoader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__css_components_ImageLoader_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_NativeAjax__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_core_LoggedInPage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//Hardcoded for now. Will be moved to DB
var maxPictureSizeInKb=200;var maxFileNameLength=0;var picExtensions=["jpeg","jpg","png"];var unsupportedCharacters="?!#$%&<>()~:;'^\"\\/";var ImageUpload=function(_LoggedInPage){_inherits(ImageUpload,_LoggedInPage);function ImageUpload(props){_classCallCheck(this,ImageUpload);var _this=_possibleConstructorReturn(this,(ImageUpload.__proto__||Object.getPrototypeOf(ImageUpload)).call(this,props));_this.state={file:'',imagePreviewUrl:'',imageLoaded:false};_this._handleImageChange=_this._handleImageChange.bind(_this);_this._handleSubmit=_this._handleSubmit.bind(_this);_this.prevFn=_this.prevFn.bind(_this);_this.deleteImage=_this.deleteImage.bind(_this);_this.callback=_this.props.callback||function(imageUrl){};return _this;}_createClass(ImageUpload,[{key:'isSizeValid',value:function isSizeValid(fileSizeinBytes){if(fileSizeinBytes&&maxPictureSizeInKb){var fileSizeinKb=Math.round(fileSizeinBytes/1000);return fileSizeinKb<=maxPictureSizeInKb;}console.warn("maxPictureSizeInKb not configured.");return false;}},{key:'isFileTypeValid',value:function isFileTypeValid(filename){if(filename&&picExtensions){for(var i=0;i<picExtensions.length;i++){if(filename.endsWith("."+picExtensions[i].toLowerCase())||filename.endsWith("."+picExtensions[i].toUpperCase())){return true;}}}return false;}},{key:'isFileNameLengthValid',value:function isFileNameLengthValid(filename){if(!maxFileNameLength){return true;}else if(filename){return filename.length<=maxFileNameLength;}return false;}},{key:'isFileNameValid',value:function isFileNameValid(filename){if(filename&&unsupportedCharacters){return!filename.match("["+unsupportedCharacters+"]+");}return false;}},{key:'componentWillMount',value:function componentWillMount(){this.setCurrentImage();if(typeof document!=='undefined'){document.addEventListener('dragover',function(event){// prevent default to allow drop
event.preventDefault();},false);document.addEventListener('drop',function(event){// prevent default to allow drop
event.preventDefault();},false);}}},{key:'setCurrentImage',value:function setCurrentImage(){var me=this;var success=function success(response){if(response&&response.imgUrl){me.setState({imagePreviewUrl:response.imgUrl,imageLoaded:true});me.callback.apply(this,[me.state.imagePreviewUrl]);}};var failure=function failure(err){//Nothing as of now
};new __WEBPACK_IMPORTED_MODULE_2__util_HmAjax__["a" /* default */](this.getUrlFor("PROFILE_PIC")).get(success,failure);}},{key:'uploadImage',value:function uploadImage(imageFile,elem){var me=this;var success=function success(response){if(response&&response.imgUrl){me.setState({imagePreviewUrl:response.imgUrl,imageLoaded:true});me.callback.apply(this,[me.state.imagePreviewUrl]);}else if(response&&response.status&&response.status==="error"){me.showAlert(me.rb("system_error"),me.rb("pic.err.generic"));return;}};var failure=function failure(err){};if(imageFile){// console.log("imageFile :::", imageFile);
var uploadValid=true;var errLabel="";var errMsg="";if(imageFile.name&&!me.isFileNameLengthValid(imageFile.name)){uploadValid=false;errLabel=me.rb("pic.label.file_name_length_invalid");errMsg=me.rb("pic.msg.file_name_length_invalid").replace("{1}",maxFileNameLength);}else if(imageFile.name&&!me.isFileNameValid(imageFile.name)){uploadValid=false;errLabel=me.rb("pic.label.file_name_invalid");errMsg=me.rb("pic.msg.file_name_invalid").replace("{1}",unsupportedCharacters.split("").join(" "));}else if(imageFile.name&&!me.isFileTypeValid(imageFile.name)){uploadValid=false;errLabel=me.rb("pic.label.file_format_invalid");errMsg=me.rb("pic.msg.file_format_invalid").replace("{1}",picExtensions.join("/"));}else if(imageFile.size&&!me.isSizeValid(imageFile.size)){uploadValid=false;errLabel=me.rb("pic.label.file_size_exceed");errMsg=me.rb("pic.msg.file_size_exceed").replace("{1}",maxPictureSizeInKb);}if(!uploadValid){me.showAlert(errLabel,errMsg);//Clear the element for retries
if(elem){elem.value=null;}me.setState({file:' '});return;}var myObj={"file":imageFile};new __WEBPACK_IMPORTED_MODULE_3__util_NativeAjax__["a" /* default */](this.getUrlFor("PROFILE_PIC")).enableCORS().setFormData(myObj).post(success,failure);}}//Yet to implemented
},{key:'deleteImage',value:function deleteImage(){var me=this;var success=function success(resp){me.setState({imagePreviewUrl:'',imageLoaded:false});me.callback.apply(this,['']);};var failure=function failure(err){};var buttons=[{label:me.rb("btn.yes.delete_pic"),handler:function handler(){new __WEBPACK_IMPORTED_MODULE_2__util_HmAjax__["a" /* default */](me.getUrlFor("PROFILE_PIC")).delete(success,failure);}},{label:me.rb("btn.no.delete_pic")}];me.showAlert(me.rb("alert.label.delete_pic"),me.rb("alert.msg.delete_pic"),buttons);}},{key:'prevFn',value:function prevFn(e){__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#brwicon").trigger("click");}},{key:'_handleSubmit',value:function _handleSubmit(e){e.preventDefault();//alert("upload");
this.uploadImage(this.state.file);// TODO: do something with -> this.state.file
}},{key:'_handleImageChange',value:function _handleImageChange(e){var _this2=this;var me=this;e.preventDefault();var reader=new FileReader();var file=e.target.files[0];//clear older image if available
e.target.value=null;reader.onloadend=function(){_this2.setState({file:file,imagePreviewUrl:reader.result});};if(file==="undefined"||file===undefined){//alert("no file chosen");
}else{me.uploadImage(file,e.target);}}},{key:'render',value:function render(){var _this3=this;var imagePreviewUrl=this.state.imagePreviewUrl;var $imagePreview=null;if(imagePreviewUrl){$imagePreview=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:imagePreviewUrl});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'imageupload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:this._handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',id:'brwicon',accept:'image/*',onChange:this._handleImageChange,ref:'test_input'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'imgpreview',onClick:this.prevFn},$imagePreview),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons photo',onClick:this.prevFn},'add_a_photo'),function(){if(_this3.state.imageLoaded){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons image-delete',onClick:_this3.deleteImage},'delete');}}());}}]);return ImageUpload;}(__WEBPACK_IMPORTED_MODULE_4__views_core_LoggedInPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ImageUpload);

/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_LoggedInPage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_UserStorageUtil__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_plp_TestTakingModalComponent__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Errmsg__ = __webpack_require__(290);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LessonView=function(_LoggedInPage){_inherits(LessonView,_LoggedInPage);function LessonView(props){_classCallCheck(this,LessonView);var _this=_possibleConstructorReturn(this,(LessonView.__proto__||Object.getPrototypeOf(LessonView)).call(this,props));_this.state={"dataLoaded":false,data:{},lessonUrl:null,iFrameHeight:'0px',AlertModalShow:false};_this.requestParams="";_this.trackId=null;_this.trackLessonClose=_this.trackLessonClose.bind(_this);_this.trackLessonCloseInICEPIE=_this.trackLessonCloseInICEPIE.bind(_this);_this.handleMessage=_this.handleMessage.bind(_this);_this.setContentSize=_this.setContentSize.bind(_this);_this.resizeCall=_this.resizeCall.bind(_this);_this.userId=null;_this.enableTimer=true;_this.enableSessionTimer=true;_this.previousEventObj={};_this.icepieTrackingTimer=false;_this.icepieActivityTrackingTimer=true;_this.currentDD=0;_this.pulseInteractivityId=null;_this.interativeType=null;_this.lessonViewStopped=false;_this.substituteZAProxy=_this.substituteZAProxy.bind(_this);_this.hideAlertModal=_this.hideAlertModal.bind(_this);_this.errorMsg={heading:'',srcval:'',description:''};return _this;}_createClass(LessonView,[{key:'substituteZAProxy',value:function substituteZAProxy(){var lessonUrl=this.state.lessonUrl;if(lessonUrl&&lessonUrl.length>0){lessonUrl=lessonUrl.replace(this.getUrlFor("ORIG_CS_BASE_URL"),this.getUrlFor("CS_BASE_URL"));}return lessonUrl;}},{key:'componentDidMount',value:function componentDidMount(){this.setState({loggedIn:true});this.getLessonUrl();var me=this;this.initiateICEPIETimer();this.initiateICEPIEActivityTimer();this.initiateSessionTimer();var myConfObj={iframeMouseOver:false};__WEBPACK_IMPORTED_MODULE_4_jquery___default()(window).on('beforeunload',function(){me.trackLessonClose();me.trackLessonCloseInICEPIE();});__WEBPACK_IMPORTED_MODULE_4_jquery___default()(window).on('unload',function(){me.trackLessonClose();me.trackLessonCloseInICEPIE();});this.userId=this.getUser().getUserId();window.addEventListener('message',this.handleMessage,false);__WEBPACK_IMPORTED_MODULE_4_jquery___default()(window).resize(function(){me.setContentSize();});this.setContentSize();}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('beforeunload',this.trackLessonClose);window.removeEventListener('message',this.handleMessage,false);}},{key:'SessionCheck',value:function SessionCheck(){var me=this;var user_Success=function user_Success(userObj){if((typeof userObj==='undefined'?'undefined':_typeof(userObj))==="object"&&userObj.authToken){//login success
}else{me.enableSessionTimer=false;__WEBPACK_IMPORTED_MODULE_5__model_HmEventRegistry__["a" /* default */].fireEvent("LOG_OUT_PROMPT_EXIT");}};var user_Failure=function user_Failure(error){//login failure	
me.enableSessionTimer=false;__WEBPACK_IMPORTED_MODULE_5__model_HmEventRegistry__["a" /* default */].fireEvent("LOG_OUT_PROMPT_EXIT");};me.sessionCheck(user_Success,user_Failure);}},{key:'handleMessage',value:function handleMessage(event){console.log("handlemessage name=="+event.data);var me=this;var trackobj={};var params=this.getAllParamsObj();var msgData=event.data[0]==='{'?JSON.parse(event.data):"";var handleMsgName=msgData.name;var handleMsgData=msgData.params;trackobj.lesson_id=parseInt(params.lessonidTracking);trackobj.interactivity_id=null;this.enableSessionTimer=true;if((typeof msgData==='undefined'?'undefined':_typeof(msgData))==="object"){//console.log(JSON.parse(event.data));
if(handleMsgName!="html5UserAction"){return false;}me.currentDD=handleMsgData.ddNo;me.lessonViewStopped|=["pause","end"].indexOf(handleMsgData.action)>-1;trackobj.lesson_dd=handleMsgData.ddNo;trackobj.type=me.getTracker().enums.lessonElementType[handleMsgData.type.toLowerCase()];me.interativeType=me.getTracker().enums.lessonElementType[handleMsgData.type.toLowerCase()];if(["play","initPlay"].indexOf(handleMsgData.action)>-1){me.lessonViewStopped=false;trackobj.resumed=handleMsgData.action==="play";trackobj.dd_url=handleMsgData.ddUrl;me.trackLessonInICEPIE(trackobj,"lesson_element_started");me.icepieTrackingTimer=true;}else if(handleMsgData.action=="pause"){me.trackLessonPause(trackobj);}else if(handleMsgData.action=="close"&&!me.lessonViewStopped){me.trackLessonPause(trackobj);}else if(handleMsgData.action=="markerOpen"&&me.previousEventObj.action!="pause"){trackobj.interactivity_id=null;me.pulseInteractivityId=handleMsgData.markerNo;me.trackLessonPause(trackobj);trackobj.interactivity_id=handleMsgData.markerNo;trackobj.resumed=false;trackobj.dd_url=handleMsgData.ddUrl;me.trackLessonInICEPIE(trackobj,"lesson_element_started");}else if(handleMsgData.action=="markerClose"){trackobj.interactivity_id=me.previousEventObj.markerNo;me.trackLessonInICEPIE(trackobj,"lesson_element_ended");}else if(handleMsgData.action=="end"){me.trackLessonInICEPIE(trackobj,"lesson_element_ended");me.icepieTrackingTimer=false;}else if(handleMsgData.action=="open"&&handleMsgData.type=="act"){me.lessonViewStopped=false;me.icepieTrackingTimer=false;trackobj.resumed=false;trackobj.dd_url=handleMsgData.ddUrl;me.trackLessonInICEPIE(trackobj,"lesson_element_started");}else if(handleMsgData.action=="activityClicked"){trackobj.interactivity_id=handleMsgData.type.toLowerCase()=="act"?null:me.pulseInteractivityId;if(me.icepieActivityTrackingTimer){me.trackICEPIEACTIVITYLessonUser();me.icepieActivityTrackingTimer=false;me.icepieTrackingTimer=false;}}me.previousEventObj=handleMsgData;}}},{key:'trackLessonPause',value:function trackLessonPause(trackobj){this.icepieTrackingTimer=false;this.trackLessonInICEPIE(trackobj,"lesson_element_paused");}},{key:'trackLessonInICEPIE',value:function trackLessonInICEPIE(trackobj,actionString){try{this.initiateTrack(actionString,trackobj);}catch(e){}}},{key:'setLessonNameAsTitle',value:function setLessonNameAsTitle(lessonId){try{if(lessonId){var title=__WEBPACK_IMPORTED_MODULE_2__util_UserStorageUtil__["a" /* default */].getStoredSessionItem(lessonId);if(!title){title=sessionStorage.getItem(lessonId);}else{title=" "+title+" ";if(sessionStorage){if(!sessionStorage.getItem(lessonId))sessionStorage.setItem(lessonId,title);//remove after setting
__WEBPACK_IMPORTED_MODULE_2__util_UserStorageUtil__["a" /* default */].deleteSessionItem(lessonId);}}}if(title)document.title+=title;}catch(e){}}},{key:'trackICEPIELessonUser',value:function trackICEPIELessonUser(){try{var params=this.getAllParamsObj();var trackObj={"lesson_id":parseInt(params.lessonidTracking),"lesson_dd":this.currentDD,"type":this.getTracker().enums.lessonElementType["video"],"interactivity_id":null};this.initiateTrack("lesson_element_pulsed",trackObj);}catch(e){}}},{key:'trackICEPIEACTIVITYLessonUser',value:function trackICEPIEACTIVITYLessonUser(){try{var params=this.getAllParamsObj();var trackObj={"lesson_id":parseInt(params.lessonidTracking),"lesson_dd":this.currentDD,"type":this.interativeType,"interactivity_id":this.pulseInteractivityId};this.initiateTrack("lesson_element_pulsed",trackObj);}catch(e){}}},{key:'initiateICEPIEActivityTimer',value:function initiateICEPIEActivityTimer(){var me=this;setInterval(function(){//if(me.icepieActivityTrackingTimer){	   
me.icepieActivityTrackingTimer=true;//}
},10000);}},{key:'initiateICEPIETimer',value:function initiateICEPIETimer(){var me=this;setInterval(function(){if(me.icepieTrackingTimer){me.trackICEPIELessonUser();}},10000);}},{key:'initiateTimer',value:function initiateTimer(){var me=this;setInterval(function(){if(me.enableTimer){//console.log("initiateTimer ::");
me.trackLessonClose();}},5000);}},{key:'initiateSessionTimer',value:function initiateSessionTimer(){var me=this;setInterval(function(){if(me.enableSessionTimer){me.SessionCheck();me.enableSessionTimer=false;}},60000);}},{key:'getAdditionalUrlParams',value:function getAdditionalUrlParams(lessonUrl){try{var paramsArr=window.location.href.split("?");if(paramsArr.length>1&&paramsArr[1].length>0){lessonUrl+="&"+paramsArr[1];var paramObj=this.extractParamsObj(paramsArr[1]);this.setLessonNameAsTitle(paramObj["url"]);//If it is a new window, else do not change the title
/*  if(paramObj["lessonname"] !== undefined && paramObj["lessonname"] !== null && paramObj["lessonname"].length > 0){
			   		try{document.title += " " + decodeURIComponent(paramObj["lessonname"]) + " ";}catch(e){}
			   	}*/}}catch(e){}return lessonUrl;}},{key:'getAllParamsObj',value:function getAllParamsObj(){var paramObj={};try{var paramsArr=window.location.href.split("?");if(paramsArr.length>1&&paramsArr[1].length>0){paramObj=this.extractParamsObj(paramsArr[1]);}}catch(e){}return paramObj;}},{key:'getAllUrlParams',value:function getAllUrlParams(urlString){try{var paramsArr=window.location.href.split("?");if(paramsArr.length>1&&paramsArr[1].length>0){if(urlString.indexOf("?")>0){urlString+="&"+paramsArr[1];}else{urlString+="?"+paramsArr[1];}}}catch(e){}return urlString;}},{key:'extractParamsObj',value:function extractParamsObj(paramsArrStr){var paramObj={};try{if(paramsArrStr!==null&&paramsArrStr.length>0){var paramPairArr=paramsArrStr.split("&");if(paramPairArr!==null&&paramPairArr.length>0){for(var i=0;i<paramPairArr.length;i++){var eachPair=paramPairArr[i].split("=");paramObj[eachPair[0]]=eachPair.length>0?eachPair[1]:eachPair[0];}}}}catch(e){}return paramObj;}},{key:'getLessonUrl',value:function getLessonUrl(){try{var me=this;var successHandler=function successHandler(data){if(data===null||data!==null&&data.errorMsg){var buttons=[{label:me.rb("home.btn.close"),handler:function handler(){window.close();}}];if(data.errorMsg&&data.errorMsg==="mobile_no_flash"){me.errorMsg={heading:me.rb("lesson."+data.errorMsg+".heading")||me.rb("lesson."+data.errorMsg+".heading"),srcval:"desktoporlaptop",description:me.rb("lesson."+data.errorMsg)||me.rb("lesson."+data.errorMsg)};me.setState({AlertModalShow:true});}else if(data.errorMsg&&data.errorMsg==="not_authorized"){me.showAlert(null,me.rb("lesson."+data.errorMsg)||me.rb("lesson."+data.errorMsg),buttons);}else if(data.errorMsg&&data.errorMsg==="user_session_not_available"){me.showAlert(null,me.rb("lesson."+data.errorMsg)||me.rb("lesson."+data.errorMsg),buttons);}else if(data.errorMsg&&data.errorMsg==="no_lesson_id"){me.showAlert(null,"<div><div>Oops!</div><div>Looks like you are lost. </div><div>Go to HeyMath! to continue learning</div></div>",buttons);}else if(data.errorMsg&&data.errorMsg==="not_free_lesson"){me.showAlert(null,"<div><div>Oops!</div><div>Looks like you are lost. </div><div>Go to HeyMath! to continue learning</div></div>",'',"no");}else if(data.testStatus){me.showAlert(me.rb(data.testStatus),me.rb(data.reference_id)||me.rb(data.testStatus),buttons);}else{me.showAlert(null,me.rb(data.errorMsg)||me.rb("lesson."+data.errorMsg),buttons);}return;}if(data&&data.lessonUrl){me.setState({"dataLoaded":true,"data":data,lessonUrl:me.getAdditionalUrlParams(data.lessonUrl)});me.trackLessonOpen();me.initiateTimer();setTimeout(function(){me.setContentSize();},1500);}else{//Please close this window and login to continue
}};var failureHandler=function failureHandler(err){var buttons=[{label:me.rb("go_home"),handler:function handler(){window.location.href=me.getUrlFor("LOGIN_HOME");}}];me.showAlert(me.rb("error"),me.rb("generic_connect_error"),buttons);return;};var lessonId=this.props.match.params.id;new __WEBPACK_IMPORTED_MODULE_3__util_HmAjax__["a" /* default */](this.getAllUrlParams(this.getUrlFor("LESSON_URL")+lessonId)).get(successHandler,failureHandler);}catch(e){var buttons=[{label:me.rb("go_home"),handler:function handler(){window.location.href=me.getUrlFor("LOGIN_HOME");}}];me.showAlert(me.rb("error"),me.rb("system_error"),buttons);}}},{key:'trackLessonClose',value:function trackLessonClose(){try{var me=this;var successHandler=function successHandler(data){console.log("track lesson close success");};var failureHandler=function failureHandler(err){console.log("Error in TRACK_LESSON_CLOSE");return;};new __WEBPACK_IMPORTED_MODULE_3__util_HmAjax__["a" /* default */](this.getUrlFor("TRACK_LESSON_CLOSE")+me.trackId+"/"+me.userId).get(successHandler,failureHandler);}catch(e){console.log("Error in track lessson close..");}}},{key:'trackLessonCloseInICEPIE',value:function trackLessonCloseInICEPIE(){try{var params=this.getAllParamsObj();var trackObj={"lesson_id":parseInt(params.lessonidTracking)};this.initiateTrack("lesson_closed",trackObj);}catch(e){}}},{key:'trackLessonOpen',value:function trackLessonOpen(){var params=this.getAllParamsObj();/*lessonPref:"html5"
		lessonname:"Subtracting%207-Digit%20Numbers"
		revisiontopicid:"0"
		src:"plp"
		testid:"0"
		url:"vl1283a_subtract7digit"*/var formData={"lessonUrl":params.url,"lessonDd":params.lessonPref=="flash"?0:parseInt(params.dd)||1,"lessonType":params.lessonPref,"classId":parseInt(params.classId),"accessId":parseInt(params.accessId),"topicSubtopicMapId":parseInt(params.revisiontopicid),"lessonSrc":!isNaN(params.lessonSrc)?Number(params.lessonSrc):1};try{var me=this;var successHandler=function successHandler(data){if(data!=null){me.trackId=data.trackId;return;}};var failureHandler=function failureHandler(err){console.log("Error in TRACK_LESSON_OPEN");return;};var lessonId=this.props.match.params.id;new __WEBPACK_IMPORTED_MODULE_3__util_HmAjax__["a" /* default */](this.getUrlFor("TRACK_LESSON_OPEN"),formData).post(successHandler,failureHandler);}catch(e){console.log("Error in lesson tracking...");}try{var trackObj={"lesson_id":parseInt(params.lessonidTracking),"lesson_dd":parseInt(params.dd)||1,"source":this.getTracker().enums.lessonSource[params.tracksource],"source_id":parseInt(params[params.tracksource=="subtopic"?"revisiontopicid":"testid"]),"snippet_id":parseInt(params.snid)||0,"question_source":params.qsrc||0};this.initiateTrack("lesson_opened",trackObj);}catch(e){}}},{key:'setContentSize',value:function setContentSize(){var me=this;//
var userAgent=navigator.userAgent||navigator.vendor||window.opera;if(/iPad|iPhone|iPod/.test(userAgent)&&!window.MSStream){//
__WEBPACK_IMPORTED_MODULE_4_jquery___default()("#contentIFrame").css("visibility","hidden");setTimeout(function(){__WEBPACK_IMPORTED_MODULE_4_jquery___default()("#contentIFrame").css("visibility","visible");me.resizeCall();},1000);//
}me.resizeCall();}//
},{key:'resizeCall',value:function resizeCall(){//
try{__WEBPACK_IMPORTED_MODULE_4_jquery___default()("#contentIFrame").css({width:window.innerWidth,height:window.innerHeight});}catch(e){}}},{key:'hideAlertModal',value:function hideAlertModal(){this.setState({AlertModalShow:false});window.close();}},{key:'renderModalContent',value:function renderModalContent(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__views_plp_TestTakingModalComponent__["a" /* default */],{visible:this.state.AlertModalShow,dialogClassName:"loginModal modal-lg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-header bg-purple'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-title'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close helpClose',onClick:this.hideAlertModal,'aria-label':'Close'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'close')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',_defineProperty({className:'modal-body'},'className','col-12 text-center bdycont'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Errmsg__["a" /* default */],{errormsg:this.errorMsg}))));}},{key:'render',value:function render(){var me=this;if(!this.state.dataLoaded||this.state.lessonUrl===null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.showLoader(),this.renderModalContent());}else{if(this.state.lessonUrl){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'lessonIframeContainer',style:{height:"100vh",overflowY:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{id:'contentIFrame',style:{width:'100%',height:me.state.iFrameHeight,overflowY:'hidden'},onLoad:function onLoad(){me.setContentSize();me.setState({"iFrameHeight":window.innerHeight+'px'});},ref:'iframe',src:me.substituteZAProxy(),width:'100%',height:me.state.iFrameHeight,scrolling:'no',frameBorder:'0',referrerpolicy:'no-referrer-when-downgrade'}),this.renderModalContent());}}}}]);return LessonView;}(__WEBPACK_IMPORTED_MODULE_1__views_core_LoggedInPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (LessonView);

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/desktoporlaptop.c1bbcad8.png";

/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_html_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_heymathlogo_png__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_heymathlogo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_heymathlogo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_form_with_constraints_bootstrap4__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_form_with_constraints_bootstrap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_form_with_constraints_bootstrap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_device_detect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_device_detect__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var fpServerResponses={200:'An email has been sent to <span class="hm-blue"><email></span> with the link to reset the password. Please check your Inbox and Spam/Junk folders.',403:'You are not allowed to reset your password. Please write to <a href="mailto:support@heymath.com">support@heymath.com</a>',600:'Invalid User ID or Email.',// also for 400, 401
0:'An unexpected error occurred. Please try again after sometime or write to <a href="mailto:support@heymath.com">support@heymath.com</a>'};var ResetPasswordForm=function(_PreLoginPage){_inherits(ResetPasswordForm,_PreLoginPage);function ResetPasswordForm(props){_classCallCheck(this,ResetPasswordForm);var _this=_possibleConstructorReturn(this,(ResetPasswordForm.__proto__||Object.getPrototypeOf(ResetPasswordForm)).call(this,props));_this.state={loader:true,validToken:false,pwdUpdated:false,password:'',confirmpassword:'',submitButtonDisabled:false,serverMessage:""};_this.handlePwdChange=_this.handlePwdChange.bind(_this);_this.handleConfirmPwdChange=_this.handleConfirmPwdChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.myTrackerInstance=_this.getTracker();return _this;}_createClass(ResetPasswordForm,[{key:'componentDidMount',value:function componentDidMount(){//console.log("token=="+this.props.match.params.id);
var me=this;var callBackSuccess=function callBackSuccess(response){if(response!==null){me.setState({validToken:response.isValid,loader:false});}console.log("response : ",response);};var callBackFailure=function callBackFailure(response){};new __WEBPACK_IMPORTED_MODULE_7__util_HmAjax__["a" /* default */](this.getUrlFor("PWD_TOKEN_VALIDATE")+this.props.match.params.id).get(callBackSuccess,callBackFailure);}},{key:'handlePwdChange',value:function handlePwdChange(e){var _setState;var target=e.currentTarget;this.form.validateFields(target);this.setState((_setState={},_defineProperty(_setState,target.name,target.value),_defineProperty(_setState,'submitButtonDisabled',!this.form.isValid()),_setState));}},{key:'handleConfirmPwdChange',value:function handleConfirmPwdChange(e){this.handlePwdChange(e);}},{key:'handleSubmit',value:function handleSubmit(e){e.preventDefault();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid(),serverMessage:""});if(this.form.isValid()){var formData={"password":this.state.password//do cofirm
};var me=this;me.setState({submitButtonDisabled:true});var callBackSuccess=function callBackSuccess(response){console.log("response : ",response);if(response!==null){me.setState({validToken:response.isValid,pwdUpdated:response.passwordUpdated,loader:false});}};var callBackFailure=function callBackFailure(response){me.setState({submitButtonDisabled:false});};new __WEBPACK_IMPORTED_MODULE_7__util_HmAjax__["a" /* default */](this.getUrlFor("PWD_RECOVER")+this.props.match.params.id,formData).put(callBackSuccess,callBackFailure);}}},{key:'renderResetPwdform',value:function renderResetPwdform(){var _this2=this;if(this.state.loader===true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' ',this.showLoader());}else if(this.state.validToken===false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-8 col-md-offset-2 mx-auto nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card rounded-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__images_heymathlogo_png___default.a,className:'heymathlogo'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center loginHeaderTxt josefinsansFont mt-50'},this.rb("rpwd.title")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.rb("rpwd.msg.invalid")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.rb("rpwd.msg.tryagain")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))));}else if(this.state.pwdUpdated===true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-8 col-md-offset-2 mx-auto nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card rounded-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__images_heymathlogo_png___default.a,className:'heymathlogo'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center loginHeaderTxt josefinsansFont mt-50'},this.rb("rpwd.title")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(this.rb("rpwd.msg.success"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 col-md-offset-3 mx-auto nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card rounded-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__images_heymathlogo_png___default.a,className:'heymathlogo'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center loginHeaderTxt josefinsansFont mt-50'},this.rb("rpwd.title")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this2.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'password'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'password',name:'password',placeholder:this.rb("rpwd.newpwd"),innerRef:function innerRef(password){return _this2.password=password;},value:this.state.password,onChange:this.handlePwdChange,required:true,minLength:1,tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'password',show:'all'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("login.pwdrequired")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'confirmpassword'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'confirmpassword',name:'confirmpassword',placeholder:this.rb("rpwd.confirmpwd"),innerRef:function innerRef(confirmpassword){return _this2.confirmpassword=confirmpassword;},value:this.state.confirmpassword,onChange:this.handleConfirmPwdChange,required:true,minLength:1,tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'confirmpassword'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("rpwd.confirmpwdrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value!==_this2.password.value;}},this.rb("rpwd.doesnotmatch")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'forgotpwdMsg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages'},' ',__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(this.state.serverMessage))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:this.state.submitButtonDisabled,className:'submitButton savebutton'},this.rb("rpwd.save")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))))));}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'loginRoot'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},this.renderResetPwdform()));}}]);return ResetPasswordForm;}(__WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ResetPasswordForm);

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(4);
var withValidateEventEmitter_1 = __webpack_require__(291);
var FieldsStore_1 = __webpack_require__(293);
var FormWithConstraintsComponent = (function (_super) {
    __extends(FormWithConstraintsComponent, _super);
    function FormWithConstraintsComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FormWithConstraintsComponent;
}(React.Component));
exports.FormWithConstraintsComponent = FormWithConstraintsComponent;
var FormWithConstraints = (function (_super) {
    __extends(FormWithConstraints, _super);
    function FormWithConstraints() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fieldsStore = new FieldsStore_1.FieldsStore();
        _this.fieldFeedbacksKey = 0;
        return _this;
    }
    FormWithConstraints.prototype.getChildContext = function () {
        return {
            form: this
        };
    };
    FormWithConstraints.prototype.computeFieldFeedbacksKey = function () {
        return this.fieldFeedbacksKey++;
    };
    FormWithConstraints.prototype.validateFields = function () {
        var _this = this;
        var inputsOrNames = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            inputsOrNames[_i] = arguments[_i];
        }
        var inputs = inputsOrNames.filter(function (inputOrName) { return typeof inputOrName !== 'string'; });
        var fieldNames = inputsOrNames.filter(function (inputOrName) { return typeof inputOrName === 'string'; });
        var otherInputs = [];
        if (inputsOrNames.length === 0) {
            otherInputs = this.form.querySelectorAll('[name]');
        }
        if (fieldNames.length > 0) {
            var selectors = fieldNames.map(function (fieldName) { return "[name=\"" + fieldName + "\"]"; });
            otherInputs = this.form.querySelectorAll(selectors.join(', '));
        }
        __spread(inputs, otherInputs).forEach(function (input) { return _this.emitValidateEvent(input); });
    };
    FormWithConstraints.prototype.isValid = function () {
        var fieldNames = Object.keys(this.fieldsStore.fields);
        return !(_a = this.fieldsStore).containErrors.apply(_a, __spread(fieldNames));
        var _a;
    };
    FormWithConstraints.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, formProps = __rest(_a, ["children"]);
        return React.createElement("form", __assign({ ref: function (form) { return _this.form = form; } }, formProps), children);
    };
    FormWithConstraints.childContextTypes = {
        form: PropTypes.object.isRequired
    };
    return FormWithConstraints;
}(withValidateEventEmitter_1.withValidateEventEmitter(FormWithConstraintsComponent)));
exports.FormWithConstraints = FormWithConstraints;
//# sourceMappingURL=FormWithConstraints.js.map

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(4);
var withValidateEventEmitter_1 = __webpack_require__(291);
var FieldsStore_1 = __webpack_require__(293);
var FieldFeedbacksComponent = (function (_super) {
    __extends(FieldFeedbacksComponent, _super);
    function FieldFeedbacksComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FieldFeedbacksComponent;
}(React.Component));
exports.FieldFeedbacksComponent = FieldFeedbacksComponent;
var FieldFeedbacks = (function (_super) {
    __extends(FieldFeedbacks, _super);
    function FieldFeedbacks(props, context) {
        var _this = _super.call(this, props) || this;
        _this.fieldFeedbackKey = 0;
        _this.validate = _this.validate.bind(_this);
        _this.reRender = _this.reRender.bind(_this);
        _this.key = context.form.computeFieldFeedbacksKey();
        return _this;
    }
    FieldFeedbacks.prototype.getChildContext = function () {
        return {
            fieldFeedbacks: this
        };
    };
    FieldFeedbacks.prototype.computeFieldFeedbackKey = function () {
        return this.key + this.fieldFeedbackKey++ / 10;
    };
    FieldFeedbacks.prototype.componentWillMount = function () {
        var fieldName = this.props.for;
        this.context.form.fieldsStore.addField(fieldName);
        this.context.form.addValidateEventListener(this.validate);
        this.context.form.fieldsStore.addListener(FieldsStore_1.FieldEvent.Updated, this.reRender);
    };
    FieldFeedbacks.prototype.componentWillUnmount = function () {
        var fieldName = this.props.for;
        this.context.form.fieldsStore.removeField(fieldName);
        this.context.form.removeValidateEventListener(this.validate);
        this.context.form.fieldsStore.removeListener(FieldsStore_1.FieldEvent.Updated, this.reRender);
    };
    FieldFeedbacks.prototype.validate = function (input) {
        var fieldName = this.props.for;
        if (input.name === fieldName) {
            this.context.form.fieldsStore.removeFieldFor(fieldName, this.key);
            this.emitValidateEvent(input);
        }
    };
    FieldFeedbacks.prototype.reRender = function (_fieldName) {
        var fieldName = this.props.for;
        if (fieldName === _fieldName) {
            this.forceUpdate();
        }
    };
    FieldFeedbacks.prototype.render = function () {
        var _a = this.props, fieldName = _a.for, show = _a.show, children = _a.children, divProps = __rest(_a, ["for", "show", "children"]);
        return React.createElement("div", __assign({}, divProps), children);
    };
    FieldFeedbacks.defaultProps = {
        show: 'first'
    };
    FieldFeedbacks.contextTypes = {
        form: PropTypes.object.isRequired
    };
    FieldFeedbacks.childContextTypes = {
        fieldFeedbacks: PropTypes.object.isRequired
    };
    return FieldFeedbacks;
}(withValidateEventEmitter_1.withValidateEventEmitter(FieldFeedbacksComponent)));
exports.FieldFeedbacks = FieldFeedbacks;
//# sourceMappingURL=FieldFeedbacks.js.map

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(4);
var FieldFeedback = (function (_super) {
    __extends(FieldFeedback, _super);
    function FieldFeedback(props, context) {
        var _this = _super.call(this, props) || this;
        _this.validate = _this.validate.bind(_this);
        _this.key = context.fieldFeedbacks.computeFieldFeedbackKey();
        return _this;
    }
    FieldFeedback.prototype.componentWillMount = function () {
        this.context.fieldFeedbacks.addValidateEventListener(this.validate);
    };
    FieldFeedback.prototype.componentWillUnmount = function () {
        this.context.fieldFeedbacks.removeValidateEventListener(this.validate);
    };
    FieldFeedback.prototype.validate = function (input) {
        var _a = this.props, when = _a.when, warning = _a.warning, info = _a.info;
        var fieldName = this.context.fieldFeedbacks.props.for;
        var show = false;
        if (typeof when === 'function') {
            var constraintViolation = when(input.value);
            if (constraintViolation) {
                show = true;
            }
        }
        else if (typeof when === 'string') {
            var validity = input.validity;
            if (!validity.valid) {
                if (when === '*') {
                    show = true;
                }
                else if (validity.badInput && when === 'badInput' ||
                    validity.patternMismatch && when === 'patternMismatch' ||
                    validity.rangeOverflow && when === 'rangeOverflow' ||
                    validity.rangeUnderflow && when === 'rangeUnderflow' ||
                    validity.stepMismatch && when === 'stepMismatch' ||
                    validity.tooLong && when === 'tooLong' ||
                    validity.tooShort && when === 'tooShort' ||
                    validity.typeMismatch && when === 'typeMismatch' ||
                    validity.valueMissing && when === 'valueMissing') {
                    show = true;
                }
            }
        }
        else {
            throw new TypeError("Invalid FieldFeedback 'when' type: " + typeof when);
        }
        var field = this.context.form.fieldsStore.cloneField(fieldName);
        field.dirty = true;
        field.validationMessage = input.validationMessage;
        if (show) {
            if (warning)
                field.warnings.add(this.key);
            else if (info)
                field.infos.add(this.key);
            else
                field.errors.add(this.key);
        }
        this.context.form.fieldsStore.updateField(fieldName, field);
    };
    FieldFeedback.prototype.className = function () {
        var _a = this.context.fieldFeedbacks.props, fieldName = _a.for, show = _a.show;
        var _b = this.context.form.fieldsStore.getFieldFor(fieldName, this.context.fieldFeedbacks.key), errors = _b.errors, warnings = _b.warnings, infos = _b.infos;
        var firstError = errors.values().next().value;
        var firstWarning = warnings.values().next().value;
        var className;
        if (errors.has(this.key) && (show === 'all' || (show === 'first' && firstError === this.key))) {
            className = 'error';
        }
        else if (warnings.has(this.key) && (errors.size === 0 && (show === 'all' || (show === 'first' && firstWarning === this.key)))) {
            className = 'warning';
        }
        else if (infos.has(this.key)) {
            className = 'info';
        }
        return className;
    };
    FieldFeedback.prototype.render = function () {
        var _a = this.props, when = _a.when, error = _a.error, warning = _a.warning, info = _a.info, className = _a.className, children = _a.children, divProps = __rest(_a, ["when", "error", "warning", "info", "className", "children"]);
        var fieldName = this.context.fieldFeedbacks.props.for;
        var validationMessage = this.context.form.fieldsStore.getFieldFor(fieldName, this.context.fieldFeedbacks.key).validationMessage;
        var classes = this.className();
        var feedback = null;
        if (classes !== undefined) {
            classes = className !== undefined ? className + " " + classes : classes;
            feedback = children !== undefined ? children : validationMessage;
        }
        return feedback !== null ? React.createElement("div", __assign({}, divProps, { className: classes }), feedback) : null;
    };
    FieldFeedback.contextTypes = {
        form: PropTypes.object.isRequired,
        fieldFeedbacks: PropTypes.object.isRequired
    };
    return FieldFeedback;
}(React.Component));
exports.FieldFeedback = FieldFeedback;
//# sourceMappingURL=FieldFeedback.js.map

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var PropTypes = __webpack_require__(4);
var react_form_with_constraints_1 = __webpack_require__(17);
var FormGroup = (function (_super) {
    __extends(FormGroup, _super);
    function FormGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.reRender = _this.reRender.bind(_this);
        return _this;
    }
    FormGroup.prototype.componentWillMount = function () {
        this.context.form.addValidateEventListener(this.reRender);
    };
    FormGroup.prototype.componentWillUnmount = function () {
        this.context.form.removeValidateEventListener(this.reRender);
    };
    FormGroup.prototype.reRender = function (input) {
        var fieldName = this.props.for;
        if (input.name === fieldName) {
            this.forceUpdate();
        }
    };
    FormGroup.prototype.className = function (fieldName) {
        var className = 'form-group';
        if (fieldName !== undefined) {
            var form = this.context.form;
            if (form.fieldsStore.containErrors(fieldName)) {
                className += ' has-danger';
            }
            else if (form.fieldsStore.containWarnings(fieldName)) {
                className += ' has-warning';
            }
            else if (form.fieldsStore.areValidDirtyWithoutWarnings(fieldName)) {
                className += ' has-success';
            }
        }
        return className;
    };
    FormGroup.prototype.render = function () {
        var _a = this.props, fieldName = _a.for, className = _a.className, children = _a.children, divProps = __rest(_a, ["for", "className", "children"]);
        var classes = className !== undefined ? className + " " + this.className(fieldName) : this.className(fieldName);
        return (React.createElement("div", __assign({}, divProps, { className: classes }), children));
    };
    FormGroup.contextTypes = {
        form: PropTypes.object.isRequired
    };
    return FormGroup;
}(React.Component));
exports.FormGroup = FormGroup;
var FormControlLabel = function (props) {
    var className = props.className, children = props.children, labelProps = __rest(props, ["className", "children"]);
    var classes = className !== undefined ? className + " form-control-label" : 'form-control-label';
    return (React.createElement("label", __assign({}, labelProps, { className: classes }), children));
};
exports.FormControlLabel = FormControlLabel;
var FormControlInput = (function (_super) {
    __extends(FormControlInput, _super);
    function FormControlInput(props) {
        var _this = _super.call(this, props) || this;
        _this.reRender = _this.reRender.bind(_this);
        return _this;
    }
    FormControlInput.prototype.componentWillMount = function () {
        this.context.form.addValidateEventListener(this.reRender);
    };
    FormControlInput.prototype.componentWillUnmount = function () {
        this.context.form.removeValidateEventListener(this.reRender);
    };
    FormControlInput.prototype.reRender = function (input) {
        var fieldName = this.props.name;
        if (input.name === fieldName) {
            this.forceUpdate();
        }
    };
    FormControlInput.prototype.className = function (name) {
        var className = 'form-control';
        if (name !== undefined) {
            var form = this.context.form;
            if (form.fieldsStore.containErrors(name)) {
                className += ' form-control-danger';
            }
            else if (form.fieldsStore.containWarnings(name)) {
                className += ' form-control-warning';
            }
            else if (form.fieldsStore.areValidDirtyWithoutWarnings(name)) {
                className += ' form-control-success';
            }
        }
        return className;
    };
    FormControlInput.prototype.render = function () {
        var _a = this.props, innerRef = _a.innerRef, className = _a.className, children = _a.children, inputProps = __rest(_a, ["innerRef", "className", "children"]);
        var classes = className !== undefined ? className + " " + this.className(inputProps.name) : this.className(inputProps.name);
        return (React.createElement("input", __assign({ ref: innerRef }, inputProps, { className: classes })));
    };
    FormControlInput.contextTypes = {
        form: PropTypes.object.isRequired
    };
    return FormControlInput;
}(React.Component));
exports.FormControlInput = FormControlInput;
var FieldFeedbacks = function (props) {
    var className = props.className, children = props.children, other = __rest(props, ["className", "children"]);
    var classes = className !== undefined ? className + " form-control-feedback" : 'form-control-feedback';
    return React.createElement(react_form_with_constraints_1.FieldFeedbacks, __assign({}, other, { className: classes }), children);
};
exports.FieldFeedbacks = FieldFeedbacks;
var LabelWithFormControlStyle = (function (_super) {
    __extends(LabelWithFormControlStyle, _super);
    function LabelWithFormControlStyle(props) {
        var _this = _super.call(this, props) || this;
        _this.reRender = _this.reRender.bind(_this);
        return _this;
    }
    LabelWithFormControlStyle.prototype.componentWillMount = function () {
        this.context.form.addValidateEventListener(this.reRender);
    };
    LabelWithFormControlStyle.prototype.componentWillUnmount = function () {
        this.context.form.removeValidateEventListener(this.reRender);
    };
    LabelWithFormControlStyle.prototype.reRender = function (input) {
        var fieldNames = this.props.for;
        if (fieldNames.includes(input.name)) {
            this.forceUpdate();
        }
    };
    LabelWithFormControlStyle.prototype.render = function () {
        var _a = this.props, fieldNames = _a.for, style = _a.style, children = _a.children, labelProps = __rest(_a, ["for", "style", "children"]);
        var form = this.context.form;
        var brandDanger = '#d9534f';
        var brandWarning = '#f0ad4e';
        var brandSuccess = '#5cb85c';
        var color;
        if ((_b = form.fieldsStore).containErrors.apply(_b, __spread(fieldNames))) {
            color = brandDanger;
        }
        else if ((_c = form.fieldsStore).containWarnings.apply(_c, __spread(fieldNames))) {
            color = brandWarning;
        }
        else if ((_d = form.fieldsStore).areValidDirtyWithoutWarnings.apply(_d, __spread(fieldNames))) {
            color = brandSuccess;
        }
        var styles = style !== undefined ? __assign({ color: color }, style) : { color: color };
        return (React.createElement("label", __assign({}, labelProps, { style: styles }), children));
        var _b, _c, _d;
    };
    LabelWithFormControlStyle.contextTypes = {
        form: PropTypes.object.isRequired
    };
    return LabelWithFormControlStyle;
}(React.Component));
exports.LabelWithFormControlStyle = LabelWithFormControlStyle;
//# sourceMappingURL=Bootstrap4.js.map

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_device_detect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_HawkEye__ = __webpack_require__(128);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
* Look for this key in SessionStore. Since Google Auth involves redirection,
* callback execution is not possible. Instead redirect to URL stored in SessionStore
*/var redirection_url_key="login-redirect-purchase";var ExternalLogin=function(_PreLoginPage){_inherits(ExternalLogin,_PreLoginPage);function ExternalLogin(props){_classCallCheck(this,ExternalLogin);var _this=_possibleConstructorReturn(this,(ExternalLogin.__proto__||Object.getPrototypeOf(ExternalLogin)).call(this,props));_this.UserStore=new __WEBPACK_IMPORTED_MODULE_2__util_UserStore__["a" /* default */]();_this.navigationKey="PLP_Navigation";_this.navigateURLKey="PLP_REDIRECT";_this.navigateObj={};_this.doLumosLogout=_this.doLumosLogout.bind(_this);return _this;}_createClass(ExternalLogin,[{key:'updateUserType',value:function updateUserType(commonCallback){var me=this;var callBackSuccess=function callBackSuccess(response){if(response!==null){//console.warn("user type",response)
me.UserStore.set(response);}if(typeof commonCallback==="function"){commonCallback.apply(this);}};var callBackFailure=function callBackFailure(response){//console.warn("failure ",response);
if(typeof commonCallback==="function"){commonCallback.apply(this);}};_get(ExternalLogin.prototype.__proto__||Object.getPrototypeOf(ExternalLogin.prototype),'updateUserType',this).call(this,callBackSuccess,callBackFailure);}},{key:'productsAvailableToAccess',value:function productsAvailableToAccess(userobj){var user=userobj;//console.log("user::::",user);
if(user!=null){var permissions=user.entlHistory;//console.log("permissions:::",permissions);
if(permissions!=null&&Object.keys(permissions).length>0){for(var i in permissions){if(permissions[i]!=null){var totalLevel=permissions[i].split(",").reduce(function(a,b){try{return parseInt(a)+parseInt(b);}catch(e){return 0;}});if(totalLevel>0){return true;}}}}}return false;}},{key:'componentDidMount',value:function componentDidMount(){var me=this;var success=function success(userObj){console.log("External login ajax success...");if((typeof userObj==='undefined'?'undefined':_typeof(userObj))==="object"&&userObj.authToken){//Update the userStore Object
me.UserStore.set(userObj);try{me.doLumosLogout();}catch(e){}try{me.navigateObj=JSON.parse(__WEBPACK_IMPORTED_MODULE_3__util_BrowserStorageUtil__["a" /* default */].getStoredSessionItem(me.navigationKey));var redirectUri=sessionStorage.getItem(redirection_url_key);sessionStorage.removeItem(redirection_url_key);if(!redirectUri&&me.productsAvailableToAccess(userObj)){redirectUri="/landing";}else{redirectUri=me.navigateObj&&me.navigateObj.navigateURL?me.navigateObj.navigateURL:"/";}//console.log(me.navigateObj);
/*if(me.navigateObj.navigateURL){
						me.props.history.push(me.navigateObj.navigateURL);
					}else{
						me.props.history.push('/landing');
					}*/console.log("me.navigateObj.navigateURL"+me.navigateObj.navigateURL);/*try{
						me.trackMe(true,userObj);
					}catch(e){}*/try{var loginObj={"user_id":userObj==null?"":userObj.userId,"login_id":userObj==null?"":userObj.loginId,"user_agent":navigator.userAgent,"platform":navigator.platform,"device":__WEBPACK_IMPORTED_MODULE_5_react_device_detect__["isMobile"]?"mobile":__WEBPACK_IMPORTED_MODULE_5_react_device_detect__["isTablet"]?"tablet":"PC","ip_address":"ip_address","result":true,"session_id":userObj==null?"":userObj.authToken};me.storeTrackEvent("login",loginObj);}catch(e){}/*if(userObj && userObj.userRole.role == "PRNT"){
						if(me.navigateObj.navigateURL == "/landing"){
							me.props.history.push('/myproducts');
						}else{
						me.props.history.push(me.navigateObj.navigateURL);
						}
					}else{
						me.props.history.push('/landing');
					}*/var afterUpdate=function afterUpdate(){if(me.navigateObj.navigateURL&&me.navigateObj.navigateURL.match("http[s]?://+")){window.location.href=redirectUri;}else{me.props.history.push(redirectUri);}};me.updateUserType(afterUpdate);}catch(e){}}else{//Clear userStore
me.UserStore.clearOldUser();}};var failure=function failure(error){//User session is no longer valid
console.log("External login ajax failure...");};this.sessionCheck(success,failure,true);if(!this.tracked){this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"logged-via-google"});this.tracked=true;}}},{key:'trackMe',value:function trackMe(result){var userObj=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var trackObj={"user_id":userObj==null?"":userObj.userId,"login_id":userObj==null?"":userObj.loginId,"user_agent":navigator.userAgent,"platform":navigator.platform,"device":__WEBPACK_IMPORTED_MODULE_5_react_device_detect__["isMobile"]?"mobile":__WEBPACK_IMPORTED_MODULE_5_react_device_detect__["isTablet"]?"tablet":"PC","ip_address":"ip_address","result":result===true,"session_id":userObj==null?"":userObj.authToken};this.initiateTrack("login",trackObj);}},{key:'initiateTrack',value:function initiateTrack(trackKey,addnldata){try{var eventObj=this.getTracker();var trackObj=eventObj.getEventObject(eventObj.eventCodes[trackKey]);trackObj.event_details.user_id=addnldata.user_id||"";trackObj.event_details.session_id=addnldata.authToken||"";trackObj.event_details.timestamp=new Date().getTime()||"";if(addnldata!==undefined&&(typeof addnldata==='undefined'?'undefined':_typeof(addnldata))==="object"){for(var key in addnldata){trackObj.event_data[key]=addnldata[key];}}var output={"event":trackObj};var me=this;new __WEBPACK_IMPORTED_MODULE_6__util_HawkEye__["a" /* default */](output).post();}catch(e){console.log("Error in Tracking :::",e);}}},{key:'doLumosLogout',value:function doLumosLogout(){var me=this;console.log("logout url="+me.getUrlFor("LUMOS_LOGOUT"));__WEBPACK_IMPORTED_MODULE_4_jquery___default.a.ajax({url:me.getUrlFor("LUMOS_LOGOUT"),type:'GET',xhrFields:{withCredentials:true},crossDomain:true,success:function success(response){},error:function error(response){console.log("Error in LUMOS_LOGOUT",response);}});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' ',this.showLoader());}}]);return ExternalLogin;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ExternalLogin);

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_UserStore__ = __webpack_require__(12);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LumosLogin=function(_PreLoginPage){_inherits(LumosLogin,_PreLoginPage);function LumosLogin(props){_classCallCheck(this,LumosLogin);var _this=_possibleConstructorReturn(this,(LumosLogin.__proto__||Object.getPrototypeOf(LumosLogin)).call(this,props));_this.UserStore=new __WEBPACK_IMPORTED_MODULE_2__util_UserStore__["a" /* default */]();return _this;}_createClass(LumosLogin,[{key:'componentDidMount',value:function componentDidMount(){var me=this;var success=function success(userObj){if((typeof userObj==='undefined'?'undefined':_typeof(userObj))==="object"&&userObj.authToken){me.UserStore.set(userObj);var afterUpdate=function afterUpdate(){window.location.href="/landing";};me.updateUserType(afterUpdate);}else{console.warn("Lumos user not logged in PLP system yet.");window.location.href="/";}};var failure=function failure(error){console.warn("Lumos user not logged in PLP system failure.",error);window.location.href="/";};this.sessionCheck(success,failure,true);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' ',this.showLoader());}}]);return LumosLogin;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (LumosLogin);

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_device_detect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_HawkEye__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_CoreAjax__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_heymathlogo_png__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_heymathlogo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_heymathlogo_png__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VendorLogin=function(_PreLoginPage){_inherits(VendorLogin,_PreLoginPage);function VendorLogin(props){_classCallCheck(this,VendorLogin);var _this=_possibleConstructorReturn(this,(VendorLogin.__proto__||Object.getPrototypeOf(VendorLogin)).call(this,props));_this.hmNav=function(userobj){console.log("hmnav userobj:::",userobj);var me=_this;if(_this.productsAvailableToAccess(userobj)){window.top.location.href="/landing";}else{if(userobj&&userobj.userRole&&userobj.userRole.role&&userobj.userRole.role.toUpperCase()==="TCHR"){window.top.location.href="/teachers";}else{window.top.location.href='/products';}}};_this.UserStore=new __WEBPACK_IMPORTED_MODULE_2__util_UserStore__["a" /* default */]();_this.navigationKey="PLP_Navigation";_this.navigateURLKey="PLP_REDIRECT";_this.navigateObj={};_this.doLumosLogout=_this.doLumosLogout.bind(_this);return _this;}_createClass(VendorLogin,[{key:'updateUserType',value:function updateUserType(commonCallback){var me=this;var callBackSuccess=function callBackSuccess(response){if(response!==null){//console.warn("user type",response)
me.UserStore.set(response);}if(typeof commonCallback==="function"){commonCallback.apply(this);}};var callBackFailure=function callBackFailure(response){//console.warn("failure ",response);
if(typeof commonCallback==="function"){commonCallback.apply(this);}};_get(VendorLogin.prototype.__proto__||Object.getPrototypeOf(VendorLogin.prototype),'updateUserType',this).call(this,callBackSuccess,callBackFailure);}},{key:'componentDidMount',value:function componentDidMount(){var me=this;var params=this.getAllParamsObj();console.log("query params:::",params);if(Object.keys(params).length<=0){this.showErrorMsg();return;}var success=function success(response){console.log("External login ajax success... ");console.log("authResponse ::",userObj);var userObj=response.user;if((typeof userObj==='undefined'?'undefined':_typeof(userObj))==="object"&&userObj.authToken){//Update the userStore Object
me.UserStore.set(userObj);try{me.doLumosLogout();}catch(e){}try{me.navigateObj=JSON.parse(__WEBPACK_IMPORTED_MODULE_3__util_BrowserStorageUtil__["a" /* default */].getStoredSessionItem(me.navigationKey));try{var loginObj={"user_id":userObj==null?"":userObj.userId,"login_id":userObj==null?"":userObj.loginId,"user_agent":navigator.userAgent,"platform":navigator.platform,"device":__WEBPACK_IMPORTED_MODULE_5_react_device_detect__["isMobile"]?"mobile":__WEBPACK_IMPORTED_MODULE_5_react_device_detect__["isTablet"]?"tablet":"PC","ip_address":"ip_address","result":true,"session_id":userObj==null?"":userObj.authToken};me.storeTrackEvent("login",loginObj);}catch(e){}//me.props.history.push("/");
var afterUpdate=function afterUpdate(){me.hmNav(userObj);};me.updateUserType(afterUpdate);}catch(e){}}else{//Clear userStore
me.UserStore.clearOldUser();me.showErrorMsg(response.message);}};var failure=function failure(error){//User session is no longer valid
console.log("External login ajax failure...",error);me.showErrorMsg();};//this.sessionCheck(success,failure);
new __WEBPACK_IMPORTED_MODULE_7__util_CoreAjax__["a" /* default */](me.getUrlFor("UOLO_LOGIN")+"?data="+params.data).get(success,failure);}},{key:'productsAvailableToAccess',value:function productsAvailableToAccess(userobj){var user=userobj;//console.log("user::::",user);
if(user!=null){var permissions=user.entlHistory;//console.log("permissions:::",permissions);
if(permissions!=null&&Object.keys(permissions).length>0){for(var i in permissions){if(permissions[i]!=null){var totalLevel=permissions[i].split(",").reduce(function(a,b){try{return parseInt(a)+parseInt(b);}catch(e){return 0;}});if(totalLevel>0){return true;}}}}}return false;}},{key:'showErrorMsg',value:function showErrorMsg(){var errRef=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var me=this;var msg=me.rb("profile.oops");if(errRef!=""){msg=me.rb("uolo.forbidden.msg")+(errRef.toLowerCase().split("error ::")[1]||errRef);}var buttons=[{label:me.rb("alert.ok"),handler:function handler(){me.props.history.push("/");}}];me.showAlert(" ",msg,buttons);}},{key:'getAllParamsObj',value:function getAllParamsObj(){var paramObj={};try{var paramsArr=window.location.href.split("?");if(paramsArr.length>1&&paramsArr[1].length>0){paramObj=this.extractParamsObj(paramsArr[1]);}}catch(e){}return paramObj;}},{key:'extractParamsObj',value:function extractParamsObj(paramsArrStr){var paramObj={};try{if(paramsArrStr!==null&&paramsArrStr.length>0){var paramPairArr=paramsArrStr.split("&");if(paramPairArr!==null&&paramPairArr.length>0){for(var i=0;i<paramPairArr.length;i++){var eachPair=paramPairArr[i].split("=");paramObj[eachPair[0]]=eachPair.length>0?eachPair[1]:eachPair[0];}}}}catch(e){}return paramObj;}},{key:'trackMe',value:function trackMe(result){var userObj=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var trackObj={"user_id":userObj==null?"":userObj.userId,"login_id":userObj==null?"":userObj.loginId,"user_agent":navigator.userAgent,"platform":navigator.platform,"device":__WEBPACK_IMPORTED_MODULE_5_react_device_detect__["isMobile"]?"mobile":__WEBPACK_IMPORTED_MODULE_5_react_device_detect__["isTablet"]?"tablet":"PC","ip_address":"ip_address","result":result===true,"session_id":userObj==null?"":userObj.authToken};this.initiateTrack("login",trackObj);}},{key:'initiateTrack',value:function initiateTrack(trackKey,addnldata){try{var eventObj=this.getTracker();var trackObj=eventObj.getEventObject(eventObj.eventCodes[trackKey]);trackObj.event_details.user_id=addnldata.user_id||"";trackObj.event_details.session_id=addnldata.authToken||"";trackObj.event_details.timestamp=new Date().getTime()||"";if(addnldata!==undefined&&(typeof addnldata==='undefined'?'undefined':_typeof(addnldata))==="object"){for(var key in addnldata){trackObj.event_data[key]=addnldata[key];}}var output={"event":trackObj};var me=this;new __WEBPACK_IMPORTED_MODULE_6__util_HawkEye__["a" /* default */](output).post();}catch(e){console.log("Error in Tracking :::",e);}}},{key:'doLumosLogout',value:function doLumosLogout(){var me=this;console.log("logout url="+me.getUrlFor("LUMOS_LOGOUT"));__WEBPACK_IMPORTED_MODULE_4_jquery___default.a.ajax({url:me.getUrlFor("LUMOS_LOGOUT"),type:'GET',xhrFields:{withCredentials:true},crossDomain:true,success:function success(response){},error:function error(response){console.log("Error in LUMOS_LOGOUT",response);}});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'centerhlogo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__images_heymathlogo_png___default.a})),this.showLoader());}}]);return VendorLogin;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (VendorLogin);

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_CorePage__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_UserStorageUtil__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_CoreAjax__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_plp_TestTakingModalComponent__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Errmsg__ = __webpack_require__(290);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OpenLessonView=function(_CorePage){_inherits(OpenLessonView,_CorePage);function OpenLessonView(props){_classCallCheck(this,OpenLessonView);var _this=_possibleConstructorReturn(this,(OpenLessonView.__proto__||Object.getPrototypeOf(OpenLessonView)).call(this,props));_this.state={"dataLoaded":false,data:{},lessonUrl:null,iFrameHeight:'0px',AlertModalShow:false};_this.requestParams="";_this.trackId=null;_this.trackLessonClose=_this.trackLessonClose.bind(_this);_this.setContentSize=_this.setContentSize.bind(_this);_this.resizeCall=_this.resizeCall.bind(_this);_this.userId=null;_this.enableTimer=true;_this.enableSessionTimer=true;_this.previousEventObj={};_this.icepieTrackingTimer=false;_this.icepieActivityTrackingTimer=true;_this.currentDD=0;_this.pulseInteractivityId=null;_this.interativeType=null;_this.lessonViewStopped=false;_this.substituteZAProxy=_this.substituteZAProxy.bind(_this);_this.hideAlertModal=_this.hideAlertModal.bind(_this);_this.errorMsg={heading:'',srcval:'',description:''};return _this;}_createClass(OpenLessonView,[{key:'substituteZAProxy',value:function substituteZAProxy(){var lessonUrl=this.state.lessonUrl;if(lessonUrl&&lessonUrl.length>0){lessonUrl=lessonUrl.replace(this.getUrlFor("ORIG_CS_BASE_URL"),this.getUrlFor("CS_BASE_URL"));}return lessonUrl;}},{key:'componentDidMount',value:function componentDidMount(){this.getLessonUrl();var me=this;var myConfObj={iframeMouseOver:false};__WEBPACK_IMPORTED_MODULE_4_jquery___default()(window).on('beforeunload',function(){me.trackLessonClose();});__WEBPACK_IMPORTED_MODULE_4_jquery___default()(window).on('unload',function(){me.trackLessonClose();});__WEBPACK_IMPORTED_MODULE_4_jquery___default()(window).resize(function(){me.setContentSize();});this.setContentSize();}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('beforeunload',this.trackLessonClose);}},{key:'initiateTimer',value:function initiateTimer(){var me=this;setInterval(function(){if(me.enableTimer){//console.log("initiateTimer ::");
me.trackLessonClose();}},5000);}},{key:'setLessonNameAsTitle',value:function setLessonNameAsTitle(lessonId){try{if(lessonId){var title=__WEBPACK_IMPORTED_MODULE_2__util_UserStorageUtil__["a" /* default */].getStoredSessionItem(lessonId);if(!title){title=sessionStorage.getItem(lessonId);}else{title=" "+title+" ";if(sessionStorage){if(!sessionStorage.getItem(lessonId))sessionStorage.setItem(lessonId,title);//remove after setting
__WEBPACK_IMPORTED_MODULE_2__util_UserStorageUtil__["a" /* default */].deleteSessionItem(lessonId);}}}if(title)document.title+=title;}catch(e){}}},{key:'getAdditionalUrlParams',value:function getAdditionalUrlParams(lessonUrl){try{var paramsArr=window.location.href.split("?");if(paramsArr.length>1&&paramsArr[1].length>0){lessonUrl+="&"+paramsArr[1];var paramObj=this.extractParamsObj(paramsArr[1]);this.setLessonNameAsTitle(paramObj["url"]);}}catch(e){}return lessonUrl;}},{key:'getAllParamsObj',value:function getAllParamsObj(){var paramObj={};try{var paramsArr=window.location.href.split("?");if(paramsArr.length>1&&paramsArr[1].length>0){paramObj=this.extractParamsObj(paramsArr[1]);}}catch(e){}return paramObj;}},{key:'getAllUrlParams',value:function getAllUrlParams(urlString){try{var paramsArr=window.location.href.split("?");if(paramsArr.length>1&&paramsArr[1].length>0){if(urlString.indexOf("?")>0){urlString+="&"+paramsArr[1];}else{urlString+="?"+paramsArr[1];}}}catch(e){}return urlString;}},{key:'extractParamsObj',value:function extractParamsObj(paramsArrStr){var paramObj={};try{if(paramsArrStr!==null&&paramsArrStr.length>0){var paramPairArr=paramsArrStr.split("&");if(paramPairArr!==null&&paramPairArr.length>0){for(var i=0;i<paramPairArr.length;i++){var eachPair=paramPairArr[i].split("=");paramObj[eachPair[0]]=eachPair.length>0?eachPair[1]:eachPair[0];}}}}catch(e){}return paramObj;}},{key:'getLessonUrl',value:function getLessonUrl(){try{var me=this;var successHandler=function successHandler(data){if(data===null||data!==null&&data.errorMsg){var buttons=[{label:me.rb("home.btn.close"),handler:function handler(){window.close();}}];if(data.errorMsg&&data.errorMsg==="mobile_no_flash"){me.errorMsg={heading:me.rb("lesson."+data.errorMsg+".heading")||me.rb("lesson."+data.errorMsg+".heading"),srcval:"desktoporlaptop",description:me.rb("lesson."+data.errorMsg)||me.rb("lesson."+data.errorMsg)};me.setState({AlertModalShow:true});}else if(data.errorMsg&&data.errorMsg==="not_authorized"){me.showAlert(null,me.rb("lesson."+data.errorMsg)||me.rb("lesson."+data.errorMsg),buttons);}else if(data.errorMsg&&data.errorMsg==="user_session_not_available"){me.showAlert(null,me.rb("lesson."+data.errorMsg)||me.rb("lesson."+data.errorMsg),buttons);}else if(data.errorMsg&&data.errorMsg==="no_lesson_id"){me.showAlert(null,"<div><div>Oops!</div><div>Looks like you are lost. </div><div>Go to HeyMath! to continue learning</div></div>",buttons);}else if(data.errorMsg&&data.errorMsg==="not_free_lesson"){me.showAlert(null,"<div><div>Oops!</div><div>Looks like you are lost. </div><div>Go to HeyMath! to continue learning</div></div>",'',"no");}else{me.showAlert(null,me.rb(data.errorMsg)||me.rb(data.errorMsg),buttons);}return;}if(data&&data.lessonUrl){me.setState({"dataLoaded":true,"data":data,lessonUrl:me.getAdditionalUrlParams(data.lessonUrl),"iFrameHeight":window.innerHeight});me.trackLessonOpen();me.initiateTimer();setTimeout(function(){me.setContentSize();},1500);}else{//Please close this window and login to continue
}};var failureHandler=function failureHandler(err){var buttons=[{label:me.rb("home.btn.close"),handler:function handler(){window.close();}}];me.showAlert(me.rb("error"),me.rb("generic_connect_error"),buttons);return;};var lessonId=this.props.match.params.id;new __WEBPACK_IMPORTED_MODULE_3__util_CoreAjax__["a" /* default */](this.getAllUrlParams(this.getUrlFor("LESSON_URL_OPEN")+lessonId)).get(successHandler,failureHandler);}catch(e){var buttons=[{label:me.rb("home.btn.close"),handler:function handler(){window.close();}}];me.showAlert(me.rb("error"),me.rb("system_error"),buttons);}}},{key:'trackLessonClose',value:function trackLessonClose(){try{var me=this;var successHandler=function successHandler(data){console.log("track lesson close success");};var failureHandler=function failureHandler(err){console.log("Error in TRACK_LESSON_CLOSE");return;};new __WEBPACK_IMPORTED_MODULE_3__util_CoreAjax__["a" /* default */](this.getUrlFor("TRACK_LESSON_CLOSE")+me.trackId+"/"+me.userId).get(successHandler,failureHandler);}catch(e){console.log("Error in track lessson close..");}}},{key:'trackLessonOpen',value:function trackLessonOpen(){var params=this.getAllParamsObj();/*lessonPref:"html5"
		lessonname:"Subtracting%207-Digit%20Numbers"
		revisiontopicid:"0"
		src:"plp"
		testid:"0"
		url:"vl1283a_subtract7digit"*/var formData={"lessonUrl":params.url,"lessonDd":params.lessonPref=="flash"?0:parseInt(params.dd)||1,"lessonType":params.lessonPref,"classId":parseInt(params.classId),"accessId":parseInt(params.accessId),"topicSubtopicMapId":parseInt(params.revisiontopicid)};try{var me=this;var successHandler=function successHandler(data){if(data!=null){me.trackId=data.trackId;return;}};var failureHandler=function failureHandler(err){console.log("Error in TRACK_LESSON_OPEN");return;};var lessonId=this.props.match.params.id;new __WEBPACK_IMPORTED_MODULE_3__util_CoreAjax__["a" /* default */](this.getUrlFor("TRACK_LESSON_OPEN"),formData).post(successHandler,failureHandler);}catch(e){console.log("Error in lesson tracking...");}}},{key:'setContentSize',value:function setContentSize(){var me=this;//
var userAgent=navigator.userAgent||navigator.vendor||window.opera;if(/iPad|iPhone|iPod/.test(userAgent)&&!window.MSStream){//
__WEBPACK_IMPORTED_MODULE_4_jquery___default()("#contentIFrame").css("visibility","hidden");setTimeout(function(){__WEBPACK_IMPORTED_MODULE_4_jquery___default()("#contentIFrame").css("visibility","visible");me.resizeCall();},1500);//
}me.resizeCall();}//
},{key:'resizeCall',value:function resizeCall(){//
try{__WEBPACK_IMPORTED_MODULE_4_jquery___default()("#contentIFrame").css({width:window.innerWidth,height:window.innerHeight});}catch(e){}}},{key:'hideAlertModal',value:function hideAlertModal(){this.setState({AlertModalShow:false});window.close();}},{key:'renderModalContent',value:function renderModalContent(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__views_plp_TestTakingModalComponent__["a" /* default */],{visible:this.state.AlertModalShow,dialogClassName:"loginModal modal-lg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-header bg-purple'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-title'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close helpClose',onClick:this.hideAlertModal,'aria-label':'Close'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'close')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',_defineProperty({className:'modal-body'},'className','col-12 text-center bdycont'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Errmsg__["a" /* default */],{errormsg:this.errorMsg}))));}},{key:'render',value:function render(){var me=this;if(!this.state.dataLoaded||this.state.lessonUrl===null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.showLoader(),this.renderModalContent());}else{if(this.state.lessonUrl){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'lessonIframeContainer',style:{height:"100vh",overflowY:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{id:'contentIFrame',style:{width:'100%',height:me.state.iFrameHeight,overflowY:'hidden'},onLoad:function onLoad(){me.setContentSize();me.setState({"iFrameHeight":window.innerHeight+'px'});},ref:'iframe',src:me.substituteZAProxy(),width:'100%',height:me.state.iFrameHeight,scrolling:'no',frameBorder:'0',referrerpolicy:'no-referrer-when-downgrade'}),this.renderModalContent());}}}}]);return OpenLessonView;}(__WEBPACK_IMPORTED_MODULE_1__views_core_CorePage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (OpenLessonView);

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prelogin_src_PreloginHome__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_core_ErrorPage__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vendors_mindstretcher_ms_Home__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_BrowserUtil__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_UserStorageUtil__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__model_AppConstants_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vendors_mindstretcher_Report__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__model_ComponentRegistry_js__ = __webpack_require__(38);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ms_PreloginHome=function(_PreloginHome){_inherits(ms_PreloginHome,_PreloginHome);function ms_PreloginHome(props){_classCallCheck(this,ms_PreloginHome);var _this=_possibleConstructorReturn(this,(ms_PreloginHome.__proto__||Object.getPrototypeOf(ms_PreloginHome)).call(this,props));_this.showHideLeftMenu=_this.showHideLeftMenu.bind(_this);_this.getHeaderLogo=_this.getHeaderLogo.bind(_this);return _this;}_createClass(ms_PreloginHome,[{key:'componentWillMount',value:function componentWillMount(){_get(ms_PreloginHome.prototype.__proto__||Object.getPrototypeOf(ms_PreloginHome.prototype),'componentWillMount',this).call(this);}},{key:'componentDidMount',value:function componentDidMount(){_get(ms_PreloginHome.prototype.__proto__||Object.getPrototypeOf(ms_PreloginHome.prototype),'componentDidMount',this).call(this);this.setFavIco();try{var isCollapsed=this.getAttribute("sidebar_collapsed")==="true";//UserStorageUtil.getStoredSessionItem("sidebar_collapsed") ||
__WEBPACK_IMPORTED_MODULE_9__model_AppConstants_js__["a" /* default */].collapsed=isCollapsed||__WEBPACK_IMPORTED_MODULE_9__model_AppConstants_js__["a" /* default */].collapsed;if(__WEBPACK_IMPORTED_MODULE_9__model_AppConstants_js__["a" /* default */].collapsed===true){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.side-navbar').addClass('shrinked');__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.content-inner').addClass('active');__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').removeClass('active');__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').removeClass("goRight");__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-small').show();__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-big').hide();}}catch(e){console.error(e);}if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).outerWidth()>1183){if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').hasClass('active')){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').addClass("goRight");}else{__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').removeClass("goRight");}}if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).outerWidth()<1183){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').removeClass("goRight");}this.appendCSS("./vendors/ms_main.css");}/**
    * IMPORTANT: Please follow this way to use favIcon
    */},{key:'setFavIco',value:function setFavIco(){if(window.fav_ico_by_prefix&&window.fav_ico_by_prefix[this.getUser().getSchoolPrefix()]){if(document.getElementsByName("fav_ico").length>0){document.getElementsByName("fav_ico")[0].href=window.fav_ico_by_prefix[this.getUser().getSchoolPrefix()];}}}},{key:'toggleSideBar',value:function toggleSideBar(){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').toggleClass('active');__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.side-navbar').toggleClass('shrinked');__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.content-inner').toggleClass('active');if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).outerWidth()>1183){if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').hasClass('active')){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-small').hide();__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-big').show();__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').addClass("goRight");}else{__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-small').show();__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-big').hide();__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').removeClass("goRight");}}if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).outerWidth()<1183){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-small').show();__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').removeClass("goRight");}try{var isCollapsed=__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.side-navbar').hasClass('shrinked');if(typeof isCollapsed==="boolean"){this.setAttribute("sidebar_collapsed",isCollapsed.toString());}__WEBPACK_IMPORTED_MODULE_9__model_AppConstants_js__["a" /* default */].collapsed=__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.side-navbar').hasClass('shrinked');__WEBPACK_IMPORTED_MODULE_8__util_UserStorageUtil__["a" /* default */].storeSessionItem("sidebar_collapsed",__WEBPACK_IMPORTED_MODULE_9__model_AppConstants_js__["a" /* default */].collapsed);}catch(e){console.log(e);}try{var isCollapsed=this.getAttribute("sidebar_collapsed")==="true";console.log("isCollapsed::::",isCollapsed);//UserStorageUtil.getStoredSessionItem("sidebar_collapsed") ||
__WEBPACK_IMPORTED_MODULE_9__model_AppConstants_js__["a" /* default */].collapsed=isCollapsed||__WEBPACK_IMPORTED_MODULE_9__model_AppConstants_js__["a" /* default */].collapsed;if(__WEBPACK_IMPORTED_MODULE_9__model_AppConstants_js__["a" /* default */].collapsed===true){__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".page-content .content-inner").toggleClass("fullwidth");__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".page-content nav.side-navbar").toggle();__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".page-content nav.side-navbar").toggleClass('collapsed');}}catch(e){console.error(e);}}},{key:'getButtonName',value:function getButtonName(){//console.log("lumos login::::",this.state.LumosloggedIn);
if(this.state.loggedIn||this.state.LumosloggedIn||__WEBPACK_IMPORTED_MODULE_7__util_BrowserUtil__["a" /* default */].getAuthToken()&&__WEBPACK_IMPORTED_MODULE_7__util_BrowserUtil__["a" /* default */].getAuthToken().length>=5||__WEBPACK_IMPORTED_MODULE_7__util_BrowserUtil__["a" /* default */].getLumosToken()&&__WEBPACK_IMPORTED_MODULE_7__util_BrowserUtil__["a" /* default */].getLumosToken().length>=5){return this.rb("menu.home");//return this.rb("btn.label.myheymath");
}return this.rb("btn.label.signin");}},{key:'getSwitcher',value:function getSwitcher(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{exact:true,path:'/',component:this.Home.bind(this),maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{exact:true,path:'/home',component:this.Home.bind(this),maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/landing',exact:true,component:__WEBPACK_IMPORTED_MODULE_6__vendors_mindstretcher_ms_Home__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/report',exact:true,component:__WEBPACK_IMPORTED_MODULE_10__vendors_mindstretcher_Report__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{exact:true,path:'/404',component:__WEBPACK_IMPORTED_MODULE_3__views_core_ErrorPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{component:this.getErrorPage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Redirect */],{from:'*',to:'/'}));}/*
      * IMPORTANT: Hardcoded temporarily. Needs to be addressed post demo
      */},{key:'getHeaderLogo',value:function getHeaderLogo(){if(this.getUser().getSchoolPrefix()&&this.getUser().getSchoolPrefix().length>0){if(this.getUser().getSchoolPrefix().toLowerCase()==="ms_"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/img/mindstretcher/logo.png',alt:'Mind Stretcher logo'});}else{return _get(ms_PreloginHome.prototype.__proto__||Object.getPrototypeOf(ms_PreloginHome.prototype),'getHeaderLogo',this).call(this);}}else{return _get(ms_PreloginHome.prototype.__proto__||Object.getPrototypeOf(ms_PreloginHome.prototype),'getHeaderLogo',this).call(this);}}},{key:'renderLoginView',value:function renderLoginView(){var _this2=this;if(this.state.loggedIn==true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inlineblock'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inlineblock navbar-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'nav-item dropdown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-link dropdown-toggle',href:'#',id:'navbardrop','data-toggle':'dropdown'},this.state.imageLoaded?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'material-icons md-60  usericon imgprv',src:this.state.imagePreviewUrl}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons md-40 useraccountelement'},'account_circle')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dropdown-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dropdown-item pflename'},this.UserStore.getUserName()||this.UserStore.getLoginId()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'dropdown-item',href:'#',onClick:function onClick(){_this2.onLogout();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons pr-16'},'power_settings_new'),' Sign out')))));}}},{key:'getRouter',value:function getRouter(){var me=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'nav-desktop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid norightpadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'showhidemenu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'toggle-btn',href:'#',className:'menu-btn active',onClick:this.showHideLeftMenu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'menu'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{to:'/home',onClick:me.setPreloginClass},this.getHeaderLogo())),function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'textAlignLeft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null));}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-sec'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'My HeyMath Tab',className:"r-btn myheymathbtn mr-30 "+me.getMargin(),onClick:me.showLoginForm},me.getButtonName()),me.renderLoginView())))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'}),me.getSwitcher()));}},{key:'showHideLeftMenu',value:function showHideLeftMenu(){//$(".page-content nav.side-navbar").toggle();
__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".page-content .content-inner").toggleClass("fullwidth");__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".page-content nav.side-navbar").toggle();__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".page-content nav.side-navbar").toggleClass('collapsed');try{var isCollapsed=__WEBPACK_IMPORTED_MODULE_1_jquery___default()('nav.side-navbar').hasClass('collapsed');if(typeof isCollapsed==="boolean"){this.setAttribute("sidebar_collapsed",isCollapsed.toString());}__WEBPACK_IMPORTED_MODULE_9__model_AppConstants_js__["a" /* default */].collapsed=__WEBPACK_IMPORTED_MODULE_1_jquery___default()('nav.side-navbar').hasClass('collapsed');__WEBPACK_IMPORTED_MODULE_8__util_UserStorageUtil__["a" /* default */].storeSessionItem("sidebar_collapsed",__WEBPACK_IMPORTED_MODULE_9__model_AppConstants_js__["a" /* default */].collapsed);}catch(e){//console.log(e);
}}},{key:'render',value:function render(){/*require('./ms_main.css');*/return _get(ms_PreloginHome.prototype.__proto__||Object.getPrototypeOf(ms_PreloginHome.prototype),'render',this).call(this,this.getRouter());}}]);return ms_PreloginHome;}(__WEBPACK_IMPORTED_MODULE_2__prelogin_src_PreloginHome__["a" /* default */]);/* unused harmony default export */ var _unused_webpack_default_export = (ms_PreloginHome);__WEBPACK_IMPORTED_MODULE_11__model_ComponentRegistry_js__["a" /* default */].register("ms_preloginhome",ms_PreloginHome);/*
* Also registering for the users with hm_ prefix
*/__WEBPACK_IMPORTED_MODULE_11__model_ComponentRegistry_js__["a" /* default */].register("hm_preloginhome",ms_PreloginHome);

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(68);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
var styles = {
  overlay: function overlay(isOpen) {
    return {
      position: 'fixed',
      zIndex: 1000,
      width: '100%',
      height: '100%',
      background: 'rgba(0, 0, 0, 0.3)',
      opacity: isOpen ? 1 : 0,
      MozTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
      MsTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
      OTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
      WebkitTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
      transform: isOpen ? '' : 'translate3d(100%, 0, 0)',
      transition: isOpen ? 'opacity 0.3s' : 'opacity 0.3s, transform 0s 0.3s'
    };
  },

  menuWrap: function menuWrap(isOpen, width, right) {
    return {
      position: 'fixed',
      right: right ? 0 : 'inherit',
      zIndex: 1100,
      width: width,
      height: '100%',
      MozTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      MsTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      OTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      transform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      transition: 'all 0.5s'
    };
  },

  menu: function menu() {
    return {
      height: '100%',
      boxSizing: 'border-box',
      overflow: 'auto'
    };
  },

  itemList: function itemList() {
    return {
      height: '100%'
    };
  },

  item: function item() {
    return {
      display: 'block'
    };
  }
};

exports['default'] = styles;
module.exports = exports['default'];

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var BurgerIcon = (function (_Component) {
  _inherits(BurgerIcon, _Component);

  function BurgerIcon(props) {
    _classCallCheck(this, BurgerIcon);

    _get(Object.getPrototypeOf(BurgerIcon.prototype), 'constructor', this).call(this, props);
    this.state = {
      hover: false
    };
  }

  _createClass(BurgerIcon, [{
    key: 'getLineStyle',
    value: function getLineStyle(index) {
      return _extends({
        position: 'absolute',
        height: '20%',
        left: 0,
        right: 0,
        top: 20 * (index * 2) + '%',
        opacity: this.state.hover ? 0.6 : 1
      }, this.state.hover && this.props.styles.bmBurgerBarsHover);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this = this;

      var icon = undefined;
      var buttonStyle = {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        margin: 0,
        padding: 0,
        border: 'none',
        fontSize: 0,
        background: 'transparent',
        cursor: 'pointer'
      };

      if (this.props.customIcon) {
        var extraProps = {
          className: ('bm-icon ' + (this.props.customIcon.props.className || '')).trim(),
          style: _extends({ width: '100%', height: '100%' }, this.props.styles.bmIcon)
        };
        icon = _react2['default'].cloneElement(this.props.customIcon, extraProps);
      } else {
        icon = _react2['default'].createElement(
          'span',
          null,
          [0, 1, 2].map(function (bar) {
            return _react2['default'].createElement('span', {
              key: bar,
              className: ('bm-burger-bars ' + _this.props.barClassName + ' ' + (_this.state.hover ? 'bm-burger-bars-hover' : '')).trim(),
              style: _extends({}, _this.getLineStyle(bar), _this.props.styles.bmBurgerBars)
            });
          })
        );
      }

      return _react2['default'].createElement(
        'div',
        {
          className: ('bm-burger-button ' + this.props.className).trim(),
          style: _extends({ zIndex: 1000 }, this.props.styles.bmBurgerButton)
        },
        icon,
        _react2['default'].createElement(
          'button',
          {
            onClick: this.props.onClick,
            onMouseOver: function () {
              return _this.setState({ hover: true });
            },
            onMouseOut: function () {
              return _this.setState({ hover: false });
            },
            style: buttonStyle
          },
          'Open Menu'
        )
      );
    }
  }]);

  return BurgerIcon;
})(_react.Component);

exports['default'] = BurgerIcon;

BurgerIcon.propTypes = {
  barClassName: _propTypes2['default'].string,
  customIcon: _propTypes2['default'].element,
  styles: _propTypes2['default'].object
};

BurgerIcon.defaultProps = {
  barClassName: '',
  className: '',
  styles: {}
};
module.exports = exports['default'];

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var CrossIcon = (function (_Component) {
  _inherits(CrossIcon, _Component);

  function CrossIcon() {
    _classCallCheck(this, CrossIcon);

    _get(Object.getPrototypeOf(CrossIcon.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(CrossIcon, [{
    key: 'getCrossStyle',
    value: function getCrossStyle(type) {
      return {
        position: 'absolute',
        width: 3,
        height: 14,
        transform: type === 'before' ? 'rotate(45deg)' : 'rotate(-45deg)'
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this = this;

      var icon;
      var buttonWrapperStyle = {
        position: 'absolute',
        width: 24,
        height: 24,
        right: 8,
        top: 8
      };
      var buttonStyle = {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        margin: 0,
        padding: 0,
        border: 'none',
        fontSize: 0,
        background: 'transparent',
        cursor: 'pointer'
      };

      if (this.props.customIcon) {
        var extraProps = {
          className: ('bm-cross ' + (this.props.customIcon.props.className || '')).trim(),
          style: _extends({ width: '100%', height: '100%' }, this.props.styles.bmCross)
        };
        icon = _react2['default'].cloneElement(this.props.customIcon, extraProps);
      } else {
        icon = _react2['default'].createElement(
          'span',
          { style: { position: 'absolute', top: '6px', right: '14px' } },
          ['before', 'after'].map(function (type, i) {
            return _react2['default'].createElement('span', {
              key: i,
              className: ('bm-cross ' + _this.props.crossClassName).trim(),
              style: _extends({}, _this.getCrossStyle(type), _this.props.styles.bmCross)
            });
          })
        );
      }

      return _react2['default'].createElement(
        'div',
        {
          className: ('bm-cross-button ' + this.props.className).trim(),
          style: _extends({}, buttonWrapperStyle, this.props.styles.bmCrossButton)
        },
        icon,
        _react2['default'].createElement(
          'button',
          {
            onClick: this.props.onClick,
            style: buttonStyle,
            tabIndex: this.props.tabIndex
          },
          'Close Menu'
        )
      );
    }
  }]);

  return CrossIcon;
})(_react.Component);

exports['default'] = CrossIcon;

CrossIcon.propTypes = {
  crossClassName: _propTypes2['default'].string,
  customIcon: _propTypes2['default'].element,
  styles: _propTypes2['default'].object,
  tabIndex: _propTypes2['default'].number
};

CrossIcon.defaultProps = {
  crossClassName: '',
  className: '',
  styles: {},
  tabIndex: 0
};
module.exports = exports['default'];

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(68);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  menuWrap: function menuWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      MsTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      OTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      transform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      transition: isOpen ? 'transform 0.8s cubic-bezier(0.7, 0, 0.3, 1)' : 'transform 0.4s cubic-bezier(0.7, 0, 0.3, 1)'
    };
  },

  item: function item(isOpen, width, right, nthChild) {
    return {
      MozTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
      MsTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
      OTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
      WebkitTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
      transform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
      transition: isOpen ? 'transform 0.8s cubic-bezier(0.7, 0, 0.3, 1)' : 'transform 0s 0.2s cubic-bezier(0.7, 0, 0.3, 1)'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _snapsvgImporter = __webpack_require__(445);

var _snapsvgImporter2 = _interopRequireDefault(_snapsvgImporter);

var _menuFactory = __webpack_require__(68);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  svg: {
    lib: _snapsvgImporter2['default'],
    pathInitial: 'M-1,0h101c0,0-97.833,153.603-97.833,396.167C2.167,627.579,100,800,100,800H-1V0z',
    pathOpen: 'M-1,0h101c0,0,0-1,0,395c0,404,0,405,0,405H-1V0z',
    animate: function animate(path) {
      path.animate({ path: this.pathOpen }, 400, window.mina.easeinout);
    }
  },

  morphShape: function morphShape(isOpen, width, right) {
    return {
      position: 'absolute',
      width: 120,
      height: '100%',
      right: right ? 'inherit' : 0,
      left: right ? 0 : 'inherit',
      MozTransform: right ? 'rotateY(180deg)' : '',
      MsTransform: right ? 'rotateY(180deg)' : '',
      OTransform: right ? 'rotateY(180deg)' : '',
      WebkitTransform: right ? 'rotateY(180deg)' : '',
      transform: right ? 'rotateY(180deg)' : ''
    };
  },

  menuWrap: function menuWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      transition: 'all 0.3s'
    };
  },

  menu: function menu(isOpen, width, right) {
    return {
      position: 'fixed',
      right: right ? 0 : 'inherit',
      width: 180,
      whiteSpace: 'nowrap',
      boxSizing: 'border-box',
      overflow: 'visible'
    };
  },

  itemList: function itemList(isOpen, width, right) {
    if (right) {
      return {
        position: 'relative',
        left: '-110px',
        width: '170%',
        overflow: 'auto'
      };
    }
  },

  pageWrap: function pageWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
      MsTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
      OTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
      transform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
      transition: isOpen ? 'all 0.3s' : 'all 0.3s 0.1s'
    };
  },

  outerContainer: function outerContainer(isOpen) {
    return {
      overflow: isOpen ? '' : 'hidden'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

window.eve = __webpack_require__(1080)

// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var mina = (function (eve) {
    var animations = {},
    requestAnimFrame = window.requestAnimationFrame       ||
                       window.webkitRequestAnimationFrame ||
                       window.mozRequestAnimationFrame    ||
                       window.oRequestAnimationFrame      ||
                       window.msRequestAnimationFrame     ||
                       function (callback) {
                           setTimeout(callback, 16, new Date().getTime());
                           return true;
                       },
    requestID,
    isArray = Array.isArray || function (a) {
        return a instanceof Array ||
            Object.prototype.toString.call(a) == "[object Array]";
    },
    idgen = 0,
    idprefix = "M" + (+new Date).toString(36),
    ID = function () {
        return idprefix + (idgen++).toString(36);
    },
    diff = function (a, b, A, B) {
        if (isArray(a)) {
            res = [];
            for (var i = 0, ii = a.length; i < ii; i++) {
                res[i] = diff(a[i], b, A[i], B);
            }
            return res;
        }
        var dif = (A - a) / (B - b);
        return function (bb) {
            return a + dif * (bb - b);
        };
    },
    timer = Date.now || function () {
        return +new Date;
    },
    sta = function (val) {
        var a = this;
        if (val == null) {
            return a.s;
        }
        var ds = a.s - val;
        a.b += a.dur * ds;
        a.B += a.dur * ds;
        a.s = val;
    },
    speed = function (val) {
        var a = this;
        if (val == null) {
            return a.spd;
        }
        a.spd = val;
    },
    duration = function (val) {
        var a = this;
        if (val == null) {
            return a.dur;
        }
        a.s = a.s * val / a.dur;
        a.dur = val;
    },
    stopit = function () {
        var a = this;
        delete animations[a.id];
        a.update();
        eve("mina.stop." + a.id, a);
    },
    pause = function () {
        var a = this;
        if (a.pdif) {
            return;
        }
        delete animations[a.id];
        a.update();
        a.pdif = a.get() - a.b;
    },
    resume = function () {
        var a = this;
        if (!a.pdif) {
            return;
        }
        a.b = a.get() - a.pdif;
        delete a.pdif;
        animations[a.id] = a;
        frame();
    },
    update = function () {
        var a = this,
            res;
        if (isArray(a.start)) {
            res = [];
            for (var j = 0, jj = a.start.length; j < jj; j++) {
                res[j] = +a.start[j] +
                    (a.end[j] - a.start[j]) * a.easing(a.s);
            }
        } else {
            res = +a.start + (a.end - a.start) * a.easing(a.s);
        }
        a.set(res);
    },
    frame = function (timeStamp) {
        // Manual invokation?
        if (!timeStamp) {
            // Frame loop stopped?
            if (!requestID) {
                // Start frame loop...
                requestID = requestAnimFrame(frame);
            }
            return;
        }
        var len = 0;
        for (var i in animations) if (animations.hasOwnProperty(i)) {
            var a = animations[i],
                b = a.get(),
                res;
            len++;
            a.s = (b - a.b) / (a.dur / a.spd);
            if (a.s >= 1) {
                delete animations[i];
                a.s = 1;
                len--;
                (function (a) {
                    setTimeout(function () {
                        eve("mina.finish." + a.id, a);
                    });
                }(a));
            }
            a.update();
        }
        requestID = len ? requestAnimFrame(frame) : false;
    },
    /*\
     * mina
     [ method ]
     **
     * Generic animation of numbers
     **
     - a (number) start _slave_ number
     - A (number) end _slave_ number
     - b (number) start _master_ number (start time in general case)
     - B (number) end _master_ number (end time in general case)
     - get (function) getter of _master_ number (see @mina.time)
     - set (function) setter of _slave_ number
     - easing (function) #optional easing function, default is @mina.linear
     = (object) animation descriptor
     o {
     o         id (string) animation id,
     o         start (number) start _slave_ number,
     o         end (number) end _slave_ number,
     o         b (number) start _master_ number,
     o         s (number) animation status (0..1),
     o         dur (number) animation duration,
     o         spd (number) animation speed,
     o         get (function) getter of _master_ number (see @mina.time),
     o         set (function) setter of _slave_ number,
     o         easing (function) easing function, default is @mina.linear,
     o         status (function) status getter/setter,
     o         speed (function) speed getter/setter,
     o         duration (function) duration getter/setter,
     o         stop (function) animation stopper
     o         pause (function) pauses the animation
     o         resume (function) resumes the animation
     o         update (function) calles setter with the right value of the animation
     o }
    \*/
    mina = function (a, A, b, B, get, set, easing) {
        var anim = {
            id: ID(),
            start: a,
            end: A,
            b: b,
            s: 0,
            dur: B - b,
            spd: 1,
            get: get,
            set: set,
            easing: easing || mina.linear,
            status: sta,
            speed: speed,
            duration: duration,
            stop: stopit,
            pause: pause,
            resume: resume,
            update: update
        };
        animations[anim.id] = anim;
        var len = 0, i;
        for (i in animations) if (animations.hasOwnProperty(i)) {
            len++;
            if (len == 2) {
                break;
            }
        }
        len == 1 && frame();
        return anim;
    };
    /*\
     * mina.time
     [ method ]
     **
     * Returns the current time. Equivalent to:
     | function () {
     |     return (new Date).getTime();
     | }
    \*/
    mina.time = timer;
    /*\
     * mina.getById
     [ method ]
     **
     * Returns an animation by its id
     - id (string) animation's id
     = (object) See @mina
    \*/
    mina.getById = function (id) {
        return animations[id] || null;
    };

    /*\
     * mina.linear
     [ method ]
     **
     * Default linear easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.linear = function (n) {
        return n;
    };
    /*\
     * mina.easeout
     [ method ]
     **
     * Easeout easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.easeout = function (n) {
        return Math.pow(n, 1.7);
    };
    /*\
     * mina.easein
     [ method ]
     **
     * Easein easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.easein = function (n) {
        return Math.pow(n, .48);
    };
    /*\
     * mina.easeinout
     [ method ]
     **
     * Easeinout easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.easeinout = function (n) {
        if (n == 1) {
            return 1;
        }
        if (n == 0) {
            return 0;
        }
        var q = .48 - n / 1.04,
            Q = Math.sqrt(.1734 + q * q),
            x = Q - q,
            X = Math.pow(Math.abs(x), 1 / 3) * (x < 0 ? -1 : 1),
            y = -Q - q,
            Y = Math.pow(Math.abs(y), 1 / 3) * (y < 0 ? -1 : 1),
            t = X + Y + .5;
        return (1 - t) * 3 * t * t + t * t * t;
    };
    /*\
     * mina.backin
     [ method ]
     **
     * Backin easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.backin = function (n) {
        if (n == 1) {
            return 1;
        }
        var s = 1.70158;
        return n * n * ((s + 1) * n - s);
    };
    /*\
     * mina.backout
     [ method ]
     **
     * Backout easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.backout = function (n) {
        if (n == 0) {
            return 0;
        }
        n = n - 1;
        var s = 1.70158;
        return n * n * ((s + 1) * n + s) + 1;
    };
    /*\
     * mina.elastic
     [ method ]
     **
     * Elastic easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.elastic = function (n) {
        if (n == !!n) {
            return n;
        }
        return Math.pow(2, -10 * n) * Math.sin((n - .075) *
            (2 * Math.PI) / .3) + 1;
    };
    /*\
     * mina.bounce
     [ method ]
     **
     * Bounce easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.bounce = function (n) {
        var s = 7.5625,
            p = 2.75,
            l;
        if (n < 1 / p) {
            l = s * n * n;
        } else {
            if (n < 2 / p) {
                n -= 1.5 / p;
                l = s * n * n + .75;
            } else {
                if (n < 2.5 / p) {
                    n -= 2.25 / p;
                    l = s * n * n + .9375;
                } else {
                    n -= 2.625 / p;
                    l = s * n * n + .984375;
                }
            }
        }
        return l;
    };
    window.mina = mina;
    return mina;
})(typeof eve == "undefined" ? function () {} : eve);

// Copyright (c) 2013 - 2017 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var Snap = (function(root) {
Snap.version = "0.5.1";
/*\
 * Snap
 [ method ]
 **
 * Creates a drawing surface or wraps existing SVG element.
 **
 - width (number|string) width of surface
 - height (number|string) height of surface
 * or
 - DOM (SVGElement) element to be wrapped into Snap structure
 * or
 - array (array) array of elements (will return set of elements)
 * or
 - query (string) CSS query selector
 = (object) @Element
\*/
function Snap(w, h) {
    if (w) {
        if (w.nodeType) {
            return wrap(w);
        }
        if (is(w, "array") && Snap.set) {
            return Snap.set.apply(Snap, w);
        }
        if (w instanceof Element) {
            return w;
        }
        if (h == null) {
            try {
                w = glob.doc.querySelector(String(w));
                return wrap(w);
            } catch (e) {
                return null;
            }
        }
    }
    w = w == null ? "100%" : w;
    h = h == null ? "100%" : h;
    return new Paper(w, h);
}
Snap.toString = function () {
    return "Snap v" + this.version;
};
Snap._ = {};
var glob = {
    win: root.window,
    doc: root.window.document
};
Snap._.glob = glob;
var has = "hasOwnProperty",
    Str = String,
    toFloat = parseFloat,
    toInt = parseInt,
    math = Math,
    mmax = math.max,
    mmin = math.min,
    abs = math.abs,
    pow = math.pow,
    PI = math.PI,
    round = math.round,
    E = "",
    S = " ",
    objectToString = Object.prototype.toString,
    ISURL = /^url\(['"]?([^\)]+?)['"]?\)$/i,
    colourRegExp = /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\))\s*$/i,
    bezierrg = /^(?:cubic-)?bezier\(([^,]+),([^,]+),([^,]+),([^\)]+)\)/,
    separator = Snap._.separator = /[,\s]+/,
    whitespace = /[\s]/g,
    commaSpaces = /[\s]*,[\s]*/,
    hsrg = {hs: 1, rg: 1},
    pathCommand = /([a-z])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/ig,
    tCommand = /([rstm])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/ig,
    pathValues = /(-?\d*\.?\d*(?:e[\-+]?\d+)?)[\s]*,?[\s]*/ig,
    idgen = 0,
    idprefix = "S" + (+new Date).toString(36),
    ID = function (el) {
        return (el && el.type ? el.type : E) + idprefix + (idgen++).toString(36);
    },
    xlink = "http://www.w3.org/1999/xlink",
    xmlns = "http://www.w3.org/2000/svg",
    hub = {},
    /*\
     * Snap.url
     [ method ]
     **
     * Wraps path into `"url('<path>')"`.
     - value (string) path
     = (string) wrapped path
    \*/
    URL = Snap.url = function (url) {
        return "url('#" + url + "')";
    };

function $(el, attr) {
    if (attr) {
        if (el == "#text") {
            el = glob.doc.createTextNode(attr.text || attr["#text"] || "");
        }
        if (el == "#comment") {
            el = glob.doc.createComment(attr.text || attr["#text"] || "");
        }
        if (typeof el == "string") {
            el = $(el);
        }
        if (typeof attr == "string") {
            if (el.nodeType == 1) {
                if (attr.substring(0, 6) == "xlink:") {
                    return el.getAttributeNS(xlink, attr.substring(6));
                }
                if (attr.substring(0, 4) == "xml:") {
                    return el.getAttributeNS(xmlns, attr.substring(4));
                }
                return el.getAttribute(attr);
            } else if (attr == "text") {
                return el.nodeValue;
            } else {
                return null;
            }
        }
        if (el.nodeType == 1) {
            for (var key in attr) if (attr[has](key)) {
                var val = Str(attr[key]);
                if (val) {
                    if (key.substring(0, 6) == "xlink:") {
                        el.setAttributeNS(xlink, key.substring(6), val);
                    } else if (key.substring(0, 4) == "xml:") {
                        el.setAttributeNS(xmlns, key.substring(4), val);
                    } else {
                        el.setAttribute(key, val);
                    }
                } else {
                    el.removeAttribute(key);
                }
            }
        } else if ("text" in attr) {
            el.nodeValue = attr.text;
        }
    } else {
        el = glob.doc.createElementNS(xmlns, el);
    }
    return el;
}
Snap._.$ = $;
Snap._.id = ID;
function getAttrs(el) {
    var attrs = el.attributes,
        name,
        out = {};
    for (var i = 0; i < attrs.length; i++) {
        if (attrs[i].namespaceURI == xlink) {
            name = "xlink:";
        } else {
            name = "";
        }
        name += attrs[i].name;
        out[name] = attrs[i].textContent;
    }
    return out;
}
function is(o, type) {
    type = Str.prototype.toLowerCase.call(type);
    if (type == "finite") {
        return isFinite(o);
    }
    if (type == "array" &&
        (o instanceof Array || Array.isArray && Array.isArray(o))) {
        return true;
    }
    return  type == "null" && o === null ||
            type == typeof o && o !== null ||
            type == "object" && o === Object(o) ||
            objectToString.call(o).slice(8, -1).toLowerCase() == type;
}
/*\
 * Snap.format
 [ method ]
 **
 * Replaces construction of type `{<name>}` to the corresponding argument
 **
 - token (string) string to format
 - json (object) object which properties are used as a replacement
 = (string) formatted string
 > Usage
 | // this draws a rectangular shape equivalent to "M10,20h40v50h-40z"
 | paper.path(Snap.format("M{x},{y}h{dim.width}v{dim.height}h{dim['negative width']}z", {
 |     x: 10,
 |     y: 20,
 |     dim: {
 |         width: 40,
 |         height: 50,
 |         "negative width": -40
 |     }
 | }));
\*/
Snap.format = (function () {
    var tokenRegex = /\{([^\}]+)\}/g,
        objNotationRegex = /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g, // matches .xxxxx or ["xxxxx"] to run over object properties
        replacer = function (all, key, obj) {
            var res = obj;
            key.replace(objNotationRegex, function (all, name, quote, quotedName, isFunc) {
                name = name || quotedName;
                if (res) {
                    if (name in res) {
                        res = res[name];
                    }
                    typeof res == "function" && isFunc && (res = res());
                }
            });
            res = (res == null || res == obj ? all : res) + "";
            return res;
        };
    return function (str, obj) {
        return Str(str).replace(tokenRegex, function (all, key) {
            return replacer(all, key, obj);
        });
    };
})();
function clone(obj) {
    if (typeof obj == "function" || Object(obj) !== obj) {
        return obj;
    }
    var res = new obj.constructor;
    for (var key in obj) if (obj[has](key)) {
        res[key] = clone(obj[key]);
    }
    return res;
}
Snap._.clone = clone;
function repush(array, item) {
    for (var i = 0, ii = array.length; i < ii; i++) if (array[i] === item) {
        return array.push(array.splice(i, 1)[0]);
    }
}
function cacher(f, scope, postprocessor) {
    function newf() {
        var arg = Array.prototype.slice.call(arguments, 0),
            args = arg.join("\u2400"),
            cache = newf.cache = newf.cache || {},
            count = newf.count = newf.count || [];
        if (cache[has](args)) {
            repush(count, args);
            return postprocessor ? postprocessor(cache[args]) : cache[args];
        }
        count.length >= 1e3 && delete cache[count.shift()];
        count.push(args);
        cache[args] = f.apply(scope, arg);
        return postprocessor ? postprocessor(cache[args]) : cache[args];
    }
    return newf;
}
Snap._.cacher = cacher;
function angle(x1, y1, x2, y2, x3, y3) {
    if (x3 == null) {
        var x = x1 - x2,
            y = y1 - y2;
        if (!x && !y) {
            return 0;
        }
        return (180 + math.atan2(-y, -x) * 180 / PI + 360) % 360;
    } else {
        return angle(x1, y1, x3, y3) - angle(x2, y2, x3, y3);
    }
}
function rad(deg) {
    return deg % 360 * PI / 180;
}
function deg(rad) {
    return rad * 180 / PI % 360;
}
function x_y() {
    return this.x + S + this.y;
}
function x_y_w_h() {
    return this.x + S + this.y + S + this.width + " \xd7 " + this.height;
}

/*\
 * Snap.rad
 [ method ]
 **
 * Transform angle to radians
 - deg (number) angle in degrees
 = (number) angle in radians
\*/
Snap.rad = rad;
/*\
 * Snap.deg
 [ method ]
 **
 * Transform angle to degrees
 - rad (number) angle in radians
 = (number) angle in degrees
\*/
Snap.deg = deg;
/*\
 * Snap.sin
 [ method ]
 **
 * Equivalent to `Math.sin()` only works with degrees, not radians.
 - angle (number) angle in degrees
 = (number) sin
\*/
Snap.sin = function (angle) {
    return math.sin(Snap.rad(angle));
};
/*\
 * Snap.tan
 [ method ]
 **
 * Equivalent to `Math.tan()` only works with degrees, not radians.
 - angle (number) angle in degrees
 = (number) tan
\*/
Snap.tan = function (angle) {
    return math.tan(Snap.rad(angle));
};
/*\
 * Snap.cos
 [ method ]
 **
 * Equivalent to `Math.cos()` only works with degrees, not radians.
 - angle (number) angle in degrees
 = (number) cos
\*/
Snap.cos = function (angle) {
    return math.cos(Snap.rad(angle));
};
/*\
 * Snap.asin
 [ method ]
 **
 * Equivalent to `Math.asin()` only works with degrees, not radians.
 - num (number) value
 = (number) asin in degrees
\*/
Snap.asin = function (num) {
    return Snap.deg(math.asin(num));
};
/*\
 * Snap.acos
 [ method ]
 **
 * Equivalent to `Math.acos()` only works with degrees, not radians.
 - num (number) value
 = (number) acos in degrees
\*/
Snap.acos = function (num) {
    return Snap.deg(math.acos(num));
};
/*\
 * Snap.atan
 [ method ]
 **
 * Equivalent to `Math.atan()` only works with degrees, not radians.
 - num (number) value
 = (number) atan in degrees
\*/
Snap.atan = function (num) {
    return Snap.deg(math.atan(num));
};
/*\
 * Snap.atan2
 [ method ]
 **
 * Equivalent to `Math.atan2()` only works with degrees, not radians.
 - num (number) value
 = (number) atan2 in degrees
\*/
Snap.atan2 = function (num) {
    return Snap.deg(math.atan2(num));
};
/*\
 * Snap.angle
 [ method ]
 **
 * Returns an angle between two or three points
 - x1 (number) x coord of first point
 - y1 (number) y coord of first point
 - x2 (number) x coord of second point
 - y2 (number) y coord of second point
 - x3 (number) #optional x coord of third point
 - y3 (number) #optional y coord of third point
 = (number) angle in degrees
\*/
Snap.angle = angle;
/*\
 * Snap.len
 [ method ]
 **
 * Returns distance between two points
 - x1 (number) x coord of first point
 - y1 (number) y coord of first point
 - x2 (number) x coord of second point
 - y2 (number) y coord of second point
 = (number) distance
\*/
Snap.len = function (x1, y1, x2, y2) {
    return Math.sqrt(Snap.len2(x1, y1, x2, y2));
};
/*\
 * Snap.len2
 [ method ]
 **
 * Returns squared distance between two points
 - x1 (number) x coord of first point
 - y1 (number) y coord of first point
 - x2 (number) x coord of second point
 - y2 (number) y coord of second point
 = (number) distance
\*/
Snap.len2 = function (x1, y1, x2, y2) {
    return (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
};
/*\
 * Snap.closestPoint
 [ method ]
 **
 * Returns closest point to a given one on a given path.
 - path (Element) path element
 - x (number) x coord of a point
 - y (number) y coord of a point
 = (object) in format
 {
    x (number) x coord of the point on the path
    y (number) y coord of the point on the path
    length (number) length of the path to the point
    distance (number) distance from the given point to the path
 }
\*/
// Copied from http://bl.ocks.org/mbostock/8027637
Snap.closestPoint = function (path, x, y) {
    function distance2(p) {
        var dx = p.x - x,
            dy = p.y - y;
        return dx * dx + dy * dy;
    }
    var pathNode = path.node,
        pathLength = pathNode.getTotalLength(),
        precision = pathLength / pathNode.pathSegList.numberOfItems * .125,
        best,
        bestLength,
        bestDistance = Infinity;

    // linear scan for coarse approximation
    for (var scan, scanLength = 0, scanDistance; scanLength <= pathLength; scanLength += precision) {
        if ((scanDistance = distance2(scan = pathNode.getPointAtLength(scanLength))) < bestDistance) {
            best = scan;
            bestLength = scanLength;
            bestDistance = scanDistance;
        }
    }

    // binary search for precise estimate
    precision *= .5;
    while (precision > .5) {
        var before,
            after,
            beforeLength,
            afterLength,
            beforeDistance,
            afterDistance;
        if ((beforeLength = bestLength - precision) >= 0 && (beforeDistance = distance2(before = pathNode.getPointAtLength(beforeLength))) < bestDistance) {
            best = before;
            bestLength = beforeLength;
            bestDistance = beforeDistance;
        } else if ((afterLength = bestLength + precision) <= pathLength && (afterDistance = distance2(after = pathNode.getPointAtLength(afterLength))) < bestDistance) {
            best = after;
            bestLength = afterLength;
            bestDistance = afterDistance;
        } else {
            precision *= .5;
        }
    }

    best = {
        x: best.x,
        y: best.y,
        length: bestLength,
        distance: Math.sqrt(bestDistance)
    };
    return best;
}
/*\
 * Snap.is
 [ method ]
 **
 * Handy replacement for the `typeof` operator
 - o (…) any object or primitive
 - type (string) name of the type, e.g., `string`, `function`, `number`, etc.
 = (boolean) `true` if given value is of given type
\*/
Snap.is = is;
/*\
 * Snap.snapTo
 [ method ]
 **
 * Snaps given value to given grid
 - values (array|number) given array of values or step of the grid
 - value (number) value to adjust
 - tolerance (number) #optional maximum distance to the target value that would trigger the snap. Default is `10`.
 = (number) adjusted value
\*/
Snap.snapTo = function (values, value, tolerance) {
    tolerance = is(tolerance, "finite") ? tolerance : 10;
    if (is(values, "array")) {
        var i = values.length;
        while (i--) if (abs(values[i] - value) <= tolerance) {
            return values[i];
        }
    } else {
        values = +values;
        var rem = value % values;
        if (rem < tolerance) {
            return value - rem;
        }
        if (rem > values - tolerance) {
            return value - rem + values;
        }
    }
    return value;
};
// Colour
/*\
 * Snap.getRGB
 [ method ]
 **
 * Parses color string as RGB object
 - color (string) color string in one of the following formats:
 # <ul>
 #     <li>Color name (<code>red</code>, <code>green</code>, <code>cornflowerblue</code>, etc)</li>
 #     <li>#••• — shortened HTML color: (<code>#000</code>, <code>#fc0</code>, etc.)</li>
 #     <li>#•••••• — full length HTML color: (<code>#000000</code>, <code>#bd2300</code>)</li>
 #     <li>rgb(•••, •••, •••) — red, green and blue channels values: (<code>rgb(200,&nbsp;100,&nbsp;0)</code>)</li>
 #     <li>rgba(•••, •••, •••, •••) — also with opacity</li>
 #     <li>rgb(•••%, •••%, •••%) — same as above, but in %: (<code>rgb(100%,&nbsp;175%,&nbsp;0%)</code>)</li>
 #     <li>rgba(•••%, •••%, •••%, •••%) — also with opacity</li>
 #     <li>hsb(•••, •••, •••) — hue, saturation and brightness values: (<code>hsb(0.5,&nbsp;0.25,&nbsp;1)</code>)</li>
 #     <li>hsba(•••, •••, •••, •••) — also with opacity</li>
 #     <li>hsb(•••%, •••%, •••%) — same as above, but in %</li>
 #     <li>hsba(•••%, •••%, •••%, •••%) — also with opacity</li>
 #     <li>hsl(•••, •••, •••) — hue, saturation and luminosity values: (<code>hsb(0.5,&nbsp;0.25,&nbsp;0.5)</code>)</li>
 #     <li>hsla(•••, •••, •••, •••) — also with opacity</li>
 #     <li>hsl(•••%, •••%, •••%) — same as above, but in %</li>
 #     <li>hsla(•••%, •••%, •••%, •••%) — also with opacity</li>
 # </ul>
 * Note that `%` can be used any time: `rgb(20%, 255, 50%)`.
 = (object) RGB object in the following format:
 o {
 o     r (number) red,
 o     g (number) green,
 o     b (number) blue,
 o     hex (string) color in HTML/CSS format: #••••••,
 o     error (boolean) true if string can't be parsed
 o }
\*/
Snap.getRGB = cacher(function (colour) {
    if (!colour || !!((colour = Str(colour)).indexOf("-") + 1)) {
        return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
    }
    if (colour == "none") {
        return {r: -1, g: -1, b: -1, hex: "none", toString: rgbtoString};
    }
    !(hsrg[has](colour.toLowerCase().substring(0, 2)) || colour.charAt() == "#") && (colour = toHex(colour));
    if (!colour) {
        return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
    }
    var res,
        red,
        green,
        blue,
        opacity,
        t,
        values,
        rgb = colour.match(colourRegExp);
    if (rgb) {
        if (rgb[2]) {
            blue = toInt(rgb[2].substring(5), 16);
            green = toInt(rgb[2].substring(3, 5), 16);
            red = toInt(rgb[2].substring(1, 3), 16);
        }
        if (rgb[3]) {
            blue = toInt((t = rgb[3].charAt(3)) + t, 16);
            green = toInt((t = rgb[3].charAt(2)) + t, 16);
            red = toInt((t = rgb[3].charAt(1)) + t, 16);
        }
        if (rgb[4]) {
            values = rgb[4].split(commaSpaces);
            red = toFloat(values[0]);
            values[0].slice(-1) == "%" && (red *= 2.55);
            green = toFloat(values[1]);
            values[1].slice(-1) == "%" && (green *= 2.55);
            blue = toFloat(values[2]);
            values[2].slice(-1) == "%" && (blue *= 2.55);
            rgb[1].toLowerCase().slice(0, 4) == "rgba" && (opacity = toFloat(values[3]));
            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
        }
        if (rgb[5]) {
            values = rgb[5].split(commaSpaces);
            red = toFloat(values[0]);
            values[0].slice(-1) == "%" && (red /= 100);
            green = toFloat(values[1]);
            values[1].slice(-1) == "%" && (green /= 100);
            blue = toFloat(values[2]);
            values[2].slice(-1) == "%" && (blue /= 100);
            (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
            rgb[1].toLowerCase().slice(0, 4) == "hsba" && (opacity = toFloat(values[3]));
            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
            return Snap.hsb2rgb(red, green, blue, opacity);
        }
        if (rgb[6]) {
            values = rgb[6].split(commaSpaces);
            red = toFloat(values[0]);
            values[0].slice(-1) == "%" && (red /= 100);
            green = toFloat(values[1]);
            values[1].slice(-1) == "%" && (green /= 100);
            blue = toFloat(values[2]);
            values[2].slice(-1) == "%" && (blue /= 100);
            (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
            rgb[1].toLowerCase().slice(0, 4) == "hsla" && (opacity = toFloat(values[3]));
            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
            return Snap.hsl2rgb(red, green, blue, opacity);
        }
        red = mmin(math.round(red), 255);
        green = mmin(math.round(green), 255);
        blue = mmin(math.round(blue), 255);
        opacity = mmin(mmax(opacity, 0), 1);
        rgb = {r: red, g: green, b: blue, toString: rgbtoString};
        rgb.hex = "#" + (16777216 | blue | green << 8 | red << 16).toString(16).slice(1);
        rgb.opacity = is(opacity, "finite") ? opacity : 1;
        return rgb;
    }
    return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
}, Snap);
/*\
 * Snap.hsb
 [ method ]
 **
 * Converts HSB values to a hex representation of the color
 - h (number) hue
 - s (number) saturation
 - b (number) value or brightness
 = (string) hex representation of the color
\*/
Snap.hsb = cacher(function (h, s, b) {
    return Snap.hsb2rgb(h, s, b).hex;
});
/*\
 * Snap.hsl
 [ method ]
 **
 * Converts HSL values to a hex representation of the color
 - h (number) hue
 - s (number) saturation
 - l (number) luminosity
 = (string) hex representation of the color
\*/
Snap.hsl = cacher(function (h, s, l) {
    return Snap.hsl2rgb(h, s, l).hex;
});
/*\
 * Snap.rgb
 [ method ]
 **
 * Converts RGB values to a hex representation of the color
 - r (number) red
 - g (number) green
 - b (number) blue
 = (string) hex representation of the color
\*/
Snap.rgb = cacher(function (r, g, b, o) {
    if (is(o, "finite")) {
        var round = math.round;
        return "rgba(" + [round(r), round(g), round(b), +o.toFixed(2)] + ")";
    }
    return "#" + (16777216 | b | g << 8 | r << 16).toString(16).slice(1);
});
var toHex = function (color) {
    var i = glob.doc.getElementsByTagName("head")[0] || glob.doc.getElementsByTagName("svg")[0],
        red = "rgb(255, 0, 0)";
    toHex = cacher(function (color) {
        if (color.toLowerCase() == "red") {
            return red;
        }
        i.style.color = red;
        i.style.color = color;
        var out = glob.doc.defaultView.getComputedStyle(i, E).getPropertyValue("color");
        return out == red ? null : out;
    });
    return toHex(color);
},
hsbtoString = function () {
    return "hsb(" + [this.h, this.s, this.b] + ")";
},
hsltoString = function () {
    return "hsl(" + [this.h, this.s, this.l] + ")";
},
rgbtoString = function () {
    return this.opacity == 1 || this.opacity == null ?
            this.hex :
            "rgba(" + [this.r, this.g, this.b, this.opacity] + ")";
},
prepareRGB = function (r, g, b) {
    if (g == null && is(r, "object") && "r" in r && "g" in r && "b" in r) {
        b = r.b;
        g = r.g;
        r = r.r;
    }
    if (g == null && is(r, string)) {
        var clr = Snap.getRGB(r);
        r = clr.r;
        g = clr.g;
        b = clr.b;
    }
    if (r > 1 || g > 1 || b > 1) {
        r /= 255;
        g /= 255;
        b /= 255;
    }

    return [r, g, b];
},
packageRGB = function (r, g, b, o) {
    r = math.round(r * 255);
    g = math.round(g * 255);
    b = math.round(b * 255);
    var rgb = {
        r: r,
        g: g,
        b: b,
        opacity: is(o, "finite") ? o : 1,
        hex: Snap.rgb(r, g, b),
        toString: rgbtoString
    };
    is(o, "finite") && (rgb.opacity = o);
    return rgb;
};
/*\
 * Snap.color
 [ method ]
 **
 * Parses the color string and returns an object featuring the color's component values
 - clr (string) color string in one of the supported formats (see @Snap.getRGB)
 = (object) Combined RGB/HSB object in the following format:
 o {
 o     r (number) red,
 o     g (number) green,
 o     b (number) blue,
 o     hex (string) color in HTML/CSS format: #••••••,
 o     error (boolean) `true` if string can't be parsed,
 o     h (number) hue,
 o     s (number) saturation,
 o     v (number) value (brightness),
 o     l (number) lightness
 o }
\*/
Snap.color = function (clr) {
    var rgb;
    if (is(clr, "object") && "h" in clr && "s" in clr && "b" in clr) {
        rgb = Snap.hsb2rgb(clr);
        clr.r = rgb.r;
        clr.g = rgb.g;
        clr.b = rgb.b;
        clr.opacity = 1;
        clr.hex = rgb.hex;
    } else if (is(clr, "object") && "h" in clr && "s" in clr && "l" in clr) {
        rgb = Snap.hsl2rgb(clr);
        clr.r = rgb.r;
        clr.g = rgb.g;
        clr.b = rgb.b;
        clr.opacity = 1;
        clr.hex = rgb.hex;
    } else {
        if (is(clr, "string")) {
            clr = Snap.getRGB(clr);
        }
        if (is(clr, "object") && "r" in clr && "g" in clr && "b" in clr && !("error" in clr)) {
            rgb = Snap.rgb2hsl(clr);
            clr.h = rgb.h;
            clr.s = rgb.s;
            clr.l = rgb.l;
            rgb = Snap.rgb2hsb(clr);
            clr.v = rgb.b;
        } else {
            clr = {hex: "none"};
            clr.r = clr.g = clr.b = clr.h = clr.s = clr.v = clr.l = -1;
            clr.error = 1;
        }
    }
    clr.toString = rgbtoString;
    return clr;
};
/*\
 * Snap.hsb2rgb
 [ method ]
 **
 * Converts HSB values to an RGB object
 - h (number) hue
 - s (number) saturation
 - v (number) value or brightness
 = (object) RGB object in the following format:
 o {
 o     r (number) red,
 o     g (number) green,
 o     b (number) blue,
 o     hex (string) color in HTML/CSS format: #••••••
 o }
\*/
Snap.hsb2rgb = function (h, s, v, o) {
    if (is(h, "object") && "h" in h && "s" in h && "b" in h) {
        v = h.b;
        s = h.s;
        o = h.o;
        h = h.h;
    }
    h *= 360;
    var R, G, B, X, C;
    h = h % 360 / 60;
    C = v * s;
    X = C * (1 - abs(h % 2 - 1));
    R = G = B = v - C;

    h = ~~h;
    R += [C, X, 0, 0, X, C][h];
    G += [X, C, C, X, 0, 0][h];
    B += [0, 0, X, C, C, X][h];
    return packageRGB(R, G, B, o);
};
/*\
 * Snap.hsl2rgb
 [ method ]
 **
 * Converts HSL values to an RGB object
 - h (number) hue
 - s (number) saturation
 - l (number) luminosity
 = (object) RGB object in the following format:
 o {
 o     r (number) red,
 o     g (number) green,
 o     b (number) blue,
 o     hex (string) color in HTML/CSS format: #••••••
 o }
\*/
Snap.hsl2rgb = function (h, s, l, o) {
    if (is(h, "object") && "h" in h && "s" in h && "l" in h) {
        l = h.l;
        s = h.s;
        h = h.h;
    }
    if (h > 1 || s > 1 || l > 1) {
        h /= 360;
        s /= 100;
        l /= 100;
    }
    h *= 360;
    var R, G, B, X, C;
    h = h % 360 / 60;
    C = 2 * s * (l < .5 ? l : 1 - l);
    X = C * (1 - abs(h % 2 - 1));
    R = G = B = l - C / 2;

    h = ~~h;
    R += [C, X, 0, 0, X, C][h];
    G += [X, C, C, X, 0, 0][h];
    B += [0, 0, X, C, C, X][h];
    return packageRGB(R, G, B, o);
};
/*\
 * Snap.rgb2hsb
 [ method ]
 **
 * Converts RGB values to an HSB object
 - r (number) red
 - g (number) green
 - b (number) blue
 = (object) HSB object in the following format:
 o {
 o     h (number) hue,
 o     s (number) saturation,
 o     b (number) brightness
 o }
\*/
Snap.rgb2hsb = function (r, g, b) {
    b = prepareRGB(r, g, b);
    r = b[0];
    g = b[1];
    b = b[2];

    var H, S, V, C;
    V = mmax(r, g, b);
    C = V - mmin(r, g, b);
    H = C == 0 ? null :
        V == r ? (g - b) / C :
        V == g ? (b - r) / C + 2 :
                 (r - g) / C + 4;
    H = (H + 360) % 6 * 60 / 360;
    S = C == 0 ? 0 : C / V;
    return {h: H, s: S, b: V, toString: hsbtoString};
};
/*\
 * Snap.rgb2hsl
 [ method ]
 **
 * Converts RGB values to an HSL object
 - r (number) red
 - g (number) green
 - b (number) blue
 = (object) HSL object in the following format:
 o {
 o     h (number) hue,
 o     s (number) saturation,
 o     l (number) luminosity
 o }
\*/
Snap.rgb2hsl = function (r, g, b) {
    b = prepareRGB(r, g, b);
    r = b[0];
    g = b[1];
    b = b[2];

    var H, S, L, M, m, C;
    M = mmax(r, g, b);
    m = mmin(r, g, b);
    C = M - m;
    H = C == 0 ? null :
        M == r ? (g - b) / C :
        M == g ? (b - r) / C + 2 :
                 (r - g) / C + 4;
    H = (H + 360) % 6 * 60 / 360;
    L = (M + m) / 2;
    S = C == 0 ? 0 :
         L < .5 ? C / (2 * L) :
                  C / (2 - 2 * L);
    return {h: H, s: S, l: L, toString: hsltoString};
};

// Transformations
/*\
 * Snap.parsePathString
 [ method ]
 **
 * Utility method
 **
 * Parses given path string into an array of arrays of path segments
 - pathString (string|array) path string or array of segments (in the last case it is returned straight away)
 = (array) array of segments
\*/
Snap.parsePathString = function (pathString) {
    if (!pathString) {
        return null;
    }
    var pth = Snap.path(pathString);
    if (pth.arr) {
        return Snap.path.clone(pth.arr);
    }

    var paramCounts = {a: 7, c: 6, o: 2, h: 1, l: 2, m: 2, r: 4, q: 4, s: 4, t: 2, v: 1, u: 3, z: 0},
        data = [];
    if (is(pathString, "array") && is(pathString[0], "array")) { // rough assumption
        data = Snap.path.clone(pathString);
    }
    if (!data.length) {
        Str(pathString).replace(pathCommand, function (a, b, c) {
            var params = [],
                name = b.toLowerCase();
            c.replace(pathValues, function (a, b) {
                b && params.push(+b);
            });
            if (name == "m" && params.length > 2) {
                data.push([b].concat(params.splice(0, 2)));
                name = "l";
                b = b == "m" ? "l" : "L";
            }
            if (name == "o" && params.length == 1) {
                data.push([b, params[0]]);
            }
            if (name == "r") {
                data.push([b].concat(params));
            } else while (params.length >= paramCounts[name]) {
                data.push([b].concat(params.splice(0, paramCounts[name])));
                if (!paramCounts[name]) {
                    break;
                }
            }
        });
    }
    data.toString = Snap.path.toString;
    pth.arr = Snap.path.clone(data);
    return data;
};
/*\
 * Snap.parseTransformString
 [ method ]
 **
 * Utility method
 **
 * Parses given transform string into an array of transformations
 - TString (string|array) transform string or array of transformations (in the last case it is returned straight away)
 = (array) array of transformations
\*/
var parseTransformString = Snap.parseTransformString = function (TString) {
    if (!TString) {
        return null;
    }
    var paramCounts = {r: 3, s: 4, t: 2, m: 6},
        data = [];
    if (is(TString, "array") && is(TString[0], "array")) { // rough assumption
        data = Snap.path.clone(TString);
    }
    if (!data.length) {
        Str(TString).replace(tCommand, function (a, b, c) {
            var params = [],
                name = b.toLowerCase();
            c.replace(pathValues, function (a, b) {
                b && params.push(+b);
            });
            data.push([b].concat(params));
        });
    }
    data.toString = Snap.path.toString;
    return data;
};
function svgTransform2string(tstr) {
    var res = [];
    tstr = tstr.replace(/(?:^|\s)(\w+)\(([^)]+)\)/g, function (all, name, params) {
        params = params.split(/\s*,\s*|\s+/);
        if (name == "rotate" && params.length == 1) {
            params.push(0, 0);
        }
        if (name == "scale") {
            if (params.length > 2) {
                params = params.slice(0, 2);
            } else if (params.length == 2) {
                params.push(0, 0);
            }
            if (params.length == 1) {
                params.push(params[0], 0, 0);
            }
        }
        if (name == "skewX") {
            res.push(["m", 1, 0, math.tan(rad(params[0])), 1, 0, 0]);
        } else if (name == "skewY") {
            res.push(["m", 1, math.tan(rad(params[0])), 0, 1, 0, 0]);
        } else {
            res.push([name.charAt(0)].concat(params));
        }
        return all;
    });
    return res;
}
Snap._.svgTransform2string = svgTransform2string;
Snap._.rgTransform = /^[a-z][\s]*-?\.?\d/i;
function transform2matrix(tstr, bbox) {
    var tdata = parseTransformString(tstr),
        m = new Snap.Matrix;
    if (tdata) {
        for (var i = 0, ii = tdata.length; i < ii; i++) {
            var t = tdata[i],
                tlen = t.length,
                command = Str(t[0]).toLowerCase(),
                absolute = t[0] != command,
                inver = absolute ? m.invert() : 0,
                x1,
                y1,
                x2,
                y2,
                bb;
            if (command == "t" && tlen == 2){
                m.translate(t[1], 0);
            } else if (command == "t" && tlen == 3) {
                if (absolute) {
                    x1 = inver.x(0, 0);
                    y1 = inver.y(0, 0);
                    x2 = inver.x(t[1], t[2]);
                    y2 = inver.y(t[1], t[2]);
                    m.translate(x2 - x1, y2 - y1);
                } else {
                    m.translate(t[1], t[2]);
                }
            } else if (command == "r") {
                if (tlen == 2) {
                    bb = bb || bbox;
                    m.rotate(t[1], bb.x + bb.width / 2, bb.y + bb.height / 2);
                } else if (tlen == 4) {
                    if (absolute) {
                        x2 = inver.x(t[2], t[3]);
                        y2 = inver.y(t[2], t[3]);
                        m.rotate(t[1], x2, y2);
                    } else {
                        m.rotate(t[1], t[2], t[3]);
                    }
                }
            } else if (command == "s") {
                if (tlen == 2 || tlen == 3) {
                    bb = bb || bbox;
                    m.scale(t[1], t[tlen - 1], bb.x + bb.width / 2, bb.y + bb.height / 2);
                } else if (tlen == 4) {
                    if (absolute) {
                        x2 = inver.x(t[2], t[3]);
                        y2 = inver.y(t[2], t[3]);
                        m.scale(t[1], t[1], x2, y2);
                    } else {
                        m.scale(t[1], t[1], t[2], t[3]);
                    }
                } else if (tlen == 5) {
                    if (absolute) {
                        x2 = inver.x(t[3], t[4]);
                        y2 = inver.y(t[3], t[4]);
                        m.scale(t[1], t[2], x2, y2);
                    } else {
                        m.scale(t[1], t[2], t[3], t[4]);
                    }
                }
            } else if (command == "m" && tlen == 7) {
                m.add(t[1], t[2], t[3], t[4], t[5], t[6]);
            }
        }
    }
    return m;
}
Snap._.transform2matrix = transform2matrix;
Snap._unit2px = unit2px;
var contains = glob.doc.contains || glob.doc.compareDocumentPosition ?
    function (a, b) {
        var adown = a.nodeType == 9 ? a.documentElement : a,
            bup = b && b.parentNode;
            return a == bup || !!(bup && bup.nodeType == 1 && (
                adown.contains ?
                    adown.contains(bup) :
                    a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16
            ));
    } :
    function (a, b) {
        if (b) {
            while (b) {
                b = b.parentNode;
                if (b == a) {
                    return true;
                }
            }
        }
        return false;
    };
function getSomeDefs(el) {
    var p = el.node.ownerSVGElement && wrap(el.node.ownerSVGElement) ||
            el.node.parentNode && wrap(el.node.parentNode) ||
            Snap.select("svg") ||
            Snap(0, 0),
        pdefs = p.select("defs"),
        defs  = pdefs == null ? false : pdefs.node;
    if (!defs) {
        defs = make("defs", p.node).node;
    }
    return defs;
}
function getSomeSVG(el) {
    return el.node.ownerSVGElement && wrap(el.node.ownerSVGElement) || Snap.select("svg");
}
Snap._.getSomeDefs = getSomeDefs;
Snap._.getSomeSVG = getSomeSVG;
function unit2px(el, name, value) {
    var svg = getSomeSVG(el).node,
        out = {},
        mgr = svg.querySelector(".svg---mgr");
    if (!mgr) {
        mgr = $("rect");
        $(mgr, {x: -9e9, y: -9e9, width: 10, height: 10, "class": "svg---mgr", fill: "none"});
        svg.appendChild(mgr);
    }
    function getW(val) {
        if (val == null) {
            return E;
        }
        if (val == +val) {
            return val;
        }
        $(mgr, {width: val});
        try {
            return mgr.getBBox().width;
        } catch (e) {
            return 0;
        }
    }
    function getH(val) {
        if (val == null) {
            return E;
        }
        if (val == +val) {
            return val;
        }
        $(mgr, {height: val});
        try {
            return mgr.getBBox().height;
        } catch (e) {
            return 0;
        }
    }
    function set(nam, f) {
        if (name == null) {
            out[nam] = f(el.attr(nam) || 0);
        } else if (nam == name) {
            out = f(value == null ? el.attr(nam) || 0 : value);
        }
    }
    switch (el.type) {
        case "rect":
            set("rx", getW);
            set("ry", getH);
        case "image":
            set("width", getW);
            set("height", getH);
        case "text":
            set("x", getW);
            set("y", getH);
        break;
        case "circle":
            set("cx", getW);
            set("cy", getH);
            set("r", getW);
        break;
        case "ellipse":
            set("cx", getW);
            set("cy", getH);
            set("rx", getW);
            set("ry", getH);
        break;
        case "line":
            set("x1", getW);
            set("x2", getW);
            set("y1", getH);
            set("y2", getH);
        break;
        case "marker":
            set("refX", getW);
            set("markerWidth", getW);
            set("refY", getH);
            set("markerHeight", getH);
        break;
        case "radialGradient":
            set("fx", getW);
            set("fy", getH);
        break;
        case "tspan":
            set("dx", getW);
            set("dy", getH);
        break;
        default:
            set(name, getW);
    }
    svg.removeChild(mgr);
    return out;
}
/*\
 * Snap.select
 [ method ]
 **
 * Wraps a DOM element specified by CSS selector as @Element
 - query (string) CSS selector of the element
 = (Element) the current element
\*/
Snap.select = function (query) {
    query = Str(query).replace(/([^\\]):/g, "$1\\:");
    return wrap(glob.doc.querySelector(query));
};
/*\
 * Snap.selectAll
 [ method ]
 **
 * Wraps DOM elements specified by CSS selector as set or array of @Element
 - query (string) CSS selector of the element
 = (Element) the current element
\*/
Snap.selectAll = function (query) {
    var nodelist = glob.doc.querySelectorAll(query),
        set = (Snap.set || Array)();
    for (var i = 0; i < nodelist.length; i++) {
        set.push(wrap(nodelist[i]));
    }
    return set;
};

function add2group(list) {
    if (!is(list, "array")) {
        list = Array.prototype.slice.call(arguments, 0);
    }
    var i = 0,
        j = 0,
        node = this.node;
    while (this[i]) delete this[i++];
    for (i = 0; i < list.length; i++) {
        if (list[i].type == "set") {
            list[i].forEach(function (el) {
                node.appendChild(el.node);
            });
        } else {
            node.appendChild(list[i].node);
        }
    }
    var children = node.childNodes;
    for (i = 0; i < children.length; i++) {
        this[j++] = wrap(children[i]);
    }
    return this;
}
// Hub garbage collector every 10s
setInterval(function () {
    for (var key in hub) if (hub[has](key)) {
        var el = hub[key],
            node = el.node;
        if (el.type != "svg" && !node.ownerSVGElement || el.type == "svg" && (!node.parentNode || "ownerSVGElement" in node.parentNode && !node.ownerSVGElement)) {
            delete hub[key];
        }
    }
}, 1e4);
function Element(el) {
    if (el.snap in hub) {
        return hub[el.snap];
    }
    var svg;
    try {
        svg = el.ownerSVGElement;
    } catch(e) {}
    /*\
     * Element.node
     [ property (object) ]
     **
     * Gives you a reference to the DOM object, so you can assign event handlers or just mess around.
     > Usage
     | // draw a circle at coordinate 10,10 with radius of 10
     | var c = paper.circle(10, 10, 10);
     | c.node.onclick = function () {
     |     c.attr("fill", "red");
     | };
    \*/
    this.node = el;
    if (svg) {
        this.paper = new Paper(svg);
    }
    /*\
     * Element.type
     [ property (string) ]
     **
     * SVG tag name of the given element.
    \*/
    this.type = el.tagName || el.nodeName;
    var id = this.id = ID(this);
    this.anims = {};
    this._ = {
        transform: []
    };
    el.snap = id;
    hub[id] = this;
    if (this.type == "g") {
        this.add = add2group;
    }
    if (this.type in {g: 1, mask: 1, pattern: 1, symbol: 1}) {
        for (var method in Paper.prototype) if (Paper.prototype[has](method)) {
            this[method] = Paper.prototype[method];
        }
    }
}
   /*\
     * Element.attr
     [ method ]
     **
     * Gets or sets given attributes of the element.
     **
     - params (object) contains key-value pairs of attributes you want to set
     * or
     - param (string) name of the attribute
     = (Element) the current element
     * or
     = (string) value of attribute
     > Usage
     | el.attr({
     |     fill: "#fc0",
     |     stroke: "#000",
     |     strokeWidth: 2, // CamelCase...
     |     "fill-opacity": 0.5, // or dash-separated names
     |     width: "*=2" // prefixed values
     | });
     | console.log(el.attr("fill")); // #fc0
     * Prefixed values in format `"+=10"` supported. All four operations
     * (`+`, `-`, `*` and `/`) could be used. Optionally you can use units for `+`
     * and `-`: `"+=2em"`.
    \*/
    Element.prototype.attr = function (params, value) {
        var el = this,
            node = el.node;
        if (!params) {
            if (node.nodeType != 1) {
                return {
                    text: node.nodeValue
                };
            }
            var attr = node.attributes,
                out = {};
            for (var i = 0, ii = attr.length; i < ii; i++) {
                out[attr[i].nodeName] = attr[i].nodeValue;
            }
            return out;
        }
        if (is(params, "string")) {
            if (arguments.length > 1) {
                var json = {};
                json[params] = value;
                params = json;
            } else {
                return eve("snap.util.getattr." + params, el).firstDefined();
            }
        }
        for (var att in params) {
            if (params[has](att)) {
                eve("snap.util.attr." + att, el, params[att]);
            }
        }
        return el;
    };
/*\
 * Snap.parse
 [ method ]
 **
 * Parses SVG fragment and converts it into a @Fragment
 **
 - svg (string) SVG string
 = (Fragment) the @Fragment
\*/
Snap.parse = function (svg) {
    var f = glob.doc.createDocumentFragment(),
        full = true,
        div = glob.doc.createElement("div");
    svg = Str(svg);
    if (!svg.match(/^\s*<\s*svg(?:\s|>)/)) {
        svg = "<svg>" + svg + "</svg>";
        full = false;
    }
    div.innerHTML = svg;
    svg = div.getElementsByTagName("svg")[0];
    if (svg) {
        if (full) {
            f = svg;
        } else {
            while (svg.firstChild) {
                f.appendChild(svg.firstChild);
            }
        }
    }
    return new Fragment(f);
};
function Fragment(frag) {
    this.node = frag;
}
/*\
 * Snap.fragment
 [ method ]
 **
 * Creates a DOM fragment from a given list of elements or strings
 **
 - varargs (…) SVG string
 = (Fragment) the @Fragment
\*/
Snap.fragment = function () {
    var args = Array.prototype.slice.call(arguments, 0),
        f = glob.doc.createDocumentFragment();
    for (var i = 0, ii = args.length; i < ii; i++) {
        var item = args[i];
        if (item.node && item.node.nodeType) {
            f.appendChild(item.node);
        }
        if (item.nodeType) {
            f.appendChild(item);
        }
        if (typeof item == "string") {
            f.appendChild(Snap.parse(item).node);
        }
    }
    return new Fragment(f);
};

function make(name, parent) {
    var res = $(name);
    parent.appendChild(res);
    var el = wrap(res);
    return el;
}
function Paper(w, h) {
    var res,
        desc,
        defs,
        proto = Paper.prototype;
    if (w && w.tagName && w.tagName.toLowerCase() == "svg") {
        if (w.snap in hub) {
            return hub[w.snap];
        }
        var doc = w.ownerDocument;
        res = new Element(w);
        desc = w.getElementsByTagName("desc")[0];
        defs = w.getElementsByTagName("defs")[0];
        if (!desc) {
            desc = $("desc");
            desc.appendChild(doc.createTextNode("Created with Snap"));
            res.node.appendChild(desc);
        }
        if (!defs) {
            defs = $("defs");
            res.node.appendChild(defs);
        }
        res.defs = defs;
        for (var key in proto) if (proto[has](key)) {
            res[key] = proto[key];
        }
        res.paper = res.root = res;
    } else {
        res = make("svg", glob.doc.body);
        $(res.node, {
            height: h,
            version: 1.1,
            width: w,
            xmlns: xmlns
        });
    }
    return res;
}
function wrap(dom) {
    if (!dom) {
        return dom;
    }
    if (dom instanceof Element || dom instanceof Fragment) {
        return dom;
    }
    if (dom.tagName && dom.tagName.toLowerCase() == "svg") {
        return new Paper(dom);
    }
    if (dom.tagName && dom.tagName.toLowerCase() == "object" && dom.type == "image/svg+xml") {
        return new Paper(dom.contentDocument.getElementsByTagName("svg")[0]);
    }
    return new Element(dom);
}

Snap._.make = make;
Snap._.wrap = wrap;
/*\
 * Paper.el
 [ method ]
 **
 * Creates an element on paper with a given name and no attributes
 **
 - name (string) tag name
 - attr (object) attributes
 = (Element) the current element
 > Usage
 | var c = paper.circle(10, 10, 10); // is the same as...
 | var c = paper.el("circle").attr({
 |     cx: 10,
 |     cy: 10,
 |     r: 10
 | });
 | // and the same as
 | var c = paper.el("circle", {
 |     cx: 10,
 |     cy: 10,
 |     r: 10
 | });
\*/
Paper.prototype.el = function (name, attr) {
    var el = make(name, this.node);
    attr && el.attr(attr);
    return el;
};
/*\
 * Element.children
 [ method ]
 **
 * Returns array of all the children of the element.
 = (array) array of Elements
\*/
Element.prototype.children = function () {
    var out = [],
        ch = this.node.childNodes;
    for (var i = 0, ii = ch.length; i < ii; i++) {
        out[i] = Snap(ch[i]);
    }
    return out;
};
function jsonFiller(root, o) {
    for (var i = 0, ii = root.length; i < ii; i++) {
        var item = {
                type: root[i].type,
                attr: root[i].attr()
            },
            children = root[i].children();
        o.push(item);
        if (children.length) {
            jsonFiller(children, item.childNodes = []);
        }
    }
}
/*\
 * Element.toJSON
 [ method ]
 **
 * Returns object representation of the given element and all its children.
 = (object) in format
 o {
 o     type (string) this.type,
 o     attr (object) attributes map,
 o     childNodes (array) optional array of children in the same format
 o }
\*/
Element.prototype.toJSON = function () {
    var out = [];
    jsonFiller([this], out);
    return out[0];
};
// default
eve.on("snap.util.getattr", function () {
    var att = eve.nt();
    att = att.substring(att.lastIndexOf(".") + 1);
    var css = att.replace(/[A-Z]/g, function (letter) {
        return "-" + letter.toLowerCase();
    });
    if (cssAttr[has](css)) {
        return this.node.ownerDocument.defaultView.getComputedStyle(this.node, null).getPropertyValue(css);
    } else {
        return $(this.node, att);
    }
});
var cssAttr = {
    "alignment-baseline": 0,
    "baseline-shift": 0,
    "clip": 0,
    "clip-path": 0,
    "clip-rule": 0,
    "color": 0,
    "color-interpolation": 0,
    "color-interpolation-filters": 0,
    "color-profile": 0,
    "color-rendering": 0,
    "cursor": 0,
    "direction": 0,
    "display": 0,
    "dominant-baseline": 0,
    "enable-background": 0,
    "fill": 0,
    "fill-opacity": 0,
    "fill-rule": 0,
    "filter": 0,
    "flood-color": 0,
    "flood-opacity": 0,
    "font": 0,
    "font-family": 0,
    "font-size": 0,
    "font-size-adjust": 0,
    "font-stretch": 0,
    "font-style": 0,
    "font-variant": 0,
    "font-weight": 0,
    "glyph-orientation-horizontal": 0,
    "glyph-orientation-vertical": 0,
    "image-rendering": 0,
    "kerning": 0,
    "letter-spacing": 0,
    "lighting-color": 0,
    "marker": 0,
    "marker-end": 0,
    "marker-mid": 0,
    "marker-start": 0,
    "mask": 0,
    "opacity": 0,
    "overflow": 0,
    "pointer-events": 0,
    "shape-rendering": 0,
    "stop-color": 0,
    "stop-opacity": 0,
    "stroke": 0,
    "stroke-dasharray": 0,
    "stroke-dashoffset": 0,
    "stroke-linecap": 0,
    "stroke-linejoin": 0,
    "stroke-miterlimit": 0,
    "stroke-opacity": 0,
    "stroke-width": 0,
    "text-anchor": 0,
    "text-decoration": 0,
    "text-rendering": 0,
    "unicode-bidi": 0,
    "visibility": 0,
    "word-spacing": 0,
    "writing-mode": 0
};

eve.on("snap.util.attr", function (value) {
    var att = eve.nt(),
        attr = {};
    att = att.substring(att.lastIndexOf(".") + 1);
    attr[att] = value;
    var style = att.replace(/-(\w)/gi, function (all, letter) {
            return letter.toUpperCase();
        }),
        css = att.replace(/[A-Z]/g, function (letter) {
            return "-" + letter.toLowerCase();
        });
    if (cssAttr[has](css)) {
        this.node.style[style] = value == null ? E : value;
    } else {
        $(this.node, attr);
    }
});
(function (proto) {}(Paper.prototype));

// simple ajax
/*\
 * Snap.ajax
 [ method ]
 **
 * Simple implementation of Ajax
 **
 - url (string) URL
 - postData (object|string) data for post request
 - callback (function) callback
 - scope (object) #optional scope of callback
 * or
 - url (string) URL
 - callback (function) callback
 - scope (object) #optional scope of callback
 = (XMLHttpRequest) the XMLHttpRequest object, just in case
\*/
Snap.ajax = function (url, postData, callback, scope){
    var req = new XMLHttpRequest,
        id = ID();
    if (req) {
        if (is(postData, "function")) {
            scope = callback;
            callback = postData;
            postData = null;
        } else if (is(postData, "object")) {
            var pd = [];
            for (var key in postData) if (postData.hasOwnProperty(key)) {
                pd.push(encodeURIComponent(key) + "=" + encodeURIComponent(postData[key]));
            }
            postData = pd.join("&");
        }
        req.open(postData ? "POST" : "GET", url, true);
        if (postData) {
            req.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        }
        if (callback) {
            eve.once("snap.ajax." + id + ".0", callback);
            eve.once("snap.ajax." + id + ".200", callback);
            eve.once("snap.ajax." + id + ".304", callback);
        }
        req.onreadystatechange = function() {
            if (req.readyState != 4) return;
            eve("snap.ajax." + id + "." + req.status, scope, req);
        };
        if (req.readyState == 4) {
            return req;
        }
        req.send(postData);
        return req;
    }
};
/*\
 * Snap.load
 [ method ]
 **
 * Loads external SVG file as a @Fragment (see @Snap.ajax for more advanced AJAX)
 **
 - url (string) URL
 - callback (function) callback
 - scope (object) #optional scope of callback
\*/
Snap.load = function (url, callback, scope) {
    Snap.ajax(url, function (req) {
        var f = Snap.parse(req.responseText);
        scope ? callback.call(scope, f) : callback(f);
    });
};
var getOffset = function (elem) {
    var box = elem.getBoundingClientRect(),
        doc = elem.ownerDocument,
        body = doc.body,
        docElem = doc.documentElement,
        clientTop = docElem.clientTop || body.clientTop || 0, clientLeft = docElem.clientLeft || body.clientLeft || 0,
        top  = box.top  + (g.win.pageYOffset || docElem.scrollTop || body.scrollTop ) - clientTop,
        left = box.left + (g.win.pageXOffset || docElem.scrollLeft || body.scrollLeft) - clientLeft;
    return {
        y: top,
        x: left
    };
};
/*\
 * Snap.getElementByPoint
 [ method ]
 **
 * Returns you topmost element under given point.
 **
 = (object) Snap element object
 - x (number) x coordinate from the top left corner of the window
 - y (number) y coordinate from the top left corner of the window
 > Usage
 | Snap.getElementByPoint(mouseX, mouseY).attr({stroke: "#f00"});
\*/
Snap.getElementByPoint = function (x, y) {
    var paper = this,
        svg = paper.canvas,
        target = glob.doc.elementFromPoint(x, y);
    if (glob.win.opera && target.tagName == "svg") {
        var so = getOffset(target),
            sr = target.createSVGRect();
        sr.x = x - so.x;
        sr.y = y - so.y;
        sr.width = sr.height = 1;
        var hits = target.getIntersectionList(sr, null);
        if (hits.length) {
            target = hits[hits.length - 1];
        }
    }
    if (!target) {
        return null;
    }
    return wrap(target);
};
/*\
 * Snap.plugin
 [ method ]
 **
 * Let you write plugins. You pass in a function with five arguments, like this:
 | Snap.plugin(function (Snap, Element, Paper, global, Fragment) {
 |     Snap.newmethod = function () {};
 |     Element.prototype.newmethod = function () {};
 |     Paper.prototype.newmethod = function () {};
 | });
 * Inside the function you have access to all main objects (and their
 * prototypes). This allow you to extend anything you want.
 **
 - f (function) your plugin body
\*/
Snap.plugin = function (f) {
    f(Snap, Element, Paper, glob, Fragment);
};
glob.win.Snap = Snap;
return Snap;
}(window || this));

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var elproto = Element.prototype,
        is = Snap.is,
        Str = String,
        unit2px = Snap._unit2px,
        $ = Snap._.$,
        make = Snap._.make,
        getSomeDefs = Snap._.getSomeDefs,
        has = "hasOwnProperty",
        wrap = Snap._.wrap;
    /*\
     * Element.getBBox
     [ method ]
     **
     * Returns the bounding box descriptor for the given element
     **
     = (object) bounding box descriptor:
     o {
     o     cx: (number) x of the center,
     o     cy: (number) x of the center,
     o     h: (number) height,
     o     height: (number) height,
     o     path: (string) path command for the box,
     o     r0: (number) radius of a circle that fully encloses the box,
     o     r1: (number) radius of the smallest circle that can be enclosed,
     o     r2: (number) radius of the largest circle that can be enclosed,
     o     vb: (string) box as a viewbox command,
     o     w: (number) width,
     o     width: (number) width,
     o     x2: (number) x of the right side,
     o     x: (number) x of the left side,
     o     y2: (number) y of the bottom edge,
     o     y: (number) y of the top edge
     o }
    \*/
    elproto.getBBox = function (isWithoutTransform) {
        if (this.type == "tspan") {
            return Snap._.box(this.node.getClientRects().item(0));
        }
        if (!Snap.Matrix || !Snap.path) {
            return this.node.getBBox();
        }
        var el = this,
            m = new Snap.Matrix;
        if (el.removed) {
            return Snap._.box();
        }
        while (el.type == "use") {
            if (!isWithoutTransform) {
                m = m.add(el.transform().localMatrix.translate(el.attr("x") || 0, el.attr("y") || 0));
            }
            if (el.original) {
                el = el.original;
            } else {
                var href = el.attr("xlink:href");
                el = el.original = el.node.ownerDocument.getElementById(href.substring(href.indexOf("#") + 1));
            }
        }
        var _ = el._,
            pathfinder = Snap.path.get[el.type] || Snap.path.get.deflt;
        try {
            if (isWithoutTransform) {
                _.bboxwt = pathfinder ? Snap.path.getBBox(el.realPath = pathfinder(el)) : Snap._.box(el.node.getBBox());
                return Snap._.box(_.bboxwt);
            } else {
                el.realPath = pathfinder(el);
                el.matrix = el.transform().localMatrix;
                _.bbox = Snap.path.getBBox(Snap.path.map(el.realPath, m.add(el.matrix)));
                return Snap._.box(_.bbox);
            }
        } catch (e) {
            // Firefox doesn’t give you bbox of hidden element
            return Snap._.box();
        }
    };
    var propString = function () {
        return this.string;
    };
    function extractTransform(el, tstr) {
        if (tstr == null) {
            var doReturn = true;
            if (el.type == "linearGradient" || el.type == "radialGradient") {
                tstr = el.node.getAttribute("gradientTransform");
            } else if (el.type == "pattern") {
                tstr = el.node.getAttribute("patternTransform");
            } else {
                tstr = el.node.getAttribute("transform");
            }
            if (!tstr) {
                return new Snap.Matrix;
            }
            tstr = Snap._.svgTransform2string(tstr);
        } else {
            if (!Snap._.rgTransform.test(tstr)) {
                tstr = Snap._.svgTransform2string(tstr);
            } else {
                tstr = Str(tstr).replace(/\.{3}|\u2026/g, el._.transform || "");
            }
            if (is(tstr, "array")) {
                tstr = Snap.path ? Snap.path.toString.call(tstr) : Str(tstr);
            }
            el._.transform = tstr;
        }
        var m = Snap._.transform2matrix(tstr, el.getBBox(1));
        if (doReturn) {
            return m;
        } else {
            el.matrix = m;
        }
    }
    /*\
     * Element.transform
     [ method ]
     **
     * Gets or sets transformation of the element
     **
     - tstr (string) transform string in Snap or SVG format
     = (Element) the current element
     * or
     = (object) transformation descriptor:
     o {
     o     string (string) transform string,
     o     globalMatrix (Matrix) matrix of all transformations applied to element or its parents,
     o     localMatrix (Matrix) matrix of transformations applied only to the element,
     o     diffMatrix (Matrix) matrix of difference between global and local transformations,
     o     global (string) global transformation as string,
     o     local (string) local transformation as string,
     o     toString (function) returns `string` property
     o }
    \*/
    elproto.transform = function (tstr) {
        var _ = this._;
        if (tstr == null) {
            var papa = this,
                global = new Snap.Matrix(this.node.getCTM()),
                local = extractTransform(this),
                ms = [local],
                m = new Snap.Matrix,
                i,
                localString = local.toTransformString(),
                string = Str(local) == Str(this.matrix) ?
                            Str(_.transform) : localString;
            while (papa.type != "svg" && (papa = papa.parent())) {
                ms.push(extractTransform(papa));
            }
            i = ms.length;
            while (i--) {
                m.add(ms[i]);
            }
            return {
                string: string,
                globalMatrix: global,
                totalMatrix: m,
                localMatrix: local,
                diffMatrix: global.clone().add(local.invert()),
                global: global.toTransformString(),
                total: m.toTransformString(),
                local: localString,
                toString: propString
            };
        }
        if (tstr instanceof Snap.Matrix) {
            this.matrix = tstr;
            this._.transform = tstr.toTransformString();
        } else {
            extractTransform(this, tstr);
        }

        if (this.node) {
            if (this.type == "linearGradient" || this.type == "radialGradient") {
                $(this.node, {gradientTransform: this.matrix});
            } else if (this.type == "pattern") {
                $(this.node, {patternTransform: this.matrix});
            } else {
                $(this.node, {transform: this.matrix});
            }
        }

        return this;
    };
    /*\
     * Element.parent
     [ method ]
     **
     * Returns the element's parent
     **
     = (Element) the parent element
    \*/
    elproto.parent = function () {
        return wrap(this.node.parentNode);
    };
    /*\
     * Element.append
     [ method ]
     **
     * Appends the given element to current one
     **
     - el (Element|Set) element to append
     = (Element) the parent element
    \*/
    /*\
     * Element.add
     [ method ]
     **
     * See @Element.append
    \*/
    elproto.append = elproto.add = function (el) {
        if (el) {
            if (el.type == "set") {
                var it = this;
                el.forEach(function (el) {
                    it.add(el);
                });
                return this;
            }
            el = wrap(el);
            this.node.appendChild(el.node);
            el.paper = this.paper;
        }
        return this;
    };
    /*\
     * Element.appendTo
     [ method ]
     **
     * Appends the current element to the given one
     **
     - el (Element) parent element to append to
     = (Element) the child element
    \*/
    elproto.appendTo = function (el) {
        if (el) {
            el = wrap(el);
            el.append(this);
        }
        return this;
    };
    /*\
     * Element.prepend
     [ method ]
     **
     * Prepends the given element to the current one
     **
     - el (Element) element to prepend
     = (Element) the parent element
    \*/
    elproto.prepend = function (el) {
        if (el) {
            if (el.type == "set") {
                var it = this,
                    first;
                el.forEach(function (el) {
                    if (first) {
                        first.after(el);
                    } else {
                        it.prepend(el);
                    }
                    first = el;
                });
                return this;
            }
            el = wrap(el);
            var parent = el.parent();
            this.node.insertBefore(el.node, this.node.firstChild);
            this.add && this.add();
            el.paper = this.paper;
            this.parent() && this.parent().add();
            parent && parent.add();
        }
        return this;
    };
    /*\
     * Element.prependTo
     [ method ]
     **
     * Prepends the current element to the given one
     **
     - el (Element) parent element to prepend to
     = (Element) the child element
    \*/
    elproto.prependTo = function (el) {
        el = wrap(el);
        el.prepend(this);
        return this;
    };
    /*\
     * Element.before
     [ method ]
     **
     * Inserts given element before the current one
     **
     - el (Element) element to insert
     = (Element) the parent element
    \*/
    elproto.before = function (el) {
        if (el.type == "set") {
            var it = this;
            el.forEach(function (el) {
                var parent = el.parent();
                it.node.parentNode.insertBefore(el.node, it.node);
                parent && parent.add();
            });
            this.parent().add();
            return this;
        }
        el = wrap(el);
        var parent = el.parent();
        this.node.parentNode.insertBefore(el.node, this.node);
        this.parent() && this.parent().add();
        parent && parent.add();
        el.paper = this.paper;
        return this;
    };
    /*\
     * Element.after
     [ method ]
     **
     * Inserts given element after the current one
     **
     - el (Element) element to insert
     = (Element) the parent element
    \*/
    elproto.after = function (el) {
        el = wrap(el);
        var parent = el.parent();
        if (this.node.nextSibling) {
            this.node.parentNode.insertBefore(el.node, this.node.nextSibling);
        } else {
            this.node.parentNode.appendChild(el.node);
        }
        this.parent() && this.parent().add();
        parent && parent.add();
        el.paper = this.paper;
        return this;
    };
    /*\
     * Element.insertBefore
     [ method ]
     **
     * Inserts the element after the given one
     **
     - el (Element) element next to whom insert to
     = (Element) the parent element
    \*/
    elproto.insertBefore = function (el) {
        el = wrap(el);
        var parent = this.parent();
        el.node.parentNode.insertBefore(this.node, el.node);
        this.paper = el.paper;
        parent && parent.add();
        el.parent() && el.parent().add();
        return this;
    };
    /*\
     * Element.insertAfter
     [ method ]
     **
     * Inserts the element after the given one
     **
     - el (Element) element next to whom insert to
     = (Element) the parent element
    \*/
    elproto.insertAfter = function (el) {
        el = wrap(el);
        var parent = this.parent();
        el.node.parentNode.insertBefore(this.node, el.node.nextSibling);
        this.paper = el.paper;
        parent && parent.add();
        el.parent() && el.parent().add();
        return this;
    };
    /*\
     * Element.remove
     [ method ]
     **
     * Removes element from the DOM
     = (Element) the detached element
    \*/
    elproto.remove = function () {
        var parent = this.parent();
        this.node.parentNode && this.node.parentNode.removeChild(this.node);
        delete this.paper;
        this.removed = true;
        parent && parent.add();
        return this;
    };
    /*\
     * Element.select
     [ method ]
     **
     * Gathers the nested @Element matching the given set of CSS selectors
     **
     - query (string) CSS selector
     = (Element) result of query selection
    \*/
    elproto.select = function (query) {
        return wrap(this.node.querySelector(query));
    };
    /*\
     * Element.selectAll
     [ method ]
     **
     * Gathers nested @Element objects matching the given set of CSS selectors
     **
     - query (string) CSS selector
     = (Set|array) result of query selection
    \*/
    elproto.selectAll = function (query) {
        var nodelist = this.node.querySelectorAll(query),
            set = (Snap.set || Array)();
        for (var i = 0; i < nodelist.length; i++) {
            set.push(wrap(nodelist[i]));
        }
        return set;
    };
    /*\
     * Element.asPX
     [ method ]
     **
     * Returns given attribute of the element as a `px` value (not %, em, etc.)
     **
     - attr (string) attribute name
     - value (string) #optional attribute value
     = (Element) result of query selection
    \*/
    elproto.asPX = function (attr, value) {
        if (value == null) {
            value = this.attr(attr);
        }
        return +unit2px(this, attr, value);
    };
    // SIERRA Element.use(): I suggest adding a note about how to access the original element the returned <use> instantiates. It's a part of SVG with which ordinary web developers may be least familiar.
    /*\
     * Element.use
     [ method ]
     **
     * Creates a `<use>` element linked to the current element
     **
     = (Element) the `<use>` element
    \*/
    elproto.use = function () {
        var use,
            id = this.node.id;
        if (!id) {
            id = this.id;
            $(this.node, {
                id: id
            });
        }
        if (this.type == "linearGradient" || this.type == "radialGradient" ||
            this.type == "pattern") {
            use = make(this.type, this.node.parentNode);
        } else {
            use = make("use", this.node.parentNode);
        }
        $(use.node, {
            "xlink:href": "#" + id
        });
        use.original = this;
        return use;
    };
    function fixids(el) {
        var els = el.selectAll("*"),
            it,
            url = /^\s*url\(("|'|)(.*)\1\)\s*$/,
            ids = [],
            uses = {};
        function urltest(it, name) {
            var val = $(it.node, name);
            val = val && val.match(url);
            val = val && val[2];
            if (val && val.charAt() == "#") {
                val = val.substring(1);
            } else {
                return;
            }
            if (val) {
                uses[val] = (uses[val] || []).concat(function (id) {
                    var attr = {};
                    attr[name] = Snap.url(id);
                    $(it.node, attr);
                });
            }
        }
        function linktest(it) {
            var val = $(it.node, "xlink:href");
            if (val && val.charAt() == "#") {
                val = val.substring(1);
            } else {
                return;
            }
            if (val) {
                uses[val] = (uses[val] || []).concat(function (id) {
                    it.attr("xlink:href", "#" + id);
                });
            }
        }
        for (var i = 0, ii = els.length; i < ii; i++) {
            it = els[i];
            urltest(it, "fill");
            urltest(it, "stroke");
            urltest(it, "filter");
            urltest(it, "mask");
            urltest(it, "clip-path");
            linktest(it);
            var oldid = $(it.node, "id");
            if (oldid) {
                $(it.node, {id: it.id});
                ids.push({
                    old: oldid,
                    id: it.id
                });
            }
        }
        for (i = 0, ii = ids.length; i < ii; i++) {
            var fs = uses[ids[i].old];
            if (fs) {
                for (var j = 0, jj = fs.length; j < jj; j++) {
                    fs[j](ids[i].id);
                }
            }
        }
    }
    /*\
     * Element.clone
     [ method ]
     **
     * Creates a clone of the element and inserts it after the element
     **
     = (Element) the clone
    \*/
    elproto.clone = function () {
        var clone = wrap(this.node.cloneNode(true));
        if ($(clone.node, "id")) {
            $(clone.node, {id: clone.id});
        }
        fixids(clone);
        clone.insertAfter(this);
        return clone;
    };
    /*\
     * Element.toDefs
     [ method ]
     **
     * Moves element to the shared `<defs>` area
     **
     = (Element) the element
    \*/
    elproto.toDefs = function () {
        var defs = getSomeDefs(this);
        defs.appendChild(this.node);
        return this;
    };
    /*\
     * Element.toPattern
     [ method ]
     **
     * Creates a `<pattern>` element from the current element
     **
     * To create a pattern you have to specify the pattern rect:
     - x (string|number)
     - y (string|number)
     - width (string|number)
     - height (string|number)
     = (Element) the `<pattern>` element
     * You can use pattern later on as an argument for `fill` attribute:
     | var p = paper.path("M10-5-10,15M15,0,0,15M0-5-20,15").attr({
     |         fill: "none",
     |         stroke: "#bada55",
     |         strokeWidth: 5
     |     }).pattern(0, 0, 10, 10),
     |     c = paper.circle(200, 200, 100);
     | c.attr({
     |     fill: p
     | });
    \*/
    elproto.pattern = elproto.toPattern = function (x, y, width, height) {
        var p = make("pattern", getSomeDefs(this));
        if (x == null) {
            x = this.getBBox();
        }
        if (is(x, "object") && "x" in x) {
            y = x.y;
            width = x.width;
            height = x.height;
            x = x.x;
        }
        $(p.node, {
            x: x,
            y: y,
            width: width,
            height: height,
            patternUnits: "userSpaceOnUse",
            id: p.id,
            viewBox: [x, y, width, height].join(" ")
        });
        p.node.appendChild(this.node);
        return p;
    };
// SIERRA Element.marker(): clarify what a reference point is. E.g., helps you offset the object from its edge such as when centering it over a path.
// SIERRA Element.marker(): I suggest the method should accept default reference point values.  Perhaps centered with (refX = width/2) and (refY = height/2)? Also, couldn't it assume the element's current _width_ and _height_? And please specify what _x_ and _y_ mean: offsets? If so, from where?  Couldn't they also be assigned default values?
    /*\
     * Element.marker
     [ method ]
     **
     * Creates a `<marker>` element from the current element
     **
     * To create a marker you have to specify the bounding rect and reference point:
     - x (number)
     - y (number)
     - width (number)
     - height (number)
     - refX (number)
     - refY (number)
     = (Element) the `<marker>` element
     * You can specify the marker later as an argument for `marker-start`, `marker-end`, `marker-mid`, and `marker` attributes. The `marker` attribute places the marker at every point along the path, and `marker-mid` places them at every point except the start and end.
    \*/
    // TODO add usage for markers
    elproto.marker = function (x, y, width, height, refX, refY) {
        var p = make("marker", getSomeDefs(this));
        if (x == null) {
            x = this.getBBox();
        }
        if (is(x, "object") && "x" in x) {
            y = x.y;
            width = x.width;
            height = x.height;
            refX = x.refX || x.cx;
            refY = x.refY || x.cy;
            x = x.x;
        }
        $(p.node, {
            viewBox: [x, y, width, height].join(" "),
            markerWidth: width,
            markerHeight: height,
            orient: "auto",
            refX: refX || 0,
            refY: refY || 0,
            id: p.id
        });
        p.node.appendChild(this.node);
        return p;
    };
    var eldata = {};
    /*\
     * Element.data
     [ method ]
     **
     * Adds or retrieves given value associated with given key. (Don’t confuse
     * with `data-` attributes)
     *
     * See also @Element.removeData
     - key (string) key to store data
     - value (any) #optional value to store
     = (object) @Element
     * or, if value is not specified:
     = (any) value
     > Usage
     | for (var i = 0, i < 5, i++) {
     |     paper.circle(10 + 15 * i, 10, 10)
     |          .attr({fill: "#000"})
     |          .data("i", i)
     |          .click(function () {
     |             alert(this.data("i"));
     |          });
     | }
    \*/
    elproto.data = function (key, value) {
        var data = eldata[this.id] = eldata[this.id] || {};
        if (arguments.length == 0){
            eve("snap.data.get." + this.id, this, data, null);
            return data;
        }
        if (arguments.length == 1) {
            if (Snap.is(key, "object")) {
                for (var i in key) if (key[has](i)) {
                    this.data(i, key[i]);
                }
                return this;
            }
            eve("snap.data.get." + this.id, this, data[key], key);
            return data[key];
        }
        data[key] = value;
        eve("snap.data.set." + this.id, this, value, key);
        return this;
    };
    /*\
     * Element.removeData
     [ method ]
     **
     * Removes value associated with an element by given key.
     * If key is not provided, removes all the data of the element.
     - key (string) #optional key
     = (object) @Element
    \*/
    elproto.removeData = function (key) {
        if (key == null) {
            eldata[this.id] = {};
        } else {
            eldata[this.id] && delete eldata[this.id][key];
        }
        return this;
    };
    /*\
     * Element.outerSVG
     [ method ]
     **
     * Returns SVG code for the element, equivalent to HTML's `outerHTML`.
     *
     * See also @Element.innerSVG
     = (string) SVG code for the element
    \*/
    /*\
     * Element.toString
     [ method ]
     **
     * See @Element.outerSVG
    \*/
    elproto.outerSVG = elproto.toString = toString(1);
    /*\
     * Element.innerSVG
     [ method ]
     **
     * Returns SVG code for the element's contents, equivalent to HTML's `innerHTML`
     = (string) SVG code for the element
    \*/
    elproto.innerSVG = toString();
    function toString(type) {
        return function () {
            var res = type ? "<" + this.type : "",
                attr = this.node.attributes,
                chld = this.node.childNodes;
            if (type) {
                for (var i = 0, ii = attr.length; i < ii; i++) {
                    res += " " + attr[i].name + '="' +
                            attr[i].value.replace(/"/g, '\\"') + '"';
                }
            }
            if (chld.length) {
                type && (res += ">");
                for (i = 0, ii = chld.length; i < ii; i++) {
                    if (chld[i].nodeType == 3) {
                        res += chld[i].nodeValue;
                    } else if (chld[i].nodeType == 1) {
                        res += wrap(chld[i]).toString();
                    }
                }
                type && (res += "</" + this.type + ">");
            } else {
                type && (res += "/>");
            }
            return res;
        };
    }
    elproto.toDataURL = function () {
        if (window && window.btoa) {
            var bb = this.getBBox(),
                svg = Snap.format('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="{width}" height="{height}" viewBox="{x} {y} {width} {height}">{contents}</svg>', {
                x: +bb.x.toFixed(3),
                y: +bb.y.toFixed(3),
                width: +bb.width.toFixed(3),
                height: +bb.height.toFixed(3),
                contents: this.outerSVG()
            });
            return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svg)));
        }
    };
    /*\
     * Fragment.select
     [ method ]
     **
     * See @Element.select
    \*/
    Fragment.prototype.select = elproto.select;
    /*\
     * Fragment.selectAll
     [ method ]
     **
     * See @Element.selectAll
    \*/
    Fragment.prototype.selectAll = elproto.selectAll;
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var objectToString = Object.prototype.toString,
        Str = String,
        math = Math,
        E = "";
    function Matrix(a, b, c, d, e, f) {
        if (b == null && objectToString.call(a) == "[object SVGMatrix]") {
            this.a = a.a;
            this.b = a.b;
            this.c = a.c;
            this.d = a.d;
            this.e = a.e;
            this.f = a.f;
            return;
        }
        if (a != null) {
            this.a = +a;
            this.b = +b;
            this.c = +c;
            this.d = +d;
            this.e = +e;
            this.f = +f;
        } else {
            this.a = 1;
            this.b = 0;
            this.c = 0;
            this.d = 1;
            this.e = 0;
            this.f = 0;
        }
    }
    (function (matrixproto) {
        /*\
         * Matrix.add
         [ method ]
         **
         * Adds the given matrix to existing one
         - a (number)
         - b (number)
         - c (number)
         - d (number)
         - e (number)
         - f (number)
         * or
         - matrix (object) @Matrix
        \*/
        matrixproto.add = function (a, b, c, d, e, f) {
            if (a && a instanceof Matrix) {
                return this.add(a.a, a.b, a.c, a.d, a.e, a.f);
            }
            var aNew = a * this.a + b * this.c,
                bNew = a * this.b + b * this.d;
            this.e += e * this.a + f * this.c;
            this.f += e * this.b + f * this.d;
            this.c = c * this.a + d * this.c;
            this.d = c * this.b + d * this.d;

            this.a = aNew;
            this.b = bNew;
            return this;
        };
        /*\
         * Matrix.multLeft
         [ method ]
         **
         * Multiplies a passed affine transform to the left: M * this.
         - a (number)
         - b (number)
         - c (number)
         - d (number)
         - e (number)
         - f (number)
         * or
         - matrix (object) @Matrix
        \*/
        Matrix.prototype.multLeft = function (a, b, c, d, e, f) {
            if (a && a instanceof Matrix) {
                return this.multLeft(a.a, a.b, a.c, a.d, a.e, a.f);
            }
            var aNew = a * this.a + c * this.b,
                cNew = a * this.c + c * this.d,
                eNew = a * this.e + c * this.f + e;
            this.b = b * this.a + d * this.b;
            this.d = b * this.c + d * this.d;
            this.f = b * this.e + d * this.f + f;

            this.a = aNew;
            this.c = cNew;
            this.e = eNew;
            return this;
        };
        /*\
         * Matrix.invert
         [ method ]
         **
         * Returns an inverted version of the matrix
         = (object) @Matrix
        \*/
        matrixproto.invert = function () {
            var me = this,
                x = me.a * me.d - me.b * me.c;
            return new Matrix(me.d / x, -me.b / x, -me.c / x, me.a / x, (me.c * me.f - me.d * me.e) / x, (me.b * me.e - me.a * me.f) / x);
        };
        /*\
         * Matrix.clone
         [ method ]
         **
         * Returns a copy of the matrix
         = (object) @Matrix
        \*/
        matrixproto.clone = function () {
            return new Matrix(this.a, this.b, this.c, this.d, this.e, this.f);
        };
        /*\
         * Matrix.translate
         [ method ]
         **
         * Translate the matrix
         - x (number) horizontal offset distance
         - y (number) vertical offset distance
        \*/
        matrixproto.translate = function (x, y) {
            this.e += x * this.a + y * this.c;
            this.f += x * this.b + y * this.d;
            return this;
        };
        /*\
         * Matrix.scale
         [ method ]
         **
         * Scales the matrix
         - x (number) amount to be scaled, with `1` resulting in no change
         - y (number) #optional amount to scale along the vertical axis. (Otherwise `x` applies to both axes.)
         - cx (number) #optional horizontal origin point from which to scale
         - cy (number) #optional vertical origin point from which to scale
         * Default cx, cy is the middle point of the element.
        \*/
        matrixproto.scale = function (x, y, cx, cy) {
            y == null && (y = x);
            (cx || cy) && this.translate(cx, cy);
            this.a *= x;
            this.b *= x;
            this.c *= y;
            this.d *= y;
            (cx || cy) && this.translate(-cx, -cy);
            return this;
        };
        /*\
         * Matrix.rotate
         [ method ]
         **
         * Rotates the matrix
         - a (number) angle of rotation, in degrees
         - x (number) horizontal origin point from which to rotate
         - y (number) vertical origin point from which to rotate
        \*/
        matrixproto.rotate = function (a, x, y) {
            a = Snap.rad(a);
            x = x || 0;
            y = y || 0;
            var cos = +math.cos(a).toFixed(9),
                sin = +math.sin(a).toFixed(9);
            this.add(cos, sin, -sin, cos, x, y);
            return this.add(1, 0, 0, 1, -x, -y);
        };
        /*\
         * Matrix.skewX
         [ method ]
         **
         * Skews the matrix along the x-axis
         - x (number) Angle to skew along the x-axis (in degrees).
        \*/
        matrixproto.skewX = function (x) {
            return this.skew(x, 0);
        };
        /*\
         * Matrix.skewY
         [ method ]
         **
         * Skews the matrix along the y-axis
         - y (number) Angle to skew along the y-axis (in degrees).
        \*/
        matrixproto.skewY = function (y) {
            return this.skew(0, y);
        };
        /*\
         * Matrix.skew
         [ method ]
         **
         * Skews the matrix
         - y (number) Angle to skew along the y-axis (in degrees).
         - x (number) Angle to skew along the x-axis (in degrees).
        \*/
        matrixproto.skew = function (x, y) {
            x = x || 0;
            y = y || 0;
            x = Snap.rad(x);
            y = Snap.rad(y);
            var c = math.tan(x).toFixed(9);
            var b = math.tan(y).toFixed(9);
            return this.add(1, b, c, 1, 0, 0);
        };
        /*\
         * Matrix.x
         [ method ]
         **
         * Returns x coordinate for given point after transformation described by the matrix. See also @Matrix.y
         - x (number)
         - y (number)
         = (number) x
        \*/
        matrixproto.x = function (x, y) {
            return x * this.a + y * this.c + this.e;
        };
        /*\
         * Matrix.y
         [ method ]
         **
         * Returns y coordinate for given point after transformation described by the matrix. See also @Matrix.x
         - x (number)
         - y (number)
         = (number) y
        \*/
        matrixproto.y = function (x, y) {
            return x * this.b + y * this.d + this.f;
        };
        matrixproto.get = function (i) {
            return +this[Str.fromCharCode(97 + i)].toFixed(4);
        };
        matrixproto.toString = function () {
            return "matrix(" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)].join() + ")";
        };
        matrixproto.offset = function () {
            return [this.e.toFixed(4), this.f.toFixed(4)];
        };
        function norm(a) {
            return a[0] * a[0] + a[1] * a[1];
        }
        function normalize(a) {
            var mag = math.sqrt(norm(a));
            a[0] && (a[0] /= mag);
            a[1] && (a[1] /= mag);
        }
        /*\
         * Matrix.determinant
         [ method ]
         **
         * Finds determinant of the given matrix.
         = (number) determinant
        \*/
        matrixproto.determinant = function () {
            return this.a * this.d - this.b * this.c;
        };
        /*\
         * Matrix.split
         [ method ]
         **
         * Splits matrix into primitive transformations
         = (object) in format:
         o dx (number) translation by x
         o dy (number) translation by y
         o scalex (number) scale by x
         o scaley (number) scale by y
         o shear (number) shear
         o rotate (number) rotation in deg
         o isSimple (boolean) could it be represented via simple transformations
        \*/
        matrixproto.split = function () {
            var out = {};
            // translation
            out.dx = this.e;
            out.dy = this.f;

            // scale and shear
            var row = [[this.a, this.b], [this.c, this.d]];
            out.scalex = math.sqrt(norm(row[0]));
            normalize(row[0]);

            out.shear = row[0][0] * row[1][0] + row[0][1] * row[1][1];
            row[1] = [row[1][0] - row[0][0] * out.shear, row[1][1] - row[0][1] * out.shear];

            out.scaley = math.sqrt(norm(row[1]));
            normalize(row[1]);
            out.shear /= out.scaley;

            if (this.determinant() < 0) {
                out.scalex = -out.scalex;
            }

            // rotation
            var sin = row[0][1],
                cos = row[1][1];
            if (cos < 0) {
                out.rotate = Snap.deg(math.acos(cos));
                if (sin < 0) {
                    out.rotate = 360 - out.rotate;
                }
            } else {
                out.rotate = Snap.deg(math.asin(sin));
            }

            out.isSimple = !+out.shear.toFixed(9) && (out.scalex.toFixed(9) == out.scaley.toFixed(9) || !out.rotate);
            out.isSuperSimple = !+out.shear.toFixed(9) && out.scalex.toFixed(9) == out.scaley.toFixed(9) && !out.rotate;
            out.noRotation = !+out.shear.toFixed(9) && !out.rotate;
            return out;
        };
        /*\
         * Matrix.toTransformString
         [ method ]
         **
         * Returns transform string that represents given matrix
         = (string) transform string
        \*/
        matrixproto.toTransformString = function (shorter) {
            var s = shorter || this.split();
            if (!+s.shear.toFixed(9)) {
                s.scalex = +s.scalex.toFixed(4);
                s.scaley = +s.scaley.toFixed(4);
                s.rotate = +s.rotate.toFixed(4);
                return  (s.dx || s.dy ? "t" + [+s.dx.toFixed(4), +s.dy.toFixed(4)] : E) +
                        (s.rotate ? "r" + [+s.rotate.toFixed(4), 0, 0] : E) +
                        (s.scalex != 1 || s.scaley != 1 ? "s" + [s.scalex, s.scaley, 0, 0] : E);
            } else {
                return "m" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)];
            }
        };
    })(Matrix.prototype);
    /*\
     * Snap.Matrix
     [ method ]
     **
     * Matrix constructor, extend on your own risk.
     * To create matrices use @Snap.matrix.
    \*/
    Snap.Matrix = Matrix;
    /*\
     * Snap.matrix
     [ method ]
     **
     * Utility method
     **
     * Returns a matrix based on the given parameters
     - a (number)
     - b (number)
     - c (number)
     - d (number)
     - e (number)
     - f (number)
     * or
     - svgMatrix (SVGMatrix)
     = (object) @Matrix
    \*/
    Snap.matrix = function (a, b, c, d, e, f) {
        return new Matrix(a, b, c, d, e, f);
    };
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var has = "hasOwnProperty",
        make = Snap._.make,
        wrap = Snap._.wrap,
        is = Snap.is,
        getSomeDefs = Snap._.getSomeDefs,
        reURLValue = /^url\((['"]?)([^)]+)\1\)$/,
        $ = Snap._.$,
        URL = Snap.url,
        Str = String,
        separator = Snap._.separator,
        E = "";
    /*\
     * Snap.deurl
     [ method ]
     **
     * Unwraps path from `"url(<path>)"`.
     - value (string) url path
     = (string) unwrapped path
    \*/
    Snap.deurl = function (value) {
        var res = String(value).match(reURLValue);
        return res ? res[2] : value;
    }
    // Attributes event handlers
    eve.on("snap.util.attr.mask", function (value) {
        if (value instanceof Element || value instanceof Fragment) {
            eve.stop();
            if (value instanceof Fragment && value.node.childNodes.length == 1) {
                value = value.node.firstChild;
                getSomeDefs(this).appendChild(value);
                value = wrap(value);
            }
            if (value.type == "mask") {
                var mask = value;
            } else {
                mask = make("mask", getSomeDefs(this));
                mask.node.appendChild(value.node);
            }
            !mask.node.id && $(mask.node, {
                id: mask.id
            });
            $(this.node, {
                mask: URL(mask.id)
            });
        }
    });
    (function (clipIt) {
        eve.on("snap.util.attr.clip", clipIt);
        eve.on("snap.util.attr.clip-path", clipIt);
        eve.on("snap.util.attr.clipPath", clipIt);
    }(function (value) {
        if (value instanceof Element || value instanceof Fragment) {
            eve.stop();
            var clip,
                node = value.node;
            while (node) {
                if (node.nodeName === "clipPath") {
                    clip = new Element(node);
                    break;
                }
                if (node.nodeName === "svg") {
                    clip = undefined;
                    break;
                }
                node = node.parentNode;
            }
            if (!clip) {
                clip = make("clipPath", getSomeDefs(this));
                clip.node.appendChild(value.node);
                !clip.node.id && $(clip.node, {
                    id: clip.id
                });
            }
            $(this.node, {
                "clip-path": URL(clip.node.id || clip.id)
            });
        }
    }));
    function fillStroke(name) {
        return function (value) {
            eve.stop();
            if (value instanceof Fragment && value.node.childNodes.length == 1 &&
                (value.node.firstChild.tagName == "radialGradient" ||
                value.node.firstChild.tagName == "linearGradient" ||
                value.node.firstChild.tagName == "pattern")) {
                value = value.node.firstChild;
                getSomeDefs(this).appendChild(value);
                value = wrap(value);
            }
            if (value instanceof Element) {
                if (value.type == "radialGradient" || value.type == "linearGradient"
                   || value.type == "pattern") {
                    if (!value.node.id) {
                        $(value.node, {
                            id: value.id
                        });
                    }
                    var fill = URL(value.node.id);
                } else {
                    fill = value.attr(name);
                }
            } else {
                fill = Snap.color(value);
                if (fill.error) {
                    var grad = Snap(getSomeDefs(this).ownerSVGElement).gradient(value);
                    if (grad) {
                        if (!grad.node.id) {
                            $(grad.node, {
                                id: grad.id
                            });
                        }
                        fill = URL(grad.node.id);
                    } else {
                        fill = value;
                    }
                } else {
                    fill = Str(fill);
                }
            }
            var attrs = {};
            attrs[name] = fill;
            $(this.node, attrs);
            this.node.style[name] = E;
        };
    }
    eve.on("snap.util.attr.fill", fillStroke("fill"));
    eve.on("snap.util.attr.stroke", fillStroke("stroke"));
    var gradrg = /^([lr])(?:\(([^)]*)\))?(.*)$/i;
    eve.on("snap.util.grad.parse", function parseGrad(string) {
        string = Str(string);
        var tokens = string.match(gradrg);
        if (!tokens) {
            return null;
        }
        var type = tokens[1],
            params = tokens[2],
            stops = tokens[3];
        params = params.split(/\s*,\s*/).map(function (el) {
            return +el == el ? +el : el;
        });
        if (params.length == 1 && params[0] == 0) {
            params = [];
        }
        stops = stops.split("-");
        stops = stops.map(function (el) {
            el = el.split(":");
            var out = {
                color: el[0]
            };
            if (el[1]) {
                out.offset = parseFloat(el[1]);
            }
            return out;
        });
        var len = stops.length,
            start = 0,
            j = 0;
        function seed(i, end) {
            var step = (end - start) / (i - j);
            for (var k = j; k < i; k++) {
                stops[k].offset = +(+start + step * (k - j)).toFixed(2);
            }
            j = i;
            start = end;
        }
        len--;
        for (var i = 0; i < len; i++) if ("offset" in stops[i]) {
            seed(i, stops[i].offset);
        }
        stops[len].offset = stops[len].offset || 100;
        seed(len, stops[len].offset);
        return {
            type: type,
            params: params,
            stops: stops
        };
    });

    eve.on("snap.util.attr.d", function (value) {
        eve.stop();
        if (is(value, "array") && is(value[0], "array")) {
            value = Snap.path.toString.call(value);
        }
        value = Str(value);
        if (value.match(/[ruo]/i)) {
            value = Snap.path.toAbsolute(value);
        }
        $(this.node, {d: value});
    })(-1);
    eve.on("snap.util.attr.#text", function (value) {
        eve.stop();
        value = Str(value);
        var txt = glob.doc.createTextNode(value);
        while (this.node.firstChild) {
            this.node.removeChild(this.node.firstChild);
        }
        this.node.appendChild(txt);
    })(-1);
    eve.on("snap.util.attr.path", function (value) {
        eve.stop();
        this.attr({d: value});
    })(-1);
    eve.on("snap.util.attr.class", function (value) {
        eve.stop();
        this.node.className.baseVal = value;
    })(-1);
    eve.on("snap.util.attr.viewBox", function (value) {
        var vb;
        if (is(value, "object") && "x" in value) {
            vb = [value.x, value.y, value.width, value.height].join(" ");
        } else if (is(value, "array")) {
            vb = value.join(" ");
        } else {
            vb = value;
        }
        $(this.node, {
            viewBox: vb
        });
        eve.stop();
    })(-1);
    eve.on("snap.util.attr.transform", function (value) {
        this.transform(value);
        eve.stop();
    })(-1);
    eve.on("snap.util.attr.r", function (value) {
        if (this.type == "rect") {
            eve.stop();
            $(this.node, {
                rx: value,
                ry: value
            });
        }
    })(-1);
    eve.on("snap.util.attr.textpath", function (value) {
        eve.stop();
        if (this.type == "text") {
            var id, tp, node;
            if (!value && this.textPath) {
                tp = this.textPath;
                while (tp.node.firstChild) {
                    this.node.appendChild(tp.node.firstChild);
                }
                tp.remove();
                delete this.textPath;
                return;
            }
            if (is(value, "string")) {
                var defs = getSomeDefs(this),
                    path = wrap(defs.parentNode).path(value);
                defs.appendChild(path.node);
                id = path.id;
                path.attr({id: id});
            } else {
                value = wrap(value);
                if (value instanceof Element) {
                    id = value.attr("id");
                    if (!id) {
                        id = value.id;
                        value.attr({id: id});
                    }
                }
            }
            if (id) {
                tp = this.textPath;
                node = this.node;
                if (tp) {
                    tp.attr({"xlink:href": "#" + id});
                } else {
                    tp = $("textPath", {
                        "xlink:href": "#" + id
                    });
                    while (node.firstChild) {
                        tp.appendChild(node.firstChild);
                    }
                    node.appendChild(tp);
                    this.textPath = wrap(tp);
                }
            }
        }
    })(-1);
    eve.on("snap.util.attr.text", function (value) {
        if (this.type == "text") {
            var i = 0,
                node = this.node,
                tuner = function (chunk) {
                    var out = $("tspan");
                    if (is(chunk, "array")) {
                        for (var i = 0; i < chunk.length; i++) {
                            out.appendChild(tuner(chunk[i]));
                        }
                    } else {
                        out.appendChild(glob.doc.createTextNode(chunk));
                    }
                    out.normalize && out.normalize();
                    return out;
                };
            while (node.firstChild) {
                node.removeChild(node.firstChild);
            }
            var tuned = tuner(value);
            while (tuned.firstChild) {
                node.appendChild(tuned.firstChild);
            }
        }
        eve.stop();
    })(-1);
    function setFontSize(value) {
        eve.stop();
        if (value == +value) {
            value += "px";
        }
        this.node.style.fontSize = value;
    }
    eve.on("snap.util.attr.fontSize", setFontSize)(-1);
    eve.on("snap.util.attr.font-size", setFontSize)(-1);


    eve.on("snap.util.getattr.transform", function () {
        eve.stop();
        return this.transform();
    })(-1);
    eve.on("snap.util.getattr.textpath", function () {
        eve.stop();
        return this.textPath;
    })(-1);
    // Markers
    (function () {
        function getter(end) {
            return function () {
                eve.stop();
                var style = glob.doc.defaultView.getComputedStyle(this.node, null).getPropertyValue("marker-" + end);
                if (style == "none") {
                    return style;
                } else {
                    return Snap(glob.doc.getElementById(style.match(reURLValue)[1]));
                }
            };
        }
        function setter(end) {
            return function (value) {
                eve.stop();
                var name = "marker" + end.charAt(0).toUpperCase() + end.substring(1);
                if (value == "" || !value) {
                    this.node.style[name] = "none";
                    return;
                }
                if (value.type == "marker") {
                    var id = value.node.id;
                    if (!id) {
                        $(value.node, {id: value.id});
                    }
                    this.node.style[name] = URL(id);
                    return;
                }
            };
        }
        eve.on("snap.util.getattr.marker-end", getter("end"))(-1);
        eve.on("snap.util.getattr.markerEnd", getter("end"))(-1);
        eve.on("snap.util.getattr.marker-start", getter("start"))(-1);
        eve.on("snap.util.getattr.markerStart", getter("start"))(-1);
        eve.on("snap.util.getattr.marker-mid", getter("mid"))(-1);
        eve.on("snap.util.getattr.markerMid", getter("mid"))(-1);
        eve.on("snap.util.attr.marker-end", setter("end"))(-1);
        eve.on("snap.util.attr.markerEnd", setter("end"))(-1);
        eve.on("snap.util.attr.marker-start", setter("start"))(-1);
        eve.on("snap.util.attr.markerStart", setter("start"))(-1);
        eve.on("snap.util.attr.marker-mid", setter("mid"))(-1);
        eve.on("snap.util.attr.markerMid", setter("mid"))(-1);
    }());
    eve.on("snap.util.getattr.r", function () {
        if (this.type == "rect" && $(this.node, "rx") == $(this.node, "ry")) {
            eve.stop();
            return $(this.node, "rx");
        }
    })(-1);
    function textExtract(node) {
        var out = [];
        var children = node.childNodes;
        for (var i = 0, ii = children.length; i < ii; i++) {
            var chi = children[i];
            if (chi.nodeType == 3) {
                out.push(chi.nodeValue);
            }
            if (chi.tagName == "tspan") {
                if (chi.childNodes.length == 1 && chi.firstChild.nodeType == 3) {
                    out.push(chi.firstChild.nodeValue);
                } else {
                    out.push(textExtract(chi));
                }
            }
        }
        return out;
    }
    eve.on("snap.util.getattr.text", function () {
        if (this.type == "text" || this.type == "tspan") {
            eve.stop();
            var out = textExtract(this.node);
            return out.length == 1 ? out[0] : out;
        }
    })(-1);
    eve.on("snap.util.getattr.#text", function () {
        return this.node.textContent;
    })(-1);
    eve.on("snap.util.getattr.fill", function (internal) {
        if (internal) {
            return;
        }
        eve.stop();
        var value = eve("snap.util.getattr.fill", this, true).firstDefined();
        return Snap(Snap.deurl(value)) || value;
    })(-1);
    eve.on("snap.util.getattr.stroke", function (internal) {
        if (internal) {
            return;
        }
        eve.stop();
        var value = eve("snap.util.getattr.stroke", this, true).firstDefined();
        return Snap(Snap.deurl(value)) || value;
    })(-1);
    eve.on("snap.util.getattr.viewBox", function () {
        eve.stop();
        var vb = $(this.node, "viewBox");
        if (vb) {
            vb = vb.split(separator);
            return Snap._.box(+vb[0], +vb[1], +vb[2], +vb[3]);
        } else {
            return;
        }
    })(-1);
    eve.on("snap.util.getattr.points", function () {
        var p = $(this.node, "points");
        eve.stop();
        if (p) {
            return p.split(separator);
        } else {
            return;
        }
    })(-1);
    eve.on("snap.util.getattr.path", function () {
        var p = $(this.node, "d");
        eve.stop();
        return p;
    })(-1);
    eve.on("snap.util.getattr.class", function () {
        return this.node.className.baseVal;
    })(-1);
    function getFontSize() {
        eve.stop();
        return this.node.style.fontSize;
    }
    eve.on("snap.util.getattr.fontSize", getFontSize)(-1);
    eve.on("snap.util.getattr.font-size", getFontSize)(-1);
});

// Copyright (c) 2014 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var rgNotSpace = /\S+/g,
        rgBadSpace = /[\t\r\n\f]/g,
        rgTrim = /(^\s+|\s+$)/g,
        Str = String,
        elproto = Element.prototype;
    /*\
     * Element.addClass
     [ method ]
     **
     * Adds given class name or list of class names to the element.
     - value (string) class name or space separated list of class names
     **
     = (Element) original element.
    \*/
    elproto.addClass = function (value) {
        var classes = Str(value || "").match(rgNotSpace) || [],
            elem = this.node,
            className = elem.className.baseVal,
            curClasses = className.match(rgNotSpace) || [],
            j,
            pos,
            clazz,
            finalValue;

        if (classes.length) {
            j = 0;
            while (clazz = classes[j++]) {
                pos = curClasses.indexOf(clazz);
                if (!~pos) {
                    curClasses.push(clazz);
                }
            }

            finalValue = curClasses.join(" ");
            if (className != finalValue) {
                elem.className.baseVal = finalValue;
            }
        }
        return this;
    };
    /*\
     * Element.removeClass
     [ method ]
     **
     * Removes given class name or list of class names from the element.
     - value (string) class name or space separated list of class names
     **
     = (Element) original element.
    \*/
    elproto.removeClass = function (value) {
        var classes = Str(value || "").match(rgNotSpace) || [],
            elem = this.node,
            className = elem.className.baseVal,
            curClasses = className.match(rgNotSpace) || [],
            j,
            pos,
            clazz,
            finalValue;
        if (curClasses.length) {
            j = 0;
            while (clazz = classes[j++]) {
                pos = curClasses.indexOf(clazz);
                if (~pos) {
                    curClasses.splice(pos, 1);
                }
            }

            finalValue = curClasses.join(" ");
            if (className != finalValue) {
                elem.className.baseVal = finalValue;
            }
        }
        return this;
    };
    /*\
     * Element.hasClass
     [ method ]
     **
     * Checks if the element has a given class name in the list of class names applied to it.
     - value (string) class name
     **
     = (boolean) `true` if the element has given class
    \*/
    elproto.hasClass = function (value) {
        var elem = this.node,
            className = elem.className.baseVal,
            curClasses = className.match(rgNotSpace) || [];
        return !!~curClasses.indexOf(value);
    };
    /*\
     * Element.toggleClass
     [ method ]
     **
     * Add or remove one or more classes from the element, depending on either
     * the class’s presence or the value of the `flag` argument.
     - value (string) class name or space separated list of class names
     - flag (boolean) value to determine whether the class should be added or removed
     **
     = (Element) original element.
    \*/
    elproto.toggleClass = function (value, flag) {
        if (flag != null) {
            if (flag) {
                return this.addClass(value);
            } else {
                return this.removeClass(value);
            }
        }
        var classes = (value || "").match(rgNotSpace) || [],
            elem = this.node,
            className = elem.className.baseVal,
            curClasses = className.match(rgNotSpace) || [],
            j,
            pos,
            clazz,
            finalValue;
        j = 0;
        while (clazz = classes[j++]) {
            pos = curClasses.indexOf(clazz);
            if (~pos) {
                curClasses.splice(pos, 1);
            } else {
                curClasses.push(clazz);
            }
        }

        finalValue = curClasses.join(" ");
        if (className != finalValue) {
            elem.className.baseVal = finalValue;
        }
        return this;
    };
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var operators = {
            "+": function (x, y) {
                    return x + y;
                },
            "-": function (x, y) {
                    return x - y;
                },
            "/": function (x, y) {
                    return x / y;
                },
            "*": function (x, y) {
                    return x * y;
                }
        },
        Str = String,
        reUnit = /[a-z]+$/i,
        reAddon = /^\s*([+\-\/*])\s*=\s*([\d.eE+\-]+)\s*([^\d\s]+)?\s*$/;
    function getNumber(val) {
        return val;
    }
    function getUnit(unit) {
        return function (val) {
            return +val.toFixed(3) + unit;
        };
    }
    eve.on("snap.util.attr", function (val) {
        var plus = Str(val).match(reAddon);
        if (plus) {
            var evnt = eve.nt(),
                name = evnt.substring(evnt.lastIndexOf(".") + 1),
                a = this.attr(name),
                atr = {};
            eve.stop();
            var unit = plus[3] || "",
                aUnit = a.match(reUnit),
                op = operators[plus[1]];
            if (aUnit && aUnit == unit) {
                val = op(parseFloat(a), +plus[2]);
            } else {
                a = this.asPX(name);
                val = op(this.asPX(name), this.asPX(name, plus[2] + unit));
            }
            if (isNaN(a) || isNaN(val)) {
                return;
            }
            atr[name] = val;
            this.attr(atr);
        }
    })(-10);
    eve.on("snap.util.equal", function (name, b) {
        var A, B, a = Str(this.attr(name) || ""),
            el = this,
            bplus = Str(b).match(reAddon);
        if (bplus) {
            eve.stop();
            var unit = bplus[3] || "",
                aUnit = a.match(reUnit),
                op = operators[bplus[1]];
            if (aUnit && aUnit == unit) {
                return {
                    from: parseFloat(a),
                    to: op(parseFloat(a), +bplus[2]),
                    f: getUnit(aUnit)
                };
            } else {
                a = this.asPX(name);
                return {
                    from: a,
                    to: op(a, this.asPX(name, bplus[2] + unit)),
                    f: getNumber
                };
            }
        }
    })(-10);
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var proto = Paper.prototype,
        is = Snap.is;
    /*\
     * Paper.rect
     [ method ]
     *
     * Draws a rectangle
     **
     - x (number) x coordinate of the top left corner
     - y (number) y coordinate of the top left corner
     - width (number) width
     - height (number) height
     - rx (number) #optional horizontal radius for rounded corners, default is 0
     - ry (number) #optional vertical radius for rounded corners, default is rx or 0
     = (object) the `rect` element
     **
     > Usage
     | // regular rectangle
     | var c = paper.rect(10, 10, 50, 50);
     | // rectangle with rounded corners
     | var c = paper.rect(40, 40, 50, 50, 10);
    \*/
    proto.rect = function (x, y, w, h, rx, ry) {
        var attr;
        if (ry == null) {
            ry = rx;
        }
        if (is(x, "object") && x == "[object Object]") {
            attr = x;
        } else if (x != null) {
            attr = {
                x: x,
                y: y,
                width: w,
                height: h
            };
            if (rx != null) {
                attr.rx = rx;
                attr.ry = ry;
            }
        }
        return this.el("rect", attr);
    };
    /*\
     * Paper.circle
     [ method ]
     **
     * Draws a circle
     **
     - x (number) x coordinate of the centre
     - y (number) y coordinate of the centre
     - r (number) radius
     = (object) the `circle` element
     **
     > Usage
     | var c = paper.circle(50, 50, 40);
    \*/
    proto.circle = function (cx, cy, r) {
        var attr;
        if (is(cx, "object") && cx == "[object Object]") {
            attr = cx;
        } else if (cx != null) {
            attr = {
                cx: cx,
                cy: cy,
                r: r
            };
        }
        return this.el("circle", attr);
    };

    var preload = (function () {
        function onerror() {
            this.parentNode.removeChild(this);
        }
        return function (src, f) {
            var img = glob.doc.createElement("img"),
                body = glob.doc.body;
            img.style.cssText = "position:absolute;left:-9999em;top:-9999em";
            img.onload = function () {
                f.call(img);
                img.onload = img.onerror = null;
                body.removeChild(img);
            };
            img.onerror = onerror;
            body.appendChild(img);
            img.src = src;
        };
    }());

    /*\
     * Paper.image
     [ method ]
     **
     * Places an image on the surface
     **
     - src (string) URI of the source image
     - x (number) x offset position
     - y (number) y offset position
     - width (number) width of the image
     - height (number) height of the image
     = (object) the `image` element
     * or
     = (object) Snap element object with type `image`
     **
     > Usage
     | var c = paper.image("apple.png", 10, 10, 80, 80);
    \*/
    proto.image = function (src, x, y, width, height) {
        var el = this.el("image");
        if (is(src, "object") && "src" in src) {
            el.attr(src);
        } else if (src != null) {
            var set = {
                "xlink:href": src,
                preserveAspectRatio: "none"
            };
            if (x != null && y != null) {
                set.x = x;
                set.y = y;
            }
            if (width != null && height != null) {
                set.width = width;
                set.height = height;
            } else {
                preload(src, function () {
                    Snap._.$(el.node, {
                        width: this.offsetWidth,
                        height: this.offsetHeight
                    });
                });
            }
            Snap._.$(el.node, set);
        }
        return el;
    };
    /*\
     * Paper.ellipse
     [ method ]
     **
     * Draws an ellipse
     **
     - x (number) x coordinate of the centre
     - y (number) y coordinate of the centre
     - rx (number) horizontal radius
     - ry (number) vertical radius
     = (object) the `ellipse` element
     **
     > Usage
     | var c = paper.ellipse(50, 50, 40, 20);
    \*/
    proto.ellipse = function (cx, cy, rx, ry) {
        var attr;
        if (is(cx, "object") && cx == "[object Object]") {
            attr = cx;
        } else if (cx != null) {
            attr ={
                cx: cx,
                cy: cy,
                rx: rx,
                ry: ry
            };
        }
        return this.el("ellipse", attr);
    };
    // SIERRA Paper.path(): Unclear from the link what a Catmull-Rom curveto is, and why it would make life any easier.
    /*\
     * Paper.path
     [ method ]
     **
     * Creates a `<path>` element using the given string as the path's definition
     - pathString (string) #optional path string in SVG format
     * Path string consists of one-letter commands, followed by comma seprarated arguments in numerical form. Example:
     | "M10,20L30,40"
     * This example features two commands: `M`, with arguments `(10, 20)` and `L` with arguments `(30, 40)`. Uppercase letter commands express coordinates in absolute terms, while lowercase commands express them in relative terms from the most recently declared coordinates.
     *
     # <p>Here is short list of commands available, for more details see <a href="http://www.w3.org/TR/SVG/paths.html#PathData" title="Details of a path's data attribute's format are described in the SVG specification.">SVG path string format</a> or <a href="https://developer.mozilla.org/en/SVG/Tutorial/Paths">article about path strings at MDN</a>.</p>
     # <table><thead><tr><th>Command</th><th>Name</th><th>Parameters</th></tr></thead><tbody>
     # <tr><td>M</td><td>moveto</td><td>(x y)+</td></tr>
     # <tr><td>Z</td><td>closepath</td><td>(none)</td></tr>
     # <tr><td>L</td><td>lineto</td><td>(x y)+</td></tr>
     # <tr><td>H</td><td>horizontal lineto</td><td>x+</td></tr>
     # <tr><td>V</td><td>vertical lineto</td><td>y+</td></tr>
     # <tr><td>C</td><td>curveto</td><td>(x1 y1 x2 y2 x y)+</td></tr>
     # <tr><td>S</td><td>smooth curveto</td><td>(x2 y2 x y)+</td></tr>
     # <tr><td>Q</td><td>quadratic Bézier curveto</td><td>(x1 y1 x y)+</td></tr>
     # <tr><td>T</td><td>smooth quadratic Bézier curveto</td><td>(x y)+</td></tr>
     # <tr><td>A</td><td>elliptical arc</td><td>(rx ry x-axis-rotation large-arc-flag sweep-flag x y)+</td></tr>
     # <tr><td>R</td><td><a href="http://en.wikipedia.org/wiki/Catmull–Rom_spline#Catmull.E2.80.93Rom_spline">Catmull-Rom curveto</a>*</td><td>x1 y1 (x y)+</td></tr></tbody></table>
     * * _Catmull-Rom curveto_ is a not standard SVG command and added to make life easier.
     * Note: there is a special case when a path consists of only three commands: `M10,10R…z`. In this case the path connects back to its starting point.
     > Usage
     | var c = paper.path("M10 10L90 90");
     | // draw a diagonal line:
     | // move to 10,10, line to 90,90
    \*/
    proto.path = function (d) {
        var attr;
        if (is(d, "object") && !is(d, "array")) {
            attr = d;
        } else if (d) {
            attr = {d: d};
        }
        return this.el("path", attr);
    };
    /*\
     * Paper.g
     [ method ]
     **
     * Creates a group element
     **
     - varargs (…) #optional elements to nest within the group
     = (object) the `g` element
     **
     > Usage
     | var c1 = paper.circle(),
     |     c2 = paper.rect(),
     |     g = paper.g(c2, c1); // note that the order of elements is different
     * or
     | var c1 = paper.circle(),
     |     c2 = paper.rect(),
     |     g = paper.g();
     | g.add(c2, c1);
    \*/
    /*\
     * Paper.group
     [ method ]
     **
     * See @Paper.g
    \*/
    proto.group = proto.g = function (first) {
        var attr,
            el = this.el("g");
        if (arguments.length == 1 && first && !first.type) {
            el.attr(first);
        } else if (arguments.length) {
            el.add(Array.prototype.slice.call(arguments, 0));
        }
        return el;
    };
    /*\
     * Paper.svg
     [ method ]
     **
     * Creates a nested SVG element.
     - x (number) @optional X of the element
     - y (number) @optional Y of the element
     - width (number) @optional width of the element
     - height (number) @optional height of the element
     - vbx (number) @optional viewbox X
     - vby (number) @optional viewbox Y
     - vbw (number) @optional viewbox width
     - vbh (number) @optional viewbox height
     **
     = (object) the `svg` element
     **
    \*/
    proto.svg = function (x, y, width, height, vbx, vby, vbw, vbh) {
        var attrs = {};
        if (is(x, "object") && y == null) {
            attrs = x;
        } else {
            if (x != null) {
                attrs.x = x;
            }
            if (y != null) {
                attrs.y = y;
            }
            if (width != null) {
                attrs.width = width;
            }
            if (height != null) {
                attrs.height = height;
            }
            if (vbx != null && vby != null && vbw != null && vbh != null) {
                attrs.viewBox = [vbx, vby, vbw, vbh];
            }
        }
        return this.el("svg", attrs);
    };
    /*\
     * Paper.mask
     [ method ]
     **
     * Equivalent in behaviour to @Paper.g, except it’s a mask.
     **
     = (object) the `mask` element
     **
    \*/
    proto.mask = function (first) {
        var attr,
            el = this.el("mask");
        if (arguments.length == 1 && first && !first.type) {
            el.attr(first);
        } else if (arguments.length) {
            el.add(Array.prototype.slice.call(arguments, 0));
        }
        return el;
    };
    /*\
     * Paper.ptrn
     [ method ]
     **
     * Equivalent in behaviour to @Paper.g, except it’s a pattern.
     - x (number) @optional X of the element
     - y (number) @optional Y of the element
     - width (number) @optional width of the element
     - height (number) @optional height of the element
     - vbx (number) @optional viewbox X
     - vby (number) @optional viewbox Y
     - vbw (number) @optional viewbox width
     - vbh (number) @optional viewbox height
     **
     = (object) the `pattern` element
     **
    \*/
    proto.ptrn = function (x, y, width, height, vx, vy, vw, vh) {
        if (is(x, "object")) {
            var attr = x;
        } else {
            attr = {patternUnits: "userSpaceOnUse"};
            if (x) {
                attr.x = x;
            }
            if (y) {
                attr.y = y;
            }
            if (width != null) {
                attr.width = width;
            }
            if (height != null) {
                attr.height = height;
            }
            if (vx != null && vy != null && vw != null && vh != null) {
                attr.viewBox = [vx, vy, vw, vh];
            } else {
                attr.viewBox = [x || 0, y || 0, width || 0, height || 0];
            }
        }
        return this.el("pattern", attr);
    };
    /*\
     * Paper.use
     [ method ]
     **
     * Creates a <use> element.
     - id (string) @optional id of element to link
     * or
     - id (Element) @optional element to link
     **
     = (object) the `use` element
     **
    \*/
    proto.use = function (id) {
        if (id != null) {
            if (id instanceof Element) {
                if (!id.attr("id")) {
                    id.attr({id: Snap._.id(id)});
                }
                id = id.attr("id");
            }
            if (String(id).charAt() == "#") {
                id = id.substring(1);
            }
            return this.el("use", {"xlink:href": "#" + id});
        } else {
            return Element.prototype.use.call(this);
        }
    };
    /*\
     * Paper.symbol
     [ method ]
     **
     * Creates a <symbol> element.
     - vbx (number) @optional viewbox X
     - vby (number) @optional viewbox Y
     - vbw (number) @optional viewbox width
     - vbh (number) @optional viewbox height
     = (object) the `symbol` element
     **
    \*/
    proto.symbol = function (vx, vy, vw, vh) {
        var attr = {};
        if (vx != null && vy != null && vw != null && vh != null) {
            attr.viewBox = [vx, vy, vw, vh];
        }

        return this.el("symbol", attr);
    };
    /*\
     * Paper.text
     [ method ]
     **
     * Draws a text string
     **
     - x (number) x coordinate position
     - y (number) y coordinate position
     - text (string|array) The text string to draw or array of strings to nest within separate `<tspan>` elements
     = (object) the `text` element
     **
     > Usage
     | var t1 = paper.text(50, 50, "Snap");
     | var t2 = paper.text(50, 50, ["S","n","a","p"]);
     | // Text path usage
     | t1.attr({textpath: "M10,10L100,100"});
     | // or
     | var pth = paper.path("M10,10L100,100");
     | t1.attr({textpath: pth});
    \*/
    proto.text = function (x, y, text) {
        var attr = {};
        if (is(x, "object")) {
            attr = x;
        } else if (x != null) {
            attr = {
                x: x,
                y: y,
                text: text || ""
            };
        }
        return this.el("text", attr);
    };
    /*\
     * Paper.line
     [ method ]
     **
     * Draws a line
     **
     - x1 (number) x coordinate position of the start
     - y1 (number) y coordinate position of the start
     - x2 (number) x coordinate position of the end
     - y2 (number) y coordinate position of the end
     = (object) the `line` element
     **
     > Usage
     | var t1 = paper.line(50, 50, 100, 100);
    \*/
    proto.line = function (x1, y1, x2, y2) {
        var attr = {};
        if (is(x1, "object")) {
            attr = x1;
        } else if (x1 != null) {
            attr = {
                x1: x1,
                x2: x2,
                y1: y1,
                y2: y2
            };
        }
        return this.el("line", attr);
    };
    /*\
     * Paper.polyline
     [ method ]
     **
     * Draws a polyline
     **
     - points (array) array of points
     * or
     - varargs (…) points
     = (object) the `polyline` element
     **
     > Usage
     | var p1 = paper.polyline([10, 10, 100, 100]);
     | var p2 = paper.polyline(10, 10, 100, 100);
    \*/
    proto.polyline = function (points) {
        if (arguments.length > 1) {
            points = Array.prototype.slice.call(arguments, 0);
        }
        var attr = {};
        if (is(points, "object") && !is(points, "array")) {
            attr = points;
        } else if (points != null) {
            attr = {points: points};
        }
        return this.el("polyline", attr);
    };
    /*\
     * Paper.polygon
     [ method ]
     **
     * Draws a polygon. See @Paper.polyline
    \*/
    proto.polygon = function (points) {
        if (arguments.length > 1) {
            points = Array.prototype.slice.call(arguments, 0);
        }
        var attr = {};
        if (is(points, "object") && !is(points, "array")) {
            attr = points;
        } else if (points != null) {
            attr = {points: points};
        }
        return this.el("polygon", attr);
    };
    // gradients
    (function () {
        var $ = Snap._.$;
        // gradients' helpers
        /*\
         * Element.stops
         [ method ]
         **
         * Only for gradients!
         * Returns array of gradient stops elements.
         = (array) the stops array.
        \*/
        function Gstops() {
            return this.selectAll("stop");
        }
        /*\
         * Element.addStop
         [ method ]
         **
         * Only for gradients!
         * Adds another stop to the gradient.
         - color (string) stops color
         - offset (number) stops offset 0..100
         = (object) gradient element
        \*/
        function GaddStop(color, offset) {
            var stop = $("stop"),
                attr = {
                    offset: +offset + "%"
                };
            color = Snap.color(color);
            attr["stop-color"] = color.hex;
            if (color.opacity < 1) {
                attr["stop-opacity"] = color.opacity;
            }
            $(stop, attr);
            var stops = this.stops(),
                inserted;
            for (var i = 0; i < stops.length; i++) {
                var stopOffset = parseFloat(stops[i].attr("offset"));
                if (stopOffset > offset) {
                    this.node.insertBefore(stop, stops[i].node);
                    inserted = true;
                    break;
                }
            }
            if (!inserted) {
                this.node.appendChild(stop);
            }
            return this;
        }
        function GgetBBox() {
            if (this.type == "linearGradient") {
                var x1 = $(this.node, "x1") || 0,
                    x2 = $(this.node, "x2") || 1,
                    y1 = $(this.node, "y1") || 0,
                    y2 = $(this.node, "y2") || 0;
                return Snap._.box(x1, y1, math.abs(x2 - x1), math.abs(y2 - y1));
            } else {
                var cx = this.node.cx || .5,
                    cy = this.node.cy || .5,
                    r = this.node.r || 0;
                return Snap._.box(cx - r, cy - r, r * 2, r * 2);
            }
        }
        /*\
         * Element.setStops
         [ method ]
         **
         * Only for gradients!
         * Updates stops of the gradient based on passed gradient descriptor. See @Ppaer.gradient
         - str (string) gradient descriptor part after `()`.
         = (object) gradient element
         | var g = paper.gradient("l(0, 0, 1, 1)#000-#f00-#fff");
         | g.setStops("#fff-#000-#f00-#fc0");
        \*/
        function GsetStops(str) {
            var grad = str,
                stops = this.stops();
            if (typeof str == "string") {
                grad = eve("snap.util.grad.parse", null, "l(0,0,0,1)" + str).firstDefined().stops;
            }
            if (!Snap.is(grad, "array")) {
                return;
            }
            for (var i = 0; i < stops.length; i++) {
                if (grad[i]) {
                    var color = Snap.color(grad[i].color),
                        attr = {"offset": grad[i].offset + "%"};
                    attr["stop-color"] = color.hex;
                    if (color.opacity < 1) {
                        attr["stop-opacity"] = color.opacity;
                    }
                    stops[i].attr(attr);
                } else {
                    stops[i].remove();
                }
            }
            for (i = stops.length; i < grad.length; i++) {
                this.addStop(grad[i].color, grad[i].offset);
            }
            return this;
        }
        function gradient(defs, str) {
            var grad = eve("snap.util.grad.parse", null, str).firstDefined(),
                el;
            if (!grad) {
                return null;
            }
            grad.params.unshift(defs);
            if (grad.type.toLowerCase() == "l") {
                el = gradientLinear.apply(0, grad.params);
            } else {
                el = gradientRadial.apply(0, grad.params);
            }
            if (grad.type != grad.type.toLowerCase()) {
                $(el.node, {
                    gradientUnits: "userSpaceOnUse"
                });
            }
            var stops = grad.stops,
                len = stops.length;
            for (var i = 0; i < len; i++) {
                var stop = stops[i];
                el.addStop(stop.color, stop.offset);
            }
            return el;
        }
        function gradientLinear(defs, x1, y1, x2, y2) {
            var el = Snap._.make("linearGradient", defs);
            el.stops = Gstops;
            el.addStop = GaddStop;
            el.getBBox = GgetBBox;
            el.setStops = GsetStops;
            if (x1 != null) {
                $(el.node, {
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2
                });
            }
            return el;
        }
        function gradientRadial(defs, cx, cy, r, fx, fy) {
            var el = Snap._.make("radialGradient", defs);
            el.stops = Gstops;
            el.addStop = GaddStop;
            el.getBBox = GgetBBox;
            if (cx != null) {
                $(el.node, {
                    cx: cx,
                    cy: cy,
                    r: r
                });
            }
            if (fx != null && fy != null) {
                $(el.node, {
                    fx: fx,
                    fy: fy
                });
            }
            return el;
        }
        /*\
         * Paper.gradient
         [ method ]
         **
         * Creates a gradient element
         **
         - gradient (string) gradient descriptor
         > Gradient Descriptor
         * The gradient descriptor is an expression formatted as
         * follows: `<type>(<coords>)<colors>`.  The `<type>` can be
         * either linear or radial.  The uppercase `L` or `R` letters
         * indicate absolute coordinates offset from the SVG surface.
         * Lowercase `l` or `r` letters indicate coordinates
         * calculated relative to the element to which the gradient is
         * applied.  Coordinates specify a linear gradient vector as
         * `x1`, `y1`, `x2`, `y2`, or a radial gradient as `cx`, `cy`,
         * `r` and optional `fx`, `fy` specifying a focal point away
         * from the center of the circle. Specify `<colors>` as a list
         * of dash-separated CSS color values.  Each color may be
         * followed by a custom offset value, separated with a colon
         * character.
         > Examples
         * Linear gradient, relative from top-left corner to bottom-right
         * corner, from black through red to white:
         | var g = paper.gradient("l(0, 0, 1, 1)#000-#f00-#fff");
         * Linear gradient, absolute from (0, 0) to (100, 100), from black
         * through red at 25% to white:
         | var g = paper.gradient("L(0, 0, 100, 100)#000-#f00:25-#fff");
         * Radial gradient, relative from the center of the element with radius
         * half the width, from black to white:
         | var g = paper.gradient("r(0.5, 0.5, 0.5)#000-#fff");
         * To apply the gradient:
         | paper.circle(50, 50, 40).attr({
         |     fill: g
         | });
         = (object) the `gradient` element
        \*/
        proto.gradient = function (str) {
            return gradient(this.defs, str);
        };
        proto.gradientLinear = function (x1, y1, x2, y2) {
            return gradientLinear(this.defs, x1, y1, x2, y2);
        };
        proto.gradientRadial = function (cx, cy, r, fx, fy) {
            return gradientRadial(this.defs, cx, cy, r, fx, fy);
        };
        /*\
         * Paper.toString
         [ method ]
         **
         * Returns SVG code for the @Paper
         = (string) SVG code for the @Paper
        \*/
        proto.toString = function () {
            var doc = this.node.ownerDocument,
                f = doc.createDocumentFragment(),
                d = doc.createElement("div"),
                svg = this.node.cloneNode(true),
                res;
            f.appendChild(d);
            d.appendChild(svg);
            Snap._.$(svg, {xmlns: "http://www.w3.org/2000/svg"});
            res = d.innerHTML;
            f.removeChild(f.firstChild);
            return res;
        };
        /*\
         * Paper.toDataURL
         [ method ]
         **
         * Returns SVG code for the @Paper as Data URI string.
         = (string) Data URI string
        \*/
        proto.toDataURL = function () {
            if (window && window.btoa) {
                return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(this)));
            }
        };
        /*\
         * Paper.clear
         [ method ]
         **
         * Removes all child nodes of the paper, except <defs>.
        \*/
        proto.clear = function () {
            var node = this.node.firstChild,
                next;
            while (node) {
                next = node.nextSibling;
                if (node.tagName != "defs") {
                    node.parentNode.removeChild(node);
                } else {
                    proto.clear.call({node: node});
                }
                node = next;
            }
        };
    }());
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob) {
    var elproto = Element.prototype,
        is = Snap.is,
        clone = Snap._.clone,
        has = "hasOwnProperty",
        p2s = /,?([a-z]),?/gi,
        toFloat = parseFloat,
        math = Math,
        PI = math.PI,
        mmin = math.min,
        mmax = math.max,
        pow = math.pow,
        abs = math.abs;
    function paths(ps) {
        var p = paths.ps = paths.ps || {};
        if (p[ps]) {
            p[ps].sleep = 100;
        } else {
            p[ps] = {
                sleep: 100
            };
        }
        setTimeout(function () {
            for (var key in p) if (p[has](key) && key != ps) {
                p[key].sleep--;
                !p[key].sleep && delete p[key];
            }
        });
        return p[ps];
    }
    function box(x, y, width, height) {
        if (x == null) {
            x = y = width = height = 0;
        }
        if (y == null) {
            y = x.y;
            width = x.width;
            height = x.height;
            x = x.x;
        }
        return {
            x: x,
            y: y,
            width: width,
            w: width,
            height: height,
            h: height,
            x2: x + width,
            y2: y + height,
            cx: x + width / 2,
            cy: y + height / 2,
            r1: math.min(width, height) / 2,
            r2: math.max(width, height) / 2,
            r0: math.sqrt(width * width + height * height) / 2,
            path: rectPath(x, y, width, height),
            vb: [x, y, width, height].join(" ")
        };
    }
    function toString() {
        return this.join(",").replace(p2s, "$1");
    }
    function pathClone(pathArray) {
        var res = clone(pathArray);
        res.toString = toString;
        return res;
    }
    function getPointAtSegmentLength(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length) {
        if (length == null) {
            return bezlen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y);
        } else {
            return findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y,
                getTotLen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length));
        }
    }
    function getLengthFactory(istotal, subpath) {
        function O(val) {
            return +(+val).toFixed(3);
        }
        return Snap._.cacher(function (path, length, onlystart) {
            if (path instanceof Element) {
                path = path.attr("d");
            }
            path = path2curve(path);
            var x, y, p, l, sp = "", subpaths = {}, point,
                len = 0;
            for (var i = 0, ii = path.length; i < ii; i++) {
                p = path[i];
                if (p[0] == "M") {
                    x = +p[1];
                    y = +p[2];
                } else {
                    l = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
                    if (len + l > length) {
                        if (subpath && !subpaths.start) {
                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
                            sp += [
                                "C" + O(point.start.x),
                                O(point.start.y),
                                O(point.m.x),
                                O(point.m.y),
                                O(point.x),
                                O(point.y)
                            ];
                            if (onlystart) {return sp;}
                            subpaths.start = sp;
                            sp = [
                                "M" + O(point.x),
                                O(point.y) + "C" + O(point.n.x),
                                O(point.n.y),
                                O(point.end.x),
                                O(point.end.y),
                                O(p[5]),
                                O(p[6])
                            ].join();
                            len += l;
                            x = +p[5];
                            y = +p[6];
                            continue;
                        }
                        if (!istotal && !subpath) {
                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
                            return point;
                        }
                    }
                    len += l;
                    x = +p[5];
                    y = +p[6];
                }
                sp += p.shift() + p;
            }
            subpaths.end = sp;
            point = istotal ? len : subpath ? subpaths : findDotsAtSegment(x, y, p[0], p[1], p[2], p[3], p[4], p[5], 1);
            return point;
        }, null, Snap._.clone);
    }
    var getTotalLength = getLengthFactory(1),
        getPointAtLength = getLengthFactory(),
        getSubpathsAtLength = getLengthFactory(0, 1);
    function findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
        var t1 = 1 - t,
            t13 = pow(t1, 3),
            t12 = pow(t1, 2),
            t2 = t * t,
            t3 = t2 * t,
            x = t13 * p1x + t12 * 3 * t * c1x + t1 * 3 * t * t * c2x + t3 * p2x,
            y = t13 * p1y + t12 * 3 * t * c1y + t1 * 3 * t * t * c2y + t3 * p2y,
            mx = p1x + 2 * t * (c1x - p1x) + t2 * (c2x - 2 * c1x + p1x),
            my = p1y + 2 * t * (c1y - p1y) + t2 * (c2y - 2 * c1y + p1y),
            nx = c1x + 2 * t * (c2x - c1x) + t2 * (p2x - 2 * c2x + c1x),
            ny = c1y + 2 * t * (c2y - c1y) + t2 * (p2y - 2 * c2y + c1y),
            ax = t1 * p1x + t * c1x,
            ay = t1 * p1y + t * c1y,
            cx = t1 * c2x + t * p2x,
            cy = t1 * c2y + t * p2y,
            alpha = 90 - math.atan2(mx - nx, my - ny) * 180 / PI;
        // (mx > nx || my < ny) && (alpha += 180);
        return {
            x: x,
            y: y,
            m: {x: mx, y: my},
            n: {x: nx, y: ny},
            start: {x: ax, y: ay},
            end: {x: cx, y: cy},
            alpha: alpha
        };
    }
    function bezierBBox(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) {
        if (!Snap.is(p1x, "array")) {
            p1x = [p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y];
        }
        var bbox = curveDim.apply(null, p1x);
        return box(
            bbox.min.x,
            bbox.min.y,
            bbox.max.x - bbox.min.x,
            bbox.max.y - bbox.min.y
        );
    }
    function isPointInsideBBox(bbox, x, y) {
        return  x >= bbox.x &&
                x <= bbox.x + bbox.width &&
                y >= bbox.y &&
                y <= bbox.y + bbox.height;
    }
    function isBBoxIntersect(bbox1, bbox2) {
        bbox1 = box(bbox1);
        bbox2 = box(bbox2);
        return isPointInsideBBox(bbox2, bbox1.x, bbox1.y)
            || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y)
            || isPointInsideBBox(bbox2, bbox1.x, bbox1.y2)
            || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y2)
            || isPointInsideBBox(bbox1, bbox2.x, bbox2.y)
            || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y)
            || isPointInsideBBox(bbox1, bbox2.x, bbox2.y2)
            || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y2)
            || (bbox1.x < bbox2.x2 && bbox1.x > bbox2.x
                || bbox2.x < bbox1.x2 && bbox2.x > bbox1.x)
            && (bbox1.y < bbox2.y2 && bbox1.y > bbox2.y
                || bbox2.y < bbox1.y2 && bbox2.y > bbox1.y);
    }
    function base3(t, p1, p2, p3, p4) {
        var t1 = -3 * p1 + 9 * p2 - 9 * p3 + 3 * p4,
            t2 = t * t1 + 6 * p1 - 12 * p2 + 6 * p3;
        return t * t2 - 3 * p1 + 3 * p2;
    }
    function bezlen(x1, y1, x2, y2, x3, y3, x4, y4, z) {
        if (z == null) {
            z = 1;
        }
        z = z > 1 ? 1 : z < 0 ? 0 : z;
        var z2 = z / 2,
            n = 12,
            Tvalues = [-.1252,.1252,-.3678,.3678,-.5873,.5873,-.7699,.7699,-.9041,.9041,-.9816,.9816],
            Cvalues = [0.2491,0.2491,0.2335,0.2335,0.2032,0.2032,0.1601,0.1601,0.1069,0.1069,0.0472,0.0472],
            sum = 0;
        for (var i = 0; i < n; i++) {
            var ct = z2 * Tvalues[i] + z2,
                xbase = base3(ct, x1, x2, x3, x4),
                ybase = base3(ct, y1, y2, y3, y4),
                comb = xbase * xbase + ybase * ybase;
            sum += Cvalues[i] * math.sqrt(comb);
        }
        return z2 * sum;
    }
    function getTotLen(x1, y1, x2, y2, x3, y3, x4, y4, ll) {
        if (ll < 0 || bezlen(x1, y1, x2, y2, x3, y3, x4, y4) < ll) {
            return;
        }
        var t = 1,
            step = t / 2,
            t2 = t - step,
            l,
            e = .01;
        l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
        while (abs(l - ll) > e) {
            step /= 2;
            t2 += (l < ll ? 1 : -1) * step;
            l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
        }
        return t2;
    }
    function intersect(x1, y1, x2, y2, x3, y3, x4, y4) {
        if (
            mmax(x1, x2) < mmin(x3, x4) ||
            mmin(x1, x2) > mmax(x3, x4) ||
            mmax(y1, y2) < mmin(y3, y4) ||
            mmin(y1, y2) > mmax(y3, y4)
        ) {
            return;
        }
        var nx = (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4),
            ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4),
            denominator = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);

        if (!denominator) {
            return;
        }
        var px = nx / denominator,
            py = ny / denominator,
            px2 = +px.toFixed(2),
            py2 = +py.toFixed(2);
        if (
            px2 < +mmin(x1, x2).toFixed(2) ||
            px2 > +mmax(x1, x2).toFixed(2) ||
            px2 < +mmin(x3, x4).toFixed(2) ||
            px2 > +mmax(x3, x4).toFixed(2) ||
            py2 < +mmin(y1, y2).toFixed(2) ||
            py2 > +mmax(y1, y2).toFixed(2) ||
            py2 < +mmin(y3, y4).toFixed(2) ||
            py2 > +mmax(y3, y4).toFixed(2)
        ) {
            return;
        }
        return {x: px, y: py};
    }
    function inter(bez1, bez2) {
        return interHelper(bez1, bez2);
    }
    function interCount(bez1, bez2) {
        return interHelper(bez1, bez2, 1);
    }
    function interHelper(bez1, bez2, justCount) {
        var bbox1 = bezierBBox(bez1),
            bbox2 = bezierBBox(bez2);
        if (!isBBoxIntersect(bbox1, bbox2)) {
            return justCount ? 0 : [];
        }
        var l1 = bezlen.apply(0, bez1),
            l2 = bezlen.apply(0, bez2),
            n1 = ~~(l1 / 8),
            n2 = ~~(l2 / 8),
            dots1 = [],
            dots2 = [],
            xy = {},
            res = justCount ? 0 : [];
        for (var i = 0; i < n1 + 1; i++) {
            var p = findDotsAtSegment.apply(0, bez1.concat(i / n1));
            dots1.push({x: p.x, y: p.y, t: i / n1});
        }
        for (i = 0; i < n2 + 1; i++) {
            p = findDotsAtSegment.apply(0, bez2.concat(i / n2));
            dots2.push({x: p.x, y: p.y, t: i / n2});
        }
        for (i = 0; i < n1; i++) {
            for (var j = 0; j < n2; j++) {
                var di = dots1[i],
                    di1 = dots1[i + 1],
                    dj = dots2[j],
                    dj1 = dots2[j + 1],
                    ci = abs(di1.x - di.x) < .001 ? "y" : "x",
                    cj = abs(dj1.x - dj.x) < .001 ? "y" : "x",
                    is = intersect(di.x, di.y, di1.x, di1.y, dj.x, dj.y, dj1.x, dj1.y);
                if (is) {
                    if (xy[is.x.toFixed(4)] == is.y.toFixed(4)) {
                        continue;
                    }
                    xy[is.x.toFixed(4)] = is.y.toFixed(4);
                    var t1 = di.t + abs((is[ci] - di[ci]) / (di1[ci] - di[ci])) * (di1.t - di.t),
                        t2 = dj.t + abs((is[cj] - dj[cj]) / (dj1[cj] - dj[cj])) * (dj1.t - dj.t);
                    if (t1 >= 0 && t1 <= 1 && t2 >= 0 && t2 <= 1) {
                        if (justCount) {
                            res++;
                        } else {
                            res.push({
                                x: is.x,
                                y: is.y,
                                t1: t1,
                                t2: t2
                            });
                        }
                    }
                }
            }
        }
        return res;
    }
    function pathIntersection(path1, path2) {
        return interPathHelper(path1, path2);
    }
    function pathIntersectionNumber(path1, path2) {
        return interPathHelper(path1, path2, 1);
    }
    function interPathHelper(path1, path2, justCount) {
        path1 = path2curve(path1);
        path2 = path2curve(path2);
        var x1, y1, x2, y2, x1m, y1m, x2m, y2m, bez1, bez2,
            res = justCount ? 0 : [];
        for (var i = 0, ii = path1.length; i < ii; i++) {
            var pi = path1[i];
            if (pi[0] == "M") {
                x1 = x1m = pi[1];
                y1 = y1m = pi[2];
            } else {
                if (pi[0] == "C") {
                    bez1 = [x1, y1].concat(pi.slice(1));
                    x1 = bez1[6];
                    y1 = bez1[7];
                } else {
                    bez1 = [x1, y1, x1, y1, x1m, y1m, x1m, y1m];
                    x1 = x1m;
                    y1 = y1m;
                }
                for (var j = 0, jj = path2.length; j < jj; j++) {
                    var pj = path2[j];
                    if (pj[0] == "M") {
                        x2 = x2m = pj[1];
                        y2 = y2m = pj[2];
                    } else {
                        if (pj[0] == "C") {
                            bez2 = [x2, y2].concat(pj.slice(1));
                            x2 = bez2[6];
                            y2 = bez2[7];
                        } else {
                            bez2 = [x2, y2, x2, y2, x2m, y2m, x2m, y2m];
                            x2 = x2m;
                            y2 = y2m;
                        }
                        var intr = interHelper(bez1, bez2, justCount);
                        if (justCount) {
                            res += intr;
                        } else {
                            for (var k = 0, kk = intr.length; k < kk; k++) {
                                intr[k].segment1 = i;
                                intr[k].segment2 = j;
                                intr[k].bez1 = bez1;
                                intr[k].bez2 = bez2;
                            }
                            res = res.concat(intr);
                        }
                    }
                }
            }
        }
        return res;
    }
    function isPointInsidePath(path, x, y) {
        var bbox = pathBBox(path);
        return isPointInsideBBox(bbox, x, y) &&
               interPathHelper(path, [["M", x, y], ["H", bbox.x2 + 10]], 1) % 2 == 1;
    }
    function pathBBox(path) {
        var pth = paths(path);
        if (pth.bbox) {
            return clone(pth.bbox);
        }
        if (!path) {
            return box();
        }
        path = path2curve(path);
        var x = 0,
            y = 0,
            X = [],
            Y = [],
            p;
        for (var i = 0, ii = path.length; i < ii; i++) {
            p = path[i];
            if (p[0] == "M") {
                x = p[1];
                y = p[2];
                X.push(x);
                Y.push(y);
            } else {
                var dim = curveDim(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
                X = X.concat(dim.min.x, dim.max.x);
                Y = Y.concat(dim.min.y, dim.max.y);
                x = p[5];
                y = p[6];
            }
        }
        var xmin = mmin.apply(0, X),
            ymin = mmin.apply(0, Y),
            xmax = mmax.apply(0, X),
            ymax = mmax.apply(0, Y),
            bb = box(xmin, ymin, xmax - xmin, ymax - ymin);
        pth.bbox = clone(bb);
        return bb;
    }
    function rectPath(x, y, w, h, r) {
        if (r) {
            return [
                ["M", +x + +r, y],
                ["l", w - r * 2, 0],
                ["a", r, r, 0, 0, 1, r, r],
                ["l", 0, h - r * 2],
                ["a", r, r, 0, 0, 1, -r, r],
                ["l", r * 2 - w, 0],
                ["a", r, r, 0, 0, 1, -r, -r],
                ["l", 0, r * 2 - h],
                ["a", r, r, 0, 0, 1, r, -r],
                ["z"]
            ];
        }
        var res = [["M", x, y], ["l", w, 0], ["l", 0, h], ["l", -w, 0], ["z"]];
        res.toString = toString;
        return res;
    }
    function ellipsePath(x, y, rx, ry, a) {
        if (a == null && ry == null) {
            ry = rx;
        }
        x = +x;
        y = +y;
        rx = +rx;
        ry = +ry;
        if (a != null) {
            var rad = Math.PI / 180,
                x1 = x + rx * Math.cos(-ry * rad),
                x2 = x + rx * Math.cos(-a * rad),
                y1 = y + rx * Math.sin(-ry * rad),
                y2 = y + rx * Math.sin(-a * rad),
                res = [["M", x1, y1], ["A", rx, rx, 0, +(a - ry > 180), 0, x2, y2]];
        } else {
            res = [
                ["M", x, y],
                ["m", 0, -ry],
                ["a", rx, ry, 0, 1, 1, 0, 2 * ry],
                ["a", rx, ry, 0, 1, 1, 0, -2 * ry],
                ["z"]
            ];
        }
        res.toString = toString;
        return res;
    }
    var unit2px = Snap._unit2px,
        getPath = {
        path: function (el) {
            return el.attr("path");
        },
        circle: function (el) {
            var attr = unit2px(el);
            return ellipsePath(attr.cx, attr.cy, attr.r);
        },
        ellipse: function (el) {
            var attr = unit2px(el);
            return ellipsePath(attr.cx || 0, attr.cy || 0, attr.rx, attr.ry);
        },
        rect: function (el) {
            var attr = unit2px(el);
            return rectPath(attr.x || 0, attr.y || 0, attr.width, attr.height, attr.rx, attr.ry);
        },
        image: function (el) {
            var attr = unit2px(el);
            return rectPath(attr.x || 0, attr.y || 0, attr.width, attr.height);
        },
        line: function (el) {
            return "M" + [el.attr("x1") || 0, el.attr("y1") || 0, el.attr("x2"), el.attr("y2")];
        },
        polyline: function (el) {
            return "M" + el.attr("points");
        },
        polygon: function (el) {
            return "M" + el.attr("points") + "z";
        },
        deflt: function (el) {
            var bbox = el.node.getBBox();
            return rectPath(bbox.x, bbox.y, bbox.width, bbox.height);
        }
    };
    function pathToRelative(pathArray) {
        var pth = paths(pathArray),
            lowerCase = String.prototype.toLowerCase;
        if (pth.rel) {
            return pathClone(pth.rel);
        }
        if (!Snap.is(pathArray, "array") || !Snap.is(pathArray && pathArray[0], "array")) {
            pathArray = Snap.parsePathString(pathArray);
        }
        var res = [],
            x = 0,
            y = 0,
            mx = 0,
            my = 0,
            start = 0;
        if (pathArray[0][0] == "M") {
            x = pathArray[0][1];
            y = pathArray[0][2];
            mx = x;
            my = y;
            start++;
            res.push(["M", x, y]);
        }
        for (var i = start, ii = pathArray.length; i < ii; i++) {
            var r = res[i] = [],
                pa = pathArray[i];
            if (pa[0] != lowerCase.call(pa[0])) {
                r[0] = lowerCase.call(pa[0]);
                switch (r[0]) {
                    case "a":
                        r[1] = pa[1];
                        r[2] = pa[2];
                        r[3] = pa[3];
                        r[4] = pa[4];
                        r[5] = pa[5];
                        r[6] = +(pa[6] - x).toFixed(3);
                        r[7] = +(pa[7] - y).toFixed(3);
                        break;
                    case "v":
                        r[1] = +(pa[1] - y).toFixed(3);
                        break;
                    case "m":
                        mx = pa[1];
                        my = pa[2];
                    default:
                        for (var j = 1, jj = pa.length; j < jj; j++) {
                            r[j] = +(pa[j] - (j % 2 ? x : y)).toFixed(3);
                        }
                }
            } else {
                r = res[i] = [];
                if (pa[0] == "m") {
                    mx = pa[1] + x;
                    my = pa[2] + y;
                }
                for (var k = 0, kk = pa.length; k < kk; k++) {
                    res[i][k] = pa[k];
                }
            }
            var len = res[i].length;
            switch (res[i][0]) {
                case "z":
                    x = mx;
                    y = my;
                    break;
                case "h":
                    x += +res[i][len - 1];
                    break;
                case "v":
                    y += +res[i][len - 1];
                    break;
                default:
                    x += +res[i][len - 2];
                    y += +res[i][len - 1];
            }
        }
        res.toString = toString;
        pth.rel = pathClone(res);
        return res;
    }
    function pathToAbsolute(pathArray) {
        var pth = paths(pathArray);
        if (pth.abs) {
            return pathClone(pth.abs);
        }
        if (!is(pathArray, "array") || !is(pathArray && pathArray[0], "array")) { // rough assumption
            pathArray = Snap.parsePathString(pathArray);
        }
        if (!pathArray || !pathArray.length) {
            return [["M", 0, 0]];
        }
        var res = [],
            x = 0,
            y = 0,
            mx = 0,
            my = 0,
            start = 0,
            pa0;
        if (pathArray[0][0] == "M") {
            x = +pathArray[0][1];
            y = +pathArray[0][2];
            mx = x;
            my = y;
            start++;
            res[0] = ["M", x, y];
        }
        var crz = pathArray.length == 3 &&
            pathArray[0][0] == "M" &&
            pathArray[1][0].toUpperCase() == "R" &&
            pathArray[2][0].toUpperCase() == "Z";
        for (var r, pa, i = start, ii = pathArray.length; i < ii; i++) {
            res.push(r = []);
            pa = pathArray[i];
            pa0 = pa[0];
            if (pa0 != pa0.toUpperCase()) {
                r[0] = pa0.toUpperCase();
                switch (r[0]) {
                    case "A":
                        r[1] = pa[1];
                        r[2] = pa[2];
                        r[3] = pa[3];
                        r[4] = pa[4];
                        r[5] = pa[5];
                        r[6] = +pa[6] + x;
                        r[7] = +pa[7] + y;
                        break;
                    case "V":
                        r[1] = +pa[1] + y;
                        break;
                    case "H":
                        r[1] = +pa[1] + x;
                        break;
                    case "R":
                        var dots = [x, y].concat(pa.slice(1));
                        for (var j = 2, jj = dots.length; j < jj; j++) {
                            dots[j] = +dots[j] + x;
                            dots[++j] = +dots[j] + y;
                        }
                        res.pop();
                        res = res.concat(catmullRom2bezier(dots, crz));
                        break;
                    case "O":
                        res.pop();
                        dots = ellipsePath(x, y, pa[1], pa[2]);
                        dots.push(dots[0]);
                        res = res.concat(dots);
                        break;
                    case "U":
                        res.pop();
                        res = res.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
                        r = ["U"].concat(res[res.length - 1].slice(-2));
                        break;
                    case "M":
                        mx = +pa[1] + x;
                        my = +pa[2] + y;
                    default:
                        for (j = 1, jj = pa.length; j < jj; j++) {
                            r[j] = +pa[j] + (j % 2 ? x : y);
                        }
                }
            } else if (pa0 == "R") {
                dots = [x, y].concat(pa.slice(1));
                res.pop();
                res = res.concat(catmullRom2bezier(dots, crz));
                r = ["R"].concat(pa.slice(-2));
            } else if (pa0 == "O") {
                res.pop();
                dots = ellipsePath(x, y, pa[1], pa[2]);
                dots.push(dots[0]);
                res = res.concat(dots);
            } else if (pa0 == "U") {
                res.pop();
                res = res.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
                r = ["U"].concat(res[res.length - 1].slice(-2));
            } else {
                for (var k = 0, kk = pa.length; k < kk; k++) {
                    r[k] = pa[k];
                }
            }
            pa0 = pa0.toUpperCase();
            if (pa0 != "O") {
                switch (r[0]) {
                    case "Z":
                        x = +mx;
                        y = +my;
                        break;
                    case "H":
                        x = r[1];
                        break;
                    case "V":
                        y = r[1];
                        break;
                    case "M":
                        mx = r[r.length - 2];
                        my = r[r.length - 1];
                    default:
                        x = r[r.length - 2];
                        y = r[r.length - 1];
                }
            }
        }
        res.toString = toString;
        pth.abs = pathClone(res);
        return res;
    }
    function l2c(x1, y1, x2, y2) {
        return [x1, y1, x2, y2, x2, y2];
    }
    function q2c(x1, y1, ax, ay, x2, y2) {
        var _13 = 1 / 3,
            _23 = 2 / 3;
        return [
                _13 * x1 + _23 * ax,
                _13 * y1 + _23 * ay,
                _13 * x2 + _23 * ax,
                _13 * y2 + _23 * ay,
                x2,
                y2
            ];
    }
    function a2c(x1, y1, rx, ry, angle, large_arc_flag, sweep_flag, x2, y2, recursive) {
        // for more information of where this math came from visit:
        // http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
        var _120 = PI * 120 / 180,
            rad = PI / 180 * (+angle || 0),
            res = [],
            xy,
            rotate = Snap._.cacher(function (x, y, rad) {
                var X = x * math.cos(rad) - y * math.sin(rad),
                    Y = x * math.sin(rad) + y * math.cos(rad);
                return {x: X, y: Y};
            });
        if (!rx || !ry) {
            return [x1, y1, x2, y2, x2, y2];
        }
        if (!recursive) {
            xy = rotate(x1, y1, -rad);
            x1 = xy.x;
            y1 = xy.y;
            xy = rotate(x2, y2, -rad);
            x2 = xy.x;
            y2 = xy.y;
            var cos = math.cos(PI / 180 * angle),
                sin = math.sin(PI / 180 * angle),
                x = (x1 - x2) / 2,
                y = (y1 - y2) / 2;
            var h = x * x / (rx * rx) + y * y / (ry * ry);
            if (h > 1) {
                h = math.sqrt(h);
                rx = h * rx;
                ry = h * ry;
            }
            var rx2 = rx * rx,
                ry2 = ry * ry,
                k = (large_arc_flag == sweep_flag ? -1 : 1) *
                    math.sqrt(abs((rx2 * ry2 - rx2 * y * y - ry2 * x * x) / (rx2 * y * y + ry2 * x * x))),
                cx = k * rx * y / ry + (x1 + x2) / 2,
                cy = k * -ry * x / rx + (y1 + y2) / 2,
                f1 = math.asin(((y1 - cy) / ry).toFixed(9)),
                f2 = math.asin(((y2 - cy) / ry).toFixed(9));

            f1 = x1 < cx ? PI - f1 : f1;
            f2 = x2 < cx ? PI - f2 : f2;
            f1 < 0 && (f1 = PI * 2 + f1);
            f2 < 0 && (f2 = PI * 2 + f2);
            if (sweep_flag && f1 > f2) {
                f1 = f1 - PI * 2;
            }
            if (!sweep_flag && f2 > f1) {
                f2 = f2 - PI * 2;
            }
        } else {
            f1 = recursive[0];
            f2 = recursive[1];
            cx = recursive[2];
            cy = recursive[3];
        }
        var df = f2 - f1;
        if (abs(df) > _120) {
            var f2old = f2,
                x2old = x2,
                y2old = y2;
            f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1);
            x2 = cx + rx * math.cos(f2);
            y2 = cy + ry * math.sin(f2);
            res = a2c(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old, [f2, f2old, cx, cy]);
        }
        df = f2 - f1;
        var c1 = math.cos(f1),
            s1 = math.sin(f1),
            c2 = math.cos(f2),
            s2 = math.sin(f2),
            t = math.tan(df / 4),
            hx = 4 / 3 * rx * t,
            hy = 4 / 3 * ry * t,
            m1 = [x1, y1],
            m2 = [x1 + hx * s1, y1 - hy * c1],
            m3 = [x2 + hx * s2, y2 - hy * c2],
            m4 = [x2, y2];
        m2[0] = 2 * m1[0] - m2[0];
        m2[1] = 2 * m1[1] - m2[1];
        if (recursive) {
            return [m2, m3, m4].concat(res);
        } else {
            res = [m2, m3, m4].concat(res).join().split(",");
            var newres = [];
            for (var i = 0, ii = res.length; i < ii; i++) {
                newres[i] = i % 2 ? rotate(res[i - 1], res[i], rad).y : rotate(res[i], res[i + 1], rad).x;
            }
            return newres;
        }
    }
    function findDotAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
        var t1 = 1 - t;
        return {
            x: pow(t1, 3) * p1x + pow(t1, 2) * 3 * t * c1x + t1 * 3 * t * t * c2x + pow(t, 3) * p2x,
            y: pow(t1, 3) * p1y + pow(t1, 2) * 3 * t * c1y + t1 * 3 * t * t * c2y + pow(t, 3) * p2y
        };
    }

    // Returns bounding box of cubic bezier curve.
    // Source: http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
    // Original version: NISHIO Hirokazu
    // Modifications: https://github.com/timo22345
    function curveDim(x0, y0, x1, y1, x2, y2, x3, y3) {
        var tvalues = [],
            bounds = [[], []],
            a, b, c, t, t1, t2, b2ac, sqrtb2ac;
        for (var i = 0; i < 2; ++i) {
            if (i == 0) {
                b = 6 * x0 - 12 * x1 + 6 * x2;
                a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
                c = 3 * x1 - 3 * x0;
            } else {
                b = 6 * y0 - 12 * y1 + 6 * y2;
                a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
                c = 3 * y1 - 3 * y0;
            }
            if (abs(a) < 1e-12) {
                if (abs(b) < 1e-12) {
                    continue;
                }
                t = -c / b;
                if (0 < t && t < 1) {
                    tvalues.push(t);
                }
                continue;
            }
            b2ac = b * b - 4 * c * a;
            sqrtb2ac = math.sqrt(b2ac);
            if (b2ac < 0) {
                continue;
            }
            t1 = (-b + sqrtb2ac) / (2 * a);
            if (0 < t1 && t1 < 1) {
                tvalues.push(t1);
            }
            t2 = (-b - sqrtb2ac) / (2 * a);
            if (0 < t2 && t2 < 1) {
                tvalues.push(t2);
            }
        }

        var x, y, j = tvalues.length,
            jlen = j,
            mt;
        while (j--) {
            t = tvalues[j];
            mt = 1 - t;
            bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
            bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
        }

        bounds[0][jlen] = x0;
        bounds[1][jlen] = y0;
        bounds[0][jlen + 1] = x3;
        bounds[1][jlen + 1] = y3;
        bounds[0].length = bounds[1].length = jlen + 2;


        return {
          min: {x: mmin.apply(0, bounds[0]), y: mmin.apply(0, bounds[1])},
          max: {x: mmax.apply(0, bounds[0]), y: mmax.apply(0, bounds[1])}
        };
    }

    function path2curve(path, path2) {
        var pth = !path2 && paths(path);
        if (!path2 && pth.curve) {
            return pathClone(pth.curve);
        }
        var p = pathToAbsolute(path),
            p2 = path2 && pathToAbsolute(path2),
            attrs = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null},
            attrs2 = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null},
            processPath = function (path, d, pcom) {
                var nx, ny;
                if (!path) {
                    return ["C", d.x, d.y, d.x, d.y, d.x, d.y];
                }
                !(path[0] in {T: 1, Q: 1}) && (d.qx = d.qy = null);
                switch (path[0]) {
                    case "M":
                        d.X = path[1];
                        d.Y = path[2];
                        break;
                    case "A":
                        path = ["C"].concat(a2c.apply(0, [d.x, d.y].concat(path.slice(1))));
                        break;
                    case "S":
                        if (pcom == "C" || pcom == "S") { // In "S" case we have to take into account, if the previous command is C/S.
                            nx = d.x * 2 - d.bx;          // And reflect the previous
                            ny = d.y * 2 - d.by;          // command's control point relative to the current point.
                        }
                        else {                            // or some else or nothing
                            nx = d.x;
                            ny = d.y;
                        }
                        path = ["C", nx, ny].concat(path.slice(1));
                        break;
                    case "T":
                        if (pcom == "Q" || pcom == "T") { // In "T" case we have to take into account, if the previous command is Q/T.
                            d.qx = d.x * 2 - d.qx;        // And make a reflection similar
                            d.qy = d.y * 2 - d.qy;        // to case "S".
                        }
                        else {                            // or something else or nothing
                            d.qx = d.x;
                            d.qy = d.y;
                        }
                        path = ["C"].concat(q2c(d.x, d.y, d.qx, d.qy, path[1], path[2]));
                        break;
                    case "Q":
                        d.qx = path[1];
                        d.qy = path[2];
                        path = ["C"].concat(q2c(d.x, d.y, path[1], path[2], path[3], path[4]));
                        break;
                    case "L":
                        path = ["C"].concat(l2c(d.x, d.y, path[1], path[2]));
                        break;
                    case "H":
                        path = ["C"].concat(l2c(d.x, d.y, path[1], d.y));
                        break;
                    case "V":
                        path = ["C"].concat(l2c(d.x, d.y, d.x, path[1]));
                        break;
                    case "Z":
                        path = ["C"].concat(l2c(d.x, d.y, d.X, d.Y));
                        break;
                }
                return path;
            },
            fixArc = function (pp, i) {
                if (pp[i].length > 7) {
                    pp[i].shift();
                    var pi = pp[i];
                    while (pi.length) {
                        pcoms1[i] = "A"; // if created multiple C:s, their original seg is saved
                        p2 && (pcoms2[i] = "A"); // the same as above
                        pp.splice(i++, 0, ["C"].concat(pi.splice(0, 6)));
                    }
                    pp.splice(i, 1);
                    ii = mmax(p.length, p2 && p2.length || 0);
                }
            },
            fixM = function (path1, path2, a1, a2, i) {
                if (path1 && path2 && path1[i][0] == "M" && path2[i][0] != "M") {
                    path2.splice(i, 0, ["M", a2.x, a2.y]);
                    a1.bx = 0;
                    a1.by = 0;
                    a1.x = path1[i][1];
                    a1.y = path1[i][2];
                    ii = mmax(p.length, p2 && p2.length || 0);
                }
            },
            pcoms1 = [], // path commands of original path p
            pcoms2 = [], // path commands of original path p2
            pfirst = "", // temporary holder for original path command
            pcom = ""; // holder for previous path command of original path
        for (var i = 0, ii = mmax(p.length, p2 && p2.length || 0); i < ii; i++) {
            p[i] && (pfirst = p[i][0]); // save current path command

            if (pfirst != "C") // C is not saved yet, because it may be result of conversion
            {
                pcoms1[i] = pfirst; // Save current path command
                i && ( pcom = pcoms1[i - 1]); // Get previous path command pcom
            }
            p[i] = processPath(p[i], attrs, pcom); // Previous path command is inputted to processPath

            if (pcoms1[i] != "A" && pfirst == "C") pcoms1[i] = "C"; // A is the only command
            // which may produce multiple C:s
            // so we have to make sure that C is also C in original path

            fixArc(p, i); // fixArc adds also the right amount of A:s to pcoms1

            if (p2) { // the same procedures is done to p2
                p2[i] && (pfirst = p2[i][0]);
                if (pfirst != "C") {
                    pcoms2[i] = pfirst;
                    i && (pcom = pcoms2[i - 1]);
                }
                p2[i] = processPath(p2[i], attrs2, pcom);

                if (pcoms2[i] != "A" && pfirst == "C") {
                    pcoms2[i] = "C";
                }

                fixArc(p2, i);
            }
            fixM(p, p2, attrs, attrs2, i);
            fixM(p2, p, attrs2, attrs, i);
            var seg = p[i],
                seg2 = p2 && p2[i],
                seglen = seg.length,
                seg2len = p2 && seg2.length;
            attrs.x = seg[seglen - 2];
            attrs.y = seg[seglen - 1];
            attrs.bx = toFloat(seg[seglen - 4]) || attrs.x;
            attrs.by = toFloat(seg[seglen - 3]) || attrs.y;
            attrs2.bx = p2 && (toFloat(seg2[seg2len - 4]) || attrs2.x);
            attrs2.by = p2 && (toFloat(seg2[seg2len - 3]) || attrs2.y);
            attrs2.x = p2 && seg2[seg2len - 2];
            attrs2.y = p2 && seg2[seg2len - 1];
        }
        if (!p2) {
            pth.curve = pathClone(p);
        }
        return p2 ? [p, p2] : p;
    }
    function mapPath(path, matrix) {
        if (!matrix) {
            return path;
        }
        var x, y, i, j, ii, jj, pathi;
        path = path2curve(path);
        for (i = 0, ii = path.length; i < ii; i++) {
            pathi = path[i];
            for (j = 1, jj = pathi.length; j < jj; j += 2) {
                x = matrix.x(pathi[j], pathi[j + 1]);
                y = matrix.y(pathi[j], pathi[j + 1]);
                pathi[j] = x;
                pathi[j + 1] = y;
            }
        }
        return path;
    }

    // http://schepers.cc/getting-to-the-point
    function catmullRom2bezier(crp, z) {
        var d = [];
        for (var i = 0, iLen = crp.length; iLen - 2 * !z > i; i += 2) {
            var p = [
                        {x: +crp[i - 2], y: +crp[i - 1]},
                        {x: +crp[i],     y: +crp[i + 1]},
                        {x: +crp[i + 2], y: +crp[i + 3]},
                        {x: +crp[i + 4], y: +crp[i + 5]}
                    ];
            if (z) {
                if (!i) {
                    p[0] = {x: +crp[iLen - 2], y: +crp[iLen - 1]};
                } else if (iLen - 4 == i) {
                    p[3] = {x: +crp[0], y: +crp[1]};
                } else if (iLen - 2 == i) {
                    p[2] = {x: +crp[0], y: +crp[1]};
                    p[3] = {x: +crp[2], y: +crp[3]};
                }
            } else {
                if (iLen - 4 == i) {
                    p[3] = p[2];
                } else if (!i) {
                    p[0] = {x: +crp[i], y: +crp[i + 1]};
                }
            }
            d.push(["C",
                  (-p[0].x + 6 * p[1].x + p[2].x) / 6,
                  (-p[0].y + 6 * p[1].y + p[2].y) / 6,
                  (p[1].x + 6 * p[2].x - p[3].x) / 6,
                  (p[1].y + 6*p[2].y - p[3].y) / 6,
                  p[2].x,
                  p[2].y
            ]);
        }

        return d;
    }

    // export
    Snap.path = paths;

    /*\
     * Snap.path.getTotalLength
     [ method ]
     **
     * Returns the length of the given path in pixels
     **
     - path (string) SVG path string
     **
     = (number) length
    \*/
    Snap.path.getTotalLength = getTotalLength;
    /*\
     * Snap.path.getPointAtLength
     [ method ]
     **
     * Returns the coordinates of the point located at the given length along the given path
     **
     - path (string) SVG path string
     - length (number) length, in pixels, from the start of the path, excluding non-rendering jumps
     **
     = (object) representation of the point:
     o {
     o     x: (number) x coordinate,
     o     y: (number) y coordinate,
     o     alpha: (number) angle of derivative
     o }
    \*/
    Snap.path.getPointAtLength = getPointAtLength;
    /*\
     * Snap.path.getSubpath
     [ method ]
     **
     * Returns the subpath of a given path between given start and end lengths
     **
     - path (string) SVG path string
     - from (number) length, in pixels, from the start of the path to the start of the segment
     - to (number) length, in pixels, from the start of the path to the end of the segment
     **
     = (string) path string definition for the segment
    \*/
    Snap.path.getSubpath = function (path, from, to) {
        if (this.getTotalLength(path) - to < 1e-6) {
            return getSubpathsAtLength(path, from).end;
        }
        var a = getSubpathsAtLength(path, to, 1);
        return from ? getSubpathsAtLength(a, from).end : a;
    };
    /*\
     * Element.getTotalLength
     [ method ]
     **
     * Returns the length of the path in pixels (only works for `path` elements)
     = (number) length
    \*/
    elproto.getTotalLength = function () {
        if (this.node.getTotalLength) {
            return this.node.getTotalLength();
        }
    };
    // SIERRA Element.getPointAtLength()/Element.getTotalLength(): If a <path> is broken into different segments, is the jump distance to the new coordinates set by the _M_ or _m_ commands calculated as part of the path's total length?
    /*\
     * Element.getPointAtLength
     [ method ]
     **
     * Returns coordinates of the point located at the given length on the given path (only works for `path` elements)
     **
     - length (number) length, in pixels, from the start of the path, excluding non-rendering jumps
     **
     = (object) representation of the point:
     o {
     o     x: (number) x coordinate,
     o     y: (number) y coordinate,
     o     alpha: (number) angle of derivative
     o }
    \*/
    elproto.getPointAtLength = function (length) {
        return getPointAtLength(this.attr("d"), length);
    };
    // SIERRA Element.getSubpath(): Similar to the problem for Element.getPointAtLength(). Unclear how this would work for a segmented path. Overall, the concept of _subpath_ and what I'm calling a _segment_ (series of non-_M_ or _Z_ commands) is unclear.
    /*\
     * Element.getSubpath
     [ method ]
     **
     * Returns subpath of a given element from given start and end lengths (only works for `path` elements)
     **
     - from (number) length, in pixels, from the start of the path to the start of the segment
     - to (number) length, in pixels, from the start of the path to the end of the segment
     **
     = (string) path string definition for the segment
    \*/
    elproto.getSubpath = function (from, to) {
        return Snap.path.getSubpath(this.attr("d"), from, to);
    };
    Snap._.box = box;
    /*\
     * Snap.path.findDotsAtSegment
     [ method ]
     **
     * Utility method
     **
     * Finds dot coordinates on the given cubic beziér curve at the given t
     - p1x (number) x of the first point of the curve
     - p1y (number) y of the first point of the curve
     - c1x (number) x of the first anchor of the curve
     - c1y (number) y of the first anchor of the curve
     - c2x (number) x of the second anchor of the curve
     - c2y (number) y of the second anchor of the curve
     - p2x (number) x of the second point of the curve
     - p2y (number) y of the second point of the curve
     - t (number) position on the curve (0..1)
     = (object) point information in format:
     o {
     o     x: (number) x coordinate of the point,
     o     y: (number) y coordinate of the point,
     o     m: {
     o         x: (number) x coordinate of the left anchor,
     o         y: (number) y coordinate of the left anchor
     o     },
     o     n: {
     o         x: (number) x coordinate of the right anchor,
     o         y: (number) y coordinate of the right anchor
     o     },
     o     start: {
     o         x: (number) x coordinate of the start of the curve,
     o         y: (number) y coordinate of the start of the curve
     o     },
     o     end: {
     o         x: (number) x coordinate of the end of the curve,
     o         y: (number) y coordinate of the end of the curve
     o     },
     o     alpha: (number) angle of the curve derivative at the point
     o }
    \*/
    Snap.path.findDotsAtSegment = findDotsAtSegment;
    /*\
     * Snap.path.bezierBBox
     [ method ]
     **
     * Utility method
     **
     * Returns the bounding box of a given cubic beziér curve
     - p1x (number) x of the first point of the curve
     - p1y (number) y of the first point of the curve
     - c1x (number) x of the first anchor of the curve
     - c1y (number) y of the first anchor of the curve
     - c2x (number) x of the second anchor of the curve
     - c2y (number) y of the second anchor of the curve
     - p2x (number) x of the second point of the curve
     - p2y (number) y of the second point of the curve
     * or
     - bez (array) array of six points for beziér curve
     = (object) bounding box
     o {
     o     x: (number) x coordinate of the left top point of the box,
     o     y: (number) y coordinate of the left top point of the box,
     o     x2: (number) x coordinate of the right bottom point of the box,
     o     y2: (number) y coordinate of the right bottom point of the box,
     o     width: (number) width of the box,
     o     height: (number) height of the box
     o }
    \*/
    Snap.path.bezierBBox = bezierBBox;
    /*\
     * Snap.path.isPointInsideBBox
     [ method ]
     **
     * Utility method
     **
     * Returns `true` if given point is inside bounding box
     - bbox (string) bounding box
     - x (string) x coordinate of the point
     - y (string) y coordinate of the point
     = (boolean) `true` if point is inside
    \*/
    Snap.path.isPointInsideBBox = isPointInsideBBox;
    Snap.closest = function (x, y, X, Y) {
        var r = 100,
            b = box(x - r / 2, y - r / 2, r, r),
            inside = [],
            getter = X[0].hasOwnProperty("x") ? function (i) {
                return {
                    x: X[i].x,
                    y: X[i].y
                };
            } : function (i) {
                return {
                    x: X[i],
                    y: Y[i]
                };
            },
            found = 0;
        while (r <= 1e6 && !found) {
            for (var i = 0, ii = X.length; i < ii; i++) {
                var xy = getter(i);
                if (isPointInsideBBox(b, xy.x, xy.y)) {
                    found++;
                    inside.push(xy);
                    break;
                }
            }
            if (!found) {
                r *= 2;
                b = box(x - r / 2, y - r / 2, r, r)
            }
        }
        if (r == 1e6) {
            return;
        }
        var len = Infinity,
            res;
        for (i = 0, ii = inside.length; i < ii; i++) {
            var l = Snap.len(x, y, inside[i].x, inside[i].y);
            if (len > l) {
                len = l;
                inside[i].len = l;
                res = inside[i];
            }
        }
        return res;
    };
    /*\
     * Snap.path.isBBoxIntersect
     [ method ]
     **
     * Utility method
     **
     * Returns `true` if two bounding boxes intersect
     - bbox1 (string) first bounding box
     - bbox2 (string) second bounding box
     = (boolean) `true` if bounding boxes intersect
    \*/
    Snap.path.isBBoxIntersect = isBBoxIntersect;
    /*\
     * Snap.path.intersection
     [ method ]
     **
     * Utility method
     **
     * Finds intersections of two paths
     - path1 (string) path string
     - path2 (string) path string
     = (array) dots of intersection
     o [
     o     {
     o         x: (number) x coordinate of the point,
     o         y: (number) y coordinate of the point,
     o         t1: (number) t value for segment of path1,
     o         t2: (number) t value for segment of path2,
     o         segment1: (number) order number for segment of path1,
     o         segment2: (number) order number for segment of path2,
     o         bez1: (array) eight coordinates representing beziér curve for the segment of path1,
     o         bez2: (array) eight coordinates representing beziér curve for the segment of path2
     o     }
     o ]
    \*/
    Snap.path.intersection = pathIntersection;
    Snap.path.intersectionNumber = pathIntersectionNumber;
    /*\
     * Snap.path.isPointInside
     [ method ]
     **
     * Utility method
     **
     * Returns `true` if given point is inside a given closed path.
     *
     * Note: fill mode doesn’t affect the result of this method.
     - path (string) path string
     - x (number) x of the point
     - y (number) y of the point
     = (boolean) `true` if point is inside the path
    \*/
    Snap.path.isPointInside = isPointInsidePath;
    /*\
     * Snap.path.getBBox
     [ method ]
     **
     * Utility method
     **
     * Returns the bounding box of a given path
     - path (string) path string
     = (object) bounding box
     o {
     o     x: (number) x coordinate of the left top point of the box,
     o     y: (number) y coordinate of the left top point of the box,
     o     x2: (number) x coordinate of the right bottom point of the box,
     o     y2: (number) y coordinate of the right bottom point of the box,
     o     width: (number) width of the box,
     o     height: (number) height of the box
     o }
    \*/
    Snap.path.getBBox = pathBBox;
    Snap.path.get = getPath;
    /*\
     * Snap.path.toRelative
     [ method ]
     **
     * Utility method
     **
     * Converts path coordinates into relative values
     - path (string) path string
     = (array) path string
    \*/
    Snap.path.toRelative = pathToRelative;
    /*\
     * Snap.path.toAbsolute
     [ method ]
     **
     * Utility method
     **
     * Converts path coordinates into absolute values
     - path (string) path string
     = (array) path string
    \*/
    Snap.path.toAbsolute = pathToAbsolute;
    /*\
     * Snap.path.toCubic
     [ method ]
     **
     * Utility method
     **
     * Converts path to a new path where all segments are cubic beziér curves
     - pathString (string|array) path string or array of segments
     = (array) array of segments
    \*/
    Snap.path.toCubic = path2curve;
    /*\
     * Snap.path.map
     [ method ]
     **
     * Transform the path string with the given matrix
     - path (string) path string
     - matrix (object) see @Matrix
     = (string) transformed path string
    \*/
    Snap.path.map = mapPath;
    Snap.path.toString = toString;
    Snap.path.clone = pathClone;
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob) {
    var mmax = Math.max,
        mmin = Math.min;

    // Set
    var Set = function (items) {
        this.items = [];
	this.bindings = {};
        this.length = 0;
        this.type = "set";
        if (items) {
            for (var i = 0, ii = items.length; i < ii; i++) {
                if (items[i]) {
                    this[this.items.length] = this.items[this.items.length] = items[i];
                    this.length++;
                }
            }
        }
    },
    setproto = Set.prototype;
    /*\
     * Set.push
     [ method ]
     **
     * Adds each argument to the current set
     = (object) original element
    \*/
    setproto.push = function () {
        var item,
            len;
        for (var i = 0, ii = arguments.length; i < ii; i++) {
            item = arguments[i];
            if (item) {
                len = this.items.length;
                this[len] = this.items[len] = item;
                this.length++;
            }
        }
        return this;
    };
    /*\
     * Set.pop
     [ method ]
     **
     * Removes last element and returns it
     = (object) element
    \*/
    setproto.pop = function () {
        this.length && delete this[this.length--];
        return this.items.pop();
    };
    /*\
     * Set.forEach
     [ method ]
     **
     * Executes given function for each element in the set
     *
     * If the function returns `false`, the loop stops running.
     **
     - callback (function) function to run
     - thisArg (object) context object for the callback
     = (object) Set object
    \*/
    setproto.forEach = function (callback, thisArg) {
        for (var i = 0, ii = this.items.length; i < ii; i++) {
            if (callback.call(thisArg, this.items[i], i) === false) {
                return this;
            }
        }
        return this;
    };
    /*\
     * Set.animate
     [ method ]
     **
     * Animates each element in set in sync.
     *
     **
     - attrs (object) key-value pairs of destination attributes
     - duration (number) duration of the animation in milliseconds
     - easing (function) #optional easing function from @mina or custom
     - callback (function) #optional callback function that executes when the animation ends
     * or
     - animation (array) array of animation parameter for each element in set in format `[attrs, duration, easing, callback]`
     > Usage
     | // animate all elements in set to radius 10
     | set.animate({r: 10}, 500, mina.easein);
     | // or
     | // animate first element to radius 10, but second to radius 20 and in different time
     | set.animate([{r: 10}, 500, mina.easein], [{r: 20}, 1500, mina.easein]);
     = (Element) the current element
    \*/
    setproto.animate = function (attrs, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
            callback = easing;
            easing = mina.linear;
        }
        if (attrs instanceof Snap._.Animation) {
            callback = attrs.callback;
            easing = attrs.easing;
            ms = easing.dur;
            attrs = attrs.attr;
        }
        var args = arguments;
        if (Snap.is(attrs, "array") && Snap.is(args[args.length - 1], "array")) {
            var each = true;
        }
        var begin,
            handler = function () {
                if (begin) {
                    this.b = begin;
                } else {
                    begin = this.b;
                }
            },
            cb = 0,
            set = this,
            callbacker = callback && function () {
                if (++cb == set.length) {
                    callback.call(this);
                }
            };
        return this.forEach(function (el, i) {
            eve.once("snap.animcreated." + el.id, handler);
            if (each) {
                args[i] && el.animate.apply(el, args[i]);
            } else {
                el.animate(attrs, ms, easing, callbacker);
            }
        });
    };
    /*\
     * Set.remove
     [ method ]
     **
     * Removes all children of the set.
     *
     = (object) Set object
    \*/
    setproto.remove = function () {
        while (this.length) {
            this.pop().remove();
        }
        return this;
    };
    /*\
     * Set.bind
     [ method ]
     **
     * Specifies how to handle a specific attribute when applied
     * to a set.
     *
     **
     - attr (string) attribute name
     - callback (function) function to run
     * or
     - attr (string) attribute name
     - element (Element) specific element in the set to apply the attribute to
     * or
     - attr (string) attribute name
     - element (Element) specific element in the set to apply the attribute to
     - eattr (string) attribute on the element to bind the attribute to
     = (object) Set object
    \*/
    setproto.bind = function (attr, a, b) {
        var data = {};
        if (typeof a == "function") {
            this.bindings[attr] = a;
        } else {
            var aname = b || attr;
            this.bindings[attr] = function (v) {
                data[aname] = v;
                a.attr(data);
            };
        }
        return this;
    };
    /*\
     * Set.attr
     [ method ]
     **
     * Equivalent of @Element.attr.
     = (object) Set object
    \*/
    setproto.attr = function (value) {
        var unbound = {};
        for (var k in value) {
            if (this.bindings[k]) {
                this.bindings[k](value[k]);
            } else {
                unbound[k] = value[k];
            }
        }
        for (var i = 0, ii = this.items.length; i < ii; i++) {
            this.items[i].attr(unbound);
        }
        return this;
    };
    /*\
     * Set.clear
     [ method ]
     **
     * Removes all elements from the set
    \*/
    setproto.clear = function () {
        while (this.length) {
            this.pop();
        }
    };
    /*\
     * Set.splice
     [ method ]
     **
     * Removes range of elements from the set
     **
     - index (number) position of the deletion
     - count (number) number of element to remove
     - insertion… (object) #optional elements to insert
     = (object) set elements that were deleted
    \*/
    setproto.splice = function (index, count, insertion) {
        index = index < 0 ? mmax(this.length + index, 0) : index;
        count = mmax(0, mmin(this.length - index, count));
        var tail = [],
            todel = [],
            args = [],
            i;
        for (i = 2; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        for (i = 0; i < count; i++) {
            todel.push(this[index + i]);
        }
        for (; i < this.length - index; i++) {
            tail.push(this[index + i]);
        }
        var arglen = args.length;
        for (i = 0; i < arglen + tail.length; i++) {
            this.items[index + i] = this[index + i] = i < arglen ? args[i] : tail[i - arglen];
        }
        i = this.items.length = this.length -= count - arglen;
        while (this[i]) {
            delete this[i++];
        }
        return new Set(todel);
    };
    /*\
     * Set.exclude
     [ method ]
     **
     * Removes given element from the set
     **
     - element (object) element to remove
     = (boolean) `true` if object was found and removed from the set
    \*/
    setproto.exclude = function (el) {
        for (var i = 0, ii = this.length; i < ii; i++) if (this[i] == el) {
            this.splice(i, 1);
            return true;
        }
        return false;
    };
    /*\
     * Set.insertAfter
     [ method ]
     **
     * Inserts set elements after given element.
     **
     - element (object) set will be inserted after this element
     = (object) Set object
    \*/
    setproto.insertAfter = function (el) {
        var i = this.items.length;
        while (i--) {
            this.items[i].insertAfter(el);
        }
        return this;
    };
    /*\
     * Set.getBBox
     [ method ]
     **
     * Union of all bboxes of the set. See @Element.getBBox.
     = (object) bounding box descriptor. See @Element.getBBox.
    \*/
    setproto.getBBox = function () {
        var x = [],
            y = [],
            x2 = [],
            y2 = [];
        for (var i = this.items.length; i--;) if (!this.items[i].removed) {
            var box = this.items[i].getBBox();
            x.push(box.x);
            y.push(box.y);
            x2.push(box.x + box.width);
            y2.push(box.y + box.height);
        }
        x = mmin.apply(0, x);
        y = mmin.apply(0, y);
        x2 = mmax.apply(0, x2);
        y2 = mmax.apply(0, y2);
        return {
            x: x,
            y: y,
            x2: x2,
            y2: y2,
            width: x2 - x,
            height: y2 - y,
            cx: x + (x2 - x) / 2,
            cy: y + (y2 - y) / 2
        };
    };
    /*\
     * Set.insertAfter
     [ method ]
     **
     * Creates a clone of the set.
     **
     = (object) New Set object
    \*/
    setproto.clone = function (s) {
        s = new Set;
        for (var i = 0, ii = this.items.length; i < ii; i++) {
            s.push(this.items[i].clone());
        }
        return s;
    };
    setproto.toString = function () {
        return "Snap\u2018s set";
    };
    setproto.type = "set";
    // export
    /*\
     * Snap.Set
     [ property ]
     **
     * Set constructor.
    \*/
    Snap.Set = Set;
    /*\
     * Snap.set
     [ method ]
     **
     * Creates a set and fills it with list of arguments.
     **
     = (object) New Set object
     | var r = paper.rect(0, 0, 10, 10),
     |     s1 = Snap.set(), // empty set
     |     s2 = Snap.set(r, paper.circle(100, 100, 20)); // prefilled set
    \*/
    Snap.set = function () {
        var set = new Set;
        if (arguments.length) {
            set.push.apply(set, Array.prototype.slice.call(arguments, 0));
        }
        return set;
    };
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob) {
    var names = {},
        reUnit = /[%a-z]+$/i,
        Str = String;
    names.stroke = names.fill = "colour";
    function getEmpty(item) {
        var l = item[0];
        switch (l.toLowerCase()) {
            case "t": return [l, 0, 0];
            case "m": return [l, 1, 0, 0, 1, 0, 0];
            case "r": if (item.length == 4) {
                return [l, 0, item[2], item[3]];
            } else {
                return [l, 0];
            }
            case "s": if (item.length == 5) {
                return [l, 1, 1, item[3], item[4]];
            } else if (item.length == 3) {
                return [l, 1, 1];
            } else {
                return [l, 1];
            }
        }
    }
    function equaliseTransform(t1, t2, getBBox) {
        t1 = t1 || new Snap.Matrix;
        t2 = t2 || new Snap.Matrix;
        t1 = Snap.parseTransformString(t1.toTransformString()) || [];
        t2 = Snap.parseTransformString(t2.toTransformString()) || [];
        var maxlength = Math.max(t1.length, t2.length),
            from = [],
            to = [],
            i = 0, j, jj,
            tt1, tt2;
        for (; i < maxlength; i++) {
            tt1 = t1[i] || getEmpty(t2[i]);
            tt2 = t2[i] || getEmpty(tt1);
            if (tt1[0] != tt2[0] ||
                tt1[0].toLowerCase() == "r" && (tt1[2] != tt2[2] || tt1[3] != tt2[3]) ||
                tt1[0].toLowerCase() == "s" && (tt1[3] != tt2[3] || tt1[4] != tt2[4])
                ) {
                    t1 = Snap._.transform2matrix(t1, getBBox());
                    t2 = Snap._.transform2matrix(t2, getBBox());
                    from = [["m", t1.a, t1.b, t1.c, t1.d, t1.e, t1.f]];
                    to = [["m", t2.a, t2.b, t2.c, t2.d, t2.e, t2.f]];
                    break;
            }
            from[i] = [];
            to[i] = [];
            for (j = 0, jj = Math.max(tt1.length, tt2.length); j < jj; j++) {
                j in tt1 && (from[i][j] = tt1[j]);
                j in tt2 && (to[i][j] = tt2[j]);
            }
        }
        return {
            from: path2array(from),
            to: path2array(to),
            f: getPath(from)
        };
    }
    function getNumber(val) {
        return val;
    }
    function getUnit(unit) {
        return function (val) {
            return +val.toFixed(3) + unit;
        };
    }
    function getViewBox(val) {
        return val.join(" ");
    }
    function getColour(clr) {
        return Snap.rgb(clr[0], clr[1], clr[2], clr[3]);
    }
    function getPath(path) {
        var k = 0, i, ii, j, jj, out, a, b = [];
        for (i = 0, ii = path.length; i < ii; i++) {
            out = "[";
            a = ['"' + path[i][0] + '"'];
            for (j = 1, jj = path[i].length; j < jj; j++) {
                a[j] = "val[" + k++ + "]";
            }
            out += a + "]";
            b[i] = out;
        }
        return Function("val", "return Snap.path.toString.call([" + b + "])");
    }
    function path2array(path) {
        var out = [];
        for (var i = 0, ii = path.length; i < ii; i++) {
            for (var j = 1, jj = path[i].length; j < jj; j++) {
                out.push(path[i][j]);
            }
        }
        return out;
    }
    function isNumeric(obj) {
        return isFinite(obj);
    }
    function arrayEqual(arr1, arr2) {
        if (!Snap.is(arr1, "array") || !Snap.is(arr2, "array")) {
            return false;
        }
        return arr1.toString() == arr2.toString();
    }
    Element.prototype.equal = function (name, b) {
        return eve("snap.util.equal", this, name, b).firstDefined();
    };
    eve.on("snap.util.equal", function (name, b) {
        var A, B, a = Str(this.attr(name) || ""),
            el = this;
        if (names[name] == "colour") {
            A = Snap.color(a);
            B = Snap.color(b);
            return {
                from: [A.r, A.g, A.b, A.opacity],
                to: [B.r, B.g, B.b, B.opacity],
                f: getColour
            };
        }
        if (name == "viewBox") {
            A = this.attr(name).vb.split(" ").map(Number);
            B = b.split(" ").map(Number);
            return {
                from: A,
                to: B,
                f: getViewBox
            };
        }
        if (name == "transform" || name == "gradientTransform" || name == "patternTransform") {
            if (typeof b == "string") {
                b = Str(b).replace(/\.{3}|\u2026/g, a);
            }
            a = this.matrix;
            if (!Snap._.rgTransform.test(b)) {
                b = Snap._.transform2matrix(Snap._.svgTransform2string(b), this.getBBox());
            } else {
                b = Snap._.transform2matrix(b, this.getBBox());
            }
            return equaliseTransform(a, b, function () {
                return el.getBBox(1);
            });
        }
        if (name == "d" || name == "path") {
            A = Snap.path.toCubic(a, b);
            return {
                from: path2array(A[0]),
                to: path2array(A[1]),
                f: getPath(A[0])
            };
        }
        if (name == "points") {
            A = Str(a).split(Snap._.separator);
            B = Str(b).split(Snap._.separator);
            return {
                from: A,
                to: B,
                f: function (val) { return val; }
            };
        }
        if (isNumeric(a) && isNumeric(b)) {
            return {
                from: parseFloat(a),
                to: parseFloat(b),
                f: getNumber
            };
        }
        var aUnit = a.match(reUnit),
            bUnit = Str(b).match(reUnit);
        if (aUnit && arrayEqual(aUnit, bUnit)) {
            return {
                from: parseFloat(a),
                to: parseFloat(b),
                f: getUnit(aUnit)
            };
        } else {
            return {
                from: this.asPX(name),
                to: this.asPX(name, b),
                f: getNumber
            };
        }
    });
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
// http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob) {
    var elproto = Element.prototype,
    has = "hasOwnProperty",
    supportsTouch = "createTouch" in glob.doc,
    events = [
        "click", "dblclick", "mousedown", "mousemove", "mouseout",
        "mouseover", "mouseup", "touchstart", "touchmove", "touchend",
        "touchcancel"
    ],
    touchMap = {
        mousedown: "touchstart",
        mousemove: "touchmove",
        mouseup: "touchend"
    },
    getScroll = function (xy, el) {
        var name = xy == "y" ? "scrollTop" : "scrollLeft",
            doc = el && el.node ? el.node.ownerDocument : glob.doc;
        return doc[name in doc.documentElement ? "documentElement" : "body"][name];
    },
    preventDefault = function () {
        this.returnValue = false;
    },
    preventTouch = function () {
        return this.originalEvent.preventDefault();
    },
    stopPropagation = function () {
        this.cancelBubble = true;
    },
    stopTouch = function () {
        return this.originalEvent.stopPropagation();
    },
    addEvent = function (obj, type, fn, element) {
        var realName = supportsTouch && touchMap[type] ? touchMap[type] : type,
            f = function (e) {
                var scrollY = getScroll("y", element),
                    scrollX = getScroll("x", element);
                if (supportsTouch && touchMap[has](type)) {
                    for (var i = 0, ii = e.targetTouches && e.targetTouches.length; i < ii; i++) {
                        if (e.targetTouches[i].target == obj || obj.contains(e.targetTouches[i].target)) {
                            var olde = e;
                            e = e.targetTouches[i];
                            e.originalEvent = olde;
                            e.preventDefault = preventTouch;
                            e.stopPropagation = stopTouch;
                            break;
                        }
                    }
                }
                var x = e.clientX + scrollX,
                    y = e.clientY + scrollY;
                return fn.call(element, e, x, y);
            };

        if (type !== realName) {
            obj.addEventListener(type, f, false);
        }

        obj.addEventListener(realName, f, false);

        return function () {
            if (type !== realName) {
                obj.removeEventListener(type, f, false);
            }

            obj.removeEventListener(realName, f, false);
            return true;
        };
    },
    drag = [],
    dragMove = function (e) {
        var x = e.clientX,
            y = e.clientY,
            scrollY = getScroll("y"),
            scrollX = getScroll("x"),
            dragi,
            j = drag.length;
        while (j--) {
            dragi = drag[j];
            if (supportsTouch) {
                var i = e.touches && e.touches.length,
                    touch;
                while (i--) {
                    touch = e.touches[i];
                    if (touch.identifier == dragi.el._drag.id || dragi.el.node.contains(touch.target)) {
                        x = touch.clientX;
                        y = touch.clientY;
                        (e.originalEvent ? e.originalEvent : e).preventDefault();
                        break;
                    }
                }
            } else {
                e.preventDefault();
            }
            var node = dragi.el.node,
                o,
                next = node.nextSibling,
                parent = node.parentNode,
                display = node.style.display;
            // glob.win.opera && parent.removeChild(node);
            // node.style.display = "none";
            // o = dragi.el.paper.getElementByPoint(x, y);
            // node.style.display = display;
            // glob.win.opera && (next ? parent.insertBefore(node, next) : parent.appendChild(node));
            // o && eve("snap.drag.over." + dragi.el.id, dragi.el, o);
            x += scrollX;
            y += scrollY;
            eve("snap.drag.move." + dragi.el.id, dragi.move_scope || dragi.el, x - dragi.el._drag.x, y - dragi.el._drag.y, x, y, e);
        }
    },
    dragUp = function (e) {
        Snap.unmousemove(dragMove).unmouseup(dragUp);
        var i = drag.length,
            dragi;
        while (i--) {
            dragi = drag[i];
            dragi.el._drag = {};
            eve("snap.drag.end." + dragi.el.id, dragi.end_scope || dragi.start_scope || dragi.move_scope || dragi.el, e);
            eve.off("snap.drag.*." + dragi.el.id);
        }
        drag = [];
    };
    /*\
     * Element.click
     [ method ]
     **
     * Adds a click event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unclick
     [ method ]
     **
     * Removes a click event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.dblclick
     [ method ]
     **
     * Adds a double click event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.undblclick
     [ method ]
     **
     * Removes a double click event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.mousedown
     [ method ]
     **
     * Adds a mousedown event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmousedown
     [ method ]
     **
     * Removes a mousedown event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.mousemove
     [ method ]
     **
     * Adds a mousemove event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmousemove
     [ method ]
     **
     * Removes a mousemove event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.mouseout
     [ method ]
     **
     * Adds a mouseout event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmouseout
     [ method ]
     **
     * Removes a mouseout event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.mouseover
     [ method ]
     **
     * Adds a mouseover event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmouseover
     [ method ]
     **
     * Removes a mouseover event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.mouseup
     [ method ]
     **
     * Adds a mouseup event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmouseup
     [ method ]
     **
     * Removes a mouseup event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.touchstart
     [ method ]
     **
     * Adds a touchstart event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.untouchstart
     [ method ]
     **
     * Removes a touchstart event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.touchmove
     [ method ]
     **
     * Adds a touchmove event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.untouchmove
     [ method ]
     **
     * Removes a touchmove event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.touchend
     [ method ]
     **
     * Adds a touchend event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.untouchend
     [ method ]
     **
     * Removes a touchend event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    
    /*\
     * Element.touchcancel
     [ method ]
     **
     * Adds a touchcancel event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.untouchcancel
     [ method ]
     **
     * Removes a touchcancel event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    for (var i = events.length; i--;) {
        (function (eventName) {
            Snap[eventName] = elproto[eventName] = function (fn, scope) {
                if (Snap.is(fn, "function")) {
                    this.events = this.events || [];
                    this.events.push({
                        name: eventName,
                        f: fn,
                        unbind: addEvent(this.node || document, eventName, fn, scope || this)
                    });
                } else {
                    for (var i = 0, ii = this.events.length; i < ii; i++) if (this.events[i].name == eventName) {
                        try {
                            this.events[i].f.call(this);
                        } catch (e) {}
                    }
                }
                return this;
            };
            Snap["un" + eventName] =
            elproto["un" + eventName] = function (fn) {
                var events = this.events || [],
                    l = events.length;
                while (l--) if (events[l].name == eventName &&
                               (events[l].f == fn || !fn)) {
                    events[l].unbind();
                    events.splice(l, 1);
                    !events.length && delete this.events;
                    return this;
                }
                return this;
            };
        })(events[i]);
    }
    /*\
     * Element.hover
     [ method ]
     **
     * Adds hover event handlers to the element
     - f_in (function) handler for hover in
     - f_out (function) handler for hover out
     - icontext (object) #optional context for hover in handler
     - ocontext (object) #optional context for hover out handler
     = (object) @Element
    \*/
    elproto.hover = function (f_in, f_out, scope_in, scope_out) {
        return this.mouseover(f_in, scope_in).mouseout(f_out, scope_out || scope_in);
    };
    /*\
     * Element.unhover
     [ method ]
     **
     * Removes hover event handlers from the element
     - f_in (function) handler for hover in
     - f_out (function) handler for hover out
     = (object) @Element
    \*/
    elproto.unhover = function (f_in, f_out) {
        return this.unmouseover(f_in).unmouseout(f_out);
    };
    var draggable = [];
    // SIERRA unclear what _context_ refers to for starting, ending, moving the drag gesture.
    // SIERRA Element.drag(): _x position of the mouse_: Where are the x/y values offset from?
    // SIERRA Element.drag(): much of this member's doc appears to be duplicated for some reason.
    // SIERRA Unclear about this sentence: _Additionally following drag events will be triggered: drag.start.<id> on start, drag.end.<id> on end and drag.move.<id> on every move._ Is there a global _drag_ object to which you can assign handlers keyed by an element's ID?
    /*\
     * Element.drag
     [ method ]
     **
     * Adds event handlers for an element's drag gesture
     **
     - onmove (function) handler for moving
     - onstart (function) handler for drag start
     - onend (function) handler for drag end
     - mcontext (object) #optional context for moving handler
     - scontext (object) #optional context for drag start handler
     - econtext (object) #optional context for drag end handler
     * Additionaly following `drag` events are triggered: `drag.start.<id>` on start, 
     * `drag.end.<id>` on end and `drag.move.<id>` on every move. When element is dragged over another element 
     * `drag.over.<id>` fires as well.
     *
     * Start event and start handler are called in specified context or in context of the element with following parameters:
     o x (number) x position of the mouse
     o y (number) y position of the mouse
     o event (object) DOM event object
     * Move event and move handler are called in specified context or in context of the element with following parameters:
     o dx (number) shift by x from the start point
     o dy (number) shift by y from the start point
     o x (number) x position of the mouse
     o y (number) y position of the mouse
     o event (object) DOM event object
     * End event and end handler are called in specified context or in context of the element with following parameters:
     o event (object) DOM event object
     = (object) @Element
    \*/
    elproto.drag = function (onmove, onstart, onend, move_scope, start_scope, end_scope) {
        var el = this;
        if (!arguments.length) {
            var origTransform;
            return el.drag(function (dx, dy) {
                this.attr({
                    transform: origTransform + (origTransform ? "T" : "t") + [dx, dy]
                });
            }, function () {
                origTransform = this.transform().local;
            });
        }
        function start(e, x, y) {
            (e.originalEvent || e).preventDefault();
            el._drag.x = x;
            el._drag.y = y;
            el._drag.id = e.identifier;
            !drag.length && Snap.mousemove(dragMove).mouseup(dragUp);
            drag.push({el: el, move_scope: move_scope, start_scope: start_scope, end_scope: end_scope});
            onstart && eve.on("snap.drag.start." + el.id, onstart);
            onmove && eve.on("snap.drag.move." + el.id, onmove);
            onend && eve.on("snap.drag.end." + el.id, onend);
            eve("snap.drag.start." + el.id, start_scope || move_scope || el, x, y, e);
        }
        function init(e, x, y) {
            eve("snap.draginit." + el.id, el, e, x, y);
        }
        eve.on("snap.draginit." + el.id, start);
        el._drag = {};
        draggable.push({el: el, start: start, init: init});
        el.mousedown(init);
        return el;
    };
    /*
     * Element.onDragOver
     [ method ]
     **
     * Shortcut to assign event handler for `drag.over.<id>` event, where `id` is the element's `id` (see @Element.id)
     - f (function) handler for event, first argument would be the element you are dragging over
    \*/
    // elproto.onDragOver = function (f) {
    //     f ? eve.on("snap.drag.over." + this.id, f) : eve.unbind("snap.drag.over." + this.id);
    // };
    /*\
     * Element.undrag
     [ method ]
     **
     * Removes all drag event handlers from the given element
    \*/
    elproto.undrag = function () {
        var i = draggable.length;
        while (i--) if (draggable[i].el == this) {
            this.unmousedown(draggable[i].init);
            draggable.splice(i, 1);
            eve.unbind("snap.drag.*." + this.id);
            eve.unbind("snap.draginit." + this.id);
        }
        !draggable.length && Snap.unmousemove(dragMove).unmouseup(dragUp);
        return this;
    };
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob) {
    var elproto = Element.prototype,
        pproto = Paper.prototype,
        rgurl = /^\s*url\((.+)\)/,
        Str = String,
        $ = Snap._.$;
    Snap.filter = {};
    /*\
     * Paper.filter
     [ method ]
     **
     * Creates a `<filter>` element
     **
     - filstr (string) SVG fragment of filter provided as a string
     = (object) @Element
     * Note: It is recommended to use filters embedded into the page inside an empty SVG element.
     > Usage
     | var f = paper.filter('<feGaussianBlur stdDeviation="2"/>'),
     |     c = paper.circle(10, 10, 10).attr({
     |         filter: f
     |     });
    \*/
    pproto.filter = function (filstr) {
        var paper = this;
        if (paper.type != "svg") {
            paper = paper.paper;
        }
        var f = Snap.parse(Str(filstr)),
            id = Snap._.id(),
            width = paper.node.offsetWidth,
            height = paper.node.offsetHeight,
            filter = $("filter");
        $(filter, {
            id: id,
            filterUnits: "userSpaceOnUse"
        });
        filter.appendChild(f.node);
        paper.defs.appendChild(filter);
        return new Element(filter);
    };

    eve.on("snap.util.getattr.filter", function () {
        eve.stop();
        var p = $(this.node, "filter");
        if (p) {
            var match = Str(p).match(rgurl);
            return match && Snap.select(match[1]);
        }
    });
    eve.on("snap.util.attr.filter", function (value) {
        if (value instanceof Element && value.type == "filter") {
            eve.stop();
            var id = value.node.id;
            if (!id) {
                $(value.node, {id: value.id});
                id = value.id;
            }
            $(this.node, {
                filter: Snap.url(id)
            });
        }
        if (!value || value == "none") {
            eve.stop();
            this.node.removeAttribute("filter");
        }
    });
    /*\
     * Snap.filter.blur
     [ method ]
     **
     * Returns an SVG markup string for the blur filter
     **
     - x (number) amount of horizontal blur, in pixels
     - y (number) #optional amount of vertical blur, in pixels
     = (string) filter representation
     > Usage
     | var f = paper.filter(Snap.filter.blur(5, 10)),
     |     c = paper.circle(10, 10, 10).attr({
     |         filter: f
     |     });
    \*/
    Snap.filter.blur = function (x, y) {
        if (x == null) {
            x = 2;
        }
        var def = y == null ? x : [x, y];
        return Snap.format('\<feGaussianBlur stdDeviation="{def}"/>', {
            def: def
        });
    };
    Snap.filter.blur.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.shadow
     [ method ]
     **
     * Returns an SVG markup string for the shadow filter
     **
     - dx (number) #optional horizontal shift of the shadow, in pixels
     - dy (number) #optional vertical shift of the shadow, in pixels
     - blur (number) #optional amount of blur
     - color (string) #optional color of the shadow
     - opacity (number) #optional `0..1` opacity of the shadow
     * or
     - dx (number) #optional horizontal shift of the shadow, in pixels
     - dy (number) #optional vertical shift of the shadow, in pixels
     - color (string) #optional color of the shadow
     - opacity (number) #optional `0..1` opacity of the shadow
     * which makes blur default to `4`. Or
     - dx (number) #optional horizontal shift of the shadow, in pixels
     - dy (number) #optional vertical shift of the shadow, in pixels
     - opacity (number) #optional `0..1` opacity of the shadow
     = (string) filter representation
     > Usage
     | var f = paper.filter(Snap.filter.shadow(0, 2, .3)),
     |     c = paper.circle(10, 10, 10).attr({
     |         filter: f
     |     });
    \*/
    Snap.filter.shadow = function (dx, dy, blur, color, opacity) {
        if (opacity == null) {
            if (color == null) {
                opacity = blur;
                blur = 4;
                color = "#000";
            } else {
                opacity = color;
                color = blur;
                blur = 4;
            }
        }
        if (blur == null) {
            blur = 4;
        }
        if (opacity == null) {
            opacity = 1;
        }
        if (dx == null) {
            dx = 0;
            dy = 2;
        }
        if (dy == null) {
            dy = dx;
        }
        color = Snap.color(color);
        return Snap.format('<feGaussianBlur in="SourceAlpha" stdDeviation="{blur}"/><feOffset dx="{dx}" dy="{dy}" result="offsetblur"/><feFlood flood-color="{color}"/><feComposite in2="offsetblur" operator="in"/><feComponentTransfer><feFuncA type="linear" slope="{opacity}"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>', {
            color: color,
            dx: dx,
            dy: dy,
            blur: blur,
            opacity: opacity
        });
    };
    Snap.filter.shadow.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.grayscale
     [ method ]
     **
     * Returns an SVG markup string for the grayscale filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.grayscale = function (amount) {
        if (amount == null) {
            amount = 1;
        }
        return Snap.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {b} {h} 0 0 0 0 0 1 0"/>', {
            a: 0.2126 + 0.7874 * (1 - amount),
            b: 0.7152 - 0.7152 * (1 - amount),
            c: 0.0722 - 0.0722 * (1 - amount),
            d: 0.2126 - 0.2126 * (1 - amount),
            e: 0.7152 + 0.2848 * (1 - amount),
            f: 0.0722 - 0.0722 * (1 - amount),
            g: 0.2126 - 0.2126 * (1 - amount),
            h: 0.0722 + 0.9278 * (1 - amount)
        });
    };
    Snap.filter.grayscale.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.sepia
     [ method ]
     **
     * Returns an SVG markup string for the sepia filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.sepia = function (amount) {
        if (amount == null) {
            amount = 1;
        }
        return Snap.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {h} {i} 0 0 0 0 0 1 0"/>', {
            a: 0.393 + 0.607 * (1 - amount),
            b: 0.769 - 0.769 * (1 - amount),
            c: 0.189 - 0.189 * (1 - amount),
            d: 0.349 - 0.349 * (1 - amount),
            e: 0.686 + 0.314 * (1 - amount),
            f: 0.168 - 0.168 * (1 - amount),
            g: 0.272 - 0.272 * (1 - amount),
            h: 0.534 - 0.534 * (1 - amount),
            i: 0.131 + 0.869 * (1 - amount)
        });
    };
    Snap.filter.sepia.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.saturate
     [ method ]
     **
     * Returns an SVG markup string for the saturate filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.saturate = function (amount) {
        if (amount == null) {
            amount = 1;
        }
        return Snap.format('<feColorMatrix type="saturate" values="{amount}"/>', {
            amount: 1 - amount
        });
    };
    Snap.filter.saturate.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.hueRotate
     [ method ]
     **
     * Returns an SVG markup string for the hue-rotate filter
     **
     - angle (number) angle of rotation
     = (string) filter representation
    \*/
    Snap.filter.hueRotate = function (angle) {
        angle = angle || 0;
        return Snap.format('<feColorMatrix type="hueRotate" values="{angle}"/>', {
            angle: angle
        });
    };
    Snap.filter.hueRotate.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.invert
     [ method ]
     **
     * Returns an SVG markup string for the invert filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.invert = function (amount) {
        if (amount == null) {
            amount = 1;
        }
//        <feColorMatrix type="matrix" values="-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0" color-interpolation-filters="sRGB"/>
        return Snap.format('<feComponentTransfer><feFuncR type="table" tableValues="{amount} {amount2}"/><feFuncG type="table" tableValues="{amount} {amount2}"/><feFuncB type="table" tableValues="{amount} {amount2}"/></feComponentTransfer>', {
            amount: amount,
            amount2: 1 - amount
        });
    };
    Snap.filter.invert.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.brightness
     [ method ]
     **
     * Returns an SVG markup string for the brightness filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.brightness = function (amount) {
        if (amount == null) {
            amount = 1;
        }
        return Snap.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}"/><feFuncG type="linear" slope="{amount}"/><feFuncB type="linear" slope="{amount}"/></feComponentTransfer>', {
            amount: amount
        });
    };
    Snap.filter.brightness.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.contrast
     [ method ]
     **
     * Returns an SVG markup string for the contrast filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.contrast = function (amount) {
        if (amount == null) {
            amount = 1;
        }
        return Snap.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}" intercept="{amount2}"/><feFuncG type="linear" slope="{amount}" intercept="{amount2}"/><feFuncB type="linear" slope="{amount}" intercept="{amount2}"/></feComponentTransfer>', {
            amount: amount,
            amount2: .5 - amount / 2
        });
    };
    Snap.filter.contrast.toString = function () {
        return this();
    };
});

// Copyright (c) 2014 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var box = Snap._.box,
        is = Snap.is,
        firstLetter = /^[^a-z]*([tbmlrc])/i,
        toString = function () {
            return "T" + this.dx + "," + this.dy;
        };
    /*\
     * Element.getAlign
     [ method ]
     **
     * Returns shift needed to align the element relatively to given element.
     * If no elements specified, parent `<svg>` container will be used.
     - el (object) @optional alignment element
     - way (string) one of six values: `"top"`, `"middle"`, `"bottom"`, `"left"`, `"center"`, `"right"`
     = (object|string) Object in format `{dx: , dy: }` also has a string representation as a transformation string
     > Usage
     | el.transform(el.getAlign(el2, "top"));
     * or
     | var dy = el.getAlign(el2, "top").dy;
    \*/
    Element.prototype.getAlign = function (el, way) {
        if (way == null && is(el, "string")) {
            way = el;
            el = null;
        }
        el = el || this.paper;
        var bx = el.getBBox ? el.getBBox() : box(el),
            bb = this.getBBox(),
            out = {};
        way = way && way.match(firstLetter);
        way = way ? way[1].toLowerCase() : "c";
        switch (way) {
            case "t":
                out.dx = 0;
                out.dy = bx.y - bb.y;
            break;
            case "b":
                out.dx = 0;
                out.dy = bx.y2 - bb.y2;
            break;
            case "m":
                out.dx = 0;
                out.dy = bx.cy - bb.cy;
            break;
            case "l":
                out.dx = bx.x - bb.x;
                out.dy = 0;
            break;
            case "r":
                out.dx = bx.x2 - bb.x2;
                out.dy = 0;
            break;
            default:
                out.dx = bx.cx - bb.cx;
                out.dy = 0;
            break;
        }
        out.toString = toString;
        return out;
    };
    /*\
     * Element.align
     [ method ]
     **
     * Aligns the element relatively to given one via transformation.
     * If no elements specified, parent `<svg>` container will be used.
     - el (object) @optional alignment element
     - way (string) one of six values: `"top"`, `"middle"`, `"bottom"`, `"left"`, `"center"`, `"right"`
     = (object) this element
     > Usage
     | el.align(el2, "top");
     * or
     | el.align("middle");
    \*/
    Element.prototype.align = function (el, way) {
        return this.transform("..." + this.getAlign(el, way));
    };
});

// Copyright (c) 2016 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var elproto = Element.prototype,
        is = Snap.is,
        Str = String,
        has = "hasOwnProperty";
    function slice(from, to, f) {
        return function (arr) {
            var res = arr.slice(from, to);
            if (res.length == 1) {
                res = res[0];
            }
            return f ? f(res) : res;
        };
    }
    var Animation = function (attr, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
            callback = easing;
            easing = mina.linear;
        }
        this.attr = attr;
        this.dur = ms;
        easing && (this.easing = easing);
        callback && (this.callback = callback);
    };
    Snap._.Animation = Animation;
    /*\
     * Snap.animation
     [ method ]
     **
     * Creates an animation object
     **
     - attr (object) attributes of final destination
     - duration (number) duration of the animation, in milliseconds
     - easing (function) #optional one of easing functions of @mina or custom one
     - callback (function) #optional callback function that fires when animation ends
     = (object) animation object
    \*/
    Snap.animation = function (attr, ms, easing, callback) {
        return new Animation(attr, ms, easing, callback);
    };
    /*\
     * Element.inAnim
     [ method ]
     **
     * Returns a set of animations that may be able to manipulate the current element
     **
     = (object) in format:
     o {
     o     anim (object) animation object,
     o     mina (object) @mina object,
     o     curStatus (number) 0..1 — status of the animation: 0 — just started, 1 — just finished,
     o     status (function) gets or sets the status of the animation,
     o     stop (function) stops the animation
     o }
    \*/
    elproto.inAnim = function () {
        var el = this,
            res = [];
        for (var id in el.anims) if (el.anims[has](id)) {
            (function (a) {
                res.push({
                    anim: new Animation(a._attrs, a.dur, a.easing, a._callback),
                    mina: a,
                    curStatus: a.status(),
                    status: function (val) {
                        return a.status(val);
                    },
                    stop: function () {
                        a.stop();
                    }
                });
            }(el.anims[id]));
        }
        return res;
    };
    /*\
     * Snap.animate
     [ method ]
     **
     * Runs generic animation of one number into another with a caring function
     **
     - from (number|array) number or array of numbers
     - to (number|array) number or array of numbers
     - setter (function) caring function that accepts one number argument
     - duration (number) duration, in milliseconds
     - easing (function) #optional easing function from @mina or custom
     - callback (function) #optional callback function to execute when animation ends
     = (object) animation object in @mina format
     o {
     o     id (string) animation id, consider it read-only,
     o     duration (function) gets or sets the duration of the animation,
     o     easing (function) easing,
     o     speed (function) gets or sets the speed of the animation,
     o     status (function) gets or sets the status of the animation,
     o     stop (function) stops the animation
     o }
     | var rect = Snap().rect(0, 0, 10, 10);
     | Snap.animate(0, 10, function (val) {
     |     rect.attr({
     |         x: val
     |     });
     | }, 1000);
     | // in given context is equivalent to
     | rect.animate({x: 10}, 1000);
    \*/
    Snap.animate = function (from, to, setter, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
            callback = easing;
            easing = mina.linear;
        }
        var now = mina.time(),
            anim = mina(from, to, now, now + ms, mina.time, setter, easing);
        callback && eve.once("mina.finish." + anim.id, callback);
        return anim;
    };
    /*\
     * Element.stop
     [ method ]
     **
     * Stops all the animations for the current element
     **
     = (Element) the current element
    \*/
    elproto.stop = function () {
        var anims = this.inAnim();
        for (var i = 0, ii = anims.length; i < ii; i++) {
            anims[i].stop();
        }
        return this;
    };
    /*\
     * Element.animate
     [ method ]
     **
     * Animates the given attributes of the element
     **
     - attrs (object) key-value pairs of destination attributes
     - duration (number) duration of the animation in milliseconds
     - easing (function) #optional easing function from @mina or custom
     - callback (function) #optional callback function that executes when the animation ends
     = (Element) the current element
    \*/
    elproto.animate = function (attrs, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
            callback = easing;
            easing = mina.linear;
        }
        if (attrs instanceof Animation) {
            callback = attrs.callback;
            easing = attrs.easing;
            ms = attrs.dur;
            attrs = attrs.attr;
        }
        var fkeys = [], tkeys = [], keys = {}, from, to, f, eq,
            el = this;
        for (var key in attrs) if (attrs[has](key)) {
            if (el.equal) {
                eq = el.equal(key, Str(attrs[key]));
                from = eq.from;
                to = eq.to;
                f = eq.f;
            } else {
                from = +el.attr(key);
                to = +attrs[key];
            }
            var len = is(from, "array") ? from.length : 1;
            keys[key] = slice(fkeys.length, fkeys.length + len, f);
            fkeys = fkeys.concat(from);
            tkeys = tkeys.concat(to);
        }
        var now = mina.time(),
            anim = mina(fkeys, tkeys, now, now + ms, mina.time, function (val) {
                var attr = {};
                for (var key in keys) if (keys[has](key)) {
                    attr[key] = keys[key](val);
                }
                el.attr(attr);
            }, easing);
        el.anims[anim.id] = anim;
        anim._attrs = attrs;
        anim._callback = callback;
        eve("snap.animcreated." + el.id, anim);
        eve.once("mina.finish." + anim.id, function () {
            eve.off("mina.*." + anim.id);
            delete el.anims[anim.id];
            callback && callback.call(el);
        });
        eve.once("mina.stop." + anim.id, function () {
            eve.off("mina.*." + anim.id);
            delete el.anims[anim.id];
        });
        return el;
    };
});

// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob) {
    // Colours are from https://www.materialui.co
    var red         = "#ffebee#ffcdd2#ef9a9a#e57373#ef5350#f44336#e53935#d32f2f#c62828#b71c1c#ff8a80#ff5252#ff1744#d50000",
        pink        = "#FCE4EC#F8BBD0#F48FB1#F06292#EC407A#E91E63#D81B60#C2185B#AD1457#880E4F#FF80AB#FF4081#F50057#C51162",
        purple      = "#F3E5F5#E1BEE7#CE93D8#BA68C8#AB47BC#9C27B0#8E24AA#7B1FA2#6A1B9A#4A148C#EA80FC#E040FB#D500F9#AA00FF",
        deeppurple  = "#EDE7F6#D1C4E9#B39DDB#9575CD#7E57C2#673AB7#5E35B1#512DA8#4527A0#311B92#B388FF#7C4DFF#651FFF#6200EA",
        indigo      = "#E8EAF6#C5CAE9#9FA8DA#7986CB#5C6BC0#3F51B5#3949AB#303F9F#283593#1A237E#8C9EFF#536DFE#3D5AFE#304FFE",
        blue        = "#E3F2FD#BBDEFB#90CAF9#64B5F6#64B5F6#2196F3#1E88E5#1976D2#1565C0#0D47A1#82B1FF#448AFF#2979FF#2962FF",
        lightblue   = "#E1F5FE#B3E5FC#81D4FA#4FC3F7#29B6F6#03A9F4#039BE5#0288D1#0277BD#01579B#80D8FF#40C4FF#00B0FF#0091EA",
        cyan        = "#E0F7FA#B2EBF2#80DEEA#4DD0E1#26C6DA#00BCD4#00ACC1#0097A7#00838F#006064#84FFFF#18FFFF#00E5FF#00B8D4",
        teal        = "#E0F2F1#B2DFDB#80CBC4#4DB6AC#26A69A#009688#00897B#00796B#00695C#004D40#A7FFEB#64FFDA#1DE9B6#00BFA5",
        green       = "#E8F5E9#C8E6C9#A5D6A7#81C784#66BB6A#4CAF50#43A047#388E3C#2E7D32#1B5E20#B9F6CA#69F0AE#00E676#00C853",
        lightgreen  = "#F1F8E9#DCEDC8#C5E1A5#AED581#9CCC65#8BC34A#7CB342#689F38#558B2F#33691E#CCFF90#B2FF59#76FF03#64DD17",
        lime        = "#F9FBE7#F0F4C3#E6EE9C#DCE775#D4E157#CDDC39#C0CA33#AFB42B#9E9D24#827717#F4FF81#EEFF41#C6FF00#AEEA00",
        yellow      = "#FFFDE7#FFF9C4#FFF59D#FFF176#FFEE58#FFEB3B#FDD835#FBC02D#F9A825#F57F17#FFFF8D#FFFF00#FFEA00#FFD600",
        amber       = "#FFF8E1#FFECB3#FFE082#FFD54F#FFCA28#FFC107#FFB300#FFA000#FF8F00#FF6F00#FFE57F#FFD740#FFC400#FFAB00",
        orange      = "#FFF3E0#FFE0B2#FFCC80#FFB74D#FFA726#FF9800#FB8C00#F57C00#EF6C00#E65100#FFD180#FFAB40#FF9100#FF6D00",
        deeporange  = "#FBE9E7#FFCCBC#FFAB91#FF8A65#FF7043#FF5722#F4511E#E64A19#D84315#BF360C#FF9E80#FF6E40#FF3D00#DD2C00",
        brown       = "#EFEBE9#D7CCC8#BCAAA4#A1887F#8D6E63#795548#6D4C41#5D4037#4E342E#3E2723",
        grey        = "#FAFAFA#F5F5F5#EEEEEE#E0E0E0#BDBDBD#9E9E9E#757575#616161#424242#212121",
        bluegrey    = "#ECEFF1#CFD8DC#B0BEC5#90A4AE#78909C#607D8B#546E7A#455A64#37474F#263238";
    /*\
     * Snap.mui
     [ property ]
     **
     * Contain Material UI colours.
     | Snap().rect(0, 0, 10, 10).attr({fill: Snap.mui.deeppurple, stroke: Snap.mui.amber[600]});
     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
    \*/
    Snap.mui = {};
    /*\
     * Snap.flat
     [ property ]
     **
     * Contain Flat UI colours.
     | Snap().rect(0, 0, 10, 10).attr({fill: Snap.flat.carrot, stroke: Snap.flat.wetasphalt});
     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
    \*/
    Snap.flat = {};
    function saveColor(colors) {
        colors = colors.split(/(?=#)/);
        var color = new String(colors[5]);
        color[50] = colors[0];
        color[100] = colors[1];
        color[200] = colors[2];
        color[300] = colors[3];
        color[400] = colors[4];
        color[500] = colors[5];
        color[600] = colors[6];
        color[700] = colors[7];
        color[800] = colors[8];
        color[900] = colors[9];
        if (colors[10]) {
            color.A100 = colors[10];
            color.A200 = colors[11];
            color.A400 = colors[12];
            color.A700 = colors[13];
        }
        return color;
    }
    Snap.mui.red = saveColor(red);
    Snap.mui.pink = saveColor(pink);
    Snap.mui.purple = saveColor(purple);
    Snap.mui.deeppurple = saveColor(deeppurple);
    Snap.mui.indigo = saveColor(indigo);
    Snap.mui.blue = saveColor(blue);
    Snap.mui.lightblue = saveColor(lightblue);
    Snap.mui.cyan = saveColor(cyan);
    Snap.mui.teal = saveColor(teal);
    Snap.mui.green = saveColor(green);
    Snap.mui.lightgreen = saveColor(lightgreen);
    Snap.mui.lime = saveColor(lime);
    Snap.mui.yellow = saveColor(yellow);
    Snap.mui.amber = saveColor(amber);
    Snap.mui.orange = saveColor(orange);
    Snap.mui.deeporange = saveColor(deeporange);
    Snap.mui.brown = saveColor(brown);
    Snap.mui.grey = saveColor(grey);
    Snap.mui.bluegrey = saveColor(bluegrey);
    Snap.flat.turquoise = "#1abc9c";
    Snap.flat.greensea = "#16a085";
    Snap.flat.sunflower = "#f1c40f";
    Snap.flat.orange = "#f39c12";
    Snap.flat.emerland = "#2ecc71";
    Snap.flat.nephritis = "#27ae60";
    Snap.flat.carrot = "#e67e22";
    Snap.flat.pumpkin = "#d35400";
    Snap.flat.peterriver = "#3498db";
    Snap.flat.belizehole = "#2980b9";
    Snap.flat.alizarin = "#e74c3c";
    Snap.flat.pomegranate = "#c0392b";
    Snap.flat.amethyst = "#9b59b6";
    Snap.flat.wisteria = "#8e44ad";
    Snap.flat.clouds = "#ecf0f1";
    Snap.flat.silver = "#bdc3c7";
    Snap.flat.wetasphalt = "#34495e";
    Snap.flat.midnightblue = "#2c3e50";
    Snap.flat.concrete = "#95a5a6";
    Snap.flat.asbestos = "#7f8c8d";
    /*\
     * Snap.importMUIColors
     [ method ]
     **
     * Imports Material UI colours into global object.
     | Snap.importMUIColors();
     | Snap().rect(0, 0, 10, 10).attr({fill: deeppurple, stroke: amber[600]});
     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
    \*/
    Snap.importMUIColors = function () {
        for (var color in Snap.mui) {
            if (Snap.mui.hasOwnProperty(color)) {
                window[color] = Snap.mui[color];
            }
        }
    };
});

module.exports = Snap


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// ┌────────────────────────────────────────────────────────────┐ \\
// │ Eve 0.5.4 - JavaScript Events Library                      │ \\
// ├────────────────────────────────────────────────────────────┤ \\
// │ Author Dmitry Baranovskiy (http://dmitry.baranovskiy.com/) │ \\
// └────────────────────────────────────────────────────────────┘ \\

(function (glob) {
    var version = "0.5.4",
        has = "hasOwnProperty",
        separator = /[\.\/]/,
        comaseparator = /\s*,\s*/,
        wildcard = "*",
        numsort = function (a, b) {
            return a - b;
        },
        current_event,
        stop,
        events = {n: {}},
        firstDefined = function () {
            for (var i = 0, ii = this.length; i < ii; i++) {
                if (typeof this[i] != "undefined") {
                    return this[i];
                }
            }
        },
        lastDefined = function () {
            var i = this.length;
            while (--i) {
                if (typeof this[i] != "undefined") {
                    return this[i];
                }
            }
        },
        objtos = Object.prototype.toString,
        Str = String,
        isArray = Array.isArray || function (ar) {
            return ar instanceof Array || objtos.call(ar) == "[object Array]";
        },
    /*\
     * eve
     [ method ]

     * Fires event with given `name`, given scope and other parameters.

     - name (string) name of the *event*, dot (`.`) or slash (`/`) separated
     - scope (object) context for the event handlers
     - varargs (...) the rest of arguments will be sent to event handlers

     = (object) array of returned values from the listeners. Array has two methods `.firstDefined()` and `.lastDefined()` to get first or last not `undefined` value.
    \*/
        eve = function (name, scope) {
            var oldstop = stop,
                args = Array.prototype.slice.call(arguments, 2),
                listeners = eve.listeners(name),
                z = 0,
                l,
                indexed = [],
                queue = {},
                out = [],
                ce = current_event;
            out.firstDefined = firstDefined;
            out.lastDefined = lastDefined;
            current_event = name;
            stop = 0;
            for (var i = 0, ii = listeners.length; i < ii; i++) if ("zIndex" in listeners[i]) {
                indexed.push(listeners[i].zIndex);
                if (listeners[i].zIndex < 0) {
                    queue[listeners[i].zIndex] = listeners[i];
                }
            }
            indexed.sort(numsort);
            while (indexed[z] < 0) {
                l = queue[indexed[z++]];
                out.push(l.apply(scope, args));
                if (stop) {
                    stop = oldstop;
                    return out;
                }
            }
            for (i = 0; i < ii; i++) {
                l = listeners[i];
                if ("zIndex" in l) {
                    if (l.zIndex == indexed[z]) {
                        out.push(l.apply(scope, args));
                        if (stop) {
                            break;
                        }
                        do {
                            z++;
                            l = queue[indexed[z]];
                            l && out.push(l.apply(scope, args));
                            if (stop) {
                                break;
                            }
                        } while (l)
                    } else {
                        queue[l.zIndex] = l;
                    }
                } else {
                    out.push(l.apply(scope, args));
                    if (stop) {
                        break;
                    }
                }
            }
            stop = oldstop;
            current_event = ce;
            return out;
        };
    // Undocumented. Debug only.
    eve._events = events;
    /*\
     * eve.listeners
     [ method ]

     * Internal method which gives you array of all event handlers that will be triggered by the given `name`.

     - name (string) name of the event, dot (`.`) or slash (`/`) separated

     = (array) array of event handlers
    \*/
    eve.listeners = function (name) {
        var names = isArray(name) ? name : name.split(separator),
            e = events,
            item,
            items,
            k,
            i,
            ii,
            j,
            jj,
            nes,
            es = [e],
            out = [];
        for (i = 0, ii = names.length; i < ii; i++) {
            nes = [];
            for (j = 0, jj = es.length; j < jj; j++) {
                e = es[j].n;
                items = [e[names[i]], e[wildcard]];
                k = 2;
                while (k--) {
                    item = items[k];
                    if (item) {
                        nes.push(item);
                        out = out.concat(item.f || []);
                    }
                }
            }
            es = nes;
        }
        return out;
    };
    /*\
     * eve.separator
     [ method ]

     * If for some reasons you don’t like default separators (`.` or `/`) you can specify yours
     * here. Be aware that if you pass a string longer than one character it will be treated as
     * a list of characters.

     - separator (string) new separator. Empty string resets to default: `.` or `/`.
    \*/
    eve.separator = function (sep) {
        if (sep) {
            sep = Str(sep).replace(/(?=[\.\^\]\[\-])/g, "\\");
            sep = "[" + sep + "]";
            separator = new RegExp(sep);
        } else {
            separator = /[\.\/]/;
        }
    };
    /*\
     * eve.on
     [ method ]
     **
     * Binds given event handler with a given name. You can use wildcards “`*`” for the names:
     | eve.on("*.under.*", f);
     | eve("mouse.under.floor"); // triggers f
     * Use @eve to trigger the listener.
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
     **
     - name (array) if you don’t want to use separators, you can use array of strings
     - f (function) event handler function
     **
     = (function) returned function accepts a single numeric parameter that represents z-index of the handler. It is an optional feature and only used when you need to ensure that some subset of handlers will be invoked in a given order, despite of the order of assignment.
     > Example:
     | eve.on("mouse", eatIt)(2);
     | eve.on("mouse", scream);
     | eve.on("mouse", catchIt)(1);
     * This will ensure that `catchIt` function will be called before `eatIt`.
     *
     * If you want to put your handler before non-indexed handlers, specify a negative value.
     * Note: I assume most of the time you don’t need to worry about z-index, but it’s nice to have this feature “just in case”.
    \*/
    eve.on = function (name, f) {
        if (typeof f != "function") {
            return function () {};
        }
        var names = isArray(name) ? isArray(name[0]) ? name : [name] : Str(name).split(comaseparator);
        for (var i = 0, ii = names.length; i < ii; i++) {
            (function (name) {
                var names = isArray(name) ? name : Str(name).split(separator),
                    e = events,
                    exist;
                for (var i = 0, ii = names.length; i < ii; i++) {
                    e = e.n;
                    e = e.hasOwnProperty(names[i]) && e[names[i]] || (e[names[i]] = {n: {}});
                }
                e.f = e.f || [];
                for (i = 0, ii = e.f.length; i < ii; i++) if (e.f[i] == f) {
                    exist = true;
                    break;
                }
                !exist && e.f.push(f);
            }(names[i]));
        }
        return function (zIndex) {
            if (+zIndex == +zIndex) {
                f.zIndex = +zIndex;
            }
        };
    };
    /*\
     * eve.f
     [ method ]
     **
     * Returns function that will fire given event with optional arguments.
     * Arguments that will be passed to the result function will be also
     * concated to the list of final arguments.
     | el.onclick = eve.f("click", 1, 2);
     | eve.on("click", function (a, b, c) {
     |     console.log(a, b, c); // 1, 2, [event object]
     | });
     - event (string) event name
     - varargs (…) and any other arguments
     = (function) possible event handler function
    \*/
    eve.f = function (event) {
        var attrs = [].slice.call(arguments, 1);
        return function () {
            eve.apply(null, [event, null].concat(attrs).concat([].slice.call(arguments, 0)));
        };
    };
    /*\
     * eve.stop
     [ method ]
     **
     * Is used inside an event handler to stop the event, preventing any subsequent listeners from firing.
    \*/
    eve.stop = function () {
        stop = 1;
    };
    /*\
     * eve.nt
     [ method ]
     **
     * Could be used inside event handler to figure out actual name of the event.
     **
     - subname (string) #optional subname of the event
     **
     = (string) name of the event, if `subname` is not specified
     * or
     = (boolean) `true`, if current event’s name contains `subname`
    \*/
    eve.nt = function (subname) {
        var cur = isArray(current_event) ? current_event.join(".") : current_event;
        if (subname) {
            return new RegExp("(?:\\.|\\/|^)" + subname + "(?:\\.|\\/|$)").test(cur);
        }
        return cur;
    };
    /*\
     * eve.nts
     [ method ]
     **
     * Could be used inside event handler to figure out actual name of the event.
     **
     **
     = (array) names of the event
    \*/
    eve.nts = function () {
        return isArray(current_event) ? current_event : current_event.split(separator);
    };
    /*\
     * eve.off
     [ method ]
     **
     * Removes given function from the list of event listeners assigned to given name.
     * If no arguments specified all the events will be cleared.
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
    \*/
    /*\
     * eve.unbind
     [ method ]
     **
     * See @eve.off
    \*/
    eve.off = eve.unbind = function (name, f) {
        if (!name) {
            eve._events = events = {n: {}};
            return;
        }
        var names = isArray(name) ? isArray(name[0]) ? name : [name] : Str(name).split(comaseparator);
        if (names.length > 1) {
            for (var i = 0, ii = names.length; i < ii; i++) {
                eve.off(names[i], f);
            }
            return;
        }
        names = isArray(name) ? name : Str(name).split(separator);
        var e,
            key,
            splice,
            i, ii, j, jj,
            cur = [events],
            inodes = [];
        for (i = 0, ii = names.length; i < ii; i++) {
            for (j = 0; j < cur.length; j += splice.length - 2) {
                splice = [j, 1];
                e = cur[j].n;
                if (names[i] != wildcard) {
                    if (e[names[i]]) {
                        splice.push(e[names[i]]);
                        inodes.unshift({
                            n: e,
                            name: names[i]
                        });
                    }
                } else {
                    for (key in e) if (e[has](key)) {
                        splice.push(e[key]);
                        inodes.unshift({
                            n: e,
                            name: key
                        });
                    }
                }
                cur.splice.apply(cur, splice);
            }
        }
        for (i = 0, ii = cur.length; i < ii; i++) {
            e = cur[i];
            while (e.n) {
                if (f) {
                    if (e.f) {
                        for (j = 0, jj = e.f.length; j < jj; j++) if (e.f[j] == f) {
                            e.f.splice(j, 1);
                            break;
                        }
                        !e.f.length && delete e.f;
                    }
                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
                        var funcs = e.n[key].f;
                        for (j = 0, jj = funcs.length; j < jj; j++) if (funcs[j] == f) {
                            funcs.splice(j, 1);
                            break;
                        }
                        !funcs.length && delete e.n[key].f;
                    }
                } else {
                    delete e.f;
                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
                        delete e.n[key].f;
                    }
                }
                e = e.n;
            }
        }
        // prune inner nodes in path
        prune: for (i = 0, ii = inodes.length; i < ii; i++) {
            e = inodes[i];
            for (key in e.n[e.name].f) {
                // not empty (has listeners)
                continue prune;
            }
            for (key in e.n[e.name].n) {
                // not empty (has children)
                continue prune;
            }
            // is empty
            delete e.n[e.name];
        }
    };
    /*\
     * eve.once
     [ method ]
     **
     * Binds given event handler with a given name to only run once then unbind itself.
     | eve.once("login", f);
     | eve("login"); // triggers f
     | eve("login"); // no listeners
     * Use @eve to trigger the listener.
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
     **
     = (function) same return function as @eve.on
    \*/
    eve.once = function (name, f) {
        var f2 = function () {
            eve.off(name, f2);
            return f.apply(this, arguments);
        };
        return eve.on(name, f2);
    };
    /*\
     * eve.version
     [ property (string) ]
     **
     * Current version of the library.
    \*/
    eve.version = version;
    eve.toString = function () {
        return "You are running Eve " + version;
    };
    glob.eve = eve;
    typeof module != "undefined" && module.exports ? module.exports = eve :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () { return eve; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : glob.eve = eve;
})(typeof window != "undefined" ? window : this);


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _snapsvgImporter = __webpack_require__(445);

var _snapsvgImporter2 = _interopRequireDefault(_snapsvgImporter);

var _menuFactory = __webpack_require__(68);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  svg: {
    lib: _snapsvgImporter2['default'],
    pathInitial: 'M-7.312,0H0c0,0,0,113.839,0,400c0,264.506,0,400,0,400h-7.312V0z',
    pathOpen: 'M-7.312,0H15c0,0,66,113.339,66,399.5C81,664.006,15,800,15,800H-7.312V0z;M-7.312,0H100c0,0,0,113.839,0,400c0,264.506,0,400,0,400H-7.312V0z',
    animate: function animate(path) {
      var pos = 0;
      var steps = this.pathOpen.split(';');
      var stepsTotal = steps.length;
      var mina = window.mina;

      var nextStep = function nextStep() {
        if (pos > stepsTotal - 1) return;

        path.animate({ path: steps[pos] }, pos === 0 ? 400 : 500, pos === 0 ? mina.easein : mina.elastic, function () {
          nextStep();
        });

        pos++;
      };

      nextStep();
    }
  },

  morphShape: function morphShape(isOpen, width, right) {
    return {
      position: 'absolute',
      width: '100%',
      height: '100%',
      right: right ? 'inherit' : 0,
      left: right ? 0 : 'inherit',
      MozTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
      MsTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
      OTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
      WebkitTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
      transform: right ? 'rotateY(180deg)' : 'rotateY(0deg)'
    };
  },

  menuWrap: function menuWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      transition: isOpen ? 'transform 0.4s 0s' : 'transform 0.4s'
    };
  },

  menu: function menu(isOpen, width, right) {
    width -= 140;
    return {
      position: 'fixed',
      MozTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      MsTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      OTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      transform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      transition: isOpen ? 'opacity 0.1s 0.4s cubic-bezier(.17, .67, .1, 1.27), transform 0.1s 0.4s cubic-bezier(.17, .67, .1, 1.27)' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
      opacity: isOpen ? 1 : 0
    };
  },

  item: function item(isOpen, width, right, nthChild) {
    width -= 140;
    return {
      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      transition: isOpen ? 'opacity 0.3s 0.4s, transform 0.3s 0.4s' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
      opacity: isOpen ? 1 : 0
    };
  },

  closeButton: function closeButton(isOpen, width, right) {
    width -= 140;
    return {
      MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
      transition: isOpen ? 'opacity 0.3s 0.4s cubic-bezier(.17, .67, .1, 1.27), transform 0.3s 0.4s cubic-bezier(.17, .67, .1, 1.27)' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
      opacity: isOpen ? 1 : 0
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(68);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  pageWrap: function pageWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      transition: 'all 0.5s'
    };
  },

  outerContainer: function outerContainer(isOpen) {
    return {
      overflow: isOpen ? '' : 'hidden'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(68);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  pageWrap: function pageWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
      transformOrigin: right ? '100% 50%' : '0% 50%',
      transformStyle: 'preserve-3d',
      transition: 'all 0.5s'
    };
  },

  outerContainer: function outerContainer(isOpen) {
    return {
      perspective: '1500px',
      overflow: isOpen ? '' : 'hidden'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(68);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  pageWrap: function pageWrap(isOpen, width) {
    return {
      MozTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
      MsTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
      OTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
      WebkitTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
      transform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
      transformOrigin: '100%',
      transformStyle: 'preserve-3d',
      transition: 'all 0.5s'
    };
  },

  outerContainer: function outerContainer() {
    return {
      perspective: '1500px'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(68);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  pageWrap: function pageWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
      MsTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
      OTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
      transform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
      transformStyle: 'preserve-3d',
      transition: 'all 0.5s',
      overflow: isOpen ? '' : 'hidden'
    };
  },

  outerContainer: function outerContainer(isOpen) {
    return {
      perspective: '1500px',
      overflow: isOpen ? '' : 'hidden'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(68);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  menuWrap: function menuWrap(isOpen) {
    return {
      MozTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
      MsTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
      OTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
      WebkitTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
      transform: isOpen ? '' : 'translate3d(0, -100%, 0)',
      transition: 'all 0.5s ease-in-out'
    };
  },

  pageWrap: function pageWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      transition: 'all 0.5s'
    };
  },

  outerContainer: function outerContainer(isOpen) {
    return {
      perspective: '1500px',
      perspectiveOrigin: '0% 50%',
      overflow: isOpen ? '' : 'hidden'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(68);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {
  menuWrap: function menuWrap(isOpen, width, right) {
    return {
      visibility: isOpen ? 'visible' : 'hidden',
      MozTransform: 'translate3d(0, 0, 0)',
      MsTransform: 'translate3d(0, 0, 0)',
      OTransform: 'translate3d(0, 0, 0)',
      WebkitTransform: 'translate3d(0, 0, 0)',
      transform: 'translate3d(0, 0, 0)',
      zIndex: 1000
    };
  },

  overlay: function overlay(isOpen, width, right) {
    return {
      zIndex: 1400,
      MozTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      MsTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      OTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      WebkitTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      transform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      transition: 'all 0.5s',
      visibility: isOpen ? 'visible' : 'hidden'
    };
  },

  pageWrap: function pageWrap(isOpen, width, right) {
    return {
      MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
      transition: 'all 0.5s',
      zIndex: 1200,
      position: 'relative'
    };
  },

  burgerIcon: function burgerIcon(isOpen, width, right) {
    return {
      MozTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      MsTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      OTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      WebkitTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      transform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
      transition: 'all 0.1s',
      position: 'relative',
      zIndex: 1300
    };
  },

  outerContainer: function outerContainer(isOpen) {
    return {
      overflow: isOpen ? '' : 'hidden'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAwCAYAAABqkJjhAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQ1JREFUeNrsl/0NgjAQxQ/iAB2BUdjAFToKIzBCR9ANcANH6AjdoB6m0UTbQ7R81LyXPP6g9/ELacqVvPeU2Zptg3Xu+kuAvioreI4ibQI0Bt5uCTw2H/x8Db+ArwmaBXxOcMM2Pr9MqJ0NeCnQr8ClRcXu/frqQ++Pgcfgju38dnKBQUnAewCdBJ869Peix8+n4seJiI5Uhs41PxSVI1VTYQLw0qruRwW+MIDLBT5E3jVsnYi3bJNYa4NjGoJj0qFnTCb0fCoxoEtDd2q664S8TsiTLgNvAz72MIABDGAAAxjAAAZwafOwY18S8VehlhXyrJAn1XS4hAL4H4HHy6EvxAO2BIABDGBZNwEGACLEb3qb5S5bAAAAAElFTkSuQmCC"

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pwdhelpscrn.962d28b1.png";

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_html_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prelogin_public_css_react_select_css__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prelogin_public_css_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__prelogin_public_css_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Contactus=function(_PreLoginPage){_inherits(Contactus,_PreLoginPage);function Contactus(props){_classCallCheck(this,Contactus);var _this=_possibleConstructorReturn(this,(Contactus.__proto__||Object.getPrototypeOf(Contactus)).call(this,props));_this.hmNav=function(){//this.props.myProps.history.push(this.props.navigateURL);
window.top.location.href=this.props.navigateURL;};_this.submitForm=function(){var me=this;if(this.state.selectedContactOption.value==2){this.submitLumosContactForm();return;}__WEBPACK_IMPORTED_MODULE_10_jquery___default()(".contactus .server-messages").removeClass("success");var formData={"loginId":this.state.contact_userid==""?null:this.state.contact_userid,"emailId":this.state.contact_emailid==""?null:this.state.contact_emailid,"messageType":this.state.selectedContactOption.label,"phoneNo":this.state.contact_phone==""?null:this.state.contact_phone,"message":this.state.contact_message==""?null:this.state.contact_message,"city":this.state.contact_city==""?null:this.state.contact_city,"pageSource":"prelogin"};me.setState({submitButtonDisabled:true});var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status.toLowerCase()=="success"){__WEBPACK_IMPORTED_MODULE_10_jquery___default()(".contactus .server-messages").addClass("success");me.setState({submitButtonDisabled:true});//me.setState({serverMessage:me.rb("contactus.success")+" <br/>"+me.rb("reference_id")+" : "+ response.reference_id});
me.props.successContactus(me.rb("contactus.success")+" <br/> <span class='hm-blue'>"+me.rb("reference_id")+" : "+response.reference_id+"</span>");}else if(response.status.toLowerCase()=="user_invalid"){me.setState({serverMessage:me.rb("contactus.invaliduserid"),submitButtonDisabled:false});}else{me.setState({serverMessage:me.rb("error.oops"),submitButtonDisabled:false});}}console.log("response : ",response);};var callBackFailure=function callBackFailure(response){console.log("Error in CONTACT_US");me.setState({submitButtonDisabled:false});};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("CONTACT_US"),formData).post(callBackSuccess,callBackFailure);};_this.submitLumosContactForm=function(){var me=this;__WEBPACK_IMPORTED_MODULE_10_jquery___default()(".contactus .server-messages").removeClass("success");var formData={"userId":this.state.contact_userid,"name":this.state.contact_userid,"email":this.state.contact_emailid,"subject":this.state.selectedContactOption.label,"message":this.state.contact_message};me.setState({submitButtonDisabled:true});__WEBPACK_IMPORTED_MODULE_10_jquery___default.a.ajax({url:me.getUrlFor("LUMOS_CONTACT_US"),data:formData,type:'POST',xhrFields:{withCredentials:true},crossDomain:true,success:function success(response){switch(response.code){case 200:__WEBPACK_IMPORTED_MODULE_10_jquery___default()(".contactus .server-messages").addClass("success");//me.setState({serverMessage:me.rb("contactus.success")});
me.setState({submitButtonDisabled:true});me.props.successContactus(me.rb("contactus.success"));break;default:me.setState({serverMessage:response.message,submitButtonDisabled:false});}},error:function error(response){console.log("Error in lumos login",response);me.setState({submitButtonDisabled:false});}});};_this.state={contact_type:'',contact_emailid:'',contact_phone:'',contact_city:'',contact_message:'',contact_userid:"",submitButtonDisabled:false,serverMessage:"",selectedContactOption:null,cityVisible:"",userIdVisible:false,emailIdVisible:true,phoneVisible:true};_this.handleSubmit=_this.handleSubmit.bind(_this);_this.handleChange=_this.handleChange.bind(_this);_this.contactTypeDropdownChange=_this.contactTypeDropdownChange.bind(_this);_this.contactTypeDpList=[];//this.selectedContactOption = null;		
return _this;}_createClass(Contactus,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(){this.setState({serverMessage:"",contact_emailid:"",contact_phone:"",contact_city:"",contact_message:"",contact_userid:""});}},{key:'componentDidMount',value:function componentDidMount(){this.sessionCheck();this.populateContactDropdown();}},{key:'handleChange',value:function handleChange(e){var _setState;var target=e.currentTarget;//console.log("target=",target);
this.form.validateFields(target);this.setState((_setState={},_defineProperty(_setState,target.name,target.value),_defineProperty(_setState,'serverMessage',""),_defineProperty(_setState,'submitButtonDisabled',!this.form.isValid()),_setState));}},{key:'handleSubmit',value:function handleSubmit(e){e.preventDefault();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){this.submitForm();}}},{key:'populateContactDropdown',value:function populateContactDropdown(){this.contactTypeDpList.push({"label":this.rb("contactus.dropdown1"),"value":1});this.contactTypeDpList.push({"label":this.rb("contactus.dropdown2"),"value":2});this.contactTypeDpList.push({"label":this.rb("contactus.dropdown3"),"value":3});this.setState({selectedContactOption:this.contactTypeDpList[0]});}},{key:'contactTypeDropdownChange',value:function contactTypeDropdownChange(selectedOption){var me=this;this.setState({selectedContactOption:selectedOption,serverMessage:"",cityVisible:"hidden",userIdVisible:false,emailIdVisible:false,phoneVisible:false,contact_emailid:"",contact_phone:"",contact_city:"",contact_message:"",contact_userid:""});if(selectedOption.value==1){this.setState({selectedContactOption:selectedOption,cityVisible:"",emailIdVisible:true,phoneVisible:true});}else if(selectedOption.value==2){this.setState({selectedContactOption:selectedOption,emailIdVisible:true,userIdVisible:true,phoneVisible:false});}else if(selectedOption.value==3){this.setState({selectedContactOption:selectedOption,emailIdVisible:false,userIdVisible:true,phoneVisible:true});}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'loginRoot',className:'plpLogin contactus'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rounded-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this2.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{value:this.state.selectedContactOption,onChange:this.contactTypeDropdownChange,options:this.contactTypeDpList,onBlurResetsInput:false,onSelectResetsInput:false,clearable:false,rtl:false,searchable:false,tabIndex:'1'}),function(){if(_this2.state.userIdVisible==true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'contact_userid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'contact_userid',className:'contact_userid',name:'contact_userid',placeholder:_this2.rb("login.userid"),value:_this2.state.contact_userid,onChange:_this2.handleChange,required:true,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'contact_userid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},_this2.rb("login.useridrequired"))));}}(),function(){if(_this2.state.emailIdVisible==true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'contact_emailid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'contact_emailid',className:'contact_emailid',name:'contact_emailid',placeholder:_this2.rb("fpwd.email"),innerRef:function innerRef(email){return _this2.email=email;},value:_this2.state.contact_emailid,onChange:_this2.handleChange,required:true,maxLength:254,pattern:'^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$',autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'contact_emailid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},_this2.rb("fpwd.emailrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},_this2.rb("fpwd.validemail"))));}}(),function(){if(_this2.state.phoneVisible==true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'contact_phone'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'contact_phone',className:'contact_phone',name:'contact_phone',placeholder:_this2.rb("contactus.phoneno"),innerRef:function innerRef(phone){return _this2.phone=phone;},value:_this2.state.contact_phone,onChange:_this2.handleChange,pattern:'.{10,}',maxLength:20,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'contact_phone'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},_this2.rb("register.mobilerequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},_this2.rb("register.mobilenolength")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length>0&&!/\d/.test(value);}},_this2.rb("register.numbersonly")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'*'})));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'contact_city',className:this.state.cityVisible},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'contact_city',className:'contact_city',name:'contact_city',placeholder:this.rb("contactus.city"),value:this.state.contact_city,onChange:this.handleChange,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'4'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'contact_message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'contact_message',className:'contact_message',name:'contact_message',placeholder:this.rb("contactus.message"),value:this.state.contact_message,onChange:this.handleChange,required:true,maxLength:3500,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'contact_message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("contactus.messagerequired")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages'},__WEBPACK_IMPORTED_MODULE_5_react_html_parser___default()(this.state.serverMessage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-ga':'Footer - Contact Us - Send',disabled:this.state.submitButtonDisabled,className:'submitButton signup'},this.rb("login.send")))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));}}]);return Contactus;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Contactus);

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["a"] = (stylis_min);


/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (weakMemoize);


/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRegisteredStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return insertStyles; });
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash2_32_gc(str) {
  var l = str.length,
      h = l ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;
  return (h >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmurhash2_32_gc);


/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(119)))

/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return manageState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);











var defaultProps = {
  defaultInputValue: '',
  defaultMenuIsOpen: false,
  defaultValue: null
};

var manageState = function manageState(SelectComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__["a" /* default */])(StateManager, _Component);

    function StateManager() {
      var _getPrototypeOf2;

      var _this;

      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, StateManager);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, (_getPrototypeOf2 = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(StateManager)).call.apply(_getPrototypeOf2, [this].concat(args)));

      Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "select", void 0);

      Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "state", {
        inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
        menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
      });

      Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onChange", function (value, actionMeta) {
        _this.callProp('onChange', value, actionMeta);

        _this.setState({
          value: value
        });
      });

      Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onInputChange", function (value, actionMeta) {
        // TODO: for backwards compatibility, we allow the prop to return a new
        // value, but now inputValue is a controllable prop we probably shouldn't
        var newValue = _this.callProp('onInputChange', value, actionMeta);

        _this.setState({
          inputValue: newValue !== undefined ? newValue : value
        });
      });

      Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onMenuOpen", function () {
        _this.callProp('onMenuOpen');

        _this.setState({
          menuIsOpen: true
        });
      });

      Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onMenuClose", function () {
        _this.callProp('onMenuClose');

        _this.setState({
          menuIsOpen: false
        });
      });

      return _this;
    }

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(StateManager, [{
      key: "focus",
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.select.blur();
      } // FIXME: untyped flow code, return any

    }, {
      key: "getProp",
      value: function getProp(key) {
        return this.props[key] !== undefined ? this.props[key] : this.state[key];
      } // FIXME: untyped flow code, return any

    }, {
      key: "callProp",
      value: function callProp(name) {
        if (typeof this.props[name] === 'function') {
          var _this$props;

          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          return (_this$props = this.props)[name].apply(_this$props, args);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props2 = this.props,
            defaultInputValue = _this$props2.defaultInputValue,
            defaultMenuIsOpen = _this$props2.defaultMenuIsOpen,
            defaultValue = _this$props2.defaultValue,
            props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_this$props2, ["defaultInputValue", "defaultMenuIsOpen", "defaultValue"]);

        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(SelectComponent, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
          ref: function ref(_ref) {
            _this2.select = _ref;
          },
          inputValue: this.getProp('inputValue'),
          menuIsOpen: this.getProp('menuIsOpen'),
          onChange: this.onChange,
          onInputChange: this.onInputChange,
          onMenuClose: this.onMenuClose,
          onMenuOpen: this.onMenuOpen,
          value: this.getProp('value')
        }));
      }
    }]);

    return StateManager;
  }(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]), Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_class, "defaultProps", defaultProps), _temp;
};




/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_html_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prelogin_public_css_react_select_css__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prelogin_public_css_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__prelogin_public_css_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TchrContactus=function(_PreLoginPage){_inherits(TchrContactus,_PreLoginPage);function TchrContactus(props){_classCallCheck(this,TchrContactus);var _this=_possibleConstructorReturn(this,(TchrContactus.__proto__||Object.getPrototypeOf(TchrContactus)).call(this,props));_this.hmNav=function(){//this.props.myProps.history.push(this.props.navigateURL);
window.top.location.href=this.props.navigateURL;};_this.submitForm=function(){var me=this;if(this.state.selectedContactOption.value==2){this.submitLumosContactForm();return;}__WEBPACK_IMPORTED_MODULE_10_jquery___default()(".contactus .server-messages").removeClass("success");var formData={"loginId":this.state.contact_userid==""?null:this.state.contact_userid,"emailId":this.state.contact_emailid==""?null:this.state.contact_emailid,"messageType":this.state.selectedContactOption.label,"phoneNo":this.state.contact_phone==""?null:this.state.contact_phone,"message":this.state.contact_message==""?null:this.state.contact_message,"city":this.state.contact_city==""?null:this.state.contact_city,"pageSource":"prelogin"};me.setState({submitButtonDisabled:true});var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status.toLowerCase()=="success"){__WEBPACK_IMPORTED_MODULE_10_jquery___default()(".contactus .server-messages").addClass("success");me.setState({submitButtonDisabled:true});//me.setState({serverMessage:me.rb("contactus.success")+" <br/>"+me.rb("reference_id")+" : "+ response.reference_id});
me.props.successContactus(me.rb("tchrcontactus.success")+" <br/><br/> <span class='hm-blue'>"+me.rb("reference_id")+" : "+response.reference_id+"</span>");}else if(response.status.toLowerCase()=="user_invalid"){me.setState({serverMessage:me.rb("contactus.invaliduserid"),submitButtonDisabled:false});}else{me.setState({serverMessage:me.rb("error.oops"),submitButtonDisabled:false});}}console.log("response : ",response);};var callBackFailure=function callBackFailure(response){console.log("Error in CONTACT_US");me.setState({submitButtonDisabled:false});};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("CONTACT_US"),formData).post(callBackSuccess,callBackFailure);};_this.submitLumosContactForm=function(){var me=this;__WEBPACK_IMPORTED_MODULE_10_jquery___default()(".contactus .server-messages").removeClass("success");var formData={"userId":this.state.contact_userid,"name":this.state.contact_userid,"email":this.state.contact_emailid,"subject":this.state.selectedContactOption.label,"message":this.state.contact_message};me.setState({submitButtonDisabled:true});__WEBPACK_IMPORTED_MODULE_10_jquery___default.a.ajax({url:me.getUrlFor("LUMOS_CONTACT_US"),data:formData,type:'POST',xhrFields:{withCredentials:true},crossDomain:true,success:function success(response){switch(response.code){case 200:__WEBPACK_IMPORTED_MODULE_10_jquery___default()(".contactus .server-messages").addClass("success");//me.setState({serverMessage:me.rb("contactus.success")});
me.setState({submitButtonDisabled:true});me.props.successContactus(me.rb("contactus.success"));break;default:me.setState({serverMessage:response.message,submitButtonDisabled:false});}},error:function error(response){console.log("Error in lumos login",response);me.setState({submitButtonDisabled:false});}});};_this.state={contact_type:'',contact_emailid:'',contact_phone:'',contact_city:'',contact_message:'',contact_userid:"",submitButtonDisabled:false,serverMessage:"",selectedContactOption:null,cityVisible:"",userIdVisible:false,emailIdVisible:true,phoneVisible:true};_this.handleSubmit=_this.handleSubmit.bind(_this);_this.handleChange=_this.handleChange.bind(_this);_this.contactTypeDropdownChange=_this.contactTypeDropdownChange.bind(_this);_this.contactTypeDpList=[];//this.selectedContactOption = null;		
return _this;}_createClass(TchrContactus,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(){this.setState({serverMessage:"",contact_emailid:"",contact_phone:"",contact_city:"",contact_message:"",contact_userid:""});}},{key:'componentDidMount',value:function componentDidMount(){this.sessionCheck();this.populateContactDropdown();}},{key:'handleChange',value:function handleChange(e){var _setState;var target=e.currentTarget;//console.log("target=",target);
this.form.validateFields(target);this.setState((_setState={},_defineProperty(_setState,target.name,target.value),_defineProperty(_setState,'serverMessage',""),_defineProperty(_setState,'submitButtonDisabled',!this.form.isValid()),_setState));}},{key:'handleSubmit',value:function handleSubmit(e){e.preventDefault();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){this.submitForm();}}},{key:'populateContactDropdown',value:function populateContactDropdown(){this.contactTypeDpList.push({"label":this.rb("contactus.dropdown4"),"value":1});this.setState({selectedContactOption:this.contactTypeDpList[0]});}},{key:'contactTypeDropdownChange',value:function contactTypeDropdownChange(selectedOption){var me=this;this.setState({selectedContactOption:selectedOption,serverMessage:"",cityVisible:"hidden",userIdVisible:false,emailIdVisible:false,phoneVisible:false,contact_emailid:"",contact_phone:"",contact_city:"",contact_message:"",contact_userid:""});if(selectedOption.value==1){this.setState({selectedContactOption:selectedOption,cityVisible:"",emailIdVisible:true,phoneVisible:true});}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'loginRoot',className:'plpLogin contactus'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rounded-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this2.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'textAlignLeft'},this.rb("contactus.dropdown4")),function(){if(_this2.state.userIdVisible==true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'contact_userid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'contact_userid',className:'contact_userid',name:'contact_userid',placeholder:_this2.rb("login.userid"),value:_this2.state.contact_userid,onChange:_this2.handleChange,required:true,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'contact_userid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},_this2.rb("login.useridrequired"))));}}(),function(){if(_this2.state.emailIdVisible==true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'contact_emailid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'contact_emailid',className:'contact_emailid',name:'contact_emailid',placeholder:_this2.rb("fpwd.email"),innerRef:function innerRef(email){return _this2.email=email;},value:_this2.state.contact_emailid,onChange:_this2.handleChange,required:true,maxLength:254,pattern:'^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$',autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'contact_emailid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},_this2.rb("fpwd.emailrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},_this2.rb("fpwd.validemail"))));}}(),function(){if(_this2.state.phoneVisible==true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'contact_phone'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'contact_phone',className:'contact_phone',name:'contact_phone',placeholder:_this2.rb("contactus.phoneno"),innerRef:function innerRef(phone){return _this2.phone=phone;},value:_this2.state.contact_phone,onChange:_this2.handleChange,pattern:'.{10,}',maxLength:20,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'contact_phone'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},_this2.rb("register.mobilerequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},_this2.rb("register.mobilenolength")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length>0&&!/\d/.test(value);}},_this2.rb("register.numbersonly")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'*'})));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'contact_city',className:this.state.cityVisible},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'contact_city',className:'contact_city',name:'contact_city',placeholder:this.rb("contactus.city"),value:this.state.contact_city,onChange:this.handleChange,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'4'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'contact_message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{type:'contact_message',className:'contact_message',name:'contact_message',placeholder:this.rb("contactus.message"),value:this.state.contact_message,onChange:this.handleChange,required:true,maxLength:3500,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'contact_message'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("contactus.messagerequired")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages'},__WEBPACK_IMPORTED_MODULE_5_react_html_parser___default()(this.state.serverMessage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-ga':'Footer - Contact Us - Send',disabled:this.state.submitButtonDisabled,className:'submitButton signup'},this.rb("login.send")))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));}}]);return TchrContactus;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (TchrContactus);

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_device_detect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateNewAccountForm=function(_PreLoginPage){_inherits(CreateNewAccountForm,_PreLoginPage);function CreateNewAccountForm(props){_classCallCheck(this,CreateNewAccountForm);var _this=_possibleConstructorReturn(this,(CreateNewAccountForm.__proto__||Object.getPrototypeOf(CreateNewAccountForm)).call(this,props));_this.hmNav=function(){//this.props.myProps.history.push(this.props.navigateURL);
window.top.location.href=this.props.navigateURL;};_this.submitForm=function(){var verificationtype="email";if(this.state.emailDisabled){verificationtype="phone";}var formData={"userName":this.state.username_newacc,"loginId":this.state.email_newacc,"userRole":{"role":"PRNT","level":"1"},"email":this.state.email_newacc,"phone":this.state.phone_newacc,"token":this.state.otp_newacc,"countryCode":"IN","password":this.state.password_newacc,"verificationType":verificationtype,"regnProvider":"heymath"};var me=this;var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status.toLowerCase()=="success"){new __WEBPACK_IMPORTED_MODULE_7__util_UserStore__["a" /* default */]().store(response.user);//me.props.successRegisterMsg(me.rb("register.success.msg"));
try{me.doLumosLogout();}catch(e){}me.trackMe(true,"register");me.hmNav();}else{if(response.status=="user_exists"){me.setState({serverMessage:"User already exists"});}else if(response.status=="no_such_token"){me.setState({serverMessage:"The Passcode entered is incorrect"});}else if(response.status=="error"){me.setState({serverMessage:"Internal error occured"});}else if(response.status=="empty_inputs"){me.setState({serverMessage:"Please enter all the fields"});}else if(response.status=="token_not_verified"){me.setState({serverMessage:"Passcode Verification is required"});}else if(response.status=="provider_forbidden"){me.setState({serverMessage:"Already registered with Gmail ID. Please click continue with Google"});}else{me.setState({serverMessage:response.status});}me.trackMe(false,"register");}}console.log("response : ",response);};var callBackFailure=function callBackFailure(response){console.log("Error in CREATE_REGISTER");me.showAlert("","Error in CREATE_REGISTER");me.trackMe(false,"register");};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("CREATE_REGISTER"),formData).post(callBackSuccess,callBackFailure);new __WEBPACK_IMPORTED_MODULE_7__util_UserStore__["a" /* default */]().clearOldUser();};_this.state={username_newacc:'',email_newacc:'',phone_newacc:'',otp_newacc:'',password_newacc:'',confirmpassword_newacc:'',submitButtonDisabled:false,serverMessage:"",emailfeedbackmsg:"",source:"plp",isOTPSend:false,isVerified:false,OTPDisabled:"hidden",verifyDisabled:"disabled",emailDisabled:false,phoneDisabled:false,verifyText:_this.rb("register.verify"),sendOTPText:_this.rb("register.sendOTP")};_this.navigationKey="PLP_Navigation";_this.handleChange=_this.handleChange.bind(_this);_this.OTPChange=_this.OTPChange.bind(_this);_this.enterOTPChange=_this.enterOTPChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.showforgotPwd=_this.showforgotPwd.bind(_this);_this.sendOTP=_this.sendOTP.bind(_this);_this.verifyOTP=_this.verifyOTP.bind(_this);_this.getOTPField=_this.getOTPField.bind(_this);_this.googleLogin=_this.googleLogin.bind(_this);_this.doLumosLogout=_this.doLumosLogout.bind(_this);_this.myTrackerInstance=_this.getTracker();return _this;}_createClass(CreateNewAccountForm,[{key:'componentDidMount',value:function componentDidMount(){this.sessionCheck();}},{key:'handleChange',value:function handleChange(e){var _setState;var target=e.currentTarget;//console.log("target=",target);
this.form.validateFields(target);this.setState((_setState={},_defineProperty(_setState,target.name,target.value),_defineProperty(_setState,'serverMessage',""),_defineProperty(_setState,'submitButtonDisabled',!this.form.isValid()),_setState));}},{key:'OTPChange',value:function OTPChange(e){//console.log(e.currentTarget);
var target=e.currentTarget;if(target.name=="email_newacc"){this.setState({OTPDisabled:"hidden",isOTPSend:false,isVerified:false,password_newacc:""});if(target.value.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){this.setState({OTPDisabled:""});}}/*if(this.phone.value.length == 10 || this.email.value.length > 0){
			this.setState({ OTPDisabled: ""});
		}else{
			this.setState({ OTPDisabled: "disabled"});
		}*//*if(this.email.value.length>0){
			this.setState({ emailDisabled: false, phoneDisabled:true});
		}
		else if(this.phone.value.length>0){
			this.setState({ emailDisabled: true, phoneDisabled:false});
		}else{
			this.setState({ emailDisabled: false, phoneDisabled:false});
		}*/this.handleChange(e);}},{key:'enterOTPChange',value:function enterOTPChange(e){if(this.otp.value.length>0){this.setState({verifyDisabled:""});}else{this.setState({verifyDisabled:"disabled"});}this.handleChange(e);}},{key:'doLumosLogout',value:function doLumosLogout(){var me=this;console.log("logout url="+me.getUrlFor("LUMOS_LOGOUT"));__WEBPACK_IMPORTED_MODULE_9_jquery___default.a.ajax({url:me.getUrlFor("LUMOS_LOGOUT"),type:'GET',xhrFields:{withCredentials:true},crossDomain:true,success:function success(response){},error:function error(response){console.log("Error in LUMOS_LOGOUT",response);}});}},{key:'trackMe',value:function trackMe(result,source){var trackObj={"name":this.state.username_newacc,"email":this.state.email_newacc,"phone":this.state.phone_newacc,"event_source":this.getTracker().enums.signupEventSource[source],"result":result};this.initiateTrack("signup",trackObj);}},{key:'handleSubmit',value:function handleSubmit(e){e.preventDefault();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){this.submitForm();}}},{key:'showforgotPwd',value:function showforgotPwd(){this.props.callbackForgotPwd(this.state.source);}},{key:'sendOTP',value:function sendOTP(){var me=this;var otpServerMsg="";if(me.state.isOTPSend){otpServerMsg="Passcode is sent again to your email";}else{otpServerMsg="Passcode is sent to your email";}me.setState({serverMessage:"",emailfeedbackmsg:"",isOTPSend:true,isVerified:false,verifyDisabled:"disabled",otp_newacc:""});var verificationtype="email";if(this.state.emailDisabled){verificationtype="phone";}var formData={"contactId":this.state.email_newacc,"contactName":this.state.username_newacc,"contactType":verificationtype};if(this.state.emailDisabled){formData={"contactId":this.state.phone_newacc,"contactType":"phone"};}var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status){if(response.status=="user_exists"){me.setState({serverMessage:"User already exists"});}else if(response.status=="no_such_token"){me.setState({serverMessage:"The Passcode entered is incorrect"});}else if(response.status=="error"){me.setState({serverMessage:"Internal error occured"});}else{me.setState({emailfeedbackmsg:otpServerMsg});}}if(response.status=="success"){me.trackMe(true,"send_otp");}else{me.trackMe(false,"send_otp");}}console.log("response : ",response);};var callBackFailure=function callBackFailure(response){console.log("Error in CREATE_SENDVERIFICATION_TOKEN");me.trackMe(false,"send_otp");};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("CREATE_SENDVERIFICATION_TOKEN"),formData).post(callBackSuccess,callBackFailure);}},{key:'verifyOTP',value:function verifyOTP(){var me=this;me.setState({serverMessage:""});var verificationtype="email";if(this.state.emailDisabled){verificationtype="phone";}var formData={"verificationId":this.state.email_newacc};if(this.state.emailDisabled){formData={"verificationId":this.state.phone_newacc};}var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status){if(response.status=="user_exists"){me.setState({serverMessage:"User already exists"});me.trackMe(false,"verify_otp");}else if(response.status=="no_such_token"){me.setState({serverMessage:"The Passcode entered is incorrect"});me.trackMe(false,"verify_otp");}else if(response.status=="error"){me.setState({serverMessage:"Internal error occured"});me.trackMe(false,"verify_otp");}else{me.setState({isVerified:true});me.trackMe(true,"verify_otp");}}}console.log("response : ",response);};var callBackFailure=function callBackFailure(response){console.log("Error in CREATE_SENDVERIFICATION_TOKEN");me.trackMe(false,"verify_otp");};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("CREATE_VERIFY_EMAIL")+verificationtype+"/"+this.state.otp_newacc,formData).post(callBackSuccess,callBackFailure);}},{key:'getOTPField',value:function getOTPField(){var _this2=this;if(this.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'otp_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'otp_newacc',className:'otp_newacc',name:'otp_newacc',placeholder:this.rb("register.enterOTP"),innerRef:function innerRef(otp){return _this2.otp=otp;},value:this.state.otp_newacc,onChange:this.enterOTPChange,required:true,minLength:1,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'otp_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("register.enterOTP")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'})));}}},{key:'getVerifyField',value:function getVerifyField(){if(this.state.isOTPSend&&!this.state.isVerified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"submitButton verifyButton float-right "+this.state.verifyDisabled,onClick:this.verifyOTP},this.rb("register.verify"));}else if(this.state.isOTPSend&&this.state.isVerified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right verifytxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'done'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("register.verified")));}}},{key:'sendOTPText',value:function sendOTPText(){if(this.state.isOTPSend){return this.rb("register.reSendOTP");}else{return this.rb("register.sendOTP");}}},{key:'showEmailFeedback',value:function showEmailFeedback(){if(this.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-control-feedback'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error'},this.state.emailfeedbackmsg),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedbacksmall'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'All important information will be sent to this email ID')));}}},{key:'googleLogin',value:function googleLogin(){var navigateObj={navigateURL:this.props.navigateURL};__WEBPACK_IMPORTED_MODULE_3__util_BrowserStorageUtil__["a" /* default */].storeSessionItem(this.navigationKey,JSON.stringify(navigateObj));if(!this.tracked){this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"signin-googlesignin"});this.tracked=true;}window.top.location.href=this.getUrlFor("GOOGLE_LOGIN_API");}},{key:'render',value:function render(){var _this3=this;if(this.state.loggedIn){return _get(CreateNewAccountForm.prototype.__proto__||Object.getPrototypeOf(CreateNewAccountForm.prototype),'render',this).call(this);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'loginRoot',className:'plpLogin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rounded-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this3.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'username_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'username_newacc',className:'username_newacc',name:'username_newacc',placeholder:this.rb("billing.fullname"),value:this.state.username_newacc,onChange:this.handleChange,required:true,minLength:1,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'username_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.namerequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'email_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'email_newacc',className:'email_newacc',name:'email_newacc',placeholder:this.rb("fpwd.email"),innerRef:function innerRef(email){return _this3.email=email;},value:this.state.email_newacc,onChange:this.OTPChange,disabled:this.state.emailDisabled,required:true,pattern:'^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$',maxLength:254,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'email_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("fpwd.emailrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},this.rb("fpwd.validemail")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left emailfeedback'},this.showEmailFeedback()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"submitButton OTPButton float-right "+this.state.OTPDisabled,onClick:this.sendOTP},this.sendOTPText()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),this.getOTPField(),this.getVerifyField(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'phone_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'phone_newacc',className:'phone_newacc',name:'phone_newacc',placeholder:this.rb("register.phone"),innerRef:function innerRef(phone){return _this3.phone=phone;},value:this.state.phone_newacc,onChange:this.handleChange,pattern:'.{10,}',maxLength:20,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'phone_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("register.mobilerequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},this.rb("register.mobilenolength")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length>0&&!/\d/.test(value);}},this.rb("register.numbersonly")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'password_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'password_newacc',name:'password_newacc',placeholder:this.rb("login.password"),innerRef:function innerRef(password){return _this3.password=password;},value:this.state.password_newacc,onChange:this.handleChange,required:true,minLength:6,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'password_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("login.pwdrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("validate.pwd.minimum",[6])))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'confirmpassword'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'confirmpassword_newacc',name:'confirmpassword_newacc',placeholder:this.rb("rpwd.confirmpwd"),innerRef:function innerRef(confirmpassword){return _this3.confirmpassword=confirmpassword;},value:this.state.confirmpassword_newacc,onChange:this.handleChange,required:true,minLength:6,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'confirmpassword_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("rpwd.confirmpwdrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("validate.pwd.minimum",[6])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value!==_this3.password.value;}},this.rb("rpwd.doesnotmatch")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages'},this.state.serverMessage),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-ga':'Home - Sign in - Users who want to register - Sign Up',disabled:this.state.submitButtonDisabled,className:'submitButton signup'},this.rb("register.signup"))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loginTop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center josefin mt-20'},'OR'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'socialLoginContainer text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Home - Users who have independently registered - Sign Up - New User - Sign in with Google - Start Learning',className:'socialLoginButtons google',onClick:this.googleLogin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fab fa-google'}),this.rb("login.google"))))));}}}]);return CreateNewAccountForm;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (CreateNewAccountForm);

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_html_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_form_with_constraints_bootstrap4__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_form_with_constraints_bootstrap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_form_with_constraints_bootstrap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_device_detect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_icons_forgotpwdicon_png__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_icons_forgotpwdicon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_icons_forgotpwdicon_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var fpServerResponses={200:'An email has been sent to <span class="hm-blue"><email></span> with the link to reset the password. Please check your Inbox and Spam/Junk folders.',403:'You are not allowed to reset your password. Please write to <a href="mailto:support@heymath.com">support@heymath.com</a>',600:'Invalid User ID or Email.',// also for 400, 401
0:'An unexpected error occurred. Please try again after sometime or write to <a href="mailto:support@heymath.com">support@heymath.com</a>'};var ForgotPasswordForm=function(_PreLoginPage){_inherits(ForgotPasswordForm,_PreLoginPage);function ForgotPasswordForm(props){_classCallCheck(this,ForgotPasswordForm);var _this=_possibleConstructorReturn(this,(ForgotPasswordForm.__proto__||Object.getPrototypeOf(ForgotPasswordForm)).call(this,props));_this.submitLumosPwdForm=function(){var me=this;var formData={"userId":this.state.username,"email":this.state.email};me.setState({submitButtonDisabled:true});__WEBPACK_IMPORTED_MODULE_4_jquery___default.a.ajax({url:me.getUrlFor("LUMOS_FORGOTPWD"),data:formData,type:'POST',xhrFields:{withCredentials:true},crossDomain:true,success:function success(response){switch(response.code){case 200://me.setState({serverMessage: fpServerResponses[response.code].replace(/<email>/g, formData.emailId)});
me.props.successForgotPwd(fpServerResponses[response.code].replace(/<email>/g,me.state.email));break;case 403:me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[response.code].replace(/<email>/g,me.state.email)});break;case 400:case 401:case 600:me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[600]});break;default://currentDialog.serverMessageElem.innerHTML = fpServerResponses[0];
me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[0]});}me.trackMe();},error:function error(response){console.log("Error in lumos login",response);me.setState({submitButtonDisabled:false});me.trackMe();}});};_this.state={username:'',email:'',submitButtonDisabled:false,UseridEmailidSame:false,serverMessage:""};_this.handleChange=_this.handleChange.bind(_this);_this.handleemailChange=_this.handleemailChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.submitLumosPwdForm=_this.submitLumosPwdForm.bind(_this);_this.submitPLPPwdForm=_this.submitPLPPwdForm.bind(_this);_this.renderUseridEmailidValue=_this.renderUseridEmailidValue.bind(_this);_this.handleCheckboxChange=_this.handleCheckboxChange.bind(_this);_this.myTrackerInstance=_this.getTracker();return _this;}_createClass(ForgotPasswordForm,[{key:'componentDidMount',value:function componentDidMount(){this.sessionCheck();}},{key:'handleForgotPwd',value:function handleForgotPwd(){}},{key:'handleChange',value:function handleChange(e){var _setState;var target=e.currentTarget;this.form.validateFields(target);this.setState((_setState={},_defineProperty(_setState,target.name,target.value),_defineProperty(_setState,'submitButtonDisabled',!this.form.isValid()),_setState));}},{key:'handleemailChange',value:function handleemailChange(e){this.handleChange(e);}},{key:'trackMe',value:function trackMe(){/*var trackObj = {
				"login_id":this.state.username,
				"email": this.state.email
		}

		this.initiateTrack("forgot_password",trackObj);*/}},{key:'submitPLPPwdForm',value:function submitPLPPwdForm(){var userId=this.state.username;var emailId=this.state.email;if(this.state.UseridEmailidSame){userId=emailId;}var formData={"userId":userId,"emailId":emailId};var me=this;me.setState({submitButtonDisabled:true});var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status=="SUCCESS"){//me.setState({serverMessage: fpServerResponses[200].replace(/<email>/g, formData.emailId)});
me.props.successForgotPwd(fpServerResponses[200].replace(/<email>/g,formData.emailId));}else if(response.status=="INVALID_EMAIL"){me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[600]});}else if(response.status=="INVALID_USERID"){me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[600]});}else if(response.status=="PROVIDER_FORBIDDEN"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("google.errmsg.pwd")});}else{me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[0]});}}me.trackMe();console.log("response : ",response);};var callBackFailure=function callBackFailure(response){me.setState({submitButtonDisabled:false});me.trackMe();};new __WEBPACK_IMPORTED_MODULE_7__util_HmAjax__["a" /* default */](this.getUrlFor("FORGOT_PWD"),formData).post(callBackSuccess,callBackFailure);}},{key:'handleSubmit',value:function handleSubmit(e){e.preventDefault();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid(),serverMessage:""});if(this.form.isValid()){if(this.props.source.toLowerCase()=="lumos"){this.submitLumosPwdForm();}else{this.submitPLPPwdForm();}}}},{key:'handleCheckboxChange',value:function handleCheckboxChange(event){var target=event.target;this.setState({"UseridEmailidSame":target.checked});if(event.target){this.setState({username:this.state.email});}}},{key:'renderUseridEmailidValue',value:function renderUseridEmailidValue(){if(this.state.UseridEmailidSame){return this.state.email;}else{return this.state.username;}}},{key:'checkForDisabled',value:function checkForDisabled(){if(this.state.UseridEmailidSame){return true;}else{return false;}}},{key:'render',value:function render(){var _this2=this;if(this.state.loggedIn){return _get(ForgotPasswordForm.prototype.__proto__||Object.getPrototypeOf(ForgotPasswordForm.prototype),'render',this).call(this);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row nomargin loginParent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-4 nopadding loginLeftSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'loginLeftContent'},this.rb("forgot_password_label")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'charactercontainer d-none d-sm-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'charactericons forgotpwdIcon',src:__WEBPACK_IMPORTED_MODULE_10__images_icons_forgotpwdicon_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'loginRoot',className:'col-sm-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center schoolLoginInfo josefinsansFont nopadding'},this.rb("fpwd.msg1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.rb("fpwd.msg2"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),function(){if(_this2.props.source.toLowerCase()=="lumos"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center schoolLoginInfo josefinsansFont'},__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(_this2.rb("fpwd.lumos.msg")));}}())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rounded-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this2.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'email'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'email',className:'email',name:'email',placeholder:this.rb("fpwd.email"),innerRef:function innerRef(email){return _this2.email=email;},value:this.state.email,onChange:this.handleemailChange,required:true,maxLength:254,pattern:'^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$',minLength:1,tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'email',show:'all'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("fpwd.emailrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},this.rb("fpwd.validemail")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'username'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'username',className:'username',name:'username',placeholder:this.rb("login.userid"),value:this.renderUseridEmailidValue(),onChange:this.handleChange,disabled:this.checkForDisabled(),required:true,minLength:1,maxLength:254,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'username'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("login.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),function(){if(_this2.props.source.toLowerCase()=="plp"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'checkboxLabel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'fwdCheckbox',name:'sameUseridEmailid',type:'checkbox',onChange:_this2.handleCheckboxChange}),_this2.rb("fpwd.plp.useridemailidsame")));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'forgotpwdMsg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages'},' ',__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(this.state.serverMessage))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:this.state.submitButtonDisabled,className:'submitButton'},this.rb("login.send"))))))),function(){if(_this2.props.source.toLowerCase()=="plp"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center schoolLoginInfo josefinsansFont'},_this2.rb("fpwd.plp.note"));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))));}}}]);return ForgotPasswordForm;}(__WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__["a" /* default */]);/* unused harmony default export */ var _unused_webpack_default_export = (ForgotPasswordForm);

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_device_detect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_html_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_icons_forgotpwdicon_png__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_icons_forgotpwdicon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_icons_forgotpwdicon_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var fpServerResponses={200:'An email has been sent to <span class="hm-blue"><email></span> with the link to reset the password. Please check your Inbox and Spam/Junk folders.',403:'You are not allowed to reset your password. Please write to <a href="mailto:support@heymath.com">support@heymath.com</a>',600:'Invalid User ID or Email.',// also for 400, 401
0:'An unexpected error occurred. Please try again after sometime or write to <a href="mailto:support@heymath.com">support@heymath.com</a>'};var ForgotPwd=function(_PreLoginPage){_inherits(ForgotPwd,_PreLoginPage);function ForgotPwd(props){_classCallCheck(this,ForgotPwd);var _this=_possibleConstructorReturn(this,(ForgotPwd.__proto__||Object.getPrototypeOf(ForgotPwd)).call(this,props));_this.hmNav=function(){//this.props.myProps.history.push(this.props.navigateURL);
window.top.location.href=this.props.navigateURL;};_this.submitForm=function(){var verificationtype=this.state.loginType;var formData={"userId":this.state.userInput,"password":this.state.password_newacc//do cofirm
};var me=this;me.setState({submitButtonDisabled:true});var callBackSuccess=function callBackSuccess(response){console.log("response : ",response);if(response!==null){me.setState({validToken:response.isValid,pwdUpdated:response.passwordUpdated,loader:false});setTimeout(function(){console.log("timeout..........");me.bindLoginLink();},500);me.trackMe(true,"set_password");}else{me.trackMe(false,"set_password");}};var callBackFailure=function callBackFailure(response){me.setState({submitButtonDisabled:false});me.trackMe(false,"set_password");};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("PWD_RECOVER")+this.state.otp_newacc,formData).put(callBackSuccess,callBackFailure);};_this.state={username_newacc:'',password_newacc:'',confirmpassword_newacc:'',singupType:"userid",loginType:_this.props.loginType||"userid",userInput:_this.props.userInput||"",otp_newacc:'',submitButtonDisabled:false,serverMessage:"",emailfeedbackmsg:"",source:"plp",isOTPSend:false,isVerified:false,OTPDisabled:"hiddenOTP",verifyDisabled:"disabled",emailDisabled:false,phoneDisabled:false,verifyText:_this.rb("register.verify"),sendOTPText:_this.rb("register.sendOTP"),pwdUpdated:false,passcodeDisabled:"disabled"};_this.handleChange=_this.handleChange.bind(_this);_this.enterOTPChange=_this.enterOTPChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.userIdChange=_this.userIdChange.bind(_this);_this.sendOTP=_this.sendOTP.bind(_this);_this.verifyOTP=_this.verifyOTP.bind(_this);_this.getOTPField=_this.getOTPField.bind(_this);_this.showLogin=_this.showLogin.bind(_this);_this.handleKeyUp=_this.handleKeyUp.bind(_this);_this.myTrackerInstance=_this.getTracker();return _this;}_createClass(ForgotPwd,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var me=this;//console.log('componentWillReceiveProps', nextProps);    
this.setState({loginType:nextProps.loginType||"userid",userInput:nextProps.userInput||"",otp_newacc:'',submitButtonDisabled:false,serverMessage:"",emailfeedbackmsg:"",source:"plp",isOTPSend:false,isVerified:false,OTPDisabled:"hiddenOTP",verifyDisabled:"disabled",emailDisabled:false,phoneDisabled:false,verifyText:this.rb("register.verify"),sendOTPText:this.rb("register.sendOTP"),pwdUpdated:false,passcodeDisabled:"disabled"});setTimeout(function(){me.reinitiate();},500);}},{key:'componentDidMount',value:function componentDidMount(){this.sessionCheck();this.reinitiate();}},{key:'reinitiate',value:function reinitiate(){if(this.state.userInput!=""){this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){this.setState({OTPDisabled:""});__WEBPACK_IMPORTED_MODULE_9_jquery___default()(".OTPButton").trigger("click");}}__WEBPACK_IMPORTED_MODULE_9_jquery___default()("#loginRoot .userInput").focus();}},{key:'handleChange',value:function handleChange(e){var _setState;var target=e.currentTarget;//console.log("target=",target);
this.form.validateFields(target);this.setState((_setState={},_defineProperty(_setState,target.name,target.value),_defineProperty(_setState,'serverMessage',""),_defineProperty(_setState,'submitButtonDisabled',!this.form.isValid()),_setState));}},{key:'userIdChange',value:function userIdChange(e){var _setState2;var target=e.currentTarget;this.form.validateFields(target);var phoneRegx=/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;if(phoneRegx.test(target.value)){this.setState({loginType:"mobile",loginMaxLength:10,OTPDisabled:"hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});if(target.value.length>=10){this.setState({OTPDisabled:"",passcodeDisabled:""});}}else{this.setState({loginType:"email",loginMaxLength:254,OTPDisabled:"hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});//this.setState({ [target.name]: "hidden",isOTPSend:false,isVerified:false,password_newacc:""});
/*if(target.value.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){
				this.setState({ OTPDisabled: ""});
			}*/if(target.value.length>0){this.setState({OTPDisabled:"",passcodeDisabled:""});}}this.setState((_setState2={},_defineProperty(_setState2,target.name,target.value),_defineProperty(_setState2,'serverMessage',""),_defineProperty(_setState2,'submitButtonDisabled',true),_setState2));}},{key:'enterOTPChange',value:function enterOTPChange(e){if(this.otp.value.length>0){this.setState({verifyDisabled:""});}else{this.setState({verifyDisabled:"disabled"});}this.handleChange(e);}},{key:'bindLoginLink',value:function bindLoginLink(){var me=this;console.log("link::",__WEBPACK_IMPORTED_MODULE_9_jquery___default()("#loginLink"));__WEBPACK_IMPORTED_MODULE_9_jquery___default()("#loginLink").click(function(){me.showLogin();});}},{key:'trackMe',value:function trackMe(result,source){/*var trackObj = {
				"name": this.state.username_newacc,
			    "email": (this.state.loginType == "mobile") ? "" : this.state.userInput,
			    "phone": (this.state.loginType == "mobile") ? this.state.userInput : "",
			    "event_source":this.getTracker().enums.signupEventSource[source],
			    "result": result
			    
		}

		this.initiateTrack("signup",trackObj);*/var trackObj={"login_id":this.state.userInput,"email":"","event_source":this.getTracker().enums.signupEventSource[source],"result":result};if(source=="set_password"){this.storeTrackEvent("forgot_password",trackObj);}else{this.initiateTrack("forgot_password",trackObj);}}},{key:'handleSubmit',value:function handleSubmit(e){e.preventDefault();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){if(this.state.isOTPSend&&this.state.isVerified){this.submitForm();}}}},{key:'sendOTP',value:function sendOTP(){if(this.state.OTPDisabled=="hiddenOTP"){this.form.validateFields();return;}var me=this;var otpServerMsg="";if(this.state.loginType=="mobile"){if(me.state.isOTPSend){otpServerMsg="OTP is sent again to mobile";}else{otpServerMsg="OTP is sent to your mobile";}}else{if(me.state.isOTPSend){otpServerMsg="OTP is sent again to your email";}else{otpServerMsg="OTP is sent to your email";}}me.setState({serverMessage:"",emailfeedbackmsg:"",isOTPSend:false,isVerified:false,verifyDisabled:"disabled",otp_newacc:"",passcodeDisabled:"disabled"});var formData={"userId":this.state.userInput,"contactType":this.state.loginType};var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status){if(response.status=="user_exists"){me.setState({serverMessage:"User already exists",passcodeDisabled:""});}else if(response.status=="no_such_token"){me.setState({serverMessage:"The OTP entered is incorrect",passcodeDisabled:""});}else if(response.status=="error"){me.setState({serverMessage:"Internal error occured",passcodeDisabled:""});}else if(response.status=="INVALID_EMAIL"){me.setState({serverMessage:fpServerResponses[600],passcodeDisabled:""});}else if(response.status=="INVALID_USERID"){me.setState({serverMessage:fpServerResponses[600],passcodeDisabled:""});}else if(response.status=="PROVIDER_FORBIDDEN"){me.setState({serverMessage:me.rb("google.errmsg.pwd"),passcodeDisabled:""});}else{me.setState({emailfeedbackmsg:otpServerMsg});}}if(response.status.toLowerCase()=="success"){me.setState({isOTPSend:true,passcodeDisabled:"disabled"});me.trackMe(true,"send_otp");}else{me.trackMe(false,"send_otp");}}console.log("response : ",response);};var callBackFailure=function callBackFailure(response){console.log("Error in FORGOT_PWD");me.setState({passcodeDisabled:""});me.trackMe(false,"send_otp");};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("FORGOT_PWD"),formData).post(callBackSuccess,callBackFailure);}},{key:'verifyOTP',value:function verifyOTP(){var me=this;var formData={"userId":this.state.userInput};me.setState({serverMessage:""});var verificationtype=this.state.loginType;this.setState({verifyDisabled:"disabled"});var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status){if(response.status=="user_exists"){me.setState({serverMessage:"User already exists",verifyDisabled:""});me.trackMe(false,"verify_otp");}else if(response.status=="no_such_token"||response.status=="NO_TOKEN_AVAILABLE"){me.setState({serverMessage:"The OTP entered is incorrect",verifyDisabled:""});me.trackMe(false,"verify_otp");}else if(response.isValid==false){me.setState({serverMessage:"The OTP entered is incorrect",verifyDisabled:""});me.trackMe(false,"verify_otp");}else if(response.status=="error"){me.setState({serverMessage:"Internal error occured",verifyDisabled:""});me.trackMe(false,"verify_otp");}else{me.setState({isVerified:true,verifyDisabled:""});me.trackMe(true,"verify_otp");}}}console.log("response : ",response);};var callBackFailure=function callBackFailure(response){console.log("Error in PWD_TOKEN_VALIDATE");me.setState({verifyDisabled:""});me.trackMe(false,"verify_otp");};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("PWD_TOKEN_VALIDATE")+this.state.otp_newacc,formData).post(callBackSuccess,callBackFailure);}},{key:'getOTPField',value:function getOTPField(){var _this2=this;if(this.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'otp_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'otp_newacc',className:'otp_newacc',name:'otp_newacc',placeholder:this.rb("register.enterOTP"),innerRef:function innerRef(otp){return _this2.otp=otp;},onKeyUp:this.handleKeyUp,value:this.state.otp_newacc,onChange:this.enterOTPChange,required:true,minLength:1,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'otp_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("register.enterOTP")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'})));}}},{key:'showLogin',value:function showLogin(){this.props.showNewLoginForm();}},{key:'getVerifyField',value:function getVerifyField(){if(this.state.isOTPSend&&!this.state.isVerified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"submitButton verifyButton "+this.state.verifyDisabled,onClick:this.verifyOTP},this.rb("register.verify"));}/*else if(this.state.isOTPSend && this.state.isVerified){
			return (<div className="text-right verifytxt"><i class="material-icons">done</i> <span>{this.rb("register.verified")}</span></div>);
		}*/}},{key:'getSignupHeaderMsg',value:function getSignupHeaderMsg(){if(this.state.isOTPSend&&!this.state.isVerified){if(this.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10'},'Please enter the 6-digit OTP sent to'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10'},'Please enter the 6-digit OTP sent to'));}}else if(this.state.isVerified){if(this.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10'},'You have requested to reset the password for'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small mt-10'},'+91 ',this.state.userInput));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10'},'You have requested to reset the password for'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small mt-10'},this.state.userInput));}}}},{key:'sendOTPText',value:function sendOTPText(){if(this.state.isOTPSend){return this.rb("register.reSendOTP");}else{return this.rb("register.sendOTP");}}},{key:'showEmailFeedback',value:function showEmailFeedback(){var _this3=this;if(this.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-control-feedback'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error'},this.state.emailfeedbackmsg),function(){if(_this3.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedbacksmall'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'All important information will be sent to this mobile number'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedbacksmall'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'All important information will be sent to this email ID'));}}());}}},{key:'getUserInputPattern',value:function getUserInputPattern(){if(this.state.loginType=="mobile"){return".{10,}";}else{return"^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$";}}},{key:'getContactType',value:function getContactType(){var _this4=this;if(!this.state.isVerified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'userInput'},function(){if(_this4.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'countrycodeform'},'+91');}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'userInput',className:"userInput "+this.state.loginType,name:'userInput',placeholder:this.rb("login.userplaceholder"),innerRef:function innerRef(email){return _this4.email=email;},onKeyUp:this.handleKeyUp,value:this.state.userInput,onChange:this.userIdChange,pattern:this.getUserInputPattern(),required:true,minLength:1,maxLength:this.state.loginMaxLength,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'2'}),function(){if(_this4.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'userInput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},_this4.rb("login.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},_this4.rb("register.mobilenolength")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length>0&&!/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g.test(value);}},_this4.rb("register.numbersonly")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'userInput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},_this4.rb("login.useridrequired")));}}()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),this.getOTPField(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages pb-20'},this.state.serverMessage),function(){if(_this4.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this4.rb("register.reSendOTPmsg"),' '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pl-20 resendButton',onClick:_this4.sendOTP},_this4.rb("register.reSendOTP"))),_this4.getVerifyField());}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this4.getVerifyField(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"submitButton OTPButton "+_this4.state.OTPDisabled+" "+_this4.state.passcodeDisabled,onClick:_this4.sendOTP},_this4.rb("register.sendOTP"))));}}());}}},{key:'setPassword',value:function setPassword(){var _this5=this;if(this.state.isVerified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'password_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'password_newacc',name:'password_newacc',placeholder:this.rb("login.password"),innerRef:function innerRef(password){return _this5.password=password;},value:this.state.password_newacc,onChange:this.handleChange,required:true,minLength:6,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'password_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("login.pwdrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("validate.pwd.minimum",[6])))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'confirmpassword'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'confirmpassword_newacc',name:'confirmpassword_newacc',placeholder:this.rb("rpwd.confirmpwd"),innerRef:function innerRef(confirmpassword){return _this5.confirmpassword=confirmpassword;},value:this.state.confirmpassword_newacc,onChange:this.handleChange,required:true,minLength:6,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'confirmpassword_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("rpwd.confirmpwdrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("validate.pwd.minimum",[6])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value!==_this5.password.value;}},this.rb("rpwd.doesnotmatch")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages pt-20'},this.state.serverMessage));}}},{key:'renderRHSForm',value:function renderRHSForm(){var _this6=this;if(this.state.pwdUpdated===true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 mt-50'},__WEBPACK_IMPORTED_MODULE_10_react_html_parser___default()(this.rb("rpwd.msg.success"))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rounded-0'},this.getSignupHeaderMsg(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this6.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},this.getContactType(),this.setPassword(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-ga':'Home - Sign in - Users who want to register - Sign Up',disabled:this.state.submitButtonDisabled,className:"submitButton signup signupButton "+(this.state.isVerified?"":"hidden")},this.rb("register.setpassword"))))))))));}}},{key:'renderFormTitle',value:function renderFormTitle(){if(this.state.isOTPSend&&this.state.isVerified){return this.rb("rpwd.title");}else{return this.rb("forgot_password_label");}}},{key:'handleKeyUp',value:function handleKeyUp(event){if(event.key==='Enter'&&this.form.isValid()){if(!this.state.isVerified){if(this.state.isOTPSend&&this.state.verifyDisabled!="disabled"){__WEBPACK_IMPORTED_MODULE_9_jquery___default()(".verifyButton").trigger("click");}else if(this.state.passcodeDisabled!="disabled"){this.setState({OTPDisabled:""});__WEBPACK_IMPORTED_MODULE_9_jquery___default()(".OTPButton").trigger("click");}}}}},{key:'render',value:function render(){if(this.state.loggedIn){return _get(ForgotPwd.prototype.__proto__||Object.getPrototypeOf(ForgotPwd.prototype),'render',this).call(this);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row nomargin loginParent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-4 nopadding loginLeftSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'loginLeftContent'},this.renderFormTitle()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'charactercontainer d-none d-sm-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'charactericons forgotpwdIcon',src:__WEBPACK_IMPORTED_MODULE_11__images_icons_forgotpwdicon_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'loginRoot',className:'plpLogin col-sm-8'},this.renderRHSForm()));}}}]);return ForgotPwd;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* unused harmony default export */ var _unused_webpack_default_export = (ForgotPwd);

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_device_detect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_html_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_forgotpwdicon_png__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_forgotpwdicon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_icons_forgotpwdicon_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var fpServerResponses={200:'An email has been sent to <span class="hm-blue"><email></span> with the link to reset the password. Please check your Inbox and Spam/Junk folders.',403:'You are not allowed to reset your password. Please write to <a href="mailto:support@heymath.com">support@heymath.com</a>',600:'Invalid User ID / Email / Mobile no.',// also for 400, 401
0:'An unexpected error occurred. Please try again after sometime or write to <a href="mailto:support@heymath.com">support@heymath.com</a>'};var UnifiedForgotPwd=function(_PreLoginPage){_inherits(UnifiedForgotPwd,_PreLoginPage);function UnifiedForgotPwd(props){_classCallCheck(this,UnifiedForgotPwd);var _this=_possibleConstructorReturn(this,(UnifiedForgotPwd.__proto__||Object.getPrototypeOf(UnifiedForgotPwd)).call(this,props));_this.hmNav=function(){//this.props.myProps.history.push(this.props.navigateURL);
window.top.location.href=this.props.navigateURL;};_this.submitForm=function(){var verificationtype=this.state.loginType;var formData={"userId":this.state.userInput,"password":this.state.password_newacc//do cofirm
};var me=this;me.setState({submitButtonDisabled:true});var callBackSuccess=function callBackSuccess(response){console.log("response : ",response);if(response!==null){me.setState({validToken:response.isValid,pwdUpdated:response.passwordUpdated,loader:false});//console.log("timeout..........",me.state.pwdUpdated," : src = ",me.state.source);
setTimeout(function(){console.log("timeout..........");me.bindLoginLink();},500);me.trackMe(true,"set_password");}else{me.trackMe(false,"set_password");}};var callBackFailure=function callBackFailure(response){me.setState({submitButtonDisabled:false});me.trackMe(false,"set_password");};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("PWD_RECOVER")+this.state.otp_newacc,formData).put(callBackSuccess,callBackFailure);};_this.submitLumosPwdForm=function(){var me=this;var formData={"userId":this.state.username,"email":this.state.email};me.setState({submitButtonDisabled:true});__WEBPACK_IMPORTED_MODULE_10_jquery___default.a.ajax({url:me.getUrlFor("LUMOS_FORGOTPWD"),data:formData,type:'POST',xhrFields:{withCredentials:true},crossDomain:true,success:function success(response){switch(response.code){case 200://me.setState({serverMessage: fpServerResponses[response.code].replace(/<email>/g, formData.emailId)});
me.props.successForgotPwd(fpServerResponses[response.code].replace(/<email>/g,me.state.email));break;case 403:me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[response.code].replace(/<email>/g,me.state.email)});break;case 400:case 401:case 600:me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[600]});break;default://currentDialog.serverMessageElem.innerHTML = fpServerResponses[0];
me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[0]});}me.trackMe();},error:function error(response){console.log("Error in lumos login",response);me.setState({submitButtonDisabled:false});me.trackMe();}});};_this.state={plp_userinput:_this.props.userid||"",username_newacc:'',password_newacc:'',confirmpassword_newacc:'',singupType:"userid",loginType:_this.props.loginType||"userid",userInput:_this.props.userInput||"",otp_newacc:'',submitButtonDisabled:false,serverMessage:"",emailfeedbackmsg:"",source:"",isOTPSend:false,isVerified:false,OTPDisabled:"hiddenOTP",verifyDisabled:"disabled",emailDisabled:false,phoneDisabled:false,verifyText:_this.rb("register.verify"),sendOTPText:_this.rb("home.continue"),pwdUpdated:false,passcodeDisabled:"disabled",username:'',UseridEmailidSame:false,user_exists:false};_this.handleChange=_this.handleChange.bind(_this);_this.enterOTPChange=_this.enterOTPChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.handleSubmitVerify=_this.handleSubmitVerify.bind(_this);_this.userIdChange=_this.userIdChange.bind(_this);_this.userverifyIdChange=_this.userverifyIdChange.bind(_this);_this.sendOTP=_this.sendOTP.bind(_this);_this.verifyOTP=_this.verifyOTP.bind(_this);_this.getOTPField=_this.getOTPField.bind(_this);_this.showLogin=_this.showLogin.bind(_this);_this.handleKeyUp=_this.handleKeyUp.bind(_this);_this.myTrackerInstance=_this.getTracker();_this.handleemailChange=_this.handleemailChange.bind(_this);_this.submitLumosPwdForm=_this.submitLumosPwdForm.bind(_this);_this.submitPLPPwdForm=_this.submitPLPPwdForm.bind(_this);_this.submitCommonPwdForm=_this.submitCommonPwdForm.bind(_this);_this.renderUseridEmailidValue=_this.renderUseridEmailidValue.bind(_this);_this.handleCheckboxChange=_this.handleCheckboxChange.bind(_this);_this.plpForgotPassword=_this.plpForgotPassword.bind(_this);_this.lumosForgotPassword=_this.lumosForgotPassword.bind(_this);_this.commonForgotPassword=_this.commonForgotPassword.bind(_this);_this.forgotPassword=_this.forgotPassword.bind(_this);_this.renderRHSForm=_this.renderRHSForm.bind(_this);_this.userVerify=_this.userVerify.bind(_this);_this.getUserStatus=_this.getUserStatus.bind(_this);return _this;}_createClass(UnifiedForgotPwd,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var me=this;//console.log('componentWillReceiveProps', nextProps);    
this.setState({loginType:nextProps.loginType||"userid",userInput:nextProps.userInput||"",otp_newacc:'',submitButtonDisabled:false,serverMessage:"",emailfeedbackmsg:"",source:"",isOTPSend:false,isVerified:false,OTPDisabled:"hiddenOTP",verifyDisabled:"disabled",emailDisabled:false,phoneDisabled:false,verifyText:this.rb("register.verify"),sendOTPText:this.rb("home.continue"),pwdUpdated:false,passcodeDisabled:"disabled"});setTimeout(function(){me.reinitiate();},500);}},{key:'componentDidMount',value:function componentDidMount(){this.sessionCheck();this.reinitiate();}},{key:'reinitiate',value:function reinitiate(){if(this.state.userInput!=""){this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){this.setState({OTPDisabled:""});__WEBPACK_IMPORTED_MODULE_10_jquery___default()(".OTPButton").trigger("click");}}__WEBPACK_IMPORTED_MODULE_10_jquery___default()("#loginRoot .userInput").focus();}},{key:'handleChange',value:function handleChange(e){var _setState;var target=e.currentTarget;//console.log("target=",target);
this.form.validateFields(target);this.setState((_setState={},_defineProperty(_setState,target.name,target.value),_defineProperty(_setState,'serverMessage',""),_defineProperty(_setState,'submitButtonDisabled',!this.form.isValid()),_setState));}},{key:'handleemailChange',value:function handleemailChange(e){this.handleChange(e);}},{key:'userIdChange',value:function userIdChange(e){var _setState2;var target=e.currentTarget;this.form.validateFields(target);var phoneRegx=/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;if(phoneRegx.test(target.value)){this.setState({loginType:"mobile",loginMaxLength:10,OTPDisabled:"hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});if(target.value.length>=10){this.setState({OTPDisabled:"",passcodeDisabled:""});}}else{this.setState({loginType:"email",loginMaxLength:254,OTPDisabled:"hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});//this.setState({ [target.name]: "hidden",isOTPSend:false,isVerified:false,password_newacc:""});
/*if(target.value.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){
				this.setState({ OTPDisabled: ""});
			}*/if(target.value.length>0){this.setState({OTPDisabled:"",passcodeDisabled:""});}}this.setState((_setState2={},_defineProperty(_setState2,target.name,target.value),_defineProperty(_setState2,'serverMessage',""),_defineProperty(_setState2,'submitButtonDisabled',true),_setState2));}},{key:'userverifyIdChange',value:function userverifyIdChange(e){var _setState3;var target=e.currentTarget;this.form.validateFields(target);var phoneRegx=/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;if(phoneRegx.test(target.value)){this.setState({loginType:"mobile",loginMaxLength:10,isOTPSend:false,isVerified:false,OTPDisabled:"",passcodeDisabled:""});//this.setState({loginType:"mobile",loginMaxLength:10,OTPDisabled: "hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});
// if(target.value.length >= 1){				
// 	this.setState({ OTPDisabled: "", passcodeDisabled:""});
// }
}else{this.setState({loginType:"email",loginMaxLength:254,isOTPSend:false,isVerified:false});//this.setState({loginType:"email",loginMaxLength:254,OTPDisabled: "hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});
//this.setState({ [target.name]: "hidden",isOTPSend:false,isVerified:false,password_newacc:""});
/*if(target.value.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){
				this.setState({ OTPDisabled: ""});
			}*/if(target.value.length>0){this.setState({OTPDisabled:"",passcodeDisabled:""});}}this.setState((_setState3={},_defineProperty(_setState3,target.name,target.value),_defineProperty(_setState3,'serverMessage',""),_defineProperty(_setState3,'submitButtonDisabled',true),_setState3));//console.log(this.state);
}},{key:'enterOTPChange',value:function enterOTPChange(e){if(this.otp.value.length>0){this.setState({verifyDisabled:""});}else{this.setState({verifyDisabled:"disabled"});}this.handleChange(e);}},{key:'bindLoginLink',value:function bindLoginLink(){var me=this;console.log("link::",__WEBPACK_IMPORTED_MODULE_10_jquery___default()("#loginLink"));__WEBPACK_IMPORTED_MODULE_10_jquery___default()("#loginLink").click(function(){me.showLogin();});}},{key:'trackMe',value:function trackMe(result,source){/*var trackObj = {
				"name": this.state.username_newacc,
			    "email": (this.state.loginType == "mobile") ? "" : this.state.userInput,
			    "phone": (this.state.loginType == "mobile") ? this.state.userInput : "",
			    "event_source":this.getTracker().enums.signupEventSource[source],
			    "result": result
			    
		}

		this.initiateTrack("signup",trackObj);*/var trackObj={"login_id":this.state.userInput,"email":"","event_source":this.getTracker().enums.signupEventSource[source],"result":result};if(source=="set_password"){this.storeTrackEvent("forgot_password",trackObj);}else{this.initiateTrack("forgot_password",trackObj);}}},{key:'submitPLPPwdForm',value:function submitPLPPwdForm(){var userId=this.state.username;var emailId=this.state.email;if(this.state.UseridEmailidSame){userId=emailId;}var formData={"userId":userId,"emailId":emailId};var me=this;me.setState({submitButtonDisabled:true});var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status=="SUCCESS"){//me.setState({serverMessage: fpServerResponses[200].replace(/<email>/g, formData.emailId)});
me.props.successForgotPwd(fpServerResponses[200].replace(/<email>/g,formData.emailId));}else if(response.status=="INVALID_EMAIL"){me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[600]});}else if(response.status=="INVALID_USERID"){me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[600]});}else if(response.status=="PROVIDER_FORBIDDEN"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("google.errmsg.pwd")});}else{me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[0]});}}me.trackMe();console.log("response : ",response);};var callBackFailure=function callBackFailure(response){me.setState({submitButtonDisabled:false});me.trackMe();};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("FORGOT_PWD"),formData).post(callBackSuccess,callBackFailure);}},{key:'submitCommonPwdForm',value:function submitCommonPwdForm(){var userId=this.state.username;var emailId=this.state.email;if(this.state.UseridEmailidSame){userId=emailId;}var formData={"userId":userId,"email":emailId};var me=this;me.setState({submitButtonDisabled:true});var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.source=="plp"){if(response.status=="SUCCESS"){//me.setState({serverMessage: fpServerResponses[200].replace(/<email>/g, formData.email)});
me.props.successForgotPwd(fpServerResponses[200].replace(/<email>/g,formData.email));}else if(response.status=="INVALID_EMAIL"){me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[600]});}else if(response.status=="INVALID_USERID"){me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[600]});}else if(response.status=="PROVIDER_FORBIDDEN"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("google.errmsg.pwd")});}else{me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[0]});}}else if(response.source=="lumos"){switch(response.code){case 200://me.setState({serverMessage: fpServerResponses[response.code].replace(/<email>/g, formData.email)});
me.props.successForgotPwd(fpServerResponses[response.code].replace(/<email>/g,me.state.email));break;case 403:me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[response.code].replace(/<email>/g,me.state.email)});break;case 400:case 401:case 600:me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[600]});break;default://currentDialog.serverMessageElem.innerHTML = fpServerResponses[0];
me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[0]});}}}me.trackMe();console.log("response : ",response);};var PLPcallBackFailure=function PLPcallBackFailure(response){me.setState({submitButtonDisabled:false});me.trackMe();};var callBackFailure=function callBackFailure(response){//me.setState({submitButtonDisabled: false});
//me.trackMe();
new __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__["a" /* default */](me.getUrlFor("PLP_COMMON_FORGOT_PWD"),formData).enableCORS().post(callBackSuccess,PLPcallBackFailure);};//new HmAjax(this.getUrlFor("FORGOT_PWD"),formData).post(callBackSuccess,callBackFailure);
new __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__["a" /* default */](this.getUrlFor("COMMON_FORGOT_PWD"),formData).enableCORS().post(callBackSuccess,callBackFailure);}},{key:'handleSubmit',value:function handleSubmit(e){e.preventDefault();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid(),serverMessage:""});if(this.form.isValid()){if(this.state.source.toLowerCase()=="lumos"){this.submitCommonPwdForm();}else if(this.state.isOTPSend&&this.state.isVerified){this.submitForm();}else if(this.state.source.toLowerCase()=="plp"){this.submitCommonPwdForm();}}}},{key:'handleSubmitVerify',value:function handleSubmitVerify(e){e.preventDefault();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){this.getUserStatus();// if(this.state.userLoginAllowed){
// 	this.submitForm();  
// }else{
// 	this.getUserStatus();
// }
}}},{key:'handleCheckboxChange',value:function handleCheckboxChange(event){var target=event.target;this.setState({"UseridEmailidSame":target.checked});if(event.target){this.setState({username:this.state.email});}}},{key:'renderUseridEmailidValue',value:function renderUseridEmailidValue(){if(this.state.UseridEmailidSame){return this.state.email;}else{return this.state.username;}}},{key:'checkForDisabled',value:function checkForDisabled(){return true;if(this.state.UseridEmailidSame){return true;}else{return false;}}},{key:'sendOTP',value:function sendOTP(){// if(this.state.OTPDisabled == "hiddenOTP"){
// 	this.form.validateFields();
// 	return;
// }
var me=this;var otpServerMsg="";if(this.state.loginType=="mobile"){if(me.state.isOTPSend){otpServerMsg="OTP is sent again to mobile";}else{otpServerMsg="OTP is sent to your mobile";}}else{if(me.state.isOTPSend){otpServerMsg="OTP is sent again to your email";}else{otpServerMsg="OTP is sent to your email";}}me.setState({serverMessage:"",emailfeedbackmsg:"",isOTPSend:false,isVerified:false,verifyDisabled:"disabled",otp_newacc:"",passcodeDisabled:"disabled"});var formData={"userId":this.state.userInput,"contactType":this.state.loginType};var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status){if(response.status=="user_exists"){me.setState({serverMessage:"User already exists",passcodeDisabled:""});}else if(response.status=="no_such_token"){me.setState({serverMessage:"The OTP entered is incorrect",passcodeDisabled:""});}else if(response.status=="error"){me.setState({serverMessage:"Internal error occured",passcodeDisabled:""});}else if(response.status=="INVALID_EMAIL"){me.setState({serverMessage:fpServerResponses[600],passcodeDisabled:""});}else if(response.status=="INVALID_USERID"){me.setState({serverMessage:fpServerResponses[600],passcodeDisabled:""});}else if(response.status=="PROVIDER_FORBIDDEN"){me.setState({serverMessage:me.rb("google.errmsg.pwd"),passcodeDisabled:""});}else{me.setState({emailfeedbackmsg:otpServerMsg});}}if(response.status.toLowerCase()=="success"){me.setState({isOTPSend:true,passcodeDisabled:"disabled"});me.trackMe(true,"send_otp");}else{me.trackMe(false,"send_otp");}}console.log("response : ",response);};var PLPcallBackFailure=function PLPcallBackFailure(response){console.log("Error in FORGOT_PWD");me.setState({passcodeDisabled:""});me.trackMe(false,"send_otp");};var callBackFailure=function callBackFailure(response){console.log("Error in FORGOT_PWD");//me.setState({passcodeDisabled:""});
//me.trackMe(false,"send_otp");
new __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__["a" /* default */](me.getUrlFor("PLP_COMMON_FORGOT_PWD"),formData).enableCORS().post(callBackSuccess,PLPcallBackFailure);};//new HmAjax(this.getUrlFor("FORGOT_PWD"),formData).post(callBackSuccess,callBackFailure);
new __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__["a" /* default */](this.getUrlFor("COMMON_FORGOT_PWD"),formData).enableCORS().post(callBackSuccess,callBackFailure);}},{key:'verifyOTP',value:function verifyOTP(){var me=this;var formData={"userId":this.state.userInput};me.setState({serverMessage:""});var verificationtype=this.state.loginType;this.setState({verifyDisabled:"disabled"});var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status){if(response.status=="user_exists"){me.setState({serverMessage:"User already exists",verifyDisabled:""});me.trackMe(false,"verify_otp");}else if(response.status=="no_such_token"||response.status=="NO_TOKEN_AVAILABLE"){me.setState({serverMessage:"The OTP entered is incorrect",verifyDisabled:""});me.trackMe(false,"verify_otp");}else if(response.isValid==false){me.setState({serverMessage:"The OTP entered is incorrect",verifyDisabled:""});me.trackMe(false,"verify_otp");}else if(response.status=="error"){me.setState({serverMessage:"Internal error occured",verifyDisabled:""});me.trackMe(false,"verify_otp");}else{me.setState({isVerified:true,verifyDisabled:""});me.trackMe(true,"verify_otp");}}}console.log("response : ",response);};var callBackFailure=function callBackFailure(response){console.log("Error in PWD_TOKEN_VALIDATE");me.setState({verifyDisabled:""});me.trackMe(false,"verify_otp");};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("PWD_TOKEN_VALIDATE")+this.state.otp_newacc,formData).post(callBackSuccess,callBackFailure);}},{key:'getOTPField',value:function getOTPField(){var _this2=this;if(this.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'otp_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'otp_newacc',className:'otp_newacc',name:'otp_newacc',placeholder:this.rb("register.enterOTP"),innerRef:function innerRef(otp){return _this2.otp=otp;},onKeyUp:this.handleKeyUp,value:this.state.otp_newacc,onChange:this.enterOTPChange,required:true,minLength:1,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'otp_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("register.enterOTP")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'})));}}},{key:'showLogin',value:function showLogin(){this.props.showNewLoginForm();}},{key:'getVerifyField',value:function getVerifyField(){if(this.state.isOTPSend&&!this.state.isVerified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"submitButton verifyButton "+this.state.verifyDisabled,onClick:this.verifyOTP},this.rb("register.verify"));}/*else if(this.state.isOTPSend && this.state.isVerified){
			return (<div className="text-right verifytxt"><i class="material-icons">done</i> <span>{this.rb("register.verified")}</span></div>);
		}*/}},{key:'getSignupHeaderMsg',value:function getSignupHeaderMsg(){if(this.state.isOTPSend&&!this.state.isVerified){if(this.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10'},'Please enter the 6-digit OTP sent to'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10'},'Please enter the 6-digit OTP sent to'));}}else if(this.state.isVerified){if(this.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10'},'You have requested to reset the password for'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small mt-10'},'+91 ',this.state.userInput));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10'},'You have requested to reset the password for'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small mt-10'},this.state.userInput));}}}},{key:'sendOTPText',value:function sendOTPText(){if(this.state.isOTPSend){return this.rb("register.reSendOTP");}else{return this.rb("home.continue");}}},{key:'showEmailFeedback',value:function showEmailFeedback(){var _this3=this;if(this.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-control-feedback'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error'},this.state.emailfeedbackmsg),function(){if(_this3.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedbacksmall'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'All important information will be sent to this mobile number'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedbacksmall'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'All important information will be sent to this email ID'));}}());}}},{key:'getUserInputPattern',value:function getUserInputPattern(){if(this.state.loginType=="mobile"){return".{10,}";}else{return"^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$";}}},{key:'getContactType',value:function getContactType(){var _this4=this;if(!this.state.isVerified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,function(){if(!_this4.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10 textAlignLeft'},_this4.rb("unifiedlogin.otpalert"),_this4.state.loginType=="mobile"?"mobile no":"email");}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'userInput'},function(){if(_this4.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'countrycodeform'},'+91');}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'userInput',className:"userInput "+this.state.loginType,name:'userInput',placeholder:this.rb("login.userplaceholder"),innerRef:function innerRef(email){return _this4.email=email;},onKeyUp:this.handleKeyUp,value:this.state.userInput,onChange:this.userIdChange,disabled:this.checkForDisabled(),pattern:this.getUserInputPattern(),required:true,minLength:1,maxLength:this.state.loginMaxLength,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'2'}),function(){if(_this4.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'userInput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},_this4.rb("login.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},_this4.rb("register.mobilenolength")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length>0&&!/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g.test(value);}},_this4.rb("register.numbersonly")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'userInput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},_this4.rb("login.useridrequired")));}}()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),this.getOTPField(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages pb-20'},this.state.serverMessage),function(){if(_this4.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this4.rb("register.reSendOTPmsg"),' '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pl-10 resendButton',onClick:_this4.sendOTP},_this4.rb("register.reSendOTP"))),_this4.getVerifyField());}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this4.getVerifyField(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"submitButton OTPButton "+_this4.state.OTPDisabled+" "+_this4.state.passcodeDisabled,onClick:_this4.sendOTP},_this4.rb("home.continue"))));}}());}}},{key:'setPassword',value:function setPassword(){var _this5=this;if(this.state.isVerified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'password_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'password_newacc',name:'password_newacc',placeholder:this.rb("login.password"),innerRef:function innerRef(password){return _this5.password=password;},value:this.state.password_newacc,onChange:this.handleChange,required:true,minLength:6,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'password_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("login.pwdrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("validate.pwd.minimum",[6])))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'confirmpassword'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'confirmpassword_newacc',name:'confirmpassword_newacc',placeholder:this.rb("rpwd.confirmpwd"),innerRef:function innerRef(confirmpassword){return _this5.confirmpassword=confirmpassword;},value:this.state.confirmpassword_newacc,onChange:this.handleChange,required:true,minLength:6,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'confirmpassword_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("rpwd.confirmpwdrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("validate.pwd.minimum",[6])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value!==_this5.password.value;}},this.rb("rpwd.doesnotmatch")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages pt-20'},this.state.serverMessage));}}},{key:'renderRHSForm',value:function renderRHSForm(){var _this6=this;if(this.state.pwdUpdated===true&&this.state.source==="plp"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 mt-50'},__WEBPACK_IMPORTED_MODULE_11_react_html_parser___default()(this.rb("rpwd.msg.success"))));}else if(this.state.pwdUpdated===true&&this.state.source==="lumos"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 mt-50'},__WEBPACK_IMPORTED_MODULE_11_react_html_parser___default()(this.rb("rpwd.msg.success"))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rounded-0'},this.getSignupHeaderMsg(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this6.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},this.getContactType(),this.setPassword(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-ga':'Home - Sign in - Users who want to register - Sign Up',disabled:this.state.submitButtonDisabled,className:"submitButton signup signupButton "+(this.state.isVerified?"":"hidden")},this.rb("register.setpassword"))))))))));}}},{key:'renderFormTitle',value:function renderFormTitle(){if(this.state.isOTPSend&&this.state.isVerified){return this.rb("rpwd.title");}else{return this.rb("forgot_password_label");}}},{key:'handleKeyUp',value:function handleKeyUp(event){if(event.key==='Enter'&&this.form.isValid()){if(!this.state.isVerified){if(this.state.isOTPSend&&this.state.verifyDisabled!="disabled"){__WEBPACK_IMPORTED_MODULE_10_jquery___default()(".verifyButton").trigger("click");}else if(this.state.passcodeDisabled!="disabled"){this.setState({OTPDisabled:""});__WEBPACK_IMPORTED_MODULE_10_jquery___default()(".OTPButton").trigger("click");}}}}},{key:'lumosForgotPassword',value:function lumosForgotPassword(){var _this7=this;if(this.state.loggedIn){return _get(UnifiedForgotPwd.prototype.__proto__||Object.getPrototypeOf(UnifiedForgotPwd.prototype),'render',this).call(this);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center schoolLoginInfo josefinsansFont nopadding'},this.rb("unif.fpwd.msg1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),function(){if(_this7.props.source.toLowerCase()=="lumos"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center schoolLoginInfo josefinsansFont'},__WEBPACK_IMPORTED_MODULE_11_react_html_parser___default()(_this7.rb("fpwd.lumos.msg")));}}())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rounded-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this7.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'username'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'username',className:'username',name:'username',placeholder:this.rb("login.userid"),value:this.renderUseridEmailidValue(),onChange:this.handleChange,disabled:this.checkForDisabled(),required:true,minLength:1,maxLength:254,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'username'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("login.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'email'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'email',className:'email',name:'email',placeholder:this.rb("fpwd.email"),innerRef:function innerRef(email){return _this7.email=email;},value:this.state.email,onChange:this.handleemailChange,required:true,maxLength:254,pattern:'^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$',minLength:1,tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'email',show:'all'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("fpwd.emailrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},this.rb("fpwd.validemail")))),function(){if(_this7.props.source.toLowerCase()=="plp"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'checkboxLabel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'fwdCheckbox',name:'sameUseridEmailid',type:'checkbox',onChange:_this7.handleCheckboxChange}),_this7.rb("fpwd.plp.useridemailidsame")));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'forgotpwdMsg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages'},' ',__WEBPACK_IMPORTED_MODULE_11_react_html_parser___default()(this.state.serverMessage))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:this.state.submitButtonDisabled,className:'submitButton'},this.rb("login.send"))))))),function(){if(_this7.props.source.toLowerCase()=="plp"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center schoolLoginInfo josefinsansFont'},_this7.rb("fpwd.plp.note"));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))));}}},{key:'plpForgotPassword',value:function plpForgotPassword(){var me=this;if(this.state.loggedIn){return _get(UnifiedForgotPwd.prototype.__proto__||Object.getPrototypeOf(UnifiedForgotPwd.prototype),'render',this).call(this);}else{return me.renderRHSForm();}}},{key:'commonForgotPassword',value:function commonForgotPassword(){var me=this;if(this.state.loggedIn){return _get(UnifiedForgotPwd.prototype.__proto__||Object.getPrototypeOf(UnifiedForgotPwd.prototype),'render',this).call(this);}else{return me.userVerify();}}},{key:'userVerify',value:function userVerify(){var _this8=this;var me=this;if(this.state.loggedIn){return _get(UnifiedForgotPwd.prototype.__proto__||Object.getPrototypeOf(UnifiedForgotPwd.prototype),'render',this).call(this);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this8.form=formWithConstraints;},onSubmit:this.handleSubmitVerify,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'plp_userinput'},function(){if(_this8.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'countrycode'},'+91');}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'plp_userinput',className:"plp_userinput "+this.state.loginType,name:'plp_userinput',placeholder:this.rb("unifiedlogin.userplaceholder"),value:this.state.plp_userinput,onChange:this.userverifyIdChange,required:true,minLength:1,maxLength:254,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'plp_userinput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("unifiedverify.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages'},this.state.serverMessage),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-ga':"Home - Verify",className:'submitButton'},'Verify')))));}}},{key:'getUserStatus',value:function getUserStatus(){if(this.state.plp_userinput.length<=0){return;}var formData={"userId":this.state.plp_userinput};var me=this;var callBackSuccess=function callBackSuccess(response,request){if(response!==null){if(response.userExists&&response.source!=='null'&&response.message!=="provider_forbidden"){if(response.source=="lumos"){me.setState({userLoginAllowed:true,user_exists:response.userExists,source:response.source,username:me.state.plp_userinput});}else if(response.source=="plp"){me.setState({userLoginAllowed:true,user_exists:response.userExists,source:response.source,userInput:me.state.plp_userinput});}}else{if(response.message=="provider_forbidden"){if(response.authProviderId==2){me.setState({submitButtonDisabled:false,serverMessage:me.rb("google.errmsg.pwd")});}else if(response.authProviderId==4){me.setState({submitButtonDisabled:false,serverMessage:me.rb("uolo.errmsg.pwd")});}}else{//me.setState({userLoginAllowed:false});
//me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
me.setState({submitButtonDisabled:false,serverMessage:me.rb("unifiedlogin.invalidinput.msg")});//	me.checkValidUserInput();
}}}};var PLPcallBackFailure=function PLPcallBackFailure(response,request){me.setState({submitButtonDisabled:false});};var callBackFailure=function callBackFailure(response,request){//me.setState({submitButtonDisabled: false});
new __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__["a" /* default */](me.getUrlFor("PLP_GET_USER_STATUS_UNIF"),formData).enableCORS().post(callBackSuccess,PLPcallBackFailure);};//new HmAjax(this.getUrlFor("GET_USER_STATUS"),formData).post(callBackSuccess,callBackFailure);
new __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__["a" /* default */](this.getUrlFor("GET_USER_STATUS_UNIF"),formData).enableCORS().post(callBackSuccess,callBackFailure);}},{key:'checkValidUserInput',value:function checkValidUserInput(){var me=this;var userinput=this.state.plp_userinput;var phoneRegx=/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;if(phoneRegx.test(userinput)){if(userinput.length==10){me.setState({userLoginAllowed:false});me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);}else{me.setState({submitButtonDisabled:false,serverMessage:me.rb("login.invalidinput.msg")});}}else{if(userinput.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){me.setState({userLoginAllowed:false});me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);}else{me.setState({submitButtonDisabled:false,serverMessage:me.rb("login.invalidinput.msg")});}}}},{key:'forgotPassword',value:function forgotPassword(){var me=this;if(this.state.source===''){return me.commonForgotPassword();}else if(this.state.source==='plp'){return me.plpForgotPassword();}else if(this.state.source==='lumos'){return me.lumosForgotPassword();}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row nomargin loginParent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-4 nopadding loginLeftSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'loginLeftContent'},this.renderFormTitle()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'charactercontainer d-none d-sm-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'charactericons forgotpwdIcon',src:__WEBPACK_IMPORTED_MODULE_12__images_icons_forgotpwdicon_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'loginRoot',className:'plpLogin col-sm-8'},this.forgotPassword()));}}]);return UnifiedForgotPwd;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (UnifiedForgotPwd);

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_device_detect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_BrowserUtil__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_icons_loginicon_png__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_icons_loginicon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_icons_loginicon_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoginForm=function(_PreLoginPage){_inherits(LoginForm,_PreLoginPage);function LoginForm(props){_classCallCheck(this,LoginForm);var _this=_possibleConstructorReturn(this,(LoginForm.__proto__||Object.getPrototypeOf(LoginForm)).call(this,props));_this.hmNav=function(userobj){/*if(this.props.liveFeed == "true" || this.props.liveFeed == true){
			window.top.location.href = "/";
			return;
		}*///console.log("this.props.navigateURL::::"+this.props.navigateURL);
if(this.props.navigateURL=="/product-details"){window.top.location.href=this.props.navigateURL;}else{if(this.productsAvailableToAccess(userobj)){window.top.location.href="/landing";}else{window.top.location.href=this.props.navigateURL;}}};_this.submitForm=function(){var formData={"userId":this.state.plp_userinput,"password":this.state.password};var me=this;me.setState({submitButtonDisabled:true});var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.authenticated){console.log("response : ",response);//Setting user object at the browser level
new __WEBPACK_IMPORTED_MODULE_7__util_UserStore__["a" /* default */]().store(response.user);me.storeRedirectUrl();try{me.doLumosLogout();}catch(e){}me.setState({submitButtonDisabled:false});try{var userObj=response.user;var loginObj={"user_id":userObj==null?"":userObj.userId,"login_id":me.state.plp_userinput,"user_agent":navigator.userAgent,"platform":navigator.platform,"device":__WEBPACK_IMPORTED_MODULE_8_react_device_detect__["isMobile"]?"mobile":__WEBPACK_IMPORTED_MODULE_8_react_device_detect__["isTablet"]?"tablet":"PC","ip_address":"ip_address","result":true,"session_id":userObj==null?"":userObj.authToken};me.storeTrackEvent("login",loginObj);}catch(e){}if(!me.tracked){me.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"logged-in"});me.tracked=true;}/*setTimeout(function(){
						//me.trackMe(true,response.user);
						me.hmNav(response.user);
					},200);*/me.hmNav(response.user);}else{if(response.message=="provider_forbidden"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("google.errmsg.login")});}else{me.setState({submitButtonDisabled:false,serverMessage:me.rb(response.message)});}//me.showAlert(me.rb("alert"),me.rb(response.message));
me.trackMe(false);}}};var callBackFailure=function callBackFailure(response){console.log("response : ",response);me.trackMe(false);me.setState({submitButtonDisabled:false});};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("LOGIN"),formData).post(callBackSuccess,callBackFailure);new __WEBPACK_IMPORTED_MODULE_7__util_UserStore__["a" /* default */]().clearOldUser();};_this.state={plp_userinput:_this.props.userid||"",password:'',submitButtonDisabled:false,serverMessage:_this.props.errMsg||"",source:"plp",loginType:_this.props.loginType||"userid",userLoginAllowed:false};_this.handleChange=_this.handleChange.bind(_this);_this.userIdChange=_this.userIdChange.bind(_this);_this.handlePasswordChange=_this.handlePasswordChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.showforgotPwd=_this.showforgotPwd.bind(_this);_this.showCreateAccount=_this.showCreateAccount.bind(_this);_this.googleLogin=_this.googleLogin.bind(_this);_this.myTrackerInstance=_this.getTracker();_this.navigationKey="PLP_Navigation";_this.gaFrom=_this.props.gaFrom;_this.gasignin=" - Returning User";console.log("this.gaFrom:::::::::::",_this.gaFrom);if(_this.gaFrom=="Top"||_this.gaFrom=="Bottom"){_this.gaFrom=_this.gaFrom+" Home - Join";}else{_this.gaFrom="Sign In - Users who have independently registered";_this.gasignin="";}console.log("this.gaFrom2222:::::::::::",_this.gaFrom);return _this;}_createClass(LoginForm,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var me=this;//console.log('componentWillReceiveProps', nextProps);    
this.setState({plp_userinput:nextProps.userid||"",password:'',submitButtonDisabled:false,serverMessage:"",source:"plp",loginType:nextProps.loginType||"userid"});this.gaFrom=nextProps.gaFrom;console.log("this.gaFrom:::::::::::",this.gaFrom);if(this.gaFrom=="Top"||this.gaFrom=="Bottom"){this.gaFrom=this.gaFrom+" Home - Join";}else{this.gaFrom="Users who have independently registered - Sign Up";}console.log("this.gaFrom:::::::::::",this.gaFrom);}},{key:'componentDidMount',value:function componentDidMount(){this.sessionCheck();}},{key:'handleChange',value:function handleChange(e){var _setState;var target=e.currentTarget;this.form.validateFields(target);this.setState((_setState={},_defineProperty(_setState,target.name,target.value),_defineProperty(_setState,'submitButtonDisabled',!this.form.isValid()),_setState));}},{key:'userIdChange',value:function userIdChange(e){var target=e.currentTarget;var phoneRegx=/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;if(phoneRegx.test(target.value)){this.setState({loginType:"mobile",serverMessage:""});}else{this.setState({loginType:"email",serverMessage:""});}this.handleChange(e);}},{key:'handlePasswordChange',value:function handlePasswordChange(e){this.handleChange(e);}},{key:'productsAvailableToAccess',value:function productsAvailableToAccess(userobj){var user=userobj;//console.log("user::::",user);
if(user!=null){var permissions=user.entlHistory;//console.log("permissions:::",permissions);
if(permissions!=null&&Object.keys(permissions).length>0){for(var i in permissions){if(permissions[i]!=null){var totalLevel=permissions[i].split(",").reduce(function(a,b){try{return parseInt(a)+parseInt(b);}catch(e){return 0;}});if(totalLevel>0){return true;}}}}}return false;}},{key:'storeRedirectUrl',value:function storeRedirectUrl(){var redirectUrl=null;if(__WEBPACK_IMPORTED_MODULE_10__util_BrowserUtil__["a" /* default */].getCookie("loginSrc")&&__WEBPACK_IMPORTED_MODULE_10__util_BrowserUtil__["a" /* default */].getCookie("loginSrc").length>10){redirectUrl=__WEBPACK_IMPORTED_MODULE_10__util_BrowserUtil__["a" /* default */].getCookie("loginSrc").replace(/"/g,"");}if(redirectUrl){__WEBPACK_IMPORTED_MODULE_9__util_BrowserStorageUtil__["a" /* default */].storeItem("loginSrc",redirectUrl);}}},{key:'getUserStatus',value:function getUserStatus(){if(this.state.plp_userinput.length<=0){return;}var formData={"verificationId":this.state.plp_userinput};var me=this;var callBackSuccess=function callBackSuccess(response){if(response!==null){console.log("response : ",response,"me.props.from:::",me.props.from);if(response.user_exists){me.setState({userLoginAllowed:true});}else{if(response.message=="provider_forbidden"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("google.errmsg.login")});}else{//me.setState({userLoginAllowed:false});
//me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
me.checkValidUserInput();}}}};var callBackFailure=function callBackFailure(response){console.log("response : ",response);me.setState({submitButtonDisabled:false});};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("GET_USER_STATUS")+this.state.loginType,formData).post(callBackSuccess,callBackFailure);}},{key:'checkValidUserInput',value:function checkValidUserInput(){var me=this;var userinput=this.state.plp_userinput;var phoneRegx=/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;if(phoneRegx.test(userinput)){if(userinput.length==10){me.setState({userLoginAllowed:false});me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);}else{me.setState({submitButtonDisabled:false,serverMessage:me.rb("login.invalidinput.msg")});}}else{if(userinput.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){me.setState({userLoginAllowed:false});me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);}else{me.setState({submitButtonDisabled:false,serverMessage:me.rb("login.invalidinput.msg")});}}}},{key:'doLumosLogout',value:function doLumosLogout(){var me=this;console.log("logout url="+me.getUrlFor("LUMOS_LOGOUT"));__WEBPACK_IMPORTED_MODULE_3_jquery___default.a.ajax({url:me.getUrlFor("LUMOS_LOGOUT"),type:'GET',xhrFields:{withCredentials:true},crossDomain:true,success:function success(response){},error:function error(response){console.log("Error in LUMOS_LOGOUT",response);}});}},{key:'handleSubmit',value:function handleSubmit(e){e.preventDefault();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){if(this.state.userLoginAllowed){this.submitForm();}else{this.getUserStatus();}}}},{key:'trackMe',value:function trackMe(result){var userObj=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var trackObj={"user_id":userObj==null?"":userObj.userId,"login_id":this.state.plp_userinput,"user_agent":navigator.userAgent,"platform":navigator.platform,"device":__WEBPACK_IMPORTED_MODULE_8_react_device_detect__["isMobile"]?"mobile":__WEBPACK_IMPORTED_MODULE_8_react_device_detect__["isTablet"]?"tablet":"PC","ip_address":"ip_address","result":result===true,"session_id":userObj==null?"":userObj.authToken};this.initiateTrack("login",trackObj);}},{key:'showCreateAccount',value:function showCreateAccount(){if(!this.tracked){this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"signin-signup"});this.tracked=true;}this.props.callbackCreateAccount(this.props.navigateURL,this.props.freetrail);}},{key:'showforgotPwd',value:function showforgotPwd(){this.props.callbackForgotPwd(this.state.source);}},{key:'googleLogin',value:function googleLogin(){if(!this.tracked){this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"signin-googlesignin"});this.tracked=true;}var navigateObj={navigateURL:this.props.navigateURL};__WEBPACK_IMPORTED_MODULE_9__util_BrowserStorageUtil__["a" /* default */].storeSessionItem(this.navigationKey,JSON.stringify(navigateObj));window.top.location.href=this.getUrlFor("GOOGLE_LOGIN_API");}},{key:'render',value:function render(){var _this2=this;if(this.state.loggedIn){return _get(LoginForm.prototype.__proto__||Object.getPrototypeOf(LoginForm.prototype),'render',this).call(this);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row nomargin loginParent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-4 nopadding loginLeftSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'loginLeftContent'},this.rb("signincaptital")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'charactercontainer d-none d-sm-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'charactericons loginIcon',src:__WEBPACK_IMPORTED_MODULE_11__images_icons_loginicon_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'loginRoot',className:'plpLogin col-sm-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 mx-auto nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rounded-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this2.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'plp_userinput'},function(){if(_this2.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'countrycode'},'+91');}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'plp_userinput',className:"plp_userinput "+this.state.loginType,name:'plp_userinput',placeholder:this.rb("login.userplaceholder"),value:this.state.plp_userinput,onChange:this.userIdChange,required:true,minLength:1,maxLength:254,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'plp_userinput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("login.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),function(){if(_this2.state.userLoginAllowed){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'password'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'password',name:'password',placeholder:_this2.rb("login.password"),innerRef:function innerRef(password){return _this2.password=password;},value:_this2.state.password,onChange:_this2.handlePasswordChange,required:true,minLength:1,maxLength:50,tabIndex:'4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'password',show:'all'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},_this2.rb("login.pwdrequired")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':"Home - "+_this2.gaFrom+_this2.gasignin+" - Forgot Password",className:'text-right forgotPassword josefinsansFont',onClick:_this2.showforgotPwd},_this2.rb("forgot_password")));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages'},this.state.serverMessage),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-ga':"Home - "+this.gaFrom+this.gasignin+"  - Sign In",disabled:this.state.submitButtonDisabled,className:'submitButton'},this.rb("signin")))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt-20 pt-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'text-center josefin'},'OR'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'socialLoginContainer text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':"Home - "+this.gaFrom+this.gasignin+" - Continue with Google",className:'socialLoginButtons google',onClick:this.googleLogin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fab fa-google'}),this.rb("login.continuegoogle")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt-20 text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'infogrey'},this.rb("register.donthaveaccount")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':"Home - "+this.gaFrom+this.gasignin+" - Sign Up",className:'text-center loginCreateNewAccount josefinsansFont',onClick:this.showCreateAccount},this.rb("login.createnewaccount")))));}}}]);return LoginForm;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (LoginForm);

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_device_detect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_html_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_icons_loginicon_png__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_icons_loginicon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_icons_loginicon_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var loginServerResponses={200:'Success.',600:'User ID expired.',700:'Invalid User ID or Password.',500:'An unexpected error occurred. Please try again after sometime or write to <a href="mailto:<email>"><email></a>.',0:'An unexpected error occurred. Please try again after sometime or write to <a href="mailto:support@heymath.com">support@heymath.com</a>.'};var LumosLoginForm=function(_PreLoginPage){_inherits(LumosLoginForm,_PreLoginPage);function LumosLoginForm(props){_classCallCheck(this,LumosLoginForm);var _this=_possibleConstructorReturn(this,(LumosLoginForm.__proto__||Object.getPrototypeOf(LumosLoginForm)).call(this,props));_this.hmNav=function(){//this.props.history.push('/landing');
this.props.myProps.history.push('/landing');};_this.submitForm=function(){var me=this;var formData={"userId":this.state.username,"password":this.state.password};me.setState({submitButtonDisabled:true});__WEBPACK_IMPORTED_MODULE_8_jquery___default.a.ajax({url:me.getUrlFor("LUMOS_LOGIN"),data:formData,type:'POST',xhrFields:{withCredentials:true},crossDomain:true,success:function success(response){switch(response.code){case 200:case 402:window.top.location.href=response.link;break;case 500://currentDialog.serverMessageElem.innerHTML = loginServerResponses[response.codeus].replace(/<email>/g, response.link);
me.setState({submitButtonDisabled:false,serverMessage:loginServerResponses[response.code].replace(/<email>/g,response.link)});break;case 600:case 700://currentDialog.serverMessageElem.innerHTML = loginServerResponses[response.code];
me.setState({submitButtonDisabled:false,serverMessage:loginServerResponses[response.code]});break;default://currentDialog.serverMessageElem.innerHTML = loginServerResponses[0];
me.setState({submitButtonDisabled:false,serverMessage:loginServerResponses[0]});}},error:function error(response){console.log("Error in lumos login",response);me.setState({submitButtonDisabled:false});}});};_this.state={username:'',password:'',submitButtonDisabled:false,serverMessage:"",source:"lumos"};_this.handleChange=_this.handleChange.bind(_this);_this.handlePasswordChange=_this.handlePasswordChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.submitForm=_this.submitForm.bind(_this);_this.showforgotPwd=_this.showforgotPwd.bind(_this);_this.myTrackerInstance=_this.getTracker();return _this;}_createClass(LumosLoginForm,[{key:'componentDidMount',value:function componentDidMount(){this.sessionCheck();}},{key:'handleForgotPwd',value:function handleForgotPwd(){}},{key:'handleChange',value:function handleChange(e){var _setState;var target=e.currentTarget;this.form.validateFields(target);this.setState((_setState={},_defineProperty(_setState,target.name,target.value),_defineProperty(_setState,'submitButtonDisabled',!this.form.isValid()),_setState));}},{key:'handlePasswordChange',value:function handlePasswordChange(e){this.handleChange(e);}},{key:'handleSubmit',value:function handleSubmit(e){e.preventDefault();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid(),serverMessage:""});if(this.form.isValid()){this.submitForm();}}},{key:'showforgotPwd',value:function showforgotPwd(){this.props.callbackForgotPwd(this.state.source);}},{key:'render',value:function render(){var _this2=this;if(this.state.loggedIn){return _get(LumosLoginForm.prototype.__proto__||Object.getPrototypeOf(LumosLoginForm.prototype),'render',this).call(this);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row nomargin loginParent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-4 nopadding loginLeftSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'loginLeftContent'},this.rb("signincaptital")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'charactercontainer d-none d-sm-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'charactericons loginIcon',src:__WEBPACK_IMPORTED_MODULE_10__images_icons_loginicon_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'loginRoot',className:'col-sm-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 mx-auto nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rounded-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this2.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'username'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'username',className:'username',name:'username',placeholder:this.rb("login.userid"),value:this.state.username,onChange:this.handleChange,required:true,minLength:1,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'username'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("login.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'password'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'password',name:'password',placeholder:this.rb("login.password"),innerRef:function innerRef(password){return _this2.password=password;},value:this.state.password,onChange:this.handlePasswordChange,required:true,minLength:1,tabIndex:'2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'password',show:'all'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("login.pwdrequired")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Home - Sign in - Users enrolled through school - Forgot Password',className:'text-right forgotPassword josefinsansFont',onClick:this.showforgotPwd},this.rb("forgot_password")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages'},__WEBPACK_IMPORTED_MODULE_9_react_html_parser___default()(this.state.serverMessage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-ga':'Home - Sign in - Users enrolled through school - Sign In',disabled:this.state.submitButtonDisabled,className:'submitButton'},this.rb("signin"))))))))))));}}}]);return LumosLoginForm;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (LumosLoginForm);

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_device_detect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_BrowserUtil__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_loginicon_png__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_loginicon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_icons_loginicon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_CoreAjax__ = __webpack_require__(75);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var loginServerResponses={200:'Success.',600:'User ID expired.',700:'Invalid User ID or Password.',500:'An unexpected error occurred. Please try again after sometime or write to <a href="mailto:<email>"><email></a>.',0:'An unexpected error occurred. Please try again after sometime or write to <a href="mailto:support@heymath.com">support@heymath.com</a>.'};var UnifiedLogin=function(_PreLoginPage){_inherits(UnifiedLogin,_PreLoginPage);function UnifiedLogin(props){_classCallCheck(this,UnifiedLogin);var _this=_possibleConstructorReturn(this,(UnifiedLogin.__proto__||Object.getPrototypeOf(UnifiedLogin)).call(this,props));_this.hmNav=function(userobj){//console.log("UnifiedLogin hmnav "+this.navigateUrl)
/*if(this.props.liveFeed == "true" || this.props.liveFeed == true){
			window.top.location.href = "/";
			return;
		}*///console.log("this.navigateUrl::::"+this.navigateUrl);
if(this.navigateUrl===null){// Do nothing
}else if(this.navigateUrl=="/product-details"){window.top.location.href=this.navigateUrl;}else{if(this.productsAvailableToAccess(userobj)){window.top.location.href="/landing";}else{if(userobj&&userobj.userRole&&userobj.userRole.role&&userobj.userRole.role.toUpperCase()==="TCHR"){window.top.location.href="/teachers";}else{window.top.location.href=this.navigateUrl;}}}};_this.unifiedSubmitForm=function(){var formData={"userId":this.state.plp_userinput,"password":this.state.password};var me=this;me.setState({submitButtonDisabled:true});var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.source=="plp"){if(response.authenticated){//Setting user object at the browser level
me.getUser().store(response.user);me.storeRedirectUrl();try{me.doLumosLogout();}catch(e){}me.setState({submitButtonDisabled:false,source:response.source});try{var userObj=response.user;var loginObj={"user_id":userObj==null?"":userObj.userId,"login_id":me.state.plp_userinput,"user_agent":navigator.userAgent,"platform":navigator.platform,"device":__WEBPACK_IMPORTED_MODULE_9_react_device_detect__["isMobile"]?"mobile":__WEBPACK_IMPORTED_MODULE_9_react_device_detect__["isTablet"]?"tablet":"PC","ip_address":"ip_address","result":true,"session_id":userObj==null?"":userObj.authToken};me.storeTrackEvent("login",loginObj);}catch(e){}if(!me.tracked){me.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"logged-in"});me.tracked=true;}var afterUpdate=function afterUpdate(response){if(typeof me.props.callBack==="function"){me.props.callBack(response);return;}me.hmNav(response);};me.updateUserType(afterUpdate);}else{if(response.message=="provider_forbidden"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("google.errmsg.login")});}else{me.setState({submitButtonDisabled:false,serverMessage:me.rb(response.message)});}//me.showAlert(me.rb("alert"),me.rb(response.message));
me.trackMe(false);}}else if(response.source=="lumos"){try{me.doPLPLogout();}catch(e){}switch(response.code){case 200:case 402:me.setState({source:response.source});window.top.location.href=response.link;break;case 500://currentDialog.serverMessageElem.innerHTML = loginServerResponses[response.codeus].replace(/<email>/g, response.link);
me.setState({submitButtonDisabled:false,serverMessage:loginServerResponses[response.code].replace(/<email>/g,response.link)});break;case 600:case 700://currentDialog.serverMessageElem.innerHTML = loginServerResponses[response.code];
me.setState({submitButtonDisabled:false,serverMessage:loginServerResponses[response.code]});break;default://currentDialog.serverMessageElem.innerHTML = loginServerResponses[0];
me.setState({submitButtonDisabled:false,serverMessage:loginServerResponses[0]});}}}};var PLPcallBackFailure=function PLPcallBackFailure(response){//console.log("response : ", response);
me.trackMe(false);me.setState({submitButtonDisabled:false});};var callBackFailure=function callBackFailure(response){//console.log("response : ", response);
//me.trackMe(false);
//me.setState({submitButtonDisabled: false});
new __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__["a" /* default */](me.getUrlFor("PLP_COMMON_LOGIN"),formData).enableCORS().post(callBackSuccess,PLPcallBackFailure);};//new HmAjax(this.getUrlFor("LOGIN"),formData).post(callBackSuccess,callBackFailure);
new __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__["a" /* default */](this.getUrlFor("LUMOS_COMMON_LOGIN"),formData).enableCORS().post(callBackSuccess,callBackFailure);me.getUser().clearOldUser();};_this.state={plp_userinput:_this.props.userid||"",password:'',submitButtonDisabled:false,serverMessage:_this.props.errMsg||"",source:"",loginType:_this.props.loginType||"userid",userLoginAllowed:false};_this.handleChange=_this.handleChange.bind(_this);_this.userIdChange=_this.userIdChange.bind(_this);_this.handlePasswordChange=_this.handlePasswordChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.showforgotPwd=_this.showforgotPwd.bind(_this);_this.showCreateAccount=_this.showCreateAccount.bind(_this);_this.googleLogin=_this.googleLogin.bind(_this);_this.toggle_GSignin=_this.toggle_GSignin.bind(_this);_this.myTrackerInstance=_this.getTracker();_this.navigationKey="PLP_Navigation";_this.navigateUrl=props.navigateURL||window.location.href;_this.gaFrom=_this.props.gaFrom;_this.gasignin=" - Returning User";//console.log("this.gaFrom:::::::::::",this.gaFrom);
if(_this.gaFrom=="Top"||_this.gaFrom=="Bottom"){_this.gaFrom=_this.gaFrom+" Home - Join";}else{_this.gaFrom="Sign In - Users who have independently registered";_this.gasignin="";}//console.log("this.gaFrom2222:::::::::::",this.gaFrom);
//console.log("UnifiedLogin Loading"+(this.navigateUrl || 'None'));  
return _this;}_createClass(UnifiedLogin,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var me=this;//console.log('componentWillReceiveProps', nextProps);    
this.setState({plp_userinput:nextProps.userid||"",password:'',submitButtonDisabled:false,serverMessage:"",source:"",loginType:nextProps.loginType||"userid"});this.gaFrom=nextProps.gaFrom;// console.log("this.gaFrom:::::::::::",this.gaFrom);
if(this.gaFrom=="Top"||this.gaFrom=="Bottom"){this.gaFrom=this.gaFrom+" Home - Join";}else{this.gaFrom="Users who have independently registered - Sign Up";}//console.log("this.gaFrom:::::::::::",this.gaFrom);
// console.log("UnifiedLogin Testing"+(this.navigateUrl || 'None'));  
}},{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".socialLoginContainer").hide();this.sessionCheck();}},{key:'handleChange',value:function handleChange(e){var _setState;var target=e.currentTarget;this.form.validateFields(target);this.setState((_setState={},_defineProperty(_setState,target.name,target.value),_defineProperty(_setState,'submitButtonDisabled',!this.form.isValid()),_setState));}},{key:'userIdChange',value:function userIdChange(e){var target=e.currentTarget;var phoneRegx=/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;if(phoneRegx.test(target.value)){this.setState({loginType:"mobile",serverMessage:""});}else{this.setState({loginType:"email",serverMessage:""});}this.handleChange(e);}},{key:'handlePasswordChange',value:function handlePasswordChange(e){this.handleChange(e);}},{key:'productsAvailableToAccess',value:function productsAvailableToAccess(userobj){var user=userobj;//console.log("user::::",user);
if(user!=null){var permissions=user.entlHistory;//console.log("permissions:::",permissions);
if(permissions!=null&&Object.keys(permissions).length>0){for(var i in permissions){if(permissions[i]!=null){var totalLevel=permissions[i].split(",").reduce(function(a,b){try{return parseInt(a)+parseInt(b);}catch(e){return 0;}});if(totalLevel>0){return true;}}}}}return false;}},{key:'storeRedirectUrl',value:function storeRedirectUrl(){var redirectUrl=null;/*if(BrowserUtil.getCookie("loginSrc") && BrowserUtil.getCookie("loginSrc").length > 10){
			redirectUrl = (BrowserUtil.getCookie("loginSrc")).replace(/"/g,"");
		}

		if(redirectUrl){
			BrowserStorageUtil.storeItem("loginSrc", redirectUrl);
		}*/}//testplpum.heymath.com/additionalInfo/update
},{key:'updateUserType',value:function updateUserType(commonCallback){var me=this;var callBackSuccess=function callBackSuccess(response){if(response!==null){//console.warn("user type",response)
me.getUser().store(response);}if(typeof commonCallback==="function"){commonCallback.apply(this,[response]);}};var callBackFailure=function callBackFailure(response){//console.warn("failure ",response);
if(typeof commonCallback==="function"){commonCallback.apply(this);}};_get(UnifiedLogin.prototype.__proto__||Object.getPrototypeOf(UnifiedLogin.prototype),'updateUserType',this).call(this,callBackSuccess,callBackFailure);}},{key:'getUserStatus',value:function getUserStatus(){if(this.state.plp_userinput.length<=0){return;}var formData={"verificationId":this.state.plp_userinput};var me=this;var callBackSuccess=function callBackSuccess(response){if(response!==null){//console.log("response : ", response,"me.props.from:::",me.props.from);					
if(response.user_exists){me.setState({userLoginAllowed:true});}else{if(response.message=="provider_forbidden"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("google.errmsg.login")});}else{//me.setState({userLoginAllowed:false});
//me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
me.checkValidUserInput();}}}};var callBackFailure=function callBackFailure(response){//console.log("response : ", response);	
me.setState({submitButtonDisabled:false});};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("GET_USER_STATUS")+this.state.loginType,formData).post(callBackSuccess,callBackFailure);}},{key:'checkValidUserInput',value:function checkValidUserInput(){var me=this;var userinput=this.state.plp_userinput;var phoneRegx=/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;if(phoneRegx.test(userinput)){if(userinput.length==10){me.setState({userLoginAllowed:false});me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);}else{me.setState({submitButtonDisabled:false,serverMessage:me.rb("login.invalidinput.msg")});}}else{if(userinput.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){me.setState({userLoginAllowed:false});me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);}else{me.setState({submitButtonDisabled:false,serverMessage:me.rb("login.invalidinput.msg")});}}}},{key:'doLumosLogout',value:function doLumosLogout(){_get(UnifiedLogin.prototype.__proto__||Object.getPrototypeOf(UnifiedLogin.prototype),'doLumosLogout',this).call(this);}},{key:'doPLPLogout',value:function doPLPLogout(){var me=this;var callBackSuccess=function callBackSuccess(resp){me.UserStore.clearOldUser();//me.initiateTrack("logout",{});
// setTimeout(function(){
// 	me.UserStore.clearOldUser();
// 	window.location.href = me.getUrlFor("PRELOGIN_PAGE");
// },500);
};var callBackFailure=function callBackFailure(resp){console.error("Logout failed.");};_get(UnifiedLogin.prototype.__proto__||Object.getPrototypeOf(UnifiedLogin.prototype),'doPLPLogout',this).call(this,callBackSuccess,callBackFailure);}},{key:'handleSubmit',value:function handleSubmit(e){e.preventDefault();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){this.unifiedSubmitForm();// if(this.state.userLoginAllowed){
// 	this.submitForm();  
// }else{
// 	this.getUserStatus();
// }
}}},{key:'trackMe',value:function trackMe(result){var userObj=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var trackObj={"user_id":userObj==null?"":userObj.userId,"login_id":this.state.plp_userinput,"user_agent":navigator.userAgent,"platform":navigator.platform,"device":__WEBPACK_IMPORTED_MODULE_9_react_device_detect__["isMobile"]?"mobile":__WEBPACK_IMPORTED_MODULE_9_react_device_detect__["isTablet"]?"tablet":"PC","ip_address":"ip_address","result":result===true,"session_id":userObj==null?"":userObj.authToken};this.initiateTrack("login",trackObj);}},{key:'showCreateAccount',value:function showCreateAccount(){if(!this.tracked){this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"signin-signup"});this.tracked=true;}this.props.callbackCreateAccount(this.navigateUrl,this.props.freetrail);}},{key:'showforgotPwd',value:function showforgotPwd(){this.props.callbackForgotPwd(this.state.source);}},{key:'googleLogin',value:function googleLogin(){if(!this.tracked){this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"signin-googlesignin"});this.tracked=true;}var navigateObj={navigateURL:this.navigateUrl};__WEBPACK_IMPORTED_MODULE_10__util_BrowserStorageUtil__["a" /* default */].storeSessionItem(this.navigationKey,JSON.stringify(navigateObj));window.top.location.href=this.getUrlFor("GOOGLE_LOGIN_API");}},{key:'toggle_GSignin',value:function toggle_GSignin(e){var me=this;__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".socialLoginContainer").slideToggle("fast","swing",function(){if(__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".showmore-signin").text()==me.rb("unified_login.show_more")){__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".showmore-signin").css("color","#8b9095");__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".showmore-signin").text(me.rb("unified_login.Hide"));}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".showmore-signin").css("color","#01babd");__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".showmore-signin").text(me.rb("unified_login.show_more"));}});}},{key:'render',value:function render(){var _this2=this;if(this.state.loggedIn){return _get(UnifiedLogin.prototype.__proto__||Object.getPrototypeOf(UnifiedLogin.prototype),'render',this).call(this);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row nomargin loginParent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-4 nopadding loginLeftSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'loginLeftContent'},this.rb("unified_login.login")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'charactercontainer d-none d-sm-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'charactericons loginIcon',src:__WEBPACK_IMPORTED_MODULE_12__images_icons_loginicon_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'loginRoot',className:'plpLogin col-sm-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 mx-auto nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rounded-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this2.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'plp_userinput'},function(){if(_this2.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'countrycode'},'+91');}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'plp_userinput',className:"plp_userinput "+this.state.loginType,name:'plp_userinput',placeholder:this.rb("unifiedlogin.userplaceholder"),value:this.state.plp_userinput,onChange:this.userIdChange,required:true,minLength:1,maxLength:254,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'plp_userinput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("unifiedlogin.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),function(){// if(this.state.userLoginAllowed){
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'password'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'password',name:'password',placeholder:_this2.rb("login.password"),innerRef:function innerRef(password){return _this2.password=password;},value:_this2.state.password,onChange:_this2.handlePasswordChange,required:true,minLength:1,maxLength:50,tabIndex:'4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'password',show:'all'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},_this2.rb("login.pwdrequired")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':"Home - "+_this2.gaFrom+_this2.gasignin+" - Forgot Password",className:'text-right ufd-forgotPassword josefinsansFont',onClick:_this2.showforgotPwd},_this2.rb("forgot_password")));// }
}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages'},this.state.serverMessage),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-ga':"Home - "+this.gaFrom+this.gasignin+"  - Sign In",disabled:this.state.submitButtonDisabled,className:'submitButton'},this.rb("unified_login.login")))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 pt-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center josefin showmore-signin',onClick:this.toggle_GSignin},this.rb("unified_login.show_more")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'socialLoginContainer text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':"Home - "+this.gaFrom+this.gasignin+" - Continue with Google",className:'socialLoginButtons google',onClick:this.googleLogin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fab fa-google'}),this.rb("login.continuegoogle")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'google-tooltip text-center josefin '},this.rb("unified_login.google_hint")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:''},this.rb("register.donthaveaccount")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'data-ga':"Home - "+this.gaFrom+this.gasignin+" - Sign Up",className:'text-center loginCreateNewAccount josefinsansFont pl-10 resendButton',onClick:this.showCreateAccount},this.rb("unified_login.createnewaccount")))));}}}]);return UnifiedLogin;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (UnifiedLogin);

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_device_detect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_icons_signupicon_png__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_icons_signupicon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_icons_signupicon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_icons_freetrailicon_png__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_icons_freetrailicon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_icons_freetrailicon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_reactstrap__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SelectDropdown__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__RadioButtons__ = __webpack_require__(301);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SignupForm=function(_PreLoginPage){_inherits(SignupForm,_PreLoginPage);function SignupForm(props){_classCallCheck(this,SignupForm);var _this=_possibleConstructorReturn(this,(SignupForm.__proto__||Object.getPrototypeOf(SignupForm)).call(this,props));_this.hmNav=function(userObj){if(userObj&&userObj.userRole&&userObj.userRole.role&&userObj.userRole.role.toUpperCase()==="TCHR"){window.top.location.href="/teachers";}else{window.top.location.href=this.props.navigateURL;}//this.props.myProps.history.push(this.props.navigateURL);
};_this.setClassesForTCHR=function(evt){if(evt&&evt.length>0){this.classesTeaching=this.rb("dropdown.classes.tchr.prefix");for(var i=0;i<evt.length;i++){if(evt[i]&&evt[i].label&&evt[i].label.length>0){var evtArr=evt[i].label.split(" ");this.classesTeaching+=evtArr[evtArr.length-1]+",";}}this.classesTeaching=this.classesTeaching.substr(0,this.classesTeaching.length-1);//console.log("lalalalla:::", this.classesTeaching);
}};_this.submitForm=function(){var verificationtype=this.state.loginType;var formData={"userName":this.state.username_newacc,"loginId":this.state.userInput,"userRole":{"role":this.state.selectedRole||"STU","level":"1"},"token":this.state.otp_newacc,"countryCode":"IN","password":this.state.password_newacc,"verificationType":verificationtype,"regnProvider":"heymath","schoolName":this.state.schoolname_newacc,//Shyam
"location":this.state.address_newacc,"classesTeaching":this.classesTeaching,"userOrigin":this.userReferal};if(this.state.loginType=="mobile"){formData["phone"]=this.state.userInput;}else{formData["email"]=this.state.userInput;}var me=this;me.setState({submitButtonDisabled:true});var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status.toLowerCase()=="success"){new __WEBPACK_IMPORTED_MODULE_7__util_UserStore__["a" /* default */]().store(response.user);//me.props.successRegisterMsg(me.rb("register.success.msg"));
try{me.doLumosLogout();}catch(e){}me.trackMe(true,"set_password");var afterUpdate=function afterUpdate(){me.hmNav(response.user);};me.updateUserType(afterUpdate);}else{if(response.status=="user_exists"){me.setState({serverMessage:"User already exists",submitButtonDisabled:false});}else if(response.status=="no_such_token"){me.setState({serverMessage:"The OTP entered is incorrect",submitButtonDisabled:false});}else if(response.status=="error"){me.setState({serverMessage:"Internal error occured",submitButtonDisabled:false});}else if(response.status=="empty_inputs"){me.setState({serverMessage:"Please enter all the fields",submitButtonDisabled:false});}else if(response.status=="token_not_verified"){me.setState({serverMessage:"Passcode Verification is required",submitButtonDisabled:false});}else if(response.status=="provider_forbidden"){me.setState({serverMessage:"Already registered with Gmail ID. Please click continue with Google",submitButtonDisabled:false});}else{me.setState({serverMessage:response.status,submitButtonDisabled:false});}me.trackMe(false,"set_password");}}console.log("response : ",response);};var callBackFailure=function callBackFailure(response){console.log("Error in CREATE_REGISTER");me.setState({submitButtonDisabled:false});me.showAlert("","Error in CREATE_REGISTER");me.trackMe(false,"set_password");};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("CREATE_REGISTER"),formData).post(callBackSuccess,callBackFailure);new __WEBPACK_IMPORTED_MODULE_7__util_UserStore__["a" /* default */]().clearOldUser();};_this.state={username_newacc:'',password_newacc:'',confirmpassword_newacc:'',singupType:"userid",loginType:_this.props.loginType||"userid",userInput:_this.props.userInput||"",otp_newacc:'',submitButtonDisabled:false,serverMessage:"",emailfeedbackmsg:"",source:"plp",isOTPSend:false,isVerified:false,OTPDisabled:"hiddenOTP",verifyDisabled:"disabled",emailDisabled:false,phoneDisabled:false,verifyText:_this.rb("register.verify"),sendOTPText:_this.rb("register.sendOTP"),passcodeDisabled:"disabled",selectedRole:"STU"};_this.classesTeaching=null;//this.selectedRole = null;
_this.userReferal=null;_this.navigationKey="PLP_Navigation";_this.handleChange=_this.handleChange.bind(_this);_this.enterOTPChange=_this.enterOTPChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.userIdChange=_this.userIdChange.bind(_this);_this.googleLogin=_this.googleLogin.bind(_this);_this.sendOTP=_this.sendOTP.bind(_this);_this.verifyOTP=_this.verifyOTP.bind(_this);_this.getOTPField=_this.getOTPField.bind(_this);_this.handleKeyUp=_this.handleKeyUp.bind(_this);_this.radioSelected=_this.radioSelected.bind(_this);_this.setCentaReference=_this.setCentaReference.bind(_this);_this.setUserOrigin=_this.setUserOrigin.bind(_this);_this.setClassesForTCHR=_this.setClassesForTCHR.bind(_this);_this.googleLogin=_this.googleLogin.bind(_this);_this.isFreeTrialAllowed=_this.isFreeTrialAllowed.bind(_this);_this.myTrackerInstance=_this.getTracker();_this.gaFrom=_this.props.gaFrom;console.log("this.gaFrom:::::::::::",_this.gaFrom);if(_this.gaFrom=="Top"||_this.gaFrom=="Bottom"){_this.gaFrom=_this.gaFrom+" Home - Join";}else{_this.gaFrom="Users who have independently registered - Sign Up";}console.log("this.gaFrom2222:::::::::::",_this.gaFrom);return _this;}_createClass(SignupForm,[{key:'isFreeTrialAllowed',value:function isFreeTrialAllowed(val){var userRole=val||null;if(userRole&&userRole.length>1&&window.noFreeTrialRoles&&window.noFreeTrialRoles.length>0){return!~window.noFreeTrialRoles.indexOf(userRole);}//user not logged in or role not defined latter is unlikely or no suppression in window.noFreeTrialRoles
return true;}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var me=this;this.gaFrom=nextProps.gaFrom;console.log("this.gaFrom:::::::::::",this.gaFrom);if(this.gaFrom=="Top"||this.gaFrom=="Bottom"){this.gaFrom=this.gaFrom+" Home - Join";}else{this.gaFrom="Users who have independently registered - Sign Up";}console.log("this.gaFrom:::::::::::",this.gaFrom);console.log('componentWillReceiveProps',nextProps);this.setState({loginType:nextProps.loginType||"userid",userInput:nextProps.userInput||"",otp_newacc:'',submitButtonDisabled:false,serverMessage:"",emailfeedbackmsg:"",source:"plp",isOTPSend:false,isVerified:false,OTPDisabled:"hiddenOTP",verifyDisabled:"disabled",emailDisabled:false,phoneDisabled:false,verifyText:this.rb("register.verify"),sendOTPText:this.rb("register.sendOTP"),passcodeDisabled:"disabled"});setTimeout(function(){me.reinitiate();},500);}},{key:'componentDidMount',value:function componentDidMount(){var me=this;this.sessionCheck();setTimeout(function(){me.reinitiate();},200);}},{key:'reinitiate',value:function reinitiate(){console.log("reinitiate gaFrom:::::::::::",this.gaFrom);if(this.state.userInput!=""){this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){this.setState({OTPDisabled:""});__WEBPACK_IMPORTED_MODULE_9_jquery___default()(".OTPButton").trigger("click");}}__WEBPACK_IMPORTED_MODULE_9_jquery___default()("#loginRoot .userInput").focus();}},{key:'handleChange',value:function handleChange(e){var _setState;var target=e.currentTarget;//console.log("target=",target);
this.form.validateFields(target);this.setState((_setState={},_defineProperty(_setState,target.name,target.value),_defineProperty(_setState,'serverMessage',""),_defineProperty(_setState,'submitButtonDisabled',!this.form.isValid()),_setState));}},{key:'userIdChange',value:function userIdChange(e){var _setState2;var target=e.currentTarget;this.form.validateFields(target);var phoneRegx=/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;if(phoneRegx.test(target.value)){this.setState({loginType:"mobile",loginMaxLength:10,OTPDisabled:"hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});if(target.value.length>=10){this.setState({OTPDisabled:"",passcodeDisabled:""});}}else{this.setState({loginType:"email",loginMaxLength:254,OTPDisabled:"hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});//this.setState({ [target.name]: "hidden",isOTPSend:false,isVerified:false,password_newacc:""});
if(target.value.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){this.setState({OTPDisabled:"",passcodeDisabled:""});}}this.setState((_setState2={},_defineProperty(_setState2,target.name,target.value),_defineProperty(_setState2,'serverMessage',""),_defineProperty(_setState2,'submitButtonDisabled',true),_setState2));}},{key:'enterOTPChange',value:function enterOTPChange(e){if(this.otp.value.length>0){this.setState({verifyDisabled:""});}else{this.setState({verifyDisabled:"disabled"});}this.handleChange(e);}//Shyam
},{key:'setUserOrigin',value:function setUserOrigin(referal){this.userReferal=referal;}},{key:'setCentaReference',value:function setCentaReference(evt){if(evt&&evt.currentTarget&&evt.currentTarget.value){if(evt.currentTarget.value.length>0&&evt.currentTarget.value.toLowerCase()==="yes"){this.setUserOrigin("centa");}}}},{key:'updateUserType',value:function updateUserType(commonCallback){var me=this;var callBackSuccess=function callBackSuccess(response){if(response!==null){//console.warn("user type",response)
me.getUser().store(response);}if(typeof commonCallback==="function"){commonCallback.apply(this);}};var callBackFailure=function callBackFailure(response){//console.warn("failure ",response);
if(typeof commonCallback==="function"){commonCallback.apply(this);}};_get(SignupForm.prototype.__proto__||Object.getPrototypeOf(SignupForm.prototype),'updateUserType',this).call(this,callBackSuccess,callBackFailure);}},{key:'trackMe',value:function trackMe(result,source){var trackObj={"name":this.state.username_newacc,"email":this.state.loginType=="mobile"?"":this.state.userInput,"phone":this.state.loginType=="mobile"?this.state.userInput:"","event_source":this.getTracker().enums.signupEventSource[source],"result":result};if(source=="set_password"){this.storeTrackEvent("signup",trackObj);}else{this.initiateTrack("signup",trackObj);}}},{key:'handleSubmit',value:function handleSubmit(e){e.preventDefault();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){if(this.state.isOTPSend&&this.state.isVerified){this.submitForm();}}}},{key:'sendOTP',value:function sendOTP(){if(this.state.OTPDisabled=="hiddenOTP"){this.form.validateFields();return;}var me=this;var otpServerMsg="";if(this.state.loginType=="mobile"){if(me.state.isOTPSend){otpServerMsg="OTP is sent again to mobile";}else{otpServerMsg="OTP is sent to your mobile";}}else{if(me.state.isOTPSend){otpServerMsg="OTP is sent again to your email";}else{otpServerMsg="OTP is sent to your email";}}me.setState({serverMessage:"",emailfeedbackmsg:"",isOTPSend:false,isVerified:false,verifyDisabled:"disabled",otp_newacc:"",passcodeDisabled:"disabled"});var formData={"contactId":this.state.userInput,"contactType":this.state.loginType};var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status){if(response.status=="user_exists"){me.setState({serverMessage:"User already exists",passcodeDisabled:""});}else if(response.status=="no_such_token"){me.setState({serverMessage:"The OTP entered is incorrect",passcodeDisabled:""});}else if(response.status=="error"){me.setState({serverMessage:"Internal error occured",passcodeDisabled:""});}else{me.setState({emailfeedbackmsg:otpServerMsg,passcodeDisabled:""});}}if(response.status=="success"){me.setState({isOTPSend:true,passcodeDisabled:"disabled"});me.trackMe(true,"send_otp");}else{me.trackMe(false,"send_otp");}}console.log("response : ",response);};var callBackFailure=function callBackFailure(response){console.log("Error in CREATE_SENDVERIFICATION_TOKEN");me.setState({passcodeDisabled:""});me.trackMe(false,"send_otp");};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("CREATE_SENDVERIFICATION_TOKEN"),formData).post(callBackSuccess,callBackFailure);}},{key:'verifyOTP',value:function verifyOTP(){var me=this;me.setState({serverMessage:""});var verificationtype=this.state.loginType;var formData={"verificationId":this.state.userInput};this.setState({verifyDisabled:"disabled"});var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status){if(response.status=="user_exists"){me.setState({serverMessage:"User already exists",verifyDisabled:""});me.trackMe(false,"verify_otp");}else if(response.status=="no_such_token"){me.setState({serverMessage:"The OTP entered is incorrect",verifyDisabled:""});me.trackMe(false,"verify_otp");}else if(response.status=="error"){me.setState({serverMessage:"Internal error occured",verifyDisabled:""});me.trackMe(false,"verify_otp");}else{me.setState({isVerified:true,verifyDisabled:""});me.trackMe(true,"verify_otp");}}}console.log("response : ",response);};var callBackFailure=function callBackFailure(response){console.log("Error in CREATE_SENDVERIFICATION_TOKEN");me.setState({verifyDisabled:""});me.trackMe(false,"verify_otp");};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("CREATE_VERIFY_EMAIL")+verificationtype+"/"+this.state.otp_newacc,formData).post(callBackSuccess,callBackFailure);}},{key:'getOTPField',value:function getOTPField(){var _this2=this;if(this.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'otp_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'otp_newacc',className:'otp_newacc',name:'otp_newacc',placeholder:this.rb("register.enterOTP"),innerRef:function innerRef(otp){return _this2.otp=otp;},onKeyUp:this.handleKeyUp,value:this.state.otp_newacc,onChange:this.enterOTPChange,required:true,minLength:1,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'otp_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("register.enterOTP")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'})));}}},{key:'getVerifyField',value:function getVerifyField(){if(this.state.isOTPSend&&!this.state.isVerified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':"Home - "+this.gaFrom+" - New User - Verify",className:"submitButton verifyButton "+this.state.verifyDisabled,onClick:this.verifyOTP},this.rb("register.verify"));}/*else if(this.state.isOTPSend && this.state.isVerified){
			return (<div className="text-right verifytxt"><i class="material-icons">done</i> <span>{this.rb("register.verified")}</span></div>);
		}*/}},{key:'getSignupHeaderMsg',value:function getSignupHeaderMsg(){if(this.state.isOTPSend&&!this.state.isVerified){if(this.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Please verify your number')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10'},'A 6-digit OTP has been sent to your mobile number for verification'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Please verify your Email')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10'},'A 6-digit OTP has been sent to your Email for verification'));}}else if(this.state.isVerified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Congratulations')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10'},'You are almost set. Enter your Name and set password to start learning.'));}}},{key:'sendOTPText',value:function sendOTPText(){if(this.state.isOTPSend){return this.rb("register.reSendOTP");}else{return this.rb("register.sendOTP");}}},{key:'showEmailFeedback',value:function showEmailFeedback(){var _this3=this;if(this.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-control-feedback'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error'},this.state.emailfeedbackmsg),function(){if(_this3.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedbacksmall'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'All important information will be sent to this mobile number'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedbacksmall'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'All important information will be sent to this email ID'));}}());}}},{key:'getUserInputPattern',value:function getUserInputPattern(){if(this.state.loginType=="mobile"){return".{10,}";}else{return"^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$";}}},{key:'radioSelected',value:function radioSelected(evt){var val=evt.currentTarget.value;if(val&&val.length>0){//this.selectedRole = val;
this.setState({selectedRole:val});/*alert(val);*/}return true;}},{key:'getContactType',value:function getContactType(){var _this4=this;if(!this.state.isVerified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,function(){var user=_this4.props.signupUser||'student';if(user==='student'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'col-md-12 mt-30 signup-radio'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 radio-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-check-input',type:'radio',name:'student',value:'STU',id:'student_select',onChange:_this4.radioSelected,defaultChecked:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-check-label',htmlFor:'student_select'},'Student/Parent')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 radio-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-check-input',type:'radio',name:'student',value:'TCHR',id:'teacher_select',onChange:_this4.radioSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-check-label',htmlFor:'teacher_select'},'Teacher')));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'userInput'},function(){if(_this4.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'countrycodeform'},'+91');}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'userInput',className:"userInput "+this.state.loginType,name:'userInput',placeholder:this.rb("login.userplaceholder"),innerRef:function innerRef(email){return _this4.email=email;},onKeyUp:this.handleKeyUp,value:this.state.userInput,onChange:this.userIdChange,pattern:this.getUserInputPattern(),required:true,minLength:1,maxLength:this.state.loginMaxLength,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'2'}),function(){if(_this4.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'userInput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},_this4.rb("login.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},_this4.rb("register.mobilenolength")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length>0&&!/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g.test(value);}},_this4.rb("register.numbersonly")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'userInput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},_this4.rb("login.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},_this4.rb("fpwd.validemail")));}}()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),this.getOTPField(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages pt-20'},this.state.serverMessage),function(){if(_this4.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this4.rb("register.reSendOTPmsg"),' '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'data-ga':"Home - "+_this4.gaFrom+" - New User - Resend",className:'pl-10 resendButton',onClick:_this4.sendOTP},_this4.rb("register.reSendOTP"))),_this4.getVerifyField());}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this4.getVerifyField(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':"Home - "+_this4.gaFrom+" - New User - Send Passcode",className:"submitButton OTPButton "+_this4.state.OTPDisabled+" "+_this4.state.passcodeDisabled,onClick:_this4.sendOTP},_this4.rb("register.sendOTP"))));}}());}}},{key:'getStep2TeachersForm',value:function getStep2TeachersForm(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'username_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'username_newacc',className:'username_newacc',name:'username_newacc',placeholder:this.rb("billing.fullname"),value:this.state.username_newacc,onChange:this.handleChange,required:true,minLength:1,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'username_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.namerequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'schoolname_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'schoolname_newacc',className:'schoolname_newacc',name:'schoolname_newacc',placeholder:this.rb("billing.schoolname"),value:this.state.schoolname_newacc,onChange:this.handleChange,required:true,minLength:1,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'schoolname_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.schoolrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'address_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'address_newacc',className:'address_newacc',name:'address_newacc',placeholder:this.rb("billing.location"),value:this.state.address_newacc,onChange:this.handleChange,required:true,minLength:1,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'address_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.addressrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'class_dropdown',className:'classSelection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__SelectDropdown__["a" /* default */],{callBack:this.setClassesForTCHR}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'class_dropdown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.classrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'member_newacc',className:'col-md-12 mt-30 signup-radio pad-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'col-md-8 radio-section'},this.rb("centa.heading")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__RadioButtons__["a" /* default */],{callBack:this.setCentaReference}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'member_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.memberrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'password_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'password_newacc',name:'password_newacc',placeholder:this.rb("login.password"),innerRef:function innerRef(password){return _this5.password=password;},value:this.state.password_newacc,onChange:this.handleChange,required:true,minLength:6,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'password_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("login.pwdrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("validate.pwd.minimum",[6])))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'confirmpassword'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'confirmpassword_newacc',name:'confirmpassword_newacc',placeholder:this.rb("rpwd.confirmpwd"),innerRef:function innerRef(confirmpassword){return _this5.confirmpassword=confirmpassword;},value:this.state.confirmpassword_newacc,onChange:this.handleChange,required:true,minLength:6,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'confirmpassword_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("rpwd.confirmpwdrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("validate.pwd.minimum",[6])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value!==_this5.password.value;}},this.rb("rpwd.doesnotmatch")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages pt-20'},this.state.serverMessage));}},{key:'getStep2StudentsForm',value:function getStep2StudentsForm(){var _this6=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'username_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'username_newacc',className:'username_newacc',name:'username_newacc',placeholder:this.rb("billing.fullname"),value:this.state.username_newacc,onChange:this.handleChange,required:true,minLength:1,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'username_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.namerequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'password_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'password_newacc',name:'password_newacc',placeholder:this.rb("login.password"),innerRef:function innerRef(password){return _this6.password=password;},value:this.state.password_newacc,onChange:this.handleChange,required:true,minLength:6,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'password_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("login.pwdrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("validate.pwd.minimum",[6])))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'confirmpassword'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'confirmpassword_newacc',name:'confirmpassword_newacc',placeholder:this.rb("rpwd.confirmpwd"),innerRef:function innerRef(confirmpassword){return _this6.confirmpassword=confirmpassword;},value:this.state.confirmpassword_newacc,onChange:this.handleChange,required:true,minLength:6,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'confirmpassword_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("rpwd.confirmpwdrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("validate.pwd.minimum",[6])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value!==_this6.password.value;}},this.rb("rpwd.doesnotmatch")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages pt-20'},this.state.serverMessage));}},{key:'setPassword',value:function setPassword(){if(this.state.isVerified){if(this.state.selectedRole==="TCHR"){return this.getStep2TeachersForm();}else{return this.getStep2StudentsForm();}}}},{key:'googleLogin',value:function googleLogin(){var navigateObj={navigateURL:this.props.navigateURL};__WEBPACK_IMPORTED_MODULE_3__util_BrowserStorageUtil__["a" /* default */].storeSessionItem(this.navigationKey,JSON.stringify(navigateObj));if(!this.tracked){this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"signin-googlesignin"});this.tracked=true;}window.top.location.href=this.getUrlFor("GOOGLE_LOGIN_API");}},{key:'handleKeyUp',value:function handleKeyUp(event){if(event.key==='Enter'&&this.form.isValid()){if(!this.state.isVerified){if(this.state.isOTPSend&&this.state.verifyDisabled!="disabled"){__WEBPACK_IMPORTED_MODULE_9_jquery___default()(".verifyButton").trigger("click");}else if(this.state.passcodeDisabled!="disabled"){this.setState({OTPDisabled:""});__WEBPACK_IMPORTED_MODULE_9_jquery___default()(".OTPButton").trigger("click");}}}}},{key:'GoogleLoginShow',value:function GoogleLoginShow(){if(this.state.selectedRole==="STU"){if(this.state.isOTPSend==false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loginTop pt-15'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center josefin mt-20'},'OR'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'socialLoginContainer text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':"Home - Users who have independently registered - Sign Up - New User - Sign in with Google - Start Learning",className:'socialLoginButtons google',onClick:this.googleLogin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fab fa-google'}),this.rb("login.google"))));}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}},{key:'render',value:function render(){var _this7=this;if(this.state.loggedIn){return _get(SignupForm.prototype.__proto__||Object.getPrototypeOf(SignupForm.prototype),'render',this).call(this);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row nomargin loginParent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-4 col-lg-4 nopadding loginLeftSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'loginLeftContent'},this.rb("unified_login.joinincaptital")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'charactercontainer d-none d-sm-block'},function(){if(_this7.state.selectedRole&&_this7.isFreeTrialAllowed(_this7.state.selectedRole)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,function(){if(window.free_trial_extension&&window.free_trial_extension.toggle==='days'&&window.free_trial_extension.days===30){if(_this7.props.navigateURL!="/product-details"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'charactericons freetrailIcon',src:__WEBPACK_IMPORTED_MODULE_11__images_icons_freetrailicon_png___default.a});}else if(_this7.props.freetrail=="true"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'charactericons freetrailIcon',src:__WEBPACK_IMPORTED_MODULE_11__images_icons_freetrailicon_png___default.a});}}}());}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'charactericons signupIcon',src:__WEBPACK_IMPORTED_MODULE_10__images_icons_signupicon_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'loginRoot',className:'plpLogin col-sm-8 col-lg-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rounded-0'},this.getSignupHeaderMsg(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this7.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},this.getContactType(),this.setPassword(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-ga':"Home - Users who have independently registered - Sign Up - New User - Start Learning",disabled:this.state.submitButtonDisabled,className:"submitButton signup signupButton "+(this.state.isVerified?"":"hidden")},this.rb("register.startlearning")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),function(){if(_this7.state.selectedRole=="STU"){return _this7.GoogleLoginShow();}}())))))))));}}}]);return SignupForm;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (SignupForm);

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1116 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prelogin_public_css_react_select_css__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prelogin_public_css_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__prelogin_public_css_react_select_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StudentDropdown=function(_PreLoginPage){_inherits(StudentDropdown,_PreLoginPage);function StudentDropdown(props){_classCallCheck(this,StudentDropdown);var _this=_possibleConstructorReturn(this,(StudentDropdown.__proto__||Object.getPrototypeOf(StudentDropdown)).call(this,props));_this.state={selectedStudentOption:_this.props.studentDpList[0],studentDpList:_this.props.studentDpList};_this.studentDropdownChange=_this.studentDropdownChange.bind(_this);_this.resetDropdowns=_this.resetDropdowns.bind(_this);return _this;}_createClass(StudentDropdown,[{key:'resetDropdowns',value:function resetDropdowns(){//this.setState({selectedStudentOption:this.state.studentDpList[0]});
this.state.selectedStudentOption=this.props.studentDpList[0];this.setState(this.state);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(){this.setState({studentDpList:this.props.studentDpList});}},{key:'studentDropdownChange',value:function studentDropdownChange(selectedOption){this.setState({selectedStudentOption:selectedOption});this.props.callBackParentStudentDdChange(selectedOption,this.props.index);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'infoTxt'},this.rb("product.assignedto"),':',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'minwid-200 selectbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{value:this.state.selectedStudentOption,onChange:this.studentDropdownChange,options:this.state.studentDpList,onBlurResetsInput:false,onSelectResetsInput:false,clearable:false,rtl:false,searchable:false})));}}]);return StudentDropdown;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* unused harmony default export */ var _unused_webpack_default_export = (StudentDropdown);

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal_video__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_modal_video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_modal_video__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__usestyle_css__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__usestyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__usestyle_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var Use=function(_PreLoginSessionCheck){_inherits(Use,_PreLoginSessionCheck);function Use(props){_classCallCheck(this,Use);var _this=_possibleConstructorReturn(this,(Use.__proto__||Object.getPrototypeOf(Use)).call(this,props));_this.productDetails=localStorage.getItem('proDetail');_this.openModal=_this.openModal.bind(_this);return _this;}_createClass(Use,[{key:'getProductDetails',value:function getProductDetails(){if(this.productDetails!={}&&this.productDetails!=undefined){return JSON.parse(this.productDetails);}}},{key:'openModal',value:function openModal(someValue){this.setState({isOpen:true});this.videoId=someValue;console.log(this.videoId);}},{key:'loadVideoContent',value:function loadVideoContent(){var _this2=this;if(this.props.owner==="plp"||this.props.owner==="cbse"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loadvid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Home - Star Students - Shreyas Kumar',className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box popup-youtube vid-box',onClick:this.openModal.bind(null,'hsifPyadKko')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/plprev_student2.jpg',alt:'Vidya Mandir Mylapore Grade 6 students review Personalised Learning program'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Home - Star Students - Uday Saharia',className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box popup-youtube vid-box',onClick:this.openModal.bind(null,'6fBBbVLBlrw')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/plprev_student3.jpg',alt:'Vidya Mandir Mylapore Grade 9 students share feedback about Personalised Learning program'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Home - Star Students - Yamini Prashanth',className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box popup-youtube vid-box',onClick:this.openModal.bind(null,'TS7AZ-QE66A')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/plprev_student1.jpg',alt:'Grade 9 Vidya Mandir Mylapore students share feedback about Personalised Learning program'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Home - Star Students - Anuradha',className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box popup-youtube vid-box',onClick:this.openModal.bind(null,'5Dn6-cvFJ5o')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/plprev_student4.jpg',alt:'Tvisha of Grade 5 from Deens academy shares her comments on Personalised Learning program'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_modal_video___default.a,{channel:'youtube',isOpen:this.state.isOpen,videoId:this.videoId,onClose:function onClose(){return _this2.setState({isOpen:false});}}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.imgName,alt:'Young children using HeyMath! to learn Maths on their laptops'}));}}},{key:'render',value:function render(){var _this3=this;this.proID=localStorage.getItem('product');var gradeName=this.getProductDetails()[this.proID].ClassName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:"mtb usehm student useComp "+this.props.owner},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'How students make the best use of our product'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-gallery'},this.loadVideoContent())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-5'},function(){if(_this3.props.owner=="plp"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'galry-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Go through topics after they have been completed in school'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Revise topics covered for school tests'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Recommended usage: 2 hours per week'));}else if(_this3.props.owner=="cbse"){/*if(gradeName == "Class 9"){
									  return(<ul className="galry-list">
									  	<li>Allocate 2 hours a week to complete 5 topics</li>
								 		<li>Practice and master topics once completed in school</li>
								 		<li>Revise topics where you scored C or below</li>
									  </ul>);
								  }else if(gradeName == "Class 10"){
									  return(<ul className="galry-list">
									  	<li>Allocate 2 hours a week to complete 6 topics</li>
								 		<li>Practice and master topics once completed in school</li>
								 		<li>Revise topics where you scored C or below</li>
									  </ul>);
								  }else{
									  return(<ul className="galry-list">
									  	<li>Allocate 2 hours a week to complete 5 topics</li>
								 		<li>Practice and master topics once completed in school</li>
								 		<li>Revise topics where you scored C or below</li>
									  </ul>);
								  }*/return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'galry-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Work on topics that have been completed in school'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Allocate 2 hours a week for practice'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Revise topics where you have scored C or below'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'galry-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Spend 20 minutes a day going through lessons'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Do practice problems before school tests'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Go through relevant lessons before school tests'));}}())))));}}]);return Use;}(__WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Use);

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(4));

var _addClass = _interopRequireDefault(__webpack_require__(1125));

var _removeClass = _interopRequireDefault(__webpack_require__(1128));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Transition = _interopRequireDefault(__webpack_require__(458));

var _PropTypes = __webpack_require__(459);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var appearClassName = _this.getClassNames('appear').doneClassName;

      var enterClassName = _this.getClassNames('enter').doneClassName;

      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames5.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
      var className = isStringClassNames ? prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames6 = this.getClassNames(type),
        className = _this$getClassNames6.className,
        activeClassName = _this$getClassNames6.activeClassName,
        doneClassName = _this$getClassNames6.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or
   * has finished the transition. A single name can be provided and it will be
   * suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
   *
   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
   * This allows you to define different behavior for when appearing is done and
   * when regular entering is done, using selectors like
   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
   * epic entrance animation when element first appears in the DOM using
   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   * simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1126);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(1127));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Banner__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_login_UserLoginType__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_login_Whatsapp_js__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_modal_video__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_modal_video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_modal_video__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* This class is merely an extension of the previous banner
*
*/var Banner2=function(_Banner){_inherits(Banner2,_Banner);function Banner2(){_classCallCheck(this,Banner2);return _possibleConstructorReturn(this,(Banner2.__proto__||Object.getPrototypeOf(Banner2)).apply(this,arguments));}_createClass(Banner2,[{key:'homeforweb',value:function homeforweb(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slider-inner b-web-comp',style:{padding:'50px 0px 30px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 b-right',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/banner1.png',alt:'',onClick:this.openModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Home  - Hey Parent Video',className:'popup-modal',onClick:this.openModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'heading-one',style:{textAlign:'center',marginBottom:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt first-line',style:{fontSize:'32px'}},this.rb("banner.heading.2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt furtxt',style:{fontSize:'32px'}},this.rb("banner.subheading.2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt furtxt',style:{fontSize:'32px'}},this.rb("banner.subheading1.2"))),function(){if(_this2.props.PLPloggedIn){if(_this2.isFreeTrialAllowed()){var styles={display:'flex',justifyContent:'center',flexFlow:'column'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3 nopadding mx-auto joingrp',style:styles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#',align:'center','data-ga':'Home - Best Math Teacher - Free Trial',className:'r-btn',onClick:_this2.props.startFreeTrial},'Start your Free Trial'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__views_login_Whatsapp_js__["a" /* default */],{align:'center',maxWidth:'100%'},'/'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null);}}else{var _styles={margin:'0 auto'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 nopadding mx-auto joingrp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__views_login_UserLoginType__["a" /* default */],{styles:_styles,showSignUp:_this2.props.showSignUp,showNewLoginForm:_this2.props.showNewLoginForm,from:"Top"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__views_login_Whatsapp_js__["a" /* default */],{align:'center',maxWidth:'100%'},'/'));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nottxt'}))));}},{key:'homeformobile',value:function homeformobile(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comp-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-center b-comp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt'},this.rb("banner.heading.2"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt furtxt'},this.rb("banner.subheading.2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt furtxt'},this.rb("banner.subheading1.2")))),function(){if(_this3.props.PLPloggedIn){if(_this3.isFreeTrialAllowed()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'paddtri'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#','data-ga':'Home - Best Math Teacher - Free Trial',className:'r-btn text-center',onClick:_this3.props.startFreeTrial},'Start your Free Trial'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__views_login_Whatsapp_js__["a" /* default */],{align:'center',background:"#30BDBD",maxWidth:'100%'},'/'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null);}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 nopadding mx-auto joingrp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__views_login_UserLoginType__["a" /* default */],{showSignUp:_this3.props.showSignUp,showNewLoginForm:_this3.props.showNewLoginForm,from:"Top"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__views_login_Whatsapp_js__["a" /* default */],{align:'center',background:"#30BDBD",maxWidth:'100%'},'/'));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nottxt'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-banner'})));}},{key:'homecomponent',value:function homecomponent(){var _this4=this;if(this.isMobile()||this.isTab()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'h-mob-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-container home-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},this.homeformobile())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-pagination'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_modal_video___default.a,{channel:'youtube',isOpen:this.state.isOpen,videoId:'b-X5TsIQG24',onClose:function onClose(){return _this4.setState({isOpen:false});}}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'h-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-container home-bannerweb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},this.homeforweb())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-pagination'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_modal_video___default.a,{channel:'youtube',isOpen:this.state.isOpen,videoId:'b-X5TsIQG24',onClose:function onClose(){return _this4.setState({isOpen:false});}}));}}}]);return Banner2;}(__WEBPACK_IMPORTED_MODULE_1__Banner__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Banner2);

/***/ }),
/* 1131 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAAZiS0dEAAAAAAAA+UO7fwAAAAlwSFlzAAAASAAAAEgARslrPgAAAdFJREFUSMfdlDFLXFEQhefuEheTiIXBKo2drklh/oFBGyFsjAb9CYmKYio7O8EYwUps7CyMldj5JwImKxqMYQMpbGwUJBHNZ+G5MK5v377Fygw83uWcmTn3zsy9ZvfdQhoJNJnZoJmVzOyFmT0V9dvMvpjZpplthhDOG1YGhoBD6tsP4E0jifPAJ5fgKzAFdAOP9HUL++b8FoBcFoGY/A/wPi1ImxkH/irmY5ayxOS9DZz6pRN5XbOhrubvhD0B9oAjoLmOyIRiDzQctxxGXM1zwuZcjUcz9K4s37cR9/Ut6b8aQvindYfj+9MEQgiXZrZalevGDr5LveiwGWGnQGeGXjyT/34SeSKyxWFtwLEamEWgRTlOksgzkc1VeOzNLtB6F4GfIjsTuOV4dKBHE7cNbAHPs5bos8ixBC4HrIi/1ChGuwC65DctbC1JYFTkTq3bC7xyJ432CyhoTHeFDScFF4CKHIZS6pwHBoAlTVm78El30R7UCl6sHtUsBvQB54otpTmWgbLWRb1N9R67SZd8Pi150Y1jvPKxJ+NAF/AQeKxp+eBqDjCfthkDZp1zWeWqUN8OUsviBDYk4p+Kgi7auqbnjOtnYw9YA4ZrNvS/sSu5QymBdCIM1AAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0xMS0yMVQxMjo1MDowNCswMDowMHOgH+sAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTgtMTEtMjFUMTI6NTA6MDQrMDA6MDAC/adXAAAAKHRFWHRzdmc6YmFzZS11cmkAZmlsZTovLy90bXAvbWFnaWNrLUJzbE5vSHByi2BzawAAAABJRU5ErkJggg=="

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_id_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal_video__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal_video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_modal_video__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_login_UserLoginType__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_login_Whatsapp_js__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_ProductConfig_json__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_ProductConfig_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__config_ProductConfig_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_core_PreLoginPage__ = __webpack_require__(2);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var Productbox=function(_PreLoginPage){_inherits(Productbox,_PreLoginPage);function Productbox(props){_classCallCheck(this,Productbox);var _this=_possibleConstructorReturn(this,(Productbox.__proto__||Object.getPrototypeOf(Productbox)).call(this,props));_this.state={error:null,isLoaded:false,items:[],ProductList:[],pro_detail:[],products:[],self:[],plp:[],products_details:{},products_category_order:[]};_this.grades=_this.props.grades;_this.productClass=_this.props.products_class;_this.productDetails=_this.props.products_details;_this.products_category=_this.props.products_category;_this.productClasses=_this.props.classes;_this.renderFooterProduct=_this.renderFooterProduct.bind(_this);_this.restricted=false;return _this;}_createClass(Productbox,[{key:'componentDidMount',value:function componentDidMount(){var _state=this.state,products=_state.products,self=_state.self,plp=_state.plp;this.grades=this.props.grades;this.productClass=this.props.products_class;this.productDetails=this.props.products_details;this.products_category=this.props.products_category;this.productClasses=this.props.classes;// console.log("this.state ",this.state,this.products_category)
}},{key:'loadsplbox',value:function loadsplbox(){var me=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-12 col-md-6 col-lg-6'},me.loadsplcomp());}},{key:'loadplpbox',value:function loadplpbox(){var me=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-12 col-md-6 col-lg-6'},me.loadplpcomp());}},{key:'loadlessoncompAll',value:function loadlessoncompAll(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row prolesscomp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.loadsplbox()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.loadplpcomp()));}},{key:'loadlessoncomp',value:function loadlessoncomp(){var me=this;if(me.props.device=="web"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row prolesscomp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.loadsplbox()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.loadplpcomp()));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row prolesscomp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.loadplpcomp()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.loadsplbox()));}}},{key:'getProdDetails',value:function getProdDetails(){//console.log(this.state.products_details);
if(this.state.products_details!=={}&&this.state.products_details!==undefined){return this.state.products_details;}}},{key:'renderFooterProduct',value:function renderFooterProduct(product,grade){var _this2=this;//console.log(product,", ",grade,", ",this.productClasses);
if(product&&grade&&this.products_category&&this.products_category[product]&&this.products_category[product].hasOwnProperty(grade)){var restricted="";if(this.GradeRestrictionManager.isGradeRestricted(grade)){restricted="restricted";this.restricted=true;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:restricted,key:grade,'data-ga':'Home - Top - '+__WEBPACK_IMPORTED_MODULE_7__config_ProductConfig_json___default.a[product].ganame+' - '+this.productClasses[grade].ClassName,onClick:function onClick(){return _this2.saveID(''+grade,''+_this2.products_category[product][grade],__WEBPACK_IMPORTED_MODULE_7__config_ProductConfig_json___default.a[product].url+_this2.products_category[product][grade]);}},this.productClasses[grade].ClassName.substr(6),function(){if(restricted=="restricted"){return"*";}}());}}},{key:'saveID',value:function saveID(grade,proID,link){var products_details=this.state.products_details;var me=this;var callBackSuccess=function callBackSuccess(result){if(result!==null){me.setState({products_details:result}),//console.log("Footer:::",me.getProdDetails());
localStorage.setItem('grade',grade);localStorage.setItem('product',proID);localStorage.setItem('proDetail',JSON.stringify(me.getProdDetails()));window.top.location.href=link;}//console.log("response : ", response);
};var callBackFailure=function callBackFailure(response){me.setState({isLoaded:true,error:"Error in Footer PRODUCT_JSON"});console.log("Error in Footer PRODUCT_JSON in Grade");};var formData={"levelId":grade};new __WEBPACK_IMPORTED_MODULE_8__util_HmAjax__["a" /* default */](this.getUrlFor("PRODUCT_JSON"),formData).post(callBackSuccess,callBackFailure);//console.log(grade);
//console.log(proID);
if(!this.tracked){this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"class-"+grade+"-btn-click-home"});this.tracked=true;}}},{key:'loadsplcomp',value:function loadsplcomp(){var me=this;//	if(this.checkRestrictedGrade(ProductConfig.SPL.productKey,this.grades) == false){
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'splwell spl'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'proimg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/e1.png',alt:'Self-Paced Lessons'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 combox textAlignLeft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.rb("SPL"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("SPL.build"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row hrborder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 text-center'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"col-10 "+"clsdata-"+this.props.device},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'clsspan splcls'},this.rb("home.classes")),me.orderProducts(me.state.products_category_order).map(function(product){//if(me.checkRestrictedGrade(product,me.grades) == false){
if(product=="SPL"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'probox',key:product},me.grades.map(function(grade){return me.renderFooterProduct(product,grade);}));}//}
}),me.checkRestrictedGrade(__WEBPACK_IMPORTED_MODULE_7__config_ProductConfig_json___default.a.SPL.productKey,this.grades),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ntxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa'},'\uF156'),' ',this.rb("banner.SPL"))))));//	}
}},{key:'loadplpcomp',value:function loadplpcomp(){var me=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'splwell plp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'proimg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/e3.png',alt:'Personalised Learning'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 combox textAlignLeft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.rb("PLP"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("PLP.build"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row hrborder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2 text-center'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"col-10 "+"clsdata-"+this.props.device},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'clsspan plpcls'},this.rb("home.classes")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'showrow'},me.orderProducts(me.state.products_category_order).map(function(product){//if(me.checkRestrictedGrade(product,me.grades) == false){
if(product=="PLP"||product=="EXAM_PREP_CBSE"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'probox',key:product},me.grades.map(function(grade){return me.renderFooterProduct(product,grade);}));}//}
})),me.checkRestrictedGrade(__WEBPACK_IMPORTED_MODULE_7__config_ProductConfig_json___default.a.PLP.productKey,me.grades),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ntxt'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa'},'\uF156'),' ',this.rb("banner.EXAM_PREP_CBSE"))))));}},{key:'checkRestrictedGrade',value:function checkRestrictedGrade(product,grades){//console.log("grades:::",grades, ", ",product);
//console.log(this.products_category, ", ",product,", ",this.products_category[product],", ",this.products_category[product].hasOwnProperty("11"));
var restrictedAvailable=false;if(grades&&grades.length>0){for(var i=0;i<grades.length;i++){if(product&&this.products_category&&this.products_category[product]&&this.products_category[product].hasOwnProperty(grades[i])){if(this.GradeRestrictionManager.isGradeRestricted(grades[i])){restrictedAvailable=true;break;}}}}if(restrictedAvailable){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-left smallinfo'},'*Available only for desktop');}// else{ restrictedAvailable = true; }
//   return restrictedAvailable;
}},{key:'orderProducts',value:function orderProducts(obj){if(obj&&(typeof obj==='undefined'?'undefined':_typeof(obj))==="object"){//console.log("Object.values(obj) "+Object.values(obj))
return Object.values(obj);}else{return[];}}},{key:'render',value:function render(){var _state2=this.state,products=_state2.products,self=_state2.self,plp=_state2.plp;this.grades=this.props.grades;this.grades_order=this.props.grades_order;this.productClass=this.props.products_class;this.productDetails=this.props.products_details;this.products_category=this.props.products_category;this.productClasses=this.props.classes;this.state.products_category_order=this.props.products_category_order;var tifOptions=[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.loadlessoncompAll());}}]);return Productbox;}(__WEBPACK_IMPORTED_MODULE_9__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Productbox);

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SignupSection__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_login_UserLoginType__ = __webpack_require__(121);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SignupSection2=function(_SignupSection){_inherits(SignupSection2,_SignupSection);function SignupSection2(){_classCallCheck(this,SignupSection2);return _possibleConstructorReturn(this,(SignupSection2.__proto__||Object.getPrototypeOf(SignupSection2)).apply(this,arguments));}_createClass(SignupSection2,[{key:'render',value:function render(){var _this2=this;var styles={display:'inline-block',fontWeight:500};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{'data-p-ga':'',className:'mtb child'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.rb("signup.section.txt.1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hmorg',style:styles},'Hey'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hmblue',style:styles},'Math!\xA0'),this.rb("signup.section.txt.2")),function(){if(_this2.props.PLPloggedIn){if(_this2.isFreeTrialAllowed()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Home - Give your child an Edge - Free Trial',href:'#',className:'r-btn big-btn',onClick:_this2.props.startFreeTrial},'Start your Free Trial');}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null);}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-5 mx-auto text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__views_login_UserLoginType__["a" /* default */],{showSignUp:_this2.props.showSignUp,showNewLoginForm:_this2.props.showNewLoginForm,from:"Bottom"}));}}()));}}]);return SignupSection2;}(__WEBPACK_IMPORTED_MODULE_1__SignupSection__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (SignupSection2);

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Ga_js__ = __webpack_require__(123);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var WhoBanner=function(_PreLoginSessionCheck){_inherits(WhoBanner,_PreLoginSessionCheck);function WhoBanner(){_classCallCheck(this,WhoBanner);return _possibleConstructorReturn(this,(WhoBanner.__proto__||Object.getPrototypeOf(WhoBanner)).apply(this,arguments));}_createClass(WhoBanner,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'bg-grn why-us'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'We are a bunch of folks who are zealously driven to make the learning of Math creative and enjoyable for students'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Nothing excites us more than a student saying \u2018Aah, I get it now\u2019!')));}}]);return WhoBanner;}(__WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (WhoBanner);

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

module.exports = {"hometab":{"event_action":"Home Tab","event_category":"Home","event_label":"Main tab"},"home-bestmathteacher-freetrial":{"event_action":"Home - Best Math Teacher - Free Trial","event_category":"Home","event_label":"Free Trial"},"home-heyparentvideo":{"event_action":"Home - Hey Parent Video","event_category":"Home","event_label":"Video"},"home-experienceourprogramsnow-knowmore":{"event_action":"Home - Experience our programs now - Know more","event_category":"Home","event_label":"Products"},"home-whyheymath!-music&math":{"event_action":"Home - Why HeyMath! - Music & Math","event_category":"Home","event_label":"News article"},"home-whyheymath!-math&dna":{"event_action":"Home - Why HeyMath! - Math & DNA","event_category":"Home","event_label":"News article"},"home-whyheymath!-mathinarthistoryandculture":{"event_action":"Home - Why HeyMath! - Math in Art History and Culture","event_category":"Home","event_label":"News article"},"home-starstudents-anuradha":{"event_action":"Home - Star Students - Anuradha","event_category":"Home","event_label":"Video"},"home-starstudents-rajkamal":{"event_action":"Home - Star Students - Rajkamal","event_category":"Home","event_label":"Video"},"home-starstudents-ramanandankrishnamurthy":{"event_action":"Home - Star Students - Ramanandan Krishnamurthy","event_category":"Home","event_label":"Video"},"home-starstudents-shreyaskumar":{"event_action":"Home - Star Students - Shreyas Kumar","event_category":"Home","event_label":"Video"},"home-starstudents-udaysaharia":{"event_action":"Home - Star Students - Uday Saharia","event_category":"Home","event_label":"Video"},"home-starstudents-varunranganathan":{"event_action":"Home - Star Students - Varun Ranganathan","event_category":"Home","event_label":"Video"},"home-starstudents-yaminiprashanth":{"event_action":"Home - Star Students - Yamini Prashanth","event_category":"Home","event_label":"Video"},"home-featuredin-bbcnews":{"event_action":"Home - Featured In - BBC News","event_category":"Home","event_label":"News article"},"home-featuredin-newyorktimes":{"event_action":"Home - Featured In - NewYork Times","event_category":"Home","event_label":"News article"},"home-featuredin-worldisflat":{"event_action":"Home - Featured In - World is Flat","event_category":"Home","event_label":"News article"},"home-featuredin-nasscom":{"event_action":"Home - Featured In - NASSCOM","event_category":"Home","event_label":"News article"},"home-giveyourchildanedge-freetrial":{"event_action":"Home - Give your child an Edge - Free Trial","event_category":"Home","event_label":"Free Trial"},"footer-home":{"event_action":"Footer - Home","event_category":"Footer","event_label":"Home"},"footer-products":{"event_action":"Footer - Products","event_category":"Footer","event_label":"Products"},"footer-ourlearnings":{"event_action":"Footer - Our Learnings","event_category":"Footer","event_label":"Our Learnings"},"footer-whoweare":{"event_action":"Footer - Who we are","event_category":"Footer","event_label":"Who we are"},"footer-self-pacedlessons-class1":{"event_action":"Footer - Self-Paced Lessons - Class 1","event_category":"Footer","event_label":"SPL"},"footer-self-pacedlessons-class2":{"event_action":"Footer - Self-Paced Lessons - Class 2","event_category":"Footer","event_label":"SPL"},"footer-self-pacedlessons-class3":{"event_action":"Footer - Self-Paced Lessons - Class 3","event_category":"Footer","event_label":"SPL"},"footer-self-pacedlessons-class4":{"event_action":"Footer - Self-Paced Lessons - Class 4","event_category":"Footer","event_label":"SPL"},"footer-self-pacedlessons-class5":{"event_action":"Footer - Self-Paced Lessons - Class 5","event_category":"Footer","event_label":"SPL"},"footer-self-pacedlessons-class6":{"event_action":"Footer - Self-Paced Lessons - Class 6","event_category":"Footer","event_label":"SPL"},"footer-self-pacedlessons-class7":{"event_action":"Footer - Self-Paced Lessons - Class 7","event_category":"Footer","event_label":"SPL"},"footer-self-pacedlessons-class8":{"event_action":"Footer - Self-Paced Lessons - Class 8","event_category":"Footer","event_label":"SPL"},"footer-self-pacedlessons-class9":{"event_action":"Footer - Self-Paced Lessons - Class 9","event_category":"Footer","event_label":"SPL"},"footer-self-pacedlessons-class10":{"event_action":"Footer - Self-Paced Lessons - Class 10","event_category":"Footer","event_label":"SPL"},"footer-personalisedlearningprogram-grade5":{"event_action":"Footer - Personalised Learning - Grade 5","event_category":"Footer","event_label":"PLP"},"footer-personalisedlearningprogram-grade6":{"event_action":"Footer - Personalised Learning - Grade 6","event_category":"Footer","event_label":"PLP"},"footer-personalisedlearningprogram-grade7":{"event_action":"Footer - Personalised Learning - Grade 7","event_category":"Footer","event_label":"PLP"},"footer-personalisedlearningprogram-grade8":{"event_action":"Footer - Personalised Learning - Grade 8","event_category":"Footer","event_label":"PLP"},"footer-personalisedlearningprogram-class5":{"event_action":"Footer - Personalised Learning - Grade 5","event_category":"Footer","event_label":"PLP"},"footer-personalisedlearningprogram-class6":{"event_action":"Footer - Personalised Learning - Grade 6","event_category":"Footer","event_label":"PLP"},"footer-personalisedlearningprogram-class7":{"event_action":"Footer - Personalised Learning - Grade 7","event_category":"Footer","event_label":"PLP"},"footer-personalisedlearningprogram-class8":{"event_action":"Footer - Personalised Learning - Grade 8","event_category":"Footer","event_label":"PLP"},"footer-followus-facebook":{"event_action":"Footer - Follow Us - Facebook","event_category":"Footer","event_label":"Social Media"},"footer-followus-twitter":{"event_action":"Footer - Follow Us - Twitter","event_category":"Footer","event_label":"Social Media"},"footer-followus-linkedin":{"event_action":"Footer - Follow Us - Linkedin","event_category":"Footer","event_label":"Social Media"},"footer-followus-youtube":{"event_action":"Footer - Follow Us - Youtube","event_category":"Footer","event_label":"Social Media"},"footer-phonenumber":{"event_action":"Footer - Phone number","event_category":"Footer","event_label":"Phone Number"},"footer-emailid":{"event_action":"Footer - Email ID","event_category":"Footer","event_label":"Email"},"footer-contactus":{"event_action":"Footer - Contact Us","event_category":"Footer","event_label":"Contact"},"footer-contactus-contacttype-iwanttoknowmoreaboutheymath":{"event_action":"Footer - Contact Us - Contact type - I want to know more about HeyMath","event_category":"Footer","event_label":"Contact Type"},"footer-contactus-iwanttoknowmoreaboutheymath-email":{"event_action":"Footer - Contact Us - I want to know more about HeyMath - Email","event_category":"Footer","event_label":"Contact Us Fields"},"footer-contactus-iwanttoknowmoreaboutheymath-phonenumber":{"event_action":"Footer - Contact Us - I want to know more about HeyMath - Phone number","event_category":"Footer","event_label":"Contact Us Fields"},"footer-contactus-iwanttoknowmoreaboutheymath-city":{"event_action":"Footer - Contact Us - I want to know more about HeyMath - city","event_category":"Footer","event_label":"Contact Us Fields"},"footer-contactus-iwanttoknowmoreaboutheymath-message":{"event_action":"Footer - Contact Us - I want to know more about HeyMath - message","event_category":"Footer","event_label":"Contact Us Fields"},"footer-contactus-iwanttoknowmoreaboutheymath-send":{"event_action":"Footer - Contact Us - I want to know more about HeyMath - Send","event_category":"Footer","event_label":"Contact Us Send"},"footer-contactus-contacttype-ihaveaheymathidfrommyschool":{"event_action":"Footer - Contact Us - Contact type - I have a HeyMath ID from my school","event_category":"Footer","event_label":"Contact Type"},"footer-contactus-ihaveaheymathidfrommyschool-userid":{"event_action":"Footer - Contact Us - I have a HeyMath ID from my school - User ID","event_category":"Footer","event_label":"Contact Us Fields"},"footer-contactus-ihaveaheymathidfrommyschool-email":{"event_action":"Footer - Contact Us - I have a HeyMath ID from my school - Email","event_category":"Footer","event_label":"Contact Us Fields"},"footer-contactus-ihaveaheymathidfrommyschool-message":{"event_action":"Footer - Contact Us - I have a HeyMath ID from my school - Message","event_category":"Footer","event_label":"Contact Us Fields"},"footer-contactus-ihaveaheymathidfrommyschool-send":{"event_action":"Footer - Contact Us - I have a HeyMath ID from my school - Send","event_category":"Footer","event_label":"Contact Us Send"},"footer-contactus-contacttype-ihavesubscribedtoheymathindependently":{"event_action":"Footer - Contact Us - Contact type - I have subscribed to HeyMath independently","event_category":"Footer","event_label":"Contact Type"},"footer-contactus-ihavesubscribedtoheymathindependently-userid":{"event_action":"Footer - Contact Us - I have subscribed to HeyMath independently - User ID","event_category":"Footer","event_label":"Contact Us Fields"},"footer-contactus-ihavesubscribedtoheymathindependently-phoneno":{"event_action":"Footer - Contact Us - I have subscribed to HeyMath independently - Phone No","event_category":"Footer","event_label":"Contact Us Fields"},"footer-contactus-ihavesubscribedtoheymathindependently-message":{"event_action":"Footer - Contact Us - I have subscribed to HeyMath independently - Message","event_category":"Footer","event_label":"Contact Us Fields"},"footer-contactus-ihavesubscribedtoheymathindependently-send":{"event_action":"Footer - Contact Us - I have subscribed to HeyMath independently - Send","event_category":"Footer","event_label":"Contact Us Send"},"footer-contactus-close":{"event_action":"Footer - Contact Us - Close","event_category":"Footer","event_label":"Contact Us Close"},"footer-leo9":{"event_action":"Footer - Leo9","event_category":"Footer","event_label":"Leo9"},"footer-terms":{"event_action":"Footer - Terms","event_category":"Footer","event_label":"Heymath technical details"},"footer-privacypolicy":{"event_action":"Footer - Privacy Policy","event_category":"Footer","event_label":"Heymath technical details"},"":{"event_action":"","event_category":"","event_label":""},"home-signin":{"event_action":"Home - Sign in","event_category":"Home","event_label":"Sign in"},"home-signin-close":{"event_action":"Home - Sign in - Close","event_category":"Home","event_label":"Close button"},"home-signin-usersenrolledthroughschool":{"event_action":"Home - Sign in - Users enrolled through school","event_category":"Home","event_label":"Login option"},"home-signin-usersenrolledthroughschool-userid":{"event_action":"Home - Sign in - Users enrolled through school - User ID","event_category":"Home","event_label":"Form fill in"},"home-signin-usersenrolledthroughschool-password":{"event_action":"Home - Sign in - Users enrolled through school - Password","event_category":"Home","event_label":"Form fill in"},"home-signin-usersenrolledthroughschool-close":{"event_action":"Home - Sign in - Users enrolled through school - Close","event_category":"Home","event_label":"Close button"},"home-signin-usersenrolledthroughschool-signin":{"event_action":"Home - Sign in - Users enrolled through school - Sign In","event_category":"Home","event_label":"Sign In"},"home-signin-usersenrolledthroughschool-forgotpassword":{"event_action":"Home - Sign in - Users enrolled through school - Forgot Password","event_category":"Home","event_label":"Forgot Password"},"home-signin-usersenrolledthroughschool-forgotpassword-send":{"event_action":"Home - Sign in - Users enrolled through school - Forgot Password - Send","event_category":"Home","event_label":"Password Send"},"home-signin-usersenrolledthroughschool-forgotpassword-close":{"event_action":"Home - Sign in - Users enrolled through school - Forgot Password - Close","event_category":"Home","event_label":"Close button"},"home-signin-userswhohaveindependentlyregistered":{"event_action":"Home - Sign in - Users who have independently registered","event_category":"Home","event_label":"Login option"},"home-signin-userswhohaveindependentlyregistered-userid":{"event_action":"Home - Sign in - Users who have independently registered - User ID","event_category":"Home","event_label":"Form fill in"},"home-signin-userswhohaveindependentlyregistered-password":{"event_action":"Home - Sign in - Users who have independently registered -Password","event_category":"Home","event_label":"Form fill in"},"home-signin-userswhohaveindependentlyregistered-close":{"event_action":"Home - Sign in - Users who have independently registered - Close","event_category":"Home","event_label":"Close button"},"home-signin-userswhohaveindependentlyregistered-forgotpassword":{"event_action":"Home - Sign in - Users who have independently registered - Forgot Password","event_category":"Home","event_label":"Forgot Password"},"home-signin-userswhohaveindependentlyregistered-forgotpassword-close":{"event_action":"Home - Sign in - Users who have independently registered - Forgot Password - Close","event_category":"Home","event_label":"Close button"},"home-signin-userswhohaveindependentlyregistered-forgotpassword-send":{"event_action":"Home - Sign in - Users who have independently registered - Forgot Password - Send","event_category":"Home","event_label":"Password Send"},"home-signin-userswhohaveindependentlyregistered-forgotpassword-sameuserid":{"event_action":"Home - Sign in - Users who have independently registered - Forgot Password - Same user id","event_category":"Home","event_label":"Check box"},"home-signin-userswhohaveindependentlyregistered-signin":{"event_action":"Home - Sign in - Users who have independently registered - Sign In","event_category":"Home","event_label":"Sign In"},"home-signin-userswhohaveindependentlyregistered-continuewithgoogle":{"event_action":"Home - Sign in - Users who have independently registered - Continue with Google","event_category":"Home","event_label":"Google Sign In"},"home-signin-userswhohaveindependentlyregistered-createanaccount":{"event_action":"Home - Sign in - Users who have independently registered - Create an account","event_category":"Home","event_label":"Create account"},"home-signin-userswhohaveindependentlyregistered-createanaccount-fullname":{"event_action":"Home - Sign in - Users who have independently registered - Create an account - Full name","event_category":"Home","event_label":"Form fill in"},"home-signin-userswhohaveindependentlyregistered-createanaccount-emailid":{"event_action":"Home - Sign in - Users who have independently registered - Create an account - Email ID","event_category":"Home","event_label":"Form fill in"},"home-signin-userswhohaveindependentlyregistered-createanaccount-sendpasscode":{"event_action":"Home - Sign in - Users who have independently registered - Create an account - Send Passcode","event_category":"Home","event_label":"Form fill in"},"home-signin-userswhohaveindependentlyregistered-createanaccount-passcode":{"event_action":"Home - Sign in - Users who have independently registered - Create an account - Passcode","event_category":"Home","event_label":"Form fill in"},"home-signin-userswhohaveindependentlyregistered-createanaccount-mobile":{"event_action":"Home - Sign in - Users who have independently registered - Create an account - Mobile","event_category":"Home","event_label":"Form fill in"},"home-signin-userswhohaveindependentlyregistered-createanaccount-password":{"event_action":"Home - Sign in - Users who have independently registered - Create an account - Password","event_category":"Home","event_label":"Form fill in"},"home-signin-userswhohaveindependentlyregistered-createanaccount-confirmpassword":{"event_action":"Home - Sign in - Users who have independently registered - Create an account - Confirm Password","event_category":"Home","event_label":"Form fill in"},"home-signin-userswhohaveindependentlyregistered-createanaccount-signup":{"event_action":"Home - Sign in - Users who have independently registered - Create an account - Sign Up","event_category":"Home","event_label":"Sign Up"},"home-signin-userswhohaveindependentlyregistered-createanaccount-continuewithgoogle":{"event_action":"Home - Sign in - Users who have independently registered - Create an account - Continue with Google","event_category":"Home","event_label":"Google Sign In"},"home-signin-userswhowanttoregister":{"event_action":"Home - Sign in - Users who want to register","event_category":"Home","event_label":"Create account"},"home-signin-userswhowanttoregister-fullname":{"event_action":"Home - Sign in - Users who want to register - Fullname","event_category":"Home","event_label":"Form fill in"},"home-signin-userswhowanttoregister-emailid":{"event_action":"Home - Sign in - Users who want to register - Email ID","event_category":"Home","event_label":"Form fill in"},"home-signin-userswhowanttoregister-sendpasscode":{"event_action":"Home - Sign in - Users who want to register - Send Passcode","event_category":"Home","event_label":"Form fill in"},"home-signin-userswhowanttoregister-passcode":{"event_action":"Home - Sign in - Users who want to register - Passcode","event_category":"Home","event_label":"Form fill in"},"home-signin-userswhowanttoregister-mobile":{"event_action":"Home - Sign in - Users who want to register - Mobile","event_category":"Home","event_label":"Form fill in"},"home-signin-userswhowanttoregister-password":{"event_action":"Home - Sign in - Users who want to register - Password","event_category":"Home","event_label":"Form fill in"},"home-signin-userswhowanttoregister-confirmpassword":{"event_action":"Home - Sign in - Users who want to register - Confirm Password","event_category":"Home","event_label":"Form fill in"},"home-signin-userswhowanttoregister-signup":{"event_action":"Home - Sign in - Users who want to register - Sign Up","event_category":"Home","event_label":"Sign Up"},"home-signin-userswhowanttoregister-continuewithgoogle":{"event_action":"Home - Sign in - Users who want to register - Continue with Google","event_category":"Home","event_label":"Google Sign In"},"home-signin-userswhowanttoregister-close":{"event_action":"Home - Sign in - Users who want to register - Close","event_category":"Home","event_label":"Close button"},"home-signin-userswhowanttoregister-verify":{"event_action":"Home - Sign in - Users who want to register - Verify","event_category":"Home","event_label":"Verification"},"products-maintab":{"event_action":"Products - Main tab","event_category":"Products","event_label":"Main Tab"},"products-class1":{"event_action":"Products - Class 1","event_category":"Products","event_label":"Class"},"products-class2":{"event_action":"Products - Class 2","event_category":"Products","event_label":"Class"},"products-class3":{"event_action":"Products - Class 3","event_category":"Products","event_label":"Class"},"products-class4":{"event_action":"Products - Class 4","event_category":"Products","event_label":"Class"},"products-class5":{"event_action":"Products - Class 5","event_category":"Products","event_label":"Class"},"products-class5-self-pacedlessons":{"event_action":"Products - Class 5 - Self-Paced Lessons","event_category":"Products","event_label":"SPL"},"products-class5-personalisedlearningprogram":{"event_action":"Products - Class 5 - Personalised Learning","event_category":"Products","event_label":"PLP"},"products-class5-close":{"event_action":"Products - Class 5 - Close","event_category":"Products","event_label":"Close button"},"products-class6":{"event_action":"Products - Class 6","event_category":"Products","event_label":"Class"},"products-class6-self-pacedlessons":{"event_action":"Products - Class 6 - Self-Paced Lessons","event_category":"Products","event_label":"SPL"},"products-class6-personalisedlearningprogram":{"event_action":"Products - Class 6 - Personalised Learning","event_category":"Products","event_label":"PLP"},"products-class6-close":{"event_action":"Products - Class 6 - Close","event_category":"Products","event_label":"Close button"},"products-class7":{"event_action":"Products - Class 7","event_category":"Products","event_label":"Class"},"products-class7-self-pacedlessons":{"event_action":"Products - Class 7 - Self-Paced Lessons","event_category":"Products","event_label":"SPL"},"products-class7-personalisedlearningprogram":{"event_action":"Products - Class 7 - Personalised Learning","event_category":"Products","event_label":"PLP"},"products-class7-close":{"event_action":"Products - Class 7 - Close","event_category":"Products","event_label":"Close button"},"products-class8":{"event_action":"Products - Class 8","event_category":"Products","event_label":"Class"},"products-class8-self-pacedlessons":{"event_action":"Products - Class 8 - Self-Paced Lessons","event_category":"Products","event_label":"SPL"},"products-class8-personalisedlearningprogram":{"event_action":"Products - Class 8 - Personalised Learning","event_category":"Products","event_label":"PLP"},"products-class8-close":{"event_action":"Products - Class 8 - Close","event_category":"Products","event_label":"Close button"},"products-class9":{"event_action":"Products - Class 9","event_category":"Products","event_label":"Class"},"products-class10":{"event_action":"Products - Class 10","event_category":"Products","event_label":"Class"},"self-pacedlessons-maintab":{"event_action":"Self-Paced Lessons - Main Tab","event_category":"SPL","event_label":"Main Tab"},"spl-samplelessonsforclass1-takeawayducklings":{"event_action":"SPL - Sample Lessons for Class 1 - Take Away Ducklings","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass1-takeawayducklings-close":{"event_action":"SPL - Sample Lessons for Class 1 - Take Away Ducklings - Close","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass1-giveadogabone":{"event_action":"SPL - Sample Lessons for Class 1 - Give a Dog a Bone","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass1-giveadogabone-close":{"event_action":"SPL - Sample Lessons for Class 1 - Give a Dog a Bone - Close","event_category":"SPL","event_label":"Lesson"},"spl-class1-topicscoveredaspercbsesyllabus-rightarrow":{"event_action":"SPL - Class 1 - Topics covered as per CBSE syllabus - right arrow","event_category":"SPL","event_label":"Arrow"},"spl-class1-topicscoveredaspercbsesyllabus-leftarrow":{"event_action":"SPL - Class 1 - Topics covered as per CBSE syllabus - left arrow","event_category":"SPL","event_label":"Arrow"},"spl-class1-freetrial":{"event_action":"SPL - Class 1 - Free Trial","event_category":"SPL","event_label":"Free trial"},"spl-class1-subscribe":{"event_action":"SPL - Class 1 - Subscribe","event_category":"SPL","event_label":"Subscribe"},"spl-samplelessonsforclass2-yeknomisland":{"event_action":"SPL - Sample Lessons for Class 2 - Yeknom Island","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass2-yeknomisland-close":{"event_action":"SPL - Sample Lessons for Class 2 - Yeknom Island - Close","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass2-introducinglitres":{"event_action":"SPL - Sample Lessons for Class 2 - Introducing Litres","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass2-introducinglitres-close":{"event_action":"SPL - Sample Lessons for Class 2 - Introducing Litres - Close","event_category":"SPL","event_label":"Lesson"},"spl-class2topicscoveredaspercbsesyllabus-rightarrow":{"event_action":"SPL - Class 2 Topics covered as per CBSE syllabus - right arrow","event_category":"SPL","event_label":"Arrow"},"spl-class2topicscoveredaspercbsesyllabus-leftarrow":{"event_action":"SPL - Class 2 Topics covered as per CBSE syllabus - left arrow","event_category":"SPL","event_label":"Arrow"},"spl-class2-freetrial":{"event_action":"SPL - Class 2 - Free Trial","event_category":"SPL","event_label":"Free trial"},"spl-class2-subscribe":{"event_action":"SPL - Class 2 - Subscribe","event_category":"SPL","event_label":"Subscribe"},"spl-samplelessonsforclass3-measuringlength":{"event_action":"SPL - Sample Lessons for Class 3 - Measuring Length","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass3-measuringlength-close":{"event_action":"SPL - Sample Lessons for Class 3 - Measuring Length - Close","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass3-ronniesadventure":{"event_action":"SPL - Sample Lessons for Class 3 - Ronnies Adventure","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass3-ronniesadventure-close":{"event_action":"SPL - Sample Lessons for Class 3 - Ronnies Adventure - Close","event_category":"SPL","event_label":"Lesson"},"spl-class3topicscoveredaspercbsesyllabus-rightarrow":{"event_action":"SPL - Class 3 Topics covered as per CBSE syllabus - right arrow","event_category":"SPL","event_label":"Arrow"},"spl-class3topicscoveredaspercbsesyllabus-leftarrow":{"event_action":"SPL - Class 3 Topics covered as per CBSE syllabus - left arrow","event_category":"SPL","event_label":"Arrow"},"spl-class3-freetrial":{"event_action":"SPL - Class 3 - Free Trial","event_category":"SPL","event_label":"Free trial"},"spl-class3-subscribe":{"event_action":"SPL - Class 3- Subscribe","event_category":"SPL","event_label":"Subscribe"},"spl-samplelessonsforclass4-romannumerals":{"event_action":"SPL - Sample Lessons for Class 4 - Roman Numerals","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass4-romannumerals-close":{"event_action":"SPL - Sample Lessons for Class 4 - Roman Numerals - Close","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass4-readingbargraphs":{"event_action":"SPL - Sample Lessons for Class 4 - Reading Bar Graphs","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass4-readingbargraphs-close":{"event_action":"SPL - Sample Lessons for Class 4 - Reading Bar Graphs - Close","event_category":"SPL","event_label":"Lesson"},"spl-class4topicscoveredaspercbsesyllabus-rightarrow":{"event_action":"SPL - Class 4 Topics covered as per CBSE syllabus - right arrow","event_category":"SPL","event_label":"Arrow"},"spl-class4topicscoveredaspercbsesyllabus-leftarrow":{"event_action":"SPL - Class 4 Topics covered as per CBSE syllabus - left arrow","event_category":"SPL","event_label":"Arrow"},"spl-class4-freetrial":{"event_action":"SPL - Class 4 - Free Trial","event_category":"SPL","event_label":"Free trial"},"spl-class4-subscribe":{"event_action":"SPL - Class 4 - Subscribe","event_category":"SPL","event_label":"Subscribe"},"spl-samplelessonsforclass5-constructionofacirclewithgivenradius":{"event_action":"SPL - Sample Lessons for Class 5 - Construction of a circle with given radius","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass5-constructionofacirclewithgivenradius-close":{"event_action":"SPL - Sample Lessons for Class 5 - Construction of a circle with given radius - Close","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass5-anglesatapoint":{"event_action":"SPL - Sample Lessons for Class 5 - Angles at a Point","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass5-anglesatapoint-close":{"event_action":"SPL - Sample Lessons for Class 5 - Angles at a Point - Close","event_category":"SPL","event_label":"Lesson"},"spl-class5topicscoveredaspercbsesyllabus-rightarrow":{"event_action":"SPL - Class 5 Topics covered as per CBSE syllabus - right arrow","event_category":"SPL","event_label":"Arrow"},"spl-class5topicscoveredaspercbsesyllabus-leftarrow":{"event_action":"SPL - Class 5 Topics covered as per CBSE syllabus - left arrow","event_category":"SPL","event_label":"Arrow"},"spl-class5-freetrial":{"event_action":"SPL - Class 5 - Free Trial","event_category":"SPL","event_label":"Free trial"},"spl-class5-subscribe":{"event_action":"SPL - Class 5 - Subscribe","event_category":"SPL","event_label":"Subscribe"},"spl-samplelessonsforclass6-constructionsofspecialangles":{"event_action":"SPL - Sample Lessons for Class 6 - Construction of special angles","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass6-constructionsofspecialangles-close":{"event_action":"SPL - Sample Lessons for Class 6 - Construction of special angles - Close","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass6-introductiontoratios":{"event_action":"SPL - Sample Lessons for Class 6 - Introduction to ratios","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass6-introductiontoratios-close":{"event_action":"SPL - Sample Lessons for Class 6 - Introduction to ratios - Close","event_category":"SPL","event_label":"Lesson"},"spl-class6topicscoveredaspercbsesyllabus-rightarrow":{"event_action":"SPL - Class 6 Topics covered as per CBSE syllabus - right arrow","event_category":"SPL","event_label":"Arrow"},"spl-class6topicscoveredaspercbsesyllabus-leftarrow":{"event_action":"SPL - Class 6 Topics covered as per CBSE syllabus - left arrow","event_category":"SPL","event_label":"Arrow"},"spl-class6-freetrial":{"event_action":"SPL - Class 6 - Free Trial","event_category":"SPL","event_label":"Free trial"},"spl-class6-subscribe":{"event_action":"SPL - Class 6- Subscribe","event_category":"SPL","event_label":"Subscribe"},"spl-samplelessonsforclass7-verticallyoppositeangles":{"event_action":"SPL - Sample Lessons for Class 7 - Vertically Opposite Angles","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass7-verticallyoppositeangles-close":{"event_action":"SPL - Sample Lessons for Class 7 - Vertically Opposite Angles - Close","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass7-standardform":{"event_action":"SPL - Sample Lessons for Class 7 - Standard Form","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass7-standardform-close":{"event_action":"SPL - Sample Lessons for Class 7 - Standard Form - Close","event_category":"SPL","event_label":"Lesson"},"spl-class7topicscoveredaspercbsesyllabus-rightarrow":{"event_action":"SPL - Class 7 Topics covered as per CBSE syllabus - right arrow","event_category":"SPL","event_label":"Arrow"},"spl-class7topicscoveredaspercbsesyllabus-leftarrow":{"event_action":"SPL - Class 7 Topics covered as per CBSE syllabus - left arrow","event_category":"SPL","event_label":"Arrow"},"spl-class7-freetrial":{"event_action":"SPL - Class 7 - Free Trial","event_category":"SPL","event_label":"Free trial"},"spl-class7-subscribe":{"event_action":"SPL - Class 7 - Subscribe","event_category":"SPL","event_label":"Subscribe"},"spl-samplelessonsforclass8-firstquadrantinacoordinateplane":{"event_action":"SPL - Sample Lessons for Class 8 - First quadrant in a coordinate plane","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass8-firstquadrantinacoordinateplane-close":{"event_action":"SPL - Sample Lessons for Class 8 - First quadrant in a coordinate plane - Close","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass8-prismandpyramid":{"event_action":"SPL - Sample Lessons for Class 8 - Prism and pyramid","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass8-prismandpyramid-close":{"event_action":"SPL - Sample Lessons for Class 8 - Prism and pyramid - Close","event_category":"SPL","event_label":"Lesson"},"spl-class8topicscoveredaspercbsesyllabus-rightarrow":{"event_action":"SPL - Class 8 Topics covered as per CBSE syllabus - right arrow","event_category":"SPL","event_label":"Arrow"},"spl-class8topicscoveredaspercbsesyllabus-leftarrow":{"event_action":"SPL - Class 8 Topics covered as per CBSE syllabus - left arrow","event_category":"SPL","event_label":"Arrow"},"spl-class8-freetrial":{"event_action":"SPL - Class 8 - Free Trial","event_category":"SPL","event_label":"Free trial"},"spl-class8-subscribe":{"event_action":"SPL - Class 8- Subscribe","event_category":"SPL","event_label":"Subscribe"},"spl-samplelessonsforclass9-constructionofspecialangles":{"event_action":"SPL - Sample Lessons for Class 9 - Construction of special angles","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass9-constructionofspecialangles-close":{"event_action":"SPL - Sample Lessons for Class 9 - Construction of special angles - Close","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass9-anglepropertiesofcircles":{"event_action":"SPL - Sample Lessons for Class 9 - Angle properties of Circles","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass9-anglepropertiesofcircles-close":{"event_action":"SPL - Sample Lessons for Class 9 - Angle properties of Circles - Close","event_category":"SPL","event_label":"Lesson"},"spl-class9topicscoveredaspercbsesyllabus-rightarrow":{"event_action":"SPL - Class 9 Topics covered as per CBSE syllabus - right arrow","event_category":"SPL","event_label":"Arrow"},"spl-class9topicscoveredaspercbsesyllabus-leftarrow":{"event_action":"SPL - Class 9 Topics covered as per CBSE syllabus - left arrow","event_category":"SPL","event_label":"Arrow"},"spl-class9-freetrial":{"event_action":"SPL - Class 9 - Free Trial","event_category":"SPL","event_label":"Free trial"},"spl-class9-subscribe":{"event_action":"SPL - Class 9- Subscribe","event_category":"SPL","event_label":"Subscribe"},"spl-samplelessonsforclass10-introductiontotrigonometry":{"event_action":"SPL - Sample Lessons for Class 10 - Introduction to trigonometry","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass10-introductiontotrigonometry-close":{"event_action":"SPL - Sample Lessons for Class 10 - Introduction to trigonometry - Close","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass10-tangentsfromanexternalpoint":{"event_action":"SPL - Sample Lessons for Class 10 - Tangents from an external point","event_category":"SPL","event_label":"Lesson"},"spl-samplelessonsforclass10-tangentsfromanexternalpoint-close":{"event_action":"SPL - Sample Lessons for Class 10 - Tangents from an external point - Close","event_category":"SPL","event_label":"Lesson"},"spl-class10topicscoveredaspercbsesyllabus-rightarrow":{"event_action":"SPL - Class 10 Topics covered as per CBSE syllabus - right arrow","event_category":"SPL","event_label":"Arrow"},"spl-class10topicscoveredaspercbsesyllabus-leftarrow":{"event_action":"SPL - Class 10 Topics covered as per CBSE syllabus - left arrow","event_category":"SPL","event_label":"Arrow"},"spl-class10-freetrial":{"event_action":"SPL - Class 10 - Free Trial","event_category":"SPL","event_label":"Free trial"},"spl-class10-subscribe":{"event_action":"SPL - Class 10- Subscribe","event_category":"SPL","event_label":"Subscribe"},"personalisedlearningprogram-maintab":{"event_action":"Personalised Learning - Main Tab","event_category":"PLP","event_label":"Main Tab"},"plp-class5-howtheprogramworks-rightarrow":{"event_action":"PLP - Class 5 - How the program works - right arrow","event_category":"PLP","event_label":"Arrow"},"plp-class5-howtheprogramworks-leftarrow":{"event_action":"PLP - Class 5 - How the program works - left arrow","event_category":"PLP","event_label":"Arrow"},"plp-class5-topicscoveredaspercbsesyllabus-rightarrow":{"event_action":"PLP - Class 5 - Topics covered as per CBSE syllabus - right arrow","event_category":"PLP","event_label":"Arrow"},"plp-class5-topicscoveredaspercbsesyllabus-leftarrow":{"event_action":"PLP - Class 5 - Topics covered as per CBSE syllabus - left arrow","event_category":"PLP","event_label":"Arrow"},"plp-class5-freetrial":{"event_action":"PLP - Class 5 - Free Trial","event_category":"PLP","event_label":"Free trial"},"plp-class5-subscribe":{"event_action":"PLP - Class 5 - Subscribe","event_category":"PLP","event_label":"Subscribe"},"plp-class6-howtheprogramworks-rightarrow":{"event_action":"PLP - Class 6 - How the program works - right arrow","event_category":"PLP","event_label":"Arrow"},"plp-class6-howtheprogramworks-leftarrow":{"event_action":"PLP - Class 6 - How the program works - left arrow","event_category":"PLP","event_label":"Arrow"},"plp-class6-topicscoveredaspercbsesyllabus-rightarrow":{"event_action":"PLP - Class 6 - Topics covered as per CBSE syllabus - right arrow","event_category":"PLP","event_label":"Arrow"},"plp-class6-topicscoveredaspercbsesyllabus-leftarrow":{"event_action":"PLP - Class 6 - Topics covered as per CBSE syllabus - left arrow","event_category":"PLP","event_label":"Arrow"},"plp-class6-freetrial":{"event_action":"PLP - Class 6 - Free Trial","event_category":"PLP","event_label":"Free trial"},"plp-class6-subscribe":{"event_action":"PLP - Class 6 - Subscribe","event_category":"PLP","event_label":"Subscribe"},"plp-class7-howtheprogramworks-rightarrow":{"event_action":"PLP - Class 7 - How the program works - right arrow","event_category":"PLP","event_label":"Arrow"},"plp-class7-howtheprogramworks-leftarrow":{"event_action":"PLP - Class 7 - How the program works - left arrow","event_category":"PLP","event_label":"Arrow"},"plp-class7-topicscoveredaspercbsesyllabus-rightarrow":{"event_action":"PLP - Class 7 - Topics covered as per CBSE syllabus - right arrow","event_category":"PLP","event_label":"Arrow"},"plp-class7-topicscoveredaspercbsesyllabus-leftarrow":{"event_action":"PLP - Class 7 - Topics covered as per CBSE syllabus - left arrow","event_category":"PLP","event_label":"Arrow"},"plp-class7-freetrial":{"event_action":"PLP - Class 7 - Free Trial","event_category":"PLP","event_label":"Free trial"},"plp-class7-subscribe":{"event_action":"PLP - Class 7 - Subscribe","event_category":"PLP","event_label":"Subscribe"},"plp-class8-howtheprogramworks-rightarrow":{"event_action":"PLP - Class 8 - How the program works - right arrow","event_category":"PLP","event_label":"Arrow"},"plp-class8-howtheprogramworks-leftarrow":{"event_action":"PLP - Class 8 - How the program works - left arrow","event_category":"PLP","event_label":"Arrow"},"plp-class8-topicscoveredaspercbsesyllabus-rightarrow":{"event_action":"PLP - Class 8 - Topics covered as per CBSE syllabus - right arrow","event_category":"PLP","event_label":"Arrow"},"plp-class8-topicscoveredaspercbsesyllabus-leftarrow":{"event_action":"PLP - Class 8 - Topics covered as per CBSE syllabus - left arrow","event_category":"PLP","event_label":"Arrow"},"plp-class8-freetrial":{"event_action":"PLP - Class 8 - Free Trial","event_category":"PLP","event_label":"Free trial"},"plp-class8-subscribe":{"event_action":"PLP - Class 8 - Subscribe","event_category":"PLP","event_label":"Subscribe"},"ourlearning-maintab":{"event_action":"Our Learning - Main Tab","event_category":"Our Learnings","event_label":"Main Tab"},"ourlearnings-mathethaticsisnotaspectatorsport-flip":{"event_action":"Our Learnings - Mathethatics is not a spectator sport - flip","event_category":"Our Learnings","event_label":"Flip"},"ourlearnings-literacyandnumeracygotogether-flip":{"event_action":"Our Learnings - Literacy and Numeracy go together - flip","event_category":"Our Learnings","event_label":"Flip"},"ourlearnings-algebrarequiresastrongarithmeticfoundation-flip":{"event_action":"Our Learnings - Algebra requires a strong Arithmetic foundation - flip","event_category":"Our Learnings","event_label":"Flip"},"ourlearnings-mathisapowerfultoolininterdisciplinarycontexts-flip":{"event_action":"Our Learnings - Math is a powerful tool in interdisciplinary contexts - flip","event_category":"Our Learnings","event_label":"Flip"},"ourlearnings-mathematicalthinkingisallaboutprocesses-flip":{"event_action":"Our Learnings - Mathematical Thinking is all about processes - flip","event_category":"Our Learnings","event_label":"Flip"},"ourlearnings-multiplerepresentationsofconceptsdrivesthelearningdeeper-flip":{"event_action":"Our Learnings - Multiple representations of concepts drives the learning deeper - flip","event_category":"Our Learnings","event_label":"Flip"},"ourlearnings-attitudeanddispositionsmatterwhenitcomestomath-flip":{"event_action":"Our Learnings - Attitude and Dispositions matter when it comes to Math - flip","event_category":"Our Learnings","event_label":"Flip"},"ourlearnings-wecollaboratecloselywithteachers-karendickey":{"event_action":"Our Learnings - We collaborate closely with teachers - Karen Dickey","event_category":"Our Learnings","event_label":"Video"},"ourlearnings-wecollaboratecloselywithteachers-maheshwarinatarajan":{"event_action":"Our Learnings - We collaborate closely with teachers - Maheshwari Natarajan","event_category":"Our Learnings","event_label":"Video"},"ourlearnings-wecollaboratecloselywithteachers-swathiashar":{"event_action":"Our Learnings - We collaborate closely with teachers - Swathi Ashar","event_category":"Our Learnings","event_label":"Video"},"ourlearnings-wecollaboratecloselywithteachers-msjemila":{"event_action":"Our Learnings - We collaborate closely with teachers - Ms Jemila","event_category":"Our Learnings","event_label":"Video"},"ourlearnings-wecollaboratecloselywithteachers-meenameyyappan":{"event_action":"Our Learnings - We collaborate closely with teachers - Meena Meyyappan","event_category":"Our Learnings","event_label":"Video"},"ourlearnings-wecollaboratecloselywithteachers-nramadevi":{"event_action":"Our Learnings - We collaborate closely with teachers - N Rama Devi","event_category":"Our Learnings","event_label":"Video"},"whoweare-maintab":{"event_action":"Who we are - Main Tab","event_category":"Who we are","event_label":"Main Tab"},"whoweare-ourdnaandculture-intenselycollaborative-flip":{"event_action":"Who we are - Our DNA and Culture - Intensely collaborative - flip","event_category":"Who we are","event_label":"Flip"},"whoweare-ourdnaandculture-valueourglobality-flip":{"event_action":"Who we are - Our DNA and Culture - Value our Globality - flip","event_category":"Who we are","event_label":"Flip"},"whoweare-ourdnaandculture-colorfullydiverse-flip":{"event_action":"Who we are - Our DNA and Culture - Colorfully diverse - flip","event_category":"Who we are","event_label":"Flip"},"whoweare-ourdnaandculture-wehaveveneverstoppedlearning-flip":{"event_action":"Who we are - Our DNA and Culture - We have never stopped learning - flip","event_category":"Who we are","event_label":"Flip"},"whoweare-ourdnaandculture-atmosphereofacampus-flip":{"event_action":"Who we are - Our DNA and Culture - Atmosphere of a campus - flip","event_category":"Who we are","event_label":"Flip"},"whoweare-ourdnaandculture-matthewsmith1":{"event_action":"Who we are - Our DNA and Culture- Matthew Smith 1","event_category":"Who we are","event_label":"Video"},"whoweare-ourdnaandculture-kylelomer":{"event_action":"Who we are - Our DNA and Culture- Kyle Lomer","event_category":"Who we are","event_label":"Video"},"whoweare-ourdnaandculture-krishnabalakrishnan":{"event_action":"Who we are - Our DNA and Culture- Krishna Balakrishnan","event_category":"Who we are","event_label":"Video"},"whoweare-ourdnaandculture-matthewsmith2":{"event_action":"Who we are - Our DNA and Culture- Matthew Smith 2","event_category":"Who we are","event_label":"Video"},"whoweare-ourdnaandculture-samuelhewitt":{"event_action":"Who we are - Our DNA and Culture- Samuel Hewitt","event_category":"Who we are","event_label":"Video"},"whoweare-ourdnaandculture-matthewsmith3":{"event_action":"Who we are - Our DNA and Culture- Matthew Smith 3","event_category":"Who we are","event_label":"Video"},"whoweare-ourdnaandculture-kylelomer2":{"event_action":"Who we are - Our DNA and Culture- Kyle Lomer 2","event_category":"Who we are","event_label":"Video"},"whoweare-ourworkhasbeenrecognisedby-stilleatingourlunch":{"event_action":"Who we are - Our work has been recognised by - Still eating our lunch","event_category":"Who we are","event_label":"News article"},"whoweare-ourworkhasbeenrecognisedby-howmathscanbegreatfun":{"event_action":"Who we are - Our work has been recognised by - How maths can be great fun","event_category":"Who we are","event_label":"News article"},"whoweare-ourworkhasbeenrecognisedby-letstalkaboutfigures":{"event_action":"Who we are - Our work has been recognised by - Lets talk about figures","event_category":"Who we are","event_label":"News article"},"whoweare-ourworkhasbeenrecognisedby-de-mystifyingmaths":{"event_action":"Who we are - Our work has been recognised by - De-mystifying maths","event_category":"Who we are","event_label":"News article"},"whoweare-ourworkhasbeenrecognisedby-heymathcanbegreatfun":{"event_action":"Who we are - Our work has been recognised by - Hey, math can be great fun","event_category":"Who we are","event_label":"News article"},"parentpostlogin-mypurchases-maintab":{"event_action":"Parent Post Login - My Purchases - Main tab","event_category":"Post-Login","event_label":"Parent"},"parentpostlogin-mypurchases-assignto-selectastudent":{"event_action":"Parent Post Login - My Purchases - Assign to - Select a student","event_category":"Post-Login","event_label":"Assign"},"parentpostlogin-mypurchases-assignto-createanewstudent":{"event_action":"Parent Post Login - My Purchases - Assign to - Create a new student","event_category":"Post-Login","event_label":"Assign"},"parentpostlogin-mypurchases-assignto-createanewstudent-cbse":{"event_action":"Parent Post Login - My Purchases - Assign to - Create a new student - CBSE","event_category":"Post-Login","event_label":"Assign"},"parentpostlogin-mypurchases-assignto-createanewstudent-icse":{"event_action":"Parent Post Login - My Purchases - Assign to - Create a new student - ICSE","event_category":"Post-Login","event_label":"Assign"},"parentpostlogin-mypurchases-assignto-createanewstudent-other":{"event_action":"Parent Post Login - My Purchases - Assign to - Create a new student - Other","event_category":"Post-Login","event_label":"Assign"},"parentpostlogin-mypurchases-assignto-createanewstudent-assign":{"event_action":"Parent Post Login - My Purchases - Assign to - Create a new student - Assign","event_category":"Post-Login","event_label":"Assign"},"parentpostlogin-mypurchases-assignto-createanewstudent-close":{"event_action":"Parent Post Login - My Purchases - Assign to - Create a new student - Close","event_category":"Post-Login","event_label":"Close"},"parentpostlogin-signoutbutton":{"event_action":"Parent Post Login - Sign Out button","event_category":"Post-Login","event_label":"Sign out"},"parentpostlogin-areyousurewanttologout?-yes":{"event_action":"Parent Post Login - Are you sure want to logout? - Yes","event_category":"Post-Login","event_label":"Sign out"},"parentpostlogin-areyousurewanttologout?-cancel":{"event_action":"Parent Post Login - Are you sure want to logout? - Cancel","event_category":"Post-Login","event_label":"Parent"},"plp&spl-loggedin":{"event_action":"PLP & SPL- Logged In","event_category":"Post-Login","event_label":"Student"},"spl-class1-purchase":{"event_action":"SPL - Class 1 - Purchase","event_category":"SPL","event_label":"Purchase"},"spl-class1-editdetails":{"event_action":"SPL - Class 1 - Edit Details","event_category":"SPL","event_label":"Purchase"},"spl-class1-proceedtopay":{"event_action":"SPL - Class 1 - Proceed to pay","event_category":"SPL","event_label":"Purchase"},"spl-class1-revieworderdetails-close":{"event_action":"SPL - Class 1 - Review order details - close","event_category":"SPL","event_label":"Close Button"},"spl-class2-purchase":{"event_action":"SPL - Class 2 - Purchase","event_category":"SPL","event_label":"Purchase"},"spl-class2-editdetails":{"event_action":"SPL - Class 2 - Edit Details","event_category":"SPL","event_label":"Purchase"},"spl-class2-proceedtopay":{"event_action":"SPL - Class 2 - Proceed to pay","event_category":"SPL","event_label":"Purchase"},"spl-class2-revieworderdetails-close":{"event_action":"SPL - Class 2 - Review order details - close","event_category":"SPL","event_label":"Close Button"},"spl-class3-purchase":{"event_action":"SPL - Class 3 - Purchase","event_category":"SPL","event_label":"Purchase"},"spl-class3-editdetails":{"event_action":"SPL - Class 3 - Edit Details","event_category":"SPL","event_label":"Purchase"},"spl-class3-proceedtopay":{"event_action":"SPL - Class 3 - Proceed to pay","event_category":"SPL","event_label":"Purchase"},"spl-class3-revieworderdetails-close":{"event_action":"SPL - Class 3 - Review order details - close","event_category":"SPL","event_label":"Close Button"},"spl-class4-purchase":{"event_action":"SPL - Class 4 - Purchase","event_category":"SPL","event_label":"Purchase"},"spl-class4-editdetails":{"event_action":"SPL - Class 4 - Edit Details","event_category":"SPL","event_label":"Purchase"},"spl-class4-proceedtopay":{"event_action":"SPL - Class 4 - Proceed to pay","event_category":"SPL","event_label":"Purchase"},"spl-class4-revieworderdetails-close":{"event_action":"SPL - Class 4 - Review order details - close","event_category":"SPL","event_label":"Close Button"},"spl-class5-purchase":{"event_action":"SPL - Class 5 - Purchase","event_category":"SPL","event_label":"Purchase"},"spl-class5-editdetails":{"event_action":"SPL - Class 5 - Edit Details","event_category":"SPL","event_label":"Purchase"},"spl-class5-proceedtopay":{"event_action":"SPL - Class 5 - Proceed to pay","event_category":"SPL","event_label":"Purchase"},"spl-class5-revieworderdetails-close":{"event_action":"SPL - Class 5 - Review order details - close","event_category":"SPL","event_label":"Close Button"},"spl-class6-purchase":{"event_action":"SPL - Class 6 - Purchase","event_category":"SPL","event_label":"Purchase"},"spl-class6-editdetails":{"event_action":"SPL - Class 6 - Edit Details","event_category":"SPL","event_label":"Purchase"},"spl-class6-proceedtopay":{"event_action":"SPL - Class 6 - Proceed to pay","event_category":"SPL","event_label":"Purchase"},"spl-class6-revieworderdetails-close":{"event_action":"SPL - Class 6 - Review order details - close","event_category":"SPL","event_label":"Close Button"},"spl-class7-purchase":{"event_action":"SPL - Class 7 - Purchase","event_category":"SPL","event_label":"Purchase"},"spl-class7-editdetails":{"event_action":"SPL - Class 7 - Edit Details","event_category":"SPL","event_label":"Purchase"},"spl-class7-proceedtopay":{"event_action":"SPL - Class 7 - Proceed to pay","event_category":"SPL","event_label":"Purchase"},"spl-class7-revieworderdetails-close":{"event_action":"SPL - Class 7 - Review order details - close","event_category":"SPL","event_label":"Close Button"},"spl-class8-purchase":{"event_action":"SPL - Class 8 - Purchase","event_category":"SPL","event_label":"Purchase"},"spl-class8-editdetails":{"event_action":"SPL - Class 8 - Edit Details","event_category":"SPL","event_label":"Purchase"},"spl-class8-proceedtopay":{"event_action":"SPL - Class 8 - Proceed to pay","event_category":"SPL","event_label":"Purchase"},"spl-class8-revieworderdetails-close":{"event_action":"SPL - Class 8 - Review order details - close","event_category":"SPL","event_label":"Close Button"},"spl-class9-purchase":{"event_action":"SPL - Class 9 - Purchase","event_category":"SPL","event_label":"Purchase"},"spl-class9-editdetails":{"event_action":"SPL - Class 9 - Edit Details","event_category":"SPL","event_label":"Purchase"},"spl-class9-proceedtopay":{"event_action":"SPL - Class 9 - Proceed to pay","event_category":"SPL","event_label":"Purchase"},"spl-class9-revieworderdetails-close":{"event_action":"SPL - Class 9 - Review order details - close","event_category":"SPL","event_label":"Close Button"},"spl-class10-purchase":{"event_action":"SPL - Class 10 - Purchase","event_category":"SPL","event_label":"Purchase"},"spl-class10-editdetails":{"event_action":"SPL - Class 10 - Edit Details","event_category":"SPL","event_label":"Purchase"},"spl-class10-proceedtopay":{"event_action":"SPL - Class 10 - Proceed to pay","event_category":"SPL","event_label":"Purchase"},"spl-class10-revieworderdetails-close":{"event_action":"SPL - Class 10 - Review order details - close","event_category":"SPL","event_label":"Close Button"},"plp-class5-purchase":{"event_action":"PLP - Class 5 - Purchase","event_category":"PLP","event_label":"Purchase"},"plp-class5-editdetails":{"event_action":"PLP - Class 5 - Edit Details","event_category":"PLP","event_label":"Purchase"},"plp-class5-proceedtopay":{"event_action":"PLP - Class 5 - Proceed to pay","event_category":"PLP","event_label":"Purchase"},"plp-class5-revieworderdetails-close":{"event_action":"PLP - Class 5 - Review order details - close","event_category":"PLP","event_label":"Close Button"},"plp-class6-purchase":{"event_action":"PLP - Class 6 - Purchase","event_category":"PLP","event_label":"Purchase"},"plp-class6-editdetails":{"event_action":"PLP - Class 6 - Edit Details","event_category":"PLP","event_label":"Purchase"},"plp-class6-proceedtopay":{"event_action":"PLP - Class 6 - Proceed to pay","event_category":"PLP","event_label":"Purchase"},"plp-class6-revieworderdetails-close":{"event_action":"PLP - Class 6 - Review order details - close","event_category":"PLP","event_label":"Close Button"},"plp-class7-purchase":{"event_action":"PLP - Class 7 - Purchase","event_category":"PLP","event_label":"Purchase"},"plp-class7-editdetails":{"event_action":"PLP - Class 7 - Edit Details","event_category":"PLP","event_label":"Purchase"},"plp-class7-proceedtopay":{"event_action":"PLP - Class 7 - Proceed to pay","event_category":"PLP","event_label":"Purchase"},"plp-class7-revieworderdetails-close":{"event_action":"PLP - Class 7 - Review order details - close","event_category":"PLP","event_label":"Close Button"},"plp-class8-purchase":{"event_action":"PLP - Class 8 - Purchase","event_category":"PLP","event_label":"Purchase"},"plp-class8-editdetails":{"event_action":"PLP - Class 8 - Edit Details","event_category":"PLP","event_label":"Purchase"},"plp-class8-proceedtopay":{"event_action":"PLP - Class 8 - Proceed to pay","event_category":"PLP","event_label":"Purchase"},"plp-class8-revieworderdetails-close":{"event_action":"PLP - Class 8 - Review order details - close","event_category":"PLP","event_label":"Close Button"},"home-customisetoyourschoolstestcalendar":{"event_action":"Home - Customise to your schools test calendar","event_category":"Home","event_label":"Calendar"},"plp-class5-customisetoyourschoolstestcalendar":{"event_action":"PLP - Class 5 - Customise to your schools test calendar","event_category":"PLP","event_label":"Calendar"},"plp-class6-customisetoyourschoolstestcalendar":{"event_action":"PLP - Class 6 - Customise to your schools test calendar","event_category":"PLP","event_label":"Calendar"},"plp-class7-customisetoyourschoolstestcalendar":{"event_action":"PLP - Class 7 - Customise to your schools test calendar","event_category":"PLP","event_label":"Calendar"},"plp-class8-customisetoyourschoolstestcalendar":{"event_action":"PLP - Class 8 - Customise to your schools test calendar","event_category":"PLP","event_label":"Calendar"},"plp-class9-customisetoyourschoolstestcalendar":{"event_action":"PLP - Class 9 - Customise to your schools test calendar","event_category":"PLP","event_label":"Calendar"},"plp-class10-customisetoyourschoolstestcalendar":{"event_action":"PLP - Class 10 - Customise to your schools test calendar","event_category":"PLP","event_label":"Calendar"},"home-product-self-pacedlessons-class1-directlink":{"event_action":"Home - Product - Self-Paced Lessons - Class 1 - Direct link","event_category":"Home","event_label":"Products"},"home-product-self-pacedlessons-class2-directlink":{"event_action":"Home - Product - Self-Paced Lessons - Class 2- Direct link","event_category":"Home","event_label":"Products"},"home-product-self-pacedlessons-class3-directlink":{"event_action":"Home - Product - Self-Paced Lessons - Class 3 - Direct link","event_category":"Home","event_label":"Products"},"home-product-self-pacedlessons-class4-directlink":{"event_action":"Home - Product - Self-Paced Lessons - Class 4 - Direct link","event_category":"Home","event_label":"Products"},"home-product-personalisedlearningprogram-class5-directlink":{"event_action":"Home - Product - Personalised Learning- Class 5 - Direct link","event_category":"Home","event_label":"Products"},"home-product-personalisedlearningprogram-class6-directlink":{"event_action":"Home - Product - Personalised Learning - Class 6 - Direct link","event_category":"Home","event_label":"Products"},"home-product-personalisedlearningprogram-class7-directlink":{"event_action":"Home - Product - Personalised Learning - Class 7 - Direct link","event_category":"Home","event_label":"Products"},"home-product-personalisedlearningprogram-class8-directlink":{"event_action":"Home - Product - Personalised Learning - Class 8 - Direct link","event_category":"Home","event_label":"Products"},"home-product-cbseexamprep-class9-directlink":{"event_action":"Home - Product - CBSE Exam Prep - Class 9 - Direct link","event_category":"Home","event_label":"Products"},"home-product-cbseexamprep-class10-directlink":{"event_action":"Home - Product - CBSE Exam Prep - Class 10 - Direct link","event_category":"Home","event_label":"Products"},"home-enteryouremail/number-tophome-join":{"event_action":"Home - Enter your email/number - Top Home- Join","event_category":"Home","event_label":"Sign Up"},"home-enteryouremail/number-tophome-join-newuser-resend":{"event_action":"Home - Enter your email/number - Top Home- Join - New User - Resend","event_category":"Home","event_label":"OTP resend"},"home-enteryouremail/number-tophome-join-newuser-verify":{"event_action":"Home - Enter your email/number - Top Home- Join - New User - Verify","event_category":"Home","event_label":"Verify OTP"},"home-enteryouremail/number-tophome-join-newuser-signinwithgoogle":{"event_action":"Home - Enter your email/number - Top Home- Join - New User - Sign in with Google","event_category":"Home","event_label":"Google SIgn In"},"home-enteryouremail/number-tophome-join-returninguser-forgotpassword":{"event_action":"Home - Enter your email/number - Top Home- Join - Returning User - Forgot Password","event_category":"Home","event_label":"Forgot Password"},"home-enteryouremail/number-tophome-join-returninguser-signin":{"event_action":"Home - Enter your email/number - Top Home- Join - Returning User - Sign In","event_category":"Home","event_label":"Sign In"},"home-enteryouremail/number-tophome-join-returninguser-continuewithgoogle":{"event_action":"Home - Enter your email/number - Top Home- Join - Returning User - Continue with Google","event_category":"Home","event_label":"Google SIgn In"},"home-enteryouremail/number-tophome-join-returninguser-signup":{"event_action":"Home - Enter your email/number - Top Home- Join - Returning User - Sign Up","event_category":"Home","event_label":"Sign Up"},"home-enteryouremail/number-bottomhome-join":{"event_action":"Home - Enter your email/number - Bottom Home- Join","event_category":"Home","event_label":"Sign Up"},"home-enteryouremail/number-bottomhome-join-newuser-resend":{"event_action":"Home - Enter your email/number - Bottom Home- Join - New User - Resend","event_category":"Home","event_label":"OTP resend"},"home-enteryouremail/number-bottomhome-join-newuser-verify":{"event_action":"Home - Enter your email/number - Bottom Home- Join - New User - Verify","event_category":"Home","event_label":"Verify OTP"},"home-enteryouremail/number-bottomhome-join-newuser-signinwithgoogle":{"event_action":"Home - Enter your email/number - Bottom Home- Join - New User - Sign in with Google","event_category":"Home","event_label":"Google SIgn In"},"home-enteryouremail/number-bottomhome-join-returninguser-forgotpassword":{"event_action":"Home - Enter your email/number - Bottom Home- Join - Returning User - Forgot Password","event_category":"Home","event_label":"Forgot Password"},"home-enteryouremail/number-bottomhome-join-returninguser-signin":{"event_action":"Home - Enter your email/number - Bottom Home- Join - Returning User - Sign In","event_category":"Home","event_label":"Sign In"},"home-enteryouremail/number-bottomhome-join-returninguser-continuewithgoogle":{"event_action":"Home - Enter your email/number - Bottom Home- Join - Returning User - Continue with Google","event_category":"Home","event_label":"Google SIgn In"},"home-enteryouremail/number-bottomhome-join-returninguser-signup":{"event_action":"Home - Enter your email/number - Bottom Home- Join - Returning User - Sign Up","event_category":"Home","event_label":"Sign Up"},"footer-cbseexamprep-class9":{"event_action":"Footer - CBSE Exam Prep - Grade 9","event_category":"Footer","event_label":"CBSE Exam Prep"},"footer-cbseexamprep-class10":{"event_action":"Footer - CBSE Exam Prep - Grade 10","event_category":"Footer","event_label":"CBSE Exam Prep"},"spl-class1-top-freetrial":{"event_action":"SPL - Class 1 - Top - Free Trial","event_category":"SPL","event_label":"Free Trial"},"spl-class1-top-subscribenow":{"event_action":"SPL - Class 1 - Top - Subscribe now","event_category":"SPL","event_label":"Subscribe"},"spl-class1-bottom-freetrial":{"event_action":"SPL - Class 1 - Bottom - Free Trial","event_category":"SPL","event_label":"Free trial"},"spl-class1-bottom-subscribenow":{"event_action":"SPL - Class 1 - Bottom - Subscribe now","event_category":"SPL","event_label":"Subscribe"},"spl-class2-top-freetrial":{"event_action":"SPL - Class 2 - Top - Free Trial","event_category":"SPL","event_label":"Free Trial"},"spl-class2-top-subscribenow":{"event_action":"SPL - Class 2 - Top - Subscribe now","event_category":"SPL","event_label":"Subscribe"},"spl-class2-bottom-freetrial":{"event_action":"SPL - Class 2 - Bottom - Free Trial","event_category":"SPL","event_label":"Free trial"},"spl-class2-bottom-subscribenow":{"event_action":"SPL - Class 2 - Bottom -Subscribe now","event_category":"SPL","event_label":"Subscribe"},"spl-class3-top-freetrial":{"event_action":"SPL - Class 3 - Top - Free Trial","event_category":"SPL","event_label":"Free Trial"},"spl-class3-top-subscribenow":{"event_action":"SPL - Class 3 - Top - Subscribe now","event_category":"SPL","event_label":"Subscribe"},"spl-class3-bottom-freetrial":{"event_action":"SPL - Class 3 - Bottom - Free Trial","event_category":"SPL","event_label":"Free trial"},"spl-class3-bottom-subscribenow":{"event_action":"SPL - Class 3 - Bottom -Subscribe now","event_category":"SPL","event_label":"Subscribe"},"spl-class4-top-freetrial":{"event_action":"SPL - Class 4 - Top - Free Trial","event_category":"SPL","event_label":"Free Trial"},"spl-class4-top-subscribenow":{"event_action":"SPL - Class 4 - Top - Subscribe now","event_category":"SPL","event_label":"Subscribe"},"spl-class4-bottom-freetrial":{"event_action":"SPL - Class 4 - Bottom - Free Trial","event_category":"SPL","event_label":"Free trial"},"spl-class4-bottom-subscribenow":{"event_action":"SPL - Class 4 - Bottom -Subscribe now","event_category":"SPL","event_label":"Subscribe"},"plp-class5-top-freetrial":{"event_action":"PLP - Class 5 - Top - Free Trial","event_category":"SPL","event_label":"Free Trial"},"plp-class5-top-subscribenow":{"event_action":"PLP - Class 5 - Top - Subscribe now","event_category":"SPL","event_label":"Subscribe"},"plp-class5-bottom-freetrial":{"event_action":"PLP - Class 5 - Bottom - Free Trial","event_category":"SPL","event_label":"Free Trial"},"plp-class5-bottom-subscribenow":{"event_action":"PLP - Class 5 - Bottom - Subscribe now","event_category":"SPL","event_label":"Subscribe"},"plp-class6-top-freetrial":{"event_action":"PLP - Class 6 - Top - Free Trial","event_category":"SPL","event_label":"Free Trial"},"plp-class6-top-subscribenow":{"event_action":"PLP - Class 6 - Top - Subscribe now","event_category":"SPL","event_label":"Subscribe"},"plp-class6-bottom-freetrial":{"event_action":"PLP - Class 6 - Bottom - Free Trial","event_category":"SPL","event_label":"Free Trial"},"plp-class6-bottom-subscribenow":{"event_action":"PLP - Class 6 - Bottom - Subscribe now","event_category":"SPL","event_label":"Subscribe"},"plp-class7-top-freetrial":{"event_action":"PLP - Class 7 - Top - Free Trial","event_category":"SPL","event_label":"Free Trial"},"plp-class7-top-subscribenow":{"event_action":"PLP - Class 7 - Top - Subscribe now","event_category":"SPL","event_label":"Subscribe"},"plp-class7-bottom-freetrial":{"event_action":"PLP - Class 7 - Bottom - Free Trial","event_category":"SPL","event_label":"Free Trial"},"plp-class7-bottom-subscribenow":{"event_action":"PLP - Class 7 - Bottom - Subscribe now","event_category":"SPL","event_label":"Subscribe"},"plp-class8-top-freetrial":{"event_action":"PLP - Class 8 - Top - Free Trial","event_category":"PLP","event_label":"Free trial"},"plp-class8-top-subscribenow":{"event_action":"PLP - Class 8 - Top - Subscribe now","event_category":"PLP","event_label":"Subscribe"},"cbseexamprep-class9-top-freetrial":{"event_action":"CBSE Exam Prep - Class 9 - Top - Free Trial","event_category":"CBSE Exam Prep","event_label":"Free trial"},"cbseexamprep-class9-top-subscribenow":{"event_action":"CBSE Exam Prep - Class 9 - Top - Subscribe now","event_category":"CBSE Exam Prep","event_label":"Subscribe"},"cbseexamprep-class9-howtheprogramworks-rightarrow":{"event_action":"CBSE Exam Prep - Class 9 - How the program works - right arrow","event_category":"CBSE Exam Prep","event_label":"Arrow"},"cbseexamprep-class9-howtheprogramworks-leftarrow":{"event_action":"CBSE Exam Prep - Class 9 - How the program works - left arrow","event_category":"CBSE Exam Prep","event_label":"Arrow"},"cbseexamprep-class9-bottom-freetrial":{"event_action":"CBSE Exam Prep - Class 9 - Bottom - Free Trial","event_category":"CBSE Exam Prep","event_label":"Free trial"},"cbseexamprep-class9-bottom-subscribenow":{"event_action":"CBSE Exam Prep - Class 9 - Bottom - Subscribe now","event_category":"CBSE Exam Prep","event_label":"Subscribe"},"cbseexamprep-class9-purchase":{"event_action":"CBSE Exam Prep - Class 9 - Purchase","event_category":"CBSE Exam Prep","event_label":"Purchase"},"cbseexamprep-class9-editdetails":{"event_action":"CBSE Exam Prep - Class 9 - Edit Details","event_category":"CBSE Exam Prep","event_label":"Purchase"},"cbseexamprep-class9-proceedtopay":{"event_action":"CBSE Exam Prep - Class 9 - Proceed to pay","event_category":"CBSE Exam Prep","event_label":"Purchase"},"cbseexamprep-class9-revieworderdetails-close":{"event_action":"CBSE Exam Prep - Class 9 - Review order details - close","event_category":"CBSE Exam Prep","event_label":"Close Button"},"cbseexamprep-class10-top-freetrial":{"event_action":"CBSE Exam Prep - Class 10 - Top - Free Trial","event_category":"CBSE Exam Prep","event_label":"Free trial"},"cbseexamprep-class10-top-subscribenow":{"event_action":"CBSE Exam Prep - Class 10 - Top - Subscribe now","event_category":"CBSE Exam Prep","event_label":"Subscribe"},"cbseexamprep-class10-howtheprogramworks-rightarrow":{"event_action":"CBSE Exam Prep - Class 10 - How the program works - right arrow","event_category":"CBSE Exam Prep","event_label":"Arrow"},"cbseexamprep-class10-howtheprogramworks-leftarrow":{"event_action":"CBSE Exam Prep - Class 10 - How the program works - left arrow","event_category":"CBSE Exam Prep","event_label":"Arrow"},"cbseexamprep-class10-bottom-freetrial":{"event_action":"CBSE Exam Prep - Class 10 - Bottom - Free Trial","event_category":"CBSE Exam Prep","event_label":"Free trial"},"cbseexamprep-class10-bottom-subscribenow":{"event_action":"CBSE Exam Prep - Class 10 - Bottom - Subscribe now","event_category":"CBSE Exam Prep","event_label":"Subscribe"},"cbseexamprep-class10-purchase":{"event_action":"CBSE Exam Prep - Class 10 - Purchase","event_category":"CBSE Exam Prep","event_label":"Purchase"},"cbseexamprep-class10-editdetails":{"event_action":"CBSE Exam Prep - Class 10 - Edit Details","event_category":"CBSE Exam Prep","event_label":"Purchase"},"cbseexamprep-class10-proceedtopay":{"event_action":"CBSE Exam Prep - Class 10 - Proceed to pay","event_category":"CBSE Exam Prep","event_label":"Purchase"},"cbseexamprep-class10-revieworderdetails-close":{"event_action":"CBSE Exam Prep - Class 10 - Review order details - close","event_category":"CBSE Exam Prep","event_label":"Close Button"},"home-userswhohaveindependentlyregistered-signup-newuser-resend":{"event_action":"Home - Users who have independently registered- Sign Up - New User - Resend","event_category":"Home","event_label":"Sign Up"},"home-userswhohaveindependentlyregistered-signup-newuser-verify":{"event_action":"Home - Users who have independently registered - Sign Up - New User - Verify","event_category":"Home","event_label":"Verification"},"home-userswhohaveindependentlyregistered-signup-newuser-signinwithgoogle":{"event_action":"Home - Users who have independently registered - Sign Up - New User - Sign in with Google - Start Learning","event_category":"Home","event_label":"Google Sign In"},"home-userswhohaveindependentlyregistered-signup-returninguser-forgotpassword":{"event_action":"Home - Users who have independently registered - Sign Up - Returning User - Forgot Password","event_category":"Home","event_label":"Sign In"},"home-userswhohaveindependentlyregistered-signup-returninguser-signin":{"event_action":"Home - Users who have independently registered - Sign Up - Returning User - Sign In","event_category":"Home","event_label":"Sign In"},"home-userswhohaveindependentlyregistered-signup-returninguser-continuewithgoogle":{"event_action":"Home - Users who have independently registered - Sign Up - Returning User - Continue with Google","event_category":"Home","event_label":"Google Sign In"},"home-userswhohaveindependentlyregistered-signup-newuser-signup":{"event_action":"Home - Users who have independently registered - Sign Up - New User - Sign Up","event_category":"Home","event_label":"Sign Up"},"home-bottomhome-join":{"event_action":"Home - Bottom Home- Join","event_category":"Home","event_label":"Sign Up"},"home-bottomhome-join-newuser-resend":{"event_action":"Home - Bottom Home- Join - New User - Resend","event_category":"Home","event_label":"OTP resend"},"home-bottomhome-join-newuser-verify":{"event_action":"Home - Bottom Home- Join - New User - Verify","event_category":"Home","event_label":"Verify OTP"},"home-bottomhome-join-newuser-signinwithgoogle":{"event_action":"Home - Bottom Home- Join - New User - Sign in with Google","event_category":"Home","event_label":"Google SIgn In"},"home-bottomhome-join-returninguser-forgotpassword":{"event_action":"Home - Bottom Home- Join - Returning User - Forgot Password","event_category":"Home","event_label":"Forgot Password"},"home-bottomhome-join-returninguser-signin":{"event_action":"Home - Bottom Home- Join - Returning User - Sign In","event_category":"Home","event_label":"Sign In"},"home-bottomhome-join-returninguser-continuewithgoogle":{"event_action":"Home - Bottom Home- Join - Returning User - Continue with Google","event_category":"Home","event_label":"Google SIgn In"},"home-bottomhome-join-returninguser-signup":{"event_action":"Home - Bottom Home- Join - Returning User - Sign Up","event_category":"Home","event_label":"Sign Up"},"home-tophome-join":{"event_action":"Home - Top Home- Join","event_category":"Home","event_label":"Sign Up"},"home-tophome-join-newuser-resend":{"event_action":"Home - Top Home - Join - New User - Resend","event_category":"Home","event_label":"OTP resend"},"home-tophome-join-newuser-verify":{"event_action":"Home - Top Home - Join - New User - Verify","event_category":"Home","event_label":"Verify OTP"},"home-tophome-join-newuser-signinwithgoogle":{"event_action":"Home - Top Home - Join - New User - Sign in with Google","event_category":"Home","event_label":"Google SIgn In"},"home-tophome-join-returninguser-forgotpassword":{"event_action":"Home - Top Home - Join - Returning User - Forgot Password","event_category":"Home","event_label":"Forgot Password"},"home-tophome-join-returninguser-signin":{"event_action":"Home - Top Home - Join - Returning User - Sign In","event_category":"Home","event_label":"Sign In"},"home-tophome-join-returninguser-continuewithgoogle":{"event_action":"Home - Top Home - Join - Returning User - Continue with Google","event_category":"Home","event_label":"Google SIgn In"},"home-tophome-join-returninguser-signup":{"event_action":"Home - Top Home - Join - Returning User - Sign Up","event_category":"Home","event_label":"Sign Up"},"postlogin-class1":{"event_label":"Grade","event_category":"My HeyMath","event_action":"Post login - Class 1"},"postlogin-class1-lessons":{"event_label":"Lessons Main","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons"},"postlogin-class1-lessons-numbers-start":{"event_label":"Start topic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons - Numbers - Start"},"postlogin-class1-lessons-numbers-resume":{"event_label":"Resume topic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons - Numbers - Resume"},"postlogin-class1-lessons-numbers-watched":{"event_label":"Rewatch topic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons - Numbers - Watched"},"postlogin-class1-lessons-numbers-numbersfrom0to10-start":{"event_label":"Start subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Numbers - Numbers from 0 to 10 - Start"},"postlogin-class1-lessons-numbers-numbersfrom0to10-resume":{"event_label":"Resume subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Numbers - Numbers from 0 to 10 - Resume"},"postlogin-class1-lessons-numbers-numbersfrom0to10-watched":{"event_label":"Rewatch subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Numbers - Numbers from 0 to 10 - Watched"},"postlogin-class1-lessons-numbers-numbersfrom0to10-lessons":{"event_label":"Class 1 lessons","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Numbers - Numbers from 0 to 10 - Lessons"},"postlogin-class1-lessons-numbers-numbersfrom0to10-close":{"event_label":"Close subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Numbers - Numbers from 0 to 10 - Close"},"postlogin-class1-lessons-numbers-numbersupto20-start":{"event_label":"Start subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Numbers - Numbers up to 20 - Start"},"postlogin-class1-lessons-numbers-numbersupto20-resume":{"event_label":"Resume subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Numbers - Numbers up to 20 - Resume"},"postlogin-class1-lessons-numbers-numbersupto20-watched":{"event_label":"Rewatch subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Numbers - Numbers up to 20 - Watched"},"postlogin-class1-lessons-numbers-numbersupto20-lessons":{"event_label":"Class 1 lessons","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Numbers - Numbers up to 20 - Lessons"},"postlogin-class1-lessons-numbers-numbersupto20-close":{"event_label":"Close subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Numbers - Numbers up to 20 - Close"},"postlogin-class1-lessons-numbers-numbersupto50-start":{"event_label":"Start subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Numbers - Numbers up to 50 - Start"},"postlogin-class1-lessons-numbers-numbersupto50-resume":{"event_label":"Resume subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Numbers - Numbers up to 50 - Resume"},"postlogin-class1-lessons-numbers-numbersupto50-watched":{"event_label":"Rewatch subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Numbers - Numbers up to 50 - Watched"},"postlogin-class1-lessons-numbers-numbersupto50-lessons":{"event_label":"Class 1 lessons","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Numbers - Numbers up to 50 - Lessons"},"postlogin-class1-lessons-numbers-numbersupto50-close":{"event_label":"Close subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Numbers - Numbers up to 50 - Close"},"postlogin-class1-lessons-numbers-numbersupto100-start":{"event_label":"Start subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Numbers - Numbers up to 100 - Start"},"postlogin-class1-lessons-numbers-numbersupto100-resume":{"event_label":"Resume subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Numbers - Numbers up to 100 - Resume"},"postlogin-class1-lessons-numbers-numbersupto100-watched":{"event_label":"Rewatch subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Numbers - Numbers up to 100 - Watched"},"postlogin-class1-lessons-numbers-numbersupto100-lessons":{"event_label":"Class 1 lessons","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Numbers - Numbers up to 100 - Lessons"},"postlogin-class1-lessons-numbers-numbersupto100-close":{"event_label":"Close subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Numbers - Numbers up to 100 - Close"},"postlogin-class2":{"event_label":"Grade","event_category":"My HeyMath","event_action":"Post login - Class 2"},"postlogin-class2-lessons":{"event_label":"Lessons Main","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons"},"postlogin-class2-lessons-numbers-start":{"event_label":"Start topic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons - Numbers - Start"},"postlogin-class2-lessons-numbers-resume":{"event_label":"Resume topic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons - Numbers - Resume"},"postlogin-class2-lessons-numbers-watched":{"event_label":"Rewatch topic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons - Numbers - Watched"},"postlogin-class2-lessons-numbers-numbersupto200-start":{"event_label":"Start subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Numbers - Numbers up to 200 - Start"},"postlogin-class2-lessons-numbers-numbersupto200-resume":{"event_label":"Resume subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Numbers - Numbers up to 200 - Resume"},"postlogin-class2-lessons-numbers-numbersupto200-watched":{"event_label":"Rewatch subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Numbers - Numbers up to 200 - Watched"},"postlogin-class2-lessons-numbers-numbersupto200-lessons":{"event_label":"Class 2 lessons","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Numbers - Numbers up to 200 - Lessons"},"postlogin-class2-lessons-numbers-numbersupto200-close":{"event_label":"Close subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Numbers - Numbers up to 200 - Close"},"postlogin-class2-lessons-numbers-numbersupto1000-start":{"event_label":"Start subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Numbers - Numbers up to 1000 - Start"},"postlogin-class2-lessons-numbers-numbersupto1000-resume":{"event_label":"Resume subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Numbers - Numbers up to 1000 - Resume"},"postlogin-class2-lessons-numbers-numbersupto1000-watched":{"event_label":"Rewatch subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Numbers - Numbers up to 1000 - Watched"},"postlogin-class2-lessons-numbers-numbersupto1000-lessons":{"event_label":"Class 2 lessons","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Numbers - Numbers up to 1000 - Lessons"},"postlogin-class2-lessons-numbers-numbersupto1000-close":{"event_label":"Close subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Numbers - Numbers up to 1000 - Close"},"postlogin-class3":{"event_label":"Grade","event_category":"My HeyMath","event_action":"Post login - Class 3"},"postlogin-class3-lessons":{"event_label":"Lessons Main","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons"},"postlogin-class3-lessons-numbers-start":{"event_label":"Start topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Numbers - Start"},"postlogin-class3-lessons-numbers-resume":{"event_label":"Resume topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Numbers - Resume"},"postlogin-class3-lessons-numbers-watched":{"event_label":"Rewatch topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Numbers - Watched"},"postlogin-class3-lessons-numbers-placevalue-start":{"event_label":"Start subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Numbers - Place Value - Start"},"postlogin-class3-lessons-numbers-placevalue-resume":{"event_label":"Resume subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Numbers - Place Value - Resume"},"postlogin-class3-lessons-numbers-placevalue-watched":{"event_label":"Rewatch subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Numbers - Place Value - Watched"},"postlogin-class3-lessons-numbers-placevalue-lessons":{"event_label":"Class 3 lessons","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Numbers - Place Value - Lessons"},"postlogin-class3-lessons-numbers-placevalue-close":{"event_label":"Close subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Numbers - Place Value - Close"},"postlogin-class4":{"event_label":"Grade","event_category":"My HeyMath","event_action":"Post login - Class 4"},"postlogin-class4-lessons":{"event_label":"Lessons Main","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons"},"postlogin-class4-lessons-numbers-start":{"event_label":"Start topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Numbers - Start"},"postlogin-class4-lessons-numbers-resume":{"event_label":"Resume topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Numbers - Resume"},"postlogin-class4-lessons-numbers-watched":{"event_label":"Rewatch topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Numbers - Watched"},"postlogin-class4-lessons-numbers-representingnumbers-start":{"event_label":"Start subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Numbers - Representing Numbers - Start"},"postlogin-class4-lessons-numbers-representingnumbers-resume":{"event_label":"Resume subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Numbers - Representing Numbers - Resume"},"postlogin-class4-lessons-numbers-representingnumbers-watched":{"event_label":"Rewatch subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Numbers - Representing Numbers - Watched"},"postlogin-class4-lessons-numbers-representingnumbers-lessons":{"event_label":"Class 4 lessons","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Numbers - Representing Numbers - Lessons"},"postlogin-class4-lessons-numbers-representingnumbers-close":{"event_label":"Close subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Numbers - Representing Numbers - Close"},"postlogin-class4-lessons-numbers-comparingandordering-start":{"event_label":"Start subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Numbers - Comparing and Ordering - Start"},"postlogin-class4-lessons-numbers-comparingandordering-resume":{"event_label":"Resume subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Numbers - Comparing and Ordering - Resume"},"postlogin-class4-lessons-numbers-comparingandordering-watched":{"event_label":"Rewatch subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Numbers - Comparing and Ordering - Watched"},"postlogin-class4-lessons-numbers-comparingandordering-lessons":{"event_label":"Class 4 lessons","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Numbers - Comparing and Ordering - Lessons"},"postlogin-class4-lessons-numbers-comparingandordering-close":{"event_label":"Close subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Numbers - Comparing and Ordering - Close"},"postlogin-class5":{"event_label":"Grade","event_category":"My HeyMath","event_action":"Post login - Class 5"},"postlogin-class5-lessons":{"event_label":"Lessons Main","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons"},"postlogin-class5-lessons-largenumbers-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Large Numbers - Start"},"postlogin-class5-lessons-largenumbers-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Large Numbers - Resume"},"postlogin-class5-lessons-largenumbers-watched":{"event_label":"Rewatch topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Large Numbers - Watched"},"postlogin-class5-lessons-largenumbers-representinglargenumbers-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Large Numbers - Representing Large Numbers - Start"},"postlogin-class5-lessons-largenumbers-representinglargenumbers-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Large Numbers - Representing Large Numbers - Resume"},"postlogin-class5-lessons-largenumbers-representinglargenumbers-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Large Numbers - Representing Large Numbers - Watched"},"postlogin-class5-lessons-largenumbers-representinglargenumbers-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Large Numbers - Representing Large Numbers - Lessons"},"postlogin-class5-lessons-largenumbers-representinglargenumbers-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Large Numbers - Representing Large Numbers - Close"},"postlogin-class5-lessons-largenumbers-comparingandorderinglargenumbers-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Large Numbers - Comparing and Ordering Large Numbers - Start"},"postlogin-class5-lessons-largenumbers-comparingandorderinglargenumbers-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Large Numbers - Comparing and Ordering Large Numbers - Resume"},"postlogin-class5-lessons-largenumbers-comparingandorderinglargenumbers-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Large Numbers - Comparing and Ordering Large Numbers - Watched"},"postlogin-class5-lessons-largenumbers-comparingandorderinglargenumbers-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Large Numbers - Comparing and Ordering Large Numbers - Lessons"},"postlogin-class5-lessons-largenumbers-comparingandorderinglargenumbers-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Large Numbers - Comparing and Ordering Large Numbers - Close"},"postlogin-class5-lessons-largenumbers-romannumerals-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Large Numbers - Roman Numerals - Start"},"postlogin-class5-lessons-largenumbers-romannumerals-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Large Numbers - Roman Numerals - Resume"},"postlogin-class5-lessons-largenumbers-romannumerals-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Large Numbers - Roman Numerals - Watched"},"postlogin-class5-lessons-largenumbers-romannumerals-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Large Numbers - Roman Numerals - Lessons"},"postlogin-class5-lessons-largenumbers-romannumerals-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Large Numbers - Roman Numerals - Close"},"postlogin-class6":{"event_label":"Grade","event_category":"My HeyMath","event_action":"Post login - Class 6"},"postlogin-class6-lessons":{"event_label":"Lessons Main","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons"},"postlogin-class6-lessons-numbersystems-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Number Systems - Start"},"postlogin-class6-lessons-numbersystems-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Number Systems - Resume"},"postlogin-class6-lessons-numbersystems-watched":{"event_label":"Rewatch topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Number Systems - Watched"},"postlogin-class6-lessons-numbersystems-placevalueandestimation-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Number Systems - Place Value and Estimation - Start"},"postlogin-class6-lessons-numbersystems-placevalueandestimation-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Number Systems - Place Value and Estimation - Resume"},"postlogin-class6-lessons-numbersystems-placevalueandestimation-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Number Systems - Place Value and Estimation - Watched"},"postlogin-class6-lessons-numbersystems-placevalueandestimation-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Number Systems - Place Value and Estimation - Lessons"},"postlogin-class6-lessons-numbersystems-placevalueandestimation-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Number Systems - Place Value and Estimation - Close"},"postlogin-class6-lessons-numbersystems-useofbracketsinsimplification-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Number Systems - Use of Brackets in Simplification - Start"},"postlogin-class6-lessons-numbersystems-useofbracketsinsimplification-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Number Systems - Use of Brackets in Simplification - Resume"},"postlogin-class6-lessons-numbersystems-useofbracketsinsimplification-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Number Systems - Use of Brackets in Simplification - Watched"},"postlogin-class6-lessons-numbersystems-useofbracketsinsimplification-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Number Systems - Use of Brackets in Simplification - Lessons"},"postlogin-class6-lessons-numbersystems-useofbracketsinsimplification-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Number Systems - Use of Brackets in Simplification - Close"},"postlogin-class6-lessons-numbersystems-romannumerals-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Number Systems - Roman Numerals - Start"},"postlogin-class6-lessons-numbersystems-romannumerals-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Number Systems - Roman Numerals - Resume"},"postlogin-class6-lessons-numbersystems-romannumerals-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Number Systems - Roman Numerals - Watched"},"postlogin-class6-lessons-numbersystems-romannumerals-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Number Systems - Roman Numerals - Lessons"},"postlogin-class6-lessons-numbersystems-romannumerals-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Number Systems - Roman Numerals - Close"},"postlogin-class7":{"event_label":"Grade","event_category":"My HeyMath","event_action":"Post login - Class 7"},"postlogin-class7-lessons":{"event_label":"Lessons Main","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons"},"postlogin-class7-lessons-integers-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Integers - Start"},"postlogin-class7-lessons-integers-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Integers - Resume"},"postlogin-class7-lessons-integers-watched":{"event_label":"Rewatch topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Integers - Watched"},"postlogin-class7-lessons-integers-operationsonintegers-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Integers - Operations on Integers - Start"},"postlogin-class7-lessons-integers-operationsonintegers-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Integers - Operations on Integers - Resume"},"postlogin-class7-lessons-integers-operationsonintegers-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Integers - Operations on Integers - Watched"},"postlogin-class7-lessons-integers-operationsonintegers-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Integers - Operations on Integers - Lessons"},"postlogin-class7-lessons-integers-operationsonintegers-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Integers - Operations on Integers - Close"},"postlogin-class8":{"event_label":"Grade","event_category":"My HeyMath","event_action":"Post login - Class 8"},"postlogin-class8-lessons":{"event_label":"Lessons Main","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons"},"postlogin-class8-lessons-rationalnumbers-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Rational Numbers - Start"},"postlogin-class8-lessons-rationalnumbers-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Rational Numbers - Resume"},"postlogin-class8-lessons-rationalnumbers-watched":{"event_label":"Rewatch topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Rational Numbers - Watched"},"postlogin-class8-lessons-rationalnumbers-operationsonrationalnumbers-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Rational Numbers - Operations on Rational Numbers - Start"},"postlogin-class8-lessons-rationalnumbers-operationsonrationalnumbers-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Rational Numbers - Operations on Rational Numbers - Resume"},"postlogin-class8-lessons-rationalnumbers-operationsonrationalnumbers-watched":{"event_label":"Rewatch subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Rational Numbers - Operations on Rational Numbers - Watched"},"postlogin-class8-lessons-rationalnumbers-operationsonrationalnumbers-lessons":{"event_label":"Class 8 lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Rational Numbers - Operations on Rational Numbers - Lessons"},"postlogin-class8-lessons-rationalnumbers-operationsonrationalnumbers-close":{"event_label":"Close subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Rational Numbers - Operations on Rational Numbers - Close"},"postlogin-class9":{"event_label":"Grade","event_category":"My HeyMath","event_action":"Post login - Class 9"},"postlogin-class9-lessons":{"event_label":"Lessons Main","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons"},"postlogin-class9-lessons-numbersystems-start":{"event_label":"Start topic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons - Number Systems - Start"},"postlogin-class9-lessons-numbersystems-resume":{"event_label":"Resume topic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons - Number Systems - Resume"},"postlogin-class9-lessons-numbersystems-watched":{"event_label":"Rewatch topic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons - Number Systems - Watched"},"postlogin-class9-lessons-numbersystems-realnumbers-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Number Systems - Real Numbers - Start"},"postlogin-class9-lessons-numbersystems-realnumbers-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Number Systems - Real Numbers - Resume"},"postlogin-class9-lessons-numbersystems-realnumbers-watched":{"event_label":"Rewatch subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Number Systems - Real Numbers - Watched"},"postlogin-class9-lessons-numbersystems-realnumbers-lessons":{"event_label":"Class 9 lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Number Systems - Real Numbers - Lessons"},"postlogin-class9-lessons-numbersystems-realnumbers-close":{"event_label":"Close subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Number Systems - Real Numbers - Close"},"postlogin-class9-lessons-numbersystems-surdsandexponents-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Number Systems - Surds and Exponents - Start"},"postlogin-class9-lessons-numbersystems-surdsandexponents-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Number Systems - Surds and Exponents - Resume"},"postlogin-class9-lessons-numbersystems-surdsandexponents-watched":{"event_label":"Rewatch subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Number Systems - Surds and Exponents - Watched"},"postlogin-class9-lessons-numbersystems-surdsandexponents-lessons":{"event_label":"Class 9 lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Number Systems - Surds and Exponents - Lessons"},"postlogin-class9-lessons-numbersystems-surdsandexponents-close":{"event_label":"Close subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Number Systems - Surds and Exponents - Close"},"postlogin-class10":{"event_label":"Grade","event_category":"My HeyMath","event_action":"Post login - Class 10"},"postlogin-class10-lessons":{"event_label":"Lessons Main","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons"},"postlogin-class10-lessons-numbersystems-start":{"event_label":"Start topic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons - Number Systems - Start"},"postlogin-class10-lessons-numbersystems-resume":{"event_label":"Resume topic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons - Number Systems - Resume"},"postlogin-class10-lessons-numbersystems-watched":{"event_label":"Rewatch topic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons - Number Systems - Watched"},"postlogin-class10-lessons-numbersystems-realnumbers-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Number Systems - Real Numbers - Start"},"postlogin-class10-lessons-numbersystems-realnumbers-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Number Systems - Real Numbers - Resume"},"postlogin-class10-lessons-numbersystems-realnumbers-watched":{"event_label":"Rewatch subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Number Systems - Real Numbers - Watched"},"postlogin-class10-lessons-numbersystems-realnumbers-lessons":{"event_label":"Class 10 lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Number Systems - Real Numbers - Lessons"},"postlogin-class10-lessons-numbersystems-realnumbers-close":{"event_label":"Close subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Number Systems - Real Numbers - Close"},"postlogin-class5-tests":{"event_label":"Lessons Main","event_category":"Class 5","event_action":"Post login - Class 5 - Tests"},"postlogin-class5-tests-largenumbers-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Start"},"postlogin-class5-tests-largenumbers-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Resume"},"postlogin-class5-tests-largenumbers-revise":{"event_label":"Revise topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Revise"},"postlogin-class5-tests-largenumbers-largenumbersi-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - PT - Start"},"postlogin-class5-tests-largenumbers-largenumbersi-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - PT - Resume"},"postlogin-class5-tests-largenumbers-largenumbersi-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - PT - Report"},"postlogin-class5-tests-largenumbers-largenumbersi-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - PT - Start - Start Test"},"postlogin-class5-tests-largenumbers-largenumbersi-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - PT - Close"},"postlogin-class5-tests-largenumbers-largenumbersi-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - PT - Resume - Continue Test"},"postlogin-class5-tests-largenumbers-largenumbersi-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - PT - Test - Close"},"postlogin-class5-tests-largenumbers-largenumbersi-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - PT - Test - Submit Test"},"postlogin-class5-tests-largenumbers-largenumbersi-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - PT - Scorecard - View Solutions"},"postlogin-class5-tests-largenumbers-largenumbersi-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-largenumbers-largenumbersi-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-largenumbers-largenumbersi-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-largenumbers-largenumbersi-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-largenumbers-largenumbersi-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-largenumbers-largenumbersi-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-largenumbers-largenumbersi-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-largenumbers-largenumbersi-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-largenumbers-largenumbersi-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-largenumbers-largenumbersi-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-largenumbers-largenumbersi-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-largenumbers-largenumbersi-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-largenumbers-largenumbersi-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-largenumbers-largenumbersi-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-largenumbers-largenumbersi-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-largenumbers-largenumbersi-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - CP - Start"},"postlogin-class5-tests-largenumbers-largenumbersi-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - CP - Start - Start Practice"},"postlogin-class5-tests-largenumbers-largenumbersi-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - CP - Start - Close"},"postlogin-class5-tests-largenumbers-largenumbersi-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - CP - Start - Start Practice - Close"},"postlogin-class5-tests-largenumbers-largenumbersi-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - CP - Start - Start Practice - Check"},"postlogin-class5-tests-largenumbers-largenumbersi-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - CP - Resume"},"postlogin-class5-tests-largenumbers-largenumbersi-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - CP - Resume - Continue"},"postlogin-class5-tests-largenumbers-largenumbersi-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - CP - Resume - Close"},"postlogin-class5-tests-largenumbers-largenumbersi-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - CP - Resume - Continue - Close"},"postlogin-class5-tests-largenumbers-largenumbersi-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - CP - Resume - Continue - Check"},"postlogin-class5-tests-largenumbers-largenumbersi-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers I - CP - Report"},"postlogin-class5-tests-largenumbers-largenumbersii-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - PT - Start"},"postlogin-class5-tests-largenumbers-largenumbersii-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - PT - Resume"},"postlogin-class5-tests-largenumbers-largenumbersii-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - PT - Report"},"postlogin-class5-tests-largenumbers-largenumbersii-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - PT - Start - Start Test"},"postlogin-class5-tests-largenumbers-largenumbersii-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - PT - Close"},"postlogin-class5-tests-largenumbers-largenumbersii-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - PT - Resume - Continue Test"},"postlogin-class5-tests-largenumbers-largenumbersii-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - PT - Test - Close"},"postlogin-class5-tests-largenumbers-largenumbersii-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - PT - Test - Submit Test"},"postlogin-class5-tests-largenumbers-largenumbersii-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - PT - Scorecard - View Solutions"},"postlogin-class5-tests-largenumbers-largenumbersii-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-largenumbers-largenumbersii-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-largenumbers-largenumbersii-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-largenumbers-largenumbersii-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-largenumbers-largenumbersii-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-largenumbers-largenumbersii-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-largenumbers-largenumbersii-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-largenumbers-largenumbersii-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-largenumbers-largenumbersii-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-largenumbers-largenumbersii-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-largenumbers-largenumbersii-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-largenumbers-largenumbersii-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-largenumbers-largenumbersii-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-largenumbers-largenumbersii-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-largenumbers-largenumbersii-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-largenumbers-largenumbersii-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - CP - Start"},"postlogin-class5-tests-largenumbers-largenumbersii-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - CP - Start - Start Practice"},"postlogin-class5-tests-largenumbers-largenumbersii-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - CP - Start - Close"},"postlogin-class5-tests-largenumbers-largenumbersii-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - CP - Start - Start Practice - Close"},"postlogin-class5-tests-largenumbers-largenumbersii-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - CP - Start - Start Practice - Check"},"postlogin-class5-tests-largenumbers-largenumbersii-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - CP - Resume"},"postlogin-class5-tests-largenumbers-largenumbersii-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - CP - Resume - Continue"},"postlogin-class5-tests-largenumbers-largenumbersii-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - CP - Resume - Close"},"postlogin-class5-tests-largenumbers-largenumbersii-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - CP - Resume - Continue - Close"},"postlogin-class5-tests-largenumbers-largenumbersii-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - CP - Resume - Continue - Check"},"postlogin-class5-tests-largenumbers-largenumbersii-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Large Numbers - Large Numbers II - CP - Report"},"postlogin-class6-tests":{"event_label":"Lessons Main","event_category":"Class 6","event_action":"Post login - Class 6 - Tests"},"postlogin-class6-tests-numbersystems-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Start"},"postlogin-class6-tests-numbersystems-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Resume"},"postlogin-class6-tests-numbersystems-revise":{"event_label":"Revise topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Revise"},"postlogin-class6-tests-numbersystems-comparingnumbers-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - PT - Start"},"postlogin-class6-tests-numbersystems-comparingnumbers-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - PT - Resume"},"postlogin-class6-tests-numbersystems-comparingnumbers-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - PT - Report"},"postlogin-class6-tests-numbersystems-comparingnumbers-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - PT - Start - Start Test"},"postlogin-class6-tests-numbersystems-comparingnumbers-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - PT - Close"},"postlogin-class6-tests-numbersystems-comparingnumbers-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - PT - Resume - Continue Test"},"postlogin-class6-tests-numbersystems-comparingnumbers-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - PT - Test - Close"},"postlogin-class6-tests-numbersystems-comparingnumbers-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - PT - Test - Submit Test"},"postlogin-class6-tests-numbersystems-comparingnumbers-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - PT - Scorecard - View Solutions"},"postlogin-class6-tests-numbersystems-comparingnumbers-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-numbersystems-comparingnumbers-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-numbersystems-comparingnumbers-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-numbersystems-comparingnumbers-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-numbersystems-comparingnumbers-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-numbersystems-comparingnumbers-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-numbersystems-comparingnumbers-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-numbersystems-comparingnumbers-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-numbersystems-comparingnumbers-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-numbersystems-comparingnumbers-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-numbersystems-comparingnumbers-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-numbersystems-comparingnumbers-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-numbersystems-comparingnumbers-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-numbersystems-comparingnumbers-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-numbersystems-comparingnumbers-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-numbersystems-comparingnumbers-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - CP - Start"},"postlogin-class6-tests-numbersystems-comparingnumbers-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - CP - Start - Start Practice"},"postlogin-class6-tests-numbersystems-comparingnumbers-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - CP - Start - Close"},"postlogin-class6-tests-numbersystems-comparingnumbers-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - CP - Start - Start Practice - Close"},"postlogin-class6-tests-numbersystems-comparingnumbers-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - CP - Start - Start Practice - Check"},"postlogin-class6-tests-numbersystems-comparingnumbers-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - CP - Resume"},"postlogin-class6-tests-numbersystems-comparingnumbers-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - CP - Resume - Continue"},"postlogin-class6-tests-numbersystems-comparingnumbers-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - CP - Resume - Close"},"postlogin-class6-tests-numbersystems-comparingnumbers-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - CP - Resume - Continue - Close"},"postlogin-class6-tests-numbersystems-comparingnumbers-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - CP - Resume - Continue - Check"},"postlogin-class6-tests-numbersystems-comparingnumbers-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Comparing Numbers - CP - Report"},"postlogin-class6-tests-numbersystems-placevalueandestimation-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - PT - Start"},"postlogin-class6-tests-numbersystems-placevalueandestimation-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - PT - Resume"},"postlogin-class6-tests-numbersystems-placevalueandestimation-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - PT - Report"},"postlogin-class6-tests-numbersystems-placevalueandestimation-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - PT - Start - Start Test"},"postlogin-class6-tests-numbersystems-placevalueandestimation-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - PT - Close"},"postlogin-class6-tests-numbersystems-placevalueandestimation-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - PT - Resume - Continue Test"},"postlogin-class6-tests-numbersystems-placevalueandestimation-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - PT - Test - Close"},"postlogin-class6-tests-numbersystems-placevalueandestimation-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - PT - Test - Submit Test"},"postlogin-class6-tests-numbersystems-placevalueandestimation-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - PT - Scorecard - View Solutions"},"postlogin-class6-tests-numbersystems-placevalueandestimation-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-numbersystems-placevalueandestimation-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-numbersystems-placevalueandestimation-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-numbersystems-placevalueandestimation-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-numbersystems-placevalueandestimation-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-numbersystems-placevalueandestimation-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-numbersystems-placevalueandestimation-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-numbersystems-placevalueandestimation-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-numbersystems-placevalueandestimation-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-numbersystems-placevalueandestimation-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-numbersystems-placevalueandestimation-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-numbersystems-placevalueandestimation-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-numbersystems-placevalueandestimation-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-numbersystems-placevalueandestimation-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-numbersystems-placevalueandestimation-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-numbersystems-placevalueandestimation-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - CP - Start"},"postlogin-class6-tests-numbersystems-placevalueandestimation-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - CP - Start - Start Practice"},"postlogin-class6-tests-numbersystems-placevalueandestimation-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - CP - Start - Close"},"postlogin-class6-tests-numbersystems-placevalueandestimation-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - CP - Start - Start Practice - Close"},"postlogin-class6-tests-numbersystems-placevalueandestimation-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - CP - Start - Start Practice - Check"},"postlogin-class6-tests-numbersystems-placevalueandestimation-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - CP - Resume"},"postlogin-class6-tests-numbersystems-placevalueandestimation-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - CP - Resume - Continue"},"postlogin-class6-tests-numbersystems-placevalueandestimation-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - CP - Resume - Close"},"postlogin-class6-tests-numbersystems-placevalueandestimation-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - CP - Resume - Continue - Close"},"postlogin-class6-tests-numbersystems-placevalueandestimation-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - CP - Resume - Continue - Check"},"postlogin-class6-tests-numbersystems-placevalueandestimation-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Place Value and Estimation - CP - Report"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - PT - Start"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - PT - Resume"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - PT - Report"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - PT - Start - Start Test"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - PT - Close"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - PT - Resume - Continue Test"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - PT - Test - Close"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - PT - Test - Submit Test"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - PT - Scorecard - View Solutions"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - CP - Start"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - CP - Start - Start Practice"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - CP - Start - Close"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - CP - Start - Start Practice - Close"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - CP - Start - Start Practice - Check"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - CP - Resume"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - CP - Resume - Continue"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - CP - Resume - Close"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - CP - Resume - Continue - Close"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - CP - Resume - Continue - Check"},"postlogin-class6-tests-numbersystems-operationsonlargenumbers-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Operations on Large Numbers - CP - Report"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - PT - Start"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - PT - Resume"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - PT - Report"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - PT - Start - Start Test"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - PT - Close"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - PT - Resume - Continue Test"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - PT - Test - Close"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - PT - Test - Submit Test"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - PT - Scorecard - View Solutions"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - CP - Start"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - CP - Start - Start Practice"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - CP - Start - Close"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - CP - Start - Start Practice - Close"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - CP - Start - Start Practice - Check"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - CP - Resume"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - CP - Resume - Continue"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - CP - Resume - Close"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - CP - Resume - Continue - Close"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - CP - Resume - Continue - Check"},"postlogin-class6-tests-numbersystems-useofbracketsinsimplification-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Use of Brackets in Simplification - CP - Report"},"postlogin-class6-tests-numbersystems-romannumerals-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - PT - Start"},"postlogin-class6-tests-numbersystems-romannumerals-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - PT - Resume"},"postlogin-class6-tests-numbersystems-romannumerals-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - PT - Report"},"postlogin-class6-tests-numbersystems-romannumerals-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - PT - Start - Start Test"},"postlogin-class6-tests-numbersystems-romannumerals-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - PT - Close"},"postlogin-class6-tests-numbersystems-romannumerals-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - PT - Resume - Continue Test"},"postlogin-class6-tests-numbersystems-romannumerals-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - PT - Test - Close"},"postlogin-class6-tests-numbersystems-romannumerals-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - PT - Test - Submit Test"},"postlogin-class6-tests-numbersystems-romannumerals-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - PT - Scorecard - View Solutions"},"postlogin-class6-tests-numbersystems-romannumerals-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-numbersystems-romannumerals-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-numbersystems-romannumerals-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-numbersystems-romannumerals-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-numbersystems-romannumerals-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-numbersystems-romannumerals-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-numbersystems-romannumerals-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-numbersystems-romannumerals-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-numbersystems-romannumerals-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-numbersystems-romannumerals-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-numbersystems-romannumerals-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-numbersystems-romannumerals-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-numbersystems-romannumerals-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-numbersystems-romannumerals-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-numbersystems-romannumerals-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-numbersystems-romannumerals-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - CP - Start"},"postlogin-class6-tests-numbersystems-romannumerals-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - CP - Start - Start Practice"},"postlogin-class6-tests-numbersystems-romannumerals-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - CP - Start - Close"},"postlogin-class6-tests-numbersystems-romannumerals-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - CP - Start - Start Practice - Close"},"postlogin-class6-tests-numbersystems-romannumerals-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - CP - Start - Start Practice - Check"},"postlogin-class6-tests-numbersystems-romannumerals-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - CP - Resume"},"postlogin-class6-tests-numbersystems-romannumerals-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - CP - Resume - Continue"},"postlogin-class6-tests-numbersystems-romannumerals-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - CP - Resume - Close"},"postlogin-class6-tests-numbersystems-romannumerals-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - CP - Resume - Continue - Close"},"postlogin-class6-tests-numbersystems-romannumerals-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - CP - Resume - Continue - Check"},"postlogin-class6-tests-numbersystems-romannumerals-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Number Systems - Roman Numerals - CP - Report"},"postlogin-class7-tests":{"event_label":"Lessons Main","event_category":"Class 7","event_action":"Post login - Class 7 - Tests"},"postlogin-class7-tests-integers-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Start"},"postlogin-class7-tests-integers-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Resume"},"postlogin-class7-tests-integers-revise":{"event_label":"Revise topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Revise"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - PT - Start"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - PT - Resume"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - PT - Report"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - PT - Start - Start Test"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - PT - Close"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - PT - Resume - Continue Test"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - PT - Test - Close"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - PT - Test - Submit Test"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - PT - Scorecard - View Solutions"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - CP - Start"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - CP - Start - Start Practice"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - CP - Start - Close"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - CP - Start - Start Practice - Close"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - CP - Start - Start Practice - Check"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - CP - Resume"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - CP - Resume - Continue"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - CP - Resume - Close"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - CP - Resume - Continue - Close"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - CP - Resume - Continue - Check"},"postlogin-class7-tests-integers-multiplicationanddivisionofintegers-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Multiplication and Division of Integers - CP - Report"},"postlogin-class7-tests-integers-applicationsofintegers-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - PT - Start"},"postlogin-class7-tests-integers-applicationsofintegers-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - PT - Resume"},"postlogin-class7-tests-integers-applicationsofintegers-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - PT - Report"},"postlogin-class7-tests-integers-applicationsofintegers-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - PT - Start - Start Test"},"postlogin-class7-tests-integers-applicationsofintegers-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - PT - Close"},"postlogin-class7-tests-integers-applicationsofintegers-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - PT - Resume - Continue Test"},"postlogin-class7-tests-integers-applicationsofintegers-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - PT - Test - Close"},"postlogin-class7-tests-integers-applicationsofintegers-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - PT - Test - Submit Test"},"postlogin-class7-tests-integers-applicationsofintegers-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - PT - Scorecard - View Solutions"},"postlogin-class7-tests-integers-applicationsofintegers-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-integers-applicationsofintegers-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-integers-applicationsofintegers-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-integers-applicationsofintegers-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-integers-applicationsofintegers-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-integers-applicationsofintegers-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-integers-applicationsofintegers-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-integers-applicationsofintegers-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-integers-applicationsofintegers-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-integers-applicationsofintegers-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-integers-applicationsofintegers-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-integers-applicationsofintegers-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-integers-applicationsofintegers-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-integers-applicationsofintegers-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-integers-applicationsofintegers-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-integers-applicationsofintegers-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - CP - Start"},"postlogin-class7-tests-integers-applicationsofintegers-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - CP - Start - Start Practice"},"postlogin-class7-tests-integers-applicationsofintegers-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - CP - Start - Close"},"postlogin-class7-tests-integers-applicationsofintegers-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - CP - Start - Start Practice - Close"},"postlogin-class7-tests-integers-applicationsofintegers-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - CP - Start - Start Practice - Check"},"postlogin-class7-tests-integers-applicationsofintegers-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - CP - Resume"},"postlogin-class7-tests-integers-applicationsofintegers-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - CP - Resume - Continue"},"postlogin-class7-tests-integers-applicationsofintegers-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - CP - Resume - Close"},"postlogin-class7-tests-integers-applicationsofintegers-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - CP - Resume - Continue - Close"},"postlogin-class7-tests-integers-applicationsofintegers-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - CP - Resume - Continue - Check"},"postlogin-class7-tests-integers-applicationsofintegers-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Applications of Integers - CP - Report"},"postlogin-class7-tests-integers-orderofoperations-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - PT - Start"},"postlogin-class7-tests-integers-orderofoperations-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - PT - Resume"},"postlogin-class7-tests-integers-orderofoperations-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - PT - Report"},"postlogin-class7-tests-integers-orderofoperations-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - PT - Start - Start Test"},"postlogin-class7-tests-integers-orderofoperations-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - PT - Close"},"postlogin-class7-tests-integers-orderofoperations-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - PT - Resume - Continue Test"},"postlogin-class7-tests-integers-orderofoperations-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - PT - Test - Close"},"postlogin-class7-tests-integers-orderofoperations-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - PT - Test - Submit Test"},"postlogin-class7-tests-integers-orderofoperations-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - PT - Scorecard - View Solutions"},"postlogin-class7-tests-integers-orderofoperations-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-integers-orderofoperations-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-integers-orderofoperations-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-integers-orderofoperations-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-integers-orderofoperations-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-integers-orderofoperations-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-integers-orderofoperations-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-integers-orderofoperations-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-integers-orderofoperations-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-integers-orderofoperations-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-integers-orderofoperations-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-integers-orderofoperations-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-integers-orderofoperations-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-integers-orderofoperations-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-integers-orderofoperations-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-integers-orderofoperations-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - CP - Start"},"postlogin-class7-tests-integers-orderofoperations-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - CP - Start - Start Practice"},"postlogin-class7-tests-integers-orderofoperations-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - CP - Start - Close"},"postlogin-class7-tests-integers-orderofoperations-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - CP - Start - Start Practice - Close"},"postlogin-class7-tests-integers-orderofoperations-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - CP - Start - Start Practice - Check"},"postlogin-class7-tests-integers-orderofoperations-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - CP - Resume"},"postlogin-class7-tests-integers-orderofoperations-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - CP - Resume - Continue"},"postlogin-class7-tests-integers-orderofoperations-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - CP - Resume - Close"},"postlogin-class7-tests-integers-orderofoperations-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - CP - Resume - Continue - Close"},"postlogin-class7-tests-integers-orderofoperations-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - CP - Resume - Continue - Check"},"postlogin-class7-tests-integers-orderofoperations-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - Order of Operations - CP - Report"},"postlogin-class7-tests-integers-moreonorderofoperations-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - PT - Start"},"postlogin-class7-tests-integers-moreonorderofoperations-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - PT - Resume"},"postlogin-class7-tests-integers-moreonorderofoperations-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - PT - Report"},"postlogin-class7-tests-integers-moreonorderofoperations-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - PT - Start - Start Test"},"postlogin-class7-tests-integers-moreonorderofoperations-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - PT - Close"},"postlogin-class7-tests-integers-moreonorderofoperations-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - PT - Resume - Continue Test"},"postlogin-class7-tests-integers-moreonorderofoperations-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - PT - Test - Close"},"postlogin-class7-tests-integers-moreonorderofoperations-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - PT - Test - Submit Test"},"postlogin-class7-tests-integers-moreonorderofoperations-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - PT - Scorecard - View Solutions"},"postlogin-class7-tests-integers-moreonorderofoperations-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-integers-moreonorderofoperations-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-integers-moreonorderofoperations-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-integers-moreonorderofoperations-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-integers-moreonorderofoperations-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-integers-moreonorderofoperations-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-integers-moreonorderofoperations-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-integers-moreonorderofoperations-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-integers-moreonorderofoperations-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-integers-moreonorderofoperations-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-integers-moreonorderofoperations-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-integers-moreonorderofoperations-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-integers-moreonorderofoperations-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-integers-moreonorderofoperations-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-integers-moreonorderofoperations-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-integers-moreonorderofoperations-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - CP - Start"},"postlogin-class7-tests-integers-moreonorderofoperations-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - CP - Start - Start Practice"},"postlogin-class7-tests-integers-moreonorderofoperations-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - CP - Start - Close"},"postlogin-class7-tests-integers-moreonorderofoperations-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - CP - Start - Start Practice - Close"},"postlogin-class7-tests-integers-moreonorderofoperations-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - CP - Start - Start Practice - Check"},"postlogin-class7-tests-integers-moreonorderofoperations-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - CP - Resume"},"postlogin-class7-tests-integers-moreonorderofoperations-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - CP - Resume - Continue"},"postlogin-class7-tests-integers-moreonorderofoperations-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - CP - Resume - Close"},"postlogin-class7-tests-integers-moreonorderofoperations-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - CP - Resume - Continue - Close"},"postlogin-class7-tests-integers-moreonorderofoperations-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - CP - Resume - Continue - Check"},"postlogin-class7-tests-integers-moreonorderofoperations-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Integers - More on Order of Operations - CP - Report"},"postlogin-class8-tests":{"event_label":"Lessons Main","event_category":"Class 8","event_action":"Post login - Class 8 - Tests"},"postlogin-class8-tests-rationalnumbers-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Start"},"postlogin-class8-tests-rationalnumbers-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Resume"},"postlogin-class8-tests-rationalnumbers-revise":{"event_label":"Revise topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Revise"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - PT - Start"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - PT - Resume"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - PT - Report"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - PT - Start - Start Test"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - PT - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - PT - Resume - Continue Test"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - PT - Test - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - PT - Test - Submit Test"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - PT - Scorecard - View Solutions"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - CP - Start"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - CP - Start - Start Practice"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - CP - Start - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - CP - Start - Start Practice - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - CP - Start - Start Practice - Check"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - CP - Resume"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - CP - Resume - Continue"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - CP - Resume - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - CP - Resume - Continue - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - CP - Resume - Continue - Check"},"postlogin-class8-tests-rationalnumbers-rationalnumbersi-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers I - CP - Report"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - PT - Start"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - PT - Resume"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - PT - Report"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - PT - Start - Start Test"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - PT - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - PT - Resume - Continue Test"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - PT - Test - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - PT - Test - Submit Test"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - PT - Scorecard - View Solutions"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - CP - Start"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - CP - Start - Start Practice"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - CP - Start - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - CP - Start - Start Practice - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - CP - Start - Start Practice - Check"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - CP - Resume"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - CP - Resume - Continue"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - CP - Resume - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - CP - Resume - Continue - Close"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - CP - Resume - Continue - Check"},"postlogin-class8-tests-rationalnumbers-rationalnumbersii-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Rational Numbers - Rational Numbers II - CP - Report"},"postlogin-class9-tests":{"event_label":"Lessons Main","event_category":"Class 9","event_action":"Post login - Class 9 - Tests"},"postlogin-class9-tests-numbersystem-start":{"event_label":"Start topic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Start"},"postlogin-class9-tests-numbersystem-resume":{"event_label":"Resume topic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Resume"},"postlogin-class9-tests-numbersystem-revise":{"event_label":"Revise topic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Revise"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-pt-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - PT - Start"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - PT - Resume"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-pt-report":{"event_label":"View report PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - PT - Report"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - PT - Start - Start Test"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - PT - Close"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - PT - Resume - Continue Test"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-pt-test-close":{"event_label":"Close PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - PT - Test - Close"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - PT - Test - Submit Test"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - PT - Scorecard - View Solutions"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - PT - Scorecard - View Solutions - Close"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - PT - Scorecard - View Recommendations"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - PT - Scorecard - View Recommendations - Close"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-cp-start":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - CP - Start"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - CP - Start - Start Practice"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - CP - Start - Close"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - CP - Start - Start Practice - Close"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - CP - Start - Start Practice - Check"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-cp-resume":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - CP - Resume"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - CP - Resume - Continue"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - CP - Resume - Close"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - CP - Resume - Continue - Close"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - CP - Resume - Continue - Check"},"postlogin-class9-tests-numbersystem-representingrealnumbersonthenumberline-cp-report":{"event_label":"View report CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Representing Real Numbers on the Number Line - CP - Report"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-pt-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - PT - Start"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - PT - Resume"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-pt-report":{"event_label":"View report PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - PT - Report"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - PT - Start - Start Test"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - PT - Close"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - PT - Resume - Continue Test"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-pt-test-close":{"event_label":"Close PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - PT - Test - Close"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - PT - Test - Submit Test"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - PT - Scorecard - View Solutions"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - PT - Scorecard - View Solutions - Close"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - PT - Scorecard - View Recommendations"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - PT - Scorecard - View Recommendations - Close"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-cp-start":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - CP - Start"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - CP - Start - Start Practice"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - CP - Start - Close"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - CP - Start - Start Practice - Close"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - CP - Start - Start Practice - Check"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-cp-resume":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - CP - Resume"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - CP - Resume - Continue"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - CP - Resume - Close"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - CP - Resume - Continue - Close"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - CP - Resume - Continue - Check"},"postlogin-class9-tests-numbersystem-rationalnumbersasrecurringdecimals-cp-report":{"event_label":"View report CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rational Numbers as Recurring Decimals - CP - Report"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-pt-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - PT - Start"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - PT - Resume"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-pt-report":{"event_label":"View report PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - PT - Report"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - PT - Start - Start Test"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - PT - Close"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - PT - Resume - Continue Test"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-pt-test-close":{"event_label":"Close PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - PT - Test - Close"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - PT - Test - Submit Test"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - PT - Scorecard - View Solutions"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - PT - Scorecard - View Solutions - Close"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - PT - Scorecard - View Recommendations"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - PT - Scorecard - View Recommendations - Close"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-cp-start":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - CP - Start"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - CP - Start - Start Practice"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - CP - Start - Close"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - CP - Start - Start Practice - Close"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - CP - Start - Start Practice - Check"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-cp-resume":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - CP - Resume"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - CP - Resume - Continue"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - CP - Resume - Close"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - CP - Resume - Continue - Close"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - CP - Resume - Continue - Check"},"postlogin-class9-tests-numbersystem-operationsonrealnumbers-cp-report":{"event_label":"View report CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Operations on Real Numbers - CP - Report"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-pt-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - PT - Start"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - PT - Resume"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-pt-report":{"event_label":"View report PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - PT - Report"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - PT - Start - Start Test"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - PT - Close"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - PT - Resume - Continue Test"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-pt-test-close":{"event_label":"Close PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - PT - Test - Close"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - PT - Test - Submit Test"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - PT - Scorecard - View Solutions"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - PT - Scorecard - View Solutions - Close"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - PT - Scorecard - View Recommendations"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - PT - Scorecard - View Recommendations - Close"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-cp-start":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - CP - Start"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - CP - Start - Start Practice"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - CP - Start - Close"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - CP - Start - Start Practice - Close"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - CP - Start - Start Practice - Check"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-cp-resume":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - CP - Resume"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - CP - Resume - Continue"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - CP - Resume - Close"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - CP - Resume - Continue - Close"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - CP - Resume - Continue - Check"},"postlogin-class9-tests-numbersystem-lawsofexponentswithrationalexponents-cp-report":{"event_label":"View report CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Laws of Exponents With Rational Exponents - CP - Report"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-pt-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - PT - Start"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - PT - Resume"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-pt-report":{"event_label":"View report PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - PT - Report"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - PT - Start - Start Test"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - PT - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - PT - Resume - Continue Test"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-pt-test-close":{"event_label":"Close PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - PT - Test - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - PT - Test - Submit Test"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - PT - Scorecard - View Solutions"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - PT - Scorecard - View Solutions - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - PT - Scorecard - View Recommendations"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - PT - Scorecard - View Recommendations - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-cp-start":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - CP - Start"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - CP - Start - Start Practice"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - CP - Start - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - CP - Start - Start Practice - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - CP - Start - Start Practice - Check"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-cp-resume":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - CP - Resume"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - CP - Resume - Continue"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - CP - Resume - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - CP - Resume - Continue - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - CP - Resume - Continue - Check"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatori-cp-report":{"event_label":"View report CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator I - CP - Report"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-pt-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - PT - Start"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - PT - Resume"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-pt-report":{"event_label":"View report PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - PT - Report"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - PT - Start - Start Test"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - PT - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - PT - Resume - Continue Test"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-pt-test-close":{"event_label":"Close PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - PT - Test - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - PT - Test - Submit Test"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - PT - Scorecard - View Solutions"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - PT - Scorecard - View Solutions - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - PT - Scorecard - View Recommendations"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - PT - Scorecard - View Recommendations - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-cp-start":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - CP - Start"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - CP - Start - Start Practice"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - CP - Start - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - CP - Start - Start Practice - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - CP - Start - Start Practice - Check"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-cp-resume":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - CP - Resume"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - CP - Resume - Continue"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - CP - Resume - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - CP - Resume - Continue - Close"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - CP - Resume - Continue - Check"},"postlogin-class9-tests-numbersystem-rationalisingthedenominatorii-cp-report":{"event_label":"View report CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Number System - Rationalising the Denominator II - CP - Report"},"postlogin-class10-tests":{"event_label":"Lessons Main","event_category":"Class 10","event_action":"Post login - Class 10 - Tests"},"postlogin-class10-tests-polynomials-start":{"event_label":"Start topic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Start"},"postlogin-class10-tests-polynomials-resume":{"event_label":"Resume topic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Resume"},"postlogin-class10-tests-polynomials-revise":{"event_label":"Revise topic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Revise"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - PT - Start"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - PT - Resume"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - PT - Report"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - PT - Start - Start Test"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - PT - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - PT - Resume - Continue Test"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - PT - Test - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - PT - Test - Submit Test"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - PT - Scorecard - View Solutions"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - CP - Start"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - CP - Start - Start Practice"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - CP - Start - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - CP - Start - Start Practice - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - CP - Start - Start Practice - Check"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - CP - Resume"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - CP - Resume - Continue"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - CP - Resume - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - CP - Resume - Continue - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - CP - Resume - Continue - Check"},"postlogin-class10-tests-polynomials-zeroesofapolynomiali-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial I - CP - Report"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - PT - Start"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - PT - Resume"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - PT - Report"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - PT - Start - Start Test"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - PT - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - PT - Resume - Continue Test"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - PT - Test - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - PT - Test - Submit Test"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - PT - Scorecard - View Solutions"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - CP - Start"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - CP - Start - Start Practice"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - CP - Start - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - CP - Start - Start Practice - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - CP - Start - Start Practice - Check"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - CP - Resume"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - CP - Resume - Continue"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - CP - Resume - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - CP - Resume - Continue - Close"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - CP - Resume - Continue - Check"},"postlogin-class10-tests-polynomials-zeroesofapolynomialii-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Zeroes of a Polynomial II - CP - Report"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - PT - Start"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - PT - Resume"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - PT - Report"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - PT - Start - Start Test"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - PT - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - PT - Resume - Continue Test"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - PT - Test - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - PT - Test - Submit Test"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - PT - Scorecard - View Solutions"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - CP - Start"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - CP - Start - Start Practice"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - CP - Start - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - CP - Start - Start Practice - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - CP - Start - Start Practice - Check"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - CP - Resume"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - CP - Resume - Continue"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - CP - Resume - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - CP - Resume - Continue - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - CP - Resume - Continue - Check"},"postlogin-class10-tests-polynomials-divisionofpolynomialsi-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials I - CP - Report"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - PT - Start"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - PT - Resume"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - PT - Report"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - PT - Start - Start Test"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - PT - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - PT - Resume - Continue Test"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - PT - Test - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - PT - Test - Submit Test"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - PT - Scorecard - View Solutions"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - CP - Start"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - CP - Start - Start Practice"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - CP - Start - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - CP - Start - Start Practice - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - CP - Start - Start Practice - Check"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - CP - Resume"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - CP - Resume - Continue"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - CP - Resume - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - CP - Resume - Continue - Close"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - CP - Resume - Continue - Check"},"postlogin-class10-tests-polynomials-divisionofpolynomialsii-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Polynomials - Division of Polynomials II - CP - Report"},"postlogin-class1-lessons-additionandsubtraction-start":{"event_label":"Start topic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons - Addition and Subtraction - Start"},"postlogin-class1-lessons-additionandsubtraction-resume":{"event_label":"Resume topic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons - Addition and Subtraction - Resume"},"postlogin-class1-lessons-additionandsubtraction-watched":{"event_label":"Rewatch topic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons - Addition and Subtraction - Watched"},"postlogin-class1-lessons-additionandsubtraction-additionandsubtractionupto10-start":{"event_label":"Start subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Addition and Subtraction - Addition and Subtraction up to 10 - Start"},"postlogin-class1-lessons-additionandsubtraction-additionandsubtractionupto10-resume":{"event_label":"Resume subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Addition and Subtraction - Addition and Subtraction up to 10 - Resume"},"postlogin-class1-lessons-additionandsubtraction-additionandsubtractionupto10-watched":{"event_label":"Rewatch subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Addition and Subtraction - Addition and Subtraction up to 10 - Watched"},"postlogin-class1-lessons-additionandsubtraction-additionandsubtractionupto10-lessons":{"event_label":"Class 1 lessons","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Addition and Subtraction - Addition and Subtraction up to 10 - Lessons"},"postlogin-class1-lessons-additionandsubtraction-additionandsubtractionupto10-close":{"event_label":"Close subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Addition and Subtraction - Addition and Subtraction up to 10 - Close"},"postlogin-class1-lessons-additionandsubtraction-additionandsubtractionupto20-start":{"event_label":"Start subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Addition and Subtraction - Addition and Subtraction up to 20 - Start"},"postlogin-class1-lessons-additionandsubtraction-additionandsubtractionupto20-resume":{"event_label":"Resume subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Addition and Subtraction - Addition and Subtraction up to 20 - Resume"},"postlogin-class1-lessons-additionandsubtraction-additionandsubtractionupto20-watched":{"event_label":"Rewatch subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Addition and Subtraction - Addition and Subtraction up to 20 - Watched"},"postlogin-class1-lessons-additionandsubtraction-additionandsubtractionupto20-lessons":{"event_label":"Class 1 lessons","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Addition and Subtraction - Addition and Subtraction up to 20 - Lessons"},"postlogin-class1-lessons-additionandsubtraction-additionandsubtractionupto20-close":{"event_label":"Close subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Addition and Subtraction - Addition and Subtraction up to 20 - Close"},"postlogin-class1-lessons-additionandsubtraction-additionandsubtractionupto100-start":{"event_label":"Start subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Addition and Subtraction - Addition and Subtraction up to 100 - Start"},"postlogin-class1-lessons-additionandsubtraction-additionandsubtractionupto100-resume":{"event_label":"Resume subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Addition and Subtraction - Addition and Subtraction up to 100 - Resume"},"postlogin-class1-lessons-additionandsubtraction-additionandsubtractionupto100-watched":{"event_label":"Rewatch subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Addition and Subtraction - Addition and Subtraction up to 100 - Watched"},"postlogin-class1-lessons-additionandsubtraction-additionandsubtractionupto100-lessons":{"event_label":"Class 1 lessons","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Addition and Subtraction - Addition and Subtraction up to 100 - Lessons"},"postlogin-class1-lessons-additionandsubtraction-additionandsubtractionupto100-close":{"event_label":"Close subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Addition and Subtraction - Addition and Subtraction up to 100 - Close"},"postlogin-class2-lessons-additionandsubtraction-start":{"event_label":"Start topic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons - Addition and Subtraction - Start"},"postlogin-class2-lessons-additionandsubtraction-resume":{"event_label":"Resume topic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons - Addition and Subtraction - Resume"},"postlogin-class2-lessons-additionandsubtraction-watched":{"event_label":"Rewatch topic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons - Addition and Subtraction - Watched"},"postlogin-class2-lessons-additionandsubtraction-additionandsubtraction-start":{"event_label":"Start subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Addition and Subtraction - Addition and Subtraction - Start"},"postlogin-class2-lessons-additionandsubtraction-additionandsubtraction-resume":{"event_label":"Resume subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Addition and Subtraction - Addition and Subtraction - Resume"},"postlogin-class2-lessons-additionandsubtraction-additionandsubtraction-watched":{"event_label":"Rewatch subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Addition and Subtraction - Addition and Subtraction - Watched"},"postlogin-class2-lessons-additionandsubtraction-additionandsubtraction-lessons":{"event_label":"Class 2 lessons","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Addition and Subtraction - Addition and Subtraction - Lessons"},"postlogin-class2-lessons-additionandsubtraction-additionandsubtraction-close":{"event_label":"Close subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Addition and Subtraction - Addition and Subtraction - Close"},"postlogin-class3-lessons-additionandsubtraction-start":{"event_label":"Start topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Addition and Subtraction - Start"},"postlogin-class3-lessons-additionandsubtraction-resume":{"event_label":"Resume topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Addition and Subtraction - Resume"},"postlogin-class3-lessons-additionandsubtraction-watched":{"event_label":"Rewatch topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Addition and Subtraction - Watched"},"postlogin-class3-lessons-additionandsubtraction-addition-start":{"event_label":"Start subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Addition and Subtraction - Addition - Start"},"postlogin-class3-lessons-additionandsubtraction-addition-resume":{"event_label":"Resume subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Addition and Subtraction - Addition - Resume"},"postlogin-class3-lessons-additionandsubtraction-addition-watched":{"event_label":"Rewatch subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Addition and Subtraction - Addition - Watched"},"postlogin-class3-lessons-additionandsubtraction-addition-lessons":{"event_label":"Class 3 lessons","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Addition and Subtraction - Addition - Lessons"},"postlogin-class3-lessons-additionandsubtraction-addition-close":{"event_label":"Close subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Addition and Subtraction - Addition - Close"},"postlogin-class3-lessons-additionandsubtraction-subtraction-start":{"event_label":"Start subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Addition and Subtraction - Subtraction - Start"},"postlogin-class3-lessons-additionandsubtraction-subtraction-resume":{"event_label":"Resume subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Addition and Subtraction - Subtraction - Resume"},"postlogin-class3-lessons-additionandsubtraction-subtraction-watched":{"event_label":"Rewatch subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Addition and Subtraction - Subtraction - Watched"},"postlogin-class3-lessons-additionandsubtraction-subtraction-lessons":{"event_label":"Class 3 lessons","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Addition and Subtraction - Subtraction - Lessons"},"postlogin-class3-lessons-additionandsubtraction-subtraction-close":{"event_label":"Close subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Addition and Subtraction - Subtraction - Close"},"postlogin-class4-lessons-additionandsubtraction-start":{"event_label":"Start topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Addition and Subtraction - Start"},"postlogin-class4-lessons-additionandsubtraction-resume":{"event_label":"Resume topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Addition and Subtraction - Resume"},"postlogin-class4-lessons-additionandsubtraction-watched":{"event_label":"Rewatch topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Addition and Subtraction - Watched"},"postlogin-class4-lessons-additionandsubtraction-addition-start":{"event_label":"Start subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Addition and Subtraction - Addition - Start"},"postlogin-class4-lessons-additionandsubtraction-addition-resume":{"event_label":"Resume subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Addition and Subtraction - Addition - Resume"},"postlogin-class4-lessons-additionandsubtraction-addition-watched":{"event_label":"Rewatch subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Addition and Subtraction - Addition - Watched"},"postlogin-class4-lessons-additionandsubtraction-addition-lessons":{"event_label":"Class 4 lessons","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Addition and Subtraction - Addition - Lessons"},"postlogin-class4-lessons-additionandsubtraction-addition-close":{"event_label":"Close subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Addition and Subtraction - Addition - Close"},"postlogin-class4-lessons-additionandsubtraction-subtraction-start":{"event_label":"Start subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Addition and Subtraction - Subtraction - Start"},"postlogin-class4-lessons-additionandsubtraction-subtraction-resume":{"event_label":"Resume subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Addition and Subtraction - Subtraction - Resume"},"postlogin-class4-lessons-additionandsubtraction-subtraction-watched":{"event_label":"Rewatch subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Addition and Subtraction - Subtraction - Watched"},"postlogin-class4-lessons-additionandsubtraction-subtraction-lessons":{"event_label":"Class 4 lessons","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Addition and Subtraction - Subtraction - Lessons"},"postlogin-class4-lessons-additionandsubtraction-subtraction-close":{"event_label":"Close subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Addition and Subtraction - Subtraction - Close"},"postlogin-class5-lessons-additionandsubtraction-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Addition and Subtraction - Start"},"postlogin-class5-lessons-additionandsubtraction-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Addition and Subtraction - Resume"},"postlogin-class5-lessons-additionandsubtraction-watched":{"event_label":"Rewatch topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Addition and Subtraction - Watched"},"postlogin-class5-lessons-additionandsubtraction-addition-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Addition and Subtraction - Addition - Start"},"postlogin-class5-lessons-additionandsubtraction-addition-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Addition and Subtraction - Addition - Resume"},"postlogin-class5-lessons-additionandsubtraction-addition-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Addition and Subtraction - Addition - Watched"},"postlogin-class5-lessons-additionandsubtraction-addition-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Addition and Subtraction - Addition - Lessons"},"postlogin-class5-lessons-additionandsubtraction-addition-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Addition and Subtraction - Addition - Close"},"postlogin-class5-lessons-additionandsubtraction-subtraction-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Addition and Subtraction - Subtraction - Start"},"postlogin-class5-lessons-additionandsubtraction-subtraction-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Addition and Subtraction - Subtraction - Resume"},"postlogin-class5-lessons-additionandsubtraction-subtraction-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Addition and Subtraction - Subtraction - Watched"},"postlogin-class5-lessons-additionandsubtraction-subtraction-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Addition and Subtraction - Subtraction - Lessons"},"postlogin-class5-lessons-additionandsubtraction-subtraction-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Addition and Subtraction - Subtraction - Close"},"postlogin-class6-lessons-wholenumbers-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Whole Numbers - Start"},"postlogin-class6-lessons-wholenumbers-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Whole Numbers - Resume"},"postlogin-class6-lessons-wholenumbers-watched":{"event_label":"Rewatch topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Whole Numbers - Watched"},"postlogin-class6-lessons-wholenumbers-propertiesofwholenumbers-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Whole Numbers - Properties of Whole Numbers - Start"},"postlogin-class6-lessons-wholenumbers-propertiesofwholenumbers-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Whole Numbers - Properties of Whole Numbers - Resume"},"postlogin-class6-lessons-wholenumbers-propertiesofwholenumbers-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Whole Numbers - Properties of Whole Numbers - Watched"},"postlogin-class6-lessons-wholenumbers-propertiesofwholenumbers-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Whole Numbers - Properties of Whole Numbers - Lessons"},"postlogin-class6-lessons-wholenumbers-propertiesofwholenumbers-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Whole Numbers - Properties of Whole Numbers - Close"},"postlogin-class7-lessons-fractions-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Fractions - Start"},"postlogin-class7-lessons-fractions-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Fractions - Resume"},"postlogin-class7-lessons-fractions-watched":{"event_label":"Rewatch topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Fractions - Watched"},"postlogin-class7-lessons-fractions-multiplicationanddivisionoffractions-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Fractions - Multiplication and Division of Fractions - Start"},"postlogin-class7-lessons-fractions-multiplicationanddivisionoffractions-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Fractions - Multiplication and Division of Fractions - Resume"},"postlogin-class7-lessons-fractions-multiplicationanddivisionoffractions-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Fractions - Multiplication and Division of Fractions - Watched"},"postlogin-class7-lessons-fractions-multiplicationanddivisionoffractions-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Fractions - Multiplication and Division of Fractions - Lessons"},"postlogin-class7-lessons-fractions-multiplicationanddivisionoffractions-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Fractions - Multiplication and Division of Fractions - Close"},"postlogin-class8-lessons-linearequationsinonevariable-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Linear Equations in One Variable - Start"},"postlogin-class8-lessons-linearequationsinonevariable-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Linear Equations in One Variable - Resume"},"postlogin-class8-lessons-linearequationsinonevariable-watched":{"event_label":"Rewatch topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Linear Equations in One Variable - Watched"},"postlogin-class8-lessons-linearequationsinonevariable-solvinglinearequations-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Linear Equations in One Variable - Solving Linear Equations - Start"},"postlogin-class8-lessons-linearequationsinonevariable-solvinglinearequations-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Linear Equations in One Variable - Solving Linear Equations - Resume"},"postlogin-class8-lessons-linearequationsinonevariable-solvinglinearequations-watched":{"event_label":"Rewatch subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Linear Equations in One Variable - Solving Linear Equations - Watched"},"postlogin-class8-lessons-linearequationsinonevariable-solvinglinearequations-lessons":{"event_label":"Class 8 lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Linear Equations in One Variable - Solving Linear Equations - Lessons"},"postlogin-class8-lessons-linearequationsinonevariable-solvinglinearequations-close":{"event_label":"Close subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Linear Equations in One Variable - Solving Linear Equations - Close"},"postlogin-class9-lessons-algebra-start":{"event_label":"Start topic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons - Algebra - Start"},"postlogin-class9-lessons-algebra-resume":{"event_label":"Resume topic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons - Algebra - Resume"},"postlogin-class9-lessons-algebra-watched":{"event_label":"Rewatch topic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons - Algebra - Watched"},"postlogin-class9-lessons-algebra-polynomials-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Algebra - Polynomials - Start"},"postlogin-class9-lessons-algebra-polynomials-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Algebra - Polynomials - Resume"},"postlogin-class9-lessons-algebra-polynomials-watched":{"event_label":"Rewatch subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Algebra - Polynomials - Watched"},"postlogin-class9-lessons-algebra-polynomials-lessons":{"event_label":"Class 9 lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Algebra - Polynomials - Lessons"},"postlogin-class9-lessons-algebra-polynomials-close":{"event_label":"Close subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Algebra - Polynomials - Close"},"postlogin-class9-lessons-algebra-algebraicidentities-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Algebra - Algebraic Identities - Start"},"postlogin-class9-lessons-algebra-algebraicidentities-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Algebra - Algebraic Identities - Resume"},"postlogin-class9-lessons-algebra-algebraicidentities-watched":{"event_label":"Rewatch subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Algebra - Algebraic Identities - Watched"},"postlogin-class9-lessons-algebra-algebraicidentities-lessons":{"event_label":"Class 9 lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Algebra - Algebraic Identities - Lessons"},"postlogin-class9-lessons-algebra-algebraicidentities-close":{"event_label":"Close subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Algebra - Algebraic Identities - Close"},"postlogin-class9-lessons-algebra-linearequationsintwovariables-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Algebra - Linear Equations in two variables - Start"},"postlogin-class9-lessons-algebra-linearequationsintwovariables-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Algebra - Linear Equations in two variables - Resume"},"postlogin-class9-lessons-algebra-linearequationsintwovariables-watched":{"event_label":"Rewatch subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Algebra - Linear Equations in two variables - Watched"},"postlogin-class9-lessons-algebra-linearequationsintwovariables-lessons":{"event_label":"Class 9 lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Algebra - Linear Equations in two variables - Lessons"},"postlogin-class9-lessons-algebra-linearequationsintwovariables-close":{"event_label":"Close subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Algebra - Linear Equations in two variables - Close"},"postlogin-class10-lessons-algebra-start":{"event_label":"Start topic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons - Algebra - Start"},"postlogin-class10-lessons-algebra-resume":{"event_label":"Resume topic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons - Algebra - Resume"},"postlogin-class10-lessons-algebra-watched":{"event_label":"Rewatch topic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons - Algebra - Watched"},"postlogin-class10-lessons-algebra-polynomials-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Algebra - Polynomials - Start"},"postlogin-class10-lessons-algebra-polynomials-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Algebra - Polynomials - Resume"},"postlogin-class10-lessons-algebra-polynomials-watched":{"event_label":"Rewatch subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Algebra - Polynomials - Watched"},"postlogin-class10-lessons-algebra-polynomials-lessons":{"event_label":"Class 10 lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Algebra - Polynomials - Lessons"},"postlogin-class10-lessons-algebra-polynomials-close":{"event_label":"Close subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Algebra - Polynomials - Close"},"postlogin-class10-lessons-algebra-pairsoflinearequationsintwovariables-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Algebra - Pairs of Linear Equations in Two variables - Start"},"postlogin-class10-lessons-algebra-pairsoflinearequationsintwovariables-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Algebra - Pairs of Linear Equations in Two variables - Resume"},"postlogin-class10-lessons-algebra-pairsoflinearequationsintwovariables-watched":{"event_label":"Rewatch subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Algebra - Pairs of Linear Equations in Two variables - Watched"},"postlogin-class10-lessons-algebra-pairsoflinearequationsintwovariables-lessons":{"event_label":"Class 10 lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Algebra - Pairs of Linear Equations in Two variables - Lessons"},"postlogin-class10-lessons-algebra-pairsoflinearequationsintwovariables-close":{"event_label":"Close subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Algebra - Pairs of Linear Equations in Two variables - Close"},"postlogin-class10-lessons-algebra-quadraticequations-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Algebra - Quadratic Equations - Start"},"postlogin-class10-lessons-algebra-quadraticequations-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Algebra - Quadratic Equations - Resume"},"postlogin-class10-lessons-algebra-quadraticequations-watched":{"event_label":"Rewatch subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Algebra - Quadratic Equations - Watched"},"postlogin-class10-lessons-algebra-quadraticequations-lessons":{"event_label":"Class 10 lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Algebra - Quadratic Equations - Lessons"},"postlogin-class10-lessons-algebra-quadraticequations-close":{"event_label":"Close subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Algebra - Quadratic Equations - Close"},"postlogin-class10-lessons-algebra-arithmeticprogressions-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Algebra - Arithmetic Progressions - Start"},"postlogin-class10-lessons-algebra-arithmeticprogressions-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Algebra - Arithmetic Progressions - Resume"},"postlogin-class10-lessons-algebra-arithmeticprogressions-watched":{"event_label":"Rewatch subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Algebra - Arithmetic Progressions - Watched"},"postlogin-class10-lessons-algebra-arithmeticprogressions-lessons":{"event_label":"Class 10 lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Algebra - Arithmetic Progressions - Lessons"},"postlogin-class10-lessons-algebra-arithmeticprogressions-close":{"event_label":"Close subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Algebra - Arithmetic Progressions - Close"},"postlogin-class5-tests-additionandsubtraction-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Start"},"postlogin-class5-tests-additionandsubtraction-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Resume"},"postlogin-class5-tests-additionandsubtraction-revise":{"event_label":"Revise topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Revise"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - PT - Start"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - PT - Resume"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - PT - Report"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - PT - Start - Start Test"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - PT - Close"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - PT - Resume - Continue Test"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - PT - Test - Close"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - PT - Test - Submit Test"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - PT - Scorecard - View Solutions"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - CP - Start"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - CP - Start - Start Practice"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - CP - Start - Close"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - CP - Start - Start Practice - Close"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - CP - Start - Start Practice - Check"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - CP - Resume"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - CP - Resume - Continue"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - CP - Resume - Close"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - CP - Resume - Continue - Close"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - CP - Resume - Continue - Check"},"postlogin-class5-tests-additionandsubtraction-additionandsubtraction-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Addition and Subtraction - CP - Report"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - PT - Start"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - PT - Resume"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - PT - Report"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - PT - Start - Start Test"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - PT - Close"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - PT - Resume - Continue Test"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - PT - Test - Close"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - PT - Test - Submit Test"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - PT - Scorecard - View Solutions"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - CP - Start"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - CP - Start - Start Practice"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - CP - Start - Close"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - CP - Start - Start Practice - Close"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - CP - Start - Start Practice - Check"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - CP - Resume"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - CP - Resume - Continue"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - CP - Resume - Close"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - CP - Resume - Continue - Close"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - CP - Resume - Continue - Check"},"postlogin-class5-tests-additionandsubtraction-mixedoperationsandapplicationproblems-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Addition and Subtraction - Mixed Operations and Application Problems - CP - Report"},"postlogin-class6-tests-wholenumbers-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Start"},"postlogin-class6-tests-wholenumbers-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Resume"},"postlogin-class6-tests-wholenumbers-revise":{"event_label":"Revise topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Revise"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - PT - Start"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - PT - Resume"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - PT - Report"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - PT - Start - Start Test"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - PT - Close"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - PT - Resume - Continue Test"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - PT - Test - Close"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - PT - Test - Submit Test"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - PT - Scorecard - View Solutions"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - CP - Start"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - CP - Start - Start Practice"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - CP - Start - Close"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - CP - Start - Start Practice - Close"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - CP - Start - Start Practice - Check"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - CP - Resume"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - CP - Resume - Continue"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - CP - Resume - Close"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - CP - Resume - Continue - Close"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - CP - Resume - Continue - Check"},"postlogin-class6-tests-wholenumbers-introductiontowholenumbers-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Introduction to Whole Numbers - CP - Report"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - PT - Start"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - PT - Resume"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - PT - Report"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - PT - Start - Start Test"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - PT - Close"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - PT - Resume - Continue Test"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - PT - Test - Close"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - PT - Test - Submit Test"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - PT - Scorecard - View Solutions"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - CP - Start"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - CP - Start - Start Practice"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - CP - Start - Close"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - CP - Start - Start Practice - Close"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - CP - Start - Start Practice - Check"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - CP - Resume"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - CP - Resume - Continue"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - CP - Resume - Close"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - CP - Resume - Continue - Close"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - CP - Resume - Continue - Check"},"postlogin-class6-tests-wholenumbers-propertiesofwholenumber-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Properties of Whole Number - CP - Report"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - PT - Start"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - PT - Resume"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - PT - Report"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - PT - Start - Start Test"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - PT - Close"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - PT - Resume - Continue Test"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - PT - Test - Close"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - PT - Test - Submit Test"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - PT - Scorecard - View Solutions"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - CP - Start"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - CP - Start - Start Practice"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - CP - Start - Close"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - CP - Start - Start Practice - Close"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - CP - Start - Start Practice - Check"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - CP - Resume"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - CP - Resume - Continue"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - CP - Resume - Close"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - CP - Resume - Continue - Close"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - CP - Resume - Continue - Check"},"postlogin-class6-tests-wholenumbers-patternsinwholenumbers-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Whole Numbers - Patterns in Whole Numbers - CP - Report"},"postlogin-class7-tests-fractions-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Start"},"postlogin-class7-tests-fractions-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Resume"},"postlogin-class7-tests-fractions-revise":{"event_label":"Revise topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Revise"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - PT - Start"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - PT - Resume"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - PT - Report"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - PT - Start - Start Test"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - PT - Close"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - PT - Resume - Continue Test"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - PT - Test - Close"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - PT - Test - Submit Test"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - PT - Scorecard - View Solutions"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - CP - Start"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - CP - Start - Start Practice"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - CP - Start - Close"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - CP - Start - Start Practice - Close"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - CP - Start - Start Practice - Check"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - CP - Resume"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - CP - Resume - Continue"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - CP - Resume - Close"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - CP - Resume - Continue - Close"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - CP - Resume - Continue - Check"},"postlogin-class7-tests-fractions-multiplyfractionbywholenumber-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Whole Number - CP - Report"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - PT - Start"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - PT - Resume"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - PT - Report"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - PT - Start - Start Test"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - PT - Close"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - PT - Resume - Continue Test"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - PT - Test - Close"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - PT - Test - Submit Test"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - PT - Scorecard - View Solutions"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - CP - Start"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - CP - Start - Start Practice"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - CP - Start - Close"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - CP - Start - Start Practice - Close"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - CP - Start - Start Practice - Check"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - CP - Resume"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - CP - Resume - Continue"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - CP - Resume - Close"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - CP - Resume - Continue - Close"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - CP - Resume - Continue - Check"},"postlogin-class7-tests-fractions-multiplyfractionbyfraction-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Multiply Fraction by Fraction - CP - Report"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - PT - Start"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - PT - Resume"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - PT - Report"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - PT - Start - Start Test"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - PT - Close"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - PT - Resume - Continue Test"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - PT - Test - Close"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - PT - Test - Submit Test"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - PT - Scorecard - View Solutions"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - CP - Start"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - CP - Start - Start Practice"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - CP - Start - Close"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - CP - Start - Start Practice - Close"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - CP - Start - Start Practice - Check"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - CP - Resume"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - CP - Resume - Continue"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - CP - Resume - Close"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - CP - Resume - Continue - Close"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - CP - Resume - Continue - Check"},"postlogin-class7-tests-fractions-dividefractionbywholenumber-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by whole number - CP - Report"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - PT - Start"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - PT - Resume"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - PT - Report"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - PT - Start - Start Test"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - PT - Close"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - PT - Resume - Continue Test"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - PT - Test - Close"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - PT - Test - Submit Test"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - PT - Scorecard - View Solutions"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - CP - Start"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - CP - Start - Start Practice"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - CP - Start - Close"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - CP - Start - Start Practice - Close"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - CP - Start - Start Practice - Check"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - CP - Resume"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - CP - Resume - Continue"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - CP - Resume - Close"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - CP - Resume - Continue - Close"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - CP - Resume - Continue - Check"},"postlogin-class7-tests-fractions-dividewholenumberbyafraction-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Whole Number by a fraction - CP - Report"},"postlogin-class7-tests-fractions-dividefractionbyfraction-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - PT - Start"},"postlogin-class7-tests-fractions-dividefractionbyfraction-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - PT - Resume"},"postlogin-class7-tests-fractions-dividefractionbyfraction-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - PT - Report"},"postlogin-class7-tests-fractions-dividefractionbyfraction-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - PT - Start - Start Test"},"postlogin-class7-tests-fractions-dividefractionbyfraction-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - PT - Close"},"postlogin-class7-tests-fractions-dividefractionbyfraction-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - PT - Resume - Continue Test"},"postlogin-class7-tests-fractions-dividefractionbyfraction-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - PT - Test - Close"},"postlogin-class7-tests-fractions-dividefractionbyfraction-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - PT - Test - Submit Test"},"postlogin-class7-tests-fractions-dividefractionbyfraction-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - PT - Scorecard - View Solutions"},"postlogin-class7-tests-fractions-dividefractionbyfraction-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-fractions-dividefractionbyfraction-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-fractions-dividefractionbyfraction-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-fractions-dividefractionbyfraction-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-fractions-dividefractionbyfraction-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-fractions-dividefractionbyfraction-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-fractions-dividefractionbyfraction-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-fractions-dividefractionbyfraction-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-fractions-dividefractionbyfraction-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-fractions-dividefractionbyfraction-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-fractions-dividefractionbyfraction-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-fractions-dividefractionbyfraction-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-fractions-dividefractionbyfraction-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-fractions-dividefractionbyfraction-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-fractions-dividefractionbyfraction-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-fractions-dividefractionbyfraction-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - CP - Start"},"postlogin-class7-tests-fractions-dividefractionbyfraction-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - CP - Start - Start Practice"},"postlogin-class7-tests-fractions-dividefractionbyfraction-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - CP - Start - Close"},"postlogin-class7-tests-fractions-dividefractionbyfraction-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - CP - Start - Start Practice - Close"},"postlogin-class7-tests-fractions-dividefractionbyfraction-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - CP - Start - Start Practice - Check"},"postlogin-class7-tests-fractions-dividefractionbyfraction-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - CP - Resume"},"postlogin-class7-tests-fractions-dividefractionbyfraction-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - CP - Resume - Continue"},"postlogin-class7-tests-fractions-dividefractionbyfraction-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - CP - Resume - Close"},"postlogin-class7-tests-fractions-dividefractionbyfraction-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - CP - Resume - Continue - Close"},"postlogin-class7-tests-fractions-dividefractionbyfraction-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - CP - Resume - Continue - Check"},"postlogin-class7-tests-fractions-dividefractionbyfraction-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Fractions - Divide Fraction by Fraction - CP - Report"},"postlogin-class8-tests-linearequationsinonevariable-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Start"},"postlogin-class8-tests-linearequationsinonevariable-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Resume"},"postlogin-class8-tests-linearequationsinonevariable-revise":{"event_label":"Revise topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Revise"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - PT - Start"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - PT - Resume"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - PT - Report"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - PT - Start - Start Test"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - PT - Close"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - PT - Resume - Continue Test"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - PT - Test - Close"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - PT - Test - Submit Test"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - PT - Scorecard - View Solutions"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - CP - Start"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - CP - Start - Start Practice"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - CP - Start - Close"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - CP - Start - Start Practice - Close"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - CP - Start - Start Practice - Check"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - CP - Resume"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - CP - Resume - Continue"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - CP - Resume - Close"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - CP - Resume - Continue - Close"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - CP - Resume - Continue - Check"},"postlogin-class8-tests-linearequationsinonevariable-solvinglinearequations-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Solving Linear Equations - CP - Report"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - PT - Start"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - PT - Resume"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - PT - Report"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - PT - Start - Start Test"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - PT - Close"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - PT - Resume - Continue Test"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - PT - Test - Close"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - PT - Test - Submit Test"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - PT - Scorecard - View Solutions"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - CP - Start"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - CP - Start - Start Practice"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - CP - Start - Close"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - CP - Start - Start Practice - Close"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - CP - Start - Start Practice - Check"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - CP - Resume"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - CP - Resume - Continue"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - CP - Resume - Close"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - CP - Resume - Continue - Close"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - CP - Resume - Continue - Check"},"postlogin-class8-tests-linearequationsinonevariable-linearequations-applications-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Linear Equations in One Variable - Linear Equations - Applications - CP - Report"},"postlogin-class9-tests-polynomials-start":{"event_label":"Start topic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Start"},"postlogin-class9-tests-polynomials-resume":{"event_label":"Resume topic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Resume"},"postlogin-class9-tests-polynomials-revise":{"event_label":"Revise topic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Revise"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-pt-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - PT - Start"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - PT - Resume"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-pt-report":{"event_label":"View report PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - PT - Report"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - PT - Start - Start Test"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - PT - Close"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - PT - Resume - Continue Test"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-pt-test-close":{"event_label":"Close PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - PT - Test - Close"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - PT - Test - Submit Test"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - PT - Scorecard - View Solutions"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - PT - Scorecard - View Solutions - Close"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - PT - Scorecard - View Recommendations"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - PT - Scorecard - View Recommendations - Close"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-cp-start":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - CP - Start"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - CP - Start - Start Practice"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - CP - Start - Close"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - CP - Start - Start Practice - Close"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - CP - Start - Start Practice - Check"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-cp-resume":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - CP - Resume"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - CP - Resume - Continue"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - CP - Resume - Close"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - CP - Resume - Continue - Close"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - CP - Resume - Continue - Check"},"postlogin-class9-tests-polynomials-termsrelatedtopolynomials-cp-report":{"event_label":"View report CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Terms related to Polynomials - CP - Report"},"postlogin-class9-tests-polynomials-degreeofapolynomial-pt-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - PT - Start"},"postlogin-class9-tests-polynomials-degreeofapolynomial-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - PT - Resume"},"postlogin-class9-tests-polynomials-degreeofapolynomial-pt-report":{"event_label":"View report PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - PT - Report"},"postlogin-class9-tests-polynomials-degreeofapolynomial-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - PT - Start - Start Test"},"postlogin-class9-tests-polynomials-degreeofapolynomial-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - PT - Close"},"postlogin-class9-tests-polynomials-degreeofapolynomial-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - PT - Resume - Continue Test"},"postlogin-class9-tests-polynomials-degreeofapolynomial-pt-test-close":{"event_label":"Close PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - PT - Test - Close"},"postlogin-class9-tests-polynomials-degreeofapolynomial-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - PT - Test - Submit Test"},"postlogin-class9-tests-polynomials-degreeofapolynomial-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - PT - Scorecard - View Solutions"},"postlogin-class9-tests-polynomials-degreeofapolynomial-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - PT - Scorecard - View Solutions - Close"},"postlogin-class9-tests-polynomials-degreeofapolynomial-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - PT - Scorecard - View Recommendations"},"postlogin-class9-tests-polynomials-degreeofapolynomial-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - PT - Scorecard - View Recommendations - Close"},"postlogin-class9-tests-polynomials-degreeofapolynomial-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class9-tests-polynomials-degreeofapolynomial-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class9-tests-polynomials-degreeofapolynomial-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class9-tests-polynomials-degreeofapolynomial-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class9-tests-polynomials-degreeofapolynomial-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class9-tests-polynomials-degreeofapolynomial-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class9-tests-polynomials-degreeofapolynomial-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class9-tests-polynomials-degreeofapolynomial-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class9-tests-polynomials-degreeofapolynomial-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class9-tests-polynomials-degreeofapolynomial-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class9-tests-polynomials-degreeofapolynomial-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class9-tests-polynomials-degreeofapolynomial-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class9-tests-polynomials-degreeofapolynomial-cp-start":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - CP - Start"},"postlogin-class9-tests-polynomials-degreeofapolynomial-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - CP - Start - Start Practice"},"postlogin-class9-tests-polynomials-degreeofapolynomial-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - CP - Start - Close"},"postlogin-class9-tests-polynomials-degreeofapolynomial-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - CP - Start - Start Practice - Close"},"postlogin-class9-tests-polynomials-degreeofapolynomial-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - CP - Start - Start Practice - Check"},"postlogin-class9-tests-polynomials-degreeofapolynomial-cp-resume":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - CP - Resume"},"postlogin-class9-tests-polynomials-degreeofapolynomial-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - CP - Resume - Continue"},"postlogin-class9-tests-polynomials-degreeofapolynomial-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - CP - Resume - Close"},"postlogin-class9-tests-polynomials-degreeofapolynomial-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - CP - Resume - Continue - Close"},"postlogin-class9-tests-polynomials-degreeofapolynomial-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - CP - Resume - Continue - Check"},"postlogin-class9-tests-polynomials-degreeofapolynomial-cp-report":{"event_label":"View report CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Degree of a polynomial - CP - Report"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-pt-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - PT - Start"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - PT - Resume"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-pt-report":{"event_label":"View report PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - PT - Report"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - PT - Start - Start Test"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - PT - Close"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - PT - Resume - Continue Test"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-pt-test-close":{"event_label":"Close PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - PT - Test - Close"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - PT - Test - Submit Test"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - PT - Scorecard - View Solutions"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - PT - Scorecard - View Solutions - Close"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - PT - Scorecard - View Recommendations"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - PT - Scorecard - View Recommendations - Close"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-cp-start":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - CP - Start"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - CP - Start - Start Practice"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - CP - Start - Close"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - CP - Start - Start Practice - Close"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - CP - Start - Start Practice - Check"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-cp-resume":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - CP - Resume"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - CP - Resume - Continue"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - CP - Resume - Close"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - CP - Resume - Continue - Close"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - CP - Resume - Continue - Check"},"postlogin-class9-tests-polynomials-zeroesofapolynomial-cp-report":{"event_label":"View report CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Zeroes of a polynomial - CP - Report"},"postlogin-class9-tests-polynomials-remaindertheorem-pt-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - PT - Start"},"postlogin-class9-tests-polynomials-remaindertheorem-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - PT - Resume"},"postlogin-class9-tests-polynomials-remaindertheorem-pt-report":{"event_label":"View report PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - PT - Report"},"postlogin-class9-tests-polynomials-remaindertheorem-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - PT - Start - Start Test"},"postlogin-class9-tests-polynomials-remaindertheorem-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - PT - Close"},"postlogin-class9-tests-polynomials-remaindertheorem-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - PT - Resume - Continue Test"},"postlogin-class9-tests-polynomials-remaindertheorem-pt-test-close":{"event_label":"Close PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - PT - Test - Close"},"postlogin-class9-tests-polynomials-remaindertheorem-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - PT - Test - Submit Test"},"postlogin-class9-tests-polynomials-remaindertheorem-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - PT - Scorecard - View Solutions"},"postlogin-class9-tests-polynomials-remaindertheorem-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - PT - Scorecard - View Solutions - Close"},"postlogin-class9-tests-polynomials-remaindertheorem-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - PT - Scorecard - View Recommendations"},"postlogin-class9-tests-polynomials-remaindertheorem-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - PT - Scorecard - View Recommendations - Close"},"postlogin-class9-tests-polynomials-remaindertheorem-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class9-tests-polynomials-remaindertheorem-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class9-tests-polynomials-remaindertheorem-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class9-tests-polynomials-remaindertheorem-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class9-tests-polynomials-remaindertheorem-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class9-tests-polynomials-remaindertheorem-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class9-tests-polynomials-remaindertheorem-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class9-tests-polynomials-remaindertheorem-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class9-tests-polynomials-remaindertheorem-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class9-tests-polynomials-remaindertheorem-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class9-tests-polynomials-remaindertheorem-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class9-tests-polynomials-remaindertheorem-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class9-tests-polynomials-remaindertheorem-cp-start":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - CP - Start"},"postlogin-class9-tests-polynomials-remaindertheorem-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - CP - Start - Start Practice"},"postlogin-class9-tests-polynomials-remaindertheorem-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - CP - Start - Close"},"postlogin-class9-tests-polynomials-remaindertheorem-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - CP - Start - Start Practice - Close"},"postlogin-class9-tests-polynomials-remaindertheorem-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - CP - Start - Start Practice - Check"},"postlogin-class9-tests-polynomials-remaindertheorem-cp-resume":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - CP - Resume"},"postlogin-class9-tests-polynomials-remaindertheorem-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - CP - Resume - Continue"},"postlogin-class9-tests-polynomials-remaindertheorem-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - CP - Resume - Close"},"postlogin-class9-tests-polynomials-remaindertheorem-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - CP - Resume - Continue - Close"},"postlogin-class9-tests-polynomials-remaindertheorem-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - CP - Resume - Continue - Check"},"postlogin-class9-tests-polynomials-remaindertheorem-cp-report":{"event_label":"View report CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Remainder Theorem - CP - Report"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-pt-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - PT - Start"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - PT - Resume"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-pt-report":{"event_label":"View report PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - PT - Report"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - PT - Start - Start Test"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - PT - Close"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - PT - Resume - Continue Test"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-pt-test-close":{"event_label":"Close PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - PT - Test - Close"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - PT - Test - Submit Test"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - PT - Scorecard - View Solutions"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - PT - Scorecard - View Solutions - Close"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - PT - Scorecard - View Recommendations"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - PT - Scorecard - View Recommendations - Close"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-cp-start":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - CP - Start"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - CP - Start - Start Practice"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - CP - Start - Close"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - CP - Start - Start Practice - Close"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - CP - Start - Start Practice - Check"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-cp-resume":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - CP - Resume"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - CP - Resume - Continue"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - CP - Resume - Close"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - CP - Resume - Continue - Close"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - CP - Resume - Continue - Check"},"postlogin-class9-tests-polynomials-moreonremaindertheorem-cp-report":{"event_label":"View report CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Remainder Theorem - CP - Report"},"postlogin-class9-tests-polynomials-factortheorem-pt-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - PT - Start"},"postlogin-class9-tests-polynomials-factortheorem-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - PT - Resume"},"postlogin-class9-tests-polynomials-factortheorem-pt-report":{"event_label":"View report PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - PT - Report"},"postlogin-class9-tests-polynomials-factortheorem-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - PT - Start - Start Test"},"postlogin-class9-tests-polynomials-factortheorem-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - PT - Close"},"postlogin-class9-tests-polynomials-factortheorem-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - PT - Resume - Continue Test"},"postlogin-class9-tests-polynomials-factortheorem-pt-test-close":{"event_label":"Close PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - PT - Test - Close"},"postlogin-class9-tests-polynomials-factortheorem-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - PT - Test - Submit Test"},"postlogin-class9-tests-polynomials-factortheorem-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - PT - Scorecard - View Solutions"},"postlogin-class9-tests-polynomials-factortheorem-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - PT - Scorecard - View Solutions - Close"},"postlogin-class9-tests-polynomials-factortheorem-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - PT - Scorecard - View Recommendations"},"postlogin-class9-tests-polynomials-factortheorem-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - PT - Scorecard - View Recommendations - Close"},"postlogin-class9-tests-polynomials-factortheorem-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class9-tests-polynomials-factortheorem-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class9-tests-polynomials-factortheorem-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class9-tests-polynomials-factortheorem-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class9-tests-polynomials-factortheorem-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class9-tests-polynomials-factortheorem-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class9-tests-polynomials-factortheorem-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class9-tests-polynomials-factortheorem-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class9-tests-polynomials-factortheorem-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class9-tests-polynomials-factortheorem-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class9-tests-polynomials-factortheorem-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class9-tests-polynomials-factortheorem-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class9-tests-polynomials-factortheorem-cp-start":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - CP - Start"},"postlogin-class9-tests-polynomials-factortheorem-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - CP - Start - Start Practice"},"postlogin-class9-tests-polynomials-factortheorem-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - CP - Start - Close"},"postlogin-class9-tests-polynomials-factortheorem-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - CP - Start - Start Practice - Close"},"postlogin-class9-tests-polynomials-factortheorem-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - CP - Start - Start Practice - Check"},"postlogin-class9-tests-polynomials-factortheorem-cp-resume":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - CP - Resume"},"postlogin-class9-tests-polynomials-factortheorem-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - CP - Resume - Continue"},"postlogin-class9-tests-polynomials-factortheorem-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - CP - Resume - Close"},"postlogin-class9-tests-polynomials-factortheorem-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - CP - Resume - Continue - Close"},"postlogin-class9-tests-polynomials-factortheorem-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - CP - Resume - Continue - Check"},"postlogin-class9-tests-polynomials-factortheorem-cp-report":{"event_label":"View report CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Factor Theorem - CP - Report"},"postlogin-class9-tests-polynomials-moreonfactortheorem-pt-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - PT - Start"},"postlogin-class9-tests-polynomials-moreonfactortheorem-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - PT - Resume"},"postlogin-class9-tests-polynomials-moreonfactortheorem-pt-report":{"event_label":"View report PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - PT - Report"},"postlogin-class9-tests-polynomials-moreonfactortheorem-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - PT - Start - Start Test"},"postlogin-class9-tests-polynomials-moreonfactortheorem-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - PT - Close"},"postlogin-class9-tests-polynomials-moreonfactortheorem-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - PT - Resume - Continue Test"},"postlogin-class9-tests-polynomials-moreonfactortheorem-pt-test-close":{"event_label":"Close PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - PT - Test - Close"},"postlogin-class9-tests-polynomials-moreonfactortheorem-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - PT - Test - Submit Test"},"postlogin-class9-tests-polynomials-moreonfactortheorem-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - PT - Scorecard - View Solutions"},"postlogin-class9-tests-polynomials-moreonfactortheorem-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - PT - Scorecard - View Solutions - Close"},"postlogin-class9-tests-polynomials-moreonfactortheorem-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - PT - Scorecard - View Recommendations"},"postlogin-class9-tests-polynomials-moreonfactortheorem-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - PT - Scorecard - View Recommendations - Close"},"postlogin-class9-tests-polynomials-moreonfactortheorem-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class9-tests-polynomials-moreonfactortheorem-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class9-tests-polynomials-moreonfactortheorem-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class9-tests-polynomials-moreonfactortheorem-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class9-tests-polynomials-moreonfactortheorem-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class9-tests-polynomials-moreonfactortheorem-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class9-tests-polynomials-moreonfactortheorem-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class9-tests-polynomials-moreonfactortheorem-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class9-tests-polynomials-moreonfactortheorem-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class9-tests-polynomials-moreonfactortheorem-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class9-tests-polynomials-moreonfactortheorem-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class9-tests-polynomials-moreonfactortheorem-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class9-tests-polynomials-moreonfactortheorem-cp-start":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - CP - Start"},"postlogin-class9-tests-polynomials-moreonfactortheorem-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - CP - Start - Start Practice"},"postlogin-class9-tests-polynomials-moreonfactortheorem-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - CP - Start - Close"},"postlogin-class9-tests-polynomials-moreonfactortheorem-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - CP - Start - Start Practice - Close"},"postlogin-class9-tests-polynomials-moreonfactortheorem-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - CP - Start - Start Practice - Check"},"postlogin-class9-tests-polynomials-moreonfactortheorem-cp-resume":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - CP - Resume"},"postlogin-class9-tests-polynomials-moreonfactortheorem-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - CP - Resume - Continue"},"postlogin-class9-tests-polynomials-moreonfactortheorem-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - CP - Resume - Close"},"postlogin-class9-tests-polynomials-moreonfactortheorem-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - CP - Resume - Continue - Close"},"postlogin-class9-tests-polynomials-moreonfactortheorem-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - CP - Resume - Continue - Check"},"postlogin-class9-tests-polynomials-moreonfactortheorem-cp-report":{"event_label":"View report CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - More on Factor Theorem - CP - Report"},"postlogin-class9-tests-polynomials-algebraicidentities-pt-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - PT - Start"},"postlogin-class9-tests-polynomials-algebraicidentities-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - PT - Resume"},"postlogin-class9-tests-polynomials-algebraicidentities-pt-report":{"event_label":"View report PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - PT - Report"},"postlogin-class9-tests-polynomials-algebraicidentities-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - PT - Start - Start Test"},"postlogin-class9-tests-polynomials-algebraicidentities-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - PT - Close"},"postlogin-class9-tests-polynomials-algebraicidentities-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - PT - Resume - Continue Test"},"postlogin-class9-tests-polynomials-algebraicidentities-pt-test-close":{"event_label":"Close PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - PT - Test - Close"},"postlogin-class9-tests-polynomials-algebraicidentities-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - PT - Test - Submit Test"},"postlogin-class9-tests-polynomials-algebraicidentities-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - PT - Scorecard - View Solutions"},"postlogin-class9-tests-polynomials-algebraicidentities-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - PT - Scorecard - View Solutions - Close"},"postlogin-class9-tests-polynomials-algebraicidentities-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - PT - Scorecard - View Recommendations"},"postlogin-class9-tests-polynomials-algebraicidentities-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - PT - Scorecard - View Recommendations - Close"},"postlogin-class9-tests-polynomials-algebraicidentities-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class9-tests-polynomials-algebraicidentities-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class9-tests-polynomials-algebraicidentities-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class9-tests-polynomials-algebraicidentities-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class9-tests-polynomials-algebraicidentities-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class9-tests-polynomials-algebraicidentities-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class9-tests-polynomials-algebraicidentities-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class9-tests-polynomials-algebraicidentities-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class9-tests-polynomials-algebraicidentities-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class9-tests-polynomials-algebraicidentities-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class9-tests-polynomials-algebraicidentities-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class9-tests-polynomials-algebraicidentities-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class9-tests-polynomials-algebraicidentities-cp-start":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - CP - Start"},"postlogin-class9-tests-polynomials-algebraicidentities-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - CP - Start - Start Practice"},"postlogin-class9-tests-polynomials-algebraicidentities-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - CP - Start - Close"},"postlogin-class9-tests-polynomials-algebraicidentities-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - CP - Start - Start Practice - Close"},"postlogin-class9-tests-polynomials-algebraicidentities-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - CP - Start - Start Practice - Check"},"postlogin-class9-tests-polynomials-algebraicidentities-cp-resume":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - CP - Resume"},"postlogin-class9-tests-polynomials-algebraicidentities-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - CP - Resume - Continue"},"postlogin-class9-tests-polynomials-algebraicidentities-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - CP - Resume - Close"},"postlogin-class9-tests-polynomials-algebraicidentities-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - CP - Resume - Continue - Close"},"postlogin-class9-tests-polynomials-algebraicidentities-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - CP - Resume - Continue - Check"},"postlogin-class9-tests-polynomials-algebraicidentities-cp-report":{"event_label":"View report CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Algebraic Identities - CP - Report"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-pt-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - PT - Start"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - PT - Resume"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-pt-report":{"event_label":"View report PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - PT - Report"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - PT - Start - Start Test"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - PT - Close"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - PT - Resume - Continue Test"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-pt-test-close":{"event_label":"Close PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - PT - Test - Close"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - PT - Test - Submit Test"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - PT - Scorecard - View Solutions"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - PT - Scorecard - View Solutions - Close"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - PT - Scorecard - View Recommendations"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - PT - Scorecard - View Recommendations - Close"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-cp-start":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - CP - Start"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - CP - Start - Start Practice"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - CP - Start - Close"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - CP - Start - Start Practice - Close"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - CP - Start - Start Practice - Check"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-cp-resume":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - CP - Resume"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - CP - Resume - Continue"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - CP - Resume - Close"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - CP - Resume - Continue - Close"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - CP - Resume - Continue - Check"},"postlogin-class9-tests-polynomials-problemsusingalgebraicidentitiesi-cp-report":{"event_label":"View report CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Polynomials - Problems using Algebraic Identities I - CP - Report"},"postlogin-class10-tests-pairoflinearequations-start":{"event_label":"Start topic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Start"},"postlogin-class10-tests-pairoflinearequations-resume":{"event_label":"Resume topic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Resume"},"postlogin-class10-tests-pairoflinearequations-revise":{"event_label":"Revise topic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Revise"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - PT - Start"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - PT - Resume"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - PT - Report"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - PT - Start - Start Test"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - PT - Close"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - PT - Resume - Continue Test"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - PT - Test - Close"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - PT - Test - Submit Test"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - PT - Scorecard - View Solutions"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - CP - Start"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - CP - Start - Start Practice"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - CP - Start - Close"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - CP - Start - Start Practice - Close"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - CP - Start - Start Practice - Check"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - CP - Resume"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - CP - Resume - Continue"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - CP - Resume - Close"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - CP - Resume - Continue - Close"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - CP - Resume - Continue - Check"},"postlogin-class10-tests-pairoflinearequations-consistencyofsystemofequations-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Consistency of System of Equations - CP - Report"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - PT - Start"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - PT - Resume"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - PT - Report"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - PT - Start - Start Test"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - PT - Close"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - PT - Resume - Continue Test"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - PT - Test - Close"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - PT - Test - Submit Test"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - PT - Scorecard - View Solutions"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - CP - Start"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - CP - Start - Start Practice"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - CP - Start - Close"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - CP - Start - Start Practice - Close"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - CP - Start - Start Practice - Check"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - CP - Resume"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - CP - Resume - Continue"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - CP - Resume - Close"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - CP - Resume - Continue - Close"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - CP - Resume - Continue - Check"},"postlogin-class10-tests-pairoflinearequations-graphicalmethod-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Graphical Method - CP - Report"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - PT - Start"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - PT - Resume"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - PT - Report"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - PT - Start - Start Test"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - PT - Close"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - PT - Resume - Continue Test"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - PT - Test - Close"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - PT - Test - Submit Test"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - PT - Scorecard - View Solutions"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - CP - Start"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - CP - Start - Start Practice"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - CP - Start - Close"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - CP - Start - Start Practice - Close"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - CP - Start - Start Practice - Check"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - CP - Resume"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - CP - Resume - Continue"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - CP - Resume - Close"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - CP - Resume - Continue - Close"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - CP - Resume - Continue - Check"},"postlogin-class10-tests-pairoflinearequations-substitutionmethod-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Substitution Method - CP - Report"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - PT - Start"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - PT - Resume"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - PT - Report"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - PT - Start - Start Test"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - PT - Close"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - PT - Resume - Continue Test"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - PT - Test - Close"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - PT - Test - Submit Test"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - PT - Scorecard - View Solutions"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - CP - Start"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - CP - Start - Start Practice"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - CP - Start - Close"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - CP - Start - Start Practice - Close"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - CP - Start - Start Practice - Check"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - CP - Resume"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - CP - Resume - Continue"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - CP - Resume - Close"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - CP - Resume - Continue - Close"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - CP - Resume - Continue - Check"},"postlogin-class10-tests-pairoflinearequations-eliminationmethod-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Elimination Method - CP - Report"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - PT - Start"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - PT - Resume"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - PT - Report"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - PT - Start - Start Test"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - PT - Close"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - PT - Resume - Continue Test"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - PT - Test - Close"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - PT - Test - Submit Test"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - PT - Scorecard - View Solutions"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - CP - Start"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - CP - Start - Start Practice"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - CP - Start - Close"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - CP - Start - Start Practice - Close"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - CP - Start - Start Practice - Check"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - CP - Resume"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - CP - Resume - Continue"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - CP - Resume - Close"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - CP - Resume - Continue - Close"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - CP - Resume - Continue - Check"},"postlogin-class10-tests-pairoflinearequations-crossmultiplicationmethod-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Cross Multiplication Method - CP - Report"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - PT - Start"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - PT - Resume"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - PT - Report"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - PT - Start - Start Test"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - PT - Close"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - PT - Resume - Continue Test"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - PT - Test - Close"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - PT - Test - Submit Test"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - PT - Scorecard - View Solutions"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - CP - Start"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - CP - Start - Start Practice"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - CP - Start - Close"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - CP - Start - Start Practice - Close"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - CP - Start - Start Practice - Check"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - CP - Resume"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - CP - Resume - Continue"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - CP - Resume - Close"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - CP - Resume - Continue - Close"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - CP - Resume - Continue - Check"},"postlogin-class10-tests-pairoflinearequations-eqnsreducibletopairoflinearequations-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Pair of Linear Equations - Eqns Reducible to Pair of Linear Equations - CP - Report"},"postlogin-class1-lessons-shapesandpatterns-start":{"event_label":"Start topic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons - Shapes and Patterns - Start"},"postlogin-class1-lessons-shapesandpatterns-resume":{"event_label":"Resume topic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons - Shapes and Patterns - Resume"},"postlogin-class1-lessons-shapesandpatterns-watched":{"event_label":"Rewatch topic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons - Shapes and Patterns - Watched"},"postlogin-class1-lessons-shapesandpatterns-shapes-start":{"event_label":"Start subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Shapes and Patterns - Shapes - Start"},"postlogin-class1-lessons-shapesandpatterns-shapes-resume":{"event_label":"Resume subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Shapes and Patterns - Shapes - Resume"},"postlogin-class1-lessons-shapesandpatterns-shapes-watched":{"event_label":"Rewatch subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Shapes and Patterns - Shapes - Watched"},"postlogin-class1-lessons-shapesandpatterns-shapes-lessons":{"event_label":"Class 1 lessons","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Shapes and Patterns - Shapes - Lessons"},"postlogin-class1-lessons-shapesandpatterns-shapes-close":{"event_label":"Close subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Shapes and Patterns - Shapes - Close"},"postlogin-class1-lessons-shapesandpatterns-patternsandpositions-start":{"event_label":"Start subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Shapes and Patterns - Patterns and Positions - Start"},"postlogin-class1-lessons-shapesandpatterns-patternsandpositions-resume":{"event_label":"Resume subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Shapes and Patterns - Patterns and Positions - Resume"},"postlogin-class1-lessons-shapesandpatterns-patternsandpositions-watched":{"event_label":"Rewatch subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Shapes and Patterns - Patterns and Positions - Watched"},"postlogin-class1-lessons-shapesandpatterns-patternsandpositions-lessons":{"event_label":"Class 1 lessons","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Shapes and Patterns - Patterns and Positions - Lessons"},"postlogin-class1-lessons-shapesandpatterns-patternsandpositions-close":{"event_label":"Close subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Shapes and Patterns - Patterns and Positions - Close"},"postlogin-class2-lessons-multiplicationanddivision-start":{"event_label":"Start topic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons - Multiplication and Division - Start"},"postlogin-class2-lessons-multiplicationanddivision-resume":{"event_label":"Resume topic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons - Multiplication and Division - Resume"},"postlogin-class2-lessons-multiplicationanddivision-watched":{"event_label":"Rewatch topic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons - Multiplication and Division - Watched"},"postlogin-class2-lessons-multiplicationanddivision-multiplication-start":{"event_label":"Start subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Multiplication and Division - Multiplication - Start"},"postlogin-class2-lessons-multiplicationanddivision-multiplication-resume":{"event_label":"Resume subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Multiplication and Division - Multiplication - Resume"},"postlogin-class2-lessons-multiplicationanddivision-multiplication-watched":{"event_label":"Rewatch subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Multiplication and Division - Multiplication - Watched"},"postlogin-class2-lessons-multiplicationanddivision-multiplication-lessons":{"event_label":"Class 2 lessons","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Multiplication and Division - Multiplication - Lessons"},"postlogin-class2-lessons-multiplicationanddivision-multiplication-close":{"event_label":"Close subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Multiplication and Division - Multiplication - Close"},"postlogin-class2-lessons-multiplicationanddivision-division-start":{"event_label":"Start subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Multiplication and Division - Division - Start"},"postlogin-class2-lessons-multiplicationanddivision-division-resume":{"event_label":"Resume subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Multiplication and Division - Division - Resume"},"postlogin-class2-lessons-multiplicationanddivision-division-watched":{"event_label":"Rewatch subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Multiplication and Division - Division - Watched"},"postlogin-class2-lessons-multiplicationanddivision-division-lessons":{"event_label":"Class 2 lessons","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Multiplication and Division - Division - Lessons"},"postlogin-class2-lessons-multiplicationanddivision-division-close":{"event_label":"Close subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Multiplication and Division - Division - Close"},"postlogin-class3-lessons-multiplicationanddivision-start":{"event_label":"Start topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Multiplication and Division - Start"},"postlogin-class3-lessons-multiplicationanddivision-resume":{"event_label":"Resume topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Multiplication and Division - Resume"},"postlogin-class3-lessons-multiplicationanddivision-watched":{"event_label":"Rewatch topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Multiplication and Division - Watched"},"postlogin-class3-lessons-multiplicationanddivision-multiplication-start":{"event_label":"Start subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Multiplication and Division - Multiplication - Start"},"postlogin-class3-lessons-multiplicationanddivision-multiplication-resume":{"event_label":"Resume subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Multiplication and Division - Multiplication - Resume"},"postlogin-class3-lessons-multiplicationanddivision-multiplication-watched":{"event_label":"Rewatch subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Multiplication and Division - Multiplication - Watched"},"postlogin-class3-lessons-multiplicationanddivision-multiplication-lessons":{"event_label":"Class 3 lessons","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Multiplication and Division - Multiplication - Lessons"},"postlogin-class3-lessons-multiplicationanddivision-multiplication-close":{"event_label":"Close subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Multiplication and Division - Multiplication - Close"},"postlogin-class3-lessons-multiplicationanddivision-division-start":{"event_label":"Start subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Multiplication and Division - Division - Start"},"postlogin-class3-lessons-multiplicationanddivision-division-resume":{"event_label":"Resume subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Multiplication and Division - Division - Resume"},"postlogin-class3-lessons-multiplicationanddivision-division-watched":{"event_label":"Rewatch subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Multiplication and Division - Division - Watched"},"postlogin-class3-lessons-multiplicationanddivision-division-lessons":{"event_label":"Class 3 lessons","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Multiplication and Division - Division - Lessons"},"postlogin-class3-lessons-multiplicationanddivision-division-close":{"event_label":"Close subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Multiplication and Division - Division - Close"},"postlogin-class4-lessons-multiplicationanddivision-start":{"event_label":"Start topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Multiplication and Division - Start"},"postlogin-class4-lessons-multiplicationanddivision-resume":{"event_label":"Resume topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Multiplication and Division - Resume"},"postlogin-class4-lessons-multiplicationanddivision-watched":{"event_label":"Rewatch topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Multiplication and Division - Watched"},"postlogin-class4-lessons-multiplicationanddivision-multiplication-start":{"event_label":"Start subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Multiplication and Division - Multiplication - Start"},"postlogin-class4-lessons-multiplicationanddivision-multiplication-resume":{"event_label":"Resume subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Multiplication and Division - Multiplication - Resume"},"postlogin-class4-lessons-multiplicationanddivision-multiplication-watched":{"event_label":"Rewatch subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Multiplication and Division - Multiplication - Watched"},"postlogin-class4-lessons-multiplicationanddivision-multiplication-lessons":{"event_label":"Class 4 lessons","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Multiplication and Division - Multiplication - Lessons"},"postlogin-class4-lessons-multiplicationanddivision-multiplication-close":{"event_label":"Close subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Multiplication and Division - Multiplication - Close"},"postlogin-class4-lessons-multiplicationanddivision-division-start":{"event_label":"Start subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Multiplication and Division - Division - Start"},"postlogin-class4-lessons-multiplicationanddivision-division-resume":{"event_label":"Resume subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Multiplication and Division - Division - Resume"},"postlogin-class4-lessons-multiplicationanddivision-division-watched":{"event_label":"Rewatch subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Multiplication and Division - Division - Watched"},"postlogin-class4-lessons-multiplicationanddivision-division-lessons":{"event_label":"Class 4 lessons","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Multiplication and Division - Division - Lessons"},"postlogin-class4-lessons-multiplicationanddivision-division-close":{"event_label":"Close subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Multiplication and Division - Division - Close"},"postlogin-class5-lessons-multiplicationanddivision-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Multiplication and Division - Start"},"postlogin-class5-lessons-multiplicationanddivision-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Multiplication and Division - Resume"},"postlogin-class5-lessons-multiplicationanddivision-watched":{"event_label":"Rewatch topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Multiplication and Division - Watched"},"postlogin-class5-lessons-multiplicationanddivision-multiplication-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Multiplication and Division - Multiplication - Start"},"postlogin-class5-lessons-multiplicationanddivision-multiplication-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Multiplication and Division - Multiplication - Resume"},"postlogin-class5-lessons-multiplicationanddivision-multiplication-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Multiplication and Division - Multiplication - Watched"},"postlogin-class5-lessons-multiplicationanddivision-multiplication-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Multiplication and Division - Multiplication - Lessons"},"postlogin-class5-lessons-multiplicationanddivision-multiplication-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Multiplication and Division - Multiplication - Close"},"postlogin-class5-lessons-multiplicationanddivision-division-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Multiplication and Division - Division - Start"},"postlogin-class5-lessons-multiplicationanddivision-division-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Multiplication and Division - Division - Resume"},"postlogin-class5-lessons-multiplicationanddivision-division-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Multiplication and Division - Division - Watched"},"postlogin-class5-lessons-multiplicationanddivision-division-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Multiplication and Division - Division - Lessons"},"postlogin-class5-lessons-multiplicationanddivision-division-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Multiplication and Division - Division - Close"},"postlogin-class6-lessons-factorsandmultiples-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Factors and Multiples - Start"},"postlogin-class6-lessons-factorsandmultiples-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Factors and Multiples - Resume"},"postlogin-class6-lessons-factorsandmultiples-watched":{"event_label":"Rewatch topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Factors and Multiples - Watched"},"postlogin-class6-lessons-factorsandmultiples-primeandcompositenumbers-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Factors and Multiples - Prime and Composite Numbers - Start"},"postlogin-class6-lessons-factorsandmultiples-primeandcompositenumbers-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Factors and Multiples - Prime and Composite Numbers - Resume"},"postlogin-class6-lessons-factorsandmultiples-primeandcompositenumbers-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Factors and Multiples - Prime and Composite Numbers - Watched"},"postlogin-class6-lessons-factorsandmultiples-primeandcompositenumbers-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Factors and Multiples - Prime and Composite Numbers - Lessons"},"postlogin-class6-lessons-factorsandmultiples-primeandcompositenumbers-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Factors and Multiples - Prime and Composite Numbers - Close"},"postlogin-class6-lessons-factorsandmultiples-testsofdivisibility-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Factors and Multiples - Tests of Divisibility - Start"},"postlogin-class6-lessons-factorsandmultiples-testsofdivisibility-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Factors and Multiples - Tests of Divisibility - Resume"},"postlogin-class6-lessons-factorsandmultiples-testsofdivisibility-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Factors and Multiples - Tests of Divisibility - Watched"},"postlogin-class6-lessons-factorsandmultiples-testsofdivisibility-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Factors and Multiples - Tests of Divisibility - Lessons"},"postlogin-class6-lessons-factorsandmultiples-testsofdivisibility-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Factors and Multiples - Tests of Divisibility - Close"},"postlogin-class6-lessons-factorsandmultiples-primefactorisation-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Factors and Multiples - Prime Factorisation - Start"},"postlogin-class6-lessons-factorsandmultiples-primefactorisation-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Factors and Multiples - Prime Factorisation - Resume"},"postlogin-class6-lessons-factorsandmultiples-primefactorisation-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Factors and Multiples - Prime Factorisation - Watched"},"postlogin-class6-lessons-factorsandmultiples-primefactorisation-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Factors and Multiples - Prime Factorisation - Lessons"},"postlogin-class6-lessons-factorsandmultiples-primefactorisation-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Factors and Multiples - Prime Factorisation - Close"},"postlogin-class6-lessons-factorsandmultiples-hcfandlcm-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Factors and Multiples - HCF and LCM - Start"},"postlogin-class6-lessons-factorsandmultiples-hcfandlcm-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Factors and Multiples - HCF and LCM - Resume"},"postlogin-class6-lessons-factorsandmultiples-hcfandlcm-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Factors and Multiples - HCF and LCM - Watched"},"postlogin-class6-lessons-factorsandmultiples-hcfandlcm-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Factors and Multiples - HCF and LCM - Lessons"},"postlogin-class6-lessons-factorsandmultiples-hcfandlcm-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Factors and Multiples - HCF and LCM - Close"},"postlogin-class7-lessons-decimals-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Decimals - Start"},"postlogin-class7-lessons-decimals-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Decimals - Resume"},"postlogin-class7-lessons-decimals-watched":{"event_label":"Rewatch topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Decimals - Watched"},"postlogin-class7-lessons-decimals-multiplicationanddivisionofdecimals-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Decimals - Multiplication and Division of Decimals - Start"},"postlogin-class7-lessons-decimals-multiplicationanddivisionofdecimals-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Decimals - Multiplication and Division of Decimals - Resume"},"postlogin-class7-lessons-decimals-multiplicationanddivisionofdecimals-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Decimals - Multiplication and Division of Decimals - Watched"},"postlogin-class7-lessons-decimals-multiplicationanddivisionofdecimals-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Decimals - Multiplication and Division of Decimals - Lessons"},"postlogin-class7-lessons-decimals-multiplicationanddivisionofdecimals-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Decimals - Multiplication and Division of Decimals - Close"},"postlogin-class8-lessons-understandingquadrilaterals-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Understanding Quadrilaterals - Start"},"postlogin-class8-lessons-understandingquadrilaterals-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Understanding Quadrilaterals - Resume"},"postlogin-class8-lessons-understandingquadrilaterals-watched":{"event_label":"Rewatch topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Understanding Quadrilaterals - Watched"},"postlogin-class8-lessons-understandingquadrilaterals-polygons-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Understanding Quadrilaterals - Polygons - Start"},"postlogin-class8-lessons-understandingquadrilaterals-polygons-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Understanding Quadrilaterals - Polygons - Resume"},"postlogin-class8-lessons-understandingquadrilaterals-polygons-watched":{"event_label":"Rewatch subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Understanding Quadrilaterals - Polygons - Watched"},"postlogin-class8-lessons-understandingquadrilaterals-polygons-lessons":{"event_label":"Class 8 lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Understanding Quadrilaterals - Polygons - Lessons"},"postlogin-class8-lessons-understandingquadrilaterals-polygons-close":{"event_label":"Close subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Understanding Quadrilaterals - Polygons - Close"},"postlogin-class8-lessons-understandingquadrilaterals-quadrilaterals-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Understanding Quadrilaterals - Quadrilaterals - Start"},"postlogin-class8-lessons-understandingquadrilaterals-quadrilaterals-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Understanding Quadrilaterals - Quadrilaterals - Resume"},"postlogin-class8-lessons-understandingquadrilaterals-quadrilaterals-watched":{"event_label":"Rewatch subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Understanding Quadrilaterals - Quadrilaterals - Watched"},"postlogin-class8-lessons-understandingquadrilaterals-quadrilaterals-lessons":{"event_label":"Class 8 lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Understanding Quadrilaterals - Quadrilaterals - Lessons"},"postlogin-class8-lessons-understandingquadrilaterals-quadrilaterals-close":{"event_label":"Close subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Understanding Quadrilaterals - Quadrilaterals - Close"},"postlogin-class9-lessons-coordinategeometry-start":{"event_label":"Start topic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons - Coordinate Geometry - Start"},"postlogin-class9-lessons-coordinategeometry-resume":{"event_label":"Resume topic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons - Coordinate Geometry - Resume"},"postlogin-class9-lessons-coordinategeometry-watched":{"event_label":"Rewatch topic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons - Coordinate Geometry - Watched"},"postlogin-class9-lessons-coordinategeometry-plottingpoints-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Coordinate Geometry - Plotting Points - Start"},"postlogin-class9-lessons-coordinategeometry-plottingpoints-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Coordinate Geometry - Plotting Points - Resume"},"postlogin-class9-lessons-coordinategeometry-plottingpoints-watched":{"event_label":"Rewatch subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Coordinate Geometry - Plotting Points - Watched"},"postlogin-class9-lessons-coordinategeometry-plottingpoints-lessons":{"event_label":"Class 9 lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Coordinate Geometry - Plotting Points - Lessons"},"postlogin-class9-lessons-coordinategeometry-plottingpoints-close":{"event_label":"Close subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Coordinate Geometry - Plotting Points - Close"},"postlogin-class10-lessons-coordinategeometry-start":{"event_label":"Start topic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons - Coordinate Geometry - Start"},"postlogin-class10-lessons-coordinategeometry-resume":{"event_label":"Resume topic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons - Coordinate Geometry - Resume"},"postlogin-class10-lessons-coordinategeometry-watched":{"event_label":"Rewatch topic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons - Coordinate Geometry - Watched"},"postlogin-class10-lessons-coordinategeometry-coordinategeometry-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Coordinate Geometry - Coordinate Geometry - Start"},"postlogin-class10-lessons-coordinategeometry-coordinategeometry-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Coordinate Geometry - Coordinate Geometry - Resume"},"postlogin-class10-lessons-coordinategeometry-coordinategeometry-watched":{"event_label":"Rewatch subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Coordinate Geometry - Coordinate Geometry - Watched"},"postlogin-class10-lessons-coordinategeometry-coordinategeometry-lessons":{"event_label":"Class 10 lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Coordinate Geometry - Coordinate Geometry - Lessons"},"postlogin-class10-lessons-coordinategeometry-coordinategeometry-close":{"event_label":"Close subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Coordinate Geometry - Coordinate Geometry - Close"},"postlogin-class5-tests-multiplicationanddivision-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Start"},"postlogin-class5-tests-multiplicationanddivision-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Resume"},"postlogin-class5-tests-multiplicationanddivision-revise":{"event_label":"Revise topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Revise"},"postlogin-class5-tests-multiplicationanddivision-multiplication-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - PT - Start"},"postlogin-class5-tests-multiplicationanddivision-multiplication-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - PT - Resume"},"postlogin-class5-tests-multiplicationanddivision-multiplication-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - PT - Report"},"postlogin-class5-tests-multiplicationanddivision-multiplication-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - PT - Start - Start Test"},"postlogin-class5-tests-multiplicationanddivision-multiplication-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - PT - Close"},"postlogin-class5-tests-multiplicationanddivision-multiplication-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - PT - Resume - Continue Test"},"postlogin-class5-tests-multiplicationanddivision-multiplication-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - PT - Test - Close"},"postlogin-class5-tests-multiplicationanddivision-multiplication-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - PT - Test - Submit Test"},"postlogin-class5-tests-multiplicationanddivision-multiplication-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - PT - Scorecard - View Solutions"},"postlogin-class5-tests-multiplicationanddivision-multiplication-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-multiplicationanddivision-multiplication-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-multiplicationanddivision-multiplication-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-multiplicationanddivision-multiplication-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-multiplicationanddivision-multiplication-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-multiplicationanddivision-multiplication-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-multiplicationanddivision-multiplication-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-multiplicationanddivision-multiplication-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-multiplicationanddivision-multiplication-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-multiplicationanddivision-multiplication-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-multiplicationanddivision-multiplication-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-multiplicationanddivision-multiplication-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-multiplicationanddivision-multiplication-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-multiplicationanddivision-multiplication-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-multiplicationanddivision-multiplication-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-multiplicationanddivision-multiplication-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - CP - Start"},"postlogin-class5-tests-multiplicationanddivision-multiplication-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - CP - Start - Start Practice"},"postlogin-class5-tests-multiplicationanddivision-multiplication-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - CP - Start - Close"},"postlogin-class5-tests-multiplicationanddivision-multiplication-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - CP - Start - Start Practice - Close"},"postlogin-class5-tests-multiplicationanddivision-multiplication-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - CP - Start - Start Practice - Check"},"postlogin-class5-tests-multiplicationanddivision-multiplication-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - CP - Resume"},"postlogin-class5-tests-multiplicationanddivision-multiplication-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - CP - Resume - Continue"},"postlogin-class5-tests-multiplicationanddivision-multiplication-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - CP - Resume - Close"},"postlogin-class5-tests-multiplicationanddivision-multiplication-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - CP - Resume - Continue - Close"},"postlogin-class5-tests-multiplicationanddivision-multiplication-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - CP - Resume - Continue - Check"},"postlogin-class5-tests-multiplicationanddivision-multiplication-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Multiplication - CP - Report"},"postlogin-class5-tests-multiplicationanddivision-division-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - PT - Start"},"postlogin-class5-tests-multiplicationanddivision-division-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - PT - Resume"},"postlogin-class5-tests-multiplicationanddivision-division-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - PT - Report"},"postlogin-class5-tests-multiplicationanddivision-division-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - PT - Start - Start Test"},"postlogin-class5-tests-multiplicationanddivision-division-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - PT - Close"},"postlogin-class5-tests-multiplicationanddivision-division-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - PT - Resume - Continue Test"},"postlogin-class5-tests-multiplicationanddivision-division-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - PT - Test - Close"},"postlogin-class5-tests-multiplicationanddivision-division-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - PT - Test - Submit Test"},"postlogin-class5-tests-multiplicationanddivision-division-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - PT - Scorecard - View Solutions"},"postlogin-class5-tests-multiplicationanddivision-division-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-multiplicationanddivision-division-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-multiplicationanddivision-division-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-multiplicationanddivision-division-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-multiplicationanddivision-division-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-multiplicationanddivision-division-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-multiplicationanddivision-division-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-multiplicationanddivision-division-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-multiplicationanddivision-division-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-multiplicationanddivision-division-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-multiplicationanddivision-division-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-multiplicationanddivision-division-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-multiplicationanddivision-division-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-multiplicationanddivision-division-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-multiplicationanddivision-division-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-multiplicationanddivision-division-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - CP - Start"},"postlogin-class5-tests-multiplicationanddivision-division-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - CP - Start - Start Practice"},"postlogin-class5-tests-multiplicationanddivision-division-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - CP - Start - Close"},"postlogin-class5-tests-multiplicationanddivision-division-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - CP - Start - Start Practice - Close"},"postlogin-class5-tests-multiplicationanddivision-division-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - CP - Start - Start Practice - Check"},"postlogin-class5-tests-multiplicationanddivision-division-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - CP - Resume"},"postlogin-class5-tests-multiplicationanddivision-division-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - CP - Resume - Continue"},"postlogin-class5-tests-multiplicationanddivision-division-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - CP - Resume - Close"},"postlogin-class5-tests-multiplicationanddivision-division-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - CP - Resume - Continue - Close"},"postlogin-class5-tests-multiplicationanddivision-division-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - CP - Resume - Continue - Check"},"postlogin-class5-tests-multiplicationanddivision-division-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Division - CP - Report"},"postlogin-class5-tests-multiplicationanddivision-average-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - PT - Start"},"postlogin-class5-tests-multiplicationanddivision-average-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - PT - Resume"},"postlogin-class5-tests-multiplicationanddivision-average-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - PT - Report"},"postlogin-class5-tests-multiplicationanddivision-average-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - PT - Start - Start Test"},"postlogin-class5-tests-multiplicationanddivision-average-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - PT - Close"},"postlogin-class5-tests-multiplicationanddivision-average-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - PT - Resume - Continue Test"},"postlogin-class5-tests-multiplicationanddivision-average-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - PT - Test - Close"},"postlogin-class5-tests-multiplicationanddivision-average-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - PT - Test - Submit Test"},"postlogin-class5-tests-multiplicationanddivision-average-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - PT - Scorecard - View Solutions"},"postlogin-class5-tests-multiplicationanddivision-average-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-multiplicationanddivision-average-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-multiplicationanddivision-average-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-multiplicationanddivision-average-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-multiplicationanddivision-average-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-multiplicationanddivision-average-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-multiplicationanddivision-average-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-multiplicationanddivision-average-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-multiplicationanddivision-average-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-multiplicationanddivision-average-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-multiplicationanddivision-average-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-multiplicationanddivision-average-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-multiplicationanddivision-average-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-multiplicationanddivision-average-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-multiplicationanddivision-average-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-multiplicationanddivision-average-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - CP - Start"},"postlogin-class5-tests-multiplicationanddivision-average-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - CP - Start - Start Practice"},"postlogin-class5-tests-multiplicationanddivision-average-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - CP - Start - Close"},"postlogin-class5-tests-multiplicationanddivision-average-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - CP - Start - Start Practice - Close"},"postlogin-class5-tests-multiplicationanddivision-average-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - CP - Start - Start Practice - Check"},"postlogin-class5-tests-multiplicationanddivision-average-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - CP - Resume"},"postlogin-class5-tests-multiplicationanddivision-average-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - CP - Resume - Continue"},"postlogin-class5-tests-multiplicationanddivision-average-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - CP - Resume - Close"},"postlogin-class5-tests-multiplicationanddivision-average-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - CP - Resume - Continue - Close"},"postlogin-class5-tests-multiplicationanddivision-average-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - CP - Resume - Continue - Check"},"postlogin-class5-tests-multiplicationanddivision-average-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Multiplication and Division - Average - CP - Report"},"postlogin-class6-tests-factorsandmultiples-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Start"},"postlogin-class6-tests-factorsandmultiples-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Resume"},"postlogin-class6-tests-factorsandmultiples-revise":{"event_label":"Revise topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Revise"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - PT - Start"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - PT - Resume"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - PT - Report"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - PT - Start - Start Test"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - PT - Close"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - PT - Resume - Continue Test"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - PT - Test - Close"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - PT - Test - Submit Test"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - PT - Scorecard - View Solutions"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - CP - Start"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - CP - Start - Start Practice"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - CP - Start - Close"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - CP - Start - Start Practice - Close"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - CP - Start - Start Practice - Check"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - CP - Resume"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - CP - Resume - Continue"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - CP - Resume - Close"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - CP - Resume - Continue - Close"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - CP - Resume - Continue - Check"},"postlogin-class6-tests-factorsandmultiples-primeandcompositenumbers-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime and Composite Numbers - CP - Report"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - PT - Start"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - PT - Resume"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - PT - Report"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - PT - Start - Start Test"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - PT - Close"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - PT - Resume - Continue Test"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - PT - Test - Close"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - PT - Test - Submit Test"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - PT - Scorecard - View Solutions"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - CP - Start"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - CP - Start - Start Practice"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - CP - Start - Close"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - CP - Start - Start Practice - Close"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - CP - Start - Start Practice - Check"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - CP - Resume"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - CP - Resume - Continue"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - CP - Resume - Close"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - CP - Resume - Continue - Close"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - CP - Resume - Continue - Check"},"postlogin-class6-tests-factorsandmultiples-testsofdivisibility-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Tests of Divisibility - CP - Report"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - PT - Start"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - PT - Resume"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - PT - Report"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - PT - Start - Start Test"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - PT - Close"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - PT - Resume - Continue Test"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - PT - Test - Close"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - PT - Test - Submit Test"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - PT - Scorecard - View Solutions"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - CP - Start"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - CP - Start - Start Practice"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - CP - Start - Close"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - CP - Start - Start Practice - Close"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - CP - Start - Start Practice - Check"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - CP - Resume"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - CP - Resume - Continue"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - CP - Resume - Close"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - CP - Resume - Continue - Close"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - CP - Resume - Continue - Check"},"postlogin-class6-tests-factorsandmultiples-primefactorisation-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Prime Factorisation - CP - Report"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - PT - Start"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - PT - Resume"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - PT - Report"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - PT - Start - Start Test"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - PT - Close"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - PT - Resume - Continue Test"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - PT - Test - Close"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - PT - Test - Submit Test"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - PT - Scorecard - View Solutions"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - CP - Start"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - CP - Start - Start Practice"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - CP - Start - Close"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - CP - Start - Start Practice - Close"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - CP - Start - Start Practice - Check"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - CP - Resume"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - CP - Resume - Continue"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - CP - Resume - Close"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - CP - Resume - Continue - Close"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - CP - Resume - Continue - Check"},"postlogin-class6-tests-factorsandmultiples-highestcommonfactor-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Highest Common Factor - CP - Report"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - PT - Start"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - PT - Resume"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - PT - Report"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - PT - Start - Start Test"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - PT - Close"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - PT - Resume - Continue Test"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - PT - Test - Close"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - PT - Test - Submit Test"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - PT - Scorecard - View Solutions"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - CP - Start"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - CP - Start - Start Practice"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - CP - Start - Close"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - CP - Start - Start Practice - Close"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - CP - Start - Start Practice - Check"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - CP - Resume"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - CP - Resume - Continue"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - CP - Resume - Close"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - CP - Resume - Continue - Close"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - CP - Resume - Continue - Check"},"postlogin-class6-tests-factorsandmultiples-lowestcommonmultiple-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Factors and Multiples - Lowest Common Multiple - CP - Report"},"postlogin-class7-tests-decimals-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Start"},"postlogin-class7-tests-decimals-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Resume"},"postlogin-class7-tests-decimals-revise":{"event_label":"Revise topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Revise"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - PT - Start"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - PT - Resume"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - PT - Report"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - PT - Start - Start Test"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - PT - Close"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - PT - Resume - Continue Test"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - PT - Test - Close"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - PT - Test - Submit Test"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - PT - Scorecard - View Solutions"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - CP - Start"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - CP - Start - Start Practice"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - CP - Start - Close"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - CP - Start - Start Practice - Close"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - CP - Start - Start Practice - Check"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - CP - Resume"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - CP - Resume - Continue"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - CP - Resume - Close"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - CP - Resume - Continue - Close"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - CP - Resume - Continue - Check"},"postlogin-class7-tests-decimals-multiplydecimalsby10,100and1000-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by 10, 100 and 1000 - CP - Report"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - PT - Start"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - PT - Resume"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - PT - Report"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - PT - Start - Start Test"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - PT - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - PT - Resume - Continue Test"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - PT - Test - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - PT - Test - Submit Test"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - PT - Scorecard - View Solutions"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - CP - Start"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - CP - Start - Start Practice"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - CP - Start - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - CP - Start - Start Practice - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - CP - Start - Start Practice - Check"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - CP - Resume"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - CP - Resume - Continue"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - CP - Resume - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - CP - Resume - Continue - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - CP - Resume - Continue - Check"},"postlogin-class7-tests-decimals-multiplydecimalsbywholenumbers-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Whole Numbers - CP - Report"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - PT - Start"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - PT - Resume"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - PT - Report"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - PT - Start - Start Test"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - PT - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - PT - Resume - Continue Test"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - PT - Test - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - PT - Test - Submit Test"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - PT - Scorecard - View Solutions"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - CP - Start"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - CP - Start - Start Practice"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - CP - Start - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - CP - Start - Start Practice - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - CP - Start - Start Practice - Check"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - CP - Resume"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - CP - Resume - Continue"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - CP - Resume - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - CP - Resume - Continue - Close"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - CP - Resume - Continue - Check"},"postlogin-class7-tests-decimals-multiplydecimalsbydecimals-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Multiply Decimals by Decimals - CP - Report"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - PT - Start"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - PT - Resume"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - PT - Report"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - PT - Start - Start Test"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - PT - Close"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - PT - Resume - Continue Test"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - PT - Test - Close"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - PT - Test - Submit Test"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - PT - Scorecard - View Solutions"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - CP - Start"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - CP - Start - Start Practice"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - CP - Start - Close"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - CP - Start - Start Practice - Close"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - CP - Start - Start Practice - Check"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - CP - Resume"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - CP - Resume - Continue"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - CP - Resume - Close"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - CP - Resume - Continue - Close"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - CP - Resume - Continue - Check"},"postlogin-class7-tests-decimals-dividedecimalsby10,100and1000-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by 10, 100 and 1000 - CP - Report"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - PT - Start"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - PT - Resume"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - PT - Report"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - PT - Start - Start Test"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - PT - Close"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - PT - Resume - Continue Test"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - PT - Test - Close"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - PT - Test - Submit Test"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - PT - Scorecard - View Solutions"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - CP - Start"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - CP - Start - Start Practice"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - CP - Start - Close"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - CP - Start - Start Practice - Close"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - CP - Start - Start Practice - Check"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - CP - Resume"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - CP - Resume - Continue"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - CP - Resume - Close"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - CP - Resume - Continue - Close"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - CP - Resume - Continue - Check"},"postlogin-class7-tests-decimals-dividedecimalsbywholenumbers-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Whole Numbers - CP - Report"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - PT - Start"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - PT - Resume"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - PT - Report"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - PT - Start - Start Test"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - PT - Close"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - PT - Resume - Continue Test"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - PT - Test - Close"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - PT - Test - Submit Test"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - PT - Scorecard - View Solutions"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - CP - Start"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - CP - Start - Start Practice"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - CP - Start - Close"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - CP - Start - Start Practice - Close"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - CP - Start - Start Practice - Check"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - CP - Resume"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - CP - Resume - Continue"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - CP - Resume - Close"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - CP - Resume - Continue - Close"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - CP - Resume - Continue - Check"},"postlogin-class7-tests-decimals-dividewholenumbersbydecimals-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Whole Numbers by Decimals - CP - Report"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - PT - Start"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - PT - Resume"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - PT - Report"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - PT - Start - Start Test"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - PT - Close"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - PT - Resume - Continue Test"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - PT - Test - Close"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - PT - Test - Submit Test"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - PT - Scorecard - View Solutions"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - CP - Start"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - CP - Start - Start Practice"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - CP - Start - Close"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - CP - Start - Start Practice - Close"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - CP - Start - Start Practice - Check"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - CP - Resume"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - CP - Resume - Continue"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - CP - Resume - Close"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - CP - Resume - Continue - Close"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - CP - Resume - Continue - Check"},"postlogin-class7-tests-decimals-dividedecimalsbydecimals-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Decimals - Divide Decimals by Decimals - CP - Report"},"postlogin-class8-tests-understandingquadrilaterals-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Start"},"postlogin-class8-tests-understandingquadrilaterals-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Resume"},"postlogin-class8-tests-understandingquadrilaterals-revise":{"event_label":"Revise topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Revise"},"postlogin-class8-tests-understandingquadrilaterals-polygons-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - PT - Start"},"postlogin-class8-tests-understandingquadrilaterals-polygons-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - PT - Resume"},"postlogin-class8-tests-understandingquadrilaterals-polygons-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - PT - Report"},"postlogin-class8-tests-understandingquadrilaterals-polygons-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - PT - Start - Start Test"},"postlogin-class8-tests-understandingquadrilaterals-polygons-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - PT - Close"},"postlogin-class8-tests-understandingquadrilaterals-polygons-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - PT - Resume - Continue Test"},"postlogin-class8-tests-understandingquadrilaterals-polygons-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - PT - Test - Close"},"postlogin-class8-tests-understandingquadrilaterals-polygons-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - PT - Test - Submit Test"},"postlogin-class8-tests-understandingquadrilaterals-polygons-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - PT - Scorecard - View Solutions"},"postlogin-class8-tests-understandingquadrilaterals-polygons-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-understandingquadrilaterals-polygons-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-understandingquadrilaterals-polygons-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-understandingquadrilaterals-polygons-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-understandingquadrilaterals-polygons-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-understandingquadrilaterals-polygons-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-understandingquadrilaterals-polygons-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-understandingquadrilaterals-polygons-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-understandingquadrilaterals-polygons-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-understandingquadrilaterals-polygons-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-understandingquadrilaterals-polygons-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-understandingquadrilaterals-polygons-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-understandingquadrilaterals-polygons-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-understandingquadrilaterals-polygons-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-understandingquadrilaterals-polygons-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-understandingquadrilaterals-polygons-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - CP - Start"},"postlogin-class8-tests-understandingquadrilaterals-polygons-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - CP - Start - Start Practice"},"postlogin-class8-tests-understandingquadrilaterals-polygons-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - CP - Start - Close"},"postlogin-class8-tests-understandingquadrilaterals-polygons-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - CP - Start - Start Practice - Close"},"postlogin-class8-tests-understandingquadrilaterals-polygons-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - CP - Start - Start Practice - Check"},"postlogin-class8-tests-understandingquadrilaterals-polygons-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - CP - Resume"},"postlogin-class8-tests-understandingquadrilaterals-polygons-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - CP - Resume - Continue"},"postlogin-class8-tests-understandingquadrilaterals-polygons-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - CP - Resume - Close"},"postlogin-class8-tests-understandingquadrilaterals-polygons-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - CP - Resume - Continue - Close"},"postlogin-class8-tests-understandingquadrilaterals-polygons-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - CP - Resume - Continue - Check"},"postlogin-class8-tests-understandingquadrilaterals-polygons-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Polygons - CP - Report"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - PT - Start"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - PT - Resume"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - PT - Report"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - PT - Start - Start Test"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - PT - Close"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - PT - Resume - Continue Test"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - PT - Test - Close"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - PT - Test - Submit Test"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - PT - Scorecard - View Solutions"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - CP - Start"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - CP - Start - Start Practice"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - CP - Start - Close"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - CP - Start - Start Practice - Close"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - CP - Start - Start Practice - Check"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - CP - Resume"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - CP - Resume - Continue"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - CP - Resume - Close"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - CP - Resume - Continue - Close"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - CP - Resume - Continue - Check"},"postlogin-class8-tests-understandingquadrilaterals-quadrilaterals-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Quadrilaterals - CP - Report"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - PT - Start"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - PT - Resume"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - PT - Report"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - PT - Start - Start Test"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - PT - Close"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - PT - Resume - Continue Test"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - PT - Test - Close"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - PT - Test - Submit Test"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - PT - Scorecard - View Solutions"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - CP - Start"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - CP - Start - Start Practice"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - CP - Start - Close"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - CP - Start - Start Practice - Close"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - CP - Start - Start Practice - Check"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - CP - Resume"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - CP - Resume - Continue"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - CP - Resume - Close"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - CP - Resume - Continue - Close"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - CP - Resume - Continue - Check"},"postlogin-class8-tests-understandingquadrilaterals-propertiesofquadrilaterals-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Understanding Quadrilaterals - Properties of Quadrilaterals - CP - Report"},"postlogin-class9-tests-coordinategeometry-start":{"event_label":"Start topic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Start"},"postlogin-class9-tests-coordinategeometry-resume":{"event_label":"Resume topic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Resume"},"postlogin-class9-tests-coordinategeometry-revise":{"event_label":"Revise topic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Revise"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-pt-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - PT - Start"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - PT - Resume"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-pt-report":{"event_label":"View report PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - PT - Report"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - PT - Start - Start Test"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - PT - Close"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - PT - Resume - Continue Test"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-pt-test-close":{"event_label":"Close PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - PT - Test - Close"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - PT - Test - Submit Test"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - PT - Scorecard - View Solutions"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - PT - Scorecard - View Solutions - Close"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - PT - Scorecard - View Recommendations"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - PT - Scorecard - View Recommendations - Close"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-cp-start":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - CP - Start"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - CP - Start - Start Practice"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - CP - Start - Close"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - CP - Start - Start Practice - Close"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - CP - Start - Start Practice - Check"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-cp-resume":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - CP - Resume"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - CP - Resume - Continue"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - CP - Resume - Close"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - CP - Resume - Continue - Close"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - CP - Resume - Continue - Check"},"postlogin-class9-tests-coordinategeometry-introductiontoquadrants-cp-report":{"event_label":"View report CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Introduction to Quadrants - CP - Report"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-pt-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - PT - Start"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - PT - Resume"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-pt-report":{"event_label":"View report PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - PT - Report"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - PT - Start - Start Test"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - PT - Close"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - PT - Resume - Continue Test"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-pt-test-close":{"event_label":"Close PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - PT - Test - Close"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - PT - Test - Submit Test"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - PT - Scorecard - View Solutions"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - PT - Scorecard - View Solutions - Close"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - PT - Scorecard - View Recommendations"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - PT - Scorecard - View Recommendations - Close"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-cp-start":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - CP - Start"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - CP - Start - Start Practice"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - CP - Start - Close"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - CP - Start - Start Practice - Close"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - CP - Start - Start Practice - Check"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-cp-resume":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - CP - Resume"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - CP - Resume - Continue"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - CP - Resume - Close"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - CP - Resume - Continue - Close"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - CP - Resume - Continue - Check"},"postlogin-class9-tests-coordinategeometry-workingwithcoordinates-cp-report":{"event_label":"View report CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Coordinate Geometry - Working with Coordinates - CP - Report"},"postlogin-class10-tests-quadraticequations-start":{"event_label":"Start topic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Start"},"postlogin-class10-tests-quadraticequations-resume":{"event_label":"Resume topic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Resume"},"postlogin-class10-tests-quadraticequations-revise":{"event_label":"Revise topic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Revise"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - PT - Start"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - PT - Resume"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - PT - Report"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - PT - Start - Start Test"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - PT - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - PT - Resume - Continue Test"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - PT - Test - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - PT - Test - Submit Test"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - PT - Scorecard - View Solutions"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - CP - Start"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - CP - Start - Start Practice"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - CP - Start - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - CP - Start - Start Practice - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - CP - Start - Start Practice - Check"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - CP - Resume"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - CP - Resume - Continue"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - CP - Resume - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - CP - Resume - Continue - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - CP - Resume - Continue - Check"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - CP - Report"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - PT - Start"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - PT - Resume"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - PT - Report"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - PT - Start - Start Test"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - PT - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - PT - Resume - Continue Test"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - PT - Test - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - PT - Test - Submit Test"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - PT - Scorecard - View Solutions"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - CP - Start"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - CP - Start - Start Practice"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - CP - Start - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - CP - Start - Start Practice - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - CP - Start - Start Practice - Check"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - CP - Resume"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - CP - Resume - Continue"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - CP - Resume - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - CP - Resume - Continue - Close"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - CP - Resume - Continue - Check"},"postlogin-class10-tests-quadraticequations-solvebyfactorisation-wordproblems-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Factorisation - Word Problems - CP - Report"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - PT - Start"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - PT - Resume"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - PT - Report"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - PT - Start - Start Test"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - PT - Close"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - PT - Resume - Continue Test"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - PT - Test - Close"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - PT - Test - Submit Test"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - PT - Scorecard - View Solutions"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - CP - Start"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - CP - Start - Start Practice"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - CP - Start - Close"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - CP - Start - Start Practice - Close"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - CP - Start - Start Practice - Check"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - CP - Resume"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - CP - Resume - Continue"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - CP - Resume - Close"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - CP - Resume - Continue - Close"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - CP - Resume - Continue - Check"},"postlogin-class10-tests-quadraticequations-solvebycompletingthesquares-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Completing the Squares - CP - Report"},"postlogin-class10-tests-quadraticequations-solvebyformula-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - PT - Start"},"postlogin-class10-tests-quadraticequations-solvebyformula-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - PT - Resume"},"postlogin-class10-tests-quadraticequations-solvebyformula-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - PT - Report"},"postlogin-class10-tests-quadraticequations-solvebyformula-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - PT - Start - Start Test"},"postlogin-class10-tests-quadraticequations-solvebyformula-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - PT - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - PT - Resume - Continue Test"},"postlogin-class10-tests-quadraticequations-solvebyformula-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - PT - Test - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - PT - Test - Submit Test"},"postlogin-class10-tests-quadraticequations-solvebyformula-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - PT - Scorecard - View Solutions"},"postlogin-class10-tests-quadraticequations-solvebyformula-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-quadraticequations-solvebyformula-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-quadraticequations-solvebyformula-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-quadraticequations-solvebyformula-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-quadraticequations-solvebyformula-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-quadraticequations-solvebyformula-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-quadraticequations-solvebyformula-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-quadraticequations-solvebyformula-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-quadraticequations-solvebyformula-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - CP - Start"},"postlogin-class10-tests-quadraticequations-solvebyformula-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - CP - Start - Start Practice"},"postlogin-class10-tests-quadraticequations-solvebyformula-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - CP - Start - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - CP - Start - Start Practice - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - CP - Start - Start Practice - Check"},"postlogin-class10-tests-quadraticequations-solvebyformula-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - CP - Resume"},"postlogin-class10-tests-quadraticequations-solvebyformula-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - CP - Resume - Continue"},"postlogin-class10-tests-quadraticequations-solvebyformula-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - CP - Resume - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - CP - Resume - Continue - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - CP - Resume - Continue - Check"},"postlogin-class10-tests-quadraticequations-solvebyformula-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - CP - Report"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - PT - Start"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - PT - Resume"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - PT - Report"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - PT - Start - Start Test"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - PT - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - PT - Resume - Continue Test"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - PT - Test - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - PT - Test - Submit Test"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - PT - Scorecard - View Solutions"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - CP - Start"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - CP - Start - Start Practice"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - CP - Start - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - CP - Start - Start Practice - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - CP - Start - Start Practice - Check"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - CP - Resume"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - CP - Resume - Continue"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - CP - Resume - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - CP - Resume - Continue - Close"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - CP - Resume - Continue - Check"},"postlogin-class10-tests-quadraticequations-solvebyformula-wordproblems-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Solve by Formula - Word Problems - CP - Report"},"postlogin-class10-tests-quadraticequations-natureofroots-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - PT - Start"},"postlogin-class10-tests-quadraticequations-natureofroots-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - PT - Resume"},"postlogin-class10-tests-quadraticequations-natureofroots-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - PT - Report"},"postlogin-class10-tests-quadraticequations-natureofroots-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - PT - Start - Start Test"},"postlogin-class10-tests-quadraticequations-natureofroots-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - PT - Close"},"postlogin-class10-tests-quadraticequations-natureofroots-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - PT - Resume - Continue Test"},"postlogin-class10-tests-quadraticequations-natureofroots-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - PT - Test - Close"},"postlogin-class10-tests-quadraticequations-natureofroots-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - PT - Test - Submit Test"},"postlogin-class10-tests-quadraticequations-natureofroots-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - PT - Scorecard - View Solutions"},"postlogin-class10-tests-quadraticequations-natureofroots-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-quadraticequations-natureofroots-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-quadraticequations-natureofroots-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-quadraticequations-natureofroots-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-quadraticequations-natureofroots-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-quadraticequations-natureofroots-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-quadraticequations-natureofroots-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-quadraticequations-natureofroots-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-quadraticequations-natureofroots-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-quadraticequations-natureofroots-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-quadraticequations-natureofroots-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-quadraticequations-natureofroots-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-quadraticequations-natureofroots-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-quadraticequations-natureofroots-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-quadraticequations-natureofroots-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-quadraticequations-natureofroots-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - CP - Start"},"postlogin-class10-tests-quadraticequations-natureofroots-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - CP - Start - Start Practice"},"postlogin-class10-tests-quadraticequations-natureofroots-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - CP - Start - Close"},"postlogin-class10-tests-quadraticequations-natureofroots-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - CP - Start - Start Practice - Close"},"postlogin-class10-tests-quadraticequations-natureofroots-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - CP - Start - Start Practice - Check"},"postlogin-class10-tests-quadraticequations-natureofroots-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - CP - Resume"},"postlogin-class10-tests-quadraticequations-natureofroots-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - CP - Resume - Continue"},"postlogin-class10-tests-quadraticequations-natureofroots-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - CP - Resume - Close"},"postlogin-class10-tests-quadraticequations-natureofroots-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - CP - Resume - Continue - Close"},"postlogin-class10-tests-quadraticequations-natureofroots-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - CP - Resume - Continue - Check"},"postlogin-class10-tests-quadraticequations-natureofroots-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Quadratic Equations - Nature of Roots - CP - Report"},"postlogin-class1-lessons-measurement-start":{"event_label":"Start topic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons - Measurement - Start"},"postlogin-class1-lessons-measurement-resume":{"event_label":"Resume topic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons - Measurement - Resume"},"postlogin-class1-lessons-measurement-watched":{"event_label":"Rewatch topic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons - Measurement - Watched"},"postlogin-class1-lessons-measurement-length-start":{"event_label":"Start subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Measurement - Length - Start"},"postlogin-class1-lessons-measurement-length-resume":{"event_label":"Resume subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Measurement - Length - Resume"},"postlogin-class1-lessons-measurement-length-watched":{"event_label":"Rewatch subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Measurement - Length - Watched"},"postlogin-class1-lessons-measurement-length-lessons":{"event_label":"Class 1 lessons","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Measurement - Length - Lessons"},"postlogin-class1-lessons-measurement-length-close":{"event_label":"Close subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Measurement - Length - Close"},"postlogin-class1-lessons-measurement-mass-start":{"event_label":"Start subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Measurement - Mass - Start"},"postlogin-class1-lessons-measurement-mass-resume":{"event_label":"Resume subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Measurement - Mass - Resume"},"postlogin-class1-lessons-measurement-mass-watched":{"event_label":"Rewatch subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Measurement - Mass - Watched"},"postlogin-class1-lessons-measurement-mass-lessons":{"event_label":"Class 1 lessons","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Measurement - Mass - Lessons"},"postlogin-class1-lessons-measurement-mass-close":{"event_label":"Close subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Measurement - Mass - Close"},"postlogin-class1-lessons-measurement-capacity-start":{"event_label":"Start subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Measurement - Capacity - Start"},"postlogin-class1-lessons-measurement-capacity-resume":{"event_label":"Resume subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Measurement - Capacity - Resume"},"postlogin-class1-lessons-measurement-capacity-watched":{"event_label":"Rewatch subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Measurement - Capacity - Watched"},"postlogin-class1-lessons-measurement-capacity-lessons":{"event_label":"Class 1 lessons","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Measurement - Capacity - Lessons"},"postlogin-class1-lessons-measurement-capacity-close":{"event_label":"Close subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Measurement - Capacity - Close"},"postlogin-class2-lessons-measurement-start":{"event_label":"Start topic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons - Measurement - Start"},"postlogin-class2-lessons-measurement-resume":{"event_label":"Resume topic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons - Measurement - Resume"},"postlogin-class2-lessons-measurement-watched":{"event_label":"Rewatch topic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons - Measurement - Watched"},"postlogin-class2-lessons-measurement-length-start":{"event_label":"Start subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Measurement - Length - Start"},"postlogin-class2-lessons-measurement-length-resume":{"event_label":"Resume subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Measurement - Length - Resume"},"postlogin-class2-lessons-measurement-length-watched":{"event_label":"Rewatch subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Measurement - Length - Watched"},"postlogin-class2-lessons-measurement-length-lessons":{"event_label":"Class 2 lessons","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Measurement - Length - Lessons"},"postlogin-class2-lessons-measurement-length-close":{"event_label":"Close subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Measurement - Length - Close"},"postlogin-class2-lessons-measurement-mass-start":{"event_label":"Start subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Measurement - Mass - Start"},"postlogin-class2-lessons-measurement-mass-resume":{"event_label":"Resume subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Measurement - Mass - Resume"},"postlogin-class2-lessons-measurement-mass-watched":{"event_label":"Rewatch subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Measurement - Mass - Watched"},"postlogin-class2-lessons-measurement-mass-lessons":{"event_label":"Class 2 lessons","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Measurement - Mass - Lessons"},"postlogin-class2-lessons-measurement-mass-close":{"event_label":"Close subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Measurement - Mass - Close"},"postlogin-class2-lessons-measurement-capacity-start":{"event_label":"Start subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Measurement - Capacity - Start"},"postlogin-class2-lessons-measurement-capacity-resume":{"event_label":"Resume subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Measurement - Capacity - Resume"},"postlogin-class2-lessons-measurement-capacity-watched":{"event_label":"Rewatch subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Measurement - Capacity - Watched"},"postlogin-class2-lessons-measurement-capacity-lessons":{"event_label":"Class 2 lessons","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Measurement - Capacity - Lessons"},"postlogin-class2-lessons-measurement-capacity-close":{"event_label":"Close subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Measurement - Capacity - Close"},"postlogin-class3-lessons-fractions-start":{"event_label":"Start topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Fractions - Start"},"postlogin-class3-lessons-fractions-resume":{"event_label":"Resume topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Fractions - Resume"},"postlogin-class3-lessons-fractions-watched":{"event_label":"Rewatch topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Fractions - Watched"},"postlogin-class3-lessons-fractions-introductiontofractions-start":{"event_label":"Start subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Fractions - Introduction to Fractions - Start"},"postlogin-class3-lessons-fractions-introductiontofractions-resume":{"event_label":"Resume subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Fractions - Introduction to Fractions - Resume"},"postlogin-class3-lessons-fractions-introductiontofractions-watched":{"event_label":"Rewatch subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Fractions - Introduction to Fractions - Watched"},"postlogin-class3-lessons-fractions-introductiontofractions-lessons":{"event_label":"Class 3 lessons","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Fractions - Introduction to Fractions - Lessons"},"postlogin-class3-lessons-fractions-introductiontofractions-close":{"event_label":"Close subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Fractions - Introduction to Fractions - Close"},"postlogin-class4-lessons-fractionsanddecimals-start":{"event_label":"Start topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Fractions and Decimals - Start"},"postlogin-class4-lessons-fractionsanddecimals-resume":{"event_label":"Resume topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Fractions and Decimals - Resume"},"postlogin-class4-lessons-fractionsanddecimals-watched":{"event_label":"Rewatch topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Fractions and Decimals - Watched"},"postlogin-class4-lessons-fractionsanddecimals-fractions-start":{"event_label":"Start subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Fractions and Decimals - Fractions - Start"},"postlogin-class4-lessons-fractionsanddecimals-fractions-resume":{"event_label":"Resume subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Fractions and Decimals - Fractions - Resume"},"postlogin-class4-lessons-fractionsanddecimals-fractions-watched":{"event_label":"Rewatch subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Fractions and Decimals - Fractions - Watched"},"postlogin-class4-lessons-fractionsanddecimals-fractions-lessons":{"event_label":"Class 4 lessons","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Fractions and Decimals - Fractions - Lessons"},"postlogin-class4-lessons-fractionsanddecimals-fractions-close":{"event_label":"Close subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Fractions and Decimals - Fractions - Close"},"postlogin-class4-lessons-fractionsanddecimals-decimals-start":{"event_label":"Start subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Fractions and Decimals - Decimals - Start"},"postlogin-class4-lessons-fractionsanddecimals-decimals-resume":{"event_label":"Resume subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Fractions and Decimals - Decimals - Resume"},"postlogin-class4-lessons-fractionsanddecimals-decimals-watched":{"event_label":"Rewatch subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Fractions and Decimals - Decimals - Watched"},"postlogin-class4-lessons-fractionsanddecimals-decimals-lessons":{"event_label":"Class 4 lessons","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Fractions and Decimals - Decimals - Lessons"},"postlogin-class4-lessons-fractionsanddecimals-decimals-close":{"event_label":"Close subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Fractions and Decimals - Decimals - Close"},"postlogin-class5-lessons-factorsandmultiples-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Factors and Multiples - Start"},"postlogin-class5-lessons-factorsandmultiples-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Factors and Multiples - Resume"},"postlogin-class5-lessons-factorsandmultiples-watched":{"event_label":"Rewatch topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Factors and Multiples - Watched"},"postlogin-class5-lessons-factorsandmultiples-primefactorsandtestsofdivisibility-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Factors and Multiples - Prime Factors and Tests of Divisibility - Start"},"postlogin-class5-lessons-factorsandmultiples-primefactorsandtestsofdivisibility-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Factors and Multiples - Prime Factors and Tests of Divisibility - Resume"},"postlogin-class5-lessons-factorsandmultiples-primefactorsandtestsofdivisibility-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Factors and Multiples - Prime Factors and Tests of Divisibility - Watched"},"postlogin-class5-lessons-factorsandmultiples-primefactorsandtestsofdivisibility-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Factors and Multiples - Prime Factors and Tests of Divisibility - Lessons"},"postlogin-class5-lessons-factorsandmultiples-primefactorsandtestsofdivisibility-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Factors and Multiples - Prime Factors and Tests of Divisibility - Close"},"postlogin-class5-lessons-factorsandmultiples-hcfandlcm-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Factors and Multiples - HCF and LCM - Start"},"postlogin-class5-lessons-factorsandmultiples-hcfandlcm-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Factors and Multiples - HCF and LCM - Resume"},"postlogin-class5-lessons-factorsandmultiples-hcfandlcm-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Factors and Multiples - HCF and LCM - Watched"},"postlogin-class5-lessons-factorsandmultiples-hcfandlcm-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Factors and Multiples - HCF and LCM - Lessons"},"postlogin-class5-lessons-factorsandmultiples-hcfandlcm-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Factors and Multiples - HCF and LCM - Close"},"postlogin-class6-lessons-basicgoemetricalideas-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Basic Goemetrical Ideas - Start"},"postlogin-class6-lessons-basicgoemetricalideas-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Basic Goemetrical Ideas - Resume"},"postlogin-class6-lessons-basicgoemetricalideas-watched":{"event_label":"Rewatch topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Basic Goemetrical Ideas - Watched"},"postlogin-class6-lessons-basicgoemetricalideas-points,linesandangles-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Basic Goemetrical Ideas - Points, Lines and Angles - Start"},"postlogin-class6-lessons-basicgoemetricalideas-points,linesandangles-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Basic Goemetrical Ideas - Points, Lines and Angles - Resume"},"postlogin-class6-lessons-basicgoemetricalideas-points,linesandangles-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Basic Goemetrical Ideas - Points, Lines and Angles - Watched"},"postlogin-class6-lessons-basicgoemetricalideas-points,linesandangles-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Basic Goemetrical Ideas - Points, Lines and Angles - Lessons"},"postlogin-class6-lessons-basicgoemetricalideas-points,linesandangles-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Basic Goemetrical Ideas - Points, Lines and Angles - Close"},"postlogin-class6-lessons-basicgoemetricalideas-circlesandquadrilaterals-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Basic Goemetrical Ideas - Circles and Quadrilaterals - Start"},"postlogin-class6-lessons-basicgoemetricalideas-circlesandquadrilaterals-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Basic Goemetrical Ideas - Circles and Quadrilaterals - Resume"},"postlogin-class6-lessons-basicgoemetricalideas-circlesandquadrilaterals-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Basic Goemetrical Ideas - Circles and Quadrilaterals - Watched"},"postlogin-class6-lessons-basicgoemetricalideas-circlesandquadrilaterals-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Basic Goemetrical Ideas - Circles and Quadrilaterals - Lessons"},"postlogin-class6-lessons-basicgoemetricalideas-circlesandquadrilaterals-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Basic Goemetrical Ideas - Circles and Quadrilaterals - Close"},"postlogin-class7-lessons-datahandling-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Data Handling - Start"},"postlogin-class7-lessons-datahandling-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Data Handling - Resume"},"postlogin-class7-lessons-datahandling-watched":{"event_label":"Rewatch topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Data Handling - Watched"},"postlogin-class7-lessons-datahandling-bargraph-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Data Handling - Bar Graph - Start"},"postlogin-class7-lessons-datahandling-bargraph-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Data Handling - Bar Graph - Resume"},"postlogin-class7-lessons-datahandling-bargraph-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Data Handling - Bar Graph - Watched"},"postlogin-class7-lessons-datahandling-bargraph-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Data Handling - Bar Graph - Lessons"},"postlogin-class7-lessons-datahandling-bargraph-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Data Handling - Bar Graph - Close"},"postlogin-class7-lessons-datahandling-probability-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Data Handling - Probability - Start"},"postlogin-class7-lessons-datahandling-probability-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Data Handling - Probability - Resume"},"postlogin-class7-lessons-datahandling-probability-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Data Handling - Probability - Watched"},"postlogin-class7-lessons-datahandling-probability-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Data Handling - Probability - Lessons"},"postlogin-class7-lessons-datahandling-probability-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Data Handling - Probability - Close"},"postlogin-class7-lessons-datahandling-moreonmeasuresofcentraltendency-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Data Handling - More on Measures of Central Tendency - Start"},"postlogin-class7-lessons-datahandling-moreonmeasuresofcentraltendency-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Data Handling - More on Measures of Central Tendency - Resume"},"postlogin-class7-lessons-datahandling-moreonmeasuresofcentraltendency-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Data Handling - More on Measures of Central Tendency - Watched"},"postlogin-class7-lessons-datahandling-moreonmeasuresofcentraltendency-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Data Handling - More on Measures of Central Tendency - Lessons"},"postlogin-class7-lessons-datahandling-moreonmeasuresofcentraltendency-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Data Handling - More on Measures of Central Tendency - Close"},"postlogin-class8-lessons-datahandling-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Data Handling - Start"},"postlogin-class8-lessons-datahandling-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Data Handling - Resume"},"postlogin-class8-lessons-datahandling-watched":{"event_label":"Rewatch topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Data Handling - Watched"},"postlogin-class8-lessons-datahandling-frequencytablesandpiegraphs-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Data Handling - Frequency Tables and Pie Graphs - Start"},"postlogin-class8-lessons-datahandling-frequencytablesandpiegraphs-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Data Handling - Frequency Tables and Pie Graphs - Resume"},"postlogin-class8-lessons-datahandling-frequencytablesandpiegraphs-watched":{"event_label":"Rewatch subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Data Handling - Frequency Tables and Pie Graphs - Watched"},"postlogin-class8-lessons-datahandling-frequencytablesandpiegraphs-lessons":{"event_label":"Class 8 lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Data Handling - Frequency Tables and Pie Graphs - Lessons"},"postlogin-class8-lessons-datahandling-frequencytablesandpiegraphs-close":{"event_label":"Close subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Data Handling - Frequency Tables and Pie Graphs - Close"},"postlogin-class8-lessons-datahandling-bargraphsandhistograms-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Data Handling - Bar Graphs and Histograms - Start"},"postlogin-class8-lessons-datahandling-bargraphsandhistograms-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Data Handling - Bar Graphs and Histograms - Resume"},"postlogin-class8-lessons-datahandling-bargraphsandhistograms-watched":{"event_label":"Rewatch subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Data Handling - Bar Graphs and Histograms - Watched"},"postlogin-class8-lessons-datahandling-bargraphsandhistograms-lessons":{"event_label":"Class 8 lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Data Handling - Bar Graphs and Histograms - Lessons"},"postlogin-class8-lessons-datahandling-bargraphsandhistograms-close":{"event_label":"Close subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Data Handling - Bar Graphs and Histograms - Close"},"postlogin-class8-lessons-datahandling-probability-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Data Handling - Probability - Start"},"postlogin-class8-lessons-datahandling-probability-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Data Handling - Probability - Resume"},"postlogin-class8-lessons-datahandling-probability-watched":{"event_label":"Rewatch subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Data Handling - Probability - Watched"},"postlogin-class8-lessons-datahandling-probability-lessons":{"event_label":"Class 8 lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Data Handling - Probability - Lessons"},"postlogin-class8-lessons-datahandling-probability-close":{"event_label":"Close subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Data Handling - Probability - Close"},"postlogin-class9-lessons-geometry-start":{"event_label":"Start topic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons - Geometry - Start"},"postlogin-class9-lessons-geometry-resume":{"event_label":"Resume topic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons - Geometry - Resume"},"postlogin-class9-lessons-geometry-watched":{"event_label":"Rewatch topic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons - Geometry - Watched"},"postlogin-class9-lessons-geometry-euclidsgeometry-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Euclids Geometry - Start"},"postlogin-class9-lessons-geometry-euclidsgeometry-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Euclids Geometry - Resume"},"postlogin-class9-lessons-geometry-euclidsgeometry-watched":{"event_label":"Rewatch subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Euclids Geometry - Watched"},"postlogin-class9-lessons-geometry-euclidsgeometry-lessons":{"event_label":"Class 9 lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Euclids Geometry - Lessons"},"postlogin-class9-lessons-geometry-euclidsgeometry-close":{"event_label":"Close subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Euclids Geometry - Close"},"postlogin-class9-lessons-geometry-linesandangles-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Lines and Angles - Start"},"postlogin-class9-lessons-geometry-linesandangles-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Lines and Angles - Resume"},"postlogin-class9-lessons-geometry-linesandangles-watched":{"event_label":"Rewatch subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Lines and Angles - Watched"},"postlogin-class9-lessons-geometry-linesandangles-lessons":{"event_label":"Class 9 lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Lines and Angles - Lessons"},"postlogin-class9-lessons-geometry-linesandangles-close":{"event_label":"Close subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Lines and Angles - Close"},"postlogin-class9-lessons-geometry-triangles-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Triangles - Start"},"postlogin-class9-lessons-geometry-triangles-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Triangles - Resume"},"postlogin-class9-lessons-geometry-triangles-watched":{"event_label":"Rewatch subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Triangles - Watched"},"postlogin-class9-lessons-geometry-triangles-lessons":{"event_label":"Class 9 lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Triangles - Lessons"},"postlogin-class9-lessons-geometry-triangles-close":{"event_label":"Close subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Triangles - Close"},"postlogin-class9-lessons-geometry-quadrilaterals-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Quadrilaterals - Start"},"postlogin-class9-lessons-geometry-quadrilaterals-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Quadrilaterals - Resume"},"postlogin-class9-lessons-geometry-quadrilaterals-watched":{"event_label":"Rewatch subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Quadrilaterals - Watched"},"postlogin-class9-lessons-geometry-quadrilaterals-lessons":{"event_label":"Class 9 lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Quadrilaterals - Lessons"},"postlogin-class9-lessons-geometry-quadrilaterals-close":{"event_label":"Close subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Quadrilaterals - Close"},"postlogin-class9-lessons-geometry-parallelogramsandtriangles-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Parallelograms and Triangles - Start"},"postlogin-class9-lessons-geometry-parallelogramsandtriangles-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Parallelograms and Triangles - Resume"},"postlogin-class9-lessons-geometry-parallelogramsandtriangles-watched":{"event_label":"Rewatch subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Parallelograms and Triangles - Watched"},"postlogin-class9-lessons-geometry-parallelogramsandtriangles-lessons":{"event_label":"Class 9 lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Parallelograms and Triangles - Lessons"},"postlogin-class9-lessons-geometry-parallelogramsandtriangles-close":{"event_label":"Close subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Parallelograms and Triangles - Close"},"postlogin-class9-lessons-geometry-circles-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Circles - Start"},"postlogin-class9-lessons-geometry-circles-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Circles - Resume"},"postlogin-class9-lessons-geometry-circles-watched":{"event_label":"Rewatch subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Circles - Watched"},"postlogin-class9-lessons-geometry-circles-lessons":{"event_label":"Class 9 lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Circles - Lessons"},"postlogin-class9-lessons-geometry-circles-close":{"event_label":"Close subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Circles - Close"},"postlogin-class9-lessons-geometry-geometricalconstructions-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Geometrical Constructions - Start"},"postlogin-class9-lessons-geometry-geometricalconstructions-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Geometrical Constructions - Resume"},"postlogin-class9-lessons-geometry-geometricalconstructions-watched":{"event_label":"Rewatch subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Geometrical Constructions - Watched"},"postlogin-class9-lessons-geometry-geometricalconstructions-lessons":{"event_label":"Class 9 lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Geometrical Constructions - Lessons"},"postlogin-class9-lessons-geometry-geometricalconstructions-close":{"event_label":"Close subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Geometry - Geometrical Constructions - Close"},"postlogin-class10-lessons-geometry-start":{"event_label":"Start topic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons - Geometry - Start"},"postlogin-class10-lessons-geometry-resume":{"event_label":"Resume topic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons - Geometry - Resume"},"postlogin-class10-lessons-geometry-watched":{"event_label":"Rewatch topic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons - Geometry - Watched"},"postlogin-class10-lessons-geometry-triangles-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Geometry - Triangles - Start"},"postlogin-class10-lessons-geometry-triangles-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Geometry - Triangles - Resume"},"postlogin-class10-lessons-geometry-triangles-watched":{"event_label":"Rewatch subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Geometry - Triangles - Watched"},"postlogin-class10-lessons-geometry-triangles-lessons":{"event_label":"Class 10 lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Geometry - Triangles - Lessons"},"postlogin-class10-lessons-geometry-triangles-close":{"event_label":"Close subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Geometry - Triangles - Close"},"postlogin-class10-lessons-geometry-circles-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Geometry - Circles - Start"},"postlogin-class10-lessons-geometry-circles-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Geometry - Circles - Resume"},"postlogin-class10-lessons-geometry-circles-watched":{"event_label":"Rewatch subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Geometry - Circles - Watched"},"postlogin-class10-lessons-geometry-circles-lessons":{"event_label":"Class 10 lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Geometry - Circles - Lessons"},"postlogin-class10-lessons-geometry-circles-close":{"event_label":"Close subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Geometry - Circles - Close"},"postlogin-class10-lessons-geometry-constructions-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Geometry - Constructions - Start"},"postlogin-class10-lessons-geometry-constructions-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Geometry - Constructions - Resume"},"postlogin-class10-lessons-geometry-constructions-watched":{"event_label":"Rewatch subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Geometry - Constructions - Watched"},"postlogin-class10-lessons-geometry-constructions-lessons":{"event_label":"Class 10 lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Geometry - Constructions - Lessons"},"postlogin-class10-lessons-geometry-constructions-close":{"event_label":"Close subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Geometry - Constructions - Close"},"postlogin-class5-tests-factorsandmultiples-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Start"},"postlogin-class5-tests-factorsandmultiples-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Resume"},"postlogin-class5-tests-factorsandmultiples-revise":{"event_label":"Revise topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Revise"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - PT - Start"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - PT - Resume"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - PT - Report"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - PT - Start - Start Test"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - PT - Close"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - PT - Resume - Continue Test"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - PT - Test - Close"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - PT - Test - Submit Test"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - PT - Scorecard - View Solutions"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - CP - Start"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - CP - Start - Start Practice"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - CP - Start - Close"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - CP - Start - Start Practice - Close"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - CP - Start - Start Practice - Check"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - CP - Resume"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - CP - Resume - Continue"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - CP - Resume - Close"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - CP - Resume - Continue - Close"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - CP - Resume - Continue - Check"},"postlogin-class5-tests-factorsandmultiples-primefactorsandtestsofdivisibility-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Prime Factors and Tests of Divisibility - CP - Report"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - PT - Start"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - PT - Resume"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - PT - Report"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - PT - Start - Start Test"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - PT - Close"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - PT - Resume - Continue Test"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - PT - Test - Close"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - PT - Test - Submit Test"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - PT - Scorecard - View Solutions"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - CP - Start"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - CP - Start - Start Practice"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - CP - Start - Close"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - CP - Start - Start Practice - Close"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - CP - Start - Start Practice - Check"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - CP - Resume"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - CP - Resume - Continue"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - CP - Resume - Close"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - CP - Resume - Continue - Close"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - CP - Resume - Continue - Check"},"postlogin-class5-tests-factorsandmultiples-hcfandlcm-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - HCF and LCM - CP - Report"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - PT - Start"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - PT - Resume"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - PT - Report"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - PT - Start - Start Test"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - PT - Close"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - PT - Resume - Continue Test"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - PT - Test - Close"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - PT - Test - Submit Test"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - PT - Scorecard - View Solutions"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - CP - Start"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - CP - Start - Start Practice"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - CP - Start - Close"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - CP - Start - Start Practice - Close"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - CP - Start - Start Practice - Check"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - CP - Resume"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - CP - Resume - Continue"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - CP - Resume - Close"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - CP - Resume - Continue - Close"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - CP - Resume - Continue - Check"},"postlogin-class5-tests-factorsandmultiples-applicationproblems-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Factors and Multiples - Application Problems - CP - Report"},"postlogin-class6-tests-basicgoemetricalideas-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Start"},"postlogin-class6-tests-basicgoemetricalideas-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Resume"},"postlogin-class6-tests-basicgoemetricalideas-revise":{"event_label":"Revise topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Revise"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - PT - Start"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - PT - Resume"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - PT - Report"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - PT - Start - Start Test"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - PT - Close"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - PT - Resume - Continue Test"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - PT - Test - Close"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - PT - Test - Submit Test"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - PT - Scorecard - View Solutions"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - CP - Start"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - CP - Start - Start Practice"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - CP - Start - Close"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - CP - Start - Start Practice - Close"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - CP - Start - Start Practice - Check"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - CP - Resume"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - CP - Resume - Continue"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - CP - Resume - Close"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - CP - Resume - Continue - Close"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - CP - Resume - Continue - Check"},"postlogin-class6-tests-basicgoemetricalideas-points,linesandangles-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Points, Lines and Angles - CP - Report"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - PT - Start"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - PT - Resume"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - PT - Report"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - PT - Start - Start Test"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - PT - Close"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - PT - Resume - Continue Test"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - PT - Test - Close"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - PT - Test - Submit Test"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - PT - Scorecard - View Solutions"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - CP - Start"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - CP - Start - Start Practice"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - CP - Start - Close"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - CP - Start - Start Practice - Close"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - CP - Start - Start Practice - Check"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - CP - Resume"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - CP - Resume - Continue"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - CP - Resume - Close"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - CP - Resume - Continue - Close"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - CP - Resume - Continue - Check"},"postlogin-class6-tests-basicgoemetricalideas-circlesandquadrilaterals-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Basic Goemetrical Ideas - Circles and Quadrilaterals - CP - Report"},"postlogin-class7-tests-datahandling-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Start"},"postlogin-class7-tests-datahandling-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Resume"},"postlogin-class7-tests-datahandling-revise":{"event_label":"Revise topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Revise"},"postlogin-class7-tests-datahandling-measureofcentraltendency-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - PT - Start"},"postlogin-class7-tests-datahandling-measureofcentraltendency-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - PT - Resume"},"postlogin-class7-tests-datahandling-measureofcentraltendency-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - PT - Report"},"postlogin-class7-tests-datahandling-measureofcentraltendency-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - PT - Start - Start Test"},"postlogin-class7-tests-datahandling-measureofcentraltendency-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - PT - Close"},"postlogin-class7-tests-datahandling-measureofcentraltendency-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - PT - Resume - Continue Test"},"postlogin-class7-tests-datahandling-measureofcentraltendency-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - PT - Test - Close"},"postlogin-class7-tests-datahandling-measureofcentraltendency-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - PT - Test - Submit Test"},"postlogin-class7-tests-datahandling-measureofcentraltendency-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - PT - Scorecard - View Solutions"},"postlogin-class7-tests-datahandling-measureofcentraltendency-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-datahandling-measureofcentraltendency-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-datahandling-measureofcentraltendency-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-datahandling-measureofcentraltendency-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-datahandling-measureofcentraltendency-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-datahandling-measureofcentraltendency-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-datahandling-measureofcentraltendency-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-datahandling-measureofcentraltendency-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-datahandling-measureofcentraltendency-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-datahandling-measureofcentraltendency-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-datahandling-measureofcentraltendency-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-datahandling-measureofcentraltendency-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-datahandling-measureofcentraltendency-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-datahandling-measureofcentraltendency-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-datahandling-measureofcentraltendency-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-datahandling-measureofcentraltendency-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - CP - Start"},"postlogin-class7-tests-datahandling-measureofcentraltendency-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - CP - Start - Start Practice"},"postlogin-class7-tests-datahandling-measureofcentraltendency-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - CP - Start - Close"},"postlogin-class7-tests-datahandling-measureofcentraltendency-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - CP - Start - Start Practice - Close"},"postlogin-class7-tests-datahandling-measureofcentraltendency-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - CP - Start - Start Practice - Check"},"postlogin-class7-tests-datahandling-measureofcentraltendency-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - CP - Resume"},"postlogin-class7-tests-datahandling-measureofcentraltendency-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - CP - Resume - Continue"},"postlogin-class7-tests-datahandling-measureofcentraltendency-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - CP - Resume - Close"},"postlogin-class7-tests-datahandling-measureofcentraltendency-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - CP - Resume - Continue - Close"},"postlogin-class7-tests-datahandling-measureofcentraltendency-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - CP - Resume - Continue - Check"},"postlogin-class7-tests-datahandling-measureofcentraltendency-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Measure of Central Tendency - CP - Report"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - PT - Start"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - PT - Resume"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - PT - Report"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - PT - Start - Start Test"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - PT - Close"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - PT - Resume - Continue Test"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - PT - Test - Close"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - PT - Test - Submit Test"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - PT - Scorecard - View Solutions"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - CP - Start"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - CP - Start - Start Practice"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - CP - Start - Close"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - CP - Start - Start Practice - Close"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - CP - Start - Start Practice - Check"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - CP - Resume"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - CP - Resume - Continue"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - CP - Resume - Close"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - CP - Resume - Continue - Close"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - CP - Resume - Continue - Check"},"postlogin-class7-tests-datahandling-moreonmeasuresofcentraltendency-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Measures of Central Tendency - CP - Report"},"postlogin-class7-tests-datahandling-bargraph-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - PT - Start"},"postlogin-class7-tests-datahandling-bargraph-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - PT - Resume"},"postlogin-class7-tests-datahandling-bargraph-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - PT - Report"},"postlogin-class7-tests-datahandling-bargraph-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - PT - Start - Start Test"},"postlogin-class7-tests-datahandling-bargraph-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - PT - Close"},"postlogin-class7-tests-datahandling-bargraph-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - PT - Resume - Continue Test"},"postlogin-class7-tests-datahandling-bargraph-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - PT - Test - Close"},"postlogin-class7-tests-datahandling-bargraph-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - PT - Test - Submit Test"},"postlogin-class7-tests-datahandling-bargraph-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - PT - Scorecard - View Solutions"},"postlogin-class7-tests-datahandling-bargraph-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-datahandling-bargraph-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-datahandling-bargraph-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-datahandling-bargraph-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-datahandling-bargraph-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-datahandling-bargraph-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-datahandling-bargraph-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-datahandling-bargraph-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-datahandling-bargraph-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-datahandling-bargraph-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-datahandling-bargraph-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-datahandling-bargraph-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-datahandling-bargraph-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-datahandling-bargraph-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-datahandling-bargraph-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-datahandling-bargraph-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - CP - Start"},"postlogin-class7-tests-datahandling-bargraph-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - CP - Start - Start Practice"},"postlogin-class7-tests-datahandling-bargraph-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - CP - Start - Close"},"postlogin-class7-tests-datahandling-bargraph-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - CP - Start - Start Practice - Close"},"postlogin-class7-tests-datahandling-bargraph-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - CP - Start - Start Practice - Check"},"postlogin-class7-tests-datahandling-bargraph-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - CP - Resume"},"postlogin-class7-tests-datahandling-bargraph-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - CP - Resume - Continue"},"postlogin-class7-tests-datahandling-bargraph-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - CP - Resume - Close"},"postlogin-class7-tests-datahandling-bargraph-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - CP - Resume - Continue - Close"},"postlogin-class7-tests-datahandling-bargraph-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - CP - Resume - Continue - Check"},"postlogin-class7-tests-datahandling-bargraph-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Bar Graph - CP - Report"},"postlogin-class7-tests-datahandling-moreonbargraphs-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - PT - Start"},"postlogin-class7-tests-datahandling-moreonbargraphs-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - PT - Resume"},"postlogin-class7-tests-datahandling-moreonbargraphs-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - PT - Report"},"postlogin-class7-tests-datahandling-moreonbargraphs-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - PT - Start - Start Test"},"postlogin-class7-tests-datahandling-moreonbargraphs-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - PT - Close"},"postlogin-class7-tests-datahandling-moreonbargraphs-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - PT - Resume - Continue Test"},"postlogin-class7-tests-datahandling-moreonbargraphs-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - PT - Test - Close"},"postlogin-class7-tests-datahandling-moreonbargraphs-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - PT - Test - Submit Test"},"postlogin-class7-tests-datahandling-moreonbargraphs-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - PT - Scorecard - View Solutions"},"postlogin-class7-tests-datahandling-moreonbargraphs-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-datahandling-moreonbargraphs-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-datahandling-moreonbargraphs-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-datahandling-moreonbargraphs-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-datahandling-moreonbargraphs-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-datahandling-moreonbargraphs-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-datahandling-moreonbargraphs-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-datahandling-moreonbargraphs-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-datahandling-moreonbargraphs-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-datahandling-moreonbargraphs-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-datahandling-moreonbargraphs-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-datahandling-moreonbargraphs-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-datahandling-moreonbargraphs-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-datahandling-moreonbargraphs-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-datahandling-moreonbargraphs-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-datahandling-moreonbargraphs-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - CP - Start"},"postlogin-class7-tests-datahandling-moreonbargraphs-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - CP - Start - Start Practice"},"postlogin-class7-tests-datahandling-moreonbargraphs-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - CP - Start - Close"},"postlogin-class7-tests-datahandling-moreonbargraphs-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - CP - Start - Start Practice - Close"},"postlogin-class7-tests-datahandling-moreonbargraphs-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - CP - Start - Start Practice - Check"},"postlogin-class7-tests-datahandling-moreonbargraphs-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - CP - Resume"},"postlogin-class7-tests-datahandling-moreonbargraphs-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - CP - Resume - Continue"},"postlogin-class7-tests-datahandling-moreonbargraphs-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - CP - Resume - Close"},"postlogin-class7-tests-datahandling-moreonbargraphs-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - CP - Resume - Continue - Close"},"postlogin-class7-tests-datahandling-moreonbargraphs-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - CP - Resume - Continue - Check"},"postlogin-class7-tests-datahandling-moreonbargraphs-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - More on Bar Graphs - CP - Report"},"postlogin-class7-tests-datahandling-probability-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - PT - Start"},"postlogin-class7-tests-datahandling-probability-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - PT - Resume"},"postlogin-class7-tests-datahandling-probability-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - PT - Report"},"postlogin-class7-tests-datahandling-probability-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - PT - Start - Start Test"},"postlogin-class7-tests-datahandling-probability-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - PT - Close"},"postlogin-class7-tests-datahandling-probability-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - PT - Resume - Continue Test"},"postlogin-class7-tests-datahandling-probability-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - PT - Test - Close"},"postlogin-class7-tests-datahandling-probability-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - PT - Test - Submit Test"},"postlogin-class7-tests-datahandling-probability-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - PT - Scorecard - View Solutions"},"postlogin-class7-tests-datahandling-probability-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-datahandling-probability-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-datahandling-probability-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-datahandling-probability-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-datahandling-probability-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-datahandling-probability-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-datahandling-probability-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-datahandling-probability-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-datahandling-probability-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-datahandling-probability-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-datahandling-probability-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-datahandling-probability-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-datahandling-probability-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-datahandling-probability-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-datahandling-probability-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-datahandling-probability-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - CP - Start"},"postlogin-class7-tests-datahandling-probability-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - CP - Start - Start Practice"},"postlogin-class7-tests-datahandling-probability-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - CP - Start - Close"},"postlogin-class7-tests-datahandling-probability-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - CP - Start - Start Practice - Close"},"postlogin-class7-tests-datahandling-probability-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - CP - Start - Start Practice - Check"},"postlogin-class7-tests-datahandling-probability-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - CP - Resume"},"postlogin-class7-tests-datahandling-probability-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - CP - Resume - Continue"},"postlogin-class7-tests-datahandling-probability-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - CP - Resume - Close"},"postlogin-class7-tests-datahandling-probability-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - CP - Resume - Continue - Close"},"postlogin-class7-tests-datahandling-probability-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - CP - Resume - Continue - Check"},"postlogin-class7-tests-datahandling-probability-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Data Handling - Probability - CP - Report"},"postlogin-class8-tests-datahandling-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Start"},"postlogin-class8-tests-datahandling-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Resume"},"postlogin-class8-tests-datahandling-revise":{"event_label":"Revise topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Revise"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - PT - Start"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - PT - Resume"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - PT - Report"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - PT - Start - Start Test"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - PT - Close"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - PT - Resume - Continue Test"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - PT - Test - Close"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - PT - Test - Submit Test"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - PT - Scorecard - View Solutions"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - CP - Start"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - CP - Start - Start Practice"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - CP - Start - Close"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - CP - Start - Start Practice - Close"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - CP - Start - Start Practice - Check"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - CP - Resume"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - CP - Resume - Continue"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - CP - Resume - Close"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - CP - Resume - Continue - Close"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - CP - Resume - Continue - Check"},"postlogin-class8-tests-datahandling-frequencytablesandpiegraphs-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Frequency Tables and Pie Graphs - CP - Report"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - PT - Start"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - PT - Resume"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - PT - Report"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - PT - Start - Start Test"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - PT - Close"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - PT - Resume - Continue Test"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - PT - Test - Close"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - PT - Test - Submit Test"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - PT - Scorecard - View Solutions"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - CP - Start"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - CP - Start - Start Practice"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - CP - Start - Close"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - CP - Start - Start Practice - Close"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - CP - Start - Start Practice - Check"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - CP - Resume"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - CP - Resume - Continue"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - CP - Resume - Close"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - CP - Resume - Continue - Close"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - CP - Resume - Continue - Check"},"postlogin-class8-tests-datahandling-bargraphsandhistograms-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Bar Graphs and Histograms - CP - Report"},"postlogin-class8-tests-datahandling-probability-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - PT - Start"},"postlogin-class8-tests-datahandling-probability-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - PT - Resume"},"postlogin-class8-tests-datahandling-probability-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - PT - Report"},"postlogin-class8-tests-datahandling-probability-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - PT - Start - Start Test"},"postlogin-class8-tests-datahandling-probability-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - PT - Close"},"postlogin-class8-tests-datahandling-probability-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - PT - Resume - Continue Test"},"postlogin-class8-tests-datahandling-probability-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - PT - Test - Close"},"postlogin-class8-tests-datahandling-probability-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - PT - Test - Submit Test"},"postlogin-class8-tests-datahandling-probability-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - PT - Scorecard - View Solutions"},"postlogin-class8-tests-datahandling-probability-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-datahandling-probability-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-datahandling-probability-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-datahandling-probability-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-datahandling-probability-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-datahandling-probability-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-datahandling-probability-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-datahandling-probability-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-datahandling-probability-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-datahandling-probability-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-datahandling-probability-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-datahandling-probability-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-datahandling-probability-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-datahandling-probability-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-datahandling-probability-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-datahandling-probability-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - CP - Start"},"postlogin-class8-tests-datahandling-probability-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - CP - Start - Start Practice"},"postlogin-class8-tests-datahandling-probability-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - CP - Start - Close"},"postlogin-class8-tests-datahandling-probability-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - CP - Start - Start Practice - Close"},"postlogin-class8-tests-datahandling-probability-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - CP - Start - Start Practice - Check"},"postlogin-class8-tests-datahandling-probability-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - CP - Resume"},"postlogin-class8-tests-datahandling-probability-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - CP - Resume - Continue"},"postlogin-class8-tests-datahandling-probability-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - CP - Resume - Close"},"postlogin-class8-tests-datahandling-probability-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - CP - Resume - Continue - Close"},"postlogin-class8-tests-datahandling-probability-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - CP - Resume - Continue - Check"},"postlogin-class8-tests-datahandling-probability-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Data Handling - Probability - CP - Report"},"postlogin-class9-tests-linesandangles-start":{"event_label":"Start topic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Start"},"postlogin-class9-tests-linesandangles-resume":{"event_label":"Resume topic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Resume"},"postlogin-class9-tests-linesandangles-revise":{"event_label":"Revise topic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Revise"},"postlogin-class9-tests-linesandangles-pairofangles-pt-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - PT - Start"},"postlogin-class9-tests-linesandangles-pairofangles-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - PT - Resume"},"postlogin-class9-tests-linesandangles-pairofangles-pt-report":{"event_label":"View report PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - PT - Report"},"postlogin-class9-tests-linesandangles-pairofangles-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - PT - Start - Start Test"},"postlogin-class9-tests-linesandangles-pairofangles-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - PT - Close"},"postlogin-class9-tests-linesandangles-pairofangles-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - PT - Resume - Continue Test"},"postlogin-class9-tests-linesandangles-pairofangles-pt-test-close":{"event_label":"Close PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - PT - Test - Close"},"postlogin-class9-tests-linesandangles-pairofangles-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - PT - Test - Submit Test"},"postlogin-class9-tests-linesandangles-pairofangles-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - PT - Scorecard - View Solutions"},"postlogin-class9-tests-linesandangles-pairofangles-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - PT - Scorecard - View Solutions - Close"},"postlogin-class9-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - PT - Scorecard - View Recommendations"},"postlogin-class9-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - PT - Scorecard - View Recommendations - Close"},"postlogin-class9-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class9-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class9-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class9-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class9-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class9-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class9-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class9-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class9-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class9-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class9-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class9-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class9-tests-linesandangles-pairofangles-cp-start":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - CP - Start"},"postlogin-class9-tests-linesandangles-pairofangles-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - CP - Start - Start Practice"},"postlogin-class9-tests-linesandangles-pairofangles-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - CP - Start - Close"},"postlogin-class9-tests-linesandangles-pairofangles-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - CP - Start - Start Practice - Close"},"postlogin-class9-tests-linesandangles-pairofangles-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - CP - Start - Start Practice - Check"},"postlogin-class9-tests-linesandangles-pairofangles-cp-resume":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - CP - Resume"},"postlogin-class9-tests-linesandangles-pairofangles-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - CP - Resume - Continue"},"postlogin-class9-tests-linesandangles-pairofangles-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - CP - Resume - Close"},"postlogin-class9-tests-linesandangles-pairofangles-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - CP - Resume - Continue - Close"},"postlogin-class9-tests-linesandangles-pairofangles-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - CP - Resume - Continue - Check"},"postlogin-class9-tests-linesandangles-pairofangles-cp-report":{"event_label":"View report CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Pair of angles - CP - Report"},"postlogin-class9-tests-linesandangles-anglesonparallellines-pt-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - PT - Start"},"postlogin-class9-tests-linesandangles-anglesonparallellines-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - PT - Resume"},"postlogin-class9-tests-linesandangles-anglesonparallellines-pt-report":{"event_label":"View report PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - PT - Report"},"postlogin-class9-tests-linesandangles-anglesonparallellines-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - PT - Start - Start Test"},"postlogin-class9-tests-linesandangles-anglesonparallellines-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - PT - Close"},"postlogin-class9-tests-linesandangles-anglesonparallellines-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - PT - Resume - Continue Test"},"postlogin-class9-tests-linesandangles-anglesonparallellines-pt-test-close":{"event_label":"Close PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - PT - Test - Close"},"postlogin-class9-tests-linesandangles-anglesonparallellines-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - PT - Test - Submit Test"},"postlogin-class9-tests-linesandangles-anglesonparallellines-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - PT - Scorecard - View Solutions"},"postlogin-class9-tests-linesandangles-anglesonparallellines-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - PT - Scorecard - View Solutions - Close"},"postlogin-class9-tests-linesandangles-anglesonparallellines-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - PT - Scorecard - View Recommendations"},"postlogin-class9-tests-linesandangles-anglesonparallellines-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - PT - Scorecard - View Recommendations - Close"},"postlogin-class9-tests-linesandangles-anglesonparallellines-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class9-tests-linesandangles-anglesonparallellines-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class9-tests-linesandangles-anglesonparallellines-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class9-tests-linesandangles-anglesonparallellines-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class9-tests-linesandangles-anglesonparallellines-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class9-tests-linesandangles-anglesonparallellines-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class9-tests-linesandangles-anglesonparallellines-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class9-tests-linesandangles-anglesonparallellines-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class9-tests-linesandangles-anglesonparallellines-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class9-tests-linesandangles-anglesonparallellines-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class9-tests-linesandangles-anglesonparallellines-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class9-tests-linesandangles-anglesonparallellines-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class9-tests-linesandangles-anglesonparallellines-cp-start":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - CP - Start"},"postlogin-class9-tests-linesandangles-anglesonparallellines-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - CP - Start - Start Practice"},"postlogin-class9-tests-linesandangles-anglesonparallellines-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - CP - Start - Close"},"postlogin-class9-tests-linesandangles-anglesonparallellines-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - CP - Start - Start Practice - Close"},"postlogin-class9-tests-linesandangles-anglesonparallellines-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - CP - Start - Start Practice - Check"},"postlogin-class9-tests-linesandangles-anglesonparallellines-cp-resume":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - CP - Resume"},"postlogin-class9-tests-linesandangles-anglesonparallellines-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - CP - Resume - Continue"},"postlogin-class9-tests-linesandangles-anglesonparallellines-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - CP - Resume - Close"},"postlogin-class9-tests-linesandangles-anglesonparallellines-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - CP - Resume - Continue - Close"},"postlogin-class9-tests-linesandangles-anglesonparallellines-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - CP - Resume - Continue - Check"},"postlogin-class9-tests-linesandangles-anglesonparallellines-cp-report":{"event_label":"View report CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angles on parallel lines - CP - Report"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-pt-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - PT - Start"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - PT - Resume"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-pt-report":{"event_label":"View report PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - PT - Report"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - PT - Start - Start Test"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - PT - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - PT - Resume - Continue Test"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-pt-test-close":{"event_label":"Close PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - PT - Test - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - PT - Test - Submit Test"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - PT - Scorecard - View Solutions"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - PT - Scorecard - View Solutions - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - PT - Scorecard - View Recommendations"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - PT - Scorecard - View Recommendations - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-cp-start":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - CP - Start"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - CP - Start - Start Practice"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - CP - Start - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - CP - Start - Start Practice - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - CP - Start - Start Practice - Check"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-cp-resume":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - CP - Resume"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - CP - Resume - Continue"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - CP - Resume - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - CP - Resume - Continue - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - CP - Resume - Continue - Check"},"postlogin-class9-tests-linesandangles-anglepropertiesofatrianglei-cp-report":{"event_label":"View report CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle I - CP - Report"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-pt-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - PT - Start"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - PT - Resume"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-pt-report":{"event_label":"View report PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - PT - Report"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - PT - Start - Start Test"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - PT - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - PT - Resume - Continue Test"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-pt-test-close":{"event_label":"Close PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - PT - Test - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - PT - Test - Submit Test"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - PT - Scorecard - View Solutions"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - PT - Scorecard - View Solutions - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - PT - Scorecard - View Recommendations"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - PT - Scorecard - View Recommendations - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-cp-start":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - CP - Start"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - CP - Start - Start Practice"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - CP - Start - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - CP - Start - Start Practice - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - CP - Start - Start Practice - Check"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-cp-resume":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - CP - Resume"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - CP - Resume - Continue"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - CP - Resume - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - CP - Resume - Continue - Close"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - CP - Resume - Continue - Check"},"postlogin-class9-tests-linesandangles-anglepropertiesofatriangleii-cp-report":{"event_label":"View report CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Lines and Angles - Angle properties of a triangle II - CP - Report"},"postlogin-class10-tests-arithmeticprogression-start":{"event_label":"Start topic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Start"},"postlogin-class10-tests-arithmeticprogression-resume":{"event_label":"Resume topic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Resume"},"postlogin-class10-tests-arithmeticprogression-revise":{"event_label":"Revise topic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Revise"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - PT - Start"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - PT - Resume"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - PT - Report"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - PT - Start - Start Test"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - PT - Close"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - PT - Resume - Continue Test"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - PT - Test - Close"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - PT - Test - Submit Test"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - PT - Scorecard - View Solutions"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - CP - Start"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - CP - Start - Start Practice"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - CP - Start - Close"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - CP - Start - Start Practice - Close"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - CP - Start - Start Practice - Check"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - CP - Resume"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - CP - Resume - Continue"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - CP - Resume - Close"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - CP - Resume - Continue - Close"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - CP - Resume - Continue - Check"},"postlogin-class10-tests-arithmeticprogression-nthtermofanap-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Nth term of an AP - CP - Report"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - PT - Start"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - PT - Resume"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - PT - Report"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - PT - Start - Start Test"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - PT - Close"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - PT - Resume - Continue Test"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - PT - Test - Close"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - PT - Test - Submit Test"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - PT - Scorecard - View Solutions"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - CP - Start"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - CP - Start - Start Practice"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - CP - Start - Close"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - CP - Start - Start Practice - Close"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - CP - Start - Start Practice - Check"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - CP - Resume"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - CP - Resume - Continue"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - CP - Resume - Close"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - CP - Resume - Continue - Close"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - CP - Resume - Continue - Check"},"postlogin-class10-tests-arithmeticprogression-moreonnthofanap-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on nth of an AP - CP - Report"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - PT - Start"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - PT - Resume"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - PT - Report"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - PT - Start - Start Test"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - PT - Close"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - PT - Resume - Continue Test"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - PT - Test - Close"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - PT - Test - Submit Test"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - PT - Scorecard - View Solutions"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - CP - Start"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - CP - Start - Start Practice"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - CP - Start - Close"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - CP - Start - Start Practice - Close"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - CP - Start - Start Practice - Check"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - CP - Resume"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - CP - Resume - Continue"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - CP - Resume - Close"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - CP - Resume - Continue - Close"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - CP - Resume - Continue - Check"},"postlogin-class10-tests-arithmeticprogression-sumofntermsofanap-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - Sum of n terms of an AP - CP - Report"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - PT - Start"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - PT - Resume"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - PT - Report"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - PT - Start - Start Test"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - PT - Close"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - PT - Resume - Continue Test"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - PT - Test - Close"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - PT - Test - Submit Test"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - PT - Scorecard - View Solutions"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - CP - Start"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - CP - Start - Start Practice"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - CP - Start - Close"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - CP - Start - Start Practice - Close"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - CP - Start - Start Practice - Check"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - CP - Resume"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - CP - Resume - Continue"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - CP - Resume - Close"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - CP - Resume - Continue - Close"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - CP - Resume - Continue - Check"},"postlogin-class10-tests-arithmeticprogression-moreonsumofntermsofanap-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Arithmetic Progression - More on sum of n terms of an AP - CP - Report"},"postlogin-class1-lessons-money-start":{"event_label":"Start topic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons - Money - Start"},"postlogin-class1-lessons-money-resume":{"event_label":"Resume topic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons - Money - Resume"},"postlogin-class1-lessons-money-watched":{"event_label":"Rewatch topic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons - Money - Watched"},"postlogin-class1-lessons-money-introducingmoney-start":{"event_label":"Start subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Money - Introducing Money - Start"},"postlogin-class1-lessons-money-introducingmoney-resume":{"event_label":"Resume subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Money - Introducing Money - Resume"},"postlogin-class1-lessons-money-introducingmoney-watched":{"event_label":"Rewatch subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Money - Introducing Money - Watched"},"postlogin-class1-lessons-money-introducingmoney-lessons":{"event_label":"Class 1 lessons","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Money - Introducing Money - Lessons"},"postlogin-class1-lessons-money-introducingmoney-close":{"event_label":"Close subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Money - Introducing Money - Close"},"postlogin-class2-lessons-shapesandpatterns-start":{"event_label":"Start topic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons - Shapes and Patterns - Start"},"postlogin-class2-lessons-shapesandpatterns-resume":{"event_label":"Resume topic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons - Shapes and Patterns - Resume"},"postlogin-class2-lessons-shapesandpatterns-watched":{"event_label":"Rewatch topic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons - Shapes and Patterns - Watched"},"postlogin-class2-lessons-shapesandpatterns-shapes-start":{"event_label":"Start subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Shapes and Patterns - Shapes - Start"},"postlogin-class2-lessons-shapesandpatterns-shapes-resume":{"event_label":"Resume subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Shapes and Patterns - Shapes - Resume"},"postlogin-class2-lessons-shapesandpatterns-shapes-watched":{"event_label":"Rewatch subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Shapes and Patterns - Shapes - Watched"},"postlogin-class2-lessons-shapesandpatterns-shapes-lessons":{"event_label":"Class 2 lessons","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Shapes and Patterns - Shapes - Lessons"},"postlogin-class2-lessons-shapesandpatterns-shapes-close":{"event_label":"Close subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Shapes and Patterns - Shapes - Close"},"postlogin-class2-lessons-shapesandpatterns-patternsandmaps-start":{"event_label":"Start subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Shapes and Patterns - Patterns and Maps - Start"},"postlogin-class2-lessons-shapesandpatterns-patternsandmaps-resume":{"event_label":"Resume subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Shapes and Patterns - Patterns and Maps - Resume"},"postlogin-class2-lessons-shapesandpatterns-patternsandmaps-watched":{"event_label":"Rewatch subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Shapes and Patterns - Patterns and Maps - Watched"},"postlogin-class2-lessons-shapesandpatterns-patternsandmaps-lessons":{"event_label":"Class 2 lessons","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Shapes and Patterns - Patterns and Maps - Lessons"},"postlogin-class2-lessons-shapesandpatterns-patternsandmaps-close":{"event_label":"Close subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Shapes and Patterns - Patterns and Maps - Close"},"postlogin-class3-lessons-geometry-start":{"event_label":"Start topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Geometry - Start"},"postlogin-class3-lessons-geometry-resume":{"event_label":"Resume topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Geometry - Resume"},"postlogin-class3-lessons-geometry-watched":{"event_label":"Rewatch topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Geometry - Watched"},"postlogin-class3-lessons-geometry-space,shapeandpatterns-start":{"event_label":"Start subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Geometry - Space, Shape and Patterns - Start"},"postlogin-class3-lessons-geometry-space,shapeandpatterns-resume":{"event_label":"Resume subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Geometry - Space, Shape and Patterns - Resume"},"postlogin-class3-lessons-geometry-space,shapeandpatterns-watched":{"event_label":"Rewatch subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Geometry - Space, Shape and Patterns - Watched"},"postlogin-class3-lessons-geometry-space,shapeandpatterns-lessons":{"event_label":"Class 3 lessons","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Geometry - Space, Shape and Patterns - Lessons"},"postlogin-class3-lessons-geometry-space,shapeandpatterns-close":{"event_label":"Close subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Geometry - Space, Shape and Patterns - Close"},"postlogin-class4-lessons-factorsandmultiples-start":{"event_label":"Start topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Factors and Multiples - Start"},"postlogin-class4-lessons-factorsandmultiples-resume":{"event_label":"Resume topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Factors and Multiples - Resume"},"postlogin-class4-lessons-factorsandmultiples-watched":{"event_label":"Rewatch topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Factors and Multiples - Watched"},"postlogin-class4-lessons-factorsandmultiples-factors-start":{"event_label":"Start subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Factors and Multiples - Factors - Start"},"postlogin-class4-lessons-factorsandmultiples-factors-resume":{"event_label":"Resume subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Factors and Multiples - Factors - Resume"},"postlogin-class4-lessons-factorsandmultiples-factors-watched":{"event_label":"Rewatch subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Factors and Multiples - Factors - Watched"},"postlogin-class4-lessons-factorsandmultiples-factors-lessons":{"event_label":"Class 4 lessons","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Factors and Multiples - Factors - Lessons"},"postlogin-class4-lessons-factorsandmultiples-factors-close":{"event_label":"Close subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Factors and Multiples - Factors - Close"},"postlogin-class4-lessons-factorsandmultiples-multiples-start":{"event_label":"Start subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Factors and Multiples - Multiples - Start"},"postlogin-class4-lessons-factorsandmultiples-multiples-resume":{"event_label":"Resume subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Factors and Multiples - Multiples - Resume"},"postlogin-class4-lessons-factorsandmultiples-multiples-watched":{"event_label":"Rewatch subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Factors and Multiples - Multiples - Watched"},"postlogin-class4-lessons-factorsandmultiples-multiples-lessons":{"event_label":"Class 4 lessons","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Factors and Multiples - Multiples - Lessons"},"postlogin-class4-lessons-factorsandmultiples-multiples-close":{"event_label":"Close subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Factors and Multiples - Multiples - Close"},"postlogin-class5-lessons-fractions-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Fractions - Start"},"postlogin-class5-lessons-fractions-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Fractions - Resume"},"postlogin-class5-lessons-fractions-watched":{"event_label":"Rewatch topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Fractions - Watched"},"postlogin-class5-lessons-fractions-introductiontofractions-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Fractions - Introduction to Fractions - Start"},"postlogin-class5-lessons-fractions-introductiontofractions-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Fractions - Introduction to Fractions - Resume"},"postlogin-class5-lessons-fractions-introductiontofractions-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Fractions - Introduction to Fractions - Watched"},"postlogin-class5-lessons-fractions-introductiontofractions-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Fractions - Introduction to Fractions - Lessons"},"postlogin-class5-lessons-fractions-introductiontofractions-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Fractions - Introduction to Fractions - Close"},"postlogin-class5-lessons-fractions-additionandsubtractionoffractions-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Fractions - Addition and Subtraction of Fractions - Start"},"postlogin-class5-lessons-fractions-additionandsubtractionoffractions-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Fractions - Addition and Subtraction of Fractions - Resume"},"postlogin-class5-lessons-fractions-additionandsubtractionoffractions-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Fractions - Addition and Subtraction of Fractions - Watched"},"postlogin-class5-lessons-fractions-additionandsubtractionoffractions-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Fractions - Addition and Subtraction of Fractions - Lessons"},"postlogin-class5-lessons-fractions-additionandsubtractionoffractions-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Fractions - Addition and Subtraction of Fractions - Close"},"postlogin-class5-lessons-fractions-multiplicationanddivisionoffractions-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Fractions - Multiplication and Division of Fractions - Start"},"postlogin-class5-lessons-fractions-multiplicationanddivisionoffractions-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Fractions - Multiplication and Division of Fractions - Resume"},"postlogin-class5-lessons-fractions-multiplicationanddivisionoffractions-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Fractions - Multiplication and Division of Fractions - Watched"},"postlogin-class5-lessons-fractions-multiplicationanddivisionoffractions-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Fractions - Multiplication and Division of Fractions - Lessons"},"postlogin-class5-lessons-fractions-multiplicationanddivisionoffractions-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Fractions - Multiplication and Division of Fractions - Close"},"postlogin-class5-lessons-fractions-applicationproblems-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Fractions - Application Problems - Start"},"postlogin-class5-lessons-fractions-applicationproblems-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Fractions - Application Problems - Resume"},"postlogin-class5-lessons-fractions-applicationproblems-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Fractions - Application Problems - Watched"},"postlogin-class5-lessons-fractions-applicationproblems-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Fractions - Application Problems - Lessons"},"postlogin-class5-lessons-fractions-applicationproblems-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Fractions - Application Problems - Close"},"postlogin-class6-lessons-understandingelementaryshapes-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Understanding Elementary Shapes - Start"},"postlogin-class6-lessons-understandingelementaryshapes-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Understanding Elementary Shapes - Resume"},"postlogin-class6-lessons-understandingelementaryshapes-watched":{"event_label":"Rewatch topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Understanding Elementary Shapes - Watched"},"postlogin-class6-lessons-understandingelementaryshapes-measuringangles-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Understanding Elementary Shapes - Measuring Angles - Start"},"postlogin-class6-lessons-understandingelementaryshapes-measuringangles-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Understanding Elementary Shapes - Measuring Angles - Resume"},"postlogin-class6-lessons-understandingelementaryshapes-measuringangles-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Understanding Elementary Shapes - Measuring Angles - Watched"},"postlogin-class6-lessons-understandingelementaryshapes-measuringangles-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Understanding Elementary Shapes - Measuring Angles - Lessons"},"postlogin-class6-lessons-understandingelementaryshapes-measuringangles-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Understanding Elementary Shapes - Measuring Angles - Close"},"postlogin-class6-lessons-understandingelementaryshapes-typesoftriangles-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Understanding Elementary Shapes - Types of Triangles - Start"},"postlogin-class6-lessons-understandingelementaryshapes-typesoftriangles-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Understanding Elementary Shapes - Types of Triangles - Resume"},"postlogin-class6-lessons-understandingelementaryshapes-typesoftriangles-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Understanding Elementary Shapes - Types of Triangles - Watched"},"postlogin-class6-lessons-understandingelementaryshapes-typesoftriangles-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Understanding Elementary Shapes - Types of Triangles - Lessons"},"postlogin-class6-lessons-understandingelementaryshapes-typesoftriangles-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Understanding Elementary Shapes - Types of Triangles - Close"},"postlogin-class6-lessons-understandingelementaryshapes-typesofquadrilaterals-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Understanding Elementary Shapes - Types of Quadrilaterals - Start"},"postlogin-class6-lessons-understandingelementaryshapes-typesofquadrilaterals-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Understanding Elementary Shapes - Types of Quadrilaterals - Resume"},"postlogin-class6-lessons-understandingelementaryshapes-typesofquadrilaterals-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Understanding Elementary Shapes - Types of Quadrilaterals - Watched"},"postlogin-class6-lessons-understandingelementaryshapes-typesofquadrilaterals-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Understanding Elementary Shapes - Types of Quadrilaterals - Lessons"},"postlogin-class6-lessons-understandingelementaryshapes-typesofquadrilaterals-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Understanding Elementary Shapes - Types of Quadrilaterals - Close"},"postlogin-class6-lessons-understandingelementaryshapes-typesofpolygons-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Understanding Elementary Shapes - Types of Polygons - Start"},"postlogin-class6-lessons-understandingelementaryshapes-typesofpolygons-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Understanding Elementary Shapes - Types of Polygons - Resume"},"postlogin-class6-lessons-understandingelementaryshapes-typesofpolygons-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Understanding Elementary Shapes - Types of Polygons - Watched"},"postlogin-class6-lessons-understandingelementaryshapes-typesofpolygons-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Understanding Elementary Shapes - Types of Polygons - Lessons"},"postlogin-class6-lessons-understandingelementaryshapes-typesofpolygons-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Understanding Elementary Shapes - Types of Polygons - Close"},"postlogin-class6-lessons-understandingelementaryshapes-threedimensionalshapes-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Understanding Elementary Shapes - Three Dimensional Shapes - Start"},"postlogin-class6-lessons-understandingelementaryshapes-threedimensionalshapes-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Understanding Elementary Shapes - Three Dimensional Shapes - Resume"},"postlogin-class6-lessons-understandingelementaryshapes-threedimensionalshapes-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Understanding Elementary Shapes - Three Dimensional Shapes - Watched"},"postlogin-class6-lessons-understandingelementaryshapes-threedimensionalshapes-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Understanding Elementary Shapes - Three Dimensional Shapes - Lessons"},"postlogin-class6-lessons-understandingelementaryshapes-threedimensionalshapes-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Understanding Elementary Shapes - Three Dimensional Shapes - Close"},"postlogin-class7-lessons-linearequationsinonevariable-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Linear Equations in one variable - Start"},"postlogin-class7-lessons-linearequationsinonevariable-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Linear Equations in one variable - Resume"},"postlogin-class7-lessons-linearequationsinonevariable-watched":{"event_label":"Rewatch topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Linear Equations in one variable - Watched"},"postlogin-class7-lessons-linearequationsinonevariable-writingandsolvinglinearequations-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Linear Equations in one variable - Writing and Solving Linear Equations - Start"},"postlogin-class7-lessons-linearequationsinonevariable-writingandsolvinglinearequations-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Linear Equations in one variable - Writing and Solving Linear Equations - Resume"},"postlogin-class7-lessons-linearequationsinonevariable-writingandsolvinglinearequations-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Linear Equations in one variable - Writing and Solving Linear Equations - Watched"},"postlogin-class7-lessons-linearequationsinonevariable-writingandsolvinglinearequations-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Linear Equations in one variable - Writing and Solving Linear Equations - Lessons"},"postlogin-class7-lessons-linearequationsinonevariable-writingandsolvinglinearequations-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Linear Equations in one variable - Writing and Solving Linear Equations - Close"},"postlogin-class8-lessons-squaresandsquareroots-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Squares and Square Roots - Start"},"postlogin-class8-lessons-squaresandsquareroots-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Squares and Square Roots - Resume"},"postlogin-class8-lessons-squaresandsquareroots-watched":{"event_label":"Rewatch topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Squares and Square Roots - Watched"},"postlogin-class8-lessons-squaresandsquareroots-squaresandsquareroots-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Squares and Square Roots - Squares and Square Roots - Start"},"postlogin-class8-lessons-squaresandsquareroots-squaresandsquareroots-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Squares and Square Roots - Squares and Square Roots - Resume"},"postlogin-class8-lessons-squaresandsquareroots-squaresandsquareroots-watched":{"event_label":"Rewatch subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Squares and Square Roots - Squares and Square Roots - Watched"},"postlogin-class8-lessons-squaresandsquareroots-squaresandsquareroots-lessons":{"event_label":"Class 8 lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Squares and Square Roots - Squares and Square Roots - Lessons"},"postlogin-class8-lessons-squaresandsquareroots-squaresandsquareroots-close":{"event_label":"Close subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Squares and Square Roots - Squares and Square Roots - Close"},"postlogin-class9-lessons-mensuration-start":{"event_label":"Start topic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons - Mensuration - Start"},"postlogin-class9-lessons-mensuration-resume":{"event_label":"Resume topic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons - Mensuration - Resume"},"postlogin-class9-lessons-mensuration-watched":{"event_label":"Rewatch topic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons - Mensuration - Watched"},"postlogin-class9-lessons-mensuration-areaoftriangles-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Mensuration - Area of Triangles - Start"},"postlogin-class9-lessons-mensuration-areaoftriangles-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Mensuration - Area of Triangles - Resume"},"postlogin-class9-lessons-mensuration-areaoftriangles-watched":{"event_label":"Rewatch subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Mensuration - Area of Triangles - Watched"},"postlogin-class9-lessons-mensuration-areaoftriangles-lessons":{"event_label":"Class 9 lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Mensuration - Area of Triangles - Lessons"},"postlogin-class9-lessons-mensuration-areaoftriangles-close":{"event_label":"Close subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Mensuration - Area of Triangles - Close"},"postlogin-class9-lessons-mensuration-surfaceareasandvolumes-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Mensuration - Surface Areas and Volumes - Start"},"postlogin-class9-lessons-mensuration-surfaceareasandvolumes-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Mensuration - Surface Areas and Volumes - Resume"},"postlogin-class9-lessons-mensuration-surfaceareasandvolumes-watched":{"event_label":"Rewatch subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Mensuration - Surface Areas and Volumes - Watched"},"postlogin-class9-lessons-mensuration-surfaceareasandvolumes-lessons":{"event_label":"Class 9 lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Mensuration - Surface Areas and Volumes - Lessons"},"postlogin-class9-lessons-mensuration-surfaceareasandvolumes-close":{"event_label":"Close subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Mensuration - Surface Areas and Volumes - Close"},"postlogin-class10-lessons-trigonometry-start":{"event_label":"Start topic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons - Trigonometry - Start"},"postlogin-class10-lessons-trigonometry-resume":{"event_label":"Resume topic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons - Trigonometry - Resume"},"postlogin-class10-lessons-trigonometry-watched":{"event_label":"Rewatch topic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons - Trigonometry - Watched"},"postlogin-class10-lessons-trigonometry-introductiontotrigonometry-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Trigonometry - Introduction to Trigonometry - Start"},"postlogin-class10-lessons-trigonometry-introductiontotrigonometry-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Trigonometry - Introduction to Trigonometry - Resume"},"postlogin-class10-lessons-trigonometry-introductiontotrigonometry-watched":{"event_label":"Rewatch subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Trigonometry - Introduction to Trigonometry - Watched"},"postlogin-class10-lessons-trigonometry-introductiontotrigonometry-lessons":{"event_label":"Class 10 lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Trigonometry - Introduction to Trigonometry - Lessons"},"postlogin-class10-lessons-trigonometry-introductiontotrigonometry-close":{"event_label":"Close subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Trigonometry - Introduction to Trigonometry - Close"},"postlogin-class10-lessons-trigonometry-someapplicationsoftrigonometry-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Trigonometry - Some Applications of Trigonometry - Start"},"postlogin-class10-lessons-trigonometry-someapplicationsoftrigonometry-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Trigonometry - Some Applications of Trigonometry - Resume"},"postlogin-class10-lessons-trigonometry-someapplicationsoftrigonometry-watched":{"event_label":"Rewatch subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Trigonometry - Some Applications of Trigonometry - Watched"},"postlogin-class10-lessons-trigonometry-someapplicationsoftrigonometry-lessons":{"event_label":"Class 10 lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Trigonometry - Some Applications of Trigonometry - Lessons"},"postlogin-class10-lessons-trigonometry-someapplicationsoftrigonometry-close":{"event_label":"Close subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Trigonometry - Some Applications of Trigonometry - Close"},"postlogin-class5-tests-fractions-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Start"},"postlogin-class5-tests-fractions-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Resume"},"postlogin-class5-tests-fractions-revise":{"event_label":"Revise topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Revise"},"postlogin-class5-tests-fractions-introductiontofractions-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - PT - Start"},"postlogin-class5-tests-fractions-introductiontofractions-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - PT - Resume"},"postlogin-class5-tests-fractions-introductiontofractions-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - PT - Report"},"postlogin-class5-tests-fractions-introductiontofractions-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - PT - Start - Start Test"},"postlogin-class5-tests-fractions-introductiontofractions-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - PT - Close"},"postlogin-class5-tests-fractions-introductiontofractions-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - PT - Resume - Continue Test"},"postlogin-class5-tests-fractions-introductiontofractions-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - PT - Test - Close"},"postlogin-class5-tests-fractions-introductiontofractions-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - PT - Test - Submit Test"},"postlogin-class5-tests-fractions-introductiontofractions-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - PT - Scorecard - View Solutions"},"postlogin-class5-tests-fractions-introductiontofractions-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-fractions-introductiontofractions-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-fractions-introductiontofractions-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-fractions-introductiontofractions-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-fractions-introductiontofractions-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-fractions-introductiontofractions-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-fractions-introductiontofractions-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-fractions-introductiontofractions-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-fractions-introductiontofractions-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-fractions-introductiontofractions-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-fractions-introductiontofractions-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-fractions-introductiontofractions-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-fractions-introductiontofractions-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-fractions-introductiontofractions-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-fractions-introductiontofractions-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-fractions-introductiontofractions-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - CP - Start"},"postlogin-class5-tests-fractions-introductiontofractions-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - CP - Start - Start Practice"},"postlogin-class5-tests-fractions-introductiontofractions-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - CP - Start - Close"},"postlogin-class5-tests-fractions-introductiontofractions-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - CP - Start - Start Practice - Close"},"postlogin-class5-tests-fractions-introductiontofractions-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - CP - Start - Start Practice - Check"},"postlogin-class5-tests-fractions-introductiontofractions-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - CP - Resume"},"postlogin-class5-tests-fractions-introductiontofractions-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - CP - Resume - Continue"},"postlogin-class5-tests-fractions-introductiontofractions-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - CP - Resume - Close"},"postlogin-class5-tests-fractions-introductiontofractions-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - CP - Resume - Continue - Close"},"postlogin-class5-tests-fractions-introductiontofractions-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - CP - Resume - Continue - Check"},"postlogin-class5-tests-fractions-introductiontofractions-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Introduction to Fractions - CP - Report"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Start"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Resume"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Report"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Start - Start Test"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Close"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Resume - Continue Test"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Test - Close"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Test - Submit Test"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Solutions"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - CP - Start"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - CP - Start - Start Practice"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - CP - Start - Close"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - CP - Start - Start Practice - Close"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - CP - Start - Start Practice - Check"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - CP - Resume"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - CP - Resume - Continue"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - CP - Resume - Close"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - CP - Resume - Continue - Close"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - CP - Resume - Continue - Check"},"postlogin-class5-tests-fractions-additionandsubtractionoffractions-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Addition and Subtraction of Fractions - CP - Report"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - PT - Start"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - PT - Resume"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - PT - Report"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - PT - Start - Start Test"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - PT - Close"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - PT - Resume - Continue Test"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - PT - Test - Close"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - PT - Test - Submit Test"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - PT - Scorecard - View Solutions"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - CP - Start"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - CP - Start - Start Practice"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - CP - Start - Close"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - CP - Start - Start Practice - Close"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - CP - Start - Start Practice - Check"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - CP - Resume"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - CP - Resume - Continue"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - CP - Resume - Close"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - CP - Resume - Continue - Close"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - CP - Resume - Continue - Check"},"postlogin-class5-tests-fractions-multiplicationanddivisionoffractions-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Multiplication and Division of fractions - CP - Report"},"postlogin-class5-tests-fractions-applicationproblems-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - PT - Start"},"postlogin-class5-tests-fractions-applicationproblems-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - PT - Resume"},"postlogin-class5-tests-fractions-applicationproblems-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - PT - Report"},"postlogin-class5-tests-fractions-applicationproblems-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - PT - Start - Start Test"},"postlogin-class5-tests-fractions-applicationproblems-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - PT - Close"},"postlogin-class5-tests-fractions-applicationproblems-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - PT - Resume - Continue Test"},"postlogin-class5-tests-fractions-applicationproblems-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - PT - Test - Close"},"postlogin-class5-tests-fractions-applicationproblems-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - PT - Test - Submit Test"},"postlogin-class5-tests-fractions-applicationproblems-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - PT - Scorecard - View Solutions"},"postlogin-class5-tests-fractions-applicationproblems-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-fractions-applicationproblems-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-fractions-applicationproblems-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-fractions-applicationproblems-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-fractions-applicationproblems-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-fractions-applicationproblems-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-fractions-applicationproblems-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-fractions-applicationproblems-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-fractions-applicationproblems-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-fractions-applicationproblems-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-fractions-applicationproblems-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-fractions-applicationproblems-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-fractions-applicationproblems-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-fractions-applicationproblems-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-fractions-applicationproblems-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-fractions-applicationproblems-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - CP - Start"},"postlogin-class5-tests-fractions-applicationproblems-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - CP - Start - Start Practice"},"postlogin-class5-tests-fractions-applicationproblems-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - CP - Start - Close"},"postlogin-class5-tests-fractions-applicationproblems-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - CP - Start - Start Practice - Close"},"postlogin-class5-tests-fractions-applicationproblems-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - CP - Start - Start Practice - Check"},"postlogin-class5-tests-fractions-applicationproblems-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - CP - Resume"},"postlogin-class5-tests-fractions-applicationproblems-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - CP - Resume - Continue"},"postlogin-class5-tests-fractions-applicationproblems-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - CP - Resume - Close"},"postlogin-class5-tests-fractions-applicationproblems-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - CP - Resume - Continue - Close"},"postlogin-class5-tests-fractions-applicationproblems-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - CP - Resume - Continue - Check"},"postlogin-class5-tests-fractions-applicationproblems-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Fractions - Application Problems - CP - Report"},"postlogin-class6-tests-understandingelementaryshapes-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Start"},"postlogin-class6-tests-understandingelementaryshapes-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Resume"},"postlogin-class6-tests-understandingelementaryshapes-revise":{"event_label":"Revise topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Revise"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - PT - Start"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - PT - Resume"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - PT - Report"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - PT - Start - Start Test"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - PT - Close"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - PT - Resume - Continue Test"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - PT - Test - Close"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - PT - Test - Submit Test"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - PT - Scorecard - View Solutions"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - CP - Start"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - CP - Start - Start Practice"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - CP - Start - Close"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - CP - Start - Start Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - CP - Start - Start Practice - Check"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - CP - Resume"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - CP - Resume - Continue"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - CP - Resume - Close"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - CP - Resume - Continue - Close"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - CP - Resume - Continue - Check"},"postlogin-class6-tests-understandingelementaryshapes-measuringangles-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Measuring Angles - CP - Report"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - PT - Start"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - PT - Resume"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - PT - Report"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - PT - Start - Start Test"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - PT - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - PT - Resume - Continue Test"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - PT - Test - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - PT - Test - Submit Test"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - PT - Scorecard - View Solutions"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - CP - Start"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - CP - Start - Start Practice"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - CP - Start - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - CP - Start - Start Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - CP - Start - Start Practice - Check"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - CP - Resume"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - CP - Resume - Continue"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - CP - Resume - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - CP - Resume - Continue - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - CP - Resume - Continue - Check"},"postlogin-class6-tests-understandingelementaryshapes-typesofangles-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Angles - CP - Report"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - PT - Start"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - PT - Resume"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - PT - Report"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - PT - Start - Start Test"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - PT - Close"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - PT - Resume - Continue Test"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - PT - Test - Close"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - PT - Test - Submit Test"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - PT - Scorecard - View Solutions"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - CP - Start"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - CP - Start - Start Practice"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - CP - Start - Close"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - CP - Start - Start Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - CP - Start - Start Practice - Check"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - CP - Resume"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - CP - Resume - Continue"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - CP - Resume - Close"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - CP - Resume - Continue - Close"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - CP - Resume - Continue - Check"},"postlogin-class6-tests-understandingelementaryshapes-pairoflines-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Pair of Lines - CP - Report"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - PT - Start"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - PT - Resume"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - PT - Report"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - PT - Start - Start Test"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - PT - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - PT - Resume - Continue Test"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - PT - Test - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - PT - Test - Submit Test"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - PT - Scorecard - View Solutions"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - CP - Start"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - CP - Start - Start Practice"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - CP - Start - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - CP - Start - Start Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - CP - Start - Start Practice - Check"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - CP - Resume"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - CP - Resume - Continue"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - CP - Resume - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - CP - Resume - Continue - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - CP - Resume - Continue - Check"},"postlogin-class6-tests-understandingelementaryshapes-typesoftriangles-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Triangles - CP - Report"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - PT - Start"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - PT - Resume"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - PT - Report"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - PT - Start - Start Test"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - PT - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - PT - Resume - Continue Test"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - PT - Test - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - PT - Test - Submit Test"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - PT - Scorecard - View Solutions"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - CP - Start"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - CP - Start - Start Practice"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - CP - Start - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - CP - Start - Start Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - CP - Start - Start Practice - Check"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - CP - Resume"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - CP - Resume - Continue"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - CP - Resume - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - CP - Resume - Continue - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - CP - Resume - Continue - Check"},"postlogin-class6-tests-understandingelementaryshapes-typesofquadrilaterals-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Quadrilaterals - CP - Report"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - PT - Start"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - PT - Resume"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - PT - Report"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - PT - Start - Start Test"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - PT - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - PT - Resume - Continue Test"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - PT - Test - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - PT - Test - Submit Test"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - PT - Scorecard - View Solutions"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - CP - Start"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - CP - Start - Start Practice"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - CP - Start - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - CP - Start - Start Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - CP - Start - Start Practice - Check"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - CP - Resume"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - CP - Resume - Continue"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - CP - Resume - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - CP - Resume - Continue - Close"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - CP - Resume - Continue - Check"},"postlogin-class6-tests-understandingelementaryshapes-typesofpolygons-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Types of Polygons - CP - Report"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - PT - Start"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - PT - Resume"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - PT - Report"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - PT - Start - Start Test"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - PT - Close"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - PT - Resume - Continue Test"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - PT - Test - Close"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - PT - Test - Submit Test"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - PT - Scorecard - View Solutions"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - CP - Start"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - CP - Start - Start Practice"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - CP - Start - Close"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - CP - Start - Start Practice - Close"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - CP - Start - Start Practice - Check"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - CP - Resume"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - CP - Resume - Continue"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - CP - Resume - Close"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - CP - Resume - Continue - Close"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - CP - Resume - Continue - Check"},"postlogin-class6-tests-understandingelementaryshapes-threedimensionalshapes-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Understanding Elementary Shapes - Three Dimensional Shapes - CP - Report"},"postlogin-class7-tests-linearequations-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Start"},"postlogin-class7-tests-linearequations-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Resume"},"postlogin-class7-tests-linearequations-revise":{"event_label":"Revise topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Revise"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - PT - Start"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - PT - Resume"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - PT - Report"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - PT - Start - Start Test"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - PT - Close"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - PT - Resume - Continue Test"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - PT - Test - Close"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - PT - Test - Submit Test"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - PT - Scorecard - View Solutions"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - CP - Start"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - CP - Start - Start Practice"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - CP - Start - Close"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - CP - Start - Start Practice - Close"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - CP - Start - Start Practice - Check"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - CP - Resume"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - CP - Resume - Continue"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - CP - Resume - Close"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - CP - Resume - Continue - Close"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - CP - Resume - Continue - Check"},"postlogin-class7-tests-linearequations-writingandsolvinglinearequations-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Writing and Solving Linear Equations - CP - Report"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - PT - Start"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - PT - Resume"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - PT - Report"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - PT - Start - Start Test"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - PT - Close"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - PT - Resume - Continue Test"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - PT - Test - Close"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - PT - Test - Submit Test"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - PT - Scorecard - View Solutions"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - CP - Start"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - CP - Start - Start Practice"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - CP - Start - Close"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - CP - Start - Start Practice - Close"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - CP - Start - Start Practice - Check"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - CP - Resume"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - CP - Resume - Continue"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - CP - Resume - Close"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - CP - Resume - Continue - Close"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - CP - Resume - Continue - Check"},"postlogin-class7-tests-linearequations-applicationsoflinearequations-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Linear Equations - Applications of Linear Equations - CP - Report"},"postlogin-class8-tests-squaresandsquareroots-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Start"},"postlogin-class8-tests-squaresandsquareroots-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Resume"},"postlogin-class8-tests-squaresandsquareroots-revise":{"event_label":"Revise topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Revise"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - PT - Start"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - PT - Resume"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - PT - Report"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - PT - Start - Start Test"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - PT - Close"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - PT - Resume - Continue Test"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - PT - Test - Close"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - PT - Test - Submit Test"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - PT - Scorecard - View Solutions"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - CP - Start"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - CP - Start - Start Practice"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - CP - Start - Close"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - CP - Start - Start Practice - Close"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - CP - Start - Start Practice - Check"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - CP - Resume"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - CP - Resume - Continue"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - CP - Resume - Close"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - CP - Resume - Continue - Close"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - CP - Resume - Continue - Check"},"postlogin-class8-tests-squaresandsquareroots-squarenumbers-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square Numbers - CP - Report"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - PT - Start"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - PT - Resume"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - PT - Report"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - PT - Start - Start Test"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - PT - Close"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - PT - Resume - Continue Test"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - PT - Test - Close"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - PT - Test - Submit Test"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - PT - Scorecard - View Solutions"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - CP - Start"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - CP - Start - Start Practice"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - CP - Start - Close"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - CP - Start - Start Practice - Close"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - CP - Start - Start Practice - Check"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - CP - Resume"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - CP - Resume - Continue"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - CP - Resume - Close"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - CP - Resume - Continue - Close"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - CP - Resume - Continue - Check"},"postlogin-class8-tests-squaresandsquareroots-propertiesofsquarenumbers-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Properties of square numbers - CP - Report"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - PT - Start"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - PT - Resume"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - PT - Report"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - PT - Start - Start Test"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - PT - Close"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - PT - Resume - Continue Test"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - PT - Test - Close"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - PT - Test - Submit Test"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - PT - Scorecard - View Solutions"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - CP - Start"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - CP - Start - Start Practice"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - CP - Start - Close"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - CP - Start - Start Practice - Close"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - CP - Start - Start Practice - Check"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - CP - Resume"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - CP - Resume - Continue"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - CP - Resume - Close"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - CP - Resume - Continue - Close"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - CP - Resume - Continue - Check"},"postlogin-class8-tests-squaresandsquareroots-squarerootofanumber-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Squares and Square Roots - Square root of a number - CP - Report"},"postlogin-class9-tests-heronsformula-start":{"event_label":"Start topic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Start"},"postlogin-class9-tests-heronsformula-resume":{"event_label":"Resume topic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Resume"},"postlogin-class9-tests-heronsformula-revise":{"event_label":"Revise topic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Revise"},"postlogin-class9-tests-heronsformula-areaofatriangle-pt-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - PT - Start"},"postlogin-class9-tests-heronsformula-areaofatriangle-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - PT - Resume"},"postlogin-class9-tests-heronsformula-areaofatriangle-pt-report":{"event_label":"View report PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - PT - Report"},"postlogin-class9-tests-heronsformula-areaofatriangle-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - PT - Start - Start Test"},"postlogin-class9-tests-heronsformula-areaofatriangle-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - PT - Close"},"postlogin-class9-tests-heronsformula-areaofatriangle-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - PT - Resume - Continue Test"},"postlogin-class9-tests-heronsformula-areaofatriangle-pt-test-close":{"event_label":"Close PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - PT - Test - Close"},"postlogin-class9-tests-heronsformula-areaofatriangle-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - PT - Test - Submit Test"},"postlogin-class9-tests-heronsformula-areaofatriangle-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - PT - Scorecard - View Solutions"},"postlogin-class9-tests-heronsformula-areaofatriangle-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - PT - Scorecard - View Solutions - Close"},"postlogin-class9-tests-heronsformula-areaofatriangle-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - PT - Scorecard - View Recommendations"},"postlogin-class9-tests-heronsformula-areaofatriangle-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - PT - Scorecard - View Recommendations - Close"},"postlogin-class9-tests-heronsformula-areaofatriangle-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class9-tests-heronsformula-areaofatriangle-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class9-tests-heronsformula-areaofatriangle-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class9-tests-heronsformula-areaofatriangle-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class9-tests-heronsformula-areaofatriangle-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class9-tests-heronsformula-areaofatriangle-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class9-tests-heronsformula-areaofatriangle-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class9-tests-heronsformula-areaofatriangle-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class9-tests-heronsformula-areaofatriangle-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class9-tests-heronsformula-areaofatriangle-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class9-tests-heronsformula-areaofatriangle-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class9-tests-heronsformula-areaofatriangle-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class9-tests-heronsformula-areaofatriangle-cp-start":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - CP - Start"},"postlogin-class9-tests-heronsformula-areaofatriangle-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - CP - Start - Start Practice"},"postlogin-class9-tests-heronsformula-areaofatriangle-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - CP - Start - Close"},"postlogin-class9-tests-heronsformula-areaofatriangle-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - CP - Start - Start Practice - Close"},"postlogin-class9-tests-heronsformula-areaofatriangle-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - CP - Start - Start Practice - Check"},"postlogin-class9-tests-heronsformula-areaofatriangle-cp-resume":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - CP - Resume"},"postlogin-class9-tests-heronsformula-areaofatriangle-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - CP - Resume - Continue"},"postlogin-class9-tests-heronsformula-areaofatriangle-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - CP - Resume - Close"},"postlogin-class9-tests-heronsformula-areaofatriangle-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - CP - Resume - Continue - Close"},"postlogin-class9-tests-heronsformula-areaofatriangle-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - CP - Resume - Continue - Check"},"postlogin-class9-tests-heronsformula-areaofatriangle-cp-report":{"event_label":"View report CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Area of a Triangle - CP - Report"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-pt-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - PT - Start"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - PT - Resume"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-pt-report":{"event_label":"View report PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - PT - Report"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - PT - Start - Start Test"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - PT - Close"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - PT - Resume - Continue Test"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-pt-test-close":{"event_label":"Close PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - PT - Test - Close"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - PT - Test - Submit Test"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - PT - Scorecard - View Solutions"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - PT - Scorecard - View Solutions - Close"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - PT - Scorecard - View Recommendations"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - PT - Scorecard - View Recommendations - Close"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-cp-start":{"event_label":"Start Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - CP - Start"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - CP - Start - Start Practice"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - CP - Start - Close"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - CP - Start - Start Practice - Close"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - CP - Start - Start Practice - Check"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-cp-resume":{"event_label":"Continue Practice","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - CP - Resume"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - CP - Resume - Continue"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - CP - Resume - Close"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - CP - Resume - Continue - Close"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - CP - Resume - Continue - Check"},"postlogin-class9-tests-heronsformula-heronsformula-applicationproblems-cp-report":{"event_label":"View report CP","event_category":"Class 9","event_action":"Post login - Class 9 - Tests - Herons Formula - Herons Formula - Application Problems - CP - Report"},"postlogin-class10-tests-introductiontotrignometry-start":{"event_label":"Start topic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Start"},"postlogin-class10-tests-introductiontotrignometry-resume":{"event_label":"Resume topic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Resume"},"postlogin-class10-tests-introductiontotrignometry-revise":{"event_label":"Revise topic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Revise"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - PT - Start"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - PT - Resume"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - PT - Report"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - PT - Start - Start Test"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - PT - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - PT - Resume - Continue Test"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - PT - Test - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - PT - Test - Submit Test"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - PT - Scorecard - View Solutions"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - CP - Start"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - CP - Start - Start Practice"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - CP - Start - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - CP - Start - Start Practice - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - CP - Start - Start Practice - Check"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - CP - Resume"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - CP - Resume - Continue"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - CP - Resume - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - CP - Resume - Continue - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - CP - Resume - Continue - Check"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomiali-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial I - CP - Report"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - PT - Start"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - PT - Resume"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - PT - Report"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - PT - Start - Start Test"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - PT - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - PT - Resume - Continue Test"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - PT - Test - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - PT - Test - Submit Test"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - PT - Scorecard - View Solutions"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - CP - Start"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - CP - Start - Start Practice"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - CP - Start - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - CP - Start - Start Practice - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - CP - Start - Start Practice - Check"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - CP - Resume"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - CP - Resume - Continue"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - CP - Resume - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - CP - Resume - Continue - Close"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - CP - Resume - Continue - Check"},"postlogin-class10-tests-introductiontotrignometry-zeroesofapolynomialii-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Zeroes of a Polynomial II - CP - Report"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - PT - Start"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - PT - Resume"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - PT - Report"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - PT - Start - Start Test"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - PT - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - PT - Resume - Continue Test"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - PT - Test - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - PT - Test - Submit Test"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - PT - Scorecard - View Solutions"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - CP - Start"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - CP - Start - Start Practice"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - CP - Start - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - CP - Start - Start Practice - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - CP - Start - Start Practice - Check"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - CP - Resume"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - CP - Resume - Continue"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - CP - Resume - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - CP - Resume - Continue - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - CP - Resume - Continue - Check"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsi-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials I - CP - Report"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - PT - Start"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - PT - Resume"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - PT - Report"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - PT - Start - Start Test"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - PT - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - PT - Resume - Continue Test"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - PT - Test - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - PT - Test - Submit Test"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - PT - Scorecard - View Solutions"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - CP - Start"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - CP - Start - Start Practice"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - CP - Start - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - CP - Start - Start Practice - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - CP - Start - Start Practice - Check"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - CP - Resume"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - CP - Resume - Continue"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - CP - Resume - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - CP - Resume - Continue - Close"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - CP - Resume - Continue - Check"},"postlogin-class10-tests-introductiontotrignometry-divisionofpolynomialsii-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Introduction to Trignometry - Division of Polynomials II - CP - Report"},"postlogin-class1-lessons-time-start":{"event_label":"Start topic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons - Time - Start"},"postlogin-class1-lessons-time-resume":{"event_label":"Resume topic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons - Time - Resume"},"postlogin-class1-lessons-time-watched":{"event_label":"Rewatch topic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons - Time - Watched"},"postlogin-class1-lessons-time-clockandcalendar-start":{"event_label":"Start subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Time - Clock and Calendar - Start"},"postlogin-class1-lessons-time-clockandcalendar-resume":{"event_label":"Resume subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Time - Clock and Calendar - Resume"},"postlogin-class1-lessons-time-clockandcalendar-watched":{"event_label":"Rewatch subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Time - Clock and Calendar - Watched"},"postlogin-class1-lessons-time-clockandcalendar-lessons":{"event_label":"Class 1 lessons","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Time - Clock and Calendar - Lessons"},"postlogin-class1-lessons-time-clockandcalendar-close":{"event_label":"Close subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Time - Clock and Calendar - Close"},"postlogin-class2-lessons-time-start":{"event_label":"Start topic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons - Time - Start"},"postlogin-class2-lessons-time-resume":{"event_label":"Resume topic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons - Time - Resume"},"postlogin-class2-lessons-time-watched":{"event_label":"Rewatch topic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons - Time - Watched"},"postlogin-class2-lessons-time-clockandcalendar-start":{"event_label":"Start subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Time - Clock and Calendar - Start"},"postlogin-class2-lessons-time-clockandcalendar-resume":{"event_label":"Resume subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Time - Clock and Calendar - Resume"},"postlogin-class2-lessons-time-clockandcalendar-watched":{"event_label":"Rewatch subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Time - Clock and Calendar - Watched"},"postlogin-class2-lessons-time-clockandcalendar-lessons":{"event_label":"Class 2 lessons","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Time - Clock and Calendar - Lessons"},"postlogin-class2-lessons-time-clockandcalendar-close":{"event_label":"Close subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Time - Clock and Calendar - Close"},"postlogin-class3-lessons-measurement-start":{"event_label":"Start topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Measurement - Start"},"postlogin-class3-lessons-measurement-resume":{"event_label":"Resume topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Measurement - Resume"},"postlogin-class3-lessons-measurement-watched":{"event_label":"Rewatch topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Measurement - Watched"},"postlogin-class3-lessons-measurement-length-start":{"event_label":"Start subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Measurement - Length - Start"},"postlogin-class3-lessons-measurement-length-resume":{"event_label":"Resume subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Measurement - Length - Resume"},"postlogin-class3-lessons-measurement-length-watched":{"event_label":"Rewatch subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Measurement - Length - Watched"},"postlogin-class3-lessons-measurement-length-lessons":{"event_label":"Class 3 lessons","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Measurement - Length - Lessons"},"postlogin-class3-lessons-measurement-length-close":{"event_label":"Close subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Measurement - Length - Close"},"postlogin-class3-lessons-measurement-mass-start":{"event_label":"Start subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Measurement - Mass - Start"},"postlogin-class3-lessons-measurement-mass-resume":{"event_label":"Resume subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Measurement - Mass - Resume"},"postlogin-class3-lessons-measurement-mass-watched":{"event_label":"Rewatch subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Measurement - Mass - Watched"},"postlogin-class3-lessons-measurement-mass-lessons":{"event_label":"Class 3 lessons","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Measurement - Mass - Lessons"},"postlogin-class3-lessons-measurement-mass-close":{"event_label":"Close subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Measurement - Mass - Close"},"postlogin-class3-lessons-measurement-capacity-start":{"event_label":"Start subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Measurement - Capacity - Start"},"postlogin-class3-lessons-measurement-capacity-resume":{"event_label":"Resume subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Measurement - Capacity - Resume"},"postlogin-class3-lessons-measurement-capacity-watched":{"event_label":"Rewatch subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Measurement - Capacity - Watched"},"postlogin-class3-lessons-measurement-capacity-lessons":{"event_label":"Class 3 lessons","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Measurement - Capacity - Lessons"},"postlogin-class3-lessons-measurement-capacity-close":{"event_label":"Close subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Measurement - Capacity - Close"},"postlogin-class4-lessons-geometry-start":{"event_label":"Start topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Geometry - Start"},"postlogin-class4-lessons-geometry-resume":{"event_label":"Resume topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Geometry - Resume"},"postlogin-class4-lessons-geometry-watched":{"event_label":"Rewatch topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Geometry - Watched"},"postlogin-class4-lessons-geometry-circlesandpolygons-start":{"event_label":"Start subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Geometry - Circles and Polygons - Start"},"postlogin-class4-lessons-geometry-circlesandpolygons-resume":{"event_label":"Resume subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Geometry - Circles and Polygons - Resume"},"postlogin-class4-lessons-geometry-circlesandpolygons-watched":{"event_label":"Rewatch subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Geometry - Circles and Polygons - Watched"},"postlogin-class4-lessons-geometry-circlesandpolygons-lessons":{"event_label":"Class 4 lessons","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Geometry - Circles and Polygons - Lessons"},"postlogin-class4-lessons-geometry-circlesandpolygons-close":{"event_label":"Close subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Geometry - Circles and Polygons - Close"},"postlogin-class5-lessons-decimals-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Decimals - Start"},"postlogin-class5-lessons-decimals-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Decimals - Resume"},"postlogin-class5-lessons-decimals-watched":{"event_label":"Rewatch topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Decimals - Watched"},"postlogin-class5-lessons-decimals-introductiontodecimals-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Decimals - Introduction to Decimals - Start"},"postlogin-class5-lessons-decimals-introductiontodecimals-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Decimals - Introduction to Decimals - Resume"},"postlogin-class5-lessons-decimals-introductiontodecimals-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Decimals - Introduction to Decimals - Watched"},"postlogin-class5-lessons-decimals-introductiontodecimals-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Decimals - Introduction to Decimals - Lessons"},"postlogin-class5-lessons-decimals-introductiontodecimals-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Decimals - Introduction to Decimals - Close"},"postlogin-class5-lessons-decimals-additionandsubtractionofdecimals-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Decimals - Addition and Subtraction of Decimals - Start"},"postlogin-class5-lessons-decimals-additionandsubtractionofdecimals-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Decimals - Addition and Subtraction of Decimals - Resume"},"postlogin-class5-lessons-decimals-additionandsubtractionofdecimals-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Decimals - Addition and Subtraction of Decimals - Watched"},"postlogin-class5-lessons-decimals-additionandsubtractionofdecimals-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Decimals - Addition and Subtraction of Decimals - Lessons"},"postlogin-class5-lessons-decimals-additionandsubtractionofdecimals-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Decimals - Addition and Subtraction of Decimals - Close"},"postlogin-class5-lessons-decimals-multiplicationanddivisionofdecimals-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Decimals - Multiplication and Division of Decimals - Start"},"postlogin-class5-lessons-decimals-multiplicationanddivisionofdecimals-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Decimals - Multiplication and Division of Decimals - Resume"},"postlogin-class5-lessons-decimals-multiplicationanddivisionofdecimals-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Decimals - Multiplication and Division of Decimals - Watched"},"postlogin-class5-lessons-decimals-multiplicationanddivisionofdecimals-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Decimals - Multiplication and Division of Decimals - Lessons"},"postlogin-class5-lessons-decimals-multiplicationanddivisionofdecimals-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Decimals - Multiplication and Division of Decimals - Close"},"postlogin-class6-lessons-integers-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Integers - Start"},"postlogin-class6-lessons-integers-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Integers - Resume"},"postlogin-class6-lessons-integers-watched":{"event_label":"Rewatch topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Integers - Watched"},"postlogin-class6-lessons-integers-introductiontointegers-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Integers - Introduction to Integers - Start"},"postlogin-class6-lessons-integers-introductiontointegers-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Integers - Introduction to Integers - Resume"},"postlogin-class6-lessons-integers-introductiontointegers-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Integers - Introduction to Integers - Watched"},"postlogin-class6-lessons-integers-introductiontointegers-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Integers - Introduction to Integers - Lessons"},"postlogin-class6-lessons-integers-introductiontointegers-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Integers - Introduction to Integers - Close"},"postlogin-class6-lessons-integers-additionandsubtractionofintegers-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Integers - Addition and Subtraction of Integers - Start"},"postlogin-class6-lessons-integers-additionandsubtractionofintegers-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Integers - Addition and Subtraction of Integers - Resume"},"postlogin-class6-lessons-integers-additionandsubtractionofintegers-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Integers - Addition and Subtraction of Integers - Watched"},"postlogin-class6-lessons-integers-additionandsubtractionofintegers-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Integers - Addition and Subtraction of Integers - Lessons"},"postlogin-class6-lessons-integers-additionandsubtractionofintegers-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Integers - Addition and Subtraction of Integers - Close"},"postlogin-class7-lessons-linesandangles-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Lines and Angles - Start"},"postlogin-class7-lessons-linesandangles-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Lines and Angles - Resume"},"postlogin-class7-lessons-linesandangles-watched":{"event_label":"Rewatch topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Lines and Angles - Watched"},"postlogin-class7-lessons-linesandangles-pairsofangles-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Lines and Angles - Pairs of angles - Start"},"postlogin-class7-lessons-linesandangles-pairsofangles-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Lines and Angles - Pairs of angles - Resume"},"postlogin-class7-lessons-linesandangles-pairsofangles-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Lines and Angles - Pairs of angles - Watched"},"postlogin-class7-lessons-linesandangles-pairsofangles-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Lines and Angles - Pairs of angles - Lessons"},"postlogin-class7-lessons-linesandangles-pairsofangles-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Lines and Angles - Pairs of angles - Close"},"postlogin-class7-lessons-linesandangles-anglesinparallellines-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Lines and Angles - Angles in Parallel Lines - Start"},"postlogin-class7-lessons-linesandangles-anglesinparallellines-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Lines and Angles - Angles in Parallel Lines - Resume"},"postlogin-class7-lessons-linesandangles-anglesinparallellines-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Lines and Angles - Angles in Parallel Lines - Watched"},"postlogin-class7-lessons-linesandangles-anglesinparallellines-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Lines and Angles - Angles in Parallel Lines - Lessons"},"postlogin-class7-lessons-linesandangles-anglesinparallellines-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Lines and Angles - Angles in Parallel Lines - Close"},"postlogin-class8-lessons-cubesandcuberoots-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Cubes and Cube Roots - Start"},"postlogin-class8-lessons-cubesandcuberoots-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Cubes and Cube Roots - Resume"},"postlogin-class8-lessons-cubesandcuberoots-watched":{"event_label":"Rewatch topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Cubes and Cube Roots - Watched"},"postlogin-class8-lessons-cubesandcuberoots-cubesandcuberoots-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Cubes and Cube Roots - Cubes and Cube Roots - Start"},"postlogin-class8-lessons-cubesandcuberoots-cubesandcuberoots-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Cubes and Cube Roots - Cubes and Cube Roots - Resume"},"postlogin-class8-lessons-cubesandcuberoots-cubesandcuberoots-watched":{"event_label":"Rewatch subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Cubes and Cube Roots - Cubes and Cube Roots - Watched"},"postlogin-class8-lessons-cubesandcuberoots-cubesandcuberoots-lessons":{"event_label":"Class 8 lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Cubes and Cube Roots - Cubes and Cube Roots - Lessons"},"postlogin-class8-lessons-cubesandcuberoots-cubesandcuberoots-close":{"event_label":"Close subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Cubes and Cube Roots - Cubes and Cube Roots - Close"},"postlogin-class9-lessons-statisticsandprobability-start":{"event_label":"Start topic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons - Statistics and Probability - Start"},"postlogin-class9-lessons-statisticsandprobability-resume":{"event_label":"Resume topic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons - Statistics and Probability - Resume"},"postlogin-class9-lessons-statisticsandprobability-watched":{"event_label":"Rewatch topic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons - Statistics and Probability - Watched"},"postlogin-class9-lessons-statisticsandprobability-histograms-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Statistics and Probability - Histograms - Start"},"postlogin-class9-lessons-statisticsandprobability-histograms-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Statistics and Probability - Histograms - Resume"},"postlogin-class9-lessons-statisticsandprobability-histograms-watched":{"event_label":"Rewatch subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Statistics and Probability - Histograms - Watched"},"postlogin-class9-lessons-statisticsandprobability-histograms-lessons":{"event_label":"Class 9 lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Statistics and Probability - Histograms - Lessons"},"postlogin-class9-lessons-statisticsandprobability-histograms-close":{"event_label":"Close subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Statistics and Probability - Histograms - Close"},"postlogin-class9-lessons-statisticsandprobability-measuresofcentraltendency-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Statistics and Probability - Measures of Central Tendency - Start"},"postlogin-class9-lessons-statisticsandprobability-measuresofcentraltendency-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Statistics and Probability - Measures of Central Tendency - Resume"},"postlogin-class9-lessons-statisticsandprobability-measuresofcentraltendency-watched":{"event_label":"Rewatch subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Statistics and Probability - Measures of Central Tendency - Watched"},"postlogin-class9-lessons-statisticsandprobability-measuresofcentraltendency-lessons":{"event_label":"Class 9 lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Statistics and Probability - Measures of Central Tendency - Lessons"},"postlogin-class9-lessons-statisticsandprobability-measuresofcentraltendency-close":{"event_label":"Close subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Statistics and Probability - Measures of Central Tendency - Close"},"postlogin-class9-lessons-statisticsandprobability-probabiity-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Statistics and Probability - Probabiity - Start"},"postlogin-class9-lessons-statisticsandprobability-probabiity-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Statistics and Probability - Probabiity - Resume"},"postlogin-class9-lessons-statisticsandprobability-probabiity-watched":{"event_label":"Rewatch subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Statistics and Probability - Probabiity - Watched"},"postlogin-class9-lessons-statisticsandprobability-probabiity-lessons":{"event_label":"Class 9 lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Statistics and Probability - Probabiity - Lessons"},"postlogin-class9-lessons-statisticsandprobability-probabiity-close":{"event_label":"Close subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Statistics and Probability - Probabiity - Close"},"postlogin-class10-lessons-mensuration-start":{"event_label":"Start topic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons - Mensuration - Start"},"postlogin-class10-lessons-mensuration-resume":{"event_label":"Resume topic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons - Mensuration - Resume"},"postlogin-class10-lessons-mensuration-watched":{"event_label":"Rewatch topic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons - Mensuration - Watched"},"postlogin-class10-lessons-mensuration-areasrelatedtocircles-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Mensuration - Areas related to Circles - Start"},"postlogin-class10-lessons-mensuration-areasrelatedtocircles-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Mensuration - Areas related to Circles - Resume"},"postlogin-class10-lessons-mensuration-areasrelatedtocircles-watched":{"event_label":"Rewatch subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Mensuration - Areas related to Circles - Watched"},"postlogin-class10-lessons-mensuration-areasrelatedtocircles-lessons":{"event_label":"Class 10 lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Mensuration - Areas related to Circles - Lessons"},"postlogin-class10-lessons-mensuration-areasrelatedtocircles-close":{"event_label":"Close subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Mensuration - Areas related to Circles - Close"},"postlogin-class10-lessons-mensuration-surfaceareasandvolumes-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Mensuration - Surface Areas and Volumes - Start"},"postlogin-class10-lessons-mensuration-surfaceareasandvolumes-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Mensuration - Surface Areas and Volumes - Resume"},"postlogin-class10-lessons-mensuration-surfaceareasandvolumes-watched":{"event_label":"Rewatch subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Mensuration - Surface Areas and Volumes - Watched"},"postlogin-class10-lessons-mensuration-surfaceareasandvolumes-lessons":{"event_label":"Class 10 lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Mensuration - Surface Areas and Volumes - Lessons"},"postlogin-class10-lessons-mensuration-surfaceareasandvolumes-close":{"event_label":"Close subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Mensuration - Surface Areas and Volumes - Close"},"postlogin-class5-tests-decimals-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Start"},"postlogin-class5-tests-decimals-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Resume"},"postlogin-class5-tests-decimals-revise":{"event_label":"Revise topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Revise"},"postlogin-class5-tests-decimals-introductiontodecimals-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - PT - Start"},"postlogin-class5-tests-decimals-introductiontodecimals-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - PT - Resume"},"postlogin-class5-tests-decimals-introductiontodecimals-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - PT - Report"},"postlogin-class5-tests-decimals-introductiontodecimals-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - PT - Start - Start Test"},"postlogin-class5-tests-decimals-introductiontodecimals-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - PT - Close"},"postlogin-class5-tests-decimals-introductiontodecimals-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - PT - Resume - Continue Test"},"postlogin-class5-tests-decimals-introductiontodecimals-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - PT - Test - Close"},"postlogin-class5-tests-decimals-introductiontodecimals-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - PT - Test - Submit Test"},"postlogin-class5-tests-decimals-introductiontodecimals-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Solutions"},"postlogin-class5-tests-decimals-introductiontodecimals-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-decimals-introductiontodecimals-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - CP - Start"},"postlogin-class5-tests-decimals-introductiontodecimals-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - CP - Start - Start Practice"},"postlogin-class5-tests-decimals-introductiontodecimals-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - CP - Start - Close"},"postlogin-class5-tests-decimals-introductiontodecimals-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - CP - Start - Start Practice - Close"},"postlogin-class5-tests-decimals-introductiontodecimals-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - CP - Start - Start Practice - Check"},"postlogin-class5-tests-decimals-introductiontodecimals-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - CP - Resume"},"postlogin-class5-tests-decimals-introductiontodecimals-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - CP - Resume - Continue"},"postlogin-class5-tests-decimals-introductiontodecimals-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - CP - Resume - Close"},"postlogin-class5-tests-decimals-introductiontodecimals-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - CP - Resume - Continue - Close"},"postlogin-class5-tests-decimals-introductiontodecimals-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - CP - Resume - Continue - Check"},"postlogin-class5-tests-decimals-introductiontodecimals-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Introduction to Decimals - CP - Report"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - PT - Start"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - PT - Resume"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - PT - Report"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - PT - Start - Start Test"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - PT - Close"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - PT - Resume - Continue Test"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - PT - Test - Close"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - PT - Test - Submit Test"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - PT - Scorecard - View Solutions"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - CP - Start"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - CP - Start - Start Practice"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - CP - Start - Close"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - CP - Start - Start Practice - Close"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - CP - Start - Start Practice - Check"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - CP - Resume"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - CP - Resume - Continue"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - CP - Resume - Close"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - CP - Resume - Continue - Close"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - CP - Resume - Continue - Check"},"postlogin-class5-tests-decimals-additionandsubtractionofdecimals-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Addition and Subtraction of Decimals - CP - Report"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - PT - Start"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - PT - Resume"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - PT - Report"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - PT - Start - Start Test"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - PT - Close"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - PT - Resume - Continue Test"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - PT - Test - Close"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - PT - Test - Submit Test"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - PT - Scorecard - View Solutions"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - CP - Start"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - CP - Start - Start Practice"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - CP - Start - Close"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - CP - Start - Start Practice - Close"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - CP - Start - Start Practice - Check"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - CP - Resume"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - CP - Resume - Continue"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - CP - Resume - Close"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - CP - Resume - Continue - Close"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - CP - Resume - Continue - Check"},"postlogin-class5-tests-decimals-multiplicationanddivisionofdecimals-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Multiplication and Division of Decimals - CP - Report"},"postlogin-class5-tests-decimals-applicationproblems-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - PT - Start"},"postlogin-class5-tests-decimals-applicationproblems-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - PT - Resume"},"postlogin-class5-tests-decimals-applicationproblems-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - PT - Report"},"postlogin-class5-tests-decimals-applicationproblems-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - PT - Start - Start Test"},"postlogin-class5-tests-decimals-applicationproblems-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - PT - Close"},"postlogin-class5-tests-decimals-applicationproblems-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - PT - Resume - Continue Test"},"postlogin-class5-tests-decimals-applicationproblems-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - PT - Test - Close"},"postlogin-class5-tests-decimals-applicationproblems-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - PT - Test - Submit Test"},"postlogin-class5-tests-decimals-applicationproblems-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - PT - Scorecard - View Solutions"},"postlogin-class5-tests-decimals-applicationproblems-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-decimals-applicationproblems-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-decimals-applicationproblems-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-decimals-applicationproblems-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-decimals-applicationproblems-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-decimals-applicationproblems-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-decimals-applicationproblems-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-decimals-applicationproblems-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-decimals-applicationproblems-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-decimals-applicationproblems-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-decimals-applicationproblems-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-decimals-applicationproblems-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-decimals-applicationproblems-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-decimals-applicationproblems-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-decimals-applicationproblems-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-decimals-applicationproblems-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - CP - Start"},"postlogin-class5-tests-decimals-applicationproblems-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - CP - Start - Start Practice"},"postlogin-class5-tests-decimals-applicationproblems-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - CP - Start - Close"},"postlogin-class5-tests-decimals-applicationproblems-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - CP - Start - Start Practice - Close"},"postlogin-class5-tests-decimals-applicationproblems-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - CP - Start - Start Practice - Check"},"postlogin-class5-tests-decimals-applicationproblems-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - CP - Resume"},"postlogin-class5-tests-decimals-applicationproblems-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - CP - Resume - Continue"},"postlogin-class5-tests-decimals-applicationproblems-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - CP - Resume - Close"},"postlogin-class5-tests-decimals-applicationproblems-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - CP - Resume - Continue - Close"},"postlogin-class5-tests-decimals-applicationproblems-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - CP - Resume - Continue - Check"},"postlogin-class5-tests-decimals-applicationproblems-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Decimals - Application Problems - CP - Report"},"postlogin-class6-tests-integers-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Start"},"postlogin-class6-tests-integers-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Resume"},"postlogin-class6-tests-integers-revise":{"event_label":"Revise topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Revise"},"postlogin-class6-tests-integers-introductiontointegers-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - PT - Start"},"postlogin-class6-tests-integers-introductiontointegers-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - PT - Resume"},"postlogin-class6-tests-integers-introductiontointegers-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - PT - Report"},"postlogin-class6-tests-integers-introductiontointegers-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - PT - Start - Start Test"},"postlogin-class6-tests-integers-introductiontointegers-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - PT - Close"},"postlogin-class6-tests-integers-introductiontointegers-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - PT - Resume - Continue Test"},"postlogin-class6-tests-integers-introductiontointegers-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - PT - Test - Close"},"postlogin-class6-tests-integers-introductiontointegers-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - PT - Test - Submit Test"},"postlogin-class6-tests-integers-introductiontointegers-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - PT - Scorecard - View Solutions"},"postlogin-class6-tests-integers-introductiontointegers-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-integers-introductiontointegers-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-integers-introductiontointegers-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-integers-introductiontointegers-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-integers-introductiontointegers-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-integers-introductiontointegers-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-integers-introductiontointegers-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-integers-introductiontointegers-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-integers-introductiontointegers-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-integers-introductiontointegers-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-integers-introductiontointegers-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-integers-introductiontointegers-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-integers-introductiontointegers-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-integers-introductiontointegers-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-integers-introductiontointegers-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-integers-introductiontointegers-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - CP - Start"},"postlogin-class6-tests-integers-introductiontointegers-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - CP - Start - Start Practice"},"postlogin-class6-tests-integers-introductiontointegers-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - CP - Start - Close"},"postlogin-class6-tests-integers-introductiontointegers-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - CP - Start - Start Practice - Close"},"postlogin-class6-tests-integers-introductiontointegers-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - CP - Start - Start Practice - Check"},"postlogin-class6-tests-integers-introductiontointegers-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - CP - Resume"},"postlogin-class6-tests-integers-introductiontointegers-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - CP - Resume - Continue"},"postlogin-class6-tests-integers-introductiontointegers-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - CP - Resume - Close"},"postlogin-class6-tests-integers-introductiontointegers-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - CP - Resume - Continue - Close"},"postlogin-class6-tests-integers-introductiontointegers-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - CP - Resume - Continue - Check"},"postlogin-class6-tests-integers-introductiontointegers-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Introduction to Integers - CP - Report"},"postlogin-class6-tests-integers-comparingandorderingintegers-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - PT - Start"},"postlogin-class6-tests-integers-comparingandorderingintegers-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - PT - Resume"},"postlogin-class6-tests-integers-comparingandorderingintegers-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - PT - Report"},"postlogin-class6-tests-integers-comparingandorderingintegers-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - PT - Start - Start Test"},"postlogin-class6-tests-integers-comparingandorderingintegers-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - PT - Close"},"postlogin-class6-tests-integers-comparingandorderingintegers-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - PT - Resume - Continue Test"},"postlogin-class6-tests-integers-comparingandorderingintegers-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - PT - Test - Close"},"postlogin-class6-tests-integers-comparingandorderingintegers-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - PT - Test - Submit Test"},"postlogin-class6-tests-integers-comparingandorderingintegers-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - PT - Scorecard - View Solutions"},"postlogin-class6-tests-integers-comparingandorderingintegers-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-integers-comparingandorderingintegers-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-integers-comparingandorderingintegers-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-integers-comparingandorderingintegers-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-integers-comparingandorderingintegers-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-integers-comparingandorderingintegers-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-integers-comparingandorderingintegers-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-integers-comparingandorderingintegers-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-integers-comparingandorderingintegers-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-integers-comparingandorderingintegers-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-integers-comparingandorderingintegers-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-integers-comparingandorderingintegers-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-integers-comparingandorderingintegers-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-integers-comparingandorderingintegers-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-integers-comparingandorderingintegers-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-integers-comparingandorderingintegers-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - CP - Start"},"postlogin-class6-tests-integers-comparingandorderingintegers-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - CP - Start - Start Practice"},"postlogin-class6-tests-integers-comparingandorderingintegers-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - CP - Start - Close"},"postlogin-class6-tests-integers-comparingandorderingintegers-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - CP - Start - Start Practice - Close"},"postlogin-class6-tests-integers-comparingandorderingintegers-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - CP - Start - Start Practice - Check"},"postlogin-class6-tests-integers-comparingandorderingintegers-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - CP - Resume"},"postlogin-class6-tests-integers-comparingandorderingintegers-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - CP - Resume - Continue"},"postlogin-class6-tests-integers-comparingandorderingintegers-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - CP - Resume - Close"},"postlogin-class6-tests-integers-comparingandorderingintegers-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - CP - Resume - Continue - Close"},"postlogin-class6-tests-integers-comparingandorderingintegers-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - CP - Resume - Continue - Check"},"postlogin-class6-tests-integers-comparingandorderingintegers-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Comparing and Ordering Integers - CP - Report"},"postlogin-class6-tests-integers-additionofintegers-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - PT - Start"},"postlogin-class6-tests-integers-additionofintegers-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - PT - Resume"},"postlogin-class6-tests-integers-additionofintegers-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - PT - Report"},"postlogin-class6-tests-integers-additionofintegers-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - PT - Start - Start Test"},"postlogin-class6-tests-integers-additionofintegers-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - PT - Close"},"postlogin-class6-tests-integers-additionofintegers-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - PT - Resume - Continue Test"},"postlogin-class6-tests-integers-additionofintegers-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - PT - Test - Close"},"postlogin-class6-tests-integers-additionofintegers-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - PT - Test - Submit Test"},"postlogin-class6-tests-integers-additionofintegers-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - PT - Scorecard - View Solutions"},"postlogin-class6-tests-integers-additionofintegers-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-integers-additionofintegers-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-integers-additionofintegers-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-integers-additionofintegers-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-integers-additionofintegers-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-integers-additionofintegers-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-integers-additionofintegers-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-integers-additionofintegers-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-integers-additionofintegers-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-integers-additionofintegers-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-integers-additionofintegers-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-integers-additionofintegers-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-integers-additionofintegers-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-integers-additionofintegers-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-integers-additionofintegers-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-integers-additionofintegers-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - CP - Start"},"postlogin-class6-tests-integers-additionofintegers-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - CP - Start - Start Practice"},"postlogin-class6-tests-integers-additionofintegers-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - CP - Start - Close"},"postlogin-class6-tests-integers-additionofintegers-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - CP - Start - Start Practice - Close"},"postlogin-class6-tests-integers-additionofintegers-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - CP - Start - Start Practice - Check"},"postlogin-class6-tests-integers-additionofintegers-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - CP - Resume"},"postlogin-class6-tests-integers-additionofintegers-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - CP - Resume - Continue"},"postlogin-class6-tests-integers-additionofintegers-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - CP - Resume - Close"},"postlogin-class6-tests-integers-additionofintegers-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - CP - Resume - Continue - Close"},"postlogin-class6-tests-integers-additionofintegers-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - CP - Resume - Continue - Check"},"postlogin-class6-tests-integers-additionofintegers-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Addition of Integers - CP - Report"},"postlogin-class6-tests-integers-subtractionofintegers-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - PT - Start"},"postlogin-class6-tests-integers-subtractionofintegers-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - PT - Resume"},"postlogin-class6-tests-integers-subtractionofintegers-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - PT - Report"},"postlogin-class6-tests-integers-subtractionofintegers-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - PT - Start - Start Test"},"postlogin-class6-tests-integers-subtractionofintegers-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - PT - Close"},"postlogin-class6-tests-integers-subtractionofintegers-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - PT - Resume - Continue Test"},"postlogin-class6-tests-integers-subtractionofintegers-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - PT - Test - Close"},"postlogin-class6-tests-integers-subtractionofintegers-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - PT - Test - Submit Test"},"postlogin-class6-tests-integers-subtractionofintegers-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - PT - Scorecard - View Solutions"},"postlogin-class6-tests-integers-subtractionofintegers-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-integers-subtractionofintegers-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-integers-subtractionofintegers-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-integers-subtractionofintegers-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-integers-subtractionofintegers-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-integers-subtractionofintegers-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-integers-subtractionofintegers-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-integers-subtractionofintegers-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-integers-subtractionofintegers-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-integers-subtractionofintegers-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-integers-subtractionofintegers-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-integers-subtractionofintegers-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-integers-subtractionofintegers-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-integers-subtractionofintegers-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-integers-subtractionofintegers-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-integers-subtractionofintegers-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - CP - Start"},"postlogin-class6-tests-integers-subtractionofintegers-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - CP - Start - Start Practice"},"postlogin-class6-tests-integers-subtractionofintegers-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - CP - Start - Close"},"postlogin-class6-tests-integers-subtractionofintegers-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - CP - Start - Start Practice - Close"},"postlogin-class6-tests-integers-subtractionofintegers-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - CP - Start - Start Practice - Check"},"postlogin-class6-tests-integers-subtractionofintegers-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - CP - Resume"},"postlogin-class6-tests-integers-subtractionofintegers-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - CP - Resume - Continue"},"postlogin-class6-tests-integers-subtractionofintegers-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - CP - Resume - Close"},"postlogin-class6-tests-integers-subtractionofintegers-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - CP - Resume - Continue - Close"},"postlogin-class6-tests-integers-subtractionofintegers-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - CP - Resume - Continue - Check"},"postlogin-class6-tests-integers-subtractionofintegers-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Integers - Subtraction of Integers - CP - Report"},"postlogin-class7-tests-linesandangles-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Start"},"postlogin-class7-tests-linesandangles-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Resume"},"postlogin-class7-tests-linesandangles-revise":{"event_label":"Revise topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Revise"},"postlogin-class7-tests-linesandangles-pairofangles-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - PT - Start"},"postlogin-class7-tests-linesandangles-pairofangles-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - PT - Resume"},"postlogin-class7-tests-linesandangles-pairofangles-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - PT - Report"},"postlogin-class7-tests-linesandangles-pairofangles-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - PT - Start - Start Test"},"postlogin-class7-tests-linesandangles-pairofangles-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - PT - Close"},"postlogin-class7-tests-linesandangles-pairofangles-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - PT - Resume - Continue Test"},"postlogin-class7-tests-linesandangles-pairofangles-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - PT - Test - Close"},"postlogin-class7-tests-linesandangles-pairofangles-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - PT - Test - Submit Test"},"postlogin-class7-tests-linesandangles-pairofangles-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - PT - Scorecard - View Solutions"},"postlogin-class7-tests-linesandangles-pairofangles-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-linesandangles-pairofangles-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-linesandangles-pairofangles-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - CP - Start"},"postlogin-class7-tests-linesandangles-pairofangles-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - CP - Start - Start Practice"},"postlogin-class7-tests-linesandangles-pairofangles-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - CP - Start - Close"},"postlogin-class7-tests-linesandangles-pairofangles-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - CP - Start - Start Practice - Close"},"postlogin-class7-tests-linesandangles-pairofangles-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - CP - Start - Start Practice - Check"},"postlogin-class7-tests-linesandangles-pairofangles-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - CP - Resume"},"postlogin-class7-tests-linesandangles-pairofangles-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - CP - Resume - Continue"},"postlogin-class7-tests-linesandangles-pairofangles-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - CP - Resume - Close"},"postlogin-class7-tests-linesandangles-pairofangles-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - CP - Resume - Continue - Close"},"postlogin-class7-tests-linesandangles-pairofangles-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - CP - Resume - Continue - Check"},"postlogin-class7-tests-linesandangles-pairofangles-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Pair of Angles - CP - Report"},"postlogin-class7-tests-linesandangles-moreonpairofangles-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - PT - Start"},"postlogin-class7-tests-linesandangles-moreonpairofangles-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - PT - Resume"},"postlogin-class7-tests-linesandangles-moreonpairofangles-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - PT - Report"},"postlogin-class7-tests-linesandangles-moreonpairofangles-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - PT - Start - Start Test"},"postlogin-class7-tests-linesandangles-moreonpairofangles-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - PT - Close"},"postlogin-class7-tests-linesandangles-moreonpairofangles-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - PT - Resume - Continue Test"},"postlogin-class7-tests-linesandangles-moreonpairofangles-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - PT - Test - Close"},"postlogin-class7-tests-linesandangles-moreonpairofangles-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - PT - Test - Submit Test"},"postlogin-class7-tests-linesandangles-moreonpairofangles-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - PT - Scorecard - View Solutions"},"postlogin-class7-tests-linesandangles-moreonpairofangles-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-linesandangles-moreonpairofangles-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-linesandangles-moreonpairofangles-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-linesandangles-moreonpairofangles-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-linesandangles-moreonpairofangles-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-linesandangles-moreonpairofangles-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-linesandangles-moreonpairofangles-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-linesandangles-moreonpairofangles-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-linesandangles-moreonpairofangles-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-linesandangles-moreonpairofangles-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-linesandangles-moreonpairofangles-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-linesandangles-moreonpairofangles-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-linesandangles-moreonpairofangles-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-linesandangles-moreonpairofangles-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-linesandangles-moreonpairofangles-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-linesandangles-moreonpairofangles-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - CP - Start"},"postlogin-class7-tests-linesandangles-moreonpairofangles-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - CP - Start - Start Practice"},"postlogin-class7-tests-linesandangles-moreonpairofangles-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - CP - Start - Close"},"postlogin-class7-tests-linesandangles-moreonpairofangles-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - CP - Start - Start Practice - Close"},"postlogin-class7-tests-linesandangles-moreonpairofangles-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - CP - Start - Start Practice - Check"},"postlogin-class7-tests-linesandangles-moreonpairofangles-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - CP - Resume"},"postlogin-class7-tests-linesandangles-moreonpairofangles-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - CP - Resume - Continue"},"postlogin-class7-tests-linesandangles-moreonpairofangles-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - CP - Resume - Close"},"postlogin-class7-tests-linesandangles-moreonpairofangles-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - CP - Resume - Continue - Close"},"postlogin-class7-tests-linesandangles-moreonpairofangles-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - CP - Resume - Continue - Check"},"postlogin-class7-tests-linesandangles-moreonpairofangles-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - More on Pair of Angles - CP - Report"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - PT - Start"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - PT - Resume"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - PT - Report"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - PT - Start - Start Test"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - PT - Close"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - PT - Resume - Continue Test"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - PT - Test - Close"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - PT - Test - Submit Test"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - PT - Scorecard - View Solutions"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - CP - Start"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - CP - Start - Start Practice"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - CP - Start - Close"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - CP - Start - Start Practice - Close"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - CP - Start - Start Practice - Check"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - CP - Resume"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - CP - Resume - Continue"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - CP - Resume - Close"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - CP - Resume - Continue - Close"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - CP - Resume - Continue - Check"},"postlogin-class7-tests-linesandangles-anglesmadebytransversal-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Lines and Angles - Angles Made by Transversal - CP - Report"},"postlogin-class8-tests-cubesandcuberoots-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Start"},"postlogin-class8-tests-cubesandcuberoots-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Resume"},"postlogin-class8-tests-cubesandcuberoots-revise":{"event_label":"Revise topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Revise"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - PT - Start"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - PT - Resume"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - PT - Report"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - PT - Start - Start Test"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - PT - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - PT - Resume - Continue Test"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - PT - Test - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - PT - Test - Submit Test"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - PT - Scorecard - View Solutions"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - CP - Start"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - CP - Start - Start Practice"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - CP - Start - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - CP - Start - Start Practice - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - CP - Start - Start Practice - Check"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - CP - Resume"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - CP - Resume - Continue"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - CP - Resume - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - CP - Resume - Continue - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - CP - Resume - Continue - Check"},"postlogin-class8-tests-cubesandcuberoots-findingcubeofanumber-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube of a Number - CP - Report"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - PT - Start"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - PT - Resume"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - PT - Report"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - PT - Start - Start Test"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - PT - Close"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - PT - Resume - Continue Test"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - PT - Test - Close"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - PT - Test - Submit Test"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - PT - Scorecard - View Solutions"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - CP - Start"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - CP - Start - Start Practice"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - CP - Start - Close"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - CP - Start - Start Practice - Close"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - CP - Start - Start Practice - Check"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - CP - Resume"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - CP - Resume - Continue"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - CP - Resume - Close"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - CP - Resume - Continue - Close"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - CP - Resume - Continue - Check"},"postlogin-class8-tests-cubesandcuberoots-moreproblemsonfindingcube-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - More Problems on finding Cube - CP - Report"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - PT - Start"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - PT - Resume"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - PT - Report"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - PT - Start - Start Test"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - PT - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - PT - Resume - Continue Test"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - PT - Test - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - PT - Test - Submit Test"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - PT - Scorecard - View Solutions"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - CP - Start"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - CP - Start - Start Practice"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - CP - Start - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - CP - Start - Start Practice - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - CP - Start - Start Practice - Check"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - CP - Resume"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - CP - Resume - Continue"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - CP - Resume - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - CP - Resume - Continue - Close"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - CP - Resume - Continue - Check"},"postlogin-class8-tests-cubesandcuberoots-findingcuberoot-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Cubes and Cube Roots - Finding Cube Root - CP - Report"},"postlogin-class10-tests-applicationsoftrignometry-start":{"event_label":"Start topic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Start"},"postlogin-class10-tests-applicationsoftrignometry-resume":{"event_label":"Resume topic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Resume"},"postlogin-class10-tests-applicationsoftrignometry-revise":{"event_label":"Revise topic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Revise"},"postlogin-class10-tests-applicationsoftrignometry-depression-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - PT - Start"},"postlogin-class10-tests-applicationsoftrignometry-depression-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - PT - Resume"},"postlogin-class10-tests-applicationsoftrignometry-depression-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - PT - Report"},"postlogin-class10-tests-applicationsoftrignometry-depression-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - PT - Start - Start Test"},"postlogin-class10-tests-applicationsoftrignometry-depression-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - PT - Close"},"postlogin-class10-tests-applicationsoftrignometry-depression-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - PT - Resume - Continue Test"},"postlogin-class10-tests-applicationsoftrignometry-depression-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - PT - Test - Close"},"postlogin-class10-tests-applicationsoftrignometry-depression-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - PT - Test - Submit Test"},"postlogin-class10-tests-applicationsoftrignometry-depression-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - PT - Scorecard - View Solutions"},"postlogin-class10-tests-applicationsoftrignometry-depression-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-applicationsoftrignometry-depression-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-applicationsoftrignometry-depression-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-applicationsoftrignometry-depression-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-applicationsoftrignometry-depression-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-applicationsoftrignometry-depression-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-applicationsoftrignometry-depression-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-applicationsoftrignometry-depression-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-applicationsoftrignometry-depression-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-applicationsoftrignometry-depression-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-applicationsoftrignometry-depression-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-applicationsoftrignometry-depression-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-applicationsoftrignometry-depression-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-applicationsoftrignometry-depression-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-applicationsoftrignometry-depression-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-applicationsoftrignometry-depression-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - CP - Start"},"postlogin-class10-tests-applicationsoftrignometry-depression-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - CP - Start - Start Practice"},"postlogin-class10-tests-applicationsoftrignometry-depression-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - CP - Start - Close"},"postlogin-class10-tests-applicationsoftrignometry-depression-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - CP - Start - Start Practice - Close"},"postlogin-class10-tests-applicationsoftrignometry-depression-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - CP - Start - Start Practice - Check"},"postlogin-class10-tests-applicationsoftrignometry-depression-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - CP - Resume"},"postlogin-class10-tests-applicationsoftrignometry-depression-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - CP - Resume - Continue"},"postlogin-class10-tests-applicationsoftrignometry-depression-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - CP - Resume - Close"},"postlogin-class10-tests-applicationsoftrignometry-depression-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - CP - Resume - Continue - Close"},"postlogin-class10-tests-applicationsoftrignometry-depression-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - CP - Resume - Continue - Check"},"postlogin-class10-tests-applicationsoftrignometry-depression-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Depression - CP - Report"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - PT - Start"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - PT - Resume"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - PT - Report"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - PT - Start - Start Test"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - PT - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - PT - Resume - Continue Test"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - PT - Test - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - PT - Test - Submit Test"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - PT - Scorecard - View Solutions"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - CP - Start"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - CP - Start - Start Practice"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - CP - Start - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - CP - Start - Start Practice - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - CP - Start - Start Practice - Check"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - CP - Resume"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - CP - Resume - Continue"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - CP - Resume - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - CP - Resume - Continue - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - CP - Resume - Continue - Check"},"postlogin-class10-tests-applicationsoftrignometry-elevationi-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation I - CP - Report"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-pt-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - PT - Start"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - PT - Resume"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-pt-report":{"event_label":"View report PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - PT - Report"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - PT - Start - Start Test"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - PT - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - PT - Resume - Continue Test"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-pt-test-close":{"event_label":"Close PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - PT - Test - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - PT - Test - Submit Test"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - PT - Scorecard - View Solutions"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - PT - Scorecard - View Solutions - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - PT - Scorecard - View Recommendations"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - PT - Scorecard - View Recommendations - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-cp-start":{"event_label":"Start Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - CP - Start"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - CP - Start - Start Practice"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - CP - Start - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - CP - Start - Start Practice - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - CP - Start - Start Practice - Check"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-cp-resume":{"event_label":"Continue Practice","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - CP - Resume"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - CP - Resume - Continue"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - CP - Resume - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - CP - Resume - Continue - Close"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - CP - Resume - Continue - Check"},"postlogin-class10-tests-applicationsoftrignometry-elevationii-cp-report":{"event_label":"View report CP","event_category":"Class 10","event_action":"Post login - Class 10 - Tests - Applications of Trignometry - Elevation II - CP - Report"},"postlogin-class1-lessons-datahandling-start":{"event_label":"Start topic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons - Data Handling - Start"},"postlogin-class1-lessons-datahandling-resume":{"event_label":"Resume topic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons - Data Handling - Resume"},"postlogin-class1-lessons-datahandling-watched":{"event_label":"Rewatch topic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons - Data Handling - Watched"},"postlogin-class1-lessons-datahandling-organisingandsorting-start":{"event_label":"Start subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Data Handling - Organising and Sorting - Start"},"postlogin-class1-lessons-datahandling-organisingandsorting-resume":{"event_label":"Resume subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Data Handling - Organising and Sorting - Resume"},"postlogin-class1-lessons-datahandling-organisingandsorting-watched":{"event_label":"Rewatch subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Data Handling - Organising and Sorting - Watched"},"postlogin-class1-lessons-datahandling-organisingandsorting-lessons":{"event_label":"Class 1 lessons","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Data Handling - Organising and Sorting - Lessons"},"postlogin-class1-lessons-datahandling-organisingandsorting-close":{"event_label":"Close subtopic","event_category":"Class 1","event_action":"Post login - Class 1 - Lessons  - Data Handling - Organising and Sorting - Close"},"postlogin-class2-lessons-money-start":{"event_label":"Start topic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons - Money - Start"},"postlogin-class2-lessons-money-resume":{"event_label":"Resume topic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons - Money - Resume"},"postlogin-class2-lessons-money-watched":{"event_label":"Rewatch topic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons - Money - Watched"},"postlogin-class2-lessons-money-conversionofmoney-start":{"event_label":"Start subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Money - Conversion of Money - Start"},"postlogin-class2-lessons-money-conversionofmoney-resume":{"event_label":"Resume subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Money - Conversion of Money - Resume"},"postlogin-class2-lessons-money-conversionofmoney-watched":{"event_label":"Rewatch subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Money - Conversion of Money - Watched"},"postlogin-class2-lessons-money-conversionofmoney-lessons":{"event_label":"Class 2 lessons","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Money - Conversion of Money - Lessons"},"postlogin-class2-lessons-money-conversionofmoney-close":{"event_label":"Close subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Money - Conversion of Money - Close"},"postlogin-class3-lessons-time-start":{"event_label":"Start topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Time - Start"},"postlogin-class3-lessons-time-resume":{"event_label":"Resume topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Time - Resume"},"postlogin-class3-lessons-time-watched":{"event_label":"Rewatch topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Time - Watched"},"postlogin-class3-lessons-time-clock-start":{"event_label":"Start subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Time - Clock - Start"},"postlogin-class3-lessons-time-clock-resume":{"event_label":"Resume subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Time - Clock - Resume"},"postlogin-class3-lessons-time-clock-watched":{"event_label":"Rewatch subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Time - Clock - Watched"},"postlogin-class3-lessons-time-clock-lessons":{"event_label":"Class 3 lessons","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Time - Clock - Lessons"},"postlogin-class3-lessons-time-clock-close":{"event_label":"Close subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Time - Clock - Close"},"postlogin-class4-lessons-measurement-start":{"event_label":"Start topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Measurement - Start"},"postlogin-class4-lessons-measurement-resume":{"event_label":"Resume topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Measurement - Resume"},"postlogin-class4-lessons-measurement-watched":{"event_label":"Rewatch topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Measurement - Watched"},"postlogin-class4-lessons-measurement-length-start":{"event_label":"Start subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Measurement - Length - Start"},"postlogin-class4-lessons-measurement-length-resume":{"event_label":"Resume subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Measurement - Length - Resume"},"postlogin-class4-lessons-measurement-length-watched":{"event_label":"Rewatch subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Measurement - Length - Watched"},"postlogin-class4-lessons-measurement-length-lessons":{"event_label":"Class 4 lessons","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Measurement - Length - Lessons"},"postlogin-class4-lessons-measurement-length-close":{"event_label":"Close subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Measurement - Length - Close"},"postlogin-class4-lessons-measurement-mass-start":{"event_label":"Start subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Measurement - Mass - Start"},"postlogin-class4-lessons-measurement-mass-resume":{"event_label":"Resume subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Measurement - Mass - Resume"},"postlogin-class4-lessons-measurement-mass-watched":{"event_label":"Rewatch subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Measurement - Mass - Watched"},"postlogin-class4-lessons-measurement-mass-lessons":{"event_label":"Class 4 lessons","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Measurement - Mass - Lessons"},"postlogin-class4-lessons-measurement-mass-close":{"event_label":"Close subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Measurement - Mass - Close"},"postlogin-class4-lessons-measurement-capacity-start":{"event_label":"Start subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Measurement - Capacity - Start"},"postlogin-class4-lessons-measurement-capacity-resume":{"event_label":"Resume subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Measurement - Capacity - Resume"},"postlogin-class4-lessons-measurement-capacity-watched":{"event_label":"Rewatch subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Measurement - Capacity - Watched"},"postlogin-class4-lessons-measurement-capacity-lessons":{"event_label":"Class 4 lessons","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Measurement - Capacity - Lessons"},"postlogin-class4-lessons-measurement-capacity-close":{"event_label":"Close subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Measurement - Capacity - Close"},"postlogin-class5-lessons-percentages-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Percentages - Start"},"postlogin-class5-lessons-percentages-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Percentages - Resume"},"postlogin-class5-lessons-percentages-watched":{"event_label":"Rewatch topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Percentages - Watched"},"postlogin-class5-lessons-percentages-introductiontopercentages-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Percentages - Introduction to Percentages - Start"},"postlogin-class5-lessons-percentages-introductiontopercentages-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Percentages - Introduction to Percentages - Resume"},"postlogin-class5-lessons-percentages-introductiontopercentages-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Percentages - Introduction to Percentages - Watched"},"postlogin-class5-lessons-percentages-introductiontopercentages-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Percentages - Introduction to Percentages - Lessons"},"postlogin-class5-lessons-percentages-introductiontopercentages-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Percentages - Introduction to Percentages - Close"},"postlogin-class6-lessons-fractions-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Fractions - Start"},"postlogin-class6-lessons-fractions-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Fractions - Resume"},"postlogin-class6-lessons-fractions-watched":{"event_label":"Rewatch topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Fractions - Watched"},"postlogin-class6-lessons-fractions-typesoffractions-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Fractions - Types of Fractions - Start"},"postlogin-class6-lessons-fractions-typesoffractions-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Fractions - Types of Fractions - Resume"},"postlogin-class6-lessons-fractions-typesoffractions-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Fractions - Types of Fractions - Watched"},"postlogin-class6-lessons-fractions-typesoffractions-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Fractions - Types of Fractions - Lessons"},"postlogin-class6-lessons-fractions-typesoffractions-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Fractions - Types of Fractions - Close"},"postlogin-class6-lessons-fractions-comparingandorderingfraction-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Fractions - Comparing and Ordering Fraction - Start"},"postlogin-class6-lessons-fractions-comparingandorderingfraction-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Fractions - Comparing and Ordering Fraction - Resume"},"postlogin-class6-lessons-fractions-comparingandorderingfraction-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Fractions - Comparing and Ordering Fraction - Watched"},"postlogin-class6-lessons-fractions-comparingandorderingfraction-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Fractions - Comparing and Ordering Fraction - Lessons"},"postlogin-class6-lessons-fractions-comparingandorderingfraction-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Fractions - Comparing and Ordering Fraction - Close"},"postlogin-class6-lessons-fractions-additionandsubtractionoffractions-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Fractions - Addition and Subtraction of Fractions - Start"},"postlogin-class6-lessons-fractions-additionandsubtractionoffractions-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Fractions - Addition and Subtraction of Fractions - Resume"},"postlogin-class6-lessons-fractions-additionandsubtractionoffractions-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Fractions - Addition and Subtraction of Fractions - Watched"},"postlogin-class6-lessons-fractions-additionandsubtractionoffractions-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Fractions - Addition and Subtraction of Fractions - Lessons"},"postlogin-class6-lessons-fractions-additionandsubtractionoffractions-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Fractions - Addition and Subtraction of Fractions - Close"},"postlogin-class7-lessons-triangleanditsproperties-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Triangle and its Properties - Start"},"postlogin-class7-lessons-triangleanditsproperties-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Triangle and its Properties - Resume"},"postlogin-class7-lessons-triangleanditsproperties-watched":{"event_label":"Rewatch topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Triangle and its Properties - Watched"},"postlogin-class7-lessons-triangleanditsproperties-triangleinequality-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Triangle and its Properties - Triangle Inequality - Start"},"postlogin-class7-lessons-triangleanditsproperties-triangleinequality-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Triangle and its Properties - Triangle Inequality - Resume"},"postlogin-class7-lessons-triangleanditsproperties-triangleinequality-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Triangle and its Properties - Triangle Inequality - Watched"},"postlogin-class7-lessons-triangleanditsproperties-triangleinequality-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Triangle and its Properties - Triangle Inequality - Lessons"},"postlogin-class7-lessons-triangleanditsproperties-triangleinequality-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Triangle and its Properties - Triangle Inequality - Close"},"postlogin-class7-lessons-triangleanditsproperties-pythagorastheorem-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Triangle and its Properties - Pythagoras Theorem - Start"},"postlogin-class7-lessons-triangleanditsproperties-pythagorastheorem-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Triangle and its Properties - Pythagoras Theorem - Resume"},"postlogin-class7-lessons-triangleanditsproperties-pythagorastheorem-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Triangle and its Properties - Pythagoras Theorem - Watched"},"postlogin-class7-lessons-triangleanditsproperties-pythagorastheorem-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Triangle and its Properties - Pythagoras Theorem - Lessons"},"postlogin-class7-lessons-triangleanditsproperties-pythagorastheorem-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Triangle and its Properties - Pythagoras Theorem - Close"},"postlogin-class7-lessons-triangleanditsproperties-triangles-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Triangle and its Properties - Triangles - Start"},"postlogin-class7-lessons-triangleanditsproperties-triangles-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Triangle and its Properties - Triangles - Resume"},"postlogin-class7-lessons-triangleanditsproperties-triangles-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Triangle and its Properties - Triangles - Watched"},"postlogin-class7-lessons-triangleanditsproperties-triangles-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Triangle and its Properties - Triangles - Lessons"},"postlogin-class7-lessons-triangleanditsproperties-triangles-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Triangle and its Properties - Triangles - Close"},"postlogin-class7-lessons-triangleanditsproperties-angleproperty-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Triangle and its Properties - Angle Property - Start"},"postlogin-class7-lessons-triangleanditsproperties-angleproperty-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Triangle and its Properties - Angle Property - Resume"},"postlogin-class7-lessons-triangleanditsproperties-angleproperty-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Triangle and its Properties - Angle Property - Watched"},"postlogin-class7-lessons-triangleanditsproperties-angleproperty-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Triangle and its Properties - Angle Property - Lessons"},"postlogin-class7-lessons-triangleanditsproperties-angleproperty-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Triangle and its Properties - Angle Property - Close"},"postlogin-class8-lessons-comparingquantities-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Comparing Quantities - Start"},"postlogin-class8-lessons-comparingquantities-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Comparing Quantities - Resume"},"postlogin-class8-lessons-comparingquantities-watched":{"event_label":"Rewatch topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Comparing Quantities - Watched"},"postlogin-class8-lessons-comparingquantities-ratioandpercentage-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Comparing Quantities - Ratio and Percentage - Start"},"postlogin-class8-lessons-comparingquantities-ratioandpercentage-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Comparing Quantities - Ratio and Percentage - Resume"},"postlogin-class8-lessons-comparingquantities-ratioandpercentage-watched":{"event_label":"Rewatch subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Comparing Quantities - Ratio and Percentage - Watched"},"postlogin-class8-lessons-comparingquantities-ratioandpercentage-lessons":{"event_label":"Class 8 lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Comparing Quantities - Ratio and Percentage - Lessons"},"postlogin-class8-lessons-comparingquantities-ratioandpercentage-close":{"event_label":"Close subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Comparing Quantities - Ratio and Percentage - Close"},"postlogin-class8-lessons-comparingquantities-profit,lossanddiscount-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Comparing Quantities - Profit, Loss and Discount - Start"},"postlogin-class8-lessons-comparingquantities-profit,lossanddiscount-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Comparing Quantities - Profit, Loss and Discount - Resume"},"postlogin-class8-lessons-comparingquantities-profit,lossanddiscount-watched":{"event_label":"Rewatch subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Comparing Quantities - Profit, Loss and Discount - Watched"},"postlogin-class8-lessons-comparingquantities-profit,lossanddiscount-lessons":{"event_label":"Class 8 lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Comparing Quantities - Profit, Loss and Discount - Lessons"},"postlogin-class8-lessons-comparingquantities-profit,lossanddiscount-close":{"event_label":"Close subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Comparing Quantities - Profit, Loss and Discount - Close"},"postlogin-class8-lessons-comparingquantities-salestaxandinterest-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Comparing Quantities - Sales Tax and Interest - Start"},"postlogin-class8-lessons-comparingquantities-salestaxandinterest-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Comparing Quantities - Sales Tax and Interest - Resume"},"postlogin-class8-lessons-comparingquantities-salestaxandinterest-watched":{"event_label":"Rewatch subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Comparing Quantities - Sales Tax and Interest - Watched"},"postlogin-class8-lessons-comparingquantities-salestaxandinterest-lessons":{"event_label":"Class 8 lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Comparing Quantities - Sales Tax and Interest - Lessons"},"postlogin-class8-lessons-comparingquantities-salestaxandinterest-close":{"event_label":"Close subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Comparing Quantities - Sales Tax and Interest - Close"},"postlogin-class10-lessons-statisticsandprobability-start":{"event_label":"Start topic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons - Statistics and Probability - Start"},"postlogin-class10-lessons-statisticsandprobability-resume":{"event_label":"Resume topic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons - Statistics and Probability - Resume"},"postlogin-class10-lessons-statisticsandprobability-watched":{"event_label":"Rewatch topic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons - Statistics and Probability - Watched"},"postlogin-class10-lessons-statisticsandprobability-statistics-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Statistics and Probability - Statistics - Start"},"postlogin-class10-lessons-statisticsandprobability-statistics-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Statistics and Probability - Statistics - Resume"},"postlogin-class10-lessons-statisticsandprobability-statistics-watched":{"event_label":"Rewatch subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Statistics and Probability - Statistics - Watched"},"postlogin-class10-lessons-statisticsandprobability-statistics-lessons":{"event_label":"Class 10 lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Statistics and Probability - Statistics - Lessons"},"postlogin-class10-lessons-statisticsandprobability-statistics-close":{"event_label":"Close subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Statistics and Probability - Statistics - Close"},"postlogin-class10-lessons-statisticsandprobability-probability-start":{"event_label":"Start subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Statistics and Probability - Probability - Start"},"postlogin-class10-lessons-statisticsandprobability-probability-resume":{"event_label":"Resume subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Statistics and Probability - Probability - Resume"},"postlogin-class10-lessons-statisticsandprobability-probability-watched":{"event_label":"Rewatch subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Statistics and Probability - Probability - Watched"},"postlogin-class10-lessons-statisticsandprobability-probability-lessons":{"event_label":"Class 10 lessons","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Statistics and Probability - Probability - Lessons"},"postlogin-class10-lessons-statisticsandprobability-probability-close":{"event_label":"Close subtopic","event_category":"Class 10","event_action":"Post login - Class 10 - Lessons  - Statistics and Probability - Probability - Close"},"postlogin-class5-tests-percentages-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Start"},"postlogin-class5-tests-percentages-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Resume"},"postlogin-class5-tests-percentages-revise":{"event_label":"Revise topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Revise"},"postlogin-class5-tests-percentages-introductiontopercentages-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - PT - Start"},"postlogin-class5-tests-percentages-introductiontopercentages-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - PT - Resume"},"postlogin-class5-tests-percentages-introductiontopercentages-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - PT - Report"},"postlogin-class5-tests-percentages-introductiontopercentages-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - PT - Start - Start Test"},"postlogin-class5-tests-percentages-introductiontopercentages-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - PT - Close"},"postlogin-class5-tests-percentages-introductiontopercentages-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - PT - Resume - Continue Test"},"postlogin-class5-tests-percentages-introductiontopercentages-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - PT - Test - Close"},"postlogin-class5-tests-percentages-introductiontopercentages-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - PT - Test - Submit Test"},"postlogin-class5-tests-percentages-introductiontopercentages-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - PT - Scorecard - View Solutions"},"postlogin-class5-tests-percentages-introductiontopercentages-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-percentages-introductiontopercentages-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-percentages-introductiontopercentages-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-percentages-introductiontopercentages-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-percentages-introductiontopercentages-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-percentages-introductiontopercentages-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-percentages-introductiontopercentages-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-percentages-introductiontopercentages-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-percentages-introductiontopercentages-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-percentages-introductiontopercentages-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-percentages-introductiontopercentages-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-percentages-introductiontopercentages-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-percentages-introductiontopercentages-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-percentages-introductiontopercentages-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-percentages-introductiontopercentages-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-percentages-introductiontopercentages-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - CP - Start"},"postlogin-class5-tests-percentages-introductiontopercentages-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - CP - Start - Start Practice"},"postlogin-class5-tests-percentages-introductiontopercentages-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - CP - Start - Close"},"postlogin-class5-tests-percentages-introductiontopercentages-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - CP - Start - Start Practice - Close"},"postlogin-class5-tests-percentages-introductiontopercentages-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - CP - Start - Start Practice - Check"},"postlogin-class5-tests-percentages-introductiontopercentages-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - CP - Resume"},"postlogin-class5-tests-percentages-introductiontopercentages-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - CP - Resume - Continue"},"postlogin-class5-tests-percentages-introductiontopercentages-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - CP - Resume - Close"},"postlogin-class5-tests-percentages-introductiontopercentages-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - CP - Resume - Continue - Close"},"postlogin-class5-tests-percentages-introductiontopercentages-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - CP - Resume - Continue - Check"},"postlogin-class5-tests-percentages-introductiontopercentages-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - Introduction to Percentages - CP - Report"},"postlogin-class5-tests-percentages-moreonpercentages-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - PT - Start"},"postlogin-class5-tests-percentages-moreonpercentages-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - PT - Resume"},"postlogin-class5-tests-percentages-moreonpercentages-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - PT - Report"},"postlogin-class5-tests-percentages-moreonpercentages-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - PT - Start - Start Test"},"postlogin-class5-tests-percentages-moreonpercentages-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - PT - Close"},"postlogin-class5-tests-percentages-moreonpercentages-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - PT - Resume - Continue Test"},"postlogin-class5-tests-percentages-moreonpercentages-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - PT - Test - Close"},"postlogin-class5-tests-percentages-moreonpercentages-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - PT - Test - Submit Test"},"postlogin-class5-tests-percentages-moreonpercentages-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - PT - Scorecard - View Solutions"},"postlogin-class5-tests-percentages-moreonpercentages-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-percentages-moreonpercentages-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-percentages-moreonpercentages-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-percentages-moreonpercentages-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-percentages-moreonpercentages-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-percentages-moreonpercentages-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-percentages-moreonpercentages-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-percentages-moreonpercentages-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-percentages-moreonpercentages-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-percentages-moreonpercentages-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-percentages-moreonpercentages-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-percentages-moreonpercentages-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-percentages-moreonpercentages-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-percentages-moreonpercentages-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-percentages-moreonpercentages-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-percentages-moreonpercentages-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - CP - Start"},"postlogin-class5-tests-percentages-moreonpercentages-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - CP - Start - Start Practice"},"postlogin-class5-tests-percentages-moreonpercentages-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - CP - Start - Close"},"postlogin-class5-tests-percentages-moreonpercentages-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - CP - Start - Start Practice - Close"},"postlogin-class5-tests-percentages-moreonpercentages-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - CP - Start - Start Practice - Check"},"postlogin-class5-tests-percentages-moreonpercentages-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - CP - Resume"},"postlogin-class5-tests-percentages-moreonpercentages-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - CP - Resume - Continue"},"postlogin-class5-tests-percentages-moreonpercentages-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - CP - Resume - Close"},"postlogin-class5-tests-percentages-moreonpercentages-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - CP - Resume - Continue - Close"},"postlogin-class5-tests-percentages-moreonpercentages-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - CP - Resume - Continue - Check"},"postlogin-class5-tests-percentages-moreonpercentages-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Percentages - More on Percentages - CP - Report"},"postlogin-class6-tests-fractions-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Start"},"postlogin-class6-tests-fractions-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Resume"},"postlogin-class6-tests-fractions-revise":{"event_label":"Revise topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Revise"},"postlogin-class6-tests-fractions-typesoffractions-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - PT - Start"},"postlogin-class6-tests-fractions-typesoffractions-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - PT - Resume"},"postlogin-class6-tests-fractions-typesoffractions-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - PT - Report"},"postlogin-class6-tests-fractions-typesoffractions-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - PT - Start - Start Test"},"postlogin-class6-tests-fractions-typesoffractions-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - PT - Close"},"postlogin-class6-tests-fractions-typesoffractions-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - PT - Resume - Continue Test"},"postlogin-class6-tests-fractions-typesoffractions-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - PT - Test - Close"},"postlogin-class6-tests-fractions-typesoffractions-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - PT - Test - Submit Test"},"postlogin-class6-tests-fractions-typesoffractions-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - PT - Scorecard - View Solutions"},"postlogin-class6-tests-fractions-typesoffractions-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-fractions-typesoffractions-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-fractions-typesoffractions-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-fractions-typesoffractions-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-fractions-typesoffractions-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-fractions-typesoffractions-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-fractions-typesoffractions-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-fractions-typesoffractions-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-fractions-typesoffractions-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-fractions-typesoffractions-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-fractions-typesoffractions-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-fractions-typesoffractions-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-fractions-typesoffractions-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-fractions-typesoffractions-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-fractions-typesoffractions-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-fractions-typesoffractions-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - CP - Start"},"postlogin-class6-tests-fractions-typesoffractions-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - CP - Start - Start Practice"},"postlogin-class6-tests-fractions-typesoffractions-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - CP - Start - Close"},"postlogin-class6-tests-fractions-typesoffractions-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - CP - Start - Start Practice - Close"},"postlogin-class6-tests-fractions-typesoffractions-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - CP - Start - Start Practice - Check"},"postlogin-class6-tests-fractions-typesoffractions-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - CP - Resume"},"postlogin-class6-tests-fractions-typesoffractions-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - CP - Resume - Continue"},"postlogin-class6-tests-fractions-typesoffractions-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - CP - Resume - Close"},"postlogin-class6-tests-fractions-typesoffractions-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - CP - Resume - Continue - Close"},"postlogin-class6-tests-fractions-typesoffractions-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - CP - Resume - Continue - Check"},"postlogin-class6-tests-fractions-typesoffractions-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Types of Fractions - CP - Report"},"postlogin-class6-tests-fractions-comparingandorderingfraction-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - PT - Start"},"postlogin-class6-tests-fractions-comparingandorderingfraction-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - PT - Resume"},"postlogin-class6-tests-fractions-comparingandorderingfraction-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - PT - Report"},"postlogin-class6-tests-fractions-comparingandorderingfraction-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - PT - Start - Start Test"},"postlogin-class6-tests-fractions-comparingandorderingfraction-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - PT - Close"},"postlogin-class6-tests-fractions-comparingandorderingfraction-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - PT - Resume - Continue Test"},"postlogin-class6-tests-fractions-comparingandorderingfraction-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - PT - Test - Close"},"postlogin-class6-tests-fractions-comparingandorderingfraction-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - PT - Test - Submit Test"},"postlogin-class6-tests-fractions-comparingandorderingfraction-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - PT - Scorecard - View Solutions"},"postlogin-class6-tests-fractions-comparingandorderingfraction-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-fractions-comparingandorderingfraction-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-fractions-comparingandorderingfraction-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-fractions-comparingandorderingfraction-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-fractions-comparingandorderingfraction-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-fractions-comparingandorderingfraction-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-fractions-comparingandorderingfraction-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-fractions-comparingandorderingfraction-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-fractions-comparingandorderingfraction-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-fractions-comparingandorderingfraction-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-fractions-comparingandorderingfraction-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-fractions-comparingandorderingfraction-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-fractions-comparingandorderingfraction-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-fractions-comparingandorderingfraction-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-fractions-comparingandorderingfraction-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-fractions-comparingandorderingfraction-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - CP - Start"},"postlogin-class6-tests-fractions-comparingandorderingfraction-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - CP - Start - Start Practice"},"postlogin-class6-tests-fractions-comparingandorderingfraction-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - CP - Start - Close"},"postlogin-class6-tests-fractions-comparingandorderingfraction-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - CP - Start - Start Practice - Close"},"postlogin-class6-tests-fractions-comparingandorderingfraction-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - CP - Start - Start Practice - Check"},"postlogin-class6-tests-fractions-comparingandorderingfraction-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - CP - Resume"},"postlogin-class6-tests-fractions-comparingandorderingfraction-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - CP - Resume - Continue"},"postlogin-class6-tests-fractions-comparingandorderingfraction-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - CP - Resume - Close"},"postlogin-class6-tests-fractions-comparingandorderingfraction-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - CP - Resume - Continue - Close"},"postlogin-class6-tests-fractions-comparingandorderingfraction-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - CP - Resume - Continue - Check"},"postlogin-class6-tests-fractions-comparingandorderingfraction-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Comparing and Ordering Fraction - CP - Report"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Start"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Resume"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Report"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Start - Start Test"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Close"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Resume - Continue Test"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Test - Close"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Test - Submit Test"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Solutions"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - CP - Start"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - CP - Start - Start Practice"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - CP - Start - Close"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - CP - Start - Start Practice - Close"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - CP - Start - Start Practice - Check"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - CP - Resume"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - CP - Resume - Continue"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - CP - Resume - Close"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - CP - Resume - Continue - Close"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - CP - Resume - Continue - Check"},"postlogin-class6-tests-fractions-additionandsubtractionoffractions-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Fractions - Addition and Subtraction of Fractions - CP - Report"},"postlogin-class7-tests-triangleanditsproperties-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Start"},"postlogin-class7-tests-triangleanditsproperties-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Resume"},"postlogin-class7-tests-triangleanditsproperties-revise":{"event_label":"Revise topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Revise"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - PT - Start"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - PT - Resume"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - PT - Report"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - PT - Start - Start Test"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - PT - Close"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - PT - Resume - Continue Test"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - PT - Test - Close"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - PT - Test - Submit Test"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - PT - Scorecard - View Solutions"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - CP - Start"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - CP - Start - Start Practice"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - CP - Start - Close"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - CP - Start - Start Practice - Close"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - CP - Start - Start Practice - Check"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - CP - Resume"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - CP - Resume - Continue"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - CP - Resume - Close"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - CP - Resume - Continue - Close"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - CP - Resume - Continue - Check"},"postlogin-class7-tests-triangleanditsproperties-anglesumproperty-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Angle Sum Property - CP - Report"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - PT - Start"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - PT - Resume"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - PT - Report"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - PT - Start - Start Test"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - PT - Close"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - PT - Resume - Continue Test"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - PT - Test - Close"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - PT - Test - Submit Test"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - PT - Scorecard - View Solutions"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - CP - Start"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - CP - Start - Start Practice"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - CP - Start - Close"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - CP - Start - Start Practice - Close"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - CP - Start - Start Practice - Check"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - CP - Resume"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - CP - Resume - Continue"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - CP - Resume - Close"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - CP - Resume - Continue - Close"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - CP - Resume - Continue - Check"},"postlogin-class7-tests-triangleanditsproperties-exteriorangleanditsproperty-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Exterior Angle and its Property - CP - Report"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - PT - Start"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - PT - Resume"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - PT - Report"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - PT - Start - Start Test"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - PT - Close"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - PT - Resume - Continue Test"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - PT - Test - Close"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - PT - Test - Submit Test"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - PT - Scorecard - View Solutions"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - CP - Start"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - CP - Start - Start Practice"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - CP - Start - Close"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - CP - Start - Start Practice - Close"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - CP - Start - Start Practice - Check"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - CP - Resume"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - CP - Resume - Continue"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - CP - Resume - Close"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - CP - Resume - Continue - Close"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - CP - Resume - Continue - Check"},"postlogin-class7-tests-triangleanditsproperties-triangleinequality-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Triangle Inequality - CP - Report"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - PT - Start"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - PT - Resume"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - PT - Report"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - PT - Start - Start Test"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - PT - Close"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - PT - Resume - Continue Test"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - PT - Test - Close"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - PT - Test - Submit Test"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - PT - Scorecard - View Solutions"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - CP - Start"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - CP - Start - Start Practice"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - CP - Start - Close"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - CP - Start - Start Practice - Close"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - CP - Start - Start Practice - Check"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - CP - Resume"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - CP - Resume - Continue"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - CP - Resume - Close"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - CP - Resume - Continue - Close"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - CP - Resume - Continue - Check"},"postlogin-class7-tests-triangleanditsproperties-pythagorastheorem-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Triangle and its Properties - Pythagoras Theorem - CP - Report"},"postlogin-class8-tests-comparingquantities-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Start"},"postlogin-class8-tests-comparingquantities-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Resume"},"postlogin-class8-tests-comparingquantities-revise":{"event_label":"Revise topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Revise"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - PT - Start"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - PT - Resume"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - PT - Report"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - PT - Start - Start Test"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - PT - Close"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - PT - Resume - Continue Test"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - PT - Test - Close"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - PT - Test - Submit Test"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - PT - Scorecard - View Solutions"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - CP - Start"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - CP - Start - Start Practice"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - CP - Start - Close"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - CP - Start - Start Practice - Close"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - CP - Start - Start Practice - Check"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - CP - Resume"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - CP - Resume - Continue"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - CP - Resume - Close"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - CP - Resume - Continue - Close"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - CP - Resume - Continue - Check"},"postlogin-class8-tests-comparingquantities-ratioandpercentage-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Ratio and Percentage - CP - Report"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - PT - Start"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - PT - Resume"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - PT - Report"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - PT - Start - Start Test"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - PT - Close"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - PT - Resume - Continue Test"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - PT - Test - Close"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - PT - Test - Submit Test"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - PT - Scorecard - View Solutions"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - CP - Start"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - CP - Start - Start Practice"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - CP - Start - Close"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - CP - Start - Start Practice - Close"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - CP - Start - Start Practice - Check"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - CP - Resume"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - CP - Resume - Continue"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - CP - Resume - Close"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - CP - Resume - Continue - Close"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - CP - Resume - Continue - Check"},"postlogin-class8-tests-comparingquantities-profit,lossanddiscount-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Profit, Loss and Discount - CP - Report"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - PT - Start"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - PT - Resume"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - PT - Report"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - PT - Start - Start Test"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - PT - Close"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - PT - Resume - Continue Test"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - PT - Test - Close"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - PT - Test - Submit Test"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - PT - Scorecard - View Solutions"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - CP - Start"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - CP - Start - Start Practice"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - CP - Start - Close"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - CP - Start - Start Practice - Close"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - CP - Start - Start Practice - Check"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - CP - Resume"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - CP - Resume - Continue"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - CP - Resume - Close"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - CP - Resume - Continue - Close"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - CP - Resume - Continue - Check"},"postlogin-class8-tests-comparingquantities-salestaxandinterest-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Comparing Quantities - Sales Tax and Interest - CP - Report"},"postlogin-class2-lessons-datahandling-start":{"event_label":"Start topic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons - Data Handling - Start"},"postlogin-class2-lessons-datahandling-resume":{"event_label":"Resume topic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons - Data Handling - Resume"},"postlogin-class2-lessons-datahandling-watched":{"event_label":"Rewatch topic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons - Data Handling - Watched"},"postlogin-class2-lessons-datahandling-sorting-start":{"event_label":"Start subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Data Handling - Sorting - Start"},"postlogin-class2-lessons-datahandling-sorting-resume":{"event_label":"Resume subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Data Handling - Sorting - Resume"},"postlogin-class2-lessons-datahandling-sorting-watched":{"event_label":"Rewatch subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Data Handling - Sorting - Watched"},"postlogin-class2-lessons-datahandling-sorting-lessons":{"event_label":"Class 2 lessons","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Data Handling - Sorting - Lessons"},"postlogin-class2-lessons-datahandling-sorting-close":{"event_label":"Close subtopic","event_category":"Class 2","event_action":"Post login - Class 2 - Lessons  - Data Handling - Sorting - Close"},"postlogin-class3-lessons-money-start":{"event_label":"Start topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Money - Start"},"postlogin-class3-lessons-money-resume":{"event_label":"Resume topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Money - Resume"},"postlogin-class3-lessons-money-watched":{"event_label":"Rewatch topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Money - Watched"},"postlogin-class3-lessons-money-operationswithmoney-start":{"event_label":"Start subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Money - Operations with Money - Start"},"postlogin-class3-lessons-money-operationswithmoney-resume":{"event_label":"Resume subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Money - Operations with Money - Resume"},"postlogin-class3-lessons-money-operationswithmoney-watched":{"event_label":"Rewatch subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Money - Operations with Money - Watched"},"postlogin-class3-lessons-money-operationswithmoney-lessons":{"event_label":"Class 3 lessons","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Money - Operations with Money - Lessons"},"postlogin-class3-lessons-money-operationswithmoney-close":{"event_label":"Close subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Money - Operations with Money - Close"},"postlogin-class4-lessons-areaandperimeter-start":{"event_label":"Start topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Area and Perimeter - Start"},"postlogin-class4-lessons-areaandperimeter-resume":{"event_label":"Resume topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Area and Perimeter - Resume"},"postlogin-class4-lessons-areaandperimeter-watched":{"event_label":"Rewatch topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Area and Perimeter - Watched"},"postlogin-class4-lessons-areaandperimeter-perimeter-start":{"event_label":"Start subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Area and Perimeter - Perimeter - Start"},"postlogin-class4-lessons-areaandperimeter-perimeter-resume":{"event_label":"Resume subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Area and Perimeter - Perimeter - Resume"},"postlogin-class4-lessons-areaandperimeter-perimeter-watched":{"event_label":"Rewatch subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Area and Perimeter - Perimeter - Watched"},"postlogin-class4-lessons-areaandperimeter-perimeter-lessons":{"event_label":"Class 4 lessons","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Area and Perimeter - Perimeter - Lessons"},"postlogin-class4-lessons-areaandperimeter-perimeter-close":{"event_label":"Close subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Area and Perimeter - Perimeter - Close"},"postlogin-class4-lessons-areaandperimeter-area-start":{"event_label":"Start subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Area and Perimeter - Area - Start"},"postlogin-class4-lessons-areaandperimeter-area-resume":{"event_label":"Resume subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Area and Perimeter - Area - Resume"},"postlogin-class4-lessons-areaandperimeter-area-watched":{"event_label":"Rewatch subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Area and Perimeter - Area - Watched"},"postlogin-class4-lessons-areaandperimeter-area-lessons":{"event_label":"Class 4 lessons","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Area and Perimeter - Area - Lessons"},"postlogin-class4-lessons-areaandperimeter-area-close":{"event_label":"Close subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Area and Perimeter - Area - Close"},"postlogin-class5-lessons-money-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Money - Start"},"postlogin-class5-lessons-money-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Money - Resume"},"postlogin-class5-lessons-money-watched":{"event_label":"Rewatch topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Money - Watched"},"postlogin-class5-lessons-money-applicationsofmoney-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Money - Applications of Money - Start"},"postlogin-class5-lessons-money-applicationsofmoney-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Money - Applications of Money - Resume"},"postlogin-class5-lessons-money-applicationsofmoney-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Money - Applications of Money - Watched"},"postlogin-class5-lessons-money-applicationsofmoney-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Money - Applications of Money - Lessons"},"postlogin-class5-lessons-money-applicationsofmoney-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Money - Applications of Money - Close"},"postlogin-class6-lessons-decimals-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Decimals - Start"},"postlogin-class6-lessons-decimals-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Decimals - Resume"},"postlogin-class6-lessons-decimals-watched":{"event_label":"Rewatch topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Decimals - Watched"},"postlogin-class6-lessons-decimals-introductiontodecimals-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Decimals - Introduction to Decimals - Start"},"postlogin-class6-lessons-decimals-introductiontodecimals-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Decimals - Introduction to Decimals - Resume"},"postlogin-class6-lessons-decimals-introductiontodecimals-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Decimals - Introduction to Decimals - Watched"},"postlogin-class6-lessons-decimals-introductiontodecimals-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Decimals - Introduction to Decimals - Lessons"},"postlogin-class6-lessons-decimals-introductiontodecimals-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Decimals - Introduction to Decimals - Close"},"postlogin-class6-lessons-decimals-operationsondecimals-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Decimals - Operations on Decimals - Start"},"postlogin-class6-lessons-decimals-operationsondecimals-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Decimals - Operations on Decimals - Resume"},"postlogin-class6-lessons-decimals-operationsondecimals-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Decimals - Operations on Decimals - Watched"},"postlogin-class6-lessons-decimals-operationsondecimals-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Decimals - Operations on Decimals - Lessons"},"postlogin-class6-lessons-decimals-operationsondecimals-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Decimals - Operations on Decimals - Close"},"postlogin-class7-lessons-congruence-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Congruence - Start"},"postlogin-class7-lessons-congruence-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Congruence - Resume"},"postlogin-class7-lessons-congruence-watched":{"event_label":"Rewatch topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Congruence - Watched"},"postlogin-class7-lessons-congruence-congruentfigures-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Congruence - Congruent Figures - Start"},"postlogin-class7-lessons-congruence-congruentfigures-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Congruence - Congruent Figures - Resume"},"postlogin-class7-lessons-congruence-congruentfigures-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Congruence - Congruent Figures - Watched"},"postlogin-class7-lessons-congruence-congruentfigures-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Congruence - Congruent Figures - Lessons"},"postlogin-class7-lessons-congruence-congruentfigures-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Congruence - Congruent Figures - Close"},"postlogin-class8-lessons-algebraicexpressionsandidentities-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Algebraic Expressions and Identities - Start"},"postlogin-class8-lessons-algebraicexpressionsandidentities-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Algebraic Expressions and Identities - Resume"},"postlogin-class8-lessons-algebraicexpressionsandidentities-watched":{"event_label":"Rewatch topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Algebraic Expressions and Identities - Watched"},"postlogin-class8-lessons-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - Start"},"postlogin-class8-lessons-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - Resume"},"postlogin-class8-lessons-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-watched":{"event_label":"Rewatch subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - Watched"},"postlogin-class8-lessons-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-lessons":{"event_label":"Class 8 lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - Lessons"},"postlogin-class8-lessons-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-close":{"event_label":"Close subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - Close"},"postlogin-class8-lessons-algebraicexpressionsandidentities-usingidentities-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Algebraic Expressions and Identities - Using Identities - Start"},"postlogin-class8-lessons-algebraicexpressionsandidentities-usingidentities-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Algebraic Expressions and Identities - Using Identities - Resume"},"postlogin-class8-lessons-algebraicexpressionsandidentities-usingidentities-watched":{"event_label":"Rewatch subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Algebraic Expressions and Identities - Using Identities - Watched"},"postlogin-class8-lessons-algebraicexpressionsandidentities-usingidentities-lessons":{"event_label":"Class 8 lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Algebraic Expressions and Identities - Using Identities - Lessons"},"postlogin-class8-lessons-algebraicexpressionsandidentities-usingidentities-close":{"event_label":"Close subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Algebraic Expressions and Identities - Using Identities - Close"},"postlogin-class5-tests-money-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Start"},"postlogin-class5-tests-money-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Resume"},"postlogin-class5-tests-money-revise":{"event_label":"Revise topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Revise"},"postlogin-class5-tests-money-moneyi-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - PT - Start"},"postlogin-class5-tests-money-moneyi-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - PT - Resume"},"postlogin-class5-tests-money-moneyi-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - PT - Report"},"postlogin-class5-tests-money-moneyi-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - PT - Start - Start Test"},"postlogin-class5-tests-money-moneyi-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - PT - Close"},"postlogin-class5-tests-money-moneyi-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - PT - Resume - Continue Test"},"postlogin-class5-tests-money-moneyi-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - PT - Test - Close"},"postlogin-class5-tests-money-moneyi-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - PT - Test - Submit Test"},"postlogin-class5-tests-money-moneyi-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - PT - Scorecard - View Solutions"},"postlogin-class5-tests-money-moneyi-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-money-moneyi-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-money-moneyi-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-money-moneyi-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-money-moneyi-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-money-moneyi-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-money-moneyi-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-money-moneyi-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-money-moneyi-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-money-moneyi-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-money-moneyi-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-money-moneyi-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-money-moneyi-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-money-moneyi-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-money-moneyi-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-money-moneyi-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - CP - Start"},"postlogin-class5-tests-money-moneyi-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - CP - Start - Start Practice"},"postlogin-class5-tests-money-moneyi-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - CP - Start - Close"},"postlogin-class5-tests-money-moneyi-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - CP - Start - Start Practice - Close"},"postlogin-class5-tests-money-moneyi-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - CP - Start - Start Practice - Check"},"postlogin-class5-tests-money-moneyi-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - CP - Resume"},"postlogin-class5-tests-money-moneyi-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - CP - Resume - Continue"},"postlogin-class5-tests-money-moneyi-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - CP - Resume - Close"},"postlogin-class5-tests-money-moneyi-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - CP - Resume - Continue - Close"},"postlogin-class5-tests-money-moneyi-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - CP - Resume - Continue - Check"},"postlogin-class5-tests-money-moneyi-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money I - CP - Report"},"postlogin-class5-tests-money-moneyii-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - PT - Start"},"postlogin-class5-tests-money-moneyii-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - PT - Resume"},"postlogin-class5-tests-money-moneyii-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - PT - Report"},"postlogin-class5-tests-money-moneyii-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - PT - Start - Start Test"},"postlogin-class5-tests-money-moneyii-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - PT - Close"},"postlogin-class5-tests-money-moneyii-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - PT - Resume - Continue Test"},"postlogin-class5-tests-money-moneyii-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - PT - Test - Close"},"postlogin-class5-tests-money-moneyii-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - PT - Test - Submit Test"},"postlogin-class5-tests-money-moneyii-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - PT - Scorecard - View Solutions"},"postlogin-class5-tests-money-moneyii-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-money-moneyii-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-money-moneyii-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-money-moneyii-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-money-moneyii-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-money-moneyii-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-money-moneyii-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-money-moneyii-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-money-moneyii-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-money-moneyii-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-money-moneyii-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-money-moneyii-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-money-moneyii-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-money-moneyii-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-money-moneyii-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-money-moneyii-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - CP - Start"},"postlogin-class5-tests-money-moneyii-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - CP - Start - Start Practice"},"postlogin-class5-tests-money-moneyii-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - CP - Start - Close"},"postlogin-class5-tests-money-moneyii-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - CP - Start - Start Practice - Close"},"postlogin-class5-tests-money-moneyii-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - CP - Start - Start Practice - Check"},"postlogin-class5-tests-money-moneyii-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - CP - Resume"},"postlogin-class5-tests-money-moneyii-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - CP - Resume - Continue"},"postlogin-class5-tests-money-moneyii-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - CP - Resume - Close"},"postlogin-class5-tests-money-moneyii-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - CP - Resume - Continue - Close"},"postlogin-class5-tests-money-moneyii-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - CP - Resume - Continue - Check"},"postlogin-class5-tests-money-moneyii-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Money - Money II - CP - Report"},"postlogin-class6-tests-decimals-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Start"},"postlogin-class6-tests-decimals-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Resume"},"postlogin-class6-tests-decimals-revise":{"event_label":"Revise topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Revise"},"postlogin-class6-tests-decimals-introductiontodecimals-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - PT - Start"},"postlogin-class6-tests-decimals-introductiontodecimals-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - PT - Resume"},"postlogin-class6-tests-decimals-introductiontodecimals-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - PT - Report"},"postlogin-class6-tests-decimals-introductiontodecimals-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - PT - Start - Start Test"},"postlogin-class6-tests-decimals-introductiontodecimals-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - PT - Close"},"postlogin-class6-tests-decimals-introductiontodecimals-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - PT - Resume - Continue Test"},"postlogin-class6-tests-decimals-introductiontodecimals-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - PT - Test - Close"},"postlogin-class6-tests-decimals-introductiontodecimals-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - PT - Test - Submit Test"},"postlogin-class6-tests-decimals-introductiontodecimals-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Solutions"},"postlogin-class6-tests-decimals-introductiontodecimals-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-decimals-introductiontodecimals-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-decimals-introductiontodecimals-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - CP - Start"},"postlogin-class6-tests-decimals-introductiontodecimals-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - CP - Start - Start Practice"},"postlogin-class6-tests-decimals-introductiontodecimals-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - CP - Start - Close"},"postlogin-class6-tests-decimals-introductiontodecimals-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - CP - Start - Start Practice - Close"},"postlogin-class6-tests-decimals-introductiontodecimals-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - CP - Start - Start Practice - Check"},"postlogin-class6-tests-decimals-introductiontodecimals-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - CP - Resume"},"postlogin-class6-tests-decimals-introductiontodecimals-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - CP - Resume - Continue"},"postlogin-class6-tests-decimals-introductiontodecimals-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - CP - Resume - Close"},"postlogin-class6-tests-decimals-introductiontodecimals-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - CP - Resume - Continue - Close"},"postlogin-class6-tests-decimals-introductiontodecimals-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - CP - Resume - Continue - Check"},"postlogin-class6-tests-decimals-introductiontodecimals-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Introduction to Decimals - CP - Report"},"postlogin-class6-tests-decimals-operationsondecimals-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - PT - Start"},"postlogin-class6-tests-decimals-operationsondecimals-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - PT - Resume"},"postlogin-class6-tests-decimals-operationsondecimals-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - PT - Report"},"postlogin-class6-tests-decimals-operationsondecimals-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - PT - Start - Start Test"},"postlogin-class6-tests-decimals-operationsondecimals-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - PT - Close"},"postlogin-class6-tests-decimals-operationsondecimals-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - PT - Resume - Continue Test"},"postlogin-class6-tests-decimals-operationsondecimals-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - PT - Test - Close"},"postlogin-class6-tests-decimals-operationsondecimals-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - PT - Test - Submit Test"},"postlogin-class6-tests-decimals-operationsondecimals-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - PT - Scorecard - View Solutions"},"postlogin-class6-tests-decimals-operationsondecimals-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-decimals-operationsondecimals-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-decimals-operationsondecimals-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-decimals-operationsondecimals-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-decimals-operationsondecimals-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-decimals-operationsondecimals-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-decimals-operationsondecimals-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-decimals-operationsondecimals-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-decimals-operationsondecimals-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-decimals-operationsondecimals-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-decimals-operationsondecimals-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-decimals-operationsondecimals-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-decimals-operationsondecimals-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-decimals-operationsondecimals-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-decimals-operationsondecimals-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-decimals-operationsondecimals-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - CP - Start"},"postlogin-class6-tests-decimals-operationsondecimals-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - CP - Start - Start Practice"},"postlogin-class6-tests-decimals-operationsondecimals-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - CP - Start - Close"},"postlogin-class6-tests-decimals-operationsondecimals-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - CP - Start - Start Practice - Close"},"postlogin-class6-tests-decimals-operationsondecimals-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - CP - Start - Start Practice - Check"},"postlogin-class6-tests-decimals-operationsondecimals-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - CP - Resume"},"postlogin-class6-tests-decimals-operationsondecimals-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - CP - Resume - Continue"},"postlogin-class6-tests-decimals-operationsondecimals-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - CP - Resume - Close"},"postlogin-class6-tests-decimals-operationsondecimals-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - CP - Resume - Continue - Close"},"postlogin-class6-tests-decimals-operationsondecimals-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - CP - Resume - Continue - Check"},"postlogin-class6-tests-decimals-operationsondecimals-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Decimals - Operations on Decimals - CP - Report"},"postlogin-class7-tests-congruence-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Start"},"postlogin-class7-tests-congruence-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Resume"},"postlogin-class7-tests-congruence-revise":{"event_label":"Revise topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Revise"},"postlogin-class7-tests-congruence-congruenceoftriangles-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - PT - Start"},"postlogin-class7-tests-congruence-congruenceoftriangles-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - PT - Resume"},"postlogin-class7-tests-congruence-congruenceoftriangles-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - PT - Report"},"postlogin-class7-tests-congruence-congruenceoftriangles-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - PT - Start - Start Test"},"postlogin-class7-tests-congruence-congruenceoftriangles-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - PT - Close"},"postlogin-class7-tests-congruence-congruenceoftriangles-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - PT - Resume - Continue Test"},"postlogin-class7-tests-congruence-congruenceoftriangles-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - PT - Test - Close"},"postlogin-class7-tests-congruence-congruenceoftriangles-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - PT - Test - Submit Test"},"postlogin-class7-tests-congruence-congruenceoftriangles-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - PT - Scorecard - View Solutions"},"postlogin-class7-tests-congruence-congruenceoftriangles-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-congruence-congruenceoftriangles-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-congruence-congruenceoftriangles-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-congruence-congruenceoftriangles-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-congruence-congruenceoftriangles-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-congruence-congruenceoftriangles-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-congruence-congruenceoftriangles-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-congruence-congruenceoftriangles-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-congruence-congruenceoftriangles-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-congruence-congruenceoftriangles-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-congruence-congruenceoftriangles-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-congruence-congruenceoftriangles-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-congruence-congruenceoftriangles-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-congruence-congruenceoftriangles-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-congruence-congruenceoftriangles-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-congruence-congruenceoftriangles-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - CP - Start"},"postlogin-class7-tests-congruence-congruenceoftriangles-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - CP - Start - Start Practice"},"postlogin-class7-tests-congruence-congruenceoftriangles-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - CP - Start - Close"},"postlogin-class7-tests-congruence-congruenceoftriangles-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - CP - Start - Start Practice - Close"},"postlogin-class7-tests-congruence-congruenceoftriangles-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - CP - Start - Start Practice - Check"},"postlogin-class7-tests-congruence-congruenceoftriangles-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - CP - Resume"},"postlogin-class7-tests-congruence-congruenceoftriangles-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - CP - Resume - Continue"},"postlogin-class7-tests-congruence-congruenceoftriangles-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - CP - Resume - Close"},"postlogin-class7-tests-congruence-congruenceoftriangles-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - CP - Resume - Continue - Close"},"postlogin-class7-tests-congruence-congruenceoftriangles-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - CP - Resume - Continue - Check"},"postlogin-class7-tests-congruence-congruenceoftriangles-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - Congruence of Triangles - CP - Report"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - PT - Start"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - PT - Resume"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - PT - Report"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - PT - Start - Start Test"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - PT - Close"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - PT - Resume - Continue Test"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - PT - Test - Close"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - PT - Test - Submit Test"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - PT - Scorecard - View Solutions"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - CP - Start"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - CP - Start - Start Practice"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - CP - Start - Close"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - CP - Start - Start Practice - Close"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - CP - Start - Start Practice - Check"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - CP - Resume"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - CP - Resume - Continue"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - CP - Resume - Close"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - CP - Resume - Continue - Close"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - CP - Resume - Continue - Check"},"postlogin-class7-tests-congruence-moreoncongruenceoftriangles-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Congruence - More on Congruence of Triangles - CP - Report"},"postlogin-class8-tests-algebraicexpressionsandidentities-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Start"},"postlogin-class8-tests-algebraicexpressionsandidentities-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Resume"},"postlogin-class8-tests-algebraicexpressionsandidentities-revise":{"event_label":"Revise topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Revise"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - PT - Start"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - PT - Resume"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - PT - Report"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - PT - Start - Start Test"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - PT - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - PT - Resume - Continue Test"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - PT - Test - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - PT - Test - Submit Test"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - PT - Scorecard - View Solutions"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - CP - Start"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - CP - Start - Start Practice"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - CP - Start - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - CP - Start - Start Practice - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - CP - Start - Start Practice - Check"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - CP - Resume"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - CP - Resume - Continue"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - CP - Resume - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - CP - Resume - Continue - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - CP - Resume - Continue - Check"},"postlogin-class8-tests-algebraicexpressionsandidentities-additionandsubtractionofpolynomials-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Addition and Subtraction of Polynomials - CP - Report"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - PT - Start"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - PT - Resume"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - PT - Report"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - PT - Start - Start Test"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - PT - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - PT - Resume - Continue Test"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - PT - Test - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - PT - Test - Submit Test"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - PT - Scorecard - View Solutions"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - CP - Start"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - CP - Start - Start Practice"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - CP - Start - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - CP - Start - Start Practice - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - CP - Start - Start Practice - Check"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - CP - Resume"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - CP - Resume - Continue"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - CP - Resume - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - CP - Resume - Continue - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - CP - Resume - Continue - Check"},"postlogin-class8-tests-algebraicexpressionsandidentities-multiplicationanddivisionofpolynomials-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Multiplication and Division of polynomials - CP - Report"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - PT - Start"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - PT - Resume"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - PT - Report"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - PT - Start - Start Test"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - PT - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - PT - Resume - Continue Test"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - PT - Test - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - PT - Test - Submit Test"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - PT - Scorecard - View Solutions"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - CP - Start"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - CP - Start - Start Practice"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - CP - Start - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - CP - Start - Start Practice - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - CP - Start - Start Practice - Check"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - CP - Resume"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - CP - Resume - Continue"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - CP - Resume - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - CP - Resume - Continue - Close"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - CP - Resume - Continue - Check"},"postlogin-class8-tests-algebraicexpressionsandidentities-usingidentities-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Algebraic Expressions and Identities - Using identities - CP - Report"},"postlogin-class3-lessons-datahandling-start":{"event_label":"Start topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Data Handling - Start"},"postlogin-class3-lessons-datahandling-resume":{"event_label":"Resume topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Data Handling - Resume"},"postlogin-class3-lessons-datahandling-watched":{"event_label":"Rewatch topic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons - Data Handling - Watched"},"postlogin-class3-lessons-datahandling-tablesandpictographs-start":{"event_label":"Start subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Data Handling - Tables and Pictographs - Start"},"postlogin-class3-lessons-datahandling-tablesandpictographs-resume":{"event_label":"Resume subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Data Handling - Tables and Pictographs - Resume"},"postlogin-class3-lessons-datahandling-tablesandpictographs-watched":{"event_label":"Rewatch subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Data Handling - Tables and Pictographs - Watched"},"postlogin-class3-lessons-datahandling-tablesandpictographs-lessons":{"event_label":"Class 3 lessons","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Data Handling - Tables and Pictographs - Lessons"},"postlogin-class3-lessons-datahandling-tablesandpictographs-close":{"event_label":"Close subtopic","event_category":"Class 3","event_action":"Post login - Class 3 - Lessons  - Data Handling - Tables and Pictographs - Close"},"postlogin-class4-lessons-time-start":{"event_label":"Start topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Time - Start"},"postlogin-class4-lessons-time-resume":{"event_label":"Resume topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Time - Resume"},"postlogin-class4-lessons-time-watched":{"event_label":"Rewatch topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Time - Watched"},"postlogin-class4-lessons-time-clockandcalendar-start":{"event_label":"Start subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Time - Clock and Calendar - Start"},"postlogin-class4-lessons-time-clockandcalendar-resume":{"event_label":"Resume subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Time - Clock and Calendar - Resume"},"postlogin-class4-lessons-time-clockandcalendar-watched":{"event_label":"Rewatch subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Time - Clock and Calendar - Watched"},"postlogin-class4-lessons-time-clockandcalendar-lessons":{"event_label":"Class 4 lessons","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Time - Clock and Calendar - Lessons"},"postlogin-class4-lessons-time-clockandcalendar-close":{"event_label":"Close subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Time - Clock and Calendar - Close"},"postlogin-class5-lessons-measurement-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Measurement - Start"},"postlogin-class5-lessons-measurement-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Measurement - Resume"},"postlogin-class5-lessons-measurement-watched":{"event_label":"Rewatch topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Measurement - Watched"},"postlogin-class5-lessons-measurement-length-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Measurement - Length - Start"},"postlogin-class5-lessons-measurement-length-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Measurement - Length - Resume"},"postlogin-class5-lessons-measurement-length-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Measurement - Length - Watched"},"postlogin-class5-lessons-measurement-length-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Measurement - Length - Lessons"},"postlogin-class5-lessons-measurement-length-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Measurement - Length - Close"},"postlogin-class5-lessons-measurement-mass-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Measurement - Mass - Start"},"postlogin-class5-lessons-measurement-mass-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Measurement - Mass - Resume"},"postlogin-class5-lessons-measurement-mass-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Measurement - Mass - Watched"},"postlogin-class5-lessons-measurement-mass-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Measurement - Mass - Lessons"},"postlogin-class5-lessons-measurement-mass-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Measurement - Mass - Close"},"postlogin-class5-lessons-measurement-capacity-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Measurement - Capacity - Start"},"postlogin-class5-lessons-measurement-capacity-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Measurement - Capacity - Resume"},"postlogin-class5-lessons-measurement-capacity-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Measurement - Capacity - Watched"},"postlogin-class5-lessons-measurement-capacity-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Measurement - Capacity - Lessons"},"postlogin-class5-lessons-measurement-capacity-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Measurement - Capacity - Close"},"postlogin-class6-lessons-datahandling-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Data Handling - Start"},"postlogin-class6-lessons-datahandling-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Data Handling - Resume"},"postlogin-class6-lessons-datahandling-watched":{"event_label":"Rewatch topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Data Handling - Watched"},"postlogin-class6-lessons-datahandling-pictographsandbargraphs-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Data Handling - Pictographs and Bar Graphs - Start"},"postlogin-class6-lessons-datahandling-pictographsandbargraphs-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Data Handling - Pictographs and Bar Graphs - Resume"},"postlogin-class6-lessons-datahandling-pictographsandbargraphs-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Data Handling - Pictographs and Bar Graphs - Watched"},"postlogin-class6-lessons-datahandling-pictographsandbargraphs-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Data Handling - Pictographs and Bar Graphs - Lessons"},"postlogin-class6-lessons-datahandling-pictographsandbargraphs-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Data Handling - Pictographs and Bar Graphs - Close"},"postlogin-class7-lessons-comparingquantities-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Comparing Quantities - Start"},"postlogin-class7-lessons-comparingquantities-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Comparing Quantities - Resume"},"postlogin-class7-lessons-comparingquantities-watched":{"event_label":"Rewatch topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Comparing Quantities - Watched"},"postlogin-class7-lessons-comparingquantities-ratio-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Comparing Quantities - Ratio - Start"},"postlogin-class7-lessons-comparingquantities-ratio-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Comparing Quantities - Ratio - Resume"},"postlogin-class7-lessons-comparingquantities-ratio-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Comparing Quantities - Ratio - Watched"},"postlogin-class7-lessons-comparingquantities-ratio-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Comparing Quantities - Ratio - Lessons"},"postlogin-class7-lessons-comparingquantities-ratio-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Comparing Quantities - Ratio - Close"},"postlogin-class7-lessons-comparingquantities-percentages-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Comparing Quantities - Percentages - Start"},"postlogin-class7-lessons-comparingquantities-percentages-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Comparing Quantities - Percentages - Resume"},"postlogin-class7-lessons-comparingquantities-percentages-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Comparing Quantities - Percentages - Watched"},"postlogin-class7-lessons-comparingquantities-percentages-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Comparing Quantities - Percentages - Lessons"},"postlogin-class7-lessons-comparingquantities-percentages-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Comparing Quantities - Percentages - Close"},"postlogin-class7-lessons-comparingquantities-profitandloss-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Comparing Quantities - Profit and Loss - Start"},"postlogin-class7-lessons-comparingquantities-profitandloss-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Comparing Quantities - Profit and Loss - Resume"},"postlogin-class7-lessons-comparingquantities-profitandloss-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Comparing Quantities - Profit and Loss - Watched"},"postlogin-class7-lessons-comparingquantities-profitandloss-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Comparing Quantities - Profit and Loss - Lessons"},"postlogin-class7-lessons-comparingquantities-profitandloss-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Comparing Quantities - Profit and Loss - Close"},"postlogin-class7-lessons-comparingquantities-simpleinterest-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Comparing Quantities - Simple Interest - Start"},"postlogin-class7-lessons-comparingquantities-simpleinterest-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Comparing Quantities - Simple Interest - Resume"},"postlogin-class7-lessons-comparingquantities-simpleinterest-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Comparing Quantities - Simple Interest - Watched"},"postlogin-class7-lessons-comparingquantities-simpleinterest-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Comparing Quantities - Simple Interest - Lessons"},"postlogin-class7-lessons-comparingquantities-simpleinterest-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Comparing Quantities - Simple Interest - Close"},"postlogin-class8-lessons-visualisingsolidshapes-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Visualising Solid Shapes - Start"},"postlogin-class8-lessons-visualisingsolidshapes-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Visualising Solid Shapes - Resume"},"postlogin-class8-lessons-visualisingsolidshapes-watched":{"event_label":"Rewatch topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Visualising Solid Shapes - Watched"},"postlogin-class8-lessons-visualisingsolidshapes-visualisingsolidshapes-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Visualising Solid Shapes - Visualising Solid Shapes - Start"},"postlogin-class8-lessons-visualisingsolidshapes-visualisingsolidshapes-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Visualising Solid Shapes - Visualising Solid Shapes - Resume"},"postlogin-class8-lessons-visualisingsolidshapes-visualisingsolidshapes-watched":{"event_label":"Rewatch subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Visualising Solid Shapes - Visualising Solid Shapes - Watched"},"postlogin-class8-lessons-visualisingsolidshapes-visualisingsolidshapes-lessons":{"event_label":"Class 8 lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Visualising Solid Shapes - Visualising Solid Shapes - Lessons"},"postlogin-class8-lessons-visualisingsolidshapes-visualisingsolidshapes-close":{"event_label":"Close subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Visualising Solid Shapes - Visualising Solid Shapes - Close"},"postlogin-class5-tests-measurement-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Start"},"postlogin-class5-tests-measurement-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Resume"},"postlogin-class5-tests-measurement-revise":{"event_label":"Revise topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Revise"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - PT - Start"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - PT - Resume"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - PT - Report"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - PT - Start - Start Test"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - PT - Close"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - PT - Resume - Continue Test"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - PT - Test - Close"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - PT - Test - Submit Test"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - PT - Scorecard - View Solutions"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - CP - Start"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - CP - Start - Start Practice"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - CP - Start - Close"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - CP - Start - Start Practice - Close"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - CP - Start - Start Practice - Check"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - CP - Resume"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - CP - Resume - Continue"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - CP - Resume - Close"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - CP - Resume - Continue - Close"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - CP - Resume - Continue - Check"},"postlogin-class5-tests-measurement-operationsonmetricmeasures-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Operations on Metric Measures - CP - Report"},"postlogin-class5-tests-measurement-measurement-applications-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - PT - Start"},"postlogin-class5-tests-measurement-measurement-applications-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - PT - Resume"},"postlogin-class5-tests-measurement-measurement-applications-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - PT - Report"},"postlogin-class5-tests-measurement-measurement-applications-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - PT - Start - Start Test"},"postlogin-class5-tests-measurement-measurement-applications-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - PT - Close"},"postlogin-class5-tests-measurement-measurement-applications-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - PT - Resume - Continue Test"},"postlogin-class5-tests-measurement-measurement-applications-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - PT - Test - Close"},"postlogin-class5-tests-measurement-measurement-applications-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - PT - Test - Submit Test"},"postlogin-class5-tests-measurement-measurement-applications-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - PT - Scorecard - View Solutions"},"postlogin-class5-tests-measurement-measurement-applications-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-measurement-measurement-applications-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-measurement-measurement-applications-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-measurement-measurement-applications-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-measurement-measurement-applications-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-measurement-measurement-applications-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-measurement-measurement-applications-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-measurement-measurement-applications-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-measurement-measurement-applications-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-measurement-measurement-applications-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-measurement-measurement-applications-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-measurement-measurement-applications-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-measurement-measurement-applications-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-measurement-measurement-applications-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-measurement-measurement-applications-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-measurement-measurement-applications-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - CP - Start"},"postlogin-class5-tests-measurement-measurement-applications-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - CP - Start - Start Practice"},"postlogin-class5-tests-measurement-measurement-applications-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - CP - Start - Close"},"postlogin-class5-tests-measurement-measurement-applications-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - CP - Start - Start Practice - Close"},"postlogin-class5-tests-measurement-measurement-applications-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - CP - Start - Start Practice - Check"},"postlogin-class5-tests-measurement-measurement-applications-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - CP - Resume"},"postlogin-class5-tests-measurement-measurement-applications-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - CP - Resume - Continue"},"postlogin-class5-tests-measurement-measurement-applications-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - CP - Resume - Close"},"postlogin-class5-tests-measurement-measurement-applications-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - CP - Resume - Continue - Close"},"postlogin-class5-tests-measurement-measurement-applications-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - CP - Resume - Continue - Check"},"postlogin-class5-tests-measurement-measurement-applications-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Measurement - Measurement - Applications - CP - Report"},"postlogin-class6-tests-datahandling-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Start"},"postlogin-class6-tests-datahandling-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Resume"},"postlogin-class6-tests-datahandling-revise":{"event_label":"Revise topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Revise"},"postlogin-class6-tests-datahandling-pictographs-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - PT - Start"},"postlogin-class6-tests-datahandling-pictographs-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - PT - Resume"},"postlogin-class6-tests-datahandling-pictographs-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - PT - Report"},"postlogin-class6-tests-datahandling-pictographs-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - PT - Start - Start Test"},"postlogin-class6-tests-datahandling-pictographs-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - PT - Close"},"postlogin-class6-tests-datahandling-pictographs-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - PT - Resume - Continue Test"},"postlogin-class6-tests-datahandling-pictographs-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - PT - Test - Close"},"postlogin-class6-tests-datahandling-pictographs-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - PT - Test - Submit Test"},"postlogin-class6-tests-datahandling-pictographs-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - PT - Scorecard - View Solutions"},"postlogin-class6-tests-datahandling-pictographs-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-datahandling-pictographs-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-datahandling-pictographs-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-datahandling-pictographs-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-datahandling-pictographs-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-datahandling-pictographs-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-datahandling-pictographs-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-datahandling-pictographs-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-datahandling-pictographs-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-datahandling-pictographs-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-datahandling-pictographs-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-datahandling-pictographs-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-datahandling-pictographs-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-datahandling-pictographs-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-datahandling-pictographs-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-datahandling-pictographs-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - CP - Start"},"postlogin-class6-tests-datahandling-pictographs-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - CP - Start - Start Practice"},"postlogin-class6-tests-datahandling-pictographs-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - CP - Start - Close"},"postlogin-class6-tests-datahandling-pictographs-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - CP - Start - Start Practice - Close"},"postlogin-class6-tests-datahandling-pictographs-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - CP - Start - Start Practice - Check"},"postlogin-class6-tests-datahandling-pictographs-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - CP - Resume"},"postlogin-class6-tests-datahandling-pictographs-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - CP - Resume - Continue"},"postlogin-class6-tests-datahandling-pictographs-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - CP - Resume - Close"},"postlogin-class6-tests-datahandling-pictographs-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - CP - Resume - Continue - Close"},"postlogin-class6-tests-datahandling-pictographs-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - CP - Resume - Continue - Check"},"postlogin-class6-tests-datahandling-pictographs-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Pictographs - CP - Report"},"postlogin-class6-tests-datahandling-moreonpictographs-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - PT - Start"},"postlogin-class6-tests-datahandling-moreonpictographs-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - PT - Resume"},"postlogin-class6-tests-datahandling-moreonpictographs-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - PT - Report"},"postlogin-class6-tests-datahandling-moreonpictographs-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - PT - Start - Start Test"},"postlogin-class6-tests-datahandling-moreonpictographs-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - PT - Close"},"postlogin-class6-tests-datahandling-moreonpictographs-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - PT - Resume - Continue Test"},"postlogin-class6-tests-datahandling-moreonpictographs-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - PT - Test - Close"},"postlogin-class6-tests-datahandling-moreonpictographs-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - PT - Test - Submit Test"},"postlogin-class6-tests-datahandling-moreonpictographs-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - PT - Scorecard - View Solutions"},"postlogin-class6-tests-datahandling-moreonpictographs-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-datahandling-moreonpictographs-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-datahandling-moreonpictographs-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-datahandling-moreonpictographs-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-datahandling-moreonpictographs-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-datahandling-moreonpictographs-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-datahandling-moreonpictographs-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-datahandling-moreonpictographs-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-datahandling-moreonpictographs-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-datahandling-moreonpictographs-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-datahandling-moreonpictographs-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-datahandling-moreonpictographs-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-datahandling-moreonpictographs-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-datahandling-moreonpictographs-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-datahandling-moreonpictographs-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-datahandling-moreonpictographs-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - CP - Start"},"postlogin-class6-tests-datahandling-moreonpictographs-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - CP - Start - Start Practice"},"postlogin-class6-tests-datahandling-moreonpictographs-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - CP - Start - Close"},"postlogin-class6-tests-datahandling-moreonpictographs-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - CP - Start - Start Practice - Close"},"postlogin-class6-tests-datahandling-moreonpictographs-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - CP - Start - Start Practice - Check"},"postlogin-class6-tests-datahandling-moreonpictographs-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - CP - Resume"},"postlogin-class6-tests-datahandling-moreonpictographs-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - CP - Resume - Continue"},"postlogin-class6-tests-datahandling-moreonpictographs-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - CP - Resume - Close"},"postlogin-class6-tests-datahandling-moreonpictographs-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - CP - Resume - Continue - Close"},"postlogin-class6-tests-datahandling-moreonpictographs-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - CP - Resume - Continue - Check"},"postlogin-class6-tests-datahandling-moreonpictographs-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - More on Pictographs - CP - Report"},"postlogin-class6-tests-datahandling-bargraphs-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - PT - Start"},"postlogin-class6-tests-datahandling-bargraphs-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - PT - Resume"},"postlogin-class6-tests-datahandling-bargraphs-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - PT - Report"},"postlogin-class6-tests-datahandling-bargraphs-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - PT - Start - Start Test"},"postlogin-class6-tests-datahandling-bargraphs-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - PT - Close"},"postlogin-class6-tests-datahandling-bargraphs-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - PT - Resume - Continue Test"},"postlogin-class6-tests-datahandling-bargraphs-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - PT - Test - Close"},"postlogin-class6-tests-datahandling-bargraphs-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - PT - Test - Submit Test"},"postlogin-class6-tests-datahandling-bargraphs-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - PT - Scorecard - View Solutions"},"postlogin-class6-tests-datahandling-bargraphs-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-datahandling-bargraphs-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-datahandling-bargraphs-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-datahandling-bargraphs-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-datahandling-bargraphs-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-datahandling-bargraphs-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-datahandling-bargraphs-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-datahandling-bargraphs-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-datahandling-bargraphs-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-datahandling-bargraphs-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-datahandling-bargraphs-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-datahandling-bargraphs-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-datahandling-bargraphs-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-datahandling-bargraphs-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-datahandling-bargraphs-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-datahandling-bargraphs-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - CP - Start"},"postlogin-class6-tests-datahandling-bargraphs-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - CP - Start - Start Practice"},"postlogin-class6-tests-datahandling-bargraphs-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - CP - Start - Close"},"postlogin-class6-tests-datahandling-bargraphs-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - CP - Start - Start Practice - Close"},"postlogin-class6-tests-datahandling-bargraphs-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - CP - Start - Start Practice - Check"},"postlogin-class6-tests-datahandling-bargraphs-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - CP - Resume"},"postlogin-class6-tests-datahandling-bargraphs-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - CP - Resume - Continue"},"postlogin-class6-tests-datahandling-bargraphs-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - CP - Resume - Close"},"postlogin-class6-tests-datahandling-bargraphs-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - CP - Resume - Continue - Close"},"postlogin-class6-tests-datahandling-bargraphs-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - CP - Resume - Continue - Check"},"postlogin-class6-tests-datahandling-bargraphs-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Data Handling - Bar Graphs - CP - Report"},"postlogin-class7-tests-comparingquantities-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Start"},"postlogin-class7-tests-comparingquantities-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Resume"},"postlogin-class7-tests-comparingquantities-revise":{"event_label":"Revise topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Revise"},"postlogin-class7-tests-comparingquantities-ratio-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - PT - Start"},"postlogin-class7-tests-comparingquantities-ratio-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - PT - Resume"},"postlogin-class7-tests-comparingquantities-ratio-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - PT - Report"},"postlogin-class7-tests-comparingquantities-ratio-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - PT - Start - Start Test"},"postlogin-class7-tests-comparingquantities-ratio-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - PT - Close"},"postlogin-class7-tests-comparingquantities-ratio-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - PT - Resume - Continue Test"},"postlogin-class7-tests-comparingquantities-ratio-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - PT - Test - Close"},"postlogin-class7-tests-comparingquantities-ratio-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - PT - Test - Submit Test"},"postlogin-class7-tests-comparingquantities-ratio-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - PT - Scorecard - View Solutions"},"postlogin-class7-tests-comparingquantities-ratio-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-comparingquantities-ratio-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-comparingquantities-ratio-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-comparingquantities-ratio-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-comparingquantities-ratio-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-comparingquantities-ratio-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-comparingquantities-ratio-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-comparingquantities-ratio-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-comparingquantities-ratio-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-comparingquantities-ratio-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-comparingquantities-ratio-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-comparingquantities-ratio-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-comparingquantities-ratio-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-comparingquantities-ratio-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-comparingquantities-ratio-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-comparingquantities-ratio-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - CP - Start"},"postlogin-class7-tests-comparingquantities-ratio-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - CP - Start - Start Practice"},"postlogin-class7-tests-comparingquantities-ratio-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - CP - Start - Close"},"postlogin-class7-tests-comparingquantities-ratio-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - CP - Start - Start Practice - Close"},"postlogin-class7-tests-comparingquantities-ratio-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - CP - Start - Start Practice - Check"},"postlogin-class7-tests-comparingquantities-ratio-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - CP - Resume"},"postlogin-class7-tests-comparingquantities-ratio-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - CP - Resume - Continue"},"postlogin-class7-tests-comparingquantities-ratio-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - CP - Resume - Close"},"postlogin-class7-tests-comparingquantities-ratio-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - CP - Resume - Continue - Close"},"postlogin-class7-tests-comparingquantities-ratio-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - CP - Resume - Continue - Check"},"postlogin-class7-tests-comparingquantities-ratio-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Ratio - CP - Report"},"postlogin-class7-tests-comparingquantities-moreonratio-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - PT - Start"},"postlogin-class7-tests-comparingquantities-moreonratio-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - PT - Resume"},"postlogin-class7-tests-comparingquantities-moreonratio-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - PT - Report"},"postlogin-class7-tests-comparingquantities-moreonratio-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - PT - Start - Start Test"},"postlogin-class7-tests-comparingquantities-moreonratio-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - PT - Close"},"postlogin-class7-tests-comparingquantities-moreonratio-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - PT - Resume - Continue Test"},"postlogin-class7-tests-comparingquantities-moreonratio-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - PT - Test - Close"},"postlogin-class7-tests-comparingquantities-moreonratio-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - PT - Test - Submit Test"},"postlogin-class7-tests-comparingquantities-moreonratio-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - PT - Scorecard - View Solutions"},"postlogin-class7-tests-comparingquantities-moreonratio-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-comparingquantities-moreonratio-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-comparingquantities-moreonratio-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-comparingquantities-moreonratio-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-comparingquantities-moreonratio-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-comparingquantities-moreonratio-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-comparingquantities-moreonratio-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-comparingquantities-moreonratio-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-comparingquantities-moreonratio-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-comparingquantities-moreonratio-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-comparingquantities-moreonratio-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-comparingquantities-moreonratio-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-comparingquantities-moreonratio-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-comparingquantities-moreonratio-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-comparingquantities-moreonratio-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-comparingquantities-moreonratio-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - CP - Start"},"postlogin-class7-tests-comparingquantities-moreonratio-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - CP - Start - Start Practice"},"postlogin-class7-tests-comparingquantities-moreonratio-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - CP - Start - Close"},"postlogin-class7-tests-comparingquantities-moreonratio-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - CP - Start - Start Practice - Close"},"postlogin-class7-tests-comparingquantities-moreonratio-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - CP - Start - Start Practice - Check"},"postlogin-class7-tests-comparingquantities-moreonratio-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - CP - Resume"},"postlogin-class7-tests-comparingquantities-moreonratio-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - CP - Resume - Continue"},"postlogin-class7-tests-comparingquantities-moreonratio-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - CP - Resume - Close"},"postlogin-class7-tests-comparingquantities-moreonratio-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - CP - Resume - Continue - Close"},"postlogin-class7-tests-comparingquantities-moreonratio-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - CP - Resume - Continue - Check"},"postlogin-class7-tests-comparingquantities-moreonratio-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - More on Ratio - CP - Report"},"postlogin-class7-tests-comparingquantities-percentages-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - PT - Start"},"postlogin-class7-tests-comparingquantities-percentages-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - PT - Resume"},"postlogin-class7-tests-comparingquantities-percentages-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - PT - Report"},"postlogin-class7-tests-comparingquantities-percentages-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - PT - Start - Start Test"},"postlogin-class7-tests-comparingquantities-percentages-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - PT - Close"},"postlogin-class7-tests-comparingquantities-percentages-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - PT - Resume - Continue Test"},"postlogin-class7-tests-comparingquantities-percentages-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - PT - Test - Close"},"postlogin-class7-tests-comparingquantities-percentages-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - PT - Test - Submit Test"},"postlogin-class7-tests-comparingquantities-percentages-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - PT - Scorecard - View Solutions"},"postlogin-class7-tests-comparingquantities-percentages-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-comparingquantities-percentages-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-comparingquantities-percentages-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-comparingquantities-percentages-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-comparingquantities-percentages-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-comparingquantities-percentages-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-comparingquantities-percentages-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-comparingquantities-percentages-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-comparingquantities-percentages-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-comparingquantities-percentages-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-comparingquantities-percentages-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-comparingquantities-percentages-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-comparingquantities-percentages-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-comparingquantities-percentages-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-comparingquantities-percentages-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-comparingquantities-percentages-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - CP - Start"},"postlogin-class7-tests-comparingquantities-percentages-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - CP - Start - Start Practice"},"postlogin-class7-tests-comparingquantities-percentages-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - CP - Start - Close"},"postlogin-class7-tests-comparingquantities-percentages-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - CP - Start - Start Practice - Close"},"postlogin-class7-tests-comparingquantities-percentages-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - CP - Start - Start Practice - Check"},"postlogin-class7-tests-comparingquantities-percentages-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - CP - Resume"},"postlogin-class7-tests-comparingquantities-percentages-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - CP - Resume - Continue"},"postlogin-class7-tests-comparingquantities-percentages-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - CP - Resume - Close"},"postlogin-class7-tests-comparingquantities-percentages-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - CP - Resume - Continue - Close"},"postlogin-class7-tests-comparingquantities-percentages-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - CP - Resume - Continue - Check"},"postlogin-class7-tests-comparingquantities-percentages-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Percentages - CP - Report"},"postlogin-class7-tests-comparingquantities-profitandloss-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - PT - Start"},"postlogin-class7-tests-comparingquantities-profitandloss-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - PT - Resume"},"postlogin-class7-tests-comparingquantities-profitandloss-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - PT - Report"},"postlogin-class7-tests-comparingquantities-profitandloss-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - PT - Start - Start Test"},"postlogin-class7-tests-comparingquantities-profitandloss-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - PT - Close"},"postlogin-class7-tests-comparingquantities-profitandloss-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - PT - Resume - Continue Test"},"postlogin-class7-tests-comparingquantities-profitandloss-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - PT - Test - Close"},"postlogin-class7-tests-comparingquantities-profitandloss-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - PT - Test - Submit Test"},"postlogin-class7-tests-comparingquantities-profitandloss-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - PT - Scorecard - View Solutions"},"postlogin-class7-tests-comparingquantities-profitandloss-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-comparingquantities-profitandloss-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-comparingquantities-profitandloss-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-comparingquantities-profitandloss-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-comparingquantities-profitandloss-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-comparingquantities-profitandloss-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-comparingquantities-profitandloss-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-comparingquantities-profitandloss-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-comparingquantities-profitandloss-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-comparingquantities-profitandloss-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-comparingquantities-profitandloss-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-comparingquantities-profitandloss-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-comparingquantities-profitandloss-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-comparingquantities-profitandloss-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-comparingquantities-profitandloss-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-comparingquantities-profitandloss-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - CP - Start"},"postlogin-class7-tests-comparingquantities-profitandloss-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - CP - Start - Start Practice"},"postlogin-class7-tests-comparingquantities-profitandloss-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - CP - Start - Close"},"postlogin-class7-tests-comparingquantities-profitandloss-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - CP - Start - Start Practice - Close"},"postlogin-class7-tests-comparingquantities-profitandloss-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - CP - Start - Start Practice - Check"},"postlogin-class7-tests-comparingquantities-profitandloss-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - CP - Resume"},"postlogin-class7-tests-comparingquantities-profitandloss-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - CP - Resume - Continue"},"postlogin-class7-tests-comparingquantities-profitandloss-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - CP - Resume - Close"},"postlogin-class7-tests-comparingquantities-profitandloss-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - CP - Resume - Continue - Close"},"postlogin-class7-tests-comparingquantities-profitandloss-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - CP - Resume - Continue - Check"},"postlogin-class7-tests-comparingquantities-profitandloss-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Profit and Loss - CP - Report"},"postlogin-class7-tests-comparingquantities-simpleinterest-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - PT - Start"},"postlogin-class7-tests-comparingquantities-simpleinterest-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - PT - Resume"},"postlogin-class7-tests-comparingquantities-simpleinterest-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - PT - Report"},"postlogin-class7-tests-comparingquantities-simpleinterest-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - PT - Start - Start Test"},"postlogin-class7-tests-comparingquantities-simpleinterest-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - PT - Close"},"postlogin-class7-tests-comparingquantities-simpleinterest-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - PT - Resume - Continue Test"},"postlogin-class7-tests-comparingquantities-simpleinterest-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - PT - Test - Close"},"postlogin-class7-tests-comparingquantities-simpleinterest-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - PT - Test - Submit Test"},"postlogin-class7-tests-comparingquantities-simpleinterest-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - PT - Scorecard - View Solutions"},"postlogin-class7-tests-comparingquantities-simpleinterest-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-comparingquantities-simpleinterest-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-comparingquantities-simpleinterest-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-comparingquantities-simpleinterest-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-comparingquantities-simpleinterest-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-comparingquantities-simpleinterest-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-comparingquantities-simpleinterest-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-comparingquantities-simpleinterest-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-comparingquantities-simpleinterest-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-comparingquantities-simpleinterest-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-comparingquantities-simpleinterest-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-comparingquantities-simpleinterest-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-comparingquantities-simpleinterest-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-comparingquantities-simpleinterest-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-comparingquantities-simpleinterest-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-comparingquantities-simpleinterest-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - CP - Start"},"postlogin-class7-tests-comparingquantities-simpleinterest-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - CP - Start - Start Practice"},"postlogin-class7-tests-comparingquantities-simpleinterest-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - CP - Start - Close"},"postlogin-class7-tests-comparingquantities-simpleinterest-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - CP - Start - Start Practice - Close"},"postlogin-class7-tests-comparingquantities-simpleinterest-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - CP - Start - Start Practice - Check"},"postlogin-class7-tests-comparingquantities-simpleinterest-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - CP - Resume"},"postlogin-class7-tests-comparingquantities-simpleinterest-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - CP - Resume - Continue"},"postlogin-class7-tests-comparingquantities-simpleinterest-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - CP - Resume - Close"},"postlogin-class7-tests-comparingquantities-simpleinterest-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - CP - Resume - Continue - Close"},"postlogin-class7-tests-comparingquantities-simpleinterest-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - CP - Resume - Continue - Check"},"postlogin-class7-tests-comparingquantities-simpleinterest-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Comparing Quantities - Simple Interest - CP - Report"},"postlogin-class8-tests-mensuration-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Start"},"postlogin-class8-tests-mensuration-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Resume"},"postlogin-class8-tests-mensuration-revise":{"event_label":"Revise topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Revise"},"postlogin-class8-tests-mensuration-perimeterandarea-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - PT - Start"},"postlogin-class8-tests-mensuration-perimeterandarea-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - PT - Resume"},"postlogin-class8-tests-mensuration-perimeterandarea-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - PT - Report"},"postlogin-class8-tests-mensuration-perimeterandarea-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - PT - Start - Start Test"},"postlogin-class8-tests-mensuration-perimeterandarea-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - PT - Close"},"postlogin-class8-tests-mensuration-perimeterandarea-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - PT - Resume - Continue Test"},"postlogin-class8-tests-mensuration-perimeterandarea-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - PT - Test - Close"},"postlogin-class8-tests-mensuration-perimeterandarea-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - PT - Test - Submit Test"},"postlogin-class8-tests-mensuration-perimeterandarea-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - PT - Scorecard - View Solutions"},"postlogin-class8-tests-mensuration-perimeterandarea-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-mensuration-perimeterandarea-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-mensuration-perimeterandarea-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-mensuration-perimeterandarea-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-mensuration-perimeterandarea-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-mensuration-perimeterandarea-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-mensuration-perimeterandarea-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-mensuration-perimeterandarea-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-mensuration-perimeterandarea-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-mensuration-perimeterandarea-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-mensuration-perimeterandarea-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-mensuration-perimeterandarea-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-mensuration-perimeterandarea-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-mensuration-perimeterandarea-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-mensuration-perimeterandarea-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-mensuration-perimeterandarea-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - CP - Start"},"postlogin-class8-tests-mensuration-perimeterandarea-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - CP - Start - Start Practice"},"postlogin-class8-tests-mensuration-perimeterandarea-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - CP - Start - Close"},"postlogin-class8-tests-mensuration-perimeterandarea-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - CP - Start - Start Practice - Close"},"postlogin-class8-tests-mensuration-perimeterandarea-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - CP - Start - Start Practice - Check"},"postlogin-class8-tests-mensuration-perimeterandarea-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - CP - Resume"},"postlogin-class8-tests-mensuration-perimeterandarea-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - CP - Resume - Continue"},"postlogin-class8-tests-mensuration-perimeterandarea-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - CP - Resume - Close"},"postlogin-class8-tests-mensuration-perimeterandarea-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - CP - Resume - Continue - Close"},"postlogin-class8-tests-mensuration-perimeterandarea-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - CP - Resume - Continue - Check"},"postlogin-class8-tests-mensuration-perimeterandarea-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Perimeter and Area - CP - Report"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - PT - Start"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - PT - Resume"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - PT - Report"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - PT - Start - Start Test"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - PT - Close"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - PT - Resume - Continue Test"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - PT - Test - Close"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - PT - Test - Submit Test"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - PT - Scorecard - View Solutions"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - CP - Start"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - CP - Start - Start Practice"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - CP - Start - Close"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - CP - Start - Start Practice - Close"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - CP - Start - Start Practice - Check"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - CP - Resume"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - CP - Resume - Continue"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - CP - Resume - Close"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - CP - Resume - Continue - Close"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - CP - Resume - Continue - Check"},"postlogin-class8-tests-mensuration-surfaceareaofsolids-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Surface Area of Solids - CP - Report"},"postlogin-class8-tests-mensuration-volumeofsolids-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - PT - Start"},"postlogin-class8-tests-mensuration-volumeofsolids-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - PT - Resume"},"postlogin-class8-tests-mensuration-volumeofsolids-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - PT - Report"},"postlogin-class8-tests-mensuration-volumeofsolids-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - PT - Start - Start Test"},"postlogin-class8-tests-mensuration-volumeofsolids-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - PT - Close"},"postlogin-class8-tests-mensuration-volumeofsolids-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - PT - Resume - Continue Test"},"postlogin-class8-tests-mensuration-volumeofsolids-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - PT - Test - Close"},"postlogin-class8-tests-mensuration-volumeofsolids-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - PT - Test - Submit Test"},"postlogin-class8-tests-mensuration-volumeofsolids-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - PT - Scorecard - View Solutions"},"postlogin-class8-tests-mensuration-volumeofsolids-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-mensuration-volumeofsolids-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-mensuration-volumeofsolids-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-mensuration-volumeofsolids-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-mensuration-volumeofsolids-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-mensuration-volumeofsolids-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-mensuration-volumeofsolids-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-mensuration-volumeofsolids-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-mensuration-volumeofsolids-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-mensuration-volumeofsolids-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-mensuration-volumeofsolids-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-mensuration-volumeofsolids-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-mensuration-volumeofsolids-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-mensuration-volumeofsolids-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-mensuration-volumeofsolids-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-mensuration-volumeofsolids-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - CP - Start"},"postlogin-class8-tests-mensuration-volumeofsolids-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - CP - Start - Start Practice"},"postlogin-class8-tests-mensuration-volumeofsolids-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - CP - Start - Close"},"postlogin-class8-tests-mensuration-volumeofsolids-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - CP - Start - Start Practice - Close"},"postlogin-class8-tests-mensuration-volumeofsolids-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - CP - Start - Start Practice - Check"},"postlogin-class8-tests-mensuration-volumeofsolids-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - CP - Resume"},"postlogin-class8-tests-mensuration-volumeofsolids-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - CP - Resume - Continue"},"postlogin-class8-tests-mensuration-volumeofsolids-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - CP - Resume - Close"},"postlogin-class8-tests-mensuration-volumeofsolids-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - CP - Resume - Continue - Close"},"postlogin-class8-tests-mensuration-volumeofsolids-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - CP - Resume - Continue - Check"},"postlogin-class8-tests-mensuration-volumeofsolids-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Mensuration - Volume of Solids - CP - Report"},"postlogin-class4-lessons-datahandling-start":{"event_label":"Start topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Data Handling - Start"},"postlogin-class4-lessons-datahandling-resume":{"event_label":"Resume topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Data Handling - Resume"},"postlogin-class4-lessons-datahandling-watched":{"event_label":"Rewatch topic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons - Data Handling - Watched"},"postlogin-class4-lessons-datahandling-readingandinterpretinggraphs-start":{"event_label":"Start subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Data Handling - Reading and Interpreting Graphs - Start"},"postlogin-class4-lessons-datahandling-readingandinterpretinggraphs-resume":{"event_label":"Resume subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Data Handling - Reading and Interpreting Graphs - Resume"},"postlogin-class4-lessons-datahandling-readingandinterpretinggraphs-watched":{"event_label":"Rewatch subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Data Handling - Reading and Interpreting Graphs - Watched"},"postlogin-class4-lessons-datahandling-readingandinterpretinggraphs-lessons":{"event_label":"Class 4 lessons","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Data Handling - Reading and Interpreting Graphs - Lessons"},"postlogin-class4-lessons-datahandling-readingandinterpretinggraphs-close":{"event_label":"Close subtopic","event_category":"Class 4","event_action":"Post login - Class 4 - Lessons  - Data Handling - Reading and Interpreting Graphs - Close"},"postlogin-class5-lessons-perimeter,areaandvolume-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Perimeter, Area and Volume - Start"},"postlogin-class5-lessons-perimeter,areaandvolume-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Perimeter, Area and Volume - Resume"},"postlogin-class5-lessons-perimeter,areaandvolume-watched":{"event_label":"Rewatch topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Perimeter, Area and Volume - Watched"},"postlogin-class5-lessons-perimeter,areaandvolume-volume-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Perimeter, Area and Volume - Volume - Start"},"postlogin-class5-lessons-perimeter,areaandvolume-volume-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Perimeter, Area and Volume - Volume - Resume"},"postlogin-class5-lessons-perimeter,areaandvolume-volume-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Perimeter, Area and Volume - Volume - Watched"},"postlogin-class5-lessons-perimeter,areaandvolume-volume-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Perimeter, Area and Volume - Volume - Lessons"},"postlogin-class5-lessons-perimeter,areaandvolume-volume-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Perimeter, Area and Volume - Volume - Close"},"postlogin-class5-lessons-perimeter,areaandvolume-perimeterandarea-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Perimeter, Area and Volume - Perimeter and Area - Start"},"postlogin-class5-lessons-perimeter,areaandvolume-perimeterandarea-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Perimeter, Area and Volume - Perimeter and Area - Resume"},"postlogin-class5-lessons-perimeter,areaandvolume-perimeterandarea-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Perimeter, Area and Volume - Perimeter and Area - Watched"},"postlogin-class5-lessons-perimeter,areaandvolume-perimeterandarea-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Perimeter, Area and Volume - Perimeter and Area - Lessons"},"postlogin-class5-lessons-perimeter,areaandvolume-perimeterandarea-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Perimeter, Area and Volume - Perimeter and Area - Close"},"postlogin-class6-lessons-mensuration-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Mensuration - Start"},"postlogin-class6-lessons-mensuration-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Mensuration - Resume"},"postlogin-class6-lessons-mensuration-watched":{"event_label":"Rewatch topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Mensuration - Watched"},"postlogin-class6-lessons-mensuration-perimeterandarea-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Mensuration - Perimeter and Area - Start"},"postlogin-class6-lessons-mensuration-perimeterandarea-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Mensuration - Perimeter and Area - Resume"},"postlogin-class6-lessons-mensuration-perimeterandarea-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Mensuration - Perimeter and Area - Watched"},"postlogin-class6-lessons-mensuration-perimeterandarea-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Mensuration - Perimeter and Area - Lessons"},"postlogin-class6-lessons-mensuration-perimeterandarea-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Mensuration - Perimeter and Area - Close"},"postlogin-class7-lessons-rationalnumbers-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Rational Numbers - Start"},"postlogin-class7-lessons-rationalnumbers-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Rational Numbers - Resume"},"postlogin-class7-lessons-rationalnumbers-watched":{"event_label":"Rewatch topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Rational Numbers - Watched"},"postlogin-class7-lessons-rationalnumbers-introductiontorationalnumbers-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Rational Numbers - Introduction to Rational Numbers - Start"},"postlogin-class7-lessons-rationalnumbers-introductiontorationalnumbers-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Rational Numbers - Introduction to Rational Numbers - Resume"},"postlogin-class7-lessons-rationalnumbers-introductiontorationalnumbers-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Rational Numbers - Introduction to Rational Numbers - Watched"},"postlogin-class7-lessons-rationalnumbers-introductiontorationalnumbers-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Rational Numbers - Introduction to Rational Numbers - Lessons"},"postlogin-class7-lessons-rationalnumbers-introductiontorationalnumbers-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Rational Numbers - Introduction to Rational Numbers - Close"},"postlogin-class7-lessons-rationalnumbers-addingandsubtractingrationalnumbers-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Rational Numbers - Adding and Subtracting Rational Numbers - Start"},"postlogin-class7-lessons-rationalnumbers-addingandsubtractingrationalnumbers-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Rational Numbers - Adding and Subtracting Rational Numbers - Resume"},"postlogin-class7-lessons-rationalnumbers-addingandsubtractingrationalnumbers-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Rational Numbers - Adding and Subtracting Rational Numbers - Watched"},"postlogin-class7-lessons-rationalnumbers-addingandsubtractingrationalnumbers-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Rational Numbers - Adding and Subtracting Rational Numbers - Lessons"},"postlogin-class7-lessons-rationalnumbers-addingandsubtractingrationalnumbers-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Rational Numbers - Adding and Subtracting Rational Numbers - Close"},"postlogin-class7-lessons-rationalnumbers-multiplyinganddividingrationalnumbers-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Rational Numbers - Multiplying and Dividing Rational Numbers - Start"},"postlogin-class7-lessons-rationalnumbers-multiplyinganddividingrationalnumbers-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Rational Numbers - Multiplying and Dividing Rational Numbers - Resume"},"postlogin-class7-lessons-rationalnumbers-multiplyinganddividingrationalnumbers-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Rational Numbers - Multiplying and Dividing Rational Numbers - Watched"},"postlogin-class7-lessons-rationalnumbers-multiplyinganddividingrationalnumbers-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Rational Numbers - Multiplying and Dividing Rational Numbers - Lessons"},"postlogin-class7-lessons-rationalnumbers-multiplyinganddividingrationalnumbers-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Rational Numbers - Multiplying and Dividing Rational Numbers - Close"},"postlogin-class7-lessons-rationalnumbers-comparingandorderingrationalnumber-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Rational Numbers - Comparing and Ordering Rational Number - Start"},"postlogin-class7-lessons-rationalnumbers-comparingandorderingrationalnumber-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Rational Numbers - Comparing and Ordering Rational Number - Resume"},"postlogin-class7-lessons-rationalnumbers-comparingandorderingrationalnumber-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Rational Numbers - Comparing and Ordering Rational Number - Watched"},"postlogin-class7-lessons-rationalnumbers-comparingandorderingrationalnumber-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Rational Numbers - Comparing and Ordering Rational Number - Lessons"},"postlogin-class7-lessons-rationalnumbers-comparingandorderingrationalnumber-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Rational Numbers - Comparing and Ordering Rational Number - Close"},"postlogin-class8-lessons-mensuration-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Mensuration - Start"},"postlogin-class8-lessons-mensuration-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Mensuration - Resume"},"postlogin-class8-lessons-mensuration-watched":{"event_label":"Rewatch topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Mensuration - Watched"},"postlogin-class8-lessons-mensuration-perimeterandarea-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Mensuration - Perimeter and Area - Start"},"postlogin-class8-lessons-mensuration-perimeterandarea-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Mensuration - Perimeter and Area - Resume"},"postlogin-class8-lessons-mensuration-perimeterandarea-watched":{"event_label":"Rewatch subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Mensuration - Perimeter and Area - Watched"},"postlogin-class8-lessons-mensuration-perimeterandarea-lessons":{"event_label":"Class 8 lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Mensuration - Perimeter and Area - Lessons"},"postlogin-class8-lessons-mensuration-perimeterandarea-close":{"event_label":"Close subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Mensuration - Perimeter and Area - Close"},"postlogin-class8-lessons-mensuration-surfaceareaofsolids-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Mensuration - Surface Area of Solids - Start"},"postlogin-class8-lessons-mensuration-surfaceareaofsolids-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Mensuration - Surface Area of Solids - Resume"},"postlogin-class8-lessons-mensuration-surfaceareaofsolids-watched":{"event_label":"Rewatch subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Mensuration - Surface Area of Solids - Watched"},"postlogin-class8-lessons-mensuration-surfaceareaofsolids-lessons":{"event_label":"Class 8 lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Mensuration - Surface Area of Solids - Lessons"},"postlogin-class8-lessons-mensuration-surfaceareaofsolids-close":{"event_label":"Close subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Mensuration - Surface Area of Solids - Close"},"postlogin-class8-lessons-mensuration-volumeofsolids-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Mensuration - Volume of Solids - Start"},"postlogin-class8-lessons-mensuration-volumeofsolids-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Mensuration - Volume of Solids - Resume"},"postlogin-class8-lessons-mensuration-volumeofsolids-watched":{"event_label":"Rewatch subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Mensuration - Volume of Solids - Watched"},"postlogin-class8-lessons-mensuration-volumeofsolids-lessons":{"event_label":"Class 8 lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Mensuration - Volume of Solids - Lessons"},"postlogin-class8-lessons-mensuration-volumeofsolids-close":{"event_label":"Close subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Mensuration - Volume of Solids - Close"},"postlogin-class9-lessons-exponentsandpowers-start":{"event_label":"Start topic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons - Exponents and Powers - Start"},"postlogin-class9-lessons-exponentsandpowers-resume":{"event_label":"Resume topic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons - Exponents and Powers - Resume"},"postlogin-class9-lessons-exponentsandpowers-watched":{"event_label":"Rewatch topic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons - Exponents and Powers - Watched"},"postlogin-class9-lessons-exponentsandpowers-introductiontoexponents-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Exponents and Powers - Introduction to Exponents - Start"},"postlogin-class9-lessons-exponentsandpowers-introductiontoexponents-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Exponents and Powers - Introduction to Exponents - Resume"},"postlogin-class9-lessons-exponentsandpowers-introductiontoexponents-watched":{"event_label":"Rewatch subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Exponents and Powers - Introduction to Exponents - Watched"},"postlogin-class9-lessons-exponentsandpowers-introductiontoexponents-lessons":{"event_label":"Class 9 lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Exponents and Powers - Introduction to Exponents - Lessons"},"postlogin-class9-lessons-exponentsandpowers-introductiontoexponents-close":{"event_label":"Close subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Exponents and Powers - Introduction to Exponents - Close"},"postlogin-class9-lessons-exponentsandpowers-lawsofexponents-start":{"event_label":"Start subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Exponents and Powers - Laws of Exponents - Start"},"postlogin-class9-lessons-exponentsandpowers-lawsofexponents-resume":{"event_label":"Resume subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Exponents and Powers - Laws of Exponents - Resume"},"postlogin-class9-lessons-exponentsandpowers-lawsofexponents-watched":{"event_label":"Rewatch subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Exponents and Powers - Laws of Exponents - Watched"},"postlogin-class9-lessons-exponentsandpowers-lawsofexponents-lessons":{"event_label":"Class 9 lessons","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Exponents and Powers - Laws of Exponents - Lessons"},"postlogin-class9-lessons-exponentsandpowers-lawsofexponents-close":{"event_label":"Close subtopic","event_category":"Class 9","event_action":"Post login - Class 9 - Lessons  - Exponents and Powers - Laws of Exponents - Close"},"postlogin-class5-tests-perimeter,areaandvolume-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Start"},"postlogin-class5-tests-perimeter,areaandvolume-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Resume"},"postlogin-class5-tests-perimeter,areaandvolume-revise":{"event_label":"Revise topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Revise"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - PT - Start"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - PT - Resume"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - PT - Report"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - PT - Start - Start Test"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - PT - Close"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - PT - Resume - Continue Test"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - PT - Test - Close"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - PT - Test - Submit Test"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - PT - Scorecard - View Solutions"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - CP - Start"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - CP - Start - Start Practice"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - CP - Start - Close"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - CP - Start - Start Practice - Close"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - CP - Start - Start Practice - Check"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - CP - Resume"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - CP - Resume - Continue"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - CP - Resume - Close"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - CP - Resume - Continue - Close"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - CP - Resume - Continue - Check"},"postlogin-class5-tests-perimeter,areaandvolume-perimeter-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Perimeter - CP - Report"},"postlogin-class5-tests-perimeter,areaandvolume-area-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - PT - Start"},"postlogin-class5-tests-perimeter,areaandvolume-area-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - PT - Resume"},"postlogin-class5-tests-perimeter,areaandvolume-area-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - PT - Report"},"postlogin-class5-tests-perimeter,areaandvolume-area-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - PT - Start - Start Test"},"postlogin-class5-tests-perimeter,areaandvolume-area-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - PT - Close"},"postlogin-class5-tests-perimeter,areaandvolume-area-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - PT - Resume - Continue Test"},"postlogin-class5-tests-perimeter,areaandvolume-area-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - PT - Test - Close"},"postlogin-class5-tests-perimeter,areaandvolume-area-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - PT - Test - Submit Test"},"postlogin-class5-tests-perimeter,areaandvolume-area-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - PT - Scorecard - View Solutions"},"postlogin-class5-tests-perimeter,areaandvolume-area-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-perimeter,areaandvolume-area-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-perimeter,areaandvolume-area-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-perimeter,areaandvolume-area-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-perimeter,areaandvolume-area-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-perimeter,areaandvolume-area-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-perimeter,areaandvolume-area-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-perimeter,areaandvolume-area-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-perimeter,areaandvolume-area-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-perimeter,areaandvolume-area-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-perimeter,areaandvolume-area-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-perimeter,areaandvolume-area-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-perimeter,areaandvolume-area-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-perimeter,areaandvolume-area-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-perimeter,areaandvolume-area-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-perimeter,areaandvolume-area-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - CP - Start"},"postlogin-class5-tests-perimeter,areaandvolume-area-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - CP - Start - Start Practice"},"postlogin-class5-tests-perimeter,areaandvolume-area-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - CP - Start - Close"},"postlogin-class5-tests-perimeter,areaandvolume-area-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - CP - Start - Start Practice - Close"},"postlogin-class5-tests-perimeter,areaandvolume-area-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - CP - Start - Start Practice - Check"},"postlogin-class5-tests-perimeter,areaandvolume-area-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - CP - Resume"},"postlogin-class5-tests-perimeter,areaandvolume-area-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - CP - Resume - Continue"},"postlogin-class5-tests-perimeter,areaandvolume-area-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - CP - Resume - Close"},"postlogin-class5-tests-perimeter,areaandvolume-area-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - CP - Resume - Continue - Close"},"postlogin-class5-tests-perimeter,areaandvolume-area-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - CP - Resume - Continue - Check"},"postlogin-class5-tests-perimeter,areaandvolume-area-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Area - CP - Report"},"postlogin-class5-tests-perimeter,areaandvolume-volume-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - PT - Start"},"postlogin-class5-tests-perimeter,areaandvolume-volume-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - PT - Resume"},"postlogin-class5-tests-perimeter,areaandvolume-volume-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - PT - Report"},"postlogin-class5-tests-perimeter,areaandvolume-volume-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - PT - Start - Start Test"},"postlogin-class5-tests-perimeter,areaandvolume-volume-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - PT - Close"},"postlogin-class5-tests-perimeter,areaandvolume-volume-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - PT - Resume - Continue Test"},"postlogin-class5-tests-perimeter,areaandvolume-volume-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - PT - Test - Close"},"postlogin-class5-tests-perimeter,areaandvolume-volume-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - PT - Test - Submit Test"},"postlogin-class5-tests-perimeter,areaandvolume-volume-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - PT - Scorecard - View Solutions"},"postlogin-class5-tests-perimeter,areaandvolume-volume-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-perimeter,areaandvolume-volume-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-perimeter,areaandvolume-volume-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-perimeter,areaandvolume-volume-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-perimeter,areaandvolume-volume-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-perimeter,areaandvolume-volume-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-perimeter,areaandvolume-volume-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-perimeter,areaandvolume-volume-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-perimeter,areaandvolume-volume-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-perimeter,areaandvolume-volume-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-perimeter,areaandvolume-volume-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-perimeter,areaandvolume-volume-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-perimeter,areaandvolume-volume-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-perimeter,areaandvolume-volume-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-perimeter,areaandvolume-volume-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-perimeter,areaandvolume-volume-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - CP - Start"},"postlogin-class5-tests-perimeter,areaandvolume-volume-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - CP - Start - Start Practice"},"postlogin-class5-tests-perimeter,areaandvolume-volume-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - CP - Start - Close"},"postlogin-class5-tests-perimeter,areaandvolume-volume-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - CP - Start - Start Practice - Close"},"postlogin-class5-tests-perimeter,areaandvolume-volume-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - CP - Start - Start Practice - Check"},"postlogin-class5-tests-perimeter,areaandvolume-volume-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - CP - Resume"},"postlogin-class5-tests-perimeter,areaandvolume-volume-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - CP - Resume - Continue"},"postlogin-class5-tests-perimeter,areaandvolume-volume-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - CP - Resume - Close"},"postlogin-class5-tests-perimeter,areaandvolume-volume-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - CP - Resume - Continue - Close"},"postlogin-class5-tests-perimeter,areaandvolume-volume-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - CP - Resume - Continue - Check"},"postlogin-class5-tests-perimeter,areaandvolume-volume-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Perimeter, Area and Volume - Volume - CP - Report"},"postlogin-class6-tests-mensuration-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Start"},"postlogin-class6-tests-mensuration-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Resume"},"postlogin-class6-tests-mensuration-revise":{"event_label":"Revise topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Revise"},"postlogin-class6-tests-mensuration-perimeter-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - PT - Start"},"postlogin-class6-tests-mensuration-perimeter-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - PT - Resume"},"postlogin-class6-tests-mensuration-perimeter-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - PT - Report"},"postlogin-class6-tests-mensuration-perimeter-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - PT - Start - Start Test"},"postlogin-class6-tests-mensuration-perimeter-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - PT - Close"},"postlogin-class6-tests-mensuration-perimeter-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - PT - Resume - Continue Test"},"postlogin-class6-tests-mensuration-perimeter-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - PT - Test - Close"},"postlogin-class6-tests-mensuration-perimeter-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - PT - Test - Submit Test"},"postlogin-class6-tests-mensuration-perimeter-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - PT - Scorecard - View Solutions"},"postlogin-class6-tests-mensuration-perimeter-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-mensuration-perimeter-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-mensuration-perimeter-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-mensuration-perimeter-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-mensuration-perimeter-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-mensuration-perimeter-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-mensuration-perimeter-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-mensuration-perimeter-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-mensuration-perimeter-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-mensuration-perimeter-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-mensuration-perimeter-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-mensuration-perimeter-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-mensuration-perimeter-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-mensuration-perimeter-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-mensuration-perimeter-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-mensuration-perimeter-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - CP - Start"},"postlogin-class6-tests-mensuration-perimeter-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - CP - Start - Start Practice"},"postlogin-class6-tests-mensuration-perimeter-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - CP - Start - Close"},"postlogin-class6-tests-mensuration-perimeter-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - CP - Start - Start Practice - Close"},"postlogin-class6-tests-mensuration-perimeter-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - CP - Start - Start Practice - Check"},"postlogin-class6-tests-mensuration-perimeter-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - CP - Resume"},"postlogin-class6-tests-mensuration-perimeter-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - CP - Resume - Continue"},"postlogin-class6-tests-mensuration-perimeter-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - CP - Resume - Close"},"postlogin-class6-tests-mensuration-perimeter-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - CP - Resume - Continue - Close"},"postlogin-class6-tests-mensuration-perimeter-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - CP - Resume - Continue - Check"},"postlogin-class6-tests-mensuration-perimeter-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Perimeter - CP - Report"},"postlogin-class6-tests-mensuration-area-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - PT - Start"},"postlogin-class6-tests-mensuration-area-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - PT - Resume"},"postlogin-class6-tests-mensuration-area-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - PT - Report"},"postlogin-class6-tests-mensuration-area-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - PT - Start - Start Test"},"postlogin-class6-tests-mensuration-area-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - PT - Close"},"postlogin-class6-tests-mensuration-area-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - PT - Resume - Continue Test"},"postlogin-class6-tests-mensuration-area-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - PT - Test - Close"},"postlogin-class6-tests-mensuration-area-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - PT - Test - Submit Test"},"postlogin-class6-tests-mensuration-area-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - PT - Scorecard - View Solutions"},"postlogin-class6-tests-mensuration-area-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-mensuration-area-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-mensuration-area-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-mensuration-area-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-mensuration-area-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-mensuration-area-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-mensuration-area-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-mensuration-area-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-mensuration-area-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-mensuration-area-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-mensuration-area-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-mensuration-area-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-mensuration-area-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-mensuration-area-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-mensuration-area-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-mensuration-area-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - CP - Start"},"postlogin-class6-tests-mensuration-area-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - CP - Start - Start Practice"},"postlogin-class6-tests-mensuration-area-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - CP - Start - Close"},"postlogin-class6-tests-mensuration-area-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - CP - Start - Start Practice - Close"},"postlogin-class6-tests-mensuration-area-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - CP - Start - Start Practice - Check"},"postlogin-class6-tests-mensuration-area-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - CP - Resume"},"postlogin-class6-tests-mensuration-area-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - CP - Resume - Continue"},"postlogin-class6-tests-mensuration-area-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - CP - Resume - Close"},"postlogin-class6-tests-mensuration-area-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - CP - Resume - Continue - Close"},"postlogin-class6-tests-mensuration-area-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - CP - Resume - Continue - Check"},"postlogin-class6-tests-mensuration-area-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Mensuration - Area - CP - Report"},"postlogin-class7-tests-rationalnumbers-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Start"},"postlogin-class7-tests-rationalnumbers-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Resume"},"postlogin-class7-tests-rationalnumbers-revise":{"event_label":"Revise topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Revise"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - PT - Start"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - PT - Resume"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - PT - Report"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - PT - Start - Start Test"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - PT - Close"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - PT - Resume - Continue Test"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - PT - Test - Close"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - PT - Test - Submit Test"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - PT - Scorecard - View Solutions"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - CP - Start"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - CP - Start - Start Practice"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - CP - Start - Close"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - CP - Start - Start Practice - Close"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - CP - Start - Start Practice - Check"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - CP - Resume"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - CP - Resume - Continue"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - CP - Resume - Close"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - CP - Resume - Continue - Close"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - CP - Resume - Continue - Check"},"postlogin-class7-tests-rationalnumbers-introductiontorationalnumbers-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Introduction to Rational Numbers - CP - Report"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - PT - Start"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - PT - Resume"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - PT - Report"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - PT - Start - Start Test"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - PT - Close"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - PT - Resume - Continue Test"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - PT - Test - Close"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - PT - Test - Submit Test"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - PT - Scorecard - View Solutions"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - CP - Start"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - CP - Start - Start Practice"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - CP - Start - Close"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - CP - Start - Start Practice - Close"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - CP - Start - Start Practice - Check"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - CP - Resume"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - CP - Resume - Continue"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - CP - Resume - Close"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - CP - Resume - Continue - Close"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - CP - Resume - Continue - Check"},"postlogin-class7-tests-rationalnumbers-comparingandorderingrationalnumber-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Comparing and Ordering Rational Number - CP - Report"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - PT - Start"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - PT - Resume"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - PT - Report"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - PT - Start - Start Test"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - PT - Close"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - PT - Resume - Continue Test"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - PT - Test - Close"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - PT - Test - Submit Test"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - PT - Scorecard - View Solutions"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - CP - Start"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - CP - Start - Start Practice"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - CP - Start - Close"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - CP - Start - Start Practice - Close"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - CP - Start - Start Practice - Check"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - CP - Resume"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - CP - Resume - Continue"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - CP - Resume - Close"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - CP - Resume - Continue - Close"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - CP - Resume - Continue - Check"},"postlogin-class7-tests-rationalnumbers-addingandsubtractingrationalnumbers-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Adding and Subtracting Rational Numbers - CP - Report"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - PT - Start"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - PT - Resume"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - PT - Report"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - PT - Start - Start Test"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - PT - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - PT - Resume - Continue Test"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - PT - Test - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - PT - Test - Submit Test"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - PT - Scorecard - View Solutions"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - CP - Start"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - CP - Start - Start Practice"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - CP - Start - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - CP - Start - Start Practice - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - CP - Start - Start Practice - Check"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - CP - Resume"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - CP - Resume - Continue"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - CP - Resume - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - CP - Resume - Continue - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - CP - Resume - Continue - Check"},"postlogin-class7-tests-rationalnumbers-wordproblemsonaddingandsubtracting-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problems on Adding and Subtracting - CP - Report"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - PT - Start"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - PT - Resume"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - PT - Report"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - PT - Start - Start Test"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - PT - Close"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - PT - Resume - Continue Test"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - PT - Test - Close"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - PT - Test - Submit Test"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - PT - Scorecard - View Solutions"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - CP - Start"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - CP - Start - Start Practice"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - CP - Start - Close"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - CP - Start - Start Practice - Close"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - CP - Start - Start Practice - Check"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - CP - Resume"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - CP - Resume - Continue"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - CP - Resume - Close"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - CP - Resume - Continue - Close"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - CP - Resume - Continue - Check"},"postlogin-class7-tests-rationalnumbers-multiplyinganddividingrationalnumbers-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Multiplying and Dividing Rational Numbers - CP - Report"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - PT - Start"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - PT - Resume"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - PT - Report"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - PT - Start - Start Test"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - PT - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - PT - Resume - Continue Test"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - PT - Test - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - PT - Test - Submit Test"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - PT - Scorecard - View Solutions"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - CP - Start"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - CP - Start - Start Practice"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - CP - Start - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - CP - Start - Start Practice - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - CP - Start - Start Practice - Check"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - CP - Resume"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - CP - Resume - Continue"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - CP - Resume - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - CP - Resume - Continue - Close"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - CP - Resume - Continue - Check"},"postlogin-class7-tests-rationalnumbers-wordproblemonmultiplyinganddividing-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Rational Numbers - Word Problem on Multiplying and Dividing - CP - Report"},"postlogin-class8-tests-exponentsandpowers-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Start"},"postlogin-class8-tests-exponentsandpowers-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Resume"},"postlogin-class8-tests-exponentsandpowers-revise":{"event_label":"Revise topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Revise"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - PT - Start"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - PT - Resume"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - PT - Report"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - PT - Start - Start Test"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - PT - Close"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - PT - Resume - Continue Test"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - PT - Test - Close"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - PT - Test - Submit Test"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - PT - Scorecard - View Solutions"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - CP - Start"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - CP - Start - Start Practice"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - CP - Start - Close"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - CP - Start - Start Practice - Close"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - CP - Start - Start Practice - Check"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - CP - Resume"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - CP - Resume - Continue"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - CP - Resume - Close"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - CP - Resume - Continue - Close"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - CP - Resume - Continue - Check"},"postlogin-class8-tests-exponentsandpowers-introductiontoexponents-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Introduction to Exponents - CP - Report"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - PT - Start"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - PT - Resume"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - PT - Report"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - PT - Start - Start Test"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - PT - Close"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - PT - Resume - Continue Test"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - PT - Test - Close"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - PT - Test - Submit Test"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - PT - Scorecard - View Solutions"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - CP - Start"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - CP - Start - Start Practice"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - CP - Start - Close"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - CP - Start - Start Practice - Close"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - CP - Start - Start Practice - Check"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - CP - Resume"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - CP - Resume - Continue"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - CP - Resume - Close"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - CP - Resume - Continue - Close"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - CP - Resume - Continue - Check"},"postlogin-class8-tests-exponentsandpowers-lawsofexponents-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Exponents and Powers - Laws of Exponents - CP - Report"},"postlogin-class5-lessons-timeandtemperature-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Time and Temperature - Start"},"postlogin-class5-lessons-timeandtemperature-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Time and Temperature - Resume"},"postlogin-class5-lessons-timeandtemperature-watched":{"event_label":"Rewatch topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Time and Temperature - Watched"},"postlogin-class5-lessons-timeandtemperature-time-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Time and Temperature - Time - Start"},"postlogin-class5-lessons-timeandtemperature-time-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Time and Temperature - Time - Resume"},"postlogin-class5-lessons-timeandtemperature-time-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Time and Temperature - Time - Watched"},"postlogin-class5-lessons-timeandtemperature-time-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Time and Temperature - Time - Lessons"},"postlogin-class5-lessons-timeandtemperature-time-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Time and Temperature - Time - Close"},"postlogin-class5-lessons-timeandtemperature-temperature-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Time and Temperature - Temperature - Start"},"postlogin-class5-lessons-timeandtemperature-temperature-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Time and Temperature - Temperature - Resume"},"postlogin-class5-lessons-timeandtemperature-temperature-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Time and Temperature - Temperature - Watched"},"postlogin-class5-lessons-timeandtemperature-temperature-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Time and Temperature - Temperature - Lessons"},"postlogin-class5-lessons-timeandtemperature-temperature-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Time and Temperature - Temperature - Close"},"postlogin-class6-lessons-algebra-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Algebra - Start"},"postlogin-class6-lessons-algebra-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Algebra - Resume"},"postlogin-class6-lessons-algebra-watched":{"event_label":"Rewatch topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Algebra - Watched"},"postlogin-class6-lessons-algebra-algebraicexpressions-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Algebra - Algebraic Expressions - Start"},"postlogin-class6-lessons-algebra-algebraicexpressions-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Algebra - Algebraic Expressions - Resume"},"postlogin-class6-lessons-algebra-algebraicexpressions-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Algebra - Algebraic Expressions - Watched"},"postlogin-class6-lessons-algebra-algebraicexpressions-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Algebra - Algebraic Expressions - Lessons"},"postlogin-class6-lessons-algebra-algebraicexpressions-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Algebra - Algebraic Expressions - Close"},"postlogin-class6-lessons-algebra-writingandsolvingequations-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Algebra - Writing and Solving Equations - Start"},"postlogin-class6-lessons-algebra-writingandsolvingequations-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Algebra - Writing and Solving Equations - Resume"},"postlogin-class6-lessons-algebra-writingandsolvingequations-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Algebra - Writing and Solving Equations - Watched"},"postlogin-class6-lessons-algebra-writingandsolvingequations-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Algebra - Writing and Solving Equations - Lessons"},"postlogin-class6-lessons-algebra-writingandsolvingequations-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Algebra - Writing and Solving Equations - Close"},"postlogin-class6-lessons-algebra-numberpatterns-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Algebra - Number Patterns - Start"},"postlogin-class6-lessons-algebra-numberpatterns-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Algebra - Number Patterns - Resume"},"postlogin-class6-lessons-algebra-numberpatterns-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Algebra - Number Patterns - Watched"},"postlogin-class6-lessons-algebra-numberpatterns-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Algebra - Number Patterns - Lessons"},"postlogin-class6-lessons-algebra-numberpatterns-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Algebra - Number Patterns - Close"},"postlogin-class7-lessons-practicalgeometry-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Practical Geometry - Start"},"postlogin-class7-lessons-practicalgeometry-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Practical Geometry - Resume"},"postlogin-class7-lessons-practicalgeometry-watched":{"event_label":"Rewatch topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Practical Geometry - Watched"},"postlogin-class7-lessons-practicalgeometry-geometricalconstructions-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Practical Geometry - Geometrical Constructions - Start"},"postlogin-class7-lessons-practicalgeometry-geometricalconstructions-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Practical Geometry - Geometrical Constructions - Resume"},"postlogin-class7-lessons-practicalgeometry-geometricalconstructions-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Practical Geometry - Geometrical Constructions - Watched"},"postlogin-class7-lessons-practicalgeometry-geometricalconstructions-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Practical Geometry - Geometrical Constructions - Lessons"},"postlogin-class7-lessons-practicalgeometry-geometricalconstructions-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Practical Geometry - Geometrical Constructions - Close"},"postlogin-class5-tests-timeandtemperature-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Start"},"postlogin-class5-tests-timeandtemperature-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Resume"},"postlogin-class5-tests-timeandtemperature-revise":{"event_label":"Revise topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Revise"},"postlogin-class5-tests-timeandtemperature-time-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - PT - Start"},"postlogin-class5-tests-timeandtemperature-time-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - PT - Resume"},"postlogin-class5-tests-timeandtemperature-time-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - PT - Report"},"postlogin-class5-tests-timeandtemperature-time-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - PT - Start - Start Test"},"postlogin-class5-tests-timeandtemperature-time-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - PT - Close"},"postlogin-class5-tests-timeandtemperature-time-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - PT - Resume - Continue Test"},"postlogin-class5-tests-timeandtemperature-time-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - PT - Test - Close"},"postlogin-class5-tests-timeandtemperature-time-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - PT - Test - Submit Test"},"postlogin-class5-tests-timeandtemperature-time-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - PT - Scorecard - View Solutions"},"postlogin-class5-tests-timeandtemperature-time-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-timeandtemperature-time-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-timeandtemperature-time-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-timeandtemperature-time-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-timeandtemperature-time-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-timeandtemperature-time-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-timeandtemperature-time-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-timeandtemperature-time-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-timeandtemperature-time-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-timeandtemperature-time-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-timeandtemperature-time-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-timeandtemperature-time-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-timeandtemperature-time-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-timeandtemperature-time-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-timeandtemperature-time-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-timeandtemperature-time-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - CP - Start"},"postlogin-class5-tests-timeandtemperature-time-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - CP - Start - Start Practice"},"postlogin-class5-tests-timeandtemperature-time-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - CP - Start - Close"},"postlogin-class5-tests-timeandtemperature-time-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - CP - Start - Start Practice - Close"},"postlogin-class5-tests-timeandtemperature-time-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - CP - Start - Start Practice - Check"},"postlogin-class5-tests-timeandtemperature-time-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - CP - Resume"},"postlogin-class5-tests-timeandtemperature-time-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - CP - Resume - Continue"},"postlogin-class5-tests-timeandtemperature-time-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - CP - Resume - Close"},"postlogin-class5-tests-timeandtemperature-time-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - CP - Resume - Continue - Close"},"postlogin-class5-tests-timeandtemperature-time-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - CP - Resume - Continue - Check"},"postlogin-class5-tests-timeandtemperature-time-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Time - CP - Report"},"postlogin-class5-tests-timeandtemperature-temperature-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - PT - Start"},"postlogin-class5-tests-timeandtemperature-temperature-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - PT - Resume"},"postlogin-class5-tests-timeandtemperature-temperature-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - PT - Report"},"postlogin-class5-tests-timeandtemperature-temperature-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - PT - Start - Start Test"},"postlogin-class5-tests-timeandtemperature-temperature-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - PT - Close"},"postlogin-class5-tests-timeandtemperature-temperature-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - PT - Resume - Continue Test"},"postlogin-class5-tests-timeandtemperature-temperature-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - PT - Test - Close"},"postlogin-class5-tests-timeandtemperature-temperature-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - PT - Test - Submit Test"},"postlogin-class5-tests-timeandtemperature-temperature-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - PT - Scorecard - View Solutions"},"postlogin-class5-tests-timeandtemperature-temperature-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-timeandtemperature-temperature-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-timeandtemperature-temperature-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-timeandtemperature-temperature-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-timeandtemperature-temperature-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-timeandtemperature-temperature-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-timeandtemperature-temperature-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-timeandtemperature-temperature-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-timeandtemperature-temperature-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-timeandtemperature-temperature-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-timeandtemperature-temperature-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-timeandtemperature-temperature-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-timeandtemperature-temperature-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-timeandtemperature-temperature-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-timeandtemperature-temperature-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-timeandtemperature-temperature-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - CP - Start"},"postlogin-class5-tests-timeandtemperature-temperature-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - CP - Start - Start Practice"},"postlogin-class5-tests-timeandtemperature-temperature-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - CP - Start - Close"},"postlogin-class5-tests-timeandtemperature-temperature-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - CP - Start - Start Practice - Close"},"postlogin-class5-tests-timeandtemperature-temperature-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - CP - Start - Start Practice - Check"},"postlogin-class5-tests-timeandtemperature-temperature-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - CP - Resume"},"postlogin-class5-tests-timeandtemperature-temperature-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - CP - Resume - Continue"},"postlogin-class5-tests-timeandtemperature-temperature-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - CP - Resume - Close"},"postlogin-class5-tests-timeandtemperature-temperature-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - CP - Resume - Continue - Close"},"postlogin-class5-tests-timeandtemperature-temperature-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - CP - Resume - Continue - Check"},"postlogin-class5-tests-timeandtemperature-temperature-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Time and Temperature - Temperature - CP - Report"},"postlogin-class6-tests-algebra-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Start"},"postlogin-class6-tests-algebra-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Resume"},"postlogin-class6-tests-algebra-revise":{"event_label":"Revise topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Revise"},"postlogin-class6-tests-algebra-algebraicexpressions-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - PT - Start"},"postlogin-class6-tests-algebra-algebraicexpressions-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - PT - Resume"},"postlogin-class6-tests-algebra-algebraicexpressions-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - PT - Report"},"postlogin-class6-tests-algebra-algebraicexpressions-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - PT - Start - Start Test"},"postlogin-class6-tests-algebra-algebraicexpressions-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - PT - Close"},"postlogin-class6-tests-algebra-algebraicexpressions-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - PT - Resume - Continue Test"},"postlogin-class6-tests-algebra-algebraicexpressions-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - PT - Test - Close"},"postlogin-class6-tests-algebra-algebraicexpressions-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - PT - Test - Submit Test"},"postlogin-class6-tests-algebra-algebraicexpressions-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Solutions"},"postlogin-class6-tests-algebra-algebraicexpressions-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-algebra-algebraicexpressions-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - CP - Start"},"postlogin-class6-tests-algebra-algebraicexpressions-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - CP - Start - Start Practice"},"postlogin-class6-tests-algebra-algebraicexpressions-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - CP - Start - Close"},"postlogin-class6-tests-algebra-algebraicexpressions-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - CP - Start - Start Practice - Close"},"postlogin-class6-tests-algebra-algebraicexpressions-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - CP - Start - Start Practice - Check"},"postlogin-class6-tests-algebra-algebraicexpressions-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - CP - Resume"},"postlogin-class6-tests-algebra-algebraicexpressions-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - CP - Resume - Continue"},"postlogin-class6-tests-algebra-algebraicexpressions-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - CP - Resume - Close"},"postlogin-class6-tests-algebra-algebraicexpressions-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - CP - Resume - Continue - Close"},"postlogin-class6-tests-algebra-algebraicexpressions-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - CP - Resume - Continue - Check"},"postlogin-class6-tests-algebra-algebraicexpressions-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Algebraic Expressions - CP - Report"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - PT - Start"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - PT - Resume"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - PT - Report"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - PT - Start - Start Test"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - PT - Close"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - PT - Resume - Continue Test"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - PT - Test - Close"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - PT - Test - Submit Test"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - PT - Scorecard - View Solutions"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - CP - Start"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - CP - Start - Start Practice"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - CP - Start - Close"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - CP - Start - Start Practice - Close"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - CP - Start - Start Practice - Check"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - CP - Resume"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - CP - Resume - Continue"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - CP - Resume - Close"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - CP - Resume - Continue - Close"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - CP - Resume - Continue - Check"},"postlogin-class6-tests-algebra-moreonalgebraicexpressions-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - More on Algebraic Expressions - CP - Report"},"postlogin-class6-tests-algebra-writingandsolvingequations-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - PT - Start"},"postlogin-class6-tests-algebra-writingandsolvingequations-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - PT - Resume"},"postlogin-class6-tests-algebra-writingandsolvingequations-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - PT - Report"},"postlogin-class6-tests-algebra-writingandsolvingequations-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - PT - Start - Start Test"},"postlogin-class6-tests-algebra-writingandsolvingequations-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - PT - Close"},"postlogin-class6-tests-algebra-writingandsolvingequations-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - PT - Resume - Continue Test"},"postlogin-class6-tests-algebra-writingandsolvingequations-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - PT - Test - Close"},"postlogin-class6-tests-algebra-writingandsolvingequations-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - PT - Test - Submit Test"},"postlogin-class6-tests-algebra-writingandsolvingequations-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - PT - Scorecard - View Solutions"},"postlogin-class6-tests-algebra-writingandsolvingequations-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-algebra-writingandsolvingequations-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-algebra-writingandsolvingequations-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-algebra-writingandsolvingequations-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-algebra-writingandsolvingequations-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-algebra-writingandsolvingequations-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-algebra-writingandsolvingequations-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-algebra-writingandsolvingequations-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-algebra-writingandsolvingequations-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-algebra-writingandsolvingequations-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-algebra-writingandsolvingequations-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-algebra-writingandsolvingequations-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-algebra-writingandsolvingequations-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-algebra-writingandsolvingequations-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-algebra-writingandsolvingequations-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-algebra-writingandsolvingequations-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - CP - Start"},"postlogin-class6-tests-algebra-writingandsolvingequations-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - CP - Start - Start Practice"},"postlogin-class6-tests-algebra-writingandsolvingequations-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - CP - Start - Close"},"postlogin-class6-tests-algebra-writingandsolvingequations-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - CP - Start - Start Practice - Close"},"postlogin-class6-tests-algebra-writingandsolvingequations-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - CP - Start - Start Practice - Check"},"postlogin-class6-tests-algebra-writingandsolvingequations-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - CP - Resume"},"postlogin-class6-tests-algebra-writingandsolvingequations-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - CP - Resume - Continue"},"postlogin-class6-tests-algebra-writingandsolvingequations-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - CP - Resume - Close"},"postlogin-class6-tests-algebra-writingandsolvingequations-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - CP - Resume - Continue - Close"},"postlogin-class6-tests-algebra-writingandsolvingequations-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - CP - Resume - Continue - Check"},"postlogin-class6-tests-algebra-writingandsolvingequations-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Algebra - Writing and Solving Equations - CP - Report"},"postlogin-class7-tests-mensuration-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Start"},"postlogin-class7-tests-mensuration-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Resume"},"postlogin-class7-tests-mensuration-revise":{"event_label":"Revise topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Revise"},"postlogin-class7-tests-mensuration-circumferenceofacircle-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - PT - Start"},"postlogin-class7-tests-mensuration-circumferenceofacircle-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - PT - Resume"},"postlogin-class7-tests-mensuration-circumferenceofacircle-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - PT - Report"},"postlogin-class7-tests-mensuration-circumferenceofacircle-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - PT - Start - Start Test"},"postlogin-class7-tests-mensuration-circumferenceofacircle-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - PT - Close"},"postlogin-class7-tests-mensuration-circumferenceofacircle-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - PT - Resume - Continue Test"},"postlogin-class7-tests-mensuration-circumferenceofacircle-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - PT - Test - Close"},"postlogin-class7-tests-mensuration-circumferenceofacircle-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - PT - Test - Submit Test"},"postlogin-class7-tests-mensuration-circumferenceofacircle-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - PT - Scorecard - View Solutions"},"postlogin-class7-tests-mensuration-circumferenceofacircle-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-mensuration-circumferenceofacircle-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-mensuration-circumferenceofacircle-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-mensuration-circumferenceofacircle-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-mensuration-circumferenceofacircle-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-mensuration-circumferenceofacircle-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-mensuration-circumferenceofacircle-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-mensuration-circumferenceofacircle-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-mensuration-circumferenceofacircle-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-mensuration-circumferenceofacircle-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-mensuration-circumferenceofacircle-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-mensuration-circumferenceofacircle-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-mensuration-circumferenceofacircle-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-mensuration-circumferenceofacircle-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-mensuration-circumferenceofacircle-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-mensuration-circumferenceofacircle-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - CP - Start"},"postlogin-class7-tests-mensuration-circumferenceofacircle-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - CP - Start - Start Practice"},"postlogin-class7-tests-mensuration-circumferenceofacircle-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - CP - Start - Close"},"postlogin-class7-tests-mensuration-circumferenceofacircle-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - CP - Start - Start Practice - Close"},"postlogin-class7-tests-mensuration-circumferenceofacircle-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - CP - Start - Start Practice - Check"},"postlogin-class7-tests-mensuration-circumferenceofacircle-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - CP - Resume"},"postlogin-class7-tests-mensuration-circumferenceofacircle-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - CP - Resume - Continue"},"postlogin-class7-tests-mensuration-circumferenceofacircle-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - CP - Resume - Close"},"postlogin-class7-tests-mensuration-circumferenceofacircle-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - CP - Resume - Continue - Close"},"postlogin-class7-tests-mensuration-circumferenceofacircle-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - CP - Resume - Continue - Check"},"postlogin-class7-tests-mensuration-circumferenceofacircle-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Circumference of a Circle - CP - Report"},"postlogin-class7-tests-mensuration-areaofacircle-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - PT - Start"},"postlogin-class7-tests-mensuration-areaofacircle-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - PT - Resume"},"postlogin-class7-tests-mensuration-areaofacircle-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - PT - Report"},"postlogin-class7-tests-mensuration-areaofacircle-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - PT - Start - Start Test"},"postlogin-class7-tests-mensuration-areaofacircle-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - PT - Close"},"postlogin-class7-tests-mensuration-areaofacircle-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - PT - Resume - Continue Test"},"postlogin-class7-tests-mensuration-areaofacircle-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - PT - Test - Close"},"postlogin-class7-tests-mensuration-areaofacircle-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - PT - Test - Submit Test"},"postlogin-class7-tests-mensuration-areaofacircle-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - PT - Scorecard - View Solutions"},"postlogin-class7-tests-mensuration-areaofacircle-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-mensuration-areaofacircle-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-mensuration-areaofacircle-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-mensuration-areaofacircle-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-mensuration-areaofacircle-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-mensuration-areaofacircle-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-mensuration-areaofacircle-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-mensuration-areaofacircle-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-mensuration-areaofacircle-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-mensuration-areaofacircle-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-mensuration-areaofacircle-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-mensuration-areaofacircle-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-mensuration-areaofacircle-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-mensuration-areaofacircle-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-mensuration-areaofacircle-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-mensuration-areaofacircle-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - CP - Start"},"postlogin-class7-tests-mensuration-areaofacircle-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - CP - Start - Start Practice"},"postlogin-class7-tests-mensuration-areaofacircle-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - CP - Start - Close"},"postlogin-class7-tests-mensuration-areaofacircle-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - CP - Start - Start Practice - Close"},"postlogin-class7-tests-mensuration-areaofacircle-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - CP - Start - Start Practice - Check"},"postlogin-class7-tests-mensuration-areaofacircle-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - CP - Resume"},"postlogin-class7-tests-mensuration-areaofacircle-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - CP - Resume - Continue"},"postlogin-class7-tests-mensuration-areaofacircle-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - CP - Resume - Close"},"postlogin-class7-tests-mensuration-areaofacircle-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - CP - Resume - Continue - Close"},"postlogin-class7-tests-mensuration-areaofacircle-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - CP - Resume - Continue - Check"},"postlogin-class7-tests-mensuration-areaofacircle-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Circle - CP - Report"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - PT - Start"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - PT - Resume"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - PT - Report"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - PT - Start - Start Test"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - PT - Close"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - PT - Resume - Continue Test"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - PT - Test - Close"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - PT - Test - Submit Test"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - PT - Scorecard - View Solutions"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - CP - Start"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - CP - Start - Start Practice"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - CP - Start - Close"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - CP - Start - Start Practice - Close"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - CP - Start - Start Practice - Check"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - CP - Resume"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - CP - Resume - Continue"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - CP - Resume - Close"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - CP - Resume - Continue - Close"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - CP - Resume - Continue - Check"},"postlogin-class7-tests-mensuration-areaofarectangleandasquare-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of a Rectangle and a Square - CP - Report"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - PT - Start"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - PT - Resume"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - PT - Report"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - PT - Start - Start Test"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - PT - Close"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - PT - Resume - Continue Test"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - PT - Test - Close"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - PT - Test - Submit Test"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - PT - Scorecard - View Solutions"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - CP - Start"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - CP - Start - Start Practice"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - CP - Start - Close"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - CP - Start - Start Practice - Close"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - CP - Start - Start Practice - Check"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - CP - Resume"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - CP - Resume - Continue"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - CP - Resume - Close"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - CP - Resume - Continue - Close"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - CP - Resume - Continue - Check"},"postlogin-class7-tests-mensuration-moreonareaofrectangleandsquare-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - More on Area of Rectangle and Square - CP - Report"},"postlogin-class7-tests-mensuration-areaoftriangle-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - PT - Start"},"postlogin-class7-tests-mensuration-areaoftriangle-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - PT - Resume"},"postlogin-class7-tests-mensuration-areaoftriangle-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - PT - Report"},"postlogin-class7-tests-mensuration-areaoftriangle-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - PT - Start - Start Test"},"postlogin-class7-tests-mensuration-areaoftriangle-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - PT - Close"},"postlogin-class7-tests-mensuration-areaoftriangle-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - PT - Resume - Continue Test"},"postlogin-class7-tests-mensuration-areaoftriangle-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - PT - Test - Close"},"postlogin-class7-tests-mensuration-areaoftriangle-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - PT - Test - Submit Test"},"postlogin-class7-tests-mensuration-areaoftriangle-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - PT - Scorecard - View Solutions"},"postlogin-class7-tests-mensuration-areaoftriangle-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-mensuration-areaoftriangle-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-mensuration-areaoftriangle-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-mensuration-areaoftriangle-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-mensuration-areaoftriangle-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-mensuration-areaoftriangle-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-mensuration-areaoftriangle-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-mensuration-areaoftriangle-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-mensuration-areaoftriangle-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-mensuration-areaoftriangle-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-mensuration-areaoftriangle-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-mensuration-areaoftriangle-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-mensuration-areaoftriangle-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-mensuration-areaoftriangle-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-mensuration-areaoftriangle-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-mensuration-areaoftriangle-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - CP - Start"},"postlogin-class7-tests-mensuration-areaoftriangle-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - CP - Start - Start Practice"},"postlogin-class7-tests-mensuration-areaoftriangle-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - CP - Start - Close"},"postlogin-class7-tests-mensuration-areaoftriangle-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - CP - Start - Start Practice - Close"},"postlogin-class7-tests-mensuration-areaoftriangle-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - CP - Start - Start Practice - Check"},"postlogin-class7-tests-mensuration-areaoftriangle-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - CP - Resume"},"postlogin-class7-tests-mensuration-areaoftriangle-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - CP - Resume - Continue"},"postlogin-class7-tests-mensuration-areaoftriangle-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - CP - Resume - Close"},"postlogin-class7-tests-mensuration-areaoftriangle-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - CP - Resume - Continue - Close"},"postlogin-class7-tests-mensuration-areaoftriangle-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - CP - Resume - Continue - Check"},"postlogin-class7-tests-mensuration-areaoftriangle-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Triangle - CP - Report"},"postlogin-class7-tests-mensuration-areaofparallelogram-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - PT - Start"},"postlogin-class7-tests-mensuration-areaofparallelogram-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - PT - Resume"},"postlogin-class7-tests-mensuration-areaofparallelogram-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - PT - Report"},"postlogin-class7-tests-mensuration-areaofparallelogram-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - PT - Start - Start Test"},"postlogin-class7-tests-mensuration-areaofparallelogram-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - PT - Close"},"postlogin-class7-tests-mensuration-areaofparallelogram-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - PT - Resume - Continue Test"},"postlogin-class7-tests-mensuration-areaofparallelogram-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - PT - Test - Close"},"postlogin-class7-tests-mensuration-areaofparallelogram-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - PT - Test - Submit Test"},"postlogin-class7-tests-mensuration-areaofparallelogram-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - PT - Scorecard - View Solutions"},"postlogin-class7-tests-mensuration-areaofparallelogram-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-mensuration-areaofparallelogram-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-mensuration-areaofparallelogram-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-mensuration-areaofparallelogram-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-mensuration-areaofparallelogram-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-mensuration-areaofparallelogram-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-mensuration-areaofparallelogram-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-mensuration-areaofparallelogram-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-mensuration-areaofparallelogram-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-mensuration-areaofparallelogram-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-mensuration-areaofparallelogram-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-mensuration-areaofparallelogram-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-mensuration-areaofparallelogram-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-mensuration-areaofparallelogram-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-mensuration-areaofparallelogram-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-mensuration-areaofparallelogram-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - CP - Start"},"postlogin-class7-tests-mensuration-areaofparallelogram-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - CP - Start - Start Practice"},"postlogin-class7-tests-mensuration-areaofparallelogram-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - CP - Start - Close"},"postlogin-class7-tests-mensuration-areaofparallelogram-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - CP - Start - Start Practice - Close"},"postlogin-class7-tests-mensuration-areaofparallelogram-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - CP - Start - Start Practice - Check"},"postlogin-class7-tests-mensuration-areaofparallelogram-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - CP - Resume"},"postlogin-class7-tests-mensuration-areaofparallelogram-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - CP - Resume - Continue"},"postlogin-class7-tests-mensuration-areaofparallelogram-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - CP - Resume - Close"},"postlogin-class7-tests-mensuration-areaofparallelogram-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - CP - Resume - Continue - Close"},"postlogin-class7-tests-mensuration-areaofparallelogram-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - CP - Resume - Continue - Check"},"postlogin-class7-tests-mensuration-areaofparallelogram-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Parallelogram - CP - Report"},"postlogin-class7-tests-mensuration-areaofpathways-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - PT - Start"},"postlogin-class7-tests-mensuration-areaofpathways-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - PT - Resume"},"postlogin-class7-tests-mensuration-areaofpathways-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - PT - Report"},"postlogin-class7-tests-mensuration-areaofpathways-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - PT - Start - Start Test"},"postlogin-class7-tests-mensuration-areaofpathways-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - PT - Close"},"postlogin-class7-tests-mensuration-areaofpathways-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - PT - Resume - Continue Test"},"postlogin-class7-tests-mensuration-areaofpathways-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - PT - Test - Close"},"postlogin-class7-tests-mensuration-areaofpathways-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - PT - Test - Submit Test"},"postlogin-class7-tests-mensuration-areaofpathways-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - PT - Scorecard - View Solutions"},"postlogin-class7-tests-mensuration-areaofpathways-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-mensuration-areaofpathways-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-mensuration-areaofpathways-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-mensuration-areaofpathways-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-mensuration-areaofpathways-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-mensuration-areaofpathways-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-mensuration-areaofpathways-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-mensuration-areaofpathways-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-mensuration-areaofpathways-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-mensuration-areaofpathways-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-mensuration-areaofpathways-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-mensuration-areaofpathways-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-mensuration-areaofpathways-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-mensuration-areaofpathways-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-mensuration-areaofpathways-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-mensuration-areaofpathways-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - CP - Start"},"postlogin-class7-tests-mensuration-areaofpathways-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - CP - Start - Start Practice"},"postlogin-class7-tests-mensuration-areaofpathways-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - CP - Start - Close"},"postlogin-class7-tests-mensuration-areaofpathways-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - CP - Start - Start Practice - Close"},"postlogin-class7-tests-mensuration-areaofpathways-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - CP - Start - Start Practice - Check"},"postlogin-class7-tests-mensuration-areaofpathways-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - CP - Resume"},"postlogin-class7-tests-mensuration-areaofpathways-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - CP - Resume - Continue"},"postlogin-class7-tests-mensuration-areaofpathways-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - CP - Resume - Close"},"postlogin-class7-tests-mensuration-areaofpathways-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - CP - Resume - Continue - Close"},"postlogin-class7-tests-mensuration-areaofpathways-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - CP - Resume - Continue - Check"},"postlogin-class7-tests-mensuration-areaofpathways-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Mensuration - Area of Pathways - CP - Report"},"postlogin-class8-tests-directandinverseproportions-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Start"},"postlogin-class8-tests-directandinverseproportions-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Resume"},"postlogin-class8-tests-directandinverseproportions-revise":{"event_label":"Revise topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Revise"},"postlogin-class8-tests-directandinverseproportions-directproportion-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - PT - Start"},"postlogin-class8-tests-directandinverseproportions-directproportion-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - PT - Resume"},"postlogin-class8-tests-directandinverseproportions-directproportion-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - PT - Report"},"postlogin-class8-tests-directandinverseproportions-directproportion-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - PT - Start - Start Test"},"postlogin-class8-tests-directandinverseproportions-directproportion-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - PT - Close"},"postlogin-class8-tests-directandinverseproportions-directproportion-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - PT - Resume - Continue Test"},"postlogin-class8-tests-directandinverseproportions-directproportion-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - PT - Test - Close"},"postlogin-class8-tests-directandinverseproportions-directproportion-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - PT - Test - Submit Test"},"postlogin-class8-tests-directandinverseproportions-directproportion-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - PT - Scorecard - View Solutions"},"postlogin-class8-tests-directandinverseproportions-directproportion-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-directandinverseproportions-directproportion-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-directandinverseproportions-directproportion-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-directandinverseproportions-directproportion-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-directandinverseproportions-directproportion-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-directandinverseproportions-directproportion-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-directandinverseproportions-directproportion-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-directandinverseproportions-directproportion-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-directandinverseproportions-directproportion-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-directandinverseproportions-directproportion-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-directandinverseproportions-directproportion-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-directandinverseproportions-directproportion-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-directandinverseproportions-directproportion-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-directandinverseproportions-directproportion-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-directandinverseproportions-directproportion-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-directandinverseproportions-directproportion-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - CP - Start"},"postlogin-class8-tests-directandinverseproportions-directproportion-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - CP - Start - Start Practice"},"postlogin-class8-tests-directandinverseproportions-directproportion-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - CP - Start - Close"},"postlogin-class8-tests-directandinverseproportions-directproportion-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - CP - Start - Start Practice - Close"},"postlogin-class8-tests-directandinverseproportions-directproportion-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - CP - Start - Start Practice - Check"},"postlogin-class8-tests-directandinverseproportions-directproportion-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - CP - Resume"},"postlogin-class8-tests-directandinverseproportions-directproportion-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - CP - Resume - Continue"},"postlogin-class8-tests-directandinverseproportions-directproportion-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - CP - Resume - Close"},"postlogin-class8-tests-directandinverseproportions-directproportion-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - CP - Resume - Continue - Close"},"postlogin-class8-tests-directandinverseproportions-directproportion-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - CP - Resume - Continue - Check"},"postlogin-class8-tests-directandinverseproportions-directproportion-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Direct Proportion - CP - Report"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - PT - Start"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - PT - Resume"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - PT - Report"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - PT - Start - Start Test"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - PT - Close"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - PT - Resume - Continue Test"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - PT - Test - Close"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - PT - Test - Submit Test"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - PT - Scorecard - View Solutions"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - CP - Start"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - CP - Start - Start Practice"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - CP - Start - Close"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - CP - Start - Start Practice - Close"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - CP - Start - Start Practice - Check"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - CP - Resume"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - CP - Resume - Continue"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - CP - Resume - Close"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - CP - Resume - Continue - Close"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - CP - Resume - Continue - Check"},"postlogin-class8-tests-directandinverseproportions-inverseproportion-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Direct and Inverse Proportions - Inverse Proportion - CP - Report"},"postlogin-class5-lessons-mappingskills1-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Mapping Skills 1 - Start"},"postlogin-class5-lessons-mappingskills1-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Mapping Skills 1 - Resume"},"postlogin-class5-lessons-mappingskills1-watched":{"event_label":"Rewatch topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Mapping Skills 1 - Watched"},"postlogin-class5-lessons-mappingskills1-directions-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Mapping Skills 1 - Directions - Start"},"postlogin-class5-lessons-mappingskills1-directions-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Mapping Skills 1 - Directions - Resume"},"postlogin-class5-lessons-mappingskills1-directions-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Mapping Skills 1 - Directions - Watched"},"postlogin-class5-lessons-mappingskills1-directions-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Mapping Skills 1 - Directions - Lessons"},"postlogin-class5-lessons-mappingskills1-directions-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Mapping Skills 1 - Directions - Close"},"postlogin-class6-lessons-ratioandproportion-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Ratio and Proportion - Start"},"postlogin-class6-lessons-ratioandproportion-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Ratio and Proportion - Resume"},"postlogin-class6-lessons-ratioandproportion-watched":{"event_label":"Rewatch topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Ratio and Proportion - Watched"},"postlogin-class6-lessons-ratioandproportion-ratio-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Ratio and Proportion - Ratio - Start"},"postlogin-class6-lessons-ratioandproportion-ratio-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Ratio and Proportion - Ratio - Resume"},"postlogin-class6-lessons-ratioandproportion-ratio-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Ratio and Proportion - Ratio - Watched"},"postlogin-class6-lessons-ratioandproportion-ratio-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Ratio and Proportion - Ratio - Lessons"},"postlogin-class6-lessons-ratioandproportion-ratio-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Ratio and Proportion - Ratio - Close"},"postlogin-class6-lessons-ratioandproportion-proportion-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Ratio and Proportion - Proportion - Start"},"postlogin-class6-lessons-ratioandproportion-proportion-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Ratio and Proportion - Proportion - Resume"},"postlogin-class6-lessons-ratioandproportion-proportion-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Ratio and Proportion - Proportion - Watched"},"postlogin-class6-lessons-ratioandproportion-proportion-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Ratio and Proportion - Proportion - Lessons"},"postlogin-class6-lessons-ratioandproportion-proportion-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Ratio and Proportion - Proportion - Close"},"postlogin-class6-lessons-ratioandproportion-unitarymethod-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Ratio and Proportion - Unitary Method - Start"},"postlogin-class6-lessons-ratioandproportion-unitarymethod-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Ratio and Proportion - Unitary Method - Resume"},"postlogin-class6-lessons-ratioandproportion-unitarymethod-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Ratio and Proportion - Unitary Method - Watched"},"postlogin-class6-lessons-ratioandproportion-unitarymethod-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Ratio and Proportion - Unitary Method - Lessons"},"postlogin-class6-lessons-ratioandproportion-unitarymethod-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Ratio and Proportion - Unitary Method - Close"},"postlogin-class7-lessons-mensuration-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Mensuration - Start"},"postlogin-class7-lessons-mensuration-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Mensuration - Resume"},"postlogin-class7-lessons-mensuration-watched":{"event_label":"Rewatch topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Mensuration - Watched"},"postlogin-class7-lessons-mensuration-areaoftriangle-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Mensuration - Area of Triangle - Start"},"postlogin-class7-lessons-mensuration-areaoftriangle-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Mensuration - Area of Triangle - Resume"},"postlogin-class7-lessons-mensuration-areaoftriangle-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Mensuration - Area of Triangle - Watched"},"postlogin-class7-lessons-mensuration-areaoftriangle-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Mensuration - Area of Triangle - Lessons"},"postlogin-class7-lessons-mensuration-areaoftriangle-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Mensuration - Area of Triangle - Close"},"postlogin-class7-lessons-mensuration-areaofparallelogram-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Mensuration - Area of Parallelogram - Start"},"postlogin-class7-lessons-mensuration-areaofparallelogram-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Mensuration - Area of Parallelogram - Resume"},"postlogin-class7-lessons-mensuration-areaofparallelogram-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Mensuration - Area of Parallelogram - Watched"},"postlogin-class7-lessons-mensuration-areaofparallelogram-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Mensuration - Area of Parallelogram - Lessons"},"postlogin-class7-lessons-mensuration-areaofparallelogram-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Mensuration - Area of Parallelogram - Close"},"postlogin-class7-lessons-mensuration-areaofpathways-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Mensuration - Area of Pathways - Start"},"postlogin-class7-lessons-mensuration-areaofpathways-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Mensuration - Area of Pathways - Resume"},"postlogin-class7-lessons-mensuration-areaofpathways-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Mensuration - Area of Pathways - Watched"},"postlogin-class7-lessons-mensuration-areaofpathways-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Mensuration - Area of Pathways - Lessons"},"postlogin-class7-lessons-mensuration-areaofpathways-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Mensuration - Area of Pathways - Close"},"postlogin-class7-lessons-mensuration-conversionofmetricunits-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Mensuration - Conversion of Metric Units - Start"},"postlogin-class7-lessons-mensuration-conversionofmetricunits-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Mensuration - Conversion of Metric Units - Resume"},"postlogin-class7-lessons-mensuration-conversionofmetricunits-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Mensuration - Conversion of Metric Units - Watched"},"postlogin-class7-lessons-mensuration-conversionofmetricunits-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Mensuration - Conversion of Metric Units - Lessons"},"postlogin-class7-lessons-mensuration-conversionofmetricunits-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Mensuration - Conversion of Metric Units - Close"},"postlogin-class7-lessons-mensuration-circumferenceandareaofacircle-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Mensuration - Circumference and Area of a Circle - Start"},"postlogin-class7-lessons-mensuration-circumferenceandareaofacircle-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Mensuration - Circumference and Area of a Circle - Resume"},"postlogin-class7-lessons-mensuration-circumferenceandareaofacircle-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Mensuration - Circumference and Area of a Circle - Watched"},"postlogin-class7-lessons-mensuration-circumferenceandareaofacircle-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Mensuration - Circumference and Area of a Circle - Lessons"},"postlogin-class7-lessons-mensuration-circumferenceandareaofacircle-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Mensuration - Circumference and Area of a Circle - Close"},"postlogin-class8-lessons-directandinverseproportions-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Direct and Inverse Proportions - Start"},"postlogin-class8-lessons-directandinverseproportions-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Direct and Inverse Proportions - Resume"},"postlogin-class8-lessons-directandinverseproportions-watched":{"event_label":"Rewatch topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Direct and Inverse Proportions - Watched"},"postlogin-class8-lessons-directandinverseproportions-directproportion-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Direct and Inverse Proportions - Direct Proportion - Start"},"postlogin-class8-lessons-directandinverseproportions-directproportion-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Direct and Inverse Proportions - Direct Proportion - Resume"},"postlogin-class8-lessons-directandinverseproportions-directproportion-watched":{"event_label":"Rewatch subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Direct and Inverse Proportions - Direct Proportion - Watched"},"postlogin-class8-lessons-directandinverseproportions-directproportion-lessons":{"event_label":"Class 8 lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Direct and Inverse Proportions - Direct Proportion - Lessons"},"postlogin-class8-lessons-directandinverseproportions-directproportion-close":{"event_label":"Close subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Direct and Inverse Proportions - Direct Proportion - Close"},"postlogin-class8-lessons-directandinverseproportions-inverseproportion-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Direct and Inverse Proportions - Inverse Proportion - Start"},"postlogin-class8-lessons-directandinverseproportions-inverseproportion-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Direct and Inverse Proportions - Inverse Proportion - Resume"},"postlogin-class8-lessons-directandinverseproportions-inverseproportion-watched":{"event_label":"Rewatch subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Direct and Inverse Proportions - Inverse Proportion - Watched"},"postlogin-class8-lessons-directandinverseproportions-inverseproportion-lessons":{"event_label":"Class 8 lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Direct and Inverse Proportions - Inverse Proportion - Lessons"},"postlogin-class8-lessons-directandinverseproportions-inverseproportion-close":{"event_label":"Close subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Direct and Inverse Proportions - Inverse Proportion - Close"},"postlogin-class5-tests-datahandling-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Start"},"postlogin-class5-tests-datahandling-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Resume"},"postlogin-class5-tests-datahandling-revise":{"event_label":"Revise topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Revise"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - PT - Start"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - PT - Resume"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - PT - Report"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - PT - Start - Start Test"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - PT - Close"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - PT - Resume - Continue Test"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - PT - Test - Close"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - PT - Test - Submit Test"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - PT - Scorecard - View Solutions"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - CP - Start"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - CP - Start - Start Practice"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - CP - Start - Close"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - CP - Start - Start Practice - Close"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - CP - Start - Start Practice - Check"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - CP - Resume"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - CP - Resume - Continue"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - CP - Resume - Close"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - CP - Resume - Continue - Close"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - CP - Resume - Continue - Check"},"postlogin-class5-tests-datahandling-drawingandinterpretationofgraphs-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Data Handling - Drawing and Interpretation of Graphs - CP - Report"},"postlogin-class6-tests-ratioandproportion-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Start"},"postlogin-class6-tests-ratioandproportion-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Resume"},"postlogin-class6-tests-ratioandproportion-revise":{"event_label":"Revise topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Revise"},"postlogin-class6-tests-ratioandproportion-ratio-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - PT - Start"},"postlogin-class6-tests-ratioandproportion-ratio-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - PT - Resume"},"postlogin-class6-tests-ratioandproportion-ratio-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - PT - Report"},"postlogin-class6-tests-ratioandproportion-ratio-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - PT - Start - Start Test"},"postlogin-class6-tests-ratioandproportion-ratio-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - PT - Close"},"postlogin-class6-tests-ratioandproportion-ratio-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - PT - Resume - Continue Test"},"postlogin-class6-tests-ratioandproportion-ratio-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - PT - Test - Close"},"postlogin-class6-tests-ratioandproportion-ratio-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - PT - Test - Submit Test"},"postlogin-class6-tests-ratioandproportion-ratio-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - PT - Scorecard - View Solutions"},"postlogin-class6-tests-ratioandproportion-ratio-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-ratioandproportion-ratio-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-ratioandproportion-ratio-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-ratioandproportion-ratio-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-ratioandproportion-ratio-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-ratioandproportion-ratio-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-ratioandproportion-ratio-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-ratioandproportion-ratio-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-ratioandproportion-ratio-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-ratioandproportion-ratio-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-ratioandproportion-ratio-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-ratioandproportion-ratio-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-ratioandproportion-ratio-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-ratioandproportion-ratio-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-ratioandproportion-ratio-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-ratioandproportion-ratio-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - CP - Start"},"postlogin-class6-tests-ratioandproportion-ratio-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - CP - Start - Start Practice"},"postlogin-class6-tests-ratioandproportion-ratio-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - CP - Start - Close"},"postlogin-class6-tests-ratioandproportion-ratio-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - CP - Start - Start Practice - Close"},"postlogin-class6-tests-ratioandproportion-ratio-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - CP - Start - Start Practice - Check"},"postlogin-class6-tests-ratioandproportion-ratio-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - CP - Resume"},"postlogin-class6-tests-ratioandproportion-ratio-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - CP - Resume - Continue"},"postlogin-class6-tests-ratioandproportion-ratio-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - CP - Resume - Close"},"postlogin-class6-tests-ratioandproportion-ratio-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - CP - Resume - Continue - Close"},"postlogin-class6-tests-ratioandproportion-ratio-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - CP - Resume - Continue - Check"},"postlogin-class6-tests-ratioandproportion-ratio-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Ratio - CP - Report"},"postlogin-class6-tests-ratioandproportion-proportion-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - PT - Start"},"postlogin-class6-tests-ratioandproportion-proportion-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - PT - Resume"},"postlogin-class6-tests-ratioandproportion-proportion-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - PT - Report"},"postlogin-class6-tests-ratioandproportion-proportion-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - PT - Start - Start Test"},"postlogin-class6-tests-ratioandproportion-proportion-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - PT - Close"},"postlogin-class6-tests-ratioandproportion-proportion-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - PT - Resume - Continue Test"},"postlogin-class6-tests-ratioandproportion-proportion-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - PT - Test - Close"},"postlogin-class6-tests-ratioandproportion-proportion-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - PT - Test - Submit Test"},"postlogin-class6-tests-ratioandproportion-proportion-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - PT - Scorecard - View Solutions"},"postlogin-class6-tests-ratioandproportion-proportion-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-ratioandproportion-proportion-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-ratioandproportion-proportion-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-ratioandproportion-proportion-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-ratioandproportion-proportion-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-ratioandproportion-proportion-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-ratioandproportion-proportion-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-ratioandproportion-proportion-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-ratioandproportion-proportion-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-ratioandproportion-proportion-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-ratioandproportion-proportion-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-ratioandproportion-proportion-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-ratioandproportion-proportion-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-ratioandproportion-proportion-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-ratioandproportion-proportion-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-ratioandproportion-proportion-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - CP - Start"},"postlogin-class6-tests-ratioandproportion-proportion-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - CP - Start - Start Practice"},"postlogin-class6-tests-ratioandproportion-proportion-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - CP - Start - Close"},"postlogin-class6-tests-ratioandproportion-proportion-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - CP - Start - Start Practice - Close"},"postlogin-class6-tests-ratioandproportion-proportion-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - CP - Start - Start Practice - Check"},"postlogin-class6-tests-ratioandproportion-proportion-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - CP - Resume"},"postlogin-class6-tests-ratioandproportion-proportion-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - CP - Resume - Continue"},"postlogin-class6-tests-ratioandproportion-proportion-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - CP - Resume - Close"},"postlogin-class6-tests-ratioandproportion-proportion-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - CP - Resume - Continue - Close"},"postlogin-class6-tests-ratioandproportion-proportion-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - CP - Resume - Continue - Check"},"postlogin-class6-tests-ratioandproportion-proportion-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Proportion - CP - Report"},"postlogin-class6-tests-ratioandproportion-unitarymethod-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - PT - Start"},"postlogin-class6-tests-ratioandproportion-unitarymethod-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - PT - Resume"},"postlogin-class6-tests-ratioandproportion-unitarymethod-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - PT - Report"},"postlogin-class6-tests-ratioandproportion-unitarymethod-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - PT - Start - Start Test"},"postlogin-class6-tests-ratioandproportion-unitarymethod-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - PT - Close"},"postlogin-class6-tests-ratioandproportion-unitarymethod-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - PT - Resume - Continue Test"},"postlogin-class6-tests-ratioandproportion-unitarymethod-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - PT - Test - Close"},"postlogin-class6-tests-ratioandproportion-unitarymethod-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - PT - Test - Submit Test"},"postlogin-class6-tests-ratioandproportion-unitarymethod-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - PT - Scorecard - View Solutions"},"postlogin-class6-tests-ratioandproportion-unitarymethod-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-ratioandproportion-unitarymethod-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-ratioandproportion-unitarymethod-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-ratioandproportion-unitarymethod-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-ratioandproportion-unitarymethod-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-ratioandproportion-unitarymethod-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-ratioandproportion-unitarymethod-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-ratioandproportion-unitarymethod-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-ratioandproportion-unitarymethod-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-ratioandproportion-unitarymethod-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-ratioandproportion-unitarymethod-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-ratioandproportion-unitarymethod-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-ratioandproportion-unitarymethod-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-ratioandproportion-unitarymethod-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-ratioandproportion-unitarymethod-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-ratioandproportion-unitarymethod-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - CP - Start"},"postlogin-class6-tests-ratioandproportion-unitarymethod-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - CP - Start - Start Practice"},"postlogin-class6-tests-ratioandproportion-unitarymethod-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - CP - Start - Close"},"postlogin-class6-tests-ratioandproportion-unitarymethod-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - CP - Start - Start Practice - Close"},"postlogin-class6-tests-ratioandproportion-unitarymethod-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - CP - Start - Start Practice - Check"},"postlogin-class6-tests-ratioandproportion-unitarymethod-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - CP - Resume"},"postlogin-class6-tests-ratioandproportion-unitarymethod-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - CP - Resume - Continue"},"postlogin-class6-tests-ratioandproportion-unitarymethod-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - CP - Resume - Close"},"postlogin-class6-tests-ratioandproportion-unitarymethod-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - CP - Resume - Continue - Close"},"postlogin-class6-tests-ratioandproportion-unitarymethod-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - CP - Resume - Continue - Check"},"postlogin-class6-tests-ratioandproportion-unitarymethod-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Ratio and Proportion - Unitary Method - CP - Report"},"postlogin-class7-tests-algebra-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Start"},"postlogin-class7-tests-algebra-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Resume"},"postlogin-class7-tests-algebra-revise":{"event_label":"Revise topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Revise"},"postlogin-class7-tests-algebra-algebraicexpressions-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - PT - Start"},"postlogin-class7-tests-algebra-algebraicexpressions-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - PT - Resume"},"postlogin-class7-tests-algebra-algebraicexpressions-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - PT - Report"},"postlogin-class7-tests-algebra-algebraicexpressions-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - PT - Start - Start Test"},"postlogin-class7-tests-algebra-algebraicexpressions-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - PT - Close"},"postlogin-class7-tests-algebra-algebraicexpressions-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - PT - Resume - Continue Test"},"postlogin-class7-tests-algebra-algebraicexpressions-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - PT - Test - Close"},"postlogin-class7-tests-algebra-algebraicexpressions-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - PT - Test - Submit Test"},"postlogin-class7-tests-algebra-algebraicexpressions-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Solutions"},"postlogin-class7-tests-algebra-algebraicexpressions-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-algebra-algebraicexpressions-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-algebra-algebraicexpressions-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - CP - Start"},"postlogin-class7-tests-algebra-algebraicexpressions-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - CP - Start - Start Practice"},"postlogin-class7-tests-algebra-algebraicexpressions-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - CP - Start - Close"},"postlogin-class7-tests-algebra-algebraicexpressions-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - CP - Start - Start Practice - Close"},"postlogin-class7-tests-algebra-algebraicexpressions-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - CP - Start - Start Practice - Check"},"postlogin-class7-tests-algebra-algebraicexpressions-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - CP - Resume"},"postlogin-class7-tests-algebra-algebraicexpressions-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - CP - Resume - Continue"},"postlogin-class7-tests-algebra-algebraicexpressions-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - CP - Resume - Close"},"postlogin-class7-tests-algebra-algebraicexpressions-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - CP - Resume - Continue - Close"},"postlogin-class7-tests-algebra-algebraicexpressions-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - CP - Resume - Continue - Check"},"postlogin-class7-tests-algebra-algebraicexpressions-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Algebraic Expressions - CP - Report"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - PT - Start"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - PT - Resume"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - PT - Report"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - PT - Start - Start Test"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - PT - Close"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - PT - Resume - Continue Test"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - PT - Test - Close"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - PT - Test - Submit Test"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - PT - Scorecard - View Solutions"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - CP - Start"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - CP - Start - Start Practice"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - CP - Start - Close"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - CP - Start - Start Practice - Close"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - CP - Start - Start Practice - Check"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - CP - Resume"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - CP - Resume - Continue"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - CP - Resume - Close"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - CP - Resume - Continue - Close"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - CP - Resume - Continue - Check"},"postlogin-class7-tests-algebra-addandsubtractalgebraicexpressions-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Add and Subtract Algebraic Expressions - CP - Report"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - PT - Start"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - PT - Resume"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - PT - Report"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - PT - Start - Start Test"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - PT - Close"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - PT - Resume - Continue Test"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - PT - Test - Close"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - PT - Test - Submit Test"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - PT - Scorecard - View Solutions"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - CP - Start"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - CP - Start - Start Practice"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - CP - Start - Close"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - CP - Start - Start Practice - Close"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - CP - Start - Start Practice - Check"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - CP - Resume"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - CP - Resume - Continue"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - CP - Resume - Close"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - CP - Resume - Continue - Close"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - CP - Resume - Continue - Check"},"postlogin-class7-tests-algebra-evaluatingalgebraicexpressions-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Algebra - Evaluating Algebraic Expressions - CP - Report"},"postlogin-class8-tests-factorisation-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Start"},"postlogin-class8-tests-factorisation-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Resume"},"postlogin-class8-tests-factorisation-revise":{"event_label":"Revise topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Revise"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - PT - Start"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - PT - Resume"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - PT - Report"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - PT - Start - Start Test"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - PT - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - PT - Resume - Continue Test"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - PT - Test - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - PT - Test - Submit Test"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - PT - Scorecard - View Solutions"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - CP - Start"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - CP - Start - Start Practice"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - CP - Start - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - CP - Start - Start Practice - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - CP - Start - Start Practice - Check"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - CP - Resume"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - CP - Resume - Continue"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - CP - Resume - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - CP - Resume - Continue - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - CP - Resume - Continue - Check"},"postlogin-class8-tests-factorisation-factorisingpolynomialsi-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials I - CP - Report"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - PT - Start"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - PT - Resume"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - PT - Report"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - PT - Start - Start Test"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - PT - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - PT - Resume - Continue Test"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - PT - Test - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - PT - Test - Submit Test"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - PT - Scorecard - View Solutions"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - CP - Start"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - CP - Start - Start Practice"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - CP - Start - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - CP - Start - Start Practice - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - CP - Start - Start Practice - Check"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - CP - Resume"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - CP - Resume - Continue"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - CP - Resume - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - CP - Resume - Continue - Close"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - CP - Resume - Continue - Check"},"postlogin-class8-tests-factorisation-factorisingpolynomialsii-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Factorising Polynomials II - CP - Report"},"postlogin-class8-tests-factorisation-divisionofpolynomials-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - PT - Start"},"postlogin-class8-tests-factorisation-divisionofpolynomials-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - PT - Resume"},"postlogin-class8-tests-factorisation-divisionofpolynomials-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - PT - Report"},"postlogin-class8-tests-factorisation-divisionofpolynomials-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - PT - Start - Start Test"},"postlogin-class8-tests-factorisation-divisionofpolynomials-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - PT - Close"},"postlogin-class8-tests-factorisation-divisionofpolynomials-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - PT - Resume - Continue Test"},"postlogin-class8-tests-factorisation-divisionofpolynomials-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - PT - Test - Close"},"postlogin-class8-tests-factorisation-divisionofpolynomials-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - PT - Test - Submit Test"},"postlogin-class8-tests-factorisation-divisionofpolynomials-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - PT - Scorecard - View Solutions"},"postlogin-class8-tests-factorisation-divisionofpolynomials-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-factorisation-divisionofpolynomials-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-factorisation-divisionofpolynomials-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-factorisation-divisionofpolynomials-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-factorisation-divisionofpolynomials-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-factorisation-divisionofpolynomials-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-factorisation-divisionofpolynomials-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-factorisation-divisionofpolynomials-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-factorisation-divisionofpolynomials-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-factorisation-divisionofpolynomials-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-factorisation-divisionofpolynomials-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-factorisation-divisionofpolynomials-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-factorisation-divisionofpolynomials-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-factorisation-divisionofpolynomials-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-factorisation-divisionofpolynomials-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-factorisation-divisionofpolynomials-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - CP - Start"},"postlogin-class8-tests-factorisation-divisionofpolynomials-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - CP - Start - Start Practice"},"postlogin-class8-tests-factorisation-divisionofpolynomials-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - CP - Start - Close"},"postlogin-class8-tests-factorisation-divisionofpolynomials-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - CP - Start - Start Practice - Close"},"postlogin-class8-tests-factorisation-divisionofpolynomials-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - CP - Start - Start Practice - Check"},"postlogin-class8-tests-factorisation-divisionofpolynomials-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - CP - Resume"},"postlogin-class8-tests-factorisation-divisionofpolynomials-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - CP - Resume - Continue"},"postlogin-class8-tests-factorisation-divisionofpolynomials-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - CP - Resume - Close"},"postlogin-class8-tests-factorisation-divisionofpolynomials-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - CP - Resume - Continue - Close"},"postlogin-class8-tests-factorisation-divisionofpolynomials-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - CP - Resume - Continue - Check"},"postlogin-class8-tests-factorisation-divisionofpolynomials-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Factorisation - Division of Polynomials - CP - Report"},"postlogin-class5-lessons-datahandling-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Data Handling - Start"},"postlogin-class5-lessons-datahandling-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Data Handling - Resume"},"postlogin-class5-lessons-datahandling-watched":{"event_label":"Rewatch topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Data Handling - Watched"},"postlogin-class5-lessons-datahandling-drawingandinterpretationofgraphs-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Data Handling - Drawing and Interpretation of Graphs - Start"},"postlogin-class5-lessons-datahandling-drawingandinterpretationofgraphs-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Data Handling - Drawing and Interpretation of Graphs - Resume"},"postlogin-class5-lessons-datahandling-drawingandinterpretationofgraphs-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Data Handling - Drawing and Interpretation of Graphs - Watched"},"postlogin-class5-lessons-datahandling-drawingandinterpretationofgraphs-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Data Handling - Drawing and Interpretation of Graphs - Lessons"},"postlogin-class5-lessons-datahandling-drawingandinterpretationofgraphs-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Data Handling - Drawing and Interpretation of Graphs - Close"},"postlogin-class6-lessons-symmetry-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Symmetry - Start"},"postlogin-class6-lessons-symmetry-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Symmetry - Resume"},"postlogin-class6-lessons-symmetry-watched":{"event_label":"Rewatch topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Symmetry - Watched"},"postlogin-class6-lessons-symmetry-linesofsymmetry-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Symmetry - Lines of Symmetry - Start"},"postlogin-class6-lessons-symmetry-linesofsymmetry-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Symmetry - Lines of Symmetry - Resume"},"postlogin-class6-lessons-symmetry-linesofsymmetry-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Symmetry - Lines of Symmetry - Watched"},"postlogin-class6-lessons-symmetry-linesofsymmetry-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Symmetry - Lines of Symmetry - Lessons"},"postlogin-class6-lessons-symmetry-linesofsymmetry-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Symmetry - Lines of Symmetry - Close"},"postlogin-class7-lessons-algebra-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Algebra - Start"},"postlogin-class7-lessons-algebra-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Algebra - Resume"},"postlogin-class7-lessons-algebra-watched":{"event_label":"Rewatch topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Algebra - Watched"},"postlogin-class7-lessons-algebra-algebraicexpressions-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Algebra - Algebraic Expressions - Start"},"postlogin-class7-lessons-algebra-algebraicexpressions-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Algebra - Algebraic Expressions - Resume"},"postlogin-class7-lessons-algebra-algebraicexpressions-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Algebra - Algebraic Expressions - Watched"},"postlogin-class7-lessons-algebra-algebraicexpressions-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Algebra - Algebraic Expressions - Lessons"},"postlogin-class7-lessons-algebra-algebraicexpressions-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Algebra - Algebraic Expressions - Close"},"postlogin-class7-lessons-algebra-addandsubtractalgebraicexpressions-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Algebra - Add and Subtract Algebraic Expressions - Start"},"postlogin-class7-lessons-algebra-addandsubtractalgebraicexpressions-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Algebra - Add and Subtract Algebraic Expressions - Resume"},"postlogin-class7-lessons-algebra-addandsubtractalgebraicexpressions-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Algebra - Add and Subtract Algebraic Expressions - Watched"},"postlogin-class7-lessons-algebra-addandsubtractalgebraicexpressions-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Algebra - Add and Subtract Algebraic Expressions - Lessons"},"postlogin-class7-lessons-algebra-addandsubtractalgebraicexpressions-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Algebra - Add and Subtract Algebraic Expressions - Close"},"postlogin-class7-lessons-algebra-evaluatingalgebraicexpressions-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Algebra - Evaluating Algebraic Expressions - Start"},"postlogin-class7-lessons-algebra-evaluatingalgebraicexpressions-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Algebra - Evaluating Algebraic Expressions - Resume"},"postlogin-class7-lessons-algebra-evaluatingalgebraicexpressions-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Algebra - Evaluating Algebraic Expressions - Watched"},"postlogin-class7-lessons-algebra-evaluatingalgebraicexpressions-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Algebra - Evaluating Algebraic Expressions - Lessons"},"postlogin-class7-lessons-algebra-evaluatingalgebraicexpressions-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Algebra - Evaluating Algebraic Expressions - Close"},"postlogin-class7-lessons-algebra-numberpatterns-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Algebra - Number Patterns - Start"},"postlogin-class7-lessons-algebra-numberpatterns-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Algebra - Number Patterns - Resume"},"postlogin-class7-lessons-algebra-numberpatterns-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Algebra - Number Patterns - Watched"},"postlogin-class7-lessons-algebra-numberpatterns-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Algebra - Number Patterns - Lessons"},"postlogin-class7-lessons-algebra-numberpatterns-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Algebra - Number Patterns - Close"},"postlogin-class8-lessons-factorisation-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Factorisation - Start"},"postlogin-class8-lessons-factorisation-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Factorisation - Resume"},"postlogin-class8-lessons-factorisation-watched":{"event_label":"Rewatch topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Factorisation - Watched"},"postlogin-class8-lessons-factorisation-divisionofpolynomials-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Factorisation - Division of Polynomials - Start"},"postlogin-class8-lessons-factorisation-divisionofpolynomials-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Factorisation - Division of Polynomials - Resume"},"postlogin-class8-lessons-factorisation-divisionofpolynomials-watched":{"event_label":"Rewatch subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Factorisation - Division of Polynomials - Watched"},"postlogin-class8-lessons-factorisation-divisionofpolynomials-lessons":{"event_label":"Class 8 lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Factorisation - Division of Polynomials - Lessons"},"postlogin-class8-lessons-factorisation-divisionofpolynomials-close":{"event_label":"Close subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Factorisation - Division of Polynomials - Close"},"postlogin-class8-lessons-factorisation-factorisingpolynomials-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Factorisation - Factorising Polynomials - Start"},"postlogin-class8-lessons-factorisation-factorisingpolynomials-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Factorisation - Factorising Polynomials - Resume"},"postlogin-class8-lessons-factorisation-factorisingpolynomials-watched":{"event_label":"Rewatch subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Factorisation - Factorising Polynomials - Watched"},"postlogin-class8-lessons-factorisation-factorisingpolynomials-lessons":{"event_label":"Class 8 lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Factorisation - Factorising Polynomials - Lessons"},"postlogin-class8-lessons-factorisation-factorisingpolynomials-close":{"event_label":"Close subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Factorisation - Factorising Polynomials - Close"},"postlogin-class5-tests-symmetry,patternsandnets-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Start"},"postlogin-class5-tests-symmetry,patternsandnets-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Resume"},"postlogin-class5-tests-symmetry,patternsandnets-revise":{"event_label":"Revise topic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Revise"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-pt-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - PT - Start"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - PT - Resume"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-pt-report":{"event_label":"View report PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - PT - Report"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - PT - Start - Start Test"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - PT - Close"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - PT - Resume - Continue Test"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-pt-test-close":{"event_label":"Close PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - PT - Test - Close"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - PT - Test - Submit Test"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - PT - Scorecard - View Solutions"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - PT - Scorecard - View Solutions - Close"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - PT - Scorecard - View Recommendations"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - PT - Scorecard - View Recommendations - Close"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-cp-start":{"event_label":"Start Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - CP - Start"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - CP - Start - Start Practice"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - CP - Start - Close"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - CP - Start - Start Practice - Close"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - CP - Start - Start Practice - Check"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-cp-resume":{"event_label":"Continue Practice","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - CP - Resume"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - CP - Resume - Continue"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - CP - Resume - Close"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - CP - Resume - Continue - Close"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - CP - Resume - Continue - Check"},"postlogin-class5-tests-symmetry,patternsandnets-problemsonsymmetry,patternsandnets-cp-report":{"event_label":"View report CP","event_category":"Class 5","event_action":"Post login - Class 5 - Tests - Symmetry, Patterns and Nets - Problems on Symmetry, Patterns and Nets - CP - Report"},"postlogin-class6-tests-symmetry-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Start"},"postlogin-class6-tests-symmetry-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Resume"},"postlogin-class6-tests-symmetry-revise":{"event_label":"Revise topic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Revise"},"postlogin-class6-tests-symmetry-linesofsymmetry-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - PT - Start"},"postlogin-class6-tests-symmetry-linesofsymmetry-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - PT - Resume"},"postlogin-class6-tests-symmetry-linesofsymmetry-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - PT - Report"},"postlogin-class6-tests-symmetry-linesofsymmetry-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - PT - Start - Start Test"},"postlogin-class6-tests-symmetry-linesofsymmetry-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - PT - Close"},"postlogin-class6-tests-symmetry-linesofsymmetry-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - PT - Resume - Continue Test"},"postlogin-class6-tests-symmetry-linesofsymmetry-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - PT - Test - Close"},"postlogin-class6-tests-symmetry-linesofsymmetry-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - PT - Test - Submit Test"},"postlogin-class6-tests-symmetry-linesofsymmetry-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - PT - Scorecard - View Solutions"},"postlogin-class6-tests-symmetry-linesofsymmetry-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-symmetry-linesofsymmetry-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-symmetry-linesofsymmetry-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-symmetry-linesofsymmetry-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-symmetry-linesofsymmetry-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-symmetry-linesofsymmetry-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-symmetry-linesofsymmetry-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-symmetry-linesofsymmetry-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-symmetry-linesofsymmetry-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-symmetry-linesofsymmetry-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-symmetry-linesofsymmetry-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-symmetry-linesofsymmetry-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-symmetry-linesofsymmetry-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-symmetry-linesofsymmetry-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-symmetry-linesofsymmetry-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-symmetry-linesofsymmetry-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - CP - Start"},"postlogin-class6-tests-symmetry-linesofsymmetry-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - CP - Start - Start Practice"},"postlogin-class6-tests-symmetry-linesofsymmetry-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - CP - Start - Close"},"postlogin-class6-tests-symmetry-linesofsymmetry-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - CP - Start - Start Practice - Close"},"postlogin-class6-tests-symmetry-linesofsymmetry-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - CP - Start - Start Practice - Check"},"postlogin-class6-tests-symmetry-linesofsymmetry-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - CP - Resume"},"postlogin-class6-tests-symmetry-linesofsymmetry-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - CP - Resume - Continue"},"postlogin-class6-tests-symmetry-linesofsymmetry-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - CP - Resume - Close"},"postlogin-class6-tests-symmetry-linesofsymmetry-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - CP - Resume - Continue - Close"},"postlogin-class6-tests-symmetry-linesofsymmetry-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - CP - Resume - Continue - Check"},"postlogin-class6-tests-symmetry-linesofsymmetry-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - Lines of Symmetry - CP - Report"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-pt-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - PT - Start"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - PT - Resume"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-pt-report":{"event_label":"View report PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - PT - Report"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - PT - Start - Start Test"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - PT - Close"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - PT - Resume - Continue Test"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-pt-test-close":{"event_label":"Close PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - PT - Test - Close"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - PT - Test - Submit Test"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - PT - Scorecard - View Solutions"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - PT - Scorecard - View Solutions - Close"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - PT - Scorecard - View Recommendations"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - PT - Scorecard - View Recommendations - Close"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-cp-start":{"event_label":"Start Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - CP - Start"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - CP - Start - Start Practice"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - CP - Start - Close"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - CP - Start - Start Practice - Close"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - CP - Start - Start Practice - Check"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-cp-resume":{"event_label":"Continue Practice","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - CP - Resume"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - CP - Resume - Continue"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - CP - Resume - Close"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - CP - Resume - Continue - Close"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - CP - Resume - Continue - Check"},"postlogin-class6-tests-symmetry-moreonlinesofsymmetry-cp-report":{"event_label":"View report CP","event_category":"Class 6","event_action":"Post login - Class 6 - Tests - Symmetry - More on Lines of Symmetry - CP - Report"},"postlogin-class7-tests-exponents-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Start"},"postlogin-class7-tests-exponents-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Resume"},"postlogin-class7-tests-exponents-revise":{"event_label":"Revise topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Revise"},"postlogin-class7-tests-exponents-lawsofexponents-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - PT - Start"},"postlogin-class7-tests-exponents-lawsofexponents-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - PT - Resume"},"postlogin-class7-tests-exponents-lawsofexponents-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - PT - Report"},"postlogin-class7-tests-exponents-lawsofexponents-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - PT - Start - Start Test"},"postlogin-class7-tests-exponents-lawsofexponents-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - PT - Close"},"postlogin-class7-tests-exponents-lawsofexponents-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - PT - Resume - Continue Test"},"postlogin-class7-tests-exponents-lawsofexponents-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - PT - Test - Close"},"postlogin-class7-tests-exponents-lawsofexponents-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - PT - Test - Submit Test"},"postlogin-class7-tests-exponents-lawsofexponents-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - PT - Scorecard - View Solutions"},"postlogin-class7-tests-exponents-lawsofexponents-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-exponents-lawsofexponents-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-exponents-lawsofexponents-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-exponents-lawsofexponents-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-exponents-lawsofexponents-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-exponents-lawsofexponents-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-exponents-lawsofexponents-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-exponents-lawsofexponents-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-exponents-lawsofexponents-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-exponents-lawsofexponents-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-exponents-lawsofexponents-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-exponents-lawsofexponents-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-exponents-lawsofexponents-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-exponents-lawsofexponents-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-exponents-lawsofexponents-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-exponents-lawsofexponents-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - CP - Start"},"postlogin-class7-tests-exponents-lawsofexponents-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - CP - Start - Start Practice"},"postlogin-class7-tests-exponents-lawsofexponents-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - CP - Start - Close"},"postlogin-class7-tests-exponents-lawsofexponents-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - CP - Start - Start Practice - Close"},"postlogin-class7-tests-exponents-lawsofexponents-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - CP - Start - Start Practice - Check"},"postlogin-class7-tests-exponents-lawsofexponents-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - CP - Resume"},"postlogin-class7-tests-exponents-lawsofexponents-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - CP - Resume - Continue"},"postlogin-class7-tests-exponents-lawsofexponents-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - CP - Resume - Close"},"postlogin-class7-tests-exponents-lawsofexponents-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - CP - Resume - Continue - Close"},"postlogin-class7-tests-exponents-lawsofexponents-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - CP - Resume - Continue - Check"},"postlogin-class7-tests-exponents-lawsofexponents-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Laws of Exponents - CP - Report"},"postlogin-class7-tests-exponents-moreonlawsofexponents-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - PT - Start"},"postlogin-class7-tests-exponents-moreonlawsofexponents-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - PT - Resume"},"postlogin-class7-tests-exponents-moreonlawsofexponents-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - PT - Report"},"postlogin-class7-tests-exponents-moreonlawsofexponents-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - PT - Start - Start Test"},"postlogin-class7-tests-exponents-moreonlawsofexponents-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - PT - Close"},"postlogin-class7-tests-exponents-moreonlawsofexponents-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - PT - Resume - Continue Test"},"postlogin-class7-tests-exponents-moreonlawsofexponents-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - PT - Test - Close"},"postlogin-class7-tests-exponents-moreonlawsofexponents-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - PT - Test - Submit Test"},"postlogin-class7-tests-exponents-moreonlawsofexponents-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - PT - Scorecard - View Solutions"},"postlogin-class7-tests-exponents-moreonlawsofexponents-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-exponents-moreonlawsofexponents-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-exponents-moreonlawsofexponents-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-exponents-moreonlawsofexponents-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-exponents-moreonlawsofexponents-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-exponents-moreonlawsofexponents-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-exponents-moreonlawsofexponents-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-exponents-moreonlawsofexponents-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-exponents-moreonlawsofexponents-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-exponents-moreonlawsofexponents-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-exponents-moreonlawsofexponents-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-exponents-moreonlawsofexponents-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-exponents-moreonlawsofexponents-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-exponents-moreonlawsofexponents-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-exponents-moreonlawsofexponents-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-exponents-moreonlawsofexponents-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - CP - Start"},"postlogin-class7-tests-exponents-moreonlawsofexponents-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - CP - Start - Start Practice"},"postlogin-class7-tests-exponents-moreonlawsofexponents-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - CP - Start - Close"},"postlogin-class7-tests-exponents-moreonlawsofexponents-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - CP - Start - Start Practice - Close"},"postlogin-class7-tests-exponents-moreonlawsofexponents-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - CP - Start - Start Practice - Check"},"postlogin-class7-tests-exponents-moreonlawsofexponents-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - CP - Resume"},"postlogin-class7-tests-exponents-moreonlawsofexponents-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - CP - Resume - Continue"},"postlogin-class7-tests-exponents-moreonlawsofexponents-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - CP - Resume - Close"},"postlogin-class7-tests-exponents-moreonlawsofexponents-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - CP - Resume - Continue - Close"},"postlogin-class7-tests-exponents-moreonlawsofexponents-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - CP - Resume - Continue - Check"},"postlogin-class7-tests-exponents-moreonlawsofexponents-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - More on Laws of Exponents - CP - Report"},"postlogin-class7-tests-exponents-standardform-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - PT - Start"},"postlogin-class7-tests-exponents-standardform-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - PT - Resume"},"postlogin-class7-tests-exponents-standardform-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - PT - Report"},"postlogin-class7-tests-exponents-standardform-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - PT - Start - Start Test"},"postlogin-class7-tests-exponents-standardform-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - PT - Close"},"postlogin-class7-tests-exponents-standardform-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - PT - Resume - Continue Test"},"postlogin-class7-tests-exponents-standardform-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - PT - Test - Close"},"postlogin-class7-tests-exponents-standardform-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - PT - Test - Submit Test"},"postlogin-class7-tests-exponents-standardform-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - PT - Scorecard - View Solutions"},"postlogin-class7-tests-exponents-standardform-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-exponents-standardform-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-exponents-standardform-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-exponents-standardform-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-exponents-standardform-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-exponents-standardform-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-exponents-standardform-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-exponents-standardform-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-exponents-standardform-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-exponents-standardform-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-exponents-standardform-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-exponents-standardform-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-exponents-standardform-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-exponents-standardform-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-exponents-standardform-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-exponents-standardform-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - CP - Start"},"postlogin-class7-tests-exponents-standardform-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - CP - Start - Start Practice"},"postlogin-class7-tests-exponents-standardform-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - CP - Start - Close"},"postlogin-class7-tests-exponents-standardform-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - CP - Start - Start Practice - Close"},"postlogin-class7-tests-exponents-standardform-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - CP - Start - Start Practice - Check"},"postlogin-class7-tests-exponents-standardform-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - CP - Resume"},"postlogin-class7-tests-exponents-standardform-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - CP - Resume - Continue"},"postlogin-class7-tests-exponents-standardform-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - CP - Resume - Close"},"postlogin-class7-tests-exponents-standardform-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - CP - Resume - Continue - Close"},"postlogin-class7-tests-exponents-standardform-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - CP - Resume - Continue - Check"},"postlogin-class7-tests-exponents-standardform-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Exponents - Standard Form - CP - Report"},"postlogin-class8-tests-introductiontographs-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Start"},"postlogin-class8-tests-introductiontographs-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Resume"},"postlogin-class8-tests-introductiontographs-revise":{"event_label":"Revise topic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Revise"},"postlogin-class8-tests-introductiontographs-typesofgraphs-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - PT - Start"},"postlogin-class8-tests-introductiontographs-typesofgraphs-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - PT - Resume"},"postlogin-class8-tests-introductiontographs-typesofgraphs-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - PT - Report"},"postlogin-class8-tests-introductiontographs-typesofgraphs-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - PT - Start - Start Test"},"postlogin-class8-tests-introductiontographs-typesofgraphs-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - PT - Close"},"postlogin-class8-tests-introductiontographs-typesofgraphs-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - PT - Resume - Continue Test"},"postlogin-class8-tests-introductiontographs-typesofgraphs-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - PT - Test - Close"},"postlogin-class8-tests-introductiontographs-typesofgraphs-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - PT - Test - Submit Test"},"postlogin-class8-tests-introductiontographs-typesofgraphs-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - PT - Scorecard - View Solutions"},"postlogin-class8-tests-introductiontographs-typesofgraphs-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-introductiontographs-typesofgraphs-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-introductiontographs-typesofgraphs-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-introductiontographs-typesofgraphs-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-introductiontographs-typesofgraphs-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-introductiontographs-typesofgraphs-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-introductiontographs-typesofgraphs-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-introductiontographs-typesofgraphs-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-introductiontographs-typesofgraphs-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-introductiontographs-typesofgraphs-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-introductiontographs-typesofgraphs-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-introductiontographs-typesofgraphs-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-introductiontographs-typesofgraphs-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-introductiontographs-typesofgraphs-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-introductiontographs-typesofgraphs-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-introductiontographs-typesofgraphs-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - CP - Start"},"postlogin-class8-tests-introductiontographs-typesofgraphs-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - CP - Start - Start Practice"},"postlogin-class8-tests-introductiontographs-typesofgraphs-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - CP - Start - Close"},"postlogin-class8-tests-introductiontographs-typesofgraphs-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - CP - Start - Start Practice - Close"},"postlogin-class8-tests-introductiontographs-typesofgraphs-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - CP - Start - Start Practice - Check"},"postlogin-class8-tests-introductiontographs-typesofgraphs-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - CP - Resume"},"postlogin-class8-tests-introductiontographs-typesofgraphs-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - CP - Resume - Continue"},"postlogin-class8-tests-introductiontographs-typesofgraphs-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - CP - Resume - Close"},"postlogin-class8-tests-introductiontographs-typesofgraphs-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - CP - Resume - Continue - Close"},"postlogin-class8-tests-introductiontographs-typesofgraphs-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - CP - Resume - Continue - Check"},"postlogin-class8-tests-introductiontographs-typesofgraphs-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Types of Graphs - CP - Report"},"postlogin-class8-tests-introductiontographs-lineargraphs-pt-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - PT - Start"},"postlogin-class8-tests-introductiontographs-lineargraphs-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - PT - Resume"},"postlogin-class8-tests-introductiontographs-lineargraphs-pt-report":{"event_label":"View report PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - PT - Report"},"postlogin-class8-tests-introductiontographs-lineargraphs-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - PT - Start - Start Test"},"postlogin-class8-tests-introductiontographs-lineargraphs-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - PT - Close"},"postlogin-class8-tests-introductiontographs-lineargraphs-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - PT - Resume - Continue Test"},"postlogin-class8-tests-introductiontographs-lineargraphs-pt-test-close":{"event_label":"Close PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - PT - Test - Close"},"postlogin-class8-tests-introductiontographs-lineargraphs-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - PT - Test - Submit Test"},"postlogin-class8-tests-introductiontographs-lineargraphs-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - PT - Scorecard - View Solutions"},"postlogin-class8-tests-introductiontographs-lineargraphs-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - PT - Scorecard - View Solutions - Close"},"postlogin-class8-tests-introductiontographs-lineargraphs-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - PT - Scorecard - View Recommendations"},"postlogin-class8-tests-introductiontographs-lineargraphs-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - PT - Scorecard - View Recommendations - Close"},"postlogin-class8-tests-introductiontographs-lineargraphs-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class8-tests-introductiontographs-lineargraphs-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class8-tests-introductiontographs-lineargraphs-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class8-tests-introductiontographs-lineargraphs-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class8-tests-introductiontographs-lineargraphs-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class8-tests-introductiontographs-lineargraphs-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class8-tests-introductiontographs-lineargraphs-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class8-tests-introductiontographs-lineargraphs-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class8-tests-introductiontographs-lineargraphs-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class8-tests-introductiontographs-lineargraphs-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class8-tests-introductiontographs-lineargraphs-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class8-tests-introductiontographs-lineargraphs-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class8-tests-introductiontographs-lineargraphs-cp-start":{"event_label":"Start Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - CP - Start"},"postlogin-class8-tests-introductiontographs-lineargraphs-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - CP - Start - Start Practice"},"postlogin-class8-tests-introductiontographs-lineargraphs-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - CP - Start - Close"},"postlogin-class8-tests-introductiontographs-lineargraphs-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - CP - Start - Start Practice - Close"},"postlogin-class8-tests-introductiontographs-lineargraphs-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - CP - Start - Start Practice - Check"},"postlogin-class8-tests-introductiontographs-lineargraphs-cp-resume":{"event_label":"Continue Practice","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - CP - Resume"},"postlogin-class8-tests-introductiontographs-lineargraphs-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - CP - Resume - Continue"},"postlogin-class8-tests-introductiontographs-lineargraphs-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - CP - Resume - Close"},"postlogin-class8-tests-introductiontographs-lineargraphs-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - CP - Resume - Continue - Close"},"postlogin-class8-tests-introductiontographs-lineargraphs-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - CP - Resume - Continue - Check"},"postlogin-class8-tests-introductiontographs-lineargraphs-cp-report":{"event_label":"View report CP","event_category":"Class 8","event_action":"Post login - Class 8 - Tests - Introduction to Graphs - Linear Graphs - CP - Report"},"postlogin-class5-lessons-symmetry,patternsandnets-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Symmetry, Patterns and Nets - Start"},"postlogin-class5-lessons-symmetry,patternsandnets-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Symmetry, Patterns and Nets - Resume"},"postlogin-class5-lessons-symmetry,patternsandnets-watched":{"event_label":"Rewatch topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Symmetry, Patterns and Nets - Watched"},"postlogin-class5-lessons-symmetry,patternsandnets-patterns-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Symmetry, Patterns and Nets - Patterns - Start"},"postlogin-class5-lessons-symmetry,patternsandnets-patterns-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Symmetry, Patterns and Nets - Patterns - Resume"},"postlogin-class5-lessons-symmetry,patternsandnets-patterns-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Symmetry, Patterns and Nets - Patterns - Watched"},"postlogin-class5-lessons-symmetry,patternsandnets-patterns-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Symmetry, Patterns and Nets - Patterns - Lessons"},"postlogin-class5-lessons-symmetry,patternsandnets-patterns-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Symmetry, Patterns and Nets - Patterns - Close"},"postlogin-class5-lessons-symmetry,patternsandnets-netsofsolids-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Symmetry, Patterns and Nets - Nets of Solids - Start"},"postlogin-class5-lessons-symmetry,patternsandnets-netsofsolids-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Symmetry, Patterns and Nets - Nets of Solids - Resume"},"postlogin-class5-lessons-symmetry,patternsandnets-netsofsolids-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Symmetry, Patterns and Nets - Nets of Solids - Watched"},"postlogin-class5-lessons-symmetry,patternsandnets-netsofsolids-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Symmetry, Patterns and Nets - Nets of Solids - Lessons"},"postlogin-class5-lessons-symmetry,patternsandnets-netsofsolids-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Symmetry, Patterns and Nets - Nets of Solids - Close"},"postlogin-class6-lessons-practicalgeometry-start":{"event_label":"Start topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Practical Geometry - Start"},"postlogin-class6-lessons-practicalgeometry-resume":{"event_label":"Resume topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Practical Geometry - Resume"},"postlogin-class6-lessons-practicalgeometry-watched":{"event_label":"Rewatch topic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons - Practical Geometry - Watched"},"postlogin-class6-lessons-practicalgeometry-geometricalconstruction-start":{"event_label":"Start subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Practical Geometry - Geometrical Construction - Start"},"postlogin-class6-lessons-practicalgeometry-geometricalconstruction-resume":{"event_label":"Resume subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Practical Geometry - Geometrical Construction - Resume"},"postlogin-class6-lessons-practicalgeometry-geometricalconstruction-watched":{"event_label":"Rewatch subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Practical Geometry - Geometrical Construction - Watched"},"postlogin-class6-lessons-practicalgeometry-geometricalconstruction-lessons":{"event_label":"Class 6 lessons","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Practical Geometry - Geometrical Construction - Lessons"},"postlogin-class6-lessons-practicalgeometry-geometricalconstruction-close":{"event_label":"Close subtopic","event_category":"Class 6","event_action":"Post login - Class 6 - Lessons  - Practical Geometry - Geometrical Construction - Close"},"postlogin-class7-lessons-exponents-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Exponents - Start"},"postlogin-class7-lessons-exponents-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Exponents - Resume"},"postlogin-class7-lessons-exponents-watched":{"event_label":"Rewatch topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Exponents - Watched"},"postlogin-class7-lessons-exponents-lawsofexponents-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Exponents - Laws of Exponents - Start"},"postlogin-class7-lessons-exponents-lawsofexponents-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Exponents - Laws of Exponents - Resume"},"postlogin-class7-lessons-exponents-lawsofexponents-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Exponents - Laws of Exponents - Watched"},"postlogin-class7-lessons-exponents-lawsofexponents-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Exponents - Laws of Exponents - Lessons"},"postlogin-class7-lessons-exponents-lawsofexponents-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Exponents - Laws of Exponents - Close"},"postlogin-class7-lessons-exponents-standardform-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Exponents - Standard Form - Start"},"postlogin-class7-lessons-exponents-standardform-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Exponents - Standard Form - Resume"},"postlogin-class7-lessons-exponents-standardform-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Exponents - Standard Form - Watched"},"postlogin-class7-lessons-exponents-standardform-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Exponents - Standard Form - Lessons"},"postlogin-class7-lessons-exponents-standardform-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Exponents - Standard Form - Close"},"postlogin-class8-lessons-introductiontographs-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Introduction to Graphs - Start"},"postlogin-class8-lessons-introductiontographs-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Introduction to Graphs - Resume"},"postlogin-class8-lessons-introductiontographs-watched":{"event_label":"Rewatch topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Introduction to Graphs - Watched"},"postlogin-class8-lessons-introductiontographs-lineargraphs-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Introduction to Graphs - Linear Graphs - Start"},"postlogin-class8-lessons-introductiontographs-lineargraphs-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Introduction to Graphs - Linear Graphs - Resume"},"postlogin-class8-lessons-introductiontographs-lineargraphs-watched":{"event_label":"Rewatch subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Introduction to Graphs - Linear Graphs - Watched"},"postlogin-class8-lessons-introductiontographs-lineargraphs-lessons":{"event_label":"Class 8 lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Introduction to Graphs - Linear Graphs - Lessons"},"postlogin-class8-lessons-introductiontographs-lineargraphs-close":{"event_label":"Close subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Introduction to Graphs - Linear Graphs - Close"},"postlogin-class7-tests-symmetry-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Start"},"postlogin-class7-tests-symmetry-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Resume"},"postlogin-class7-tests-symmetry-revise":{"event_label":"Revise topic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Revise"},"postlogin-class7-tests-symmetry-linesymmetry-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - PT - Start"},"postlogin-class7-tests-symmetry-linesymmetry-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - PT - Resume"},"postlogin-class7-tests-symmetry-linesymmetry-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - PT - Report"},"postlogin-class7-tests-symmetry-linesymmetry-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - PT - Start - Start Test"},"postlogin-class7-tests-symmetry-linesymmetry-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - PT - Close"},"postlogin-class7-tests-symmetry-linesymmetry-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - PT - Resume - Continue Test"},"postlogin-class7-tests-symmetry-linesymmetry-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - PT - Test - Close"},"postlogin-class7-tests-symmetry-linesymmetry-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - PT - Test - Submit Test"},"postlogin-class7-tests-symmetry-linesymmetry-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - PT - Scorecard - View Solutions"},"postlogin-class7-tests-symmetry-linesymmetry-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-symmetry-linesymmetry-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-symmetry-linesymmetry-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-symmetry-linesymmetry-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-symmetry-linesymmetry-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-symmetry-linesymmetry-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-symmetry-linesymmetry-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-symmetry-linesymmetry-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-symmetry-linesymmetry-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-symmetry-linesymmetry-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-symmetry-linesymmetry-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-symmetry-linesymmetry-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-symmetry-linesymmetry-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-symmetry-linesymmetry-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-symmetry-linesymmetry-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-symmetry-linesymmetry-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - CP - Start"},"postlogin-class7-tests-symmetry-linesymmetry-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - CP - Start - Start Practice"},"postlogin-class7-tests-symmetry-linesymmetry-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - CP - Start - Close"},"postlogin-class7-tests-symmetry-linesymmetry-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - CP - Start - Start Practice - Close"},"postlogin-class7-tests-symmetry-linesymmetry-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - CP - Start - Start Practice - Check"},"postlogin-class7-tests-symmetry-linesymmetry-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - CP - Resume"},"postlogin-class7-tests-symmetry-linesymmetry-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - CP - Resume - Continue"},"postlogin-class7-tests-symmetry-linesymmetry-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - CP - Resume - Close"},"postlogin-class7-tests-symmetry-linesymmetry-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - CP - Resume - Continue - Close"},"postlogin-class7-tests-symmetry-linesymmetry-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - CP - Resume - Continue - Check"},"postlogin-class7-tests-symmetry-linesymmetry-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Line Symmetry - CP - Report"},"postlogin-class7-tests-symmetry-rotationalsymmetry-pt-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - PT - Start"},"postlogin-class7-tests-symmetry-rotationalsymmetry-pt-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - PT - Resume"},"postlogin-class7-tests-symmetry-rotationalsymmetry-pt-report":{"event_label":"View report PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - PT - Report"},"postlogin-class7-tests-symmetry-rotationalsymmetry-pt-start-starttest":{"event_label":"Start PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - PT - Start - Start Test"},"postlogin-class7-tests-symmetry-rotationalsymmetry-pt-close":{"event_label":"Close Start PT Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - PT - Close"},"postlogin-class7-tests-symmetry-rotationalsymmetry-pt-resume-continuetest":{"event_label":"Continue PT ","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - PT - Resume - Continue Test"},"postlogin-class7-tests-symmetry-rotationalsymmetry-pt-test-close":{"event_label":"Close PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - PT - Test - Close"},"postlogin-class7-tests-symmetry-rotationalsymmetry-pt-test-submittest":{"event_label":"Submit PT","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - PT - Test - Submit Test"},"postlogin-class7-tests-symmetry-rotationalsymmetry-pt-scorecard-viewsolutions":{"event_label":"View Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - PT - Scorecard - View Solutions"},"postlogin-class7-tests-symmetry-rotationalsymmetry-pt-scorecard-viewsolutions-close":{"event_label":"Close Solutions","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - PT - Scorecard - View Solutions - Close"},"postlogin-class7-tests-symmetry-rotationalsymmetry-pt-scorecard-viewrecommendations":{"event_label":"View Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - PT - Scorecard - View Recommendations"},"postlogin-class7-tests-symmetry-rotationalsymmetry-pt-scorecard-viewrecommendations-close":{"event_label":"Close Recommendations","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - PT - Scorecard - View Recommendations - Close"},"postlogin-class7-tests-symmetry-rotationalsymmetry-pt-scorecard-viewrecommendations-startpractice":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - PT - Scorecard - View Recommendations - Start Practice"},"postlogin-class7-tests-symmetry-rotationalsymmetry-pt-scorecard-viewrecommendations-startpractice-start":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - PT - Scorecard - View Recommendations - Start Practice - Start"},"postlogin-class7-tests-symmetry-rotationalsymmetry-pt-scorecard-viewrecommendations-startpractice-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - PT - Scorecard - View Recommendations - Start Practice - Close"},"postlogin-class7-tests-symmetry-rotationalsymmetry-pt-scorecard-viewrecommendations-startpractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - PT - Scorecard - View Recommendations - Start Practice - Practice - Close"},"postlogin-class7-tests-symmetry-rotationalsymmetry-pt-scorecard-viewrecommendations-startpractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - PT - Scorecard - View Recommendations - Start Practice - Practice - Check"},"postlogin-class7-tests-symmetry-rotationalsymmetry-pt-scorecard-viewrecommendations-continuepractice":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - PT - Scorecard - View Recommendations - Continue Practice"},"postlogin-class7-tests-symmetry-rotationalsymmetry-pt-scorecard-viewrecommendations-continuepractice-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - PT - Scorecard - View Recommendations - Continue Practice - Continue"},"postlogin-class7-tests-symmetry-rotationalsymmetry-pt-scorecard-viewrecommendations-continuepractice-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - PT - Scorecard - View Recommendations - Continue Practice - Close"},"postlogin-class7-tests-symmetry-rotationalsymmetry-pt-scorecard-viewrecommendations-continuepractice-practice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - PT - Scorecard - View Recommendations - Continue Practice - Practice - Close"},"postlogin-class7-tests-symmetry-rotationalsymmetry-pt-scorecard-viewrecommendations-continuepractice-practice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - PT - Scorecard - View Recommendations - Continue Practice - Practice - Check"},"postlogin-class7-tests-symmetry-rotationalsymmetry-pt-scorecard-viewrecommendations-lessons":{"event_label":"Lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - PT - Scorecard - View Recommendations - Lessons"},"postlogin-class7-tests-symmetry-rotationalsymmetry-pt-scorecard-viewrecommendations-lessons-close":{"event_label":"Lessons Close","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - PT - Scorecard - View Recommendations - Lessons - Close"},"postlogin-class7-tests-symmetry-rotationalsymmetry-cp-start":{"event_label":"Start Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - CP - Start"},"postlogin-class7-tests-symmetry-rotationalsymmetry-cp-start-startpractice":{"event_label":"Start CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - CP - Start - Start Practice"},"postlogin-class7-tests-symmetry-rotationalsymmetry-cp-start-close":{"event_label":"Close Start Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - CP - Start - Close"},"postlogin-class7-tests-symmetry-rotationalsymmetry-cp-start-startpractice-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - CP - Start - Start Practice - Close"},"postlogin-class7-tests-symmetry-rotationalsymmetry-cp-start-startpractice-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - CP - Start - Start Practice - Check"},"postlogin-class7-tests-symmetry-rotationalsymmetry-cp-resume":{"event_label":"Continue Practice","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - CP - Resume"},"postlogin-class7-tests-symmetry-rotationalsymmetry-cp-resume-continue":{"event_label":"Continue CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - CP - Resume - Continue"},"postlogin-class7-tests-symmetry-rotationalsymmetry-cp-resume-close":{"event_label":"Close Continue Practice Dialog","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - CP - Resume - Close"},"postlogin-class7-tests-symmetry-rotationalsymmetry-cp-resume-continue-close":{"event_label":"Close CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - CP - Resume - Continue - Close"},"postlogin-class7-tests-symmetry-rotationalsymmetry-cp-resume-continue-check":{"event_label":"Check CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - CP - Resume - Continue - Check"},"postlogin-class7-tests-symmetry-rotationalsymmetry-cp-report":{"event_label":"View report CP","event_category":"Class 7","event_action":"Post login - Class 7 - Tests - Symmetry - Rotational Symmetry - CP - Report"},"postlogin-class5-lessons-geometry-start":{"event_label":"Start topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Geometry - Start"},"postlogin-class5-lessons-geometry-resume":{"event_label":"Resume topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Geometry - Resume"},"postlogin-class5-lessons-geometry-watched":{"event_label":"Rewatch topic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons - Geometry - Watched"},"postlogin-class5-lessons-geometry-basicsofgeometry-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Geometry - Basics of Geometry - Start"},"postlogin-class5-lessons-geometry-basicsofgeometry-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Geometry - Basics of Geometry - Resume"},"postlogin-class5-lessons-geometry-basicsofgeometry-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Geometry - Basics of Geometry - Watched"},"postlogin-class5-lessons-geometry-basicsofgeometry-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Geometry - Basics of Geometry - Lessons"},"postlogin-class5-lessons-geometry-basicsofgeometry-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Geometry - Basics of Geometry - Close"},"postlogin-class5-lessons-geometry-parallelandperpendicularlines-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Geometry - Parallel and Perpendicular Lines - Start"},"postlogin-class5-lessons-geometry-parallelandperpendicularlines-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Geometry - Parallel and Perpendicular Lines - Resume"},"postlogin-class5-lessons-geometry-parallelandperpendicularlines-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Geometry - Parallel and Perpendicular Lines - Watched"},"postlogin-class5-lessons-geometry-parallelandperpendicularlines-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Geometry - Parallel and Perpendicular Lines - Lessons"},"postlogin-class5-lessons-geometry-parallelandperpendicularlines-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Geometry - Parallel and Perpendicular Lines - Close"},"postlogin-class5-lessons-geometry-circles-start":{"event_label":"Start subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Geometry - Circles - Start"},"postlogin-class5-lessons-geometry-circles-resume":{"event_label":"Resume subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Geometry - Circles - Resume"},"postlogin-class5-lessons-geometry-circles-watched":{"event_label":"Rewatch subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Geometry - Circles - Watched"},"postlogin-class5-lessons-geometry-circles-lessons":{"event_label":"Class 5 lessons","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Geometry - Circles - Lessons"},"postlogin-class5-lessons-geometry-circles-close":{"event_label":"Close subtopic","event_category":"Class 5","event_action":"Post login - Class 5 - Lessons  - Geometry - Circles - Close"},"postlogin-class7-lessons-symmetry-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Symmetry - Start"},"postlogin-class7-lessons-symmetry-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Symmetry - Resume"},"postlogin-class7-lessons-symmetry-watched":{"event_label":"Rewatch topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Symmetry - Watched"},"postlogin-class7-lessons-symmetry-lineofsymmetry-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Symmetry - Line of Symmetry - Start"},"postlogin-class7-lessons-symmetry-lineofsymmetry-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Symmetry - Line of Symmetry - Resume"},"postlogin-class7-lessons-symmetry-lineofsymmetry-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Symmetry - Line of Symmetry - Watched"},"postlogin-class7-lessons-symmetry-lineofsymmetry-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Symmetry - Line of Symmetry - Lessons"},"postlogin-class7-lessons-symmetry-lineofsymmetry-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Symmetry - Line of Symmetry - Close"},"postlogin-class7-lessons-symmetry-rotationalsymmetry-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Symmetry - Rotational Symmetry - Start"},"postlogin-class7-lessons-symmetry-rotationalsymmetry-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Symmetry - Rotational Symmetry - Resume"},"postlogin-class7-lessons-symmetry-rotationalsymmetry-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Symmetry - Rotational Symmetry - Watched"},"postlogin-class7-lessons-symmetry-rotationalsymmetry-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Symmetry - Rotational Symmetry - Lessons"},"postlogin-class7-lessons-symmetry-rotationalsymmetry-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Symmetry - Rotational Symmetry - Close"},"postlogin-class8-lessons-practicalgeometry-start":{"event_label":"Start topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Practical Geometry - Start"},"postlogin-class8-lessons-practicalgeometry-resume":{"event_label":"Resume topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Practical Geometry - Resume"},"postlogin-class8-lessons-practicalgeometry-watched":{"event_label":"Rewatch topic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons - Practical Geometry - Watched"},"postlogin-class8-lessons-practicalgeometry-geometricalconstructions-start":{"event_label":"Start subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Practical Geometry - Geometrical Constructions - Start"},"postlogin-class8-lessons-practicalgeometry-geometricalconstructions-resume":{"event_label":"Resume subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Practical Geometry - Geometrical Constructions - Resume"},"postlogin-class8-lessons-practicalgeometry-geometricalconstructions-watched":{"event_label":"Rewatch subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Practical Geometry - Geometrical Constructions - Watched"},"postlogin-class8-lessons-practicalgeometry-geometricalconstructions-lessons":{"event_label":"Class 8 lessons","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Practical Geometry - Geometrical Constructions - Lessons"},"postlogin-class8-lessons-practicalgeometry-geometricalconstructions-close":{"event_label":"Close subtopic","event_category":"Class 8","event_action":"Post login - Class 8 - Lessons  - Practical Geometry - Geometrical Constructions - Close"},"postlogin-class7-lessons-visualisingsolidshapes-start":{"event_label":"Start topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Visualising Solid Shapes - Start"},"postlogin-class7-lessons-visualisingsolidshapes-resume":{"event_label":"Resume topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Visualising Solid Shapes - Resume"},"postlogin-class7-lessons-visualisingsolidshapes-watched":{"event_label":"Rewatch topic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons - Visualising Solid Shapes - Watched"},"postlogin-class7-lessons-visualisingsolidshapes-threedimensionalobjects-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Visualising Solid Shapes - Three Dimensional Objects - Start"},"postlogin-class7-lessons-visualisingsolidshapes-threedimensionalobjects-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Visualising Solid Shapes - Three Dimensional Objects - Resume"},"postlogin-class7-lessons-visualisingsolidshapes-threedimensionalobjects-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Visualising Solid Shapes - Three Dimensional Objects - Watched"},"postlogin-class7-lessons-visualisingsolidshapes-threedimensionalobjects-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Visualising Solid Shapes - Three Dimensional Objects - Lessons"},"postlogin-class7-lessons-visualisingsolidshapes-threedimensionalobjects-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Visualising Solid Shapes - Three Dimensional Objects - Close"},"postlogin-class7-lessons-visualisingsolidshapes-nets-start":{"event_label":"Start subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Visualising Solid Shapes - Nets - Start"},"postlogin-class7-lessons-visualisingsolidshapes-nets-resume":{"event_label":"Resume subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Visualising Solid Shapes - Nets - Resume"},"postlogin-class7-lessons-visualisingsolidshapes-nets-watched":{"event_label":"Rewatch subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Visualising Solid Shapes - Nets - Watched"},"postlogin-class7-lessons-visualisingsolidshapes-nets-lessons":{"event_label":"Class 7 lessons","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Visualising Solid Shapes - Nets - Lessons"},"postlogin-class7-lessons-visualisingsolidshapes-nets-close":{"event_label":"Close subtopic","event_category":"Class 7","event_action":"Post login - Class 7 - Lessons  - Visualising Solid Shapes - Nets - Close"}}

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

module.exports = {"defaultId":"UA-123178620-1","products":"UA-123178620-2","ourlearnings":"UA-123178620-3","whoweare":"UA-123178620-4","selflearning":"UA-123178620-5","personalisedlearning":"UA-123178620-6","landing":"UA-123178620-7"}

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialize */
/* unused harmony export ga */
/* unused harmony export set */
/* unused harmony export send */
/* unused harmony export pageview */
/* unused harmony export modalview */
/* unused harmony export timing */
/* unused harmony export event */
/* unused harmony export exception */
/* unused harmony export plugin */
/* unused harmony export outboundLink */
/* unused harmony export testModeAPI */
/* unused harmony export OutboundLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core__ = __webpack_require__(1139);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var initialize = __WEBPACK_IMPORTED_MODULE_1__core__["initialize"];
var ga = __WEBPACK_IMPORTED_MODULE_1__core__["ga"];
var set = __WEBPACK_IMPORTED_MODULE_1__core__["set"];
var send = __WEBPACK_IMPORTED_MODULE_1__core__["send"];
var pageview = __WEBPACK_IMPORTED_MODULE_1__core__["pageview"];
var modalview = __WEBPACK_IMPORTED_MODULE_1__core__["modalview"];
var timing = __WEBPACK_IMPORTED_MODULE_1__core__["timing"];
var event = __WEBPACK_IMPORTED_MODULE_1__core__["event"];
var exception = __WEBPACK_IMPORTED_MODULE_1__core__["exception"];
var plugin = __WEBPACK_IMPORTED_MODULE_1__core__["plugin"];
var outboundLink = __WEBPACK_IMPORTED_MODULE_1__core__["outboundLink"];
var testModeAPI = __WEBPACK_IMPORTED_MODULE_1__core__["testModeAPI"];
__WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].origTrackLink = __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].trackLink;
__WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].trackLink = __WEBPACK_IMPORTED_MODULE_1__core__["outboundLink"];
var OutboundLink = __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (_objectSpread({}, __WEBPACK_IMPORTED_MODULE_1__core__, {
  OutboundLink: OutboundLink
}));

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OutboundLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_console_warn__ = __webpack_require__(306);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var NEWTAB = '_blank';
var MIDDLECLICK = 1;

var OutboundLink =
/*#__PURE__*/
function (_Component) {
  _inherits(OutboundLink, _Component);

  function OutboundLink() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, OutboundLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OutboundLink)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      var _this$props = _this.props,
          target = _this$props.target,
          eventLabel = _this$props.eventLabel,
          to = _this$props.to,
          onClick = _this$props.onClick,
          trackerNames = _this$props.trackerNames;
      var eventMeta = {
        label: eventLabel
      };
      var sameTarget = target !== NEWTAB;
      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

      if (sameTarget && normalClick) {
        event.preventDefault();
        OutboundLink.trackLink(eventMeta, function () {
          window.location.href = to;
        }, trackerNames);
      } else {
        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
      }

      if (onClick) {
        onClick(event);
      }
    });

    return _this;
  }

  _createClass(OutboundLink, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          href = _this$props2.to,
          oldProps = _objectWithoutProperties(_this$props2, ["to"]);

      var props = _objectSpread({}, oldProps, {
        href: href,
        onClick: this.handleClick
      });

      if (this.props.target === NEWTAB) {
        props.rel = 'noopener noreferrer';
      }

      delete props.eventLabel;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
    }
  }]);

  return OutboundLink;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(OutboundLink, "trackLink", function () {
  Object(__WEBPACK_IMPORTED_MODULE_2__utils_console_warn__["a" /* default */])('ga tracking not enabled');
});

_defineProperty(OutboundLink, "propTypes", {
  eventLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  trackerNames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
});

_defineProperty(OutboundLink, "defaultProps", {
  target: null,
  to: null,
  onClick: null,
  trackerNames: null
});



/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["initialize"] = initialize;
/* harmony export (immutable) */ __webpack_exports__["ga"] = ga;
/* harmony export (immutable) */ __webpack_exports__["set"] = set;
/* harmony export (immutable) */ __webpack_exports__["send"] = send;
/* harmony export (immutable) */ __webpack_exports__["pageview"] = pageview;
/* harmony export (immutable) */ __webpack_exports__["modalview"] = modalview;
/* harmony export (immutable) */ __webpack_exports__["timing"] = timing;
/* harmony export (immutable) */ __webpack_exports__["event"] = event;
/* harmony export (immutable) */ __webpack_exports__["exception"] = exception;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "plugin", function() { return plugin; });
/* harmony export (immutable) */ __webpack_exports__["outboundLink"] = outboundLink;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "testModeAPI", function() { return testModeAPI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_format__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_removeLeadingSlash__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_trim__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_loadGA__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_console_warn__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_console_log__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__ = __webpack_require__(1146);
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * React Google Analytics Module
 *
 * @package react-ga
 * @author  Adam Lofting <adam@mozillafoundation.org>
 *          Atul Varma <atul@mozillafoundation.org>
 */

/**
 * Utilities
 */








var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';

var _debug = false;
var _titleCase = true;
var _testMode = false;
var _alwaysSendToDefaultTracker = true;

var internalGa = function internalGa() {
  var _window;

  if (_testMode) return __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */].ga.apply(__WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */], arguments);
  if (_isNotBrowser) return false;
  if (!window.ga) return Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
  return (_window = window).ga.apply(_window, arguments);
};

function _format(s) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_format__["a" /* default */])(s, _titleCase);
}

function _gaCommand(trackerNames) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var command = args[0];

  if (typeof internalGa === 'function') {
    if (typeof command !== 'string') {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('ga command must be a string');
      return;
    }

    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);

    if (Array.isArray(trackerNames)) {
      trackerNames.forEach(function (name) {
        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
      });
    }
  }
}

function _initialize(gaTrackingID, options) {
  if (!gaTrackingID) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('gaTrackingID is required in initialize()');
    return;
  }

  if (options) {
    if (options.debug && options.debug === true) {
      _debug = true;
    }

    if (options.titleCase === false) {
      _titleCase = false;
    }
  }

  if (options && options.gaOptions) {
    internalGa('create', gaTrackingID, options.gaOptions);
  } else {
    internalGa('create', gaTrackingID, 'auto');
  }
}

function initialize(configsOrTrackingId, options) {
  if (options && options.testMode === true) {
    _testMode = true;
  } else {
    if (_isNotBrowser) {
      return false;
    }

    if (!options || options.standardImplementation !== true) Object(__WEBPACK_IMPORTED_MODULE_3__utils_loadGA__["a" /* default */])(options);
  }

  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;

  if (Array.isArray(configsOrTrackingId)) {
    configsOrTrackingId.forEach(function (config) {
      if (_typeof(config) !== 'object') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('All configs must be an object');
        return;
      }

      _initialize(config.trackingId, config);
    });
  } else {
    _initialize(configsOrTrackingId, options);
  }

  return true;
}
/**
 * ga:
 * Returns the original GA object.
 */

function ga() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (args.length > 0) {
    internalGa.apply(void 0, args);

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'arguments\');');
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with arguments: ".concat(JSON.stringify(args)));
    }
  }

  return window.ga;
}
/**
 * set:
 * GA tracker set method
 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function set(fieldsObject, trackerNames) {
  if (!fieldsObject) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`fieldsObject` is required in .set()');
    return;
  }

  if (_typeof(fieldsObject) !== 'object') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `fieldsObject` arg to be an Object');
    return;
  }

  if (Object.keys(fieldsObject).length === 0) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('empty `fieldsObject` given to .set()');
  }

  _gaCommand(trackerNames, 'set', fieldsObject);

  if (_debug) {
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'set\', fieldsObject);');
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
  }
}
/**
 * send:
 * Clone of the low level `ga.send` method
 * WARNING: No validations will be applied to this
 * @param  {Object} fieldObject - field object for tracking different analytics
 * @param  {Array} trackerNames - trackers to send the command to
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function send(fieldObject, trackerNames) {
  _gaCommand(trackerNames, 'send', fieldObject);

  if (_debug) {
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', fieldObject);');
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with fieldObject: ".concat(JSON.stringify(fieldObject)));
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with trackers: ".concat(JSON.stringify(trackerNames)));
  }
}
/**
 * pageview:
 * Basic GA pageview tracking
 * @param  {String} path - the current page page e.g. '/about'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 * @param {String} title - (optional) the page title e. g. 'My Website'
 */

function pageview(rawPath, trackerNames, title) {
  if (!rawPath) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('path is required in .pageview()');
    return;
  }

  var path = Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawPath);

  if (path === '') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('path cannot be an empty string in .pageview()');
    return;
  }

  var extraFields = {};

  if (title) {
    extraFields.title = title;
  }

  if (typeof ga === 'function') {
    _gaCommand(trackerNames, 'send', _objectSpread({
      hitType: 'pageview',
      page: path
    }, extraFields));

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', \'pageview\', path);');
      var extraLog = '';

      if (title) {
        extraLog = " and title: ".concat(title);
      }

      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with path: ".concat(path).concat(extraLog));
    }
  }
}
/**
 * modalview:
 * a proxy to basic GA pageview tracking to consistently track
 * modal views that are an equivalent UX to a traditional pageview
 * @param  {String} modalName e.g. 'add-or-edit-club'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function modalview(rawModalName, trackerNames) {
  if (!rawModalName) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('modalName is required in .modalview(modalName)');
    return;
  }

  var modalName = Object(__WEBPACK_IMPORTED_MODULE_1__utils_removeLeadingSlash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawModalName));

  if (modalName === '') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('modalName cannot be an empty string or a single / in .modalview()');
    return;
  }

  if (typeof ga === 'function') {
    var path = "/modal/".concat(modalName);

    _gaCommand(trackerNames, 'send', 'pageview', path);

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', \'pageview\', path);');
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with path: ".concat(path));
    }
  }
}
/**
 * timing:
 * GA timing
 * @param args.category {String} required
 * @param args.variable {String} required
 * @param args.value  {Int}  required
 * @param args.label  {String} required
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function timing() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref.category,
      variable = _ref.variable,
      value = _ref.value,
      label = _ref.label;

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    if (!category || !variable || !value || typeof value !== 'number') {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'timing',
      timingCategory: _format(category),
      timingVar: _format(variable),
      timingValue: value
    };

    if (label) {
      fieldObject.timingLabel = _format(label);
    }

    send(fieldObject, trackerNames);
  }
}
/**
 * event:
 * GA event tracking
 * @param args.category {String} required
 * @param args.action {String} required
 * @param args.label {String} optional
 * @param args.value {Int} optional
 * @param args.nonInteraction {boolean} optional
 * @param args.transport {string} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function event() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref2.category,
      action = _ref2.action,
      label = _ref2.label,
      value = _ref2.value,
      nonInteraction = _ref2.nonInteraction,
      transport = _ref2.transport,
      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    // Simple Validation
    if (!category || !action) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.category AND args.action are required in event()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: _format(category),
      eventAction: _format(action)
    }; // Optional Fields

    if (label) {
      fieldObject.eventLabel = _format(label);
    }

    if (typeof value !== 'undefined') {
      if (typeof value !== 'number') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `args.value` arg to be a Number.');
      } else {
        fieldObject.eventValue = value;
      }
    }

    if (typeof nonInteraction !== 'undefined') {
      if (typeof nonInteraction !== 'boolean') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.nonInteraction` must be a boolean.');
      } else {
        fieldObject.nonInteraction = nonInteraction;
      }
    }

    if (typeof transport !== 'undefined') {
      if (typeof transport !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.transport` must be a string.');
      } else {
        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
        }

        fieldObject.transport = transport;
      }
    }

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'dimension'.length) === 'dimension';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });
    Object.keys(args).filter(function (key) {
      return key.substr(0, 'metric'.length) === 'metric';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    }); // Send to GA

    send(fieldObject, trackerNames);
  }
}
/**
 * exception:
 * GA exception tracking
 * @param args.description {String} optional
 * @param args.fatal {boolean} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function exception(_ref3, trackerNames) {
  var description = _ref3.description,
      fatal = _ref3.fatal;

  if (typeof ga === 'function') {
    // Required Fields
    var fieldObject = {
      hitType: 'exception'
    }; // Optional Fields

    if (description) {
      fieldObject.exDescription = _format(description);
    }

    if (typeof fatal !== 'undefined') {
      if (typeof fatal !== 'boolean') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.fatal` must be a boolean.');
      } else {
        fieldObject.exFatal = fatal;
      }
    } // Send to GA


    send(fieldObject, trackerNames);
  }
}
var plugin = {
  /**
   * require:
   * GA requires a plugin
   * @param name {String} e.g. 'ecommerce' or 'myplugin'
   * @param options {Object} optional e.g {path: '/log', debug: true}
   */
  require: function require(rawName, options) {
    if (typeof ga === 'function') {
      // Required Fields
      if (!rawName) {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`name` is required in .require()');
        return;
      }

      var name = Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawName);

      if (name === '') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`name` cannot be an empty string in .require()');
        return;
      } // Optional Fields


      if (options) {
        if (_typeof(options) !== 'object') {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `options` arg to be an Object');
          return;
        }

        if (Object.keys(options).length === 0) {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Empty `options` given to .require()');
        }

        ga('require', name, options);

        if (_debug) {
          Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
        }
      } else {
        ga('require', name);

        if (_debug) {
          Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('require', '".concat(name, "');"));
        }
      }
    }
  },

  /**
   * execute:
   * GA execute action for plugin
   * Takes variable number of arguments
   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
   * @param action {String} e.g. 'addItem' or 'myCustomAction'
   * @param actionType {String} optional e.g. 'detail'
   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
   */
  execute: function execute(pluginName, action) {
    var payload;
    var actionType;

    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
      payload = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      actionType = arguments.length <= 2 ? undefined : arguments[2];
      payload = arguments.length <= 3 ? undefined : arguments[3];
    }

    if (typeof ga === 'function') {
      if (typeof pluginName !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `pluginName` arg to be a String.');
      } else if (typeof action !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `action` arg to be a String.');
      } else {
        var command = "".concat(pluginName, ":").concat(action);
        payload = payload || null;

        if (actionType && payload) {
          ga(command, actionType, payload);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
          }
        } else if (payload) {
          ga(command, payload);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with payload: ".concat(JSON.stringify(payload)));
          }
        } else {
          ga(command);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
          }
        }
      }
    }
  }
};
/**
 * outboundLink:
 * GA outboundLink tracking
 * @param args.label {String} e.g. url, or 'Create an Account'
 * @param {function} hitCallback - Called after processing a hit.
 */

function outboundLink(args, hitCallback, trackerNames) {
  if (typeof hitCallback !== 'function') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('hitCallback function is required');
    return;
  }

  if (typeof ga === 'function') {
    // Simple Validation
    if (!args || !args.label) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.label is required in outboundLink()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: 'Outbound',
      eventAction: 'Click',
      eventLabel: _format(args.label)
    };
    var safetyCallbackCalled = false;

    var safetyCallback = function safetyCallback() {
      // This prevents a delayed response from GA
      // causing hitCallback from being fired twice
      safetyCallbackCalled = true;
      hitCallback();
    }; // Using a timeout to ensure the execution of critical application code
    // in the case when the GA server might be down
    // or an ad blocker prevents sending the data
    // register safety net timeout:


    var t = setTimeout(safetyCallback, 250);

    var clearableCallbackForGA = function clearableCallbackForGA() {
      clearTimeout(t);

      if (!safetyCallbackCalled) {
        hitCallback();
      }
    };

    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA

    send(fieldObject, trackerNames);
  } else {
    // if ga is not defined, return the callback so the application
    // continues to work as expected
    setTimeout(hitCallback, 0);
  }
}
var testModeAPI = __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */];
/* harmony default export */ __webpack_exports__["default"] = ({
  initialize: initialize,
  ga: ga,
  set: set,
  send: send,
  pageview: pageview,
  modalview: modalview,
  timing: timing,
  event: event,
  exception: exception,
  plugin: plugin,
  outboundLink: outboundLink,
  testModeAPI: __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */]
});

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mightBeEmail__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toTitleCase__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__console_warn__ = __webpack_require__(306);



var redacted = 'REDACTED (Potential Email Address)';
function format(s, titleCase) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__mightBeEmail__["a" /* default */])(s)) {
    Object(__WEBPACK_IMPORTED_MODULE_2__console_warn__["a" /* default */])('This arg looks like an email address, redacting.');
    return redacted;
  }

  if (titleCase) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__toTitleCase__["a" /* default */])(s);
  }

  return s;
}

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mightBeEmail;
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return /[^@]+@[^@]+/.test(s);
}

/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toTitleCase;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trim__ = __webpack_require__(462);
/**
 * To Title Case 2.1 - http://individed.com/code/to-title-case/
 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
 * https://github.com/gouch/to-title-case
 */

var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function toTitleCase(string) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__trim__["a" /* default */])(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeLeadingSlash;
function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (options) {
  var gaAddress = 'https://www.google-analytics.com/analytics.js';

  if (options && options.gaAddress) {
    gaAddress = options.gaAddress;
  } else if (options && options.debug) {
    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
  } // https://developers.google.com/analytics/devguides/collection/analyticsjs/

  /* eslint-disable */


  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', gaAddress, 'ga');
  /* eslint-enable */

});

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = log;
function log(s) {
  console.info('[react-ga]', s);
}

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gaCalls */
var gaCalls = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  calls: gaCalls,
  ga: function ga() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    gaCalls.push([].concat(args));
  },
  resetCalls: function resetCalls() {
    gaCalls.length = 0;
  }
});

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(463),
    now = __webpack_require__(1148),
    toNumber = __webpack_require__(1150);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(464);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(463),
    isSymbol = __webpack_require__(1151);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(1152),
    isObjectLike = __webpack_require__(1155);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(465),
    getRawTag = __webpack_require__(1153),
    objectToString = __webpack_require__(1154);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(465);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1154 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1155 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_icons_Feature1_png__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_icons_Feature1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_icons_Feature1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_icons_program_highlights_ph2_png__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_icons_program_highlights_ph2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_icons_program_highlights_ph2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_program_highlights_ph3_png__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_program_highlights_ph3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_icons_program_highlights_ph3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_icons_program_highlights_ph4_png__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_icons_program_highlights_ph4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_icons_program_highlights_ph4_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var LessonFeatures=function(_PreLoginPage){_inherits(LessonFeatures,_PreLoginPage);function LessonFeatures(){_classCallCheck(this,LessonFeatures);return _possibleConstructorReturn(this,(LessonFeatures.__proto__||Object.getPrototypeOf(LessonFeatures)).apply(this,arguments));}_createClass(LessonFeatures,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-p-ga':'',id:'LessonFeatures'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("custom.label.txt.2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-6 col-lg-3 featureSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__images_icons_Feature1_png___default.a,alt:'student listening to video lecture'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.rb("lessonfeatures2.label.1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.rb("lessonfeatures2.txt.1"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-6 col-lg-3 featureSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__images_icons_program_highlights_ph2_png___default.a,alt:'Bite-sized quizzes'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.rb("lessonfeatures2.label.2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.rb("lessonfeatures2.txt.2"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-6 col-lg-3 featureSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__images_icons_program_highlights_ph3_png___default.a,alt:' Diagnostic test report'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.rb("lessonfeatures2.label.3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.rb("lessonfeatures2.txt.3"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-6 col-lg-3 featureSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__images_icons_program_highlights_ph4_png___default.a,alt:'Granular report card'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.rb("lessonfeatures2.label.4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.rb("lessonfeatures2.txt.4"))))));}}]);return LessonFeatures;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (LessonFeatures);

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1158 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1159 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAA8CAYAAAD2ZeOZAAAAAXNSR0IArs4c6QAABGZJREFUaAXtVzlrVUEUfu4WQUXEPSQWLoiptBARLEQbQSws3BsLxcIFOxExWPoHLLQTtVAQ7O0UwcK1sNEkYCNxiQsW4vZ9N3OGyeTMvTP3Tt5LIAdO5sxZvvOd++bNfWm1Wq1/HdY36L8EWks6TZ79aw8g5GtN3rBIetceQAAa8qhVLr0HUF1rAAGo1b1hkfReBZyhOgMIQEMetcrd3v4Ay2IQXYCY/Jw5fm93gLdoVDmAD5CTXBWW1psDkDhjlQNoAFVNc8VDvfnEowYIAeQiWIZT1jtqgDKAssY5YlW9KweoAshBMoQR05sD8A3MXB4lfiesxADY5MxGbG/+9pEB+D6wA8QCZOZdwKX0HjfADEAQgEK73SK96/QdYFHM9M+dPMnX1meJLDSMaN/sxGZV6amfXmq+9OeAxVEpDGNLcLKvBeeZk51lGb9p8mVPZyJj009+Ip9uGXbskw/d8/69/gTNHnsNQ7Vyn/sYzPd9HuTotuk979/TXYD9q3YKO30MZmq+cQhMmr7nxz2WNjhiz3wbqKS36DT5flD+A/0NvZROP+5XZR1crWYxnDugC6FHoXLjyHoIvhiRfAsQU9Qkpw/FP6Bs/A06YuwLWE8Ye9iszHkKXQ/VJIm8dvem3t+vwIJNP5iV9m0obzwqbSElK2s0kbgt0JLER6JUV6rIu/krUciGX6Akugm6FOoLffyEmMNc1qyA+pJE3i9O3c9CwXcom/K8Vwn/wWYua1jrS0G+XbfNHnRnQwqfapWQNIXE9xVW4E8xRSCWw30OINLjbgLgPafutFcneBbYi2fbfjIkLmKdn4DKXNaQKDFcKci349jwBdRU+CJTxX4EarS58wwgpEfKsWGu1J31aIjfJnjxrNv9QPsJZdOuCGTeSMz9Ct2r5NcmvxtgD6E7FdCQaw4CclVq97tftwgOEmTNXD9oYownPfmTTv5VFkeK/5Lairo1Su1m+LqNX15SrPUl+cmvBcIvKP9TugKNua+RZuUFLGkqK38SyKVx04l/NvZLrJpIvQXUklxfPzYsumWc/GhXGztm2YAkdwC5Qk/Bfx5KbDlatJnLGk2iyB9A5UFTzV95LNpm9q+xDkPldb8O9nXoR+g1qHZW4bYP67BjC5kjjo+5IZF8C6Ylyrm7gSCPDO9bfvkoD6AEeQd9BGVMQLnyaGkiOYxdhrKOSptH0Y1jq4rNsYaStgW+EajkDDo5C2Dfd2Ic9Dh0F5Sv9j6oJoKlxbKSZwN+Ud9D2ZTn0JeNcGyHzvMDgX1byZPDcugd6DFuGopPvhd4VEr2Jz8Km++vS56/24egg1DeXFOGvBCXYThAN1T2MINic6wRTM0bkH4DgKU9aJS2+GiXCeNFjjXKsjPGpB9XXgQ9RuVSkHhZS5tjjbLsjDHpJ8QFugeGO4D4tVUwos6YBlDXx8Y+ccFyBxCftnaMfIi4kJQBZK+tHSPfq7HxfFU5BXm5V1lLe6oIyduXwlQhPYan/CMwxjlVNv8BIxobwQW2jcIAAAAASUVORK5CYII="

/***/ }),
/* 1160 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cambridge_home.1ef94f6a.png";

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/raffles_home.62351869.png";

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bbcnews.7b12dd56.png";

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/nasscom.2ef497b0.png";

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cambridge.dc01596d.png";

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/raffles.5f463943.png";

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/academyofsingapore.b6db8ea5.png";

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/teacherscount.849422f1.png";

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_icons_program_highlights_ph3_png__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_icons_program_highlights_ph3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_icons_program_highlights_ph3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_program_highlights_ph1_png__ = __webpack_require__(1171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_program_highlights_ph1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_icons_program_highlights_ph1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_icons_program_highlights_ph2_png__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_icons_program_highlights_ph2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_icons_program_highlights_ph2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_icons_program_highlights_ph4_png__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_icons_program_highlights_ph4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_icons_program_highlights_ph4_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var ProgramHighlights=function(_PreLoginPage){_inherits(ProgramHighlights,_PreLoginPage);function ProgramHighlights(props){_classCallCheck(this,ProgramHighlights);return _possibleConstructorReturn(this,(ProgramHighlights.__proto__||Object.getPrototypeOf(ProgramHighlights)).call(this,props));}_createClass(ProgramHighlights,[{key:'componentDidMount',value:function componentDidMount(){//console.log("Overall Features ",this.props)
}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'ProgramHighlights'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Program Highlights'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-6 col-lg-3 featureSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__images_icons_program_highlights_ph3_png___default.a,alt:'Diagnostic test report'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'heading-three'},'Digital Curriculum'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2000+ animated lessons, games and interactive tools and a Question Bank of 100,000+ problems.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-6 col-lg-3 featureSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__images_icons_program_highlights_ph2_png___default.a,alt:'Video lesson'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'heading-three'},'Online accounts'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Provide differentiated and personalized learning for students and track their progress through detailed Dashboard.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-6 col-lg-3 featureSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__images_icons_program_highlights_ph1_png___default.a,alt:'Man holding bow and arrow'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'heading-three'},'Work attachments'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'To gain an immersive exposure to digital content creation and technology skills (web and mobile apps)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-6 col-lg-3 featureSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__images_icons_program_highlights_ph4_png___default.a,alt:'Granular report card'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'heading-three'},'Teaching Methodology'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Incorporates Singapore\u2019s model method, and diverse approaches for an inclusive classroom')))));}}]);return ProgramHighlights;}(__WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ProgramHighlights);

/***/ }),
/* 1171 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_id_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal_video__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal_video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal_video__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_icons_teacher_resources_pdr1_png__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_icons_teacher_resources_pdr1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_icons_teacher_resources_pdr1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_icons_teacher_resources_pdr2_png__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_icons_teacher_resources_pdr2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_icons_teacher_resources_pdr2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_icons_teacher_resources_pdr3_png__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_icons_teacher_resources_pdr3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_icons_teacher_resources_pdr3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_icons_teacher_resources_pdr4_png__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_icons_teacher_resources_pdr4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_icons_teacher_resources_pdr4_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var TeacherResources=function(_PreLoginSessionCheck){_inherits(TeacherResources,_PreLoginSessionCheck);function TeacherResources(props){_classCallCheck(this,TeacherResources);var _this=_possibleConstructorReturn(this,(TeacherResources.__proto__||Object.getPrototypeOf(TeacherResources)).call(this,props));_this.state={isOpen:false};_this.openModal=_this.openModal.bind(_this);_this.goNext=_this.goNext.bind(_this);_this.goPrev=_this.goPrev.bind(_this);_this.swiper=null;_this.loadDataFn=_this.loadDataFn.bind(_this);_this.tabContentChange=_this.tabContentChange.bind(_this);return _this;}_createClass(TeacherResources,[{key:'goNext',value:function goNext(){if(this.swiper)this.swiper.slideNext();}},{key:'goPrev',value:function goPrev(){if(this.swiper)this.swiper.slidePrev();}},{key:'openModal',value:function openModal(someValue){this.setState({isOpen:true});this.videoId=someValue;console.log(this.videoId);}},{key:'loadDataFn',value:function loadDataFn(){__WEBPACK_IMPORTED_MODULE_4_jquery___default()(".img-content").empty();__WEBPACK_IMPORTED_MODULE_4_jquery___default()(".img-content").text("");}},{key:'tabContentChange',value:function tabContentChange(){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.img-container').on('click',function(event){event.preventDefault();__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.img-container').removeClass('tab-active');__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).addClass('tab-active');__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.main-content .img-content').hide();__WEBPACK_IMPORTED_MODULE_4_jquery___default()(__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.tab-active a').attr('href')).show();});__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.resources-slider .img-container:first').trigger('click');}},{key:'componentDidMount',value:function componentDidMount(){this.tabContentChange();}},{key:'render',value:function render(){var _this2=this;var videoId='';var params={slidesPerView:4,spaceBetween:30,loop:false,dots:true,navigation:{nextEl:'.swiper-button-next',prevEl:'.swiper-button-prev',nextButtonCustomizedClass:'.swp-next',prevButtonCustomizedClass:'.swp-prev'},breakpoints:{480:{slidesPerView:1,spaceBetween:20},640:{slidesPerView:1,spaceBetween:30},768:{slidesPerView:1,spaceBetween:30},1024:{slidesPerView:1,spaceBetween:30}}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'mtb resources-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Professional Development Resources'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container resources-slider'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.rb("tchr.resources.p")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_id_swiper___default.a,{className:'student-slider',slidesPerView:params.slidesPerView,breakpoints:params.breakpoints,loop:params.loop,spaceBetween:params.spaceBetween,ref:function ref(node){if(node)_this2.swiper=node.swiper;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Home - How HeyMath! really empowers Tutors and Teachers',className:'swiper-slide tab-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#tab1',rel:'nofollow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__images_icons_teacher_resources_pdr1_png___default.a,alt:'How HeyMath! really empowers Tutors and Teachers'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Thinking Mathematically'))),function(){if(_this2.isMobile()||_this2.isTab()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slide-content'},_this2.rb("tchr.resources.tab1"));}}()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Home - How HeyMath! really empowers Tutors and Teachers',className:'swiper-slide tab-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#tab2',rel:'nofollow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__images_icons_teacher_resources_pdr2_png___default.a,alt:'How HeyMath! really empowers Tutors and Teachers'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Low Threshold High Ceiling Tasks'))),function(){if(_this2.isMobile()||_this2.isTab()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slide-content'},_this2.rb("tchr.resources.tab2"));}}()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Home - How HeyMath! really empowers Tutors and Teachers',className:'swiper-slide tab-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#tab3',rel:'nofollow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__images_icons_teacher_resources_pdr3_png___default.a,alt:'How HeyMath! really empowers Tutors and Teachers'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Problem Solving'))),function(){if(_this2.isMobile()||_this2.isTab()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slide-content'},_this2.rb("tchr.resources.tab3"));}}()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Home - How HeyMath! really empowers Tutors and Teachers',className:'swiper-slide tab-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#tab4',rel:'nofollow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__images_icons_teacher_resources_pdr4_png___default.a,alt:'How HeyMath! really empowers Tutors and Teachers'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'CPA Methodology'))),function(){if(_this2.isMobile()||_this2.isTab()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slide-content'},_this2.rb("tchr.resources.tab4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,_this2.rb("tchr.resources.tab4.li1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,_this2.rb("tchr.resources.tab4.li2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,_this2.rb("tchr.resources.tab4.li3"))));}}())),function(){if(_this2.isMobile()||_this2.isTab()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slider-btns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-button-prev swp-prev',onClick:_this2.goPrev}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-button-next swp-next',onClick:_this2.goNext}));}}(),function(){if(_this2.isBrowser()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'tab1',className:'img-content'},_this2.rb("tchr.resources.tab1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'tab2',className:'img-content'},_this2.rb("tchr.resources.tab2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'tab3',className:'img-content'},_this2.rb("tchr.resources.tab3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'tab4',className:'img-content'},_this2.rb("tchr.resources.tab4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,_this2.rb("tchr.resources.tab4.li1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,_this2.rb("tchr.resources.tab4.li2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,_this2.rb("tchr.resources.tab4.li3")))));}}())));}}]);return TeacherResources;}(__WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (TeacherResources);

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pdr1.bbf99ef4.png";

/***/ }),
/* 1174 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pdr3.cacaeab1.png";

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pdr4.d7fcf770.png";

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_CorePage__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var Blog=function(_CorePage){_inherits(Blog,_CorePage);function Blog(props){_classCallCheck(this,Blog);var _this=_possibleConstructorReturn(this,(Blog.__proto__||Object.getPrototypeOf(Blog)).call(this,props));_this.state={lessonUrl:null};_this.setContentSize=_this.setContentSize.bind(_this);return _this;}_createClass(Blog,[{key:'componentDidMount',value:function componentDidMount(){//console.log("componentDidMount")
var me=this;__WEBPACK_IMPORTED_MODULE_2_jquery___default()(window).resize(function(){me.setContentSize();});this.setState({lessonUrl:me.getUrlFor("BLOG_URL")});__WEBPACK_IMPORTED_MODULE_2_jquery___default()("body").css({overflowY:"hidden"});this.setContentSize();}},{key:'componentWillUnmount',value:function componentWillUnmount(){//console.log("componentWillUnmount")
__WEBPACK_IMPORTED_MODULE_2_jquery___default()("body").css({overflowY:"auto"});}},{key:'setContentSize',value:function setContentSize(){var me=this;//
var userAgent=navigator.userAgent||navigator.vendor||window.opera;if(/iPad|iPhone|iPod/.test(userAgent)&&!window.MSStream){//
__WEBPACK_IMPORTED_MODULE_2_jquery___default()("#contentIFrame").css("visibility","hidden");setTimeout(function(){__WEBPACK_IMPORTED_MODULE_2_jquery___default()("#contentIFrame").css("visibility","visible");me.resizeCall();},1500);//
}me.resizeCall();}//
},{key:'resizeCall',value:function resizeCall(){//
try{__WEBPACK_IMPORTED_MODULE_2_jquery___default()("#contentIFrame").css({width:window.innerWidth,height:window.innerHeight-55});}catch(e){}}},{key:'sendDocHeightMsg',value:function sendDocHeightMsg(){var ht=this.getDocHeight();window.postMessage(JSON.stringify({'docHeight':ht}),'*');//parent.postMessage( JSON.stringify( {'docHeight': ht} ), 'http://www.your-domain.com' );
}},{key:'getDocHeight',value:function getDocHeight(doc){doc=doc||document;console.log(doc);// from http://stackoverflow.com/questions/1145850/get-height-of-entire-document-with-javascript
var body=doc.body,html=doc.documentElement;var height=Math.max(body.scrollHeight,body.offsetHeight,html.clientHeight,html.scrollHeight,html.offsetHeight);return height;}},{key:'render',value:function render(){var me=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'blogCont',style:{overflow:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{id:'contentIFrame',style:{width:'100%',height:'100%',marginTop:'55px'},onLoad:function onLoad(){setTimeout(function(){me.setContentSize();},1500);},ref:'iframe',src:this.state.lessonUrl,width:'100%',height:'100%',scrolling:'yes',frameBorder:'0'})));}}]);return Blog;}(__WEBPACK_IMPORTED_MODULE_1__views_core_CorePage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Blog);

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__public_css_Spotlight_css__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__public_css_Spotlight_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__public_css_Spotlight_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SpotlightBanner__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Spotlightyr__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Footer__ = __webpack_require__(307);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import PreloginLanding from '../../../views/common/PreloginLanding';
var Spotlight=function(_PreLoginPage){_inherits(Spotlight,_PreLoginPage);function Spotlight(props){_classCallCheck(this,Spotlight);var _this=_possibleConstructorReturn(this,(Spotlight.__proto__||Object.getPrototypeOf(Spotlight)).call(this,props));_this.callwinResize=function(){try{_this.setState({winHeight:document.querySelector('#spotlight-container').getBoundingClientRect().height,winWidth:document.querySelector('#spotlight-container').getBoundingClientRect().width});_this.setViewportRows();_this.state.rowsViewport.each(function(){__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).find('div.ss-left').removeAttr('style');__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this).find('div.ss-right').removeAttr('style');});_this.onUpdate();}catch(e){}};_this.updateData=function(){_this.setState({movers:document.querySelectorAll('.ss-row'),links:document.querySelectorAll('#ss-links'),thedivcontainer:document.querySelector('#spotlight-container'),offsetItem:document.querySelector('.ss-parent'),winHeight:document.querySelector('#spotlight-container').getBoundingClientRect().height,ssparentTop:document.querySelector('.ss-parent').offsetTop});_this.defineViewport();_this.setViewportRows();__WEBPACK_IMPORTED_MODULE_4_jquery___default()(_this.state.movers).css({'perspective':600,'-webkit-perspective':600,'perspective-origin':'50% 0%','-webkit-perspective-origin':'50% 0%'});__WEBPACK_IMPORTED_MODULE_4_jquery___default()(_this.state.rowsViewport).find('a.ss-circle').addClass('ss-circle-deco');_this.onUpdate();};_this.defineViewport=function(){__WEBPACK_IMPORTED_MODULE_4_jquery___default.a.extend(__WEBPACK_IMPORTED_MODULE_4_jquery___default.a.expr[':'],{inviewport:function inviewport(el){if(el.offsetTop+document.querySelector('.ss-parent').offsetTop<document.querySelector('#spotlight-container').getBoundingClientRect().height){return true;}return false;}});};_this.setViewportRows=function(){_this.setState({rowsViewport:__WEBPACK_IMPORTED_MODULE_4_jquery___default()(_this.state.movers).filter(':inviewport'),rowsOutViewport:__WEBPACK_IMPORTED_MODULE_4_jquery___default()(_this.state.movers).not(_this.state.rowsViewport)});};_this.onScroll=function(){_this.setState({latestKnownScrollY:__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#spotlight-container').scrollTop()});_this.requestTick();};_this.requestTick=function(){if(!_this.state.ticking){requestAnimationFrame(_this.onUpdate);}_this.setState({ticking:true});};_this.onUpdate=function(){var winscroll=_this.state.latestKnownScrollY-_this.state.ssparentTop;var winCenter=_this.state.winHeight/2+winscroll;var winHeight=_this.state.winHeight;_this.setState({ticking:false});var rowH=void 0,factor=void 0,t=void 0,o=void 0,val=void 0;__WEBPACK_IMPORTED_MODULE_4_jquery___default()(_this.state.rowsOutViewport).each(function(i){var mover=__WEBPACK_IMPORTED_MODULE_4_jquery___default()(this),rowL=mover.find('div.ss-left'),rowR=mover.find('div.ss-right'),rowT=mover[0].offsetTop;if(rowT<=winHeight+winscroll+50){rowH=mover.height();factor=(rowT+rowH/2-winCenter)/(winHeight/2+rowH/2);val=Math.max(factor*50,0);t=Math.max(factor*75,0);o=Math.min(Math.abs(factor-1),1);if(val<=0){if(!mover.data('pointer')){mover.data('pointer',true);mover.find('.ss-circle').addClass('ss-circle-deco');}}else{if(mover.data('pointer')){mover.data('pointer',false);mover.find('.ss-circle').removeClass('ss-circle-deco');}}__WEBPACK_IMPORTED_MODULE_4_jquery___default()(rowL).css({'transform':'translate3d(-'+t+'%, 0, 0)','opacity':o});__WEBPACK_IMPORTED_MODULE_4_jquery___default()(rowR).css({'transform':'translate3d('+t+'%, 0, 0)','opacity':o});}});};_this.state={latestKnownScrollY:0,ticking:false,movers:0,thedivcontainer:0,offsetItem:0,rowsViewport:0,rowsOutViewport:0,totalrows:0,links:0,inviewport:0,scollPageSpeed:2000,scollPageEasing:'easeInOutExpo',winHeight:0,winWidth:0,ssparentTop:0,isMobile:false};return _this;}_createClass(Spotlight,[{key:'componentDidMount',value:function componentDidMount(){//console.log("props ",this.props)
setTimeout(function(me){me.updateData();},100,this);var supportsPassive=false;try{var opts=Object.defineProperty({},'passive',{get:function get(){supportsPassive=true;return supportsPassive;}});window.addEventListener("testPassive",null,opts);window.removeEventListener("testPassive",null,opts);}catch(e){}__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#spotlight-container')[0].addEventListener('scroll',this.onScroll,supportsPassive?{passive:true}:false);window.addEventListener('resize',this.callwinResize);if(/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase())){__WEBPACK_IMPORTED_MODULE_4_jquery___default()(".ss-menubtn").hide();this.setState({isMobile:true});//alert("mobile");
__WEBPACK_IMPORTED_MODULE_4_jquery___default()("#custom_fc_button").css("display","none");__WEBPACK_IMPORTED_MODULE_4_jquery___default()(".ss-row").css("margin","0px 8px");if(/iPad/i.test(navigator.userAgent)===true){__WEBPACK_IMPORTED_MODULE_4_jquery___default()(".ss-parent").css("width","100% !important");__WEBPACK_IMPORTED_MODULE_4_jquery___default()(".ss-parent").css("max-width","100% !important");__WEBPACK_IMPORTED_MODULE_4_jquery___default()("#content_sub").css("display","flex");__WEBPACK_IMPORTED_MODULE_4_jquery___default()("#content_sub").css("justify-content","center");__WEBPACK_IMPORTED_MODULE_4_jquery___default()("#content_sub").css("align-items","center");__WEBPACK_IMPORTED_MODULE_4_jquery___default()(".ss-row").css("margin","0px 14px");}__WEBPACK_IMPORTED_MODULE_4_jquery___default()("#content_sub").css("bottom","0px");// $(".mdl-layout_container footer").css({'margin-bottom':'270px'});
}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()(".ss-menubtn").hide();this.setState({isMobile:false});// console.log("me entered in Desktop");
__WEBPACK_IMPORTED_MODULE_4_jquery___default()("#content_sub").css("right","20px");__WEBPACK_IMPORTED_MODULE_4_jquery___default()("#content_sub").css("width","170px");__WEBPACK_IMPORTED_MODULE_4_jquery___default()("#content_sub").css("margin-left","10px");__WEBPACK_IMPORTED_MODULE_4_jquery___default()("#content_sub").css("margin-right","10px");__WEBPACK_IMPORTED_MODULE_4_jquery___default()(".ss-links").css("display","block");__WEBPACK_IMPORTED_MODULE_4_jquery___default()("#content_sub").css("top","200px");// $(".mdl-layout_container footer").css({'margin-bottom':'50px'});
}//$("body").css({overflowY:"hidden"});
this.setTitle("SPOTLIGHT_title");this.setMeta("SPOTLIGHT_meta");this.setHeading("SPOTLIGHT_heading");}},{key:'componentWillUnmount',value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_4_jquery___default()("#custom_fc_button").css("display","block");//console.log("componentWillUnmount")
//$("body").css({overflowY:"auto"});
}/*  showmenu = () => {
    $(".ss-menubtn").hide();
    $("#content_sub").show();
    $('#content_sub').css({ opacity: 0.0, visibility: "visible" }).animate({ opacity: 1.0 });
  } 
  closeMenu = () => {
    if (this.state.isMobile === true) {
      $(".ss-menubtn").show();
      $('.ss-menubtn').css({ opacity: 0.0, visibility: "visible" }).animate({ opacity: 1.0 });
      $("#content_sub").hide();
    }
  }*/},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mdl-layout_container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mdl-layout mdl-js-layout mdl-layout--fixed-header topholder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'spotlight-container',className:'android-content mdl-layout__content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'sections m-w'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SpotlightBanner__["a" /* default */],{title:this.rb("spotlight")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Spotlightyr__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-parent numcontent flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'top-ss-container',className:'ss-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'a2019'},this.rb("2019_left1"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.rb("2019_right1")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left notrans'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2019_leftright4"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-65 ss-circle-deco'},this.rb("2019_left4"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right notrans'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2019_right4_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2019_leftright4"),target:'_blank',rel:'noopener noreferrer'},this.rb("2019_right4_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2019_left3_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2019_leftright3"),target:'_blank',rel:'noopener noreferrer'},this.rb("2019_left3_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2019_leftright3"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-64 ss-circle-deco'},this.rb("2019_right3")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2019_leftright2"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-63 ss-circle-deco'},this.rb("2019_left2"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2019_right2_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2019_leftright2"),target:'_blank',rel:'noopener noreferrer'},this.rb("2019_right2_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2019_left1_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2019_leftright1"),target:'_blank',rel:'noopener noreferrer'},this.rb("2019_left1_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2019_leftright1"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-62 ss-circle-deco'},this.rb("2019_right0")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'a2018'},this.rb("2018_left1"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.rb("2018_right1")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2018_leftright3"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-61 ss-circle-deco'},this.rb("2018_right4"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2018_left4_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2018_leftright3"),target:'_blank',rel:'noopener noreferrer'},this.rb("2018_left4_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2018_right3_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2018_leftright2"),target:'_blank',rel:'noopener noreferrer'},this.rb("2018_right3_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2018_leftright2"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-60 ss-circle-deco'},this.rb("2018_left3")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2018_leftright1"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-59 ss-circle-deco'},this.rb("2018_left2"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2018_right2_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2018_leftright1"),target:'_blank',rel:'noopener noreferrer'},this.rb("2018_right2_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'a2017'},this.rb("2018_left1"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.rb("2017_right1")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2017_left2_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2017_leftright1"),target:'_blank',rel:'noopener noreferrer'},this.rb("2017_left2_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2017_leftright1"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-58 ss-circle-deco'},this.rb("2018_left2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2017_leftright2"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-51 ss-circle-deco'},this.rb("2018_left2"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2017_right3_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2017_leftright2"),target:'_blank',rel:'noopener noreferrer'},this.rb("2017_right3_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2017_leftright4"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-46 ss-circle-deco'},this.rb("2018_left2"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2017_right5_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2017_leftright4"),target:'_blank',rel:'noopener noreferrer'},this.rb("2017_right5_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'a2016'},this.rb("2018_left1"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'2016'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2016_left2_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2016_leftright1"),target:'_blank',rel:'noopener noreferrer'},this.rb("2016_left2_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2016_leftright1"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-45 ss-circle-deco'},this.rb("2018_left2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2016_leftright2"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-44 ss-circle-deco'},this.rb("2018_left2"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2016_right3_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2016_leftright2"),target:'_blank',rel:'noopener noreferrer'},this.rb("2016_right3_1"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2016_left4_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2016_leftright3"),target:'_blank',rel:'noopener noreferrer'},this.rb("2016_left4_1")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2016_leftright3"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-43 ss-circle-deco'},this.rb("2018_left2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2016_leftright5"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-42 ss-circle-deco'},this.rb("2018_left2"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2016_right6_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2016_leftright5"),target:'_blank',rel:'noopener noreferrer'},this.rb("2016_right6_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2016_left7_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2016_leftright6"),target:'_blank',rel:'noopener noreferrer'},this.rb("2016_left7_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2016_leftright6"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-41 ss-circle-deco'},this.rb("2018_left2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2016_leftright7"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-40 ss-circle-deco'},this.rb("2018_left2"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2016_right8_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2016_leftright7"),target:'_blank',rel:'noopener noreferrer'},this.rb("2016_right8_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'a2015'},this.rb("2018_left1"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.rb("2015_right1")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2015_left2_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2015_leftright1"),target:'_blank',rel:'noopener noreferrer'},this.rb("2015_left2_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2015_leftright1"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-39'},this.rb("2018_left2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'a2014'},this.rb("2018_left1"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.rb("2014_right1")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2014_left2_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2014_leftright1"),target:'_blank',rel:'noopener noreferrer'},this.rb("2014_left2_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2014_leftright1"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-38'},this.rb("2018_left2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2014/The_gift_of_learning-AsiaOne_Edvantage_News_March_2014.pdf",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-37'},this.rb("2018_left2"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2014_right3_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2014/The_gift_of_learning-AsiaOne_Edvantage_News_March_2014.pdf",target:'_blank',rel:'noopener noreferrer'},this.rb("2014_right3_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'a2013'},this.rb("2018_left1"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.rb("2013_right1")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2013_left2_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2013_leftright1"),target:'_blank',rel:'noopener noreferrer'},this.rb("2013_left2_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2013_leftright1"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-47'},this.rb("2013_right2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2013_leftright2"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-36'},this.rb("2018_left2"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2013_right3_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2013_leftright2"),target:'_blank',rel:'noopener noreferrer'},this.rb("2018_left2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2013_left3_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2013/sa_apr2013.pdf",target:'_blank',rel:'noopener noreferrer'},this.rb("2013_left3_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2013/sa_apr2013.pdf",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-34'},this.rb("2013_right3")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'a2012'},this.rb("2018_left1"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.rb("2012_right1")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2012_left2_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2012/math_makers.pdf",target:'_blank',rel:'noopener noreferrer'},this.rb("2012_left2_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2012/math_makers.pdf",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-35'},this.rb("2012_right2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2012_leftright2"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-33'},this.rb("2012_left3"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2012_right3_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2012_leftright2"),target:'_blank',rel:'noopener noreferrer'},this.rb("2012_right3_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2012_left4_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2012/dc_feb2012.pdf",target:'_blank',rel:'noopener noreferrer'},this.rb("2012_left4_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2012/dc_feb2012.pdf",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-32'},this.rb("2012_right4")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2012/et_feb2012.pdf",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-31'},this.rb("2012_left5"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2012_right5_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2012/et_feb2012.pdf",target:'_blank',rel:'noopener noreferrer'},this.rb("2012_right5_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2012_left6_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2012/th_jan2012.pdf",target:'_blank',rel:'noopener noreferrer'},this.rb("2012_left6_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2012/th_jan2012.pdf",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-30'},this.rb("2012_right6")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'a2011'},this.rb("2018_left1"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.rb("2011_right1")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2011/digitlearning_aug2011.pdf",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-29'},this.rb("2011_left2"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2011_right2_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2011/digitlearning_aug2011.pdf",target:'_blank',rel:'noopener noreferrer'},this.rb("2011_right2_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'a2010'},this.rb("2018_left1"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.rb("2010_right1")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2010_left2_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2010_leftright1"),target:'_blank',rel:'noopener noreferrer'},this.rb("2010_left2_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2010_leftright1"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-26'},this.rb("2010_right2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2010_leftright2"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-25'},this.rb("2010_left3"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2010_right3_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2010_leftright2"),target:'_blank',rel:'noopener noreferrer'},this.rb("2010_right3_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2010_leftright3"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-24'},this.rb("2010_left4"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2010_right4_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2010_leftright3"),target:'_blank',rel:'noopener noreferrer'},this.rb("2010_right4_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2010_left5_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2010_leftright4"),target:'_blank',rel:'noopener noreferrer'},this.rb("2010_left5_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2010_leftright4"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-23'},this.rb("2010_right5")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2010_leftright5"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-22'},this.rb("2010_left6"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2010_right6_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2010_leftright5"),target:'_blank',rel:'noopener noreferrer'},this.rb("2010_right6_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2010_left7_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2010/SmartCEO.pdf",target:'_blank',rel:'noopener noreferrer'},this.rb("2010_left7_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2010/SmartCEO.pdf",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-21'},this.rb("2010_right7")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2010/inc_indiaEmagazine.pdf",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-20'},this.rb("2010_left8"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2010_right8_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2010/inc_indiaEmagazine.pdf",target:'_blank',rel:'noopener noreferrer'},this.rb("2010_right8_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2010_left9_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2010_leftright8"),target:'_blank',rel:'noopener noreferrer'},this.rb("2010_left9_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2010_leftright8"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-49'},this.rb("2010_right9")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'a2009'},this.rb("2018_left1"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.rb("2009_right1")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2009_left2_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2009/Confluence_09.pdf",target:'_blank',rel:'noopener noreferrer'},this.rb("2009_left2_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2009/Confluence_09.pdf",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-19'},this.rb("2009_right2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2009/IIMB_RoundTable%5B1%5D.pdf",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-18'},this.rb("2009_left3"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2009_right3_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2009/IIMB_RoundTable%5B1%5D.pdf",target:'_blank',rel:'noopener noreferrer'},this.rb("2009_right3_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2009_leftright3"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-17'},this.rb("2009_left4"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2009_left4_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2009_leftright3"),target:'_blank',rel:'noopener noreferrer'},this.rb("2009_left4_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'a2008'},this.rb("2018_left1"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.rb("2008_right1")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2008_left2_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2008/Economic_Times_June%206_2008.pdf",target:'_blank',rel:'noopener noreferrer'},this.rb("2008_left2_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2008/Economic_Times_June%206_2008.pdf",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-16'},this.rb("2008_right2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2008/Economist-mar08.pdf",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-15'},this.rb("2008_left3"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2008_right3_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2008/Economist-mar08.pdf",target:'_blank',rel:'noopener noreferrer'},this.rb("2008_right3_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2008_left4_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2008/timesofindia_may08.pdf",target:'_blank',rel:'noopener noreferrer'},this.rb("2008_left4_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2008/timesofindia_may08.pdf",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-14'},this.rb("2008_right4")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2008/Westport-Nov08.pdf",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-13'},this.rb("2008_left5"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2008_right5_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2008/Westport-Nov08.pdf",target:'_blank',rel:'noopener noreferrer'},this.rb("2008_right5_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2008_left6_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2008_leftright5"),target:'_blank',rel:'noopener noreferrer'},this.rb("2008_left6_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2008_leftright5"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-12'},this.rb("2008_right6")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'a2007'},this.rb("2018_left1"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.rb("2007_right1")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2007_leftright1"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-9'},this.rb("2007_left2"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2007_right2_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2007_leftright1"),target:'_blank',rel:'noopener noreferrer'},this.rb("2007_right2_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2007_left3_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2007/outlook.jpg",target:'_blank',rel:'noopener noreferrer'},this.rb("2007_left3_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2007/outlook.jpg",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-10'},this.rb("2007_right3")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2007_leftright3"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-53'},this.rb("2007_left4"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2007_right4_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2007_leftright3"),target:'_blank',rel:'noopener noreferrer'},this.rb("2007_right4_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2007/Indiatoday_march122007%28article%29.pdf",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-11'},this.rb("2007_left6"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2007_right6_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2007/Indiatoday_march122007%28article%29.pdf",target:'_blank',rel:'noopener noreferrer'},this.rb("2007_right6_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'a2006'},this.rb("2018_left1"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.rb("2006_right1")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2006/Raffle-Indian_Maths _Tamil_Murasu.jpg",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-56'},this.rb("2006_left2"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2006_right2_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2006/Raffle-Indian_Maths _Tamil_Murasu.jpg",target:'_blank',rel:'noopener noreferrer'},this.rb("2006_right2_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2006_left3_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2006/RI_exampapersonline-Nov06.pdf",target:'_blank',rel:'noopener noreferrer'},this.rb("2006_left3_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2006/RI_exampapersonline-Nov06.pdf",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-5'},this.rb("2006_right3")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2006/November_17_2006.pdf",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-6'},this.rb("2006_left4"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2006_right4_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2006/November_17_2006.pdf",target:'_blank',rel:'noopener noreferrer'},this.rb("2006_right4_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2006_leftright4"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-4'},this.rb("2006_left5"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2006_right5_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2006_leftright4"),target:'_blank',rel:'noopener noreferrer'},this.rb("2006_right5_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2006_left6_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2006_leftright5"),target:'_blank',rel:'noopener noreferrer'},this.rb("2006_left6_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2006_leftright5"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-48'},this.rb("2006_right6")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2006/Simplifying_problems in_learning_maths.pdf",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-50'},this.rb("2006_left7"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2006_right7_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2006/Simplifying_problems in_learning_maths.pdf",target:'_blank',rel:'noopener noreferrer'},this.rb("2006_right7_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2006_left8_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2006/BBC-july%2006.pdf",target:'_blank',rel:'noopener noreferrer'},this.rb("2006_left8_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2006/BBC-july%2006.pdf",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-8'},this.rb("2006_right8")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2006/New_York_Times-mar06.pdf",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-7'},this.rb("2006_left9"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2006_right9_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2006/New_York_Times-mar06.pdf",target:'_blank',rel:'noopener noreferrer'},this.rb("2006_right9_2"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{id:'a2005'},this.rb("2018_left1"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.rb("2005_right1")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2005_left2_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2005/SIMEX_Chennai.pdf",target:'_blank',rel:'noopener noreferrer'},this.rb("2005_left2_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2005/SIMEX_Chennai.pdf",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-3'},this.rb("2005_right2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2005_left4_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2005_leftright3"),target:'_blank',rel:'noopener noreferrer'},this.rb("2005_left4_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("2005_leftright3"),target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-1'},this.rb("2005_right4")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2005/Hey_its_math_the_singapore_way.pdf",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-54'},this.rb("2005_left5"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2005_right5_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2005/Hey_its_math_the_singapore_way.pdf",target:'_blank',rel:'noopener noreferrer'},this.rb("2005_right5_1"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-row ss-medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("2005_left6_1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2005/Singapores_racing_US_to_the_top.pdf",target:'_blank',rel:'noopener noreferrer'},this.rb("2005_left6_2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ss-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.getUrlFor("IFRAME_DOMAIN")+"/assets/2005/Singapores_racing_US_to_the_top.pdf",target:'_blank',rel:'noopener noreferrer',className:'ss-circle ss-circle-52'},this.rb("2005_right6")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Footer__["a" /* default */],{showContactus:this.props.showContactus,products_category_order:this.props.products_category_order,products_category:this.props.products_category,classes:this.props.classes,grades:this.props.grades,products_class:this.props.products_class})))));}}]);return Spotlight;}(__WEBPACK_IMPORTED_MODULE_5__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Spotlight);

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import PreloginLanding from '../../../views/common/PreloginLanding';
var Spotlightyr=function(_PreLoginPage){_inherits(Spotlightyr,_PreLoginPage);function Spotlightyr(){_classCallCheck(this,Spotlightyr);return _possibleConstructorReturn(this,(Spotlightyr.__proto__||Object.getPrototypeOf(Spotlightyr)).apply(this,arguments));}_createClass(Spotlightyr,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'content_sub'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Jump To')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'ss-links',className:'ss-links'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#a2019'},'2019'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#a2018'},'2018'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#a2017'},'2017'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#a2016'},'2016'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#a2015'},'2015'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#a2014'},'2014'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#a2013'},'2013'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#a2012'},'2012'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#a2011'},'2011'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#a2010'},'2010'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#a2009'},'2009'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#a2008'},'2008'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#a2007'},'2007'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#a2006'},'2006'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#a2005'},'2005')));}}]);return Spotlightyr;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Spotlightyr);

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1182);


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(36);

var ReactBaseClasses = __webpack_require__(476);
var ReactChildren = __webpack_require__(1184);
var ReactDOMFactories = __webpack_require__(1189);
var ReactElement = __webpack_require__(124);
var ReactPropTypes = __webpack_require__(1190);
var ReactVersion = __webpack_require__(1191);

var createReactClass = __webpack_require__(1192);
var onlyChild = __webpack_require__(1193);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(1185);
var ReactElement = __webpack_require__(124);

var emptyFunction = __webpack_require__(152);
var traverseAllChildren = __webpack_require__(1186);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(194);

var invariant = __webpack_require__(62);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(194);

var ReactCurrentOwner = __webpack_require__(479);
var REACT_ELEMENT_TYPE = __webpack_require__(480);

var getIteratorFn = __webpack_require__(1187);
var invariant = __webpack_require__(62);
var KeyEscapeUtils = __webpack_require__(1188);
var warning = __webpack_require__(96);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(124);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(124),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(441);

module.exports = factory(isValidElement);

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(476),
    Component = _require.Component;

var _require2 = __webpack_require__(124),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(477);
var factory = __webpack_require__(289);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(194);

var ReactElement = __webpack_require__(124);

var invariant = __webpack_require__(62);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAYAAAA8AXHiAAAAAXNSR0IArs4c6QAAJXBJREFUeAHtXQd4VFUWPkACIYQeIPSEBIHQpHdCEymCiKCuUgQ74oou2FhdhdVdbIiFxQ4oSlEUEQSk9yK9hBJCEkgIEBJCCIQUsv9/Jy+ZTCaZybRMwjvfd+bNvHLffWfOu+Wc/5wropMuAV0CugR0CegS0CWgS0CXgC4BXQK6BHQJ6BLQJaBLQJeALgFdAroEdAnoEtAloEtAl4AuAV0CugR0CegS0CWgS0CXgC4BXQK6BHQJ6BLQJaBLQJeALgFdAroEdAnoEtAloEtAl4AuAV0CugR0CbihBEq5YZ1Mq+SJHUHgFmB/cAC4PrgquALYmNLwIwF8EXwWfBJ8GHwMfAPsrjQVFRsG9jCqIOvLZzkHPg0+Az4CPgVOB7s1uaNiVYbEuoL7gbuDW4G9wPbQLVx8ALwOvAa8CUwldDZRvm3BvcBUjKVgc3QdO8ubO2BmH8/ls6wHbwDvALvdS+MOilULggkB9wD3BLNlKg3OQ6XKlBHvKlWlYs3a4lWpkniW9851TvrNm5KSlCjX4i5JUmxMrmMmP67i94/gOWD+SY6mLijwIfAIcJ2swqnc1cCJWb+NN6PrtWk/o3zlqrW1nWkpNyTl6lVJunBerl+Jl8yMDO2Q6ZYvyF7wRvBW8BYwn69IqSgUqzqeuDe4L7gXuCk4D5UpW1YatOsstYNbSs0mwVIjsIlUrlNPPMqVy3OuuR0ZaakSF35KLoWdlPPHDsm5/X/JhePsSfLQbuyZBV4Ezvffy3NV3h1sVR8FTwQ3B+dQqVJStX6D/U8tWjW8TLlymTkHcr5lZMoXUqpU/5w9Od/SUlIkMeasXDp1QmJDD8v5owfl7IG/8lM2PsN+MFs0ts7bwClgl5IrFIutD9/gAVnMriFPi1S2go/Ub9NB6oG59YNCeZS1TolQnlWUfPmSnN6yQY6tWS4RO/ly56II/JoOngtm62ItUaGeAr8KZuuriK1rQOce0vSuwRLYLUQqVK+hHXLINvXGdYk5tE/O7t8jZ/fukujD+yUjNdVc2VSqzeBV4D/Ax8FOJ2cpVhXU/B7wYPDdYA60cxEVqWH7ztKgfRep37aj1LyjmZTGn+Eqio+KkEO/LpIDvyyUlMQrxrel4F8E80+wRKNwwgyw1t2JT41a0vaB0dLq3gfEx9exylRQZTgMiIFyRf21U6L27pRzB/fJrXSzw8gIlLMii9dia/Yk7LeLHKlY7NKGgoeA2ULl0pJSpUtLnRZ3SkDXEAno1F1qN28lpT08cFrRUtqNG3Lg14Wy89s5khzHyWQ2/YpvE8Dns/fkfGmGr1+Cu2m7qtRrKF3GT5AWg4dJGc+y2u4i26ZeT5az+3bLmR1bJHzHJomPCDdXF04E/gT/nsWx5k6yZZ+9itUJNx0GHg6+w7QCGIxKI3QDgd17SyMolFclTvjckziO2btonuz4+jO5eS1JqyQH2s+Bv8vawS58CngaWGmPd7Xq0v3J5+XO4X9zixclq555NlcwRju9eb2c3rYRrdoOYQtnQuz+94B/yeKTJscL9dMWxaIyjcziBqZ3qx4QJEE9+kgguN6d7V3avZnWxZbfSRcvyPqZb0vo6uXGly/Ej7fA/wP3AgsG2tJ25CjpOeEfbv3CqLqafLCVDt++CUq2QY05OfY0Q7T/LQYvAZ8wc7zAXdYqFlujMeCHwIG5SoSA2cXd0eduuaNXf6nWMCDX4eL649SmtbLq369K8uW4PI9QtX5DGTztA6nXul2eY8VtR+atW2qWyec9sW6VxEea7TIP4rl+AC8AR1vzjJYUKxiFfAXmmCmHoEwUatP+g6VJn4GwK9XKOVaCvl1PuCwr/jVFTm+lHdJALYeOlLte+peU9a6g7SpR28tnwuT42pUS+ucKiYOpxoTYXXJMxkYm14DU5DyxpFhv44LXtItoT2o+aJgE3z0EyuSn7S7R25Skq/JRSGv1jOUqVpIXNvHlvT2ISnZ01W8Sumq5JJyNMH5o2uo+M95h+t3StMybF3iU85Kx3y+DkTLP+Ny0vJL9O9OsbdMlz8wJRQwMo5zd3YAlXqNyFSur4Ued5q2lPLwSjiSOl3s+86LiiF3bZOEztK4osqQ3uZye2kV5tmU8Pd1CqTgeoHsj5WpinlkNbWCchVK4rG9JoFvp6XJi/So5sHShsk0V4NZRj1u7RWvp/tQkGGR7OfzxabAuDFnUvMIU5qhzKdBLp09KLFwxF8NOCJvkxJho8Ln8jH7Zt6a9zAfddOXaddXLQIHUbdVOfBsFZZ9THL6c3rZJ1r73piRERajqenqUljYtaknzRtXFzzdnfHcx/rqEnomX7QfPy/kjB2XrnJlOUazCyswtFIt+vdjQI8qgFw03BZvdNLgsbCG2anRAk8/B3aERDZi0qXHm2rBDF6ECuiNRFuveny77lnyvqhfcqJpMGNlKhvcNkoreynSWp9oLV59QilXaw1NCJr6U53hR7CgSxTJ2P9DXFX14n6TDQGmOaFSt3qgxnLgN1YShIlwm3MdxnzHRT3YjMUGSLl2QxOizygF9OeJ0tv/syrlI2bdovuIK1X1hIR8ure97yK3MI5TLT5MeUy9WhfIe8u9nu8r4oc2ldOn851iXEq7LlI+2KlH0w2zVv1O2M8BYPC7/7hLFYtd2/ughidizTSL37JDog3uz/3DTJ/bFBIG+QzpwazVtrro003Os/W1AOIQJbTRndmxWvjS2aLRN7Zr/hez67kvVbXQe94xyfFtbrjPOuwVYzG+vPa+Uyr9OJVny7iBp6l/N4q3en79PriTdVArVdsQjFs931QlOU6yki7ESDvcBxwp0IXDAbUrsjmo1aQ54TCepB2UiqqF8ZfqvHUP02dWCiYTc/cm/A6d1UU6s/UOO/rFMKZlglkcbFbkh3vSB//yPVKlb3zE3L2Qpm2d/ICc3rBa/6t7y+6yh0rB2JYslUKHmLj+mzuv1/KsWz3flCQ5TLGXBxWA7bPM6xRdPhuZ9DhhWazZuKg07dgWyoYuCyHjBNuQq8vGtKe0eGqv4womj8tcPc5WSEQUQiXHdzrlzZMBUmu5cS+eArdo173MpV7aMLJ4xyCqlYg2Xbw6X6ynpQIh0Fj+07u5EdilWRhr+kN3b5QTetDB0N+Z8TvwziWho1KWnUijvqpabd1cIiC3l4Lfekx4TXoTjeTa66G1qYO+KexvfIxOt5p8z3hS+mFMf6yJtmtY0Plzg93W7z6rjTfoOLPC8ojhos2IRxbj4uXEw1iXkrjd9hzDWBfbso5zRNe8Ihr82/8Fn7otd/6tSrdpy92vTXX/jrDuyhWfrGYBx1cQHWxWqHvtCDV4VjkndjWxWLALJNKUiXLhhx2544++SoJ59HY6WdDehObI+BwE0JD0LpfL0KGN10bduZUrUBQO8p7p/I6uvc9WJNivWnZiqc2zCwIYgtE4l1SnrzD+C5oUzO7coc8J9vYMKdauryamSkZEp5XwqugWw0LTyNiuWZ/ny0mnMk6bl6b8LIQEGRtD+1rqxr9SsptyyhbjavU91T/Oze8vMYbWLg6uK1KJx9UKXWdHb4A+9mXxNaANzN9IVqwj/EW0WXcfXp9C1KFOmtNT2RSuHWeXVCzGFvt7ZF9jcFTq7Yiw/PfWmcsLSNUMHdNKFWCH4jhipdAR0GlNpIBqIbqB5g/GH5BpBTYrM4Glct/y+a2gFDziYbaEWgb5yPi4KzvrDUqVO0Rh286u3WykWFYZO6FMb/1QuoEtANuQTwpTf8+TZ71WpitRv11GCENBBexrNC+5CWjRPys10m6rUs11d+XNXlMKtN+03yKYynHVRkSrWDcTzMUSJsXDcXjwVqgyF+T2sd9XqCm9Fa70p5irtZgrMH1ck6eL5XH7IlKtX5NSGNYpZrl+zloBU3wMn9H0ujfsz90zecIaTYuOSzR22uO/ekEby+uwdwKr/IX0nvy6u9GJYqpxLFYuxblGI2o2CIzpi9zYoEmJDzaAytajomo2bSa1mzaW6fyC6tAbI1VDe0vOo44y0YfdJt9IFwHHCtqzLDuniTIy86dN3pXHPftL+kXHSoG0nq8p19El8LtLR8BxEaGHuEVC3sgzo2lBWbY+U3XCoM2LIXcipikVUA7u2SLRIkbu2Ah5zwGzX5uHlpcB4Ddp3Un9ybVjurc3RYE6QDO4g+8MnSeKsieiKU5v+lOMIErhyLkrlPaDTl8zgWYW8RHfpSvJr2kKYo+LI6csSn5gi1SrnhgJZU5fXxneQNTujFFqjGWIR3AU+7nDFuh5/WcKAFghHzBqjcI2CP7PlRGHWRZQPAXdM/FEHkFptvJF9kgO/ELZct1UbxSETpwDZcABAuu/k+JoVQmgNlW7J38dLnxdek46jn3DgnQsuii+PP6LCT29ZL0s3hMnjw1oUfIGZo/QtPvtAK/lk4UH5ZcoEGTNvqVt0iQ5RrLhwYJ42rlGoBianMO3eCI9hbgYKMaBzdwSydrCrRTIjX6t30W+pKVmfSa8qhMPexfMlFfag66Z+T6tLtf3EVggno2J98uMBefSeYLFlhvjmU51l5+FY2XP0tCyaMEYe/GxekQfR2qxYHC8RLBe6+nezQY4caDfq3ksCu/aSgC49ivxBzf31zAAT8twU6TDqMZXqiC2oq+mO3v2F4MZwYPy//OWIPAMYcmGprKcBbjP478vkGMAB340bISNmfilVG/gXtiiHnW+zYh38dbFs++LjXBWhgBqHGBzR7N7cFVeeq9L4QSiPMyJbTO9j7jdl1G/yGyq06s3Pd0pIu3pCnHthybdKeVnx8b0y8qUV8texMPn2kSEYNz4vbUaMEk+MYV1NtlnmUEvmZWDQKsPre2Ns8tSyjfL4ktUA809WXU1xUSpXC9zc/YhTb/+3cQq09+ArKyUq1oBaMHduQfuoXCs/GSZj72mmuvb1H74tswd1U2DGgq5zxjGbWyxm2nt21Q5n1Om2LJMTh7gzp1RCuLueWQrM+2BpBed0Yal8OQ/59JXe0iygmrzyyTYV3MqAleYD7y1sUXadb3OLZddd9YvzSIC5wu7/8EuFZ4u5lCz9nl4qsxcflPR0pkuwnjIybsnnPx+WaV/uUhcRH9f3xX9aX4CDziyxikXj6FUkhi1OxLHQ8A8+VyaPG3DzvPzxNukweqHMQ8AE8VcFUdL1VPl+Zah0GrtIJs/corpVTkrue292kYyxbO4KC3rIoj5GpfrmoUFq/Ddm/i9FXZ1C3Z82N3aLzC+29t1/SRgyvkycsVEmvb9Z2gfXlJZBvuJbNccDcfnKDTl0Kk72AqacltW6MefCXS+9WaQxhiVSsY6sMChTzJEDkgAre9V6DQr157rDyczPOn7hH3IcfkDClxmPSVsV2RxxskR4eOthD0rTfgOLPLtgiVMsum+OrmT6UAPRhdMFAanFkagszZB1mUzkB9OKX4Yxmo51jYjeqB4QCLdUa7ewuGv1KnGKxbwPBNCV9SwlqWmZcgz5nYqrYml/ErdELjApMLk4UIkbvB9ZsVTJfcroWlKjqgeS7h9X2WqKw59RkupYohSL+G9ir0hj76kuw3sbwvWP5U5UW5L+P7d9lhKlWEzOyjVourSqII0beMkjAw2uEfozdXKtBEqUYh3Nmg2OHmRQqG6tfRBw4Kmc5LHHj7pWsrf53UqMYtEYGomsNhy0P3iXQbGYV+pvdxvych5fo7dartR1t58VEnUanxV/R8FwcSIiU0mZtzKE8B3SBbZIgDkP7l4FSMycxxrZr6p8uOAiHLG/qtB/zq7oPuGSdEze5gHQIaO4uY9RxcyKxzVwdCe6EqvNHzn/gM1FOO9CYte/G3tfoW4wdnDu4M/OLX2kUd2yEh4dK+s+sC75Rx/41jrCHaKT7RJwa8Viy8GIGq0bY84MzvZ8vPEFhJhNqVjB8J2/69csK0N6VubXXPTNG/6ybNMVSUeug6vJt+Rm6i25cROZ/W7ckjTsOxl5E/F5aeoatlSV/Orkul7/UXgJuLVi8U8e9t9PZDcwXxtm/QeKkQG/2A356d1AaeBnPtGrORGEtKsIAF1Fc4fkp7Xx8tj0SHWMwa5D/zNL4fDNnuyEnezKmWmQmXtM1xssg/Ua2XUzxbi75BWzVgRurVjaQ7Bb8mvWQpa9MlH2HIuTdqNC5ce3A6Rfp0raKYXepqbdkpdmRcushYYcU/7A4g/590ypUK3wGChrb37h5DEsWrlbhZ9x5dersdHZqaAslcEAFEZ3V2vYSHwDGquFQomJ4z53pGKhWBQc85SO+2GF/PLyBIk+sFfufu6UTH+6jrw6zq/Qid3ORN+UB18Nh5JeV4N0Qni7PjbR4QN2RgCdwUquDDQJRy5W5mW1ldiacVUKMrMnasQ0Aky8xnSRjI/kMnfuQFYpFhy76ZIpYVh5p2lRVtqnRk15+PMfsezbO7J34VyZOjtGdh9Nlnlv+UtlH6seRX7ZkCDjp0Ui03AGZom+aKU+cji8hIsfHPj5B+UMN5fUlwG5jFpiwjTmn2cMZPkq1cTTNMU48o8xfI7dJHNXXEGacQbicoUurdtkGgLyvsXfqb+GcQd8CalozPPq6GVQrP3/Lf0bf6Cgp5HM/8dSpWUTZvNzrS3YWecxtJ6rbzGE649pr2BQnigdxx6XAwuCpbxXwWa5GXNj5ZVPo1XVGnboKkPe/sihYfZ0gO/49n/Iy7ot1+PThMFg3ADkYb0DwSb2Rs8wWQoVLGrPTpVm/BzSmzN8jRQHpSYrRUOomwq7A5xGhd216egy0J8lxaLjTUOVjVU1d5OP4AFDpSJmbwvGj5Qz0alqxmepaofCDBlqWgy5Xwa9McNhi3Qysvr3NybLuQM5K2FwoUy2GMHAmjfpO8ChkBYuwl4LuV3JHR4ZryK9acfjWtDEbTEPhlrZAy3BxRPHFDMEn0HBdVreqVa7bYT1dpim3FlkSbGcdV+HlMtlTUi92/vkMjvkV/hdnSrKD6viJRMGVkcubL77u6+ylYrRzS2HjJB2iLrxBU7KFcRnYZoAMrMs0oBMkGMEMlobpzbgmI9KR9706XsqyopIVeLi2YI7MkysWCsW0x2R7g2xbtGBAV0MNq7w7ZvVW+4o5Wo5dIScDz2E7rkdsF9PF3lyX3oRGJ5H5sIJNGmwJWNWH+Y8ZVdJ4mSCY0Gyp1d5Q1eNAFoqmr3rdxdbxeLbx3WNSaaKtWZHokz76ryCzbzwSK3sWaMfHNLtmnkDH56gVsqq27qtut7eD7YUY+fnoFbtLc/R19Nl1Tikn2KWzYkAFx1naH/knu1qiT6iQrQkKWx173t/jl1BvAWPdh34hIQLz+gQ5LDgSb59nDG1D/aWurC4k65dz5Cn3o6EKSJMth1Mln98FC0DYJaIuZSa/SSDuhlsX+HbN2bvu92+0PbFhdJHfvyNPL9+vwz/8AvhksScmZKYzZlmDXvIkmIxNpsr/9htZuAyaUyNeOR3A8LTnkrz2pOwDZG01mrT3iRp+dAx+eKXOOVc7oixRgW4hNbsTJJW2E8zA2lgV0N3eHrrRvX7dv9gzjHm5x/85rvy3J+75aH/fY8FFd5GaL59Cz5ZUixm8voerpWVWJrD5lCXhLORasUv/olsepnJzx7iMiFhm9apIgZ0qYTQqLPS++mTEhGTqkK+xv34uzCTzGOL/pAgdAGXEzNk+JRweXx6hAQHeAH9UEZijx+R5Pi8K9TbU6/ifi3HnAz3bzPiYbuzAVkaYyn/BvroAJFS02wVnBaOxes5Y2FeqjYjbX8juPIqB57EXo16/YycgBOZU2la0DuNfSp7xseMN8y6sh+DU+Yx+HrZZdmIlq12dYD/kOiM1vCWMD24GzEih0niYJRWq6HRT8hVY7lWY3GB81hSLLtlztZFC8caM7iazF8RL8fXrrRLsbTZIKNwqFQ0At4z/UO1spi5Cre5/2HYlDrL8n++IKeRZE0jLifnKsXizIyrfJ3dt0euXYrFCmSPKv+nVhfj7YZZ/5WDS3803qW+8+VhqBez9tVCLlUaiWsHtyryGMI8FcUOpysWU0VyddNa1T3k48n1ZfHaBGXIYzdkq8OXGQNJpdB0dxk/Qbo9/lyeZLfqBKMPOm9HffOTbP1iluyEdZyrbXHqzThER5kdjG6nvl6Lu6RmWsTi03ZknAGardL9GDSbI6aAMqdYnAkzypvMNRdJNAvQzKHSbCI7IhcPddbzmKtrfvucrliHl/+s7v3w3dWkckUPGYTB89INV+TkutU2t1qEt5SCj4lrC3Kqby3RHRTy7GQ1jWbrRT8eWxJHZhtWCosUmft/XqAyHPK3KVXCQuh3ohXNjxjNzDxjtJ5z5ss4SSppwtkILEkcplYLo8mAiFk+w+mt6xWzPENiYDqlOyEHazfVmhdF9+lUxaJPi5HIpDFZyE5ChalY9nSHD3zyrSrT1g8aDp9YulZNqx2lVFy7kWPJXfPmwEl8JlfVmDkwsEdvtWZjA7h5rMFWqXOy13Zslqs8/rieEK+6Vi5JzDRFmtGTPkNjRfPCirXMVMhAV6bqrOKidANOVawwGOBuoslvEegldzbB8hyge3pUFm84ixn4QOgxPftFQfS3kR1B57EyxLJXnlNdvlYejZJN+yPHFexDdVu1dfigm4rHNJNkEpMKR+3bpSzsnHlrdqgUzMC5XDGZRHQsF1IIRIZozgDLAvvvDLJJsW6wC0ETrRHHCxrRuJaBloq0f8kCtR09KAcjRFgx4cOL1iSo7iIYKaTpTmBKbg5OGdDgzgtnqgcy+Tj820/ZSuWDmRvTB3HZPT6Lq4g4LK5Ooa1QwVkzc+lzSWKiLohSJV2Ff5XjNzLlTXgNXTjkyuiiHUWlLBQ0E8cnUUAvbDbMptiF/fryRNW/W7hWHQa6WM6uaCl1auRAiX9elyAjXs7fsssxAd94oiaJUfLCGjkPfPqtzYN9a+qZ3zl8aT4Kaa0OG8vB+HyOfTZ9+r5qmWhGcVRLaHwPe79zsQYu+s4JC/2G6SkpeYrkwJ8tYFMkIdEWN9BOMpYD9k0Cz9KOmdsWusXieIEhU2yZSJUqlJaAujldilfZ0uJVzqCv/BzcvXIupeI1g7pVlqFotSJjUyUFQQ0pqZnKHZOWbgh24IDXOD88YwZTEhOLRLFYX0tUtb6/DJvxqaXTivQ4F3knM9dpGpSKEBsuG0x/IVsxEqE35C3/mylD35klhCbZSoVWrPptOsiob39GsvpnJBGIRqwgK68/Vlvu72sIDLWmIgTkLfswKN9TF/8ZL+PeikRWulvZKE/ab3RyjAQIj2GWaJUp+tXpmGUeg0F2rYJQq/hM3IZ5MOyhQisWb+aHJvPR739TBsdweMnZrU1Gdpf/TqwrZcpY6l3zry5brJc/PiczfzCMB5yB8sz/7rfvEQL+yITY0P3Grp1oV3vIkq8w37LLYxo7ctbXag0ajLbl/e8uSL8JJ+XC5bR8rynoQBS6xZ5PHFdKxTFWtyeflwdnz3codLig++vHDBKoWr+hQpjaO4GyWbFYDSoA/XNUMFqAN+69Jm0RmrXzUOGa0eWbr8idDx9DGsTrsPFUl5GwU/V4epJbWJB1hbNNAnYplnZL2kQeXbAczWlzYJ/SpOeTJ2XucuuQA69+ek6GvnhaEq5mqDCmcQtXKEOiVra+LZ4SsGmMZe5Rq9Stj0H9Txh3TZKT61cDSRAnjw5R4Ahzp6t9DBp9D10oqTPyhHK9PXfwc6kKOeGDyA4uMM5wLUbZJMBCzxnvjSvx4CvwWxqSnWi3ZtISFQkNYyhXAaGdqRrWOKwR2Fi5amiHcldymGLxATnboDmC1L+zAampfuTzUdaztHRt5SNb9l9TLoeSqFSMCSSKgkwotbEZJR+xZO/W/IQCJTQlDkO4UGhQzz6qpacj2tqFQk3LcsZvhyqWAuDBNkLSkJ2WKj2wayWlWBR8w6yFKy1d4+7HiUI4BTkcWrYES5gAQYGWypQYa1ilXn21ciyt9d7Iz2C6+Gc6op/pZKYTmgutc7amKSZtfRdOwO4EJrE8oiK0YNWiVjSHKhZXU09C0x6AtEGtGuf2QW07kCQrtibCLOGXK38VjaWvfRaj3ug+L041lX+x+k1kLBfYZLBoMtAIxkSrPc0nDGqghZt2OVu6MqIcGCvIPBBsAYnxIuSbkBx+J2//+jOlaMRr8Z70CXIxLUbvuIoceqdTmw05Be7tmROORcv6K59Ey8eLLqr1MecB6Df/LX/p29HQVba+g8EQnhKN5v5KzFmpUqe+q57dYfehJXvHN5/JXz/OzY5IZuFUJgarckldriRrukC6LRVgaicf3xBp1C1EpRlnIroYYN4YXML1tmOOHFRKRkXTYgi3fv6RgtMQ7OjfuYcyJ9Cs4ExyrGJlZSzWusGdh6/Jo29GZEOHfTHojIHLoN+EU/LiIzXlnWfrSjm4gIhbJ2yYUGFGjxQ32jpnploUVKs38yd0eHi8NB80LE/3pp3jqC3RCYTDkEkKqbr/L4MDGigHWtX5RhNOo6zrWQlFmDMisDut772VI9q0G7a3fg5TLCas4GyHgQodm3vL1M+iZcb8WEErnQ0dJqR2F0K9t8z+UKVvXLs7SRZMD1C+Q4NibSyWilULi4bTSExzS49nXlCQFHsNjLb+sXTeszUjk4jbIoyG63PTAc2hComo3r0L5ykmuoRpnBh4EoTIaFuRvargrA+HKdbJrNYqoE456Tr+hBxEgjRCh7s+kRs63BnBDkxQ8dtrk5BELUzajwmVqeP94ApCBA9CwgkOdEd0gLHQTL8HDxiCP6WvQmJwtuZORNxWM2RFJJOYCYfgQIa/nQNAkBMNBqsyjoDM+hM/NmDqO1hSuLHNj+IwxVJRJajG3tDrqjKEXTDAwRx0mG/2uB9+l/UfvSP7Fs2XN+YY3qKMjBsYK+zCGMA+P5XN0rDjQmcB5uyoktlL2WuQO456XHWbxGoplAPgzcmX41QsACcAjIoucsWirYbarwhdQsfRj0vPZ/5R4PiCfXr/l99SffzKaS9lz6Lo1C6OimX2X3Tznew2NRQqzRcxyFDNQGDCaJiRxx5ySIt1DXYWVowzjUH/elcZ7KytFAeQDCxdiVxXzFTHabROrpeA6gKRy8JR+SwcolhsWp/+bZPQ0GfL7EILLGWiimoNAlwvVf2ODpeAQxSLtXJE9IcCnjn8EfUCi0IC7jWFKQoJ6Pd0igR0xXKKWPVCHdYVOluUDAhlWH5qcrJyxGohZqb3pYe/rLcPgIdMvF/NLWE4tB3RcMnIFz5P/s/iDbeQD9wxFRX2v6iMrqYytua3WykWY+EYRcx009wyjDw+6oyyEmtRQdY8lHYOPf7MkcXFxpm7gclDuBAB8d22OIC1cq3dMiDhPHx3F0+FqugXeido8aZScRZdWCqHVSo482ZUUJW6DVT25WoN/OHQDlJZaQpbnjPPLzLFosLQbqJCjmBiuHTqhAK8OfJh6YhlAlwynbQaMTiWYfb0k9GfZ03Iu3atpS1fCuariNi1FStQHLFJgfK7B6PKiSAhm1LFWnWkRuMmhmzKQE/Ua90Os/Sapqe57LdLFIutTczh/cJ85DSkxhw9iDhBi8nXEFgmTMoeDibSLR5MuCnDrhPBhtza+GJCFfCb8AoyQ3v9wfRNcOsJVsGaEVgxgrx+5tsKB8ZMx037DbSpJWOXxkyFh5YtVplgeA8zxAhRPscpcBSY7gamGaQg8kaPYifIB8wUhISCMBcBUZSB4CBwLnhu0gW8QODwrEw8OK5Qp3UAnanX2pDo1pWZaJyiWAS2nUdyNC73EQUHaDSUSltJgQ9sQnBTyxHwQTCto6HgE2AqlG0hP7jQDBHHC2+xdAQTCtAX7McuSVMyLjtHVELbB8dIOaweYYmYe2LHt7OFIfYqr3ruC8Lwcz14G5huCSpUOthRxBeoEZhpPIOzuA22fIkUcWhhnLdBy0RDfBYThXBo4CxymGIR5UgPOqEZ9KJrKyWYqTjf1h1g9k3bwfvBjlQgFGeWmOF2XxbPwbYMuB94RBZXYWIN5j/fNf8LFX7W7oHROJSXOHba/uUnCn/FgbgRxeL79+CfwLuM9jvjazIKZZ9o2i9S4TplcVdsO4NV62aaiYbpoJgghOBDoneteZlQllVkl2JdRmAAIbj0ijPBmkLy5b1tBHatAm8GU5Eiwe5AbClXZ/HfsR0FngQOJhx43fvT5OCvi6TPC69hVw7R2b76ndeRlc8QBJJ1hM/1Hvh3sCNbpaziC7WhwrGlJGvUHF+6gHuB+4PZpapEIYd/W4IWd4kaAhDW3BiJbhv36m93FqBSvEEBNBPHciUFIezi5PpVEoq8V3FYGs0MccywJovXYusuimSmqnl2UR7Dwf8FB+U5mnfHXuyaAt6Q95Bb7+GQgEOBAeBeYC9wDgFIUKd5a2ly1yCFgCWqt7BJQXIKM/+NipUJIFhmz2cnZ9Zo3JQDanPM8dAH4D5gu1pBXO8OxEH+VDAnCOaely/PE2BLLyZOcXti1zkE/BWYuQ1yP2+pUpnAZ2X2mPAP4/3P4zy7SCkWSjAuVPvOvv3f4LZ23cG9L2YXwufUnpnbTeD64JJIpfFQvcEfgiPBxs9t/N1uxXrfpHDObKaBOfu4Xag8HvRb8BnwDDAH/bcDsTXuDmZPFA02VqyJ+G0XNcPVnOGw5eI0XafbUwJUMrZknE0vAPuBddIloEtAl4AuAV0CugR0CegS0CWgS0CXgC4BXQK6BHQJ6BLQJaBLQJeALgFdAroEdAnoEtAloEtAl4AuAV0CugR0CegS0CWgS0CXgC4BXQK6BHQJ6BLQJaBLQJeALgFdAroEdAnoEtAloEvAqRL4P4zyIQeG2fR9AAAAAElFTkSuQmCC"

/***/ }),
/* 1195 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1198 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1200 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DownloadButton=function(_PreLoginPage){_inherits(DownloadButton,_PreLoginPage);function DownloadButton(props){_classCallCheck(this,DownloadButton);var _this=_possibleConstructorReturn(this,(DownloadButton.__proto__||Object.getPrototypeOf(DownloadButton)).call(this,props));_this.productDetails=localStorage.getItem('proDetail');_this.getPDF=_this.getPDF.bind(_this);return _this;}_createClass(DownloadButton,[{key:'getProductDetails',value:function getProductDetails(){//console.log(JSON.parse(this.productDetails));
if(this.productDetails!={}&&this.productDetails!=undefined){return JSON.parse(this.productDetails);}}},{key:'getPDF',value:function getPDF(){window.open(this.getUrlFor("GET_MOCK"),"_blank");}},{key:'render',value:function render(){var martop=this.props.className||'';var classname=this.getProductDetails()[this.props.id].ClassName;//console.log("classname ::: ",classname)
if(classname=="Class 10"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'DownloadButton',className:" "+martop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'col-12 text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',id:'download',onClick:this.getPDF,className:'btn btn-primary dwnldBtn widthmax','data-ga':'Personalised Learning Program - Class 10 - Download Mock Exam Paper','data-category':'PLP','data-label':'Download'},this.rb("mock.download"))))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{display:'none'}});}}}]);return DownloadButton;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (DownloadButton);

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_ProductConfig_json__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_ProductConfig_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_ProductConfig_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var Experience=function(_PreLoginPage){_inherits(Experience,_PreLoginPage);function Experience(props){_classCallCheck(this,Experience);var _this=_possibleConstructorReturn(this,(Experience.__proto__||Object.getPrototypeOf(Experience)).call(this,props));_this.state={error:null,isLoaded:false,items:[],ProductList:[],pro_detail:[],products:[],self:[],plp:[],products_details:{},products_category_order:[]};_this.grades=_this.props.grades;_this.productClass=_this.props.products_class;_this.productDetails=_this.props.products_details;_this.products_category=_this.props.products_category;_this.productClasses=_this.props.classes;_this.state.products=Object.keys(_this.products_category);return _this;}_createClass(Experience,[{key:'componentDidMount',value:function componentDidMount(){var _state=this.state,products=_state.products,self=_state.self,plp=_state.plp;this.grades=this.props.grades;this.productClass=this.props.products_class;this.productDetails=this.props.products_details;this.products_category=this.props.products_category;this.productClasses=this.props.classes;this.state.products=Object.keys(this.products_category);}},{key:'getProdDetails',value:function getProdDetails(){//console.log(this.state.products_details);
if(this.state.products_details!=={}&&this.state.products_details!==undefined){return this.state.products_details;}}},{key:'saveID',value:function saveID(grade,proID,link){var products_details=this.state.products_details;var me=this;var callBackSuccess=function callBackSuccess(result){if(result!==null){me.setState({products_details:result}),//console.log("Footer:::",me.getProdDetails());
localStorage.setItem('grade',grade);localStorage.setItem('product',proID);localStorage.setItem('proDetail',JSON.stringify(me.getProdDetails()));window.top.location.href=link;}//console.log("response : ", response);
};var callBackFailure=function callBackFailure(response){me.setState({isLoaded:true,error:"Error in Footer PRODUCT_JSON"});console.log("Error in Footer PRODUCT_JSON in Grade");};var formData={"levelId":grade};new __WEBPACK_IMPORTED_MODULE_3__util_HmAjax__["a" /* default */](this.getUrlFor("PRODUCT_JSON"),formData).post(callBackSuccess,callBackFailure);//console.log(grade);
//console.log(proID);
}},{key:'renderFooterProduct',value:function renderFooterProduct(product,grade){var _this2=this;//console.log(product,", ",grade,", ",this.products_category);
if(this.products_category[product].hasOwnProperty(grade)){//console.log(this.productClasses[grade].ClassName);
var restricted="";if(this.GradeRestrictionManager.isGradeRestricted(grade)){restricted="restricted";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6 plr-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Home -  Product - '+__WEBPACK_IMPORTED_MODULE_4__config_ProductConfig_json___default.a[product].ganame+' - '+this.productClasses[grade].ClassName+' - Direct link',onClick:function onClick(){return _this2.saveID(''+grade,''+_this2.products_category[product][grade],__WEBPACK_IMPORTED_MODULE_4__config_ProductConfig_json___default.a[product].url+_this2.products_category[product][grade]);},className:"mbt-5 classbtn "+restricted},this.productClasses[grade].ClassName,function(){if(restricted=="restricted"){return"*";}}()));}}},{key:'checkRestrictedGrade',value:function checkRestrictedGrade(product,grades){//console.log("grades:::",grades, ", ",product);
//console.log(this.products_category, ", ",product,", ",this.products_category[product],", ",this.products_category[product].hasOwnProperty("11"));
var restrictedAvailable=false;if(grades&&grades.length>0){for(var i=0;i<grades.length;i++){if(this.products_category[product].hasOwnProperty(grades[i])){if(this.GradeRestrictionManager.isGradeRestricted(grades[i])){restrictedAvailable=true;break;}}}}else{restrictedAvailable=true;}return restrictedAvailable;/*if(restrictedAvailable){
  			return (<div className="col-12 text-center smallinfo">
  						*Available only for desktop
  					</div>
  					);	   
  		}*/}},{key:'render',value:function render(){var _this3=this;var _state2=this.state,products=_state2.products,self=_state2.self,plp=_state2.plp;this.grades=this.props.grades;this.grades_order=this.props.grades_order;this.productClass=this.props.products_class;this.productDetails=this.props.products_details;this.products_category=this.props.products_category;this.productClasses=this.props.classes;this.state.products=Object.keys(this.products_category);this.state.products_category_order=this.props.products_category_order;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'experience mtb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.rb("custom.label.txt.2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,this.rb("experience.heading")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prod-list clearfix text-center'},function(){if(_this3.checkRestrictedGrade(__WEBPACK_IMPORTED_MODULE_4__config_ProductConfig_json___default.a.SPL.productKey,_this3.grades)==false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pro-box pro-box-home float-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'e-box e-h2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/e1.png',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Self-Paced Lessons'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'h-line'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'To build a strong conceptual foundation'),function(){if(_this3.state.products_category_order.indexOf(__WEBPACK_IMPORTED_MODULE_4__config_ProductConfig_json___default.a.SPL.productKey)>-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 mx-auto no-padding row notopbottommargin classlistPool'},_this3.grades.map(function(grade){return _this3.renderFooterProduct(__WEBPACK_IMPORTED_MODULE_4__config_ProductConfig_json___default.a.SPL.productKey,grade);})));}}()));}}(),function(){if(_this3.checkRestrictedGrade(__WEBPACK_IMPORTED_MODULE_4__config_ProductConfig_json___default.a.PLP.productKey,_this3.grades)==false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pro-box pro-box-home  float-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'e-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/e3.png',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Personalised Learning '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'h-line'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'To build confidence through continuous progress'),function(){if(_this3.state.products_category_order.indexOf(__WEBPACK_IMPORTED_MODULE_4__config_ProductConfig_json___default.a.PLP.productKey)>-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 mx-auto no-padding row notopbottommargin classlistPool'},_this3.grades.map(function(grade){return _this3.renderFooterProduct(__WEBPACK_IMPORTED_MODULE_4__config_ProductConfig_json___default.a.PLP.productKey,grade);})));}}()));}}(),function(){if(_this3.checkRestrictedGrade(__WEBPACK_IMPORTED_MODULE_4__config_ProductConfig_json___default.a.EXAM_PREP_CBSE.productKey,_this3.grades)==false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pro-box pro-box-home  float-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'e-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/e2.png',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'CBSE Exam Prep'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'h-line'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'To achieve your best in the board exams'),function(){if(_this3.state.products_category_order.indexOf(__WEBPACK_IMPORTED_MODULE_4__config_ProductConfig_json___default.a.EXAM_PREP_CBSE.productKey)>-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10 mx-auto no-padding row notopbottommargin pti-15 classlistPool'},_this3.grades.map(function(grade){return _this3.renderFooterProduct(__WEBPACK_IMPORTED_MODULE_4__config_ProductConfig_json___default.a.EXAM_PREP_CBSE.productKey,grade);})));}}()));}}())));}}]);return Experience;}(__WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__["a" /* default */]);/* unused harmony default export */ var _unused_webpack_default_export = (Experience);

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var Featured=function(_PreLoginPage){_inherits(Featured,_PreLoginPage);function Featured(){_classCallCheck(this,Featured);return _possibleConstructorReturn(this,(Featured.__proto__||Object.getPrototypeOf(Featured)).apply(this,arguments));}_createClass(Featured,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-p-ga':'',className:'featured'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Featured In'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row justify-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'books'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Home - Featured In - BBC News',href:'http://news.bbc.co.uk/2/hi/south_asia/5203440.stm',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/BBCNews.png',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Home - Featured In - NewYork Times',href:'https://www.nytimes.com/2005/09/16/opinion/still-eating-our-lunch.html?_r=1',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/Newyorktimes.png',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Home - Featured In - World is Flat',href:this.getUrlFor("IFRAME_DOMAIN")+"/staticfiles/Thomas-FriedMan.pdf",target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/Friedman.png',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Home - Featured In - NASSCOM',href:this.getUrlFor("IFRAME_DOMAIN")+"/staticfiles/NASSCOM-Award.png",target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/Nasscom.png',alt:''})))))));}}]);return Featured;}(__WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__["a" /* default */]);/* unused harmony default export */ var _unused_webpack_default_export = (Featured);

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_if_elseif_else_render__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_if_elseif_else_render___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_if_elseif_else_render__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Footer_js__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PageBanner_js__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config_ProductConfig_json__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config_ProductConfig_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__config_ProductConfig_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var customStyles={content:{top:'50%',left:'50%',right:'auto',bottom:'auto',marginRight:'-50%',transform:'translate(-50%, -50%)',padding:'0px',maxWidth:'1170px'}};__WEBPACK_IMPORTED_MODULE_3_react_modal___default.a.setAppElement('#root');var response=[];var gradeNo='';var ProductList=[];var proClass='';var grades=[];// ES6 class-style
var Grades=function(_PreLoginPage){_inherits(Grades,_PreLoginPage);function Grades(props){var _this2=this;_classCallCheck(this,Grades);var _this=_possibleConstructorReturn(this,(Grades.__proto__||Object.getPrototypeOf(Grades)).call(this,props));_this.afterOpenModal=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var me,callBackSuccess,callBackFailure,formData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0://GoogleAnalytics.GA();
__WEBPACK_IMPORTED_MODULE_12__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");me=_this;callBackSuccess=function callBackSuccess(result){if(result!==null){me.setState({products_details:result}),console.log(me.state.products_details);localStorage.setItem('proDetail',JSON.stringify(me.state.products_details));}//console.log("response : ", response);
};callBackFailure=function callBackFailure(response){me.setState({isLoaded:true,error:"Error in PRODUCT_JSON"});console.log("Error in PRODUCT_JSON in Grade");};formData={"levelId":_this.gradeNo};new __WEBPACK_IMPORTED_MODULE_10__util_HmAjax__["a" /* default */](_this.getUrlFor("PRODUCT_JSON"),formData).post(callBackSuccess,callBackFailure);__WEBPACK_IMPORTED_MODULE_11_jquery___default()(document).ready(function(){console.log(__WEBPACK_IMPORTED_MODULE_11_jquery___default()('.pro-box').length);if(__WEBPACK_IMPORTED_MODULE_11_jquery___default()('.pro-box').length===1){__WEBPACK_IMPORTED_MODULE_11_jquery___default()('.pro-box').addClass('pro-box-100');}else if(__WEBPACK_IMPORTED_MODULE_11_jquery___default()('.pro-box').length===2){__WEBPACK_IMPORTED_MODULE_11_jquery___default()('.pro-box').addClass('pro-box-50');}else{__WEBPACK_IMPORTED_MODULE_11_jquery___default()('.pro-box').addClass('pro-box-33');}});case 7:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.state={modalIsOpen:false,error:null,isLoaded:false,items:[],ProductList:[],pro_detail:[],products_details:{}//  products : {self:ProductConfig["SPL"].productKey,plp:ProductConfig["PLP"].productKey,test:ProductConfig["EXAM_PREP_CBSE"].productKey}
};_this.openModal=_this.openModal.bind(_this);_this.closeModal=_this.closeModal.bind(_this);_this.grades=_this.props.grades;_this.productClass=_this.props.products_class;_this.productClasses=_this.props.classes;_this.products_category=_this.props.products_category;_this.checkProductAvailability=_this.checkProductAvailability.bind(_this);_this.singleLink=null;_this.selected_ga=null;return _this;}_createClass(Grades,[{key:'componentDidMount',value:function componentDidMount(){this.setState({isLoaded:true});this.grades=this.props.grades;this.productClass=this.props.products_class;this.productClasses=this.props.classes;this.products_category=this.props.products_category;__WEBPACK_IMPORTED_MODULE_12__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA");__WEBPACK_IMPORTED_MODULE_12__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");}},{key:'saveIDs',value:function saveIDs(proID){localStorage.setItem('product',proID);console.log(proID);return false;}},{key:'getSingleProductNavigation',value:function getSingleProductNavigation(){var me=this;var callBackSuccess=function callBackSuccess(result){if(result!==null){me.setState({products_details:result}),me.saveIDs(Object.keys(result)[0]);localStorage.setItem('proDetail',JSON.stringify(me.state.products_details));window.top.location.href=me.singleLink;}//console.log("response : ", response);
};var callBackFailure=function callBackFailure(response){me.setState({isLoaded:true,error:"Error in PRODUCT_JSON"});console.log("Error in PRODUCT_JSON in Grade");};var formData={"levelId":this.gradeNo};new __WEBPACK_IMPORTED_MODULE_10__util_HmAjax__["a" /* default */](this.getUrlFor("PRODUCT_JSON"),formData).post(callBackSuccess,callBackFailure);}},{key:'checkProductAvailability',value:function checkProductAvailability(event){this.gradeNo=event.target.id;this.ProductList=Object.keys(this.products_category);localStorage.setItem('grade',this.gradeNo);//console.log("sdf=",this.state.products);
var availableProductCount=0;for(var i=0;i<this.ProductList.length;i++){if(__WEBPACK_IMPORTED_MODULE_13__config_ProductConfig_json___default.a.hasOwnProperty(this.ProductList[i])){var proid=this.products_category[this.ProductList[i]][this.gradeNo];if(this.products_category[this.ProductList[i]][this.gradeNo]!=undefined){availableProductCount++;this.singleLink=__WEBPACK_IMPORTED_MODULE_13__config_ProductConfig_json___default.a[this.ProductList[i]].url+proid;/* 
		        	if(this.ProductList[i] == 'PLP'){
				        this.singleLink = '/personalised-learning/'+proid;
				    }else if(this.ProductList[i] == 'SPL'){
				    	this.singleLink = '/self-learning/'+proid;
				    }else if(this.ProductList[i] == 'EXAM_PREP_CBSE'){
				    	this.singleLink = '/cbse-exam/'+proid;
				    }*/}}}//console.log("availableProductCount="+availableProductCount);
if(availableProductCount==1){this.getSingleProductNavigation();}else{this.openModal(event);}}},{key:'openModal',value:function openModal(event){var _this3=this;console.log("open modal 111");var _state=this.state,products=_state.products,products_details=_state.products_details;this.setState({modalIsOpen:true});this.gradeNo=event.target.id;this.ProductList=Object.keys(this.products_category);localStorage.setItem('grade',this.gradeNo);this.selfLearn='';this.plp='';this.test='';console.log(this);this.selected_ga=__WEBPACK_IMPORTED_MODULE_11_jquery___default()(event.target).data("ga");// for (var i = 0; i < this.ProductList.length; i++) {
//   if(this.ProductList[i] == products.self){
//     this.setState({selfLearn: this.products_category[this.ProductList[i]][this.gradeNo]});
//   }else if(this.ProductList[i] == products.plp){
//     this.setState({plp: this.products_category[this.ProductList[i]][this.gradeNo]});
//   }else{
//     this.setState({test: this.products_category[this.ProductList[i]][this.gradeNo]});
//   }
// }
for(var i=0;i<this.ProductList.length;i++){if(this.ProductList[i]==products.self){if(this.products_category[this.ProductList[i]][this.gradeNo]!=undefined){(function(){var sid=_this3.products_category[_this3.ProductList[i]][_this3.gradeNo];console.log("sid=="+sid);console.log(_this3.props);_this3.selfLearn=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'pro-box float-left'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'e-box e-h2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'../img/e1.png',alt:''})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'In understanding concepts better'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',{className:'h-line'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Self-Paced Lessons'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'e-btn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Link */],{'data-ga':_this3.selected_ga+" - Self-Paced Lessons",to:"/self-learning/"+sid,className:'r-btn',onClick:function onClick(){return _this3.saveIDs(''+sid);}},'select'))));})();}}else if(this.ProductList[i]==products.plp){if(this.products_category[this.ProductList[i]][this.gradeNo]!=undefined){(function(){console.log("render..");var pid=_this3.products_category[_this3.ProductList[i]][_this3.gradeNo];console.log(_this3.products_details);//  console.log(this.props.pid);
_this3.plp=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'pro-box float-left'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'e-box e-h2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'../img/e3.png',alt:''})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'To score better in school tests'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',{className:'h-line'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Personalised Learning'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'e-btn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Link */],{'data-ga':_this3.selected_ga+" - Personalised Learning",to:"/personalised-learning/"+pid,className:'r-btn',onClick:function onClick(){return _this3.saveIDs(''+pid);}},'select'))));})();}}else{if(this.products_category[this.ProductList[i]][this.gradeNo]!=undefined){(function(){console.log("render..");var cid=_this3.products_category[_this3.ProductList[i]][_this3.gradeNo];_this3.test=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'pro-box float-left'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'e-box e-h2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'../img/e2.png',alt:''})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'To achieve your best in the board exams'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',{className:'h-line'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'CBSE Exam Prep'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'e-btn'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["b" /* Link */],{'data-ga':_this3.selected_ga+" - CBSE Test Prep",to:"/cbse-exam/"+cid,className:'r-btn',onClick:function onClick(){return _this3.saveIDs(''+cid);}},'select'))));})();}}}}},{key:'closeModal',value:function closeModal(){this.setState({modalIsOpen:false});}},{key:'checkRestrictedGrade',value:function checkRestrictedGrade(grade){var restricted="";if(this.GradeRestrictionManager.isGradeRestricted(grade)){restricted="restricted";}return restricted;}},{key:'render',value:function render(){var _this4=this;this.grades=this.props.grades;this.productClass=this.props.products_class;this.productDetails=this.props.products_details;this.productClasses=this.props.classes;this.products_category=this.props.products_category;var img='';var _state2=this.state,error=_state2.error,isLoaded=_state2.isLoaded,items=_state2.items,selfLearn=_state2.selfLearn,plp=_state2.plp,test=_state2.test,products_details=_state2.products_details;var gradeItem='';if(error){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Error: ',error.message);}else if(!isLoaded){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'text-center'},'Loading...');}else if(this.grades!==[]&&this.grades!==undefined){//	console.log("grades::",this.grades);
// console.log("grades productClasses::",this.productClasses);
this.gradeItem=this.grades.map(function(item){if(_this4.productClasses&&_this4.productClasses[item]){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{'data-ga':"Products - "+_this4.productClasses[item].ClassName,className:"grade-box popup-modal "+_this4.checkRestrictedGrade(item),key:item,onClick:_this4.checkProductAvailability,id:item},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'g-img'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:_this4.productClasses[item].thumbnail,alt:''})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'g-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,_this4.productClasses[item].ClassName)),function(){if(_this4.checkRestrictedGrade(item)=="restricted"){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'text-center desktopinfo'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,_this4.rb("msg.desktop")));}}());}});}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('section',{className:'product-main  mt-30'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'Which grade are you interested in?'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row grade-list'},this.gradeItem)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_modal___default.a,{isOpen:this.state.modalIsOpen,onRequestClose:this.closeModal,onAfterOpen:this.afterOpenModal,style:customStyles},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'grade-modal',className:'white-popup-block grade-popup'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{'data-ga':this.selected_ga+" - Close",className:'popup-modal-dismiss',onClick:this.closeModal},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:'../img/cross.png',alt:''})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'What do you need help with?'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'prod-list clearfix'},this.selfLearn,this.plp,this.test))));}}]);return Grades;}(__WEBPACK_IMPORTED_MODULE_9__views_core_PreLoginPage__["a" /* default */]);__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Grades,null),document.getElementById('root'));/* harmony default export */ __webpack_exports__["a"] = (Grades);

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(1207);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(10);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(1208);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(490);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(309);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(303);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _reactDom2.default.createPortal !== undefined;

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      parent.removeChild(_this.node);
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

exports.default = Modal;

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(1209);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(1210);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(490);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(1213);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(309);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus();
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen();
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.afterClose();
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      bodyOpenClassName && classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? null : _react2.default.createElement(
        "div",
        {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        },
        _react2.default.createElement(
          "div",
          _extends({
            ref: this.setContentRef,
            style: _extends({}, contentStyles, this.props.style.content),
            className: this.buildClassName("content", className),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.attributesFromObject("aria", this.props.aria || {}), this.attributesFromObject("data", this.props.data || {}), {
            "data-testid": this.props.testId
          }),
          this.props.children
        )
      );
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(489);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus();
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(489);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  var target;
  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof tabbable[x] === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  tabbable[x].focus();
}
module.exports = exports["default"];

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if (false) {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n";
    }

    classes = document.body.className;

    // eslint-disable-next-line max-len
    buffer += "\n\ndoc.body (" + classes + "):\n";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
    }

    buffer += "\n";

    // eslint-disable-next-line no-console
    console.log(buffer);
  }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_id_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var HowWorks=function(_PreLoginSessionCheck){_inherits(HowWorks,_PreLoginSessionCheck);function HowWorks(props){_classCallCheck(this,HowWorks);console.log(props);var _this=_possibleConstructorReturn(this,(HowWorks.__proto__||Object.getPrototypeOf(HowWorks)).call(this,props));_this.goNext=_this.goNext.bind(_this);_this.goPrev=_this.goPrev.bind(_this);_this.swiper=null;_this.productDetails=localStorage.getItem('proDetail');return _this;}_createClass(HowWorks,[{key:'goNext',value:function goNext(){if(this.swiper)this.swiper.slideNext();}},{key:'goPrev',value:function goPrev(){if(this.swiper)this.swiper.slidePrev();}},{key:'getProductDetails',value:function getProductDetails(){console.log(JSON.parse(this.productDetails));if(this.productDetails!={}&&this.productDetails!=undefined){return JSON.parse(this.productDetails);}}},{key:'render',value:function render(){var _this2=this;var params={slidesPerView:1,spaceBetween:50,autoHeight:true};this.proID=localStorage.getItem('product');var gradeName=this.getProductDetails()[this.proID].ClassName;var productCategory=this.getProductDetails()[this.proID].productCategory;var category_ga=this.getProductDetails()[this.proID].productCategory;if(category_ga=="EXAM_PREP_CBSE"){category_ga="CBSE Exam Prep";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'pd-main product-main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-container sample-lessons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_id_swiper___default.a,Object.assign({},params,{className:'swiper-wrapper',ref:function ref(node){if(node)_this2.swiper=node.swiper;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'How it Works'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/t-slider.jpg',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Score Card'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/t-slider-1.jpg',alt:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slider-btns plpsliderbuttons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':category_ga+" - "+gradeName+" - How the program works - left arrow",className:'swiper-button-prev swp-prev',onClick:this.goPrev}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':category_ga+" - "+gradeName+" - How the program works - right arrow",className:'swiper-button-next swp-next',onClick:this.goNext}))))));}}]);return HowWorks;}(__WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (HowWorks);

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_UserStorageUtil__ = __webpack_require__(33);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var Lessons=function(_PreLoginPage){_inherits(Lessons,_PreLoginPage);function Lessons(props){_classCallCheck(this,Lessons);var _this=_possibleConstructorReturn(this,(Lessons.__proto__||Object.getPrototypeOf(Lessons)).call(this,props));_this.state={products_details:{}};_this.productDetails=localStorage.getItem('proDetail');_this.gradeID=localStorage.getItem('grade');_this.proID=localStorage.getItem('product');_this.url=_this.gradeID+'.json';_this.openLesson=_this.openLesson.bind(_this);return _this;}_createClass(Lessons,[{key:'componentDidMount',value:function componentDidMount(){var me=this;this.proID=localStorage.getItem('product');__WEBPACK_IMPORTED_MODULE_3__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA");}},{key:'getProductDetails',value:function getProductDetails(){//console.log(JSON.parse(this.productDetails));
if(this.productDetails!={}&&this.productDetails!=undefined){return JSON.parse(this.productDetails);}}},{key:'openLesson',value:function openLesson(event){var lesIndex=event.currentTarget.dataset.index;this.proID=localStorage.getItem('product');var samples=JSON.parse(this.getProductDetails()[this.proID].productDetails);var gradeName=this.getProductDetails()[this.proID].ClassName;var samplesLessons=samples[0].samples;//console.log(samplesLessons[lesIndex]);
var lessonidTracking=samplesLessons[lesIndex].lessonUrl;var lessonid=samplesLessons[lesIndex].lessonUrl;var lessonname=samplesLessons[lesIndex].name;var lurl=samplesLessons[lesIndex].lessonUrl;var dd=0;var lessonPref=null;var testid=null;var topicSubTopicMapId=null;var accessId=null;var classId=null;var snippetId="";var source=0;var lessonviewRoute="/openlessonview";if(this.props.PLPloggedIn||this.props.PLPloggedIn=="true"){lessonviewRoute="/lessonview";}var _url=lessonviewRoute+"/"+lessonid+"?url="+lurl+"&lessonPref="+lessonPref+"&testid="+testid+"&revisiontopicid="+topicSubTopicMapId+"&accessId="+accessId+"&classId="+classId+"&src=plp"+"&lessonidTracking="+lessonidTracking+"&tracksource="+this.props.tracksource+"&snid="+snippetId+"&qsrc="+source;if(dd>0){_url+="&dd="+dd;}__WEBPACK_IMPORTED_MODULE_4__util_UserStorageUtil__["a" /* default */].storeSessionItem(lurl,lessonname);//console.log(_url);
window.open(_url,lessonid,'fullscreen=yes,menubar=no,width='+window.innerWidth+',height='+window.innerHeight).focus();}},{key:'render',value:function render(){var _this2=this;this.proID=localStorage.getItem('product');var samples=JSON.parse(this.getProductDetails()[this.proID].productDetails);var gradeName=this.getProductDetails()[this.proID].ClassName;var samplesLessons=samples[0].samples;//console.log(this.proID);
console.log(samples);try{if(samplesLessons.length!=0){this.stitle=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'spl-lessons'},'Sample Lessons');// this.stitle = <h4>Sample Lessons for {this.getProductDetails()[this.proID].ClassName}</h4>;
}}catch(e){}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'product-main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},this.stitle,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},Object.keys(samplesLessons).map(function(v,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12',key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':"SPL - Sample Lessons for "+gradeName+" - "+samplesLessons[i].name},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sample-les samplelessonbox','data-index':i,onClick:_this2.openLesson},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sampl-img lessonthumb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/"+samplesLessons[i].image,alt:samplesLessons[i].name+" - HeyMath! lesson"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sampl-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,samplesLessons[i].name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,samplesLessons[i].Description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}))));}))));}}]);return Lessons;}(__WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Lessons);

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_slick_carousel_slick_slick_css__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_slick_carousel_slick_slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_slick_carousel_slick_slick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_theme_css__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_theme_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_slick__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__public_img_l_quote_png__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__public_img_l_quote_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__public_img_l_quote_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__public_img_r_quote_png__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__public_img_r_quote_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__public_img_r_quote_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__public_img_testimonial_anuradha_png__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__public_img_testimonial_anuradha_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__public_img_testimonial_anuradha_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__public_img_testimonial_bindu_png__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__public_img_testimonial_bindu_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__public_img_testimonial_bindu_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__public_img_testimonial_mekhala_balaji_png__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__public_img_testimonial_mekhala_balaji_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__public_img_testimonial_mekhala_balaji_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var items=[{id:1,src:__WEBPACK_IMPORTED_MODULE_8__public_img_testimonial_bindu_png___default.a,caption:"Bindu Subramaniam",occupation:"Parent of Mahati - Class II, NPS",header:'My daughter Mahati started using HeyMath! when she was three, and \n    she loved it so much she started giving tutorials to everyone she met! It\'s \n    so much fun that she never realized she was doing hard work and learning so much. \n    I think HeyMath! is an incredible resource for children to learn math, \n    and I can\'t recommend it enough.'},{id:2,src:__WEBPACK_IMPORTED_MODULE_9__public_img_testimonial_mekhala_balaji_png___default.a,caption:"Mekhala",occupation:"Grade 7, Bala Vidya Mandir, Chennai",header:'I like PLP because it\'s easy to use. It helps correct my\n     mistakes by giving me recommended practice sums & sometimes videos too.'},{id:3,src:__WEBPACK_IMPORTED_MODULE_7__public_img_testimonial_anuradha_png___default.a,caption:"Anuradha",occupation:"Parent of Arjun - Grade 3, AAIS, ECR",header:'My 8 year old loves Math and HeyMath! is a big reason behind that! \n    The lessons are cool and I find that the content is structured intuitively, \n    keeping the learner in mind. As a parent I\'m impressed with Prasso that challenges \n    kids to master the topic yet there\'s no associated pressure \n    - such a welcome change from traditional methods! Highly \n    recommend this program to parents and teachers across curriculum!'}];var OurParents=function(_PreLoginSessionCheck){_inherits(OurParents,_PreLoginSessionCheck);function OurParents(props){_classCallCheck(this,OurParents);return _possibleConstructorReturn(this,(OurParents.__proto__||Object.getPrototypeOf(OurParents)).call(this,props));}_createClass(OurParents,[{key:'render',value:function render(){var settings={dots:true,infinite:true,speed:500,slidesToShow:1,slidesToScroll:1,adaptiveHeight:true,autoplay:true,autoplaySpeed:3000,pauseOnHover:true};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'OurparFBSlider'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container justify-content-md-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_slick___default.a,settings,function(){return items.map(function(fbcomm,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fbcont',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-12 col-md-12 col-lg-12 txtcont'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtpart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-4 col-md-4 col-lg-4 test-pic'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figure',{'class':'figure'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:items[index].src,'class':'figure-img img-fluid rounded',alt:items[index].caption}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figcaption',{'class':'figure-caption'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtcaption'},items[index].caption),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtoccupation'},items[index].occupation)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-8 col-md-8 col-lg-8 test-cont'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtimg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__public_img_l_quote_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtheader'},items[index].header)))));});}())));}}]);return OurParents;}(__WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__["a" /* default */]);/* unused harmony default export */ var _unused_webpack_default_export = (OurParents);

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAVCAYAAABc6S4mAAAAAXNSR0IArs4c6QAAA3VJREFUOBGFVN1LVEEUPzN7ddd119XyAyp6KiHoJfqAfIx8UOqlwAd7KI2yXgyiP6C3HoOI6qHExD6wDDQQrV4z6Q+IoECKitBc97q7razemX5n7h33w5sO3HtmzvzOmXN+58yIHXNzDRk3d1uTPq2JGgQRQZaGEDkopikZH6SOjjRvJGbet/4VhbtK00lBOl6BZ4AgFzbjtLPphpNxV+5opc/7ev7zvj+EgLlSUchzIpuLe0RneCevc6OkqHMDV47XmoBvheqq+JNWQk5NZ7BIBZhKATDQSMnEWDzU1pL4ns1Gl1aLK9BZ/yWbSjwz8dMRSoU7t2a+c17Vzi8s1K06TkJ43mbnm/GcSSMfUMm5BULa4Fn6Q/oCNmGjGs9JOgSwDDxoRGt4t1HDsWB27AERHFAgkkFI2+GlkOQIdhY4NH74EBue0WMV7Fs1B8VjWzyiQwYegBsuN3zwBK1r9liWRoGY1rBRjRfI1ZFK58FDvW/AB5U4QZMatZW8iMbjec9dMXo/hy3w2sMRSr/liExUHrLh6CD9z85Z+lEvd3a6UqmPFmdlGJ7pl06s5opU9EYorVgBiYTCvyBsqq1xeoH5wNXZEm/oD6z2jI3V4cYlrBPEe0x76gXWdbbIdY2pVLq72/JDbTMz9XnXjVsb7XmduLq45SooqsiHVzewiD95+hJlOGsdxHY0Vhxg9eUSNrOwOW50QuSDm1MOKc1BXZPQqA9ThioMdnXlSrvhM6k1bHyKkYnrhMPA1chIK6n1o3YfF3D+phB+pa2ySiYfP29XXrHdqiMkv4Zm0DwxkSSPRhBB0hSRu8xTk9YwTCbGxlpIrY4CL7mzTHcJNbmRQWpo5ASR2ofG3V9cWu5BmnvN/UO6eEsWktGaW9kqz8mhx6cQ4W5N6oDO5Xux3cL0sB1eny8Nsdg9c0Dzo2e7irrwzjzBAQmm+uZFRi+TvPqrt/dPuf/U8PBhvb7+2r+KwbPhR2Sa15F04UdPT8FQpOVqAygAw5waChSkiAJnwfrlTF/fq3LnZr6mUtV48+xovSiE7kn3988yzmTgRCJpr7iO66sjpucFraGoU0jgWubSxW+bnEMhlVg0b5SlBO8sQhuPOfL67/7+RWtjmOBF0/2HB9GPe1GhJbD0eXlgwLWg/8nmBw+OeEq2RKRarBXi06+Bgb/V2H8HY9IYNbRGEAAAAABJRU5ErkJggg=="

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__public_img_phone_png__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__public_img_phone_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__public_img_phone_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContactHeader=function(_PreLoginPage){_inherits(ContactHeader,_PreLoginPage);function ContactHeader(props){_classCallCheck(this,ContactHeader);return _possibleConstructorReturn(this,(ContactHeader.__proto__||Object.getPrototypeOf(ContactHeader)).call(this,props));}_createClass(ContactHeader,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'ContactHeader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'contactbtn',onClick:this.props.showContactus},'Contact us'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'local_phone')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'contactbtn'},'9884400755')))//     </div>
// </div>
;}}]);return ContactHeader;}(__WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__["a" /* default */]);/* unused harmony default export */ var _unused_webpack_default_export = (ContactHeader);

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

var HM_TEAMS=[{name:"Aarthy S",desgn:"Content Development",picture:"aarthy.jpg"},{name:"Abdul Kadhar S ",desgn:"UI Development",picture:"abdul.jpg"},{name:"Ananda Kumar A ",desgn:"HTML5 Development",picture:"anand.jpg"},{name:"Angela Susan Mathews ",desgn:"Content Development",picture:"angela.jpg"},{name:"Antony A ",desgn:"HTML5 Development",picture:"antony.jpg"},{name:"Balakumar VK ",desgn:"Content Development",picture:"bala.jpg"},{name:"Bavuyise Mtana ",desgn:"Customer Engagement",picture:"bavuyise.jpg"},{name:"Benny Geo G ",desgn:"HTML5 Development",picture:"benny.jpg"},{name:"Bhavya B ",desgn:"Content Development",picture:"bhavya.jpg"},{name:"Bhuvana S ",desgn:"Content Development",picture:"bhuvana.jpg"},{name:"Daniel Kinch ",desgn:"Content Development",picture:"daniel-kinch.jpg"},{name:"Deepika Nair ",desgn:"UI Development",picture:"deepika_n.jpg"},{name:"Dhamimun Nisha ",desgn:"Animation",picture:"nisha.jpg"},{name:"Divya Srinivasan ",desgn:"Finance & Accounts",picture:"divya.jpg"},{name:"Dlamini Gerald ",desgn:"Customer Engagement",picture:"dlamini.jpg"},{name:"Dumisani Nyamane ",desgn:"Customer Engagement",picture:"dumisani.jpg"},{name:"Frank Tlaletsi ",desgn:"Customer Engagement",picture:"frank.jpg"},{name:"Frank Van Schalkwyk ",desgn:"Customer Engagement",picture:"frankV.jpg"},{name:"Gayathri H ",desgn:"Customer Engagement",picture:"gayathri.jpg"},{name:"Geetha Ramanujam ",desgn:"Content Development",picture:"geetha.jpg"},{name:"Hemachandran S ",desgn:"Data Analysis",picture:"hemachandran.jpg"},{name:"Jai Karthik R ",desgn:"Mobile App Development",picture:"jaikarthik.jpg"},{name:"Jayapackiam T.N ",desgn:"Content Development",picture:"jaya.jpg"},{name:"Jayashree Gautham ",desgn:"Customer Engagement",picture:"jayashree-gautham.jpg"},{name:"Jona Sherly ",desgn:"Software Development",picture:"jona-sherly.jpg"},{name:"Kaliyaperumal V ",desgn:"Animation",picture:"kaliyaperumal.jpg"},{name:"Karikalan M ",desgn:"Content Development",picture:"karikalan.jpg"},{name:"Krishna Gaurav ",desgn:"UI/UX Design",picture:"krishna-gaurav.jpg"},{name:"Ladongnuklu Jamir ",desgn:"Product Marketing",picture:"ladang.jpg"},{name:"Lakshmidaran M ",desgn:"UI Design",picture:"lucky.jpg"},{name:"Luthando Makinza ",desgn:"Customer Engagement",picture:"luthando.jpg"},{name:"Mbuso Ncube ",desgn:"Customer Engagement",picture:"mbuso.jpg"},{name:"Narayanan K ",desgn:"Quality Assurance",picture:"narayanan.jpg"},{name:"Naveen P ",desgn:"HTML5 Development",picture:"naveen.jpg"},{name:"Nirmala Agadgar ",desgn:"Software Development",picture:"nirmala.jpg"},{name:"Paballo Moses Moloi ",desgn:"Tech Infrastructure",picture:"paballa.jpg"},{name:"Padmini Ravi ",desgn:"Content Development",picture:"padmini.jpg"},{name:"Pavithra R ",desgn:"Content Development",picture:"pavithra.jpg"},{name:"Porsha Megan Norton ",desgn:"Customer Engagement",picture:"porsha.jpg"},{name:"Prabhakaran R ",desgn:"HTML5 Development",picture:"prabhakaran.jpg"},{name:"Radhika R ",desgn:"HTML5 Development",picture:"radika.jpg"},{name:"Raghavendiran A ",desgn:"HTML5 Development",picture:"ragavendar.jpg"},{name:"Raja M ",desgn:"Mobile App Development",picture:"raja.jpg"},{name:"Ranjan Ray Chaudhuri ",desgn:"Finance & Accounts",picture:"ranjan.jpg"},{name:"Sai Bharath ",desgn:"Quality Assurance",picture:"sai.jpg"},{name:"Sangeetha Chittibabu ",desgn:"Content Development",picture:"sangeetha.jpg"},{name:"Sankarapandian T ",desgn:"Software Development",picture:"sankar.jpg"},{name:"Saranya S ",desgn:"Customer Operations",picture:"saranya.jpg"},{name:"Satheesh S ",desgn:"Content Development",picture:"sathish.jpg"},{name:"Sathish Kumar V ",desgn:"Tech Infrastructure",picture:"sathishtec.jpg"},{name:"Shanthi Arunachalam ",desgn:"HTML5 Development",picture:"shanthi.jpg"},{name:"Sheela Shankar ",desgn:"Customer Engagement",picture:"sheela.jpg"},{name:"Shriram N ",desgn:"Software Development",picture:"shriram.jpg"},{name:"Shyam Sundar G ",desgn:"Software Development",picture:"shyamg.jpg"},{name:"Shyam Sundar V ",desgn:"HTML5 Development",picture:"shyam.jpg"},{name:"Sivakumar P ",desgn:"Human Capital Management",picture:"shiva.jpg"},{name:"Sureka SR ",desgn:"Animation",picture:"sureka.jpg"},{name:"Suresh S ",desgn:"Content Development",picture:"suresh.jpg"},{name:"Swetha Sekar ",desgn:"Customer Engagement",picture:"swetha.jpg"},{name:"Tamizh Selvi N ",desgn:"Admin & Procurement",picture:"tamilselvi.jpg"},{name:"Thapelo Nyoni ",desgn:"Customer Engagement",picture:"thapelo.jpg"},{name:"Tharani Dushendra ",desgn:"Content Development",picture:"tharani.jpg"},{name:"Thato Gloria Botlhoko ",desgn:"Admin & Procurement",picture:"thato-botlhoko.jpg"},{name:"Thejasvi Parthasarathy ",desgn:"Customer Engagement",picture:"thejasvi-parthasarathy.jpg"},{name:"Udaya Kumar K ",desgn:"Finance & Accounts",picture:"uday.jpg"},{name:"Veenus Vivie B ",desgn:"Admin & Procurement",picture:"veenus.jpg"},{name:"Venugopal G ",desgn:"Tech Infrastructure",picture:"venu.jpg"},{name:"Vijayakumar R ",desgn:"Audio Development",picture:"vijay.jpg"},{name:"Vinitha R ",desgn:"Content Development",picture:"vinitha.jpg"},{name:"Yuvaraja C ",desgn:"Content Development",picture:"yuvaraj.jpg"}];module.exports=HM_TEAMS;

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BuyOption_js__ = __webpack_require__(195);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var PageBannerBuy=function(_PreLoginSessionCheck){_inherits(PageBannerBuy,_PreLoginSessionCheck);function PageBannerBuy(props){_classCallCheck(this,PageBannerBuy);var _this=_possibleConstructorReturn(this,(PageBannerBuy.__proto__||Object.getPrototypeOf(PageBannerBuy)).call(this,props));_this.productDetails=localStorage.getItem('proDetail');_this.getBuyOptions=_this.getBuyOptions.bind(_this);return _this;}_createClass(PageBannerBuy,[{key:'getProductDetails',value:function getProductDetails(){//console.log(JSON.parse(this.productDetails));
if(this.productDetails!={}&&this.productDetails!=undefined){return JSON.parse(this.productDetails);}else{return{};}}},{key:'componentDidMount',value:function componentDidMount(){var clsName=this.removeWhiteSpace(this.getProductDetails()[this.props.id].ClassName);console.log("lalala",clsName);this.setTitle(clsName+"_title");this.setMeta(clsName+"_meta");this.setHeading(clsName+"_heading");}},{key:'getBuyOptions',value:function getBuyOptions(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BuyOption_js__["a" /* default */],{id:this.props.id,triedFree:this.props.triedFree,purchased:this.props.purchased,showSubScripeLoginForm:this.props.showSubScripeLoginForm,productBase:this.props.productBase,simpleform:this.props.simpleform});}},{key:'render',value:function render(){var classname=this.getProductDetails()[this.props.id].ClassName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:this.props.classes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,this.props.name,' for ',classname),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.props.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'buyoptionline'}),this.getBuyOptions()));}}]);return PageBannerBuy;}(__WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (PageBannerBuy);

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var ProductBanner=function(_PreLoginSessionCheck){_inherits(ProductBanner,_PreLoginSessionCheck);function ProductBanner(){_classCallCheck(this,ProductBanner);return _possibleConstructorReturn(this,(ProductBanner.__proto__||Object.getPrototypeOf(ProductBanner)).apply(this,arguments));}_createClass(ProductBanner,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:this.props.classes},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.props.name,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.text)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'self-pross'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.bannerPoint1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.bannerPoint2),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.bannerPoint3))));}}]);return ProductBanner;}(__WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ProductBanner);

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_id_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal_video__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal_video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal_video__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var Testimonial=function(_PreLoginSessionCheck){_inherits(Testimonial,_PreLoginSessionCheck);function Testimonial(props){_classCallCheck(this,Testimonial);var _this=_possibleConstructorReturn(this,(Testimonial.__proto__||Object.getPrototypeOf(Testimonial)).call(this,props));_this.state={isOpen:false};_this.openModal=_this.openModal.bind(_this);_this.goNext=_this.goNext.bind(_this);_this.goPrev=_this.goPrev.bind(_this);_this.swiper=null;return _this;}_createClass(Testimonial,[{key:'goNext',value:function goNext(){if(this.swiper)this.swiper.slideNext();}},{key:'goPrev',value:function goPrev(){if(this.swiper)this.swiper.slidePrev();}},{key:'openModal',value:function openModal(someValue){this.setState({isOpen:true});this.videoId=someValue;console.log(this.videoId);}},{key:'render',value:function render(){var _this2=this;var videoId='';var params={slidesPerView:3,spaceBetween:30,loop:true,navigation:{nextEl:'.swiper-button-next',prevEl:'.swiper-button-prev',nextButtonCustomizedClass:'.swp-next',prevButtonCustomizedClass:'.swp-prev'},breakpoints:{480:{slidesPerView:1,spaceBetween:20},640:{slidesPerView:2,spaceBetween:30},768:{slidesPerView:2,spaceBetween:30}}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'mtb our-student'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Our star students, placed in the best of colleges and workplaces, speak about HeyMath!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_id_swiper___default.a,{className:'student-slider',slidesPerView:params.slidesPerView,breakpoints:params.breakpoints,loop:params.loop,spaceBetween:params.spaceBetween,ref:function ref(node){if(node)_this2.swiper=node.swiper;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Home - Star Students - Shreyas Kumar',className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box popup-youtube',onClick:this.openModal.bind(null,'bRE5tit8zqU')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/student4.jpg',alt:'Shreyas Kumar, Heymath Intern from Harvey Mudd shares his journey experience'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Home - Star Students - Uday Saharia',className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box popup-youtube',onClick:this.openModal.bind(null,'KT-uJDOLOvA')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/student5.jpg',alt:'Uday Saharia, Heymath Intern from University of Chicago presents his experience'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Home - Star Students - Yamini Prashanth',className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box popup-youtube',onClick:this.openModal.bind(null,'8yKwHD8fANY')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/student7.jpg',alt:'Yamini Prashanth, Heymath user from Vidya Mandir Mylapore shares her story'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Home - Star Students - Anuradha',className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box popup-youtube',onClick:this.openModal.bind(null,'uiqV8V4f6PE')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/student1.jpg',alt:'Anuratha Rao, Heymath user from IIM Banglore shares her journey'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Home - Star Students - Rajkamal',className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box popup-youtube',onClick:this.openModal.bind(null,'wYKQM3-Yb94')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/student2.jpg',alt:'Rajkamal Ganesa, Heymath user from NIT Trichy tells his journey'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Home - Star Students - Ramanandan Krishnamurthy',className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box popup-youtube',onClick:this.openModal.bind(null,'-BFo63cdLSY')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/student3.jpg',alt:'Ramnandan Krishnamurthy, Heymath user from IIT Madras provides his feeback'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':'Home - Star Students - Varun Ranganathan',className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box popup-youtube',onClick:this.openModal.bind(null,'MLyYoLco1eY')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/student6.jpg',alt:'Varun Ranganathan, Heymath User and Intern from SSN College shares his experience'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slider-btns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-button-prev swp-prev',onClick:this.goPrev}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-button-next swp-next',onClick:this.goNext})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_modal_video___default.a,{channel:'youtube',isOpen:this.state.isOpen,videoId:this.videoId,onClose:function onClose(){return _this2.setState({isOpen:false});}}));}}]);return Testimonial;}(__WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__["a" /* default */]);/* unused harmony default export */ var _unused_webpack_default_export = (Testimonial);

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/centalogo.078fecdb.png";

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_slick_carousel_slick_slick_css__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_slick_carousel_slick_slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_slick_carousel_slick_slick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_theme_css__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_theme_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_slick__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_modal_video__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_modal_video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_modal_video__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__public_img_l_quote_png__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__public_img_l_quote_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__public_img_l_quote_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__public_img_testimonial_anuradha_rao_jpg__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__public_img_testimonial_anuradha_rao_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__public_img_testimonial_anuradha_rao_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__public_img_testimonial_bindu_png__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__public_img_testimonial_bindu_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__public_img_testimonial_bindu_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__public_img_testimonial_ramnandan_jpg__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__public_img_testimonial_ramnandan_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__public_img_testimonial_ramnandan_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__public_img_testimonial_anuradha_png__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__public_img_testimonial_anuradha_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__public_img_testimonial_anuradha_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__public_img_testimonial_yamini_jpg__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__public_img_testimonial_yamini_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__public_img_testimonial_yamini_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__public_img_testimonial_mekhala_balaji_png__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__public_img_testimonial_mekhala_balaji_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__public_img_testimonial_mekhala_balaji_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__public_img_testimonial_rajkamal_jpg__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__public_img_testimonial_rajkamal_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__public_img_testimonial_rajkamal_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__public_img_testimonial_karuna_png__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__public_img_testimonial_karuna_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__public_img_testimonial_karuna_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var items=[{id:1,type:"video",src:__WEBPACK_IMPORTED_MODULE_7__public_img_testimonial_anuradha_rao_jpg___default.a,urlstr:'uiqV8V4f6PE',caption:"Anuradha Rao",occupation:"PSBB | IIM Bangalore | Top Consulting Firm",header:'One of the ways in which teachers brought Math alive was HeyMath! \n    HeyMath! was a tool that helped me in visualizing. \n    It made maths more interesting.',altText:"Anuratha Rao, Heymath user from IIM Banglore shares her journey"},{id:2,type:"image",src:__WEBPACK_IMPORTED_MODULE_8__public_img_testimonial_bindu_png___default.a,urlstr:'none',caption:"Bindu Subramaniam",occupation:"Parent of Mahati - Class II, NPS",header:'My daughter Mahati started using HeyMath! when she was three, and \n    she loved it so much she started giving tutorials to everyone she met! It\'s \n    so much fun that she never realized she was doing hard work and learning so much. \n    I think HeyMath! is an incredible resource for children to learn math, \n    and I can\'t recommend it enough.',altText:"Bindu Subramaniam shares testimonial about Grade 2 Self-Paced Lessons"},{id:3,type:"video",src:__WEBPACK_IMPORTED_MODULE_9__public_img_testimonial_ramnandan_jpg___default.a,urlstr:'-BFo63cdLSY',caption:"Ramnandan Krishnamurthy",occupation:"PSBB | IIT Madras - CSE | Microsoft",header:'Thanks to HeyMath, we had a very hands-on learning experience in school. \n    What helped with HeyMath and the lab was it had all the other types of learning \n    (auditory, visual etc.) along with the textual. \n    One genre of topics that which really helped, especially from a \n    visual standpoint was geometry',altText:"Ramnandan Krishnamurthy, Heymath user from IIT Madras provides his feeback"},{id:4,type:"image",src:__WEBPACK_IMPORTED_MODULE_10__public_img_testimonial_anuradha_png___default.a,urlstr:'none',caption:"Anuradha",occupation:"Arjun's Mom - Grade 3, AAIS, ECR",header:'My 8 year old loves Math and HeyMath! is a big reason behind that! \n    The lessons are cool and I find that the content is structured intuitively, \n    keeping the learner in mind. As a parent I\'m impressed with Prasso that challenges \n    kids to master the topic yet there\'s no associated pressure \n    - such a welcome change from traditional methods! Highly \n    recommend this program to parents and teachers across curriculum!',altText:"Anuradha shares testimonial about Grade 3 Self-Paced Lessons"},{id:5,type:"video",src:__WEBPACK_IMPORTED_MODULE_11__public_img_testimonial_yamini_jpg___default.a,urlstr:'8yKwHD8fANY',caption:"Yamini Prashanth",occupation:"Grade 10, Vidya Mandir, Mylapore",header:'HeyMath! is like an after-school tutor for me as I can watch animated \n    lessons and review my concepts with a human voice guiding me through them. \n    HeyMath is like having access to the best math teacher at home. \n    If I have not understood a concept at school or if I missed a class for some reason, \n    I can learn it by myself on HeyMath',altText:"Yamini Prashanth, Heymath user from Vidya Mandir Mylapore shares her story"},{id:6,type:"image",src:__WEBPACK_IMPORTED_MODULE_12__public_img_testimonial_mekhala_balaji_png___default.a,urlstr:'',caption:"Mekhala",occupation:"Grade 7, Bala Vidya Mandir, Chennai",header:'I like PLP because it\'s easy to use. It helps correct my\n    mistakes by giving me recommended practice sums & sometimes videos too.',altText:"Mekhala from Grade 7 shares testimonial about PLP"},{id:7,type:"video",src:__WEBPACK_IMPORTED_MODULE_13__public_img_testimonial_rajkamal_jpg___default.a,urlstr:'wYKQM3-Yb94',caption:"Rajkamal Ganesan",occupation:"The Indian High School, Dubai | IIM Bangalore | Vedanta Resources",header:'What I like about HeyMath teaching interface was how they were trying to bring in \n    concepts by focusing on real-life issues rather than through \n    just plain equations making even a layman understand. It makes math more fun.',altText:"Rajkamal Ganesa, Heymath user from NIT Trichy tells his HeyMath! journey"},{id:8,type:"image",src:__WEBPACK_IMPORTED_MODULE_14__public_img_testimonial_karuna_png___default.a,urlstr:'',caption:"Karuna",occupation:"Karuna, Mother of Lyra",header:'My daughter has been quite wary of Maths in general and numbers in particular. \n    She is often frustrated and tries to avoid. We have found HeyMath! a great help.\n    Not only are the concepts introduced creatively but practice sessions are so engaging\n    that she loves repeating them endlessly. HeyMath! has made learning an enjoyable experience\n    which she looks forward to and getting her to do Maths is no longer a struggle.',altText:"Karuna shares testimonial of her 7 year old daughter using HeyMath!"}];var OurTestimonial=function(_PreLoginSessionCheck){_inherits(OurTestimonial,_PreLoginSessionCheck);function OurTestimonial(props){_classCallCheck(this,OurTestimonial);var _this=_possibleConstructorReturn(this,(OurTestimonial.__proto__||Object.getPrototypeOf(OurTestimonial)).call(this,props));_this.state={isOpen:false};_this.openModal=_this.openModal.bind(_this);_this.goNext=_this.goNext.bind(_this);_this.goPrev=_this.goPrev.bind(_this);return _this;}_createClass(OurTestimonial,[{key:'openModal',value:function openModal(someValue){this.setState({isOpen:true});this.videoId=someValue;}},{key:'goNext',value:function goNext(){if(this.swiper)this.swiper.slideNext();}},{key:'goPrev',value:function goPrev(){if(this.swiper)this.swiper.slidePrev();}},{key:'loadimage',value:function loadimage(item){if(item.type=="image"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figure',{className:'figure'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:item.src,className:'figure-img img-fluid rounded',alt:item.altText}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figcaption',{className:'figure-caption'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtcaption'},item.caption),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtoccupation'},item.occupation)));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figure',{className:'figure'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:this.openModal.bind(null,item.urlstr)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:item.src,className:'figure-img img-fluid rounded videoimg',alt:item.altText}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figcaption',{className:'figure-caption'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtcaption'},item.caption),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtoccupation'},item.occupation)));}}},{key:'render',value:function render(){var _this2=this;var settings={dots:true,infinite:true,speed:500,slidesToShow:1,slidesToScroll:1,adaptiveHeight:true,autoplay:true,autoplaySpeed:3000,pauseOnHover:true};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'OurparFBSlider',className:'mtb our-student'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container justify-content-md-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Students and Parents share their HeyMath! experience'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stud-cont'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_slick___default.a,settings,function(){return items.map(function(fbcomm,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fbcont',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-12 col-md-12 col-lg-12 txtcont'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtpart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-4 col-md-4 col-lg-4 test-pic'},_this2.loadimage(items[index])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-8 col-md-8 col-lg-8 test-cont'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtimg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__public_img_l_quote_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtheader'},items[index].header)))));});}()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_modal_video___default.a,{channel:'youtube',isOpen:this.state.isOpen,videoId:this.videoId,onClose:function onClose(){return _this2.setState({isOpen:false});}}));}}]);return OurTestimonial;}(__WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (OurTestimonial);

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/anuradha_rao.d0880fda.jpg";

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ramnandan.88cb4f79.jpg";

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/yamini.724523ac.jpg";

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/rajkamal.6efc0316.jpg";

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/karuna.590625d1.png";

/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_slick_carousel_slick_slick_css__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_slick_carousel_slick_slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_slick_carousel_slick_slick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_theme_css__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_theme_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_slick__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_modal_video__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_modal_video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_modal_video__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__public_img_l_quote_png__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__public_img_l_quote_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__public_img_l_quote_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__public_img_testimonial_jeremiah_png__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__public_img_testimonial_jeremiah_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__public_img_testimonial_jeremiah_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__public_img_testimonial_maheshwari_jpg__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__public_img_testimonial_maheshwari_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__public_img_testimonial_maheshwari_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__public_img_testimonial_elizabeth_png__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__public_img_testimonial_elizabeth_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__public_img_testimonial_elizabeth_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__public_img_testimonial_karen_jpg__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__public_img_testimonial_karen_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__public_img_testimonial_karen_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__public_img_testimonial_tsoai_png__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__public_img_testimonial_tsoai_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__public_img_testimonial_tsoai_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__public_img_testimonial_meena_jpg__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__public_img_testimonial_meena_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__public_img_testimonial_meena_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__public_img_testimonial_pulane_png__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__public_img_testimonial_pulane_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__public_img_testimonial_pulane_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__public_img_testimonial_rama_jpg__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__public_img_testimonial_rama_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__public_img_testimonial_rama_jpg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var items=[{id:1,type:"video",src:__WEBPACK_IMPORTED_MODULE_8__public_img_testimonial_maheshwari_jpg___default.a,urlstr:'RGZ8kSxUi8Y',caption:"Ms Maheshwari Natarajan",occupation:"Principal, Vidya Mandir Estancia",header:' We find that most times we are delivering concepts through the chalk and talk \n      method but HeyMath has allowed us to experiment with activities and experiment with digital \n      solutions for delivering concepts.',altText:"Ms Maheshwari Natarajan"},{id:2,type:"image",src:__WEBPACK_IMPORTED_MODULE_7__public_img_testimonial_jeremiah_png___default.a,urlstr:'none',caption:"Jeremiah",occupation:"Qifa Primary School, Singapore",header:' I had the chance to utilize the HeyMath! resources and that brought excitements\n        and squeals of joy among the pupils too. It was indeed an experience as the pupils were\n        really very enthusiastic and warm. They were interested in learning and were participating \n        actively in the lesson.',altText:"Jeremiah"},{id:3,type:"image",src:__WEBPACK_IMPORTED_MODULE_9__public_img_testimonial_elizabeth_png___default.a,urlstr:'none',caption:"Elizabeth Ng",occupation:"CHIJ Katong Convent, Singapore",header:' I never knew that so much work has to go into developing \n        just one ICT lesson that we see in a Learning Management System. \n        HeyMath! had indeed enhanced my professional development and provided a \n        global perspective about education.',altText:"Elizabeth Ng"},{id:4,type:"video",src:__WEBPACK_IMPORTED_MODULE_10__public_img_testimonial_karen_jpg___default.a,urlstr:'MMbIMB1eQ9U',caption:"Karen Dickey",occupation:"Middle School Math Coordinator for Westport Schools, CT",header:' We\u2019ve worked together with the people here to create the lessons \n        and to come up with new and exciting ways of approaching Mathematics.',altText:"Karen Dickey"},{id:5,type:"video",src:__WEBPACK_IMPORTED_MODULE_12__public_img_testimonial_meena_jpg___default.a,urlstr:'c3Z2ty6gwv4',caption:"Ms. Meena Mayyappan",occupation:"Correspondent/ Director Academics, Honey Bunch School",header:'I think this will definitely help the children. Because now Math is not taught, it is again \n        like memorising and it is more without understanding that children are doing. So, with this children I \n        feel would have an understanding.',altText:"Ms. Meena Mayyappan"},{id:6,type:"video",src:__WEBPACK_IMPORTED_MODULE_14__public_img_testimonial_rama_jpg___default.a,urlstr:'jKx6LKHFIqs',caption:"Ms.N Rama Devi",occupation:"Teacher, Vidya Niketan Public School, Coimbatore",header:'It is really useful. It\u2019s not coming from the lips, \n        it\u2019s coming from the heart. Definitely children will be benefited if used constructively.',altText:"Ms.N Rama Devi"}];// {
//   id: 5,
//   type:"image",
//   src:tsoai,
//   urlstr:'none',
//   caption: "Tsoai",
//   occupation: "Free State Province, South Africa",
//   header: `I found the team capable and professional in their development of high quality material that 
//   will be used in our schools. The process that each lesson goes through before it becomes a final product, 
//   is of a high standard! This was a real Aha! experience for me.`,
//   altText:"Tsoai"
// },
// {
//   id: 7,
//   type:"image",
//   src:pulane,
//   urlstr:'none',
//   caption: "Pulane Phala", 
//   occupation: "Free State Province, South Africa",
//   header: `I cherish the co-founder of this programme and her team for their willingness 
//   to share their intelligent ideas to benefit us as officials and teachers and most importantly 
//   to benefit the schools in South Africa.`,
//   altText:"Pulane Phala"
// },
var TeacherTestimonial=function(_PreLoginSessionCheck){_inherits(TeacherTestimonial,_PreLoginSessionCheck);function TeacherTestimonial(props){_classCallCheck(this,TeacherTestimonial);var _this=_possibleConstructorReturn(this,(TeacherTestimonial.__proto__||Object.getPrototypeOf(TeacherTestimonial)).call(this,props));_this.state={isOpen:false};_this.openModal=_this.openModal.bind(_this);_this.goNext=_this.goNext.bind(_this);_this.goPrev=_this.goPrev.bind(_this);return _this;}_createClass(TeacherTestimonial,[{key:'openModal',value:function openModal(someValue){this.setState({isOpen:true});this.videoId=someValue;}},{key:'goNext',value:function goNext(){if(this.swiper)this.swiper.slideNext();}},{key:'goPrev',value:function goPrev(){if(this.swiper)this.swiper.slidePrev();}},{key:'loadimage',value:function loadimage(item){if(item.type=="image"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figure',{className:'figure'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:item.src,className:'figure-img img-fluid rounded',alt:item.altText}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figcaption',{className:'figure-caption'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtcaption'},item.caption),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtoccupation'},item.occupation)));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figure',{className:'figure'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:this.openModal.bind(null,item.urlstr)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:item.src,className:'figure-img img-fluid rounded videoimg',alt:item.altText}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figcaption',{className:'figure-caption'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtcaption'},item.caption),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtoccupation'},item.occupation)));}}},{key:'render',value:function render(){var _this2=this;var settings={dots:true,infinite:true,speed:500,slidesToShow:1,slidesToScroll:1,adaptiveHeight:true,autoplay:true,autoplaySpeed:3000,pauseOnHover:true};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'OurparFBSlider',className:'mtb our-student'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container justify-content-md-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'What teachers have to say about HeyMath!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stud-cont'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_slick___default.a,settings,function(){return items.map(function(fbcomm,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fbcont',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-12 col-md-12 col-lg-12 txtcont'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtpart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-4 col-md-4 col-lg-4 test-pic'},_this2.loadimage(items[index])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-8 col-md-8 col-lg-8 test-cont'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtimg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__public_img_l_quote_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'txtheader'},items[index].header)))));});}()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_modal_video___default.a,{channel:'youtube',isOpen:this.state.isOpen,videoId:this.videoId,onClose:function onClose(){return _this2.setState({isOpen:false});}}));}}]);return TeacherTestimonial;}(__WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (TeacherTestimonial);

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jeremiah.d745738f.png";

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/maheshwari.1ffc362c.jpg";

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/elizabeth.4fa2fc92.png";

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/karen.31ad12b7.jpg";

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tsoai.c75425a9.png";

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/meena.273e7053.jpg";

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pulane.ac5bb7a8.png";

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/rama.9881b030.jpg";

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__products_details_json__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__products_details_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__products_details_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_id_swiper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_id_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_id_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_lessonmenuiconwhite_png__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_lessonmenuiconwhite_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_icons_lessonmenuiconwhite_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var Topics=function(_PreLoginSessionCheck){_inherits(Topics,_PreLoginSessionCheck);function Topics(props){_classCallCheck(this,Topics);var _this=_possibleConstructorReturn(this,(Topics.__proto__||Object.getPrototypeOf(Topics)).call(this,props));_this.state={products_details:{}};_this.productDetails=localStorage.getItem('proDetail');_this.gradeID=localStorage.getItem('grade');_this.proID=localStorage.getItem('product');_this.url=_this.gradeID+'.json';_this.goNext=_this.goNext.bind(_this);_this.goPrev=_this.goPrev.bind(_this);_this.LessonTestMaps=window.LessonTestMaps||{};return _this;}_createClass(Topics,[{key:'componentDidMount',value:function componentDidMount(){var me=this;this.proID=localStorage.getItem('product');}},{key:'getProductDetails',value:function getProductDetails(){//console.log(JSON.parse(this.productDetails));
if(this.productDetails!={}&&this.productDetails!=undefined){return JSON.parse(this.productDetails);}}},{key:'goNext',value:function goNext(){if(this.swiper)this.swiper.slideNext();}},{key:'goPrev',value:function goPrev(){if(this.swiper)this.swiper.slidePrev();}},{key:'render',value:function render(){var _this2=this;var params={slidesPerView:1,spaceBetween:30,navigation:{nextEl:'.swiper-button-next',prevEl:'.swiper-button-prev'},containerClass:'swiper-container cbse-syllabus'};var productType="SPL - ";if(this.props.productBase=="plp"){productType="PLP - ";}this.proID=localStorage.getItem('product');var det=JSON.parse(this.getProductDetails()[this.proID].productDetails);var gradeName=this.getProductDetails()[this.proID].ClassName;var topics=det[0].topics;// console.log("topics  ::: ",det)
var topArray=[];var createGroupedArray=function createGroupedArray(arr,chunkSize){var groups=[],i;for(i=0;i<arr.length;i+=chunkSize){groups.push(arr.slice(i,i+chunkSize));}return groups;};var groupedArr=createGroupedArray(topics,6);//console.log("topic::",topics);
//console.log("groupedArr::",groupedArr);
var group=det[0].group;if(group){group=group.split(" ").join("").toLowerCase();}this.stitle=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Topics covered as per CBSE syllabus');try{this.stitle=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Topics covered as per CBSE syllabus - ',this.getProductDetails()[this.proID].ClassName);}catch(e){}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:"mtb whyhm student nomargintop "+this.props.owner},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container syllabus'},this.stitle,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/1.gif',alt:'Geometric pattern in Algebra topic'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/2.gif',alt:'Ratio and Proportion of water and land in the world map'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/3.gif',alt:'Large Numbers represented through Abacus'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/4.gif',alt:'Dollar currency notes piling up'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/5.gif',alt:'Measurement using a weighing scale'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/6.gif',alt:'Decimal number line shown in a conical flask'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/7.gif',alt:'Nets of a solid cylinder'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/8.gif',alt:'Square and square roots'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/9.gif',alt:'Symmetry in butterfly wings'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_id_swiper___default.a,{className:'student-slider',slidesPerView:params.slidesPerView,spaceBetween:params.spaceBetween,containerClass:params.containerClass,ref:function ref(node){if(node)_this2.swiper=node.swiper;}},groupedArr.map(function(j){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide',key:j},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,j.map(function(v){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:v},v);})));})),function(){if(topics.length>6){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slider-btns cbse-syllabus'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':productType+gradeName+" Topics covered as per CBSE syllabus - left arrow",className:'swiper-button-prev swp-prev',onClick:_this2.goPrev}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':productType+gradeName+" Topics covered as per CBSE syllabus - right arrow",className:'swiper-button-next swp-next',onClick:_this2.goNext}));}}())),function(){var gdname=gradeName.split(" ").join("").toLowerCase();if(gradeName=="Class 1"||gradeName=="Class 2"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center mt-50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-lg-9 col-sm-11 mx-auto text-left topicmapinforow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 col-12 clearfix greyborderright'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left pt-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'topicmapLessons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'material-icons',src:__WEBPACK_IMPORTED_MODULE_4__images_icons_lessonmenuiconwhite_png___default.a,alt:'Animated Lessons icon'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left pl-20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,_this2.LessonTestMaps[gdname].LessonsMapped)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Animated Lessons'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 col-12 norightpadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left pt-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'topicmaptests'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons',role:'img','aria-label':'Puzzles and activites icon'},'extension'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left pl-20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,_this2.LessonTestMaps[gdname].SolvedExamplesGameQuiz)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Activities, Games and Quizzes')))));}else if(gradeName=="Class 3"||gradeName=="Class 4"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center mt-50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-lg-10 col-sm-12 mx-auto text-left topicmapinforow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 col-12 clearfix greyborderright'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left pt-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'topicmapLessons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'material-icons',src:__WEBPACK_IMPORTED_MODULE_4__images_icons_lessonmenuiconwhite_png___default.a,alt:'Animated Lessons icon'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left pl-20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,_this2.LessonTestMaps[gdname].LessonsMapped)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Animated Lessons'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 col-12 norightpadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left pt-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'topicmaptests'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons',role:'img','aria-label':'Puzzles and activites icon'},'extension'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left pl-20 width85p'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,_this2.LessonTestMaps[gdname].SolvedExamplesGameQuiz)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Solved Examples, Activities, and Quizzes')))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center mt-50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row col-lg-7 col-md-8 col-12 mx-auto text-left topicmapinforow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 clearfix greyborderright'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left pt-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'topicmapLessons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'material-icons',src:__WEBPACK_IMPORTED_MODULE_4__images_icons_lessonmenuiconwhite_png___default.a,alt:'Animated Lessons icon'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left pl-20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,_this2.LessonTestMaps[gdname].LessonsMapped)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Animated Lessons'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left pt-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'topicmaptests'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons',role:'img','aria-label':'Puzzles and activites icon'},'assignment'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-left pl-20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,_this2.LessonTestMaps[gdname].DiagnosticTests)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Diagnostic Tests')))));}}()));}}]);return Topics;}(__WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Topics);

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Ga_js__ = __webpack_require__(123);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 className-style
var Trusted=function(_PreLoginSessionCheck){_inherits(Trusted,_PreLoginSessionCheck);function Trusted(){_classCallCheck(this,Trusted);return _possibleConstructorReturn(this,(Trusted.__proto__||Object.getPrototypeOf(Trusted)).apply(this,arguments));}_createClass(Trusted,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'product-main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'mar-adjust'},'Trusted by the best'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'trust-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'sub-heading'},'Academic collaborations'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'l-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'trust-img'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/t11.png',alt:''}),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'University of Cambridge')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'trust-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/t21.png',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Raffles Institution, Singapore')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'trust-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'sub-heading'},'Successfully implemented since 2001'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'l-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'trust-img'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/t31.png',alt:''}),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'CBSE, ICSE and IGCSE schools')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'trust-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/t41.png',alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Singapore MOE schools')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}))))));}}]);return Trusted;}(__WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Trusted);

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var iitStyle={backgroundImage:'url("../img/w1.png")',backgroundRepeat:'no-repeat',backgroundPosition:'center',backgroundSize:'cover'// ES6 class-style
};var Why=function(_PreLoginSessionCheck){_inherits(Why,_PreLoginSessionCheck);function Why(){_classCallCheck(this,Why);return _possibleConstructorReturn(this,(Why.__proto__||Object.getPrototypeOf(Why)).apply(this,arguments));}_createClass(Why,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'mtb whyhm why-heymath'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Why HeyMath!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-hmth'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-left bg-inline',role:'img','aria-label':'HeyMath! employees group photo',style:iitStyle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-right '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Backed by a team of passionate professionals from Cambridge, IIM, IIT and NID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'In May 2000, a group of talented people who love &  live Maths came together to spread their enthusiasm for the subject. They observed classroom practices of the finest of Math teachers around the world. The HeyMath! team then digitised its learnings into curriculum solutions that help every student achieve his or her best potential in Math. '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-hmth'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-left res-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/w2.png',alt:'University of Cambridge logo'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-right res-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Proven methodology that has successfully impacted 1 million students and 5000 teachers in 50 countries'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Right from our inception, experts at the University of Cambridge have helped shape HeyMath\'s rich teaching methodologies. Our approach is to strengthen conceptual understanding by emphasizing on both the \'why\' and the \'how\' and using real life contexts and interactive activities to drive the learning deeper. Our adaptive assessments provide personalised learning paths for students to achieve mastery.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'w-hmth w-col4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/w3.jpg',alt:'Maths & Interdisciplinary representation'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'We are much more than Math! We think interdisciplinary'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'What will set a student apart in the 21st century is multi-disciplinary thinking, creativity and problem solving skills. HeyMath! has been a pioneer in making interdisciplinary connections between ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://timesofindia.indiatimes.com/city/bengaluru/A-workshop-where-kids-can-learn-music-through-maths/articleshow/55611063.cms',target:'_blank',className:'btn-links','data-ga':'Home - Why HeyMath! - Music & Math'},'Math and Music'),', ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://www.thehindu.com/features/education/college-and-university/a-double-helix-lesson-to-beat-world-records/article7774567.ece',target:'_blank',className:'btn-links','data-ga':'Home - Why HeyMath! - Math & DNA'},'Math and DNA'),', ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://youtu.be/A1LMAOyhghI?list=PLTlcLjeiG_8uTAVrxk5frfWPeNKu208h8',target:'_blank',className:'btn-links','data-ga':'Home - Why HeyMath! - Math in Art History and Culture'},'Math in Art History and Culture'),'.'))))))));}}]);return Why;}(__WEBPACK_IMPORTED_MODULE_1__PreLoginSessionCheck_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Why);

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_id_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PreLoginSessionCheck_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal_video__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal_video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_modal_video__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_login_UserLoginType__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_login_Whatsapp_js__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_ProductConfig_json__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_ProductConfig_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__config_ProductConfig_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_core_PreLoginPage__ = __webpack_require__(2);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var ProductMenu=function(_PreLoginPage){_inherits(ProductMenu,_PreLoginPage);function ProductMenu(props){_classCallCheck(this,ProductMenu);var _this=_possibleConstructorReturn(this,(ProductMenu.__proto__||Object.getPrototypeOf(ProductMenu)).call(this,props));_this.state={error:null,isLoaded:false,items:[],ProductList:[],pro_detail:[],products:[],self:[],plp:[],products_details:{},products_category_order:[]};_this.grades=_this.props.grades;_this.productClass=_this.props.products_class;_this.productDetails=_this.props.products_details;_this.products_category=_this.props.products_category;_this.productClasses=_this.props.classes;_this.renderFooterProduct=_this.renderFooterProduct.bind(_this);_this.restricted=false;return _this;}_createClass(ProductMenu,[{key:'componentDidMount',value:function componentDidMount(){var _state=this.state,products=_state.products,self=_state.self,plp=_state.plp;this.grades=this.props.grades;this.productClass=this.props.products_class;this.productDetails=this.props.products_details;this.products_category=this.props.products_category;this.productClasses=this.props.classes;// console.log("this.state ",this.state,this.products_category)
}},{key:'loadlessoncomp',value:function loadlessoncomp(){var me=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,me.loadsplcomp(),me.loadplpcomp(),me.loadcbsecomp());}},{key:'getProdDetails',value:function getProdDetails(){//console.log(this.state.products_details);
if(this.state.products_details!=={}&&this.state.products_details!==undefined){return this.state.products_details;}}},{key:'renderFooterProduct',value:function renderFooterProduct(product,grade){var _this2=this;//console.log(product,", ",grade,", ",this.productClasses);
if(product&&grade&&this.products_category&&this.products_category[product]&&this.products_category[product].hasOwnProperty(grade)){var restricted="";if(this.GradeRestrictionManager.isGradeRestricted(grade)){restricted="restricted";this.restricted=true;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:grade},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:restricted,id:this.productClasses[grade].ClassName,'data-ga':'Classes - Menu - '+__WEBPACK_IMPORTED_MODULE_7__config_ProductConfig_json___default.a[product].ganame+' - '+this.productClasses[grade].ClassName,onClick:function onClick(){return _this2.saveID(''+grade,''+_this2.products_category[product][grade],__WEBPACK_IMPORTED_MODULE_7__config_ProductConfig_json___default.a[product].url+_this2.products_category[product][grade]);}},this.productClasses[grade].ClassName,function(){if(restricted=="restricted"){return"*";}}()));}}},{key:'saveID',value:function saveID(grade,proID,link){var products_details=this.state.products_details;var me=this;var callBackSuccess=function callBackSuccess(result){if(result!==null){me.setState({products_details:result}),//console.log("Footer:::",me.getProdDetails());
localStorage.setItem('grade',grade);localStorage.setItem('product',proID);localStorage.setItem('proDetail',JSON.stringify(me.getProdDetails()));window.top.location.href=link;}//console.log("response : ", response);
};var callBackFailure=function callBackFailure(response){me.setState({isLoaded:true,error:"Error in Footer PRODUCT_JSON"});console.log("Error in Footer PRODUCT_JSON in Grade");};var formData={"levelId":grade};new __WEBPACK_IMPORTED_MODULE_8__util_HmAjax__["a" /* default */](this.getUrlFor("PRODUCT_JSON"),formData).post(callBackSuccess,callBackFailure);//console.log(grade);
//console.log(proID);
}},{key:'loadsplcomp',value:function loadsplcomp(){var me=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'splwell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'spltxt'},this.rb("SPL")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row atagalign'},me.orderProducts(me.state.products_category_order).map(function(product){if(me.checkRestrictedGrade(product,me.grades)==false){if(product=="SPL"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'aelement',key:product},me.grades.map(function(grade){return me.renderFooterProduct(product,grade);}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));}}})));}},{key:'loadplpcomp',value:function loadplpcomp(){var me=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'splwell'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'plptxt'},this.rb("PLP")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row atagalign'},me.orderProducts(me.state.products_category_order).map(function(product){if(me.checkRestrictedGrade(product,me.grades)==false){if(product=="PLP"||product=="EXAM_PREP_CBSE"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'aelement',key:product},me.grades.map(function(grade){return me.renderFooterProduct(product,grade);}));}}})));}},{key:'checkRestrictedGrade',value:function checkRestrictedGrade(product,grades){//console.log("grades:::",grades, ", ",product);
//console.log(this.products_category, ", ",product,", ",this.products_category[product],", ",this.products_category[product].hasOwnProperty("11"));
var restrictedAvailable=false;if(grades&&grades.length>0){for(var i=0;i<grades.length;i++){if(product&&this.products_category&&this.products_category[product]&&this.products_category[product].hasOwnProperty(grades[i])){if(this.GradeRestrictionManager.isGradeRestricted(grades[i])){restrictedAvailable=true;break;}}}}else{restrictedAvailable=true;}return restrictedAvailable;}},{key:'orderProducts',value:function orderProducts(obj){if(obj&&(typeof obj==='undefined'?'undefined':_typeof(obj))==="object"){//console.log("Object.values(obj) "+Object.values(obj))
return Object.values(obj);}else{return[];}}},{key:'render',value:function render(){var _state2=this.state,products=_state2.products,self=_state2.self,plp=_state2.plp;this.grades=this.props.grades;this.grades_order=this.props.grades_order;this.productClass=this.props.products_class;this.productDetails=this.props.products_details;this.products_category=this.props.products_category;this.productClasses=this.props.classes;this.state.products_category_order=this.props.products_category_order;var tifOptions=[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'productmenu',className:'dropdown-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dropdown-item'},this.loadsplcomp()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dropdown-item'},this.loadplpcomp()));}}]);return ProductMenu;}(__WEBPACK_IMPORTED_MODULE_9__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ProductMenu);

/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FlipBox__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SampleLessonLayout__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_id_swiper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_id_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_id_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_slick__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_plp_TestTakingModalComponent__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_purchase_TchrBillingForm__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_NativeAjax__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_purchase_CouponCodeModel__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_purchase_CouponCodeLayout__ = __webpack_require__(504);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var settings={dots:false,infinite:false,speed:300,slidesToShow:5,slidesToScroll:5,responsive:[{breakpoint:1370,settings:{slidesToShow:5,slidesToScroll:5,infinite:false,dots:false}},{breakpoint:1100,settings:{slidesToShow:4,slidesToScroll:4,infinite:false,dots:false}},{breakpoint:767,settings:{slidesToShow:3,slidesToScroll:3}},{breakpoint:550,settings:{slidesToShow:2,slidesToScroll:2}// You can unslick at a given breakpoint now by adding:
// settings: "unslick"
// instead of a settings object
}]};var TeacherProdComp=function(_PreLoginPage){_inherits(TeacherProdComp,_PreLoginPage);function TeacherProdComp(props){_classCallCheck(this,TeacherProdComp);var _this=_possibleConstructorReturn(this,(TeacherProdComp.__proto__||Object.getPrototypeOf(TeacherProdComp)).call(this,props));_this.state={tchrdata:{},chooseGrade:null,products_details:{},OPSAvailable:false,ModalShow:false,review_order:false,BillingFormShow:false,currentGradeIndex:0,dataLoaded:false,teacherLessonsList:null,selectedGrade:'',purchaseObj:null,noData:false,couponApplied:false,SubscribeModal:false,trackId:0,couponCodeTracked:false};_this.swiper=null;_this.productCateBox=_this.productCateBox.bind(_this);_this.renderClassTab=_this.renderClassTab.bind(_this);_this.similarLessonList={};_this.productsJson={};//this.purchaseObj = null;
_this.appDetails={};_this.tchrgradeOrder=[];_this.productEvt=null;_this.teacherLumosProduct=null;_this.showBillingForm=_this.showBillingForm.bind(_this);_this.renderbillingForm=_this.renderbillingForm.bind(_this);_this.showOrderReview=_this.showOrderReview.bind(_this);_this.hideBillingModal=_this.hideBillingModal.bind(_this);_this.hideReviewModal=_this.hideReviewModal.bind(_this);_this.teachergradeSwiper=_this.teachergradeSwiper.bind(_this);_this.couponValidFn=_this.couponValidFn.bind(_this);_this.setTrackId=_this.setTrackId.bind(_this);_this.SuccesscallBackFn=_this.SuccesscallBackFn.bind(_this);_this.hideSubscribeModal=_this.hideSubscribeModal.bind(_this);return _this;}_createClass(TeacherProdComp,[{key:'couponValidFn',value:function couponValidFn(response){if(response&&(typeof response==='undefined'?'undefined':_typeof(response))=="object"){this.SuccesscallBackFn(response);this.setState({couponApplied:true});}}},{key:'setTrackId',value:function setTrackId(trackId,couponCodeTracked){this.setState({trackId:trackId,couponCodeTracked:couponCodeTracked});}},{key:'componentWillMount',value:function componentWillMount(){var me=this;var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status==='active'){me.setState({OPSAvailable:true});}}//console.log("OPS_DETECT response : ", response);
};var callBackFailure=function callBackFailure(response){console.log("Error in OPS_DETECT");};new __WEBPACK_IMPORTED_MODULE_8__util_HmAjax__["a" /* default */](this.getUrlFor("OPS_DETECT")).get(callBackSuccess,callBackFailure);// try {
// 	this.userObj = JSON.parse(BrowserStorageUtil.getStoredItem(this.userDataKey));
// 	//console.log("userobj::",this.userObj);
// 	for(var key in this.userObj){
// 		this.userId = this.userObj[key].USER_DETAILS.userId;
// 		this.userCountryCode = this.userObj[key].USER_DETAILS.countryCode;
// 	}
// } catch (e) {}
}},{key:'componentDidMount',value:function componentDidMount(){var me=this;try{var refUrl=document.referrer;var centaRef=me.callByReferer(refUrl);var userLoggedIn=this.getUser().getUserId()&&this.getUser().getUserId().length>0?true:false;var userOrigin=this.getUser().getUserOrigin();var couponcodeCenta=this.getAttribute("couponcodeCenta")||'';var AllowUserOrigin=me.callByOrigin(userOrigin);if(centaRef&&!userLoggedIn||AllowUserOrigin&&userLoggedIn&&couponcodeCenta===""){me.setState({SubscribeModal:true});}else if(AllowUserOrigin&&couponcodeCenta===""){me.setState({SubscribeModal:true});}me.tchrgetProductDetails();}catch(e){console.error("Error occurred while couponcode",e);}}},{key:'SuccesscallBackFn',value:function SuccesscallBackFn(response){var me=this;if(response!==null){me.productsJson=response;var sortedProducts=me.sortTeacherProducts(response);me.teacherLumosProduct=sortedProducts[0];if(response.categories&&response.categories.TCHR_SPL){var tchrdata=Object.values(response.categories.TCHR_SPL.grade_wise);if(tchrdata&&tchrdata.length>0){me.tchrgradeOrder=[];tchrdata.map(function(gradeList,index){me.tchrgradeOrder.push(gradeList.gradeDisplayName);});var teacherLessonsList=null;var gradeName=tchrdata[0].gradeDisplayName.toLowerCase().replace(/\s/g,'')||'';var TeacherLessonMaps=window.TeacherLessonMaps||{};teacherLessonsList=TeacherLessonMaps[gradeName];me.setState({teacherLessonsList:teacherLessonsList,chooseGrade:tchrdata[0].gradeDisplayName,tchrdata:tchrdata,dataLoaded:true,currentGradeIndex:0,selectedGrade:gradeName});//chooseGrade:tchrdata[0].gradeDisplayName,
}else{me.setState({noData:true});}}else{me.setState({noData:true});}}}},{key:'tchrgetProductDetails',value:function tchrgetProductDetails(){var me=this;var callBackSuccess=function callBackSuccess(response){me.SuccesscallBackFn(response);};var callBackFailure=function callBackFailure(response){me.setState({noData:true});console.log("Error in PRODUCT_DETAILS");};new __WEBPACK_IMPORTED_MODULE_11__util_NativeAjax__["a" /* default */](this.getUrlFor("TCHR_PRODUCTS")).enableCORS().post(callBackSuccess,callBackFailure);}},{key:'sortTeacherProducts',value:function sortTeacherProducts(data){var products=data&&data.productList&&data.productList.length>0?data.productList:[];var tchrProducts=[];var filterProductCategories=window.teacherProdProducts||[];var appName=data.appName;var appId=data._appId;this.appDetails.appName=appName;this.appDetails.appId=appId;if(products.length>0){for(var i=0;i<products.length;i++){if(filterProductCategories&&filterProductCategories.length>0&&filterProductCategories.indexOf(products[i].productCategory)>-1){products[i]["appName"]=appName;products[i]["appId"]=appId;tchrProducts.push(products[i]);}else if((!filterProductCategories||filterProductCategories.length==0)&&!isNaN(products[i].productCategory)){products[i]["appName"]=appName;products[i]["appId"]=appId;tchrProducts.push(products[i]);}}}//console.warn("tchr prod",tchrProducts);
return tchrProducts;}},{key:'showBillingForm',value:function showBillingForm(productObj){var me=this;var userLoggedIn=this.getUser().getUserId()&&this.getUser().getUserId().length>0?true:false;//React.unmountComponentAtNode(document.getElementById('tchrbilling'));
if(productObj&&productObj.productId){if(this.state.purchaseObj&&this.state.purchaseObj.productId){//Product already exists
if(this.state.purchaseObj.productId!==productObj.productId){this.setState({purchaseObj:null,BillingFormShow:false,ModalShow:false});}}}else{return;}var tempFunc=function tempFunc(){if(typeof me.props.postLoginCallBack==="function"){me.props.postLoginCallBack();}userLoggedIn=me.getUser().getUserId()&&me.getUser().getUserId().length>0?true:false;if(productObj&&productObj.productId){me.purchaseObj=productObj;me.setState({purchaseObj:productObj,BillingFormShow:true,ModalShow:true});}};if(!userLoggedIn){if(typeof this.props.showSubscriptionForm==="function"){console.warn("productObj ",productObj);var gradeName=productObj.gradeName.toLowerCase().replace(/\s/g,'')||'';var productName=productObj.productName.toLowerCase().replace(/\s/g,'')||'';this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":gradeName+"-"+productName+"-subscribebtn"});this.props.showSubscriptionForm(tempFunc);}}else{tempFunc();}}},{key:'hideBillingModal',value:function hideBillingModal(){// Shyam
/*
        * IMPORTANT: It is very IMPORTANT to unmount the Billing form.
        */this.setState({ModalShow:false});}},{key:'showOrderReview',value:function showOrderReview(){this.setState({review_order:true});}},{key:'hideReviewModal',value:function hideReviewModal(){this.setState({review_order:false});}},{key:'hideSubscribeModal',value:function hideSubscribeModal(){this.setState({SubscribeModal:false});}},{key:'renderCouponCodeModel',value:function renderCouponCodeModel(){if(!this.state.couponApplied){var couponCode=this.getAttribute("couponcodeCenta")||'';return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__views_purchase_CouponCodeModel__["a" /* default */],Object.assign({},this.props,{couponCode:couponCode,setTrackId:this.setTrackId,couponApplied:this.state.couponApplied,hideSubscribeModal:this.hideSubscribeModal,showSubscriptionForm:this.props.showSubscriptionForm,callBackParent:this.couponValidFn,SubscribeModal:this.state.SubscribeModal,couponCodeTracked:this.state.couponCodeTracked}));}}},{key:'callByReferer',value:function callByReferer(url){var couponTrackers=window.couponTrackers||{};if(url&&couponTrackers){for(var i in couponTrackers){if(url.match(i)){return true;}}}return false;}},{key:'callByOrigin',value:function callByOrigin(origin){var couponPopup=window.couponPopup||[];if(origin&&origin.length>1&&couponPopup&&couponPopup.length>0){return~couponPopup.indexOf(origin)?true:false;}return false;}},{key:'renderbillingForm',value:function renderbillingForm(){var _this2=this;//console.log("renderbilling Form ",this.state.ModalShow);
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__views_plp_TestTakingModalComponent__["a" /* default */],{visible:this.state.ModalShow,dialogClassName:'modal-md'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'loginHeader text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'text-center modallogo loginHeaderTxt'},this.rb("billing.information")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'close loginClose',onClick:this.hideBillingModal,'aria-label':'Close'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{'aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'material-icons'},'close')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-body'},function(){if(_this2.state.purchaseObj&&_this2.state.ModalShow){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__views_purchase_TchrBillingForm__["a" /* default */],{trackId:_this2.state.trackId,purchaseObj:_this2.state.purchaseObj,productsJson:_this2.productsJson,myProps:_this2.props,ModalShow:_this2.state.ModalShow,showBillingForm:_this2.showBillingForm,hideBillingModal:_this2.hideBillingModal,review_order:_this2.state.review_order,showOrderReview:_this2.showOrderReview,hideReviewModal:_this2.hideReviewModal,purchaseKey:_this2.state.purchaseKey});}else if(!_this2.state.ModalShow){return null;}}())));}},{key:'renderClassTab',value:function renderClassTab(list,indVal){if(this.state.chooseGrade==list){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'swiper-slide',key:indVal},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'swiper-active','data-grade':list,'data-index':indVal,onClick:this.gradeTabClickFn.bind(this)},list)));}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'swiper-slide',key:indVal},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'grade','data-grade':list,'data-index':indVal,onClick:this.gradeTabClickFn.bind(this)},list)));}}},{key:'teachergradeSwiper',value:function teachergradeSwiper(){var _this3=this;var me=this;if(me.state.tchrdata&&me.state.tchrdata!=null&&me.tchrgradeOrder.length>0){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row tchrswiper'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'swiper-container row allMiddle'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-sm-12 col-xs-12 col-md-12 col-lg-12 imgGal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-12 text-center scorecardLessons'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_slick___default.a,settings,me.tchrgradeOrder.map(function(list,index){return _this3.renderClassTab(list,index);}))))));}}},{key:'gradeTabClickFn',value:function gradeTabClickFn(e){//console.warn("grade ",e.target.dataset.index);
var allElements=Array.from(document.querySelectorAll('.swiper-active'));var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=allElements[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var element=_step.value;if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).hasClass('swiper-active')){element.classList.remove('swiper-active');element.classList.add('grade');}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}if(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).hasClass('grade')){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).removeClass('grade');__WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).addClass("swiper-active");}var teacherLessonsList=null;var gradeName=this.state.tchrdata[e.target.dataset.index].gradeDisplayName.toLowerCase().replace(/\s/g,'')||'';var TeacherLessonMaps=window.TeacherLessonMaps||{};teacherLessonsList=TeacherLessonMaps[gradeName];__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".tchrprodanim").animate({opacity:0},"fast",function(){__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".tchrprodanim").animate({opacity:1});});this.setState({teacherLessonsList:teacherLessonsList,selectedGrade:gradeName,currentGradeIndex:e.target.dataset.index,chooseGrade:e.target.dataset.grade});}},{key:'productCateBox',value:function productCateBox(){var _this4=this;var me=this;var gradeData=null;if(me.state.tchrdata&&me.state.tchrdata!=null&&me.tchrgradeOrder.length>0&&me.state.teacherLessonsList){gradeData=me.state.tchrdata[me.state.currentGradeIndex].tariffDetails;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'flex-container'},function(){return Object.values(gradeData).map(function(gradeBox,index){var productDetails=gradeBox.productDetails;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FlipBox__["a" /* default */],{key:index,OPSAvailable:me.state.OPSAvailable,teacherLessonsList:me.state.teacherLessonsList[index],gradeBox:gradeBox,productDetails:productDetails,gradeName:me.state.selectedGrade,showBillingForm:me.showBillingForm,appDetails:_this4.appDetails});});}());}}},{key:'getSampleLessons',value:function getSampleLessons(){var me=this;if(me.state.tchrdata[me.state.currentGradeIndex].sampleLessons){var sampleLessons=me.state.tchrdata[me.state.currentGradeIndex].sampleLessons;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SampleLessonLayout__["a" /* default */],{sampleLessons:sampleLessons});}}},{key:'getBuyOptions',value:function getBuyOptions(){if(this.state.BillingFormShow&&this.state.purchaseObj){return this.renderbillingForm();}}},{key:'getProductBoxes',value:function getProductBoxes(){if(this.state.currentGradeIndex>=0&&this.state.tchrdata){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tchrprodanim'},this.getSampleLessons(),this.productCateBox(),this.getBuyOptions());}}},{key:'couponLayout',value:function couponLayout(){var userLoggedIn=this.getUser().getUserId()&&this.getUser().getUserId().length>0?true:false;var userOrigin=this.getUser().getUserOrigin();var boxlocked='';if(this.state.couponApplied){boxlocked="disabled";}var couponCode=this.getAttribute("couponcodeCenta")||'';return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"CouponCodeBoxLayout "+boxlocked},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__views_purchase_CouponCodeLayout__["a" /* default */],Object.assign({},this.props,{couponCode:couponCode,couponApplied:this.state.couponApplied,showSubscriptionForm:this.props.showSubscriptionForm,setTrackId:this.setTrackId,callBackParent:this.couponValidFn,couponCodeTracked:this.state.couponCodeTracked})));}},{key:'render',value:function render(){var _this5=this;var me=this;if(this.state.dataLoaded){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tchrprodcomp container'},function(){if(me.state.chooseGrade){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},function(){if(!_this5.state.SubscribeModal){return me.couponLayout();}}(),me.teachergradeSwiper()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('hr',null),me.getProductBoxes(),function(){if(_this5.state.SubscribeModal){return me.renderCouponCodeModel();}}());}}());}else if(this.state.noData){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null);}else{return _get(TeacherProdComp.prototype.__proto__||Object.getPrototypeOf(TeacherProdComp.prototype),'render',this).call(this);}}}]);return TeacherProdComp;}(__WEBPACK_IMPORTED_MODULE_2__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (TeacherProdComp);

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OrderReview_js__ = __webpack_require__(193);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TchrOrderReview=function(_OrderReview){_inherits(TchrOrderReview,_OrderReview);function TchrOrderReview(props){_classCallCheck(this,TchrOrderReview);return _possibleConstructorReturn(this,(TchrOrderReview.__proto__||Object.getPrototypeOf(TchrOrderReview)).call(this,props));}_createClass(TchrOrderReview,[{key:'componentWillMount',value:function componentWillMount(){_get(TchrOrderReview.prototype.__proto__||Object.getPrototypeOf(TchrOrderReview.prototype),'componentWillMount',this).call(this);}},{key:'render',value:function render(){var me=this;if(this.props.reviewData){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'confirm-dialog',className:'mdl-dialog'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{align:'center',cellPadding:'0',cellSpacing:'0',className:'container-for-gmail-android',width:'100%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center',valign:'top',width:'100%',className:'content-padding billingReviewTop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellSpacing:'0',cellPadding:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'free-text'},this.rb("label.review_the_order"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mini-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'header-sm'},this.rb("label.billing_address")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'review-billing-name'},this.props.reviewData.fullName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'review-address-1'},this.props.reviewData.address),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'review-address-2'},this.getAddrss2()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'review-address-3'},this.props.reviewData.country))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mini-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'header-sm'},this.rb("label.email_address")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'review-email'},this.props.reviewData.email))))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{align:'center',valign:'top',width:'100%',className:'splitblock'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellPadding:'0',cellSpacing:'0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'item-table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{cellSpacing:'0',cellPadding:'0',width:'100%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',{id:'confirm-cart'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'title-dark',width:'200'},this.rb("label.order_item")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'title-dark table-pull-right',width:'100'},this.rb("label.order_validity")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'title-dark table-pull-right',width:'100'},this.rb("label.order_quantity")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'title-dark table-pull-right',width:'70'},this.rb("label.order_currency")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'title-dark table-pull-right',width:'100'},this.rb("label.order_total"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'item-template'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'item-col item bold4dcolor'},this.props.reviewData.productName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'item-col validity table-pull-right'},this.props.reviewData.validity),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'item-col quantity table-pull-right'},'1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'item-col table-pull-right pt4'},this.props.reviewData.currency),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'item-col price table-pull-right'},this.props.reviewData.price)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'item-col'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'item-col'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'item-col quantity subtotal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'total-space'},this.rb("label.order_subtotal")),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'total-space'},this.rb("label.order_gst")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'total-space bold4dcolor'},this.rb("label.order_total"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'item-col table-pull-right topbdr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'total-space currency'},this.props.reviewData.currency),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'total-space currency'},this.props.reviewData.currency),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'total-space currency bold4dcolor'},this.props.reviewData.currency),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'item-col price table-pull-right topbdr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'total-space transx4'},Number(this.props.reviewData.basePrice).toFixed(2)),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'total-space'},Number(this.props.reviewData.taxAmount).toFixed(2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'total-space bold4dcolor'},Number(this.props.reviewData.totalAmount).toFixed(2)))))))))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mdl-dialog__actions clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-ga':this.props.reviewData.selectedProductCategoryTypeGA+" - "+this.props.reviewData.selectedProductClassName+" - "+"Proceed to pay",type:'button',className:'submitButton pay float-right',onClick:this.props.proceedPay},this.rb("label.order_proceed_to_pay")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-ga':this.props.reviewData.selectedProductCategoryTypeGA+" - "+this.props.reviewData.selectedProductClassName+" - "+"Edit Details",type:'button',className:'submitButton go-back float-right',onClick:this.props.hideReviewModal},this.rb("label.order_edit_details"))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}}]);return TchrOrderReview;}(__WEBPACK_IMPORTED_MODULE_4__OrderReview_js__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (TchrOrderReview);

/***/ }),
/* 1245 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/teachersday.6a616be7.png";

/***/ }),
/* 1248 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_core_LoggedInPage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AccordionLayout__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_plp_TestTakingModalComponent__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_loader_spinner__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_loader_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_loader_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ViewSolutionLayout__ = __webpack_require__(1251);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Diagnostic=function(_LoggedInPage){_inherits(Diagnostic,_LoggedInPage);function Diagnostic(props){_classCallCheck(this,Diagnostic);var _this=_possibleConstructorReturn(this,(Diagnostic.__proto__||Object.getPrototypeOf(Diagnostic)).call(this,props));_this.state={dataLoaded:false,dataUpdated:false,testModalView:"",testModalShow:false,testModalContent:"loading"};_this.loadDiagnostic=_this.loadDiagnostic.bind(_this);_this.showSolnModal=_this.showSolnModal.bind(_this);return _this;}_createClass(Diagnostic,[{key:'componentDidMount',value:function componentDidMount(){///this.getReportTab();
}},{key:'getColor',value:function getColor(percentage,status){var percArr=window.diagnosticColor||['#9c9e9f','#F73E21','#fb9100','#7cb045'];var clrval=percArr[1];if(status&&status.toUpperCase()==="NEW"){clrval=percArr[0];}else if(percentage>=41&&percentage<=70){clrval=percArr[2];}else if(percentage>70&&percentage<=100){clrval=percArr[3];}return clrval;}},{key:'loadsubTopicasTile',value:function loadsubTopicasTile(diagdata){var me=this;if(diagdata!=null){if(diagdata.subTopics){return Object.values(diagdata.subTopics).map(function(diagsubTopics,index){var colorStyle={backgroundColor:me.getColor(diagsubTopics.percentage,diagsubTopics.status),color:'white'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'subtopiccont',style:colorStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subtopbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,diagsubTopics.subTopicName)));});}}}},{key:'loadsubTopicasBanner',value:function loadsubTopicasBanner(diagdata){var borStrg=this.isMobile()?"1rem solid ":"1.5rem solid ";var me=this;if(diagdata!=null){if(diagdata.subTopics){return Object.values(diagdata.subTopics).map(function(diagsubTopics,index){var colorStyle={border:"1px solid "+me.getColor(diagsubTopics.percentage,diagsubTopics.status),borderLeft:borStrg+me.getColor(diagsubTopics.percentage,diagsubTopics.status)};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'subtopiccontBan',style:colorStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'subtopbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,diagsubTopics.subTopicDesc||diagsubTopics.subTopicName)));});}}}},{key:'showSolnModal',value:function showSolnModal(data,idx){console.log("lalalal data ::",data);var accessId=this.props.reportData.accessId;var classId=this.props.reportData.classId;var diagnosticType=this.props.reportData.diagnosticType;var benchMarkType=this.props.reportData.benchMarkType;var topicId=data.topicId||0;var topicName=data.topic||"";__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ViewSolutionLayout__["a" /* default */],{accessId:accessId,classId:classId,benchMarkType:benchMarkType,diagnosticType:diagnosticType,topicId:topicId,topicName:topicName,unMount:this.hideSolnModal}),document.getElementById("diag_view_solns_modal"));}},{key:'hideSolnModal',value:function hideSolnModal(){__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(null,document.getElementById("diag_view_solns_modal"));}},{key:'getTitleContent',value:function getTitleContent(diagdata){var me=this;return diagdata.topic;}},{key:'getBodyContent',value:function getBodyContent(diagdata,index){var _this2=this;var me=this;//console.warn("lalalal 3 : ", diagdata)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faqcnt'},function(){if(diagdata.status==="COMPLETED"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-right bottomBtns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-primary largeBtn',onClick:me.showSolnModal.bind(_this2,diagdata,index)},'View Solutions'));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-containerBan'},me.loadsubTopicasBanner(diagdata)));}},{key:'loadDiagnostic',value:function loadDiagnostic(){console.log("lalalala 2::",this.props);var me=this;if(me.props.reportData&&me.props.reportData!=null){var benchMarkData=me.props.reportData.benchMarkData;if(benchMarkData!=null){if(benchMarkData.diagnostic_report){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'diagnosticRep'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},benchMarkData.diagnostic_report.map(function(diagdata,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AccordionLayout__["a" /* default */],{key:index,titleContent:me.getTitleContent(diagdata),bodyContent:me.getBodyContent(diagdata,index)});})));}}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center loadingAnim'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_loader_spinner___default.a,{type:'Oval',color:'#00BFFF',height:'100',width:'100'}));}}},{key:'render',value:function render(){var me=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,me.loadDiagnostic(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'diag_view_solns_modal',style:{zIndex:3}}));}}]);return Diagnostic;}(__WEBPACK_IMPORTED_MODULE_2__views_core_LoggedInPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Diagnostic);

/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AccordionLayout=function(_Component){_inherits(AccordionLayout,_Component);function AccordionLayout(props){_classCallCheck(this,AccordionLayout);var _this=_possibleConstructorReturn(this,(AccordionLayout.__proto__||Object.getPrototypeOf(AccordionLayout)).call(this,props));_this.state={accordion:false};_this.handleChange=_this.handleChange.bind(_this);return _this;}_createClass(AccordionLayout,[{key:'getTitleContent',value:function getTitleContent(){if(this.props.titleContent){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.titleContent,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'acc_close'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'add')));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Accordian Title ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'acc_close'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'add')));}}},{key:'getBodyContent',value:function getBodyContent(){if(this.props.bodyContent){return this.props.bodyContent;}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Accordian Body');}}},{key:'handleChange',value:function handleChange(e){var me=this;var node=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this);var child=null;if(node&&node instanceof HTMLElement){child=node.children&&node.children.length>0?node.children[0]:null;//console.log("Accordian Triggered ",child);
}if(child&&this.state.accordion){__WEBPACK_IMPORTED_MODULE_3_jquery___default()(child).find(".acc_close").removeClass("minus");__WEBPACK_IMPORTED_MODULE_3_jquery___default()(child).find(".acc_close").addClass("plus");__WEBPACK_IMPORTED_MODULE_3_jquery___default()(child).find(".acc_close").html('<i class="material-icons">add</i>');me.setState({accordion:false});}else if(child){__WEBPACK_IMPORTED_MODULE_3_jquery___default()(child).find(".acc_close").removeClass("plus");__WEBPACK_IMPORTED_MODULE_3_jquery___default()(child).find(".acc_close").addClass("minus");__WEBPACK_IMPORTED_MODULE_3_jquery___default()(child).find(".acc_close").html('<i class="material-icons">remove</i>');me.setState({accordion:true});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["Accordion"],{id:'AccordionLayout',onChange:this.handleChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItem"],{expanded:this.props.expanded||false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItemTitle"],null,this.getTitleContent()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_accessible_accordion__["AccordionItemBody"],null,this.getBodyContent())));}}]);return AccordionLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AccordionLayout);

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_LoaderMask__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_core_LoggedInPage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_plp_TestTakingModalComponent__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_loader_spinner__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_loader_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_loader_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InfoDetail__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_question_WebQuestionPanel__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_ultimate_pagination_material_ui__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_ultimate_pagination_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_ultimate_pagination_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_styles_MuiThemeProvider__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_styles_MuiThemeProvider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_styles_MuiThemeProvider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_question_AbstractQuestionPanel__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}__WEBPACK_IMPORTED_MODULE_11_jquery___default.a.fn.inView=function(){var elementTop=__WEBPACK_IMPORTED_MODULE_11_jquery___default()(this).offset().top;var elementBottom=elementTop+__WEBPACK_IMPORTED_MODULE_11_jquery___default()(this).outerHeight();var viewportTop=__WEBPACK_IMPORTED_MODULE_11_jquery___default()("#questionsParent").scrollTop();var viewportBottom=viewportTop+__WEBPACK_IMPORTED_MODULE_11_jquery___default()(window).height();return elementBottom>viewportTop&&elementTop<viewportBottom;};var ViewSolutionLayout=function(_LoggedInPage){_inherits(ViewSolutionLayout,_LoggedInPage);function ViewSolutionLayout(props){_classCallCheck(this,ViewSolutionLayout);var _this=_possibleConstructorReturn(this,(ViewSolutionLayout.__proto__||Object.getPrototypeOf(ViewSolutionLayout)).call(this,props));_this.state={dataLoaded:false,testModalView:"",testModalShow:true,testModalContent:"loading",currentScrollIndex:1};_this.infoData=null;_this.questionData=[];_this.data=null;_this.testId=0;_this.questions=[];_this.scoreCalculated=false;_this.questionTypeCount=0;_this.questionCount=0;_this.attemptCount=0;_this.unAttemptedCount=0;_this.partialCorrect=0;_this.questionsCorrect=0;_this.questionsIncorrect=0;_this.totalScore=0;_this.userScore=0;_this.testMode=1;_this.renderQuestions=_this.renderQuestions.bind(_this);_this.renderQuestionInfo=_this.renderQuestionInfo.bind(_this);_this.viewSolnModal=_this.viewSolnModal.bind(_this);_this.hideTestModal=_this.hideTestModal.bind(_this);_this.setModalClass=_this.setModalClass.bind(_this);_this.setModalBackdropClose=_this.setModalBackdropClose.bind(_this);_this.onPageChange=_this.onPageChange.bind(_this);//this.scrollFinished = this.scrollFinished.bind(this);
_this.isScrollPreset=false;return _this;}_createClass(ViewSolutionLayout,[{key:'componentDidMount',value:function componentDidMount(){var me=this;var scrollTimer=-1;__WEBPACK_IMPORTED_MODULE_11_jquery___default()("#questionsParent").scroll(function(event){if(me.isScrollPreset==false){var element=document.getElementById("qindex-"+me.state.currentScrollIndex);if(me.state.currentScrollIndex!=0&&__WEBPACK_IMPORTED_MODULE_11_jquery___default()(element).inView()==false){me.setState({currentScrollIndex:0});}}if(scrollTimer!=-1)clearTimeout(scrollTimer);scrollTimer=setTimeout(function(){me.isScrollPreset=false;},500);});this.loadQuestionData();console.log("ViewSolutionLayout");}},{key:'onPageChange',value:function onPageChange(page){//console.log(page);
this.isScrollPreset=true;this.setState({currentScrollIndex:page});var element=document.getElementById("qindex-"+page);element.scrollIntoView({behavior:'smooth',block:"start"});}},{key:'loadQuestionData',value:function loadQuestionData(){var _this2=this;var me=this;var success=function success(resp){me.data=resp;me.infoData=resp;console.log("resp lalala ::",resp);//Setting questionData
_this2.questionData=resp&&resp.transcripts&&resp.transcripts.length>0?resp.transcripts:[];me.calculateQuestionCount();me.setState({dataLoaded:true});};var failure=function failure(err){};var url=this.getUrlFor("DIAG_SOLNS_BY_TOPIC");url=url.replace("{classId}",this.props.classId).replace("{accessId}",this.props.accessId).replace("{skillId}",this.props.topicId);new __WEBPACK_IMPORTED_MODULE_5__util_HmAjax__["a" /* default */](url).get(success,failure);}},{key:'calculateQuestionCount',value:function calculateQuestionCount(){if(!this.scoreCalculated){this.testMode=this.data.testDetails&&this.data.testDetails.mode?this.data.testDetails.mode:1;if(this.testMode===1){this.calculateScoreForTest();}else if(this.testMode===2){this.calculateScoreForStandard();}else if(this.testMode===3){this.calculateScoreForAdaptive();}this.scoreCalculated=true;}}},{key:'calculateScoreForTest',value:function calculateScoreForTest(){var me=this;try{this.data.transcripts.map(function(transcript,index){try{me.questionTypeCount++;if(transcript.attempts===null||transcript.attempts.length<=0){me.unAttemptedCount++;me.questionCount++;}else{transcript.attempts.map(function(attempt,index){//Push additional details to attempt object 
attempt.questionNo=transcript.questionNo;attempt.testMode="TEST";//This method pushes the question to renderer array
me.populateQuestions(attempt);me.totalScore+=attempt.marks;me.questionCount++;if(attempt.attempted){me.attemptCount++;if(attempt.attemptCorrect){me.questionsCorrect++;}else if(attempt.partialCorrect){me.partialCorrect++;}else{me.questionsIncorrect++;}}else{me.unAttemptedCount++;}me.userScore+=attempt.userMarks;});}// For Test, take the user marks
//me.userScore = me.data.testDetails.marks;
}catch(e){console.log("Error occurred for the question of index:"+index,e);}});}catch(e){console.error("Error occurred while calculating questions count in Scorecard:",e);}}},{key:'calculateScoreForAdaptive',value:function calculateScoreForAdaptive(){var me=this;try{this.data.transcripts.map(function(transcript,index){try{me.questionTypeCount++;me.questionCount++;if(transcript.attempts===null||transcript.attempts.length<=0){me.unAttemptedCount++;}else{me.totalScore++;if(transcript.answerCorrect){me.userScore++;me.questionsCorrect++;}else{me.questionsIncorrect++;}transcript.attempts.map(function(attempt,index){//Push additional details to attempt object 
attempt.questionNo=transcript.questionNo;attempt.testMode="PRACTICE";//This method pushes the question to renderer array
me.populateQuestions(attempt);});}}catch(e){console.log("Error occurred for the question of index:"+index,e);}});}catch(e){console.error("Error occurred while calculating questions count in Scorecard:",e);}}},{key:'calculateScoreForStandard',value:function calculateScoreForStandard(){var me=this;try{this.data.transcripts.map(function(transcript,index){try{me.questionTypeCount++;if(transcript.attempts===null||transcript.attempts.length<=0){me.unAttemptedCount++;}else{transcript.attempts.map(function(attempt,index){//Push additional details to attempt object 
attempt.questionNo=transcript.questionNo;attempt.testMode="TEST";//This method pushes the question to renderer array
me.populateQuestions(attempt);me.totalScore++;if(attempt.attemptCorrect){me.userScore++;}me.questionCount++;if(attempt.attempted){me.attemptCount++;if(attempt.attemptCorrect){me.questionsCorrect++;}else if(attempt.partialCorrect){me.partialCorrect++;}else{me.questionsIncorrect++;}}else{me.unAttemptedCount++;}});}}catch(e){console.log("Error occurred for the question of index:"+index,e);}});}catch(e){console.error("Error occurred while calculating questions count in Scorecard:",e);}}},{key:'populateQuestions',value:function populateQuestions(questionAttempt){try{this.questions.push(questionAttempt);}catch(e){console.log("Error Occurred while populating questions.",e);}}},{key:'dismiss',value:function dismiss(){if(typeof this.props.unMount==="function"){this.props.unMount();}this.setState({testModalShow:false});}},{key:'viewSolnModal',value:function viewSolnModal(data){this.setState({testModalShow:true,testModalContent:"new loading",modalTitle:"Diagnostic-Detail report",testModalView:"loading",modalLabel:""});}},{key:'hideTestModal',value:function hideTestModal(){this.dismiss();/*this.setState({ testModalShow: false, testModalContent: "loading", modalTitle: "", testModalView: "loading", modalLabel:"" });*/}},{key:'setModalClass',value:function setModalClass(){if(this.state.testModalView=="testView"){return" modal-lg custom-modal";}else if(this.state.testModalView=="testInfo"){return" modal-lg info-modal";}else if(this.state.testModalView=="staticContent"){return" modal-lg solution-modal";}return" modal-lg";}},{key:'setModalBackdropClose',value:function setModalBackdropClose(){if(this.state.testModalView=="testView"){return"";}else if(this.state.testModalView=="testInfo"){return"";}else if(this.state.testModalView=="staticContent"){return this.hideTestModal;}return this.hideTestModal;}},{key:'loadModalContent',value:function loadModalContent(){if(!this.state.dataLoaded){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center loadingAnim'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_loader_spinner___default.a,{type:'Oval',color:'#00BFFF',height:'100',width:'100'}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.renderQuestions());}}},{key:'renderQuestions',value:function renderQuestions(){var _this3=this;var me=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_styles_MuiThemeProvider___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'questionsParent'},this.renderQuestionInfo(),function(){if(_this3.questions&&_this3.questions.length>0){return _this3.questions.map(function(eachques,index){console.log(" eachques :::",eachques);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,id:"qindex-"+eachques.questionNo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_question_AbstractQuestionPanel__["a" /* default */],{qno:eachques.questionNo,qdata:eachques}));});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center loadingAnim viewsoln_loadingAnim'},_this3.rb("view.solution.noques"));}}()),function(){if(_this3.questionTypeCount&&_this3.questionTypeCount>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-center paginationParent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_ultimate_pagination_material_ui___default.a,{currentPage:_this3.state.currentScrollIndex,totalPages:_this3.questionTypeCount,boundaryPagesRange:5,siblingPagesRange:5,hidePreviousAndNextPageLinks:true,hideFirstAndLastPageLinks:true,hideEllipsis:true,onChange:_this3.onPageChange}));}}()));}},{key:'renderQuestionInfo',value:function renderQuestionInfo(){if(this.infoData){this.infoData["topicName"]=this.props.topicName||"";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__InfoDetail__["a" /* default */],{data:this.infoData}));}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__views_plp_TestTakingModalComponent__["a" /* default */],{visible:this.state.testModalShow,dialogClassName:this.setModalClass(),onClickBackdrop:this.setModalBackdropClose()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-header bg-purple'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-title'},this.rb("viewsolution.layout.headermsg"),this.state.modalTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close',onClick:this.hideTestModal,'aria-label':'Close','data-ga':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'close')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-body testModalBody'},this.loadModalContent())));}}]);return ViewSolutionLayout;}(__WEBPACK_IMPORTED_MODULE_2__views_core_LoggedInPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ViewSolutionLayout);

/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_LoggedInPage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_loader_spinner__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_loader_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_loader_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_HmEventRegistry__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InfoDetail=function(_LoggedInPage){_inherits(InfoDetail,_LoggedInPage);function InfoDetail(props){_classCallCheck(this,InfoDetail);var _this=_possibleConstructorReturn(this,(InfoDetail.__proto__||Object.getPrototypeOf(InfoDetail)).call(this,props));_this.render=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.renderInfoDetail());};_this.data=_this.props.data?_this.props.data:{wrongQuestionCount:0,unAttemptedQuestionCount:0,totalQuestionCount:0,correctQuestionCount:0,topicName:""};_this.state={};return _this;}_createClass(InfoDetail,[{key:'componentDidMount',value:function componentDidMount(){_get(InfoDetail.prototype.__proto__||Object.getPrototypeOf(InfoDetail.prototype),'componentDidMount',this).call(this);}},{key:'getUnattemptedAndWrong',value:function getUnattemptedAndWrong(){return(this.props.data.wrongQuestionCount||0)+(this.props.data.unAttemptedQuestionCount||0);}},{key:'renderInfoDetail',value:function renderInfoDetail(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'ques-info',className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 left-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'topicDetails'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.rb("view.solution.topic")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'topicName'},this.props.data.topicName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 right-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'testInfo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 col-12 caption'},this.rb("view.solution.questions"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'count-value'},this.props.data.totalQuestionCount))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 col-6 caption correct'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'check_circle'),this.rb("view.solution.correct"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'count-value'},this.props.data.correctQuestionCount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 col-6 caption wrong'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'cancel'),this.rb("view.solution.wrong"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'count-value'},this.getUnattemptedAndWrong())))))));}}]);return InfoDetail;}(__WEBPACK_IMPORTED_MODULE_1__views_core_LoggedInPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (InfoDetail);

/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_CoreComponent__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AbstractQuestionView__ = __webpack_require__(1255);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AbstractQuestionPanel=function(_CoreComponent){_inherits(AbstractQuestionPanel,_CoreComponent);function AbstractQuestionPanel(props){_classCallCheck(this,AbstractQuestionPanel);return _possibleConstructorReturn(this,(AbstractQuestionPanel.__proto__||Object.getPrototypeOf(AbstractQuestionPanel)).call(this,props));}/*
	 * IMPORTANT: Callback function for the QuestionView to access.
	 * This can be overridden in Child classes for more specified usage.
	 * Maintain it empty here and override only in child classes.
	 */_createClass(AbstractQuestionPanel,[{key:'callBackFunc',value:function callBackFunc(){}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'qcont'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AbstractQuestionView__["a" /* default */],{qno:this.props.qno,qdata:this.props.qdata,ga:this.props.ga,callbackParent:this.callBackFunc,accessId:this.props.accessId,classId:this.props.classId}));}}]);return AbstractQuestionPanel;}(__WEBPACK_IMPORTED_MODULE_1__core_CoreComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (AbstractQuestionPanel);

/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_RbUtil__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ComponentHelper__ = __webpack_require__(337);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CoreComponent=function(_React$Component){_inherits(CoreComponent,_React$Component);function CoreComponent(){_classCallCheck(this,CoreComponent);return _possibleConstructorReturn(this,(CoreComponent.__proto__||Object.getPrototypeOf(CoreComponent)).apply(this,arguments));}_createClass(CoreComponent,[{key:'rb',value:function rb(rawTxt){var replaceStringArray=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];return __WEBPACK_IMPORTED_MODULE_1__util_RbUtil__["a" /* default */].getText(rawTxt,replaceStringArray);}},{key:'getCmpHelper',value:function getCmpHelper(userStore){return Object(__WEBPACK_IMPORTED_MODULE_2__util_ComponentHelper__["a" /* default */])(userStore);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}]);return CoreComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (CoreComponent);

/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_html_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_core_CorePage__ = __webpack_require__(37);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultFontColor="&color=%23000000";var defaultFontName="&fontFamily=Muli-Light";var defaultFontSize="&fontSize=13";var AbstractQuestionView=function(_CorePage){_inherits(AbstractQuestionView,_CorePage);function AbstractQuestionView(props){_classCallCheck(this,AbstractQuestionView);var _this=_possibleConstructorReturn(this,(AbstractQuestionView.__proto__||Object.getPrototypeOf(AbstractQuestionView)).call(this,props));_this.filterHTML=_this.filterHTML.bind(_this);_this.checkImageLoaded=_this.checkImageLoaded.bind(_this);try{_this.WIRIS_URL=_this.getUrlFor("WIRIS_URL");_this.imageServiceUrl=_this.WIRIS_URL+"/formula3/render?transparency=true";}catch(e){if(console)console.log("Error occurred in mathmlToimage | ",e);}return _this;}_createClass(AbstractQuestionView,[{key:'renderOptions',value:function renderOptions(){if(this.props.qdata.questionType==="mcq"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{name:'optionsVw'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'qoption'},this.props.qdata.optionText.map(function(option,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index},__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(option));})));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' ');}}},{key:'filterHTML',value:function filterHTML(html){if(html!==null){var sb="";var pos=0;var start;while((start=html.indexOf("<math",pos))!=-1){sb+=html.substring(pos,start);var autoclose=html.indexOf("/>",start);var greaterindex=html.indexOf(">",start);if(autoclose!=-1&&autoclose<greaterindex){//autoclosed math tag
pos=autoclose+"/>".length();}else{pos=html.indexOf("</math>",start)+"</math>".length;var formula=html.substring(start,pos);var url=this.getImageUrl(formula);var img="<img src=\""+url+"\" align='middle' class='formula' />";sb+=img;}}sb+=html.substring(pos);return sb.toString();}}},{key:'renderResultFn',value:function renderResultFn(){if(this.props.qdata&&(!this.props.qdata.attemptNo||this.props.qdata.attemptNo===0)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'unans'},this.rb("scorecard.notattempted"));}else if(this.props.qdata.optionResult&&this.props.qdata.optionResult.length>0){if(this.props.qdata.optionResult[0].optionCorrect===true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons corrans'},'done'));}else if(this.props.qdata.optionResult[0].optionCorrect===false&&this.props.qdata.optionResult[0].userAns!==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons wrgans'},'close'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'unans'},this.rb("scorecard.notattempted"));}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'unans'},this.rb("scorecard.notattempted"));}}},{key:'getQuestionNumber',value:function getQuestionNumber(){var qNo=0;if(this.props.qno){qNo=this.props.qno;}if(this.props.qdata.testMode==="TEST"){return this.rb("questionview.q-label").replace("{1}",this.props.qno);}return this.rb("questionview.q-label.withattempt").replace("{1}",this.props.qno).replace("{2}",this.props.qdata.attemptNo);}},{key:'getImageUrl',value:function getImageUrl(mathml,fontColor,fontSize,fontName){var fontOptions="";if(fontColor!=null&&fontColor!=undefined){fontOptions+="&color=%23"+fontColor;}else{fontOptions+=defaultFontColor;}if(fontSize!=null&&fontSize!=undefined){fontOptions+="&fontSize="+fontSize;}else{fontOptions+=defaultFontSize;}if(fontName!=null&&fontName!=undefined){fontOptions+="&fontFamily="+fontName;}else{fontOptions+=defaultFontName;}// replace hack to remove <br> tag from mathml input to wiris editor service since latest versions 
// throws error for invalid inputs, which was previously rendered by older editor versions.
mathml=mathml.trim().replace("</math><br>","</math>");var returnImage=this.imageServiceUrl+"&mml="+encodeURIComponent(this.escapeUTF8Chars(mathml))+fontOptions;return returnImage;}},{key:'escapeUTF8Chars',value:function escapeUTF8Chars(str){var out="";for(var i=0;i<str.length;i++){var c=str.charCodeAt(i);if(c<128){out+=str.charAt(i);}else{out+="&#"+c+";";}}return out.trim();}},{key:'checkImageLoaded',value:function checkImageLoaded(){try{__WEBPACK_IMPORTED_MODULE_2_jquery___default()('img').unbind("error");__WEBPACK_IMPORTED_MODULE_2_jquery___default()('img').error(function(){var me=this;var timeDelay=5000;if(!__WEBPACK_IMPORTED_MODULE_2_jquery___default()(me).attr('imageReloadCount')){__WEBPACK_IMPORTED_MODULE_2_jquery___default()(me).attr('imageReloadCount',1);}timeDelay=timeDelay*parseInt(__WEBPACK_IMPORTED_MODULE_2_jquery___default()(me).attr('imageReloadCount'));setTimeout(function(){if(!__WEBPACK_IMPORTED_MODULE_2_jquery___default()(me).attr('imageReloadCount')){__WEBPACK_IMPORTED_MODULE_2_jquery___default()(me).attr('imageReloadCount',1);}else{__WEBPACK_IMPORTED_MODULE_2_jquery___default()(me).attr('imageReloadCount',parseInt(__WEBPACK_IMPORTED_MODULE_2_jquery___default()(me).attr('imageReloadCount'))+1);}if(__WEBPACK_IMPORTED_MODULE_2_jquery___default()(me).attr('imageReloadCount')<=4){//console.log("timeDelay::",timeDelay);
__WEBPACK_IMPORTED_MODULE_2_jquery___default()(me).attr('src',__WEBPACK_IMPORTED_MODULE_2_jquery___default()(me).attr('src'));}if(console){console.log("image not loaded :"+__WEBPACK_IMPORTED_MODULE_2_jquery___default()(me).attr('src'));}},timeDelay);}).load(function(){//console.log("loaded successfully...");
});}catch(e){}}},{key:'componentDidMount',value:function componentDidMount(){this.checkImageLoaded();}},{key:'render',value:function render(){var me=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{name:'questionView',className:'qvroot'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'qView scrollEqn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'qvwList'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quesorder'},this.getQuestionNumber(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'qVw'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{name:'questionVw scro'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(this.props.qdata.questionText))),this.renderOptions(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{name:'userAnswerVw',className:'anspadd'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("scorecard.your_answer"),':'),this.renderResultFn(),this.props.qdata.optionResult.map(function(optionObj,index){if(me.props.qdata.attemptNo>0){if(optionObj.unitPosition==0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mathml',key:index},__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(optionObj.label),' ',__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(optionObj.unit),' ',__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(me.filterHTML(optionObj.userAns)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mathml',key:index},__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(optionObj.label),' ',__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(me.filterHTML(optionObj.userAns)),' ',__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(optionObj.unit));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mathml',key:index},__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(me.filterHTML(optionObj.userAns)));}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{name:'correctAnswerVw',className:'anspadd'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("scorecard.correct_answer"),':'),this.props.qdata.optionResult.map(function(optionObj,index){if(me.props.qdata.attemptNo>0){if(optionObj.unitPosition==0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mathml',key:index},__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(optionObj.label),' ',__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(optionObj.unit),' ',__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(me.filterHTML(optionObj.correctAns)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mathml',key:index},__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(optionObj.label),' ',__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(me.filterHTML(optionObj.correctAns)),' ',__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(optionObj.unit));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'mathml',key:index},__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(me.filterHTML(optionObj.correctAns)));}})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{name:'solutionVw'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'qsoln scrollEqn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.rb("editor.solutionTitle"),':'),__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(this.props.qdata.solutionText))));}}]);return AbstractQuestionView;}(__WEBPACK_IMPORTED_MODULE_3__views_core_CorePage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (AbstractQuestionView);

/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BarChart__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_LoaderMask__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_core_LoggedInPage__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Barchart_Topicwise=function(_LoggedInPage){_inherits(Barchart_Topicwise,_LoggedInPage);function Barchart_Topicwise(props){_classCallCheck(this,Barchart_Topicwise);return _possibleConstructorReturn(this,(Barchart_Topicwise.__proto__||Object.getPrototypeOf(Barchart_Topicwise)).call(this,props));}_createClass(Barchart_Topicwise,[{key:"getColor",value:function getColor(percentage){var percArr=window.barchartColor||['#9c9e9f','#F73E21','#fb9100','#7cb045'];var clrval=percArr[1];if(percentage>=41&&percentage<=70){clrval=percArr[2];}else if(percentage>70&&percentage<=100){clrval=percArr[3];}return clrval;}},{key:"render",value:function render(){var _options;var rclrVal='#D3D3D3';var data=[];if(this.props.benchMarkData&&this.props.benchMarkData!=null){if(this.props.benchMarkData.topic_wise&&this.props.benchMarkData.topic_wise.length>0){var topic_wise=this.props.benchMarkData.topic_wise;data=[['','',{role:'style'},{sourceColumn:0,role:'annotation',type:'string',calc:'stringify'},'',{role:'style'}]];for(var i=0;i<topic_wise.length;i++){var topicName=topic_wise[i].topicName;var percentile=topic_wise[i].percentile;var getperc=Math.abs(percentile);var overallscore=100;var loseperc=overallscore-getperc;data[i+1]=[topicName,getperc,this.getColor(getperc),String(getperc),loseperc,rclrVal];//data = ["tooltip title","percentage","leftbarcolor","Bar inside txt","100-perce","rightbarcolor"];
}}}var params={chartType:"BarChart",width:'auto',height:'500px',loader:__WEBPACK_IMPORTED_MODULE_3__components_common_LoaderMask__["a" /* default */],data:data,options:(_options={title:'',chartArea:{width:'70%'},legend:{position:'none'},isStacked:true,bar:{groupWidth:'60%'}},_defineProperty(_options,"legend",{position:'none'}),_defineProperty(_options,"hAxis",{title:'Percentile Ranking',italic:false,minValue:0,baselineColor:'#003465',textStyle:{color:'#003465',fontSize:14}}),_options)};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BarChart__["a" /* default */],{params:params});}}]);return Barchart_Topicwise;}(__WEBPACK_IMPORTED_MODULE_4__views_core_LoggedInPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Barchart_Topicwise);

/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Chart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_load_script__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_load_script___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_load_script__);



/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var chartDefaultProps = {
    graph_id: null,
    legend_toggle: false,
    graphID: null,
    options: {
        colors: null
    },
    data: null,
    rows: null,
    columns: null,
    diffdata: null,
    chartEvents: null,
    legendToggle: false,
    chartActions: null,
    getChartWrapper: function (chartWrapper, google) { },
    getChartEditor: null,
    className: "",
    style: {},
    formatters: null,
    spreadSheetUrl: null,
    spreadSheetQueryParameters: {
        headers: 1,
        gid: 1
    },
    rootProps: {},
    chartWrapperParams: {},
    controls: null,
    render: null,
    toolbarItems: null,
    toolbarID: null
};

var GoogleChartLoader = (function (_super) {
    __extends(GoogleChartLoader, _super);
    function GoogleChartLoader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleGoogleChartsLoaderScriptLoaded = function (windowGoogleCharts) {
            var _a = _this.props, version = _a.chartVersion, packages = _a.chartPackages, language = _a.chartLanguage, mapsApiKey = _a.mapsApiKey, onLoad = _a.onLoad;
            windowGoogleCharts.charts.load(version || "current", {
                packages: packages || ["corechart", "controls"],
                language: language || "en",
                mapsApiKey: mapsApiKey
            });
            windowGoogleCharts.charts.setOnLoadCallback(function () {
                onLoad(windowGoogleCharts);
            });
        };
        return _this;
    }
    GoogleChartLoader.prototype.shouldComponentUpdate = function (nextProps) {
        return nextProps.chartPackages === this.props.chartPackages;
    };
    GoogleChartLoader.prototype.render = function () {
        var _this = this;
        var onError = this.props.onError;
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_1_react_load_script___default.a, { url: "https://www.gstatic.com/charts/loader.js", onError: onError, onLoad: function () {
                var windowWithGoogle = window;
                if (windowWithGoogle.google) {
                    _this.handleGoogleChartsLoaderScriptLoaded(windowWithGoogle.google);
                }
            } }));
    };
    return GoogleChartLoader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var uniqueID = 0;
var generateUniqueID = function () {
    uniqueID += 1;
    return "reactgooglegraph-" + uniqueID;
};

var DEFAULT_CHART_COLORS = [
    "#3366CC",
    "#DC3912",
    "#FF9900",
    "#109618",
    "#990099",
    "#3B3EAC",
    "#0099C6",
    "#DD4477",
    "#66AA00",
    "#B82E2E",
    "#316395",
    "#994499",
    "#22AA99",
    "#AAAA11",
    "#6633CC",
    "#E67300",
    "#8B0707",
    "#329262",
    "#5574A6",
    "#3B3EAC"
];

var _this = undefined;
var loadDataTableFromSpreadSheet = function (googleViz, spreadSheetUrl, urlParams) {
    if (urlParams === void 0) { urlParams = {}; }
    return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2, new Promise(function (resolve, reject) {
                    var headers = "" + (urlParams.headers ? "headers=" + urlParams.headers : "headers=0");
                    var queryString = "" + (urlParams.query ? "&tq=" + encodeURIComponent(urlParams.query) : "");
                    var gid = "" + (urlParams.gid ? "&gid=" + urlParams.gid : "");
                    var sheet = "" + (urlParams.sheet ? "&sheet=" + urlParams.sheet : "");
                    var access_token = "" + (urlParams.access_token ? "&access_token=" + urlParams.access_token : "");
                    var urlQueryString = "" + headers + gid + sheet + queryString + access_token;
                    var urlToSpreadSheet = spreadSheetUrl + "/gviz/tq?" + urlQueryString;
                    var query = new googleViz.visualization.Query(urlToSpreadSheet);
                    query.send(function (response) {
                        if (response.isError()) {
                            reject("Error in query:  " + response.getMessage() + " " + response.getDetailedMessage());
                        }
                        else {
                            resolve(response.getDataTable());
                        }
                    });
                })];
        });
    });
};

var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(chartDefaultProps), Provider = _a.Provider, Consumer = _a.Consumer;
var ContextProvider = function (_a) {
    var children = _a.children, value = _a.value;
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Provider, { value: value }, children);
};
var ContextConsumer = function (_a) {
    var render = _a.render;
    return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Consumer, null, function (context) {
        return render(context);
    }));
};

var GRAY_COLOR = "#CCCCCC";
var GoogleChartDataTableInner = (function (_super) {
    __extends(GoogleChartDataTableInner, _super);
    function GoogleChartDataTableInner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hiddenColumns: []
        };
        _this.listenToLegendToggle = function () {
            var _a = _this.props, google = _a.google, googleChartWrapper = _a.googleChartWrapper;
            google.visualization.events.addListener(googleChartWrapper, "select", function () {
                var chart = googleChartWrapper.getChart();
                var selection = chart.getSelection();
                var dataTable = googleChartWrapper.getDataTable();
                if (selection.length === 0 ||
                    selection[0].row !== null ||
                    dataTable === null) {
                    return;
                }
                var columnIndex = selection[0].column;
                var columnID = _this.getColumnID(dataTable, columnIndex);
                if (_this.state.hiddenColumns.includes(columnID)) {
                    _this.setState(function (state) { return (__assign({}, state, { hiddenColumns: state.hiddenColumns.filter(function (colID) { return colID !== columnID; }).slice() })); });
                }
                else {
                    _this.setState(function (state) { return (__assign({}, state, { hiddenColumns: state.hiddenColumns.concat([columnID]) })); });
                }
            });
        };
        _this.applyFormatters = function (dataTable, formatters) {
            var google = _this.props.google;
            for (var _i = 0, formatters_1 = formatters; _i < formatters_1.length; _i++) {
                var formatter = formatters_1[_i];
                switch (formatter.type) {
                    case "ArrowFormat": {
                        var vizFormatter = new google.visualization.ArrowFormat(formatter.options);
                        vizFormatter.format(dataTable, formatter.column);
                        break;
                    }
                    case "BarFormat": {
                        var vizFormatter = new google.visualization.BarFormat(formatter.options);
                        vizFormatter.format(dataTable, formatter.column);
                        break;
                    }
                    case "ColorFormat": {
                        var vizFormatter = new google.visualization.ColorFormat(formatter.options);
                        var ranges = formatter.ranges;
                        for (var _a = 0, ranges_1 = ranges; _a < ranges_1.length; _a++) {
                            var range = ranges_1[_a];
                            vizFormatter.addRange.apply(vizFormatter, range);
                        }
                        vizFormatter.format(dataTable, formatter.column);
                        break;
                    }
                    case "DateFormat": {
                        var vizFormatter = new google.visualization.DateFormat(formatter.options);
                        vizFormatter.format(dataTable, formatter.column);
                        break;
                    }
                    case "NumberFormat": {
                        var vizFormatter = new google.visualization.NumberFormat(formatter.options);
                        vizFormatter.format(dataTable, formatter.column);
                        break;
                    }
                    case "PatternFormat": {
                        var vizFormatter = new google.visualization.PatternFormat(formatter.options);
                        vizFormatter.format(dataTable, formatter.column);
                        break;
                    }
                }
            }
        };
        _this.getColumnID = function (dataTable, columnIndex) {
            return (dataTable.getColumnId(columnIndex) ||
                dataTable.getColumnLabel(columnIndex));
        };
        _this.draw = function (_a) {
            var data = _a.data, diffdata = _a.diffdata, rows = _a.rows, columns = _a.columns, options = _a.options, legend_toggle = _a.legend_toggle, legendToggle = _a.legendToggle, chartType = _a.chartType, formatters = _a.formatters, spreadSheetUrl = _a.spreadSheetUrl, spreadSheetQueryParameters = _a.spreadSheetQueryParameters;
            return __awaiter(_this, void 0, void 0, function () {
                var _b, google, googleChartWrapper, dataTable, chartDiff, oldData, newData, columnCount, i, columnID, previousColumnLabel, previousColumnID, previousColumnType, chart;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _b = this.props, google = _b.google, googleChartWrapper = _b.googleChartWrapper;
                            chartDiff = null;
                            if (diffdata !== null) {
                                oldData = google.visualization.arrayToDataTable(diffdata.old);
                                newData = google.visualization.arrayToDataTable(diffdata.new);
                                chartDiff = google.visualization[chartType].prototype.computeDiff(oldData, newData);
                            }
                            if (!(data !== null)) return [3, 1];
                            if (Array.isArray(data)) {
                                dataTable = google.visualization.arrayToDataTable(data);
                            }
                            else {
                                dataTable = new google.visualization.DataTable(data);
                            }
                            return [3, 5];
                        case 1:
                            if (!(rows !== null && columns !== null)) return [3, 2];
                            dataTable = google.visualization.arrayToDataTable([columns].concat(rows));
                            return [3, 5];
                        case 2:
                            if (!(spreadSheetUrl !== null)) return [3, 4];
                            return [4, loadDataTableFromSpreadSheet(google, spreadSheetUrl, spreadSheetQueryParameters)];
                        case 3:
                            dataTable = (_c.sent());
                            return [3, 5];
                        case 4:
                            dataTable = google.visualization.arrayToDataTable([]);
                            _c.label = 5;
                        case 5:
                            columnCount = dataTable.getNumberOfColumns();
                            for (i = 0; i < columnCount; i += 1) {
                                columnID = this.getColumnID(dataTable, i);
                                if (this.state.hiddenColumns.includes(columnID)) {
                                    previousColumnLabel = dataTable.getColumnLabel(i);
                                    previousColumnID = dataTable.getColumnId(i);
                                    previousColumnType = dataTable.getColumnType(i);
                                    dataTable.removeColumn(i);
                                    dataTable.addColumn({
                                        label: previousColumnLabel,
                                        id: previousColumnID,
                                        type: previousColumnType
                                    });
                                }
                            }
                            chart = googleChartWrapper.getChart();
                            if (googleChartWrapper.getChartType() === "Timeline") {
                                chart && chart.clearChart();
                            }
                            googleChartWrapper.setOptions(options);
                            googleChartWrapper.setDataTable(dataTable);
                            googleChartWrapper.draw();
                            if (this.props.googleChartDashboard !== null) {
                                this.props.googleChartDashboard.draw(dataTable);
                            }
                            if (chartDiff !== null) {
                                googleChartWrapper.setDataTable(chartDiff);
                                googleChartWrapper.draw();
                            }
                            if (formatters !== null) {
                                this.applyFormatters(dataTable, formatters);
                                googleChartWrapper.setDataTable(dataTable);
                                googleChartWrapper.draw();
                            }
                            if (legendToggle === true || legend_toggle === true) {
                                this.grayOutHiddenColumns({ options: options });
                            }
                            return [2];
                    }
                });
            });
        };
        _this.grayOutHiddenColumns = function (_a) {
            var options = _a.options;
            var googleChartWrapper = _this.props.googleChartWrapper;
            var dataTable = googleChartWrapper.getDataTable();
            if (dataTable === null)
                return;
            var columnCount = dataTable.getNumberOfColumns();
            var hasAHiddenColumn = _this.state.hiddenColumns.length > 0;
            if (hasAHiddenColumn === false)
                return;
            var colors = Array.from({ length: columnCount - 1 }).map(function (dontcare, i) {
                var columnID = _this.getColumnID(dataTable, i + 1);
                if (_this.state.hiddenColumns.includes(columnID)) {
                    return GRAY_COLOR;
                }
                else if (typeof options.colors !== "undefined" &&
                    options.colors !== null) {
                    return options.colors[i];
                }
                else {
                    return DEFAULT_CHART_COLORS[i];
                }
            });
            googleChartWrapper.setOptions(__assign({}, options, { colors: colors }));
            googleChartWrapper.draw();
        };
        _this.onResize = function () {
            var googleChartWrapper = _this.props.googleChartWrapper;
            googleChartWrapper.draw();
        };
        return _this;
    }
    GoogleChartDataTableInner.prototype.componentDidMount = function () {
        this.draw(this.props);
        window.addEventListener("resize", this.onResize);
        if (this.props.legend_toggle || this.props.legendToggle) {
            this.listenToLegendToggle();
        }
    };
    GoogleChartDataTableInner.prototype.componentWillUnmount = function () {
        var _a = this.props, google = _a.google, googleChartWrapper = _a.googleChartWrapper;
        window.removeEventListener("resize", this.onResize);
        google.visualization.events.removeAllListeners(googleChartWrapper);
        if (googleChartWrapper.getChartType() === "Timeline") {
            googleChartWrapper.getChart() &&
                googleChartWrapper.getChart().clearChart();
        }
    };
    GoogleChartDataTableInner.prototype.componentDidUpdate = function () {
        this.draw(this.props);
    };
    GoogleChartDataTableInner.prototype.render = function () {
        return null;
    };
    return GoogleChartDataTableInner;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var GoogleChartDataTable = (function (_super) {
    __extends(GoogleChartDataTable, _super);
    function GoogleChartDataTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GoogleChartDataTable.prototype.componentDidMount = function () { };
    GoogleChartDataTable.prototype.componentWillUnmount = function () { };
    GoogleChartDataTable.prototype.shouldComponentUpdate = function () {
        return false;
    };
    GoogleChartDataTable.prototype.render = function () {
        var _a = this.props, google = _a.google, googleChartWrapper = _a.googleChartWrapper, googleChartDashboard = _a.googleChartDashboard;
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ContextConsumer, { render: function (props) {
                return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(GoogleChartDataTableInner, __assign({}, props, { google: google, googleChartWrapper: googleChartWrapper, googleChartDashboard: googleChartDashboard })));
            } }));
    };
    return GoogleChartDataTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var GoogleChartEvents = (function (_super) {
    __extends(GoogleChartEvents, _super);
    function GoogleChartEvents() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GoogleChartEvents.prototype.shouldComponentUpdate = function () {
        return false;
    };
    GoogleChartEvents.prototype.listenToEvents = function (_a) {
        var _this = this;
        var chartEvents = _a.chartEvents, google = _a.google, googleChartWrapper = _a.googleChartWrapper;
        if (chartEvents === null) {
            return;
        }
        google.visualization.events.removeAllListeners(googleChartWrapper);
        var _loop_1 = function (event_1) {
            var eventName = event_1.eventName, callback = event_1.callback;
            google.visualization.events.addListener(googleChartWrapper, eventName, function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                callback({
                    chartWrapper: googleChartWrapper,
                    props: _this.props,
                    google: google,
                    eventArgs: args
                });
            });
        };
        for (var _i = 0, chartEvents_1 = chartEvents; _i < chartEvents_1.length; _i++) {
            var event_1 = chartEvents_1[_i];
            _loop_1(event_1);
        }
    };
    GoogleChartEvents.prototype.render = function () {
        var _this = this;
        var _a = this.props, google = _a.google, googleChartWrapper = _a.googleChartWrapper;
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ContextConsumer, { render: function (propsFromContext) {
                _this.listenToEvents({
                    chartEvents: propsFromContext.chartEvents || null,
                    google: google,
                    googleChartWrapper: googleChartWrapper
                });
                return null;
            } }));
    };
    return GoogleChartEvents;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var controlCounter = 0;
var GoogleChart = (function (_super) {
    __extends(GoogleChart, _super);
    function GoogleChart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            googleChartWrapper: null,
            googleChartDashboard: null,
            googleChartControls: null,
            googleChartEditor: null,
            isReady: false
        };
        _this.graphID = null;
        _this.dashboard_ref = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createRef"])();
        _this.toolbar_ref = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createRef"])();
        _this.getGraphID = function () {
            var _a = _this.props, graphID = _a.graphID, graph_id = _a.graph_id;
            var instanceGraphID;
            if (graphID === null && graph_id === null) {
                if (_this.graphID === null) {
                    instanceGraphID = generateUniqueID();
                }
                else {
                    instanceGraphID = _this.graphID;
                }
            }
            else if (graphID !== null && graph_id === null) {
                instanceGraphID = graphID;
            }
            else if (graph_id !== null && graphID === null) {
                instanceGraphID = graph_id;
            }
            else {
                instanceGraphID = graphID;
            }
            _this.graphID = instanceGraphID;
            return _this.graphID;
        };
        _this.getControlID = function (id, index) {
            controlCounter += 1;
            var controlID;
            if (typeof id === "undefined") {
                controlID = "googlechart-control-" + index + "-" + controlCounter;
            }
            else {
                controlID = id;
            }
            return controlID;
        };
        _this.addControls = function (googleChartWrapper, googleChartDashboard) {
            var _a = _this.props, google = _a.google, controls = _a.controls;
            var googleChartControls = controls === null
                ? null
                : controls.map(function (control, i) {
                    var controlIDMaybe = control.controlID, controlType = control.controlType, controlOptions = control.options, controlWrapperParams = control.controlWrapperParams;
                    var controlID = _this.getControlID(controlIDMaybe, i);
                    return {
                        controlProp: control,
                        control: new google.visualization.ControlWrapper(__assign({ containerId: controlID, controlType: controlType, options: controlOptions }, controlWrapperParams))
                    };
                });
            if (googleChartControls === null) {
                return null;
            }
            googleChartDashboard.bind(googleChartControls.map(function (_a) {
                var control = _a.control;
                return control;
            }), googleChartWrapper);
            var _loop_1 = function (chartControl) {
                var control = chartControl.control, controlProp = chartControl.controlProp;
                var _a = controlProp.controlEvents, controlEvents = _a === void 0 ? [] : _a;
                var _loop_2 = function (event_1) {
                    var callback = event_1.callback, eventName = event_1.eventName;
                    google.visualization.events.removeListener(control, eventName, callback);
                    google.visualization.events.addListener(control, eventName, function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        callback({
                            chartWrapper: googleChartWrapper,
                            controlWrapper: control,
                            props: _this.props,
                            google: google,
                            eventArgs: args
                        });
                    });
                };
                for (var _i = 0, controlEvents_1 = controlEvents; _i < controlEvents_1.length; _i++) {
                    var event_1 = controlEvents_1[_i];
                    _loop_2(event_1);
                }
            };
            for (var _i = 0, googleChartControls_1 = googleChartControls; _i < googleChartControls_1.length; _i++) {
                var chartControl = googleChartControls_1[_i];
                _loop_1(chartControl);
            }
            return googleChartControls;
        };
        _this.renderChart = function () {
            var _a = _this.props, width = _a.width, height = _a.height, options = _a.options, style = _a.style, className = _a.className, rootProps = _a.rootProps, google = _a.google;
            var divStyle = __assign({ height: height || (options && options.height), width: width || (options && options.width) }, style);
            return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", __assign({ id: _this.getGraphID(), style: divStyle, className: className }, rootProps), _this.state.isReady && _this.state.googleChartWrapper !== null ? (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(GoogleChartDataTable, { googleChartWrapper: _this.state.googleChartWrapper, google: google, googleChartDashboard: _this.state.googleChartDashboard }),
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(GoogleChartEvents, { googleChartWrapper: _this.state.googleChartWrapper, google: google }))) : null));
        };
        _this.renderControl = function (filter) {
            if (filter === void 0) { filter = function (_a) {
                var control = _a.control, controlProp = _a.controlProp;
                return true;
            }; }
            return _this.state.isReady && _this.state.googleChartControls !== null ? (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, _this.state.googleChartControls
                .filter(function (_a) {
                var controlProp = _a.controlProp, control = _a.control;
                return filter({ control: control, controlProp: controlProp });
            })
                .map(function (_a) {
                var control = _a.control, controlProp = _a.controlProp;
                return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { key: control.getContainerId(), id: control.getContainerId() }));
            }))) : null;
        };
        _this.renderToolBar = function () {
            if (_this.props.toolbarItems === null)
                return null;
            return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { ref: _this.toolbar_ref });
        };
        return _this;
    }
    GoogleChart.prototype.componentDidMount = function () {
        var _a = this.props, options = _a.options, google = _a.google, chartType = _a.chartType, chartWrapperParams = _a.chartWrapperParams, toolbarItems = _a.toolbarItems, getChartEditor = _a.getChartEditor, getChartWrapper = _a.getChartWrapper;
        var chartConfig = __assign({ chartType: chartType,
            options: options, containerId: this.getGraphID() }, chartWrapperParams);
        var googleChartWrapper = new google.visualization.ChartWrapper(chartConfig);
        googleChartWrapper.setOptions(options);
        getChartWrapper(googleChartWrapper, google);
        var googleChartDashboard = new google.visualization.Dashboard(this.dashboard_ref);
        var googleChartControls = this.addControls(googleChartWrapper, googleChartDashboard);
        if (toolbarItems !== null) {
            google.visualization.drawToolbar(this.toolbar_ref.current, toolbarItems);
        }
        var googleChartEditor = null;
        if (getChartEditor !== null) {
            googleChartEditor = new google.visualization.ChartEditor();
            getChartEditor({
                chartEditor: googleChartEditor,
                chartWrapper: googleChartWrapper,
                google: google
            });
        }
        this.setState({
            googleChartEditor: googleChartEditor,
            googleChartControls: googleChartControls,
            googleChartDashboard: googleChartDashboard,
            googleChartWrapper: googleChartWrapper,
            isReady: true
        });
    };
    GoogleChart.prototype.componentDidUpdate = function () {
        if (this.state.googleChartWrapper === null)
            return;
        if (this.state.googleChartDashboard === null)
            return;
        if (this.state.googleChartControls === null)
            return;
        var controls = this.props.controls;
        for (var i = 0; i < controls.length; i += 1) {
            var _a = controls[i], controlType = _a.controlType, options = _a.options, controlWrapperParams = _a.controlWrapperParams;
            if (controlWrapperParams && "state" in controlWrapperParams) {
                this.state.googleChartControls[i].control.setState(controlWrapperParams["state"]);
            }
            this.state.googleChartControls[i].control.setOptions(options);
            this.state.googleChartControls[i].control.setControlType(controlType);
        }
    };
    GoogleChart.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return (this.state.isReady !== nextState.isReady ||
            nextProps.controls !== this.props.controls);
    };
    GoogleChart.prototype.render = function () {
        var _a = this.props, width = _a.width, height = _a.height, options = _a.options, style = _a.style;
        var divStyle = __assign({ height: height || (options && options.height), width: width || (options && options.width) }, style);
        if (this.props.render !== null) {
            return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { ref: this.dashboard_ref, style: divStyle },
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { ref: this.toolbar_ref, id: "toolbar" }),
                this.props.render({
                    renderChart: this.renderChart,
                    renderControl: this.renderControl,
                    renderToolbar: this.renderToolBar
                })));
        }
        else {
            return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { ref: this.dashboard_ref, style: divStyle },
                this.renderControl(function (_a) {
                    var controlProp = _a.controlProp;
                    return controlProp.controlPosition !== "bottom";
                }),
                this.renderChart(),
                this.renderControl(function (_a) {
                    var controlProp = _a.controlProp;
                    return controlProp.controlPosition === "bottom";
                }),
                this.renderToolBar()));
        }
    };
    return GoogleChart;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var Chart = (function (_super) {
    __extends(Chart, _super);
    function Chart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isMounted = false;
        _this.state = {
            loadingStatus: "loading",
            google: null
        };
        _this.onLoad = function (google) {
            if (_this.isFullyLoaded(google)) {
                _this.onSuccess(google);
            }
            else {
                var id_1 = setInterval(function () {
                    var google = window.google;
                    if (_this._isMounted) {
                        if (google && _this.isFullyLoaded(google)) {
                            clearInterval(id_1);
                            _this.onSuccess(google);
                        }
                    }
                    else {
                        clearInterval(id_1);
                    }
                }, 1000);
            }
        };
        _this.onSuccess = function (google) {
            _this.setState({
                loadingStatus: "ready",
                google: google
            });
        };
        _this.onError = function () {
            _this.setState({
                loadingStatus: "errored"
            });
        };
        return _this;
    }
    Chart.prototype.render = function () {
        var _a = this.props, chartLanguage = _a.chartLanguage, chartPackages = _a.chartPackages, chartVersion = _a.chartVersion, mapsApiKey = _a.mapsApiKey, loader = _a.loader, errorElement = _a.errorElement;
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ContextProvider, { value: this.props },
            this.state.loadingStatus === "ready" && this.state.google !== null ? (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(GoogleChart, __assign({}, this.props, { google: this.state.google }))) : this.state.loadingStatus === "errored" && errorElement ? (errorElement) : (loader),
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(GoogleChartLoader, __assign({}, { chartLanguage: chartLanguage, chartPackages: chartPackages, chartVersion: chartVersion, mapsApiKey: mapsApiKey }, { onLoad: this.onLoad, onError: this.onError }))));
    };
    Chart.prototype.componentDidMount = function () {
        this._isMounted = true;
    };
    Chart.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    Chart.prototype.isFullyLoaded = function (google) {
        var _a = this.props, controls = _a.controls, toolbarItems = _a.toolbarItems, getChartEditor = _a.getChartEditor;
        return (google &&
            google.visualization &&
            google.visualization.ChartWrapper &&
            google.visualization.Dashboard &&
            (!controls || google.visualization.ChartWrapper) &&
            (!getChartEditor || google.visualization.ChartEditor) &&
            (!toolbarItems || google.visualization.drawToolbar));
    };
    Chart.defaultProps = chartDefaultProps;
    return Chart;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

/* harmony default export */ __webpack_exports__["a"] = (Chart);



/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Script = function (_React$Component) {
  _inherits(Script, _React$Component);

  // A dictionary mapping script URL to a boolean value indicating if the script
  // has failed to load.


  // A dictionary mapping script URLs to a dictionary mapping
  // component key to component for all components that are waiting
  // for the script to load.
  function Script(props) {
    _classCallCheck(this, Script);

    var _this = _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).call(this, props));

    _this.scriptLoaderId = 'id' + _this.constructor.idCount++; // eslint-disable-line space-unary-ops, no-plusplus
    return _this;
  }

  // A counter used to generate a unique id for each component that uses
  // ScriptLoaderMixin.


  // A dictionary mapping script URL to a boolean value indicating if the script
  // has already been loaded.


  _createClass(Script, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          onError = _props.onError,
          onLoad = _props.onLoad,
          url = _props.url;


      if (this.constructor.loadedScripts[url]) {
        onLoad();
        return;
      }

      if (this.constructor.erroredScripts[url]) {
        onError();
        return;
      }

      // If the script is loading, add the component to the script's observers
      // and return. Otherwise, initialize the script's observers with the component
      // and start loading the script.
      if (this.constructor.scriptObservers[url]) {
        this.constructor.scriptObservers[url][this.scriptLoaderId] = this.props;
        return;
      }

      this.constructor.scriptObservers[url] = _defineProperty({}, this.scriptLoaderId, this.props);

      this.createScript();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var url = this.props.url;

      var observers = this.constructor.scriptObservers[url];

      // If the component is waiting for the script to load, remove the
      // component from the script's observers before unmounting the component.
      if (observers) {
        delete observers[this.scriptLoaderId];
      }
    }
  }, {
    key: 'createScript',
    value: function createScript() {
      var _this2 = this;

      var _props2 = this.props,
          onCreate = _props2.onCreate,
          url = _props2.url,
          attributes = _props2.attributes;

      var script = document.createElement('script');

      onCreate();

      // add 'data-' or non standard attributes to the script tag
      if (attributes) {
        Object.keys(attributes).forEach(function (prop) {
          return script.setAttribute(prop, attributes[prop]);
        });
      }

      script.src = url;

      // default async to true if not set with custom attributes
      if (!script.hasAttribute('async')) {
        script.async = 1;
      }

      var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(shouldRemoveObserver) {
        var observers = _this2.constructor.scriptObservers[url];
        Object.keys(observers).forEach(function (key) {
          if (shouldRemoveObserver(observers[key])) {
            delete _this2.constructor.scriptObservers[url][_this2.scriptLoaderId];
          }
        });
      };
      script.onload = function () {
        _this2.constructor.loadedScripts[url] = true;
        callObserverFuncAndRemoveObserver(function (observer) {
          observer.onLoad();
          return true;
        });
      };

      script.onerror = function () {
        _this2.constructor.erroredScripts[url] = true;
        callObserverFuncAndRemoveObserver(function (observer) {
          observer.onError();
          return true;
        });
      };

      document.body.appendChild(script);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Script;
}(_react2.default.Component);

Script.propTypes = {
  attributes: _propTypes.PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onCreate: _propTypes.PropTypes.func,
  onError: _propTypes.PropTypes.func.isRequired,
  onLoad: _propTypes.PropTypes.func.isRequired,
  url: _propTypes.PropTypes.string.isRequired
};
Script.defaultProps = {
  attributes: {},
  onCreate: function onCreate() {},
  onError: function onError() {},
  onLoad: function onLoad() {} };
Script.scriptObservers = {};
Script.loadedScripts = {};
Script.erroredScripts = {};
Script.idCount = 0;
exports.default = Script;
module.exports = exports['default'];

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BarChart__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_LoaderMask__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_core_LoggedInPage__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Barchart_Overall=function(_LoggedInPage){_inherits(Barchart_Overall,_LoggedInPage);function Barchart_Overall(props){_classCallCheck(this,Barchart_Overall);return _possibleConstructorReturn(this,(Barchart_Overall.__proto__||Object.getPrototypeOf(Barchart_Overall)).call(this,props));}_createClass(Barchart_Overall,[{key:"getColor",value:function getColor(percentage){var percArr=window.barchartColor||['#9c9e9f','#F73E21','#fb9100','#7cb045'];var clrval=percArr[1];if(percentage>=41&&percentage<=70){clrval=percArr[2];}else if(percentage>70&&percentage<=100){clrval=percArr[3];}return clrval;}},{key:"render",value:function render(){var _options;var rclrVal='#D3D3D3';var data=[];if(this.props.benchMarkData&&this.props.benchMarkData!=null){var percentile=this.props.benchMarkData.percentile;var getperc=Math.abs(percentile.percentile_ranking);var overallscore=100;var loseperc=overallscore-getperc;//data = ["tooltip title","percentage","leftbarcolor","Bar inside txt","100-perce","rightbarcolor"];
data=[['','',{role:'style'},{sourceColumn:0,role:'annotation',type:'string',calc:'stringify'},'',{role:'style'}],['',getperc,this.getColor(getperc),String(getperc),loseperc,rclrVal]];}var params={chartType:"BarChart",width:'auto',height:'200px',loader:__WEBPACK_IMPORTED_MODULE_3__components_common_LoaderMask__["a" /* default */],data:data,options:(_options={title:'',chartArea:{width:'70%'},legend:{position:'none'},isStacked:true,bar:{groupWidth:'50%'}},_defineProperty(_options,"legend",{position:'none'}),_defineProperty(_options,"hAxis",{title:'Percentile Ranking',minValue:0,italic:false,baseline:getperc,baselineColor:'#003465',textStyle:{color:'#003465',fontSize:14},gridlines:{color:'#fff'}}),_options)};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BarChart__["a" /* default */],{params:params});}}]);return Barchart_Overall;}(__WEBPACK_IMPORTED_MODULE_4__views_core_LoggedInPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Barchart_Overall);

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_CorePage__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_HmAjax__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var DownloadContent=function(_CorePage){_inherits(DownloadContent,_CorePage);function DownloadContent(props){_classCallCheck(this,DownloadContent);var _this=_possibleConstructorReturn(this,(DownloadContent.__proto__||Object.getPrototypeOf(DownloadContent)).call(this,props));_this.classId=_this.props.classId||0;_this.accessId=_this.props.accessId||0;_this.clicked=false;_this.exportId=_this.props.exportId||0;return _this;}_createClass(DownloadContent,[{key:'initGenerate',value:function initGenerate(callback){var _this2=this;var me=this;var success=function success(resp){me.exportId=resp&&!isNaN(resp.exportId)&&resp.exportId>0?resp.exportId:0;me.clicked=false;console.log("resp ::: ",resp);if(typeof callback==="function"){callback.apply(_this2);}};var failure=function failure(err){me.clicked=false;};if(!this.clicked){this.clicked=true;var params={"classId":this.classId,"accessId":this.accessId};new __WEBPACK_IMPORTED_MODULE_2__util_HmAjax__["a" /* default */](this.getUrlFor("MS_GENERATE_PDF"),params).post(success,failure);}}},{key:'initDownload',value:function initDownload(){if(this.exportId){var url=this.getUrlFor("MS_DOWNLOAD_PDF").replace("{exportId}",this.exportId);window.open(url,"_blank");}else{console.warn("no export id available");}}},{key:'downloadFile',value:function downloadFile(){//if(!this.exportId){
this.initGenerate(this.initDownload);//}else{
// this.initDownload();
//}
}},{key:'render',value:function render(){var me=this;var dynClass=this.props.className||'';var dynText=this.props.text||'btn.download.pdf';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'DownloadContent',className:dynClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',className:'download-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'picture_as_pdf'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'download-text',onClick:function onClick(){me.downloadFile();}},this.rb(dynText))));}}]);return DownloadContent;}(__WEBPACK_IMPORTED_MODULE_1__views_core_CorePage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (DownloadContent);

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommonProductCatalogue__ = __webpack_require__(508);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PROD_TYPE_MAP={"class1":"SPL","class2":"SPL","class3":"SPL","class4":"SPL","class5":"PLP","class6":"PLP","class7":"PLP","class8":"PLP","class9":"PLP","class10":"PLP"};var NewINProductCatalogue=function(_CommonProductCatalog){_inherits(NewINProductCatalogue,_CommonProductCatalog);function NewINProductCatalogue(){_classCallCheck(this,NewINProductCatalogue);return _possibleConstructorReturn(this,(NewINProductCatalogue.__proto__||Object.getPrototypeOf(NewINProductCatalogue)).apply(this,arguments));}_createClass(NewINProductCatalogue,[{key:"componentDidMount",value:function componentDidMount(){_get(NewINProductCatalogue.prototype.__proto__||Object.getPrototypeOf(NewINProductCatalogue.prototype),"componentDidMount",this).call(this);this.isReloadRequired=!this.userLoggedIn;}},{key:"getSelectedIndex",value:function getSelectedIndex(indVal){var chosenGradeFromURL=this.getProdFromQryParam();if(window.catalog_qry_param_support[this.getCategory()]&&!isNaN(window.catalog_qry_param_support[this.getCategory()][chosenGradeFromURL])){return window.catalog_qry_param_support[this.getCategory()][chosenGradeFromURL];}return _get(NewINProductCatalogue.prototype.__proto__||Object.getPrototypeOf(NewINProductCatalogue.prototype),"getSelectedIndex",this).call(this,indVal);}},{key:"tabCustomCallBack",value:function tabCustomCallBack(tab){if(tab&&tab.selectedGrade&&PROD_TYPE_MAP[tab.selectedGrade]){this.switchProdType(PROD_TYPE_MAP[tab.selectedGrade]);}}},{key:"switchProdType",value:function switchProdType(prodType){if(typeof this.props.switchProdType==="function"){this.props.switchProdType(prodType);}}},{key:"getCategory",value:function getCategory(){return"IN_PLP";}//setting coupon false
},{key:"isCouponAllowed",value:function isCouponAllowed(){return window.in_plp_discount_available;}},{key:"couponAttrPrefix",value:function couponAttrPrefix(){return"in1";}},{key:"onBillingFormClose",value:function onBillingFormClose(){if(this.isReloadRequired){window.location.reload();}}}]);return NewINProductCatalogue;}(__WEBPACK_IMPORTED_MODULE_0__CommonProductCatalogue__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (NewINProductCatalogue);

/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__prelogin_src_components_TeacherBannerBuy__ = __webpack_require__(313);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InTopBanner=function(_TeacherBannerBuy){_inherits(InTopBanner,_TeacherBannerBuy);function InTopBanner(){_classCallCheck(this,InTopBanner);return _possibleConstructorReturn(this,(InTopBanner.__proto__||Object.getPrototypeOf(InTopBanner)).apply(this,arguments));}_createClass(InTopBanner,[{key:'render',value:function render(){var prodType=this.props.prodType?this.props.prodType.toLowerCase()+".":"";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:this.props.classes+" tchrhead"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,this.rb("in."+prodType+"products.heading"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tchrdiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.rb("in."+prodType+"products.subheading"),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.rb("in."+prodType+"products.subheading1")))));}}]);return InTopBanner;}(__WEBPACK_IMPORTED_MODULE_1__prelogin_src_components_TeacherBannerBuy__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (InTopBanner);

/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TeacherBuy__ = __webpack_require__(499);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SGTeacherBuy=function(_TeacherBuy){_inherits(SGTeacherBuy,_TeacherBuy);function SGTeacherBuy(){_classCallCheck(this,SGTeacherBuy);return _possibleConstructorReturn(this,(SGTeacherBuy.__proto__||Object.getPrototypeOf(SGTeacherBuy)).apply(this,arguments));}_createClass(SGTeacherBuy,[{key:'render',value:function render(){//var classname = this.getProductDetails()[this.props.id].ClassName;
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'mtb yellow-child'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container tchrbuy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.rb("sg.tchrcomp.subheading"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'galry-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,this.rb("sg.tchrcomp.subheading1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,this.rb("sg.tchrcomp.subheading2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,this.rb("sg.tchrcomp.subheading3")))));}}]);return SGTeacherBuy;}(__WEBPACK_IMPORTED_MODULE_1__TeacherBuy__["a" /* default */]);/* unused harmony default export */ var _unused_webpack_default_export = (SGTeacherBuy);

/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_common_Landing__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mdl_materialUsage_css__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mdl_materialUsage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__mdl_materialUsage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home_style_violet_css__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home_style_violet_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__home_style_violet_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__home_custom_css__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__home_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__home_custom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__css_myHome_css__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__css_myHome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__css_myHome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ms_topiccomponent__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ms_subtopiccomponent__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_plp_TestTakingModalComponent__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_plp_SubscribeModal__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_loader_spinner__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_loader_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_loader_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mindstretcher_ms_TestInfo__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_plp_GetTest__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_html_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_super_responsive_table_dist_SuperResponsiveTableStyle_css__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_super_responsive_table_dist_SuperResponsiveTableStyle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_super_responsive_table_dist_SuperResponsiveTableStyle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_dropdown__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_dropdown_style_css__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_dropdown_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_dropdown_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_slick_carousel_slick_slick_css__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_slick_carousel_slick_slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_slick_carousel_slick_slick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_slick_carousel_slick_slick_theme_css__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_slick_carousel_slick_slick_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_slick_carousel_slick_slick_theme_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_slick__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_scorecard_LessonComponent__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__images_icons_recom_lesson_png__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__images_icons_recom_lesson_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__images_icons_recom_lesson_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_warning_DesktopOnly__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__TimerComp__ = __webpack_require__(1267);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*import TopicComponent from '../../views/plp/TopicComponent';*//*import SubTopicComponent from '../../views/plp/SubTopicComponent';*//*
* Using Extended component
*///import { Table } from 'reactstrap';
/*import Swiper from 'react-id-swiper';*/var topicListPlaceHolder="{\"4\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":4,\"topicId\":2,\"subTopicId\":4,\"topicName\":\"Decimals\",\"subTopicName\":\"Introduction to Decimals\",\"subtopicStatus\":{\"topicsubtopicId\":4,\"testId\":1,\"revisiontestid\":4,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"COMPLETED\",\"referenceId\":\"4\",\"recommendtestid\":\"2\",\"testScore\":\"1\",\"testTotalScore\":\"10\",\"recommendTestScore\":\"3\",\"recommendTestTotalScore\":\"9\",\"cumulativeScore\":\"4\",\"cumulativeTotalScore\":\"10\"},\"displayorder\":1,\"styleid\":1,\"animationGif\":\"05-fivedecimal\"},\"5\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":5,\"topicId\":2,\"subTopicId\":5,\"topicName\":\"Decimals\",\"subTopicName\":\"Addition and Subtraction of Decimals\",\"subtopicStatus\":{\"topicsubtopicId\":5,\"testId\":9,\"revisiontestid\":5,\"testStatus\":\"IN_PROGRESS\",\"reqTestStatus\":null,\"referenceId\":\"5\",\"recommendtestid\":\"0\",\"testScore\":\"0\",\"testTotalScore\":\"5\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"0\",\"cumulativeScore\":\"0\",\"cumulativeTotalScore\":\"5\"},\"displayorder\":2,\"styleid\":1,\"animationGif\":\"05-fivedecimal\"},\"6\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":6,\"topicId\":2,\"subTopicId\":6,\"topicName\":\"Decimals\",\"subTopicName\":\"Multiplication and Division of Decimals\",\"subtopicStatus\":{\"topicsubtopicId\":6,\"testId\":39,\"revisiontestid\":6,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"NEW\",\"referenceId\":\"6\",\"recommendtestid\":\"40\",\"testScore\":\"1\",\"testTotalScore\":\"7\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"6\",\"cumulativeScore\":\"1\",\"cumulativeTotalScore\":\"7\"},\"displayorder\":3,\"styleid\":1,\"animationGif\":\"05-fivedecimal\"},\"7\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":7,\"topicId\":2,\"subTopicId\":7,\"topicName\":\"Decimals\",\"subTopicName\":\"Application Problems\",\"subtopicStatus\":{\"topicsubtopicId\":7,\"testId\":52,\"revisiontestid\":7,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"NEW\",\"referenceId\":\"7\",\"recommendtestid\":\"53\",\"testScore\":\"0\",\"testTotalScore\":\"5\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"5\",\"cumulativeScore\":\"0\",\"cumulativeTotalScore\":\"5\"},\"displayorder\":4,\"styleid\":1,\"animationGif\":\"05-fivedecimal\"},\"12\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":12,\"topicId\":5,\"subTopicId\":12,\"topicName\":\"Factors and Multiples\",\"subTopicName\":\"Prime Factors and Tests of Divisibility\",\"subtopicStatus\":{\"topicsubtopicId\":12,\"testId\":13,\"revisiontestid\":12,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"COMPLETED\",\"referenceId\":\"12\",\"recommendtestid\":\"14\",\"testScore\":\"0\",\"testTotalScore\":\"3\",\"recommendTestScore\":\"2\",\"recommendTestTotalScore\":\"3\",\"cumulativeScore\":\"2\",\"cumulativeTotalScore\":\"3\"},\"displayorder\":5,\"styleid\":2,\"animationGif\":\"05-fivefactmult\"},\"13\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":13,\"topicId\":5,\"subTopicId\":13,\"topicName\":\"Factors and Multiples\",\"subTopicName\":\"HCF and LCM\",\"subtopicStatus\":{\"topicsubtopicId\":13,\"testId\":19,\"revisiontestid\":13,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"COMPLETED\",\"referenceId\":\"13\",\"recommendtestid\":\"20\",\"testScore\":\"0\",\"testTotalScore\":\"4\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"4\",\"cumulativeScore\":\"0\",\"cumulativeTotalScore\":\"4\"},\"displayorder\":6,\"styleid\":2,\"animationGif\":\"05-fivefactmult\"},\"14\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":14,\"topicId\":5,\"subTopicId\":7,\"topicName\":\"Factors and Multiples\",\"subTopicName\":\"Application Problems\",\"subtopicStatus\":{\"topicsubtopicId\":14,\"testId\":22,\"revisiontestid\":14,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"COMPLETED\",\"referenceId\":\"14\",\"recommendtestid\":\"23\",\"testScore\":\"0\",\"testTotalScore\":\"5\",\"recommendTestScore\":\"1\",\"recommendTestTotalScore\":\"5\",\"cumulativeScore\":\"1\",\"cumulativeTotalScore\":\"5\"},\"displayorder\":7,\"styleid\":2,\"animationGif\":\"05-fivefactmult\"},\"15\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":15,\"topicId\":6,\"subTopicId\":14,\"topicName\":\"Fractions\",\"subTopicName\":\"Introduction to Fractions\",\"subtopicStatus\":{\"topicsubtopicId\":15,\"testId\":0,\"revisiontestid\":15,\"testStatus\":null,\"reqTestStatus\":null,\"referenceId\":\"0\",\"recommendtestid\":\"0\",\"testScore\":\"0\",\"testTotalScore\":\"0\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"0\",\"cumulativeScore\":\"0\",\"cumulativeTotalScore\":\"0\"},\"displayorder\":8,\"styleid\":3,\"animationGif\":\"05-fivefraction\"},\"16\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":16,\"topicId\":6,\"subTopicId\":15,\"topicName\":\"Fractions\",\"subTopicName\":\"Addition and Subtraction of fractions\",\"subtopicStatus\":{\"topicsubtopicId\":16,\"testId\":44,\"revisiontestid\":16,\"testStatus\":\"NEW\",\"reqTestStatus\":null,\"referenceId\":\"16\",\"recommendtestid\":\"0\",\"testScore\":\"0\",\"testTotalScore\":\"7\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"0\",\"cumulativeScore\":\"0\",\"cumulativeTotalScore\":\"7\"},\"displayorder\":9,\"styleid\":3,\"animationGif\":\"05-fivefraction\"},\"17\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":17,\"topicId\":6,\"subTopicId\":16,\"topicName\":\"Fractions\",\"subTopicName\":\"Multiplication and Division of fractions\",\"subtopicStatus\":{\"topicsubtopicId\":17,\"testId\":54,\"revisiontestid\":17,\"testStatus\":\"IN_PROGRESS\",\"reqTestStatus\":null,\"referenceId\":\"17\",\"recommendtestid\":\"0\",\"testScore\":\"0\",\"testTotalScore\":\"6\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"0\",\"cumulativeScore\":\"0\",\"cumulativeTotalScore\":\"6\"},\"displayorder\":10,\"styleid\":3,\"animationGif\":\"05-fivefraction\"},\"18\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":18,\"topicId\":6,\"subTopicId\":7,\"topicName\":\"Fractions\",\"subTopicName\":\"Application Problems\",\"subtopicStatus\":{\"topicsubtopicId\":18,\"testId\":41,\"revisiontestid\":18,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"IN_PROGRESS\",\"referenceId\":\"18\",\"recommendtestid\":\"42\",\"testScore\":\"0\",\"testTotalScore\":\"4\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"4\",\"cumulativeScore\":\"0\",\"cumulativeTotalScore\":\"4\"},\"displayorder\":11,\"styleid\":3,\"animationGif\":\"05-fivefraction\"},\"19\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":19,\"topicId\":7,\"subTopicId\":17,\"topicName\":\"Percentages\",\"subTopicName\":\"Percentages\",\"subtopicStatus\":{\"topicsubtopicId\":19,\"testId\":34,\"revisiontestid\":19,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"IN_PROGRESS\",\"referenceId\":\"19\",\"recommendtestid\":\"51\",\"testScore\":\"0\",\"testTotalScore\":\"8\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"8\",\"cumulativeScore\":\"0\",\"cumulativeTotalScore\":\"8\"},\"displayorder\":12,\"styleid\":4,\"animationGif\":\"05-fivepercentage\"},\"20\":{\"classId\":2,\"className\":\"Class 5\",\"topics\":null,\"topicSubTopicMapId\":20,\"topicId\":7,\"subTopicId\":18,\"topicName\":\"Percentages\",\"subTopicName\":\"More on Percentages\",\"subtopicStatus\":{\"topicsubtopicId\":20,\"testId\":50,\"revisiontestid\":20,\"testStatus\":\"COMPLETED\",\"reqTestStatus\":\"IN_PROGRESS\",\"referenceId\":\"20\",\"recommendtestid\":\"56\",\"testScore\":\"2\",\"testTotalScore\":\"8\",\"recommendTestScore\":\"0\",\"recommendTestTotalScore\":\"6\",\"cumulativeScore\":\"2\",\"cumulativeTotalScore\":\"8\"},\"displayorder\":13,\"styleid\":4,\"animationGif\":\"05-fivepercentage\"}}";//var selectedProductOption = "";
//var selectedGradeOption = "";
var settings={dots:false,infinite:false,speed:300,slidesToShow:5,slidesToScroll:5,responsive:[{breakpoint:1370,settings:{slidesToShow:4,slidesToScroll:4,infinite:false,dots:false}},{breakpoint:1100,settings:{slidesToShow:3,slidesToScroll:3,infinite:false,dots:false}},{breakpoint:767,settings:{slidesToShow:2,slidesToScroll:2}},{breakpoint:550,settings:{slidesToShow:1,slidesToScroll:1}// You can unslick at a given breakpoint now by adding:
// settings: "unslick"
// instead of a settings object
}]};function groupTopicsBy(list,lessonOnlyMode){var topicList=[];var tempTopicMap={};for(var i in list){if(list[i].subtopicStatus){var topicId=list[i].topicId;var topicOb=tempTopicMap[topicId];if(topicOb==null){topicOb={};//Topic Atttributes here
topicOb.topicId=topicId;topicOb.classId=list[i].classId;topicOb.className=list[i].className;topicOb.topicName=list[i].topicName;topicOb.topicDescription=list[i].topicDescription;topicOb.topicSubTopicMapId=list[i].topicSubTopicMapId;topicOb.staticImgPath=list[i].staticImgPath;topicOb.animatedImgPath=list[i].animatedImgPath;topicOb.colourCode=list[i].colourCode;topicOb.styleid=list[i].styleid;topicOb.statusArr=[];topicOb.scoreNumeratorArr=[];topicOb.scoreDenominatorArr=[];topicOb.topicPoints=0;topicOb.userTopicPoints=0;//Check if topic is locked
topicOb.topicLocked=list[i].topicLocked&&list[i].topicLocked===true?list[i].topicLocked:false;//topicOb.practiceLocked = list[i].practiceLocked;	
}if(topicOb["subTopicMap"]!=undefined&&topicOb["subTopicMap"]!=null){topicOb["subTopicMap"];}else{topicOb["subTopicMap"]={};topicOb["sortedSubTopicArr"]=[];}if(!topicOb["subTopicMap"][list[i].subTopicId]){var subTopicObj={};//Subtopic Atttributes here
subTopicObj.subTopicId=list[i].subTopicId;subTopicObj.subTopicName=list[i].subTopicName;subTopicObj.reqTestStatus=list[i].subtopicStatus.reqTestStatus?list[i].subtopicStatus.reqTestStatus:null;subTopicObj.revisiontestid=list[i].subtopicStatus.revisiontestid;subTopicObj.testId=list[i].subtopicStatus.testId;subTopicObj.testStatus=list[i].subtopicStatus.testStatus?list[i].subtopicStatus.testStatus:null;subTopicObj.topicsubtopicId=list[i].subtopicStatus.topicsubtopicId;subTopicObj.recommendtestid=list[i].subtopicStatus.recommendtestid;subTopicObj.displayorder=list[i].displayorder;topicOb.topicPoints+=subTopicObj.subTopicPoints=list[i].subtopicStatus.subTopicPoints?list[i].subtopicStatus.subTopicPoints:0;topicOb.userTopicPoints+=subTopicObj.userPoints=list[i].subtopicStatus.userPoints?list[i].subtopicStatus.userPoints:0;subTopicObj.grade=list[i].subtopicStatus.grade?list[i].subtopicStatus.grade:"";subTopicObj.cumulativeScore=parseInt(list[i].subtopicStatus.cumulativeScore);subTopicObj.cumulativeTotalScore=parseInt(list[i].subtopicStatus.cumulativeTotalScore);subTopicObj.recommendTestScore=parseInt(list[i].subtopicStatus.recommendTestScore);subTopicObj.recommendTestTotalScore=parseInt(list[i].subtopicStatus.recommendTestTotalScore);subTopicObj.testScore=parseInt(list[i].subtopicStatus.testScore);subTopicObj.testTotalScore=parseInt(list[i].subtopicStatus.testTotalScore);subTopicObj.percentScore=Math.round(subTopicObj.cumulativeScore/subTopicObj.cumulativeTotalScore*100);subTopicObj.topicNumerator=subTopicObj.cumulativeScore;subTopicObj.topicDenominator=subTopicObj.cumulativeTotalScore;subTopicObj.rating=parseInt(list[i].subtopicStatus.rating);subTopicObj.parentTopicId=topicId;subTopicObj.practiceLocked=list[i].practiceLocked;subTopicObj.purchased=list[i].purchased;subTopicObj.noOfRetakesAvailable=parseInt(list[i].subtopicStatus.noOfRetakesAvailable);if(lessonOnlyMode){subTopicObj.lessonsSubTopicArr=list[i].subtopicStatus.lessonDefnList;}if(list[i].subtopicStatus!=null){if(list[i].subtopicStatus.reqTestStatus==null&&list[i].subtopicStatus.testStatus==null){subTopicObj.status="NEW";}else if(list[i].subtopicStatus.reqTestStatus=="NEW"&&list[i].subtopicStatus.testStatus==null||list[i].subtopicStatus.reqTestStatus==null&&list[i].subtopicStatus.testStatus=="NEW"){subTopicObj.status="NEW";}else if(list[i].subtopicStatus.reqTestStatus=="COMPLETED"&&list[i].subtopicStatus.testStatus=="COMPLETED"){subTopicObj.status="COMPLETED";}else if(list[i].subtopicStatus.recommendtestid==0&&list[i].subtopicStatus.testStatus=="COMPLETED"){subTopicObj.status="COMPLETED";}else{subTopicObj.status="IN_PROGRESS";}}else{subTopicObj.status="NEW";}if(lessonOnlyMode){subTopicObj.status=list[i].subtopicStatus.lessonStatus;}topicOb.scoreNumeratorArr.push(subTopicObj.topicNumerator);topicOb.scoreDenominatorArr.push(subTopicObj.topicDenominator);topicOb.statusArr.push(subTopicObj.status);topicOb["subTopicMap"][subTopicObj.subTopicId]=subTopicObj;topicOb["sortedSubTopicArr"].push(subTopicObj);}tempTopicMap[topicId]=topicOb;}//console.log("Temp topic ",topicOb)
}for(var j in tempTopicMap){topicList.push(topicStatusCheck(tempTopicMap[j]));}//Sorting of Topics goes here
topicList=sortTopics(topicList);//console.log("topicList ::", topicList);
return topicList;}function topicStatusCheck(topicOb){try{if(topicOb.statusArr!=null){if(topicOb.statusArr.indexOf("IN_PROGRESS")>=0){topicOb.status="IN_PROGRESS";}else{if(topicOb.statusArr.indexOf("NEW")<0&&topicOb.statusArr.indexOf("UN_ATTEMPTED")<0){topicOb.status="COMPLETED";}else{if(topicOb.statusArr.indexOf("COMPLETED")<0){topicOb.status="NEW";}else{topicOb.status="IN_PROGRESS";}}}}if(topicOb.scoreNumeratorArr!=null&&topicOb.scoreDenominatorArr!=null){var _numerator=0;var _denominator=0;for(var i=0;i<topicOb.scoreNumeratorArr.length;i++){_numerator+=topicOb.scoreNumeratorArr[i];_denominator+=topicOb.scoreDenominatorArr[i];}var percentScore=Math.round(_numerator/_denominator*100);topicOb.percentScore=percentScore;}}catch(e){}return topicOb;}/**
 * Topics Sorting is not present. Future Implementation if required
 */function sortTopics(topicObj){try{for(var t in topicObj){topicObj[t]["sortedSubTopicArr"]=sortSubTopics(topicObj[t]["sortedSubTopicArr"]);}}catch(e){}return topicObj;}/**
 * Sub-Topics Sorting
 */function sortSubTopics(subTopicArr){try{var sortedSubTopicArr=subTopicArr.sort(function(a,b){return a.displayorder-b.displayorder;});return sortedSubTopicArr;}catch(e){}return subTopicArr;}var loadingView="loadingView";var topicView="topicView";var subTopicView="subTopicView";var messageView="messageView";var productExpiredView="productExpiredView";var allTopicsView="allTopicsView";var pointsSystemView="pointsSystemView";var noProductView="noProductView";var desktopOnlyView="desktopOnlyView";var gradePointsMap={"grades":[{"id":1,"name":"defaultGradeCalculator","grade":"C","minPercent":0,"maxPercent":39},{"id":1,"name":"defaultGradeCalculator","grade":"B","minPercent":40,"maxPercent":64},{"id":1,"name":"defaultGradeCalculator","grade":"B+","minPercent":65,"maxPercent":74},{"id":1,"name":"defaultGradeCalculator","grade":"A","minPercent":75,"maxPercent":84},{"id":1,"name":"defaultGradeCalculator","grade":"A+","minPercent":85,"maxPercent":100}],"points":{"hard":{"1":30,"2":20,"3":15},"medium":{"1":20,"2":13,"3":10},"easy":{"1":10,"2":7,"3":5}}};var ms_Home=function(_Landing){_inherits(ms_Home,_Landing);function ms_Home(props){_classCallCheck(this,ms_Home);var _this=_possibleConstructorReturn(this,(ms_Home.__proto__||Object.getPrototypeOf(ms_Home)).call(this,props));_this.state={topics:[],subtopics:[],selectedTopic:[],selectedSubTopic:[],selectedTopicIndex:null,view:loadingView,message:"",modalShow:false,modalContent:"loading",modalTitle:"",modalView:"loading",productArr:[],gradeArr:[],lessonOnlyMode:false,subTopicBoxColor:"#77b900",productExpired:false,noProducts:false,topicSubView:allTopicsView,purchased:true,SubscribeModal:false,timerShow:false,elapsedTime:0};_this.onTopicChangedEvent=_this.onTopicChangedEvent.bind(_this);_this.onSubTopicChangedEvent=_this.onSubTopicChangedEvent.bind(_this);_this.getTopicList=_this.getTopicList.bind(_this);_this.showAllTopics=_this.showAllTopics.bind(_this);_this.showModal=_this.showModal.bind(_this);_this.hideModal=_this.hideModal.bind(_this);_this.startTest=_this.startTest.bind(_this);_this.topicPointClick=_this.topicPointClick.bind(_this);_this.setModalBackdropClose=_this.setModalBackdropClose.bind(_this);_this.accessId=0;_this.gradeProductMap={};_this.selectedGradeOption=null;_this.selectedProductOption=null;_this.comboNamesLoaded=false;_this.gradeStore=null;_this.homeDropDownKey="homeDropdown";_this.preferredGrade=null;_this.preferredProduct=null;_this.TestTypeLbl="";_this.showSubscribemodal=_this.showSubscribemodal.bind(_this);_this.hideSubscribeModal=_this.hideSubscribeModal.bind(_this);_this.assignStateFromParent=_this.assignStateFromParent.bind(_this);_this.showFormobile=_this.showFormobile.bind(_this);_this.goToLanding=_this.goToLanding.bind(_this);_this.setChild(_this,"HOME");_this.closeTimer=_this.closeTimer.bind(_this);_this.starttime=0;_this.topicInfoObj={};_this.getelapsedTime=_this.getelapsedTime.bind(_this);_this.updateelapsedTime=_this.updateelapsedTime.bind(_this);_this.autoSubmit=_this.autoSubmit.bind(_this);_this.startTimer=_this.startTimer.bind(_this);_this.resumeTimer=_this.resumeTimer.bind(_this);_this.pauseTimer=_this.pauseTimer.bind(_this);_this.closeTimer=_this.closeTimer.bind(_this);return _this;}_createClass(ms_Home,[{key:'assignStateFromParent',value:function assignStateFromParent(obj){if(obj){this.setState(obj);}}},{key:'componentDidMount',value:function componentDidMount(){_get(ms_Home.prototype.__proto__||Object.getPrototypeOf(ms_Home.prototype),'componentDidMount',this).call(this);if(this.productsAvailableToAccess()){//this.getGradeList();
this.getPointDetails();}this.fireMobileToast();}},{key:'productsAvailableToAccess',value:function productsAvailableToAccess(){var user=this.getUser();if(user!=null){var permissions=user.getPermissions();if(permissions!=null&&Object.keys(permissions).length>0){for(var i in permissions){if(permissions[i]!=null){var totalLevel=permissions[i].split(",").reduce(function(a,b){try{return parseInt(a)+parseInt(b);}catch(e){return 0;}});if(totalLevel>0){return true;}}}}}return false;}},{key:'isLessonTabAvailable',value:function isLessonTabAvailable(){//This is restricted to only Mobile check for now
return this.showFormobile();}},{key:'showFormobile',value:function showFormobile(){var isMobileOrTab=this.isTab()||this.isMobile();var lessonLockForGrades=window.lessonLockForGrades||[];var gradeVal=!isNaN(this.selectedGradeOption.value)?Number(this.selectedGradeOption.value):0;return!(lessonLockForGrades.indexOf(gradeVal)>-1&&isMobileOrTab);}},{key:'getPointDetails',value:function getPointDetails(){var me=this;var callBackSuccess=function callBackSuccess(response){//console.log("point response::",response);	
if(response){gradePointsMap=response;}};var callBackFailure=function callBackFailure(response){console.log("Failure::: in GET_POINTS_DETAILS");};new __WEBPACK_IMPORTED_MODULE_8__util_HmAjax__["a" /* default */](this.getUrlFor("GET_POINTS_DETAILS")).get(callBackSuccess,callBackFailure);}},{key:'getTopicList',value:function getTopicList(){var myView=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var me=this;me.setState({productExpired:false,topicSubView:allTopicsView});var permissions=this.getUser().getPermissions();var entlhistory=this.getUser().getEntlHistory();//console.log(permissions);
//console.log(entlhistory);
/*if((permissions && Object.keys(permissions).length <= 0) && (entlhistory && Object.keys(entlhistory).length <= 0)){
			alert("no products for you..");	
			return;
		}else if((permissions && Object.keys(permissions).length <= 0)){
			alert("products expired...");	
			return;
		}*/var serviceType=null;var accessId=0;if(me.selectedProductOption.value!==undefined&&me.selectedProductOption.value!==null&&me.selectedProductOption.value.length>0){if(me.selectedProductOption.value.toLowerCase().indexOf("revision")>0){serviceType="revision";}else if(me.selectedProductOption.value.toLowerCase().indexOf("test")>0){serviceType="test";}}accessId=!isNaN(me.selectedProductOption.value)?me.selectedProductOption.value:accessId;this.accessId=accessId;if(this.accessId==3){me.setState({lessonOnlyMode:true});}else{me.setState({lessonOnlyMode:false});}try{if(permissions[accessId]){var levels=permissions[accessId].split(",");//console.log("me.selectedProductOption.value=="+me.selectedProductOption.value);
//console.log(products,me.selectedProductOption.value,$.inArray(me.selectedProductOption.value, products));
if(__WEBPACK_IMPORTED_MODULE_7_jquery___default.a.inArray(me.selectedGradeOption.value,levels)<0){me.setState({productExpired:true,view:productExpiredView});try{this.gradeStore={"grd":me.selectedGradeOption.value,"prod":accessId};this.setAttribute(this.homeDropDownKey,JSON.stringify(this.gradeStore));}catch(e){}try{var trackObj={"grade_id":me.selectedGradeOption.value,"product_type":accessId,"source":this.getTracker().enums.selectedProductSource.home};this.initiateTrack("product_selected",trackObj);}catch(e){}return;}}else{me.setState({productExpired:true,view:productExpiredView});try{this.gradeStore={"grd":me.selectedGradeOption.value,"prod":accessId};this.setAttribute(this.homeDropDownKey,JSON.stringify(this.gradeStore));}catch(e){}try{var trackObj={"grade_id":me.selectedGradeOption.value,"product_type":accessId,"source":this.getTracker().enums.selectedProductSource.home};this.initiateTrack("product_selected",trackObj);}catch(e){}return;}}catch(e){}if(myView===null){myView=topicView;}this.setState({modalShow:false,modalContent:"loading",view:loadingView,modalTitle:"",modalView:"loading"});var callBackSuccess=function callBackSuccess(response){if(response.code===200){var topicListObj=JSON.parse(response.data);var topicListObjFinal=groupTopicsBy(topicListObj,me.state.lessonOnlyMode);if(topicListObjFinal&&topicListObjFinal.length>0){if(myView===subTopicView){var subTopicMap=topicListObjFinal[me.state.selectedTopicIndex].sortedSubTopicArr;if(subTopicMap.length>0){me.setState({topics:topicListObjFinal,subtopics:subTopicMap,view:subTopicView});}}else{me.setState({topics:topicListObjFinal,view:myView});}if(topicListObjFinal&&topicListObjFinal[0].subTopicMap&&topicListObjFinal[0].subTopicMap){var purchased=false;try{purchased=Object.values(topicListObjFinal[0].subTopicMap)[0].purchased;}catch(e){}me.setState({purchased:purchased});}//console.log("lalala ::" , topicListObjFinal);
}else{me.setState({message:me.rb("home.notopics"),view:messageView});}}else if(response.code===400){me.setState({message:me.rb("home.notopics"),view:messageView});}else{me.setState({message:me.rb("error.oops"),view:messageView});}};var callBackFailure=function callBackFailure(response){me.setState({message:me.rb("error.oops"),view:messageView});me.showAlert(me.rb("503.title"),me.rb("503.msg"));};new __WEBPACK_IMPORTED_MODULE_8__util_HmAjax__["a" /* default */](this.getUrlFor("GET_PLP_TOPICS")+"?access="+accessId+"&level="+me.selectedGradeOption.value).get(callBackSuccess,callBackFailure);try{this.gradeStore={"grd":me.selectedGradeOption.value,"prod":accessId};this.setAttribute(this.homeDropDownKey,JSON.stringify(this.gradeStore));}catch(e){}try{var trackObj={"grade_id":me.selectedGradeOption.value,"product_type":accessId,"source":this.getTracker().enums.selectedProductSource.home};this.initiateTrack("product_selected",trackObj);}catch(e){}__WEBPACK_IMPORTED_MODULE_7_jquery___default()(".hometopmenu").removeClass("selected");__WEBPACK_IMPORTED_MODULE_7_jquery___default()(".allTopics").addClass("selected");}},{key:'onTopicChangedEvent',value:function onTopicChangedEvent(topicMap,selectedTopicIndex,boxColor){var me=this;var subTopicMap=topicMap.sortedSubTopicArr;if(subTopicMap.length>0){this.setState({subtopics:subTopicMap,view:subTopicView,selectedTopic:topicMap,selectedTopicIndex:selectedTopicIndex,subTopicBoxColor:boxColor});}else{me.setState({message:me.rb("home.nosubtopics"),view:messageView});}var trackObj={"item_id":topicMap.topicId,"item_type":this.getTracker().enums.selectedItemType.topic,"source":this.getTracker().enums.selectedItemSource.home};this.initiateTrack("item_selected",trackObj);}},{key:'onSubTopicChangedEvent',value:function onSubTopicChangedEvent(subtopicMap){var typelbl=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";var testId=subtopicMap.testId;var classId=subtopicMap.classId;var testStatus=subtopicMap.testStatus||subtopicMap.status;var recommendtestid=subtopicMap.recommendtestid;var reqTestStatus=subtopicMap.reqTestStatus;var selectedtopicsubtopicId=subtopicMap.topicsubtopicId;var selectedrevisiontestid=subtopicMap.revisiontestid;this.TestTypeLbl=typelbl;this.setState({selectedSubTopic:subtopicMap});//console.log(subtopicMap)
if(this.state.lessonOnlyMode){var lessonList=subtopicMap.lessonsSubTopicArr;this.showLessonOnlyModal(lessonList,testId,selectedtopicsubtopicId,selectedrevisiontestid,subtopicMap);}else{if(testStatus.toUpperCase()=="COMPLETED"){if(recommendtestid==0||recommendtestid==null){alert("show revision scorecared for testId="+testId);}else if(reqTestStatus=="COMPLETED"){alert("show recommendation scorecared for testId="+recommendtestid);}else{//alert("start Practice for recommendtestid="+recommendtestid);
this.showModal(recommendtestid,selectedtopicsubtopicId,selectedrevisiontestid,classId);this.fireMobileToast();}}else{this.showModal(testId,selectedtopicsubtopicId,selectedrevisiontestid,classId);this.fireMobileToast();}}var trackObj={"item_id":subtopicMap.topicsubtopicId,"item_type":this.getTracker().enums.selectedItemType.subtopic,"source":this.getTracker().enums.selectedItemSource.home};this.initiateTrack("item_selected",trackObj);}},{key:'showAllTopics',value:function showAllTopics(){this.setState({view:topicView,selectedTopicIndex:null});}},{key:'showLessonOnlyModal',value:function showLessonOnlyModal(lessonList,testId,selectedtopicsubtopicId,selectedrevisiontestid,subtopicObj){this.setState({modalShow:true,modalContent:this.getLessonModalContent(lessonList,testId,selectedtopicsubtopicId,selectedrevisiontestid,subtopicObj),modalTitle:subtopicObj.subTopicName,modalView:"lessonInfo"});//alert(lessonId+", "+lessonName+", "+lessonUrl+", "+lessonDd);
//this.setSlick();
}},{key:'showModal',value:function showModal(testId){var topicsubtopicId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var revisiontestid=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var classId=arguments[3];this.setState({modalShow:true,modalContent:this.setTestInfoScreen(testId,topicsubtopicId,revisiontestid,classId),modalTitle:"",modalView:"testInfo"});}},{key:'setTestInfoScreen',value:function setTestInfoScreen(testId,topicsubtopicId,revisiontestid,classId){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__mindstretcher_ms_TestInfo__["a" /* default */],{callbackParent:this.startTest,accessId:this.accessId,testId:testId,topicsubtopicId:topicsubtopicId,revisiontestid:revisiontestid,classId:this.selectedGradeOption.value,onRef:function onRef(ref){return _this2.getTestInfoComponent=ref;},gradeName:this.selectedGradeOption.label});}},{key:'loadTestScreen',value:function loadTestScreen(topicInfoObj,topicsubtopicId,revisiontestid){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__views_plp_GetTest__["a" /* default */],_defineProperty({topicInfoObj:topicInfoObj,topicsubtopicId:topicsubtopicId,revisiontestid:revisiontestid,onRef:function onRef(ref){return _this3.getTestComponent=ref;},gradeName:this.selectedGradeOption.label,subtopic:this.state.selectedSubTopic,closeTimer:this.closeTimer,callbackParent:this.getelapsedTime,startTimer:this.startTimer,resumeTimer:this.resumeTimer,pauseTimer:this.pauseTimer},'closeTimer',this.closeTimer));}},{key:'getelapsedTime',value:function getelapsedTime(){return this.state.elapsedTime;}},{key:'updateelapsedTime',value:function updateelapsedTime(time){this.setState({elapsedTime:time});}},{key:'hideSubscribeModal',value:function hideSubscribeModal(){this.setState({SubscribeModal:false});}},{key:'showSubscribemodal',value:function showSubscribemodal(){this.setState({SubscribeModal:true});}},{key:'rendershowSubscribe',value:function rendershowSubscribe(dataga,subtopictitle){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'ss-modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__views_plp_TestTakingModalComponent__["a" /* default */],{visible:this.state.SubscribeModal,dialogClassName:"fullwidthdiag grademodal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-header bg-purple'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-title'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close helpClose',onClick:this.hideSubscribeModal,'aria-label':'Close'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'close')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',_defineProperty({className:'modal-body'},'className','col-12 text-center subscrcont'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__views_plp_SubscribeModal__["a" /* default */],{ga:dataga}))));}},{key:'setSlick',value:function setSlick(){__WEBPACK_IMPORTED_MODULE_7_jquery___default()('.responsive').slick({dots:true,infinite:false,speed:300,slidesToShow:4,slidesToScroll:4,responsive:[{breakpoint:1024,settings:{slidesToShow:3,slidesToScroll:3,infinite:true,dots:true}},{breakpoint:600,settings:{slidesToShow:2,slidesToScroll:2}},{breakpoint:480,settings:{slidesToShow:1,slidesToScroll:1}// You can unslick at a given breakpoint now by adding:
// settings: "unslick"
// instead of a settings object
}]});}},{key:'subscribeFn',value:function subscribeFn(props,dataga){if(props){return _get(ms_Home.prototype.__proto__||Object.getPrototypeOf(ms_Home.prototype),'subscribeFn',this).call(this,dataga);}}},{key:'getLessonModalContent',value:function getLessonModalContent(lessonList,testId,selectedtopicsubtopicId,selectedrevisiontestid,subtopicObj){var accessId=0;var accessId=!isNaN(this.selectedProductOption.value)?this.selectedProductOption.value:accessId;var classId=this.selectedGradeOption.value;var isFreeTrial=subtopicObj.practiceLocked;// if(!subtopicObj.practiceLocked){
// 	var classIdCount = this.getClassIdforAccessCount(classId);
// 	if(classIdCount>1){
// 		isFreeTrial = true;
// 	}
// }
//console.log("lessonList::",lessonList);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,this.rb("home.lessons"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row allMiddle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-12 col-12 col-md-2 col-lg-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_25__images_icons_recom_lesson_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-12 col-12 col-md-10 col-lg-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.rb("scorecard.recommended.rawtext2")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row allMiddle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-8 col-8 col-md-10 col-lg-10 imgGal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-center scorecardLessons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_react_slick___default.a,settings,lessonList.map(function(lesson,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__views_scorecard_LessonComponent__["a" /* default */],{isFrom:"Home",isFreeTrail:isFreeTrial,lesson:lesson,testId:testId,topicSubTopicMapId:selectedtopicsubtopicId,accessId:accessId,classId:classId,key:index,tracksource:'subtopic'});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-center allMiddle'},this.subscribeFn(isFreeTrial,"Post login - Class "+classId+" - Lessons - "+this.state.selectedTopic.topicName+" - "+subtopicObj.subTopicName+" - Lessons - Subscribe")))));}},{key:'onCloseHandler',value:function onCloseHandler(){try{if(this.getTestComponent&&typeof this.getTestComponent.onCloseHandler==="function"){this.getTestComponent.onCloseHandler();}else{console.warn("Not submitting this test: function 'onCloseHandler' not available");}}catch(e){console.error(e);}}},{key:'hideModal',value:function hideModal(){try{if(this.getTestComponent){this.closeTimer();this.getTestComponent.modalCloseEvent();}else if(this.getTestInfoComponent){this.getTestInfoComponent.trackTestClose();}}catch(e){}this.onCloseHandler();this.getTestComponent=null;this.getTestInfoComponent=null;this.setState({modalShow:false,modalContent:"loading",view:loadingView,modalTitle:"",modalView:"loading"});this.getTopicList(subTopicView);}},{key:'setModalClass',value:function setModalClass(){if(this.state.modalView=="testView"){return" modal-lg custom-modal";}return" modal-lg";}},{key:'setModalBackdropClose',value:function setModalBackdropClose(){if(this.state.modalView=="lessonInfo"){return this.hideModal;}return"";}},{key:'setModalTitle',value:function setModalTitle(topicInfoObj){/* let testType = "";
		if(topicInfoObj.testDetails.mode == 1 || topicInfoObj.testDetails.mode == "1"){
			testType = " - "+ this.rb("home.proficiencytest");
		}else{
			//testType = this.rb("home.practicetest");
		} */var topics=topicInfoObj.testDetails.topics;//.split("- Customized Practice").join("- Customised Practice");	
return topics;//+ testType;
}},{key:'loadModalContent',value:function loadModalContent(){if(this.state.modalContent==="loading"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center loadingAnim'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_loader_spinner___default.a,{type:'Oval',color:'#00BFFF',height:'100',width:'100'}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.modalContent);}}},{key:'startTest',value:function startTest(topicInfoObj,topicsubtopicId,revisiontestid){var me=this;var durationInSeconds=false;if(topicInfoObj&&topicInfoObj.testDetails){durationInSeconds=topicInfoObj.testDetails.durationInSeconds>0?true:false;}this.setState({modalContent:this.loadTestScreen(topicInfoObj,topicsubtopicId,revisiontestid),modalTitle:this.setModalTitle(topicInfoObj),modalView:"testView",timerShow:durationInSeconds});if(topicInfoObj&&topicInfoObj.testDetails){try{me.starttime=topicInfoObj.testDetails.durationInSeconds;me.topicInfoObj=topicInfoObj;me.setState({elapsedTime:me.topicInfoObj.userTest.elapsedTime});}catch(e){console.log("timer not saved");}}var source_test_id=0;var resumed=null;if(topicInfoObj.testDetails.mode==1||topicInfoObj.testDetails.mode=="1"){source_test_id=null;if(this.state.selectedSubTopic.status=="NEW"){resumed=false;}else if(this.state.selectedSubTopic.status=="IN_PROGRESS"){resumed=true;}}else{source_test_id=this.state.selectedSubTopic.testId;if(this.state.selectedSubTopic.reqTestStatus=="NEW"){resumed=false;}else if(this.state.selectedSubTopic.reqTestStatus=="IN_PROGRESS"){resumed=true;}}var trackObj={"subtopic_id":topicsubtopicId,"test_id":topicInfoObj.testDetails.id,"source_test_id":source_test_id,"resumed":resumed};this.initiateTrack("test_started",trackObj);}},{key:'topicPointClick',value:function topicPointClick(event){var target=event.currentTarget;__WEBPACK_IMPORTED_MODULE_7_jquery___default()(".hometopmenu").removeClass("selected");__WEBPACK_IMPORTED_MODULE_7_jquery___default()(target).addClass("selected");if(__WEBPACK_IMPORTED_MODULE_7_jquery___default()(target).hasClass("allTopics")){this.setState({topicSubView:allTopicsView});}else if(__WEBPACK_IMPORTED_MODULE_7_jquery___default()(target).hasClass("pointssystem")){gradePointsMap.grades=gradePointsMap.grades.reverse();//console.log(gradePointsMap.grades);		
this.setState({topicSubView:pointsSystemView});}}},{key:'custsubscribeFn',value:function custsubscribeFn(dataga){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pointssystem hometopmenu float-right sub-mb-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'SubscribeButton',className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'btn btn-primary largeBtn subscribe_style subhome','data-ga':dataga||"Post login - Subscribe",onClick:function onClick(){window.location.href="/myproducts";}},'Subscribe')));}},{key:'closeTimer',value:function closeTimer(){//console.log("closeTimer", this.refs.TimerComp);
if(__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.refs.TimerComp)){if(typeof this.refs.TimerComp.stopTimer==="function"){this.refs.TimerComp.stopTimer();}}/*if(this.timerComp && typeof this.timerComp.stopTimer === "function"){
				this.timerComp.stopTimer();
			}*/this.setState({timerShow:false});}},{key:'pauseTimer',value:function pauseTimer(){if(__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.refs.TimerComp)){if(typeof this.refs.TimerComp.pauseTimer==="function"){this.refs.TimerComp.pauseTimer();}}/*	if(this.timerComp && typeof this.timerComp.pauseTimer === "function"){
				this.timerComp.pauseTimer();
			}*/this.setState({timerShow:true});}},{key:'resumeTimer',value:function resumeTimer(){if(__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.refs.TimerComp)){if(typeof this.refs.TimerComp.resumeTimer==="function"){this.refs.TimerComp.resumeTimer();}}/*if(this.timerComp && typeof this.timerComp.resumeTimer === "function"){
				this.timerComp.resumeTimer();
			}*/this.setState({timerShow:true});}},{key:'startTimer',value:function startTimer(){if(__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.refs.TimerComp)){if(typeof this.refs.TimerComp.startTimer==="function"){this.refs.TimerComp.startTimer();}}/*if(this.timerComp && typeof this.timerComp.startTimer === "function"){
				this.timerComp.startTimer();
			}*/this.setState({timerShow:true});}},{key:'autoSubmit',value:function autoSubmit(){if(this.getTestComponent&&typeof this.getTestComponent.submitClick==="function"){this.getTestComponent.submitClick(true);}}},{key:'renderTopics',value:function renderTopics(){var _this4=this;var me=this;if(this.state.view===topicView&&this.state.lessonOnlyMode&&!this.isLessonTabAvailable()){this.setState({view:desktopOnlyView});}//console.log("view:::",this.state.view);
if(this.state.view===desktopOnlyView){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__views_warning_DesktopOnly__["a" /* default */],null);}else if(this.state.view===loadingView){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center loadingAnim'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_loader_spinner___default.a,{type:'Oval',color:'#00BFFF',height:'100',width:'100'}));}else if(this.state.view===messageView){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'messageView text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.state.message));}else if(this.state.view===topicView){var topics=this.state.topics;var topicLength=topics.length;var classId=this.selectedGradeOption.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,function(){console.log("this.state.topicSubView=="+_this4.state.topicSubView);if(_this4.state.topicSubView==pointsSystemView){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'pointsContainer',className:'homeTopicContainer mainScrollContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pointsheadertxt'},_this4.rb("points.ptest")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this4.rb("points.testmsg")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pointsTable testtable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Table"],{className:'table noleftpadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Tbody"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'dark'},_this4.rb("points.hardquestions")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'medium'},gradePointsMap.points.hard[1])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'dark'},_this4.rb("points.mediumquestions")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'medium'},gradePointsMap.points.medium[1])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'dark'},_this4.rb("points.easyquestions")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'medium'},gradePointsMap.points.easy[1])))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pointsheadertxt'},_this4.rb("points.cpractice")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pointsTable practicetable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Table"],{className:'table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Thead"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'dark'},_this4.rb("points.answeredrightly")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'dark'},_this4.rb("points.hardquestion")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'dark'},_this4.rb("points.mediumquestion")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'dark'},_this4.rb("points.easyquestion")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Tbody"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'dark'},_this4.rb("points.1attempt")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'medium'},gradePointsMap.points.hard[1]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'medium'},gradePointsMap.points.medium[1]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'medium'},gradePointsMap.points.easy[1])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'dark'},_this4.rb("points.2attempt")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'medium'},gradePointsMap.points.hard[2]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'medium'},gradePointsMap.points.medium[2]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'medium'},gradePointsMap.points.easy[2])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'dark'},_this4.rb("points.3attempt")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'medium'},gradePointsMap.points.hard[3]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'medium'},gradePointsMap.points.medium[3]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:'medium'},gradePointsMap.points.easy[3])))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pointsheader2txt'},_this4.rb("points.gradingsystem")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pointsheadertxt'},_this4.rb("points.forasubtopic")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Percentage = (Points scored/ Total no.of points in that sub-topic)*100'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pointsheadertxt mt-10'},_this4.rb("points.foratopic")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Percentage = (Total points scored in all subtopics (in that topic)/ Total no.of points of all sub-topics (in that topic))*100'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pointsTable gradetable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Table"],{className:'table'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Thead"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Th"],{className:'dark'},_this4.rb("points.percentagerange")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Th"],{className:'dark'},_this4.rb("points.grade")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Tbody"],null,gradePointsMap.grades.map(function(grades,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Tr"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:"green "+grades.grade.toLowerCase().split("+").join("plus")},grades.minPercent,'% - ',grades.maxPercent,'%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_super_responsive_table__["Td"],{className:"green "+grades.grade.toLowerCase().split("+").join("plus")},grades.grade));}))))));}else{var selectedGradeLabel="";try{selectedGradeLabel=_this4.selectedGradeOption.label.split(" ").join("").toLowerCase();}catch(e){}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'topicContainer',className:'homeTopicContainer mainScrollContent'},topics.map(function(topic,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ms_topiccomponent__["a" /* default */],{topic:topic,callbackParent:_this4.onTopicChangedEvent,key:index,dataIndex:index,lessonOnlyMode:_this4.state.lessonOnlyMode,selectedGradeLabel:selectedGradeLabel,gradeName:_this4.selectedGradeOption.label});}));}}());}else if(this.state.view===subTopicView){var subtopics=this.state.subtopics;var subLength=subtopics.length;var accessId=0;var accessId=!isNaN(this.selectedProductOption.value)?this.selectedProductOption.value:accessId;var classId=this.selectedGradeOption.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'float-right'},function(){if(!me.state.purchased){return _this4.custsubscribeFn(_this4.state.lessonOnlyMode?"Post login - Class "+classId+" - Lessons - "+_this4.state.selectedTopic.topicName+" - Subscribe":"Post login - Class "+classId+" - Tests - "+_this4.state.selectedTopic.topicName+" - Subscribe");}}()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'breadcrumb-holder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'breadcrumb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'breadcrumb-item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0);',onClick:this.showAllTopics},this.rb("landing.alltopics_small"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'breadcrumb-item active'},this.state.selectedTopic.topicName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'topicContainer',className:'homeTopicContainer mainScrollContent'},subtopics.map(function(subtopic,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ms_subtopiccomponent__["a" /* default */],{key:index,subtopic:subtopic,accessId:accessId,classId:classId,showSubscribe:_this4.showSubscribemodal,callbackParent:_this4.onSubTopicChangedEvent,lessonOnlyMode:_this4.state.lessonOnlyMode,subTopicBoxColor:_this4.state.subTopicBoxColor,gradeName:_this4.selectedGradeOption.label,topicName:_this4.state.selectedTopic.topicName});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__views_plp_TestTakingModalComponent__["a" /* default */],{visible:this.state.modalShow,dialogClassName:this.setModalClass(),onClickBackdrop:this.setModalBackdropClose()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-header bg-purple'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-title'},this.state.modalTitle),function(){if(_this4.state.timerShow){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__TimerComp__["a" /* default */],{onShow:true,ref:'TimerComp',autoSubmit:_this4.autoSubmit,starttime:_this4.starttime-_this4.topicInfoObj.userTest.elapsedTime,testDetails:_this4.topicInfoObj.testDetails,elapsedTime:_this4.topicInfoObj.userTest.elapsedTime,callbackParent:_this4.updateelapsedTime});}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close',onClick:this.hideModal,'aria-label':'Close','data-ga':"Post login - "+this.selectedGradeOption.label+" - "+this.getProductIndication()+" - "+this.state.selectedTopic.topicName+" - "+this.state.selectedSubTopic.subTopicName+" - "+this.getTestTypeLbl()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'aria-hidden':'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'close')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-body testModalBody'},this.loadModalContent()))),this.rendershowSubscribe("Post login - "+this.selectedGradeOption.label+" - "+this.getProductIndication()+" - "+this.state.selectedTopic.topicName+" - Subscribe"));}else if(this.state.productExpired==true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'messageView expiredView text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'expiredlock'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'lock')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.rb("access.expiredmsg1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Go to ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'r-btn myheymathbtn goprod-btn',onClick:this.goToLanding},'Products'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'to subscribe')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_16_react_html_parser___default()(this.rb("access.expiredmsg3"))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Nothing'));}}},{key:'showProductpage',value:function showProductpage(){window.location.href='/products';}},{key:'goToLanding',value:function goToLanding(){window.location.href='/mysubscriptions';}},{key:'getTestTypeLbl',value:function getTestTypeLbl(){if(this.TestTypeLbl==""){return"Close";}else{return this.TestTypeLbl+" - Close";}}},{key:'getProductIndication',value:function getProductIndication(){if(this.state.modalView=="lessonInfo"){return"Lessons";}else{return"Tests";}}},{key:'render',value:function render(){if(this.comboNamesLoaded){return _get(ms_Home.prototype.__proto__||Object.getPrototypeOf(ms_Home.prototype),'render',this).call(this,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'HomeComponent mt-40'},this.renderTopics()));}else if(this.state.noProducts){return _get(ms_Home.prototype.__proto__||Object.getPrototypeOf(ms_Home.prototype),'render',this).call(this,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'messageView expiredView text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'expiredlock'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{'class':'material-icons'},'lock')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.rb("register.noproducts.msg")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.rb("register.noproducts.msg2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_16_react_html_parser___default()(this.rb("register.noproducts.msg3")))));}else{return _get(ms_Home.prototype.__proto__||Object.getPrototypeOf(ms_Home.prototype),'render',this).call(this);}}}]);return ms_Home;}(__WEBPACK_IMPORTED_MODULE_2__views_common_Landing__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ms_Home);

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_plp_TopicComponent__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_ComponentRegistry_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_icons_tick_icon_white_png__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_icons_tick_icon_white_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_icons_tick_icon_white_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ms_TopicComponent=function(_TopicComponent){_inherits(ms_TopicComponent,_TopicComponent);function ms_TopicComponent(props){_classCallCheck(this,ms_TopicComponent);var _this=_possibleConstructorReturn(this,(ms_TopicComponent.__proto__||Object.getPrototypeOf(ms_TopicComponent)).call(this,props));_this.clickTopic=_this.clickTopic.bind(_this);return _this;}_createClass(ms_TopicComponent,[{key:'clickTopic',value:function clickTopic(){var me=this;if(me.props.topic.topicLocked===false){return me.onTopicStart();}}},{key:'getTopicBottomSection',value:function getTopicBottomSection(){var _this2=this;var me=this;var lessonLocked=me.props.topic.topicLocked||false;var showCursor='lockcursor';if(!lessonLocked){showCursor="showcursor";}if(this.props.lessonOnlyMode==true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body card-bottom text-center lessononlytopic'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"card-link tileLink "+showCursor,onClick:this.clickTopic,'data-ga':"Post login - "+this.props.gradeName+" - Lessons - "+this.props.topic.topicName+" - "+this.getLesssonsActionLabel()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,function(){if(me.props.topic.topicLocked===true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'lock');}switch(me.props.topic.status){case"COMPLETED":return _this2.rb("lesson.watched");case"IN_PROGRESS":return _this2.rb("home.resume");default:return _this2.rb("home.start");}}())));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body card-bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"card-link tileLink "+showCursor,onClick:this.clickTopic,'data-ga':"Post login - "+this.props.gradeName+" - Tests - "+this.props.topic.topicName+" - "+this.getTestsActionLabel()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,function(){if(me.props.topic.topicLocked===true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons'},'lock');}switch(me.props.topic.status){case"COMPLETED":return _this2.rb("home.completed");case"IN_PROGRESS":return _this2.rb("home.resume");default:return _this2.rb("home.start");}}())));}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'mstopicomp',className:"card "+this.props.selectedGradeLabel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-img-top topic text-center',style:{backgroundColor:this.state.boxColor}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-img-overlay'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-title topic-title'},this.props.topic.topicName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body descBody'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'card-text'},this.props.topic.topicDescription)),this.getTopicBottomSection());}}]);return ms_TopicComponent;}(__WEBPACK_IMPORTED_MODULE_1__views_plp_TopicComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ms_TopicComponent);__WEBPACK_IMPORTED_MODULE_2__model_ComponentRegistry_js__["a" /* default */].register("ms_TopicComponent",ms_TopicComponent);/*
* Also registering for the users with hm_ prefix
*/__WEBPACK_IMPORTED_MODULE_2__model_ComponentRegistry_js__["a" /* default */].register("hm_TopicComponent",ms_TopicComponent);

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_plp_SubTopicComponent__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_ComponentRegistry_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_icons_report_proficiency_png__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_icons_report_proficiency_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_icons_report_proficiency_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_report_practice_png__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_report_practice_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_icons_report_practice_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_icons_emojis_rating_default_png__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_icons_emojis_rating_default_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_icons_emojis_rating_default_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_icons_emojis_bad_gif__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_icons_emojis_bad_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_icons_emojis_bad_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_icons_emojis_good_gif__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_icons_emojis_good_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_icons_emojis_good_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_icons_emojis_loveit_gif__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_icons_emojis_loveit_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_icons_emojis_loveit_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_icons_emojis_normal_gif__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_icons_emojis_normal_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_icons_emojis_normal_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_icons_emojis_verybad_gif__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_icons_emojis_verybad_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_icons_emojis_verybad_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_emojis_bad_small_png__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_emojis_bad_small_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_icons_emojis_bad_small_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_icons_emojis_good_small_png__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_icons_emojis_good_small_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_icons_emojis_good_small_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_icons_emojis_loveit_small_png__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_icons_emojis_loveit_small_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_icons_emojis_loveit_small_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_icons_emojis_normal_small_png__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_icons_emojis_normal_small_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_icons_emojis_normal_small_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_icons_emojis_verybad_small_png__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_icons_emojis_verybad_small_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__images_icons_emojis_verybad_small_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ms_SubTopicComponent=function(_SubTopicComponent){_inherits(ms_SubTopicComponent,_SubTopicComponent);function ms_SubTopicComponent(){_classCallCheck(this,ms_SubTopicComponent);return _possibleConstructorReturn(this,(ms_SubTopicComponent.__proto__||Object.getPrototypeOf(ms_SubTopicComponent)).apply(this,arguments));}_createClass(ms_SubTopicComponent,[{key:'getSubTopicBodyContent',value:function getSubTopicBodyContent(){if(this.props.lessonOnlyMode==false&&window.topic_name_in_subtopic_tile_by_schoolprefix&&~window.topic_name_in_subtopic_tile_by_schoolprefix.indexOf(this.getUser().getSchoolPrefix())){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body info subtopicbody'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'card-title'},this.props.topicName));}}},{key:'getBottomItems',value:function getBottomItems(){var _this2=this;if(this.props.lessonOnlyMode==true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row clearfix bottomSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 card-bottom text-center nosidepadding showcursor',onClick:this.onSubTopicStartLessons,'data-ga':"Post login - "+this.props.gradeName+" - Lessons - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - "+this.getLesssonsActionLabel()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'card-link tileLink'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,function(){if(_this2.subtopic.status=="COMPLETED"){return _this2.rb("lesson.watched");}else if(_this2.subtopic.status=="IN_PROGRESS"){return _this2.rb("home.resume");}else{return _this2.rb("home.start");}}()))));}else{var completedTestRoute="/report";var completedPracRoute="/report";if(this.subtopic&&this.subtopic.testType&&this.subtopic.testType!==5&&this.subtopic.testType!==6){completedTestRoute="/scorecard/"+this.props.subtopic.testId;completedPracRoute="/scorecard/"+this.props.subtopic.recommendtestid;}if(this.subtopic.status=="IN_PROGRESS"){if(this.subtopic.reqTestStatus!="COMPLETED"&&this.subtopic.testStatus=="COMPLETED"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row clearfix bottomSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'col-6 card-bottom text-center borderRight nosidepadding notoppadding showcursor',href:completedTestRoute,'data-ga':"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - PT - Report"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-link tileLink review-cont'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'completed-stat-review'},this.rb("report-nav-text")))),this.lockcontent(this.props.subtopic.practiceLocked));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row clearfix bottomSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 card-bottom text-center nosidepadding showcursor',onClick:this.onSubTopicStartPT,'data-ga':"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - PT - "+this.getStatusActionText()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-link tileLink'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,this.getStatusActionText()))));}}else if(this.subtopic.status=="COMPLETED"){if(this.props.subtopic.recommendtestid!=0&&this.props.subtopic.recommendtestid!="0"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row clearfix bottomSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'col-6 card-bottom text-center borderRight nosidepadding notoppadding showcursor',href:completedTestRoute,'data-ga':"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - PT - Report"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-link tileLink review-cont'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'completed-stat-review'},this.rb("report-nav-text")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'col-6 card-bottom text-center nosidepadding notoppadding showcursor',href:completedPracRoute,'data-ga':"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - CP - Report"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-link tileLink review-cont'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'completed-stat-review'},this.rb("report-nav-text")))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row clearfix bottomSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'col-12 card-bottom text-center borderRight nosidepadding notoppadding showcursor',href:completedTestRoute,'data-ga':"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - PT - Report"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-link tileLink review-cont'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'completed-stat-review'},this.rb("report-nav-text")))));}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row clearfix bottomSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 card-bottom text-center nosidepadding showcursor',onClick:this.onSubTopicStartPT,'data-ga':"Post login - "+this.props.gradeName+" - Tests - "+this.props.topicName+" - "+this.props.subtopic.subTopicName+" - PT - "+this.getStatusActionText()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'card-link tileLink'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,this.getStatusActionText()))));}}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card subTopic clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-img-top subtopic text-center',style:{backgroundColor:this.props.subTopicBoxColor}},this.getBGImg()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-img-overlay'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-title'},this.props.subtopic.subTopicName)),this.getSubTopicBodyContent(),this.getBottomItems());}}]);return ms_SubTopicComponent;}(__WEBPACK_IMPORTED_MODULE_1__views_plp_SubTopicComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (ms_SubTopicComponent);

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_core_LoggedInPage__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TimerComp=function(_LoggedInPage){_inherits(TimerComp,_LoggedInPage);function TimerComp(props){_classCallCheck(this,TimerComp);var _this=_possibleConstructorReturn(this,(TimerComp.__proto__||Object.getPrototypeOf(TimerComp)).call(this,props));_this.state={time:{},seconds:3600,timerStarted:false};_this.timer=0;_this.countDown=_this.countDown.bind(_this);_this.getTimerStatus=_this.getTimerStatus.bind(_this);_this.storeTimerStatus=_this.storeTimerStatus.bind(_this);_this.autoSubmit=_this.autoSubmit.bind(_this);_this.storetimerinterval=0;_this.timercnt=0;_this.startTimer=_this.startTimer.bind(_this);_this.stopTimer=_this.stopTimer.bind(_this);_this.resumeTimer=_this.resumeTimer.bind(_this);_this.pauseTimer=_this.pauseTimer.bind(_this);_this.timerActive=false;return _this;}_createClass(TimerComp,[{key:'secondsToTime',value:function secondsToTime(secs){var hours=Math.floor(secs/(60*60));var divisor_for_minutes=secs%(60*60);var minutes=Math.floor(divisor_for_minutes/60);var divisor_for_seconds=divisor_for_minutes%60;var seconds=Math.ceil(divisor_for_seconds);hours=("00"+hours).substr(-2);minutes=("00"+minutes).substr(-2);seconds=("00"+seconds).substr(-2);var obj={"hours":hours,"minutes":minutes,"seconds":seconds};return obj;}},{key:'componentDidMount',value:function componentDidMount(){var me=this;/* if(this.props.onShow){
      this.getTimerStatus();
    }*/}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.props.onShow){this.stopTimer();}}},{key:'getTimerStatus',value:function getTimerStatus(){//let timeLeftSec = me.secondsToTime(me.state.seconds);
this.setState({seconds:this.props.starttime});this.startTimer();}},{key:'autoSubmit',value:function autoSubmit(){//Enter all the autosubmit pertaining to timer here
//Reference function to Submission via GetTest.js
if(typeof this.props.autoSubmit==="function"){this.props.autoSubmit();}}},{key:'storeTimerStatus',value:function storeTimerStatus(){var me=this;var timerVal=me.props.elapsedTime+me.timercnt;var postParams={"testId":this.props.testDetails.id,"time":window.btoa(timerVal),"revisionTestId":this.props.testDetails.revisionTestId,"topicSubtopicMapId":this.props.testDetails.topicSubTopicMapId};var callBackSuccess=function callBackSuccess(response){me.props.callbackParent(timerVal);console.log("Timer is Saved");};var callBackFailure=function callBackFailure(error){console.log("Error in store Timer");};new __WEBPACK_IMPORTED_MODULE_1__util_HmAjax__["a" /* default */](this.getUrlFor("STORE_TIMER"),postParams).put(callBackSuccess,callBackFailure);}},{key:'startTimer',value:function startTimer(){if(!this.state.timerStarted){this.timerActive=true;this.stopTimer();this.setState({timerStarted:true});if(this.timer==0&&this.state.seconds>0){this.timer=setInterval(this.countDown,1000);}}else{console.warn("Timer already started do not restart");}}},{key:'stopTimer',value:function stopTimer(){try{clearInterval(this.timer);}catch(e){}this.setState({timerStarted:false});}},{key:'resumeTimer',value:function resumeTimer(){if(!this.state.timerStarted){this.getTimerStatus();}this.timerActive=true;}},{key:'pauseTimer',value:function pauseTimer(){this.timerActive=false;}},{key:'countDown',value:function countDown(){if(this.timerActive){// Remove one second, set state so a re-render happens.
var seconds=this.state.seconds-1;this.timercnt++;this.storetimerinterval++;this.setState({time:this.secondsToTime(seconds),seconds:seconds});if(this.storetimerinterval==5){this.storeTimerStatus();this.storetimerinterval=0;}if(this.props.starttime-this.timercnt<=15){if(!__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".countdown-timer").hasClass("blink")){__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".countdown-timer").addClass("blink");}}if(this.props.starttime-this.timercnt==0){if(__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".countdown-timer").hasClass("blink")){__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".countdown-timer").removeClass("blink");}this.autoSubmit();}// Check if we're at zero.
if(seconds==0){this.stopTimer();}}}},{key:'renderTimer',value:function renderTimer(){var me=this;if(me.state.timerStarted&&me.state.time.seconds!=undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Time left : \xA0',me.state.time.hours,' : ',me.state.time.minutes,' : ',me.state.time.seconds,' ');}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'countdown-timer'},this.renderTimer());}}]);return TimerComp;}(__WEBPACK_IMPORTED_MODULE_2__views_core_LoggedInPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (TimerComp);

/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prelogin_src_PreloginHome__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_burger_menu__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_burger_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_burger_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_BrowserUtil__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_UserStorageUtil__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_AppConstants_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__prelogin_src_components_ScrollToTopOnMount_js__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sg_Banner_js__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__prelogin_src_components_RecognisedStatic__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__prelogin_src_components_LessonFeatures_js__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__prelogin_src_components_OurTeachers__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__prelogin_src_components_StaticFeed__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__sg_SignupSection_js__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__sg_UnifiedForgotPwd__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__sg_Footer__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__sg_UnifiedLogin__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__sg_SignupForm__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__model_ComponentRegistry_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_plp_Home__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_dashboard_Dashboard__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_scorecard_Scorecard__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__prelogin_src_components_PageBanner_js__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__prelogin_src_components_FlipSection_js__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__prelogin_src_components_OtherLearnings_js__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__prelogin_src_components_EndorsedStatic__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__prelogin_src_components_NrichCollaboration__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__prelogin_src_components_WhoBanner2_js__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__prelogin_src_components_DayInLife_js__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__prelogin_src_components_Culture_js__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__prelogin_src_components_Founders_js__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__prelogin_src_components_OurTeam_js__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__prelogin_src_components_FounderVideos_js__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__prelogin_src_components_Recognised_js__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_others_TopBanner__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__prelogin_src_components_OverallFeatures__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_others_SGProductCatalogue__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__prelogin_src_components_FAQ__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__views_purchase_BillingDetails__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__views_purchase_MyProducts__ = __webpack_require__(457);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var sg_PreloginHome=function(_PreloginHome){_inherits(sg_PreloginHome,_PreloginHome);function sg_PreloginHome(props){_classCallCheck(this,sg_PreloginHome);var _this=_possibleConstructorReturn(this,(sg_PreloginHome.__proto__||Object.getPrototypeOf(sg_PreloginHome)).call(this,props));_this.Home=function(){if(!_this.tracked){_this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"home-PageView"});_this.tracked=true;}try{if(_this.state.LumosloggedIn){window.location.href=_this.getUrlFor("LUMOS_REDIRECT_URL");}else if(_this.state.PLPloggedIn&&!window.location.href.match("/home")){window.location.href="/landing";}}catch(e){}_this.selectedMenu="menuhome";var me=_this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,me.setTitle("HOME_title"),me.setMeta("HOME_meta"),me.setHeading("HOME_heading"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'bannerElement'},_this.getBannerContent()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__prelogin_src_components_ScrollToTopOnMount_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__sg_Banner_js__["a" /* default */],{products_category_order:_this.getProductsTypeOrder(),products_category:_this.getProductsType(),classes:_this.getClasses(),grades:_this.getGrades(),products_class:_this.getProductsClass(),PLPloggedIn:_this.state.PLPloggedIn,startFreeTrial:_this.startFreeTrial,showSignUp:_this.showSignUp,showNewLoginForm:_this.showNewLoginForm}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__prelogin_src_components_RecognisedStatic__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__prelogin_src_components_LessonFeatures_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__prelogin_src_components_OurTeachers__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__prelogin_src_components_StaticFeed__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__sg_SignupSection_js__["a" /* default */],{PLPloggedIn:_this.state.PLPloggedIn,startFreeTrial:_this.startFreeTrial,showSignUp:_this.showSignUp,showNewLoginForm:_this.showNewLoginForm}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__sg_Footer__["a" /* default */],{showContactus:_this.showContactus,products_category_order:_this.getProductsTypeOrder(),products_category:_this.getProductsType(),classes:_this.getClasses(),grades:_this.getGrades(),products_class:_this.getProductsClass()}),_this.fireMobileToast());};_this.renderLoginView=function(){if(_this.state.loggedIn==true){//console.warn("this.UserStore ",this.UserStore);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inlineblock'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inlineblock navbar-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'nav-item dropdown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-link dropdown-toggle',href:'#',id:'navbardrop','data-toggle':'dropdown'},_this.state.imageLoaded?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'material-icons md-60  usericon imgprv',src:_this.state.imagePreviewUrl}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons md-40 useraccountelement'},'account_circle')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dropdown-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:"dropdown-item",href:'/myproducts','data-ga':'Home - My Subscriptions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons pr-16'},'credit_card'),' My Subscriptions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'dropdown-item',href:'/settings'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons pr-16'},'account_circle'),' My Profile'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'dropdown-item',href:'#',onClick:function onClick(){_this.onLogout();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons pr-16'},'power_settings_new'),' Sign out')))));}};_this.Learnings=function(){_this.setTitle("LEARNINGS_title");__WEBPACK_IMPORTED_MODULE_23__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA");__WEBPACK_IMPORTED_MODULE_23__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");_this.selectedMenu="menuourlearnings";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__prelogin_src_components_ScrollToTopOnMount_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__prelogin_src_components_PageBanner_js__["a" /* default */],{classes:'bg-grn bg-blue banner-text',text:_this.rb("our_learnings_heading")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__prelogin_src_components_FlipSection_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__prelogin_src_components_OtherLearnings_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__sg_Footer__["a" /* default */],{showContactus:_this.showContactus,products_category_order:_this.getProductsTypeOrder(),products_category:_this.getProductsType(),classes:_this.getClasses(),grades:_this.getGrades(),products_class:_this.getProductsClass()}));};_this.WhoWeAre=function(){__WEBPACK_IMPORTED_MODULE_23__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA");__WEBPACK_IMPORTED_MODULE_23__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");_this.selectedMenu="menuwhoweare";var me=_this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,me.setTitle("WHO_WE_ARE_title"),me.setMeta("WHO_WE_ARE_meta"),me.setHeading("WHO_WE_ARE_heading"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__prelogin_src_components_ScrollToTopOnMount_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__prelogin_src_components_WhoBanner2_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__prelogin_src_components_DayInLife_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__prelogin_src_components_Culture_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__prelogin_src_components_Founders_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__prelogin_src_components_OurTeam_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__prelogin_src_components_FounderVideos_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__prelogin_src_components_Recognised_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__sg_Footer__["a" /* default */],{showContactus:_this.showContactus,products_category_order:_this.getProductsTypeOrder(),products_category:_this.getProductsType(),classes:_this.getClasses(),grades:_this.getGrades(),products_class:_this.getProductsClass()}));};_this.SGCatalogue=function(_ref){var match=_ref.match;__WEBPACK_IMPORTED_MODULE_23__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA");__WEBPACK_IMPORTED_MODULE_23__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");_this.selectedMenu="sgproducts";if(!_this.tracked){_this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"teacherpage"});_this.tracked=true;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__prelogin_src_components_ScrollToTopOnMount_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__views_others_TopBanner__["a" /* default */],{name:'CBSE Exam Prep',showContactus:_this.showContactusForTeacher,triedFree:_this.state.triedFree,purchased:_this.state.purchased,classes:'bg-grn bg-yellowbg banner-text',text:'To achieve your best in the board exams',id:''+match.params.id,showSubScripeLoginForm:_this.showSubScripeLoginForm,productBase:'cbse',simpleform:'true'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__prelogin_src_components_OverallFeatures__["a" /* default */],{name:'PLP'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__views_others_SGProductCatalogue__["a" /* default */],{showSubscriptionForm:_this.showSubscriptionForm,postLoginCallBack:_this.postLoginCallBack}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__prelogin_src_components_EndorsedStatic__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__prelogin_src_components_NrichCollaboration__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__sg_Footer__["a" /* default */],{showContactus:_this.showContactus,products_category_order:_this.getProductsTypeOrder(),products_category:_this.getProductsType(),classes:_this.getClasses(),grades:_this.getGrades(),products_class:_this.getProductsClass()}));};_this.Faq=function(){__WEBPACK_IMPORTED_MODULE_23__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA");__WEBPACK_IMPORTED_MODULE_23__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");//this.selectedMenu = "menufaq";
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__prelogin_src_components_FAQ__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__sg_Footer__["a" /* default */],{showContactus:_this.showContactus,products_category_order:_this.getProductsTypeOrder(),products_category:_this.getProductsType(),classes:_this.getClasses(),grades:_this.getGrades(),products_class:_this.getProductsClass()}));};_this.GetProductDetails=function(_ref2){var match=_ref2.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'heyPrelolgin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__views_purchase_BillingDetails__["a" /* default */],{myProps:_this.props,purchaseKey:_this.state.purchaseKey}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__sg_Footer__["a" /* default */],{showContactus:_this.showContactus,products_category_order:_this.getProductsTypeOrder(),products_category:_this.getProductsType(),classes:_this.getClasses(),grades:_this.getGrades(),products_class:_this.getProductsClass()}));};_this.GetMyProducts=function(_ref3){var match=_ref3.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'heyPrelolgin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41__views_purchase_MyProducts__["a" /* default */],{myProps:_this.props,PLPloggedIn:_this.state.PLPloggedIn,purchaseKey:_this.state.purchaseKey,showSubScripeLoginForm:_this.showSubScripeLoginForm}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__sg_Footer__["a" /* default */],{showContactus:_this.showContactus,products_category_order:_this.getProductsTypeOrder(),products_category:_this.getProductsType(),classes:_this.getClasses(),grades:_this.getGrades(),products_class:_this.getProductsClass()}));};_this.showHideLeftMenu=_this.showHideLeftMenu.bind(_this);_this.getHeaderLogo=_this.getHeaderLogo.bind(_this);return _this;}_createClass(sg_PreloginHome,[{key:'componentWillMount',value:function componentWillMount(){_get(sg_PreloginHome.prototype.__proto__||Object.getPrototypeOf(sg_PreloginHome.prototype),'componentWillMount',this).call(this);}},{key:'componentDidMount',value:function componentDidMount(){//console.warn("PreloginHome SG");
_get(sg_PreloginHome.prototype.__proto__||Object.getPrototypeOf(sg_PreloginHome.prototype),'componentDidMount',this).call(this);this.setFavIco();try{var isCollapsed=this.getAttribute("sidebar_collapsed")==="true";//UserStorageUtil.getStoredSessionItem("sidebar_collapsed") ||
__WEBPACK_IMPORTED_MODULE_7__model_AppConstants_js__["a" /* default */].collapsed=isCollapsed||__WEBPACK_IMPORTED_MODULE_7__model_AppConstants_js__["a" /* default */].collapsed;if(__WEBPACK_IMPORTED_MODULE_7__model_AppConstants_js__["a" /* default */].collapsed===true){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.side-navbar').addClass('shrinked');__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.content-inner').addClass('active');__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').removeClass('active');__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').removeClass("goRight");__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-small').show();__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-big').hide();}}catch(e){console.error(e);}if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).outerWidth()>1183){if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').hasClass('active')){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').addClass("goRight");}else{__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').removeClass("goRight");}}if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).outerWidth()<1183){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').removeClass("goRight");}this.appendCSS("./vendors/sg_main.css");}/**
    * IMPORTANT: Please follow this way to use favIcon
    */},{key:'setFavIco',value:function setFavIco(){if(window.fav_ico_by_prefix&&window.fav_ico_by_prefix[this.getUser().getSchoolPrefix()]){if(document.getElementsByName("fav_ico").length>0){document.getElementsByName("fav_ico")[0].href=window.fav_ico_by_prefix[this.getUser().getSchoolPrefix()];}}}},{key:'toggleSideBar',value:function toggleSideBar(){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').toggleClass('active');__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.side-navbar').toggleClass('shrinked');__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.content-inner').toggleClass('active');if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).outerWidth()>1183){if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').hasClass('active')){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-small').hide();__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-big').show();__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').addClass("goRight");}else{__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-small').show();__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-big').hide();__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').removeClass("goRight");}}if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).outerWidth()<1183){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-small').show();__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').removeClass("goRight");}try{var isCollapsed=__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.side-navbar').hasClass('shrinked');if(typeof isCollapsed==="boolean"){this.setAttribute("sidebar_collapsed",isCollapsed.toString());}__WEBPACK_IMPORTED_MODULE_7__model_AppConstants_js__["a" /* default */].collapsed=__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.side-navbar').hasClass('shrinked');__WEBPACK_IMPORTED_MODULE_6__util_UserStorageUtil__["a" /* default */].storeSessionItem("sidebar_collapsed",__WEBPACK_IMPORTED_MODULE_7__model_AppConstants_js__["a" /* default */].collapsed);}catch(e){console.log(e);}try{var isCollapsed=this.getAttribute("sidebar_collapsed")==="true";console.log("isCollapsed::::",isCollapsed);//UserStorageUtil.getStoredSessionItem("sidebar_collapsed") ||
__WEBPACK_IMPORTED_MODULE_7__model_AppConstants_js__["a" /* default */].collapsed=isCollapsed||__WEBPACK_IMPORTED_MODULE_7__model_AppConstants_js__["a" /* default */].collapsed;if(__WEBPACK_IMPORTED_MODULE_7__model_AppConstants_js__["a" /* default */].collapsed===true){__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".page-content .content-inner").toggleClass("fullwidth");__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".page-content nav.side-navbar").toggle();__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".page-content nav.side-navbar").toggleClass('collapsed');}}catch(e){console.error(e);}}},{key:'getButtonName',value:function getButtonName(){//console.log("lumos login::::",this.state.LumosloggedIn);
if(this.state.loggedIn||this.state.LumosloggedIn||__WEBPACK_IMPORTED_MODULE_5__util_BrowserUtil__["a" /* default */].getAuthToken()&&__WEBPACK_IMPORTED_MODULE_5__util_BrowserUtil__["a" /* default */].getAuthToken().length>=5||__WEBPACK_IMPORTED_MODULE_5__util_BrowserUtil__["a" /* default */].getLumosToken()&&__WEBPACK_IMPORTED_MODULE_5__util_BrowserUtil__["a" /* default */].getLumosToken().length>=5){//return this.rb("menu.home");
return this.rb("btn.label.myheymath");}return this.rb("btn.label.signin");}},{key:'getHeaderLogo',/*
      * IMPORTANT: Hardcoded temporarily. Needs to be addressed post demo
      */value:function getHeaderLogo(){if(this.getUser().getSchoolPrefix()&&this.getUser().getSchoolPrefix().length>0){if(this.getUser().getSchoolPrefix().toLowerCase()==="ms_"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/img/mindstretcher/logo.png',alt:'Mind Stretcher logo'});}else{return _get(sg_PreloginHome.prototype.__proto__||Object.getPrototypeOf(sg_PreloginHome.prototype),'getHeaderLogo',this).call(this);}}else{return _get(sg_PreloginHome.prototype.__proto__||Object.getPrototypeOf(sg_PreloginHome.prototype),'getHeaderLogo',this).call(this);}}},{key:'getUnifiedLoginForm',value:function getUnifiedLoginForm(){var loginType=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var userid=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var errMsg=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__sg_UnifiedLogin__["a" /* default */],{myProps:this.props,loginType:loginType,userid:userid,callbackForgotPwd:this.showForgotPasswordForm,callbackCreateAccount:this.showCreateAccount,showSignUp:this.showSignUp,navigateURL:'/products',errMsg:errMsg})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)));}},{key:'getVerifyAccount',value:function getVerifyAccount(){var loginType=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var userInput=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var navigateurl=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var freetrail=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;if(navigateurl==null){navigateurl='/products';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__sg_SignupForm__["a" /* default */],{signupUser:'student',myProps:this.props,loginType:loginType,'data-ga':this.modalcloseDataGA,userInput:userInput,successRegisterMsg:this.showsuccessRegisterMsg,navigateURL:navigateurl,freetrail:freetrail,gaFrom:this.gaFrom});}},{key:'getForgotPassword',value:function getForgotPassword(source){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__sg_UnifiedForgotPwd__["a" /* default */],{myProps:this.props,pwdIframeView:this.pwdIframeView,source:source,successForgotPwd:this.showSuccessForgotPwdMessage,showNewLoginForm:this.showNewLoginForm}))));}},{key:'getUnifiedLoginFormWithoutNav',value:function getUnifiedLoginFormWithoutNav(){var loginType=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var userid=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var errMsg=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var navUrl=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;var callBack=arguments.length>4&&arguments[4]!==undefined?arguments[4]:null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__sg_UnifiedLogin__["a" /* default */],{myProps:this.props,loginType:loginType,userid:userid,callBack:callBack,callbackForgotPwd:this.showForgotPasswordForm,callbackCreateAccount:this.showCreateAccount,showSignUp:this.showSignUp,navigateURL:navUrl,errMsg:errMsg})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)));}},{key:'postLoginTchr',value:function postLoginTchr(userObj){var me=this;if(!userObj){userObj=this.getUser().get();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'textAlignLeft'},this.sgProductTab());//    if(userObj && userObj.userRole && userObj.userRole.role && userObj.userRole.role.toUpperCase() === "TCHR") {
//       return (
//         <ul className="textAlignLeft">
//           <li data-ga="Teachers - Main Tab" ><Link className="heyMenu menuteachers" data-classname="menuteachers" to="/teachers" onClick={this.menuSelected}>Teachers</Link></li>
//         </ul> 
//       );
//     }else{ 
//       return (
//         <ul className="textAlignLeft">
//           { this.sgProductTab() }
//         </ul>
//       );
//     }
}},{key:'postLoginTchrTab',value:function postLoginTchrTab(userObj){var me=this;if(!userObj){userObj=this.getUser().get();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'textAlignLeft'},this.sgProductTab());//    if(userObj && userObj.userRole && userObj.userRole.role && userObj.userRole.role.toUpperCase() === "TCHR") {
//       return (
//         <ul className="textAlignLeft">
//           <li data-ga="Teachers - Main Tab" ><Link className="heyMenu menuteachers" data-classname="menuteachers" to="/teachers" onClick={this.menuSelected}>Teachers</Link></li>
//         </ul> 
//       );
//     }else{ 
//       return (
//         <ul className="textAlignLeft">
//           { this.sgProductTab() }
//         </ul>
//       );
//     }
}},{key:'getSingleLoginForm',value:function getSingleLoginForm(event){var loginSource=event.currentTarget.dataset.source||'';if(loginSource==""||loginSource=="lumos"||loginSource=="plp"){this.modalcloseDataGA="Home - Users who have independently registered - Close";this.setState({"ModalShow":true,"ModalContent":this.getUnifiedLoginForm(),"ModalHeader":"logo",customClass:"newloginDialog"});}else if(loginSource=="register"){this.modalcloseDataGA="Home - Sign in - Users who want to register - Close";this.setState({"ModalShow":true,"ModalContent":this.getVerifyAccount(),"ModalHeader":this.rb("login.createnewaccount"),customClass:"newloginDialog"});}}},{key:'getSwitcher',value:function getSwitcher(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Redirect */],{from:'/',exact:true,to:'/sg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{exact:true,path:'/sg',component:this.Home,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{exact:true,path:'/home',component:this.Home,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/landing',exact:true,component:__WEBPACK_IMPORTED_MODULE_20__views_plp_Home__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/dashboard',exact:true,component:__WEBPACK_IMPORTED_MODULE_21__views_dashboard_Dashboard__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/settings',exact:true,component:this.GetMyProfile}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/scorecard/:id/:reset?',exact:true,component:__WEBPACK_IMPORTED_MODULE_22__views_scorecard_Scorecard__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/our-learnings',component:this.Learnings,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/who-we-are',component:this.WhoWeAre,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/blog',component:this.Blog,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/spotlight',component:this.Spotlight,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/faq',component:this.Faq,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{exact:true,path:'/product-details',component:this.GetProductDetails,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Redirect */],{from:'/products',exact:true,to:this.getGeo()+"/products"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/in/products',component:this.newINCatalogue,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{exact:true,path:'/sg/products',component:this.SGCatalogue,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Redirect */],{from:'/myproducts',to:'/mysubscriptions'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{path:'/mysubscriptions',exact:true,component:this.GetMyProducts,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{exact:true,path:'/404',component:this.Home}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Route */],{component:this.Home}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Redirect */],{from:'*',to:'/'}));}},{key:'getRouter',value:function getRouter(){var _this2=this;var me=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'nav-desktop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid norightpadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuhome','data-classname':'menuhome',to:'/home',onClick:me.setPreloginClass},this.getHeaderLogo())),function(){if(me.state.LumosloggedIn){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'textAlignLeft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null));}else if(me.state.loggedIn||me.state.PLPloggedIn){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,function(){if(me.isHeaderMenuAllowed("products")){return me.postLoginTchr();}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'textAlignLeft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null));}}());}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'Home Tab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuhome','data-classname':'menuhome',to:'/',onClick:me.menuSelected},'Home')),me.sgProductTab(),function(){if(!window.teachers_tab_suppressed){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'Teachers - Main Tab'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuteachers','data-classname':'menuteachers',to:'/teachers',onClick:_this2.menuSelected},'Teachers'));}}(),me.aboutUsTab());}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-sec'},function(){if(me.isHeaderMenuAllowed("my_heymath")){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'My HeyMath Tab',className:"r-btn myheymathbtn mr-30 "+me.getMargin(),onClick:me.showLoginForm},me.getButtonName());}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'textAlignLeft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null));}}(),me.renderLoginView()))),function(){if(_this2.isHeaderMenuAllowed("hamburger")){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_burger_menu__["slide"],{right:true,onStateChange:function onStateChange(state){return me.handleStateChange(state);},isOpen:me.state.menuOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'menu-icon-wrapper',className:'menu-icon-wrapper'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'nav-mobile'},function(){if(me.state.loggedIn&&_this2.isHeaderMenuAllowed("hamburger")){return me.postLoginTchrTab();}else if(_this2.isHeaderMenuAllowed("hamburger")){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'Home Tab',className:'animated'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuhome','data-classname':'menuhome',to:'/',onClick:function onClick(){return _this2.menuSelected();}},'Home')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'SG Prducts - Main Tab',className:'animated'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menusgproducts','data-classname':'menusgproducts',to:'/sg/products',onClick:function onClick(){return _this2.menuSelected();}},_this2.rb("sg.products.title"))),function(){if(!window.teachers_tab_suppressed){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'Teachers - Main Tab',className:'animated'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuteachers','data-classname':'menuteachers',to:'/teachers',onClick:function onClick(){return _this2.menuSelected();}},'Teachers'));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'Our Learning - Main Tab',className:'animated'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuourlearnings','data-classname':'menuourlearnings',to:'/our-learnings',onClick:function onClick(){return _this2.menuSelected();}},'Our Learnings')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'Who we are - Main Tab',className:'animated'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuwhoweare','data-classname':'menuwhoweare',to:'/who-we-are',onClick:function onClick(){return _this2.menuSelected();}},'Who We Are')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'Spotlight - Main Tab',className:'animated'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{className:'heyMenu menuspotlight','data-classname':'menuspotlight',to:'/spotlight',onClick:function onClick(){return _this2.menuSelected();}},'Spotlight')));}}()));}else{return null;}}()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'}),me.getSwitcher()));}},{key:'showHideLeftMenu',value:function showHideLeftMenu(){//$(".page-content nav.side-navbar").toggle();
__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".page-content .content-inner").toggleClass("fullwidth");__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".page-content nav.side-navbar").toggle();__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".page-content nav.side-navbar").toggleClass('collapsed');try{var isCollapsed=__WEBPACK_IMPORTED_MODULE_1_jquery___default()('nav.side-navbar').hasClass('collapsed');if(typeof isCollapsed==="boolean"){this.setAttribute("sidebar_collapsed",isCollapsed.toString());}__WEBPACK_IMPORTED_MODULE_7__model_AppConstants_js__["a" /* default */].collapsed=__WEBPACK_IMPORTED_MODULE_1_jquery___default()('nav.side-navbar').hasClass('collapsed');__WEBPACK_IMPORTED_MODULE_6__util_UserStorageUtil__["a" /* default */].storeSessionItem("sidebar_collapsed",__WEBPACK_IMPORTED_MODULE_7__model_AppConstants_js__["a" /* default */].collapsed);}catch(e){//console.log(e);
}}},{key:'render',value:function render(){/*require('./ms_main.css');*/return _get(sg_PreloginHome.prototype.__proto__||Object.getPrototypeOf(sg_PreloginHome.prototype),'render',this).call(this,this.getRouter());}}]);return sg_PreloginHome;}(__WEBPACK_IMPORTED_MODULE_2__prelogin_src_PreloginHome__["a" /* default */]);/* unused harmony default export */ var _unused_webpack_default_export = (sg_PreloginHome);__WEBPACK_IMPORTED_MODULE_19__model_ComponentRegistry_js__["a" /* default */].register("sg_PreloginHome",sg_PreloginHome);/*
* Also registering for the users with hm_ prefix
*/__WEBPACK_IMPORTED_MODULE_19__model_ComponentRegistry_js__["a" /* default */].register("hm_preloginhome",sg_PreloginHome);/**
* IMPORTANT: Global Prelogin home for SG and other country users
*/__WEBPACK_IMPORTED_MODULE_19__model_ComponentRegistry_js__["a" /* default */].register("PreloginHome",sg_PreloginHome);

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__prelogin_src_components_Banner__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sg_UserLoginType__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__login_Whatsapp_js__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal_video__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal_video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_modal_video__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* This class is merely an extension of the previous banner
*
*/var sg_Banner=function(_Banner){_inherits(sg_Banner,_Banner);function sg_Banner(){_classCallCheck(this,sg_Banner);return _possibleConstructorReturn(this,(sg_Banner.__proto__||Object.getPrototypeOf(sg_Banner)).apply(this,arguments));}_createClass(sg_Banner,[{key:'homeforweb',value:function homeforweb(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slider-inner b-web-comp',style:{padding:'40px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 b-right',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/banner1.png',alt:'',onClick:this.openModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Home  - Hey Parent Video',className:'popup-modal',onClick:this.openModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'heading-one',style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt first-line',style:{fontSize:'32px'}},this.rb("banner.heading.2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt furtxt',style:{fontSize:'32px'}},this.rb("banner.subheading.2"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'heading-one',style:{textAlign:'center',marginBottom:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt furtxt',style:{fontSize:'32px'}},this.rb("banner.subheading1.2"))),function(){if(!_this2.props.PLPloggedIn){var styles={margin:'0 auto'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 nopadding mx-auto joingrp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__sg_UserLoginType__["a" /* default */],{styles:styles,showSignUp:_this2.props.showSignUp,showNewLoginForm:_this2.props.showNewLoginForm,from:"Top"}));}}()));}},{key:'homeformobile',value:function homeformobile(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comp-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-center b-comp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'heading-one',style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt first-line',style:{fontSize:'32px'}},this.rb("banner.heading.za2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt furtxt',style:{fontSize:'32px'}},this.rb("banner.subheading.za2"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'heading-one',style:{textAlign:'center',marginBottom:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt furtxt',style:{fontSize:'32px'}},this.rb("banner.subheading1.za2"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'heading-one robotospan',style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt first-line',style:{fontSize:'24px'}},this.rb("banner.subheading1.za3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt furtxt',style:{fontSize:'24px'}},this.rb("banner.subheading1.za4")))),function(){if(!_this3.props.PLPloggedIn){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 nopadding mx-auto joingrp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__sg_UserLoginType__["a" /* default */],{showSignUp:_this3.props.showSignUp,showNewLoginForm:_this3.props.showNewLoginForm,from:"Top"}));}}()));}},{key:'homecomponent',value:function homecomponent(){var _this4=this;if(this.isMobile()||this.isTab()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'h-mob-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-container home-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},this.homeformobile())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-pagination'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_modal_video___default.a,{channel:'youtube',isOpen:this.state.isOpen,videoId:'b-X5TsIQG24',onClose:function onClose(){return _this4.setState({isOpen:false});}}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'h-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-container home-bannerweb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},this.homeforweb())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-pagination'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_modal_video___default.a,{channel:'youtube',isOpen:this.state.isOpen,videoId:'b-X5TsIQG24',onClose:function onClose(){return _this4.setState({isOpen:false});}}));}}}]);return sg_Banner;}(__WEBPACK_IMPORTED_MODULE_1__prelogin_src_components_Banner__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (sg_Banner);

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_icons_Feature1_png__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_icons_Feature1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_icons_Feature1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_icons_Feature2_png__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_icons_Feature2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_icons_Feature2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_Feature3_png__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_icons_Feature3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_icons_Feature3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_icons_Feature4_png__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_icons_Feature4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_icons_Feature4_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var LessonFeatures=function(_PreLoginPage){_inherits(LessonFeatures,_PreLoginPage);function LessonFeatures(){_classCallCheck(this,LessonFeatures);return _possibleConstructorReturn(this,(LessonFeatures.__proto__||Object.getPrototypeOf(LessonFeatures)).apply(this,arguments));}_createClass(LessonFeatures,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-p-ga':'',id:'LessonFeatures'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("custom.label.txt.2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-6 col-lg-3 featureSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__images_icons_Feature1_png___default.a,alt:'student listening to video lecture'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Video lessons'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'10,000+ animated lessons with interesting real-life contexts that explain the how and why of every concept')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-6 col-lg-3 featureSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__images_icons_Feature2_png___default.a,alt:'Bite-sized quizzes'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Bite-sized quizzes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Interactive tasks that make learning fun and immediate feedback to help you build confidence')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-6 col-lg-3 featureSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__images_icons_Feature3_png___default.a,alt:' Diagnostic test report'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Customised Study Plan'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Diagnostics Tests, recommended lessons and targeted practice, from a bank of 1,00,000+ problems')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-6 col-lg-3 featureSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__images_icons_Feature4_png___default.a,alt:'Granular report card'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Granular report card'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Topic wise grades to know precisely which problems to focus on to improve your overall performance')))));}}]);return LessonFeatures;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (LessonFeatures);

/***/ }),
/* 1271 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1272 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1273 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__prelogin_src_components_SignupSection__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sg_UserLoginType__ = __webpack_require__(510);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var sg_SignupSection=function(_SignupSection){_inherits(sg_SignupSection,_SignupSection);function sg_SignupSection(){_classCallCheck(this,sg_SignupSection);return _possibleConstructorReturn(this,(sg_SignupSection.__proto__||Object.getPrototypeOf(sg_SignupSection)).apply(this,arguments));}_createClass(sg_SignupSection,[{key:'render',value:function render(){var _this2=this;var styles={display:'inline-block',fontWeight:500};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{'data-p-ga':'',className:'mtb child'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.rb("signup.section.txt.1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hmorg',style:styles},'Hey'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hmblue',style:styles},'Math!\xA0'),this.rb("signup.section.txt.2")),function(){if(!_this2.props.PLPloggedIn){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-5 mx-auto text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__sg_UserLoginType__["a" /* default */],{showSignUp:_this2.props.showSignUp,showNewLoginForm:_this2.props.showNewLoginForm,from:"Bottom"}));}}()));}}]);return sg_SignupSection;}(__WEBPACK_IMPORTED_MODULE_1__prelogin_src_components_SignupSection__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (sg_SignupSection);

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_device_detect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_html_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_forgotpwdicon_png__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_forgotpwdicon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_icons_forgotpwdicon_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var fpServerResponses={200:'An email has been sent to <span class="hm-blue"><email></span> with the link to reset the password. Please check your Inbox and Spam/Junk folders.',403:'You are not allowed to reset your password. Please write to <a href="mailto:support@heymath.com">support@heymath.com</a>',600:'Invalid User ID / Email.',// also for 400, 401
0:'An unexpected error occurred. Please try again after sometime or write to <a href="mailto:support@heymath.com">support@heymath.com</a>'};var UnifiedForgotPwd=function(_PreLoginPage){_inherits(UnifiedForgotPwd,_PreLoginPage);function UnifiedForgotPwd(props){_classCallCheck(this,UnifiedForgotPwd);var _this=_possibleConstructorReturn(this,(UnifiedForgotPwd.__proto__||Object.getPrototypeOf(UnifiedForgotPwd)).call(this,props));_this.hmNav=function(){//this.props.myProps.history.push(this.props.navigateURL);
window.top.location.href=this.props.navigateURL;};_this.submitForm=function(){var verificationtype=this.state.loginType;var formData={"userId":this.state.userInput,"password":this.state.password_newacc//do cofirm
};var me=this;me.setState({submitButtonDisabled:true});var callBackSuccess=function callBackSuccess(response){console.log("response : ",response);if(response!==null){me.setState({validToken:response.isValid,pwdUpdated:response.passwordUpdated,loader:false});//console.log("timeout..........",me.state.pwdUpdated," : src = ",me.state.source);
setTimeout(function(){console.log("timeout..........");me.bindLoginLink();},500);me.trackMe(true,"set_password");}else{me.trackMe(false,"set_password");}};var callBackFailure=function callBackFailure(response){me.setState({submitButtonDisabled:false});me.trackMe(false,"set_password");};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("PWD_RECOVER")+this.state.otp_newacc,formData).put(callBackSuccess,callBackFailure);};_this.submitLumosPwdForm=function(){var me=this;var formData={"userId":this.state.username,"email":this.state.email};me.setState({submitButtonDisabled:true});__WEBPACK_IMPORTED_MODULE_10_jquery___default.a.ajax({url:me.getUrlFor("LUMOS_FORGOTPWD"),data:formData,type:'POST',xhrFields:{withCredentials:true},crossDomain:true,success:function success(response){switch(response.code){case 200://me.setState({serverMessage: fpServerResponses[response.code].replace(/<email>/g, formData.emailId)});
me.props.successForgotPwd(fpServerResponses[response.code].replace(/<email>/g,me.state.email));break;case 403:me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[response.code].replace(/<email>/g,me.state.email)});break;case 400:case 401:case 600:me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[600]});break;default://currentDialog.serverMessageElem.innerHTML = fpServerResponses[0];
me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[0]});}me.trackMe();},error:function error(response){console.log("Error in lumos login",response);me.setState({submitButtonDisabled:false});me.trackMe();}});};_this.state={plp_userinput:_this.props.userid||"",username_newacc:'',password_newacc:'',confirmpassword_newacc:'',singupType:"userid",loginType:_this.props.loginType||"userid",userInput:_this.props.userInput||"",otp_newacc:'',submitButtonDisabled:false,serverMessage:"",emailfeedbackmsg:"",source:"",isOTPSend:false,isVerified:false,OTPDisabled:"hiddenOTP",verifyDisabled:"disabled",emailDisabled:false,phoneDisabled:false,verifyText:_this.rb("register.verify"),sendOTPText:_this.rb("home.continue"),pwdUpdated:false,passcodeDisabled:"disabled",username:'',UseridEmailidSame:false,user_exists:false};_this.handleChange=_this.handleChange.bind(_this);_this.enterOTPChange=_this.enterOTPChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.handleSubmitVerify=_this.handleSubmitVerify.bind(_this);_this.userIdChange=_this.userIdChange.bind(_this);_this.userverifyIdChange=_this.userverifyIdChange.bind(_this);_this.sendOTP=_this.sendOTP.bind(_this);_this.verifyOTP=_this.verifyOTP.bind(_this);_this.getOTPField=_this.getOTPField.bind(_this);_this.showLogin=_this.showLogin.bind(_this);_this.handleKeyUp=_this.handleKeyUp.bind(_this);_this.myTrackerInstance=_this.getTracker();_this.handleemailChange=_this.handleemailChange.bind(_this);_this.submitLumosPwdForm=_this.submitLumosPwdForm.bind(_this);_this.submitPLPPwdForm=_this.submitPLPPwdForm.bind(_this);_this.submitCommonPwdForm=_this.submitCommonPwdForm.bind(_this);_this.renderUseridEmailidValue=_this.renderUseridEmailidValue.bind(_this);_this.handleCheckboxChange=_this.handleCheckboxChange.bind(_this);_this.plpForgotPassword=_this.plpForgotPassword.bind(_this);_this.lumosForgotPassword=_this.lumosForgotPassword.bind(_this);_this.commonForgotPassword=_this.commonForgotPassword.bind(_this);_this.forgotPassword=_this.forgotPassword.bind(_this);_this.renderRHSForm=_this.renderRHSForm.bind(_this);_this.userVerify=_this.userVerify.bind(_this);_this.getUserStatus=_this.getUserStatus.bind(_this);return _this;}_createClass(UnifiedForgotPwd,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var me=this;//console.log('componentWillReceiveProps', nextProps);    
this.setState({loginType:nextProps.loginType||"userid",userInput:nextProps.userInput||"",otp_newacc:'',submitButtonDisabled:false,serverMessage:"",emailfeedbackmsg:"",source:"",isOTPSend:false,isVerified:false,OTPDisabled:"hiddenOTP",verifyDisabled:"disabled",emailDisabled:false,phoneDisabled:false,verifyText:this.rb("register.verify"),sendOTPText:this.rb("home.continue"),pwdUpdated:false,passcodeDisabled:"disabled"});setTimeout(function(){me.reinitiate();},500);}},{key:'componentDidMount',value:function componentDidMount(){this.sessionCheck();this.reinitiate();}},{key:'reinitiate',value:function reinitiate(){if(this.state.userInput!=""){this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){this.setState({OTPDisabled:""});__WEBPACK_IMPORTED_MODULE_10_jquery___default()(".OTPButton").trigger("click");}}__WEBPACK_IMPORTED_MODULE_10_jquery___default()("#loginRoot .userInput").focus();}},{key:'handleChange',value:function handleChange(e){var _setState;var target=e.currentTarget;//console.log("target=",target);
this.form.validateFields(target);this.setState((_setState={},_defineProperty(_setState,target.name,target.value),_defineProperty(_setState,'serverMessage',""),_defineProperty(_setState,'submitButtonDisabled',!this.form.isValid()),_setState));}},{key:'handleemailChange',value:function handleemailChange(e){this.handleChange(e);}},{key:'userIdChange',value:function userIdChange(e){var _setState2;var target=e.currentTarget;this.form.validateFields(target);// var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
// if(phoneRegx.test(target.value)){
// 	this.setState({loginType:"mobile",loginMaxLength:10,OTPDisabled: "hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});
// 	if(target.value.length >= 10){				
// 		this.setState({ OTPDisabled: "", passcodeDisabled:""});
// 	}
// }else{
// 	this.setState({loginType:"email",loginMaxLength:254,OTPDisabled: "hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});
// 	if(target.value.length>0){
// 		this.setState({ OTPDisabled: "",passcodeDisabled:""});
// 	}
// }
this.setState({loginType:"email",loginMaxLength:254,OTPDisabled:"hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});if(target.value.length>0){this.setState({OTPDisabled:"",passcodeDisabled:""});}this.setState((_setState2={},_defineProperty(_setState2,target.name,target.value),_defineProperty(_setState2,'serverMessage',""),_defineProperty(_setState2,'submitButtonDisabled',true),_setState2));}},{key:'userverifyIdChange',value:function userverifyIdChange(e){var _setState3;var target=e.currentTarget;this.form.validateFields(target);// var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
// if(phoneRegx.test(target.value)){
// 	this.setState({loginType:"mobile",loginMaxLength:10,isOTPSend:false,isVerified:false,OTPDisabled: "", passcodeDisabled:""});
// }else{
// 	this.setState({loginType:"email",loginMaxLength:254,isOTPSend:false,isVerified:false});
// 	if(target.value.length>0){
// 		this.setState({ OTPDisabled: "",passcodeDisabled:""});
// 	}
// }
this.setState({loginType:"email",loginMaxLength:254,isOTPSend:false,isVerified:false});if(target.value.length>0){this.setState({OTPDisabled:"",passcodeDisabled:""});}this.setState((_setState3={},_defineProperty(_setState3,target.name,target.value),_defineProperty(_setState3,'serverMessage',""),_defineProperty(_setState3,'submitButtonDisabled',true),_setState3));//console.log(this.state);
}},{key:'enterOTPChange',value:function enterOTPChange(e){if(this.otp.value.length>0){this.setState({verifyDisabled:""});}else{this.setState({verifyDisabled:"disabled"});}this.handleChange(e);}},{key:'bindLoginLink',value:function bindLoginLink(){var me=this;console.log("link::",__WEBPACK_IMPORTED_MODULE_10_jquery___default()("#loginLink"));__WEBPACK_IMPORTED_MODULE_10_jquery___default()("#loginLink").click(function(){me.showLogin();});}},{key:'trackMe',value:function trackMe(result,source){/*var trackObj = {
				"name": this.state.username_newacc,
			    "email": (this.state.loginType == "mobile") ? "" : this.state.userInput,
			    "phone": (this.state.loginType == "mobile") ? this.state.userInput : "",
			    "event_source":this.getTracker().enums.signupEventSource[source],
			    "result": result
			    
		}

		this.initiateTrack("signup",trackObj);*/var trackObj={"login_id":this.state.userInput,"email":"","event_source":this.getTracker().enums.signupEventSource[source],"result":result};if(source=="set_password"){this.storeTrackEvent("forgot_password",trackObj);}else{this.initiateTrack("forgot_password",trackObj);}}},{key:'submitPLPPwdForm',value:function submitPLPPwdForm(){var userId=this.state.username;var emailId=this.state.email;if(this.state.UseridEmailidSame){userId=emailId;}var formData={"userId":userId,"emailId":emailId};var me=this;me.setState({submitButtonDisabled:true});var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status=="SUCCESS"){//me.setState({serverMessage: fpServerResponses[200].replace(/<email>/g, formData.emailId)});
me.props.successForgotPwd(fpServerResponses[200].replace(/<email>/g,formData.emailId));}else if(response.status=="INVALID_EMAIL"){me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[600]});}else if(response.status=="INVALID_USERID"){me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[600]});}else if(response.status=="PROVIDER_FORBIDDEN"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("google.errmsg.pwd")});}else{me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[0]});}}me.trackMe();console.log("response : ",response);};var callBackFailure=function callBackFailure(response){me.setState({submitButtonDisabled:false});me.trackMe();};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("FORGOT_PWD"),formData).post(callBackSuccess,callBackFailure);}},{key:'submitCommonPwdForm',value:function submitCommonPwdForm(){var userId=this.state.username;var emailId=this.state.email;if(this.state.UseridEmailidSame){userId=emailId;}var formData={"userId":userId,"email":emailId};var me=this;me.setState({submitButtonDisabled:true});var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.source=="plp"){if(response.status=="SUCCESS"){//me.setState({serverMessage: fpServerResponses[200].replace(/<email>/g, formData.email)});
me.props.successForgotPwd(fpServerResponses[200].replace(/<email>/g,formData.email));}else if(response.status=="INVALID_EMAIL"){me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[600]});}else if(response.status=="INVALID_USERID"){me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[600]});}else if(response.status=="PROVIDER_FORBIDDEN"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("google.errmsg.pwd")});}else{me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[0]});}}else if(response.source=="lumos"){switch(response.code){case 200://me.setState({serverMessage: fpServerResponses[response.code].replace(/<email>/g, formData.email)});
me.props.successForgotPwd(fpServerResponses[response.code].replace(/<email>/g,me.state.email));break;case 403:me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[response.code].replace(/<email>/g,me.state.email)});break;case 400:case 401:case 600:me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[600]});break;default://currentDialog.serverMessageElem.innerHTML = fpServerResponses[0];
me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[0]});}}}me.trackMe();console.log("response : ",response);};var PLPcallBackFailure=function PLPcallBackFailure(response){me.setState({submitButtonDisabled:false});me.trackMe();};var callBackFailure=function callBackFailure(response){//me.setState({submitButtonDisabled: false});
//me.trackMe();
new __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__["a" /* default */](me.getUrlFor("PLP_COMMON_FORGOT_PWD"),formData).enableCORS().post(callBackSuccess,PLPcallBackFailure);};//new HmAjax(this.getUrlFor("FORGOT_PWD"),formData).post(callBackSuccess,callBackFailure);
new __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__["a" /* default */](this.getUrlFor("COMMON_FORGOT_PWD"),formData).enableCORS().post(callBackSuccess,callBackFailure);}},{key:'handleSubmit',value:function handleSubmit(e){e.preventDefault();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid(),serverMessage:""});if(this.form.isValid()){if(this.state.source.toLowerCase()=="lumos"){this.submitCommonPwdForm();}else if(this.state.isOTPSend&&this.state.isVerified){this.submitForm();}else if(this.state.source.toLowerCase()=="plp"){this.submitCommonPwdForm();}}}},{key:'handleSubmitVerify',value:function handleSubmitVerify(e){e.preventDefault();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){this.getUserStatus();// if(this.state.userLoginAllowed){
// 	this.submitForm();  
// }else{
// 	this.getUserStatus();
// }
}}},{key:'handleCheckboxChange',value:function handleCheckboxChange(event){var target=event.target;this.setState({"UseridEmailidSame":target.checked});if(event.target){this.setState({username:this.state.email});}}},{key:'renderUseridEmailidValue',value:function renderUseridEmailidValue(){if(this.state.UseridEmailidSame){return this.state.email;}else{return this.state.username;}}},{key:'checkForDisabled',value:function checkForDisabled(){return true;if(this.state.UseridEmailidSame){return true;}else{return false;}}},{key:'sendOTP',value:function sendOTP(){// if(this.state.OTPDisabled == "hiddenOTP"){
// 	this.form.validateFields();
// 	return;
// }
var me=this;var otpServerMsg="";if(this.state.loginType=="mobile"){if(me.state.isOTPSend){otpServerMsg="OTP is sent again to mobile";}else{otpServerMsg="OTP is sent to your mobile";}}else{if(me.state.isOTPSend){otpServerMsg="OTP is sent again to your email";}else{otpServerMsg="OTP is sent to your email";}}me.setState({serverMessage:"",emailfeedbackmsg:"",isOTPSend:false,isVerified:false,verifyDisabled:"disabled",otp_newacc:"",passcodeDisabled:"disabled"});var formData={"userId":this.state.userInput,"contactType":this.state.loginType};var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status){if(response.status=="user_exists"){me.setState({serverMessage:"User already exists",passcodeDisabled:""});}else if(response.status=="no_such_token"){me.setState({serverMessage:"The OTP entered is incorrect",passcodeDisabled:""});}else if(response.status=="error"){me.setState({serverMessage:"Internal error occured",passcodeDisabled:""});}else if(response.status=="INVALID_EMAIL"){me.setState({serverMessage:fpServerResponses[600],passcodeDisabled:""});}else if(response.status=="INVALID_USERID"){me.setState({serverMessage:fpServerResponses[600],passcodeDisabled:""});}else if(response.status=="PROVIDER_FORBIDDEN"){me.setState({serverMessage:me.rb("google.errmsg.pwd"),passcodeDisabled:""});}else{me.setState({emailfeedbackmsg:otpServerMsg});}}if(response.status.toLowerCase()=="success"){me.setState({isOTPSend:true,passcodeDisabled:"disabled"});me.trackMe(true,"send_otp");}else{me.trackMe(false,"send_otp");}}console.log("response : ",response);};var PLPcallBackFailure=function PLPcallBackFailure(response){console.log("Error in FORGOT_PWD");me.setState({passcodeDisabled:""});me.trackMe(false,"send_otp");};var callBackFailure=function callBackFailure(response){console.log("Error in FORGOT_PWD");//me.setState({passcodeDisabled:""});
//me.trackMe(false,"send_otp");
new __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__["a" /* default */](me.getUrlFor("PLP_COMMON_FORGOT_PWD"),formData).enableCORS().post(callBackSuccess,PLPcallBackFailure);};//new HmAjax(this.getUrlFor("FORGOT_PWD"),formData).post(callBackSuccess,callBackFailure);
new __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__["a" /* default */](this.getUrlFor("COMMON_FORGOT_PWD"),formData).enableCORS().post(callBackSuccess,callBackFailure);}},{key:'verifyOTP',value:function verifyOTP(){var me=this;var formData={"userId":this.state.userInput};me.setState({serverMessage:""});var verificationtype=this.state.loginType;this.setState({verifyDisabled:"disabled"});var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status){if(response.status=="user_exists"){me.setState({serverMessage:"User already exists",verifyDisabled:""});me.trackMe(false,"verify_otp");}else if(response.status=="no_such_token"||response.status=="NO_TOKEN_AVAILABLE"){me.setState({serverMessage:"The OTP entered is incorrect",verifyDisabled:""});me.trackMe(false,"verify_otp");}else if(response.isValid==false){me.setState({serverMessage:"The OTP entered is incorrect",verifyDisabled:""});me.trackMe(false,"verify_otp");}else if(response.status=="error"){me.setState({serverMessage:"Internal error occured",verifyDisabled:""});me.trackMe(false,"verify_otp");}else{me.setState({isVerified:true,verifyDisabled:""});me.trackMe(true,"verify_otp");}}}console.log("response : ",response);};var callBackFailure=function callBackFailure(response){console.log("Error in PWD_TOKEN_VALIDATE");me.setState({verifyDisabled:""});me.trackMe(false,"verify_otp");};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("PWD_TOKEN_VALIDATE")+this.state.otp_newacc,formData).post(callBackSuccess,callBackFailure);}},{key:'getOTPField',value:function getOTPField(){var _this2=this;if(this.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'otp_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'otp_newacc',className:'otp_newacc',name:'otp_newacc',placeholder:this.rb("register.enterOTP"),innerRef:function innerRef(otp){return _this2.otp=otp;},onKeyUp:this.handleKeyUp,value:this.state.otp_newacc,onChange:this.enterOTPChange,required:true,minLength:1,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'otp_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("register.enterOTP")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'})));}}},{key:'showLogin',value:function showLogin(){this.props.showNewLoginForm();}},{key:'getVerifyField',value:function getVerifyField(){if(this.state.isOTPSend&&!this.state.isVerified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"submitButton verifyButton "+this.state.verifyDisabled,onClick:this.verifyOTP},this.rb("register.verify"));}/*else if(this.state.isOTPSend && this.state.isVerified){
			return (<div className="text-right verifytxt"><i class="material-icons">done</i> <span>{this.rb("register.verified")}</span></div>);
		}*/}},{key:'getSignupHeaderMsg',value:function getSignupHeaderMsg(){if(this.state.isOTPSend&&!this.state.isVerified){if(this.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10'},'Please enter the 6-digit OTP sent to'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10'},'Please enter the 6-digit OTP sent to'));}}else if(this.state.isVerified){if(this.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10'},'You have requested to reset the password for'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small mt-10'},'+91 ',this.state.userInput));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10'},'You have requested to reset the password for'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small mt-10'},this.state.userInput));}}}},{key:'sendOTPText',value:function sendOTPText(){if(this.state.isOTPSend){return this.rb("register.reSendOTP");}else{return this.rb("home.continue");}}},{key:'showEmailFeedback',value:function showEmailFeedback(){var _this3=this;if(this.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-control-feedback'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error'},this.state.emailfeedbackmsg),function(){if(_this3.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedbacksmall'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'All important information will be sent to this mobile number'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedbacksmall'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'All important information will be sent to this email ID'));}}());}}},{key:'getUserInputPattern',value:function getUserInputPattern(){if(this.state.loginType=="mobile"){return".{10,}";}else{return"^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$";}}},{key:'getContactType',value:function getContactType(){var _this4=this;if(!this.state.isVerified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,function(){if(!_this4.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10 textAlignLeft'},_this4.rb("unifiedlogin.otpalert"),_this4.state.loginType=="mobile"?"mobile no":"email");}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'userInput'},function(){if(_this4.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'countrycodeform'},'+91');}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'userInput',className:"userInput "+this.state.loginType,name:'userInput',placeholder:this.rb("login.userplaceholder.za"),innerRef:function innerRef(email){return _this4.email=email;},onKeyUp:this.handleKeyUp,value:this.state.userInput,onChange:this.userIdChange,disabled:this.checkForDisabled(),pattern:this.getUserInputPattern(),required:true,minLength:1,maxLength:this.state.loginMaxLength,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'2'}),function(){if(_this4.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'userInput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},_this4.rb("za_login.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},_this4.rb("register.mobilenolength")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length>0&&!/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g.test(value);}},_this4.rb("register.numbersonly")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'userInput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},_this4.rb("za_login.useridrequired")));}}()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),this.getOTPField(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages pb-20'},this.state.serverMessage),function(){if(_this4.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this4.rb("register.reSendOTPmsg"),' '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pl-10 resendButton',onClick:_this4.sendOTP},_this4.rb("register.reSendOTP"))),_this4.getVerifyField());}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this4.getVerifyField(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"submitButton OTPButton "+_this4.state.OTPDisabled+" "+_this4.state.passcodeDisabled,onClick:_this4.sendOTP},_this4.rb("home.continue"))));}}());}}},{key:'setPassword',value:function setPassword(){var _this5=this;if(this.state.isVerified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'password_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'password_newacc',name:'password_newacc',placeholder:this.rb("login.password"),innerRef:function innerRef(password){return _this5.password=password;},value:this.state.password_newacc,onChange:this.handleChange,required:true,minLength:6,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'password_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("login.pwdrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("validate.pwd.minimum",[6])))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'confirmpassword'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'confirmpassword_newacc',name:'confirmpassword_newacc',placeholder:this.rb("rpwd.confirmpwd"),innerRef:function innerRef(confirmpassword){return _this5.confirmpassword=confirmpassword;},value:this.state.confirmpassword_newacc,onChange:this.handleChange,required:true,minLength:6,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'confirmpassword_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("rpwd.confirmpwdrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("validate.pwd.minimum",[6])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value!==_this5.password.value;}},this.rb("rpwd.doesnotmatch")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages pt-20'},this.state.serverMessage));}}},{key:'renderRHSForm',value:function renderRHSForm(){var _this6=this;if(this.state.pwdUpdated===true&&this.state.source==="plp"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 mt-50'},__WEBPACK_IMPORTED_MODULE_11_react_html_parser___default()(this.rb("rpwd.msg.success"))));}else if(this.state.pwdUpdated===true&&this.state.source==="lumos"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 mt-50'},__WEBPACK_IMPORTED_MODULE_11_react_html_parser___default()(this.rb("rpwd.msg.success"))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rounded-0'},this.getSignupHeaderMsg(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this6.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},this.getContactType(),this.setPassword(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-ga':'Home - Sign in - Users who want to register - Sign Up',disabled:this.state.submitButtonDisabled,className:"submitButton signup signupButton "+(this.state.isVerified?"":"hidden")},this.rb("register.setpassword"))))))))));}}},{key:'renderFormTitle',value:function renderFormTitle(){if(this.state.isOTPSend&&this.state.isVerified){return this.rb("rpwd.title");}else{return this.rb("forgot_password_label");}}},{key:'handleKeyUp',value:function handleKeyUp(event){if(event.key==='Enter'&&this.form.isValid()){if(!this.state.isVerified){if(this.state.isOTPSend&&this.state.verifyDisabled!="disabled"){__WEBPACK_IMPORTED_MODULE_10_jquery___default()(".verifyButton").trigger("click");}else if(this.state.passcodeDisabled!="disabled"){this.setState({OTPDisabled:""});__WEBPACK_IMPORTED_MODULE_10_jquery___default()(".OTPButton").trigger("click");}}}}},{key:'lumosForgotPassword',value:function lumosForgotPassword(){var _this7=this;if(this.state.loggedIn){return _get(UnifiedForgotPwd.prototype.__proto__||Object.getPrototypeOf(UnifiedForgotPwd.prototype),'render',this).call(this);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center schoolLoginInfo josefinsansFont nopadding'},this.rb("unif.fpwd.msg1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),function(){if(_this7.props.source.toLowerCase()=="lumos"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center schoolLoginInfo josefinsansFont'},__WEBPACK_IMPORTED_MODULE_11_react_html_parser___default()(_this7.rb("fpwd.lumos.msg")));}}())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rounded-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this7.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'username'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'username',className:'username',name:'username',placeholder:this.rb("login.userid"),value:this.renderUseridEmailidValue(),onChange:this.handleChange,disabled:this.checkForDisabled(),required:true,minLength:1,maxLength:254,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'username'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("za_login.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'email'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'email',className:'email',name:'email',placeholder:this.rb("fpwd.email"),innerRef:function innerRef(email){return _this7.email=email;},value:this.state.email,onChange:this.handleemailChange,required:true,maxLength:254,pattern:'^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$',minLength:1,tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'email',show:'all'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("fpwd.emailrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},this.rb("fpwd.validemail")))),function(){if(_this7.props.source.toLowerCase()=="plp"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'checkboxLabel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'fwdCheckbox',name:'sameUseridEmailid',type:'checkbox',onChange:_this7.handleCheckboxChange}),_this7.rb("fpwd.plp.useridemailidsame")));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'forgotpwdMsg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages'},' ',__WEBPACK_IMPORTED_MODULE_11_react_html_parser___default()(this.state.serverMessage))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:this.state.submitButtonDisabled,className:'submitButton'},this.rb("login.send"))))))),function(){if(_this7.props.source.toLowerCase()=="plp"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center schoolLoginInfo josefinsansFont'},_this7.rb("fpwd.plp.note"));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))));}}},{key:'plpForgotPassword',value:function plpForgotPassword(){var me=this;if(this.state.loggedIn){return _get(UnifiedForgotPwd.prototype.__proto__||Object.getPrototypeOf(UnifiedForgotPwd.prototype),'render',this).call(this);}else{return me.renderRHSForm();}}},{key:'commonForgotPassword',value:function commonForgotPassword(){var me=this;if(this.state.loggedIn){return _get(UnifiedForgotPwd.prototype.__proto__||Object.getPrototypeOf(UnifiedForgotPwd.prototype),'render',this).call(this);}else{return me.userVerify();}}},{key:'userVerify',value:function userVerify(){var _this8=this;var me=this;if(this.state.loggedIn){return _get(UnifiedForgotPwd.prototype.__proto__||Object.getPrototypeOf(UnifiedForgotPwd.prototype),'render',this).call(this);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this8.form=formWithConstraints;},onSubmit:this.handleSubmitVerify,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'plp_userinput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'plp_userinput',className:"plp_userinput "+this.state.loginType,name:'plp_userinput',placeholder:this.rb("unifiedlogin.userplaceholder"),value:this.state.plp_userinput,onChange:this.userverifyIdChange,required:true,minLength:1,maxLength:254,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'plp_userinput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("za_unifiedverify.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages'},this.state.serverMessage),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-ga':"Home - Verify",className:'submitButton'},'Verify')))));}}},{key:'getUserStatus',value:function getUserStatus(){if(this.state.plp_userinput.length<=0){return;}var formData={"userId":this.state.plp_userinput};var me=this;var callBackSuccess=function callBackSuccess(response,request){if(response!==null){if(response.userExists&&response.source!=='null'&&response.message!=="provider_forbidden"){if(response.source=="lumos"){me.setState({userLoginAllowed:true,user_exists:response.userExists,source:response.source,username:me.state.plp_userinput});}else if(response.source=="plp"){me.setState({userLoginAllowed:true,user_exists:response.userExists,source:response.source,userInput:me.state.plp_userinput});}}else{if(response.message=="provider_forbidden"){if(response.authProviderId==2){me.setState({submitButtonDisabled:false,serverMessage:me.rb("google.errmsg.pwd")});}else if(response.authProviderId==4){me.setState({submitButtonDisabled:false,serverMessage:me.rb("uolo.errmsg.pwd")});}}else{//me.setState({userLoginAllowed:false});
//me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
me.setState({submitButtonDisabled:false,serverMessage:me.rb("za_unifiedlogin.invalidinput.msg")});//	me.checkValidUserInput();
}}}};var PLPcallBackFailure=function PLPcallBackFailure(response,request){me.setState({submitButtonDisabled:false});};var callBackFailure=function callBackFailure(response,request){//me.setState({submitButtonDisabled: false});
new __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__["a" /* default */](me.getUrlFor("PLP_GET_USER_STATUS_UNIF"),formData).enableCORS().post(callBackSuccess,PLPcallBackFailure);};//new HmAjax(this.getUrlFor("GET_USER_STATUS"),formData).post(callBackSuccess,callBackFailure);
new __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__["a" /* default */](this.getUrlFor("GET_USER_STATUS_UNIF"),formData).enableCORS().post(callBackSuccess,callBackFailure);}},{key:'checkValidUserInput',value:function checkValidUserInput(){var me=this;var userinput=this.state.plp_userinput;if(userinput.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){me.setState({userLoginAllowed:false});me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);}else{me.setState({submitButtonDisabled:false,serverMessage:me.rb("za_login.invalidinput.msg")});}// var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
// if(phoneRegx.test(userinput)){			
// 	if(userinput.length == 10){				
// 		me.setState({userLoginAllowed:false});
// 		me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
// 	}else{
// 		me.setState({submitButtonDisabled: false, serverMessage: me.rb("login.invalidinput.msg")});
// 	}
// }else{
// 	if(userinput.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){
// 		me.setState({userLoginAllowed:false});
// 		me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
// 	}else{
// 		me.setState({submitButtonDisabled: false, serverMessage: me.rb("login.invalidinput.msg")});
// 	}
// }
}},{key:'forgotPassword',value:function forgotPassword(){var me=this;if(this.state.source===''){return me.commonForgotPassword();}else if(this.state.source==='plp'){return me.plpForgotPassword();}else if(this.state.source==='lumos'){return me.lumosForgotPassword();}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row nomargin loginParent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-4 nopadding loginLeftSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'loginLeftContent'},this.renderFormTitle()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'charactercontainer d-none d-sm-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'charactericons forgotpwdIcon',src:__WEBPACK_IMPORTED_MODULE_12__images_icons_forgotpwdicon_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'loginRoot',className:'plpLogin col-sm-8'},this.forgotPassword()));}}]);return UnifiedForgotPwd;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (UnifiedForgotPwd);

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_config_ProductConfig_json__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_config_ProductConfig_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__src_config_ProductConfig_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var sg_Footer=function(_PreLoginPage){_inherits(sg_Footer,_PreLoginPage);function sg_Footer(props){_classCallCheck(this,sg_Footer);var _this=_possibleConstructorReturn(this,(sg_Footer.__proto__||Object.getPrototypeOf(sg_Footer)).call(this,props));_this.geoBasedProductHeader=function(){var me=_this;if(_this.prodForCountry()==='IN'){return me.renderProductTab();}else if(_this.prodForCountry()==='SG'){return me.SgCatalogue();}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,me.renderProductTab(),me.SgCatalogue());}};_this.getFooterProduct=function(product){var me=_this;if(_this.prodForCountry()!=='SG'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,me.rb(product)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'Lessons-links'},me.grades.map(function(grade){return me.renderFooterProduct(product,grade);})));}};_this.state={error:null,isLoaded:false,items:[],ProductList:[],pro_detail:[],products:[],self:[],plp:[],products_details:{},products_category_order:[]};_this.grades=_this.props.grades;_this.productClass=_this.props.products_class;_this.productDetails=_this.props.products_details;_this.products_category=_this.props.products_category;_this.productClasses=_this.props.classes;_this.state.products=Object.keys(_this.products_category);_this.renderFooterProduct=_this.renderFooterProduct.bind(_this);_this.restricted=false;_this.userObj=null;_this.restrictedCategories=window.footerRestrictedProdCategories||[];return _this;}_createClass(sg_Footer,[{key:'componentDidMount',value:function componentDidMount(){//console.warn("SG Footer");
var _state=this.state,products=_state.products,self=_state.self,plp=_state.plp;this.grades=this.props.grades;this.productClass=this.props.products_class;this.productDetails=this.props.products_details;this.products_category=this.props.products_category;this.productClasses=this.props.classes;this.state.products=Object.keys(this.products_category);//HmEventRegistry.fireEvent("INITIATE_GA");
}},{key:'componentDidUpdate',value:function componentDidUpdate(){__WEBPACK_IMPORTED_MODULE_4__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");}},{key:'getProdDetails',value:function getProdDetails(){//console.log(this.state.products_details);
if(this.state.products_details!=={}&&this.state.products_details!==undefined){return this.state.products_details;}}},{key:'saveID',value:function saveID(grade,proID,link){var products_details=this.state.products_details;var me=this;var callBackSuccess=function callBackSuccess(result){if(result!==null){me.setState({products_details:result}),//console.log("Footer:::",me.getProdDetails());
localStorage.setItem('grade',grade);localStorage.setItem('product',proID);localStorage.setItem('proDetail',JSON.stringify(me.getProdDetails()));window.top.location.href=link;}//console.log("response : ", response);
};var callBackFailure=function callBackFailure(response){me.setState({isLoaded:true,error:"Error in Footer PRODUCT_JSON"});console.log("Error in Footer PRODUCT_JSON in Grade");};var formData={"levelId":grade};new __WEBPACK_IMPORTED_MODULE_3__util_HmAjax__["a" /* default */](this.getUrlFor("PRODUCT_JSON"),formData).post(callBackSuccess,callBackFailure);//console.log(grade);
//console.log(proID);
}},{key:'renderFooterProduct',value:function renderFooterProduct(product,grade){var _this2=this;//console.log(product,", ",grade,", ",this.productClasses);
if(product&&grade&&this.products_category&&this.products_category[product]&&this.products_category[product].hasOwnProperty(grade)){var restricted="";if(this.GradeRestrictionManager.isGradeRestricted(grade)){restricted="restricted";this.restricted=true;}if(__WEBPACK_IMPORTED_MODULE_5__src_config_ProductConfig_json___default.a[product]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:restricted,key:grade,'data-ga':'Footer - '+__WEBPACK_IMPORTED_MODULE_5__src_config_ProductConfig_json___default.a[product].ganame+' - '+this.productClasses[grade].ClassName,onClick:function onClick(){return _this2.saveID(''+grade,''+_this2.products_category[product][grade],__WEBPACK_IMPORTED_MODULE_5__src_config_ProductConfig_json___default.a[product].url+_this2.products_category[product][grade]);}},this.productClasses[grade].ClassName,function(){if(restricted=="restricted"){return"*";}}());}}}},{key:'checkRestrictedGrade',value:function checkRestrictedGrade(product,grades){//console.log("grades:::",grades, ", ",product);
//console.log(this.products_category, ", ",product,", ",this.products_category[product],", ",this.products_category[product].hasOwnProperty("11"));
var restrictedAvailable=false;var restrictedGrades=[];if(grades&&grades.length>0){for(var i=0;i<grades.length;i++){if(this.products_category&&this.products_category[product]&&this.products_category[product].hasOwnProperty(grades[i])){if(this.GradeRestrictionManager.isGradeRestricted(grades[i])){restrictedGrades.push(grades[i]);}}}try{restrictedAvailable=restrictedGrades.length===Object.keys(this.products_category[product]).length;}catch(e){}}else{restrictedAvailable=true;}return restrictedAvailable;}},{key:'getUserRole',value:function getUserRole(){var role='';if(this.UserStore){if(this.getUser()&&this.getUser().get()){role=this.getUser().get().userRole.role;}}//console.log("role ",role);
return role;}},{key:'renderProductTab',value:function renderProductTab(){var geoLocation=this.getGeo().toUpperCase()||'';if(this.getUserRole()=="TCHR"&&geoLocation==='IN'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'Footer - Products'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/in/products'},this.rb("in.products.students.title"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'Footer - Products'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/sg/products'},this.rb("sg.products.title"))));}}},{key:'renderTeacherTab',value:function renderTeacherTab(){if(window.teachers_tab_suppressed){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null);}if(this.getUserRole()=="STU"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'Footer - Teachers'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/teachers'},'Teachers'));}}},{key:'SgCatalogue',value:function SgCatalogue(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'Footer - SgCatalogue'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/sg/products'},this.rb("sg.products.title")));}},{key:'renderLessonsTab',value:function renderLessonsTab(){var _this3=this;var me=this;if(me.getUserRole()!="TCHR"){return me.state.products_category_order.map(function(product){//if(this.checkRestrictedGrade(product,this.grades) == false){
if(!me.restrictedCategories||me.restrictedCategories.length===0||me.restrictedCategories.length>0&&me.restrictedCategories.indexOf(product)<0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-3 no-padding',key:product},_this3.getFooterProduct(product));}});//}
}}},{key:'render',value:function render(){var telPhoneNo=window.telPhoneNo[this.getGeo()]||window.telPhoneNo['OTHERS']||'+91 44 3500 2073';var _state2=this.state,products=_state2.products,self=_state2.self,plp=_state2.plp;this.grades=this.props.grades;this.grades_order=this.props.grades_order;this.productClass=this.props.products_class;this.productDetails=this.props.products_details;this.products_category=this.props.products_category;this.productClasses=this.props.classes;this.state.products=Object.keys(this.products_category);this.state.products_category_order=this.props.products_category_order;var tifOptions=[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row grade-links'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'f-links atag'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'Footer - Home'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/'},'Home')),this.SgCatalogue(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'Footer - Who we are'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/who-we-are'},'Who We Are')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'Footer - Our Learnings'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/our-learnings'},'Our Learnings')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'Footer - Spotlight'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/spotlight'},'Spotlight')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{'data-ga':'Footer - FAQ'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/faq'},this.rb("FAQ"))))),this.renderLessonsTab()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row follow-us'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-4 col-md-5 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'follow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Follow us on'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Footer - Follow Us - Facebook',href:'https://www.facebook.com/heymath',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fab fa-facebook-f'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Footer - Follow Us - Twitter',href:'http://twitter.com/heymath',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fab fa-twitter'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Footer - Follow Us - Linkedin',href:'http://linkedin.com/company/heymath',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fab fa-linkedin-in'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Footer - Follow Us - Youtube',href:'http://bit.ly/HeyMathYouTube',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fab fa-youtube'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Footer - Follow Us - Instagram',href:'https://www.instagram.com/heymath_india/',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fab fa-instagram'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-4 col-md norightpadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-link text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Footer - Phone number',href:"tel:"+telPhoneNo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/tel.png',alt:''}),' ',telPhoneNo)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-link text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Footer - Email ID',href:'mailto:support@heymath.com'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/mail.png',alt:''}),' support@heymath.com'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-4 col-md nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-link text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'data-ga':'Footer - Contact Us',className:'r-btn contactbtn',onClick:this.props.showContactus},'Contact us')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 text-link '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-left'},'All rights reserved \xA9 ',this.rb("footer.copyright.year"),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'HeyMath!'),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 text-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Footer - Terms',href:this.getTermsUrl("SG"),target:'_blank'},' Terms of Use'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'|'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Footer - Privacy Policy',href:this.getUrlFor("LUMOS_PRIVACY"),target:'_blank'},' Privacy Policy')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 text-link'}))));}}]);return sg_Footer;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (sg_Footer);

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_device_detect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_BrowserUtil__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_loginicon_png__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_loginicon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_icons_loginicon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_CoreAjax__ = __webpack_require__(75);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var loginServerResponses={200:'Success.',600:'User ID expired.',700:'Invalid User ID or Password.',500:'An unexpected error occurred. Please try again after sometime or write to <a href="mailto:<email>"><email></a>.',0:'An unexpected error occurred. Please try again after sometime or write to <a href="mailto:support@heymath.com">support@heymath.com</a>.'};var UnifiedLogin=function(_PreLoginPage){_inherits(UnifiedLogin,_PreLoginPage);function UnifiedLogin(props){_classCallCheck(this,UnifiedLogin);var _this=_possibleConstructorReturn(this,(UnifiedLogin.__proto__||Object.getPrototypeOf(UnifiedLogin)).call(this,props));_this.hmNav=function(userobj){//console.log("UnifiedLogin hmnav "+this.navigateUrl)
/*if(this.props.liveFeed == "true" || this.props.liveFeed == true){
			window.top.location.href = "/";
			return;
		}*///console.log("this.navigateUrl::::"+this.navigateUrl);
if(this.navigateUrl===null){// Do nothing
}else if(this.navigateUrl=="/product-details"){window.top.location.href=this.navigateUrl;}else{if(this.productsAvailableToAccess(userobj)){window.top.location.href="/landing";}else{if(userobj&&userobj.userRole&&userobj.userRole.role&&userobj.userRole.role.toUpperCase()==="TCHR"){window.top.location.href="/sg/products";}else{window.top.location.href=this.navigateUrl;}}}};_this.unifiedSubmitForm=function(){var formData={"userId":this.state.plp_userinput,"password":this.state.password};var me=this;me.setState({submitButtonDisabled:true});var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.source=="plp"){if(response.authenticated){//Setting user object at the browser level
me.getUser().store(response.user);me.storeRedirectUrl();try{me.doLumosLogout();}catch(e){}me.setState({submitButtonDisabled:false,source:response.source});try{var userObj=response.user;var loginObj={"user_id":userObj==null?"":userObj.userId,"login_id":me.state.plp_userinput,"user_agent":navigator.userAgent,"platform":navigator.platform,"device":__WEBPACK_IMPORTED_MODULE_9_react_device_detect__["isMobile"]?"mobile":__WEBPACK_IMPORTED_MODULE_9_react_device_detect__["isTablet"]?"tablet":"PC","ip_address":"ip_address","result":true,"session_id":userObj==null?"":userObj.authToken};me.storeTrackEvent("login",loginObj);}catch(e){}if(!me.tracked){me.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"logged-in"});me.tracked=true;}var afterUpdate=function afterUpdate(response){if(typeof me.props.callBack==="function"){me.props.callBack(response);return;}me.hmNav(response);};me.updateUserType(afterUpdate);}else{if(response.message=="provider_forbidden"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("google.errmsg.login")});}else{me.setState({submitButtonDisabled:false,serverMessage:me.rb(response.message)});}//me.showAlert(me.rb("alert"),me.rb(response.message));
me.trackMe(false);}}else if(response.source=="lumos"){try{me.doPLPLogout();}catch(e){}switch(response.code){case 200:case 402:me.setState({source:response.source});window.top.location.href=response.link;break;case 500://currentDialog.serverMessageElem.innerHTML = loginServerResponses[response.codeus].replace(/<email>/g, response.link);
me.setState({submitButtonDisabled:false,serverMessage:loginServerResponses[response.code].replace(/<email>/g,response.link)});break;case 600:case 700://currentDialog.serverMessageElem.innerHTML = loginServerResponses[response.code];
me.setState({submitButtonDisabled:false,serverMessage:loginServerResponses[response.code]});break;default://currentDialog.serverMessageElem.innerHTML = loginServerResponses[0];
me.setState({submitButtonDisabled:false,serverMessage:loginServerResponses[0]});}}}};var PLPcallBackFailure=function PLPcallBackFailure(response){//console.log("response : ", response);
me.trackMe(false);me.setState({submitButtonDisabled:false});};var callBackFailure=function callBackFailure(response){//console.log("response : ", response);
//me.trackMe(false);
//me.setState({submitButtonDisabled: false});
new __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__["a" /* default */](me.getUrlFor("PLP_COMMON_LOGIN"),formData).enableCORS().post(callBackSuccess,PLPcallBackFailure);};//new HmAjax(this.getUrlFor("LOGIN"),formData).post(callBackSuccess,callBackFailure);
new __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__["a" /* default */](this.getUrlFor("LUMOS_COMMON_LOGIN"),formData).enableCORS().post(callBackSuccess,callBackFailure);me.getUser().clearOldUser();};_this.state={plp_userinput:_this.props.userid||"",password:'',submitButtonDisabled:false,serverMessage:_this.props.errMsg||"",source:"",loginType:_this.props.loginType||"userid",userLoginAllowed:false};_this.handleChange=_this.handleChange.bind(_this);_this.userIdChange=_this.userIdChange.bind(_this);_this.handlePasswordChange=_this.handlePasswordChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.showforgotPwd=_this.showforgotPwd.bind(_this);_this.showCreateAccount=_this.showCreateAccount.bind(_this);_this.googleLogin=_this.googleLogin.bind(_this);_this.toggle_GSignin=_this.toggle_GSignin.bind(_this);_this.myTrackerInstance=_this.getTracker();_this.navigationKey="PLP_Navigation";_this.navigateUrl=props.navigateURL||window.location.href;_this.gaFrom=_this.props.gaFrom;_this.gasignin=" - Returning User";//console.log("this.gaFrom:::::::::::",this.gaFrom);
if(_this.gaFrom=="Top"||_this.gaFrom=="Bottom"){_this.gaFrom=_this.gaFrom+" Home - Join";}else{_this.gaFrom="Sign In - Users who have independently registered";_this.gasignin="";}//console.log("this.gaFrom2222:::::::::::",this.gaFrom);
//console.log("UnifiedLogin Loading"+(this.navigateUrl || 'None'));  
return _this;}_createClass(UnifiedLogin,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var me=this;//console.log('componentWillReceiveProps', nextProps);    
this.setState({plp_userinput:nextProps.userid||"",password:'',submitButtonDisabled:false,serverMessage:"",source:"",loginType:nextProps.loginType||"userid"});this.gaFrom=nextProps.gaFrom;// console.log("this.gaFrom:::::::::::",this.gaFrom);
if(this.gaFrom=="Top"||this.gaFrom=="Bottom"){this.gaFrom=this.gaFrom+" Home - Join";}else{this.gaFrom="Users who have independently registered - Sign Up";}//console.log("this.gaFrom:::::::::::",this.gaFrom);
// console.log("UnifiedLogin Testing"+(this.navigateUrl || 'None'));  
}},{key:'componentDidMount',value:function componentDidMount(){//$(".socialLoginContainer").hide();
this.sessionCheck();}},{key:'handleChange',value:function handleChange(e){var _setState;var target=e.currentTarget;this.form.validateFields(target);this.setState((_setState={},_defineProperty(_setState,target.name,target.value),_defineProperty(_setState,'submitButtonDisabled',!this.form.isValid()),_setState));}},{key:'userIdChange',value:function userIdChange(e){var target=e.currentTarget;// var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
// if(phoneRegx.test(target.value)){
// 	this.setState({loginType:"mobile", serverMessage: ""});
// }else{
// 	this.setState({loginType:"email", serverMessage: ""});
// }
this.setState({loginType:"email",serverMessage:""});this.handleChange(e);}},{key:'handlePasswordChange',value:function handlePasswordChange(e){this.handleChange(e);}},{key:'productsAvailableToAccess',value:function productsAvailableToAccess(userobj){var user=userobj;//console.log("user::::",user);
if(user!=null){var permissions=user.entlHistory;//console.log("permissions:::",permissions);
if(permissions!=null&&Object.keys(permissions).length>0){for(var i in permissions){if(permissions[i]!=null){var totalLevel=permissions[i].split(",").reduce(function(a,b){try{return parseInt(a)+parseInt(b);}catch(e){return 0;}});if(totalLevel>0){return true;}}}}}return false;}},{key:'storeRedirectUrl',value:function storeRedirectUrl(){var redirectUrl=null;/*if(BrowserUtil.getCookie("loginSrc") && BrowserUtil.getCookie("loginSrc").length > 10){
			redirectUrl = (BrowserUtil.getCookie("loginSrc")).replace(/"/g,"");
		}

		if(redirectUrl){
			BrowserStorageUtil.storeItem("loginSrc", redirectUrl);
		}*/}//testplpum.heymath.com/additionalInfo/update
},{key:'updateUserType',value:function updateUserType(commonCallback){var me=this;var callBackSuccess=function callBackSuccess(response){if(response!==null){//console.warn("user type",response)
me.getUser().store(response);}if(typeof commonCallback==="function"){commonCallback.apply(this,[response]);}};var callBackFailure=function callBackFailure(response){//console.warn("failure ",response);
if(typeof commonCallback==="function"){commonCallback.apply(this);}};_get(UnifiedLogin.prototype.__proto__||Object.getPrototypeOf(UnifiedLogin.prototype),'updateUserType',this).call(this,callBackSuccess,callBackFailure);}},{key:'getUserStatus',value:function getUserStatus(){if(this.state.plp_userinput.length<=0){return;}var formData={"verificationId":this.state.plp_userinput};var me=this;var callBackSuccess=function callBackSuccess(response){if(response!==null){//console.log("response : ", response,"me.props.from:::",me.props.from);					
if(response.user_exists){me.setState({userLoginAllowed:true});}else{if(response.message=="provider_forbidden"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("google.errmsg.login")});}else{//me.setState({userLoginAllowed:false});
//me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
me.checkValidUserInput();}}}};var callBackFailure=function callBackFailure(response){//console.log("response : ", response);	
me.setState({submitButtonDisabled:false});};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("GET_USER_STATUS")+this.state.loginType,formData).post(callBackSuccess,callBackFailure);}},{key:'checkValidUserInput',value:function checkValidUserInput(){var me=this;var userinput=this.state.plp_userinput;if(userinput.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){me.setState({userLoginAllowed:false});me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);}else{me.setState({submitButtonDisabled:false,serverMessage:me.rb("za_login.invalidinput.msg")});}// var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
// if(phoneRegx.test(userinput)){			
// 	if(userinput.length == 10){				
// 		me.setState({userLoginAllowed:false});
// 		me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
// 	}else{
// 		me.setState({submitButtonDisabled: false, serverMessage: me.rb("login.invalidinput.msg")});
// 	}
// }else{
// 	if(userinput.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){
// 		me.setState({userLoginAllowed:false});
// 		me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
// 	}else{
// 		me.setState({submitButtonDisabled: false, serverMessage: me.rb("login.invalidinput.msg")});
// 	}
// }
}},{key:'doLumosLogout',value:function doLumosLogout(){_get(UnifiedLogin.prototype.__proto__||Object.getPrototypeOf(UnifiedLogin.prototype),'doLumosLogout',this).call(this);}},{key:'doPLPLogout',value:function doPLPLogout(){var me=this;var callBackSuccess=function callBackSuccess(resp){me.UserStore.clearOldUser();//me.initiateTrack("logout",{});
// setTimeout(function(){
// 	me.UserStore.clearOldUser();
// 	window.location.href = me.getUrlFor("PRELOGIN_PAGE");
// },500);
};var callBackFailure=function callBackFailure(resp){console.error("Logout failed.");};_get(UnifiedLogin.prototype.__proto__||Object.getPrototypeOf(UnifiedLogin.prototype),'doPLPLogout',this).call(this,callBackSuccess,callBackFailure);}},{key:'handleSubmit',value:function handleSubmit(e){e.preventDefault();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){this.unifiedSubmitForm();// if(this.state.userLoginAllowed){
// 	this.submitForm();  
// }else{
// 	this.getUserStatus();
// }
}}},{key:'trackMe',value:function trackMe(result){var userObj=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var trackObj={"user_id":userObj==null?"":userObj.userId,"login_id":this.state.plp_userinput,"user_agent":navigator.userAgent,"platform":navigator.platform,"device":__WEBPACK_IMPORTED_MODULE_9_react_device_detect__["isMobile"]?"mobile":__WEBPACK_IMPORTED_MODULE_9_react_device_detect__["isTablet"]?"tablet":"PC","ip_address":"ip_address","result":result===true,"session_id":userObj==null?"":userObj.authToken};this.initiateTrack("login",trackObj);}},{key:'showCreateAccount',value:function showCreateAccount(){if(!this.tracked){this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"signin-signup"});this.tracked=true;}this.props.callbackCreateAccount(this.navigateUrl,this.props.freetrail);}},{key:'showforgotPwd',value:function showforgotPwd(){this.props.callbackForgotPwd(this.state.source);}},{key:'googleLogin',value:function googleLogin(){if(!this.tracked){this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"signin-googlesignin"});this.tracked=true;}var navigateObj={navigateURL:this.navigateUrl};__WEBPACK_IMPORTED_MODULE_10__util_BrowserStorageUtil__["a" /* default */].storeSessionItem(this.navigationKey,JSON.stringify(navigateObj));window.top.location.href=this.getUrlFor("GOOGLE_LOGIN_API");}},{key:'toggle_GSignin',value:function toggle_GSignin(e){var me=this;__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".socialLoginContainer").slideToggle("fast","swing",function(){if(__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".showmore-signin").text()==me.rb("unified_login.show_more")){__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".showmore-signin").css("color","#8b9095");__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".showmore-signin").text(me.rb("unified_login.Hide"));}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".showmore-signin").css("color","#01babd");__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".showmore-signin").text(me.rb("unified_login.show_more"));}});}},{key:'render',value:function render(){var _this2=this;if(this.state.loggedIn){return _get(UnifiedLogin.prototype.__proto__||Object.getPrototypeOf(UnifiedLogin.prototype),'render',this).call(this);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row nomargin loginParent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-4 nopadding loginLeftSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'loginLeftContent'},this.rb("unified_login.login")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'charactercontainer d-none d-sm-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'charactericons loginIcon',src:__WEBPACK_IMPORTED_MODULE_12__images_icons_loginicon_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'loginRoot',className:'plpLogin col-sm-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 mx-auto nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rounded-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this2.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'plp_userinput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'plp_userinput',className:"plp_userinput "+this.state.loginType,name:'plp_userinput',placeholder:this.rb("unifiedlogin.userplaceholder"),value:this.state.plp_userinput,onChange:this.userIdChange,required:true,minLength:1,maxLength:254,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'plp_userinput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("za_unifiedlogin.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),function(){// if(this.state.userLoginAllowed){
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'password'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'password',name:'password',placeholder:_this2.rb("login.password"),innerRef:function innerRef(password){return _this2.password=password;},value:_this2.state.password,onChange:_this2.handlePasswordChange,required:true,minLength:1,maxLength:50,tabIndex:'4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'password',show:'all'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},_this2.rb("login.pwdrequired")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':"Home - "+_this2.gaFrom+_this2.gasignin+" - Forgot Password",className:'text-right ufd-forgotPassword josefinsansFont',onClick:_this2.showforgotPwd},_this2.rb("forgot_password")));// }
}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages'},this.state.serverMessage),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-ga':"Home - "+this.gaFrom+this.gasignin+"  - Sign In",disabled:this.state.submitButtonDisabled,className:'submitButton'},this.rb("unified_login.login")))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 pt-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center josefin showmore-signin'},this.rb("za_unified_login.or")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'socialLoginContainer text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':"Home - "+this.gaFrom+this.gasignin+" - Continue with Google",className:'socialLoginButtons google',onClick:this.googleLogin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fab fa-google'}),this.rb("login.continuegoogle")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:''},this.rb("register.donthaveaccount")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'data-ga':"Home - "+this.gaFrom+this.gasignin+" - Sign Up",className:'text-center loginCreateNewAccount josefinsansFont pl-10 resendButton',onClick:this.showCreateAccount},this.rb("unified_login.createnewaccount")))));}}}]);return UnifiedLogin;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (UnifiedLogin);

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_icons_signupicon_png__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_icons_signupicon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_icons_signupicon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_icons_freetrailicon_png__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_icons_freetrailicon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_icons_freetrailicon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_reactstrap__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__login_SelectDropdown__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__login_RadioButtons__ = __webpack_require__(301);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SignupForm=function(_PreLoginPage){_inherits(SignupForm,_PreLoginPage);function SignupForm(props){_classCallCheck(this,SignupForm);var _this=_possibleConstructorReturn(this,(SignupForm.__proto__||Object.getPrototypeOf(SignupForm)).call(this,props));_this.hmNav=function(userObj){if(userObj&&userObj.userRole&&userObj.userRole.role&&userObj.userRole.role.toUpperCase()==="TCHR"){window.top.location.href="/sg/products";}else{window.top.location.href=this.props.navigateURL;}//this.props.myProps.history.push(this.props.navigateURL);
};_this.setClassesForTCHR=function(evt){if(evt&&evt.length>0){this.classesTeaching=this.rb("dropdown.classes.tchr.prefix");for(var i=0;i<evt.length;i++){if(evt[i]&&evt[i].label&&evt[i].label.length>0){var evtArr=evt[i].label.split(" ");this.classesTeaching+=evtArr[evtArr.length-1]+",";}}this.classesTeaching=this.classesTeaching.substr(0,this.classesTeaching.length-1);//console.log("lalalalla:::", this.classesTeaching);
}};_this.submitForm=function(){var verificationtype=this.state.loginType;var formData={"userName":this.state.username_newacc,"loginId":this.state.userInput,"userRole":{"role":this.state.selectedRole||"STU","level":"1"},"token":this.state.otp_newacc,"countryCode":null,"password":this.state.password_newacc,"verificationType":verificationtype,"regnProvider":"heymath","schoolName":this.state.schoolname_newacc,//Shyam
"location":this.state.address_newacc,"classesTeaching":this.classesTeaching,"userOrigin":this.userReferal};if(this.state.loginType=="mobile"){formData["phone"]=this.state.userInput;}else{formData["email"]=this.state.userInput;}var me=this;me.setState({submitButtonDisabled:true});var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status.toLowerCase()=="success"){new __WEBPACK_IMPORTED_MODULE_7__util_UserStore__["a" /* default */]().store(response.user);//me.props.successRegisterMsg(me.rb("register.success.msg"));
try{me.doLumosLogout();}catch(e){}me.trackMe(true,"set_password");var afterUpdate=function afterUpdate(){me.hmNav(response.user);};me.updateUserType(afterUpdate);}else{if(response.status=="user_exists"){me.setState({serverMessage:"User already exists",submitButtonDisabled:false});}else if(response.status=="no_such_token"){me.setState({serverMessage:"The OTP entered is incorrect",submitButtonDisabled:false});}else if(response.status=="error"){me.setState({serverMessage:"Internal error occured",submitButtonDisabled:false});}else if(response.status=="empty_inputs"){me.setState({serverMessage:"Please enter all the fields",submitButtonDisabled:false});}else if(response.status=="token_not_verified"){me.setState({serverMessage:"Passcode Verification is required",submitButtonDisabled:false});}else if(response.status=="provider_forbidden"){me.setState({serverMessage:"Already registered with Gmail ID. Please click continue with Google",submitButtonDisabled:false});}else{me.setState({serverMessage:response.status,submitButtonDisabled:false});}me.trackMe(false,"set_password");}}console.log("response : ",response);};var callBackFailure=function callBackFailure(response){console.log("Error in CREATE_REGISTER");me.setState({submitButtonDisabled:false});me.showAlert("","Error in CREATE_REGISTER");me.trackMe(false,"set_password");};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("CREATE_REGISTER"),formData).post(callBackSuccess,callBackFailure);new __WEBPACK_IMPORTED_MODULE_7__util_UserStore__["a" /* default */]().clearOldUser();};_this.state={username_newacc:'',password_newacc:'',confirmpassword_newacc:'',singupType:"userid",loginType:_this.props.loginType||"userid",userInput:_this.props.userInput||"",otp_newacc:'',submitButtonDisabled:false,serverMessage:"",emailfeedbackmsg:"",source:"plp",isOTPSend:false,isVerified:false,OTPDisabled:"hiddenOTP",verifyDisabled:"disabled",emailDisabled:false,phoneDisabled:false,verifyText:_this.rb("register.verify"),sendOTPText:_this.rb("register.sendOTP"),passcodeDisabled:"disabled",selectedRole:"STU"};_this.classesTeaching=null;//this.selectedRole = null;
_this.userReferal=null;_this.navigationKey="PLP_Navigation";_this.handleChange=_this.handleChange.bind(_this);_this.enterOTPChange=_this.enterOTPChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.userIdChange=_this.userIdChange.bind(_this);_this.googleLogin=_this.googleLogin.bind(_this);_this.sendOTP=_this.sendOTP.bind(_this);_this.verifyOTP=_this.verifyOTP.bind(_this);_this.getOTPField=_this.getOTPField.bind(_this);_this.handleKeyUp=_this.handleKeyUp.bind(_this);_this.radioSelected=_this.radioSelected.bind(_this);_this.setCentaReference=_this.setCentaReference.bind(_this);_this.setUserOrigin=_this.setUserOrigin.bind(_this);_this.setClassesForTCHR=_this.setClassesForTCHR.bind(_this);_this.googleLogin=_this.googleLogin.bind(_this);_this.isFreeTrialAllowed=_this.isFreeTrialAllowed.bind(_this);_this.myTrackerInstance=_this.getTracker();_this.gaFrom=_this.props.gaFrom;console.log("this.gaFrom:::::::::::",_this.gaFrom);if(_this.gaFrom=="Top"||_this.gaFrom=="Bottom"){_this.gaFrom=_this.gaFrom+" Home - Join";}else{_this.gaFrom="Users who have independently registered - Sign Up";}console.log("this.gaFrom2222:::::::::::",_this.gaFrom);return _this;}_createClass(SignupForm,[{key:'isFreeTrialAllowed',value:function isFreeTrialAllowed(val){var userRole=val||null;if(userRole&&userRole.length>1&&window.noFreeTrialRoles&&window.noFreeTrialRoles.length>0){return!~window.noFreeTrialRoles.indexOf(userRole);}//user not logged in or role not defined latter is unlikely or no suppression in window.noFreeTrialRoles
return true;}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var me=this;this.gaFrom=nextProps.gaFrom;console.log("this.gaFrom:::::::::::",this.gaFrom);if(this.gaFrom=="Top"||this.gaFrom=="Bottom"){this.gaFrom=this.gaFrom+" Home - Join";}else{this.gaFrom="Users who have independently registered - Sign Up";}console.log("this.gaFrom:::::::::::",this.gaFrom);console.log('componentWillReceiveProps',nextProps);this.setState({loginType:nextProps.loginType||"userid",userInput:nextProps.userInput||"",otp_newacc:'',submitButtonDisabled:false,serverMessage:"",emailfeedbackmsg:"",source:"plp",isOTPSend:false,isVerified:false,OTPDisabled:"hiddenOTP",verifyDisabled:"disabled",emailDisabled:false,phoneDisabled:false,verifyText:this.rb("register.verify"),sendOTPText:this.rb("register.sendOTP"),passcodeDisabled:"disabled"});setTimeout(function(){me.reinitiate();},500);}},{key:'componentDidMount',value:function componentDidMount(){var me=this;this.sessionCheck();setTimeout(function(){me.reinitiate();},200);}},{key:'reinitiate',value:function reinitiate(){console.log("reinitiate gaFrom:::::::::::",this.gaFrom);if(this.state.userInput!=""){this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){this.setState({OTPDisabled:""});__WEBPACK_IMPORTED_MODULE_8_jquery___default()(".OTPButton").trigger("click");}}__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#loginRoot .userInput").focus();}},{key:'handleChange',value:function handleChange(e){var _setState;var target=e.currentTarget;//console.log("target=",target);
this.form.validateFields(target);this.setState((_setState={},_defineProperty(_setState,target.name,target.value),_defineProperty(_setState,'serverMessage',""),_defineProperty(_setState,'submitButtonDisabled',!this.form.isValid()),_setState));}},{key:'userIdChange',value:function userIdChange(e){var _setState2;var target=e.currentTarget;this.form.validateFields(target);// var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
// if(phoneRegx.test(target.value)){
// 	this.setState({loginType:"mobile",loginMaxLength:10,OTPDisabled: "hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});
// 	if(target.value.length >= 10){				
// 		this.setState({ OTPDisabled: "",passcodeDisabled:""});
// 	}
// }else{
// 	this.setState({loginType:"email",loginMaxLength:254,OTPDisabled: "hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});
// 	if(target.value.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){
// 		this.setState({ OTPDisabled: "",passcodeDisabled:""});
// 	}
// }
this.setState({loginType:"email",loginMaxLength:254,OTPDisabled:"hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});if(target.value.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){this.setState({OTPDisabled:"",passcodeDisabled:""});}this.setState((_setState2={},_defineProperty(_setState2,target.name,target.value),_defineProperty(_setState2,'serverMessage',""),_defineProperty(_setState2,'submitButtonDisabled',true),_setState2));}},{key:'enterOTPChange',value:function enterOTPChange(e){if(this.otp.value.length>0){this.setState({verifyDisabled:""});}else{this.setState({verifyDisabled:"disabled"});}this.handleChange(e);}//Shyam
},{key:'setUserOrigin',value:function setUserOrigin(referal){this.userReferal=referal;}},{key:'setCentaReference',value:function setCentaReference(evt){if(evt&&evt.currentTarget&&evt.currentTarget.value){if(evt.currentTarget.value.length>0&&evt.currentTarget.value.toLowerCase()==="yes"){this.setUserOrigin("centa");}}}},{key:'updateUserType',value:function updateUserType(commonCallback){var me=this;var callBackSuccess=function callBackSuccess(response){if(response!==null){//console.warn("user type",response)
me.getUser().store(response);}if(typeof commonCallback==="function"){commonCallback.apply(this);}};var callBackFailure=function callBackFailure(response){//console.warn("failure ",response);
if(typeof commonCallback==="function"){commonCallback.apply(this);}};_get(SignupForm.prototype.__proto__||Object.getPrototypeOf(SignupForm.prototype),'updateUserType',this).call(this,callBackSuccess,callBackFailure);}},{key:'trackMe',value:function trackMe(result,source){var trackObj={"name":this.state.username_newacc,"email":this.state.loginType=="mobile"?"":this.state.userInput,"phone":this.state.loginType=="mobile"?this.state.userInput:"","event_source":this.getTracker().enums.signupEventSource[source],"result":result};if(source=="set_password"){this.storeTrackEvent("signup",trackObj);}else{this.initiateTrack("signup",trackObj);}}},{key:'handleSubmit',value:function handleSubmit(e){e.preventDefault();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){if(this.state.isOTPSend&&this.state.isVerified){this.submitForm();}}}},{key:'sendOTP',value:function sendOTP(){if(this.state.OTPDisabled=="hiddenOTP"){this.form.validateFields();return;}var me=this;var otpServerMsg="";if(this.state.loginType=="mobile"){if(me.state.isOTPSend){otpServerMsg="OTP is sent again to mobile";}else{otpServerMsg="OTP is sent to your mobile";}}else{if(me.state.isOTPSend){otpServerMsg="OTP is sent again to your email";}else{otpServerMsg="OTP is sent to your email";}}me.setState({serverMessage:"",emailfeedbackmsg:"",isOTPSend:false,isVerified:false,verifyDisabled:"disabled",otp_newacc:"",passcodeDisabled:"disabled"});var formData={"contactId":this.state.userInput,"contactType":this.state.loginType};var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status){if(response.status=="user_exists"){me.setState({serverMessage:"User already exists",passcodeDisabled:""});}else if(response.status=="no_such_token"){me.setState({serverMessage:"The OTP entered is incorrect",passcodeDisabled:""});}else if(response.status=="error"){me.setState({serverMessage:"Internal error occured",passcodeDisabled:""});}else{me.setState({emailfeedbackmsg:otpServerMsg,passcodeDisabled:""});}}if(response.status=="success"){me.setState({isOTPSend:true,passcodeDisabled:"disabled"});me.trackMe(true,"send_otp");}else{me.trackMe(false,"send_otp");}}console.log("response : ",response);};var callBackFailure=function callBackFailure(response){console.log("Error in CREATE_SENDVERIFICATION_TOKEN");me.setState({passcodeDisabled:""});me.trackMe(false,"send_otp");};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("CREATE_SENDVERIFICATION_TOKEN"),formData).post(callBackSuccess,callBackFailure);}},{key:'verifyOTP',value:function verifyOTP(){var me=this;me.setState({serverMessage:""});var verificationtype=this.state.loginType;var formData={"verificationId":this.state.userInput};this.setState({verifyDisabled:"disabled"});var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status){if(response.status=="user_exists"){me.setState({serverMessage:"User already exists",verifyDisabled:""});me.trackMe(false,"verify_otp");}else if(response.status=="no_such_token"){me.setState({serverMessage:"The OTP entered is incorrect",verifyDisabled:""});me.trackMe(false,"verify_otp");}else if(response.status=="error"){me.setState({serverMessage:"Internal error occured",verifyDisabled:""});me.trackMe(false,"verify_otp");}else{me.setState({isVerified:true,verifyDisabled:""});me.trackMe(true,"verify_otp");}}}console.log("response : ",response);};var callBackFailure=function callBackFailure(response){console.log("Error in CREATE_SENDVERIFICATION_TOKEN");me.setState({verifyDisabled:""});me.trackMe(false,"verify_otp");};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("CREATE_VERIFY_EMAIL")+verificationtype+"/"+this.state.otp_newacc,formData).post(callBackSuccess,callBackFailure);}},{key:'getOTPField',value:function getOTPField(){var _this2=this;if(this.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'otp_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'otp_newacc',className:'otp_newacc',name:'otp_newacc',placeholder:this.rb("register.enterOTP"),innerRef:function innerRef(otp){return _this2.otp=otp;},onKeyUp:this.handleKeyUp,value:this.state.otp_newacc,onChange:this.enterOTPChange,required:true,minLength:1,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'otp_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("register.enterOTP")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'})));}}},{key:'getVerifyField',value:function getVerifyField(){if(this.state.isOTPSend&&!this.state.isVerified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':"Home - "+this.gaFrom+" - New User - Verify",className:"submitButton verifyButton "+this.state.verifyDisabled,onClick:this.verifyOTP},this.rb("register.verify"));}/*else if(this.state.isOTPSend && this.state.isVerified){
			return (<div className="text-right verifytxt"><i class="material-icons">done</i> <span>{this.rb("register.verified")}</span></div>);
		}*/}},{key:'getSignupHeaderMsg',value:function getSignupHeaderMsg(){if(this.state.isOTPSend&&!this.state.isVerified){if(this.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Please verify your number')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10'},'A 6-digit OTP has been sent to your mobile number for verification'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Please verify your Email')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10'},'A 6-digit OTP has been sent to your Email for verification'));}}else if(this.state.isVerified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Congratulations')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10'},'You are almost set. Enter your Name and set password to start learning.'));}}},{key:'sendOTPText',value:function sendOTPText(){if(this.state.isOTPSend){return this.rb("register.reSendOTP");}else{return this.rb("register.sendOTP");}}},{key:'showEmailFeedback',value:function showEmailFeedback(){var _this3=this;if(this.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-control-feedback'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error'},this.state.emailfeedbackmsg),function(){if(_this3.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedbacksmall'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'All important information will be sent to this mobile number'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedbacksmall'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'All important information will be sent to this email ID'));}}());}}},{key:'getUserInputPattern',value:function getUserInputPattern(){if(this.state.loginType=="mobile"){return".{10,}";}else{return"^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$";}}},{key:'radioSelected',value:function radioSelected(evt){var val=evt.currentTarget.value;if(val&&val.length>0){//this.selectedRole = val;
this.setState({selectedRole:val});/*alert(val);*/}return true;}},{key:'getContactType',value:function getContactType(){var _this4=this;if(!this.state.isVerified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,function(){var user=_this4.props.signupUser||'student';if(user==='student'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'col-md-12 mt-30 signup-radio'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 radio-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-check-input',type:'radio',name:'student',value:'STU',id:'student_select',onChange:_this4.radioSelected,defaultChecked:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-check-label',htmlFor:'student_select'},'Student/Parent')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 radio-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-check-input',type:'radio',name:'student',value:'TCHR',id:'teacher_select',onChange:_this4.radioSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-check-label',htmlFor:'teacher_select'},'Teacher')));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'userInput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'userInput',className:"userInput "+this.state.loginType,name:'userInput',placeholder:this.rb("login.userplaceholder.za"),innerRef:function innerRef(email){return _this4.email=email;},onKeyUp:this.handleKeyUp,value:this.state.userInput,onChange:this.userIdChange,pattern:this.getUserInputPattern(),required:true,minLength:1,maxLength:this.state.loginMaxLength,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'2'}),function(){if(_this4.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'userInput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},_this4.rb("za_login.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},_this4.rb("register.mobilenolength")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length>0&&!/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g.test(value);}},_this4.rb("register.numbersonly")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'userInput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},_this4.rb("za_login.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},_this4.rb("fpwd.validemail")));}}()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),this.getOTPField(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages pt-20'},this.state.serverMessage),function(){if(_this4.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this4.rb("register.reSendOTPmsg"),' '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'data-ga':"Home - "+_this4.gaFrom+" - New User - Resend",className:'pl-10 resendButton',onClick:_this4.sendOTP},_this4.rb("register.reSendOTP"))),_this4.getVerifyField());}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this4.getVerifyField(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':"Home - "+_this4.gaFrom+" - New User - Send Passcode",className:"submitButton OTPButton "+_this4.state.OTPDisabled+" "+_this4.state.passcodeDisabled,onClick:_this4.sendOTP},_this4.rb("register.sendOTP"))));}}());}}},{key:'getStep2TeachersForm',value:function getStep2TeachersForm(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'username_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'username_newacc',className:'username_newacc',name:'username_newacc',placeholder:this.rb("billing.fullname"),value:this.state.username_newacc,onChange:this.handleChange,required:true,minLength:1,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'username_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.namerequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'schoolname_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'schoolname_newacc',className:'schoolname_newacc',name:'schoolname_newacc',placeholder:this.rb("billing.schoolname"),value:this.state.schoolname_newacc,onChange:this.handleChange,required:true,minLength:1,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'schoolname_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.schoolrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'address_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'address_newacc',className:'address_newacc',name:'address_newacc',placeholder:this.rb("billing.location"),value:this.state.address_newacc,onChange:this.handleChange,required:true,minLength:1,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'address_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.addressrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'password_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'password_newacc',name:'password_newacc',placeholder:this.rb("login.password"),innerRef:function innerRef(password){return _this5.password=password;},value:this.state.password_newacc,onChange:this.handleChange,required:true,minLength:6,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'password_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("login.pwdrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("validate.pwd.minimum",[6])))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'confirmpassword'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'confirmpassword_newacc',name:'confirmpassword_newacc',placeholder:this.rb("rpwd.confirmpwd"),innerRef:function innerRef(confirmpassword){return _this5.confirmpassword=confirmpassword;},value:this.state.confirmpassword_newacc,onChange:this.handleChange,required:true,minLength:6,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'confirmpassword_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("rpwd.confirmpwdrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("validate.pwd.minimum",[6])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value!==_this5.password.value;}},this.rb("rpwd.doesnotmatch")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages pt-20'},this.state.serverMessage));}},{key:'getStep2StudentsForm',value:function getStep2StudentsForm(){var _this6=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'username_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'username_newacc',className:'username_newacc',name:'username_newacc',placeholder:this.rb("billing.fullname"),value:this.state.username_newacc,onChange:this.handleChange,required:true,minLength:1,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'username_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.namerequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'password_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'password_newacc',name:'password_newacc',placeholder:this.rb("login.password"),innerRef:function innerRef(password){return _this6.password=password;},value:this.state.password_newacc,onChange:this.handleChange,required:true,minLength:6,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'password_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("login.pwdrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("validate.pwd.minimum",[6])))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'confirmpassword'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'confirmpassword_newacc',name:'confirmpassword_newacc',placeholder:this.rb("rpwd.confirmpwd"),innerRef:function innerRef(confirmpassword){return _this6.confirmpassword=confirmpassword;},value:this.state.confirmpassword_newacc,onChange:this.handleChange,required:true,minLength:6,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'confirmpassword_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("rpwd.confirmpwdrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("validate.pwd.minimum",[6])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value!==_this6.password.value;}},this.rb("rpwd.doesnotmatch")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages pt-20'},this.state.serverMessage));}},{key:'setPassword',value:function setPassword(){if(this.state.isVerified){if(this.state.selectedRole==="TCHR"){return this.getStep2TeachersForm();}else{return this.getStep2StudentsForm();}}}},{key:'googleLogin',value:function googleLogin(){var navigateObj={navigateURL:this.props.navigateURL};__WEBPACK_IMPORTED_MODULE_3__util_BrowserStorageUtil__["a" /* default */].storeSessionItem(this.navigationKey,JSON.stringify(navigateObj));if(!this.tracked){this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"signin-googlesignin"});this.tracked=true;}window.top.location.href=this.getUrlFor("GOOGLE_LOGIN_API");}},{key:'handleKeyUp',value:function handleKeyUp(event){if(event.key==='Enter'&&this.form.isValid()){if(!this.state.isVerified){if(this.state.isOTPSend&&this.state.verifyDisabled!="disabled"){__WEBPACK_IMPORTED_MODULE_8_jquery___default()(".verifyButton").trigger("click");}else if(this.state.passcodeDisabled!="disabled"){this.setState({OTPDisabled:""});__WEBPACK_IMPORTED_MODULE_8_jquery___default()(".OTPButton").trigger("click");}}}}},{key:'GoogleLoginShow',value:function GoogleLoginShow(){if(this.state.isOTPSend==false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loginTop pt-15'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center josefin mt-20'},'OR'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'socialLoginContainer text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':"Home - Users who have independently registered - Sign Up - New User - Sign in with Google - Start Learning",className:'socialLoginButtons google',onClick:this.googleLogin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fab fa-google'}),this.rb("login.google"))));}}},{key:'render',value:function render(){var _this7=this;if(this.state.loggedIn){return _get(SignupForm.prototype.__proto__||Object.getPrototypeOf(SignupForm.prototype),'render',this).call(this);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row nomargin loginParent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-4 col-lg-4 nopadding loginLeftSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'loginLeftContent'},this.rb("unified_login.joinincaptital")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'charactercontainer d-none d-sm-block'},function(){if(_this7.state.selectedRole&&_this7.isFreeTrialAllowed(_this7.state.selectedRole)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,function(){if(window.free_trial_extension&&window.free_trial_extension.toggle==='days'&&window.free_trial_extension.days===30){if(_this7.props.navigateURL!="/product-details"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'charactericons freetrailIcon',src:__WEBPACK_IMPORTED_MODULE_10__images_icons_freetrailicon_png___default.a});}else if(_this7.props.freetrail=="true"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'charactericons freetrailIcon',src:__WEBPACK_IMPORTED_MODULE_10__images_icons_freetrailicon_png___default.a});}}}());}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'charactericons signupIcon',src:__WEBPACK_IMPORTED_MODULE_9__images_icons_signupicon_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'loginRoot',className:'plpLogin col-sm-8 col-lg-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rounded-0'},this.getSignupHeaderMsg(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this7.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},this.getContactType(),this.setPassword(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-ga':"Home - Users who have independently registered - Sign Up - New User - Start Learning",disabled:this.state.submitButtonDisabled,className:"submitButton signup signupButton "+(this.state.isVerified?"":"hidden")},this.rb("register.startlearning")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),this.GoogleLoginShow())))))))));}}}]);return SignupForm;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (SignupForm);

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_UserStorageUtil__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_NativeAjax__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_plp_TestTakingModalComponent__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Errmsg__ = __webpack_require__(290);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*import LoggedInPage from '../../views/core/LoggedInPage';*/var MozartView=function(_PreLoginPage){_inherits(MozartView,_PreLoginPage);function MozartView(props){_classCallCheck(this,MozartView);var _this=_possibleConstructorReturn(this,(MozartView.__proto__||Object.getPrototypeOf(MozartView)).call(this,props));_this.trackId=null;_this.userId=null;_this.trackLessonClose=_this.trackLessonClose.bind(_this);_this.enableTimer=true;_this.state={lessonLoaded:false};_this.lessonUrlBase=_this.getUrlFor("MOZART_LESSON_URL");_this.lessonId=_this.props.match.params.lid;_this.substituteZAProxy=_this.substituteZAProxy.bind(_this);_this.errorText="error";// Default Error Text message
_this.lessonUrl=_this.lessonUrlBase.replace("#lessonId",_this.lessonId);window.pageId=_this.lessonId;window.pageXML_request=_this.lessonUrlBase;window.selectedPageid=_this.lessonId;return _this;}_createClass(MozartView,[{key:'substituteZAProxy',value:function substituteZAProxy(lessonUrl){if(lessonUrl&&lessonUrl.length>0){lessonUrl=lessonUrl.replace(this.getUrlFor("ORIG_CS_BASE_URL"),this.getUrlFor("CS_BASE_URL"));//for audio
lessonUrl=lessonUrl.replace(this.getUrlFor("ORIG_CS_BASE_URL"),this.getUrlFor("CS_BASE_URL"));}return lessonUrl;}},{key:'componentDidMount',value:function componentDidMount(){var me=this;var success=function success(pageXML){if(pageXML&&!pageXML.error&&pageXML.xmlResponse){if(!me.checkError(pageXML.xmlResponse)){me.setState({lessonLoaded:true});//substitute proxy URL
pageXML.xmlResponse=me.substituteZAProxy(pageXML.xmlResponse);me.loadMozart(pageXML.xmlResponse);}else{}//pageXML = "<page>  <page_id>chep10063_sa101</page_id>  <name>Diffusion and Brownian Motion</name><content_type>animated_unit</content_type>  <group label='Slider'><video_url>http://local.heyscience.com:3000/stub/mozarts/chep10063_sa101.swf</video_url><type>slider</type><audio_url>http://local.heyscience.com:3000/stub/mozarts/chep10063_sa101_audio_en.swf</audio_url></group></page>";
}};var failure=function failure(resp){console.error("Error Occurred ::",resp);if(resp&&resp.status=="404"){me.errorText="resource.404.message";}else if(resp&&resp.status=="403"){me.errorText="resource.403.message";}else{me.errorText="503.title";}me.showError();};var lessonUrl=me.lessonUrl.replace("#lessonId",me.lessonId);new __WEBPACK_IMPORTED_MODULE_3__util_NativeAjax__["a" /* default */](lessonUrl).enableCORS().get(success,failure);}},{key:'showError',value:function showError(){this.showAlert(this.rb("error"),this.rb(this.errorText));}},{key:'checkError',value:function checkError(xmlResponse){var me=this;var error=true;try{var video_url=xmlResponse&&__WEBPACK_IMPORTED_MODULE_5_jquery___default()(xmlResponse).find("video_url")?__WEBPACK_IMPORTED_MODULE_5_jquery___default()(xmlResponse).find("video_url").text():"";if(video_url&&video_url.length>0){error=false;}else{if(__WEBPACK_IMPORTED_MODULE_5_jquery___default()(xmlResponse).find("error")){console.error(__WEBPACK_IMPORTED_MODULE_5_jquery___default()(xmlResponse));if(xmlResponse&&xmlResponse.indexOf("404")>0){me.errorText="resource.404.message";}else if(xmlResponse&&xmlResponse.indexOf("403")>0){me.errorText="resource.403.message";}me.showError();}}}catch(e){console.error(e);}return error;}},{key:'initiateTimer',value:function initiateTimer(){var me=this;setInterval(function(){if(me.enableTimer){//console.log("initiateTimer ::");
me.trackLessonClose();}},5000);}},{key:'loadMozart',value:function loadMozart(pageXML){var me=this;__WEBPACK_IMPORTED_MODULE_5_jquery___default.a.ajax({url:window.mozartTemplateLocation||"/mozart/HeyScience.html",dataType:"text",cache:false,success:function success(data){//window.removeLoading();
// for tracking
/*if($.trim(lessonName)=="") {
					selectedLessonId = search_sellessonid;
					selectedLessonName = search_sellessonname;
					selectedCategory = search_selCategory;
				}
				else
				{			
					selectedLessonId = $(myPageList).attr("ID");
					if(selectedLessonId == undefined || selectedLessonId == null)
					{
						selectedLessonId = "null";
						selectedLessonName = "null";
						selectedCategory = selectedcategory;
					}else{
						selectedLessonName = $(myPageList).attr("label");
						selectedCategory = "Lesson";
					}	
				}*/var playerContainer=__WEBPACK_IMPORTED_MODULE_5_jquery___default()("#playerHTML");__WEBPACK_IMPORTED_MODULE_5_jquery___default()(playerContainer).css({top:0,width:"100%",height:"100%",position:"absolute",zIndex:10001});__WEBPACK_IMPORTED_MODULE_5_jquery___default()(playerContainer).html(data);//$("body").append(playerContainer);
if(typeof window.loadPlayer==="function"){window.loadPlayer(pageXML);var bridgeLoadAttempt=0;setTimeout(function(){var bridgeLoader=setInterval(function(){if(window.isPlayerLoaded||bridgeLoadAttempt>10){console.log("Interval Cleared");//new HmAjax(this.getUrlFor("TRACK_LESSON_CLOSE") + me.trackId + "/" + me.userId).get(successHandler, failureHandler);
clearInterval(bridgeLoader);me.trackLessonOpen();me.initiateTimer();}else{console.log("waiting to load....");window.bridgeLoaded();//new HmAjax(this.getUrlFor("TRACK_LESSON_OPEN"), formData).post(successHandler, failureHandler);
}bridgeLoadAttempt++;},200);},500);//SP added
if(window.isPlayerLoaded){me.trackLessonOpen();me.initiateTimer();}//setTimeout(function(){if(!window.isPlayerLoaded) {window.bridgeLoaded();}},2000);
}/*let pageName = window.pageName;
				let lessonName = window.lessonName;
				
				///eval("loadPlayer(pageXML)");
				//var headerString = lessonName+" - "+pageName;
				var headerString = pageName;
				if(window.$.trim(lessonName)=="") {
					headerString = pageName;
				}
				window.setPlayerHeader(headerString);

				if(window.myPageList!=null) {
					window.setLeftPanel(window.$(window.myPageList),lessonName);
				}
				*///$("#playerHTML").jScrollPane({autoReinitialise: true});
},error:function error(){//removeLoading();
}});this.userId=this.getUser().getUserId();}},{key:'trackLessonClose',value:function trackLessonClose(){alert('tracking lesson closes....');try{var me=this;var successHandler=function successHandler(data){console.log("track lesson close success");};var failureHandler=function failureHandler(err){console.log("Error in TRACK_LESSON_CLOSE");return;};new __WEBPACK_IMPORTED_MODULE_4__util_HmAjax__["a" /* default */](this.getUrlFor("TRACK_LESSON_CLOSE")+me.trackId+"/"+me.userId).get(successHandler,failureHandler);}catch(e){console.log("Error in track lessson close..");}}},{key:'getAllParamsObj',value:function getAllParamsObj(){var paramObj={};try{var paramsArr=window.location.href.split("?");if(paramsArr.length>1&&paramsArr[1].length>0){paramObj=this.extractParamsObj(paramsArr[1]);}}catch(e){}return paramObj;}},{key:'getAllUrlParams',value:function getAllUrlParams(urlString){try{var paramsArr=window.location.href.split("?");if(paramsArr.length>1&&paramsArr[1].length>0){if(urlString.indexOf("?")>0){urlString+="&"+paramsArr[1];}else{urlString+="?"+paramsArr[1];}}}catch(e){}return urlString;}},{key:'extractParamsObj',value:function extractParamsObj(paramsArrStr){var paramObj={};try{if(paramsArrStr!==null&&paramsArrStr.length>0){var paramPairArr=paramsArrStr.split("&");if(paramPairArr!==null&&paramPairArr.length>0){for(var i=0;i<paramPairArr.length;i++){var eachPair=paramPairArr[i].split("=");paramObj[eachPair[0]]=eachPair.length>0?eachPair[1]:eachPair[0];}}}}catch(e){}return paramObj;}},{key:'trackLessonOpen',value:function trackLessonOpen(){alert('tracking lesson open....');var params=this.getAllParamsObj();/*lessonPref:"html5"
		lessonname:"Subtracting%207-Digit%20Numbers"
		revisiontopicid:"0"
		src:"plp"
		testid:"0"
		url:"vl1283a_subtract7digit"*/var formData={"lessonUrl":params.url,"lessonDd":params.dd,"lessonType":params.lessonPref,"classId":parseInt(params.classId),"accessId":parseInt(params.accessId),"topicSubtopicMapId":parseInt(params.revisiontopicid)};try{var me=this;var successHandler=function successHandler(data){if(data!=null){console.log("open: "+me.trackId+"...."+data.trackId);me.trackId=data.trackId;return;}};var failureHandler=function failureHandler(err){console.log("Error in TRACK_LESSON_OPEN");return;};var lessonId=this.props.match.params.id;new __WEBPACK_IMPORTED_MODULE_4__util_HmAjax__["a" /* default */](this.getUrlFor("TRACK_LESSON_OPEN"),formData).post(successHandler,failureHandler);}catch(e){console.log("Error in lesson tracking...");}try{var trackObj={"lesson_id":parseInt(params.lessonidTracking),"lesson_dd":parseInt(params.dd)||1,"source":this.getTracker().enums.lessonSource[params.tracksource],"source_id":parseInt(params[params.tracksource=="subtopic"?"revisiontopicid":"testid"]),"snippet_id":parseInt(params.snid)||0,"question_source":params.qsrc||0};this.initiateTrack("lesson_opened",trackObj);}catch(e){}}},{key:'render',value:function render(){if(this.state.lessonLoaded){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'playerHTML'});}else{return _get(MozartView.prototype.__proto__||Object.getPrototypeOf(MozartView.prototype),'render',this).call(this);}}}]);return MozartView;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (MozartView);

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_PreLoginPage__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TestComplete=function(_PreLoginPage){_inherits(TestComplete,_PreLoginPage);function TestComplete(){_classCallCheck(this,TestComplete);return _possibleConstructorReturn(this,(TestComplete.__proto__||Object.getPrototypeOf(TestComplete)).apply(this,arguments));}_createClass(TestComplete,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'errorContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'errorback text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fff'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'temp_test_complete'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'f40 fwb'},'Test Complete! This is a temporary page.')))));}}]);return TestComplete;}(__WEBPACK_IMPORTED_MODULE_1__core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (TestComplete);

/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_UrlManager__ = __webpack_require__(104);
var CouponTracker=function CouponTracker(obj){var URL=__WEBPACK_IMPORTED_MODULE_2__model_UrlManager__["a" /* default */].getUrlForAction("COUPON_TRACKING");var trackId=obj&&!isNaN(obj.trackId)?obj.trackId:0;var isPostDataValid=function(){return URL&&URL.length>0;}();var isPutDataValid=function(){return URL&&URL.length>0&&trackId>0;}();this.post=function(success,failure){if(isPostDataValid){delete obj["trackId"];//to be generated by system only
new __WEBPACK_IMPORTED_MODULE_1__util_HmAjax__["a" /* default */](URL,obj).post(success,failure);}else{console.warn("Create data invalid",obj);}};this.put=function(success,failure){if(isPutDataValid){new __WEBPACK_IMPORTED_MODULE_1__util_HmAjax__["a" /* default */](URL+"/"+trackId,obj).put(success,failure);}else{console.warn("Update data invalid",obj);}};};/* unused harmony default export */ var _unused_webpack_default_export = (CouponTracker);__WEBPACK_IMPORTED_MODULE_0__model_HmEventRegistry__["a" /* default */].registerEvent("COUPON_TRACK_CREATE",function(obj,success,failure){new CouponTracker(obj).post(success,failure);});__WEBPACK_IMPORTED_MODULE_0__model_HmEventRegistry__["a" /* default */].registerEvent("COUPON_TRACK_UPDATE",function(obj,success,failure){new CouponTracker(obj).put(success,failure);});

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prelogin_src_PreloginHome__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_BrowserUtil__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_UserStorageUtil__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_AppConstants_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__prelogin_src_components_ScrollToTopOnMount_js__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__za_Banner_js__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__za_EventDetails__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__za_RecognisedStatic__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__za_LessonFeatures_js__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__za_OurTeachers__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__za_StaticFeed__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__za_SignupSection_js__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__za_UnifiedForgotPwd__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__za_Footer_js__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__za_UnifiedLogin__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__za_SignupForm__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__model_ComponentRegistry_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_plp_Home__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_dashboard_Dashboard__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_scorecard_Scorecard__ = __webpack_require__(151);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var za_PreloginHome=function(_PreloginHome){_inherits(za_PreloginHome,_PreloginHome);function za_PreloginHome(props){_classCallCheck(this,za_PreloginHome);var _this=_possibleConstructorReturn(this,(za_PreloginHome.__proto__||Object.getPrototypeOf(za_PreloginHome)).call(this,props));_this.getFaceBookEvent=function(){if(window.facebookEventAvailForZA){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__za_EventDetails__["a" /* default */],null);}};_this.Home=function(){if(!_this.tracked){_this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"home-PageView"});_this.tracked=true;}try{if(_this.state.LumosloggedIn){window.location.href=_this.getUrlFor("LUMOS_REDIRECT_URL");}else if(_this.state.PLPloggedIn&&!window.location.href.match("/home")){window.location.href="/landing";}}catch(e){}_this.selectedMenu="menuhome";var me=_this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,me.setTitle("HOME_title"),me.setMeta("HOME_meta"),me.setHeading("HOME_heading"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'bannerElement'},_this.getBannerContent()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__prelogin_src_components_ScrollToTopOnMount_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__za_Banner_js__["a" /* default */],{products_category_order:_this.getProductsTypeOrder(),products_category:_this.getProductsType(),classes:_this.getClasses(),grades:_this.getGrades(),products_class:_this.getProductsClass(),PLPloggedIn:_this.state.PLPloggedIn,startFreeTrial:_this.startFreeTrial,showSignUp:_this.showSignUp,showNewLoginForm:_this.showNewLoginForm}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__za_LessonFeatures_js__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__za_RecognisedStatic__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__za_OurTeachers__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__za_StaticFeed__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__za_SignupSection_js__["a" /* default */],{PLPloggedIn:_this.state.PLPloggedIn,startFreeTrial:_this.startFreeTrial,showSignUp:_this.showSignUp,showNewLoginForm:_this.showNewLoginForm}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__za_Footer_js__["a" /* default */],{showContactus:_this.showContactus,products_category_order:_this.getProductsTypeOrder(),products_category:_this.getProductsType(),classes:_this.getClasses(),grades:_this.getGrades(),products_class:_this.getProductsClass()}),_this.fireMobileToast());};_this.renderLoginView=function(){if(_this.state.loggedIn==true){//console.warn("this.UserStore ",this.UserStore);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inlineblock'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inlineblock navbar-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'nav-item dropdown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'nav-link dropdown-toggle',href:'#',id:'navbardrop','data-toggle':'dropdown'},_this.state.imageLoaded?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'material-icons md-60  usericon imgprv',src:_this.state.imagePreviewUrl}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons md-40 useraccountelement'},'account_circle')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dropdown-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'dropdown-item',href:'/settings'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons pr-16'},'account_circle'),' My Profile'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'dropdown-item',href:'#',onClick:function onClick(){_this.onLogout();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'material-icons pr-16'},'power_settings_new'),' Sign out')))));}};_this.showHideLeftMenu=_this.showHideLeftMenu.bind(_this);_this.getHeaderLogo=_this.getHeaderLogo.bind(_this);return _this;}_createClass(za_PreloginHome,[{key:'componentWillMount',value:function componentWillMount(){_get(za_PreloginHome.prototype.__proto__||Object.getPrototypeOf(za_PreloginHome.prototype),'componentWillMount',this).call(this);}},{key:'componentDidMount',value:function componentDidMount(){_get(za_PreloginHome.prototype.__proto__||Object.getPrototypeOf(za_PreloginHome.prototype),'componentDidMount',this).call(this);this.setFavIco();try{var isCollapsed=this.getAttribute("sidebar_collapsed")==="true";//UserStorageUtil.getStoredSessionItem("sidebar_collapsed") ||
__WEBPACK_IMPORTED_MODULE_6__model_AppConstants_js__["a" /* default */].collapsed=isCollapsed||__WEBPACK_IMPORTED_MODULE_6__model_AppConstants_js__["a" /* default */].collapsed;if(__WEBPACK_IMPORTED_MODULE_6__model_AppConstants_js__["a" /* default */].collapsed===true){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.side-navbar').addClass('shrinked');__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.content-inner').addClass('active');__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').removeClass('active');__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').removeClass("goRight");__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-small').show();__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-big').hide();}}catch(e){console.error(e);}if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).outerWidth()>1183){if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').hasClass('active')){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').addClass("goRight");}else{__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').removeClass("goRight");}}if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).outerWidth()<1183){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').removeClass("goRight");}this.appendCSS("./vendors/za_main.css");}/**
    * IMPORTANT: Please follow this way to use favIcon
    */},{key:'setFavIco',value:function setFavIco(){if(window.fav_ico_by_prefix&&window.fav_ico_by_prefix[this.getUser().getSchoolPrefix()]){if(document.getElementsByName("fav_ico").length>0){document.getElementsByName("fav_ico")[0].href=window.fav_ico_by_prefix[this.getUser().getSchoolPrefix()];}}}},{key:'toggleSideBar',value:function toggleSideBar(){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').toggleClass('active');__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.side-navbar').toggleClass('shrinked');__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.content-inner').toggleClass('active');if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).outerWidth()>1183){if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').hasClass('active')){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-small').hide();__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-big').show();__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').addClass("goRight");}else{__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-small').show();__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-big').hide();__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').removeClass("goRight");}}if(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(window).outerWidth()<1183){__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.navbar-header .brand-small').show();__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#toggle-btn').removeClass("goRight");}try{var isCollapsed=__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.side-navbar').hasClass('shrinked');if(typeof isCollapsed==="boolean"){this.setAttribute("sidebar_collapsed",isCollapsed.toString());}__WEBPACK_IMPORTED_MODULE_6__model_AppConstants_js__["a" /* default */].collapsed=__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.side-navbar').hasClass('shrinked');__WEBPACK_IMPORTED_MODULE_5__util_UserStorageUtil__["a" /* default */].storeSessionItem("sidebar_collapsed",__WEBPACK_IMPORTED_MODULE_6__model_AppConstants_js__["a" /* default */].collapsed);}catch(e){console.log(e);}try{var isCollapsed=this.getAttribute("sidebar_collapsed")==="true";console.log("isCollapsed::::",isCollapsed);//UserStorageUtil.getStoredSessionItem("sidebar_collapsed") ||
__WEBPACK_IMPORTED_MODULE_6__model_AppConstants_js__["a" /* default */].collapsed=isCollapsed||__WEBPACK_IMPORTED_MODULE_6__model_AppConstants_js__["a" /* default */].collapsed;if(__WEBPACK_IMPORTED_MODULE_6__model_AppConstants_js__["a" /* default */].collapsed===true){__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".page-content .content-inner").toggleClass("fullwidth");__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".page-content nav.side-navbar").toggle();__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".page-content nav.side-navbar").toggleClass('collapsed');}}catch(e){console.error(e);}}},{key:'getButtonName',value:function getButtonName(){//console.log("lumos login::::",this.state.LumosloggedIn);
if(this.state.loggedIn||this.state.LumosloggedIn||__WEBPACK_IMPORTED_MODULE_4__util_BrowserUtil__["a" /* default */].getAuthToken()&&__WEBPACK_IMPORTED_MODULE_4__util_BrowserUtil__["a" /* default */].getAuthToken().length>=5||__WEBPACK_IMPORTED_MODULE_4__util_BrowserUtil__["a" /* default */].getLumosToken()&&__WEBPACK_IMPORTED_MODULE_4__util_BrowserUtil__["a" /* default */].getLumosToken().length>=5){//return this.rb("menu.home");
return this.rb("btn.label.myheymath");}return this.rb("btn.label.signin");}},{key:'getHeaderLogo',/*
    * IMPORTANT: Hardcoded temporarily. Needs to be addressed post demo
    */value:function getHeaderLogo(){if(this.getUser().getSchoolPrefix()&&this.getUser().getSchoolPrefix().length>0){if(this.getUser().getSchoolPrefix().toLowerCase()==="ms_"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/img/mindstretcher/logo.png',alt:'Mind Stretcher logo'});}else{return _get(za_PreloginHome.prototype.__proto__||Object.getPrototypeOf(za_PreloginHome.prototype),'getHeaderLogo',this).call(this);}}else{return _get(za_PreloginHome.prototype.__proto__||Object.getPrototypeOf(za_PreloginHome.prototype),'getHeaderLogo',this).call(this);}}},{key:'getUnifiedLoginForm',value:function getUnifiedLoginForm(){var loginType=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var userid=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var errMsg=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__za_UnifiedLogin__["a" /* default */],{myProps:this.props,loginType:loginType,userid:userid,callbackForgotPwd:this.showForgotPasswordForm,callbackCreateAccount:this.showCreateAccount,showSignUp:this.showSignUp,navigateURL:'/products',errMsg:errMsg})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)));}},{key:'getVerifyAccount',value:function getVerifyAccount(){var loginType=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var userInput=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var navigateurl=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var freetrail=arguments.length>3&&arguments[3]!==undefined?arguments[3]:null;if(navigateurl==null){navigateurl='/products';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__za_SignupForm__["a" /* default */],{signupUser:'student',myProps:this.props,loginType:loginType,'data-ga':this.modalcloseDataGA,userInput:userInput,successRegisterMsg:this.showsuccessRegisterMsg,navigateURL:navigateurl,freetrail:freetrail,gaFrom:this.gaFrom});}},{key:'getForgotPassword',value:function getForgotPassword(source){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__za_UnifiedForgotPwd__["a" /* default */],{myProps:this.props,pwdIframeView:this.pwdIframeView,source:source,successForgotPwd:this.showSuccessForgotPwdMessage,showNewLoginForm:this.showNewLoginForm}))));}},{key:'getSingleLoginForm',value:function getSingleLoginForm(event){var loginSource=event.currentTarget.dataset.source||'';if(loginSource==""||loginSource=="lumos"||loginSource=="plp"){this.modalcloseDataGA="Home - Users who have independently registered - Close";this.setState({"ModalShow":true,"ModalContent":this.getUnifiedLoginForm(),"ModalHeader":"logo",customClass:"newloginDialog"});}else if(loginSource=="register"){this.modalcloseDataGA="Home - Sign in - Users who want to register - Close";this.setState({"ModalShow":true,"ModalContent":this.getVerifyAccount(),"ModalHeader":this.rb("login.createnewaccount"),customClass:"newloginDialog"});}}},{key:'getSwitcher',value:function getSwitcher(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{exact:true,path:'/',component:this.Home,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{exact:true,path:'/home',component:this.Home,maintainScrollPosition:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:'/landing',exact:true,component:__WEBPACK_IMPORTED_MODULE_20__views_plp_Home__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:'/dashboard',exact:true,component:__WEBPACK_IMPORTED_MODULE_21__views_dashboard_Dashboard__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:'/settings',exact:true,component:this.GetMyProfile}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{path:'/scorecard/:id/:reset?',exact:true,component:__WEBPACK_IMPORTED_MODULE_22__views_scorecard_Scorecard__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Redirect */],{from:'*',to:'/'}));}},{key:'getRouter',value:function getRouter(){var me=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'nav-desktop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-fluid norightpadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],{to:'/home',onClick:me.setPreloginClass},this.getHeaderLogo())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'textAlignLeft'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-sec'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'My HeyMath Tab',className:"r-btn myheymathbtn mr-30 "+me.getMargin(),onClick:me.showLoginForm},me.getButtonName()),me.renderLoginView())))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'}),me.getSwitcher()));}},{key:'showHideLeftMenu',value:function showHideLeftMenu(){//$(".page-content nav.side-navbar").toggle();
__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".page-content .content-inner").toggleClass("fullwidth");__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".page-content nav.side-navbar").toggle();__WEBPACK_IMPORTED_MODULE_1_jquery___default()(".page-content nav.side-navbar").toggleClass('collapsed');try{var isCollapsed=__WEBPACK_IMPORTED_MODULE_1_jquery___default()('nav.side-navbar').hasClass('collapsed');if(typeof isCollapsed==="boolean"){this.setAttribute("sidebar_collapsed",isCollapsed.toString());}__WEBPACK_IMPORTED_MODULE_6__model_AppConstants_js__["a" /* default */].collapsed=__WEBPACK_IMPORTED_MODULE_1_jquery___default()('nav.side-navbar').hasClass('collapsed');__WEBPACK_IMPORTED_MODULE_5__util_UserStorageUtil__["a" /* default */].storeSessionItem("sidebar_collapsed",__WEBPACK_IMPORTED_MODULE_6__model_AppConstants_js__["a" /* default */].collapsed);}catch(e){//console.log(e);
}}},{key:'render',value:function render(){/*require('./ms_main.css');*/return _get(za_PreloginHome.prototype.__proto__||Object.getPrototypeOf(za_PreloginHome.prototype),'render',this).call(this,this.getRouter());}}]);return za_PreloginHome;}(__WEBPACK_IMPORTED_MODULE_2__prelogin_src_PreloginHome__["a" /* default */]);/* unused harmony default export */ var _unused_webpack_default_export = (za_PreloginHome);__WEBPACK_IMPORTED_MODULE_19__model_ComponentRegistry_js__["a" /* default */].register("za_PreloginHome",za_PreloginHome);/*
* Also registering for the users with hm_ prefix
*/__WEBPACK_IMPORTED_MODULE_19__model_ComponentRegistry_js__["a" /* default */].register("Preloginhome",za_PreloginHome);

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__prelogin_src_components_Banner__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__za_UserLoginType__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__login_Whatsapp_js__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal_video__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_modal_video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_modal_video__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* This class is merely an extension of the previous banner
*
*/var za_Banner=function(_Banner){_inherits(za_Banner,_Banner);function za_Banner(){var _ref;var _temp,_this,_ret;_classCallCheck(this,za_Banner);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=za_Banner.__proto__||Object.getPrototypeOf(za_Banner)).call.apply(_ref,[this].concat(args))),_this),_this.callregisterform=function(){//window.open({ this.getUrlFor("za_registerform") }, "_blank")
window.open(_this.getUrlFor("ZA_FACEBOOKEVENT_REGISTRATIONFORM"),"_blank");},_this.openpdfform=function(){//window.open({ this.getUrlFor("za_registerfbpdfform") }, "_blank")
window.open(_this.getUrlFor("ZA_FACEBOOKEVENT_PDFLINK"),"_blank");},_this.getFaceBookEventUIMob=function(){if(window.facebookEventAvailForZA){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'heading-one robotospan headerpart2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt first-line'},_this.rb("banner.subheading1.za5"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-link text-center registerbtncontain',onClick:_this.callregisterform},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt furtxt registerbtn'},_this.rb("banner.subheading1.za6"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'heading-one robotospan headerpart3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt furtxt'},_this.rb("banner.subheading1.za7")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{onClick:_this.openpdfform,src:'/img/facebook.png',alt:''})));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'heading-one robotospan',style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt first-line',style:{fontSize:'24px'}},_this.rb("banner.subheading1.za3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt furtxt',style:{fontSize:'24px'}},_this.rb("banner.subheading1.za4")));}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(za_Banner,[{key:'getFaceBookEventUIWeb',value:function getFaceBookEventUIWeb(){if(window.facebookEventAvailForZA){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'heading-one robotospan headerpart2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt first-line'},this.rb("banner.subheading1.za5"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-link text-center registerbtncontain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:this.callregisterform,className:'txtcnt furtxt registerbtn'},this.rb("banner.subheading1.za6"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'heading-one robotospan headerpart3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt furtxt'},this.rb("banner.subheading1.za7")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{onClick:this.openpdfform,src:'/img/facebook.png',alt:''})));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'heading-one robotospan',style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt first-line',style:{fontSize:'24px'}},this.rb("banner.subheading1.za3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt furtxt',style:{fontSize:'24px'}},this.rb("banner.subheading1.za4")));}}},{key:'homeforweb',value:function homeforweb(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slider-inner b-web-comp za-banner',style:{padding:'80px 0px 40px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 b-right',style:{display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'r-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'../img/banner1.png',alt:'',onClick:this.openModal}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Home  - Hey Parent Video',className:'popup-modal',onClick:this.openModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'heading-one',style:{textAlign:'center',marginBottom:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt first-line',style:{fontSize:'32px',marginBottom:'10px'}},this.rb("banner.heading.za2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt furtxt',style:{fontSize:'32px'}},this.rb("banner.subheading.za2")))));}},{key:'homeformobile',value:function homeformobile(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'comp-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-center b-comp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'heading-one',style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt first-line',style:{fontSize:'32px'}},this.rb("banner.heading.za2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'txtcnt furtxt',style:{fontSize:'32px'}},this.rb("banner.subheading.za2"))))));}},{key:'homecomponent',value:function homecomponent(){var _this2=this;if(this.isMobile()||this.isTab()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'h-mob-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-container home-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},this.homeformobile())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-pagination'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_modal_video___default.a,{channel:'youtube',isOpen:this.state.isOpen,videoId:'b-X5TsIQG24',onClose:function onClose(){return _this2.setState({isOpen:false});}}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'h-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-container home-bannerweb'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-slide'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},this.homeforweb())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'swiper-pagination'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_modal_video___default.a,{channel:'youtube',isOpen:this.state.isOpen,videoId:'b-X5TsIQG24',onClose:function onClose(){return _this2.setState({isOpen:false});}}));}}}]);return za_Banner;}(__WEBPACK_IMPORTED_MODULE_1__prelogin_src_components_Banner__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (za_Banner);

/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(39);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var SA_EventDetails=function(_PreLoginPage){_inherits(SA_EventDetails,_PreLoginPage);function SA_EventDetails(){_classCallCheck(this,SA_EventDetails);return _possibleConstructorReturn(this,(SA_EventDetails.__proto__||Object.getPrototypeOf(SA_EventDetails)).apply(this,arguments));}_createClass(SA_EventDetails,[{key:'render',value:function render(){var eventDate=new Date();console.log("eventDate == ",eventDate);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-p-ga':'',id:'EventDetails'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container eventSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["l" /* Table */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'date'},this.rb("event.heading.za1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'coloncontainer'},this.rb("event.heading.colon"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.rb("event.heading.za1_1"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'date'},this.rb("event.heading.za2"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'coloncontainer'},this.rb("event.heading.colon"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.rb("event.heading.za2_2"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'date'},this.rb("event.heading.za3"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'coloncontainer'},this.rb("event.heading.colon"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this.rb("event.heading.za3_3"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'date'},this.rb("event.heading.za4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'coloncontainer'},this.rb("event.heading.colon"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,' ',this.rb("event.heading.za4_4")))))));}}]);return SA_EventDetails;}(__WEBPACK_IMPORTED_MODULE_1__core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (SA_EventDetails);

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var za_RecognisedStatic=function(_PreLoginPage){_inherits(za_RecognisedStatic,_PreLoginPage);function za_RecognisedStatic(){_classCallCheck(this,za_RecognisedStatic);return _possibleConstructorReturn(this,(za_RecognisedStatic.__proto__||Object.getPrototypeOf(za_RecognisedStatic)).apply(this,arguments));}_createClass(za_RecognisedStatic,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-p-ga':'',id:'recognisedStatic'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'books'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 collaboration'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Academic collaborations'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/icons/cambridge_home.png',alt:'University of Cambridge logo'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/icons/raffles_home.png',alt:' Raffles Institution, Singapore'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 recognised'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Featured in'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Home - Featured In - BBC News',href:'http://news.bbc.co.uk/2/hi/south_asia/5203440.stm',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/icons/bbcnews.png',alt:'BBC News logo'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Home - Featured In - NewYork Times',href:'https://www.nytimes.com/2005/09/16/opinion/still-eating-our-lunch.html?_r=1',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/icons/nytimes.png',alt:'The New York Times logo'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4 recognised'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Recognised by'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Home - Featured In - AOT_certificate',href:this.getUrlFor("IFRAME_DOMAIN")+"/staticfiles/Partner_AoT_Award.pdf",target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/icons/aot_certificate.png',alt:'aot_certificate'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Home - Featured In - Eduweek_Awards',href:this.getUrlFor("IFRAME_DOMAIN")+"/staticfiles/eduweek-pres.png",target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/icons/eduweek-pres.png',alt:'Eduweek Awards'}))))))));}}]);return za_RecognisedStatic;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (za_RecognisedStatic);

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_PreLoginPage__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var SA_LessonFeatures=function(_PreLoginPage){_inherits(SA_LessonFeatures,_PreLoginPage);function SA_LessonFeatures(){_classCallCheck(this,SA_LessonFeatures);return _possibleConstructorReturn(this,(SA_LessonFeatures.__proto__||Object.getPrototypeOf(SA_LessonFeatures)).apply(this,arguments));}_createClass(SA_LessonFeatures,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-p-ga':'',id:'LessonFeatures'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("custom.label.txt.za1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("custom.label.txt.za2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.rb("custom.label.txt.za3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-6 col-lg-3 featureSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/icons/Feature1.png',alt:'student listening to video lecture'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.rb("za_lessonfeatures2.label.1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.rb("za_lessonfeatures2.txt.1"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-6 col-lg-3 featureSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/icons/ph2.png',alt:'Bite-sized quizzes'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.rb("za_lessonfeatures2.label.2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.rb("za_lessonfeatures2.txt.2"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-6 col-lg-3 featureSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/icons/ph3.png',alt:' Diagnostic test report'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.rb("za_lessonfeatures2.label.3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.rb("za_lessonfeatures2.txt.3"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-6 col-lg-3 featureSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/icons/ph4.png',alt:'Granular report card'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.rb("za_lessonfeatures2.label.4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.rb("za_lessonfeatures2.txt.4"))))));}}]);return SA_LessonFeatures;}(__WEBPACK_IMPORTED_MODULE_1__core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (SA_LessonFeatures);

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_id_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_id_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__prelogin_src_components_PreLoginSessionCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal_video__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal_video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal_video__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ES6 class-style
var za_OurTeachers=function(_PreLoginSessionCheck){_inherits(za_OurTeachers,_PreLoginSessionCheck);function za_OurTeachers(props){_classCallCheck(this,za_OurTeachers);var _this=_possibleConstructorReturn(this,(za_OurTeachers.__proto__||Object.getPrototypeOf(za_OurTeachers)).call(this,props));_this.state={isOpen:false};_this.openModal=_this.openModal.bind(_this);_this.goNext=_this.goNext.bind(_this);_this.goPrev=_this.goPrev.bind(_this);_this.swiper=null;return _this;}_createClass(za_OurTeachers,[{key:'goNext',value:function goNext(){if(this.swiper)this.swiper.slideNext();}},{key:'goPrev',value:function goPrev(){if(this.swiper)this.swiper.slidePrev();}},{key:'openModal',value:function openModal(someValue){this.setState({isOpen:true});this.videoId=someValue;console.log(this.videoId);}},{key:'render',value:function render(){var _this2=this;var videoId='';var params={slidesPerView:3,spaceBetween:30,loop:true,navigation:{nextEl:'.swiper-button-next',prevEl:'.swiper-button-prev',nextButtonCustomizedClass:'.swp-next',prevButtonCustomizedClass:'.swp-prev'},breakpoints:{480:{slidesPerView:1,spaceBetween:20},640:{slidesPerView:2,spaceBetween:30},768:{slidesPerView:2,spaceBetween:30}}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'mtb our-educators'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.rb("za_ourteachers.heading")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box popup-youtube',onClick:this.openModal.bind(null,'vc2dUrFVkqw')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/icons/educator_test1.png',alt:'educator_test1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box popup-youtube',onClick:this.openModal.bind(null,'yLaDCETATK8')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/icons/educator_test2.png',alt:'educator_test2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box popup-youtube',onClick:this.openModal.bind(null,'wKe0TYfSDXc')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/icons/educator_test3.png',alt:'educator_test3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box popup-youtube',onClick:this.openModal.bind(null,'CJU8vhSqnG4')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/icons/educator_test4.png',alt:'educator_test4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-box popup-youtube',onClick:this.openModal.bind(null,'dhm5us6T-eE')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'/images/icons/educator_test5.png',alt:'educator_test5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'play-btn'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_modal_video___default.a,{channel:'youtube',isOpen:this.state.isOpen,videoId:this.videoId,onClose:function onClose(){return _this2.setState({isOpen:false});}}));}}]);return za_OurTeachers;}(__WEBPACK_IMPORTED_MODULE_2__prelogin_src_components_PreLoginSessionCheck__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (za_OurTeachers);

/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var za_StaticFeed=function(_PreLoginPage){_inherits(za_StaticFeed,_PreLoginPage);function za_StaticFeed(props){_classCallCheck(this,za_StaticFeed);return _possibleConstructorReturn(this,(za_StaticFeed.__proto__||Object.getPrototypeOf(za_StaticFeed)).call(this,props));}_createClass(za_StaticFeed,[{key:'componentDidMount',value:function componentDidMount(){// this.getLiveFeedData();
}},{key:'componentWillMount',value:function componentWillMount(){//this.getLiveFeedData();
}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container staticfeed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row scorecardLessons text-center padd'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'performicon',height:'35px',src:'./images/icons/education.png'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'5,000')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body card-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.rb("staticfeed.teacher")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'performicon',height:'35px',src:'./images/icons/pencil.png'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1,000,000')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body card-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.rb("staticfeed.student")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'performicon',height:'35px',src:'./images/icons/diploma.png'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'30%')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body card-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.rb("staticfeed.improveInfo")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-6 col-md-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'performicon',height:'35px',src:'./images/icons/studentinfo.png'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{}},'92%')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-body card-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.rb("staticfeed.studentsInfo")))))));}}]);return za_StaticFeed;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (za_StaticFeed);

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__prelogin_src_components_SignupSection__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__za_UserLoginType__ = __webpack_require__(511);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var za_SignupSection=function(_SignupSection){_inherits(za_SignupSection,_SignupSection);function za_SignupSection(){_classCallCheck(this,za_SignupSection);return _possibleConstructorReturn(this,(za_SignupSection.__proto__||Object.getPrototypeOf(za_SignupSection)).apply(this,arguments));}_createClass(za_SignupSection,[{key:'render',value:function render(){var _this2=this;var styles={display:'inline-block',fontWeight:500};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{'data-p-ga':'',className:'mtb child'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,this.rb("signup.section.txt.1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hmorg',style:styles},'Hey'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'hmblue',style:styles},'Math!\xA0'),this.rb("signup.section.txt.2")),function(){if(!_this2.props.PLPloggedIn){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-5 mx-auto text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__za_UserLoginType__["a" /* default */],{showSignUp:_this2.props.showSignUp,showNewLoginForm:_this2.props.showNewLoginForm,from:"Bottom"}));}}()));}}]);return za_SignupSection;}(__WEBPACK_IMPORTED_MODULE_1__prelogin_src_components_SignupSection__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (za_SignupSection);

/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_device_detect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_html_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_forgotpwdicon_png__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_forgotpwdicon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_icons_forgotpwdicon_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var fpServerResponses={200:'An email has been sent to <span class="hm-blue"><email></span> with the link to reset the password. Please check your Inbox and Spam/Junk folders.',403:'You are not allowed to reset your password. Please write to <a href="mailto:support@heymath.com">support@heymath.com</a>',600:'Invalid User ID / Email.',// also for 400, 401
0:'An unexpected error occurred. Please try again after sometime or write to <a href="mailto:support@heymath.com">support@heymath.com</a>'};var UnifiedForgotPwd=function(_PreLoginPage){_inherits(UnifiedForgotPwd,_PreLoginPage);function UnifiedForgotPwd(props){_classCallCheck(this,UnifiedForgotPwd);var _this=_possibleConstructorReturn(this,(UnifiedForgotPwd.__proto__||Object.getPrototypeOf(UnifiedForgotPwd)).call(this,props));_this.hmNav=function(){//this.props.myProps.history.push(this.props.navigateURL);
window.top.location.href=this.props.navigateURL;};_this.submitForm=function(){var verificationtype=this.state.loginType;var formData={"userId":this.state.userInput,"password":this.state.password_newacc//do cofirm
};var me=this;me.setState({submitButtonDisabled:true});var callBackSuccess=function callBackSuccess(response){console.log("response : ",response);if(response!==null){me.setState({validToken:response.isValid,pwdUpdated:response.passwordUpdated,loader:false});//console.log("timeout..........",me.state.pwdUpdated," : src = ",me.state.source);
setTimeout(function(){console.log("timeout..........");me.bindLoginLink();},500);me.trackMe(true,"set_password");}else{me.trackMe(false,"set_password");}};var callBackFailure=function callBackFailure(response){me.setState({submitButtonDisabled:false});me.trackMe(false,"set_password");};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("PWD_RECOVER")+this.state.otp_newacc,formData).put(callBackSuccess,callBackFailure);};_this.submitLumosPwdForm=function(){var me=this;var formData={"userId":this.state.username,"email":this.state.email};me.setState({submitButtonDisabled:true});__WEBPACK_IMPORTED_MODULE_10_jquery___default.a.ajax({url:me.getUrlFor("LUMOS_FORGOTPWD"),data:formData,type:'POST',xhrFields:{withCredentials:true},crossDomain:true,success:function success(response){switch(response.code){case 200://me.setState({serverMessage: fpServerResponses[response.code].replace(/<email>/g, formData.emailId)});
me.props.successForgotPwd(fpServerResponses[response.code].replace(/<email>/g,me.state.email));break;case 403:me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[response.code].replace(/<email>/g,me.state.email)});break;case 400:case 401:case 600:me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[600]});break;default://currentDialog.serverMessageElem.innerHTML = fpServerResponses[0];
me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[0]});}me.trackMe();},error:function error(response){console.log("Error in lumos login",response);me.setState({submitButtonDisabled:false});me.trackMe();}});};_this.state={plp_userinput:_this.props.userid||"",username_newacc:'',password_newacc:'',confirmpassword_newacc:'',singupType:"userid",loginType:_this.props.loginType||"userid",userInput:_this.props.userInput||"",otp_newacc:'',submitButtonDisabled:false,serverMessage:"",emailfeedbackmsg:"",source:"",isOTPSend:false,isVerified:false,OTPDisabled:"hiddenOTP",verifyDisabled:"disabled",emailDisabled:false,phoneDisabled:false,verifyText:_this.rb("register.verify"),sendOTPText:_this.rb("home.continue"),pwdUpdated:false,passcodeDisabled:"disabled",username:'',UseridEmailidSame:false,user_exists:false};_this.handleChange=_this.handleChange.bind(_this);_this.enterOTPChange=_this.enterOTPChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.handleSubmitVerify=_this.handleSubmitVerify.bind(_this);_this.userIdChange=_this.userIdChange.bind(_this);_this.userverifyIdChange=_this.userverifyIdChange.bind(_this);_this.sendOTP=_this.sendOTP.bind(_this);_this.verifyOTP=_this.verifyOTP.bind(_this);_this.getOTPField=_this.getOTPField.bind(_this);_this.showLogin=_this.showLogin.bind(_this);_this.handleKeyUp=_this.handleKeyUp.bind(_this);_this.myTrackerInstance=_this.getTracker();_this.handleemailChange=_this.handleemailChange.bind(_this);_this.submitLumosPwdForm=_this.submitLumosPwdForm.bind(_this);_this.submitPLPPwdForm=_this.submitPLPPwdForm.bind(_this);_this.submitCommonPwdForm=_this.submitCommonPwdForm.bind(_this);_this.renderUseridEmailidValue=_this.renderUseridEmailidValue.bind(_this);_this.handleCheckboxChange=_this.handleCheckboxChange.bind(_this);_this.plpForgotPassword=_this.plpForgotPassword.bind(_this);_this.lumosForgotPassword=_this.lumosForgotPassword.bind(_this);_this.commonForgotPassword=_this.commonForgotPassword.bind(_this);_this.forgotPassword=_this.forgotPassword.bind(_this);_this.renderRHSForm=_this.renderRHSForm.bind(_this);_this.userVerify=_this.userVerify.bind(_this);_this.getUserStatus=_this.getUserStatus.bind(_this);return _this;}_createClass(UnifiedForgotPwd,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var me=this;//console.log('componentWillReceiveProps', nextProps);    
this.setState({loginType:nextProps.loginType||"userid",userInput:nextProps.userInput||"",otp_newacc:'',submitButtonDisabled:false,serverMessage:"",emailfeedbackmsg:"",source:"",isOTPSend:false,isVerified:false,OTPDisabled:"hiddenOTP",verifyDisabled:"disabled",emailDisabled:false,phoneDisabled:false,verifyText:this.rb("register.verify"),sendOTPText:this.rb("home.continue"),pwdUpdated:false,passcodeDisabled:"disabled"});setTimeout(function(){me.reinitiate();},500);}},{key:'componentDidMount',value:function componentDidMount(){this.sessionCheck();this.reinitiate();}},{key:'reinitiate',value:function reinitiate(){if(this.state.userInput!=""){this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){this.setState({OTPDisabled:""});__WEBPACK_IMPORTED_MODULE_10_jquery___default()(".OTPButton").trigger("click");}}__WEBPACK_IMPORTED_MODULE_10_jquery___default()("#loginRoot .userInput").focus();}},{key:'handleChange',value:function handleChange(e){var _setState;var target=e.currentTarget;//console.log("target=",target);
this.form.validateFields(target);this.setState((_setState={},_defineProperty(_setState,target.name,target.value),_defineProperty(_setState,'serverMessage',""),_defineProperty(_setState,'submitButtonDisabled',!this.form.isValid()),_setState));}},{key:'handleemailChange',value:function handleemailChange(e){this.handleChange(e);}},{key:'userIdChange',value:function userIdChange(e){var _setState2;var target=e.currentTarget;this.form.validateFields(target);// var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
// if(phoneRegx.test(target.value)){
// 	this.setState({loginType:"mobile",loginMaxLength:10,OTPDisabled: "hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});
// 	if(target.value.length >= 10){				
// 		this.setState({ OTPDisabled: "", passcodeDisabled:""});
// 	}
// }else{
// 	this.setState({loginType:"email",loginMaxLength:254,OTPDisabled: "hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});
// 	if(target.value.length>0){
// 		this.setState({ OTPDisabled: "",passcodeDisabled:""});
// 	}
// }
this.setState({loginType:"email",loginMaxLength:254,OTPDisabled:"hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});if(target.value.length>0){this.setState({OTPDisabled:"",passcodeDisabled:""});}this.setState((_setState2={},_defineProperty(_setState2,target.name,target.value),_defineProperty(_setState2,'serverMessage',""),_defineProperty(_setState2,'submitButtonDisabled',true),_setState2));}},{key:'userverifyIdChange',value:function userverifyIdChange(e){var _setState3;var target=e.currentTarget;this.form.validateFields(target);// var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
// if(phoneRegx.test(target.value)){
// 	this.setState({loginType:"mobile",loginMaxLength:10,isOTPSend:false,isVerified:false,OTPDisabled: "", passcodeDisabled:""});
// }else{
// 	this.setState({loginType:"email",loginMaxLength:254,isOTPSend:false,isVerified:false});
// 	if(target.value.length>0){
// 		this.setState({ OTPDisabled: "",passcodeDisabled:""});
// 	}
// }
this.setState({loginType:"email",loginMaxLength:254,isOTPSend:false,isVerified:false});if(target.value.length>0){this.setState({OTPDisabled:"",passcodeDisabled:""});}this.setState((_setState3={},_defineProperty(_setState3,target.name,target.value),_defineProperty(_setState3,'serverMessage',""),_defineProperty(_setState3,'submitButtonDisabled',true),_setState3));//console.log(this.state);
}},{key:'enterOTPChange',value:function enterOTPChange(e){if(this.otp.value.length>0){this.setState({verifyDisabled:""});}else{this.setState({verifyDisabled:"disabled"});}this.handleChange(e);}},{key:'bindLoginLink',value:function bindLoginLink(){var me=this;console.log("link::",__WEBPACK_IMPORTED_MODULE_10_jquery___default()("#loginLink"));__WEBPACK_IMPORTED_MODULE_10_jquery___default()("#loginLink").click(function(){me.showLogin();});}},{key:'trackMe',value:function trackMe(result,source){/*var trackObj = {
				"name": this.state.username_newacc,
			    "email": (this.state.loginType == "mobile") ? "" : this.state.userInput,
			    "phone": (this.state.loginType == "mobile") ? this.state.userInput : "",
			    "event_source":this.getTracker().enums.signupEventSource[source],
			    "result": result
			    
		}

		this.initiateTrack("signup",trackObj);*/var trackObj={"login_id":this.state.userInput,"email":"","event_source":this.getTracker().enums.signupEventSource[source],"result":result};if(source=="set_password"){this.storeTrackEvent("forgot_password",trackObj);}else{this.initiateTrack("forgot_password",trackObj);}}},{key:'submitPLPPwdForm',value:function submitPLPPwdForm(){var userId=this.state.username;var emailId=this.state.email;if(this.state.UseridEmailidSame){userId=emailId;}var formData={"userId":userId,"emailId":emailId};var me=this;me.setState({submitButtonDisabled:true});var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status=="SUCCESS"){//me.setState({serverMessage: fpServerResponses[200].replace(/<email>/g, formData.emailId)});
me.props.successForgotPwd(fpServerResponses[200].replace(/<email>/g,formData.emailId));}else if(response.status=="INVALID_EMAIL"){me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[600]});}else if(response.status=="INVALID_USERID"){me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[600]});}else if(response.status=="PROVIDER_FORBIDDEN"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("google.errmsg.pwd")});}else{me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[0]});}}me.trackMe();console.log("response : ",response);};var callBackFailure=function callBackFailure(response){me.setState({submitButtonDisabled:false});me.trackMe();};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("FORGOT_PWD"),formData).post(callBackSuccess,callBackFailure);}},{key:'submitCommonPwdForm',value:function submitCommonPwdForm(){var userId=this.state.username;var emailId=this.state.email;if(this.state.UseridEmailidSame){userId=emailId;}var formData={"userId":userId,"email":emailId};var me=this;me.setState({submitButtonDisabled:true});var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.source=="plp"){if(response.status=="SUCCESS"){//me.setState({serverMessage: fpServerResponses[200].replace(/<email>/g, formData.email)});
me.props.successForgotPwd(fpServerResponses[200].replace(/<email>/g,formData.email));}else if(response.status=="INVALID_EMAIL"){me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[600]});}else if(response.status=="INVALID_USERID"){me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[600]});}else if(response.status=="PROVIDER_FORBIDDEN"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("google.errmsg.pwd")});}else{me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[0]});}}else if(response.source=="lumos"){switch(response.code){case 200://me.setState({serverMessage: fpServerResponses[response.code].replace(/<email>/g, formData.email)});
me.props.successForgotPwd(fpServerResponses[response.code].replace(/<email>/g,me.state.email));break;case 403:me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[response.code].replace(/<email>/g,me.state.email)});break;case 400:case 401:case 600:me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[600]});break;default://currentDialog.serverMessageElem.innerHTML = fpServerResponses[0];
me.setState({submitButtonDisabled:false,serverMessage:fpServerResponses[0]});}}}me.trackMe();console.log("response : ",response);};var PLPcallBackFailure=function PLPcallBackFailure(response){me.setState({submitButtonDisabled:false});me.trackMe();};var callBackFailure=function callBackFailure(response){//me.setState({submitButtonDisabled: false});
//me.trackMe();
new __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__["a" /* default */](me.getUrlFor("PLP_COMMON_FORGOT_PWD"),formData).enableCORS().post(callBackSuccess,PLPcallBackFailure);};//new HmAjax(this.getUrlFor("FORGOT_PWD"),formData).post(callBackSuccess,callBackFailure);
new __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__["a" /* default */](this.getUrlFor("COMMON_FORGOT_PWD"),formData).enableCORS().post(callBackSuccess,callBackFailure);}},{key:'handleSubmit',value:function handleSubmit(e){e.preventDefault();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid(),serverMessage:""});if(this.form.isValid()){if(this.state.source.toLowerCase()=="lumos"){this.submitCommonPwdForm();}else if(this.state.isOTPSend&&this.state.isVerified){this.submitForm();}else if(this.state.source.toLowerCase()=="plp"){this.submitCommonPwdForm();}}}},{key:'handleSubmitVerify',value:function handleSubmitVerify(e){e.preventDefault();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){this.getUserStatus();// if(this.state.userLoginAllowed){
// 	this.submitForm();  
// }else{
// 	this.getUserStatus();
// }
}}},{key:'handleCheckboxChange',value:function handleCheckboxChange(event){var target=event.target;this.setState({"UseridEmailidSame":target.checked});if(event.target){this.setState({username:this.state.email});}}},{key:'renderUseridEmailidValue',value:function renderUseridEmailidValue(){if(this.state.UseridEmailidSame){return this.state.email;}else{return this.state.username;}}},{key:'checkForDisabled',value:function checkForDisabled(){return true;if(this.state.UseridEmailidSame){return true;}else{return false;}}},{key:'sendOTP',value:function sendOTP(){// if(this.state.OTPDisabled == "hiddenOTP"){
// 	this.form.validateFields();
// 	return;
// }
var me=this;var otpServerMsg="";if(this.state.loginType=="mobile"){if(me.state.isOTPSend){otpServerMsg="OTP is sent again to mobile";}else{otpServerMsg="OTP is sent to your mobile";}}else{if(me.state.isOTPSend){otpServerMsg="OTP is sent again to your email";}else{otpServerMsg="OTP is sent to your email";}}me.setState({serverMessage:"",emailfeedbackmsg:"",isOTPSend:false,isVerified:false,verifyDisabled:"disabled",otp_newacc:"",passcodeDisabled:"disabled"});var formData={"userId":this.state.userInput,"contactType":this.state.loginType};var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status){if(response.status=="user_exists"){me.setState({serverMessage:"User already exists",passcodeDisabled:""});}else if(response.status=="no_such_token"){me.setState({serverMessage:"The OTP entered is incorrect",passcodeDisabled:""});}else if(response.status=="error"){me.setState({serverMessage:"Internal error occured",passcodeDisabled:""});}else if(response.status=="INVALID_EMAIL"){me.setState({serverMessage:fpServerResponses[600],passcodeDisabled:""});}else if(response.status=="INVALID_USERID"){me.setState({serverMessage:fpServerResponses[600],passcodeDisabled:""});}else if(response.status=="PROVIDER_FORBIDDEN"){me.setState({serverMessage:me.rb("google.errmsg.pwd"),passcodeDisabled:""});}else{me.setState({emailfeedbackmsg:otpServerMsg});}}if(response.status.toLowerCase()=="success"){me.setState({isOTPSend:true,passcodeDisabled:"disabled"});me.trackMe(true,"send_otp");}else{me.trackMe(false,"send_otp");}}console.log("response : ",response);};var PLPcallBackFailure=function PLPcallBackFailure(response){console.log("Error in FORGOT_PWD");me.setState({passcodeDisabled:""});me.trackMe(false,"send_otp");};var callBackFailure=function callBackFailure(response){console.log("Error in FORGOT_PWD");//me.setState({passcodeDisabled:""});
//me.trackMe(false,"send_otp");
new __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__["a" /* default */](me.getUrlFor("PLP_COMMON_FORGOT_PWD"),formData).enableCORS().post(callBackSuccess,PLPcallBackFailure);};//new HmAjax(this.getUrlFor("FORGOT_PWD"),formData).post(callBackSuccess,callBackFailure);
new __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__["a" /* default */](this.getUrlFor("COMMON_FORGOT_PWD"),formData).enableCORS().post(callBackSuccess,callBackFailure);}},{key:'verifyOTP',value:function verifyOTP(){var me=this;var formData={"userId":this.state.userInput};me.setState({serverMessage:""});var verificationtype=this.state.loginType;this.setState({verifyDisabled:"disabled"});var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status){if(response.status=="user_exists"){me.setState({serverMessage:"User already exists",verifyDisabled:""});me.trackMe(false,"verify_otp");}else if(response.status=="no_such_token"||response.status=="NO_TOKEN_AVAILABLE"){me.setState({serverMessage:"The OTP entered is incorrect",verifyDisabled:""});me.trackMe(false,"verify_otp");}else if(response.isValid==false){me.setState({serverMessage:"The OTP entered is incorrect",verifyDisabled:""});me.trackMe(false,"verify_otp");}else if(response.status=="error"){me.setState({serverMessage:"Internal error occured",verifyDisabled:""});me.trackMe(false,"verify_otp");}else{me.setState({isVerified:true,verifyDisabled:""});me.trackMe(true,"verify_otp");}}}console.log("response : ",response);};var callBackFailure=function callBackFailure(response){console.log("Error in PWD_TOKEN_VALIDATE");me.setState({verifyDisabled:""});me.trackMe(false,"verify_otp");};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("PWD_TOKEN_VALIDATE")+this.state.otp_newacc,formData).post(callBackSuccess,callBackFailure);}},{key:'getOTPField',value:function getOTPField(){var _this2=this;if(this.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'otp_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'otp_newacc',className:'otp_newacc',name:'otp_newacc',placeholder:this.rb("register.enterOTP"),innerRef:function innerRef(otp){return _this2.otp=otp;},onKeyUp:this.handleKeyUp,value:this.state.otp_newacc,onChange:this.enterOTPChange,required:true,minLength:1,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'otp_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("register.enterOTP")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'})));}}},{key:'showLogin',value:function showLogin(){this.props.showNewLoginForm();}},{key:'getVerifyField',value:function getVerifyField(){if(this.state.isOTPSend&&!this.state.isVerified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"submitButton verifyButton "+this.state.verifyDisabled,onClick:this.verifyOTP},this.rb("register.verify"));}/*else if(this.state.isOTPSend && this.state.isVerified){
			return (<div className="text-right verifytxt"><i class="material-icons">done</i> <span>{this.rb("register.verified")}</span></div>);
		}*/}},{key:'getSignupHeaderMsg',value:function getSignupHeaderMsg(){if(this.state.isOTPSend&&!this.state.isVerified){if(this.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10'},'Please enter the 6-digit OTP sent to'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10'},'Please enter the 6-digit OTP sent to'));}}else if(this.state.isVerified){if(this.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10'},'You have requested to reset the password for'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small mt-10'},'+91 ',this.state.userInput));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10'},'You have requested to reset the password for'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small mt-10'},this.state.userInput));}}}},{key:'sendOTPText',value:function sendOTPText(){if(this.state.isOTPSend){return this.rb("register.reSendOTP");}else{return this.rb("home.continue");}}},{key:'showEmailFeedback',value:function showEmailFeedback(){var _this3=this;if(this.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-control-feedback'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error'},this.state.emailfeedbackmsg),function(){if(_this3.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedbacksmall'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'All important information will be sent to this mobile number'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedbacksmall'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'All important information will be sent to this email ID'));}}());}}},{key:'getUserInputPattern',value:function getUserInputPattern(){if(this.state.loginType=="mobile"){return".{10,}";}else{return"^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$";}}},{key:'getContactType',value:function getContactType(){var _this4=this;if(!this.state.isVerified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,function(){if(!_this4.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10 textAlignLeft'},_this4.rb("unifiedlogin.otpalert"),_this4.state.loginType=="mobile"?"mobile no":"email");}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'userInput'},function(){if(_this4.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'countrycodeform'},'+91');}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'userInput',className:"userInput "+this.state.loginType,name:'userInput',placeholder:this.rb("login.userplaceholder.za"),innerRef:function innerRef(email){return _this4.email=email;},onKeyUp:this.handleKeyUp,value:this.state.userInput,onChange:this.userIdChange,disabled:this.checkForDisabled(),pattern:this.getUserInputPattern(),required:true,minLength:1,maxLength:this.state.loginMaxLength,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'2'}),function(){if(_this4.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'userInput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},_this4.rb("za_login.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},_this4.rb("register.mobilenolength")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length>0&&!/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g.test(value);}},_this4.rb("register.numbersonly")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'userInput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},_this4.rb("za_login.useridrequired")));}}()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),this.getOTPField(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages pb-20'},this.state.serverMessage),function(){if(_this4.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this4.rb("register.reSendOTPmsg"),' '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'pl-10 resendButton',onClick:_this4.sendOTP},_this4.rb("register.reSendOTP"))),_this4.getVerifyField());}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this4.getVerifyField(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"submitButton OTPButton "+_this4.state.OTPDisabled+" "+_this4.state.passcodeDisabled,onClick:_this4.sendOTP},_this4.rb("home.continue"))));}}());}}},{key:'setPassword',value:function setPassword(){var _this5=this;if(this.state.isVerified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'password_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'password_newacc',name:'password_newacc',placeholder:this.rb("login.password"),innerRef:function innerRef(password){return _this5.password=password;},value:this.state.password_newacc,onChange:this.handleChange,required:true,minLength:6,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'password_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("login.pwdrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("validate.pwd.minimum",[6])))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'confirmpassword'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'confirmpassword_newacc',name:'confirmpassword_newacc',placeholder:this.rb("rpwd.confirmpwd"),innerRef:function innerRef(confirmpassword){return _this5.confirmpassword=confirmpassword;},value:this.state.confirmpassword_newacc,onChange:this.handleChange,required:true,minLength:6,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'confirmpassword_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("rpwd.confirmpwdrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("validate.pwd.minimum",[6])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value!==_this5.password.value;}},this.rb("rpwd.doesnotmatch")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages pt-20'},this.state.serverMessage));}}},{key:'renderRHSForm',value:function renderRHSForm(){var _this6=this;if(this.state.pwdUpdated===true&&this.state.source==="plp"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 mt-50'},__WEBPACK_IMPORTED_MODULE_11_react_html_parser___default()(this.rb("rpwd.msg.success"))));}else if(this.state.pwdUpdated===true&&this.state.source==="lumos"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 mt-50'},__WEBPACK_IMPORTED_MODULE_11_react_html_parser___default()(this.rb("rpwd.msg.success"))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rounded-0'},this.getSignupHeaderMsg(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this6.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},this.getContactType(),this.setPassword(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-ga':'Home - Sign in - Users who want to register - Sign Up',disabled:this.state.submitButtonDisabled,className:"submitButton signup signupButton "+(this.state.isVerified?"":"hidden")},this.rb("register.setpassword"))))))))));}}},{key:'renderFormTitle',value:function renderFormTitle(){if(this.state.isOTPSend&&this.state.isVerified){return this.rb("rpwd.title");}else{return this.rb("forgot_password_label");}}},{key:'handleKeyUp',value:function handleKeyUp(event){if(event.key==='Enter'&&this.form.isValid()){if(!this.state.isVerified){if(this.state.isOTPSend&&this.state.verifyDisabled!="disabled"){__WEBPACK_IMPORTED_MODULE_10_jquery___default()(".verifyButton").trigger("click");}else if(this.state.passcodeDisabled!="disabled"){this.setState({OTPDisabled:""});__WEBPACK_IMPORTED_MODULE_10_jquery___default()(".OTPButton").trigger("click");}}}}},{key:'lumosForgotPassword',value:function lumosForgotPassword(){var _this7=this;if(this.state.loggedIn){return _get(UnifiedForgotPwd.prototype.__proto__||Object.getPrototypeOf(UnifiedForgotPwd.prototype),'render',this).call(this);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center schoolLoginInfo josefinsansFont nopadding'},this.rb("unif.fpwd.msg1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),function(){if(_this7.props.source.toLowerCase()=="lumos"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center schoolLoginInfo josefinsansFont'},__WEBPACK_IMPORTED_MODULE_11_react_html_parser___default()(_this7.rb("fpwd.lumos.msg")));}}())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rounded-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this7.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'username'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'username',className:'username',name:'username',placeholder:this.rb("login.userid"),value:this.renderUseridEmailidValue(),onChange:this.handleChange,disabled:this.checkForDisabled(),required:true,minLength:1,maxLength:254,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'username'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("za_login.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'email'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'email',className:'email',name:'email',placeholder:this.rb("fpwd.email"),innerRef:function innerRef(email){return _this7.email=email;},value:this.state.email,onChange:this.handleemailChange,required:true,maxLength:254,pattern:'^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$',minLength:1,tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'email',show:'all'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("fpwd.emailrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},this.rb("fpwd.validemail")))),function(){if(_this7.props.source.toLowerCase()=="plp"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'checkboxLabel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'fwdCheckbox',name:'sameUseridEmailid',type:'checkbox',onChange:_this7.handleCheckboxChange}),_this7.rb("fpwd.plp.useridemailidsame")));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'forgotpwdMsg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages'},' ',__WEBPACK_IMPORTED_MODULE_11_react_html_parser___default()(this.state.serverMessage))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:this.state.submitButtonDisabled,className:'submitButton'},this.rb("login.send"))))))),function(){if(_this7.props.source.toLowerCase()=="plp"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center schoolLoginInfo josefinsansFont'},_this7.rb("fpwd.plp.note"));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))));}}},{key:'plpForgotPassword',value:function plpForgotPassword(){var me=this;if(this.state.loggedIn){return _get(UnifiedForgotPwd.prototype.__proto__||Object.getPrototypeOf(UnifiedForgotPwd.prototype),'render',this).call(this);}else{return me.renderRHSForm();}}},{key:'commonForgotPassword',value:function commonForgotPassword(){var me=this;if(this.state.loggedIn){return _get(UnifiedForgotPwd.prototype.__proto__||Object.getPrototypeOf(UnifiedForgotPwd.prototype),'render',this).call(this);}else{return me.userVerify();}}},{key:'userVerify',value:function userVerify(){var _this8=this;var me=this;if(this.state.loggedIn){return _get(UnifiedForgotPwd.prototype.__proto__||Object.getPrototypeOf(UnifiedForgotPwd.prototype),'render',this).call(this);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this8.form=formWithConstraints;},onSubmit:this.handleSubmitVerify,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'plp_userinput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'plp_userinput',className:"plp_userinput "+this.state.loginType,name:'plp_userinput',placeholder:this.rb("unifiedlogin.userplaceholder"),value:this.state.plp_userinput,onChange:this.userverifyIdChange,required:true,minLength:1,maxLength:254,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'plp_userinput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("za_unifiedverify.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages'},this.state.serverMessage),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-ga':"Home - Verify",className:'submitButton'},'Verify')))));}}},{key:'getUserStatus',value:function getUserStatus(){if(this.state.plp_userinput.length<=0){return;}var formData={"userId":this.state.plp_userinput};var me=this;var callBackSuccess=function callBackSuccess(response,request){if(response!==null){if(response.userExists&&response.source!=='null'&&response.message!=="provider_forbidden"){if(response.source=="lumos"){me.setState({userLoginAllowed:true,user_exists:response.userExists,source:response.source,username:me.state.plp_userinput});}else if(response.source=="plp"){me.setState({userLoginAllowed:true,user_exists:response.userExists,source:response.source,userInput:me.state.plp_userinput});}}else{if(response.message=="provider_forbidden"){if(response.authProviderId==2){me.setState({submitButtonDisabled:false,serverMessage:me.rb("google.errmsg.pwd")});}else if(response.authProviderId==4){me.setState({submitButtonDisabled:false,serverMessage:me.rb("uolo.errmsg.pwd")});}}else{//me.setState({userLoginAllowed:false});
//me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
me.setState({submitButtonDisabled:false,serverMessage:me.rb("za_unifiedlogin.invalidinput.msg")});//	me.checkValidUserInput();
}}}};var PLPcallBackFailure=function PLPcallBackFailure(response,request){me.setState({submitButtonDisabled:false});};var callBackFailure=function callBackFailure(response,request){//me.setState({submitButtonDisabled: false});
new __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__["a" /* default */](me.getUrlFor("PLP_GET_USER_STATUS_UNIF"),formData).enableCORS().post(callBackSuccess,PLPcallBackFailure);};//new HmAjax(this.getUrlFor("GET_USER_STATUS"),formData).post(callBackSuccess,callBackFailure);
new __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__["a" /* default */](this.getUrlFor("GET_USER_STATUS_UNIF"),formData).enableCORS().post(callBackSuccess,callBackFailure);}},{key:'checkValidUserInput',value:function checkValidUserInput(){var me=this;var userinput=this.state.plp_userinput;if(userinput.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){me.setState({userLoginAllowed:false});me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);}else{me.setState({submitButtonDisabled:false,serverMessage:me.rb("za_login.invalidinput.msg")});}// var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
// if(phoneRegx.test(userinput)){			
// 	if(userinput.length == 10){				
// 		me.setState({userLoginAllowed:false});
// 		me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
// 	}else{
// 		me.setState({submitButtonDisabled: false, serverMessage: me.rb("login.invalidinput.msg")});
// 	}
// }else{
// 	if(userinput.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){
// 		me.setState({userLoginAllowed:false});
// 		me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
// 	}else{
// 		me.setState({submitButtonDisabled: false, serverMessage: me.rb("login.invalidinput.msg")});
// 	}
// }
}},{key:'forgotPassword',value:function forgotPassword(){var me=this;if(this.state.source===''){return me.commonForgotPassword();}else if(this.state.source==='plp'){return me.plpForgotPassword();}else if(this.state.source==='lumos'){return me.lumosForgotPassword();}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row nomargin loginParent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-4 nopadding loginLeftSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'loginLeftContent'},this.renderFormTitle()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'charactercontainer d-none d-sm-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'charactericons forgotpwdIcon',src:__WEBPACK_IMPORTED_MODULE_12__images_icons_forgotpwdicon_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'loginRoot',className:'plpLogin col-sm-8'},this.forgotPassword()));}}]);return UnifiedForgotPwd;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (UnifiedForgotPwd);

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_HmEventRegistry__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var proClass='';// ES6 class-style
var za_Footer=function(_PreLoginPage){_inherits(za_Footer,_PreLoginPage);function za_Footer(props){_classCallCheck(this,za_Footer);var _this=_possibleConstructorReturn(this,(za_Footer.__proto__||Object.getPrototypeOf(za_Footer)).call(this,props));_this.state={error:null,isLoaded:false,items:[],ProductList:[],pro_detail:[],products:[],self:[],plp:[],products_details:{},products_category_order:[]};_this.grades=_this.props.grades;_this.productClass=_this.props.products_class;_this.productDetails=_this.props.products_details;_this.products_category=_this.props.products_category;_this.productClasses=_this.props.classes;_this.state.products=Object.keys(_this.products_category);_this.restricted=false;_this.userObj=null;_this.restrictedCategories=window.footerRestrictedProdCategories||[];return _this;}_createClass(za_Footer,[{key:'componentDidMount',value:function componentDidMount(){var _state=this.state,products=_state.products,self=_state.self,plp=_state.plp;this.grades=this.props.grades;this.productClass=this.props.products_class;this.productDetails=this.props.products_details;this.products_category=this.props.products_category;this.productClasses=this.props.classes;this.state.products=Object.keys(this.products_category);//HmEventRegistry.fireEvent("INITIATE_GA");
}},{key:'componentDidUpdate',value:function componentDidUpdate(){__WEBPACK_IMPORTED_MODULE_4__model_HmEventRegistry__["a" /* default */].fireEvent("INITIATE_GA_EVENT");}},{key:'render',value:function render(){var _state2=this.state,products=_state2.products,self=_state2.self,plp=_state2.plp;this.grades=this.props.grades;this.grades_order=this.props.grades_order;this.productClass=this.props.products_class;this.productDetails=this.props.products_details;this.products_category=this.props.products_category;this.productClasses=this.props.classes;this.state.products=Object.keys(this.products_category);this.state.products_category_order=this.props.products_category_order;var tifOptions=[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row follow-us'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-4 col-md-5 no-padding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'follow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Follow us on'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Footer - Follow Us - Facebook',href:'https://www.facebook.com/heymath',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fab fa-facebook-f'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Footer - Follow Us - Twitter',href:'http://twitter.com/heymath',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fab fa-twitter'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Footer - Follow Us - Linkedin',href:'http://linkedin.com/company/heymath',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fab fa-linkedin-in'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Footer - Follow Us - Youtube',href:'http://bit.ly/HeyMathYouTube',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fab fa-youtube'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-4 col-md norightpadding'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-lg-4 col-md nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-link text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'data-ga':'Footer - Contact Us',className:'r-btn contactbtn',onClick:this.props.showContactus},'Contact us')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 text-link '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-left'},'All rights reserved \xA9 ',this.rb("footer.copyright.year"),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'HeyMath!'),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 text-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Footer - Terms',href:this.getTermsUrl("ZA"),target:'_blank'},' Terms of Use'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'|'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-ga':'Footer - Privacy Policy',href:this.getUrlFor("LUMOS_PRIVACY"),target:'_blank'},' Privacy Policy')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-4 text-link'}))));}}]);return za_Footer;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (za_Footer);

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_device_detect__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_BrowserUtil__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_loginicon_png__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_icons_loginicon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_icons_loginicon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_CoreAjax__ = __webpack_require__(75);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var loginServerResponses={200:'Success.',600:'User ID expired.',700:'Invalid User ID or Password.',500:'An unexpected error occurred. Please try again after sometime or write to <a href="mailto:<email>"><email></a>.',0:'An unexpected error occurred. Please try again after sometime or write to <a href="mailto:support@heymath.com">support@heymath.com</a>.'};var UnifiedLogin=function(_PreLoginPage){_inherits(UnifiedLogin,_PreLoginPage);function UnifiedLogin(props){_classCallCheck(this,UnifiedLogin);var _this=_possibleConstructorReturn(this,(UnifiedLogin.__proto__||Object.getPrototypeOf(UnifiedLogin)).call(this,props));_this.hmNav=function(userobj){//console.log("UnifiedLogin hmnav "+this.navigateUrl)
/*if(this.props.liveFeed == "true" || this.props.liveFeed == true){
			window.top.location.href = "/";
			return;
		}*///console.log("this.navigateUrl::::"+this.navigateUrl);
if(this.navigateUrl===null){// Do nothing
}else if(this.navigateUrl=="/product-details"){window.top.location.href=this.navigateUrl;}else{if(this.productsAvailableToAccess(userobj)){window.top.location.href="/landing";}else{if(userobj&&userobj.userRole&&userobj.userRole.role&&userobj.userRole.role.toUpperCase()==="TCHR"){window.top.location.href="/teachers";}else{window.top.location.href=this.navigateUrl;}}}};_this.unifiedSubmitForm=function(){var formData={"userId":this.state.plp_userinput,"password":this.state.password};var me=this;me.setState({submitButtonDisabled:true});var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.source=="plp"){if(response.authenticated){//Setting user object at the browser level
me.getUser().store(response.user);me.storeRedirectUrl();try{me.doLumosLogout();}catch(e){}me.setState({submitButtonDisabled:false,source:response.source});try{var userObj=response.user;var loginObj={"user_id":userObj==null?"":userObj.userId,"login_id":me.state.plp_userinput,"user_agent":navigator.userAgent,"platform":navigator.platform,"device":__WEBPACK_IMPORTED_MODULE_9_react_device_detect__["isMobile"]?"mobile":__WEBPACK_IMPORTED_MODULE_9_react_device_detect__["isTablet"]?"tablet":"PC","ip_address":"ip_address","result":true,"session_id":userObj==null?"":userObj.authToken};me.storeTrackEvent("login",loginObj);}catch(e){}if(!me.tracked){me.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"logged-in"});me.tracked=true;}var afterUpdate=function afterUpdate(response){if(typeof me.props.callBack==="function"){me.props.callBack(response);return;}me.hmNav(response);};me.updateUserType(afterUpdate);}else{if(response.message=="provider_forbidden"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("google.errmsg.login")});}else{me.setState({submitButtonDisabled:false,serverMessage:me.rb(response.message)});}//me.showAlert(me.rb("alert"),me.rb(response.message));
me.trackMe(false);}}else if(response.source=="lumos"){try{me.doLumosLogout();}catch(e){}me.setState({submitButtonDisabled:false,serverMessage:me.rb("user_invalid")});/* try{
						me.doPLPLogout();
					}catch(e){}

					switch (response.code) {
						case 200:
						case 402:
							me.setState({source:response.source});
							window.top.location.href = response.link;
						break;
						case 500:
							//currentDialog.serverMessageElem.innerHTML = loginServerResponses[response.codeus].replace(/<email>/g, response.link);
							me.setState({ submitButtonDisabled: false, serverMessage: loginServerResponses[response.code].replace(/<email>/g, response.link)});
						break;
						case 600:
						case 700:
							//currentDialog.serverMessageElem.innerHTML = loginServerResponses[response.code];
							me.setState({ submitButtonDisabled: false, serverMessage: loginServerResponses[response.code] });
						break;
						default:
							//currentDialog.serverMessageElem.innerHTML = loginServerResponses[0];
							me.setState({ submitButtonDisabled: false, serverMessage: loginServerResponses[0]});
					} */}}};var PLPcallBackFailure=function PLPcallBackFailure(response){//console.log("response : ", response);
me.trackMe(false);me.setState({submitButtonDisabled:false});};var callBackFailure=function callBackFailure(response){//console.log("response : ", response);
//me.trackMe(false);
//me.setState({submitButtonDisabled: false});
new __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__["a" /* default */](me.getUrlFor("PLP_COMMON_LOGIN"),formData).enableCORS().post(callBackSuccess,PLPcallBackFailure);};//new HmAjax(this.getUrlFor("LOGIN"),formData).post(callBackSuccess,callBackFailure);
new __WEBPACK_IMPORTED_MODULE_7__util_NativeAjax__["a" /* default */](this.getUrlFor("LUMOS_COMMON_LOGIN"),formData).enableCORS().post(callBackSuccess,callBackFailure);me.getUser().clearOldUser();};_this.state={plp_userinput:_this.props.userid||"",password:'',submitButtonDisabled:false,serverMessage:_this.props.errMsg||"",source:"",loginType:_this.props.loginType||"userid",userLoginAllowed:false};_this.handleChange=_this.handleChange.bind(_this);_this.userIdChange=_this.userIdChange.bind(_this);_this.handlePasswordChange=_this.handlePasswordChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.showforgotPwd=_this.showforgotPwd.bind(_this);_this.showCreateAccount=_this.showCreateAccount.bind(_this);_this.googleLogin=_this.googleLogin.bind(_this);_this.toggle_GSignin=_this.toggle_GSignin.bind(_this);_this.myTrackerInstance=_this.getTracker();_this.navigationKey="PLP_Navigation";_this.navigateUrl=props.navigateURL||window.location.href;_this.gaFrom=_this.props.gaFrom;_this.gasignin=" - Returning User";//console.log("this.gaFrom:::::::::::",this.gaFrom);
if(_this.gaFrom=="Top"||_this.gaFrom=="Bottom"){_this.gaFrom=_this.gaFrom+" Home - Join";}else{_this.gaFrom="Sign In - Users who have independently registered";_this.gasignin="";}//console.log("this.gaFrom2222:::::::::::",this.gaFrom);
//console.log("UnifiedLogin Loading"+(this.navigateUrl || 'None'));  
return _this;}_createClass(UnifiedLogin,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var me=this;//console.log('componentWillReceiveProps', nextProps);    
this.setState({plp_userinput:nextProps.userid||"",password:'',submitButtonDisabled:false,serverMessage:"",source:"",loginType:nextProps.loginType||"userid"});this.gaFrom=nextProps.gaFrom;// console.log("this.gaFrom:::::::::::",this.gaFrom);
if(this.gaFrom=="Top"||this.gaFrom=="Bottom"){this.gaFrom=this.gaFrom+" Home - Join";}else{this.gaFrom="Users who have independently registered - Sign Up";}//console.log("this.gaFrom:::::::::::",this.gaFrom);
// console.log("UnifiedLogin Testing"+(this.navigateUrl || 'None'));  
}},{key:'componentDidMount',value:function componentDidMount(){//$(".socialLoginContainer").hide();
this.sessionCheck();}},{key:'handleChange',value:function handleChange(e){var _setState;var target=e.currentTarget;this.form.validateFields(target);this.setState((_setState={},_defineProperty(_setState,target.name,target.value),_defineProperty(_setState,'submitButtonDisabled',!this.form.isValid()),_setState));}},{key:'userIdChange',value:function userIdChange(e){var target=e.currentTarget;// var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
// if(phoneRegx.test(target.value)){
// 	this.setState({loginType:"mobile", serverMessage: ""});
// }else{
// 	this.setState({loginType:"email", serverMessage: ""});
// }
this.setState({loginType:"email",serverMessage:""});this.handleChange(e);}},{key:'handlePasswordChange',value:function handlePasswordChange(e){this.handleChange(e);}},{key:'productsAvailableToAccess',value:function productsAvailableToAccess(userobj){var user=userobj;//console.log("user::::",user);
if(user!=null){var permissions=user.entlHistory;//console.log("permissions:::",permissions);
if(permissions!=null&&Object.keys(permissions).length>0){for(var i in permissions){if(permissions[i]!=null){var totalLevel=permissions[i].split(",").reduce(function(a,b){try{return parseInt(a)+parseInt(b);}catch(e){return 0;}});if(totalLevel>0){return true;}}}}}return false;}},{key:'storeRedirectUrl',value:function storeRedirectUrl(){var redirectUrl=null;/*if(BrowserUtil.getCookie("loginSrc") && BrowserUtil.getCookie("loginSrc").length > 10){
			redirectUrl = (BrowserUtil.getCookie("loginSrc")).replace(/"/g,"");
		}

		if(redirectUrl){
			BrowserStorageUtil.storeItem("loginSrc", redirectUrl);
		}*/}//testplpum.heymath.com/additionalInfo/update
},{key:'updateUserType',value:function updateUserType(commonCallback){var me=this;var callBackSuccess=function callBackSuccess(response){if(response!==null){//console.warn("user type",response)
me.getUser().store(response);}if(typeof commonCallback==="function"){commonCallback.apply(this,[response]);}};var callBackFailure=function callBackFailure(response){//console.warn("failure ",response);
if(typeof commonCallback==="function"){commonCallback.apply(this);}};_get(UnifiedLogin.prototype.__proto__||Object.getPrototypeOf(UnifiedLogin.prototype),'updateUserType',this).call(this,callBackSuccess,callBackFailure);}},{key:'getUserStatus',value:function getUserStatus(){if(this.state.plp_userinput.length<=0){return;}var formData={"verificationId":this.state.plp_userinput};var me=this;var callBackSuccess=function callBackSuccess(response){if(response!==null){//console.log("response : ", response,"me.props.from:::",me.props.from);					
if(response.user_exists){me.setState({userLoginAllowed:true});}else{if(response.message=="provider_forbidden"){me.setState({submitButtonDisabled:false,serverMessage:me.rb("google.errmsg.login")});}else{//me.setState({userLoginAllowed:false});
//me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
me.checkValidUserInput();}}}};var callBackFailure=function callBackFailure(response){//console.log("response : ", response);	
me.setState({submitButtonDisabled:false});};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("GET_USER_STATUS")+this.state.loginType,formData).post(callBackSuccess,callBackFailure);}},{key:'checkValidUserInput',value:function checkValidUserInput(){var me=this;var userinput=this.state.plp_userinput;if(userinput.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){me.setState({userLoginAllowed:false});me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);}else{me.setState({submitButtonDisabled:false,serverMessage:me.rb("za_login.invalidinput.msg")});}// var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
// if(phoneRegx.test(userinput)){			
// 	if(userinput.length == 10){				
// 		me.setState({userLoginAllowed:false});
// 		me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
// 	}else{
// 		me.setState({submitButtonDisabled: false, serverMessage: me.rb("login.invalidinput.msg")});
// 	}
// }else{
// 	if(userinput.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){
// 		me.setState({userLoginAllowed:false});
// 		me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
// 	}else{
// 		me.setState({submitButtonDisabled: false, serverMessage: me.rb("login.invalidinput.msg")});
// 	}
// }
}},{key:'doLumosLogout',value:function doLumosLogout(){_get(UnifiedLogin.prototype.__proto__||Object.getPrototypeOf(UnifiedLogin.prototype),'doLumosLogout',this).call(this);}},{key:'doPLPLogout',value:function doPLPLogout(){var me=this;var callBackSuccess=function callBackSuccess(resp){me.UserStore.clearOldUser();//me.initiateTrack("logout",{});
// setTimeout(function(){
// 	me.UserStore.clearOldUser();
// 	window.location.href = me.getUrlFor("PRELOGIN_PAGE");
// },500);
};var callBackFailure=function callBackFailure(resp){console.error("Logout failed.");};_get(UnifiedLogin.prototype.__proto__||Object.getPrototypeOf(UnifiedLogin.prototype),'doPLPLogout',this).call(this,callBackSuccess,callBackFailure);}},{key:'handleSubmit',value:function handleSubmit(e){e.preventDefault();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){this.unifiedSubmitForm();// if(this.state.userLoginAllowed){
// 	this.submitForm();  
// }else{
// 	this.getUserStatus();
// }
}}},{key:'trackMe',value:function trackMe(result){var userObj=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var trackObj={"user_id":userObj==null?"":userObj.userId,"login_id":this.state.plp_userinput,"user_agent":navigator.userAgent,"platform":navigator.platform,"device":__WEBPACK_IMPORTED_MODULE_9_react_device_detect__["isMobile"]?"mobile":__WEBPACK_IMPORTED_MODULE_9_react_device_detect__["isTablet"]?"tablet":"PC","ip_address":"ip_address","result":result===true,"session_id":userObj==null?"":userObj.authToken};this.initiateTrack("login",trackObj);}},{key:'showCreateAccount',value:function showCreateAccount(){if(!this.tracked){this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"signin-signup"});this.tracked=true;}this.props.callbackCreateAccount(this.navigateUrl,this.props.freetrail);}},{key:'showforgotPwd',value:function showforgotPwd(){this.props.callbackForgotPwd(this.state.source);}},{key:'googleLogin',value:function googleLogin(){if(!this.tracked){this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"signin-googlesignin"});this.tracked=true;}var navigateObj={navigateURL:this.navigateUrl};__WEBPACK_IMPORTED_MODULE_10__util_BrowserStorageUtil__["a" /* default */].storeSessionItem(this.navigationKey,JSON.stringify(navigateObj));window.top.location.href=this.getUrlFor("GOOGLE_LOGIN_API");}},{key:'toggle_GSignin',value:function toggle_GSignin(e){var me=this;__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".socialLoginContainer").slideToggle("fast","swing",function(){if(__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".showmore-signin").text()==me.rb("unified_login.show_more")){__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".showmore-signin").css("color","#8b9095");__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".showmore-signin").text(me.rb("unified_login.Hide"));}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".showmore-signin").css("color","#01babd");__WEBPACK_IMPORTED_MODULE_3_jquery___default()(".showmore-signin").text(me.rb("unified_login.show_more"));}});}},{key:'render',value:function render(){var _this2=this;if(this.state.loggedIn){return _get(UnifiedLogin.prototype.__proto__||Object.getPrototypeOf(UnifiedLogin.prototype),'render',this).call(this);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row nomargin loginParent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-4 nopadding loginLeftSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'loginLeftContent'},this.rb("unified_login.login")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'charactercontainer d-none d-sm-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'charactericons loginIcon',src:__WEBPACK_IMPORTED_MODULE_12__images_icons_loginicon_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'loginRoot',className:'plpLogin col-sm-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 mx-auto nopadding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rounded-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this2.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'plp_userinput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'plp_userinput',className:"plp_userinput "+this.state.loginType,name:'plp_userinput',placeholder:this.rb("unifiedlogin.userplaceholder"),value:this.state.plp_userinput,onChange:this.userIdChange,required:true,minLength:1,maxLength:254,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'plp_userinput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("za_unifiedlogin.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),function(){// if(this.state.userLoginAllowed){
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'password'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'password',name:'password',placeholder:_this2.rb("login.password"),innerRef:function innerRef(password){return _this2.password=password;},value:_this2.state.password,onChange:_this2.handlePasswordChange,required:true,minLength:1,maxLength:50,tabIndex:'4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'password',show:'all'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},_this2.rb("login.pwdrequired")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':"Home - "+_this2.gaFrom+_this2.gasignin+" - Forgot Password",className:'text-right ufd-forgotPassword josefinsansFont',onClick:_this2.showforgotPwd},_this2.rb("forgot_password")));// }
}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages'},this.state.serverMessage),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-ga':"Home - "+this.gaFrom+this.gasignin+"  - Sign In",disabled:this.state.submitButtonDisabled,className:'submitButton'},this.rb("unified_login.login")))))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 pt-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center josefin showmore-signin'},this.rb("za_unified_login.or")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'socialLoginContainer text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':"Home - "+this.gaFrom+this.gasignin+" - Continue with Google",className:'socialLoginButtons google',onClick:this.googleLogin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fab fa-google'}),this.rb("login.continuegoogle"))))))));}}}]);return UnifiedLogin;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (UnifiedLogin);

/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_LoginForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_UserStore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_icons_signupicon_png__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_icons_signupicon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_icons_signupicon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_icons_freetrailicon_png__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_icons_freetrailicon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_icons_freetrailicon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_reactstrap__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__login_SelectDropdown__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__login_RadioButtons__ = __webpack_require__(301);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SignupForm=function(_PreLoginPage){_inherits(SignupForm,_PreLoginPage);function SignupForm(props){_classCallCheck(this,SignupForm);var _this=_possibleConstructorReturn(this,(SignupForm.__proto__||Object.getPrototypeOf(SignupForm)).call(this,props));_this.hmNav=function(userObj){if(userObj&&userObj.userRole&&userObj.userRole.role&&userObj.userRole.role.toUpperCase()==="TCHR"){window.top.location.href="/teachers";}else{window.top.location.href=this.props.navigateURL;}//this.props.myProps.history.push(this.props.navigateURL);
};_this.setClassesForTCHR=function(evt){if(evt&&evt.length>0){this.classesTeaching=this.rb("dropdown.classes.tchr.prefix");for(var i=0;i<evt.length;i++){if(evt[i]&&evt[i].label&&evt[i].label.length>0){var evtArr=evt[i].label.split(" ");this.classesTeaching+=evtArr[evtArr.length-1]+",";}}this.classesTeaching=this.classesTeaching.substr(0,this.classesTeaching.length-1);//console.log("lalalalla:::", this.classesTeaching);
}};_this.submitForm=function(){var verificationtype=this.state.loginType;var formData={"userName":this.state.username_newacc,"loginId":this.state.userInput,"userRole":{"role":this.state.selectedRole||"STU","level":"1"},"token":this.state.otp_newacc,"countryCode":null,"password":this.state.password_newacc,"verificationType":verificationtype,"regnProvider":"heymath","schoolName":this.state.schoolname_newacc,//Shyam
"location":this.state.address_newacc,"classesTeaching":this.classesTeaching,"userOrigin":this.userReferal};if(this.state.loginType=="mobile"){formData["phone"]=this.state.userInput;}else{formData["email"]=this.state.userInput;}var me=this;me.setState({submitButtonDisabled:true});var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status.toLowerCase()=="success"){new __WEBPACK_IMPORTED_MODULE_7__util_UserStore__["a" /* default */]().store(response.user);//me.props.successRegisterMsg(me.rb("register.success.msg"));
try{me.doLumosLogout();}catch(e){}me.trackMe(true,"set_password");var afterUpdate=function afterUpdate(){me.hmNav(response.user);};me.updateUserType(afterUpdate);}else{if(response.status=="user_exists"){me.setState({serverMessage:"User already exists",submitButtonDisabled:false});}else if(response.status=="no_such_token"){me.setState({serverMessage:"The OTP entered is incorrect",submitButtonDisabled:false});}else if(response.status=="error"){me.setState({serverMessage:"Internal error occured",submitButtonDisabled:false});}else if(response.status=="empty_inputs"){me.setState({serverMessage:"Please enter all the fields",submitButtonDisabled:false});}else if(response.status=="token_not_verified"){me.setState({serverMessage:"Passcode Verification is required",submitButtonDisabled:false});}else if(response.status=="provider_forbidden"){me.setState({serverMessage:"Already registered with Gmail ID. Please click continue with Google",submitButtonDisabled:false});}else{me.setState({serverMessage:response.status,submitButtonDisabled:false});}me.trackMe(false,"set_password");}}console.log("response : ",response);};var callBackFailure=function callBackFailure(response){console.log("Error in CREATE_REGISTER");me.setState({submitButtonDisabled:false});me.showAlert("","Error in CREATE_REGISTER");me.trackMe(false,"set_password");};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("CREATE_REGISTER"),formData).post(callBackSuccess,callBackFailure);new __WEBPACK_IMPORTED_MODULE_7__util_UserStore__["a" /* default */]().clearOldUser();};_this.state={username_newacc:'',password_newacc:'',confirmpassword_newacc:'',singupType:"userid",loginType:_this.props.loginType||"userid",userInput:_this.props.userInput||"",otp_newacc:'',submitButtonDisabled:false,serverMessage:"",emailfeedbackmsg:"",source:"plp",isOTPSend:false,isVerified:false,OTPDisabled:"hiddenOTP",verifyDisabled:"disabled",emailDisabled:false,phoneDisabled:false,verifyText:_this.rb("register.verify"),sendOTPText:_this.rb("register.sendOTP"),passcodeDisabled:"disabled",selectedRole:"STU"};_this.classesTeaching=null;//this.selectedRole = null;
_this.userReferal=null;_this.navigationKey="PLP_Navigation";_this.handleChange=_this.handleChange.bind(_this);_this.enterOTPChange=_this.enterOTPChange.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.userIdChange=_this.userIdChange.bind(_this);_this.googleLogin=_this.googleLogin.bind(_this);_this.sendOTP=_this.sendOTP.bind(_this);_this.verifyOTP=_this.verifyOTP.bind(_this);_this.getOTPField=_this.getOTPField.bind(_this);_this.handleKeyUp=_this.handleKeyUp.bind(_this);_this.radioSelected=_this.radioSelected.bind(_this);_this.setCentaReference=_this.setCentaReference.bind(_this);_this.setUserOrigin=_this.setUserOrigin.bind(_this);_this.setClassesForTCHR=_this.setClassesForTCHR.bind(_this);_this.googleLogin=_this.googleLogin.bind(_this);_this.isFreeTrialAllowed=_this.isFreeTrialAllowed.bind(_this);_this.myTrackerInstance=_this.getTracker();_this.gaFrom=_this.props.gaFrom;console.log("this.gaFrom:::::::::::",_this.gaFrom);if(_this.gaFrom=="Top"||_this.gaFrom=="Bottom"){_this.gaFrom=_this.gaFrom+" Home - Join";}else{_this.gaFrom="Users who have independently registered - Sign Up";}console.log("this.gaFrom2222:::::::::::",_this.gaFrom);return _this;}_createClass(SignupForm,[{key:'isFreeTrialAllowed',value:function isFreeTrialAllowed(val){var userRole=val||null;if(userRole&&userRole.length>1&&window.noFreeTrialRoles&&window.noFreeTrialRoles.length>0){return!~window.noFreeTrialRoles.indexOf(userRole);}//user not logged in or role not defined latter is unlikely or no suppression in window.noFreeTrialRoles
return true;}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var me=this;this.gaFrom=nextProps.gaFrom;console.log("this.gaFrom:::::::::::",this.gaFrom);if(this.gaFrom=="Top"||this.gaFrom=="Bottom"){this.gaFrom=this.gaFrom+" Home - Join";}else{this.gaFrom="Users who have independently registered - Sign Up";}console.log("this.gaFrom:::::::::::",this.gaFrom);console.log('componentWillReceiveProps',nextProps);this.setState({loginType:nextProps.loginType||"userid",userInput:nextProps.userInput||"",otp_newacc:'',submitButtonDisabled:false,serverMessage:"",emailfeedbackmsg:"",source:"plp",isOTPSend:false,isVerified:false,OTPDisabled:"hiddenOTP",verifyDisabled:"disabled",emailDisabled:false,phoneDisabled:false,verifyText:this.rb("register.verify"),sendOTPText:this.rb("register.sendOTP"),passcodeDisabled:"disabled"});setTimeout(function(){me.reinitiate();},500);}},{key:'componentDidMount',value:function componentDidMount(){var me=this;this.sessionCheck();setTimeout(function(){me.reinitiate();},200);}},{key:'reinitiate',value:function reinitiate(){console.log("reinitiate gaFrom:::::::::::",this.gaFrom);if(this.state.userInput!=""){this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){this.setState({OTPDisabled:""});__WEBPACK_IMPORTED_MODULE_8_jquery___default()(".OTPButton").trigger("click");}}__WEBPACK_IMPORTED_MODULE_8_jquery___default()("#loginRoot .userInput").focus();}},{key:'handleChange',value:function handleChange(e){var _setState;var target=e.currentTarget;//console.log("target=",target);
this.form.validateFields(target);this.setState((_setState={},_defineProperty(_setState,target.name,target.value),_defineProperty(_setState,'serverMessage',""),_defineProperty(_setState,'submitButtonDisabled',!this.form.isValid()),_setState));}},{key:'userIdChange',value:function userIdChange(e){var _setState2;var target=e.currentTarget;this.form.validateFields(target);// var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
// if(phoneRegx.test(target.value)){
// 	this.setState({loginType:"mobile",loginMaxLength:10,OTPDisabled: "hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});
// 	if(target.value.length >= 10){				
// 		this.setState({ OTPDisabled: "",passcodeDisabled:""});
// 	}
// }else{
// 	this.setState({loginType:"email",loginMaxLength:254,OTPDisabled: "hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});
// 	if(target.value.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){
// 		this.setState({ OTPDisabled: "",passcodeDisabled:""});
// 	}
// }
this.setState({loginType:"email",loginMaxLength:254,OTPDisabled:"hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});if(target.value.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){this.setState({OTPDisabled:"",passcodeDisabled:""});}this.setState((_setState2={},_defineProperty(_setState2,target.name,target.value),_defineProperty(_setState2,'serverMessage',""),_defineProperty(_setState2,'submitButtonDisabled',true),_setState2));}},{key:'enterOTPChange',value:function enterOTPChange(e){if(this.otp.value.length>0){this.setState({verifyDisabled:""});}else{this.setState({verifyDisabled:"disabled"});}this.handleChange(e);}//Shyam
},{key:'setUserOrigin',value:function setUserOrigin(referal){this.userReferal=referal;}},{key:'setCentaReference',value:function setCentaReference(evt){if(evt&&evt.currentTarget&&evt.currentTarget.value){if(evt.currentTarget.value.length>0&&evt.currentTarget.value.toLowerCase()==="yes"){this.setUserOrigin("centa");}}}},{key:'updateUserType',value:function updateUserType(commonCallback){var me=this;var callBackSuccess=function callBackSuccess(response){if(response!==null){//console.warn("user type",response)
me.getUser().store(response);}if(typeof commonCallback==="function"){commonCallback.apply(this);}};var callBackFailure=function callBackFailure(response){//console.warn("failure ",response);
if(typeof commonCallback==="function"){commonCallback.apply(this);}};_get(SignupForm.prototype.__proto__||Object.getPrototypeOf(SignupForm.prototype),'updateUserType',this).call(this,callBackSuccess,callBackFailure);}},{key:'trackMe',value:function trackMe(result,source){var trackObj={"name":this.state.username_newacc,"email":this.state.loginType=="mobile"?"":this.state.userInput,"phone":this.state.loginType=="mobile"?this.state.userInput:"","event_source":this.getTracker().enums.signupEventSource[source],"result":result};if(source=="set_password"){this.storeTrackEvent("signup",trackObj);}else{this.initiateTrack("signup",trackObj);}}},{key:'handleSubmit',value:function handleSubmit(e){e.preventDefault();this.form.validateFields();this.setState({submitButtonDisabled:!this.form.isValid()});if(this.form.isValid()){if(this.state.isOTPSend&&this.state.isVerified){this.submitForm();}}}},{key:'sendOTP',value:function sendOTP(){if(this.state.OTPDisabled=="hiddenOTP"){this.form.validateFields();return;}var me=this;var otpServerMsg="";if(this.state.loginType=="mobile"){if(me.state.isOTPSend){otpServerMsg="OTP is sent again to mobile";}else{otpServerMsg="OTP is sent to your mobile";}}else{if(me.state.isOTPSend){otpServerMsg="OTP is sent again to your email";}else{otpServerMsg="OTP is sent to your email";}}me.setState({serverMessage:"",emailfeedbackmsg:"",isOTPSend:false,isVerified:false,verifyDisabled:"disabled",otp_newacc:"",passcodeDisabled:"disabled"});var formData={"contactId":this.state.userInput,"contactType":this.state.loginType};var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status){if(response.status=="user_exists"){me.setState({serverMessage:"User already exists",passcodeDisabled:""});}else if(response.status=="no_such_token"){me.setState({serverMessage:"The OTP entered is incorrect",passcodeDisabled:""});}else if(response.status=="error"){me.setState({serverMessage:"Internal error occured",passcodeDisabled:""});}else{me.setState({emailfeedbackmsg:otpServerMsg,passcodeDisabled:""});}}if(response.status=="success"){me.setState({isOTPSend:true,passcodeDisabled:"disabled"});me.trackMe(true,"send_otp");}else{me.trackMe(false,"send_otp");}}console.log("response : ",response);};var callBackFailure=function callBackFailure(response){console.log("Error in CREATE_SENDVERIFICATION_TOKEN");me.setState({passcodeDisabled:""});me.trackMe(false,"send_otp");};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("CREATE_SENDVERIFICATION_TOKEN"),formData).post(callBackSuccess,callBackFailure);}},{key:'verifyOTP',value:function verifyOTP(){var me=this;me.setState({serverMessage:""});var verificationtype=this.state.loginType;var formData={"verificationId":this.state.userInput};this.setState({verifyDisabled:"disabled"});var callBackSuccess=function callBackSuccess(response){if(response!==null){if(response.status){if(response.status=="user_exists"){me.setState({serverMessage:"User already exists",verifyDisabled:""});me.trackMe(false,"verify_otp");}else if(response.status=="no_such_token"){me.setState({serverMessage:"The OTP entered is incorrect",verifyDisabled:""});me.trackMe(false,"verify_otp");}else if(response.status=="error"){me.setState({serverMessage:"Internal error occured",verifyDisabled:""});me.trackMe(false,"verify_otp");}else{me.setState({isVerified:true,verifyDisabled:""});me.trackMe(true,"verify_otp");}}}console.log("response : ",response);};var callBackFailure=function callBackFailure(response){console.log("Error in CREATE_SENDVERIFICATION_TOKEN");me.setState({verifyDisabled:""});me.trackMe(false,"verify_otp");};new __WEBPACK_IMPORTED_MODULE_6__util_HmAjax__["a" /* default */](this.getUrlFor("CREATE_VERIFY_EMAIL")+verificationtype+"/"+this.state.otp_newacc,formData).post(callBackSuccess,callBackFailure);}},{key:'getOTPField',value:function getOTPField(){var _this2=this;if(this.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'otp_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'otp_newacc',className:'otp_newacc',name:'otp_newacc',placeholder:this.rb("register.enterOTP"),innerRef:function innerRef(otp){return _this2.otp=otp;},onKeyUp:this.handleKeyUp,value:this.state.otp_newacc,onChange:this.enterOTPChange,required:true,minLength:1,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'otp_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("register.enterOTP")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'})));}}},{key:'getVerifyField',value:function getVerifyField(){if(this.state.isOTPSend&&!this.state.isVerified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':"Home - "+this.gaFrom+" - New User - Verify",className:"submitButton verifyButton "+this.state.verifyDisabled,onClick:this.verifyOTP},this.rb("register.verify"));}/*else if(this.state.isOTPSend && this.state.isVerified){
			return (<div className="text-right verifytxt"><i class="material-icons">done</i> <span>{this.rb("register.verified")}</span></div>);
		}*/}},{key:'getSignupHeaderMsg',value:function getSignupHeaderMsg(){if(this.state.isOTPSend&&!this.state.isVerified){if(this.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Please verify your number')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10'},'A 6-digit OTP has been sent to your mobile number for verification'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Please verify your Email')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10'},'A 6-digit OTP has been sent to your Email for verification'));}}else if(this.state.isVerified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Congratulations')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small infogrey mt-10'},'You are almost set. Enter your Name and set password to start learning.'));}}},{key:'sendOTPText',value:function sendOTPText(){if(this.state.isOTPSend){return this.rb("register.reSendOTP");}else{return this.rb("register.sendOTP");}}},{key:'showEmailFeedback',value:function showEmailFeedback(){var _this3=this;if(this.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-control-feedback'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error'},this.state.emailfeedbackmsg),function(){if(_this3.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedbacksmall'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'All important information will be sent to this mobile number'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedbacksmall'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'All important information will be sent to this email ID'));}}());}}},{key:'getUserInputPattern',value:function getUserInputPattern(){if(this.state.loginType=="mobile"){return".{10,}";}else{return"^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$";}}},{key:'radioSelected',value:function radioSelected(evt){var val=evt.currentTarget.value;if(val&&val.length>0){//this.selectedRole = val;
this.setState({selectedRole:val});/*alert(val);*/}return true;}},{key:'getContactType',value:function getContactType(){var _this4=this;if(!this.state.isVerified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,function(){var user=_this4.props.signupUser||'student';if(user==='student'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'col-md-12 mt-30 signup-radio'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 radio-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-check-input',type:'radio',name:'student',value:'STU',id:'student_select',onChange:_this4.radioSelected,defaultChecked:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-check-label',htmlFor:'student_select'},'Student/Parent')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-6 radio-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-check-input',type:'radio',name:'student',value:'TCHR',id:'teacher_select',onChange:_this4.radioSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-check-label',htmlFor:'teacher_select'},'Teacher')));}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'userInput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'userInput',className:"userInput "+this.state.loginType,name:'userInput',placeholder:this.rb("login.userplaceholder.za"),innerRef:function innerRef(email){return _this4.email=email;},onKeyUp:this.handleKeyUp,value:this.state.userInput,onChange:this.userIdChange,pattern:this.getUserInputPattern(),required:true,minLength:1,maxLength:this.state.loginMaxLength,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'2'}),function(){if(_this4.state.loginType=="mobile"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'userInput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},_this4.rb("za_login.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},_this4.rb("register.mobilenolength")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length>0&&!/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g.test(value);}},_this4.rb("register.numbersonly")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'userInput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},_this4.rb("za_login.useridrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'patternMismatch'},_this4.rb("fpwd.validemail")));}}()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),this.getOTPField(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages pt-20'},this.state.serverMessage),function(){if(_this4.state.isOTPSend){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clearfix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this4.rb("register.reSendOTPmsg"),' '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'data-ga':"Home - "+_this4.gaFrom+" - New User - Resend",className:'pl-10 resendButton',onClick:_this4.sendOTP},_this4.rb("register.reSendOTP"))),_this4.getVerifyField());}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this4.getVerifyField(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':"Home - "+_this4.gaFrom+" - New User - Send Passcode",className:"submitButton OTPButton "+_this4.state.OTPDisabled+" "+_this4.state.passcodeDisabled,onClick:_this4.sendOTP},_this4.rb("register.sendOTP"))));}}());}}},{key:'getStep2TeachersForm',value:function getStep2TeachersForm(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'username_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'username_newacc',className:'username_newacc',name:'username_newacc',placeholder:this.rb("billing.fullname"),value:this.state.username_newacc,onChange:this.handleChange,required:true,minLength:1,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'username_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.namerequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'schoolname_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'schoolname_newacc',className:'schoolname_newacc',name:'schoolname_newacc',placeholder:this.rb("billing.schoolname"),value:this.state.schoolname_newacc,onChange:this.handleChange,required:true,minLength:1,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'schoolname_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.schoolrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'address_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'address_newacc',className:'address_newacc',name:'address_newacc',placeholder:this.rb("billing.location"),value:this.state.address_newacc,onChange:this.handleChange,required:true,minLength:1,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'address_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.addressrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'password_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'password_newacc',name:'password_newacc',placeholder:this.rb("login.password"),innerRef:function innerRef(password){return _this5.password=password;},value:this.state.password_newacc,onChange:this.handleChange,required:true,minLength:6,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'password_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("login.pwdrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("validate.pwd.minimum",[6])))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'confirmpassword'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'confirmpassword_newacc',name:'confirmpassword_newacc',placeholder:this.rb("rpwd.confirmpwd"),innerRef:function innerRef(confirmpassword){return _this5.confirmpassword=confirmpassword;},value:this.state.confirmpassword_newacc,onChange:this.handleChange,required:true,minLength:6,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'confirmpassword_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("rpwd.confirmpwdrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("validate.pwd.minimum",[6])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value!==_this5.password.value;}},this.rb("rpwd.doesnotmatch")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages pt-20'},this.state.serverMessage));}},{key:'getStep2StudentsForm',value:function getStep2StudentsForm(){var _this6=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'username_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'username_newacc',className:'username_newacc',name:'username_newacc',placeholder:this.rb("billing.fullname"),value:this.state.username_newacc,onChange:this.handleChange,required:true,minLength:1,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'username_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("billing.namerequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'*'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'password_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'password_newacc',name:'password_newacc',placeholder:this.rb("login.password"),innerRef:function innerRef(password){return _this6.password=password;},value:this.state.password_newacc,onChange:this.handleChange,required:true,minLength:6,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'password_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("login.pwdrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("validate.pwd.minimum",[6])))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormGroup"],{'for':'confirmpassword'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FormControlInput"],{type:'password',className:'confirmpassword_newacc',name:'confirmpassword_newacc',placeholder:this.rb("rpwd.confirmpwd"),innerRef:function innerRef(confirmpassword){return _this6.confirmpassword=confirmpassword;},value:this.state.confirmpassword_newacc,onChange:this.handleChange,required:true,minLength:6,maxLength:50,autoCapitalize:'none',autoComplete:'off',autoCorrect:'off',spellCheck:'false',tabIndex:'5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_form_with_constraints_bootstrap4__["FieldFeedbacks"],{'for':'confirmpassword_newacc'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:'valueMissing'},this.rb("rpwd.confirmpwdrequired")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value.length<6;}},this.rb("validate.pwd.minimum",[6])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FieldFeedback"],{when:function when(value){return value!==_this6.password.value;}},this.rb("rpwd.doesnotmatch")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear clearfix'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'server-messages pt-20'},this.state.serverMessage));}},{key:'setPassword',value:function setPassword(){if(this.state.isVerified){if(this.state.selectedRole==="TCHR"){return this.getStep2TeachersForm();}else{return this.getStep2StudentsForm();}}}},{key:'googleLogin',value:function googleLogin(){var navigateObj={navigateURL:this.props.navigateURL};__WEBPACK_IMPORTED_MODULE_3__util_BrowserStorageUtil__["a" /* default */].storeSessionItem(this.navigationKey,JSON.stringify(navigateObj));if(!this.tracked){this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"signin-googlesignin"});this.tracked=true;}window.top.location.href=this.getUrlFor("GOOGLE_LOGIN_API");}},{key:'handleKeyUp',value:function handleKeyUp(event){if(event.key==='Enter'&&this.form.isValid()){if(!this.state.isVerified){if(this.state.isOTPSend&&this.state.verifyDisabled!="disabled"){__WEBPACK_IMPORTED_MODULE_8_jquery___default()(".verifyButton").trigger("click");}else if(this.state.passcodeDisabled!="disabled"){this.setState({OTPDisabled:""});__WEBPACK_IMPORTED_MODULE_8_jquery___default()(".OTPButton").trigger("click");}}}}},{key:'GoogleLoginShow',value:function GoogleLoginShow(){if(this.state.isOTPSend==false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loginTop pt-15'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center josefin mt-20'},'OR'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'socialLoginContainer text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'data-ga':"Home - Users who have independently registered - Sign Up - New User - Sign in with Google - Start Learning",className:'socialLoginButtons google',onClick:this.googleLogin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fab fa-google'}),this.rb("login.google"))));}}},{key:'render',value:function render(){var _this7=this;if(this.state.loggedIn){return _get(SignupForm.prototype.__proto__||Object.getPrototypeOf(SignupForm.prototype),'render',this).call(this);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row nomargin loginParent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-sm-4 col-lg-4 nopadding loginLeftSection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'loginLeftContent'},this.rb("unified_login.joinincaptital")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'charactercontainer d-none d-sm-block'},function(){if(_this7.state.selectedRole&&_this7.isFreeTrialAllowed(_this7.state.selectedRole)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,function(){if(window.free_trial_extension&&window.free_trial_extension.toggle==='days'&&window.free_trial_extension.days===30){if(_this7.props.navigateURL!="/product-details"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'charactericons freetrailIcon',src:__WEBPACK_IMPORTED_MODULE_10__images_icons_freetrailicon_png___default.a});}else if(_this7.props.freetrail=="true"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'charactericons freetrailIcon',src:__WEBPACK_IMPORTED_MODULE_10__images_icons_freetrailicon_png___default.a});}}}());}}(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'charactericons signupIcon',src:__WEBPACK_IMPORTED_MODULE_9__images_icons_signupicon_png___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'loginRoot',className:'plpLogin col-sm-8 col-lg-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-md-12 mx-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rounded-0'},this.getSignupHeaderMsg(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_form_with_constraints__["FormWithConstraints"],{ref:function ref(formWithConstraints){return _this7.form=formWithConstraints;},onSubmit:this.handleSubmit,noValidate:true},this.getContactType(),this.setPassword(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-ga':"Home - Users who have independently registered - Sign Up - New User - Start Learning",disabled:this.state.submitButtonDisabled,className:"submitButton signup signupButton "+(this.state.isVerified?"":"hidden")},this.rb("register.startlearning")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),this.GoogleLoginShow())))))))));}}}]);return SignupForm;}(__WEBPACK_IMPORTED_MODULE_1__views_core_PreLoginPage__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (SignupForm);

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CorePage__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toastify__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toastify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toastify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_toastify_dist_ReactToastify_css__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_toastify_dist_ReactToastify_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_toastify_dist_ReactToastify_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_html_parser__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var toastStatus={error:false,warn:false,info:false,success:false};var toastAutoCloseTime=5000;var ToastPage=function(_CorePage){_inherits(ToastPage,_CorePage);function ToastPage(props){_classCallCheck(this,ToastPage);return _possibleConstructorReturn(this,(ToastPage.__proto__||Object.getPrototypeOf(ToastPage)).call(this,props));}_createClass(ToastPage,[{key:'componentDidMount',value:function componentDidMount(){console.log("ToastPage componentDidMount");}},{key:'showToast',value:function showToast(toastdata){console.log("Toast Fired");var level=toastdata.level;if(level==="error"){this.error(toastdata);}else if(level==="warn"){this.warn(toastdata);}else if(level==="success"){this.success(toastdata);}else{this.info(toastdata);}}},{key:'warn',value:function warn(toastdata){var me=this;__WEBPACK_IMPORTED_MODULE_5_react_toastify__["toast"].warn(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_7_react_html_parser___default()(me.rb(toastdata.msg))),{position:"top-center",autoClose:toastAutoCloseTime,hideProgressBar:true,closeOnClick:true,pauseOnHover:true,draggable:true});}},{key:'info',value:function info(toastdata){var me=this;__WEBPACK_IMPORTED_MODULE_5_react_toastify__["toast"].info(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_7_react_html_parser___default()(me.rb(toastdata.msg))),{position:"top-center",autoClose:toastAutoCloseTime,hideProgressBar:true,closeOnClick:true,pauseOnHover:true,draggable:true});}},{key:'error',value:function error(toastdata){var me=this;__WEBPACK_IMPORTED_MODULE_5_react_toastify__["toast"].error(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_7_react_html_parser___default()(me.rb(toastdata.msg))),{position:"top-center",autoClose:toastAutoCloseTime,hideProgressBar:true,closeOnClick:true,pauseOnHover:true,draggable:true});}},{key:'success',value:function success(toastdata){var me=this;__WEBPACK_IMPORTED_MODULE_5_react_toastify__["toast"].success(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_7_react_html_parser___default()(me.rb(toastdata.msg))),{position:"top-center",autoClose:toastAutoCloseTime,hideProgressBar:true,closeOnClick:true,pauseOnHover:true,draggable:true});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_toastify__["ToastContainer"],null),this.showToast(this.props.toastmsg));}}]);return ToastPage;}(__WEBPACK_IMPORTED_MODULE_2__CorePage__["a" /* default */]);/* unused harmony default export */ var _unused_webpack_default_export = (ToastPage);__WEBPACK_IMPORTED_MODULE_3__model_HmEventRegistry__["a" /* default */].registerEvent("DESKTOP_EXP_TOAST",function(obj){//Disabled for co.za
return;var level=obj&&obj.level?obj.level:"info";var toastTime=!isNaN(__WEBPACK_IMPORTED_MODULE_4__util_BrowserStorageUtil__["a" /* default */].getStoredItem("WARN_TOAST_TIME"))?Number(__WEBPACK_IMPORTED_MODULE_4__util_BrowserStorageUtil__["a" /* default */].getStoredItem("WARN_TOAST_TIME")):0;//console.log("toastTime ", toastTime , " browserStorageUtil :", browserStorageUtil.getStoredItem("WARN_TOAST_TIME"))
var intervalInSecs=window.toastTimer?window.toastTimer:900;console.log("intervalInSecs ",intervalInSecs);if(toastTime>0){//Use interval check to display toast
var currentTime=Math.round(new Date().getTime()/1000);if(currentTime-toastTime<=intervalInSecs){return;}else{__WEBPACK_IMPORTED_MODULE_4__util_BrowserStorageUtil__["a" /* default */].storeItem("WARN_TOAST_TIME",String(Math.round(new Date().getTime()/1000)));}}else{__WEBPACK_IMPORTED_MODULE_4__util_BrowserStorageUtil__["a" /* default */].storeItem("WARN_TOAST_TIME",String(Math.round(new Date().getTime()/1000)));}if(toastStatus&&!toastStatus[level]){toastStatus[level]=true;__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ToastPage,{toastmsg:obj||{}}),document.getElementById('subroot'));}setTimeout(function(){try{var _false=false;var _false2=_slicedToArray(_false,1);level=_false2[0];}catch(e){//console.log("failed to load "+toastStatus[level])
}},toastAutoCloseTime);});/*HmEventRegistry.registerEvent("SLOW_NET_1", function(){
  var toastData = {msg:"slow_net", level:"info"};

  ReactDOM.render(<ToastPage toastmsg={toastData}/>, document.getElementById('subroot')); 
});

HmEventRegistry.registerEvent("NO_NET_1", function(){
  var toastData = {msg:"no_net", level:"info"};

  ReactDOM.render(<ToastPage toastmsg={toastData}/>, document.getElementById('subroot')); 
});*/

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _ToastContainer = _interopRequireDefault(__webpack_require__(1296));

exports.ToastContainer = _ToastContainer.default;

var _Transitions = __webpack_require__(512);

exports.Bounce = _Transitions.Bounce;
exports.Slide = _Transitions.Slide;
exports.Zoom = _Transitions.Zoom;
exports.Flip = _Transitions.Flip;

var _constant = __webpack_require__(148);

exports.ToastPosition = _constant.POSITION;
exports.ToastType = _constant.TYPE;

var _toast = _interopRequireDefault(__webpack_require__(1302));

exports.toast = _toast.default;

var _cssTransition = _interopRequireDefault(__webpack_require__(513));

exports.cssTransition = _cssTransition.default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _classnames = _interopRequireDefault(__webpack_require__(49));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(1297));

var _Toast = _interopRequireDefault(__webpack_require__(1299));

var _CloseButton = _interopRequireDefault(__webpack_require__(1301));

var _Transitions = __webpack_require__(512);

var _constant = __webpack_require__(148);

var _eventManager = _interopRequireDefault(__webpack_require__(514));

var _propValidator = __webpack_require__(315);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var ToastContainer =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(ToastContainer, _Component);

  function ToastContainer() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      toast: []
    };
    _this.toastKey = 1;
    _this.collection = {};

    _this.isToastActive = function (id) {
      return _this.state.toast.indexOf(id) !== -1;
    };

    return _this;
  }

  var _proto = ToastContainer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    _eventManager.default.on(_constant.ACTION.SHOW, function (content, options) {
      return _this2.show(content, options);
    }).on(_constant.ACTION.CLEAR, function (id) {
      return !id ? _this2.clear() : _this2.removeToast(id);
    }).emit(_constant.ACTION.DID_MOUNT, this);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    _eventManager.default.off(_constant.ACTION.SHOW).off(_constant.ACTION.CLEAR).emit(_constant.ACTION.WILL_UNMOUNT);
  };

  _proto.removeToast = function removeToast(id) {
    this.setState({
      toast: this.state.toast.filter(function (v) {
        return v !== id;
      })
    }, this.dispatchChange);
  };

  _proto.dispatchChange = function dispatchChange() {
    _eventManager.default.emit(_constant.ACTION.ON_CHANGE, this.state.toast.length);
  };

  _proto.makeCloseButton = function makeCloseButton(toastClose, toastId, type) {
    var _this3 = this;

    var closeButton = this.props.closeButton;

    if ((0, _react.isValidElement)(toastClose) || toastClose === false) {
      closeButton = toastClose;
    }

    return closeButton === false ? false : (0, _react.cloneElement)(closeButton, {
      closeToast: function closeToast() {
        return _this3.removeToast(toastId);
      },
      type: type
    });
  };

  _proto.getAutoCloseDelay = function getAutoCloseDelay(toastAutoClose) {
    return toastAutoClose === false || (0, _propValidator.isValidDelay)(toastAutoClose) ? toastAutoClose : this.props.autoClose;
  };

  _proto.canBeRendered = function canBeRendered(content) {
    return (0, _react.isValidElement)(content) || typeof content === 'string' || typeof content === 'number' || typeof content === 'function';
  };

  _proto.parseClassName = function parseClassName(prop) {
    if (typeof prop === 'string') {
      return prop;
    } else if (prop !== null && typeof prop === 'object' && 'toString' in prop) {
      return prop.toString();
    }

    return null;
  };

  _proto.show = function show(content, options) {
    var _this4 = this,
        _extends2;

    if (!this.canBeRendered(content)) {
      throw new Error("The element you provided cannot be rendered. You provided an element of type " + typeof content);
    }

    var toastId = options.toastId;

    var closeToast = function closeToast() {
      return _this4.removeToast(toastId);
    };

    var toastOptions = {
      id: toastId,
      // ⚠️ if no options.key, this.toastKey - 1 is assigned
      key: options.key || this.toastKey++,
      type: options.type,
      closeToast: closeToast,
      updateId: options.updateId,
      rtl: this.props.rtl,
      position: options.position || this.props.position,
      transition: options.transition || this.props.transition,
      className: this.parseClassName(options.className || this.props.toastClassName),
      bodyClassName: this.parseClassName(options.bodyClassName || this.props.bodyClassName),
      closeButton: this.makeCloseButton(options.closeButton, toastId, options.type),
      pauseOnHover: typeof options.pauseOnHover === 'boolean' ? options.pauseOnHover : this.props.pauseOnHover,
      pauseOnFocusLoss: typeof options.pauseOnFocusLoss === 'boolean' ? options.pauseOnFocusLoss : this.props.pauseOnFocusLoss,
      draggable: typeof options.draggable === 'boolean' ? options.draggable : this.props.draggable,
      draggablePercent: typeof options.draggablePercent === 'number' && !isNaN(options.draggablePercent) ? options.draggablePercent : this.props.draggablePercent,
      closeOnClick: typeof options.closeOnClick === 'boolean' ? options.closeOnClick : this.props.closeOnClick,
      progressClassName: this.parseClassName(options.progressClassName || this.props.progressClassName),
      progressStyle: this.props.progressStyle,
      autoClose: this.getAutoCloseDelay(options.autoClose),
      hideProgressBar: typeof options.hideProgressBar === 'boolean' ? options.hideProgressBar : this.props.hideProgressBar,
      progress: parseFloat(options.progress),
      isProgressDone: options.isProgressDone
    };
    typeof options.onOpen === 'function' && (toastOptions.onOpen = options.onOpen);
    typeof options.onClose === 'function' && (toastOptions.onClose = options.onClose); // add closeToast function to react component only

    if ((0, _react.isValidElement)(content) && typeof content.type !== 'string' && typeof content.type !== 'number') {
      content = (0, _react.cloneElement)(content, {
        closeToast: closeToast
      });
    } else if (typeof content === 'function') {
      content = content({
        closeToast: closeToast
      });
    }

    this.collection = _extends({}, this.collection, (_extends2 = {}, _extends2[toastId] = {
      position: toastOptions.position,
      options: toastOptions,
      content: content
    }, _extends2));
    this.setState({
      toast: (toastOptions.updateId ? _toConsumableArray(this.state.toast) : _toConsumableArray(this.state.toast).concat([toastId])).filter(function (id) {
        return id !== options.staleToastId;
      })
    }, this.dispatchChange);
  };

  _proto.makeToast = function makeToast(content, options) {
    return _react.default.createElement(_Toast.default, _extends({}, options, {
      isDocumentHidden: this.state.isDocumentHidden,
      key: "toast-" + options.key
    }), content);
  };

  _proto.clear = function clear() {
    this.setState({
      toast: []
    });
  };

  _proto.renderToast = function renderToast() {
    var _this5 = this;

    var toastToRender = {};
    var _this$props = this.props,
        className = _this$props.className,
        style = _this$props.style,
        newestOnTop = _this$props.newestOnTop;
    var collection = newestOnTop ? Object.keys(this.collection).reverse() : Object.keys(this.collection); // group toast by position

    collection.forEach(function (toastId) {
      var _this5$collection$toa = _this5.collection[toastId],
          position = _this5$collection$toa.position,
          options = _this5$collection$toa.options,
          content = _this5$collection$toa.content;
      toastToRender[position] || (toastToRender[position] = []);

      if (_this5.state.toast.indexOf(options.id) !== -1) {
        toastToRender[position].push(_this5.makeToast(content, options));
      } else {
        toastToRender[position].push(null);
        delete _this5.collection[toastId];
      }
    });
    return Object.keys(toastToRender).map(function (position) {
      var disablePointer = toastToRender[position].length === 1 && toastToRender[position][0] === null;
      var props = {
        className: (0, _classnames.default)('Toastify__toast-container', "Toastify__toast-container--" + position, {
          'Toastify__toast-container--rtl': _this5.props.rtl
        }, _this5.parseClassName(className)),
        style: disablePointer ? _extends({}, style, {
          pointerEvents: 'none'
        }) : _extends({}, style)
      };
      return _react.default.createElement(_TransitionGroup.default, _extends({}, props, {
        key: "container-" + position
      }), toastToRender[position]);
    });
  };

  _proto.render = function render() {
    return _react.default.createElement("div", {
      className: "Toastify"
    }, this.renderToast());
  };

  return ToastContainer;
}(_react.Component);

ToastContainer.propTypes = {
  /**
   * Set toast position
   */
  position: _propTypes.default.oneOf((0, _propValidator.objectValues)(_constant.POSITION)),

  /**
   * Disable or set autoClose delay
   */
  autoClose: _propValidator.falseOrDelay,

  /**
   * Disable or set a custom react element for the close button
   */
  closeButton: _propValidator.falseOrElement,

  /**
   * Hide or not progress bar when autoClose is enabled
   */
  hideProgressBar: _propTypes.default.bool,

  /**
   * Pause toast duration on hover
   */
  pauseOnHover: _propTypes.default.bool,

  /**
   * Dismiss toast on click
   */
  closeOnClick: _propTypes.default.bool,

  /**
   * Newest on top
   */
  newestOnTop: _propTypes.default.bool,

  /**
   * An optional className
   */
  className: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),

  /**
   * An optional style
   */
  style: _propTypes.default.object,

  /**
   * An optional className for the toast
   */
  toastClassName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),

  /**
   * An optional className for the toast body
   */
  bodyClassName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),

  /**
   * An optional className for the toast progress bar
   */
  progressClassName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),

  /**
   * An optional style for the toast progress bar
   */
  progressStyle: _propTypes.default.object,

  /**
   * Define enter and exit transition using react-transition-group
   */
  transition: _propTypes.default.func,

  /**
   * Support rtl display
   */
  rtl: _propTypes.default.bool,

  /**
   * Allow toast to be draggable
   */
  draggable: _propTypes.default.bool,

  /**
   * The percentage of the toast's width it takes for a drag to dismiss a toast
   */
  draggablePercent: _propTypes.default.number,

  /**
   * Pause the toast on focus loss
   */
  pauseOnFocusLoss: _propTypes.default.bool
};
ToastContainer.defaultProps = {
  position: _constant.POSITION.TOP_RIGHT,
  transition: _Transitions.Bounce,
  rtl: false,
  autoClose: 5000,
  hideProgressBar: false,
  closeButton: _react.default.createElement(_CloseButton.default, null),
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  closeOnClick: true,
  newestOnTop: false,
  draggable: true,
  draggablePercent: 80,
  className: null,
  style: null,
  toastClassName: null,
  bodyClassName: null,
  progressClassName: null,
  progressStyle: null
};
var _default = ToastContainer;
exports.default = _default;

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(303);

var _ChildMapping = __webpack_require__(1298);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _classnames = _interopRequireDefault(__webpack_require__(49));

var _ProgressBar = _interopRequireDefault(__webpack_require__(1300));

var _constant = __webpack_require__(148);

var _propValidator = __webpack_require__(315);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function getX(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
}

function getY(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
}

var noop = function noop() {};

var Toast =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Toast, _Component);

  function Toast() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      isRunning: true,
      preventExitTransition: false
    };
    _this.flag = {
      canCloseOnClick: true,
      canDrag: false
    };
    _this.drag = {
      start: 0,
      x: 0,
      y: 0,
      deltaX: 0,
      removalDistance: 0
    };
    _this.ref = null;

    _this.pauseToast = function () {
      if (_this.props.autoClose) {
        _this.setState({
          isRunning: false
        });
      }
    };

    _this.playToast = function () {
      if (_this.props.autoClose) {
        _this.setState({
          isRunning: true
        });
      }
    };

    _this.onDragStart = function (e) {
      _this.flag.canCloseOnClick = true;
      _this.flag.canDrag = true;
      _this.ref.style.transition = '';
      _this.drag.start = _this.drag.x = getX(e.nativeEvent);
      _this.drag.removalDistance = _this.ref.offsetWidth * (_this.props.draggablePercent / 100);
    };

    _this.onDragMove = function (e) {
      if (_this.flag.canDrag) {
        if (_this.state.isRunning) {
          _this.pauseToast();
        }

        _this.drag.x = getX(e);
        _this.drag.deltaX = _this.drag.x - _this.drag.start; // prevent false positif during a toast click

        _this.drag.start !== _this.drag.x && (_this.flag.canCloseOnClick = false);
        _this.ref.style.transform = "translateX(" + _this.drag.deltaX + "px)";
        _this.ref.style.opacity = 1 - Math.abs(_this.drag.deltaX / _this.drag.removalDistance);
      }
    };

    _this.onDragEnd = function (e) {
      if (_this.flag.canDrag) {
        _this.flag.canDrag = false;

        if (Math.abs(_this.drag.deltaX) > _this.drag.removalDistance) {
          _this.setState({
            preventExitTransition: true
          }, _this.props.closeToast);

          return;
        }

        _this.drag.y = getY(e);
        _this.ref.style.transition = 'transform 0.2s, opacity 0.2s';
        _this.ref.style.transform = 'translateX(0)';
        _this.ref.style.opacity = 1;
      }
    };

    _this.onDragTransitionEnd = function () {
      var _this$ref$getBounding = _this.ref.getBoundingClientRect(),
          top = _this$ref$getBounding.top,
          bottom = _this$ref$getBounding.bottom,
          left = _this$ref$getBounding.left,
          right = _this$ref$getBounding.right;

      if (_this.props.pauseOnHover && _this.drag.x >= left && _this.drag.x <= right && _this.drag.y >= top && _this.drag.y <= bottom) {
        _this.pauseToast();
      } else {
        _this.playToast();
      }
    };

    return _this;
  }

  var _proto = Toast.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.props.onOpen(this.props.children.props);

    if (this.props.draggable) {
      this.bindDragEvents();
    } // Maybe I could bind the event in the ToastContainer and rely on delegation


    if (this.props.pauseOnFocusLoss) {
      this.bindFocusEvents();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.draggable !== this.props.draggable) {
      if (this.props.draggable) {
        this.bindDragEvents();
      } else {
        this.unbindDragEvents();
      }
    }

    if (prevProps.pauseOnFocusLoss !== this.props.pauseOnFocusLoss) {
      if (this.props.pauseOnFocusLoss) {
        this.bindFocusEvents();
      } else {
        this.unbindFocusEvents();
      }
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.props.onClose(this.props.children.props);

    if (this.props.draggable) {
      this.unbindDragEvents();
    }

    if (this.props.pauseOnFocusLoss) {
      this.unbindFocusEvents();
    }
  };

  _proto.bindFocusEvents = function bindFocusEvents() {
    window.addEventListener('focus', this.playToast);
    window.addEventListener('blur', this.pauseToast);
  };

  _proto.unbindFocusEvents = function unbindFocusEvents() {
    window.removeEventListener('focus', this.playToast);
    window.removeEventListener('blur', this.pauseToast);
  };

  _proto.bindDragEvents = function bindDragEvents() {
    document.addEventListener('mousemove', this.onDragMove);
    document.addEventListener('mouseup', this.onDragEnd);
    document.addEventListener('touchmove', this.onDragMove);
    document.addEventListener('touchend', this.onDragEnd);
  };

  _proto.unbindDragEvents = function unbindDragEvents() {
    document.removeEventListener('mousemove', this.onDragMove);
    document.removeEventListener('mouseup', this.onDragEnd);
    document.removeEventListener('touchmove', this.onDragMove);
    document.removeEventListener('touchend', this.onDragEnd);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        closeButton = _this$props.closeButton,
        children = _this$props.children,
        autoClose = _this$props.autoClose,
        pauseOnHover = _this$props.pauseOnHover,
        closeOnClick = _this$props.closeOnClick,
        type = _this$props.type,
        hideProgressBar = _this$props.hideProgressBar,
        closeToast = _this$props.closeToast,
        Transition = _this$props.transition,
        position = _this$props.position,
        onExited = _this$props.onExited,
        className = _this$props.className,
        bodyClassName = _this$props.bodyClassName,
        progressClassName = _this$props.progressClassName,
        progressStyle = _this$props.progressStyle,
        updateId = _this$props.updateId,
        role = _this$props.role,
        progress = _this$props.progress,
        isProgressDone = _this$props.isProgressDone,
        rtl = _this$props.rtl;
    var toastProps = {
      className: (0, _classnames.default)('Toastify__toast', "Toastify__toast--" + type, {
        'Toastify__toast--rtl': rtl
      }, className)
    };

    if (autoClose && pauseOnHover) {
      toastProps.onMouseEnter = this.pauseToast;
      toastProps.onMouseLeave = this.playToast;
    } // prevent toast from closing when user drags the toast


    if (closeOnClick) {
      toastProps.onClick = function () {
        return _this2.flag.canCloseOnClick && closeToast();
      };
    }

    var controlledProgress = parseFloat(progress) === progress;
    return _react.default.createElement(Transition, {
      in: this.props.in,
      appear: true,
      unmountOnExit: true,
      onExited: onExited,
      position: position,
      preventExitTransition: this.state.preventExitTransition
    }, _react.default.createElement("div", _extends({}, toastProps, {
      ref: function ref(_ref) {
        return _this2.ref = _ref;
      },
      onMouseDown: this.onDragStart,
      onTouchStart: this.onDragStart,
      onTransitionEnd: this.onDragTransitionEnd
    }), _react.default.createElement("div", _extends({}, this.props.in && {
      role: role
    }, {
      className: (0, _classnames.default)('Toastify__toast-body', bodyClassName)
    }), children), closeButton && closeButton, (autoClose || controlledProgress) && _react.default.createElement(_ProgressBar.default, _extends({}, updateId && !controlledProgress ? {
      key: "pb-" + updateId
    } : {}, {
      rtl: rtl,
      delay: autoClose,
      isRunning: this.state.isRunning,
      closeToast: closeToast,
      hide: hideProgressBar,
      type: type,
      style: progressStyle,
      className: progressClassName,
      controlledProgress: controlledProgress,
      isProgressDone: isProgressDone,
      progress: progress
    }))));
  };

  return Toast;
}(_react.Component);

Toast.propTypes = {
  closeButton: _propValidator.falseOrElement.isRequired,
  autoClose: _propValidator.falseOrDelay.isRequired,
  children: _propTypes.default.node.isRequired,
  closeToast: _propTypes.default.func.isRequired,
  position: _propTypes.default.oneOf((0, _propValidator.objectValues)(_constant.POSITION)).isRequired,
  pauseOnHover: _propTypes.default.bool.isRequired,
  pauseOnFocusLoss: _propTypes.default.bool.isRequired,
  closeOnClick: _propTypes.default.bool.isRequired,
  transition: _propTypes.default.func.isRequired,
  rtl: _propTypes.default.bool.isRequired,
  hideProgressBar: _propTypes.default.bool.isRequired,
  draggable: _propTypes.default.bool.isRequired,
  draggablePercent: _propTypes.default.number.isRequired,
  in: _propTypes.default.bool,
  onExited: _propTypes.default.func,
  onOpen: _propTypes.default.func,
  onClose: _propTypes.default.func,
  type: _propTypes.default.oneOf((0, _propValidator.objectValues)(_constant.TYPE)),
  className: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  bodyClassName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  progressClassName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  progressStyle: _propTypes.default.object,
  progress: _propTypes.default.number,
  isProgressDone: _propTypes.default.bool,
  updateId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  ariaLabel: _propTypes.default.string
};
Toast.defaultProps = {
  type: _constant.TYPE.DEFAULT,
  in: true,
  onOpen: noop,
  onClose: noop,
  className: null,
  bodyClassName: null,
  progressClassName: null,
  updateId: null,
  role: 'alert'
};
var _default = Toast;
exports.default = _default;

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _classnames = _interopRequireDefault(__webpack_require__(49));

var _constant = __webpack_require__(148);

var _propValidator = __webpack_require__(315);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ProgressBar(_ref) {
  var _animationEvent;

  var delay = _ref.delay,
      isRunning = _ref.isRunning,
      closeToast = _ref.closeToast,
      type = _ref.type,
      hide = _ref.hide,
      className = _ref.className,
      userStyle = _ref.style,
      controlledProgress = _ref.controlledProgress,
      progress = _ref.progress,
      isProgressDone = _ref.isProgressDone,
      rtl = _ref.rtl;

  var style = _extends({}, userStyle, {
    animationDuration: delay + "ms",
    animationPlayState: isRunning ? 'running' : 'paused',
    opacity: hide ? 0 : 1,
    transform: controlledProgress ? "scaleX(" + progress + ")" : null
  });

  var classNames = (0, _classnames.default)('Toastify__progress-bar', controlledProgress ? 'Toastify__progress-bar--controlled' : 'Toastify__progress-bar--animated', "Toastify__progress-bar--" + type, {
    'Toastify__progress-bar--rtl': rtl
  }, className);
  var animationEvent = (_animationEvent = {}, _animationEvent[controlledProgress && isProgressDone ? 'onTransitionEnd' : 'onAnimationEnd'] = controlledProgress && !isProgressDone ? null : closeToast, _animationEvent);
  return _react.default.createElement("div", _extends({
    className: classNames,
    style: style
  }, animationEvent));
}

ProgressBar.propTypes = {
  /**
   * The animation delay which determine when to close the toast
   */
  delay: _propValidator.falseOrDelay.isRequired,

  /**
   * Whether or not the animation is running or paused
   */
  isRunning: _propTypes.default.bool.isRequired,

  /**
   * Func to close the current toast
   */
  closeToast: _propTypes.default.func.isRequired,

  /**
   * Support rtl content
   */
  rtl: _propTypes.default.bool.isRequired,

  /**
   * Optional type : info, success ...
   */
  type: _propTypes.default.string,

  /**
   * Hide or not the progress bar
   */
  hide: _propTypes.default.bool,

  /**
   * Optionnal className
   */
  className: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),

  /**
   * Controlled progress value
   */
  progress: _propTypes.default.number,

  /**
   * Tell wether or not controlled progress bar is used
   */
  controlledProgress: _propTypes.default.bool,

  /**
   * Helper to close the toast when using controlled progress value
   */
  isProgressDone: _propTypes.default.bool
};
ProgressBar.defaultProps = {
  type: _constant.TYPE.DEFAULT,
  hide: false
};
var _default = ProgressBar;
exports.default = _default;

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CloseButton(_ref) {
  var closeToast = _ref.closeToast,
      type = _ref.type,
      ariaLabel = _ref.ariaLabel;
  return _react.default.createElement("button", {
    className: "Toastify__close-button Toastify__close-button--" + type,
    type: "button",
    onClick: closeToast,
    "aria-label": ariaLabel
  }, "\u2716");
}

CloseButton.propTypes = {
  closeToast: _propTypes.default.func,
  arialLabel: _propTypes.default.string
};
CloseButton.defaultProps = {
  ariaLabel: 'close'
};
var _default = CloseButton;
exports.default = _default;

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _eventManager = _interopRequireDefault(__webpack_require__(514));

var _constant = __webpack_require__(148);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var container = null;
var queue = [];

var noop = function noop() {
  return false;
};
/**
 * Merge provided options with the defaults settings and generate the toastId
 */


function mergeOptions(options, type) {
  return _extends({}, options, {
    type: type,
    toastId: getToastId(options)
  });
}
/**
 * Generate a random toastId
 */


function generateToastId() {
  return (Math.random().toString(36) + Date.now().toString(36)).substr(2, 10);
}
/**
 * Generate the toastId either automatically or by provided toastId
 */


function getToastId(options) {
  if (options && (typeof options.toastId === 'string' || typeof options.toastId === 'number' && !isNaN(options.toastId))) {
    return options.toastId;
  }

  return generateToastId();
}
/**
 * Dispatch toast. If the container is not mounted, the toast is enqueued
 */


function emitEvent(content, options) {
  if (container !== null) {
    _eventManager.default.emit(_constant.ACTION.SHOW, content, options);
  } else {
    queue.push({
      action: _constant.ACTION.SHOW,
      content: content,
      options: options
    });
  }

  return options.toastId;
}

var toast = _extends(function (content, options) {
  return emitEvent(content, mergeOptions(options, options && options.type || _constant.TYPE.DEFAULT));
}, {
  success: function success(content, options) {
    return emitEvent(content, mergeOptions(options, _constant.TYPE.SUCCESS));
  },
  info: function info(content, options) {
    return emitEvent(content, mergeOptions(options, _constant.TYPE.INFO));
  },
  warn: function warn(content, options) {
    return emitEvent(content, mergeOptions(options, _constant.TYPE.WARNING));
  },
  warning: function warning(content, options) {
    return emitEvent(content, mergeOptions(options, _constant.TYPE.WARNING));
  },
  error: function error(content, options) {
    return emitEvent(content, mergeOptions(options, _constant.TYPE.ERROR));
  },
  dismiss: function dismiss(id) {
    if (id === void 0) {
      id = null;
    }

    return container && _eventManager.default.emit(_constant.ACTION.CLEAR, id);
  },
  isActive: noop,
  update: function update(toastId, options) {
    setTimeout(function () {
      if (container && typeof container.collection[toastId] !== 'undefined') {
        var _container$collection = container.collection[toastId],
            oldOptions = _container$collection.options,
            oldContent = _container$collection.content;

        var nextOptions = _extends({}, oldOptions, options, {
          toastId: options.toastId || toastId
        });

        if (!options.toastId || options.toastId === toastId) {
          nextOptions.updateId = generateToastId();
        } else {
          nextOptions.staleToastId = toastId;
        }

        var content = typeof nextOptions.render !== 'undefined' ? nextOptions.render : oldContent;
        delete nextOptions.render;
        emitEvent(content, nextOptions);
      }
    }, 0);
  },
  done: function done(id, progress) {
    if (progress === void 0) {
      progress = 1;
    }

    toast.update(id, {
      progress: progress,
      isProgressDone: true
    });
  },
  onChange: function onChange(callback) {
    if (typeof callback === 'function') {
      _eventManager.default.on(_constant.ACTION.ON_CHANGE, callback);
    }
  },
  POSITION: _constant.POSITION,
  TYPE: _constant.TYPE
});
/**
 * Wait until the ToastContainer is mounted to dispatch the toast
 * and attach isActive method
 */


_eventManager.default.on(_constant.ACTION.DID_MOUNT, function (containerInstance) {
  container = containerInstance;

  toast.isActive = function (id) {
    return container.isToastActive(id);
  };

  queue.forEach(function (item) {
    _eventManager.default.emit(item.action, item.content, item.options);
  });
  queue = [];
}).on(_constant.ACTION.WILL_UNMOUNT, function () {
  container = null;
  toast.isActive = noop;
});

var _default = toast;
exports.default = _default;

/***/ }),
/* 1303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CorePage__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_BrowserUtil__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_BrowserStorageUtil__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_NativeAjax__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_HawkEye__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_UserStore__ = __webpack_require__(12);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoggedOutPrompt=function(_CorePage){_inherits(LoggedOutPrompt,_CorePage);function LoggedOutPrompt(props){_classCallCheck(this,LoggedOutPrompt);var _this=_possibleConstructorReturn(this,(LoggedOutPrompt.__proto__||Object.getPrototypeOf(LoggedOutPrompt)).call(this,props));_this.userObj={};_this.UserStore=new __WEBPACK_IMPORTED_MODULE_8__util_UserStore__["a" /* default */]();_this.doCommonLogout=_this.doCommonLogout.bind(_this);return _this;}_createClass(LoggedOutPrompt,[{key:'showPrompt',value:function showPrompt(){var _this2=this;var me=this;var PLPToken=__WEBPACK_IMPORTED_MODULE_3__util_BrowserUtil__["a" /* default */].getCookie('_rToken');var LumosToken=__WEBPACK_IMPORTED_MODULE_3__util_BrowserUtil__["a" /* default */].getCookie('authToken');var buttons=[{label:this.props.exit?this.rb("home.btn.close"):this.rb("login"),handler:function handler(){if(_this2.props.exit){window.close();}else if((PLPToken||LumosToken)!=""){me.doCommonLogout();}else{window.location.href=me.getPostLogoutUrl();}}}];this.showAlert(this.rb("logged_out_label"),this.rb("logged_out_desc"),buttons);}},{key:'getPostLogoutUrl',value:function getPostLogoutUrl(){var redirectUrl=null;/*if(BrowserUtil.getCookie("loginSrc") && BrowserUtil.getCookie("loginSrc").length > 10){
      redirectUrl = (BrowserUtil.getCookie("loginSrc")).replace(/"/g,"");
    }else if(BrowserStorageUtil.getStoredItem("loginSrc") && BrowserStorageUtil.getStoredItem("loginSrc").length > 10){
      redirectUrl = (BrowserStorageUtil.getStoredItem("loginSrc")).replace(/"/g,"");
      BrowserStorageUtil.removeItem("loginSrc");
    }else */if(this.getUrlFor("PRELOGIN_PAGE")&&this.getUrlFor("PRELOGIN_PAGE").length>0){redirectUrl=this.getUrlFor("PRELOGIN_PAGE").replace(/"/g,"");}else if(this.getUrlFor("HEYMATH_HOME")&&this.getUrlFor("HEYMATH_HOME").length>0){redirectUrl=this.getUrlFor("HEYMATH_HOME").replace(/"/g,"");}return redirectUrl;}},{key:'doCommonLogout',value:function doCommonLogout(){var me=this;var callBackSuccess=function callBackSuccess(){me.initiateTrack("logout",{});setTimeout(function(){me.UserStore.clearOldUser();window.location.href=me.getPostLogoutUrl()+"?loginForm=lumos";},500);};var PLPcallBackFailure=function PLPcallBackFailure(){window.location.href=me.getPostLogoutUrl();console.error("Logout failed.");};var callBackFailure=function callBackFailure(response,request){if(request.status!=403){new __WEBPACK_IMPORTED_MODULE_6__util_NativeAjax__["a" /* default */](me.getUrlFor("PLP_COMMON_LOGOUT")).enableCORS().get(callBackSuccess,PLPcallBackFailure);}else{window.location.href=me.getPostLogoutUrl();}console.error("Logout failed.");};new __WEBPACK_IMPORTED_MODULE_6__util_NativeAjax__["a" /* default */](this.getUrlFor("LUMOS_COMMON_LOGOUT")).enableCORS().get(callBackSuccess,callBackFailure);}},{key:'initiateTrack',value:function initiateTrack(trackKey,addnldata){var me=this;var trackObj=me.getTracker().getEventObject(me.getTracker().eventCodes[trackKey]);trackObj.event_details.user_id=me.userObj.userId||"";trackObj.event_details.session_id=me.userObj.authToken||"";trackObj.event_details.timestamp=new Date().getTime()||"";if(addnldata!==undefined&&(typeof addnldata==='undefined'?'undefined':_typeof(addnldata))==="object"){for(var key in addnldata){trackObj.event_data[key]=addnldata[key];}}var output={"event":trackObj};new __WEBPACK_IMPORTED_MODULE_7__util_HawkEye__["a" /* default */](output).post();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{styles:{backgroundColor:'#ccc',position:'absolute',top:0,left:0,width:'100vw',height:'100vh',zIndex:10,opacity:0.5}},this.showPrompt());}}]);return LoggedOutPrompt;}(__WEBPACK_IMPORTED_MODULE_2__CorePage__["a" /* default */]);/* unused harmony default export */ var _unused_webpack_default_export = (LoggedOutPrompt);__WEBPACK_IMPORTED_MODULE_5__model_HmEventRegistry__["a" /* default */].registerEvent("LOG_OUT_PROMPT",function(obj){__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoggedOutPrompt,null),document.getElementById('root'));});__WEBPACK_IMPORTED_MODULE_5__model_HmEventRegistry__["a" /* default */].registerEvent("LOG_OUT_PROMPT_EXIT",function(obj){__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoggedOutPrompt,{exit:true}),document.getElementById('root'));});

/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_html_parser__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_html_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_html_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_confirm_alert__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_RbUtil__ = __webpack_require__(205);
var ErrorPrompt=function ErrorPrompt(obj){var rb=function rb(rawTxt){var replaceStringArray=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];return __WEBPACK_IMPORTED_MODULE_4__util_RbUtil__["a" /* default */].getText(rawTxt,replaceStringArray);};var title=rb("500.title");var msg="";var btnHandlers=obj.buttons||null;try{title=rb(obj.title);}catch(e){}try{if(obj.reference_id){msg+=rb("500.reference_id").replace("{#reference_id}",obj.reference_id);}if(obj.msg){msg+=rb(obj.msg);}else if(obj.message){msg+=rb(obj.message);}}catch(e){}var errObj={"error_id":obj.reference_id,"status_code":obj.status_code||500,"url":obj.url||"","enum_key":"source","enum_replace_key":"encounteredErrorSource","enum_replace_value":obj.server_src||"um"};__WEBPACK_IMPORTED_MODULE_3__model_HmEventRegistry__["a" /* default */].fireEvent("TRACK_EVENT","error_encountered",errObj);this.show=function(){var me=this;var buttons=[];try{if(btnHandlers!==undefined&&btnHandlers!==null&&btnHandlers.length>0){for(var i=0;i<btnHandlers.length;i++){buttons.push({label:btnHandlers[i].label||me.rb("btn.ok"),onClick:typeof btnHandlers[i].handler==="function"?btnHandlers[i].handler:function(){}});}}}catch(e){}if(buttons.length==0){buttons.push({label:'Ok',onClick:function onClick(){}});}return Object(__WEBPACK_IMPORTED_MODULE_2_react_confirm_alert__["confirmAlert"])({title:title||'Alert',message:msg?__WEBPACK_IMPORTED_MODULE_1_react_html_parser___default()(msg):'Hello..',buttons:buttons});};};__WEBPACK_IMPORTED_MODULE_3__model_HmEventRegistry__["a" /* default */].registerEvent("ERROR_PROMPT",function(obj){new ErrorPrompt(obj).show();});

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_UrlManager__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_NativeAjax__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_HmAjax__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_UserStorageUtil__ = __webpack_require__(33);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var LumosHeartBeat=function(){var LUMOS_HEARTBEAT_URL=__WEBPACK_IMPORTED_MODULE_1__model_UrlManager__["a" /* default */].getUrlForAction("LUMOS_SESSION_CHECK");var PLP_LOGOUT_URL=__WEBPACK_IMPORTED_MODULE_1__model_UrlManager__["a" /* default */].getUrlForAction("LOGOUT");var FAIL_MAX_COUNT=window.lumos&&window.lumos.FAIL_MAX_COUNT&&!isNaN(window.lumos.FAIL_MAX_COUNT)&&window.lumos.FAIL_MAX_COUNT>0?window.lumos.FAIL_MAX_COUNT:0;var BEAT_INTERVAL=window.lumos&&window.lumos.BEAT_INTERVAL&&!isNaN(window.lumos.BEAT_INTERVAL)&&window.lumos.BEAT_INTERVAL>0?window.lumos.BEAT_INTERVAL:30;var failCount=0;var scheduler=null;var failureHandler=function failureHandler(){failCount++;if(failCount>=FAIL_MAX_COUNT){if(scheduler){try{clearInterval(scheduler);}catch(e){}}new __WEBPACK_IMPORTED_MODULE_3__util_HmAjax__["a" /* default */](PLP_LOGOUT_URL).get();}};var isActive=false;return{initiate:function initiate(){var success=function success(userObj){if((typeof userObj==='undefined'?'undefined':_typeof(userObj))==="object"&&userObj.sessionValid){failCount=0;}else{failureHandler();}};var failure=function failure(err){failureHandler();};new __WEBPACK_IMPORTED_MODULE_2__util_NativeAjax__["a" /* default */](LUMOS_HEARTBEAT_URL).enableCORS().get(success,failure);},schedule:function schedule(){var me=this;var userObj=__WEBPACK_IMPORTED_MODULE_4__util_UserStorageUtil__["a" /* default */].getStoredSessionItem("USER_DETAILS");var authProviderId=userObj&&userObj.authProviderId?userObj.authProviderId:0;if(authProviderId===5){if(!isActive){scheduler=setInterval(function(){me.initiate();},BEAT_INTERVAL*1000);isActive=true;}}}};}();/* unused harmony default export */ var _unused_webpack_default_export = (LumosHeartBeat);__WEBPACK_IMPORTED_MODULE_0__model_HmEventRegistry__["a" /* default */].registerEvent("SCHEDULE_LUMOS_HEARTBEAT",function(){try{LumosHeartBeat.schedule();}catch(e){}});

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_HmEventRegistry__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__images_icons_heypractest_icon_png__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__images_icons_heypractest_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__images_icons_heypractest_icon_png__);
var FreshChatWidget=function(){var USER_STORE=null;var IS_USER_PARAMS_ADDED=false;return{init:function init(){try{var urlPathName=window.location.pathname;if(urlPathName.indexOf("openlessonview/")>-1||urlPathName.indexOf("lessonview/")>-1){return;}if(!window.fcWidget){return;}window.fcWidget.init({token:"888bef39-c0da-4bda-8f07-725d8cf794b1",host:"https://wchat.freshchat.com",config:{disableEvents:true,cssNames:{widget:'fc_frame',open:'fc_open',expanded:'fc_expanded'},showFAQOnOpen:true,hideFAQ:true,agent:{hideName:false,hidePic:false,hideBio:false},headerProperty:{//If you have multiple sites you can use the appName and appLogo to overwrite the values.
appName:'',hideChatButton:true,appLogo:__WEBPACK_IMPORTED_MODULE_1__images_icons_heypractest_icon_png___default.a,backgroundColor:'#f76d7e',foregroundColor:'#fff',backgroundImage:'https://wchat.freshchat.com/assets/images/texture_background_1-bdc7191884a15871ed640bcb0635e7e7.png'},content:{placeholders:{search_field:'Search',reply_field:'Reply',csat_reply:'Add your comments here'},actions:{csat_yes:'Yes',csat_no:'No',push_notify_yes:'Yes',push_notify_no:'No',tab_faq:'Solutions',tab_chat:'Chat',csat_submit:'Submit'},headers:{chat:'Chat with Us',chat_help:'Reach out to us if you have any questions',faq:'Solution Articles',faq_help:'Browse our articles',faq_not_available:'No Articles Found',faq_search_not_available:'No articles were found for {{query}}',faq_useful:'Was this article helpful?',faq_thankyou:'Thank you for your feedback',faq_message_us:'Message Us',push_notification:'Don\'t miss out on any replies! Allow push notifications?',csat_question:'Did we address your concerns??',csat_yes_question:'How would you rate this interaction?',csat_no_question:'How could we have helped better?',csat_thankyou:'Thanks for the response',csat_rate_here:'Submit your rating here',channel_response:{offline:'We are currently away. Please leave us a message',online:{minutes:{one:"Currently replying in {!time!} minutes ",more:"Typically replies in {!time!} minutes"},hours:{one:"Currently replying in under an hour",more:"Typically replies in {!time!} hours"}}}}}}});window.fcWidget.on("widget:loaded",function(){document.getElementById('custom_fc_button').style.visibility='visible';window.fcWidget.on("widget:closed",function(){document.getElementById('fc_frame').style.visibility='hidden';document.getElementById('open_fc_widget').style.visibility='visible';});window.fcWidget.on("widget:opened",function(resp){document.getElementById('open_fc_widget').style.visibility='hidden';});});}catch(e){console.error(e);}},setUser:function setUser(userStore){try{if(IS_USER_PARAMS_ADDED){return;}if(!window.fcWidget||!window.fcWidget.user||!window.fcWidget.user.setProperties){return;}if(userStore&&userStore.getUserId()&&userStore.getUserId().length>0){USER_STORE=userStore;}if(USER_STORE&&USER_STORE.getUserId()&&USER_STORE.getUserId().length>0){IS_USER_PARAMS_ADDED=true;window.fcWidget.user.setProperties({firstName:USER_STORE.getUserName()||"",lastName:"",externalId:USER_STORE.getLoginId()||"",email:USER_STORE.getEmail()||"",phone:USER_STORE.getMobile()||"","status":"Active"});}}catch(e){IS_USER_PARAMS_ADDED=false;}},clearUser:function clearUser(){try{IS_USER_PARAMS_ADDED=false;if(!window.fcWidget){return;}window.fcWidget.clear();}catch(e){IS_USER_PARAMS_ADDED=false;}}};}();/* unused harmony default export */ var _unused_webpack_default_export = (FreshChatWidget);__WEBPACK_IMPORTED_MODULE_0__model_HmEventRegistry__["a" /* default */].registerEvent("INIT_FRESHCHAT",function(){FreshChatWidget.init();});__WEBPACK_IMPORTED_MODULE_0__model_HmEventRegistry__["a" /* default */].registerEvent("ADD_USER_FRESHCHAT",function(userStore){FreshChatWidget.setUser(userStore);});__WEBPACK_IMPORTED_MODULE_0__model_HmEventRegistry__["a" /* default */].registerEvent("CLEAR_USER_FRESHCHAT",function(){FreshChatWidget.clearUser();});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.bbf80847.js